const causes = {
   "akdce" : {
      "0" : "0 (No cause code entered)",
      "02:0431" : "02:0431 (02:431 Fed. Election Commission: Failure Enforce C)",
      "02:0437" : "02:0437 (02:437 Federal Election Commission)",
      "05:0075" : "05:0075 (05:75(2) Contract - Reduction in Grade)",
      "05:0551" : "05:0551 (05:551 Administrative Procedure Act)",
      "05:0552fi" : "05:0552fi (05:552 Freedom of Information Act)",
      "05:0552pa" : "05:0552pa (05:552 Right to Privacy Act)",
      "05:0554" : "05:0554 (05:0554 Constitutionality of Maritime Statutes)",
      "05:0701" : "05:0701 (05:0701 Maritime Subsidy Board)",
      "05:0702" : "05:0702 (05:702 Administrative Procedure Act)",
      "05:0704" : "05:0704 (05:704 Labor Litigation)",
      "05:7703" : "05:7703 (05:7703 Discrimination - Review of Agency Act)",
      "07:0006" : "07:0006 (7:6(b) Federal Commodity Exchange Regulation)",
      "07:0025" : "07:0025 (7:25 Fraud - Commodities Leverage Contracts)",
      "07:0181" : "07:0181 (07:181 Packers & Stockyard Act)",
      "07:0499" : "07:0499 (07:499 Agricultural Commodities Act)",
      "07:0601" : "07:0601 (07:601 USDA Condemnation)",
      "07:2321" : "07:2321 (07:2321 Plant Variety Protection Act)",
      "08:1105" : "08:1105 (8:1105(a) Aliens: Habeas Corpus to Release INS Det)",
      "08:1252" : "08:1252 (08:1252(a)(2) Injunction for Deportation)",
      "08:1260" : "08:1260 (08:1260 Aliens: Access to Records)",
      "08:1324" : "08:1324 (08:1324 Aliens: Complaint for Forfeiture)",
      "08:1329" : "08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petiti)",
      "08:1446" : "08:1446 (8:1446 Petition for Naturalization Hearing)",
      "09:0001" : "09:0001 (09:1 U.S. Arbitration Act)",
      "09:0009" : "09:0009 (9:9 Motion to Confirm Arbitration Loan)",
      "09:0010" : "09:0010 (09:0010 Petition to Vacate Arbitration Award)",
      "10:1552" : "10:1552 (10:1552 Armed Forces: Action to Correct Records)",
      "10:1553" : "10:1553 (10:1553 Armed Forces: FOIA General)",
      "10:2305" : "10:2305 (10:2305 Review of Federal Contract)",
      "11:0101" : "11:0101 (11:101 Bankruptcy)",
      "12:0022" : "12:0022 (12:22 Securities Fraud)",
      "12:0635" : "12:0635 (12:635 Breach of Insurance Contract)",
      "12:1461" : "12:1461 (12:1461 Homeowners Loan Act)",
      "12:1703" : "12:1703 (12:1703 Default of HUD Loan)",
      "12:1725" : "12:1725 (12:1725 Collection under Contract Guaranty)",
      "12:1730" : "12:1730 (12:1730 Collection Under Contract Guaranty)",
      "12:1819" : "12:1819 (12:1819 Default of Promissory Note)",
      "12:1821" : "12:1821 (12:1821 Default of Loan by Promissary Note)",
      "12:1971" : "12:1971 (12:1971 Relief under Bank Holding Act)",
      "12:3410" : "12:3410 (12:3410 Right to Financial Privacy Act)",
      "15:0001" : "15:0001 (15:1 Antitrust Litigation)",
      "15:0002at" : "15:0002at (15:2 Antitrust Litigation)",
      "15:0002fl" : "15:0002fl (15:2(a) Fair Labor Standards Act)",
      "15:0005" : "15:0005 (15:5(a) Fair Labor Standards Act)",
      "15:0015" : "15:0015 (15:15 Antitrust Litigation)",
      "15:0025" : "15:0025 (15:25 Clayton Act)",
      "15:0044" : "15:0044 (15:44 Trademark Infringement)",
      "15:0045" : "15:0045 (15:0045 Federal Trade Commission Act)",
      "15:0052" : "15:0052 (15:0052 Federal Trade Commission Act)",
      "15:0053" : "15:0053 (15:0053 Federal Trade Commission Act)",
      "15:0077" : "15:0077 (15:77 Securities Fraud)",
      "15:0078" : "15:0078 (15:78m(a) Securities Exchange Act)",
      "15:0631" : "15:0631 (15:631 Small Business Act)",
      "15:0717" : "15:0717 (15:717 Natural Gas Act)",
      "15:1051" : "15:1051 (15:1051 Trademark Infringement)",
      "15:1114" : "15:1114 (15:1114 Trademark Infringement)",
      "15:1121" : "15:1121 (15:1121 Trademark Infringement)",
      "15:1125" : "15:1125 (15:1125 Trademark Infringement (Lanham Act))",
      "15:1126" : "15:1126 (15:1126 Patent Infringement)",
      "15:1127" : "15:1127 (15:1127 Trademark Infringement)",
      "15:1601" : "15:1601 (15:1601 Truth in Lending)",
      "15:1640" : "15:1640 (15:1640 Truth in Lending)",
      "15:1681" : "15:1681 (15:1681 Fair Credit Reporting Act)",
      "15:1692" : "15:1692 (15:1692 Fair Debt Collection Act)",
      "15:1938" : "15:1938 (15:1938 Fair Labor Standards Act)",
      "15:1981" : "15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))",
      "15:1988" : "15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))",
      "15:1989" : "15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))",
      "15:2301" : "15:2301 (15:2301 Magnuson-Moss Warranty Act)",
      "15:2801" : "15:2801 (15:2801 Petroleum Marketing Practices Act)",
      "15:53(b)" : "15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equita)",
      "16:0668" : "16:0668 (16:668 Bald Eagle Protection Act)",
      "16:0703" : "16:0703 (16:703 Migratory Bird Act)",
      "16:1538" : "16:1538 (16:1538 Endangered Species Act)",
      "16:3371" : "16:3371 (16:3371 Wildlife Under the Lacey Act)",
      "16:3372" : "16:3372 (16:3372 Conservation: Complaint for Forfeiture)",
      "16:3373" : "16:3373 (16:3373 Appeal of Decision - DOI)",
      "16:3374" : "16:3374 (16:3374 Conservation: Complaint for Forfeiture)",
      "17:0101" : "17:0101 (17:101 Copyright Infringement)",
      "17:0501" : "17:0501 (17:501 Copyright Infringement)",
      "17:0504" : "17:0504 (17:504 Copyright Infringement)",
      "18:0241" : "18:0241 (18:241 Conspiracy Against Citizen Rights)",
      "18:1836a" : "18:1836a (18:1836(a) Injunction against Misappropriation of Trade Secrets)",
      "18:1836b" : "18:1836b (18:1836(b) Civil Action to Protect Trade Secrets)",
      "18:1961" : "18:1961 (18:1961 Racketeering (RICO) Act)",
      "18:1962" : "18:1962 (18:1962 Racketeering (RICO) Act)",
      "18:1964" : "18:1964 (18:1964 Racketeering (RICO) Act)",
      "18:4208" : "18:4208 (18:4208(B) Agency Action Review)",
      "19:1305" : "19:1305 (19:1305 Custom Duties:0Forfeiture-Immoral Articles)",
      "20:1080" : "20:1080 (20:1080 Student Loan Recovery)",
      "20:1400" : "20:1400 (20:1400 Civil Rights of Handicapped Child)",
      "20:1401" : "20:1401 (20:1401 Education: Handicapped Child Act)",
      "21:0841" : "21:0841 (21:841 Forfeiture Property-Drugs)",
      "21:0881" : "21:0881 (21:881 Forfeiture Property-Drugs)",
      "21:0881a" : "21:0881a (21:881 Forfeiture Property - Aircraft)",
      "21:0881re" : "21:0881re (21:881 Forfeiture Property - Real Estate)",
      "23:0134" : "23:0134 (23:134 P.I.- Auto Negligence)",
      "23:1441" : "23:1441 (23:1441 Contract Real Estate)",
      "24:1000" : "24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)",
      "25:0640" : "25:0640 (25:640 Indian Tribal Rights)",
      "25:1901" : "25:1901 (25:1901 Indian Child Welfare Act)",
      "26:6212" : "26:6212 (26:6212 Injunctive Relief from IRS Lien)",
      "26:6213" : "26:6213 (26:6213 Injunctive Relief from IRS Lien)",
      "26:6502" : "26:6502 (26:6502 IRS:Enforcement of tax liens)",
      "26:6532" : "26:6532 (26:6532 IRS: Refund of Tax Penalty)",
      "26:6702" : "26:6702 (26:6702 IRS: Refund of Income Tax Penalty)",
      "26:6703" : "26:6703 (26:6703 IRS: Refund of Tax Penalty)",
      "26:7401" : "26:7401 (26:7401 IRS: Tax Liability)",
      "26:7402" : "26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)",
      "26:7403" : "26:7403 (26:7403 Suit to Enforce Federal Tax Lien)",
      "26:7422rt" : "26:7422rt (26:7422 IRS: Refund Taxes)",
      "26:7422rx" : "26:7422rx (26:7422 IRS: Refund Excise Tax)",
      "26:7426" : "26:7426 (26:7426 IRS: Wrongful Levy for Taxes)",
      "26:7429" : "26:7429 (26:7429 IRS: Tax Jeopardy Assessment)",
      "26:7609" : "26:7609 (26:7609 IRS: Petition to Quash IRS Summons)",
      "27:0185" : "27:0185 (27:185 Enforcement of Arbitration Award)",
      "28:0157c" : "28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)",
      "28:0157d" : "28:0157d (28:0157 Motion for Withdrawal of Reference)",
      "28:0158" : "28:0158 (28:0158 Notice of Appeal re Bankruptcy Matter (BA)",
      "28:0185" : "28:0185 (28:185 Suit to Compel Arbitration)",
      "28:0451" : "28:0451 (28:451 Employment Discrimination)",
      "28:0794" : "28:0794 (28:794 Rehabilitation Act)",
      "28:1001" : "28:1001 (28:1001 E.R.I.S.A.)",
      "28:1132" : "28:1132 (28:1132 E.R.I.S.A.)",
      "28:1330" : "28:1330 (28:1330 Breach of Contract)",
      "28:1331" : "28:1331 (28:1331 Fed. Question)",
      "28:1331al" : "28:1331al (28:1331 Fed. Question: Airline Crash)",
      "28:1331at" : "28:1331at (28:1331 Fed. Question: Anti-trust)",
      "28:1331au" : "28:1331au (28:1331 Fed. Question: Auto Negligence)",
      "28:1331b" : "28:1331b (28:1331 Federal Question: Bivens Act)",
      "28:1331bc" : "28:1331bc (28:1331 Fed. Question: Breach of Contract)",
      "28:1331ca" : "28:1331ca (28:1331 Fed Question: Fed Communications Act of 1)",
      "28:1331cm" : "28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)",
      "28:1331cv" : "28:1331cv (28:1331 Federal Question: Other Civil Rights)",
      "28:1331ed" : "28:1331ed (28:1331 Fed. Question: Employment Discrimination)",
      "28:1331es" : "28:1331es (28:1331 Enforcement of Administrative Subpoena)",
      "28:1331fl" : "28:1331fl (28:1331 Fed. Question: Fair Labor Standards)",
      "28:1331in" : "28:1331in (28:1331 Fed. Question: Insurance Contract)",
      "28:1331mm" : "28:1331mm (28:1331 Fed. Question: Medical Malpractice)",
      "28:1331pi" : "28:1331pi (28:1331 Fed. Question: Personal Injury)",
      "28:1331rd" : "28:1331rd (28:1331 Fed. Question: Review Agency Decision)",
      "28:1331rp" : "28:1331rp (28:1331(a) Fed. Question: Real Property)",
      "28:1331rr" : "28:1331rr (28:1331 Fed. Question: Railway Labor Act)",
      "28:1331sv" : "28:1331sv (28:1331 Fed. Question: Securities Violation)",
      "28:1331tr" : "28:1331tr (28:1331 Fed. Question: Trademark)",
      "28:1331tt" : "28:1331tt (28:1331 Fed. Question: Tort Action)",
      "28:1331v" : "28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendme)",
      "28:1331wl" : "28:1331wl (28:1331 Federal Question: EPA Waste Lien)",
      "28:1331wt" : "28:1331wt (28:1331 Fed. Question: Water Rights)",
      "28:1332ac" : "28:1332ac (28:1332 Diversity-Account Receivable)",
      "28:1332al" : "28:1332al (28:1332 Diversity-Airline Crash)",
      "28:1332as" : "28:1332as (28:1332 Diversity-Asbestos Litigation)",
      "28:1332au" : "28:1332au (28:1332 Diversity-Auto Negligence)",
      "28:1332bc" : "28:1332bc (28:1332 Diversity-Breach of Contract)",
      "28:1332co" : "28:1332co (28:1332 Diversity-Conversion)",
      "28:1332ct" : "28:1332ct (28:1332 Diversity-(Citizenship))",
      "28:1332det" : "28:1332det (28:1332 Diversity: Forcible Detainer)",
      "28:1332df" : "28:1332df (28:1332 Diversity-Contract Default)",
      "28:1332ds" : "28:1332ds (28:1332 Diversity-Contract Dispute)",
      "28:1332ed" : "28:1332ed (28:1332 Diversity-Employment Discrimination)",
      "28:1332fd" : "28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)",
      "28:1332fr" : "28:1332fr (28:1332 Diversity-Fraud)",
      "28:1332ia" : "28:1332ia (28:1332 Diversity-Interpleader Action)",
      "28:1332ij" : "28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)",
      "28:1332in" : "28:1332in (28:1332 Diversity-Insurance Contract)",
      "28:1332jd" : "28:1332jd (28:1332 Diversity-Declaratory Judgement)",
      "28:1332lb" : "28:1332lb (28:1332 Diversity-Libel,Assault,Slander)",
      "28:1332lm" : "28:1332lm (28:1332 Diversity - Legal Malpractice)",
      "28:1332ma" : "28:1332ma (28:1332 Diversity-Miller Act)",
      "28:1332mm" : "28:1332mm (28:1332 Diversity-Medical Malpractice)",
      "28:1332mv" : "28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)",
      "28:1332ni" : "28:1332ni (28:1332 Diversity-Negotiable Instrument)",
      "28:1332nm" : "28:1332nm (28:1332 Diversity-Non-Motor Vehicle)",
      "28:1332oc" : "28:1332oc (28:1332 Diversity-Other Contract)",
      "28:1332pd" : "28:1332pd (28:1332 Diversity-Property Damage)",
      "28:1332pi" : "28:1332pi (28:1332 Diversity-Personal Injury)",
      "28:1332pl" : "28:1332pl (28:1332 Diversity-Product Liability)",
      "28:1332pr" : "28:1332pr (28:1332 Diversity-Petition for Removal)",
      "28:1332qt" : "28:1332qt (28:1332 Diversity-Petition to Quiet Title)",
      "28:1332ri" : "28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)",
      "28:1332sa" : "28:1332sa (28:1332 - Diversity: Securities & Exchange Commiss)",
      "28:1332sf" : "28:1332sf (28:1332 - Diversity: Securities Fraud)",
      "28:1332ss" : "28:1332ss (28:1332 Diversity - Stockholders Suits)",
      "28:1332tl" : "28:1332tl (28:1332 Diversity-Torts to Land)",
      "28:1332tm" : "28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))",
      "28:1332tn" : "28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)",
      "28:1332wd" : "28:1332wd (28:1332 Diversity-Wrongful Death)",
      "28:1333" : "28:1333 (28:1333 Admiralty)",
      "28:1334" : "28:1334 (28:1334 Bankruptcy Appeal)",
      "28:1334c" : "28:1334c (28:1334(c) R&R re motions for abstention (non-cor)",
      "28:1335" : "28:1335 (28:1335 Interpleader Action)",
      "28:1337" : "28:1337 (28:1337 Sherman-Clayton Act)",
      "28:1338cp" : "28:1338cp (28:1338 Copyright Infringement)",
      "28:1338pt" : "28:1338pt (28:1338 Patent Infringement)",
      "28:1338tr" : "28:1338tr (28:1338 Trademark Infringement)",
      "28:1340" : "28:1340 (28:1340 IRS: Custom Duties)",
      "28:1340er" : "28:1340er (28:1340 Recovery of Erroneous Refund)",
      "28:1341" : "28:1341 (28:1341 Complaint for Forfeiture)",
      "28:1343" : "28:1343 (28:1343 Violation of Civil Rights)",
      "28:1345co" : "28:1345co (28:1345 Replevin & Conversion)",
      "28:1345db" : "28:1345db (28:1345 Debt to US - FHA/HUD Title I)",
      "28:1345df" : "28:1345df (28:1345 Default of Promissory Note)",
      "28:1345er" : "28:1345er (28:1345 Recovery of Erroneous Refund)",
      "28:1345fc" : "28:1345fc (28:1345 Foreclosure)",
      "28:1345ff" : "28:1345ff (28:1345 Complaint for Forfeiture)",
      "28:1345hl" : "28:1345hl (28:1345 VA Home Loan Guaranty Debt)",
      "28:1345mc" : "28:1345mc (28:1345 Medical Care Recovery)",
      "28:1345mi" : "28:1345mi (28:1345 Mining Claim Ejectment)",
      "28:1345pd" : "28:1345pd (28:1345 Property Damage)",
      "28:1345pe" : "28:1345pe (28:1345 Property Ejectment)",
      "28:1345rc" : "28:1345rc (28:1345 Recovery of Debt to US)",
      "28:1345st" : "28:1345st (28:1345 Default of Student Loan)",
      "28:1345tp" : "28:1345tp (28:1345 Trespass on Public Land)",
      "28:1345va" : "28:1345va (28:1345 Recovery of VA Overpayment)",
      "28:1346bc" : "28:1346bc (28:1346 Breach of Contract)",
      "28:1346rc" : "28:1346rc (28:1346 Recovery of IRS Tax)",
      "28:1346tc" : "28:1346tc (28:1346 Tort Claim)",
      "28:1346wd" : "28:1346wd (28:1346 Wrongful Death)",
      "28:1352" : "28:1352 (28:1352 Miller Act)",
      "28:1355" : "28:1355 (28:1355 Petition for Return of Property)",
      "28:1358" : "28:1358 (28:1358 Land Condemnation)",
      "28:1361" : "28:1361 (28:1361 Petition for Writ of Mandamus)",
      "28:1362ic" : "28:1362ic (28:1362 Indian Tribal Controversy)",
      "28:1362iw" : "28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)",
      "28:1364" : "28:1364 (28:1364 Auto Negligence)",
      "28:1391" : "28:1391 (28:1391 Personal Injury)",
      "28:1402" : "28:1402 (28:1402 Medical Malpractice)",
      "28:1407" : "28:1407 (28:1407 Airline Crash)",
      "28:1441ac" : "28:1441ac (28:1441 Petition for Removal- Account Receivable)",
      "28:1441al" : "28:1441al (28:1441 Petition for Removal- Airline Crash)",
      "28:1441as" : "28:1441as (28:1441 Petition for Removal- Asbestos Litigation)",
      "28:1441au" : "28:1441au (28:1441 Petition for Removal- Auto Negligence)",
      "28:1441bc" : "28:1441bc (28:1441 Petition for Removal- Breach of Contract)",
      "28:1441cv" : "28:1441cv (28:1441 Petition for Removal- Civil Rights Act)",
      "28:1441df" : "28:1441df (28:1441 Petition for Removal- Contract Default)",
      "28:1441dj" : "28:1441dj (28:1441 Petition for Removal- Declaratory Judgemen)",
      "28:1441ds" : "28:1441ds (28:1441 Petition for Removal- Contract Dispute)",
      "28:1441ed" : "28:1441ed (28:1441 Petition for Removal - Employment Discrim)",
      "28:1441fc" : "28:1441fc (28:1441 Petition for Removal - Fair Credit Reporti)",
      "28:1441fr" : "28:1441fr (28:1441 Petition for Removal- Fraud)",
      "28:1441ij" : "28:1441ij (28:1441 Petition for Removal- Injunctive/Declarato)",
      "28:1441in" : "28:1441in (28:1441 Petition for Removal- Insurance Contract)",
      "28:1441int" : "28:1441int (28:1441 Petition for Removal- Action for Interplea)",
      "28:1441lb" : "28:1441lb (28:1441 Petition for Removal Libel,Assault,Slander)",
      "28:1441lm" : "28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relatio)",
      "28:1441mm" : "28:1441mm (28:1441 Petition for Removal- Medical Malpractice)",
      "28:1441ni" : "28:1441ni (28:1441 Petition for Removal- Negotiable Instrumen)",
      "28:1441nm" : "28:1441nm (28:1441 Petition for Removal- Non-Motor Vehicle)",
      "28:1441oc" : "28:1441oc (28:1441 Petition For Removal--Other Contract)",
      "28:1441pd" : "28:1441pd (28:1441 Petition for Removal- Property Damage)",
      "28:1441pi" : "28:1441pi (28:1441 Petition for Removal- Personal Injury)",
      "28:1441pl" : "28:1441pl (28:1441 Petition for Removal- Product Liability)",
      "28:1441pr" : "28:1441pr (28:1441 Petition for Removal)",
      "28:1441qt" : "28:1441qt (28:1441 Petition for Removal- Petition to Quiet Ti)",
      "28:1441ri" : "28:1441ri (28:1441 Petition for Removal- Racketeering (RICO))",
      "28:1441sa" : "28:1441sa (28:1441 - Petition for Removal: SEC Act)",
      "28:1441sf" : "28:1441sf (28:1441 - Petition for Removal: Securities Fraud)",
      "28:1441tl" : "28:1441tl (28:1441 Petition for Removal- Torts to Land)",
      "28:1441tm" : "28:1441tm (28:1441 Petition for Removal- Tort/Motor Vehicle ()",
      "28:1441tn" : "28:1441tn (28:1441 Petition for Removal- Tort/Non-Motor Vehic)",
      "28:1441wd" : "28:1441wd (28:1441 Petition for Removal- Wrongful Death)",
      "28:1442bc" : "28:1442bc (28:1442 Petition for Removal- Breach of Contract)",
      "28:1442pr" : "28:1442pr (28:1442 Petition for Removal)",
      "28:1443" : "28:1443 (28:1443(1) Rent, Lease & Ejectment)",
      "28:1444" : "28:1444 (28:1444 Petition for Removal- Foreclosure)",
      "28:1446in" : "28:1446in (28:1446 Breach of Contract- Insurance)",
      "28:1446pd" : "28:1446pd (28:1446 Petition for Removal- Property Damage (P.I)",
      "28:1446pi" : "28:1446pi (28:1446 Petition for Removal- Personal Injury)",
      "28:1446pl" : "28:1446pl (28:1446pl Petition for Removal - Product Liability)",
      "28:1446pr" : "28:1446pr (28:1446 Petition for Removal)",
      "28:1452" : "28:1452 (28:1452 R&R re motions to remand (non-core))",
      "28:1651" : "28:1651 (28:1651 Petition for Writ of Coram Nobis)",
      "28:1651hc" : "28:1651hc (28:1651 Petition for Writ of Habeas Corpus)",
      "28:1651mn" : "28:1651mn (28:1651 Petition for Writ of Mandamus)",
      "28:1983" : "28:1983 (28:1983 Civil Rights)",
      "28:2201" : "28:2201 (28:2201 Constitutionality of State Statute(s))",
      "28:2201dj" : "28:2201dj (28:2201 Declaratory Judgment)",
      "28:2201ij" : "28:2201ij (28:2201 Injunction)",
      "28:2201in" : "28:2201in (28:2201 Declaratory Judgment (Insurance))",
      "28:2241" : "28:2241 (28:2241 Petition for Writ of Habeas Corpus (federa)",
      "28:2254" : "28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))",
      "28:2254se" : "28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)",
      "28:2255" : "28:2255 (28:2255 Motion to Vacate / Correct Illegal Sentenc)",
      "28:2271" : "28:2271 (28:2271 Federal Tort Claims Act)",
      "28:2345" : "28:2345 (28:2345 Medicare Recovery)",
      "28:2409" : "28:2409 (28:2409(a) Quiet Title Action)",
      "28:2410" : "28:2410 (28:2410 Quiet Title)",
      "28:2671" : "28:2671 (28:2671 Federal Tort Claims Act)",
      "28:2674" : "28:2674 (28:2674 Federal Tort Claims Act)",
      "28:7402" : "28:7402 (28:7402 Refund of Taxes)",
      "28:7422" : "28:7422 (28:7422 Appeal from Administrative Decision)",
      "29:0151" : "29:0151 (29:151 Labor: Review of Agency Action)",
      "29:0160" : "29:0160 (29:160(1) National Labor Relations Act)",
      "29:0184" : "29:0184 (29:184 Violation Collection Bargain Agreement)",
      "29:0185ep" : "29:0185ep (29:185 Employee Pension Plan)",
      "29:0185lm" : "29:0185lm (29:185 Labor/Mgt. Relations (Contracts))",
      "29:0201do" : "29:0201do (29:201 Denial of Overtime Compensation)",
      "29:0201fl" : "29:0201fl (29:201 Fair Labor Standards Act)",
      "29:0203" : "29:0203 (29:203 Equal Pay Act)",
      "29:0206" : "29:0206 (29:206 Collect Unpaid Wages)",
      "29:0401" : "29:0401 (29:0401 Labor Management Disclosure Act)",
      "29:0621" : "29:0621 (29:621 Job Discrimination (Age))",
      "29:0623" : "29:0623 (29:623 Job Discrimination (Age))",
      "29:0626" : "29:0626 (29:626 Job Discrimination (Age))",
      "29:0633" : "29:0633 (29:633 Job Discrimination (Age))",
      "29:0651" : "29:0651 (29:651 Occupational Safety/Health)",
      "29:0754" : "29:0754 (29:754 Discrimination)",
      "29:0791" : "29:0791 (29:791 Job Discrimination (Rehabilitation Act))",
      "29:0794" : "29:0794 (29:0794 Job Discrimination (Handicap))",
      "29:1001" : "29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)",
      "29:1002" : "29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)",
      "29:1104" : "29:1104 (29:1104 Recovery of Benefits to Employee)",
      "29:1109" : "29:1109 (29:1109 Breach of Fiduciary Duties)",
      "29:1131" : "29:1131 (29:1131 ERISA - Collection of Delinquent Trust Fun)",
      "29:1132" : "29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)",
      "29:1145" : "29:1145 (29:1145 E.R.I.S.A.)",
      "29:1149" : "29:1149 (29:1149 Recover Pension & Profit Sharing)",
      "29:1337" : "29:1337 (29:1337 E.R.I.S.A.)",
      "29:1362" : "29:1362 (29:1362 ERISA)",
      "29:1381" : "29:1381 (29:1381 E.R.I.S.A.)",
      "29:1401" : "29:1401 (29:1401(b)(2) Appeal of Arbitration Award)",
      "29:1451" : "29:1451 (29:1451 E.R.I.S.A.)",
      "29:1801" : "29:1801 (29:1801 Farmworker Rights)",
      "29:790" : "29:790 (29:790 Rehabilitation of Labor)",
      "30:0181" : "30:0181 (30:181 Environment: Review of Agency Action)",
      "30:0801" : "30:0801 (30:0801 Penalities/Federal Mine Safety Health Act)",
      "30:1201" : "30:1201 (30:1201 Environment: Review of Agency Action)",
      "30:1202" : "30:1202 (30:1202 Mining Reclamation Act)",
      "30:1276" : "30:1276 (30:1276 Interior: Review of Agency Action)",
      "31:3545" : "31:3545 (31:3545 Action to Recovery Money)",
      "31:3729" : "31:3729 (31:3729 False Claims Act)",
      "31:3730" : "31:3730 (31:3730 Qui Tam False Claims Act)",
      "31:3731" : "31:3731 (31:3731 Fraud)",
      "33:1319cw" : "33:1319cw (33:1319 Clean Water Act)",
      "33:1319pv" : "33:1319pv (33:1319 Pollutants & Permit Violations)",
      "33:1365" : "33:1365 (33:1365 Environmental Matters)",
      "35:0145" : "35:0145 (35:145 Patent Infringement)",
      "35:0183" : "35:0183 (35:183 Patent Infringement)",
      "35:0271" : "35:0271 (35:271 Patent Infringement)",
      "38:1681" : "38:1681 (38:1681 Recovery of VA Overpayment)",
      "38:1686" : "38:1686 (38:1686 Recovery of VA Overpayment)",
      "38:1780" : "38:1780 (38:1780 Recovery of VA Overpayment)",
      "38:2011" : "38:2011 (38:2011 - Veteran's Readjustment Assistance Act of)",
      "38:3116" : "38:3116 (38:3116 VA Overpayment)",
      "39:3005" : "39:3005 (39:3005 Detention of Mail for Temporary Periods)",
      "39:409" : "39:409 (39:409 Postal Service)",
      "40:0258" : "40:0258 (40:258(a) Public Buildings & Property: Land Condem)",
      "40:0270" : "40:0270 (40:270 Miller Act)",
      "40:0875" : "40:0875 (40:875 Public Buildings & Property: Negligence)",
      "41:0251" : "41:0251 (41:251 Public Contracts-Review of Agency Action)",
      "41:1463" : "41:1463 (41:1463 Public Contracts: Unlawful Employment Prac)",
      "42:0205" : "42:0205 (42:205 Denial Social Security Benefits)",
      "42:0206" : "42:0206 (42:206 Social Security Benefits)",
      "42:0247" : "42:0247 (42:247 Personal Injury-Swine Flu)",
      "42:0402" : "42:0402 (42:402 Social Security Benefits)",
      "42:0405id" : "42:0405id (42:405 Review of HHS Decision (SSID))",
      "42:0405wc" : "42:0405wc (42:405 Review of HHS Decision (DIWC))",
      "42:0405ww" : "42:0405ww (42:405 Review of HHS Decision (DIWW))",
      "42:0416" : "42:0416 (42:416 Denial of Social Security Benefits)",
      "42:0427" : "42:0427 (42:427 Social Security Benefits)",
      "42:1383" : "42:1383 (42:1383 Review of HHS Decision)",
      "42:1395" : "42:1395 (42:1395 HHS: Adverse Reimbursement Review)",
      "42:1396" : "42:1396 (42:1396 - Tort Negligence)",
      "42:1471" : "42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclo)",
      "42:1981cv" : "42:1981cv (42:1981 Civil Rights)",
      "42:1981hs" : "42:1981hs (42:1981 Housing Discrimination)",
      "42:1981jb" : "42:1981jb (42:1981 Job Discrimination (Race))",
      "42:1981sx" : "42:1981sx (42:1981 Sex Discrimination)",
      "42:1983cv" : "42:1983cv (42:1983 Civil Rights Act)",
      "42:1983ed" : "42:1983ed (42:1983 Civil Rights (Employment Discrimination))",
      "42:1983pr" : "42:1983pr (42:1983 Prisoner Civil Rights)",
      "42:1986" : "42:1986 (42:1986 Neglect of Duty)",
      "42:2000ag" : "42:2000ag (42:2000 Job Discrimination (Age))",
      "42:2000e" : "42:2000e (42:2000e Job Discrimination (Employment))",
      "42:2000pb" : "42:2000pb (42:2000 Job Discrimination (Public Accomodations))",
      "42:2000ra" : "42:2000ra (42:2000 Job Discrimination (Race))",
      "42:2000sx" : "42:2000sx (42:2000 Job Discrimination (Sex))",
      "42:2003" : "42:2003 (42:2003 Job Discrimination)",
      "42:2005" : "42:2005 (42:2005 Review of Agency Action-HHS)",
      "42:2651" : "42:2651 (42:2651 Medical Care Recovery)",
      "42:3601" : "42:3601 (42:405 Fair Housing Act)",
      "42:4000" : "42:4000 (42:4000 National Flood Insurance Act)",
      "42:4001" : "42:4001 (42:4001 National Insurance Flood Act)",
      "42:4053" : "42:4053 (42:4053 Breach of Insurance Contract)",
      "42:4072" : "42:4072 (42:4072 Payment of Flood Insurance Claim)",
      "42:4321" : "42:4321 (42:4321 Review of Agency Action-Environment)",
      "42:4332" : "42:4332 (42:4332 Environmental Policy - Coop of Agency Repo)",
      "42:6901en" : "42:6901en (42:6901 Environmental Cleanup Expenses)",
      "42:6901rs" : "42:6901rs (42:6901 Resource & Recovery Act)",
      "42:7413" : "42:7413 (42:7413(b) Clean Air Act)",
      "42:7604cl" : "42:7604cl (42:7604 Clear Air Act (Emission Standards))",
      "42:7604ir" : "42:7604ir (42:7604 Petition to Quash IRS Summons)",
      "42:9607" : "42:9607 (42:9607 Real Property Tort to Land)",
      "43:945" : "43:945 (43:945 Compensation for Land Condemnation)",
      "43:945a" : "43:945a (43:945a Complaint in Condemnation)",
      "43:946" : "43:946 (43:946 Complaint in Condemnation - Eminent Domain)",
      "45:0051" : "45:0051 (45:51 Railways: Fed. Employer's Liability Act)",
      "45:0151" : "45:0151 (45:151 Railway Labor Act)",
      "45:0184" : "45:0184 (45:184 Action to Set Aside Award of a System Board)",
      "45:1395" : "45:1395 (45:1395 Railroads: Adverse Reimbursement Review)",
      "45:7457" : "45:7457 (45:7457 Compel Reclamation Under Clear Air Act)",
      "46:0688" : "46:0688 (46:688 Jones Act)",
      "46:0741" : "46:0741 (46:741 Shipping)",
      "46:0761" : "46:0761 (46:761 Shipping: Damages for Death on High Seas)",
      "46:1101" : "46:1101 (46:1101 Violation of Maritime Regulations)",
      "46:1156" : "46:1156 (46:1156 Administrative Procedure Act)",
      "48:0883" : "48:0883 (48:883 Violation of US Coastal Law)",
      "48:1985" : "48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)",
      "49:0081" : "49:0081 (49:81 Damaged Goods While Being Transported)",
      "49:0781" : "49:0781 (49:781 Forfeiture)",
      "49:11503" : "49:11503 (49:11503 Railroad Revitalization Regulatory Reform)",
      "49:11702" : "49:11702 (49:11702(a)(4) Violations of Interstate Commerce A)",
      "49:1471" : "49:1471 (49:1471 Federal Aviation Act)",
      "49:1903" : "49:1903 (49:1903 Petition to enforce administrative summon)",
      "8:287" : "8:287 (8:287 Petition to Enforce INS Subpoena)",
      "misc" : "misc (Civil Miscellaneous Case)"
   },
   "almdce" : {
      "0" : "0 (No cause code entered)",
      "02:0431" : "02:0431 (02:431 Fed. Election Commission: Failure Enforce C)",
      "02:0437" : "02:0437 (02:437 Federal Election Commission)",
      "05:0075" : "05:0075 (05:75(2) Contract - Reduction in Grade)",
      "05:0551" : "05:0551 (05:551 Administrative Procedure Act)",
      "05:0552fi" : "05:0552fi (05:552 Freedom of Information Act)",
      "05:0552pa" : "05:0552pa (05:552 Right to Privacy Act)",
      "05:0554" : "05:0554 (05:0554 Constitutionality of Maritime Statutes)",
      "05:0701" : "05:0701 (05:0701 Maritime Subsidy Board)",
      "05:0702" : "05:0702 (05:702 Administrative Procedure Act)",
      "05:0704" : "05:0704 (05:704 Labor Litigation)",
      "05:7703" : "05:7703 (05:7703 Discrimination - Review of Agency Act)",
      "05:8101" : "05:8101 (05:8101 Workmen's Compensation Benefits)",
      "05:8470" : "05:8470 (05:8470 Enforcement of Judgment against Retirement Benefits)",
      "05:8701" : "05:8701 (05:8701 Federal Employees' Group Life Insurance Act)",
      "05:8705" : "05:8705 (05:8705 Declaratory Judgment - Insurance)",
      "07:0006" : "07:0006 (7:6(b) Federal Commodity Exchange Regulation)",
      "07:0025" : "07:0025 (7:25 Fraud - Commodities Leverage Contracts)",
      "07:0136" : "07:0136 (07:0136 Fed. Insecticide Fungicide & Rodenticide Act of 1942)",
      "07:0181" : "07:0181 (07:181 Packers & Stockyard Act)",
      "07:0499" : "07:0499 (07:499 Agricultural Commodities Act)",
      "07:0601" : "07:0601 (07:601 USDA Condemnation)",
      "07:0901" : "07:0901 (07:0901 Rural Electrification Act)",
      "07:1501" : "07:1501 (07:1501 Federal Crop Insurance Act)",
      "07:2156" : "07:2156 (07:2156 Animal Fighting Venture Prohibition)",
      "07:2321" : "07:2321 (07:2321 Plant Variety Protection Act)",
      "08:1105" : "08:1105 (8:1105(a) Aliens: Habeas Corpus to Release INS Det)",
      "08:1182" : "08:1182 (8:1182 Defend. Denial of Pla. Appl. for Alien Employment Cer)",
      "08:1252" : "08:1252 (08:1252(a)(2) Injunction for Deportation)",
      "08:1260" : "08:1260 (08:1260 Aliens: Access to Records)",
      "08:1324" : "08:1324 (08:1324 Aliens: Complaint for Forfeiture)",
      "08:1329" : "08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petiti)",
      "08:1421" : "08:1421 (08:1421 Judicial Review of Naturalization Authority)",
      "08:1446" : "08:1446 (8:1446 Petition for Naturalization Hearing)",
      "08:1451(j)" : "08:1451(j) (8:1451(j) Motion to Correct Order & Judg. of Naturalization)",
      "09:0001" : "09:0001 (09:1 U.S. Arbitration Act)",
      "09:0004" : "09:0004 (09:0004 U.S. Arbitration Act)",
      "09:0009" : "09:0009 (9:9 Motion to Confirm Arbitration Award)",
      "09:0010" : "09:0010 (09:0010 Petition to Vacate Arbitration Award)",
      "10:1072tc" : "10:1072tc (10:1072 TRICARE PROGRAM)",
      "10:1408" : "10:1408 (10:1408 Claim for Military Retirement)",
      "10:1552" : "10:1552 (10:1552 Armed Forces: Action to Correct Records)",
      "10:1553" : "10:1553 (10:1553 Armed Forces: FOIA General)",
      "10:2305" : "10:2305 (10:2305 Review of Federal Contract)",
      "11:0101" : "11:0101 (11:101 Bankruptcy)",
      "11:525" : "11:525 (11:525 Discrimination Treatment (Bankruptcy))",
      "12:0022" : "12:0022 (12:22 Securities Fraud)",
      "12:0611" : "12:0611 (12:0611 Edge Act)",
      "12:0635" : "12:0635 (12:635 Breach of Insurance Contract)",
      "12:1452" : "12:1452 (12:1452 Federa Home Loan Mortgage Corporation)",
      "12:1461" : "12:1461 (12:1461 Homeowners Loan Act)",
      "12:1464" : "12:1464 (12:1464 Federal Savings and Loan)",
      "12:1703" : "12:1703 (12:1703 Default of HUD Loan)",
      "12:1725" : "12:1725 (12:1725 Collection under Contract Guaranty)",
      "12:1730" : "12:1730 (12:1730 Collection Under Contract Guaranty)",
      "12:1819" : "12:1819 (12:1819 Default of Promissory Note)",
      "12:1821" : "12:1821 (12:1821 FDIC Insurance Funds)",
      "12:191" : "12:191 (12:191 Bank Foreclosure)",
      "12:192" : "12:192 (12:192 Liquidation of National Bank)",
      "12:1971" : "12:1971 (12:1971 Relief under Bank Holding Act)",
      "12:1972" : "12:1972 (12:1972 Typing Arrangement Act)",
      "12:2601" : "12:2601 (12:2601 Real Estate Settlement Procedures Act)",
      "12:2605" : "12:2605 (12:2605 Real Estate Settlement Procedures Act)",
      "12:3410" : "12:3410 (12:3410 Right to Financial Privacy Act)",
      "12:3801" : "12:3801 (12:3801 Parity Act)",
      "12:5201" : "12:5201 (12:5201 Economic Stabilization Act of 2008)",
      "15:0001" : "15:0001 (15:1 Antitrust Litigation)",
      "15:0002at" : "15:0002at (15:2 Antitrust Litigation)",
      "15:0002fl" : "15:0002fl (15:2(a) Fair Labor Standards Act)",
      "15:0005" : "15:0005 (15:5(a) Fair Labor Standards Act)",
      "15:0013" : "15:0013 (15:0013 Robinson Patman Act)",
      "15:0015" : "15:0015 (15:15 Antitrust Litigation)",
      "15:0015a" : "15:0015a (15:15(a) Antitrust Litigation)",
      "15:0025" : "15:0025 (15:25 Clayton Act)",
      "15:0044" : "15:0044 (15:44 Trademark Infringement)",
      "15:0045" : "15:0045 (15:0045 Federal Trade Commission Act)",
      "15:0052" : "15:0052 (15:0052 Federal Trade Commission Act)",
      "15:0053" : "15:0053 (15:0053 Federal Trade Commission Act)",
      "15:0077" : "15:0077 (15:77 Securities Fraud)",
      "15:0078" : "15:0078 (15:78m(a) Securities Exchange Act)",
      "15:0631" : "15:0631 (15:631 Small Business Act)",
      "15:0717" : "15:0717 (15:717 Natural Gas Act)",
      "15:0754" : "15:0754 (15:754 Emergency Petroleum Allocation-Admin.& Enforcement)",
      "15:1051" : "15:1051 (15:1051 Trademark Infringement)",
      "15:1114" : "15:1114 (15:1114 Trademark Infringement)",
      "15:1120" : "15:1120 (15:1120 Trademark - False or Fraudulent Registration)",
      "15:1121" : "15:1121 (15:1121 Trademark Infringement)",
      "15:1125" : "15:1125 (15:1125 Trademark Infringement (Lanham Act))",
      "15:1126" : "15:1126 (15:1126 Patent Infringement)",
      "15:1127" : "15:1127 (15:1127 Trademark Infringement)",
      "15:1601" : "15:1601 (15:1601 Truth in Lending)",
      "15:1640" : "15:1640 (15:1640 Truth in Lending)",
      "15:1667" : "15:1667 (15:1667 Consumer Leasing Act)",
      "15:1671" : "15:1671 (15:1671 Consumer Credit Protection Act)",
      "15:1681" : "15:1681 (15:1681 Fair Credit Reporting Act)",
      "15:1691" : "15:1691 (15:1691 Equal Credit Opportunity Act)",
      "15:1692" : "15:1692 (15:1692 Fair Debt Collection Act)",
      "15:1693" : "15:1693 (15:1693 Electronic Fund Transfer Act)",
      "15:1938" : "15:1938 (15:1938 Fair Labor Standards Act)",
      "15:1981" : "15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))",
      "15:1988" : "15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))",
      "15:1989" : "15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))",
      "15:2301" : "15:2301 (15:2301 Magnuson-Moss Warranty Act)",
      "15:2801" : "15:2801 (15:2801 Petroleum Marketing Practices Act)",
      "15:53(b)" : "15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equita)",
      "16:0470" : "16:0470 (16:0470 National Historic Preservation Act)",
      "16:0668" : "16:0668 (16:668 Bald Eagle Protection Act)",
      "16:0703" : "16:0703 (16:703 Migratory Bird Act)",
      "16:1244" : "16:1244 (16:1244 National Scenic and National Historic Trails)",
      "16:1533" : "16:1533 (16:1533 Endangered Species Act)",
      "16:1538" : "16:1538 (16:1538 Endangered Species Act)",
      "16:3371" : "16:3371 (16:3371 Wildlife Under the Lacey Act)",
      "16:3372" : "16:3372 (16:3372 Conservation: Complaint for Forfeiture)",
      "16:3373" : "16:3373 (16:3373 Appeal of Decision - DOI)",
      "16:3374" : "16:3374 (16:3374 Conservation: Complaint for Forfeiture)",
      "17:0101" : "17:0101 (17:101 Copyright Infringement)",
      "17:0501" : "17:0501 (17:501 Copyright Infringement)",
      "17:0504" : "17:0504 (17:504 Copyright Infringement)",
      "18:0241" : "18:0241 (18:241 Conspiracy Against Citizen Rights)",
      "18:0981" : "18:0981 (18:0981 Civil forfeiture)",
      "18:1030" : "18:1030 (18:1030 Computer Fraud and Abuse Act)",
      "18:1345" : "18:1345 (18:1345 Fraud Injunction Statute)",
      "18:1836a" : "18:1836a (18:1836(a) Injunction against Misappropriation of Trade Secrets)",
      "18:1836b" : "18:1836b (18:1836(b) Civil Action to Protect Trade Secrets)",
      "18:1956" : "18:1956 (18:1956 Forfeiture Property)",
      "18:1957" : "18:1957 (18:1957 Forfeiture Property)",
      "18:1961" : "18:1961 (18:1961 Racketeering (RICO) Act)",
      "18:1962" : "18:1962 (18:1962 Racketeering (RICO) Act)",
      "18:1964" : "18:1964 (18:1964 Racketeering (RICO) Act)",
      "18:2254" : "18:2254 (18:2254 Civil Forfeiture)",
      "18:2510" : "18:2510 (18:2510 Electronic Communications Privacy Act)",
      "18:2511" : "18:2511 (18:2511 Wiretapping)",
      "18:2721" : "18:2721 (18:2721 Automobile Information Disclosure Act)",
      "18:3114" : "18:3114 (18:3114 Motion for Return of Seized Property)",
      "18:3184" : "18:3184 (18:3184 Extradition Procedure)",
      "18:3771" : "18:3771 (18:3771(d)(3) Crime Victims' Rights Motion for Relief and Writ)",
      "18:4100" : "18:4100 (18:4100 Transfer of Offenders)",
      "18:4208" : "18:4208 (18:4208(B) Agency Action Review)",
      "18:492" : "18:492 (18:492 Counterfeiting and Forgery)",
      "18:922" : "18:922 (18:922 Firearms - Unlawful Possession)",
      "19:1305" : "19:1305 (19:1305 Custom Duties:0Forfeiture-Immoral Articles)",
      "19:1607" : "19:1607 (19:1607 Notice of Seizure-Return of Seized Property)",
      "20:107" : "20:107 (20:107 Randolph-Sheppard Vending Stand Act)",
      "20:1080" : "20:1080 (20:1080 Student Loan Recovery)",
      "20:1400" : "20:1400 (20:1400 Civil Rights of Handicapped Child)",
      "20:1401" : "20:1401 (20:1401 Education: Handicapped Child Act)",
      "20:1681" : "20:1681 (20:1681 Education: Sex)",
      "21:0360" : "21:0360 (21:0360 Federal Food, Drug and Cosmetic Act)",
      "21:0841" : "21:0841 (21:841 Forfeiture Property-Drugs)",
      "21:0881" : "21:0881 (21:881 Forfeiture Property-Drugs)",
      "21:0881a" : "21:0881a (21:881 Forfeiture Property - Aircraft)",
      "21:0881re" : "21:0881re (21:881 Forfeiture Property - Real Estate)",
      "23:0112" : "23:0112 (23:112 Federal Highway Act)",
      "23:0134" : "23:0134 (23:134 P.I.- Auto Negligence)",
      "23:1441" : "23:1441 (23:1441 Contract Real Estate)",
      "24:1000" : "24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)",
      "25:0640" : "25:0640 (25:640 Indian Tribal Rights)",
      "25:1901" : "25:1901 (25:1901 Indian Child Welfare Act)",
      "25:2701" : "25:2701 (25:2701 Indian Gaming Regulation)",
      "26:6109" : "26:6109 (26:6109 IRS:Procedure and Administration)",
      "26:6212" : "26:6212 (26:6212 Injunctive Relief from IRS Lien)",
      "26:6213" : "26:6213 (26:6213 Injunctive Relief from IRS Lien)",
      "26:6221" : "26:6221 (TEFRA Tax, Equity and Fiscal Responsibility Act of 1982)",
      "26:63" : "26:63 (26:63 IRS: Taxable income)",
      "26:6330" : "26:6330 (26:6330 IRS: Notice and Opportunity for Hearing before Levy)",
      "26:6331" : "26:6331 (26:6331 IRS: Levy and distraint-Seizure of Property for Collection of Taxes)",
      "26:6502" : "26:6502 (26:6502 IRS:Enforcement of tax liens)",
      "26:6532" : "26:6532 (26:6532 IRS: Refund of Tax Penalty)",
      "26:6694" : "26:6694 (26:6694 IRS: Injunction against Tax Preparer)",
      "26:6702" : "26:6702 (26:6702 IRS: Refund of Income Tax Penalty)",
      "26:6703" : "26:6703 (26:6703 IRS: Refund of Tax Penalty)",
      "26:7401" : "26:7401 (26:7401 IRS: Tax Liability)",
      "26:7402" : "26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)",
      "26:7403" : "26:7403 (26:7403 Suit to Enforce Federal Tax Lien)",
      "26:7407" : "26:7407 (26:7407 IRS Action to enjoin tax return preparers)",
      "26:7422rt" : "26:7422rt (26:7422 IRS: Refund Taxes)",
      "26:7422rx" : "26:7422rx (26:7422 IRS: Refund Excise Tax)",
      "26:7426" : "26:7426 (26:7426 IRS: Wrongful Levy for Taxes)",
      "26:7429" : "26:7429 (26:7429 IRS: Tax Jeopardy Assessment)",
      "26:7609" : "26:7609 (26:7609 IRS: Petition to Quash IRS Summons)",
      "27:0185" : "27:0185 (27:185 Enforcement of Arbitration Award)",
      "28:0157c" : "28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)",
      "28:0157d" : "28:0157d (28:0157 Motion for Withdrawal of Reference)",
      "28:0158" : "28:0158 (28:0158 Notice of Appeal re Bankruptcy Matter (BA)",
      "28:0185" : "28:0185 (28:185 Suit to Compel Arbitration)",
      "28:0451" : "28:0451 (28:451 Employment Discrimination)",
      "28:0754" : "28:0754 (28:754 Receiver of Property in Different Districts)",
      "28:0794" : "28:0794 (28:794 Rehabilitation Act)",
      "28:1001" : "28:1001 (28:1001 E.R.I.S.A.)",
      "28:1132" : "28:1132 (28:1132 E.R.I.S.A.)",
      "28:1330" : "28:1330 (28:1330 Breach of Contract)",
      "28:1331" : "28:1331 (28:1331 Fed. Question)",
      "28:1331al" : "28:1331al (28:1331 Fed. Question: Airline Crash)",
      "28:1331at" : "28:1331at (28:1331 Fed. Question: Anti-trust)",
      "28:1331au" : "28:1331au (28:1331 Fed. Question: Auto Negligence)",
      "28:1331b" : "28:1331b (28:1331 Federal Question: Bivens Act)",
      "28:1331bc" : "28:1331bc (28:1331 Fed. Question: Breach of Contract)",
      "28:1331ca" : "28:1331ca (28:1331 Fed Question: Fed Communications Act of 1)",
      "28:1331cm" : "28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)",
      "28:1331cv" : "28:1331cv (28:1331 Federal Question: Other Civil Rights)",
      "28:1331ed" : "28:1331ed (28:1331 Fed. Question: Employment Discrimination)",
      "28:1331ej" : "28:1331ej (28:1331ej Federal Question: Enforcement of Judgment)",
      "28:1331es" : "28:1331es (28:1331 Enforcement of Administrative Subpoena)",
      "28:1331fl" : "28:1331fl (28:1331 Fed. Question: Fair Labor Standards)",
      "28:1331in" : "28:1331in (28:1331 Fed. Question: Insurance Contract)",
      "28:1331mm" : "28:1331mm (28:1331 Fed. Question: Medical Malpractice)",
      "28:1331ng" : "28:1331ng (28:1331 Fed. Question: Natural Gas Act)",
      "28:1331pi" : "28:1331pi (28:1331 Fed. Question: Personal Injury)",
      "28:1331rd" : "28:1331rd (28:1331 Fed. Question: Review Agency Decision)",
      "28:1331rp" : "28:1331rp (28:1331(a) Fed. Question: Real Property)",
      "28:1331rr" : "28:1331rr (28:1331 Fed. Question: Railway Labor Act)",
      "28:1331sv" : "28:1331sv (28:1331 Fed. Question: Securities Violation)",
      "28:1331tr" : "28:1331tr (28:1331 Fed. Question: Trademark)",
      "28:1331tt" : "28:1331tt (28:1331 Fed. Question: Tort Action)",
      "28:1331v" : "28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendme)",
      "28:1331wl" : "28:1331wl (28:1331 Federal Question: EPA Waste Lien)",
      "28:1331wt" : "28:1331wt (28:1331 Fed. Question: Water Rights)",
      "28:1332" : "28:1332 (28:1332 Diversity)",
      "28:1332ac" : "28:1332ac (28:1332 Diversity-Account Receivable)",
      "28:1332al" : "28:1332al (28:1332 Diversity-Airline Crash)",
      "28:1332as" : "28:1332as (28:1332 Diversity-Asbestos Litigation)",
      "28:1332au" : "28:1332au (28:1332 Diversity-Auto Negligence)",
      "28:1332bc" : "28:1332bc (28:1332 Diversity-Breach of Contract)",
      "28:1332co" : "28:1332co (28:1332 Diversity-Conversion)",
      "28:1332ct" : "28:1332ct (28:1332 Diversity-(Citizenship))",
      "28:1332det" : "28:1332det (28:1332 Diversity: Forcible Detainer)",
      "28:1332df" : "28:1332df (28:1332 Diversity-Contract Default)",
      "28:1332ds" : "28:1332ds (28:1332 Diversity-Contract Dispute)",
      "28:1332ed" : "28:1332ed (28:1332 Diversity-Employment Discrimination)",
      "28:1332fd" : "28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)",
      "28:1332fo" : "28:1332fo (28:1332 Diversity - Real Property Foreclosure)",
      "28:1332fr" : "28:1332fr (28:1332 Diversity-Fraud)",
      "28:1332ia" : "28:1332ia (28:1332 Diversity-Interpleader Action)",
      "28:1332if" : "28:1332if (28:1332 Diversity- Insurance Fraud)",
      "28:1332ij" : "28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)",
      "28:1332in" : "28:1332in (28:1332 Diversity-Insurance Contract)",
      "28:1332jd" : "28:1332jd (28:1332 Diversity-Declaratory Judgement)",
      "28:1332lb" : "28:1332lb (28:1332 Diversity-Libel,Assault,Slander)",
      "28:1332lm" : "28:1332lm (28:1332 Diversity - Legal Malpractice)",
      "28:1332ma" : "28:1332ma (28:1332 Diversity-Miller Act)",
      "28:1332mm" : "28:1332mm (28:1332 Diversity-Medical Malpractice)",
      "28:1332mv" : "28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)",
      "28:1332ni" : "28:1332ni (28:1332 Diversity-Negotiable Instrument)",
      "28:1332nm" : "28:1332nm (28:1332 Diversity-Non-Motor Vehicle)",
      "28:1332nr" : "28:1332nr (28:1332 Diversity-Notice of Removal)",
      "28:1332oc" : "28:1332oc (28:1332 Diversity-Other Contract)",
      "28:1332pd" : "28:1332pd (28:1332 Diversity-Property Damage)",
      "28:1332pi" : "28:1332pi (28:1332 Diversity-Personal Injury)",
      "28:1332pl" : "28:1332pl (28:1332 Diversity-Product Liability)",
      "28:1332pr" : "28:1332pr (28:1332 Diversity-Petition for Removal)",
      "28:1332qt" : "28:1332qt (28:1332 Diversity-Petition to Quiet Title)",
      "28:1332ri" : "28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)",
      "28:1332rp" : "28:1332rp (28:1332 Diversity-Real Property)",
      "28:1332sa" : "28:1332sa (28:1332 - Diversity: Securities & Exchange Commiss)",
      "28:1332sf" : "28:1332sf (28:1332 - Diversity: Securities Fraud)",
      "28:1332ss" : "28:1332ss (28:1332 Diversity - Stockholders Suits)",
      "28:1332tl" : "28:1332tl (28:1332 Diversity-Torts to Land)",
      "28:1332tm" : "28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))",
      "28:1332tn" : "28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)",
      "28:1332wc" : "28:1332wc (28:1332 Diversity- Worker's Compensation Benefits)",
      "28:1332wd" : "28:1332wd (28:1332 Diversity-Wrongful Death)",
      "28:1333" : "28:1333 (28:1333 Admiralty)",
      "28:1334" : "28:1334 (28:1334 Bankruptcy Cases & Proceedings)",
      "28:1334c" : "28:1334c (28:1334(c) R&R re motions for abstention (non-cor)",
      "28:1335" : "28:1335 (28:1335 Interpleader Action)",
      "28:1337" : "28:1337 (28:1337 Sherman-Clayton Act)",
      "28:1338cp" : "28:1338cp (28:1338 Copyright Infringement)",
      "28:1338pt" : "28:1338pt (28:1338 Patent Infringement)",
      "28:1338tr" : "28:1338tr (28:1338 Trademark Infringement)",
      "28:1340" : "28:1340 (28:1340 IRS: Custom Duties)",
      "28:1340er" : "28:1340er (28:1340 Recovery of Erroneous Refund)",
      "28:1341" : "28:1341 (28:1341 Complaint for Forfeiture)",
      "28:1343" : "28:1343 (28:1343 Violation of Civil Rights)",
      "28:1345" : "28:1345 (USA Plaintiff)",
      "28:1345co" : "28:1345co (28:1345 Replevin & Conversion)",
      "28:1345db" : "28:1345db (28:1345 Debt to US - FHA/HUD Title I)",
      "28:1345df" : "28:1345df (28:1345 Default of Promissory Note)",
      "28:1345er" : "28:1345er (28:1345 Recovery of Erroneous Refund)",
      "28:1345fc" : "28:1345fc (28:1345 Foreclosure)",
      "28:1345ff" : "28:1345ff (28:1345 Complaint for Forfeiture)",
      "28:1345hl" : "28:1345hl (28:1345 VA Home Loan Guaranty Debt)",
      "28:1345mc" : "28:1345mc (28:1345 Medical Care Recovery)",
      "28:1345mi" : "28:1345mi (28:1345 Mining Claim Ejectment)",
      "28:1345pd" : "28:1345pd (28:1345 Property Damage)",
      "28:1345pe" : "28:1345pe (28:1345 Property Ejectment)",
      "28:1345rc" : "28:1345rc (28:1345 Recovery of Debt to US)",
      "28:1345st" : "28:1345st (28:1345 Default of Student Loan)",
      "28:1345tp" : "28:1345tp (28:1345 Trespass on Public Land)",
      "28:1345va" : "28:1345va (28:1345 Recovery of VA Overpayment)",
      "28:1346bc" : "28:1346bc (28:1346 Breach of Contract)",
      "28:1346rc" : "28:1346rc (28:1346 Recovery of IRS Tax)",
      "28:1346tc" : "28:1346tc (28:1346 Tort Claim)",
      "28:1346wd" : "28:1346wd (28:1346 Wrongful Death)",
      "28:1349" : "28:1349 (28:1348 Corporation organized under Federal Law as party)",
      "28:1350" : "28:1350 (28:1350 Alien's action for tort)",
      "28:1352" : "28:1352 (28:1352 Miller Act)",
      "28:1355" : "28:1355 (28:1355 Petition for Return of Property)",
      "28:1358" : "28:1358 (28:1358 Land Condemnation)",
      "28:1361" : "28:1361 (28:1361 Petition for Writ of Mandamus)",
      "28:1362ic" : "28:1362ic (28:1362 Indian Tribal Controversy)",
      "28:1362iw" : "28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)",
      "28:1364" : "28:1364 (28:1364 Auto Negligence)",
      "28:1391" : "28:1391 (28:1391 Personal Injury)",
      "28:1402" : "28:1402 (28:1402 Medical Malpractice)",
      "28:1407" : "28:1407 (28:1407 Airline Crash)",
      "28:1441" : "28:1441 (28:1441 Notice of Removal (Lanham Act))",
      "28:1441ac" : "28:1441ac (28:1441 Petition for Removal- Account Receivable)",
      "28:1441ada" : "28:1441ada (28:1441 Notice of Removal-Americans with Disabilities Act)",
      "28:1441al" : "28:1441al (28:1441 Petition for Removal- Airline Crash)",
      "28:1441as" : "28:1441as (28:1441 Petition for Removal- Asbestos Litigation)",
      "28:1441au" : "28:1441au (28:1441 Petition for Removal- Auto Negligence)",
      "28:1441ba" : "28:1441ba (Notice of Removal - National Bank Act)",
      "28:1441bc" : "28:1441bc (28:1441 Petition for Removal- Breach of Contract)",
      "28:1441bfd" : "28:1441bfd (28:1441bfd Notice of Removal-Breach of Fiduciary Duties)",
      "28:1441ca" : "28:1441ca (28:1441 Notice of Removal (Carmack Amendment))",
      "28:1441cla" : "28:1441cla (28:1441 Notice of Removal - Consumer Leasing Act)",
      "28:1441cpl" : "28:1441cpl (28:1441 Notice of Removal - Contract Product Liability)",
      "28:1441cr" : "28:1441cr (28:1441 Notice of Removal - Civil Rights)",
      "28:1441cra" : "28:1441cra (28:1441 Notice of Removal - Fair Credit Reporting Act)",
      "28:1441cv" : "28:1441cv (28:1441 Petition for Removal- Civil Rights Act)",
      "28:1441dea" : "28:1441dea (28:1441 Notice of Removal - Disabilities Education Act)",
      "28:1441df" : "28:1441df (28:1441 Petition for Removal- Contract Default)",
      "28:1441dj" : "28:1441dj (28:1441 Petition for Removal- Declaratory Judgemen)",
      "28:1441ds" : "28:1441ds (28:1441 Petition for Removal- Contract Dispute)",
      "28:1441ec" : "28:1441ec (28:1441 Notice of Removal - Electronic Comm. Privacy Act)",
      "28:1441ed" : "28:1441ed (28:1441 Petition for Removal - Employment Discrim)",
      "28:1441em" : "28:1441em (28:1441 Notice of Removal - Emergency Medical Treatment & Active Labor)",
      "28:1441eri" : "28:1441eri (28:1441 Notice of Removal - E.R.I.S.A.)",
      "28:1441fc" : "28:1441fc (28:1441 Petition for Removal - Fair Credit Reporti)",
      "28:1441fd" : "28:1441fd (28:1441 Notice of Removal - Fair Debt Collection Practices Act)",
      "28:1441fh" : "28:1441fh (28:1441 Notice of Removal (FEHBA))",
      "28:1441fif" : "28:1441fif (28:1441 Notice of Removal - Insecticide/Fungicide/Rodenticide Act -1942)",
      "28:1441fr" : "28:1441fr (28:1441 Petition for Removal- Fraud)",
      "28:1441fsa" : "28:1441fsa (28:1441 Notice of Removal - Federal Food Stamp Act)",
      "28:1441if" : "28:1441if (28:1441 Notice of Removal - Insurance Fraud)",
      "28:1441ij" : "28:1441ij (28:1441 Petition for Removal- Injunctive/Declarato)",
      "28:1441in" : "28:1441in (28:1441 Petition for Removal- Insurance Contract)",
      "28:1441int" : "28:1441int (28:1441 Petition for Removal- Action for Interplea)",
      "28:1441la" : "28:1441la (28:1441 Notice of Removal - Truth in Lending Act)",
      "28:1441lb" : "28:1441lb (28:1441 Petition for Removal Libel,Assault,Slander)",
      "28:1441lm" : "28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relatio)",
      "28:1441mm" : "28:1441mm (28:1441 Petition for Removal- Medical Malpractice)",
      "28:1441mv" : "28:1441mv (28:1441 Notice of Removal - Motor Vehicle Safety)",
      "28:1441mw" : "28:1441mw (28:1441 Notice of Removal - Magnuson-Moss Warranty Act)",
      "28:1441nba" : "28:1441nba (28:1441 Notice of Removal - National Bank Act)",
      "28:1441ni" : "28:1441ni (28:1441 Petition for Removal- Negotiable Instrumen)",
      "28:1441nm" : "28:1441nm (28:1441 Petition for Removal- Non-Motor Vehicle)",
      "28:1441nr" : "28:1441nr (28:1441 Notice of Removal)",
      "28:1441oc" : "28:1441oc (28:1441 Petition For Removal--Other Contract)",
      "28:1441pd" : "28:1441pd (28:1441 Petition for Removal- Property Damage)",
      "28:1441pi" : "28:1441pi (28:1441 Petition for Removal- Personal Injury)",
      "28:1441pl" : "28:1441pl (28:1441 Petition for Removal- Product Liability)",
      "28:1441pr" : "28:1441pr (28:1441 Petition for Removal)",
      "28:1441qt" : "28:1441qt (28:1441 Petition for Removal- Petition to Quiet Ti)",
      "28:1441res" : "28:1441res (28:1441 Notice of Removal - \"RESPA\")",
      "28:1441ri" : "28:1441ri (28:1441 Petition for Removal- Racketeering (RICO))",
      "28:1441sa" : "28:1441sa (28:1441 - Petition for Removal: SEC Act)",
      "28:1441sf" : "28:1441sf (28:1441 - Petition for Removal: Securities Fraud)",
      "28:1441tc" : "28:1441tc (28:1441 Notice of Removal - Tort Claim)",
      "28:1441tl" : "28:1441tl (28:1441 Petition for Removal- Torts to Land)",
      "28:1441tm" : "28:1441tm (28:1441 Petition for Removal- Tort/Motor Vehicle ()",
      "28:1441tma" : "28:1441tma (28:1441 Notice of Removal - Alabama Telemarketing Act)",
      "28:1441tn" : "28:1441tn (28:1441 Petition for Removal- Tort/Non-Motor Vehic)",
      "28:1441tr" : "28:1441tr (28:1441 Notice of Removal - Tricare Program)",
      "28:1441use" : "28:1441use (28:1441 Notice of Removal - Uniformed Svc Emp/Reemp Rights Act)",
      "28:1441wc" : "28:1441wc (28:1441 Notice of Removal - Worker's Compensation Benefits)",
      "28:1441wd" : "28:1441wd (28:1441 Petition for Removal- Wrongful Death)",
      "28:1441wt" : "28:1441wt (28:1441wt Notice of Removal - Wrongful Termination (Employment))",
      "28:1442bc" : "28:1442bc (28:1442 Petition for Removal- Breach of Contract)",
      "28:1442nr" : "28:1442nr (28:1442 Notice of Removal)",
      "28:1442pr" : "28:1442pr (28:1442 Petition for Removal)",
      "28:1443" : "28:1443 (28:1443(1) Rent, Lease & Ejectment)",
      "28:1444" : "28:1444 (28:1444 Petition for Removal- Foreclosure)",
      "28:1446in" : "28:1446in (28:1446 Breach of Contract- Insurance)",
      "28:1446nr" : "28:1446nr (28:1446 Notice of Removal)",
      "28:1446pd" : "28:1446pd (28:1446 Petition for Removal- Property Damage (P.I)",
      "28:1446pi" : "28:1446pi (28:1446 Petition for Removal- Personal Injury)",
      "28:1446pl" : "28:1446pl (28:1446pl Petition for Removal - Product Liability)",
      "28:1446pr" : "28:1446pr (28:1446 Petition for Removal)",
      "28:1452" : "28:1452 (28:1452 Removal of claims related to bankruptcy case)",
      "28:1453" : "28:1453 (28:1453 Class Action Fairness Act)",
      "28:14706" : "28:14706 (Carmack Amendment to Hepburn Act (Interstate Commerce))",
      "28:1651" : "28:1651 (28:1651 Petition for Writ of Coram Nobis)",
      "28:1651hc" : "28:1651hc (28:1651 Petition for Writ of Habeas Corpus)",
      "28:1651mn" : "28:1651mn (28:1651 Petition for Writ of Mandamus)",
      "28:1738A" : "28:1738A (28:1738A Full faith and credit given to Child Custody Determinations)",
      "28:1782" : "28:1782 (28:1782 Letter Rogatory - Appointment)",
      "28:1983" : "28:1983 (28:1983 Civil Rights)",
      "28:2001" : "28:2001 (28:2001 Judicial Sale of Realty)",
      "28:2071" : "28:2071 (28:2071 Rule Making Power Generally)",
      "28:2201" : "28:2201 (28:2201 Constitutionality of State Statute(s))",
      "28:2201dj" : "28:2201dj (28:2201 Declaratory Judgement)",
      "28:2201ij" : "28:2201ij (28:2201 Injunction)",
      "28:2201in" : "28:2201in (28:2201 Declaratory Judgement (Insurance))",
      "28:2241" : "28:2241 (28:2241 Petition for Writ of Habeas Corpus (federa)",
      "28:2254" : "28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))",
      "28:2254se" : "28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)",
      "28:2255" : "28:2255 (28:2255 Motion to Vacate / Correct Illegal Sentenc)",
      "28:2271" : "28:2271 (28:2271 Federal Tort Claims Act)",
      "28:2345" : "28:2345 (28:2345 Medicare Recovery)",
      "28:2409" : "28:2409 (28:2409(a) Quiet Title Action)",
      "28:2410" : "28:2410 (28:2410 Quiet Title)",
      "28:2671" : "28:2671 (28:2671 Federal Tort Claims Act)",
      "28:2674" : "28:2674 (28:2674 Federal Tort Claims Act)",
      "28:2679" : "28:2679 (28:2679 Federal Tort Claim)",
      "28:3001" : "28:3001 (28:3001 Federal Debt Collection Act)",
      "28:3203" : "28:3203 (28:3203 Writ of Execution)",
      "28:3301" : "28:3301 (28:3301 Fraudulent Transfer Federal Debt Collection Procedures Act)",
      "28:636" : "28:636 (28:636 Jurisdiction, Powers & Temporary Assignment)",
      "28:7402" : "28:7402 (28:7402 Refund of Taxes)",
      "28:7422" : "28:7422 (28:7422 Appeal from Administrative Decision)",
      "29:0151" : "29:0151 (29:151 Labor: Review of Agency Action)",
      "29:0160" : "29:0160 (29:160(1) National Labor Relations Act)",
      "29:0184" : "29:0184 (29:184 Violation Collection Bargain Agreement)",
      "29:0185ep" : "29:0185ep (29:185 Employee Pension Plan)",
      "29:0185lm" : "29:0185lm (29:185 Labor/Mgt. Relations (Contracts))",
      "29:0201do" : "29:0201do (29:201 Denial of Overtime Compensation)",
      "29:0201fl" : "29:0201fl (29:201 Fair Labor Standards Act)",
      "29:0203" : "29:0203 (29:203 Equal Pay Act)",
      "29:0206" : "29:0206 (29:206 Collect Unpaid Wages)",
      "29:0206d" : "29:0206d (29:206(d) The Equal Pay Act)",
      "29:0207fl" : "29:0207fl (29:0207 Fair Labor Standards Act)",
      "29:0215fl" : "29:0215fl (29:0215 Fair Labor Standards Act)",
      "29:0401" : "29:0401 (29:0401 Labor Management Disclosure Act)",
      "29:0621" : "29:0621 (29:621 Job Discrimination (Age))",
      "29:0623" : "29:0623 (29:623 Job Discrimination (Age))",
      "29:0626" : "29:0626 (29:626 Job Discrimination (Age))",
      "29:0633" : "29:0633 (29:633 Job Discrimination (Age))",
      "29:0651" : "29:0651 (29:651 Occupational Safety/Health)",
      "29:0754" : "29:0754 (29:754 Discrimination)",
      "29:0791" : "29:0791 (29:791 Job Discrimination (Rehabilitation Act))",
      "29:0794" : "29:0794 (29:0794 Job Discrimination (Handicap))",
      "29:1001" : "29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)",
      "29:1002" : "29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)",
      "29:1104" : "29:1104 (29:1104 Recovery of Benefits to Employee)",
      "29:1109" : "29:1109 (29:1109 Breach of Fiduciary Duties)",
      "29:1131" : "29:1131 (29:1131 ERISA - Collection of Delinquent Trust Fun)",
      "29:1132" : "29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)",
      "29:1145" : "29:1145 (29:1145 E.R.I.S.A.)",
      "29:1149" : "29:1149 (29:1149 Recover Pension & Profit Sharing)",
      "29:1162" : "29:1162 (29:1162 COBRA)",
      "29:1337" : "29:1337 (29:1337 E.R.I.S.A.)",
      "29:1362" : "29:1362 (29:1362 ERISA)",
      "29:1381" : "29:1381 (29:1381 E.R.I.S.A.)",
      "29:1401" : "29:1401 (29:1401(b)(2) Appeal of Arbitration Award)",
      "29:1451" : "29:1451 (29:1451 E.R.I.S.A.)",
      "29:1801" : "29:1801 (29:1801 Farmworker Rights)",
      "29:206" : "29:206 (29:206 Equal Pay Act)",
      "29:2101" : "29:2101 (29:2101 Worker Adjustment and Retaining Notification Act)",
      "29:2601" : "29:2601 (29:2601 Family and Medical Leave Act)",
      "29:2617" : "29:2617 (29:2617 Family & Medical Leave)",
      "29:790" : "29:790 (29:790 Rehabilitation of Labor)",
      "30:0181" : "30:0181 (30:181 Environment: Review of Agency Action)",
      "30:0801" : "30:0801 (30:0801 Penalities/Federal Mine Safety Health Act)",
      "30:1201" : "30:1201 (30:1201 Environment: Review of Agency Action)",
      "30:1202" : "30:1202 (30:1202 Mining Reclamation Act)",
      "30:1276" : "30:1276 (30:1276 Interior: Review of Agency Action)",
      "31:3545" : "31:3545 (31:3545 Action to Recovery Money)",
      "31:3729" : "31:3729 (31:3729 False Claims Act)",
      "31:3730" : "31:3730 (31:3730 Qui Tam False Claims Act)",
      "31:3731" : "31:3731 (31:3731 Fraud)",
      "31:5332" : "31:5332 (31:5332.F Transport and Transfer US currency from in to out)",
      "31:9306" : "31:9306 (31:9306 Registration of Power of Attorney)",
      "33:1319cw" : "33:1319cw (33:1319 Clean Water Act)",
      "33:1319pv" : "33:1319pv (33:1319 Pollutants & Permit Violations)",
      "33:1365" : "33:1365 (33:1365 Environmental Matters)",
      "33:2702" : "33:2702 (33:2702 Federal Oil Pollution Act of 1990)",
      "35:0102" : "35:0102 (35:0102 Patent Grants)",
      "35:0145" : "35:0145 (35:145 Patent Infringement)",
      "35:0183" : "35:0183 (35:183 Patent Infringement)",
      "35:0271" : "35:0271 (35:271 Patent Infringement)",
      "35:0282" : "35:0282 (35:0282 Patent Infringement)",
      "38:1110" : "38:1110 (38:1110 VA Basic Entitlements)",
      "38:1681" : "38:1681 (38:1681 Recovery of VA Overpayment)",
      "38:1686" : "38:1686 (38:1686 Recovery of VA Overpayment)",
      "38:1780" : "38:1780 (38:1780 Recovery of VA Overpayment)",
      "38:1965" : "38:1965 (38:1965 Servicemembers Group Life Insurance Act)",
      "38:2011" : "38:2011 (38:2011 - Veteran's Readjustment Assistance Act of)",
      "38:2021" : "38:2021 (38:2021 Right to re-employment of inducted persons)",
      "38:3116" : "38:3116 (38:3116 VA Overpayment)",
      "38:4311" : "38:4311 (38:4311 Uniformed Service Employment/Reemployment Rights Act)",
      "38:775" : "38:775 (Recovery of Servicemen's Group Life Insurance)",
      "39:3005" : "39:3005 (39:3005 Detention of Mail for Temporary Periods)",
      "39:409" : "39:409 (39:409 Postal Service)",
      "40:0258" : "40:0258 (40:258(a) Public Buildings & Property: Land Condem)",
      "40:0270" : "40:0270 (40:270 Miller Act OLD)",
      "40:0875" : "40:0875 (40:875 Public Buildings & Property: Negligence)",
      "40:3131" : "40:3131 (40:3131 Miller Act NEW)",
      "41:0251" : "41:0251 (41:251 Public Contracts-Review of Agency Action)",
      "41:1463" : "41:1463 (41:1463 Public Contracts: Unlawful Employment Prac)",
      "41:4712" : "41:4712 (41:4712 Public Contracts: Enhancement of contractor protection from reprisal for disclosure)",
      "42:0205" : "42:0205 (42:205 Denial Social Security Benefits)",
      "42:0206" : "42:0206 (42:206 Social Security Benefits)",
      "42:0247" : "42:0247 (42:247 Personal Injury-Swine Flu)",
      "42:0256" : "42:0256 (42:0256 Public Health Services Act)",
      "42:0402" : "42:0402 (42:402 Social Security Benefits)",
      "42:0405id" : "42:0405id (42:405 Review of HHS Decision (SSID))",
      "42:0405wc" : "42:0405wc (42:405 Review of HHS Decision (DIWC))",
      "42:0405ww" : "42:0405ww (42:405 Review of HHS Decision (DIWW))",
      "42:0416" : "42:0416 (42:416 Denial of Social Security Benefits)",
      "42:0427" : "42:0427 (42:427 Social Security Benefits)",
      "42:10801" : "42:10801 (42:10801 Protection & Advocacy for Individuals with Mental Illness Act of 1986 (\"PAIMI Act\")",
      "42:11112" : "42:11112 (42:11112 Health Care Quality Improvement Act)",
      "42:11601" : "42:11601 (42:11601 International Child Abduction Remedies Act)",
      "42:120711" : "42:120711 (42:120711 Americans with Disabilities Act)",
      "42:12101" : "42:12101 (42:12101 Americans with Disabilities Act)",
      "42:12102" : "42:12102 (42:12102 Americans with Disabilities Act (\"ADA\"))",
      "42:12111" : "42:12111 (42:12111 Americans with Disabilities Act)",
      "42:12112" : "42:12112 (42:12112 Americans with Disabilities Act)",
      "42:12117" : "42:12117 (42:12117 Americans with Disabilities Act of 1990)",
      "42:12181" : "42:12181 (42:12181Americans with Disabilities Act-Public Accommodations Private)",
      "42:12201" : "42:12201 (42:12201 Americans with Disabilities Act)",
      "42:1383" : "42:1383 (42:1383 Review of HHS Decision)",
      "42:1395" : "42:1395 (42:1395 HHS: Adverse Reimbursement Review)",
      "42:1395dd" : "42:1395dd (42:1395 Emergency Medical Treatment and Active Labor Act)",
      "42:1395w21" : "42:1395w21 (42:1395w21 Medicare Act)",
      "42:1396" : "42:1396 (42:1396 - Tort Negligence)",
      "42:14135" : "42:14135 (42:14135 DNA Backlog Grant Program)",
      "42:1437" : "42:1437 (42:1437 U.S. Housing Act)",
      "42:1471" : "42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclo)",
      "42:15483" : "42:15483 (42:15483 Help America Vote Act)",
      "42:1973" : "42:1973 (42:1973 Voting Rights Act)",
      "42:1973c" : "42:1973c (42:1973(c) Voting Rights -Qualifications & Procedures)",
      "42:1981cv" : "42:1981cv (42:1981 Civil Rights)",
      "42:1981hs" : "42:1981hs (42:1981 Housing Discrimination)",
      "42:1981jb" : "42:1981jb (42:1981 Job Discrimination (Race))",
      "42:1981sx" : "42:1981sx (42:1981 Sex Discrimination)",
      "42:1983cv" : "42:1983cv (42:1983 Civil Rights Act)",
      "42:1983ed" : "42:1983ed (42:1983 Civil Rights (Employment Discrimination))",
      "42:1983pr" : "42:1983pr (42:1983 Prisoner Civil Rights)",
      "42:1986" : "42:1986 (42:1986 Neglect of Duty)",
      "42:1997" : "42:1997 (42:1997 Civil Rights of Institutionalized Persons Act)",
      "42:2000" : "42:2000 (42:2000 Job Discrimination)",
      "42:2000ag" : "42:2000ag (42:2000 Job Discrimination (Age))",
      "42:2000cc" : "42:2000cc (42:2000cc Protection of Religious Exercise in Land Use and by Institutionalized Persons)",
      "42:2000d" : "42:2000d (42:2000d Discrimination under federal programs on ground of race, color, or national origin)",
      "42:2000e" : "42:2000e (42:2000e Job Discrimination (Employment))",
      "42:2000pb" : "42:2000pb (42:2000pb Job Discrimination (Public Accommodations))",
      "42:2000ra" : "42:2000ra (42:2000 Job Discrimination (Race))",
      "42:2000sx" : "42:2000sx (42:2000 Job Discrimination (Sex))",
      "42:2003" : "42:2003 (42:2003 Job Discrimination)",
      "42:2005" : "42:2005 (42:2005 Review of Agency Action-HHS)",
      "42:2615" : "42:2615 (42:2615 Medical Recovery Act)",
      "42:2651" : "42:2651 (42:2651 Medical Care Recovery)",
      "42:32701" : "42:32701 (42:32701 Odometer Disclosure)",
      "42:3601" : "42:3601 (42:3601 Fair Housing Act)",
      "42:4000" : "42:4000 (42:4000 National Flood Insurance Act)",
      "42:4001" : "42:4001 (42:4001 National Insurance Flood Act)",
      "42:4053" : "42:4053 (42:4053 Breach of Insurance Contract)",
      "42:4072" : "42:4072 (42:4072 Payment of Flood Insurance Claim)",
      "42:4321" : "42:4321 (42:4321 Review of Agency Action-Environment)",
      "42:4332" : "42:4332 (42:4332 Environmental Policy - Coop of Agency Repo)",
      "42:4821" : "42:4821 (42:4821 Lead-Based Paint Poisoning Prevention Act)",
      "42:6000" : "42:6000 (42:6000 Developmental Disabilities Asst./Bill of Rights Act)",
      "42:6101" : "42:6101 (42:6101 Age Discrimination in Federally Assisted Programs)",
      "42:6901en" : "42:6901en (42:6901 Environmental Cleanup Expenses)",
      "42:6901rs" : "42:6901rs (42:6901 Resource & Recovery Act)",
      "42:6991" : "42:6991 (42:6991 Regulation of Underground Storage Tanks)",
      "42:7413" : "42:7413 (42:7413(b) Clean Air Act)",
      "42:7475" : "42:7475 (42:7475 Clean Air Act)",
      "42:7604cl" : "42:7604cl (42:7604 Clear Air Act (Emission Standards))",
      "42:7604ir" : "42:7604ir (42:7604 Petition to Quash IRS Summons)",
      "42:9601" : "42:9601 (42:9601 Comprehensive Environmental Response, Compensation & Liability Act of 1980 (CERCLA))",
      "42:9607" : "42:9607 (42:9607 Real Property Tort to Land)",
      "43:945" : "43:945 (43:945 Compensation for Land Condemnation)",
      "43:945a" : "43:945a (43:945a Complaint in Condemnation)",
      "43:946" : "43:946 (43:946 Complaint in Condemnation - Eminent Domain)",
      "45:0051" : "45:0051 (45:51 Railways: Fed. Employer's Liability Act)",
      "45:0151" : "45:0151 (45:151 Railway Labor Act)",
      "45:0184" : "45:0184 (45:184 Action to Set Aside Award of a System Board)",
      "45:1395" : "45:1395 (45:1395 Railroads: Adverse Reimbursement Review)",
      "45:501" : "45:501 (45:501 Rail Passenger Service Act)",
      "45:7457" : "45:7457 (45:7457 Compel Reclamation Under Clear Air Act)",
      "46:0688" : "46:0688 (46:688 Jones Act)",
      "46:0741" : "46:0741 (46:741 Shipping)",
      "46:0761" : "46:0761 (46:761 Shipping: Damages for Death on High Seas)",
      "46:1101" : "46:1101 (46:1101 Violation of Maritime Regulations)",
      "46:1156" : "46:1156 (46:1156 Administrative Procedure Act)",
      "46:1701" : "46:1701 (46:1701 Shipping Act of 1984)",
      "47:0151" : "47:0151 (47:0151 Communications Act)",
      "47:0332" : "47:0332 (47:332 Mobile Services)",
      "47:0521" : "47:0521 (47:521 Cable Communications Act)",
      "47:227" : "47:227 (47:227 Telephone Consumer Protection Act)",
      "47:252" : "47:252 (47:252 Telecommunications Act)",
      "47:605" : "47:605 (47:605 Unauthorized publication or use of communications)",
      "48:0883" : "48:0883 (48:883 Violation of US Coastal Law)",
      "48:1985" : "48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)",
      "49:0081" : "49:0081 (49:81 Damaged Goods While Being Transported)",
      "49:0781" : "49:0781 (49:781 Forfeiture)",
      "49:10101" : "49:10101 (49:10101 Interstate Commerce Act-Interstate Transportation Rail)",
      "49:11501" : "49:11501 (49:11501 Railroad Revitalization & Regulatory Reform Act)",
      "49:11503" : "49:11503 (49:11503 Railroad Revitalization Regulatory Reform)",
      "49:11702" : "49:11702 (49:11702(a)(4) Violations of Interstate Commerce A)",
      "49:14706" : "49:14706 (Carmack Amendment to the Interstate Commerce Act)",
      "49:1471" : "49:1471 (49:1471 Federal Aviation Act)",
      "49:1903" : "49:1903 (49:1903 Petition to enforce administrative summon)",
      "49:30112" : "49:30112 (49:30112 Motor Vehicle Safety)",
      "49:32701" : "49:32701 (49:32701 Odometer Disclosure)",
      "49:41705" : "49:41705 (49:41705 Air Carrier Access Act of 1986 (ACAA))",
      "50:501" : "50:501 (50:501 Soldiers' & Sailors' Civil Relief Act)",
      "5:8901" : "5:8901 (5:8901 Notice of Removal - FEHBP)",
      "7:2023" : "7:2023 (7:2023 Administrative & Judicial Review (Food Stamp Program))",
      "8:1481" : "8:1481 (8:1481 Immigration and Nationality Act)",
      "8:287" : "8:287 (8:287 Petition to Enforce INS Subpoena)",
      "99:9999" : "99:9999 (99:9999 Report cause code (DO NOT DELETE!))",
      "9:201" : "9:201 (Convention on the Recognition and Enforcement of Foreign Arbitral Awards)",
      "adsup" : "adsup (Administrative Subpoena)",
      "contempt" : "contempt (Contempt Proceedings)",
      "dbexam" : "dbexam (Motion for Order Requiring Examination of Judgment Debtor)",
      "disbar" : "disbar (Disbarment Proceedings)",
      "fordepo" : "fordepo (Foreign Deposition)",
      "misc" : "misc (Civil Miscellaneous Case)",
      "motcomp" : "motcomp (Motion to Compel)",
      "motquash" : "motquash (Motion to Quash)",
      "motret" : "motret (Motion for Return of Property)",
      "petenf" : "petenf (Petition to Enforce IRS Summons)",
      "petper" : "petper (Petition to Perpetuate Testimony)",
      "regjgm" : "regjgm (Registration of Foreign Judgment)",
      "tranbkref" : "tranbkref (Transmission of Bankruptcy Reference)",
      "tranff" : "tranff (Transmission of Proposed Findings of Fact and Conclusion of Law)",
      "writgar" : "writgar (Application for a Writ of Garnishment)"
   },
   "alndce" : {
      "0" : "0 (No cause code entered)",
      "00:0000" : "00:0000 (00:0000 Cause Code Unknown)",
      "02:0431" : "02:0431 (02:431 Fed. Election Commission: Failure Enforce C)",
      "02:0437" : "02:0437 (02:437 Federal Election Commission)",
      "05:0075" : "05:0075 (05:75(2) Contract - Reduction in Grade)",
      "05:0551" : "05:0551 (05:551 Administrative Procedure Act)",
      "05:0552fi" : "05:0552fi (05:552 Freedom of Information Act)",
      "05:0552pa" : "05:0552pa (05:552 Right to Privacy Act)",
      "05:0554" : "05:0554 (05:0554 Constitutionality of Maritime Statutes)",
      "05:0701" : "05:0701 (05:0701 Maritime Subsidy Board)",
      "05:0702" : "05:0702 (05:702 Administrative Procedure Act)",
      "05:0704" : "05:0704 (05:704 Labor Litigation)",
      "05:7703" : "05:7703 (05:7703 Discrimination - Review of Agency Act)",
      "07:0006" : "07:0006 (7:6(b) Federal Commodity Exchange Regulation)",
      "07:0025" : "07:0025 (7:25 Fraud - Commodities Leverage Contracts)",
      "07:0181" : "07:0181 (07:181 Packers & Stockyard Act)",
      "07:0499" : "07:0499 (07:499 Agricultural Commodities Act)",
      "07:0601" : "07:0601 (07:601 USDA Condemnation)",
      "07:1926" : "07:1926 (07:1926 Water & Waste Facility Loans)",
      "07:2001" : "07:2001 (07:2001 - Food Stamps)",
      "07:2321" : "07:2321 (07:2321 Plant Variety Protection Act)",
      "08:0287" : "08:0287 (08:0287 Petition to Enforce INS Subpoena)",
      "08:1105" : "08:1105 (8:1105(a) Aliens: Habeas Corpus to Release INS Det)",
      "08:1252" : "08:1252 (08:1252(a)(2) Injunction for Deportation)",
      "08:1260" : "08:1260 (08:1260 Aliens: Access to Records)",
      "08:1324" : "08:1324 (08:1324 Aliens: Complaint for Forfeiture)",
      "08:1329" : "08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petiti)",
      "08:1446" : "08:1446 (8:1446 Petition for Naturalization Hearing)",
      "08:1522" : "08:1522 (Refugee Act of 1980)",
      "09:0001" : "09:0001 (09:1 U.S. Arbitration Act)",
      "09:0009" : "09:0009 (9:9 Motion to Confirm Arbitration Loan)",
      "09:0010" : "09:0010 (09:0010 Petition to Vacate Arbitration Award)",
      "10:1552" : "10:1552 (10:1552 Armed Forces: Action to Correct Records)",
      "10:1553" : "10:1553 (10:1553 Armed Forces: FOIA General)",
      "10:2305" : "10:2305 (10:2305 Review of Federal Contract)",
      "11:0101" : "11:0101 (11:101 Bankruptcy)",
      "11:524" : "11:524 (11:524 Enjoin Collection due to Bankruptcy)",
      "12:0022" : "12:0022 (12:22 Securities Fraud)",
      "12:0635" : "12:0635 (12:635 Breach of Insurance Contract)",
      "12:1441" : "12:1441 (12:1441 Action by Resolution Trust Corp - collection)",
      "12:1461" : "12:1461 (12:1461 Homeowners Loan Act)",
      "12:1703" : "12:1703 (12:1703 Default of HUD Loan)",
      "12:1725" : "12:1725 (12:1725 Collection under Contract Guaranty)",
      "12:1730" : "12:1730 (12:1730 Collection Under Contract Guaranty)",
      "12:1819" : "12:1819 (12:1819 Default of Promissory Note)",
      "12:1821" : "12:1821 (12:1821 Default of Loan by Promissary Note)",
      "12:1831jb" : "12:1831jb (12:1831j(b) - FDIC employment protection act)",
      "12:1971" : "12:1971 (12:1971 Relief under Bank Holding Act)",
      "12:2601" : "12:2601 (12:2601 - Real Estate Settlement Proceedures Act)",
      "12:2604" : "12:2604 (12:2604 RESPA (Real Estate Settlement Procedures Act))",
      "12:3410" : "12:3410 (12:3410 Right to Financial Privacy Act)",
      "15:0001" : "15:0001 (15:1 Antitrust Litigation)",
      "15:0002at" : "15:0002at (15:2 Antitrust Litigation)",
      "15:0002fl" : "15:0002fl (15:2(a) Fair Labor Standards Act)",
      "15:0005" : "15:0005 (15:5(a) Fair Labor Standards Act)",
      "15:0015" : "15:0015 (15:15 Antitrust Litigation)",
      "15:0025" : "15:0025 (15:25 Clayton Act)",
      "15:0044" : "15:0044 (15:44 Trademark Infringement)",
      "15:0045" : "15:0045 (15:0045 Federal Trade Commission Act)",
      "15:0052" : "15:0052 (15:0052 Federal Trade Commission Act)",
      "15:0053" : "15:0053 (15:0053 Federal Trade Commission Act)",
      "15:0053b" : "15:0053b (15:0053(b) Prelim & Perm Inj Relief & other Equitable Relief)",
      "15:0077" : "15:0077 (15:77 Securities Fraud)",
      "15:0078" : "15:0078 (15:78m(a) Securities Exchange Act)",
      "15:0631" : "15:0631 (15:631 Small Business Act)",
      "15:0717" : "15:0717 (15:717 Natural Gas Act)",
      "15:1051" : "15:1051 (15:1051 Trademark Infringement)",
      "15:1114" : "15:1114 (15:1114 Trademark Infringement)",
      "15:1121" : "15:1121 (15:1121 Trademark Infringement)",
      "15:1125" : "15:1125 (15:1125 Trademark Infringement (Lanham Act))",
      "15:1126" : "15:1126 (15:1126 Patent Infringement)",
      "15:1127" : "15:1127 (15:1127 Trademark Infringement)",
      "15:1601" : "15:1601 (15:1601 Truth in Lending)",
      "15:1640" : "15:1640 (15:1640 Truth in Lending)",
      "15:1667" : "15:1667 (15:1667 - Violation of the Consumer Leasing Act)",
      "15:1681" : "15:1681 (15:1681 Fair Credit Reporting Act)",
      "15:1692" : "15:1692 (15:1692 Fair Debt Collection Act)",
      "15:1938" : "15:1938 (15:1938 Fair Labor Standards Act)",
      "15:1981" : "15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))",
      "15:1988" : "15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))",
      "15:1989" : "15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))",
      "15:2301" : "15:2301 (15:2301 Magnuson-Moss Warranty Act)",
      "15:2801" : "15:2801 (15:2801 Petroleum Marketing Practices Act)",
      "15:53(b)" : "15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equita)",
      "16:0668" : "16:0668 (16:668 Bald Eagle Protection Act)",
      "16:0703" : "16:0703 (16:703 Migratory Bird Act)",
      "16:1538" : "16:1538 (16:1538 Endangered Species Act)",
      "16:3371" : "16:3371 (16:3371 Wildlife Under the Lacey Act)",
      "16:3372" : "16:3372 (16:3372 Conservation: Complaint for Forfeiture)",
      "16:3373" : "16:3373 (16:3373 Appeal of Decision - DOI)",
      "16:3374" : "16:3374 (16:3374 Conservation: Complaint for Forfeiture)",
      "16:831dd" : "16:831dd (16:831dd - Land Condemnation)",
      "17:0101" : "17:0101 (17:101 Copyright Infringement)",
      "17:0501" : "17:0501 (17:501 Copyright Infringement)",
      "17:0504" : "17:0504 (17:504 Copyright Infringement)",
      "18:0241" : "18:0241 (18:241 Conspiracy Against Citizen Rights)",
      "18:0981" : "18:0981 (18:0981 Civil Forfeiture)",
      "18:1836a" : "18:1836a (18:1836(a) Injunction against Misappropriation of Trade Secrets)",
      "18:1836b" : "18:1836b (18:1836(b) Civil Action to Protect Trade Secrets)",
      "18:1955" : "18:1955 (18:1955(d) Seizure of Property - Illegal Gambling)",
      "18:1961" : "18:1961 (18:1961 Racketeering (RICO) Act)",
      "18:1962" : "18:1962 (18:1962 Racketeering (RICO) Act)",
      "18:1964" : "18:1964 (18:1964 Racketeering (RICO) Act)",
      "18:4208" : "18:4208 (18:4208(B) Agency Action Review)",
      "19:1305" : "19:1305 (19:1305 Custom Duties:0Forfeiture-Immoral Articles)",
      "19:3301" : "19:3301 (19:3301 - NAFTA)",
      "20:1080" : "20:1080 (20:1080 Student Loan Recovery)",
      "20:1400" : "20:1400 (20:1400 Civil Rights of Handicapped Child)",
      "20:1401" : "20:1401 (20:1401 Education: Handicapped Child Act)",
      "20:1681" : "20:1681 (20:1681 Title IX Education Amendments of 1972)",
      "21:0841" : "21:0841 (21:841 Forfeiture Property-Drugs)",
      "21:0881" : "21:0881 (21:881 Forfeiture Property-Drugs)",
      "21:0881a" : "21:0881a (21:881 Forfeiture Property - Aircraft)",
      "21:0881re" : "21:0881re (21:881 Forfeiture Property - Real Estate)",
      "23:0134" : "23:0134 (23:134 P.I.- Auto Negligence)",
      "23:1441" : "23:1441 (23:1441 Contract Real Estate)",
      "24:1000" : "24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)",
      "25:0640" : "25:0640 (25:640 Indian Tribal Rights)",
      "25:1901" : "25:1901 (25:1901 Indian Child Welfare Act)",
      "26:6212" : "26:6212 (26:6212 Injunctive Relief from IRS Lien)",
      "26:6213" : "26:6213 (26:6213 Injunctive Relief from IRS Lien)",
      "26:6502" : "26:6502 (26:6502 IRS:Enforcement of tax liens)",
      "26:6532" : "26:6532 (26:6532 IRS: Refund of Tax Penalty)",
      "26:6702" : "26:6702 (26:6702 IRS: Refund of Income Tax Penalty)",
      "26:6703" : "26:6703 (26:6703 IRS: Refund of Tax Penalty)",
      "26:7401" : "26:7401 (26:7401 IRS: Tax Liability)",
      "26:7402" : "26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)",
      "26:7403" : "26:7403 (26:7403 Suit to Enforce Federal Tax Lien)",
      "26:7422rt" : "26:7422rt (26:7422 IRS: Refund Taxes)",
      "26:7422rx" : "26:7422rx (26:7422 IRS: Refund Excise Tax)",
      "26:7426" : "26:7426 (26:7426 IRS: Wrongful Levy for Taxes)",
      "26:7429" : "26:7429 (26:7429 IRS: Tax Jeopardy Assessment)",
      "26:7609" : "26:7609 (26:7609 IRS: Petition to Quash IRS Summons)",
      "27:0185" : "27:0185 (27:185 Enforcement of Arbitration Award)",
      "28:0157c" : "28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)",
      "28:0157d" : "28:0157d (28:0157 Motion for Withdrawal of Reference)",
      "28:0158" : "28:0158 (28:0158 Notice of Appeal re Bankruptcy Matter (BA)",
      "28:0185" : "28:0185 (28:185 Suit to Compel Arbitration)",
      "28:0451" : "28:0451 (28:451 Employment Discrimination)",
      "28:0794" : "28:0794 (28:794 Rehabilitation Act)",
      "28:1001" : "28:1001 (28:1001 E.R.I.S.A.)",
      "28:1132" : "28:1132 (28:1132 E.R.I.S.A.)",
      "28:1330" : "28:1330 (28:1330 Breach of Contract)",
      "28:1331" : "28:1331 (28:1331 Fed. Question)",
      "28:1331al" : "28:1331al (28:1331 Fed. Question: Airline Crash)",
      "28:1331at" : "28:1331at (28:1331 Fed. Question: Anti-trust)",
      "28:1331au" : "28:1331au (28:1331 Fed. Question: Auto Negligence)",
      "28:1331b" : "28:1331b (28:1331 Federal Question: Bivens Act)",
      "28:1331bc" : "28:1331bc (28:1331 Fed. Question: Breach of Contract)",
      "28:1331ca" : "28:1331ca (28:1331 Fed Question: Fed Communications Act of 1)",
      "28:1331cm" : "28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)",
      "28:1331cv" : "28:1331cv (28:1331 Federal Question: Other Civil Rights)",
      "28:1331ed" : "28:1331ed (28:1331 Fed. Question: Employment Discrimination)",
      "28:1331es" : "28:1331es (28:1331 Enforcement of Administrative Subpoena)",
      "28:1331fl" : "28:1331fl (28:1331 Fed. Question: Fair Labor Standards)",
      "28:1331in" : "28:1331in (28:1331 Fed. Question: Insurance Contract)",
      "28:1331mm" : "28:1331mm (28:1331 Fed. Question: Medical Malpractice)",
      "28:1331pi" : "28:1331pi (28:1331 Fed. Question: Personal Injury)",
      "28:1331rd" : "28:1331rd (28:1331 Fed. Question: Review Agency Decision)",
      "28:1331rp" : "28:1331rp (28:1331(a) Fed. Question: Real Property)",
      "28:1331rr" : "28:1331rr (28:1331 Fed. Question: Railway Labor Act)",
      "28:1331sv" : "28:1331sv (28:1331 Fed. Question: Securities Violation)",
      "28:1331tr" : "28:1331tr (28:1331 Fed. Question: Trademark)",
      "28:1331tt" : "28:1331tt (28:1331 Fed. Question: Tort Action)",
      "28:1331v" : "28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendme)",
      "28:1331wl" : "28:1331wl (28:1331 Federal Question: EPA Waste Lien)",
      "28:1331wt" : "28:1331wt (28:1331 Fed. Question: Water Rights)",
      "28:1332ac" : "28:1332ac (28:1332 Diversity-Account Receivable)",
      "28:1332al" : "28:1332al (28:1332 Diversity-Airline Crash)",
      "28:1332as" : "28:1332as (28:1332 Diversity-Asbestos Litigation)",
      "28:1332au" : "28:1332au (28:1332 Diversity-Auto Negligence)",
      "28:1332bc" : "28:1332bc (28:1332 Diversity-Breach of Contract)",
      "28:1332co" : "28:1332co (28:1332 Diversity-Conversion)",
      "28:1332ct" : "28:1332ct (28:1332 Diversity-(Citizenship))",
      "28:1332det" : "28:1332det (28:1332 Diversity: Forcible Detainer)",
      "28:1332df" : "28:1332df (28:1332 Diversity-Contract Default)",
      "28:1332ds" : "28:1332ds (28:1332 Diversity-Contract Dispute)",
      "28:1332ed" : "28:1332ed (28:1332 Diversity-Employment Discrimination)",
      "28:1332ej" : "28:1332ej (28:1332 Diversity - Enforcement of Judgment)",
      "28:1332fd" : "28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)",
      "28:1332fr" : "28:1332fr (28:1332 Diversity-Fraud)",
      "28:1332ia" : "28:1332ia (28:1332 Diversity-Interpleader Action)",
      "28:1332ij" : "28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)",
      "28:1332in" : "28:1332in (28:1332 Diversity-Insurance Contract)",
      "28:1332jd" : "28:1332jd (28:1332 Diversity-Declaratory Judgement)",
      "28:1332lb" : "28:1332lb (28:1332 Diversity-Libel,Assault,Slander)",
      "28:1332lm" : "28:1332lm (28:1332 Diversity - Legal Malpractice)",
      "28:1332ma" : "28:1332ma (28:1332 Diversity-Miller Act)",
      "28:1332mm" : "28:1332mm (28:1332 Diversity-Medical Malpractice)",
      "28:1332mv" : "28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)",
      "28:1332ni" : "28:1332ni (28:1332 Diversity-Negotiable Instrument)",
      "28:1332nm" : "28:1332nm (28:1332 Diversity-Non-Motor Vehicle)",
      "28:1332oc" : "28:1332oc (28:1332 Diversity-Other Contract)",
      "28:1332pd" : "28:1332pd (28:1332 Diversity-Property Damage)",
      "28:1332pi" : "28:1332pi (28:1332 Diversity-Personal Injury)",
      "28:1332pl" : "28:1332pl (28:1332 Diversity-Product Liability)",
      "28:1332pr" : "28:1332pr (28:1332 Diversity-Petition for Removal)",
      "28:1332qt" : "28:1332qt (28:1332 Diversity-Petition to Quiet Title)",
      "28:1332ri" : "28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)",
      "28:1332sa" : "28:1332sa (28:1332 - Diversity: Securities & Exchange Commiss)",
      "28:1332sf" : "28:1332sf (28:1332 - Diversity: Securities Fraud)",
      "28:1332ss" : "28:1332ss (28:1332 Diversity - Stockholders Suits)",
      "28:1332tl" : "28:1332tl (28:1332 Diversity-Torts to Land)",
      "28:1332tm" : "28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))",
      "28:1332tn" : "28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)",
      "28:1332wd" : "28:1332wd (28:1332 Diversity-Wrongful Death)",
      "28:1333" : "28:1333 (28:1333 Admiralty)",
      "28:1334" : "28:1334 (28:1334 Bankruptcy Appeal)",
      "28:1334c" : "28:1334c (28:1334(c) R&R re motions for abstention (non-cor)",
      "28:1335" : "28:1335 (28:1335 Interpleader Action)",
      "28:1337" : "28:1337 (28:1337 Sherman-Clayton Act)",
      "28:1338cp" : "28:1338cp (28:1338 Copyright Infringement)",
      "28:1338pt" : "28:1338pt (28:1338 Patent Infringement)",
      "28:1338tr" : "28:1338tr (28:1338 Trademark Infringement)",
      "28:1340" : "28:1340 (28:1340 IRS: Custom Duties)",
      "28:1340er" : "28:1340er (28:1340 Recovery of Erroneous Refund)",
      "28:1341" : "28:1341 (28:1341 Complaint for Forfeiture)",
      "28:1343" : "28:1343 (28:1343 Violation of Civil Rights)",
      "28:1345co" : "28:1345co (28:1345 Replevin & Conversion)",
      "28:1345db" : "28:1345db (28:1345 Debt to US - FHA/HUD Title I)",
      "28:1345df" : "28:1345df (28:1345 Default of Promissory Note)",
      "28:1345er" : "28:1345er (28:1345 Recovery of Erroneous Refund)",
      "28:1345fc" : "28:1345fc (28:1345 Foreclosure)",
      "28:1345ff" : "28:1345ff (28:1345 Complaint for Forfeiture)",
      "28:1345fr" : "28:1345fr (28:1345 Enjoin Fraud)",
      "28:1345hl" : "28:1345hl (28:1345 VA Home Loan Guaranty Debt)",
      "28:1345mc" : "28:1345mc (28:1345 Medical Care Recovery)",
      "28:1345mi" : "28:1345mi (28:1345 Mining Claim Ejectment)",
      "28:1345pd" : "28:1345pd (28:1345 Property Damage)",
      "28:1345pe" : "28:1345pe (28:1345 Property Ejectment)",
      "28:1345rc" : "28:1345rc (28:1345 Recovery of Debt to US)",
      "28:1345st" : "28:1345st (28:1345 Default of Student Loan)",
      "28:1345tp" : "28:1345tp (28:1345 Trespass on Public Land)",
      "28:1345va" : "28:1345va (28:1345 Recovery of VA Overpayment)",
      "28:1346bc" : "28:1346bc (28:1346 Breach of Contract)",
      "28:1346rc" : "28:1346rc (28:1346 Recovery of IRS Tax)",
      "28:1346tc" : "28:1346tc (28:1346 Tort Claim)",
      "28:1346wd" : "28:1346wd (28:1346 Wrongful Death)",
      "28:1352" : "28:1352 (28:1352 Miller Act)",
      "28:1355" : "28:1355 (28:1355 Petition for Return of Property)",
      "28:1358" : "28:1358 (28:1358 Land Condemnation)",
      "28:1361" : "28:1361 (28:1361 Petition for Writ of Mandamus)",
      "28:1362ic" : "28:1362ic (28:1362 Indian Tribal Controversy)",
      "28:1362iw" : "28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)",
      "28:1364" : "28:1364 (28:1364 Auto Negligence)",
      "28:1391" : "28:1391 (28:1391 Personal Injury)",
      "28:1402" : "28:1402 (28:1402 Medical Malpractice)",
      "28:1407" : "28:1407 (28:1407 Airline Crash)",
      "28:1441ac" : "28:1441ac (28:1441 Petition for Removal- Account Receivable)",
      "28:1441al" : "28:1441al (28:1441 Petition for Removal- Airline Crash)",
      "28:1441as" : "28:1441as (28:1441 Petition for Removal- Asbestos Litigation)",
      "28:1441au" : "28:1441au (28:1441 Petition for Removal- Auto Negligence)",
      "28:1441bc" : "28:1441bc (28:1441 Petition for Removal- Breach of Contract)",
      "28:1441cv" : "28:1441cv (28:1441 Petition for Removal- Civil Rights Act)",
      "28:1441df" : "28:1441df (28:1441 Petition for Removal- Contract Default)",
      "28:1441dj" : "28:1441dj (28:1441 Petition for Removal- Declaratory Judgemen)",
      "28:1441ds" : "28:1441ds (28:1441 Petition for Removal- Contract Dispute)",
      "28:1441ed" : "28:1441ed (28:1441 Petition for Removal - Employment Discrim)",
      "28:1441eri" : "28:1441eri (28:1441eri - Petition for removal - E.R.I.S.A.)",
      "28:1441fc" : "28:1441fc (28:1441 Petition for Removal - Fair Credit Reporti)",
      "28:1441fr" : "28:1441fr (28:1441 Petition for Removal- Fraud)",
      "28:1441ij" : "28:1441ij (28:1441 Petition for Removal- Injunctive/Declarato)",
      "28:1441in" : "28:1441in (28:1441 Petition for Removal- Insurance Contract)",
      "28:1441int" : "28:1441int (28:1441 Petition for Removal- Action for Interplea)",
      "28:1441lb" : "28:1441lb (28:1441 Petition for Removal Libel,Assault,Slander)",
      "28:1441lm" : "28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relatio)",
      "28:1441mm" : "28:1441mm (28:1441 Petition for Removal- Medical Malpractice)",
      "28:1441ni" : "28:1441ni (28:1441 Petition for Removal- Negotiable Instrumen)",
      "28:1441nm" : "28:1441nm (28:1441 Petition for Removal- Non-Motor Vehicle)",
      "28:1441oc" : "28:1441oc (28:1441 Petition For Removal--Other Contract)",
      "28:1441pd" : "28:1441pd (28:1441 Petition for Removal- Property Damage)",
      "28:1441pi" : "28:1441pi (28:1441 Petition for Removal- Personal Injury)",
      "28:1441pl" : "28:1441pl (28:1441 Petition for Removal- Product Liability)",
      "28:1441pr" : "28:1441pr (28:1441 Petition for Removal)",
      "28:1441qt" : "28:1441qt (28:1441 Petition for Removal- Petition to Quiet Ti)",
      "28:1441ri" : "28:1441ri (28:1441 Petition for Removal- Racketeering (RICO))",
      "28:1441sa" : "28:1441sa (28:1441 - Petition for Removal: SEC Act)",
      "28:1441sf" : "28:1441sf (28:1441 - Petition for Removal: Securities Fraud)",
      "28:1441tl" : "28:1441tl (28:1441 Petition for Removal- Torts to Land)",
      "28:1441tm" : "28:1441tm (28:1441 Petition for Removal- Tort/Motor Vehicle ()",
      "28:1441tn" : "28:1441tn (28:1441 Petition for Removal- Tort/Non-Motor Vehic)",
      "28:1441wd" : "28:1441wd (28:1441 Petition for Removal- Wrongful Death)",
      "28:1442bc" : "28:1442bc (28:1442 Petition for Removal- Breach of Contract)",
      "28:1442pr" : "28:1442pr (28:1442 Petition for Removal)",
      "28:1443" : "28:1443 (28:1443(1) Rent, Lease & Ejectment)",
      "28:1444" : "28:1444 (28:1444 Petition for Removal- Foreclosure)",
      "28:1446in" : "28:1446in (28:1446 Breach of Contract- Insurance)",
      "28:1446pd" : "28:1446pd (28:1446 Petition for Removal- Property Damage (P.I)",
      "28:1446pi" : "28:1446pi (28:1446 Petition for Removal- Personal Injury)",
      "28:1446pl" : "28:1446pl (28:1446pl Petition for Removal - Product Liability)",
      "28:1446pr" : "28:1446pr (28:1446 Petition for Removal)",
      "28:1452" : "28:1452 (28:1452 R&R re motions to remand (non-core))",
      "28:1651" : "28:1651 (28:1651 Petition for Writ of Coram Nobis)",
      "28:1651hc" : "28:1651hc (28:1651 Petition for Writ of Habeas Corpus)",
      "28:1651mn" : "28:1651mn (28:1651 Petition for Writ of Mandamus)",
      "28:1983" : "28:1983 (28:1983 Civil Rights)",
      "28:2201" : "28:2201 (28:2201 Constitutionality of State Statute(s))",
      "28:2201dj" : "28:2201dj (28:2201 Declaratory Judgement)",
      "28:2201ij" : "28:2201ij (28:2201 Injunction)",
      "28:2201in" : "28:2201in (28:2201 Declaratory Judgement (Insurance))",
      "28:2241" : "28:2241 (28:2241 Petition for Writ of Habeas Corpus (federa)",
      "28:2254" : "28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))",
      "28:2254se" : "28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)",
      "28:2255" : "28:2255 (28:2255 Motion to Vacate / Correct Illegal Sentenc)",
      "28:2271" : "28:2271 (28:2271 Federal Tort Claims Act)",
      "28:2345" : "28:2345 (28:2345 Medicare Recovery)",
      "28:2409" : "28:2409 (28:2409(a) Quiet Title Action)",
      "28:2410" : "28:2410 (28:2410 Quiet Title)",
      "28:2671" : "28:2671 (28:2671 Federal Tort Claims Act)",
      "28:2674" : "28:2674 (28:2674 Federal Tort Claims Act)",
      "28:7402" : "28:7402 (28:7402 Refund of Taxes)",
      "28:7422" : "28:7422 (28:7422 Appeal from Administrative Decision)",
      "29:0151" : "29:0151 (29:151 Labor: Review of Agency Action)",
      "29:0160" : "29:0160 (29:160(1) National Labor Relations Act)",
      "29:0184" : "29:0184 (29:184 Violation Collection Bargain Agreement)",
      "29:0185ep" : "29:0185ep (29:185 Employee Pension Plan)",
      "29:0185lm" : "29:0185lm (29:185 Labor/Mgt. Relations (Contracts))",
      "29:0201do" : "29:0201do (29:201 Denial of Overtime Compensation)",
      "29:0201fl" : "29:0201fl (29:201 Fair Labor Standards Act)",
      "29:0203" : "29:0203 (29:203 Equal Pay Act)",
      "29:0206" : "29:0206 (29:206 Collect Unpaid Wages)",
      "29:0401" : "29:0401 (29:0401 Labor Management Disclosure Act)",
      "29:0621" : "29:0621 (29:621 Job Discrimination (Age))",
      "29:0623" : "29:0623 (29:623 Job Discrimination (Age))",
      "29:0626" : "29:0626 (29:626 Job Discrimination (Age))",
      "29:0633" : "29:0633 (29:633 Job Discrimination (Age))",
      "29:0651" : "29:0651 (29:651 Occupational Safety/Health)",
      "29:0754" : "29:0754 (29:754 Discrimination)",
      "29:0790" : "29:0790 (29:0790 Rehabilitation of Labor)",
      "29:0791" : "29:0791 (29:791 Job Discrimination (Rehabilitation Act))",
      "29:0794" : "29:0794 (29:0794 Job Discrimination (Handicap))",
      "29:1001" : "29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)",
      "29:1002" : "29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)",
      "29:1104" : "29:1104 (29:1104 Recovery of Benefits to Employee)",
      "29:1109" : "29:1109 (29:1109 Breach of Fiduciary Duties)",
      "29:1131" : "29:1131 (29:1131 ERISA - Collection of Delinquent Trust Fun)",
      "29:1132" : "29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)",
      "29:1145" : "29:1145 (29:1145 E.R.I.S.A.)",
      "29:1149" : "29:1149 (29:1149 Recover Pension & Profit Sharing)",
      "29:1337" : "29:1337 (29:1337 E.R.I.S.A.)",
      "29:1362" : "29:1362 (29:1362 ERISA)",
      "29:1381" : "29:1381 (29:1381 E.R.I.S.A.)",
      "29:1401" : "29:1401 (29:1401(b)(2) Appeal of Arbitration Award)",
      "29:1451" : "29:1451 (29:1451 E.R.I.S.A.)",
      "29:1801" : "29:1801 (29:1801 Farmworker Rights)",
      "29:2601" : "29:2601 (29:2601 Family and Medical Leave Act (1993))",
      "29:790" : "29:790 (29:790 Rehabilitation of Labor)",
      "30:0181" : "30:0181 (30:181 Environment: Review of Agency Action)",
      "30:0801" : "30:0801 (30:0801 Penalities/Federal Mine Safety Health Act)",
      "30:1201" : "30:1201 (30:1201 Environment: Review of Agency Action)",
      "30:1202" : "30:1202 (30:1202 Mining Reclamation Act)",
      "30:1276" : "30:1276 (30:1276 Interior: Review of Agency Action)",
      "31:3545" : "31:3545 (31:3545 Action to Recovery Money)",
      "31:3729" : "31:3729 (31:3729 False Claims Act)",
      "31:3730" : "31:3730 (31:3730 Qui Tam False Claims Act)",
      "31:3731" : "31:3731 (31:3731 Fraud)",
      "33:0903" : "33:0903 (33:0903 Longshore & Harbor Worker's Compensation Act)",
      "33:1319cw" : "33:1319cw (33:1319 Clean Water Act)",
      "33:1319pv" : "33:1319pv (33:1319 Pollutants & Permit Violations)",
      "33:1365" : "33:1365 (33:1365 Environmental Matters)",
      "35:0145" : "35:0145 (35:145 Patent Infringement)",
      "35:0183" : "35:0183 (35:183 Patent Infringement)",
      "35:0271" : "35:0271 (35:271 Patent Infringement)",
      "35:0292" : "35:0292 (35:0292 False Marking - Marking with Patent Number that is expired)",
      "38:1681" : "38:1681 (38:1681 Recovery of VA Overpayment)",
      "38:1686" : "38:1686 (38:1686 Recovery of VA Overpayment)",
      "38:1780" : "38:1780 (38:1780 Recovery of VA Overpayment)",
      "38:2011" : "38:2011 (38:2011 - Veteran's Readjustment Assistance Act of)",
      "38:3116" : "38:3116 (38:3116 VA Overpayment)",
      "39:0409" : "39:0409 (39:0409 Postal Service)",
      "39:3005" : "39:3005 (39:3005 Detention of Mail for Temporary Periods)",
      "39:409" : "39:409 (39:409 Postal Service)",
      "40:0258" : "40:0258 (40:258(a) Public Buildings & Property: Land Condem)",
      "40:0270" : "40:0270 (40:270 Miller Act)",
      "40:0875" : "40:0875 (40:875 Public Buildings & Property: Negligence)",
      "41:0251" : "41:0251 (41:251 Public Contracts-Review of Agency Action)",
      "41:1463" : "41:1463 (41:1463 Public Contracts: Unlawful Employment Prac)",
      "42:0205" : "42:0205 (42:205 Denial Social Security Benefits)",
      "42:0206" : "42:0206 (42:206 Social Security Benefits)",
      "42:0247" : "42:0247 (42:247 Personal Injury-Swine Flu)",
      "42:0300" : "42:0300 (42:0300 National Vaccine Injury Comp Program)",
      "42:0402" : "42:0402 (42:402 Social Security Benefits)",
      "42:0405id" : "42:0405id (42:405 Review of HHS Decision (SSID))",
      "42:0405wc" : "42:0405wc (42:405 Review of HHS Decision (DIWC))",
      "42:0405ww" : "42:0405ww (42:405 Review of HHS Decision (DIWW))",
      "42:0416" : "42:0416 (42:416 Denial of Social Security Benefits)",
      "42:0425" : "42:0425 (42:0425 Social Security Benefits)",
      "42:0427" : "42:0427 (42:427 Social Security Benefits)",
      "42:12117ad" : "42:12117ad (42:12117ad - Americans with Disabilities Act)",
      "42:1383" : "42:1383 (42:1383 Review of HHS Decision)",
      "42:1395" : "42:1395 (42:1395 HHS: Adverse Reimbursement Review)",
      "42:1396" : "42:1396 (42:1396 - Tort Negligence)",
      "42:1471" : "42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclo)",
      "42:1973" : "42:1973 (42:1973 Voting Rights Act)",
      "42:1981cv" : "42:1981cv (42:1981 Civil Rights)",
      "42:1981hs" : "42:1981hs (42:1981 Housing Discrimination)",
      "42:1981jb" : "42:1981jb (42:1981 Job Discrimination (Race))",
      "42:1981sx" : "42:1981sx (42:1981 Sex Discrimination)",
      "42:1983cv" : "42:1983cv (42:1983 Civil Rights Act)",
      "42:1983ed" : "42:1983ed (42:1983 Civil Rights (Employment Discrimination))",
      "42:1983pr" : "42:1983pr (42:1983 Prisoner Civil Rights)",
      "42:1986" : "42:1986 (42:1986 Neglect of Duty)",
      "42:2000ag" : "42:2000ag (42:2000 Job Discrimination (Age))",
      "42:2000e" : "42:2000e (42:2000e Job Discrimination (Employment))",
      "42:2000pb" : "42:2000pb (42:2000 Job Discrimination (Public Accomodations))",
      "42:2000ra" : "42:2000ra (42:2000 Job Discrimination (Race))",
      "42:2000sx" : "42:2000sx (42:2000 Job Discrimination (Sex))",
      "42:2003" : "42:2003 (42:2003 Job Discrimination)",
      "42:2005" : "42:2005 (42:2005 Review of Agency Action-HHS)",
      "42:2651" : "42:2651 (42:2651 Medical Care Recovery)",
      "42:31325" : "42:31325 (42:31325 Admiralty and Maritime Claim)",
      "42:3601" : "42:3601 (42:405 Fair Housing Act)",
      "42:4000" : "42:4000 (42:4000 National Flood Insurance Act)",
      "42:4001" : "42:4001 (42:4001 National Insurance Flood Act)",
      "42:4053" : "42:4053 (42:4053 Breach of Insurance Contract)",
      "42:4072" : "42:4072 (42:4072 Payment of Flood Insurance Claim)",
      "42:4321" : "42:4321 (42:4321 Review of Agency Action-Environment)",
      "42:4332" : "42:4332 (42:4332 Environmental Policy - Coop of Agency Repo)",
      "42:5851" : "42:5851 (Energy reorg act-empl contract)",
      "42:6291" : "42:6291 (42:6291 (EPCA)-Energy Policy and Conservation Act of 1975)",
      "42:6901en" : "42:6901en (42:6901 Environmental Cleanup Expenses)",
      "42:6901rs" : "42:6901rs (42:6901 Resource & Recovery Act)",
      "42:7413" : "42:7413 (42:7413(b) Clean Air Act)",
      "42:7604cl" : "42:7604cl (42:7604 Clear Air Act (Emission Standards))",
      "42:7604ir" : "42:7604ir (42:7604 Petition to Quash IRS Summons)",
      "42:9601" : "42:9601 (42:9601 - CERCLA)",
      "42:9607" : "42:9607 (42:9607 Real Property Tort to Land)",
      "43:0945" : "43:0945 (43:0945 Compensation for Land Condemnation)",
      "43:0945a" : "43:0945a (43:0945(a) Complaint in Condemnation)",
      "43:0946" : "43:0946 (43:0946 Complaint in Condemnation - Eminent Domain)",
      "43:4323" : "43:4323 (Soldiers and Sailors Employment and Reemployment Act)",
      "43:945" : "43:945 (43:945 Compensation for Land Condemnation)",
      "43:945a" : "43:945a (43:945a Complaint in Condemnation)",
      "43:946" : "43:946 (43:946 Complaint in Condemnation - Eminent Domain)",
      "45:0051" : "45:0051 (45:51 Railways: Fed. Employer's Liability Act)",
      "45:0151" : "45:0151 (45:151 Railway Labor Act)",
      "45:0184" : "45:0184 (45:184 Action to Set Aside Award of a System Board)",
      "45:1395" : "45:1395 (45:1395 Railroads: Adverse Reimbursement Review)",
      "45:7457" : "45:7457 (45:7457 Compel Reclamation Under Clear Air Act)",
      "46:0183" : "46:0183 (46:0183 Admiralty - exoneration of liability)",
      "46:0688" : "46:0688 (46:688 Jones Act)",
      "46:0741" : "46:0741 (46:741 Shipping)",
      "46:0761" : "46:0761 (46:761 Shipping: Damages for Death on High Seas)",
      "46:1101" : "46:1101 (46:1101 Violation of Maritime Regulations)",
      "46:1156" : "46:1156 (46:1156 Administrative Procedure Act)",
      "47:0151ta" : "47:0151ta (47:0151ta - Telecommunications Act of 1996)",
      "47:605" : "47:605 (47:605 Electronic Communications Privacy Act)",
      "48:0883" : "48:0883 (48:883 Violation of US Coastal Law)",
      "48:1985" : "48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)",
      "49:0081" : "49:0081 (49:81 Damaged Goods While Being Transported)",
      "49:0781" : "49:0781 (49:781 Forfeiture)",
      "49:11503" : "49:11503 (49:11503 Railroad Revitalization Regulatory Reform)",
      "49:11702" : "49:11702 (49:11702(a)(4) Violations of Interstate Commerce A)",
      "49:1374(c)" : "49:1374(c) (49:1374(c)(1) - Air Carriers Access Act)",
      "49:1471" : "49:1471 (49:1471 Federal Aviation Act)",
      "49:1903" : "49:1903 (49:1903 Petition to enforce administrative summon)",
      "49:20109" : "49:20109 (49:20109 - Federal Railroad Safety Act)",
      "49:30101" : "49:30101 (49:30101 - National Traffic & Motor Vehicle Safety Act)",
      "8:287" : "8:287 (8:287 Petition to Enforce INS Subpoena)",
      "misc" : "misc (Civil Miscellaneous Case)"
   },
   "alsdce" : {
      "0" : "0 (No cause code entered)",
      "02:0431" : "02:0431 (02:431 Fed. Election Commission: Failure Enforce C)",
      "02:0437" : "02:0437 (02:437 Federal Election Commission)",
      "02:1202" : "02:1202 (02:1202 Discriminatory practices affecting US Senate employees)",
      "02:1301" : "02:1301 (02:1301 Congressional Accountability Act)",
      "02:1317a" : "02:1317a (02:1317a Violation of Congressional Accountability Act)",
      "02:138" : "02:138 (02:138 Library of Congress Access)",
      "02:358" : "02:358 (02:358 President's Recommendations on Exec., Jud. & Leg. Salary)",
      "02:681" : "02:681 (02:681 Deferral of Budget Authority)",
      "05:0075" : "05:0075 (05:75(2) Contract - Reduction in Grade)",
      "05:0551" : "05:0551 (05:551 Administrative Procedure Act)",
      "05:0552fi" : "05:0552fi (05:552 Freedom of Information Act)",
      "05:0552pa" : "05:0552pa (05:552 Right to Privacy Act)",
      "05:0554" : "05:0554 (05:0554 Constitutionality of Maritime Statutes)",
      "05:0701" : "05:0701 (05:0701 Maritime Subsidy Board)",
      "05:0702" : "05:0702 (05:702 Administrative Procedure Act)",
      "05:0704" : "05:0704 (05:704 Labor Litigation)",
      "05:7703" : "05:7703 (05:7703 Discrimination - Review of Agency Act)",
      "05:8470" : "05:8470 (05:8470 Enforcement of Judgment against Retirement Benefits)",
      "05:8701" : "05:8701 (05:8701 Federal Employees Group Life Insurance Act of 1954)",
      "07:0006" : "07:0006 (7:6(b) Federal Commodity Exchange Regulation)",
      "07:0025" : "07:0025 (7:25 Fraud - Commodities Leverage Contracts)",
      "07:0181" : "07:0181 (07:181 Packers & Stockyard Act)",
      "07:0499" : "07:0499 (07:499 Agricultural Commodities Act)",
      "07:0601" : "07:0601 (07:601 USDA Condemnation)",
      "07:2011" : "07:2011 (07:2011 Food Stamp Program)",
      "07:2023" : "07:2023 (07:2023 Food Stamp Program, Judicial Review)",
      "07:2321" : "07:2321 (07:2321 Plant Variety Protection Act)",
      "08:1105" : "08:1105 (8:1105(a) Aliens: Habeas Corpus to Release INS Det)",
      "08:1182" : "08:1182 (8:1182 Defend. Denial of Pla. Appl. for Alien Employment Cer)",
      "08:1252" : "08:1252 (08:1252(a)(2) Injunction for Deportation)",
      "08:1260" : "08:1260 (08:1260 Aliens: Access to Records)",
      "08:1324" : "08:1324 (08:1324 Aliens: Complaint for Forfeiture)",
      "08:1329" : "08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petiti)",
      "08:1421" : "08:1421 (08:1421 Review of Denial of Naturalization)",
      "08:1446" : "08:1446 (8:1446 Petition for Naturalization Hearing)",
      "08:1451(j)" : "08:1451(j) (8:1451(j) Motion to Correct Order & Judg. of Naturalization)",
      "09:0001" : "09:0001 (09:1 U.S. Arbitration Act)",
      "09:0009" : "09:0009 (9:9 Motion to Confirm Arbitration Loan)",
      "09:0010" : "09:0010 (09:0010 Petition to Vacate Arbitration Award)",
      "10:1408" : "10:1408 (10:1408 Claim for Military Retirement)",
      "10:1552" : "10:1552 (10:1552 Armed Forces: Action to Correct Records)",
      "10:1553" : "10:1553 (10:1553 Armed Forces: FOIA General)",
      "10:2305" : "10:2305 (10:2305 Review of Federal Contract)",
      "11:0101" : "11:0101 (11:101 Bankruptcy)",
      "12:0022" : "12:0022 (12:22 Securities Fraud)",
      "12:0635" : "12:0635 (12:635 Breach of Insurance Contract)",
      "12:1461" : "12:1461 (12:1461 Homeowners Loan Act)",
      "12:1464" : "12:1464 (12:1464 Federal Savings and Loan)",
      "12:1703" : "12:1703 (12:1703 Default of HUD Loan)",
      "12:1725" : "12:1725 (12:1725 Collection under Contract Guaranty)",
      "12:1730" : "12:1730 (12:1730 Collection Under Contract Guaranty)",
      "12:1787" : "12:1787 (12:1787(a)(B) Fed Credit Unions: Liquidation of Insured Credit Union by Board)",
      "12:1819" : "12:1819 (12:1819 Default of Promissory Note)",
      "12:1821" : "12:1821 (12:1821 Default of Loan by Promissary Note)",
      "12:191" : "12:191 (12:191 Bank Foreclosure)",
      "12:192" : "12:192 (12:192 Liquidation of National Bank)",
      "12:1971" : "12:1971 (12:1971 Relief under Bank Holding Act)",
      "12:1972" : "12:1972 (12:1972 Typing Arrangement Act)",
      "12:2601" : "12:2601 (12:2601 Real Estate Settlement Procedures Act (RESPA) (findings & purpose))",
      "12:3410" : "12:3410 (12:3410 Right to Financial Privacy Act)",
      "15:0001" : "15:0001 (15:1 Antitrust Litigation)",
      "15:0002at" : "15:0002at (15:2 Antitrust Litigation)",
      "15:0002fl" : "15:0002fl (15:2(a) Fair Labor Standards Act)",
      "15:0005" : "15:0005 (15:5(a) Fair Labor Standards Act)",
      "15:0015" : "15:0015 (15:15 Antitrust Litigation)",
      "15:0025" : "15:0025 (15:25 Clayton Act)",
      "15:0044" : "15:0044 (15:44 Trademark Infringement)",
      "15:0045" : "15:0045 (15:0045 Federal Trade Commission Act)",
      "15:0052" : "15:0052 (15:0052 Federal Trade Commission Act)",
      "15:0053" : "15:0053 (15:0053 Federal Trade Commission Act)",
      "15:0077" : "15:0077 (15:77 Securities Fraud)",
      "15:0078" : "15:0078 (15:78m(a) Securities Exchange Act)",
      "15:0631" : "15:0631 (15:631 Small Business Act)",
      "15:0717" : "15:0717 (15:717 Natural Gas Act)",
      "15:0754" : "15:0754 (15:754 Emergency Petroleum Allocation-Admin.& Enforcement)",
      "15:1051" : "15:1051 (15:1051 Trademark Infringement)",
      "15:1114" : "15:1114 (15:1114 Trademark Infringement)",
      "15:1121" : "15:1121 (15:1121 Trademark Infringement)",
      "15:1125" : "15:1125 (15:1125 Trademark Infringement (Lanham Act))",
      "15:1126" : "15:1126 (15:1126 Patent Infringement)",
      "15:1127" : "15:1127 (15:1127 Trademark Infringement)",
      "15:1601" : "15:1601 (15:1601 Truth in Lending)",
      "15:1640" : "15:1640 (15:1640 Truth in Lending)",
      "15:1666" : "15:1666 (15:1666 Fair Credit Billing Act Dispute)",
      "15:1681" : "15:1681 (15:1681 Fair Credit Reporting Act)",
      "15:1692" : "15:1692 (15:1692 Fair Debt Collection Act)",
      "15:1693ef" : "15:1693ef (15:1693ef Electronic Funds Transfer Act)",
      "15:1701" : "15:1701 (15:1701 Interstate Land Sales Full Disclosure Act)",
      "15:1938" : "15:1938 (15:1938 Fair Labor Standards Act)",
      "15:1981" : "15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))",
      "15:1988" : "15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))",
      "15:1989" : "15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))",
      "15:2301" : "15:2301 (15:2301 Magnuson-Moss Warranty Act)",
      "15:2801" : "15:2801 (15:2801 Petroleum Marketing Practices Act)",
      "15:53(b)" : "15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equita)",
      "16:0668" : "16:0668 (16:668 Bald Eagle Protection Act)",
      "16:0703" : "16:0703 (16:703 Migratory Bird Act)",
      "16:1538" : "16:1538 (16:1538 Endangered Species Act)",
      "16:3371" : "16:3371 (16:3371 Wildlife Under the Lacey Act)",
      "16:3372" : "16:3372 (16:3372 Conservation: Complaint for Forfeiture)",
      "16:3373" : "16:3373 (16:3373 Appeal of Decision - DOI)",
      "16:3374" : "16:3374 (16:3374 Conservation: Complaint for Forfeiture)",
      "17:0101" : "17:0101 (17:101 Copyright Infringement)",
      "17:0501" : "17:0501 (17:501 Copyright Infringement)",
      "17:0504" : "17:0504 (17:504 Copyright Infringement)",
      "18:0241" : "18:0241 (18:241 Conspiracy Against Citizen Rights)",
      "18:1030" : "18:1030 (18:1030 Fraud and Related Activity in Connection with Computers)",
      "18:1836a" : "18:1836a (18:1836(a) - Injunction against Misappropriation of Trade Secrets)",
      "18:1836b" : "18:1836b (18:1836(b) - Civil Action to Protect Trade Secrets)",
      "18:1961" : "18:1961 (18:1961 Racketeering (RICO) Act)",
      "18:1962" : "18:1962 (18:1962 Racketeering (RICO) Act)",
      "18:1964" : "18:1964 (18:1964 Racketeering (RICO) Act)",
      "18:2511" : "18:2511 (18:2511 Wiretapping)",
      "18:3114" : "18:3114 (18:3114 Motion for Return of Seized Property)",
      "18:4208" : "18:4208 (18:4208(B) Agency Action Review)",
      "18:981" : "18:981 (18:981 Civil Forfeiture)",
      "18:981(a)" : "18:981(a) (18:981(a)(1)(A) Civil Forfeiture)",
      "19:1305" : "19:1305 (19:1305 Custom Duties:0Forfeiture-Immoral Articles)",
      "20:1080" : "20:1080 (20:1080 Student Loan Recovery)",
      "20:1400" : "20:1400 (20:1400 Civil Rights of Handicapped Child)",
      "20:1401" : "20:1401 (20:1401 Education: Handicapped Child Act)",
      "20:1681" : "20:1681 (20:1681 Title IX Educational Amendments 1992 - Sex Discrimination)",
      "21:0841" : "21:0841 (21:841 Forfeiture Property-Drugs)",
      "21:0881" : "21:0881 (21:881 Forfeiture Property-Drugs)",
      "21:0881a" : "21:0881a (21:881 Forfeiture Property - Aircraft)",
      "21:0881re" : "21:0881re (21:881 Forfeiture Property - Real Estate)",
      "23:0134" : "23:0134 (23:134 P.I.- Auto Negligence)",
      "23:1441" : "23:1441 (23:1441 Contract Real Estate)",
      "24:1000" : "24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)",
      "25:0640" : "25:0640 (25:640 Indian Tribal Rights)",
      "25:1901" : "25:1901 (25:1901 Indian Child Welfare Act)",
      "26:6212" : "26:6212 (26:6212 Injunctive Relief from IRS Lien)",
      "26:6213" : "26:6213 (26:6213 Injunctive Relief from IRS Lien)",
      "26:6502" : "26:6502 (26:6502 IRS:Enforcement of tax liens)",
      "26:6532" : "26:6532 (26:6532 IRS: Refund of Tax Penalty)",
      "26:6702" : "26:6702 (26:6702 IRS: Refund of Income Tax Penalty)",
      "26:6703" : "26:6703 (26:6703 IRS: Refund of Tax Penalty)",
      "26:7401" : "26:7401 (26:7401 IRS: Tax Liability)",
      "26:7402" : "26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)",
      "26:7403" : "26:7403 (26:7403 Suit to Enforce Federal Tax Lien)",
      "26:7422rt" : "26:7422rt (26:7422 IRS: Refund Taxes)",
      "26:7422rx" : "26:7422rx (26:7422 IRS: Refund Excise Tax)",
      "26:7426" : "26:7426 (26:7426 IRS: Wrongful Levy for Taxes)",
      "26:7429" : "26:7429 (26:7429 IRS: Tax Jeopardy Assessment)",
      "26:7609" : "26:7609 (26:7609 IRS: Petition to Quash IRS Summons)",
      "27:0185" : "27:0185 (27:185 Enforcement of Arbitration Award)",
      "28:0157b" : "28:0157b (28:0157(b) Bankruptcy Claim to be tried in U.S. District Court)",
      "28:0157c" : "28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)",
      "28:0157d" : "28:0157d (28:0157 Motion for Withdrawal of Reference)",
      "28:0158" : "28:0158 (28:0158 Notice of Appeal re Bankruptcy Matter (BA)",
      "28:0185" : "28:0185 (28:185 Suit to Compel Arbitration)",
      "28:0451" : "28:0451 (28:451 Employment Discrimination)",
      "28:0754" : "28:0754 (28:754 Receiver of Property in Different Districts)",
      "28:0794" : "28:0794 (28:794 Rehabilitation Act)",
      "28:1001" : "28:1001 (28:1001 E.R.I.S.A.)",
      "28:1132" : "28:1132 (28:1132 E.R.I.S.A.)",
      "28:1330" : "28:1330 (28:1330 Breach of Contract)",
      "28:1331" : "28:1331 (28:1331 Fed. Question)",
      "28:1331al" : "28:1331al (28:1331 Fed. Question: Airline Crash)",
      "28:1331at" : "28:1331at (28:1331 Fed. Question: Anti-trust)",
      "28:1331au" : "28:1331au (28:1331 Fed. Question: Auto Negligence)",
      "28:1331b" : "28:1331b (28:1331 Federal Question: Bivens Act)",
      "28:1331bc" : "28:1331bc (28:1331 Fed. Question: Breach of Contract)",
      "28:1331ca" : "28:1331ca (28:1331 Fed Question: Fed Communications Act of 1)",
      "28:1331cm" : "28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)",
      "28:1331cv" : "28:1331cv (28:1331 Federal Question: Other Civil Rights)",
      "28:1331ed" : "28:1331ed (28:1331 Fed. Question: Employment Discrimination)",
      "28:1331ej" : "28:1331ej (28:1331 Federal Question: Enforcement of Judgment)",
      "28:1331es" : "28:1331es (28:1331 Enforcement of Administrative Subpoena)",
      "28:1331fl" : "28:1331fl (28:1331 Fed. Question: Fair Labor Standards)",
      "28:1331in" : "28:1331in (28:1331 Fed. Question: Insurance Contract)",
      "28:1331mm" : "28:1331mm (28:1331 Fed. Question: Medical Malpractice)",
      "28:1331ng" : "28:1331ng (28:1331 Fed. Question: Natural Gas Act)",
      "28:1331pi" : "28:1331pi (28:1331 Fed. Question: Personal Injury)",
      "28:1331rd" : "28:1331rd (28:1331 Fed. Question: Review Agency Decision)",
      "28:1331rp" : "28:1331rp (28:1331(a) Fed. Question: Real Property)",
      "28:1331rr" : "28:1331rr (28:1331 Fed. Question: Railway Labor Act)",
      "28:1331sv" : "28:1331sv (28:1331 Fed. Question: Securities Violation)",
      "28:1331tr" : "28:1331tr (28:1331 Fed. Question: Trademark)",
      "28:1331tt" : "28:1331tt (28:1331 Fed. Question: Tort Action)",
      "28:1331v" : "28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendme)",
      "28:1331wl" : "28:1331wl (28:1331 Federal Question: EPA Waste Lien)",
      "28:1331wt" : "28:1331wt (28:1331 Fed. Question: Water Rights)",
      "28:1332" : "28:1332 (28:1332 Diversity Action)",
      "28:1332ac" : "28:1332ac (28:1332 Diversity-Account Receivable)",
      "28:1332al" : "28:1332al (28:1332 Diversity-Airline Crash)",
      "28:1332as" : "28:1332as (28:1332 Diversity-Asbestos Litigation)",
      "28:1332au" : "28:1332au (28:1332 Diversity-Auto Negligence)",
      "28:1332bc" : "28:1332bc (28:1332 Diversity-Breach of Contract)",
      "28:1332co" : "28:1332co (28:1332 Diversity-Conversion)",
      "28:1332ct" : "28:1332ct (28:1332 Diversity-(Citizenship))",
      "28:1332det" : "28:1332det (28:1332 Diversity: Forcible Detainer)",
      "28:1332df" : "28:1332df (28:1332 Diversity-Contract Default)",
      "28:1332ds" : "28:1332ds (28:1332 Diversity-Contract Dispute)",
      "28:1332ed" : "28:1332ed (28:1332 Diversity-Employment Discrimination)",
      "28:1332fd" : "28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)",
      "28:1332fr" : "28:1332fr (28:1332 Diversity-Fraud)",
      "28:1332ia" : "28:1332ia (28:1332 Diversity-Interpleader Action)",
      "28:1332ij" : "28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)",
      "28:1332in" : "28:1332in (28:1332 Diversity-Insurance Contract)",
      "28:1332jd" : "28:1332jd (28:1332 Diversity-Declaratory Judgement)",
      "28:1332lb" : "28:1332lb (28:1332 Diversity-Libel,Assault,Slander)",
      "28:1332lm" : "28:1332lm (28:1332 Diversity - Legal Malpractice)",
      "28:1332ma" : "28:1332ma (28:1332 Diversity-Miller Act)",
      "28:1332mm" : "28:1332mm (28:1332 Diversity-Medical Malpractice)",
      "28:1332mv" : "28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)",
      "28:1332ni" : "28:1332ni (28:1332 Diversity-Negotiable Instrument)",
      "28:1332nm" : "28:1332nm (28:1332 Diversity-Non-Motor Vehicle)",
      "28:1332nr" : "28:1332nr (28:1332 Diversity-Notice of Removal)",
      "28:1332oc" : "28:1332oc (28:1332 Diversity-Other Contract)",
      "28:1332pd" : "28:1332pd (28:1332 Diversity-Property Damage)",
      "28:1332pi" : "28:1332pi (28:1332 Diversity-Personal Injury)",
      "28:1332pl" : "28:1332pl (28:1332 Diversity-Product Liability)",
      "28:1332pr" : "28:1332pr (28:1332 Diversity-Petition for Removal)",
      "28:1332qt" : "28:1332qt (28:1332 Diversity-Petition to Quiet Title)",
      "28:1332ri" : "28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)",
      "28:1332rp" : "28:1332rp (28:1332rp Diversity-Real Property)",
      "28:1332sa" : "28:1332sa (28:1332 - Diversity: Securities & Exchange Commiss)",
      "28:1332sf" : "28:1332sf (28:1332 - Diversity: Securities Fraud)",
      "28:1332ss" : "28:1332ss (28:1332 Diversity - Stockholders Suits)",
      "28:1332tl" : "28:1332tl (28:1332 Diversity-Torts to Land)",
      "28:1332tm" : "28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))",
      "28:1332tn" : "28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)",
      "28:1332wd" : "28:1332wd (28:1332 Diversity-Wrongful Death)",
      "28:1333" : "28:1333 (28:1333 Admiralty)",
      "28:1333ds" : "28:1333ds (28:1333 Marine-Contract Dispute)",
      "28:1333ll" : "28:1333ll (28:1333 Marine-Exoneration from/or Limitation of Liability)",
      "28:1333mt" : "28:1333mt (28:1333 Marine Tort/Collision/Allision)",
      "28:1333pi" : "28:1333pi (28:1333 Marine-Personal Injury)",
      "28:1333pm" : "28:1333pm (28:1333 Marine-Preferred Ship Mortgage)",
      "28:1334" : "28:1334 (28:1334 Bankruptcy Appeal)",
      "28:1334c" : "28:1334c (28:1334(c) R&R re motions for abstention (non-cor)",
      "28:1335" : "28:1335 (28:1335 Interpleader Action)",
      "28:1337" : "28:1337 (28:1337 Sherman-Clayton Act)",
      "28:1338cp" : "28:1338cp (28:1338 Copyright Infringement)",
      "28:1338pt" : "28:1338pt (28:1338 Patent Infringement)",
      "28:1338tr" : "28:1338tr (28:1338 Trademark Infringement)",
      "28:1340" : "28:1340 (28:1340 IRS: Custom Duties)",
      "28:1340er" : "28:1340er (28:1340 Recovery of Erroneous Refund)",
      "28:1341" : "28:1341 (28:1341 Complaint for Forfeiture)",
      "28:1343" : "28:1343 (28:1343 Violation of Civil Rights)",
      "28:1345" : "28:1345 (28:1345 USA Plaintiff)",
      "28:1345co" : "28:1345co (28:1345 Replevin & Conversion)",
      "28:1345db" : "28:1345db (28:1345 Debt to US - FHA/HUD Title I)",
      "28:1345df" : "28:1345df (28:1345 Default of Promissory Note)",
      "28:1345er" : "28:1345er (28:1345 Recovery of Erroneous Refund)",
      "28:1345fc" : "28:1345fc (28:1345 Foreclosure)",
      "28:1345ff" : "28:1345ff (28:1345 Complaint for Forfeiture)",
      "28:1345hl" : "28:1345hl (28:1345 VA Home Loan Guaranty Debt)",
      "28:1345mc" : "28:1345mc (28:1345 Medical Care Recovery)",
      "28:1345mi" : "28:1345mi (28:1345 Mining Claim Ejectment)",
      "28:1345pd" : "28:1345pd (28:1345 Property Damage)",
      "28:1345pe" : "28:1345pe (28:1345 Property Ejectment)",
      "28:1345rc" : "28:1345rc (28:1345 Recovery of Debt to US)",
      "28:1345st" : "28:1345st (28:1345 Default of Student Loan)",
      "28:1345tp" : "28:1345tp (28:1345 Trespass on Public Land)",
      "28:1345va" : "28:1345va (28:1345 Recovery of VA Overpayment)",
      "28:1346bc" : "28:1346bc (28:1346 Breach of Contract)",
      "28:1346rc" : "28:1346rc (28:1346 Recovery of IRS Tax)",
      "28:1346tc" : "28:1346tc (28:1346 Tort Claim)",
      "28:1346wd" : "28:1346wd (28:1346 Wrongful Death)",
      "28:1349" : "28:1349 (28:1348 Corporation organized under Federal Law as party)",
      "28:1350" : "28:1350 (28:1350 Alien Tort Claims Act)",
      "28:1352" : "28:1352 (28:1352 Miller Act)",
      "28:1355" : "28:1355 (28:1355 Petition for Return of Property)",
      "28:1358" : "28:1358 (28:1358 Land Condemnation)",
      "28:1361" : "28:1361 (28:1361 Petition for Writ of Mandamus)",
      "28:1362ic" : "28:1362ic (28:1362 Indian Tribal Controversy)",
      "28:1362iw" : "28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)",
      "28:1364" : "28:1364 (28:1364 Auto Negligence)",
      "28:1391" : "28:1391 (28:1391 Personal Injury)",
      "28:1402" : "28:1402 (28:1402 Medical Malpractice)",
      "28:1407" : "28:1407 (28:1407 Airline Crash)",
      "28:1441ac" : "28:1441ac (28:1441 Petition for Removal- Account Receivable)",
      "28:1441al" : "28:1441al (28:1441 Petition for Removal- Airline Crash)",
      "28:1441as" : "28:1441as (28:1441 Petition for Removal- Asbestos Litigation)",
      "28:1441au" : "28:1441au (28:1441 Petition for Removal- Auto Negligence)",
      "28:1441bc" : "28:1441bc (28:1441 Petition for Removal- Breach of Contract)",
      "28:1441cv" : "28:1441cv (28:1441 Petition for Removal- Civil Rights Act)",
      "28:1441df" : "28:1441df (28:1441 Petition for Removal- Contract Default)",
      "28:1441dj" : "28:1441dj (28:1441 Petition for Removal- Declaratory Judgemen)",
      "28:1441ds" : "28:1441ds (28:1441 Petition for Removal- Contract Dispute)",
      "28:1441ed" : "28:1441ed (28:1441 Petition for Removal - Employment Discrim)",
      "28:1441fc" : "28:1441fc (28:1441 Petition for Removal - Fair Credit Reporti)",
      "28:1441fr" : "28:1441fr (28:1441 Petition for Removal- Fraud)",
      "28:1441ij" : "28:1441ij (28:1441 Petition for Removal- Injunctive/Declarato)",
      "28:1441in" : "28:1441in (28:1441 Petition for Removal- Insurance Contract)",
      "28:1441int" : "28:1441int (28:1441 Petition for Removal- Action for Interplea)",
      "28:1441lb" : "28:1441lb (28:1441 Petition for Removal Libel,Assault,Slander)",
      "28:1441lm" : "28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relatio)",
      "28:1441mm" : "28:1441mm (28:1441 Petition for Removal- Medical Malpractice)",
      "28:1441ni" : "28:1441ni (28:1441 Petition for Removal- Negotiable Instrumen)",
      "28:1441nm" : "28:1441nm (28:1441 Petition for Removal- Non-Motor Vehicle)",
      "28:1441oc" : "28:1441oc (28:1441 Petition For Removal--Other Contract)",
      "28:1441pd" : "28:1441pd (28:1441 Petition for Removal- Property Damage)",
      "28:1441pi" : "28:1441pi (28:1441 Petition for Removal- Personal Injury)",
      "28:1441pl" : "28:1441pl (28:1441 Petition for Removal- Product Liability)",
      "28:1441pr" : "28:1441pr (28:1441 Petition for Removal)",
      "28:1441qt" : "28:1441qt (28:1441 Petition for Removal- Petition to Quiet Ti)",
      "28:1441ri" : "28:1441ri (28:1441 Petition for Removal- Racketeering (RICO))",
      "28:1441sa" : "28:1441sa (28:1441 - Petition for Removal: SEC Act)",
      "28:1441sf" : "28:1441sf (28:1441 - Petition for Removal: Securities Fraud)",
      "28:1441tl" : "28:1441tl (28:1441 Petition for Removal- Torts to Land)",
      "28:1441tm" : "28:1441tm (28:1441 Petition for Removal- Tort/Motor Vehicle ()",
      "28:1441tn" : "28:1441tn (28:1441 Petition for Removal- Tort/Non-Motor Vehic)",
      "28:1441wd" : "28:1441wd (28:1441 Petition for Removal- Wrongful Death)",
      "28:1442bc" : "28:1442bc (28:1442 Petition for Removal- Breach of Contract)",
      "28:1442pr" : "28:1442pr (28:1442 Petition for Removal)",
      "28:1443" : "28:1443 (28:1443(1) Rent, Lease & Ejectment)",
      "28:1444" : "28:1444 (28:1444 Petition for Removal- Foreclosure)",
      "28:1446" : "28:1446 (28:1446 Removal of Civil/Criminal Action from State Court)",
      "28:1446in" : "28:1446in (28:1446 Breach of Contract- Insurance)",
      "28:1446pd" : "28:1446pd (28:1446 Petition for Removal- Property Damage (P.I)",
      "28:1446pi" : "28:1446pi (28:1446 Petition for Removal- Personal Injury)",
      "28:1446pl" : "28:1446pl (28:1446pl Petition for Removal - Product Liability)",
      "28:1446pr" : "28:1446pr (28:1446 Petition for Removal)",
      "28:1452" : "28:1452 (28:1452 R&R re motions to remand (non-core))",
      "28:1651" : "28:1651 (28:1651 Petition for Writ of Coram Nobis)",
      "28:1651hc" : "28:1651hc (28:1651 Petition for Writ of Habeas Corpus)",
      "28:1651mn" : "28:1651mn (28:1651 Petition for Writ of Mandamus)",
      "28:1782" : "28:1782 (28:1782 Letter rogatory - appointment)",
      "28:1983" : "28:1983 (28:1983 Civil Rights)",
      "28:2201" : "28:2201 (28:2201 Constitutionality of State Statute(s))",
      "28:2201dj" : "28:2201dj (28:2201 Declaratory Judgement)",
      "28:2201ij" : "28:2201ij (28:2201 Injunction)",
      "28:2201in" : "28:2201in (28:2201 Declaratory Judgement (Insurance))",
      "28:2241" : "28:2241 (28:2241 Petition for Writ of Habeas Corpus (federa)",
      "28:2254" : "28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))",
      "28:2254dp" : "28:2254dp (Petition for Writ of Habeas Corpus (Death Penalty))",
      "28:2254se" : "28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)",
      "28:2255" : "28:2255 (28:2255 Motion to Vacate / Correct Illegal Sentenc)",
      "28:2271" : "28:2271 (28:2271 Federal Tort Claims Act)",
      "28:2345" : "28:2345 (28:2345 Medicare Recovery)",
      "28:2409" : "28:2409 (28:2409(a) Quiet Title Action)",
      "28:2410" : "28:2410 (28:2410 Quiet Title)",
      "28:2671" : "28:2671 (28:2671 Federal Tort Claims Act)",
      "28:2674" : "28:2674 (28:2674 Federal Tort Claims Act)",
      "28:2679" : "28:2679 (28:2679(d)(2) Federal Tort Claims Act - Employee of U.S.A.)",
      "28:3001" : "28:3001 (28:3001 Federal Debt Collection)",
      "28:7402" : "28:7402 (28:7402 Refund of Taxes)",
      "28:7422" : "28:7422 (28:7422 Appeal from Administrative Decision)",
      "29:0151" : "29:0151 (29:151 Labor: Review of Agency Action)",
      "29:0160" : "29:0160 (29:160(1) National Labor Relations Act)",
      "29:0184" : "29:0184 (29:184 Violation Collection Bargain Agreement)",
      "29:0185ep" : "29:0185ep (29:185 Employee Pension Plan)",
      "29:0185lm" : "29:0185lm (29:185 Labor/Mgt. Relations (Contracts))",
      "29:0201do" : "29:0201do (29:201 Denial of Overtime Compensation)",
      "29:0201fl" : "29:0201fl (29:201 Fair Labor Standards Act)",
      "29:0203" : "29:0203 (29:203 Equal Pay Act)",
      "29:0206" : "29:0206 (29:206 Collect Unpaid Wages)",
      "29:0401" : "29:0401 (29:0401 Labor Management Disclosure Act)",
      "29:0621" : "29:0621 (29:621 Job Discrimination (Age))",
      "29:0623" : "29:0623 (29:623 Job Discrimination (Age))",
      "29:0626" : "29:0626 (29:626 Job Discrimination (Age))",
      "29:0633" : "29:0633 (29:633 Job Discrimination (Age))",
      "29:0651" : "29:0651 (29:651 Occupational Safety/Health)",
      "29:0754" : "29:0754 (29:754 Discrimination)",
      "29:0791" : "29:0791 (29:791 Job Discrimination (Rehabilitation Act))",
      "29:0794" : "29:0794 (29:0794 Job Discrimination (Handicap))",
      "29:1001" : "29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)",
      "29:1002" : "29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)",
      "29:1104" : "29:1104 (29:1104 Recovery of Benefits to Employee)",
      "29:1109" : "29:1109 (29:1109 Breach of Fiduciary Duties)",
      "29:1131" : "29:1131 (29:1131 ERISA - Collection of Delinquent Trust Fun)",
      "29:1132" : "29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)",
      "29:1145" : "29:1145 (29:1145 E.R.I.S.A.)",
      "29:1149" : "29:1149 (29:1149 Recover Pension & Profit Sharing)",
      "29:1232" : "29:1232 (29:1232 E.R.I.S.A.)",
      "29:1337" : "29:1337 (29:1337 E.R.I.S.A.)",
      "29:1362" : "29:1362 (29:1362 ERISA)",
      "29:1381" : "29:1381 (29:1381 E.R.I.S.A.)",
      "29:1401" : "29:1401 (29:1401(b)(2) Appeal of Arbitration Award)",
      "29:1451" : "29:1451 (29:1451 E.R.I.S.A.)",
      "29:1801" : "29:1801 (29:1801 Farmworker Rights)",
      "29:2101" : "29:2101 (Worker Adjustment and Retraining Notification Act)",
      "29:2601" : "29:2601 (Family & Medical Leave Act of 1993)",
      "29:790" : "29:790 (29:790 Rehabilitation of Labor)",
      "30:0181" : "30:0181 (30:181 Environment: Review of Agency Action)",
      "30:0801" : "30:0801 (30:0801 Penalities/Federal Mine Safety Health Act)",
      "30:1201" : "30:1201 (30:1201 Environment: Review of Agency Action)",
      "30:1202" : "30:1202 (30:1202 Mining Reclamation Act)",
      "30:1276" : "30:1276 (30:1276 Interior: Review of Agency Action)",
      "31:3545" : "31:3545 (31:3545 Action to Recovery Money)",
      "31:3729" : "31:3729 (31:3729 False Claims Act)",
      "31:3730" : "31:3730 (31:3730 Qui Tam False Claims Act)",
      "31:3731" : "31:3731 (31:3731 Fraud)",
      "33:1319cw" : "33:1319cw (33:1319 Clean Water Act)",
      "33:1319pv" : "33:1319pv (33:1319 Pollutants & Permit Violations)",
      "33:1365" : "33:1365 (33:1365 Environmental Matters)",
      "33:906" : "33:906 (Longshore & Haborworker's Compensation)",
      "35:0145" : "35:0145 (35:145 Patent Infringement)",
      "35:0183" : "35:0183 (35:183 Patent Infringement)",
      "35:0271" : "35:0271 (35:271 Patent Infringement)",
      "38:1681" : "38:1681 (38:1681 Recovery of VA Overpayment)",
      "38:1686" : "38:1686 (38:1686 Recovery of VA Overpayment)",
      "38:1780" : "38:1780 (38:1780 Recovery of VA Overpayment)",
      "38:2011" : "38:2011 (38:2011 - Veteran's Readjustment Assistance Act of)",
      "38:2021" : "38:2021 (Right to re-employment of inducted persons)",
      "38:3116" : "38:3116 (38:3116 VA Overpayment)",
      "38:775" : "38:775 (Recovery of Servicemen's Group Life Insurance)",
      "39:3005" : "39:3005 (39:3005 Detention of Mail for Temporary Periods)",
      "39:409" : "39:409 (39:409 Postal Service)",
      "40:0258" : "40:0258 (40:258(a) Public Buildings & Property: Land Condem)",
      "40:0270" : "40:0270 (40:270 Miller Act)",
      "40:0875" : "40:0875 (40:875 Public Buildings & Property: Negligence)",
      "40:3114" : "40:3114 (40:3114 Declaration of Taking)",
      "41:0251" : "41:0251 (41:251 Public Contracts-Review of Agency Action)",
      "41:1463" : "41:1463 (41:1463 Public Contracts: Unlawful Employment Prac)",
      "42:0205" : "42:0205 (42:205 Denial Social Security Benefits)",
      "42:0206" : "42:0206 (42:206 Social Security Benefits)",
      "42:0247" : "42:0247 (42:247 Personal Injury-Swine Flu)",
      "42:0402" : "42:0402 (42:402 Social Security Benefits)",
      "42:0405id" : "42:0405id (42:405 Review of HHS Decision (SSID))",
      "42:0405wc" : "42:0405wc (42:405 Review of HHS Decision (DIWC))",
      "42:0405ww" : "42:0405ww (42:405 Review of HHS Decision (DIWW))",
      "42:0416" : "42:0416 (42:416 Denial of Social Security Benefits)",
      "42:0427" : "42:0427 (42:427 Social Security Benefits)",
      "42:12101" : "42:12101 (Disability Act of 1990)",
      "42:12182" : "42:12182 (Prohibition of discrimination by public accommodations)",
      "42:1383" : "42:1383 (42:1383 Review of HHS Decision)",
      "42:1395" : "42:1395 (42:1395 HHS: Adverse Reimbursement Review)",
      "42:1396" : "42:1396 (42:1396 - Tort Negligence)",
      "42:1471" : "42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclo)",
      "42:1981cv" : "42:1981cv (42:1981 Civil Rights)",
      "42:1981hs" : "42:1981hs (42:1981 Housing Discrimination)",
      "42:1981jb" : "42:1981jb (42:1981 Job Discrimination (Race))",
      "42:1981sx" : "42:1981sx (42:1981 Sex Discrimination)",
      "42:1983cv" : "42:1983cv (42:1983 Civil Rights Act)",
      "42:1983ed" : "42:1983ed (42:1983 Civil Rights (Employment Discrimination))",
      "42:1983pr" : "42:1983pr (42:1983 Prisoner Civil Rights)",
      "42:1986" : "42:1986 (42:1986 Neglect of Duty)",
      "42:2000a-3" : "42:2000a-3 (42:2000a-3pa Discrimination, Segregation; Public Accommodation - Injunctive Relief)",
      "42:2000ag" : "42:2000ag (42:2000 Job Discrimination (Age))",
      "42:2000d" : "42:2000d (42:2000d Federally Assisted Programs)",
      "42:2000e" : "42:2000e (42:2000e Job Discrimination (Employment))",
      "42:2000pb" : "42:2000pb (42:2000 Job Discrimination (Public Accomodations))",
      "42:2000pg" : "42:2000pg (Job Discrimination (Pregancy))",
      "42:2000ra" : "42:2000ra (42:2000 Job Discrimination (Race))",
      "42:2000rt" : "42:2000rt (42:2000rt Job Discrimination/Retaliation)",
      "42:2000sx" : "42:2000sx (42:2000 Job Discrimination (Sex))",
      "42:2003" : "42:2003 (42:2003 Job Discrimination)",
      "42:2005" : "42:2005 (42:2005 Review of Agency Action-HHS)",
      "42:2615" : "42:2615 (42:2616 Medical Recovery Act)",
      "42:2651" : "42:2651 (42:2651 Medical Care Recovery)",
      "42:3601" : "42:3601 (42:405 Fair Housing Act)",
      "42:4000" : "42:4000 (42:4000 National Flood Insurance Act)",
      "42:4001" : "42:4001 (42:4001 National Insurance Flood Act)",
      "42:4053" : "42:4053 (42:4053 Breach of Insurance Contract)",
      "42:4072" : "42:4072 (42:4072 Payment of Flood Insurance Claim)",
      "42:4321" : "42:4321 (42:4321 Review of Agency Action-Environment)",
      "42:4332" : "42:4332 (42:4332 Environmental Policy - Coop of Agency Repo)",
      "42:6901en" : "42:6901en (42:6901 Environmental Cleanup Expenses)",
      "42:6901rs" : "42:6901rs (42:6901 Resource & Recovery Act)",
      "42:7413" : "42:7413 (42:7413(b) Clean Air Act)",
      "42:7604cl" : "42:7604cl (42:7604 Clear Air Act (Emission Standards))",
      "42:7604ir" : "42:7604ir (42:7604 Petition to Quash IRS Summons)",
      "42:9607" : "42:9607 (42:9607 Real Property Tort to Land)",
      "43:945" : "43:945 (43:945 Compensation for Land Condemnation)",
      "43:945a" : "43:945a (43:945a Complaint in Condemnation)",
      "43:946" : "43:946 (43:946 Complaint in Condemnation - Eminent Domain)",
      "45:0051" : "45:0051 (45:51 Railways: Fed. Employer's Liability Act)",
      "45:0151" : "45:0151 (45:151 Railway Labor Act)",
      "45:0184" : "45:0184 (45:184 Action to Set Aside Award of a System Board)",
      "45:1395" : "45:1395 (45:1395 Railroads: Adverse Reimbursement Review)",
      "45:7457" : "45:7457 (45:7457 Compel Reclamation Under Clear Air Act)",
      "46:0688" : "46:0688 (46:688 Jones Act)",
      "46:0688ja" : "46:0688ja (46:0688 Marine-Jones Act)",
      "46:0741" : "46:0741 (46:741 Shipping)",
      "46:0761" : "46:0761 (46:761 Shipping: Damages for Death on High Seas)",
      "46:1101" : "46:1101 (46:1101 Violation of Maritime Regulations)",
      "46:1156" : "46:1156 (46:1156 Administrative Procedure Act)",
      "46:30104" : "46:30104 (46:30104 Marine Personal Injury - Jones Act)",
      "46:30505" : "46:30505 (46:30505-30510 Exoneration, Limitation of Liability)",
      "47:0151" : "47:0151 (47:0151 Wire or Radio Communication)",
      "47:227b3" : "47:227b3 (47:227(b)(3) Telephone Consumer Protection Act of 1991)",
      "47:553" : "47:553 (Communications Act of 1934)",
      "48:0883" : "48:0883 (48:883 Violation of US Coastal Law)",
      "48:1985" : "48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)",
      "49:0081" : "49:0081 (49:81 Damaged Goods While Being Transported)",
      "49:0781" : "49:0781 (49:781 Forfeiture)",
      "49:11702" : "49:11702 (49:11702(a)(4) Violations of Interstate Commerce A)",
      "8:287" : "8:287 (8:287 Petition to Enforce INS Subpoena)",
      "99:9999" : "99:9999 (99:9999 Report cause code (DO NOT DELETE!))",
      "PhenFen" : "PhenFen (Phen Fen Actions)",
      "adsup" : "adsup (Administrative Subpoena)",
      "amtrak" : "amtrak (Amtrak Sunset Limited Train Crash - MDL 1003)",
      "appstate" : "appstate (Appeal from State Court Decision)",
      "contempt" : "contempt (Contempt Proceedings)",
      "crmisc" : "crmisc (Miscellaneous Criminal Action)",
      "disbar" : "disbar (Disbarment Proceedings)",
      "expunge" : "expunge (Motion for Expungement)",
      "fordepo" : "fordepo (Foreign Deposition)",
      "forreq" : "forreq (Foreign Request for Assistance)",
      "mdl" : "mdl (Multi-District Litigation)",
      "misc" : "misc (Civil Miscellaneous Case)",
      "motcomp" : "motcomp (Motion to Compel)",
      "motquash" : "motquash (Motion to Quash)",
      "motret" : "motret (Motion for Return of Property)",
      "objsubp" : "objsubp (Objection to Non-Party Subpoena)",
      "petenf" : "petenf (Petition to Enforce IRS Summons)",
      "petper" : "petper (Petition to Perpetuate Testimony)",
      "powatty" : "powatty (Power of Attorney for Service of Process)",
      "regjgm" : "regjgm (Registration of Foreign Judgment)",
      "tranbkref" : "tranbkref (Transmission of Bankruptcy Reference)",
      "tranff" : "tranff (Transmission of Proposed Findings of Fact and Concl. of Law)",
      "writgar" : "writgar (Application for a Writ of Garnishment)"
   },
   "aredce" : {
      "*41*" : "*41* ( )",
      "0" : "0 (No cause code entered)",
      "00:0000" : "00:0000 (00:0000 Cause Code Unknown)",
      "02:0431" : "02:0431 (02:431 Fed. Election Commission: Failure Enforce Compliance)",
      "02:0437" : "02:0437 (02:437 Federal Election Commission)",
      "05:0075" : "05:0075 (05:75(2) Contract - Reduction in Grade)",
      "05:0551" : "05:0551 (05:551 Administrative Procedure Act)",
      "05:0552fi" : "05:0552fi (05:552 Freedom of Information Act)",
      "05:0552pa" : "05:0552pa (05:552 Right to Privacy Act)",
      "05:0554" : "05:0554 (05:0554 Constitutionality of Maritime Statutes)",
      "05:0701" : "05:0701 (05:0701 Maritime Subsidy Board)",
      "05:0702" : "05:0702 (05:702 Administrative Procedure Act)",
      "05:0704" : "05:0704 (05:704 Labor Litigation)",
      "05:7703" : "05:7703 (05:7703 Discrimination - Review of Agency Act)",
      "05:8902" : "05:8902 (05:8902 Health Insurance - Govt Organizations and Employees)",
      "07:0006" : "07:0006 (7:6(b) Federal Commodity Exchange Regulation)",
      "07:0025" : "07:0025 (7:25 Fraud - Commodities Leverage Contracts)",
      "07:0181" : "07:0181 (07:181 Packers & Stockyard Act)",
      "07:0499" : "07:0499 (07:499 Agricultural Commodities Act)",
      "07:0601" : "07:0601 (07:601 USDA Condemnation)",
      "07:2014" : "07:2014 (07:2014 Welfare Food and Stamp Act)",
      "07:2321" : "07:2321 (07:2321 Plant Variety Protection Act)",
      "08:1105" : "08:1105 (8:1105(a) Aliens: Habeas Corpus to Release INS Detainee)",
      "08:1154" : "08:1154 (08:1154 Immigration and Nationality Act)",
      "08:1252" : "08:1252 (08:1252(a)(2) Injunction for Deportation)",
      "08:1260" : "08:1260 (08:1260 Aliens: Access to Records)",
      "08:1324" : "08:1324 (08:1324 Aliens: Complaint for Forfeiture)",
      "08:1329" : "08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petition)",
      "08:1446" : "08:1446 (8:1446 Petition for Naturalization Hearing)",
      "09:0001" : "09:0001 (09:1 U.S. Arbitration Act)",
      "09:0004" : "09:0004 (09:4 Petition for Order Compelling Arbitration)",
      "09:0009" : "09:0009 (9:9 Motion to Confirm Arbitration Loan)",
      "09:0010" : "09:0010 (09:0010 Petition to Vacate Arbitration Award)",
      "10:1552" : "10:1552 (10:1552 Armed Forces: Action to Correct Records)",
      "10:1553" : "10:1553 (10:1553 Armed Forces: FOIA General)",
      "10:2305" : "10:2305 (10:2305 Review of Federal Contract)",
      "11:0101" : "11:0101 (11:101 Bankruptcy)",
      "12:0022" : "12:0022 (12:22 Securities Fraud)",
      "12:0635" : "12:0635 (12:635 Breach of Insurance Contract)",
      "12:1461" : "12:1461 (12:1461 Homeowners Loan Act)",
      "12:1703" : "12:1703 (12:1703 Default of HUD Loan)",
      "12:1725" : "12:1725 (12:1725 Collection under Contract Guaranty)",
      "12:1730" : "12:1730 (12:1730 Collection Under Contract Guaranty)",
      "12:1819" : "12:1819 (12:1819 Default of Promissory Note)",
      "12:1821" : "12:1821 (12:1821 Default of Loan by Promissary Note)",
      "12:191" : "12:191 (12:191 Bank Foreclosure)",
      "12:1971" : "12:1971 (12:1971 Relief under Bank Holding Act)",
      "12:3410" : "12:3410 (12:3410 Right to Financial Privacy Act)",
      "15:0001" : "15:0001 (15:1 Antitrust Litigation)",
      "15:0002at" : "15:0002at (15:2 Antitrust Litigation)",
      "15:0002fl" : "15:0002fl (15:2(a) Fair Labor Standards Act)",
      "15:0005" : "15:0005 (15:5(a) Fair Labor Standards Act)",
      "15:0015" : "15:0015 (15:15 Antitrust Litigation)",
      "15:0025" : "15:0025 (15:25 Clayton Act)",
      "15:0044" : "15:0044 (15:44 Trademark Infringement)",
      "15:0045" : "15:0045 (15:0045 Federal Trade Commission Act)",
      "15:0052" : "15:0052 (15:0052 Federal Trade Commission Act)",
      "15:0053" : "15:0053 (15:0053 Federal Trade Commission Act)",
      "15:0077" : "15:0077 (15:77 Securities Fraud)",
      "15:0078" : "15:0078 (15:78m(a) Securities Exchange Act)",
      "15:0631" : "15:0631 (15:631 Small Business Act)",
      "15:0717" : "15:0717 (15:717 Natural Gas Act)",
      "15:1051" : "15:1051 (15:1051 Trademark Infringement)",
      "15:1114" : "15:1114 (15:1114 Trademark Infringement)",
      "15:1121" : "15:1121 (15:1121 Trademark Infringement)",
      "15:1125" : "15:1125 (15:1125 Trademark Infringement (Lanham Act))",
      "15:1126" : "15:1126 (15:1126 Patent Infringement)",
      "15:1127" : "15:1127 (15:1127 Trademark Infringement)",
      "15:1601" : "15:1601 (15:1601 Truth in Lending)",
      "15:1605" : "15:1605 (15:1605 Consumer Credit Protection - Finance Charge)",
      "15:1640" : "15:1640 (15:1640 Truth in Lending)",
      "15:1681" : "15:1681 (15:1681 Fair Credit Reporting Act)",
      "15:1692" : "15:1692 (15:1692 Fair Debt Collection Act)",
      "15:1938" : "15:1938 (15:1938 Fair Labor Standards Act)",
      "15:1981" : "15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))",
      "15:1988" : "15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))",
      "15:1989" : "15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))",
      "15:2301" : "15:2301 (15:2301 Magnuson-Moss Warranty Act)",
      "15:2801" : "15:2801 (15:2801 Petroleum Marketing Practices Act)",
      "15:53(b)" : "15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equitable Relief)",
      "16:0668" : "16:0668 (16:668 Bald Eagle Protection Act)",
      "16:0703" : "16:0703 (16:703 Migratory Bird Act)",
      "16:1538" : "16:1538 (16:1538 Endangered Species Act)",
      "16:3371" : "16:3371 (16:3371 Wildlife Under the Lacey Act)",
      "16:3372" : "16:3372 (16:3372 Conservation: Complaint for Forfeiture)",
      "16:3373" : "16:3373 (16:3373 Appeal of Decision - DOI)",
      "16:3374" : "16:3374 (16:3374 Conservation: Complaint for Forfeiture)",
      "17:0101" : "17:0101 (17:101 Copyright Infringement)",
      "17:0501" : "17:0501 (17:501 Copyright Infringement)",
      "17:0504" : "17:0504 (17:504 Copyright Infringement)",
      "18:0241" : "18:0241 (18:241 Conspiracy Against Citizen Rights)",
      "18:0981" : "18:0981 (18:981 Civil Forfeiture)",
      "18:0982" : "18:0982 (18:982 Criminal Forfeiture)",
      "18:0985" : "18:0985 (18:985 Forfeiture of Real Property)",
      "18:1836a" : "18:1836a (18:1836(a) Injunction against Misappropriation of Trade Secrets)",
      "18:1836b" : "18:1836b (18:1836(b) Civil Action to Protect Trade Secrets)",
      "18:1961" : "18:1961 (18:1961 Racketeering (RICO) Act)",
      "18:1962" : "18:1962 (18:1962 Racketeering (RICO) Act)",
      "18:1964" : "18:1964 (18:1964 Racketeering (RICO) Act)",
      "18:3114" : "18:3114 (18:3114 Motion for Return of Seized Property)",
      "18:4208" : "18:4208 (18:4208(B) Agency Action Review)",
      "19:1305" : "19:1305 (19:1305 Custom Duties:0Forfeiture-Immoral Articles)",
      "20:1080" : "20:1080 (20:1080 Student Loan Recovery)",
      "20:1400" : "20:1400 (20:1400 Civil Rights of Handicapped Child)",
      "20:1401" : "20:1401 (20:1401 Education: Handicapped Child Act)",
      "21:0841" : "21:0841 (21:841 Forfeiture Property-Drugs)",
      "21:0881" : "21:0881 (21:881 Forfeiture Property-Drugs)",
      "21:0881a" : "21:0881a (21:881 Forfeiture Property - Aircraft)",
      "21:0881j" : "21:0881j (21:0881j Forfeiture Property-Gambling)",
      "21:0881re" : "21:0881re (21:881 Forfeiture Property - Real Estate)",
      "23:0134" : "23:0134 (23:134 P.I.- Auto Negligence)",
      "23:1441" : "23:1441 (23:1441 Contract Real Estate)",
      "24:1000" : "24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)",
      "25:0640" : "25:0640 (25:640 Indian Tribal Rights)",
      "25:1901" : "25:1901 (25:1901 Indian Child Welfare Act)",
      "26:6212" : "26:6212 (26:6212 Injunctive Relief from IRS Lien)",
      "26:6213" : "26:6213 (26:6213 Injunctive Relief from IRS Lien)",
      "26:6502" : "26:6502 (26:6502 IRS:Enforcement of tax liens)",
      "26:6532" : "26:6532 (26:6532 IRS: Refund of Tax Penalty)",
      "26:6702" : "26:6702 (26:6702 IRS: Refund of Income Tax Penalty)",
      "26:6703" : "26:6703 (26:6703 IRS: Refund of Tax Penalty)",
      "26:7401" : "26:7401 (26:7401 IRS: Tax Liability)",
      "26:7402" : "26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)",
      "26:7403" : "26:7403 (26:7403 Suit to Enforce Federal Tax Lien)",
      "26:7422rt" : "26:7422rt (26:7422 IRS: Refund Taxes)",
      "26:7422rx" : "26:7422rx (26:7422 IRS: Refund Excise Tax)",
      "26:7426" : "26:7426 (26:7426 IRS: Wrongful Levy for Taxes)",
      "26:7429" : "26:7429 (26:7429 IRS: Tax Jeopardy Assessment)",
      "26:7433" : "26:7433 (26:7433 Civil Damages for Unauthorized Collection Actions)",
      "26:7609" : "26:7609 (26:7609 IRS: Petition to Quash IRS Summons)",
      "27:0185" : "27:0185 (27:185 Enforcement of Arbitration Award)",
      "28:0157c" : "28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)",
      "28:0157d" : "28:0157d (28:0157 Motion for Withdrawal of Reference)",
      "28:0158" : "28:0158 (28:0158 Notice of Appeal re Bankruptcy Matter (BAP))",
      "28:0185" : "28:0185 (28:185 Suit to Compel Arbitration)",
      "28:01851m" : "28:01851m (28:185 Labor/Management Relations Act)",
      "28:0451" : "28:0451 (28:451 Employment Discrimination)",
      "28:0794" : "28:0794 (28:794 Rehabilitation Act)",
      "28:1001" : "28:1001 (28:1001 E.R.I.S.A.)",
      "28:1132" : "28:1132 (28:1132 E.R.I.S.A.)",
      "28:1330" : "28:1330 (28:1330 Breach of Contract)",
      "28:1331" : "28:1331 (28:1331 Fed. Question)",
      "28:1331al" : "28:1331al (28:1331 Fed. Question: Airline Crash)",
      "28:1331at" : "28:1331at (28:1331 Fed. Question: Anti-trust)",
      "28:1331au" : "28:1331au (28:1331 Fed. Question: Auto Negligence)",
      "28:1331b" : "28:1331b (28:1331 Federal Question: Bivens Act)",
      "28:1331bc" : "28:1331bc (28:1331 Fed. Question: Breach of Contract)",
      "28:1331ca" : "28:1331ca (28:1331 Fed Question: Fed Communications Act of 1934)",
      "28:1331cm" : "28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)",
      "28:1331cv" : "28:1331cv (28:1331 Federal Question: Other Civil Rights)",
      "28:1331ed" : "28:1331ed (28:1331 Fed. Question: Employment Discrimination)",
      "28:1331es" : "28:1331es (28:1331 Enforcement of Administrative Subpoena)",
      "28:1331fl" : "28:1331fl (28:1331 Fed. Question: Fair Labor Standards)",
      "28:1331in" : "28:1331in (28:1331 Fed. Question: Insurance Contract)",
      "28:1331mm" : "28:1331mm (28:1331 Fed. Question: Medical Malpractice)",
      "28:1331mp" : "28:1331mp (28:1331 Federal Question-Marine Personal Injury)",
      "28:1331pi" : "28:1331pi (28:1331 Fed. Question: Personal Injury)",
      "28:1331rd" : "28:1331rd (28:1331 Fed. Question: Review Agency Decision)",
      "28:1331rp" : "28:1331rp (28:1331(a) Fed. Question: Real Property)",
      "28:1331rr" : "28:1331rr (28:1331 Fed. Question: Railway Labor Act)",
      "28:1331sv" : "28:1331sv (28:1331 Fed. Question: Securities Violation)",
      "28:1331tc" : "28:1331tc (28:1331 Federal Question-Fed. Telecomm. Act of 1996)",
      "28:1331tr" : "28:1331tr (28:1331 Fed. Question: Trademark)",
      "28:1331tt" : "28:1331tt (28:1331 Fed. Question: Tort Action)",
      "28:1331v" : "28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendment)",
      "28:1331wl" : "28:1331wl (28:1331 Federal Question: EPA Waste Lien)",
      "28:1331wt" : "28:1331wt (28:1331 Fed. Question: Water Rights)",
      "28:1332" : "28:1332 (28:1332 Diversity-Personal Injury-Product Liability)",
      "28:1332ac" : "28:1332ac (28:1332 Diversity-Account Receivable)",
      "28:1332al" : "28:1332al (28:1332 Diversity-Airline Crash)",
      "28:1332as" : "28:1332as (28:1332 Diversity-Asbestos Litigation)",
      "28:1332au" : "28:1332au (28:1332 Diversity-Auto Negligence)",
      "28:1332bc" : "28:1332bc (28:1332 Diversity-Breach of Contract)",
      "28:1332co" : "28:1332co (28:1332 Diversity-Conversion)",
      "28:1332ct" : "28:1332ct (28:1332 Diversity-(Citizenship))",
      "28:1332det" : "28:1332det (28:1332 Diversity: Forcible Detainer)",
      "28:1332df" : "28:1332df (28:1332 Diversity-Contract Default)",
      "28:1332ds" : "28:1332ds (28:1332 Diversity-Contract Dispute)",
      "28:1332ed" : "28:1332ed (28:1332 Diversity-Employment Discrimination)",
      "28:1332fd" : "28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)",
      "28:1332fr" : "28:1332fr (28:1332 Diversity-Fraud)",
      "28:1332ia" : "28:1332ia (28:1332 Diversity-Interpleader Action)",
      "28:1332ij" : "28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)",
      "28:1332in" : "28:1332in (28:1332 Diversity-Insurance Contract)",
      "28:1332jd" : "28:1332jd (28:1332 Diversity-Declaratory Judgement)",
      "28:1332lb" : "28:1332lb (28:1332 Diversity-Libel,Assualt,Slander)",
      "28:1332lm" : "28:1332lm (28:1332 Diversity - Legal Malpractice)",
      "28:1332ma" : "28:1332ma (28:1332 Diversity-Miller Act)",
      "28:1332mm" : "28:1332mm (28:1332 Diversity-Medical Malpractice)",
      "28:1332mp" : "28:1332mp (28:1332 Diversity-Motor Vehicle Product Liability)",
      "28:1332mv" : "28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)",
      "28:1332ni" : "28:1332ni (28:1332 Diversity-Negotiable Instrument)",
      "28:1332nm" : "28:1332nm (28:1332 Diversity-Non-Motor Vehicle)",
      "28:1332oc" : "28:1332oc (28:1332 Diversity-Other Contract)",
      "28:1332pd" : "28:1332pd (28:1332 Diversity-Property Damage)",
      "28:1332pi" : "28:1332pi (28:1332 Diversity-Personal Injury)",
      "28:1332pl" : "28:1332pl (28:1332 Diversity-Product Liability)",
      "28:1332pr" : "28:1332pr (28:1332 Diversity-Petition for Removal)",
      "28:1332qt" : "28:1332qt (28:1332 Diversity-Petition to Quiet Title)",
      "28:1332ri" : "28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)",
      "28:1332rp" : "28:1332rp (28:1332 Diversity-Real Property)",
      "28:1332sa" : "28:1332sa (28:1332 - Diversity: Securities & Exchange Commission Act)",
      "28:1332sf" : "28:1332sf (28:1332 - Diversity: Securities Fraud)",
      "28:1332ss" : "28:1332ss (28:1332 Diversity - Stockholders Suits)",
      "28:1332tl" : "28:1332tl (28:1332 Diversity-Torts to Land)",
      "28:1332tm" : "28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))",
      "28:1332tn" : "28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)",
      "28:1332wd" : "28:1332wd (28:1332 Diversity-Wrongful Death)",
      "28:1333" : "28:1333 (28:1333 Admiralty)",
      "28:1334" : "28:1334 (28:1334 Bankruptcy Appeal)",
      "28:1334c" : "28:1334c (28:1334(c) R&R re motions for abstention (non-core))",
      "28:1335" : "28:1335 (28:1335 Interpleader Action)",
      "28:1337" : "28:1337 (28:1337 Sherman-Clayton Act)",
      "28:1338cp" : "28:1338cp (28:1338 Copyright Infringement)",
      "28:1338pt" : "28:1338pt (28:1338 Patent Infringement)",
      "28:1338tr" : "28:1338tr (28:1338 Trademark Infringement)",
      "28:1340" : "28:1340 (28:1340 IRS: Custom Duties)",
      "28:1340er" : "28:1340er (28:1340 Recovery of Erroneous Refund)",
      "28:1341" : "28:1341 (28:1341 Complaint for Forfeiture)",
      "28:1343" : "28:1343 (28:1343 Violation of Civil Rights)",
      "28:1345" : "28:1345 (28:1345 Agricultural Acts)",
      "28:1345co" : "28:1345co (28:1345 Replevin & Conversion)",
      "28:1345db" : "28:1345db (28:1345 Debt to US - FHA/HUD Title I)",
      "28:1345df" : "28:1345df (28:1345 Default of Promissory Note)",
      "28:1345er" : "28:1345er (28:1345 Recovery of Erroneous Refund)",
      "28:1345fc" : "28:1345fc (28:1345 Foreclosure)",
      "28:1345ff" : "28:1345ff (28:1345 Complaint for Forfeiture)",
      "28:1345hd" : "28:1345hd (28:1345 Default of HUD Loan)",
      "28:1345hl" : "28:1345hl (28:1345 VA Home Loan Guaranty Debt)",
      "28:1345mc" : "28:1345mc (28:1345 Medical Care Recovery)",
      "28:1345mi" : "28:1345mi (28:1345 Mining Claim Ejectment)",
      "28:1345pd" : "28:1345pd (28:1345 Property Damage)",
      "28:1345pe" : "28:1345pe (28:1345 Property Ejectment)",
      "28:1345rc" : "28:1345rc (28:1345 Recovery of Debt to US)",
      "28:1345st" : "28:1345st (28:1345 Default of Student Loan)",
      "28:1345tp" : "28:1345tp (28:1345 Trespass on Public Land)",
      "28:1345us" : "28:1345us (28:1345 Debt to United States)",
      "28:1345va" : "28:1345va (28:1345 Recovery of VA Overpayment)",
      "28:1346bc" : "28:1346bc (28:1346 Breach of Contract)",
      "28:1346rc" : "28:1346rc (28:1346 Recovery of IRS Tax)",
      "28:1346tc" : "28:1346tc (28:1346 Tort Claim)",
      "28:1346wd" : "28:1346wd (28:1346 Wrongful Death)",
      "28:1352" : "28:1352 (28:1352 Miller Act)",
      "28:1355" : "28:1355 (28:1355 Petition for Return of Property)",
      "28:1358" : "28:1358 (28:1358 Land Condemnation)",
      "28:1361" : "28:1361 (28:1361 Petition for Writ of Mandamus)",
      "28:1362ic" : "28:1362ic (28:1362 Indian Tribal Controversy)",
      "28:1362iw" : "28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)",
      "28:1364" : "28:1364 (28:1364 Auto Negligence)",
      "28:1391" : "28:1391 (28:1391 Personal Injury)",
      "28:1402" : "28:1402 (28:1402 Medical Malpractice)",
      "28:1404" : "28:1404 (28:1404 Registration of Judgment)",
      "28:1407" : "28:1407 (28:1407 Airline Crash)",
      "28:1441" : "28:1441 (28:1441 Contract Property Liability)",
      "28:1441ac" : "28:1441ac (28:1441 Petition for Removal- Account Receivable)",
      "28:1441ag" : "28:1441ag (28:1441ag Petition for Removal-Age Discrimination)",
      "28:1441al" : "28:1441al (28:1441 Petition for Removal- Airline Crash)",
      "28:1441as" : "28:1441as (28:1441 Petition for Removal- Asbestos Litigation)",
      "28:1441au" : "28:1441au (28:1441 Petition for Removal- Auto Negligence)",
      "28:1441bc" : "28:1441bc (28:1441 Petition for Removal- Breach of Contract)",
      "28:1441cr" : "28:1441cr (28:1441 Petition for Removal-Constitutional Rights)",
      "28:1441crl" : "28:1441crl (28:1441 Petition for Removal - 42:1983 Civil Rights)",
      "28:1441cv" : "28:1441cv (28:1441 Petition for Removal- Civil Rights Act)",
      "28:1441df" : "28:1441df (28:1441 Petition for Removal- Contract Default)",
      "28:1441dj" : "28:1441dj (28:1441 Petition for Removal- Declaratory Judgement)",
      "28:1441ds" : "28:1441ds (28:1441 Petition for Removal- Contract Dispute)",
      "28:1441ed" : "28:1441ed (28:1441 Petition for Removal - Employment Discrimination)",
      "28:1441em" : "28:1441em (28:1441 Petition for Removal-Employment Discrimination)",
      "28:1441er" : "28:1441er (28:1441 Petition for Removal-ERISA)",
      "28:1441fc" : "28:1441fc (28:1441 Petition for Removal - Fair Credit Reporting Act)",
      "28:1441fl" : "28:1441fl (28:1441 Petition for Removal-Family & Medical Leave Act)",
      "28:1441fr" : "28:1441fr (28:1441 Petition for Removal- Fraud)",
      "28:1441ij" : "28:1441ij (28:1441 Petition for Removal- Injunctive/Declaratory Relief)",
      "28:1441in" : "28:1441in (28:1441 Petition for Removal- Insurance Contract)",
      "28:1441int" : "28:1441int (28:1441 Petition for Removal- Action for Interpleader)",
      "28:1441lb" : "28:1441lb (28:1441 Petition for Removal- Libel,Assualt,Slander)",
      "28:1441lm" : "28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relations)",
      "28:1441mm" : "28:1441mm (28:1441 Petition for Removal- Medical Malpractice)",
      "28:1441ni" : "28:1441ni (28:1441 Petition for Removal- Negotiable Instrument)",
      "28:1441nm" : "28:1441nm (28:1441 Petition for Removal- Non-Motor Vehicle)",
      "28:1441oc" : "28:1441oc (28:1441 Petition For Removal--Other Contract)",
      "28:1441pd" : "28:1441pd (28:1441 Petition for Removal- Property Damage)",
      "28:1441pi" : "28:1441pi (28:1441 Petition for Removal- Personal Injury)",
      "28:1441pl" : "28:1441pl (28:1441 Petition for Removal- Product Liability)",
      "28:1441pr" : "28:1441pr (28:1441 Petition for Removal)",
      "28:1441qt" : "28:1441qt (28:1441 Petition for Removal- Petition to Quiet Title)",
      "28:1441rc" : "28:1441rc (28:1441 Petition for Removal-Race Discrimination)",
      "28:1441ri" : "28:1441ri (28:1441 Petition for Removal- Racketeering (RICO) Act)",
      "28:1441sa" : "28:1441sa (28:1441 - Petition for Removal: SEC Act)",
      "28:1441sf" : "28:1441sf (28:1441 - Petition for Removal: Securities Fraud)",
      "28:1441tl" : "28:1441tl (28:1441 Petition for Removal- Torts to Land)",
      "28:1441tm" : "28:1441tm (28:1441 Petition for Removal- Tort/Motor Vehicle (P.I.))",
      "28:1441tn" : "28:1441tn (28:1441 Petition for Removal- Tort/Non-Motor Vehicle)",
      "28:1441ts" : "28:1441ts (28:1441 Petition for Removal-Title VII)",
      "28:1441wd" : "28:1441wd (28:1441 Petition for Removal- Wrongful Death)",
      "28:1442bc" : "28:1442bc (28:1442 Petition for Removal- Breach of Contract)",
      "28:1442pr" : "28:1442pr (28:1442 Petition for Removal)",
      "28:1443" : "28:1443 (28:1443(1) Rent, Lease & Ejectment)",
      "28:1444" : "28:1444 (28:1444 Petition for Removal- Foreclosure)",
      "28:1446bc" : "28:1446bc (28:1446 Petition for Removal-Breach of Contract)",
      "28:1446er" : "28:1446er (28:1446 Petition for Removal-ERISA)",
      "28:1446fl" : "28:1446fl (28:1446 Petition for Removal-Fair Labor Standards)",
      "28:1446in" : "28:1446in (28:1446 Breach of Contract- Insurance)",
      "28:1446pd" : "28:1446pd (28:1446 Petition for Removal- Property Damage (P.I.))",
      "28:1446pi" : "28:1446pi (28:1446 Petition for Removal- Personal Injury)",
      "28:1446pl" : "28:1446pl (28:1446pl Petition for Removal - Product Liability)",
      "28:1446pr" : "28:1446pr (28:1446 Petition for Removal)",
      "28:1446sd" : "28:1446sd (28:1446 Petition for Removal-Sex Discrimination/Harass)",
      "28:1452" : "28:1452 (28:1452 R&R re motions to remand (non-core))",
      "28:1491" : "28:1491 (28:1491 Claim Against the United States)",
      "28:1651" : "28:1651 (28:1651 Petition for Writ of Coram Nobis)",
      "28:1651hc" : "28:1651hc (28:1651 Petition for Writ of Habeas Corpus)",
      "28:1651mn" : "28:1651mn (28:1651 Petition for Writ of Mandamus)",
      "28:1983" : "28:1983 (28:1983 Civil Rights)",
      "28:2201" : "28:2201 (28:2201 Constitutionality of State Statute(s))",
      "28:2201dj" : "28:2201dj (28:2201 Declaratory Judgement)",
      "28:2201ij" : "28:2201ij (28:2201 Injunction)",
      "28:2201in" : "28:2201in (28:2201 Declaratory Judgement (Insurance))",
      "28:2241" : "28:2241 (28:2241 Petition for Writ of Habeas Corpus)",
      "28:2242" : "28:2242 (28:2242 Petition for Writ of Habeas Corpus)",
      "28:2254" : "28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))",
      "28:2254se" : "28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)",
      "28:2255" : "28:2255 (28:2255 Petition for Writ of Habeas Corpus (Federal))",
      "28:2271" : "28:2271 (28:2271 Federal Tort Claims Act)",
      "28:2345" : "28:2345 (28:2345 Medicare Recovery)",
      "28:2409" : "28:2409 (28:2409(a) Quiet Title Action)",
      "28:2410" : "28:2410 (28:2410 Quiet Title)",
      "28:2671" : "28:2671 (28:2671 Federal Tort Claims Act)",
      "28:2674" : "28:2674 (28:2674 Federal Tort Claims Act)",
      "28:2679" : "28:2679 (28:2679 Petition for Removal-Tort Claims Procedure)",
      "28:7402" : "28:7402 (28:7402 Refund of Taxes)",
      "28:7422" : "28:7422 (28:7422 Appeal from Administrative Decision)",
      "29:0151" : "29:0151 (29:151 Labor: Review of Agency Action)",
      "29:0160" : "29:0160 (29:160(1) National Labor Relations Act)",
      "29:0184" : "29:0184 (29:184 Violation Collection Bargain Agreement)",
      "29:0185ep" : "29:0185ep (29:185 Employee Pension Plan)",
      "29:0185lm" : "29:0185lm (29:185 Labor/Mgt. Relations (Contracts))",
      "29:0201do" : "29:0201do (29:201 Denial of Overtime Compensation)",
      "29:0201fl" : "29:0201fl (29:201 Fair Labor Standards Act)",
      "29:0203" : "29:0203 (29:203 Equal Pay Act)",
      "29:0206" : "29:0206 (29:206 Collect Unpaid Wages)",
      "29:0401" : "29:0401 (29:0401 Labor Management Disclosure Act)",
      "29:0621" : "29:0621 (29:621 Job Discrimination (Age))",
      "29:0623" : "29:0623 (29:623 Job Discrimination (Age))",
      "29:0626" : "29:0626 (29:626 Job Discrimination (Age))",
      "29:0633" : "29:0633 (29:633 Job Discrimination (Age))",
      "29:0651" : "29:0651 (29:651 Occupational Safety/Health)",
      "29:0701" : "29:0701 (29:701 Rehabilitation Act of 1973)",
      "29:0754" : "29:0754 (29:754 Discrimination)",
      "29:0791" : "29:0791 (29:791 Job Discrimination (Rehabilitation Act))",
      "29:0794" : "29:0794 (29:0794 Job Discrimination (Handicap))",
      "29:0825" : "29:0825 (29:825 The Family and Medical Leave Act of 1993)",
      "29:1001" : "29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)",
      "29:1002" : "29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)",
      "29:1104" : "29:1104 (29:1104 Recovery of Benefits to Employee)",
      "29:1109" : "29:1109 (29:1109 Breach of Fiduciary Duties)",
      "29:1131" : "29:1131 (29:1131 ERISA - Collection of Delinquent Trust Funds)",
      "29:1132" : "29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)",
      "29:1145" : "29:1145 (29:1145 E.R.I.S.A.)",
      "29:1149" : "29:1149 (29:1149 Recover Pension & Profit Sharing)",
      "29:1337" : "29:1337 (29:1337 E.R.I.S.A.)",
      "29:1362" : "29:1362 (29:1362 ERISA)",
      "29:1381" : "29:1381 (29:1381 E.R.I.S.A.)",
      "29:1401" : "29:1401 (29:1401(b)(2) Appeal of Arbitration Award)",
      "29:1451" : "29:1451 (29:1451 E.R.I.S.A.)",
      "29:1801" : "29:1801 (29:1801 Farmworker Rights)",
      "29:2001" : "29:2001 (29:2001 Employee Polygraph Protection Act)",
      "29:2601" : "29:2601 (29:2601 Violation of the Family and Medical Leave Act-1993)",
      "29:790" : "29:790 (29:790 Rehabilitation of Labor)",
      "30:0181" : "30:0181 (30:181 Environment: Review of Agency Action)",
      "30:0801" : "30:0801 (30:0801 Penalities/Federal Mine Safety Health Act)",
      "30:1201" : "30:1201 (30:1201 Environment: Review of Agency Action)",
      "30:1202" : "30:1202 (30:1202 Mining Reclamation Act)",
      "30:1276" : "30:1276 (30:1276 Interior: Review of Agency Action)",
      "31:3545" : "31:3545 (31:3545 Action to Recovery Money)",
      "31:3729" : "31:3729 (31:3729 False Claims Act)",
      "31:3730" : "31:3730 (31:3730 Qui Tam False Claims Act)",
      "31:3731" : "31:3731 (31:3731 Fraud)",
      "33:1319cw" : "33:1319cw (33:1319 Clean Water Act)",
      "33:1319pv" : "33:1319pv (33:1319 Pollutants & Permit Violations)",
      "33:1365" : "33:1365 (33:1365 Environmental Matters)",
      "35:0145" : "35:0145 (35:145 Patent Infringement)",
      "35:0183" : "35:0183 (35:183 Patent Infringement)",
      "35:0271" : "35:0271 (35:271 Patent Infringement)",
      "35:1331" : "35:1331 (35:1331 Patent Infringement)",
      "38:1681" : "38:1681 (38:1681 Recovery of VA Overpayment)",
      "38:1686" : "38:1686 (38:1686 Recovery of VA Overpayment)",
      "38:1780" : "38:1780 (38:1780 Recovery of VA Overpayment)",
      "38:2011" : "38:2011 (38:2011 - Veteran's Readjustment Assistance Act of 1974)",
      "38:3116" : "38:3116 (38:3116 VA Overpayment)",
      "39:3005" : "39:3005 (39:3005 Detention of Mail for Temporary Periods)",
      "39:409" : "39:409 (39:409 Postal Service)",
      "40:0257" : "40:0257 (40:0257 Land Condemnation Action)",
      "40:0258" : "40:0258 (40:258(a) Public Buildings & Property: Land Condemnation)",
      "40:0270" : "40:0270 (40:270 Miller Act)",
      "40:0875" : "40:0875 (40:875 Public Buildings & Property: Negligence)",
      "41:0251" : "41:0251 (41:251 Public Contracts-Review of Agency Action)",
      "41:1463" : "41:1463 (41:1463 Public Contracts: Unlawful Employment Practices)",
      "42:0205" : "42:0205 (42:205 Denial Social Security Benefits)",
      "42:0206" : "42:0206 (42:206 Social Security Benefits)",
      "42:0247" : "42:0247 (42:247 Personal Injury-Swine Flu)",
      "42:0402" : "42:0402 (42:402 Social Security Benefits)",
      "42:0405" : "42:0405 (42:0405 Review of HHS Decision)",
      "42:0405id" : "42:0405id (42:405 Review of HHS Decision (SSID))",
      "42:0405wc" : "42:0405wc (42:405 Review of HHS Decision (DIWC))",
      "42:0405ww" : "42:0405ww (42:405 Review of HHS Decision (DIWW))",
      "42:0416" : "42:0416 (42:416 Denial of Social Security Benefits)",
      "42:0427" : "42:0427 (42:427 Social Security Benefits)",
      "42:12101" : "42:12101 (42:12101 American Disability Act for Handicapped)",
      "42:12111" : "42:12111 (42:12111 American Disability Act)",
      "42:12117" : "42:12117 (42:12117 Americans with Disabilities Act-Enforcement)",
      "42:12131" : "42:12131 (42:12131 Americans with Disabilities Act)",
      "42:12133" : "42:12133 (42:12133 Americans with Disabilities Act-Enforcement)",
      "42:1383" : "42:1383 (42:1383 Review of HHS Decision)",
      "42:1395" : "42:1395 (42:1395 HHS: Adverse Reimbursement Review)",
      "42:1396" : "42:1396 (42:1396 - Tort Negligence)",
      "42:1437" : "42:1437 (42:1437 Housing Act)",
      "42:1471" : "42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclosure Sale)",
      "42:1973" : "42:1973 (42:1973 Voting Rights Act)",
      "42:1981cv" : "42:1981cv (42:1981 Civil Rights)",
      "42:1981hs" : "42:1981hs (42:1981 Housing Discrimination)",
      "42:1981jb" : "42:1981jb (42:1981 Job Discrimination (Race))",
      "42:1981sx" : "42:1981sx (42:1981 Sex Discrimination)",
      "42:1982" : "42:1982 (42:1982 Property Rights of Citizens)",
      "42:1983" : "42:1983 (42:1983 Other Civil Rights)",
      "42:1983cv" : "42:1983cv (42:1983 Civil Rights Act)",
      "42:1983ed" : "42:1983ed (42:1983 Civil Rights (Employment Discrimination))",
      "42:1983pr" : "42:1983pr (42:1983 Prisoner Civil Rights)",
      "42:1985" : "42:1985 (42:1985 Conspiracy to interfere with civil rights)",
      "42:1986" : "42:1986 (42:1986 Neglect of Duty)",
      "42:2000ag" : "42:2000ag (42:2000 Job Discrimination (Age))",
      "42:2000e" : "42:2000e (42:2000e Job Discrimination (Employment))",
      "42:2000pb" : "42:2000pb (42:2000 Job Discrimination (Public Accomodations))",
      "42:2000ra" : "42:2000ra (42:2000 Job Discrimination (Race))",
      "42:2000sx" : "42:2000sx (42:2000 Job Discrimination (Sex))",
      "42:2003" : "42:2003 (42:2003 Job Discrimination)",
      "42:2005" : "42:2005 (42:2005 Review of Agency Action-HHS)",
      "42:2651" : "42:2651 (42:2651 Medical Care Recovery)",
      "42:292(f)" : "42:292(f) (42:292(f) Registration of State Court Judgment)",
      "42:3601" : "42:3601 (42:3601 Fair Housing Act)",
      "42:4000" : "42:4000 (42:4000 National Flood Insurance Act)",
      "42:4001" : "42:4001 (42:4001 National Insurance Flood Act)",
      "42:4053" : "42:4053 (42:4053 Breach of Insurance Contract)",
      "42:4072" : "42:4072 (42:4072 Payment of Flood Insurance Claim)",
      "42:425" : "42:425 (42:427 Social Security Benefits)",
      "42:4321" : "42:4321 (42:4321 Review of Agency Action-Environment)",
      "42:4332" : "42:4332 (42:4332 Environmental Policy - Coop of Agency Reports)",
      "42:6901en" : "42:6901en (42:6901 Environmental Cleanup Expenses)",
      "42:6901rs" : "42:6901rs (42:6901 Resource & Recovery Act)",
      "42:6928" : "42:6928 (42:6928 Environmental Protection Agency Rules Violation)",
      "42:698" : "42:698 ( )",
      "42:7413" : "42:7413 (42:7413(b) Clean Air Act)",
      "42:7604cl" : "42:7604cl (42:7604 Clear Air Act (Emission Standards))",
      "42:7604ir" : "42:7604ir (42:7604 Petition to Quash IRS Summons)",
      "42:9601" : "42:9601 (42:9601 Environmental Matters)",
      "42:9606" : "42:9606 (42:9606 Environmental Matters-Abatement Actions)",
      "42:9607" : "42:9607 (42:9607 Real Property Tort to Land)",
      "42:9613" : "42:9613 (42:9613 Environmental Matters)",
      "43:945" : "43:945 (43:945 Compensation for Land Condemnation)",
      "43:945a" : "43:945a (43:945a Complaint in Condemnation)",
      "43:946" : "43:946 (43:946 Complaint in Condemnation - Eminent Domain)",
      "45:0051" : "45:0051 (45:51 Railways: Fed. Employer's Liability Act)",
      "45:0151" : "45:0151 (45:151 Railway Labor Act)",
      "45:0184" : "45:0184 (45:184 Action to Set Aside Award of a System Board of Adjust)",
      "45:1395" : "45:1395 (45:1395 Railroads: Adverse Reimbursement Review)",
      "45:7457" : "45:7457 (45:7457 Compel Reclamation Under Clear Air Act)",
      "46:0063" : "46:0063 (46:63 Marine Personal Injury)",
      "46:0688" : "46:0688 (46:0688 Jones Act)",
      "46:0688mp" : "46:0688mp (46:688 Maritime Personal Injury)",
      "46:0741" : "46:0741 (46:741 Shipping)",
      "46:0761" : "46:0761 (46:761 Shipping: Damages for Death on High Seas)",
      "46:1101" : "46:1101 (46:1101 Violation of Maritime Regulations)",
      "46:1156" : "46:1156 (46:1156 Administrative Procedure Act)",
      "46:3134" : "46:3134 (46:3134 Marine Contract Actions)",
      "47:521" : "47:521 (47:521 Communications Act)",
      "48:0883" : "48:0883 (48:883 Violation of US Coastal Law)",
      "48:1985" : "48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)",
      "49:0081" : "49:0081 (49:81 Damaged Goods While Being Transported)",
      "49:0781" : "49:0781 (49:781 Forfeiture)",
      "49:10743" : "49:10743 (49:10743 Revised Interstate Commerce Act)",
      "49:11503" : "49:11503 (49:11503 Railroad Revitalization Regulatory Reform Act)",
      "49:11702" : "49:11702 (49:11702(a)(4) Violations of Interstate Commerce Act)",
      "49:1471" : "49:1471 (49:1471 Federal Aviation Act)",
      "49:1903" : "49:1903 (49:1903 Petition to enforce administrative summons)",
      "49:32710" : "49:32710 (49:32710 Odometer Tampering)",
      "8:287" : "8:287 (8:287 Petition to Enforce INS Subpoena)",
      "gj" : "gj (Grand Jury Matters)",
      "misc" : "misc (Civil Miscellaneous Case)"
   },
   "arwdce" : {
      "0" : "0 (No cause code entered)",
      "00:0000" : "00:0000 (00:0000 Cause Code Unknown)",
      "02:0431" : "02:0431 (02:431 Fed. Election Commission: Failure Enforce Compliance)",
      "02:0437" : "02:0437 (02:437 Federal Election Commission)",
      "05:0075" : "05:0075 (05:75(2) Contract - Reduction in Grade)",
      "05:0551" : "05:0551 (05:551 Administrative Procedure Act)",
      "05:0552fi" : "05:0552fi (05:552 Freedom of Information Act)",
      "05:0552pa" : "05:0552pa (05:552 Right to Privacy Act)",
      "05:0554" : "05:0554 (05:0554 Constitutionality of Maritime Statutes)",
      "05:0701" : "05:0701 (05:0701 Maritime Subsidy Board)",
      "05:0702" : "05:0702 (05:702 Administrative Procedure Act)",
      "05:0704" : "05:0704 (05:704 Labor Litigation)",
      "05:7703" : "05:7703 (05:7703 Discrimination - Review of Agency Act)",
      "07:0006" : "07:0006 (7:6(b) Federal Commodity Exchange Regulation)",
      "07:0025" : "07:0025 (7:25 Fraud - Commodities Leverage Contracts)",
      "07:0181" : "07:0181 (07:181 Packers & Stockyard Act)",
      "07:0499" : "07:0499 (07:499 Agricultural Commodities Act)",
      "07:0601" : "07:0601 (07:601 USDA Condemnation)",
      "07:2022" : "07:2022 (07:2022 Food Stamp Program: Review of Admin. Decision)",
      "07:2321" : "07:2321 (07:2321 Plant Variety Protection Act)",
      "07:6999" : "07:6999 (Review from National Appeals Division-Dept of Agriculture)",
      "08:1105" : "08:1105 (8:1105(a) Aliens: Habeas Corpus to Release INS Detainee)",
      "08:1252" : "08:1252 (08:1252(a)(2) Injunction for Deportation)",
      "08:1260" : "08:1260 (08:1260 Aliens: Access to Records)",
      "08:1324" : "08:1324 (08:1324 Aliens: Complaint for Forfeiture)",
      "08:1329" : "08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petition)",
      "08:1421" : "08:1421 (08:1421(c) - Judicial Review of Naturalization Application)",
      "08:1446" : "08:1446 (8:1446 Petition for Naturalization Hearing)",
      "09:0001" : "09:0001 (09:1 U.S. Arbitration Act)",
      "09:0009" : "09:0009 (9:9 Motion to Confirm Arbitration Loan)",
      "09:0010" : "09:0010 (09:0010 Petition to Vacate Arbitration Award)",
      "10:1552" : "10:1552 (10:1552 Armed Forces: Action to Correct Records)",
      "10:1553" : "10:1553 (10:1553 Armed Forces: FOIA General)",
      "10:2305" : "10:2305 (10:2305 Review of Federal Contract)",
      "11:0101" : "11:0101 (11:101 Bankruptcy)",
      "12:0022" : "12:0022 (12:22 Securities Fraud)",
      "12:0635" : "12:0635 (12:635 Breach of Insurance Contract)",
      "12:1441a" : "12:1441a (12:1441a Resolution Trust Corporation Act)",
      "12:1461" : "12:1461 (12:1461 Homeowners Loan Act)",
      "12:1703" : "12:1703 (12:1703 Default of HUD Loan)",
      "12:1725" : "12:1725 (12:1725 Collection under Contract Guaranty)",
      "12:1730" : "12:1730 (12:1730 Collection Under Contract Guaranty)",
      "12:1819" : "12:1819 (12:1819 Default of Promissory Note)",
      "12:1821" : "12:1821 (12:1821 Default of Loan by Promissary Note)",
      "12:1971" : "12:1971 (12:1971 Relief under Bank Holding Act)",
      "12:2601" : "12:2601 (12:2601 Real Estate Settlement Procedures Act (RESPA))",
      "12:3410" : "12:3410 (12:3410 Right to Financial Privacy Act)",
      "15:0001" : "15:0001 (15:1 Antitrust Litigation)",
      "15:0002at" : "15:0002at (15:2 Antitrust Litigation)",
      "15:0002fl" : "15:0002fl (15:2(a) Fair Labor Standards Act)",
      "15:0005" : "15:0005 (15:5(a) Fair Labor Standards Act)",
      "15:0015" : "15:0015 (15:15 Antitrust Litigation)",
      "15:0025" : "15:0025 (15:25 Clayton Act)",
      "15:0044" : "15:0044 (15:44 Trademark Infringement)",
      "15:0045" : "15:0045 (15:0045 Federal Trade Commission Act)",
      "15:0052" : "15:0052 (15:0052 Federal Trade Commission Act)",
      "15:0053" : "15:0053 (15:0053 Federal Trade Commission Act)",
      "15:0072" : "15:0072 (15:72 Anti-dumping Act of 1916)",
      "15:0077" : "15:0077 (15:77 Securities Fraud)",
      "15:0078" : "15:0078 (15:78m(a) Securities Exchange Act)",
      "15:0631" : "15:0631 (15:631 Small Business Act)",
      "15:0717" : "15:0717 (15:717 Natural Gas Act)",
      "15:1051" : "15:1051 (15:1051 Trademark Infringement)",
      "15:1114" : "15:1114 (15:1114 Trademark Infringement)",
      "15:1121" : "15:1121 (15:1121 Trademark Infringement)",
      "15:1125" : "15:1125 (15:1125 Trademark Infringement (Lanham Act))",
      "15:1126" : "15:1126 (15:1126 Patent Infringement)",
      "15:1127" : "15:1127 (15:1127 Trademark Infringement)",
      "15:1601" : "15:1601 (15:1601 Truth in Lending)",
      "15:1640" : "15:1640 (15:1640 Truth in Lending)",
      "15:1681" : "15:1681 (15:1681 Fair Credit Reporting Act)",
      "15:1692" : "15:1692 (15:1692 Fair Debt Collection Act)",
      "15:1693" : "15:1693 (15:1693 Electronic Funds Transfer Act)",
      "15:1701" : "15:1701 (15:1701 Interstate Land Sales - Full Disclosure Act)",
      "15:1938" : "15:1938 (15:1938 Fair Labor Standards Act)",
      "15:1981" : "15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))",
      "15:1988" : "15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))",
      "15:1989" : "15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))",
      "15:2301" : "15:2301 (15:2301 Magnuson-Moss Warranty Act)",
      "15:2801" : "15:2801 (15:2801 Petroleum Marketing Practices Act)",
      "15:2805" : "15:2805 (15:2805 Dispute in Franchise Agreement)",
      "15:53(b)" : "15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equitable Relief)",
      "16:0668" : "16:0668 (16:668 Bald Eagle Protection Act)",
      "16:0703" : "16:0703 (16:703 Migratory Bird Act)",
      "16:1538" : "16:1538 (16:1538 Endangered Species Act)",
      "16:3371" : "16:3371 (16:3371 Wildlife Under the Lacey Act)",
      "16:3372" : "16:3372 (16:3372 Conservation: Complaint for Forfeiture)",
      "16:3373" : "16:3373 (16:3373 Appeal of Decision - DOI)",
      "16:3374" : "16:3374 (16:3374 Conservation: Complaint for Forfeiture)",
      "17:0101" : "17:0101 (17:101 Copyright Infringement)",
      "17:0501" : "17:0501 (17:501 Copyright Infringement)",
      "17:0504" : "17:0504 (17:504 Copyright Infringement)",
      "18:0241" : "18:0241 (18:241 Conspiracy Against Citizen Rights)",
      "18:1836a" : "18:1836a (18:1836(a) - Injunction against Misappropriation of Trade Secrets)",
      "18:1836b" : "18:1836b (18:1836(b) - Civil Action to Protect Trade Secrets)",
      "18:1961" : "18:1961 (18:1961 Racketeering (RICO) Act)",
      "18:1962" : "18:1962 (18:1962 Racketeering (RICO) Act)",
      "18:1964" : "18:1964 (18:1964 Racketeering (RICO) Act)",
      "18:2255" : "18:2255 (18:2255 Violation of Protection of Children Against Sexual Exploitation Act)",
      "18:2721" : "18:2721 (18:2721 Driver Privacy Protection Act)",
      "18:4208" : "18:4208 (18:4208(B) Agency Action Review)",
      "18:512" : "18:512 (18:512 Forfeiture of Motor Vehicle)",
      "19:1305" : "19:1305 (19:1305 Custom Duties:0Forfeiture-Immoral Articles)",
      "20:1080" : "20:1080 (20:1080 Student Loan Recovery)",
      "20:1400" : "20:1400 (20:1400 Civil Rights of Handicapped Child)",
      "20:1401" : "20:1401 (20:1401 Education: Handicapped Child Act)",
      "21:0601" : "21:0601 (21:0601 Federal Meat Inspection Act)",
      "21:0841" : "21:0841 (21:841 Forfeiture Property-Drugs)",
      "21:0842" : "21:0842 (21:842 Drug Abuse Prevention Act)",
      "21:0881" : "21:0881 (21:881 Forfeiture Property-Drugs)",
      "21:0881a" : "21:0881a (21:881 Forfeiture Property - Aircraft)",
      "21:0881re" : "21:0881re (21:881 Forfeiture Property - Real Estate)",
      "22:6081" : "22:6081 (22:6081 Cuban Liberty & Democratic Solidarity Act of 1996)",
      "23:0134" : "23:0134 (23:134 P.I.- Auto Negligence)",
      "23:1441" : "23:1441 (23:1441 Contract Real Estate)",
      "24:1000" : "24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)",
      "25:0640" : "25:0640 (25:640 Indian Tribal Rights)",
      "25:1901" : "25:1901 (25:1901 Indian Child Welfare Act)",
      "26:6212" : "26:6212 (26:6212 Injunctive Relief from IRS Lien)",
      "26:6213" : "26:6213 (26:6213 Injunctive Relief from IRS Lien)",
      "26:6502" : "26:6502 (26:6502 IRS:Enforcement of tax liens)",
      "26:6532" : "26:6532 (26:6532 IRS: Refund of Tax Penalty)",
      "26:6702" : "26:6702 (26:6702 IRS: Refund of Income Tax Penalty)",
      "26:6703" : "26:6703 (26:6703 IRS: Refund of Tax Penalty)",
      "26:7401" : "26:7401 (26:7401 IRS: Tax Liability)",
      "26:7402" : "26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)",
      "26:7403" : "26:7403 (26:7403 Suit to Enforce Federal Tax Lien)",
      "26:7422rt" : "26:7422rt (26:7422 IRS: Refund Taxes)",
      "26:7422rx" : "26:7422rx (26:7422 IRS: Refund Excise Tax)",
      "26:7426" : "26:7426 (26:7426 IRS: Wrongful Levy for Taxes)",
      "26:7429" : "26:7429 (26:7429 IRS: Tax Jeopardy Assessment)",
      "26:7609" : "26:7609 (26:7609 IRS: Petition to Quash IRS Summons)",
      "27:0185" : "27:0185 (27:185 Enforcement of Arbitration Award)",
      "28:0157c" : "28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)",
      "28:0157d" : "28:0157d (28:0157 Motion for Withdrawal of Reference)",
      "28:0157e" : "28:0157e (28:0157(e) Jury Trial in Bankruptcy Proceeding)",
      "28:0158" : "28:0158 (28:0158 Notice of Appeal re Bankruptcy Matter (BAP))",
      "28:0185" : "28:0185 (28:185 Suit to Compel Arbitration)",
      "28:0451" : "28:0451 (28:451 Employment Discrimination)",
      "28:0794" : "28:0794 (28:794 Rehabilitation Act)",
      "28:1001" : "28:1001 (28:1001 E.R.I.S.A.)",
      "28:1132" : "28:1132 (28:1132 E.R.I.S.A.)",
      "28:1330" : "28:1330 (28:1330 Breach of Contract)",
      "28:1331" : "28:1331 (28:1331 Fed. Question)",
      "28:1331al" : "28:1331al (28:1331 Fed. Question: Airline Crash)",
      "28:1331at" : "28:1331at (28:1331 Fed. Question: Anti-trust)",
      "28:1331au" : "28:1331au (28:1331 Fed. Question: Auto Negligence)",
      "28:1331b" : "28:1331b (28:1331 Federal Question: Bivens Act)",
      "28:1331bc" : "28:1331bc (28:1331 Fed. Question: Breach of Contract)",
      "28:1331ca" : "28:1331ca (28:1331 Fed Question: Fed Communications Act of 1934)",
      "28:1331cm" : "28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)",
      "28:1331cv" : "28:1331cv (28:1331 Federal Question: Other Civil Rights)",
      "28:1331ed" : "28:1331ed (28:1331 Fed. Question: Employment Discrimination)",
      "28:1331es" : "28:1331es (28:1331 Enforcement of Administrative Subpoena)",
      "28:1331fl" : "28:1331fl (28:1331 Fed. Question: Fair Labor Standards)",
      "28:1331in" : "28:1331in (28:1331 Fed. Question: Insurance Contract)",
      "28:1331mm" : "28:1331mm (28:1331 Fed. Question: Medical Malpractice)",
      "28:1331pi" : "28:1331pi (28:1331 Fed. Question: Personal Injury)",
      "28:1331rd" : "28:1331rd (28:1331 Fed. Question: Review Agency Decision)",
      "28:1331rp" : "28:1331rp (28:1331(a) Fed. Question: Real Property)",
      "28:1331rr" : "28:1331rr (28:1331 Fed. Question: Railway Labor Act)",
      "28:1331sv" : "28:1331sv (28:1331 Fed. Question: Securities Violation)",
      "28:1331tr" : "28:1331tr (28:1331 Fed. Question: Trademark)",
      "28:1331tt" : "28:1331tt (28:1331 Fed. Question: Tort Action)",
      "28:1331v" : "28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendment)",
      "28:1331wl" : "28:1331wl (28:1331 Federal Question: EPA Waste Lien)",
      "28:1331wt" : "28:1331wt (28:1331 Fed. Question: Water Rights)",
      "28:1332ac" : "28:1332ac (28:1332 Diversity-Account Receivable)",
      "28:1332al" : "28:1332al (28:1332 Diversity-Airline Crash)",
      "28:1332as" : "28:1332as (28:1332 Diversity-Asbestos Litigation)",
      "28:1332au" : "28:1332au (28:1332 Diversity-Auto Negligence)",
      "28:1332bc" : "28:1332bc (28:1332 Diversity-Breach of Contract)",
      "28:1332cafa" : "28:1332cafa (28:1332(d) - Class Action Fairness Act - DISCONTINUED)",
      "28:1332co" : "28:1332co (28:1332 Diversity-Conversion)",
      "28:1332ct" : "28:1332ct (28:1332 Diversity-(Citizenship))",
      "28:1332det" : "28:1332det (28:1332 Diversity: Forcible Detainer)",
      "28:1332df" : "28:1332df (28:1332 Diversity-Contract Default)",
      "28:1332ds" : "28:1332ds (28:1332 Diversity-Contract Dispute)",
      "28:1332ed" : "28:1332ed (28:1332 Diversity-Employment Discrimination)",
      "28:1332fd" : "28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)",
      "28:1332fr" : "28:1332fr (28:1332 Diversity-Fraud)",
      "28:1332ia" : "28:1332ia (28:1332 Diversity-Interpleader Action)",
      "28:1332ij" : "28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)",
      "28:1332in" : "28:1332in (28:1332 Diversity-Insurance Contract)",
      "28:1332jd" : "28:1332jd (28:1332 Diversity-Declaratory Judgment)",
      "28:1332lb" : "28:1332lb (28:1332 Diversity-Libel,Assault,Slander)",
      "28:1332lm" : "28:1332lm (28:1332 Diversity - Legal Malpractice)",
      "28:1332ma" : "28:1332ma (28:1332 Diversity-Miller Act)",
      "28:1332mm" : "28:1332mm (28:1332 Diversity-Medical Malpractice)",
      "28:1332mv" : "28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)",
      "28:1332ni" : "28:1332ni (28:1332 Diversity-Negotiable Instrument)",
      "28:1332nm" : "28:1332nm (28:1332 Diversity-Non-Motor Vehicle)",
      "28:1332oc" : "28:1332oc (28:1332 Diversity-Other Contract)",
      "28:1332pd" : "28:1332pd (28:1332 Diversity-Property Damage)",
      "28:1332pi" : "28:1332pi (28:1332 Diversity-Personal Injury)",
      "28:1332pl" : "28:1332pl (28:1332 Diversity-Product Liability)",
      "28:1332pr" : "28:1332pr (28:1332 Diversity-Petition for Removal)",
      "28:1332qt" : "28:1332qt (28:1332 Diversity-Petition to Quiet Title)",
      "28:1332ri" : "28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)",
      "28:1332sa" : "28:1332sa (28:1332 - Diversity: Securities & Exchange Commission Act)",
      "28:1332sf" : "28:1332sf (28:1332 - Diversity: Securities Fraud)",
      "28:1332ss" : "28:1332ss (28:1332 Diversity - Stockholders Suits)",
      "28:1332tl" : "28:1332tl (28:1332 Diversity-Torts to Land)",
      "28:1332tm" : "28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))",
      "28:1332tn" : "28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)",
      "28:1332wd" : "28:1332wd (28:1332 Diversity-Wrongful Death)",
      "28:1333" : "28:1333 (28:1333 Admiralty)",
      "28:1334" : "28:1334 (28:1334 Bankruptcy Appeal)",
      "28:1334c" : "28:1334c (28:1334(c) R&R re motions for abstention (non-core))",
      "28:1335" : "28:1335 (28:1335 Interpleader Action)",
      "28:1337" : "28:1337 (28:1337 Sherman-Clayton Act)",
      "28:1338cp" : "28:1338cp (28:1338 Copyright Infringement)",
      "28:1338pt" : "28:1338pt (28:1338 Patent Infringement)",
      "28:1338tr" : "28:1338tr (28:1338 Trademark Infringement)",
      "28:1340" : "28:1340 (28:1340 IRS: Custom Duties)",
      "28:1340er" : "28:1340er (28:1340 Recovery of Erroneous Refund)",
      "28:1341" : "28:1341 (28:1341 Complaint for Forfeiture)",
      "28:1343" : "28:1343 (28:1343 Violation of Civil Rights)",
      "28:1345co" : "28:1345co (28:1345 Replevin & Conversion)",
      "28:1345db" : "28:1345db (28:1345 Debt to US - FHA/HUD Title I)",
      "28:1345df" : "28:1345df (28:1345 Default of Promissory Note)",
      "28:1345er" : "28:1345er (28:1345 Recovery of Erroneous Refund)",
      "28:1345fc" : "28:1345fc (28:1345 Foreclosure)",
      "28:1345ff" : "28:1345ff (28:1345 Complaint for Forfeiture)",
      "28:1345hl" : "28:1345hl (28:1345 VA Home Loan Guaranty Debt)",
      "28:1345mc" : "28:1345mc (28:1345 Medical Care Recovery)",
      "28:1345mi" : "28:1345mi (28:1345 Mining Claim Ejectment)",
      "28:1345pd" : "28:1345pd (28:1345 Property Damage)",
      "28:1345pe" : "28:1345pe (28:1345 Property Ejectment)",
      "28:1345qt" : "28:1345qt (28:1345 Petition to Quiet Title)",
      "28:1345rc" : "28:1345rc (28:1345 Recovery of Debt to US)",
      "28:1345st" : "28:1345st (28:1345 Default of Student Loan)",
      "28:1345tp" : "28:1345tp (28:1345 Trespass on Public Land)",
      "28:1345va" : "28:1345va (28:1345 Recovery of VA Overpayment)",
      "28:1346bc" : "28:1346bc (28:1346 Breach of Contract)",
      "28:1346rc" : "28:1346rc (28:1346 Recovery of IRS Tax)",
      "28:1346tc" : "28:1346tc (28:1346 Tort Claim)",
      "28:1346wd" : "28:1346wd (28:1346 Wrongful Death)",
      "28:1352" : "28:1352 (28:1352 Miller Act)",
      "28:1355" : "28:1355 (28:1355 Petition for Return of Property)",
      "28:1358" : "28:1358 (28:1358 Land Condemnation)",
      "28:1361" : "28:1361 (28:1361 Petition for Writ of Mandamus)",
      "28:1362ic" : "28:1362ic (28:1362 Indian Tribal Controversy)",
      "28:1362iw" : "28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)",
      "28:1364" : "28:1364 (28:1364 Auto Negligence)",
      "28:1367" : "28:1367 (28:1367 Supplemental Jurisdiction)",
      "28:1391" : "28:1391 (28:1391 Personal Injury)",
      "28:1402" : "28:1402 (28:1402 Medical Malpractice)",
      "28:1407" : "28:1407 (28:1407 Airline Crash)",
      "28:1441ac" : "28:1441ac (28:1441 Petition for Removal- Account Receivable)",
      "28:1441al" : "28:1441al (28:1441 Petition for Removal- Airline Crash)",
      "28:1441as" : "28:1441as (28:1441 Petition for Removal- Asbestos Litigation)",
      "28:1441au" : "28:1441au (28:1441 Petition for Removal- Auto Negligence)",
      "28:1441bc" : "28:1441bc (28:1441 Petition for Removal- Breach of Contract)",
      "28:1441cv" : "28:1441cv (28:1441 Petition for Removal- Civil Rights Act)",
      "28:1441df" : "28:1441df (28:1441 Petition for Removal- Contract Default)",
      "28:1441dj" : "28:1441dj (28:1441 Petition for Removal- Declaratory Judgment)",
      "28:1441ds" : "28:1441ds (28:1441 Petition for Removal- Contract Dispute)",
      "28:1441ed" : "28:1441ed (28:1441 Petition for Removal - Employment Discrimination)",
      "28:1441fc" : "28:1441fc (28:1441 Petition for Removal - Fair Credit Reporting Act)",
      "28:1441fr" : "28:1441fr (28:1441 Petition for Removal- Fraud)",
      "28:1441ij" : "28:1441ij (28:1441 Petition for Removal- Injunctive/Declaratory Relief)",
      "28:1441in" : "28:1441in (28:1441 Petition for Removal- Insurance Contract)",
      "28:1441int" : "28:1441int (28:1441 Petition for Removal- Action for Interpleader)",
      "28:1441lb" : "28:1441lb (28:1441 Petition for Removal Libel,Assault,Slander)",
      "28:1441lm" : "28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relations)",
      "28:1441mm" : "28:1441mm (28:1441 Petition for Removal- Medical Malpractice)",
      "28:1441ni" : "28:1441ni (28:1441 Petition for Removal- Negotiable Instrument)",
      "28:1441nm" : "28:1441nm (28:1441 Petition for Removal- Non-Motor Vehicle)",
      "28:1441oc" : "28:1441oc (28:1441 Petition For Removal--Other Contract)",
      "28:1441pd" : "28:1441pd (28:1441 Petition for Removal- Property Damage)",
      "28:1441pi" : "28:1441pi (28:1441 Petition for Removal- Personal Injury)",
      "28:1441pl" : "28:1441pl (28:1441 Petition for Removal- Product Liability)",
      "28:1441pr" : "28:1441pr (28:1441 Petition for Removal)",
      "28:1441qt" : "28:1441qt (28:1441 Petition for Removal- Petition to Quiet Title)",
      "28:1441ri" : "28:1441ri (28:1441 Petition for Removal- Racketeering (RICO) Act)",
      "28:1441sa" : "28:1441sa (28:1441 - Petition for Removal: SEC Act)",
      "28:1441sf" : "28:1441sf (28:1441 - Petition for Removal: Securities Fraud)",
      "28:1441tl" : "28:1441tl (28:1441 Petition for Removal- Torts to Land)",
      "28:1441tm" : "28:1441tm (28:1441 Petition for Removal- Tort/Motor Vehicle (P.I.))",
      "28:1441tn" : "28:1441tn (28:1441 Petition for Removal- Tort/Non-Motor Vehicle)",
      "28:1441wd" : "28:1441wd (28:1441 Petition for Removal- Wrongful Death)",
      "28:1442bc" : "28:1442bc (28:1442 Petition for Removal- Breach of Contract)",
      "28:1442pr" : "28:1442pr (28:1442 Petition for Removal)",
      "28:1443" : "28:1443 (28:1443 Petition for Removal - Civil Rights)",
      "28:1443(1)" : "28:1443(1) (28:1443(1) Rent, Lease & Ejectment)",
      "28:1444" : "28:1444 (28:1444 Petition for Removal- Foreclosure)",
      "28:1446in" : "28:1446in (28:1446 Breach of Contract- Insurance)",
      "28:1446pd" : "28:1446pd (28:1446 Petition for Removal- Property Damage (P.I.))",
      "28:1446pi" : "28:1446pi (28:1446 Petition for Removal- Personal Injury)",
      "28:1446pl" : "28:1446pl (28:1446pl Petition for Removal - Product Liability)",
      "28:1446pr" : "28:1446pr (28:1446 Petition for Removal)",
      "28:1452" : "28:1452 (28:1452 R&R re motions to remand (non-core))",
      "28:1453" : "28:1453 (28:1453 Class Action Fairness Act)",
      "28:1651" : "28:1651 (28:1651 Petition for Writ of Coram Nobis)",
      "28:1651hc" : "28:1651hc (28:1651 Petition for Writ of Habeas Corpus)",
      "28:1651mn" : "28:1651mn (28:1651 Petition for Writ of Mandamus)",
      "28:1983" : "28:1983 (28:1983 Civil Rights)",
      "28:2201" : "28:2201 (28:2201 Constitutionality of State Statute(s))",
      "28:2201dj" : "28:2201dj (28:2201 Declaratory Judgment)",
      "28:2201ij" : "28:2201ij (28:2201 Injunction)",
      "28:2201in" : "28:2201in (28:2201 Declaratory Judgment (Insurance))",
      "28:2241" : "28:2241 (28:2241 Petition for Writ of Habeas Corpus)",
      "28:2254" : "28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))",
      "28:2254se" : "28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)",
      "28:2255" : "28:2255 (28:2255 Petition for Writ of Habeas Corpus (Federal))",
      "28:2271" : "28:2271 (28:2271 Federal Tort Claims Act)",
      "28:2345" : "28:2345 (28:2345 Medicare Recovery)",
      "28:2409" : "28:2409 (28:2409(a) Quiet Title Action)",
      "28:2410" : "28:2410 (28:2410 Quiet Title)",
      "28:2671" : "28:2671 (28:2671 Federal Tort Claims Act)",
      "28:2674" : "28:2674 (28:2674 Federal Tort Claims Act)",
      "28:7402" : "28:7402 (28:7402 Refund of Taxes)",
      "28:7422" : "28:7422 (28:7422 Appeal from Administrative Decision)",
      "29:0151" : "29:0151 (29:151 Labor: Review of Agency Action)",
      "29:0160" : "29:0160 (29:160(1) National Labor Relations Act)",
      "29:0184" : "29:0184 (29:184 Violation Collection Bargain Agreement)",
      "29:0185ep" : "29:0185ep (29:185 Employee Pension Plan)",
      "29:0185lm" : "29:0185lm (29:185 Labor/Mgt. Relations (Contracts))",
      "29:0201do" : "29:0201do (29:201 Denial of Overtime Compensation)",
      "29:0201fl" : "29:0201fl (29:201 Fair Labor Standards Act)",
      "29:0203" : "29:0203 (29:203 Equal Pay Act)",
      "29:0206" : "29:0206 (29:206 Collect Unpaid Wages)",
      "29:0217" : "29:0217 (29:217 Injunction proceedings to enjoin violations of 29:215)",
      "29:0401" : "29:0401 (29:0401 Labor Management Disclosure Act)",
      "29:0621" : "29:0621 (29:621 Job Discrimination (Age))",
      "29:0623" : "29:0623 (29:623 Job Discrimination (Age))",
      "29:0626" : "29:0626 (29:626 Job Discrimination (Age))",
      "29:0633" : "29:0633 (29:633 Job Discrimination (Age))",
      "29:0651" : "29:0651 (29:651 Occupational Safety/Health)",
      "29:0754" : "29:0754 (29:754 Discrimination)",
      "29:0791" : "29:0791 (29:791 Job Discrimination (Rehabilitation Act))",
      "29:0794" : "29:0794 (29:0794 Job Discrimination (Handicap))",
      "29:1001" : "29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)",
      "29:1002" : "29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)",
      "29:1104" : "29:1104 (29:1104 Recovery of Benefits to Employee)",
      "29:1109" : "29:1109 (29:1109 Breach of Fiduciary Duties)",
      "29:1131" : "29:1131 (29:1131 ERISA - Collection of Delinquent Trust Funds)",
      "29:1132" : "29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)",
      "29:1145" : "29:1145 (29:1145 E.R.I.S.A.)",
      "29:1149" : "29:1149 (29:1149 Recover Pension & Profit Sharing)",
      "29:1337" : "29:1337 (29:1337 E.R.I.S.A.)",
      "29:1362" : "29:1362 (29:1362 ERISA)",
      "29:1381" : "29:1381 (29:1381 E.R.I.S.A.)",
      "29:1401" : "29:1401 (29:1401(b)(2) Appeal of Arbitration Award)",
      "29:1451" : "29:1451 (29:1451 E.R.I.S.A.)",
      "29:1801" : "29:1801 (29:1801 Farmworker Rights)",
      "29:2101" : "29:2101 (29:2101 Worker Adjustment and Retraining Notification Act)",
      "29:2601" : "29:2601 (29:2601 Family and Medical Leave Act of 1993)",
      "29:790" : "29:790 (29:790 Rehabilitation of Labor)",
      "30:0181" : "30:0181 (30:181 Environment: Review of Agency Action)",
      "30:0801" : "30:0801 (30:0801 Penalities/Federal Mine Safety Health Act - 1977)",
      "30:1201" : "30:1201 (30:1201 Environment: Review of Agency Action)",
      "30:1202" : "30:1202 (30:1202 Mining Reclamation Act)",
      "30:1276" : "30:1276 (30:1276 Interior: Review of Agency Action)",
      "31:3545" : "31:3545 (31:3545 Action to Recovery Money)",
      "31:3729" : "31:3729 (31:3729 False Claims Act)",
      "31:3730" : "31:3730 (31:3730 Qui Tam False Claims Act)",
      "31:3730(h)" : "31:3730(h) (31:3730(h) Whistleblower Protection Act)",
      "31:3731" : "31:3731 (31:3731 Fraud)",
      "33:1319cw" : "33:1319cw (33:1319 Clean Water Act)",
      "33:1319pv" : "33:1319pv (33:1319 Pollutants & Permit Violations)",
      "33:1365" : "33:1365 (33:1365 Environmental Matters)",
      "33:2701" : "33:2701 (33:2701 Oil Pollution Act of 1990)",
      "35:0145" : "35:0145 (35:145 Patent Infringement)",
      "35:0183" : "35:0183 (35:183 Patent Infringement)",
      "35:0271" : "35:0271 (35:271 Patent Infringement)",
      "38:1681" : "38:1681 (38:1681 Recovery of VA Overpayment)",
      "38:1686" : "38:1686 (38:1686 Recovery of VA Overpayment)",
      "38:1780" : "38:1780 (38:1780 Recovery of VA Overpayment)",
      "38:1975" : "38:1975 (38:1975 Servicemen's Group Life Insurance Act)",
      "38:2011" : "38:2011 (38:2011 - Veteran's Readjustment Assistance Act of 1974)",
      "38:3116" : "38:3116 (38:3116 VA Overpayment)",
      "38:4301" : "38:4301 (38:4301 Uniformed Services Employment and Reemployment Act)",
      "39:3005" : "39:3005 (39:3005 Detention of Mail for Temporary Periods)",
      "39:409" : "39:409 (39:409 Postal Service)",
      "40:0258" : "40:0258 (40:258(a) Public Buildings & Property: Land Condemnation)",
      "40:0270" : "40:0270 (40:270 Miller Act)",
      "40:0875" : "40:0875 (40:875 Public Buildings & Property: Negligence)",
      "40:3133" : "40:3133 (40:3133 Miller Act)",
      "41:0251" : "41:0251 (41:251 Public Contracts-Review of Agency Action)",
      "41:1463" : "41:1463 (41:1463 Public Contracts: Unlawful Employment Practices)",
      "42:0205" : "42:0205 (42:205 Denial Social Security Benefits)",
      "42:0206" : "42:0206 (42:206 Social Security Benefits)",
      "42:0247" : "42:0247 (42:247 Personal Injury-Swine Flu)",
      "42:0402" : "42:0402 (42:402 Social Security Benefits)",
      "42:0405id" : "42:0405id (42:405 Review of HHS Decision (SSID))",
      "42:0405rsi" : "42:0405rsi (42:0405g Review of HHS Decision (RSI))",
      "42:0405wc" : "42:0405wc (42:405 Review of HHS Decision (DIWC))",
      "42:0405ww" : "42:0405ww (42:405 Review of HHS Decision (DIWW))",
      "42:0415" : "42:0415 (42:415 Windfall Elimination Provision)",
      "42:0416" : "42:0416 (42:416 Denial of Social Security Benefits)",
      "42:0427" : "42:0427 (42:427 Social Security Benefits)",
      "42:0532" : "42:0532 (42:0532 Dispute in Franchise Agreement)",
      "42:0688" : "42:0688 (42:0688 Jones Act Case)",
      "42:11601" : "42:11601 (42:11601 International Child Abduction Remedies Act)",
      "42:12101" : "42:12101 (42:12101 Americans with Disabilities Act of 1990)",
      "42:12117" : "42:12117 (42:12117 Americans with Disabilities-Employment)",
      "42:12133" : "42:12133 (42:12133 Americans with Disabilities-Services)",
      "42:12188" : "42:12188 (42:12188 Americans with Disabilities-Public Accommodations)",
      "42:1383" : "42:1383 (42:1383 Review of HHS Decision)",
      "42:1395" : "42:1395 (42:1395 HHS: Adverse Reimbursement Review)",
      "42:1396" : "42:1396 (42:1396 - Tort Negligence)",
      "42:1471" : "42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclosure Sale)",
      "42:1981cv" : "42:1981cv (42:1981 Civil Rights)",
      "42:1981hs" : "42:1981hs (42:1981 Housing Discrimination)",
      "42:1981jb" : "42:1981jb (42:1981 Job Discrimination (Race))",
      "42:1981sx" : "42:1981sx (42:1981 Sex Discrimination)",
      "42:1983cv" : "42:1983cv (42:1983 Civil Rights Act)",
      "42:1983ed" : "42:1983ed (42:1983 Civil Rights (Employment Discrimination))",
      "42:1983pr" : "42:1983pr (42:1983 Prisoner Civil Rights)",
      "42:1986" : "42:1986 (42:1986 Neglect of Duty)",
      "42:2000ag" : "42:2000ag (42:2000 Job Discrimination (Age))",
      "42:2000e" : "42:2000e (42:2000e Job Discrimination (Employment))",
      "42:2000pb" : "42:2000pb (42:2000 Job Discrimination (Public Accommodations))",
      "42:2000ra" : "42:2000ra (42:2000 Job Discrimination (Race))",
      "42:2000sh" : "42:2000sh (42:2000 Job Discrimination (Sexual Harassment))",
      "42:2000sx" : "42:2000sx (42:2000 Job Discrimination (Sex))",
      "42:2003" : "42:2003 (42:2003 Job Discrimination)",
      "42:2005" : "42:2005 (42:2005 Review of Agency Action-HHS)",
      "42:2651" : "42:2651 (42:2651 Medical Care Recovery)",
      "42:3601" : "42:3601 (42:405 Fair Housing Act)",
      "42:4000" : "42:4000 (42:4000 National Flood Insurance Act)",
      "42:4001" : "42:4001 (42:4001 National Insurance Flood Act)",
      "42:4053" : "42:4053 (42:4053 Breach of Insurance Contract)",
      "42:405rsi" : "42:405rsi (42:405g Review of HHS Decision (RSI))",
      "42:4072" : "42:4072 (42:4072 Payment of Flood Insurance Claim)",
      "42:425" : "42:425 (42:427 Social Security Benenfits)",
      "42:4321" : "42:4321 (42:4321 Review of Agency Action-Environment)",
      "42:4332" : "42:4332 (42:4332 Environmental Policy - Coop of Agency Reports)",
      "42:6901en" : "42:6901en (42:6901 Environmental Cleanup Expenses)",
      "42:6901rs" : "42:6901rs (42:6901 Resource & Recovery Act)",
      "42:7413" : "42:7413 (42:7413(b) Clean Air Act)",
      "42:7604cl" : "42:7604cl (42:7604 Clear Air Act (Emission Standards))",
      "42:7604ir" : "42:7604ir (42:7604 Petition to Quash IRS Summons)",
      "42:9601" : "42:9601 (42:9601 Environmental Act (CERCLA))",
      "42:9607" : "42:9607 (42:9607 Real Property Tort to Land)",
      "43:945" : "43:945 (43:945 Compensation for Land Condemnation)",
      "43:945a" : "43:945a (43:945a Complaint in Condemnation)",
      "43:946" : "43:946 (43:946 Complaint in Condemnation - Eminent Domain)",
      "45:0051" : "45:0051 (45:51 Railways: Fed. Employer's Liability Act)",
      "45:0151" : "45:0151 (45:151 Railway Labor Act)",
      "45:0184" : "45:0184 (45:184 Action to Set Aside Award of a System Board of Adjust)",
      "45:1395" : "45:1395 (45:1395 Railroads: Adverse Reimbursement Review)",
      "45:7457" : "45:7457 (45:7457 Compel Reclamation Under Clear Air Act)",
      "46:0688" : "46:0688 (46:688 Jones Act)",
      "46:0741" : "46:0741 (46:741 Shipping)",
      "46:0761" : "46:0761 (46:761 Shipping: Damages for Death on High Seas)",
      "46:1101" : "46:1101 (46:1101 Violation of Maritime Regulations)",
      "46:1156" : "46:1156 (46:1156 Administrative Procedure Act)",
      "47:0251" : "47:0251 (47:251 Telecommunications Act of 1996)",
      "47:0277" : "47:0277 (47:0277 Telephone Consumer Protection Act)",
      "47:0542" : "47:0542 (47:0542 Dispute in Franchise Agreement)",
      "47:0553" : "47:0553 (47:0553 Unauthorized Reception of Cable/Satellite TV)",
      "47:0605" : "47:0605 (47:0605 Unauthorized Use or Publication of Communication)",
      "47:521" : "47:521 (47:521 Cable Communications Policy Act)",
      "48:0883" : "48:0883 (48:883 Violation of US Coastal Law)",
      "48:1985" : "48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)",
      "49:0081" : "49:0081 (49:81 Damaged Goods While Being Transported)",
      "49:0781" : "49:0781 (49:781 Forfeiture)",
      "49:11503" : "49:11503 (49:11503 Railroad Revitalization Regulatory Reform Act)",
      "49:11702" : "49:11702 (49:11702(a)(4) Violations of Interstate Commerce Act)",
      "49:11704" : "49:11704 (49:11704 Private Action to Enjoin Abandonment of Service)",
      "49:1471" : "49:1471 (49:1471 Federal Aviation Act)",
      "49:1903" : "49:1903 (49:1903 Petition to enforce administrative summons)",
      "49:2501" : "49:2501 (49:2501 Motor Carrier Act of 1984)",
      "50:501" : "50:501 (50:501 Servicemembers Civil Relief Act)",
      "8:287" : "8:287 (8:287 Petition to Enforce INS Subpoena)",
      "misc" : "misc (Civil Miscellaneous Case)"
   },
   "azdce" : {
      "0" : "0 (No cause code entered)",
      "02:0431" : "02:0431 (02:431 Fed. Election Commission: Failure Enforce Compliance)",
      "02:0437" : "02:0437 (02:437 Federal Election Commission)",
      "05:0075" : "05:0075 (05:75(2) Contract - Reduction in Grade)",
      "05:0551" : "05:0551 (05:551 Administrative Procedure Act)",
      "05:0552fi" : "05:0552fi (05:552 Freedom of Information Act)",
      "05:0552pa" : "05:0552pa (05:552 Right to Privacy Act)",
      "05:0554" : "05:0554 (05:0554 Constitutionality of Maritime Statutes)",
      "05:0701" : "05:0701 (05:0701 Maritime Subsidy Board)",
      "05:0702" : "05:0702 (05:702 Administrative Procedure Act)",
      "05:0704" : "05:0704 (05:704 Labor Litigation)",
      "05:7703" : "05:7703 (05:7703 Discrimination - Review of Agency Act)",
      "07:0006" : "07:0006 (7:6(b) Federal Commodity Exchange Regulation)",
      "07:0025" : "07:0025 (7:25 Fraud - Commodities Leverage Contracts)",
      "07:0181" : "07:0181 (07:181 Packers & Stockyard Act)",
      "07:0499" : "07:0499 (07:499 Agricultural Commodities Act)",
      "07:0601" : "07:0601 (07:601 USDA Condemnation)",
      "07:2321" : "07:2321 (07:2321 Plant Variety Protection Act)",
      "08:1105" : "08:1105 (8:1105(a) Aliens: Habeas Corpus to Release INS Detainee)",
      "08:1252" : "08:1252 (08:1252(a)(2) Injunction for Deportation)",
      "08:1260" : "08:1260 (08:1260 Aliens: Access to Records)",
      "08:1324" : "08:1324 (08:1324 Aliens: Complaint for Forfeiture)",
      "08:1329" : "08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petition)",
      "08:1446" : "08:1446 (8:1446 Petition for Naturalization Hearing)",
      "09:0001" : "09:0001 (09:1 U.S. Arbitration Act)",
      "09:0009" : "09:0009 (9:9 Motion to Confirm Arbitration Loan)",
      "09:0010" : "09:0010 (09:0010 Petition to Vacate Arbitration Award)",
      "10:1552" : "10:1552 (10:1552 Armed Forces: Action to Correct Records)",
      "10:1553" : "10:1553 (10:1553 Armed Forces: FOIA General)",
      "10:2305" : "10:2305 (10:2305 Review of Federal Contract)",
      "11:0101" : "11:0101 (11:101 Bankruptcy)",
      "12:0022" : "12:0022 (12:22 Securities Fraud)",
      "12:0635" : "12:0635 (12:635 Breach of Insurance Contract)",
      "12:1461" : "12:1461 (12:1461 Homeowners Loan Act)",
      "12:1703" : "12:1703 (12:1703 Default of HUD Loan)",
      "12:1725" : "12:1725 (12:1725 Collection under Contract Guaranty)",
      "12:1730" : "12:1730 (12:1730 Collection Under Contract Guaranty)",
      "12:1819" : "12:1819 (12:1819 Default of Promissory Note)",
      "12:1821" : "12:1821 (12:1821 Default of Loan by Promissary Note)",
      "12:1971" : "12:1971 (12:1971 Relief under Bank Holding Act)",
      "12:3410" : "12:3410 (12:3410 Right to Financial Privacy Act)",
      "15:0001" : "15:0001 (15:1 Antitrust Litigation)",
      "15:0002at" : "15:0002at (15:2 Antitrust Litigation)",
      "15:0002fl" : "15:0002fl (15:2(a) Fair Labor Standards Act)",
      "15:0005" : "15:0005 (15:5(a) Fair Labor Standards Act)",
      "15:0015" : "15:0015 (15:15 Antitrust Litigation)",
      "15:0025" : "15:0025 (15:25 Clayton Act)",
      "15:0044" : "15:0044 (15:44 Trademark Infringement)",
      "15:0045" : "15:0045 (15:0045 Federal Trade Commission Act)",
      "15:0052" : "15:0052 (15:0052 Federal Trade Commission Act)",
      "15:0053" : "15:0053 (15:0053 Federal Trade Commission Act)",
      "15:0077" : "15:0077 (15:77 Securities Fraud)",
      "15:0078" : "15:0078 (15:78m(a) Securities Exchange Act)",
      "15:0631" : "15:0631 (15:631 Small Business Act)",
      "15:0717" : "15:0717 (15:717 Natural Gas Act)",
      "15:1051" : "15:1051 (15:1051 Trademark Infringement)",
      "15:1114" : "15:1114 (15:1114 Trademark Infringement)",
      "15:1121" : "15:1121 (15:1121 Trademark Infringement)",
      "15:1125" : "15:1125 (15:1125 Trademark Infringement (Lanham Act))",
      "15:1126" : "15:1126 (15:1126 Patent Infringement)",
      "15:1127" : "15:1127 (15:1127 Trademark Infringement)",
      "15:1601" : "15:1601 (15:1601 Truth in Lending)",
      "15:1640" : "15:1640 (15:1640 Truth in Lending)",
      "15:1681" : "15:1681 (15:1681 Fair Credit Reporting Act)",
      "15:1692" : "15:1692 (15:1692 Fair Debt Collection Act)",
      "15:1693" : "15:1693 (15:1693 Electronic Fund Transfer Act)",
      "15:1938" : "15:1938 (15:1938 Fair Labor Standards Act)",
      "15:1981" : "15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))",
      "15:1988" : "15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))",
      "15:1989" : "15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))",
      "15:2301" : "15:2301 (15:2301 Magnuson-Moss Warranty Act)",
      "15:2801" : "15:2801 (15:2801 Petroleum Marketing Practices Act)",
      "15:53(b)" : "15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equitable Relief)",
      "16:0668" : "16:0668 (16:668 Bald Eagle Protection Act)",
      "16:0703" : "16:0703 (16:703 Migratory Bird Act)",
      "16:1538" : "16:1538 (16:1538 Endangered Species Act)",
      "16:3371" : "16:3371 (16:3371 Wildlife Under the Lacey Act)",
      "16:3372" : "16:3372 (16:3372 Conservation: Complaint for Forfeiture)",
      "16:3373" : "16:3373 (16:3373 Appeal of Decision - DOI)",
      "16:3374" : "16:3374 (16:3374 Conservation: Complaint for Forfeiture)",
      "17:0101" : "17:0101 (17:101 Copyright Infringement)",
      "17:0501" : "17:0501 (17:501 Copyright Infringement)",
      "17:0504" : "17:0504 (17:504 Copyright Infringement)",
      "18:0241" : "18:0241 (18:241 Conspiracy Against Citizen Rights)",
      "18:1030" : "18:1030 (18:1030 Computer Fraud and Abuse Act)",
      "18:1836a" : "18:1836a (18:1836(a) Injunction against Misappropriation of Trade Secrets)",
      "18:1836b" : "18:1836b (18:1836(b) Civil Action to Protect Trade Secrets)",
      "18:1961" : "18:1961 (18:1961 Racketeering (RICO) Act)",
      "18:1962" : "18:1962 (18:1962 Racketeering (RICO) Act)",
      "18:1964" : "18:1964 (18:1964 Racketeering (RICO) Act)",
      "18:2510" : "18:2510 (18:2510 Electronic Communications Privacy Act)",
      "18:4208" : "18:4208 (18:4208(B) Agency Action Review)",
      "19:1305" : "19:1305 (19:1305 Custom Duties:0Forfeiture-Immoral Articles)",
      "20:1080" : "20:1080 (20:1080 Student Loan Recovery)",
      "20:1400" : "20:1400 (20:1400 Civil Rights of Handicapped Child)",
      "20:1401" : "20:1401 (20:1401 Education: Handicapped Child Act)",
      "21:0841" : "21:0841 (21:841 Forfeiture Property-Drugs)",
      "21:0881" : "21:0881 (21:881 Forfeiture Property-Drugs)",
      "21:0881a" : "21:0881a (21:881 Forfeiture Property - Aircraft)",
      "21:0881re" : "21:0881re (21:881 Forfeiture Property - Real Estate)",
      "22:9003" : "22:9003 (22:9003 International Child Abduction Remedies Act)",
      "23:0134" : "23:0134 (23:134 P.I.- Auto Negligence)",
      "23:1441" : "23:1441 (23:1441 Contract Real Estate)",
      "24:1000" : "24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)",
      "25:0640" : "25:0640 (25:640 Indian Tribal Rights)",
      "25:1303" : "25:1303 (25:1303 Indian Habeas Corpus)",
      "25:1901" : "25:1901 (25:1901 Indian Child Welfare Act)",
      "26:6212" : "26:6212 (26:6212 Injunctive Relief from IRS Lien)",
      "26:6213" : "26:6213 (26:6213 Injunctive Relief from IRS Lien)",
      "26:6502" : "26:6502 (26:6502 IRS:Enforcement of tax liens)",
      "26:6532" : "26:6532 (26:6532 IRS: Refund of Tax Penalty)",
      "26:6702" : "26:6702 (26:6702 IRS: Refund of Income Tax Penalty)",
      "26:6703" : "26:6703 (26:6703 IRS: Refund of Tax Penalty)",
      "26:7401" : "26:7401 (26:7401 IRS: Tax Liability)",
      "26:7402" : "26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)",
      "26:7403" : "26:7403 (26:7403 Suit to Enforce Federal Tax Lien)",
      "26:7422rt" : "26:7422rt (26:7422 IRS: Refund Taxes)",
      "26:7422rx" : "26:7422rx (26:7422 IRS: Refund Excise Tax)",
      "26:7426" : "26:7426 (26:7426 IRS: Wrongful Levy for Taxes)",
      "26:7429" : "26:7429 (26:7429 IRS: Tax Jeopardy Assessment)",
      "26:7609" : "26:7609 (26:7609 IRS: Petition to Quash IRS Summons)",
      "27:0185" : "27:0185 (27:185 Enforcement of Arbitration Award)",
      "28:0157c" : "28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)",
      "28:0157d" : "28:0157d (28:0157 Motion for Withdrawal of Reference)",
      "28:0158" : "28:0158 (28:0158 Notice of Appeal re Bankruptcy Matter (BAP))",
      "28:0185" : "28:0185 (28:185 Suit to Compel Arbitration)",
      "28:0451" : "28:0451 (28:451 Employment Discrimination)",
      "28:0794" : "28:0794 (28:794 Rehabilitation Act)",
      "28:1001" : "28:1001 (28:1001 E.R.I.S.A.)",
      "28:1132" : "28:1132 (28:1132 E.R.I.S.A.)",
      "28:1330" : "28:1330 (28:1330 Breach of Contract)",
      "28:1331" : "28:1331 (28:1331 Fed. Question)",
      "28:1331al" : "28:1331al (28:1331 Fed. Question: Airline Crash)",
      "28:1331at" : "28:1331at (28:1331 Fed. Question: Anti-trust)",
      "28:1331au" : "28:1331au (28:1331 Fed. Question: Auto Negligence)",
      "28:1331b" : "28:1331b (28:1331 Federal Question: Bivens Act)",
      "28:1331bc" : "28:1331bc (28:1331 Fed. Question: Breach of Contract)",
      "28:1331ca" : "28:1331ca (28:1331 Fed Question: Fed Communications Act of 1934)",
      "28:1331cm" : "28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)",
      "28:1331cv" : "28:1331cv (28:1331 Federal Question: Other Civil Rights)",
      "28:1331ed" : "28:1331ed (28:1331 Fed. Question: Employment Discrimination)",
      "28:1331es" : "28:1331es (28:1331 Enforcement of Administrative Subpoena)",
      "28:1331fl" : "28:1331fl (28:1331 Fed. Question: Fair Labor Standards)",
      "28:1331in" : "28:1331in (28:1331 Fed. Question: Insurance Contract)",
      "28:1331mm" : "28:1331mm (28:1331 Fed. Question: Medical Malpractice)",
      "28:1331pi" : "28:1331pi (28:1331 Fed. Question: Personal Injury)",
      "28:1331rd" : "28:1331rd (28:1331 Fed. Question: Review Agency Decision)",
      "28:1331rp" : "28:1331rp (28:1331(a) Fed. Question: Real Property)",
      "28:1331rr" : "28:1331rr (28:1331 Fed. Question: Railway Labor Act)",
      "28:1331sv" : "28:1331sv (28:1331 Fed. Question: Securities Violation)",
      "28:1331tr" : "28:1331tr (28:1331 Fed. Question: Trademark)",
      "28:1331tt" : "28:1331tt (28:1331 Fed. Question: Tort Action)",
      "28:1331v" : "28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendment)",
      "28:1331wl" : "28:1331wl (28:1331 Federal Question: EPA Waste Lien)",
      "28:1331wt" : "28:1331wt (28:1331 Fed. Question: Water Rights)",
      "28:1332ac" : "28:1332ac (28:1332 Diversity-Account Receivable)",
      "28:1332al" : "28:1332al (28:1332 Diversity-Airline Crash)",
      "28:1332as" : "28:1332as (28:1332 Diversity-Asbestos Litigation)",
      "28:1332au" : "28:1332au (28:1332 Diversity-Auto Negligence)",
      "28:1332bc" : "28:1332bc (28:1332 Diversity-Breach of Contract)",
      "28:1332co" : "28:1332co (28:1332 Diversity-Conversion)",
      "28:1332ct" : "28:1332ct (28:1332 Diversity-Citizenship)",
      "28:1332det" : "28:1332det (28:1332 Diversity: Forcible Detainer)",
      "28:1332df" : "28:1332df (28:1332 Diversity-Contract Default)",
      "28:1332ds" : "28:1332ds (28:1332 Diversity-Contract Dispute)",
      "28:1332ed" : "28:1332ed (28:1332 Diversity-Employment Discrimination)",
      "28:1332fd" : "28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)",
      "28:1332fr" : "28:1332fr (28:1332 Diversity-Fraud)",
      "28:1332ia" : "28:1332ia (28:1332 Diversity-Interpleader Action)",
      "28:1332ij" : "28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)",
      "28:1332in" : "28:1332in (28:1332 Diversity-Insurance Contract)",
      "28:1332jd" : "28:1332jd (28:1332 Diversity-Declaratory Judgment)",
      "28:1332lb" : "28:1332lb (28:1332 Diversity-Libel,Assault,Slander)",
      "28:1332lm" : "28:1332lm (28:1332 Diversity - Legal Malpractice)",
      "28:1332ma" : "28:1332ma (28:1332 Diversity-Miller Act)",
      "28:1332mm" : "28:1332mm (28:1332 Diversity-Medical Malpractice)",
      "28:1332mv" : "28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)",
      "28:1332ni" : "28:1332ni (28:1332 Diversity-Negotiable Instrument)",
      "28:1332nm" : "28:1332nm (28:1332 Diversity-Non-Motor Vehicle)",
      "28:1332oc" : "28:1332oc (28:1332 Diversity-Other Contract)",
      "28:1332pd" : "28:1332pd (28:1332 Diversity-Property Damage)",
      "28:1332pi" : "28:1332pi (28:1332 Diversity-Personal Injury)",
      "28:1332pl" : "28:1332pl (28:1332 Diversity-Product Liability)",
      "28:1332pr" : "28:1332pr (28:1332 Diversity-Petition for Removal)",
      "28:1332qt" : "28:1332qt (28:1332 Diversity-Petition to Quiet Title)",
      "28:1332ri" : "28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)",
      "28:1332sa" : "28:1332sa (28:1332 - Diversity: Securities & Exchange Commission Act)",
      "28:1332sf" : "28:1332sf (28:1332 - Diversity: Securities Fraud)",
      "28:1332ss" : "28:1332ss (28:1332 Diversity - Stockholders Suits)",
      "28:1332tl" : "28:1332tl (28:1332 Diversity-Torts to Land)",
      "28:1332tm" : "28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))",
      "28:1332tn" : "28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)",
      "28:1332wd" : "28:1332wd (28:1332 Diversity-Wrongful Death)",
      "28:1333" : "28:1333 (28:1333 Admiralty)",
      "28:1334" : "28:1334 (28:1334 Bankruptcy Appeal)",
      "28:1334c" : "28:1334c (28:1334(c) R&R re motions for abstention (non-core))",
      "28:1335" : "28:1335 (28:1335 Interpleader Action)",
      "28:1337" : "28:1337 (28:1337 Sherman-Clayton Act)",
      "28:1338cp" : "28:1338cp (28:1338 Copyright Infringement)",
      "28:1338pt" : "28:1338pt (28:1338 Patent Infringement)",
      "28:1338tr" : "28:1338tr (28:1338 Trademark Infringement)",
      "28:1340" : "28:1340 (28:1340 IRS: Custom Duties)",
      "28:1340er" : "28:1340er (28:1340 Recovery of Erroneous Refund)",
      "28:1341" : "28:1341 (28:1341 Complaint for Forfeiture)",
      "28:1343" : "28:1343 (28:1343 Violation of Civil Rights)",
      "28:1345co" : "28:1345co (28:1345 Replevin & Conversion)",
      "28:1345db" : "28:1345db (28:1345 Debt to US - FHA/HUD Title I)",
      "28:1345df" : "28:1345df (28:1345 Default of Promissory Note)",
      "28:1345er" : "28:1345er (28:1345 Recovery of Erroneous Refund)",
      "28:1345fc" : "28:1345fc (28:1345 Foreclosure)",
      "28:1345ff" : "28:1345ff (28:1345 Complaint for Forfeiture)",
      "28:1345hl" : "28:1345hl (28:1345 VA Home Loan Guaranty Debt)",
      "28:1345mc" : "28:1345mc (28:1345 Medical Care Recovery)",
      "28:1345mi" : "28:1345mi (28:1345 Mining Claim Ejectment)",
      "28:1345pd" : "28:1345pd (28:1345 Property Damage)",
      "28:1345pe" : "28:1345pe (28:1345 Property Ejectment)",
      "28:1345rc" : "28:1345rc (28:1345 Recovery of Debt to US)",
      "28:1345st" : "28:1345st (28:1345 Default of Student Loan)",
      "28:1345tp" : "28:1345tp (28:1345 Trespass on Public Land)",
      "28:1345va" : "28:1345va (28:1345 Recovery of VA Overpayment)",
      "28:1346bc" : "28:1346bc (28:1346 Breach of Contract)",
      "28:1346rc" : "28:1346rc (28:1346 Recovery of IRS Tax)",
      "28:1346tc" : "28:1346tc (28:1346 Tort Claim)",
      "28:1346wd" : "28:1346wd (28:1346 Wrongful Death)",
      "28:1352" : "28:1352 (28:1352 Miller Act)",
      "28:1355" : "28:1355 (28:1355 Petition for Return of Property)",
      "28:1358" : "28:1358 (28:1358 Land Condemnation)",
      "28:1361" : "28:1361 (28:1361 Petition for Writ of Mandamus)",
      "28:1362ic" : "28:1362ic (28:1362 Indian Tribal Controversy)",
      "28:1362iw" : "28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)",
      "28:1364" : "28:1364 (28:1364 Auto Negligence)",
      "28:1391" : "28:1391 (28:1391 Personal Injury)",
      "28:1402" : "28:1402 (28:1402 Medical Malpractice)",
      "28:1407" : "28:1407 (28:1407 Airline Crash)",
      "28:1441ac" : "28:1441ac (28:1441 Petition for Removal- Account Receivable)",
      "28:1441al" : "28:1441al (28:1441 Petition for Removal- Airline Crash)",
      "28:1441as" : "28:1441as (28:1441 Petition for Removal- Asbestos Litigation)",
      "28:1441au" : "28:1441au (28:1441 Petition for Removal- Auto Negligence)",
      "28:1441bc" : "28:1441bc (28:1441 Petition for Removal- Breach of Contract)",
      "28:1441cv" : "28:1441cv (28:1441 Petition for Removal- Civil Rights Act)",
      "28:1441df" : "28:1441df (28:1441 Petition for Removal- Contract Default)",
      "28:1441dj" : "28:1441dj (28:1441 Petition for Removal- Declaratory Judgement)",
      "28:1441ds" : "28:1441ds (28:1441 Petition for Removal- Contract Dispute)",
      "28:1441ed" : "28:1441ed (28:1441 Petition for Removal - Employment Discrimination)",
      "28:1441fc" : "28:1441fc (28:1441 Petition for Removal - Fair Credit Reporting Act)",
      "28:1441fr" : "28:1441fr (28:1441 Petition for Removal- Fraud)",
      "28:1441ij" : "28:1441ij (28:1441 Petition for Removal- Injunctive/Declaratory Relief)",
      "28:1441in" : "28:1441in (28:1441 Petition for Removal- Insurance Contract)",
      "28:1441int" : "28:1441int (28:1441 Petition for Removal- Action for Interpleader)",
      "28:1441lb" : "28:1441lb (28:1441 Petition for Removal Libel,Assault,Slander)",
      "28:1441lm" : "28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relations)",
      "28:1441mm" : "28:1441mm (28:1441 Petition for Removal- Medical Malpractice)",
      "28:1441ni" : "28:1441ni (28:1441 Petition for Removal- Negotiable Instrument)",
      "28:1441nm" : "28:1441nm (28:1441 Petition for Removal- Non-Motor Vehicle)",
      "28:1441oc" : "28:1441oc (28:1441 Petition For Removal--Other Contract)",
      "28:1441pd" : "28:1441pd (28:1441 Petition for Removal- Property Damage)",
      "28:1441pi" : "28:1441pi (28:1441 Petition for Removal- Personal Injury)",
      "28:1441pl" : "28:1441pl (28:1441 Petition for Removal- Product Liability)",
      "28:1441pr" : "28:1441pr (28:1441 Petition for Removal)",
      "28:1441qt" : "28:1441qt (28:1441 Petition for Removal- Petition to Quiet Title)",
      "28:1441ri" : "28:1441ri (28:1441 Petition for Removal- Racketeering (RICO))",
      "28:1441sa" : "28:1441sa (28:1441 - Petition for Removal: SEC Act)",
      "28:1441sf" : "28:1441sf (28:1441 - Petition for Removal: Securities Fraud)",
      "28:1441tl" : "28:1441tl (28:1441 Petition for Removal- Torts to Land)",
      "28:1441tm" : "28:1441tm (28:1441 Petition for Removal- Tort/Motor Vehicle (P.I.))",
      "28:1441tn" : "28:1441tn (28:1441 Petition for Removal- Tort/Non-Motor Vehicle)",
      "28:1441wd" : "28:1441wd (28:1441 Petition for Removal- Wrongful Death)",
      "28:1442bc" : "28:1442bc (28:1442 Petition for Removal- Breach of Contract)",
      "28:1442pr" : "28:1442pr (28:1442 Petition for Removal)",
      "28:1443" : "28:1443 (28:1443(1) Rent, Lease & Ejectment)",
      "28:1444" : "28:1444 (28:1444 Petition for Removal- Foreclosure)",
      "28:1446in" : "28:1446in (28:1446 Petition for Removal - Breach of Contract - Insurance)",
      "28:1446pd" : "28:1446pd (28:1446 Petition for Removal- Property Damage (P.I.))",
      "28:1446pi" : "28:1446pi (28:1446 Petition for Removal- Personal Injury)",
      "28:1446pl" : "28:1446pl (28:1446pl Petition for Removal - Product Liability)",
      "28:1446pr" : "28:1446pr (28:1446 Petition for Removal)",
      "28:1452" : "28:1452 (28:1452 R&R re motions to remand (non-core))",
      "28:1651" : "28:1651 (28:1651 Petition for Writ of Coram Nobis)",
      "28:1651hc" : "28:1651hc (28:1651 Petition for Writ of Habeas Corpus)",
      "28:1651mn" : "28:1651mn (28:1651 Petition for Writ of Mandamus)",
      "28:1983" : "28:1983 (28:1983 Civil Rights)",
      "28:2201" : "28:2201 (28:2201 Constitutionality of State Statute(s))",
      "28:2201dj" : "28:2201dj (28:2201 Declaratory Judgment)",
      "28:2201ij" : "28:2201ij (28:2201 Injunction)",
      "28:2201in" : "28:2201in (28:2201 Declaratory Judgment (Insurance))",
      "28:2241" : "28:2241 (28:2241 Petition for Writ of Habeas Corpus (Federal))",
      "28:2254" : "28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))",
      "28:2254se" : "28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)",
      "28:2255" : "28:2255 (28:2255 Motion to Vacate / Correct Illegal Sentence)",
      "28:2271" : "28:2271 (28:2271 Federal Tort Claims Act)",
      "28:2345" : "28:2345 (28:2345 Medicare Recovery)",
      "28:2409" : "28:2409 (28:2409(a) Quiet Title Action)",
      "28:2410" : "28:2410 (28:2410 Quiet Title)",
      "28:2671" : "28:2671 (28:2671 Federal Tort Claims Act)",
      "28:2674" : "28:2674 (28:2674 Federal Tort Claims Act)",
      "28:7402" : "28:7402 (28:7402 Refund of Taxes)",
      "28:7422" : "28:7422 (28:7422 Appeal from Administrative Decision)",
      "29:0151" : "29:0151 (29:151 Labor: Review of Agency Action)",
      "29:0160" : "29:0160 (29:160(1) National Labor Relations Act)",
      "29:0184" : "29:0184 (29:184 Violation Collection Bargain Agreement)",
      "29:0185ep" : "29:0185ep (29:185 Employee Pension Plan)",
      "29:0185lm" : "29:0185lm (29:185 Labor/Mgt. Relations (Contracts))",
      "29:0201do" : "29:0201do (29:201 Denial of Overtime Compensation)",
      "29:0201fl" : "29:0201fl (29:201 Fair Labor Standards Act)",
      "29:0203" : "29:0203 (29:203 Equal Pay Act)",
      "29:0206" : "29:0206 (29:206 Collect Unpaid Wages)",
      "29:0401" : "29:0401 (29:0401 Labor Management Disclosure Act)",
      "29:0621" : "29:0621 (29:621 Job Discrimination (Age))",
      "29:0623" : "29:0623 (29:623 Job Discrimination (Age))",
      "29:0626" : "29:0626 (29:626 Job Discrimination (Age))",
      "29:0633" : "29:0633 (29:633 Job Discrimination (Age))",
      "29:0651" : "29:0651 (29:651 Occupational Safety/Health)",
      "29:0754" : "29:0754 (29:754 Discrimination)",
      "29:0791" : "29:0791 (29:791 Job Discrimination (Rehabilitation Act))",
      "29:0794" : "29:0794 (29:0794 Job Discrimination (Handicap))",
      "29:1001" : "29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)",
      "29:1002" : "29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)",
      "29:1104" : "29:1104 (29:1104 Recovery of Benefits to Employee)",
      "29:1109" : "29:1109 (29:1109 Breach of Fiduciary Duties)",
      "29:1131" : "29:1131 (29:1131 ERISA - Collection of Delinquent Trust Funds)",
      "29:1132" : "29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)",
      "29:1145" : "29:1145 (29:1145 E.R.I.S.A.)",
      "29:1149" : "29:1149 (29:1149 Recover Pension & Profit Sharing)",
      "29:1337" : "29:1337 (29:1337 E.R.I.S.A.)",
      "29:1362" : "29:1362 (29:1362 ERISA)",
      "29:1381" : "29:1381 (29:1381 E.R.I.S.A.)",
      "29:1401" : "29:1401 (29:1401(b)(2) Appeal of Arbitration Award)",
      "29:1451" : "29:1451 (29:1451 E.R.I.S.A.)",
      "29:1801" : "29:1801 (29:1801 Farmworker Rights)",
      "29:2601" : "29:2601 (29:2601 FMLA: Family and Medical Leave Act (Findings and Purposes))",
      "29:2617" : "29:2617 (29:2617 FMLA: Enforcement)",
      "29:790" : "29:790 (29:790 Rehabilitation of Labor)",
      "30:0181" : "30:0181 (30:181 Environment: Review of Agency Action)",
      "30:0801" : "30:0801 (30:0801 Penalities/Federal Mine Safety Health Act)",
      "30:1201" : "30:1201 (30:1201 Environment: Review of Agency Action)",
      "30:1202" : "30:1202 (30:1202 Mining Reclamation Act)",
      "30:1276" : "30:1276 (30:1276 Interior: Review of Agency Action)",
      "31:3545" : "31:3545 (31:3545 Action to Recovery Money)",
      "31:3729" : "31:3729 (31:3729 False Claims Act)",
      "31:3730" : "31:3730 (31:3730 Qui Tam False Claims Act)",
      "31:3731" : "31:3731 (31:3731 Fraud)",
      "31:5317" : "31:5317 (Search and forfeiture of monetary instruments)",
      "31:5332" : "31:5332 (Bulk cash smuggling into or out of the United States)",
      "33:1319cw" : "33:1319cw (33:1319 Clean Water Act)",
      "33:1319pv" : "33:1319pv (33:1319 Pollutants & Permit Violations)",
      "33:1365" : "33:1365 (33:1365 Environmental Matters)",
      "35:0145" : "35:0145 (35:145 Patent Infringement)",
      "35:0183" : "35:0183 (35:183 Patent Infringement)",
      "35:0271" : "35:0271 (35:271 Patent Infringement)",
      "38:1681" : "38:1681 (38:1681 Recovery of VA Overpayment)",
      "38:1686" : "38:1686 (38:1686 Recovery of VA Overpayment)",
      "38:1780" : "38:1780 (38:1780 Recovery of VA Overpayment)",
      "38:2011" : "38:2011 (38:2011 - Veteran's Readjustment Assistance Act of 1974)",
      "38:3116" : "38:3116 (38:3116 VA Overpayment)",
      "38:4323" : "38:4323 (38:4323 Uniformed Services Employment and Reemployment Rights Act)",
      "39:3005" : "39:3005 (39:3005 Detention of Mail for Temporary Periods)",
      "39:409" : "39:409 (39:409 Postal Service)",
      "40:0258" : "40:0258 (40:258(a) Public Buildings & Property: Land Condemnation)",
      "40:0270" : "40:0270 (40:270 Miller Act)",
      "40:0875" : "40:0875 (40:875 Public Buildings & Property: Negligence)",
      "40:3131" : "40:3131 (40:3131 Miller Act)",
      "41:0251" : "41:0251 (41:251 Public Contracts-Review of Agency Action)",
      "41:1463" : "41:1463 (41:1463 Public Contracts: Unlawful Employment Practices)",
      "42:0205" : "42:0205 (42:205 Denial Social Security Benefits)",
      "42:0206" : "42:0206 (42:206 Social Security Benefits)",
      "42:0247" : "42:0247 (42:247 Personal Injury-Swine Flu)",
      "42:0402" : "42:0402 (42:402 Social Security Benefits)",
      "42:0405id" : "42:0405id (42:405 Review of HHS Decision (SSID))",
      "42:0405wc" : "42:0405wc (42:405 Review of HHS Decision (DIWC))",
      "42:0405ww" : "42:0405ww (42:405 Review of HHS Decision (DIWW))",
      "42:0416" : "42:0416 (42:416 Denial of Social Security Benefits)",
      "42:0427" : "42:0427 (42:427 Social Security Benefits)",
      "42:11601" : "42:11601 (42:11601 International Child Abduction Remedies Act)",
      "42:12101" : "42:12101 (42:12101 Americans with Disabilities Act)",
      "42:12181" : "42:12181 (42:12181 Americans with Disabilities Act)",
      "42:1383" : "42:1383 (42:1383 Review of HHS Decision)",
      "42:1395" : "42:1395 (42:1395 HHS: Adverse Reimbursement Review)",
      "42:1396" : "42:1396 (42:1396 - Tort Negligence)",
      "42:1471" : "42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclosure Sale)",
      "42:1981cv" : "42:1981cv (42:1981 Civil Rights)",
      "42:1981hs" : "42:1981hs (42:1981 Housing Discrimination)",
      "42:1981jb" : "42:1981jb (42:1981 Job Discrimination (Race))",
      "42:1981sx" : "42:1981sx (42:1981 Sex Discrimination)",
      "42:1983cv" : "42:1983cv (42:1983 Civil Rights Act)",
      "42:1983ed" : "42:1983ed (42:1983 Civil Rights (Employment Discrimination))",
      "42:1983pr" : "42:1983pr (42:1983 Prisoner Civil Rights)",
      "42:1986" : "42:1986 (42:1986 Neglect of Duty)",
      "42:2000ag" : "42:2000ag (42:2000 Job Discrimination (Age))",
      "42:2000e" : "42:2000e (42:2000e Job Discrimination (Employment))",
      "42:2000pb" : "42:2000pb (42:2000 Job Discrimination (Public Accomodations))",
      "42:2000ra" : "42:2000ra (42:2000 Job Discrimination (Race))",
      "42:2000sx" : "42:2000sx (42:2000 Job Discrimination (Sex))",
      "42:2003" : "42:2003 (42:2003 Job Discrimination)",
      "42:2005" : "42:2005 (42:2005 Review of Agency Action-HHS)",
      "42:2651" : "42:2651 (42:2651 Medical Care Recovery)",
      "42:3601" : "42:3601 (42:405 Fair Housing Act)",
      "42:4000" : "42:4000 (42:4000 National Flood Insurance Act)",
      "42:4001" : "42:4001 (42:4001 National Insurance Flood Act)",
      "42:4053" : "42:4053 (42:4053 Breach of Insurance Contract)",
      "42:4072" : "42:4072 (42:4072 Payment of Flood Insurance Claim)",
      "42:4321" : "42:4321 (42:4321 Review of Agency Action-Environment)",
      "42:4332" : "42:4332 (42:4332 Environmental Policy - Coop of Agency Reports)",
      "42:6901en" : "42:6901en (42:6901 Environmental Cleanup Expenses)",
      "42:6901rs" : "42:6901rs (42:6901 Resource & Recovery Act)",
      "42:7413" : "42:7413 (42:7413(b) Clean Air Act)",
      "42:7604cl" : "42:7604cl (42:7604 Clear Air Act (Emission Standards))",
      "42:7604ir" : "42:7604ir (42:7604 Petition to Quash IRS Summons)",
      "42:9607" : "42:9607 (42:9607 Real Property Tort to Land)",
      "43:945" : "43:945 (43:945 Compensation for Land Condemnation)",
      "43:945a" : "43:945a (43:945a Complaint in Condemnation)",
      "43:946" : "43:946 (43:946 Complaint in Condemnation - Eminent Domain)",
      "45:0051" : "45:0051 (45:51 Railways: Fed. Employer's Liability Act)",
      "45:0151" : "45:0151 (45:151 Railway Labor Act)",
      "45:0184" : "45:0184 (45:184 Action to Set Aside Award of a System Board)",
      "45:1395" : "45:1395 (45:1395 Railroads: Adverse Reimbursement Review)",
      "45:7457" : "45:7457 (45:7457 Compel Reclamation Under Clear Air Act)",
      "46:0688" : "46:0688 (46:688 Jones Act)",
      "46:0741" : "46:0741 (46:741 Shipping)",
      "46:0761" : "46:0761 (46:761 Shipping: Damages for Death on High Seas)",
      "46:1101" : "46:1101 (46:1101 Violation of Maritime Regulations)",
      "46:1156" : "46:1156 (46:1156 Administrative Procedure Act)",
      "47:0227" : "47:0227 (47:227 Telephone Consumer Protection Act)",
      "47:0605" : "47:0605 (47:0605 Communications Act of 1934)",
      "48:0883" : "48:0883 (48:883 Violation of US Coastal Law)",
      "48:1985" : "48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)",
      "49:0081" : "49:0081 (49:81 Damaged Goods While Being Transported)",
      "49:0781" : "49:0781 (49:781 Forfeiture)",
      "49:11503" : "49:11503 (49:11503 Railroad Revitalization Regulatory Reform)",
      "49:11702" : "49:11702 (49:11702(a)(4) Violations of Interstate Commerce Act)",
      "49:14706" : "49:14706 (49:14706 Carmack Amendment to the Interstate Commerce Act)",
      "49:1471" : "49:1471 (49:1471 Federal Aviation Act)",
      "49:1903" : "49:1903 (49:1903 Petition to enforce administrative summon)",
      "49:32710" : "49:32710 (49:32710 Federal Odometer Act)",
      "8:287" : "8:287 (8:287 Petition to Enforce INS Subpoena)",
      "misc" : "misc (Civil Miscellaneous Case)"
   },
   "cacdce" : {
      "0" : "0 (00:0000 Cause Code Unknown)",
      "00:0000" : "00:0000 (00:0000 Cause Code Unknown)",
      "02:0431" : "02:0431 (02:431 Fed. Election Commission: Failure Enforce Compliance)",
      "02:0437" : "02:0437 (02:437 Federal Election Commission)",
      "05:0075" : "05:0075 (05:75(2) Contract - Reduction in Grade)",
      "05:0551" : "05:0551 (05:551 Administrative Procedure Act)",
      "05:0552fi" : "05:0552fi (05:552 Freedom of Information Act)",
      "05:0552pa" : "05:0552pa (05:552 Right to Privacy Act)",
      "05:0554" : "05:0554 (05:0554 Constitutionality of Maritime Statutes)",
      "05:0701" : "05:0701 (05:0701 Maritime Subsidy Board)",
      "05:0702" : "05:0702 (05:702 Administrative Procedure Act)",
      "05:0704" : "05:0704 (05:704 Labor Litigation)",
      "05:7703" : "05:7703 (05:7703 Discrimination - Review of Agency Act)",
      "07:0006" : "07:0006 (7:0006(b) Federal Commodity Exchange Regulation)",
      "07:0025" : "07:0025 (07:0025 Fraud - Commodities Leverage Contracts)",
      "07:0181" : "07:0181 (07:0181 Packers & Stockyard Act)",
      "07:0499" : "07:0499 (07:499 Agricultural Commodities Act)",
      "07:0601" : "07:0601 (07:0601 USDA Condemnation)",
      "07:2321" : "07:2321 (07:2321 Plant Variety Protection Act)",
      "08:0287" : "08:0287 (08:0287 Petition To Enforce INS Subpoena)",
      "08:1105" : "08:1105 (08:1105(a) Aliens: Habeas Corpus to Release INS Detainee)",
      "08:1252" : "08:1252 (08:1252(a)(2) Injunction for Deportation)",
      "08:1260" : "08:1260 (08:1260 Aliens: Access to Records)",
      "08:1324" : "08:1324 (08:1324 Aliens: Complaint for Forfeiture)",
      "08:1329" : "08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petition)",
      "08:1446" : "08:1446 (08:1446 Application for Naturalization Hearing)",
      "08:1447" : "08:1447 (08:1447 Denial of Application for Naturalization Hearing)",
      "08:1451" : "08:1451 (08:1451(a) Revoke Citizenship)",
      "09:0001" : "09:0001 (09:0001 U.S. Arbitration Act)",
      "09:0009" : "09:0009 (09:0009 Petition to Confirm Arbitration Award)",
      "09:0010" : "09:0010 (09:0010 Petition to Vacate Arbitration Award)",
      "10:1552" : "10:1552 (10:1552 Armed Forces: Action to Correct Records)",
      "10:1553" : "10:1553 (10:1553 Armed Forces: FOIA General)",
      "10:2305" : "10:2305 (10:2305 Review of Federal Contract)",
      "11:0101" : "11:0101 (11:0101 Bankruptcy)",
      "11:0523" : "11:0523 (11:0523 Dischargeable Debt)",
      "12:0022" : "12:0022 (12:22 Securities Fraud)",
      "12:0635" : "12:0635 (12:0635 Breach of Insurance Contract)",
      "12:1345" : "12:1345 (12:1345 Default on Promissory Note - FDIC Receiver)",
      "12:1452" : "12:1452 (12:1452(f) Federal Home Loan Mortgage: Investments)",
      "12:1452f" : "12:1452f (12:1452(f) Federal Home Loan Mortgage: Investments)",
      "12:1461" : "12:1461 (12:1461 Homeowners Loan Act)",
      "12:1703" : "12:1703 (12:1703 Default of HUD Loan)",
      "12:1725" : "12:1725 (12:1725 Collection under Contract Guaranty)",
      "12:1730" : "12:1730 (12:1730 Collection Under Contract Guaranty)",
      "12:1811" : "12:1811 (12:1811 Recovery & Enforcement Act (FIRREA))",
      "12:1818" : "12:1818 (12:1818 FDIC)",
      "12:1819" : "12:1819 (12:1819 Default of Promissory Note)",
      "12:1821" : "12:1821 (12:1821 Default of Loan by Promissary Note)",
      "12:1904" : "12:1904 (12:1904 Credit Controls)",
      "12:1971" : "12:1971 (12:1971 Relief under Bank Holding Act)",
      "12:3410" : "12:3410 (12:3410 Right to Financial Privacy Act)",
      "15:0001" : "15:0001 (15:0001 Antitrust Litigation)",
      "15:0002at" : "15:0002at (15:0002 Antitrust Litigation)",
      "15:0002fl" : "15:0002fl (15:0002(a) Fair Labor Standards Act)",
      "15:0005" : "15:0005 (15:5(a) Fair Labor Standards Act)",
      "15:0015" : "15:0015 (15:15 Antitrust Litigation)",
      "15:0025" : "15:0025 (15:25 Clayton Act)",
      "15:0044" : "15:0044 (15:44 Trademark Infringement)",
      "15:0045" : "15:0045 (15:0045 Federal Trade Commission Act)",
      "15:0052" : "15:0052 (15:0052 Federal Trade Commission Act)",
      "15:0053" : "15:0053 (15:0053 Federal Trade Commission Act)",
      "15:0053b" : "15:0053b (15:0053(b) Prelim & Perm Inj Relief & Other Equitable Rel)",
      "15:0077" : "15:0077 (15:77 Securities Fraud)",
      "15:0078" : "15:0078 (15:78m(a) Securities Exchange Act)",
      "15:0631" : "15:0631 (15:631 Small Business Act)",
      "15:0717" : "15:0717 (15:717 Natural Gas Act)",
      "15:1051" : "15:1051 (15:1051 Trademark Infringement)",
      "15:1114" : "15:1114 (15:1114 Trademark Infringement)",
      "15:1121" : "15:1121 (15:1121 Trademark Infringement)",
      "15:1125" : "15:1125 (15:1125 Trademark Infringement (Lanham Act))",
      "15:1126" : "15:1126 (15:1126 Patent Infringement)",
      "15:1127" : "15:1127 (15:1127 Trademark Infringement)",
      "15:1601" : "15:1601 (15:1601 Truth in Lending)",
      "15:1640" : "15:1640 (15:1640 Truth in Lending)",
      "15:1681" : "15:1681 (15:1681 Fair Credit Reporting Act)",
      "15:1692" : "15:1692 (15:1692 Fair Debt Collection Act)",
      "15:1938" : "15:1938 (15:1938 Fair Labor Standards Act)",
      "15:1981" : "15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))",
      "15:1988" : "15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))",
      "15:1989" : "15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))",
      "15:2301" : "15:2301 (15:2301 Magnuson-Moss Warranty Act)",
      "15:2801" : "15:2801 (15:2801 Petroleum Marketing Practices Act)",
      "15:53(b)" : "15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equitable Relief)",
      "16:0668" : "16:0668 (16:668 Bald Eagle Protection Act)",
      "16:0703" : "16:0703 (16:703 Migratory Bird Act)",
      "16:1538" : "16:1538 (16:1538 Endangered Species Act)",
      "16:3371" : "16:3371 (16:3371 Wildlife Under the Lacey Act)",
      "16:3372" : "16:3372 (16:3372 Conservation: Complaint for Forfeiture)",
      "16:3373" : "16:3373 (16:3373 Appeal of Decision - DOI)",
      "16:3374" : "16:3374 (16:3374 Conservation: Complaint for Forfeiture)",
      "17:0101" : "17:0101 (17:101 Copyright Infringement)",
      "17:0106" : "17:0106 (17:0106 Motion Pictures & Other Audiovisual Works)",
      "17:0501" : "17:0501 (17:501 Copyright Infringement)",
      "17:0504" : "17:0504 (17:504 Copyright Infringement)",
      "18:0241" : "18:0241 (18:241 Conspiracy Against Citizen Rights)",
      "18:0981" : "18:0981 (18:0981 Civil Forfeiture)",
      "18:0982" : "18:0982 (18:0982 Criminal Forfeiture)",
      "18:1836a" : "18:1836a (18:1836(a) Injunction against Misappropriation of Trade Secrets)",
      "18:1836b" : "18:1836b (18:1836(b) Civil Action to Protect Trade Secrets)",
      "18:1961" : "18:1961 (18:1961 Racketeering (RICO) Act)",
      "18:1962" : "18:1962 (18:1962 Racketeering (RICO) Act)",
      "18:1964" : "18:1964 (18:1964 Racketeering (RICO) Act)",
      "18:2510" : "18:2510 (18:2510 Wire Interception)",
      "18:3184" : "18:3184 (18:3184 Extradition)",
      "18:4108" : "18:4108 (18:4108 Prisoner Exchanges)",
      "18:4208" : "18:4208 (18:4208(B) Agency Action Review)",
      "18:923f3" : "18:923f3 (18:0923(f)(3) Firearms Licensing)",
      "19:1305" : "19:1305 (19:1305 Custom Duties:0Forfeiture-Immoral Articles)",
      "19:1673" : "19:1673 (19:1673 Violations of Antidumping Act)",
      "20:1080" : "20:1080 (20:1080 Student Loan Recovery)",
      "20:1400" : "20:1400 (20:1400 Civil Rights of Handicapped Child)",
      "20:1401" : "20:1401 (20:1401 Education: Handicapped Child Act)",
      "21:0841" : "21:0841 (21:841 Forfeiture Property-Drugs)",
      "21:0881" : "21:0881 (21:881 Forfeiture Property-Drugs)",
      "21:0881a" : "21:0881a (21:881 Forfeiture Property - Aircraft)",
      "21:0881dr" : "21:0881dr (21:0881 Forfeiture Property - Drugs)",
      "21:0881re" : "21:0881re (21:881 Forfeiture Property - Real Estate)",
      "23:0134" : "23:0134 (23:134 P.I.- Auto Negligence)",
      "23:0154" : "23:0154 (23:0154 National Maximum Speed Limit)",
      "23:1441" : "23:1441 (23:1441 Contract Real Estate)",
      "24:1000" : "24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)",
      "25:0640" : "25:0640 (25:640 Indian Tribal Rights)",
      "25:1901" : "25:1901 (25:1901 Indian Child Welfare Act)",
      "26:6212" : "26:6212 (26:6212 Injunctive Relief from IRS Lien)",
      "26:6213" : "26:6213 (26:6213 Injunctive Relief from IRS Lien)",
      "26:6502" : "26:6502 (26:6502 IRS:Enforcement of tax liens)",
      "26:6532" : "26:6532 (26:6532 IRS: Refund of Tax Penalty)",
      "26:6702" : "26:6702 (26:6702 IRS: Refund of Income Tax Penalty)",
      "26:6703" : "26:6703 (26:6703 IRS: Refund of Tax Penalty)",
      "26:7401" : "26:7401 (26:7401 IRS: Tax Liability)",
      "26:7402" : "26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)",
      "26:7403" : "26:7403 (26:7403 Suit to Enforce Federal Tax Lien)",
      "26:7422rt" : "26:7422rt (26:7422 IRS: Refund Taxes)",
      "26:7422rx" : "26:7422rx (26:7422 IRS: Refund Excise Tax)",
      "26:7426" : "26:7426 (26:7426 IRS: Wrongful Levy for Taxes)",
      "26:7429" : "26:7429 (26:7429 IRS: Tax Jeopardy Assessment)",
      "26:7609" : "26:7609 (26:7609 IRS: Petition to Quash IRS Summons)",
      "27:0185" : "27:0185 (27:185 Enforcement of Arbitration Award)",
      "28:0157c" : "28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)",
      "28:0157d" : "28:0157d (28:0157 Motion for Withdrawal of Reference)",
      "28:0158" : "28:0158 (28:0158 Notice of Appeal re Bankruptcy Matter (BAP))",
      "28:0185" : "28:0185 (28:185 Suit to Compel Arbitration)",
      "28:0451" : "28:0451 (28:451 Employment Discrimination)",
      "28:0794" : "28:0794 (28:794 Rehabilitation Act)",
      "28:1001" : "28:1001 (28:1001 E.R.I.S.A.)",
      "28:1132" : "28:1132 (28:1132 E.R.I.S.A.)",
      "28:1330" : "28:1330 (28:1330 Breach of Contract)",
      "28:1331" : "28:1331 (28:1331 Fed. Question)",
      "28:1331al" : "28:1331al (28:1331 Fed. Question: Airline Crash)",
      "28:1331at" : "28:1331at (28:1331 Fed. Question: Anti-trust)",
      "28:1331au" : "28:1331au (28:1331 Fed. Question: Auto Negligence)",
      "28:1331b" : "28:1331b (28:1331 Federal Question: Bivens Act)",
      "28:1331bc" : "28:1331bc (28:1331 Fed. Question: Breach of Contract)",
      "28:1331ca" : "28:1331ca (28:1331 Fed Question: Fed Communications Act of 1934)",
      "28:1331cm" : "28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)",
      "28:1331cv" : "28:1331cv (28:1331 Federal Question: Other Civil Rights)",
      "28:1331ed" : "28:1331ed (28:1331 Fed. Question: Employment Discrimination)",
      "28:1331es" : "28:1331es (28:1331 Enforcement of Administrative Subpoena)",
      "28:1331fl" : "28:1331fl (28:1331 Fed. Question: Fair Labor Standards)",
      "28:1331fp" : "28:1331fp (28:1331 Forma Pauperis Denial)",
      "28:1331gl" : "28:1331gl (28:1331 Guardian Ad Litem Application)",
      "28:1331in" : "28:1331in (28:1331 Fed. Question: Insurance Contract)",
      "28:1331mm" : "28:1331mm (28:1331 Fed. Question: Medical Malpractice)",
      "28:1331pi" : "28:1331pi (28:1331 Fed. Question: Personal Injury)",
      "28:1331rd" : "28:1331rd (28:1331 Fed. Question: Review Agency Decision)",
      "28:1331rp" : "28:1331rp (28:1331(a) Fed. Question: Real Property)",
      "28:1331rr" : "28:1331rr (28:1331 Fed. Question: Railway Labor Act)",
      "28:1331sv" : "28:1331sv (28:1331 Fed. Question: Securities Violation)",
      "28:1331tr" : "28:1331tr (28:1331 Fed. Question: Trademark)",
      "28:1331tt" : "28:1331tt (28:1331 Fed. Question: Tort Action)",
      "28:1331v" : "28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendment)",
      "28:1331wl" : "28:1331wl (28:1331 Federal Question: EPA Waste Lien)",
      "28:1331wt" : "28:1331wt (28:1331 Fed. Question: Water Rights)",
      "28:1332ac" : "28:1332ac (28:1332 Diversity-Account Receivable)",
      "28:1332al" : "28:1332al (28:1332 Diversity-Airline Crash)",
      "28:1332as" : "28:1332as (28:1332 Diversity-Asbestos Litigation)",
      "28:1332au" : "28:1332au (28:1332 Diversity-Auto Negligence)",
      "28:1332bc" : "28:1332bc (28:1332 Diversity-Breach of Contract)",
      "28:1332co" : "28:1332co (28:1332 Diversity-Conversion)",
      "28:1332ct" : "28:1332ct (28:1332 Diversity-(Citizenship))",
      "28:1332det" : "28:1332det (28:1332 Diversity: Forcible Detainer)",
      "28:1332df" : "28:1332df (28:1332 Diversity-Contract Default)",
      "28:1332ds" : "28:1332ds (28:1332 Diversity-Contract Dispute)",
      "28:1332ed" : "28:1332ed (28:1332 Diversity-Employment Discrimination)",
      "28:1332fd" : "28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)",
      "28:1332fr" : "28:1332fr (28:1332 Diversity-Fraud)",
      "28:1332ia" : "28:1332ia (28:1332 Diversity-Interpleader Action)",
      "28:1332ij" : "28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)",
      "28:1332in" : "28:1332in (28:1332 Diversity-Insurance Contract)",
      "28:1332jd" : "28:1332jd (28:1332 Diversity-Declaratory Judgement)",
      "28:1332lb" : "28:1332lb (28:1332 Diversity-Libel,Assault,Slander)",
      "28:1332lm" : "28:1332lm (28:1332 Diversity - Legal Malpractice)",
      "28:1332ma" : "28:1332ma (28:1332 Diversity-Miller Act)",
      "28:1332mm" : "28:1332mm (28:1332 Diversity-Medical Malpractice)",
      "28:1332mv" : "28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)",
      "28:1332ni" : "28:1332ni (28:1332 Diversity-Negotiable Instrument)",
      "28:1332nm" : "28:1332nm (28:1332 Diversity-Non-Motor Vehicle)",
      "28:1332oc" : "28:1332oc (28:1332 Diversity-Other Contract)",
      "28:1332pd" : "28:1332pd (28:1332 Diversity-Property Damage)",
      "28:1332pi" : "28:1332pi (28:1332 Diversity-Personal Injury)",
      "28:1332pl" : "28:1332pl (28:1332 Diversity-Product Liability)",
      "28:1332pr" : "28:1332pr (28:1332 Diversity-Petition for Removal)",
      "28:1332qt" : "28:1332qt (28:1332 Diversity-Petition to Quiet Title)",
      "28:1332ri" : "28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)",
      "28:1332sa" : "28:1332sa (28:1332 - Diversity: Securities & Exchange Commission Act)",
      "28:1332sf" : "28:1332sf (28:1332 - Diversity: Securities Fraud)",
      "28:1332ss" : "28:1332ss (28:1332 Diversity - Stockholders Suits)",
      "28:1332tl" : "28:1332tl (28:1332 Diversity-Torts to Land)",
      "28:1332tm" : "28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))",
      "28:1332tn" : "28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)",
      "28:1332wd" : "28:1332wd (28:1332 Diversity-Wrongful Death)",
      "28:1333" : "28:1333 (28:1333 Admiralty)",
      "28:1334" : "28:1334 (28:1334 Bankruptcy Appeal)",
      "28:1334c" : "28:1334c (28:1334(c) R&R re motions for abstention (non-core))",
      "28:1335" : "28:1335 (28:1335 Interpleader Action)",
      "28:1337" : "28:1337 (28:1337 Sherman-Clayton Act)",
      "28:1338cp" : "28:1338cp (28:1338 Copyright Infringement)",
      "28:1338pt" : "28:1338pt (28:1338 Patent Infringement)",
      "28:1338tr" : "28:1338tr (28:1338 Trademark Infringement)",
      "28:1340" : "28:1340 (28:1340 IRS: Custom Duties)",
      "28:1340er" : "28:1340er (28:1340 Recovery of Erroneous Refund)",
      "28:1341" : "28:1341 (28:1341 Complaint for Forfeiture)",
      "28:1343" : "28:1343 (28:1343 Violation of Civil Rights)",
      "28:1345co" : "28:1345co (28:1345 Replevin & Conversion)",
      "28:1345db" : "28:1345db (28:1345 Debt to US - FHA/HUD Title I)",
      "28:1345df" : "28:1345df (28:1345 Default of Promissory Note)",
      "28:1345er" : "28:1345er (28:1345 Recovery of Erroneous Refund)",
      "28:1345fc" : "28:1345fc (28:1345 Foreclosure)",
      "28:1345ff" : "28:1345ff (28:1345 Complaint for Forfeiture)",
      "28:1345hl" : "28:1345hl (28:1345 VA Home Loan Guaranty Debt)",
      "28:1345mc" : "28:1345mc (28:1345 Medical Care Recovery)",
      "28:1345mi" : "28:1345mi (28:1345 Mining Claim Ejectment)",
      "28:1345pd" : "28:1345pd (28:1345 Property Damage)",
      "28:1345pe" : "28:1345pe (28:1345 Property Ejectment)",
      "28:1345rc" : "28:1345rc (28:1345 Recovery of Debt to US)",
      "28:1345st" : "28:1345st (28:1345 Default of Student Loan)",
      "28:1345tp" : "28:1345tp (28:1345 Trespass on Public Land)",
      "28:1345va" : "28:1345va (28:1345 Recovery of VA Overpayment)",
      "28:1346bc" : "28:1346bc (28:1346 Breach of Contract)",
      "28:1346rc" : "28:1346rc (28:1346 Recovery of IRS Tax)",
      "28:1346tc" : "28:1346tc (28:1346 Tort Claim)",
      "28:1346wd" : "28:1346wd (28:1346 Wrongful Death)",
      "28:1352" : "28:1352 (28:1352 Miller Act)",
      "28:1355" : "28:1355 (28:1355 Petition for Return of Property)",
      "28:1358" : "28:1358 (28:1358 Land Condemnation)",
      "28:1361" : "28:1361 (28:1361 Petition for Writ of Mandamus)",
      "28:1362ic" : "28:1362ic (28:1362 Indian Tribal Controversy)",
      "28:1362iw" : "28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)",
      "28:1364" : "28:1364 (28:1364 Auto Negligence)",
      "28:1391" : "28:1391 (28:1391 Personal Injury)",
      "28:1402" : "28:1402 (28:1402 Medical Malpractice)",
      "28:1407" : "28:1407 (28:1407 Airline Crash)",
      "28:1441ac" : "28:1441ac (28:1441 Notice of Removal - Account Receivable)",
      "28:1441al" : "28:1441al (28:1441 Notice of Removal - Airline Crash)",
      "28:1441as" : "28:1441as (28:1441 Notice of Removal - Asbestos Litigation)",
      "28:1441au" : "28:1441au (28:1441 Notice of Removal - Auto Negligence)",
      "28:1441bc" : "28:1441bc (28:1441 Notice of Removal - Breach of Contract)",
      "28:1441cv" : "28:1441cv (28:1441 Notice of Removal - Civil Rights Act)",
      "28:1441df" : "28:1441df (28:1441 Notice of Removal - Contract Default)",
      "28:1441dj" : "28:1441dj (28:1441 Notice of Removal - Declaratory Judgement)",
      "28:1441ds" : "28:1441ds (28:1441 Notice of Removal - Contract Dispute)",
      "28:1441ed" : "28:1441ed (28:1441 Notice of Removal - Employment Discrimination)",
      "28:1441fc" : "28:1441fc (28:1441 Notice of Removal - Fair Credit Reporting Act)",
      "28:1441fr" : "28:1441fr (28:1441 Notice of Removal - Fraud)",
      "28:1441ij" : "28:1441ij (28:1441 Notice of Removal - Injunctive/Declaratory Relief)",
      "28:1441in" : "28:1441in (28:1441 Notice of Removal - Insurance Contract)",
      "28:1441int" : "28:1441int (28:1441 Notice of Removal - Action for Interpleader)",
      "28:1441lb" : "28:1441lb (28:1441 Notice of Removal - Libel,Assault,Slander)",
      "28:1441lm" : "28:1441lm (28:1441 Notice of Removal - Labor/Mgmnt. Relations)",
      "28:1441mm" : "28:1441mm (28:1441 Notice of Removal - Medical Malpractice)",
      "28:1441ni" : "28:1441ni (28:1441 Notice of Removal - Negotiable Instrument)",
      "28:1441nm" : "28:1441nm (28:1441 Notice of Removal - Non-Motor Vehicle)",
      "28:1441oc" : "28:1441oc (28:1441 Notice of Removal -- Other Contract)",
      "28:1441pd" : "28:1441pd (28:1441 Notice of Removal - Property Damage)",
      "28:1441pi" : "28:1441pi (28:1441 Notice of Removal - Personal Injury)",
      "28:1441pl" : "28:1441pl (28:1441 Notice of Removal - Product Liability)",
      "28:1441pr" : "28:1441pr (28:1441 Notice of Removal)",
      "28:1441qt" : "28:1441qt (28:1441 Notice of Removal - Petition to Quiet Title)",
      "28:1441ri" : "28:1441ri (28:1441 Notice of Removal - Racketeering (RICO) Act)",
      "28:1441sa" : "28:1441sa (28:1441 - Notice of Removal - SEC Act)",
      "28:1441sf" : "28:1441sf (28:1441 - Notice of Removal - Securities Fraud)",
      "28:1441tl" : "28:1441tl (28:1441 Notice of Removal - Torts to Land)",
      "28:1441tm" : "28:1441tm (28:1441 Notice of Removal - Tort/Motor Vehicle (P.I.))",
      "28:1441tn" : "28:1441tn (28:1441 Petition for Removal - Tort/Non-Motor Vehicle)",
      "28:1441wd" : "28:1441wd (28:1441 Notice of Removal - Wrongful Death)",
      "28:1442bc" : "28:1442bc (28:1442 Notice of Removal - Breach of Contract)",
      "28:1442pr" : "28:1442pr (28:1442 Notice of Removal)",
      "28:1443" : "28:1443 (28:1443(1) Notice of Removal - Rent, Lease & Ejectment)",
      "28:1444" : "28:1444 (28:1444 Notice of Removal - Foreclosure)",
      "28:1446in" : "28:1446in (28:1446 Notice of Removal - Breach of Contract - Insurance)",
      "28:1446pd" : "28:1446pd (28:1446 Notice of Removal - Property Damage (P.I.))",
      "28:1446pi" : "28:1446pi (28:1446 Notice of Removal - Personal Injury)",
      "28:1446pl" : "28:1446pl (28:1446pl Notice of Removal - Product Liability)",
      "28:1446pr" : "28:1446pr (28:1446 Notice of Removal)",
      "28:1452" : "28:1452 (28:1452 R&R re motions to remand (non-core))",
      "28:1651" : "28:1651 (28:1651 Petition for Writ of Coram Nobis)",
      "28:1651hc" : "28:1651hc (28:1651 Petition for Writ of Habeas Corpus)",
      "28:1651mn" : "28:1651mn (28:1651 Petition for Writ of Mandamus)",
      "28:1833a" : "28:1833a (28:1833a Civil Penalty - FIRREA)",
      "28:1983" : "28:1983 (28:1983 Civil Rights)",
      "28:2201" : "28:2201 (28:2201 Constitutionality of State Statute(s))",
      "28:2201dj" : "28:2201dj (28:2201 Declaratory Judgment)",
      "28:2201ij" : "28:2201ij (28:2201 Injunction)",
      "28:2201in" : "28:2201in (28:2201 Declaratory Judgment (Insurance))",
      "28:2241" : "28:2241 (28:2241 Petition for Writ of Habeas Corpus (federal))",
      "28:2241me" : "28:2241me (28:2241 Motion to Extend Time to File 28:2241)",
      "28:2254" : "28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))",
      "28:2254me" : "28:2254me (28:2254 Motion to Extend Time to File 28:2254)",
      "28:2254se" : "28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)",
      "28:2255" : "28:2255 (28:2255 Motion to Vacate / Correct Illegal Sentence)",
      "28:2255me" : "28:2255me (28:2255 Motion to Extend Time to File 28:2255)",
      "28:2271" : "28:2271 (28:2271 Federal Tort Claims Act)",
      "28:2345" : "28:2345 (28:2345 Medicare Recovery)",
      "28:2409" : "28:2409 (28:2409(a) Quiet Title Action)",
      "28:2410" : "28:2410 (28:2410 Quiet Title)",
      "28:2671" : "28:2671 (28:2671 Federal Tort Claims Act)",
      "28:2674" : "28:2674 (28:2674 Federal Tort Claims Act)",
      "28:3205" : "28:3205 (28:3205 Garnishment)",
      "28:7402" : "28:7402 (28:7402 Refund of Taxes)",
      "28:7422" : "28:7422 (28:7422 Appeal from Administrative Decision)",
      "29:0151" : "29:0151 (29:151 Labor: Review of Agency Action)",
      "29:0160" : "29:0160 (29:160(1) National Labor Relations Act)",
      "29:0184" : "29:0184 (29:184 Violation Collection Bargain Agreement)",
      "29:0185ep" : "29:0185ep (29:185 Employee Pension Plan)",
      "29:0185lm" : "29:0185lm (29:185 Labor/Mgt. Relations (Contracts))",
      "29:0201do" : "29:0201do (29:201 Denial of Overtime Compensation)",
      "29:0201fl" : "29:0201fl (29:201 Fair Labor Standards Act)",
      "29:0203" : "29:0203 (29:203 Equal Pay Act)",
      "29:0206" : "29:0206 (29:206 Collect Unpaid Wages)",
      "29:0207" : "29:0207 (29:0207 Maximum Hours)",
      "29:0401" : "29:0401 (29:0401 Labor Management Disclosure Act)",
      "29:0621" : "29:0621 (29:621 Job Discrimination (Age))",
      "29:0623" : "29:0623 (29:623 Job Discrimination (Age))",
      "29:0626" : "29:0626 (29:626 Job Discrimination (Age))",
      "29:0633" : "29:0633 (29:633 Job Discrimination (Age))",
      "29:0651" : "29:0651 (29:651 Occupational Safety/Health)",
      "29:0754" : "29:0754 (29:754 Discrimination)",
      "29:0790" : "29:0790 (29:0790 Rehabilitation of Labor)",
      "29:0791" : "29:0791 (29:791 Job Discrimination (Rehabilitation Act))",
      "29:0794" : "29:0794 (29:0794 Job Discrimination (Handicap))",
      "29:1001" : "29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)",
      "29:1002" : "29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)",
      "29:1104" : "29:1104 (29:1104 Recovery of Benefits to Employee)",
      "29:1109" : "29:1109 (29:1109 Breach of Fiduciary Duties)",
      "29:1131" : "29:1131 (29:1131 ERISA - Collection of Delinquent Trust Funds)",
      "29:1132" : "29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)",
      "29:1145" : "29:1145 (29:1145 E.R.I.S.A.)",
      "29:1149" : "29:1149 (29:1149 Recover Pension & Profit Sharing)",
      "29:1337" : "29:1337 (29:1337 E.R.I.S.A.)",
      "29:1362" : "29:1362 (29:1362 ERISA)",
      "29:1381" : "29:1381 (29:1381 E.R.I.S.A.)",
      "29:1401" : "29:1401 (29:1401(b)(2) Appeal of Arbitration Award)",
      "29:1451" : "29:1451 (29:1451 E.R.I.S.A.)",
      "29:1801" : "29:1801 (29:1801 Farmworker Rights)",
      "29:2601" : "29:2601 (29:2601 Family and Medical Leave Act)",
      "29:790" : "29:790 (29:790 Rehabilitation of Labor)",
      "30:0181" : "30:0181 (30:181 Environment: Review of Agency Action)",
      "30:0801" : "30:0801 (30:0801 Penalities/Federal Mine Safety Health Act - 1977)",
      "30:0923" : "30:0923 (30:923 Federal Coal Mine Health and Safety Act of 1969)",
      "30:1201" : "30:1201 (30:1201 Environment: Review of Agency Action)",
      "30:1202" : "30:1202 (30:1202 Mining Reclamation Act)",
      "30:1276" : "30:1276 (30:1276 Interior: Review of Agency Action)",
      "31:3545" : "31:3545 (31:3545 Action to Recovery Money)",
      "31:3729" : "31:3729 (31:3729 False Claims Act)",
      "31:3730" : "31:3730 (31:3730 Qui Tam False Claims Act)",
      "31:3731" : "31:3731 (31:3731 Fraud)",
      "33:1319cw" : "33:1319cw (33:1319 Clean Water Act)",
      "33:1319pv" : "33:1319pv (33:1319 Pollutants & Permit Violations)",
      "33:1365" : "33:1365 (33:1365 Environmental Matters)",
      "35:0145" : "35:0145 (35:145 Patent Infringement)",
      "35:0183" : "35:0183 (35:183 Patent Infringement)",
      "35:0271" : "35:0271 (35:271 Patent Infringement)",
      "38:1681" : "38:1681 (38:1681 Recovery of VA Overpayment)",
      "38:1686" : "38:1686 (38:1686 Recovery of VA Overpayment)",
      "38:1780" : "38:1780 (38:1780 Recovery of VA Overpayment)",
      "38:2011" : "38:2011 (38:2011 - Veteran's Readjustment Assistance Act of 1974)",
      "38:3116" : "38:3116 (38:3116 VA Overpayment)",
      "39:0409" : "39:0409 (39:0409 Postal Service)",
      "39:3005" : "39:3005 (39:3005 Detention of Mail for Temporary Periods)",
      "39:3008" : "39:3008 (39:3008 Pandering)",
      "39:409" : "39:409 (39:409 Postal Service)",
      "40:0258" : "40:0258 (40:258(a) Public Buildings & Property: Land Condemnation)",
      "40:0270" : "40:0270 (40:270 Miller Act)",
      "40:0875" : "40:0875 (40:875 Public Buildings & Property: Negligence)",
      "41:0251" : "41:0251 (41:251 Public Contracts-Review of Agency Action)",
      "41:1463" : "41:1463 (41:1463 Public Contracts: Unlawful Employment Practices)",
      "42:0205" : "42:0205 (42:205 Denial Social Security Benefits)",
      "42:0206" : "42:0206 (42:206 Social Security Benefits)",
      "42:0247" : "42:0247 (42:247 Personal Injury-Swine Flu)",
      "42:0402" : "42:0402 (42:402 Social Security Benefits)",
      "42:0405id" : "42:0405id (42:405 Review of HHS Decision (SSID))",
      "42:0405wc" : "42:0405wc (42:405 Review of HHS Decision (DIWC))",
      "42:0405ww" : "42:0405ww (42:405 Review of HHS Decision (DIWW))",
      "42:0416" : "42:0416 (42:416 Denial of Social Security Benefits)",
      "42:0425" : "42:0425 (42:0425 Suspension of Social Security Benefits)",
      "42:0427" : "42:0427 (42:427 Social Security Benefits)",
      "42:0901" : "42:0901 (42:0901 Comprehensive Response, Compensation & Liability)",
      "42:12101" : "42:12101 (42:12101 Americans With Disabilities Act)",
      "42:1383" : "42:1383 (42:1383 Review of HHS Decision)",
      "42:1395" : "42:1395 (42:1395 HHS: Adverse Reimbursement Review)",
      "42:1396" : "42:1396 (42:1396 - Tort Negligence)",
      "42:1471" : "42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclosure Sale)",
      "42:1981cv" : "42:1981cv (42:1981 Civil Rights)",
      "42:1981hs" : "42:1981hs (42:1981 Housing Discrimination)",
      "42:1981jb" : "42:1981jb (42:1981 Job Discrimination (Race))",
      "42:1981sx" : "42:1981sx (42:1981 Sex Discrimination)",
      "42:1983cv" : "42:1983cv (42:1983 Civil Rights Act)",
      "42:1983ed" : "42:1983ed (42:1983 Civil Rights (Employment Discrimination))",
      "42:1983pr" : "42:1983pr (42:1983 Prisoner Civil Rights)",
      "42:1986" : "42:1986 (42:1986 Neglect of Duty)",
      "42:2000ag" : "42:2000ag (42:2000 Job Discrimination (Age))",
      "42:2000e" : "42:2000e (42:2000e Job Discrimination (Employment))",
      "42:2000pb" : "42:2000pb (42:2000 Job Discrimination (Public Accomodations))",
      "42:2000ra" : "42:2000ra (42:2000 Job Discrimination (Race))",
      "42:2000sx" : "42:2000sx (42:2000 Job Discrimination (Sex))",
      "42:2003" : "42:2003 (42:2003 Job Discrimination)",
      "42:2005" : "42:2005 (42:2005 Review of Agency Action-HHS)",
      "42:2651" : "42:2651 (42:2651 Medical Care Recovery)",
      "42:3601" : "42:3601 (42:405 Fair Housing Act)",
      "42:4000" : "42:4000 (42:4000 National Flood Insurance Act)",
      "42:4001" : "42:4001 (42:4001 National Insurance Flood Act)",
      "42:4053" : "42:4053 (42:4053 Breach of Insurance Contract)",
      "42:4072" : "42:4072 (42:4072 Payment of Flood Insurance Claim)",
      "42:4321" : "42:4321 (42:4321 Review of Agency Action-Environment)",
      "42:4332" : "42:4332 (42:4332 Environmental Policy - Coop of Agency Reports)",
      "42:6901en" : "42:6901en (42:6901 Environmental Cleanup Expenses)",
      "42:6901rs" : "42:6901rs (42:6901 Resource & Recovery Act)",
      "42:7413" : "42:7413 (42:7413(b) Clean Air Act)",
      "42:7604cl" : "42:7604cl (42:7604 Clear Air Act (Emission Standards))",
      "42:7604ir" : "42:7604ir (42:7604 Petition to Quash IRS Summons)",
      "42:9607" : "42:9607 (42:9607 Real Property Tort to Land)",
      "42:9831" : "42:9831 (42:9831 Head Start Program)",
      "42:9835(d)" : "42:9835(d) (42:9835(d) Head Start Handicap)",
      "43:0945" : "43:0945 (43:0945 Compensation for Land Condemnation)",
      "43:0945a" : "43:0945a (43:0945(a) Complaint in Condemnation)",
      "43:0946" : "43:0946 (43:0946 Complaint in Condemnation - Eminent Domain)",
      "43:945" : "43:945 (43:945 Compensation for Land Condemnation)",
      "43:945a" : "43:945a (43:945a Complaint in Condemnation)",
      "43:946" : "43:946 (43:946 Complaint in Condemnation - Eminent Domain)",
      "45:0051" : "45:0051 (45:51 Railways: Fed. Employer's Liability Act)",
      "45:0151" : "45:0151 (45:151 Railway Labor Act)",
      "45:0184" : "45:0184 (45:184 Action to Set Aside Award of a System Board of Adjust)",
      "45:1395" : "45:1395 (45:1395 Railroads: Adverse Reimbursement Review)",
      "45:7457" : "45:7457 (45:7457 Compel Reclamation Under Clear Air Act)",
      "46:0688" : "46:0688 (46:688 Jones Act)",
      "46:0741" : "46:0741 (46:741 Shipping)",
      "46:0761" : "46:0761 (46:761 Shipping: Damages for Death on High Seas)",
      "46:0953" : "46:0953 (46:0953 Foreclosure on Maritime Lien)",
      "46:1101" : "46:1101 (46:1101 Violation of Maritime Regulations)",
      "46:1156" : "46:1156 (46:1156 Administrative Procedure Act)",
      "46:1701" : "46:1701 (46:1701 Shipping/Maritime)",
      "47:0227" : "47:0227 (47:0227 Violation of Telephone Consumer Protection Act)",
      "47:0521" : "47:0521 (47:521 Violations of Cable Communications Act of 1984)",
      "48:0883" : "48:0883 (48:883 Violation of US Coastal Law)",
      "48:1985" : "48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)",
      "49:0081" : "49:0081 (49:81 Damaged Goods While Being Transported)",
      "49:0781" : "49:0781 (49:781 Forfeiture)",
      "49:11503" : "49:11503 (49:11503 Railroad Revitalization Regulatory Reform Act)",
      "49:11702" : "49:11702 (49:11702(a)(4) Violations of Interstate Commerce Act)",
      "49:1471" : "49:1471 (49:1471 Federal Aviation Act)",
      "49:1903" : "49:1903 (49:1903 Petition to enforce administrative summons)",
      "8:287" : "8:287 (8:287 Petition to Enforce INS Subpoena)",
      "misc" : "misc (Civil Miscellaneous Case)"
   },
   "caedce" : {
      "0" : "0 (No cause code entered)",
      "00:0000" : "00:0000 (00:0000 Cause Code Unknown)",
      "02:0431" : "02:0431 (02:431 Fed. Election Commission: Failure Enforce Compliance)",
      "02:0437" : "02:0437 (02:437 Federal Election Commission)",
      "05:0075" : "05:0075 (05:75(2) Contract - Reduction in Grade)",
      "05:0551" : "05:0551 (05:551 Administrative Procedure Act)",
      "05:0552fi" : "05:0552fi (05:552 Freedom of Information Act)",
      "05:0552pa" : "05:0552pa (05:552 Right to Privacy Act)",
      "05:0554" : "05:0554 (05:0554 Constitutionality of Maritime Statutes)",
      "05:0701" : "05:0701 (05:0701 Maritime Subsidy Board)",
      "05:0702" : "05:0702 (05:702 Administrative Procedure Act)",
      "05:0704" : "05:0704 (05:704 Labor Litigation)",
      "05:7703" : "05:7703 (05:7703 Discrimination - Review of Agency Act)",
      "07:0006" : "07:0006 (7:6(b) Federal Commodity Exchange Regulation)",
      "07:0025" : "07:0025 (7:25 Fraud - Commodities Leverage Contracts)",
      "07:0181" : "07:0181 (07:181 Packers & Stockyard Act)",
      "07:0499" : "07:0499 (07:499 Agricultural Commodities Act)",
      "07:0601" : "07:0601 (07:601 USDA Condemnation)",
      "07:2321" : "07:2321 (07:2321 Plant Variety Protection Act)",
      "08:1105" : "08:1105 (8:1105(a) Aliens: Habeas Corpus to Release INS Detainee)",
      "08:1252" : "08:1252 (08:1252(a)(2) Injunction for Deportation)",
      "08:1260" : "08:1260 (08:1260 Aliens: Access to Records)",
      "08:1324" : "08:1324 (08:1324 Aliens: Complaint for Forfeiture)",
      "08:1329" : "08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petition)",
      "08:1446" : "08:1446 (8:1446 Petition for Naturalization Hearing)",
      "09:0001" : "09:0001 (09:1 U.S. Arbitration Act)",
      "09:0009" : "09:0009 (9:9 Motion to Confirm Arbitration Loan)",
      "09:0010" : "09:0010 (09:0010 Petition to Vacate Arbitration Award)",
      "10:1552" : "10:1552 (10:1552 Armed Forces: Action to Correct Records)",
      "10:1553" : "10:1553 (10:1553 Armed Forces: FOIA General)",
      "10:2305" : "10:2305 (10:2305 Review of Federal Contract)",
      "11:0101" : "11:0101 (11:101 Bankruptcy)",
      "12:0022" : "12:0022 (12:22 Securities Fraud)",
      "12:0635" : "12:0635 (12:635 Breach of Insurance Contract)",
      "12:1461" : "12:1461 (12:1461 Homeowners Loan Act)",
      "12:1703" : "12:1703 (12:1703 Default of HUD Loan)",
      "12:1725" : "12:1725 (12:1725 Collection under Contract Guaranty)",
      "12:1730" : "12:1730 (12:1730 Collection Under Contract Guaranty)",
      "12:1819" : "12:1819 (12:1819 Default of Promissory Note)",
      "12:1821" : "12:1821 (12:1821 Default of Loan by Promissary Note)",
      "12:1971" : "12:1971 (12:1971 Relief under Bank Holding Act)",
      "12:3410" : "12:3410 (12:3410 Right to Financial Privacy Act)",
      "15:0001" : "15:0001 (15:1 Antitrust Litigation)",
      "15:0002at" : "15:0002at (15:2 Antitrust Litigation)",
      "15:0002fl" : "15:0002fl (15:2(a) Fair Labor Standards Act)",
      "15:0005" : "15:0005 (15:5(a) Fair Labor Standards Act)",
      "15:0015" : "15:0015 (15:15 Antitrust Litigation)",
      "15:0025" : "15:0025 (15:25 Clayton Act)",
      "15:0044" : "15:0044 (15:44 Trademark Infringement)",
      "15:0045" : "15:0045 (15:0045 Federal Trade Commission Act)",
      "15:0052" : "15:0052 (15:0052 Federal Trade Commission Act)",
      "15:0053" : "15:0053 (15:0053 Federal Trade Commission Act)",
      "15:0077" : "15:0077 (15:77 Securities Fraud)",
      "15:0078" : "15:0078 (15:78m(a) Securities Exchange Act)",
      "15:0631" : "15:0631 (15:631 Small Business Act)",
      "15:0717" : "15:0717 (15:717 Natural Gas Act)",
      "15:1051" : "15:1051 (15:1051 Trademark Infringement)",
      "15:1114" : "15:1114 (15:1114 Trademark Infringement)",
      "15:1121" : "15:1121 (15:1121 Trademark Infringement)",
      "15:1125" : "15:1125 (15:1125 Trademark Infringement (Lanham Act))",
      "15:1126" : "15:1126 (15:1126 Patent Infringement)",
      "15:1127" : "15:1127 (15:1127 Trademark Infringement)",
      "15:1601" : "15:1601 (15:1601 Truth in Lending)",
      "15:1640" : "15:1640 (15:1640 Truth in Lending)",
      "15:1681" : "15:1681 (15:1681 Fair Credit Reporting Act)",
      "15:1692" : "15:1692 (15:1692 Fair Debt Collection Act)",
      "15:1938" : "15:1938 (15:1938 Fair Labor Standards Act)",
      "15:1981" : "15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))",
      "15:1988" : "15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))",
      "15:1989" : "15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))",
      "15:2301" : "15:2301 (15:2301 Magnuson-Moss Warranty Act)",
      "15:2801" : "15:2801 (15:2801 Petroleum Marketing Practices Act)",
      "15:53(b)" : "15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equitable Relief)",
      "16:0668" : "16:0668 (16:668 Bald Eagle Protection Act)",
      "16:0703" : "16:0703 (16:703 Migratory Bird Act)",
      "16:1538" : "16:1538 (16:1538 Endangered Species Act)",
      "16:3371" : "16:3371 (16:3371 Wildlife Under the Lacey Act)",
      "16:3372" : "16:3372 (16:3372 Conservation: Complaint for Forfeiture)",
      "16:3373" : "16:3373 (16:3373 Appeal of Decision - DOI)",
      "16:3374" : "16:3374 (16:3374 Conservation: Complaint for Forfeiture)",
      "17:0101" : "17:0101 (17:101 Copyright Infringement)",
      "17:0501" : "17:0501 (17:501 Copyright Infringement)",
      "17:0504" : "17:0504 (17:504 Copyright Infringement)",
      "18:0241" : "18:0241 (18:241 Conspiracy Against Citizen Rights)",
      "18:1836a" : "18:1836a (18:1836(a) Injunction against Misappropriation of Trade Secrets)",
      "18:1836b" : "18:1836b (18:1836(b) Civil Action to Protect Trade Secrets)",
      "18:1961" : "18:1961 (18:1961 Racketeering (RICO) Act)",
      "18:1962" : "18:1962 (18:1962 Racketeering (RICO) Act)",
      "18:1964" : "18:1964 (18:1964 Racketeering (RICO) Act)",
      "18:4208" : "18:4208 (18:4208(B) Agency Action Review)",
      "19:1305" : "19:1305 (19:1305 Custom Duties:0Forfeiture-Immoral Articles)",
      "20:1080" : "20:1080 (20:1080 Student Loan Recovery)",
      "20:1400" : "20:1400 (20:1400 Civil Rights of Handicapped Child)",
      "20:1401" : "20:1401 (20:1401 Education: Handicapped Child Act)",
      "21:0841" : "21:0841 (21:841 Forfeiture Property-Drugs)",
      "21:0881" : "21:0881 (21:881 Forfeiture Property-Drugs)",
      "21:0881a" : "21:0881a (21:881 Forfeiture Property - Aircraft)",
      "21:0881re" : "21:0881re (21:881 Forfeiture Property - Real Estate)",
      "23:0134" : "23:0134 (23:134 P.I.- Auto Negligence)",
      "23:1441" : "23:1441 (23:1441 Contract Real Estate)",
      "24:1000" : "24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)",
      "25:0640" : "25:0640 (25:640 Indian Tribal Rights)",
      "25:1901" : "25:1901 (25:1901 Indian Child Welfare Act)",
      "26:6212" : "26:6212 (26:6212 Injunctive Relief from IRS Lien)",
      "26:6213" : "26:6213 (26:6213 Injunctive Relief from IRS Lien)",
      "26:6502" : "26:6502 (26:6502 IRS:Enforcement of tax liens)",
      "26:6532" : "26:6532 (26:6532 IRS: Refund of Tax Penalty)",
      "26:6702" : "26:6702 (26:6702 IRS: Refund of Income Tax Penalty)",
      "26:6703" : "26:6703 (26:6703 IRS: Refund of Tax Penalty)",
      "26:7401" : "26:7401 (26:7401 IRS: Tax Liability)",
      "26:7402" : "26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)",
      "26:7403" : "26:7403 (26:7403 Suit to Enforce Federal Tax Lien)",
      "26:7422rt" : "26:7422rt (26:7422 IRS: Refund Taxes)",
      "26:7422rx" : "26:7422rx (26:7422 IRS: Refund Excise Tax)",
      "26:7426" : "26:7426 (26:7426 IRS: Wrongful Levy for Taxes)",
      "26:7429" : "26:7429 (26:7429 IRS: Tax Jeopardy Assessment)",
      "26:7609" : "26:7609 (26:7609 IRS: Petition to Quash IRS Summons)",
      "27:0185" : "27:0185 (27:185 Enforcement of Arbitration Award)",
      "28:0157c" : "28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)",
      "28:0157d" : "28:0157d (28:0157 Motion for Withdrawal of Reference)",
      "28:0158" : "28:0158 (28:0158 Notice of Appeal re Bankruptcy Matter (BAP))",
      "28:0185" : "28:0185 (28:185 Suit to Compel Arbitration)",
      "28:0451" : "28:0451 (28:451 Employment Discrimination)",
      "28:0794" : "28:0794 (28:794 Rehabilitation Act)",
      "28:1001" : "28:1001 (28:1001 E.R.I.S.A.)",
      "28:1132" : "28:1132 (28:1132 E.R.I.S.A.)",
      "28:1330" : "28:1330 (28:1330 Breach of Contract)",
      "28:1331" : "28:1331 (28:1331 Fed. Question)",
      "28:1331al" : "28:1331al (28:1331 Fed. Question: Airline Crash)",
      "28:1331at" : "28:1331at (28:1331 Fed. Question: Anti-trust)",
      "28:1331au" : "28:1331au (28:1331 Fed. Question: Auto Negligence)",
      "28:1331b" : "28:1331b (28:1331 Federal Question: Bivens Act)",
      "28:1331bc" : "28:1331bc (28:1331 Fed. Question: Breach of Contract)",
      "28:1331ca" : "28:1331ca (28:1331 Fed Question: Fed Communications Act of 1934)",
      "28:1331cm" : "28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)",
      "28:1331cv" : "28:1331cv (28:1331 Federal Question: Other Civil Rights)",
      "28:1331ed" : "28:1331ed (28:1331 Fed. Question: Employment Discrimination)",
      "28:1331es" : "28:1331es (28:1331 Enforcement of Administrative Subpoena)",
      "28:1331fl" : "28:1331fl (28:1331 Fed. Question: Fair Labor Standards)",
      "28:1331in" : "28:1331in (28:1331 Fed. Question: Insurance Contract)",
      "28:1331mm" : "28:1331mm (28:1331 Fed. Question: Medical Malpractice)",
      "28:1331pi" : "28:1331pi (28:1331 Fed. Question: Personal Injury)",
      "28:1331rd" : "28:1331rd (28:1331 Fed. Question: Review Agency Decision)",
      "28:1331rp" : "28:1331rp (28:1331(a) Fed. Question: Real Property)",
      "28:1331rr" : "28:1331rr (28:1331 Fed. Question: Railway Labor Act)",
      "28:1331sv" : "28:1331sv (28:1331 Fed. Question: Securities Violation)",
      "28:1331tr" : "28:1331tr (28:1331 Fed. Question: Trademark)",
      "28:1331tt" : "28:1331tt (28:1331 Fed. Question: Tort Action)",
      "28:1331v" : "28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendment)",
      "28:1331wl" : "28:1331wl (28:1331 Federal Question: EPA Waste Lien)",
      "28:1331wt" : "28:1331wt (28:1331 Fed. Question: Water Rights)",
      "28:1332ac" : "28:1332ac (28:1332 Diversity-Account Receivable)",
      "28:1332al" : "28:1332al (28:1332 Diversity-Airline Crash)",
      "28:1332as" : "28:1332as (28:1332 Diversity-Asbestos Litigation)",
      "28:1332au" : "28:1332au (28:1332 Diversity-Auto Negligence)",
      "28:1332bc" : "28:1332bc (28:1332 Diversity-Breach of Contract)",
      "28:1332co" : "28:1332co (28:1332 Diversity-Conversion)",
      "28:1332ct" : "28:1332ct (28:1332 Diversity-(Citizenship))",
      "28:1332det" : "28:1332det (28:1332 Diversity: Forcible Detainer)",
      "28:1332df" : "28:1332df (28:1332 Diversity-Contract Default)",
      "28:1332ds" : "28:1332ds (28:1332 Diversity-Contract Dispute)",
      "28:1332ed" : "28:1332ed (28:1332 Diversity-Employment Discrimination)",
      "28:1332fd" : "28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)",
      "28:1332fr" : "28:1332fr (28:1332 Diversity-Fraud)",
      "28:1332ia" : "28:1332ia (28:1332 Diversity-Interpleader Action)",
      "28:1332ij" : "28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)",
      "28:1332in" : "28:1332in (28:1332 Diversity-Insurance Contract)",
      "28:1332jd" : "28:1332jd (28:1332 Diversity-Declaratory Judgement)",
      "28:1332lb" : "28:1332lb (28:1332 Diversity-Libel,Assualt,Slander)",
      "28:1332lm" : "28:1332lm (28:1332 Diversity - Legal Malpractice)",
      "28:1332ma" : "28:1332ma (28:1332 Diversity-Miller Act)",
      "28:1332mm" : "28:1332mm (28:1332 Diversity-Medical Malpractice)",
      "28:1332mv" : "28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)",
      "28:1332ni" : "28:1332ni (28:1332 Diversity-Negotiable Instrument)",
      "28:1332nm" : "28:1332nm (28:1332 Diversity-Non-Motor Vehicle)",
      "28:1332oc" : "28:1332oc (28:1332 Diversity-Other Contract)",
      "28:1332pd" : "28:1332pd (28:1332 Diversity-Property Damage)",
      "28:1332pi" : "28:1332pi (28:1332 Diversity-Personal Injury)",
      "28:1332pl" : "28:1332pl (28:1332 Diversity-Product Liability)",
      "28:1332pr" : "28:1332pr (28:1332 Diversity-Petition for Removal)",
      "28:1332qt" : "28:1332qt (28:1332 Diversity-Petition to Quiet Title)",
      "28:1332ri" : "28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)",
      "28:1332sa" : "28:1332sa (28:1332 - Diversity: Securities & Exchange Commission Act)",
      "28:1332sf" : "28:1332sf (28:1332 - Diversity: Securities Fraud)",
      "28:1332ss" : "28:1332ss (28:1332 Diversity - Stockholders Suits)",
      "28:1332tl" : "28:1332tl (28:1332 Diversity-Torts to Land)",
      "28:1332tm" : "28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))",
      "28:1332tn" : "28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)",
      "28:1332wd" : "28:1332wd (28:1332 Diversity-Wrongful Death)",
      "28:1333" : "28:1333 (28:1333 Admiralty)",
      "28:1334" : "28:1334 (28:1334 Bankruptcy Appeal)",
      "28:1334c" : "28:1334c (28:1334(c) R&R re motions for abstention (non-core))",
      "28:1335" : "28:1335 (28:1335 Interpleader Action)",
      "28:1337" : "28:1337 (28:1337 Sherman-Clayton Act)",
      "28:1338cp" : "28:1338cp (28:1338 Copyright Infringement)",
      "28:1338pt" : "28:1338pt (28:1338 Patent Infringement)",
      "28:1338tr" : "28:1338tr (28:1338 Trademark Infringement)",
      "28:1340" : "28:1340 (28:1340 IRS: Custom Duties)",
      "28:1340er" : "28:1340er (28:1340 Recovery of Erroneous Refund)",
      "28:1341" : "28:1341 (28:1341 Complaint for Forfeiture)",
      "28:1343" : "28:1343 (28:1343 Violation of Civil Rights)",
      "28:1345co" : "28:1345co (28:1345 Replevin & Conversion)",
      "28:1345db" : "28:1345db (28:1345 Debt to US - FHA/HUD Title I)",
      "28:1345df" : "28:1345df (28:1345 Default of Promissory Note)",
      "28:1345er" : "28:1345er (28:1345 Recovery of Erroneous Refund)",
      "28:1345fc" : "28:1345fc (28:1345 Foreclosure)",
      "28:1345ff" : "28:1345ff (28:1345 Complaint for Forfeiture)",
      "28:1345hl" : "28:1345hl (28:1345 VA Home Loan Guaranty Debt)",
      "28:1345mc" : "28:1345mc (28:1345 Medical Care Recovery)",
      "28:1345mi" : "28:1345mi (28:1345 Mining Claim Ejectment)",
      "28:1345pd" : "28:1345pd (28:1345 Property Damage)",
      "28:1345pe" : "28:1345pe (28:1345 Property Ejectment)",
      "28:1345rc" : "28:1345rc (28:1345 Recovery of Debt to US)",
      "28:1345st" : "28:1345st (28:1345 Default of Student Loan)",
      "28:1345tp" : "28:1345tp (28:1345 Trespass on Public Land)",
      "28:1345va" : "28:1345va (28:1345 Recovery of VA Overpayment)",
      "28:1346bc" : "28:1346bc (28:1346 Breach of Contract)",
      "28:1346rc" : "28:1346rc (28:1346 Recovery of IRS Tax)",
      "28:1346tc" : "28:1346tc (28:1346 Tort Claim)",
      "28:1346wd" : "28:1346wd (28:1346 Wrongful Death)",
      "28:1352" : "28:1352 (28:1352 Miller Act)",
      "28:1355" : "28:1355 (28:1355 Petition for Return of Property)",
      "28:1358" : "28:1358 (28:1358 Land Condemnation)",
      "28:1361" : "28:1361 (28:1361 Petition for Writ of Mandamus)",
      "28:1362ic" : "28:1362ic (28:1362 Indian Tribal Controversy)",
      "28:1362iw" : "28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)",
      "28:1364" : "28:1364 (28:1364 Auto Negligence)",
      "28:1391" : "28:1391 (28:1391 Personal Injury)",
      "28:1402" : "28:1402 (28:1402 Medical Malpractice)",
      "28:1407" : "28:1407 (28:1407 Airline Crash)",
      "28:1441ac" : "28:1441ac (28:1441 Petition for Removal- Account Receivable)",
      "28:1441al" : "28:1441al (28:1441 Petition for Removal- Airline Crash)",
      "28:1441as" : "28:1441as (28:1441 Petition for Removal- Asbestos Litigation)",
      "28:1441au" : "28:1441au (28:1441 Petition for Removal- Auto Negligence)",
      "28:1441bc" : "28:1441bc (28:1441 Petition for Removal- Breach of Contract)",
      "28:1441cv" : "28:1441cv (28:1441 Petition for Removal- Civil Rights Act)",
      "28:1441df" : "28:1441df (28:1441 Petition for Removal- Contract Default)",
      "28:1441dj" : "28:1441dj (28:1441 Petition for Removal- Declaratory Judgement)",
      "28:1441ds" : "28:1441ds (28:1441 Petition for Removal- Contract Dispute)",
      "28:1441ed" : "28:1441ed (28:1441 Petition for Removal - Employment Discrimination)",
      "28:1441fc" : "28:1441fc (28:1441 Petition for Removal - Fair Credit Reporting Act)",
      "28:1441fr" : "28:1441fr (28:1441 Petition for Removal- Fraud)",
      "28:1441ij" : "28:1441ij (28:1441 Petition for Removal- Injunctive/Declaratory Relief)",
      "28:1441in" : "28:1441in (28:1441 Petition for Removal- Insurance Contract)",
      "28:1441int" : "28:1441int (28:1441 Petition for Removal- Action for Interpleader)",
      "28:1441lb" : "28:1441lb (28:1441 Petition for Removal - Libel, Assault, Slander)",
      "28:1441lm" : "28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relations)",
      "28:1441mm" : "28:1441mm (28:1441 Petition for Removal- Medical Malpractice)",
      "28:1441ni" : "28:1441ni (28:1441 Petition for Removal- Negotiable Instrument)",
      "28:1441nm" : "28:1441nm (28:1441 Petition for Removal- Non-Motor Vehicle)",
      "28:1441oc" : "28:1441oc (28:1441 Petition For Removal--Other Contract)",
      "28:1441pd" : "28:1441pd (28:1441 Petition for Removal- Property Damage)",
      "28:1441pi" : "28:1441pi (28:1441 Petition for Removal- Personal Injury)",
      "28:1441pl" : "28:1441pl (28:1441 Petition for Removal- Product Liability)",
      "28:1441pr" : "28:1441pr (28:1441 Petition for Removal)",
      "28:1441qt" : "28:1441qt (28:1441 Petition for Removal- Petition to Quiet Title)",
      "28:1441ri" : "28:1441ri (28:1441 Petition for Removal- Racketeering (RICO) Act)",
      "28:1441sa" : "28:1441sa (28:1441 - Petition for Removal: SEC Act)",
      "28:1441sf" : "28:1441sf (28:1441 - Petition for Removal: Securities Fraud)",
      "28:1441tl" : "28:1441tl (28:1441 Petition for Removal- Torts to Land)",
      "28:1441tm" : "28:1441tm (28:1441 Petition for Removal- Tort/Motor Vehicle (P.I.))",
      "28:1441tn" : "28:1441tn (28:1441 Petition for Removal- Tort/Non-Motor Vehicle)",
      "28:1441wd" : "28:1441wd (28:1441 Petition for Removal- Wrongful Death)",
      "28:1442bc" : "28:1442bc (28:1442 Petition for Removal- Breach of Contract)",
      "28:1442pr" : "28:1442pr (28:1442 Petition for Removal)",
      "28:1443" : "28:1443 (28:1443(1) Rent, Lease & Ejectment)",
      "28:1444" : "28:1444 (28:1444 Petition for Removal- Foreclosure)",
      "28:1446in" : "28:1446in (28:1446 Breach of Contract- Insurance)",
      "28:1446pd" : "28:1446pd (28:1446 Petition for Removal- Property Damage (P.I.))",
      "28:1446pi" : "28:1446pi (28:1446 Petition for Removal- Personal Injury)",
      "28:1446pl" : "28:1446pl (28:1446pl Petition for Removal - Product Liability)",
      "28:1446pr" : "28:1446pr (28:1446 Petition for Removal)",
      "28:1452" : "28:1452 (28:1452 R&R re motions to remand (non-core))",
      "28:1651" : "28:1651 (28:1651 Petition for Writ of Coram Nobis)",
      "28:1651hc" : "28:1651hc (28:1651 Petition for Writ of Habeas Corpus)",
      "28:1651mn" : "28:1651mn (28:1651 Petition for Writ of Mandamus)",
      "28:1867" : "28:1867 (28:1867 Grand Jury Disclosure)",
      "28:1983" : "28:1983 (28:1983 Civil Rights)",
      "28:2201" : "28:2201 (28:2201 Constitutionality of State Statute(s))",
      "28:2201dj" : "28:2201dj (28:2201 Declaratory Judgement)",
      "28:2201ij" : "28:2201ij (28:2201 Injunction)",
      "28:2201in" : "28:2201in (28:2201 Declaratory Judgement (Insurance))",
      "28:2241" : "28:2241 (28:2241 Petition for Writ of Habeas Corpus)",
      "28:2254" : "28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))",
      "28:2254se" : "28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)",
      "28:2255" : "28:2255 (28:2255 Petition for Writ of Habeas Corpus (Federal))",
      "28:2271" : "28:2271 (28:2271 Federal Tort Claims Act)",
      "28:2345" : "28:2345 (28:2345 Medicare Recovery)",
      "28:2409" : "28:2409 (28:2409(a) Quiet Title Action)",
      "28:2410" : "28:2410 (28:2410 Quiet Title)",
      "28:2671" : "28:2671 (28:2671 Federal Tort Claims Act)",
      "28:2674" : "28:2674 (28:2674 Federal Tort Claims Act)",
      "28:7402" : "28:7402 (28:7402 Refund of Taxes)",
      "28:7422" : "28:7422 (28:7422 Appeal from Administrative Decision)",
      "29:0151" : "29:0151 (29:151 Labor: Review of Agency Action)",
      "29:0160" : "29:0160 (29:160(1) National Labor Relations Act)",
      "29:0184" : "29:0184 (29:184 Violation Collection Bargain Agreement)",
      "29:0185ep" : "29:0185ep (29:185 Employee Pension Plan)",
      "29:0185lm" : "29:0185lm (29:185 Labor/Mgt. Relations (Contracts))",
      "29:0201do" : "29:0201do (29:201 Denial of Overtime Compensation)",
      "29:0201fl" : "29:0201fl (29:201 Fair Labor Standards Act)",
      "29:0203" : "29:0203 (29:203 Equal Pay Act)",
      "29:0206" : "29:0206 (29:206 Collect Unpaid Wages)",
      "29:0401" : "29:0401 (29:0401 Labor Management Disclosure Act)",
      "29:0621" : "29:0621 (29:621 Job Discrimination (Age))",
      "29:0623" : "29:0623 (29:623 Job Discrimination (Age))",
      "29:0626" : "29:0626 (29:626 Job Discrimination (Age))",
      "29:0633" : "29:0633 (29:633 Job Discrimination (Age))",
      "29:0651" : "29:0651 (29:651 Occupational Safety/Health)",
      "29:0754" : "29:0754 (29:754 Discrimination)",
      "29:0791" : "29:0791 (29:791 Job Discrimination (Rehabilitation Act))",
      "29:0794" : "29:0794 (29:0794 Job Discrimination (Handicap))",
      "29:1001" : "29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)",
      "29:1002" : "29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)",
      "29:1104" : "29:1104 (29:1104 Recovery of Benefits to Employee)",
      "29:1109" : "29:1109 (29:1109 Breach of Fiduciary Duties)",
      "29:1131" : "29:1131 (29:1131 ERISA - Collection of Delinquent Trust Funds)",
      "29:1132" : "29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)",
      "29:1145" : "29:1145 (29:1145 E.R.I.S.A.)",
      "29:1149" : "29:1149 (29:1149 Recover Pension & Profit Sharing)",
      "29:1337" : "29:1337 (29:1337 E.R.I.S.A.)",
      "29:1362" : "29:1362 (29:1362 ERISA)",
      "29:1381" : "29:1381 (29:1381 E.R.I.S.A.)",
      "29:1401" : "29:1401 (29:1401(b)(2) Appeal of Arbitration Award)",
      "29:1451" : "29:1451 (29:1451 E.R.I.S.A.)",
      "29:1801" : "29:1801 (29:1801 Farmworker Rights)",
      "29:790" : "29:790 (29:790 Rehabilitation of Labor)",
      "30:0181" : "30:0181 (30:181 Environment: Review of Agency Action)",
      "30:0801" : "30:0801 (30:0801 Penalities/Federal Mine Safety Health Act - 1977)",
      "30:1201" : "30:1201 (30:1201 Environment: Review of Agency Action)",
      "30:1202" : "30:1202 (30:1202 Mining Reclamation Act)",
      "30:1276" : "30:1276 (30:1276 Interior: Review of Agency Action)",
      "31:3545" : "31:3545 (31:3545 Action to Recovery Money)",
      "31:3729" : "31:3729 (31:3729 False Claims Act)",
      "31:3730" : "31:3730 (31:3730 Qui Tam False Claims Act)",
      "31:3731" : "31:3731 (31:3731 Fraud)",
      "32:4323" : "32:4323 (32:4323 Employment Rights of Uniformed Officers)",
      "33:1319cw" : "33:1319cw (33:1319 Clean Water Act)",
      "33:1319pv" : "33:1319pv (33:1319 Pollutants & Permit Violations)",
      "33:1365" : "33:1365 (33:1365 Environmental Matters)",
      "35:0145" : "35:0145 (35:145 Patent Infringement)",
      "35:0183" : "35:0183 (35:183 Patent Infringement)",
      "35:0271" : "35:0271 (35:271 Patent Infringement)",
      "38:1681" : "38:1681 (38:1681 Recovery of VA Overpayment)",
      "38:1686" : "38:1686 (38:1686 Recovery of VA Overpayment)",
      "38:1780" : "38:1780 (38:1780 Recovery of VA Overpayment)",
      "38:2011" : "38:2011 (38:2011 - Veteran's Readjustment Assistance Act of 1974)",
      "38:3116" : "38:3116 (38:3116 VA Overpayment)",
      "39:3005" : "39:3005 (39:3005 Detention of Mail for Temporary Periods)",
      "39:409" : "39:409 (39:409 Postal Service)",
      "40:0258" : "40:0258 (40:258(a) Public Buildings & Property: Land Condemnation)",
      "40:0270" : "40:0270 (40:270 Miller Act)",
      "40:0875" : "40:0875 (40:875 Public Buildings & Property: Negligence)",
      "41:0251" : "41:0251 (41:251 Public Contracts-Review of Agency Action)",
      "41:1463" : "41:1463 (41:1463 Public Contracts: Unlawful Employment Practices)",
      "42:0205" : "42:0205 (42:205 Denial Social Security Benefits)",
      "42:0206" : "42:0206 (42:206 Social Security Benefits)",
      "42:0247" : "42:0247 (42:247 Personal Injury-Swine Flu)",
      "42:0402" : "42:0402 (42:402 Social Security Benefits)",
      "42:0405id" : "42:0405id (42:405 Review of HHS Decision (SSID))",
      "42:0405wc" : "42:0405wc (42:405 Review of HHS Decision (DIWC))",
      "42:0405ww" : "42:0405ww (42:405 Review of HHS Decision (DIWW))",
      "42:0416" : "42:0416 (42:416 Denial of Social Security Benefits)",
      "42:0427" : "42:0427 (42:0427 Social Security Benefits)",
      "42:12101" : "42:12101 (42:12101 Americans with Disabilities Act)",
      "42:1383" : "42:1383 (42:1383 Review of HHS Decision)",
      "42:1395" : "42:1395 (42:1395 HHS: Adverse Reimbursement Review)",
      "42:1396" : "42:1396 (42:1396 - Tort Negligence)",
      "42:1471" : "42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclosure Sale)",
      "42:1981cv" : "42:1981cv (42:1981 Civil Rights)",
      "42:1981hs" : "42:1981hs (42:1981 Housing Discrimination)",
      "42:1981jb" : "42:1981jb (42:1981 Job Discrimination (Race))",
      "42:1981sx" : "42:1981sx (42:1981 Sex Discrimination)",
      "42:1983cv" : "42:1983cv (42:1983 Civil Rights Act)",
      "42:1983ed" : "42:1983ed (42:1983 Civil Rights (Employment Discrimination))",
      "42:1983pr" : "42:1983pr (42:1983 Prisoner Civil Rights)",
      "42:1986" : "42:1986 (42:1986 Neglect of Duty)",
      "42:2000ag" : "42:2000ag (42:2000 Job Discrimination (Age))",
      "42:2000e" : "42:2000e (42:2000e Job Discrimination (Employment))",
      "42:2000pb" : "42:2000pb (42:2000 Job Discrimination (Public Accomodations))",
      "42:2000ra" : "42:2000ra (42:2000 Job Discrimination (Race))",
      "42:2000sx" : "42:2000sx (42:2000 Job Discrimination (Sex))",
      "42:2003" : "42:2003 (42:2003 Job Discrimination)",
      "42:2005" : "42:2005 (42:2005 Review of Agency Action-HHS)",
      "42:2651" : "42:2651 (42:2651 Medical Care Recovery)",
      "42:3601" : "42:3601 (42:405 Fair Housing Act)",
      "42:4000" : "42:4000 (42:4000 National Flood Insurance Act)",
      "42:4001" : "42:4001 (42:4001 National Insurance Flood Act)",
      "42:4053" : "42:4053 (42:4053 Breach of Insurance Contract)",
      "42:4072" : "42:4072 (42:4072 Payment of Flood Insurance Claim)",
      "42:4321" : "42:4321 (42:4321 Review of Agency Action-Environment)",
      "42:4332" : "42:4332 (42:4332 Environmental Policy - Coop of Agency Reports)",
      "42:6901en" : "42:6901en (42:6901 Environmental Cleanup Expenses)",
      "42:6901rs" : "42:6901rs (42:6901 Resource & Recovery Act)",
      "42:7413" : "42:7413 (42:7413(b) Clean Air Act)",
      "42:7604cl" : "42:7604cl (42:7604 Clear Air Act (Emission Standards))",
      "42:7604ir" : "42:7604ir (42:7604 Petition to Quash IRS Summons)",
      "42:9607" : "42:9607 (42:9607 Real Property Tort to Land)",
      "43:945" : "43:945 (43:945 Compensation for Land Condemnation)",
      "43:945a" : "43:945a (43:945a Complaint in Condemnation)",
      "43:946" : "43:946 (43:946 Complaint in Condemnation - Eminent Domain)",
      "45:0051" : "45:0051 (45:51 Railways: Fed. Employer's Liability Act)",
      "45:0151" : "45:0151 (45:151 Railway Labor Act)",
      "45:0184" : "45:0184 (45:184 Action to Set Aside Award of a System Board of Adjust)",
      "45:1395" : "45:1395 (45:1395 Railroads: Adverse Reimbursement Review)",
      "45:7457" : "45:7457 (45:7457 Compel Reclamation Under Clear Air Act)",
      "46:0688" : "46:0688 (46:688 Jones Act)",
      "46:0741" : "46:0741 (46:741 Shipping)",
      "46:0761" : "46:0761 (46:761 Shipping: Damages for Death on High Seas)",
      "46:1101" : "46:1101 (46:1101 Violation of Maritime Regulations)",
      "46:1156" : "46:1156 (46:1156 Administrative Procedure Act)",
      "47:0227" : "47:0227 (47:227 Telephone Consumer Protection Act)",
      "47:0553" : "47:0553 (47:553 Unauthorized Reception of Cable Service)",
      "48:0883" : "48:0883 (48:883 Violation of US Coastal Law)",
      "48:1985" : "48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)",
      "49:0081" : "49:0081 (49:81 Damaged Goods While Being Transported)",
      "49:0781" : "49:0781 (49:781 Forfeiture)",
      "49:11503" : "49:11503 (49:11503 Railroad Revitalization Regulatory Reform Act)",
      "49:11702" : "49:11702 (49:11702(a)(4) Violations of Interstate Commerce Act)",
      "49:1471" : "49:1471 (49:1471 Federal Aviation Act)",
      "49:1903" : "49:1903 (49:1903 Petition to enforce administrative summons)",
      "8:287" : "8:287 (8:287 Petition to Enforce INS Subpoena)",
      "misc" : "misc (Civil Miscellaneous Case)"
   },
   "candce" : {
      "0" : "0 (No cause code entered)",
      "00:0000" : "00:0000 (00:0000 Cause Code Unknown)",
      "02:0431" : "02:0431 (02:431 Fed. Election Commission: Failure Enforce Compliance)",
      "02:0437" : "02:0437 (02:437 Federal Election Commission)",
      "05:0075" : "05:0075 (05:75(2) Contract - Reduction in Grade)",
      "05:0551" : "05:0551 (05:551 Administrative Procedure Act)",
      "05:0552fi" : "05:0552fi (05:552 Freedom of Information Act)",
      "05:0552pa" : "05:0552pa (05:552 Right to Privacy Act)",
      "05:0554" : "05:0554 (05:0554 Constitutionality of Maritime Statutes)",
      "05:0701" : "05:0701 (05:0701 Maritime Subsidy Board)",
      "05:0702" : "05:0702 (05:702 Administrative Procedure Act)",
      "05:0704" : "05:0704 (05:704 Labor Litigation)",
      "05:7703" : "05:7703 (05:7703 Discrimination - Review of Agency Act)",
      "07:0006" : "07:0006 (7:6(b) Federal Commodity Exchange Regulation)",
      "07:0025" : "07:0025 (7:25 Fraud - Commodities Leverage Contracts)",
      "07:0181" : "07:0181 (07:181 Packers & Stockyard Act)",
      "07:0499" : "07:0499 (07:499 Agricultural Commodities Act)",
      "07:0601" : "07:0601 (07:601 USDA Condemnation)",
      "07:2321" : "07:2321 (07:2321 Plant Variety Protection Act)",
      "08:1105" : "08:1105 (8:1105(a) Aliens: Habeas Corpus to Release INS Detainee)",
      "08:1252" : "08:1252 (08:1252(a)(2) Injunction for Deportation)",
      "08:1260" : "08:1260 (08:1260 Aliens: Access to Records)",
      "08:1324" : "08:1324 (08:1324 Aliens: Complaint for Forfeiture)",
      "08:1329" : "08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petition)",
      "08:1421" : "08:1421 (Review of denial of an application for naturalization)",
      "08:1446" : "08:1446 (8:1446 Petition for Naturalization Hearing)",
      "08:1447" : "08:1447 (Application for Naturalization)",
      "08:287" : "08:287 (8:287 Petition to Enforce INS Subpoena)",
      "09:0001" : "09:0001 (09:1 U.S. Arbitration Act)",
      "09:0009" : "09:0009 (9:9 Motion to Confirm Arbitration Loan)",
      "09:0010" : "09:0010 (09:0010 Petition to Vacate Arbitration Award)",
      "09:0201" : "09:0201 (09:201 Petition for Enforcement of Foreign Arbitration Award)",
      "10:1552" : "10:1552 (10:1552 Armed Forces: Action to Correct Records)",
      "10:1553" : "10:1553 (10:1553 Armed Forces: FOIA General)",
      "10:2305" : "10:2305 (10:2305 Review of Federal Contract)",
      "11:0101" : "11:0101 (11:101 Bankruptcy)",
      "12:0022" : "12:0022 (12:22 Securities Fraud)",
      "12:0635" : "12:0635 (12:635 Breach of Insurance Contract)",
      "12:1461" : "12:1461 (12:1461 Homeowners Loan Act)",
      "12:1703" : "12:1703 (12:1703 Default of HUD Loan)",
      "12:1725" : "12:1725 (12:1725 Collection under Contract Guaranty)",
      "12:1730" : "12:1730 (12:1730 Collection Under Contract Guaranty)",
      "12:1819" : "12:1819 (12:1819 Default of Promissory Note)",
      "12:1821" : "12:1821 (12:1821 Default of Loan by Promissary Note)",
      "12:1971" : "12:1971 (12:1971 Relief under Bank Holding Act)",
      "12:3410" : "12:3410 (12:3410 Right to Financial Privacy Act)",
      "12:4001" : "12:4001 (Expedited Funds Availability Act)",
      "15:0001" : "15:0001 (15:1 Antitrust Litigation)",
      "15:0002at" : "15:0002at (15:2 Antitrust Litigation)",
      "15:0002fl" : "15:0002fl (15:2(a) Fair Labor Standards Act)",
      "15:0005" : "15:0005 (15:5(a) Fair Labor Standards Act)",
      "15:0015" : "15:0015 (15:15 Antitrust Litigation)",
      "15:0025" : "15:0025 (15:25 Clayton Act)",
      "15:0044" : "15:0044 (15:44 Trademark Infringement)",
      "15:0045" : "15:0045 (15:0045 Federal Trade Commission Act)",
      "15:0052" : "15:0052 (15:0052 Federal Trade Commission Act)",
      "15:0053" : "15:0053 (15:0053 Federal Trade Commission Act)",
      "15:0053b" : "15:0053b (15:53(b) - Prelim & Perm Inj Relief & other Equitable Relief)",
      "15:0077" : "15:0077 (15:77 Securities Fraud)",
      "15:0078" : "15:0078 (15:78m(a) Securities Exchange Act)",
      "15:0631" : "15:0631 (15:631 Small Business Act)",
      "15:0717" : "15:0717 (15:717 Natural Gas Act)",
      "15:1051" : "15:1051 (15:1051 Trademark Infringement)",
      "15:1114" : "15:1114 (15:1114 Trademark Infringement)",
      "15:1121" : "15:1121 (15:1121 Trademark Infringement)",
      "15:1125" : "15:1125 (15:1125 Trademark Infringement (Lanham Act))",
      "15:1126" : "15:1126 (15:1126 Patent Infringement)",
      "15:1127" : "15:1127 (15:1127 Trademark Infringement)",
      "15:1601" : "15:1601 (15:1601 Truth in Lending)",
      "15:1640" : "15:1640 (15:1640 Truth in Lending)",
      "15:1681" : "15:1681 (15:1681 Fair Credit Reporting Act)",
      "15:1692" : "15:1692 (15:1692 Fair Debt Collection Act)",
      "15:1938" : "15:1938 (15:1938 Fair Labor Standards Act)",
      "15:1981" : "15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))",
      "15:1988" : "15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))",
      "15:1989" : "15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))",
      "15:2301" : "15:2301 (15:2301 Magnuson-Moss Warranty Act)",
      "15:2801" : "15:2801 (15:2801 Petroleum Marketing Practices Act)",
      "15:53(b)" : "15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equita)",
      "16:0668" : "16:0668 (16:668 Bald Eagle Protection Act)",
      "16:0703" : "16:0703 (16:703 Migratory Bird Act)",
      "16:1361" : "16:1361 ()",
      "16:1538" : "16:1538 (16:1538 Endangered Species Act)",
      "16:3371" : "16:3371 (16:3371 Wildlife Under the Lacey Act)",
      "16:3372" : "16:3372 (16:3372 Conservation: Complaint for Forfeiture)",
      "16:3373" : "16:3373 (16:3373 Appeal of Decision - DOI)",
      "16:3374" : "16:3374 (16:3374 Conservation: Complaint for Forfeiture)",
      "17:0101" : "17:0101 (17:101 Copyright Infringement)",
      "17:0501" : "17:0501 (17:501 Copyright Infringement)",
      "17:0504" : "17:0504 (17:504 Copyright Infringement)",
      "18:0241" : "18:0241 (18:241 Conspiracy Against Citizen Rights)",
      "18:1836a" : "18:1836a (18:1836(a) - Injunction against Misappropriation of Trade Secrets)",
      "18:1836b" : "18:1836b (18:1836(b) - Civil Action to Protect Trade Secrets)",
      "18:1961" : "18:1961 (18:1961 Racketeering (RICO) Act)",
      "18:1962" : "18:1962 (18:1962 Racketeering (RICO) Act)",
      "18:1964" : "18:1964 (18:1964 Racketeering (RICO) Act)",
      "18:4208" : "18:4208 (18:4208(B) Agency Action Review)",
      "19:1305" : "19:1305 (19:1305 Custom Duties: Forfeiture-Immoral Articles)",
      "20:1071" : "20:1071 (Defaulted Student Loan)",
      "20:1080" : "20:1080 (20:1080 Student Loan Recovery)",
      "20:1400" : "20:1400 (20:1400 Civil Rights of Handicapped Child)",
      "20:1401" : "20:1401 (20:1401 Education: Handicapped Child Act)",
      "21:0841" : "21:0841 (21:841 Forfeiture Property-Drugs)",
      "21:0881" : "21:0881 (21:881 Forfeiture Property-Drugs)",
      "21:0881a" : "21:0881a (21:881 Forfeiture Property - Aircraft)",
      "21:0881re" : "21:0881re (21:881 Forfeiture Property - Real Estate)",
      "23:0134" : "23:0134 (23:134 P.I.- Auto Negligence)",
      "23:1441" : "23:1441 (23:1441 Contract Real Estate)",
      "24:1000" : "24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)",
      "25:0640" : "25:0640 (25:640 Indian Tribal Rights)",
      "25:1901" : "25:1901 (25:1901 Indian Child Welfare Act)",
      "26:6103" : "26:6103 (26:6103 Taxpayer wrongful disclosure)",
      "26:6212" : "26:6212 (26:6212 Injunctive Relief from IRS Lien)",
      "26:6213" : "26:6213 (26:6213 Injunctive Relief from IRS Lien)",
      "26:6502" : "26:6502 (26:6502 IRS:Enforcement of tax liens)",
      "26:6532" : "26:6532 (26:6532 IRS: Refund of Tax Penalty)",
      "26:6702" : "26:6702 (26:6702 IRS: Refund of Income Tax Penalty)",
      "26:6703" : "26:6703 (26:6703 IRS: Refund of Tax Penalty)",
      "26:7401" : "26:7401 (26:7401 IRS: Tax Liability)",
      "26:7402" : "26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)",
      "26:7403" : "26:7403 (26:7403 Suit to Enforce Federal Tax Lien)",
      "26:7422rt" : "26:7422rt (26:7422 IRS: Refund Taxes)",
      "26:7422rx" : "26:7422rx (26:7422 IRS: Refund Excise Tax)",
      "26:7426" : "26:7426 (26:7426 IRS: Wrongful Levy for Taxes)",
      "26:7429" : "26:7429 (26:7429 IRS: Tax Jeopardy Assessment)",
      "26:7431" : "26:7431 (26:7431 Taxpayer wrongful disclosure)",
      "26:7609" : "26:7609 (26:7609 IRS: Petition to Quash IRS Summons)",
      "27:0185" : "27:0185 (27:185 Enforcement of Arbitration Award)",
      "28:0157c" : "28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)",
      "28:0157d" : "28:0157d (28:0157 Motion for Withdrawal of Reference)",
      "28:0158" : "28:0158 (28:0158 Notice of Appeal re Bankruptcy Matter (BAP))",
      "28:0185" : "28:0185 (28:185 Suit to Compel Arbitration)",
      "28:0451" : "28:0451 (28:451 Employment Discrimination)",
      "28:0794" : "28:0794 (28:794 Rehabilitation Act)",
      "28:1001" : "28:1001 (28:1001 E.R.I.S.A.)",
      "28:1132" : "28:1132 (28:1132 E.R.I.S.A.)",
      "28:1330" : "28:1330 (28:1330 Breach of Contract)",
      "28:1331" : "28:1331 (28:1331 Fed. Question)",
      "28:1331al" : "28:1331al (28:1331 Fed. Question: Airline Crash)",
      "28:1331at" : "28:1331at (28:1331 Fed. Question: Anti-trust)",
      "28:1331au" : "28:1331au (28:1331 Fed. Question: Auto Negligence)",
      "28:1331b" : "28:1331b (28:1331 Federal Question: Bivens Act)",
      "28:1331bc" : "28:1331bc (28:1331 Fed. Question: Breach of Contract)",
      "28:1331ca" : "28:1331ca (28:1331 Fed Question: Fed Communications Act of 1934)",
      "28:1331cm" : "28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)",
      "28:1331cv" : "28:1331cv (28:1331 Federal Question: Other Civil Rights)",
      "28:1331ed" : "28:1331ed (28:1331 Fed. Question: Employment Discrimination)",
      "28:1331es" : "28:1331es (28:1331 Enforcement of Administrative Subpoena)",
      "28:1331fl" : "28:1331fl (28:1331 Fed. Question: Fair Labor Standards)",
      "28:1331in" : "28:1331in (28:1331 Fed. Question: Insurance Contract)",
      "28:1331mm" : "28:1331mm (28:1331 Fed. Question: Medical Malpractice)",
      "28:1331pi" : "28:1331pi (28:1331 Fed. Question: Personal Injury)",
      "28:1331rd" : "28:1331rd (28:1331 Fed. Question: Review Agency Decision)",
      "28:1331rp" : "28:1331rp (28:1331(a) Fed. Question: Real Property)",
      "28:1331rr" : "28:1331rr (28:1331 Fed. Question: Railway Labor Act)",
      "28:1331sv" : "28:1331sv (28:1331 Fed. Question: Securities Violation)",
      "28:1331tr" : "28:1331tr (28:1331 Fed. Question: Trademark)",
      "28:1331tt" : "28:1331tt (28:1331 Fed. Question: Tort Action)",
      "28:1331v" : "28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendment)",
      "28:1331wl" : "28:1331wl (28:1331 Federal Question: EPA Waste Lien)",
      "28:1331wt" : "28:1331wt (28:1331 Fed. Question: Water Rights)",
      "28:1332ac" : "28:1332ac (28:1332 Diversity-Account Receivable)",
      "28:1332al" : "28:1332al (28:1332 Diversity-Airline Crash)",
      "28:1332as" : "28:1332as (28:1332 Diversity-Asbestos Litigation)",
      "28:1332au" : "28:1332au (28:1332 Diversity-Auto Negligence)",
      "28:1332bc" : "28:1332bc (28:1332 Diversity-Breach of Contract)",
      "28:1332co" : "28:1332co (28:1332 Diversity-Conversion)",
      "28:1332ct" : "28:1332ct (28:1332 Diversity-(Citizenship))",
      "28:1332det" : "28:1332det (28:1332 Diversity-Forcible Detainer)",
      "28:1332df" : "28:1332df (28:1332 Diversity-Contract Default)",
      "28:1332ds" : "28:1332ds (28:1332 Diversity-Contract Dispute)",
      "28:1332ed" : "28:1332ed (28:1332 Diversity-Employment Discrimination)",
      "28:1332fd" : "28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)",
      "28:1332fls" : "28:1332fls (28:1332 Diversity-Fair Labor Standards Act)",
      "28:1332fr" : "28:1332fr (28:1332 Diversity-Fraud)",
      "28:1332ia" : "28:1332ia (28:1332 Diversity-Interpleader Action)",
      "28:1332ij" : "28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)",
      "28:1332in" : "28:1332in (28:1332 Diversity-Insurance Contract)",
      "28:1332jd" : "28:1332jd (28:1332 Diversity-Declaratory Judgement)",
      "28:1332lb" : "28:1332lb (28:1332 Diversity-Libel,Assault,Slander)",
      "28:1332lm" : "28:1332lm (28:1332 Diversity-Legal Malpractice)",
      "28:1332ma" : "28:1332ma (28:1332 Diversity-Miller Act)",
      "28:1332mm" : "28:1332mm (28:1332 Diversity-Medical Malpractice)",
      "28:1332mv" : "28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)",
      "28:1332ni" : "28:1332ni (28:1332 Diversity-Negotiable Instrument)",
      "28:1332nm" : "28:1332nm (28:1332 Diversity-Non-Motor Vehicle)",
      "28:1332oc" : "28:1332oc (28:1332 Diversity-Other Contract)",
      "28:1332pd" : "28:1332pd (28:1332 Diversity-Property Damage)",
      "28:1332pi" : "28:1332pi (28:1332 Diversity-Personal Injury)",
      "28:1332pl" : "28:1332pl (28:1332 Diversity-Product Liability)",
      "28:1332pp" : "28:1332pp (28:1332 Diversity-Personal Property)",
      "28:1332pr" : "28:1332pr (28:1332 Diversity-Petition for Removal)",
      "28:1332qt" : "28:1332qt (28:1332 Diversity-Petition to Quiet Title)",
      "28:1332ri" : "28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)",
      "28:1332sa" : "28:1332sa (28:1332 Diversity-Securities & Exchange Commission Act)",
      "28:1332sf" : "28:1332sf (28:1332 Diversity-Securities Fraud)",
      "28:1332ss" : "28:1332ss (28:1332 Diversity-Stockholders Suits)",
      "28:1332tl" : "28:1332tl (28:1332 Diversity-Torts to Land)",
      "28:1332tm" : "28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))",
      "28:1332tn" : "28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)",
      "28:1332wd" : "28:1332wd (28:1332 Diversity-Wrongful Death)",
      "28:1333" : "28:1333 (28:1333 Admiralty)",
      "28:1334" : "28:1334 (28:1334 Bankruptcy cases and proceedings under title 11)",
      "28:1334c" : "28:1334c (28:1334(c) R&R re motions for abstention (non-core))",
      "28:1335" : "28:1335 (28:1335 Interpleader Action)",
      "28:1337" : "28:1337 (28:1337 Sherman-Clayton Act)",
      "28:1338cp" : "28:1338cp (28:1338 Copyright Infringement)",
      "28:1338pt" : "28:1338pt (28:1338 Patent Infringement)",
      "28:1338tr" : "28:1338tr (28:1338 Trademark Infringement)",
      "28:1340" : "28:1340 (28:1340 IRS: Custom Duties)",
      "28:1340er" : "28:1340er (28:1340 Recovery of Erroneous Refund)",
      "28:1341" : "28:1341 (28:1341 Complaint for Forfeiture)",
      "28:1343" : "28:1343 (28:1343 Violation of Civil Rights)",
      "28:1345co" : "28:1345co (28:1345 Replevin & Conversion)",
      "28:1345db" : "28:1345db (28:1345 Debt to US - FHA/HUD Title I)",
      "28:1345df" : "28:1345df (28:1345 Default of Promissory Note)",
      "28:1345er" : "28:1345er (28:1345 Recovery of Erroneous Refund)",
      "28:1345fc" : "28:1345fc (28:1345 Foreclosure)",
      "28:1345ff" : "28:1345ff (28:1345 Complaint for Forfeiture)",
      "28:1345hl" : "28:1345hl (28:1345 VA Home Loan Guaranty Debt)",
      "28:1345mc" : "28:1345mc (28:1345 Medical Care Recovery)",
      "28:1345mi" : "28:1345mi (28:1345 Mining Claim Ejectment)",
      "28:1345pd" : "28:1345pd (28:1345 Property Damage)",
      "28:1345pe" : "28:1345pe (28:1345 Property Ejectment)",
      "28:1345rc" : "28:1345rc (28:1345 Recovery of Debt to US)",
      "28:1345st" : "28:1345st (28:1345 Default of Student Loan)",
      "28:1345tp" : "28:1345tp (28:1345 Trespass on Public Land)",
      "28:1345va" : "28:1345va (28:1345 Recovery of VA Overpayment)",
      "28:1346bc" : "28:1346bc (28:1346 Breach of Contract)",
      "28:1346rc" : "28:1346rc (28:1346 Recovery of IRS Tax)",
      "28:1346tc" : "28:1346tc (28:1346 Tort Claim)",
      "28:1346wd" : "28:1346wd (28:1346 Wrongful Death)",
      "28:1352" : "28:1352 (28:1352 Miller Act)",
      "28:1355" : "28:1355 (28:1355 Petition for Return of Property)",
      "28:1358" : "28:1358 (28:1358 Land Condemnation)",
      "28:1361" : "28:1361 (28:1361 Petition for Writ of Mandamus)",
      "28:1362ic" : "28:1362ic (28:1362 Indian Tribal Controversy)",
      "28:1362iw" : "28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)",
      "28:1364" : "28:1364 (28:1364 Auto Negligence)",
      "28:1391" : "28:1391 (28:1391 Personal Injury)",
      "28:1402" : "28:1402 (28:1402 Medical Malpractice)",
      "28:1407" : "28:1407 (28:1407 Airline Crash)",
      "28:1441ac" : "28:1441ac (28:1441 Petition for Removal- Account Receivable)",
      "28:1441al" : "28:1441al (28:1441 Petition for Removal- Airline Crash)",
      "28:1441as" : "28:1441as (28:1441 Petition for Removal- Asbestos Litigation)",
      "28:1441au" : "28:1441au (28:1441 Petition for Removal- Auto Negligence)",
      "28:1441bc" : "28:1441bc (28:1441 Petition for Removal- Breach of Contract)",
      "28:1441cv" : "28:1441cv (28:1441 Petition for Removal- Civil Rights Act)",
      "28:1441df" : "28:1441df (28:1441 Petition for Removal- Contract Default)",
      "28:1441dj" : "28:1441dj (28:1441 Petition for Removal- Declaratory Judgement)",
      "28:1441ds" : "28:1441ds (28:1441 Petition for Removal- Contract Dispute)",
      "28:1441ed" : "28:1441ed (28:1441 Petition for Removal - Employment Discrimination)",
      "28:1441fc" : "28:1441fc (28:1441 Petition for Removal - Fair Credit Reporting Act)",
      "28:1441fr" : "28:1441fr (28:1441 Petition for Removal- Fraud)",
      "28:1441ij" : "28:1441ij (28:1441 Petition for Removal- Injunctive/Declaratory Relief)",
      "28:1441in" : "28:1441in (28:1441 Petition for Removal- Insurance Contract)",
      "28:1441int" : "28:1441int (28:1441 Petition for Removal- Action for Interpleader)",
      "28:1441lb" : "28:1441lb (28:1441 Petition for Removal Libel,Assault,Slander)",
      "28:1441lm" : "28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relations)",
      "28:1441mm" : "28:1441mm (28:1441 Petition for Removal- Medical Malpractice)",
      "28:1441ni" : "28:1441ni (28:1441 Petition for Removal- Negotiable Instrument)",
      "28:1441nm" : "28:1441nm (28:1441 Petition for Removal- Non-Motor Vehicle)",
      "28:1441oc" : "28:1441oc (28:1441 Petition For Removal--Other Contract)",
      "28:1441pd" : "28:1441pd (28:1441 Petition for Removal- Property Damage)",
      "28:1441pi" : "28:1441pi (28:1441 Petition for Removal- Personal Injury)",
      "28:1441pl" : "28:1441pl (28:1441 Petition for Removal- Product Liability)",
      "28:1441pr" : "28:1441pr (28:1441 Petition for Removal)",
      "28:1441qt" : "28:1441qt (28:1441 Petition for Removal- Petition to Quiet Title)",
      "28:1441ri" : "28:1441ri (28:1441 Petition for Removal- Racketeering (RICO) Act)",
      "28:1441sa" : "28:1441sa (28:1441 - Petition for Removal: SEC Act)",
      "28:1441sf" : "28:1441sf (28:1441 - Petition for Removal: Securities Fraud)",
      "28:1441tl" : "28:1441tl (28:1441 Petition for Removal- Torts to Land)",
      "28:1441tm" : "28:1441tm (28:1441 Petition for Removal- Tort/Motor Vehicle (P.I.))",
      "28:1441tn" : "28:1441tn (28:1441 Petition for Removal- Tort/Non-Motor Vehicle)",
      "28:1441wd" : "28:1441wd (28:1441 Petition for Removal- Wrongful Death)",
      "28:1442bc" : "28:1442bc (28:1442 Petition for Removal- Breach of Contract)",
      "28:1442pr" : "28:1442pr (28:1442 Petition for Removal)",
      "28:1443" : "28:1443 (28:1443(1) Rent, Lease & Ejectment)",
      "28:1444" : "28:1444 (28:1444 Petition for Removal- Foreclosure)",
      "28:1446in" : "28:1446in (28:1446 Breach of Contract- Insurance)",
      "28:1446pd" : "28:1446pd (28:1446 Petition for Removal- Property Damage (P.I.))",
      "28:1446pi" : "28:1446pi (28:1446 Petition for Removal- Personal Injury)",
      "28:1446pl" : "28:1446pl (28:1446pl Petition for Removal - Product Liability)",
      "28:1446pr" : "28:1446pr (28:1446 Petition for Removal)",
      "28:1452" : "28:1452 (28:1452 R&R re motions to remand (non-core))",
      "28:1651" : "28:1651 (28:1651 Petition for Writ of Coram Nobis)",
      "28:1651hc" : "28:1651hc (28:1651 Petition for Writ of Habeas Corpus)",
      "28:1651mn" : "28:1651mn (28:1651 Petition for Writ of Mandamus)",
      "28:2201" : "28:2201 (28:2201 Constitutionality of State Statutes)",
      "28:2201dj" : "28:2201dj (28:2201 Declaratory Judgement)",
      "28:2201ij" : "28:2201ij (28:2201 Injunction)",
      "28:2201in" : "28:2201in (28:2201 Declaratory Judgement (Insurance))",
      "28:2241" : "28:2241 (28:2241 Petition for Writ of Habeas Corpus)",
      "28:2254" : "28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))",
      "28:2254se" : "28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)",
      "28:2255" : "28:2255 (28:2255 Petition for Writ of Habeas Corpus (Federal))",
      "28:2271" : "28:2271 (28:2271 Federal Tort Claims Act)",
      "28:2345" : "28:2345 (28:2345 Medicare Recovery)",
      "28:2409" : "28:2409 (28:2409(a) Quiet Title Action)",
      "28:2410" : "28:2410 (28:2410 Quiet Title)",
      "28:2671" : "28:2671 (28:2671 Federal Tort Claims Act)",
      "28:2674" : "28:2674 (28:2674 Federal Tort Claims Act)",
      "28:7402" : "28:7402 (28:7402 Refund of Taxes)",
      "28:7422" : "28:7422 (28:7422 Appeal from Administrative Decision)",
      "29:0151" : "29:0151 (29:151 Labor: Review of Agency Action)",
      "29:0160" : "29:0160 (29:160(1) National Labor Relations Act)",
      "29:0184" : "29:0184 (29:184 Violation Collection Bargain Agreement)",
      "29:0185ep" : "29:0185ep (29:185 Employee Pension Plan)",
      "29:0185lm" : "29:0185lm (29:185 Labor/Mgt. Relations (Contracts))",
      "29:0201do" : "29:0201do (29:201 Denial of Overtime Compensation)",
      "29:0201fl" : "29:0201fl (29:201 Fair Labor Standards Act)",
      "29:0203" : "29:0203 (29:203 Equal Pay Act)",
      "29:0206" : "29:0206 (29:206 Collect Unpaid Wages)",
      "29:0401" : "29:0401 (29:0401 Labor Management Disclosure Act)",
      "29:0621" : "29:0621 (29:621 Job Discrimination (Age))",
      "29:0623" : "29:0623 (29:623 Job Discrimination (Age))",
      "29:0626" : "29:0626 (29:626 Job Discrimination (Age))",
      "29:0633" : "29:0633 (29:633 Job Discrimination (Age))",
      "29:0651" : "29:0651 (29:651 Occupational Safety/Health)",
      "29:0754" : "29:0754 (29:754 Discrimination)",
      "29:0791" : "29:0791 (29:791 Job Discrimination (Rehabilitation Act))",
      "29:0794" : "29:0794 (29:0794 Job Discrimination (Handicap))",
      "29:1001" : "29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)",
      "29:1002" : "29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)",
      "29:1104" : "29:1104 (29:1104 Recovery of Benefits to Employee)",
      "29:1109" : "29:1109 (29:1109 Breach of Fiduciary Duties)",
      "29:1131" : "29:1131 (29:1131 E.R.I.S.A. Collection of Delinquent Trust Funds)",
      "29:1132" : "29:1132 (29:1132 E.R.I.S.A.: Employee Benefits)",
      "29:1144a" : "29:1144a (29:1144(a) E.R.I.S.A supersedes state law employee benefits)",
      "29:1145" : "29:1145 (29:1145 E.R.I.S.A.)",
      "29:1149" : "29:1149 (29:1149 Recover Pension & Profit Sharing)",
      "29:1337" : "29:1337 (29:1337 E.R.I.S.A.)",
      "29:1362" : "29:1362 (29:1362 E.R.I.S.A.)",
      "29:1381" : "29:1381 (29:1381 E.R.I.S.A.)",
      "29:1401" : "29:1401 (29:1401(b)(2) Appeal of Arbitration Award)",
      "29:1451" : "29:1451 (29:1451 E.R.I.S.A.)",
      "29:1801" : "29:1801 (29:1801 Farmworker Rights)",
      "29:790" : "29:790 (29:790 Rehabilitation of Labor)",
      "30:0181" : "30:0181 (30:181 Environment: Review of Agency Action)",
      "30:0801" : "30:0801 (30:0801 Penalities/Federal Mine Safety Health Act - 1977)",
      "30:1201" : "30:1201 (30:1201 Environment: Review of Agency Action)",
      "30:1202" : "30:1202 (30:1202 Mining Reclamation Act)",
      "30:1276" : "30:1276 (30:1276 Interior: Review of Agency Action)",
      "31:3545" : "31:3545 (31:3545 Action to Recovery Money)",
      "31:3729" : "31:3729 (31:3729 False Claims Act)",
      "31:3730" : "31:3730 (31:3730 Qui Tam False Claims Act)",
      "31:3731" : "31:3731 (31:3731 Fraud)",
      "33:1319cw" : "33:1319cw (33:1319 Clean Water Act)",
      "33:1319pv" : "33:1319pv (33:1319 Pollutants & Permit Violations)",
      "33:1321" : "33:1321 ()",
      "33:1344" : "33:1344 ()",
      "33:1365" : "33:1365 (33:1365 Environmental Matters)",
      "35:0145" : "35:0145 (35:145 Patent Infringement)",
      "35:0183" : "35:0183 (35:183 Patent Infringement)",
      "35:0271" : "35:0271 (35:271 Patent Infringement)",
      "38:1681" : "38:1681 (38:1681 Recovery of VA Overpayment)",
      "38:1686" : "38:1686 (38:1686 Recovery of VA Overpayment)",
      "38:1729" : "38:1729 (38:1729 Recovery of Medical Payments)",
      "38:1780" : "38:1780 (38:1780 Recovery of VA Overpayment)",
      "38:2011" : "38:2011 (38:2011 - Veteran's Readjustment Assistance Act of 1974)",
      "38:3116" : "38:3116 (38:3116 VA Overpayment)",
      "39:0409" : "39:0409 (Postal Service)",
      "39:3005" : "39:3005 (39:3005 Detention of Mail for Temporary Periods)",
      "39:409" : "39:409 (39:409 Postal Service)",
      "40:0258" : "40:0258 (40:258(a) Public Buildings & Property: Land Condemnation)",
      "40:0270" : "40:0270 (40:270 Miller Act)",
      "40:0875" : "40:0875 (40:875 Public Buildings & Property: Negligence)",
      "41:0251" : "41:0251 (41:251 Public Contracts-Review of Agency Action)",
      "41:1463" : "41:1463 (41:1463 Public Contracts: Unlawful Employment Practices)",
      "42:0205" : "42:0205 (42:205 Denial Social Security Benefits)",
      "42:0206" : "42:0206 (42:206 Social Security Benefits)",
      "42:0247" : "42:0247 (42:247 Personal Injury-Swine Flu)",
      "42:0402" : "42:0402 (42:402 Social Security Benefits)",
      "42:0405id" : "42:0405id (42:405 Review of HHS Decision (SSID))",
      "42:0405wc" : "42:0405wc (42:405 Review of HHS Decision (DIWC))",
      "42:0405ww" : "42:0405ww (42:405 Review of HHS Decision (DIWW))",
      "42:0416" : "42:0416 (42:416 Denial of Social Security Benefits)",
      "42:0425" : "42:0425 (42:427 Social Security Benefits)",
      "42:0427" : "42:0427 (42:427 Social Security Benefits)",
      "42:12101" : "42:12101 (42:12101 Americans w/ Disabilities Act (ADA))",
      "42:1383" : "42:1383 (42:1383 Review of HHS Decision)",
      "42:1395" : "42:1395 (42:1395 HHS: Adverse Reimbursement Review)",
      "42:1396" : "42:1396 (42:1396 - Tort Negligence)",
      "42:1471" : "42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclosure Sale)",
      "42:1981cv" : "42:1981cv (42:1981 Civil Rights)",
      "42:1981hs" : "42:1981hs (42:1981 Housing Discrimination)",
      "42:1981jb" : "42:1981jb (42:1981 Job Discrimination (Race))",
      "42:1981sx" : "42:1981sx (42:1981 Sex Discrimination)",
      "42:1983cv" : "42:1983cv (42:1983 Civil Rights Act)",
      "42:1983ed" : "42:1983ed (42:1983 Civil Rights (Employment Discrimination))",
      "42:1983pr" : "42:1983pr (42:1983 Prisoner Civil Rights)",
      "42:1986" : "42:1986 (42:1986 Neglect of Duty)",
      "42:2000ag" : "42:2000ag (42:2000 Job Discrimination (Age))",
      "42:2000e" : "42:2000e (42:2000e Job Discrimination (Employment))",
      "42:2000pb" : "42:2000pb (42:2000 Job Discrimination (Public Accomodations))",
      "42:2000ra" : "42:2000ra (42:2000 Job Discrimination (Race))",
      "42:2000sx" : "42:2000sx (42:2000 Job Discrimination (Sex))",
      "42:2003" : "42:2003 (42:2003 Job Discrimination)",
      "42:2005" : "42:2005 (42:2005 Review of Agency Action-HHS)",
      "42:2651" : "42:2651 (42:2651 Medical Care Recovery)",
      "42:3601" : "42:3601 (42:405 Fair Housing Act)",
      "42:4000" : "42:4000 (42:4000 National Flood Insurance Act)",
      "42:4001" : "42:4001 (42:4001 National Insurance Flood Act)",
      "42:4053" : "42:4053 (42:4053 Breach of Insurance Contract)",
      "42:4072" : "42:4072 (42:4072 Payment of Flood Insurance Claim)",
      "42:4321" : "42:4321 (42:4321 Review of Agency Action-Environment)",
      "42:4332" : "42:4332 (42:4332 Environmental Policy - Coop of Agency Reports)",
      "42:6901en" : "42:6901en (42:6901 Environmental Cleanup Expenses)",
      "42:6901rs" : "42:6901rs (42:6901 Resource & Recovery Act)",
      "42:7413" : "42:7413 (42:7413(b) Clean Air Act)",
      "42:7604cl" : "42:7604cl (42:7604 Clear Air Act (Emission Standards))",
      "42:7604ir" : "42:7604ir (42:7604 Petition to Quash IRS Summons)",
      "42:9601" : "42:9601 (42:9601 CERCLA)",
      "42:9607" : "42:9607 (42:9607 Real Property Tort to Land)",
      "42:9613b" : "42:9613b (Environmental Matters)",
      "42:9659" : "42:9659 (42:9659 CERCLA Comprehensive Environmental Response)",
      "43:945" : "43:945 (43:945 Compensation for Land Condemnation)",
      "43:945a" : "43:945a (43:945a Complaint in Condemnation)",
      "43:946" : "43:946 (43:946 Complaint in Condemnation - Eminent Domain)",
      "45:0051" : "45:0051 (45:51 Railways: Fed. Employer's Liability Act)",
      "45:0151" : "45:0151 (45:151 Railway Labor Act)",
      "45:0184" : "45:0184 (45:184 Action to Set Aside Award of a System Board of Adjust)",
      "45:1395" : "45:1395 (45:1395 Railroads: Adverse Reimbursement Review)",
      "45:7457" : "45:7457 (45:7457 Compel Reclamation Under Clear Air Act)",
      "46:0183" : "46:0183 (Petition for limitation of liability)",
      "46:0688" : "46:0688 (46:688 Jones Act)",
      "46:0741" : "46:0741 (46:741 Shipping)",
      "46:0761" : "46:0761 (46:761 Shipping: Damages for Death on High Seas)",
      "46:1101" : "46:1101 (46:1101 Violation of Maritime Regulations)",
      "46:1156" : "46:1156 (46:1156 Administrative Procedure Act)",
      "47:227" : "47:227 (47:227 Telephone Consumer Protection Act)",
      "47:553" : "47:553 (47:553 Communications Act of 1994)",
      "47:605" : "47:605 (47:605 Communications Act of 1994)",
      "48:0883" : "48:0883 (48:883 Violation of US Coastal Law)",
      "48:1985" : "48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)",
      "49:0081" : "49:0081 (49:81 Damaged Goods While Being Transported)",
      "49:0781" : "49:0781 (49:781 Forfeiture)",
      "49:10761" : "49:10761 (49:10761 I.C.C. Tariff Enforcement Action)",
      "49:1150" : "49:1150 ()",
      "49:11503" : "49:11503 (49:11503 Railroad Revitalization Regulatory Reform Act)",
      "49:11702" : "49:11702 (49:11702(a)(4) Violations of Interstate Commerce Act)",
      "49:1471" : "49:1471 (49:1471 Federal Aviation Act)",
      "49:1903" : "49:1903 (49:1903 Petition to enforce administrative summons)",
      "misc" : "misc (Civil Miscellaneous Case)"
   },
   "casdce" : {
      "0" : "0 (No cause code entered)",
      "00:0000" : "00:0000 (00:0000 Cause Code Unknown)",
      "02:0138" : "02:0138 (02:0138 Library of Congress Access)",
      "02:0358" : "02:0358 (02:0358 President's Recommendations on Exec., Jud. & Leg. Salary)",
      "02:0431" : "02:0431 (02:0431 Federal Election Commission: Failure to Enforce Compliance)",
      "02:0437" : "02:0437 (02:0437 Federal Election Commission)",
      "02:0681" : "02:0681 (02:0681 Deferral of Budget Authority)",
      "02:1202" : "02:1202 (02:1202 Discriminatory practices affecting US Senate employees)",
      "02:1301" : "02:1301 (02:1301 Congressional Accountability Act)",
      "02:1317(a)" : "02:1317(a) (02:1317(a) Violation of Congressional Accountability Act)",
      "05:0101" : "05:0101 (05:0101 Ethics in Government Act)",
      "05:0504c2" : "05:0504c2 (05:0504(c )(2) Equal Access to Justice (Govt Employees))",
      "05:0551" : "05:0551 (05:0551 Administrative Procedures Act)",
      "05:0552bg" : "05:0552bg (05:0552b(g)sa Implement requirements of Govt in Sunshine Act)",
      "05:0552fi" : "05:0552fi (05:0552fi Freedom of Information Act)",
      "05:0552pa" : "05:0552pa (05:0552pa Right to Privacy Act)",
      "05:0554" : "05:0554 (05:0554 Adjudications Required by Statutes )",
      "05:0555(b)" : "05:0555(b) (05:0555(b) Agency Decision - Right to Counsel )",
      "05:0701" : "05:0701 (05:0701 Judicial Review of Agency Decision)",
      "05:0702" : "05:0702 (05:0702 Administrative Procedure Act - Right of Review)",
      "05:0704" : "05:0704 (05:0704 Labor Litigation)",
      "05:0706" : "05:0706 (05:0706 Judicial Review of Agency Action)",
      "05:1508" : "05:1508 (05:1508 Judicial Review of Order Issued by the Merit Systems Protection Board)",
      "05:2302" : "05:2302 (05:2302 Federal Whistleblowing Act / Civil Service Reform Act (CSRA))",
      "05:3318" : "05:3318 (05:3318 Veterans Preference Act)",
      "05:5514" : "05:5514 (05:5514 Debt Collection Act of 1982)",
      "05:5542" : "05:5542 (05:5542 Federal Employees Pay Act -- overtime rates)",
      "05:7101" : "05:7101 (05:7101 Labor-Management Relations (Findings and Purpose))",
      "05:7123" : "05:7123 (05:7123 Petition by FLRA against unfair labor practices)",
      "05:7501" : "05:7501 (05:7501 Government Employees Adverse Action--14 days or less)",
      "05:7511" : "05:7511 (05:7511 Government Employees Adverse Action--Over 14 days)",
      "05:7703" : "05:7703 (05:7703 Discrimination - Review of Agency Act)",
      "05:8101" : "05:8101 (05:8101 Workmen's Compensation Benefits)",
      "05:8110" : "05:8110 (05:8110 Augmented Compensation for dependents of Govt. Employees)",
      "05:8316" : "05:8316 (05:8316 Claims agst US re Retirement for Federal Emp.)",
      "05:8470" : "05:8470 (05:8470 Enforcement of Judgment against Retirement Benefits)",
      "05:8701" : "05:8701 (05:8701 Federal Employees Group Life Insurance Act of 1954)",
      "05:8705" : "05:8705 (05:8705 Declaratory Judgment - Insurance)",
      "05:8715" : "05:8715 (05:8715 Claims against the US - Jurisdiction of Courts)",
      "05:8901" : "05:8901 (05:8901 Federal Employees Health Benefits Act)",
      "05:8902" : "05:8902 (05:8902 Contracting Authority of OPM - Group Health Insurance )",
      "05:8903" : "05:8903 (05:8903 Federal Employees Health Benefit Act)",
      "05:8912" : "05:8912 (05:8912 Claims agst US re health benefits for Federal emp.)",
      "07:0001" : "07:0001 (07:0001 Commodity Exchange Act)",
      "07:0006(b)" : "07:0006(b) (07:0006(b) Federal Commodity Exchange Regulation)",
      "07:0009a" : "07:0009a (07:0009a Recovery of penalties by Commodity Futures Trading Com)",
      "07:0013a" : "07:0013a (07:0013a Contract market rules violations; recovery of penalty)",
      "07:0013a-1" : "07:0013a-1 (07:0013a-1 Enjoin or restrain violations Contract Market rules)",
      "07:0025" : "07:0025 (07:0025 Fraud - Commodities Leverage Contracts)",
      "07:0087" : "07:0087 (07:0087 Enforcement of United States Grain Standards Act)",
      "07:0136" : "07:0136 (07:0136 Violations of EPA re Environmental Pesticide Control)",
      "07:0181" : "07:0181 (07:0181 Packers & Stockyards Act)",
      "07:0193(b)" : "07:0193(b) (07:0193(b) Recovery of penalties re violations by packers)",
      "07:0203" : "07:0203 (07:0203 Recovery of penalties for violations by stockyards)",
      "07:0209(b)" : "07:0209(b) (07:0209(b) Violations re purchase, sale, handling of livestock)",
      "07:0210(f)" : "07:0210(f) (07:0210(f) Suit to enforce award of damages (Packers/Stockyards))",
      "07:0213(b)" : "07:0213(b) (07:0213(b) Unfair, discriminatory, deceptive practice/marketing)",
      "07:0216" : "07:0216 (07:0216 Injunctions to restrain & enforce orders of Secretary)",
      "07:0222" : "07:0222 (07:0222 Adoption of FTC powers for enforcement.)",
      "07:0228a" : "07:0228a (07:0228a Request by Secretary for TRO or Inj. re Poultry)",
      "07:0245" : "07:0245 (07:0245 Action on bond by person injured in Warehouse)",
      "07:0292" : "07:0292 (07:0292 Monopolizing or restraining trade & enhancing prices)",
      "07:0499" : "07:0499 (07:0499 Agricultural Commodities Act)",
      "07:0601" : "07:0601 (07:0601 USDA Condemnation)",
      "07:0608" : "07:0608 (07:0608 Agriculture Adjustment Act)",
      "07:0901" : "07:0901 (07:0901 Rural Electrification Act)",
      "07:1291(b)" : "07:1291(b) (07:1291(b) Agricultural Adjustment Act; freight rates.)",
      "07:1376" : "07:1376 (07:1376 Adjustment of Quotas and Enforcement; penalties.)",
      "07:1501" : "07:1501 (07:1501 Federal Crop Insurance Act)",
      "07:1508" : "07:1508 (07:1508 Crop Insurance)",
      "07:1631" : "07:1631 (07:1631 Food Security Act)",
      "07:1721" : "07:1721 (07:1721 Agricultural Trade Development Asst Act)",
      "07:1922" : "07:1922 (07:1922 Persons Eligible for Loans - Forclosure)",
      "07:1926" : "07:1926 (07:1926 Water and Waste Facility Loans and Grants)",
      "07:1930" : "07:1930 (07:1930 Perishable Agric. Comm. Act of 1930)",
      "07:2011" : "07:2011 (07:2011 Supplemental Nutrition Assistance Program)",
      "07:2022" : "07:2022 (07:2022 Disposition of Claims: Denial application to participate; food stamp prog.)",
      "07:2023(a)" : "07:2023(a) (07:2023(a) Judicial Review of Food Stamp Disqualification)",
      "07:2024" : "07:2024 (07:2024 False Claims Act, Food Stamp Fraud)",
      "07:2131" : "07:2131 (07:2131 Violation of the Animal Welfare Act)",
      "07:2146" : "07:2146 (07:2146 Transportation, Sale, and Handling of Animals)",
      "07:2301" : "07:2301 (07:2301 Agricultural Fair Practices Act)",
      "07:2305" : "07:2305 (07:2305 Unfair trade practices affecting producers Agri prod)",
      "07:2321" : "07:2321 (07:2321 Plant Variety Protection Act)",
      "07:2563" : "07:2563 (07:2563 Plant Variety Protection and Rights - Injunction)",
      "07:499E(c)" : "07:499E(c) (07:499E(c )(4) Perishable Agricultural Commodities Act (PACA))",
      "07:6999" : "07:6999 (07:6999 Judicial Review of Adverse Farm Agency Decision)",
      "08:1101i" : "08:1101i (08:1101i Immigration & Nationality Act (Definitions))",
      "08:1105a" : "08:1105a (08:1105a Immigration: Judicial Review for Battered Spouses; Deportation (INS))",
      "08:1151" : "08:1151 (08:1151 Immigration and Nationality Act of 1952)",
      "08:1152" : "08:1152 (08:1152 Immigration: Numerical limitations on individual foreign states)",
      "08:1153" : "08:1153 (08:1153 Immigration: Allocation of Immigrant Visas)",
      "08:1154" : "08:1154 (08:1154 Immigration: Procedure for Granting Immigration Status)",
      "08:1158" : "08:1158 (08:1158 Immigration & Nationality Act, Section 208 (Asylum))",
      "08:1182" : "08:1182 (08:1182 Inadmissible Aliens: Defend. Denial of Pla. Appl. for Alien Employment Cer)",
      "08:1183" : "08:1183 (08:1183 Admission of Aliens on Giving Bond or Undertaking; Return on Departure)",
      "08:1188" : "08:1188 (08:1188 Immigration: Admission of Temporary H-2A Workers)",
      "08:1225" : "08:1225 (08:1225 Immigration: Enforcement of Administrative Subpoena)",
      "08:1231(a)" : "08:1231(a) (08:1231(a) Immigration: Due Process Clause)",
      "08:1251(A)" : "08:1251(A) (08:1251(A)(4) Immigration: Application for a Stay of Deportation)",
      "08:1252" : "08:1252 (08:1252 Judicial Review of Orders of Removal)",
      "08:1255" : "08:1255 (08:1255 Immigration: Failure USCIS To Adjudicate Permanent Residency Petition)",
      "08:1260" : "08:1260 (08:1260 Aliens: Removal of Aliens Falling into Distress)",
      "08:1324" : "08:1324 (08:1324 Immigration: Complaint for Forfeiture)",
      "08:1329" : "08:1329 (08:1329 Immigration: Writ of Mandamus to Adjudicate Visa Petition)",
      "08:1357" : "08:1357 (08:1357 Immigration and Nationality Act - Administrative Search Warrant)",
      "08:1421" : "08:1421 (08:1421 Immigration: Naturalization Authority)",
      "08:1445" : "08:1445 (08:1445 Immigration: Application for Naturalization)",
      "08:1446" : "08:1446 (08:1446 Immigration: Petition for Naturalization Hearing)",
      "08:1447" : "08:1447 (08:1447 Immigration: Review of Denial of Naturalization Application)",
      "08:1451" : "08:1451 (08:1451 Immigration: Revocation of Citizenship)",
      "08:1451(a)" : "08:1451(a) (08:1451(a) Action to revoke Citizenship)",
      "08:1451(j)" : "08:1451(j) (08:1451(j) Immigration: Motion to Correct Order & Judg. of Naturalization)",
      "09:0001" : "09:0001 (09:0001 U.S. Arbitration Act)",
      "09:0003" : "09:0003 (09:0003 Application to Stay Proceedings Pending Arbitration)",
      "09:0004" : "09:0004 (09:0004 Petition to order arbitration; failure to arbitrate)",
      "09:0007" : "09:0007 (09:0007 Petition to compel attendance before arbitrator)",
      "09:0008" : "09:0008 (09:0008 Declaratory Judgment/Admiralty)",
      "09:0009" : "09:0009 (09:0009 Motion to Confirm Arbitration Award)",
      "09:0010" : "09:0010 (09:0010 Petition to Vacate Arbitration Award)",
      "09:0011" : "09:0011 (09:0011 Motion to modify or correct arbitration award)",
      "09:0201" : "09:0201 (09:0201 Petition to Compel/Stay Arbitration under an Insurance Contract)",
      "09:0202" : "09:0202 (09:0202 Award under Convention on Foreign Arbitral Awards)",
      "09:0205" : "09:0205 (09:0205 Removal from State Court: Enforcement of Foreign Arbital Awards)",
      "09:0207" : "09:0207 (09:0207 Application for order confirming award of arbitrators)",
      "10:0672" : "10:0672 (10:0672 Armed Forces: Active Guard/Reserve (AGR) Program)",
      "10:1006" : "10:1006 (10:1006 Armed Forces: Review of Agency Decision)",
      "10:1072tc" : "10:1072tc (10:1072tc Armed Forces: TRICARE PROGRAM)",
      "10:1089c" : "10:1089c (10:1089(c ) Armed Forces: Removal; dft acting in scope of duties)",
      "10:1091" : "10:1091 (10:1091 Armed Forces: Personal Service Contracts)",
      "10:1107" : "10:1107 (10:1107 Armed Forces: Use Of Investigational New Drug)",
      "10:1408" : "10:1408 (10:1408 Armed Forces: Claim for Military Retirement)",
      "10:1552" : "10:1552 (10:1552 Armed Forces: Action to Correct Records)",
      "10:1553" : "10:1553 (10:1553 Armed Forces: Review of Discharge or Dismissal)",
      "10:2005" : "10:2005 (10:2005 Armed Forces: Advanced Education Assistance)",
      "10:2121" : "10:2121 (10:2121 Armed Forces: Health Professions Scholarship Financial Asst Prog)",
      "10:2302" : "10:2302 (10:2302 Armed Forces: Arms Services Procurement Act)",
      "10:2305" : "10:2305 (10:2305 Armed Forces: Review of Federal Contract)",
      "10:2323fa" : "10:2323fa (10:2323fa Armed Forces: Fifth Amendment Equal Protection: Contract Goal for Small Disadv Businesses)",
      "10:2733" : "10:2733 (10:2733 Armed Forces: Military Claims Act)",
      "10:2734" : "10:2734 (10:2734 Armed Forces: Foreign Military Claims Act)",
      "10:2771" : "10:2771 (10:2771 Armed Forces: Final Settlement - Deceased Members)",
      "10:3258" : "10:3258 (10:3258 Armed Forces: Reg.Army: Re-enlistment after Service as Ofcr)",
      "11:0101" : "11:0101 (11:0101 Bankruptcy (Definitions))",
      "11:0110" : "11:0110 (11:0110 Bankruptcy: Penalty for Preparers of Fraudulent or Negligent Petitions)",
      "11:0362(h)" : "11:0362(h) (11:0362(h) Bankruptcy: Violation of Automatic Stay)",
      "11:0523" : "11:0523 (11:0523 Bankruptcy: Exceptions to Discharge)",
      "11:0524" : "11:0524 (11:0524 Bankruptcy: Effect of Discharge)",
      "11:0525" : "11:0525 (11:0525 Bankruptcy: Protections Against Discriminatory Treatment )",
      "11:0548" : "11:0548 (11:0548 Bankruptcy: Fraudulent Transfers and Obligations)",
      "11:0704" : "11:0704 (11:0704 Bankruptcy: Duties of Trustee)",
      "12:0085" : "12:0085 (12:0085 National Banks: Rate of Interest on Loans, Discounts, and Purchases)",
      "12:0093(a)" : "12:0093(a) (12:0093(a) National Banks: Violation of Prov; Forfeit of Franchise; Personal Liability of Director)",
      "12:0191" : "12:0191 (12:0191 National Banks: Appointment of Receiver)",
      "12:0192" : "12:0192 (12:0192 National Banks: Liquidation of National Bank)",
      "12:0215" : "12:0215 (12:0215 National Banks: Consolidation and Merger)",
      "12:0622" : "12:0622 (12:0622 Foreign Banking: Forfeiture, Dissolution & Liability of Dirs & Officers for Noncompliance)",
      "12:0632" : "12:0632 (12:0632 Foreign Banking: Voluntary Liquidation)",
      "12:0635i-3" : "12:0635i-3 (12:0635i-3 Export-Import Bank: Breach of Insurance Contract)",
      "12:1421" : "12:1421 (12:1421 Federal Home Loan Bank Act (Short Title))",
      "12:1441" : "12:1441 (12:1441 FHLB: Financial Inst Reform Receiving Enforcement Act 1989)",
      "12:1451" : "12:1451 (12:1451 Emergency Home Loan Corporation (Definitions))",
      "12:1452" : "12:1452 (12:1452 Federal Home Loan Mortgage Corporation Act)",
      "12:1452(f)" : "12:1452(f) (12:1452(f) Fed Home Loan Mortgage Corp: Actions by and against the Corporation)",
      "12:1455(b)" : "12:1455(b) (12:1455(b) Fed Home Loan Mortgage Corp: Enforcement of Regulations)",
      "12:1461" : "12:1461 (12:1461 Savings Associations: Homeowners Loan Act (Short Title))",
      "12:1464" : "12:1464 (12:1464 Savings Associations: Federal Savings and Loan)",
      "12:1703" : "12:1703 (12:1703 National Housing: Insurance of Financial Institutions)",
      "12:1715(b)" : "12:1715(b) (12:1715(b) National Housing: Rules and Regulations)",
      "12:1749aaa" : "12:1749aaa (12:1749aaa National Housing: National Insurance Development Program)",
      "12:1751" : "12:1751 (12:1751 Fed Credit Unions: Short Title)",
      "12:1782" : "12:1782 (12:1782 Fed Credit Unions: Administration of Insurance Fund)",
      "12:1786" : "12:1786 (12:1786 Fed Credit Unions: Actions re Violations by Credit Unions)",
      "12:1787aB" : "12:1787aB (12:1787(a)(B) Fed Credit Unions: Liquidation of Insured Credit Union by Board)",
      "12:1789a2" : "12:1789a2 (12:1789(a)(2) Fed Credit Unions: Admin Provision to Sue and be Sued)",
      "12:1811" : "12:1811 (12:1811 FDIC: Financial Inst. Reform Recovery Act of 1989 (FIRREA) (Organization of FDIC))",
      "12:1818" : "12:1818 (12:1818 FDIC: Violations re Federal Deposit Insurance Corporation)",
      "12:1818(e)" : "12:1818(e) (12:1818(e) FDIC: Suspension or Removal of Bank Officer)",
      "12:1819" : "12:1819 (12:1819 FDIC: Corporate Powers )",
      "12:1821" : "12:1821 (12:1821 FDIC: Insurance Funds )",
      "12:1831" : "12:1831 (12:1831 FDIC: Separability of Certain Provisions)",
      "12:1831(d)" : "12:1831(d) (12:1831(d) FDIC: Deposit. Inst. Dereg. & Monetary Ctrl. Act of 1980)",
      "12:1831r-1" : "12:1831r-1 (12:1831r-1 FDIC: Notice of Branch Closure)",
      "12:1833(a)" : "12:1833(a) (12:1833(a) FDIC: Forfieture Civil Penalties)",
      "12:1954" : "12:1954 (12:1954 Injunctions (Action by Sec of Treasury re financial recordkeeping))",
      "12:1971" : "12:1971 (12:1971 Relief under Bank Holding Company Act (Definitions))",
      "12:1972" : "12:1972 (12:1972 Tying Arrangement Act)",
      "12:2001" : "12:2001 (12:2001 Farm Credit Act of 1971)",
      "12:2601" : "12:2601 (12:2601 Real Estate Settlement Procedures Act (RESPA) (findings & purpose))",
      "12:2604(c)" : "12:2604(c) (12:2604(c) Real Estate Settlement Procedures Act (RESPA))",
      "12:2605" : "12:2605 (12:2605 RESPA: Servicing of Mortgage Loans)",
      "12:2607" : "12:2607 (12:2607 RESPA: Violation re kickbacks/unearned fees; Real Estate)",
      "12:2609" : "12:2609 (12:2609 RESPA: Escrow)",
      "12:3012" : "12:3012 (12:3012 National Consumer Cooperative Bank: Suits by or against Bank)",
      "12:3410" : "12:3410 (12:3410 Right to Financial Privacy: Customer Challenges )",
      "12:3751" : "12:3751 (12:3751 Single Family Mortgage Forclosure Act: Findings and Purpose)",
      "12:3801" : "12:3801 (12:3801 Alternative Mortgage Transaction Parity Act)",
      "12:3907" : "12:3907 (12:3907 International Lending Supervision: Capital Adequacy)",
      "12:4010" : "12:4010 (12:4010 Expedited Funds Availability: Violation of Act (Civil Liability))",
      "12:5101" : "12:5101 (12:5101 Fraudulent Transfer Act (Enforcement for Mortgage Licensing))",
      "15:0001" : "15:0001 (15:0001 Antitrust Litigation (Monopolizing Trade))",
      "15:0002at" : "15:0002at (15:0002at Antitrust Litigation)",
      "15:0002fl" : "15:0002fl (15:0002fl Antitrust Litigation)",
      "15:0004" : "15:0004 (15:0004 USDC Jurisdiction re violations of Sec. 1-7 of Title 15)",
      "15:0005" : "15:0005 (15:0005 Bringing in Additional Parties)",
      "15:0009" : "15:0009 (15:0009 USDC Jurisdiction re violations of Sec. 8 of Title 15)",
      "15:0013" : "15:0013 (15:0013 Robinson Patman Act)",
      "15:0014" : "15:0014 (15:0014 Clayton Act)",
      "15:0015" : "15:0015 (15:0015 Antitrust Litigation)",
      "15:0025" : "15:0025 (15:0025 Clayton Act)",
      "15:0026" : "15:0026 (15:0026 Suit for injunctive relief re violation antitrust laws)",
      "15:0041" : "15:0041 (15:0041 Federal Trade Commission Act)",
      "15:0045" : "15:0045 (15:0045 Federal Trade Commission Act (unfair or deceptive acts))",
      "15:0045cp" : "15:0045cp (15:0045cp Violation of Children Online Privacy Protection Act)",
      "15:0052" : "15:0052 (15:0052 Federal Trade Commission Act )",
      "15:0053" : "15:0053 (15:0053 Federal Trade Commission Act)",
      "15:0053(b)" : "15:0053(b) (15:0053(b) Prelim & Perm Inj Relief & other Equitable Relief)",
      "15:0068" : "15:0068 (15:0068 Proceedings re FTC violations re wool products)",
      "15:0069" : "15:0069 (15:0069 Proceedings re FTC violations re fur products)",
      "15:0070" : "15:0070 (15:0070 Proceedings re FTC violations re textile fiber product)",
      "15:0077" : "15:0077 (15:0077 Securities Fraud)",
      "15:0078jb" : "15:0078jb (15:0078j(b)ss Stockholder Suit)",
      "15:0078ma" : "15:0078ma (15:0078m(a) Securities Exchange Act)",
      "15:0079" : "15:0079 (15:0079 Public Utility Holding Companies)",
      "15:0080a-3" : "15:0080a-3 (15:0080a-3 Investment Company Act of 1940)",
      "15:0260" : "15:0260 (15:0260 Proceedings re weights and measures and standard time)",
      "15:0298" : "15:0298 (15:0298 Violation of Law Proceedings re gold or silver)",
      "15:0433" : "15:0433 (15:0433 Discrimination against farmers)",
      "15:0631" : "15:0631 (15:0631 Small Business Act)",
      "15:0636" : "15:0636 (15:0636 Small Business Act - Aid to small business)",
      "15:0661" : "15:0661 (15:0661 Small Business Investment Act of 1958)",
      "15:0687" : "15:0687 (15:0687 Small Business Investment Program)",
      "15:0714(b)" : "15:0714(b) (15:0714(b) Commodity Credit Corporation)",
      "15:0715(f)" : "15:0715(f) (15:0715(f) Proceedings re petroleum and petroleum products)",
      "15:0717" : "15:0717 (15:0717 Natural Gas Act)",
      "15:0719ic" : "15:0719ic (15:0719i(c ) Civil actions re violations or inj involving Gas)",
      "15:0766" : "15:0766 (15:0766 Controversies arising re Federal Energy Admin. rules)",
      "15:1051" : "15:1051 (15:1051 Trademark Infringement)",
      "15:1071" : "15:1071 (15:1071 Appeal of Decision of U.S. Patent & Trademark Office (Comm / Trademark Trial Bd))",
      "15:1114" : "15:1114 (15:1114 Trademark Infringement (Lanham Act))",
      "15:1116" : "15:1116 (15:1116 Inj to prevent violation rights of trademark owner)",
      "15:1120" : "15:1120 (15:1120 Trademark - False or Fraudulent Registration)",
      "15:1121" : "15:1121 (15:1121 Trademark Infringement (jurisdiction))",
      "15:1125(a)" : "15:1125(a) (15:1125(a) False representation of goods sold in interstate commerce)",
      "15:1125dac" : "15:1125dac (15:1125(d)ac Trademark (Anticybersquatting consumer protection))",
      "15:1125la" : "15:1125la (15:1125la Trademark Infringement (Lanham Act))",
      "15:1126" : "15:1126 (15:1126 Trademarks - International conventions)",
      "15:1127" : "15:1127 (15:1127 Trademark Infringement)",
      "15:1191" : "15:1191 (15:1191 Flamable Fabrics Act)",
      "15:1221" : "15:1221 (15:1221 Auto Dealer Suits Agst Manufacturers)",
      "15:1261" : "15:1261 (15:1261 Hazardous Substances (definitions))",
      "15:1263" : "15:1263 (15:1263 Prohibited Hazardous Substance - Interstate Commerce)",
      "15:1267(a)" : "15:1267(a) (15:1267(a) Federal Hazardous Substances Act)",
      "15:1314" : "15:1314 (15:1314 Antitrust--Petition for enforcement)",
      "15:1501" : "15:1501 (15:1501 Estab of Dept of Commerce)",
      "15:1601" : "15:1601 (15:1601 Truth in Lending)",
      "15:1605" : "15:1605 (15:1605 Determination of Finance Charge)",
      "15:1638" : "15:1638 (15:1638 Truth in Lending)",
      "15:1640" : "15:1640 (15:1640 Truth in Lending)",
      "15:1666" : "15:1666 (15:1666 Fair Credit Billing Act Dispute)",
      "15:1667" : "15:1667 (15:1667 Consumer Leasing Act)",
      "15:1679" : "15:1679 (15:1679 Violation of Credit Repair Organizations Act)",
      "15:1681" : "15:1681 (15:1681 Fair Credit Reporting Act)",
      "15:1691" : "15:1691 (15:1691 Equal Credit Opportunity Act)",
      "15:1692" : "15:1692 (15:1692 Fair Debt Collection Act)",
      "15:1693ef" : "15:1693ef (15:1693ef Electronic Funds Transfer Act)",
      "15:1693m" : "15:1693m (15:1693m Violation of Prov. of Subchpt.VI (Electronic Fund Transfers))",
      "15:1701" : "15:1701 (15:1701 Interstate Land Sales Full Disclosure Act (ILFFDA))",
      "15:1709" : "15:1709 (15:1709 Interstate Land Sales )",
      "15:1714" : "15:1714 (15:1714 Actions to enjoin violations re interstate land sale)",
      "15:2071" : "15:2071 (15:2071 Consumer Product Safety; Condemnation hazardous prod)",
      "15:2073" : "15:2073 (15:2073 Private action to enforce Consumer Product Safety)",
      "15:2301" : "15:2301 (15:2301 Magnuson-Moss Warranty Act)",
      "15:2310(c)" : "15:2310(c) (15:2310(c ) Consumer Product Warranties)",
      "15:2601" : "15:2601 (15:2601 Toxic Substances Control Act (TCSA))",
      "15:2604" : "15:2604 (15:2604 Application for inj re distribution toxic substance)",
      "15:2616" : "15:2616 (15:2616 Toxic Substance control; seizure of chemical)",
      "15:2620" : "15:2620 (15:2620 Toxic Substances Control Act: citizen's petition)",
      "15:2651" : "15:2651 (15:2651 Asbestos Hazard Emergency Response Act)",
      "15:2801" : "15:2801 (15:2801 Petroleum Marketing Practices Act)",
      "15:2805" : "15:2805 (15:2805 Petroleum Marketing Practices-Franchise Protection)",
      "15:34-35" : "15:34-35 (15:34-35 Investment Company Act of 1940 )",
      "15:3414" : "15:3414 (15:3414 National Gas Policy Act)",
      "15:3710a" : "15:3710a (15:3710a Federal Technology Transfer Act of 1986)",
      "15:3901" : "15:3901 (15:3901 Federal Risk Retention Act)",
      "15:6801" : "15:6801 (15:6801 Gram-Leach-Bliley Act)",
      "15:7701" : "15:7701 (15:7701 Federal CAN-Spam Act)",
      "16:0019jj" : "16:0019jj (16:0019jj Park System Resource Protection Act)",
      "16:0470" : "16:0470 (16:0470 Archaeological resources Protection Act)",
      "16:0470f" : "16:0470f (16:0470f National Historic Preservation Act)",
      "16:0668" : "16:0668 (16:0668 Bald and Golden Eagle Protection Act)",
      "16:0669" : "16:0669 (16:0669 Pittman-Robertson Conservation Restoration Act)",
      "16:0675" : "16:0675 (16:0675 Norbeck Wildlife Preserve Organic Act)",
      "16:0703" : "16:0703 (16:0703 Migratory Bird Act)",
      "16:0823a" : "16:0823a (16:0823a Federal Public Utility Regulatory Policies Act)",
      "16:0825" : "16:0825 (16:0825 Federal Power Commission Regulation; Public Utilities)",
      "16:0831" : "16:0831 (16:0831 Actions re: rights of Tennessee Valley Authority)",
      "16:1244" : "16:1244 (16:1244 National Scenic and National Historic Trails)",
      "16:1374d6" : "16:1374d6 (16:1374(d)(6) Petition for Review re Application for Import of Polar Bear Trophies)",
      "16:1531" : "16:1531 (16:1531 Endangered Species Act)",
      "16:1533" : "16:1533 (16:1533 Endangered Species Act)",
      "16:1538" : "16:1538 (16:1538 Endangered Species Act)",
      "16:1540" : "16:1540 (16:1540 Endangered Species Act - Penalties and Enforcement)",
      "16:1600" : "16:1600 (16:1600 National Forest Management Act of 1976)",
      "16:1801" : "16:1801 (16:1801 Magnuson-Stevens Fishery Conservation and Management Act )",
      "16:1858" : "16:1858 (16:1858 National Fishery Management Program - Civil Penalties and Permit Sanctions)",
      "16:3371" : "16:3371 (16:3371 Wildlife Under the Lacey Act (Definitions))",
      "16:3372" : "16:3372 (16:3372 Lacey Act: Prohibited Acts)",
      "16:3373" : "16:3373 (16:3373 Lacey Act: Penalties and Sanctions - Appeal of Decision - DOI )",
      "16:3374" : "16:3374 (16:3374 Lacey Act: Complaint for Forfeiture )",
      "17:0101" : "17:0101 (17:0101 Copyright Infringement (definitions))",
      "17:0201" : "17:0201 (17:0201 Ownership of Copyright)",
      "17:0205(d)" : "17:0205(d) (17:0205(d) Priority Between Conflicting Transfers)",
      "17:0407" : "17:0407 (17:0407 Recovery of fines & penalties by Register of Copyrights)",
      "17:0411(b)" : "17:0411(b) (17:0411(b) Action by copyright owner for infringement)",
      "17:0501" : "17:0501 (17:0501 Copyright Infringement)",
      "17:0502(a)" : "17:0502(a) (17:0502(a) Inj to prevent or restrain infringement copyright)",
      "17:0504" : "17:0504 (17:0504 Remedies for Copyright Infringement)",
      "17:0512" : "17:0512 (17:0512 Copyright Infringement of Digital Communications)",
      "17:1201" : "17:1201 (17:1201 Digital Millennium Copyright Act)",
      "18:0492" : "18:0492 (18:0492 Forfeiture of Counterfeit Paraphernalia)",
      "18:0603" : "18:0603 (18:0603 Conflict of Interest)",
      "18:0922" : "18:0922 (18:0922 Firearms - Unlawful Possession (Civil Fines) )",
      "18:0923f3" : "18:0923f3 (18:0923(f)(3) Review of Revocation of a License as a Dealer in Firearms)",
      "18:0925(c)" : "18:0925(c) (18:0925(c) Restoration of ability to possess firearms/ammo)",
      "18:0981" : "18:0981 (18:0981 Civil Forfeiture)",
      "18:0981a1A" : "18:0981a1A (18:0981(a)(1)(A) Civil Forfeiture: Money Laundering Control Act)",
      "18:0983" : "18:0983 (18:0983 Civil Forfeiture - General Rules)",
      "18:1030" : "18:1030 (18:1030 Fraud & Related Activity in Connection with Computers)",
      "18:1345" : "18:1345 (18:1345 Injunction against Fraud)",
      "18:1514" : "18:1514 (18:1514 Civil Action to Restrain Harassment of a Victim)",
      "18:1514A" : "18:1514A (18:1514A Civil Action to Protect Against Retaliation in Fraud Cases)",
      "18:1836a" : "18:1836a (18:1836(a) Injunction against Misappropriation of Trade Secrets)",
      "18:1836b" : "18:1836b (18:1836(b) Civil Action to Protect Trade Secrets)",
      "18:1905" : "18:1905 (18:1905 Disclosure of Confidential Information)",
      "18:1955" : "18:1955 (18:1955 Civil Forfeiture-Prohibition of Illegal Gambling)",
      "18:1956b3" : "18:1956b3 (18:1956(b)(3) Laundering of Monetary Instruments - Forfeit Property)",
      "18:1964" : "18:1964 (18:1964 Civil Remedies: Racketeering (RICO) Act)",
      "18:1968" : "18:1968 (18:1968 Action re civil investigative demand)",
      "18:2254" : "18:2254 (18:2254 Civil Forfeiture - Exploitation of Children)",
      "18:2333" : "18:2333 (18:2333 Civil Remedies: Anti-Terrorism Act of 1991)",
      "18:2511" : "18:2511 (18:2511 Wiretapping - Injunctive Relief or Civil Fine)",
      "18:2520" : "18:2520 (18:2520 Civil Damages for Interception Wire or Oral Communications)",
      "18:2707" : "18:2707 (18:2707 Civil Action: Stored Communications)",
      "18:2710c" : "18:2710c (18:2710(c) Wrongful Disclosure of Video Tape Rental or Sales Records)",
      "18:2724" : "18:2724 (18:2724 Civil Action - Motor Vehicle Records)",
      "18:3114" : "18:3114 (18:3114 Motion for Return of Seized Property)",
      "18:3184" : "18:3184 (18:3184 Extradition Procedure)",
      "18:3663" : "18:3663 (18:3663 Civil Enforcement of Crim. Rest. Obligation)",
      "18:4100" : "18:4100 (18:4100 Transfer of Offenders)",
      "19:1305" : "19:1305 (19:1305 Customs Duties: Forfeiture-Immoral Articles)",
      "19:1497" : "19:1497 (19:1497 Customs Duties: Penalty for Failure to Declare)",
      "19:1595a" : "19:1595a (19:1595a Customs Duties: Forfeiture and Other Penalties)",
      "19:1607" : "19:1607 (19:1607 Customs Duties: Notice of Seizure)",
      "20:0107" : "20:0107 (20:0107 Randolph-Sheppard Vending Stand Act)",
      "20:1070" : "20:1070 (20:1070 Student Assistance)",
      "20:1080" : "20:1080 (20:1080 Default of Student Loan: Recovery)",
      "20:1087" : "20:1087 (20:1087 Student Loan Discharge)",
      "20:1095a" : "20:1095a (20:1095a Education - Wage Garnishment Requirement)",
      "20:1097" : "20:1097 (20:1097 Education - Criminal penalties for fraud)",
      "20:1098g" : "20:1098g (20:1098g Higher Education Act - Exemption from state disclosure)",
      "20:1232(g)" : "20:1232(g) (20:1232(g) Family Education Rights & Privacy Act of 1974)",
      "20:1400" : "20:1400 (20:1400 IDEA: Individuals With Disabilities Education Act (short title))",
      "20:1401" : "20:1401 (20:1401 IDEA: Education of Individuals with Disabilities (definitions))",
      "20:1412" : "20:1412 (20:1412 IDEA: State Eligibility)",
      "20:1415" : "20:1415 (20:1415 IDEA: Challenge decision re education for handicapped )",
      "20:1415e2" : "20:1415e2 (20:1415(e)(2)de IDEA: Mediation)",
      "20:1681" : "20:1681 (20:1681 Title IX Educational Amendments 1992 - Sex Discrimination)",
      "20:1683" : "20:1683 (20:1683 Judicial Review: Prohibition against sex discrimination in education)",
      "20:1706" : "20:1706 (20:1706 Relief from denial of equal educational opportunity)",
      "20:1717" : "20:1717 (20:1717 Reopening proceedings w/order to end segregation)",
      "21:0301" : "21:0301 (21:0301 Federal Food, Drug & Cosmetic Act)",
      "21:0331" : "21:0331 (21:0331 Federal Food, Drug & Cosmetic Act - Prohibited Acts)",
      "21:0332" : "21:0332 (21:0332 Federal Food, Drug and Cosmetic Act, Injunctive Relief)",
      "21:0332(a)" : "21:0332(a) (21:0332(a) Federal Food, Drug, and Cosmetic Act)",
      "21:0334(a)" : "21:0334(a) (21:0334(a) Forfeiture or condemnation-food, drug, cosmetics)",
      "21:0348" : "21:0348 (21:0348 Federal Food, Drug and Cosmetic Act - Food Additives)",
      "21:0360" : "21:0360 (21:0360 Federal Food, Drug & Cosmetic Act - Drugs and Devices)",
      "21:0467" : "21:0467 (21:0467 Seizure and condemnation of poultry products)",
      "21:0601" : "21:0601 (21:0601 Federal Meat Inspection Act 21 USC 601-695 (Definitions))",
      "21:0673" : "21:0673 (21:0673 Seizure and condemnation of meat or meat products)",
      "21:0674" : "21:0674 (21:0674 Proceeding to enforce & enjoin re meat products)",
      "21:0821" : "21:0821 (21:0821 Violation of Record Keeping Provision of Controlled Substance Act)",
      "21:0841" : "21:0841 (21:0841 Forfeiture Property - Drugs)",
      "21:0842" : "21:0842 (21:0842 Civil Penalty for violation re controlled substance)",
      "21:0881" : "21:0881 (21:0881 Forfeiture Property - Drugs)",
      "21:0881a" : "21:0881a (21:0881a Forfeiture Property - Aircraft)",
      "21:0881re" : "21:0881re (21:0881re Forfeiture Property - Real Estate)",
      "21:0882" : "21:0882 (21:0882 Inj to enjoin violations re controlled substance)",
      "21:1049" : "21:1049 (21:1049 Seizure and condemnation re eggs or egg products)",
      "22:0286" : "22:0286 (22:0286 Action against World Bank or IMF)",
      "22:2702" : "22:2702 (22:2702 Medical Malpractice by Govt. Medical Personnel)",
      "22:3612" : "22:3612 (22:3612 Claim for Damage to Panama Canal)",
      "22:3776" : "22:3776 (22:3776 Panama Canal Commission Action on claims)",
      "22:3777" : "22:3777 (22:3777 Investigation of accident or injury giving rise to a claim)",
      "22:4140" : "22:4140 (22:4140 Foreign Service Grievance Act - Judicial Review)",
      "23:0112" : "23:0112 (23:0112 Federal Highway Act - Letting of Contracts)",
      "23:0134" : "23:0134 (23:0134 Metropolitan Transportation Planning)",
      "25:1901" : "25:1901 (25:1901 Indian Child Welfare Act)",
      "25:2701" : "25:2701 (25:2701 Indian Gaming Regulatory Act (IGRA))",
      "25:4101" : "25:4101 (25:4101 Native American Housing Assistance and Self-Determination Act (NAHASDA))",
      "26:0063" : "26:0063 (26:0063 IRS: Taxable income (Definition))",
      "26:0982" : "26:0982 (26:0982 IRS: To Quash IRS Formal Document Request)",
      "26:2032" : "26:2032 (26:2032 IRS: Alternate valuation)",
      "26:6212" : "26:6212 (26:6212 IRS: Notice of Deficiency (Injunctive Relief from IRS Lien))",
      "26:6213" : "26:6213 (26:6213 IRS: Injunctive Relief from IRS Lien in Tax Court)",
      "26:6221" : "26:6221 (26:6221 IRS: TEFRA Tax, Equity and Fiscal Responsibility Act of 1982)",
      "26:6226" : "26:6226 (26:6226 IRS: Judicial Review of Partnership Adjustment)",
      "26:6320" : "26:6320 (26:6320 IRS: Notice and Opportunity for Hearing upon Filing Notice of Lien)",
      "26:6330" : "26:6330 (26:6330 IRS: Notice and Opportunity for Hearing before Levy)",
      "26:6331" : "26:6331 (26:6331 IRS: Wrongful Levy)",
      "26:6334" : "26:6334 (26:6334 IRS: Property Exempt from Levy)",
      "26:6502" : "26:6502 (26:6502 IRS: Collection after Assessment (Enforcement of tax liens))",
      "26:6532" : "26:6532 (26:6532 IRS: Periods of Limitation on Suits)",
      "26:6653sp" : "26:6653sp (26:6653sp IRS: Failure to Pay Stamp Tax)",
      "26:6672" : "26:6672 (26:6672 IRS: Failure to Collect and Pay Over Tax, or Attempt to Evade or Defeat Tax)",
      "26:6694" : "26:6694 (26:6694 IRS: Underestimate Of Tax Liability By Tax Preparer)",
      "26:6702" : "26:6702 (26:6702 IRS: Penalty for Frivolous Tax Submission)",
      "26:6703" : "26:6703 (26:6703 IRS: Refund of Tax Penalty)",
      "26:7323" : "26:7323 (26:7323 IRS: Proceedings in rem enforce forfeitures property)",
      "26:7401" : "26:7401 (26:7401 IRS: Tax Liability - Authorization to collect via civil action)",
      "26:7402" : "26:7402 (26:7402 IRS: Jurisdiction of District Courts)",
      "26:7403" : "26:7403 (26:7403 IRS: Action to Enforce Federal Tax Lien)",
      "26:7404" : "26:7404 (26:7404 IRS: Action for collection of estate tax)",
      "26:7405" : "26:7405 (26:7405 IRS: Action for recovery of refunds erroneously made)",
      "26:7407" : "26:7407 (26:7407 IRS: Action to enjoin income tax preparers)",
      "26:7422rt" : "26:7422rt (26:7422rt IRS: Refund Taxes)",
      "26:7422rx" : "26:7422rx (26:7422rx IRS: Refund Excise Tax)",
      "26:7425(a)" : "26:7425(a) (26:7425(a) IRS: Judiciary & Judicial Procedures - Discharge of Liens)",
      "26:7426" : "26:7426 (26:7426 IRS: Wrongful Levy for Taxes)",
      "26:7428" : "26:7428 (26:7428 IRS: Declaratory Judgment)",
      "26:7429" : "26:7429 (26:7429 IRS: Tax Jeopardy Assessment)",
      "26:7430" : "26:7430 (26:7430 IRS: Awarding of Costs and Certain Fees in Tax Suit)",
      "26:7431" : "26:7431 (26:7431 IRS: Unauthorized Disclosure of Return & Return Info)",
      "26:7434" : "26:7434 (26:7434 IRS: Civil Damages for Fraudulent Filing of Information)",
      "26:7604" : "26:7604 (26:7604 IRS: Enforce summons; examination books & witnesses)",
      "26:7604(a)" : "26:7604(a) (26:7604(a) IRS: Complaint to Enforce IRS Summons)",
      "26:7609" : "26:7609 (26:7609 IRS: Petition to Quash IRS Summons)",
      "26:7609en" : "26:7609en (26:7609en IRS: Petition to serve Third-Party Summons)",
      "28:0157(b)" : "28:0157(b) (28:0157(b) Bankruptcy Claim to be tried in U.S. District Court)",
      "28:0157(c)" : "28:0157(c) (28:0157(c )(1) Findings, Concl. & Proposed Judgment)",
      "28:0157(d)" : "28:0157(d) (28:0157(d) Motion for Withdrawal of Reference)",
      "28:0158" : "28:0158 (28:0158 Notice of Appeal re Bankruptcy Matter (District or BAP))",
      "28:0463" : "28:0463 (28:0463 Expenses of Judicial Litigation)",
      "28:0534" : "28:0534 (28:0534 Arrest Records)",
      "28:0591" : "28:0591 (28:0591 Independent Counsel)",
      "28:0592" : "28:0592 (28:0592 Independent Counsel - Application for Appointment)",
      "28:0593" : "28:0593 (28:0593 Independent Counsel - Court Responsibilities)",
      "28:0594" : "28:0594 (28:0594 Independent Counsel - Responsibilities)",
      "28:0595" : "28:0595 (28:0595 Independent Counsel - Congressional Oversight)",
      "28:0596" : "28:0596 (28:0596 Independent Counsel - Removal)",
      "28:0597" : "28:0597 (28:0597 Independent Counsel - Dept. of Justice Relationship)",
      "28:0598" : "28:0598 (28:0598 Independent Counsel - Chapter Termination)",
      "28:0636" : "28:0636 (28:0636 Jurisdiction and Power of Magistrate Judges)",
      "28:0754" : "28:0754 (28:0754 Receiver of Property in Different Districts )",
      "28:1291" : "28:1291 (28:1291 Maritime)",
      "28:1330" : "28:1330 (28:1330 Breach of Contract)",
      "28:1331" : "28:1331 (28:1331 Fed. Question)",
      "28:1331ag" : "28:1331ag (28:1331ag Fed. Question: Employment Discrimination (Age))",
      "28:1331al" : "28:1331al (28:1331al Fed. Question: Airline Crash)",
      "28:1331as" : "28:1331as (28:1331as Fed. Question: Assault, Libel, Slander)",
      "28:1331at" : "28:1331at (28:1331at Fed. Question: Anti-trust)",
      "28:1331au" : "28:1331au (28:1331au Fed. Question: Auto Negligence)",
      "28:1331b" : "28:1331b (28:1331b Fed. Question: Bivens Act)",
      "28:1331bc" : "28:1331bc (28:1331bc Fed. Question: Breach of Contract)",
      "28:1331bv" : "28:1331bv (28:1331bv Fed. Question: Bivens-Prisoner)",
      "28:1331ca" : "28:1331ca (28:1331ca Fed Question: Fed Communications Act)",
      "28:1331cm" : "28:1331cm (28:1331cm Fed. Question: Interstate Commerce Act)",
      "28:1331cr" : "28:1331cr (28:1331cr Fed. Question: Civil Rights (Race Discrimination))",
      "28:1331cv" : "28:1331cv (28:1331cv Fed. Question: Other Civil Rights)",
      "28:1331dd" : "28:1331dd (28:1331dd Fed. Question: Discovery Disputes (conversion case))",
      "28:1331dj" : "28:1331dj (28:1331dj Fed. Question: Declaratory Judgment)",
      "28:1331dp" : "28:1331dp (28:1331dp Fed. Question: Violation of Due Process)",
      "28:1331ed" : "28:1331ed (28:1331ed Fed. Question: Employment Discrimination)",
      "28:1331ef" : "28:1331ef (28:1331ef Fed. Question: Civil Rights Violation (Excess Force))",
      "28:1331ej" : "28:1331ej (28:1331ej Fed. Question: Enforcement of Judgment)",
      "28:1331es" : "28:1331es (28:1331es Fed. Question: Enforcement of Administrative Subpoena)",
      "28:1331fa" : "28:1331fa (28:1331fa Fed. Question: Civil Rights Violation-False Arrest)",
      "28:1331fl" : "28:1331fl (28:1331fl Fed. Question: Fair Labor Standards)",
      "28:1331fm" : "28:1331fm (28:1331fm Fed. Question: Family and Medical Leave Act)",
      "28:1331fr" : "28:1331fr (28:1331fr Fed. Question: Fraud)",
      "28:1331in" : "28:1331in (28:1331in Fed. Question: Insurance Contract)",
      "28:1331lm" : "28:1331lm (28:1331lm Fed. Question: Legal Malpractice)",
      "28:1331mm" : "28:1331mm (28:1331mm Fed. Question: Medical Malpractice)",
      "28:1331ng" : "28:1331ng (28:1331ng Fed. Question: Natural Gas Act)",
      "28:1331ni" : "28:1331ni (28:1331ni Fed. Question: Negotiable Instrument)",
      "28:1331pd" : "28:1331pd (28:1331pd Fed. Question: Property Damage)",
      "28:1331pi" : "28:1331pi (28:1331pi Fed. Question: Personal Injury)",
      "28:1331pl" : "28:1331pl (28:1331pl Fed. Question: Product Liability)",
      "28:1331pr" : "28:1331pr (28:1331pr Fed. Question: Federal Prisoner Civil Rights)",
      "28:1331ra" : "28:1331ra (28:1331ra Fed. Question: Racketeering (RICO) Act)",
      "28:1331rc" : "28:1331rc (28:1331rc Fed. Question: Reclamation Project Auth. Act of 1972)",
      "28:1331rd" : "28:1331rd (28:1331rd Fed. Question: Review Agency Decision)",
      "28:1331rp" : "28:1331rp (28:1331(a)rp Fed. Question: Real Property )",
      "28:1331rr" : "28:1331rr (28:1331rr Fed. Question: Railway Labor Act)",
      "28:1331rs" : "28:1331rs (28:1331rs Fed. Question: Federal Rail Safety Act)",
      "28:1331sh" : "28:1331sh (28:1331sh Fed. Question: Sexual Harassment)",
      "28:1331ss" : "28:1331ss (28:1331ss Fed. Question: Constitutionality of State Statutes)",
      "28:1331sv" : "28:1331sv (28:1331sv Fed. Question: Securities Violation)",
      "28:1331sx" : "28:1331sx (28:1331sx Fed. Question: Employment Discrimination (Sex))",
      "28:1331tr" : "28:1331tr (28:1331tr Fed. Question: Trademark)",
      "28:1331tt" : "28:1331tt (28:1331tt Fed. Question: Tort Action)",
      "28:1331v" : "28:1331v (28:1331v Fed. Question: Violation 5th & 8th Amendments)",
      "28:1331va" : "28:1331va (28:1331va Fed. Question: Violation 5th & 14th Amendment)",
      "28:1331vc" : "28:1331vc (28:1331vc Fed. Question: Violation of Constitutional Rights)",
      "28:1331w" : "28:1331w (28:1331w Fed. Question: Wrongful Termination of Employment)",
      "28:1331wd" : "28:1331wd (28:1331wd Fed. Question: Wrongful Death)",
      "28:1331wl" : "28:1331wl (28:1331wl Fed. Question: EPA Waste Lien)",
      "28:1331wt" : "28:1331wt (28:1331wt Fed. Question: Water Rights)",
      "28:1332" : "28:1332 (28:1332 Diversity Action)",
      "28:1332ac" : "28:1332ac (28:1332ac Diversity-Account Receivable)",
      "28:1332al" : "28:1332al (28:1332al Diversity-Airline Crash)",
      "28:1332ap" : "28:1332ap (28:1332ap Diversity-Airplane Product Liability)",
      "28:1332as" : "28:1332as (28:1332as Diversity-Asbestos Litigation)",
      "28:1332au" : "28:1332au (28:1332au Diversity-Auto Negligence)",
      "28:1332bc" : "28:1332bc (28:1332bc Diversity-Breach of Contract)",
      "28:1332bw" : "28:1332bw (28:1332bw Diversity -Breach of Warranty)",
      "28:1332co" : "28:1332co (28:1332co Diversity-Conversion)",
      "28:1332ct" : "28:1332ct (28:1332ct Diversity-(Citizenship))",
      "28:1332de" : "28:1332de (28:1332de Diversity: Forcible Detainer)",
      "28:1332df" : "28:1332df (28:1332df Diversity-Contract Default)",
      "28:1332ds" : "28:1332ds (28:1332ds Diversity-Contract Dispute)",
      "28:1332dtp" : "28:1332dtp (28:1332dtp Diversity - Deceptive Trade Practices)",
      "28:1332ed" : "28:1332ed (28:1332ed Diversity-Employment Discrimination)",
      "28:1332ej" : "28:1332ej (28:1332ej Diversity-Enforcement of Judgment)",
      "28:1332fc" : "28:1332fc (28:1332fc Diversity - Foreclosure)",
      "28:1332fd" : "28:1332fd (28:1332fd Diversity-Breach of Fiduciary Duty)",
      "28:1332fr" : "28:1332fr (28:1332fr Diversity-Fraud)",
      "28:1332ia" : "28:1332ia (28:1332ia Diversity-Interpleader Action)",
      "28:1332if" : "28:1332if (28:1332if Diversity- Insurance Fraud)",
      "28:1332ij" : "28:1332ij (28:1332ij Diversity-Injunctive & Declaratory Relief)",
      "28:1332in" : "28:1332in (28:1332in Diversity-Insurance Contract)",
      "28:1332jd" : "28:1332jd (28:1332jd Diversity-Declaratory Judgement)",
      "28:1332lb" : "28:1332lb (28:1332lb Diversity-Libel,Assault,Slander)",
      "28:1332lm" : "28:1332lm (28:1332lm Diversity - Legal Malpractice)",
      "28:1332lp" : "28:1332lp (28:1332lp Diversity-Property Damage/Product Liability)",
      "28:1332lr" : "28:1332lr (28:1332lr Diversity - Labor)",
      "28:1332ma" : "28:1332ma (28:1332ma Diversity-Miller Act)",
      "28:1332md" : "28:1332md (28:1332md Diversity-Motor Vehicle/Wrongful Death)",
      "28:1332mm" : "28:1332mm (28:1332mm Diversity-Medical Malpractice)",
      "28:1332mv" : "28:1332mv (28:1332mv Diversity-Motor Vehicle Product Liability)",
      "28:1332ni" : "28:1332ni (28:1332ni Diversity-Negotiable Instrument)",
      "28:1332nm" : "28:1332nm (28:1332nm Diversity-Non-Motor Vehicle)",
      "28:1332nr" : "28:1332nr (28:1332nr Diversity-Notice of Removal)",
      "28:1332oc" : "28:1332oc (28:1332oc Diversity-Other Contract)",
      "28:1332op" : "28:1332op (28:1332op Diversity-Recovery of Overpayment)",
      "28:1332pa" : "28:1332pa (28:1332pa Diversity-Personal Injury/Airplane)",
      "28:1332pd" : "28:1332pd (28:1332pd Diversity-Property Damage)",
      "28:1332pi" : "28:1332pi (28:1332pi Diversity-Personal Injury)",
      "28:1332pl" : "28:1332pl (28:1332pl Diversity-Product Liability)",
      "28:1332pr" : "28:1332pr (28:1332pr Diversity-Petition for Removal)",
      "28:1332qt" : "28:1332qt (28:1332qt Diversity-Petition to Quiet Title)",
      "28:1332rd" : "28:1332rd (28:1332rd Diversity-Recovery of Debt)",
      "28:1332ri" : "28:1332ri (28:1332ri Diversity-Racketeering (RICO) Act)",
      "28:1332rl" : "28:1332rl (28:1332rl Diversity-Rent Lease & Ejectment)",
      "28:1332rp" : "28:1332rp (28:1332rp Diversity-Real Property)",
      "28:1332sa" : "28:1332sa (28:1332sa Diversity: Securities & Exchange Commiss)",
      "28:1332sf" : "28:1332sf (28:1332sf Diversity: Securities Fraud)",
      "28:1332sh" : "28:1332sh (28:1332sh Diversity-Sexual Harassment)",
      "28:1332ss" : "28:1332ss (28:1332ss Diversity - Stockholders Suits)",
      "28:1332t" : "28:1332t (28:1332t Diversity-Torts)",
      "28:1332tl" : "28:1332tl (28:1332tl Diversity-Torts to Land)",
      "28:1332tm" : "28:1332tm (28:1332tm Diversity-Tort/Motor Vehicle (P.I.))",
      "28:1332tn" : "28:1332tn (28:1332tn Diversity-Tort/Non-Motor Vehicle)",
      "28:1332ts" : "28:1332ts (28:1332ts Diversity-Misappropriation of Trade Secrets)",
      "28:1332vt" : "28:1332vt (28:1332vt Diversity-Natl Motor Vehicle Title Information System)",
      "28:1332wc" : "28:1332wc (28:1332wc Diversity- Worker's Compensation Benefits)",
      "28:1332wd" : "28:1332wd (28:1332wd Diversity-Wrongful Death)",
      "28:1333ad" : "28:1333ad (28:1333ad Admiralty)",
      "28:1333in" : "28:1333in (28:1333in Personal Injury)",
      "28:1333mc" : "28:1333mc (28:1333mc Marine Contract)",
      "28:1333pd" : "28:1333pd (28:1333pd Property Damage)",
      "28:1333pi" : "28:1333pi (28:1333pi Marine Personal Injury)",
      "28:1334" : "28:1334 (28:1334 Bankruptcy Appeal)",
      "28:1334(b)" : "28:1334(b) (28:1334(b) Proceeding arising/related to case under title 11)",
      "28:1334(c)" : "28:1334(c) (28:1334(c) R&R re motions for abstention)",
      "28:1335" : "28:1335 (28:1335 Interpleader Action)",
      "28:1337sc" : "28:1337sc (28:1337sc Sherman-Clayton Act)",
      "28:1338cp" : "28:1338cp (28:1338cp Copyright Infringement)",
      "28:1338pt" : "28:1338pt (28:1338pt Patent Infringement)",
      "28:1338tr" : "28:1338tr (28:1338tr Trademark Infringement)",
      "28:1339" : "28:1339 (28:1339 Postal matters)",
      "28:1340tp" : "28:1340tp (28:1340tp Jurisdiction of Internal Revenue Matters; Customs Duties)",
      "28:1341" : "28:1341 (28:1341 Taxes by States)",
      "28:1343" : "28:1343 (28:1343 Violation of Civil Rights)",
      "28:1344" : "28:1344 (28:1344 Election disputes)",
      "28:1345" : "28:1345 (28:1345 U.S. Plaintiff)",
      "28:1345co" : "28:1345co (28:1345co Replevin & Conversion)",
      "28:1345db" : "28:1345db (28:1345db Debt to US - FHA/HUD Title I)",
      "28:1345df" : "28:1345df (28:1345df Default of Promissory Note)",
      "28:1345er" : "28:1345er (28:1345er Recovery of Erroneous Refund)",
      "28:1345fc" : "28:1345fc (28:1345fc Foreclosure)",
      "28:1345ff" : "28:1345ff (28:1345ff Complaint for Forfeiture)",
      "28:1345hl" : "28:1345hl (28:1345hl VA Home Loan Guaranty Debt)",
      "28:1345lc" : "28:1345lc (28:1345lc Land Condemnation)",
      "28:1345mc" : "28:1345mc (28:1345mc Medical Care Recovery)",
      "28:1345mi" : "28:1345mi (28:1345mi Mining Claim Ejectment)",
      "28:1345pd" : "28:1345pd (28:1345pd Property Damage)",
      "28:1345pe" : "28:1345pe (28:1345pe Property Ejectment)",
      "28:1345rc" : "28:1345rc (28:1345rc Recovery of Debt to US)",
      "28:1345ro" : "28:1345ro (28:1345ro Recovery of Retirement Overpayment)",
      "28:1345st" : "28:1345st (28:1345st Default of Student Loan)",
      "28:1345tp" : "28:1345tp (28:1345tp Trespass on Public Land)",
      "28:1345tx" : "28:1345tx (28:1345tx Prohibit dfts assessing tx on purch/use of pers prop)",
      "28:1345va" : "28:1345va (28:1345va Recovery of VA Overpayment)",
      "28:1346" : "28:1346 (28:1346 U.S. Defendant)",
      "28:1346bc" : "28:1346bc (28:1346bc Breach of Contract)",
      "28:1346pi" : "28:1346pi (28:1346pi Marine Personal Injury (or tort claim - personal injury / motor vehicle))",
      "28:1346rc" : "28:1346rc (28:1346rc Recovery of IRS Tax)",
      "28:1346t" : "28:1346t (28:1346t Tort Claim)",
      "28:1346wd" : "28:1346wd (28:1346wd Wrongful Death)",
      "28:1348" : "28:1348 (28:1348 Banking association as party)",
      "28:1349" : "28:1349 (28:1349 Corporation organized under Federal Law as party)",
      "28:1350" : "28:1350 (28:1350 Alien Tort Claims Act)",
      "28:1352" : "28:1352 (28:1352 Miller Act)",
      "28:1355" : "28:1355 (28:1355 Petition for Return of Property)",
      "28:1356" : "28:1356 (28:1356 Executory Process/Foreclosure)",
      "28:1358" : "28:1358 (28:1358 Land Condemnation)",
      "28:1361" : "28:1361 (28:1361 Petition for Writ of Mandamus)",
      "28:1361pr" : "28:1361pr (28:1361pr Complaint for mandamus relief (prisoner))",
      "28:1362ic" : "28:1362ic (28:1362ic Indian Tribal Controversy)",
      "28:1362iw" : "28:1362iw (28:1362iw Declaration re: Indian Tribal Water Rights)",
      "28:1363" : "28:1363 (28:1363 Action for protection of jurors employment rights)",
      "28:1364" : "28:1364 (28:1364 Auto Negligence)",
      "28:1367" : "28:1367 (28:1367 Other Property Damage)",
      "28:1391" : "28:1391 (28:1391 Venue)",
      "28:1394" : "28:1394 (28:1394 Banking Assoc action agst Comptroller of Currency)",
      "28:1395" : "28:1395 (28:1395 Complaint for Forfeiture )",
      "28:1402" : "28:1402 (28:1402 US as Defendant)",
      "28:1403" : "28:1403 (28:1403 Condemnation of real estate for the use of the US)",
      "28:1407" : "28:1407 (28:1407 MDL: Airline Crash)",
      "28:1407im" : "28:1407im (28:1407im MDL: Silicone Gel Breast Implant Products Liability)",
      "28:1407md" : "28:1407md (28:1407md MDL: Multidistrict Litigation)",
      "28:1407n" : "28:1407n (28:1407n MDL: Personal Injury/Norplant Product Liability)",
      "28:1407pl" : "28:1407pl (28:1407pl MDL: Products Liability)",
      "28:1441ac" : "28:1441ac (28:1441ac Removal- Account Receivable)",
      "28:1441ada" : "28:1441ada (28:1441ada Removal- Americans with Disabilities Act)",
      "28:1441ag" : "28:1441ag (28:1441ag Removal- Civil Rights (Age))",
      "28:1441al" : "28:1441al (28:1441al Removal- Airline Crash)",
      "28:1441as" : "28:1441as (28:1441as Removal- Asbestos Litigation)",
      "28:1441au" : "28:1441au (28:1441au Removal- Auto Negligence)",
      "28:1441ba" : "28:1441ba (28:1441ba Removal - National Bank Act)",
      "28:1441bc" : "28:1441bc (28:1441bc Removal- Breach of Contract)",
      "28:1441bfd" : "28:1441bfd (28:1441bfd Removal- Breach of Fiduciary Duties)",
      "28:1441ca" : "28:1441ca (28:1441ca Removal - Carmack Amendment)",
      "28:1441cc" : "28:1441cc (28:1441cc Removal- Computer Crimes Act)",
      "28:1441cj" : "28:1441cj (28:1441cj Removal- Confessed Judgement)",
      "28:1441cla" : "28:1441cla (28:1441cla Removal - Consumer Leasing Act)",
      "28:1441cp" : "28:1441cp (28:1441cp Removal- Copyright)",
      "28:1441cpl" : "28:1441cpl (28:1441cpl Removal - Contract Product Liability)",
      "28:1441cra" : "28:1441cra (28:1441cra Removal - Fair Credit Reporting Act)",
      "28:1441cv" : "28:1441cv (28:1441cv Removal- Civil Rights Act)",
      "28:1441dea" : "28:1441dea (28:1441dea Removal - Disabilities Education Act)",
      "28:1441df" : "28:1441df (28:1441df Removal- Contract Default)",
      "28:1441di" : "28:1441di (28:1441di Removal- Civil Rights (Disability Act))",
      "28:1441dj" : "28:1441dj (28:1441dj Removal- Declaratory Judgment)",
      "28:1441ds" : "28:1441ds (28:1441ds Removal- Contract Dispute)",
      "28:1441ea" : "28:1441ea (28:1441ea Removal- Employment Discrimination (Age))",
      "28:1441eb" : "28:1441eb (28:1441eb Removal - E.R.I.S.A. Employee Benefits)",
      "28:1441ec" : "28:1441ec (28:1441ec Removal - Electronic Comm. Privacy Act)",
      "28:1441ed" : "28:1441ed (28:1441ed Removal - Employment Discrimination)",
      "28:1441em" : "28:1441em (28:1441em Removal - Emergency Medical Treatment & Active Labor)",
      "28:1441er" : "28:1441er (28:1441er Removal- Employment Discrimination (Race))",
      "28:1441es" : "28:1441es (28:1441es Removal- Employment Discrimination (Sex))",
      "28:1441fa" : "28:1441fa (28:1441fa Removal - Civil Rights - False Arrest)",
      "28:1441fc" : "28:1441fc (28:1441fc Removal - Fair Credit Reporting Act)",
      "28:1441fd" : "28:1441fd (28:1441fd Removal - Fair Debt Collection Practices Act)",
      "28:1441fe" : "28:1441fe (28:1441fe Removal- Fed. Employee Garnishment Statute)",
      "28:1441fh" : "28:1441fh (28:1441fh Removal- FEHBA)",
      "28:1441fif" : "28:1441fif (28:1441fif Removal - Insecticide/Fungicide/Rodenticide Act -1942)",
      "28:1441fl" : "28:1441fl (28:1441fl Removal- Fair Labor Standards Act)",
      "28:1441fm" : "28:1441fm (28:1441fm Removal - Family and Medical Leave Act)",
      "28:1441fr" : "28:1441fr (28:1441fr Removal- Fraud)",
      "28:1441fs" : "28:1441fs (28:1441fs Removal - Foreign Sovereign Immunities Act)",
      "28:1441fsa" : "28:1441fsa (28:1441fsa Removal - Federal Food Stamp Act)",
      "28:1441hb" : "28:1441hb (28:1441hb Removal - Petition of Habeas Corpus)",
      "28:1441hc" : "28:1441hc (28:1441hc Removal - Handicapped Child Protection Act)",
      "28:1441hd" : "28:1441hd (28:1441hd Removal- Housing Discrimination)",
      "28:1441ia" : "28:1441ia (28:1441ia Removal- Interstate Commerce Act)",
      "28:1441if" : "28:1441if (28:1441if Removal - Insurance Fraud)",
      "28:1441ij" : "28:1441ij (28:1441ij Removal- Injunctive/Declaratory Relief)",
      "28:1441il" : "28:1441il (28:1441il Removal- Interstate Land Full Discloser Act)",
      "28:1441in" : "28:1441in (28:1441in Removal- Insurance Contract)",
      "28:1441int" : "28:1441int (28:1441int Removal- Action for Interpleader)",
      "28:1441la" : "28:1441la (28:1441la Removal - Truth in Lending Act)",
      "28:1441lb" : "28:1441lb (28:1441lb Removal- Libel, Assault, Slander)",
      "28:1441lm" : "28:1441lm (28:1441lm Removal- Labor/Mgmt. Relations)",
      "28:1441ml" : "28:1441ml (28:1441ml Removal- Motor Vehicle Prod Liability)",
      "28:1441mm" : "28:1441mm (28:1441mm Removal- Medical Malpractice)",
      "28:1441mv" : "28:1441mv (28:1441mv Removal- Motor Vehicle)",
      "28:1441ni" : "28:1441ni (28:1441ni Removal- Negotiable Instrument)",
      "28:1441nm" : "28:1441nm (28:1441nm Removal- Non-Motor Vehicle)",
      "28:1441nr" : "28:1441nr (28:1441nr Notice of Removal)",
      "28:1441oc" : "28:1441oc (28:1441oc Removal- Other Contract)",
      "28:1441pa" : "28:1441pa (28:1441pa Removal - Patent Infringement)",
      "28:1441pd" : "28:1441pd (28:1441pd Removal- Property Damage)",
      "28:1441pi" : "28:1441pi (28:1441pi Removal- Personal Injury)",
      "28:1441pl" : "28:1441pl (28:1441pl Removal- Product Liability)",
      "28:1441pr" : "28:1441pr (28:1441pr Petition for Removal)",
      "28:1441qt" : "28:1441qt (28:1441qt Removal- Petition to Quiet Title)",
      "28:1441ra" : "28:1441ra (28:1441ra Removal- Civil Rights (Race))",
      "28:1441ri" : "28:1441ri (28:1441ri Removal- Racketeering (RICO))",
      "28:1441rl" : "28:1441rl (28:1441rl Removal- Rent, Lease, & Ejectment)",
      "28:1441sa" : "28:1441sa (28:1441sa Removal- SEC Act)",
      "28:1441sf" : "28:1441sf (28:1441sf Removal- Securities Fraud)",
      "28:1441sh" : "28:1441sh (28:1441sh Removal-Sexual Harassment)",
      "28:1441st" : "28:1441st (28:1441st Removal - Stockholders Suit)",
      "28:1441sv" : "28:1441sv (28:1441sv Removal-Security Violation)",
      "28:1441sx" : "28:1441sx (28:1441sx Removal-Civil Rights (Sex))",
      "28:1441tc" : "28:1441tc (28:1441tc Removal - Tricare Program)",
      "28:1441ti" : "28:1441ti (28:1441ti Removal-Trademark Infringement)",
      "28:1441til" : "28:1441til (28:1441til Removal - Truth and Lending)",
      "28:1441tl" : "28:1441tl (28:1441tl Removal- Torts to Land)",
      "28:1441tm" : "28:1441tm (28:1441tm Removal- Tort/Motor Vehicle (P.I.))",
      "28:1441tn" : "28:1441tn (28:1441tn Removal- Tort/Non-Motor Vehicle)",
      "28:1441us" : "28:1441us (28:1441us Removal - Uniformed Svc Emp/Reemp Rights Act)",
      "28:1441wc" : "28:1441wc (28:1441wc Removal - Worker's Compensation Benefits)",
      "28:1441wd" : "28:1441wd (28:1441wd Removal- Wrongful Death)",
      "28:1441wt" : "28:1441wt (28:1441wt Removal- Employment (Wrongful Termination))",
      "28:1442" : "28:1442 (28:1442 Notice of Removal - Suit against Federal Officer)",
      "28:1442aaf" : "28:1442aaf (28:1442aaf Petition for Removal - Agst members of armed forces)",
      "28:1443(1)" : "28:1443(1) (28:1443(1) Removal from State Court - Civil Rights: Rent, Lease, and Ejectment)",
      "28:1444" : "28:1444 (28:1444 Notice of Removal- Foreclosure)",
      "28:1446al" : "28:1446al (28:1446al Notice of Removal - Airline Crash)",
      "28:1446as" : "28:1446as (28:1446as Notice of Removal - Asbestos Litigation)",
      "28:1446bc" : "28:1446bc (28:1446bc Notice of Removal - Breach of Contract)",
      "28:1446cs" : "28:1446cs (28:1446cs Notice of Removal - Child Support Enforcement)",
      "28:1446dj" : "28:1446dj (28:1446dj Notice of Removal - Declaratory Judgment)",
      "28:1446er" : "28:1446er (28:1446er Notice of Removal - E.R.I.S.A)",
      "28:1446fm" : "28:1446fm (28:1446fm Notice of Removal - Family and Medical Leave Act)",
      "28:1446fr" : "28:1446fr (28:1446fr Notice of Removal - Fraud)",
      "28:1446in" : "28:1446in (28:1446in Breach of Contract - Insurance)",
      "28:1446lb" : "28:1446lb (28:1446lb Notice of Removal - Libel, Assault, Slander)",
      "28:1446ml" : "28:1446ml (28:1446ml Notice of Removal - Motor Vehicle Prod Liability)",
      "28:1446mm" : "28:1446mm (28:1446mm Notice of Removal - Medical Malpractice)",
      "28:1446mv" : "28:1446mv (28:1446mv Notice of Removal - Motor Vehicle)",
      "28:1446ni" : "28:1446ni (28:1446ni Notice of Removal - Negotiable Instrument)",
      "28:1446nr" : "28:1446nr (28:1446nr Notice of Removal)",
      "28:1446oc" : "28:1446oc (28:1446oc Notice of Removal - Other Contract)",
      "28:1446pd" : "28:1446pd (28:1446pd Notice of Removal - Property Damage (P.I.))",
      "28:1446pi" : "28:1446pi (28:1446pi Notice of Removal- Personal Injury)",
      "28:1446pl" : "28:1446pl (28:1446pl Notice of Removal - Product Liability)",
      "28:1446pr" : "28:1446pr (28:1446pr Petition for Removal)",
      "28:1446st" : "28:1446st (28:1446st Notice of Removal - Stockholders Suit)",
      "28:1446tl" : "28:1446tl (28:1446tl Notice of Removal - Torts to Land)",
      "28:1446wd" : "28:1446wd (28:1446wd Notice of Removal - Wrongful Death)",
      "28:1452" : "28:1452 (28:1452 Removal of Claims Related to Bankruptcy Cases)",
      "28:1453" : "28:1453 (28:1453 Class Action Fairness Act)",
      "28:1491" : "28:1491 (28:1491 Tucker Act)",
      "28:1602" : "28:1602 (28:1602 Foreign Sovereign Immunities Act)",
      "28:1605" : "28:1605 (28:1605 Foreign Sovereign Immunities Act of 1976)",
      "28:1605A" : "28:1605A (28:1605A Antiterrorism & Effective Death Penalty Act 1996)",
      "28:1610" : "28:1610 (28:1610 Juridictional Immunities of Foreign States)",
      "28:1631" : "28:1631 (28:1631 Case Transferred to Cure Want of Jurisdiction)",
      "28:1651cn" : "28:1651cn (28:1651cn Petition for Writ of Error Coram Nobis )",
      "28:1651hc" : "28:1651hc (28:1651hc Petition for Writ of Habeas Corpus)",
      "28:1651mn" : "28:1651mn (28:1651mn Petition for Writ of Mandamus)",
      "28:1651ne" : "28:1651ne (28:1651ne Application for Writ Ne Exeat)",
      "28:1651w" : "28:1651w (28:1651w All Writs Act)",
      "28:1715" : "28:1715 (28:1715 Class Action Fairness Act of 2005)",
      "28:1732" : "28:1732 (28:1732 Reproduction of Records)",
      "28:1738Acs" : "28:1738Acs (28:1738Acs The Uniform Child Custody Jurisdiction Act)",
      "28:1782" : "28:1782 (28:1782 Assistance to Foreign Tribunals (incl letter rogatory))",
      "28:1783" : "28:1783 (28:1783 Petition for Subpoena of person in foreign country)",
      "28:1826" : "28:1826 (28:1826 Order of confinement of recalcitrant witness)",
      "28:1875" : "28:1875 (28:1875 Juror Protection Act / Protection of Jurors' Employment)",
      "28:1916" : "28:1916 (28:1916 Marine Personal Injury)",
      "28:1963" : "28:1963 (28:1963 Registration of judgment from another district)",
      "28:2001" : "28:2001 (28:2001 Judicial Sale of Realty)",
      "28:2071" : "28:2071 (28:2071 Rule Making Power Generally)",
      "28:2201" : "28:2201 (28:2201 Creation of a Remedy - Declaration of Rights)",
      "28:2201an" : "28:2201an (28:2201an Declaratory Judgement (aliens and nationality))",
      "28:2201cp" : "28:2201cp (28:2201cp Declaratory Judgment (Copyright))",
      "28:2201dj" : "28:2201dj (28:2201dj Declaratory Judgment)",
      "28:2201fa" : "28:2201fa (28:2201fa Declaratory Judgment- Firearms)",
      "28:2201fs" : "28:2201fs (28:2201fs Declaratory Judgment (Food Security Act))",
      "28:2201ij" : "28:2201ij (28:2201ij Injunction)",
      "28:2201in" : "28:2201in (28:2201in Declaratory Judgment (Insurance))",
      "28:2201pi" : "28:2201pi (28:2201pi Declaratory Judgment - Personal Injury)",
      "28:2241fd" : "28:2241fd (28:2241fd Petition for Writ of Habeas Corpus (federal))",
      "28:2241in" : "28:2241in (28:2241in Habeas Corpus: INS)",
      "28:2241st" : "28:2241st (28:2241st Petition for Writ of Habeas Corpus (State))",
      "28:2244" : "28:2244 (28:2244 Habeas Corpus - Finality of Determination)",
      "28:2254" : "28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))",
      "28:2254dp" : "28:2254dp (28:2254dp Petition for Writ of Habeas Corpus (Death Penalty))",
      "28:2254se" : "28:2254se (28:2254se Petition for Writ of Habeas Corpus (Stay of Execution))",
      "28:2255" : "28:2255 (28:2255 Motion to Vacate / Correct Illegal Sentence)",
      "28:2283" : "28:2283 (28:2283 Stay of State Court Proceedings (Injunctive Relief))",
      "28:2347" : "28:2347 (28:2347 Petition to Review Orders in the Ct of Appeals)",
      "28:2401" : "28:2401 (28:2401 Federal Tort Claims Act (Time for commencing action against the US))",
      "28:2403" : "28:2403 (28:2403 Constitutionality of State Statute(s) )",
      "28:2405" : "28:2405 (28:2405 Garnishment of debtors of a corporation by US)",
      "28:2409(a)" : "28:2409(a) (28:2409(a) Quiet Title Action)",
      "28:2410" : "28:2410 (28:2410 Quiet Title - Actions affecting property on which United States has lien)",
      "28:2412" : "28:2412 (28:2412 Equal Access to Justice Act)",
      "28:2415" : "28:2415 (28:2415 Detinue and Conversion)",
      "28:2671" : "28:2671 (28:2671 Federal Tort Claims Act (Definitions))",
      "28:2672mv" : "28:2672mv (28:2672mv Federal Tort Claims Act - Motor Vehicle)",
      "28:2672pi" : "28:2672pi (28:2672pi Federal Tort Claim Act - Personal Injury)",
      "28:2674" : "28:2674 (28:2674 Federal Tort Claims Act - Liability of US)",
      "28:2675" : "28:2675 (28:2675 Federal Tort Claims Act - Disposition by Agency Req)",
      "28:2679d2" : "28:2679d2 (28:2679(d)(2) Federal Tort Claims Act - Employee of U.S.A.)",
      "28:2680" : "28:2680 (28:2680 Federal Tort Claims Act - Exceptions)",
      "28:3001" : "28:3001 (28:3001 Federal Debt Collection Act)",
      "28:3001(a)" : "28:3001(a) (28:3001(a) Federal Debt Collection Procedures Act of 1990)",
      "28:3203" : "28:3203 (28:3203 Postjudgment Remedies: Writ of Execution)",
      "28:3301" : "28:3301 (28:3301 Fraudulent Transfer Federal Debt Collection Procedures Act)",
      "29:0101" : "29:0101 (29:0101 Labor: Issuance of Restraining Orders and Injunctions )",
      "29:0151" : "29:0151 (29:0151 Labor: National Labor Relations Act (NLRA))",
      "29:0158(b)" : "29:0158(b) (29:0158(b) Labor: NLRA - Unfair Labor Practices)",
      "29:0159" : "29:0159 (29:0159 Labor: Violation of Collective Bargaining Agreement )",
      "29:0160" : "29:0160 (29:0160 Labor: NLRA - Prevention of Unfair Labor Practices)",
      "29:0160j" : "29:0160j (29:0160j Labor: Petition for Inj - Relief from Unfair Labor Practice)",
      "29:0160l" : "29:0160l (29:0160l Labor: Petition for Inj re Uncertified Labor Organizations)",
      "29:0161(2)" : "29:0161(2) (29:0161(2) Labor: Enforcement of agency subpoena)",
      "29:0178" : "29:0178 (29:0178 Labor: Petition for Inj to Enjoin Strike during Natl Emergency)",
      "29:0185" : "29:0185 (29:0185 Labor: Suits by and against Labor Organizations)",
      "29:0186" : "29:0186 (29:0186 Labor: Liabilities of and Restrictions on Labor and Management)",
      "29:0187" : "29:0187 (29:0187 Labor: Recover Damages from Unfair Labor Practice)",
      "29:0201fl" : "29:0201fl (29:0201fl FLSA: Fair Labor Standards Act (FLSA))",
      "29:0203" : "29:0203 (29:0203 FLSA: Definitions)",
      "29:0206" : "29:0206 (29:0206 FLSA: Minimum Wage)",
      "29:0206(d)" : "29:0206(d) (29:0206(d) FLSA: Prohibition of Sex Discrimination)",
      "29:0207(a)" : "29:0207(a) (29:0207(a) FLSA: Action for Overtime Wage Violation)",
      "29:0207fl" : "29:0207fl (29:0207fl FLSA: Maximum Hours)",
      "29:0210" : "29:0210 (29:0210 FLSA: Court Review of Wage Orders in PR and VI)",
      "29:0215fl" : "29:0215fl (29:0215fl FLSA: Prohibited Acts)",
      "29:0216(b)" : "29:0216(b) (29:0216(b) FLSA: Minimum wage or overtime compensation)",
      "29:0216(e)" : "29:0216(e) (29:0216(e) FLSA: Penalty assessed for child labor provisions)",
      "29:0217" : "29:0217 (29:0217 FLSA: Enjoin Violations of Fair Labor Standards Act)",
      "29:0260" : "29:0260 (29:0260 FLSA: Liquidated Damages)",
      "29:0401" : "29:0401 (29:0401 Labor Management Disclosure Act)",
      "29:0411" : "29:0411 (29:0411 Landrum Griffin Act)",
      "29:0412" : "29:0412 (29:0412 Infringement of rights; members of labor organization)",
      "29:0440" : "29:0440 (29:0440 violations reporting requirements; labor organization)",
      "29:0501(b)" : "29:0501(b) (29:0501(b) Violation of Fiduciary Responsibility)",
      "29:0621" : "29:0621 (29:0621 Job Discrimination (Age))",
      "29:0623" : "29:0623 (29:0623 Job Discrimination (Prohibition of Age Discrimination))",
      "29:0626" : "29:0626 (29:0626 Job Discrimination (Investigation and Enforcement))",
      "29:0633" : "29:0633 (29:0633 Job Discrimination (Age - Federal-State Realtionshship))",
      "29:0651" : "29:0651 (29:0651 Occupational Safety/Health)",
      "29:0660" : "29:0660 (29:0660 Action by Sec Labor for discrimination re rights OSHA)",
      "29:0662" : "29:0662 (29:0662 Inj proceedings re dangerous emp conditions; by Sec.)",
      "29:0666" : "29:0666 (29:0666 Collection of civil penalties under OSHA)",
      "29:0701" : "29:0701 (29:0701 Vocational Rehabilitation)",
      "29:0791" : "29:0791 (29:0791 Job Discrimination (Rehabilitation Act))",
      "29:0792d2" : "29:0792d2 (29:0792(d)(2) Accessible facilities for phys. handicapped emp)",
      "29:0794" : "29:0794 (29:0794 Job Discrimination (Handicap))",
      "29:1001" : "29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)",
      "29:1002" : "29:1002 (29:1002 E.R.I.S.A.: Employee Retirement (Definitions))",
      "29:1055" : "29:1055 (29:1055 E.R.I.S.A., Employee Retirement (Joint and Survivor Annuity))",
      "29:1101" : "29:1101 (29:1101 E.R.I.S.A.: Coverage)",
      "29:1104" : "29:1104 (29:1104 E.R.I.S.A.: Recovery of Benefits to Employee)",
      "29:1109" : "29:1109 (29:1109 E.R.I.S.A.: Breach of Fiduciary Duties)",
      "29:1132" : "29:1132 (29:1132 E.R.I.S.A.: Civil Enforcement of Employee Benefits )",
      "29:1145" : "29:1145 (29:1145 E.R.I.S.A.: Delinquent Contributions)",
      "29:1149" : "29:1149 (29:1149 E.R.I.S.A.: Prohibition on False Statements and Representations)",
      "29:1161" : "29:1161 (29:1161 COBRA - Continuation Coverage)",
      "29:1162" : "29:1162 (29:1162 COBRA - Continuation Coverage)",
      "29:1303" : "29:1303 (29:1303 PBGC: Operation of Corporation)",
      "29:1362" : "29:1362 (29:1362 E.R.I.S.A.: Liability for Termination of Single Employer Plans)",
      "29:1381" : "29:1381 (29:1381 E.R.I.S.A.: Withdrawal Liability)",
      "29:1401b2" : "29:1401b2 (29:1401(b)(2) E.R.I.S.A.: Resolution of Disputes - Appeal of Arbitration Award)",
      "29:1451" : "29:1451 (29:1451 E.R.I.S.A.: Enforcement - Civil Actions)",
      "29:1801" : "29:1801 (29:1801 Farmworker Rights)",
      "29:1854" : "29:1854 (29:1854 Migrant & Seasonal Agri Worker Protect Act (AWPA))",
      "29:1916" : "29:1916 (29:1916 Spec. Rule for Longshoremen & Harborworkers)",
      "29:2001" : "29:2001 (29:2001 Employee Polygraph Protection Act)",
      "29:2101" : "29:2101 (29:2101 Worker Adjustment and Retraining Notification Act)",
      "29:2104" : "29:2104 (29:2104 Worker Adjustment & Retraining Notification (WARN))",
      "29:2601" : "29:2601 (29:2601 FMLA: Family and Medical Leave Act (Findings and Purposes))",
      "29:2611" : "29:2611 (29:2611 FMLA: Definitions)",
      "29:2612" : "29:2612 (29:2612 FMLA: Leave Requirements)",
      "29:2617" : "29:2617 (29:2617 FMLA: Enforcement)",
      "30:0022" : "30:0022 (30:0022 General Mining Law of 1872 (Lands Open to Purchase by Citizens))",
      "30:0181" : "30:0181 (30:0181 Land subject to disposition; persons entitled to benefits; reciprocal privileges)",
      "30:0801" : "30:0801 (30:0801 Penalities/Federal Mine Safety Health Act)",
      "30:0815" : "30:0815 (30:0815 Federal Mine Safety & Health Act (Procedure for Enforcement))",
      "30:1201" : "30:1201 (30:1201 Environment: Review of Agency Action (Congressional Findings))",
      "30:1202" : "30:1202 (30:1202 Mining Reclamation Act (Statement of Purpose))",
      "30:1276" : "30:1276 (30:1276 Interior: Judicial Review of Agency Action)",
      "30:1701" : "30:1701 (30:1701 Federal Oil Gas Royalty Mgt Act 1982 (FOGRMA))",
      "31:0732" : "31:0732 (31:0732 General Acct. Office Personnel Act of 1980 (Personnel Management System))",
      "31:1341" : "31:1341 (31:1341 Government employee--limitations on expending monies)",
      "31:3545" : "31:3545 (31:3545 Civil Action to Recovery Money)",
      "31:3702" : "31:3702 (31:3702 Procedures for Settling Claims )",
      "31:3713" : "31:3713 (31:3713 Priority of Government Claims)",
      "31:3720" : "31:3720 (31:3720 Federal Income Tax Interceptions (Collection of Payments))",
      "31:3728" : "31:3728 (31:3728 Setoff against Judgment )",
      "31:3729" : "31:3729 (31:3729 False Claims Act - Liability )",
      "31:3730" : "31:3730 (31:3730 Qui Tam False Claims Act)",
      "31:3731" : "31:3731 (31:3731 False Claims Act - Procedures)",
      "31:3733j2" : "31:3733j2 (31:3733(j)(2) Pet to Mod or Set Aside CV Investigative Demand)",
      "31:5314" : "31:5314 (31:5314 Failure to Report Interest in Foreign Accounts)",
      "31:5317" : "31:5317 (31:5317 Search and Forfeiture of Monetary Instruments)",
      "31:5320" : "31:5320 (31:5320 Inj proceedings re Rpts of Currency & Foreign Trans. )",
      "31:5321" : "31:5321 (31:5321 Penalty; Reports of Currency and Foreign Transaction )",
      "31:5332(a)" : "31:5332(a) (31:5332(a) Evading Currency Reporting Requirement)",
      "31:5332(f)" : "31:5332(f) (31:5332(f) Transport and Transfer US currency from in to out)",
      "31:6716" : "31:6716 (31:6716 Discrimination re money and finance )",
      "31:9701" : "31:9701 (31:9701 Federal User Charge Statute)",
      "33:0408" : "33:0408 (33:0408 Injury to Harbor Improvement)",
      "33:0594" : "33:0594 (33:0594 Land Condemnation)",
      "33:0901" : "33:0901 (33:0901 Longshoremen Harbor Workers Compensation Act (Navigation and Navigable Waters))",
      "33:0905(b)" : "33:0905(b) (33:0905(b) Longshoremen Workers Comp. Act - Recovery of Damage caused by negligence of Vessel)",
      "33:0918" : "33:0918 (33:0918 Longshore and Harbor Workers Compensation Act - Collection of Defaulted Payments)",
      "33:0921" : "33:0921 (33:0921 Longshore & Harbor Workers Compensation Act - Review of Compensation Orders)",
      "33:0933" : "33:0933 (33:0933 Longshore and Harbor Workers Comp.Act - Compensation for Injuries (Third-Party Claims))",
      "33:1221" : "33:1221 (33:1221 Ports and Waterways Safety Program)",
      "33:1251" : "33:1251 (33:1251 Federal Water Pollution Control Act (Clean Water Act))",
      "33:1319a2" : "33:1319a2 (33:1319(a)(2)pv Clean Water Act - Pollutants & Permit Violations)",
      "33:1319cw" : "33:1319cw (33:1319cw Clean Water Act - Enforcement)",
      "33:1321" : "33:1321 (33:1321 Clean Water Act - Discharge of hazardous substance or pollutants/water)",
      "33:1361" : "33:1361 (33:1361 Clean Water Act-Administrator Authority)",
      "33:1364" : "33:1364 (33:1364 Clean Water Act - EPA action to restrain pollution endangering health (emergency powers))",
      "33:1365" : "33:1365 (33:1365 Clean Water Act - Citizen Suits re Environmental Matters )",
      "33:1415" : "33:1415 (33:1415 Marine Protection, Research, and Sanctuaries Act)",
      "33:1515" : "33:1515 (33:1515 Deepwater Ports Act (citizen civil action))",
      "33:2701" : "33:2701 (33:2701 Oil Pollution Act of 1940)",
      "35:0001" : "35:0001 (35:0001 Establishment of PTO)",
      "35:0032" : "35:0032 (35:0032 Suspension from Practice before Patent & Trade. Off.)",
      "35:0145" : "35:0145 (35:0145 Civil Action to Obtain Patent)",
      "35:0146" : "35:0146 (35:0146 Appeal from Decision of the Board of Patent Appeals)",
      "35:0183" : "35:0183 (35:0183 Right to Compensation - Patent Laws)",
      "35:0256" : "35:0256 (35:0256 Patent Non-Infringement (Correction of Named Inventor))",
      "35:0271" : "35:0271 (35:0271 Patent Infringement)",
      "35:0281" : "35:0281 (35:0281 Remedy for Infringement of Patent/jurisdiction conferred 28:1338)",
      "35:0282" : "35:0282 (35:0282 Patent Infringement - Defenses)",
      "35:0283" : "35:0283 (35:0283 Action to enjoin violation of right secured by patent)",
      "35:0289" : "35:0289 (35:0289 Recover profits from unlicensed use of design patent)",
      "35:0291" : "35:0291 (35:0291 Action for relief between owners; interfering patents)",
      "35:0292" : "35:0292 (35:0292 Penalty & Forfeiture; illegal use of word patent (false marking))",
      "35:0311" : "35:0311 (35:0311 Patent - Request for Inter Partes Reexamination)",
      "38:1110" : "38:1110 (38:1110 Basic Entitlements / Wartime)",
      "38:1131" : "38:1131 (38:1131 Basic Entitlements / Peacetime)",
      "38:1816" : "38:1816 (38:1816 Deficiency balance on VA Mortgage Foreclosure (Reg. Governing the VA Loan Guaranty Prgm))",
      "38:1965" : "38:1965 (38:1965 Servicemen's Group Life Insurance (Definitions))",
      "38:1975" : "38:1975 (38:1975 Recovery of Servicemen's Group Life Insurance - Jurisdiction of District Court)",
      "38:1984" : "38:1984 (38:1984 Suit for Veterans Insurance)",
      "38:3481" : "38:3481 (38:3481 Recovery of VA Overpayment)",
      "38:3680" : "38:3680 (38:3680 Recovery of Education Assist Allowance Overpayment)",
      "38:4212" : "38:4212 (38:4212 Veterans Employment Emphasis Under Federal Contracts )",
      "38:4301" : "38:4301 (38:4301 Uniformed Srvs. Employment & Reemployment Rights Act (purpose))",
      "38:4302" : "38:4302 (38:4302 Veterans Reemployment Rights Act (relation to other laws and plans or agreements.)",
      "38:4311" : "38:4311 (38:4311 Uniformed Service Employment or Reemployment Rights Act (USERRA) - Discrimination)",
      "38:4312" : "38:4312 (38:4312 Rights of inducted persons to reemployment )",
      "38:4323" : "38:4323 (38:4323 USERRA - Enforcement of rights with respect to state or private employer )",
      "38:4324" : "38:4324 (38:4324 USERRA - Enforcement of rights with respect to federal executive agencies)",
      "38:5315" : "38:5315 (38:5315 Delinquent Payment of Amounts Due to US)",
      "38:5316" : "38:5316 (38:5316 VA Overpayment )",
      "39:0403" : "39:0403 (39:0403 Discriminatory use of the Postal Service)",
      "39:0409" : "39:0409 (39:0409 Suits by and against the Postal Service)",
      "39:1207" : "39:1207 (39:1207 Review Agency Action--Labor Disputes)",
      "39:1208(b)" : "39:1208(b) (39:1208(b) Postal Reorganization Act of 1970 - Suits)",
      "39:3005" : "39:3005 (39:3005 False Representations and Lotteries)",
      "39:3007" : "39:3007 (39:3007 Detention of Mail for Temporary Periods - Injunction directing retention of incoming mail)",
      "39:3008(e)" : "39:3008(e) (39:3008(e) Enforce compliance with a USPS Prohibitory Order)",
      "40:0581" : "40:0581 (40:0581 General Authority of Administrator of General Services)",
      "40:1101" : "40:1101 (40:1101 Brooks Architect - Engineers Act)",
      "40:3131" : "40:3131 (40:3131 Bonds of contractors of public buildings )",
      "40:3142" : "40:3142 (40:3142 Davis-Bacon Act (prevailing wages))",
      "41:2102" : "41:2102 (41:2102-2107 Procurement Integrity Act)",
      "41:3301" : "41:3301 (41:3301 Competition in Contracting Act)",
      "41:6503" : "41:6503 (41:6503 Walsh-Healy Act - Breach of Public Contract)",
      "41:6505" : "41:6505 (41:6505 Exclusions - Review of legal questions in contracts; Walsh-Healy Act)",
      "41:6702" : "41:6702 (41:6702-6704 Service Contract Labor Standards / McNamara-O'Hara Service Contract Act 1965)",
      "41:7105(f)" : "41:7105(f) (41:7105(f) Action to Judicially Enforce Administrative Subpoena)",
      "42:0205" : "42:0205 (42:0205 Appointment of Surgeon General)",
      "42:0206" : "42:0206 (42:0206 Surgeon General - Assignment of Officers)",
      "42:0254o" : "42:0254o (42:0254o Breach of Scholarship Contract)",
      "42:0256" : "42:0256 (42:0256 Public Health Services Act - Grants)",
      "42:0292f" : "42:0292f (42:0292f Default of borrower)",
      "42:0292k" : "42:0292k (42:0292k Student loan insurance (Public Health Occupations))",
      "42:0293" : "42:0293 (42:0293 Recovery of losses from loan guarantee; public health)",
      "42:0297" : "42:0297 (42:0297 Student loans; public or nonprofit school of nursing)",
      "42:0300aa" : "42:0300aa (42:0300aa-1 Nat'l. Childhood Vaccine Injury Compensation Act)",
      "42:0300f" : "42:0300f (42:0300f Safe Drinking Water Act (Definitions))",
      "42:0300g" : "42:0300g (42:0300g Actions re safety of public water systems (EPA))",
      "42:0300g-3" : "42:0300g-3 (42:0300g-3 Enforcement of Drinking Water Regulations)",
      "42:0401" : "42:0401 (42:0401 Social Security Act - Trust Funds)",
      "42:0402" : "42:0402 (42:0402 Social Security Benefits)",
      "42:0405id" : "42:0405id (42:0405id Review of HHS Decision (SSID))",
      "42:0405rs" : "42:0405rs (42:0405rs Review of HHS Decision (RSI))",
      "42:0405wc" : "42:0405wc (42:0405wc Review of HHS Decision (DIWC))",
      "42:0405ww" : "42:0405ww (42:0405ww Review of HHS Decision (DIWW))",
      "42:0421(d)" : "42:0421(d) (42:0421(d) Review HHS decision re disability determinations)",
      "42:0423" : "42:0423 (42:0423 Social Security Act (Disability Insurance Benefit Payments))",
      "42:0427" : "42:0427 (42:0427 Social Security Benefits (Transitional Insured Status))",
      "42:0601" : "42:0601 (42:0601 Title IV-A of Social Security Act (Grants to States for Aid and Assist to Needy Families))",
      "42:0602" : "42:0602 (42:0602 Temp. Assistance for Needy Families (TANF) )",
      "42:0660" : "42:0660 (42:0660 Action to enforce child support obligations)",
      "42:10139" : "42:10139 (42:10139 judicial review of agency actions )",
      "42:10801" : "42:10801 (42:10801 Protection & Advocacy for Individuals with Mental Illness Act of 1986 (PAIMI))",
      "42:10805" : "42:10805 (42:10805 Protection and Advocacy Systems)",
      "42:11001" : "42:11001 (42:11001 Emergency Plan. & Comm. Right to Know Act (EPCRA))",
      "42:11046" : "42:11046 (42:11046 Fed Emer Plan Comm Right-to-know Act (EPCRA) - civil actions)",
      "42:11101" : "42:11101 (42:11101 Health Care Quality Improvement Act of 1986 )",
      "42:11112" : "42:11112 (42:11112 Health Care Quality Improvement Act (Standards for Professional Review Actions))",
      "42:11601" : "42:11601 (42:11601 International Child Abduction Remedies Act)",
      "42:11603b" : "42:11603b (42:11603(b) Int'l. Child Abduction Remedies Act (ICARA) - Judicial Remedies)",
      "42:12101" : "42:12101 (42:12101 The Americans with Disabilities Act of 1990)",
      "42:12102" : "42:12102 (42:12102 Americans with Disabilities Act (ADA) Disability Definition)",
      "42:12111" : "42:12111 (42:12111 Americans with Disabilities Act - Employment )",
      "42:12112" : "42:12112 (42:12112 Americans with Disabilities Act - Employment Discrimination)",
      "42:12117" : "42:12117 (42:12117 Americans with Disabilities Act - Enforcement)",
      "42:12132" : "42:12132 (42:12132 Americans with Disabilities Act - Discrimination)",
      "42:12188" : "42:12188 (42:12188 Americans With Disabilities Act - Civil Enforcement Actions)",
      "42:1320a" : "42:1320a (42:1320a-7b(b)(2)(A) Anti-Kickback Act (for federal health care programs) )",
      "42:1320d-2" : "42:1320d-2 (42:1320d-2 Health Insurance Portability And Accountability Act (HIPAA))",
      "42:1381a" : "42:1381a (42:1381a Supplemental Security Income benefits (SSID))",
      "42:1382" : "42:1382 (42:1382 Eligibility for benefits)",
      "42:1383" : "42:1383 (42:1383 Review of HHS Decision (regarding payment of benefits))",
      "42:1395" : "42:1395 (42:1395 Emergency Medical Treatment and Active Labor Act )",
      "42:1395dd" : "42:1395dd (42:1395dd Exam & Treatment Emergency Med Cond & Women in Labor)",
      "42:1395hr" : "42:1395hr (42:1395hr Hospital Reimbursement for Medicare Services)",
      "42:1395w" : "42:1395w (42:1395w-21 Medicare Act (Eligibility, Election, and Enrollment))",
      "42:1396a" : "42:1396a (42:1396a State Plans for Medical Assistance)",
      "42:1396b" : "42:1396b (42:1396b Medical Assist Prgm, Pmt to States/Medicaid Implem)",
      "42:13981" : "42:13981 (42:13981 Violence Against Women Act (Civil Rights))",
      "42:14135" : "42:14135 (42:14135 DNA Backlog Grant Program)",
      "42:1437" : "42:1437 (42:1437 U.S. Housing Act of 1937)",
      "42:1475" : "42:1475 (42:1475 Declaratory & Injunctive Relief - Foreclosure Procedures)",
      "42:1479" : "42:1479 (42:1479 Mortgage, lease, contract re farm housing)",
      "42:14901" : "42:14901 (42:14901 Intercountry Adoptions)",
      "42:15483" : "42:15483 (42:15483 Help America Vote Act)",
      "42:1651" : "42:1651 (42:1651 Defense Base Act)",
      "42:1705" : "42:1705 (42:1705 Receipt of Workmen's compensation benefits)",
      "42:1971" : "42:1971 (42:1971 Voting Rights Law)",
      "42:1973" : "42:1973 (42:1973 Voting Rights Act)",
      "42:1973(a)" : "42:1973(a) (42:1973(a) Enforcement of Voting Rights)",
      "42:1973(c)" : "42:1973(c) (42:1973(c ) Voting Rights -Qualifications & Procedures)",
      "42:1973gg" : "42:1973gg (42:1973gg-2 Nat'l. Voter Registration Act of 1993 (NVRA))",
      "42:1981a" : "42:1981a (42:1981a Damages in cases of intentional discrim. in employment)",
      "42:1981cv" : "42:1981cv (42:1981cv Civil Rights)",
      "42:1981hs" : "42:1981hs (42:1981hs Housing Discrimination)",
      "42:1981jb" : "42:1981jb (42:1981jb Job Discrimination (Race))",
      "42:1981ra" : "42:1981ra (42:1981ra Race Discrimination)",
      "42:1981sx" : "42:1981sx (42:1981sx Sex Discrimination)",
      "42:1982hs" : "42:1982hs (42:1982hs Discrimination re property rights (housing))",
      "42:1982ra" : "42:1982ra (42:1982ra Discrimination re property rights (race))",
      "42:1982sx" : "42:1982sx (42:1982sx Discrimination re property rights (sex))",
      "42:1983bv" : "42:1983bv (42:1983bv Bivens Non-Prisoner)",
      "42:1983cv" : "42:1983cv (42:1983cv Civil Rights Act - Civil Action for Deprivation of Rights)",
      "42:1983cvp" : "42:1983cvp (42:1983cvp Civil Rights (Personal Property))",
      "42:1983d" : "42:1983d (42:1983d Civil Rights (Death))",
      "42:1983dp" : "42:1983dp (42:1983dp Civil Right Denial of Due Process)",
      "42:1983ed" : "42:1983ed (42:1983ed Civil Rights (Employment Discrimination) )",
      "42:1983pr" : "42:1983pr (42:1983pr Prisoner Civil Rights)",
      "42:1983vp" : "42:1983vp (42:1983vp Violation of Due Process and Equal Protection)",
      "42:1985" : "42:1985 (42:1985 Consipracy to interfere with civil rights)",
      "42:1986" : "42:1986 (42:1986 Neglect of Duty)",
      "42:1987" : "42:1987 (42:1987 Prosecution of violations of certain laws (sec 1990,5506,5516,5518 to 5532))",
      "42:1988" : "42:1988 (42:1988 Proceedings in Vindication of Civil Rights)",
      "42:1997" : "42:1997 (42:1997 Institutionalized Persons Act of 1980 )",
      "42:2000ad" : "42:2000ad (42:2000ad Job Discrimination (Disability Act))",
      "42:2000apa" : "42:2000apa (42:2000a-3pa Discrimination, segregation; public accommodation - Injunctive Relief)",
      "42:2000bb" : "42:2000bb (42:2000bb Religious Freedom Restoration Act of 1993)",
      "42:2000bea" : "42:2000bea (42:2000bea Equal access to public facilities)",
      "42:2000cc" : "42:2000cc (42:2000cc Religious Land Use & Institutionalized Persons Act of 2000)",
      "42:2000ced" : "42:2000ced (42:2000c-6ed Discrimination in Education)",
      "42:2000d" : "42:2000d (42:2000d Federally Assisted Programs)",
      "42:2000e2e" : "42:2000e2e (42:2000e-2e Job Discrimination (Unlawful Employment Practices))",
      "42:2000eag" : "42:2000eag (42:2000e-2ag Job Discrimination (Age))",
      "42:2000eeo" : "42:2000eeo (42:2000e-5eeo Petition to Enforce EEOC Subpoena)",
      "42:2000eno" : "42:2000eno (42:2000e-2no Job Discrimination (National Origin))",
      "42:2000eot" : "42:2000eot (42:2000e-2ot Job Discrimination (other))",
      "42:2000epb" : "42:2000epb (42:2000e-2pb Job Discrimination (Public Accomodations))",
      "42:2000era" : "42:2000era (42:2000e-2ra Job Discrimination (Race))",
      "42:2000erl" : "42:2000erl (42:2000e-2rl Job Discrimination (religion))",
      "42:2000esh" : "42:2000esh (42:2000e-2sh Job Discrimination (Sexual Harassment))",
      "42:2000esx" : "42:2000esx (42:2000e-2sx Job Discrimination (Sex))",
      "42:2003" : "42:2003 (42:2003 Regulations of Indian Hospitals)",
      "42:2005" : "42:2005 (42:2005 financial assistance to Indian tribes )",
      "42:2210" : "42:2210 (42:2210 Indeminification & Limitation of Liability-Financial)",
      "42:2651" : "42:2651 (42:2651 Medical Care Recovery by US)",
      "42:2996" : "42:2996 (42:2996 Legal Services Corporation Act)",
      "42:3058(g)" : "42:3058(g) (42:3058(g) Older American's Act of 1965, 42 U.S.C. 3058(g) (State Long-term Care Ombudsman Program))",
      "42:3121" : "42:3121 (42:3121 Public Works and Economic Development Act of 1965)",
      "42:3133" : "42:3133 (42:3133 Coordination - Grants for Public Works and Economic Development)",
      "42:3601" : "42:3601 (42:3601 Fair Housing Act)",
      "42:3604f3c" : "42:3604f3c (42:3604(f)(3)(c) Fair Housing Amendments Act)",
      "42:3610" : "42:3610 (42:3610 Fair Housing Act-Administrative Enforcement; Preliminary Matters)",
      "42:3612" : "42:3612 (42:3612 Civil rights in housing - Enforcement by Secretary)",
      "42:3613" : "42:3613 (42:3613 Action for inj relief re deprivation of civil rights)",
      "42:4001" : "42:4001 (42:4001 National Insurance Flood Act)",
      "42:4013" : "42:4013 (42:4013 National Flood Insurance Act - Nature and Limitation of Insurance Coverage)",
      "42:4053" : "42:4053 (42:4053 Breach of Insurance Contract)",
      "42:4072" : "42:4072 (42:4072 Payment of Flood Insurance Claim)",
      "42:4321" : "42:4321 (42:4321 Review of Agency Action-Environment (Declaration of Purpose))",
      "42:4332" : "42:4332 (42:4332 Environmental Policy - Cooperation of Agencies; Reports)",
      "42:4721" : "42:4721 (42:4721 Intergovernmental Personnel Act (findings and purposes))",
      "42:4821" : "42:4821 (42:4821 Lead-Based Paint Poisoning Prevention Act (findings and purposes) )",
      "42:4901" : "42:4901 (42:4901 Noise Control Act of 1972 (findings and purposes))",
      "42:4910(c)" : "42:4910(c) (42:4910(c) Action to restrain violation re noise control)",
      "42:5101" : "42:5101 (42:5101 Child Abuse Prevention and Treatment Act)",
      "42:5303" : "42:5303 (42:5303 Block Grant Act of 1974 (42 USC 5301-5321))",
      "42:5401" : "42:5401 (42:5401 Natl Mnfactrd Housing Cnstr Safety Standard Act 1974 (findings and purposes))",
      "42:5411" : "42:5411 (42:5411 Housing Construction and Safety Standards Act - Injunctive Relief)",
      "42:5851" : "42:5851 (42:5851 Discrimination Whistle blower Employee - ERA (employee protection))",
      "42:6101" : "42:6101 (42:6101 Age Discrimination in Federally Assisted Programs (statement of purpose))",
      "42:6201" : "42:6201 (42:6201 Energy Policy & Conservation Act (statement of purpose))",
      "42:6393" : "42:6393 (42:6393 Controversies under Energy Policy & Conservation Act (Admin Procedure and Judicial Review))",
      "42:6901en" : "42:6901en (42:6901en Environmental Cleanup Expenses (congressional findings))",
      "42:6901rs" : "42:6901rs (42:6901rs Resource & Recovery Act (congressional findings))",
      "42:6928" : "42:6928 (42:6928 Violations of requirements of hazardous Waste Mgmt (federal enforcement))",
      "42:6961" : "42:6961 (42:6961 Federal Facilities Compliance Act)",
      "42:6972" : "42:6972 (42:6972 Resource & Recovery Act - Citizen Suit)",
      "42:6972(a)" : "42:6972(a) (42:6972(a) Solid Waste Disposal Act - Citizen Suit)",
      "42:7192" : "42:7192 (42:7192 Controversies under Dept of Energy Organization Act - Judicial Review)",
      "42:7384" : "42:7384 (42:7384 Energy Employees Occupational Illness Compensation Program Act (EEOICPA))",
      "42:7401" : "42:7401 (42:7401 Clean Air Act (findings & declarations))",
      "42:7412" : "42:7412 (42:7412 Air Pollution Control - emission standards )",
      "42:7413(b)" : "42:7413(b) (42:7413(b) Clean Air Act - Enforcement)",
      "42:7475" : "42:7475 (42:7475 Clean Air Act - Preconstruction Requirements)",
      "42:7545" : "42:7545 (42:7545 Air Pollution Prevention - Regulation of Fuels)",
      "42:7603" : "42:7603 (42:7603 Action for immediate restraint (Emergency Powers))",
      "42:7604" : "42:7604 (42:7604 Clean Air Act - Citizen suit to enforce Clean Air Act)",
      "42:7604fcl" : "42:7604fcl (42:7604(f)cl Clear Air Act - Emission Standards)",
      "42:7671" : "42:7671 (42:7671 Clean Air Act (Stratospheric Ozone Protection) (Definitions))",
      "42:8324" : "42:8324 (42:8324 Powerplant and Industrial Fuel Use - terms and conditions)",
      "42:8351" : "42:8351 (42:8351 Powerplant and Industrial Fuel Use - Temporary Exemptions)",
      "42:9601" : "42:9601 (42:9601 Comprehensive Environmental Compen/Resp/Liab (CERCLA) (Definitions))",
      "42:9604" : "42:9604 (42:9604 Comprehensive Envir., Response, Comp. & Liab. Act (CERCLA) - Removal & Oth. Remedial Action)",
      "42:9607" : "42:9607 (42:9607 Real Property Tort to Land - Liability)",
      "42:9613" : "42:9613 (42:9613 Comp Environ Recovery Comp & Liability Act (CERCLA) - Civil Proceedings)",
      "43:0421" : "43:0421 (43:0421 Complaint in Condemnation - Eminent Domain)",
      "43:0945a" : "43:0945a (43:0945a Compensation for Land Condemnation )",
      "43:0945b" : "43:0945b (43:0945b Complaint in Condemnation - Easements)",
      "43:0946" : "43:0946 (43:0946 Complaint in Condemnation - Right of Way for Irrigation and Drainage Projects)",
      "43:1331" : "43:1331 (43:1331 Outer Continental Shelf Lands Act (Definitions))",
      "43:1333" : "43:1333 (43:1333 Outer Continental Shelf Lands Act - Laws and Regulations Governing Lands)",
      "43:1349" : "43:1349 (43:1349 Outer Continental Land Shelf Act - Citizen Suits)",
      "43:1701" : "43:1701 (43:1701 Violation of Federal Land Policy and Management Act (FLPMA))",
      "43:1737" : "43:1737 (43:1737 FLPMA - Implementation Provisions)",
      "44:2107" : "44:2107 (44:2107 Presidential Recordings and Materials Act (NARA accept of records for hist. preservation))",
      "45:0051" : "45:0051 (45:0051 Railways: Fed. Employer's Liability Act)",
      "45:0056" : "45:0056 (45:0056 Employers Liability Act - Personal Inj re Railroads (bringing an action))",
      "45:0151" : "45:0151 (45:0151 Railway Labor Act (Definitions))",
      "45:0152" : "45:0152 (45:0152 Railway Labor Act - General Duties)",
      "45:0153" : "45:0153 (45:0153 First Railway Labor Act - National Railroad Adjustment Board)",
      "45:0159" : "45:0159 (45:0159 Review of arbitration award (RR Carriers/Mediation Bd))",
      "45:0184" : "45:0184 (45:0184 Action to Set Aside Award of a System Board)",
      "45:0231(f)" : "45:0231(f) (45:0231(f) Compel obedience to order of Railroad Retirement Bd)",
      "45:0351" : "45:0351 (45:0351 Railroad Unemployment Insurance Act)",
      "45:0719" : "45:0719 (45:0719 Regional Rail Reorganization Act of 1973 (judicial review))",
      "45:1105" : "45:1105 (45:1105 Northeast Rail Service Act - Judicial Review)",
      "46:2114" : "46:2114 (46:2114 Wrongful Discharge from Employment - protection from discrimination)",
      "46:30101" : "46:30101 (46:30101 Extension of jurisdiction to cases of damage or injury on land)",
      "46:30104" : "46:30104 (46:30104 Marine Personal Injury - Jones Act)",
      "46:30302" : "46:30302 (46:30302 Shipping: Damages for Death on High Seas )",
      "46:30304" : "46:30304 (46:30304 Breach of Maritime Contract - liability of noncompliance)",
      "46:30503" : "46:30503 (46:30503 Limitation of Liability - declaration of nature and value of goods)",
      "46:30504" : "46:30504 (46:30504 Limitation of Liability - loss by fire)",
      "46:30505" : "46:30505 (46:30505-30510 Exoneration, Limitation of Liability)",
      "46:30511" : "46:30511 (46:30511 Action by owner for limitation)",
      "46:30701" : "46:30701 (46:30701 Marine Cargo Loss or Damage - Liability of Water Carriers)",
      "46:30704" : "46:30704 (46:30704 Liability of Water Carriers - Loading, stowage, custody, care, and delivery)",
      "46:30902" : "46:30902 (46:30902 to 30911 Suits in Admiralty Act )",
      "46:31102" : "46:31102 (46:31102 Public Vessels Act - Waiver of Immunity)",
      "46:31301" : "46:31301 (46:31301 Federal Maritime Lien Act)",
      "46:31301a" : "46:31301a (46:31301 to 31343 Maritime Commercial Instruments and Liens Act)",
      "46:31321" : "46:31321 (46:31321 Foreclosure of Preferred Ship Mortgages)",
      "46:31325" : "46:31325 (46:31325 Suit to enforce lien upon mort. vessel-foreclosure / Foreclosure of Pref Foreign Ship Mort)",
      "46:31341" : "46:31341 (46:31341 Federal Maritime Lien Act)",
      "46:31342" : "46:31342 (46:31342 Breach of Maritime Contract (establishing maritime liens))",
      "46:31343" : "46:31343 (46:31343 Commercial Instruments & Maritime Liens)",
      "46:40101" : "46:40101 (46:40101 Shipping Act of 1998 )",
      "46:41102a" : "46:41102a (46:41102(a) Shipping Act of 1984 - General Prohibitions)",
      "46:41309" : "46:41309 (46:41309 Shipping Act of 1984 - Enforcement of Reparation Orders)",
      "46:50101" : "46:50101 (46:50101 Violation of Maritime Regulations )",
      "46:58109" : "46:58109 (46:58109 Violation of Merchant Marine Act - Penalties)",
      "47:0151" : "47:0151 (47:0151 Federal Communications Act of 1934)",
      "47:0151cs" : "47:0151cs (47:0151cs Federal Communications Act - Collection for Services)",
      "47:0201bt" : "47:0201bt (47:0201bt Breach of Tariff)",
      "47:0203" : "47:0203 (47:0203 Telecommunications Collection of Charges)",
      "47:0205" : "47:0205 (47:0205 Wire and Radio Communication Svc and Charges (Recovery of Damages) )",
      "47:0206" : "47:0206 (47:0206 Carrier's Liability for Damages)",
      "47:0227" : "47:0227 (47:0227 FCC-Unsolicited Telephone Sales)",
      "47:0227b3" : "47:0227b3 (47:0227(b)(3) Telephone Consumer Protection Act of 1991)",
      "47:0251" : "47:0251 (47:0251 Telecommunications Act of 1996 - Interconnection)",
      "47:0252" : "47:0252 (47:0252 Telecommunications Act)",
      "47:0254(h)" : "47:0254(h) (47:0254(h) Children's Internet Protection Act)",
      "47:0332" : "47:0332 (47:0332 FCA-Wire or Radio Communications (Mobile Services))",
      "47:0332(c)" : "47:0332(c) (47:0332(c ) Federal Telecommunications Act of 1996)",
      "47:0338" : "47:0338 (47:0338 Satellite Home Viewer Improvement Act)",
      "47:0401" : "47:0401 (47:0401 Application of Federal Communication Comm for Inj. (Enforcement Provisions))",
      "47:0407" : "47:0407 (47:0407 Order for payment of money; petition for enforcement;)",
      "47:0510" : "47:0510 (47:0510 Forfeiture of Communications Devices)",
      "47:0521" : "47:0521 (47:0521 Cable Televsn. Consumer Protection & Competition Act of 1992)",
      "47:0532" : "47:0532 (47:0532 Cable Communication Policy Act of 1984)",
      "47:0551" : "47:0551 (47:0551 Cable Communications Act)",
      "47:0553" : "47:0553 (47:0553 U.S.C.A. Cable Communications Policy Act)",
      "47:0605" : "47:0605 (47:0605 Unlawful Reception Broadcast Signal i.e., Satellite - Theft of Satellite Communications)",
      "49:0101" : "49:0101 (49:0101 ICC Termination Act of 1996)",
      "49:0502" : "49:0502 (49:0502 Transportation Administrative Subpoena)",
      "49:10101" : "49:10101 (49:10101 Interstate Commerce Act-Interstate Transportation Rail)",
      "49:10743" : "49:10743 (49:10743 Revised Interstate Commerce Act)",
      "49:11101" : "49:11101 (49:11101 Interstate Commerce Act)",
      "49:1113" : "49:1113 (49:1113 Petition to enforce administrative summon)",
      "49:1136" : "49:1136 (49:1136 Aviation Disaster Family Assistance Act of 1996)",
      "49:11501" : "49:11501 (49:11501 Railroad Revitalization & Regulatory Reform Act (General jurisdiction))",
      "49:11502" : "49:11502 (49:11502 Railroad Revitalization Regulatory Reform (authority to exempt rail carrier transportation))",
      "49:11701" : "49:11701 (49:11701 General authority of enforcement of regulations in rail)",
      "49:11702" : "49:11702 (49:11702 Enforcement by the Board)",
      "49:11705" : "49:11705 (49:11705 Limitation on actions by and against rail carriers)",
      "49:11706" : "49:11706 (49:11706 Carmack Amendent (Liability of carriers under receipts and bills of lading))",
      "49:11707" : "49:11707 (49:11707 Carmack Amendment (Liability when property delivered in violation of routing instruct))",
      "49:13101" : "49:13101 (49:13101 Transportation Policy)",
      "49:13702" : "49:13702 (49:13702 Tariff requirement for certain transportation)",
      "49:13706" : "49:13706 (49:13706 Motor Carriers, etc-Liability for Payment of Rates)",
      "49:14501" : "49:14501 (49:14501 Preemption (federal authority of intrastate transportation))",
      "49:14705" : "49:14705 (49:14705 Interstate Commerce Act/Carmack Amendment (Limitations on actions by and against carriers))",
      "49:14706" : "49:14706 (49:14706 Carmack Amendment Interstate Commerce Act / Liab. of Carriers - Receipts & Bills of Landing)",
      "49:20301" : "49:20301 (49:20301-20306 Federal Safety Appliance Act)",
      "49:21302" : "49:21302 (49:21302 Carriers violate of Interstate Comm Act (Chap 201,203 & 209 accident & incident violations))",
      "49:30101" : "49:30101 (49:30101 National Traffic & Motor Vehicle Safety Act )",
      "49:30112" : "49:30112 (49:30112 Motor Vehicle Safety (prohibition on non-complying motor vehicles and equipment))",
      "49:30502" : "49:30502 (49:30502 Natl Motor Vehicle Title Information Syst)",
      "49:31114" : "49:31114 (49:31114 Access to Interstate System/Commercial Motor Vehicle )",
      "49:31502" : "49:31502 (49:31502 Motor Carrier Safety: Requirements for Qualifications)",
      "49:32101" : "49:32101 (49:32101 Motor Vehicle Information and Costs Savings Act)",
      "49:32701" : "49:32701 (49:32701 Odometer Requirements Act)",
      "49:40101" : "49:40101 (49:40101 Federal Aviation Act)",
      "49:40102" : "49:40102 (49:40102 Airline Deregulation Actv(definitions of air and commerce safety) )",
      "49:40105" : "49:40105 (49:40105 Warsaw Convention )",
      "49:41705" : "49:41705 (49:41705 Air Carrier Access Act (discrimination against handicapped individuals))",
      "49:41713" : "49:41713 (49:41713 Airline Deregulation Actv (premp of authority over prices, routes, and service))",
      "49:44709" : "49:44709 (49:44709 Noise Control Act of 1972 )",
      "49:44715" : "49:44715 (49:44715 Noise Control Act of 1972 )",
      "49:46507" : "49:46507 (49:46507 False information and threats)",
      "49:47101" : "49:47101 (49:47101 Airport and Airway Improvement Act of 1982)",
      "49:47501" : "49:47501 (49:47501 Aviation Safety & Noise Abatement Act of 1979 )",
      "49:49101" : "49:49101 (49:49101 Wrongful Termination in Contravention of Published Regulations)",
      "49:49104" : "49:49104 (49:49104 Breach of Lease by Metro. Wash. Airport Auth.)",
      "49:60101" : "49:60101 (49:60101 Pipeline Safety Act of 1994)",
      "49:60102" : "49:60102 (49:60102 Hazardous Liquid Pipeline Safety Act of 1979 (HLPSA))",
      "49:80102" : "49:80102 (49:80102 Bills of Lading - Application)",
      "49:80302" : "49:80302 (49:80302 Contraband - Prohibitions)",
      "49:80303" : "49:80303 (49:80303 Seizure and forfeiture of vessel or aircraft conveying contraband )",
      "50:1701" : "50:1701 (50:1701-1706 International Emergency Economic Powers Act)",
      "50a:0001" : "50a:0001 (50a:0001 Trading With the Enemy Act (act located in Title 50, Appendix.))",
      "50a:0501" : "50a:0501 (50a:0501 Sailors and Soldiers Civil Relief Act (act located in Title 50, Appendix.))",
      "50a:0533" : "50a:0533 (50a:0533 Servicemembers Civil Relief Act-mortgages (act located in Title 50, Appendix.))",
      "50a:0540" : "50a:0540 (50a:0540 Sailors and Soldiers Civil Relief Act (act located in Title 50, Appendix.))",
      "50a:2412" : "50a:2412 (50a:2412 Export Administration Act--1979 (act located in Title 50, Appendix.))",
      "51:20137a" : "51:20137a (51:20137(a) Malpractice & Negligence Against U.S. Space program )",
      "ins" : "ins (Immigration Petition)",
      "misc" : "misc (Civil Miscellaneous Case)"
   },
   "codce" : {
      "0" : "0 (No cause code entered)",
      "00:0000" : "00:0000 (00:0000 Cause Code Unknown)",
      "02:0138" : "02:0138 (02:0138 Library of Congress Access)",
      "02:0358" : "02:0358 (02:0358 President's Recommendations on Exec., Jud. & Leg. Salary)",
      "02:0431" : "02:0431 (02:431 Fed. Election Commission: Failure Enforce Compliance)",
      "02:0437" : "02:0437 (02:437 Federal Election Commission)",
      "02:0681" : "02:0681 (02:0681 Deferral of Budget Authority)",
      "02:1202" : "02:1202 (02:1202 Discriminatory practices affecting US Senate employees)",
      "02:1301" : "02:1301 (02:1301 Congressional Accountability Act)",
      "02:1317a" : "02:1317a (02:1317a Violation of Congressional Accountability Act)",
      "03:4301" : "03:4301 (03:4301 Uniformed Services Employment and Reemployment Fights Act)",
      "05:0101" : "05:0101 (05:0101 - Ethics in Government Act)",
      "05:0304" : "05:0304 (05:304 Subpoenas)",
      "05:0504(c)" : "05:0504(c) (05:0504(c)(2) - Equal Access to Justice (Govt. Employees))",
      "05:0551" : "05:0551 (05:551 Administrative Procedure Act)",
      "05:0552fi" : "05:0552fi (05:552 Freedom of Information Act)",
      "05:0552pa" : "05:0552pa (05:552 Right to Privacy Act)",
      "05:0552sa" : "05:0552sa (05:0552b(g) - Implement Requirements of Govt. in Sunshine Act)",
      "05:0554" : "05:0554 (05:0554 Constitutionality of Maritime Statutes)",
      "05:0555(b)" : "05:0555(b) (05:0555(b) - Agency Decision - Right to Counsel)",
      "05:0701" : "05:0701 (05:0701 Administrative Procedure Act)",
      "05:0702" : "05:0702 (05:702 Administrative Procedure Act)",
      "05:0704" : "05:0704 (05:704 Labor Litigation)",
      "05:0706" : "05:0706 (05:0706 - Judicial Review of Agency Action)",
      "05:1508" : "05:1508 (05:1508 - Judicial Review of Order Issued by MSPB)",
      "05:2302" : "05:2302 (05:2302 Civil Service Reform Act (CSRA))",
      "05:3318" : "05:3318 (05:3318 - Veterans Preference Act)",
      "05:5514" : "05:5514 (05:5514 (05:5514 Debt Collection Act of 1982))",
      "05:5542" : "05:5542 (05:5542 - Federal Employees Pay Act - overtime rates)",
      "05:7101" : "05:7101 (05:7101 - Labor-Management Relations(Findings and Purpose))",
      "05:7123" : "05:7123 (05:7123 - Petition by FLRA against unfair labor practices)",
      "05:7501" : "05:7501 (05:7501 - Government Employees Adverse Action - 14 days or less)",
      "05:7511" : "05:7511 (05:7511 - Government Employees Adverse Action - Over 14 days)",
      "05:7703" : "05:7703 (05:7703 Discrimination - Review of Agency Act)",
      "05:8101" : "05:8101 (05:8101 - Workmen's Compensation Benefits)",
      "05:8110" : "05:8110 (05:8110 - Augmented Compensation for Dependents of Govt. Employees)",
      "05:8316" : "05:8316 (05:8316 - Claims Against US re: Retirement for Federal Emp.)",
      "05:8470" : "05:8470 (05:8470 - Enforcement of Judgment Against Retirement Benefits)",
      "05:8701" : "05:8701 (05:8701 Federal Employees Group Life Insurance Act (FEGLI))",
      "05:8705" : "05:8705 (05:8705 - Declaratory Judgment - Insurance)",
      "05:8715" : "05:8715 (05:8715 - Claims against the US - Jurisdiction of Courts)",
      "05:8901" : "05:8901 (05:8901 Federal Employees Health Benefit Act)",
      "05:8902" : "05:8902 (05:8902 - Contracting authority of OPM - Group Health Insurance)",
      "05:8903" : "05:8903 (05:8903 - Federal Employees Health Benefit Act)",
      "05:8912" : "05:8912 (05:8912 Jurisdiction of courts)",
      "05:AppII" : "05:AppII (05:AppII Federal Advisory Committee Act (FACA))",
      "07:0001" : "07:0001 (07:0001 Commodity Exchange Act)",
      "07:0006(b)" : "07:0006(b) (07:0006(b) - Federal Commodity Exchange Regulation)",
      "07:0009a" : "07:0009a (07:009a - Recovery of Penalties by Commodity Futures Trading Com)",
      "07:0013a" : "07:0013a (07:0013a - Contract Market Rules Violations; Recovery of Penalty)",
      "07:0013a-1" : "07:0013a-1 (07:0013a-1 -- Enjoin or Restrain Violations Contract Market Rules)",
      "07:0025" : "07:0025 (7:25 Fraud - Commodities Leverage Contracts)",
      "07:0087" : "07:0087 (07:0087 - Enforcement of US Grain Standards Act)",
      "07:0136" : "07:0136 (07:0136 - Violations of EPA re: Environmental Pesticide Control)",
      "07:0181" : "07:0181 (07:181 Packers & Stockyard Act)",
      "07:0193(b)" : "07:0193(b) (07:0193(b) - Recovery of Penalties re: violations by packers)",
      "07:0203" : "07:0203 (07:0203 - Recovery of Penalties for Violations by Stockyards)",
      "07:0209(b)" : "07:0209(b) (07:0209(b) - Violations re: Purchase, Sale, Handling of Livestock)",
      "07:0210(f)" : "07:0210(f) (07:0210(f) - Suit to enforce Award of Damages (Packers/Stockyards))",
      "07:0213(b)" : "07:0213(b) (07:0213(b) - Unfair, Discriminatory, Deceptive Practice/Marketing)",
      "07:0216" : "07:0216 (07:0216 - Injunctions to Restrain & Enforce Orders of Secretary)",
      "07:0222" : "07:0222 (07:0222 - Adoption of FTC Powers for Enforcement)",
      "07:0228a" : "07:0228a (07:0228a - Request by Secretary for TRO or Inj. re: Poultry)",
      "07:0245" : "07:0245 (07:0245 - Action on Bond by Person Injured in Warehouse)",
      "07:0292" : "07:0292 (07:0292 - Monopolizing or Restraining Trade & Enhancing Prices)",
      "07:0499" : "07:0499 (07:499 Agricultural Commodities Act)",
      "07:0499E" : "07:0499E (07:0499E(c)(4) - Perishable Agricultural Commodities Act (PACA))",
      "07:0601" : "07:0601 (07:601 USDA Condemnation)",
      "07:0608" : "07:0608 (07:0608 - Agriculture Adjustment Act)",
      "07:0901" : "07:0901 (07:0901 - Rural Electrification Act)",
      "07:1291(b)" : "07:1291(b) (07:1291(b) - Agricultural Adjustment Act; Freight Rates)",
      "07:1376" : "07:1376 (07:1376 - Adjustment of Quotas and Enforcement Penalties)",
      "07:1501" : "07:1501 (07:1501 Federal Crop Protection)",
      "07:1508" : "07:1508 (07:1508 - Crop Insurance)",
      "07:1631" : "07:1631 (07:1631 Food Security Act)",
      "07:1721" : "07:1721 (07:1721 - Agricultural Trade Development Asst. Act)",
      "07:1901" : "07:1901 (07:1901 Commercial Transportation of Equine for Slaughter Act)",
      "07:1922" : "07:1922 (07:1922 - Persons Eligible for Loans - Foreclosure)",
      "07:1926" : "07:1926 (07:1926 - Water and Waste Facility Loans and Grants)",
      "07:1930" : "07:1930 (07:1930 - Perishable Agric. Comm. Act of 1930)",
      "07:2011" : "07:2011 (07:2011 - Supplemental Nutrition Assistance Program)",
      "07:2022" : "07:2022 (07:2022 - Disposition of Claims: Denial Application to Participate; Food Stamp Prog.)",
      "07:2023" : "07:2023 (07:2023 (a)(07:2023(a) Jud Rvw Admin Agency Determin))",
      "07:2024" : "07:2024 (07:2024 - Flase Claims Act, Food Stamp Fraud)",
      "07:2131" : "07:2131 (07:2131 - Violation of the Animal Welfare Act)",
      "07:2146" : "07:2146 (07:2146 - Transportation, Sale, and Handling of Animals)",
      "07:2301" : "07:2301 (07:2301 Agricultural Fair Practices Act)",
      "07:2305" : "07:2305 (07:2305 - Unfair Trade Practices Affecting Producers Agri. Prod.)",
      "07:2321" : "07:2321 (07:2321 Plant Variety Protection Act)",
      "07:2563" : "07:2563 (07:2563 - Plant Variety Protection and Rights - Injunction)",
      "07:6999" : "07:6999 (07:6999 - Judicial Review of Adverse Farm Agency Decision)",
      "08:0336" : "08:0336 (08:0336 (08:0336 Judicial Review of Naturalization Denials))",
      "08:1101" : "08:1101 (08:1101 (08:1101 Illegal Immigration Reform and Immigrant Responsibility Act))",
      "08:1151" : "08:1151 (08:1151 Immigration and Nationality Act of 1952)",
      "08:1152" : "08:1152 (08:1152 Numerical limitations on individual foreign states)",
      "08:1153" : "08:1153 (08:1153 Allocation of Immigrant Visas)",
      "08:1154" : "08:1154 (08:1154 - Immigration: Procedure for Granting Immigration Status)",
      "08:1158" : "08:1158 (08:1158 - Immigration & Nationality Act, Section 208 (Asylum))",
      "08:1182" : "08:1182 (08:1182 - Inadmissible Aliens: Defend. Denial of Pla. Appl. for Alien Employment Cert.)",
      "08:1183" : "08:1183 (08:1183 - Admission of Aliens on Giving Bond or Undertaking; Return on Departure)",
      "08:1188" : "08:1188 (08:1188: Admission of Temporary H-2A Workers)",
      "08:1225" : "08:1225 (08:1225 - Immigration: Enforcement of Administrative Subpoena)",
      "08:1231a6" : "08:1231a6 (08:1231(a)(6) - Immigration: Due Process Clause)",
      "08:1251a4" : "08:1251a4 (08:1251(a)(4) - Immigration: Application for a Stay of Deportation)",
      "08:1252" : "08:1252 (08:1252(a)(2) Injunction for Deportation)",
      "08:1255" : "08:1255 (08:1255 Immigration and Nationality Act)",
      "08:1260" : "08:1260 (08:1260 Aliens: Access to Records)",
      "08:1324" : "08:1324 (08:1324 Aliens: Complaint for Forfeiture)",
      "08:1329" : "08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petiti)",
      "08:1357" : "08:1357 (08:1357 Immigration and Nationality Act - Administrative Search Warrant)",
      "08:1421" : "08:1421 (08:1421 Aliens and Nationality)",
      "08:1445" : "08:1445 (08:1445 (08:1445 Immigration and Nationality Act))",
      "08:1446" : "08:1446 (8:1446 Petition for Naturalization Hearing)",
      "08:1447" : "08:1447 (08:1447 (08:1447 Petition for Naturalization Hearing Before District Court))",
      "08:1451" : "08:1451 (08:1451 Revocation of Naturalization )",
      "08:1451(a)" : "08:1451(a) (08:1451(a) - Action to Revoke Citizenship)",
      "08:1451(j)" : "08:1451(j) (08:1451(j) - Immigration: Motion to Correct Order & Judg. of Naturalization)",
      "09:0001" : "09:0001 (09:1 U.S. Arbitration Act)",
      "09:0003" : "09:0003 (09:0003 - Application to Stay Proceedings Pending Arbitration)",
      "09:0004" : "09:0004 (09:4 Federal Arbitration Act)",
      "09:0007" : "09:0007 (09:0007 - Petition to Compel Attendance Before Arbitrator)",
      "09:0008" : "09:0008 (09:0008 - Declaratory Judgment/Admiralty)",
      "09:0009" : "09:0009 (9:9 Motion to Confirm Arbitration)",
      "09:0010" : "09:0010 (09:0010 Petition to Vacate Arbitration Award)",
      "09:0011" : "09:0011 (09:0011 - Motion to Modify or Correct Arbitration Award)",
      "09:0202" : "09:0202 (09:0202 - Award Under Convention on Foreign Arbitral Awards)",
      "09:0205" : "09:0205 (09:0205 - Removal From State Court: Enforcement of Foreign Arbital Awards)",
      "09:0207" : "09:0207 (09:0207 - Application for Order Confirming Award of Arbitrators)",
      "09:201" : "09:201 (09:201 Conv. on the Recog. & Enf. of Foreign Arbitral Awards)",
      "10:0672" : "10:0672 (10:0672 - Armed Forces: Active Guard/Reserve (AGR) Program)",
      "10:1006" : "10:1006 (10:1006 - Armed Forces: Review of Agency Decision)",
      "10:1072tc" : "10:1072tc (10:1072tc - Armed Forces: Tricare Program)",
      "10:1089(c)" : "10:1089(c) (10:1089(c) - Armed Forces: Removal, Dft. Acting in Scope of Duties)",
      "10:1091" : "10:1091 (10:1091 Personal Service Contract)",
      "10:1107" : "10:1107 (10:1107 Armed Forces: Use Of Investigational New Drug)",
      "10:1408" : "10:1408 (10:1408 - Armed Forces: Claim for Military Retirement)",
      "10:1552" : "10:1552 (10:1552 Armed Forces: Action to Correct Records)",
      "10:1553" : "10:1553 (10:1553 Armed Forces: FOIA General)",
      "10:2005" : "10:2005 (10:2005 - Armed Forces: Advanced Education Assistance)",
      "10:2121" : "10:2121 (10:2121 - Armed Forces: Helath Professions Scholarship Financial Asst. Prog.)",
      "10:2302" : "10:2302 (10:2302 - Armed Forces: Arms Services Procurement Act)",
      "10:2305" : "10:2305 (10:2305 Review of Federal Contract)",
      "10:2323fa" : "10:2323fa (10:2323fa - Armed Forces: Fifth Amendment Equal Protection: Contract Goal for Small Disadvant. Bus.)",
      "10:2733" : "10:2733 (10:2733 - Armed Forces: Military Claims Act)",
      "10:2734" : "10:2734 (10:2734 - Armed Forces: Foreign Military Claims Act)",
      "10:2771" : "10:2771 (10:2771 Armed Forces: Final Settlement - Deceased Members)",
      "10:3258" : "10:3258 (10:3258 - Armed Forces: Reg. Army: Re-Enlistment After Service as Ofcr.)",
      "11:0101" : "11:0101 (11:101 Bankruptcy)",
      "11:0110" : "11:0110 (11:0110 Bankruptcy)",
      "11:0362h" : "11:0362h (11:362h Bankruptcy - Violation of Automatic Stay)",
      "11:0523" : "11:0523 (11:0523 - Bankruptcy: Exceptions to Discharge)",
      "11:0524" : "11:0524 (11:0524 - Bankruptcy: Effect of Discharge)",
      "11:0525" : "11:0525 (11:0525 - Bankruptcy: Protections Against Discriminatory Treatment)",
      "11:0548" : "11:0548 (11:0548 - Bankruptcy: Fraudulent Transfers and Obligations)",
      "11:0704" : "11:0704 (11:0704 | 11:0704 Bankruptcy - Duties of Trustee)",
      "11:Append" : "11:Append (11:Appendix - Bankruptcy Appeal: This Refers to Rule 8001, not Section 8001)",
      "12:0085" : "12:0085 (12:0085 National Bank Act)",
      "12:0093" : "12:0093 (12:0093(a) National Bank Act)",
      "12:0191" : "12:0191 (12:0191 - National Banks: Appointment of Receiver)",
      "12:0192" : "12:0192 (12:0192 - National Banks: Liquidation of National Bank)",
      "12:0215" : "12:0215 (12:0215 Banks and Banking - Consolidation and Merger)",
      "12:0622" : "12:0622 (12:0622 - Foreign Banking: Forfeiture, Dissolution, and Liability of Directors & Officers for Noncmp)",
      "12:0632" : "12:0632 (12:0632 - Foreign Banking: Voluntary Liquidation)",
      "12:0635" : "12:0635 (12:635(i)(3) Breach of Insurance Contract)",
      "12:1421" : "12:1421 (12:1421 - Federal Home Loan Bank Act (Short Title))",
      "12:1441" : "12:1441 (12:1441 Financial Inst Reform Receiving Enforcement Act 1989)",
      "12:1451" : "12:1451 (12:1451 Federal Home Loan Mortgage Corporation Act)",
      "12:1452" : "12:1452 (12:1452 - Federal Home Loan Mortgage Corporation Act)",
      "12:1452(f)" : "12:1452(f) (12:1452(f) - Fed. Home Loan Mortgage Corp: Actions By and Against Corporation)",
      "12:1455(b)" : "12:1455(b) (12:1455(b) - Fed Home Loan Mortgage Corp: Enforcement of Regulations)",
      "12:1461" : "12:1461 (12:1461 Homeowners Loan Act)",
      "12:1464" : "12:1464 (12:1464 - Savings Associations - Federal Savings and Loan)",
      "12:1703" : "12:1703 (12:1703 Default of HUD Loan)",
      "12:1715(b)" : "12:1715(b) (12:1715(b) - National Housing: Rules and Regulations)",
      "12:1749aaa" : "12:1749aaa (12:1749aaa - National Housing: National Insurance Development Program)",
      "12:1751" : "12:1751 (12:1751 - Fed. Credit Unions: Short Title)",
      "12:1782" : "12:1782 (12:1782 - Fed. Credit Unions: Administration of Insurance Fund)",
      "12:1786" : "12:1786 (12:1786 - Fed. Credit Unions: Actions re: Violations by Credit Unions)",
      "12:1787" : "12:1787 (12:1787(a)(B) Federal Credit Union Act)",
      "12:1789a2" : "12:1789a2 (12:1789(a)(2) - Fed. Credit Unions: Admin. Provision to Sue and be Sued)",
      "12:1811" : "12:1811 (12:1811 - FDIC: Financial Inst. Reform Recovery Act of 1989(FIRREA) (Org. of FDIC))",
      "12:1818" : "12:1818 (12:1818 FDIC - Subpoena Power)",
      "12:1818(e)" : "12:1818(e) (12:1818(e) - FDIC: Suspension or Removal of Bank Officer)",
      "12:1819" : "12:1819 (12:1819 Default of Promissory Note)",
      "12:1821" : "12:1821 (12:1821 Default of Loan by Promissary Note)",
      "12:1831" : "12:1831 (12:1831 Depository Institution Dereg Monetary Act 1980(DIDA))",
      "12:1831(d)" : "12:1831(d) (12:1831(d) - FDIC: Deposit Inst. Dereg & Monetary Ctrl. Act of 1980)",
      "12:1831r-1" : "12:1831r-1 (12:1831r-1 - FDIC: Notice of Branch Closure)",
      "12:1833a" : "12:1833a (12:1833a Financial Institutions Reform, Recovery and Enforcement Act)",
      "12:1904" : "12:1904 (12:1904 Economic Stablization Act of 1970)",
      "12:1954" : "12:1954 (12:1954 - Injunctions (Action by Sec. of Treasury re: Financial Recordkeeping))",
      "12:1971" : "12:1971 (12:1971 Relief under Bank Holding Act)",
      "12:1972" : "12:1972 (12:1972 - Tying Arrangement Act)",
      "12:2001" : "12:2001 (12:2001 Farm Credit Act of 1971)",
      "12:2601" : "12:2601 (12:2601 Real Estate Settlement Procedure Act of 1974 (RESPA))",
      "12:2604(c)" : "12:2604(c) (12:2604(c) - Real Estate Settlement Procedures Act (RESPA))",
      "12:2605" : "12:2605 (12:2605 - RESPA: Servicing of Mortgage Loans)",
      "12:2607" : "12:2607 (12:2607 - RESPA: Violation re: Kickbacks/Unearned Fees; Real Estate)",
      "12:2609" : "12:2609 (12:2609 - RESPA: Escrow)",
      "12:3012" : "12:3012 (12:3012 - National Consumer Cooperative Bank: Suits By or Against Bank)",
      "12:3410" : "12:3410 (12:3410 Right to Financial Privacy Act)",
      "12:3416" : "12:3416 (12:3416 Right to Financial Privacy Act)",
      "12:3751" : "12:3751 (12:3751 - Single Family Mortgage Forclosure Act: Findings & Purpose)",
      "12:3801" : "12:3801 (12:3801 - Alternative Mortgage Transaction Parity Act)",
      "12:3907" : "12:3907 (12:3907 - International Lending Supervision: Capital Adequacy)",
      "12:4010" : "12:4010 (Expedited Funds Availability: Violation of Act (Civil Liability))",
      "12:5101" : "12:5101 (12:5101 - Fraudulent Transfer Act (Enforcement for Mortgage Licensing))",
      "15:0001" : "15:0001 (15:1 Antitrust Litigation)",
      "15:0002at" : "15:0002at (15:2 Antitrust Litigation)",
      "15:0002fl" : "15:0002fl (15:2(a) Fair Labor Standards Act)",
      "15:0004" : "15:0004 (15:0004 - USDC Jurisdiction re: Violations of Sec. 1-7 of Title 15)",
      "15:0005" : "15:0005 (15:5(a) Fair Labor Standards Act)",
      "15:0009" : "15:0009 (15:0009 - USDC Jurisdiction re: Violations of Sec. 8 of Title 15)",
      "15:0010" : "15:0010 (15:10 Securities Exchange Act)",
      "15:0013" : "15:0013 (15:0013 Robinson-Patman Act)",
      "15:0014" : "15:0014 (15:0014 Clayton Act)",
      "15:0015" : "15:0015 (15:15 Antitrust Litigation)",
      "15:0025" : "15:0025 (15:25 Clayton Act)",
      "15:0026" : "15:0026 (15:0026 - Suit for Injunctive Relief re: Violation Antitrust Laws)",
      "15:0041" : "15:0041 (15:0041 - Federal Trade Commission Act)",
      "15:0044" : "15:0044 (15:44 Trademark Infringement)",
      "15:0045cp" : "15:0045cp (15:0045cp - Violation of Children Online Privacy Protection Act)",
      "15:0052" : "15:0052 (15:0052 Federal Trade Commission Act)",
      "15:0053" : "15:0053 (15:0053 Federal Trade Commission Act)",
      "15:0068" : "15:0068 (15:0068 - Proceedings re: FTC Violations re: Wool Products)",
      "15:0069" : "15:0069 (15:0069 - Proceedings re: FTC Violations re: Fur Products)",
      "15:0070" : "15:0070 (15:0070 - Proceedings re: FTC Violations re: Textile Fiber Product)",
      "15:0077" : "15:0077 (15:77 Securities Fraud)",
      "15:0078" : "15:0078 (15:78 Securities Exchange Act)",
      "15:0078jb" : "15:0078jb (15:0078j(b)ss - Stockholder Suit)",
      "15:0078ma" : "15:0078ma (15:0078m(a) - Securities Exchange Act)",
      "15:0079" : "15:0079 (15:0079 - Public Utility Holding Companies)",
      "15:0080" : "15:0080 (15:0080 Investment Company Act of 1940)",
      "15:0080a-3" : "15:0080a-3 (15:0080a-3 - Investment Company Act of 1940)",
      "15:0260" : "15:0260 (15:0260 - Proceedings re: Weights and Measures and Standard Time)",
      "15:0298" : "15:0298 (15:0298 - Violation of Law Proceedings re: Gold or Silver)",
      "15:0433" : "15:0433 (15:0433 - Discrimination against Farmers)",
      "15:0631" : "15:0631 (15:631 Small Business Act)",
      "15:0636" : "15:0636 (15:0636 - Small Business Act - Aid to Small Business)",
      "15:0661" : "15:0661 (15:0661 - Small Business Investment Act of 1958)",
      "15:0687" : "15:0687 (15:0687 - Small Business Investment Program)",
      "15:0714(b)" : "15:0714(b) (15:0714(b) - Commodity Credit Corporation)",
      "15:0715(f)" : "15:0715(f) (15:0715(f) - Proceedings re: Petroleum and Petroleum Products)",
      "15:0717" : "15:0717 (15:717 Natural Gas Act)",
      "15:0719ic" : "15:0719ic (15:0719i(c) - Civil Actions re: Violations for Inj. Involving Gas)",
      "15:0751" : "15:0751 (15:0751 - Energy Allocation Act; Emergency Petroleum Allocation)",
      "15:0754" : "15:0754 (15\"0754 - Emergency Petroleum Allocation-Admin. & Enforcement)",
      "15:0766" : "15:0766 (15:0766 - Controversies Arising re: Federal Energy Admin. Rules)",
      "15:1051" : "15:1051 (15:1051 Trademark Infringement)",
      "15:1071" : "15:1071 (15:1071 - Appeal of Decision of US Patent & Trademark Office (Comm/Trademark Trial Bd))",
      "15:1114" : "15:1114 (15:1114 Trademark Infringement)",
      "15:1116" : "15:1116 (15:1116 - Inj. to Prevent Violation Rights of Trademark Owner)",
      "15:1120" : "15:1120 (15:1120 - Trademark - False or Fraudulent Registration)",
      "15:1121" : "15:1121 (15:1121 Trademark Infringement)",
      "15:1125" : "15:1125 (15:1125 Unfair Competition (Lanham Act))",
      "15:1125(a)" : "15:1125(a) (15:1125(a) - False Representation of Goods Sold in Interstate Commerce)",
      "15:1125d" : "15:1125d (15:1125d Anti Cybersquatting Consumer Protection Act)",
      "15:1126" : "15:1126 (15:1126 Patent Infringement)",
      "15:1127" : "15:1127 (15:1127 Trademark Infringement)",
      "15:1191" : "15:1191 (15:1191 - Flamable Fabrics Act)",
      "15:1221" : "15:1221 (15:1221 Automobile Dealer's Day in Court Act (DDCA))",
      "15:1261" : "15:1261 (15:1261 - Hazardous Substances (Definitions))",
      "15:1263" : "15:1263 (15:1263 - Prohibited Hazardous Substance - Interstate Commerce)",
      "15:1267(a)" : "15:1267(a) (15:1267(a) - Federal Hazardous Substances Act)",
      "15:1314" : "15:1314 (15:1314 - Antitrust - Petition for Enforcement)",
      "15:1501" : "15:1501 (15:1501 - Estab. of Dept. of Commerce)",
      "15:1601" : "15:1601 (15:1601 Truth in Lending)",
      "15:1605" : "15:1605 (15:1605 - Determination of Finance Charge)",
      "15:1638" : "15:1638 (15:1638 Truth in Lending)",
      "15:1639" : "15:1639 (15:1639 Home Owners Equity Protection Act (HOEPA))",
      "15:1640" : "15:1640 (15:1640 Truth in Lending)",
      "15:1666" : "15:1666 (15:1666 - Fair Credit Billing Act Dispute)",
      "15:1667" : "15:1667 (15:1667 Federal Consumer Leasing Act)",
      "15:1679" : "15:1679 (15:1679 Credit Repair Organizations Act)",
      "15:1681" : "15:1681 (15:1681 Fair Credit Reporting Act)",
      "15:1691" : "15:1691 (15:1691 Equal Credit Opportunity Act)",
      "15:1692" : "15:1692 (15:1692 Fair Debt Collection Act)",
      "15:1693" : "15:1693 (15:1693 Electronic Fund Transfer Act)",
      "15:1693m" : "15:1693m (15:1693m - Violation of Prov. of Subchpt. VI (Electronic Fund Transfer))",
      "15:1701" : "15:1701 (15:1701 Interstate Land Sales Disclosure Act-15 USC:1701)",
      "15:1709" : "15:1709 (15:1709 - Interstate Land Sales)",
      "15:1714" : "15:1714 (15:1714 - Actions to Enjoin Violations re: Interstate Land Sale)",
      "15:1938" : "15:1938 (15:1938 Fair Labor Standards Act)",
      "15:2071" : "15:2071 (15:2071 - Consumer Product Safety; Condemnation Hazardous Prod.)",
      "15:2073" : "15:2073 (15:2073 - Private Action to Enforce Consumer Product Safety)",
      "15:2301" : "15:2301 (15:2301 Magnuson-Moss Warranty Act)",
      "15:2310(c)" : "15:2310(c) (15:2310(c) - Consumer Product Warranties)",
      "15:2601" : "15:2601 (15:2601 Toxic Substances Control Act (TCSA))",
      "15:2604" : "15:2604 (15:2604 - Application for Inj. re: Distribution Toxic Substance)",
      "15:2616" : "15:2616 (15:2616 - Toxic Substnace Control; Seizure of Chemical)",
      "15:2620" : "15:2620 (15:2620 - Toxic Substances Control Act - Citizen's Petition)",
      "15:2651" : "15:2651 (15:2651 Asbestos Hazard Emergency Response Act)",
      "15:2801" : "15:2801 (15:2801 Petroleum Marketing Practices Act)",
      "15:2805" : "15:2805 (15:2805 - Petroleum Marketing Practices-Franchise Protection)",
      "15:34-35" : "15:34-35 (15:34-35 - Investment Company Act of 1940)",
      "15:3414" : "15:3414 (15:3414 - National Gas Policy Act)",
      "15:3710a" : "15:3710a (15:3710a - Federal Technology Transfer Act of 1986)",
      "15:3901" : "15:3901 (15:3901 Federal Risk Retention Act)",
      "15:53(b)" : "15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equita)",
      "15:6801" : "15:6801 (15:6801 - Gram-Leach-Bliley Act)",
      "15:7701" : "15:7701 (15:7701 - Federal CAN-Spam Act)",
      "16:0019" : "16:0019 (16:0019(j)(j) (16:0019 Park System Resource Protection Act))",
      "16:0470" : "16:0470 (16:0470 - Archaeological Resources Protection Act)",
      "16:0470(f)" : "16:0470(f) (16:0470(f) - National Historic Preservation Act)",
      "16:0668" : "16:0668 (16:668 Bald Eagle Protection Act)",
      "16:0669" : "16:0669 (16:0669 Pittman-Robertson Conservation Restoration Act)",
      "16:0675" : "16:0675 (16:0675 Norbeck Wildlife Preserve Organic Act)",
      "16:0703" : "16:0703 (16:703 Migratory Bird Act)",
      "16:0823(a)" : "16:0823(a) (16:0823(a) - Federal Public Utility Regulatory Policies Act)",
      "16:0825" : "16:0825 (16:0825 - Federal Power Commission Regulation;Public Utilities)",
      "16:0831" : "16:0831 (16:0831 - Actions re: Rights of Tennessee Valley Authority)",
      "16:1244" : "16:1244 (16:1244 - National Scenic and National Historic Trails)",
      "16:1331" : "16:1331 (16:1331 Wild Free Roaming Horse Act)",
      "16:1374d6" : "16:1374d6 (16:1374(d)(6) - Petition for Review re: Application for Import of Polar Bear Trophies)",
      "16:1531" : "16:1531 (16:1531 Endangered Species Act)",
      "16:1533" : "16:1533 (16:1533 - Endangered Species Act)",
      "16:1538" : "16:1538 (16:1538 Endangered Species Act)",
      "16:1540" : "16:1540 (16:1540 - Endangered Species Act - Penalties and Enforcement)",
      "16:1600" : "16:1600 (16:1600 National Forest Managment Act)",
      "16:1801" : "16:1801 (16:1801 - Magnuson-Stevens Fishery Conservation and Management Act)",
      "16:1858" : "16:1858 (16:1858 - National Fishery Management Program - Civil Penalties and Permit Sanctions)",
      "16:3371" : "16:3371 (16:3371 Wildlife Under the Lacey Act)",
      "16:3372" : "16:3372 (16:3372 Conservation: Complaint for Forfeiture)",
      "16:3373" : "16:3373 (16:3373 Appeal of Decision - DOI)",
      "16:3374" : "16:3374 (16:3374 Conservation: Complaint for Forfeiture)",
      "16:6802" : "16:6802 (16:6802 Recreation Enhancement Act (REA))",
      "17:0101" : "17:0101 (17:101 Copyright Infringement)",
      "17:0201" : "17:0201 (17:0201 - Ownership of Copyright)",
      "17:0205(d)" : "17:0205(d) (17:0205(d) - Priority Between Conflicting Transfers)",
      "17:0407" : "17:0407 (17:0407 - Recovery of Fines & Penalties by Register of Copyrights)",
      "17:0411" : "17:0411 (17:0411(b) Copyright infringment)",
      "17:0501" : "17:0501 (17:501 Copyright Infringement)",
      "17:0502(a)" : "17:0502(a) (17:0502(a) - Inj. to Prevent or Restrain Infringement Copyright)",
      "17:0504" : "17:0504 (17:504 Copyright Infringement)",
      "17:0512" : "17:0512 (17:0512 - Copyright Infringement of Digital Communications)",
      "17:1201" : "17:1201 (17:1201 Digital Millennium Copyright Act)",
      "18:0241" : "18:0241 (18:241 Conspiracy Against Citizen Rights)",
      "18:0248" : "18:0248 (18:248 Freedom of Access to Clinic Entrances Act)",
      "18:0492" : "18:0492 (18:0492: Forfeiture: Counterfeiting and Forgery)",
      "18:0603" : "18:0603 (18:0603 - Conflict of Interest)",
      "18:0921" : "18:0921 (18:0921 Title IV Omnibus Crime Control & Safe Streets Act)",
      "18:0922" : "18:0922 (18:0922 - Firearms - Unlawful Possession (Civil Fines))",
      "18:0923" : "18:0923 (18:0923 Gun Control Act of 1968)",
      "18:0923f3" : "18:0923f3 (18:0923(f)(3) - Review of Revocation of a License as a Dealer in Firearms)",
      "18:0924" : "18:0924 (18:0924 Civil Forfeiture)",
      "18:0925(c)" : "18:0925(c) (18:0925(c) - Restoration of Ability to Possess Firearms/Ammo)",
      "18:0981" : "18:0981 (18:0981 Civil Forfeiture)",
      "18:0981a1A" : "18:0981a1A (18:0981(a)(1)(A) - Civil Forfeiture: Money Laundering Control Act)",
      "18:0983" : "18:0983 (18:0983 (18:0983 Civil Forfeiture))",
      "18:1030g" : "18:1030g (18:1030(g) - Fraud & Related Matters in Connection w/ Computers)",
      "18:1201" : "18:1201 (18:1201 Federal Kidnapping across state lines)",
      "18:1343" : "18:1343 (Fraud by wire)",
      "18:1345" : "18:1345 (18:1345 - Injunction Against Fraud)",
      "18:1514" : "18:1514 (18:1514 - Civil Action to Restrain Harrassment of a Victim)",
      "18:1514A" : "18:1514A (18:1514A Sarbanes-Oxley Act)",
      "18:1589" : "18:1589 (18:1589 Forced Labor)",
      "18:1831" : "18:1831 (18:1831: Economic Espionage Act of 1996)",
      "18:1836a" : "18:1836a (18:1836(a) Injunction against Misappropriation of Trade Secrets)",
      "18:1836b" : "18:1836b (18:1836(b) Civil Action to Protect Trade Secrets)",
      "18:1905" : "18:1905 (18:1905 - Disclosure of Confidential Information)",
      "18:1955" : "18:1955 (18:1955 - Civil Forfeiture - Prohibition of Illegal Gambling)",
      "18:1956b3" : "18:1956b3 (18:1956(b)(3) - Laundering of Monetary Instruments - Forfeit Property)",
      "18:1957" : "18:1957 (18:1957 - Forfeiture Property)",
      "18:1961" : "18:1961 (18:1961 Racketeering (RICO) Act)",
      "18:1962" : "18:1962 (18:1962 Racketeering (RICO) Act)",
      "18:1964" : "18:1964 (18:1964 Racketeering (RICO) Act)",
      "18:1968" : "18:1968 (18:1968 - Action re: Civil Investigative Demand)",
      "18:2252" : "18:2252 (18:2252 - Assault, Internet Pornography)",
      "18:2254" : "18:2254 (18:2254 - Civil Forfeiture - Exploitation of Children)",
      "18:2331" : "18:2331 (18:2331 - Anti-Terrorism Act (Definitions))",
      "18:2333" : "18:2333 (18:2333 - Civil Remedies: Anti-Terrorism Act of 1991)",
      "18:2382" : "18:2382 (18:2382 - Misprison of Treason -- No Civil Action)",
      "18:2510" : "18:2510 (18:2510 Electronic Communications Privacy Act of 1986)",
      "18:2511" : "18:2511 (18:2511 - Wiretapping - Injunctive Relief or Civil Fine)",
      "18:2520" : "18:2520 (18:2520 Interception of Communications)",
      "18:2701" : "18:2701 (18:2701 Unlawful Access To Stored Communications)",
      "18:2707" : "18:2707 (18:2707 - Civil Action: Stored Communications)",
      "18:2710(c)" : "18:2710(c) (18:2710(c) - Wrongful Disclosure of Video Tape Rental or Sales Records)",
      "18:2721" : "18:2721 (18:2721 Drivers Privacy Protection Act of 1994)",
      "18:2724" : "18:2724 (18:2724 - Civil Action - Motor Vehicle Records)",
      "18:3006" : "18:3006 (18:3006 - Hyde Amendment, Statutory Note)",
      "18:3114" : "18:3114 (18:3114 - Motion for Return of Seized Property)",
      "18:3184" : "18:3184 (18:3184 - Extradition Procedure)",
      "18:3569" : "18:3569 (18:3569 - Unresolved Committed Fine -- Indigent Prisoners)",
      "18:3663" : "18:3663 (18:3663 - Civil Enforcement of Crim. Rest. Obligation)",
      "18:4100" : "18:4100 (18:4100 - Transfer of Offenders)",
      "19:1305" : "19:1305 (19:1305 Custom Duties:0Forfeiture-Immoral Articles)",
      "19:1497" : "19:1497 (19:1497 - Customs Duties: Penalty for Failure to Declare)",
      "19:1595(a)" : "19:1595(a) (19:1595(a) - Customs Duties: Forfeiture and Other Penalties)",
      "19:1607" : "19:1607 (19:1607 - Customs Duties: Notice of Seizure)",
      "20:0107" : "20:0107 (20:0107 Randolph - Sheppard Act)",
      "20:1070" : "20:1070 (20:1070 - Student Assistance)",
      "20:1080" : "20:1080 (20:1080 Student Loan Recovery)",
      "20:1087" : "20:1087 (20:1087 - Student Loan Discharge)",
      "20:1095a" : "20:1095a (20:1095a Education - Wage Garnishment Requirement)",
      "20:1097" : "20:1097 (20:1097 - Education - Criminal Penalties for Fraud)",
      "20:1098(g)" : "20:1098(g) (20:1098(g) - Higher Education Act - Exemption From State Disclosure)",
      "20:1232(g)" : "20:1232(g) (20:1232(g) - Family Education Rights & Privacy Act of 1974)",
      "20:1332" : "20:1332 (20:1332 - ERISA)",
      "20:1400" : "20:1400 (20:1400 Civil Rights of Handicapped Child)",
      "20:1401" : "20:1401 (20:1401 Education: Handicapped Child Act)",
      "20:1412" : "20:1412 (20:1412 - IDEA: State Eligibility)",
      "20:1415" : "20:1415 (20:1415 - IDEA: Challenge Decision re: Education for Handicapped)",
      "20:1415e2" : "20:1415e2 (20:1415(e)(2)de - IDEA: Mediation)",
      "20:1681" : "20:1681 (20:1681 Title IX Educational Amendments 1992)",
      "20:1683" : "20:1683 (20:1683 - Judicial Review: Prohibition Against Sex Descrimination in Education)",
      "20:1706" : "20:1706 (20:1706 - Relief From Denial of Equal Educational Opportunity)",
      "20:1717" : "20:1717 (20:1717 - Reopening Proceedings w/Order to End Segregation)",
      "21:0301" : "21:0301 (21:0301 - Federal Food, Drug & Cosmetic Act)",
      "21:0331" : "21:0331 (21:331 Federal Food, Drug & Cosmetic Act)",
      "21:0332" : "21:0332 (21:0332 Federal Food, Drug and Cosmetic Act, Injunctive Relief)",
      "21:0332(a)" : "21:0332(a) (21:0332(a) - Federal Food, Drug & Cosmetic Act)",
      "21:0334(a)" : "21:0334(a) (21:0334(a) - Forfeiture or Condemnation- food, drug,cosmetics)",
      "21:0348" : "21:0348 (21:0348 - Federal Food, Drug & Cosmetic Act - Food Additives)",
      "21:0360" : "21:0360 (21:0360 - Federal Food, Drug & Cosmetic Act - Drugs & Devices)",
      "21:0467" : "21:0467 (21:0467 - Seizure & Condemnation of Poultry Products)",
      "21:0601" : "21:0601 (21:0601 - Federal Meat Inspection Act 21 USC 601-695 (Definitions))",
      "21:0673" : "21:0673 (21:0673 - Seizure & condemnation of Meat or Meat Products)",
      "21:0674" : "21:0674 (21:0674 - Proceeding to Enforce& Enjoin re: Meat Products)",
      "21:0821" : "21:0821 (21:0821 - Violation of Record Keeping Provision of Controlled Substances Act)",
      "21:0841" : "21:0841 (21:841 Forfeiture Property-Drugs)",
      "21:0842" : "21:0842 (21:0842 - Civil Penalty for Violation re: Controlled Substance)",
      "21:0881" : "21:0881 (21:881 Forfeiture Property-Drugs)",
      "21:0881a" : "21:0881a (21:881 Forfeiture Property - Aircraft)",
      "21:0881re" : "21:0881re (21:881 Forfeiture Property - Real Estate)",
      "21:0882" : "21:0882 (21:0882 - Inj. to Enjoin Violations re: Controlled Substance)",
      "21:1049" : "21:1049 (21:1049 - Seiure & condemnation re: Eggs or Egg Products)",
      "22:0286" : "22:0286 (22:0286 - Action Against Workd Bank or IMF)",
      "22:2702" : "22:2702 (22:2702 - Medical Malpractice by Govt. Medical Personnel)",
      "22:3612" : "22:3612 (22:3612 - Claim for Damage to Panama Canal)",
      "22:3776" : "22:3776 (22:3776 - Panama Canal Commission Action on Claims)",
      "22:3777" : "22:3777 (22:3777 - Investigation of Accident or Injury Giving Rise to a Claim)",
      "22:4140" : "22:4140 (22:4140 - Foreign Service Grievance Act - Judicial Review)",
      "23:0112" : "23:0112 (23:0112 - Federal Highway Act - Letting of Contracts)",
      "23:0134" : "23:0134 (23:134 P.I.- Auto Negligence)",
      "23:1441" : "23:1441 (23:1441 Contract Real Estate)",
      "24:1000" : "24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)",
      "25:0391" : "25:0391 (25:0391 Indian Land Laws)",
      "25:0640" : "25:0640 (25:640(a)(d) - Indian Tribal Rights)",
      "25:1303" : "25:1303 (25:1303 Petition for Writ of Habeas Corpus)",
      "25:1901" : "25:1901 (25:1901 Indian Child Welfare Act)",
      "25:2701" : "25:2701 (25:2701 - Indian Gaming Regulatory Act (IGRA))",
      "25:4101" : "25:4101 (25:4101 Native American Housing Assistance and Self-Determination Act (NAHASDA))",
      "26:0063" : "26:0063 (26:0063 - IRS: Taxable Income (definition))",
      "26:0982" : "26:0982 (26:0982 - IRS: To Quash IRS Formal Document Request)",
      "26:2032" : "26:2032 ((26:2032 IRS: Alternate valuation))",
      "26:6212" : "26:6212 (26:6212 Injunctive Relief from IRS Lien)",
      "26:6213" : "26:6213 (26:6213 Injunctive Relief from IRS Lien)",
      "26:6221" : "26:6221 (26:6221 - IRS: TEFRA Tax, Equity and Fiscal Responsibility Act of 1982)",
      "26:6226" : "26:6226 (26:6226 - IRS - Partnership Administrative Adjustment)",
      "26:6320" : "26:6320 (26:6320 - IRS: Notice and Opportunity for Hearing Upon Filing Notice of Lien)",
      "26:6330" : "26:6330 (26:6330 IRS: Appeal of Agency Determination)",
      "26:6331" : "26:6331 (26:6331 IRS: Wrongful Levy)",
      "26:6334" : "26:6334 (26:6334 IRS: Property Exempt from Levy)",
      "26:6502" : "26:6502 (26:6502 IRS:Enforcement of tax liens)",
      "26:6532" : "26:6532 (26:6532 IRS: Refund of Tax Penalty)",
      "26:6653sp" : "26:6653sp (26:6653 IRS: Additions & Penalties - Spousal Liability)",
      "26:6672" : "26:6672 (26:6672 - IRS: Failure to Collect and Pay Over Tax, or Attempt to Evade or Defeat Tax)",
      "26:6694" : "26:6694 (26:6694 - IRS: Underestimate of Tax Liability by Tax Preparer)",
      "26:6702" : "26:6702 (26:6702 IRS: Refund of Income Tax Penalty)",
      "26:6703" : "26:6703 (26:6703 IRS: Refund of Tax Penalty)",
      "26:7323" : "26:7323 (26:7323 - IRS: Proceedings in Rem Enforce Forfeitures Property)",
      "26:7401" : "26:7401 (26:7401 IRS: Tax Liability)",
      "26:7402" : "26:7402 (26:7402 - IRS: Jurisdiction of District Courts)",
      "26:7403" : "26:7403 (26:7403 Suit to Enforce Federal Tax Lien)",
      "26:7404" : "26:7404 (26:7404 - IRS: Enforce Summons, Examination Books & Witnesses)",
      "26:7405" : "26:7405 (26:7405 - IRS: Action for Recovery of Refunds Erroneously Made)",
      "26:7407" : "26:7407 (26:7407 Action to enjoin tax return preparers)",
      "26:7422rt" : "26:7422rt (26:7422 IRS: Refund Taxes)",
      "26:7422rx" : "26:7422rx (26:7422 IRS: Refund Excise Tax)",
      "26:7425(a)" : "26:7425(a) (26:7425(a) - IRS: Judiciary & Judicial Procedures - Discharge of Liens)",
      "26:7426" : "26:7426 (26:7426 IRS: Wrongful Levy for Taxes)",
      "26:7428" : "26:7428 (26:7428 - IRS: Declaratory Judgment)",
      "26:7429" : "26:7429 (26:7429 IRS: Tax Jeopardy Assessment)",
      "26:7430" : "26:7430 (26:7430 - IRS: Awarding of Costs and Certain Fees in Tax Suit)",
      "26:7431" : "26:7431 (26:7431 Civil damages for unauth disclosure returns & info)",
      "26:7433" : "26:7433 (26:7433 Civil damages for unauthorized collection actions)",
      "26:7434" : "26:7434 (26:7434 Taxpayer Bill of Rights)",
      "26:7604(a)" : "26:7604(a) (26:7604(a) - IRS: Complaint to Enforce IRS Summons)",
      "26:7609" : "26:7609 (26:7609 - IRS: Petition to Serve Third Party Summons)",
      "26:7609j" : "26:7609j (26:7609 IRS: Petition for John Doe Summons)",
      "26:7609q" : "26:7609q (26:7609 IRS: Petition to Quash IRS Summons)",
      "27:0185" : "27:0185 (27:185 Enforcement of Arbitration Award)",
      "28:0051" : "28:0051 (28:0051 - Personal Injury)",
      "28:0157b" : "28:0157b (28:157b Bankruptcy Claim to be tried in U.S. District Court)",
      "28:0157c" : "28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)",
      "28:0157d" : "28:0157d (28:0157 Motion for Withdrawal of Reference)",
      "28:0158" : "28:0158 (28:0158 Notice of Appeal re Bankruptcy Matter (BA)",
      "28:0185" : "28:0185 (28:185 Suit to Compel Arbitration)",
      "28:0451" : "28:0451 (28:451 Employment Discrimination)",
      "28:0463" : "28:0463 (28:0463 - Expenses of Judicial Litigation)",
      "28:0534" : "28:0534 (28:0534 - Arrest Records)",
      "28:0591" : "28:0591 (28:0591 - Independent Counsel)",
      "28:0592" : "28:0592 (28:0592 - Independent Counsel - Application for Appointment)",
      "28:0593" : "28:0593 (28:0593 - Independent Counsel - Court Responsibilities)",
      "28:0594" : "28:0594 (28:0594 - Independent Counsel - Responsibilities)",
      "28:0595" : "28:0595 (28:0595 - Independent Counsel - Congressional Oversight)",
      "28:0596" : "28:0596 (28:0596 - Independent Counsel - Removal)",
      "28:0597" : "28:0597 (28:0597 - Independent Counsel - Dept. of Justice Relationship)",
      "28:0598" : "28:0598 (28:0598 - Independent Counsel - Chapter Termination)",
      "28:0636" : "28:0636 (28:0636 - Jurisdiction and Power of Magistrate Judges)",
      "28:0754" : "28:0754 (28:0754 - Receiver of Property in Different Districts)",
      "28:0794" : "28:0794 (28:794 Rehabilitation Act)",
      "28:1291" : "28:1291 (28:1291 - Maritime)",
      "28:1330" : "28:1330 (28:1330 Breach of Contract)",
      "28:1331" : "28:1331 (28:1331 Fed. Question: Labor)",
      "28:1331ag" : "28:1331ag (28:1331ag - Fed. Question - Employment Discrimination (Age))",
      "28:1331al" : "28:1331al (28:1331 Fed. Question: Airline Crash)",
      "28:1331as" : "28:1331as (28:1331as - Fed. Question - Assault, Libel, Slander)",
      "28:1331at" : "28:1331at (28:1331 Fed. Question: Anti-trust)",
      "28:1331au" : "28:1331au (28:1331 Fed. Question: Auto Negligence)",
      "28:1331b" : "28:1331b (28:1331 Federal Question: Bivens Act)",
      "28:1331bc" : "28:1331bc (28:1331 Fed. Question: Breach of Contract)",
      "28:1331bv" : "28:1331bv (28:1331bv - Fed. Question - Bivens-Prisoner)",
      "28:1331ca" : "28:1331ca (28:1331 Fed Question: Fed Communications Act of 1)",
      "28:1331cm" : "28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)",
      "28:1331cr" : "28:1331cr (28:1331cr - Fed. Question - Civil Rights (Race Discrimination))",
      "28:1331cv" : "28:1331cv (28:1331 Federal Question: Other Civil Rights)",
      "28:1331dd" : "28:1331dd (28:1331dd Fed. Question: Discovery Disputes)",
      "28:1331dj" : "28:1331dj (28:1331dj - Fed. Question - Declaratory Judgment)",
      "28:1331dp" : "28:1331dp (28:1331dp - Fed. Question - Violation of Due Process)",
      "28:1331ed" : "28:1331ed (28:1331 Fed. Question: Employment Discrimination)",
      "28:1331ef" : "28:1331ef (28:1331ef - Fed. Question - Civil Rights Violation (Excess Force))",
      "28:1331ej" : "28:1331ej (28:1331ej - Fed. Question: Enforcement of Judgment)",
      "28:1331es" : "28:1331es (28:1331 Enforcement of Administrative Subpoena)",
      "28:1331fa" : "28:1331fa (28:1331fa - Fed. Question: Civil Rights Violation - False Arrest)",
      "28:1331fd" : "28:1331fd (28:1331 Fed. Question: Fraud)",
      "28:1331fl" : "28:1331fl (28:1331 Fed. Question: Fair Labor Standards)",
      "28:1331fm" : "28:1331fm (28:1331fm - Fed. Question: Family and Medical Leave Act)",
      "28:1331fr" : "28:1331fr (28:1331fr - Fed. Question - Fraud)",
      "28:1331in" : "28:1331in (28:1331 Fed. Question: Insurance Contract)",
      "28:1331lm" : "28:1331lm (28:1331lm - Fed. Question - Legal Malpractice)",
      "28:1331mm" : "28:1331mm (28:1331 Fed. Question: Medical Malpractice)",
      "28:1331ng" : "28:1331ng (28:1331ng - Fed. Question - Natural Gas Act)",
      "28:1331ni" : "28:1331ni (28:1331ni - Negotiable Instrument)",
      "28:1331pd" : "28:1331pd (28:1331pd - Fed. Question - Property Damage)",
      "28:1331pi" : "28:1331pi (28:1331 Fed. Question: Personal Injury)",
      "28:1331pl" : "28:1331pl (28:1331pl - Fed. Question - Product Liability)",
      "28:1331pr" : "28:1331pr (28:1331pr - Fed. Question: Federal Prisoner Civil Rights)",
      "28:1331ra" : "28:1331ra (28:1331ra - Fed. Question: Racketeering (RICO) Act)",
      "28:1331rc" : "28:1331rc (28:1331 Fed. Question: Reclamation Project Auth. Act of 1972)",
      "28:1331rd" : "28:1331rd (28:1331 Fed. Question: Review Agency Decision)",
      "28:1331rp" : "28:1331rp (28:1331(a) Fed. Question: Real Property)",
      "28:1331rr" : "28:1331rr (28:1331 Fed. Question: Railway Labor Act)",
      "28:1331rs" : "28:1331rs (28:1331rs Federal Rail Safety Act)",
      "28:1331sh" : "28:1331sh (28:1331sh - Fed. Question - Sexual Harrassment)",
      "28:1331ss" : "28:1331ss (28:1331ss - Fed. Question: Constitutionality of State Statutes)",
      "28:1331sv" : "28:1331sv (28:1331 Fed. Question: Securities Violation)",
      "28:1331sx" : "28:1331sx (28:1331sx - Fed. Question: Employment Discrimination (Sex))",
      "28:1331ta" : "28:1331ta (28:1331 Fed. Question: Taxes)",
      "28:1331tr" : "28:1331tr (28:1331 Fed. Question: Trademark)",
      "28:1331tt" : "28:1331tt (28:1331 Fed. Question: Tort Action)",
      "28:1331v" : "28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendme)",
      "28:1331va" : "28:1331va (28:1331va - Fed. Question: Violation 5th & 14th Amendments)",
      "28:1331vc" : "28:1331vc (28:1331vc - Fed. Question: Violation of Constitutional Rights)",
      "28:1331w" : "28:1331w (28:1331w - Fed. Question: Wrongful Termination of Employment)",
      "28:1331wd" : "28:1331wd (28:1331wd - Fed.Question: Wrongful Death)",
      "28:1331wl" : "28:1331wl (28:1331 Federal Question: EPA Waste Lien)",
      "28:1331wt" : "28:1331wt (28:1331 Fed. Question: Water Rights)",
      "28:1332" : "28:1332 (28:1332 Diversity)",
      "28:1332ac" : "28:1332ac (28:1332 Diversity-Account Receivable)",
      "28:1332al" : "28:1332al (28:1332 Diversity-Airline Crash)",
      "28:1332ap" : "28:1332ap (28:1332ap - Diversity - Airplane Product Liability)",
      "28:1332as" : "28:1332as (28:1332 Diversity-Asbestos Litigation)",
      "28:1332au" : "28:1332au (28:1332 Diversity-Auto Negligence)",
      "28:1332bc" : "28:1332bc (28:1332 Diversity-Breach of Contract)",
      "28:1332bw" : "28:1332bw (28:1332bw - Diversity - Breach of Warranty)",
      "28:1332co" : "28:1332co (28:1332 Diversity-Conversion)",
      "28:1332ct" : "28:1332ct (28:1332 Diversity-(Citizenship))",
      "28:1332de" : "28:1332de (28:1332de - Diversity: Forcible Detainer)",
      "28:1332det" : "28:1332det (28:1332 Diversity: Forcible Detainer)",
      "28:1332df" : "28:1332df (28:1332 Diversity-Contract Default)",
      "28:1332dm" : "28:1332dm (28:1332 Diversity-Discrimination)",
      "28:1332ds" : "28:1332ds (28:1332 Diversity-Contract Dispute)",
      "28:1332dtp" : "28:1332dtp (28:1332 Diversity - Deceptive Trade Practices)",
      "28:1332ed" : "28:1332ed (28:1332 Diversity-Employment Discrimination)",
      "28:1332ej" : "28:1332ej (28:1332ej (28:1332 Enforcement of Judgment))",
      "28:1332em" : "28:1332em (28:1332 Diversity - Employment)",
      "28:1332fc" : "28:1332fc (28:1332 Diversity - Foreclosure)",
      "28:1332fd" : "28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)",
      "28:1332fr" : "28:1332fr (28:1332 Diversity-Fraud)",
      "28:1332ia" : "28:1332ia (28:1332 Diversity-Interpleader Action)",
      "28:1332if" : "28:1332if (28:1332if - Diversity - Insurance Fraud)",
      "28:1332ij" : "28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)",
      "28:1332in" : "28:1332in (28:1332 Diversity-Insurance Contract)",
      "28:1332jd" : "28:1332jd (28:1332 Diversity-Declaratory Judgment)",
      "28:1332lb" : "28:1332lb (28:1332 Diversity-Libel,Assault,Slander)",
      "28:1332lm" : "28:1332lm (28:1332 Diversity - Legal Malpractice)",
      "28:1332lp" : "28:1332lp (28:1332lp - Diversity: Property Damage/Product Liability)",
      "28:1332lr" : "28:1332lr (28:1332lr Diversity - Labor)",
      "28:1332ma" : "28:1332ma (28:1332 Diversity-Miller Act)",
      "28:1332md" : "28:1332md (28:1332md - Diversity: Motor Vehicle/Wrongful Death)",
      "28:1332mm" : "28:1332mm (28:1332 Diversity-Medical Malpractice)",
      "28:1332mv" : "28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)",
      "28:1332ni" : "28:1332ni (28:1332 Diversity-Negotiable Instrument)",
      "28:1332nm" : "28:1332nm (28:1332 Diversity-Non-Motor Vehicle)",
      "28:1332nr" : "28:1332nr (28:1332nr - Diversity: Notice of Removal)",
      "28:1332oc" : "28:1332oc (28:1332 Diversity-Other Contract)",
      "28:1332op" : "28:1332op (28:1332op - Diversity: Recovery of Overpayment)",
      "28:1332pa" : "28:1332pa (28:1332pa - Diversity: Personal Injury/Airplane)",
      "28:1332pd" : "28:1332pd (28:1332 Diversity-Property Damage)",
      "28:1332pi" : "28:1332pi (28:1332 Diversity-Personal Injury)",
      "28:1332pl" : "28:1332pl (28:1332 Diversity-Product Liability)",
      "28:1332pr" : "28:1332pr (28:1332 Diversity-Petition for Removal)",
      "28:1332qt" : "28:1332qt (28:1332 Diversity-Petition to Quiet Title)",
      "28:1332rd" : "28:1332rd (28:1332rd - Diversity: Recovery of Debt)",
      "28:1332ri" : "28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)",
      "28:1332rl" : "28:1332rl (28:1332rl - Diversity: Rent Lease & Ejectment)",
      "28:1332rp" : "28:1332rp (28:1332 Diversity - Real Property)",
      "28:1332sa" : "28:1332sa (28:1332 - Diversity: Securities & Exchange Commiss)",
      "28:1332sf" : "28:1332sf (28:1332 - Diversity: Securities)",
      "28:1332sh" : "28:1332sh (28:1332sh - Diversity: Sexual Harassment)",
      "28:1332ss" : "28:1332ss (28:1332 Diversity - Stockholders Suits)",
      "28:1332t" : "28:1332t (28:1332t - Diversity: Torts)",
      "28:1332tl" : "28:1332tl (28:1332 Diversity-Torts to Land)",
      "28:1332tm" : "28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))",
      "28:1332tn" : "28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)",
      "28:1332ts" : "28:1332ts (28:1332ts - Diversity: Misappropriation of Trade Secrets)",
      "28:1332vt" : "28:1332vt (28:1332vt - Diversity: Natl. Motor Vehicle Title Information System)",
      "28:1332wc" : "28:1332wc (28:1332wc - Diversity: Worker's Compensation Benefits)",
      "28:1332wd" : "28:1332wd (28:1332 Diversity-Wrongful Death)",
      "28:1333" : "28:1333 (28:1333ad - Admiralty)",
      "28:1333in" : "28:1333in (28:1333in - Personal Injury)",
      "28:1333mc" : "28:1333mc (28:1333mc - Marine Contract)",
      "28:1333pd" : "28:1333pd (28:1333pd - Property Damage)",
      "28:1333pi" : "28:1333pi (28:1333pid - Marine Personal Injury)",
      "28:1334" : "28:1334 (28:1334 Bankruptcy Appeal)",
      "28:1334(b)" : "28:1334(b) (28:1334(b) - Proceeding Arising/Related to Case Under Title 11)",
      "28:1334c" : "28:1334c (28:1334(c) R&R re motions for abstention (non-cor)",
      "28:1335" : "28:1335 (28:1335 Interpleader Action)",
      "28:1337" : "28:1337 (28:1337 Commerce and Antitrust Regulations)",
      "28:1338cp" : "28:1338cp (28:1338 Copyright Infringement)",
      "28:1338pt" : "28:1338pt (28:1338 Patent Infringement)",
      "28:1338tr" : "28:1338tr (28:1338 Trademark Infringement)",
      "28:1339" : "28:1339 (28:1339 - Postal Matters)",
      "28:1340" : "28:1340 (28:1340 IRS: Custom Duties)",
      "28:1340er" : "28:1340er (28:1340 Recovery of Erroneous Refund)",
      "28:1340tp" : "28:1340tp (28:1340tp Injunction of Tax Preparer)",
      "28:1341" : "28:1341 (28:1341 Complaint for Forfeiture)",
      "28:1343" : "28:1343 (28:1343 Violation of Civil Rights)",
      "28:1344" : "28:1344 (28:1344 - Election Disputes)",
      "28:1345" : "28:1345 (28:1345 - U.S. Plaintiff)",
      "28:1345co" : "28:1345co (28:1345 Replevin & Conversion)",
      "28:1345db" : "28:1345db (28:1345 Debt to US - FHA/HUD Title I)",
      "28:1345df" : "28:1345df (28:1345 Default of Promissory Note)",
      "28:1345er" : "28:1345er (28:1345 Recovery of Erroneous Refund)",
      "28:1345fc" : "28:1345fc (28:1345 Foreclosure)",
      "28:1345ff" : "28:1345ff (28:1345 Complaint for Forfeiture)",
      "28:1345hl" : "28:1345hl (28:1345 VA Home Loan Guaranty Debt)",
      "28:1345lc" : "28:1345lc (28:1345lc - Land Condemnation)",
      "28:1345mc" : "28:1345mc (28:1345 Medical Care Recovery)",
      "28:1345mi" : "28:1345mi (28:1345 Mining Claim Ejectment)",
      "28:1345pd" : "28:1345pd (28:1345 Property Damage)",
      "28:1345pe" : "28:1345pe (28:1345 Property Ejectment)",
      "28:1345rc" : "28:1345rc (28:1345 Recovery of Debt to US)",
      "28:1345ro" : "28:1345ro (28:1345 Recovery of Retirement Overpayment)",
      "28:1345st" : "28:1345st (28:1345 Default of Student Loan)",
      "28:1345tp" : "28:1345tp (28:1345 Trespass on Public Land)",
      "28:1345tx" : "28:1345tx (28:1345 Prohibit dfts assessing tx on purch/use of pers prop)",
      "28:1345va" : "28:1345va (28:1345 Recovery of VA Overpayment)",
      "28:1346" : "28:1346 ()",
      "28:1346bc" : "28:1346bc (28:1346 Breach of Contract)",
      "28:1346pi" : "28:1346pi (28:1346pi - Marine Personal Injury (or Tort Claim - Personal Injury/Motor Vehicle))",
      "28:1346rc" : "28:1346rc (28:1346 Recovery of IRS Tax)",
      "28:1346tc" : "28:1346tc (28:1346t Tort Claim)",
      "28:1346wd" : "28:1346wd (28:1346 Wrongful Death)",
      "28:1348" : "28:1348 (28:1348 - Banking Association as Party)",
      "28:1349" : "28:1349 (28:1349 - Corporation Organized Under Federal Law as Party)",
      "28:1350" : "28:1350 (28:1350 - Alien Tort Claims Act)",
      "28:1352" : "28:1352 (28:1352 Miller Act)",
      "28:1355" : "28:1355 (28:1355 Petition for Return of Property)",
      "28:1356" : "28:1356 (28:1356 - Executory Process/Foreclosure)",
      "28:1358" : "28:1358 (28:1358 Land Condemnation)",
      "28:1361" : "28:1361 (28:1361 - Petition for Writ of Mandamus)",
      "28:1362ic" : "28:1362ic (28:1362 Indian Tribal Controversy)",
      "28:1362iw" : "28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)",
      "28:1363" : "28:1363 (28:1363 - Action for Protection of Jurors Employment Rights)",
      "28:1364" : "28:1364 (28:1364 Auto Negligence)",
      "28:1367" : "28:1367 (28:1367 - Other Property Damage)",
      "28:1369" : "28:1369 (28:1369 Multiparty, multiforum jurisdiction)",
      "28:1391" : "28:1391 (28:1391 - Venue)",
      "28:1394" : "28:1394 (28:1394 - Banking Assoc. Action Against Comptroller of Currency)",
      "28:1395" : "28:1395 (28:1395 - Complaint for Forfeiture)",
      "28:1402" : "28:1402 (28:1402 Medical Malpractice)",
      "28:1403" : "28:1403 (28:1403 - Condemnation of Real Estate for the Use of the US)",
      "28:1407" : "28:1407 (28:1407 Airline Crash)",
      "28:1407im" : "28:1407im (28:1407im - MDL: Silicone Gel Breast Implant Products Liability)",
      "28:1407md" : "28:1407md (28:1407md - MDL: Multidistrict Litigation)",
      "28:1407n" : "28:1407n (28:1407n - MDL: Personal Injury/Norplant Product Liability)",
      "28:1407pl" : "28:1407pl (28:1407pl - MDL: Products Liability)",
      "28:1441ac" : "28:1441ac (28:1441 Petition for Removal- Account Receivable)",
      "28:1441ada" : "28:1441ada (28:1441ada - Removal - Americans With Disabilities Act)",
      "28:1441ag" : "28:1441ag (28:1441ag - Removal - Civil Rights (Age))",
      "28:1441al" : "28:1441al (28:1441 Petition for Removal- Airline Crash)",
      "28:1441as" : "28:1441as (28:1441 Petition for Removal- Asbestos Litigation)",
      "28:1441au" : "28:1441au (28:1441 Petition for Removal- Auto Negligence)",
      "28:1441ba" : "28:1441ba (28:1441ba - Removal - National Bank Act)",
      "28:1441bc" : "28:1441bc (28:1441bc - Removal - Breach of Contract)",
      "28:1441bfd" : "28:1441bfd (28:1441bfd - Removal - Breach of Fiduciary Duties)",
      "28:1441ca" : "28:1441ca (28:1441ca - Removal - Carmack Amendment)",
      "28:1441cc" : "28:1441cc (28:1441cc - Removal - Computer Crimes Act)",
      "28:1441cj" : "28:1441cj (28:1441cj - Removal - Confessed Judgment)",
      "28:1441cla" : "28:1441cla (28:1441cla - Removal - Consumer Leasing Act)",
      "28:1441cp" : "28:1441cp (28:1441cp - Removal - Copyright)",
      "28:1441cpl" : "28:1441cpl (28:1441cpl - Removal - Contract Product Liability)",
      "28:1441cra" : "28:1441cra (28:1441cra - Removal - Fair Credit Reporting Act)",
      "28:1441cv" : "28:1441cv (28:1441 Petition for Removal- Civil Rights Act)",
      "28:1441dea" : "28:1441dea (28:1441dea - Removal - Disabilities Education Act)",
      "28:1441df" : "28:1441df (28:1441 Petition for Removal- Contract Default)",
      "28:1441di" : "28:1441di (28:1441di - Removal - Civil Rights (Disability Act))",
      "28:1441dj" : "28:1441dj (28:1441 Petition for Removal- Declaratory Judgment)",
      "28:1441ds" : "28:1441ds (28:1441 Petition for Removal- Contract Dispute)",
      "28:1441ea" : "28:1441ea (28:1441ea - Removal - Employment Discrimination (Age))",
      "28:1441eb" : "28:1441eb (28:1441eb - Removal - ERISA Employee Benefits)",
      "28:1441ec" : "28:1441ec (28:1441ec - Removal - Electronic Comm. Privacy Act)",
      "28:1441ed" : "28:1441ed (28:1441 Petition for Removal - Employment Discrim)",
      "28:1441em" : "28:1441em (28:1441em - Removal - Emergency Medical Treatment & Active Labor)",
      "28:1441er" : "28:1441er (28:1441er - Removal - Employment Discrimination (Race))",
      "28:1441es" : "28:1441es (28:1441es - Removal - Employment Discrimination (Sex))",
      "28:1441fa" : "28:1441fa (28:1441fa - Removal - Civil Rights -- False Arrest)",
      "28:1441fc" : "28:1441fc (28:1441 Petition for Removal - Fair Credit Reporti)",
      "28:1441fd" : "28:1441fd (28:1441fd - Removal - Fair Debt Collection Practices Act)",
      "28:1441fe" : "28:1441fe (28:1441fe - Removal - Fed. Employee Garnishment Statute)",
      "28:1441fh" : "28:1441fh (28:1441fh - Removal - FEHBA)",
      "28:1441fif" : "28:1441fif (28:1441fif - Removal -- Insecticide/Fungicide/Rodenticide Act - 1942)",
      "28:1441fl" : "28:1441fl (28:1441fl - Removal - Fair Labor Standards Act)",
      "28:1441fm" : "28:1441fm (28:1441fm - Removal - Family and Medical Leave Act)",
      "28:1441fr" : "28:1441fr (28:1441 Petition for Removal- Fraud)",
      "28:1441fs" : "28:1441fs (28:1441fs - Removal - Foreign Sovereign Immunities Act)",
      "28:1441fsa" : "28:1441fsa (28:1441fsa - Removal - Federal Food Stamp Act)",
      "28:1441hb" : "28:1441hb (28:1441hb - Removal - Petition of Habeas Corpus)",
      "28:1441hc" : "28:1441hc (28:1441hc - Removal - Handicapped Child Protection Act)",
      "28:1441hd" : "28:1441hd (28:1441hd - Removal - Housing Discrimination)",
      "28:1441ia" : "28:1441ia (28:1441ia - Removal - Interstate Commerce Act)",
      "28:1441if" : "28:1441if (28:1441if - Removal - Insurance Fraud)",
      "28:1441ij" : "28:1441ij (28:1441 Petition for Removal- Injunctive/Declarato)",
      "28:1441il" : "28:1441il (28:1441il - Removal - Interstate Land Full Discloser Act)",
      "28:1441in" : "28:1441in (28:1441 Petition for Removal- Insurance Contract)",
      "28:1441int" : "28:1441int (28:1441 Petition for Removal- Action for Interplea)",
      "28:1441la" : "28:1441la (28:1441la - Removal -- Truth In Lending Act)",
      "28:1441lb" : "28:1441lb (28:1441 Petition for Removal Libel,Assault,Slander)",
      "28:1441lm" : "28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relatio)",
      "28:1441ml" : "28:1441ml (28:1441ml - Removal - Motor Vehicle Prod. Liability)",
      "28:1441mm" : "28:1441mm (28:1441 Petition for Removal- Medical Malpractice)",
      "28:1441mv" : "28:1441mv (28:1441mv - Removal - Motor Vehicle)",
      "28:1441ni" : "28:1441ni (28:1441 Petition for Removal- Negotiable Instrumen)",
      "28:1441nm" : "28:1441nm (28:1441 Petition for Removal- Non-Motor Vehicle)",
      "28:1441nr" : "28:1441nr (28:1441nr - Notice of Removal)",
      "28:1441oc" : "28:1441oc (28:1441 Petition For Removal--Other Contract)",
      "28:1441pa" : "28:1441pa (28:1441pa - Removal - Patent Infringement)",
      "28:1441pd" : "28:1441pd (28:1441 Petition for Removal- Property Damage)",
      "28:1441pi" : "28:1441pi (28:1441 Petition for Removal- Personal Injury)",
      "28:1441pl" : "28:1441pl (28:1441 Petition for Removal- Product Liability)",
      "28:1441pr" : "28:1441pr (28:1441 Petition for Removal)",
      "28:1441qt" : "28:1441qt (28:1441 Petition for Removal- Petition to Quiet Ti)",
      "28:1441ra" : "28:1441ra (28:1441ra - Removal -- Civil Rights (Race))",
      "28:1441ri" : "28:1441ri (28:1441 Petition for Removal- Racketeering (RICO))",
      "28:1441rl" : "28:1441rl (28:1441rl - Removal -- Rent, Lease & Ejectment)",
      "28:1441sa" : "28:1441sa (28:1441 - Petition for Removal: SEC Act)",
      "28:1441sf" : "28:1441sf (28:1441 - Petition for Removal: Securities Fraud)",
      "28:1441sh" : "28:1441sh (28:1441sh - Removal - Sexual Harassment)",
      "28:1441st" : "28:1441st (28:1441st - Removal -- Stockholders Suit)",
      "28:1441sv" : "28:1441sv (28:1441sv - Removal -- Security Violation)",
      "28:1441sx" : "28:1441sx (28:1441sx - Removal -- Civil Rights (Sex))",
      "28:1441tc" : "28:1441tc (28:1441tc - Removal -- Tricare Program)",
      "28:1441ti" : "28:1441ti (28:1441ti - Removal - Trademark Infringement)",
      "28:1441til" : "28:1441til (28:1441til - Removal -- Truth and Lending)",
      "28:1441tl" : "28:1441tl (28:1441 Petition for Removal- Torts to Land)",
      "28:1441tm" : "28:1441tm (28:1441 Petition for Removal- Tort/Motor Vehicle ()",
      "28:1441tn" : "28:1441tn (28:1441 Petition for Removal- Tort/Non-Motor Vehic)",
      "28:1441us" : "28:1441us (28:1441us - Removal -- Uniformed Svc. Emp./Reemp. Rights Act)",
      "28:1441wc" : "28:1441wc (28:1441wc - Removal -- Worker's Compensation Benefits)",
      "28:1441wd" : "28:1441wd (28:1441 Petition for Removal- Wrongful Death)",
      "28:1441wt" : "28:1441wt (28:1441wt - Removal -- Employment (Wrongful Termination))",
      "28:1442" : "28:1442 (28:1442 - Notice of Removal -- Suit Against Federal Officer)",
      "28:1442aaf" : "28:1442aaf (28:1442aaf - Petition for Removal -- Agst. Members of Armed Forces)",
      "28:1442bc" : "28:1442bc (28:1442 Petition for Removal- Breach of Contract)",
      "28:1442pr" : "28:1442pr (28:1442 Petition for Removal)",
      "28:1443" : "28:1443 (28:1443(1) Rent, Lease & Ejectment)",
      "28:1444" : "28:1444 (28:1444 Petition for Removal- Foreclosure)",
      "28:1446al" : "28:1446al (28:1446al - Notice of Removal -- Airline Crash)",
      "28:1446as" : "28:1446as (28:1446as - Notice of Removal -- Asbestos Litigation)",
      "28:1446bc" : "28:1446bc (28:1446bc - Notice of Removal -- Breach of Contract)",
      "28:1446cs" : "28:1446cs (28:1446cs - Notice of Removal -- Child Support Enforcement)",
      "28:1446dj" : "28:1446dj (28:1446dj - Notice of Removal -- Declaratory Judgment)",
      "28:1446er" : "28:1446er (28:1446er - Notice of Removal -- ERISA)",
      "28:1446fm" : "28:1446fm (28:1446fm - Notice of Removal -- Family and Medical Leave Act)",
      "28:1446fr" : "28:1446fr (28:1446fr - Notice of Removal -- Fraud)",
      "28:1446in" : "28:1446in (28:1446 Breach of Contract- Insurance)",
      "28:1446lb" : "28:1446lb (28:1446lb - Notice of Removal -- Libel, Assault, Slander)",
      "28:1446ml" : "28:1446ml (28:1446ml - Notice of Removal -- Motor Vehicle Prod. Liability)",
      "28:1446mm" : "28:1446mm (28:1446mm - Notice of Removal -- Medical Malpractice)",
      "28:1446mv" : "28:1446mv (28:1446mv - Notice of Removal -- Motor Vehicle)",
      "28:1446ni" : "28:1446ni (28:1446ni - Notice of Removal -- Negotiable Instrument)",
      "28:1446nr" : "28:1446nr (28:1446nr - Notice of Removal)",
      "28:1446oc" : "28:1446oc (28:1446oc - Notice of Removal -- Other Contract)",
      "28:1446pd" : "28:1446pd (28:1446 Petition for Removal- Property Damage (P.I)",
      "28:1446pi" : "28:1446pi (28:1446 Petition for Removal- Personal Injury)",
      "28:1446pl" : "28:1446pl (28:1446pl - Notice of Removal -- Product Liability)",
      "28:1446pr" : "28:1446pr (28:1446 Petition for Removal)",
      "28:1446st" : "28:1446st (28:1446st - Notice of Removal - Stockholders Suit)",
      "28:1446tl" : "28:1446tl (28:1446tl - Notice of Removal -- Torts to Land)",
      "28:1446wd" : "28:1446wd (28:1446ws - Notice of Removal -- Wrongful Death)",
      "28:1452" : "28:1452 (28:1452 R&R re motions to remand (non-core))",
      "28:1452a" : "28:1452a (28:1452 (a) Removal of Claims Related to Bankruptcy Cases)",
      "28:1453" : "28:1453 (28:1453 - Class Action Fairness Act)",
      "28:1491" : "28:1491 (28:1491 Tucker Act - Claims Against United States)",
      "28:1602" : "28:1602 (28:1602 Foreign Sovereign Immunities Act of 1976)",
      "28:1605" : "28:1605 (28:1605 - Foreigh Sovereign Immunities Act of 1976)",
      "28:1605A" : "28:1605A (28:1605A - Antiterrorism & Effective Death Penalty Act 1996)",
      "28:1610" : "28:1610 (28:1610 Juridictional Immunities of Foreign States)",
      "28:1631" : "28:1631 (28:1631 - Case Transferred to Cure Want of Jurisdiction)",
      "28:1651" : "28:1651 (28:1651 Petition for Writ of Coram Nobis)",
      "28:1651hc" : "28:1651hc (28:1651 Petition for Writ of Habeas Corpus)",
      "28:1651mn" : "28:1651mn (28:1651 Petition for Writ of Mandamus)",
      "28:1651ne" : "28:1651ne (28:1651ne - Application for Writ Ne Exeat)",
      "28:1651w" : "28:1651w (28:1651w - All Writs Act)",
      "28:1715" : "28:1715 (28:1715 - Class Action Fairness Act of 2005)",
      "28:1732" : "28:1732 (28:1732 - Reproduction of Records)",
      "28:1738Acs" : "28:1738Acs (28:1738Acs - The Uniform Child Custody Jurisdiction Act)",
      "28:1782" : "28:1782 (28:1782 Assistance to foreign & international tribunals & litigants)",
      "28:1783" : "28:1783 (28:1783 - Petition for Subpoena of Person in Foreign Country)",
      "28:1826" : "28:1826 (28:1826 - Order of Confinement of Recalcitrant Witness)",
      "28:1875" : "28:1875 (28:1875 Protection of Jurors' Employment)",
      "28:1916" : "28:1916 (28:1916 - Marine Personal Injury)",
      "28:1963" : "28:1963 (28:1963 - Registration of Judgment From Another District)",
      "28:1983" : "28:1983 (28:1983 Civil Rights)",
      "28:2001" : "28:2001 (28:2001 Judicial Sale of Realty)",
      "28:2071" : "28:2071 (28:2071 - Rule Making Power Generally)",
      "28:2201" : "28:2201 (28:2201 Constitutionality of State Statute(s))",
      "28:2201an" : "28:2201an (28:2201an - Declaratory Judgment (Aliens and Nationality))",
      "28:2201cp" : "28:2201cp (28:2201cp - Declaratory Judgment (Copyright))",
      "28:2201dj" : "28:2201dj (28:2201 Declaratory Judgment)",
      "28:2201fa" : "28:2201fa (28:2201fa - Declaratory Judgment -- Firearms)",
      "28:2201fs" : "28:2201fs (28:2201fs - Declaratory Judgment -- Food Securty Act)",
      "28:2201ij" : "28:2201ij (28:2201 Injunction)",
      "28:2201in" : "28:2201in (28:2201 Declaratory Judgment (Insurance))",
      "28:2201pi" : "28:2201pi (28:2201pi - Declaratory Judgment -- Personal Injury)",
      "28:2241" : "28:2241 (28:2241 Petition for Writ of Habeas Corpus (federa)",
      "28:2241fd" : "28:2241fd (28:2241fd - Petition for Writ of Habeas Corpus (Federal))",
      "28:2241in" : "28:2241in (28:2241in - Habeas Corpus: INS)",
      "28:2241st" : "28:2241st (28:2241st - Petition for Writ of Habeas Corpus (State))",
      "28:2244" : "28:2244 (28:2244 Habeas Corpus - Finality of Determination)",
      "28:2254" : "28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))",
      "28:2254dp" : "28:2254dp (28:2254dp - Petition for Writ of Habeas Corpus (Death Penalty))",
      "28:2254se" : "28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)",
      "28:2255" : "28:2255 (28:2255 Motion to Vacate / Correct Illegal Sentenc)",
      "28:2255hc" : "28:2255hc (28:2255 Petition for Writ of Habeas Corpus)",
      "28:2256" : "28:2256 (28:2256 - Transfer Convicted Offenders to Foreign Country)",
      "28:2283" : "28:2283 (28:2283 Stay of State Court Proceedings)",
      "28:2347" : "28:2347 (28:2347 - Petition to Review Orders in the Court of Appeals)",
      "28:2401" : "28:2401 (28:2401 - Federal Tort Claims Act (Time for Commencing Action Against the US))",
      "28:2403" : "28:2403 (28:2403 - Constitutionality of State Statute(s))",
      "28:2405" : "28:2405 (28:2405 - Garnishment of Debtors of a Corporation by US)",
      "28:2409" : "28:2409 (28:2409(a) Quiet Title Action)",
      "28:2410" : "28:2410 (28:2410 Action affecting property on which US has lien)",
      "28:2412" : "28:2412 (28:2412 Equal Access to Justice Act)",
      "28:2415" : "28:2415 (28:2415 - Detinue and Conversion)",
      "28:2671" : "28:2671 (28:2671 Federal Tort Claims Act)",
      "28:2672mv" : "28:2672mv (28:2672mv - Federal Tort Claims Act -- Motor Vehicle)",
      "28:2672pi" : "28:2672pi (28:2672pi - Federal Tort Claims Act -- Personal Injury)",
      "28:2674" : "28:2674 (28:2674 Federal Tort Claims Act)",
      "28:2675" : "28:2675 (28:2675 - Federal Tort Claims Act - Disposition by Agency Req.)",
      "28:2679" : "28:2679 (28:2679 Federal Tort Claims Act)",
      "28:2679d2" : "28:2679d2 (28:2679(d)(2) - Federal Tort Claims Act - Employee of USA)",
      "28:2680" : "28:2680 (28:2680 - Federal Tort Claims Act -- Exceptions)",
      "28:3001" : "28:3001 (28:3001 - Federal Debt Collection Act)",
      "28:3001(a)" : "28:3001(a) (28:3001(a) - Federal Debt Collection Procedures Act of 1990)",
      "28:3203" : "28:3203 (28:3203 - Post Judgment Remedies: Writ of Execution)",
      "28:3301" : "28:3301 (28:3301 - Fraudulent Transfer Federal Debt Collection Procedures Act)",
      "28:6694" : "28:6694 (28:6694 IRS Underestimate Of Tax Liability By Tax Preparer)",
      "28:7402" : "28:7402 (28:7402 Refund of Taxes)",
      "28:7422" : "28:7422 (28:7422 Appeal from Administrative Decision)",
      "28:876" : "28:876 (28:876 Controlled Substance Act)",
      "29:0101" : "29:0101 (29:0101 Equal Pay Act)",
      "29:0151" : "29:0151 (29:151 Labor: Review of Agency Action)",
      "29:0158" : "29:0158 (29:0158 Unfair Labor Practices)",
      "29:0158(b)" : "29:0158(b) (29:0158(b) - NLRA -- Unfair Labor Practices)",
      "29:0159" : "29:0159 (29:0159 - Labor: Violation of Collective Bargaining Agreement)",
      "29:0160" : "29:0160 (29:160(1) National Labor Relations Act)",
      "29:0160j" : "29:0160j (29:0160j - Labor: Petition for Inj. -- Relief From Unfair Labor Practice)",
      "29:0160l" : "29:0160l (29:0160l - Labor: Petition for Inj. re: Uncertified Labor Organizations)",
      "29:0161(2)" : "29:0161(2) (29:0161(2) - Labor: Enforcement of Agency Subpoena)",
      "29:0178" : "29:0178 (29:0178 - Labor: Petition for Inj. to Enjoin Strike During Nat'l. Emergency)",
      "29:0184" : "29:0184 (29:184 Violation Collection Bargain Agreement)",
      "29:0185" : "29:0185 (29:0185 - Labor: Suits By and Against Labor Organizations)",
      "29:0185ep" : "29:0185ep (29:185 Employee Pension Plan)",
      "29:0185lm" : "29:0185lm (29:185 Labor/Mgt. Relations)",
      "29:0186" : "29:0186 (29:0186 Liabilities of and Restrictions on Labor and Management)",
      "29:0187" : "29:0187 (29:0187 - Labor: Recover Damages From Unfair Labor Practice)",
      "29:0201do" : "29:0201do (29:201 Denial of Overtime Compensation)",
      "29:0201fl" : "29:0201fl (29:201 Fair Labor Standards Act)",
      "29:0203" : "29:0203 (29:203 Equal Pay Act)",
      "29:0206" : "29:0206 (29:0206 - FLSA -- Minimum Wage)",
      "29:0206(d)" : "29:0206(d) (29:0206(d) - FLSA: Prohibition of Sex Discrimination)",
      "29:0207(a)" : "29:0207(a) (29:0207(a) - FLSA: Action for Overtime Wage Violation)",
      "29:0207fl" : "29:0207fl (29:0207fl - FLSA: Maximum Hours)",
      "29:0210" : "29:0210 (29:0210 - FLSA: Court Review of Wage Orders in PR and VI)",
      "29:0215" : "29:0215 (29:215 Fair Labor Standards Act)",
      "29:0215fl" : "29:0215fl (29:0215fl - FLSA: Prohibited Acts)",
      "29:0216" : "29:0216 (29:0216 Fair Labor Standards Act)",
      "29:0216(b)" : "29:0216(b) (29:0216(b) - FLSA: Minimum Wage or Overtime Compensation)",
      "29:0216(e)" : "29:0216(e) (29:0216(e) - FLSA: Penalty Assessed for Child Labor Provisions)",
      "29:0217" : "29:0217 (29:0217 - FLSA: Enjoin Violations of Fair Labor Standards Act)",
      "29:0260" : "29:0260 (29:0260 - FLSA: Liquidated Damages)",
      "29:0401" : "29:0401 (29:0401 Labor Management Disclosure Act)",
      "29:0411" : "29:0411 (29:0411 - Landrum Griffin Act)",
      "29:0412" : "29:0412 (29:0412 - Infringement of Rights; Members of Labor Organization)",
      "29:0440" : "29:0440 (29:0440 - Violations Reporting Requirements; Labor Organization)",
      "29:0501(b)" : "29:0501(b) (29:0501(b) - Violation of Fiduciary Responsibility)",
      "29:0621" : "29:0621 (29:621 Job Discrimination)",
      "29:0623" : "29:0623 (29:623 Job Discrimination)",
      "29:0626" : "29:0626 (29:626 Job Discrimination)",
      "29:0633" : "29:0633 (29:633 Job Discrimination)",
      "29:0651" : "29:0651 (29:651 Occupational Safety/Health)",
      "29:0660" : "29:0660 (29:0660 - Action by Sec. Labor for Discrimination re: Rights OSHA)",
      "29:0662" : "29:0662 (29:0662 - Inj. PRoceedings re: Dangerous Emp. Conditions; by Sec.)",
      "29:0666" : "29:0666 (29:0666 - Collection of Civil Penalties Under OSHA)",
      "29:0701" : "29:0701 (29:0701 Vocational Rehabilitation)",
      "29:0706" : "29:0706 (29:0706 Rehabilitation Act of 1973)",
      "29:0791" : "29:0791 (29:791 Job Discrimination (Rehabilitation Act))",
      "29:0792d2" : "29:0792d2 (29:0792(d)(2) - Accessible Facilities for Phys. Handicapped Emp.)",
      "29:0794" : "29:0794 (29:0794 Discrimination (Handicap))",
      "29:1001" : "29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)",
      "29:1002" : "29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)",
      "29:1055" : "29:1055 (29:1055 - ERISA: Employee Retirement (Joint & Survivor Annuity))",
      "29:1101" : "29:1101 (29:1101 E.R.I.S.A.)",
      "29:1104" : "29:1104 (29:1104 Recovery of Benefits to Employee)",
      "29:1109" : "29:1109 (29:1109 Breach of Fiduciary Duties)",
      "29:1131" : "29:1131 (29:1131 ERISA - Collection of Delinquent Trust Fun)",
      "29:1132" : "29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)",
      "29:1145" : "29:1145 (29:1145 E.R.I.S.A.)",
      "29:1149" : "29:1149 (29:1149 Recover Pension & Profit Sharing)",
      "29:1161" : "29:1161 (29:1161 ERISA, COBRA)",
      "29:1162" : "29:1162 (29:1162 - COBRA -- Continuation Coverage)",
      "29:1303" : "29:1303 (29:1303 - PBGC: Operation of Corporation)",
      "29:1362" : "29:1362 (29:1362 ERISA)",
      "29:1381" : "29:1381 (29:1381 E.R.I.S.A.)",
      "29:1401" : "29:1401 (29:1401(b)(2) Appeal of Arbitration Award)",
      "29:1451" : "29:1451 (29:1451 E.R.I.S.A.)",
      "29:159" : "29:159 (29:159 - Labor: Violation of Collective Bargaining Agreement)",
      "29:1612" : "29:1612 (29:1612 - FMLA: Leave Requirements)",
      "29:1801" : "29:1801 (29:1801 Farmworker Rights)",
      "29:1854" : "29:1854 (28:1854 Migrant & Seasonal Agri Worker Protect Act (AWPA))",
      "29:1916" : "29:1916 (29:1916 - Spec. Rule for Longshoremen & Harborworkers)",
      "29:2001" : "29:2001 (29:2001 Employee Polygraph Protection Act)",
      "29:2101" : "29:2101 (29:2101 Worker Adjustment and Retaining Notification Act)",
      "29:2104" : "29:2104 (29:2104 - Worker Adjustment & Retraining Notification (WARN))",
      "29:2601" : "29:2601 (29:2601 Family and Medical Leave Act)",
      "29:2611" : "29:2611 (29:2611 Family & Medical Leave Act 1993)",
      "29:2615" : "29:2615 (29:2615 Family and Medical Leave Act)",
      "29:2617" : "29:2617 (29:2617 Family and Medical Leave Act)",
      "29:790" : "29:790 (29:790 Rehabilitation of Labor)",
      "30:0022" : "30:0022 (30:0022 General Mining Law of 1872 )",
      "30:0181" : "30:0181 (30:181 Environment: Review of Agency Action)",
      "30:0801" : "30:0801 (30:0801 Penalities/Federal Mine Safety Health Act)",
      "30:0815" : "30:0815 (30:0815 Federal Mine Safety & Health Act)",
      "30:1201" : "30:1201 (30:1201 Environment: Review of Agency Action)",
      "30:1202" : "30:1202 (30:1202 Mining Reclamation Act)",
      "30:1276" : "30:1276 (30:1276 Interior: Review of Agency Action)",
      "30:1701" : "30:1701 (30:1701 Federal Oil Gas Royalty Mgt Act 1982 (FOGRMA))",
      "30:181" : "30:181 (30:181 Mineral Lands Leasing Act (MLLA))",
      "31:0732" : "31:0732 (31:0732 General Acct. Office Personnel Act of 1980)",
      "31:1341" : "31:1341 (31:1341 - Government Employee -- Limitations on Expending Monies)",
      "31:3545" : "31:3545 (31:3545 Action to Recovery Money)",
      "31:3702" : "31:3702 (31:3702 - Procedures for Settling Claims)",
      "31:3713" : "31:3713 (31:3713 - Priority of Government Claims)",
      "31:3720" : "31:3720 (31:3720 - Federal Income Tax Interceptions (Collection of Payments))",
      "31:3728" : "31:3728 (31:3728 - Setoff Against Judgment)",
      "31:3729" : "31:3729 (31:3729 - False Claims Act -- Liability)",
      "31:3730" : "31:3730 (31:3730 Qui Tam False Claims Act)",
      "31:3731" : "31:3731 (31:3731 Fraud)",
      "31:3733" : "31:3733 (31:3733(j)(2)Pet to Mod or Set Aside CV Investigative Demand)",
      "31:5314" : "31:5314 (31:5314 - Failure to Report Interest in Foreign Accounts)",
      "31:5317" : "31:5317 (31:5317 - Search and Forfeiture of Monetary Instruments)",
      "31:5320" : "31:5320 (31:5320 - Inj. or Penalty; Failure to File Foreign Currency Rpt.)",
      "31:5321" : "31:5321 (31:5321 - Penalty for Failure to Report Transportation Money)",
      "31:5332(a)" : "31:5332(a) (31:5332(a) - Evading Currency Reporting Requirement)",
      "31:5332(f)" : "31:5332(f) (31:5332(f) - Transport and Transfer US Currency From in to Out)",
      "31:6716" : "31:6716 (31:6716 - Discrimination re: Money and Finance)",
      "31:9701" : "31:9701 (31:9701 - Federal User Charge Statute)",
      "33.1301" : "33.1301 (33.1301 Clean Water Act)",
      "33:0408" : "33:0408 (33:0408 - Injury to Harbor Improvement)",
      "33:0594" : "33:0594 (33:0594 - Land Condemnation)",
      "33:0901" : "33:0901 (33:0901 - Longshoremen Harbor Workers Compensation Ace (Navigation & Navigable Waters))",
      "33:0905(b)" : "33:0905(b) (33:0905(b) - Longshoremen Workers' Compensation Act -- Recovery of Damages Caused by Negl. of V)",
      "33:0918" : "33:0918 (33:0918 - Longshore & Harbor Workers Compensation Act -- Collection of Defaulted Payments)",
      "33:0921" : "33:0921 (33:0921 - Longshore & Harborworkers Compensation Act -- Review of Compensation Orders)",
      "33:0933" : "33:0933 (33:0933 - Longshore & Harbor Workers' Compensation Act - Comp. for Injuries (Third-Party Claims)",
      "33:1221" : "33:1221 (33:1221 - Ports and Waterways Safety Program)",
      "33:1251" : "33:1251 (33:1251 - Federal Water Pollution Control Act (Clean Water Act))",
      "33:1311" : "33:1311 (33:1311 Federal Water Pollution Control Act)",
      "33:1319cw" : "33:1319cw (33:1319 Clean Water Act)",
      "33:1319pv" : "33:1319pv (33:1319 Pollutants & Permit Violations)",
      "33:1321" : "33:1321 (33:1321 - Clean Water Act -- Discharge of Hazardous Substance or Pollutants/Water)",
      "33:1342" : "33:1342 (33:1342 Federal Water Pollution Control Act)",
      "33:1361" : "33:1361 (33:1361 - Clean Water Act -- Administrator Authority)",
      "33:1364" : "33:1364 (33:1364 - Clean Water Act -- EPA Action to Restrain Pollution Endangering Health (Emergency Powers))",
      "33:1365" : "33:1365 (33:1365 Environmental Matters)",
      "33:1415" : "33:1415 (33:1415 - Marine Protection, Research, & Sanctuaries Act)",
      "33:1515" : "33:1515 (33:1515 - Deepwater Ports Act (Citizen Civil Action))",
      "33:2701" : "33:2701 (33:2701 - Oil Pollution Act of 1940)",
      "35:0001" : "35:0001 ( 35:0001 Patent Infringement)",
      "35:0032" : "35:0032 (35:0032 - Suspension From Practice Before Patent & Trade Off.)",
      "35:0101" : "35:0101 (35:0101 (35:101 Patent Infringement))",
      "35:0145" : "35:0145 (35:145 Patent Infringement)",
      "35:0146" : "35:0146 (35:0146 - Appeal From Decision of the Board of Patent Appeals)",
      "35:0183" : "35:0183 (35:183 Patent Infringement)",
      "35:0256" : "35:0256 (35:0256 (35:256 Patent Infringement))",
      "35:0271" : "35:0271 (35:271 Patent Infringement)",
      "35:0281" : "35:0281 (35:0281 - Remedy for Infringement of Patent/Jurisdiction Conferred 28:1338)",
      "35:0282" : "35:0282 (35:0282 - Patent Infringement -- Defenses)",
      "35:0283" : "35:0283 (35:0283 - Action to Enjoin Violation of Right Secured by Patent)",
      "35:0289" : "35:0289 (35:0289 - Recover Profits From Unlicensed Use of Design Patent)",
      "35:0291" : "35:0291 (35:0291 - Action for Relief Between Owners; Interferring Patents)",
      "35:0292" : "35:0292 (35:0292 - Penalty & Forfeiture; Illegal Use of Word Patent (False Marking))",
      "35:0311" : "35:0311 (35:0311 - Patent - Request for Inter Partes Reexamination)",
      "36:220501" : "36:220501 (36:220501 Olympic and Amateur Sports Act)",
      "37:3729(a)" : "37:3729(a) (Unsealed Qui Tam Case)",
      "38:1110" : "38:1110 (38:1110 - Basic Entitlements/Wartime)",
      "38:1131" : "38:1131 (38:1131 - Basic Entitlements/Peacetime)",
      "38:1681" : "38:1681 (38:1681 Recovery of VA Overpayment)",
      "38:1686" : "38:1686 (38:1686 Recovery of VA Overpayment)",
      "38:1780" : "38:1780 (38:1780 Recovery of VA Overpayment)",
      "38:1816" : "38:1816 (38:1816 Recover Liability of Home Loan Deficiency Amount)",
      "38:1965" : "38:1965 (38:1965 Servicemen's Group Life Insurance)",
      "38:1975" : "38:1975 (38:1975 Servicemembers Group Life Insurance Traumatic Injury Protection Program \"TGSLI\")",
      "38:1984" : "38:1984 (1984 - Suit For Veterans Insurance)",
      "38:2011" : "38:2011 (38:2011 - Veteran's Readjustment Assistance Act of)",
      "38:2021" : "38:2021 (38:2021 Reemployment of Inducted Persons; Benefits Protected)",
      "38:2024" : "38:2024 (38:2024 Enlisted/Active Duty Persons Rights; Reserves)",
      "38:3116" : "38:3116 (38:3116 VA Overpayment)",
      "38:3481" : "38:3481 (38:3481 - Recovery of VA Overpayment)",
      "38:3680" : "38:3680 (38:3680 - Recovery of Education Assist Allowance Overpayment)",
      "38:4212" : "38:4212 (38:4212 - Veterans Employment Emphasis Under Federal Contracts)",
      "38:4301" : "38:4301 (38:4301 Uniformed Services Employment and Reemployment Rights Act)",
      "38:4302" : "38:4302 (38:4302 Veterans Reemployment Rights Act)",
      "38:4311" : "38:4311 (38:4311 - Uniformed Service Employment or Reemployment Rights Act (USERRA) - Discrimination)",
      "38:4312" : "38:4312 (38:4312 - Rights of Inducted Persons to Reemployment)",
      "38:4323" : "38:4323 (38:4323 - USERRA -- Enforcement of Rights With Respect to State or Private Employer)",
      "38:4324" : "38:4324 (38:4324 - USERRA -- Enforcement of Rights With Respect to Federal Executive Agencies)",
      "38:5315" : "38:5315 (38:5315 Delinquent Payment of Amounts Due to US)",
      "38:5316" : "38:5316 (38:5316 - VA Overpayment)",
      "39:0403" : "39:0403 (39:0403 - Discriminatory Use of the Postal Service)",
      "39:1207" : "39:1207 (39:1207 - Review Agency Action -- Labor Disputes)",
      "39:1208(b)" : "39:1208(b) (39:1208(b) - Postal Reorganization Ace of 1970 - Suits)",
      "39:3005" : "39:3005 (39:3005 - False Representations and Lotteries)",
      "39:3007" : "39:3007 (39:3007 - Detention of Mail for Temporary Periods - Inj. Directing Retention of Incoming Mail)",
      "39:3008(e)" : "39:3008(e) (39:3008(e) - Enforce Compliance With a USPS Prohibitory Order)",
      "39:409" : "39:409 (39:409 Postal Service)",
      "40:0258" : "40:0258 (40:258(a) Public Buildings & Property: Land Condem)",
      "40:0270" : "40:0270 (40:270 Miller Act)",
      "40:1101" : "40:1101 (40:1101 - Brooks Architect -- Engineers Act)",
      "40:3131" : "40:3131 (40:3131 Miller Act)",
      "40:3142" : "40:3142 (40:3142 - Davis-Bacon Act (Prevailing Wages))",
      "40:581" : "40:581 (40:581 General Authority of Administrator of General Services)",
      "41:0351" : "41:0351 (41:0351 McNamara-O'Hara Service Contract Act 1965)",
      "41:1463" : "41:1463 (41:1463 Public Contracts: Unlawful Employment Prac)",
      "41:2102-" : "41:2102- (41:2102-2107 -- Procurement Integrity Act)",
      "41:3301" : "41:3301 (41:3301 - Competition in Contracting Act)",
      "41:6503" : "41:6503 (41:6503 - Walsh-Healy Act -- Breach of Public Contract)",
      "41:6505" : "41:6505 (41:6505 - Exclusions -- Review of Legal Questions in Contracts; Walsh-Healy Act)",
      "41:6702-" : "41:6702- (41:6702-6704 -- Service Contract Labor Standards/McNamara-O'Hara Service Contract Act 1965)",
      "41:7105(f)" : "41:7105(f) (41:7105(f) - Action to Judicially Enforce Administrative Subpoena)",
      "42:0205" : "42:0205 (42:205 Denial Social Security Benefits)",
      "42:0206" : "42:0206 (42:206 Social Security Benefits)",
      "42:0247" : "42:0247 (42:247 Personal Injury-Swine Flu)",
      "42:0254o" : "42:0254o (42:0254(o) - Breach of Scholarship Contract)",
      "42:0256" : "42:0256 (42:0256 - Public Health Services Act -- Grants)",
      "42:0274e" : "42:0274e (42:0274e National Organ Transplant Act)",
      "42:0292(f)" : "42:0292(f) (42:0292(f) - Default of Borrower)",
      "42:0292(k)" : "42:0292(k) (42:0292(k) - Student Loan Insurance (Public Health Occupations))",
      "42:0293" : "42:0293 (42:0293 - Recovery of Lossed From Loan Guarantee; Public Health)",
      "42:0294" : "42:0294 (42:0294(w) - Health Educ Assist Loan (HEAL) under Public Health Svc Act)",
      "42:0297" : "42:0297 (42:0297 - Student Loans; Public or Nonprofit School of Nursing)",
      "42:0300(f)" : "42:0300(f) (42:0300(f) - Safe Drinking Water Act (Definitions))",
      "42:0300(g)" : "42:0300(g) (42:0300(g) - Actions re: Safety of Public Water Systems (EPA))",
      "42:0300aa1" : "42:0300aa1 (42:0300(a)(a)(1) - Nat'l Childhoot Vaccine Injury Compensation Act)",
      "42:0401" : "42:0401 (42:0401 - Social Security Act -- Trust Funds)",
      "42:0402" : "42:0402 (42:402 Social Security Benefits)",
      "42:0405id" : "42:0405id (42:405 Review of HHS Decision (SSID))",
      "42:0405rs" : "42:0405rs (42:0405(r)(s) - Review of HHS Decision (RSI))",
      "42:0405si" : "42:0405si (42:405 Review of HHS Decision (RSI))",
      "42:0405wc" : "42:0405wc (42:405 Review of HHS Decision (DIWC))",
      "42:0405ww" : "42:0405ww (42:405 Review of HHS Decision (DIWW))",
      "42:0416" : "42:0416 (42:416 Denial of Social Security Benefits)",
      "42:0421(d)" : "42:0421(d) (42:0421(d) - Review of HHS Decision re: Disability Determinations)",
      "42:0423" : "42:0423 (42:0423 - Social Security Act (Disability Insurance Benefit Payments))",
      "42:0427" : "42:0427 (42:427 Social Security Benefits)",
      "42:0601" : "42:0601 (42:0601 - Title IV-A of the Social Security Act (Grants to State for Aid & Asst. to Needy Families))",
      "42:0602" : "42:0602 (42:0602 Aid to Families with Dependent Children (AFDC))",
      "42:0660" : "42:0660 (42:0660 - Action to Enforce Child Support Obligations)",
      "42:10139" : "42:10139 (42:10139 - Judicial Review of Agency Actions)",
      "42:10801" : "42:10801 (42:10801 - Protection & Advocacy for Individuals With Mental Illness Act of 1986 (PAIMI))",
      "42:10805" : "42:10805 (42:10805 Protection and Advocacy Systems)",
      "42:11001" : "42:11001 (42:11001 - Emergency Plan. & Comm. Right to Know Act (EPCRA))",
      "42:11046" : "42:11046 (42:11046 Fed Emer Plan Comm Right-to-know Act (EPCRA))",
      "42:11101" : "42:11101 (42:11101 - Health Care Quality Improvement Act of 1986)",
      "42:11112" : "42:11112 (42:11112 - Health Care Quality Improvement Act (Standards for Professional Review Actions))",
      "42:11601" : "42:11601 (42:11601 Intl Child Abduction Remedies Act (ICARA))",
      "42:11603b" : "42:11603b (42:11603(b) - Int'l. Child Abduction Remedies Act (ICARA) -- Judicial Review)",
      "42:12101" : "42:12101 (42:12101 Americans With Disabilities Act (ADA))",
      "42:12102" : "42:12102 (42:12102 - Americans With Disabilities Act (ADA) Disability Definition)",
      "42:12111" : "42:12111 (42:12111 - Americans With Disabilities Act - Employment)",
      "42:12112" : "42:12112 (42:12112 American with Disabilities Act (ADA- Discrimination))",
      "42:12117" : "42:12117 (42:12117 American With Disabilities Act (ADA))",
      "42:12131" : "42:12131 (42:12131 American with Disabilities Act (ADA- Accommodations))",
      "42:12132" : "42:12132 (42:12132 - Americans With Disabilities Act -- Discrimination)",
      "42:12134" : "42:12134 (42:12134 Americans with Disabilities Act (IDEA) Education)",
      "42:12181" : "42:12181 (42:12181 American With Disabilities Act (ADA))",
      "42:12188" : "42:12188 (42:12188 - Americans With Disabilities Act -- Civil Enforcement Actions)",
      "42:12201" : "42:12201 (42:12201 - Violation sof Title II Amer. With Disabilities Act)",
      "42:1320a7b" : "42:1320a7b (42:1320(a)(7)(b)(b)(2)(A) - Anti-Kickback Act (For Federal Health Care Programs))",
      "42:1320d-2" : "42:1320d-2 (42:1320(d)(2) - Health Insurance Portability & Accountability Act (HIPAA))",
      "42:1381(a)" : "42:1381(a) (42:1381(a) - Supplemental Security Income Benefits (SSID))",
      "42:1382" : "42:1382 (42:1382 - Eligibility for Benefits)",
      "42:1383" : "42:1383 (42:1383 Review of HHS Decision)",
      "42:1385" : "42:1385 (42:1385 - Medicare Health Act)",
      "42:1395" : "42:1395 (42:1395 - Emergency Medical Treatment & Active Labor Act)",
      "42:1395dd" : "42:1395dd (42:1395dd Emergency Medical Treatment and Active Labor Act)",
      "42:1395hr" : "42:1395hr (42:1395(h)(r) - Hospital Reimbursement for Medicare Services)",
      "42:1395w21" : "42:1395w21 (42:1395(w)(21) - Medicare Act (Eligibility, Election, & Enrollment))",
      "42:1396" : "42:1396 (42:1396 Grants to States for Medical Assistance Programs)",
      "42:1396(a)" : "42:1396(a) (42:1396(a) - State Plans for Medical Assistance)",
      "42:1396(b)" : "42:1396(b) (42:1396(b) - Medical Asst. Prgm., Pmt. to States/Medicaid Implem.)",
      "42:13981" : "42:13981 (42:13981 Civil Rights for Women Act 1994)",
      "42:1401" : "42:1401 (42:1401 - Actions by or Against U.S. Housing Authority)",
      "42:14135" : "42:14135 (42:14135 - DNA Backlog Grant Program)",
      "42:1437" : "42:1437 (42:1437 - U.S. Housing Act of 1937)",
      "42:1456" : "42:1456 (42:1456 - U.S. Housing Authority Action re: Slums/Urban Renewal)",
      "42:1471" : "42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclo)",
      "42:1475" : "42:1475 (42:1475 - Declaratory & Injunctive Relief -- Foreclosure Procedures)",
      "42:1479" : "42:1479 (42:1479 - Mortgage, Lease, Contract re: Farm Housing)",
      "42:14901" : "42:14901 (42:14901 Intercountry Adoptions)",
      "42:15483" : "42:15483 (42:15483 - Help America Vote Act)",
      "42:1651" : "42:1651 (42:1651 Defense Base Act)",
      "42:1705" : "42:1705 (42:1705 - Receipt of Workmen's Compensation Benefits)",
      "42:1971" : "42:1971 (42:1971 Voting Rights Act of 1965)",
      "42:1973" : "42:1973 (42:1973 - Voting Rights Act)",
      "42:1973(c)" : "42:1973(c) (42:1973(c) - Voting Rights -- Qualifications & Procedures)",
      "42:1973a" : "42:1973a (Enforcement of Voting Rights)",
      "42:1973gg2" : "42:1973gg2 (42:1973(g)(g)(2) - Nat'l. Voter Registration Act of 1993 (NVRA))",
      "42:1981(a)" : "42:1981(a) (42:1981(a) - Damages in Cases of Intentional Descrim. in Employment)",
      "42:1981cv" : "42:1981cv (42:1981 Civil Rights)",
      "42:1981hs" : "42:1981hs (42:1981 Housing Discrimination)",
      "42:1981jb" : "42:1981jb (42:1981 Job Discrimination)",
      "42:1981ra" : "42:1981ra (42:1981(r)(a) - Race Discrimination)",
      "42:1981sx" : "42:1981sx (42:1981 Sex Discrimination)",
      "42:1982hs" : "42:1982hs (42:1982(h)(s) - Discrimation re: Property Rights (Housing))",
      "42:1982ra" : "42:1982ra (42:1982(r)(a) - Discrimination re: Property Rights (Race))",
      "42:1982sx" : "42:1982sx (42:1982(s)(x) - Discrimination re: Property Rights (Sex))",
      "42:1983(d)" : "42:1983(d) (42:1983(d) - Civil Rights (Death))",
      "42:1983bv" : "42:1983bv (42:1983(b)(v) - Bivens -- Non Prisoner)",
      "42:1983cv" : "42:1983cv (42:1983 Civil Rights Act)",
      "42:1983cvp" : "42:1983cvp (42:1983(c)(v)(p) - Civil Rights (Personal Property))",
      "42:1983dp" : "42:1983dp (42:1983(d)(p) - Civil Right Denial of Due Process)",
      "42:1983ed" : "42:1983ed (42:1983 Civil Rights (Employment Discrimination))",
      "42:1983pr" : "42:1983pr (42:1983 Prisoner Civil Rights)",
      "42:1983vp" : "42:1983vp (42:1983(v)(p) - Violation of Due Process & Equal Protection)",
      "42:1984" : "42:1984 (Civil Rights)",
      "42:1985" : "42:1985 (42:1985 Conspiracy to Interfere with Civil Rights)",
      "42:1986" : "42:1986 (42:1986 Neglect of Duty)",
      "42:1987" : "42:1987 (42:1987 - Procesution of Violations of Certain Laws (Viol. of Sec. 1990 or 5506-5516 or 5518-5532))",
      "42:1988" : "42:1988 (42:1988 - Proceedings in Vindication of Civil Rights)",
      "42:1997" : "42:1997 (42:1997 - Institutional Persons Act of 1980)",
      "42:2000" : "42:2000 (42:2000 Job Discrimination (Gender))",
      "42:2000(b)" : "42:2000(b) (42:2000(b) - Equal Access to Public Facilities)",
      "42:2000a" : "42:2000a (42:2000a Title II Civil Rights Act 1964)",
      "42:2000a3" : "42:2000a3 (42:2000(a)(3)-(p)(a) - Discrimination, Segregation; Public Accommodation -- Inj. Relief)",
      "42:2000ad" : "42:2000ad (42:2000(a)(d) - Job Discrimination (Disability Act))",
      "42:2000ag" : "42:2000ag (42:2000 Job Discrimination (Age))",
      "42:2000bb" : "42:2000bb (42:2000bb Religious Freedom Restoration Act.)",
      "42:2000c6" : "42:2000c6 (42:2000(c)(6)-(e)(d) - Discrimination in Education)",
      "42:2000cc" : "42:2000cc (42:2000cc Religious Land Use & Institutionalized Persons Act of 2000)",
      "42:2000d" : "42:2000d (42:2000d (42:2000d Federally Assisted Programs))",
      "42:2000di" : "42:2000di (42:2000 Job Discrimination (Disability))",
      "42:2000e" : "42:2000e (42:2000e Job Discrimination (Employment))",
      "42:2000e2" : "42:2000e2 (42:2000(e)(2)-(o)(t) - Job Discrimination (Other))",
      "42:2000e2s" : "42:2000e2s (42:2000(e)(2) - (s)(h) -- Job Discrimination (Sexual Harassment))",
      "42:2000e5e" : "42:2000e5e (42:2000(s)(5) - (e)(e)(o) -- Petition to Enforce EEOC Subpoena)",
      "42:2000e9" : "42:2000e9 (42:2000e9 Petition to Enforce EEOC Subpoena)",
      "42:2000no" : "42:2000no (42:2000no Job Discrimination (National Origin))",
      "42:2000pb" : "42:2000pb (42:2000 Job Discrimination (Public Accomodations))",
      "42:2000ra" : "42:2000ra (42:2000 Job Discrimination (Race))",
      "42:2000sx" : "42:2000sx (42:2000 Job Discrimination (Sex))",
      "42:2003" : "42:2003 (42:2003 Job Discrimination)",
      "42:2005" : "42:2005 (42:2005 Review of Agency Action-HHS)",
      "42:200e2rl" : "42:200e2rl (42:2000(e)(2) - (r)(l) -- Job Discrimination (Religion))",
      "42:2210" : "42:2210 (42:2210 Indeminification & Limitation of Liability-Financial)",
      "42:2651" : "42:2651 (42:2651 Medical Care Recovery)",
      "42:2996" : "42:2996 (42:2996 - Legal Services Corporation Act)",
      "42:300g-3" : "42:300g-3 (42:300g-3 Enforcement of Drinking Water Regulations)",
      "42:3058(g)" : "42:3058(g) (42:3058(g) - Older American's Act of 1965; 42 USC 3058(g) (State Long-Term Care Ombudsman Prgm.)",
      "42:3121" : "42:3121 (42:3121 Public Works and Economic Development Act of 1965)",
      "42:3133" : "42:3133 (42:3133 - Coordination -- Grants for Public Works & Economic Development)",
      "42:3601" : "42:3601 (42:3601 Fair Housing Act)",
      "42:3604f3c" : "42:3604f3c (42:3604(f)(3)(c) - Fair Housing Amendments Act)",
      "42:3610" : "42:3610 (42:3610 - Fair Housing Act -- Administrative Enforcement; Preliminary Matters)",
      "42:3612" : "42:3612 (42:3612 - Civil Rights in Housing -- Enforcement by Secretary)",
      "42:3613" : "42:3613 (42:3613 - Action for Inj. Relief re: Deprivation of Civil Rights)",
      "42:4000" : "42:4000 (42:4000 National Flood Insurance Act)",
      "42:4001" : "42:4001 (42:4001(s)(r) - National Insurance Flood Act)",
      "42:4013" : "42:4013 (42:4013 - National Flood Insurance Act -- Nature & Limitation of Insurance Coverage)",
      "42:4053" : "42:4053 (42:4053 Breach of Insurance Contract)",
      "42:4072" : "42:4072 (42:4072 Payment of Flood Insurance Claim)",
      "42:4231" : "42:4231 (42:4231 National Environmental Policy Act (NEPA))",
      "42:425" : "42:425 (42:427 Social Security Benenfits)",
      "42:4321" : "42:4321 (42:4321 - Review of Agency Action -- Environment (Declaration of Purpose))",
      "42:4331" : "42:4331 (42:4331 National Environmental Policy Act (NEPA))",
      "42:4332" : "42:4332 (42:4332 Environmental Policy - Coop of Agency Repo)",
      "42:4721" : "42:4721 (42:4721 Intergovernmental Personnel Act)",
      "42:4821" : "42:4821 (42:4821 - Lead-Based Paint Poisoning Prevention Act (Findings & Purposes))",
      "42:4901" : "42:4901 (42:4901 - Noise Control Act of 1972 (Findings & Purposes))",
      "42:4910(c)" : "42:4910(c) (42:4910(c) - Action to Restrain Violation re: Noise Control)",
      "42:5101" : "42:5101 (42:5101 Child Abuse Prevention and Treatment Act)",
      "42:5303" : "42:5303 (42:5303 - Block Grant Act of 1974 (42 USC 5301-5321))",
      "42:5401" : "42:5401 (42:5401 Natl Mnfactrd Housing Cnstr Safety Standard Act 1974)",
      "42:5411" : "42:5411 (42:5411 - Housing Construction & Safety Standards Act -- Injunctive Relief)",
      "42:5851" : "42:5851 (42:5851 - Discrimination \"Whistle Blower\" Employee - ERA (Employee Protection))",
      "42:6101" : "42:6101 (42:6101 Age Discrimination in Federally Assisted Programs (Statement of Purpose))",
      "42:6201" : "42:6201 (42:6201 - Energy Policy & Conservation Act (Statement of Purpose))",
      "42:6393" : "42:6393 (42:6393 - Controversies Under Energy Policy & Conservation Act (Admin. Procedure & Judicial Review))",
      "42:6901en" : "42:6901en (42:6901 Environmental Cleanup Expenses)",
      "42:6901rs" : "42:6901rs (42:6901 Resource & Recovery Act)",
      "42:6928" : "42:6928 (42:6928 - Violations of Requirements of Hazardous Waste Mgmt. (Federal Enforcement))",
      "42:6961" : "42:6961 (42:6961 Federal Facilities Compliance Act)",
      "42:6972" : "42:6972 (42:6972 Resource & Recovery Act - Citizen Suit)",
      "42:6972(a)" : "42:6972(a) (42:6972(a) - Solid Waste Disposal Act - Citizen Suit)",
      "42:7192" : "42:7192 (42:7192 - Controversies Under Dept. of Energy Organization Act -- Judical Review)",
      "42:7384" : "42:7384 (42:7384 Energy Employees Occupational Illness Compensation Program Act (EEOICPA))",
      "42:7401" : "42:7401 (42:7401 Air Pollution Prevention and Control Act)",
      "42:7412" : "42:7412 (42:7412 - Air Pollution Control -- Emission Standards)",
      "42:7413" : "42:7413 (42:7413(b) Clean Air Act)",
      "42:7475" : "42:7475 (42:7475 - Clean Air Act -- Preconstruction Requirements)",
      "42:7545" : "42:7545 (42:7545 Clean Air Act)",
      "42:7603" : "42:7603 (42:7603 - Action for Immediate Restraint (Emergency Powers))",
      "42:7604" : "42:7604 (42:7604 - Clean Air Act -- Citizen Suit to Enforce Clean Air Act)",
      "42:7604cl" : "42:7604cl (42:7604 Clear Air Act (Emission Standards))",
      "42:7604ir" : "42:7604ir (42:7604 Petition to Quash IRS Summons)",
      "42:7671" : "42:7671 (42:7671 - Clean Air Act (Stratospheric Ozone Protection) (Definitions))",
      "42:8324" : "42:8324 (42:8324 - Powerplant & Industrial Fuel Use -- Terms & Conditions)",
      "42:8351" : "42:8351 (42:8351 - Powerplant & Industrial Fuel Use -- Temporary Exemptions)",
      "42:9601" : "42:9601 (42:9601 - Comprehensive Environmental Compen/Resp/Liab (CERCLA) (Definitions))",
      "42:9604" : "42:9604 (42:9604 - Comprehensive Envir., Response, Comp. & Liab. Act (CERCLA) -- Removal & Other Remedial Act)",
      "42:9607" : "42:9607 (42:9607 Real Property Tort to Land)",
      "42:9613" : "42:9613 (42:9613 Comp Environ Recovery Comp & Liability Act (CERCLA))",
      "43:0421" : "43:0421 (43:0421 - Complaint in Condemnation -- Eminent Domain)",
      "43:0945(b)" : "43:0945(b) (43:0945(b) - Complaint in Condemnation -- Easements)",
      "43:1331" : "43:1331 (43:1331 - Outer Continental Shelf Lands Act (Definitions))",
      "43:1333" : "43:1333 (43:1333 - Outer Continental Shelf Lands Act -- Laws & Regulations Governing Lands)",
      "43:1349" : "43:1349 (43:1349 - Outer Continental Land Shelf Act -- Citizen Suits)",
      "43:1701" : "43:1701 (43:1701 - Violation of Federal Land Policy & Management Act (FLPMA))",
      "43:1737" : "43:1737 (43:1737 FLPMA)",
      "43:945" : "43:945 (43:945 Compensation for Land Condemnation)",
      "43:945a" : "43:945a (43:945a Complaint in Condemnation)",
      "43:946" : "43:946 (43:946 Complaint in Condemnation - Eminent Domain)",
      "44:2107" : "44:2107 (44:2107 - Presidential Records & Materials Act (NARA Acceptance of Records for Historical Preserv.))",
      "45:0051" : "45:0051 (45:51 Railways: Fed. Employer's Liability Act)",
      "45:0056" : "45:0056 (45:0056 - Employers Liability Act - Personal Inj. re: Railroads (Bringing an Action))",
      "45:0151" : "45:0151 (45:151 Railway Labor Act)",
      "45:0152" : "45:0152 (45:0152 - Railway Labor Act -- General Duties)",
      "45:0153" : "45:0153 (45:0153 - First Railway Labor Act -- National Railroad Adjustment Board)",
      "45:0159" : "45:0159 (45:0159 - Review of Arbitration Award (RR Carriers/Mediation Bd.))",
      "45:0184" : "45:0184 (45:184 Action to Set Aside Award of a System Board)",
      "45:0231(f)" : "45:0231(f) (45:0231(f) - Compel Obedience to Order of Railroad Retirement Bd.)",
      "45:0351" : "45:0351 (45:0351 - Railroad Unemployment Insurance Act)",
      "45:0719" : "45:0719 (45:0719 - Regional Rail Reorganization Act of 1973 (Judicial Review))",
      "45:1105" : "45:1105 (45:1105 - Northeast Rail Service Act -- Judicial Review)",
      "45:1395" : "45:1395 (45:1395 Railroads: Adverse Reimbursement Review)",
      "46:0761" : "46:0761 (46:761 Shipping: Damages for Death on High Seas)",
      "46:1101" : "46:1101 (46:1101 Violation of Maritime Regulations)",
      "46:1300" : "46:1300 (46:1300 Carriage of Goods by Sea Act (COGSA))",
      "46:2114" : "46:2114 (46:2114 - Wrongful Discharge From Employment -- Protection From Discrimination)",
      "46:30101" : "46:30101 (46:30101 - Extension of Jurisdiction to Cases of Damage or Injury on Land)",
      "46:30104" : "46:30104 (46:30104 - Marine Personal Injury - Jones Act)",
      "46:30302" : "46:30302 (46:30302 - Shipping: Damages for Death on High Seas)",
      "46:30304" : "46:30304 (46:30304 - Breach of Maritime Contract -- Liability of Noncompliance)",
      "46:30503" : "46:30503 (46:30503 - Limitation of Liability -- Declaration of Nature & Value of Goods)",
      "46:30504" : "46:30504 (46:30504 - Limitation of Liability -- Loss by Fire)",
      "46:30505" : "46:30505 (46:30505-30510 - Exoneration, Limitation of Liability)",
      "46:30511" : "46:30511 (46:30511 - Action by Owner for Limitation)",
      "46:30701" : "46:30701 (46:30701 - Marine Cargo Loss or Damage -- Liability of Water Carriers)",
      "46:30704" : "46:30704 (46:30704 - Liability of Water Carriers -- Loading, Stowage, Custoey, Care, and Delivery)",
      "46:30902" : "46:30902 (46:30902-30911 - Suits in Admiralty Act)",
      "46:31102" : "46:31102 (46:31102 - Public Vessels Act -- Waiver of Immunity)",
      "46:31301" : "46:31301 (46:31301 - Federal Maritime Lien Act)",
      "46:31321" : "46:31321 (46:31321 - Foreclosure of Preferred Ship Mortgages)",
      "46:31325" : "46:31325 (46:31325 - Suit to Enforce Lien Upon Mortgaged Vessel/Foreclosure of Preferred Foreign Ship)",
      "46:31341" : "46:31341 (46:31341 - Federal Maritime Lien Act)",
      "46:31342" : "46:31342 (46:31342 - Breach of Maritime Contract (Establishing Maritime Liens))",
      "46:31343" : "46:31343 (46:31343 - Commercial Instruments & Maritime Liens)",
      "46:40101" : "46:40101 (46:40101 - Shipping Act of 1998)",
      "46:41102a" : "46:41102a (46:41102(a) - Shipping Act of 1984 -- General Prohibitions)",
      "46:41309" : "46:41309 (46:41309 - Shipping Act of 1984 -- Enforcement of Reparation Orders)",
      "46:50101" : "46:50101 (46:50101 - Violation of Maritime Regulations)",
      "46:58109" : "46:58109 (46:58109 - Violation of Merchant Marine Act -- Penalties)",
      "47:0151" : "47:0151 (47:0151 Communications Act of 1934)",
      "47:0151cs" : "47:0151cs (47:0151(c)(s) - Federal Communications Act -- Collection for Services)",
      "47:0201bt" : "47:0201bt (47:0201(b)(t) - Breach of Tariff)",
      "47:0203" : "47:0203 (47:0203 - Telecommunications Collection of Charges)",
      "47:0205" : "47:0205 (47:0205 - Waire & Radio Communication Svc. & Charges (Recovery of Damages))",
      "47:0206" : "47:0206 (47:0206 - Carrier's Liability for Damages)",
      "47:0207" : "47:0207 (47:0207 Wire and Radio Communication Svc and Charges)",
      "47:0227" : "47:0227 (47:0227 Telephone Consumer Protection Act)",
      "47:0227b3" : "47:0227b3 (47:0227(b)(3) - Telephone Consumer Protection Act of 1991)",
      "47:0251" : "47:0251 (47:0251 - Telecommunications Act of 1996 -- Interconnection)",
      "47:0252" : "47:0252 (47:0252 - Telecommunications Act)",
      "47:0254(h)" : "47:0254(h) (47:0254(h) - Children's Internet Protection Act)",
      "47:0332" : "47:0332 (47:0332 Telecommunications Act of 1996)",
      "47:0332(c)" : "47:0332(c) (47:0332(c) - Federal Telecommunications Act of 1996)",
      "47:0338" : "47:0338 (47:0338 - Satellite Home Viewer Improvement Act)",
      "47:0401" : "47:0401 (47:0401 - Application of Federal Communication Comm. for Inj. (Enforcement Provisions))",
      "47:0407" : "47:0407 (47:0407 - Order for Payment of Money; Petition for Enforcement)",
      "47:0510" : "47:0510 (47:510 Forfeiture of Communications Devices)",
      "47:0521" : "47:0521 (47:0521 Cable Consumer Protection and Competition Act 1992)",
      "47:0532" : "47:0532 (47:0532 Cable Communication Policy Act of 1984)",
      "47:0551" : "47:0551 (47:0551 Cable Communications:Protection of Subscriber Prvcy.)",
      "47:0553" : "47:0553 (47:0553 Cable Comm: Unauthorized Reception of Cable Services)",
      "47:0605" : "47:0605 (47:0605 Cable Comm:Unauthorized publication or use of comm)",
      "47:407" : "47:407 (47:407 Order for payment of money; petition for enforcement;)",
      "48:0883" : "48:0883 (48:883 Violation of US Coastal Law)",
      "49:0081" : "49:0081 (49:81 Damaged Goods While Being Transported)",
      "49:0101" : "49:0101 (49:0101 - ICC Termination Act of 1996)",
      "49:0502" : "49:0502 (49:0502 Transportation Administrative Subpoena)",
      "49:10101" : "49:10101 (49:10101 Rail Transportation)",
      "49:10501" : "49:10501 (49:10501 Rail Interstate Transportation - General Jurisdiction)",
      "49:10743" : "49:10743 (49:10743 - Revised Interstate Commerce Act)",
      "49:10903" : "49:10903 (49:10903 Filing and Procedure for Application to Abandon or Discontinue)",
      "49:11101" : "49:11101 (49:11101 Interstate Commerce Act)",
      "49:1113" : "49:1113 (49:1113 - Petition to Enforce Administrative Summon)",
      "49:1136" : "49:1136 (Aviation Disaster Family Assistance Act of 1996)",
      "49:11501" : "49:11501 (49:11501 - Railroad Revitalization & Regulatory Reform Act (General Jurisdiction))",
      "49:11502" : "49:11502 (49:11502 - Transportation)",
      "49:11701" : "49:11701 (49:11701 - General Authority of Enforcement of Regulations in Rail)",
      "49:11702" : "49:11702 (49:11702(a)(4) Violations of Interstate Commerce A)",
      "49:11705" : "49:11705 (49:11705 - Limitation on Actions by and Against Rail Carriers)",
      "49:11706" : "49:11706 (49:11706 - Carmack Amendment (Liability of Carriers Under Receipts & Bills of Lading))",
      "49:11707" : "49:11707 (49:11707 - Instructions)",
      "49:1305" : "49:1305 (49:1305 FAA Regulations)",
      "49:13101" : "49:13101 (49:13101 ICC Termination Act)",
      "49:13702" : "49:13702 (49:13702 - Tariff Requirement for Certain Transportation)",
      "49:13706" : "49:13706 (49:13706 Motor Carriers, etc-Liability for Payment of Rates)",
      "49:14501" : "49:14501 (49:14501 - Preemption (Federal Authority of Intrastate Transportation))",
      "49:14705" : "49:14705 (49:14705 - Carriers)",
      "49:14706" : "49:14706 (49:14706 Carmack Amendment to the Interstate Commerce Act)",
      "49:20301" : "49:20301 (49:20301-20306 - Federal Safety Appliance Act)",
      "49:21302" : "49:21302 (49:21302 - Carriers Violations of Interstate Comm. Act (Ch. 201 Accident & Incident Viol. & ch. 209))",
      "49:30101" : "49:30101 (49:30101 - National Traffic & Motor Vehicle Safety Act)",
      "49:30112" : "49:30112 (49:30112 - Motor Vehicle Safety (Prohibition on Non-Complying Motor Vehicles & Equip))",
      "49:30502" : "49:30502 (49:30502 - Nat'l. Motor Vehicle Title Information Syst.)",
      "49:31105" : "49:31105 (49:31105 Surface Transportation Assistance Act)",
      "49:31114" : "49:31114 (49:31114 - Access to Interstate System/Commercial Motor Vehicle)",
      "49:31502" : "49:31502 (49:31502 - Motor Carrier Safety: Requirements for Qualifications)",
      "49:32101" : "49:32101 (49:32101 - Motor Vehicle Information & Costs Savings Act)",
      "49:32701" : "49:32701 (49:32701 - Odometer Requirements Act)",
      "49:40101" : "49:40101 (49:40101 - Federal Aviation Act)",
      "49:40102" : "49:40102 (49:40102 - Airline Deregulation Act (Definitions of Air & Commerce Safety))",
      "49:40105" : "49:40105 (49:40105 - Warsaw Convention)",
      "49:41705" : "49:41705 (49:41705 - Air Carrier Access Act (Discrimination Against Handicapped Individuals))",
      "49:41713" : "49:41713 (49:41713 - Airline Deregulation Avt (Premp. of Authority Over Prices, Routes & Service))",
      "49:44709" : "49:44709 (49:44709 - Noise Control Act of 1972)",
      "49:44715" : "49:44715 (49:44715 - Noise Control Act of 1972)",
      "49:46507" : "49:46507 (49:46507 - False Information & Threats)",
      "49:47101" : "49:47101 (49:47101 - Airport & Airway Improvement Act)",
      "49:47501" : "49:47501 (49:47501 - Aviation Safety & Noise Abatement Act of 1979)",
      "49:49101" : "49:49101 (49:49101 - Wrongful Termination in Contravention of Published Regulations)",
      "49:49104" : "49:49104 (49:49104 - Breach of Lease by Metro Wash. Airport Authority)",
      "49:60101" : "49:60101 (49:60101 Pipeline Safety Act of 1994)",
      "49:60102" : "49:60102 (49:60102 - Hazardous Liquid Pipeline Safety Act of 1979 (HLPSA))",
      "49:80102" : "49:80102 (49:80102 - Bills of Lading -- Application)",
      "49:80302" : "49:80302 (49:80302 - Contraband - Prohibitions)",
      "49:80303" : "49:80303 (49:80303 - Seizure & Forfeiture of Vessel or Aircraft Conveying Contraband)",
      "50(a):0001" : "50(a):0001 (50(a):0001 - Trading With the Enemy Act (Act in Title 50 Appendix))",
      "50(a):0533" : "50(a):0533 (50(a):0533 - Servicemenbers Civil Relief Act -- Mortgages (In Title 50 Appendix))",
      "50(a):0540" : "50(a):0540 (50(a):0540 - Sailors & Soldiers Civil Relief Act (In Title 50 Appendix))",
      "50(a):2412" : "50(a):2412 (50(a):2412 - Export Administration Act - 1979 (In Title 50 Appendix))",
      "50:0501" : "50:0501 (50:0501: Soldiers and Sailors Civil Relief Act of 1940)",
      "50:1701-06" : "50:1701-06 (50:1701-1706 -- International Emergency Economic Powers Act)",
      "51:20137a" : "51:20137a (51:20137(a) - Malpractice & Negligence Against U.S. Space Program)",
      "BR9020" : "BR9020 (BR9020 Bankruptcy Rule 9020)",
      "bj" : "bj (bk Execution of Bankruptcy Judgments)",
      "misc" : "misc (Civil Miscellaneous Case)",
      "rj" : "rj (Registration of Foreign Judgments)"
   },
   "ctdce" : {
      "0" : "0 (No cause code entered)",
      "02:0431" : "02:0431 (02:431 Fed. Election Commission: Failure Enforce C)",
      "02:0437" : "02:0437 (02:437 Federal Election Commission)",
      "05:0075" : "05:0075 (05:75(2) Contract - Reduction in Grade)",
      "05:0551" : "05:0551 (05:551 Administrative Procedure Act)",
      "05:0552fi" : "05:0552fi (05:552 Freedom of Information Act)",
      "05:0552pa" : "05:0552pa (05:552 Right to Privacy Act)",
      "05:0554" : "05:0554 (05:0554 Constitutionality of Maritime Statutes)",
      "05:0701" : "05:0701 (05:0701 Maritime Subsidy Board)",
      "05:0702" : "05:0702 (05:702 Administrative Procedure Act)",
      "05:0704" : "05:0704 (05:704 Labor Litigation)",
      "05:7703" : "05:7703 (05:7703 Discrimination - Review of Agency Act)",
      "05:8470" : "05:8470 (05:8470 Enforcement of Judgment against Retirement Benefits)",
      "07:0006" : "07:0006 (7:6(b) Federal Commodity Exchange Regulation)",
      "07:0025" : "07:0025 (7:25 Fraud - Commodities Leverage Contracts)",
      "07:0181" : "07:0181 (07:181 Packers & Stockyard Act)",
      "07:0499" : "07:0499 (07:499 Agricultural Commodities Act)",
      "07:0601" : "07:0601 (07:601 USDA Condemnation)",
      "07:2321" : "07:2321 (07:2321 Plant Variety Protection Act)",
      "08:1105" : "08:1105 (8:1105(a) Aliens: Habeas Corpus to Release INS Det)",
      "08:1182" : "08:1182 (8:1182 Defend. Denial of Pla. Appl. for Alien Employment Cer)",
      "08:1252" : "08:1252 (08:1252(a)(2) Injunction for Deportation)",
      "08:1260" : "08:1260 (08:1260 Aliens: Access to Records)",
      "08:1324" : "08:1324 (08:1324 Aliens: Complaint for Forfeiture)",
      "08:1329" : "08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petiti)",
      "08:1446" : "08:1446 (8:1446 Petition for Naturalization Hearing)",
      "08:1451(j)" : "08:1451(j) (8:1451(j) Motion to Correct Order & Judg. of Naturalization)",
      "09:0001" : "09:0001 (09:1 U.S. Arbitration Act)",
      "09:0009" : "09:0009 (9:9 Motion to Confirm Arbitration Award)",
      "09:0010" : "09:0010 (09:0010 Petition to Vacate Arbitration Award)",
      "10:1408" : "10:1408 (10:1408 Claim for Military Retirement)",
      "10:1552" : "10:1552 (10:1552 Armed Forces: Action to Correct Records)",
      "10:1553" : "10:1553 (10:1553 Armed Forces: FOIA General)",
      "10:2305" : "10:2305 (10:2305 Review of Federal Contract)",
      "11:0101" : "11:0101 (11:101 Bankruptcy)",
      "12:0022" : "12:0022 (12:22 Securities Fraud)",
      "12:0635" : "12:0635 (12:635 Breach of Insurance Contract)",
      "12:1461" : "12:1461 (12:1461 Homeowners Loan Act)",
      "12:1464" : "12:1464 (12:1464 Federal Savings and Loan)",
      "12:1703" : "12:1703 (12:1703 Default of HUD Loan)",
      "12:1725" : "12:1725 (12:1725 Collection under Contract Guaranty)",
      "12:1730" : "12:1730 (12:1730 Collection Under Contract Guaranty)",
      "12:1819" : "12:1819 (12:1819 Default of Promissory Note)",
      "12:1819COS" : "12:1819COS (12:1819 Default of Promisory Note)",
      "12:1819Fdi" : "12:1819Fdi (Default by Promissary Note)",
      "12:1821" : "12:1821 (12:1821 Default of Loan by Promissary Note)",
      "12:191" : "12:191 (12:191 Bank Foreclosure)",
      "12:192" : "12:192 (12:192 Liquidation of National Bank)",
      "12:1971" : "12:1971 (12:1971 Relief under Bank Holding Act)",
      "12:1972" : "12:1972 (12:1972 Typing Arrangement Act)",
      "12:3410" : "12:3410 (12:3410 Right to Financial Privacy Act)",
      "15:0001" : "15:0001 (15:1 Antitrust Litigation)",
      "15:0002at" : "15:0002at (15:2 Antitrust Litigation)",
      "15:0002fl" : "15:0002fl (15:2(a) Fair Labor Standards Act)",
      "15:0005" : "15:0005 (15:5(a) Fair Labor Standards Act)",
      "15:0015" : "15:0015 (15:15 Antitrust Litigation)",
      "15:0025" : "15:0025 (15:25 Clayton Act)",
      "15:0044" : "15:0044 (15:44 Trademark Infringement)",
      "15:0045" : "15:0045 (15:0045 Federal Trade Commission Act)",
      "15:0052" : "15:0052 (15:0052 Federal Trade Commission Act)",
      "15:0053" : "15:0053 (15:0053 Federal Trade Commission Act)",
      "15:0077" : "15:0077 (15:77 Securities Fraud)",
      "15:0078" : "15:0078 (15:78m(a) Securities Exchange Act)",
      "15:0078COL" : "15:0078COL (15:78m(a) Securities Exchange Act)",
      "15:0631" : "15:0631 (15:631 Small Business Act)",
      "15:0717" : "15:0717 (15:717 Natural Gas Act)",
      "15:0754" : "15:0754 (15:754 Emergency Petroleum Allocation-Admin.& Enforcement)",
      "15:1051" : "15:1051 (15:1051 Trademark Infringement)",
      "15:1114" : "15:1114 (15:1114 Trademark Infringement)",
      "15:1121" : "15:1121 (15:1121 Trademark Infringement)",
      "15:1125" : "15:1125 (15:1125 Trademark Infringement (Lanham Act))",
      "15:1126" : "15:1126 (15:1126 Patent Infringement)",
      "15:1127" : "15:1127 (15:1127 Trademark Infringement)",
      "15:1601" : "15:1601 (15:1601 Truth in Lending)",
      "15:1640" : "15:1640 (15:1640 Truth in Lending)",
      "15:1681" : "15:1681 (15:1681 Fair Credit Reporting Act)",
      "15:1692" : "15:1692 (15:1692 Fair Debt Collection Act)",
      "15:1938" : "15:1938 (15:1938 Fair Labor Standards Act)",
      "15:1981" : "15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))",
      "15:1988" : "15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))",
      "15:1989" : "15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))",
      "15:2301" : "15:2301 (15:2301 Magnuson-Moss Warranty Act)",
      "15:2801" : "15:2801 (15:2801 Petroleum Marketing Practices Act)",
      "16:0668" : "16:0668 (16:668 Bald Eagle Protection Act)",
      "16:0703" : "16:0703 (16:703 Migratory Bird Act)",
      "16:1538" : "16:1538 (16:1538 Endangered Species Act)",
      "16:3371" : "16:3371 (16:3371 Wildlife Under the Lacey Act)",
      "16:3372" : "16:3372 (16:3372 Conservation: Complaint for Forfeiture)",
      "16:3373" : "16:3373 (16:3373 Appeal of Decision - DOI)",
      "16:3374" : "16:3374 (16:3374 Conservation: Complaint for Forfeiture)",
      "17:0101" : "17:0101 (17:101 Copyright Infringement)",
      "17:0501" : "17:0501 (17:501 Copyright Infringement)",
      "17:0504" : "17:0504 (17:504 Copyright Infringement)",
      "18:0241" : "18:0241 (18:241 Conspiracy Against Citizen Rights)",
      "18:1451j" : "18:1451j (8:1451j Motion to Correct Order & Judg. of Naturalization)",
      "18:1514" : "18:1514 (18:1514 Civil action to restrain harassment of a victim or witness)",
      "18:1514A" : "18:1514A (18:1514A Motion for Protective Order)",
      "18:1836a" : "18:1836a (18:1836(a) Injunction against Misappropriation of Trade Secrets)",
      "18:1836b" : "18:1836b (18:1836(b) Civil Action to Protect Trade Secrets)",
      "18:1961" : "18:1961 (18:1961 Racketeering (RICO) Act)",
      "18:1962" : "18:1962 (18:1962 Racketeering (RICO) Act)",
      "18:1964" : "18:1964 (18:1964 Racketeering (RICO) Act)",
      "18:2511" : "18:2511 (18:2511 Wiretapping)",
      "18:3114" : "18:3114 (18:3114 Motion for Return of Seized Property)",
      "18:4208" : "18:4208 (18:4208(B) Agency Action Review)",
      "19:1305" : "19:1305 (19:1305 Custom Duties:0Forfeiture-Immoral Articles)",
      "20:1080" : "20:1080 (20:1080 Student Loan Recovery)",
      "20:1400" : "20:1400 (20:1400 Civil Rights of Handicapped Child)",
      "20:1401" : "20:1401 (20:1401 Education: Handicapped Child Act)",
      "21:0841" : "21:0841 (21:841 Forfeiture Property-Drugs)",
      "21:0881" : "21:0881 (21:881 Forfeiture Property-Drugs)",
      "21:0881a" : "21:0881a (21:881 Forfeiture Property - Aircraft)",
      "21:0881re" : "21:0881re (21:881 Forfeiture Property - Real Estate)",
      "23:0134" : "23:0134 (23:134 P.I.- Auto Negligence)",
      "23:1441" : "23:1441 (23:1441 Contract Real Estate)",
      "24:1000" : "24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)",
      "25:0640" : "25:0640 (25:640 Indian Tribal Rights)",
      "25:1901" : "25:1901 (25:1901 Indian Child Welfare Act)",
      "26:6212" : "26:6212 (26:6212 Injunctive Relief from IRS Lien)",
      "26:6213" : "26:6213 (26:6213 Injunctive Relief from IRS Lien)",
      "26:6502" : "26:6502 (26:6502 IRS:Enforcement of tax liens)",
      "26:6532" : "26:6532 (26:6532 IRS: Refund of Tax Penalty)",
      "26:6702" : "26:6702 (26:6702 IRS: Refund of Income Tax Penalty)",
      "26:6703" : "26:6703 (26:6703 IRS: Refund of Tax Penalty)",
      "26:7401" : "26:7401 (26:7401 IRS: Tax Liability)",
      "26:7402" : "26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)",
      "26:7403" : "26:7403 (26:7403 Suit to Enforce Federal Tax Lien)",
      "26:7422rt" : "26:7422rt (26:7422 IRS: Refund Taxes)",
      "26:7422rx" : "26:7422rx (26:7422 IRS: Refund Excise Tax)",
      "26:7426" : "26:7426 (26:7426 IRS: Wrongful Levy for Taxes)",
      "26:7429" : "26:7429 (26:7429 IRS: Tax Jeopardy Assessment)",
      "26:7609" : "26:7609 (26:7609 IRS: Petition to Quash IRS Summons)",
      "27:0185" : "27:0185 (27:185 Enforcement of Arbitration Award)",
      "28:0157c" : "28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)",
      "28:0157d" : "28:0157d (28:0157 Motion for Withdrawal of Reference)",
      "28:0158" : "28:0158 (28:0158 Notice of Appeal re Bankruptcy Matter)",
      "28:0185" : "28:0185 (28:185 Suit to Compel Arbitration)",
      "28:0451" : "28:0451 (28:451 Employment Discrimination)",
      "28:0754" : "28:0754 (28:754 Receiver of Property in Different Districts)",
      "28:0794" : "28:0794 (28:794 Rehabilitation Act)",
      "28:1001" : "28:1001 (28:1001 E.R.I.S.A.)",
      "28:1132" : "28:1132 (28:1132 E.R.I.S.A.)",
      "28:1330" : "28:1330 (28:1330 Breach of Contract)",
      "28:1331" : "28:1331 (28:1331 Fed. Question)",
      "28:1331al" : "28:1331al (28:1331 Fed. Question: Airline Crash)",
      "28:1331at" : "28:1331at (28:1331 Fed. Question: Anti-trust)",
      "28:1331au" : "28:1331au (28:1331 Fed. Question: Auto Negligence)",
      "28:1331b" : "28:1331b (28:1331 Federal Question: Bivens Act)",
      "28:1331bc" : "28:1331bc (28:1331 Fed. Question: Breach of Contract)",
      "28:1331ca" : "28:1331ca (28:1331 Fed Question: Fed Communications Act of 1)",
      "28:1331cm" : "28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)",
      "28:1331cv" : "28:1331cv (28:1331 Federal Question: Other Civil Rights)",
      "28:1331ed" : "28:1331ed (28:1331 Fed. Question: Employment Discrimination)",
      "28:1331ej" : "28:1331ej (28:1331 Federal Question: Enforcement of Judgment)",
      "28:1331es" : "28:1331es (28:1331 Enforcement of Administrative Subpoena)",
      "28:1331fl" : "28:1331fl (28:1331 Fed. Question: Fair Labor Standards)",
      "28:1331in" : "28:1331in (28:1331 Fed. Question: Insurance Contract)",
      "28:1331mm" : "28:1331mm (28:1331 Fed. Question: Medical Malpractice)",
      "28:1331ng" : "28:1331ng (28:1331 Fed. Question: Natural Gas Act)",
      "28:1331pi" : "28:1331pi (28:1331 Fed. Question: Personal Injury)",
      "28:1331rd" : "28:1331rd (28:1331 Fed. Question: Review Agency Decision)",
      "28:1331rp" : "28:1331rp (28:1331(a) Fed. Question: Real Property)",
      "28:1331rr" : "28:1331rr (28:1331 Fed. Question: Railway Labor Act)",
      "28:1331sv" : "28:1331sv (28:1331 Fed. Question: Securities Violation)",
      "28:1331tr" : "28:1331tr (28:1331 Fed. Question: Trademark)",
      "28:1331tt" : "28:1331tt (28:1331 Fed. Question: Tort Action)",
      "28:1331v" : "28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendme)",
      "28:1331wl" : "28:1331wl (28:1331 Federal Question: EPA Waste Lien)",
      "28:1331wt" : "28:1331wt (28:1331 Fed. Question: Water Rights)",
      "28:1332ac" : "28:1332ac (28:1332 Diversity-Account Receivable)",
      "28:1332al" : "28:1332al (28:1332 Diversity-Airline Crash)",
      "28:1332as" : "28:1332as (28:1332 Diversity-Asbestos Litigation)",
      "28:1332au" : "28:1332au (28:1332 Diversity-Auto Negligence)",
      "28:1332bc" : "28:1332bc (28:1332 Diversity-Breach of Contract)",
      "28:1332co" : "28:1332co (28:1332 Diversity-Conversion)",
      "28:1332ct" : "28:1332ct (28:1332 Diversity-(Citizenship))",
      "28:1332det" : "28:1332det (28:1332 Diversity: Forcible Detainer)",
      "28:1332df" : "28:1332df (28:1332 Diversity-Contract Default)",
      "28:1332ds" : "28:1332ds (28:1332 Diversity-Contract Dispute)",
      "28:1332ed" : "28:1332ed (28:1332 Diversity-Employment Discrimination)",
      "28:1332fd" : "28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)",
      "28:1332fr" : "28:1332fr (28:1332 Diversity-Fraud)",
      "28:1332ia" : "28:1332ia (28:1332 Diversity-Interpleader Action)",
      "28:1332ij" : "28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)",
      "28:1332in" : "28:1332in (28:1332 Diversity-Insurance Contract)",
      "28:1332jd" : "28:1332jd (28:1332 Diversity-Declaratory Judgment)",
      "28:1332lb" : "28:1332lb (28:1332 Diversity-Libel,Assault,Slander)",
      "28:1332lm" : "28:1332lm (28:1332 Diversity - Legal Malpractice)",
      "28:1332ma" : "28:1332ma (28:1332 Diversity-Miller Act)",
      "28:1332mm" : "28:1332mm (28:1332 Diversity-Medical Malpractice)",
      "28:1332mv" : "28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)",
      "28:1332ni" : "28:1332ni (28:1332 Diversity-Negotiable Instrument)",
      "28:1332nm" : "28:1332nm (28:1332 Diversity-Non-Motor Vehicle)",
      "28:1332nr" : "28:1332nr (28:1332 Diversity-Notice of Removal)",
      "28:1332oc" : "28:1332oc (28:1332 Diversity-Other Contract)",
      "28:1332pd" : "28:1332pd (28:1332 Diversity-Property Damage)",
      "28:1332pi" : "28:1332pi (28:1332 Diversity-Personal Injury)",
      "28:1332pl" : "28:1332pl (28:1332 Diversity-Product Liability)",
      "28:1332pr" : "28:1332pr (28:1332 Diversity-Petition for Removal)",
      "28:1332qt" : "28:1332qt (28:1332 Diversity-Petition to Quiet Title)",
      "28:1332ri" : "28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)",
      "28:1332sa" : "28:1332sa (28:1332 - Diversity: Securities & Exchange Commiss)",
      "28:1332sf" : "28:1332sf (28:1332 - Diversity: Securities Fraud)",
      "28:1332ss" : "28:1332ss (28:1332 Diversity - Stockholders Suits)",
      "28:1332tl" : "28:1332tl (28:1332 Diversity-Torts to Land)",
      "28:1332tm" : "28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))",
      "28:1332tn" : "28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)",
      "28:1332wd" : "28:1332wd (28:1332 Diversity-Wrongful Death)",
      "28:1333" : "28:1333 (28:1333 Admiralty)",
      "28:1334" : "28:1334 (28:1334 Bankruptcy Appeal)",
      "28:1334c" : "28:1334c (28:1334(c) R&R re motions for abstention (non-cor)",
      "28:1335" : "28:1335 (28:1335 Interpleader Action)",
      "28:1337" : "28:1337 (28:1337 Sherman-Clayton Act)",
      "28:1338cp" : "28:1338cp (28:1338 Copyright Infringement)",
      "28:1338pt" : "28:1338pt (28:1338 Patent Infringement)",
      "28:1338tr" : "28:1338tr (28:1338 Trademark Infringement)",
      "28:1340" : "28:1340 (28:1340 IRS: Custom Duties)",
      "28:1340er" : "28:1340er (28:1340 Recovery of Erroneous Refund)",
      "28:1341" : "28:1341 (28:1341 Complaint for Forfeiture)",
      "28:1343" : "28:1343 (28:1343 Violation of Civil Rights)",
      "28:1345" : "28:1345 (28:1345 USA Plaintiff)",
      "28:1345co" : "28:1345co (28:1345 Replevin & Conversion)",
      "28:1345db" : "28:1345db (28:1345 Debt to US - FHA/HUD Title I)",
      "28:1345df" : "28:1345df (28:1345 Default of Promissory Note)",
      "28:1345er" : "28:1345er (28:1345 Recovery of Erroneous Refund)",
      "28:1345fc" : "28:1345fc (28:1345 Foreclosure)",
      "28:1345ff" : "28:1345ff (28:1345 Complaint for Forfeiture)",
      "28:1345hl" : "28:1345hl (28:1345 VA Home Loan Guaranty Debt)",
      "28:1345mc" : "28:1345mc (28:1345 Medical Care Recovery)",
      "28:1345mi" : "28:1345mi (28:1345 Mining Claim Ejectment)",
      "28:1345pd" : "28:1345pd (28:1345 Property Damage)",
      "28:1345pe" : "28:1345pe (28:1345 Property Ejectment)",
      "28:1345rc" : "28:1345rc (28:1345 Recovery of Debt to US)",
      "28:1345st" : "28:1345st (28:1345 Default of Student Loan)",
      "28:1345tp" : "28:1345tp (28:1345 Trespass on Public Land)",
      "28:1345va" : "28:1345va (28:1345 Recovery of VA Overpayment)",
      "28:1346bc" : "28:1346bc (28:1346 Breach of Contract)",
      "28:1346rc" : "28:1346rc (28:1346 Recovery of IRS Tax)",
      "28:1346tc" : "28:1346tc (28:1346 Tort Claim)",
      "28:1346wd" : "28:1346wd (28:1346 Wrongful Death)",
      "28:1349" : "28:1349 (28:1348 Corporation organized under Federal Law as party)",
      "28:1352" : "28:1352 (28:1352 Miller Act)",
      "28:1355" : "28:1355 (28:1355 Petition for Return of Property)",
      "28:1358" : "28:1358 (28:1358 Land Condemnation)",
      "28:1361" : "28:1361 (28:1361 Petition for Writ of Mandamus)",
      "28:1362ic" : "28:1362ic (28:1362 Indian Tribal Controversy)",
      "28:1362iw" : "28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)",
      "28:1364" : "28:1364 (28:1364 Auto Negligence)",
      "28:1391" : "28:1391 (28:1391 Venue)",
      "28:1402" : "28:1402 (28:1402 Medical Malpractice)",
      "28:1407" : "28:1407 (28:1407 Airline Crash)",
      "28:1441ac" : "28:1441ac (28:1441 Petition for Removal- Account Receivable)",
      "28:1441al" : "28:1441al (28:1441 Petition for Removal- Airline Crash)",
      "28:1441as" : "28:1441as (28:1441 Petition for Removal- Asbestos Litigation)",
      "28:1441au" : "28:1441au (28:1441 Petition for Removal- Auto Negligence)",
      "28:1441bc" : "28:1441bc (28:1441 Petition for Removal- Breach of Contract)",
      "28:1441cv" : "28:1441cv (28:1441 Petition for Removal- Civil Rights Act)",
      "28:1441df" : "28:1441df (28:1441 Petition for Removal- Contract Default)",
      "28:1441dj" : "28:1441dj (28:1441 Petition for Removal- Declaratory Judgemen)",
      "28:1441ds" : "28:1441ds (28:1441 Petition for Removal- Contract Dispute)",
      "28:1441ed" : "28:1441ed (28:1441 Petition for Removal - Employment Discrim)",
      "28:1441fc" : "28:1441fc (28:1441 Petition for Removal - Fair Credit Reporti)",
      "28:1441fr" : "28:1441fr (28:1441 Petition for Removal- Fraud)",
      "28:1441ij" : "28:1441ij (28:1441 Petition for Removal- Injunctive/Declarato)",
      "28:1441in" : "28:1441in (28:1441 Petition for Removal- Insurance Contract)",
      "28:1441int" : "28:1441int (28:1441 Petition for Removal- Action for Interplea)",
      "28:1441lb" : "28:1441lb (28:1441 Petition for Removal Libel,Assault,Slander)",
      "28:1441lm" : "28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relatio)",
      "28:1441mm" : "28:1441mm (28:1441 Petition for Removal- Medical Malpractice)",
      "28:1441ni" : "28:1441ni (28:1441 Petition for Removal- Negotiable Instrumen)",
      "28:1441nm" : "28:1441nm (28:1441 Petition for Removal- Non-Motor Vehicle)",
      "28:1441nr" : "28:1441nr (28:1441 Notice of Removal)",
      "28:1441oc" : "28:1441oc (28:1441 Petition For Removal--Other Contract)",
      "28:1441pd" : "28:1441pd (28:1441 Petition for Removal- Property Damage)",
      "28:1441pi" : "28:1441pi (28:1441 Petition for Removal- Personal Injury)",
      "28:1441pl" : "28:1441pl (28:1441 Petition for Removal- Product Liability)",
      "28:1441pr" : "28:1441pr (28:1441 Petition for Removal)",
      "28:1441qt" : "28:1441qt (28:1441 Petition for Removal- Petition to Quiet Ti)",
      "28:1441ri" : "28:1441ri (28:1441 Petition for Removal- Racketeering (RICO))",
      "28:1441sa" : "28:1441sa (28:1441 - Petition for Removal: SEC Act)",
      "28:1441sf" : "28:1441sf (28:1441 - Petition for Removal: Securities Fraud)",
      "28:1441tl" : "28:1441tl (28:1441 Petition for Removal- Torts to Land)",
      "28:1441tm" : "28:1441tm (28:1441 Petition for Removal- Tort/Motor Vehicle ()",
      "28:1441tn" : "28:1441tn (28:1441 Petition for Removal- Tort/Non-Motor Vehic)",
      "28:1441wd" : "28:1441wd (28:1441 Petition for Removal- Wrongful Death)",
      "28:1442bc" : "28:1442bc (28:1442 Petition for Removal- Breach of Contract)",
      "28:1442nr" : "28:1442nr (28:1442 Notice of Removal)",
      "28:1442pr" : "28:1442pr (28:1442 Petition for Removal)",
      "28:1443" : "28:1443 (28:1443(1) Rent, Lease & Ejectment)",
      "28:1444" : "28:1444 (28:1444 Petition for Removal- Foreclosure)",
      "28:1446in" : "28:1446in (28:1446 Breach of Contract- Insurance)",
      "28:1446nr" : "28:1446nr (28:1446 Notice of Removal)",
      "28:1446pd" : "28:1446pd (28:1446 Petition for Removal- Property Damage (P.I)",
      "28:1446pi" : "28:1446pi (28:1446 Petition for Removal- Personal Injury)",
      "28:1446pl" : "28:1446pl (28:1446pl Petition for Removal - Product Liability)",
      "28:1446pr" : "28:1446pr (28:1446 Petition for Removal)",
      "28:1452" : "28:1452 (28:1452 Removal of Claim in Civil Action Related to BK. Case)",
      "28:1651" : "28:1651 (28:1651 Petition for Writ of Coram Nobis)",
      "28:1651hc" : "28:1651hc (28:1651 Petition for Writ of Habeas Corpus)",
      "28:1651mn" : "28:1651mn (28:1651 Petition for Writ of Mandamus)",
      "28:1782" : "28:1782 (28:1782 Letter rogatory - appointment)",
      "28:1983" : "28:1983 (28:1983 Civil Rights)",
      "28:2201" : "28:2201 (28:2201 Constitutionality of State Statute(s))",
      "28:2201dj" : "28:2201dj (28:2201 Declaratory Judgment)",
      "28:2201ij" : "28:2201ij (28:2201 Injunction)",
      "28:2201in" : "28:2201in (28:2201 Declaratory Judgement (Insurance))",
      "28:2241" : "28:2241 (28:2241 Petition for Writ of Habeas Corpus (federal))",
      "28:2254" : "28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))",
      "28:2254se" : "28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)",
      "28:2255" : "28:2255 (28:2255 Motion to Vacate / Correct Illegal Sentence)",
      "28:2271" : "28:2271 (28:2271 Federal Tort Claims Act)",
      "28:2345" : "28:2345 (28:2345 Medicare Recovery)",
      "28:2409" : "28:2409 (28:2409(a) Quiet Title Action)",
      "28:2410" : "28:2410 (28:2410 Quiet Title)",
      "28:2671" : "28:2671 (28:2671 Federal Tort Claims Act)",
      "28:2674" : "28:2674 (28:2674 Federal Tort Claims Act)",
      "28:7402" : "28:7402 (28:7402 Refund of Taxes)",
      "28:7422" : "28:7422 (28:7422 Appeal from Administrative Decision)",
      "29:0151" : "29:0151 (29:151 Labor: Review of Agency Action)",
      "29:0160" : "29:0160 (29:160(1) National Labor Relations Act)",
      "29:0184" : "29:0184 (29:184 Violation Collection Bargain Agreement)",
      "29:0185ep" : "29:0185ep (29:185 Employee Pension Plan)",
      "29:0185lm" : "29:0185lm (29:185 Labor/Mgt. Relations (Contracts))",
      "29:0201do" : "29:0201do (29:201 Denial of Overtime Compensation)",
      "29:0201fl" : "29:0201fl (29:201 Fair Labor Standards Act)",
      "29:0203" : "29:0203 (29:203 Equal Pay Act)",
      "29:0206" : "29:0206 (29:206 Collect Unpaid Wages)",
      "29:0401" : "29:0401 (29:0401 Labor Management Disclosure Act)",
      "29:0621" : "29:0621 (29:621 Job Discrimination (Age))",
      "29:0623" : "29:0623 (29:623 Job Discrimination (Age))",
      "29:0626" : "29:0626 (29:626 Job Discrimination (Age))",
      "29:0633" : "29:0633 (29:633 Job Discrimination (Age))",
      "29:0651" : "29:0651 (29:651 Occupational Safety/Health)",
      "29:0754" : "29:0754 (29:754 Discrimination)",
      "29:0791" : "29:0791 (29:791 Job Discrimination (Rehabilitation Act))",
      "29:0794" : "29:0794 (29:0794 Job Discrimination (Handicap))",
      "29:1001" : "29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)",
      "29:1002" : "29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)",
      "29:1104" : "29:1104 (29:1104 Recovery of Benefits to Employee)",
      "29:1109" : "29:1109 (29:1109 Breach of Fiduciary Duties)",
      "29:1131" : "29:1131 (29:1131 ERISA - Collection of Delinquent Trust Fun)",
      "29:1132" : "29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)",
      "29:1145" : "29:1145 (29:1145 E.R.I.S.A.)",
      "29:1149" : "29:1149 (29:1149 Recover Pension & Profit Sharing)",
      "29:1337" : "29:1337 (29:1337 E.R.I.S.A.)",
      "29:1362" : "29:1362 (29:1362 ERISA)",
      "29:1381" : "29:1381 (29:1381 E.R.I.S.A.)",
      "29:1401" : "29:1401 (29:1401(b)(2) Appeal of Arbitration Award)",
      "29:1451" : "29:1451 (29:1451 E.R.I.S.A.)",
      "29:1801" : "29:1801 (29:1801 Farmworker Rights)",
      "29:2601" : "29:2601 (29:2601 Family & Medical Leave Act)",
      "29:2612" : "29:2612 (29:2612 Family & Medical Leave Act)",
      "29:2615" : "29:2615 (29:2615 Family & Medical Leave Act)",
      "29:790" : "29:790 (29:790 Rehabilitation of Labor)",
      "30:0181" : "30:0181 (30:181 Environment: Review of Agency Action)",
      "30:0801" : "30:0801 (30:0801 Penalities/Federal Mine Safety Health Act)",
      "30:1201" : "30:1201 (30:1201 Environment: Review of Agency Action)",
      "30:1202" : "30:1202 (30:1202 Mining Reclamation Act)",
      "30:1276" : "30:1276 (30:1276 Interior: Review of Agency Action)",
      "31:3545" : "31:3545 (31:3545 Action to Recovery Money)",
      "31:3729" : "31:3729 (31:3729 False Claims Act)",
      "31:3730" : "31:3730 (31:3730 Qui Tam False Claims Act)",
      "31:3731" : "31:3731 (31:3731 Fraud)",
      "33:1319cw" : "33:1319cw (33:1319 Clean Water Act)",
      "33:1319pv" : "33:1319pv (33:1319 Pollutants & Permit Violations)",
      "33:1365" : "33:1365 (33:1365 Environmental Matters)",
      "35:0145" : "35:0145 (35:145 Patent Infringement)",
      "35:0183" : "35:0183 (35:183 Patent Infringement)",
      "35:0271" : "35:0271 (35:271 Patent Infringement)",
      "38:1681" : "38:1681 (38:1681 Recovery of VA Overpayment)",
      "38:1686" : "38:1686 (38:1686 Recovery of VA Overpayment)",
      "38:1780" : "38:1780 (38:1780 Recovery of VA Overpayment)",
      "38:2011" : "38:2011 (38:2011 - Veteran's Readjustment Assistance Act of)",
      "38:2021" : "38:2021 (Right to re-employment of inducted persons)",
      "38:3116" : "38:3116 (38:3116 VA Overpayment)",
      "38:4301" : "38:4301 (38:4301-4335 Uniformed Services Employment and Reemployment Rights Act (USERRA))",
      "38:775" : "38:775 (Recovery of Servicemen's Group Life Insurance)",
      "39:3005" : "39:3005 (39:3005 Detention of Mail for Temporary Periods)",
      "39:409" : "39:409 (39:409 Postal Service)",
      "40:0258" : "40:0258 (40:258(a) Public Buildings & Property: Land Condem)",
      "40:0270" : "40:0270 (40:270 Miller Act)",
      "40:0875" : "40:0875 (40:875 Public Buildings & Property: Negligence)",
      "40:3131" : "40:3131 (40:3131 et seq Miller Act)",
      "41:0251" : "41:0251 (41:251 Public Contracts-Review of Agency Action)",
      "41:1463" : "41:1463 (41:1463 Public Contracts: Unlawful Employment Prac)",
      "42:0205" : "42:0205 (42:205 Denial Social Security Benefits)",
      "42:0206" : "42:0206 (42:206 Social Security Benefits)",
      "42:0247" : "42:0247 (42:247 Personal Injury-Swine Flu)",
      "42:0402" : "42:0402 (42:402 Social Security Benefits)",
      "42:0405" : "42:0405 (42:0405 Public Health and Welfare HHS)",
      "42:0405dc" : "42:0405dc (42:0405dc Review of SSA Decision SSDC - Concurrent Title II and Title XVI Claims)",
      "42:0405id" : "42:0405id (42:405 Review of HHS Decision (SSID))",
      "42:0405rs" : "42:0405rs (42:0405rs Review of SSA Decision RSI - Application for Retirement or Survivor Benefits)",
      "42:0405wc" : "42:0405wc (42:405 Review of SSA Decision DIWC - Title II Worker or Child Claims)",
      "42:0405ww" : "42:0405ww (42:405 Review of SSA Decision DIWW - Title II Widow or Widower Claims)",
      "42:0416" : "42:0416 (42:416 Denial of Social Security Benefits)",
      "42:0427" : "42:0427 (42:427 Social Security Benefits)",
      "42:11601" : "42:11601 (International Child Abduction Remedies Act)",
      "42:12101" : "42:12101 (42:12101 Americans with Disabilities Act)",
      "42:12182" : "42:12182 (42:12182 Americans with Disabilities Act)",
      "42:1383" : "42:1383 (42:1383 Review of SSA Decision SSID - SSI Disability Cases)",
      "42:1395" : "42:1395 (42:1395 HHS: Adverse Reimbursement Review)",
      "42:1396" : "42:1396 (42:1396 - Tort Negligence)",
      "42:1471" : "42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclo)",
      "42:1981cv" : "42:1981cv (42:1981 Civil Rights)",
      "42:1981hs" : "42:1981hs (42:1981 Housing Discrimination)",
      "42:1981jb" : "42:1981jb (42:1981 Job Discrimination (Race))",
      "42:1981sx" : "42:1981sx (42:1981 Sex Discrimination)",
      "42:1983cv" : "42:1983cv (42:1983 Civil Rights Act)",
      "42:1983ed" : "42:1983ed (42:1983 Civil Rights (Employment Discrimination))",
      "42:1983pr" : "42:1983pr (42:1983 Prisoner Civil Rights)",
      "42:1986" : "42:1986 (42:1986 Neglect of Duty)",
      "42:2000ag" : "42:2000ag (42:2000 Job Discrimination (Age))",
      "42:2000e" : "42:2000e (42:2000e Job Discrimination (Employment))",
      "42:2000pb" : "42:2000pb (42:2000 Job Discrimination (Public Accomodations))",
      "42:2000ra" : "42:2000ra (42:2000 Job Discrimination (Race))",
      "42:2000sx" : "42:2000sx (42:2000 Job Discrimination (Sex))",
      "42:2003" : "42:2003 (42:2003 Job Discrimination)",
      "42:2005" : "42:2005 (42:2005 Review of Agency Action-HHS)",
      "42:2615" : "42:2615 (42:2616 Medical Recovery Act)",
      "42:2651" : "42:2651 (42:2651 Medical Care Recovery)",
      "42:3601" : "42:3601 (42:3601 Fair Housing Act)",
      "42:4000" : "42:4000 (42:4000 National Flood Insurance Act)",
      "42:4001" : "42:4001 (42:4001 National Insurance Flood Act)",
      "42:4053" : "42:4053 (42:4053 Breach of Insurance Contract)",
      "42:4072" : "42:4072 (42:4072 Payment of Flood Insurance Claim)",
      "42:4321" : "42:4321 (42:4321 Review of Agency Action-Environment)",
      "42:4332" : "42:4332 (42:4332 Environmental Policy - Coop of Agency Repo)",
      "42:6901en" : "42:6901en (42:6901 Environmental Cleanup Expenses)",
      "42:6901rs" : "42:6901rs (42:6901 Resource & Recovery Act)",
      "42:7413" : "42:7413 (42:7413(b) Clean Air Act)",
      "42:7604cl" : "42:7604cl (42:7604 Clear Air Act (Emission Standards))",
      "42:7604ir" : "42:7604ir (42:7604 Petition to Quash IRS Summons)",
      "42:9607" : "42:9607 (42:9607 Real Property Tort to Land)",
      "43:945" : "43:945 (43:945 Compensation for Land Condemnation)",
      "43:945a" : "43:945a (43:945a Complaint in Condemnation)",
      "43:946" : "43:946 (43:946 Complaint in Condemnation - Eminent Domain)",
      "45:0051" : "45:0051 (45:51 Railways: Fed. Employer's Liability Act)",
      "45:0151" : "45:0151 (45:151 Railway Labor Act)",
      "45:0184" : "45:0184 (45:184 Action to Set Aside Award of a System Board)",
      "45:1395" : "45:1395 (45:1395 Railroads: Adverse Reimbursement Review)",
      "45:7457" : "45:7457 (45:7457 Compel Reclamation Under Clear Air Act)",
      "46:0688" : "46:0688 (46:688 Jones Act)",
      "46:0741" : "46:0741 (46:741 Shipping)",
      "46:0761" : "46:0761 (46:761 Shipping: Damages for Death on High Seas)",
      "46:1101" : "46:1101 (46:1101 Violation of Maritime Regulations)",
      "46:1156" : "46:1156 (46:1156 Administrative Procedure Act)",
      "46:31342" : "46:31342 (Maritime Lien)",
      "47:0332" : "47:0332 (Telecommunications Act)",
      "47:0553" : "47:0553 (47:0553 Unauthorized reception of signal)",
      "48:0883" : "48:0883 (48:883 Violation of US Coastal Law)",
      "48:1985" : "48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)",
      "49:0081" : "49:0081 (49:81 Damaged Goods While Being Transported)",
      "49:0781" : "49:0781 (49:781 Forfeiture)",
      "49:11503" : "49:11503 (49:11503 Railroad Revitalization Regulatory Reform)",
      "49:11702" : "49:11702 (49:11702(a)(4) Violations of Interstate Commerce A)",
      "49:1471" : "49:1471 (49:1471 Federal Aviation Act)",
      "49:1903" : "49:1903 (49:1903 Petition to enforce administrative summon)",
      "8:287" : "8:287 (8:287 Petition to Enforce INS Subpoena)",
      "99:9999" : "99:9999 (99:9999 Report cause code (DO NOT DELETE!))",
      "Alleyne" : "Alleyne (Request for Relief Pursuant to Alleyne)",
      "MDL1180" : "MDL1180 (28:1332 diversity-airline crash MDL #1180)",
      "MDL1210" : "MDL1210 (In re: SmithKline Beecham Clinical Labs MDL#1210)",
      "MDL1241" : "MDL1241 (15:78m(a) Securities Exchange Act MDL1241)",
      "MDL1463" : "MDL1463 (In Re: Xerox Corp Securities Litigation)",
      "MDL1505" : "MDL1505 (In Re: Cardiac Devices Qui Tam Litigation)",
      "MDL1542" : "MDL1542 (In Re: EPDM Anti-trust Litigation)",
      "MDL1568" : "MDL1568 (In re Parcel Tanker Shipping Services Antitrust Litigation)",
      "MDL1572" : "MDL1572 (In Re: Aircrash near Castellon Spain Oct 10 2001)",
      "MDL1631" : "MDL1631 (MDL1631 - In Re: Publication Paper Antitrust Litigation)",
      "MDL1642" : "MDL1642 (In re: Polychloroprene Rubber (CR) Antitrust Litigation)",
      "MDL1649" : "MDL1649 (MDL1649 In re Helicopter Crash Near Wendle Creek, BC on August 8, 2002)",
      "MDL1894" : "MDL1894 (MDL1894 In Re: US Foodservice Inc.)",
      "MDL2407" : "MDL2407 (MDL 2407 In Re: Higher One OneAccount Marketing and Sales Practices)",
      "MDL2478" : "MDL2478 (MDL 2478 In Re: Convergent Telephone Consumer Protection Act)",
      "MDL2516" : "MDL2516 (MDL 2516 In Re: Aggrenox Antitrust Litigation)",
      "RSI" : "RSI (Repetitive Stress Injury Case)",
      "Resign" : "Resign (Resign)",
      "adsup" : "adsup (Administrative Subpoena)",
      "attyappt" : "attyappt (Appointment of Attorney/GJ)",
      "contempt" : "contempt (Contempt Proceedings)",
      "disbar" : "disbar (Disbarment Proceedings)",
      "fordepo" : "fordepo (Foreign Deposition)",
      "gpcmp" : "gpcmp (Grievance Complaint)",
      "gpfed" : "gpfed (Federal Conviction)",
      "gpre" : "gpre (Petition for Reinstatement)",
      "gprec" : "gprec (Reciprocal Discipline)",
      "gpref" : "gpref (Referral by Judge)",
      "gpst" : "gpst (State Court Discipline)",
      "gpstate" : "gpstate (State Conviction)",
      "juryosc" : "juryosc (Jury Order to Show Cause)",
      "misc" : "misc (Civil Miscellaneous Case)",
      "motcomp" : "motcomp (Motion to Compel)",
      "motquash" : "motquash (Motion to Quash)",
      "motret" : "motret (Motion for Return of Property)",
      "penreg" : "penreg (Application for Pen Register)",
      "petenf" : "petenf (Petition to Enforce IRS Summons)",
      "petper" : "petper (Petition to Perpetuate Testimony)",
      "prem" : "prem (Application to Enter Premises)",
      "pwratty" : "pwratty (Power of Attorney)",
      "regjgm" : "regjgm (Registration of Foreign Judgment)",
      "seizwar" : "seizwar (Seizure Warrant)",
      "tap" : "tap (Wiretap)",
      "tranbkref" : "tranbkref (Transmission of Bankruptcy Reference)",
      "tranff" : "tranff (Transmission of Proposed Findings of Fact and Concl. of Law)",
      "writgar" : "writgar (Application for a Writ of Garnishment)"
   },
   "dcdce" : {
      "0" : "0 (No cause code entered)",
      "01D2439" : "01D2439 (01DCC2439 WMATA (court jurisdiction) )",
      "02:0138" : "02:0138 (2:138 Library of Congress Access )",
      "02:0358" : "02:0358 (02:0358 President's Recommendations on Exec.,Jud.&Leg.Salary)",
      "02:0431" : "02:0431 (02:431 Fed. Election Commission: Failure Enforce C)",
      "02:0437" : "02:0437 (02:437 Federal Election Commission)",
      "02:0681" : "02:0681 (2:681 Deferral of Budget Authority )",
      "02:1202" : "02:1202 (02:1201 Discriminatory pract. affecting US Senate employees )",
      "02:1317a" : "02:1317a (Violation of Congressional Accountability Act )",
      "05:0075" : "05:0075 (05:75(2) Contract - Reduction in Grade)",
      "05:0504" : "05:0504 (05:0504 Equal Access to Justice )",
      "05:0551" : "05:0551 (05:551 Administrative Procedure Act)",
      "05:0552fi" : "05:0552fi (05:552 Freedom of Information Act)",
      "05:0552pa" : "05:0552pa (05:552 Right to Privacy Act)",
      "05:0554" : "05:0554 (05:0554 Constitutionality of Maritime Statutes)",
      "05:0555b" : "05:0555b (05:0555b Agency Decision - Right to Counsel )",
      "05:0701" : "05:0701 (05:0701 Maritime Subsidy Board)",
      "05:0702" : "05:0702 (05:702 Administrative Procedure Act)",
      "05:0704" : "05:0704 (05:704 Labor Litigation)",
      "05:0706" : "05:0706 (05:0706 Judicial Review of Agency Actions)",
      "05:2302" : "05:2302 (05:2302 Merit System Principles )",
      "05:5542" : "05:5542 (05:5542 Federal Employees Pay Act -- overtime rates )",
      "05:7101" : "05:7101 (05:7101 Labor-Management Relations )",
      "05:7501" : "05:7501 (05:7501 Government Employees Adverse Action--14 days or less)",
      "05:7511" : "05:7511 (05:7511 Government Employees Adverse Action--Over 14 days )",
      "05:7703" : "05:7703 (05:7703 Discrimination - Review of Agency Act)",
      "05:8101" : "05:8101 (05:8101 Federal Employees' Liability Act )",
      "05:8110" : "05:8110 (05:8110 Aug. Compensation for dependents of Govt. Employees )",
      "05:8715" : "05:8715 (05:8715 Unemployment Compensation - Jurisdiction of Courts )",
      "05:App1" : "05:App1 (05:App1 Government Employees Reorganization Plans )",
      "05:App2" : "05:App2 (05:App. 2,1 Federal Advisory Committee Act )",
      "07:0006" : "07:0006 (7:6(b) Federal Commodity Exchange Regulation)",
      "07:0025" : "07:0025 (7:25 Fraud - Commodities Leverage Contracts)",
      "07:0136" : "07:0136 (7:136 Forfeiture/Penalty of Environmental Protection Agency )",
      "07:0181" : "07:0181 (07:181 Packers & Stockyard Act)",
      "07:0499" : "07:0499 (07:499 Agricultural Commodities Act)",
      "07:0601" : "07:0601 (07:601 USDA Condemnation)",
      "07:0608" : "07:0608 (07:0608 Agricultural Marketing Agreement Act )",
      "07:2023" : "07:2023 (07:2023 Judicial Review of Admin Determination by DOA )",
      "07:2321" : "07:2321 (07:2321 Plant Variety Protection Act)",
      "08:1101" : "08:1101 (8:1101 Immigration and Nationality Act)",
      "08:1105" : "08:1105 (8:1105(a) Aliens: Habeas Corpus to Release INS Det)",
      "08:1252" : "08:1252 (08:1252(a)(2) Injunction for Deportation)",
      "08:1260" : "08:1260 (08:1260 Aliens: Access to Records)",
      "08:1324" : "08:1324 (08:1324 Aliens: Complaint for Forfeiture)",
      "08:1329" : "08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petiti)",
      "08:1446" : "08:1446 (8:1446 Petition for Naturalization Hearing)",
      "08:1451" : "08:1451 (08:1451 Revocation of Naturalization )",
      "09:0001" : "09:0001 (09:1 U.S. Arbitration Act)",
      "09:0009" : "09:0009 (9:9 Motion to Confirm Arbitration Loan)",
      "09:0010" : "09:0010 (09:0010 Petition to Vacate Arbitration Award)",
      "09:0202" : "09:0202 (09:0202 Award under Convention on Foreign Arbitral Awards )",
      "10:1006" : "10:1006 (10:1006 Review of Agency Decision)",
      "10:1552" : "10:1552 (10:1552 Armed Forces: Action to Correct Records)",
      "10:1553" : "10:1553 (10:1553 Armed Forces: FOIA General)",
      "10:2305" : "10:2305 (10:2305 Review of Federal Contract)",
      "10:2734" : "10:2734 (10:2734 Foreign Military Claims Act )",
      "11:0101" : "11:0101 (11:101 Bankruptcy)",
      "11:8001" : "11:8001 (11:8001 Bankruptcy Appeal )",
      "12:0022" : "12:0022 (12:22 Securities Fraud)",
      "12:0632" : "12:0632 (12:0632 Foreign Banking )",
      "12:0635" : "12:0635 (12:635 Breach of Insurance Contract)",
      "12:1441" : "12:1441 (12:1441 Financing Corporation )",
      "12:1461" : "12:1461 (12:1461 Homeowners Loan Act)",
      "12:1703" : "12:1703 (12:1703 Default of HUD Loan)",
      "12:1725" : "12:1725 (12:1725 Collection under Contract Guaranty)",
      "12:1730" : "12:1730 (12:1730 Collection Under Contract Guaranty)",
      "12:1818e" : "12:1818e (12:1818e Suspension or Removal of Bank Officer )",
      "12:1819" : "12:1819 (12:1819 Default of Promissory Note)",
      "12:1821" : "12:1821 (12:1821 Default of Loan by Promissary Note)",
      "12:1971" : "12:1971 (12:1971 Relief under Bank Holding Act)",
      "12:3410" : "12:3410 (12:3410 Right to Financial Privacy Act)",
      "12:3907" : "12:3907 (12:3907 Summary Enforcement of Capital Directive )",
      "15:0001" : "15:0001 (15:1 Antitrust Litigation)",
      "15:0002at" : "15:0002at (15:2 Antitrust Litigation)",
      "15:0002fl" : "15:0002fl (15:2(a) Fair Labor Standards Act)",
      "15:0005" : "15:0005 (15:5(a) Fair Labor Standards Act)",
      "15:0015" : "15:0015 (15:15 Antitrust Litigation)",
      "15:0025" : "15:0025 (15:25 Clayton Act)",
      "15:0044" : "15:0044 (15:44 Trademark Infringement)",
      "15:0045" : "15:0045 (15:0045 Federal Trade Commission Act)",
      "15:0052" : "15:0052 (15:0052 Federal Trade Commission Act)",
      "15:0053" : "15:0053 (15:0053 Federal Trade Commission Act)",
      "15:0053b" : "15:0053b (15:53b Federal Trade Commission Act )",
      "15:0077" : "15:0077 (15:77 Securities Fraud)",
      "15:0078" : "15:0078 (15:78m(a) Securities Exchange Act)",
      "15:0078ss" : "15:0078ss (15:78j(b) Stockholder Suit )",
      "15:0078ud" : "15:0078ud (15:78u(d) Securities Exchange Act )",
      "15:0631" : "15:0631 (15:631 Small Business Act)",
      "15:0661" : "15:0661 (15:0661 Small Business Investment Act of 1958 )",
      "15:0717" : "15:0717 (15:717 Natural Gas Act)",
      "15:0751" : "15:0751 (15:0751 Economic Stabilization Act of 1970 )",
      "15:078ss" : "15:078ss (15:078JCB; Stockholder Suit )",
      "15:1051" : "15:1051 (15:1051 Trademark Infringement)",
      "15:1114" : "15:1114 (15:1114 Trademark Infringement)",
      "15:1121" : "15:1121 (15:1121 Trademark Infringement)",
      "15:1125" : "15:1125 (15:1125 Trademark Infringement (Lanham Act))",
      "15:1126" : "15:1126 (15:1126 Patent Infringement)",
      "15:1127" : "15:1127 (15:1127 Trademark Infringement)",
      "15:1263" : "15:1263 (15:1263 Prohibited Hazardous Substance - Interstate Commerce)",
      "15:1314" : "15:1314 (15:1314 Antitrust--Petition for enforcement )",
      "15:1601" : "15:1601 (15:1601 Truth in Lending)",
      "15:1640" : "15:1640 (15:1640 Truth in Lending)",
      "15:1666" : "15:1666 (15:1666 Consumer Credit Protection-billing errors )",
      "15:1681" : "15:1681 (15:1681 Fair Credit Reporting Act)",
      "15:1692" : "15:1692 (15:1692 Fair Debt Collection Act)",
      "15:1938" : "15:1938 (15:1938 Fair Labor Standards Act)",
      "15:1981" : "15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))",
      "15:1988" : "15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))",
      "15:1989" : "15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))",
      "15:2301" : "15:2301 (15:2301 Magnuson-Moss Warranty Act)",
      "15:2620" : "15:2620 (15:2620 Toxic Substances Control Act )",
      "15:2801" : "15:2801 (15:2801 Petroleum Marketing Practices Act)",
      "15:53(b)" : "15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equita)",
      "16:0668" : "16:0668 (16:668 Bald Eagle Protection Act)",
      "16:0703" : "16:0703 (16:703 Migratory Bird Act)",
      "16:1538" : "16:1538 (16:1538 Endangered Species Act)",
      "16:1540" : "16:1540 (16:1540 Endangered Species Act )",
      "16:1801" : "16:1801 (16:1801 Fishery Conservation and Management Act (FCMA) )",
      "16:1831r-1" : "16:1831r-1 (16:1831r-1 Notice of Branch Closure)",
      "16:3371" : "16:3371 (16:3371 Wildlife Under the Lacey Act)",
      "16:3372" : "16:3372 (16:3372 Conservation: Complaint for Forfeiture)",
      "16:3373" : "16:3373 (16:3373 Appeal of Decision - DOI)",
      "16:3374" : "16:3374 (16:3374 Conservation: Complaint for Forfeiture)",
      "17:0101" : "17:0101 (17:101 Copyright Infringement)",
      "17:0501" : "17:0501 (17:501 Copyright Infringement)",
      "17:0504" : "17:0504 (17:504 Copyright Infringement)",
      "18:0241" : "18:0241 (18:241 Conspiracy Against Citizen Rights)",
      "18:1836a" : "18:1836a (18:1836(a) Injunction against Misappropriation of Trade Secrets)",
      "18:1836b" : "18:1836b (18:1836(b) Civil Action to Protect Trade Secrets)",
      "18:1905" : "18:1905 (18:1905 Disclosure of Confidential Information )",
      "18:1961" : "18:1961 (18:1961 Racketeering (RICO) Act)",
      "18:1962" : "18:1962 (18:1962 Racketeering (RICO) Act)",
      "18:1964" : "18:1964 (18:1964 Racketeering (RICO) Act)",
      "18:2331" : "18:2331 (18:2331 Anti-terrorism Act )",
      "18:3511" : "18:3511 (18:3511 Petition for Judicial Review)",
      "18:4208" : "18:4208 (18:4208(B) Agency Action Review)",
      "18:981" : "18:981 (18:981 Civil Forfeiture)",
      "19:1305" : "19:1305 (19:1305 Custom Duties:0Forfeiture-Immoral Articles)",
      "20:1080" : "20:1080 (20:1080 Student Loan Recovery)",
      "20:1400" : "20:1400 (20:1400 Civil Rights of Handicapped Child)",
      "20:1401" : "20:1401 (20:1401 Education: Handicapped Child Act)",
      "21:0348" : "21:0348 (21:0348 Federal Food, Drug and Cosmetic Act )",
      "21:0841" : "21:0841 (21:841 Forfeiture Property-Drugs)",
      "21:0881" : "21:0881 (21:881 Forfeiture Property-Drugs)",
      "21:0881a" : "21:0881a (21:881 Forfeiture Property - Aircraft)",
      "21:0881re" : "21:0881re (21:881 Forfeiture Property - Real Estate)",
      "22:2702" : "22:2702 (22:2702 Medical Malpractice by Govt. Medical Personnel )",
      "22:286" : "22:286 (22:286 Action against World Bank )",
      "22:4140" : "22:4140 (22:4140 Foreign Service Grievance Act )",
      "22:4181" : "22:4181 (22:4181 Foreign Service Grievance Act )",
      "23:0134" : "23:0134 (23:134 P.I.- Auto Negligence)",
      "23:1441" : "23:1441 (23:1441 Contract Real Estate)",
      "24:1000" : "24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)",
      "25:0640" : "25:0640 (25:640 Indian Tribal Rights)",
      "25:1901" : "25:1901 (25:1901 Indian Child Welfare Act)",
      "25:2701" : "25:2701 (25:2701 Indian Gaming Regulatory Act )",
      "26:6212" : "26:6212 (26:6212 Injunctive Relief from IRS Lien)",
      "26:6213" : "26:6213 (26:6213 Injunctive Relief from IRS Lien)",
      "26:6502" : "26:6502 (26:6502 IRS:Enforcement of tax liens)",
      "26:6532" : "26:6532 (26:6532 IRS: Refund of Tax Penalty)",
      "26:6702" : "26:6702 (26:6702 IRS: Refund of Income Tax Penalty)",
      "26:6703" : "26:6703 (26:6703 IRS: Refund of Tax Penalty)",
      "26:7401" : "26:7401 (26:7401 IRS: Tax Liability)",
      "26:7402" : "26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)",
      "26:7403" : "26:7403 (26:7403 Suit to Enforce Federal Tax Lien)",
      "26:7422" : "26:7422 (26:7422 Civil Actions by Taxpayers for Refund of Taxes )",
      "26:7422rt" : "26:7422rt (26:7422 IRS: Refund Taxes)",
      "26:7422rx" : "26:7422rx (26:7422 IRS: Refund Excise Tax)",
      "26:7426" : "26:7426 (26:7426 IRS: Wrongful Levy for Taxes)",
      "26:7428" : "26:7428 (26:7428 IRS: Declaratory Judgment )",
      "26:7429" : "26:7429 (26:7429 IRS: Tax Jeopardy Assessment)",
      "26:7431" : "26:7431 (26:7431 IRS: Unauthorized Inspection or Disclosure of Returns and Return Information)",
      "26:7609" : "26:7609 (26:7609 IRS: Petition to Quash IRS Summons)",
      "27:0185" : "27:0185 (27:185 Enforcement of Arbitration Award)",
      "28:0157c" : "28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)",
      "28:0157d" : "28:0157d (28:0157 Motion for Withdrawal of Reference)",
      "28:0158" : "28:0158 (28:0158 Notice of Appeal re Bankruptcy Matter (BA)",
      "28:0185" : "28:0185 (28:185 Suit to Compel Arbitration)",
      "28:0451" : "28:0451 (28:451 Employment Discrimination)",
      "28:0463" : "28:0463 (Expenses of Judicial Litigation )",
      "28:0591" : "28:0591 (28:0591 Independent Counsel )",
      "28:0592" : "28:0592 (28:0592 Independent Counsel - Application for Appointment )",
      "28:0593" : "28:0593 (28:0593 Independent Counsel - Court Responsibilities )",
      "28:0594" : "28:0594 (28:0594 Independent Counsel - Responsibilities )",
      "28:0595" : "28:0595 (28:0595 Independent Counsel - Congressional Oversight )",
      "28:0596" : "28:0596 (28:0596 Independent Counsel - Removal )",
      "28:0597" : "28:0597 (28:0597 Independent Counsel - Dept. of Justice Relationship )",
      "28:0598" : "28:0598 (28:0598 Independent Counsel - Chapter Termination )",
      "28:0794" : "28:0794 (28:794 Rehabilitation Act)",
      "28:1001" : "28:1001 (28:1001 E.R.I.S.A.)",
      "28:1132" : "28:1132 (28:1132 E.R.I.S.A.)",
      "28:1330" : "28:1330 (28:1330 Breach of Contract)",
      "28:1331" : "28:1331 (28:1331 Fed. Question)",
      "28:1331al" : "28:1331al (28:1331 Fed. Question: Airline Crash)",
      "28:1331at" : "28:1331at (28:1331 Fed. Question: Anti-trust)",
      "28:1331au" : "28:1331au (28:1331 Fed. Question: Auto Negligence)",
      "28:1331b" : "28:1331b (28:1331 Federal Question: Bivens Act)",
      "28:1331bc" : "28:1331bc (28:1331 Fed. Question: Breach of Contract)",
      "28:1331ca" : "28:1331ca (28:1331 Fed Question: Fed Communications Act of 1)",
      "28:1331cm" : "28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)",
      "28:1331cv" : "28:1331cv (28:1331 Federal Question: Other Civil Rights)",
      "28:1331ed" : "28:1331ed (28:1331 Fed. Question: Employment Discrimination)",
      "28:1331es" : "28:1331es (28:1331 Enforcement of Administrative Subpoena)",
      "28:1331fl" : "28:1331fl (28:1331 Fed. Question: Fair Labor Standards)",
      "28:1331in" : "28:1331in (28:1331 Fed. Question: Insurance Contract)",
      "28:1331mm" : "28:1331mm (28:1331 Fed. Question: Medical Malpractice)",
      "28:1331pi" : "28:1331pi (28:1331 Fed. Question: Personal Injury)",
      "28:1331rd" : "28:1331rd (28:1331 Fed. Question: Review Agency Decision)",
      "28:1331rp" : "28:1331rp (28:1331(a) Fed. Question: Real Property)",
      "28:1331rr" : "28:1331rr (28:1331 Fed. Question: Railway Labor Act)",
      "28:1331sv" : "28:1331sv (28:1331 Fed. Question: Securities Violation)",
      "28:1331tr" : "28:1331tr (28:1331 Fed. Question: Trademark)",
      "28:1331tt" : "28:1331tt (28:1331 Fed. Question: Tort Action)",
      "28:1331v" : "28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendme)",
      "28:1331wl" : "28:1331wl (28:1331 Federal Question: EPA Waste Lien)",
      "28:1331wt" : "28:1331wt (28:1331 Fed. Question: Water Rights)",
      "28:1332ac" : "28:1332ac (28:1332 Diversity-Account Receivable)",
      "28:1332al" : "28:1332al (28:1332 Diversity-Airline Crash)",
      "28:1332as" : "28:1332as (28:1332 Diversity-Asbestos Litigation)",
      "28:1332au" : "28:1332au (28:1332 Diversity-Auto Negligence)",
      "28:1332bc" : "28:1332bc (28:1332 Diversity-Breach of Contract)",
      "28:1332co" : "28:1332co (28:1332 Diversity-Conversion)",
      "28:1332ct" : "28:1332ct (28:1332 Diversity-(Citizenship))",
      "28:1332det" : "28:1332det (28:1332 Diversity: Forcible Detainer)",
      "28:1332df" : "28:1332df (28:1332 Diversity-Contract Default)",
      "28:1332dj" : "28:1332dj (28:1332 Diversity-Declaratory Judgment )",
      "28:1332ds" : "28:1332ds (28:1332 Diversity-Contract Dispute)",
      "28:1332ed" : "28:1332ed (28:1332 Diversity-Employment Discrimination)",
      "28:1332fd" : "28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)",
      "28:1332fr" : "28:1332fr (28:1332 Diversity-Fraud)",
      "28:1332ia" : "28:1332ia (28:1332 Diversity-Interpleader Action)",
      "28:1332ij" : "28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)",
      "28:1332in" : "28:1332in (28:1332 Diversity-Insurance Contract)",
      "28:1332jd" : "28:1332jd (28:1332 Diversity-Declaratory Judgement)",
      "28:1332lb" : "28:1332lb (28:1332 Diversity-Libel,Assault,Slander)",
      "28:1332lm" : "28:1332lm (28:1332 Diversity - Legal Malpractice)",
      "28:1332ma" : "28:1332ma (28:1332 Diversity-Miller Act)",
      "28:1332mm" : "28:1332mm (28:1332 Diversity-Medical Malpractice)",
      "28:1332mv" : "28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)",
      "28:1332ni" : "28:1332ni (28:1332 Diversity-Negotiable Instrument)",
      "28:1332nm" : "28:1332nm (28:1332 Diversity-Non-Motor Vehicle)",
      "28:1332oc" : "28:1332oc (28:1332 Diversity-Other Contract)",
      "28:1332pd" : "28:1332pd (28:1332 Diversity-Property Damage)",
      "28:1332pi" : "28:1332pi (28:1332 Diversity-Personal Injury)",
      "28:1332pl" : "28:1332pl (28:1332 Diversity-Product Liability)",
      "28:1332pr" : "28:1332pr (28:1332 Diversity-Petition for Removal)",
      "28:1332qt" : "28:1332qt (28:1332 Diversity-Petition to Quiet Title)",
      "28:1332ri" : "28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)",
      "28:1332sa" : "28:1332sa (28:1332 - Diversity: Securities & Exchange Commiss)",
      "28:1332sf" : "28:1332sf (28:1332 - Diversity: Securities Fraud)",
      "28:1332ss" : "28:1332ss (28:1332 Diversity - Stockholders Suits)",
      "28:1332tl" : "28:1332tl (28:1332 Diversity-Torts to Land)",
      "28:1332tm" : "28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))",
      "28:1332tn" : "28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)",
      "28:1332wd" : "28:1332wd (28:1332 Diversity-Wrongful Death)",
      "28:1333" : "28:1333 (28:1333 Admiralty)",
      "28:1334" : "28:1334 (28:1334 Bankruptcy Appeal)",
      "28:1334c" : "28:1334c (28:1334(c) R&R re motions for abstention (non-cor)",
      "28:1335" : "28:1335 (28:1335 Interpleader Action)",
      "28:1337" : "28:1337 (28:1337 Sherman-Clayton Act)",
      "28:1338cp" : "28:1338cp (28:1338 Copyright Infringement)",
      "28:1338pt" : "28:1338pt (28:1338 Patent Infringement)",
      "28:1338tr" : "28:1338tr (28:1338 Trademark Infringement)",
      "28:1340" : "28:1340 (28:1340 IRS: Custom Duties)",
      "28:1340er" : "28:1340er (28:1340 Recovery of Erroneous Refund)",
      "28:1341" : "28:1341 (28:1341 Complaint for Forfeiture)",
      "28:1343" : "28:1343 (28:1343 Violation of Civil Rights)",
      "28:1345co" : "28:1345co (28:1345 Replevin & Conversion)",
      "28:1345db" : "28:1345db (28:1345 Debt to US - FHA/HUD Title I)",
      "28:1345df" : "28:1345df (28:1345 Default of Promissory Note)",
      "28:1345er" : "28:1345er (28:1345 Recovery of Erroneous Refund)",
      "28:1345fc" : "28:1345fc (28:1345 Foreclosure)",
      "28:1345ff" : "28:1345ff (28:1345 Complaint for Forfeiture)",
      "28:1345hl" : "28:1345hl (28:1345 VA Home Loan Guaranty Debt)",
      "28:1345mc" : "28:1345mc (28:1345 Medical Care Recovery)",
      "28:1345mi" : "28:1345mi (28:1345 Mining Claim Ejectment)",
      "28:1345pd" : "28:1345pd (28:1345 Property Damage)",
      "28:1345pe" : "28:1345pe (28:1345 Property Ejectment)",
      "28:1345rc" : "28:1345rc (28:1345 Recovery of Debt to US)",
      "28:1345st" : "28:1345st (28:1345 Default of Student Loan)",
      "28:1345tp" : "28:1345tp (28:1345 Trespass on Public Land)",
      "28:1345va" : "28:1345va (28:1345 Recovery of VA Overpayment)",
      "28:1346bc" : "28:1346bc (28:1346 Breach of Contract)",
      "28:1346rc" : "28:1346rc (28:1346 Recovery of IRS Tax)",
      "28:1346tc" : "28:1346tc (28:1346 Tort Claim)",
      "28:1346wd" : "28:1346wd (28:1346 Wrongful Death)",
      "28:1352" : "28:1352 (28:1352 Miller Act)",
      "28:1355" : "28:1355 (28:1355 Petition for Return of Property)",
      "28:1358" : "28:1358 (28:1358 Land Condemnation)",
      "28:1361" : "28:1361 (28:1361 Petition for Writ of Mandamus)",
      "28:1362ic" : "28:1362ic (28:1362 Indian Tribal Controversy)",
      "28:1362iw" : "28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)",
      "28:1364" : "28:1364 (28:1364 Auto Negligence)",
      "28:1391" : "28:1391 (28:1391 Personal Injury)",
      "28:1402" : "28:1402 (28:1402 Medical Malpractice)",
      "28:1407" : "28:1407 (28:1407 Airline Crash)",
      "28:1441ac" : "28:1441ac (28:1441 Petition for Removal- Account Receivable)",
      "28:1441al" : "28:1441al (28:1441 Petition for Removal- Airline Crash)",
      "28:1441as" : "28:1441as (28:1441 Petition for Removal- Asbestos Litigation)",
      "28:1441au" : "28:1441au (28:1441 Petition for Removal- Auto Negligence)",
      "28:1441bc" : "28:1441bc (28:1441 Petition for Removal- Breach of Contract)",
      "28:1441cr" : "28:1441cr (Petition for Removal- Civil Rights )",
      "28:1441cv" : "28:1441cv (28:1441 Petition for Removal- Civil Rights Act)",
      "28:1441df" : "28:1441df (28:1441 Petition for Removal- Contract Default)",
      "28:1441dj" : "28:1441dj (28:1441 Petition for Removal- Declaratory Judgemen)",
      "28:1441ds" : "28:1441ds (28:1441 Petition for Removal- Contract Dispute)",
      "28:1441ed" : "28:1441ed (28:1441 Petition for Removal - Employment Discrim)",
      "28:1441fc" : "28:1441fc (28:1441 Petition for Removal - Fair Credit Reporti)",
      "28:1441fr" : "28:1441fr (28:1441 Petition for Removal- Fraud)",
      "28:1441ij" : "28:1441ij (28:1441 Petition for Removal- Injunctive/Declarato)",
      "28:1441in" : "28:1441in (28:1441 Petition for Removal- Insurance Contract)",
      "28:1441int" : "28:1441int (28:1441 Petition for Removal- Action for Interplea)",
      "28:1441lb" : "28:1441lb (28:1441 Petition for Removal Libel,Assault,Slander)",
      "28:1441lm" : "28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relatio)",
      "28:1441mm" : "28:1441mm (28:1441 Petition for Removal- Medical Malpractice)",
      "28:1441ni" : "28:1441ni (28:1441 Petition for Removal- Negotiable Instrumen)",
      "28:1441nm" : "28:1441nm (28:1441 Petition for Removal- Non-Motor Vehicle)",
      "28:1441oc" : "28:1441oc (28:1441 Petition For Removal--Other Contract)",
      "28:1441pd" : "28:1441pd (28:1441 Petition for Removal- Property Damage)",
      "28:1441pi" : "28:1441pi (28:1441 Petition for Removal- Personal Injury)",
      "28:1441pl" : "28:1441pl (28:1441 Petition for Removal- Product Liability)",
      "28:1441pr" : "28:1441pr (28:1441 Petition for Removal)",
      "28:1441qt" : "28:1441qt (28:1441 Petition for Removal- Petition to Quiet Ti)",
      "28:1441ri" : "28:1441ri (28:1441 Petition for Removal- Racketeering (RICO))",
      "28:1441sa" : "28:1441sa (28:1441 - Petition for Removal: SEC Act)",
      "28:1441sf" : "28:1441sf (28:1441 - Petition for Removal: Securities Fraud)",
      "28:1441tl" : "28:1441tl (28:1441 Petition for Removal- Torts to Land)",
      "28:1441tm" : "28:1441tm (28:1441 Petition for Removal- Tort/Motor Vehicle ()",
      "28:1441tn" : "28:1441tn (28:1441 Petition for Removal- Tort/Non-Motor Vehic)",
      "28:1441wd" : "28:1441wd (28:1441 Petition for Removal- Wrongful Death)",
      "28:1442bc" : "28:1442bc (28:1442 Petition for Removal- Breach of Contract)",
      "28:1442pr" : "28:1442pr (28:1442 Petition for Removal)",
      "28:1443" : "28:1443 (28:1443(1) Rent, Lease & Ejectment)",
      "28:1444" : "28:1444 (28:1444 Petition for Removal- Foreclosure)",
      "28:1446in" : "28:1446in (28:1446 Breach of Contract- Insurance)",
      "28:1446pd" : "28:1446pd (28:1446 Petition for Removal- Property Damage (P.I)",
      "28:1446pi" : "28:1446pi (28:1446 Petition for Removal- Personal Injury)",
      "28:1446pl" : "28:1446pl (28:1446pl Petition for Removal - Product Liability)",
      "28:1446pr" : "28:1446pr (28:1446 Petition for Removal)",
      "28:1452" : "28:1452 (28:1452 R&R re motions to remand (non-core))",
      "28:1602" : "28:1602 (28:1602 Foreign Sovereign Immunities Act)",
      "28:1605A" : "28:1605A (28:1605A Foreign Sovereign Immunities Act)",
      "28:1631" : "28:1631 (28:1631 Case Transferred to Cure Want of Jurisdiction )",
      "28:1651" : "28:1651 (28:1651 Petition for Writ of Coram Nobis)",
      "28:1651hc" : "28:1651hc (28:1651 Petition for Writ of Habeas Corpus)",
      "28:1651mn" : "28:1651mn (28:1651 Petition for Writ of Mandamus)",
      "28:1738" : "28:1738 (28:1738 State and Territorial Statutes-Full Faith and Credit)",
      "28:1983" : "28:1983 (28:1983 Civil Rights)",
      "28:2201" : "28:2201 (28:2201 Constitutionality of State Statute(s))",
      "28:2201an" : "28:2201an (28:2201 Declaratory Judgment (aliens and nationality))",
      "28:2201dj" : "28:2201dj (28:2201 Declaratory Judgment)",
      "28:2201fa" : "28:2201fa (28:2201 Declaratory Judgment- Firearms )",
      "28:2201fs" : "28:2201fs (28:2201fs Declaratory Judgment (Food Security Act) )",
      "28:2201ij" : "28:2201ij (28:2201 Injunction)",
      "28:2201in" : "28:2201in (28:2201 Declaratory Judgment (Insurance))",
      "28:2241" : "28:2241 (28:2241 Petition for Writ of Habeas Corpus (federa)",
      "28:2254" : "28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))",
      "28:2254se" : "28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)",
      "28:2255" : "28:2255 (28:2255 Motion to Vacate / Correct Illegal Sentenc)",
      "28:2255mo" : "28:2255mo (Motion to Vacate, Set Aside or Correct Sentence )",
      "28:2271" : "28:2271 (28:2271 Federal Tort Claims Act)",
      "28:2345" : "28:2345 (28:2345 Medicare Recovery)",
      "28:2347" : "28:2347 (28:2347 Withdrawal of Bankruptcy Appeal )",
      "28:2401" : "28:2401 (28:2401 Federal Tort Claims Act- time for commencing action )",
      "28:2409" : "28:2409 (28:2409(a) Quiet Title Action)",
      "28:2410" : "28:2410 (28:2410 Quiet Title)",
      "28:2671" : "28:2671 (28:2671 Federal Tort Claims Act)",
      "28:2674" : "28:2674 (28:2674 Federal Tort Claims Act)",
      "28:3001" : "28:3001 (28:3001 Federal Debt Collection Act )",
      "28:7402" : "28:7402 (28:7402 Refund of Taxes)",
      "28:7422" : "28:7422 (28:7422 Appeal from Administrative Decision)",
      "29:0151" : "29:0151 (29:151 Labor: Review of Agency Action)",
      "29:0160" : "29:0160 (29:160(1) National Labor Relations Act)",
      "29:0184" : "29:0184 (29:184 Violation Collection Bargain Agreement)",
      "29:0185ep" : "29:0185ep (29:185 Employee Pension Plan)",
      "29:0185lm" : "29:0185lm (29:185 Labor/Mgt. Relations (Contracts))",
      "29:0187" : "29:0187 (29:0187 Labor Management Relations Act-unfair labor practice)",
      "29:0201do" : "29:0201do (29:201 Denial of Overtime Compensation)",
      "29:0201fl" : "29:0201fl (29:201 Fair Labor Standards Act)",
      "29:0203" : "29:0203 (29:203 Equal Pay Act)",
      "29:0206" : "29:0206 (29:206 Collect Unpaid Wages)",
      "29:0216" : "29:0216 (29:216 Fair Labor Standards Act )",
      "29:0260" : "29:0260 (Family and Medical Leave Act of 1993)",
      "29:0401" : "29:0401 (29:0401 Labor Management Disclosure Act)",
      "29:0501(b)" : "29:0501(b) (29:0501(b) Violation of Fiduciary Responsibility )",
      "29:0621" : "29:0621 (29:621 Job Discrimination (Age))",
      "29:0623" : "29:0623 (29:623 Job Discrimination (Age))",
      "29:0626" : "29:0626 (29:626 Job Discrimination (Age))",
      "29:0633" : "29:0633 (29:633 Job Discrimination (Age))",
      "29:0651" : "29:0651 (29:651 Occupational Safety/Health)",
      "29:0754" : "29:0754 (29:754 Discrimination)",
      "29:0791" : "29:0791 (29:791 Job Discrimination (Rehabilitation Act))",
      "29:0794" : "29:0794 (29:0794 Job Discrimination (Handicap))",
      "29:1001" : "29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)",
      "29:1002" : "29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)",
      "29:1104" : "29:1104 (29:1104 Recovery of Benefits to Employee)",
      "29:1109" : "29:1109 (29:1109 Breach of Fiduciary Duties)",
      "29:1131" : "29:1131 (29:1131 ERISA - Collection of Delinquent Trust Fun)",
      "29:1132" : "29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)",
      "29:1145" : "29:1145 (29:1145 E.R.I.S.A.)",
      "29:1149" : "29:1149 (29:1149 Recover Pension & Profit Sharing)",
      "29:1337" : "29:1337 (29:1337 E.R.I.S.A.)",
      "29:1362" : "29:1362 (29:1362 ERISA)",
      "29:1381" : "29:1381 (29:1381 E.R.I.S.A.)",
      "29:1401" : "29:1401 (29:1401(b)(2) Appeal of Arbitration Award)",
      "29:1451" : "29:1451 (29:1451 E.R.I.S.A.)",
      "29:1801" : "29:1801 (29:1801 Farmworker Rights)",
      "29:2001" : "29:2001 (29:2001 Employee Polygraph Protection Act )",
      "29:2601" : "29:2601 (Family Medical Leave Act of 1993 )",
      "29:790" : "29:790 (29:790 Rehabilitation of Labor)",
      "30:0181" : "30:0181 (30:181 Environment: Review of Agency Action)",
      "30:0801" : "30:0801 (30:0801 Penalities/Federal Mine Safety Health Act)",
      "30:1201" : "30:1201 (30:1201 Environment: Review of Agency Action)",
      "30:1202" : "30:1202 (30:1202 Mining Reclamation Act)",
      "30:1276" : "30:1276 (30:1276 Interior: Review of Agency Action)",
      "31:1341" : "31:1341 (31:1341 Government employee--limitations on expending monies)",
      "31:3545" : "31:3545 (31:3545 Action to Recovery Money)",
      "31:3729" : "31:3729 (31:3729 False Claims Act)",
      "31:3730" : "31:3730 (31:3730 Qui Tam False Claims Act)",
      "31:3731" : "31:3731 (31:3731 Fraud)",
      "33:1319cw" : "33:1319cw (33:1319 Clean Water Act)",
      "33:1319pv" : "33:1319pv (33:1319 Pollutants & Permit Violations)",
      "33:1361" : "33:1361 (33:1361 Clean Water Act-Administrator Authority )",
      "33:1365" : "33:1365 (33:1365 Environmental Matters)",
      "35:0032" : "35:0032 (35:0032 Suspension from Practice before Patent & Trade. Off.)",
      "35:0145" : "35:0145 (35:145 Patent Infringement)",
      "35:0183" : "35:0183 (35:183 Patent Infringement)",
      "35:0271" : "35:0271 (35:271 Patent Infringement)",
      "35:146" : "35:146 (35:146 Patent Interference - Dissatisfaction )",
      "38:1681" : "38:1681 (38:1681 Recovery of VA Overpayment)",
      "38:1686" : "38:1686 (38:1686 Recovery of VA Overpayment)",
      "38:1780" : "38:1780 (38:1780 Recovery of VA Overpayment)",
      "38:2011" : "38:2011 (38:2011 - Veteran's Readjustment Assistance Act of)",
      "38:3116" : "38:3116 (38:3116 VA Overpayment)",
      "38:4301" : "38:4301 (38:4301 Uniformed Services Employment & Re-Employment Rights)",
      "39:0403" : "39:0403 (39:0403 Discriminatory use of the Postal Service )",
      "39:0409" : "39:0409 (39:0409 Action by or against the Postal Service )",
      "39:1207" : "39:1207 (39:1207 Review Agency Action--Labor )",
      "39:1208" : "39:1208 (39:1208 1970 Postal Act-enforced supervision by parent union)",
      "39:3005" : "39:3005 (39:3005 Detention of Mail for Temporary Periods)",
      "39:409" : "39:409 (39:409 Postal Service)",
      "40:0258" : "40:0258 (40:258(a) Public Buildings & Property: Land Condem)",
      "40:0270" : "40:0270 (40:270 Miller Act)",
      "40:0875" : "40:0875 (40:875 Public Buildings & Property: Negligence)",
      "41:0251" : "41:0251 (41:251 Public Contracts-Review of Agency Action)",
      "41:1463" : "41:1463 (41:1463 Public Contracts: Unlawful Employment Prac)",
      "42:0205" : "42:0205 (42:205 Denial Social Security Benefits)",
      "42:0206" : "42:0206 (42:206 Social Security Benefits)",
      "42:0247" : "42:0247 (42:247 Personal Injury-Swine Flu)",
      "42:0254o" : "42:0254o (42:254o Breach of Scholarship Contract )",
      "42:0402" : "42:0402 (42:402 Social Security Benefits)",
      "42:0405id" : "42:0405id (42:405 Review of HHS Decision (SSID))",
      "42:0405rd" : "42:0405rd (42:0405rd Review of HHS Decision (RSI) )",
      "42:0405rsi" : "42:0405rsi (42:0405rsi Review of HHS Decision (RSI) )",
      "42:0405wc" : "42:0405wc (42:405 Review of HHS Decision (DIWC))",
      "42:0405ww" : "42:0405ww (42:405 Review of HHS Decision (DIWW))",
      "42:0416" : "42:0416 (42:416 Denial of Social Security Benefits)",
      "42:0427" : "42:0427 (42:427 Social Security Benefits)",
      "42:12101" : "42:12101 (Viol. of the Americans with Disabilities Act of 1990)",
      "42:12188" : "42:12188 (42:12188 Americans With Disabilities Act )",
      "42:1383" : "42:1383 (42:1383 Review of HHS Decision)",
      "42:1395" : "42:1395 (42:1395 HHS: Adverse Reimbursement Review)",
      "42:1395dd" : "42:1395dd (42:1395 Denial of Services (EMTALA) )",
      "42:1396" : "42:1396 (42:1396 - Tort Negligence)",
      "42:13981" : "42:13981 (42:13981 Violence Against Women Act )",
      "42:1471" : "42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclo)",
      "42:1973" : "42:1973 (42:1973 Voting Rights Act )",
      "42:1981cv" : "42:1981cv (42:1981 Civil Rights)",
      "42:1981hs" : "42:1981hs (42:1981 Housing Discrimination)",
      "42:1981jb" : "42:1981jb (42:1981 Job Discrimination (Race))",
      "42:1981sx" : "42:1981sx (42:1981 Sex Discrimination)",
      "42:1983cv" : "42:1983cv (42:1983 Civil Rights Act)",
      "42:1983ed" : "42:1983ed (42:1983 Civil Rights (Employment Discrimination))",
      "42:1983pr" : "42:1983pr (42:1983 Prisoner Civil Rights)",
      "42:1986" : "42:1986 (42:1986 Neglect of Duty)",
      "42:2000" : "42:2000 (42:2000 Religion )",
      "42:2000ag" : "42:2000ag (42:2000 Job Discrimination (Age))",
      "42:2000e" : "42:2000e (42:2000e Job Discrimination (Employment))",
      "42:2000pb" : "42:2000pb (42:2000 Job Discrimination (Public Accomodations))",
      "42:2000ra" : "42:2000ra (42:2000 Job Discrimination (Race))",
      "42:2000sx" : "42:2000sx (42:2000 Job Discrimination (Sex))",
      "42:2003" : "42:2003 (42:2003 Job Discrimination)",
      "42:2005" : "42:2005 (42:2005 Review of Agency Action-HHS)",
      "42:2651" : "42:2651 (42:2651 Medical Care Recovery)",
      "42:2996" : "42:2996 (42:2996 Legal Services Corporation Act )",
      "42:300" : "42:300 (42:300 Safe Drinking Water Act )",
      "42:3601" : "42:3601 (42:405 Fair Housing Act)",
      "42:4000" : "42:4000 (42:4000 National Flood Insurance Act)",
      "42:4001" : "42:4001 (42:4001 National Insurance Flood Act)",
      "42:4053" : "42:4053 (42:4053 Breach of Insurance Contract)",
      "42:4072" : "42:4072 (42:4072 Payment of Flood Insurance Claim)",
      "42:4321" : "42:4321 (42:4321 Review of Agency Action-Environment)",
      "42:4332" : "42:4332 (42:4332 Environmental Policy - Coop of Agency Repo)",
      "42:4901" : "42:4901 (42:4901 Noise Control Act of 1972 )",
      "42:5411" : "42:5411 (42:5411 Housing Construction and Safety Standards Act )",
      "42:6901en" : "42:6901en (42:6901 Environmental Cleanup Expenses)",
      "42:6901rs" : "42:6901rs (42:6901 Resource & Recovery Act)",
      "42:7192" : "42:7192 (42:7192 Review by U.S.District Court of D.O.E. Agency Action)",
      "42:7413" : "42:7413 (42:7413(b) Clean Air Act)",
      "42:7523" : "42:7523 (42:7523 Clean Air Act-Mobile Source Emissions)",
      "42:7545" : "42:7545 (42:7545 Air Pollution Prevention - Regulation of Fuels )",
      "42:7604cl" : "42:7604cl (42:7604 Clear Air Act (Emission Standards))",
      "42:7604ir" : "42:7604ir (42:7604 Petition to Quash IRS Summons)",
      "42:7671" : "42:7671 (42:7671 Clean Air Act (Stratospheric Ozone Protection) )",
      "42:9601" : "42:9601 (42:9601 Environmental Response,Compensation & Liability Act )",
      "42:9607" : "42:9607 (42:9607 Real Property Tort to Land)",
      "43:1701" : "43:1701 (43:1701 Violation of Federal Land and Management Act)",
      "43:945" : "43:945 (43:945 Compensation for Land Condemnation)",
      "43:945a" : "43:945a (43:945a Complaint in Condemnation)",
      "43:946" : "43:946 (43:946 Complaint in Condemnation - Eminent Domain)",
      "44:2107" : "44:2107 (44:2107 Presidential Recordings and Materials Act )",
      "45:0002" : "45:0002 (45:2 Federal Employers' Liability Act )",
      "45:0023" : "45:0023 (45:23 Federal Employees' Liability Act )",
      "45:0051" : "45:0051 (45:51 Railways: Fed. Employer's Liability Act)",
      "45:0151" : "45:0151 (45:151 Railway Labor Act)",
      "45:0184" : "45:0184 (45:184 Action to Set Aside Award of a System Board)",
      "45:0719" : "45:0719 (45:0719 Regional Rail Reorganization Act of 1973 )",
      "45:1105" : "45:1105 (45:1105 Northeast Rail Service Act )",
      "45:1395" : "45:1395 (45:1395 Railroads: Adverse Reimbursement Review)",
      "45:7457" : "45:7457 (45:7457 Compel Reclamation Under Clear Air Act)",
      "46:0688" : "46:0688 (46:688 Jones Act)",
      "46:0741" : "46:0741 (46:741 Shipping)",
      "46:0761" : "46:0761 (46:761 Shipping: Damages for Death on High Seas)",
      "46:0951" : "46:0951 (46:0951 Foreclosure of Preferred Foreign Ship Mortgages )",
      "46:1101" : "46:1101 (46:1101 Violation of Maritime Regulations)",
      "46:1156" : "46:1156 (46:1156 Administrative Procedure Act)",
      "47:0206" : "47:0206 (47:0206 Carrier's Liability for Damages )",
      "47:0605" : "47:0605 (47:0605 Theft of Satellite Communications Services )",
      "48:0883" : "48:0883 (48:883 Violation of US Coastal Law)",
      "48:1985" : "48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)",
      "49:0020" : "49:0020 (49:0020 Liability for Motor Carrier )",
      "49:0081" : "49:0081 (49:81 Damaged Goods While Being Transported)",
      "49:0781" : "49:0781 (49:781 Forfeiture)",
      "49:11503" : "49:11503 (49:11503 Railroad Revitalization Regulatory Reform)",
      "49:11702" : "49:11702 (49:11702(a)(4) Violations of Interstate Commerce A)",
      "49:14706" : "49:14706 (49:14706 Liability of Carriers - Receipts & Bills of Landing)",
      "49:1471" : "49:1471 (49:1471 Federal Aviation Act)",
      "49:1552" : "49:1552 (49:1552 Airline Deregulation Act;Labor Protection Provisions)",
      "49:1903" : "49:1903 (49:1903 Petition to enforce administrative summon)",
      "50:0001" : "50:0001 (50:0001 Trading With the Enemy Act )",
      "50:2412" : "50:2412 (50:2412 Export Administration Act--1979 )",
      "8:287" : "8:287 (8:287 Petition to Enforce INS Subpoena)",
      "99:99" : "99:99 (TEMPORARILY OUT OF ORDER )",
      "MS:1001" : "MS:1001 (Registration of Foreign Judgment )",
      "MS:1002" : "MS:1002 (Motion for Extension of Time )",
      "MS:1003" : "MS:1003 (Motion to Quash Subpoenas )",
      "MS:1004" : "MS:1004 (Application: Order Show Cause for Non-Enforcement Subpoena )",
      "MS:1005" : "MS:1005 (Notice of Appeal: Orders of Bankruptcy Court )",
      "MS:1006" : "MS:1006 (Motion to Compel )",
      "MS:1007" : "MS:1007 (Notice of Filing Arbitration Award )",
      "MS:1008" : "MS:1008 (Motion for Reconsideration of Court Ruling )",
      "MS:1009" : "MS:1009 (Petition for Writ of Mandamus )",
      "MS:1010" : "MS:1010 (Writ of Habeas Corpus Ad Testificandum & Ad Prosequendum )",
      "MS:1011" : "MS:1011 (Motion for Production of Documents & Continued Deposition )",
      "MS:1012" : "MS:1012 (Application for Letters Rogatory )",
      "MS:1013" : "MS:1013 (Complaint )",
      "MS:1014" : "MS:1014 (Application for Order Immunizing Testimony )",
      "MS:1015" : "MS:1015 (Appointment of Receiver )",
      "MS:1016" : "MS:1016 (Request for Judicial Assistance )",
      "MS:1017" : "MS:1017 (Motion to Enforce Subpoena )",
      "MS:1018" : "MS:1018 (Motion for Protective Order )",
      "MS:1019" : "MS:1019 (Petition for Ancillary Hearing )",
      "MS:1020" : "MS:1020 (MS:1020 Perpetuate Testimony )",
      "MS:1021" : "MS:1021 (Withdrawal of Reference (from U. S. Bankruptcy Court) )",
      "MS:1022" : "MS:1022 (Motion for Return of Property )",
      "MS:1023" : "MS:1023 (MS:1023 Application for Extradition )",
      "MS:1024" : "MS:1024 (Application to Effect Levy )",
      "MS:1025" : "MS:1025 (Motion to Stay Arbitration )",
      "MS:1026" : "MS:1026 (Petition for Expungement )",
      "MS:1027" : "MS:1027 (Motion to Vacate Forfeiture of Collateral )",
      "MS:1028" : "MS:1028 (Leave of Court before Filing and Action )",
      "MS:1029" : "MS:1029 (U.M.W.A. - Employee Benefit Plans Litigation )",
      "MS:1030" : "MS:1030 (SEALED )",
      "MS:1031" : "MS:1031 (Contempt Proceeding )",
      "MS:1032" : "MS:1032 (Motion to Intervene )",
      "MS:1033" : "MS:1033 (Petition for Disclosure )",
      "MS:1034" : "MS:1034 (Certification to the USDC/DC pursuant to 11 Section 110(i) )",
      "MS:1035" : "MS:1035 (Application for Pen Register)",
      "MS:Administrative Subpoena" : "MS:Administrative Subpoena (Administrative Subpoena)",
      "MS:Consent Order" : "MS:Consent Order (MS:Consent Order)",
      "MS:MiscOrder" : "MS:MiscOrder (MS:Motion for Order)",
      "MS:MotionFor OrderDelNtc" : "MS:MotionFor OrderDelNtc (Motion for Order Authorizing Delayed Notice)",
      "MS:NoticeRemoval" : "MS:NoticeRemoval (MS:Notice of Removal)",
      "MS:Tracking Device" : "MS:Tracking Device (Application for Tracking Device)",
      "MS:Wire Comm" : "MS:Wire Comm (Application for Interception of Wire Communication)",
      "misc" : "misc (Civil Miscellaneous Case)"
   },
   "dedce" : {
      "0" : "0 (no cause specified)",
      "02:0431" : "02:0431 (02:431 Fed. Election Commission: Failure Enforce Compliance)",
      "02:0437" : "02:0437 (02:437 Federal Election Commission)",
      "05:0075" : "05:0075 (05:75(2) Contract - Reduction in Grade)",
      "05:0551" : "05:0551 (05:551 Administrative Procedure Act)",
      "05:0552fi" : "05:0552fi (05:552 Freedom of Information Act)",
      "05:0552pa" : "05:0552pa (05:552 Right to Privacy Act)",
      "05:0554" : "05:0554 (05:0554 Constitutionality of Maritime Statutes)",
      "05:0701" : "05:0701 (05:0701 Maritime Subsidy Board)",
      "05:0702" : "05:0702 (05:702 Administrative Procedure Act)",
      "05:0704" : "05:0704 (05:704 Labor Litigation)",
      "05:7703" : "05:7703 (05:7703 Discrimination - Review of Agency Act)",
      "05:8470" : "05:8470 (05:8470 Enforcement of Judgment against Retirement Benefits)",
      "07:0006" : "07:0006 (7:6(b) Federal Commodity Exchange Regulation)",
      "07:0025" : "07:0025 (7:25 Fraud - Commodities Leverage Contracts)",
      "07:0181" : "07:0181 (07:181 Packers & Stockyard Act)",
      "07:0499" : "07:0499 (07:499 Agricultural Commodities Act)",
      "07:0601" : "07:0601 (07:601 USDA Condemnation)",
      "07:2023" : "07:2023 (07:2023 Review of Agency Action - Agriculture)",
      "07:2321" : "07:2321 (07:2321 Plant Variety Protection Act)",
      "08:1105" : "08:1105 (8:1105(a) Aliens: Habeas Corpus to Release INS Detainee)",
      "08:1182" : "08:1182 (8:1182 Defend. Denial of Pla. Appl. for Alien Employment Cer)",
      "08:1252" : "08:1252 (08:1252(a)(2) Injunction for Deportation)",
      "08:1260" : "08:1260 (08:1260 Aliens: Access to Records)",
      "08:1324" : "08:1324 (08:1324 Aliens: Complaint for Forfeiture)",
      "08:1329" : "08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petition)",
      "08:1446" : "08:1446 (8:1446 Petition for Naturalization Hearing)",
      "08:1451(j)" : "08:1451(j) (8:1451(j) Motion to Correct Order & Judg. of Naturalization)",
      "09:0001" : "09:0001 (09:1 U.S. Arbitration Act)",
      "09:0009" : "09:0009 (9:9 Motion to Confirm Arbitration Loan)",
      "09:0010" : "09:0010 (09:0010 Petition to Vacate Arbitration Award)",
      "09:0207" : "09:0207 (09:207 Confirm Arbitral Award)",
      "10:1408" : "10:1408 (10:1408 Claim for Military Retirement)",
      "10:1552" : "10:1552 (10:1552 Armed Forces: Action to Correct Records)",
      "10:1553" : "10:1553 (10:1553 Armed Forces: FOIA General)",
      "10:2305" : "10:2305 (10:2305 Review of Federal Contract)",
      "11:0101" : "11:0101 (11:101 Bankruptcy)",
      "11:0547" : "11:0547 (11:0547 Bankruptcy)",
      "12:0022" : "12:0022 (12:22 Securities Fraud)",
      "12:0635" : "12:0635 (12:635 Breach of Insurance Contract)",
      "12:1461" : "12:1461 (12:1461 Homeowners Loan Act)",
      "12:1464" : "12:1464 (12:1464 Federal Savings and Loan)",
      "12:1703" : "12:1703 (12:1703 Default of HUD Loan)",
      "12:1725" : "12:1725 (12:1725 Collection under Contract Guaranty)",
      "12:1730" : "12:1730 (12:1730 Collection Under Contract Guaranty)",
      "12:1819" : "12:1819 (12:1819 Default of Promissory Note)",
      "12:1821" : "12:1821 (12:1821 Default of Loan by Promissary Note)",
      "12:191" : "12:191 (12:191 Bank Foreclosure)",
      "12:192" : "12:192 (12:192 Liquidation of National Bank)",
      "12:1971" : "12:1971 (12:1971 Relief under Bank Holding Act)",
      "12:1972" : "12:1972 (12:1972 Typing Arrangement Act)",
      "12:3410" : "12:3410 (12:3410 Right to Financial Privacy Act)",
      "15:0001" : "15:0001 (15:1 Antitrust Litigation)",
      "15:0002at" : "15:0002at (15:2 Antitrust Litigation)",
      "15:0002fl" : "15:0002fl (15:2(a) Fair Labor Standards Act)",
      "15:0005" : "15:0005 (15:5(a) Fair Labor Standards Act)",
      "15:0015" : "15:0015 (15:15 Antitrust Litigation)",
      "15:0025" : "15:0025 (15:25 Clayton Act)",
      "15:0044" : "15:0044 (15:44 Trademark Infringement)",
      "15:0045" : "15:0045 (15:0045 Federal Trade Commission Act)",
      "15:0052" : "15:0052 (15:0052 Federal Trade Commission Act)",
      "15:0053" : "15:0053 (15:0053 Federal Trade Commission Act)",
      "15:0077" : "15:0077 (15:77 Securities Fraud)",
      "15:0078" : "15:0078 (15:78m(a) Securities Exchange Act)",
      "15:0080" : "15:0080 (15:0080 Investment Companies)",
      "15:0631" : "15:0631 (15:631 Small Business Act)",
      "15:0717" : "15:0717 (15:717 Natural Gas Act)",
      "15:0754" : "15:0754 (15:754 Emergency Petroleum Allocation-Admin.& Enforcement)",
      "15:1051" : "15:1051 (15:1051 Trademark Infringement)",
      "15:1114" : "15:1114 (15:1114 Trademark Infringement)",
      "15:1121" : "15:1121 (15:1121 Trademark Infringement)",
      "15:1125" : "15:1125 (15:1125 Trademark Infringement (Lanham Act))",
      "15:1126" : "15:1126 (15:1126 Patent Infringement)",
      "15:1127" : "15:1127 (15:1127 Trademark Infringement)",
      "15:1261" : "15:1261 (15:1261 Federal Hazardous Substance Act)",
      "15:1601" : "15:1601 (15:1601 Truth in Lending)",
      "15:1640" : "15:1640 (15:1640 Truth in Lending)",
      "15:1679" : "15:1679 (15:1679 Credit Repair Organizations Act)",
      "15:1681" : "15:1681 (15:1681 Fair Credit Reporting Act)",
      "15:1692" : "15:1692 (15:1692 Fair Debt Collection Act)",
      "15:1938" : "15:1938 (15:1938 Fair Labor Standards Act)",
      "15:1981" : "15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))",
      "15:1988" : "15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))",
      "15:1989" : "15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))",
      "15:2301" : "15:2301 (15:2301 Magnuson-Moss Warranty Act)",
      "15:2801" : "15:2801 (15:2801 Petroleum Marketing Practices Act)",
      "15:53(b)" : "15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equita)",
      "16:0668" : "16:0668 (16:668 Bald Eagle Protection Act)",
      "16:0703" : "16:0703 (16:703 Migratory Bird Act)",
      "16:1538" : "16:1538 (16:1538 Endangered Species Act)",
      "16:3371" : "16:3371 (16:3371 Wildlife Under the Lacey Act)",
      "16:3372" : "16:3372 (16:3372 Conservation: Complaint for Forfeiture)",
      "16:3373" : "16:3373 (16:3373 Appeal of Decision - DOI)",
      "16:3374" : "16:3374 (16:3374 Conservation: Complaint for Forfeiture)",
      "17:0101" : "17:0101 (17:101 Copyright Infringement)",
      "17:0501" : "17:0501 (17:501 Copyright Infringement)",
      "17:0504" : "17:0504 (17:504 Copyright Infringement)",
      "18:0241" : "18:0241 (18:241 Conspiracy Against Citizen Rights)",
      "18:0492" : "18:0492 (18:492 Forfeiture - Counterfeit Obligations)",
      "18:1836a" : "18:1836a (18:1836(a) Injunction against Misappropriation of Trade Secrets)",
      "18:1836b" : "18:1836b (18:1836(b) Civil Action to Protect Trade Secrets)",
      "18:1961" : "18:1961 (18:1961 Racketeering (RICO) Act)",
      "18:1962" : "18:1962 (18:1962 Racketeering (RICO) Act)",
      "18:1964" : "18:1964 (18:1964 Racketeering (RICO) Act)",
      "18:2511" : "18:2511 (18:2511 Wiretapping)",
      "18:3114" : "18:3114 (18:3114 Motion for Return of Seized Property)",
      "18:3184" : "18:3184 (18:3184 Fugitives From Foreign Countries)",
      "18:4208" : "18:4208 (18:4208(B) Agency Action Review)",
      "18:923" : "18:923 (18:923 Firearms Licensing Review)",
      "19:1305" : "19:1305 (19:1305 Custom Duties: Forfeiture-Immoral Articles)",
      "20:1080" : "20:1080 (20:1080 Student Loan Recovery)",
      "20:1400" : "20:1400 (20:1400 Civil Rights of Handicapped Child)",
      "20:1401" : "20:1401 (20:1401 Education: Handicapped Child Act)",
      "20:1415" : "20:1415 (20:1415 Education: Procedural Safeguards)",
      "21:0841" : "21:0841 (21:841 Forfeiture Property-Drugs)",
      "21:0881" : "21:0881 (21:881 Forfeiture Property-Drugs)",
      "21:0881a" : "21:0881a (21:881 Forfeiture Property - Aircraft)",
      "21:0881re" : "21:0881re (21:881 Forfeiture Property - Real Estate)",
      "23:0134" : "23:0134 (23:134 P.I.- Auto Negligence)",
      "23:1441" : "23:1441 (23:1441 Contract Real Estate)",
      "24:1000" : "24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)",
      "25:0640" : "25:0640 (25:640 Indian Tribal Rights)",
      "25:1901" : "25:1901 (25:1901 Indian Child Welfare Act)",
      "26:0982" : "26:0982 (26:0982 IRS:Petition to Quash Formal Document Request)",
      "26:6212" : "26:6212 (26:6212 Injunctive Relief from IRS Lien)",
      "26:6213" : "26:6213 (26:6213 Injunctive Relief from IRS Lien)",
      "26:6502" : "26:6502 (26:6502 IRS:Enforcement of tax liens)",
      "26:6532" : "26:6532 (26:6532 IRS: Refund of Tax Penalty)",
      "26:6702" : "26:6702 (26:6702 IRS: Refund of Income Tax Penalty)",
      "26:6703" : "26:6703 (26:6703 IRS: Refund of Tax Penalty)",
      "26:7401" : "26:7401 (26:7401 IRS: Tax Liability)",
      "26:7402" : "26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)",
      "26:7403" : "26:7403 (26:7403 Suit to Enforce Federal Tax Lien)",
      "26:7422rt" : "26:7422rt (26:7422 IRS: Refund Taxes)",
      "26:7422rx" : "26:7422rx (26:7422 IRS: Refund Excise Tax)",
      "26:7426" : "26:7426 (26:7426 IRS: Wrongful Levy for Taxes)",
      "26:7429" : "26:7429 (26:7429 IRS: Tax Jeopardy Assessment)",
      "26:7609" : "26:7609 (26:7609 IRS: Petition to Quash IRS Summons)",
      "27:0185" : "27:0185 (27:185 Enforcement of Arbitration Award)",
      "28:0157c" : "28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)",
      "28:0157d" : "28:0157d (28:0157 Motion for Withdrawal of Reference)",
      "28:0158" : "28:0158 (28:0158 Bankruptcy Appeal from Judgment/Order)",
      "28:0185" : "28:0185 (28:185 Suit to Compel Arbitration)",
      "28:0451" : "28:0451 (28:451 Employment Discrimination)",
      "28:0754" : "28:0754 (28:754 Receiver of Property in Different Districts)",
      "28:0794" : "28:0794 (28:794 Rehabilitation Act)",
      "28:1001" : "28:1001 (28:1001 E.R.I.S.A.)",
      "28:1132" : "28:1132 (28:1132 E.R.I.S.A.)",
      "28:1330" : "28:1330 (28:1330 Breach of Contract)",
      "28:1331" : "28:1331 (28:1331 Fed. Question)",
      "28:1331al" : "28:1331al (28:1331 Fed. Question: Airline Crash)",
      "28:1331at" : "28:1331at (28:1331 Fed. Question: Anti-trust)",
      "28:1331au" : "28:1331au (28:1331 Fed. Question: Auto Negligence)",
      "28:1331b" : "28:1331b (28:1331 Federal Question: Bivens Act)",
      "28:1331bc" : "28:1331bc (28:1331 Fed. Question: Breach of Contract)",
      "28:1331ca" : "28:1331ca (28:1331 Fed Question: Fed Communications Act of 1)",
      "28:1331cm" : "28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)",
      "28:1331cv" : "28:1331cv (28:1331 Fed. Question: Civil Rights Violation)",
      "28:1331ed" : "28:1331ed (28:1331 Fed. Question: Employment Discrimination)",
      "28:1331ej" : "28:1331ej (28:1331 Federal Question: Enforcement of Judgment)",
      "28:1331es" : "28:1331es (28:1331 Enforcement of Administrative Subpoena)",
      "28:1331fl" : "28:1331fl (28:1331 Fed. Question: Fair Labor Standards)",
      "28:1331in" : "28:1331in (28:1331 Fed. Question: Insurance Contract)",
      "28:1331mm" : "28:1331mm (28:1331 Fed. Question: Medical Malpractice)",
      "28:1331ng" : "28:1331ng (28:1331 Fed. Question: Natural Gas Act)",
      "28:1331pi" : "28:1331pi (28:1331 Fed. Question: Personal Injury)",
      "28:1331rd" : "28:1331rd (28:1331 Fed. Question: Review Agency Decision)",
      "28:1331rp" : "28:1331rp (28:1331(a) Fed. Question: Real Property)",
      "28:1331rr" : "28:1331rr (28:1331 Fed. Question: Railway Labor Act)",
      "28:1331sv" : "28:1331sv (28:1331 Fed. Question: Securities Violation)",
      "28:1331tr" : "28:1331tr (28:1331 Fed. Question: Trademark)",
      "28:1331tt" : "28:1331tt (28:1331 Fed. Question: Tort Action)",
      "28:1331v" : "28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendment)",
      "28:1331wl" : "28:1331wl (28:1331 Federal Question: EPA Waste Lien)",
      "28:1331wt" : "28:1331wt (28:1331 Fed. Question: Water Rights)",
      "28:1332ac" : "28:1332ac (28:1332 Diversity-Account Receivable)",
      "28:1332al" : "28:1332al (28:1332 Diversity-Airline Crash)",
      "28:1332as" : "28:1332as (28:1332 Diversity-Asbestos Litigation)",
      "28:1332au" : "28:1332au (28:1332 Diversity-Auto Negligence)",
      "28:1332bc" : "28:1332bc (28:1332 Diversity-Breach of Contract)",
      "28:1332co" : "28:1332co (28:1332 Diversity-Conversion)",
      "28:1332ct" : "28:1332ct (28:1332 Diversity-(Citizenship))",
      "28:1332det" : "28:1332det (28:1332 Diversity: Forcible Detainer)",
      "28:1332df" : "28:1332df (28:1332 Diversity-Contract Default)",
      "28:1332ds" : "28:1332ds (28:1332 Diversity-Contract Dispute)",
      "28:1332ed" : "28:1332ed (28:1332 Diversity-Employment Discrimination)",
      "28:1332fd" : "28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)",
      "28:1332fr" : "28:1332fr (28:1332 Diversity-Fraud)",
      "28:1332ia" : "28:1332ia (28:1332 Diversity-Interpleader Action)",
      "28:1332ij" : "28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)",
      "28:1332in" : "28:1332in (28:1332 Diversity-Insurance Contract)",
      "28:1332jd" : "28:1332jd (28:1332 Diversity-Declaratory Judgment)",
      "28:1332lb" : "28:1332lb (28:1332 Diversity-Libel, Assault, Slander)",
      "28:1332lm" : "28:1332lm (Diversity - Legal Malpractice)",
      "28:1332ma" : "28:1332ma (28:1332 Diversity-Miller Act)",
      "28:1332mm" : "28:1332mm (28:1332 Diversity-Medical Malpractice)",
      "28:1332mv" : "28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)",
      "28:1332ni" : "28:1332ni (28:1332 Diversity-Negotiable Instrument)",
      "28:1332nm" : "28:1332nm (28:1332 Diversity-Non-Motor Vehicle)",
      "28:1332nr" : "28:1332nr (28:1332 Diversity-Notice of Removal)",
      "28:1332oc" : "28:1332oc (28:1332 Diversity-Other Contract)",
      "28:1332pd" : "28:1332pd (28:1332 Diversity-Property Damage)",
      "28:1332pi" : "28:1332pi (28:1332 Diversity-Personal Injury)",
      "28:1332pl" : "28:1332pl (28:1332 Diversity-Product Liability)",
      "28:1332pr" : "28:1332pr (28:1332 Diversity-Petition for Removal)",
      "28:1332qt" : "28:1332qt (28:1332 Diversity-Petition to Quiet Title)",
      "28:1332ri" : "28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)",
      "28:1332sa" : "28:1332sa (28:1332 - Diversity: Securities & Exchange Commiss)",
      "28:1332sf" : "28:1332sf (28:1332 - Diversity: Securities Fraud)",
      "28:1332ss" : "28:1332ss (28:1332 Diversity - Stockholders Suits)",
      "28:1332tl" : "28:1332tl (28:1332 Diversity-Torts to Land)",
      "28:1332tm" : "28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))",
      "28:1332tn" : "28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)",
      "28:1332wd" : "28:1332wd (28:1332 Diversity-Wrongful Death)",
      "28:1333" : "28:1333 (28:1333 Admiralty)",
      "28:1334" : "28:1334 (28:1334 Bankruptcy Appeal)",
      "28:1334c" : "28:1334c (28:1334(c) R&R re motions for abstention (non-cor)",
      "28:1335" : "28:1335 (28:1335 Interpleader Action)",
      "28:1337" : "28:1337 (28:1337 Sherman-Clayton Act)",
      "28:1338cp" : "28:1338cp (28:1338 Copyright Infringement)",
      "28:1338pt" : "28:1338pt (28:1338 Patent Infringement)",
      "28:1338tr" : "28:1338tr (28:1338 Trademark Infringement)",
      "28:1340" : "28:1340 (28:1340 IRS: Custom Duties)",
      "28:1340er" : "28:1340er (28:1340 Recovery of Erroneous Refund)",
      "28:1341" : "28:1341 (28:1341 Complaint for Forfeiture)",
      "28:1343" : "28:1343 (28:1343 Violation of Civil Rights)",
      "28:1345" : "28:1345 (28:1345 USA Plaintiff)",
      "28:1345co" : "28:1345co (28:1345 Replevin & Conversion)",
      "28:1345db" : "28:1345db (28:1345 Debt to US - FHA/HUD Title I)",
      "28:1345df" : "28:1345df (28:1345 Default of Promissory Note)",
      "28:1345er" : "28:1345er (28:1345 Recovery of Erroneous Refund)",
      "28:1345fc" : "28:1345fc (28:1345 Foreclosure)",
      "28:1345ff" : "28:1345ff (28:1345 Complaint for Forfeiture)",
      "28:1345hl" : "28:1345hl (28:1345 VA Home Loan Guaranty Debt)",
      "28:1345mc" : "28:1345mc (28:1345 Medical Care Recovery)",
      "28:1345mi" : "28:1345mi (28:1345 Mining Claim Ejectment)",
      "28:1345pd" : "28:1345pd (28:1345 Property Damage)",
      "28:1345pe" : "28:1345pe (28:1345 VA Property Ejectment)",
      "28:1345rc" : "28:1345rc (28:1345 Recovery of Debt to US)",
      "28:1345st" : "28:1345st (28:1345 Default of Student Loan)",
      "28:1345tp" : "28:1345tp (28:1345 Trespass on Public Land)",
      "28:1345va" : "28:1345va (28:1345 Recovery of VA Overpayment)",
      "28:1346bc" : "28:1346bc (28:1346 Breach of Contract)",
      "28:1346rc" : "28:1346rc (28:1346 Recovery of IRS Tax)",
      "28:1346tc" : "28:1346tc (28:1346 Tort Claim)",
      "28:1346wd" : "28:1346wd (28:1346 Wrongful Death)",
      "28:1349" : "28:1349 (28:1348 Corporation organized under Federal Law as party)",
      "28:1352" : "28:1352 (28:1352 Miller Act)",
      "28:1355" : "28:1355 (28:1355 Petition for Return of Property)",
      "28:1358" : "28:1358 (28:1358 Land Condemnation)",
      "28:1361" : "28:1361 (28:1361 Petition for Writ of Mandamus)",
      "28:1362ic" : "28:1362ic (28:1362 Indian Tribal Controversy)",
      "28:1362iw" : "28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)",
      "28:1364" : "28:1364 (28:1364 Auto Negligence)",
      "28:1391" : "28:1391 (28:1391 Personal Injury)",
      "28:1402" : "28:1402 (28:1402 Medical Malpractice)",
      "28:1407" : "28:1407 (28:1407 Airline Crash)",
      "28:1441ac" : "28:1441ac (28:1441 Notice of Removal-Account Receivable)",
      "28:1441al" : "28:1441al (28:1441 Notice of Removal-Airline Crash)",
      "28:1441as" : "28:1441as (28:1441 Notice of Removal-Asbestos Litigation)",
      "28:1441au" : "28:1441au (28:1441 Notice of Removal-Auto Negligence)",
      "28:1441bc" : "28:1441bc (28:1441 Notice of Removal-Breach of Contract)",
      "28:1441cv" : "28:1441cv (28:1441 Petition for Removal- Civil Rights Act)",
      "28:1441df" : "28:1441df (28:1441 Notice of Removal-Contract Default)",
      "28:1441dj" : "28:1441dj (28:1441 Notice of Removal-Declaratory Judgment)",
      "28:1441ds" : "28:1441ds (28:1441 Notice of Removal-Contract Dispute)",
      "28:1441ed" : "28:1441ed (28:1441 Petition for Removal - Employment Discrim)",
      "28:1441fc" : "28:1441fc (28:1441 Petition for Removal - Fair Credit Reporti)",
      "28:1441fr" : "28:1441fr (28:1441 Notice of Removal-Fraud)",
      "28:1441ij" : "28:1441ij (28:1441 Notice of Removal-Injunctive/Declaratory Relief)",
      "28:1441in" : "28:1441in (28:1441 Notice of Removal-Insurance Contract)",
      "28:1441int" : "28:1441int (28:1441 Petition for Removal- Action for Interplea)",
      "28:1441lb" : "28:1441lb (28:1441 Notice of Removal-Libel, Assault, Slander)",
      "28:1441lm" : "28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relatio)",
      "28:1441mm" : "28:1441mm (28:1441 Notice of Removal-Medical Malpractice)",
      "28:1441ni" : "28:1441ni (28:1441 Notice of Removal-Negotiable Instrument)",
      "28:1441nm" : "28:1441nm (28:1441 Notice of Removal-Non-Motor Vehicle)",
      "28:1441nr" : "28:1441nr (28:1441 Notice of Removal)",
      "28:1441oc" : "28:1441oc (28:1441 Petition For Removal--Other Contract)",
      "28:1441pd" : "28:1441pd (28:1441 Notice of Removal-Property Damage)",
      "28:1441pi" : "28:1441pi (28:1441 Notice of Removal-Personal Injury)",
      "28:1441pl" : "28:1441pl (28:1441 Notice of Removal-Product Liability)",
      "28:1441pr" : "28:1441pr (28:1441 Petition for Removal)",
      "28:1441qt" : "28:1441qt (28:1441 Notice of Removal-Petition to Quiet Title)",
      "28:1441ri" : "28:1441ri (28:1441 Petition for Removal- Racketeering (RICO))",
      "28:1441sa" : "28:1441sa (28:1441 - Petition for Removal: SEC Act)",
      "28:1441sf" : "28:1441sf (28:1441 - Petition for Removal: Securities Fraud)",
      "28:1441tl" : "28:1441tl (28:1441 Notice of Removal-Torts to Land)",
      "28:1441tm" : "28:1441tm (28:1441 Notice of Removal-Tort/Motor Vehicle (P.I.))",
      "28:1441tn" : "28:1441tn (28:1441 Notice of Removal-Tort/Non-Motor Vehicle)",
      "28:1441wd" : "28:1441wd (28:1441 Notice of Removal-Wrongful Death)",
      "28:1442bc" : "28:1442bc (28:1442 Notice of Removal-Breach of Contract)",
      "28:1442nr" : "28:1442nr (28:1442 Notice of Removal)",
      "28:1442pr" : "28:1442pr (28:1442 Petition for Removal)",
      "28:1443" : "28:1443 (28:1443(1) Rent, Lease & Ejectment)",
      "28:1444" : "28:1444 (28:1441 Notice of Removal-Foreclosure)",
      "28:1446in" : "28:1446in (28:1446 Breach of Contract- Insurance)",
      "28:1446nr" : "28:1446nr (28:1446 Notice of Removal)",
      "28:1446pd" : "28:1446pd (28:1446 Notice of Removal-Property Damage (P.I.))",
      "28:1446pi" : "28:1446pi (28:1446 Notice of Removal-Personal Injury)",
      "28:1446pl" : "28:1446pl (28:1446pl Petition for Removal - Product Liability)",
      "28:1446pr" : "28:1446pr (28:1446 Petition for Removal)",
      "28:1452" : "28:1452 (28:1452 Removal of Claim in Civil Action Related to BK. Case)",
      "28:1651" : "28:1651 (28:1651 Petition for Writ of Coram Nobis)",
      "28:1651hc" : "28:1651hc (28:1651 Petition for Writ of Habeas Corpus)",
      "28:1651mn" : "28:1651mn (28:1651 Petition for Writ of Mandamus)",
      "28:1782" : "28:1782 (28:1782 Letter rogatory - appointment)",
      "28:1983" : "28:1983 (28:1983 Civil Rights)",
      "28:2201" : "28:2201 (28:2201 Constitutionality of State Statute(s))",
      "28:2201dj" : "28:2201dj (28:2201 Declaratory Judgment)",
      "28:2201ij" : "28:2201ij (28:2201 Injunction)",
      "28:2201in" : "28:2201in (28:2201 Declaratory Judgment (Insurance))",
      "28:2241" : "28:2241 (28:2241 Petition for Writ of Habeas Corpus (Federal))",
      "28:2254" : "28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))",
      "28:2254se" : "28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)",
      "28:2255" : "28:2255 (28:2255 Motion to Vacate Sentence)",
      "28:2271" : "28:2271 (28:2271 Federal Tort Claims Act)",
      "28:2345" : "28:2345 (28:2345 Medicare Recovery)",
      "28:2409" : "28:2409 (28:2409(a) Quiet Title Action)",
      "28:2410" : "28:2410 (Actions affecting property on which United States had lien)",
      "28:2671" : "28:2671 (28:2671 Federal Tort Claims Act)",
      "28:2674" : "28:2674 (28:2674 Federal Tort Claims Act)",
      "28:3001" : "28:3001 (Federal Debt Collection)",
      "28:7402" : "28:7402 (28:7402 Refund of Taxes)",
      "28:7422" : "28:7422 (28:7422 Appeal from Administrative Decision)",
      "29:0151" : "29:0151 (29:151 Labor: Review of Agency Action)",
      "29:0160" : "29:0160 (29:160(1) National Labor Relations Act)",
      "29:0184" : "29:0184 (29:184 Violation Collection Bargain Agreement)",
      "29:0185ep" : "29:0185ep (29:185 Employee Pension Plan)",
      "29:0185lm" : "29:0185lm (29:185 Labor/Mgt. Relations (Contracts))",
      "29:0201do" : "29:0201do (29:201 Denial of Overtime Compensation)",
      "29:0201fl" : "29:0201fl (29:201 Fair Labor Standards Act)",
      "29:0203" : "29:0203 (29:203 Equal Pay Act)",
      "29:0206" : "29:0206 (29:206 Collect Unpaid Wages)",
      "29:0401" : "29:0401 (29:0401 Labor Management Disclosure Act)",
      "29:0621" : "29:0621 (29:621 Job Discrimination (Age))",
      "29:0623" : "29:0623 (29:623 Job Discrimination (Age))",
      "29:0626" : "29:0626 (29:626 Job Discrimination (Age))",
      "29:0633" : "29:0633 (29:633 Job Discrimination (Age))",
      "29:0651" : "29:0651 (29:651 Occupational Safety/Health)",
      "29:0754" : "29:0754 (29:754 Discrimination)",
      "29:0791" : "29:0791 (29:791 Job Discrimination (Rehabilitation Act))",
      "29:0794" : "29:0794 (29:0794 Job Discrimination (Handicap))",
      "29:1001" : "29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)",
      "29:1002" : "29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)",
      "29:1104" : "29:1104 (29:1104 Recovery of Benefits to Employee)",
      "29:1109" : "29:1109 (29:1109 Breach of Fiduciary Duties)",
      "29:1131" : "29:1131 (29:1131 ERISA - Collection of Delinquent Trust Funds)",
      "29:1132" : "29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)",
      "29:1145" : "29:1145 (29:1145 E.R.I.S.A.)",
      "29:1149" : "29:1149 (29:1149 Recover Pension & Profit Sharing)",
      "29:1337" : "29:1337 (29:1337 E.R.I.S.A.)",
      "29:1362" : "29:1362 (29:1362 ERISA)",
      "29:1381" : "29:1381 (29:1381 E.R.I.S.A.)",
      "29:1401" : "29:1401 (29:1401(b)(2) Appeal of Arbitration Award)",
      "29:1451" : "29:1451 (29:1451 E.R.I.S.A.)",
      "29:1801" : "29:1801 (29:1801 Farmworker Rights)",
      "29:2104" : "29:2104 (29:2104 Worker Adjustment & Retraining Notification Act)",
      "29:2601" : "29:2601 (29:2601 Family and Medical Leave Act of 1993)",
      "29:790" : "29:790 (29:790 Rehabilitation of Labor)",
      "30:0181" : "30:0181 (30:181 Environment: Review of Agency Action)",
      "30:0801" : "30:0801 (30:0801 Penalities/Federal Mine Safety Health Act)",
      "30:1201" : "30:1201 (30:1201 Environment: Review of Agency Action)",
      "30:1202" : "30:1202 (30:1202 Mining Reclamation Act)",
      "30:1276" : "30:1276 (30:1276 Interior: Review of Agency Action)",
      "31:3545" : "31:3545 (31:3545 Action to Recovery Money)",
      "31:3729" : "31:3729 (31:3729 False Claims Act)",
      "31:3730" : "31:3730 (31:3730 Qui Tam False Claims Act)",
      "31:3731" : "31:3731 (31:3731 Fraud)",
      "33:1319cw" : "33:1319cw (33:1319 Clean Water Act)",
      "33:1319pv" : "33:1319pv (33:1319 Pollutants & Permit Violations)",
      "33:1365" : "33:1365 (33:1365 Environmental Matters)",
      "35:01" : "35:01 (35:1 Patent Infringement)",
      "35:0146" : "35:0146 (35:0146 Review of Board of Patent Appeals Decision)",
      "35:0183" : "35:0183 (35:183 Patent Infringement)",
      "35:0271" : "35:0271 (35:271 Patent Infringement)",
      "35:0297" : "35:0297 (35:0297 - American Inventor's Protection Act)",
      "38:1681" : "38:1681 (38:1681 Recovery of VA Overpayment)",
      "38:1686" : "38:1686 (38:1686 Recovery of VA Overpayment)",
      "38:1780" : "38:1780 (38:1780 Recovery of VA Overpayment)",
      "38:2011" : "38:2011 (38:2011 - Veteran's Readjustment Assistance Act of)",
      "38:2021" : "38:2021 (Right to re-employment of inducted persons)",
      "38:3116" : "38:3116 (38:3116 VA Overpayment)",
      "38:775" : "38:775 (Recovery of Servicemen's Group Life Insurance)",
      "39:3005" : "39:3005 (39:3005 Detention of Mail for Temporary Periods)",
      "39:409" : "39:409 (39:409 Postal Service)",
      "40:0258" : "40:0258 (40:258(a) Public Buildings & Property: Land Condemnation)",
      "40:0270" : "40:0270 (40:270 Miller Act)",
      "40:0875" : "40:0875 (40:875 Public Buildings & Property: Negligence)",
      "41:0251" : "41:0251 (41:251 Public Contracts-Review of Agency Action)",
      "41:1463" : "41:1463 (41:1463 Public Contracts: Unlawful Employment Practices)",
      "42:0205" : "42:0205 (42:205 Denial Social Security Benefits)",
      "42:0206" : "42:0206 (42:206 Social Security Benefits)",
      "42:0247" : "42:0247 (42:247 Personal Injury-Swine Flu)",
      "42:0402" : "42:0402 (42:402 Social Security Benefits)",
      "42:0405id" : "42:0405id (42:405 Review of HHS Decision (SSID))",
      "42:0405wc" : "42:0405wc (42:405 Review of HHS Decision (DIWC))",
      "42:0405ww" : "42:0405ww (42:405 Review of HHS Decision (DIWW))",
      "42:0416" : "42:0416 (42:416 Denial of Social Security Benefits)",
      "42:0427" : "42:0427 (42:427 Social Security Benefits)",
      "42:11601" : "42:11601 (42:11601 International Child Abduction Remedies Act)",
      "42:12101" : "42:12101 (42:12101 Americans with Disabilities Act)",
      "42:1320" : "42:1320 (42:1320 Health Insurance Portability And Accountability Act)",
      "42:1383" : "42:1383 (42:1383 Review of HHS Decision)",
      "42:1395" : "42:1395 (42:1395 HHS: Adverse Reimbursement Review)",
      "42:1396" : "42:1396 (42:1396 - Tort Negligence)",
      "42:1471" : "42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclo)",
      "42:1981cv" : "42:1981cv (42:1981 Civil Rights)",
      "42:1981hs" : "42:1981hs (42:1981 Housing Discrimination)",
      "42:1981jb" : "42:1981jb (42:1981 Job Discrimination (Race))",
      "42:1981sx" : "42:1981sx (42:1981 Sex Discrimination)",
      "42:1983cv" : "42:1983cv (42:1983 Civil Rights Act)",
      "42:1983ed" : "42:1983ed (42:1983 Civil Rights (Employment Discrimination))",
      "42:1983pr" : "42:1983pr (42:1983 Prisoner Civil Rights)",
      "42:1986" : "42:1986 (42:1986 Neglect of Duty)",
      "42:2000ag" : "42:2000ag (42:2000 Job Discrimination (Age))",
      "42:2000e" : "42:2000e (42:2000e Job Discrimination (Employment))",
      "42:2000pb" : "42:2000pb (42:2000 Job Discrimination (Public Accommodations))",
      "42:2000ra" : "42:2000ra (42:2000 Job Discrimination (Race))",
      "42:2000re" : "42:2000re (42:2000 Job Discrimination (Religion))",
      "42:2000sx" : "42:2000sx (42:2000 Job Discrimination (Sex))",
      "42:2003" : "42:2003 (42:2003 Job Discrimination)",
      "42:2005" : "42:2005 (42:2005 Review of Agency Action-HHS)",
      "42:2615" : "42:2615 (42:2616 Medical Recovery Act)",
      "42:2651" : "42:2651 (42:2651 Medical Care Recovery)",
      "42:3601" : "42:3601 (42:405 Fair Housing Act)",
      "42:4000" : "42:4000 (42:4000 National Flood Insurance Act)",
      "42:4001" : "42:4001 (42:4001 National Insurance Flood Act)",
      "42:4053" : "42:4053 (42:4053 Breach of Insurance Contract)",
      "42:4072" : "42:4072 (42:4072 Payment of Flood Insurance Claim)",
      "42:4321" : "42:4321 (42:4321 Review of Agency Action-Environment)",
      "42:4332" : "42:4332 (42:4332)",
      "42:6901en" : "42:6901en (42:6901 Environmental Cleanup Expenses)",
      "42:6901rs" : "42:6901rs (42:6901 Resource & Recovery Act)",
      "42:7413" : "42:7413 (42:7413(b) Clean Air Act)",
      "42:7604cl" : "42:7604cl (42:7604 Clear Air Act (Emission Standards))",
      "42:7604ir" : "42:7604ir (42:7604 Petition to Quash IRS Summons)",
      "42:9607" : "42:9607 (42:9607 Real Property Tort to Land)",
      "43:945" : "43:945 (43:945 Compensation for Land Condemnation)",
      "43:945a" : "43:945a (43:945a Complaint in Condemnation)",
      "43:946" : "43:946 (43:946 Complaint in Condemnation - Eminent Domain)",
      "45:0051" : "45:0051 (45:51 Railways: Fed. Employer's Liability Act)",
      "45:0151" : "45:0151 (45:151 Railway Labor Act)",
      "45:0184" : "45:0184 (45:184 Action to Set Aside Award of a System Board of Adjust)",
      "45:1395" : "45:1395 (45:1395 Railroads: Adverse Reimbursement Review)",
      "45:7457" : "45:7457 (45:7457 Compel Reclamation Under Clear Air Act)",
      "46:0688" : "46:0688 (46:688 Jones Act)",
      "46:0741" : "46:0741 (46:741 Shipping)",
      "46:0761" : "46:0761 (46:761 Shipping: Damages for Death on High Seas)",
      "46:1101" : "46:1101 (46:1101 Violation of Maritime Regulations)",
      "46:1156" : "46:1156 (46:1156 Administrative Procedure Act)",
      "47:0151" : "47:0151 (Internet Tax Freedom Act)",
      "47:332" : "47:332 (Mobile Services)",
      "47:605a" : "47:605a (Cable System Piracy)",
      "48:0883" : "48:0883 (48:883 Violation of US Coastal Law)",
      "48:1985" : "48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)",
      "49:0081" : "49:0081 (49:81 Damaged Goods While Being Transported)",
      "49:0781" : "49:0781 (49:781 Forfeiture)",
      "49:11503" : "49:11503 (49:11503 Railroad Revitalization Regulatory Reform)",
      "49:11702" : "49:11702 (49:11702(a)(4) Violations of Interstate Commerce A)",
      "49:1471" : "49:1471 (49:1471 Federal Aviation Act)",
      "49:1903" : "49:1903 (49:1903 Petition to enforce administrative summon)",
      "77-7777mc" : "77-7777mc (Miscellaneous Case Cause not Known)",
      "88:8888mc" : "88:8888mc (Miscellaneous Case Cause not Known)",
      "8:287" : "8:287 (8:287 Petition to Enforce INS Subpoena)",
      "99:9999" : "99:9999 (99:9999 (Miscellaneous Case - Cause Not Known))",
      "adsup" : "adsup (Administrative Subpoena)",
      "bail" : "bail (Bail - Other District)",
      "contempt" : "contempt (Contempt Proceedings)",
      "disbar" : "disbar (Disbarment Proceedings)",
      "fordepo" : "fordepo (Foreign Deposition)",
      "misc" : "misc (Civil Miscellaneous Case)",
      "miscapp" : "miscapp (Miscellaneous Application)",
      "motcomp" : "motcomp (Motion to Compel)",
      "motquash" : "motquash (Motion to Quash)",
      "motret" : "motret (Motion for Return of Property)",
      "petenf" : "petenf (Petition to Enforce IRS Summons)",
      "petper" : "petper (Petition to Perpetuate Testimony)",
      "regjgm" : "regjgm (Registration of Foreign Judgment)",
      "tranbkref" : "tranbkref (Transmission of Bankruptcy Reference)",
      "tranff" : "tranff (Transmission of Proposed Findings of Fact and Concl. of Law)",
      "writgar" : "writgar (Application for a Writ of Garnishment)"
   },
   "flmdce" : {
      "0" : "0 (no cause specified)",
      "01:01test" : "01:01test (01:01 test case)",
      "02:0431" : "02:0431 (02:0431 Fed. Election Comm: Failure Enforcement Compliance)",
      "02:0437" : "02:0437 (02:0437 Federal Election Commission)",
      "05:0075" : "05:0075 (05:0075(2) Contract-Reduction in Grade)",
      "05:0551" : "05:0551 (05:0551 Administrative Procedure Act)",
      "05:0552fi" : "05:0552fi (05:0552 Freedom of Information Act)",
      "05:0552pa" : "05:0552pa (05:0552 Right to Privacy Act)",
      "05:0554" : "05:0554 (05:0554 Constitutionality of Maritime Statutes)",
      "05:0701" : "05:0701 (05:0701 Maritime Subsidy Board)",
      "05:0702" : "05:0702 (05:0702 Administrative Procedure Act)",
      "05:0704" : "05:0704 (05:0704 Labor Litigation)",
      "05:7703" : "05:7703 (05:7703 Discrimination - Review of Agency Act)",
      "05:8470" : "05:8470 (05:8470 Enforcement of Judgment against Retirement Benefits)",
      "07:0006" : "07:0006 (07:0006(b) Federal Commodity Exchange Regulation)",
      "07:0025" : "07:0025 (07:0025 Fraud - Commodities Leverage Contracts)",
      "07:0181" : "07:0181 (07:0181 Packers & Stockyard Act)",
      "07:0499" : "07:0499 (07:0499 Agricultural Commodities Act)",
      "07:0601" : "07:0601 (07:0601 USDA Condemnation)",
      "07:2023" : "07:2023 (07:2023 Review of Findings of Dept. of Agriculture)",
      "07:2321" : "07:2321 (07:2321 Plant Variety Protection Act)",
      "08:0287" : "08:0287 (08:0287 Petition to Enforce INS Subpoena)",
      "08:1105" : "08:1105 (08:1105(a) Aliens:Habeas Corpus to Release INS Detainee)",
      "08:1182" : "08:1182 (08:1182 Defend. Denial of Pla. Appl. Alien Employment Cert)",
      "08:1252" : "08:1252 (08:1252(a)(2) Injunction for Deportation)",
      "08:1260" : "08:1260 (08:1260 Aliens: Access to Records)",
      "08:1324" : "08:1324 (08:1324 Aliens: Complaint for Forfeiture)",
      "08:1329" : "08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petition)",
      "08:1446" : "08:1446 (08:1446 Petition for Naturalization Hearing)",
      "08:1447" : "08:1447 (08:1447 Hearings on denials of applications for naturalization)",
      "08:1451j" : "08:1451j (08:1451j Motion to Correct Order & Judg. of Naturalization)",
      "09:0001" : "09:0001 (09:0001 U.S. Arbitration Act)",
      "09:0009" : "09:0009 (09:0009 Motion to confirm arbitration award)",
      "09:0010" : "09:0010 (09:10 Petition to Vacate Arbitration Award)",
      "10:1408" : "10:1408 (10:1408 Claim for Military Retirement)",
      "10:1552" : "10:1552 (10:1552 Armed Forces: Action to Correct Records)",
      "10:1553" : "10:1553 (10:1553 Armed Forces: FOIA General)",
      "10:2305" : "10:2305 (10:2305 Review of Federal Contract)",
      "11:0101" : "11:0101 (11:0101 Bankruptcy)",
      "11:0525" : "11:0525 (11:0525 Protection Against Discriminatory Treatment)",
      "12:0022" : "12:0022 (12:0022 Securities Fraud)",
      "12:0635" : "12:0635 (12:0635 Breach of Insurance Contract)",
      "12:1461" : "12:1461 (12:1461 Homeowners Loan Act)",
      "12:1464" : "12:1464 (12:1464 Federal Savings and Loan)",
      "12:1703" : "12:1703 (12:1703 Default of HUD Loan)",
      "12:1725" : "12:1725 (12:1725 Collection Under Contract Guaranty)",
      "12:1730" : "12:1730 (12:1730 Collection Under Contract Guaranty)",
      "12:1819" : "12:1819 (12:1819 Default of Promissory Note)",
      "12:1821" : "12:1821 (12:1821 Default of Loan by Promissary Note)",
      "12:191" : "12:191 (12:191 Bank Foreclosure)",
      "12:192" : "12:192 (12:192 Liquidation of National Bank)",
      "12:1971" : "12:1971 (12:1971 Relief under Bank Holding Act)",
      "12:1972" : "12:1972 (12:1972 Tying Arrangement Act)",
      "12:2607" : "12:2607 (Real Estate Settlement Procedure (RESPA) Act)",
      "12:3410" : "12:3410 (12:3410 Right to Financial Privacy Act)",
      "15:0001" : "15:0001 (15:0001 Antitrust Litigation)",
      "15:0002at" : "15:0002at (15:0002 Antitrust Litigation)",
      "15:0002fl" : "15:0002fl (15:0002(a) Fair Labor Standards Act)",
      "15:0005" : "15:0005 (15:0005(a) Fair Labor Standards Act)",
      "15:0015" : "15:0015 (15:0015 Antitrust Litigation)",
      "15:0025" : "15:0025 (15:0025 Clayton Act)",
      "15:0044" : "15:0044 (15:0044 Trademark Infringement)",
      "15:0045" : "15:0045 (15:0045 Federal Trade Commission)",
      "15:0052" : "15:0052 (15:0052 Federal Trade Commission Act)",
      "15:0053" : "15:0053 (15:53 Federal Trade Commission Act)",
      "15:0077" : "15:0077 (15:0077 Securities Fraud)",
      "15:0078" : "15:0078 (15:0078m(a) Securities Exchange Act)",
      "15:0631" : "15:0631 (15:0631 Small Business Act)",
      "15:0717" : "15:0717 (15:0717 Natural Gas Act)",
      "15:0754" : "15:0754 (15:0754 Emergency Petroleum Allocation-Admin. & Enforcement)",
      "15:1051" : "15:1051 (15:1051 Trademark Infringement)",
      "15:1114" : "15:1114 (15:1114 Trademark Infringement)",
      "15:1121" : "15:1121 (15:1121 Trademark Infringement)",
      "15:1125" : "15:1125 (15:1125 Trademark Infringement (Lanham Act))",
      "15:1126" : "15:1126 (15:1126 Patent Infringement)",
      "15:1127" : "15:1127 (15:1127 Trademark Infringement)",
      "15:1601" : "15:1601 (15:1601 Truth in Lending)",
      "15:1640" : "15:1640 (15:1640 Truth in Lending)",
      "15:1681" : "15:1681 (15:1681 Fair Credit Reporting Act)",
      "15:1691" : "15:1691 (15:1691 Equal Credit Opportunity Act)",
      "15:1692" : "15:1692 (15:1692 Fair Debt Collection Act)",
      "15:1693" : "15:1693 (15:1693 Electronic Fund Transfer Act (EFTA))",
      "15:1701" : "15:1701 (15:1701 Interstate Land Sales Full Disclosure Act)",
      "15:1938" : "15:1938 (15:1938 Fair Labor Standards Act)",
      "15:1981" : "15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))",
      "15:1988" : "15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))",
      "15:1989" : "15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))",
      "15:2301" : "15:2301 (15:2301 Magnuson-Moss Warranty Act)",
      "15:2801" : "15:2801 (15:2801 Petroleum Marketing Practices Act)",
      "15:53b" : "15:53b (15:53b - Prelim & Perm Inj Relief & other Equita)",
      "16:0668" : "16:0668 (16:668 Bald Eagle Protection Act)",
      "16:0703" : "16:0703 (16:703 Migratory Bird Act)",
      "16:1538" : "16:1538 (16:1538 Endangered Species Act)",
      "16:3371" : "16:3371 (16:3371 Wildlife Under the Lacey Act)",
      "16:3372" : "16:3372 (16:3372 Conservation: Complaint for Forfeiture)",
      "16:3373" : "16:3373 (16:3373 Appeal of Decision - DOI)",
      "16:3374" : "16:3374 (16:3374 Conservation: Complaint for Forfeiture)",
      "17:0101" : "17:0101 (17:101 Copyright Infringement)",
      "17:0501" : "17:0501 (17:501 Copyright Infringement)",
      "17:0504" : "17:0504 (17:504 Copyright Infringement)",
      "17:512h" : "17:512h (17:512h Limitations on liability relating to material online)",
      "18:0241" : "18:0241 (18:241 Conspiracy Against Citizen Rights)",
      "18:0983" : "18:0983 (18:983 Civil Forfeiture Proceedings)",
      "18:1030" : "18:1030 (18:1030 Violation of Computer Fraud & Abuse Act)",
      "18:1345" : "18:1345 (18:1345 Injunctions Against Fraud)",
      "18:1514" : "18:1514 (18:1514 Civil Action to Restrain Harassment of a Victim or Witness)",
      "18:1836a" : "18:1836a (18:1836(a) Injunction against Misappropriation of Trade Secrets)",
      "18:1836b" : "18:1836b (18:1836(b) Civil Action to Protect Trade Secrets)",
      "18:1961" : "18:1961 (18:1961 Racketeering (RICO) Act)",
      "18:1962" : "18:1962 (18:1962 Racketeering (RICO) Act)",
      "18:1964" : "18:1964 (18:1964 Racketeering (RICO) Act)",
      "18:2333" : "18:2333 (18:2333 Civil Remedies - International Terrorism)",
      "18:2511" : "18:2511 (18:2511 Wiretapping)",
      "18:2721" : "18:2721 (18:2721 Driver's Privacy Protection Act)",
      "18:3114" : "18:3114 (18:3114 Motion for Return of Seized Property)",
      "18:4208" : "18:4208 (18:4208(B) Agency Action Review)",
      "19:1305" : "19:1305 (19:1305 Custom Duties: Forfeiture-Immoral Articles)",
      "20:1080" : "20:1080 (20:1080 Student Loan Recovery)",
      "20:1095" : "20:1095 (20:1095 Wage Garnishment Requirement)",
      "20:1400" : "20:1400 (20:1400 Civil Rights of Handicapped Child)",
      "20:1401" : "20:1401 (20:1401 Education: Handicapped Child Act)",
      "21:0301" : "21:0301 (21:0301 Federal Food, Drug & Cosmetic Act)",
      "21:0841" : "21:0841 (21:841 Forfeiture Property-Drugs)",
      "21:0881" : "21:0881 (21:881 Forfeiture Property-Drugs)",
      "21:0881a" : "21:0881a (21:881 Forfeiture Property - Aircraft)",
      "21:0881re" : "21:0881re (21:881 Forfeiture Property - Real Estate)",
      "21:801" : "21:801 (21:801 Comprehensive Drug Abuse Prevention Control Act)",
      "22:6081" : "22:6081 (22:6081 Protection of Property Rights of U.S. Nationals)",
      "22:6081USC" : "22:6081USC (22:6081 Protection of Property Rights of U.S. Nationals)",
      "23:0134" : "23:0134 (23:134 P.I.- Auto Negligence)",
      "23:1441" : "23:1441 (23:1441 Contract Real Estate)",
      "24:1000" : "24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)",
      "25:0640" : "25:0640 (25:640 Indian Tribal Rights)",
      "25:1901" : "25:1901 (25:1901 Indian Child Welfare Act)",
      "26:6212" : "26:6212 (26:6212 Injunctive Relief from IRS Lien)",
      "26:6213" : "26:6213 (26:6213 Injunctive Relief from IRS Lien)",
      "26:6502" : "26:6502 (26:6502 IRS:Enforcement of tax liens)",
      "26:6532" : "26:6532 (26:6532 IRS: Refund of Tax Penalty)",
      "26:6702" : "26:6702 (26:6702 IRS: Refund of Income Tax Penalty)",
      "26:6703" : "26:6703 (26:6703 IRS: Refund of Tax Penalty)",
      "26:7401" : "26:7401 (26:7401 IRS: Tax Liability)",
      "26:7402" : "26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)",
      "26:7403" : "26:7403 (26:7403 Suit to Enforce Federal Tax Lien)",
      "26:7405" : "26:7405 (26:7405 IRS: Recovery of IRS Tax)",
      "26:7422rt" : "26:7422rt (26:7422 IRS: Refund Taxes)",
      "26:7422rx" : "26:7422rx (26:7422 IRS: Refund Excise Tax)",
      "26:7426" : "26:7426 (26:7426 IRS: Wrongful Levy for Taxes)",
      "26:7429" : "26:7429 (26:7429 IRS: Tax Jeopardy Assessment)",
      "26:7431" : "26:7431 (26:7431 Civil Damages for Unauthorized Inspection or Disclosure of Returns and Return Information)",
      "26:7434" : "26:7434 (Fraudulent Filing of Information Returns)",
      "26:7609" : "26:7609 (26:7609 IRS: Petition to Quash IRS Summons)",
      "27:0185" : "27:0185 (27:185 Enforcement of Arbitration Award)",
      "28:0157c" : "28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)",
      "28:0157d" : "28:0157d (28:0157 Motion for Withdrawal of Reference)",
      "28:0157e" : "28:0157e (28:0157e Bankruptcy Case Jury Trial)",
      "28:0158" : "28:0158 (28:0158 Bankruptcy Appeal from Judgment/Order)",
      "28:0185" : "28:0185 (28:185 Suit to Compel Arbitration)",
      "28:0451" : "28:0451 (28:451 Employment Discrimination)",
      "28:0754" : "28:0754 (28:754 Receiver of Property in Different Districts)",
      "28:0794" : "28:0794 (28:794 Rehabilitation Act)",
      "28:1001" : "28:1001 (28:1001 E.R.I.S.A.)",
      "28:1132" : "28:1132 (28:1132 E.R.I.S.A.)",
      "28:1330" : "28:1330 (28:1330 Breach of Contract)",
      "28:1331" : "28:1331 (28:1331 Fed. Question)",
      "28:1331al" : "28:1331al (28:1331 Fed. Question: Airline Crash)",
      "28:1331at" : "28:1331at (28:1331 Fed. Question: Antitrust)",
      "28:1331au" : "28:1331au (28:1331 Fed. Question: Auto Negligence)",
      "28:1331b" : "28:1331b (28:1331 Federal Question: Bivens Act)",
      "28:1331bc" : "28:1331bc (28:1331 Fed. Question: Breach of Contract)",
      "28:1331ca" : "28:1331ca (28:1331 Fed Question: Fed Communications Act of 1)",
      "28:1331cm" : "28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)",
      "28:1331cv" : "28:1331cv (28:1331 Fed. Question: Civil Rights Violation)",
      "28:1331ed" : "28:1331ed (28:1331 Fed. Question: Employment Discrimination)",
      "28:1331ej" : "28:1331ej (28:1331 Fed. Question - Enforcement of Judgment)",
      "28:1331es" : "28:1331es (28:1331 Enforcement of Administrative Subpoena)",
      "28:1331fl" : "28:1331fl (28:1331 Fed. Question: Fair Labor Standards)",
      "28:1331in" : "28:1331in (28:1331 Fed. Question: Insurance Contract)",
      "28:1331mm" : "28:1331mm (28:1331 Fed. Question: Medical Malpractice)",
      "28:1331ng" : "28:1331ng (28:1331 Fed. Question: Natural Gas Act)",
      "28:1331pi" : "28:1331pi (28:1331 Fed. Question: Personal Injury)",
      "28:1331rd" : "28:1331rd (28:1331 Fed. Question: Review Agency Decision)",
      "28:1331rp" : "28:1331rp (28:1331(a) Fed. Question: Real Property)",
      "28:1331rr" : "28:1331rr (28:1331 Fed. Question: Railway Labor Act)",
      "28:1331sv" : "28:1331sv (28:1331 Fed. Question: Securities Violation)",
      "28:1331tr" : "28:1331tr (28:1331 Fed. Question: Trademark)",
      "28:1331tt" : "28:1331tt (28:1331 Fed. Question: Tort Action)",
      "28:1331v" : "28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendment)",
      "28:1331wl" : "28:1331wl (28:1331 Federal Question: EPA Waste Lien)",
      "28:1331wt" : "28:1331wt (28:1331 Fed. Question: Water Rights)",
      "28:1332ac" : "28:1332ac (28:1332 Diversity-Account Receivable)",
      "28:1332al" : "28:1332al (28:1332 Diversity-Airline Crash)",
      "28:1332as" : "28:1332as (28:1332 Diversity-Asbestos Litigation)",
      "28:1332au" : "28:1332au (28:1332 Diversity-Auto Negligence)",
      "28:1332bc" : "28:1332bc (28:1332 Diversity-Breach of Contract)",
      "28:1332co" : "28:1332co (28:1332 Diversity-Conversion)",
      "28:1332ct" : "28:1332ct (28:1332 Diversity-(Citizenship))",
      "28:1332det" : "28:1332det (28:1332 Diversity: Forcible Detainer)",
      "28:1332df" : "28:1332df (28:1332 Diversity-Contract Default)",
      "28:1332ds" : "28:1332ds (28:1332 Diversity-Contract Dispute)",
      "28:1332ed" : "28:1332ed (28:1332 Diversity-Employment Discrimination)",
      "28:1332fd" : "28:1332fd (28:1332fd Diversity-Breach of Fiduciary Duty)",
      "28:1332fr" : "28:1332fr (28:1332 Diversity-Fraud)",
      "28:1332ia" : "28:1332ia (28:1332 Diversity-Interpleader Action)",
      "28:1332ij" : "28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)",
      "28:1332in" : "28:1332in (28:1332 Diversity-Insurance Contract)",
      "28:1332jd" : "28:1332jd (28:1332 Diversity-Declaratory Judgment)",
      "28:1332lb" : "28:1332lb (28:1332 Diversity-Libel, Assault, Slander)",
      "28:1332lm" : "28:1332lm (28:1332 Diversity-Legal Malpractice)",
      "28:1332ma" : "28:1332ma (28:1332 Diversity-Miller Act)",
      "28:1332mm" : "28:1332mm (28:1332 Diversity-Medical Malpractice)",
      "28:1332mv" : "28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)",
      "28:1332ni" : "28:1332ni (28:1332 Diversity-Negotiable Instrument)",
      "28:1332nm" : "28:1332nm (28:1332 Diversity-Non-Motor Vehicle)",
      "28:1332nr" : "28:1332nr (28:1332 Diversity-Notice of Removal)",
      "28:1332oc" : "28:1332oc (28:1332 Diversity-Other Contract)",
      "28:1332pd" : "28:1332pd (28:1332 Diversity-Property Damage)",
      "28:1332pi" : "28:1332pi (28:1332 Diversity-Personal Injury)",
      "28:1332pl" : "28:1332pl (28:1332 Diversity-Product Liability)",
      "28:1332pr" : "28:1332pr (28:1332 Diversity-Petition for Removal)",
      "28:1332qt" : "28:1332qt (28:1332 Diversity-Petition to Quiet Title)",
      "28:1332ri" : "28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)",
      "28:1332sa" : "28:1332sa (28:1332 - Diversity: Securities & Exchange Commiss)",
      "28:1332sf" : "28:1332sf (28:1332 - Diversity: Securities Fraud)",
      "28:1332ss" : "28:1332ss (28:1332 Diversity - Stockholders Suits)",
      "28:1332tl" : "28:1332tl (28:1332 Diversity-Torts to Land)",
      "28:1332tm" : "28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))",
      "28:1332tn" : "28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)",
      "28:1332wd" : "28:1332wd (28:1332 Diversity-Wrongful Death)",
      "28:1333" : "28:1333 (28:1333 Admiralty)",
      "28:1334" : "28:1334 (28:1334 Bankruptcy Appeal)",
      "28:1334c" : "28:1334c (28:1334(c) R&R re motions for abstention (non-cor)",
      "28:1335" : "28:1335 (28:1335 Interpleader Action)",
      "28:1337" : "28:1337 (28:1337 Sherman-Clayton Act)",
      "28:1338cp" : "28:1338cp (28:1338 Copyright Infringement)",
      "28:1338pt" : "28:1338pt (28:1338 Patent Infringement)",
      "28:1338tr" : "28:1338tr (28:1338 Trademark Infringement)",
      "28:1340" : "28:1340 (28:1340 IRS: Custom Duties)",
      "28:1340er" : "28:1340er (28:1340 Recovery of Erroneous Refund)",
      "28:1341" : "28:1341 (28:1341 Complaint for Forfeiture)",
      "28:1343" : "28:1343 (28:1343 Violation of Civil Rights)",
      "28:1345" : "28:1345 (28:1345 USA Plaintiff)",
      "28:1345co" : "28:1345co (28:1345 Replevin & Conversion)",
      "28:1345db" : "28:1345db (28:1345 Debt to US - FHA/HUD Title I)",
      "28:1345df" : "28:1345df (28:1345 Default of Promissory Note)",
      "28:1345er" : "28:1345er (28:1345 Recovery of Erroneous Refund)",
      "28:1345fc" : "28:1345fc (28:1345 Foreclosure)",
      "28:1345ff" : "28:1345ff (28:1345 Complaint for Forfeiture)",
      "28:1345hl" : "28:1345hl (28:1345 VA Home Loan Guaranty Debt)",
      "28:1345mc" : "28:1345mc (28:1345 Medical Care Recovery)",
      "28:1345mi" : "28:1345mi (28:1345 Mining Claim Ejectment)",
      "28:1345pd" : "28:1345pd (28:1345 Property Damage)",
      "28:1345pe" : "28:1345pe (28:1345 VA Property Ejectment)",
      "28:1345rc" : "28:1345rc (28:1345 Recovery of Debt to US)",
      "28:1345st" : "28:1345st (28:1345 Default of Student Loan)",
      "28:1345tp" : "28:1345tp (28:1345 Trespass on Public Land)",
      "28:1345va" : "28:1345va (28:1345 Recovery of VA Overpayment)",
      "28:1346bc" : "28:1346bc (28:1346 Breach of Contract)",
      "28:1346rc" : "28:1346rc (28:1346 Recovery of IRS Tax)",
      "28:1346tc" : "28:1346tc (28:1346 Tort Claim)",
      "28:1346wd" : "28:1346wd (28:1346 Wrongful Death)",
      "28:1349" : "28:1349 (28:1348 Corporation organized under Federal Law as party)",
      "28:1352" : "28:1352 (28:1352 Miller Act)",
      "28:1355" : "28:1355 (28:1355 Petition for Return of Property)",
      "28:1358" : "28:1358 (28:1358 Land Condemnation)",
      "28:1361" : "28:1361 (28:1361 Petition for Writ of Mandamus)",
      "28:1362ic" : "28:1362ic (28:1362 Indian Tribal Controversy)",
      "28:1362iw" : "28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)",
      "28:1364" : "28:1364 (28:1364 Auto Negligence)",
      "28:1391" : "28:1391 (28:1391 Not to be used for cause)",
      "28:1402" : "28:1402 (28:1402 Medical Malpractice)",
      "28:1407" : "28:1407 (28:1407 Airline Crash)",
      "28:1441ac" : "28:1441ac (28:1441 Notice of Removal-Account Receivable)",
      "28:1441al" : "28:1441al (28:1441 Notice of Removal-Airline Crash)",
      "28:1441as" : "28:1441as (28:1441 Notice of Removal-Asbestos Litigation)",
      "28:1441au" : "28:1441au (28:1441 Notice of Removal-Auto Negligence)",
      "28:1441bc" : "28:1441bc (28:1441 Notice of Removal-Breach of Contract)",
      "28:1441cv" : "28:1441cv (28:1441 Notice of Removal- Civil Rights Act)",
      "28:1441dc" : "28:1441dc (Notice of Removal - Discrimination)",
      "28:1441df" : "28:1441df (28:1441 Notice of Removal-Contract Default)",
      "28:1441dj" : "28:1441dj (28:1441 Notice of Removal-Declaratory Judgment)",
      "28:1441ds" : "28:1441ds (28:1441 Notice of Removal-Contract Dispute)",
      "28:1441ed" : "28:1441ed (28:1441 Notice of Removal - Employment Discrim)",
      "28:1441fc" : "28:1441fc (28:1441 Notice of Removal - Fair Credit Reporti)",
      "28:1441fr" : "28:1441fr (28:1441 Notice of Removal-Fraud)",
      "28:1441ij" : "28:1441ij (28:1441 Notice of Removal-Injunctive/Declaratory Relief)",
      "28:1441in" : "28:1441in (28:1441 Notice of Removal-Insurance Contract)",
      "28:1441int" : "28:1441int (28:1441 Notice of Removal- Action for Interplea)",
      "28:1441lb" : "28:1441lb (28:1441 Notice of Removal-Libel, Assault, Slander)",
      "28:1441lm" : "28:1441lm (28:1441 Notice of Removal- Labor/Mgmnt. Relatio)",
      "28:1441mm" : "28:1441mm (28:1441 Notice of Removal-Medical Malpractice)",
      "28:1441ni" : "28:1441ni (28:1441 Notice of Removal-Negotiable Instrument)",
      "28:1441nm" : "28:1441nm (28:1441 Notice of Removal-Non-Motor Vehicle)",
      "28:1441nr" : "28:1441nr (28:1441 Notice of Removal)",
      "28:1441oc" : "28:1441oc (28:1441 Notice of Removal--Other Contract)",
      "28:1441pd" : "28:1441pd (28:1441 Notice of Removal-Property Damage)",
      "28:1441pi" : "28:1441pi (28:1441 Notice of Removal-Personal Injury)",
      "28:1441pl" : "28:1441pl (28:1441 Notice of Removal-Product Liability)",
      "28:1441pr" : "28:1441pr (28:1441 Notice of Removal)",
      "28:1441qt" : "28:1441qt (28:1441 Notice of Removal-Petition to Quiet Title)",
      "28:1441ri" : "28:1441ri (28:1441 Notice of Removal- Racketeering (RICO))",
      "28:1441sa" : "28:1441sa (28:1441 - Notice of Removal: SEC Act)",
      "28:1441sf" : "28:1441sf (28:1441 - Notice of Removal: Securities Fraud)",
      "28:1441tl" : "28:1441tl (28:1441 Notice of Removal-Torts to Land)",
      "28:1441tm" : "28:1441tm (28:1441 Notice of Removal-Tort/Motor Vehicle (P.I.))",
      "28:1441tn" : "28:1441tn (28:1441 Notice of Removal-Tort/Non-Motor Vehicle)",
      "28:1441wd" : "28:1441wd (28:1441 Notice of Removal-Wrongful Death)",
      "28:1442bc" : "28:1442bc (28:1442 Notice of Removal-Breach of Contract)",
      "28:1442nr" : "28:1442nr (28:1442 Notice of Removal)",
      "28:1442pr" : "28:1442pr (28:1442 Notice of Removal)",
      "28:1443" : "28:1443 (28:1443(1) Rent, Lease & Ejectment)",
      "28:1443cr" : "28:1443cr (28:1443 Notice of Removal-Criminal)",
      "28:1444" : "28:1444 (28:1441 Notice of Removal-Foreclosure)",
      "28:1446in" : "28:1446in (28:1446 Breach of Contract- Insurance)",
      "28:1446nr" : "28:1446nr (28:1446 Notice of Removal)",
      "28:1446pd" : "28:1446pd (28:1446 Notice of Removal-Property Damage (P.I.))",
      "28:1446pi" : "28:1446pi (28:1446 Notice of Removal-Personal Injury)",
      "28:1446pl" : "28:1446pl (28:1446pl Petition for Removal - Product Liability)",
      "28:1446pr" : "28:1446pr (28:1446 Petition for Removal)",
      "28:1452" : "28:1452 (28:1452 Removal of Claim in Civil Action Related to BK. Case)",
      "28:1453" : "28:1453 (Notice of Removal - class actions)",
      "28:1651" : "28:1651 (28:1651 Petition for Writ of Coram Nobis)",
      "28:1651hc" : "28:1651hc (28:1651 Petition for Writ of Habeas Corpus)",
      "28:1651mn" : "28:1651mn (28:1651 Petition for Writ of Mandamus)",
      "28:1711" : "28:1711 (28:1711 Class Action Fairness Act of 2005)",
      "28:1738" : "28:1738 (28:1738A Full Faith and Credit Given to Child Custody Determinations)",
      "28:1782" : "28:1782 (28:1782 Letter rogatory - appointment)",
      "28:1875" : "28:1875 (28:1875 Protection of Jurors Employment)",
      "28:1983" : "28:1983 (28:1983 Civil Rights (DO NOT USE))",
      "28:2201" : "28:2201 (28:2201 Constitutionality of State Statute(s))",
      "28:2201dj" : "28:2201dj (28:2201 Declaratory Judgment)",
      "28:2201ij" : "28:2201ij (28:2201 Injunction)",
      "28:2201in" : "28:2201in (28:2201 Declaratory Judgment (Insurance))",
      "28:2241" : "28:2241 (28:2241 Petition for Writ of Habeas Corpus (Federal))",
      "28:2241st" : "28:2241st (28:2241 Petition for Writ of Habeas Corpus (State))",
      "28:2254" : "28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))",
      "28:2254se" : "28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)",
      "28:2255" : "28:2255 (28:2255 Motion to Vacate Sentence)",
      "28:2271" : "28:2271 (28:2271 Federal Tort Claims Act)",
      "28:2345" : "28:2345 (28:2345 Medicare Recovery)",
      "28:2409" : "28:2409 (28:2409(a) Quiet Title Action)",
      "28:2410" : "28:2410 (28:2410 Actions affecting property which US had lien)",
      "28:2671" : "28:2671 (28:2671 Federal Tort Claims Act)",
      "28:2674" : "28:2674 (28:2674 Federal Tort Claims Act)",
      "28:3001" : "28:3001 (28:3001 Federal Debt Collection Act)",
      "28:7402" : "28:7402 (28:7402 Refund of Taxes)",
      "28:7422" : "28:7422 (28:7422 Appeal from Administrative Decision)",
      "29:0151" : "29:0151 (29:0151 Labor: Review of Agency Action)",
      "29:0160" : "29:0160 (29:160(1) National Labor Relations Act)",
      "29:0184" : "29:0184 (29:0184 Violation Collection Bargain Agreement)",
      "29:0185ep" : "29:0185ep (29:185 Employee Pension Plan)",
      "29:0185lm" : "29:0185lm (29:185 Labor/Mgt. Relations (Contracts))",
      "29:0201do" : "29:0201do (29:201 Denial of Overtime Compensation)",
      "29:0201fl" : "29:0201fl (29:201 Fair Labor Standards Act)",
      "29:0203" : "29:0203 (29:203 Equal Pay Act)",
      "29:0206" : "29:0206 (29:206 Collect Unpaid Wages)",
      "29:0401" : "29:0401 (29:0401 Labor Management Disclosure Act)",
      "29:0621" : "29:0621 (29:621 Job Discrimination (Age))",
      "29:0623" : "29:0623 (29:623 Job Discrimination (Age))",
      "29:0626" : "29:0626 (29:626 Job Discrimination (Age))",
      "29:0633" : "29:0633 (29:633 Job Discrimination (Age))",
      "29:0651" : "29:0651 (29:651 Occupational Safety/Health)",
      "29:0754" : "29:0754 (29:754 Discrimination)",
      "29:0791" : "29:0791 (29:791 Job Discrimination (Rehabilitation Act))",
      "29:0794" : "29:0794 (29:0794 Job Discrimination (Handicap))",
      "29:1001" : "29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)",
      "29:1002" : "29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)",
      "29:1104" : "29:1104 (29:1104 Recovery of Benefits to Employee)",
      "29:1109" : "29:1109 (29:1109 Breach of Fiduciary Duties)",
      "29:1131" : "29:1131 (29:1131 ERISA - Collection of Delinquent Trust Funds)",
      "29:1132" : "29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)",
      "29:1145" : "29:1145 (29:1145 E.R.I.S.A.)",
      "29:1149" : "29:1149 (29:1149 Recover Pension & Profit Sharing)",
      "29:1161" : "29:1161 (29:1161 COBRA - Continuation Coverage)",
      "29:1162" : "29:1162 (29:1162 COBRA - Continuation Coverage)",
      "29:1337" : "29:1337 (29:1337 E.R.I.S.A.)",
      "29:1362" : "29:1362 (29:1362 ERISA)",
      "29:1381" : "29:1381 (29:1381 E.R.I.S.A.)",
      "29:1401" : "29:1401 (29:1401(b)(2) Appeal of Arbitration Award)",
      "29:1451" : "29:1451 (29:1451 E.R.I.S.A.)",
      "29:1801" : "29:1801 (29:1801 Farmworker Rights)",
      "29:2001" : "29:2001 (29:2001 Employee Polygraph Protection Act)",
      "29:2102" : "29:2102 (29:2102 Notice Required Before Plant Closings and Mass Layoffs)",
      "29:2601" : "29:2601 (29:2601 Family Medical Leave Act)",
      "29:790" : "29:790 (29:790 Rehabilitation of Labor)",
      "30:0181" : "30:0181 (30:181 Environment: Review of Agency Action)",
      "30:0801" : "30:0801 (30:0801 Penalities/Federal Mine Safety Health Act)",
      "30:1201" : "30:1201 (30:1201 Environment: Review of Agency Action)",
      "30:1202" : "30:1202 (30:1202 Mining Reclamation Act)",
      "30:1276" : "30:1276 (30:1276 Interior: Review of Agency Action)",
      "30:775" : "30:775 (30:775 Recovery of Servicemen's Group Life Insurance)",
      "31:3545" : "31:3545 (31:3545 Action to Recovery Money)",
      "31:3729" : "31:3729 (31:3729 False Claims Act)",
      "31:3730" : "31:3730 (31:3730 Qui Tam False Claims Act)",
      "31:3731" : "31:3731 (31:3731 Fraud)",
      "33:0901" : "33:0901 (33:0901 Longshore and Harbor Workers Compensation Act)",
      "33:1319cw" : "33:1319cw (33:1319 Clean Water Act)",
      "33:1319pv" : "33:1319pv (33:1319 Pollutants & Permit Violations)",
      "33:1365" : "33:1365 (33:1365 Environmental Matters)",
      "35:0145" : "35:0145 (35:145 Patent Infringement)",
      "35:0183" : "35:0183 (35:183 Patent Infringement)",
      "35:0271" : "35:0271 (35:271 Patent Infringement)",
      "38:1681" : "38:1681 (38:1681 Recovery of VA Overpayment)",
      "38:1686" : "38:1686 (38:1686 Recovery of VA Overpayment)",
      "38:1780" : "38:1780 (38:1780 Recovery of VA Overpayment)",
      "38:2011" : "38:2011 (38:2011 - Veteran's Readjustment Assistance Act of)",
      "38:2021" : "38:2021 (38:2021 Right to re-employment of inducted persons)",
      "38:3116" : "38:3116 (38:3116 VA Overpayment)",
      "38:4301" : "38:4301 (38:4301 Uniformed Services Employment and Reemployment Rights Act of 1994 (USERRA))",
      "38:7462" : "38:7462 (38:7462 Major adverse actions involving professional conduct or competence)",
      "38:775" : "38:775 (38:775 Recovery of Servicemens Group Life Insurance)",
      "39:3005" : "39:3005 (39:3005 Detention of Mail for Temporary Periods)",
      "39:409" : "39:409 (39:409 Postal Service)",
      "40:0258" : "40:0258 (40:258(a) Public Buildings & Property: Land Condemnation)",
      "40:0270" : "40:0270 (40:270 Miller Act)",
      "40:0875" : "40:0875 (40:875 Public Buildings & Property: Negligence)",
      "41:0251" : "41:0251 (41:251 Public Contracts-Review of Agency Action)",
      "41:1463" : "41:1463 (41:1463 Public Contracts: Unlawful Employment Practices)",
      "42:0205" : "42:0205 (42:205 Denial Social Security Benefits)",
      "42:0206" : "42:0206 (42:206 Social Security Benefits)",
      "42:0247" : "42:0247 (42:247 Personal Injury-Swine Flu)",
      "42:0402" : "42:0402 (42:402 Social Security Benefits)",
      "42:0405id" : "42:0405id (42:405 Review of HHS Decision (SSID))",
      "42:0405wc" : "42:0405wc (42:405 Review of HHS Decision (DIWC))",
      "42:0405ww" : "42:0405ww (42:405 Review of HHS Decision (DIWW))",
      "42:0416" : "42:0416 (42:416 Denial of Social Security Benefits)",
      "42:0427" : "42:0427 (42:427 Social Security Benefits)",
      "42:11601" : "42:11601 (42:11601 International Child Abduction Remedies Act)",
      "42:12131" : "42:12131 (Americans with Disabilities Act)",
      "42:1383" : "42:1383 (42:1383 Review of HHS Decision)",
      "42:1395" : "42:1395 (42:1395 HHS: Adverse Reimbursement Review)",
      "42:1396" : "42:1396 (42:1396 - Tort Negligence)",
      "42:13981" : "42:13981 (42:13981 Violence Against Women Act)",
      "42:1471" : "42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclo)",
      "42:1973" : "42:1973 (42:1973 Voting Rights Act)",
      "42:1981cv" : "42:1981cv (42:1981 Civil Rights)",
      "42:1981hs" : "42:1981hs (42:1981 Housing Discrimination)",
      "42:1981jb" : "42:1981jb (42:1981 Job Discrimination (Race))",
      "42:1981sx" : "42:1981sx (42:1981 Sex Discrimination)",
      "42:1983cv" : "42:1983cv (42:1983 Civil Rights Act)",
      "42:1983ed" : "42:1983ed (42:1983 Civil Rights (Employment Discrimination))",
      "42:1983pr" : "42:1983pr (42:1983 Prisoner Civil Rights)",
      "42:1986" : "42:1986 (42:1986 Neglect of Duty)",
      "42:2000ag" : "42:2000ag (42:2000 Job Discrimination (Age))",
      "42:2000e" : "42:2000e (42:2000e Job Discrimination (Employment))",
      "42:2000pb" : "42:2000pb (42:2000 Job Discrimination (Public Accommodations))",
      "42:2000ra" : "42:2000ra (42:2000 Job Discrimination (Race))",
      "42:2000sx" : "42:2000sx (42:2000 Job Discrimination (Sex))",
      "42:2003" : "42:2003 (42:2003 Job Discrimination)",
      "42:2005" : "42:2005 (42:2005 Review of Agency Action-HHS)",
      "42:2615" : "42:2615 (42:2615 Medical Recovery Act)",
      "42:2651" : "42:2651 (42:2651 Medical Care Recovery)",
      "42:3601" : "42:3601 (42:3601 Fair Housing Act)",
      "42:4000" : "42:4000 (42:4000 National Flood Insurance Act)",
      "42:4001" : "42:4001 (42:4001 National Insurance Flood Act)",
      "42:4053" : "42:4053 (42:4053 Breach of Insurance Contract)",
      "42:4072" : "42:4072 (42:4072 Payment of Flood Insurance Claim)",
      "42:4321" : "42:4321 (42:4321 Review of Agency Action-Environment)",
      "42:4332" : "42:4332 (National Environmental Policy Act NEPA)",
      "42:5121" : "42:5121 (42:5121 Stafford Disaster Relief and Emergency Assistance Act)",
      "42:6901en" : "42:6901en (42:6901 Environmental Cleanup Expenses)",
      "42:6901rs" : "42:6901rs (42:6901 Resource & Recovery Act)",
      "42:7384" : "42:7384 (42:7384 ENERGY EMPLOYEES OCCUPATIONAL ILLNESS COMPENSATION PROGRAM)",
      "42:7413" : "42:7413 (42:7413(b) Clean Air Act)",
      "42:7604cl" : "42:7604cl (42:7604 Clear Air Act (Emission Standards))",
      "42:7604ir" : "42:7604ir (42:7604 Petition to Quash IRS Summons)",
      "42:9607" : "42:9607 (42:9607 Real Property Tort to Land)",
      "43:945" : "43:945 (43:945 Compensation for Land Condemnation)",
      "43:945a" : "43:945a (43:945a Complaint in Condemnation)",
      "43:946" : "43:946 (43:946 Complaint in Condemnation - Eminent Domain)",
      "45:0051" : "45:0051 (45:51 Railways: Fed. Employers Liability Act)",
      "45:0151" : "45:0151 (45:151 Railway Labor Act)",
      "45:0184" : "45:0184 (45:184 Action to Set Aside Award of a System Board of Adjust)",
      "45:1395" : "45:1395 (45:1395 Railroads: Adverse Reimbursement Review)",
      "45:7457" : "45:7457 (45:7457 Compel Reclamation Under Clear Air Act)",
      "46:0688" : "46:0688 (46:0688 Jones Act)",
      "46:0741" : "46:0741 (46:741 Shipping)",
      "46:0761" : "46:0761 (46:761 Shipping: Damages for Death on High Seas)",
      "46:1101" : "46:1101 (46:1101 Violation of Maritime Regulations)",
      "46:1156" : "46:1156 (46:1156 Administrative Procedure Act)",
      "46:31301" : "46:31301 (46:31301 Commercial Instruments and Maritime Liens)",
      "46:688USC" : "46:688USC (46:688 Jones Act)",
      "47:0201bt" : "47:0201bt (47:0201 Breach of Tariff)",
      "47:0227" : "47:0227 (Restrictions on Use of Telephone Equipment)",
      "47:0605" : "47:0605 (47:0605 Federal Communications Act)",
      "48:0883" : "48:0883 (48:883 Violation of US Coastal Law)",
      "48:1985" : "48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)",
      "49:0081" : "49:0081 (49:81 Damaged Goods While Being Transported)",
      "49:0781" : "49:0781 (49:781 Forfeiture)",
      "49:11503" : "49:11503 (49:11503 Railroad Revitalization Regulatory Reform)",
      "49:11702" : "49:11702 (49:11702(a)(4) Violations of Interstate Commerce Act)",
      "49:14706" : "49:14706 (49:14706 Liability of Carriers Under Receipts and Bills of Lading)",
      "49:1471" : "49:1471 (49:1471 Federal Aviation Act)",
      "49:1903" : "49:1903 (49:1903 Petition to enforce administrative summon)",
      "49:32701" : "49:32701 (49:32701 Findings and Purposes)",
      "99:9999" : "99:9999 (99:9999 Report cause code (DO NOT DELETE!))",
      "adsup" : "adsup (Administrative Subpoena)",
      "ausaappt" : "ausaappt (Registration of AUSA appointment)",
      "contempt" : "contempt (Contempt Proceedings)",
      "disbar" : "disbar (Disbarment Proceedings)",
      "enlvy" : "enlvy (Application for entry on premises to effect levy)",
      "fordepo" : "fordepo (Foreign Deposition)",
      "misc" : "misc (Civil Miscellaneous Case)",
      "motcomp" : "motcomp (Motion to Compel)",
      "motquash" : "motquash (Motion to Quash)",
      "motret" : "motret (Motion for Return of Property)",
      "ohabpet" : "ohabpet (Order: 2nd or Successive Habeas Petition)",
      "petenf" : "petenf (Petition to Enforce IRS Summons)",
      "petper" : "petper (Petition to Perpetuate Testimony)",
      "regjgm" : "regjgm (Registration of Foreign Judgment)",
      "regstjgm" : "regstjgm (Registration of State Court Judgment)",
      "stano" : "stano (Standing Order)",
      "tranbkref" : "tranbkref (Transmission of Bankruptcy Reference)",
      "tranff" : "tranff (Transmission of Proposed Findings of Fact and Concl. of Law)",
      "writgar" : "writgar (Application for a Writ of Garnishment)"
   },
   "flndce" : {
      "0" : "0 (No cause code entered)",
      "02:0431" : "02:0431 (02:431 Fed. Election Commission: Failure Enforce C)",
      "02:0437" : "02:0437 (02:437 Federal Election Commission)",
      "05:0075" : "05:0075 (05:75(2) Contract - Reduction in Grade)",
      "05:0551" : "05:0551 (05:551 Administrative Procedure Act)",
      "05:0552fi" : "05:0552fi (05:552 Freedom of Information Act)",
      "05:0552pa" : "05:0552pa (05:552 Right to Privacy Act)",
      "05:0554" : "05:0554 (05:0554 Constitutionality of Maritime Statutes)",
      "05:0701" : "05:0701 (05:0701 Maritime Subsidy Board)",
      "05:0702" : "05:0702 (05:702 Administrative Procedure Act)",
      "05:0704" : "05:0704 (05:704 Labor Litigation)",
      "05:7703" : "05:7703 (05:7703 Discrimination - Review of Agency Act)",
      "05:8470" : "05:8470 (05:8470 Enforcement of Judgment against Retirement Benefits)",
      "07:0006" : "07:0006 (7:6(b) Federal Commodity Exchange Regulation)",
      "07:0025" : "07:0025 (7:25 Fraud - Commodities Leverage Contracts)",
      "07:0181" : "07:0181 (07:181 Packers & Stockyard Act)",
      "07:0499" : "07:0499 (07:499 Agricultural Commodities Act)",
      "07:0601" : "07:0601 (07:601 USDA Condemnation)",
      "07:2321" : "07:2321 (07:2321 Plant Variety Protection Act)",
      "08:1105" : "08:1105 (8:1105(a) Aliens: Habeas Corpus to Release INS Det)",
      "08:1182" : "08:1182 (8:1182 Defend. Denial of Pla. Appl. for Alien Employment Cer)",
      "08:1252" : "08:1252 (08:1252(a)(2) Injunction for Deportation)",
      "08:1260" : "08:1260 (08:1260 Aliens: Access to Records)",
      "08:1324" : "08:1324 (08:1324 Aliens: Complaint for Forfeiture)",
      "08:1329" : "08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petiti)",
      "08:1446" : "08:1446 (8:1446 Petition for Naturalization Hearing)",
      "08:1451(j)" : "08:1451(j) (8:1451(j) Motion to Correct Order & Judg. of Naturalization)",
      "09:0001" : "09:0001 (09:1 U.S. Arbitration Act)",
      "09:0009" : "09:0009 (9:9 Motion to Confirm Arbitration Loan)",
      "09:0010" : "09:0010 (09:0010 Petition to Vacate Arbitration Award)",
      "10:1408" : "10:1408 (10:1408 Claim for Military Retirement)",
      "10:1552" : "10:1552 (10:1552 Armed Forces: Action to Correct Records)",
      "10:1553" : "10:1553 (10:1553 Armed Forces: FOIA General)",
      "10:2305" : "10:2305 (10:2305 Review of Federal Contract)",
      "11:0101" : "11:0101 (11:101 Bankruptcy)",
      "12:0022" : "12:0022 (12:22 Securities Fraud)",
      "12:0635" : "12:0635 (12:635 Breach of Insurance Contract)",
      "12:1461" : "12:1461 (12:1461 Homeowners Loan Act)",
      "12:1464" : "12:1464 (12:1464 Federal Savings and Loan)",
      "12:1703" : "12:1703 (12:1703 Default of HUD Loan)",
      "12:1725" : "12:1725 (12:1725 Collection under Contract Guaranty)",
      "12:1730" : "12:1730 (12:1730 Collection Under Contract Guaranty)",
      "12:1819" : "12:1819 (12:1819 Default of Promissory Note)",
      "12:1821" : "12:1821 (12:1821 Default of Loan by Promissary Note)",
      "12:191" : "12:191 (12:191 Bank Foreclosure)",
      "12:192" : "12:192 (12:192 Liquidation of National Bank)",
      "12:1971" : "12:1971 (12:1971 Relief under Bank Holding Act)",
      "12:1972" : "12:1972 (12:1972 Typing Arrangement Act)",
      "12:3410" : "12:3410 (12:3410 Right to Financial Privacy Act)",
      "15:0001" : "15:0001 (15:1 Antitrust Litigation)",
      "15:0002at" : "15:0002at (15:2 Antitrust Litigation)",
      "15:0002fl" : "15:0002fl (15:2(a) Fair Labor Standards Act)",
      "15:0005" : "15:0005 (15:5(a) Fair Labor Standards Act)",
      "15:0015" : "15:0015 (15:15 Antitrust Litigation)",
      "15:0025" : "15:0025 (15:25 Clayton Act)",
      "15:0044" : "15:0044 (15:44 Trademark Infringement)",
      "15:0045" : "15:0045 (15:0045 Federal Trade Commission Act)",
      "15:0052" : "15:0052 (15:0052 Federal Trade Commission Act)",
      "15:0053" : "15:0053 (15:0053 Federal Trade Commission Act)",
      "15:0077" : "15:0077 (15:77 Securities Fraud)",
      "15:0078" : "15:0078 (15:78m(a) Securities Exchange Act)",
      "15:0631" : "15:0631 (15:631 Small Business Act)",
      "15:0717" : "15:0717 (15:717 Natural Gas Act)",
      "15:0754" : "15:0754 (15:754 Emergency Petroleum Allocation-Admin.& Enforcement)",
      "15:1051" : "15:1051 (15:1051 Trademark Infringement)",
      "15:1114" : "15:1114 (15:1114 Trademark Infringement)",
      "15:1121" : "15:1121 (15:1121 Trademark Infringement)",
      "15:1125" : "15:1125 (15:1125 Trademark Infringement (Lanham Act))",
      "15:1126" : "15:1126 (15:1126 Patent Infringement)",
      "15:1127" : "15:1127 (15:1127 Trademark Infringement)",
      "15:1601" : "15:1601 (15:1601 Truth in Lending)",
      "15:1640" : "15:1640 (15:1640 Truth in Lending)",
      "15:1681" : "15:1681 (15:1681 Fair Credit Reporting Act)",
      "15:1692" : "15:1692 (15:1692 Fair Debt Collection Act)",
      "15:1938" : "15:1938 (15:1938 Fair Labor Standards Act)",
      "15:1981" : "15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))",
      "15:1988" : "15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))",
      "15:1989" : "15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))",
      "15:2301" : "15:2301 (15:2301 Magnuson-Moss Warranty Act)",
      "15:2801" : "15:2801 (15:2801 Petroleum Marketing Practices Act)",
      "15:53(b)" : "15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equita)",
      "16:0668" : "16:0668 (16:668 Bald Eagle Protection Act)",
      "16:0703" : "16:0703 (16:703 Migratory Bird Act)",
      "16:1538" : "16:1538 (16:1538 Endangered Species Act)",
      "16:3371" : "16:3371 (16:3371 Wildlife Under the Lacey Act)",
      "16:3372" : "16:3372 (16:3372 Conservation: Complaint for Forfeiture)",
      "16:3373" : "16:3373 (16:3373 Appeal of Decision - DOI)",
      "16:3374" : "16:3374 (16:3374 Conservation: Complaint for Forfeiture)",
      "17:0101" : "17:0101 (17:101 Copyright Infringement)",
      "17:0501" : "17:0501 (17:501 Copyright Infringement)",
      "17:0504" : "17:0504 (17:504 Copyright Infringement)",
      "18:0241" : "18:0241 (18:241 Conspiracy Against Citizen Rights)",
      "18:1836a" : "18:1836a (18:1836(a) Injunction against Misappropriation of Trade Secrets)",
      "18:1836b" : "18:1836b (18:1836(b) Civil Action to Protect Trade Secrets)",
      "18:1961" : "18:1961 (18:1961 Racketeering (RICO) Act)",
      "18:1962" : "18:1962 (18:1962 Racketeering (RICO) Act)",
      "18:1964" : "18:1964 (18:1964 Racketeering (RICO) Act)",
      "18:2511" : "18:2511 (18:2511 Wiretapping)",
      "18:3114" : "18:3114 (18:3114 Motion for Return of Seized Property)",
      "18:4208" : "18:4208 (18:4208(B) Agency Action Review)",
      "19:1305" : "19:1305 (19:1305 Custom Duties:0Forfeiture-Immoral Articles)",
      "20:1080" : "20:1080 (20:1080 Student Loan Recovery)",
      "20:1400" : "20:1400 (20:1400 Civil Rights of Handicapped Child)",
      "20:1401" : "20:1401 (20:1401 Education: Handicapped Child Act)",
      "21:0841" : "21:0841 (21:841 Forfeiture Property-Drugs)",
      "21:0881" : "21:0881 (21:881 Forfeiture Property-Drugs)",
      "21:0881a" : "21:0881a (21:881 Forfeiture Property - Aircraft)",
      "21:0881re" : "21:0881re (21:881 Forfeiture Property - Real Estate)",
      "23:0134" : "23:0134 (23:134 P.I.- Auto Negligence)",
      "23:1441" : "23:1441 (23:1441 Contract Real Estate)",
      "24:1000" : "24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)",
      "25:0640" : "25:0640 (25:640 Indian Tribal Rights)",
      "25:1901" : "25:1901 (25:1901 Indian Child Welfare Act)",
      "26:6212" : "26:6212 (26:6212 Injunctive Relief from IRS Lien)",
      "26:6213" : "26:6213 (26:6213 Injunctive Relief from IRS Lien)",
      "26:6502" : "26:6502 (26:6502 IRS:Enforcement of tax liens)",
      "26:6532" : "26:6532 (26:6532 IRS: Refund of Tax Penalty)",
      "26:6702" : "26:6702 (26:6702 IRS: Refund of Income Tax Penalty)",
      "26:6703" : "26:6703 (26:6703 IRS: Refund of Tax Penalty)",
      "26:7401" : "26:7401 (26:7401 IRS: Tax Liability)",
      "26:7402" : "26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)",
      "26:7403" : "26:7403 (26:7403 Suit to Enforce Federal Tax Lien)",
      "26:7422rt" : "26:7422rt (26:7422 IRS: Refund Taxes)",
      "26:7422rx" : "26:7422rx (26:7422 IRS: Refund Excise Tax)",
      "26:7426" : "26:7426 (26:7426 IRS: Wrongful Levy for Taxes)",
      "26:7429" : "26:7429 (26:7429 IRS: Tax Jeopardy Assessment)",
      "26:7609" : "26:7609 (26:7609 IRS: Petition to Quash IRS Summons)",
      "27:0185" : "27:0185 (27:185 Enforcement of Arbitration Award)",
      "28:0157c" : "28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)",
      "28:0157d" : "28:0157d (28:0157 Motion for Withdrawal of Reference)",
      "28:0158" : "28:0158 (28:0158 Notice of Appeal re Bankruptcy Matter (BA)",
      "28:0185" : "28:0185 (28:185 Suit to Compel Arbitration)",
      "28:0451" : "28:0451 (28:451 Employment Discrimination)",
      "28:0754" : "28:0754 (28:754 Receiver of Property in Different Districts)",
      "28:0794" : "28:0794 (28:794 Rehabilitation Act)",
      "28:1001" : "28:1001 (28:1001 E.R.I.S.A.)",
      "28:1132" : "28:1132 (28:1132 E.R.I.S.A.)",
      "28:1330" : "28:1330 (28:1330 Breach of Contract)",
      "28:1331" : "28:1331 (28:1331 Fed. Question)",
      "28:1331al" : "28:1331al (28:1331 Fed. Question: Airline Crash)",
      "28:1331at" : "28:1331at (28:1331 Fed. Question: Anti-trust)",
      "28:1331au" : "28:1331au (28:1331 Fed. Question: Auto Negligence)",
      "28:1331b" : "28:1331b (28:1331 Federal Question: Bivens Act)",
      "28:1331bc" : "28:1331bc (28:1331 Fed. Question: Breach of Contract)",
      "28:1331ca" : "28:1331ca (28:1331 Fed Question: Fed Communications Act of 1)",
      "28:1331cm" : "28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)",
      "28:1331cv" : "28:1331cv (28:1331 Federal Question: Other Civil Rights)",
      "28:1331ed" : "28:1331ed (28:1331 Fed. Question: Employment Discrimination)",
      "28:1331ej" : "28:1331ej (28:1331 Federal Question: Enforcement of Judgment)",
      "28:1331es" : "28:1331es (28:1331 Enforcement of Administrative Subpoena)",
      "28:1331fl" : "28:1331fl (28:1331 Fed. Question: Fair Labor Standards)",
      "28:1331in" : "28:1331in (28:1331 Fed. Question: Insurance Contract)",
      "28:1331mm" : "28:1331mm (28:1331 Fed. Question: Medical Malpractice)",
      "28:1331ng" : "28:1331ng (28:1331 Fed. Question: Natural Gas Act)",
      "28:1331pi" : "28:1331pi (28:1331 Fed. Question: Personal Injury)",
      "28:1331rd" : "28:1331rd (28:1331 Fed. Question: Review Agency Decision)",
      "28:1331rp" : "28:1331rp (28:1331(a) Fed. Question: Real Property)",
      "28:1331rr" : "28:1331rr (28:1331 Fed. Question: Railway Labor Act)",
      "28:1331sv" : "28:1331sv (28:1331 Fed. Question: Securities Violation)",
      "28:1331tr" : "28:1331tr (28:1331 Fed. Question: Trademark)",
      "28:1331tt" : "28:1331tt (28:1331 Fed. Question: Tort Action)",
      "28:1331v" : "28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendme)",
      "28:1331wl" : "28:1331wl (28:1331 Federal Question: EPA Waste Lien)",
      "28:1331wt" : "28:1331wt (28:1331 Fed. Question: Water Rights)",
      "28:1332ac" : "28:1332ac (28:1332 Diversity-Account Receivable)",
      "28:1332al" : "28:1332al (28:1332 Diversity-Airline Crash)",
      "28:1332as" : "28:1332as (28:1332 Diversity-Asbestos Litigation)",
      "28:1332au" : "28:1332au (28:1332 Diversity-Auto Negligence)",
      "28:1332bc" : "28:1332bc (28:1332 Diversity-Breach of Contract)",
      "28:1332co" : "28:1332co (28:1332 Diversity-Conversion)",
      "28:1332ct" : "28:1332ct (28:1332 Diversity-(Citizenship))",
      "28:1332det" : "28:1332det (28:1332 Diversity: Forcible Detainer)",
      "28:1332df" : "28:1332df (28:1332 Diversity-Contract Default)",
      "28:1332ds" : "28:1332ds (28:1332 Diversity-Contract Dispute)",
      "28:1332ed" : "28:1332ed (28:1332 Diversity-Employment Discrimination)",
      "28:1332fd" : "28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)",
      "28:1332fr" : "28:1332fr (28:1332 Diversity-Fraud)",
      "28:1332ia" : "28:1332ia (28:1332 Diversity-Interpleader Action)",
      "28:1332ij" : "28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)",
      "28:1332in" : "28:1332in (28:1332 Diversity-Insurance Contract)",
      "28:1332jd" : "28:1332jd (28:1332 Diversity-Declaratory Judgement)",
      "28:1332lb" : "28:1332lb (28:1332 Diversity-Libel,Assault,Slander)",
      "28:1332lm" : "28:1332lm (28:1332 Diversity - Legal Malpractice)",
      "28:1332ma" : "28:1332ma (28:1332 Diversity-Miller Act)",
      "28:1332mm" : "28:1332mm (28:1332 Diversity-Medical Malpractice)",
      "28:1332mv" : "28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)",
      "28:1332ni" : "28:1332ni (28:1332 Diversity-Negotiable Instrument)",
      "28:1332nm" : "28:1332nm (28:1332 Diversity-Non-Motor Vehicle)",
      "28:1332nr" : "28:1332nr (28:1332 Diversity-Notice of Removal)",
      "28:1332oc" : "28:1332oc (28:1332 Diversity-Other Contract)",
      "28:1332pd" : "28:1332pd (28:1332 Diversity-Property Damage)",
      "28:1332pi" : "28:1332pi (28:1332 Diversity-Personal Injury)",
      "28:1332pl" : "28:1332pl (28:1332 Diversity-Product Liability)",
      "28:1332pr" : "28:1332pr (28:1332 Diversity-Petition for Removal)",
      "28:1332qt" : "28:1332qt (28:1332 Diversity-Petition to Quiet Title)",
      "28:1332ri" : "28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)",
      "28:1332sa" : "28:1332sa (28:1332 - Diversity: Securities & Exchange Commiss)",
      "28:1332sf" : "28:1332sf (28:1332 - Diversity: Securities Fraud)",
      "28:1332ss" : "28:1332ss (28:1332 Diversity - Stockholders Suits)",
      "28:1332tl" : "28:1332tl (28:1332 Diversity-Torts to Land)",
      "28:1332tm" : "28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))",
      "28:1332tn" : "28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)",
      "28:1332wd" : "28:1332wd (28:1332 Diversity-Wrongful Death)",
      "28:1333" : "28:1333 (28:1333 Admiralty)",
      "28:1334" : "28:1334 (28:1334 Bankruptcy Appeal)",
      "28:1334c" : "28:1334c (28:1334(c) R&R re motions for abstention (non-cor)",
      "28:1335" : "28:1335 (28:1335 Interpleader Action)",
      "28:1337" : "28:1337 (28:1337 Sherman-Clayton Act)",
      "28:1338cp" : "28:1338cp (28:1338 Copyright Infringement)",
      "28:1338pt" : "28:1338pt (28:1338 Patent Infringement)",
      "28:1338tr" : "28:1338tr (28:1338 Trademark Infringement)",
      "28:1340" : "28:1340 (28:1340 IRS: Custom Duties)",
      "28:1340er" : "28:1340er (28:1340 Recovery of Erroneous Refund)",
      "28:1341" : "28:1341 (28:1341 Complaint for Forfeiture)",
      "28:1343" : "28:1343 (28:1343 Violation of Civil Rights)",
      "28:1345" : "28:1345 (28:1345 USA Plaintiff)",
      "28:1345co" : "28:1345co (28:1345 Replevin & Conversion)",
      "28:1345db" : "28:1345db (28:1345 Debt to US - FHA/HUD Title I)",
      "28:1345df" : "28:1345df (28:1345 Default of Promissory Note)",
      "28:1345er" : "28:1345er (28:1345 Recovery of Erroneous Refund)",
      "28:1345fc" : "28:1345fc (28:1345 Foreclosure)",
      "28:1345ff" : "28:1345ff (28:1345 Complaint for Forfeiture)",
      "28:1345hl" : "28:1345hl (28:1345 VA Home Loan Guaranty Debt)",
      "28:1345mc" : "28:1345mc (28:1345 Medical Care Recovery)",
      "28:1345mi" : "28:1345mi (28:1345 Mining Claim Ejectment)",
      "28:1345pd" : "28:1345pd (28:1345 Property Damage)",
      "28:1345pe" : "28:1345pe (28:1345 Property Ejectment)",
      "28:1345rc" : "28:1345rc (28:1345 Recovery of Debt to US)",
      "28:1345st" : "28:1345st (28:1345 Default of Student Loan)",
      "28:1345tp" : "28:1345tp (28:1345 Trespass on Public Land)",
      "28:1345va" : "28:1345va (28:1345 Recovery of VA Overpayment)",
      "28:1346bc" : "28:1346bc (28:1346 Breach of Contract)",
      "28:1346rc" : "28:1346rc (28:1346 Recovery of IRS Tax)",
      "28:1346tc" : "28:1346tc (28:1346 Tort Claim)",
      "28:1346wd" : "28:1346wd (28:1346 Wrongful Death)",
      "28:1349" : "28:1349 (28:1348 Corporation organized under Federal Law as party)",
      "28:1352" : "28:1352 (28:1352 Miller Act)",
      "28:1355" : "28:1355 (28:1355 Petition for Return of Property)",
      "28:1358" : "28:1358 (28:1358 Land Condemnation)",
      "28:1361" : "28:1361 (28:1361 Petition for Writ of Mandamus)",
      "28:1362ic" : "28:1362ic (28:1362 Indian Tribal Controversy)",
      "28:1362iw" : "28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)",
      "28:1364" : "28:1364 (28:1364 Auto Negligence)",
      "28:1391" : "28:1391 (28:1391 Personal Injury)",
      "28:1402" : "28:1402 (28:1402 Medical Malpractice)",
      "28:1407" : "28:1407 (28:1407 Airline Crash)",
      "28:1441ac" : "28:1441ac (28:1441 Petition for Removal- Account Receivable)",
      "28:1441al" : "28:1441al (28:1441 Petition for Removal- Airline Crash)",
      "28:1441as" : "28:1441as (28:1441 Petition for Removal- Asbestos Litigation)",
      "28:1441au" : "28:1441au (28:1441 Petition for Removal- Auto Negligence)",
      "28:1441bc" : "28:1441bc (28:1441 Petition for Removal- Breach of Contract)",
      "28:1441cv" : "28:1441cv (28:1441 Petition for Removal- Civil Rights Act)",
      "28:1441df" : "28:1441df (28:1441 Petition for Removal- Contract Default)",
      "28:1441dj" : "28:1441dj (28:1441 Petition for Removal- Declaratory Judgemen)",
      "28:1441ds" : "28:1441ds (28:1441 Petition for Removal- Contract Dispute)",
      "28:1441ed" : "28:1441ed (28:1441 Petition for Removal - Employment Discrim)",
      "28:1441fc" : "28:1441fc (28:1441 Petition for Removal - Fair Credit Reporti)",
      "28:1441fr" : "28:1441fr (28:1441 Petition for Removal- Fraud)",
      "28:1441ij" : "28:1441ij (28:1441 Petition for Removal- Injunctive/Declarato)",
      "28:1441in" : "28:1441in (28:1441 Petition for Removal- Insurance Contract)",
      "28:1441int" : "28:1441int (28:1441 Petition for Removal- Action for Interplea)",
      "28:1441lb" : "28:1441lb (28:1441 Petition for Removal Libel,Assault,Slander)",
      "28:1441lm" : "28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relatio)",
      "28:1441mm" : "28:1441mm (28:1441 Petition for Removal- Medical Malpractice)",
      "28:1441ni" : "28:1441ni (28:1441 Petition for Removal- Negotiable Instrumen)",
      "28:1441nm" : "28:1441nm (28:1441 Petition for Removal- Non-Motor Vehicle)",
      "28:1441nr" : "28:1441nr (28:1441 Notice of Removal)",
      "28:1441oc" : "28:1441oc (28:1441 Petition For Removal--Other Contract)",
      "28:1441pd" : "28:1441pd (28:1441 Petition for Removal- Property Damage)",
      "28:1441pi" : "28:1441pi (28:1441 Petition for Removal- Personal Injury)",
      "28:1441pl" : "28:1441pl (28:1441 Petition for Removal- Product Liability)",
      "28:1441pr" : "28:1441pr (28:1441 Petition for Removal)",
      "28:1441qt" : "28:1441qt (28:1441 Petition for Removal- Petition to Quiet Ti)",
      "28:1441ri" : "28:1441ri (28:1441 Petition for Removal- Racketeering (RICO))",
      "28:1441sa" : "28:1441sa (28:1441 - Petition for Removal: SEC Act)",
      "28:1441sf" : "28:1441sf (28:1441 - Petition for Removal: Securities Fraud)",
      "28:1441tl" : "28:1441tl (28:1441 Petition for Removal- Torts to Land)",
      "28:1441tm" : "28:1441tm (28:1441 Petition for Removal- Tort/Motor Vehicle ()",
      "28:1441tn" : "28:1441tn (28:1441 Petition for Removal- Tort/Non-Motor Vehic)",
      "28:1441wd" : "28:1441wd (28:1441 Petition for Removal- Wrongful Death)",
      "28:1442bc" : "28:1442bc (28:1442 Petition for Removal- Breach of Contract)",
      "28:1442nr" : "28:1442nr (28:1442 Notice of Removal)",
      "28:1442pr" : "28:1442pr (28:1442 Petition for Removal)",
      "28:1443" : "28:1443 (28:1443(1) Rent, Lease & Ejectment)",
      "28:1444" : "28:1444 (28:1444 Petition for Removal- Foreclosure)",
      "28:1446in" : "28:1446in (28:1446 Breach of Contract- Insurance)",
      "28:1446nr" : "28:1446nr (28:1446 Notice of Removal)",
      "28:1446pd" : "28:1446pd (28:1446 Petition for Removal- Property Damage (P.I)",
      "28:1446pi" : "28:1446pi (28:1446 Petition for Removal- Personal Injury)",
      "28:1446pl" : "28:1446pl (28:1446pl Petition for Removal - Product Liability)",
      "28:1446pr" : "28:1446pr (28:1446 Petition for Removal)",
      "28:1452" : "28:1452 (28:1452 R&R re motions to remand (non-core))",
      "28:1651" : "28:1651 (28:1651 Petition for Writ of Coram Nobis)",
      "28:1651hc" : "28:1651hc (28:1651 Petition for Writ of Habeas Corpus)",
      "28:1651mn" : "28:1651mn (28:1651 Petition for Writ of Mandamus)",
      "28:1782" : "28:1782 (28:1782 Letter rogatory - appointment)",
      "28:1983" : "28:1983 ((DO NOT USE) 28:1983 Civil Rights)",
      "28:2201" : "28:2201 (28:2201 Constitutionality of State Statute(s))",
      "28:2201dj" : "28:2201dj (28:2201 Declaratory Judgement)",
      "28:2201ij" : "28:2201ij (28:2201 Injunction)",
      "28:2201in" : "28:2201in (28:2201 Declaratory Judgement (Insurance))",
      "28:2241" : "28:2241 (28:2241 Petition for Writ of Habeas Corpus (federa)",
      "28:2254" : "28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))",
      "28:2254se" : "28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)",
      "28:2255" : "28:2255 (28:2255 Motion to Vacate / Correct Illegal Sentenc)",
      "28:2271" : "28:2271 (28:2271 Federal Tort Claims Act)",
      "28:2345" : "28:2345 (28:2345 Medicare Recovery)",
      "28:2409" : "28:2409 (28:2409(a) Quiet Title Action)",
      "28:2410" : "28:2410 (28:2410 Quiet Title)",
      "28:2671" : "28:2671 (28:2671 Federal Tort Claims Act)",
      "28:2674" : "28:2674 (28:2674 Federal Tort Claims Act)",
      "28:3001" : "28:3001 (28:3001 Federal Debt Collection Act)",
      "28:7402" : "28:7402 (28:7402 Refund of Taxes)",
      "28:7422" : "28:7422 (28:7422 Appeal from Administrative Decision)",
      "29:0151" : "29:0151 (29:151 Labor: Review of Agency Action)",
      "29:0160" : "29:0160 (29:160(1) National Labor Relations Act)",
      "29:0184" : "29:0184 (29:184 Violation Collection Bargain Agreement)",
      "29:0185ep" : "29:0185ep (29:185 Employee Pension Plan)",
      "29:0185lm" : "29:0185lm (29:185 Labor/Mgt. Relations (Contracts))",
      "29:0201do" : "29:0201do (29:201 Denial of Overtime Compensation)",
      "29:0201fl" : "29:0201fl (29:201 Fair Labor Standards Act)",
      "29:0203" : "29:0203 (29:203 Equal Pay Act)",
      "29:0206" : "29:0206 (29:206 Collect Unpaid Wages)",
      "29:0401" : "29:0401 (29:0401 Labor Management Disclosure Act)",
      "29:0621" : "29:0621 (29:621 Job Discrimination (Age))",
      "29:0623" : "29:0623 (29:623 Job Discrimination (Age))",
      "29:0626" : "29:0626 (29:626 Job Discrimination (Age))",
      "29:0633" : "29:0633 (29:633 Job Discrimination (Age))",
      "29:0651" : "29:0651 (29:651 Occupational Safety/Health)",
      "29:0754" : "29:0754 (29:754 Discrimination)",
      "29:0791" : "29:0791 (29:791 Job Discrimination (Rehabilitation Act))",
      "29:0794" : "29:0794 (29:0794 Job Discrimination (Handicap))",
      "29:1001" : "29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)",
      "29:1002" : "29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)",
      "29:1104" : "29:1104 (29:1104 Recovery of Benefits to Employee)",
      "29:1109" : "29:1109 (29:1109 Breach of Fiduciary Duties)",
      "29:1131" : "29:1131 (29:1131 ERISA - Collection of Delinquent Trust Fun)",
      "29:1132" : "29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)",
      "29:1145" : "29:1145 (29:1145 E.R.I.S.A.)",
      "29:1149" : "29:1149 (29:1149 Recover Pension & Profit Sharing)",
      "29:1337" : "29:1337 (29:1337 E.R.I.S.A.)",
      "29:1362" : "29:1362 (29:1362 ERISA)",
      "29:1381" : "29:1381 (29:1381 E.R.I.S.A.)",
      "29:1401" : "29:1401 (29:1401(b)(2) Appeal of Arbitration Award)",
      "29:1451" : "29:1451 (29:1451 E.R.I.S.A.)",
      "29:1801" : "29:1801 (29:1801 Farmworker Rights)",
      "29:2601" : "29:2601 (29:2601 Family and Medical Leave Act)",
      "29:790" : "29:790 (29:790 Rehabilitation of Labor)",
      "30:0181" : "30:0181 (30:181 Environment: Review of Agency Action)",
      "30:0801" : "30:0801 (30:0801 Penalities/Federal Mine Safety Health Act)",
      "30:1201" : "30:1201 (30:1201 Environment: Review of Agency Action)",
      "30:1202" : "30:1202 (30:1202 Mining Reclamation Act)",
      "30:1276" : "30:1276 (30:1276 Interior: Review of Agency Action)",
      "31:3545" : "31:3545 (31:3545 Action to Recovery Money)",
      "31:3729" : "31:3729 (31:3729 False Claims Act)",
      "31:3730" : "31:3730 (31:3730 Qui Tam False Claims Act)",
      "31:3731" : "31:3731 (31:3731 Fraud)",
      "33:1319cw" : "33:1319cw (33:1319 Clean Water Act)",
      "33:1319pv" : "33:1319pv (33:1319 Pollutants & Permit Violations)",
      "33:1365" : "33:1365 (33:1365 Environmental Matters)",
      "35:0145" : "35:0145 (35:145 Patent Infringement)",
      "35:0183" : "35:0183 (35:183 Patent Infringement)",
      "35:0271" : "35:0271 (35:271 Patent Infringement)",
      "38:1681" : "38:1681 (38:1681 Recovery of VA Overpayment)",
      "38:1686" : "38:1686 (38:1686 Recovery of VA Overpayment)",
      "38:1780" : "38:1780 (38:1780 Recovery of VA Overpayment)",
      "38:2011" : "38:2011 (38:2011 - Veteran's Readjustment Assistance Act of)",
      "38:2021" : "38:2021 (Right to re-employment of inducted persons)",
      "38:3116" : "38:3116 (38:3116 VA Overpayment)",
      "38:4301" : "38:4301 (38:4301 Uniformed Services Employment and Reemployment Rights Act of 1994 (USERRA))",
      "38:775" : "38:775 (Recovery of Servicemen's Group Life Insurance)",
      "39:3005" : "39:3005 (39:3005 Detention of Mail for Temporary Periods)",
      "39:409" : "39:409 (39:409 Postal Service)",
      "40:0258" : "40:0258 (40:258(a) Public Buildings & Property: Land Condem)",
      "40:0270" : "40:0270 (40:270 Miller Act)",
      "40:0875" : "40:0875 (40:875 Public Buildings & Property: Negligence)",
      "41:0251" : "41:0251 (41:251 Public Contracts-Review of Agency Action)",
      "41:1463" : "41:1463 (41:1463 Public Contracts: Unlawful Employment Prac)",
      "42:0205" : "42:0205 (42:205 Denial Social Security Benefits)",
      "42:0206" : "42:0206 (42:206 Social Security Benefits)",
      "42:0247" : "42:0247 (42:247 Personal Injury-Swine Flu)",
      "42:0402" : "42:0402 (42:402 Social Security Benefits)",
      "42:0405id" : "42:0405id (42:405 Review of HHS Decision (SSID))",
      "42:0405wc" : "42:0405wc (42:405 Review of HHS Decision (DIWC))",
      "42:0405ww" : "42:0405ww (42:405 Review of HHS Decision (DIWW))",
      "42:0416" : "42:0416 (42:416 Denial of Social Security Benefits)",
      "42:0427" : "42:0427 (42:427 Social Security Benefits)",
      "42:1383" : "42:1383 (42:1383 Review of HHS Decision)",
      "42:1395" : "42:1395 (42:1395 HHS: Adverse Reimbursement Review)",
      "42:1396" : "42:1396 (42:1396 - Tort Negligence)",
      "42:1471" : "42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclo)",
      "42:1981cv" : "42:1981cv (42:1981 Civil Rights)",
      "42:1981hs" : "42:1981hs (42:1981 Housing Discrimination)",
      "42:1981jb" : "42:1981jb (42:1981 Job Discrimination (Race))",
      "42:1981sx" : "42:1981sx (42:1981 Sex Discrimination)",
      "42:1983cv" : "42:1983cv (42:1983 Civil Rights Act)",
      "42:1983ed" : "42:1983ed (42:1983 Civil Rights (Employment Discrimination))",
      "42:1983pr" : "42:1983pr (42:1983 Prisoner Civil Rights)",
      "42:1986" : "42:1986 (42:1986 Neglect of Duty)",
      "42:2000ag" : "42:2000ag (42:2000 Job Discrimination (Age))",
      "42:2000e" : "42:2000e (42:2000e Job Discrimination (Employment))",
      "42:2000pb" : "42:2000pb (42:2000 Job Discrimination (Public Accomodations))",
      "42:2000ra" : "42:2000ra (42:2000 Job Discrimination (Race))",
      "42:2000sx" : "42:2000sx (42:2000 Job Discrimination (Sex))",
      "42:2003" : "42:2003 (42:2003 Job Discrimination)",
      "42:2005" : "42:2005 (42:2005 Review of Agency Action-HHS)",
      "42:2615" : "42:2615 (42:2616 Medical Recovery Act)",
      "42:2651" : "42:2651 (42:2651 Medical Care Recovery)",
      "42:3601" : "42:3601 (42:405 Fair Housing Act)",
      "42:4000" : "42:4000 (42:4000 National Flood Insurance Act)",
      "42:4001" : "42:4001 (42:4001 National Insurance Flood Act)",
      "42:4053" : "42:4053 (42:4053 Breach of Insurance Contract)",
      "42:4072" : "42:4072 (42:4072 Payment of Flood Insurance Claim)",
      "42:4321" : "42:4321 (42:4321 Review of Agency Action-Environment)",
      "42:4332" : "42:4332 (42:4332 Environmental Policy - Coop of Agency Repo)",
      "42:6901en" : "42:6901en (42:6901 Environmental Cleanup Expenses)",
      "42:6901rs" : "42:6901rs (42:6901 Resource & Recovery Act)",
      "42:7413" : "42:7413 (42:7413(b) Clean Air Act)",
      "42:7604cl" : "42:7604cl (42:7604 Clear Air Act (Emission Standards))",
      "42:7604ir" : "42:7604ir (42:7604 Petition to Quash IRS Summons)",
      "42:9607" : "42:9607 (42:9607 Real Property Tort to Land)",
      "43:945" : "43:945 (43:945 Compensation for Land Condemnation)",
      "43:945a" : "43:945a (43:945a Complaint in Condemnation)",
      "43:946" : "43:946 (43:946 Complaint in Condemnation - Eminent Domain)",
      "45:0051" : "45:0051 (45:51 Railways: Fed. Employer's Liability Act)",
      "45:0151" : "45:0151 (45:151 Railway Labor Act)",
      "45:0184" : "45:0184 (45:184 Action to Set Aside Award of a System Board)",
      "45:1395" : "45:1395 (45:1395 Railroads: Adverse Reimbursement Review)",
      "45:7457" : "45:7457 (45:7457 Compel Reclamation Under Clear Air Act)",
      "46:0183" : "46:0183 (46:183 Limitation of Liability)",
      "46:0688" : "46:0688 (46:688 Jones Act)",
      "46:0741" : "46:0741 (46:741 Shipping)",
      "46:0761" : "46:0761 (46:761 Shipping: Damages for Death on High Seas)",
      "46:1101" : "46:1101 (46:1101 Violation of Maritime Regulations)",
      "46:1156" : "46:1156 (46:1156 Administrative Procedure Act)",
      "46:688USC" : "46:688USC (46:688 Jones Act)",
      "48:0883" : "48:0883 (48:883 Violation of US Coastal Law)",
      "48:1985" : "48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)",
      "49:0081" : "49:0081 (49:81 Damaged Goods While Being Transported)",
      "49:0781" : "49:0781 (49:781 Forfeiture)",
      "49:11503" : "49:11503 (49:11503 Railroad Revitalization Regulatory Reform)",
      "49:11702" : "49:11702 (49:11702(a)(4) Violations of Interstate Commerce A)",
      "49:1471" : "49:1471 (49:1471 Federal Aviation Act)",
      "49:1903" : "49:1903 (49:1903 Petition to enforce administrative summon)",
      "8:287" : "8:287 (8:287 Petition to Enforce INS Subpoena)",
      "99:9999" : "99:9999 (99:9999 Report cause code (DO NOT DELETE!))",
      "adsup" : "adsup (Administrative Subpoena)",
      "contempt" : "contempt (Contempt Proceedings)",
      "disbar" : "disbar (Disbarment Proceedings)",
      "enlvy" : "enlvy (Application for entry on premises to effect levy)",
      "fordepo" : "fordepo (Foreign Deposition)",
      "misc" : "misc (Civil Miscellaneous Case)",
      "motcomp" : "motcomp (Motion to Compel)",
      "motquash" : "motquash (Motion to Quash)",
      "motret" : "motret (Motion for Return of Property)",
      "petenf" : "petenf (Petition to Enforce IRS Summons)",
      "petper" : "petper (Petition to Perpetuate Testimony)",
      "regigm" : "regigm (Registration of Foreign Judgement)",
      "regjgm" : "regjgm (Registration of Foreign Judgment)",
      "stano" : "stano (Standing Order)",
      "tranbkref" : "tranbkref (Transmission of Bankruptcy Reference)",
      "tranff" : "tranff (Transmission of Proposed Findings of Fact and Concl. of Law)",
      "writgar" : "writgar (Application for a Writ of Garnishment)"
   },
   "flsdce" : {
      "0" : "0 (no cause specified)",
      "02:0431" : "02:0431 (02:0431 Fed. Election Commission: Failure Enforce Compliance)",
      "02:0437" : "02:0437 (02:0437 Federal Election Commission)",
      "05:0075" : "05:0075 (05:0075(2) Contract - Reduction in Grade)",
      "05:0551" : "05:0551 (05:0551 Administrative Procedure Act)",
      "05:0552fi" : "05:0552fi (05:0552 Freedom of Information Act)",
      "05:0552pa" : "05:0552pa (05:0552 Right to Privacy Act)",
      "05:0554" : "05:0554 (05:0554 Constitutionality of Maritime Statutes)",
      "05:0701" : "05:0701 (05:0701 Maritime Subsidy Board)",
      "05:0702" : "05:0702 (05:0702 Administrative Procedure Act)",
      "05:0704" : "05:0704 (05:0704 Labor Litigation)",
      "05:7703" : "05:7703 (05:7703 Discrimination - Review of Agency Act)",
      "05:8470" : "05:8470 (05:8470 Enforcement of Judgment against Retirement Benefits)",
      "07:0006" : "07:0006 (7:6(b) Federal Commodity Exchange Regulation)",
      "07:0009" : "07:0009 (07:0009 Commodity Futures Trading Act)",
      "07:0025" : "07:0025 (07:0025 Fraud - Commodities Leverage Contracts)",
      "07:006(b)" : "07:006(b) (07:006 Federal Commodity Exchange Regulation)",
      "07:0181" : "07:0181 (07:0181 Packers & Stockyard Act)",
      "07:0499" : "07:0499 (07:0499 Agricultural Commodities Act)",
      "07:0601" : "07:0601 (07:0601 USDA Condemnation)",
      "07:2023a" : "07:2023a (07:2023a Food Stamp Program)",
      "07:2321" : "07:2321 (07:2321 Plant Variety Protection Act)",
      "08:1105" : "08:1105 (08:1105(a)Immigration and Nationality (Deportation Review))",
      "08:1182" : "08:1182 (08:1182 Defend. Denial of Pla. Appl. for Alien Employment Ce)",
      "08:1252" : "08:1252 (08:1252(a)(2) Injunction for Deportation)",
      "08:1260" : "08:1260 (08:1260 Aliens: Access to Records)",
      "08:1324" : "08:1324 (08:1324 Aliens: Complaint for Forfeiture)",
      "08:1329" : "08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petition)",
      "08:1446" : "08:1446 (08:1446 Petition for Naturalization Hearing)",
      "08:1451(j)" : "08:1451(j) (08:1451 Motion to Correct Order & Judg. of Naturalization)",
      "09:0001" : "09:0001 (09:0001 U.S. Arbitration Act)",
      "09:0009" : "09:0009 (09:0009 Motion to confirm arbitration award)",
      "09:0010" : "09:0010 (09:0010 Petition to Vacate Arbitration Award)",
      "10:1408" : "10:1408 (10:1408 Claim for Military Retirement)",
      "10:1552" : "10:1552 (10:1552 Armed Forces: Action to Correct Records)",
      "10:1553" : "10:1553 (10:1553 Armed Forces: FOIA General)",
      "10:2305" : "10:2305 (10:2305 Review of Federal Contract)",
      "11:0101" : "11:0101 (11:0101 Bankruptcy)",
      "11:0523" : "11:0523 (11:0523 Discharge of Tax Liability)",
      "11:0548" : "11:0548 (11:0548 Bankruptcy- Fraudulent Transfers)",
      "12:0022" : "12:0022 (12:0022 Securities Fraud)",
      "12:0191" : "12:0191 (12:0191 Bank Foreclosure)",
      "12:0192" : "12:0192 (12:0192 Liquidation of National Bank)",
      "12:0635" : "12:0635 (12:0635 Breach of Insurance Contract)",
      "12:1441" : "12:1441 (12:1441 Federal Mortgage Foreclosure)",
      "12:1461" : "12:1461 (12:1461 Homeowners Loan Act)",
      "12:1464" : "12:1464 (12:1464 Federal Savings and Loan)",
      "12:1703" : "12:1703 (12:1703 Default of HUD Loan)",
      "12:1725" : "12:1725 (12:1725 Collection under Contract Guaranty)",
      "12:1730" : "12:1730 (12:1730 Collection Under Contract Guaranty)",
      "12:1819" : "12:1819 (12:1819 Default of Promissory Note)",
      "12:1821" : "12:1821 (12:1821 Default of Loan by Promissary Note)",
      "12:1821(d)" : "12:1821(d) (12:1821 Claim for Indemnification)",
      "12:1971" : "12:1971 (12:1971 Relief under Bank Holding Act)",
      "12:3410" : "12:3410 (12:3410 Right to Financial Privacy Act)",
      "15:0001" : "15:0001 (15:0001 Antitrust Litigation)",
      "15:0002at" : "15:0002at (15:0002 Antitrust Litigation)",
      "15:0002fl" : "15:0002fl (15:0002 Fair Labor Standards Act)",
      "15:0005" : "15:0005 (15:5(a) Fair Labor Standards Act)",
      "15:0005(m)" : "15:0005(m) (15:0005 Fair Labor Standards Act)",
      "15:0015" : "15:0015 (15:0015 Antitrust Litigation)",
      "15:0025" : "15:0025 (15:0025 Clayton Act)",
      "15:0044" : "15:0044 (15:44 Trademark Infringement)",
      "15:0045" : "15:0045 (15:0045 Federal Trade Commission Act)",
      "15:0052" : "15:0052 (15:0052 Federal Trade Commission Act)",
      "15:0053" : "15:0053 (15:0053 Federal Trade Commission Act)",
      "15:0077" : "15:0077 (15:0077 Securities Fraud)",
      "15:0078" : "15:0078 (15:0078 Securities Exchange Act)",
      "15:0631" : "15:0631 (15:0631 Small Business Act)",
      "15:0717" : "15:0717 (15:717 Natural Gas Act)",
      "15:0754" : "15:0754 (15:0754 Emergency Petroleum Allocation-Admin.& Enforcement)",
      "15:1051" : "15:1051 (15:1051 Trademark Infringement)",
      "15:1114" : "15:1114 (15:1114 Trademark Infringement)",
      "15:1121" : "15:1121 (15:1121 Trademark Infringement)",
      "15:1125" : "15:1125 (15:1125 Trademark Infringement (Lanham Act))",
      "15:1126" : "15:1126 (15:1126 Patent Infringement)",
      "15:1127" : "15:1127 (15:1127 Trademark Infringement)",
      "15:1601" : "15:1601 (15:1601 Truth in Lending)",
      "15:1640" : "15:1640 (15:1640 Truth in Lending)",
      "15:1681" : "15:1681 (15:1681 Fair Credit Reporting Act)",
      "15:1692" : "15:1692 (15:1692 Fair Debt Collection Act)",
      "15:1701" : "15:1701 (15:1701 Interstate Land Sales Full Disclosure Act)",
      "15:1938" : "15:1938 (15:1938 Fair Labor Standards Act)",
      "15:1981" : "15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))",
      "15:1988" : "15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))",
      "15:1989" : "15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))",
      "15:2301" : "15:2301 (15:2301 Magnuson-Moss Warranty Act)",
      "15:2801" : "15:2801 (15:2801 Petroleum Marketing Practices Act)",
      "15:53(b)" : "15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equita)",
      "16:0410" : "16:0410 (16:0410 Land Condemnation)",
      "16:0668" : "16:0668 (16:0668 Bald Eagle Protection Act)",
      "16:0703" : "16:0703 (16:0703 Migratory Bird Act)",
      "16:1437" : "16:1437 (16:1437 Marine Sanctuaries Act (MPRSA))",
      "16:1538" : "16:1538 (16:1538 Endangered Species Act)",
      "16:1540" : "16:1540 (16:1540 ESA - Endangered Species Act)",
      "16:3371" : "16:3371 (16:3371 Wildlife Under the Lacey Act)",
      "16:3372" : "16:3372 (16:3372 Conservation: Complaint for Forfeiture)",
      "16:3373" : "16:3373 (16:3373 Appeal of Decision - DOI)",
      "16:3374" : "16:3374 (16:3374 Conservation: Complaint for Forfeiture)",
      "17:0101" : "17:0101 (17:0101 Copyright Infringement)",
      "17:0501" : "17:0501 (17:0501 Copyright Infringement)",
      "17:0504" : "17:0504 (17:504 Copyright Infringement)",
      "17:0512" : "17:0512 (17:0512 Limitations on liability relating to material online)",
      "18:0241" : "18:0241 (18:0241 Conspiracy Against Citizen Rights)",
      "18:0981" : "18:0981 (18:0981 Property forfeiture from criminal acts)",
      "18:0983" : "18:0983 (18:0983 Civil Asset Forfeiture Reform Act of 2000 (CAFRA))",
      "18:1030" : "18:1030 (Computer Fraud and Abuse Act)",
      "18:1836a" : "18:1836a (18:1836(a) Injunction against Misappropriation of Trade Secrets)",
      "18:1836b" : "18:1836b (18:1836(b) Civil Action to Protect Trade Secrets)",
      "18:1957" : "18:1957 (18:1957 Forfeiture - currency from criminal acts)",
      "18:1961" : "18:1961 (18:1961 Racketeering (RICO) Act)",
      "18:1962" : "18:1962 (18:1962 Racketeering (RICO) Act)",
      "18:1964" : "18:1964 (18:1964 Racketeering (RICO) Act)",
      "18:2511" : "18:2511 (18:2511 Wiretapping)",
      "18:3114" : "18:3114 (18:3114 Motion for Return of Seized Property)",
      "18:3181" : "18:3181 (18:3181 Extradition to Foreign Country)",
      "18:3582" : "18:3582 (18:3582 Motion to Reduce Sentence)",
      "18:4208" : "18:4208 (18:4208(B) Agency Action Review)",
      "19:1305" : "19:1305 (19:1305 Custom Duties:0Forfeiture-Immoral Articles)",
      "20:1080" : "20:1080 (20:1080 Student Loan Recovery)",
      "20:1099" : "20:1099 (20:1099 Higher Education Act - Accreditation)",
      "20:1400" : "20:1400 (20:1400 Civil Rights of Handicapped Child)",
      "20:1401" : "20:1401 (20:1401 Education: Handicapped Child Act)",
      "21:0841" : "21:0841 (21:0841 Forfeiture Property-Drugs)",
      "21:0881" : "21:0881 (21:0881 Forfeiture Property-Drugs)",
      "21:0881a" : "21:0881a (21:881 Forfeiture Property - Aircraft)",
      "21:0881re" : "21:0881re (21:881 Forfeiture Property - Real Estate)",
      "23:0134" : "23:0134 (23:0134 P.I.- Auto Negligence)",
      "23:1441" : "23:1441 (23:1441 Contract Real Estate)",
      "24:1000" : "24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)",
      "25:0640" : "25:0640 (25:0640 Indian Tribal Rights)",
      "25:1901" : "25:1901 (25:1901 Indian Child Welfare Act)",
      "26:6212" : "26:6212 (26:6212 Injunctive Relief from IRS Lien)",
      "26:6213" : "26:6213 (26:6213 Injunctive Relief from IRS Lien)",
      "26:6502" : "26:6502 (26:6502 IRS:Enforcement of tax liens)",
      "26:6532" : "26:6532 (26:6532 IRS: Refund of Tax Penalty)",
      "26:6702" : "26:6702 (26:6702 IRS: Refund of Income Tax Penalty)",
      "26:6703" : "26:6703 (26:6703 IRS: Refund of Tax Penalty)",
      "26:7401" : "26:7401 (26:7401 IRS: Tax Liability)",
      "26:7402" : "26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)",
      "26:7403" : "26:7403 (26:7403 Suit to Enforce Federal Tax Lien)",
      "26:7422rt" : "26:7422rt (26:7422 IRS: Refund Taxes)",
      "26:7422rx" : "26:7422rx (26:7422 IRS: Refund Excise Tax)",
      "26:7426" : "26:7426 (26:7426 IRS: Wrongful Levy for Taxes)",
      "26:7429" : "26:7429 (26:7429 IRS: Tax Jeopardy Assessment)",
      "26:7609" : "26:7609 (26:7609 IRS: Petition to Quash IRS Summons)",
      "27:0185" : "27:0185 (27:0185 Enforcement of Arbitration Award)",
      "28:0157c" : "28:0157c (28:0157 BKC 9033 Proposed findings/judgment)",
      "28:0157d" : "28:0157d (28:0157 Motion for Withdrawal of Reference)",
      "28:0158" : "28:0158 (28:0158 Bankruptcy Appeal from Judgment/Order)",
      "28:0158a" : "28:0158a (28:0158 Motion for Leave to File Notice of Appeal)",
      "28:0185" : "28:0185 (28:0185 Suit to Compel Arbitration)",
      "28:0451" : "28:0451 (28:0451 Employment Discrimination)",
      "28:0754" : "28:0754 (28:0754 Receiver of Property in Different Districts)",
      "28:0794" : "28:0794 (28:0794 Rehabilitation Act)",
      "28:1001" : "28:1001 (28:1001 E.R.I.S.A.)",
      "28:1132" : "28:1132 (28:1132 E.R.I.S.A.)",
      "28:1330" : "28:1330 (28:1330 Breach of Contract)",
      "28:1331" : "28:1331 (28:1331 Federal Question)",
      "28:1331al" : "28:1331al (28:1331 Fed. Question: Airline Crash)",
      "28:1331at" : "28:1331at (28:1331 Fed. Question: Anti-trust)",
      "28:1331au" : "28:1331au (28:1331 Fed. Question: Auto Negligence)",
      "28:1331b" : "28:1331b (28:1331 Federal Question: Bivens Act)",
      "28:1331bc" : "28:1331bc (28:1331 Fed. Question: Breach of Contract)",
      "28:1331ca" : "28:1331ca (28:1331 Fed Question: Fed Communications Act of 1)",
      "28:1331cm" : "28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)",
      "28:1331cv" : "28:1331cv (28:1331 Fed. Question: Civil Rights Violation)",
      "28:1331ed" : "28:1331ed (28:1331 Fed. Question: Employment Discrimination)",
      "28:1331ej" : "28:1331ej (28:1331 Federal Question: Enforcement of Judgment)",
      "28:1331es" : "28:1331es (28:1331 Enforcement of Administrative Subpoena)",
      "28:1331fl" : "28:1331fl (28:1331 Fed. Question: Fair Labor Standards)",
      "28:1331in" : "28:1331in (28:1331 Fed. Question: Insurance Contract)",
      "28:1331mm" : "28:1331mm (28:1331 Fed. Question: Medical Malpractice)",
      "28:1331ng" : "28:1331ng (28:1331 Fed. Question: Natural Gas Act)",
      "28:1331pi" : "28:1331pi (28:1331 Fed. Question: Personal Injury)",
      "28:1331rd" : "28:1331rd (28:1331 Fed. Question: Review Agency Decision)",
      "28:1331rp" : "28:1331rp (28:1331 Fed. Question: Real Property)",
      "28:1331rr" : "28:1331rr (28:1331 Fed. Question: Railway Labor Act)",
      "28:1331sv" : "28:1331sv (28:1331 Fed. Question: Securities Violation)",
      "28:1331tr" : "28:1331tr (28:1331 Fed. Question: Trademark)",
      "28:1331tt" : "28:1331tt (28:1331 Fed. Question: Tort Action)",
      "28:1331v" : "28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendment)",
      "28:1331wl" : "28:1331wl (28:1331 Federal Question: EPA Waste Lien)",
      "28:1331wt" : "28:1331wt (28:1331 Fed. Question: Water Rights)",
      "28:1332" : "28:1332 (28:1332 Diversity)",
      "28:1332ac" : "28:1332ac (28:1332 Diversity-Account Receivable)",
      "28:1332al" : "28:1332al (28:1332 Diversity-Airline Crash)",
      "28:1332as" : "28:1332as (28:1332 Diversity-Asbestos Litigation)",
      "28:1332au" : "28:1332au (28:1332 Diversity-Auto Negligence)",
      "28:1332bc" : "28:1332bc (28:1332 Diversity-Breach of Contract)",
      "28:1332co" : "28:1332co (28:1332 Diversity-Conversion)",
      "28:1332ct" : "28:1332ct (28:1332 Diversity-(Citizenship))",
      "28:1332det" : "28:1332det (28:1332 Diversity: Forcible Detainer)",
      "28:1332df" : "28:1332df (28:1332 Diversity-Contract Default)",
      "28:1332ds" : "28:1332ds (28:1332 Diversity-Contract Dispute)",
      "28:1332ed" : "28:1332ed (28:1332 Diversity-Employment Discrimination)",
      "28:1332fd" : "28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)",
      "28:1332fr" : "28:1332fr (28:1332 Diversity-Fraud)",
      "28:1332ia" : "28:1332ia (28:1332 Diversity-Interpleader Action)",
      "28:1332ij" : "28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)",
      "28:1332in" : "28:1332in (28:1332 Diversity-Insurance Contract)",
      "28:1332jd" : "28:1332jd (28:1332 Diversity-Declaratory Judgment)",
      "28:1332lb" : "28:1332lb (28:1332 Diversity-Libel, Assault, Slander)",
      "28:1332lm" : "28:1332lm (28:1332 Diversity - Legal Malpractice)",
      "28:1332ma" : "28:1332ma (28:1332 Diversity-Miller Act)",
      "28:1332mm" : "28:1332mm (28:1332 Diversity-Medical Malpractice)",
      "28:1332mv" : "28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)",
      "28:1332ni" : "28:1332ni (28:1332 Diversity-Negotiable Instrument)",
      "28:1332nm" : "28:1332nm (28:1332 Diversity-Non-Motor Vehicle)",
      "28:1332nr" : "28:1332nr (28:1332 Diversity-Notice of Removal)",
      "28:1332oc" : "28:1332oc (28:1332 Diversity-Other Contract)",
      "28:1332pd" : "28:1332pd (28:1332 Diversity-Property Damage)",
      "28:1332pi" : "28:1332pi (28:1332 Diversity-Personal Injury)",
      "28:1332pl" : "28:1332pl (28:1332 Diversity-Product Liability)",
      "28:1332pr" : "28:1332pr (28:1332 Diversity-Petition for Removal)",
      "28:1332qt" : "28:1332qt (28:1332 Diversity-Petition to Quiet Title)",
      "28:1332ri" : "28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)",
      "28:1332sa" : "28:1332sa (28:1332 - Diversity: Securities & Exchange Commiss)",
      "28:1332sf" : "28:1332sf (28:1332 - Diversity: Securities Fraud)",
      "28:1332ss" : "28:1332ss (28:1332 Diversity - Stockholders Suits)",
      "28:1332tl" : "28:1332tl (28:1332 Diversity-Torts to Land)",
      "28:1332tm" : "28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))",
      "28:1332tn" : "28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)",
      "28:1332wd" : "28:1332wd (28:1332 Diversity-Wrongful Death)",
      "28:1333" : "28:1333 (28:1333 Admiralty)",
      "28:1333dc" : "28:1333dc (28:1333 Admiralty - Damaged/Lost Cargo)",
      "28:1333fc" : "28:1333fc (28:1333 Admiralty - Freight/Tariff Charges)",
      "28:1333fm" : "28:1333fm (28:1333 Admiralty - Foreclose Ship's Mortgage)",
      "28:1333sc" : "28:1333sc (28:1333 Admiralty - Seaman Complaint)",
      "28:1333sr" : "28:1333sr (28:1333 Admiralty - Services Rendered)",
      "28:1334" : "28:1334 (28:1334 Bankruptcy Appeal)",
      "28:1334c" : "28:1334c (28:1334(c) R&R re motions for abstention (non-cor)",
      "28:1335" : "28:1335 (28:1335 Interpleader Action)",
      "28:1337" : "28:1337 (28:1337 Sherman-Clayton Act)",
      "28:1338cp" : "28:1338cp (28:1338 Copyright Infringement)",
      "28:1338pt" : "28:1338pt (28:1338 Patent Infringement)",
      "28:1338tr" : "28:1338tr (28:1338 Trademark Infringement)",
      "28:1340" : "28:1340 (28:1340 IRS: Custom Duties)",
      "28:1340er" : "28:1340er (28:1340 Recovery of Erroneous Refund)",
      "28:1341" : "28:1341 (28:1341 Complaint for Forfeiture)",
      "28:1343" : "28:1343 (28:1343 Violation of Civil Rights)",
      "28:1345" : "28:1345 (28:1345 USA Plaintiff)",
      "28:1345co" : "28:1345co (28:1345 Replevin & Conversion)",
      "28:1345db" : "28:1345db (28:1345 Debt to US - FHA/HUD Title I)",
      "28:1345df" : "28:1345df (28:1345 Default of Promissory Note)",
      "28:1345er" : "28:1345er (28:1345 Recovery of Erroneous Refund)",
      "28:1345fc" : "28:1345fc (28:1345 Foreclosure)",
      "28:1345ff" : "28:1345ff (28:1345 Complaint for Forfeiture)",
      "28:1345hl" : "28:1345hl (28:1345 VA Home Loan Guaranty Debt)",
      "28:1345mc" : "28:1345mc (28:1345 Medical Care Recovery)",
      "28:1345mi" : "28:1345mi (28:1345 Mining Claim Ejectment)",
      "28:1345pd" : "28:1345pd (28:1345 Property Damage)",
      "28:1345pe" : "28:1345pe (28:1345 VA Property Ejectment)",
      "28:1345rc" : "28:1345rc (28:1345 Recovery of Debt to US)",
      "28:1345st" : "28:1345st (28:1345 Default of Student Loan)",
      "28:1345tp" : "28:1345tp (28:1345 Trespass on Public Land)",
      "28:1345va" : "28:1345va (28:1345 Recovery of VA Overpayment)",
      "28:1346bc" : "28:1346bc (28:1346 Breach of Contract)",
      "28:1346rc" : "28:1346rc (28:1346 Recovery of IRS Tax)",
      "28:1346tc" : "28:1346tc (28:1346 Tort Claim)",
      "28:1346wd" : "28:1346wd (28:1346 Wrongful Death)",
      "28:1348" : "28:1348 (28:1348 Corporation organized under Federal Law as party)",
      "28:1352" : "28:1352 (28:1352 Miller Act)",
      "28:1355" : "28:1355 (28:1355 Petition for Return of Property)",
      "28:1358" : "28:1358 (28:1358 Land Condemnation)",
      "28:1361" : "28:1361 (28:1361 Petition for Writ of Mandamus)",
      "28:1361us" : "28:1361us (28:1361 Action to compel U.S. officer to perform duty)",
      "28:1362ic" : "28:1362ic (28:1362 Indian Tribal Controversy)",
      "28:1362iw" : "28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)",
      "28:1364" : "28:1364 (28:1364 Auto Negligence)",
      "28:1391" : "28:1391 (28:1391 Personal Injury)",
      "28:1402" : "28:1402 (28:1402 Medical Malpractice)",
      "28:1407" : "28:1407 (28:1407 Multidistrict Litigation)",
      "28:1441ac" : "28:1441ac (28:1441 Notice of Removal-Account Receivable)",
      "28:1441al" : "28:1441al (28:1441 Notice of Removal-Airline Crash)",
      "28:1441as" : "28:1441as (28:1441 Notice of Removal-Asbestos Litigation)",
      "28:1441au" : "28:1441au (28:1441 Notice of Removal-Auto Negligence)",
      "28:1441bc" : "28:1441bc (28:1441 Notice of Removal-Breach of Contract)",
      "28:1441cs" : "28:1441cs (28:1441 Notice of Removal-Constitutionality State Statutes)",
      "28:1441cv" : "28:1441cv (28:1441 Petition for Removal- Civil Rights Act)",
      "28:1441df" : "28:1441df (28:1441 Notice of Removal-Contract Default)",
      "28:1441dj" : "28:1441dj (28:1441 Notice of Removal-Declaratory Judgment)",
      "28:1441ds" : "28:1441ds (28:1441 Notice of Removal-Contract Dispute)",
      "28:1441ed" : "28:1441ed (28:1441 Petition for Removal - Employment Discrim)",
      "28:1441fc" : "28:1441fc (28:1441 Petition for Removal - Fair Credit Reporti)",
      "28:1441fr" : "28:1441fr (28:1441 Notice of Removal-Fraud)",
      "28:1441ij" : "28:1441ij (28:1441 Notice of Removal-Injunctive/Declaratory Relief)",
      "28:1441in" : "28:1441in (28:1441 Notice of Removal-Insurance Contract)",
      "28:1441int" : "28:1441int (28:1441 Petition for Removal- Action for Interplea)",
      "28:1441la" : "28:1441la (28:1441 Notice of Removal - Labor)",
      "28:1441lb" : "28:1441lb (28:1441 Notice of Removal-Libel, Assault, Slander)",
      "28:1441lm" : "28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relatio)",
      "28:1441mm" : "28:1441mm (28:1441 Notice of Removal-Medical Malpractice)",
      "28:1441ni" : "28:1441ni (28:1441 Notice of Removal-Negotiable Instrument)",
      "28:1441nm" : "28:1441nm (28:1441 Notice of Removal-Non-Motor Vehicle)",
      "28:1441nr" : "28:1441nr (28:1441 Notice of Removal)",
      "28:1441oc" : "28:1441oc (28:1441 Petition For Removal--Other Contract)",
      "28:1441pd" : "28:1441pd (28:1441 Notice of Removal-Property Damage)",
      "28:1441pi" : "28:1441pi (28:1441 Notice of Removal-Personal Injury)",
      "28:1441pl" : "28:1441pl (28:1441 Notice of Removal-Product Liability)",
      "28:1441pr" : "28:1441pr (28:1441 Petition for Removal)",
      "28:1441qt" : "28:1441qt (28:1441 Notice of Removal-Petition to Quiet Title)",
      "28:1441ri" : "28:1441ri (28:1441 Petition for Removal- Racketeering (RICO))",
      "28:1441sa" : "28:1441sa (28:1441 - Petition for Removal: SEC Act)",
      "28:1441sf" : "28:1441sf (28:1441 - Petition for Removal: Securities Fraud)",
      "28:1441tl" : "28:1441tl (28:1441 Notice of Removal-Torts to Land)",
      "28:1441tm" : "28:1441tm (28:1441 Notice of Removal-Tort/Motor Vehicle (P.I.))",
      "28:1441tn" : "28:1441tn (28:1441 Notice of Removal-Tort/Non-Motor Vehicle)",
      "28:1441wd" : "28:1441wd (28:1441 Notice of Removal-Wrongful Death)",
      "28:1442bc" : "28:1442bc (28:1442 Notice of Removal-Breach of Contract)",
      "28:1442nr" : "28:1442nr (28:1442 Notice of Removal)",
      "28:1442pr" : "28:1442pr (28:1442 Petition for Removal)",
      "28:1443" : "28:1443 (28:1443 Rent, Lease & Ejectment)",
      "28:1443cv" : "28:1443cv (28:1443cv Notice of Removal - Civil Rights Cases)",
      "28:1444" : "28:1444 (28:1441 Notice of Removal-Foreclosure)",
      "28:1446in" : "28:1446in (28:1446 Breach of Contract- Insurance)",
      "28:1446nr" : "28:1446nr (28:1446 Notice of Removal)",
      "28:1446pd" : "28:1446pd (28:1446 Notice of Removal-Property Damage (P.I.))",
      "28:1446pi" : "28:1446pi (28:1446 Notice of Removal-Personal Injury)",
      "28:1446pl" : "28:1446pl (28:1446pl Petition for Removal - Product Liability)",
      "28:1446pr" : "28:1446pr (28:1446 Petition for Removal)",
      "28:1452" : "28:1452 (28:1452 Removal of Claim in Civil Action Related to BK. Case)",
      "28:1602" : "28:1602 (28:1602 Foreign Sovereign Immunities Act)",
      "28:1651" : "28:1651 (28:1651 Petition for Writ of Coram Nobis)",
      "28:1651hc" : "28:1651hc (28:1651 Petition for Writ of Habeas Corpus)",
      "28:1651mn" : "28:1651mn (28:1651 Petition for Writ of Mandamus)",
      "28:1782" : "28:1782 (28:1782 Letter rogatory - appointment)",
      "28:1875" : "28:1875 (28:1875 Protection of Jurors' Employment)",
      "28:1983" : "28:1983 (28:1983 Civil Rights)",
      "28:2201" : "28:2201 (28:2201 Constitutionality of State Statute(s))",
      "28:2201dj" : "28:2201dj (28:2201 Declaratory Judgment)",
      "28:2201ij" : "28:2201ij (28:2201 Injunction)",
      "28:2201in" : "28:2201in (28:2201 Declaratory Judgment (Insurance))",
      "28:2241" : "28:2241 (28:2241 Petition for Writ of Habeas Corpus (Federal))",
      "28:2242" : "28:2242 (28:2242 Application for writ of Habeas Corpus)",
      "28:2254" : "28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))",
      "28:2254se" : "28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)",
      "28:2255" : "28:2255 (28:2255 Motion to Vacate Sentence)",
      "28:2271" : "28:2271 (28:2271 Federal Tort Claims Act)",
      "28:2345" : "28:2345 (28:2345 Medicare Recovery)",
      "28:2409" : "28:2409 (28:2409 Quiet Title Action)",
      "28:2410" : "28:2410 (28:2410 Actions affecting property on which USA had lien)",
      "28:2671" : "28:2671 (28:2671 Federal Tort Claims Act)",
      "28:2674" : "28:2674 (28:2674 Federal Tort Claims Act)",
      "28:7402" : "28:7402 (28:7402 Refund of Taxes)",
      "28:7422" : "28:7422 (28:7422 Appeal from Administrative Decision)",
      "29:0151" : "29:0151 (29:0151 Labor: Review of Agency Action)",
      "29:0158" : "29:0158 (29:0158 Interstate Commerce Commission)",
      "29:0160" : "29:0160 (29:0160 National Labor Relations Act)",
      "29:0184" : "29:0184 (29:0184 Violation Collection Bargain Agreement)",
      "29:0185ep" : "29:0185ep (29:0185 Employee Pension Plan)",
      "29:0185lm" : "29:0185lm (29:01851 Labor/Mgt. Relations (Contracts))",
      "29:0201do" : "29:0201do (29:0201 Denial of Overtime Compensation)",
      "29:0201fl" : "29:0201fl (29:0201 Fair Labor Standards Act)",
      "29:0203" : "29:0203 (29:203 Equal Pay Act)",
      "29:0206" : "29:0206 (29:0206 Collect Unpaid Wages)",
      "29:0401" : "29:0401 (29:0401 Labor Management Disclosure Act)",
      "29:0621" : "29:0621 (29:0621 Job Discrimination (Age))",
      "29:0623" : "29:0623 (29:0623 Job Discrimination (Age))",
      "29:0626" : "29:0626 (29:0626 Job Discrimination (Age))",
      "29:0633" : "29:0633 (29:0633 Job Discrimination (Age))",
      "29:0651" : "29:0651 (29:0651 Occupational Safety/Health)",
      "29:0754" : "29:0754 (29:0754 Discrimination)",
      "29:0791" : "29:0791 (29:0791 Job Discrimination (Rehabilitation Act))",
      "29:0794" : "29:0794 (29:0794 Job Discrimination (Handicap))",
      "29:1001" : "29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)",
      "29:1002" : "29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)",
      "29:1104" : "29:1104 (29:1104 Recovery of Benefits to Employee)",
      "29:1109" : "29:1109 (29:1109 Breach of Fiduciary Duties)",
      "29:1131" : "29:1131 (29:1131 ERISA - Collection of Delinquent Trust Funds)",
      "29:1132" : "29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)",
      "29:1145" : "29:1145 (29:1145 E.R.I.S.A.)",
      "29:1149" : "29:1149 (29:1149 Recover Pension & Profit Sharing)",
      "29:1337" : "29:1337 (29:1337 E.R.I.S.A.)",
      "29:1362" : "29:1362 (29:1362 ERISA)",
      "29:1381" : "29:1381 (29:1381 E.R.I.S.A.)",
      "29:1401" : "29:1401 (29:1401(b)(2) Appeal of Arbitration Award)",
      "29:1451" : "29:1451 (29:1451 E.R.I.S.A.)",
      "29:1801" : "29:1801 (29:1801 Farmworker Rights)",
      "29:2001" : "29:2001 (29:2001 Employee Polygraph Protection Act)",
      "29:2611" : "29:2611 (29:2611 Family Medical Leave Act)",
      "29:790" : "29:790 (29:790 Rehabilitation of Labor)",
      "30:0181" : "30:0181 (30:0181 Environment: Review of Agency Action)",
      "30:0801" : "30:0801 (30:0801 Penalities/Federal Mine Safety Health Act)",
      "30:1201" : "30:1201 (30:1201 Environment: Review of Agency Action)",
      "30:1202" : "30:1202 (30:1202 Mining Reclamation Act)",
      "30:1276" : "30:1276 (30:1276 Interior: Review of Agency Action)",
      "31:3545" : "31:3545 (31:3545 Action to Recover Money)",
      "31:3729" : "31:3729 (31:3729 False Claims Act)",
      "31:3730" : "31:3730 (31:3730 Qui Tam False Claims Act)",
      "31:3731" : "31:3731 (31:3731 Fraud)",
      "31:5313" : "31:5313 (31:5313 Forfeiture - currency reporting violation)",
      "31:5316" : "31:5316 (31:5316 Forfeiture - currency reporting violation)",
      "33:1319cw" : "33:1319cw (33:1319 Clean Water Act)",
      "33:1319pv" : "33:1319pv (33:1319 Pollutants & Permit Violations)",
      "33:1365" : "33:1365 (33:1365 Environmental Matters)",
      "35:0145" : "35:0145 (35:0145 Patent Infringement)",
      "35:0183" : "35:0183 (35:0183 Patent Infringement)",
      "35:0271" : "35:0271 (35:0271 Patent Infringement)",
      "38:0775" : "38:0775 (38:0775 Recovery of Servicemen's Group Life Insurance)",
      "38:1681" : "38:1681 (38:1681 Recovery of VA Overpayment)",
      "38:1686" : "38:1686 (38:1686 Recovery of VA Overpayment)",
      "38:1780" : "38:1780 (38:1780 Recovery of VA Overpayment)",
      "38:1803" : "38:1803 (38:1803 Recoupment of VA mortgage)",
      "38:2011" : "38:2011 (38:2011 - Veteran's Readjustment Assistance Act of)",
      "38:2021" : "38:2021 (38:2021 Deactivated Per Administrative Office)",
      "38:3116" : "38:3116 (38:3116 VA Overpayment)",
      "38:4311" : "38:4311 (38:4311 Uniformed Service Employment or Reemployment Rights Act - Discrimination)",
      "38:4323" : "38:4323 (38:4323 Uniformed Service Employment/Reemployment Rights Act - Enforcement re state/private employer)",
      "38:4324" : "38:4324 (38:4324 Uniformed Service Employment/Reemployment Rights Act - Enforcement re Federal Exec. Agencies)",
      "39:3005" : "39:3005 (39:3005 Detention of Mail for Temporary Periods)",
      "39:3007" : "39:3007 (39:3007 Injunc. direct. retention/examination incoming mail)",
      "39:409" : "39:409 (39:409 Postal Service)",
      "40:0258" : "40:0258 (40:0258 Public Buildings & Property: Land Condemnation)",
      "40:0270" : "40:0270 (40:0270 Miller Act)",
      "40:0875" : "40:0875 (40:0875 Public Buildings & Property: Negligence)",
      "41:0251" : "41:0251 (41:0251 Public Contracts-Review of Agency Action)",
      "41:1463" : "41:1463 (41:1463 Public Contracts: Unlawful Employment Practices)",
      "42:0205" : "42:0205 (42:0205 Denial Social Security Benefits)",
      "42:0206" : "42:0206 (42:0206 Social Security Benefits)",
      "42:0247" : "42:0247 (42:0247 Personal Injury-Swine Flu)",
      "42:0402" : "42:0402 (42:0402 Social Security Benefits)",
      "42:0405" : "42:0405 (42:0405 Fair Housing Act)",
      "42:0405id" : "42:0405id (42:0405 Review of HHS Decision (SSID))",
      "42:0405wc" : "42:0405wc (42:0405 Review of HHS Decision (DIWC))",
      "42:0405ww" : "42:0405ww (42:0405 Review of HHS Decision (DIWW))",
      "42:0416" : "42:0416 (42:0416 Denial of Social Security Benefits)",
      "42:0427" : "42:0427 (42:427 Social Security Benefits)",
      "42:11601" : "42:11601 (42:11601 International Child Abduction Remedies Act)",
      "42:12182" : "42:12182 (42:12182 Americans with Disabilities Act)",
      "42:1383" : "42:1383 (42:1383 Review of HHS Decision)",
      "42:1395" : "42:1395 (42:1395 HHS: Adverse Reimbursement Review)",
      "42:1396" : "42:1396 (Public Health and Welfare)",
      "42:1471" : "42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclo)",
      "42:1981cv" : "42:1981cv (42:1981 Civil Rights)",
      "42:1981hs" : "42:1981hs (42:1981 Housing Discrimination)",
      "42:1981jb" : "42:1981jb (42:1981 Job Discrimination (Race))",
      "42:1981sx" : "42:1981sx (42:1981 Sex Discrimination)",
      "42:1983cv" : "42:1983cv (42:1983 Civil Rights Act)",
      "42:1983ed" : "42:1983ed (42:1983 Civil Rights (Employment Discrimination))",
      "42:1983pr" : "42:1983pr (42:1983 State Prisoner Civil Rights)",
      "42:1986" : "42:1986 (42:1986 Neglect of Duty)",
      "42:2000ag" : "42:2000ag (42:2000 Job Discrimination (Age))",
      "42:2000e" : "42:2000e (42:2000e Job Discrimination (Employment))",
      "42:2000pb" : "42:2000pb (42:2000 Job Discrimination (Public Accommodations))",
      "42:2000ra" : "42:2000ra (42:2000 Job Discrimination (Race))",
      "42:2000sx" : "42:2000sx (42:2000 Job Discrimination (Sex))",
      "42:2003" : "42:2003 (42:2003 Job Discrimination)",
      "42:2005" : "42:2005 (42:2005 Review of Agency Action-HHS)",
      "42:2615" : "42:2615 (42:2615 Medical Recovery Act)",
      "42:2651" : "42:2651 (42:2651 Medical Care Recovery)",
      "42:3601" : "42:3601 (42:3601 Fair Housing Act)",
      "42:4000" : "42:4000 (42:4000 National Flood Insurance Act)",
      "42:4001" : "42:4001 (42:4001 National Insurance Flood Act)",
      "42:4053" : "42:4053 (42:4053 Breach of Insurance Contract)",
      "42:4072" : "42:4072 (42:4072 Payment of Flood Insurance Claim)",
      "42:4321" : "42:4321 (42:4321 Review of Agency Action-Environment)",
      "42:4332" : "42:4332 (42:4332 Environmental Policy - Coop of Agency Repo)",
      "42:6901en" : "42:6901en (42:6901 Environmental Cleanup Expenses)",
      "42:6901rs" : "42:6901rs (42:6901 Resource & Recovery Act)",
      "42:7413" : "42:7413 (42:7413(b) Clean Air Act)",
      "42:7604cl" : "42:7604cl (42:7604 Clear Air Act (Emission Standards))",
      "42:7604ir" : "42:7604ir (42:7604 Petition to Quash IRS Summons)",
      "42:9607" : "42:9607 (42:9607 Real Property Tort to Land)",
      "43:945" : "43:945 (43:945 Compensation for Land Condemnation)",
      "43:945a" : "43:945a (43:945a Complaint in Condemnation)",
      "43:946" : "43:946 (43:946 Complaint in Condemnation - Eminent Domain)",
      "45:0051" : "45:0051 (45:0051 Railways: Fed. Employer's Liability Act)",
      "45:0151" : "45:0151 (45:0151 Railway Labor Act)",
      "45:0184" : "45:0184 (45:0184 Action to Set Aside Award of a System Board of Adjus)",
      "45:1395" : "45:1395 (45:1395 Railroads: Adverse Reimbursement Review)",
      "45:7457" : "45:7457 (45:7457 Compel Reclamation Under Clear Air Act)",
      "46:0185" : "46:0185 (46:0185 Petition by vessel owner for limitation of liability)",
      "46:0688" : "46:0688 (46:0688 Jones Act)",
      "46:0741" : "46:0741 (46:0741 Shipping)",
      "46:0761" : "46:0761 (46:0761 Shipping: Damages for Death on High Seas)",
      "46:1101" : "46:1101 (46:1101 Violation of Maritime Regulations)",
      "46:1156" : "46:1156 (46:1156 Administrative Procedure Act)",
      "46:1301" : "46:1301 (46:1301 Admiralty - Damaged/Lost Cargo)",
      "47:0151" : "47:0151 (47:0151 Telegraphs/Telephones - FCC: fees/charges)",
      "47:0202" : "47:0202 (47:0202 Discriminations and Preferences)",
      "47:0605" : "47:0605 (47:0605 Unauthorized publication or use of communications)",
      "48:0883" : "48:0883 (48:0883 Violation of US Coastal Law)",
      "48:1985" : "48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)",
      "49:0081" : "49:0081 (49:0081 Damaged Goods While Being Transported)",
      "49:0781" : "49:0781 (49:0781 Forfeiture)",
      "49:11503" : "49:11503 (49:11503 Railroad Revitalization Regulatory Reform)",
      "49:11702" : "49:11702 (49:11702(a)(4) Violations of Interstate Commerce A)",
      "49:11707" : "49:11707 (49:11707 Liability of Common Carriers)",
      "49:1471" : "49:1471 (49:1471 Federal Aviation Act)",
      "49:1502" : "49:1502 (49:1502 Air Transportation (Warsaw Convention))",
      "49:1903" : "49:1903 (49:1903 Petition to enforce administrative summon)",
      "49:32701" : "49:32701 (49:32701 Federal Odometer Act)",
      "8:287" : "8:287 (8:287 Petition to Enforce INS Subpoena)",
      "99:9999" : "99:9999 (99:9999 Report cause code (DO NOT DELETE!))",
      "adsup" : "adsup (Administrative Subpoena)",
      "apptrec" : "apptrec (Appointment of receiver)",
      "attydiscp" : "attydiscp (Attorney Discipline)",
      "bvcmp" : "bvcmp (Bivens - Federal Prisoner Civil Rights)",
      "contempt" : "contempt (Contempt Proceedings)",
      "disbar" : "disbar (Disbarment Proceedings)",
      "fordepo" : "fordepo (Foreign Deposition)",
      "menfsubp" : "menfsubp (Motion to enforce deposition subpoena)",
      "misc" : "misc (Civil Miscellaneous Case)",
      "motcomp" : "motcomp (Motion to Compel)",
      "motjudrev" : "motjudrev (Motion for Judicial Review)",
      "motquash" : "motquash (Motion to Quash)",
      "motret" : "motret (Motion for Return of Property)",
      "motstaybkc" : "motstaybkc (Motion to Stay Bankruptcy Proceedings)",
      "mottro" : "mottro (Motion for Temporary Restraining Order)",
      "petenf" : "petenf (Petition to Enforce IRS Summons)",
      "petper" : "petper (Petition to Perpetuate Testimony)",
      "regjgm" : "regjgm (Registration of Foreign Judgment)",
      "tranbkref" : "tranbkref (Transmission of Bankruptcy Reference)",
      "tranff" : "tranff (Transmission of Proposed Findings of Fact and Concl. of Law)",
      "writgar" : "writgar (Application for a Writ of Garnishment)",
      "writman" : "writman (Writ of Mandamus)"
   },
   "gamdce" : {
      "0" : "0 (No cause code entered)",
      "02:0138" : "02:0138 (02:138 Library of Congress Access)",
      "02:0358" : "02:0358 (02:358 President's Recommendations on Exec., Jud. & Leg. Salary)",
      "02:0431" : "02:0431 (02:431 Federal Election Commission: Failure to Enforce Compliance)",
      "02:0437" : "02:0437 (02:437 Federal Election Commission)",
      "02:0681" : "02:0681 (02:681 Deferral of Budget Authority)",
      "02:1202" : "02:1202 (02:1202 Discriminatory practices affecting US Senate employees)",
      "02:1301" : "02:1301 (02:1301 Congressional Accountability Act)",
      "02:1317a" : "02:1317a (02:1317a Violation of Congressional Accountability Act)",
      "05:0075" : "05:0075 (05:75(2) Contract - Reduction in Grade)",
      "05:0551" : "05:0551 (05:551 Administrative Procedure Act)",
      "05:0552fi" : "05:0552fi (05:552 Freedom of Information Act)",
      "05:0552pa" : "05:0552pa (05:552 Right to Privacy Act)",
      "05:0554" : "05:0554 (05:0554 Constitutionality of Maritime Statutes)",
      "05:0701" : "05:0701 (05:0701 Maritime Subsidy Board)",
      "05:0702" : "05:0702 (05:702 Administrative Procedure Act)",
      "05:0704" : "05:0704 (05:704 Labor Litigation)",
      "05:7703" : "05:7703 (05:7703 Discrimination - Review of Agency Act)",
      "05:8470" : "05:8470 (05:8470 Enforcement of Judgment against Retirement Benefits )",
      "07:0006" : "07:0006 (7:6(b) Federal Commodity Exchange Regulation)",
      "07:0025" : "07:0025 (7:25 Fraud - Commodities Leverage Contracts)",
      "07:0181" : "07:0181 (07:181 Packers & Stockyard Act)",
      "07:0499" : "07:0499 (07:499 Agricultural Commodities Act)",
      "07:0601" : "07:0601 (07:601 USDA Condemnation)",
      "07:2321" : "07:2321 (07:2321 Plant Variety Protection Act)",
      "08:1105" : "08:1105 (8:1105(a) Aliens: Habeas Corpus to Release INS Det)",
      "08:1182" : "08:1182 (8:1182 Defend. Denial of Pla. Appl. for Alien Employment Cer)",
      "08:1252" : "08:1252 (08:1252(a)(2) Injunction for Deportation)",
      "08:1260" : "08:1260 (08:1260 Aliens: Access to Records)",
      "08:1324" : "08:1324 (08:1324 Aliens: Complaint for Forfeiture)",
      "08:1329" : "08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petiti)",
      "08:1446" : "08:1446 (8:1446 Petition for Naturalization Hearing)",
      "08:1451(j)" : "08:1451(j) (8:1451(j) Motion to Correct Order & Judg. of Naturalization )",
      "09:0001" : "09:0001 (09:1 U.S. Arbitration Act)",
      "09:0009" : "09:0009 (9:9 Motion to Confirm Arbitration Loan)",
      "09:0010" : "09:0010 (09:0010 Petition to Vacate Arbitration Award)",
      "10:1408" : "10:1408 (10:1408 Claim for Military Retirement )",
      "10:1552" : "10:1552 (10:1552 Armed Forces: Action to Correct Records)",
      "10:1553" : "10:1553 (10:1553 Armed Forces: FOIA General)",
      "10:2305" : "10:2305 (10:2305 Review of Federal Contract)",
      "11:0101" : "11:0101 (11:101 Bankruptcy)",
      "12:0022" : "12:0022 (12:22 Securities Fraud)",
      "12:0635" : "12:0635 (12:635 Breach of Insurance Contract)",
      "12:1461" : "12:1461 (12:1461 Homeowners Loan Act)",
      "12:1464" : "12:1464 (12:1464 Federal Savings and Loan )",
      "12:1703" : "12:1703 (12:1703 Default of HUD Loan)",
      "12:1725" : "12:1725 (12:1725 Collection under Contract Guaranty)",
      "12:1730" : "12:1730 (12:1730 Collection Under Contract Guaranty)",
      "12:1818" : "12:1818 (12:1818 Federal Depository Insurance Act )",
      "12:1819" : "12:1819 (12:1819 Default of Promissory Note)",
      "12:1821" : "12:1821 (12:1821 Default of Loan by Promissary Note)",
      "12:191" : "12:191 (12:191 Bank Foreclosure )",
      "12:192" : "12:192 (12:192 Liquidation of National Bank )",
      "12:1971" : "12:1971 (12:1971 Relief under Bank Holding Act)",
      "12:1972" : "12:1972 (12:1972 Typing Arrangement Act )",
      "12:3410" : "12:3410 (12:3410 Right to Financial Privacy Act)",
      "15:0001" : "15:0001 (15:1 Antitrust Litigation)",
      "15:0002at" : "15:0002at (15:2 Antitrust Litigation)",
      "15:0002fl" : "15:0002fl (15:2(a) Fair Labor Standards Act)",
      "15:0005" : "15:0005 (15:5(a) Fair Labor Standards Act)",
      "15:0015" : "15:0015 (15:15 Antitrust Litigation)",
      "15:0025" : "15:0025 (15:25 Clayton Act)",
      "15:0044" : "15:0044 (15:44 Trademark Infringement)",
      "15:0045" : "15:0045 (15:0045 Federal Trade Commission Act)",
      "15:0052" : "15:0052 (15:0052 Federal Trade Commission Act)",
      "15:0053" : "15:0053 (15:0053 Federal Trade Commission Act)",
      "15:0077" : "15:0077 (15:77 Securities Fraud)",
      "15:0078" : "15:0078 (15:78m(a) Securities Exchange Act)",
      "15:0631" : "15:0631 (15:631 Small Business Act)",
      "15:0717" : "15:0717 (15:717 Natural Gas Act)",
      "15:0754" : "15:0754 (15:754 Emergency Petroleum Allocation-Admin.& Enforcement )",
      "15:1051" : "15:1051 (15:1051 Trademark Infringement)",
      "15:1114" : "15:1114 (15:1114 Trademark Infringement)",
      "15:1121" : "15:1121 (15:1121 Trademark Infringement)",
      "15:1125" : "15:1125 (15:1125 Trademark Infringement (Lanham Act))",
      "15:1126" : "15:1126 (15:1126 Patent Infringement)",
      "15:1127" : "15:1127 (15:1127 Trademark Infringement)",
      "15:1601" : "15:1601 (15:1601 Truth in Lending)",
      "15:1640" : "15:1640 (15:1640 Truth in Lending)",
      "15:1681" : "15:1681 (15:1681 Fair Credit Reporting Act)",
      "15:1692" : "15:1692 (15:1692 Fair Debt Collection Act)",
      "15:1938" : "15:1938 (15:1938 Fair Labor Standards Act)",
      "15:1981" : "15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))",
      "15:1988" : "15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))",
      "15:1989" : "15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))",
      "15:2301" : "15:2301 (15:2301 Magnuson-Moss Warranty Act)",
      "15:2801" : "15:2801 (15:2801 Petroleum Marketing Practices Act)",
      "15:53(b)" : "15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equita)",
      "16:0668" : "16:0668 (16:668 Bald Eagle Protection Act)",
      "16:0703" : "16:0703 (16:703 Migratory Bird Act)",
      "16:1538" : "16:1538 (16:1538 Endangered Species Act)",
      "16:3371" : "16:3371 (16:3371 Wildlife Under the Lacey Act)",
      "16:3372" : "16:3372 (16:3372 Conservation: Complaint for Forfeiture)",
      "16:3373" : "16:3373 (16:3373 Appeal of Decision - DOI)",
      "16:3374" : "16:3374 (16:3374 Conservation: Complaint for Forfeiture)",
      "17:0101" : "17:0101 (17:101 Copyright Infringement)",
      "17:0501" : "17:0501 (17:501 Copyright Infringement)",
      "17:0504" : "17:0504 (17:504 Copyright Infringement)",
      "18:0241" : "18:0241 (18:241 Conspiracy Against Citizen Rights)",
      "18:1030" : "18:1030 (18:1030(g) Computer Fraud and Abuse Act )",
      "18:1836a" : "18:1836a (18:1836(a) - Injunction against Misappropriation of Trade Secrets)",
      "18:1836b" : "18:1836b (18:1836(b) Civil Action to Protect Trade Secrets)",
      "18:1961" : "18:1961 (18:1961 Racketeering (RICO) Act)",
      "18:1962" : "18:1962 (18:1962 Racketeering (RICO) Act)",
      "18:1964" : "18:1964 (18:1964 Racketeering (RICO) Act)",
      "18:2511" : "18:2511 (18:2511 Wiretapping)",
      "18:3114" : "18:3114 (18:3114 Motion for Return of Seized Property )",
      "18:3524f" : "18:3524f (18:3524 Child Custody Arrangements)",
      "18:4208" : "18:4208 (18:4208(B) Agency Action Review)",
      "19:1305" : "19:1305 (19:1305 Custom Duties:0Forfeiture-Immoral Articles)",
      "20:1080" : "20:1080 (20:1080 Student Loan Recovery)",
      "20:1400" : "20:1400 (20:1400 Civil Rights of Handicapped Child)",
      "20:1401" : "20:1401 (20:1401 Education: Handicapped Child Act)",
      "21:0841" : "21:0841 (21:841 Forfeiture Property-Drugs)",
      "21:0881" : "21:0881 (21:881 Forfeiture Property-Drugs)",
      "21:0881a" : "21:0881a (21:881 Forfeiture Property - Aircraft)",
      "21:0881re" : "21:0881re (21:881 Forfeiture Property - Real Estate)",
      "22:9001" : "22:9001 (22:9001 International Child Abduction Remedies Act)",
      "23:0134" : "23:0134 (23:134 P.I.- Auto Negligence)",
      "23:1441" : "23:1441 (23:1441 Contract Real Estate)",
      "24:1000" : "24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)",
      "25:0640" : "25:0640 (25:640 Indian Tribal Rights)",
      "25:1901" : "25:1901 (25:1901 Indian Child Welfare Act)",
      "26:5872" : "26:5872 (26:5872 Forfeitures)",
      "26:6212" : "26:6212 (26:6212 Injunctive Relief from IRS Lien)",
      "26:6213" : "26:6213 (26:6213 Injunctive Relief from IRS Lien)",
      "26:6502" : "26:6502 (26:6502 IRS:Enforcement of tax liens)",
      "26:6532" : "26:6532 (26:6532 IRS: Refund of Tax Penalty)",
      "26:6702" : "26:6702 (26:6702 IRS: Refund of Income Tax Penalty)",
      "26:6703" : "26:6703 (26:6703 IRS: Refund of Tax Penalty)",
      "26:7401" : "26:7401 (26:7401 IRS: Tax Liability)",
      "26:7402" : "26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)",
      "26:7403" : "26:7403 (26:7403 Suit to Enforce Federal Tax Lien)",
      "26:7422rt" : "26:7422rt (26:7422 IRS: Refund Taxes)",
      "26:7422rx" : "26:7422rx (26:7422 IRS: Refund Excise Tax)",
      "26:7426" : "26:7426 (26:7426 IRS: Wrongful Levy for Taxes)",
      "26:7429" : "26:7429 (26:7429 IRS: Tax Jeopardy Assessment)",
      "26:7609" : "26:7609 (26:7609 IRS: Petition to Quash IRS Summons)",
      "27:0185" : "27:0185 (27:185 Enforcement of Arbitration Award)",
      "28:0157c" : "28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)",
      "28:0157d" : "28:0157d (28:0157 Motion for Withdrawal of Reference)",
      "28:0158" : "28:0158 (28:0158 Notice of Appeal re Bankruptcy Matter (BA)",
      "28:0185" : "28:0185 (28:185 Suit to Compel Arbitration)",
      "28:0451" : "28:0451 (28:451 Employment Discrimination)",
      "28:0754" : "28:0754 (28:754 Receiver of Property in Different Districts )",
      "28:0794" : "28:0794 (28:794 Rehabilitation Act)",
      "28:1001" : "28:1001 (28:1001 E.R.I.S.A.)",
      "28:1132" : "28:1132 (28:1132 E.R.I.S.A.)",
      "28:1330" : "28:1330 (28:1330 Breach of Contract)",
      "28:1331" : "28:1331 (28:1331 Fed. Question)",
      "28:1331al" : "28:1331al (28:1331 Fed. Question: Airline Crash)",
      "28:1331at" : "28:1331at (28:1331 Fed. Question: Anti-trust)",
      "28:1331au" : "28:1331au (28:1331 Fed. Question: Auto Negligence)",
      "28:1331b" : "28:1331b (28:1331 Federal Question: Bivens Act)",
      "28:1331bc" : "28:1331bc (28:1331 Fed. Question: Breach of Contract)",
      "28:1331ca" : "28:1331ca (28:1331 Fed Question: Fed Communications Act of 1)",
      "28:1331cm" : "28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)",
      "28:1331cv" : "28:1331cv (28:1331 Federal Question: Other Civil Rights)",
      "28:1331ed" : "28:1331ed (28:1331 Fed. Question: Employment Discrimination)",
      "28:1331ej" : "28:1331ej (28:1331 Federal Question: Enforcement of Judgment )",
      "28:1331es" : "28:1331es (28:1331 Enforcement of Administrative Subpoena)",
      "28:1331fl" : "28:1331fl (28:1331 Fed. Question: Fair Labor Standards)",
      "28:1331in" : "28:1331in (28:1331 Fed. Question: Insurance Contract)",
      "28:1331mm" : "28:1331mm (28:1331 Fed. Question: Medical Malpractice)",
      "28:1331ng" : "28:1331ng (28:1331 Fed. Question: Natural Gas Act )",
      "28:1331pi" : "28:1331pi (28:1331 Fed. Question: Personal Injury)",
      "28:1331rd" : "28:1331rd (28:1331 Fed. Question: Review Agency Decision)",
      "28:1331rp" : "28:1331rp (28:1331(a) Fed. Question: Real Property)",
      "28:1331rr" : "28:1331rr (28:1331 Fed. Question: Railway Labor Act)",
      "28:1331sv" : "28:1331sv (28:1331 Fed. Question: Securities Violation)",
      "28:1331tr" : "28:1331tr (28:1331 Fed. Question: Trademark)",
      "28:1331tt" : "28:1331tt (28:1331 Fed. Question: Tort Action)",
      "28:1331v" : "28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendme)",
      "28:1331wl" : "28:1331wl (28:1331 Federal Question: EPA Waste Lien)",
      "28:1331wt" : "28:1331wt (28:1331 Fed. Question: Water Rights)",
      "28:1332ac" : "28:1332ac (28:1332 Diversity-Account Receivable)",
      "28:1332al" : "28:1332al (28:1332 Diversity-Airline Crash)",
      "28:1332as" : "28:1332as (28:1332 Diversity-Asbestos Litigation)",
      "28:1332au" : "28:1332au (28:1332 Diversity-Auto Negligence)",
      "28:1332bc" : "28:1332bc (28:1332 Diversity-Breach of Contract)",
      "28:1332co" : "28:1332co (28:1332 Diversity-Conversion)",
      "28:1332ct" : "28:1332ct (28:1332 Diversity-(Citizenship))",
      "28:1332det" : "28:1332det (28:1332 Diversity: Forcible Detainer)",
      "28:1332df" : "28:1332df (28:1332 Diversity-Contract Default)",
      "28:1332ds" : "28:1332ds (28:1332 Diversity-Contract Dispute)",
      "28:1332ed" : "28:1332ed (28:1332 Diversity-Employment Discrimination)",
      "28:1332fd" : "28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)",
      "28:1332fr" : "28:1332fr (28:1332 Diversity-Fraud)",
      "28:1332ia" : "28:1332ia (28:1332 Diversity-Interpleader Action)",
      "28:1332ij" : "28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)",
      "28:1332in" : "28:1332in (28:1332 Diversity-Insurance Contract)",
      "28:1332jd" : "28:1332jd (28:1332 Diversity-Declaratory Judgment)",
      "28:1332lb" : "28:1332lb (28:1332 Diversity-Libel,Assault,Slander)",
      "28:1332lm" : "28:1332lm (28:1332 Diversity - Legal Malpractice)",
      "28:1332ma" : "28:1332ma (28:1332 Diversity-Miller Act)",
      "28:1332mm" : "28:1332mm (28:1332 Diversity-Medical Malpractice)",
      "28:1332mv" : "28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)",
      "28:1332ni" : "28:1332ni (28:1332 Diversity-Negotiable Instrument)",
      "28:1332nm" : "28:1332nm (28:1332 Diversity-Non-Motor Vehicle)",
      "28:1332nr" : "28:1332nr (28:1332 Diversity-Notice of Removal )",
      "28:1332oc" : "28:1332oc (28:1332 Diversity-Other Contract)",
      "28:1332pd" : "28:1332pd (28:1332 Diversity-Property Damage)",
      "28:1332pi" : "28:1332pi (28:1332 Diversity-Personal Injury)",
      "28:1332pl" : "28:1332pl (28:1332 Diversity-Product Liability)",
      "28:1332pr" : "28:1332pr (28:1332 Diversity-Petition for Removal)",
      "28:1332qt" : "28:1332qt (28:1332 Diversity-Petition to Quiet Title)",
      "28:1332ri" : "28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)",
      "28:1332sa" : "28:1332sa (28:1332 - Diversity: Securities & Exchange Commiss)",
      "28:1332sf" : "28:1332sf (28:1332 - Diversity: Securities Fraud)",
      "28:1332ss" : "28:1332ss (28:1332 Diversity - Stockholders Suits)",
      "28:1332tl" : "28:1332tl (28:1332 Diversity-Torts to Land)",
      "28:1332tm" : "28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))",
      "28:1332tn" : "28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)",
      "28:1332wd" : "28:1332wd (28:1332 Diversity-Wrongful Death)",
      "28:1333" : "28:1333 (28:1333 Admiralty)",
      "28:1334" : "28:1334 (28:1334 Bankruptcy Appeal)",
      "28:1334c" : "28:1334c (28:1334(c) R&R re motions for abstention (non-cor)",
      "28:1335" : "28:1335 (28:1335 Interpleader Action)",
      "28:1337" : "28:1337 (28:1337 Sherman-Clayton Act)",
      "28:1338cp" : "28:1338cp (28:1338 Copyright Infringement)",
      "28:1338pt" : "28:1338pt (28:1338 Patent Infringement)",
      "28:1338tr" : "28:1338tr (28:1338 Trademark Infringement)",
      "28:1340" : "28:1340 (28:1340 IRS: Custom Duties)",
      "28:1340er" : "28:1340er (28:1340 Recovery of Erroneous Refund)",
      "28:1341" : "28:1341 (28:1341 Complaint for Forfeiture)",
      "28:1343" : "28:1343 (28:1343 Violation of Civil Rights)",
      "28:1345" : "28:1345 (28:1345 USA Plaintiff )",
      "28:1345co" : "28:1345co (28:1345 Replevin & Conversion)",
      "28:1345db" : "28:1345db (28:1345 Debt to US - FHA/HUD Title I)",
      "28:1345df" : "28:1345df (28:1345 Default of Promissory Note)",
      "28:1345er" : "28:1345er (28:1345 Recovery of Erroneous Refund)",
      "28:1345fc" : "28:1345fc (28:1345 Foreclosure)",
      "28:1345ff" : "28:1345ff (28:1345 Complaint for Forfeiture)",
      "28:1345hl" : "28:1345hl (28:1345 VA Home Loan Guaranty Debt)",
      "28:1345mc" : "28:1345mc (28:1345 Medical Care Recovery)",
      "28:1345mi" : "28:1345mi (28:1345 Mining Claim Ejectment)",
      "28:1345pd" : "28:1345pd (28:1345 Property Damage)",
      "28:1345pe" : "28:1345pe (28:1345 Property Ejectment)",
      "28:1345rc" : "28:1345rc (28:1345 Recovery of Debt to US)",
      "28:1345st" : "28:1345st (28:1345 Default of Student Loan)",
      "28:1345tp" : "28:1345tp (28:1345 Trespass on Public Land)",
      "28:1345va" : "28:1345va (28:1345 Recovery of VA Overpayment)",
      "28:1346bc" : "28:1346bc (28:1346 Breach of Contract)",
      "28:1346rc" : "28:1346rc (28:1346 Recovery of IRS Tax)",
      "28:1346tc" : "28:1346tc (28:1346 Tort Claim)",
      "28:1346wd" : "28:1346wd (28:1346 Wrongful Death)",
      "28:1349" : "28:1349 (28:1348 Corporation organized under Federal Law as party )",
      "28:1352" : "28:1352 (28:1352 Miller Act)",
      "28:1355" : "28:1355 (28:1355 Petition for Return of Property)",
      "28:1358" : "28:1358 (28:1358 Land Condemnation)",
      "28:1361" : "28:1361 (28:1361 Petition for Writ of Mandamus)",
      "28:1362ic" : "28:1362ic (28:1362 Indian Tribal Controversy)",
      "28:1362iw" : "28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)",
      "28:1364" : "28:1364 (28:1364 Auto Negligence)",
      "28:1391" : "28:1391 (28:1391 Personal Injury)",
      "28:1402" : "28:1402 (28:1402 Medical Malpractice)",
      "28:1407" : "28:1407 (28:1407 Airline Crash)",
      "28:1441ac" : "28:1441ac (28:1441 Petition for Removal- Account Receivable)",
      "28:1441al" : "28:1441al (28:1441 Petition for Removal- Airline Crash)",
      "28:1441as" : "28:1441as (28:1441 Petition for Removal- Asbestos Litigation)",
      "28:1441au" : "28:1441au (28:1441 Petition for Removal- Auto Negligence)",
      "28:1441bc" : "28:1441bc (28:1441 Petition for Removal- Breach of Contract)",
      "28:1441cv" : "28:1441cv (28:1441 Petition for Removal- Civil Rights Act)",
      "28:1441df" : "28:1441df (28:1441 Petition for Removal- Contract Default)",
      "28:1441dj" : "28:1441dj (28:1441 Petition for Removal- Declaratory Judgemen)",
      "28:1441ds" : "28:1441ds (28:1441 Petition for Removal- Contract Dispute)",
      "28:1441ed" : "28:1441ed (28:1441 Petition for Removal - Employment Discrim)",
      "28:1441fc" : "28:1441fc (28:1441 Petition for Removal - Fair Credit Reporti)",
      "28:1441fr" : "28:1441fr (28:1441 Petition for Removal- Fraud)",
      "28:1441ij" : "28:1441ij (28:1441 Petition for Removal- Injunctive/Declarato)",
      "28:1441in" : "28:1441in (28:1441 Petition for Removal- Insurance Contract)",
      "28:1441int" : "28:1441int (28:1441 Petition for Removal- Action for Interplea)",
      "28:1441lb" : "28:1441lb (28:1441 Petition for Removal Libel,Assault,Slander)",
      "28:1441lm" : "28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relatio)",
      "28:1441mm" : "28:1441mm (28:1441 Petition for Removal- Medical Malpractice)",
      "28:1441ni" : "28:1441ni (28:1441 Petition for Removal- Negotiable Instrumen)",
      "28:1441nm" : "28:1441nm (28:1441 Petition for Removal- Non-Motor Vehicle)",
      "28:1441nr" : "28:1441nr (28:1441 Notice of Removal )",
      "28:1441oc" : "28:1441oc (28:1441 Petition For Removal--Other Contract)",
      "28:1441pd" : "28:1441pd (28:1441 Petition for Removal- Property Damage)",
      "28:1441pi" : "28:1441pi (28:1441 Petition for Removal- Personal Injury)",
      "28:1441pl" : "28:1441pl (28:1441 Petition for Removal- Product Liability)",
      "28:1441pr" : "28:1441pr (28:1441 Petition for Removal)",
      "28:1441qt" : "28:1441qt (28:1441 Petition for Removal- Petition to Quiet Ti)",
      "28:1441ri" : "28:1441ri (28:1441 Petition for Removal- Racketeering (RICO))",
      "28:1441sa" : "28:1441sa (28:1441 - Petition for Removal: SEC Act)",
      "28:1441sf" : "28:1441sf (28:1441 - Petition for Removal: Securities Fraud)",
      "28:1441tl" : "28:1441tl (28:1441 Petition for Removal- Torts to Land)",
      "28:1441tm" : "28:1441tm (28:1441 Petition for Removal- Tort/Motor Vehicle ()",
      "28:1441tn" : "28:1441tn (28:1441 Petition for Removal- Tort/Non-Motor Vehic)",
      "28:1441wd" : "28:1441wd (28:1441 Petition for Removal- Wrongful Death)",
      "28:1442bc" : "28:1442bc (28:1442 Petition for Removal- Breach of Contract)",
      "28:1442nr" : "28:1442nr (28:1442 Notice of Removal )",
      "28:1442pr" : "28:1442pr (28:1442 Petition for Removal)",
      "28:1443" : "28:1443 (28:1443(1) Rent, Lease & Ejectment)",
      "28:1444" : "28:1444 (28:1444 Petition for Removal- Foreclosure)",
      "28:1446in" : "28:1446in (28:1446 Breach of Contract- Insurance)",
      "28:1446nr" : "28:1446nr (28:1446 Notice of Removal )",
      "28:1446pd" : "28:1446pd (28:1446 Petition for Removal- Property Damage (P.I)",
      "28:1446pi" : "28:1446pi (28:1446 Petition for Removal- Personal Injury)",
      "28:1446pl" : "28:1446pl (28:1446pl Petition for Removal - Product Liability)",
      "28:1446pr" : "28:1446pr (28:1446 Petition for Removal)",
      "28:1452" : "28:1452 (28:1452 R&R re motions to remand (non-core))",
      "28:1651" : "28:1651 (28:1651 Petition for Writ of Coram Nobis)",
      "28:1651hc" : "28:1651hc (28:1651 Petition for Writ of Habeas Corpus)",
      "28:1651mn" : "28:1651mn (28:1651 Petition for Writ of Mandamus)",
      "28:1782" : "28:1782 (28:1782 Letter rogatory - appointment )",
      "28:1983" : "28:1983 (28:1983 Civil Rights)",
      "28:2201" : "28:2201 (28:2201 Constitutionality of State Statute(s))",
      "28:2201dj" : "28:2201dj (28:2201 Declaratory Judgment)",
      "28:2201ij" : "28:2201ij (28:2201 Injunction)",
      "28:2201in" : "28:2201in (28:2201 Declaratory Judgment (Insurance))",
      "28:2241" : "28:2241 (28:2241 Petition for Writ of Habeas Corpus (federa)",
      "28:2254" : "28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))",
      "28:2254se" : "28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)",
      "28:2255" : "28:2255 (28:2255 Motion to Vacate / Correct Illegal Sentenc)",
      "28:2271" : "28:2271 (28:2271 Federal Tort Claims Act)",
      "28:2345" : "28:2345 (28:2345 Medicare Recovery)",
      "28:2409" : "28:2409 (28:2409(a) Quiet Title Action)",
      "28:2410" : "28:2410 (28:2410 Quiet Title)",
      "28:2617" : "28:2617 (28:2617 Family & Medical Leave Act of 1993 )",
      "28:2671" : "28:2671 (28:2671 Federal Tort Claims Act)",
      "28:2674" : "28:2674 (28:2674 Federal Tort Claims Act)",
      "28:3301" : "28:3301 (28:3301 Federal Debt Collection Procedures Act )",
      "28:7402" : "28:7402 (28:7402 Refund of Taxes)",
      "28:7422" : "28:7422 (28:7422 Appeal from Administrative Decision)",
      "29:0151" : "29:0151 (29:151 Labor: Review of Agency Action)",
      "29:0160" : "29:0160 (29:160(1) National Labor Relations Act)",
      "29:0184" : "29:0184 (29:184 Violation Collection Bargain Agreement)",
      "29:0185ep" : "29:0185ep (29:185 Employee Pension Plan)",
      "29:0185lm" : "29:0185lm (29:185 Labor/Mgt. Relations (Contracts))",
      "29:0201do" : "29:0201do (29:201 Denial of Overtime Compensation)",
      "29:0201fl" : "29:0201fl (29:201 Fair Labor Standards Act)",
      "29:0203" : "29:0203 (29:203 Equal Pay Act)",
      "29:0206" : "29:0206 (29:206 Collect Unpaid Wages)",
      "29:0401" : "29:0401 (29:0401 Labor Management Disclosure Act)",
      "29:0621" : "29:0621 (29:621 Job Discrimination (Age))",
      "29:0623" : "29:0623 (29:623 Job Discrimination (Age))",
      "29:0626" : "29:0626 (29:626 Job Discrimination (Age))",
      "29:0633" : "29:0633 (29:633 Job Discrimination (Age))",
      "29:0651" : "29:0651 (29:651 Occupational Safety/Health)",
      "29:0754" : "29:0754 (29:754 Discrimination)",
      "29:0791" : "29:0791 (29:791 Job Discrimination (Rehabilitation Act))",
      "29:0794" : "29:0794 (29:0794 Job Discrimination (Handicap))",
      "29:1001" : "29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)",
      "29:1002" : "29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)",
      "29:1104" : "29:1104 (29:1104 Recovery of Benefits to Employee)",
      "29:1109" : "29:1109 (29:1109 Breach of Fiduciary Duties)",
      "29:1131" : "29:1131 (29:1131 ERISA - Collection of Delinquent Trust Fun)",
      "29:1132" : "29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)",
      "29:1145" : "29:1145 (29:1145 E.R.I.S.A.)",
      "29:1149" : "29:1149 (29:1149 Recover Pension & Profit Sharing)",
      "29:1337" : "29:1337 (29:1337 E.R.I.S.A.)",
      "29:1362" : "29:1362 (29:1362 ERISA)",
      "29:1381" : "29:1381 (29:1381 E.R.I.S.A.)",
      "29:1401" : "29:1401 (29:1401(b)(2) Appeal of Arbitration Award)",
      "29:1451" : "29:1451 (29:1451 E.R.I.S.A.)",
      "29:1801" : "29:1801 (29:1801 Farmworker Rights)",
      "29:790" : "29:790 (29:790 Rehabilitation of Labor)",
      "30:0181" : "30:0181 (30:181 Environment: Review of Agency Action)",
      "30:0801" : "30:0801 (30:0801 Penalities/Federal Mine Safety Health Act)",
      "30:1201" : "30:1201 (30:1201 Environment: Review of Agency Action)",
      "30:1202" : "30:1202 (30:1202 Mining Reclamation Act)",
      "30:1276" : "30:1276 (30:1276 Interior: Review of Agency Action)",
      "31:3545" : "31:3545 (31:3545 Action to Recovery Money)",
      "31:3729" : "31:3729 (31:3729 False Claims Act)",
      "31:3730" : "31:3730 (31:3730 Qui Tam False Claims Act)",
      "31:3731" : "31:3731 (31:3731 Fraud)",
      "31:5314" : "31:5314 (Records and Reports on Foreign Financial Agency Transactions)",
      "33:1319cw" : "33:1319cw (33:1319 Clean Water Act)",
      "33:1319pv" : "33:1319pv (33:1319 Pollutants & Permit Violations)",
      "33:1365" : "33:1365 (33:1365 Environmental Matters)",
      "35:0145" : "35:0145 (35:145 Patent Infringement)",
      "35:0183" : "35:0183 (35:183 Patent Infringement)",
      "35:0271" : "35:0271 (35:271 Patent Infringement)",
      "38:1681" : "38:1681 (38:1681 Recovery of VA Overpayment)",
      "38:1686" : "38:1686 (38:1686 Recovery of VA Overpayment)",
      "38:1780" : "38:1780 (38:1780 Recovery of VA Overpayment)",
      "38:2011" : "38:2011 (38:2011 - Veteran's Readjustment Assistance Act of)",
      "38:2021" : "38:2021 (Right to re-employment of inducted persons )",
      "38:3116" : "38:3116 (38:3116 VA Overpayment)",
      "38:775" : "38:775 (Recovery of Servicemen's Group Life Insurance )",
      "39:3005" : "39:3005 (39:3005 Detention of Mail for Temporary Periods)",
      "39:409" : "39:409 (39:409 Postal Service)",
      "40:0258" : "40:0258 (40:258(a) Public Buildings & Property: Land Condem)",
      "40:0270" : "40:0270 (40:270 Miller Act)",
      "40:0875" : "40:0875 (40:875 Public Buildings & Property: Negligence)",
      "41:0251" : "41:0251 (41:251 Public Contracts-Review of Agency Action)",
      "41:1463" : "41:1463 (41:1463 Public Contracts: Unlawful Employment Prac)",
      "42:0205" : "42:0205 (42:205 Denial Social Security Benefits)",
      "42:0206" : "42:0206 (42:206 Social Security Benefits)",
      "42:0247" : "42:0247 (42:247 Personal Injury-Swine Flu)",
      "42:0402" : "42:0402 (42:402 Social Security Benefits)",
      "42:0405id" : "42:0405id (42:405 Review of HHS Decision (SSID))",
      "42:0405wc" : "42:0405wc (42:405 Review of HHS Decision (DIWC))",
      "42:0405ww" : "42:0405ww (42:405 Review of HHS Decision (DIWW))",
      "42:0416" : "42:0416 (42:416 Denial of Social Security Benefits)",
      "42:0427" : "42:0427 (42:427 Social Security Benefits)",
      "42:12182" : "42:12182 (42:12182 Americans with Disabilities Act )",
      "42:1383" : "42:1383 (42:1383 Review of HHS Decision)",
      "42:1395" : "42:1395 (42:1395 HHS: Adverse Reimbursement Review)",
      "42:1396" : "42:1396 (42:1396 - Tort Negligence)",
      "42:1471" : "42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclo)",
      "42:1981cv" : "42:1981cv (42:1981 Civil Rights)",
      "42:1981hs" : "42:1981hs (42:1981 Housing Discrimination)",
      "42:1981jb" : "42:1981jb (42:1981 Job Discrimination (Race))",
      "42:1981sx" : "42:1981sx (42:1981 Sex Discrimination)",
      "42:1983cv" : "42:1983cv (42:1983 Civil Rights Act)",
      "42:1983ed" : "42:1983ed (42:1983 Civil Rights (Employment Discrimination))",
      "42:1983pr" : "42:1983pr (42:1983 Prisoner Civil Rights)",
      "42:1986" : "42:1986 (42:1986 Neglect of Duty)",
      "42:2000ag" : "42:2000ag (42:2000 Job Discrimination (Age))",
      "42:2000e" : "42:2000e (42:2000e Job Discrimination (Employment))",
      "42:2000pb" : "42:2000pb (42:2000 Job Discrimination (Public Accomodations))",
      "42:2000ra" : "42:2000ra (42:2000 Job Discrimination (Race))",
      "42:2000sx" : "42:2000sx (42:2000 Job Discrimination (Sex))",
      "42:2003" : "42:2003 (42:2003 Job Discrimination)",
      "42:2005" : "42:2005 (42:2005 Review of Agency Action-HHS)",
      "42:2615" : "42:2615 (42:2616 Medical Recovery Act )",
      "42:2651" : "42:2651 (42:2651 Medical Care Recovery)",
      "42:3601" : "42:3601 (42:405 Fair Housing Act)",
      "42:4000" : "42:4000 (42:4000 National Flood Insurance Act)",
      "42:4001" : "42:4001 (42:4001 National Insurance Flood Act)",
      "42:4053" : "42:4053 (42:4053 Breach of Insurance Contract)",
      "42:4072" : "42:4072 (42:4072 Payment of Flood Insurance Claim)",
      "42:4321" : "42:4321 (42:4321 Review of Agency Action-Environment)",
      "42:4332" : "42:4332 (42:4332 Environmental Policy - Coop of Agency Repo)",
      "42:6901en" : "42:6901en (42:6901 Environmental Cleanup Expenses)",
      "42:6901rs" : "42:6901rs (42:6901 Resource & Recovery Act)",
      "42:7413" : "42:7413 (42:7413(b) Clean Air Act)",
      "42:7604cl" : "42:7604cl (42:7604 Clear Air Act (Emission Standards))",
      "42:7604ir" : "42:7604ir (42:7604 Petition to Quash IRS Summons)",
      "42:9607" : "42:9607 (42:9607 Real Property Tort to Land)",
      "43:945" : "43:945 (43:945 Compensation for Land Condemnation)",
      "43:945a" : "43:945a (43:945a Complaint in Condemnation)",
      "43:946" : "43:946 (43:946 Complaint in Condemnation - Eminent Domain)",
      "45:0051" : "45:0051 (45:51 Railways: Fed. Employer's Liability Act)",
      "45:0151" : "45:0151 (45:151 Railway Labor Act)",
      "45:0184" : "45:0184 (45:184 Action to Set Aside Award of a System Board)",
      "45:1395" : "45:1395 (45:1395 Railroads: Adverse Reimbursement Review)",
      "45:7457" : "45:7457 (45:7457 Compel Reclamation Under Clear Air Act)",
      "46:0688" : "46:0688 (46:688 Jones Act)",
      "46:0741" : "46:0741 (46:741 Shipping)",
      "46:0761" : "46:0761 (46:761 Shipping: Damages for Death on High Seas)",
      "46:1101" : "46:1101 (46:1101 Violation of Maritime Regulations)",
      "46:1156" : "46:1156 (46:1156 Administrative Procedure Act)",
      "47:0254" : "47:0254 (Telegraphs, Telephones, and Radio Telegraphs )",
      "48:0883" : "48:0883 (48:883 Violation of US Coastal Law)",
      "48:1985" : "48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)",
      "49:0081" : "49:0081 (49:81 Damaged Goods While Being Transported)",
      "49:0781" : "49:0781 (49:781 Forfeiture)",
      "49:11503" : "49:11503 (49:11503 Railroad Revitalization Regulatory Reform)",
      "49:11702" : "49:11702 (49:11702(a)(4) Violations of Interstate Commerce A)",
      "49:1471" : "49:1471 (49:1471 Federal Aviation Act)",
      "49:1903" : "49:1903 (49:1903 Petition to enforce administrative summon)",
      "8:287" : "8:287 (8:287 Petition to Enforce INS Subpoena)",
      "99:9999" : "99:9999 (99:9999 Report cause code (DO NOT DELETE!) )",
      "adsup" : "adsup (Administrative Subpoena )",
      "contempt" : "contempt (Contempt Proceedings )",
      "disbar" : "disbar (Disbarment Proceedings )",
      "fordepo" : "fordepo (Foreign Deposition )",
      "misc" : "misc (Civil Miscellaneous Case)",
      "motcomp" : "motcomp (Motion to Compel )",
      "motquash" : "motquash (Motion to Quash )",
      "motret" : "motret (Motion for Return of Property )",
      "petenf" : "petenf (Petition to Enforce IRS Summons )",
      "petper" : "petper (Petition to Perpetuate Testimony )",
      "regjgm" : "regjgm (Registration of Foreign Judgment )",
      "rule60" : "rule60 (Rule 60(b) Motion for Relief from Judgment/Order)",
      "tranbkref" : "tranbkref (Transmission of Bankruptcy Reference )",
      "tranff" : "tranff (Transmission of Proposed Findings of Fact and Concl. of Law )",
      "writgar" : "writgar (Application for a Writ of Garnishment )"
   },
   "gasdce" : {
      "0" : "0 (no cause specified)",
      "02:0431" : "02:0431 (02:431 Fed. Election Commission: Failure Enforce Compliance)",
      "02:0437" : "02:0437 (02:437 Federal Election Commission)",
      "05:0075" : "05:0075 (05:75(2) Contract - Reduction in Grade)",
      "05:0551" : "05:0551 (05:551 Administrative Procedure Act)",
      "05:0552fi" : "05:0552fi (05:552 Freedom of Information Act)",
      "05:0552pa" : "05:0552pa (05:552 Right to Privacy Act)",
      "05:0554" : "05:0554 (05:0554 Constitutionality of Maritime Statutes)",
      "05:0701" : "05:0701 (05:0701 Maritime Subsidy Board)",
      "05:0702" : "05:0702 (05:702 Administrative Procedure Act)",
      "05:0704" : "05:0704 (05:704 Labor Litigation)",
      "05:7703" : "05:7703 (05:7703 Discrimination - Review of Agency Act)",
      "05:8470" : "05:8470 (05:8470 Enforcement of Judgment against Retirement Benefits)",
      "07:0006" : "07:0006 (7:6(b) Federal Commodity Exchange Regulation)",
      "07:0025" : "07:0025 (7:25 Fraud - Commodities Leverage Contracts)",
      "07:0181" : "07:0181 (07:181 Packers & Stockyard Act)",
      "07:0499" : "07:0499 (07:499 Agricultural Commodities Act)",
      "07:0601" : "07:0601 (07:601 USDA Condemnation)",
      "07:2321" : "07:2321 (07:2321 Plant Variety Protection Act)",
      "08:1105" : "08:1105 (8:1105(a) Aliens: Habeas Corpus to Release INS Detainee)",
      "08:1182" : "08:1182 (8:1182 Defend. Denial of Pla. Appl. for Alien Employment Cer)",
      "08:1252" : "08:1252 (08:1252(a)(2) Injunction for Deportation)",
      "08:1260" : "08:1260 (08:1260 Aliens: Access to Records)",
      "08:1324" : "08:1324 (08:1324 Aliens: Complaint for Forfeiture)",
      "08:1329" : "08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petition)",
      "08:1446" : "08:1446 (8:1446 Petition for Naturalization Hearing)",
      "08:1451(j)" : "08:1451(j) (8:1451(j) Motion to Correct Order & Judg. of Naturalization)",
      "09:0001" : "09:0001 (09:1 U.S. Arbitration Act)",
      "09:0009" : "09:0009 (9:9 Motion to Confirm Arbitration Loan)",
      "09:0010" : "09:0010 (09:0010 Petition to Vacate Arbitration Award)",
      "10:1408" : "10:1408 (10:1408 Claim for Military Retirement)",
      "10:1552" : "10:1552 (10:1552 Armed Forces: Action to Correct Records)",
      "10:1553" : "10:1553 (10:1553 Armed Forces: FOIA General)",
      "10:2305" : "10:2305 (10:2305 Review of Federal Contract)",
      "11:0101" : "11:0101 (11:101 Bankruptcy)",
      "12:0022" : "12:0022 (12:22 Securities Fraud)",
      "12:0635" : "12:0635 (12:635 Breach of Insurance Contract)",
      "12:1461" : "12:1461 (12:1461 Homeowners Loan Act)",
      "12:1464" : "12:1464 (12:1464 Federal Savings and Loan)",
      "12:1703" : "12:1703 (12:1703 Default of HUD Loan)",
      "12:1725" : "12:1725 (12:1725 Collection under Contract Guaranty)",
      "12:1730" : "12:1730 (12:1730 Collection Under Contract Guaranty)",
      "12:1819" : "12:1819 (12:1819 Default of Promissory Note)",
      "12:1821" : "12:1821 (12:1821 Default of Loan by Promissary Note)",
      "12:191" : "12:191 (12:191 Bank Foreclosure)",
      "12:192" : "12:192 (12:192 Liquidation of National Bank)",
      "12:1971" : "12:1971 (12:1971 Relief under Bank Holding Act)",
      "12:1972" : "12:1972 (12:1972 Typing Arrangement Act)",
      "12:3410" : "12:3410 (12:3410 Right to Financial Privacy Act)",
      "15:0001" : "15:0001 (15:1 Antitrust Litigation)",
      "15:0002at" : "15:0002at (15:2 Antitrust Litigation)",
      "15:0002fl" : "15:0002fl (15:2(a) Fair Labor Standards Act)",
      "15:0005" : "15:0005 (15:5(a) Fair Labor Standards Act)",
      "15:0015" : "15:0015 (15:15 Antitrust Litigation)",
      "15:0025" : "15:0025 (15:25 Clayton Act)",
      "15:0044" : "15:0044 (15:44 Trademark Infringement)",
      "15:0045" : "15:0045 (15:0045 Federal Trade Commission Act)",
      "15:0052" : "15:0052 (15:0052 Federal Trade Commission Act)",
      "15:0053" : "15:0053 (15:0053 Federal Trade Commission Act)",
      "15:0077" : "15:0077 (15:77 Securities Fraud)",
      "15:0078" : "15:0078 (15:78m(a) Securities Exchange Act)",
      "15:0078(j)" : "15:0078(j) (15:78(j) Securities Fraud under Securities Exch. Act of 1934)",
      "15:0631" : "15:0631 (15:631 Small Business Act)",
      "15:0717" : "15:0717 (15:717 Natural Gas Act)",
      "15:0754" : "15:0754 (15:754 Emergency Petroleum Allocation-Admin.& Enforcement)",
      "15:1051" : "15:1051 (15:1051 Trademark Infringement)",
      "15:1114" : "15:1114 (15:1114 Trademark Infringement)",
      "15:1121" : "15:1121 (15:1121 Trademark Infringement)",
      "15:1125" : "15:1125 (15:1125 Trademark Infringement (Lanham Act))",
      "15:1126" : "15:1126 (15:1126 Patent Infringement)",
      "15:1127" : "15:1127 (15:1127 Trademark Infringement)",
      "15:1601" : "15:1601 (15:1601 Truth in Lending)",
      "15:1640" : "15:1640 (15:1640 Truth in Lending)",
      "15:1681" : "15:1681 (15:1681 Fair Credit Reporting Act)",
      "15:1692" : "15:1692 (15:1692 Fair Debt Collection Act)",
      "15:1938" : "15:1938 (15:1938 Fair Labor Standards Act)",
      "15:1981" : "15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))",
      "15:1988" : "15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))",
      "15:1989" : "15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))",
      "15:2301" : "15:2301 (15:2301 Magnuson-Moss Warranty Act)",
      "15:2801" : "15:2801 (15:2801 Petroleum Marketing Practices Act)",
      "15:53(b)" : "15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equita)",
      "16:0668" : "16:0668 (16:668 Bald Eagle Protection Act)",
      "16:0703" : "16:0703 (16:703 Migratory Bird Act)",
      "16:1538" : "16:1538 (16:1538 Endangered Species Act)",
      "16:3371" : "16:3371 (16:3371 Wildlife Under the Lacey Act)",
      "16:3372" : "16:3372 (16:3372 Conservation: Complaint for Forfeiture)",
      "16:3373" : "16:3373 (16:3373 Appeal of Decision - DOI)",
      "16:3374" : "16:3374 (16:3374 Conservation: Complaint for Forfeiture)",
      "17:0101" : "17:0101 (17:101 Copyright Infringement)",
      "17:0501" : "17:0501 (17:501 Copyright Infringement)",
      "17:0504" : "17:0504 (17:504 Copyright Infringement)",
      "18:0241" : "18:0241 (18:241 Conspiracy Against Citizen Rights)",
      "18:0981" : "18:0981 (18:0981 Civil Forfeiture)",
      "18:1581" : "18:1581 (18:1581 Peonage: Obstructing Enforcement)",
      "18:1582" : "18:1582 (18:1582 Vessels for Slave Trade)",
      "18:1583" : "18:1583 (18:1583 Enticement Into Slavery)",
      "18:1584" : "18:1584 (18:1584 Sale Into Involuntary Servitude)",
      "18:1585" : "18:1585 (18:1585 Seizure, Detention, Transportation or Sale of Slave)",
      "18:1586" : "18:1586 (18:1586 Service on Vessels in Slave Trade)",
      "18:1587" : "18:1587 (18:1587 Possession of Slaves Aboard Vessel)",
      "18:1588" : "18:1588 (18:1588 Transportation of Slaves from U.S.)",
      "18:1589" : "18:1589 (18:1589 Forced Labor)",
      "18:1590" : "18:1590 (18:1590 Trafficking With Respect to Peonage, Slavery, Involuntary Servitude, or Forced Labor)",
      "18:1591" : "18:1591 (18:1591 Sex Trafficking of Children or by Force, Fraud or Coercion)",
      "18:1592" : "18:1592 (18:1592 Unlawful Conduct w/ Respect to Documents in Furtherance of Trafficking, ..., Forced Labor)",
      "18:1594" : "18:1594 (18:1594 Forfeiture)",
      "18:1594(A)" : "18:1594(A) (18:1594(A) Attempt to Establish Peonage, Slavery, Involuntary Servitude, or Human Trafficking)",
      "18:1594(C)" : "18:1594(C) (18:1594(C) Conspiracy to Commit Sex Trafficking of Children by Force, Fraud, or Coercion)",
      "18:1836a" : "18:1836a (18:1836(a) Injunction against Misappropriation of Trade Secrets)",
      "18:1836b" : "18:1836b (18:1836(b) Civil Action to Protect Trade Secrets)",
      "18:1961" : "18:1961 (18:1961 Racketeering (RICO) Act)",
      "18:1962" : "18:1962 (18:1962 Racketeering (RICO) Act)",
      "18:1964" : "18:1964 (18:1964 Racketeering (RICO) Act)",
      "18:2511" : "18:2511 (18:2511 Wiretapping)",
      "18:3114" : "18:3114 (18:3114 Motion for Return of Seized Property)",
      "18:4208" : "18:4208 (18:4208(B) Agency Action Review)",
      "18:843(b)" : "18:843(b) (Use of Communication Facility)",
      "19:1305" : "19:1305 (19:1305 Custom Duties: Forfeiture-Immoral Articles)",
      "20:1080" : "20:1080 (20:1080 Student Loan Recovery)",
      "20:1400" : "20:1400 (20:1400 Civil Rights of Handicapped Child)",
      "20:1401" : "20:1401 (20:1401 Education: Handicapped Child Act)",
      "21:0841" : "21:0841 (21:841 Forfeiture Property-Drugs)",
      "21:0881" : "21:0881 (21:881 Forfeiture Property-Drugs)",
      "21:0881a" : "21:0881a (21:881 Forfeiture Property - Aircraft)",
      "21:0881re" : "21:0881re (21:881 Forfeiture Property - Real Estate)",
      "23:0134" : "23:0134 (23:134 P.I.- Auto Negligence)",
      "23:1441" : "23:1441 (23:1441 Contract Real Estate)",
      "24:1000" : "24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)",
      "25:0640" : "25:0640 (25:640 Indian Tribal Rights)",
      "25:1901" : "25:1901 (25:1901 Indian Child Welfare Act)",
      "26:6212" : "26:6212 (26:6212 Injunctive Relief from IRS Lien)",
      "26:6213" : "26:6213 (26:6213 Injunctive Relief from IRS Lien)",
      "26:6502" : "26:6502 (26:6502 IRS:Enforcement of tax liens)",
      "26:6532" : "26:6532 (26:6532 IRS: Refund of Tax Penalty)",
      "26:6702" : "26:6702 (26:6702 IRS: Refund of Income Tax Penalty)",
      "26:6703" : "26:6703 (26:6703 IRS: Refund of Tax Penalty)",
      "26:7401" : "26:7401 (26:7401 IRS: Tax Liability)",
      "26:7402" : "26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)",
      "26:7403" : "26:7403 (26:7403 Suit to Enforce Federal Tax Lien)",
      "26:7422rt" : "26:7422rt (26:7422 IRS: Refund Taxes)",
      "26:7422rx" : "26:7422rx (26:7422 IRS: Refund Excise Tax)",
      "26:7426" : "26:7426 (26:7426 IRS: Wrongful Levy for Taxes)",
      "26:7429" : "26:7429 (26:7429 IRS: Tax Jeopardy Assessment)",
      "26:7609" : "26:7609 (26:7609 IRS: Petition to Quash IRS Summons)",
      "27:0185" : "27:0185 (27:185 Enforcement of Arbitration Award)",
      "28:0157c" : "28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)",
      "28:0157d" : "28:0157d (28:0157 Motion for Withdrawal of Reference)",
      "28:0158" : "28:0158 (28:0158 Bankruptcy Appeal from Judgment/Order)",
      "28:0185" : "28:0185 (28:185 Suit to Compel Arbitration)",
      "28:0451" : "28:0451 (28:451 Employment Discrimination)",
      "28:0754" : "28:0754 (28:754 Receiver of Property in Different Districts)",
      "28:0794" : "28:0794 (28:794 Rehabilitation Act)",
      "28:1001" : "28:1001 (28:1001 E.R.I.S.A.)",
      "28:1132" : "28:1132 (28:1132 E.R.I.S.A.)",
      "28:1330" : "28:1330 (28:1330 Breach of Contract)",
      "28:1331" : "28:1331 (28:1331 Fed. Question)",
      "28:1331al" : "28:1331al (28:1331 Fed. Question: Airline Crash)",
      "28:1331at" : "28:1331at (28:1331 Fed. Question: Anti-trust)",
      "28:1331au" : "28:1331au (28:1331 Fed. Question: Auto Negligence)",
      "28:1331b" : "28:1331b (28:1331 Federal Question: Bivens Act)",
      "28:1331bc" : "28:1331bc (28:1331 Fed. Question: Breach of Contract)",
      "28:1331ca" : "28:1331ca (28:1331 Fed Question: Fed Communications Act of 1)",
      "28:1331cm" : "28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)",
      "28:1331cv" : "28:1331cv (28:1331 Fed. Question: Civil Rights Violation)",
      "28:1331ed" : "28:1331ed (28:1331 Fed. Question: Employment Discrimination)",
      "28:1331ej" : "28:1331ej (28:1331 Federal Question: Enforcement of Judgment)",
      "28:1331es" : "28:1331es (28:1331 Enforcement of Administrative Subpoena)",
      "28:1331fl" : "28:1331fl (28:1331 Fed. Question: Fair Labor Standards)",
      "28:1331in" : "28:1331in (28:1331 Fed. Question: Insurance Contract)",
      "28:1331mm" : "28:1331mm (28:1331 Fed. Question: Medical Malpractice)",
      "28:1331ng" : "28:1331ng (28:1331 Fed. Question: Natural Gas Act)",
      "28:1331pi" : "28:1331pi (28:1331 Fed. Question: Personal Injury)",
      "28:1331pr" : "28:1331pr (Fed. Question: Prisoner Petition)",
      "28:1331rd" : "28:1331rd (28:1331 Fed. Question: Review Agency Decision)",
      "28:1331rp" : "28:1331rp (28:1331(a) Fed. Question: Real Property)",
      "28:1331rr" : "28:1331rr (28:1331 Fed. Question: Railway Labor Act)",
      "28:1331sv" : "28:1331sv (28:1331 Fed. Question: Securities Violation)",
      "28:1331tr" : "28:1331tr (28:1331 Fed. Question: Trademark)",
      "28:1331tt" : "28:1331tt (28:1331 Fed. Question: Tort Action)",
      "28:1331v" : "28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendment)",
      "28:1331wl" : "28:1331wl (28:1331 Federal Question: EPA Waste Lien)",
      "28:1331wt" : "28:1331wt (28:1331 Fed. Question: Water Rights)",
      "28:1332" : "28:1332 (28:1332 Diversity of citizenship)",
      "28:1332ac" : "28:1332ac (28:1332 Diversity-Account Receivable)",
      "28:1332al" : "28:1332al (28:1332 Diversity-Airline Crash)",
      "28:1332as" : "28:1332as (28:1332 Diversity-Asbestos Litigation)",
      "28:1332au" : "28:1332au (28:1332 Diversity-Auto Negligence)",
      "28:1332bc" : "28:1332bc (28:1332 Diversity-Breach of Contract)",
      "28:1332co" : "28:1332co (28:1332 Diversity-Conversion)",
      "28:1332ct" : "28:1332ct (28:1332 Diversity-(Citizenship))",
      "28:1332det" : "28:1332det (28:1332 Diversity: Forcible Detainer)",
      "28:1332df" : "28:1332df (28:1332 Diversity-Contract Default)",
      "28:1332ds" : "28:1332ds (28:1332 Diversity-Contract Dispute)",
      "28:1332ed" : "28:1332ed (28:1332 Diversity-Employment Discrimination)",
      "28:1332fd" : "28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)",
      "28:1332fr" : "28:1332fr (28:1332 Diversity-Fraud)",
      "28:1332ia" : "28:1332ia (28:1332 Diversity-Interpleader Action)",
      "28:1332ij" : "28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)",
      "28:1332in" : "28:1332in (28:1332 Diversity-Insurance Contract)",
      "28:1332ip" : "28:1332ip (Diversity - Interpleader Action)",
      "28:1332jd" : "28:1332jd (28:1332 Diversity-Declaratory Judgment)",
      "28:1332lb" : "28:1332lb (28:1332 Diversity-Libel, Assault, Slander)",
      "28:1332lm" : "28:1332lm (28:1332 Diversity - Legal Malpractice)",
      "28:1332ma" : "28:1332ma (28:1332 Diversity-Miller Act)",
      "28:1332mm" : "28:1332mm (28:1332 Diversity-Medical Malpractice)",
      "28:1332mv" : "28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)",
      "28:1332ni" : "28:1332ni (28:1332 Diversity-Negotiable Instrument)",
      "28:1332nm" : "28:1332nm (28:1332 Diversity-Non-Motor Vehicle)",
      "28:1332nr" : "28:1332nr (28:1332 Diversity-Notice of Removal)",
      "28:1332oc" : "28:1332oc (28:1332 Diversity-Other Contract)",
      "28:1332pd" : "28:1332pd (28:1332 Diversity-Property Damage)",
      "28:1332pi" : "28:1332pi (28:1332 Diversity-Personal Injury)",
      "28:1332pl" : "28:1332pl (28:1332 Diversity-Product Liability)",
      "28:1332pr" : "28:1332pr (28:1332 Diversity-Petition for Removal)",
      "28:1332qt" : "28:1332qt (28:1332 Diversity-Petition to Quiet Title)",
      "28:1332ri" : "28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)",
      "28:1332sa" : "28:1332sa (28:1332 - Diversity: Securities & Exchange Commiss)",
      "28:1332sf" : "28:1332sf (28:1332 - Diversity: Securities Fraud)",
      "28:1332ss" : "28:1332ss (28:1332 Diversity - Stockholders Suits)",
      "28:1332tl" : "28:1332tl (28:1332 Diversity-Torts to Land)",
      "28:1332tm" : "28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))",
      "28:1332tn" : "28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)",
      "28:1332wd" : "28:1332wd (28:1332 Diversity-Wrongful Death)",
      "28:1333" : "28:1333 (28:1333 Admiralty)",
      "28:1334" : "28:1334 (28:1334 Bankruptcy Appeal)",
      "28:1334c" : "28:1334c (28:1334(c) R&R re motions for abstention (non-cor)",
      "28:1335" : "28:1335 (28:1335 Interpleader Action)",
      "28:1337" : "28:1337 (28:1337 Sherman-Clayton Act)",
      "28:1338cp" : "28:1338cp (28:1338 Copyright Infringement)",
      "28:1338pt" : "28:1338pt (28:1338 Patent Infringement)",
      "28:1338tr" : "28:1338tr (28:1338 Trademark Infringement)",
      "28:1340" : "28:1340 (28:1340 IRS: Custom Duties)",
      "28:1340er" : "28:1340er (28:1340 Recovery of Erroneous Refund)",
      "28:1341" : "28:1341 (28:1341 Complaint for Forfeiture)",
      "28:1343" : "28:1343 (28:1343 Violation of Civil Rights)",
      "28:1345" : "28:1345 (28:1345 USA Plaintiff)",
      "28:1345co" : "28:1345co (28:1345 Replevin & Conversion)",
      "28:1345db" : "28:1345db (28:1345 Debt to US - FHA/HUD Title I)",
      "28:1345df" : "28:1345df (28:1345 Default of Promissory Note)",
      "28:1345er" : "28:1345er (28:1345 Recovery of Erroneous Refund)",
      "28:1345fc" : "28:1345fc (28:1345 Foreclosure)",
      "28:1345ff" : "28:1345ff (28:1345 Complaint for Forfeiture)",
      "28:1345hl" : "28:1345hl (28:1345 VA Home Loan Guaranty Debt)",
      "28:1345mc" : "28:1345mc (28:1345 Medical Care Recovery)",
      "28:1345mi" : "28:1345mi (28:1345 Mining Claim Ejectment)",
      "28:1345pd" : "28:1345pd (28:1345 Property Damage)",
      "28:1345pe" : "28:1345pe (28:1345 VA Property Ejectment)",
      "28:1345rc" : "28:1345rc (28:1345 Recovery of Debt to US)",
      "28:1345st" : "28:1345st (28:1345 Default of Student Loan)",
      "28:1345tp" : "28:1345tp (28:1345 Trespass on Public Land)",
      "28:1345va" : "28:1345va (28:1345 Recovery of VA Overpayment)",
      "28:1346(b)" : "28:1346(b) (28:1346(b) Federal Tort Claims Act)",
      "28:1346bc" : "28:1346bc (28:1346 Breach of Contract)",
      "28:1346rc" : "28:1346rc (28:1346 Recovery of IRS Tax)",
      "28:1346tc" : "28:1346tc (28:1346 Tort Claim)",
      "28:1346wd" : "28:1346wd (28:1346 Wrongful Death)",
      "28:1349" : "28:1349 (28:1348 Corporation organized under Federal Law as party)",
      "28:1352" : "28:1352 (28:1352 Miller Act)",
      "28:1355" : "28:1355 (28:1355 Petition for Return of Property)",
      "28:1358" : "28:1358 (28:1358 Land Condemnation)",
      "28:1361" : "28:1361 (28:1361 Petition for Writ of Mandamus)",
      "28:1362ic" : "28:1362ic (28:1362 Indian Tribal Controversy)",
      "28:1362iw" : "28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)",
      "28:1364" : "28:1364 (28:1364 Actions against Insurers of Diplomatic Missions)",
      "28:1391" : "28:1391 (28:1391 Venue Generally)",
      "28:1402" : "28:1402 (28:1402 United States as Defendant)",
      "28:1407" : "28:1407 (28:1407 Multidistrict Litigation)",
      "28:1441ac" : "28:1441ac (28:1441 Notice of Removal-Account Receivable)",
      "28:1441al" : "28:1441al (28:1441 Notice of Removal-Airline Crash)",
      "28:1441as" : "28:1441as (28:1441 Notice of Removal-Asbestos Litigation)",
      "28:1441au" : "28:1441au (28:1441 Notice of Removal-Auto Negligence)",
      "28:1441bc" : "28:1441bc (28:1441 Notice of Removal-Breach of Contract)",
      "28:1441cv" : "28:1441cv (28:1441 Petition for Removal- Civil Rights Act)",
      "28:1441df" : "28:1441df (28:1441 Notice of Removal-Contract Default)",
      "28:1441dj" : "28:1441dj (28:1441 Notice of Removal-Declaratory Judgment)",
      "28:1441ds" : "28:1441ds (28:1441 Notice of Removal-Contract Dispute)",
      "28:1441ed" : "28:1441ed (28:1441 Petition for Removal - Employment Discrim)",
      "28:1441fc" : "28:1441fc (28:1441 Petition for Removal - Fair Credit Reporti)",
      "28:1441fr" : "28:1441fr (28:1441 Notice of Removal-Fraud)",
      "28:1441ij" : "28:1441ij (28:1441 Notice of Removal-Injunctive/Declaratory Relief)",
      "28:1441in" : "28:1441in (28:1441 Notice of Removal-Insurance Contract)",
      "28:1441int" : "28:1441int (28:1441 Petition for Removal- Action for Interplea)",
      "28:1441lb" : "28:1441lb (28:1441 Notice of Removal-Libel, Assault, Slander)",
      "28:1441lm" : "28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relatio)",
      "28:1441mm" : "28:1441mm (28:1441 Notice of Removal-Medical Malpractice)",
      "28:1441ni" : "28:1441ni (28:1441 Notice of Removal-Negotiable Instrument)",
      "28:1441nm" : "28:1441nm (28:1441 Notice of Removal-Non-Motor Vehicle)",
      "28:1441nr" : "28:1441nr (28:1441 Notice of Removal)",
      "28:1441oc" : "28:1441oc (28:1441 Petition For Removal--Other Contract)",
      "28:1441pd" : "28:1441pd (28:1441 Notice of Removal-Property Damage)",
      "28:1441pi" : "28:1441pi (28:1441 Notice of Removal-Personal Injury)",
      "28:1441pl" : "28:1441pl (28:1441 Notice of Removal-Product Liability)",
      "28:1441pr" : "28:1441pr (28:1441 Petition for Removal)",
      "28:1441qt" : "28:1441qt (28:1441 Notice of Removal-Petition to Quiet Title)",
      "28:1441ri" : "28:1441ri (28:1441 Petition for Removal- Racketeering (RICO))",
      "28:1441sa" : "28:1441sa (28:1441 - Petition for Removal: SEC Act)",
      "28:1441sf" : "28:1441sf (28:1441 - Petition for Removal: Securities Fraud)",
      "28:1441tl" : "28:1441tl (28:1441 Notice of Removal-Torts to Land)",
      "28:1441tm" : "28:1441tm (28:1441 Notice of Removal-Tort/Motor Vehicle (P.I.))",
      "28:1441tn" : "28:1441tn (28:1441 Notice of Removal-Tort/Non-Motor Vehicle)",
      "28:1441wd" : "28:1441wd (28:1441 Notice of Removal-Wrongful Death)",
      "28:1442bc" : "28:1442bc (28:1442 Notice of Removal-Breach of Contract)",
      "28:1442nr" : "28:1442nr (28:1442 Notice of Removal)",
      "28:1442pr" : "28:1442pr (28:1442 Petition for Removal)",
      "28:1443" : "28:1443 (28:1443(1) Rent, Lease & Ejectment)",
      "28:1444" : "28:1444 (28:1441 Notice of Removal-Foreclosure)",
      "28:1446in" : "28:1446in (28:1446 Breach of Contract- Insurance)",
      "28:1446nr" : "28:1446nr (28:1446 Notice of Removal)",
      "28:1446pd" : "28:1446pd (28:1446 Notice of Removal-Property Damage (P.I.))",
      "28:1446pi" : "28:1446pi (28:1446 Notice of Removal-Personal Injury)",
      "28:1446pl" : "28:1446pl (28:1446pl Petition for Removal - Product Liability)",
      "28:1446pr" : "28:1446pr (28:1446 Petition for Removal)",
      "28:1452" : "28:1452 (28:1452 Removal of Claim in Civil Action Related to BK. Case)",
      "28:1651" : "28:1651 (28:1651 Petition for Writ of Coram Nobis)",
      "28:1651hc" : "28:1651hc (28:1651 Petition for Writ of Habeas Corpus)",
      "28:1651mn" : "28:1651mn (28:1651 Petition for Writ of Mandamus)",
      "28:1782" : "28:1782 (28:1782 Letter rogatory - appointment)",
      "28:1983" : "28:1983 (28:1983 Civil Rights)",
      "28:2201" : "28:2201 (28:2201 Constitutionality of State Statute(s))",
      "28:2201dj" : "28:2201dj (28:2201 Declaratory Judgment)",
      "28:2201ij" : "28:2201ij (28:2201 Injunction)",
      "28:2201in" : "28:2201in (28:2201 Declaratory Judgment (Insurance))",
      "28:2241" : "28:2241 (28:2241 Petition for Writ of Habeas Corpus (Federal))",
      "28:2254" : "28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))",
      "28:2254se" : "28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)",
      "28:2255" : "28:2255 (28:2255 Motion to Vacate Sentence)",
      "28:2271" : "28:2271 (28:2271 Federal Tort Claims Act)",
      "28:2345" : "28:2345 (28:2345 Medicare Recovery)",
      "28:2409" : "28:2409 (28:2409(a) Quiet Title Action)",
      "28:2410" : "28:2410 (Actions affecting property on which United States had lien)",
      "28:2671" : "28:2671 (28:2671 Federal Tort Claims Act)",
      "28:2674" : "28:2674 (28:2674 Federal Tort Claims Act)",
      "28:3001" : "28:3001 (28:3001 Federal Debt Collection Act)",
      "28:7402" : "28:7402 (28:7402 Refund of Taxes)",
      "28:7422" : "28:7422 (28:7422 Appeal from Administrative Decision)",
      "29:0151" : "29:0151 (29:151 Labor: Review of Agency Action)",
      "29:0160" : "29:0160 (29:160(1) National Labor Relations Act)",
      "29:0184" : "29:0184 (29:184 Violation Collection Bargain Agreement)",
      "29:0185ep" : "29:0185ep (29:185 Employee Pension Plan)",
      "29:0185lm" : "29:0185lm (29:185 Labor/Mgt. Relations (Contracts))",
      "29:0201do" : "29:0201do (29:201 Denial of Overtime Compensation)",
      "29:0201fl" : "29:0201fl (29:201 Fair Labor Standards Act)",
      "29:0203" : "29:0203 (29:203 Equal Pay Act)",
      "29:0206" : "29:0206 (29:206 Collect Unpaid Wages)",
      "29:0401" : "29:0401 (29:0401 Labor Management Disclosure Act)",
      "29:0621" : "29:0621 (29:621 Job Discrimination (Age))",
      "29:0623" : "29:0623 (29:623 Job Discrimination (Age))",
      "29:0626" : "29:0626 (29:626 Job Discrimination (Age))",
      "29:0633" : "29:0633 (29:633 Job Discrimination (Age))",
      "29:0651" : "29:0651 (29:651 Occupational Safety/Health)",
      "29:0754" : "29:0754 (29:754 Discrimination)",
      "29:0791" : "29:0791 (29:791 Job Discrimination (Rehabilitation Act))",
      "29:0794" : "29:0794 (29:0794 Job Discrimination (Handicap))",
      "29:1001" : "29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)",
      "29:1002" : "29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)",
      "29:1104" : "29:1104 (29:1104 Recovery of Benefits to Employee)",
      "29:1109" : "29:1109 (29:1109 Breach of Fiduciary Duties)",
      "29:1131" : "29:1131 (29:1131 ERISA - Collection of Delinquent Trust Funds)",
      "29:1132" : "29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)",
      "29:1145" : "29:1145 (29:1145 E.R.I.S.A.)",
      "29:1149" : "29:1149 (29:1149 Recover Pension & Profit Sharing)",
      "29:1337" : "29:1337 (29:1337 E.R.I.S.A.)",
      "29:1362" : "29:1362 (29:1362 ERISA)",
      "29:1381" : "29:1381 (29:1381 E.R.I.S.A.)",
      "29:1401" : "29:1401 (29:1401(b)(2) Appeal of Arbitration Award)",
      "29:1451" : "29:1451 (29:1451 E.R.I.S.A.)",
      "29:1801" : "29:1801 (29:1801 Farmworker Rights)",
      "29:2615" : "29:2615 (Family and Medical Leave Act of 1993 (FMLA of 1993))",
      "29:790" : "29:790 (29:790 Rehabilitation of Labor)",
      "30:0181" : "30:0181 (30:181 Environment: Review of Agency Action)",
      "30:0801" : "30:0801 (30:0801 Penalities/Federal Mine Safety Health Act)",
      "30:1201" : "30:1201 (30:1201 Environment: Review of Agency Action)",
      "30:1202" : "30:1202 (30:1202 Mining Reclamation Act)",
      "30:1276" : "30:1276 (30:1276 Interior: Review of Agency Action)",
      "31:3545" : "31:3545 (31:3545 Action to Recovery Money)",
      "31:3729" : "31:3729 (31:3729 False Claims Act)",
      "31:3730" : "31:3730 (31:3730 Qui Tam False Claims Act)",
      "31:3731" : "31:3731 (31:3731 Fraud)",
      "33:1319cw" : "33:1319cw (33:1319 Clean Water Act)",
      "33:1319pv" : "33:1319pv (33:1319 Pollutants & Permit Violations)",
      "33:1365" : "33:1365 (33:1365 Environmental Matters)",
      "35:0145" : "35:0145 (35:145 Patent Infringement)",
      "35:0183" : "35:0183 (35:183 Patent Infringement)",
      "35:0271" : "35:0271 (35:271 Patent Infringement)",
      "38:1681" : "38:1681 (38:1681 Recovery of VA Overpayment)",
      "38:1686" : "38:1686 (38:1686 Recovery of VA Overpayment)",
      "38:1780" : "38:1780 (38:1780 Recovery of VA Overpayment)",
      "38:2011" : "38:2011 (38:2011 - Veteran's Readjustment Assistance Act of)",
      "38:2021" : "38:2021 (Right to re-employment of inducted persons)",
      "38:3116" : "38:3116 (38:3116 VA Overpayment)",
      "38:775" : "38:775 (Recovery of Servicemen's Group Life Insurance)",
      "39:3005" : "39:3005 (39:3005 Detention of Mail for Temporary Periods)",
      "39:409" : "39:409 (39:409 Postal Service)",
      "40:0258" : "40:0258 (40:258(a) Public Buildings & Property: Land Condemnation)",
      "40:0270" : "40:0270 (40:270 Miller Act)",
      "40:0875" : "40:0875 (40:875 Public Buildings & Property: Negligence)",
      "41:0251" : "41:0251 (41:251 Public Contracts-Review of Agency Action)",
      "41:1463" : "41:1463 (41:1463 Public Contracts: Unlawful Employment Practices)",
      "42:0205" : "42:0205 (42:205 Denial Social Security Benefits)",
      "42:0206" : "42:0206 (42:206 Social Security Benefits)",
      "42:0247" : "42:0247 (42:247 Personal Injury-Swine Flu)",
      "42:0402" : "42:0402 (42:402 Social Security Benefits)",
      "42:0405id" : "42:0405id (42:405 Review of HHS Decision (SSID))",
      "42:0405wc" : "42:0405wc (42:405 Review of HHS Decision (DIWC))",
      "42:0405ww" : "42:0405ww (42:405 Review of HHS Decision (DIWW))",
      "42:0416" : "42:0416 (42:416 Denial of Social Security Benefits)",
      "42:0427" : "42:0427 (42:427 Social Security Benefits)",
      "42:11601" : "42:11601 (42:11601 Int'l Child Abduction Remedies Act (Hague Conventn))",
      "42:12111" : "42:12111 (Americans with Disabilities Act of 1990)",
      "42:12117" : "42:12117 (42:12117 Americans with Disabilities Act)",
      "42:1383" : "42:1383 (42:1383 Review of HHS Decision)",
      "42:1395" : "42:1395 (42:1395 HHS: Adverse Reimbursement Review)",
      "42:1396" : "42:1396 (42:1396 - Tort Negligence)",
      "42:1471" : "42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclo)",
      "42:1981cv" : "42:1981cv (42:1981 Civil Rights)",
      "42:1981hs" : "42:1981hs (42:1981 Housing Discrimination)",
      "42:1981jb" : "42:1981jb (42:1981 Job Discrimination (Race))",
      "42:1981sx" : "42:1981sx (42:1981 Sex Discrimination)",
      "42:1983cv" : "42:1983cv (42:1983 Civil Rights Act)",
      "42:1983ed" : "42:1983ed (42:1983 Civil Rights (Employment Discrimination))",
      "42:1983pr" : "42:1983pr (42:1983 Prisoner Civil Rights)",
      "42:1986" : "42:1986 (42:1986 Neglect of Duty)",
      "42:2000ag" : "42:2000ag (42:2000 Job Discrimination (Age))",
      "42:2000e" : "42:2000e (42:2000e Job Discrimination (Employment))",
      "42:2000pb" : "42:2000pb (42:2000 Job Discrimination (Public Accommodations))",
      "42:2000ra" : "42:2000ra (42:2000 Job Discrimination (Race))",
      "42:2000sx" : "42:2000sx (42:2000 Job Discrimination (Sex))",
      "42:2003" : "42:2003 (42:2003 Job Discrimination)",
      "42:2005" : "42:2005 (42:2005 Review of Agency Action-HHS)",
      "42:2615" : "42:2615 (42:2616 Medical Recovery Act)",
      "42:2651" : "42:2651 (42:2651 Medical Care Recovery)",
      "42:3601" : "42:3601 (42:3601 Fair Housing Act)",
      "42:4000" : "42:4000 (42:4000 National Flood Insurance Act)",
      "42:4001" : "42:4001 (42:4001 National Insurance Flood Act)",
      "42:4053" : "42:4053 (42:4053 Breach of Insurance Contract)",
      "42:4072" : "42:4072 (42:4072 Payment of Flood Insurance Claim)",
      "42:4321" : "42:4321 (42:4321 Review of Agency Action-Environment)",
      "42:4332" : "42:4332 (42:4332)",
      "42:5851" : "42:5851 (42:5851 Proto/emp. Reporting Violations/atomic energy act)",
      "42:6901en" : "42:6901en (42:6901 Environmental Cleanup Expenses)",
      "42:6901rs" : "42:6901rs (42:6901 Resource & Recovery Act)",
      "42:7413" : "42:7413 (42:7413(b) Clean Air Act)",
      "42:7604cl" : "42:7604cl (42:7604 Clear Air Act (Emission Standards))",
      "42:7604ir" : "42:7604ir (42:7604 Petition to Quash IRS Summons)",
      "42:9604" : "42:9604 (42:9604 Comp. Environ. Response Comp. and Liab. Act (CERCLA))",
      "42:9607" : "42:9607 (42:9607 Real Property Tort to Land)",
      "43:945" : "43:945 (43:945 Compensation for Land Condemnation)",
      "43:945a" : "43:945a (43:945a Complaint in Condemnation)",
      "43:946" : "43:946 (43:946 Complaint in Condemnation - Eminent Domain)",
      "45:0051" : "45:0051 (45:51 Railways: Fed. Employer's Liability Act)",
      "45:0151" : "45:0151 (45:151 Railway Labor Act)",
      "45:0184" : "45:0184 (45:184 Action to Set Aside Award of a System Board of Adjust)",
      "45:1395" : "45:1395 (45:1395 Railroads: Adverse Reimbursement Review)",
      "45:7457" : "45:7457 (45:7457 Compel Reclamation Under Clear Air Act)",
      "46:0688" : "46:0688 (46:688 Jones Act)",
      "46:0741" : "46:0741 (46:741 Shipping)",
      "46:0761" : "46:0761 (46:761 Shipping: Damages for Death on High Seas)",
      "46:1101" : "46:1101 (46:1101 Violation of Maritime Regulations)",
      "46:1156" : "46:1156 (46:1156 Administrative Procedure Act)",
      "47:227" : "47:227 (47 USC 227 Telephone Consumer Protection Act)",
      "47:332" : "47:332 (47.U.S.C. 332(c)(7) Federal Communications Act of 1996)",
      "48:0883" : "48:0883 (48:883 Violation of US Coastal Law)",
      "48:1985" : "48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)",
      "49:0081" : "49:0081 (49:81 Damaged Goods While Being Transported)",
      "49:0781" : "49:0781 (49:781 Forfeiture)",
      "49:11503" : "49:11503 (49:11503 Railroad Revitalization Regulatory Reform)",
      "49:11702" : "49:11702 (49:11702(a)(4) Violations of Interstate Commerce A)",
      "49:11707" : "49:11707 (Liability of Common Carriers)",
      "49:1471" : "49:1471 (49:1471 Federal Aviation Act)",
      "49:1903" : "49:1903 (49:1903 Petition to enforce administrative summon)",
      "4:111" : "4:111 (4:111 Taxation Affecting Federal Employees)",
      "8:287" : "8:287 (8:287 Petition to Enforce INS Subpoena)",
      "99:9999" : "99:9999 (99:9999 Report cause code (DO NOT DELETE!))",
      "adsup" : "adsup (Administrative Subpoena)",
      "contempt" : "contempt (Contempt Proceedings)",
      "disbar" : "disbar (Disbarment Proceedings)",
      "fordepo" : "fordepo (Foreign Deposition)",
      "misc" : "misc (Civil Miscellaneous Case)",
      "motcomp" : "motcomp (Motion to Compel)",
      "motquash" : "motquash (Motion to Quash)",
      "motret" : "motret (Motion for Return of Property)",
      "petenf" : "petenf (Petition to Enforce IRS Summons)",
      "petper" : "petper (Petition to Perpetuate Testimony)",
      "regjgm" : "regjgm (Registration of Foreign Judgment)",
      "tranbkref" : "tranbkref (Transmission of Bankruptcy Reference)",
      "tranff" : "tranff (Transmission of Proposed Findings of Fact and Concl. of Law)",
      "writgar" : "writgar (Application for a Writ of Garnishment)"
   },
   "gudce" : {
      "0" : "0 (No cause code entered)",
      "00:0000" : "00:0000 (00:0000 Cause Code Unknown)",
      "02:0431" : "02:0431 (02:431 Fed. Election Commission: Failure Enforce Compliance)",
      "02:0437" : "02:0437 (02:437 Federal Election Commission)",
      "05:0075" : "05:0075 (05:75(2) Contract - Reduction in Grade)",
      "05:0551" : "05:0551 (05:551 Administrative Procedure Act)",
      "05:0552fi" : "05:0552fi (05:552 Freedom of Information Act)",
      "05:0552pa" : "05:0552pa (05:552 Right to Privacy Act)",
      "05:0554" : "05:0554 (05:0554 Constitutionality of Maritime Statutes)",
      "05:0701" : "05:0701 (05:0701 Maritime Subsidy Board)",
      "05:0702" : "05:0702 (05:702 Administrative Procedure Act)",
      "05:0704" : "05:0704 (05:704 Labor Litigation)",
      "05:7703" : "05:7703 (05:7703 Discrimination - Review of Agency Act)",
      "07:0006" : "07:0006 (7:6(b) Federal Commodity Exchange Regulation)",
      "07:0025" : "07:0025 (7:25 Fraud - Commodities Leverage Contracts)",
      "07:0181" : "07:0181 (07:181 Packers & Stockyard Act)",
      "07:0499" : "07:0499 (07:499 Agricultural Commodities Act)",
      "07:0601" : "07:0601 (07:601 USDA Condemnation)",
      "07:2023" : "07:2023 (07:2023 Administrative and judicial review - restoration of rights)",
      "07:2024e" : "07:2024e (Forfeiture of property involved in illegal benefit transactions, 7 USC 2014(e))",
      "07:2321" : "07:2321 (07:2321 Plant Variety Protection Act)",
      "08:1105" : "08:1105 (8:1105(a) Aliens: Habeas Corpus to Release INS Detainee)",
      "08:1252" : "08:1252 (08:1252(a)(2) Injunction for Deportation)",
      "08:1260" : "08:1260 (08:1260 Aliens: Access to Records)",
      "08:1324" : "08:1324 (08:1324 Aliens: Complaint for Forfeiture)",
      "08:1329" : "08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petition)",
      "08:1446" : "08:1446 (8:1446 Petition for Naturalization Hearing)",
      "08:1451a" : "08:1451a (Revocation of Naturalization - Title 8 USC 1451(a))",
      "09:0001" : "09:0001 (09:1 U.S. Arbitration Act)",
      "09:0009" : "09:0009 (9:9 Motion to Confirm Arbitration Loan)",
      "09:0010" : "09:0010 (09:0010 Petition to Vacate Arbitration Award)",
      "10:1552" : "10:1552 (10:1552 Armed Forces: Action to Correct Records)",
      "10:1553" : "10:1553 (10:1553 Armed Forces: FOIA General)",
      "10:2305" : "10:2305 (10:2305 Review of Federal Contract)",
      "11:0101" : "11:0101 (11:101 Bankruptcy)",
      "12:0022" : "12:0022 (12:22 Securities Fraud)",
      "12:0635" : "12:0635 (12:635 Breach of Insurance Contract)",
      "12:1461" : "12:1461 (12:1461 Homeowners Loan Act)",
      "12:1703" : "12:1703 (12:1703 Default of HUD Loan)",
      "12:1725" : "12:1725 (12:1725 Collection under Contract Guaranty)",
      "12:1730" : "12:1730 (12:1730 Collection Under Contract Guaranty)",
      "12:1819" : "12:1819 (12:1819 Default of Promissory Note)",
      "12:1821" : "12:1821 (12:1821 Default of Loan by Promissary Note)",
      "12:1971" : "12:1971 (12:1971 Relief under Bank Holding Act)",
      "12:3410" : "12:3410 (12:3410 Right to Financial Privacy Act)",
      "15:0001" : "15:0001 (15:1 Antitrust Litigation)",
      "15:0002at" : "15:0002at (15:2 Antitrust Litigation)",
      "15:0002fl" : "15:0002fl (15:2(a) Fair Labor Standards Act)",
      "15:0005" : "15:0005 (15:5(a) Fair Labor Standards Act)",
      "15:0015" : "15:0015 (15:15 Antitrust Litigation)",
      "15:0025" : "15:0025 (15:25 Clayton Act)",
      "15:0044" : "15:0044 (15:44 Trademark Infringement)",
      "15:0045" : "15:0045 (15:0045 Federal Trade Commission Act)",
      "15:0052" : "15:0052 (15:0052 Federal Trade Commission Act)",
      "15:0053" : "15:0053 (15:0053 Federal Trade Commission Act)",
      "15:0077" : "15:0077 (15:77 Securities Fraud)",
      "15:0078" : "15:0078 (15:78m(a) Securities Exchange Act)",
      "15:0631" : "15:0631 (15:631 Small Business Act)",
      "15:0717" : "15:0717 (15:717 Natural Gas Act)",
      "15:1051" : "15:1051 (15:1051 Trademark Infringement)",
      "15:1114" : "15:1114 (15:1114 Trademark Infringement)",
      "15:1121" : "15:1121 (15:1121 Trademark Infringement)",
      "15:1125" : "15:1125 (15:1125 Trademark Infringement (Lanham Act))",
      "15:1126" : "15:1126 (15:1126 Patent Infringement)",
      "15:1127" : "15:1127 (15:1127 Trademark Infringement)",
      "15:1601" : "15:1601 (15:1601 Truth in Lending)",
      "15:1640" : "15:1640 (15:1640 Truth in Lending)",
      "15:1681" : "15:1681 (15:1681 Fair Credit Reporting Act)",
      "15:1692" : "15:1692 (15:1692 Fair Debt Collection Act)",
      "15:1938" : "15:1938 (15:1938 Fair Labor Standards Act)",
      "15:1981" : "15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))",
      "15:1988" : "15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))",
      "15:1989" : "15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))",
      "15:2301" : "15:2301 (15:2301 Magnuson-Moss Warranty Act)",
      "15:2801" : "15:2801 (15:2801 Petroleum Marketing Practices Act)",
      "15:53(b)" : "15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equitable Relief)",
      "16:0668" : "16:0668 (16:668 Bald Eagle Protection Act)",
      "16:0703" : "16:0703 (16:703 Migratory Bird Act)",
      "16:1538" : "16:1538 (16:1538 Endangered Species Act)",
      "16:3371" : "16:3371 (16:3371 Wildlife Under the Lacey Act)",
      "16:3372" : "16:3372 (16:3372 Conservation: Complaint for Forfeiture)",
      "16:3373" : "16:3373 (16:3373 Appeal of Decision - DOI)",
      "16:3374" : "16:3374 (16:3374 Conservation: Complaint for Forfeiture)",
      "17:0101" : "17:0101 (17:101 Copyright Infringement)",
      "17:0501" : "17:0501 (17:501 Copyright Infringement)",
      "17:0504" : "17:0504 (17:504 Copyright Infringement)",
      "18:0241" : "18:0241 (18:241 Conspiracy Against Citizen Rights)",
      "18:0981a1C" : "18:0981a1C (Civil Forfeiture, 18 USC 981(a)(1)(C))",
      "18:1836a" : "18:1836a (18:1836(a) Injunction against Misappropriation of Trade Secrets)",
      "18:1836b" : "18:1836b (18:1836(b) Civil Action to Protect Trade Secrets)",
      "18:1961" : "18:1961 (18:1961 Racketeering (RICO) Act)",
      "18:1962" : "18:1962 (18:1962 Racketeering (RICO) Act)",
      "18:1964" : "18:1964 (18:1964 Racketeering (RICO) Act)",
      "18:2323" : "18:2323 (18:2323 Forfeiture, destruction, and restitution)",
      "18:4208" : "18:4208 (18:4208(B) Agency Action Review)",
      "19:1305" : "19:1305 (19:1305 Custom Duties:0Forfeiture-Immoral Articles)",
      "20:1080" : "20:1080 (20:1080 Student Loan Recovery)",
      "20:1400" : "20:1400 (20:1400 Civil Rights of Handicapped Child)",
      "20:1401" : "20:1401 (20:1401 Education: Handicapped Child Act)",
      "21:0841" : "21:0841 (21:841 Forfeiture Property-Drugs)",
      "21:0881" : "21:0881 (21:881 Forfeiture Property-Drugs)",
      "21:0881a" : "21:0881a (21:881 Forfeiture Property - Aircraft)",
      "21:0881re" : "21:0881re (21:881 Forfeiture Property - Real Estate)",
      "21:451" : "21:451 (21:451 Poultry and Poultry Products Inspection)",
      "23:0134" : "23:0134 (23:134 P.I.- Auto Negligence)",
      "23:1441" : "23:1441 (23:1441 Contract Real Estate)",
      "24:1000" : "24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)",
      "25:0640" : "25:0640 (25:640 Indian Tribal Rights)",
      "25:1901" : "25:1901 (25:1901 Indian Child Welfare Act)",
      "26:6212" : "26:6212 (26:6212 Injunctive Relief from IRS Lien)",
      "26:6213" : "26:6213 (26:6213 Injunctive Relief from IRS Lien)",
      "26:6502" : "26:6502 (26:6502 IRS:Enforcement of tax liens)",
      "26:6532" : "26:6532 (26:6532 IRS: Refund of Tax Penalty)",
      "26:6702" : "26:6702 (26:6702 IRS: Refund of Income Tax Penalty)",
      "26:6703" : "26:6703 (26:6703 IRS: Refund of Tax Penalty)",
      "26:7401" : "26:7401 (26:7401 IRS: Tax Liability)",
      "26:7402" : "26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)",
      "26:7403" : "26:7403 (26:7403 Suit to Enforce Federal Tax Lien)",
      "26:7422rt" : "26:7422rt (26:7422 IRS: Refund Taxes)",
      "26:7422rx" : "26:7422rx (26:7422 IRS: Refund Excise Tax)",
      "26:7426" : "26:7426 (26:7426 IRS: Wrongful Levy for Taxes)",
      "26:7429" : "26:7429 (26:7429 IRS: Tax Jeopardy Assessment)",
      "26:7609" : "26:7609 (26:7609 IRS: Petition to Quash IRS Summons)",
      "27:0185" : "27:0185 (27:185 Enforcement of Arbitration Award)",
      "28:0157c" : "28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)",
      "28:0157d" : "28:0157d (28:0157 Motion for Withdrawal of Reference)",
      "28:0158" : "28:0158 (28:0158 Notice of Appeal re Bankruptcy Matter (BAP))",
      "28:0185" : "28:0185 (28:185 Suit to Compel Arbitration)",
      "28:0451" : "28:0451 (28:451 Employment Discrimination)",
      "28:0794" : "28:0794 (28:794 Rehabilitation Act)",
      "28:1001" : "28:1001 (28:1001 E.R.I.S.A.)",
      "28:1132" : "28:1132 (28:1132 E.R.I.S.A.)",
      "28:1330" : "28:1330 (28:1330 Breach of Contract)",
      "28:1331" : "28:1331 (28:1331 Fed. Question)",
      "28:1331al" : "28:1331al (28:1331 Fed. Question: Airline Crash)",
      "28:1331at" : "28:1331at (28:1331 Fed. Question: Anti-trust)",
      "28:1331au" : "28:1331au (28:1331 Fed. Question: Auto Negligence)",
      "28:1331b" : "28:1331b (28:1331 Federal Question: Bivens Act)",
      "28:1331bc" : "28:1331bc (28:1331 Fed. Question: Breach of Contract)",
      "28:1331ca" : "28:1331ca (28:1331 Fed Question: Fed Communications Act of 1934)",
      "28:1331cm" : "28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)",
      "28:1331cv" : "28:1331cv (28:1331 Federal Question: Other Civil Rights)",
      "28:1331ed" : "28:1331ed (28:1331 Fed. Question: Employment Discrimination)",
      "28:1331es" : "28:1331es (28:1331 Enforcement of Administrative Subpoena)",
      "28:1331fl" : "28:1331fl (28:1331 Fed. Question: Fair Labor Standards)",
      "28:1331in" : "28:1331in (28:1331 Fed. Question: Insurance Contract)",
      "28:1331mm" : "28:1331mm (28:1331 Fed. Question: Medical Malpractice)",
      "28:1331pi" : "28:1331pi (28:1331 Fed. Question: Personal Injury)",
      "28:1331rd" : "28:1331rd (28:1331 Fed. Question: Review Agency Decision)",
      "28:1331rp" : "28:1331rp (28:1331(a) Fed. Question: Real Property)",
      "28:1331rr" : "28:1331rr (28:1331 Fed. Question: Railway Labor Act)",
      "28:1331sv" : "28:1331sv (28:1331 Fed. Question: Securities Violation)",
      "28:1331tr" : "28:1331tr (28:1331 Fed. Question: Trademark)",
      "28:1331tt" : "28:1331tt (28:1331 Fed. Question: Tort Action)",
      "28:1331v" : "28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendment)",
      "28:1331wl" : "28:1331wl (28:1331 Federal Question: EPA Waste Lien)",
      "28:1331wt" : "28:1331wt (28:1331 Fed. Question: Water Rights)",
      "28:1332ac" : "28:1332ac (28:1332 Diversity-Account Receivable)",
      "28:1332al" : "28:1332al (28:1332 Diversity-Airline Crash)",
      "28:1332as" : "28:1332as (28:1332 Diversity-Asbestos Litigation)",
      "28:1332au" : "28:1332au (28:1332 Diversity-Auto Negligence)",
      "28:1332bc" : "28:1332bc (28:1332 Diversity-Breach of Contract)",
      "28:1332co" : "28:1332co (28:1332 Diversity-Conversion)",
      "28:1332ct" : "28:1332ct (28:1332 Diversity-(Citizenship))",
      "28:1332det" : "28:1332det (28:1332 Diversity: Forcible Detainer)",
      "28:1332df" : "28:1332df (28:1332 Diversity-Contract Default)",
      "28:1332ds" : "28:1332ds (28:1332 Diversity-Contract Dispute)",
      "28:1332ed" : "28:1332ed (28:1332 Diversity-Employment Discrimination)",
      "28:1332fd" : "28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)",
      "28:1332fr" : "28:1332fr (28:1332 Diversity-Fraud)",
      "28:1332ia" : "28:1332ia (28:1332 Diversity-Interpleader Action)",
      "28:1332ij" : "28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)",
      "28:1332in" : "28:1332in (28:1332 Diversity-Insurance Contract)",
      "28:1332jd" : "28:1332jd (28:1332 Diversity-Declaratory Judgement)",
      "28:1332lb" : "28:1332lb (28:1332 Diversity-Libel,Assault,Slander)",
      "28:1332lm" : "28:1332lm (28:1332 Diversity - Legal Malpractice)",
      "28:1332ma" : "28:1332ma (28:1332 Diversity-Miller Act)",
      "28:1332mm" : "28:1332mm (28:1332 Diversity-Medical Malpractice)",
      "28:1332mv" : "28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)",
      "28:1332ni" : "28:1332ni (28:1332 Diversity-Negotiable Instrument)",
      "28:1332nm" : "28:1332nm (28:1332 Diversity-Non-Motor Vehicle)",
      "28:1332oc" : "28:1332oc (28:1332 Diversity-Other Contract)",
      "28:1332pd" : "28:1332pd (28:1332 Diversity-Property Damage)",
      "28:1332pi" : "28:1332pi (28:1332 Diversity-Personal Injury)",
      "28:1332pl" : "28:1332pl (28:1332 Diversity-Product Liability)",
      "28:1332pr" : "28:1332pr (28:1332 Diversity-Petition for Removal)",
      "28:1332qt" : "28:1332qt (28:1332 Diversity-Petition to Quiet Title)",
      "28:1332ri" : "28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)",
      "28:1332sa" : "28:1332sa (28:1332 - Diversity: Securities & Exchange Commission Act)",
      "28:1332sf" : "28:1332sf (28:1332 - Diversity: Securities Fraud)",
      "28:1332ss" : "28:1332ss (28:1332 Diversity - Stockholders Suits)",
      "28:1332tl" : "28:1332tl (28:1332 Diversity-Torts to Land)",
      "28:1332tm" : "28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))",
      "28:1332tn" : "28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)",
      "28:1332wd" : "28:1332wd (28:1332 Diversity-Wrongful Death)",
      "28:1333" : "28:1333 (28:1333 Admiralty)",
      "28:1334" : "28:1334 (28:1334 Bankruptcy Appeal)",
      "28:1334c" : "28:1334c (28:1334(c) R&R re motions for abstention (non-core))",
      "28:1335" : "28:1335 (28:1335 Interpleader Action)",
      "28:1337" : "28:1337 (28:1337 Sherman-Clayton Act)",
      "28:1338cp" : "28:1338cp (28:1338 Copyright Infringement)",
      "28:1338pt" : "28:1338pt (28:1338 Patent Infringement)",
      "28:1338tr" : "28:1338tr (28:1338 Trademark Infringement)",
      "28:1340" : "28:1340 (28:1340 IRS: Custom Duties)",
      "28:1340er" : "28:1340er (28:1340 Recovery of Erroneous Refund)",
      "28:1341" : "28:1341 (28:1341 Complaint for Forfeiture)",
      "28:1343" : "28:1343 (28:1343 Violation of Civil Rights)",
      "28:1345co" : "28:1345co (28:1345 Replevin & Conversion)",
      "28:1345db" : "28:1345db (28:1345 Debt to US - FHA/HUD Title I)",
      "28:1345df" : "28:1345df (28:1345 Default of Promissory Note)",
      "28:1345er" : "28:1345er (28:1345 Recovery of Erroneous Refund)",
      "28:1345fc" : "28:1345fc (28:1345 Foreclosure)",
      "28:1345ff" : "28:1345ff (28:1345 Complaint for Forfeiture)",
      "28:1345hl" : "28:1345hl (28:1345 VA Home Loan Guaranty Debt)",
      "28:1345mc" : "28:1345mc (28:1345 Medical Care Recovery)",
      "28:1345mi" : "28:1345mi (28:1345 Mining Claim Ejectment)",
      "28:1345pd" : "28:1345pd (28:1345 Property Damage)",
      "28:1345pe" : "28:1345pe (28:1345 Property Ejectment)",
      "28:1345rc" : "28:1345rc (28:1345 Recovery of Debt to US)",
      "28:1345st" : "28:1345st (28:1345 Default of Student Loan)",
      "28:1345tp" : "28:1345tp (28:1345 Trespass on Public Land)",
      "28:1345va" : "28:1345va (28:1345 Recovery of VA Overpayment)",
      "28:1346bc" : "28:1346bc (28:1346 Breach of Contract)",
      "28:1346rc" : "28:1346rc (28:1346 Recovery of IRS Tax)",
      "28:1346tc" : "28:1346tc (28:1346 Tort Claim)",
      "28:1346wd" : "28:1346wd (28:1346 Wrongful Death)",
      "28:1352" : "28:1352 (28:1352 Miller Act)",
      "28:1355" : "28:1355 (28:1355 Petition for Return of Property)",
      "28:1358" : "28:1358 (28:1358 Land Condemnation)",
      "28:1361" : "28:1361 (28:1361 Petition for Writ of Mandamus)",
      "28:1362ic" : "28:1362ic (28:1362 Indian Tribal Controversy)",
      "28:1362iw" : "28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)",
      "28:1364" : "28:1364 (28:1364 Auto Negligence)",
      "28:1391" : "28:1391 (28:1391 Personal Injury)",
      "28:1402" : "28:1402 (28:1402 Medical Malpractice)",
      "28:1407" : "28:1407 (28:1407 Airline Crash)",
      "28:1441ac" : "28:1441ac (28:1441 Petition for Removal- Account Receivable)",
      "28:1441al" : "28:1441al (28:1441 Petition for Removal- Airline Crash)",
      "28:1441as" : "28:1441as (28:1441 Petition for Removal- Asbestos Litigation)",
      "28:1441au" : "28:1441au (28:1441 Petition for Removal- Auto Negligence)",
      "28:1441bc" : "28:1441bc (28:1441 Petition for Removal- Breach of Contract)",
      "28:1441cv" : "28:1441cv (28:1441 Petition for Removal- Civil Rights Act)",
      "28:1441df" : "28:1441df (28:1441 Petition for Removal- Contract Default)",
      "28:1441dj" : "28:1441dj (28:1441 Petition for Removal- Declaratory Judgement)",
      "28:1441ds" : "28:1441ds (28:1441 Petition for Removal- Contract Dispute)",
      "28:1441ed" : "28:1441ed (28:1441 Petition for Removal - Employment Discrimination)",
      "28:1441fc" : "28:1441fc (28:1441 Petition for Removal - Fair Credit Reporting Act)",
      "28:1441fr" : "28:1441fr (28:1441 Petition for Removal- Fraud)",
      "28:1441ij" : "28:1441ij (28:1441 Petition for Removal- Injunctive/Declaratory Relief)",
      "28:1441in" : "28:1441in (28:1441 Petition for Removal- Insurance Contract)",
      "28:1441int" : "28:1441int (28:1441 Petition for Removal- Action for Interpleader)",
      "28:1441lb" : "28:1441lb (28:1441 Petition for Removal Libel,Assault,Slander)",
      "28:1441lm" : "28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relations)",
      "28:1441mm" : "28:1441mm (28:1441 Petition for Removal- Medical Malpractice)",
      "28:1441ni" : "28:1441ni (28:1441 Petition for Removal- Negotiable Instrument)",
      "28:1441nm" : "28:1441nm (28:1441 Petition for Removal- Non-Motor Vehicle)",
      "28:1441oc" : "28:1441oc (28:1441 Petition For Removal--Other Contract)",
      "28:1441pd" : "28:1441pd (28:1441 Petition for Removal- Property Damage)",
      "28:1441pi" : "28:1441pi (28:1441 Petition for Removal- Personal Injury)",
      "28:1441pl" : "28:1441pl (28:1441 Petition for Removal- Product Liability)",
      "28:1441pr" : "28:1441pr (28:1441 Petition for Removal)",
      "28:1441qt" : "28:1441qt (28:1441 Petition for Removal- Petition to Quiet Title)",
      "28:1441ri" : "28:1441ri (28:1441 Petition for Removal- Racketeering (RICO) Act)",
      "28:1441sa" : "28:1441sa (28:1441 - Petition for Removal: SEC Act)",
      "28:1441sf" : "28:1441sf (28:1441 - Petition for Removal: Securities Fraud)",
      "28:1441tl" : "28:1441tl (28:1441 Petition for Removal- Torts to Land)",
      "28:1441tm" : "28:1441tm (28:1441 Petition for Removal- Tort/Motor Vehicle (P.I.))",
      "28:1441tn" : "28:1441tn (28:1441 Petition for Removal- Tort/Non-Motor Vehicle)",
      "28:1441wd" : "28:1441wd (28:1441 Petition for Removal- Wrongful Death)",
      "28:1442bc" : "28:1442bc (28:1442 Petition for Removal- Breach of Contract)",
      "28:1442pr" : "28:1442pr (28:1442 Petition for Removal)",
      "28:1443" : "28:1443 (28:1443(1) Rent, Lease & Ejectment)",
      "28:1444" : "28:1444 (28:1444 Petition for Removal- Foreclosure)",
      "28:1446in" : "28:1446in (28:1446 Breach of Contract- Insurance)",
      "28:1446pd" : "28:1446pd (28:1446 Petition for Removal- Property Damage (P.I.))",
      "28:1446pi" : "28:1446pi (28:1446 Petition for Removal- Personal Injury)",
      "28:1446pl" : "28:1446pl (28:1446pl Petition for Removal - Product Liability)",
      "28:1446pr" : "28:1446pr (28:1446 Petition for Removal)",
      "28:1452" : "28:1452 (28:1452 R&R re motions to remand (non-core))",
      "28:1651" : "28:1651 (28:1651 Petition for Writ of Coram Nobis)",
      "28:1651hc" : "28:1651hc (28:1651 Petition for Writ of Habeas Corpus)",
      "28:1651mn" : "28:1651mn (28:1651 Petition for Writ of Mandamus)",
      "28:1983" : "28:1983 (28:1983 Civil Rights)",
      "28:2201" : "28:2201 (28:2201 Constitutionality of State Statute(s))",
      "28:2201dj" : "28:2201dj (28:2201 Declaratory Judgement)",
      "28:2201ij" : "28:2201ij (28:2201 Injunction)",
      "28:2201in" : "28:2201in (28:2201 Declaratory Judgement (Insurance))",
      "28:2241" : "28:2241 (28:2241 Petition for Writ of Habeas Corpus (federal))",
      "28:2254" : "28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))",
      "28:2254se" : "28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)",
      "28:2255" : "28:2255 (28:2255 Motion to Vacate / Correct Illegal Sentence)",
      "28:2271" : "28:2271 (28:2271 Federal Tort Claims Act)",
      "28:2345" : "28:2345 (28:2345 Medicare Recovery)",
      "28:2409" : "28:2409 (28:2409(a) Quiet Title Action)",
      "28:2410" : "28:2410 (28:2410 Quiet Title)",
      "28:2671" : "28:2671 (28:2671 Federal Tort Claims Act)",
      "28:2674" : "28:2674 (28:2674 Federal Tort Claims Act)",
      "28:3001" : "28:3001 (28:3001 Federal Debt Collection Act)",
      "28:7402" : "28:7402 (28:7402 Refund of Taxes)",
      "28:7422" : "28:7422 (28:7422 Appeal from Administrative Decision)",
      "29:0151" : "29:0151 (29:151 Labor: Review of Agency Action)",
      "29:0160" : "29:0160 (29:160(1) National Labor Relations Act)",
      "29:0184" : "29:0184 (29:184 Violation Collection Bargain Agreement)",
      "29:0185ep" : "29:0185ep (29:185 Employee Pension Plan)",
      "29:0185lm" : "29:0185lm (29:185 Labor/Mgt. Relations (Contracts))",
      "29:0201do" : "29:0201do (29:201 Denial of Overtime Compensation)",
      "29:0201fl" : "29:0201fl (29:201 Fair Labor Standards Act)",
      "29:0203" : "29:0203 (29:203 Equal Pay Act)",
      "29:0206" : "29:0206 (29:206 Collect Unpaid Wages)",
      "29:0401" : "29:0401 (29:0401 Labor Management Disclosure Act)",
      "29:0621" : "29:0621 (29:621 Job Discrimination (Age))",
      "29:0623" : "29:0623 (29:623 Job Discrimination (Age))",
      "29:0626" : "29:0626 (29:626 Job Discrimination (Age))",
      "29:0633" : "29:0633 (29:633 Job Discrimination (Age))",
      "29:0651" : "29:0651 (29:651 Occupational Safety/Health)",
      "29:0754" : "29:0754 (29:754 Discrimination)",
      "29:0791" : "29:0791 (29:791 Job Discrimination (Rehabilitation Act))",
      "29:0794" : "29:0794 (29:0794 Job Discrimination (Handicap))",
      "29:1001" : "29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)",
      "29:1002" : "29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)",
      "29:1104" : "29:1104 (29:1104 Recovery of Benefits to Employee)",
      "29:1109" : "29:1109 (29:1109 Breach of Fiduciary Duties)",
      "29:1131" : "29:1131 (29:1131 ERISA - Collection of Delinquent Trust Funds)",
      "29:1132" : "29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)",
      "29:1145" : "29:1145 (29:1145 E.R.I.S.A.)",
      "29:1149" : "29:1149 (29:1149 Recover Pension & Profit Sharing)",
      "29:1337" : "29:1337 (29:1337 E.R.I.S.A.)",
      "29:1362" : "29:1362 (29:1362 ERISA)",
      "29:1381" : "29:1381 (29:1381 E.R.I.S.A.)",
      "29:1401" : "29:1401 (29:1401(b)(2) Appeal of Arbitration Award)",
      "29:1451" : "29:1451 (29:1451 E.R.I.S.A.)",
      "29:1801" : "29:1801 (29:1801 Farmworker Rights)",
      "29:2001" : "29:2001 (29:2001 Employee Polygraph Protection Act)",
      "29:2101" : "29:2101 (29:2101 Worker Adjustment and Retraining Notification Act)",
      "29:2601" : "29:2601 (29:2601 FMLA: Family and Medical Leave Act (Findings and Purposes))",
      "29:790" : "29:790 (29:790 Rehabilitation of Labor)",
      "30:0181" : "30:0181 (30:181 Environment: Review of Agency Action)",
      "30:0801" : "30:0801 (30:0801 Penalities/Federal Mine Safety Health Act - 1977)",
      "30:1201" : "30:1201 (30:1201 Environment: Review of Agency Action)",
      "30:1202" : "30:1202 (30:1202 Mining Reclamation Act)",
      "30:1276" : "30:1276 (30:1276 Interior: Review of Agency Action)",
      "31:3545" : "31:3545 (31:3545 Action to Recovery Money)",
      "31:3729" : "31:3729 (31:3729 False Claims Act)",
      "31:3730" : "31:3730 (31:3730 Qui Tam False Claims Act)",
      "31:3731" : "31:3731 (31:3731 Fraud)",
      "33:1319cw" : "33:1319cw (33:1319 Clean Water Act)",
      "33:1319pv" : "33:1319pv (33:1319 Pollutants & Permit Violations)",
      "33:1365" : "33:1365 (33:1365 Environmental Matters)",
      "33:901" : "33:901 (33:901 Longshoremen & Harbor Worker's Comp Act)",
      "35:0145" : "35:0145 (35:145 Patent Infringement)",
      "35:0183" : "35:0183 (35:183 Patent Infringement)",
      "35:0271" : "35:0271 (35:271 Patent Infringement)",
      "38:1681" : "38:1681 (38:1681 Recovery of VA Overpayment)",
      "38:1686" : "38:1686 (38:1686 Recovery of VA Overpayment)",
      "38:1780" : "38:1780 (38:1780 Recovery of VA Overpayment)",
      "38:2011" : "38:2011 (38:2011 - Veteran's Readjustment Assistance Act of 1974)",
      "38:3116" : "38:3116 (38:3116 VA Overpayment)",
      "38:4323b3" : "38:4323b3 (Enforcement of rights with respect to a private employer)",
      "39:3005" : "39:3005 (39:3005 Detention of Mail for Temporary Periods)",
      "39:409" : "39:409 (39:409 Postal Service)",
      "40:0258" : "40:0258 (40:258(a) Public Buildings & Property: Land Condemnation)",
      "40:0270" : "40:0270 (40:270 Miller Act)",
      "40:0875" : "40:0875 (40:875 Public Buildings & Property: Negligence)",
      "40:3131" : "40:3131 (40:3131 Miller Act)",
      "41:0251" : "41:0251 (41:251 Public Contracts-Review of Agency Action)",
      "41:1463" : "41:1463 (41:1463 Public Contracts: Unlawful Employment Practices)",
      "42:0205" : "42:0205 (42:205 Denial Social Security Benefits)",
      "42:0206" : "42:0206 (42:206 Social Security Benefits)",
      "42:0247" : "42:0247 (42:247 Personal Injury-Swine Flu)",
      "42:0402" : "42:0402 (42:402 Social Security Benefits)",
      "42:0405id" : "42:0405id (42:405 Review of HHS Decision (SSID))",
      "42:0405wc" : "42:0405wc (42:405 Review of HHS Decision (DIWC))",
      "42:0405ww" : "42:0405ww (42:405 Review of HHS Decision (DIWW))",
      "42:0416" : "42:0416 (42:416 Denial of Social Security Benefits)",
      "42:0427" : "42:0427 (42:427 Social Security Benefits)",
      "42:12101" : "42:12101 (42:12101 Violation of Americans with Disabilities Act)",
      "42:1383" : "42:1383 (42:1383 Review of HHS Decision)",
      "42:1395" : "42:1395 (42:1395 HHS: Adverse Reimbursement Review)",
      "42:1396" : "42:1396 (42:1396 - Tort Negligence)",
      "42:1471" : "42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclosure Sale)",
      "42:1981cv" : "42:1981cv (42:1981 Civil Rights)",
      "42:1981hs" : "42:1981hs (42:1981 Housing Discrimination)",
      "42:1981jb" : "42:1981jb (42:1981 Job Discrimination (Race))",
      "42:1981sx" : "42:1981sx (42:1981 Sex Discrimination)",
      "42:1983cv" : "42:1983cv (42:1983 Civil Rights Act)",
      "42:1983ed" : "42:1983ed (42:1983 Civil Rights (Employment Discrimination))",
      "42:1983pr" : "42:1983pr (42:1983 Prisoner Civil Rights)",
      "42:1985" : "42:1985 (42:1985 Civil Rights Act)",
      "42:1986" : "42:1986 (42:1986 Neglect of Duty)",
      "42:2000ag" : "42:2000ag (42:2000 Job Discrimination (Age))",
      "42:2000e" : "42:2000e (42:2000e Job Discrimination (Employment))",
      "42:2000pb" : "42:2000pb (42:2000 Job Discrimination (Public Accomodations))",
      "42:2000ra" : "42:2000ra (42:2000 Job Discrimination (Race))",
      "42:2000sx" : "42:2000sx (42:2000 Job Discrimination (Sex))",
      "42:2003" : "42:2003 (42:2003 Job Discrimination)",
      "42:2005" : "42:2005 (42:2005 Review of Agency Action-HHS)",
      "42:2651" : "42:2651 (42:2651 Medical Care Recovery)",
      "42:3601" : "42:3601 (42:405 Fair Housing Act)",
      "42:4000" : "42:4000 (42:4000 National Flood Insurance Act)",
      "42:4001" : "42:4001 (42:4001 National Insurance Flood Act)",
      "42:4053" : "42:4053 (42:4053 Breach of Insurance Contract)",
      "42:4072" : "42:4072 (42:4072 Payment of Flood Insurance Claim)",
      "42:4321" : "42:4321 (42:4321 Review of Agency Action-Environment)",
      "42:4332" : "42:4332 (42:4332 Environmental Policy - Coop of Agency Reports)",
      "42:6901en" : "42:6901en (42:6901 Environmental Cleanup Expenses)",
      "42:6901rs" : "42:6901rs (42:6901 Resource & Recovery Act)",
      "42:7413" : "42:7413 (42:7413(b) Clean Air Act)",
      "42:7604cl" : "42:7604cl (42:7604 Clear Air Act (Emission Standards))",
      "42:7604ir" : "42:7604ir (42:7604 Petition to Quash IRS Summons)",
      "42:9607" : "42:9607 (42:9607 Real Property Tort to Land)",
      "43:945" : "43:945 (43:945 Compensation for Land Condemnation)",
      "43:945a" : "43:945a (43:945a Complaint in Condemnation)",
      "43:946" : "43:946 (43:946 Complaint in Condemnation - Eminent Domain)",
      "45:0051" : "45:0051 (45:51 Railways: Fed. Employer's Liability Act)",
      "45:0151" : "45:0151 (45:151 Railway Labor Act)",
      "45:0184" : "45:0184 (45:184 Action to Set Aside Award of a System Board of Adjust)",
      "45:1395" : "45:1395 (45:1395 Railroads: Adverse Reimbursement Review)",
      "45:7457" : "45:7457 (45:7457 Compel Reclamation Under Clear Air Act)",
      "46:0688" : "46:0688 (46:688 Jones Act)",
      "46:0741" : "46:0741 (46:741 Shipping)",
      "46:0761" : "46:0761 (46:761 Shipping: Damages for Death on High Seas)",
      "46:1101" : "46:1101 (46:1101 Violation of Maritime Regulations)",
      "46:1156" : "46:1156 (46:1156 Administrative Procedure Act)",
      "46:190" : "46:190 (46:190 INDEMNITY UNDER THE GENERAL MARITIME LAW)",
      "48:0883" : "48:0883 (48:883 Violation of US Coastal Law)",
      "48:1424" : "48:1424 (48:1424 The Organic Act of Guam)",
      "48:1983" : "48:1983 (48:1983 Civil Rights)",
      "48:1985" : "48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)",
      "49:0081" : "49:0081 (49:81 Damaged Goods While Being Transported)",
      "49:0781" : "49:0781 (49:781 Forfeiture)",
      "49:11503" : "49:11503 (49:11503 Railroad Revitalization Regulatory Reform Act)",
      "49:11702" : "49:11702 (49:11702(a)(4) Violations of Interstate Commerce Act)",
      "49:1471" : "49:1471 (49:1471 Federal Aviation Act)",
      "49:1903" : "49:1903 (49:1903 Petition to enforce administrative summons)",
      "8:287" : "8:287 (8:287 Petition to Enforce INS Subpoena)",
      "MiscCause" : "MiscCause (Civil Miscellaneous Case)",
      "Rule9H" : "Rule9H (Breach of Contract - Maritime Rule 9(h))",
      "misc" : "misc (Civil Miscellaneous Case)"
   },
   "hidce" : {
      "*41*" : "*41* ()",
      "0" : "0 (No cause code entered)",
      "00:0000" : "00:0000 (00:0000 Cause Code Unknown)",
      "02:0431" : "02:0431 (02:431 Fed. Election Commission: Failure Enforce Compliance)",
      "02:0437" : "02:0437 (02:437 Federal Election Commission)",
      "05:0075" : "05:0075 (05:75(2) Contract - Reduction in Grade)",
      "05:0551" : "05:0551 (05:551 Administrative Procedure Act)",
      "05:0552fi" : "05:0552fi (05:552 Freedom of Information Act)",
      "05:0552pa" : "05:0552pa (05:552 Right to Privacy Act)",
      "05:0554" : "05:0554 (05:0554 Constitutionality of Maritime Statutes)",
      "05:0701" : "05:0701 (05:0701 Maritime Subsidy Board)",
      "05:0702" : "05:0702 (05:702 Administrative Procedure Act)",
      "05:0704" : "05:0704 (05:704 Labor Litigation)",
      "05:7703" : "05:7703 (05:7703 Discrimination - Review of Agency Act)",
      "07:0006" : "07:0006 (7:6(b) Federal Commodity Exchange Regulation)",
      "07:0025" : "07:0025 (7:25 Fraud - Commodities Leverage Contracts)",
      "07:0181" : "07:0181 (07:181 Packers & Stockyard Act)",
      "07:0499" : "07:0499 (07:499 Agricultural Commodities Act)",
      "07:0601" : "07:0601 (07:601 USDA Condemnation)",
      "07:2321" : "07:2321 (07:2321 Plant Variety Protection Act)",
      "08:1105" : "08:1105 (8:1105(a) Aliens: Habeas Corpus to Release INS Detainee)",
      "08:1153b5" : "08:1153b5 (08:1153b5 Immigrant Investor Law)",
      "08:1252" : "08:1252 (08:1252(a)(2) Injunction for Deportation)",
      "08:1260" : "08:1260 (08:1260 Aliens: Access to Records)",
      "08:1324" : "08:1324 (08:1324 Aliens: Complaint for Forfeiture)",
      "08:1329" : "08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petition)",
      "08:1446" : "08:1446 (8:1446 Petition for Naturalization Hearing)",
      "08:1451a" : "08:1451a (Revocation of Naturalization - Title 8 USC 1451(a))",
      "09:0001" : "09:0001 (09:1 U.S. Arbitration Act)",
      "09:0009" : "09:0009 (9:9 Motion to Confirm Arbitration Loan)",
      "09:0010" : "09:0010 (09:0010 Petition to Vacate Arbitration Award)",
      "10:1552" : "10:1552 (10:1552 Armed Forces: Action to Correct Records)",
      "10:1553" : "10:1553 (10:1553 Armed Forces: FOIA General)",
      "10:2305" : "10:2305 (10:2305 Review of Federal Contract)",
      "11:0101" : "11:0101 (11:101 Bankruptcy)",
      "12:0022" : "12:0022 (12:22 Securities Fraud)",
      "12:0635" : "12:0635 (12:635 Breach of Insurance Contract)",
      "12:1461" : "12:1461 (12:1461 Homeowners Loan Act)",
      "12:1703" : "12:1703 (12:1703 Default of HUD Loan)",
      "12:1725" : "12:1725 (12:1725 Collection under Contract Guaranty)",
      "12:1730" : "12:1730 (12:1730 Collection Under Contract Guaranty)",
      "12:1819" : "12:1819 (12:1819 Default of Promissory Note)",
      "12:1821" : "12:1821 (12:1821 Default of Loan by Promissary Note)",
      "12:1971" : "12:1971 (12:1971 Relief under Bank Holding Act)",
      "12:3410" : "12:3410 (12:3410 Right to Financial Privacy Act)",
      "15:0001" : "15:0001 (15:1 Antitrust Litigation)",
      "15:0002at" : "15:0002at (15:2 Antitrust Litigation)",
      "15:0002fl" : "15:0002fl (15:2(a) Fair Labor Standards Act)",
      "15:0005" : "15:0005 (15:5(a) Fair Labor Standards Act)",
      "15:0015" : "15:0015 (15:15 Antitrust Litigation)",
      "15:0025" : "15:0025 (15:25 Clayton Act)",
      "15:0044" : "15:0044 (15:44 Trademark Infringement)",
      "15:0045" : "15:0045 (15:0045 Federal Trade Commission Act)",
      "15:0052" : "15:0052 (15:0052 Federal Trade Commission Act)",
      "15:0053" : "15:0053 (15:0053 Federal Trade Commission Act)",
      "15:0077" : "15:0077 (15:77 Securities Fraud)",
      "15:0078" : "15:0078 (15:78m(a) Securities Exchange Act)",
      "15:0631" : "15:0631 (15:631 Small Business Act)",
      "15:0717" : "15:0717 (15:717 Natural Gas Act)",
      "15:1051" : "15:1051 (15:1051 Trademark Infringement)",
      "15:1114" : "15:1114 (15:1114 Trademark Infringement)",
      "15:1121" : "15:1121 (15:1121 Trademark Infringement)",
      "15:1125" : "15:1125 (15:1125 Trademark Infringement (Lanham Act))",
      "15:1126" : "15:1126 (15:1126 Patent Infringement)",
      "15:1127" : "15:1127 (15:1127 Trademark Infringement)",
      "15:1601" : "15:1601 (15:1601 Truth in Lending)",
      "15:1640" : "15:1640 (15:1640 Truth in Lending)",
      "15:1681" : "15:1681 (15:1681 Fair Credit Reporting Act)",
      "15:1692" : "15:1692 (15:1692 Fair Debt Collection Act)",
      "15:1938" : "15:1938 (15:1938 Fair Labor Standards Act)",
      "15:1981" : "15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))",
      "15:1988" : "15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))",
      "15:1989" : "15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))",
      "15:2301" : "15:2301 (15:2301 Magnuson-Moss Warranty Act)",
      "15:2801" : "15:2801 (15:2801 Petroleum Marketing Practices Act)",
      "15:53(b)" : "15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equitable Relief)",
      "16:0668" : "16:0668 (16:668 Bald Eagle Protection Act)",
      "16:0703" : "16:0703 (16:703 Migratory Bird Act)",
      "16:1538" : "16:1538 (16:1538 Endangered Species Act)",
      "16:1801" : "16:1801 (Magnuson-Stevens Fishery Conservation and Management Act)",
      "16:3371" : "16:3371 (16:3371 Wildlife Under the Lacey Act)",
      "16:3372" : "16:3372 (16:3372 Conservation: Complaint for Forfeiture)",
      "16:3373" : "16:3373 (16:3373 Appeal of Decision - DOI)",
      "16:3374" : "16:3374 (16:3374 Conservation: Complaint for Forfeiture)",
      "17:0101" : "17:0101 (17:101 Copyright Infringement)",
      "17:0501" : "17:0501 (17:501 Copyright Infringement)",
      "17:0504" : "17:0504 (17:504 Copyright Infringement)",
      "18:01956" : "18:01956 (Civil Money Laundering Penalty)",
      "18:0241" : "18:0241 (18:241 Conspiracy Against Citizen Rights)",
      "18:0924" : "18:0924 (18:0924(d) Forfeiture - Firearms)",
      "18:1836a" : "18:1836a (18:1836(a) Injunction against Misappropriation of Trade Secrets)",
      "18:1836b" : "18:1836b (18:1836(b) Civil Action to Protect Trade Secrets)",
      "18:1955" : "18:1955 (18:1955 Forfeiture - Illegal Gambling)",
      "18:1961" : "18:1961 (18:1961 Racketeering (RICO) Act)",
      "18:1962" : "18:1962 (18:1962 Racketeering (RICO) Act)",
      "18:1964" : "18:1964 (18:1964 Racketeering (RICO) Act)",
      "18:4208" : "18:4208 (18:4208(B) Agency Action Review)",
      "19:1305" : "19:1305 (19:1305 Custom Duties:0Forfeiture-Immoral Articles)",
      "20:1080" : "20:1080 (20:1080 Student Loan Recovery)",
      "20:1400" : "20:1400 (20:1400 Civil Rights of Handicapped Child)",
      "20:1401" : "20:1401 (20:1401 Education: Handicapped Child Act)",
      "21:0841" : "21:0841 (21:841 Forfeiture Property-Drugs)",
      "21:0881" : "21:0881 (21:881 Forfeiture Property-Drugs)",
      "21:0881a" : "21:0881a (21:881 Forfeiture Property - Aircraft)",
      "21:0881re" : "21:0881re (21:881 Forfeiture Property - Real Estate)",
      "23:0134" : "23:0134 (23:134 P.I.- Auto Negligence)",
      "23:1441" : "23:1441 (23:1441 Contract Real Estate)",
      "24:1000" : "24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)",
      "25:0640" : "25:0640 (25:640 Indian Tribal Rights)",
      "25:1901" : "25:1901 (25:1901 Indian Child Welfare Act)",
      "26:6212" : "26:6212 (26:6212 Injunctive Relief from IRS Lien)",
      "26:6213" : "26:6213 (26:6213 Injunctive Relief from IRS Lien)",
      "26:6502" : "26:6502 (26:6502 IRS:Enforcement of tax liens)",
      "26:6532" : "26:6532 (26:6532 IRS: Refund of Tax Penalty)",
      "26:6702" : "26:6702 (26:6702 IRS: Refund of Income Tax Penalty)",
      "26:6703" : "26:6703 (26:6703 IRS: Refund of Tax Penalty)",
      "26:7401" : "26:7401 (26:7401 IRS: Tax Liability)",
      "26:7402" : "26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)",
      "26:7403" : "26:7403 (26:7403 Suit to Enforce Federal Tax Lien)",
      "26:7422rt" : "26:7422rt (26:7422 IRS: Refund Taxes)",
      "26:7422rx" : "26:7422rx (26:7422 IRS: Refund Excise Tax)",
      "26:7426" : "26:7426 (26:7426 IRS: Wrongful Levy for Taxes)",
      "26:7429" : "26:7429 (26:7429 IRS: Tax Jeopardy Assessment)",
      "26:7609" : "26:7609 (26:7609 IRS: Petition to Quash IRS Summons)",
      "27:0185" : "27:0185 (27:185 Enforcement of Arbitration Award)",
      "28:0157c" : "28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)",
      "28:0157d" : "28:0157d (28:0157 Motion for Withdrawal of Reference)",
      "28:0158" : "28:0158 (28:0158 Notice of Appeal re Bankruptcy Matter (BAP))",
      "28:0185" : "28:0185 (28:185 Suit to Compel Arbitration)",
      "28:0451" : "28:0451 (28:451 Employment Discrimination)",
      "28:0794" : "28:0794 (28:794 Rehabilitation Act)",
      "28:1001" : "28:1001 (28:1001 E.R.I.S.A.)",
      "28:1132" : "28:1132 (28:1132 E.R.I.S.A.)",
      "28:1330" : "28:1330 (28:1330 Breach of Contract)",
      "28:1331" : "28:1331 (28:1331 Fed. Question)",
      "28:1331al" : "28:1331al (28:1331 Fed. Question: Airline Crash)",
      "28:1331at" : "28:1331at (28:1331 Fed. Question: Anti-trust)",
      "28:1331au" : "28:1331au (28:1331 Fed. Question: Auto Negligence)",
      "28:1331b" : "28:1331b (28:1331 Federal Question: Bivens Act)",
      "28:1331bc" : "28:1331bc (28:1331 Fed. Question: Breach of Contract)",
      "28:1331ca" : "28:1331ca (28:1331 Fed Question: Fed Communications Act of 1934)",
      "28:1331cm" : "28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)",
      "28:1331cv" : "28:1331cv (28:1331 Federal Question: Other Civil Rights)",
      "28:1331ed" : "28:1331ed (28:1331 Fed. Question: Employment Discrimination)",
      "28:1331es" : "28:1331es (28:1331 Enforcement of Administrative Subpoena)",
      "28:1331fl" : "28:1331fl (28:1331 Fed. Question: Fair Labor Standards)",
      "28:1331in" : "28:1331in (28:1331 Fed. Question: Insurance Contract)",
      "28:1331mm" : "28:1331mm (28:1331 Fed. Question: Medical Malpractice)",
      "28:1331pi" : "28:1331pi (28:1331 Fed. Question: Personal Injury)",
      "28:1331rd" : "28:1331rd (28:1331 Fed. Question: Review Agency Decision)",
      "28:1331rp" : "28:1331rp (28:1331(a) Fed. Question: Real Property)",
      "28:1331rr" : "28:1331rr (28:1331 Fed. Question: Railway Labor Act)",
      "28:1331sv" : "28:1331sv (28:1331 Fed. Question: Securities Violation)",
      "28:1331tr" : "28:1331tr (28:1331 Fed. Question: Trademark)",
      "28:1331tt" : "28:1331tt (28:1331 Fed. Question: Tort Action)",
      "28:1331v" : "28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendment)",
      "28:1331wl" : "28:1331wl (28:1331 Federal Question: EPA Waste Lien)",
      "28:1331wt" : "28:1331wt (28:1331 Fed. Question: Water Rights)",
      "28:1332ac" : "28:1332ac (28:1332 Diversity-Account Receivable)",
      "28:1332al" : "28:1332al (28:1332 Diversity-Airline Crash)",
      "28:1332as" : "28:1332as (28:1332 Diversity-Asbestos Litigation)",
      "28:1332au" : "28:1332au (28:1332 Diversity-Auto Negligence)",
      "28:1332bc" : "28:1332bc (28:1332 Diversity-Breach of Contract)",
      "28:1332co" : "28:1332co (28:1332 Diversity-Conversion)",
      "28:1332ct" : "28:1332ct (28:1332 Diversity-(Citizenship))",
      "28:1332det" : "28:1332det (28:1332 Diversity: Forcible Detainer)",
      "28:1332df" : "28:1332df (28:1332 Diversity-Contract Default)",
      "28:1332ds" : "28:1332ds (28:1332 Diversity-Contract Dispute)",
      "28:1332ed" : "28:1332ed (28:1332 Diversity-Employment Discrimination)",
      "28:1332fd" : "28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)",
      "28:1332fr" : "28:1332fr (28:1332 Diversity-Fraud)",
      "28:1332ia" : "28:1332ia (28:1332 Diversity-Interpleader Action)",
      "28:1332ij" : "28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)",
      "28:1332in" : "28:1332in (28:1332 Diversity-Insurance Contract)",
      "28:1332jd" : "28:1332jd (28:1332 Diversity-Declaratory Judgement)",
      "28:1332lb" : "28:1332lb (28:1332 Diversity-Libel,Assault,Slander)",
      "28:1332lm" : "28:1332lm (28:1332 Diversity - Legal Malpractice)",
      "28:1332ma" : "28:1332ma (28:1332 Diversity-Miller Act)",
      "28:1332mm" : "28:1332mm (28:1332 Diversity-Medical Malpractice)",
      "28:1332mv" : "28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)",
      "28:1332ni" : "28:1332ni (28:1332 Diversity-Negotiable Instrument)",
      "28:1332nm" : "28:1332nm (28:1332 Diversity-Non-Motor Vehicle)",
      "28:1332oc" : "28:1332oc (28:1332 Diversity-Other Contract)",
      "28:1332pd" : "28:1332pd (28:1332 Diversity-Property Damage)",
      "28:1332pi" : "28:1332pi (28:1332 Diversity-Personal Injury)",
      "28:1332pl" : "28:1332pl (28:1332 Diversity-Product Liability)",
      "28:1332pr" : "28:1332pr (28:1332 Diversity-Petition for Removal)",
      "28:1332qt" : "28:1332qt (28:1332 Diversity-Petition to Quiet Title)",
      "28:1332ri" : "28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)",
      "28:1332sa" : "28:1332sa (28:1332 - Diversity: Securities & Exchange Commission Act)",
      "28:1332sf" : "28:1332sf (28:1332 - Diversity: Securities Fraud)",
      "28:1332ss" : "28:1332ss (28:1332 Diversity - Stockholders Suits)",
      "28:1332tl" : "28:1332tl (28:1332 Diversity-Torts to Land)",
      "28:1332tm" : "28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))",
      "28:1332tn" : "28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)",
      "28:1332wd" : "28:1332wd (28:1332 Diversity-Wrongful Death)",
      "28:1333" : "28:1333 (28:1333 Admiralty)",
      "28:1334" : "28:1334 (28:1334 Bankruptcy Appeal)",
      "28:1334c" : "28:1334c (28:1334(c) R&R re motions for abstention (non-core))",
      "28:1335" : "28:1335 (28:1335 Interpleader Action)",
      "28:1337" : "28:1337 (28:1337 Sherman-Clayton Act)",
      "28:1338cp" : "28:1338cp (28:1338 Copyright Infringement)",
      "28:1338pt" : "28:1338pt (28:1338 Patent Infringement)",
      "28:1338tr" : "28:1338tr (28:1338 Trademark Infringement)",
      "28:1340" : "28:1340 (28:1340 IRS: Custom Duties)",
      "28:1340er" : "28:1340er (28:1340 Recovery of Erroneous Refund)",
      "28:1341" : "28:1341 (28:1341 Complaint for Forfeiture)",
      "28:1343" : "28:1343 (28:1343 Violation of Civil Rights)",
      "28:1345co" : "28:1345co (28:1345 Replevin & Conversion)",
      "28:1345db" : "28:1345db (28:1345 Debt to US - FHA/HUD Title I)",
      "28:1345df" : "28:1345df (28:1345 Default of Promissory Note)",
      "28:1345er" : "28:1345er (28:1345 Recovery of Erroneous Refund)",
      "28:1345fc" : "28:1345fc (28:1345 Foreclosure)",
      "28:1345ff" : "28:1345ff (28:1345 Complaint for Forfeiture)",
      "28:1345hl" : "28:1345hl (28:1345 VA Home Loan Guaranty Debt)",
      "28:1345mc" : "28:1345mc (28:1345 Medical Care Recovery)",
      "28:1345mi" : "28:1345mi (28:1345 Mining Claim Ejectment)",
      "28:1345pd" : "28:1345pd (28:1345 Property Damage)",
      "28:1345pe" : "28:1345pe (28:1345 Property Ejectment)",
      "28:1345rc" : "28:1345rc (28:1345 Recovery of Debt to US)",
      "28:1345st" : "28:1345st (28:1345 Default of Student Loan)",
      "28:1345tp" : "28:1345tp (28:1345 Trespass on Public Land)",
      "28:1345va" : "28:1345va (28:1345 Recovery of VA Overpayment)",
      "28:1346bc" : "28:1346bc (28:1346 Breach of Contract)",
      "28:1346rc" : "28:1346rc (28:1346 Recovery of IRS Tax)",
      "28:1346tc" : "28:1346tc (28:1346 Tort Claim)",
      "28:1346wd" : "28:1346wd (28:1346 Wrongful Death)",
      "28:1352" : "28:1352 (28:1352 Miller Act)",
      "28:1355" : "28:1355 (28:1355 Petition for Return of Property)",
      "28:1358" : "28:1358 (28:1358 Land Condemnation)",
      "28:1361" : "28:1361 (28:1361 Petition for Writ of Mandamus)",
      "28:1362ic" : "28:1362ic (28:1362 Indian Tribal Controversy)",
      "28:1362iw" : "28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)",
      "28:1364" : "28:1364 (28:1364 Auto Negligence)",
      "28:1391" : "28:1391 (28:1391 Personal Injury)",
      "28:1402" : "28:1402 (28:1402 Medical Malpractice)",
      "28:1407" : "28:1407 (28:1407 Airline Crash)",
      "28:1441ac" : "28:1441ac (28:1441 Petition for Removal- Account Receivable)",
      "28:1441al" : "28:1441al (28:1441 Petition for Removal- Airline Crash)",
      "28:1441as" : "28:1441as (28:1441 Petition for Removal- Asbestos Litigation)",
      "28:1441au" : "28:1441au (28:1441 Petition for Removal- Auto Negligence)",
      "28:1441bc" : "28:1441bc (28:1441 Petition for Removal- Breach of Contract)",
      "28:1441cv" : "28:1441cv (28:1441 Petition for Removal- Civil Rights Act)",
      "28:1441df" : "28:1441df (28:1441 Petition for Removal- Contract Default)",
      "28:1441dj" : "28:1441dj (28:1441 Petition for Removal- Declaratory Judgement)",
      "28:1441ds" : "28:1441ds (28:1441 Petition for Removal- Contract Dispute)",
      "28:1441ed" : "28:1441ed (28:1441 Petition for Removal - Employment Discrimination)",
      "28:1441fc" : "28:1441fc (28:1441 Petition for Removal - Fair Credit Reporting Act)",
      "28:1441fr" : "28:1441fr (28:1441 Petition for Removal- Fraud)",
      "28:1441ij" : "28:1441ij (28:1441 Petition for Removal- Injunctive/Declaratory Relief)",
      "28:1441in" : "28:1441in (28:1441 Petition for Removal- Insurance Contract)",
      "28:1441int" : "28:1441int (28:1441 Petition for Removal- Action for Interpleader)",
      "28:1441lb" : "28:1441lb (28:1441 Petition for Removal Libel,Assault,Slander)",
      "28:1441lm" : "28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relations)",
      "28:1441mm" : "28:1441mm (28:1441 Petition for Removal- Medical Malpractice)",
      "28:1441ni" : "28:1441ni (28:1441 Petition for Removal- Negotiable Instrument)",
      "28:1441nm" : "28:1441nm (28:1441 Petition for Removal- Non-Motor Vehicle)",
      "28:1441oc" : "28:1441oc (28:1441 Petition For Removal--Other Contract)",
      "28:1441pd" : "28:1441pd (28:1441 Petition for Removal- Property Damage)",
      "28:1441pi" : "28:1441pi (28:1441 Petition for Removal- Personal Injury)",
      "28:1441pl" : "28:1441pl (28:1441 Petition for Removal- Product Liability)",
      "28:1441pr" : "28:1441pr (28:1441 Petition for Removal)",
      "28:1441qt" : "28:1441qt (28:1441 Petition for Removal- Petition to Quiet Title)",
      "28:1441ri" : "28:1441ri (28:1441 Petition for Removal- Racketeering (RICO) Act)",
      "28:1441sa" : "28:1441sa (28:1441 - Petition for Removal: SEC Act)",
      "28:1441sf" : "28:1441sf (28:1441 - Petition for Removal: Securities Fraud)",
      "28:1441tl" : "28:1441tl (28:1441 Petition for Removal- Torts to Land)",
      "28:1441tm" : "28:1441tm (28:1441 Petition for Removal- Tort/Motor Vehicle (P.I.))",
      "28:1441tn" : "28:1441tn (28:1441 Petition for Removal- Tort/Non-Motor Vehicle)",
      "28:1441wd" : "28:1441wd (28:1441 Petition for Removal- Wrongful Death)",
      "28:1442bc" : "28:1442bc (28:1442 Petition for Removal- Breach of Contract)",
      "28:1442pr" : "28:1442pr (28:1442 Petition for Removal)",
      "28:1443" : "28:1443 (28:1443(1) Rent, Lease & Ejectment)",
      "28:1444" : "28:1444 (28:1444 Petition for Removal- Foreclosure)",
      "28:1446in" : "28:1446in (28:1446 Breach of Contract- Insurance)",
      "28:1446pd" : "28:1446pd (28:1446 Petition for Removal- Property Damage (P.I.))",
      "28:1446pi" : "28:1446pi (28:1446 Petition for Removal- Personal Injury)",
      "28:1446pl" : "28:1446pl (28:1446pl Petition for Removal - Product Liability)",
      "28:1446pr" : "28:1446pr (28:1446 Petition for Removal)",
      "28:1452" : "28:1452 (28:1452 R&R re motions to remand (non-core))",
      "28:1651" : "28:1651 (28:1651 Petition for Writ of Coram Nobis)",
      "28:1651hc" : "28:1651hc (28:1651 Petition for Writ of Habeas Corpus)",
      "28:1651mn" : "28:1651mn (28:1651 Petition for Writ of Mandamus)",
      "28:1983" : "28:1983 (28:1983 Civil Rights)",
      "28:2201" : "28:2201 (28:2201 Constitutionality of State Statute(s))",
      "28:2201dj" : "28:2201dj (28:2201 Declaratory Judgement)",
      "28:2201ij" : "28:2201ij (28:2201 Injunction)",
      "28:2201in" : "28:2201in (28:2201 Declaratory Judgement (Insurance))",
      "28:2241" : "28:2241 (28:2241 Petition for Writ of Habeas Corpus (federal))",
      "28:2254" : "28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))",
      "28:2254se" : "28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)",
      "28:2255" : "28:2255 (28:2255 Motion to Vacate / Correct Illegal Sentence)",
      "28:2271" : "28:2271 (28:2271 Federal Tort Claims Act)",
      "28:2345" : "28:2345 (28:2345 Medicare Recovery)",
      "28:2409" : "28:2409 (28:2409(a) Quiet Title Action)",
      "28:2410" : "28:2410 (28:2410 Quiet Title)",
      "28:2671" : "28:2671 (28:2671 Federal Tort Claims Act)",
      "28:2674" : "28:2674 (28:2674 Federal Tort Claims Act)",
      "28:7402" : "28:7402 (28:7402 Refund of Taxes)",
      "28:7422" : "28:7422 (28:7422 Appeal from Administrative Decision)",
      "29:0151" : "29:0151 (29:151 Labor: Review of Agency Action)",
      "29:0160" : "29:0160 (29:160(1) National Labor Relations Act)",
      "29:0184" : "29:0184 (29:184 Violation Collection Bargain Agreement)",
      "29:0185ep" : "29:0185ep (29:185 Employee Pension Plan)",
      "29:0185lm" : "29:0185lm (29:185 Labor/Mgt. Relations (Contracts))",
      "29:0201do" : "29:0201do (29:201 Denial of Overtime Compensation)",
      "29:0201fl" : "29:0201fl (29:201 Fair Labor Standards Act)",
      "29:0203" : "29:0203 (29:203 Equal Pay Act)",
      "29:0206" : "29:0206 (29:206 Collect Unpaid Wages)",
      "29:0401" : "29:0401 (29:0401 Labor Management Disclosure Act)",
      "29:0621" : "29:0621 (29:621 Job Discrimination (Age))",
      "29:0623" : "29:0623 (29:623 Job Discrimination (Age))",
      "29:0626" : "29:0626 (29:626 Job Discrimination (Age))",
      "29:0633" : "29:0633 (29:633 Job Discrimination (Age))",
      "29:0651" : "29:0651 (29:651 Occupational Safety/Health)",
      "29:0754" : "29:0754 (29:754 Discrimination)",
      "29:0791" : "29:0791 (29:791 Job Discrimination (Rehabilitation Act))",
      "29:0794" : "29:0794 (29:0794 Job Discrimination (Handicap))",
      "29:1001" : "29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)",
      "29:1002" : "29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)",
      "29:1104" : "29:1104 (29:1104 Recovery of Benefits to Employee)",
      "29:1109" : "29:1109 (29:1109 Breach of Fiduciary Duties)",
      "29:1131" : "29:1131 (29:1131 ERISA - Collection of Delinquent Trust Funds)",
      "29:1132" : "29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)",
      "29:1145" : "29:1145 (29:1145 E.R.I.S.A.)",
      "29:1149" : "29:1149 (29:1149 Recover Pension & Profit Sharing)",
      "29:1337" : "29:1337 (29:1337 E.R.I.S.A.)",
      "29:1362" : "29:1362 (29:1362 ERISA)",
      "29:1381" : "29:1381 (29:1381 E.R.I.S.A.)",
      "29:1401" : "29:1401 (29:1401(b)(2) Appeal of Arbitration Award)",
      "29:1451" : "29:1451 (29:1451 E.R.I.S.A.)",
      "29:1801" : "29:1801 (29:1801 Farmworker Rights)",
      "29:2601" : "29:2601 (29:2601 Family and Medical Leave Act of 1993)",
      "29:481" : "29:481 (Labor-Mgmt Reporting and Disclosure Act)",
      "29:790" : "29:790 (29:790 Rehabilitation of Labor)",
      "30:0181" : "30:0181 (30:181 Environment: Review of Agency Action)",
      "30:0801" : "30:0801 (30:0801 Penalities/Federal Mine Safety Health Act - 1977)",
      "30:1201" : "30:1201 (30:1201 Environment: Review of Agency Action)",
      "30:1202" : "30:1202 (30:1202 Mining Reclamation Act)",
      "30:1276" : "30:1276 (30:1276 Interior: Review of Agency Action)",
      "31:3545" : "31:3545 (31:3545 Action to Recovery Money)",
      "31:3729" : "31:3729 (31:3729 False Claims Act)",
      "31:3730" : "31:3730 (31:3730 Qui Tam False Claims Act)",
      "31:3731" : "31:3731 (31:3731 Fraud)",
      "33:1319cw" : "33:1319cw (33:1319 Clean Water Act)",
      "33:1319pv" : "33:1319pv (33:1319 Pollutants & Permit Violations)",
      "33:1365" : "33:1365 (33:1365 Environmental Matters)",
      "33:9091" : "33:9091 (Longshoremen's and Harbor Workers' Compensation Act)",
      "35:0145" : "35:0145 (35:145 Patent Infringement)",
      "35:0183" : "35:0183 (35:183 Patent Infringement)",
      "35:0271" : "35:0271 (35:271 Patent Infringement)",
      "38:1681" : "38:1681 (38:1681 Recovery of VA Overpayment)",
      "38:1686" : "38:1686 (38:1686 Recovery of VA Overpayment)",
      "38:1780" : "38:1780 (38:1780 Recovery of VA Overpayment)",
      "38:2011" : "38:2011 (38:2011 - Veteran's Readjustment Assistance Act of 1974)",
      "38:3116" : "38:3116 (38:3116 VA Overpayment)",
      "39:3005" : "39:3005 (39:3005 Detention of Mail for Temporary Periods)",
      "39:409" : "39:409 (39:409 Postal Service)",
      "40:0258" : "40:0258 (40:258(a) Public Buildings & Property: Land Condemnation)",
      "40:0270" : "40:0270 (40:270 Miller Act)",
      "40:0875" : "40:0875 (40:875 Public Buildings & Property: Negligence)",
      "41:0251" : "41:0251 (41:251 Public Contracts-Review of Agency Action)",
      "41:1463" : "41:1463 (41:1463 Public Contracts: Unlawful Employment Practices)",
      "42:0205" : "42:0205 (42:205 Denial Social Security Benefits)",
      "42:0206" : "42:0206 (42:206 Social Security Benefits)",
      "42:0247" : "42:0247 (42:247 Personal Injury-Swine Flu)",
      "42:0402" : "42:0402 (42:402 Social Security Benefits)",
      "42:0405id" : "42:0405id (42:405 Review of HHS Decision (SSID))",
      "42:0405wc" : "42:0405wc (42:405 Review of HHS Decision (DIWC))",
      "42:0405ww" : "42:0405ww (42:405 Review of HHS Decision (DIWW))",
      "42:0416" : "42:0416 (42:416 Denial of Social Security Benefits)",
      "42:0427" : "42:0427 (42:427 Social Security Benefits)",
      "42:12101" : "42:12101 (42:12101 Violation of Americans with Disabilities Act)",
      "42:1383" : "42:1383 (42:1383 Review of HHS Decision)",
      "42:1395" : "42:1395 (42:1395 HHS: Adverse Reimbursement Review)",
      "42:1396" : "42:1396 (42:1396 - Tort Negligence)",
      "42:1471" : "42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclosure Sale)",
      "42:1981cv" : "42:1981cv (42:1981 Civil Rights)",
      "42:1981hs" : "42:1981hs (42:1981 Housing Discrimination)",
      "42:1981jb" : "42:1981jb (42:1981 Job Discrimination (Race))",
      "42:1981sx" : "42:1981sx (42:1981 Sex Discrimination)",
      "42:1983cv" : "42:1983cv (42:1983 Civil Rights Act)",
      "42:1983ed" : "42:1983ed (42:1983 Civil Rights (Employment Discrimination))",
      "42:1983pr" : "42:1983pr (42:1983 Prisoner Civil Rights)",
      "42:1986" : "42:1986 (42:1986 Neglect of Duty)",
      "42:2000ag" : "42:2000ag (42:2000 Job Discrimination (Age))",
      "42:2000e" : "42:2000e (42:2000e Job Discrimination (Employment))",
      "42:2000pb" : "42:2000pb (42:2000 Job Discrimination (Public Accomodations))",
      "42:2000ra" : "42:2000ra (42:2000 Job Discrimination (Race))",
      "42:2000sx" : "42:2000sx (42:2000 Job Discrimination (Sex))",
      "42:2003" : "42:2003 (42:2003 Job Discrimination)",
      "42:2005" : "42:2005 (42:2005 Review of Agency Action-HHS)",
      "42:2651" : "42:2651 (42:2651 Medical Care Recovery)",
      "42:3601" : "42:3601 (42:3601 Fair Housing Act)",
      "42:4000" : "42:4000 (42:4000 National Flood Insurance Act)",
      "42:4001" : "42:4001 (42:4001 National Insurance Flood Act)",
      "42:4053" : "42:4053 (42:4053 Breach of Insurance Contract)",
      "42:4072" : "42:4072 (42:4072 Payment of Flood Insurance Claim)",
      "42:4321" : "42:4321 (42:4321 Review of Agency Action-Environment)",
      "42:4332" : "42:4332 (42:4332 Environmental Policy - Coop of Agency Reports)",
      "42:6901en" : "42:6901en (42:6901 Environmental Cleanup Expenses)",
      "42:6901rs" : "42:6901rs (42:6901 Resource & Recovery Act)",
      "42:7413" : "42:7413 (42:7413(b) Clean Air Act)",
      "42:7604cl" : "42:7604cl (42:7604 Clear Air Act (Emission Standards))",
      "42:7604ir" : "42:7604ir (42:7604 Petition to Quash IRS Summons)",
      "42:9607" : "42:9607 (42:9607 Real Property Tort to Land)",
      "43:945" : "43:945 (43:945 Compensation for Land Condemnation)",
      "43:945a" : "43:945a (43:945a Complaint in Condemnation)",
      "43:946" : "43:946 (43:946 Complaint in Condemnation - Eminent Domain)",
      "45:0051" : "45:0051 (45:51 Railways: Fed. Employer's Liability Act)",
      "45:0151" : "45:0151 (45:151 Railway Labor Act)",
      "45:0184" : "45:0184 (45:184 Action to Set Aside Award of a System Board of Adjust)",
      "45:1395" : "45:1395 (45:1395 Railroads: Adverse Reimbursement Review)",
      "45:7457" : "45:7457 (45:7457 Compel Reclamation Under Clear Air Act)",
      "46:0688" : "46:0688 (46:688 Jones Act)",
      "46:0741" : "46:0741 (46:741 Shipping)",
      "46:0761" : "46:0761 (46:761 Shipping: Damages for Death on High Seas)",
      "46:1101" : "46:1101 (46:1101 Violation of Maritime Regulations)",
      "46:1156" : "46:1156 (46:1156 Administrative Procedure Act)",
      "47:521" : "47:521 (CABLE TV CONSUMER PROTECTION ACT)",
      "48:0883" : "48:0883 (48:883 Violation of US Coastal Law)",
      "48:1985" : "48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)",
      "49:0081" : "49:0081 (49:81 Damaged Goods While Being Transported)",
      "49:0781" : "49:0781 (49:781 Forfeiture)",
      "49:11503" : "49:11503 (49:11503 Railroad Revitalization Regulatory Reform Act)",
      "49:11702" : "49:11702 (49:11702(a)(4) Violations of Interstate Commerce Act)",
      "49:1471" : "49:1471 (49:1471 Federal Aviation Act)",
      "49:1903" : "49:1903 (49:1903 Petition to enforce administrative summons)",
      "49:41705" : "49:41705 (Discrimination Against Handicapped Individuals)",
      "8:287" : "8:287 (8:287 Petition to Enforce INS Subpoena)",
      "Rule9H" : "Rule9H (Breach of Contract - Maritime Rule 9(h))",
      "misc" : "misc (Civil Miscellaneous Case)"
   },
   "iandce" : {
      "0" : "0 (No cause code entered)",
      "00:0000" : "00:0000 (00:0000 Cause Code Unknown )",
      "02:0358" : "02:0358 (02:358 President's Recommendations on Exec., Jud. & Leg. Salary)",
      "02:0431" : "02:0431 (02:431 Fed. Election Commission: Failure Enforce C)",
      "02:0437" : "02:0437 (02:437 Federal Election Commission)",
      "02:0681" : "02:0681 (02:681 Deferral of Budget Authority)",
      "02:1202" : "02:1202 (02:1202 Discriminatory practices affecting US Senate employees)",
      "02:1301" : "02:1301 (02:1301 Congressional Accountability Act)",
      "02:1317(a)" : "02:1317(a) (02:1317(a) Violation of Congressional Accountability Act)",
      "05:0075" : "05:0075 (05:75(2) Contract - Reduction in Grade)",
      "05:0101" : "05:0101 (05:101 Ethics in Government Act)",
      "05:0504" : "05:0504 (05:504(c)(2) Equal Access to Justice (Govt Employees))",
      "05:0551" : "05:0551 (05:551 Administrative Procedure Act)",
      "05:0552" : "05:0552 (05:552b(g)sa Implement Requirements of Govt in Sunshine Act)",
      "05:0552fi" : "05:0552fi (05:552 Freedom of Information Act)",
      "05:0552pa" : "05:0552pa (05:552 Right to Privacy Act)",
      "05:0554" : "05:0554 (05:0554 Adjudications Required by Statutes)",
      "05:0555(b)" : "05:0555(b) (05:555(b) Agency Decision - Right to Counsel)",
      "05:0701" : "05:0701 (05:0701 Judicial Review of Agency Decision)",
      "05:0702" : "05:0702 (05:702 Administrative Procedure Act - Right of Review)",
      "05:0704" : "05:0704 (05:704 Labor Litigation)",
      "05:0706" : "05:0706 (05:706 Judicial Review of Agency Action)",
      "05:1508" : "05:1508 (05:1508 Judicial Review of Order Issued by the Merit Systems Protection Board)",
      "05:2302" : "05:2302 (05:2302 Federal Whistleblowing Act/Civil Service Reform Act (CSRA))",
      "05:3318" : "05:3318 (05:3318 Veterans Preference Act)",
      "05:5514" : "05:5514 (05:5514 Debt Collection Act of 1982)",
      "05:5542" : "05:5542 (05:5542 Federal Employees Pay Act - overtime rates)",
      "05:7101" : "05:7101 (05:7101 Labor-Management Relations (Findings and Purpose))",
      "05:7123" : "05:7123 (05:7123 Petition by FLRA against unfair labor practices)",
      "05:7501" : "05:7501 (05:7501 Government Employees Adverse Action - 14 days or less)",
      "05:7511" : "05:7511 (05:7511 Government Employees Adverse Action--Over 14 days)",
      "05:7703" : "05:7703 (05:7703 Discrimination - Review of Agency Act)",
      "05:8101" : "05:8101 (05:8101 Workmen's Compensation Benefits)",
      "05:8110" : "05:8110 (05:8110 Augmented Compensation for dependents of Govt. Employees)",
      "05:8316" : "05:8316 (05:8316 Claims agst US re Retirement for Federal Emp.)",
      "05:8470" : "05:8470 (05:8470 Enforcement of Judgment against Retirement Benefits)",
      "05:8701" : "05:8701 (05:8701 Federal Employees Group Life Insurance Act of 1954)",
      "05:8705" : "05:8705 (05:8705 Declaratory Judgment - Insurance)",
      "05:8715" : "05:8715 (05:8715 Claims against the US - Jurisdiction of Courts)",
      "05:8901" : "05:8901 (05:8901 Federal Employees Health Benefits Act)",
      "05:8902" : "05:8902 (05:8902 Contracting Authority of OPM - Group Health Insurance)",
      "05:8903" : "05:8903 (05:8903 Federal Employees Health Benefit Act)",
      "05:8912" : "05:8912 (05:8912 Claims agst US re health benefits for Federal emp.)",
      "07:0001" : "07:0001 (07:1 Commodity Exchange Act)",
      "07:0006" : "07:0006 (7:6(b) Federal Commodity Exchange Regulation)",
      "07:0009a" : "07:0009a (07:9a Recovery of penalties by Commodity Futures Trading Com)",
      "07:0013a" : "07:0013a (07:13a Contract market rules violations; recovery of penalty)",
      "07:0013a-1" : "07:0013a-1 (07:13a-1 Enjoin or restrain violations Contract Market rules)",
      "07:0025" : "07:0025 (7:25 Fraud - Commodities Leverage Contracts)",
      "07:0087" : "07:0087 (07:87 Enforcement of United States Grain Standards Act)",
      "07:0136" : "07:0136 (07:136 Violations of EPA re Environmental Pesticide Control)",
      "07:0181" : "07:0181 (07:181 Packers & Stockyard Act)",
      "07:0193(b)" : "07:0193(b) (07:193(b) Recovery of penalties re violations by packers)",
      "07:0203" : "07:0203 (07:203 Recovery of penalties for violations by stockyards)",
      "07:0209(b)" : "07:0209(b) (07:209(b) Violations re purchase, sale, handling of livestock)",
      "07:0210(f)" : "07:0210(f) (07:210(f) Suit to enforce award of damages (Packers/Stockyards))",
      "07:0213(b)" : "07:0213(b) (07:213(b) Unfair, discriminatory, deceptive practice/marketing)",
      "07:0216" : "07:0216 (07:216 Injunctions to restrain & enforce orders of Secretary)",
      "07:0222" : "07:0222 (07:222 Adoption of FTC powers for enforcement)",
      "07:0228a" : "07:0228a (07:228a Request by Secretary for TRO or Inj. re Poultry)",
      "07:0245" : "07:0245 (07:245 Action on bond by person injured in Warehouse)",
      "07:0292" : "07:0292 (07:292 Monopolizing or restraining trade & enhancing prices)",
      "07:0499" : "07:0499 (07:499 Agricultural Commodities Act)",
      "07:0499E" : "07:0499E (07:499E (c)(4) Perishable Agriculture Commodities Act (PACA))",
      "07:0601" : "07:0601 (07:601 USDA Condemnation)",
      "07:0608" : "07:0608 (07:608 Agriculture Adjustment Act)",
      "07:0901" : "07:0901 (07:901 Rural Electrification Act)",
      "07:1291(b)" : "07:1291(b) (07:1291(b) Agricultural Adjustment Act; freight rates)",
      "07:1376" : "07:1376 (07:1376 Adjustment of Quotas and Enforcement; penalties)",
      "07:1501" : "07:1501 (07:1501 Federal Crop Insurance Act)",
      "07:1508" : "07:1508 (07:1508 Crop Insurance )",
      "07:1631" : "07:1631 (07:1631 Food Security Act)",
      "07:1721" : "07:1721 (07:1721 Agricultural Trade Development Asst Act)",
      "07:1922" : "07:1922 (07:1922 Persons Eligible for Loans - Forclosure)",
      "07:1926" : "07:1926 (07:1926 Water and Waste Facility Loans and Grants)",
      "07:1930" : "07:1930 (07:1930 Perishable Agric. Comm. Act of 1930)",
      "07:2011" : "07:2011 (07:2011 Supplemental Nutrition Assistance Program)",
      "07:2022" : "07:2022 (07:2022 Disposition of Claims; Denial application to participate; food stamp prog.)",
      "07:2023(a)" : "07:2023(a) (07:2023(a) Judicial Review of Food Stamp Disqualification)",
      "07:2024" : "07:2024 (07:2024 False Claims Act, Food Stamp Fraud)",
      "07:2131" : "07:2131 (07:2131 Violation of the Animal Welfare Act)",
      "07:2146" : "07:2146 (07:2146 Transportation, Sale, and Handling of Animals)",
      "07:2301" : "07:2301 (07:2301 Agricultural Fair Practices Act)",
      "07:2305" : "07:2305 (07:2305 Unfair trade practices affecting producers Agri prod)",
      "07:2321" : "07:2321 (07:2321 Plant Variety Protection Act)",
      "07:2563" : "07:2563 (07:2563 Plant Variety Protection and Rights - Injunction)",
      "07:6999" : "07:6999 (07:6999 Judicial Review of Adverse Farm Agency Decision)",
      "08:1101" : "08:1101 (08:1101 Immigration & Nationality Act (Definitions))",
      "08:1105" : "08:1105 (8:1105a Immigration: Judicial Review for Battered Spouses; Deportation (INS))",
      "08:1151" : "08:1151 (08:1151 Immigration and Nationality Act of 1952)",
      "08:1152" : "08:1152 (08:1152 Immigration: Numerical limitations on individual foreign states)",
      "08:1153" : "08:1153 (08:1153 Immigration: Allocation of Immigrant Visas)",
      "08:1154" : "08:1154 (08:1154 Immigration: Procedure for Granting Immigration Status)",
      "08:1158" : "08:1158 (08:1158 Immigration & Nationality Act, Section 208 (Asylum))",
      "08:1182" : "08:1182 (08:1182 Inadmissible Aliens: Defend. Denial of Pla. Appl. for Alien Employment Cer)",
      "08:1183" : "08:1183 (08:1183 Admission of Aliens on Giving Bond or Undertaking; Return on Departure)",
      "08:1188" : "08:1188 (08:1188 Immigration: Admission of Temporary H-2A Workers)",
      "08:1225" : "08:1225 (08:1225 Immigration: Enforcement of Administrative Subpoena)",
      "08:1231" : "08:1231 (08:1231(a)(6) Immigration: Due Process Clause)",
      "08:1251" : "08:1251 (081251(A)(4) Immigration: Application for a Stay of Deportation)",
      "08:1252" : "08:1252 (08:1252 Judicial Review of Orders of Removal)",
      "08:1255" : "08:1255 (08:1255 Immigration: Failure USCIS To Adjudicate Permanent Residency Petition)",
      "08:1260" : "08:1260 (08:1260 Aliens: Removal of Aliens Falling into Distress)",
      "08:1324" : "08:1324 (08:1324 Aliens: Complaint for Forfeiture)",
      "08:1329" : "08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petiti)",
      "08:1357" : "08:1357 (08:1357 Immigration and Nationality Act - Administrative Search Warrant)",
      "08:1421" : "08:1421 (08:1421 Immigration: Naturalization Authority)",
      "08:1445" : "08:1445 (08:1445 Immigration: Application for Naturalization)",
      "08:1446" : "08:1446 (8:1446 Petition for Naturalization Hearing)",
      "08:1447" : "08:1447 (08:1447 Immigration: Review of Denial of Naturalization Application)",
      "08:1451" : "08:1451 (08:1451 Immigration: Revocation of Citizenship)",
      "08:1451(a)" : "08:1451(a) (08:1451(a) Action to revoke Citizenship)",
      "08:1451(j)" : "08:1451(j) (08:1451(j) Immigation: Motion to Correct Order and Judg. of Naturalization)",
      "09:0001" : "09:0001 (09:1 U.S. Arbitration Act)",
      "09:0003" : "09:0003 (09:3 Application to Stay Proceedings Pending Arbitration)",
      "09:0004" : "09:0004 (09:4 Petition to order arbitration; failure to arbitrate)",
      "09:0007" : "09:0007 (09:7 Petition to compel attendance before arbitrator)",
      "09:0008" : "09:0008 (09:8 Declaratory Judgment/Admiralty)",
      "09:0009" : "09:0009 (9:9 Motion to Confirm Arbitration Loan)",
      "09:0010" : "09:0010 (09:0010 Petition to Vacate Arbitration Award)",
      "09:0011" : "09:0011 (09:11 Motion to modify or correct arbitration award)",
      "09:0201" : "09:0201 (09:201 Petition to Compel/Stay Arbitration under an Insurance Contract)",
      "09:0202" : "09:0202 (09:202 Award under Convention on Foreign Arbitral Awards)",
      "09:0205" : "09:0205 (09:205 Removal from State Court: Enforcement of Foreign Arbital Awards)",
      "09:0207" : "09:0207 (09:207 Application for order confirming award of arbitrators)",
      "10:0672" : "10:0672 (10:672 Armed Forces: Active Guard/Reserve (AGR) Program)",
      "10:1006" : "10:1006 (10:1006 Armed Forces: Review of Agency Decision)",
      "10:1072" : "10:1072 (10:1072 Armed Forces: TRICARE PROGRAM)",
      "10:1089(c)" : "10:1089(c) (10:1089(c) Armed Forces: Removal; dft acting in scope of duties)",
      "10:1091" : "10:1091 (10:1091 Armed Forces: Personal Service Contracts)",
      "10:1107" : "10:1107 (10:1107 Armed Forces: Use of Investigational New Drug)",
      "10:1408" : "10:1408 (10:1408 Armed Forces: Claim for Military Retirement)",
      "10:1552" : "10:1552 (10:1552 Armed Forces: Action to Correct Records)",
      "10:1553" : "10:1553 (10:1553 Armed Forces: Review of Discharge or Dismissal)",
      "10:2005" : "10:2005 (10:2005 Armed Forces: Advanced Education Assistance)",
      "10:2121" : "10:2121 (10:2121 Armed Forces: Health Professions Scholarship Financial Asst Prog)",
      "10:2302" : "10:2302 (10:2302 Armed Forces: Arms Services Procurement Act)",
      "10:2305" : "10:2305 (10:2305 Review of Federal Contract)",
      "10:2323" : "10:2323 (10:2323fa Armed Forces: 5th Amendment Equal Protection: Contract Goal for Small Disadvantaged Bus.)",
      "10:2733" : "10:2733 (10:2733 Armed Forces: Military Claims Act)",
      "10:2734" : "10:2734 (10:2734 Armed Forces: Foreign Military Claims Act)",
      "10:2771" : "10:2771 (10:2771 Armed Forces: Final Settlement - Deceased Members)",
      "10:3258" : "10:3258 (10:3258 Armed Forces: Reg.Army: Re-enlistment after Service as Ofcr)",
      "11:0101" : "11:0101 (11:101 Bankruptcy)",
      "11:0110" : "11:0110 (11:110 Bankruptcy: Penalty for Preparers of Fraudulent or Negligent Petitions)",
      "11:0362(h)" : "11:0362(h) (11:362(h) Bankruptcy: Violation of Automatic Stay)",
      "11:0523" : "11:0523 (11:523 Bankruptcy: Exceptions to Discharge)",
      "11:0524" : "11:0524 (11:524 Bankruptcy: Effect of Discharge)",
      "11:0525" : "11:0525 (11:525 Bankruptcy: Protections Against Discriminatory Treatment)",
      "11:0548" : "11:0548 (11:548 Bankruptcy: Fraudulent Transfers and Obligations)",
      "11:0704" : "11:0704 (11:704 Bankruptcy: Duties of Trustee)",
      "12:0022" : "12:0022 (12:22 Securities Fraud)",
      "12:0085" : "12:0085 (12:85 National Banks: Rate of Interest on Loans, Discounts, and Purchases)",
      "12:0093(a)" : "12:0093(a) (12:93(a) National Banks: Violation of Provisions; Forfeiture of Franchise; Per. Liability of Dir.)",
      "12:0191" : "12:0191 (12:191 National Banks: Appointment of Receiver)",
      "12:0192" : "12:0192 (12:192 National Banks: Liquidation of National Bank)",
      "12:0215" : "12:0215 (12:215 National Banks: Consolidation and Merger)",
      "12:0622" : "12:0622 (12:622 Foreign Banking: Forfeiture, Dissolution, and Liability of Dir. and Officers for Noncomplianc)",
      "12:0632" : "12:0632 (12:632 Foreign Banking: Voluntary Liquidation)",
      "12:0635" : "12:0635 (12:635i-3 Export-Import Bank: Breach of Insurance Contract)",
      "12:1421" : "12:1421 (12:1421 Federal Home Loan Bank Act (Short Title))",
      "12:1441" : "12:1441 (12:1441 FHLB: Financial Inst Reform Receiving Enforcement Act 1989)",
      "12:1451" : "12:1451 (12:1451 Emergency Home Loan Corporation (Definitions))",
      "12:1452" : "12:1452 (12:1452 Federal Home Loan Mortgage Corporation Act)",
      "12:1452(f)" : "12:1452(f) (12:1452(f) Fed Home Loan Mortgage Corp: Actions by and against the Corporation)",
      "12:1455(b)" : "12:1455(b) (12:1455(b) Fed Home Loan Mortgage Corp: Enforcement of Regulations)",
      "12:1461" : "12:1461 (12:1461 Savings Association: Homeowners Loan Act (Short Title))",
      "12:1464" : "12:1464 (12:1464 Savings Associations: Federal Savings and Loan)",
      "12:1703" : "12:1703 (12:1703 National Housing: Insurance of Financial Institutions)",
      "12:1715(b)" : "12:1715(b) (12:1715(b) National Housing: Rules and Regulations)",
      "12:1725" : "12:1725 (12:1725 Collection under Contract Guaranty)",
      "12:1730" : "12:1730 (12:1730 Collection Under Contract Guaranty)",
      "12:1749aaa" : "12:1749aaa (12:1749aaa National Housing: National Insurance Development Program)",
      "12:1751" : "12:1751 (12:1751 Fed Credit Unions: Short Title)",
      "12:1782" : "12:1782 (12:1782 Fed Credit Unions: Administration of Insurance Fund)",
      "12:1786" : "12:1786 (12:1786 Fed Credit Unions: Actions re Violations by Credit Unions)",
      "12:1787" : "12:1787 (12:(a)(B) Fed Credit Unions: Liquidation of Insured Credit Union by Board)",
      "12:1789" : "12:1789 (12:1789(a)(2) Fed Credit Unions: Admin Provision to Sue and be Sued)",
      "12:1811" : "12:1811 (12:1811 FDIC: Financial Inst. Reform Recovery Act of 1989 (FIRREA) (Org of FDIC))",
      "12:1818" : "12:1818 (12:1818 FDIC: Violations re Federal Deposit Insurance Corporation)",
      "12:1818(e)" : "12:1818(e) (12:1818(e) FDIC: Suspension of Removal of Bank Officer)",
      "12:1819" : "12:1819 (12:1819 FDIC: Corporate Powers)",
      "12:1821" : "12:1821 (12:1821 FDIC: Insurance Funds)",
      "12:1831" : "12:1831 (12:1831 FDIC: Separability of Certain Provisions)",
      "12:1831(d)" : "12:1831(d) (12:1831(d) FDIC: Deposit. Inst. Dereg. & Monetary Ctrl. Act of 1980)",
      "12:1831r-1" : "12:1831r-1 (12:1831r-1 FDIC: Notice of Branch Closure)",
      "12:1833(a)" : "12:1833(a) (12:1833(a) FDIC: Forfeiture Civil Penalties)",
      "12:1954" : "12:1954 (12:1954 Injunctions (Action by Sec of Treasury re financial recordkeeping))",
      "12:1971" : "12:1971 (12:1971 Relief under Bank Holding Company Act (Definitions))",
      "12:1972" : "12:1972 (12:1972 Tying Arrangement Act)",
      "12:2001" : "12:2001 (12:2001 Farm Credit Act of 1971)",
      "12:2601" : "12:2601 (12:2601 Real Estate Settlement Procedures Act (RESPA) (findings & purpose))",
      "12:2604(c)" : "12:2604(c) (12:2604(c) Real Estate Settlement Procedures Act (\"RESPA\"))",
      "12:2605" : "12:2605 (12:2605 RESPA: Servicing of Mortgage Loans)",
      "12:2607" : "12:2607 (12:2607 RESPA: Violation re kickbacks/unearned fees; Real Estate)",
      "12:2609" : "12:2609 (12:2609 RESPA: Escrow)",
      "12:3012" : "12:3012 (12:3012 National Consumer Cooperative Bank: Suits by or against Bank)",
      "12:3410" : "12:3410 (12:3410 Right to Financial Privacy: Customer Challenges)",
      "12:3751" : "12:3751 (12:3751 Single Family Mortgage Foreclosure Act: Findings and Purpose)",
      "12:3801" : "12:3801 (12:3801 Alternative Mortgage Transaction Parity Act)",
      "12:3907" : "12:3907 (12:3907 International Lending Supervision: Capital Adequacy)",
      "12:4010" : "12:4010 (12:4010 Expedited Funds Availability: Violation of Act (Civil Liability))",
      "12:5101" : "12:5101 (12:5101 Fraudulent Transfer Act (Enforcement for Mortgage Licensing))",
      "15:0001" : "15:0001 (15:1 Antitrust Litigation (Monopolizing Trade))",
      "15:0002at" : "15:0002at (15:2 Antitrust Litigation)",
      "15:0002fl" : "15:0002fl (15:2fl Antitrust Litigation)",
      "15:0004" : "15:0004 (15:4 USDC Jurisdiction re violations of Sec. 1-7 of Title 15)",
      "15:0005" : "15:0005 (15:5 Bringing in Additional Parties)",
      "15:0009" : "15:0009 (15:9 USDC Jurisdiction re violations of Sec. 8 of Title 15)",
      "15:0013" : "15:0013 (15:13 Robinson Patman Act)",
      "15:0014" : "15:0014 (15:14 Clayton Act)",
      "15:0015" : "15:0015 (15:15 Antitrust Litigation)",
      "15:0025" : "15:0025 (15:25 Clayton Act)",
      "15:0026" : "15:0026 (15:26 Suit for injunctive relief re violation antitrust laws)",
      "15:0041" : "15:0041 (15:41 Federal Trade Commission Act)",
      "15:0044" : "15:0044 (15:44 Trademark Infringement)",
      "15:0045" : "15:0045 (15:0045 Federal Trade Commission Act (unfair or deceptive acts))",
      "15:0045cp" : "15:0045cp (15:45cp Violation of Children Online Privacy Protection Act)",
      "15:0052" : "15:0052 (15:0052 Federal Trade Commission Act)",
      "15:0053" : "15:0053 (15:0053 Federal Trade Commission Act)",
      "15:0053(b)" : "15:0053(b) (15:53(b) Prelim & Perm Inj Relief & other Equitable Relief)",
      "15:0068" : "15:0068 (15:68 Proceedings re FTC violations re wool products)",
      "15:0069" : "15:0069 (15:69 Proceedings re FTC violations re fur products)",
      "15:0070" : "15:0070 (15:70 Proceedings re FTC violations re textile fiber product)",
      "15:0077" : "15:0077 (15:77 Securities Fraud)",
      "15:0078" : "15:0078 (15:78m(a) Securities Exchange Act)",
      "15:0079" : "15:0079 (15:79 Public Utility Holding Companies)",
      "15:0080a-3" : "15:0080a-3 (15:80a-3 Investment Company Act of 1940)",
      "15:0260" : "15:0260 (15:260 Proceedings re weights and measures and standard time)",
      "15:0298" : "15:0298 (15:0298 Violation of Law Proceedings re gold or silver)",
      "15:0433" : "15:0433 (15:433 Discrimination against farmers)",
      "15:0631" : "15:0631 (15:631 Small Business Act)",
      "15:0636" : "15:0636 (15:636 Small Business Act - Aid to small business)",
      "15:0661" : "15:0661 (15:661 Small Business Investment Act of 1958)",
      "15:0687" : "15:0687 (15:687 Small Business Investment Program)",
      "15:0714(b)" : "15:0714(b) (15:714(b) Commodity Credit Corporation)",
      "15:0715(f)" : "15:0715(f) (15:715(f) Proceedings re petroleum and petroleum products)",
      "15:0717" : "15:0717 (15:717 Natural Gas Act)",
      "15:0719i" : "15:0719i (15:719i(c) Civil actions re violations or inj involving Gas)",
      "15:0766" : "15:0766 (15:766 Controversies arising re Federal Energy Admin. rules)",
      "15:078j(b)" : "15:078j(b) (15:78j(b)ss Stockholder Suit)",
      "15:1051" : "15:1051 (15:1051 Trademark Infringement)",
      "15:1071" : "15:1071 (15:1071 Appeal of Decision of U.S. Patent & Trademark Office (Comm/Trademark Trial Bd))",
      "15:1114" : "15:1114 (15:1114 Trademark Infringement (Lanham Act))",
      "15:1116" : "15:1116 (15:1116 Inj to prevent violation rights of trademark owner)",
      "15:1120" : "15:1120 (15:1120 Trademark - False or Fraudulent Registration)",
      "15:1121" : "15:1121 (15:1121 Trademark Infringement (jurisdiction))",
      "15:1125" : "15:1125 (15:1125la Trademark Infringement (Lanham Act))",
      "15:1125(a)" : "15:1125(a) (15:1125(a) False representation of goods sold in interstate commerce)",
      "15:1125(d)" : "15:1125(d) (15:1125(d)ac Trademark (Anticybersquatting consumer protection))",
      "15:1126" : "15:1126 (15:1126 Trademarks - International conventions)",
      "15:1127" : "15:1127 (15:1127 Trademark Infringement)",
      "15:1191" : "15:1191 (15:1191 Flamable Fabrics Act)",
      "15:1221" : "15:1221 (15:1221 Auto Dealer Suits Agst Manufacturers)",
      "15:1261" : "15:1261 (15:1261 Hazardous Substances (definitions))",
      "15:1263" : "15:1263 (15:1263 Prohibited Hazardous Substance - Interstate Commerce)",
      "15:1267(a)" : "15:1267(a) (15:1267(a) Federal Hazardous Substance Act)",
      "15:1314" : "15:1314 (15:1314 Antitrust--Petition for enforcement)",
      "15:1501" : "15:1501 (15:1501 Estab of Dept of Commerce)",
      "15:1601" : "15:1601 (15:1601 Truth in Lending)",
      "15:1605" : "15:1605 (15:1605 Determination of Finance Charge)",
      "15:1638" : "15:1638 (15:1638 Truth in Lending)",
      "15:1640" : "15:1640 (15:1640 Truth in Lending)",
      "15:1666" : "15:1666 (15:1666 Fair Credit Billing Act Dispute)",
      "15:1667" : "15:1667 (15:1667 Consumer Leasing Act)",
      "15:1679" : "15:1679 (15:1679 Violation of Credit Repair Organizations Act)",
      "15:1681" : "15:1681 (15:1681 Fair Credit Reporting Act)",
      "15:1691" : "15:1691 (15:1691 Equal Credit Opportunity Act)",
      "15:1692" : "15:1692 (15:1692 Fair Debt Collection Act)",
      "15:1693" : "15:1693 (15:1693ef Electronic Funds Transfer Act)",
      "15:1693m" : "15:1693m (15:1693m Violation of Prov. of Subchpt. VI (Electronic Fund Transfers))",
      "15:1701" : "15:1701 (15:1701 Interstate Land Sales Full Disclosure Act (ILFFDA))",
      "15:1709" : "15:1709 (15:1709 Interstate Land Sales)",
      "15:1714" : "15:1714 (15:1714 Actions to enjoin violations re interstate land sale)",
      "15:1938" : "15:1938 (15:1938 Fair Labor Standards Act)",
      "15:1981" : "15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))",
      "15:1988" : "15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))",
      "15:1989" : "15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))",
      "15:2071" : "15:2071 (15:2071 Consumer Product Safety; Condemnation hazardous prod)",
      "15:2073" : "15:2073 (15:2073 Private action to enforce Consumer Product Safety)",
      "15:2301" : "15:2301 (15:2301 Magnuson-Moss Warranty Act)",
      "15:2310(c)" : "15:2310(c) (15:2310(c) Consumer Product Warranties)",
      "15:2601" : "15:2601 (15:2601 Toxic Substances Control Act (TCSA))",
      "15:2604" : "15:2604 (15:2604 Application for inj re distribution toxic substance)",
      "15:2616" : "15:2616 (15:2616 Toxic Substance control; seizure of chemical)",
      "15:2620" : "15:2620 (15:2620 Toxic Substances Control Act: citizen's petition)",
      "15:2651" : "15:2651 (15:2651 Asbestos Hazard Emergency Response Act)",
      "15:2801" : "15:2801 (15:2801 Petroleum Marketing Practices Act)",
      "15:2805" : "15:2805 (15:2805 Petroleum Marketing Practices-Franchise Protection)",
      "15:34-35" : "15:34-35 (15:34-35 Investment Company Act of 1940)",
      "15:3414" : "15:3414 (15:3414 National Gas Policy Act)",
      "15:3710" : "15:3710 (15:3710a Federal Technology Transfer Act of 1986)",
      "15:3901" : "15:3901 (15:3901 Federal Risk Retention Act)",
      "15:53(b)" : "15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equita)",
      "15:6801" : "15:6801 (15:6801 Gram-Leach-Bliley Act)",
      "15:7701" : "15:7701 (15:7701 Federal CAN-Spam Act)",
      "16:0019jj" : "16:0019jj (16:19jj Park System Resource Protection Act)",
      "16:0470" : "16:0470 (16:470 Archaeological Resources Protection Act)",
      "16:0470f" : "16:0470f (16:470f National Historic Preservation Act)",
      "16:0668" : "16:0668 (16:668 Bald and Golden Eagle Protection Act)",
      "16:0669" : "16:0669 (16:669 Pittman-Robertson Conservation Restoration Act)",
      "16:0675" : "16:0675 (16:675 Norbeck Wildlife Preserve Organic Act)",
      "16:0703" : "16:0703 (16:703 Migratory Bird Act)",
      "16:0823" : "16:0823 (16:823a Federal Public Utility Regulatory Policies Act)",
      "16:0825" : "16:0825 (16:825 Federal Power Commission Regulation; Public Utilities)",
      "16:0831" : "16:0831 (16:831 Actions re: rights of Tennessee Valley Authority)",
      "16:1244" : "16:1244 (16:1244 National Scenic and National Historic Trails)",
      "16:1374(d)" : "16:1374(d) (16:1374(d)(6) Petition for Review re Application for Import of Polar Bear Trophies)",
      "16:1531" : "16:1531 (16:1531 Endangered Species Act)",
      "16:1533" : "16:1533 (16:1533 Endangered Species Act)",
      "16:1538" : "16:1538 (16:1538 Endangered Species Act)",
      "16:1540" : "16:1540 (16:1540 Endangered Species Act - Penalties and Enforcement)",
      "16:1600" : "16:1600 (16:1600 National Forest Management Act of 1976)",
      "16:1801" : "16:1801 (16:1801 Magnuson-Stevens Fishery Conservation and Management Act)",
      "16:1858" : "16:1858 (16:1858 National Fishery Management Program-Civil Penalties and Permit Sanctions)",
      "16:3371" : "16:3371 (16:3371 Wildlife Under the Lacey Act (Definitions)",
      "16:3372" : "16:3372 (16:3372 Lacey Act: Prohibited Acts)",
      "16:3373" : "16:3373 (16:3373 Lacey Act: Penalties and Sanctions - Appeal of Decision-DOI)",
      "16:3374" : "16:3374 (16:3374 Lacey Act: Complaint for Forfeiture)",
      "17:0101" : "17:0101 (17:101 Copyright Infringement (definitions))",
      "17:0201" : "17:0201 (17:201 Ownership of Copyright)",
      "17:0205(d)" : "17:0205(d) (17:205(d) Priority Between Conflicting Transfers)",
      "17:0407" : "17:0407 (17:407 Recovery of fines & penalties by Register of Copyrights)",
      "17:0411(b)" : "17:0411(b) (17:411(b) Action by copyright owner for infringement)",
      "17:0501" : "17:0501 (17:501 Copyright Infringement)",
      "17:0502(a)" : "17:0502(a) (17:502(a) Inj to prevent or restrain infringement copyright)",
      "17:0504" : "17:0504 (17:504 Remedies for Copyright Infringement)",
      "17:0512" : "17:0512 (17:512 Copyright Infringement of Digital Communications)",
      "17:1201" : "17:1201 (17:1201 Digital Millennium Copyright Act)",
      "18:0241" : "18:0241 (18:241 Conspiracy Against Citizen Rights)",
      "18:0492" : "18:0492 (18:492 Forfeiture of Counterfeit Paraphernalia)",
      "18:0603" : "18:0603 (18:603 Conflict of Interest)",
      "18:0922" : "18:0922 (18:922 Firearms - Unlawful Possession (Civil Fines))",
      "18:0923(f)" : "18:0923(f) (18:923(f)(3) Review of Revocation of a License as a Dealer in Firearms)",
      "18:0924" : "18:0924 (18:0924 Firearms Seizure, Forfeiture and Disposition of Firearm)",
      "18:0925(c)" : "18:0925(c) (18:925(c) Restoration of ability to possess firearms/ammo)",
      "18:0981" : "18:0981 (18:981 Civil Forfeiture )",
      "18:0981(a)" : "18:0981(a) (18:981(a)(1)(A) Civil Forfeiture: Money Laundering Control Act)",
      "18:0983" : "18:0983 (18:983 Civil Forfeiture - General Rules)",
      "18:1030" : "18:1030 (18:1030 Fraud & Related Activity in Connection with Computers)",
      "18:1345" : "18:1345 (18:1345 Injunction against Fraud)",
      "18:1514" : "18:1514 (18:1514 Civil Action to Restrain Harassment of a Victim)",
      "18:1514(A)" : "18:1514(A) (18:1514(A) Civil Action to Protect Against Retaliation in Fraud Cases)",
      "18:1836(a)" : "18:1836(a) (18:1836(a) Injunction against Misappropriation of Trade Secrets)",
      "18:1836(b)" : "18:1836(b) (18:1836(b) Civil Action to Protect Trade Secrets)",
      "18:1836a" : "18:1836a (18:1836(a) Injunction against Misappropriation of Trade Secrets)",
      "18:1836b" : "18:1836b (18:1836(b) Civil Action to Protect Trade Secrets)",
      "18:1905" : "18:1905 (18:1905 Disclosure of Confidential Information)",
      "18:1955" : "18:1955 (18:1955 Civil Forfeiture-Prohibition of Illegal Gambling)",
      "18:1956(b)" : "18:1956(b) (18:1956(b)(3) Laundering of Monetary Instruments - Forfeit Property)",
      "18:1961" : "18:1961 (18:1961 Racketeering (RICO) Act)",
      "18:1962" : "18:1962 (18:1962 Racketeering (RICO) Act)",
      "18:1964" : "18:1964 (18:1964 Civil Remedies: Racketeering (RICO) Act)",
      "18:1968" : "18:1968 (18:1968 Action re civil investigative demand)",
      "18:2254" : "18:2254 (18:2254 Civil Forfeiture - Exploitation of Children)",
      "18:2333" : "18:2333 (18:2333 Civil Remedies: Anti-Terrorism Act of 1991)",
      "18:2428" : "18:2428 (Forfeiture of property)",
      "18:2511" : "18:2511 (18:2511 Wiretapping - Injunctive Relief or Civil Fine)",
      "18:2520" : "18:2520 (18:2520 Civil Damages for Interception Wire or Oral Communications)",
      "18:2707" : "18:2707 (18:2707 Civil Action: Stored Communications)",
      "18:2710(c)" : "18:2710(c) (18:2710(c) Wrongful Disclosure of Video Tape Rental or Sales Records)",
      "18:2724" : "18:2724 (18:2724 Civil Action - Motor Vehicle Records)",
      "18:3114" : "18:3114 (18:3114 Motion for Return of Seized Property)",
      "18:3184" : "18:3184 (18:3184 Extradition Procedure)",
      "18:3511" : "18:3511 (18:3511 Petition for Judicial Review)",
      "18:3663" : "18:3663 (18:3663 Civil Enforcement of Crim. Rest. Obligation)",
      "18:4100" : "18:4100 (18:4100 Transfer of Offenders)",
      "18:4208" : "18:4208 (18:4208(B) Agency Action Review)",
      "19:1305" : "19:1305 (19:1305 Custom Duties: Forfeiture-Immoral Articles)",
      "19:1497" : "19:1497 (19:1497 Customs Duties: Penalty for Failure to Declare)",
      "19:1595a" : "19:1595a (19:1595a Customs Duties: Forfeiture and Other Penalties)",
      "19:1607" : "19:1607 (19:1607 Customs Duties: Notice of Seizure)",
      "20:0107" : "20:0107 (20:107 Randolph-Sheppard Vending Stand Act)",
      "20:1070" : "20:1070 (20:1070 Student Assistance)",
      "20:1080" : "20:1080 (20:1080 Default of Student Loan: Recovery)",
      "20:1087" : "20:1087 (20:1087 Student Loan Discharge)",
      "20:1095a" : "20:1095a (20:1095a Education - Wage Garnishment Requirement)",
      "20:1097" : "20:1097 (20:1097 Education - Criminal penalties for fraud)",
      "20:1098g" : "20:1098g (20:1098g Higher Education Act - Exemption from state disclosure)",
      "20:1232(g)" : "20:1232(g) (20:1232(g) Family Education Rights & Privacy Act of 1974)",
      "20:1400" : "20:1400 (20:1400 IDEA: Individuals With Disabilities Education Act (short title))",
      "20:1401" : "20:1401 (20:1401 IDEA: Education of Individuals with Disabilities (definitions))",
      "20:1412" : "20:1412 (20:1412 IDEA: State Eligibility)",
      "20:1415" : "20:1415 (20:1415 IDEA: Challenge decision re education for handicapped)",
      "20:1415(e)" : "20:1415(e) (20:1415(e)(2)de IDEA: Mediation)",
      "20:1681" : "20:1681 (20:1681 Title IX Educational Amendments 1992 - Sex Discrimination)",
      "20:1683" : "20:1683 (20:1683 Judicial Review: Prohibition against sex discrimination in education)",
      "20:1706" : "20:1706 (20:1706 Relief from denial of equal educational opportunity)",
      "20:1717" : "20:1717 (20:1717 Reopening proceedings w/order to end segregation)",
      "21:0301" : "21:0301 (21:0301 Federal Food, Drug & Cosmetic Act)",
      "21:0331" : "21:0331 (21:0331 Federal Food, Drug & Cosmetic Act - Prohibited Acts)",
      "21:0332" : "21:0332 (21:332 Federal Food, Drug and Cosmetic Act, Injunctive Relief)",
      "21:0332(a)" : "21:0332(a) (21:332(a) Federal Food, Drug, and Cosmetic Act)",
      "21:0334(a)" : "21:0334(a) (21:334(a) Forfeiture or condemnation-food, drug, cosmetics)",
      "21:0348" : "21:0348 (21:348 Federal Food, Drug and Cosmetic Act - Food Additives)",
      "21:0360" : "21:0360 (21:360 Federal Food, Drug & Cosmetic Act - Drugs and Devices)",
      "21:0467" : "21:0467 (21:467 Seizure and condemnation of poultry products)",
      "21:0601" : "21:0601 (21:601 Federal Meat Inspection Act 21 USC 601-695 (Definitions))",
      "21:0673" : "21:0673 (21:673 Seizure and condemnation of meat or meat products)",
      "21:0674" : "21:0674 (21:674 Proceeding to enforce & enjoin re meat products)",
      "21:0821" : "21:0821 (21:821 Violation of Record Keeping Provision of Controlled Substance Act)",
      "21:0841" : "21:0841 (21:841 Forfeiture Property-Drugs)",
      "21:0842" : "21:0842 (21:842 Civil Penalty for violation re controlled substance)",
      "21:0881" : "21:0881 (21:881 Forfeiture Property-Drugs)",
      "21:0881a" : "21:0881a (21:881 Forfeiture Property - Aircraft)",
      "21:0881re" : "21:0881re (21:881 Forfeiture Property - Real Estate)",
      "21:0882" : "21:0882 (21:882 Inj to enjoin violations re controlled substance)",
      "21:1049" : "21:1049 (21:1049 Seizure and condemnation re eggs or egg products)",
      "22:0286" : "22:0286 (22:286 Action against World Bank or IMF)",
      "22:2702" : "22:2702 (22:2702 Medical Malpractice by Govt. Medical Personnel)",
      "22:3612" : "22:3612 (22:3612 Claim for Damage to Panama Canal)",
      "22:3776" : "22:3776 (22:3776 Panama Canal Commission Action on claims)",
      "22:3777" : "22:3777 (22:3777 Investigation of accident or injury giving rise to a claim)",
      "22:4140" : "22:4140 (22:4140 Foreign Service Grievance Act - Judicial Review)",
      "23:0112" : "23:0112 (23:112 Federal Highway Act - Letting of Contracts)",
      "23:0134" : "23:0134 (23:134 Metropolitan Transportation Planning)",
      "23:1441" : "23:1441 (23:1441 Contract Real Estate)",
      "24:1000" : "24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)",
      "25:0640" : "25:0640 (25:640 Indian Tribal Rights)",
      "25:1901" : "25:1901 (25:1901 Indian Child Welfare Act)",
      "25:2701" : "25:2701 (25:2701 Indian Gaming Regulatory Act (IGRA))",
      "25:4101" : "25:4101 (25:4101 Native American Housing Assistance and Self-Determination Act (NAHASDA))",
      "26:0063" : "26:0063 (26:63 IRS: Taxable income (Definition))",
      "26:0982" : "26:0982 (26:982 IRS: To Quash IRS Formal Document Request)",
      "26:2032" : "26:2032 (26:2032 IRS: Alternate valuation)",
      "26:6212" : "26:6212 (26:6212 IRS: Notice of Deficiency (Injunctive Relief from IRS Lien))",
      "26:6213" : "26:6213 (26:6213 IRS: Injunctive Relief from IRS Lien in Tax Court)",
      "26:6221" : "26:6221 (26:6221 IRS: TEFRA Tax, Equity and Fiscal Responsibility Act of 1982)",
      "26:6226" : "26:6226 (26:6226 IRS: Judicial Review of Partnership Adjustment)",
      "26:6320" : "26:6320 (26:6320 IRS: Notice and Opportunity for Hearing upon Filing Notice of Lien)",
      "26:6330" : "26:6330 (26:6330 IRS: Notice and Opportunity for Hearing before Levy)",
      "26:6331" : "26:6331 (26:6331 IRS: Wrongful Levy)",
      "26:6334" : "26:6334 (26:6334 IRS: Property Exempt from Levy)",
      "26:6502" : "26:6502 (26:6502 IRS: Collection after Assessment (Enforcement of tax liens))",
      "26:6532" : "26:6532 (26:6532 IRS: Periods of Limitation on Suits)",
      "26:6653" : "26:6653 (26:6653sp IRS: Failure to Pay Stamp Tax)",
      "26:6672" : "26:6672 (26:6672 IRS: Failure to Collect and Pay Over Tax, or Attempt to Evade or Defeat Tax)",
      "26:6694" : "26:6694 (26:6694 IRS: Underestimate of Tax Liability By Tax Preparer)",
      "26:6702" : "26:6702 (26:6702 IRS: Penalty for Frivolous Tax Submission)",
      "26:6703" : "26:6703 (26:6703 IRS: Refund of Tax Penalty)",
      "26:7323" : "26:7323 (26:7323 IRS: Proceedings in rem enforce forfeitures property)",
      "26:7401" : "26:7401 (26:7401 IRS: Tax Liability - Authorization to collect via civil action)",
      "26:7402" : "26:7402 (26:7402 IRS: Jurisdiction of District Courts)",
      "26:7402(b)" : "26:7402(b) (26:7402(b) IRS: Petition to Enforce IRS Summons)",
      "26:7403" : "26:7403 (26:7403 IRS: Action to Enforce Federal Tax Lien)",
      "26:7404" : "26:7404 (26:7404 IRS: Action for collection of estate tax)",
      "26:7405" : "26:7405 (26:7405 IRS: Action for recovery of refunds erroneously made)",
      "26:7407" : "26:7407 (26:7407 IRS: Action to enjoin income tax preparers)",
      "26:7422rt" : "26:7422rt (26:7422 IRS: Refund Taxes)",
      "26:7422rx" : "26:7422rx (26:7422 IRS: Refund Excise Tax)",
      "26:7425(a)" : "26:7425(a) (26:7425(a) IRS: Judiciary & Judicial Procedures - Discharge of Liens)",
      "26:7426" : "26:7426 (26:7426 IRS: Wrongful Levy for Taxes)",
      "26:7428" : "26:7428 (26:7428 IRS: Declaratory Judgment)",
      "26:7429" : "26:7429 (26:7429 IRS: Tax Jeopardy Assessment)",
      "26:7430" : "26:7430 (26:7430 IRS: Awarding of Costs and Certain Fees in Tax Suit)",
      "26:7431" : "26:7431 (26:7431 IRS: Unauthorized Disclosure of Return & Return Info)",
      "26:7434" : "26:7434 (26:7434 IRS: Civil Damages for Fraudulent Filing of Information)",
      "26:7604" : "26:7604 (26:7604 IRS: Enforce summons; examination books & witnesses)",
      "26:7604(a)" : "26:7604(a) (26:7604(a) IRS: Complaint to Enforce IRS Summons)",
      "26:7609" : "26:7609 (26:7609 IRS: Petition to Quash IRS Summons)",
      "26:7609en" : "26:7609en (26:7609en IRS: Petition to serve Third-Party Summons)",
      "27:0185" : "27:0185 (27:185 Enforcement of Arbitration Award)",
      "28:0157(b)" : "28:0157(b) (28:157(b) Bankruptcy Claim to be tried in U.S. District Court)",
      "28:0157(c)" : "28:0157(c) (28:157(c)(1) Findings, Concl. & Proposed Judgment)",
      "28:0157c" : "28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)",
      "28:0157d" : "28:0157d (28:0157 Motion for Withdrawal of Reference)",
      "28:0158" : "28:0158 (28:0158 Notice of Appeal re Bankruptcy Matter (BA)",
      "28:0185" : "28:0185 (28:185 Suit to Compel Arbitration)",
      "28:0451" : "28:0451 (28:451 Employment Discrimination)",
      "28:0463" : "28:0463 (28:463 Expenses of Judicial Litigation)",
      "28:0534" : "28:0534 (28:534 Arrest Records)",
      "28:0591" : "28:0591 (28:591 Independent Counsel)",
      "28:0592" : "28:0592 (28:592 Independent Counsel - Application for Appointment)",
      "28:0593" : "28:0593 (28:593 Independent Counsel - Court Responsibilities)",
      "28:0594" : "28:0594 (28:594 Independent Counsel - Responsibilities)",
      "28:0595" : "28:0595 (28:595 Independent Counsel - Congressional Oversight)",
      "28:0596" : "28:0596 (28:596 Independent Counsel - Removal)",
      "28:0597" : "28:0597 (28:597 Independent Counsel - Dept. of Justice Relationship)",
      "28:0598" : "28:0598 (28:598 Independent Counsel - Chapter Termination)",
      "28:0636" : "28:0636 (28:636 Jurisdiction and Power of Magistrate Judges)",
      "28:0754" : "28:0754 (28:754 Receiver of Property in Different Districts)",
      "28:0794" : "28:0794 (28:794 Rehabilitation Act)",
      "28:1001" : "28:1001 (28:1001 E.R.I.S.A.)",
      "28:1132" : "28:1132 (28:1132 E.R.I.S.A.)",
      "28:1291" : "28:1291 (28:1291 Maritime)",
      "28:1330" : "28:1330 (28:1330 Breach of Contract)",
      "28:1331" : "28:1331 (28:1331 Fed. Question)",
      "28:1331ag" : "28:1331ag (28:1331 Fed. Question: Employment Discrimination (Age))",
      "28:1331al" : "28:1331al (28:1331 Fed. Question: Airline Crash)",
      "28:1331as" : "28:1331as (28:1331 Fed. Question: Assault, Libel, Slander)",
      "28:1331at" : "28:1331at (28:1331 Fed. Question: Anti-trust)",
      "28:1331au" : "28:1331au (28:1331 Fed. Question: Auto Negligence)",
      "28:1331b" : "28:1331b (28:1331 Federal Question: Bivens Act)",
      "28:1331bc" : "28:1331bc (28:1331 Fed. Question: Breach of Contract)",
      "28:1331bv" : "28:1331bv (28:1331 Fed. Question: Bivens-Prisoner)",
      "28:1331ca" : "28:1331ca (28:1331 Fed Question: Fed Communications Act of 1)",
      "28:1331cm" : "28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)",
      "28:1331cr" : "28:1331cr (28:1331 Fed. Question: Civil Rights (Race Discrimination))",
      "28:1331cv" : "28:1331cv (28:1331 Federal Question: Other Civil Rights)",
      "28:1331dd" : "28:1331dd (28:1331 Fed. Question: Discovery Disputes (conversion case))",
      "28:1331dj" : "28:1331dj (28:1331 Fed. Question: Declaratory Judgment)",
      "28:1331dp" : "28:1331dp (28:1331 Fed. Question: Violation of Due Process)",
      "28:1331ed" : "28:1331ed (28:1331 Fed. Question: Employment Discrimination)",
      "28:1331ef" : "28:1331ef (28:1331 Fed. Question: Civil Rights Violation (Excess Force))",
      "28:1331ej" : "28:1331ej (28:1331 Fed Question: Enforcement of Judgment)",
      "28:1331es" : "28:1331es (28:1331 Enforcement of Administrative Subpoena)",
      "28:1331fa" : "28:1331fa (28:1331 Fed. Question: Civil Rights Violation - False Arrest)",
      "28:1331fl" : "28:1331fl (28:1331 Fed. Question: Fair Labor Standards)",
      "28:1331fm" : "28:1331fm (28:1331 Fed. Question: Family and Medical Leave Act)",
      "28:1331fr" : "28:1331fr (28:1331 Fed. Question: Fraud)",
      "28:1331in" : "28:1331in (28:1331 Fed. Question: Insurance Contract)",
      "28:1331lm" : "28:1331lm (28:1331 Fed. Question: Labor/Mgt. Relations Act)",
      "28:1331lml" : "28:1331lml (28:1331 Fed. Question: Legal Malpractice)",
      "28:1331mm" : "28:1331mm (28:1331 Fed. Question: Medical Malpractice)",
      "28:1331ng" : "28:1331ng (28:1331 Fed. Question: Natural Gas Act)",
      "28:1331ni" : "28:1331ni (28:1331 Fed. Question: Negotiable Instrument)",
      "28:1331pd" : "28:1331pd (28:1331 Fed. Question: Property Damage)",
      "28:1331pi" : "28:1331pi (28:1331 Fed. Question: Personal Injury)",
      "28:1331pl" : "28:1331pl (28:1331 Fed. Question: Product Liability)",
      "28:1331pr" : "28:1331pr (28:1331 Fed. Question: Federal Prisoner Civil Rights)",
      "28:1331ra" : "28:1331ra (28:1331 Fed. Question: Racketeering (RICO) Act)",
      "28:1331rc" : "28:1331rc (28:1331 Fed. Question: Reclamation Project Auth. Act of 1972)",
      "28:1331rd" : "28:1331rd (28:1331 Fed. Question: Review Agency Decision)",
      "28:1331rp" : "28:1331rp (28:1331(a) Fed. Question: Real Property)",
      "28:1331rr" : "28:1331rr (28:1331 Fed. Question: Railway Labor Act)",
      "28:1331rs" : "28:1331rs (28:1331 Fed. Question: Federal Rail Safety Act)",
      "28:1331sh" : "28:1331sh (28:1331 Fed. Question: Sexual Harassment)",
      "28:1331ss" : "28:1331ss (28:1331 Fed. Question: Constitutionality of State Statutes)",
      "28:1331sv" : "28:1331sv (28:1331 Fed. Question: Securities Violation)",
      "28:1331sx" : "28:1331sx (28:1331 Fed. Question: Employment Discrimination (Sex))",
      "28:1331tr" : "28:1331tr (28:1331 Fed. Question: Trademark)",
      "28:1331tt" : "28:1331tt (28:1331 Fed. Question: Tort Action)",
      "28:1331v" : "28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendme)",
      "28:1331va" : "28:1331va (28:1331 Fed. Question: Violation 5th & 14th Amendment)",
      "28:1331vc" : "28:1331vc (28:1331 Fed. Question: Violation of Constitutional Rights)",
      "28:1331w" : "28:1331w (28:1331 Fed. Question: Wrongful Termination of Employment)",
      "28:1331wd" : "28:1331wd (28:1331 Fed. Question: Wrongful Death)",
      "28:1331wl" : "28:1331wl (28:1331 Federal Question: EPA Waste Lien)",
      "28:1331wt" : "28:1331wt (28:1331 Fed. Question: Water Rights)",
      "28:1332" : "28:1332 (28:1332 Diversity Action)",
      "28:1332ac" : "28:1332ac (28:1332 Diversity-Account Receivable)",
      "28:1332al" : "28:1332al (28:1332 Diversity-Airline Crash)",
      "28:1332ap" : "28:1332ap (28:1332 Diversity-Airplane Product Liability)",
      "28:1332as" : "28:1332as (28:1332 Diversity-Asbestos Litigation)",
      "28:1332au" : "28:1332au (28:1332 Diversity-Auto Negligence)",
      "28:1332bc" : "28:1332bc (28:1332 Diversity-Breach of Contract)",
      "28:1332bw" : "28:1332bw (28:1332 Diversity-Breach of Warranty)",
      "28:1332co" : "28:1332co (28:1332 Diversity-Conversion)",
      "28:1332ct" : "28:1332ct (28:1332 Diversity-(Citizenship))",
      "28:1332de" : "28:1332de (28:1332 Diversity-Forcible Detainer)",
      "28:1332det" : "28:1332det (28:1332 Diversity: Forcible Detainer)",
      "28:1332df" : "28:1332df (28:1332 Diversity-Contract Default)",
      "28:1332ds" : "28:1332ds (28:1332 Diversity-Contract Dispute)",
      "28:1332dtp" : "28:1332dtp (28:1332 Diversity-Deceptive Trade Practices)",
      "28:1332ed" : "28:1332ed (28:1332 Diversity-Employment Discrimination)",
      "28:1332ej" : "28:1332ej (28:1332 Diversity-Enforcement of Judgment)",
      "28:1332fc" : "28:1332fc (28:1332 Diversity-Foreclosure)",
      "28:1332fd" : "28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)",
      "28:1332fr" : "28:1332fr (28:1332 Diversity-Fraud)",
      "28:1332ia" : "28:1332ia (28:1332 Diversity-Interpleader Action)",
      "28:1332if" : "28:1332if (28:1332 Diversity-Insurance Fraud)",
      "28:1332ij" : "28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)",
      "28:1332in" : "28:1332in (28:1332 Diversity-Insurance Contract)",
      "28:1332jd" : "28:1332jd (28:1332 Diversity-Declaratory Judgement)",
      "28:1332lb" : "28:1332lb (28:1332 Diversity-Libel,Assault,Slander)",
      "28:1332lm" : "28:1332lm (28:1332 Diversity - Legal Malpractice)",
      "28:1332lp" : "28:1332lp (28:1332 Diversity-Property Damage/Product Liability)",
      "28:1332lr" : "28:1332lr (28:1332 Diversity-Labor)",
      "28:1332ma" : "28:1332ma (28:1332 Diversity-Miller Act)",
      "28:1332md" : "28:1332md (28:1332 Diversity-Motor Vehicle/Wrongful Death)",
      "28:1332mm" : "28:1332mm (28:1332 Diversity-Medical Malpractice)",
      "28:1332mv" : "28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)",
      "28:1332ni" : "28:1332ni (28:1332 Diversity-Negotiable Instrument)",
      "28:1332nm" : "28:1332nm (28:1332 Diversity-Non-Motor Vehicle)",
      "28:1332nr" : "28:1332nr (28:1332 Diversity-Notice of Removal)",
      "28:1332oc" : "28:1332oc (28:1332 Diversity-Other Contract)",
      "28:1332op" : "28:1332op (28:1332 Diversity-Recovery of Overpayment)",
      "28:1332pa" : "28:1332pa (28:1332 Diversity-Personal Injury/Airplane)",
      "28:1332pd" : "28:1332pd (28:1332 Diversity-Property Damage)",
      "28:1332pi" : "28:1332pi (28:1332 Diversity-Personal Injury)",
      "28:1332pl" : "28:1332pl (28:1332 Diversity-Product Liability)",
      "28:1332pr" : "28:1332pr (28:1332 Diversity-Petition for Removal)",
      "28:1332qt" : "28:1332qt (28:1332 Diversity-Petition to Quiet Title)",
      "28:1332rd" : "28:1332rd (28:1332 Diversity-Recovery of Debt)",
      "28:1332ri" : "28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)",
      "28:1332rl" : "28:1332rl (28:1332 Diversity-Rent Lease & Ejectment)",
      "28:1332rp" : "28:1332rp (28:1332 Diversity-Real Property)",
      "28:1332sa" : "28:1332sa (28:1332 - Diversity: Securities & Exchange Commiss)",
      "28:1332sf" : "28:1332sf (28:1332 - Diversity: Securities Fraud)",
      "28:1332sh" : "28:1332sh (28:1332 Diversity-Sexual Harassment)",
      "28:1332ss" : "28:1332ss (28:1332 Diversity - Stockholders Suits)",
      "28:1332t" : "28:1332t (28:1332 Diversity-Torts)",
      "28:1332tl" : "28:1332tl (28:1332 Diversity-Torts to Land)",
      "28:1332tm" : "28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))",
      "28:1332tn" : "28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)",
      "28:1332ts" : "28:1332ts (28:1332 Diversity-Misappropriation of Trade Secrets)",
      "28:1332vt" : "28:1332vt (28:1332 Diversity-Natl Motor Vehicle Title Information System)",
      "28:1332wc" : "28:1332wc (28:1332 Diversity-Worker's Compensation Benefits)",
      "28:1332wd" : "28:1332wd (28:1332 Diversity-Wrongful Death)",
      "28:1333" : "28:1333 (28:1333 Admiralty)",
      "28:1333ad" : "28:1333ad (28:1333 Admiralty)",
      "28:1333in" : "28:1333in (28:1333 Personal Injury)",
      "28:1333mc" : "28:1333mc (28:1333 Marine Contract)",
      "28:1333pd" : "28:1333pd (28:1333 Property Damage)",
      "28:1333pi" : "28:1333pi (28:1333 Marine Personal Injury)",
      "28:1334" : "28:1334 (28:1334 Bankruptcy Appeal)",
      "28:1334(b)" : "28:1334(b) (28:1334(b) Proceeding arising/related to case under title 11)",
      "28:1334c" : "28:1334c (28:1334(c) R&R re motions for abstention (non-cor)",
      "28:1335" : "28:1335 (28:1335 Interpleader Action)",
      "28:1337" : "28:1337 (28:1337 Sherman-Clayton Act)",
      "28:1338cp" : "28:1338cp (28:1338 Copyright Infringement)",
      "28:1338pt" : "28:1338pt (28:1338 Patent Infringement)",
      "28:1338tr" : "28:1338tr (28:1338 Trademark Infringement)",
      "28:1339" : "28:1339 (28:1339 Postal matters)",
      "28:1340" : "28:1340 (28:1340 IRS: Custom Duties)",
      "28:1340er" : "28:1340er (28:1340 Recovery of Erroneous Refund)",
      "28:1340tp" : "28:1340tp (28:1340 Jurisdiction of Internal Revenue Matters; Customs Duties)",
      "28:1341" : "28:1341 (28:1341 Taxes by States)",
      "28:1343" : "28:1343 (28:1343 Violation of Civil Rights)",
      "28:1344" : "28:1344 (28:1344 Election disputes)",
      "28:1345" : "28:1345 (28:1345 U.S. Plaintiff)",
      "28:1345co" : "28:1345co (28:1345 Replevin & Conversion)",
      "28:1345db" : "28:1345db (28:1345 Debt to US - FHA/HUD Title I)",
      "28:1345df" : "28:1345df (28:1345 Default of Promissory Note)",
      "28:1345er" : "28:1345er (28:1345 Recovery of Erroneous Refund)",
      "28:1345fc" : "28:1345fc (28:1345 Foreclosure)",
      "28:1345ff" : "28:1345ff (28:1345 Complaint for Forfeiture)",
      "28:1345hl" : "28:1345hl (28:1345 VA Home Loan Guaranty Debt)",
      "28:1345lc" : "28:1345lc (28:1345 Land Condemnation)",
      "28:1345mc" : "28:1345mc (28:1345 Medical Care Recovery)",
      "28:1345mi" : "28:1345mi (28:1345 Mining Claim Ejectment)",
      "28:1345pd" : "28:1345pd (28:1345 Property Damage)",
      "28:1345pe" : "28:1345pe (28:1345 Property Ejectment)",
      "28:1345rc" : "28:1345rc (28:1345 Recovery of Debt to US)",
      "28:1345ro" : "28:1345ro (28:1345 Recovery of Retirement Overpayment)",
      "28:1345st" : "28:1345st (28:1345 Default of Student Loan)",
      "28:1345tp" : "28:1345tp (28:1345 Trespass on Public Land)",
      "28:1345tx" : "28:1345tx (28:1345 Prohibit dfts assessing tx on purch/use of pers prop)",
      "28:1345va" : "28:1345va (28:1345 Recovery of VA Overpayment)",
      "28:1346" : "28:1346 (28:1346 U.S. Defendant)",
      "28:1346bc" : "28:1346bc (28:1346 Breach of Contract)",
      "28:1346pi" : "28:1346pi (28:1346 Marine Personal Injury (or tort claim-personal injury/motor vehicle)",
      "28:1346rc" : "28:1346rc (28:1346 Recovery of IRS Tax)",
      "28:1346t" : "28:1346t (28:1346 Tort Claim)",
      "28:1346tc" : "28:1346tc (28:1346 Tort Claim)",
      "28:1346wd" : "28:1346wd (28:1346 Wrongful Death)",
      "28:1348" : "28:1348 (28:1348 Banking association as party)",
      "28:1349" : "28:1349 (28:1349 Corporation organized under Federal Law as party)",
      "28:1350" : "28:1350 (28:1350 Alien Tort Claims Act)",
      "28:1352" : "28:1352 (28:1352 Miller Act)",
      "28:1355" : "28:1355 (28:1355 Petition for Return of Property)",
      "28:1356" : "28:1356 (28:1356 Executory Process/Foreclosure)",
      "28:1358" : "28:1358 (28:1358 Land Condemnation)",
      "28:1361" : "28:1361 (28:1361 Petition for Writ of Mandamus)",
      "28:1361pr" : "28:1361pr (28:1361 Complaint for mandamus relief (prisoner))",
      "28:1362ic" : "28:1362ic (28:1362 Indian Tribal Controversy)",
      "28:1362iw" : "28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)",
      "28:1363" : "28:1363 (28:1363 Action for protection of jurors employment rights)",
      "28:1364" : "28:1364 (28:1364 Auto Negligence)",
      "28:1367" : "28:1367 (28:1367 Other Property Damage)",
      "28:1391" : "28:1391 (28:1391 Venue)",
      "28:1394" : "28:1394 (28:1394 Banking Assoc action agst Comptroller of Currency)",
      "28:1395" : "28:1395 (28:1395 Complaint for Forfeiture)",
      "28:1402" : "28:1402 (28:1402 US as Defendant)",
      "28:1403" : "28:1403 (28:1403 Condemnation of real estate for the use of the US)",
      "28:1407" : "28:1407 (28:1407 Airline Crash)",
      "28:1407im" : "28:1407im (28:1407 MDL: Silicone Gel Breast Implant Products Liability)",
      "28:1407md" : "28:1407md (28:1407 MDL: Multidistrict Litigation)",
      "28:1407n" : "28:1407n (28:1407 MDL: Personal Injury/Norplant Product Liability)",
      "28:1407pl" : "28:1407pl (28:1407 MDL: Products Liability)",
      "28:1441ac" : "28:1441ac (28:1441 Petition for Removal- Account Receivable)",
      "28:1441ada" : "28:1441ada (28:1441 Removal-Americans with Disabilities Act)",
      "28:1441ag" : "28:1441ag (28:1441 Removal-Civil Rights (Age))",
      "28:1441al" : "28:1441al (28:1441 Petition for Removal- Airline Crash)",
      "28:1441as" : "28:1441as (28:1441 Petition for Removal- Asbestos Litigation)",
      "28:1441au" : "28:1441au (28:1441 Petition for Removal- Auto Negligence)",
      "28:1441ba" : "28:1441ba (28:1441 Removal-National Bank Act)",
      "28:1441bc" : "28:1441bc (28:1441 Petition for Removal- Breach of Contract)",
      "28:1441bce" : "28:1441bce (28:1441 Removal-Employee Benefits)",
      "28:1441bfd" : "28:1441bfd (28:1441 Removal-Breach of Fiduciary Duties)",
      "28:1441ca" : "28:1441ca (28:1441 Removal-Carmack Amendment)",
      "28:1441cc" : "28:1441cc (28:1441 Removal-Computer Crimes Act)",
      "28:1441cj" : "28:1441cj (28:1441 Removal-Confessed Judgment)",
      "28:1441cla" : "28:1441cla (28:1441 Removal-Consumer Leasing Act)",
      "28:1441cp" : "28:1441cp (28:1441 Removal-Copyright)",
      "28:1441cpl" : "28:1441cpl (28:1441 Removal-Contract Product Liability)",
      "28:1441cra" : "28:1441cra (28:1441 Removal-Fair Credit Reporting Act)",
      "28:1441cv" : "28:1441cv (28:1441 Petition for Removal- Civil Rights Act)",
      "28:1441dea" : "28:1441dea (28:1441 Removal-Disabilities Education Act)",
      "28:1441df" : "28:1441df (28:1441 Petition for Removal- Contract Default)",
      "28:1441di" : "28:1441di (28:1441 Removal-Civil Rights (Disability Act))",
      "28:1441dj" : "28:1441dj (28:1441 Petition for Removal- Declaratory Judgemen)",
      "28:1441ds" : "28:1441ds (28:1441 Petition for Removal- Contract Dispute)",
      "28:1441ea" : "28:1441ea (28:1441 Removal-Employment Discrimination (Age))",
      "28:1441eb" : "28:1441eb (28:1441 Removal-E.R.I.S.A. Employee Benefits)",
      "28:1441ec" : "28:1441ec (28:1441 Removal-Electronic Comm. Privacy Act)",
      "28:1441ed" : "28:1441ed (28:1441 Petition for Removal - Employment Discrim)",
      "28:1441em" : "28:1441em (28:1441 Removal-Emergency Medical Treatment & Active Labor)",
      "28:1441er" : "28:1441er (28:1441 Removal-Employment Discrimination (Race))",
      "28:1441es" : "28:1441es (28:1441 Removal-Employment Discrimination (Sex))",
      "28:1441fa" : "28:1441fa (28:1441 Removal-Civil Rights - False Arrest)",
      "28:1441fc" : "28:1441fc (28:1441 Petition for Removal - Fair Credit Reporti)",
      "28:1441fd" : "28:1441fd (28:1441 Removal-Fair Debt Collection Practices Act)",
      "28:1441fe" : "28:1441fe (28:1441 Removal-Fed. Employee Garnishment Statute)",
      "28:1441fh" : "28:1441fh (28:1441 Removal-FEHBA)",
      "28:1441fif" : "28:1441fif (28:1441 Removal-Insecticide/Fungicide/Rodenticide Act-1942)",
      "28:1441fl" : "28:1441fl (28:1441 Removal-Fair Labor Standards Act)",
      "28:1441fm" : "28:1441fm (28:1441 Removal-Family and Medical Leave Act)",
      "28:1441fr" : "28:1441fr (28:1441 Petition for Removal- Fraud)",
      "28:1441fs" : "28:1441fs (28:1441 Removal-Foreign Sovereign Immunities Act)",
      "28:1441fsa" : "28:1441fsa (28:1441 Removal-Federal Food Stamp Act)",
      "28:1441hb" : "28:1441hb (28:1441 Removal-Petition of Habeas Corpus)",
      "28:1441hc" : "28:1441hc (28:1441 Removal-Handicapped Child Protection Act)",
      "28:1441hd" : "28:1441hd (28:1441 Removal-Housing Discrimination)",
      "28:1441ia" : "28:1441ia (28:1441 Removal-Interstate Commerce Act)",
      "28:1441if" : "28:1441if (28:1441 Removal-Insurance Fraud)",
      "28:1441ij" : "28:1441ij (28:1441 Petition for Removal- Injunctive/Declarato)",
      "28:1441il" : "28:1441il (28:1441 Removal-Interstate Land Full Discloser Act)",
      "28:1441in" : "28:1441in (28:1441 Petition for Removal- Insurance Contract)",
      "28:1441int" : "28:1441int (28:1441 Petition for Removal- Action for Interplea)",
      "28:1441la" : "28:1441la (28:1441 Removal-Truth in Lending Act)",
      "28:1441lb" : "28:1441lb (28:1441 Petition for Removal Libel,Assault,Slander)",
      "28:1441lm" : "28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relatio)",
      "28:1441ml" : "28:1441ml (28:1441 Removal-Motor Vehicle Prod Liability)",
      "28:1441mm" : "28:1441mm (28:1441 Petition for Removal- Medical Malpractice)",
      "28:1441mv" : "28:1441mv (28:1441 Removal-Motor Vehicle)",
      "28:1441ni" : "28:1441ni (28:1441 Petition for Removal- Negotiable Instrumen)",
      "28:1441nm" : "28:1441nm (28:1441 Petition for Removal- Non-Motor Vehicle)",
      "28:1441nr" : "28:1441nr (28:1441 Notice of Removal)",
      "28:1441oc" : "28:1441oc (28:1441 Petition For Removal--Other Contract)",
      "28:1441pa" : "28:1441pa (28:1441 Removal-Patent Infringement)",
      "28:1441pd" : "28:1441pd (28:1441 Petition for Removal- Property Damage)",
      "28:1441pi" : "28:1441pi (28:1441 Petition for Removal- Personal Injury)",
      "28:1441pl" : "28:1441pl (28:1441 Petition for Removal- Product Liability)",
      "28:1441pr" : "28:1441pr (28:1441 Petition for Removal)",
      "28:1441qt" : "28:1441qt (28:1441 Petition for Removal- Petition to Quiet Ti)",
      "28:1441ra" : "28:1441ra (28:1441 Removal-Civil Rights (Race))",
      "28:1441ri" : "28:1441ri (28:1441 Petition for Removal- Racketeering (RICO))",
      "28:1441rl" : "28:1441rl (28:1441 Removal-Rent, Lease, & Ejectment)",
      "28:1441sa" : "28:1441sa (28:1441 - Petition for Removal: SEC Act)",
      "28:1441sf" : "28:1441sf (28:1441 - Petition for Removal: Securities Fraud)",
      "28:1441sh" : "28:1441sh (28:1441 Removal-Sexual Harassment)",
      "28:1441st" : "28:1441st (28:1441 Removal-Stockholders Suit)",
      "28:1441sv" : "28:1441sv (28:1441 Removal-Security Violation)",
      "28:1441sx" : "28:1441sx (28:1441 Removal-Civil Rights (Sex))",
      "28:1441tc" : "28:1441tc (28:1441 Removal-Tricare Program)",
      "28:1441ti" : "28:1441ti (28:1441 Removal-Trademark Infringement)",
      "28:1441til" : "28:1441til (28:1441 Removal-Truth and Lending)",
      "28:1441tl" : "28:1441tl (28:1441 Petition for Removal- Torts to Land)",
      "28:1441tm" : "28:1441tm (28:1441 Petition for Removal- Tort/Motor Vehicle ()",
      "28:1441tn" : "28:1441tn (28:1441 Petition for Removal- Tort/Non-Motor Vehic)",
      "28:1441us" : "28:1441us (28:1441 Removal-Uniformed Svc Emp/Reemp Rights Act)",
      "28:1441wc" : "28:1441wc (28:1441 Removal-Worker's Compensation Benefits)",
      "28:1441wd" : "28:1441wd (28:1441 Petition for Removal- Wrongful Death)",
      "28:1441wt" : "28:1441wt (28:1441 Removal-Employment (Wrongful Termination))",
      "28:1442" : "28:1442 (28:1442 Notice of Removal-Suit against Federal Officer)",
      "28:1442aaf" : "28:1442aaf (28:1442 Petition for Removal-Agst members of armed forces)",
      "28:1442bc" : "28:1442bc (28:1442 Petition for Removal- Breach of Contract)",
      "28:1442pr" : "28:1442pr (28:1442 Petition for Removal)",
      "28:1443" : "28:1443 (28:1443(1) Rent, Lease & Ejectment)",
      "28:1443(1)" : "28:1443(1) (28:1443(1) Removal from State Court-Civil Rights: Rent, Lease, and Ejectment)",
      "28:1444" : "28:1444 (28:1444 Petition for Removal- Foreclosure)",
      "28:1446al" : "28:1446al (28:1446 Notice of Removal - Airline Crash)",
      "28:1446as" : "28:1446as (28:1446 Notice of Removal - Asbestos Litigation)",
      "28:1446bc" : "28:1446bc (28:1446 Notice of Removal - Breach of Contract)",
      "28:1446cs" : "28:1446cs (28:1446 Notice of Removal - Child Support Enforcement)",
      "28:1446dj" : "28:1446dj (28:1446 Notice of Removal - Declaratory Judgment)",
      "28:1446er" : "28:1446er (28:1446 Notice of Removal - E.R.I.S.A)",
      "28:1446fm" : "28:1446fm (28:1446 Notice of Removal - Family and Medical Leave Act)",
      "28:1446fr" : "28:1446fr (28:1446 Notice of Removal - Fraud)",
      "28:1446in" : "28:1446in (28:1446 Breach of Contract- Insurance)",
      "28:1446lb" : "28:1446lb (28:1446 Notice of Removal - Libel, Assault, Slander)",
      "28:1446ml" : "28:1446ml (28:1446 Notice of Removal - Motor Vehicle Prod Liability)",
      "28:1446mm" : "28:1446mm (28:1446 Notice of Removal - Medical Malpractice)",
      "28:1446mv" : "28:1446mv (28:1446 Notice of Removal - Motor Vehicle)",
      "28:1446ni" : "28:1446ni (28:1446 Notice of Removal - Negotiable Instrument)",
      "28:1446nr" : "28:1446nr (28:1446 Notice of Removal)",
      "28:1446oc" : "28:1446oc (28:1446 Notice of Removal - Other Contract)",
      "28:1446pd" : "28:1446pd (28:1446 Petition for Removal- Property Damage (P.I)",
      "28:1446pi" : "28:1446pi (28:1446 Petition for Removal- Personal Injury)",
      "28:1446pl" : "28:1446pl (28:1446pl Petition for Removal - Product Liability)",
      "28:1446pr" : "28:1446pr (28:1446 Petition for Removal)",
      "28:1446st" : "28:1446st (28:1446 Notice of Removal - Stockholders Suit)",
      "28:1446tl" : "28:1446tl (28:1446 Notice of Removal - Torts to Land)",
      "28:1446wd" : "28:1446wd (28:1446 Notice of Removal - Wrongful Death)",
      "28:1452" : "28:1452 (28:1452 Removal of Claims Related to Bankruptcy Cases)",
      "28:1453" : "28:1453 (28:1453 Class Action Fairness Act)",
      "28:1491" : "28:1491 (28:1491 Tucker Act)",
      "28:1602" : "28:1602 (28:1602 Foreign Sovereign Immunities Act)",
      "28:1605" : "28:1605 (28:1605 Foreign Sovereign Immunities Act of 1976)",
      "28:1605A" : "28:1605A (28:1605A Antiterrorism & Effective Death Penalty Act 1996)",
      "28:1610" : "28:1610 (28:1610 Juridictional Immunities of Foreign States)",
      "28:1631" : "28:1631 (28:1631 Case Transferred to Cure Want of Jurisdiction)",
      "28:1651" : "28:1651 (28:1651 Petition for Writ of Coram Nobis)",
      "28:1651cn" : "28:1651cn (28:1651 Petition for Writ of Error Coram Nobis)",
      "28:1651hc" : "28:1651hc (28:1651 Petition for Writ of Habeas Corpus)",
      "28:1651mn" : "28:1651mn (28:1651 Petition for Writ of Mandamus)",
      "28:1651ne" : "28:1651ne (28:1651 Application for Writ Ne Exeat)",
      "28:1651w" : "28:1651w (28:1651 All Writs Act)",
      "28:1715" : "28:1715 (28:1715 Class Action Fairness Act of 2005)",
      "28:1732" : "28:1732 (28:1732 Reproduction of Records)",
      "28:1738Acs" : "28:1738Acs (28:1738 The Uniform Child Custody Jurisdiction Act)",
      "28:1782" : "28:1782 (28:1782 Assistance to Foreign Tribunals (incl letter rogatory))",
      "28:1783" : "28:1783 (28:1783 Petition for Subpoena of person in foreign country)",
      "28:1826" : "28:1826 (28:1826 Order of confinement of recalcitrant witness)",
      "28:1875" : "28:1875 (28:1875 Juror Protection Act / Protection of Juror's Employment)",
      "28:1916" : "28:1916 (28:1916 Marine Personal Injury)",
      "28:1963" : "28:1963 (28:1963 Registration of judgment from another district)",
      "28:1983" : "28:1983 (28:1983 Civil Rights)",
      "28:2001" : "28:2001 (28:2001 Judicial Sale of Realty)",
      "28:2071" : "28:2071 (28:2071 Rule Making Power Generally)",
      "28:2201" : "28:2201 (28:2201 Creation of a Remedy - Declaration of Rights)",
      "28:2201an" : "28:2201an (28:2201 Declaratory Judgment (aliens and nationality))",
      "28:2201cp" : "28:2201cp (28:2201 Declaratory Judgment (Copyright))",
      "28:2201dj" : "28:2201dj (28:2201 Declaratory Judgement)",
      "28:2201fa" : "28:2201fa (28:2201 Declaratory Judgment (Firearms))",
      "28:2201fs" : "28:2201fs (28:2201 Declaratory Judgment (Food Security Act))",
      "28:2201ij" : "28:2201ij (28:2201 Injunction)",
      "28:2201in" : "28:2201in (28:2201 Declaratory Judgement (Insurance))",
      "28:2201pi" : "28:2201pi (28:2201 Declaratory Judgment (Personal Injury))",
      "28:2241" : "28:2241 (28:2241 Petition for Writ of Habeas Corpus (federa)",
      "28:2241fd" : "28:2241fd (28:2241 Petition for Writ of Habeas Corpus (Federal))",
      "28:2241in" : "28:2241in (28:2241 Habeas Corpus: INS)",
      "28:2241st" : "28:2241st (28:2241 Petition for Writ of Habeas Corpus (State))",
      "28:2244" : "28:2244 (28:2244 Habeas Corpus - Finality of Determination)",
      "28:2254" : "28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))",
      "28:2254dp" : "28:2254dp (28:2254 Petition for Writ of Habeas Corpus (Death Penalty))",
      "28:2254se" : "28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)",
      "28:2255" : "28:2255 (28:2255 Motion to Vacate / Correct Illegal Sentenc)",
      "28:2271" : "28:2271 (28:2271 Federal Tort Claims Act)",
      "28:2283" : "28:2283 (28:2283 Stay of State Court Proceedings (Injunctive Relief))",
      "28:2345" : "28:2345 (28:2345 Medicare Recovery)",
      "28:2347" : "28:2347 (28:2347 Petition to Review Orders in the Ct of Appeals)",
      "28:2401" : "28:2401 (28:2401 Federal Tort Claims Act (Time for commencing action against the US))",
      "28:2403" : "28:2403 (28:2403 Constitutionality of State Statute(s))",
      "28:2405" : "28:2405 (28:2405 Garnishment of debtors of a corporation by US)",
      "28:2409" : "28:2409 (28:2409(a) Quiet Title Action)",
      "28:2410" : "28:2410 (28:2410 Quiet Title - Actions affecting property on which United States has lien)",
      "28:2412" : "28:2412 (28:2412 Equal Access to Justice Act)",
      "28:2415" : "28:2415 (28:2415 Detinue and Conversion)",
      "28:2671" : "28:2671 (28:2671 Federal Tort Claims Act (Definitions))",
      "28:2672mv" : "28:2672mv (28:2672 Federal Tort Claims Act - Motor Vehicle)",
      "28:2672pi" : "28:2672pi (28:2672 Federal Tort Claims Act - Personal Injury)",
      "28:2674" : "28:2674 (28:2674 Federal Tort Claims Act - Liability of US)",
      "28:2675" : "28:2675 (28:2675 Federal Tort Claims Act - Disposition by Agency Req)",
      "28:2679(d)" : "28:2679(d) (28:2679(d)(2) Federal Tort Claims Act - Employee of U.S.A.)",
      "28:2680" : "28:2680 (28:2680 Federal Tort Claims Act - Exceptions)",
      "28:3001" : "28:3001 (28:3001 Federal Debt Collection Act)",
      "28:3001(a)" : "28:3001(a) (28:3001(a) Federal Debt Collection Procedures Act of 1990)",
      "28:3203" : "28:3203 (28:3203 Postjudgment Remedies: Writ of Execution)",
      "28:3301" : "28:3301 (28:3301 Fraudulent Transfer Federal Debt Collection Procedures Act)",
      "28:7402" : "28:7402 (28:7402 Refund of Taxes)",
      "28:7422" : "28:7422 (28:7422 Appeal from Administrative Decision)",
      "29:0101" : "29:0101 (29:101 Labor: Issuance of Restraining Orders and Injunctions)",
      "29:0151" : "29:0151 (29:151 Labor: National Labor Relations Act (NLRA))",
      "29:0160" : "29:0160 (29:160 Labor: NLRA - Prevention of Unfair Labor Practices)",
      "29:0160(i)" : "29:0160(i) (29:160(i) Labor: Petition for Inj re Uncertified Labor Organizations)",
      "29:0160(j)" : "29:0160(j) (29:160(j) Labor: Petition for Inj - Relief from Unfair Labor Practice)",
      "29:0161(2)" : "29:0161(2) (29:161(2) Labor: Enforcement of agency subpoena)",
      "29:0178" : "29:0178 (29:178 Labor: Petiton for Inj to Enjoin Strike duing Natl Emergency)",
      "29:0184" : "29:0184 (29:184 Violation Collection Bargain Agreement)",
      "29:0185" : "29:0185 (29:185 Labor: Suits by and against Labor Organizations)",
      "29:0185ep" : "29:0185ep (29:185 Employee Pension Plan)",
      "29:0185lm" : "29:0185lm (29:185 Labor/Mgt. Relations (Contracts))",
      "29:0186" : "29:0186 (29:186 Labor: Liabilities of and Restrictions on Labor and Management)",
      "29:0187" : "29:0187 (29:187 Labor: Recover Damages from Unfair Labor Practice)",
      "29:0201do" : "29:0201do (29:201 Denial of Overtime Compensation)",
      "29:0201fl" : "29:0201fl (29:201 Fair Labor Standards Act)",
      "29:0203" : "29:0203 (29:203 FLSA: Definitions)",
      "29:0206" : "29:0206 (29:206 FLSA: Minimum Wage)",
      "29:0206(d)" : "29:0206(d) (29:206(d) FLSA: Prohibition of Sex Discrimination)",
      "29:0207(a)" : "29:0207(a) (29:207(a) FLSA: Action for Overtime Wage Violation)",
      "29:0207fl" : "29:0207fl (29:207fl FLSA: Maximum Hours)",
      "29:0210" : "29:0210 (29:210 FLSA: Court Review of Wage Orders in PR and VI)",
      "29:0215fl" : "29:0215fl (29:215fl FLSA: Prohibited Acts)",
      "29:0216(b)" : "29:0216(b) (29:216(b) FLSA: Minimum wage or overtime compensation)",
      "29:0216(e)" : "29:0216(e) (29:216(e) FLSA: Penalty assessed for child labor provision)",
      "29:0217" : "29:0217 (29:217 FLSA: Enjoin Violations of Fair Labor Standards Act)",
      "29:0260" : "29:0260 (29:260 FLSA: Liquidated Damages)",
      "29:0401" : "29:0401 (29:401 Labor Management Disclosure Act)",
      "29:0411" : "29:0411 (29:411 Landrum Griffin Act)",
      "29:0412" : "29:0412 (29:412 Infringement of rights; members of labor organization)",
      "29:0440" : "29:0440 (29:440 violations reporting requirements; labor organization)",
      "29:0501(b)" : "29:0501(b) (29:501(b) Violation of Fiduciary Responsibility)",
      "29:0621" : "29:0621 (29:621 Job Discrimination (Age))",
      "29:0623" : "29:0623 (29:623 Job Discrimination (Prohibition of Age Discrimination))",
      "29:0626" : "29:0626 (29:626 Job Discrimination (Investigation and Enforcement))",
      "29:0633" : "29:0633 (29:633 Job Discrimination (Age - Federal - State Relationship))",
      "29:0651" : "29:0651 (29:651 Occupational Safety/Health)",
      "29:0660" : "29:0660 (29:660 Action by Sec Labor for discrimination re rights OSHA)",
      "29:0662" : "29:0662 (29:662 Inj proceedings re dangerous emp conditions; by Sec.)",
      "29:0666" : "29:0666 (29:666 Collection of civil penalties under OSHA)",
      "29:0701" : "29:0701 (29:701 Vocational Rehabilitation)",
      "29:0754" : "29:0754 (29:754 Discrimination)",
      "29:0791" : "29:0791 (29:791 Job Discrimination (Rehabilitation Act))",
      "29:0792(d)" : "29:0792(d) (29:792(d)(2) Accessible facilities for phys. handicapped emp)",
      "29:0794" : "29:0794 (29:794 Job Discrimination (Handicap))",
      "29:1001" : "29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)",
      "29:1002" : "29:1002 (29:1002 E.R.I.S.A.: Employee Retirement (Definitions))",
      "29:1055" : "29:1055 (29:1055 E.R.I.S.A.: Employee Retirement (Joint and Survivor Annuity))",
      "29:1101" : "29:1101 (29:1101 E.R.I.S.A.: Coverage)",
      "29:1104" : "29:1104 (29:1104 E.R.I.S.A.: Recovery of Benefits to Employee)",
      "29:1109" : "29:1109 (29:1109 E.R.I.S.A.: Breach of Fiduciary Duties)",
      "29:1131" : "29:1131 (29:1131 ERISA - Collection of Delinquent Trust Fun)",
      "29:1132" : "29:1132 (29:1132 E.R.I.S.A.: Civil Enforcement of Employee Benefits)",
      "29:1145" : "29:1145 (29:1145 E.R.I.S.A.: Delinquent Contributions)",
      "29:1149" : "29:1149 (29:1149 E.R.I.S.A.: Prohibition on False Statements and Representations)",
      "29:1161" : "29:1161 (29:1161 COBRA - Continuation Coverage)",
      "29:1162" : "29:1162 (29:1162 COBRA - Continuation Coverage)",
      "29:1303" : "29:1303 (29:1303 PBGC: Operation of Corporation)",
      "29:1337" : "29:1337 (29:1337 E.R.I.S.A.)",
      "29:1362" : "29:1362 (29:1362 E.R.I.S.A.: Liability for Termination of Single Employer Plans)",
      "29:1381" : "29:1381 (29:1381 E.R.I.S.A.: WIthdrawal Liability)",
      "29:1401" : "29:1401 (29:1401(b)(2) Appeal of Arbitration Award)",
      "29:1401(b)" : "29:1401(b) (29:1401(b)(2) E.R.I.S.A.: Resolution of Disputes - Appeal of Arbitration Award)",
      "29:1451" : "29:1451 (29:1451 E.R.I.S.A.: Enforcement - Civil Actions)",
      "29:158(b)" : "29:158(b) (29:158(b) Labor: NLRA - Unfair Labor Practices)",
      "29:159" : "29:159 (29:159 Labor: Violation of Collective Bargaining Agreement)",
      "29:1801" : "29:1801 (29:1801 Farmworker Rights)",
      "29:1854" : "29:1854 (29:1854 Migrant & Seasonal Agri Worker Protect Act (AWPA))",
      "29:1916" : "29:1916 (29:1916 Spec. Rule for Longshoremen & Harborworkers)",
      "29:2001" : "29:2001 (29:2001 Employee Polygraph Protection Act)",
      "29:2101" : "29:2101 (29:2101 Worker Adjustment and Retraining Notification Act)",
      "29:2102" : "29:2102 (29:2102 Notice required before plant closings & mass layoffs)",
      "29:2104" : "29:2104 (29:2104 Worker Adjustment & Retraining Notification (WARN))",
      "29:2601" : "29:2601 (29:2601 FMLA: Family and Medical Leave Act (Findings and Purposes))",
      "29:2611" : "29:2611 (29:2611 FMLA: Definitions)",
      "29:2612" : "29:2612 (29:2612 FMLA: Leave Requirements)",
      "29:2617" : "29:2617 (29:2617 FMLA: Enforcement)",
      "29:790" : "29:790 (29:790 Rehabilitation of Labor)",
      "2:138" : "2:138 (Library of Congress Access)",
      "30:0022" : "30:0022 (30:22 General Mining Law of 1872 (Lands Open to Purchase by Citizens))",
      "30:0181" : "30:0181 (30:0181 Land subject to disposition; presons entitled to benefits; reciprocal privileges)",
      "30:0801" : "30:0801 (30:801 Penalties/Federal Mine Safety Health Act)",
      "30:0815" : "30:0815 (30:815 Federal Mine Safety & Health Act (Procedure for Enforcement))",
      "30:1201" : "30:1201 (30:1201 Environment: Review of Agency Action (Congressional Findings))",
      "30:1202" : "30:1202 (30:1202 Mining Reclamation Act (Statement of Purpose))",
      "30:1276" : "30:1276 (30:1276 Interior: Judicial Review of Agency Action)",
      "30:1701" : "30:1701 (30:1701 Federal Oil Gas Royalty Mgt Act 1983 (FOGRMA))",
      "31:0732" : "31:0732 (31:732 General Acct. Office Personnel Act of 1980 (Personnel Management System))",
      "31:1341" : "31:1341 (31:1341 Government employee--limitations on expending monies)",
      "31:3545" : "31:3545 (31:3545 Action to Recovery Money)",
      "31:3702" : "31:3702 (31:3702 Procedures for Settling Claims)",
      "31:3713" : "31:3713 (31:3713 Priority of Government Claims)",
      "31:3720" : "31:3720 (31:3720 Federal Income Tax Interceptions (Collection of Payments))",
      "31:3728" : "31:3728 (31:3728 Setoff against Judgment)",
      "31:3729" : "31:3729 (31:3729 False Claims Act)",
      "31:3730" : "31:3730 (31:3730 Qui Tam False Claims Act)",
      "31:3731" : "31:3731 (31:3731 False Claims Act - Procedures)",
      "31:3733(j)" : "31:3733(j) (31:3733(j)(2) Pet to Mod or Set Aside CV Investigative Demand)",
      "31:5314" : "31:5314 (31:5314 Failure to Report Interest in Foreign Accounts)",
      "31:5317" : "31:5317 (31:5317 Search and forfeiture of monetary instruments)",
      "31:5320" : "31:5320 (31:5320 Inj proceedings re Rpts of Currency & Foreign Trans.)",
      "31:5321" : "31:5321 (31:5321 Civil Penalties re Reports of Currency and Foreign Transaction)",
      "31:5324" : "31:5324 (31:5324 Structuring transactions to evade reporting requirement prohibited)",
      "31:5332" : "31:5332 (31:5332(a) Evading Currency Reporting Requirement)",
      "31:5332(f)" : "31:5332(f) (31:5332(f) Transport and Transfer US currency from in to out)",
      "31:6716" : "31:6716 (31:6716 Discrimination re money and finance)",
      "31:9701" : "31:9701 (31:9701 Federal User Charge Statute)",
      "33:0408" : "33:0408 (33:408 Injury to Harbor Improvement)",
      "33:0412" : "33:0412 (33:412 Liability of Pilots and Vessels Engaged in Violations)",
      "33:0594" : "33:0594 (33:594 Land Condemnation)",
      "33:0901" : "33:0901 (33:901 Longshoremen Harbor Workers Compensation Act (Navigation and Navigable Waters))",
      "33:0905(b)" : "33:0905(b) (33:905(b) Longshoremen Workers' Compensation Act - Recovery of Damages cause by the negligence )",
      "33:0918" : "33:0918 (33:918 Longshore and Harbor Workers Compensation Act - Collection of Defaulted Payments)",
      "33:0921" : "33:0921 (33:921 Longshore & Harbor Workers Compensation Act - Review of Compensation Orders)",
      "33:0933" : "33:0933 (33:933 Longshore and Harbor Workers' Compensation Act - Compensation for Injuries (Third-Party )",
      "33:1221" : "33:1221 (33:1221 Ports and Waterways Safety Program)",
      "33:1251" : "33:1251 (33:1251 Federal Water Pollution Control Act (Clean Water Act))",
      "33:1319(a)" : "33:1319(a) (33:1319(a)(2)pv Clean Water Act - Pollutants & Permit Violations)",
      "33:1319cw" : "33:1319cw (33:1319cw Clean Water Act - Enforcement)",
      "33:1319pv" : "33:1319pv (33:1319 Pollutants & Permit Violations)",
      "33:1321" : "33:1321 (33:1321 Clean Water Act - Discharge of hazardous substance or pollutants/water)",
      "33:1361" : "33:1361 (33:1361 Clean Water Act - Administrator Authority)",
      "33:1364" : "33:1364 (33:1364 Clean Water Act - EPA action to restrain pollution endangering health (emergency powers))",
      "33:1365" : "33:1365 (33:1365 Clean Water Act - CItizen Suits re Environmental Matters)",
      "33:1415" : "33:1415 (33:1415 Marine Protection, Research, and Sanctuaries Act)",
      "33:1515" : "33:1515 (33:1515 Deepwater Ports Act (citizen civil action))",
      "33:2701" : "33:2701 (33:2701 Oil Pollution Act of 1940)",
      "35:0001" : "35:0001 (35:1 Establishment of PTO)",
      "35:0032" : "35:0032 (35:0032 Suspension from Practice before Patent & Trade. Off.)",
      "35:0145" : "35:0145 (35:145 Civil Action to Obtain Patent)",
      "35:0146" : "35:0146 (35:146 Appeal from Decision of the Board of Patent Appeals)",
      "35:0183" : "35:0183 (35:183 Patent Infringement)",
      "35:0256" : "35:0256 (35:256 Patent Non-Infringement (Correction of Named Inventor))",
      "35:0271" : "35:0271 (35:271 Patent Infringement)",
      "35:0281" : "35:0281 (35:281 Remedy for Infringement of Patent/jurisdiction conferred 28:1338)",
      "35:0282" : "35:0282 (35:282 Patent Infringement - Defenses)",
      "35:0283" : "35:0283 (35:283 Action to enjoin violation of right secured by patent)",
      "35:0289" : "35:0289 (35:289 Recover profits from unlicensed use of design patent)",
      "35:0291" : "35:0291 (35:291 Action for relief between owners; interferring patents)",
      "35:0292" : "35:0292 (35:292 Penalty & Forfeiture; illegal use of word patent (false marking))",
      "35:0311" : "35:0311 (35:311 Patent - Request for Inter Partes Reexamination)",
      "35:183" : "35:183 (35:183 Right to Compensation - Patent Laws)",
      "38:1100" : "38:1100 (38:1100 Basic Entitlements / Wartime)",
      "38:1131" : "38:1131 (38:1131 Basic Entitlements / Peacetime)",
      "38:1681" : "38:1681 (38:1681 Recovery of VA Overpayment)",
      "38:1686" : "38:1686 (38:1686 Recovery of VA Overpayment)",
      "38:1780" : "38:1780 (38:1780 Recovery of VA Overpayment)",
      "38:1816" : "38:1816 (38:1816 Deficiency balance on VA Mortgage Foreclosure (Regulations Governing the VA Loan Guaranty Pr)",
      "38:1965" : "38:1965 (38:1965 Servicemen's Group Life Insurance (Definitions))",
      "38:1975" : "38:1975 (38:1975 Recovery of Servicemen's Group Life Insurance - Jurisdiction of District Court)",
      "38:1984" : "38:1984 (38:1984 Suit for Veterans Insurance)",
      "38:2011" : "38:2011 (38:2011 - Veteran's Readjustment Assistance Act of)",
      "38:3116" : "38:3116 (38:3116 VA Overpayment)",
      "38:3481" : "38:3481 (38:3481 Recovery of VA Overpayment)",
      "38:3680" : "38:3680 (38:3680 Recovery of Education Assist Allowance Overpayment)",
      "38:4212" : "38:4212 (38:4212 Veterans Employment Emphasis Under Federal Contracts)",
      "38:4300" : "38:4300 (38:4300 Uniformed Services Employment and Reemployment Act )",
      "38:4301" : "38:4301 (38:4301 Uniformed Srvs. Employment & Reemployment Rights Act (purpose))",
      "38:4302" : "38:4302 (38:4302 Veterans Reemployment Rights Act (relation to other laws and plans or agreements))",
      "38:4311" : "38:4311 (38:4311 Uniformed Service Employment or Reemployment Rights Act (USERRA) - Discrimination)",
      "38:4312" : "38:4312 (38:4312 Rights of inducted persons to reemployment)",
      "38:4323" : "38:4323 (38:4323 USERAA - Enforcement of rights with respect to state or private employer)",
      "38:4324" : "38:4324 (38:4324 USERRA - Enforcement of rights with respect to federal executive agencies)",
      "38:5315" : "38:5315 (38:5315 Delinquent Payment of Amounts Due to US)",
      "38:5316" : "38:5316 (38:5316 VA Overpayment)",
      "39:0403" : "39:0403 (39:0403 Discriminatory use of the Postal Service)",
      "39:0409" : "39:0409 (39:0409 Suits by and against the Postal Service)",
      "39:1207" : "39:1207 (39:1207 Review Agency Action --Labor Disputes)",
      "39:1208(b)" : "39:1208(b) (39:1208(b) Postal Reorganization Act of 1970 - Suits)",
      "39:3005" : "39:3005 (39:3005 False Representation and Lotteries)",
      "39:3007" : "39:3007 (39:3007 Detention of Mail for Temporary Periods - Injunction directing retention of incoming mail)",
      "39:3008(e)" : "39:3008(e) (39:3008(e) Enforce compliance with a USPS Prohibitory Order)",
      "39:409" : "39:409 (39:409 Postal Service)",
      "40:0258" : "40:0258 (40:258(a) Public Buildings & Property: Land Condem)",
      "40:0270" : "40:0270 (40:270 Miller Act)",
      "40:0581" : "40:0581 (40:581 General Authority of Administrator of General Services)",
      "40:0875" : "40:0875 (40:875 Public Buildings & Property: Negligence)",
      "40:1101" : "40:1101 (40:1101 Brooks Architecht - Engineers Act)",
      "40:3131" : "40:3131 (40:3131 Bonds of contractors of public buildings)",
      "40:3142" : "40:3142 (40:3142 Davis-Bacon Act (prevailing wages))",
      "41:0251" : "41:0251 (41:251 Public Contracts-Review of Agency Action)",
      "41:1463" : "41:1463 (41:1463 Public Contracts: Unlawful Employment Prac)",
      "41:2102-21" : "41:2102-21 (41:2102-2107 Procurement Integrity Act)",
      "41:3301" : "41:3301 (41:3301 Competition in Contracting Act)",
      "41:6503" : "41:6503 (41:6503 Walsh-Healy Act - Breach of Public Contract)",
      "41:6702" : "41:6702 (41:6702-6704 Service Contract Labor Standards/McNamara-O\"Hara Service Contract Act 1965)",
      "41:6702-67" : "41:6702-67 (41:6702-6704)",
      "41:7105(f)" : "41:7105(f) (41:7105(f) Action to Judicially Enforce Administrative Subpoena)",
      "42:0205" : "42:0205 (42:205 Appointment of Surgeon General)",
      "42:0206" : "42:0206 (42:206 Surgeon General - Assignment of Officers)",
      "42:0247" : "42:0247 (42:247 Personal Injury-Swine Flu)",
      "42:0254o" : "42:0254o (42:254 Breach of Scholarship Contract)",
      "42:0256" : "42:0256 (42:256 Public Health Services Act - Grants)",
      "42:0292f" : "42:0292f (42:292 Default of borrower)",
      "42:0292k" : "42:0292k (42:292 Student loan insurance (Public Health Occupations))",
      "42:0293" : "42:0293 (42:293 Recovery of losses from loan guarantee; public health)",
      "42:0297" : "42:0297 (42:297 Student loans; public or nonprofit school of nursing)",
      "42:0300aa" : "42:0300aa (42:0300 Nat'l Childhood Vaccine Injury Compensation Act)",
      "42:0300f" : "42:0300f (42:300 Safe Drinking Water Act (Definitions))",
      "42:0300g" : "42:0300g (42:300 Actions re safety of public water systems (EPA))",
      "42:0300g-3" : "42:0300g-3 (42:300 Enforcement of Drinking Water Regulations)",
      "42:0401" : "42:0401 (42:401 Social Security Act - Trust Funds)",
      "42:0402" : "42:0402 (42:402 Social Security Benefits)",
      "42:0405id" : "42:0405id (42:405 Review of HHS Decision (SSID))",
      "42:0405rs" : "42:0405rs (42:405 Review of HHS Decision (RSI))",
      "42:0405wc" : "42:0405wc (42:405 Review of HHS Decision (DIWC))",
      "42:0405ww" : "42:0405ww (42:405 Review of HHS Decision (DIWW))",
      "42:0416" : "42:0416 (42:416 Denial of Social Security Benefits)",
      "42:0421(d)" : "42:0421(d) (42:421(d) Review of HHS Decision re disability determinations)",
      "42:0423" : "42:0423 (42:423 Social Security Act (Disability Insurance Benefit Payments))",
      "42:0427" : "42:0427 (42:427 Social Security Benefits (Transitional Insured Status))",
      "42:0601" : "42:0601 (42:601 Title IV-A of the Social Security Act-Grants to States for Aid & Assistance to Needy Families)",
      "42:0602" : "42:0602 (42:602 Temp. Assistance for Needy Families (TANF))",
      "42:0660" : "42:0660 (42:660 Action to enforce child support obligations)",
      "42:10139" : "42:10139 (42:10139 Judicial Review of Agency Actions)",
      "42:10801" : "42:10801 (42:10801 Protection & Advocacy for Individuals with Mental Illness Act of 1986 (PAIMI))",
      "42:10805" : "42:10805 (42:10805 Protection and Advocacy Systems)",
      "42:11001" : "42:11001 (42:11001 Emergency Plan. & Comm. Right to Know Act (EPCRA))",
      "42:11046" : "42:11046 (42:11046 Fed Emer Plan Comm Right to Know Act (EPCRA) - Civil actions)",
      "42:11101" : "42:11101 (42:11101 Health Care Quality Improvement Act of 1986)",
      "42:11112" : "42:11112 (42:11112 Health Care Quality Improvement Act (Standards for Professional Review Actions))",
      "42:11601" : "42:11601 (International Child Abduction Remedies Act)",
      "42:11603" : "42:11603 (42:11603(b) Int'l. Child Abduction Remedies Act (ICARA) - Judicial Remedies)",
      "42:1210" : "42:1210 (42:12100 Americans With Disabilities Act )",
      "42:12101" : "42:12101 (42:12101 The Americans with Disabilities Act of 1990)",
      "42:12102" : "42:12102 (42:12102 Americans with Disabilities Act (ADA) Disability Definition)",
      "42:12111" : "42:12111 (42:12111 Americans with Disabilities Act - Employment)",
      "42:12112" : "42:12112 (42:12112 Americans with Disabilities Act - Employment Discrimination)",
      "42:12117" : "42:12117 (42:12117 Americans with Disabilities Act - Enforcement)",
      "42:12132" : "42:12132 (42:12132 Americans with Disabilities Act - Discrimination)",
      "42:12188" : "42:12188 (42:12188 Americans with Disabilities Act - Civil Enforcement Actions)",
      "42:1320a-7" : "42:1320a-7 (42:1320(b)(2)(A) Anti-Kickback Act (for federal health care programs))",
      "42:1320d-2" : "42:1320d-2 (42:1320 Health Insurance Portability And Accountability Act (HIPAA))",
      "42:1381a" : "42:1381a (42:1381 Supplemental Security Income Benefits (SSID))",
      "42:1382" : "42:1382 (42:1382 Eligibility for benefits)",
      "42:1383" : "42:1383 (42:1383 Review of HHS Decision)",
      "42:1395" : "42:1395 (42:1395 Emergency Medical Treatment and Active Labor Act)",
      "42:1395dd" : "42:1395dd (42:1395 Exam & Treatment Emergency Med Cond & Women in Labor)",
      "42:1395hr" : "42:1395hr (42:1395 Hospital Reimbursement for Medicare Services)",
      "42:1395w" : "42:1395w (42:1395 Medicare Act (Eligibility, Election, and Enrollment))",
      "42:1396" : "42:1396 (42:1396 - Tort Negligence)",
      "42:1396a" : "42:1396a (42:1396 State Plans for Medical Assistance)",
      "42:1396b" : "42:1396b (42:1396 Medical Assist Prgm, Pmt to States/Medicaid Implem)",
      "42:13981" : "42:13981 (42:13981 Violence Against Women Act )",
      "42:14135" : "42:14135 (42:14135 DNA Backlog Grant Program)",
      "42:1437" : "42:1437 (42:1437 U.S. Housing Act of 1937)",
      "42:1471" : "42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclo)",
      "42:1475" : "42:1475 (42:1475 Declaratory & Injunctive Relief - Foreclosure Procedures)",
      "42:1479" : "42:1479 (42:1479 Mortgage, lease, contract re farm housing)",
      "42:14901" : "42:14901 (42:14901 Intercountry Adoptions)",
      "42:15483" : "42:15483 (42:15483 Help America Vote Act)",
      "42:1651" : "42:1651 (42:1651 Defense Base Act)",
      "42:1705" : "42:1705 (42:1705 Receipt of Workmen's Compensation Benefits)",
      "42:1971" : "42:1971 (42:1971 Voting Rights Law)",
      "42:1973" : "42:1973 (42:1973 Voting Rights Act)",
      "42:1973(a)" : "42:1973(a) (42:1973(a) Enforcement of Voting Rights)",
      "42:1973(c)" : "42:1973(c) (42:1973(c) Voting Rights - Qualifications & Procedures)",
      "42:1973gg" : "42:1973gg (42:1973 Nat'l. Voter Registration Act of 1993 (NVRA))",
      "42:1981a" : "42:1981a (42:1981 Damages in cases of intentional discrim in employment)",
      "42:1981cv" : "42:1981cv (42:1981 Civil Rights)",
      "42:1981hs" : "42:1981hs (42:1981 Housing Discrimination)",
      "42:1981jb" : "42:1981jb (42:1981 Job Discrimination (Race))",
      "42:1981ra" : "42:1981ra (42:1981 Race Discrimination)",
      "42:1981sx" : "42:1981sx (42:1981 Sex Discrimination)",
      "42:1982hs" : "42:1982hs (42:1982 Discrimination re property rights (housing))",
      "42:1982ra" : "42:1982ra (42:1982 Discrimination re property rights (race))",
      "42:1982sx" : "42:1982sx (42:1982 Discrimination re property rights (sex))",
      "42:1983bv" : "42:1983bv (42:1983 Bivens Non-Prisoner)",
      "42:1983cv" : "42:1983cv (42:1983 Civil Rights Act - Civil Action for Deprivation of Rights)",
      "42:1983cvp" : "42:1983cvp (42:1983 Civil Rights (Personal Property))",
      "42:1983d" : "42:1983d (42:1983 Civil Rights (Death))",
      "42:1983dp" : "42:1983dp (42:1983 Civil Rights Denial of Due Process)",
      "42:1983ed" : "42:1983ed (42:1983 Civil Rights (Employment Discrimination))",
      "42:1983pr" : "42:1983pr (42:1983 Prisoner Civil Rights)",
      "42:1983vp" : "42:1983vp (42:1983 Violation of Due Process and Equal Protection)",
      "42:1985" : "42:1985 (42:1985 Consipracy to interfere with civil rights)",
      "42:1986" : "42:1986 (42:1986 Neglect of Duty)",
      "42:1987" : "42:1987 (42:1987 Prosecutionof violations of certain laws (violations of sec 1990, 5506, 5516, 5518, 5532))",
      "42:1988" : "42:1988 (42:1988 Proceedings in Vindication of Civil Rights)",
      "42:1997" : "42:1997 (42:1997 Institutionalized Persons Act of 1980)",
      "42:20002sx" : "42:20002sx (42:2000e-2sx)",
      "42:2000a-3" : "42:2000a-3 (42:2000 Discrimination, segregation; public accommodation-Injunctive Relief)",
      "42:2000ad" : "42:2000ad (42:2000 Job Discrimination (Disability Act))",
      "42:2000ag" : "42:2000ag (42:2000 Job Discrimination (Age))",
      "42:2000bb" : "42:2000bb (42:2000 Religious Freedom Restoration Act of 1993)",
      "42:2000bea" : "42:2000bea (42:2000 Equal access to public facilities)",
      "42:2000c-6" : "42:2000c-6 (42:2000 Discrimination in Education)",
      "42:2000cc" : "42:2000cc (42:2000 Religious Land Use & Institutionalized Persons Act of 2000)",
      "42:2000d" : "42:2000d (42:2000 Federally Assisted Programs)",
      "42:2000e" : "42:2000e (42:2000e Job Discrimination (Employment))",
      "42:2000e-2" : "42:2000e-2 (42:2000 Job Discrimination (Age))",
      "42:2000e-5" : "42:2000e-5 (42:2000 Petition to Enforce EEOC Subpoena)",
      "42:2000e2a" : "42:2000e2a (42:2000e-2ag)",
      "42:2000e2e" : "42:2000e2e (42:2000e-2e)",
      "42:2000e2n" : "42:2000e2n (42:2000e-2no)",
      "42:2000e2o" : "42:2000e2o (42:2000e-2ot)",
      "42:2000e2p" : "42:2000e2p (42:2000e-2pb)",
      "42:2000e2r" : "42:2000e2r (42:2000e-2ra)",
      "42:2000e2s" : "42:2000e2s (42:2000e-2sh)",
      "42:2000erl" : "42:2000erl (42:2000e-2rl)",
      "42:2000pb" : "42:2000pb (42:2000 Job Discrimination (Public Accomodations))",
      "42:2000ra" : "42:2000ra (42:2000 Job Discrimination (Race))",
      "42:2000sx" : "42:2000sx (42:2000 Job Discrimination (Sex))",
      "42:2003" : "42:2003 (42:2003 Regulations of Indian Hospitals)",
      "42:2005" : "42:2005 (42:2005 Financial Assistance to Indian Tribes)",
      "42:2210" : "42:2210 (42:2210 Indeminification & Limitation of Liability-Financial)",
      "42:2651" : "42:2651 (42:2651 Medical Care Recovery)",
      "42:2996" : "42:2996 (42:2996 Legal Services Corporation Act)",
      "42:3058(g)" : "42:3058(g) (42:3058(g) Older American's Act of 1965, 42 USC 3058(g)(State Long-term Care Ombudsman Program))",
      "42:3121" : "42:3121 (42:3121 Public Works and Economic Development Act of 1965)",
      "42:3133" : "42:3133 (42:3133 Coordination-Grants for Public Works and Economic Development)",
      "42:3601" : "42:3601 (42:405 Fair Housing Act)",
      "42:3604(f)" : "42:3604(f) (42:3604(f)(3)(c) Fair Housing Amendments Act)",
      "42:3610" : "42:3610 (42:3610 Fair Housing Act-Administrative Enforcement; Preliminary Matters)",
      "42:3612" : "42:3612 (42:3612 Civil Rights in housing-Enforcement by Secretary)",
      "42:3613" : "42:3613 (42:3613 Action for inj relief re deprivation of civil rights)",
      "42:4000" : "42:4000 (42:4000 National Flood Insurance Act)",
      "42:4001" : "42:4001 (42:4001 National Insurance Flood Act)",
      "42:4013" : "42:4013 (42:4013 National Flood Insurance Act-Nature and Limitation of Insurance Coverage)",
      "42:4053" : "42:4053 (42:4053 Breach of Insurance Contract)",
      "42:4072" : "42:4072 (42:4072 Payment of Flood Insurance Claim)",
      "42:4321" : "42:4321 (42:4321 Review of Agency Action-Environment)",
      "42:4332" : "42:4332 (42:4332 Environmental Policy - Coop of Agency Repo)",
      "42:4721" : "42:4721 (42:4721 Intergovernmental Personnel Act (findings and purposes))",
      "42:4821" : "42:4821 (42:4821 Lead-Based Paint Poisoning Prevention Act (findings and purposes))",
      "42:4901" : "42:4901 (42:4901 Noise Control Act of 1972 (findings and purpose))",
      "42:4910(c)" : "42:4910(c) (42:4910(c) Action to restrain violation re noise control)",
      "42:5101" : "42:5101 (42:5101 Child Abuse Prevention and Treatment Act)",
      "42:5303" : "42:5303 (42:5303 Block Grant Act of 1974 (42 USC 5301-5321))",
      "42:5401" : "42:5401 (42:5401 Natl Mnfactrd Housing Cnstr Safety Standard Act of 1974 (findings and purposes))",
      "42:5411" : "42:5411 (42:5411 Housing Construction and Safety Standards Act-Injunctive Relief)",
      "42:5851" : "42:5851 (42:5851 Discrimination \"Whistle Blower\" Employee-ERA (employee protection))",
      "42:6101" : "42:6101 (42:6101 Age Discrimination in Federally Assisted Programs (statement of purpose))",
      "42:6201" : "42:6201 (42:6201 Energy Policy & Conservation Act (statement of purpose))",
      "42:6393" : "42:6393 (42:6393 Controversies under Energy Policy & Conservation Act (Admin Procedure and Judicial Review))",
      "42:6901en" : "42:6901en (42:6901 Environmental Cleanup Expenses)",
      "42:6901rs" : "42:6901rs (42:6901 Resource & Recovery Act)",
      "42:6928" : "42:6928 (42:6928 Violations of requirements of hazardous Waste Mgmt (federal enforcement))",
      "42:6961" : "42:6961 (42:6961 Federal Facilities Compliance Act)",
      "42:6972" : "42:6972 (42:6972 Resource & Recovery Act-Citizen Suit)",
      "42:6972(a)" : "42:6972(a) (42:6972(a) Solid Waste Disposal Act-Citizen Suit)",
      "42:7192" : "42:7192 (42:7192 Controversies under Dept of Energy Organization Act-Judicial Review)",
      "42:7384" : "42:7384 (42:7384 Energy Employees Occupational Illness Compensation Program Act (EEOICPA))",
      "42:7401" : "42:7401 (42:7401 Clean Air Act (findings & declarations))",
      "42:7412" : "42:7412 (42:7412 Air Pollution Control-emission standards)",
      "42:7413" : "42:7413 (42:7413(b) Clean Air Act)",
      "42:7413(b)" : "42:7413(b) (42:7413(b) Clean Air Act-Enforcement)",
      "42:7475" : "42:7475 (42:7475 Clean Air Act-Preconstruction Requirements)",
      "42:7545" : "42:7545 (42:7545 Air Pollution Prevention (Regulation of Fuels))",
      "42:7603" : "42:7603 (42:7603 Action for immediate restraint (Emergency Powers))",
      "42:7604" : "42:7604 (42:7604 Clean Air Act - Citizen suit to enforce Clean Air Act)",
      "42:7604(f)" : "42:7604(f) (42:7604(f) Clean Air Act - Emission Standards)",
      "42:7604cl" : "42:7604cl (42:7604 Clear Air Act (Emission Standards))",
      "42:7604ir" : "42:7604ir (42:7604 Petition to Quash IRS Summons)",
      "42:7671" : "42:7671 (42:7671 Clean Air Act (Stratospheric Ozone Protection) (Definitions))",
      "42:8324" : "42:8324 (42:8324 Powerplant and Industrial Fuel Use - terms and conditions)",
      "42:8351" : "42:8351 (42:8351 Powerplant and Industrial Fuel Use - Temporary Exemptions)",
      "42:9601" : "42:9601 (42:9601 Comprehensive Environmental Compen/Resp/Liab (CERLA) (Definitions))",
      "42:9604" : "42:9604 (42:9604 Comprehensive Envir., Response, Comp. & Liab. Act (CERCLA)-Removal and Other Remedial Action)",
      "42:9607" : "42:9607 (42:9607 Real Property Tort to Land)",
      "42:9613" : "42:9613 (42:9613 Comp Environ Recovery Comp & Liability Act (CERCLA) - Civil Proceedings)",
      "43:0945a" : "43:0945a (43:945a Compensation for Land Condemnation)",
      "43:0946" : "43:0946 (43:946 Complaint in Condemnation - Right of Way for Irrigation and Drainage Projects)",
      "43:1331" : "43:1331 (43:1331 Outer Continental Shelf Lands Act (Definitions))",
      "43:1333" : "43:1333 (43:1333 Outer Continental Shelf Lands Act - Citizen Suits)",
      "43:1701" : "43:1701 (43:1701 Violation of Federal Land Policy and Management Act (FLPMA))",
      "43:1737" : "43:1737 (43:1737 FLPMA - Implementation Provisions)",
      "43:421" : "43:421 (43:421 Complaint in Condemnation- Eminent Domain)",
      "43:945" : "43:945 (43:945 Compensation for Land Condemnation)",
      "43:945a" : "43:945a (43:945a Complaint in Condemnation)",
      "43:946" : "43:946 (43:946 Complaint in Condemnation - Eminent Domain)",
      "44:2107" : "44:2107 (44:2107 Presidential Recordings and Materials Act (NARA acceptance of records for historical preserv)",
      "45:0051" : "45:0051 (45:51 Railways: Fed. Employer's Liability Act)",
      "45:0056" : "45:0056 (45:56 Employers Liability Act - Personal Inj re Railroads (bringing an action))",
      "45:0151" : "45:0151 (45:151 Railway Labor Act (Definitions))",
      "45:0152" : "45:0152 (45:152 Railway Labor Act - General Duties)",
      "45:0153" : "45:0153 (45:153 First Railway Labor Act - National Railroad Adjustment Board)",
      "45:0159" : "45:0159 (45:159 Review of arbitration award (RR Carriers/Mediation Bd))",
      "45:0184" : "45:0184 (45:184 Action to Set Aside Award of a System Board)",
      "45:0231(f)" : "45:0231(f) (45:0231(f) Compel obediance to order of Railroad Retirement Bd)",
      "45:0351" : "45:0351 (45:351 Railroad Unemployment Insurance Act)",
      "45:0719" : "45:0719 (45:719 Regional Rail Reorganization Act of 1973 (judicial review))",
      "45:1105" : "45:1105 (45:1105 Northeast Rail Service Act - Judicial Review)",
      "45:1395" : "45:1395 (45:1395 Railroads: Adverse Reimbursement Review)",
      "45:7457" : "45:7457 (45:7457 Compel Reclamation Under Clear Air Act)",
      "46:0151" : "46:0151 (46:151 Federal Communications Act of 1934)",
      "46:0688" : "46:0688 (46:688 Jones Act)",
      "46:0741" : "46:0741 (46:741 Shipping)",
      "46:0761" : "46:0761 (46:761 Shipping: Damages for Death on High Seas)",
      "46:1101" : "46:1101 (46:1101 Violation of Maritime Regulations)",
      "46:1156" : "46:1156 (46:1156 Administrative Procedure Act)",
      "46:2114" : "46:2114 (46:2114 Wrongful Discharge from Employment - protection from discrimination)",
      "46:30101" : "46:30101 (46:3010 Extension of jurisdiction to cases or damage or injury on land)",
      "46:30104" : "46:30104 (46:30104 Marine Personal Injury - Jones Act)",
      "46:30302" : "46:30302 (46:30302 Shipping: Damages for Death on High Seas)",
      "46:30304" : "46:30304 (46:30304 Breach of Maritime Contract - liability of noncompliance)",
      "46:30503" : "46:30503 (46:30503 Limitation of Liability - declaration of nature and value of goods)",
      "46:30504" : "46:30504 (46:30504 Limitation of Liability - loss by fire)",
      "46:30511" : "46:30511 (46:30511 Action by owner for limitation)",
      "46:30701" : "46:30701 (46:30701 Marine Cargo Loss or Damage - Loading, stowage, custody, care, and deliver)",
      "46:30704" : "46:30704 (46:30704 Liability of Water Carriers - Loading, stowage, custody, care, and delivery)",
      "46:30902" : "46:30902 (46:30902 to 30911 Suits in Admirality Act)",
      "46:31102" : "46:31102 (46:31102 Public Vessels Act - Waiver of Immunity)",
      "46:31301" : "46:31301 (46:31301 Federal Maritime Lien Act)",
      "46:31321" : "46:31321 (46:31321 Foreclosure of Preferred Ship Mortgages)",
      "46:31325" : "46:31325 (46:31325 Suit to enforce lien upon mortgaged vessel-foreclosure/Foreclosure of Preferred Foreign Shi)",
      "46:31341" : "46:31341 (46:31341 Federal Maritime Lien Act)",
      "46:31343" : "46:31343 (46:31343 Commercial Instruments & Maritime Liens)",
      "46:4010" : "46:4010 (46:4010 Shipping Act of 1998)",
      "46:41102(a" : "46:41102(a (46:41102(a) Shipping Act of 1984 - General Prohibitions)",
      "46:41309" : "46:41309 (46:41309 Shipping Act of 1984 - Enforcement of Reparation Orders)",
      "46:50101" : "46:50101 (46:50101 Violation of Maritime Regulations)",
      "46:58109" : "46:58109 (46:58108 Violation of Merchant Marine Act - Penalties)",
      "47:0151cs" : "47:0151cs (47:151cs Federal Coummunications Act - Collection for Services)",
      "47:0201bt" : "47:0201bt (47:201bt Breach of Tariff)",
      "47:0203" : "47:0203 (47:203 Telecommunications Collection of Charges)",
      "47:0205" : "47:0205 (47:205 Wire and Radio Communication Svc and Charges(Recovery of Damages))",
      "47:0206" : "47:0206 (47:206 Carrier's Liability for Damages)",
      "47:0227" : "47:0227 (47:227 FCC-Unsolicited Telephone Sales)",
      "47:0227(b)" : "47:0227(b) (47:227(b)(3) Telephone Consumer Protection Act of 1991)",
      "47:0251" : "47:0251 (47:251 Telecommunications Act of 1996 - Interconnection)",
      "47:0252" : "47:0252 (47:252 Telecommunications Act)",
      "47:0254(h)" : "47:0254(h) (47:254(h) Children's Internet Protection Act)",
      "47:0332" : "47:0332 (47:332 FCA-Wire or Radio Communications (Mobile Services))",
      "47:0332(c)" : "47:0332(c) (47:332(c) Federal Telecommunications Act of 1996)",
      "47:0401" : "47:0401 (47:401 Application of Federal Communication Comm for Inj. (Enforcement Provisions))",
      "47:0407" : "47:0407 (47:407 Order for paymnet of money; petition for enforcement)",
      "47:0510" : "47:0510 (47:510 Forfeiture of Communications Devices)",
      "47:0521" : "47:0521 (47:521 Cable Televsn. Consumer Protection & Competition Act of 1992)",
      "47:0532" : "47:0532 (47:532 Cable Communication Policy Act of 1984)",
      "47:0551" : "47:0551 (47:551 Cable Communications Act)",
      "47:0553" : "47:0553 (47:553 U.S.C.A. Cable Communications Policy Act)",
      "47:0605" : "47:0605 (47:605 Unlawful Reception Broadcase Signal i.e., Satellite - Theft of Satellite Communications)",
      "48:0883" : "48:0883 (48:883 Violation of US Coastal Law)",
      "48:1985" : "48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)",
      "49:0081" : "49:0081 (49:81 Damaged Goods While Being Transported)",
      "49:0101" : "49:0101 (49:101 ICC Termination Act of 1996)",
      "49:0502" : "49:0502 (49:502 Transportation Administration Subpoena)",
      "49:0781" : "49:0781 (49:781 Forfeiture)",
      "49:0945b" : "49:0945b (49:945b Complaint in Condemnation - Easements)",
      "49:10101" : "49:10101 (49:10101 Interstate Commerce Act - Interstate Transportation Rail)",
      "49:10743" : "49:10743 (49:10743 Revised Interstate Commerce Act)",
      "49:11101" : "49:11101 (49:11101 Interstate Commerce Act)",
      "49:1113" : "49:1113 (49:1113 Petition to enforce administative summon)",
      "49:1136" : "49:1136 (49:1136 Aviation Disaster Family Assistance Act of 1996)",
      "49:11501" : "49:11501 (49:11501 Railroad Revitalization & Regulatory Act (General Jurisdiction))",
      "49:11502" : "49:11502 (49:11502 Railroad Revitalization Regulatory Reform (authority to exempt rail carrier transportation))",
      "49:11503" : "49:11503 (49:11503 Railroad Revitalization Regulatory Reform)",
      "49:11701" : "49:11701 (49:11701 General authority of enforcement of regulations in rail)",
      "49:11702" : "49:11702 (49:11702 Enforcement by the Board)",
      "49:11705" : "49:11705 (49:11705 Limitation on actions by and against rail carriers)",
      "49:11706" : "49:11706 (49:11706 Carmack Amendment (Liability of carriers under receipts and bills of lading))",
      "49:11707" : "49:11707 (49:11707 Carmack Amendment (Liability when property is delivered in violation of routing instruction)",
      "49:13101" : "49:13101 (49:13101 Transportation Policy)",
      "49:13702" : "49:13702 (49:13702 Tariff requirement for certain transportation)",
      "49:13706" : "49:13706 (49:13706 Motor Carriers etc. - Liability for Payment of Rates)",
      "49:14501" : "49:14501 (49:14501 Preemption (Federal authority of intrastate transportation))",
      "49:14705" : "49:14705 (49:14705 Interstate Commerce Act/Carmack Amendment (Limitations on actions by and against carriers))",
      "49:14706" : "49:14706 (49:14706 Carmack Amendment to the Interstate Commerce Act/Liability of Carriers - Receipts & Bills)",
      "49:1471" : "49:1471 (49:1471 Federal Aviation Act)",
      "49:1903" : "49:1903 (49:1903 Petition to enforce administrative summon)",
      "49:20301" : "49:20301 (49:20301 Federal Safety Appliance Act)",
      "49:20302" : "49:20302 (49:20302 Federal Safety Appliance Act)",
      "49:20303" : "49:20303 (49:20303 Federal Safety Appliance Act)",
      "49:20304" : "49:20304 (49:20304 Federal Safety Appliance Act)",
      "49:20305" : "49:20305 (49:20305 Federal Safety Appliance Act)",
      "49:20306" : "49:20306 (49:20306 Federal Safety Appliance Act)",
      "49:21302" : "49:21302 (49:21302 Carriers violations of Interstate Commerce Act Chapter 201 accident and incident violations)",
      "49:30101" : "49:30101 (49:30101 National Traffic and Motor Vehicle Safety Act)",
      "49:30112" : "49:30112 (49:30112 Motor Vehicle Safety (prohibition on non-complying motor vehicles and equipment))",
      "49:30502" : "49:30502 (49:30502 Natl Motor Vehicle Title Information Syst)",
      "49:31114" : "49:31114 (49:31114 Access to Interstate System/Commercial Motor Vehicle)",
      "49:31502" : "49:31502 (49:31502 Motor Carrier Safety - Requirements for Qualifications)",
      "49:32101" : "49:32101 (49:32101 Motor Vehicle Information and Costs Savings Act)",
      "49:32701" : "49:32701 (49:32701 Odometer Requirements Act)",
      "49:40101" : "49:40101 (49:40101 Federal Aviation Act)",
      "49:40102" : "49:40102 (49:40102 Airline Deregulation Act (definitions of air and commerce safety))",
      "49:40105" : "49:40105 (49:40105 Warsaw Convention)",
      "49:41705" : "49:41705 (49:41705 Air Carrier Access Act (discrimination against handicapped indiciduals))",
      "49:41713" : "49:41713 (49:41713 Airline Deregulation Act (premp of authority over prices, routes and service))",
      "49:44709" : "49:44709 (49:44709 Noise Control Act of 1972)",
      "49:44715" : "49:44715 (49:44715 Noise Control Act of 1972)",
      "49:46507" : "49:46507 (49:46507 False Information and Threats)",
      "49:47101" : "49:47101 (49:47101 Airport and Airway Improvement Act of 1982)",
      "49:47501" : "49:47501 (49:47501 Aviation Safety & Noise Abatement Act of 1979)",
      "49:49101" : "49:49101 (49:49101 Wrongful Termination in Contravention of Published Regulations)",
      "49:49104" : "49:49104 (49:49104 Breach of Lease by Metro. Wash. Airport Auth.)",
      "49:60101" : "49:60101 (49:60101 Pipeline Safety Act of 1994)",
      "49:60102" : "49:60102 (49:60102 Hazardous Liquid Pipeline Safety Act of 1979 (HLPSA))",
      "49:80102" : "49:80102 (49:80102 Bills of Lading - Application)",
      "49:80302" : "49:80302 (49:80302 Contraband - Prohibitions)",
      "49:80303" : "49:80303 (49:80303 Seizure and forfeiture of vessel or aircraft conveying contraband)",
      "50:0001" : "50:0001 (50(a):0001 Trading With the Enemy Act (act located in Title 50, Appendix))",
      "50:0501" : "50:0501 (50(a):501 Sailors and Soldiers Civil Relief Act (act located in Title 50, Appendix))",
      "50:0533" : "50:0533 (50(a):533 Servicemembers Civil Relief Act - Mortgages (act located in Title 50, Appendix))",
      "50:0540" : "50:0540 (50(a):540 Sailors and Soldiers Civil Relief Act (act located in Title 50, Appendix))",
      "50:1701" : "50:1701 (50:1701 International Emergency Economic Powers Act)",
      "50:1702" : "50:1702 (50:1702 International Emergency Economic Powers Act)",
      "50:1703" : "50:1703 (50:1703 International Emergency Economic Powers Act)",
      "50:1704" : "50:1704 (50:1704 International Emergency Economic Powers Act)",
      "50:1705" : "50:1705 (50:1705 International Emergency Economic Powers Act)",
      "50:1706" : "50:1706 (50:1706 International Emergency Economic Powers Act)",
      "50:2412" : "50:2412 (50(a):2412 Export Administration Act - 1979 (act located in Title 50, Appendix))",
      "51:20137" : "51:20137 (51:20137(a) Malpractice and Negligence Against U.S. Space program)",
      "8:287" : "8:287 (8:287 Petition to Enforce INS Subpoena)",
      "misc" : "misc (Civil Miscellaneous Case)"
   },
   "iasdce" : {
      "0" : "0 (No cause code entered)",
      "00:0000" : "00:0000 (00:0000 Cause Code Unknown )",
      "02:0138" : "02:0138 (02:0138 Library of Congress Access)",
      "02:0358" : "02:0358 (02:0358 President's Recommendations on Exec., Jud. & Leg. Salary)",
      "02:0431" : "02:0431 (02:431 Fed. Election Commission: Failure Enforce C)",
      "02:0437" : "02:0437 (02:437 Federal Election Commission)",
      "02:0681" : "02:0681 (02:0681 Deferral of Budget Authority)",
      "02:1202" : "02:1202 (02:1202 Discriminatory practices affecting US Senate employees)",
      "02:1301" : "02:1301 (02:1301 Congressional Accountability Act)",
      "02:1317(a)" : "02:1317(a) (02:1317(a) Violation of Congressional Accountability Act)",
      "05:0101" : "05:0101 (05:0101 Ethics in Government Act)",
      "05:0504(c" : "05:0504(c (05:0504(c )(2) Equal Access to Justice (Govt Employees))",
      "05:0551" : "05:0551 (05:551 Administrative Procedure Act)",
      "05:0552b(g" : "05:0552b(g (05:0552b(g)sa Implement requirements of Govt in Sunshine Act)",
      "05:0552fi" : "05:0552fi (05:552 Freedom of Information Act)",
      "05:0552pa" : "05:0552pa (05:552 Right to Privacy Act)",
      "05:0554" : "05:0554 (05:0554 Constitutionality of Maritime Statutes)",
      "05:0555(b)" : "05:0555(b) (05:0555(b) Agency Decision - Right to Counsel )",
      "05:0701" : "05:0701 (05:0701 Maritime Subsidy Board)",
      "05:0702" : "05:0702 (05:702 Administrative Procedure Act)",
      "05:0704" : "05:0704 (05:704 Labor Litigation)",
      "05:0706" : "05:0706 (05:0706 Judicial Review of Agency Action)",
      "05:1508" : "05:1508 (05:1508 Judicial Review of Order Issued by the Merit Systems Protection Board)",
      "05:2302" : "05:2302 (05:2302 Federal Whistleblowing Act / Civil Service Reform Act (CSRA))",
      "05:3318" : "05:3318 (05:3318 Veterans Preference Act)",
      "05:5514" : "05:5514 (05:5514 Debt Collection Act of 1982)",
      "05:5542" : "05:5542 (05:5542 Federal Employees Pay Act -- overtime rates)",
      "05:7101" : "05:7101 (05:7101 Labor-Management Relations (Findings and Purpose))",
      "05:7123" : "05:7123 (05:7123 Petition by FLRA against unfair labor practices)",
      "05:7501" : "05:7501 (05:7501 Government Employees Adverse Action--14 days or less)",
      "05:7511" : "05:7511 (05:7511 Government Employees Adverse Action--Over 14 days)",
      "05:7703" : "05:7703 (05:7703 Discrimination - Review of Agency Act)",
      "05:8101" : "05:8101 (05:8101 Workmen's Compensation Benefits)",
      "05:8110" : "05:8110 (05:8110 Augmented Compensation for dependents of Govt. Employees)",
      "05:8316" : "05:8316 (05:8316 Claims agst US re Retirement for Federal Emp.)",
      "05:8470" : "05:8470 (05:8470 Enforcement of Judgment against Retirement Benefits)",
      "05:8701" : "05:8701 (05:8701 Federal Employees Group Life Insurance Act of 1954)",
      "05:8705" : "05:8705 (05:8705 Declaratory Judgment - Insurance)",
      "05:8715" : "05:8715 (05:8715 Claims against the US - Jurisdiction of Courts)",
      "05:8901" : "05:8901 (05:8901 Federal Employees Health Benefits Act)",
      "05:8902" : "05:8902 (05:8902 Contracting Authority of OPM - Group Health Insurance )",
      "05:8903" : "05:8903 (05:8903 Federal Employees Health Benefit Act)",
      "05:8912" : "05:8912 (05:8912 Claims agst US re health benefits for Federal emp.)",
      "07:0001" : "07:0001 (07:0001 Commodity Exchange Act)",
      "07:0006" : "07:0006 (7:6(b) Federal Commodity Exchange Regulation)",
      "07:0006(b)" : "07:0006(b) (07:0006(b) Federal Commodity Exchange Regulation)",
      "07:0009a" : "07:0009a (07:0009a Recovery of penalties by Commodity Futures Trading Com)",
      "07:0013a" : "07:0013a (07:0013a Contract market rules violations; recovery of penalty)",
      "07:0013a-1" : "07:0013a-1 (07:0013a-1 Enjoin or restrain violations Contract Market rules)",
      "07:0025" : "07:0025 (7:25 Fraud - Commodities Leverage Contracts)",
      "07:0087" : "07:0087 (07:0087 Enforcement of United States Grain Standards Act)",
      "07:0136" : "07:0136 (07:0136 Violations of EPA re Environmental Pesticide Control)",
      "07:0181" : "07:0181 (07:181 Packers & Stockyard Act)",
      "07:0193(b)" : "07:0193(b) (07:0193(b) Recovery of penalties re violations by packers)",
      "07:0203" : "07:0203 (07:0203 Recovery of penalties for violations by stockyards)",
      "07:0209(b)" : "07:0209(b) (07:0209(b) Violations re purchase, sale, handling of livestock)",
      "07:0210(f)" : "07:0210(f) (07:0210(f) Suit to enforce award of damages (Packers/Stockyards))",
      "07:0213(b)" : "07:0213(b) (07:0213(b) Unfair, discriminatory, deceptive practice/marketing)",
      "07:0216" : "07:0216 (07:0216 Injunctions to restrain & enforce orders of Secretary)",
      "07:0222" : "07:0222 (07:0222 Adoption of FTC powers for enforcement.)",
      "07:0228a" : "07:0228a (07:0228a Request by Secretary for TRO or Inj. re Poultry)",
      "07:0245" : "07:0245 (07:0245 Action on bond by person injured in Warehouse)",
      "07:0292" : "07:0292 (07:0292 Monopolizing or restraining trade & enhancing prices)",
      "07:0499" : "07:0499 (07:499 Agricultural Commodities Act)",
      "07:0499E(c" : "07:0499E(c (07:0499E(c )(4) Perishable Agricultural Commodities Act (PACA))",
      "07:0601" : "07:0601 (07:601 USDA Condemnation)",
      "07:0608" : "07:0608 (07:0608 Agriculture Adjustment Act)",
      "07:0901" : "07:0901 (07:0901 Rural Electrification Act)",
      "07:1291(b)" : "07:1291(b) (07:1291(b) Agricultural Adjustment Act; freight rates.)",
      "07:1376" : "07:1376 (07:1376 Adjustment of Quotas and Enforcement; penalties.)",
      "07:1501" : "07:1501 (Federal Crop Insurance Act )",
      "07:1508" : "07:1508 (07:1508 Crop Insurance)",
      "07:1631" : "07:1631 (07:1631 Food Security Act)",
      "07:1721" : "07:1721 (07:1721 Agricultural Trade Development Asst Act)",
      "07:1922" : "07:1922 (07:1922 Persons Eligible for Loans - Forclosure)",
      "07:1926" : "07:1926 (07:1926 Water and Waste Facility Loans and Grants)",
      "07:1930" : "07:1930 (07:1930 Perishable Agric. Comm. Act of 1930)",
      "07:2011" : "07:2011 (07:2011 Supplemental Nutrition Assistance Program)",
      "07:2022" : "07:2022 (07:2022 Disposition of Claims: Denial application to participate; food stamp prog.)",
      "07:2023(a)" : "07:2023(a) (07:2023(a) Judicial Review of Food Stamp Disqualification)",
      "07:2024" : "07:2024 (07:2024 False Claims Act, Food Stamp Fraud)",
      "07:2131" : "07:2131 (07:2131 Violation of the Animal Welfare Act)",
      "07:2146" : "07:2146 (07:2146 Transportation, Sale, and Handling of Animals)",
      "07:2301" : "07:2301 (07:2301 Agricultural Fair Practices Act)",
      "07:2305" : "07:2305 (07:2305 Unfair trade practices affecting producers Agri prod)",
      "07:2321" : "07:2321 (07:2321 Plant Variety Protection Act)",
      "07:2563" : "07:2563 (07:2563 Plant Variety Protection and Rights - Injunction)",
      "07:6999" : "07:6999 (07:6999 Judicial Review of Adverse Farm Agency Decision)",
      "08:1101" : "08:1101 (08:1101 Immigration & Nationality Act (Definitions))",
      "08:1105(a)" : "08:1105(a) (08:1105(a)Immigration: Judicial Review for Battered Spouses; Deportation (INS))",
      "08:1151" : "08:1151 (08:1151 Immigration and Nationality Act of 1952)",
      "08:1152" : "08:1152 (08:1152 Immigration: Numerical limitations on individual foreign states)",
      "08:1153" : "08:1153 (08:1153 Immigration: Allocation of Immigrant Visas)",
      "08:1154" : "08:1154 (08:1154 Immigration: Procedure for Granting Immigration Status)",
      "08:1158" : "08:1158 (08:1158 Immigration & Nationality Act, Section 208 (Asylum))",
      "08:1182" : "08:1182 (08:1182 Inadmissible Aliens: Defend. Denial of Pla. Appl. for Alien Employment Cer)",
      "08:1183" : "08:1183 (08:1183 Admission of Aliens on Giving Bond or Undertaking; Return on Departure)",
      "08:1188" : "08:1188 (08:1188 Immigration: Admission of Temporary H-2A Workers)",
      "08:1225" : "08:1225 (08:1225 Immigration: Enforcement of Administrative Subpoena)",
      "08:1231(a)" : "08:1231(a) (08:1231(a)(6) Immigration: Due Process Clause)",
      "08:1251(A)" : "08:1251(A) (08:1251(A)(4) Immigration: Application for a Stay of Deportation)",
      "08:1252" : "08:1252 (08:1252(a)(2) Injunction for Deportation)",
      "08:1255" : "08:1255 (08:1255 Immigration: Failure USCIS To Adjudicate Permanent Residency Petition)",
      "08:1260" : "08:1260 (08:1260 Aliens: Access to Records)",
      "08:1324" : "08:1324 (08:1324 Aliens: Complaint for Forfeiture)",
      "08:1329" : "08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petiti)",
      "08:1357" : "08:1357 (08:1357 Immigration and Nationality Act - Administrative Search Warrant)",
      "08:1421" : "08:1421 (08:1421 Immigration: Naturalization Authority)",
      "08:1445" : "08:1445 (08:1445 Immigration: Application for Naturalization)",
      "08:1446" : "08:1446 (8:1446 Petition for Naturalization Hearing)",
      "08:1447" : "08:1447 (08:1447 Immigration: Review of Denial of Naturalization Application)",
      "08:1451" : "08:1451 (08:1451 Immigration: Revocation of Citizenship)",
      "08:1451(a)" : "08:1451(a) (08:1451(a) Action to revoke Citizenship)",
      "08:1451(j)" : "08:1451(j) (08:1451(j) Immigration: Motion to Correct Order & Judg. of Naturalization)",
      "09:0001" : "09:0001 (09:1 U.S. Arbitration Act)",
      "09:0003" : "09:0003 (09:0003 Application to Stay Proceedings Pending Arbitration)",
      "09:0004" : "09:0004 (09:0004 Petition to order arbitration; failure to arbitrate)",
      "09:0007" : "09:0007 (09:0007 Petition to compel attendance before arbitrator)",
      "09:0008" : "09:0008 (09:0008 Declaratory Judgment/Admiralty)",
      "09:0009" : "09:0009 (9:9 Motion to Confirm Arbitration Loan)",
      "09:0010" : "09:0010 (09:0010 Petition to Vacate Arbitration Award)",
      "09:0011" : "09:0011 (09:0011 Motion to modify or correct arbitration award)",
      "09:0201" : "09:0201 (09:0201 Petition to Compel/Stay Arbitration under an Insurance Contract)",
      "09:0202" : "09:0202 (09:0202 Award under Convention on Foreign Arbitral Awards)",
      "09:0205" : "09:0205 (09:0205 Removal from State Court: Enforcement of Foreign Arbital Awards)",
      "09:0207" : "09:0207 (09:0207 Application for order confirming award of arbitrators)",
      "10:0672" : "10:0672 (10:0672 Armed Forces: Active Guard/Reserve (AGR) Program)",
      "10:1006" : "10:1006 (10:1006 Armed Forces: Review of Agency Decision)",
      "10:1072tc" : "10:1072tc (10:1072tc Armed Forces: TRICARE PROGRAM)",
      "10:1089(c" : "10:1089(c (10:1089(c ) Armed Forces: Removal; dft acting in scope of duties)",
      "10:1091" : "10:1091 (10:1091 Armed Forces: Personal Service Contracts)",
      "10:1107" : "10:1107 (10:1107 Armed Forces: Use Of Investigational New Drug)",
      "10:1408" : "10:1408 (10:1408 Armed Forces: Claim for Military Retirement)",
      "10:1552" : "10:1552 (10:1552 Armed Forces: Action to Correct Records)",
      "10:1553" : "10:1553 (10:1553 Armed Forces: FOIA General)",
      "10:2005" : "10:2005 (10:2005 Armed Forces: Advanced Education Assistance)",
      "10:2121" : "10:2121 (10:2121 Armed Forces: Health Professions Scholarship Financial Asst Prog)",
      "10:2302" : "10:2302 (10:2302 Armed Forces: Arms Services Procurement Act)",
      "10:2305" : "10:2305 (10:2305 Review of Federal Contract)",
      "10:2323fa" : "10:2323fa (10:2323fa Armed Forces: Fifth Amendment Equal Protection: Contract Goal for Small Disadvantaged Bus)",
      "10:2733" : "10:2733 (10:2733 Armed Forces: Military Claims Act)",
      "10:2734" : "10:2734 (10:2734 Armed Forces: Foreign Military Claims Act)",
      "10:2771" : "10:2771 (10:2771 Armed Forces: Final Settlement - Deceased Members)",
      "10:3258" : "10:3258 (10:3258 Armed Forces: Reg.Army: Re-enlistment after Service as Ofcr)",
      "11:0101" : "11:0101 (11:101 Bankruptcy)",
      "11:0110" : "11:0110 (11:0110 Bankruptcy: Penalty for Preparers of Fraudulent or Negligent Petitions)",
      "11:0362(h)" : "11:0362(h) (11:0362(h) Bankruptcy: Violation of Automatic Stay)",
      "11:0523" : "11:0523 (11:0523 Bankruptcy: Exceptions to Discharge)",
      "11:0524" : "11:0524 (11:0524 Bankruptcy: Effect of Discharge)",
      "11:0525" : "11:0525 (11:0525 Bankruptcy: Protections Against Discriminatory Treatment )",
      "11:0548" : "11:0548 (11:0548 Bankruptcy: Fraudulent Transfers and Obligations)",
      "11:0704" : "11:0704 (11:0704 Bankruptcy: Duties of Trustee)",
      "11:Appendi" : "11:Appendi (11:Appendix Bankruptcy Appeal - this refers to rule 8001, not section 8001)",
      "12:0085" : "12:0085 (12:0085 National Banks: Rate of Interest on Loans, Discounts, and Purchases)",
      "12:0093(a)" : "12:0093(a) (12:0093(a) National Banks: Violation of Provisions; Forfeiture of Franchise; Personal Liability of )",
      "12:0191" : "12:0191 (12:0191 National Banks: Appointment of Receiver)",
      "12:0192" : "12:0192 (12:0192 National Banks: Liquidation of National Bank)",
      "12:0215" : "12:0215 (12:0215 National Banks: Consolidation and Merger)",
      "12:0622" : "12:0622 (12:0622 Foreign Banking: Forfeiture, Dissolution, and Liability of Directors and Officers for Nonco)",
      "12:0632" : "12:0632 (12:0632 Foreign Banking: Voluntary Liquidation)",
      "12:0635" : "12:0635 (12:635 Breach of Insurance Contract)",
      "12:0635i-3" : "12:0635i-3 (12:0635i-3 Export-Import Bank: Breach of Insurance Contract)",
      "12:1421" : "12:1421 (12:1421 Federal Home Loan Bank Act (Short Title))",
      "12:1441" : "12:1441 (12:1441 FHLB: Financial Inst Reform Receiving Enforcement Act 1989)",
      "12:1451" : "12:1451 (12:1451 Emergency Home Loan Corporation (Definitions))",
      "12:1452" : "12:1452 (12:1452 Federal Home Loan Mortgage Corporation Act)",
      "12:1452(f)" : "12:1452(f) (12:1452(f) Fed Home Loan Mortgage Corp: Actions by and against the Corporation)",
      "12:1455(b)" : "12:1455(b) (12:1455(b) Fed Home Loan Mortgage Corp: Enforcement of Regulations)",
      "12:1461" : "12:1461 (12:1461 Homeowners Loan Act)",
      "12:1464" : "12:1464 (12:1464 Savings Associations: Federal Savings and Loan)",
      "12:1703" : "12:1703 (12:1703 Default of HUD Loan)",
      "12:1715(b)" : "12:1715(b) (12:1715(b) National Housing: Rules and Regulations)",
      "12:1749aaa" : "12:1749aaa (12:1749aaa National Housing: National Insurance Development Program)",
      "12:1751" : "12:1751 (12:1751 Fed Credit Unions: Short Title)",
      "12:1782" : "12:1782 (12:1782 Fed Credit Unions: Administration of Insurance Fund)",
      "12:1786" : "12:1786 (12:1786 Fed Credit Unions: Actions re Violations by Credit Unions)",
      "12:1787(a)" : "12:1787(a) (12:1787(a)(B) Fed Credit Unions: Liquidation of Insured Credit Union by Board)",
      "12:1789(a)" : "12:1789(a) (12:1789(a)(2) Fed Credit Unions: Admin Provision to Sue and be Sued)",
      "12:1811" : "12:1811 (12:1811 FDIC: Financial Inst. Reform Recovery Act of 1989 (FIRREA) (Organization of FDIC))",
      "12:1818" : "12:1818 (12:1818 FDIC: Violations re Federal Deposit Insurance Corporation)",
      "12:1818(e)" : "12:1818(e) (12:1818(e) FDIC: Suspension or Removal of Bank Officer)",
      "12:1819" : "12:1819 (12:1819 Default of Promissory Note)",
      "12:1821" : "12:1821 (12:1821 Default of Loan by Promissary Note)",
      "12:1831" : "12:1831 (12:1831 FDIC: Separability of Certain Provisions)",
      "12:1831(d)" : "12:1831(d) (12:1831(d) FDIC: Deposit. Inst. Dereg. & Monetary Ctrl. Act of 1980)",
      "12:1831r-1" : "12:1831r-1 (12:1831r-1 FDIC: Notice of Branch Closure)",
      "12:1833(a)" : "12:1833(a) (12:1833(a) FDIC: Forfeiture Civil Penalties)",
      "12:1954" : "12:1954 (12:1954 Injunctions (Action by Sec of Treasury re financial recordkeeping))",
      "12:1971" : "12:1971 (12:1971 Relief under Bank Holding Act)",
      "12:1972" : "12:1972 (12:1972 Tying Arrangement Act)",
      "12:2001" : "12:2001 (12:2001 Farm Credit Act of 1971)",
      "12:2601" : "12:2601 (12:2601 Real Estate Settlement Procedures Act (RESPA) (findings & purpose))",
      "12:2604(c" : "12:2604(c (12:2604(c ) Real Estate Settlement Procedures Act (RESPA))",
      "12:2605" : "12:2605 (12:2605 RESPA: Servicing of Mortgage Loans)",
      "12:2607" : "12:2607 (12:2607 RESPA: Violation re kickbacks/unearned fees; Real Estate)",
      "12:2609" : "12:2609 (12:2609 RESPA: Escrow)",
      "12:3012" : "12:3012 (12:3012 National Consumer Cooperative Bank: Suits by or against Bank)",
      "12:3410" : "12:3410 (12:3410 Right to Financial Privacy Act)",
      "12:3751" : "12:3751 (12:3751 Single Family Mortgage Forclosure Act: Findings and Purpose)",
      "12:3801" : "12:3801 (12:3801 Alternative Mortgage Transaction Parity Act)",
      "12:3907" : "12:3907 (12:3907 International Lending Supervision: Capital Adequacy)",
      "12:4010" : "12:4010 (12:4010 Expedited Funds Availability: Violation of Act (Civil Liability))",
      "12:5101" : "12:5101 (12:5101 Fraudulent Transfer Act (Enforcement for Mortgage Licensing))",
      "15:0001" : "15:0001 (15:1 Antitrust Litigation)",
      "15:0002at" : "15:0002at (15:2 Antitrust Litigation)",
      "15:0002fl" : "15:0002fl (15:2(a) Fair Labor Standards Act)",
      "15:0004" : "15:0004 (15:0004 USDC Jurisdiction re violations of Sec. 1-7 of Title 15)",
      "15:0005" : "15:0005 (15:5(a) Fair Labor Standards Act)",
      "15:0009" : "15:0009 (15:0009 USDC Jurisdiction re violations of Sec. 8 of Title 15)",
      "15:0013" : "15:0013 (15:0013 Robinson Patman Act)",
      "15:0014" : "15:0014 (15:0014 Clayton Act)",
      "15:0015" : "15:0015 (15:15 Antitrust Litigation)",
      "15:0025" : "15:0025 (15:25 Clayton Act)",
      "15:0026" : "15:0026 (15:0026 Suit for injunctive relief re violation antitrust laws)",
      "15:0041" : "15:0041 (15:0041 Federal Trade Commission Act)",
      "15:0045" : "15:0045 (15:0045 Federal Trade Commission Act (unfair or deceptive acts))",
      "15:0045cp" : "15:0045cp (15:0045cp Violation of Children Online Privacy Protection Act)",
      "15:0052" : "15:0052 (15:0052 Federal Trade Commission Act)",
      "15:0053" : "15:0053 (15:0053 Federal Trade Commission Act)",
      "15:0068" : "15:0068 (15:0068 Proceedings re FTC violations re wool products)",
      "15:0069" : "15:0069 (15:0069 Proceedings re FTC violations re fur products)",
      "15:0070" : "15:0070 (15:0070 Proceedings re FTC violations re textile fiber product)",
      "15:0077" : "15:0077 (15:77 Securities Fraud)",
      "15:0078" : "15:0078 (15:78m(a) Securities Exchange Act)",
      "15:0078j(b" : "15:0078j(b (15:0078j(b)ss Stockholder Suit)",
      "15:0078m(a" : "15:0078m(a (15:0078m(a) Securities Exchange Act)",
      "15:0079" : "15:0079 (15:0079 Public Utility Holding Companies)",
      "15:0080a-3" : "15:0080a-3 (15:0080a-3 Investment Company Act of 1940)",
      "15:0260" : "15:0260 (15:0260 Proceedings re weights and measures and standard time)",
      "15:0298" : "15:0298 (15:0298 Violation of Law Proceedings re gold or silver)",
      "15:0433" : "15:0433 (15:0433 Discrimination against farmers)",
      "15:0631" : "15:0631 (15:631 Small Business Act)",
      "15:0636" : "15:0636 (15:0636 Small Business Act - Aid to small business)",
      "15:0661" : "15:0661 (15:0661 Small Business Investment Act of 1958)",
      "15:0687" : "15:0687 (15:0687 Small Business Investment Program)",
      "15:0714(b)" : "15:0714(b) (15:0714(b) Commodity Credit Corporation)",
      "15:0715(f)" : "15:0715(f) (15:0715(f) Proceedings re petroleum and petroleum products)",
      "15:0717" : "15:0717 (15:717 Natural Gas Act)",
      "15:0719i(c" : "15:0719i(c (15:0719i(c ) Civil actions re violations or inj involving Gas)",
      "15:0766" : "15:0766 (15:0766 Controversies arising re Federal Energy Admin. rules)",
      "15:1051" : "15:1051 (15:1051 Trademark Infringement)",
      "15:1071" : "15:1071 (15:1071 Appeal of Decision of U.S. Patent & Trademark Office (Comm / Trademark Trial Bd))",
      "15:1114" : "15:1114 (15:1114 Trademark Infringement)",
      "15:1116" : "15:1116 (15:1116 Inj to prevent violation rights of trademark owner)",
      "15:1120" : "15:1120 (15:1120 Trademark - False or Fraudulent Registration)",
      "15:1121" : "15:1121 (15:1121 Trademark Infringement)",
      "15:1125" : "15:1125 (15:1125 Trademark Infringement (Lanham Act))",
      "15:1125(a)" : "15:1125(a) (15:1125(a) False representation of goods sold in interstate commerce)",
      "15:1125(d)" : "15:1125(d) (15:1125(d)ac Trademark (Anticybersquatting consumer protection))",
      "15:1125la" : "15:1125la (15:1125la Trademark Infringement (Lanham Act))",
      "15:1126" : "15:1126 (15:1126 Patent Infringement)",
      "15:1127" : "15:1127 (15:1127 Trademark Infringement)",
      "15:1191" : "15:1191 (15:1191 Flamable Fabrics Act)",
      "15:1221" : "15:1221 (15:1221 Auto Dealer Suits Agst Manufacturers)",
      "15:1261" : "15:1261 (15:1261 Hazardous Substances (definitions))",
      "15:1263" : "15:1263 (15:1263 Prohibited Hazardous Substance - Interstate Commerce)",
      "15:1267(a)" : "15:1267(a) (15:1267(a) Federal Hazardous Substances Act)",
      "15:1314" : "15:1314 (15:1314 Antitrust--Petition for enforcement)",
      "15:1501" : "15:1501 (15:1501 Estab of Dept of Commerce)",
      "15:1601" : "15:1601 (15:1601 Truth in Lending)",
      "15:1605" : "15:1605 (15:1605 Determination of Finance Charge)",
      "15:1638" : "15:1638 (15:1638 Truth in Lending)",
      "15:1640" : "15:1640 (15:1640 Truth in Lending)",
      "15:1666" : "15:1666 (15:1666 Fair Credit Billing Act Dispute)",
      "15:1667" : "15:1667 (15:1667 Consumer Leasing Act)",
      "15:1679" : "15:1679 (15:1679 Violation of Credit Repair Organizations Act)",
      "15:1681" : "15:1681 (15:1681 Fair Credit Reporting Act)",
      "15:1691" : "15:1691 (15:1691 Equal Credit Opportunity Act)",
      "15:1692" : "15:1692 (15:1692 Fair Debt Collection Act)",
      "15:1693ef" : "15:1693ef (15:1693ef Electronic Funds Transfer Act)",
      "15:1693m" : "15:1693m (15:1693m Violation of Prov. of Subchpt.VI (Electronic Fund Transfers))",
      "15:1701" : "15:1701 (15:1701 Interstate Land Sales Full Disclosure Act (ILFFDA))",
      "15:1709" : "15:1709 (15:1709 Interstate Land Sales )",
      "15:1714" : "15:1714 (15:1714 Actions to enjoin violations re interstate land sale)",
      "15:2071" : "15:2071 (15:2071 Consumer Product Safety; Condemnation hazardous prod)",
      "15:2073" : "15:2073 (15:2073 Private action to enforce Consumer Product Safety)",
      "15:2301" : "15:2301 (15:2301 Magnuson-Moss Warranty Act)",
      "15:2310(c" : "15:2310(c (15:2310(c ) Consumer Product Warranties)",
      "15:2601" : "15:2601 (15:2601 Toxic Substances Control Act (TCSA))",
      "15:2604" : "15:2604 (15:2604 Application for inj re distribution toxic substance)",
      "15:2616" : "15:2616 (15:2616 Toxic Substance control; seizure of chemical)",
      "15:2620" : "15:2620 (15:2620 Toxic Substances Control Act: citizen's petition)",
      "15:2651" : "15:2651 (15:2651 Asbestos Hazard Emergency Response Act)",
      "15:2801" : "15:2801 (15:2801 Petroleum Marketing Practices Act)",
      "15:2805" : "15:2805 (15:2805 Petroleum Marketing Practices-Franchise Protection)",
      "15:34-35" : "15:34-35 (15:34-35 Investment Company Act of 1940 )",
      "15:3414" : "15:3414 (15:3414 National Gas Policy Act)",
      "15:3710a" : "15:3710a (15:3710a Federal Technology Transfer Act of 1986)",
      "15:3901" : "15:3901 (15:3901 Federal Risk Retention Act)",
      "15:45" : "15:45 (15:45 Federal Trade Commission Act (unfair or deceptive acts))",
      "15:53(b)" : "15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equita)",
      "15:6801" : "15:6801 (15:6801 Gram-Leach-Bliley Act)",
      "15:7701" : "15:7701 (15:7701 Federal CAN-Spam Act)",
      "16:0019jj" : "16:0019jj (16:0019jj Park System Resource Protection Act)",
      "16:0470" : "16:0470 (16:0470 Archaeological resources Protection Act)",
      "16:0470f" : "16:0470f (16:0470f National Historic Preservation Act)",
      "16:0668" : "16:0668 (16:668 Bald Eagle Protection Act)",
      "16:0669" : "16:0669 (16:0669 Pittman-Robertson Conservation Restoration Act)",
      "16:0675" : "16:0675 (16:0675 Norbeck Wildlife Preserve Organic Act)",
      "16:0703" : "16:0703 (16:703 Migratory Bird Act)",
      "16:0823a" : "16:0823a (16:0823a Federal Public Utility Regulatory Policies Act)",
      "16:0825" : "16:0825 (16:0825 Federal Power Commission Regulation; Public Utilities)",
      "16:0831" : "16:0831 (16:0831 Actions re: rights of Tennessee Valley Authority)",
      "16:1244" : "16:1244 (16:1244 National Scenic and National Historic Trails)",
      "16:1374(d)" : "16:1374(d) (16:1374(d)(6) Petition for Review re Application for Import of Polar Bear Trophies)",
      "16:1531" : "16:1531 (16:1531 Endangered Species Act)",
      "16:1533" : "16:1533 (16:1533 Endangered Species Act)",
      "16:1538" : "16:1538 (16:1538 Endangered Species Act)",
      "16:1540" : "16:1540 (16:1540 Endangered Species Act - Penalties and Enforcement)",
      "16:1600" : "16:1600 (16:1600 National Forest Management Act of 1976)",
      "16:1801" : "16:1801 (16:1801 Magnuson-Stevens Fishery Conservation and Management Act )",
      "16:1858" : "16:1858 (16:1858 National Fishery Management Program - Civil Penalties and Permit Sanctions)",
      "16:3371" : "16:3371 (16:3371 Wildlife Under the Lacey Act)",
      "16:3372" : "16:3372 (16:3372 Conservation: Complaint for Forfeiture)",
      "16:3373" : "16:3373 (16:3373 Appeal of Decision - DOI)",
      "16:3374" : "16:3374 (16:3374 Conservation: Complaint for Forfeiture)",
      "17:0101" : "17:0101 (17:101 Copyright Infringement)",
      "17:0201" : "17:0201 (17:0201 Ownership of Copyright)",
      "17:0205(d)" : "17:0205(d) (17:0205(d) Priority Between Conflicting Transfers)",
      "17:0407" : "17:0407 (17:0407 Recovery of fines & penalties by Register of Copyrights)",
      "17:0411(b)" : "17:0411(b) (17:0411(b) Action by copyright owner for infringement)",
      "17:0501" : "17:0501 (17:501 Copyright Infringement)",
      "17:0502(a)" : "17:0502(a) (17:0502(a) Inj to prevent or restrain infringement copyright)",
      "17:0504" : "17:0504 (17:504 Copyright Infringement)",
      "17:0512" : "17:0512 (17:0512 Copyright Infringement of Digital Communications)",
      "17:1201" : "17:1201 (17:1201 Digital Millennium Copyright Act)",
      "18:0492" : "18:0492 (18:0492 Forfeiture of Counterfeit Paraphernalia)",
      "18:0603" : "18:0603 (18:0603 Conflict of Interest)",
      "18:0922" : "18:0922 (18:0922 Firearms - Unlawful Possession (Civil Fines) )",
      "18:0923(f)" : "18:0923(f) (18:0923(f)(3) Review of Revocation of a License as a Dealer in Firearms)",
      "18:0925(c" : "18:0925(c (18:0925(c ) Restoration of ability to possess firearms/ammo)",
      "18:1030" : "18:1030 (18:1030 Fraud & Related Activity in Connection with Computers)",
      "18:1345" : "18:1345 (18:1345 Injunction against Fraud)",
      "18:1514" : "18:1514 (18:1514 Civil Action to Restrain Harassment of a Victim)",
      "18:1514A" : "18:1514A (18:1514A Civil Action to Protect Against Retaliation in Fraud Cases)",
      "18:1836a" : "18:1836a (18:1836(a) Injunction against Misappropriation of Trade Secrets)",
      "18:1836b" : "18:1836b (18:1836(b) Civil Action to Protect Trade Secrets)",
      "18:1905" : "18:1905 (18:1905 Disclosure of Confidential Information)",
      "18:1955" : "18:1955 (18:1955 Civil Forfeiture-Prohibition of Illegal Gambling)",
      "18:1956(b)" : "18:1956(b) (18:1956(b)(3) Laundering of Monetary Instruments - Forfeit Property)",
      "18:1964" : "18:1964 (18:1964 Racketeering (RICO) Act)",
      "18:1968" : "18:1968 (18:1968 Action re civil investigative demand)",
      "18:2254" : "18:2254 (18:2254 Civil Forfeiture - Exploitation of Children)",
      "18:2333" : "18:2333 (18:2333 Civil Remedies: Anti-Terrorism Act of 1991)",
      "18:2511" : "18:2511 (18:2511 Wiretapping - Injunctive Relief or Civil Fine)",
      "18:2520" : "18:2520 (18:2520 Civil Damages for Interception Wire or Oral Communications)",
      "18:2707" : "18:2707 (Electronic Communications Privacy Act)",
      "18:2710( c" : "18:2710( c (18:2710( c) Wrongful Disclosure of Video Tape Rental or Sales Records)",
      "18:2724" : "18:2724 (18:2724 Civil Action - Motor Vehicle Records)",
      "18:3114" : "18:3114 (18:3114 Motion for Return of Seized Property)",
      "18:3184" : "18:3184 (18:3184 Extradition Procedure)",
      "18:3663" : "18:3663 (18:3663 Civil Enforcement of Crim. Rest. Obligation)",
      "18:4100" : "18:4100 (18:4100 Transfer of Offenders)",
      "18:981" : "18:981 (18:981 Civil Forfeiture)",
      "18:981(a)(" : "18:981(a)( (18:981(a)(1)(A) Civil Forfeiture: Money Laundering Control Act)",
      "18:983" : "18:983 (18:983 Civil Forfeiture - General Rules)",
      "19:1305" : "19:1305 (19:1305 Custom Duties:0Forfeiture-Immoral Articles)",
      "19:1497" : "19:1497 (19:1497 Customs Duties: Penalty for Failure to Declare)",
      "19:1595a" : "19:1595a (19:1595a Customs Duties: Forfeiture and Other Penalties)",
      "19:1607" : "19:1607 (19:1607 Customs Duties: Notice of Seizure)",
      "20:0107" : "20:0107 (20:0107 Randolph-Sheppard Vending Stand Act)",
      "20:1070" : "20:1070 (20:1070 Student Assistance)",
      "20:1080" : "20:1080 (20:1080 Student Loan Recovery)",
      "20:1087" : "20:1087 (20:1087 Student Loan Discharge)",
      "20:1095a" : "20:1095a (20:1095a Education - Wage Garnishment Requirement)",
      "20:1097" : "20:1097 (20:1097 Education - Criminal penalties for fraud)",
      "20:1098g" : "20:1098g (20:1098g Higher Education Act - Exemption from state disclosure)",
      "20:1232(g)" : "20:1232(g) (20:1232(g) Family Education Rights & Privacy Act of 1974)",
      "20:1400" : "20:1400 (20:1400 Civil Rights of Handicapped Child)",
      "20:1401" : "20:1401 (20:1401 Education: Handicapped Child Act)",
      "20:1412" : "20:1412 (20:1412 IDEA: State Eligibility)",
      "20:1415" : "20:1415 (20:1415 IDEA: Challenge decision re education for handicapped )",
      "20:1415(e)" : "20:1415(e) (20:1415(e)(2)de IDEA: Mediation)",
      "20:1681" : "20:1681 (20:1681 Title IX Educational Amendments 1992 - Sex Discrimination)",
      "20:1683" : "20:1683 (20:1683 Judicial Review: Prohibition against sex discrimination in education)",
      "20:1706" : "20:1706 (20:1706 Relief from denial of equal educational opportunity)",
      "20:1717" : "20:1717 (20:1717 Reopening proceedings w/order to end segregation)",
      "21:0301" : "21:0301 (21:0301 Federal Food, Drug & Cosmetic Act)",
      "21:0331" : "21:0331 (21:0331 Federal Food, Drug & Cosmetic Act - Prohibited Acts)",
      "21:0332" : "21:0332 (21:0332 Federal Food, Drug and Cosmetic Act, Injunctive Relief)",
      "21:0332(a)" : "21:0332(a) (21:0332(a) Federal Food, Drug, and Cosmetic Act)",
      "21:0334(a)" : "21:0334(a) (21:0334(a) Forfeiture or condemnation-food, drug, cosmetics)",
      "21:0348" : "21:0348 (21:0348 Federal Food, Drug and Cosmetic Act - Food Additives)",
      "21:0360" : "21:0360 (21:0360 Federal Food, Drug & Cosmetic Act - Drugs and Devices)",
      "21:0467" : "21:0467 (21:0467 Seizure and condemnation of poultry products)",
      "21:0601" : "21:0601 (21:0601 Federal Meat Inspection Act 21 USC 601-695 (Definitions))",
      "21:0673" : "21:0673 (21:0673 Seizure and condemnation of meat or meat products)",
      "21:0674" : "21:0674 (21:0674 Proceeding to enforce & enjoin re meat products)",
      "21:0821" : "21:0821 (21:0821 Violation of Record Keeping Provision of Controlled Substance Act)",
      "21:0841" : "21:0841 (21:841 Forfeiture Property-Drugs)",
      "21:0842" : "21:0842 (21:0842 Civil Penalty for violation re controlled substance)",
      "21:0881" : "21:0881 (21:881 Forfeiture Property-Drugs)",
      "21:0881a" : "21:0881a (21:881 Forfeiture Property - Aircraft)",
      "21:0881re" : "21:0881re (21:881 Forfeiture Property - Real Estate)",
      "21:0882" : "21:0882 (21:0882 Inj to enjoin violations re controlled substance)",
      "21:1049" : "21:1049 (21:1049 Seizure and condemnation re eggs or egg products)",
      "22:0286" : "22:0286 (22:0286 Action against World Bank or IMF)",
      "22:2702" : "22:2702 (22:2702 Medical Malpractice by Govt. Medical Personnel)",
      "22:3612" : "22:3612 (22:3612 Claim for Damage to Panama Canal)",
      "22:3776" : "22:3776 (22:3776 Panama Canal Commission Action on claims)",
      "22:3777" : "22:3777 (22:3777 Investigation of accident or injury giving rise to a claim)",
      "22:4140" : "22:4140 (22:4140 Foreign Service Grievance Act - Judicial Review)",
      "23:0112" : "23:0112 (23:0112 Federal Highway Act - Letting of Contracts)",
      "23:0134" : "23:0134 (23:134 P.I.- Auto Negligence)",
      "25:1901" : "25:1901 (25:1901 Indian Child Welfare Act)",
      "25:2701" : "25:2701 (25:2701 Indian Gaming Regulatory Act (IGRA))",
      "25:4101" : "25:4101 (25:4101 Native American Housing Assistance and Self-Determination Act (NAHASDA))",
      "26:6212" : "26:6212 (26:6212 Injunctive Relief from IRS Lien)",
      "26:6213" : "26:6213 (26:6213 Injunctive Relief from IRS Lien)",
      "26:6502" : "26:6502 (26:6502 IRS:Enforcement of tax liens)",
      "26:6532" : "26:6532 (26:6532 IRS: Refund of Tax Penalty)",
      "26:6653sp" : "26:6653sp (26:6653sp IRS: Failure to Pay Stamp Tax)",
      "26:6672" : "26:6672 (26:6672 IRS: Failure to Collect and Pay Over Tax, or Attempt to Evade or Defeat Tax)",
      "26:6694" : "26:6694 (26:6694 IRS: Underestimate Of Tax Liability By Tax Preparer)",
      "26:6702" : "26:6702 (26:6702 IRS: Refund of Income Tax Penalty)",
      "26:6703" : "26:6703 (26:6703 IRS: Refund of Tax Penalty)",
      "26:7323" : "26:7323 (26:7323 IRS: Proceedings in rem enforce forfeitures property)",
      "26:7401" : "26:7401 (26:7401 IRS: Tax Liability)",
      "26:7402" : "26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)",
      "26:7403" : "26:7403 (26:7403 Suit to Enforce Federal Tax Lien)",
      "26:7404" : "26:7404 (26:7404 IRS: Action for collection of estate tax)",
      "26:7405" : "26:7405 (26:7405 IRS: Action for recovery of refunds erroneously made)",
      "26:7407" : "26:7407 (26:7407 IRS: Action to enjoin income tax preparers)",
      "26:7422rt" : "26:7422rt (26:7422 IRS: Refund Taxes)",
      "26:7422rx" : "26:7422rx (26:7422 IRS: Refund Excise Tax)",
      "26:7425(a)" : "26:7425(a) (26:7425(a) IRS: Judiciary & Judicial Procedures - Discharge of Liens)",
      "26:7426" : "26:7426 (26:7426 IRS: Wrongful Levy for Taxes)",
      "26:7428" : "26:7428 (26:7428 IRS: Declaratory Judgment)",
      "26:7429" : "26:7429 (26:7429 IRS: Tax Jeopardy Assessment)",
      "26:7430" : "26:7430 (26:7430 IRS: Awarding of Costs and Certain Fees in Tax Suit)",
      "26:7431" : "26:7431 (26:7431 IRS: Unauthorized Disclosure of Return & Return Info)",
      "26:7434" : "26:7434 (26:7434 IRS: Civil Damages for Fraudulent Filing of Information)",
      "26:7604" : "26:7604 (26:7604 IRS: Enforce summons; examination books & witnesses)",
      "26:7604(a)" : "26:7604(a) (26:7604(a) IRS: Complaint to Enforce IRS Summons)",
      "26:7609" : "26:7609 (26:7609 IRS: Petition to Quash IRS Summons)",
      "26:7609en" : "26:7609en (26:7609en IRS: Petition to serve Third-Party Summons)",
      "27:0185" : "27:0185 (27:185 Enforcement of Arbitration Award)",
      "28:0157(b)" : "28:0157(b) (28:0157(b) Bankruptcy Claim to be tried in U.S. District Court)",
      "28:0157(c" : "28:0157(c (28:0157(c )(1) Findings, Concl. & Proposed Judgment)",
      "28:0157(d)" : "28:0157(d) (28:0157(d) Motion for Withdrawal of Reference)",
      "28:0157c" : "28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)",
      "28:0157d" : "28:0157d (28:0157 Motion for Withdrawal of Reference)",
      "28:0158" : "28:0158 (28:0158 Notice of Appeal re Bankruptcy Matter (BA)",
      "28:0463" : "28:0463 (28:0463 Expenses of Judicial Litigation)",
      "28:0534" : "28:0534 (28:0534 Arrest Records)",
      "28:0591" : "28:0591 (28:0591 Independent Counsel)",
      "28:0592" : "28:0592 (28:0592 Independent Counsel - Application for Appointment)",
      "28:0593" : "28:0593 (28:0593 Independent Counsel - Court Responsibilities)",
      "28:0594" : "28:0594 (28:0594 Independent Counsel - Responsibilities)",
      "28:0595" : "28:0595 (28:0595 Independent Counsel - Congressional Oversight)",
      "28:0596" : "28:0596 (28:0596 Independent Counsel - Removal)",
      "28:0597" : "28:0597 (28:0597 Independent Counsel - Dept. of Justice Relationship)",
      "28:0598" : "28:0598 (28:0598 Independent Counsel - Chapter Termination)",
      "28:0636" : "28:0636 (28:0636 Jurisdiction and Power of Magistrate Judges)",
      "28:0754" : "28:0754 (28:0754 Receiver of Property in Different Districts )",
      "28:1291" : "28:1291 (28:1291 Maritime)",
      "28:1330" : "28:1330 (28:1330 Breach of Contract)",
      "28:1331" : "28:1331 (28:1331 Fed. Question)",
      "28:1331(a)" : "28:1331(a) (28:1331(a)rp Fed. Question: Real Property )",
      "28:1331ag" : "28:1331ag (28:1331ag Fed. Question: Employment Discrimination (Age))",
      "28:1331al" : "28:1331al (28:1331 Fed. Question: Airline Crash)",
      "28:1331as" : "28:1331as (28:1331as Fed. Question: Assault, Libel, Slander)",
      "28:1331at" : "28:1331at (28:1331 Fed. Question: Anti-trust)",
      "28:1331au" : "28:1331au (28:1331 Fed. Question: Auto Negligence)",
      "28:1331b" : "28:1331b (28:1331 Federal Question: Bivens Act)",
      "28:1331bc" : "28:1331bc (28:1331 Fed. Question: Breach of Contract)",
      "28:1331ca" : "28:1331ca (28:1331 Fed Question: Fed Communications Act of 1)",
      "28:1331cm" : "28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)",
      "28:1331cr" : "28:1331cr (28:1331cr Fed. Question: Civil Rights (Race Discrimination))",
      "28:1331cv" : "28:1331cv (28:1331 Federal Question: Other Civil Rights)",
      "28:1331dd" : "28:1331dd (28:1331dd Fed. Question: Discovery Disputes (conversion case))",
      "28:1331dj" : "28:1331dj (28:1331dj Fed. Question: Declaratory Judgment)",
      "28:1331dp" : "28:1331dp (28:1331dp Fed. Question: Violation of Due Process)",
      "28:1331ed" : "28:1331ed (28:1331 Fed. Question: Employment Discrimination)",
      "28:1331ef" : "28:1331ef (28:1331ef Fed. Question: Civil Rights Violation (Excess Force))",
      "28:1331ej" : "28:1331ej (28:1331ej Fed. Question: Enforcement of Judgment)",
      "28:1331es" : "28:1331es (28:1331 Enforcement of Administrative Subpoena)",
      "28:1331fa" : "28:1331fa (28:1331fa Fed. Question: Civil Rights Violation-False Arrest)",
      "28:1331fl" : "28:1331fl (28:1331 Fed. Question: Fair Labor Standards)",
      "28:1331fm" : "28:1331fm (28:1331fm Fed. Question: Family and Medical Leave Act)",
      "28:1331fr" : "28:1331fr (28:1331fr Fed. Question: Fraud)",
      "28:1331in" : "28:1331in (28:1331 Fed. Question: Insurance Contract)",
      "28:1331mm" : "28:1331mm (28:1331 Fed. Question: Medical Malpractice)",
      "28:1331ng" : "28:1331ng (28:1331ng Fed. Question: Natural Gas Act)",
      "28:1331ni" : "28:1331ni (28:1331ni Fed. Question: Negotiable Instrument)",
      "28:1331pd" : "28:1331pd (28:1331pd Fed. Question: Property Damage)",
      "28:1331pi" : "28:1331pi (28:1331 Fed. Question: Personal Injury)",
      "28:1331pl" : "28:1331pl (28:1331pl Fed. Question: Product Liability)",
      "28:1331pr" : "28:1331pr (28:1331pr Fed. Question: Federal Prisoner Civil Rights)",
      "28:1331ra" : "28:1331ra (28:1331ra Fed. Question: Racketeering (RICO) Act)",
      "28:1331rc" : "28:1331rc (28:1331rc Fed. Question: Reclamation Project Auth. Act of 1972)",
      "28:1331rd" : "28:1331rd (28:1331 Fed. Question: Review Agency Decision)",
      "28:1331rp" : "28:1331rp (28:1331(a) Fed. Question: Real Property)",
      "28:1331rr" : "28:1331rr (28:1331 Fed. Question: Railway Labor Act)",
      "28:1331rs" : "28:1331rs (28:1331rs Fed. Question: Federal Rail Safety Act)",
      "28:1331sh" : "28:1331sh (28:1331sh Fed. Question: Sexual Harassment)",
      "28:1331ss" : "28:1331ss (28:1331ss Fed. Question: Constitutionality of State Statutes)",
      "28:1331sv" : "28:1331sv (28:1331 Fed. Question: Securities Violation)",
      "28:1331sx" : "28:1331sx (28:1331sx Fed. Question: Employment Discrimination (Sex))",
      "28:1331tr" : "28:1331tr (28:1331 Fed. Question: Trademark)",
      "28:1331tt" : "28:1331tt (28:1331 Fed. Question: Tort Action)",
      "28:1331v" : "28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendme)",
      "28:1331va" : "28:1331va (28:1331va Fed. Question: Violation 5th & 14th Amendment)",
      "28:1331vc" : "28:1331vc (28:1331vc Fed. Question: Violation of Constitutional Rights)",
      "28:1331w" : "28:1331w (28:1331w Fed. Question: Wrongful Termination of Employment)",
      "28:1331wd" : "28:1331wd (28:1331wd Fed. Question: Wrongful Death)",
      "28:1331wl" : "28:1331wl (28:1331 Federal Question: EPA Waste Lien)",
      "28:1331wt" : "28:1331wt (28:1331 Fed. Question: Water Rights)",
      "28:1332" : "28:1332 (28:1332 Diversity Action)",
      "28:1332ac" : "28:1332ac (28:1332 Diversity-Account Receivable)",
      "28:1332al" : "28:1332al (28:1332 Diversity-Airline Crash)",
      "28:1332ap" : "28:1332ap (28:1332ap Diversity-Airplane Product Liability)",
      "28:1332as" : "28:1332as (28:1332 Diversity-Asbestos Litigation)",
      "28:1332au" : "28:1332au (28:1332 Diversity-Auto Negligence)",
      "28:1332bc" : "28:1332bc (28:1332 Diversity-Breach of Contract)",
      "28:1332bw" : "28:1332bw (28:1332bw Diversity -Breach of Warranty)",
      "28:1332co" : "28:1332co (28:1332 Diversity-Conversion)",
      "28:1332ct" : "28:1332ct (28:1332 Diversity-(Citizenship))",
      "28:1332de" : "28:1332de (28:1332de Diversity: Forcible Detainer)",
      "28:1332det" : "28:1332det (28:1332 Diversity: Forcible Detainer)",
      "28:1332df" : "28:1332df (28:1332 Diversity-Contract Default)",
      "28:1332ds" : "28:1332ds (28:1332 Diversity-Contract Dispute)",
      "28:1332dtp" : "28:1332dtp (28:1332dtp Diversity - Deceptive Trade Practices)",
      "28:1332ed" : "28:1332ed (28:1332 Diversity-Employment Discrimination)",
      "28:1332ej" : "28:1332ej (28:1332ej Diversity-Enforcement of Judgment)",
      "28:1332fc" : "28:1332fc (28:1332fc Diversity - Foreclosure)",
      "28:1332fd" : "28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)",
      "28:1332fr" : "28:1332fr (28:1332 Diversity-Fraud)",
      "28:1332ia" : "28:1332ia (28:1332 Diversity-Interpleader Action)",
      "28:1332if" : "28:1332if (28:1332if Diversity- Insurance Fraud)",
      "28:1332ij" : "28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)",
      "28:1332in" : "28:1332in (28:1332 Diversity-Insurance Contract)",
      "28:1332jd" : "28:1332jd (28:1332 Diversity-Declaratory Judgement)",
      "28:1332lb" : "28:1332lb (28:1332 Diversity-Libel,Assault,Slander)",
      "28:1332lm" : "28:1332lm (28:1332 Diversity - Legal Malpractice)",
      "28:1332lp" : "28:1332lp (28:1332lp Diversity-Property Damage/Product Liability)",
      "28:1332lr" : "28:1332lr (28:1332lr Diversity - Labor)",
      "28:1332ma" : "28:1332ma (28:1332 Diversity-Miller Act)",
      "28:1332md" : "28:1332md (28:1332md Diversity-Motor Vehicle/Wrongful Death)",
      "28:1332mm" : "28:1332mm (28:1332 Diversity-Medical Malpractice)",
      "28:1332mv" : "28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)",
      "28:1332ni" : "28:1332ni (28:1332 Diversity-Negotiable Instrument)",
      "28:1332nm" : "28:1332nm (28:1332 Diversity-Non-Motor Vehicle)",
      "28:1332nr" : "28:1332nr (28:1332nr Diversity-Notice of Removal)",
      "28:1332oc" : "28:1332oc (28:1332 Diversity-Other Contract)",
      "28:1332op" : "28:1332op (28:1332op Diversity-Recovery of Overpayment)",
      "28:1332pa" : "28:1332pa (28:1332pa Diversity-Personal Injury/Airplane)",
      "28:1332pd" : "28:1332pd (28:1332 Diversity-Property Damage)",
      "28:1332pi" : "28:1332pi (28:1332 Diversity-Personal Injury)",
      "28:1332pl" : "28:1332pl (28:1332 Diversity-Product Liability)",
      "28:1332pr" : "28:1332pr (28:1332 Diversity-Petition for Removal)",
      "28:1332qt" : "28:1332qt (28:1332 Diversity-Petition to Quiet Title)",
      "28:1332rd" : "28:1332rd (28:1332rd Diversity-Recovery of Debt)",
      "28:1332ri" : "28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)",
      "28:1332rl" : "28:1332rl (28:1332rl Diversity-Rent Lease & Ejectment)",
      "28:1332rp" : "28:1332rp (28:1332rp Diversity-Real Property)",
      "28:1332sa" : "28:1332sa (28:1332 - Diversity: Securities & Exchange Commiss)",
      "28:1332sf" : "28:1332sf (28:1332 - Diversity: Securities Fraud)",
      "28:1332sh" : "28:1332sh (28:1332sh Diversity-Sexual Harassment)",
      "28:1332ss" : "28:1332ss (28:1332 Diversity - Stockholders Suits)",
      "28:1332t" : "28:1332t (28:1332t Diversity-Torts)",
      "28:1332tl" : "28:1332tl (28:1332 Diversity-Torts to Land)",
      "28:1332tm" : "28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))",
      "28:1332tn" : "28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)",
      "28:1332ts" : "28:1332ts (28:1332ts Diversity-Misappropriation of Trade Secrets)",
      "28:1332vt" : "28:1332vt (28:1332vt Diversity-Natl Motor Vehicle Title Information System)",
      "28:1332wc" : "28:1332wc (28:1332wc Diversity- Worker's Compensation Benefits)",
      "28:1332wd" : "28:1332wd (28:1332 Diversity-Wrongful Death)",
      "28:1333" : "28:1333 (28:1333 Admiralty)",
      "28:1333ad" : "28:1333ad (28:1333ad Admiralty)",
      "28:1333in" : "28:1333in (28:1333in Personal Injury)",
      "28:1333mc" : "28:1333mc (28:1333mc Marine Contract)",
      "28:1333pd" : "28:1333pd (28:1333pd Property Damage)",
      "28:1333pi" : "28:1333pi (28:1333pi Marine Personal Injury)",
      "28:1334" : "28:1334 (28:1334 Bankruptcy Appeal)",
      "28:1334(b)" : "28:1334(b) (28:1334(b) Proceeding arising/related to case under title 11)",
      "28:1334(c" : "28:1334(c (28:1334(c ) R&R re motions for abstention)",
      "28:1335" : "28:1335 (28:1335 Interpleader Action)",
      "28:1337" : "28:1337 (28:1337 Sherman-Clayton Act)",
      "28:1337sc" : "28:1337sc (28:1337sc Sherman-Clayton Act)",
      "28:1338cp" : "28:1338cp (28:1338 Copyright Infringement)",
      "28:1338pt" : "28:1338pt (28:1338 Patent Infringement)",
      "28:1338tr" : "28:1338tr (28:1338 Trademark Infringement)",
      "28:1339" : "28:1339 (28:1339 Postal matters)",
      "28:1340" : "28:1340 (28:1340 IRS: Custom Duties)",
      "28:1340er" : "28:1340er (28:1340 Recovery of Erroneous Refund)",
      "28:1340tp" : "28:1340tp (28:1340tp Jurisdiction of Internal Revenue Matters; Customs Duties)",
      "28:1341" : "28:1341 (28:1341 Complaint for Forfeiture)",
      "28:1343" : "28:1343 (28:1343 Violation of Civil Rights)",
      "28:1344" : "28:1344 (28:1344 Election disputes)",
      "28:1345" : "28:1345 (28:1345 U.S. Plaintiff)",
      "28:1345co" : "28:1345co (28:1345 Replevin & Conversion)",
      "28:1345db" : "28:1345db (28:1345 Debt to US - FHA/HUD Title I)",
      "28:1345df" : "28:1345df (28:1345 Default of Promissory Note)",
      "28:1345er" : "28:1345er (28:1345 Recovery of Erroneous Refund)",
      "28:1345fc" : "28:1345fc (28:1345 Foreclosure)",
      "28:1345ff" : "28:1345ff (28:1345 Complaint for Forfeiture)",
      "28:1345hl" : "28:1345hl (28:1345 VA Home Loan Guaranty Debt)",
      "28:1345lc" : "28:1345lc (28:1345lc Land Condemnation)",
      "28:1345mc" : "28:1345mc (28:1345 Medical Care Recovery)",
      "28:1345mi" : "28:1345mi (28:1345 Mining Claim Ejectment)",
      "28:1345pd" : "28:1345pd (28:1345 Property Damage)",
      "28:1345pe" : "28:1345pe (28:1345 Property Ejectment)",
      "28:1345rc" : "28:1345rc (28:1345 Recovery of Debt to US)",
      "28:1345ro" : "28:1345ro (28:1345ro Recovery of Retirement Overpayment)",
      "28:1345st" : "28:1345st (28:1345 Default of Student Loan)",
      "28:1345tp" : "28:1345tp (28:1345 Trespass on Public Land)",
      "28:1345tx" : "28:1345tx (28:1345tx Prohibit dfts assessing tx on purch/use of pers prop)",
      "28:1345va" : "28:1345va (28:1345 Recovery of VA Overpayment)",
      "28:1346" : "28:1346 (28:1346 U.S. Defendant)",
      "28:1346bc" : "28:1346bc (28:1346 Breach of Contract)",
      "28:1346pi" : "28:1346pi (28:1346pi Marine Personal Injury (or tort claim - personal injury / motor vehicle))",
      "28:1346rc" : "28:1346rc (28:1346 Recovery of IRS Tax)",
      "28:1346t" : "28:1346t (28:1346t Tort Claim)",
      "28:1346tc" : "28:1346tc (28:1346 Tort Claim)",
      "28:1346wd" : "28:1346wd (28:1346 Wrongful Death)",
      "28:1348" : "28:1348 (28:1348 Banking association as party)",
      "28:1349" : "28:1349 (28:1349 Corporation organized under Federal Law as party)",
      "28:1350" : "28:1350 (28:1350 Alien Tort Claims Act)",
      "28:1352" : "28:1352 (28:1352 Miller Act)",
      "28:1355" : "28:1355 (28:1355 Petition for Return of Property)",
      "28:1356" : "28:1356 (28:1356 Executory Process/Foreclosure)",
      "28:1358" : "28:1358 (28:1358 Land Condemnation)",
      "28:1361" : "28:1361 (28:1361 Petition for Writ of Mandamus)",
      "28:1361pr" : "28:1361pr (28:1361pr Complaint for mandamus relief (prisoner))",
      "28:1362ic" : "28:1362ic (28:1362 Indian Tribal Controversy)",
      "28:1362iw" : "28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)",
      "28:1363" : "28:1363 (28:1363 Action for protection of jurors employment rights)",
      "28:1364" : "28:1364 (28:1364 Auto Negligence)",
      "28:1367" : "28:1367 (28:1367 Other Property Damage)",
      "28:1394" : "28:1394 (28:1394 Banking Assoc action agst Comptroller of Currency)",
      "28:1395" : "28:1395 (28:1395 Complaint for Forfeiture )",
      "28:1402" : "28:1402 (28:1402 Medical Malpractice)",
      "28:1403" : "28:1403 (28:1403 Condemnation of real estate for the use of the US)",
      "28:1407" : "28:1407 (28:1407 Airline Crash)",
      "28:1407im" : "28:1407im (28:1407im MDL: Silicone Gel Breast Implant Products Liability)",
      "28:1407md" : "28:1407md (28:1407md MDL: Multidistrict Litigation)",
      "28:1407n" : "28:1407n (28:1407n MDL: Personal Injury/Norplant Product Liability)",
      "28:1407pl" : "28:1407pl (28:1407pl MDL: Products Liability)",
      "28:1441ac" : "28:1441ac (28:1441 Petition for Removal- Account Receivable)",
      "28:1441ada" : "28:1441ada (28:1441ada Removal- Americans with Disabilities Act)",
      "28:1441ag" : "28:1441ag (28:1441ag Removal- Civil Rights (Age))",
      "28:1441al" : "28:1441al (28:1441 Petition for Removal- Airline Crash)",
      "28:1441as" : "28:1441as (28:1441 Petition for Removal- Asbestos Litigation)",
      "28:1441au" : "28:1441au (28:1441 Petition for Removal- Auto Negligence)",
      "28:1441ba" : "28:1441ba (28:1441ba Removal - National Bank Act)",
      "28:1441bc" : "28:1441bc (28:1441 Petition for Removal- Breach of Contract)",
      "28:1441bfd" : "28:1441bfd (28:1441bfd Removal- Breach of Fiduciary Duties)",
      "28:1441ca" : "28:1441ca (28:1441ca Removal - Carmack Amendment)",
      "28:1441cc" : "28:1441cc (28:1441cc Removal- Computer Crimes Act)",
      "28:1441cj" : "28:1441cj (28:1441cj Removal- Confessed Judgement)",
      "28:1441cla" : "28:1441cla (28:1441cla Removal - Consumer Leasing Act)",
      "28:1441cp" : "28:1441cp (28:1441cp Removal- Copyright)",
      "28:1441cpl" : "28:1441cpl (28:1441cpl Removal - Contract Product Liability)",
      "28:1441cra" : "28:1441cra (28:1441cra Removal - Fair Credit Reporting Act)",
      "28:1441cv" : "28:1441cv (28:1441 Petition for Removal- Civil Rights Act)",
      "28:1441dea" : "28:1441dea (28:1441dea Removal - Disabilities Education Act)",
      "28:1441df" : "28:1441df (28:1441 Petition for Removal- Contract Default)",
      "28:1441di" : "28:1441di (28:1441di Removal- Civil Rights (Disability Act))",
      "28:1441dj" : "28:1441dj (28:1441 Petition for Removal- Declaratory Judgemen)",
      "28:1441ds" : "28:1441ds (28:1441 Petition for Removal- Contract Dispute)",
      "28:1441ea" : "28:1441ea (28:1441ea Removal- Employment Discrimination (Age))",
      "28:1441eb" : "28:1441eb (28:1441eb Removal - E.R.I.S.A. Employee Benefits)",
      "28:1441ec" : "28:1441ec (28:1441ec Removal - Electronic Comm. Privacy Act)",
      "28:1441ed" : "28:1441ed (28:1441 Petition for Removal - Employment Discrim)",
      "28:1441em" : "28:1441em (28:1441em Removal - Emergency Medical Treatment & Active Labor)",
      "28:1441er" : "28:1441er (28:1441er Removal- Employment Discrimination (Race))",
      "28:1441es" : "28:1441es (28:1441es Removal- Employment Discrimination (Sex))",
      "28:1441fa" : "28:1441fa (28:1441fa Removal - Civil Rights - False Arrest)",
      "28:1441fc" : "28:1441fc (28:1441 Petition for Removal - Fair Credit Reporti)",
      "28:1441fd" : "28:1441fd (28:1441fd Removal - Fair Debt Collection Practices Act)",
      "28:1441fe" : "28:1441fe (28:1441fe Removal- Fed. Employee Garnishment Statute)",
      "28:1441fh" : "28:1441fh (28:1441fh Removal- FEHBA)",
      "28:1441fif" : "28:1441fif (28:1441fif Removal - Insecticide/Fungicide/Rodenticide Act -1942)",
      "28:1441fl" : "28:1441fl (28:1441fl Removal- Fair Labor Standards Act)",
      "28:1441fm" : "28:1441fm (28:1441fm Removal - Family and Medical Leave Act)",
      "28:1441fr" : "28:1441fr (28:1441 Petition for Removal- Fraud)",
      "28:1441fs" : "28:1441fs (28:1441fs Removal - Foreign Sovereign Immunities Act)",
      "28:1441fsa" : "28:1441fsa (28:1441fsa Removal - Federal Food Stamp Act)",
      "28:1441hb" : "28:1441hb (28:1441hb Removal - Petition of Habeas Corpus)",
      "28:1441hc" : "28:1441hc (28:1441hc Removal - Handicapped Child Protection Act)",
      "28:1441hd" : "28:1441hd (28:1441hd Removal- Housing Discrimination)",
      "28:1441ia" : "28:1441ia (28:1441ia Removal- Interstate Commerce Act)",
      "28:1441if" : "28:1441if (28:1441if Removal - Insurance Fraud)",
      "28:1441ij" : "28:1441ij (28:1441 Petition for Removal- Injunctive/Declarato)",
      "28:1441il" : "28:1441il (28:1441il Removal- Interstate Land Full Discloser Act)",
      "28:1441in" : "28:1441in (28:1441 Petition for Removal- Insurance Contract)",
      "28:1441int" : "28:1441int (28:1441 Petition for Removal- Action for Interplea)",
      "28:1441la" : "28:1441la (28:1441la Removal - Truth in Lending Act)",
      "28:1441lb" : "28:1441lb (28:1441 Petition for Removal Libel,Assault,Slander)",
      "28:1441lm" : "28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relatio)",
      "28:1441ml" : "28:1441ml (28:1441ml Removal- Motor Vehicle Prod Liability)",
      "28:1441mm" : "28:1441mm (28:1441 Petition for Removal- Medical Malpractice)",
      "28:1441mv" : "28:1441mv (28:1441mv Removal- Motor Vehicle)",
      "28:1441ni" : "28:1441ni (28:1441 Petition for Removal- Negotiable Instrumen)",
      "28:1441nm" : "28:1441nm (28:1441 Petition for Removal- Non-Motor Vehicle)",
      "28:1441nr" : "28:1441nr (28:1441nr Notice of Removal)",
      "28:1441oc" : "28:1441oc (28:1441 Petition For Removal--Other Contract)",
      "28:1441pa" : "28:1441pa (28:1441pa Removal - Patent Infringement)",
      "28:1441pd" : "28:1441pd (28:1441 Petition for Removal- Property Damage)",
      "28:1441pi" : "28:1441pi (28:1441 Petition for Removal- Personal Injury)",
      "28:1441pl" : "28:1441pl (28:1441 Petition for Removal- Product Liability)",
      "28:1441pr" : "28:1441pr (28:1441 Petition for Removal)",
      "28:1441qt" : "28:1441qt (28:1441 Petition for Removal- Petition to Quiet Ti)",
      "28:1441ra" : "28:1441ra (28:1441ra Removal- Civil Rights (Race))",
      "28:1441ri" : "28:1441ri (28:1441 Petition for Removal- Racketeering (RICO))",
      "28:1441rl" : "28:1441rl (28:1441rl Removal- Rent, Lease, & Ejectment)",
      "28:1441sa" : "28:1441sa (28:1441 - Petition for Removal: SEC Act)",
      "28:1441sf" : "28:1441sf (28:1441 - Petition for Removal: Securities Fraud)",
      "28:1441sh" : "28:1441sh (28:1441sh Removal-Sexual Harassment)",
      "28:1441st" : "28:1441st (28:1441st Removal - Stockholders Suit)",
      "28:1441sv" : "28:1441sv (28:1441sv Removal-Security Violation)",
      "28:1441sx" : "28:1441sx (28:1441sx Removal-Civil Rights (Sex))",
      "28:1441tc" : "28:1441tc (28:1441tc Removal - Tricare Program)",
      "28:1441ti" : "28:1441ti (28:1441ti Removal-Trademark Infringement)",
      "28:1441til" : "28:1441til (28:1441til Removal - Truth and Lending)",
      "28:1441tl" : "28:1441tl (28:1441 Petition for Removal- Torts to Land)",
      "28:1441tm" : "28:1441tm (28:1441 Petition for Removal- Tort/Motor Vehicle ()",
      "28:1441tn" : "28:1441tn (28:1441 Petition for Removal- Tort/Non-Motor Vehic)",
      "28:1441us" : "28:1441us (28:1441us Removal - Uniformed Svc Emp/Reemp Rights Act)",
      "28:1441wc" : "28:1441wc (28:1441wc Removal - Worker's Compensation Benefits)",
      "28:1441wd" : "28:1441wd (28:1441 Petition for Removal- Wrongful Death)",
      "28:1441wt" : "28:1441wt (28:1441wt Removal- Employment (Wrongful Termination))",
      "28:1442" : "28:1442 (28:1442 Notice of Removal - Suit against Federal Officer)",
      "28:1442aaf" : "28:1442aaf (28:1442aaf Petition for Removal - Agst members of armed forces)",
      "28:1443" : "28:1443 (28:1443(1) Removal - Civil Rights: Rent, Lease & Ejectment)",
      "28:1444" : "28:1444 (28:1444 Petition for Removal- Foreclosure)",
      "28:1446al" : "28:1446al (28:1446al Notice of Removal - Airline Crash)",
      "28:1446as" : "28:1446as (28:1446as Notice of Removal - Asbestos Litigation)",
      "28:1446bc" : "28:1446bc (28:1446bc Notice of Removal - Breach of Contract)",
      "28:1446cs" : "28:1446cs (28:1446cs Notice of Removal - Child Support Enforcement)",
      "28:1446dj" : "28:1446dj (28:1446dj Notice of Removal - Declaratory Judgment)",
      "28:1446er" : "28:1446er (28:1446er Notice of Removal - E.R.I.S.A)",
      "28:1446fm" : "28:1446fm (28:1446fm Notice of Removal - Family and Medical Leave Act)",
      "28:1446fr" : "28:1446fr (28:1446fr Notice of Removal - Fraud)",
      "28:1446in" : "28:1446in (28:1446 Breach of Contract- Insurance)",
      "28:1446lb" : "28:1446lb (28:1446lb Notice of Removal - Libel, Assault, Slander)",
      "28:1446ml" : "28:1446ml (28:1446ml Notice of Removal - Motor Vehicle Prod Liability)",
      "28:1446mm" : "28:1446mm (28:1446mm Notice of Removal - Medical Malpractice)",
      "28:1446mv" : "28:1446mv (28:1446mv Notice of Removal - Motor Vehicle)",
      "28:1446ni" : "28:1446ni (28:1446ni Notice of Removal - Negotiable Instrument)",
      "28:1446nr" : "28:1446nr (28:1446nr Notice of Removal)",
      "28:1446oc" : "28:1446oc (28:1446oc Notice of Removal - Other Contract)",
      "28:1446pd" : "28:1446pd (28:1446 Petition for Removal- Property Damage (P.I)",
      "28:1446pi" : "28:1446pi (28:1446 Petition for Removal- Personal Injury)",
      "28:1446pl" : "28:1446pl (28:1446pl Petition for Removal - Product Liability)",
      "28:1446pr" : "28:1446pr (28:1446 Petition for Removal)",
      "28:1446st" : "28:1446st (28:1446st Notice of Removal - Stockholders Suit)",
      "28:1446tl" : "28:1446tl (28:1446tl Notice of Removal - Torts to Land)",
      "28:1446wd" : "28:1446wd (28:1446wd Notice of Removal - Wrongful Death)",
      "28:1452" : "28:1452 (28:1452 R&R re motions to remand (non-core))",
      "28:1453" : "28:1453 (28:1453 Class Action Fairness Act)",
      "28:1491" : "28:1491 (28:1491 Tucker Act)",
      "28:1602" : "28:1602 (28:1602 Foreign Sovereign Immunities Act)",
      "28:1605" : "28:1605 (28:1605 Foreign Sovereign Immunities Act of 1976)",
      "28:1605A" : "28:1605A (28:1605A Antiterrorism & Effective Death Penalty Act 1996)",
      "28:1610" : "28:1610 (28:1610 Juridictional Immunities of Foreign States)",
      "28:1631" : "28:1631 (28:1631 Case Transferred to Cure Want of Jurisdiction)",
      "28:1651cn" : "28:1651cn (28:1651cn Petition for Writ of Error Coram Nobis )",
      "28:1651hc" : "28:1651hc (28:1651 Petition for Writ of Habeas Corpus)",
      "28:1651mn" : "28:1651mn (28:1651 Petition for Writ of Mandamus)",
      "28:1651ne" : "28:1651ne (28:1651ne Application for Writ Ne Exeat)",
      "28:1651w" : "28:1651w (28:1651w All Writs Act)",
      "28:1715" : "28:1715 (28:1715 Class Action Fairness Act of 2005)",
      "28:1732" : "28:1732 (28:1732 Reproduction of Records)",
      "28:1738Acs" : "28:1738Acs (28:1738Acs The Uniform Child Custody Jurisdiction Act)",
      "28:1782" : "28:1782 (28:1782 Assistance to Foreign Tribunals (incl letter rogatory))",
      "28:1783" : "28:1783 (28:1783 Petition for Subpoena of person in foreign country)",
      "28:1826" : "28:1826 (28:1826 Order of confinement of recalcitrant witness)",
      "28:1875" : "28:1875 (28:1875 Juror Protection Act / Protection of Jurors' Employment)",
      "28:1916" : "28:1916 (28:1916 Marine Personal Injury)",
      "28:1963" : "28:1963 (28:1963 Registration of judgment from another district)",
      "28:2001" : "28:2001 (28:2001 Judicial Sale of Realty)",
      "28:2071" : "28:2071 (28:2071 Rule Making Power Generally)",
      "28:2201" : "28:2201 (28:2201 Constitutionality of State Statute(s))",
      "28:2201an" : "28:2201an (28:2201an Declaratory Judgement (aliens and nationality))",
      "28:2201cp" : "28:2201cp (28:2201cp Declaratory Judgment (Copyright))",
      "28:2201dj" : "28:2201dj (28:2201 Declaratory Judgement)",
      "28:2201fa" : "28:2201fa (28:2201fa Declaratory Judgment- Firearms)",
      "28:2201fs" : "28:2201fs (28:2201fs Declaratory Judgment (Food Security Act))",
      "28:2201ij" : "28:2201ij (28:2201 Injunction)",
      "28:2201in" : "28:2201in (28:2201 Declaratory Judgement (Insurance))",
      "28:2201pi" : "28:2201pi (28:2201pi Declaratory Judgment - Personal Injury)",
      "28:2241" : "28:2241 (28:2241 Petition for Writ of Habeas Corpus (federa)",
      "28:2241fd" : "28:2241fd (28:2241fd Petition for Writ of Habeas Corpus (federal))",
      "28:2241in" : "28:2241in (28:2241in Habeas Corpus: INS)",
      "28:2241st" : "28:2241st (28:2241st Petition for Writ of Habeas Corpus (State))",
      "28:2244" : "28:2244 (28:2244 Habeas Corpus - Finality of Determination)",
      "28:2254" : "28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))",
      "28:2254dp" : "28:2254dp (28:2254dp Petition for Writ of Habeas Corpus (Death Penalty))",
      "28:2254se" : "28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)",
      "28:2255" : "28:2255 (28:2255 Motion to Vacate / Correct Illegal Sentenc)",
      "28:2283" : "28:2283 (28:2283 Stay of State Court Proceedings (Injunctive Relief))",
      "28:2347" : "28:2347 (28:2347 Petition to Review Orders in the Ct of Appeals)",
      "28:2401" : "28:2401 (28:2401 Federal Tort Claims Act (Time for commencing action against the US))",
      "28:2403" : "28:2403 (28:2403 Constitutionality of State Statute(s) )",
      "28:2405" : "28:2405 (28:2405 Garnishment of debtors of a corporation by US)",
      "28:2409" : "28:2409 (28:2409(a) Quiet Title Action)",
      "28:2409(a)" : "28:2409(a) (28:2409(a) Quiet Title Action)",
      "28:2410" : "28:2410 (28:2410 Quiet Title)",
      "28:2412" : "28:2412 (28:2412 Equal Access to Justice Act)",
      "28:2415" : "28:2415 (28:2415 Detinue and Conversion)",
      "28:2671" : "28:2671 (28:2671 Federal Tort Claims Act)",
      "28:2672mv" : "28:2672mv (28:2672mv Federal Tort Claims Act - Motor Vehicle)",
      "28:2672pi" : "28:2672pi (28:2672pi Federal Tort Claim Act - Personal Injury)",
      "28:2674" : "28:2674 (28:2674 Federal Tort Claims Act)",
      "28:2675" : "28:2675 (28:2675 Federal Tort Claims Act - Disposition by Agency Req)",
      "28:2679(d)" : "28:2679(d) (28:2679(d)(2) Federal Tort Claims Act - Employee of U.S.A.)",
      "28:2680" : "28:2680 (28:2680 Federal Tort Claims Act - Exceptions)",
      "28:3001" : "28:3001 (28:3001 Federal Debt Collection Act)",
      "28:3001(a)" : "28:3001(a) (28:3001(a) Federal Debt Collection Procedures Act of 1990)",
      "28:3203" : "28:3203 (28:3203 Postjudgment Remedies: Writ of Execution)",
      "28:3301" : "28:3301 (28:3301 Fraudulent Transfer Federal Debt Collection Procedures Act)",
      "28:7402" : "28:7402 (28:7402 Refund of Taxes)",
      "28:7422" : "28:7422 (28:7422 Appeal from Administrative Decision)",
      "29:0101" : "29:0101 (29:0101 Labor: Issuance of Restraining Orders and Injunctions )",
      "29:0151" : "29:0151 (29:151 Labor: Review of Agency Action)",
      "29:0158(b)" : "29:0158(b) (29:0158(b) Labor: NLRA - Unfair Labor Practices)",
      "29:0159" : "29:0159 (29:0159 Labor: Violation of Collective Bargaining Agreement )",
      "29:0160" : "29:0160 (29:160(1) National Labor Relations Act)",
      "29:0160j" : "29:0160j (29:0160j Labor: Petition for Inj - Relief from Unfair Labor Practice)",
      "29:0160l" : "29:0160l (29:0160l Labor: Petition for Inj re Uncertified Labor Organizations)",
      "29:0161(2)" : "29:0161(2) (29:0161(2) Labor: Enforcement of agency subpoena)",
      "29:0178" : "29:0178 (29:0178 Labor: Petition for Inj to Enjoin Strike during Natl Emergency)",
      "29:0184" : "29:0184 (29:184 Violation Collection Bargain Agreement)",
      "29:0185" : "29:0185 (29:0185 Labor: Suits by and against Labor Organizations)",
      "29:0185ep" : "29:0185ep (29:185 Employee Pension Plan)",
      "29:0185lm" : "29:0185lm (29:185 Labor/Mgt. Relations (Contracts))",
      "29:0186" : "29:0186 (29:0186 Labor: Liabilities of and Restrictions on Labor and Management)",
      "29:0187" : "29:0187 (29:0187 Labor: Recover Damages from Unfair Labor Practice)",
      "29:0201do" : "29:0201do (29:201 Denial of Overtime Compensation)",
      "29:0201fl" : "29:0201fl (29:201 Fair Labor Standards Act)",
      "29:0203" : "29:0203 (29:203 Equal Pay Act)",
      "29:0206" : "29:0206 (29:206 Collect Unpaid Wages)",
      "29:0206(d)" : "29:0206(d) (29:0206(d) FLSA: Prohibition of Sex Discrimination)",
      "29:0207(a)" : "29:0207(a) (29:0207(a) FLSA: Action for Overtime Wage Violation)",
      "29:0207fl" : "29:0207fl (29:0207fl FLSA: Maximum Hours)",
      "29:0210" : "29:0210 (29:0210 FLSA: Court Review of Wage Orders in PR and VI)",
      "29:0215fl" : "29:0215fl (29:0215fl FLSA: Prohibited Acts)",
      "29:0216(b)" : "29:0216(b) (29:0216(b) FLSA: Minimum wage or overtime compensation)",
      "29:0216(e)" : "29:0216(e) (29:0216(e) FLSA: Penalty assessed for child labor provisions)",
      "29:0217" : "29:0217 (29:0217 FLSA: Enjoin Violations of Fair Labor Standards Act)",
      "29:0260" : "29:0260 (29:0260 FLSA: Liquidated Damages)",
      "29:0401" : "29:0401 (29:0401 Labor Management Disclosure Act)",
      "29:0411" : "29:0411 (29:0411 Landrum Griffin Act)",
      "29:0412" : "29:0412 (29:0412 Infringement of rights; members of labor organization)",
      "29:0440" : "29:0440 (29:0440 violations reporting requirements; labor organization)",
      "29:0501(b)" : "29:0501(b) (29:0501(b) Violation of Fiduciary Responsibility)",
      "29:0621" : "29:0621 (29:621 Job Discrimination (Age))",
      "29:0623" : "29:0623 (29:623 Job Discrimination (Age))",
      "29:0626" : "29:0626 (29:626 Job Discrimination (Age))",
      "29:0633" : "29:0633 (29:633 Job Discrimination (Age))",
      "29:0651" : "29:0651 (29:651 Occupational Safety/Health)",
      "29:0660" : "29:0660 (29:0660 Action by Sec Labor for discrimination re rights OSHA)",
      "29:0662" : "29:0662 (29:0662 Inj proceedings re dangerous emp conditions; by Sec.)",
      "29:0666" : "29:0666 (29:0666 Collection of civil penalties under OSHA)",
      "29:0701" : "29:0701 (29:0701 Vocational Rehabilitation)",
      "29:0791" : "29:0791 (29:791 Job Discrimination (Rehabilitation Act))",
      "29:0792(d)" : "29:0792(d) (29:0792(d)(2) Accessible facilities for phys. handicapped emp)",
      "29:0794" : "29:0794 (29:0794 Job Discrimination (Handicap))",
      "29:1001" : "29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)",
      "29:1002" : "29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)",
      "29:1055" : "29:1055 (29:1055 E.R.I.S.A., Employee Retirement (Joint and Survivor Annuity))",
      "29:1101" : "29:1101 (29:1101 E.R.I.S.A.: Coverage)",
      "29:1104" : "29:1104 (29:1104 Recovery of Benefits to Employee)",
      "29:1109" : "29:1109 (29:1109 Breach of Fiduciary Duties)",
      "29:1132" : "29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)",
      "29:1145" : "29:1145 (29:1145 E.R.I.S.A.)",
      "29:1149" : "29:1149 (29:1149 Recover Pension & Profit Sharing)",
      "29:1161" : "29:1161 (29:1161 COBRA - Continuation Coverage)",
      "29:1162" : "29:1162 (29:1162 COBRA - Continuation Coverage)",
      "29:1303" : "29:1303 (29:1303 PBGC: Operation of Corporation)",
      "29:1362" : "29:1362 (29:1362 ERISA)",
      "29:1381" : "29:1381 (29:1381 E.R.I.S.A.)",
      "29:1401" : "29:1401 (29:1401(b)(2) Appeal of Arbitration Award)",
      "29:1401(b)" : "29:1401(b) (29:1401(b)(2) E.R.I.S.A.: Resolution of Disputes - Appeal of Arbitration Award)",
      "29:1451" : "29:1451 (29:1451 E.R.I.S.A.)",
      "29:1801" : "29:1801 (29:1801 Farmworker Rights)",
      "29:1854" : "29:1854 (29:1854 Migrant & Seasonal Agri Worker Protect Act (AWPA))",
      "29:1916" : "29:1916 (29:1916 Spec. Rule for Longshoremen & Harborworkers)",
      "29:2001" : "29:2001 (29:2001 Employee Polygraph Protection Act)",
      "29:2101" : "29:2101 (29:2101 Worker Adjustment Retraining Notification Act)",
      "29:2102" : "29:2102 (29:2102 Notice required before plant closings and mass layoffs)",
      "29:2104" : "29:2104 (29:2104 Worker Adjustment & Retraining Notification (WARN))",
      "29:2601" : "29:2601 (29:2601 FMLA: Family and Medical Leave Act (Findings and Purposes))",
      "29:2611" : "29:2611 (29:2611 FMLA: Definitions)",
      "29:2612" : "29:2612 (29:2612 FMLA: Leave Requirements)",
      "29:2617" : "29:2617 (29:2617 Family and Medical Leave Act)",
      "30:0022" : "30:0022 (30:0022 General Mining Law of 1872 (Lands Open to Purchase by Citizens))",
      "30:0181" : "30:0181 (30:181 Environment: Review of Agency Action)",
      "30:0801" : "30:0801 (30:0801 Penalities/Federal Mine Safety Health Act)",
      "30:0815" : "30:0815 (30:0815 Federal Mine Safety & Health Act (Procedure for Enforcement))",
      "30:1201" : "30:1201 (30:1201 Environment: Review of Agency Action)",
      "30:1202" : "30:1202 (30:1202 Mining Reclamation Act)",
      "30:1276" : "30:1276 (30:1276 Interior: Review of Agency Action)",
      "30:1701" : "30:1701 (30:1701 Federal Oil Gas Royalty Mgt Act 1982 (FOGRMA))",
      "31:0732" : "31:0732 (31:0732 General Acct. Office Personnel Act of 1980 (Personnel Management System))",
      "31:1341" : "31:1341 (31:1341 Government employee--limitations on expending monies)",
      "31:3545" : "31:3545 (31:3545 Action to Recovery Money)",
      "31:3702" : "31:3702 (31:3702 Procedures for Settling Claims )",
      "31:3713" : "31:3713 (31:3713 Priority of Government Claims)",
      "31:3720" : "31:3720 (31:3720 Federal Income Tax Interceptions (Collection of Payments))",
      "31:3728" : "31:3728 (31:3728 Setoff against Judgment )",
      "31:3729" : "31:3729 (31:3729 False Claims Act)",
      "31:3730" : "31:3730 (31:3730 Qui Tam False Claims Act)",
      "31:3731" : "31:3731 (31:3731 Fraud)",
      "31:3733(j)" : "31:3733(j) (31:3733(j)(2) Pet to Mod or Set Aside CV Investigative Demand)",
      "31:5314" : "31:5314 (31:5314 Failure to Report Interest in Foreign Accounts)",
      "31:5332(a)" : "31:5332(a) (31:5332(a) Evading Currency Reporting Requirement)",
      "31:5332(f)" : "31:5332(f) (31:5332(f) Transport and Transfer US currency from in to out)",
      "31:6716" : "31:6716 (31:6716 Discrimination re money and finance )",
      "31:9701" : "31:9701 (31:9701 Federal User Charge Statute)",
      "33:0408" : "33:0408 (33:0408 Injury to Harbor Improvement)",
      "33:0412" : "33:0412 (33:412 Liability of Pilots & Vessels Engaged in Violations)",
      "33:0594" : "33:0594 (33:0594 Land Condemnation)",
      "33:0901" : "33:0901 (33:0901 Longshoremen Harbor Workers Compensation Act (Navigation and Navigable Waters))",
      "33:0905(b)" : "33:0905(b) (33:0905(b) Longshoremen Workers' Compensation Act - Recovery of Damages caused by the negligence of )",
      "33:0918" : "33:0918 (33:0918 Longshore and Harbor Workers Compensation Act - Collection of Defaulted Payments)",
      "33:0921" : "33:0921 (33:0921 Longshore & Harbor Workers Compensation Act - Review of Compensation Orders)",
      "33:0933" : "33:0933 (33:0933 Longshore and Harbor Workers' Compensation Act - Compensation for Injuries (Third-Party Clai)",
      "33:1221" : "33:1221 (33:1221 Ports and Waterways Safety Program)",
      "33:1251" : "33:1251 (33:1251 Federal Water Pollution Control Act (Clean Water Act))",
      "33:1319(a)" : "33:1319(a) (33:1319(a)(2)pv Clean Water Act - Pollutants & Permit Violations)",
      "33:1319cw" : "33:1319cw (33:1319 Clean Water Act)",
      "33:1319pv" : "33:1319pv (33:1319 Pollutants & Permit Violations)",
      "33:1321" : "33:1321 (33:1321 Clean Water Act - Discharge of hazardous substance or pollutants/water)",
      "33:1361" : "33:1361 (33:1361 Clean Water Act-Administrator Authority)",
      "33:1364" : "33:1364 (33:1364 Clean Water Act - EPA action to restrain pollution endangering health (emergency powers))",
      "33:1365" : "33:1365 (33:1365 Environmental Matters)",
      "33:1415" : "33:1415 (33:1415 Marine Protection, Research, and Sanctuaries Act)",
      "33:1515" : "33:1515 (33:1515 Deepwater Ports Act (citizen civil action))",
      "33:2701" : "33:2701 (33:2701 Oil Pollution Act of 1940)",
      "35:0001" : "35:0001 (35:0001 Establishment of PTO)",
      "35:0032" : "35:0032 (35:0032 Suspension from Practice before Patent & Trade. Off.)",
      "35:0145" : "35:0145 (35:145 Patent Infringement)",
      "35:0146" : "35:0146 (35:0146 Appeal from Decision of the Board of Patent Appeals)",
      "35:0183" : "35:0183 (35:183 Patent Infringement)",
      "35:0256" : "35:0256 (35:0256 Patent Non-Infringement (Correction of Named Inventor))",
      "35:0271" : "35:0271 (35:271 Patent Infringement)",
      "35:0281" : "35:0281 (35:0281 Remedy for Infringement of Patent/jurisdiction conferred 28:1338)",
      "35:0282" : "35:0282 (35:0282 Patent Infringement - Defenses)",
      "35:0283" : "35:0283 (35:0283 Action to enjoin violation of right secured by patent)",
      "35:0289" : "35:0289 (35:0289 Recover profits from unlicensed use of design patent)",
      "35:0291" : "35:0291 (35:0291 Action for relief between owners; interfering patents)",
      "35:0292" : "35:0292 (35:0292 Penalty & Forfeiture; illegal use of word patent (false marking))",
      "35:0311" : "35:0311 (35:0311 Patent - Request for Inter Partes Reexamination)",
      "38:1110" : "38:1110 (38:1110 Basic Entitlements / Wartime)",
      "38:1131" : "38:1131 (38:1131 Basic Entitlements / Peacetime)",
      "38:1681" : "38:1681 (38:1681 Recovery of VA Overpayment)",
      "38:1686" : "38:1686 (38:1686 Recovery of VA Overpayment)",
      "38:1780" : "38:1780 (38:1780 Recovery of VA Overpayment)",
      "38:1816" : "38:1816 (38:1816 Deficiency balance on VA Mortgage Foreclosure (Regulations Governing the VA Loan Guaranty Pr)",
      "38:1965" : "38:1965 (38:1965 Servicemen's Group Life Insurance (Definitions))",
      "38:1975" : "38:1975 (38:1975 Recovery of Servicemen's Group Life Insurance - Jurisdiction of District Court)",
      "38:1984" : "38:1984 (38:1984 Suit for Veterans Insurance)",
      "38:2011" : "38:2011 (38:2011 - Veterans Readjustment Assistance Act of)",
      "38:3116" : "38:3116 (38:3116 VA Overpayment)",
      "38:3481" : "38:3481 (38:3481 Recovery of VA Overpayment)",
      "38:3680" : "38:3680 (38:3680 Recovery of Education Assist Allowance Overpayment)",
      "38:4212" : "38:4212 (38:4212 Veterans Employment Emphasis Under Federal Contracts )",
      "38:4300" : "38:4300 (38:4300 Uniformed Services Employment and Reemployment Act)",
      "38:4301" : "38:4301 (38:4301 Uniformed Srvs. Employment & Reemployment Rights Act (purpose))",
      "38:4302" : "38:4302 (38:4302 Veterans Reemployment Rights Act (relation to other laws and plans or agreements.)",
      "38:4311" : "38:4311 (38:4311 Uniformed Service Employment or Reemployment Rights Act (USERRA) - Discrimination)",
      "38:4312" : "38:4312 (38:4312 Rights of inducted persons to reemployment )",
      "38:4323" : "38:4323 (38:4323 USERRA - Enforcement of rights with respect to state or private employer )",
      "38:4324" : "38:4324 (38:4324 USERRA - Enforcement of rights with respect to federal executive agencies)",
      "38:5315" : "38:5315 (38:5315 Delinquent Payment of Amounts Due to US)",
      "38:5316" : "38:5316 (38:5316 VA Overpayment )",
      "39:0403" : "39:0403 (39:0403 Discriminatory use of the Postal Service)",
      "39:1207" : "39:1207 (39:1207 Review Agency Action--Labor Disputes)",
      "39:1208(b)" : "39:1208(b) (39:1208(b) Postal Reorganization Act of 1970 - Suits)",
      "39:3005" : "39:3005 (39:3005 Detention of Mail for Temporary Periods)",
      "39:3007" : "39:3007 (39:3007 Detention of Mail for Temporary Periods - Injunction directing retention of incoming mail)",
      "39:3008(e)" : "39:3008(e) (39:3008(e) Enforce compliance with a USPS Prohibitory Order)",
      "39:409" : "39:409 (39:409 Postal Service)",
      "40:0270" : "40:0270 (40:270 Miller Act)",
      "40:0581" : "40:0581 (40:0581 General Authority of Administrator of General Services)",
      "40:1101" : "40:1101 (40:1101 Brooks Architect - Engineers Act)",
      "40:3131" : "40:3131 (40:3131 Bonds of contractors of public buildings )",
      "40:3142" : "40:3142 (40:3142 Davis-Bacon Act (prevailing wages))",
      "41:2102-21" : "41:2102-21 (41:2102-2107 Procurement Integrity Act)",
      "41:3301" : "41:3301 (41:3301 Competition in Contracting Act)",
      "41:6503" : "41:6503 (41:6503 Walsh-Healy Act - Breach of Public Contract)",
      "41:6505" : "41:6505 (41:6505 Exclusions - Review of legal questions in contracts; Walsh-Healy Act)",
      "41:6702 -" : "41:6702 - (41:6702 - 6704 Service Contract Labor Standards / McNamara-O'Hara Service Contract Act 1965)",
      "41:7105(f)" : "41:7105(f) (41:7105(f) Action to Judicially Enforce Administrative Subpoena)",
      "42:0205" : "42:0205 (42:205 Denial Social Security Benefits)",
      "42:0206" : "42:0206 (42:206 Social Security Benefits)",
      "42:0254o" : "42:0254o (42:0254o Breach of Scholarship Contract)",
      "42:0256" : "42:0256 (42:0256 Public Health Services Act - Grants)",
      "42:0292f" : "42:0292f (42:0292f Default of borrower)",
      "42:0292k" : "42:0292k (42:0292k Student loan insurance (Public Health Occupations))",
      "42:0293" : "42:0293 (42:0293 Recovery of losses from loan guarantee; public health)",
      "42:0297" : "42:0297 (42:0297 Student loans; public or nonprofit school of nursing)",
      "42:0300aa-" : "42:0300aa- (42:0300aa-1 Nat'l. Childhood Vaccine Injury Compensation Act)",
      "42:0300f" : "42:0300f (42:0300f Safe Drinking Water Act (Definitions))",
      "42:0300g" : "42:0300g (42:0300g Actions re safety of public water systems (EPA))",
      "42:0300g-3" : "42:0300g-3 (42:0300g-3 Enforcement of Drinking Water Regulations)",
      "42:0401" : "42:0401 (42:0401 Social Security Act - Trust Funds)",
      "42:0402" : "42:0402 (42:402 Social Security Benefits)",
      "42:0405id" : "42:0405id (42:405 Review of HHS Decision (SSID))",
      "42:0405rs" : "42:0405rs (42:0405rs Review of HHS Decision (RSI))",
      "42:0405wc" : "42:0405wc (42:405 Review of HHS Decision (DIWC))",
      "42:0405ww" : "42:0405ww (42:405 Review of HHS Decision (DIWW))",
      "42:0416" : "42:0416 (42:416 Denial of Social Security Benefits)",
      "42:0421(d)" : "42:0421(d) (42:0421(d) Review HHS decision re disability determinations)",
      "42:0423" : "42:0423 (42:0423 Social Security Act (Disability Insurance Benefit Payments))",
      "42:0427" : "42:0427 (42:427 Social Security Benefits)",
      "42:0601" : "42:0601 (42:0601 Title IV-A of the Social Security Act (Grants to States for Aid and Assistance to Needy Fami)",
      "42:0602" : "42:0602 (42:0602 Temp. Assistance for Needy Families (TANF) )",
      "42:0660" : "42:0660 (42:0660 Action to enforce child support obligations)",
      "42:10139" : "42:10139 (42:10139 judicial review of agency actions )",
      "42:10801" : "42:10801 (42:10801 Protection & Advocacy for Individuals with Mental Illness Act of 1986 (PAIMI))",
      "42:10805" : "42:10805 (42:10805 Protection and Advocacy Systems)",
      "42:11001" : "42:11001 (42:11001 Emergency Plan. & Comm. Right to Know Act (EPCRA))",
      "42:11046" : "42:11046 (42:11046 Fed Emer Plan Comm Right-to-know Act (EPCRA) - civil actions)",
      "42:11101" : "42:11101 (42:11101 Health Care Quality Improvement Act of 1986 )",
      "42:11112" : "42:11112 (42:11112 Health Care Quality Improvement Act (Standards for Professional Review Actions))",
      "42:11601" : "42:11601 (42:11601 International Child Abduction Remedies Act)",
      "42:11603(b" : "42:11603(b (42:11603(b) Int'l. Child Abduction Remedies Act (ICARA) - Judicial Remedies)",
      "42:12101" : "42:12101 (42:12101 The Americans with Disabilities Act of 1990)",
      "42:12102" : "42:12102 (42:12102 Americans with Disabilities Act (ADA) Disability Definition)",
      "42:12111" : "42:12111 (42:12111 Americans with Disabilities Act - Employment )",
      "42:12112" : "42:12112 (42:12112 Americans with Disabilities Act - Employment Discrimination)",
      "42:12117" : "42:12117 (42:12117 Americans with Disabilities Act - Enforcement)",
      "42:12132" : "42:12132 (42:12132 Americans with Disabilities Act - Discrimination)",
      "42:12188" : "42:12188 (42:12188 Americans With Disabilities Act - Civil Enforcement Actions)",
      "42:1320a-7" : "42:1320a-7 (42:1320a-7b(b)(2)(A) Anti-Kickback Act (for federal health care programs) )",
      "42:1320d-2" : "42:1320d-2 (42:1320d-2 Health Insurance Portability And Accountability Act (HIPAA))",
      "42:1381a" : "42:1381a (42:1381a Supplemental Security Income benefits (SSID))",
      "42:1382" : "42:1382 (42:1382 Eligibility for benefits)",
      "42:1383" : "42:1383 (42:1383 Review of HHS Decision)",
      "42:1395" : "42:1395 (42:1395 HHS: Adverse Reimbursement Review)",
      "42:1395dd" : "42:1395dd (42:1395dd Exam & Treatment Emergency Med Cond & Women in Labor)",
      "42:1395hr" : "42:1395hr (42:1395hr Hospital Reimbursement for Medicare Services)",
      "42:1395w-2" : "42:1395w-2 (42:1395w-21 Medicare Act (Eligibility, Election, and Enrollment))",
      "42:1396a" : "42:1396a (42:1396a State Plans for Medical Assistance)",
      "42:1396b" : "42:1396b (42:1396b Medical Assist Prgm, Pmt to States/Medicaid Implem)",
      "42:13981" : "42:13981 (42:13981 Violence Against Women Act)",
      "42:14135" : "42:14135 (42:14135 DNA Backlog Grant Program)",
      "42:1437" : "42:1437 (42:1437 U.S. Housing Act of 1937)",
      "42:1471" : "42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclo)",
      "42:1475" : "42:1475 (42:1475 Declaratory & Injunctive Relief - Foreclosure Procedures)",
      "42:1479" : "42:1479 (42:1479 Mortgage, lease, contract re farm housing)",
      "42:14901" : "42:14901 (42:14901 Intercountry Adoptions)",
      "42:15483" : "42:15483 (42:15483 Help America Vote Act)",
      "42:1651" : "42:1651 (42:1651 Defense Base Act)",
      "42:1705" : "42:1705 (42:1705 Receipt of Workmen's compensation benefits)",
      "42:1971" : "42:1971 (42:1971 Voting Rights Law)",
      "42:1973" : "42:1973 (42:1973 Voting Rights Act)",
      "42:1973(a)" : "42:1973(a) (42:1973(a) Enforcement of Voting Rights)",
      "42:1973(c" : "42:1973(c (42:1973(c ) Voting Rights -Qualifications & Procedures)",
      "42:1973gg-" : "42:1973gg- (42:1973gg-2 Nat'l. Voter Registration Act of 1993 (NVRA))",
      "42:1981a" : "42:1981a (42:1981a Damages in cases of intentional discrim. in employment)",
      "42:1981cv" : "42:1981cv (42:1981 Civil Rights)",
      "42:1981hs" : "42:1981hs (42:1981 Housing Discrimination)",
      "42:1981jb" : "42:1981jb (42:1981 Job Discrimination (Race))",
      "42:1981ra" : "42:1981ra (42:1981ra Race Discrimination)",
      "42:1981sx" : "42:1981sx (42:1981 Sex Discrimination)",
      "42:1982hs" : "42:1982hs (42:1982hs Discrimination re property rights (housing))",
      "42:1982ra" : "42:1982ra (42:1982ra Discrimination re property rights (race))",
      "42:1982sx" : "42:1982sx (42:1982sx Discrimination re property rights (sex))",
      "42:1983bv" : "42:1983bv (42:1983bv Bivens Non-Prisoner)",
      "42:1983cv" : "42:1983cv (42:1983 Civil Rights Act)",
      "42:1983cvp" : "42:1983cvp (42:1983cvp Civil Rights (Personal Property))",
      "42:1983d" : "42:1983d (42:1983d Civil Rights (Death))",
      "42:1983dp" : "42:1983dp (42:1983dp Civil Right Denial of Due Process)",
      "42:1983ed" : "42:1983ed (42:1983 Civil Rights (Employment Discrimination))",
      "42:1983pr" : "42:1983pr (42:1983 Prisoner Civil Rights)",
      "42:1983vp" : "42:1983vp (42:1983vp Violation of Due Process and Equal Protection)",
      "42:1985" : "42:1985 (42:1985 Consipracy to interfere with civil rights)",
      "42:1986" : "42:1986 (42:1986 Neglect of Duty)",
      "42:1987" : "42:1987 (42:1987 Prosecution of violations of certain laws (violations of sec 1990 or 5506 to 5516 or 5518 to)",
      "42:1988" : "42:1988 (42:1988 Proceedings in Vindication of Civil Rights)",
      "42:1997" : "42:1997 (42:1997 Institutionalized Persons Act of 1980 )",
      "42:2000a-3" : "42:2000a-3 (42:2000a-3pa Discrimination, segregation; public accommodation - Injunctive Relief)",
      "42:2000ad" : "42:2000ad (42:2000ad Job Discrimination (Disability Act))",
      "42:2000ag" : "42:2000ag (42:2000e-2ag Job Discrimination (Age))",
      "42:2000bb" : "42:2000bb (42:2000bb Religious Freedom Restoration Act of 1993)",
      "42:2000bea" : "42:2000bea (42:2000bea Equal access to public facilities)",
      "42:2000c-6" : "42:2000c-6 (42:2000c-6ed Discrimination in Education)",
      "42:2000cc" : "42:2000cc (42:2000cc Religious Land Use & Institutionalized Persons Act of 2000)",
      "42:2000d" : "42:2000d (42:2000d Federally Assisted Programs)",
      "42:2000e" : "42:2000e (42:2000e Job Discrimination (Employment))",
      "42:2000e-5" : "42:2000e-5 (42:2000e-5eeo Petition to Enforce EEOC Subpoena)",
      "42:2000e2e" : "42:2000e2e (42:2000e-2e Job Discrimination (Unlawful Employment Practices))",
      "42:2000no" : "42:2000no (42:2000e-2no Job Discrimination (National Origin))",
      "42:2000ot" : "42:2000ot (42:2000e-2ot Job Discrimination (other))",
      "42:2000pb" : "42:2000pb (42:2000e-2pb Job Discrimination (Public Accomodations))",
      "42:2000ra" : "42:2000ra (42:2000e-2ra Job Discrimination (Race))",
      "42:2000rl" : "42:2000rl (42:2000e-2rl Job Discrimination (religion))",
      "42:2000sh" : "42:2000sh (42:2000e-2sh Job Discrimination (Sexual Harassment))",
      "42:2000sx" : "42:2000sx (42:2000e-2sx Job Discrimination (Sex))",
      "42:2003" : "42:2003 (42:2003 Job Discrimination)",
      "42:2005" : "42:2005 (42:2005 Review of Agency Action-HHS)",
      "42:2210" : "42:2210 (42:2210 Indeminification & Limitation of Liability-Financial)",
      "42:2651" : "42:2651 (42:2651 Medical Care Recovery)",
      "42:2996" : "42:2996 (42:2996 Legal Services Corporation Act)",
      "42:3058(g)" : "42:3058(g) (42:3058(g) Older American's Act of 1965, 42 U.S.C. 3058(g) (State Long-term Care Ombudsman Program))",
      "42:3121" : "42:3121 (42:3121 Public Works and Economic Development Act of 1965)",
      "42:3133" : "42:3133 (42:3133 Coordination - Grants for Public Works and Economic Development)",
      "42:3601" : "42:3601 (42:405 Fair Housing Act)",
      "42:3604(f)" : "42:3604(f) (42:3604(f)(3)(c ) Fair Housing Amendments Act)",
      "42:3610" : "42:3610 (42:3610 Fair Housing Act-Administrative Enforcement; Preliminary Matters)",
      "42:3612" : "42:3612 (42:3612 Civil rights in housing - Enforcement by Secretary)",
      "42:3613" : "42:3613 (42:3613 Action for inj relief re deprivation of civil rights)",
      "42:4001" : "42:4001 (42:4001 National Insurance Flood Act)",
      "42:4013" : "42:4013 (42:4013 National Flood Insurance Act - Nature and Limitation of Insurance Coverage)",
      "42:4053" : "42:4053 (42:4053 Breach of Insurance Contract)",
      "42:4072" : "42:4072 (42:4072 Payment of Flood Insurance Claim)",
      "42:4321" : "42:4321 (42:4321 Review of Agency Action-Environment)",
      "42:4721" : "42:4721 (42:4721 Intergovernmental Personnel Act (findings and purposes))",
      "42:4821" : "42:4821 (42:4821 Lead-Based Paint Poisoning Prevention Act (findings and purposes) )",
      "42:4901" : "42:4901 (42:4901 Noise Control Act of 1972 (findings and purposes))",
      "42:4910(c" : "42:4910(c (42:4910(c ) Action to restrain violation re noise control)",
      "42:5101" : "42:5101 (42:5101 Child Abuse Prevention and Treatment Act)",
      "42:5303" : "42:5303 (42:5303 Block Grant Act of 1974 (42 USC 5301-5321))",
      "42:5401" : "42:5401 (42:5401 Natl Mnfactrd Housing Cnstr Safety Standard Act 1974 (findings and purposes))",
      "42:5411" : "42:5411 (42:5411 Housing Construction and Safety Standards Act - Injunctive Relief)",
      "42:5851" : "42:5851 (42:5851 Discrimination Whistle blower Employee - ERA (employee protection))",
      "42:6101" : "42:6101 (42:6101 Age Discrimination in Federally Assisted Programs (statement of purpose))",
      "42:6201" : "42:6201 (42:6201 Energy Policy & Conservation Act (statement of purpose))",
      "42:6393" : "42:6393 (42:6393 Controversies under Energy Policy & Conservation Act (Admin Procedure and Judicial Review))",
      "42:6901en" : "42:6901en (42:6901 Environmental Cleanup Expenses)",
      "42:6901rs" : "42:6901rs (42:6901 Resource & Recovery Act)",
      "42:6928" : "42:6928 (42:6928 Violations of requirements of hazardous Waste Mgmt (federal enforcement))",
      "42:6961" : "42:6961 (42:6961 Federal Facilities Compliance Act)",
      "42:6972" : "42:6972 (42:6972 Private Action for Remediation (Environment))",
      "42:6972(a)" : "42:6972(a) (42:6972(a) Solid Waste Disposal Act - Citizen Suit)",
      "42:7192" : "42:7192 (42:7192 Controversies under Dept of Energy Organization Act - Judicial Review)",
      "42:7384" : "42:7384 (42:7384 Energy Employees Occupational Illness Compensation Program Act (EEOICPA))",
      "42:7401" : "42:7401 (42:7401 Clean Air Act (findings & declarations))",
      "42:7412" : "42:7412 (42:7412 Air Pollution Control - emission standards )",
      "42:7413" : "42:7413 (42:7413(b) Clean Air Act)",
      "42:7413(b)" : "42:7413(b) (42:7413(b) Clean Air Act - Enforcement)",
      "42:7475" : "42:7475 (42:7475 Clean Air Act - Preconstruction Requirements)",
      "42:7545" : "42:7545 (42:7545 Air Pollution Prevention - Regulation of Fuels)",
      "42:7603" : "42:7603 (42:7603 Action for immediate restraint (Emergency Powers))",
      "42:7604" : "42:7604 (42:7604 Clean Air Act - Citizen suit to enforce Clean Air Act)",
      "42:7604(f)" : "42:7604(f) (42:7604(f)cl Clear Air Act - Emission Standards)",
      "42:7604cl" : "42:7604cl (42:7604 Clear Air Act (Emission Standards))",
      "42:7604ir" : "42:7604ir (42:7604 Petition to Quash IRS Summons)",
      "42:7671" : "42:7671 (42:7671 Clean Air Act (Stratospheric Ozone Protection) (Definitions))",
      "42:8324" : "42:8324 (42:8324 Powerplant and Industrial Fuel Use - terms and conditions)",
      "42:8351" : "42:8351 (42:8351 Powerplant and Industrial Fuel Use - Temporary Exemptions)",
      "42:9601" : "42:9601 (42:9601 Comprehensive Environmental Compen/Resp/Liab (CERCLA) (Definitions))",
      "42:9604" : "42:9604 (42:9604 Comprehensive Envir., Response, Comp. & Liab. Act (CERCLA) - Removal and Other Remedial Acti)",
      "42:9607" : "42:9607 (42:9607 Real Property Tort to Land)",
      "42:9613" : "42:9613 (42:9613 Comp Environ Recovery Comp & Liability Act (CERCLA) - Civil Proceedings)",
      "43:1333" : "43:1333 (43:1333 Outer Continental Shelf Lands Act - Laws and Regulations Governing Lands)",
      "43:1349" : "43:1349 (43:1349 Outer Continental Land Shelf Act - Citizen Suits)",
      "43:1701" : "43:1701 (43:1701 Violation of Federal Land Policy and Management Act (FLPMA))",
      "43:1737" : "43:1737 (43:1737 FLPMA - Implementation Provisions)",
      "43:421" : "43:421 (43:421 Complaint in Condemnation - Eminent Domain)",
      "43:945" : "43:945 (43:945 Compensation for Land Condemnation)",
      "43:945a" : "43:945a (43:945a Complaint in Condemnation)",
      "43:945b" : "43:945b (43:945b Complaint in Condemnation - Easements)",
      "43:946" : "43:946 (43:946 Complaint in Condemnation - Eminent Domain)",
      "44:2107" : "44:2107 (44:2107 Presidential Recordings and Materials Act (NARA acceptance of records for historical preserv)",
      "45:0051" : "45:0051 (45:51 Railways: Fed. Employers Liability Act)",
      "45:0056" : "45:0056 (45:0056 Employers Liability Act - Personal Inj re Railroads (bringing an action))",
      "45:0151" : "45:0151 (45:151 Railway Labor Act)",
      "45:0152" : "45:0152 (45:0152 Railway Labor Act - General Duties)",
      "45:0153" : "45:0153 (45:0153 First Railway Labor Act - National Railroad Adjustment Board)",
      "45:0159" : "45:0159 (45:0159 Review of arbitration award (RR Carriers/Mediation Bd))",
      "45:0184" : "45:0184 (45:184 Action to Set Aside Award of a System Board)",
      "45:0231(f)" : "45:0231(f) (45:0231(f) Compel obedience to order of Railroad Retirement Bd)",
      "45:0351" : "45:0351 (45:0351 Railroad Unemployment Insurance Act)",
      "45:0719" : "45:0719 (45:0719 Regional Rail Reorganization Act of 1973 (judicial review))",
      "45:1105" : "45:1105 (45:1105 Northeast Rail Service Act - Judicial Review)",
      "46:0688" : "46:0688 (46:688 Jones Act)",
      "46:0761" : "46:0761 (46:761 Shipping: Damages for Death on High Seas)",
      "46:1101" : "46:1101 (46:1101 Violation of Maritime Regulations)",
      "46:2114" : "46:2114 (46:2114 Wrongful Discharge from Employment - protection from discrimination)",
      "46:30101" : "46:30101 (46:30101 Extension of jurisdiction to cases of damage or injury on land)",
      "46:30302" : "46:30302 (46:30302 Shipping: Damages for Death on High Seas )",
      "46:30304" : "46:30304 (46:30304 Breach of Maritime Contract - liability of noncompliance)",
      "46:30503" : "46:30503 (46:30503 Limitation of Liability - declaration of nature and value of goods)",
      "46:30504" : "46:30504 (46:30504 Limitation of Liability - loss by fire)",
      "46:30505-3" : "46:30505-3 (46:30505-30510 Exoneration, Limitation of Liability)",
      "46:30511" : "46:30511 (46:30511 Action by owner for limitation)",
      "46:30701" : "46:30701 (46:30701 Marine Cargo Loss or Damage - Liability of Water Carriers)",
      "46:30704" : "46:30704 (46:30704 Liability of Water Carriers - Loading, stowage, custody, care, and delivery)",
      "46:30902 t" : "46:30902 t (46:30902 to 30911 Suits in Admiralty Act )",
      "46:31102" : "46:31102 (46:31102 Public Vessels Act - Waiver of Immunity)",
      "46:31301" : "46:31301 (46:31301 Federal Maritime Lien Act)",
      "46:31301 t" : "46:31301 t (46:31301 to 31343 Maritime Commercial Instruments and Liens Act)",
      "46:31321" : "46:31321 (46:31321 Foreclosure of Preferred Ship Mortgages)",
      "46:31325" : "46:31325 (46:31325 Suit to enforce lien upon mortgaged vessel-foreclosure / Foreclosure of Preferred Foreign S)",
      "46:31341" : "46:31341 (46:31341 Federal Maritime Lien Act)",
      "46:31343" : "46:31343 (46:31343 Commercial Instruments & Maritime Liens)",
      "46:40101" : "46:40101 (46:40101 Shipping Act of 1998 )",
      "46:41102(a" : "46:41102(a (46:41102(a) Shipping Act of 1984 - General Prohibitions)",
      "46:41309" : "46:41309 (46:41309 Shipping Act of 1984 - Enforcement of Reparation Orders)",
      "46:50101" : "46:50101 (46:50101 Violation of Maritime Regulations )",
      "46:58109" : "46:58109 (46:58109 Violation of Merchant Marine Act - Penalties)",
      "47:0151" : "47:0151 (47:0151 Federal Communications Act of 1934)",
      "47:0151cs" : "47:0151cs (47:0151cs Federal Communications Act - Collection for Services)",
      "47:0201bt" : "47:0201bt (47:0201bt Breach of Tariff)",
      "47:0203" : "47:0203 (47:0203 Telecommunications Collection of Charges)",
      "47:0205" : "47:0205 (47:0205 Wire and Radio Communication Svc and Charges (Recovery of Damages) )",
      "47:0206" : "47:0206 (47:0206 Carrier's Liability for Damages)",
      "47:0227" : "47:0227 (47:0227 FCC-Unsolicited Telephone Sales)",
      "47:0227(b)" : "47:0227(b) (47:0227(b)(3) Telephone Consumer Protection Act of 1991)",
      "47:0251" : "47:0251 (47:0251 Telecommunications Act of 1996 - Interconnection)",
      "47:0252" : "47:0252 (47:0252 Telecommunications Act)",
      "47:0254(h)" : "47:0254(h) (47:0254(h) Children's Internet Protection Act)",
      "47:0332" : "47:0332 (47:332(c)(7)(B) Telecommunications Act of 1996)",
      "47:0332(c" : "47:0332(c (47:0332(c ) Federal Telecommunications Act of 1996)",
      "47:0338" : "47:0338 (47:0338 Satellite Home Viewer Improvement Act)",
      "47:0401" : "47:0401 (47:0401 Application of Federal Communication Comm for Inj. (Enforcement Provisions))",
      "47:0407" : "47:0407 (47:0407 Order for payment of money; petition for enforcement;)",
      "47:0510" : "47:0510 (47:0510 Forfeiture of Communications Devices)",
      "47:0521" : "47:0521 (47:0521 Cable Televsn. Consumer Protection & Competition Act of 1992)",
      "47:0532" : "47:0532 (47:0532 Cable Communication Policy Act of 1984)",
      "47:0551" : "47:0551 (47:0551 Cable Communications Act)",
      "47:0553" : "47:0553 (47:0553 U.S.C.A. Cable Communications Policy Act)",
      "47:605" : "47:605 (47:605 Communications Act of 1934)",
      "49:0101" : "49:0101 (49:0101 ICC Termination Act of 1996)",
      "49:0502" : "49:0502 (49:0502 Transportation Administrative Subpoena)",
      "49:10101" : "49:10101 (49:10101 Interstate Commerce Act-Interstate Transportation Rail)",
      "49:10743" : "49:10743 (49:10743 Revised Interstate Commerce Act)",
      "49:11101" : "49:11101 (49:11101 Interstate Commerce Act)",
      "49:1113" : "49:1113 (49:1113 Petition to enforce administrative summon)",
      "49:1136" : "49:1136 (49:1136 Aviation Disaster Family Assistance Act of 1996)",
      "49:11501" : "49:11501 (49:11501 Railroad Revitalization & Regulatory Reform Act (General jurisdiction))",
      "49:11502" : "49:11502 (49:11502 Railroad Revitalization Regulatory Reform (authority to exempt rail carrier transportation))",
      "49:11702" : "49:11702 (49:11702(a)(4) Violations of Interstate Commerce A)",
      "49:11705" : "49:11705 (49:11705 Limitation on actions by and against rail carriers)",
      "49:11706" : "49:11706 (49:11706 Carmack Amendent (Liability of carriers under receipts and bills of lading))",
      "49:11707" : "49:11707 (49:11707 Carmack Amendment (Liability when property is delivered in violation of routing instruction)",
      "49:13101" : "49:13101 (49:13101 Transportation Policy)",
      "49:13702" : "49:13702 (49:13702 Tariff requirement for certain transportation)",
      "49:13706" : "49:13706 (49:13706 Motor Carriers, etc-Liability for Payment of Rates)",
      "49:14501" : "49:14501 (49:14501 Preemption (federal authority of intrastate transportation))",
      "49:14705" : "49:14705 (49:14705 Interstate Commerce Act/Carmack Amendment (Limitations on actions by and against carriers))",
      "49:14706" : "49:14706 (49:14706 Carmack Amendment to the Interstate Commerce Act / Liability of Carriers - Receipts & Bills)",
      "49:20301-2" : "49:20301-2 (49:20301-20306 Federal Safety Appliance Act)",
      "49:21302" : "49:21302 (49:21302 Carriers violations of Interstate Commerce Act (Chapter 201 accident and incident violation)",
      "49:30101" : "49:30101 (49:30101 National Traffic & Motor Vehicle Safety Act )",
      "49:30112" : "49:30112 (49:30112 Motor Vehicle Safety (prohibition on non-complying motor vehicles and equipment))",
      "49:30502" : "49:30502 (49:30502 Natl Motor Vehicle Title Information Syst)",
      "49:31114" : "49:31114 (49:31114 Access to Interstate System/Commercial Motor Vehicle )",
      "49:31502" : "49:31502 (49:31502 Motor Carrier Safety: Requirements for Qualifications)",
      "49:32101" : "49:32101 (49:32101 Motor Vehicle Information and Costs Savings Act)",
      "49:32701" : "49:32701 (49:32701 Odometer Requirements Act)",
      "49:40101" : "49:40101 (49:40101 Federal Aviation Act)",
      "49:40102" : "49:40102 (49:40102 Airline Deregulation Actv(definitions of air and commerce safety) )",
      "49:40105" : "49:40105 (49:40105 Warsaw Convention )",
      "49:41705" : "49:41705 (49:41705 Air Carrier Access Act (discrimination against handicapped individuals))",
      "49:41713" : "49:41713 (49:41713 Airline Deregulation Actv (premp of authority over prices, routes, and service))",
      "49:44709" : "49:44709 (49:44709 Noise Control Act of 1972 )",
      "49:44715" : "49:44715 (49:44715 Noise Control Act of 1972 )",
      "49:46507" : "49:46507 (49:46507 False information and threats)",
      "49:47101" : "49:47101 (49:47101 Airport and Airway Improvement Act of 1982)",
      "49:47501" : "49:47501 (49:47501 Aviation Safety & Noise Abatement Act of 1979 )",
      "49:49101" : "49:49101 (49:49101 Wrongful Termination in Contravention of Published Regulations)",
      "49:49104" : "49:49104 (49:49104 Breach of Lease by Metro. Wash. Airport Auth.)",
      "49:60101" : "49:60101 (49:60101 Pipeline Safety Act of 1994)",
      "49:60102" : "49:60102 (49:60102 Hazardous Liquid Pipeline Safety Act of 1979 (HLPSA))",
      "49:80102" : "49:80102 (49:80102 Bills of Lading - Application)",
      "49:80302" : "49:80302 (49:80302 Contraband - Prohibitions)",
      "49:80303" : "49:80303 (49:80303 Seizure and forfeiture of vessel or aircraft conveying contraband )",
      "50:1701-17" : "50:1701-17 (50:1701-1706 International Emergency Economic Powers Act)",
      "50a:1" : "50a:1 (50a:1 Trading With the Enemy Act (act located in Title 50, Appendix.))",
      "50a:2412" : "50a:2412 (50a:2412 Export Administration Act--1979 (act located in Title 50, Appendix.))",
      "50a:501" : "50a:501 (50a:501 Sailors and Soldiers Civil Relief Act (act located in Title 50, Appendix.))",
      "50a:533" : "50a:533 (50a:533 Servicemembers Civil Relief Act-mortgages (act located in Title 50, Appendix.))",
      "50a:540" : "50a:540 (50a:540 Sailors and Soldiers Civil Relief Act (act located in Title 50, Appendix.))",
      "51:20137(a" : "51:20137(a (51:20137(a) Malpractice & Negligence Against U.S. Space program )",
      "misc" : "misc (Civil Miscellaneous Case)"
   },
   "iddce" : {
      "0" : "0 (No cause code entered)",
      "00:0000" : "00:0000 (00:0000 Cause Code Unknown)",
      "02:0431" : "02:0431 (02:431 Fed. Election Commission: Failure Enforce Compliance)",
      "02:0437" : "02:0437 (02:437 Federal Election Commission)",
      "05:0075" : "05:0075 (05:75(2) Contract - Reduction in Grade)",
      "05:0551" : "05:0551 (05:551 Administrative Procedure Act)",
      "05:0552fi" : "05:0552fi (05:552 Freedom of Information Act)",
      "05:0552pa" : "05:0552pa (05:552 Right to Privacy Act)",
      "05:0554" : "05:0554 (05:554 Constitutionality of Maritime Statutes)",
      "05:0701" : "05:0701 (05:701 Maritime Subsidy Board)",
      "05:0702" : "05:0702 (05:702 Administrative Procedure Act)",
      "05:0704" : "05:0704 (05:704 Labor Litigation)",
      "05:1221" : "05:1221 (05:1221 Federal Whistleblower Protection Act)",
      "05:7703" : "05:7703 (05:7703 Discrimination - Review of Agency Act)",
      "07:0006" : "07:0006 (07:6(b) Federal Commodity Exchange Regulation)",
      "07:0025" : "07:0025 (07:25 Fraud - Commodities Leverage Contracts)",
      "07:0181" : "07:0181 (07:181 Packers & Stockyard Act)",
      "07:0499" : "07:0499 (07:499 Agricultural Commodities Act)",
      "07:0601" : "07:0601 (07:601 USDA Condemnation)",
      "07:2302" : "07:2302 (07:2302 Agricultural Fair Practices Act)",
      "07:2321" : "07:2321 (07:2321 Plant Variety Protection Act)",
      "08:0287" : "08:0287 (08:287 Petition to Enforce INS Subpoena)",
      "08:1105" : "08:1105 (08:1105(a) Aliens: Habeas Corpus to Release INS Detainee)",
      "08:1252" : "08:1252 (08:1252(a)(2) Injunction for Deportation)",
      "08:1260" : "08:1260 (08:1260 Aliens: Access to Records)",
      "08:1324" : "08:1324 (08:1324 Aliens: Complaint for Forfeiture)",
      "08:1329" : "08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petition)",
      "08:1446" : "08:1446 (08:1446 Petition for Naturalization Hearing)",
      "08:1451" : "08:1451 (08:1451 Revocation of Naturalization)",
      "09:0001" : "09:0001 (09:1 U.S. Arbitration Act)",
      "09:0009" : "09:0009 (09:9 Motion to Confirm Arbitration Loan)",
      "09:0010" : "09:0010 (09:10 Petition to Vacate Arbitration Award)",
      "10:1552" : "10:1552 (10:1552 Armed Forces: Action to Correct Records)",
      "10:1553" : "10:1553 (10:1553 Armed Forces: FOIA General)",
      "10:2305" : "10:2305 (10:2305 Review of Federal Contract)",
      "11:0101" : "11:0101 (11:101 Bankruptcy)",
      "11:0342" : "11:0342 (11:342 Bankrupty Notice)",
      "12:0022" : "12:0022 (12:22 Securities Fraud)",
      "12:0635" : "12:0635 (12:635 Breach of Insurance Contract)",
      "12:1461" : "12:1461 (12:1461 Homeowners Loan Act)",
      "12:1703" : "12:1703 (12:1703 Default of HUD Loan)",
      "12:1725" : "12:1725 (12:1725 Collection under Contract Guaranty)",
      "12:1730" : "12:1730 (12:1730 Collection under Contract Guaranty)",
      "12:1811" : "12:1811 (12:1811 Federal Deposit Insurance Act)",
      "12:1819" : "12:1819 (12:1819 Default of Promissory Note)",
      "12:1821" : "12:1821 (12:1821 Default of Loan by Promissory Note)",
      "12:1971" : "12:1971 (12:1971 Relief under Bank Holding Act)",
      "12:3410" : "12:3410 (12:3410 Right to Financial Privacy Act)",
      "15:0001" : "15:0001 (15:1 Antitrust Litigation)",
      "15:0002at" : "15:0002at (15:2 Antitrust Litigation)",
      "15:0002fl" : "15:0002fl (15:2(a) Fair Labor Standards Act)",
      "15:0005" : "15:0005 (15:5(a) Fair Labor Standards Act)",
      "15:0015" : "15:0015 (15:15 Antitrust Litigation)",
      "15:0025" : "15:0025 (15:25 Clayton Act)",
      "15:0044" : "15:0044 (15:44 Trademark Infringement)",
      "15:0045" : "15:0045 (15:45 Federal Trade Commission Act)",
      "15:0052" : "15:0052 (15:52 Federal Trade Commission Act)",
      "15:0053" : "15:0053 (15:53 Federal Trade Commission Act)",
      "15:0053(b)" : "15:0053(b) (15:53(b) Prelim & Perm Inj Relief & Other Equitable Relief)",
      "15:0077" : "15:0077 (15:77 Securities Fraud)",
      "15:0078" : "15:0078 (15:78m(a) Securities Exchange Act)",
      "15:0631" : "15:0631 (15:631 Small Business Act)",
      "15:0717" : "15:0717 (15:717 Natural Gas Act)",
      "15:1051" : "15:1051 (15:1051 Trademark Infringement)",
      "15:1114" : "15:1114 (15:1114 Trademark Infringement)",
      "15:1121" : "15:1121 (15:1121 Trademark Infringement)",
      "15:1125" : "15:1125 (15:1125 Trademark Infringement (Lanham Act))",
      "15:1126" : "15:1126 (15:1126 Patent Infringement)",
      "15:1127" : "15:1127 (15:1127 Trademark Infringement)",
      "15:1601" : "15:1601 (15:1601 Truth in Lending)",
      "15:1640" : "15:1640 (15:1640 Truth in Lending)",
      "15:1681" : "15:1681 (15:1681 Fair Credit Reporting Act)",
      "15:1691" : "15:1691 (15:1691 Equal Credit Opportunity Act;Consumer Protection Act)",
      "15:1692" : "15:1692 (15:1692 Fair Debt Collection Act)",
      "15:1693" : "15:1693 (15:1693 Electronic Fund Transfer Act)",
      "15:1938" : "15:1938 (15:1938 Fair Labor Standards Act)",
      "15:1981" : "15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))",
      "15:1988" : "15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))",
      "15:1989" : "15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))",
      "15:2301" : "15:2301 (15:2301 Magnuson-Moss Warranty Act)",
      "15:2801" : "15:2801 (15:2801 Petroleum Marketing Practices Act)",
      "15:53(b)" : "15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equita)",
      "15:7701" : "15:7701 (15:7701 Congressional findings and policy)",
      "15:7704" : "15:7704 (15:7704 Other protections for users of commercial electronic mail)",
      "15:7706" : "15:7706 (15:7706 Enforcement generally)",
      "16:0668" : "16:0668 (16:668 Bald Eagle Protection Act)",
      "16:0703" : "16:0703 (16:703 Migratory Bird Act)",
      "16:0791" : "16:0791 (16:791 Federal Power Act)",
      "16:0814" : "16:0814 (16:814 Power of Eminent Domain/Waterways)",
      "16:1538" : "16:1538 (16:1538 Endangered Species Act)",
      "16:3371" : "16:3371 (16:3371 Wildlife Under the Lacey Act)",
      "16:3372" : "16:3372 (16:3372 Conservation: Complaint for Forfeiture)",
      "16:3373" : "16:3373 (16:3373 Appeal of Decision - DOI)",
      "16:3374" : "16:3374 (16:3374 Conservation: Complaint for Forfeiture)",
      "17:0101" : "17:0101 (17:101 Copyright Infringement)",
      "17:0501" : "17:0501 (17:501 Copyright Infringement)",
      "17:0504" : "17:0504 (17:504 Copyright Infringement)",
      "18:0241" : "18:0241 (18:241 Conspiracy Against Citizen Rights)",
      "18:0923" : "18:0923 (18:923 Firearms Sales - Licensing)",
      "18:0981" : "18:0981 (18:981 Forfeiture of Property - Contract Fraud/Sole Source)",
      "18:1514" : "18:1514 (18:1514 Motion for Issuance of Protective Order (harassment))",
      "18:1836a" : "18:1836a (18:1836(a) Injunction against Misappropriation of Trade Secrets)",
      "18:1836b" : "18:1836b (18:1836(b) Civil Action to Protect Trade Secrets)",
      "18:1955" : "18:1955 (18:1955 Forfeiture of Real Property)",
      "18:1961" : "18:1961 (18:1961 Racketeering (RICO) Act)",
      "18:1962" : "18:1962 (18:1962 Racketeering (RICO) Act)",
      "18:1964" : "18:1964 (18:1964 Racketeering (RICO) Act)",
      "18:2254" : "18:2254 (18:2254 Civil Forfeiture)",
      "18:4208" : "18:4208 (18:4208(B) Agency Action Review)",
      "19:1305" : "19:1305 (19:1305 Custom Duties:Forfeiture-Immoral Articles)",
      "20:1080" : "20:1080 (20:1080 Student Loan Recovery)",
      "20:1400" : "20:1400 (20:1400 Civil Rights of Handicapped Child)",
      "20:1401" : "20:1401 (20:1401 Education: Handicapped Child Act)",
      "21:0331" : "21:0331 (21:331 Federal Food Drug & Cosmetic Act)",
      "21:0841" : "21:0841 (21:841 Forfeiture Property - Drugs)",
      "21:0881" : "21:0881 (21:881 Forfeiture Property - Drugs)",
      "21:0881a" : "21:0881a (21:881 Forfeiture Property - Aircraft)",
      "21:0881re" : "21:0881re (21:881 Forfeiture Property - Real Estate)",
      "23:0134" : "23:0134 (23:134 P.I.- Auto Negligence)",
      "23:1441" : "23:1441 (23:1441 Contract Real Estate)",
      "24:1000" : "24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)",
      "25:0357" : "25:0357 (25:0357 Condemnation of Indian Lands)",
      "25:0640" : "25:0640 (25:640 Indian Tribal Rights)",
      "25:1303cc" : "25:1303cc (25:1303 Tribal Court Jurisdiction - Child Custody)",
      "25:1901" : "25:1901 (25:1901 Indian Child Welfare Act)",
      "26:6212" : "26:6212 (26:6212 Injunctive Relief from IRS Lien)",
      "26:6213" : "26:6213 (26:6213 Injunctive Relief from IRS Lien)",
      "26:6330" : "26:6330 (26:6330 Notice & Opportunity for Hearing - IRS Levy)",
      "26:6502" : "26:6502 (26:6502 IRS: Enforcement of Tax Liens)",
      "26:6532" : "26:6532 (26:6532 IRS: Refund of Tax Penalty)",
      "26:6702" : "26:6702 (26:6702 IRS: Refund of Income Tax Penalty)",
      "26:6703" : "26:6703 (26:6703 IRS: Refund of Tax Penalty)",
      "26:7401" : "26:7401 (26:7401 IRS: Tax Liability)",
      "26:7402" : "26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)",
      "26:7403" : "26:7403 (26:7403 Suit to Enforce Federal Tax Lien)",
      "26:7422rt" : "26:7422rt (26:7422 IRS: Refund Taxes)",
      "26:7422rx" : "26:7422rx (26:7422 IRS: Refund Excise Tax)",
      "26:7426" : "26:7426 (26:7426 IRS: Wrongful Levy for Taxes)",
      "26:7429" : "26:7429 (26:7429 IRS: Tax Jeopardy Assessment)",
      "26:7609" : "26:7609 (26:7609 IRS: Petition to Quash IRS Summons)",
      "27:0185" : "27:0185 (27:185 Enforcement of Arbitration Award)",
      "28:0157c" : "28:0157c (28:157(c)(1) Findings, Concl. & Proposed Judgment)",
      "28:0157d" : "28:0157d (28:157 Motion for Withdrawal of Reference)",
      "28:0158" : "28:0158 (28:158 Notice of Appeal re Bankruptcy Matter (BAP))",
      "28:0185" : "28:0185 (28:185 Suit to Compel Arbitration)",
      "28:0451" : "28:0451 (28:451 Employment Discrimination)",
      "28:0794" : "28:0794 (28:794 Rehabilitation Act)",
      "28:1001" : "28:1001 (28:1001 E.R.I.S.A.)",
      "28:1132" : "28:1132 (28:1132 E.R.I.S.A.)",
      "28:1330" : "28:1330 (28:1330 Breach of Contract)",
      "28:1331" : "28:1331 (28:1331 Fed. Question)",
      "28:1331al" : "28:1331al (28:1331 Fed. Question: Airline Crash)",
      "28:1331at" : "28:1331at (28:1331 Fed. Question: Anti-trust)",
      "28:1331au" : "28:1331au (28:1331 Fed. Question: Auto Negligence)",
      "28:1331b" : "28:1331b (28:1331 Fed. Question: Bivens Act)",
      "28:1331bc" : "28:1331bc (28:1331 Fed. Question: Breach of Contract)",
      "28:1331ca" : "28:1331ca (28:1331 Fed. Question: Fed Communications Act of 1934)",
      "28:1331cm" : "28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)",
      "28:1331cv" : "28:1331cv (28:1331 Fed. Question: Other Civil Rights)",
      "28:1331ed" : "28:1331ed (28:1331 Fed. Question: Employment Discrimination)",
      "28:1331es" : "28:1331es (28:1331 Enforcement of Administrative Subpoena)",
      "28:1331fl" : "28:1331fl (28:1331 Fed. Question: Fair Labor Standards)",
      "28:1331in" : "28:1331in (28:1331 Fed. Question: Insurance Contract)",
      "28:1331mm" : "28:1331mm (28:1331 Fed. Question: Medical Malpractice)",
      "28:1331pi" : "28:1331pi (28:1331 Fed. Question: Personal Injury)",
      "28:1331rd" : "28:1331rd (28:1331 Fed. Question: Review Agency Decision)",
      "28:1331rp" : "28:1331rp (28:1331(a) Fed. Question: Real Property)",
      "28:1331rr" : "28:1331rr (28:1331 Fed. Question: Railway Labor Act)",
      "28:1331sv" : "28:1331sv (28:1331 Fed. Question: Securities Violation)",
      "28:1331tr" : "28:1331tr (28:1331 Fed. Question: Trademark)",
      "28:1331tt" : "28:1331tt (28:1331 Fed. Question: Tort Action)",
      "28:1331v" : "28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendment)",
      "28:1331wl" : "28:1331wl (28:1331 Fed. Question: EPA Waste Lien)",
      "28:1331wt" : "28:1331wt (28:1331 Fed. Question: Water Rights)",
      "28:1332ac" : "28:1332ac (28:1332 Diversity-Account Receivable)",
      "28:1332al" : "28:1332al (28:1332 Diversity-Airline Crash)",
      "28:1332as" : "28:1332as (28:1332 Diversity-Asbestos Litigation)",
      "28:1332au" : "28:1332au (28:1332 Diversity-Auto Negligence)",
      "28:1332bc" : "28:1332bc (28:1332 Diversity-Breach of Contract)",
      "28:1332co" : "28:1332co (28:1332 Diversity-Conversion)",
      "28:1332ct" : "28:1332ct (28:1332 Diversity-(Citizenship))",
      "28:1332det" : "28:1332det (28:1332 Diversity-Forcible Detainer)",
      "28:1332df" : "28:1332df (28:1332 Diversity-Contract Default)",
      "28:1332ds" : "28:1332ds (28:1332 Diversity-Contract Dispute)",
      "28:1332ed" : "28:1332ed (28:1332 Diversity-Employment Discrimination)",
      "28:1332fd" : "28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)",
      "28:1332fr" : "28:1332fr (28:1332 Diversity-Fraud)",
      "28:1332ia" : "28:1332ia (28:1332 Diversity-Interpleader Action)",
      "28:1332ij" : "28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)",
      "28:1332in" : "28:1332in (28:1332 Diversity-Insurance Contract)",
      "28:1332jd" : "28:1332jd (28:1332 Diversity-Declaratory Judgement)",
      "28:1332lb" : "28:1332lb (28:1332 Diversity-Libel, Assault, Slander)",
      "28:1332lm" : "28:1332lm (28:1332 Diversity-Legal Malpractice)",
      "28:1332ma" : "28:1332ma (28:1332 Diversity-Miller Act)",
      "28:1332mm" : "28:1332mm (28:1332 Diversity-Medical Malpractice)",
      "28:1332mv" : "28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)",
      "28:1332ni" : "28:1332ni (28:1332 Diversity-Negotiable Instrument)",
      "28:1332nm" : "28:1332nm (28:1332 Diversity-Non-Motor Vehicle)",
      "28:1332oc" : "28:1332oc (28:1332 Diversity-Other Contract)",
      "28:1332pd" : "28:1332pd (28:1332 Diversity-Property Damage)",
      "28:1332pi" : "28:1332pi (28:1332 Diversity-Personal Injury)",
      "28:1332pl" : "28:1332pl (28:1332 Diversity-Product Liability)",
      "28:1332pr" : "28:1332pr (28:1332 Diversity-Petition for Removal)",
      "28:1332qt" : "28:1332qt (28:1332 Diversity-Petition to Quiet Title)",
      "28:1332ri" : "28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)",
      "28:1332sa" : "28:1332sa (28:1332 Diversity-Securities & Exchange Commission Act)",
      "28:1332sf" : "28:1332sf (28:1332 Diversity-Securities Fraud)",
      "28:1332ss" : "28:1332ss (28:1332 Diversity-Stockholders Suits)",
      "28:1332tl" : "28:1332tl (28:1332 Diversity-Torts to Land)",
      "28:1332tm" : "28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))",
      "28:1332tn" : "28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)",
      "28:1332wd" : "28:1332wd (28:1332 Diversity-Wrongful Death)",
      "28:1333" : "28:1333 (28:1333 Admiralty)",
      "28:1334" : "28:1334 (28:1334 Bankruptcy Appeal)",
      "28:1334c" : "28:1334c (28:1334(c) R&R re motions for abstention (non-core))",
      "28:1335" : "28:1335 (28:1335 Interpleader Action)",
      "28:1337" : "28:1337 (28:1337 Sherman-Clayton Act)",
      "28:1338cp" : "28:1338cp (28:1338 Copyright Infringement)",
      "28:1338pt" : "28:1338pt (28:1338 Patent Infringement)",
      "28:1338tr" : "28:1338tr (28:1338 Trademark Infringement)",
      "28:1340" : "28:1340 (28:1340 IRS: Custom Duties)",
      "28:1340er" : "28:1340er (28:1340 Recovery of Erroneous Refund)",
      "28:1341" : "28:1341 (28:1341 Complaint for Forfeiture)",
      "28:1343" : "28:1343 (28:1343 Violation of Civil Rights)",
      "28:1345co" : "28:1345co (28:1345 Replevin & Conversion)",
      "28:1345db" : "28:1345db (28:1345 Debt to US - FHA/HUD Title I)",
      "28:1345df" : "28:1345df (28:1345 Default of Promissory Note)",
      "28:1345er" : "28:1345er (28:1345 Recovery of Erroneous Refund)",
      "28:1345fc" : "28:1345fc (28:1345 Foreclosure)",
      "28:1345ff" : "28:1345ff (28:1345 Complaint for Forfeiture)",
      "28:1345hl" : "28:1345hl (28:1345 VA Home Loan Guaranty Debt)",
      "28:1345mc" : "28:1345mc (28:1345 Medical Care Recovery)",
      "28:1345mi" : "28:1345mi (28:1345 Mining Claim Ejectment)",
      "28:1345pd" : "28:1345pd (28:1345 Property Damage)",
      "28:1345pe" : "28:1345pe (28:1345 Property Ejectment)",
      "28:1345rc" : "28:1345rc (28:1345 Recovery of Debt to US)",
      "28:1345st" : "28:1345st (28:1345 Default of Student Loan)",
      "28:1345tp" : "28:1345tp (28:1345 Trespass on Public Land)",
      "28:1345va" : "28:1345va (28:1345 Recovery of VA Overpayment)",
      "28:1346bc" : "28:1346bc (28:1346 Breach of Contract)",
      "28:1346rc" : "28:1346rc (28:1346 Recovery of IRS Tax)",
      "28:1346tc" : "28:1346tc (28:1346 Tort Claim)",
      "28:1346wd" : "28:1346wd (28:1346 Wrongful Death)",
      "28:1352" : "28:1352 (28:1352 Miller Act)",
      "28:1355" : "28:1355 (28:1355 Petition for Return of Property)",
      "28:1358" : "28:1358 (28:1358 Land Condemnation)",
      "28:1361" : "28:1361 (28:1361 Petition for Writ of Mandamus)",
      "28:1362ic" : "28:1362ic (28:1362 Indian Tribal Controversy)",
      "28:1362iw" : "28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)",
      "28:1364" : "28:1364 (28:1364 Auto Negligence)",
      "28:1391" : "28:1391 (28:1391 Personal Injury)",
      "28:1402" : "28:1402 (28:1402 Medical Malpractice)",
      "28:1407" : "28:1407 (28:1407 Airline Crash)",
      "28:1441ac" : "28:1441ac (28:1441 Petition for Removal- Account Receivable)",
      "28:1441al" : "28:1441al (28:1441 Petition for Removal- Airline Crash)",
      "28:1441as" : "28:1441as (28:1441 Petition for Removal- Asbestos Litigation)",
      "28:1441au" : "28:1441au (28:1441 Petition for Removal- Auto Negligence)",
      "28:1441bc" : "28:1441bc (28:1441 Petition for Removal- Breach of Contract)",
      "28:1441cv" : "28:1441cv (28:1441 Petition for Removal- Civil Rights Act)",
      "28:1441df" : "28:1441df (28:1441 Petition for Removal- Contract Default)",
      "28:1441dj" : "28:1441dj (28:1441 Petition for Removal- Declaratory Judgement)",
      "28:1441ds" : "28:1441ds (28:1441 Petition for Removal- Contract Dispute)",
      "28:1441ed" : "28:1441ed (28:1441 Petition for Removal- Employment Discrimination)",
      "28:1441fc" : "28:1441fc (28:1441 Petition for Removal- Fair Credit Reporting Act)",
      "28:1441fr" : "28:1441fr (28:1441 Petition for Removal- Fraud)",
      "28:1441ij" : "28:1441ij (28:1441 Petition for Removal- Injunctive/Declaratory Relief)",
      "28:1441in" : "28:1441in (28:1441 Petition for Removal- Insurance Contract)",
      "28:1441int" : "28:1441int (28:1441 Petition for Removal- Action for Interpleader)",
      "28:1441lb" : "28:1441lb (28:1441 Petition for Removal- Libel, Assault, Slander)",
      "28:1441lm" : "28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relations)",
      "28:1441mm" : "28:1441mm (28:1441 Petition for Removal- Medical Malpractice)",
      "28:1441ni" : "28:1441ni (28:1441 Petition for Removal- Negotiable Instrument)",
      "28:1441nm" : "28:1441nm (28:1441 Petition for Removal- Non-Motor Vehicle)",
      "28:1441oc" : "28:1441oc (28:1441 Petition for Removal- Other Contract)",
      "28:1441pd" : "28:1441pd (28:1441 Petition for Removal- Property Damage)",
      "28:1441pi" : "28:1441pi (28:1441 Petition for Removal- Personal Injury)",
      "28:1441pl" : "28:1441pl (28:1441 Petition for Removal- Product Liability)",
      "28:1441pr" : "28:1441pr (28:1441 Petition for Removal)",
      "28:1441qt" : "28:1441qt (28:1441 Petition for Removal- Petition to Quiet Title)",
      "28:1441ri" : "28:1441ri (28:1441 Petition for Removal- Racketeering (RICO) Act)",
      "28:1441sa" : "28:1441sa (28:1441 Petition for Removal- SEC Act)",
      "28:1441sf" : "28:1441sf (28:1441 Petition for Removal- Securities Fraud)",
      "28:1441tl" : "28:1441tl (28:1441 Petition for Removal- Torts to Land)",
      "28:1441tm" : "28:1441tm (28:1441 Petition for Removal- Tort/Motor Vehicle (P.I.))",
      "28:1441tn" : "28:1441tn (28:1441 Petition for Removal- Tort/Non-Motor Vehicle)",
      "28:1441wd" : "28:1441wd (28:1441 Petition for Removal- Wrongful Death)",
      "28:1442bc" : "28:1442bc (28:1442 Petition for Removal- Breach of Contract)",
      "28:1442pr" : "28:1442pr (28:1442 Petition for Removal)",
      "28:1443" : "28:1443 (28:1443(1) Rent, Lease & Ejectment)",
      "28:1444" : "28:1444 (28:1444 Petition for Removal- Foreclosure)",
      "28:1446in" : "28:1446in (28:1446 Breach of Contract- Insurance)",
      "28:1446pd" : "28:1446pd (28:1446 Petition for Removal- Property Damage (P.I.))",
      "28:1446pi" : "28:1446pi (28:1446 Petition for Removal- Personal Injury)",
      "28:1446pl" : "28:1446pl (28:1446 Petition for Removal- Product Liability)",
      "28:1446pr" : "28:1446pr (28:1446 Petition for Removal)",
      "28:1452" : "28:1452 (28:1452 R&R re motions to remand (non-core))",
      "28:1651" : "28:1651 (28:1651 Petition for Writ of Coram Nobis)",
      "28:1651hc" : "28:1651hc (28:1651 Petition for Writ of Habeas Corpus)",
      "28:1651mn" : "28:1651mn (28:1651 Petition for Writ of Mandamus)",
      "28:1983" : "28:1983 (28:1983 Civil Rights)",
      "28:2201" : "28:2201 (28:2201 Constitutionality of State Statute(s))",
      "28:2201dj" : "28:2201dj (28:2201 Declaratory Judgment)",
      "28:2201ij" : "28:2201ij (28:2201 Injunction)",
      "28:2201in" : "28:2201in (28:2201 Declaratory Judgment (Insurance))",
      "28:2241" : "28:2241 (28:2241 Petition for Writ of Habeas Corpus)",
      "28:2254" : "28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))",
      "28:2254se" : "28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)",
      "28:2255" : "28:2255 (28:2255 Petition for Writ of Habeas Corpus (Federal))",
      "28:2271" : "28:2271 (28:2271 Federal Tort Claims Act)",
      "28:2345" : "28:2345 (28:2345 Medicare Recovery)",
      "28:2409" : "28:2409 (28:2409(a) Quiet Title Action)",
      "28:2410" : "28:2410 (28:2410 Quiet Title)",
      "28:2671" : "28:2671 (28:2671 Federal Tort Claims Act)",
      "28:2674" : "28:2674 (28:2674 Federal Tort Claims Act)",
      "28:2679" : "28:2679 (28:2679 Certification as US Employee)",
      "28:3001" : "28:3001 (28:3001 Federal Debt Collection Procedures Act)",
      "28:7402" : "28:7402 (28:7402 Refund of Taxes)",
      "28:7422" : "28:7422 (28:7422 Appeal from Administrative Decision)",
      "29:0151" : "29:0151 (29:151 Labor: Review of Agency Action)",
      "29:0160" : "29:0160 (29:160(1) National Labor Relations Act)",
      "29:0184" : "29:0184 (29:184 Violation Collection Bargain Agreement)",
      "29:0185ep" : "29:0185ep (29:185 Employee Pension Plan)",
      "29:0185lm" : "29:0185lm (29:185 Labor/Mgt. Relations (Contracts))",
      "29:0201do" : "29:0201do (29:201 Denial of Overtime Compensation)",
      "29:0201fl" : "29:0201fl (29:201 Fair Labor Standards Act)",
      "29:0203" : "29:0203 (29:203 Equal Pay Act)",
      "29:0206" : "29:0206 (29:206 Collect Unpaid Wages)",
      "29:0401" : "29:0401 (29:401 Labor Management Disclosure Act)",
      "29:0621" : "29:0621 (29:621 Job Discrimination (Age))",
      "29:0623" : "29:0623 (29:623 Job Discrimination (Age))",
      "29:0626" : "29:0626 (29:626 Job Discrimination (Age))",
      "29:0633" : "29:0633 (29:633 Job Discrimination (Age))",
      "29:0651" : "29:0651 (29:651 Occupational Safety/Health)",
      "29:0754" : "29:0754 (29:754 Discrimination)",
      "29:0790" : "29:0790 (29:790 Rehabilitation of Labor)",
      "29:0791" : "29:0791 (29:791 Job Discrimination (Rehabilitation Act))",
      "29:0794" : "29:0794 (29:0794 Job Discrimination (Handicap))",
      "29:1001" : "29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)",
      "29:1002" : "29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)",
      "29:1104" : "29:1104 (29:1104 Recovery of Benefits to Employee)",
      "29:1109" : "29:1109 (29:1109 Breach of Fiduciary Duties)",
      "29:1131" : "29:1131 (29:1131 E.R.I.S.A.-Collection of Delinquent Trust Funds)",
      "29:1132" : "29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)",
      "29:1145" : "29:1145 (29:1145 E.R.I.S.A.)",
      "29:1149" : "29:1149 (29:1149 Recover Pension & Profit Sharing)",
      "29:1337" : "29:1337 (29:1337 E.R.I.S.A.)",
      "29:1362" : "29:1362 (29:1362 E.R.I.S.A.)",
      "29:1381" : "29:1381 (29:1381 E.R.I.S.A.)",
      "29:1401" : "29:1401 (29:1401(b)(2) Appeal of Arbitration Award)",
      "29:1451" : "29:1451 (29:1451 E.R.I.S.A.)",
      "29:1801" : "29:1801 (29:1801 Farmworker Rights)",
      "29:2601" : "29:2601 (29:2601 Family Medical Leave Act)",
      "29:790" : "29:790 (29:790 Rehabilitation of Labor)",
      "30:0181" : "30:0181 (30:181 Environment: Review of Agency Action)",
      "30:0801" : "30:0801 (30:801 Penalties/Federal Mine Safety Health Act - 1977)",
      "30:0818" : "30:0818 (30:818 Federal Mine Safety & Health Act)",
      "30:1201" : "30:1201 (30:1201 Environment: Review of Agency Action)",
      "30:1202" : "30:1202 (30:1202 Mining Reclamation Act)",
      "30:1276" : "30:1276 (30:1276 Interior: Review of Agency Action)",
      "31:3545" : "31:3545 (31:3545 Action to Recover Money)",
      "31:3729" : "31:3729 (31:3729 False Claims Act)",
      "31:3730" : "31:3730 (31:3730 Qui Tam False Claims Act)",
      "31:3731" : "31:3731 (31:3731 Fraud)",
      "33:1319cw" : "33:1319cw (33:1319 Clean Water Act)",
      "33:1319pv" : "33:1319pv (33:1319 Pollutants & Permit Violations)",
      "33:1365" : "33:1365 (33:1365 Environmental Matters)",
      "35:0145" : "35:0145 (35:145 Patent Infringement)",
      "35:0183" : "35:0183 (35:183 Patent Infringement)",
      "35:0271" : "35:0271 (35:271 Patent Infringement)",
      "38:1681" : "38:1681 (38:1681 Recovery of VA Overpayment)",
      "38:1686" : "38:1686 (38:1686 Recovery of VA Overpayment)",
      "38:1780" : "38:1780 (38:1780 Recovery of VA Overpayment)",
      "38:2011" : "38:2011 (38:2011 Veteran's Readjustment Assistance Act of 1974)",
      "38:3116" : "38:3116 (38:3116 VA Overpayment)",
      "39:0409" : "39:0409 (39:409 Postal Service)",
      "39:3005" : "39:3005 (39:3005 Detention of Mail for Temporary Periods)",
      "39:409" : "39:409 (39:409 Postal Service)",
      "40:0258" : "40:0258 (40:258(a) Public Buildings & Property: Land Condemnation)",
      "40:0270" : "40:0270 (40:270 Miller Act)",
      "40:0875" : "40:0875 (40:875 Public Buildings & Property: Negligence)",
      "40:3133" : "40:3133 (40:3133 Rights of Persons Furnishing Labor or Material)",
      "41:0251" : "41:0251 (41:251 Public Contracts-Review of Agency Action)",
      "41:1463" : "41:1463 (41:1463 Public Contracts-Unlawful Employment Practices)",
      "42:0205" : "42:0205 (42:205 Denial Social Security Benefits)",
      "42:0206" : "42:0206 (42:206 Social Security Benefits)",
      "42:0247" : "42:0247 (42:247 Personal Injury-Swine Flu)",
      "42:0402" : "42:0402 (42:402 Social Security Benefits)",
      "42:0405id" : "42:0405id (42:405 Review of HHS Decision (SSID))",
      "42:0405wc" : "42:0405wc (42:405 Review of HHS Decision (DIWC))",
      "42:0405ww" : "42:0405ww (42:405 Review of HHS Decision (DIWW))",
      "42:0416" : "42:0416 (42:416 Denial of Social Security Benefits)",
      "42:0427" : "42:0427 (42:427 Social Security Benefits)",
      "42:10801" : "42:10801 (42:10801 Protection & Advocacy for Individuals w/Mental Ill)",
      "42:11603" : "42:11603 (42:11603 International Child Abduction Remedies Act)",
      "42:12101" : "42:12101 (42:12101 Americans with Disabilities Act)",
      "42:1383" : "42:1383 (42:1383 Review of HHS Decision)",
      "42:1395" : "42:1395 (42:1395 HHS: Adverse Reimbursement Review)",
      "42:1396" : "42:1396 (42:1396 Tort Negligence)",
      "42:1471" : "42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclosure Sale)",
      "42:1981cv" : "42:1981cv (42:1981 Civil Rights)",
      "42:1981hs" : "42:1981hs (42:1981 Housing Discrimination)",
      "42:1981jb" : "42:1981jb (42:1981 Job Discrimination (Race))",
      "42:1981sx" : "42:1981sx (42:1981 Sex Discrimination)",
      "42:1983cv" : "42:1983cv (42:1983 Civil Rights Act)",
      "42:1983ed" : "42:1983ed (42:1983 Civil Rights (Employment Discrimination))",
      "42:1983pr" : "42:1983pr (42:1983 Prisoner Civil Rights)",
      "42:1986" : "42:1986 (42:1986 Neglect of Duty)",
      "42:2000ag" : "42:2000ag (42:2000 Job Discrimination (Age))",
      "42:2000e" : "42:2000e (42:2000 Job Discrimination (Employment))",
      "42:2000pb" : "42:2000pb (42:2000 Job Discrimination (Public Accommodations))",
      "42:2000ra" : "42:2000ra (42:2000 Job Discrimination (Race))",
      "42:2000sx" : "42:2000sx (42:2000 Job Discrimination (Sex))",
      "42:2003" : "42:2003 (42:2003 Job Discrimination)",
      "42:2005" : "42:2005 (42:2005 Review of Agency Action-HHS)",
      "42:2651" : "42:2651 (42:2651 Medical Care Recovery)",
      "42:3601" : "42:3601 (42:3601 Fair Housing Act)",
      "42:4000" : "42:4000 (42:4000 National Flood Insurance Act)",
      "42:4001" : "42:4001 (42:4001 National Insurance Flood Act)",
      "42:4053" : "42:4053 (42:4053 Breach of Insurance Contract)",
      "42:4072" : "42:4072 (42:4072 Payment of Flood Insurance Claim)",
      "42:4321" : "42:4321 (42:4321 Review of Agency Action-Environment)",
      "42:4332" : "42:4332 (42:4332 Environmental Policy - Coop of Agency Reports)",
      "42:5851" : "42:5851 (42:5851 Nuclear Whistleblower Protection - Employee Discrim)",
      "42:6901en" : "42:6901en (42:6901 Environmental Cleanup Expenses)",
      "42:6901rs" : "42:6901rs (42:6901 Resource & Recovery Act)",
      "42:7413" : "42:7413 (42:7413(b) Clean Air Act)",
      "42:7604cl" : "42:7604cl (42:7604 Clear Air Act (Emission Standards))",
      "42:7604ir" : "42:7604ir (42:7604 Petition to Quash IRS Summons)",
      "42:9607" : "42:9607 (42:9607 Real Property Tort to Land)",
      "43:0945" : "43:0945 (43:945 Compensation for Land Condemnation)",
      "43:0945a" : "43:0945a (43:945a Complaint in Condemnation)",
      "43:0946" : "43:0946 (43:946 Complaint in Condemnation - Eminent Domain)",
      "43:945" : "43:945 (43:945 Compensation for Land Condemnation)",
      "43:945a" : "43:945a (43:945a Complaint in Condemnation)",
      "43:946" : "43:946 (43:946 Complaint in Condemnation - Eminent Domain)",
      "45:0051" : "45:0051 (45:51 Railways: Fed. Employer's Liability Act)",
      "45:0151" : "45:0151 (45:151 Railway Labor Act)",
      "45:0153" : "45:0153 (45:153 Action to Set Aside Award of a System Board of Adjust)",
      "45:0184" : "45:0184 (45:184 Action to Set Aside Award of a System Board of Adjust)",
      "45:1395" : "45:1395 (45:1395 Railroads: Adverse Reimbursement Review)",
      "45:7457" : "45:7457 (45:7457 Compel Reclamation Under Clear Air Act)",
      "46:0688" : "46:0688 (46:688 Jones Act)",
      "46:0741" : "46:0741 (46:741 Shipping)",
      "46:0761" : "46:0761 (46:761 Shipping: Damages for Death on High Seas)",
      "46:1101" : "46:1101 (46:1101 Violation of Maritime Regulations)",
      "46:1156" : "46:1156 (46:1156 Administrative Procedure Act)",
      "47:0153" : "47:0153 (47:153 Telecommunications Act of 1966)",
      "47:0605" : "47:0605 (47:605 Federal Communications Act of 1934)",
      "48:0883" : "48:0883 (48:883 Violation of US Coastal Law)",
      "48:1985" : "48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)",
      "49:0081" : "49:0081 (49:81 Damaged Goods While Being Transported)",
      "49:0781" : "49:0781 (49:781 Forfeiture)",
      "49:11503" : "49:11503 (49:11503 Railroad Revitalization Regulatory Reform Act)",
      "49:11702" : "49:11702 (49:11702(a)(4) Violations of Interstate Commerce Act)",
      "49:1471" : "49:1471 (49:1471 Federal Aviation Act)",
      "49:1903" : "49:1903 (49:1903 Petition to enforce administrative summons)",
      "49:31105" : "49:31105 (49:31105 Surface Transportation Assistance Act)",
      "49:5101" : "49:5101 (49:5101 Federal Hazardous Materials Transportation Law)",
      "8:287" : "8:287 (8:287 Petition to Enforce INS Subpoena)",
      "misc" : "misc (Civil Miscellaneous Case)"
   },
   "ilcdce" : {
      "0" : "0 (No cause code entered)",
      "00:0000" : "00:0000 (00:0000 Cause Code Unknown)",
      "02:0431" : "02:0431 (02:431 Fed. Election Commission: Failure Enforce C)",
      "02:0437" : "02:0437 (02:437 Federal Election Commission)",
      "05:0075" : "05:0075 (05:75(2) Contract - Reduction in Grade)",
      "05:0551" : "05:0551 (05:551 Administrative Procedure Act)",
      "05:0552fi" : "05:0552fi (05:552 Freedom of Information Act)",
      "05:0552pa" : "05:0552pa (05:552 Right to Privacy Act)",
      "05:0554" : "05:0554 (05:0554 Constitutionality of Maritime Statutes)",
      "05:0701" : "05:0701 (05:0701 Maritime Subsidy Board)",
      "05:0702" : "05:0702 (05:702 Administrative Procedure Act)",
      "05:0704" : "05:0704 (05:704 Labor Litigation)",
      "05:555e" : "05:555e (05:555 Enforcement of Agency Subpoena)",
      "05:555q" : "05:555q (05:555 Quash Agency Subpoena)",
      "05:7703" : "05:7703 (05:7703 Discrimination - Review of Agency Act)",
      "05:8701" : "05:8701 (05:8701 FEGLI Act)",
      "07:0006" : "07:0006 (7:6(b) Federal Commodity Exchange Regulation)",
      "07:0025" : "07:0025 (7:25 Fraud - Commodities Leverage Contracts)",
      "07:0181" : "07:0181 (07:181 Packers & Stockyard Act)",
      "07:0499" : "07:0499 (07:499 Agricultural Commodities Act)",
      "07:0601" : "07:0601 (07:601 USDA Condemnation)",
      "07:2023" : "07:2023 (07:2023 Business Disqualification for Food Stamp Program)",
      "07:2321" : "07:2321 (07:2321 Plant Variety Protection Act)",
      "08:1105" : "08:1105 (8:1105(a) Aliens: Habeas Corpus to Release INS Det)",
      "08:1252" : "08:1252 (08:1252(a)(2) Injunction for Deportation)",
      "08:1260" : "08:1260 (08:1260 Aliens: Access to Records)",
      "08:1324" : "08:1324 (08:1324 Aliens: Complaint for Forfeiture)",
      "08:1329" : "08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petiti)",
      "08:1421" : "08:1421 (08:1421 Review of Denial of Application for Naturalization)",
      "08:1446" : "08:1446 (8:1446 Petition for Naturalization Hearing)",
      "08:1447b" : "08:1447b (08:1447(b) Naturalization - Request for Hearing Before U.S. District Court)",
      "08:287" : "08:287 (08:287 Petition to Enforce INS Subpoena)",
      "09:0001" : "09:0001 (09:1 U.S. Arbitration Act)",
      "09:0009" : "09:0009 (9:9 Motion to Confirm Arbitration Loan)",
      "09:0010" : "09:0010 (09:0010 Petition to Vacate Arbitration Award)",
      "10:1552" : "10:1552 (10:1552 Armed Forces: Action to Correct Records)",
      "10:1553" : "10:1553 (10:1553 Armed Forces: FOIA General)",
      "10:2305" : "10:2305 (10:2305 Review of Federal Contract)",
      "11:0101" : "11:0101 (11:101 Bankruptcy)",
      "12:0022" : "12:0022 (12:22 Securities Fraud)",
      "12:0635" : "12:0635 (12:635 Breach of Insurance Contract)",
      "12:1461" : "12:1461 (12:1461 Homeowners Loan Act)",
      "12:1703" : "12:1703 (12:1703 Default of HUD Loan)",
      "12:1725" : "12:1725 (12:1725 Collection under Contract Guaranty)",
      "12:1730" : "12:1730 (12:1730 Collection Under Contract Guaranty)",
      "12:1819" : "12:1819 (12:1819 Default of Promissory Note)",
      "12:1821" : "12:1821 (12:1821 Default of Loan by Promissary Note)",
      "12:1971" : "12:1971 (12:1971 Relief under Bank Holding Act)",
      "12:2605" : "12:2605 (12:2605 Mortgage Servicer Failure to Comply w/Request f/Info)",
      "12:3410" : "12:3410 (12:3410 Right to Financial Privacy Act)",
      "12:4001" : "12:4001 (12:4001 Expedited Funds Availability Act)",
      "14:0088" : "14:0088 (14:88 False Distress Signal to Coast Guard)",
      "15:0001" : "15:0001 (15:1 Antitrust Litigation)",
      "15:0002at" : "15:0002at (15:2 Antitrust Litigation)",
      "15:0002fl" : "15:0002fl (15:2(a) Fair Labor Standards Act)",
      "15:0005" : "15:0005 (15:5(a) Fair Labor Standards Act)",
      "15:0015" : "15:0015 (15:15 Antitrust Litigation)",
      "15:0025" : "15:0025 (15:25 Clayton Act)",
      "15:0044" : "15:0044 (15:44 Trademark Infringement)",
      "15:0045" : "15:0045 (15:0045 Federal Trade Commission Act)",
      "15:0052" : "15:0052 (15:0052 Federal Trade Commission Act)",
      "15:0053" : "15:0053 (15:0053 Federal Trade Commission Act)",
      "15:0077" : "15:0077 (15:77 Securities Fraud)",
      "15:0078" : "15:0078 (15:78m(a) Securities Exchange Act)",
      "15:0631" : "15:0631 (15:631 Small Business Act)",
      "15:0717" : "15:0717 (15:717 Natural Gas Act)",
      "15:1051" : "15:1051 (15:1051 Trademark Infringement)",
      "15:1114" : "15:1114 (15:1114 Trademark Infringement)",
      "15:1121" : "15:1121 (15:1121 Trademark Infringement)",
      "15:1125" : "15:1125 (15:1125 Trademark Infringement (Lanham Act))",
      "15:1126" : "15:1126 (15:1126 Patent Infringement)",
      "15:1127" : "15:1127 (15:1127 Trademark Infringement)",
      "15:1601" : "15:1601 (15:1601 Truth in Lending)",
      "15:1640" : "15:1640 (15:1640 Truth in Lending)",
      "15:1681" : "15:1681 (15:1681 Fair Credit Reporting Act)",
      "15:1692" : "15:1692 (15:1692 Fair Debt Collection Act)",
      "15:1693" : "15:1693 (15:1693 Electronic Fund Transfer Act)",
      "15:1938" : "15:1938 (15:1938 Fair Labor Standards Act)",
      "15:1981" : "15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))",
      "15:1988" : "15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))",
      "15:1989" : "15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))",
      "15:2301" : "15:2301 (15:2301 Magnuson-Moss Warranty Act)",
      "15:2801" : "15:2801 (15:2801 Petroleum Marketing Practices Act)",
      "15:53(b)" : "15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equita)",
      "15:6101" : "15:6101 (15:6101 Telemarketing Act/Consumer Fraud)",
      "15:717" : "15:717 (15:717(h) Natural Gas Act)",
      "16:0668" : "16:0668 (16:668 Bald Eagle Protection Act)",
      "16:0703" : "16:0703 (16:703 Migratory Bird Act)",
      "16:1538" : "16:1538 (16:1538 Endangered Species Act)",
      "16:3371" : "16:3371 (16:3371 Wildlife Under the Lacey Act)",
      "16:3372" : "16:3372 (16:3372 Conservation: Complaint for Forfeiture)",
      "16:3373" : "16:3373 (16:3373 Appeal of Decision - DOI)",
      "16:3374" : "16:3374 (16:3374 Conservation: Complaint for Forfeiture)",
      "17:0101" : "17:0101 (17:101 Copyright Infringement)",
      "17:0501" : "17:0501 (17:501 Copyright Infringement)",
      "17:0504" : "17:0504 (17:504 Copyright Infringement)",
      "17:1203" : "17:1203 (17:1203 Digital Millennium-Copyright Act)",
      "18:0241" : "18:0241 (18:241 Conspiracy Against Citizen Rights)",
      "18:1030" : "18:1030 (18:1030(g) Computer Fraud and Abuse Act)",
      "18:1345" : "18:1345 (18:1345 Injunction Against Fraud)",
      "18:1517" : "18:1517 (18:1517 Obstructing Examination of Financial Institution)",
      "18:1836a" : "18:1836a (18:1836(a) Injunction against Misappropriation of Trade Secrets)",
      "18:1836b" : "18:1836b (18:1836(b) Civil Action to Protect Trade Secrets)",
      "18:1961" : "18:1961 (18:1961 Racketeering (RICO) Act)",
      "18:1962" : "18:1962 (18:1962 Racketeering (RICO) Act)",
      "18:1964" : "18:1964 (18:1964 Racketeering (RICO) Act)",
      "18:2119" : "18:2119 (18:2119 Motor Vehicle Theft - Carjacking)",
      "18:2254" : "18:2254 (Forfeiture of Property)",
      "18:2510" : "18:2510 (18:2510 Wire/Electronic/Oral Communications Interception)",
      "18:2707" : "18:2707 (18:2707 Wire/Electronic/Transactional Record Access)",
      "18:2710" : "18:2710 (18:2710 Video Privacy Act of 1988)",
      "18:4208" : "18:4208 (18:4208(B) Agency Action Review)",
      "18:981a" : "18:981a (18:981(a)(1)(D) Asset Forfeiture)",
      "19:1305" : "19:1305 (19:1305 Custom Duties:0Forfeiture-Immoral Articles)",
      "20:1080" : "20:1080 (20:1080 Student Loan Recovery)",
      "20:1400" : "20:1400 (20:1400 Civil Rights of Handicapped Child)",
      "20:1401" : "20:1401 (20:1401 Education: Handicapped Child Act)",
      "20:1415" : "20:1415 (20:1415 Individuals with Disabilities Education Act)",
      "20:1681" : "20:1681 (20:1681 Discrimination in Federally-Funded Education Program)",
      "21:0301" : "21:0301 (21:301 Federal Food, Drug & Cosmetics Act)",
      "21:0841" : "21:0841 (21:841 Forfeiture Property-Drugs)",
      "21:0881" : "21:0881 (21:881 Forfeiture Property-Drugs)",
      "21:0881a" : "21:0881a (21:881 Forfeiture Property - Aircraft)",
      "21:0881re" : "21:0881re (21:881 Forfeiture Property - Real Estate)",
      "21:842c" : "21:842c (21:842c Comprehensive Drug Abuse Prevention and Control Act)",
      "23:0134" : "23:0134 (23:134 P.I.- Auto Negligence)",
      "23:1441" : "23:1441 (23:1441 Contract Real Estate)",
      "24:1000" : "24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)",
      "25:0640" : "25:0640 (25:640 Indian Tribal Rights)",
      "25:1901" : "25:1901 (25:1901 Indian Child Welfare Act)",
      "26:6103" : "26:6103 (26:6103 Wrongful Disclosure)",
      "26:6212" : "26:6212 (26:6212 Injunctive Relief from IRS Lien)",
      "26:6213" : "26:6213 (26:6213 Injunctive Relief from IRS Lien)",
      "26:6502" : "26:6502 (26:6502 IRS:Enforcement of tax liens)",
      "26:6532" : "26:6532 (26:6532 IRS: Refund of Tax Penalty)",
      "26:6702" : "26:6702 (26:6702 IRS: Refund of Income Tax Penalty)",
      "26:6703" : "26:6703 (26:6703 IRS: Refund of Tax Penalty)",
      "26:7401" : "26:7401 (26:7401 IRS: Tax Liability)",
      "26:7402" : "26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)",
      "26:7403" : "26:7403 (26:7403 Suit to Enforce Federal Tax Lien)",
      "26:7422rt" : "26:7422rt (26:7422 IRS: Refund Taxes)",
      "26:7422rx" : "26:7422rx (26:7422 IRS: Refund Excise Tax)",
      "26:7426" : "26:7426 (26:7426 IRS: Wrongful Levy for Taxes)",
      "26:7429" : "26:7429 (26:7429 IRS: Tax Jeopardy Assessment)",
      "26:7434" : "26:7434 (26:7434 Civil Damages for Faudulent Filing of Info. Returns)",
      "26:7609" : "26:7609 (26:7609 IRS: Petition to Quash IRS Summons)",
      "27:0185" : "27:0185 (27:185 Enforcement of Arbitration Award)",
      "28:0157c" : "28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)",
      "28:0157d" : "28:0157d (28:0157 Motion for Withdrawal of Reference)",
      "28:0157e" : "28:0157e (28:0157 Bankruptcy Judge Authorized to Conduct Jury Trial)",
      "28:0158" : "28:0158 (28:0158 Notice of Appeal re Bankruptcy Matter (BA)",
      "28:0185" : "28:0185 (28:185 Suit to Compel Arbitration)",
      "28:0451" : "28:0451 (28:451 Employment Discrimination)",
      "28:0794" : "28:0794 (28:794 Rehabilitation Act)",
      "28:0881" : "28:0881 (28:881 Drug Related Seizure of Property)",
      "28:1001" : "28:1001 (28:1001 E.R.I.S.A.)",
      "28:1132" : "28:1132 (28:1132 E.R.I.S.A.)",
      "28:1330" : "28:1330 (28:1330 Breach of Contract)",
      "28:1331" : "28:1331 (28:1331 Fed. Question)",
      "28:1331al" : "28:1331al (28:1331 Fed. Question: Airline Crash)",
      "28:1331at" : "28:1331at (28:1331 Fed. Question: Anti-trust)",
      "28:1331au" : "28:1331au (28:1331 Fed. Question: Auto Negligence)",
      "28:1331b" : "28:1331b (28:1331 Federal Question: Bivens Act)",
      "28:1331bc" : "28:1331bc (28:1331 Fed. Question: Breach of Contract)",
      "28:1331ca" : "28:1331ca (28:1331 Fed Question: Fed Communications Act of 1)",
      "28:1331cm" : "28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)",
      "28:1331cv" : "28:1331cv (28:1331 Federal Question: Other Civil Rights)",
      "28:1331ed" : "28:1331ed (28:1331 Fed. Question: Employment Discrimination)",
      "28:1331es" : "28:1331es (28:1331 Enforcement of Administrative Subpoena)",
      "28:1331fl" : "28:1331fl (28:1331 Fed. Question: Fair Labor Standards)",
      "28:1331in" : "28:1331in (28:1331 Fed. Question: Insurance Contract)",
      "28:1331mm" : "28:1331mm (28:1331 Fed. Question: Medical Malpractice)",
      "28:1331pi" : "28:1331pi (28:1331 Fed. Question: Personal Injury)",
      "28:1331rd" : "28:1331rd (28:1331 Fed. Question: Review Agency Decision)",
      "28:1331rp" : "28:1331rp (28:1331(a) Fed. Question: Real Property)",
      "28:1331rr" : "28:1331rr (28:1331 Fed. Question: Railway Labor Act)",
      "28:1331sv" : "28:1331sv (28:1331 Fed. Question: Securities Violation)",
      "28:1331tr" : "28:1331tr (28:1331 Fed. Question: Trademark)",
      "28:1331tt" : "28:1331tt (28:1331 Fed. Question: Tort Action)",
      "28:1331v" : "28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendme)",
      "28:1331wl" : "28:1331wl (28:1331 Federal Question: EPA Waste Lien)",
      "28:1331wt" : "28:1331wt (28:1331 Fed. Question: Water Rights)",
      "28:1332ac" : "28:1332ac (28:1332 Diversity-Account Receivable)",
      "28:1332al" : "28:1332al (28:1332 Diversity-Airline Crash)",
      "28:1332as" : "28:1332as (28:1332 Diversity-Asbestos Litigation)",
      "28:1332au" : "28:1332au (28:1332 Diversity-Auto Negligence)",
      "28:1332bc" : "28:1332bc (28:1332 Diversity-Breach of Contract)",
      "28:1332co" : "28:1332co (28:1332 Diversity-Conversion)",
      "28:1332ct" : "28:1332ct (28:1332 Diversity-(Citizenship))",
      "28:1332det" : "28:1332det (28:1332 Diversity: Forcible Detainer)",
      "28:1332df" : "28:1332df (28:1332 Diversity-Contract Default)",
      "28:1332ds" : "28:1332ds (28:1332 Diversity-Contract Dispute)",
      "28:1332ed" : "28:1332ed (28:1332 Diversity-Employment Discrimination)",
      "28:1332fd" : "28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)",
      "28:1332fm" : "28:1332fm (Mortgage Foreclosure)",
      "28:1332fr" : "28:1332fr (28:1332 Diversity-Fraud)",
      "28:1332ia" : "28:1332ia (28:1332 Diversity-Interpleader Action)",
      "28:1332ij" : "28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)",
      "28:1332in" : "28:1332in (28:1332 Diversity-Insurance Contract)",
      "28:1332jd" : "28:1332jd (28:1332 Diversity-Declaratory Judgement)",
      "28:1332lb" : "28:1332lb (28:1332 Diversity-Libel,Assault,Slander)",
      "28:1332lm" : "28:1332lm (28:1332 Diversity - Legal Malpractice)",
      "28:1332ma" : "28:1332ma (28:1332 Diversity-Miller Act)",
      "28:1332mm" : "28:1332mm (28:1332 Diversity-Medical Malpractice)",
      "28:1332mv" : "28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)",
      "28:1332ni" : "28:1332ni (28:1332 Diversity-Negotiable Instrument)",
      "28:1332nm" : "28:1332nm (28:1332 Diversity-Non-Motor Vehicle)",
      "28:1332nr" : "28:1332nr (28:1332 Diversity - Notice of Removal)",
      "28:1332oc" : "28:1332oc (28:1332 Diversity-Other Contract)",
      "28:1332pd" : "28:1332pd (28:1332 Diversity-Property Damage)",
      "28:1332pi" : "28:1332pi (28:1332 Diversity-Personal Injury)",
      "28:1332pl" : "28:1332pl (28:1332 Diversity-Product Liability)",
      "28:1332pr" : "28:1332pr (28:1332 Diversity-Notice of Removal)",
      "28:1332qt" : "28:1332qt (28:1332 Diversity-Petition to Quiet Title)",
      "28:1332ri" : "28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)",
      "28:1332sa" : "28:1332sa (28:1332 - Diversity: Securities & Exchange Commiss)",
      "28:1332sf" : "28:1332sf (28:1332 - Diversity: Securities Fraud)",
      "28:1332ss" : "28:1332ss (28:1332 Diversity - Stockholders Suits)",
      "28:1332tl" : "28:1332tl (28:1332 Diversity-Torts to Land)",
      "28:1332tm" : "28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))",
      "28:1332tn" : "28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)",
      "28:1332wd" : "28:1332wd (28:1332 Diversity-Wrongful Death)",
      "28:1333" : "28:1333 (28:1333 Admiralty)",
      "28:1334" : "28:1334 (28:1334 Bankruptcy Appeal)",
      "28:1334b" : "28:1334b (28:1334(b) Bankruptcy Matters (other))",
      "28:1334c" : "28:1334c (28:1334(c) R&R re motions for abstention (non-cor)",
      "28:1335" : "28:1335 (28:1335 Interpleader Action)",
      "28:1337" : "28:1337 (28:1337 Sherman-Clayton Act)",
      "28:1338cp" : "28:1338cp (28:1338 Copyright Infringement)",
      "28:1338pt" : "28:1338pt (28:1338 Patent Infringement)",
      "28:1338tr" : "28:1338tr (28:1338 Trademark Infringement)",
      "28:1340" : "28:1340 (28:1340 IRS: Custom Duties)",
      "28:1340er" : "28:1340er (28:1340 Recovery of Erroneous Refund)",
      "28:1341" : "28:1341 (28:1341 Complaint for Forfeiture)",
      "28:1343" : "28:1343 (28:1343 Violation of Civil Rights)",
      "28:1345co" : "28:1345co (28:1345 Replevin & Conversion)",
      "28:1345db" : "28:1345db (28:1345 Debt to US - FHA/HUD Title I)",
      "28:1345df" : "28:1345df (28:1345 Default of Promissory Note)",
      "28:1345er" : "28:1345er (28:1345 Recovery of Erroneous Refund)",
      "28:1345fc" : "28:1345fc (28:1345 Foreclosure)",
      "28:1345ff" : "28:1345ff (28:1345 Complaint for Forfeiture)",
      "28:1345hl" : "28:1345hl (28:1345 VA Home Loan Guaranty Debt)",
      "28:1345mc" : "28:1345mc (28:1345 Medical Care Recovery)",
      "28:1345mi" : "28:1345mi (28:1345 Mining Claim Ejectment)",
      "28:1345pd" : "28:1345pd (28:1345 Property Damage)",
      "28:1345pe" : "28:1345pe (28:1345 Property Ejectment)",
      "28:1345rc" : "28:1345rc (28:1345 Recovery of Debt to US)",
      "28:1345st" : "28:1345st (28:1345 Default of Student Loan)",
      "28:1345tp" : "28:1345tp (28:1345 Trespass on Public Land)",
      "28:1345va" : "28:1345va (28:1345 Recovery of VA Overpayment)",
      "28:1346bc" : "28:1346bc (28:1346 Breach of Contract)",
      "28:1346rc" : "28:1346rc (28:1346 Recovery of IRS Tax)",
      "28:1346tc" : "28:1346tc (28:1346 Tort Claim)",
      "28:1346wd" : "28:1346wd (28:1346 Wrongful Death)",
      "28:1352" : "28:1352 (28:1352 Miller Act)",
      "28:1355" : "28:1355 (28:1355 Petition for Return of Property)",
      "28:1358" : "28:1358 (28:1358 Land Condemnation)",
      "28:1361" : "28:1361 (28:1361 Petition for Writ of Mandamus)",
      "28:1362ic" : "28:1362ic (28:1362 Indian Tribal Controversy)",
      "28:1362iw" : "28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)",
      "28:1364" : "28:1364 (28:1364 Auto Negligence)",
      "28:1391" : "28:1391 (28:1391 Personal Injury)",
      "28:1402" : "28:1402 (28:1402 Medical Malpractice)",
      "28:1407" : "28:1407 (28:1407 Airline Crash)",
      "28:1441ac" : "28:1441ac (28:1441 Notice of Removal- Account Receivable)",
      "28:1441al" : "28:1441al (28:1441 Notice of Removal- Airline Crash)",
      "28:1441as" : "28:1441as (28:1441 Notice of Removal- Asbestos Litigation)",
      "28:1441au" : "28:1441au (28:1441 Notice of Removal- Auto Negligence)",
      "28:1441bc" : "28:1441bc (28:1441 Notice of Removal- Breach of Contract)",
      "28:1441cv" : "28:1441cv (28:1441 Notice of Removal- Civil Rights Act)",
      "28:1441df" : "28:1441df (28:1441 Notice of Removal- Contract Default)",
      "28:1441dj" : "28:1441dj (28:1441 Notice of Removal- Declaratory Judgemen)",
      "28:1441ds" : "28:1441ds (28:1441 Notice of Removal- Contract Dispute)",
      "28:1441ed" : "28:1441ed (28:1441 Notice of Removal - Employment Discrim)",
      "28:1441er" : "28:1441er (28:1441 Notice of Removal - ERISA)",
      "28:1441fc" : "28:1441fc (28:1441 Notice of Removal - Fair Credit Reporti)",
      "28:1441fr" : "28:1441fr (28:1441 Notice of Removal- Fraud)",
      "28:1441ij" : "28:1441ij (28:1441 Notice of Removal- Injunctive/Declarato)",
      "28:1441in" : "28:1441in (28:1441 Notice of Removal- Insurance Contract)",
      "28:1441int" : "28:1441int (28:1441 Notice of Removal- Action for Interplea)",
      "28:1441lb" : "28:1441lb (28:1441 Notice of Removal Libel,Assault,Slander)",
      "28:1441lm" : "28:1441lm (28:1441 Notice of Removal- Labor/Mgmnt. Relations)",
      "28:1441mm" : "28:1441mm (28:1441 Notice of Removal- Medical Malpractice)",
      "28:1441ni" : "28:1441ni (28:1441 Notice of Removal- Negotiable Instrumen)",
      "28:1441nm" : "28:1441nm (28:1441 Notice of Removal- Non-Motor Vehicle)",
      "28:1441nr" : "28:1441nr (28:1441 Notice of Removal)",
      "28:1441oc" : "28:1441oc (28:1441 Notice of Removal--Other Contract)",
      "28:1441pd" : "28:1441pd (28:1441 Notice of Removal- Property Damage)",
      "28:1441pi" : "28:1441pi (28:1441 Notice of Removal- Personal Injury)",
      "28:1441pl" : "28:1441pl (28:1441 Notice of Removal- Product Liability)",
      "28:1441pr" : "28:1441pr (28:1441 Notice of Removal)",
      "28:1441qt" : "28:1441qt (28:1441 Notice of Removal- Petition to Quiet Ti)",
      "28:1441ri" : "28:1441ri (28:1441 Notice of Removal- Racketeering (RICO))",
      "28:1441sa" : "28:1441sa (28:1441 - Notice of Removal: SEC Act)",
      "28:1441sf" : "28:1441sf (28:1441 - Notice of Removal: Securities Fraud)",
      "28:1441tl" : "28:1441tl (28:1441 Notice of Removal- Torts to Land)",
      "28:1441tm" : "28:1441tm (28:1441 Notice of Removal- Tort/Motor Vehicle ()",
      "28:1441tn" : "28:1441tn (28:1441 Notice of Removal- Tort/Non-Motor Vehic)",
      "28:1441wd" : "28:1441wd (28:1441 Notice of Removal- Wrongful Death)",
      "28:1442bc" : "28:1442bc (28:1442 Notice of Removal- Breach of Contract)",
      "28:1442nr" : "28:1442nr (28:1442 Notice of Removal)",
      "28:1442pr" : "28:1442pr (28:1442 Notice of Removal)",
      "28:1443" : "28:1443 (28:1443(1) Rent, Lease & Ejectment)",
      "28:1444" : "28:1444 (28:1444 Notice of Removal- Foreclosure)",
      "28:1446in" : "28:1446in (28:1446 Breach of Contract- Insurance)",
      "28:1446nr" : "28:1446nr (28:1446 Notice of Removal)",
      "28:1446pd" : "28:1446pd (28:1446 Notice of Removal- Property Damage (P.I)",
      "28:1446pi" : "28:1446pi (28:1446 Notice of Removal- Personal Injury)",
      "28:1446pl" : "28:1446pl (28:1446pl Notice of Removal - Product Liability)",
      "28:1446pr" : "28:1446pr (28:1446 Notice of Removal)",
      "28:1452" : "28:1452 (28:1452 R&R re motions to remand (non-core))",
      "28:1651" : "28:1651 (28:1651 Petition for Writ of Coram Nobis)",
      "28:1651hc" : "28:1651hc (28:1651 Petition for Writ of Habeas Corpus)",
      "28:1651mn" : "28:1651mn (28:1651 Petition for Writ of Mandamus)",
      "28:1916" : "28:1916 (28:1916 Seaman's Suit Filing Fee Waived)",
      "28:1983" : "28:1983 (28:1983 Civil Rights)",
      "28:2201" : "28:2201 (28:2201 Constitutionality of State Statute(s))",
      "28:2201dj" : "28:2201dj (28:2201 Declaratory Judgment)",
      "28:2201ij" : "28:2201ij (28:2201 Injunction)",
      "28:2201in" : "28:2201in (28:2201 Declaratory Judgement (Insurance))",
      "28:2241" : "28:2241 (28:2241 Petition for Writ of Habeas Corpus (federa)",
      "28:2254" : "28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))",
      "28:2254se" : "28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)",
      "28:2255" : "28:2255 (28:2255 Motion to Vacate / Correct Illegal Sentenc)",
      "28:2271" : "28:2271 (28:2271 Federal Tort Claims Act)",
      "28:2284" : "28:2284 (Three Judge Court)",
      "28:2345" : "28:2345 (28:2345 Medicare Recovery)",
      "28:2409" : "28:2409 (28:2409(a) Quiet Title Action)",
      "28:2410" : "28:2410 (28:2410 Quiet Title)",
      "28:2671" : "28:2671 (28:2671 Federal Tort Claims Act)",
      "28:2674" : "28:2674 (28:2674 Federal Tort Claims Act)",
      "28:3001" : "28:3001 (28:3001 Debt Collection Act)",
      "28:3301" : "28:3301 (28:3301 Fraudulent Transfer Action)",
      "28:7402" : "28:7402 (28:7402 Refund of Taxes)",
      "28:7422" : "28:7422 (28:7422 Appeal from Administrative Decision)",
      "29:0151" : "29:0151 (29:151 Labor: Review of Agency Action)",
      "29:0160" : "29:0160 (29:160(1) National Labor Relations Act)",
      "29:0184" : "29:0184 (29:184 Violation Collection Bargain Agreement)",
      "29:0185ep" : "29:0185ep (29:185 Employee Pension Plan)",
      "29:0185lm" : "29:0185lm (29:185 Labor/Mgt. Relations (Contracts))",
      "29:0201do" : "29:0201do (29:201 Denial of Overtime Compensation)",
      "29:0201fl" : "29:0201fl (29:201 Fair Labor Standards Act)",
      "29:0203" : "29:0203 (29:203 Equal Pay Act)",
      "29:0206" : "29:0206 (29:206 Collect Unpaid Wages)",
      "29:0401" : "29:0401 (29:0401 Labor Management Disclosure Act)",
      "29:0621" : "29:0621 (29:621 Job Discrimination (Age))",
      "29:0623" : "29:0623 (29:623 Job Discrimination (Age))",
      "29:0626" : "29:0626 (29:626 Job Discrimination (Age))",
      "29:0633" : "29:0633 (29:633 Job Discrimination (Age))",
      "29:0651" : "29:0651 (29:651 Occupational Safety/Health)",
      "29:0754" : "29:0754 (29:754 Discrimination)",
      "29:0791" : "29:0791 (29:791 Job Discrimination (Rehabilitation Act))",
      "29:0794" : "29:0794 (29:0794 Job Discrimination (Handicap))",
      "29:1001" : "29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)",
      "29:1002" : "29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)",
      "29:1104" : "29:1104 (29:1104 Recovery of Benefits to Employee)",
      "29:1109" : "29:1109 (29:1109 Breach of Fiduciary Duties)",
      "29:1131" : "29:1131 (29:1131 ERISA - Collection of Delinquent Trust Fun)",
      "29:1132" : "29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)",
      "29:1145" : "29:1145 (29:1145 E.R.I.S.A.)",
      "29:1149" : "29:1149 (29:1149 Recover Pension & Profit Sharing)",
      "29:1337" : "29:1337 (29:1337 E.R.I.S.A.)",
      "29:1362" : "29:1362 (29:1362 ERISA)",
      "29:1381" : "29:1381 (29:1381 E.R.I.S.A.)",
      "29:1401" : "29:1401 (29:1401(b)(2) Appeal of Arbitration Award)",
      "29:1451" : "29:1451 (29:1451 E.R.I.S.A.)",
      "29:1801" : "29:1801 (29:1801 Farmworker Rights)",
      "29:1854" : "29:1854 (29:1854 Migrant and Seasonal Agricultural Worker Protection Act)",
      "29:2101" : "29:2101 (29:2101 WARN Act)",
      "29:2601" : "29:2601 (29:2601 Family and Medical Leave Act)",
      "29:790" : "29:790 (29:790 Rehabilitation of Labor)",
      "30:0181" : "30:0181 (30:181 Environment: Review of Agency Action)",
      "30:0801" : "30:0801 (30:0801 Penalities/Federal Mine Safety Health Act)",
      "30:1201" : "30:1201 (30:1201 Environment: Review of Agency Action)",
      "30:1202" : "30:1202 (30:1202 Mining Reclamation Act)",
      "30:1276" : "30:1276 (30:1276 Interior: Review of Agency Action)",
      "30:932a" : "30:932a (30:932 Black Lung Benefits: Longshore & Harbor Workers Act)",
      "31:3545" : "31:3545 (31:3545 Action to Recovery Money)",
      "31:3729" : "31:3729 (31:3729 False Claims Act)",
      "31:3730" : "31:3730 (31:3730 Qui Tam False Claims Act)",
      "31:3731" : "31:3731 (31:3731 Fraud)",
      "33:1319cw" : "33:1319cw (33:1319 Clean Water Act)",
      "33:1319pv" : "33:1319pv (33:1319 Pollutants & Permit Violations)",
      "33:1365" : "33:1365 (33:1365 Environmental Matters)",
      "33:2701" : "33:2701 (33:2701 Oil Pollution Act)",
      "33:921d" : "33:921d (33:921 Longshore & Harbor Workers Comp. Act: Jurisdiction)",
      "35:0145" : "35:0145 (35:145 Patent Infringement)",
      "35:0183" : "35:0183 (35:183 Patent Infringement)",
      "35:0271" : "35:0271 (35:271 Patent Infringement)",
      "38:1681" : "38:1681 (38:1681 Recovery of VA Overpayment)",
      "38:1686" : "38:1686 (38:1686 Recovery of VA Overpayment)",
      "38:1780" : "38:1780 (38:1780 Recovery of VA Overpayment)",
      "38:2011" : "38:2011 (38:2011 - Veteran's Readjustment Assistance Act of)",
      "38:3116" : "38:3116 (38:3116 VA Overpayment)",
      "38:4223" : "38:4223 (38:4223 Employment Rights - Uniformed Services)",
      "38:4301" : "38:4301 (38:4301 Uniformed Svcs Emplmnt and Re-Emplmnt Act of 1994)",
      "39:3005" : "39:3005 (39:3005 Detention of Mail for Temporary Periods)",
      "39:409" : "39:409 (39:409 Postal Service)",
      "40:0258" : "40:0258 (40:258(a) Public Buildings & Property: Land Condem)",
      "40:0270" : "40:0270 (40:270 Miller Act)",
      "40:0875" : "40:0875 (40:875 Public Buildings & Property: Negligence)",
      "41:0251" : "41:0251 (41:251 Public Contracts-Review of Agency Action)",
      "41:0351" : "41:0351 (41:0351 McNamara-O'Hara Service Contract Act of 1965)",
      "41:1463" : "41:1463 (41:1463 Public Contracts: Unlawful Employment Prac)",
      "42:0205" : "42:0205 (42:205 Denial Social Security Benefits)",
      "42:0206" : "42:0206 (42:206 Social Security Benefits)",
      "42:0247" : "42:0247 (42:247 Personal Injury-Swine Flu)",
      "42:0300g" : "42:0300g (42:300g-3- Enforcement of Drinking Water Regulations)",
      "42:0402" : "42:0402 (42:402 Social Security Benefits)",
      "42:0405id" : "42:0405id (42:405 Review of HHS Decision (SSID))",
      "42:0405wc" : "42:0405wc (42:405 Review of HHS Decision (DIWC))",
      "42:0405ww" : "42:0405ww (42:405 Review of HHS Decision (DIWW))",
      "42:0416" : "42:0416 (42:416 Denial of Social Security Benefits)",
      "42:0427" : "42:0427 (42:427 Social Security Benefits)",
      "42:11604" : "42:11604 (42:11604 International Child Abduction Remedies Act)",
      "42:12101" : "42:12101 (42:12101 Americans with Disabilities Act)",
      "42:1383" : "42:1383 (42:1383 Review of HHS Decision)",
      "42:1395" : "42:1395 (42:1395 HHS: Adverse Reimbursement Review)",
      "42:1396" : "42:1396 (42:1396 - Tort Negligence)",
      "42:13981" : "42:13981 (42:13981 Violence Against Women Act)",
      "42:1471" : "42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclo)",
      "42:1981cv" : "42:1981cv (42:1981 Civil Rights)",
      "42:1981hs" : "42:1981hs (42:1981 Housing Discrimination)",
      "42:1981jb" : "42:1981jb (42:1981 Job Discrimination (Race))",
      "42:1981sx" : "42:1981sx (42:1981 Sex Discrimination)",
      "42:1983cv" : "42:1983cv (42:1983 Civil Rights Act)",
      "42:1983ed" : "42:1983ed (42:1983 Civil Rights (Employment Discrimination))",
      "42:1983pr" : "42:1983pr (42:1983 Prisoner Civil Rights)",
      "42:1986" : "42:1986 (42:1986 Neglect of Duty)",
      "42:2000ag" : "42:2000ag (42:2000 Job Discrimination (Age))",
      "42:2000cc" : "42:2000cc (42:2000 Religious Land Use and Institutionalized Persons Act)",
      "42:2000e" : "42:2000e (42:2000e Job Discrimination (Employment))",
      "42:2000pb" : "42:2000pb (42:2000 Job Discrimination (Public Accomodations))",
      "42:2000ra" : "42:2000ra (42:2000 Job Discrimination (Race))",
      "42:2000sx" : "42:2000sx (42:2000 Job Discrimination (Sex))",
      "42:2003" : "42:2003 (42:2003 Job Discrimination)",
      "42:2005" : "42:2005 (42:2005 Review of Agency Action-HHS)",
      "42:2651" : "42:2651 (42:2651 Medical Care Recovery)",
      "42:3601" : "42:3601 (42:405 Fair Housing Act)",
      "42:4000" : "42:4000 (42:4000 National Flood Insurance Act)",
      "42:4001" : "42:4001 (42:4001 National Insurance Flood Act)",
      "42:4053" : "42:4053 (42:4053 Breach of Insurance Contract)",
      "42:4072" : "42:4072 (42:4072 Payment of Flood Insurance Claim)",
      "42:4321" : "42:4321 (42:4321 Review of Agency Action-Environment)",
      "42:4332" : "42:4332 (42:4332 Environmental Policy - Coop of Agency Repo)",
      "42:6901en" : "42:6901en (42:6901 Environmental Cleanup Expenses)",
      "42:6901rs" : "42:6901rs (42:6901 Resource & Recovery Act)",
      "42:6972" : "42:6972 (42:6972 Resource and Recovery Act)",
      "42:7401" : "42:7401 (42:7401 Clean Air Act)",
      "42:7413" : "42:7413 (42:7413(b) Clean Air Act)",
      "42:7604cl" : "42:7604cl (42:7604 Clear Air Act (Emission Standards))",
      "42:7604ir" : "42:7604ir (42:7604 Petition to Quash IRS Summons)",
      "42:9601en" : "42:9601en (42:9601 Environmental Cleanup Expenses)",
      "42:9601rs" : "42:9601rs (42:9601 Resource and Recovery Act)",
      "42:9607" : "42:9607 (42:9607 Real Property Tort to Land)",
      "43:945" : "43:945 (43:945 Compensation for Land Condemnation)",
      "43:945a" : "43:945a (43:945a Complaint in Condemnation)",
      "43:946" : "43:946 (43:946 Complaint in Condemnation - Eminent Domain)",
      "45:0051" : "45:0051 (45:51 Railways: Fed. Employer's Liability Act)",
      "45:0151" : "45:0151 (45:151 Railway Labor Act)",
      "45:0184" : "45:0184 (45:184 Action to Set Aside Award of a System Board)",
      "45:1395" : "45:1395 (45:1395 Railroads: Adverse Reimbursement Review)",
      "45:7457" : "45:7457 (45:7457 Compel Reclamation Under Clear Air Act)",
      "46:0688" : "46:0688 (46:688 Jones Act)",
      "46:0741" : "46:0741 (46:741 Shipping)",
      "46:0761" : "46:0761 (46:761 Shipping: Damages for Death on High Seas)",
      "46:1101" : "46:1101 (46:1101 Violation of Maritime Regulations)",
      "46:1156" : "46:1156 (46:1156 Administrative Procedure Act)",
      "46:30505" : "46:30505 (Limitation of Vessel Owner's Liability)",
      "46:30511" : "46:30511 (Limitation of Vessel Owner's Liability)",
      "46:688" : "46:688 (46:688 Jones Act)",
      "46:740" : "46:740 (46:740 Admiralty Jurisdiction Extension Act)",
      "47:227" : "47:227 (47:227 Telephone Consumer Protection Act)",
      "47:332" : "47:332 (47:332 Telecommunications Act of 1996)",
      "47:605" : "47:605 (47:605 Communications Act of 1934)",
      "48:0883" : "48:0883 (48:883 Violation of US Coastal Law)",
      "48:1985" : "48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)",
      "49:0081" : "49:0081 (49:81 Damaged Goods While Being Transported)",
      "49:0781" : "49:0781 (49:781 Forfeiture)",
      "49:10101" : "49:10101 (49:10101 Rail Transportation Policy)",
      "49:11503" : "49:11503 (49:11503 Railroad Revitalization Regulatory Reform)",
      "49:11702" : "49:11702 (49:11702(a)(4) Violations of Interstate Commerce A)",
      "49:14706" : "49:14706 (Interstate Cargo Claim)",
      "49:1471" : "49:1471 (49:1471 Federal Aviation Act)",
      "49:1671" : "49:1671 (49:1671 Natural Gas Pipeline Safety Act)",
      "49:1903" : "49:1903 (49:1903 Petition to enforce administrative summon)",
      "49:20302" : "49:20302 (49:20302 Federal Safety Appliance Act)",
      "49:32705a" : "49:32705a (49:32705(a)(1)(B) Vehicle Odometer Disclosure Act/Tampering)",
      "5:552a" : "5:552a (5:552a Administrative Procedures Act)",
      "8:287" : "8:287 (8:287 Petition to Enforce INS Subpoena)",
      "cvmisc" : "cvmisc (Civil Miscellaneous Case)",
      "misc" : "misc (Civil Miscellaneous Case)"
   },
   "ilndce" : {
      "02:0431" : "02:0431 (02:431 Fed. Election Commission: Failure Enforce Compliance)",
      "02:0437" : "02:0437 (02:437 Federal Election Commission)",
      "05:0075" : "05:0075 (05:75(2) Contract - Reduction in Grade)",
      "05:0551" : "05:0551 (05:551 Administrative Procedure Act)",
      "05:0552fi" : "05:0552fi (05:552 Freedom of Information Act)",
      "05:0552pa" : "05:0552pa (05:552 Right to Privacy Act)",
      "05:0554" : "05:0554 (05:0554 Constitutionality of Maritime Statutes)",
      "05:0701" : "05:0701 (05:0701 Administrative Procedure Act)",
      "05:0702" : "05:0702 (05:702 Administrative Procedure Act)",
      "05:0704" : "05:0704 (05:704 Labor Litigation)",
      "05:7703" : "05:7703 (05:7703 Discrimination - Review of Agency Act)",
      "07:0006" : "07:0006 (7:6(b) Federal Commodity Exchange Regulation)",
      "07:0025" : "07:0025 (7:25 Fraud - Commodities Leverage Contracts)",
      "07:0181" : "07:0181 (07:181 Packers & Stockyard Act)",
      "07:0499" : "07:0499 (07:499 Agricultural Commodities Act)",
      "07:0601" : "07:0601 (07:601 USDA Condemnation)",
      "07:2321" : "07:2321 (07:2321 Plant Variety Protection Act)",
      "08:1105" : "08:1105 (8:1105(a) Aliens: Habeas Corpus to Release INS Detainee)",
      "08:1252" : "08:1252 (08:1252(a)(2) Injunction for Deportation)",
      "08:1260" : "08:1260 (08:1260 Aliens: Access to Records)",
      "08:1324" : "08:1324 (08:1324 Aliens: Complaint for Forfeiture)",
      "08:1329" : "08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petition)",
      "08:1446" : "08:1446 (8:1446 Petition for Naturalization Hearing)",
      "08:287" : "08:287 (8:287 Petition to Enforce INS Subpoena)",
      "09:0001" : "09:0001 (09:1 U.S. Arbitration Act)",
      "09:0009" : "09:0009 (9:9 Motion to Confirm Arbitration Loan)",
      "09:0010" : "09:0010 (09:0010 Petition to Vacate Arbitration Award)",
      "10:1552" : "10:1552 (10:1552 Armed Forces: Action to Correct Records)",
      "10:1553" : "10:1553 (10:1553 Armed Forces: FOIA General)",
      "10:2305" : "10:2305 (10:2305 Review of Federal Contract)",
      "11:0101" : "11:0101 (11:101 Bankruptcy)",
      "11:110i" : "11:110i (11:110(i) Order on a standing petition)",
      "12:0022" : "12:0022 (12:22 Securities Fraud)",
      "12:0635" : "12:0635 (12:635 Breach of Insurance Contract)",
      "12:1461" : "12:1461 (12:1461 Homeowners Loan Act)",
      "12:1703" : "12:1703 (12:1703 Default of HUD Loan)",
      "12:1725" : "12:1725 (12:1725 Collection under Contract Guaranty)",
      "12:1730" : "12:1730 (12:1730 Collection Under Contract Guaranty)",
      "12:1819" : "12:1819 (12:1819 Default of Promissory Note)",
      "12:1821" : "12:1821 (12:1821 Default of Loan by Promissary Note)",
      "12:1971" : "12:1971 (12:1971 Relief under Bank Holding Act)",
      "12:3410" : "12:3410 (12:3410 Right to Financial Privacy Act)",
      "15:0001" : "15:0001 (15:1 Antitrust Litigation)",
      "15:0002at" : "15:0002at (15:2 Antitrust Litigation)",
      "15:0002fl" : "15:0002fl (15:2(a) Fair Labor Standards Act)",
      "15:0005" : "15:0005 (15:5(a) Fair Labor Standards Act)",
      "15:0015" : "15:0015 (15:15 Antitrust Litigation)",
      "15:0025" : "15:0025 (15:25 Clayton Act)",
      "15:0044" : "15:0044 (15:44 Trademark Infringement)",
      "15:0045" : "15:0045 (15:0045 Federal Trade Commission Act)",
      "15:0052" : "15:0052 (15:0052 Federal Trade Commission Act)",
      "15:0053" : "15:0053 (15:0053 Federal Trade Commission Act)",
      "15:0077" : "15:0077 (15:77 Securities Fraud)",
      "15:0078" : "15:0078 (15:78m(a) Securities Exchange Act)",
      "15:0631" : "15:0631 (15:631 Small Business Act)",
      "15:0717" : "15:0717 (15:717 Natural Gas Act)",
      "15:1051" : "15:1051 (15:1051 Trademark Infringement)",
      "15:1114" : "15:1114 (15:1114 Trademark Infringement)",
      "15:1121" : "15:1121 (15:1121 Trademark Infringement)",
      "15:1125" : "15:1125 (15:1125 Trademark Infringement (Lanham Act))",
      "15:1126" : "15:1126 (15:1126 Patent Infringement)",
      "15:1127" : "15:1127 (15:1127 Trademark Infringement)",
      "15:1601" : "15:1601 (15:1601 Truth in Lending)",
      "15:1640" : "15:1640 (15:1640 Truth in Lending)",
      "15:1681" : "15:1681 (15:1681 Fair Credit Reporting Act)",
      "15:1692" : "15:1692 (15:1692 Fair Debt Collection Act)",
      "15:1938" : "15:1938 (15:1938 Fair Labor Standards Act)",
      "15:1981" : "15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))",
      "15:1988" : "15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))",
      "15:1989" : "15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))",
      "15:2301" : "15:2301 (15:2301 Magnuson-Moss Warranty Act)",
      "15:2801" : "15:2801 (15:2801 Petroleum Marketing Practices Act)",
      "15:53(b)" : "15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equitable Relief)",
      "16:0668" : "16:0668 (16:668 Bald Eagle Protection Act)",
      "16:0703" : "16:0703 (16:703 Migratory Bird Act)",
      "16:1538" : "16:1538 (16:1538 Endangered Species Act)",
      "16:3371" : "16:3371 (16:3371 Wildlife Under the Lacey Act)",
      "16:3372" : "16:3372 (16:3372 Conservation: Complaint for Forfeiture)",
      "16:3373" : "16:3373 (16:3373 Appeal of Decision - DOI)",
      "16:3374" : "16:3374 (16:3374 Conservation: Complaint for Forfeiture)",
      "17:0101" : "17:0101 (17:101 Copyright Infringement)",
      "17:0501" : "17:0501 (17:501 Copyright Infringement)",
      "17:0504" : "17:0504 (17:504 Copyright Infringement)",
      "18:0241" : "18:0241 (18:241 Conspiracy Against Citizen Rights)",
      "18:1836a" : "18:1836a (18:1836(a) Injunction against Misappropriation of Trade Secrets)",
      "18:1836b" : "18:1836b (18:1836(b) Civil Action to Protect Trade Secrets)",
      "18:1961" : "18:1961 (18:1961 Racketeering (RICO) Act)",
      "18:1962" : "18:1962 (18:1962 Racketeering (RICO) Act)",
      "18:1964" : "18:1964 (18:1964 Racketeering (RICO) Act)",
      "18:2518" : "18:2518 (18:2518 Interception of Wire/Oral/Electronic Communication)",
      "18:4208" : "18:4208 (18:4208(B) Agency Action Review)",
      "19:1305" : "19:1305 (19:1305 Custom Duties:0Forfeiture-Immoral Articles)",
      "20:1080" : "20:1080 (20:1080 Student Loan Recovery)",
      "20:1400" : "20:1400 (20:1400 Civil Rights of Handicapped Child)",
      "20:1401" : "20:1401 (20:1401 Education: Handicapped Child Act)",
      "21:0841" : "21:0841 (21:841 Forfeiture Property-Drugs)",
      "21:0881" : "21:0881 (21:0881 Forfeiture of Property)",
      "21:0881a" : "21:0881a (21:881 Forfeiture Property - Aircraft)",
      "21:0881c" : "21:0881c (21:881 Forfeiture of Property-Currency)",
      "21:0881dr" : "21:0881dr (21:0881 Forfeiture Property-Drugs)",
      "21:0881re" : "21:0881re (21:881 Forfeiture Property - Real Estate)",
      "23:0134" : "23:0134 (23:134 P.I.- Auto Negligence)",
      "23:1441" : "23:1441 (23:1441 Contract Real Estate)",
      "24:1000" : "24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)",
      "25:0640" : "25:0640 (25:640 Indian Tribal Rights)",
      "25:1901" : "25:1901 (25:1901 Indian Child Welfare Act)",
      "26:6212" : "26:6212 (26:6212 Injunctive Relief from IRS Lien)",
      "26:6213" : "26:6213 (26:6213 Injunctive Relief from IRS Lien)",
      "26:6502" : "26:6502 (26:6502 IRS:Enforcement of tax liens)",
      "26:6532" : "26:6532 (26:6532 IRS: Refund of Tax Penalty)",
      "26:6702" : "26:6702 (26:6702 IRS: Refund of Income Tax Penalty)",
      "26:6703" : "26:6703 (26:6703 IRS: Refund of Tax Penalty)",
      "26:7401" : "26:7401 (26:7401 IRS: Tax Liability)",
      "26:7402" : "26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)",
      "26:7403" : "26:7403 (26:7403 Suit to Enforce Federal Tax Lien)",
      "26:7422rt" : "26:7422rt (26:7422 IRS: Refund Taxes)",
      "26:7422rx" : "26:7422rx (26:7422 IRS: Refund Excise Tax)",
      "26:7426" : "26:7426 (26:7426 IRS: Wrongful Levy for Taxes)",
      "26:7429" : "26:7429 (26:7429 IRS: Tax Jeopardy Assessment)",
      "26:7609" : "26:7609 (26:7609 IRS: Petition to Quash IRS Summons)",
      "27:0185" : "27:0185 (27:185 Enforcement of Arbitration Award)",
      "28:0157c" : "28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)",
      "28:0157d" : "28:0157d (28:0157 Motion for Withdrawal of Reference)",
      "28:0158" : "28:0158 (28:0158 Notice of Appeal re Bankruptcy Matter (BAP))",
      "28:0185" : "28:0185 (28:185 Suit to Compel Arbitration)",
      "28:0451" : "28:0451 (28:451 Employment Discrimination)",
      "28:0794" : "28:0794 (28:794 Rehabilitation Act)",
      "28:1001" : "28:1001 (28:1001 E.R.I.S.A.)",
      "28:1132" : "28:1132 (28:1132 E.R.I.S.A.)",
      "28:1330" : "28:1330 (28:1330 Breach of Contract)",
      "28:1331" : "28:1331 (28:1331 Federal Question)",
      "28:1331al" : "28:1331al (28:1331 Fed. Question: Airline Crash)",
      "28:1331at" : "28:1331at (28:1331 Fed. Question: Anti-trust)",
      "28:1331au" : "28:1331au (28:1331 Fed. Question: Auto Negligence)",
      "28:1331b" : "28:1331b (28:1331 Federal Question: Bivens Act)",
      "28:1331bc" : "28:1331bc (28:1331 Fed. Question: Breach of Contract)",
      "28:1331ca" : "28:1331ca (28:1331 Fed Question: Fed Communications Act of 1934)",
      "28:1331cm" : "28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)",
      "28:1331cv" : "28:1331cv (28:1331 Federal Question: Other Civil Rights)",
      "28:1331ed" : "28:1331ed (28:1331 Fed. Question: Employment Discrimination)",
      "28:1331es" : "28:1331es (28:1331 Enforcement of Administrative Subpoena)",
      "28:1331fl" : "28:1331fl (28:1331 Fed. Question: Fair Labor Standards)",
      "28:1331in" : "28:1331in (28:1331 Fed. Question: Insurance Contract)",
      "28:1331mm" : "28:1331mm (28:1331 Fed. Question: Medical Malpractice)",
      "28:1331pi" : "28:1331pi (28:1331 Fed. Question: Personal Injury)",
      "28:1331rd" : "28:1331rd (28:1331 Fed. Question: Review Agency Decision)",
      "28:1331rp" : "28:1331rp (28:1331(a) Fed. Question: Real Property)",
      "28:1331rr" : "28:1331rr (28:1331 Fed. Question: Railway Labor Act)",
      "28:1331sv" : "28:1331sv (28:1331 Fed. Question: Securities Violation)",
      "28:1331tr" : "28:1331tr (28:1331 Fed. Question: Trademark)",
      "28:1331tt" : "28:1331tt (28:1331 Fed. Question: Tort Action)",
      "28:1331v" : "28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendment)",
      "28:1331wl" : "28:1331wl (28:1331 Federal Question: EPA Waste Lien)",
      "28:1331wt" : "28:1331wt (28:1331 Fed. Question: Water Rights)",
      "28:1332ac" : "28:1332ac (28:1332 Diversity-Account Receivable)",
      "28:1332al" : "28:1332al (28:1332 Diversity-Airline Crash)",
      "28:1332as" : "28:1332as (28:1332 Diversity-Asbestos Litigation)",
      "28:1332au" : "28:1332au (28:1332 Diversity-Auto Negligence)",
      "28:1332bc" : "28:1332bc (28:1332 Diversity-Breach of Contract)",
      "28:1332co" : "28:1332co (28:1332 Diversity-Conversion)",
      "28:1332ct" : "28:1332ct (28:1332 Diversity-(Citizenship))",
      "28:1332det" : "28:1332det (28:1332 Diversity: Forcible Detainer)",
      "28:1332df" : "28:1332df (28:1332 Diversity-Contract Default)",
      "28:1332ds" : "28:1332ds (28:1332 Diversity-Contract Dispute)",
      "28:1332ed" : "28:1332ed (28:1332 Diversity-Employment Discrimination)",
      "28:1332fd" : "28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)",
      "28:1332fr" : "28:1332fr (28:1332 Diversity-Fraud)",
      "28:1332ia" : "28:1332ia (28:1332 Diversity-Interpleader Action)",
      "28:1332ij" : "28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)",
      "28:1332in" : "28:1332in (28:1332 Diversity-Insurance Contract)",
      "28:1332jd" : "28:1332jd (28:1332 Diversity-Declaratory Judgement)",
      "28:1332lb" : "28:1332lb (28:1332 Diversity-Libel,Assault,Slander)",
      "28:1332lm" : "28:1332lm (28:1332 Diversity - Legal Malpractice)",
      "28:1332ma" : "28:1332ma (28:1332 Diversity-Miller Act)",
      "28:1332mf" : "28:1332mf (28:1332 Diversity-Mortgage Foreclosure)",
      "28:1332mm" : "28:1332mm (28:1332 Diversity-Medical Malpractice)",
      "28:1332mv" : "28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)",
      "28:1332ni" : "28:1332ni (28:1332 Diversity-Negotiable Instrument)",
      "28:1332nm" : "28:1332nm (28:1332 Diversity-Non-Motor Vehicle)",
      "28:1332oc" : "28:1332oc (28:1332 Diversity-Other Contract)",
      "28:1332pd" : "28:1332pd (28:1332 Diversity-Property Damage)",
      "28:1332pi" : "28:1332pi (28:1332 Diversity-Personal Injury)",
      "28:1332pl" : "28:1332pl (28:1332 Diversity-Product Liability)",
      "28:1332pr" : "28:1332pr (28:1332 Diversity-Petition for Removal)",
      "28:1332qt" : "28:1332qt (28:1332 Diversity-Petition to Quiet Title)",
      "28:1332ri" : "28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)",
      "28:1332sa" : "28:1332sa (28:1332 - Diversity: Securities & Exchange Commission Act)",
      "28:1332sf" : "28:1332sf (28:1332 - Diversity: Securities Fraud)",
      "28:1332ss" : "28:1332ss (28:1332 Diversity - Stockholders Suits)",
      "28:1332tl" : "28:1332tl (28:1332 Diversity-Torts to Land)",
      "28:1332tm" : "28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))",
      "28:1332tn" : "28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)",
      "28:1332wd" : "28:1332wd (28:1332 Diversity-Wrongful Death)",
      "28:1333" : "28:1333 (28:1333 Admiralty)",
      "28:1334" : "28:1334 (28:1334 Bankruptcy Appeal)",
      "28:1334c" : "28:1334c (28:1334(c) R&R re motions for abstention (non-core))",
      "28:1335" : "28:1335 (28:1335 Interpleader Action)",
      "28:1337" : "28:1337 (28:1337 Sherman-Clayton Act)",
      "28:1338cp" : "28:1338cp (28:1338 Copyright Infringement)",
      "28:1338pt" : "28:1338pt (28:1338 Patent Infringement)",
      "28:1338tr" : "28:1338tr (28:1338 Trademark Infringement)",
      "28:1340" : "28:1340 (28:1340 IRS: Custom Duties)",
      "28:1340er" : "28:1340er (28:1340 Recovery of Erroneous Refund)",
      "28:1341" : "28:1341 (28:1341 Complaint for Forfeiture)",
      "28:1343" : "28:1343 (28:1343 Violation of Civil Rights)",
      "28:1345co" : "28:1345co (28:1345 Replevin & Conversion)",
      "28:1345db" : "28:1345db (28:1345 Debt to US - FHA/HUD Title I)",
      "28:1345df" : "28:1345df (28:1345 Default of Promissory Note)",
      "28:1345er" : "28:1345er (28:1345 Recovery of Erroneous Refund)",
      "28:1345fc" : "28:1345fc (28:1345 Foreclosure)",
      "28:1345ff" : "28:1345ff (28:1345 Complaint for Forfeiture)",
      "28:1345hl" : "28:1345hl (28:1345 VA Home Loan Guaranty Debt)",
      "28:1345mc" : "28:1345mc (28:1345 Medical Care Recovery)",
      "28:1345mi" : "28:1345mi (28:1345 Mining Claim Ejectment)",
      "28:1345pd" : "28:1345pd (28:1345 Property Damage)",
      "28:1345pe" : "28:1345pe (28:1345 Property Ejectment)",
      "28:1345rc" : "28:1345rc (28:1345 Recovery of Debt to US)",
      "28:1345st" : "28:1345st (28:1345 Default of Student Loan)",
      "28:1345tp" : "28:1345tp (28:1345 Trespass on Public Land)",
      "28:1345va" : "28:1345va (28:1345 Recovery of VA Overpayment)",
      "28:1346bc" : "28:1346bc (28:1346 Breach of Contract)",
      "28:1346rc" : "28:1346rc (28:1346 Recovery of IRS Tax)",
      "28:1346tc" : "28:1346tc (28:1346 Tort Claim)",
      "28:1346wd" : "28:1346wd (28:1346 Wrongful Death)",
      "28:1352" : "28:1352 (28:1352 Miller Act)",
      "28:1355" : "28:1355 (28:1355 Petition for Return of Property)",
      "28:1358" : "28:1358 (28:1358 Land Condemnation)",
      "28:1361" : "28:1361 (28:1361 Petition for Writ of Mandamus)",
      "28:1362ic" : "28:1362ic (28:1362 Indian Tribal Controversy)",
      "28:1362iw" : "28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)",
      "28:1364" : "28:1364 (28:1364 Auto Negligence)",
      "28:1391" : "28:1391 (28:1391 Personal Injury)",
      "28:1402" : "28:1402 (28:1402 Medical Malpractice)",
      "28:1407" : "28:1407 (28:1407 Airline Crash)",
      "28:1441ac" : "28:1441ac (28:1441 Petition for Removal- Account Receivable)",
      "28:1441al" : "28:1441al (28:1441 Petition for Removal- Airline Crash)",
      "28:1441as" : "28:1441as (28:1441 Petition for Removal- Asbestos Litigation)",
      "28:1441au" : "28:1441au (28:1441 Petition for Removal- Auto Negligence)",
      "28:1441bc" : "28:1441bc (28:1441 Petition for Removal- Breach of Contract)",
      "28:1441cv" : "28:1441cv (28:1441 Petition for Removal- Civil Rights Act)",
      "28:1441df" : "28:1441df (28:1441 Petition for Removal- Contract Default)",
      "28:1441dj" : "28:1441dj (28:1441 Petition for Removal- Declaratory Judgement)",
      "28:1441ds" : "28:1441ds (28:1441 Petition for Removal- Contract Dispute)",
      "28:1441ed" : "28:1441ed (28:1441 Petition for Removal - Employment Discrimination)",
      "28:1441fc" : "28:1441fc (28:1441 Petition for Removal - Fair Credit Reporting Act)",
      "28:1441fr" : "28:1441fr (28:1441 Petition for Removal- Fraud)",
      "28:1441ij" : "28:1441ij (28:1441 Petition for Removal- Injunctive/Declaratory Relief)",
      "28:1441in" : "28:1441in (28:1441 Petition for Removal- Insurance Contract)",
      "28:1441int" : "28:1441int (28:1441 Petition for Removal- Action for Interpleader)",
      "28:1441lb" : "28:1441lb (28:1441 Petition for Removal Libel,Assault,Slander)",
      "28:1441lm" : "28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relations)",
      "28:1441mm" : "28:1441mm (28:1441 Petition for Removal- Medical Malpractice)",
      "28:1441ni" : "28:1441ni (28:1441 Petition for Removal- Negotiable Instrument)",
      "28:1441nm" : "28:1441nm (28:1441 Petition for Removal- Non-Motor Vehicle)",
      "28:1441oc" : "28:1441oc (28:1441 Petition For Removal--Other Contract)",
      "28:1441pd" : "28:1441pd (28:1441 Petition for Removal- Property Damage)",
      "28:1441pi" : "28:1441pi (28:1441 Petition for Removal- Personal Injury)",
      "28:1441pl" : "28:1441pl (28:1441 Petition for Removal- Product Liability)",
      "28:1441pr" : "28:1441pr (28:1441 Petition for Removal)",
      "28:1441qt" : "28:1441qt (28:1441 Petition for Removal- Petition to Quiet Title)",
      "28:1441ri" : "28:1441ri (28:1441 Petition for Removal- Racketeering (RICO) Act)",
      "28:1441sa" : "28:1441sa (28:1441 - Petition for Removal: SEC Act)",
      "28:1441sf" : "28:1441sf (28:1441 - Petition for Removal: Securities Fraud)",
      "28:1441tl" : "28:1441tl (28:1441 Petition for Removal- Torts to Land)",
      "28:1441tm" : "28:1441tm (28:1441 Petition for Removal- Tort/Motor Vehicle (P.I.))",
      "28:1441tn" : "28:1441tn (28:1441 Petition for Removal- Tort/Non-Motor Vehicle)",
      "28:1441wd" : "28:1441wd (28:1441 Petition for Removal- Wrongful Death)",
      "28:1442bc" : "28:1442bc (28:1442 Petition for Removal- Breach of Contract)",
      "28:1442pr" : "28:1442pr (28:1442 Petition for Removal)",
      "28:1443" : "28:1443 (28:1443(1) Rent, Lease & Ejectment)",
      "28:1444" : "28:1444 (28:1444 Petition for Removal- Foreclosure)",
      "28:1446in" : "28:1446in (28:1446 Breach of Contract- Insurance)",
      "28:1446pd" : "28:1446pd (28:1446 Petition for Removal- Property Damage (P.I.))",
      "28:1446pi" : "28:1446pi (28:1446 Petition for Removal- Personal Injury)",
      "28:1446pl" : "28:1446pl (28:1446pl Petition for Removal - Product Liability)",
      "28:1446pr" : "28:1446pr (28:1446 Petition for Removal)",
      "28:1452" : "28:1452 (28:1452 R&R re motions to remand (non-core))",
      "28:1651" : "28:1651 (28:1651 Petition for Writ of Coram Nobis)",
      "28:1651hc" : "28:1651hc (28:1651 Petition for Writ of Habeas Corpus)",
      "28:1651mn" : "28:1651mn (28:1651 Petition for Writ of Mandamus)",
      "28:1983" : "28:1983 (28:1983 Civil Rights)",
      "28:2201" : "28:2201 (28:2201 Constitutionality of State Statute(s))",
      "28:2201dj" : "28:2201dj (28:2201 Declaratory Judgement)",
      "28:2201ij" : "28:2201ij (28:2201 Injunction)",
      "28:2201in" : "28:2201in (28:2201 Declaratory Judgement (Insurance))",
      "28:2241" : "28:2241 (28:2241 Petition for Writ of Habeas Corpus)",
      "28:2254" : "28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))",
      "28:2254se" : "28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)",
      "28:2255" : "28:2255 (28:2255 Remedies on motion attacking sentence)",
      "28:2271" : "28:2271 (28:2271 Federal Tort Claims Act)",
      "28:2345" : "28:2345 (28:2345 Medicare Recovery)",
      "28:2409" : "28:2409 (28:2409(a) Quiet Title Action)",
      "28:2410" : "28:2410 (28:2410 Quiet Title)",
      "28:2671" : "28:2671 (28:2671 Federal Tort Claims Act)",
      "28:2674" : "28:2674 (28:2674 Federal Tort Claims Act)",
      "28:7402" : "28:7402 (28:7402 Refund of Taxes)",
      "28:7422" : "28:7422 (28:7422 Appeal from Administrative Decision)",
      "29:0151" : "29:0151 (29:151 Labor: Review of Agency Action)",
      "29:0160" : "29:0160 (29:160(1) National Labor Relations Act)",
      "29:0184" : "29:0184 (29:184 Violation Collection Bargain Agreement)",
      "29:0185ep" : "29:0185ep (29:185 Employee Pension Plan)",
      "29:0185lm" : "29:0185lm (29:185 Labor/Mgt. Relations (Contracts))",
      "29:0201do" : "29:0201do (29:201 Denial of Overtime Compensation)",
      "29:0201fl" : "29:0201fl (29:201 Fair Labor Standards Act)",
      "29:0203" : "29:0203 (29:203 Equal Pay Act)",
      "29:0206" : "29:0206 (29:206 Collect Unpaid Wages)",
      "29:0401" : "29:0401 (29:0401 Labor Management Disclosure Act)",
      "29:0621" : "29:0621 (29:621 Job Discrimination (Age))",
      "29:0623" : "29:0623 (29:623 Job Discrimination (Age))",
      "29:0626" : "29:0626 (29:626 Job Discrimination (Age))",
      "29:0633" : "29:0633 (29:633 Job Discrimination (Age))",
      "29:0651" : "29:0651 (29:651 Occupational Safety/Health)",
      "29:0754" : "29:0754 (29:754 Discrimination)",
      "29:0791" : "29:0791 (29:791 Job Discrimination (Rehabilitation Act))",
      "29:0794" : "29:0794 (29:0794 Job Discrimination (Handicap))",
      "29:1001" : "29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)",
      "29:1002" : "29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)",
      "29:1104" : "29:1104 (29:1104 Recovery of Benefits to Employee)",
      "29:1109" : "29:1109 (29:1109 Breach of Fiduciary Duties)",
      "29:1131" : "29:1131 (29:1131 ERISA - Collection of Delinquent Trust Funds)",
      "29:1132" : "29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)",
      "29:1145" : "29:1145 (29:1145 E.R.I.S.A.)",
      "29:1149" : "29:1149 (29:1149 Recover Pension & Profit Sharing)",
      "29:1337" : "29:1337 (29:1337 E.R.I.S.A.)",
      "29:1362" : "29:1362 (29:1362 ERISA)",
      "29:1381" : "29:1381 (29:1381 E.R.I.S.A.)",
      "29:1401" : "29:1401 (29:1401(b)(2) Appeal of Arbitration Award)",
      "29:1451" : "29:1451 (29:1451 E.R.I.S.A.)",
      "29:1801" : "29:1801 (29:1801 Farmworker Rights)",
      "29:2101" : "29:2101 (Worker Adjustment and Restraining Notification Act)",
      "29:790" : "29:790 (29:790 Rehabilitation of Labor)",
      "30:0181" : "30:0181 (30:181 Environment: Review of Agency Action)",
      "30:0801" : "30:0801 (30:0801 Penalities/Federal Mine Safety Health Act - 1977)",
      "30:1201" : "30:1201 (30:1201 Environment: Review of Agency Action)",
      "30:1202" : "30:1202 (30:1202 Mining Reclamation Act)",
      "30:1276" : "30:1276 (30:1276 Interior: Review of Agency Action)",
      "31:3545" : "31:3545 (31:3545 Action to Recovery Money)",
      "31:3729" : "31:3729 (31:3729 False Claims Act)",
      "31:3730" : "31:3730 (31:3730 Qui Tam False Claims Act)",
      "31:3731" : "31:3731 (31:3731 Fraud)",
      "33:1319cw" : "33:1319cw (33:1319 Clean Water Act)",
      "33:1319pv" : "33:1319pv (33:1319 Pollutants & Permit Violations)",
      "33:1365" : "33:1365 (33:1365 Environmental Matters)",
      "35:0145" : "35:0145 (35:145 Patent Infringement)",
      "35:0183" : "35:0183 (35:183 Patent Infringement)",
      "35:0271" : "35:0271 (35:271 Patent Infringement)",
      "38:1681" : "38:1681 (38:1681 Recovery of VA Overpayment)",
      "38:1686" : "38:1686 (38:1686 Recovery of VA Overpayment)",
      "38:1780" : "38:1780 (38:1780 Recovery of VA Overpayment)",
      "38:2011" : "38:2011 (38:2011 - Veteran's Readjustment Assistance Act of 1974)",
      "38:3116" : "38:3116 (38:3116 VA Overpayment)",
      "39:3005" : "39:3005 (39:3005 Detention of Mail for Temporary Periods)",
      "39:409" : "39:409 (39:409 Postal Service)",
      "40:0258" : "40:0258 (40:258(a) Public Buildings & Property: Land Condemnation)",
      "40:0875" : "40:0875 (40:875 Public Buildings & Property: Negligence)",
      "40:3131" : "40:3131 (Miller Act)",
      "41:0251" : "41:0251 (41:251 Public Contracts-Review of Agency Action)",
      "41:1463" : "41:1463 (41:1463 Public Contracts: Unlawful Employment Practices)",
      "42:0205" : "42:0205 (42:205 Denial Social Security Benefits)",
      "42:0206" : "42:0206 (42:206 Social Security Benefits)",
      "42:0247" : "42:0247 (42:247 Personal Injury-Swine Flu)",
      "42:0402" : "42:0402 (42:402 Social Security Benefits)",
      "42:0405id" : "42:0405id (42:405 Review of HHS Decision (SSID))",
      "42:0405wc" : "42:0405wc (42:405 Review of HHS Decision (DIWC))",
      "42:0405ww" : "42:0405ww (42:405 Review of HHS Decision (DIWW))",
      "42:0416" : "42:0416 (42:416 Denial of Social Security Benefits)",
      "42:0427" : "42:0427 (42:427 Social Security Benefits)",
      "42:12101" : "42:12101 (42:12101 Americans with Disabilities Act)",
      "42:1383" : "42:1383 (42:1383 Review of HHS Decision)",
      "42:1395" : "42:1395 (42:1395 HHS: Adverse Reimbursement Review)",
      "42:1396" : "42:1396 (42:1396 - Tort Negligence)",
      "42:1471" : "42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclosure Sale)",
      "42:1981cv" : "42:1981cv (42:1981 Civil Rights)",
      "42:1981hs" : "42:1981hs (42:1981 Housing Discrimination)",
      "42:1981jb" : "42:1981jb (42:1981 Job Discrimination (Race))",
      "42:1981sx" : "42:1981sx (42:1981 Sex Discrimination)",
      "42:1983cv" : "42:1983cv (42:1983 Civil Rights Act)",
      "42:1983ed" : "42:1983ed (42:1983 Civil Rights (Employment Discrimination))",
      "42:1983pr" : "42:1983pr (42:1983 Prisoner Civil Rights)",
      "42:1985cv" : "42:1985cv (42:1985 Civil Rights)",
      "42:1986" : "42:1986 (42:1986 Neglect of Duty)",
      "42:2000ag" : "42:2000ag (42:2000 Job Discrimination (Age))",
      "42:2000e" : "42:2000e (42:2000e Job Discrimination (Employment))",
      "42:2000pb" : "42:2000pb (42:2000 Job Discrimination (Public Accomodations))",
      "42:2000ra" : "42:2000ra (42:2000 Job Discrimination (Race))",
      "42:2000sx" : "42:2000sx (42:2000 Job Discrimination (Sex))",
      "42:2003" : "42:2003 (42:2003 Job Discrimination)",
      "42:2005" : "42:2005 (42:2005 Review of Agency Action-HHS)",
      "42:2651" : "42:2651 (42:2651 Medical Care Recovery)",
      "42:3601" : "42:3601 (42:405 Fair Housing Act)",
      "42:4000" : "42:4000 (42:4000 National Flood Insurance Act)",
      "42:4001" : "42:4001 (42:4001 National Insurance Flood Act)",
      "42:4053" : "42:4053 (42:4053 Breach of Insurance Contract)",
      "42:4072" : "42:4072 (42:4072 Payment of Flood Insurance Claim)",
      "42:425" : "42:425 (42:425 Social Security Benefits)",
      "42:4321" : "42:4321 (42:4321 Review of Agency Action-Environment)",
      "42:4332" : "42:4332 (42:4332 Environmental Policy - Coop of Agency Reports)",
      "42:6901en" : "42:6901en (42:6901 Environmental Cleanup Expenses)",
      "42:6901rs" : "42:6901rs (42:6901 Resource & Recovery Act)",
      "42:7413" : "42:7413 (42:7413(b) Clean Air Act)",
      "42:7604cl" : "42:7604cl (42:7604 Clear Air Act (Emission Standards))",
      "42:7604ir" : "42:7604ir (42:7604 Petition to Quash IRS Summons)",
      "42:9607" : "42:9607 (42:9607 Real Property Tort to Land)",
      "43:945" : "43:945 (43:945 Compensation for Land Condemnation)",
      "43:945a" : "43:945a (43:945a Complaint in Condemnation)",
      "43:946" : "43:946 (43:946 Complaint in Condemnation - Eminent Domain)",
      "45:0051" : "45:0051 (45:51 Railways: Fed. Employer's Liability Act)",
      "45:0151" : "45:0151 (45:151 Railway Labor Act)",
      "45:0184" : "45:0184 (45:184 Action to Set Aside Award of a System Board of Adjust)",
      "45:1395" : "45:1395 (45:1395 Railroads: Adverse Reimbursement Review)",
      "45:7457" : "45:7457 (45:7457 Compel Reclamation Under Clear Air Act)",
      "46:0688" : "46:0688 (46:688 Jones Act)",
      "46:0741" : "46:0741 (46:741 Shipping)",
      "46:0761" : "46:0761 (46:761 Shipping: Damages for Death on High Seas)",
      "46:1101" : "46:1101 (46:1101 Violation of Maritime Regulations)",
      "46:1156" : "46:1156 (46:1156 Administrative Procedure Act)",
      "48:0883" : "48:0883 (48:883 Violation of US Coastal Law)",
      "48:1985" : "48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)",
      "49:0081" : "49:0081 (49:81 Damaged Goods While Being Transported)",
      "49:0781" : "49:0781 (49:781 Forfeiture)",
      "49:11503" : "49:11503 (49:11503 Railroad Revitalization Regulatory Reform Act)",
      "49:11702" : "49:11702 (49:11702(a)(4) Violations of Interstate Commerce Act)",
      "49:1471" : "49:1471 (49:1471 Federal Aviation Act)",
      "49:1903" : "49:1903 (49:1903 Petition to enforce administrative summons)",
      "8:287" : "8:287 (8:287 Petition to Enforce INS Subpoena)",
      "misc" : "misc (Civil Miscellaneous Case)"
   },
   "ilsdce" : {
      "*41*" : "*41* ()",
      "0" : "0 (No cause code entered)",
      "00:0000" : "00:0000 (00:0000 Cause Code Unknown)",
      "02:0431" : "02:0431 (02:431 Fed. Election Commission: Failure Enforce C)",
      "02:0437" : "02:0437 (02:437 Federal Election Commission)",
      "05:0075" : "05:0075 (05:75(2) Contract - Reduction in Grade)",
      "05:0551" : "05:0551 (05:551 Administrative Procedure Act)",
      "05:0552fi" : "05:0552fi (05:552 Freedom of Information Act)",
      "05:0552pa" : "05:0552pa (05:552 Right to Privacy Act)",
      "05:0554" : "05:0554 (05:0554 Constitutionality of Maritime Statutes)",
      "05:0701" : "05:0701 (05:0701 Maritime Subsidy Board)",
      "05:0702" : "05:0702 (05:702 Administrative Procedure Act)",
      "05:0704" : "05:0704 (05:704 Labor Litigation)",
      "05:7703" : "05:7703 (05:7703 Discrimination - Review of Agency Act)",
      "07:0006" : "07:0006 (7:6(b) Federal Commodity Exchange Regulation)",
      "07:0025" : "07:0025 (7:25 Fraud - Commodities Leverage Contracts)",
      "07:0181" : "07:0181 (07:181 Packers & Stockyard Act)",
      "07:0499" : "07:0499 (07:499 Agricultural Commodities Act)",
      "07:0601" : "07:0601 (07:601 USDA Condemnation)",
      "07:2321" : "07:2321 (07:2321 Plant Variety Protection Act)",
      "08:1105" : "08:1105 (8:1105(a) Aliens: Habeas Corpus to Release INS Det)",
      "08:1252" : "08:1252 (08:1252(a)(2) Injunction for Deportation)",
      "08:1260" : "08:1260 (08:1260 Aliens: Access to Records)",
      "08:1324" : "08:1324 (08:1324 Aliens: Complaint for Forfeiture)",
      "08:1329" : "08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petiti)",
      "08:1446" : "08:1446 (8:1446 Petition for Naturalization Hearing)",
      "09:0001" : "09:0001 (09:1 U.S. Arbitration Act)",
      "09:0009" : "09:0009 (9:9 Motion to Confirm Arbitration Loan)",
      "09:0010" : "09:0010 (09:0010 Petition to Vacate Arbitration Award)",
      "10:1552" : "10:1552 (10:1552 Armed Forces: Action to Correct Records)",
      "10:1553" : "10:1553 (10:1553 Armed Forces: FOIA General)",
      "10:2305" : "10:2305 (10:2305 Review of Federal Contract)",
      "11:0101" : "11:0101 (11:101 Bankruptcy)",
      "12:0022" : "12:0022 (12:22 Securities Fraud)",
      "12:0635" : "12:0635 (12:635 Breach of Insurance Contract)",
      "12:1461" : "12:1461 (12:1461 Homeowners Loan Act)",
      "12:1703" : "12:1703 (12:1703 Default of HUD Loan)",
      "12:1725" : "12:1725 (12:1725 Collection under Contract Guaranty)",
      "12:1730" : "12:1730 (12:1730 Collection Under Contract Guaranty)",
      "12:1819" : "12:1819 (12:1819 Default of Promissory Note)",
      "12:1821" : "12:1821 (12:1821 Default of Loan by Promissary Note)",
      "12:1971" : "12:1971 (12:1971 Relief under Bank Holding Act)",
      "12:3410" : "12:3410 (12:3410 Right to Financial Privacy Act)",
      "15:0001" : "15:0001 (15:1 Antitrust Litigation)",
      "15:0002at" : "15:0002at (15:2 Antitrust Litigation)",
      "15:0002fl" : "15:0002fl (15:2(a) Fair Labor Standards Act)",
      "15:0005" : "15:0005 (15:5(a) Fair Labor Standards Act)",
      "15:0015" : "15:0015 (15:15 Antitrust Litigation)",
      "15:0025" : "15:0025 (15:25 Clayton Act)",
      "15:0044" : "15:0044 (15:44 Trademark Infringement)",
      "15:0045" : "15:0045 (15:0045 Federal Trade Commission Act)",
      "15:0052" : "15:0052 (15:0052 Federal Trade Commission Act)",
      "15:0053" : "15:0053 (15:0053 Federal Trade Commission Act)",
      "15:0077" : "15:0077 (15:77 Securities Fraud)",
      "15:0078" : "15:0078 (15:78m(a) Securities Exchange Act)",
      "15:0631" : "15:0631 (15:631 Small Business Act)",
      "15:0717" : "15:0717 (15:717 Natural Gas Act)",
      "15:1051" : "15:1051 (15:1051 Trademark Infringement)",
      "15:1114" : "15:1114 (15:1114 Trademark Infringement)",
      "15:1121" : "15:1121 (15:1121 Trademark Infringement)",
      "15:1125" : "15:1125 (15:1125 Trademark Infringement (Lanham Act))",
      "15:1126" : "15:1126 (15:1126 Patent Infringement)",
      "15:1127" : "15:1127 (15:1127 Trademark Infringement)",
      "15:1601" : "15:1601 (15:1601 Truth in Lending)",
      "15:1640" : "15:1640 (15:1640 Truth in Lending)",
      "15:1681" : "15:1681 (15:1681 Fair Credit Reporting Act)",
      "15:1692" : "15:1692 (15:1692 Fair Debt Collection Act)",
      "15:1938" : "15:1938 (15:1938 Fair Labor Standards Act)",
      "15:1981" : "15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))",
      "15:1988" : "15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))",
      "15:1989" : "15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))",
      "15:2301" : "15:2301 (15:2301 Magnuson-Moss Warranty Act)",
      "15:2801" : "15:2801 (15:2801 Petroleum Marketing Practices Act)",
      "15:53(b)" : "15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equita)",
      "16:0668" : "16:0668 (16:668 Bald Eagle Protection Act)",
      "16:0703" : "16:0703 (16:703 Migratory Bird Act)",
      "16:1538" : "16:1538 (16:1538 Endangered Species Act)",
      "16:3371" : "16:3371 (16:3371 Wildlife Under the Lacey Act)",
      "16:3372" : "16:3372 (16:3372 Conservation: Complaint for Forfeiture)",
      "16:3373" : "16:3373 (16:3373 Appeal of Decision - DOI)",
      "16:3374" : "16:3374 (16:3374 Conservation: Complaint for Forfeiture)",
      "17:0101" : "17:0101 (17:101 Copyright Infringement)",
      "17:0501" : "17:0501 (17:501 Copyright Infringement)",
      "17:0504" : "17:0504 (17:504 Copyright Infringement)",
      "18:0241" : "18:0241 (18:241 Conspiracy Against Citizen Rights)",
      "18:1836a" : "18:1836a (18:1836(a) Injunction against Misappropriation of Trade Secrets)",
      "18:1836b" : "18:1836b (18:1836(b) Civil Action to Protect Trade Secrets)",
      "18:1961" : "18:1961 (18:1961 Racketeering (RICO) Act)",
      "18:1962" : "18:1962 (18:1962 Racketeering (RICO) Act)",
      "18:1964" : "18:1964 (18:1964 Racketeering (RICO) Act)",
      "18:4208" : "18:4208 (18:4208(B) Agency Action Review)",
      "18:4248" : "18:4248 (18:4248(a) Adam Walsh Act)",
      "19:1305" : "19:1305 (19:1305 Custom Duties:0Forfeiture-Immoral Articles)",
      "1:102" : "1:102 (1:102 Americans with Disabilities Act)",
      "20:1080" : "20:1080 (20:1080 Student Loan Recovery)",
      "20:1400" : "20:1400 (20:1400 Civil Rights of Handicapped Child)",
      "20:1401" : "20:1401 (20:1401 Education: Handicapped Child Act)",
      "21:0841" : "21:0841 (21:841 Forfeiture Property-Drugs)",
      "21:0881" : "21:0881 (21:881 Forfeiture Property-Drugs)",
      "21:0881a" : "21:0881a (21:881 Forfeiture Property - Aircraft)",
      "21:0881re" : "21:0881re (21:881 Forfeiture Property - Real Estate)",
      "23:0134" : "23:0134 (23:134 P.I.- Auto Negligence)",
      "23:1441" : "23:1441 (23:1441 Contract Real Estate)",
      "24:1000" : "24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)",
      "25:0640" : "25:0640 (25:640 Indian Tribal Rights)",
      "25:1901" : "25:1901 (25:1901 Indian Child Welfare Act)",
      "26:6212" : "26:6212 (26:6212 Injunctive Relief from IRS Lien)",
      "26:6213" : "26:6213 (26:6213 Injunctive Relief from IRS Lien)",
      "26:6502" : "26:6502 (26:6502 IRS:Enforcement of tax liens)",
      "26:6532" : "26:6532 (26:6532 IRS: Refund of Tax Penalty)",
      "26:6702" : "26:6702 (26:6702 IRS: Refund of Income Tax Penalty)",
      "26:6703" : "26:6703 (26:6703 IRS: Refund of Tax Penalty)",
      "26:7401" : "26:7401 (26:7401 IRS: Tax Liability)",
      "26:7402" : "26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)",
      "26:7403" : "26:7403 (26:7403 Suit to Enforce Federal Tax Lien)",
      "26:7422rt" : "26:7422rt (26:7422 IRS: Refund Taxes)",
      "26:7422rx" : "26:7422rx (26:7422 IRS: Refund Excise Tax)",
      "26:7426" : "26:7426 (26:7426 IRS: Wrongful Levy for Taxes)",
      "26:7429" : "26:7429 (26:7429 IRS: Tax Jeopardy Assessment)",
      "26:7609" : "26:7609 (26:7609 IRS: Petition to Quash IRS Summons)",
      "27:0185" : "27:0185 (27:185 Enforcement of Arbitration Award)",
      "28:0157c" : "28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)",
      "28:0157d" : "28:0157d (28:0157 Motion for Withdrawal of Reference)",
      "28:0158" : "28:0158 (28:0158 Notice of Appeal re Bankruptcy Matter (BA)",
      "28:0185" : "28:0185 (28:185 Suit to Compel Arbitration)",
      "28:0451" : "28:0451 (28:451 Employment Discrimination)",
      "28:0794" : "28:0794 (28:794 Rehabilitation Act)",
      "28:1001" : "28:1001 (28:1001 E.R.I.S.A.)",
      "28:1132" : "28:1132 (28:1132 E.R.I.S.A.)",
      "28:1330" : "28:1330 (28:1330 Breach of Contract)",
      "28:1331" : "28:1331 (28:1331 Fed. Question)",
      "28:1331al" : "28:1331al (28:1331 Fed. Question: Airline Crash)",
      "28:1331at" : "28:1331at (28:1331 Fed. Question: Anti-trust)",
      "28:1331au" : "28:1331au (28:1331 Fed. Question: Auto Negligence)",
      "28:1331b" : "28:1331b (28:1331 Federal Question: Bivens Act)",
      "28:1331bc" : "28:1331bc (28:1331 Fed. Question: Breach of Contract)",
      "28:1331ca" : "28:1331ca (28:1331 Fed Question: Fed Communications Act of 1)",
      "28:1331cm" : "28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)",
      "28:1331cv" : "28:1331cv (28:1331 Federal Question: Other Civil Rights)",
      "28:1331ed" : "28:1331ed (28:1331 Fed. Question: Employment Discrimination)",
      "28:1331es" : "28:1331es (28:1331 Enforcement of Administrative Subpoena)",
      "28:1331fl" : "28:1331fl (28:1331 Fed. Question: Fair Labor Standards)",
      "28:1331in" : "28:1331in (28:1331 Fed. Question: Insurance Contract)",
      "28:1331mm" : "28:1331mm (28:1331 Fed. Question: Medical Malpractice)",
      "28:1331pi" : "28:1331pi (28:1331 Fed. Question: Personal Injury)",
      "28:1331rd" : "28:1331rd (28:1331 Fed. Question: Review Agency Decision)",
      "28:1331rp" : "28:1331rp (28:1331(a) Fed. Question: Real Property)",
      "28:1331rr" : "28:1331rr (28:1331 Fed. Question: Railway Labor Act)",
      "28:1331sv" : "28:1331sv (28:1331 Fed. Question: Securities Violation)",
      "28:1331tr" : "28:1331tr (28:1331 Fed. Question: Trademark)",
      "28:1331tt" : "28:1331tt (28:1331 Fed. Question: Tort Action)",
      "28:1331v" : "28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendme)",
      "28:1331wl" : "28:1331wl (28:1331 Federal Question: EPA Waste Lien)",
      "28:1331wt" : "28:1331wt (28:1331 Fed. Question: Water Rights)",
      "28:1332ac" : "28:1332ac (28:1332 Diversity-Account Receivable)",
      "28:1332al" : "28:1332al (28:1332 Diversity-Airline Crash)",
      "28:1332as" : "28:1332as (28:1332 Diversity-Asbestos Litigation)",
      "28:1332au" : "28:1332au (28:1332 Diversity-Auto Negligence)",
      "28:1332bc" : "28:1332bc (28:1332 Diversity-Breach of Contract)",
      "28:1332co" : "28:1332co (28:1332 Diversity-Conversion)",
      "28:1332ct" : "28:1332ct (28:1332 Diversity-(Citizenship))",
      "28:1332det" : "28:1332det (28:1332 Diversity: Forcible Detainer)",
      "28:1332df" : "28:1332df (28:1332 Diversity-Contract Default)",
      "28:1332ds" : "28:1332ds (28:1332 Diversity-Contract Dispute)",
      "28:1332ed" : "28:1332ed (28:1332 Diversity-Employment Discrimination)",
      "28:1332fd" : "28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)",
      "28:1332fr" : "28:1332fr (28:1332 Diversity-Fraud)",
      "28:1332ia" : "28:1332ia (28:1332 Diversity-Interpleader Action)",
      "28:1332ij" : "28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)",
      "28:1332in" : "28:1332in (28:1332 Diversity-Insurance Contract)",
      "28:1332jd" : "28:1332jd (28:1332 Diversity-Declaratory Judgement)",
      "28:1332lb" : "28:1332lb (28:1332 Diversity-Libel,Assault,Slander)",
      "28:1332lm" : "28:1332lm (28:1332 Diversity - Legal Malpractice)",
      "28:1332ma" : "28:1332ma (28:1332 Diversity-Miller Act)",
      "28:1332mm" : "28:1332mm (28:1332 Diversity-Medical Malpractice)",
      "28:1332mv" : "28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)",
      "28:1332ni" : "28:1332ni (28:1332 Diversity-Negotiable Instrument)",
      "28:1332nm" : "28:1332nm (28:1332 Diversity-Non-Motor Vehicle)",
      "28:1332oc" : "28:1332oc (28:1332 Diversity-Other Contract)",
      "28:1332pd" : "28:1332pd (28:1332 Diversity-Property Damage)",
      "28:1332pi" : "28:1332pi (28:1332 Diversity-Personal Injury)",
      "28:1332pl" : "28:1332pl (28:1332 Diversity-Product Liability)",
      "28:1332pr" : "28:1332pr (28:1332 Diversity-Petition for Removal)",
      "28:1332qt" : "28:1332qt (28:1332 Diversity-Petition to Quiet Title)",
      "28:1332ri" : "28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)",
      "28:1332sa" : "28:1332sa (28:1332 - Diversity: Securities & Exchange Commiss)",
      "28:1332sf" : "28:1332sf (28:1332 - Diversity: Securities Fraud)",
      "28:1332ss" : "28:1332ss (28:1332 Diversity - Stockholders Suits)",
      "28:1332tl" : "28:1332tl (28:1332 Diversity-Torts to Land)",
      "28:1332tm" : "28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))",
      "28:1332tn" : "28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)",
      "28:1332wd" : "28:1332wd (28:1332 Diversity-Wrongful Death)",
      "28:1333" : "28:1333 (28:1333 Admiralty)",
      "28:1334" : "28:1334 (28:1334 Bankruptcy Appeal)",
      "28:1334c" : "28:1334c (28:1334(c) R&R re motions for abstention (non-cor)",
      "28:1335" : "28:1335 (28:1335 Interpleader Action)",
      "28:1337" : "28:1337 (28:1337 Sherman-Clayton Act)",
      "28:1338cp" : "28:1338cp (28:1338 Copyright Infringement)",
      "28:1338pt" : "28:1338pt (28:1338 Patent Infringement)",
      "28:1338tr" : "28:1338tr (28:1338 Trademark Infringement)",
      "28:1340" : "28:1340 (28:1340 IRS: Custom Duties)",
      "28:1340er" : "28:1340er (28:1340 Recovery of Erroneous Refund)",
      "28:1341" : "28:1341 (28:1341 Complaint for Forfeiture)",
      "28:1343" : "28:1343 (28:1343 Violation of Civil Rights)",
      "28:1345co" : "28:1345co (28:1345 Replevin & Conversion)",
      "28:1345db" : "28:1345db (28:1345 Debt to US - FHA/HUD Title I)",
      "28:1345df" : "28:1345df (28:1345 Default of Promissory Note)",
      "28:1345er" : "28:1345er (28:1345 Recovery of Erroneous Refund)",
      "28:1345fc" : "28:1345fc (28:1345 Foreclosure)",
      "28:1345ff" : "28:1345ff (28:1345 Complaint for Forfeiture)",
      "28:1345hl" : "28:1345hl (28:1345 VA Home Loan Guaranty Debt)",
      "28:1345mc" : "28:1345mc (28:1345 Medical Care Recovery)",
      "28:1345mi" : "28:1345mi (28:1345 Mining Claim Ejectment)",
      "28:1345pd" : "28:1345pd (28:1345 Property Damage)",
      "28:1345pe" : "28:1345pe (28:1345 Property Ejectment)",
      "28:1345rc" : "28:1345rc (28:1345 Recovery of Debt to US)",
      "28:1345st" : "28:1345st (28:1345 Default of Student Loan)",
      "28:1345tp" : "28:1345tp (28:1345 Trespass on Public Land)",
      "28:1345va" : "28:1345va (28:1345 Recovery of VA Overpayment)",
      "28:1346bc" : "28:1346bc (28:1346 Breach of Contract)",
      "28:1346rc" : "28:1346rc (28:1346 Recovery of IRS Tax)",
      "28:1346tc" : "28:1346tc (28:1346 Tort Claim)",
      "28:1346wd" : "28:1346wd (28:1346 Wrongful Death)",
      "28:1352" : "28:1352 (28:1352 Miller Act)",
      "28:1355" : "28:1355 (28:1355 Petition for Return of Property)",
      "28:1358" : "28:1358 (28:1358 Land Condemnation)",
      "28:1361" : "28:1361 (28:1361 Petition for Writ of Mandamus)",
      "28:1362ic" : "28:1362ic (28:1362 Indian Tribal Controversy)",
      "28:1362iw" : "28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)",
      "28:1364" : "28:1364 (28:1364 Auto Negligence)",
      "28:1391" : "28:1391 (28:1391 Personal Injury)",
      "28:1402" : "28:1402 (28:1402 Medical Malpractice)",
      "28:1407" : "28:1407 (28:1407 Airline Crash)",
      "28:1441ac" : "28:1441ac (28:1441 Petition for Removal- Account Receivable)",
      "28:1441al" : "28:1441al (28:1441 Petition for Removal- Airline Crash)",
      "28:1441as" : "28:1441as (28:1441 Petition for Removal- Asbestos Litigation)",
      "28:1441au" : "28:1441au (28:1441 Petition for Removal- Auto Negligence)",
      "28:1441bc" : "28:1441bc (28:1441 Petition for Removal- Breach of Contract)",
      "28:1441cv" : "28:1441cv (28:1441 Petition for Removal- Civil Rights Act)",
      "28:1441df" : "28:1441df (28:1441 Petition for Removal- Contract Default)",
      "28:1441dj" : "28:1441dj (28:1441 Petition for Removal- Declaratory Judgemen)",
      "28:1441ds" : "28:1441ds (28:1441 Petition for Removal- Contract Dispute)",
      "28:1441ed" : "28:1441ed (28:1441 Petition for Removal - Employment Discrim)",
      "28:1441fc" : "28:1441fc (28:1441 Petition for Removal - Fair Credit Reporti)",
      "28:1441fr" : "28:1441fr (28:1441 Petition for Removal- Fraud)",
      "28:1441ij" : "28:1441ij (28:1441 Petition for Removal- Injunctive/Declarato)",
      "28:1441in" : "28:1441in (28:1441 Petition for Removal- Insurance Contract)",
      "28:1441int" : "28:1441int (28:1441 Petition for Removal- Action for Interplea)",
      "28:1441lb" : "28:1441lb (28:1441 Petition for Removal Libel,Assault,Slander)",
      "28:1441lm" : "28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relatio)",
      "28:1441mm" : "28:1441mm (28:1441 Petition for Removal- Medical Malpractice)",
      "28:1441ni" : "28:1441ni (28:1441 Petition for Removal- Negotiable Instrumen)",
      "28:1441nm" : "28:1441nm (28:1441 Petition for Removal- Non-Motor Vehicle)",
      "28:1441oc" : "28:1441oc (28:1441 Petition For Removal--Other Contract)",
      "28:1441pd" : "28:1441pd (28:1441 Petition for Removal- Property Damage)",
      "28:1441pi" : "28:1441pi (28:1441 Petition for Removal- Personal Injury)",
      "28:1441pl" : "28:1441pl (28:1441 Petition for Removal- Product Liability)",
      "28:1441pr" : "28:1441pr (28:1441 Petition for Removal)",
      "28:1441qt" : "28:1441qt (28:1441 Petition for Removal- Petition to Quiet Ti)",
      "28:1441ri" : "28:1441ri (28:1441 Petition for Removal- Racketeering (RICO))",
      "28:1441sa" : "28:1441sa (28:1441 - Petition for Removal: SEC Act)",
      "28:1441sf" : "28:1441sf (28:1441 - Petition for Removal: Securities Fraud)",
      "28:1441tl" : "28:1441tl (28:1441 Petition for Removal- Torts to Land)",
      "28:1441tm" : "28:1441tm (28:1441 Petition for Removal- Tort/Motor Vehicle ()",
      "28:1441tn" : "28:1441tn (28:1441 Petition for Removal- Tort/Non-Motor Vehic)",
      "28:1441wd" : "28:1441wd (28:1441 Petition for Removal- Wrongful Death)",
      "28:1442bc" : "28:1442bc (28:1442 Petition for Removal- Breach of Contract)",
      "28:1442pr" : "28:1442pr (28:1442 Petition for Removal)",
      "28:1443" : "28:1443 (28:1443(1) Rent, Lease & Ejectment)",
      "28:1444" : "28:1444 (28:1444 Petition for Removal- Foreclosure)",
      "28:1446in" : "28:1446in (28:1446 Breach of Contract- Insurance)",
      "28:1446pd" : "28:1446pd (28:1446 Petition for Removal- Property Damage (P.I)",
      "28:1446pi" : "28:1446pi (28:1446 Petition for Removal- Personal Injury)",
      "28:1446pl" : "28:1446pl (28:1446pl Petition for Removal - Product Liability)",
      "28:1446pr" : "28:1446pr (28:1446 Petition for Removal)",
      "28:1452" : "28:1452 (28:1452 R&R re motions to remand (non-core))",
      "28:1651" : "28:1651 (28:1651 Petition for Writ of Coram Nobis)",
      "28:1651hc" : "28:1651hc (28:1651 Petition for Writ of Habeas Corpus)",
      "28:1651mn" : "28:1651mn (28:1651 Petition for Writ of Mandamus)",
      "28:1983" : "28:1983 (28:1983 Civil Rights)",
      "28:2201" : "28:2201 (28:2201 Constitutionality of State Statute(s))",
      "28:2201dj" : "28:2201dj (28:2201 Declaratory Judgement)",
      "28:2201ij" : "28:2201ij (28:2201 Injunction)",
      "28:2201in" : "28:2201in (28:2201 Declaratory Judgement (Insurance))",
      "28:2241" : "28:2241 (28:2241 Petition for Writ of Habeas Corpus (federa)",
      "28:2254" : "28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))",
      "28:2254se" : "28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)",
      "28:2255" : "28:2255 (28:2255 Motion to Vacate / Correct Illegal Sentenc)",
      "28:2271" : "28:2271 (28:2271 Federal Tort Claims Act)",
      "28:2345" : "28:2345 (28:2345 Medicare Recovery)",
      "28:2409" : "28:2409 (28:2409(a) Quiet Title Action)",
      "28:2410" : "28:2410 (28:2410 Quiet Title)",
      "28:2671" : "28:2671 (28:2671 Federal Tort Claims Act)",
      "28:2674" : "28:2674 (28:2674 Federal Tort Claims Act)",
      "28:3001" : "28:3001 (28:3001 Applicability of chapter)",
      "28:7402" : "28:7402 (28:7402 Refund of Taxes)",
      "28:7422" : "28:7422 (28:7422 Appeal from Administrative Decision)",
      "29:0151" : "29:0151 (29:151 Labor: Review of Agency Action)",
      "29:0160" : "29:0160 (29:160(1) National Labor Relations Act)",
      "29:0184" : "29:0184 (29:184 Violation Collection Bargain Agreement)",
      "29:0185ep" : "29:0185ep (29:185 Employee Pension Plan)",
      "29:0185lm" : "29:0185lm (29:185 Labor/Mgt. Relations (Contracts))",
      "29:0201do" : "29:0201do (29:201 Denial of Overtime Compensation)",
      "29:0201fl" : "29:0201fl (29:201 Fair Labor Standards Act)",
      "29:0203" : "29:0203 (29:203 Equal Pay Act)",
      "29:0206" : "29:0206 (29:206 Collect Unpaid Wages)",
      "29:0401" : "29:0401 (29:0401 Labor Management Disclosure Act)",
      "29:0621" : "29:0621 (29:621 Job Discrimination (Age))",
      "29:0623" : "29:0623 (29:623 Job Discrimination (Age))",
      "29:0626" : "29:0626 (29:626 Job Discrimination (Age))",
      "29:0633" : "29:0633 (29:633 Job Discrimination (Age))",
      "29:0651" : "29:0651 (29:651 Occupational Safety/Health)",
      "29:0754" : "29:0754 (29:754 Discrimination)",
      "29:0791" : "29:0791 (29:791 Job Discrimination (Rehabilitation Act))",
      "29:0794" : "29:0794 (29:0794 Job Discrimination (Handicap))",
      "29:1001" : "29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)",
      "29:1002" : "29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)",
      "29:1104" : "29:1104 (29:1104 Recovery of Benefits to Employee)",
      "29:1109" : "29:1109 (29:1109 Breach of Fiduciary Duties)",
      "29:1131" : "29:1131 (29:1131 ERISA - Collection of Delinquent Trust Fun)",
      "29:1132" : "29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)",
      "29:1145" : "29:1145 (29:1145 E.R.I.S.A.)",
      "29:1149" : "29:1149 (29:1149 Recover Pension & Profit Sharing)",
      "29:1337" : "29:1337 (29:1337 E.R.I.S.A.)",
      "29:1362" : "29:1362 (29:1362 ERISA)",
      "29:1381" : "29:1381 (29:1381 E.R.I.S.A.)",
      "29:1401" : "29:1401 (29:1401(b)(2) Appeal of Arbitration Award)",
      "29:1451" : "29:1451 (29:1451 E.R.I.S.A.)",
      "29:1801" : "29:1801 (29:1801 Farmworker Rights)",
      "29:2601" : "29:2601 (29:2601 FMLA: Family and Medical Leave Act (Findings and Purposes))",
      "29:790" : "29:790 (29:790 Rehabilitation of Labor)",
      "30:0181" : "30:0181 (30:181 Environment: Review of Agency Action)",
      "30:0801" : "30:0801 (30:0801 Penalities/Federal Mine Safety Health Act)",
      "30:1201" : "30:1201 (30:1201 Environment: Review of Agency Action)",
      "30:1202" : "30:1202 (30:1202 Mining Reclamation Act)",
      "30:1276" : "30:1276 (30:1276 Interior: Review of Agency Action)",
      "31:3545" : "31:3545 (31:3545 Action to Recovery Money)",
      "31:3729" : "31:3729 (31:3729 False Claims Act)",
      "31:3730" : "31:3730 (31:3730 Qui Tam False Claims Act)",
      "31:3731" : "31:3731 (31:3731 Fraud)",
      "33:1319cw" : "33:1319cw (33:1319 Clean Water Act)",
      "33:1319pv" : "33:1319pv (33:1319 Pollutants & Permit Violations)",
      "33:1365" : "33:1365 (33:1365 Environmental Matters)",
      "35:0145" : "35:0145 (35:145 Patent Infringement)",
      "35:0183" : "35:0183 (35:183 Patent Infringement)",
      "35:0271" : "35:0271 (35:271 Patent Infringement)",
      "38:1681" : "38:1681 (38:1681 Recovery of VA Overpayment)",
      "38:1686" : "38:1686 (38:1686 Recovery of VA Overpayment)",
      "38:1780" : "38:1780 (38:1780 Recovery of VA Overpayment)",
      "38:2011" : "38:2011 (38:2011 - Veteran's Readjustment Assistance Act of)",
      "38:3116" : "38:3116 (38:3116 VA Overpayment)",
      "39:3005" : "39:3005 (39:3005 Detention of Mail for Temporary Periods)",
      "39:409" : "39:409 (39:409 Postal Service)",
      "40:0258" : "40:0258 (40:258(a) Public Buildings & Property: Land Condem)",
      "40:0270" : "40:0270 (40:270 Miller Act)",
      "40:0875" : "40:0875 (40:875 Public Buildings & Property: Negligence)",
      "41:0251" : "41:0251 (41:251 Public Contracts-Review of Agency Action)",
      "41:1463" : "41:1463 (41:1463 Public Contracts: Unlawful Employment Prac)",
      "42:0205" : "42:0205 (42:205 Denial Social Security Benefits)",
      "42:0206" : "42:0206 (42:206 Social Security Benefits)",
      "42:0247" : "42:0247 (42:247 Personal Injury-Swine Flu)",
      "42:0402" : "42:0402 (42:402 Social Security Benefits)",
      "42:0405id" : "42:0405id (42:405 Review of HHS Decision (SSID))",
      "42:0405wc" : "42:0405wc (42:405 Review of HHS Decision (DIWC))",
      "42:0405ww" : "42:0405ww (42:405 Review of HHS Decision (DIWW))",
      "42:0416" : "42:0416 (42:416 Denial of Social Security Benefits)",
      "42:0427" : "42:0427 (42:427 Social Security Benefits)",
      "42:1383" : "42:1383 (42:1383 Review of HHS Decision)",
      "42:1395" : "42:1395 (42:1395 HHS: Adverse Reimbursement Review)",
      "42:1396" : "42:1396 (42:1396 - Tort Negligence)",
      "42:1471" : "42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclo)",
      "42:1981cv" : "42:1981cv (42:1981 Civil Rights)",
      "42:1981hs" : "42:1981hs (42:1981 Housing Discrimination)",
      "42:1981jb" : "42:1981jb (42:1981 Job Discrimination (Race))",
      "42:1981sx" : "42:1981sx (42:1981 Sex Discrimination)",
      "42:1983cv" : "42:1983cv (42:1983 Civil Rights Act)",
      "42:1983ed" : "42:1983ed (42:1983 Civil Rights (Employment Discrimination))",
      "42:1983pr" : "42:1983pr (42:1983 Prisoner Civil Rights)",
      "42:1986" : "42:1986 (42:1986 Neglect of Duty)",
      "42:2000ag" : "42:2000ag (42:2000 Job Discrimination (Age))",
      "42:2000e" : "42:2000e (42:2000e Job Discrimination (Employment))",
      "42:2000pb" : "42:2000pb (42:2000 Job Discrimination (Public Accomodations))",
      "42:2000ra" : "42:2000ra (42:2000 Job Discrimination (Race))",
      "42:2000sx" : "42:2000sx (42:2000 Job Discrimination (Sex))",
      "42:2003" : "42:2003 (42:2003 Job Discrimination)",
      "42:2005" : "42:2005 (42:2005 Review of Agency Action-HHS)",
      "42:2651" : "42:2651 (42:2651 Medical Care Recovery)",
      "42:3601" : "42:3601 (42:405 Fair Housing Act)",
      "42:4000" : "42:4000 (42:4000 National Flood Insurance Act)",
      "42:4001" : "42:4001 (42:4001 National Insurance Flood Act)",
      "42:4053" : "42:4053 (42:4053 Breach of Insurance Contract)",
      "42:4072" : "42:4072 (42:4072 Payment of Flood Insurance Claim)",
      "42:4321" : "42:4321 (42:4321 Review of Agency Action-Environment)",
      "42:4332" : "42:4332 (42:4332 Environmental Policy - Coop of Agency Repo)",
      "42:6901en" : "42:6901en (42:6901 Environmental Cleanup Expenses)",
      "42:6901rs" : "42:6901rs (42:6901 Resource & Recovery Act)",
      "42:7413" : "42:7413 (42:7413(b) Clean Air Act)",
      "42:7604cl" : "42:7604cl (42:7604 Clear Air Act (Emission Standards))",
      "42:7604ir" : "42:7604ir (42:7604 Petition to Quash IRS Summons)",
      "42:9607" : "42:9607 (42:9607 Real Property Tort to Land)",
      "43:945" : "43:945 (43:945 Compensation for Land Condemnation)",
      "43:945a" : "43:945a (43:945a Complaint in Condemnation)",
      "43:946" : "43:946 (43:946 Complaint in Condemnation - Eminent Domain)",
      "45:0051" : "45:0051 (45:51 Railways: Fed. Employer's Liability Act)",
      "45:0151" : "45:0151 (45:151 Railway Labor Act)",
      "45:0184" : "45:0184 (45:184 Action to Set Aside Award of a System Board)",
      "45:1395" : "45:1395 (45:1395 Railroads: Adverse Reimbursement Review)",
      "45:7457" : "45:7457 (45:7457 Compel Reclamation Under Clear Air Act)",
      "46:0688" : "46:0688 (46:688 Jones Act)",
      "46:0741" : "46:0741 (46:741 Shipping)",
      "46:0761" : "46:0761 (46:761 Shipping: Damages for Death on High Seas)",
      "46:1101" : "46:1101 (46:1101 Violation of Maritime Regulations)",
      "46:1156" : "46:1156 (46:1156 Administrative Procedure Act)",
      "48:0883" : "48:0883 (48:883 Violation of US Coastal Law)",
      "48:1985" : "48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)",
      "49:0081" : "49:0081 (49:81 Damaged Goods While Being Transported)",
      "49:0781" : "49:0781 (49:781 Forfeiture)",
      "49:11503" : "49:11503 (49:11503 Railroad Revitalization Regulatory Reform)",
      "49:11702" : "49:11702 (49:11702(a)(4) Violations of Interstate Commerce A)",
      "49:1471" : "49:1471 (49:1471 Federal Aviation Act)",
      "49:1903" : "49:1903 (49:1903 Petition to enforce administrative summon)",
      "8:287" : "8:287 (8:287 Petition to Enforce INS Subpoena)",
      "misc" : "misc (Civil Miscellaneous Case)"
   },
   "inndce" : {
      "0" : "0 (00:0000)",
      "00:0000" : "00:0000 (00:0000 Cause Code Unknown)",
      "02:0431" : "02:0431 (02:431 Fed. Election Commission: Failure Enforce C)",
      "02:0437" : "02:0437 (02:437 Federal Election Commission)",
      "05:0075" : "05:0075 (05:75(2) Contract - Reduction in Grade)",
      "05:0551" : "05:0551 (05:551 Administrative Procedure Act)",
      "05:0552fi" : "05:0552fi (05:552 Freedom of Information Act)",
      "05:0552pa" : "05:0552pa (05:552 Right to Privacy Act)",
      "05:0554" : "05:0554 (05:0554 Constitutionality of Maritime Statutes)",
      "05:0701" : "05:0701 (05:0701 Maritime Subsidy Board)",
      "05:0702" : "05:0702 (05:702 Administrative Procedure Act)",
      "05:0704" : "05:0704 (05:704 Labor Litigation)",
      "05:7703" : "05:7703 (05:7703 Discrimination - Review of Agency Act)",
      "07:0006" : "07:0006 (7:6(b) Federal Commodity Exchange Regulation)",
      "07:0025" : "07:0025 (7:25 Fraud - Commodities Leverage Contracts)",
      "07:0181" : "07:0181 (07:181 Packers & Stockyard Act)",
      "07:0499" : "07:0499 (07:499 Agricultural Commodities Act)",
      "07:0601" : "07:0601 (07:601 USDA Condemnation)",
      "07:151" : "07:151 (07:151 The Tax Freedom Act)",
      "07:2321" : "07:2321 (07:2321 Plant Variety Protection Act)",
      "08:1105" : "08:1105 (8:1105(a) Aliens: Habeas Corpus to Release INS Det)",
      "08:1183" : "08:1183 (8:1183 Immigration and Nationality Act)",
      "08:1252" : "08:1252 (08:1252(a)(2) Injunction for Deportation)",
      "08:1260" : "08:1260 (08:1260 Aliens: Access to Records)",
      "08:1324" : "08:1324 (08:1324 Aliens: Complaint for Forfeiture)",
      "08:1329" : "08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petiti)",
      "08:1446" : "08:1446 (8:1446 Petition for Naturalization Hearing)",
      "08:1503" : "08:1503 (8:1503 - Unlawful denial of U.S. Passport)",
      "09:0001" : "09:0001 (09:1 U.S. Arbitration Act)",
      "09:0009" : "09:0009 (9:9 Motion to Confirm Arbitration Loan)",
      "09:0010" : "09:0010 (09:0010 Petition to Vacate Arbitration Award)",
      "10:1552" : "10:1552 (10:1552 Armed Forces: Action to Correct Records)",
      "10:1553" : "10:1553 (10:1553 Armed Forces: FOIA General)",
      "10:2305" : "10:2305 (10:2305 Review of Federal Contract)",
      "11:0101" : "11:0101 (11:101 Bankruptcy)",
      "12:0022" : "12:0022 (12:22 Securities Fraud)",
      "12:0635" : "12:0635 (12:635 Breach of Insurance Contract)",
      "12:1461" : "12:1461 (12:1461 Homeowners Loan Act)",
      "12:1703" : "12:1703 (12:1703 Default of HUD Loan)",
      "12:1725" : "12:1725 (12:1725 Collection under Contract Guaranty)",
      "12:1730" : "12:1730 (12:1730 Collection Under Contract Guaranty)",
      "12:1790" : "12:1790 (12:1790 Federal Credit Union Act)",
      "12:1819" : "12:1819 (12:1819 Default of Promissory Note)",
      "12:1821" : "12:1821 (12:1821 Default of Loan by Promissary Note)",
      "12:1971" : "12:1971 (12:1971 Relief under Bank Holding Act)",
      "12:2605" : "12:2605 (12:2605 Lender Refusal to Acct for Mortgage Loan Receipts)",
      "12:3410" : "12:3410 (12:3410 Right to Financial Privacy Act)",
      "12:5001-5018" : "12:5001-5018 (12:5001-5018 Check Clearing for the 21st Century Act)",
      "15:0001" : "15:0001 (15:1 Antitrust Litigation)",
      "15:0002at" : "15:0002at (15:2 Antitrust Litigation)",
      "15:0002fl" : "15:0002fl (15:2(a) Fair Labor Standards Act)",
      "15:0005" : "15:0005 (15:5(a) Fair Labor Standards Act)",
      "15:0015" : "15:0015 (15:15 Antitrust Litigation)",
      "15:0025" : "15:0025 (15:25 Clayton Act)",
      "15:0044" : "15:0044 (15:44 Trademark Infringement)",
      "15:0045" : "15:0045 (15:0045 Federal Trade Commission Act)",
      "15:0052" : "15:0052 (15:0052 Federal Trade Commission Act)",
      "15:0053" : "15:0053 (15:0053 Federal Trade Commission Act)",
      "15:0077" : "15:0077 (15:77 Securities Fraud)",
      "15:0078" : "15:0078 (15:78m(a) Securities Exchange Act)",
      "15:0631" : "15:0631 (15:631 Small Business Act)",
      "15:0717" : "15:0717 (15:717 Natural Gas Act)",
      "15:1051" : "15:1051 (15:1051 Trademark Infringement)",
      "15:1071" : "15:1071 (15:1071 Trademark Infringement)",
      "15:1114" : "15:1114 (15:1114 Trademark Infringement)",
      "15:1121" : "15:1121 (15:1121 Trademark Infringement)",
      "15:1125" : "15:1125 (15:1125 Trademark Infringement (Lanham Act))",
      "15:1126" : "15:1126 (15:1126 Patent Infringement)",
      "15:1127" : "15:1127 (15:1127 Trademark Infringement)",
      "15:1601" : "15:1601 (15:1601 Truth in Lending)",
      "15:1635" : "15:1635 (15:1635 Truth in Lending)",
      "15:1640" : "15:1640 (15:1640 Truth in Lending)",
      "15:1681" : "15:1681 (15:1681 Fair Credit Reporting Act)",
      "15:1691" : "15:1691 (15:1691 Equal Credit Opportunity Act)",
      "15:1692" : "15:1692 (15:1692 Fair Debt Collection Act)",
      "15:1693" : "15:1693 (15:1693 Electronic Funds Transfer Act)",
      "15:1938" : "15:1938 (15:1938 Fair Labor Standards Act)",
      "15:1981" : "15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))",
      "15:1988" : "15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))",
      "15:1989" : "15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))",
      "15:2301" : "15:2301 (15:2301 Magnuson-Moss Warranty Act)",
      "15:2801" : "15:2801 (15:2801 Petroleum Marketing Practices Act)",
      "15:53(b)" : "15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equita)",
      "16:0668" : "16:0668 (16:668 Bald Eagle Protection Act)",
      "16:0703" : "16:0703 (16:703 Migratory Bird Act)",
      "16:1538" : "16:1538 (16:1538 Endangered Species Act)",
      "16:3371" : "16:3371 (16:3371 Wildlife Under the Lacey Act)",
      "16:3372" : "16:3372 (16:3372 Conservation: Complaint for Forfeiture)",
      "16:3373" : "16:3373 (16:3373 Appeal of Decision - DOI)",
      "16:3374" : "16:3374 (16:3374 Conservation: Complaint for Forfeiture)",
      "17:0101" : "17:0101 (17:101 Copyright Infringement)",
      "17:0501" : "17:0501 (17:501 Copyright Infringement)",
      "17:0504" : "17:0504 (17:504 Copyright Infringement)",
      "17:1203" : "17:1203 (17:1203 Digital Millenium Copyright Act)",
      "18:0241" : "18:0241 (18:241 Conspiracy Against Citizen Rights)",
      "18:1030" : "18:1030 (Computer Fraud and Abuse Act)",
      "18:1514" : "18:1514 (18:1514 Action to Restrain Harrassment of Victim or Witness)",
      "18:1835" : "18:1835 (18:1835 Orders to Preserve Confidentiality)",
      "18:1836" : "18:1836 (18:1836 Civil Proceedings to Enjoin Violations)",
      "18:1836a" : "18:1836a (18:1836(a) Injunction against Misappropriation of Trade Secrets)",
      "18:1836b" : "18:1836b (18:1836(b) Civil Action to Protect Trade Secrets)",
      "18:1961" : "18:1961 (18:1961 Racketeering (RICO) Act)",
      "18:1962" : "18:1962 (18:1962 Racketeering (RICO) Act)",
      "18:1964" : "18:1964 (18:1964 Racketeering (RICO) Act)",
      "18:2254" : "18:2254 (18:2254 Forfeiture - Pornography)",
      "18:2381" : "18:2381 (18:2381 Treason)",
      "18:2510" : "18:2510 (18:2510 Federal Wire Tap Act)",
      "18:2520" : "18:2520 (18:2520 Unlawful Interception of Wire Communication)",
      "18:2721" : "18:2721 (18:2721 Unlawful release of personal information from State motor vehicle records)",
      "18:4208" : "18:4208 (18:4208(B) Agency Action Review)",
      "19:1305" : "19:1305 (19:1305 Custom Duties:0Forfeiture-Immoral Articles)",
      "20:1071" : "20:1071 (20:1071 Alledged student loan default)",
      "20:1080" : "20:1080 (20:1080 Student Loan Recovery)",
      "20:1400" : "20:1400 (20:1400 Civil Rights of Handicapped Child)",
      "20:1401" : "20:1401 (20:1401 Education: Handicapped Child Act)",
      "20:1415" : "20:1415 (20:1415 Individuals With Disabilities Education Act)",
      "20:1681" : "20:1681 (20:1681(a) Title IX Sex Discrimination in Education)",
      "21:0332" : "21:0332 (21:332 Federal Food Drug and Cosmetic Act)",
      "21:0399d" : "21:0399d (21:399d Employee Protections)",
      "21:0601" : "21:0601 (21:601 Federal Meat Inspection Act)",
      "21:0841" : "21:0841 (21:841 Forfeiture Property-Drugs)",
      "21:0853" : "21:0853 (21:853Forfeiture Property - Firearms)",
      "21:0881" : "21:0881 (21:881 Forfeiture Property-Drugs)",
      "21:0881a" : "21:0881a (21:881 Forfeiture Property - Aircraft)",
      "21:0881cc" : "21:0881cc (21:881 Forfeiture Property - Credit Card Fraud)",
      "21:0881re" : "21:0881re (21:881 Forfeiture Property - Real Estate)",
      "21:1441ag" : "21:1441ag (Petition for Removal - Agricultural Commodities Act)",
      "21:853a" : "21:853a (21:853 Forfeiture of Property - Automobiles)",
      "23:0134" : "23:0134 (23:134 P.I.- Auto Negligence)",
      "23:1441" : "23:1441 (23:1441 Contract Real Estate)",
      "24:1000" : "24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)",
      "25:0640" : "25:0640 (25:640 Indian Tribal Rights)",
      "25:1901" : "25:1901 (25:1901 Indian Child Welfare Act)",
      "26:6212" : "26:6212 (26:6212 Injunctive Relief from IRS Lien)",
      "26:6213" : "26:6213 (26:6213 Injunctive Relief from IRS Lien)",
      "26:6330" : "26:6330 (26:6330 Review of Tax Levy)",
      "26:6502" : "26:6502 (26:6502 IRS:Enforcement of tax liens)",
      "26:6532" : "26:6532 (26:6532 IRS: Refund of Tax Penalty)",
      "26:6702" : "26:6702 (26:6702 IRS: Refund of Income Tax Penalty)",
      "26:6703" : "26:6703 (26:6703 IRS: Refund of Tax Penalty)",
      "26:7401" : "26:7401 (26:7401 IRS: Tax Liability)",
      "26:7402" : "26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)",
      "26:7403" : "26:7403 (26:7403 Suit to Enforce Federal Tax Lien)",
      "26:7422rt" : "26:7422rt (26:7422 IRS: Refund Taxes)",
      "26:7422rx" : "26:7422rx (26:7422 IRS: Refund Excise Tax)",
      "26:7426" : "26:7426 (26:7426 IRS: Wrongful Levy for Taxes)",
      "26:7429" : "26:7429 (26:7429 IRS: Tax Jeopardy Assessment)",
      "26:7609" : "26:7609 (26:7609 IRS: Petition to Quash IRS Summons)",
      "26:9701" : "26:9701 (Coal Industry Retiree Health Benefit Act of 1992 (Coal Act))",
      "27:0185" : "27:0185 (27:185 Enforcement of Arbitration Award)",
      "28:0157c" : "28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)",
      "28:0157d" : "28:0157d (28:0157 Motion for Withdrawal of Reference)",
      "28:0158" : "28:0158 (28:0158 Notice of Appeal re Bankruptcy Matter (BA)",
      "28:0185" : "28:0185 (28:185 Suit to Compel Arbitration)",
      "28:0187" : "28:0187 (Unfair labor practices - Damages from actions of labor org)",
      "28:0451" : "28:0451 (28:451 Employment Discrimination)",
      "28:0636" : "28:0636 (28:636 Appeal to District Court from Magistrate Judgment)",
      "28:0754" : "28:0754 (28:754 Receiver of Property in Different Districts)",
      "28:0794" : "28:0794 (28:794 Rehabilitation Act)",
      "28:1001" : "28:1001 (28:1001 E.R.I.S.A.)",
      "28:1132" : "28:1132 (28:1132 E.R.I.S.A.)",
      "28:1330" : "28:1330 (28:1330 Breach of Contract)",
      "28:1331" : "28:1331 (28:1331 Fed. Question)",
      "28:1331al" : "28:1331al (28:1331 Fed. Question: Airline Crash)",
      "28:1331at" : "28:1331at (28:1331 Fed. Question: Anti-trust)",
      "28:1331au" : "28:1331au (28:1331 Fed. Question: Auto Negligence)",
      "28:1331b" : "28:1331b (28:1331 Federal Question: Bivens Act)",
      "28:1331bc" : "28:1331bc (28:1331 Fed. Question: Breach of Contract)",
      "28:1331ca" : "28:1331ca (28:1331 Fed Question: Fed Communications Act of 1)",
      "28:1331cm" : "28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)",
      "28:1331cv" : "28:1331cv (28:1331 Federal Question: Other Civil Rights)",
      "28:1331ed" : "28:1331ed (28:1331 Fed. Question: Employment Discrimination)",
      "28:1331es" : "28:1331es (28:1331 Enforcement of Administrative Subpoena)",
      "28:1331fl" : "28:1331fl (28:1331 Fed. Question: Fair Labor Standards)",
      "28:1331in" : "28:1331in (28:1331 Fed. Question: Insurance Contract)",
      "28:1331mm" : "28:1331mm (28:1331 Fed. Question: Medical Malpractice)",
      "28:1331pi" : "28:1331pi (28:1331 Fed. Question: Personal Injury)",
      "28:1331rd" : "28:1331rd (28:1331 Fed. Question: Review Agency Decision)",
      "28:1331rp" : "28:1331rp (28:1331(a) Fed. Question: Real Property)",
      "28:1331rr" : "28:1331rr (28:1331 Fed. Question: Railway Labor Act)",
      "28:1331sv" : "28:1331sv (28:1331 Fed. Question: Securities Violation)",
      "28:1331ta" : "28:1331ta (28:1331 Telecommunications Act of 1996)",
      "28:1331tr" : "28:1331tr (28:1331 Fed. Question: Trademark)",
      "28:1331tt" : "28:1331tt (28:1331 Fed. Question: Tort Action)",
      "28:1331v" : "28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendme)",
      "28:1331wl" : "28:1331wl (28:1331 Federal Question: EPA Waste Lien)",
      "28:1331wt" : "28:1331wt (28:1331 Fed. Question: Water Rights)",
      "28:1332ac" : "28:1332ac (28:1332 Diversity-Account Receivable)",
      "28:1332al" : "28:1332al (28:1332 Diversity-Airline Crash)",
      "28:1332as" : "28:1332as (28:1332 Diversity-Asbestos Litigation)",
      "28:1332au" : "28:1332au (28:1332 Diversity-Auto Negligence)",
      "28:1332bc" : "28:1332bc (28:1332 Diversity-Breach of Contract)",
      "28:1332co" : "28:1332co (28:1332 Diversity-Conversion)",
      "28:1332ct" : "28:1332ct (28:1332 Diversity-(Citizenship))",
      "28:1332det" : "28:1332det (28:1332 Diversity: Forcible Detainer)",
      "28:1332df" : "28:1332df (28:1332 Diversity-Contract Default)",
      "28:1332ds" : "28:1332ds (28:1332 Diversity-Contract Dispute)",
      "28:1332ed" : "28:1332ed (28:1332 Diversity-Employment Discrimination)",
      "28:1332fd" : "28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)",
      "28:1332fr" : "28:1332fr (28:1332 Diversity-Fraud)",
      "28:1332ia" : "28:1332ia (28:1332 Diversity-Interpleader Action)",
      "28:1332ij" : "28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)",
      "28:1332in" : "28:1332in (28:1332 Diversity-Insurance Contract)",
      "28:1332jd" : "28:1332jd (28:1332 Diversity-Declaratory Judgment)",
      "28:1332lb" : "28:1332lb (28:1332 Diversity-Libel,Assault,Slander)",
      "28:1332lm" : "28:1332lm (28:1332 Diversity - Legal Malpractice)",
      "28:1332ma" : "28:1332ma (28:1332 Diversity-Miller Act)",
      "28:1332mm" : "28:1332mm (28:1332 Diversity-Medical Malpractice)",
      "28:1332mv" : "28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)",
      "28:1332ni" : "28:1332ni (28:1332 Diversity-Negotiable Instrument)",
      "28:1332nm" : "28:1332nm (28:1332 Diversity-Non-Motor Vehicle)",
      "28:1332oc" : "28:1332oc (28:1332 Diversity-Other Contract)",
      "28:1332pd" : "28:1332pd (28:1332 Diversity-Property Damage)",
      "28:1332pi" : "28:1332pi (28:1332 Diversity-Personal Injury)",
      "28:1332pl" : "28:1332pl (28:1332 Diversity-Product Liability)",
      "28:1332pr" : "28:1332pr (28:1332 Diversity-Petition for Removal)",
      "28:1332qt" : "28:1332qt (28:1332 Diversity-Petition to Quiet Title)",
      "28:1332ri" : "28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)",
      "28:1332sa" : "28:1332sa (28:1332 - Diversity: Securities & Exchange Commiss)",
      "28:1332sf" : "28:1332sf (28:1332 - Diversity: Securities Fraud)",
      "28:1332ss" : "28:1332ss (28:1332 Diversity - Stockholders Suits)",
      "28:1332tl" : "28:1332tl (28:1332 Diversity-Torts to Land)",
      "28:1332tm" : "28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))",
      "28:1332tn" : "28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)",
      "28:1332wd" : "28:1332wd (28:1332 Diversity-Wrongful Death)",
      "28:1333" : "28:1333 (28:1333 Admiralty)",
      "28:1334" : "28:1334 (28:1334 Bankruptcy Appeal)",
      "28:1334c" : "28:1334c (28:1334(c) R&R re motions for abstention (non-cor)",
      "28:1335" : "28:1335 (28:1335 Interpleader Action)",
      "28:1337" : "28:1337 (28:1337 Sherman-Clayton Act)",
      "28:1338cp" : "28:1338cp (28:1338 Copyright Infringement)",
      "28:1338pt" : "28:1338pt (28:1338 Patent Infringement)",
      "28:1338tr" : "28:1338tr (28:1338 Trademark Infringement)",
      "28:1340" : "28:1340 (28:1340 IRS: Custom Duties)",
      "28:1340er" : "28:1340er (28:1340 Recovery of Erroneous Refund)",
      "28:1341" : "28:1341 (28:1341 Complaint for Forfeiture)",
      "28:1343" : "28:1343 (28:1343 Violation of Civil Rights)",
      "28:1345co" : "28:1345co (28:1345 Replevin & Conversion)",
      "28:1345db" : "28:1345db (28:1345 Debt to US - FHA/HUD Title I)",
      "28:1345df" : "28:1345df (28:1345 Default of Promissory Note)",
      "28:1345er" : "28:1345er (28:1345 Recovery of Erroneous Refund)",
      "28:1345fc" : "28:1345fc (28:1345 Foreclosure)",
      "28:1345ff" : "28:1345ff (28:1345 Complaint for Forfeiture)",
      "28:1345hl" : "28:1345hl (28:1345 VA Home Loan Guaranty Debt)",
      "28:1345mc" : "28:1345mc (28:1345 Medical Care Recovery)",
      "28:1345mi" : "28:1345mi (28:1345 Mining Claim Ejectment)",
      "28:1345pd" : "28:1345pd (28:1345 Property Damage)",
      "28:1345pe" : "28:1345pe (28:1345 Property Ejectment)",
      "28:1345rc" : "28:1345rc (28:1345 Recovery of Debt to US)",
      "28:1345st" : "28:1345st (28:1345 Default of Student Loan)",
      "28:1345tp" : "28:1345tp (28:1345 Trespass on Public Land)",
      "28:1345va" : "28:1345va (28:1345 Recovery of VA Overpayment)",
      "28:1346bc" : "28:1346bc (28:1346 Breach of Contract)",
      "28:1346rc" : "28:1346rc (28:1346 Recovery of IRS Tax)",
      "28:1346tc" : "28:1346tc (28:1346 Tort Claim)",
      "28:1346wd" : "28:1346wd (28:1346 Wrongful Death)",
      "28:1352" : "28:1352 (28:1352 Miller Act)",
      "28:1355" : "28:1355 (28:1355 Petition for Return of Property)",
      "28:1356" : "28:1356 (28:1356 Seizures not with Admiralty and Maritime jursdicatio)",
      "28:1358" : "28:1358 (28:1358 Land Condemnation)",
      "28:1361" : "28:1361 (28:1361 Petition for Writ of Mandamus)",
      "28:1362ic" : "28:1362ic (28:1362 Indian Tribal Controversy)",
      "28:1362iw" : "28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)",
      "28:1364" : "28:1364 (28:1364 Auto Negligence)",
      "28:1391" : "28:1391 (28:1391 Personal Injury)",
      "28:1402" : "28:1402 (28:1402 Medical Malpractice)",
      "28:1407" : "28:1407 (28:1407 Airline Crash)",
      "28:1441ac" : "28:1441ac (28:1441 Petition for Removal- Account Receivable)",
      "28:1441al" : "28:1441al (28:1441 Petition for Removal- Airline Crash)",
      "28:1441as" : "28:1441as (28:1441 Petition for Removal- Asbestos Litigation)",
      "28:1441au" : "28:1441au (28:1441 Petition for Removal- Auto Negligence)",
      "28:1441bc" : "28:1441bc (28:1441 Petition for Removal- Breach of Contract)",
      "28:1441cv" : "28:1441cv (28:1441 Petition for Removal- Civil Rights Act)",
      "28:1441df" : "28:1441df (28:1441 Petition for Removal- Contract Default)",
      "28:1441dj" : "28:1441dj (28:1441 Petition for Removal- Declaratory Judgment)",
      "28:1441ds" : "28:1441ds (28:1441 Petition for Removal- Contract Dispute)",
      "28:1441ed" : "28:1441ed (28:1441 Petition for Removal - Employment Discrim)",
      "28:1441er" : "28:1441er (28:1441 Petition for Removal-ERISA)",
      "28:1441fc" : "28:1441fc (28:1441 Petition for Removal - Fair Credit Reporting)",
      "28:1441fml" : "28:1441fml (28:1441fml Petition for Removal - Family and Medical Leave Act)",
      "28:1441fr" : "28:1441fr (28:1441 Petition for Removal- Fraud)",
      "28:1441fw" : "28:1441fw (28:1441 Petition for Removal - Federal Wire Tap Act)",
      "28:1441ij" : "28:1441ij (28:1441 Petition for Removal- Injunctive/Declarato)",
      "28:1441in" : "28:1441in (28:1441 Petition for Removal- Insurance Contract)",
      "28:1441int" : "28:1441int (28:1441 Petition for Removal- Action for Interplea)",
      "28:1441lb" : "28:1441lb (28:1441 Petition for Removal Libel,Assault,Slander)",
      "28:1441lm" : "28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relatio)",
      "28:1441mm" : "28:1441mm (28:1441 Petition for Removal- Medical Malpractice)",
      "28:1441ni" : "28:1441ni (28:1441 Petition for Removal- Negotiable Instrumen)",
      "28:1441nm" : "28:1441nm (28:1441 Petition for Removal- Non-Motor Vehicle)",
      "28:1441oc" : "28:1441oc (28:1441 Petition For Removal--Other Contract)",
      "28:1441pd" : "28:1441pd (28:1441 Petition for Removal- Property Damage)",
      "28:1441pi" : "28:1441pi (28:1441 Petition for Removal- Personal Injury)",
      "28:1441pl" : "28:1441pl (28:1441 Petition for Removal- Product Liability)",
      "28:1441pr" : "28:1441pr (28:1441 Petition for Removal)",
      "28:1441qt" : "28:1441qt (28:1441 Petition for Removal- Petition to Quiet Ti)",
      "28:1441ri" : "28:1441ri (28:1441 Petition for Removal- Racketeering (RICO))",
      "28:1441sa" : "28:1441sa (28:1441 - Petition for Removal: SEC Act)",
      "28:1441sf" : "28:1441sf (28:1441 - Petition for Removal: Securities Fraud)",
      "28:1441ti" : "28:1441ti (28:1441 Petn for Removal: Trademark Infringement-Lanham Act)",
      "28:1441tl" : "28:1441tl (28:1441 Petition for Removal- Torts to Land)",
      "28:1441tm" : "28:1441tm (28:1441 Petition for Removal- Tort/Motor Vehicle ()",
      "28:1441tn" : "28:1441tn (28:1441 Petition for Removal- Tort/Non-Motor Vehic)",
      "28:1441wd" : "28:1441wd (28:1441 Petition for Removal- Wrongful Death)",
      "28:1442bc" : "28:1442bc (28:1442 Petition for Removal- Breach of Contract)",
      "28:1442pr" : "28:1442pr (28:1442 Petition for Removal)",
      "28:1443" : "28:1443 (28:1443(1) Rent, Lease & Ejectment)",
      "28:1444" : "28:1444 (28:1444 Petition for Removal- Foreclosure)",
      "28:1446in" : "28:1446in (28:1446 Breach of Contract- Insurance)",
      "28:1446pd" : "28:1446pd (28:1446 Petition for Removal- Property Damage (P.I)",
      "28:1446pi" : "28:1446pi (28:1446 Petition for Removal- Personal Injury)",
      "28:1446pl" : "28:1446pl (28:1446pl Petition for Removal - Product Liability)",
      "28:1446pr" : "28:1446pr (28:1446 Petition for Removal)",
      "28:1452" : "28:1452 (28:1452 R&R re motions to remand (non-core))",
      "28:1651" : "28:1651 (28:1651 Petition for Writ of Coram Nobis)",
      "28:1651hc" : "28:1651hc (28:1651 Petition for Writ of Habeas Corpus)",
      "28:1651mn" : "28:1651mn (28:1651 Petition for Writ of Mandamus)",
      "28:1782" : "28:1782 (28:1782 International Litigant Assistance)",
      "28:1983" : "28:1983 (28:1983 Civil Rights)",
      "28:2201" : "28:2201 (28:2201 Constitutionality of State Statute(s))",
      "28:2201dj" : "28:2201dj (28:2201 Declaratory Judgment)",
      "28:2201ij" : "28:2201ij (28:2201 Injunction)",
      "28:2201in" : "28:2201in (28:2201 Declaratory Judgment (Insurance))",
      "28:2241" : "28:2241 (28:2241 Petition for Writ of Habeas Corpus (federa)",
      "28:2241cab" : "28:2241cab (28:2241 Habeas Disciplinary (Good Time) Action)",
      "28:2254" : "28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))",
      "28:2254se" : "28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)",
      "28:2255" : "28:2255 (28:2255 Motion to Vacate / Correct Illegal Sentenc)",
      "28:2271" : "28:2271 (28:2271 Federal Tort Claims Act)",
      "28:2345" : "28:2345 (28:2345 Medicare Recovery)",
      "28:2401" : "28:2401 (28:2401(b) Final Denial of Administrative Claim)",
      "28:2409" : "28:2409 (28:2409(a) Quiet Title Action)",
      "28:2410" : "28:2410 (28:2410 Quiet Title)",
      "28:2461" : "28:2461 (28:2461 Recovery Funds or Property)",
      "28:2671" : "28:2671 (28:2671 Federal Tort Claims Act)",
      "28:2674" : "28:2674 (28:2674 Federal Tort Claims Act)",
      "28:2675" : "28:2675 (28:2675 Disposition By Federal Agency As Pre-Requisite; Evidence)",
      "28:2679" : "28:2679 (28:2679 Petition for Certification of Scope of Employment)",
      "28:3001" : "28:3001 (Federal Debt Collection Procedure Act)",
      "28:7402" : "28:7402 (28:7402 Refund of Taxes)",
      "28:7422" : "28:7422 (28:7422 Appeal from Administrative Decision)",
      "29:0151" : "29:0151 (29:151 Labor: Review of Agency Action)",
      "29:0160" : "29:0160 (29:160(1) National Labor Relations Act)",
      "29:0184" : "29:0184 (29:184 Violation Collection Bargain Agreement)",
      "29:0185ep" : "29:0185ep (29:185 Employee Pension Plan)",
      "29:0185lm" : "29:0185lm (29:185 Labor/Mgt. Relations (Contracts))",
      "29:0201do" : "29:0201do (29:201 Denial of Overtime Compensation)",
      "29:0201fl" : "29:0201fl (29:201 Fair Labor Standards Act)",
      "29:0203" : "29:0203 (29:203 Equal Pay Act)",
      "29:0206" : "29:0206 (29:206 Collect Unpaid Wages)",
      "29:0401" : "29:0401 (29:0401 Labor Management Disclosure Act)",
      "29:0510" : "29:0510 (29:510 E.R.I.S.A.)",
      "29:0621" : "29:0621 (29:621 Job Discrimination (Age))",
      "29:0623" : "29:0623 (29:623 Job Discrimination (Age))",
      "29:0626" : "29:0626 (29:626 Job Discrimination (Age))",
      "29:0631" : "29:0631 (29:0631(a) Age Discrimination in Employment Act of 1967)",
      "29:0633" : "29:0633 (29:633 Job Discrimination (Age))",
      "29:0651" : "29:0651 (29:651 Occupational Safety/Health)",
      "29:0754" : "29:0754 (29:754 Discrimination)",
      "29:0791" : "29:0791 (29:791 Job Discrimination (Rehabilitation Act))",
      "29:0794" : "29:0794 (29:0794 Job Discrimination (Handicap))",
      "29:1001" : "29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)",
      "29:1002" : "29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)",
      "29:1104" : "29:1104 (29:1104 Recovery of Benefits to Employee)",
      "29:1109" : "29:1109 (29:1109 Breach of Fiduciary Duties)",
      "29:1131" : "29:1131 (29:1131 ERISA - Collection of Delinquent Trust Fun)",
      "29:1132" : "29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)",
      "29:1145" : "29:1145 (29:1145 E.R.I.S.A.)",
      "29:1149" : "29:1149 (29:1149 Recover Pension & Profit Sharing)",
      "29:1337" : "29:1337 (29:1337 E.R.I.S.A.)",
      "29:1362" : "29:1362 (29:1362 ERISA)",
      "29:1381" : "29:1381 (29:1381 E.R.I.S.A.)",
      "29:1401" : "29:1401 (29:1401(b)(2) Appeal of Arbitration Award)",
      "29:1451" : "29:1451 (29:1451 E.R.I.S.A.)",
      "29:1501" : "29:1501 (Job Training Partnership Act)",
      "29:1801" : "29:1801 (29:1801 Farmworker Rights)",
      "29:1854" : "29:1854 (29:1854 Migrant and Seasonal Agric. Workers Proctection Act)",
      "29:2101" : "29:2101 (29:2101 WARN Act: Worker Adjustment and Retraining Notification Act)",
      "29:2601" : "29:2601 (29:2601 Family and Medical Leave Act)",
      "29:2615" : "29:2615 (29:2615 Family Medical Leave Act (FMLA))",
      "29:2617" : "29:2617 (29:2617 Family Medical Leave Act (FMLA))",
      "29:481-84" : "29:481-84 (29:481-84 Title IV Labor-Management Reporting and Disclosure Act of 1959)",
      "29:790" : "29:790 (29:790 Rehabilitation of Labor)",
      "30:0181" : "30:0181 (30:181 Environment: Review of Agency Action)",
      "30:0801" : "30:0801 (30:0801 Penalities/Federal Mine Safety Health Act)",
      "30:1201" : "30:1201 (30:1201 Environment: Review of Agency Action)",
      "30:1202" : "30:1202 (30:1202 Mining Reclamation Act)",
      "30:1276" : "30:1276 (30:1276 Interior: Review of Agency Action)",
      "31:3545" : "31:3545 (31:3545 Action to Recovery Money)",
      "31:3729" : "31:3729 (31:3729 False Claims Act)",
      "31:3730" : "31:3730 (31:3730 Qui Tam False Claims Act)",
      "31:3731" : "31:3731 (31:3731 Fraud)",
      "31:5317" : "31:5317 (31:5317 Asset Forfeiture)",
      "33:1319cw" : "33:1319cw (33:1319 Clean Water Act)",
      "33:1319pv" : "33:1319pv (33:1319 Pollutants & Permit Violations)",
      "33:1365" : "33:1365 (33:1365 Environmental Matters)",
      "35:0041" : "35:0041 (35:41 Patent Infringement)",
      "35:0145" : "35:0145 (35:145 Patent Infringement)",
      "35:0183" : "35:0183 (35:183 Patent Infringement)",
      "35:0271" : "35:0271 (35:271 Patent Infringement)",
      "38:1681" : "38:1681 (38:1681 Recovery of VA Overpayment)",
      "38:1686" : "38:1686 (38:1686 Recovery of VA Overpayment)",
      "38:1780" : "38:1780 (38:1780 Recovery of VA Overpayment)",
      "38:2011" : "38:2011 (38:2011 - Veteran's Readjustment Assistance Act of)",
      "38:3116" : "38:3116 (38:3116 VA Overpayment)",
      "38:4301" : "38:4301 (Uniformed Services Employment and Reemployment Act of 1994)",
      "38:4311" : "38:4311 (Wrongful Termination for Membership in US Military Service)",
      "39:3005" : "39:3005 (39:3005 Detention of Mail for Temporary Periods)",
      "39:409" : "39:409 (39:409 Postal Service)",
      "40:0258" : "40:0258 (40:258(a) Public Buildings & Property: Land Condem)",
      "40:0270" : "40:0270 (40:270 Miller Act)",
      "40:0875" : "40:0875 (40:875 Public Buildings & Property: Negligence)",
      "40:276" : "40:276 (40:0276 Failure to pay prevailing wages in contracts with USA)",
      "40:3133" : "40:3133 (40:3133 Rights of persons furnishing labor or material)",
      "41:0251" : "41:0251 (41:251 Public Contracts-Review of Agency Action)",
      "41:1463" : "41:1463 (41:1463 Public Contracts: Unlawful Employment Prac)",
      "42:0205" : "42:0205 (42:205 Denial Social Security Benefits)",
      "42:0206" : "42:0206 (42:206 Social Security Benefits)",
      "42:0247" : "42:0247 (42:247 Personal Injury-Swine Flu)",
      "42:0402" : "42:0402 (42:402 Social Security Benefits)",
      "42:0405id" : "42:0405id (42:405 Review of HHS Decision (SSID))",
      "42:0405rsi" : "42:0405rsi (42:405 Review of HHS Decision (RSI))",
      "42:0405wc" : "42:0405wc (42:405 Review of HHS Decision (DIWC))",
      "42:0405ww" : "42:0405ww (42:405 Review of HHS Decision (DIWW))",
      "42:0416" : "42:0416 (42:416 Denial of Social Security Benefits)",
      "42:0427" : "42:0427 (42:427 Social Security Benefits)",
      "42:11601" : "42:11601 (42:11601 International Child Abduction Remedies Act)",
      "42:12101" : "42:12101 (42:12101 Americans with Disabilites Act)",
      "42:12117" : "42:12117 (42:117 Americans with Disabilites Act)",
      "42:12131" : "42:12131 (42:13131 Americans With Disabilities Act)",
      "42:1320" : "42:1320 (42:1320 Health Insurance Portability and Accountability Act)",
      "42:1383" : "42:1383 (42:1383 Review of HHS Decision)",
      "42:1395" : "42:1395 (42:1395 HHS: Adverse Reimbursement Review)",
      "42:1395dd" : "42:1395dd (42:1395 Violation of Emerg Med Treatment & Active Labor Act)",
      "42:1395sp" : "42:1395sp (42:1395 Medicare Secondary Payer Law)",
      "42:1396" : "42:1396 (42:1396 - Tort Negligence)",
      "42:1471" : "42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclo)",
      "42:1981cv" : "42:1981cv (42:1981 Civil Rights)",
      "42:1981hs" : "42:1981hs (42:1981 Housing Discrimination)",
      "42:1981jb" : "42:1981jb (42:1981 Job Discrimination (Race))",
      "42:1981sx" : "42:1981sx (42:1981 Sex Discrimination)",
      "42:1983cv" : "42:1983cv (42:1983 Civil Rights Act)",
      "42:1983ed" : "42:1983ed (42:1983 Civil Rights (Employment Discrimination))",
      "42:1983pr" : "42:1983pr (42:1983 Prisoner Civil Rights)",
      "42:1986" : "42:1986 (42:1986 Neglect of Duty)",
      "42:1997" : "42:1997 (42:1997 Civil Rights of Institutionalized Persons Act)",
      "42:2000a" : "42:2000a (42:2000a Access to Public Accommodations)",
      "42:2000ag" : "42:2000ag (42:2000 Job Discrimination (Age))",
      "42:2000e" : "42:2000e (42:2000e Job Discrimination (Employment))",
      "42:2000no" : "42:2000no (42:2000 Job Discrimination (National Origin))",
      "42:2000pb" : "42:2000pb (42:2000 Job Discrimination (Public Accomodations))",
      "42:2000ra" : "42:2000ra (42:2000 Job Discrimination (Race))",
      "42:2000sx" : "42:2000sx (42:2000 Job Discrimination (Sex))",
      "42:2003" : "42:2003 (42:2003 Job Discrimination)",
      "42:2005" : "42:2005 (42:2005 Review of Agency Action-HHS)",
      "42:2651" : "42:2651 (42:2651 Medical Care Recovery)",
      "42:3601" : "42:3601 (42:405 Fair Housing Act)",
      "42:4000" : "42:4000 (42:4000 National Flood Insurance Act)",
      "42:4001" : "42:4001 (42:4001 National Insurance Flood Act)",
      "42:4053" : "42:4053 (42:4053 Breach of Insurance Contract)",
      "42:4072" : "42:4072 (42:4072 Payment of Flood Insurance Claim)",
      "42:4321" : "42:4321 (42:4321 Review of Agency Action-Environment)",
      "42:4332" : "42:4332 (42:4332 Environmental Policy - Coop of Agency Repo)",
      "42:4852" : "42:4852 (Residential Lead-Based Paint Hazard Reduction Act)",
      "42:5401" : "42:5401 (Violation of Manufactured Housing Standards act of 1974)",
      "42:6901en" : "42:6901en (42:6901 Environmental Cleanup Expenses)",
      "42:6901rs" : "42:6901rs (42:6901 Resource & Recovery Act)",
      "42:6972" : "42:6972 (42:6972 Resource Conservation and Recovery Act)",
      "42:6991" : "42:6991 (Environmental Matters)",
      "42:7413" : "42:7413 (42:7413(b) Clean Air Act)",
      "42:7604cl" : "42:7604cl (42:7604 Clear Air Act (Emission Standards))",
      "42:7604ir" : "42:7604ir (42:7604 Petition to Quash IRS Summons)",
      "42:9601" : "42:9601 (42:9601 Comprehensive Env Response, Compensation & Liability Act)",
      "42:9607" : "42:9607 (42:9607 Real Property Tort to Land)",
      "43:945" : "43:945 (43:945 Compensation for Land Condemnation)",
      "43:945a" : "43:945a (43:945a Complaint in Condemnation)",
      "43:946" : "43:946 (43:946 Complaint in Condemnation - Eminent Domain)",
      "45:0051" : "45:0051 (45:51 Railways: Fed. Employer's Liability Act)",
      "45:0056" : "45:0056 (45:56 Railways: Fed. Employer's Liability Act)",
      "45:0151" : "45:0151 (45:151 Railway Labor Act)",
      "45:0184" : "45:0184 (45:184 Action to Set Aside Award of a System Board)",
      "45:1395" : "45:1395 (45:1395 Railroads: Adverse Reimbursement Review)",
      "45:7457" : "45:7457 (45:7457 Compel Reclamation Under Clear Air Act)",
      "46:0183" : "46:0183 (46:183 Action for Limitation of and Exoneration from Liability)",
      "46:0688" : "46:0688 (46:688 Jones Act)",
      "46:0741" : "46:0741 (46:741 Shipping)",
      "46:0761" : "46:0761 (46:761 Shipping: Damages for Death on High Seas)",
      "46:1101" : "46:1101 (46:1101 Violation of Maritime Regulations)",
      "46:1156" : "46:1156 (46:1156 Administrative Procedure Act)",
      "46:31342" : "46:31342 (46:31342 Maritime Liens)",
      "47:227" : "47:227 (47:227 Telephone Consumer Protection Act)",
      "47:521" : "47:521 (47:521 Cable Communications Policy Act of 1984)",
      "47:553" : "47:553 (47:553 Unauthorized Reception of Cable/Satellite TV)",
      "47:605" : "47:605 (47:605 Federal Communications Act of 1934)",
      "48:0883" : "48:0883 (48:883 Violation of US Coastal Law)",
      "48:1983" : "48:1983 (Petition for Judicial Review of State Board of Special Ed)",
      "48:1985" : "48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)",
      "49:0081" : "49:0081 (49:81 Damaged Goods While Being Transported)",
      "49:0781" : "49:0781 (49:781 Forfeiture)",
      "49:10101" : "49:10101 (49:10101 Interstate Commerce Act)",
      "49:10741" : "49:10741 (49:10741 Collection of unpaid freight bills)",
      "49:11503" : "49:11503 (49:11503 Railroad Revitalization Regulatory Reform)",
      "49:11702" : "49:11702 (49:11702(a)(4) Violations of Interstate Commerce A)",
      "49:14706" : "49:14706 (49:14706 Damages to Interstate Shipments by Motor Carriers)",
      "49:1471" : "49:1471 (49:1471 Federal Aviation Act)",
      "49:1903" : "49:1903 (49:1903 Petition to enforce administrative summon)",
      "49:20109" : "49:20109 (49:20109 Railway: Employee Protections)",
      "49:501" : "49:501 (49:501 Federal Motor Carrier Saftey Regulation)",
      "7:2023" : "7:2023 (7:2023 Food Stamp Program - denial of application to partic.)",
      "8:287" : "8:287 (8:287 Petition to Enforce INS Subpoena)",
      "misc" : "misc (Civil Miscellaneous Case)"
   },
   "insdce" : {
      "0" : "0 (No cause code entered)",
      "02:0431" : "02:0431 (02:431 Fed. Election Commission: Failure Enforce C)",
      "02:0437" : "02:0437 (02:437 Federal Election Commission)",
      "05:0075" : "05:0075 (05:75(2) Contract - Reduction in Grade)",
      "05:0551" : "05:0551 (05:551 Administrative Procedure Act)",
      "05:0552fi" : "05:0552fi (05:552 Freedom of Information Act)",
      "05:0552pa" : "05:0552pa (05:552 Right to Privacy Act)",
      "05:0554" : "05:0554 (05:0554 Constitutionality of Maritime Statutes)",
      "05:0701" : "05:0701 (05:0701 Maritime Subsidy Board)",
      "05:0702" : "05:0702 (05:702 Administrative Procedure Act)",
      "05:0704" : "05:0704 (05:704 Labor Litigation)",
      "05:7703" : "05:7703 (05:7703 Discrimination - Review of Agency Act)",
      "07:0006" : "07:0006 (7:6(b) Federal Commodity Exchange Regulation)",
      "07:0025" : "07:0025 (7:25 Fraud - Commodities Leverage Contracts)",
      "07:0181" : "07:0181 (07:181 Packers & Stockyard Act)",
      "07:0499" : "07:0499 (07:499 Agricultural Commodities Act)",
      "07:0601" : "07:0601 (07:601 USDA Condemnation)",
      "07:2321" : "07:2321 (07:2321 Plant Variety Protection Act)",
      "08:1105" : "08:1105 (8:1105(a) Aliens: Habeas Corpus to Release INS Det)",
      "08:1252" : "08:1252 (08:1252(a)(2) Injunction for Deportation)",
      "08:1260" : "08:1260 (08:1260 Aliens: Access to Records)",
      "08:1324" : "08:1324 (08:1324 Aliens: Complaint for Forfeiture)",
      "08:1329" : "08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petiti)",
      "08:1421" : "08:1421 (08:1421 Immigration: Naturalization Authority)",
      "08:1446" : "08:1446 (8:1446 Petition for Naturalization Hearing)",
      "08:1447" : "08:1447 (08:1447 Immigration: Review of Denial of Naturalization Application)",
      "08:1451" : "08:1451 (08:1451 Immigration: Revocation of Citizenship)",
      "09:0001" : "09:0001 (09:1 U.S. Arbitration Act)",
      "09:0009" : "09:0009 (9:9 Motion to Confirm Arbitration Loan)",
      "09:0010" : "09:0010 (09:0010 Petition to Vacate Arbitration Award)",
      "10:1552" : "10:1552 (10:1552 Armed Forces: Action to Correct Records)",
      "10:1553" : "10:1553 (10:1553 Armed Forces: FOIA General)",
      "10:2305" : "10:2305 (10:2305 Review of Federal Contract)",
      "11:0101" : "11:0101 (11:101 Bankruptcy)",
      "12:0022" : "12:0022 (12:22 Securities Fraud)",
      "12:0635" : "12:0635 (12:635 Breach of Insurance Contract)",
      "12:1461" : "12:1461 (12:1461 Homeowners Loan Act)",
      "12:1703" : "12:1703 (12:1703 Default of HUD Loan)",
      "12:1725" : "12:1725 (12:1725 Collection under Contract Guaranty)",
      "12:1730" : "12:1730 (12:1730 Collection Under Contract Guaranty)",
      "12:1819" : "12:1819 (12:1819 Default of Promissory Note)",
      "12:1821" : "12:1821 (12:1821 Default of Loan by Promissary Note)",
      "12:1971" : "12:1971 (12:1971 Relief under Bank Holding Act)",
      "12:3410" : "12:3410 (12:3410 Right to Financial Privacy Act)",
      "15:0001" : "15:0001 (15:1 Antitrust Litigation)",
      "15:0002at" : "15:0002at (15:2 Antitrust Litigation)",
      "15:0002fl" : "15:0002fl (15:2(a) Fair Labor Standards Act)",
      "15:0005" : "15:0005 (15:5(a) Fair Labor Standards Act)",
      "15:0015" : "15:0015 (15:15 Antitrust Litigation)",
      "15:0025" : "15:0025 (15:25 Clayton Act)",
      "15:0044" : "15:0044 (15:44 Trademark Infringement)",
      "15:0045" : "15:0045 (15:0045 Federal Trade Commission Act)",
      "15:0052" : "15:0052 (15:0052 Federal Trade Commission Act)",
      "15:0053" : "15:0053 (15:0053 Federal Trade Commission Act)",
      "15:0077" : "15:0077 (15:77 Securities Fraud)",
      "15:0078" : "15:0078 (15:78m(a) Securities Exchange Act)",
      "15:0631" : "15:0631 (15:631 Small Business Act)",
      "15:0717" : "15:0717 (15:717 Natural Gas Act)",
      "15:1051" : "15:1051 (15:1051 Trademark Infringement)",
      "15:1114" : "15:1114 (15:1114 Trademark Infringement)",
      "15:1121" : "15:1121 (15:1121 Trademark Infringement)",
      "15:1125" : "15:1125 (15:1125 Trademark Infringement (Lanham Act))",
      "15:1126" : "15:1126 (15:1126 Patent Infringement)",
      "15:1127" : "15:1127 (15:1127 Trademark Infringement)",
      "15:1601" : "15:1601 (15:1601 Truth in Lending)",
      "15:1640" : "15:1640 (15:1640 Truth in Lending)",
      "15:1681" : "15:1681 (15:1681 Fair Credit Reporting Act)",
      "15:1692" : "15:1692 (15:1692 Fair Debt Collection Act)",
      "15:1938" : "15:1938 (15:1938 Fair Labor Standards Act)",
      "15:1981" : "15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))",
      "15:1988" : "15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))",
      "15:1989" : "15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))",
      "15:2301" : "15:2301 (15:2301 Magnuson-Moss Warranty Act)",
      "15:2801" : "15:2801 (15:2801 Petroleum Marketing Practices Act)",
      "15:53(b)" : "15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equita)",
      "16:0668" : "16:0668 (16:668 Bald Eagle Protection Act)",
      "16:0703" : "16:0703 (16:703 Migratory Bird Act)",
      "16:1538" : "16:1538 (16:1538 Endangered Species Act)",
      "16:3371" : "16:3371 (16:3371 Wildlife Under the Lacey Act)",
      "16:3372" : "16:3372 (16:3372 Conservation: Complaint for Forfeiture)",
      "16:3373" : "16:3373 (16:3373 Appeal of Decision - DOI)",
      "16:3374" : "16:3374 (16:3374 Conservation: Complaint for Forfeiture)",
      "17:0101" : "17:0101 (17:101 Copyright Infringement)",
      "17:0501" : "17:0501 (17:501 Copyright Infringement)",
      "17:0504" : "17:0504 (17:504 Copyright Infringement)",
      "18:0241" : "18:0241 (18:241 Conspiracy Against Citizen Rights)",
      "18:1345" : "18:1345 (18:1345 Injunction against Fraud)",
      "18:1836a" : "18:1836a (18:1836(a) Injunction against Misappropriation of Trade Secrets)",
      "18:1836b" : "18:1836b (18:1836(b) Civil Action to Protect Trade Secrets)",
      "18:1961" : "18:1961 (18:1961 Racketeering (RICO) Act)",
      "18:1962" : "18:1962 (18:1962 Racketeering (RICO) Act)",
      "18:1964" : "18:1964 (18:1964 Racketeering (RICO) Act)",
      "18:4208" : "18:4208 (18:4208(B) Agency Action Review)",
      "18:981" : "18:981 (Civil Forfeiture)",
      "19:1305" : "19:1305 (19:1305 Custom Duties:0Forfeiture-Immoral Articles)",
      "20:1080" : "20:1080 (20:1080 Student Loan Recovery)",
      "20:1400" : "20:1400 (20:1400 Civil Rights of Handicapped Child)",
      "20:1401" : "20:1401 (20:1401 Education: Handicapped Child Act)",
      "20:1415" : "20:1415 (20:1415 IDEA: Challenge decision re education for handicapped)",
      "20:1681" : "20:1681 (20:1681 Title IX Educational Amendments - Sex Discrimination)",
      "21:0841" : "21:0841 (21:841 Forfeiture Property-Drugs)",
      "21:0842" : "21:0842 (21:0842 Civil Penalty for Violation re Controlled Substance)",
      "21:0881" : "21:0881 (21:881 Forfeiture Property-Drugs)",
      "21:0881a" : "21:0881a (21:881 Forfeiture Property - Aircraft)",
      "21:0881re" : "21:0881re (21:881 Forfeiture Property - Real Estate)",
      "23:0134" : "23:0134 (23:134 P.I.- Auto Negligence)",
      "23:1441" : "23:1441 (23:1441 Contract Real Estate)",
      "24:1000" : "24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)",
      "25:0640" : "25:0640 (25:640 Indian Tribal Rights)",
      "25:1901" : "25:1901 (25:1901 Indian Child Welfare Act)",
      "26:6212" : "26:6212 (26:6212 Injunctive Relief from IRS Lien)",
      "26:6213" : "26:6213 (26:6213 Injunctive Relief from IRS Lien)",
      "26:6502" : "26:6502 (26:6502 IRS:Enforcement of tax liens)",
      "26:6532" : "26:6532 (26:6532 IRS: Refund of Tax Penalty)",
      "26:6702" : "26:6702 (26:6702 IRS: Refund of Income Tax Penalty)",
      "26:6703" : "26:6703 (26:6703 IRS: Refund of Tax Penalty)",
      "26:7401" : "26:7401 (26:7401 IRS: Tax Liability)",
      "26:7402" : "26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)",
      "26:7403" : "26:7403 (26:7403 Suit to Enforce Federal Tax Lien)",
      "26:7422rt" : "26:7422rt (26:7422 IRS: Refund Taxes)",
      "26:7422rx" : "26:7422rx (26:7422 IRS: Refund Excise Tax)",
      "26:7426" : "26:7426 (26:7426 IRS: Wrongful Levy for Taxes)",
      "26:7429" : "26:7429 (26:7429 IRS: Tax Jeopardy Assessment)",
      "26:7433" : "26:7433 (26:7433 IRS: Civil Damages for Unauthorized Collection Actions)",
      "26:7609" : "26:7609 (26:7609 IRS: Petition to Quash IRS Summons)",
      "27:0185" : "27:0185 (27:185 Enforcement of Arbitration Award)",
      "28:0157c" : "28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)",
      "28:0157d" : "28:0157d (28:0157 Motion for Withdrawal of Reference)",
      "28:0158" : "28:0158 (28:0158 Notice of Appeal re Bankruptcy Matter (BA)",
      "28:0185" : "28:0185 (28:185 Suit to Compel Arbitration)",
      "28:0451" : "28:0451 (28:451 Employment Discrimination)",
      "28:0794" : "28:0794 (28:794 Rehabilitation Act)",
      "28:1001" : "28:1001 (28:1001 E.R.I.S.A.)",
      "28:1132" : "28:1132 (28:1132 E.R.I.S.A.)",
      "28:1330" : "28:1330 (28:1330 Breach of Contract)",
      "28:1331" : "28:1331 (28:1331 Fed. Question)",
      "28:1331al" : "28:1331al (28:1331 Fed. Question: Airline Crash)",
      "28:1331as" : "28:1331as (28:1331 Fed. Question: Assault, Libel, Slander)",
      "28:1331at" : "28:1331at (28:1331 Fed. Question: Anti-trust)",
      "28:1331au" : "28:1331au (28:1331 Fed. Question: Auto Negligence)",
      "28:1331b" : "28:1331b (28:1331 Federal Question: Bivens Act)",
      "28:1331bc" : "28:1331bc (28:1331 Fed. Question: Breach of Contract)",
      "28:1331ca" : "28:1331ca (28:1331 Fed Question: Fed Communications Act of 1)",
      "28:1331cm" : "28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)",
      "28:1331cv" : "28:1331cv (28:1331 Federal Question: Other Civil Rights)",
      "28:1331ed" : "28:1331ed (28:1331 Fed. Question: Employment Discrimination)",
      "28:1331es" : "28:1331es (28:1331 Enforcement of Administrative Subpoena)",
      "28:1331fl" : "28:1331fl (28:1331 Fed. Question: Fair Labor Standards)",
      "28:1331in" : "28:1331in (28:1331 Fed. Question: Insurance Contract)",
      "28:1331mm" : "28:1331mm (28:1331 Fed. Question: Medical Malpractice)",
      "28:1331pi" : "28:1331pi (28:1331 Fed. Question: Personal Injury)",
      "28:1331rd" : "28:1331rd (28:1331 Fed. Question: Review Agency Decision)",
      "28:1331rp" : "28:1331rp (28:1331(a) Fed. Question: Real Property)",
      "28:1331rr" : "28:1331rr (28:1331 Fed. Question: Railway Labor Act)",
      "28:1331sv" : "28:1331sv (28:1331 Fed. Question: Securities Violation)",
      "28:1331tr" : "28:1331tr (28:1331 Fed. Question: Trademark)",
      "28:1331tt" : "28:1331tt (28:1331 Fed. Question: Tort Action)",
      "28:1331v" : "28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendme)",
      "28:1331wl" : "28:1331wl (28:1331 Federal Question: EPA Waste Lien)",
      "28:1331wt" : "28:1331wt (28:1331 Fed. Question: Water Rights)",
      "28:1332ac" : "28:1332ac (28:1332 Diversity-Account Receivable)",
      "28:1332al" : "28:1332al (28:1332 Diversity-Airline Crash)",
      "28:1332as" : "28:1332as (28:1332 Diversity-Asbestos Litigation)",
      "28:1332au" : "28:1332au (28:1332 Diversity-Auto Negligence)",
      "28:1332bc" : "28:1332bc (28:1332 Diversity-Breach of Contract)",
      "28:1332co" : "28:1332co (28:1332 Diversity-Conversion)",
      "28:1332ct" : "28:1332ct (28:1332 Diversity-(Citizenship))",
      "28:1332det" : "28:1332det (28:1332 Diversity: Forcible Detainer)",
      "28:1332df" : "28:1332df (28:1332 Diversity-Contract Default)",
      "28:1332ds" : "28:1332ds (28:1332 Diversity-Contract Dispute)",
      "28:1332ed" : "28:1332ed (28:1332 Diversity-Employment Discrimination)",
      "28:1332fd" : "28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)",
      "28:1332fr" : "28:1332fr (28:1332 Diversity-Fraud)",
      "28:1332ia" : "28:1332ia (28:1332 Diversity-Interpleader Action)",
      "28:1332ij" : "28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)",
      "28:1332in" : "28:1332in (28:1332 Diversity-Insurance Contract)",
      "28:1332jd" : "28:1332jd (28:1332 Diversity-Declaratory Judgement)",
      "28:1332lb" : "28:1332lb (28:1332 Diversity-Libel,Assault,Slander)",
      "28:1332lm" : "28:1332lm (28:1332 Diversity - Legal Malpractice)",
      "28:1332ma" : "28:1332ma (28:1332 Diversity-Miller Act)",
      "28:1332mm" : "28:1332mm (28:1332 Diversity-Medical Malpractice)",
      "28:1332mv" : "28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)",
      "28:1332ni" : "28:1332ni (28:1332 Diversity-Negotiable Instrument)",
      "28:1332nm" : "28:1332nm (28:1332 Diversity-Non-Motor Vehicle)",
      "28:1332nr" : "28:1332nr (28:1332 Diversity-Notice of Removal)",
      "28:1332oc" : "28:1332oc (28:1332 Diversity-Other Contract)",
      "28:1332pd" : "28:1332pd (28:1332 Diversity-Property Damage)",
      "28:1332pi" : "28:1332pi (28:1332 Diversity-Personal Injury)",
      "28:1332pl" : "28:1332pl (28:1332 Diversity-Product Liability)",
      "28:1332pr" : "28:1332pr (28:1332 Diversity-Petition for Removal)",
      "28:1332qt" : "28:1332qt (28:1332 Diversity-Petition to Quiet Title)",
      "28:1332ri" : "28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)",
      "28:1332sa" : "28:1332sa (28:1332 - Diversity: Securities & Exchange Commiss)",
      "28:1332sf" : "28:1332sf (28:1332 - Diversity: Securities Fraud)",
      "28:1332ss" : "28:1332ss (28:1332 Diversity - Stockholders Suits)",
      "28:1332tl" : "28:1332tl (28:1332 Diversity-Torts to Land)",
      "28:1332tm" : "28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))",
      "28:1332tn" : "28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)",
      "28:1332wd" : "28:1332wd (28:1332 Diversity-Wrongful Death)",
      "28:1333" : "28:1333 (28:1333 Admiralty)",
      "28:1334" : "28:1334 (28:1334 Bankruptcy Appeal)",
      "28:1334c" : "28:1334c (28:1334(c) R&R re motions for abstention (non-cor)",
      "28:1335" : "28:1335 (28:1335 Interpleader Action)",
      "28:1337" : "28:1337 (28:1337 Sherman-Clayton Act)",
      "28:1338cp" : "28:1338cp (28:1338 Copyright Infringement)",
      "28:1338pt" : "28:1338pt (28:1338 Patent Infringement)",
      "28:1338tr" : "28:1338tr (28:1338 Trademark Infringement)",
      "28:1340" : "28:1340 (28:1340 IRS: Custom Duties)",
      "28:1340er" : "28:1340er (28:1340 Recovery of Erroneous Refund)",
      "28:1341" : "28:1341 (28:1341 Complaint for Forfeiture)",
      "28:1343" : "28:1343 (28:1343 Violation of Civil Rights)",
      "28:1345co" : "28:1345co (28:1345 Replevin & Conversion)",
      "28:1345db" : "28:1345db (28:1345 Debt to US - FHA/HUD Title I)",
      "28:1345df" : "28:1345df (28:1345 Default of Promissory Note)",
      "28:1345er" : "28:1345er (28:1345 Recovery of Erroneous Refund)",
      "28:1345fc" : "28:1345fc (28:1345 Foreclosure)",
      "28:1345ff" : "28:1345ff (28:1345 Complaint for Forfeiture)",
      "28:1345hl" : "28:1345hl (28:1345 VA Home Loan Guaranty Debt)",
      "28:1345mc" : "28:1345mc (28:1345 Medical Care Recovery)",
      "28:1345mi" : "28:1345mi (28:1345 Mining Claim Ejectment)",
      "28:1345pd" : "28:1345pd (28:1345 Property Damage)",
      "28:1345pe" : "28:1345pe (28:1345 Property Ejectment)",
      "28:1345rc" : "28:1345rc (28:1345 Recovery of Debt to US)",
      "28:1345st" : "28:1345st (28:1345 Default of Student Loan)",
      "28:1345tp" : "28:1345tp (28:1345 Trespass on Public Land)",
      "28:1345va" : "28:1345va (28:1345 Recovery of VA Overpayment)",
      "28:1346bc" : "28:1346bc (28:1346 Breach of Contract)",
      "28:1346rc" : "28:1346rc (28:1346 Recovery of IRS Tax)",
      "28:1346tc" : "28:1346tc (28:1346 Tort Claim)",
      "28:1346wd" : "28:1346wd (28:1346 Wrongful Death)",
      "28:1352" : "28:1352 (28:1352 Miller Act)",
      "28:1355" : "28:1355 (28:1355 Petition for Return of Property)",
      "28:1358" : "28:1358 (28:1358 Land Condemnation)",
      "28:1361" : "28:1361 (28:1361 Petition for Writ of Mandamus)",
      "28:1362ic" : "28:1362ic (28:1362 Indian Tribal Controversy)",
      "28:1362iw" : "28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)",
      "28:1364" : "28:1364 (28:1364 Auto Negligence)",
      "28:1367" : "28:1367 (28:1367 Other Property Damage)",
      "28:1391" : "28:1391 (28:1391 Personal Injury)",
      "28:1402" : "28:1402 (28:1402 Medical Malpractice)",
      "28:1407" : "28:1407 (28:1407 Airline Crash)",
      "28:1407pl" : "28:1407pl (28:1407 Products Liability)",
      "28:1441ac" : "28:1441ac (28:1441 Petition for Removal- Account Receivable)",
      "28:1441al" : "28:1441al (28:1441 Petition for Removal- Airline Crash)",
      "28:1441as" : "28:1441as (28:1441 Petition for Removal- Asbestos Litigation)",
      "28:1441au" : "28:1441au (28:1441 Petition for Removal- Auto Negligence)",
      "28:1441bc" : "28:1441bc (28:1441 Petition for Removal- Breach of Contract)",
      "28:1441cv" : "28:1441cv (28:1441 Petition for Removal- Civil Rights Act)",
      "28:1441df" : "28:1441df (28:1441 Petition for Removal- Contract Default)",
      "28:1441dj" : "28:1441dj (28:1441 Petition for Removal- Declaratory Judgemen)",
      "28:1441ds" : "28:1441ds (28:1441 Petition for Removal- Contract Dispute)",
      "28:1441ed" : "28:1441ed (28:1441 Petition for Removal - Employment Discrim)",
      "28:1441fc" : "28:1441fc (28:1441 Petition for Removal - Fair Credit Reporti)",
      "28:1441fr" : "28:1441fr (28:1441 Petition for Removal- Fraud)",
      "28:1441ij" : "28:1441ij (28:1441 Petition for Removal- Injunctive/Declarato)",
      "28:1441in" : "28:1441in (28:1441 Petition for Removal- Insurance Contract)",
      "28:1441int" : "28:1441int (28:1441 Petition for Removal- Action for Interplea)",
      "28:1441lb" : "28:1441lb (28:1441 Petition for Removal Libel,Assault,Slander)",
      "28:1441lm" : "28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relatio)",
      "28:1441mm" : "28:1441mm (28:1441 Petition for Removal- Medical Malpractice)",
      "28:1441ni" : "28:1441ni (28:1441 Petition for Removal- Negotiable Instrumen)",
      "28:1441nm" : "28:1441nm (28:1441 Petition for Removal- Non-Motor Vehicle)",
      "28:1441oc" : "28:1441oc (28:1441 Petition For Removal--Other Contract)",
      "28:1441pd" : "28:1441pd (28:1441 Petition for Removal- Property Damage)",
      "28:1441pi" : "28:1441pi (28:1441 Petition for Removal- Personal Injury)",
      "28:1441pl" : "28:1441pl (28:1441 Petition for Removal- Product Liability)",
      "28:1441pr" : "28:1441pr (28:1441 Petition for Removal)",
      "28:1441qt" : "28:1441qt (28:1441 Petition for Removal- Petition to Quiet Ti)",
      "28:1441ri" : "28:1441ri (28:1441 Petition for Removal- Racketeering (RICO))",
      "28:1441sa" : "28:1441sa (28:1441 - Petition for Removal: SEC Act)",
      "28:1441sf" : "28:1441sf (28:1441 - Petition for Removal: Securities Fraud)",
      "28:1441tl" : "28:1441tl (28:1441 Petition for Removal- Torts to Land)",
      "28:1441tm" : "28:1441tm (28:1441 Petition for Removal- Tort/Motor Vehicle ()",
      "28:1441tn" : "28:1441tn (28:1441 Petition for Removal- Tort/Non-Motor Vehic)",
      "28:1441wd" : "28:1441wd (28:1441 Petition for Removal- Wrongful Death)",
      "28:1442bc" : "28:1442bc (28:1442 Petition for Removal- Breach of Contract)",
      "28:1442pr" : "28:1442pr (28:1442 Petition for Removal)",
      "28:1443" : "28:1443 (28:1443(1) Rent, Lease & Ejectment)",
      "28:1444" : "28:1444 (28:1444 Petition for Removal- Foreclosure)",
      "28:1446in" : "28:1446in (28:1446 Breach of Contract- Insurance)",
      "28:1446pd" : "28:1446pd (28:1446 Petition for Removal- Property Damage (P.I)",
      "28:1446pi" : "28:1446pi (28:1446 Petition for Removal- Personal Injury)",
      "28:1446pl" : "28:1446pl (28:1446pl Petition for Removal - Product Liability)",
      "28:1446pr" : "28:1446pr (28:1446 Petition for Removal)",
      "28:1452" : "28:1452 (28:1452 R&R re motions to remand (non-core))",
      "28:1605A" : "28:1605A (28:1605 Antiterrorism & Effective Death Penalty Act 1996)",
      "28:1651" : "28:1651 (28:1651 Petition for Writ of Coram Nobis)",
      "28:1651hc" : "28:1651hc (28:1651 Petition for Writ of Habeas Corpus)",
      "28:1651mn" : "28:1651mn (28:1651 Petition for Writ of Mandamus)",
      "28:2201" : "28:2201 (28:2201 Constitutionality of State Statute(s))",
      "28:2201dj" : "28:2201dj (28:2201 Declaratory Judgement)",
      "28:2201ij" : "28:2201ij (28:2201 Injunction)",
      "28:2201in" : "28:2201in (28:2201 Declaratory Judgement (Insurance))",
      "28:2241" : "28:2241 (28:2241 Petition for Writ of Habeas Corpus (federal))",
      "28:2254" : "28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))",
      "28:2254se" : "28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)",
      "28:2255" : "28:2255 (28:2255 Motion to Vacate / Correct Illegal Sentenc)",
      "28:2271" : "28:2271 (28:2271 Federal Tort Claims Act)",
      "28:2345" : "28:2345 (28:2345 Medicare Recovery)",
      "28:2409" : "28:2409 (28:2409(a) Quiet Title Action)",
      "28:2410" : "28:2410 (28:2410 Quiet Title)",
      "28:2671" : "28:2671 (28:2671 Federal Tort Claims Act)",
      "28:2674" : "28:2674 (28:2674 Federal Tort Claims Act)",
      "28:7402" : "28:7402 (28:7402 Refund of Taxes)",
      "28:7422" : "28:7422 (28:7422 Appeal from Administrative Decision)",
      "29:0151" : "29:0151 (29:151 Labor: Review of Agency Action)",
      "29:0160" : "29:0160 (29:160(1) National Labor Relations Act)",
      "29:0184" : "29:0184 (29:184 Violation Collection Bargain Agreement)",
      "29:0185ep" : "29:0185ep (29:185 Employee Pension Plan)",
      "29:0185lm" : "29:0185lm (29:185 Labor/Mgt. Relations (Contracts))",
      "29:0201do" : "29:0201do (29:201 Denial of Overtime Compensation)",
      "29:0201fl" : "29:0201fl (29:201 Fair Labor Standards Act)",
      "29:0203" : "29:0203 (29:203 Equal Pay Act)",
      "29:0206" : "29:0206 (29:206 Collect Unpaid Wages)",
      "29:0401" : "29:0401 (29:0401 Labor Management Disclosure Act)",
      "29:0621" : "29:0621 (29:621 Job Discrimination (Age))",
      "29:0623" : "29:0623 (29:623 Job Discrimination (Age))",
      "29:0626" : "29:0626 (29:626 Job Discrimination (Age))",
      "29:0633" : "29:0633 (29:633 Job Discrimination (Age))",
      "29:0651" : "29:0651 (29:651 Occupational Safety/Health)",
      "29:0754" : "29:0754 (29:754 Discrimination)",
      "29:0791" : "29:0791 (29:791 Job Discrimination (Rehabilitation Act))",
      "29:0794" : "29:0794 (29:0794 Job Discrimination (Handicap))",
      "29:1001" : "29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)",
      "29:1002" : "29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)",
      "29:1104" : "29:1104 (29:1104 Recovery of Benefits to Employee)",
      "29:1109" : "29:1109 (29:1109 Breach of Fiduciary Duties)",
      "29:1131" : "29:1131 (29:1131 ERISA - Collection of Delinquent Trust Fun)",
      "29:1132" : "29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)",
      "29:1145" : "29:1145 (29:1145 E.R.I.S.A.)",
      "29:1149" : "29:1149 (29:1149 Recover Pension & Profit Sharing)",
      "29:1337" : "29:1337 (29:1337 E.R.I.S.A.)",
      "29:1362" : "29:1362 (29:1362 ERISA)",
      "29:1381" : "29:1381 (29:1381 E.R.I.S.A.)",
      "29:1401" : "29:1401 (29:1401(b)(2) Appeal of Arbitration Award)",
      "29:1451" : "29:1451 (29:1451 E.R.I.S.A.)",
      "29:1801" : "29:1801 (29:1801 Farmworker Rights)",
      "29:2101" : "29:2101 (29:2101 Worker Adjustment and Retraining Notification Act)",
      "29:2104" : "29:2104 (29:2104 Worker Adjustment & Retraining Notification (WARN))",
      "29:2601" : "29:2601 (29:2601 FMLA:Family and Medical Leave Act)",
      "29:2612" : "29:2612 (29:2612 FMLA: Leave Requirements)",
      "29:2617" : "29:2617 (29:2617 FMLA: Enforcement)",
      "29:701" : "29:701 (29:701 Vocational Rehabilitation)",
      "29:790" : "29:790 (29:790 Rehabilitation of Labor)",
      "30:0181" : "30:0181 (30:181 Environment: Review of Agency Action)",
      "30:0801" : "30:0801 (30:0801 Penalities/Federal Mine Safety Health Act)",
      "30:1201" : "30:1201 (30:1201 Environment: Review of Agency Action)",
      "30:1202" : "30:1202 (30:1202 Mining Reclamation Act)",
      "30:1276" : "30:1276 (30:1276 Interior: Review of Agency Action)",
      "31:3545" : "31:3545 (31:3545 Action to Recovery Money)",
      "31:3729" : "31:3729 (31:3729 False Claims Act)",
      "31:3730" : "31:3730 (31:3730 Qui Tam False Claims Act)",
      "31:3731" : "31:3731 (31:3731 Fraud)",
      "33:1319cw" : "33:1319cw (33:1319 Clean Water Act)",
      "33:1319pv" : "33:1319pv (33:1319 Pollutants & Permit Violations)",
      "33:1365" : "33:1365 (33:1365 Environmental Matters)",
      "35:0145" : "35:0145 (35:145 Patent Infringement)",
      "35:0183" : "35:0183 (35:183 Patent Infringement)",
      "35:0271" : "35:0271 (35:271 Patent Infringement)",
      "38:1681" : "38:1681 (38:1681 Recovery of VA Overpayment)",
      "38:1686" : "38:1686 (38:1686 Recovery of VA Overpayment)",
      "38:1780" : "38:1780 (38:1780 Recovery of VA Overpayment)",
      "38:2011" : "38:2011 (38:2011 - Veteran's Readjustment Assistance Act of)",
      "38:3116" : "38:3116 (38:3116 VA Overpayment)",
      "38:4311" : "38:4311 (38:4311 Uniformed Service Employment or Reemployment Rights Act (USERRA) - Discrimination)",
      "39:3005" : "39:3005 (39:3005 Detention of Mail for Temporary Periods)",
      "39:409" : "39:409 (39:409 Postal Service)",
      "40:0258" : "40:0258 (40:258(a) Public Buildings & Property: Land Condem)",
      "40:0270" : "40:0270 (40:270 Miller Act)",
      "40:0875" : "40:0875 (40:875 Public Buildings & Property: Negligence)",
      "41:0251" : "41:0251 (41:251 Public Contracts-Review of Agency Action)",
      "41:1463" : "41:1463 (41:1463 Public Contracts: Unlawful Employment Prac)",
      "42:0205" : "42:0205 (42:205 Denial Social Security Benefits)",
      "42:0206" : "42:0206 (42:206 Social Security Benefits)",
      "42:0247" : "42:0247 (42:247 Personal Injury-Swine Flu)",
      "42:0254o" : "42:0254o (42:254o Breach of Scholarship Contract)",
      "42:0402" : "42:0402 (42:402 Social Security Benefits)",
      "42:0405id" : "42:0405id (42:405 Review of HHS Decision (SSID))",
      "42:0405wc" : "42:0405wc (42:405 Review of HHS Decision (DIWC))",
      "42:0405ww" : "42:0405ww (42:405 Review of HHS Decision (DIWW))",
      "42:0416" : "42:0416 (42:416 Denial of Social Security Benefits)",
      "42:0427" : "42:0427 (42:427 Social Security Benefits)",
      "42:10801" : "42:10801 (42:10801 Protection & Advocacy for Individuals with Mental Illness Act of 1986 (PAIMI))",
      "42:10805" : "42:10805 (42:10805 Protection and Advocacy System)",
      "42:12101" : "42:12101 (42:12101 The Americans with Disabilities Act)",
      "42:12117" : "42:12117 (42:12117 Americans with Disabilities Act - Enforcement)",
      "42:1383" : "42:1383 (42:1383 Review of HHS Decision)",
      "42:1395" : "42:1395 (42:1395 HHS: Adverse Reimbursement Review)",
      "42:1395dd" : "42:1395dd (42:1395dd Exam & Treatment Emergency Med Cond & Women in Labor)",
      "42:1396" : "42:1396 (42:1396 - Tort Negligence)",
      "42:1471" : "42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclo)",
      "42:1973gg2" : "42:1973gg2 (42:1973gg-2 Nat'l. Voter Registration Act of 1993 (NVRA))",
      "42:1981cv" : "42:1981cv (42:1981 Civil Rights)",
      "42:1981hs" : "42:1981hs (42:1981 Housing Discrimination)",
      "42:1981jb" : "42:1981jb (42:1981 Job Discrimination (Race))",
      "42:1981ra" : "42:1981ra (42:1981ra Race Discrimination)",
      "42:1981sx" : "42:1981sx (42:1981 Sex Discrimination)",
      "42:1983cv" : "42:1983cv (42:1983 Civil Rights Act)",
      "42:1983ed" : "42:1983ed (42:1983 Civil Rights (Employment Discrimination))",
      "42:1983pr" : "42:1983pr (42:1983 Prisoner Civil Rights)",
      "42:1986" : "42:1986 (42:1986 Neglect of Duty)",
      "42:2000ag" : "42:2000ag (42:2000 Job Discrimination (Age))",
      "42:2000cc" : "42:2000cc (42:2000 Religious Land Use & Institutionalized Persons Act of 2000)",
      "42:2000e" : "42:2000e (42:2000e Job Discrimination (Employment))",
      "42:2000e2e" : "42:2000e2e (42:2000e-2e Injunctive Relief/TRO (Unlawful Employment Practices))",
      "42:2000pb" : "42:2000pb (42:2000 Job Discrimination (Public Accomodations))",
      "42:2000ra" : "42:2000ra (42:2000 Job Discrimination (Race))",
      "42:2000sx" : "42:2000sx (42:2000 Job Discrimination (Sex))",
      "42:2003" : "42:2003 (42:2003 Job Discrimination)",
      "42:2005" : "42:2005 (42:2005 Review of Agency Action-HHS)",
      "42:2651" : "42:2651 (42:2651 Medical Care Recovery)",
      "42:3601" : "42:3601 (42:405 Fair Housing Act)",
      "42:4000" : "42:4000 (42:4000 National Flood Insurance Act)",
      "42:4001" : "42:4001 (42:4001 National Insurance Flood Act)",
      "42:4053" : "42:4053 (42:4053 Breach of Insurance Contract)",
      "42:405rs" : "42:405rs (42:405rs Review of HHS Decision (RSI))",
      "42:4072" : "42:4072 (42:4072 Payment of Flood Insurance Claim)",
      "42:4321" : "42:4321 (42:4321 Review of Agency Action-Environment)",
      "42:4332" : "42:4332 (42:4332 Environmental Policy - Coop of Agency Repo)",
      "42:6901en" : "42:6901en (42:6901 Environmental Cleanup Expenses)",
      "42:6901rs" : "42:6901rs (42:6901 Resource & Recovery Act)",
      "42:7413" : "42:7413 (42:7413(b) Clean Air Act)",
      "42:7604cl" : "42:7604cl (42:7604 Clear Air Act (Emission Standards))",
      "42:7604ir" : "42:7604ir (42:7604 Petition to Quash IRS Summons)",
      "42:9601" : "42:9601 (42:9601 Comprehensive Environmental Compen/Resp/Liab (CERCLA) (Definitions))",
      "42:9607" : "42:9607 (42:9607 Real Property Tort to Land)",
      "43:945" : "43:945 (43:945 Compensation for Land Condemnation)",
      "43:945a" : "43:945a (43:945a Complaint in Condemnation)",
      "43:946" : "43:946 (43:946 Complaint in Condemnation - Eminent Domain)",
      "45:0051" : "45:0051 (45:51 Railways: Fed. Employer's Liability Act)",
      "45:0151" : "45:0151 (45:151 Railway Labor Act)",
      "45:0184" : "45:0184 (45:184 Action to Set Aside Award of a System Board)",
      "45:1395" : "45:1395 (45:1395 Railroads: Adverse Reimbursement Review)",
      "45:7457" : "45:7457 (45:7457 Compel Reclamation Under Clear Air Act)",
      "46:0688" : "46:0688 (46:688 Jones Act)",
      "46:0741" : "46:0741 (46:741 Shipping)",
      "46:0761" : "46:0761 (46:761 Shipping: Damages for Death on High Seas)",
      "46:1101" : "46:1101 (46:1101 Violation of Maritime Regulations)",
      "46:1156" : "46:1156 (46:1156 Administrative Procedure Act)",
      "47:227b3" : "47:227b3 (47:227b3 Telephone Consumer Protection Act)",
      "47:605" : "47:605 (47:605 Unlawful Reception Broadcast Signal i.e., Satellite Comm.)",
      "48:0883" : "48:0883 (48:883 Violation of US Coastal Law)",
      "48:1985" : "48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)",
      "49:0081" : "49:0081 (49:81 Damaged Goods While Being Transported)",
      "49:0781" : "49:0781 (49:781 Forfeiture)",
      "49:11503" : "49:11503 (49:11503 Railroad Revitalization Regulatory Reform)",
      "49:11702" : "49:11702 (49:11702(a)(4) Violations of Interstate Commerce A)",
      "49:14706" : "49:14706 (49:14706 Carmack Amendment to the Interstate Commerce Act)",
      "49:1471" : "49:1471 (49:1471 Federal Aviation Act)",
      "49:1903" : "49:1903 (49:1903 Petition to enforce administrative summon)",
      "8:287" : "8:287 (8:287 Petition to Enforce INS Subpoena)",
      "misc" : "misc (Civil Miscellaneous Case)"
   },
   "ksdce" : {
      "0" : "0 (No cause code entered)",
      "00:0000" : "00:0000 (00:0000 Cause Code Unknown)",
      "02:0431" : "02:0431 (02:431 Fed. Election Commission: Failure Enforce C)",
      "02:0437" : "02:0437 (02:437 Federal Election Commission)",
      "05:0075" : "05:0075 (05:75(2) Contract - Reduction in Grade)",
      "05:0551" : "05:0551 (05:551 Administrative Procedure Act)",
      "05:0552fi" : "05:0552fi (05:552 Freedom of Information Act)",
      "05:0552pa" : "05:0552pa (05:552 Right to Privacy Act)",
      "05:0554" : "05:0554 (05:0554 Constitutionality of Maritime Statutes)",
      "05:0701" : "05:0701 (05:0701 Maritime Subsidy Board)",
      "05:0702" : "05:0702 (05:702 Administrative Procedure Act)",
      "05:0704" : "05:0704 (05:704 Labor Litigation)",
      "05:7703" : "05:7703 (05:7703 Discrimination - Review of Agency Act)",
      "07:0006" : "07:0006 (7:6(b) Federal Commodity Exchange Regulation)",
      "07:0025" : "07:0025 (7:25 Fraud - Commodities Leverage Contracts)",
      "07:0181" : "07:0181 (07:181 Packers & Stockyard Act)",
      "07:0499" : "07:0499 (07:499 Agricultural Commodities Act)",
      "07:0601" : "07:0601 (07:601 USDA Condemnation)",
      "07:1926" : "07:1926 (07:1926 Water and Waste Facility Loans and Grants)",
      "07:2023" : "07:2023 (07:2023 Agriculture Food Stamp Program)",
      "07:2131" : "07:2131 (07:2131 Animal Welfare Act)",
      "07:2321" : "07:2321 (07:2321 Plant Variety Protection Act)",
      "07:6999" : "07:6999 (07:6999 Judicial Review from Agency Action)",
      "08:1105" : "08:1105 (8:1105(a) Aliens: Habeas Corpus to Release INS Det)",
      "08:1252" : "08:1252 (08:1252(a)(2) Injunction for Deportation)",
      "08:1260" : "08:1260 (08:1260 Aliens: Access to Records)",
      "08:1324" : "08:1324 (08:1324 Aliens: Complaint for Forfeiture)",
      "08:1329" : "08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petiti)",
      "08:1446" : "08:1446 (8:1446 Petition for Naturalization Hearing)",
      "08:1451" : "08:1451 (08:1451 Immigration and Nationality Act of 1952)",
      "09:0001" : "09:0001 (09:1 U.S. Arbitration Act)",
      "09:0009" : "09:0009 (9:9 Motion to Confirm Arbitration Loan)",
      "09:0010" : "09:0010 (09:0010 Petition to Vacate Arbitration Award)",
      "09:0206" : "09:0206 (9:206 Order to Compel Arbitration)",
      "10:1552" : "10:1552 (10:1552 Armed Forces: Action to Correct Records)",
      "10:1553" : "10:1553 (10:1553 Armed Forces: FOIA General)",
      "10:2305" : "10:2305 (10:2305 Review of Federal Contract)",
      "11:0101" : "11:0101 (11:101 Bankruptcy)",
      "12:0022" : "12:0022 (12:22 Securities Fraud)",
      "12:0635" : "12:0635 (12:635 Breach of Insurance Contract)",
      "12:1461" : "12:1461 (12:1461 Homeowners Loan Act)",
      "12:1703" : "12:1703 (12:1703 Default of HUD Loan)",
      "12:1725" : "12:1725 (12:1725 Collection under Contract Guaranty)",
      "12:1730" : "12:1730 (12:1730 Collection Under Contract Guaranty)",
      "12:1819" : "12:1819 (12:1819 Default of Promissory Note)",
      "12:1821" : "12:1821 (12:1821 Default of Loan by Promissary Note)",
      "12:1971" : "12:1971 (12:1971 Relief under Bank Holding Act)",
      "12:3410" : "12:3410 (12:3410 Right to Financial Privacy Act)",
      "15:0001" : "15:0001 (15:1 Antitrust Litigation)",
      "15:0002at" : "15:0002at (15:2 Antitrust Litigation)",
      "15:0002fl" : "15:0002fl (15:2(a) Fair Labor Standards Act)",
      "15:0005" : "15:0005 (15:5(a) Fair Labor Standards Act)",
      "15:0015" : "15:0015 (15:15 Antitrust Litigation)",
      "15:0025" : "15:0025 (15:25 Clayton Act)",
      "15:0044" : "15:0044 (15:44 Trademark Infringement)",
      "15:0045" : "15:0045 (15:0045 Federal Trade Commission Act)",
      "15:0052" : "15:0052 (15:0052 Federal Trade Commission Act)",
      "15:0053" : "15:0053 (15:0053 Federal Trade Commission Act)",
      "15:0077" : "15:0077 (15:77 Securities Fraud)",
      "15:0078" : "15:0078 (15:78m(a) Securities Exchange Act)",
      "15:0631" : "15:0631 (15:631 Small Business Act)",
      "15:0717" : "15:0717 (15:717 Natural Gas Act)",
      "15:1051" : "15:1051 (15:1051 Trademark Infringement)",
      "15:1114" : "15:1114 (15:1114 Trademark Infringement)",
      "15:1121" : "15:1121 (15:1121 Trademark Infringement)",
      "15:1125" : "15:1125 (15:1125 Trademark Infringement (Lanham Act))",
      "15:1126" : "15:1126 (15:1126 Patent Infringement)",
      "15:1127" : "15:1127 (15:1127 Trademark Infringement)",
      "15:1261" : "15:1261 (15:1261 - Federal Hazardous Substances Act FHSA)",
      "15:1601" : "15:1601 (15:1601 Truth in Lending)",
      "15:1640" : "15:1640 (15:1640 Truth in Lending)",
      "15:1681" : "15:1681 (15:1681 Fair Credit Reporting Act)",
      "15:1691" : "15:1691 (15:1691 Equal Credit Opportunity)",
      "15:1692" : "15:1692 (15:1692 Fair Debt Collection Act)",
      "15:1693" : "15:1693 (15:1693 Electronic Funds Transfer Act)",
      "15:1938" : "15:1938 (15:1938 Fair Labor Standards Act)",
      "15:1981" : "15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))",
      "15:1988" : "15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))",
      "15:1989" : "15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))",
      "15:2301" : "15:2301 (15:2301 Magnuson-Moss Warranty Act)",
      "15:2801" : "15:2801 (15:2801 Petroleum Marketing Practices Act)",
      "15:53(b)" : "15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equita)",
      "16:0668" : "16:0668 (16:668 Bald Eagle Protection Act)",
      "16:0703" : "16:0703 (16:703 Migratory Bird Act)",
      "16:0791" : "16:0791 (16:791 Federal Power Act)",
      "16:1538" : "16:1538 (16:1538 Endangered Species Act)",
      "16:3371" : "16:3371 (16:3371 Wildlife Under the Lacey Act)",
      "16:3372" : "16:3372 (16:3372 Conservation: Complaint for Forfeiture)",
      "16:3373" : "16:3373 (16:3373 Appeal of Decision - DOI)",
      "16:3374" : "16:3374 (16:3374 Conservation: Complaint for Forfeiture)",
      "16:3837" : "16:3837 (16:3837 Wetlands Reserve Program)",
      "17:0101" : "17:0101 (17:101 Copyright Infringement)",
      "17:0501" : "17:0501 (17:501 Copyright Infringement)",
      "17:0504" : "17:0504 (17:504 Copyright Infringement)",
      "18:0241" : "18:0241 (18:241 Conspiracy Against Citizen Rights)",
      "18:0981" : "18:0981 (18:981 Civil Forfeiture)",
      "18:1030" : "18:1030 (18:1030 Fraud and Related Activity in Connection with Computers)",
      "18:1345" : "18:1345 (18:1345 Injunctions Against Fraud)",
      "18:1961" : "18:1961 (18:1961 Racketeering (RICO) Act)",
      "18:1962" : "18:1962 (18:1962 Racketeering (RICO) Act)",
      "18:1964" : "18:1964 (18:1964 Racketeering (RICO) Act)",
      "18:2511" : "18:2511 (18: 2511 Interception and Disclosure of Wire, Oral or Electronic Communications)",
      "18:4208" : "18:4208 (18:4208(B) Agency Action Review)",
      "19:1305" : "19:1305 (19:1305 Custom Duties:0Forfeiture-Immoral Articles)",
      "20:1080" : "20:1080 (20:1080 Student Loan Recovery)",
      "20:1400" : "20:1400 (20:1400 Civil Rights of Handicapped Child)",
      "20:1401" : "20:1401 (20:1401 Education: Handicapped Child Act)",
      "20:1681" : "20:1681 (20:1681 Education: Sex Discrimination)",
      "21:0331" : "21:0331 (21:0331 Federal Food, Drug, and Cosmetic Act)",
      "21:0801" : "21:0801 (21:801 COMPREHENSIVE DRUG ABUSE PREVENTION AND CONTROL ACT)",
      "21:0841" : "21:0841 (21:841 Forfeiture Property-Drugs)",
      "21:0881" : "21:0881 (21:881 Forfeiture Property-Drugs)",
      "21:0881a" : "21:0881a (21:881 Forfeiture Property - Aircraft)",
      "21:0881re" : "21:0881re (21:881 Forfeiture Property - Real Estate)",
      "23:0134" : "23:0134 (23:134 P.I.- Auto Negligence)",
      "23:1441" : "23:1441 (23:1441 Contract Real Estate)",
      "24:1000" : "24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)",
      "25:0640" : "25:0640 (25:640 Indian Tribal Rights)",
      "25:1901" : "25:1901 (25:1901 Indian Child Welfare Act)",
      "25:3731" : "25:3731 (25:3731 Haskell Indian Nations University and Southwestern Indian Polytechnic Institute Adminstrativ)",
      "26:6212" : "26:6212 (26:6212 Injunctive Relief from IRS Lien)",
      "26:6213" : "26:6213 (26:6213 Injunctive Relief from IRS Lien)",
      "26:6320" : "26:6320 (26:6320 Notice and Hearing Upon Filing of Notice of Lien)",
      "26:6502" : "26:6502 (26:6502 IRS:Enforcement of tax liens)",
      "26:6532" : "26:6532 (26:6532 IRS: Refund of Tax Penalty)",
      "26:6702" : "26:6702 (26:6702 IRS: Refund of Income Tax Penalty)",
      "26:6703" : "26:6703 (26:6703 IRS: Refund of Tax Penalty)",
      "26:7401" : "26:7401 (26:7401 IRS: Tax Liability)",
      "26:7402" : "26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)",
      "26:7403" : "26:7403 (26:7403 Suit to Enforce Federal Tax Lien)",
      "26:7405" : "26:7405 (26:7405 Recovery of Erroneous Refund)",
      "26:7422rt" : "26:7422rt (26:7422 IRS: Refund Taxes)",
      "26:7422rx" : "26:7422rx (26:7422 IRS: Refund Excise Tax)",
      "26:7426" : "26:7426 (26:7426 IRS: Wrongful Levy for Taxes)",
      "26:7429" : "26:7429 (26:7429 IRS: Tax Jeopardy Assessment)",
      "26:7433" : "26:7433 (26:7433 IRS: Unauthorized Collection Action)",
      "26:7609" : "26:7609 (26:7609 IRS: Petition to Quash IRS Summons)",
      "27:0185" : "27:0185 (27:185 Enforcement of Arbitration Award)",
      "28:0157c" : "28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)",
      "28:0157d" : "28:0157d (28:0157 Motion for Withdrawal of Reference)",
      "28:0158" : "28:0158 (28:0158 Notice of Appeal re Bankruptcy Matter (BA)",
      "28:0185" : "28:0185 (28:185 Suit to Compel Arbitration)",
      "28:0451" : "28:0451 (28:451 Employment Discrimination)",
      "28:0794" : "28:0794 (28:794 Rehabilitation Act)",
      "28:1001" : "28:1001 (28:1001 E.R.I.S.A.)",
      "28:1132" : "28:1132 (28:1132 E.R.I.S.A.)",
      "28:1330" : "28:1330 (28:1330 Breach of Contract)",
      "28:1331" : "28:1331 (28:1331 Fed. Question)",
      "28:1331al" : "28:1331al (28:1331 Fed. Question: Airline Crash)",
      "28:1331at" : "28:1331at (28:1331 Fed. Question: Anti-trust)",
      "28:1331au" : "28:1331au (28:1331 Fed. Question: Auto Negligence)",
      "28:1331b" : "28:1331b (28:1331 Federal Question: Bivens Act)",
      "28:1331bc" : "28:1331bc (28:1331 Fed. Question: Breach of Contract)",
      "28:1331ca" : "28:1331ca (28:1331 Fed Question: Fed Communications Act of 1)",
      "28:1331cm" : "28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)",
      "28:1331cv" : "28:1331cv (28:1331 Federal Question: Other Civil Rights)",
      "28:1331ed" : "28:1331ed (28:1331 Fed. Question: Employment Discrimination)",
      "28:1331es" : "28:1331es (28:1331 Enforcement of Administrative Subpoena)",
      "28:1331fl" : "28:1331fl (28:1331 Fed. Question: Fair Labor Standards)",
      "28:1331in" : "28:1331in (28:1331 Fed. Question: Insurance Contract)",
      "28:1331mm" : "28:1331mm (28:1331 Fed. Question: Medical Malpractice)",
      "28:1331pi" : "28:1331pi (28:1331 Fed. Question: Personal Injury)",
      "28:1331rd" : "28:1331rd (28:1331 Fed. Question: Review Agency Decision)",
      "28:1331rp" : "28:1331rp (28:1331(a) Fed. Question: Real Property)",
      "28:1331rr" : "28:1331rr (28:1331 Fed. Question: Railway Labor Act)",
      "28:1331sv" : "28:1331sv (28:1331 Fed. Question: Securities Violation)",
      "28:1331tr" : "28:1331tr (28:1331 Fed. Question: Trademark)",
      "28:1331tt" : "28:1331tt (28:1331 Fed. Question: Tort Action)",
      "28:1331v" : "28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendme)",
      "28:1331wl" : "28:1331wl (28:1331 Federal Question: EPA Waste Lien)",
      "28:1331wt" : "28:1331wt (28:1331 Fed. Question: Water Rights)",
      "28:1332ac" : "28:1332ac (28:1332 Diversity-Account Receivable)",
      "28:1332al" : "28:1332al (28:1332 Diversity-Airline Crash)",
      "28:1332as" : "28:1332as (28:1332 Diversity-Asbestos Litigation)",
      "28:1332au" : "28:1332au (28:1332 Diversity-Auto Negligence)",
      "28:1332bc" : "28:1332bc (28:1332 Diversity-Breach of Contract)",
      "28:1332co" : "28:1332co (28:1332 Diversity-Conversion)",
      "28:1332ct" : "28:1332ct (28:1332 Diversity-(Citizenship))",
      "28:1332det" : "28:1332det (28:1332 Diversity: Forcible Detainer)",
      "28:1332df" : "28:1332df (28:1332 Diversity-Contract Default)",
      "28:1332ds" : "28:1332ds (28:1332 Diversity-Contract Dispute)",
      "28:1332ed" : "28:1332ed (28:1332 Diversity-Employment Discrimination)",
      "28:1332fd" : "28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)",
      "28:1332fr" : "28:1332fr (28:1332 Diversity-Fraud)",
      "28:1332ia" : "28:1332ia (28:1332 Diversity-Interpleader Action)",
      "28:1332ij" : "28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)",
      "28:1332in" : "28:1332in (28:1332 Diversity-Insurance Contract)",
      "28:1332jd" : "28:1332jd (28:1332 Diversity-Declaratory Judgement)",
      "28:1332lb" : "28:1332lb (28:1332 Diversity-Libel,Assault,Slander)",
      "28:1332lm" : "28:1332lm (28:1332 Diversity - Legal Malpractice)",
      "28:1332ma" : "28:1332ma (28:1332 Diversity-Miller Act)",
      "28:1332mm" : "28:1332mm (28:1332 Diversity-Medical Malpractice)",
      "28:1332mv" : "28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)",
      "28:1332ni" : "28:1332ni (28:1332 Diversity-Negotiable Instrument)",
      "28:1332nm" : "28:1332nm (28:1332 Diversity-Non-Motor Vehicle)",
      "28:1332oc" : "28:1332oc (28:1332 Diversity-Other Contract)",
      "28:1332pd" : "28:1332pd (28:1332 Diversity-Property Damage)",
      "28:1332pi" : "28:1332pi (28:1332 Diversity-Personal Injury)",
      "28:1332pl" : "28:1332pl (28:1332 Diversity-Product Liability)",
      "28:1332pr" : "28:1332pr (28:1332 Diversity-Petition for Removal)",
      "28:1332qt" : "28:1332qt (28:1332 Diversity-Petition to Quiet Title)",
      "28:1332ri" : "28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)",
      "28:1332sa" : "28:1332sa (28:1332 - Diversity: Securities & Exchange Commiss)",
      "28:1332sf" : "28:1332sf (28:1332 - Diversity: Securities Fraud)",
      "28:1332ss" : "28:1332ss (28:1332 Diversity - Stockholders Suits)",
      "28:1332tl" : "28:1332tl (28:1332 Diversity-Torts to Land)",
      "28:1332tm" : "28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))",
      "28:1332tn" : "28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)",
      "28:1332wd" : "28:1332wd (28:1332 Diversity-Wrongful Death)",
      "28:1333" : "28:1333 (28:1333 Admiralty)",
      "28:1334" : "28:1334 (28:1334 Bankruptcy Appeal)",
      "28:1334c" : "28:1334c (28:1334(c) R&R re motions for abstention (non-cor)",
      "28:1335" : "28:1335 (28:1335 Interpleader Action)",
      "28:1337" : "28:1337 (28:1337 Sherman-Clayton Act)",
      "28:1338cp" : "28:1338cp (28:1338 Copyright Infringement)",
      "28:1338pt" : "28:1338pt (28:1338 Patent Infringement)",
      "28:1338tr" : "28:1338tr (28:1338 Trademark Infringement)",
      "28:1339" : "28:1339 (28:1339 Postal Matters)",
      "28:1340" : "28:1340 (28:1340 IRS: Custom Duties)",
      "28:1340er" : "28:1340er (28:1340 Recovery of Erroneous Refund)",
      "28:1341" : "28:1341 (28:1341 Complaint for Forfeiture)",
      "28:1343" : "28:1343 (28:1343 Violation of Civil Rights)",
      "28:1345co" : "28:1345co (28:1345 Replevin & Conversion)",
      "28:1345db" : "28:1345db (28:1345 Debt to US - FHA/HUD Title I)",
      "28:1345df" : "28:1345df (28:1345 Default of Promissory Note)",
      "28:1345er" : "28:1345er (28:1345 Recovery of Erroneous Refund)",
      "28:1345fc" : "28:1345fc (28:1345 Foreclosure)",
      "28:1345ff" : "28:1345ff (28:1345 Complaint for Forfeiture)",
      "28:1345hl" : "28:1345hl (28:1345 VA Home Loan Guaranty Debt)",
      "28:1345mc" : "28:1345mc (28:1345 Medical Care Recovery)",
      "28:1345mi" : "28:1345mi (28:1345 Mining Claim Ejectment)",
      "28:1345pd" : "28:1345pd (28:1345 Property Damage)",
      "28:1345pe" : "28:1345pe (28:1345 Property Ejectment)",
      "28:1345rc" : "28:1345rc (28:1345 Recovery of Debt to US)",
      "28:1345st" : "28:1345st (28:1345 Default of Student Loan)",
      "28:1345tp" : "28:1345tp (28:1345 Trespass on Public Land)",
      "28:1345va" : "28:1345va (28:1345 Recovery of VA Overpayment)",
      "28:1346bc" : "28:1346bc (28:1346 Breach of Contract)",
      "28:1346rc" : "28:1346rc (28:1346 Recovery of IRS Tax)",
      "28:1346tc" : "28:1346tc (28:1346 Tort Claim)",
      "28:1346wd" : "28:1346wd (28:1346 Wrongful Death)",
      "28:1352" : "28:1352 (28:1352 Miller Act)",
      "28:1355" : "28:1355 (28:1355 Petition for Return of Property)",
      "28:1358" : "28:1358 (28:1358 Land Condemnation)",
      "28:1361" : "28:1361 (28:1361 Petition for Writ of Mandamus)",
      "28:1362ic" : "28:1362ic (28:1362 Indian Tribal Controversy)",
      "28:1362iw" : "28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)",
      "28:1364" : "28:1364 (28:1364 Auto Negligence)",
      "28:1391" : "28:1391 (28:1391 Personal Injury)",
      "28:1402" : "28:1402 (28:1402 Medical Malpractice)",
      "28:1407" : "28:1407 (28:1407 Multi-District Litigation)",
      "28:1441ac" : "28:1441ac (28:1441 Petition for Removal- Account Receivable)",
      "28:1441al" : "28:1441al (28:1441 Petition for Removal- Airline Crash)",
      "28:1441as" : "28:1441as (28:1441 Petition for Removal- Asbestos Litigation)",
      "28:1441au" : "28:1441au (28:1441 Petition for Removal- Auto Negligence)",
      "28:1441bc" : "28:1441bc (28:1441 Petition for Removal- Breach of Contract)",
      "28:1441cv" : "28:1441cv (28:1441 Petition for Removal- Civil Rights Act)",
      "28:1441df" : "28:1441df (28:1441 Petition for Removal- Contract Default)",
      "28:1441dj" : "28:1441dj (28:1441 Petition for Removal- Declaratory Judgemen)",
      "28:1441ds" : "28:1441ds (28:1441 Petition for Removal- Contract Dispute)",
      "28:1441ed" : "28:1441ed (28:1441 Petition for Removal - Employment Discrim)",
      "28:1441fc" : "28:1441fc (28:1441 Petition for Removal - Fair Credit Reporti)",
      "28:1441fr" : "28:1441fr (28:1441 Petition for Removal- Fraud)",
      "28:1441ij" : "28:1441ij (28:1441 Petition for Removal- Injunctive/Declarato)",
      "28:1441in" : "28:1441in (28:1441 Petition for Removal- Insurance Contract)",
      "28:1441int" : "28:1441int (28:1441 Petition for Removal- Action for Interplea)",
      "28:1441lb" : "28:1441lb (28:1441 Petition for Removal Libel,Assault,Slander)",
      "28:1441lm" : "28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relatio)",
      "28:1441mm" : "28:1441mm (28:1441 Petition for Removal- Medical Malpractice)",
      "28:1441ni" : "28:1441ni (28:1441 Petition for Removal- Negotiable Instrumen)",
      "28:1441nm" : "28:1441nm (28:1441 Petition for Removal- Non-Motor Vehicle)",
      "28:1441oc" : "28:1441oc (28:1441 Petition For Removal--Other Contract)",
      "28:1441pd" : "28:1441pd (28:1441 Petition for Removal- Property Damage)",
      "28:1441pi" : "28:1441pi (28:1441 Petition for Removal- Personal Injury)",
      "28:1441pl" : "28:1441pl (28:1441 Petition for Removal- Product Liability)",
      "28:1441pr" : "28:1441pr (28:1441 Petition for Removal)",
      "28:1441qt" : "28:1441qt (28:1441 Petition for Removal- Petition to Quiet Ti)",
      "28:1441ri" : "28:1441ri (28:1441 Petition for Removal- Racketeering (RICO))",
      "28:1441sa" : "28:1441sa (28:1441 - Petition for Removal: SEC Act)",
      "28:1441sf" : "28:1441sf (28:1441 - Petition for Removal: Securities Fraud)",
      "28:1441tl" : "28:1441tl (28:1441 Petition for Removal- Torts to Land)",
      "28:1441tm" : "28:1441tm (28:1441 Petition for Removal- Tort/Motor Vehicle ()",
      "28:1441tn" : "28:1441tn (28:1441 Petition for Removal- Tort/Non-Motor Vehic)",
      "28:1441wd" : "28:1441wd (28:1441 Petition for Removal- Wrongful Death)",
      "28:1442bc" : "28:1442bc (28:1442 Petition for Removal- Breach of Contract)",
      "28:1442pr" : "28:1442pr (28:1442 Petition for Removal)",
      "28:1443" : "28:1443 (28:1443(1) Rent, Lease & Ejectment)",
      "28:1444" : "28:1444 (28:1444 Petition for Removal- Foreclosure)",
      "28:1446in" : "28:1446in (28:1446 Breach of Contract- Insurance)",
      "28:1446pd" : "28:1446pd (28:1446 Petition for Removal- Property Damage (P.I)",
      "28:1446pi" : "28:1446pi (28:1446 Petition for Removal- Personal Injury)",
      "28:1446pl" : "28:1446pl (28:1446pl Petition for Removal - Product Liability)",
      "28:1446pr" : "28:1446pr (28:1446 Petition for Removal)",
      "28:1452" : "28:1452 (28:1452 R&R re motions to remand (non-core))",
      "28:1651" : "28:1651 (28:1651 Petition for Writ of Coram Nobis)",
      "28:1651hc" : "28:1651hc (28:1651 Petition for Writ of Habeas Corpus)",
      "28:1651mn" : "28:1651mn (28:1651 Petition for Writ of Mandamus)",
      "28:1875" : "28:1875 (28:1875 Protection of Jurors Employment)",
      "28:1983" : "28:1983 (28:1983 Civil Rights)",
      "28:2201" : "28:2201 (28:2201 Constitutionality of State Statute(s))",
      "28:2201dj" : "28:2201dj (28:2201 Declaratory Judgement)",
      "28:2201ij" : "28:2201ij (28:2201 Injunction)",
      "28:2201in" : "28:2201in (28:2201 Declaratory Judgement (Insurance))",
      "28:2241" : "28:2241 (28:2241 Petition for Writ of Habeas Corpus (federa)",
      "28:2254" : "28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))",
      "28:2254se" : "28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)",
      "28:2255" : "28:2255 (28:2255 Motion to Vacate / Correct Illegal Sentenc)",
      "28:2271" : "28:2271 (28:2271 Federal Tort Claims Act)",
      "28:2345" : "28:2345 (28:2345 Medicare Recovery)",
      "28:2409" : "28:2409 (28:2409(a) Quiet Title Action)",
      "28:2410" : "28:2410 (28:2410 Quiet Title)",
      "28:2671" : "28:2671 (28:2671 Federal Tort Claims Act)",
      "28:2674" : "28:2674 (28:2674 Federal Tort Claims Act)",
      "28:7402" : "28:7402 (28:7402 Refund of Taxes)",
      "28:7422" : "28:7422 (28:7422 Appeal from Administrative Decision)",
      "28:875" : "28:875 (28:0875 Protection of Jurors Employment)",
      "29:0141" : "29:0141 (29:141 Labor Management Relations Act)",
      "29:0151" : "29:0151 (29:151 Labor: Review of Agency Action)",
      "29:0160" : "29:0160 (29:160(1) National Labor Relations Act)",
      "29:0184" : "29:0184 (29:184 Violation Collection Bargain Agreement)",
      "29:0185ep" : "29:0185ep (29:185 Employee Pension Plan)",
      "29:0185lm" : "29:0185lm (29:185 Labor/Mgt. Relations (Contracts))",
      "29:0201do" : "29:0201do (29:201 Denial of Overtime Compensation)",
      "29:0201fl" : "29:0201fl (29:201 Fair Labor Standards Act)",
      "29:0203" : "29:0203 (29:203 Equal Pay Act)",
      "29:0206" : "29:0206 (29:206 Collect Unpaid Wages)",
      "29:0401" : "29:0401 (29:0401 Labor Management Disclosure Act)",
      "29:0621" : "29:0621 (29:621 Job Discrimination (Age))",
      "29:0623" : "29:0623 (29:623 Job Discrimination (Age))",
      "29:0626" : "29:0626 (29:626 Job Discrimination (Age))",
      "29:0633" : "29:0633 (29:633 Job Discrimination (Age))",
      "29:0651" : "29:0651 (29:651 Occupational Safety/Health)",
      "29:0660" : "29:0660 (29:0660 Occupational Safety and Health Act)",
      "29:0754" : "29:0754 (29:754 Discrimination)",
      "29:0791" : "29:0791 (29:791 Job Discrimination (Rehabilitation Act))",
      "29:0794" : "29:0794 (29:0794 Job Discrimination (Handicap))",
      "29:1001" : "29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)",
      "29:1002" : "29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)",
      "29:1104" : "29:1104 (29:1104 Recovery of Benefits to Employee)",
      "29:1109" : "29:1109 (29:1109 Breach of Fiduciary Duties)",
      "29:1131" : "29:1131 (29:1131 ERISA - Collection of Delinquent Trust Fun)",
      "29:1132" : "29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)",
      "29:1145" : "29:1145 (29:1145 E.R.I.S.A.)",
      "29:1149" : "29:1149 (29:1149 Recover Pension & Profit Sharing)",
      "29:1337" : "29:1337 (29:1337 E.R.I.S.A.)",
      "29:1362" : "29:1362 (29:1362 ERISA)",
      "29:1381" : "29:1381 (29:1381 E.R.I.S.A.)",
      "29:1401" : "29:1401 (29:1401(b)(2) Appeal of Arbitration Award)",
      "29:1451" : "29:1451 (29:1451 E.R.I.S.A.)",
      "29:1801" : "29:1801 (29:1801 Farmworker Rights)",
      "29:2101" : "29:2101 (29:2101 Worker Adjustment Retraining Notification (WARN))",
      "29:2601" : "29:2601 (29:2601 Family Medical Leave Act)",
      "29:2617" : "29:2617 (29:2617(a)(2) Family and Medical Leave Act)",
      "29:790" : "29:790 (29:790 Rehabilitation of Labor)",
      "30:0181" : "30:0181 (30:181 Environment: Review of Agency Action)",
      "30:0801" : "30:0801 (30:0801 Penalities/Federal Mine Safety Health Act)",
      "30:1201" : "30:1201 (30:1201 Environment: Review of Agency Action)",
      "30:1202" : "30:1202 (30:1202 Mining Reclamation Act)",
      "30:1276" : "30:1276 (30:1276 Interior: Review of Agency Action)",
      "31:3545" : "31:3545 (31:3545 Action to Recovery Money)",
      "31:3729" : "31:3729 (31:3729 False Claims Act)",
      "31:3730" : "31:3730 (31:3730 Civil Actions for False Claims)",
      "31:3731" : "31:3731 (31:3731 Fraud)",
      "31:3801" : "31:3801 (31:3801 Program Fraud Civil Remedies Act)",
      "33:1319cw" : "33:1319cw (33:1319 Clean Water Act)",
      "33:1319pv" : "33:1319pv (33:1319 Pollutants & Permit Violations)",
      "33:1365" : "33:1365 (33:1365 Environmental Matters)",
      "35:0145" : "35:0145 (35:145 Patent Infringement)",
      "35:0183" : "35:0183 (35:183 Patent Infringement)",
      "35:0271" : "35:0271 (35:271 Patent Infringement)",
      "38:1681" : "38:1681 (38:1681 Recovery of VA Overpayment)",
      "38:1686" : "38:1686 (38:1686 Recovery of VA Overpayment)",
      "38:1780" : "38:1780 (38:1780 Recovery of VA Overpayment)",
      "38:2011" : "38:2011 (38:2011 - Veteran's Readjustment Assistance Act of)",
      "38:3116" : "38:3116 (38:3116 VA Overpayment)",
      "38:4301" : "38:4301 (38:4301Federal Uniformed Services Employment/Re-Employment Act)",
      "38:4323" : "38:4323 (38:4323 Enforcement of employer rights)",
      "39:3005" : "39:3005 (39:3005 Detention of Mail for Temporary Periods)",
      "39:409" : "39:409 (39:409 Postal Service)",
      "40:0258" : "40:0258 (40:258(a) Public Buildings & Property: Land Condem)",
      "40:0270" : "40:0270 (40:270 Miller Act)",
      "40:0875" : "40:0875 (40:875 Public Buildings & Property: Negligence)",
      "41:0251" : "41:0251 (41:251 Public Contracts-Review of Agency Action)",
      "41:1463" : "41:1463 (41:1463 Public Contracts: Unlawful Employment Prac)",
      "42:0205" : "42:0205 (42:205 Denial Social Security Benefits)",
      "42:0206" : "42:0206 (42:206 Social Security Benefits)",
      "42:0247" : "42:0247 (42:247 Personal Injury-Swine Flu)",
      "42:0402" : "42:0402 (42:402 Social Security Benefits)",
      "42:0405id" : "42:0405id (42:405 Review of HHS Decision (SSID))",
      "42:0405wc" : "42:0405wc (42:405 Review of HHS Decision (DIWC))",
      "42:0405ww" : "42:0405ww (42:405 Review of HHS Decision (DIWW))",
      "42:0416" : "42:0416 (42:416 Denial of Social Security Benefits)",
      "42:0427" : "42:0427 (42:427 Social Security Benefits)",
      "42:11603" : "42:11603 (42:11603 International Child Abduction Remedies Act)",
      "42:12101" : "42:12101 (42:12101 Americans with Disabilities Act)",
      "42:12131" : "42:12131 (42:12131 Civil Disabilities Act)",
      "42:1383" : "42:1383 (42:1383 Review of HHS Decision)",
      "42:1395" : "42:1395 (42:1395 HHS: Adverse Reimbursement Review)",
      "42:1396" : "42:1396 (42:1396 - Tort Negligence)",
      "42:13981" : "42:13981 (42:13981 Violence Against Women Act (VAWA))",
      "42:1471" : "42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclo)",
      "42:1981cv" : "42:1981cv (42:1981 Civil Rights)",
      "42:1981hs" : "42:1981hs (42:1981 Housing Discrimination)",
      "42:1981jb" : "42:1981jb (42:1981 Job Discrimination (Race))",
      "42:1981sh" : "42:1981sh (42:1981 Sexual Harrassment)",
      "42:1981sx" : "42:1981sx (42:1981 Sex Discrimination)",
      "42:1983cv" : "42:1983cv (42:1983 Civil Rights Act)",
      "42:1983ed" : "42:1983ed (42:1983 Civil Rights (Employment Discrimination))",
      "42:1983pr" : "42:1983pr (42:1983 Prisoner Civil Rights)",
      "42:1986" : "42:1986 (42:1986 Neglect of Duty)",
      "42:2000ag" : "42:2000ag (42:2000 Job Discrimination (Age))",
      "42:2000cc" : "42:2000cc (42:2000 Protection of Land Use as Religious Exercise)",
      "42:2000e" : "42:2000e (42:2000e Job Discrimination (Employment))",
      "42:2000pb" : "42:2000pb (42:2000 Job Discrimination (Public Accomodations))",
      "42:2000ra" : "42:2000ra (42:2000 Job Discrimination (Race))",
      "42:2000sx" : "42:2000sx (42:2000 Job Discrimination (Sex))",
      "42:2003" : "42:2003 (42:2003 Job Discrimination)",
      "42:2005" : "42:2005 (42:2005 Review of Agency Action-HHS)",
      "42:2651" : "42:2651 (42:2651 Medical Care Recovery)",
      "42:3601" : "42:3601 (42:405 Fair Housing Act)",
      "42:4000" : "42:4000 (42:4000 National Flood Insurance Act)",
      "42:4001" : "42:4001 (42:4001 National Insurance Flood Act)",
      "42:4053" : "42:4053 (42:4053 Breach of Insurance Contract)",
      "42:4072" : "42:4072 (42:4072 Payment of Flood Insurance Claim)",
      "42:425" : "42:425 (42:427 Social Security Benenfits)",
      "42:4321" : "42:4321 (42:4321 Review of Agency Action-Environment)",
      "42:4332" : "42:4332 (42:4332 Environmental Policy - Coop of Agency Repo)",
      "42:4852d" : "42:4852d (42:4852d Disclosure of Information Concerning Lead)",
      "42:6901en" : "42:6901en (42:6901 Environmental Cleanup Expenses)",
      "42:6901rs" : "42:6901rs (42:6901 Resource & Recovery Act)",
      "42:7413" : "42:7413 (42:7413(b) Clean Air Act)",
      "42:7604cl" : "42:7604cl (42:7604 Clear Air Act (Emission Standards))",
      "42:7604ir" : "42:7604ir (42:7604 Petition to Quash IRS Summons)",
      "42:9601" : "42:9601 (42:9601 Environmental Cleanup)",
      "42:9607" : "42:9607 (42:9607 Real Property Tort to Land)",
      "43:945" : "43:945 (43:945 Compensation for Land Condemnation)",
      "43:945a" : "43:945a (43:945a Complaint in Condemnation)",
      "43:946" : "43:946 (43:946 Complaint in Condemnation - Eminent Domain)",
      "45:0051" : "45:0051 (45:51 Railways: Fed. Employer's Liability Act)",
      "45:0151" : "45:0151 (45:151 Railway Labor Act)",
      "45:0184" : "45:0184 (45:184 Action to Set Aside Award of a System Board)",
      "45:1395" : "45:1395 (45:1395 Railroads: Adverse Reimbursement Review)",
      "45:7457" : "45:7457 (45:7457 Compel Reclamation Under Clear Air Act)",
      "46:0688" : "46:0688 (46:688 Jones Act)",
      "46:0741" : "46:0741 (46:741 Shipping)",
      "46:0761" : "46:0761 (46:761 Shipping: Damages for Death on High Seas)",
      "46:1101" : "46:1101 (46:1101 Violation of Maritime Regulations)",
      "46:1156" : "46:1156 (46:1156 Administrative Procedure Act)",
      "47:0151" : "47:0151 (47:0151 Communications Act of 1934)",
      "47:0227" : "47:0227 (47:0227 Telephone Consumer Protection Act)",
      "47:0332" : "47:0332 (47:0332 Mobile Services)",
      "48:0883" : "48:0883 (48:883 Violation of US Coastal Law)",
      "48:1985" : "48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)",
      "49:0081" : "49:0081 (49:81 Damaged Goods While Being Transported)",
      "49:0781" : "49:0781 (49:781 Forfeiture)",
      "49:10101" : "49:10101 (49:10101 Interstate Commerce Act)",
      "49:11503" : "49:11503 (49:11503 Railroad Revitalization Regulatory Reform)",
      "49:11702" : "49:11702 (49:11702(a)(4) Violations of Interstate Commerce A)",
      "49:1471" : "49:1471 (49:1471 Federal Aviation Act)",
      "49:1903" : "49:1903 (49:1903 Petition to enforce administrative summon)",
      "49:3102" : "49:3102 (49:3102 Motor Carrier Safety Requirements)",
      "8:287" : "8:287 (8:287 Petition to Enforce INS Subpoena)",
      "misc" : "misc (Civil Miscellaneous Case)"
   },
   "kyedce" : {
      "0" : "0 (No cause code entered)",
      "02:0431" : "02:0431 (02:431 Fed. Election Commission: Failure Enforce C)",
      "02:0437" : "02:0437 (02:437 Federal Election Commission)",
      "05:0075" : "05:0075 (05:75(2) Contract - Reduction in Grade)",
      "05:0551" : "05:0551 (05:551 Administrative Procedure Act)",
      "05:0552fi" : "05:0552fi (05:552 Freedom of Information Act)",
      "05:0552pa" : "05:0552pa (05:552 Right to Privacy Act)",
      "05:0554" : "05:0554 (05:0554 Constitutionality of Maritime Statutes)",
      "05:0701" : "05:0701 (05:0701 Maritime Subsidy Board)",
      "05:0702" : "05:0702 (05:702 Administrative Procedure Act)",
      "05:0704" : "05:0704 (05:704 Labor Litigation)",
      "05:7703" : "05:7703 (05:7703 Discrimination - Review of Agency Act)",
      "07:0006" : "07:0006 (7:6(b) Federal Commodity Exchange Regulation)",
      "07:0025" : "07:0025 (7:25 Fraud - Commodities Leverage Contracts)",
      "07:0181" : "07:0181 (07:181 Packers & Stockyard Act)",
      "07:0499" : "07:0499 (07:499 Agricultural Commodities Act)",
      "07:0601" : "07:0601 (07:601 USDA Condemnation)",
      "07:2321" : "07:2321 (07:2321 Plant Variety Protection Act)",
      "08:1105" : "08:1105 (8:1105(a) Aliens: Habeas Corpus to Release INS Det)",
      "08:1252" : "08:1252 (08:1252(a)(2) Injunction for Deportation)",
      "08:1260" : "08:1260 (08:1260 Aliens: Access to Records)",
      "08:1324" : "08:1324 (08:1324 Aliens: Complaint for Forfeiture)",
      "08:1329" : "08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petiti)",
      "08:1446" : "08:1446 (8:1446 Petition for Naturalization Hearing)",
      "09:0001" : "09:0001 (09:1 U.S. Arbitration Act)",
      "09:0009" : "09:0009 (9:9 Motion to Confirm Arbitration Loan)",
      "09:0010" : "09:0010 (09:0010 Petition to Vacate Arbitration Award)",
      "10:1552" : "10:1552 (10:1552 Armed Forces: Action to Correct Records)",
      "10:1553" : "10:1553 (10:1553 Armed Forces: FOIA General)",
      "10:2305" : "10:2305 (10:2305 Review of Federal Contract)",
      "11:0101" : "11:0101 (11:101 Bankruptcy)",
      "12:0022" : "12:0022 (12:22 Securities Fraud)",
      "12:0635" : "12:0635 (12:635 Breach of Insurance Contract)",
      "12:1461" : "12:1461 (12:1461 Homeowners Loan Act)",
      "12:1703" : "12:1703 (12:1703 Default of HUD Loan)",
      "12:1725" : "12:1725 (12:1725 Collection under Contract Guaranty)",
      "12:1730" : "12:1730 (12:1730 Collection Under Contract Guaranty)",
      "12:1819" : "12:1819 (12:1819 Default of Promissory Note)",
      "12:1821" : "12:1821 (12:1821 Default of Loan by Promissary Note)",
      "12:1971" : "12:1971 (12:1971 Relief under Bank Holding Act)",
      "12:3410" : "12:3410 (12:3410 Right to Financial Privacy Act)",
      "15:0001" : "15:0001 (15:1 Antitrust Litigation)",
      "15:0002at" : "15:0002at (15:2 Antitrust Litigation)",
      "15:0002fl" : "15:0002fl (15:2(a) Fair Labor Standards Act)",
      "15:0005" : "15:0005 (15:5(a) Fair Labor Standards Act)",
      "15:0015" : "15:0015 (15:15 Antitrust Litigation)",
      "15:0025" : "15:0025 (15:25 Clayton Act)",
      "15:0044" : "15:0044 (15:44 Trademark Infringement)",
      "15:0045" : "15:0045 (15:0045 Federal Trade Commission Act)",
      "15:0052" : "15:0052 (15:0052 Federal Trade Commission Act)",
      "15:0053" : "15:0053 (15:0053 Federal Trade Commission Act)",
      "15:0077" : "15:0077 (15:77 Securities Fraud)",
      "15:0078" : "15:0078 (15:78m(a) Securities Exchange Act)",
      "15:0631" : "15:0631 (15:631 Small Business Act)",
      "15:0717" : "15:0717 (15:717 Natural Gas Act)",
      "15:1051" : "15:1051 (15:1051 Trademark Infringement)",
      "15:1114" : "15:1114 (15:1114 Trademark Infringement)",
      "15:1121" : "15:1121 (15:1121 Trademark Infringement)",
      "15:1125" : "15:1125 (15:1125 Trademark Infringement (Lanham Act))",
      "15:1126" : "15:1126 (15:1126 Patent Infringement)",
      "15:1127" : "15:1127 (15:1127 Trademark Infringement)",
      "15:1601" : "15:1601 (15:1601 Truth in Lending)",
      "15:1640" : "15:1640 (15:1640 Truth in Lending)",
      "15:1681" : "15:1681 (15:1681 Fair Credit Reporting Act)",
      "15:1692" : "15:1692 (15:1692 Fair Debt Collection Act)",
      "15:1938" : "15:1938 (15:1938 Fair Labor Standards Act)",
      "15:1981" : "15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))",
      "15:1988" : "15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))",
      "15:1989" : "15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))",
      "15:2301" : "15:2301 (15:2301 Magnuson-Moss Warranty Act)",
      "15:2801" : "15:2801 (15:2801 Petroleum Marketing Practices Act)",
      "15:53(b)" : "15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equita)",
      "16:0668" : "16:0668 (16:668 Bald Eagle Protection Act)",
      "16:0703" : "16:0703 (16:703 Migratory Bird Act)",
      "16:1538" : "16:1538 (16:1538 Endangered Species Act)",
      "16:3371" : "16:3371 (16:3371 Wildlife Under the Lacey Act)",
      "16:3372" : "16:3372 (16:3372 Conservation: Complaint for Forfeiture)",
      "16:3373" : "16:3373 (16:3373 Appeal of Decision - DOI)",
      "16:3374" : "16:3374 (16:3374 Conservation: Complaint for Forfeiture)",
      "17:0101" : "17:0101 (17:101 Copyright Infringement)",
      "17:0501" : "17:0501 (17:501 Copyright Infringement)",
      "17:0504" : "17:0504 (17:504 Copyright Infringement)",
      "18:0241" : "18:0241 (18:241 Conspiracy Against Citizen Rights)",
      "18:1836a" : "18:1836a (18:1836(a) Injunction against Misappropriation of Trade Secrets)",
      "18:1836b" : "18:1836b (18:1836(b) Civil Action to Protect Trade Secrets)",
      "18:1961" : "18:1961 (18:1961 Racketeering (RICO) Act)",
      "18:1962" : "18:1962 (18:1962 Racketeering (RICO) Act)",
      "18:1964" : "18:1964 (18:1964 Racketeering (RICO) Act)",
      "18:4208" : "18:4208 (18:4208(B) Agency Action Review)",
      "18:4245" : "18:4245 (18:4245 Petition to Determine Mental Cond. of Impris..Person)",
      "19:1305" : "19:1305 (19:1305 Custom Duties:0Forfeiture-Immoral Articles)",
      "20:1080" : "20:1080 (20:1080 Student Loan Recovery)",
      "20:1400" : "20:1400 (20:1400 Civil Rights of Handicapped Child)",
      "20:1401" : "20:1401 (20:1401 Education: Handicapped Child Act)",
      "20:1681" : "20:1681 (20:1681 Title IX Educational Amendments 1992 - Sex Discrimination)",
      "20:1683" : "20:1683 (20:1683 Judicial Review: Prohibition against sex discrimination in education)",
      "21:0841" : "21:0841 (21:841 Forfeiture Property-Drugs)",
      "21:0881" : "21:0881 (21:881 Forfeiture Property-Drugs)",
      "21:0881a" : "21:0881a (21:881 Forfeiture Property - Aircraft)",
      "21:0881re" : "21:0881re (21:881 Forfeiture Property - Real Estate)",
      "23:0134" : "23:0134 (23:134 P.I.- Auto Negligence)",
      "23:1441" : "23:1441 (23:1441 Contract Real Estate)",
      "24:1000" : "24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)",
      "25:0640" : "25:0640 (25:640 Indian Tribal Rights)",
      "25:1901" : "25:1901 (25:1901 Indian Child Welfare Act)",
      "26:6212" : "26:6212 (26:6212 Injunctive Relief from IRS Lien)",
      "26:6213" : "26:6213 (26:6213 Injunctive Relief from IRS Lien)",
      "26:6502" : "26:6502 (26:6502 IRS:Enforcement of tax liens)",
      "26:6532" : "26:6532 (26:6532 IRS: Refund of Tax Penalty)",
      "26:6702" : "26:6702 (26:6702 IRS: Refund of Income Tax Penalty)",
      "26:6703" : "26:6703 (26:6703 IRS: Refund of Tax Penalty)",
      "26:7401" : "26:7401 (26:7401 IRS: Tax Liability)",
      "26:7402" : "26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)",
      "26:7403" : "26:7403 (26:7403 Suit to Enforce Federal Tax Lien)",
      "26:7422rt" : "26:7422rt (26:7422 IRS: Refund Taxes)",
      "26:7422rx" : "26:7422rx (26:7422 IRS: Refund Excise Tax)",
      "26:7426" : "26:7426 (26:7426 IRS: Wrongful Levy for Taxes)",
      "26:7429" : "26:7429 (26:7429 IRS: Tax Jeopardy Assessment)",
      "26:7609" : "26:7609 (26:7609 IRS: Petition to Quash IRS Summons)",
      "27:0185" : "27:0185 (27:185 Enforcement of Arbitration Award)",
      "28:0157c" : "28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)",
      "28:0157d" : "28:0157d (28:0157 Motion for Withdrawal of Reference)",
      "28:0158" : "28:0158 (28:0158 Notice of Appeal re Bankruptcy Matter (BA)",
      "28:0185" : "28:0185 (28:185 Suit to Compel Arbitration)",
      "28:0451" : "28:0451 (28:451 Employment Discrimination)",
      "28:0794" : "28:0794 (28:794 Rehabilitation Act)",
      "28:1001" : "28:1001 (28:1001 E.R.I.S.A.)",
      "28:1132" : "28:1132 (28:1132 E.R.I.S.A.)",
      "28:1330" : "28:1330 (28:1330 Breach of Contract)",
      "28:1331" : "28:1331 (28:1331 Fed. Question)",
      "28:1331al" : "28:1331al (28:1331 Fed. Question: Airline Crash)",
      "28:1331at" : "28:1331at (28:1331 Fed. Question: Anti-trust)",
      "28:1331au" : "28:1331au (28:1331 Fed. Question: Auto Negligence)",
      "28:1331b" : "28:1331b (28:1331 Federal Question: Bivens Act)",
      "28:1331bc" : "28:1331bc (28:1331 Fed. Question: Breach of Contract)",
      "28:1331ca" : "28:1331ca (28:1331 Fed Question: Fed Communications Act of 1)",
      "28:1331cm" : "28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)",
      "28:1331cv" : "28:1331cv (28:1331 Federal Question: Other Civil Rights)",
      "28:1331ed" : "28:1331ed (28:1331 Fed. Question: Employment Discrimination)",
      "28:1331es" : "28:1331es (28:1331 Enforcement of Administrative Subpoena)",
      "28:1331fl" : "28:1331fl (28:1331 Fed. Question: Fair Labor Standards)",
      "28:1331in" : "28:1331in (28:1331 Fed. Question: Insurance Contract)",
      "28:1331mm" : "28:1331mm (28:1331 Fed. Question: Medical Malpractice)",
      "28:1331pi" : "28:1331pi (28:1331 Fed. Question: Personal Injury)",
      "28:1331rd" : "28:1331rd (28:1331 Fed. Question: Review Agency Decision)",
      "28:1331rp" : "28:1331rp (28:1331(a) Fed. Question: Real Property)",
      "28:1331rr" : "28:1331rr (28:1331 Fed. Question: Railway Labor Act)",
      "28:1331sv" : "28:1331sv (28:1331 Fed. Question: Securities Violation)",
      "28:1331tr" : "28:1331tr (28:1331 Fed. Question: Trademark)",
      "28:1331tt" : "28:1331tt (28:1331 Fed. Question: Tort Action)",
      "28:1331v" : "28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendme)",
      "28:1331wl" : "28:1331wl (28:1331 Federal Question: EPA Waste Lien)",
      "28:1331wt" : "28:1331wt (28:1331 Fed. Question: Water Rights)",
      "28:1332ac" : "28:1332ac (28:1332 Diversity-Account Receivable)",
      "28:1332al" : "28:1332al (28:1332 Diversity-Airline Crash)",
      "28:1332as" : "28:1332as (28:1332 Diversity-Asbestos Litigation)",
      "28:1332au" : "28:1332au (28:1332 Diversity-Auto Negligence)",
      "28:1332bc" : "28:1332bc (28:1332 Diversity-Breach of Contract)",
      "28:1332co" : "28:1332co (28:1332 Diversity-Conversion)",
      "28:1332ct" : "28:1332ct (28:1332 Diversity-(Citizenship))",
      "28:1332det" : "28:1332det (28:1332 Diversity: Forcible Detainer)",
      "28:1332df" : "28:1332df (28:1332 Diversity-Contract Default)",
      "28:1332ds" : "28:1332ds (28:1332 Diversity-Contract Dispute)",
      "28:1332ed" : "28:1332ed (28:1332 Diversity-Employment Discrimination)",
      "28:1332fd" : "28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)",
      "28:1332fr" : "28:1332fr (28:1332 Diversity-Fraud)",
      "28:1332ia" : "28:1332ia (28:1332 Diversity-Interpleader Action)",
      "28:1332ij" : "28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)",
      "28:1332in" : "28:1332in (28:1332 Diversity-Insurance Contract)",
      "28:1332jd" : "28:1332jd (28:1332 Diversity-Declaratory Judgement)",
      "28:1332lb" : "28:1332lb (28:1332 Diversity-Libel,Assault,Slander)",
      "28:1332lm" : "28:1332lm (28:1332 Diversity - Legal Malpractice)",
      "28:1332ma" : "28:1332ma (28:1332 Diversity-Miller Act)",
      "28:1332mm" : "28:1332mm (28:1332 Diversity-Medical Malpractice)",
      "28:1332mv" : "28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)",
      "28:1332ni" : "28:1332ni (28:1332 Diversity-Negotiable Instrument)",
      "28:1332nm" : "28:1332nm (28:1332 Diversity-Non-Motor Vehicle)",
      "28:1332oc" : "28:1332oc (28:1332 Diversity-Other Contract)",
      "28:1332pd" : "28:1332pd (28:1332 Diversity-Property Damage)",
      "28:1332pi" : "28:1332pi (28:1332 Diversity-Personal Injury)",
      "28:1332pl" : "28:1332pl (28:1332 Diversity-Product Liability)",
      "28:1332pr" : "28:1332pr (28:1332 Diversity-Petition for Removal)",
      "28:1332qt" : "28:1332qt (28:1332 Diversity-Petition to Quiet Title)",
      "28:1332ri" : "28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)",
      "28:1332sa" : "28:1332sa (28:1332 - Diversity: Securities & Exchange Commiss)",
      "28:1332sf" : "28:1332sf (28:1332 - Diversity: Securities Fraud)",
      "28:1332ss" : "28:1332ss (28:1332 Diversity - Stockholders Suits)",
      "28:1332tl" : "28:1332tl (28:1332 Diversity-Torts to Land)",
      "28:1332tm" : "28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))",
      "28:1332tn" : "28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)",
      "28:1332wd" : "28:1332wd (28:1332 Diversity-Wrongful Death)",
      "28:1333" : "28:1333 (28:1333 Admiralty)",
      "28:1334" : "28:1334 (28:1334 Bankruptcy Appeal)",
      "28:1334c" : "28:1334c (28:1334(c) R&R re motions for abstention (non-cor)",
      "28:1335" : "28:1335 (28:1335 Interpleader Action)",
      "28:1337" : "28:1337 (28:1337 Sherman-Clayton Act)",
      "28:1338cp" : "28:1338cp (28:1338 Copyright Infringement)",
      "28:1338pt" : "28:1338pt (28:1338 Patent Infringement)",
      "28:1338tr" : "28:1338tr (28:1338 Trademark Infringement)",
      "28:1340" : "28:1340 (28:1340 IRS: Custom Duties)",
      "28:1340er" : "28:1340er (28:1340 Recovery of Erroneous Refund)",
      "28:1341" : "28:1341 (28:1341 Complaint for Forfeiture)",
      "28:1343" : "28:1343 (28:1343 Violation of Civil Rights)",
      "28:1345co" : "28:1345co (28:1345 Replevin & Conversion)",
      "28:1345db" : "28:1345db (28:1345 Debt to US - FHA/HUD Title I)",
      "28:1345df" : "28:1345df (28:1345 Default of Promissory Note)",
      "28:1345er" : "28:1345er (28:1345 Recovery of Erroneous Refund)",
      "28:1345fc" : "28:1345fc (28:1345 Foreclosure)",
      "28:1345ff" : "28:1345ff (28:1345 Complaint for Forfeiture)",
      "28:1345hl" : "28:1345hl (28:1345 VA Home Loan Guaranty Debt)",
      "28:1345mc" : "28:1345mc (28:1345 Medical Care Recovery)",
      "28:1345mi" : "28:1345mi (28:1345 Mining Claim Ejectment)",
      "28:1345pd" : "28:1345pd (28:1345 Property Damage)",
      "28:1345pe" : "28:1345pe (28:1345 Property Ejectment)",
      "28:1345rc" : "28:1345rc (28:1345 Recovery of Debt to US)",
      "28:1345st" : "28:1345st (28:1345 Default of Student Loan)",
      "28:1345tp" : "28:1345tp (28:1345 Trespass on Public Land)",
      "28:1345va" : "28:1345va (28:1345 Recovery of VA Overpayment)",
      "28:1346bc" : "28:1346bc (28:1346 Breach of Contract)",
      "28:1346rc" : "28:1346rc (28:1346 Recovery of IRS Tax)",
      "28:1346tc" : "28:1346tc (28:1346 Tort Claim)",
      "28:1346wd" : "28:1346wd (28:1346 Wrongful Death)",
      "28:1352" : "28:1352 (28:1352 Miller Act)",
      "28:1355" : "28:1355 (28:1355 Petition for Return of Property)",
      "28:1358" : "28:1358 (28:1358 Land Condemnation)",
      "28:1361" : "28:1361 (28:1361 Petition for Writ of Mandamus)",
      "28:1362ic" : "28:1362ic (28:1362 Indian Tribal Controversy)",
      "28:1362iw" : "28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)",
      "28:1364" : "28:1364 (28:1364 Auto Negligence)",
      "28:1391" : "28:1391 (28:1391 Personal Injury)",
      "28:1402" : "28:1402 (28:1402 Medical Malpractice)",
      "28:1407" : "28:1407 (28:1407 Airline Crash)",
      "28:1441ac" : "28:1441ac (28:1441 Petition for Removal- Account Receivable)",
      "28:1441al" : "28:1441al (28:1441 Petition for Removal- Airline Crash)",
      "28:1441as" : "28:1441as (28:1441 Petition for Removal- Asbestos Litigation)",
      "28:1441au" : "28:1441au (28:1441 Petition for Removal- Auto Negligence)",
      "28:1441bc" : "28:1441bc (28:1441 Petition for Removal- Breach of Contract)",
      "28:1441cv" : "28:1441cv (28:1441 Petition for Removal- Civil Rights Act)",
      "28:1441df" : "28:1441df (28:1441 Petition for Removal- Contract Default)",
      "28:1441dj" : "28:1441dj (28:1441 Petition for Removal- Declaratory Judgemen)",
      "28:1441ds" : "28:1441ds (28:1441 Petition for Removal- Contract Dispute)",
      "28:1441ed" : "28:1441ed (28:1441 Petition for Removal - Employment Discrim)",
      "28:1441fc" : "28:1441fc (28:1441 Petition for Removal - Fair Credit Reporti)",
      "28:1441fr" : "28:1441fr (28:1441 Petition for Removal- Fraud)",
      "28:1441ij" : "28:1441ij (28:1441 Petition for Removal- Injunctive/Declarato)",
      "28:1441in" : "28:1441in (28:1441 Petition for Removal- Insurance Contract)",
      "28:1441int" : "28:1441int (28:1441 Petition for Removal- Action for Interplea)",
      "28:1441lb" : "28:1441lb (28:1441 Petition for Removal Libel,Assault,Slander)",
      "28:1441lm" : "28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relatio)",
      "28:1441mm" : "28:1441mm (28:1441 Petition for Removal- Medical Malpractice)",
      "28:1441ni" : "28:1441ni (28:1441 Petition for Removal- Negotiable Instrumen)",
      "28:1441nm" : "28:1441nm (28:1441 Petition for Removal- Non-Motor Vehicle)",
      "28:1441oc" : "28:1441oc (28:1441 Petition For Removal--Other Contract)",
      "28:1441pd" : "28:1441pd (28:1441 Petition for Removal- Property Damage)",
      "28:1441pi" : "28:1441pi (28:1441 Petition for Removal- Personal Injury)",
      "28:1441pl" : "28:1441pl (28:1441 Petition for Removal- Product Liability)",
      "28:1441pr" : "28:1441pr (28:1441 Petition for Removal)",
      "28:1441qt" : "28:1441qt (28:1441 Petition for Removal- Petition to Quiet Ti)",
      "28:1441ri" : "28:1441ri (28:1441 Petition for Removal- Racketeering (RICO))",
      "28:1441sa" : "28:1441sa (28:1441 - Petition for Removal: SEC Act)",
      "28:1441sf" : "28:1441sf (28:1441 - Petition for Removal: Securities Fraud)",
      "28:1441tl" : "28:1441tl (28:1441 Petition for Removal- Torts to Land)",
      "28:1441tm" : "28:1441tm (28:1441 Petition for Removal- Tort/Motor Vehicle ()",
      "28:1441tn" : "28:1441tn (28:1441 Petition for Removal- Tort/Non-Motor Vehic)",
      "28:1441wd" : "28:1441wd (28:1441 Petition for Removal- Wrongful Death)",
      "28:1442bc" : "28:1442bc (28:1442 Petition for Removal- Breach of Contract)",
      "28:1442pr" : "28:1442pr (28:1442 Petition for Removal)",
      "28:1443" : "28:1443 (28:1443(1) Removal of Criminal Prosecution - Civil Rights)",
      "28:1444" : "28:1444 (28:1444 Petition for Removal- Foreclosure)",
      "28:1446in" : "28:1446in (28:1446 Breach of Contract- Insurance)",
      "28:1446pd" : "28:1446pd (28:1446 Petition for Removal- Property Damage (P.I)",
      "28:1446pi" : "28:1446pi (28:1446 Petition for Removal- Personal Injury)",
      "28:1446pl" : "28:1446pl (28:1446pl Petition for Removal - Product Liability)",
      "28:1446pr" : "28:1446pr (28:1446 Petition for Removal)",
      "28:1452" : "28:1452 (28:1452 R&R re motions to remand (non-core))",
      "28:1651" : "28:1651 (28:1651 Petition for Writ of Coram Nobis)",
      "28:1651hc" : "28:1651hc (28:1651 Petition for Writ of Habeas Corpus)",
      "28:1651mn" : "28:1651mn (28:1651 Petition for Writ of Mandamus)",
      "28:1983" : "28:1983 (28:1983 Civil Rights)",
      "28:2201" : "28:2201 (28:2201 Constitutionality of State Statute(s))",
      "28:2201dj" : "28:2201dj (28:2201 Declaratory Judgment)",
      "28:2201ij" : "28:2201ij (28:2201 Injunction)",
      "28:2201in" : "28:2201in (28:2201 Declaratory Judgment (Insurance))",
      "28:2241" : "28:2241 (28:2241 Petition for Writ of Habeas Corpus (federa)",
      "28:2244" : "28:2244 (Second Petition for Writ of Habeas Corpus )",
      "28:2254" : "28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))",
      "28:2254se" : "28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)",
      "28:2255" : "28:2255 (28:2255 Motion to Vacate / Correct Illegal Sentence)",
      "28:2271" : "28:2271 (28:2271 Federal Tort Claims Act)",
      "28:2345" : "28:2345 (28:2345 Medicare Recovery)",
      "28:2409" : "28:2409 (28:2409(a) Quiet Title Action)",
      "28:2410" : "28:2410 (28:2410 Quiet Title)",
      "28:2462" : "28:2462 (Occupation Safety and Health Act of 1970)",
      "28:2671" : "28:2671 (28:2671 Federal Tort Claims Act)",
      "28:2674" : "28:2674 (28:2674 Federal Tort Claims Act)",
      "28:7402" : "28:7402 (28:7402 Refund of Taxes)",
      "28:7422" : "28:7422 (28:7422 Appeal from Administrative Decision)",
      "29:0151" : "29:0151 (29:151 Labor: Review of Agency Action)",
      "29:0160" : "29:0160 (29:160(1) National Labor Relations Act)",
      "29:0184" : "29:0184 (29:184 Violation Collection Bargain Agreement)",
      "29:0185ep" : "29:0185ep (29:185 Employee Pension Plan)",
      "29:0185lm" : "29:0185lm (29:185 Labor/Mgt. Relations (Contracts))",
      "29:0201do" : "29:0201do (29:201 Denial of Overtime Compensation)",
      "29:0201fl" : "29:0201fl (29:201 Fair Labor Standards Act)",
      "29:0203" : "29:0203 (29:203 Equal Pay Act)",
      "29:0206" : "29:0206 (29:206 Collect Unpaid Wages)",
      "29:0401" : "29:0401 (29:0401 Labor Management Disclosure Act)",
      "29:0621" : "29:0621 (29:621 Job Discrimination (Age))",
      "29:0623" : "29:0623 (29:623 Job Discrimination (Age))",
      "29:0626" : "29:0626 (29:626 Job Discrimination (Age))",
      "29:0633" : "29:0633 (29:633 Job Discrimination (Age))",
      "29:0651" : "29:0651 (29:651 Occupational Safety/Health)",
      "29:0754" : "29:0754 (29:754 Discrimination)",
      "29:0791" : "29:0791 (29:791 Job Discrimination (Rehabilitation Act))",
      "29:0794" : "29:0794 (29:0794 Job Discrimination (Handicap))",
      "29:1001" : "29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)",
      "29:1002" : "29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)",
      "29:1104" : "29:1104 (29:1104 Recovery of Benefits to Employee)",
      "29:1109" : "29:1109 (29:1109 Breach of Fiduciary Duties)",
      "29:1131" : "29:1131 (29:1131 ERISA - Collection of Delinquent Trust Fun)",
      "29:1132" : "29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)",
      "29:1145" : "29:1145 (29:1145 E.R.I.S.A.)",
      "29:1149" : "29:1149 (29:1149 Recover Pension & Profit Sharing)",
      "29:1337" : "29:1337 (29:1337 E.R.I.S.A.)",
      "29:1362" : "29:1362 (29:1362 ERISA)",
      "29:1381" : "29:1381 (29:1381 E.R.I.S.A.)",
      "29:1401" : "29:1401 (29:1401(b)(2) Appeal of Arbitration Award)",
      "29:1451" : "29:1451 (29:1451 E.R.I.S.A.)",
      "29:1801" : "29:1801 (29:1801 Farmworker Rights)",
      "29:2001" : "29:2001 (Employee Polygraph Protection Act )",
      "29:2101" : "29:2101 (29:2101 Workers Adjustment - Retraining Notification Act )",
      "29:2601" : "29:2601 (29:2601 Family Leave Act )",
      "29:2612" : "29:2612 (29:2612 Family and Medical Leave Act )",
      "29:790" : "29:790 (29:790 Rehabilitation of Labor)",
      "30:0181" : "30:0181 (30:181 Environment: Review of Agency Action)",
      "30:0801" : "30:0801 (30:0801 Penalities/Federal Mine Safety Health Act)",
      "30:1201" : "30:1201 (30:1201 Environment: Review of Agency Action)",
      "30:1202" : "30:1202 (30:1202 Mining Reclamation Act)",
      "30:1276" : "30:1276 (30:1276 Interior: Review of Agency Action)",
      "31:3545" : "31:3545 (31:3545 Action to Recovery Money)",
      "31:3729" : "31:3729 (31:3729 False Claims Act)",
      "31:3730" : "31:3730 (31:3730 Qui Tam False Claims Act)",
      "31:3731" : "31:3731 (31:3731 Fraud)",
      "33:1319cw" : "33:1319cw (33:1319 Clean Water Act)",
      "33:1319pv" : "33:1319pv (33:1319 Pollutants & Permit Violations)",
      "33:1365" : "33:1365 (33:1365 Environmental Matters)",
      "35:0145" : "35:0145 (35:145 Patent Infringement)",
      "35:0183" : "35:0183 (35:183 Patent Infringement)",
      "35:0271" : "35:0271 (35:271 Patent Infringement)",
      "38:1681" : "38:1681 (38:1681 Recovery of VA Overpayment)",
      "38:1686" : "38:1686 (38:1686 Recovery of VA Overpayment)",
      "38:1780" : "38:1780 (38:1780 Recovery of VA Overpayment)",
      "38:2011" : "38:2011 (38:2011 - Veteran's Readjustment Assistance Act of)",
      "38:3116" : "38:3116 (38:3116 VA Overpayment)",
      "38:4301" : "38:4301 (38:4301 Uniformed Services Employment and Reemployment Rights Act)",
      "39:3005" : "39:3005 (39:3005 Detention of Mail for Temporary Periods)",
      "39:409" : "39:409 (39:409 Postal Service)",
      "40:0258" : "40:0258 (40:258(a) Public Buildings & Property: Land Condem)",
      "40:0270" : "40:0270 (40:270 Miller Act)",
      "40:0875" : "40:0875 (40:875 Public Buildings & Property: Negligence)",
      "41:0251" : "41:0251 (41:251 Public Contracts-Review of Agency Action)",
      "41:1463" : "41:1463 (41:1463 Public Contracts: Unlawful Employment Prac)",
      "42:0205" : "42:0205 (42:205 Denial Social Security Benefits)",
      "42:0206" : "42:0206 (42:206 Social Security Benefits)",
      "42:0247" : "42:0247 (42:247 Personal Injury-Swine Flu)",
      "42:0402" : "42:0402 (42:402 Social Security Benefits)",
      "42:0405id" : "42:0405id (42:405 Review of HHS Decision (SSID))",
      "42:0405wc" : "42:0405wc (42:405 Review of HHS Decision (DIWC))",
      "42:0405ww" : "42:0405ww (42:405 Review of HHS Decision (DIWW))",
      "42:0416" : "42:0416 (42:416 Denial of Social Security Benefits)",
      "42:0427" : "42:0427 (42:427 Social Security Benefits)",
      "42:12101" : "42:12101 (42:12101et seq. - Americans with Disabilities Act )",
      "42:1331" : "42:1331 (42:1331 Prisoner Civil Rights - Bivens Action )",
      "42:1383" : "42:1383 (42:1383 Review of HHS Decision)",
      "42:1395" : "42:1395 (42:1395 HHS: Adverse Reimbursement Review)",
      "42:1396" : "42:1396 (42:1396 - Tort Negligence)",
      "42:1471" : "42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclo)",
      "42:1981cv" : "42:1981cv (42:1981 Civil Rights)",
      "42:1981hs" : "42:1981hs (42:1981 Housing Discrimination)",
      "42:1981jb" : "42:1981jb (42:1981 Job Discrimination (Race))",
      "42:1981sx" : "42:1981sx (42:1981 Sex Discrimination)",
      "42:1983cv" : "42:1983cv (42:1983 Civil Rights Act)",
      "42:1983ed" : "42:1983ed (42:1983 Civil Rights (Employment Discrimination))",
      "42:1983pr" : "42:1983pr (42:1983 Prisoner Civil Rights)",
      "42:1986" : "42:1986 (42:1986 Neglect of Duty)",
      "42:2000ag" : "42:2000ag (42:2000 Job Discrimination (Age))",
      "42:2000e" : "42:2000e (42:2000e Job Discrimination (Employment))",
      "42:2000pb" : "42:2000pb (42:2000 Job Discrimination (Public Accomodations))",
      "42:2000ra" : "42:2000ra (42:2000 Job Discrimination (Race))",
      "42:2000sx" : "42:2000sx (42:2000 Job Discrimination (Sex))",
      "42:2003" : "42:2003 (42:2003 Job Discrimination)",
      "42:2005" : "42:2005 (42:2005 Review of Agency Action-HHS)",
      "42:2651" : "42:2651 (42:2651 Medical Care Recovery)",
      "42:3601" : "42:3601 (42:405 Fair Housing Act)",
      "42:4000" : "42:4000 (42:4000 National Flood Insurance Act)",
      "42:4001" : "42:4001 (42:4001 National Insurance Flood Act)",
      "42:4053" : "42:4053 (42:4053 Breach of Insurance Contract)",
      "42:4072" : "42:4072 (42:4072 Payment of Flood Insurance Claim)",
      "42:4321" : "42:4321 (42:4321 Review of Agency Action-Environment)",
      "42:4332" : "42:4332 (42:4332 Environmental Policy - Coop of Agency Repo)",
      "42:6901en" : "42:6901en (42:6901 Environmental Cleanup Expenses)",
      "42:6901rs" : "42:6901rs (42:6901 Resource & Recovery Act)",
      "42:7413" : "42:7413 (42:7413(b) Clean Air Act)",
      "42:7604cl" : "42:7604cl (42:7604 Clear Air Act (Emission Standards))",
      "42:7604ir" : "42:7604ir (42:7604 Petition to Quash IRS Summons)",
      "42:9607" : "42:9607 (42:9607 Real Property Tort to Land)",
      "43:945" : "43:945 (43:945 Compensation for Land Condemnation)",
      "43:945a" : "43:945a (43:945a Complaint in Condemnation)",
      "43:946" : "43:946 (43:946 Complaint in Condemnation - Eminent Domain)",
      "45:0051" : "45:0051 (45:51 Railways: Fed. Employer's Liability Act)",
      "45:0151" : "45:0151 (45:151 Railway Labor Act)",
      "45:0184" : "45:0184 (45:184 Action to Set Aside Award of a System Board)",
      "45:1395" : "45:1395 (45:1395 Railroads: Adverse Reimbursement Review)",
      "45:7457" : "45:7457 (45:7457 Compel Reclamation Under Clear Air Act)",
      "46:0183" : "46:0183 (46:183 Limitation of Vessel Owners Liability)",
      "46:0688" : "46:0688 (46:688 Jones Act)",
      "46:0741" : "46:0741 (46:741 Shipping)",
      "46:0761" : "46:0761 (46:761 Shipping: Damages for Death on High Seas)",
      "46:1101" : "46:1101 (46:1101 Violation of Maritime Regulations)",
      "46:1156" : "46:1156 (46:1156 Administrative Procedure Act)",
      "48:0883" : "48:0883 (48:883 Violation of US Coastal Law)",
      "48:1985" : "48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)",
      "49:0081" : "49:0081 (49:81 Damaged Goods While Being Transported)",
      "49:0781" : "49:0781 (49:781 Forfeiture)",
      "49:11503" : "49:11503 (49:11503 Railroad Revitalization Regulatory Reform)",
      "49:11702" : "49:11702 (49:11702(a)(4) Violations of Interstate Commerce A)",
      "49:1471" : "49:1471 (49:1471 Federal Aviation Act)",
      "49:1903" : "49:1903 (49:1903 Petition to enforce administrative summon)",
      "8:287" : "8:287 (8:287 Petition to Enforce INS Subpoena)",
      "misc" : "misc (Civil Miscellaneous Case)"
   },
   "kywdce" : {
      "0" : "0 (No cause code entered)",
      "02:0138" : "02:0138 (02:138 Library of Congress Access)",
      "02:0358" : "02:0358 (02:358 President's Recommendations on Exec., Jud. & Leg. Salary)",
      "02:0431" : "02:0431 (02:431 Fed. Election Commission: Failure Enforce C)",
      "02:0437" : "02:0437 (02:437 Federal Election Commission)",
      "02:0681" : "02:0681 (02:681 Deferral of Budget Authority)",
      "02:1202" : "02:1202 (02:1202 Discriminatory practices affecting US Senate employees)",
      "02:1301" : "02:1301 (02:1301 Congressional Accountability Act)",
      "02:1317(a)" : "02:1317(a) (02:1317(a) Violation of Congressional Accountability Act)",
      "05:0075" : "05:0075 (05:75(2) Contract - Reduction in Grade)",
      "05:0101" : "05:0101 (05:101 Ethics in Government Act)",
      "05:0504" : "05:0504 (05:504(c)(2) Equal Access to Justice (Govt Employees))",
      "05:0504(c )(2)" : "05:0504(c )(2) (05:0504(c )(2) Equal Access to Justice (Govt Employees))",
      "05:0551" : "05:0551 (05:551 Administrative Procedure Act)",
      "05:0552b(g)sa" : "05:0552b(g)sa (05:0552b(g)sa Implement requirements of Govt in Sunshine Act)",
      "05:0552fi" : "05:0552fi (05:552 Freedom of Information Act)",
      "05:0552pa" : "05:0552pa (05:552 Right to Privacy Act)",
      "05:0552sa" : "05:0552sa (05:552b(g)sa Implement requirements of Govt in Sunshine Act)",
      "05:0554" : "05:0554 (05:0554 Constitutionality of Maritime Statutes)",
      "05:0555(b)" : "05:0555(b) (05:0555(b) Agency Decision - Right to Counsel )",
      "05:0701" : "05:0701 (05:0701 Maritime Subsidy Board)",
      "05:0702" : "05:0702 (05:702 Administrative Procedure Act)",
      "05:0704" : "05:0704 (05:704 Labor Litigation)",
      "05:0706" : "05:0706 (05:0706 Judicial Review of Agency Action)",
      "05:1508" : "05:1508 (05:1508 Judicial Review of Order Issued by the Merit Systems Protection Board)",
      "05:2302" : "05:2302 (05:2302 Federal Whistleblowing Act / Civil Service Reform Act (CSRA))",
      "05:3318" : "05:3318 (05:3318 Veterans Preference Act)",
      "05:5514" : "05:5514 (05:5514 Debt Collection Act of 1982)",
      "05:5542" : "05:5542 (05:5542 Federal Employees Pay Act -- overtime rates)",
      "05:7101" : "05:7101 (05:7101 Labor-Management Relations (Findings and Purpose))",
      "05:7123" : "05:7123 (05:7123 Petition by FLRA against unfair labor practices)",
      "05:7501" : "05:7501 (05:7501 Government Employees Adverse Action--14 days or less)",
      "05:7511" : "05:7511 (05:7511 Government Employees Adverse Action--Over 14 days)",
      "05:7703" : "05:7703 (05:7703 Discrimination - Review of Agency Act)",
      "05:8101" : "05:8101 (05:8101 Workmen's Compensation Benefits)",
      "05:8110" : "05:8110 (05:8110 Augmented Compensation for dependents of Govt. Employees)",
      "05:8316" : "05:8316 (05:8316 Claims agst US re Retirement for Federal Emp.)",
      "05:8470" : "05:8470 (05:8470 Enforcement of Judgment against Retirement Benefits)",
      "05:8701" : "05:8701 (05:8701 Federal Employees Group Life Insurance Act of 1954)",
      "05:8705" : "05:8705 (05:8705 Declaratory Judgment - Insurance)",
      "05:8715" : "05:8715 (05:8715 Claims against the US - Jurisdiction of Courts)",
      "05:8901" : "05:8901 (05:8901 Federal Employees Health Benefits Act)",
      "05:8902" : "05:8902 (05:8902 Contracting Authority of OPM - Group Health Insurance )",
      "05:8903" : "05:8903 (05:8903 Federal Employees Health Benefit Act)",
      "05:8912" : "05:8912 (05:8912 Claims agst US re health benefits for Federal emp.)",
      "07:0001" : "07:0001 (07:0001 Commodity Exchange Act)",
      "07:0006" : "07:0006 (7:6(b) Federal Commodity Exchange Regulation)",
      "07:0006(b)" : "07:0006(b) (07:0006(b) Federal Commodity Exchange Regulation)",
      "07:0009a" : "07:0009a (07:0009a Recovery of penalties by Commodity Futures Trading Com)",
      "07:0013a" : "07:0013a (07:0013a Contract market rules violations; recovery of penalty)",
      "07:0013a-1" : "07:0013a-1 (07:0013a-1 Enjoin or restrain violations Contract Market rules)",
      "07:0025" : "07:0025 (7:25 Fraud - Commodities Leverage Contracts)",
      "07:0087" : "07:0087 (07:0087 Enforcement of United States Grain Standards Act)",
      "07:0136" : "07:0136 (07:0136 Violations of EPA re Environmental Pesticide Control)",
      "07:0181" : "07:0181 (07:181 Packers & Stockyard Act)",
      "07:0193(b)" : "07:0193(b) (07:0193(b) Recovery of penalties re violations by packers)",
      "07:0203" : "07:0203 (07:0203 Recovery of penalties for violations by stockyards)",
      "07:0209(b)" : "07:0209(b) (07:0209(b) Violations re purchase, sale, handling of livestock)",
      "07:0210(f)" : "07:0210(f) (07:0210(f) Suit to enforce award of damages (Packers/Stockyards))",
      "07:0213(b)" : "07:0213(b) (07:0213(b) Unfair, discriminatory, deceptive practice/marketing)",
      "07:0216" : "07:0216 (07:0216 Injunctions to restrain & enforce orders of Secretary)",
      "07:0222" : "07:0222 (07:0222 Adoption of FTC powers for enforcement.)",
      "07:0228a" : "07:0228a (07:0228a Request by Secretary for TRO or Inj. re Poultry)",
      "07:0245" : "07:0245 (07:0245 Action on bond by person injured in Warehouse)",
      "07:0292" : "07:0292 (07:0292 Monopolizing or restraining trade & enhancing prices)",
      "07:0499" : "07:0499 (07:499 Agricultural Commodities Act)",
      "07:0499E(c )(4)" : "07:0499E(c )(4) (07:0499E(c )(4) Perishable Agricultural Commodities Act (PACA))",
      "07:0601" : "07:0601 (07:601 USDA Condemnation)",
      "07:0608" : "07:0608 (07:0608 Agriculture Adjustment Act)",
      "07:0901" : "07:0901 (07:0901 Rural Electrification Act)",
      "07:1291(b)" : "07:1291(b) (07:1291(b) Agricultural Adjustment Act; freight rates.)",
      "07:1376" : "07:1376 (07:1376 Adjustment of Quotas and Enforcement; penalties.)",
      "07:1501" : "07:1501 (07:1501 Federal Crop Insurance Act)",
      "07:1508" : "07:1508 (07:1508 Crop Insurance)",
      "07:1631" : "07:1631 (07:1631 Food Security Act)",
      "07:1721" : "07:1721 (07:1721 Agricultural Trade Development Asst Act)",
      "07:1922" : "07:1922 (07:1922 Persons Eligible for Loans - Forclosure)",
      "07:1926" : "07:1926 (07:1926 Water and Waste Facility Loans and Grants)",
      "07:1930" : "07:1930 (07:1930 Perishable Agric. Comm. Act of 1930)",
      "07:2011" : "07:2011 (07:2011 Supplemental Nutrition Assistance Program)",
      "07:2022" : "07:2022 (07:2022 Disposition of Claims: Denial application to participate; food stamp prog.)",
      "07:2023(a)" : "07:2023(a) (07:2023(a) Judicial Review of Food Stamp Disqualification)",
      "07:2024" : "07:2024 (07:2024 False Claims Act, Food Stamp Fraud)",
      "07:2131" : "07:2131 (07:2131 Violation of the Animal Welfare Act)",
      "07:2146" : "07:2146 (07:2146 Transportation, Sale, and Handling of Animals)",
      "07:2301" : "07:2301 (07:2301 Agricultural Fair Practices Act)",
      "07:2305" : "07:2305 (07:2305 Unfair trade practices affecting producers Agri prod)",
      "07:2321" : "07:2321 (07:2321 Plant Variety Protection Act)",
      "07:2563" : "07:2563 (07:2563 Plant Variety Protection and Rights - Injunction)",
      "07:6999" : "07:6999 (07:6999 Judicial Review of Adverse Farm Agency Decision)",
      "08:1101" : "08:1101 (08:1101 Immigration & Nationality Act (Definitions))",
      "08:1105" : "08:1105 (8:1105(a) Aliens: Habeas Corpus to Release INS Det)",
      "08:1105a" : "08:1105a (08:1105a Immigration: Judicial Review for Battered Spouses; Deportation (INS))",
      "08:1151" : "08:1151 (08:1151 Immigration and Nationality Act of 1952)",
      "08:1152" : "08:1152 (08:1152 Immigration: Numerical limitations on individual foreign states)",
      "08:1153" : "08:1153 (08:1153 Immigration: Allocation of Immigrant Visas)",
      "08:1154" : "08:1154 (08:1154 Immigration: Procedure for Granting Immigration Status)",
      "08:1158" : "08:1158 (08:1158 Immigration & Nationality Act, Section 208 (Asylum))",
      "08:1182" : "08:1182 (08:1182 Inadmissible Aliens: Defend. Denial of Pla. Appl. for Alien Employment Cer)",
      "08:1183" : "08:1183 (08:1183 Admission of Aliens on Giving Bond or Undertaking; Return on Departure)",
      "08:1188" : "08:1188 (08:1188 Immigration: Admission of Temporary H-2A Workers)",
      "08:1225" : "08:1225 (08:1225 Immigration: Enforcement of Administrative Subpoena)",
      "08:1231(a)(6)" : "08:1231(a)(6) (08:1231(a)(6) Immigration: Due Process Clause)",
      "08:1251(A)(4)" : "08:1251(A)(4) (08:1251(A)(4) Immigration: Application for a Stay of Deportation)",
      "08:1252" : "08:1252 (08:1252(a)(2) Injunction for Deportation)",
      "08:1255" : "08:1255 (08:1255 Immigration: Failure USCIS To Adjudicate Permanent Residency Petition)",
      "08:1260" : "08:1260 (08:1260 Aliens: Access to Records)",
      "08:1324" : "08:1324 (08:1324 Aliens: Complaint for Forfeiture)",
      "08:1329" : "08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petiti)",
      "08:1357" : "08:1357 (08:1357 Immigration and Nationality Act - Administrative Search Warrant)",
      "08:1421" : "08:1421 (08:1421 Immigration: Naturalization Authority)",
      "08:1445" : "08:1445 (08:1445 Immigration: Application for Naturalization)",
      "08:1446" : "08:1446 (8:1446 Petition for Naturalization Hearing)",
      "08:1447" : "08:1447 (08:1447 Immigration: Review of Denial of Naturalization Application)",
      "08:1451" : "08:1451 (08:1451 Immigration: Revocation of Citizenship)",
      "08:1451(a)" : "08:1451(a) (08:1451(a) Action to revoke Citizenship)",
      "08:1451(j)" : "08:1451(j) (08:1451(j) Immigration: Motion to Correct Order & Judg. of Naturalization)",
      "08:287" : "08:287 (08:287 Petition to Enforce INS Subpoena)",
      "09:0001" : "09:0001 (09:1 U.S. Arbitration Act)",
      "09:0003" : "09:0003 (09:0003 Application to Stay Proceedings Pending Arbitration)",
      "09:0004" : "09:0004 (09:0004 Petition to order arbitration; failure to arbitrate)",
      "09:0007" : "09:0007 (09:0007 Petition to compel attendance before arbitrator)",
      "09:0008" : "09:0008 (09:0008 Declaratory Judgment/Admiralty)",
      "09:0009" : "09:0009 (9:9 Motion to Confirm Arbitration Loan)",
      "09:0010" : "09:0010 (09:0010 Petition to Vacate Arbitration Award)",
      "09:0011" : "09:0011 (09:0011 Motion to modify or correct arbitration award)",
      "09:0201" : "09:0201 (09:0201 Petition to Compel/Stay Arbitration under an Insurance Contract)",
      "09:0202" : "09:0202 (09:0202 Award under Convention on Foreign Arbitral Awards)",
      "09:0205" : "09:0205 (09:0205 Removal from State Court: Enforcement of Foreign Arbital Awards)",
      "09:0207" : "09:0207 (09:0207 Application for order confirming award of arbitrators)",
      "10:0672" : "10:0672 (10:0672 Armed Forces: Active Guard/Reserve (AGR) Program)",
      "10:1006" : "10:1006 (10:1006 Armed Forces: Review of Agency Decision)",
      "10:1072tc" : "10:1072tc (10:1072tc Armed Forces: TRICARE PROGRAM)",
      "10:1089(c )" : "10:1089(c ) (10:1089(c ) Armed Forces: Removal; dft acting in scope of duties)",
      "10:1091" : "10:1091 (10:1091 Armed Forces: Personal Service Contracts)",
      "10:1107" : "10:1107 (10:1107 Armed Forces: Use Of Investigational New Drug)",
      "10:1408" : "10:1408 (10:1408 Armed Forces: Claim for Military Retirement)",
      "10:1552" : "10:1552 (10:1552 Armed Forces: Action to Correct Records)",
      "10:1553" : "10:1553 (10:1553 Armed Forces: FOIA General)",
      "10:2005" : "10:2005 (10:2005 Armed Forces: Advanced Education Assistance)",
      "10:2121" : "10:2121 (10:2121 Armed Forces: Health Professions Scholarship Financial Asst Prog)",
      "10:2302" : "10:2302 (10:2302 Armed Forces: Arms Services Procurement Act)",
      "10:2305" : "10:2305 (10:2305 Review of Federal Contract)",
      "10:2323fa" : "10:2323fa (10:2323fa Armed Forces: Fifth Amendment Equal Protection: Contract Goal for Small Disadvantaged Bus)",
      "10:2733" : "10:2733 (10:2733 Armed Forces: Military Claims Act)",
      "10:2734" : "10:2734 (10:2734 Armed Forces: Foreign Military Claims Act)",
      "10:2771" : "10:2771 (10:2771 Armed Forces: Final Settlement - Deceased Members)",
      "10:3258" : "10:3258 (10:3258 Armed Forces: Reg.Army: Re-enlistment after Service as Ofcr)",
      "11:0101" : "11:0101 (11:101 Bankruptcy)",
      "11:0110" : "11:0110 (11:0110 Bankruptcy: Penalty for Preparers of Fraudulent or Negligent Petitions)",
      "11:0362(h)" : "11:0362(h) (11:0362(h) Bankruptcy: Violation of Automatic Stay)",
      "11:0523" : "11:0523 (11:0523 Bankruptcy: Exceptions to Discharge)",
      "11:0524" : "11:0524 (11:0524 Bankruptcy: Effect of Discharge)",
      "11:0525" : "11:0525 (11:0525 Bankruptcy: Protections Against Discriminatory Treatment )",
      "11:0548" : "11:0548 (11:0548 Bankruptcy: Fraudulent Transfers and Obligations)",
      "11:0704" : "11:0704 (11:0704 Bankruptcy: Duties of Trustee)",
      "12:0022" : "12:0022 (12:22 Securities Fraud)",
      "12:0085" : "12:0085 (12:0085 National Banks: Rate of Interest on Loans, Discounts, and Purchases)",
      "12:0093(a)" : "12:0093(a) (12:0093(a) National Banks: Violation of Provisions; Forfeiture of Franchise; Personal Liability of )",
      "12:0191" : "12:0191 (12:0191 National Banks: Appointment of Receiver)",
      "12:0192" : "12:0192 (12:0192 National Banks: Liquidation of National Bank)",
      "12:0215" : "12:0215 (12:0215 National Banks: Consolidation and Merger)",
      "12:0622" : "12:0622 (12:0622 Foreign Banking: Forfeiture, Dissolution, and Liability of Directors and Officers for Nonco)",
      "12:0632" : "12:0632 (12:0632 Foreign Banking: Voluntary Liquidation)",
      "12:0635" : "12:0635 (12:635 Breach of Insurance Contract)",
      "12:0635i-3" : "12:0635i-3 (12:0635i-3 Export-Import Bank: Breach of Insurance Contract)",
      "12:1421" : "12:1421 (12:1421 Federal Home Loan Bank Act (Short Title))",
      "12:1441" : "12:1441 (12:1441 FHLB: Financial Inst Reform Receiving Enforcement Act 1989)",
      "12:1451" : "12:1451 (12:1451 Emergency Home Loan Corporation (Definitions))",
      "12:1452" : "12:1452 (12:1452 Federal Home Loan Mortgage Corporation Act)",
      "12:1452(f)" : "12:1452(f) (12:1452(f) Fed Home Loan Mortgage Corp: Actions by and against the Corporation)",
      "12:1455(b)" : "12:1455(b) (12:1455(b) Fed Home Loan Mortgage Corp: Enforcement of Regulations)",
      "12:1461" : "12:1461 (12:1461 Homeowners Loan Act)",
      "12:1464" : "12:1464 (12:1464 Savings Associations: Federal Savings and Loan)",
      "12:1703" : "12:1703 (12:1703 Default of HUD Loan)",
      "12:1715(b)" : "12:1715(b) (12:1715(b) National Housing: Rules and Regulations)",
      "12:1725" : "12:1725 (12:1725 Collection under Contract Guaranty)",
      "12:1730" : "12:1730 (12:1730 Collection Under Contract Guaranty)",
      "12:1749aaa" : "12:1749aaa (12:1749aaa National Housing: National Insurance Development Program)",
      "12:1751" : "12:1751 (12:1751 Fed Credit Unions: Short Title)",
      "12:1782" : "12:1782 (12:1782 Fed Credit Unions: Administration of Insurance Fund)",
      "12:1786" : "12:1786 (12:1786 Fed Credit Unions: Actions re Violations by Credit Unions)",
      "12:1787(a)(B)" : "12:1787(a)(B) (12:1787(a)(B) Fed Credit Unions: Liquidation of Insured Credit Union by Board)",
      "12:1789(a)(2)" : "12:1789(a)(2) (12:1789(a)(2) Fed Credit Unions: Admin Provision to Sue and be Sued)",
      "12:1811" : "12:1811 (12:1811 FDIC: Financial Inst. Reform Recovery Act of 1989 (FIRREA) (Organization of FDIC))",
      "12:1818" : "12:1818 (12:1818 FDIC: Violations re Federal Deposit Insurance Corporation)",
      "12:1818(e)" : "12:1818(e) (12:1818(e) FDIC: Suspension or Removal of Bank Officer)",
      "12:1819" : "12:1819 (12:1819 Default of Promissory Note)",
      "12:1821" : "12:1821 (12:1821 Default of Loan by Promissary Note)",
      "12:1831" : "12:1831 (12:1831 FDIC: Separability of Certain Provisions)",
      "12:1831(d)" : "12:1831(d) (12:1831(d) FDIC: Deposit. Inst. Dereg. & Monetary Ctrl. Act of 1980)",
      "12:1831r-1" : "12:1831r-1 (12:1831r-1 FDIC: Notice of Branch Closure)",
      "12:1833(a)" : "12:1833(a) (12:1833(a) FDIC: Forfieture Civil Penalties)",
      "12:1954" : "12:1954 (12:1954 Injunctions (Action by Sec of Treasury re financial recordkeeping))",
      "12:1971" : "12:1971 (12:1971 Relief under Bank Holding Act)",
      "12:1972" : "12:1972 (12:1972 Tying Arrangement Act)",
      "12:2001" : "12:2001 (12:2001 Farm Credit Act of 1971)",
      "12:2601" : "12:2601 (Real Estate Settlement Procedures Act of 1974)",
      "12:2604(c )" : "12:2604(c ) (12:2604(c ) Real Estate Settlement Procedures Act (RESPA))",
      "12:2605" : "12:2605 (12:2605 RESPA: Servicing of Mortgage Loans)",
      "12:2607" : "12:2607 (12:2607 RESPA: Violation re kickbacks/unearned fees; Real Estate)",
      "12:2609" : "12:2609 (12:2609 RESPA: Escrow)",
      "12:3012" : "12:3012 (12:3012 National Consumer Cooperative Bank: Suits by or against Bank)",
      "12:3410" : "12:3410 (12:3410 Right to Financial Privacy Act)",
      "12:3751" : "12:3751 (12:3751 Single Family Mortgage Forclosure Act: Findings and Purpose)",
      "12:3801" : "12:3801 (12:3801 Alternative Mortgage Transaction Parity Act)",
      "12:3907" : "12:3907 (12:3907 International Lending Supervision: Capital Adequacy)",
      "12:4010" : "12:4010 (12:4010 Expedited Funds Availability: Violation of Act (Civil Liability))",
      "12:5101" : "12:5101 (12:5101 Fraudulent Transfer Act (Enforcement for Mortgage Licensing))",
      "15:0001" : "15:0001 (15:1 Antitrust Litigation)",
      "15:0002at" : "15:0002at (15:2 Antitrust Litigation)",
      "15:0002fl" : "15:0002fl (15:2(a) Fair Labor Standards Act)",
      "15:0004" : "15:0004 (15:0004 USDC Jurisdiction re violations of Sec. 1-7 of Title 15)",
      "15:0005" : "15:0005 (15:5(a) Fair Labor Standards Act)",
      "15:0009" : "15:0009 (15:0009 USDC Jurisdiction re violations of Sec. 8 of Title 15)",
      "15:0013" : "15:0013 (15:0013 Robinson Patman Act)",
      "15:0014" : "15:0014 (15:0014 Clayton Act)",
      "15:0015" : "15:0015 (15:15 Antitrust Litigation)",
      "15:0025" : "15:0025 (15:25 Clayton Act)",
      "15:0026" : "15:0026 (15:0026 Suit for injunctive relief re violation antitrust laws)",
      "15:0034-35" : "15:0034-35 (15:0034-35 Investment Company Act of 1940 )",
      "15:0041" : "15:0041 (15:0041 Federal Trade Commission Act)",
      "15:0044" : "15:0044 (15:44 Trademark Infringement)",
      "15:0045" : "15:0045 (15:0045 Federal Trade Commission Act)",
      "15:0045cp" : "15:0045cp (15:0045cp Violation of Children Online Privacy Protection Act)",
      "15:0052" : "15:0052 (15:0052 Federal Trade Commission Act)",
      "15:0053" : "15:0053 (15:0053 Federal Trade Commission Act)",
      "15:0053(b)" : "15:0053(b) (15:0053(b) Prelim & Perm Inj Relief & other Equitable Relief)",
      "15:0068" : "15:0068 (15:0068 Proceedings re FTC violations re wool products)",
      "15:0069" : "15:0069 (15:0069 Proceedings re FTC violations re fur products)",
      "15:0070" : "15:0070 (15:0070 Proceedings re FTC violations re textile fiber product)",
      "15:0077" : "15:0077 (15:77 Securities Fraud)",
      "15:0078" : "15:0078 (15:78m(a) Securities Exchange Act)",
      "15:0078j(b)ss" : "15:0078j(b)ss (15:0078j(b)ss Stockholder Suit)",
      "15:0078m(a)" : "15:0078m(a) (15:0078m(a) Securities Exchange Act)",
      "15:0079" : "15:0079 (15:0079 Public Utility Holding Companies)",
      "15:0080a-3" : "15:0080a-3 (15:0080a-3 Investment Company Act of 1940)",
      "15:0260" : "15:0260 (15:0260 Proceedings re weights and measures and standard time)",
      "15:0298" : "15:0298 (15:0298 Violation of Law Proceedings re gold or silver)",
      "15:0433" : "15:0433 (15:0433 Discrimination against farmers)",
      "15:0631" : "15:0631 (15:631 Small Business Act)",
      "15:0636" : "15:0636 (15:0636 Small Business Act - Aid to small business)",
      "15:0661" : "15:0661 (15:0661 Small Business Investment Act of 1958)",
      "15:0687" : "15:0687 (15:0687 Small Business Investment Program)",
      "15:0714(b)" : "15:0714(b) (15:0714(b) Commodity Credit Corporation)",
      "15:0715(f)" : "15:0715(f) (15:0715(f) Proceedings re petroleum and petroleum products)",
      "15:0717" : "15:0717 (15:717 Natural Gas Act)",
      "15:0719i(c )" : "15:0719i(c ) (15:0719i(c ) Civil actions re violations or inj involving Gas)",
      "15:0766" : "15:0766 (15:0766 Controversies arising re Federal Energy Admin. rules)",
      "15:1051" : "15:1051 (15:1051 Trademark Infringement)",
      "15:1071" : "15:1071 (15:1071 Appeal of Decision of U.S. Patent & Trademark Office (Comm / Trademark Trial Bd))",
      "15:1114" : "15:1114 (15:1114 Trademark Infringement)",
      "15:1116" : "15:1116 (15:1116 Inj to prevent violation rights of trademark owner)",
      "15:1120" : "15:1120 (15:1120 Trademark - False or Fraudulent Registration)",
      "15:1121" : "15:1121 (15:1121 Trademark Infringement)",
      "15:1125" : "15:1125 (15:1125 Trademark Infringement (Lanham Act))",
      "15:1125(a)" : "15:1125(a) (15:1125(a) False representation of goods sold in interstate commerce)",
      "15:1125(d)ac" : "15:1125(d)ac (15:1125(d)ac Trademark (Anticybersquatting consumer protection))",
      "15:1125la" : "15:1125la (15:1125la Trademark Infringement (Lanham Act))",
      "15:1126" : "15:1126 (15:1126 Patent Infringement)",
      "15:1127" : "15:1127 (15:1127 Trademark Infringement)",
      "15:1191" : "15:1191 (15:1191 Flamable Fabrics Act)",
      "15:1221" : "15:1221 (15:1221 Auto Dealer Suits Agst Manufacturers)",
      "15:1261" : "15:1261 (15:1261 Hazardous Substances (definitions))",
      "15:1263" : "15:1263 (15:1263 Prohibited Hazardous Substance - Interstate Commerce)",
      "15:1267(a)" : "15:1267(a) (15:1267(a) Federal Hazardous Substances Act)",
      "15:1314" : "15:1314 (15:1314 Antitrust--Petition for enforcement)",
      "15:1501" : "15:1501 (15:1501 Estab of Dept of Commerce)",
      "15:1601" : "15:1601 (15:1601 Truth in Lending)",
      "15:1605" : "15:1605 (15:1605 Determination of Finance Charge)",
      "15:1638" : "15:1638 (15:1638 Truth in Lending)",
      "15:1640" : "15:1640 (15:1640 Truth in Lending)",
      "15:1666" : "15:1666 (15:1666 Fair Credit Billing Act Dispute)",
      "15:1667" : "15:1667 (15:1667 Consumer Leasing Act)",
      "15:1679" : "15:1679 (15:1679 Violation of Credit Repair Organizations Act)",
      "15:1681" : "15:1681 (15:1681 Fair Credit Reporting Act)",
      "15:1691" : "15:1691 (15:1691 Equal Credit Opportunity Act)",
      "15:1692" : "15:1692 (15:1692 Fair Debt Collection Act)",
      "15:1693ef" : "15:1693ef (15:1693ef Electronic Funds Transfer Act)",
      "15:1693m" : "15:1693m (15:1693m Violation of Prov. of Subchpt.VI (Electronic Fund Transfers))",
      "15:1701" : "15:1701 (15:1701 Interstate Land Sales Full Disclosure Act (ILFFDA))",
      "15:1709" : "15:1709 (15:1709 Interstate Land Sales )",
      "15:1714" : "15:1714 (15:1714 Actions to enjoin violations re interstate land sale)",
      "15:1938" : "15:1938 (15:1938 Fair Labor Standards Act)",
      "15:1981" : "15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))",
      "15:1988" : "15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))",
      "15:1989" : "15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))",
      "15:2071" : "15:2071 (15:2071 Consumer Product Safety; Condemnation hazardous prod)",
      "15:2073" : "15:2073 (15:2073 Private action to enforce Consumer Product Safety)",
      "15:2301" : "15:2301 (15:2301 Magnuson-Moss Warranty Act)",
      "15:2310(c )" : "15:2310(c ) (15:2310(c ) Consumer Product Warranties)",
      "15:2601" : "15:2601 (15:2601 Toxic Substances Control Act (TCSA))",
      "15:2604" : "15:2604 (15:2604 Application for inj re distribution toxic substance)",
      "15:2616" : "15:2616 (15:2616 Toxic Substance control; seizure of chemical)",
      "15:2620" : "15:2620 (15:2620 Toxic Substances Control Act: citizen's petition)",
      "15:2651" : "15:2651 (15:2651 Asbestos Hazard Emergency Response Act)",
      "15:2801" : "15:2801 (15:2801 Petroleum Marketing Practices Act)",
      "15:2805" : "15:2805 (15:2805 Petroleum Marketing Practices-Franchise Protection)",
      "15:3414" : "15:3414 (15:3414 National Gas Policy Act)",
      "15:3710a" : "15:3710a (15:3710a Federal Technology Transfer Act of 1986)",
      "15:3901" : "15:3901 (15:3901 Federal Risk Retention Act)",
      "15:53(b)" : "15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equita)",
      "15:6801" : "15:6801 (15:6801 Gram-Leach-Bliley Act)",
      "15:7701" : "15:7701 (15:7701 Federal CAN-Spam Act)",
      "16:0019jj" : "16:0019jj (16:0019jj Park System Resource Protection Act)",
      "16:0470" : "16:0470 (16:0470 Archaeological resources Protection Act)",
      "16:0470f" : "16:0470f (16:0470f National Historic Preservation Act)",
      "16:0668" : "16:0668 (16:668 Bald Eagle Protection Act)",
      "16:0669" : "16:0669 (16:0669 Pittman-Robertson Conservation Restoration Act)",
      "16:0675" : "16:0675 (16:0675 Norbeck Wildlife Preserve Organic Act)",
      "16:0703" : "16:0703 (16:703 Migratory Bird Act)",
      "16:0823a" : "16:0823a (16:0823a Federal Public Utility Regulatory Policies Act)",
      "16:0825" : "16:0825 (16:0825 Federal Power Commission Regulation; Public Utilities)",
      "16:0831" : "16:0831 (16:0831 Actions re: rights of Tennessee Valley Authority)",
      "16:1244" : "16:1244 (16:1244 National Scenic and National Historic Trails)",
      "16:1374(d)(6)" : "16:1374(d)(6) (16:1374(d)(6) Petition for Review re Application for Import of Polar Bear Trophies)",
      "16:1531" : "16:1531 (16:1531 Endangered Species Act)",
      "16:1533" : "16:1533 (16:1533 Endangered Species Act)",
      "16:1538" : "16:1538 (16:1538 Endangered Species Act)",
      "16:1540" : "16:1540 (16:1540 Endangered Species Act - Penalties and Enforcement)",
      "16:1600" : "16:1600 (16:1600 National Forest Management Act of 1976)",
      "16:1801" : "16:1801 (16:1801 Magnuson-Stevens Fishery Conservation and Management Act )",
      "16:1858" : "16:1858 (16:1858 National Fishery Management Program - Civil Penalties and Permit Sanctions)",
      "16:3371" : "16:3371 (16:3371 Wildlife Under the Lacey Act)",
      "16:3372" : "16:3372 (16:3372 Conservation: Complaint for Forfeiture)",
      "16:3373" : "16:3373 (16:3373 Appeal of Decision - DOI)",
      "16:3374" : "16:3374 (16:3374 Conservation: Complaint for Forfeiture)",
      "17:0101" : "17:0101 (17:101 Copyright Infringement)",
      "17:0201" : "17:0201 (17:0201 Ownership of Copyright)",
      "17:0205(d)" : "17:0205(d) (17:0205(d) Priority Between Conflicting Transfers)",
      "17:0407" : "17:0407 (17:0407 Recovery of fines & penalties by Register of Copyrights)",
      "17:0411(b)" : "17:0411(b) (17:0411(b) Action by copyright owner for infringement)",
      "17:0501" : "17:0501 (17:501 Copyright Infringement)",
      "17:0502(a)" : "17:0502(a) (17:0502(a) Inj to prevent or restrain infringement copyright)",
      "17:0504" : "17:0504 (17:504 Copyright Infringement)",
      "17:0512" : "17:0512 (17:0512 Copyright Infringement of Digital Communications)",
      "17:1201" : "17:1201 (17:1201 Digital Millennium Copyright Act)",
      "18:0241" : "18:0241 (18:241 Conspiracy Against Citizen Rights)",
      "18:0492" : "18:0492 (18:0492 Forfeiture of Counterfeit Paraphernalia)",
      "18:0603" : "18:0603 (18:0603 Conflict of Interest)",
      "18:0922" : "18:0922 (18:0922 Firearms - Unlawful Possession (Civil Fines) )",
      "18:0923(f)(3)" : "18:0923(f)(3) (18:0923(f)(3) Review of Revocation of a License as a Dealer in Firearms)",
      "18:0925(c )" : "18:0925(c ) (18:0925(c ) Restoration of ability to possess firearms/ammo)",
      "18:0981" : "18:0981 (18:0981 Civil Forfeiture)",
      "18:0981(a)(1)(A)" : "18:0981(a)(1)(A) (18:0981(a)(1)(A) Civil Forfeiture: Money Laundering Control Act)",
      "18:0983" : "18:0983 (18:0983 Civil Forfeiture - General Rules)",
      "18:1030" : "18:1030 (18:1030 Fraud & Related Activity in Connection with Computers)",
      "18:1345" : "18:1345 (18:1345 Injunction against Fraud)",
      "18:1514" : "18:1514 (18:1514 Civil Action to Restrain Harassment of a Victim)",
      "18:1514A" : "18:1514A (18:1514A Civil Action to Protect Against Retaliation in Fraud Cases)",
      "18:1836a" : "18:1836a (18:1836(a) Injunction against Misappropriation of Trade Secrets)",
      "18:1836b" : "18:1836b (18:1836(b) Civil Action to Protect Trade Secrets)",
      "18:1905" : "18:1905 (18:1905 Disclosure of Confidential Information)",
      "18:1955" : "18:1955 (18:1955 Civil Forfeiture-Prohibition of Illegal Gambling)",
      "18:1956(b)(3)" : "18:1956(b)(3) (18:1956(b)(3) Laundering of Monetary Instruments - Forfeit Property)",
      "18:1961" : "18:1961 (18:1961 Racketeering (RICO) Act)",
      "18:1962" : "18:1962 (18:1962 Racketeering (RICO) Act)",
      "18:1964" : "18:1964 (18:1964 Racketeering (RICO) Act)",
      "18:1968" : "18:1968 (18:1968 Action re civil investigative demand)",
      "18:2254" : "18:2254 (18:2254 Civil Forfeiture - Exploitation of Children)",
      "18:2333" : "18:2333 (18:2333 Civil Remedies: Anti-Terrorism Act of 1991)",
      "18:2511" : "18:2511 (18:2511 Wiretapping - Injunctive Relief or Civil Fine)",
      "18:2520" : "18:2520 (18:2520 Civil Damages for Interception Wire or Oral Communications)",
      "18:2707" : "18:2707 (18:2707 Civil Action: Stored Communications)",
      "18:2710( c)" : "18:2710( c) (18:2710( c) Wrongful Disclosure of Video Tape Rental or Sales Records)",
      "18:2724" : "18:2724 (18:2724 Civil Action - Motor Vehicle Records)",
      "18:3114" : "18:3114 (18:3114 Motion for Return of Seized Property)",
      "18:3184" : "18:3184 (18:3184 Extradition Procedure)",
      "18:3663" : "18:3663 (18:3663 Civil Enforcement of Crim. Rest. Obligation)",
      "18:4100" : "18:4100 (18:4100 Transfer of Offenders)",
      "18:4208" : "18:4208 (18:4208(B) Agency Action Review)",
      "19:1305" : "19:1305 (19:1305 Custom Duties:0Forfeiture-Immoral Articles)",
      "19:1497" : "19:1497 (19:1497 Customs Duties: Penalty for Failure to Declare)",
      "19:1595a" : "19:1595a (19:1595a Customs Duties: Forfeiture and Other Penalties)",
      "19:1607" : "19:1607 (19:1607 Customs Duties: Notice of Seizure)",
      "20:0107" : "20:0107 (20:0107 Randolph-Sheppard Vending Stand Act)",
      "20:1070" : "20:1070 (20:1070 Student Assistance)",
      "20:1080" : "20:1080 (20:1080 Student Loan Recovery)",
      "20:1087" : "20:1087 (20:1087 Student Loan Discharge)",
      "20:1095a" : "20:1095a (20:1095a Education - Wage Garnishment Requirement)",
      "20:1097" : "20:1097 (20:1097 Education - Criminal penalties for fraud)",
      "20:1098g" : "20:1098g (20:1098g Higher Education Act - Exemption from state disclosure)",
      "20:1232(g)" : "20:1232(g) (20:1232(g) Family Education Rights & Privacy Act of 1974)",
      "20:1400" : "20:1400 (20:1400 Civil Rights of Handicapped Child)",
      "20:1401" : "20:1401 (20:1401 Education: Handicapped Child Act)",
      "20:1412" : "20:1412 (20:1412 IDEA: State Eligibility)",
      "20:1415" : "20:1415 (20:1415 IDEA: Challenge decision re education for handicapped )",
      "20:1415(e)(2)de" : "20:1415(e)(2)de (20:1415(e)(2)de IDEA: Mediation)",
      "20:1681" : "20:1681 (20:1681 Title IX Educational Amendments 1992 - Sex Discrimination)",
      "20:1683" : "20:1683 (20:1683 Judicial Review: Prohibition against sex discrimination in education)",
      "20:1706" : "20:1706 (20:1706 Relief from denial of equal educational opportunity)",
      "20:1717" : "20:1717 (20:1717 Reopening proceedings w/order to end segregation)",
      "21:0301" : "21:0301 (21:0301 Federal Food, Drug & Cosmetic Act)",
      "21:0331" : "21:0331 (21:0331 Federal Food, Drug & Cosmetic Act - Prohibited Acts)",
      "21:0332" : "21:0332 (21:0332 Federal Food, Drug and Cosmetic Act, Injunctive Relief)",
      "21:0332(a)" : "21:0332(a) (21:0332(a) Federal Food, Drug, and Cosmetic Act)",
      "21:0334(a)" : "21:0334(a) (21:0334(a) Forfeiture or condemnation-food, drug, cosmetics)",
      "21:0348" : "21:0348 (21:0348 Federal Food, Drug and Cosmetic Act - Food Additives)",
      "21:0360" : "21:0360 (21:0360 Federal Food, Drug & Cosmetic Act - Drugs and Devices)",
      "21:0467" : "21:0467 (21:0467 Seizure and condemnation of poultry products)",
      "21:0601" : "21:0601 (21:0601 Federal Meat Inspection Act 21 USC 601-695 (Definitions))",
      "21:0673" : "21:0673 (21:0673 Seizure and condemnation of meat or meat products)",
      "21:0674" : "21:0674 (21:0674 Proceeding to enforce & enjoin re meat products)",
      "21:0821" : "21:0821 (21:0821 Violation of Record Keeping Provision of Controlled Substance Act)",
      "21:0841" : "21:0841 (21:841 Forfeiture Property-Drugs)",
      "21:0842" : "21:0842 (21:0842 Civil Penalty for violation re controlled substance)",
      "21:0881" : "21:0881 (21:881 Forfeiture Property-Drugs)",
      "21:0881a" : "21:0881a (21:881 Forfeiture Property - Aircraft)",
      "21:0881re" : "21:0881re (21:881 Forfeiture Property - Real Estate)",
      "21:0882" : "21:0882 (21:0882 Inj to enjoin violations re controlled substance)",
      "21:1049" : "21:1049 (21:1049 Seizure and condemnation re eggs or egg products)",
      "22:0286" : "22:0286 (22:0286 Action against World Bank or IMF)",
      "22:2702" : "22:2702 (22:2702 Medical Malpractice by Govt. Medical Personnel)",
      "22:3612" : "22:3612 (22:3612 Claim for Damage to Panama Canal)",
      "22:3776" : "22:3776 (22:3776 Panama Canal Commission Action on claims)",
      "22:3777" : "22:3777 (22:3777 Investigation of accident or injury giving rise to a claim)",
      "22:4140" : "22:4140 (22:4140 Foreign Service Grievance Act - Judicial Review)",
      "23:0112" : "23:0112 (23:0112 Federal Highway Act - Letting of Contracts)",
      "23:0134" : "23:0134 (23:134 P.I.- Auto Negligence)",
      "23:1441" : "23:1441 (23:1441 Contract Real Estate)",
      "24:1000" : "24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)",
      "25:0640" : "25:0640 (25:640 Indian Tribal Rights)",
      "25:1901" : "25:1901 (25:1901 Indian Child Welfare Act)",
      "25:2701" : "25:2701 (25:2701 Indian Gaming Regulatory Act (IGRA))",
      "25:4101" : "25:4101 (25:4101 Native American Housing Assistance and Self-Determination Act (NAHASDA))",
      "26:0063" : "26:0063 (26:0063 IRS: Taxable income (Definition))",
      "26:0982" : "26:0982 (26:0982 IRS: To Quash IRS Formal Document Request)",
      "26:2032" : "26:2032 (26:2032 IRS: Alternate valuation)",
      "26:6212" : "26:6212 (26:6212 Injunctive Relief from IRS Lien)",
      "26:6213" : "26:6213 (26:6213 Injunctive Relief from IRS Lien)",
      "26:6221" : "26:6221 (26:6221 IRS: TEFRA Tax, Equity and Fiscal Responsibility Act of 1982)",
      "26:6226" : "26:6226 (26:6226 IRS: Judicial Review of Partnership Adjustment)",
      "26:6320" : "26:6320 (26:6320 IRS: Notice and Opportunity for Hearing upon Filing Notice of Lien)",
      "26:6330" : "26:6330 (26:6330 IRS: Notice and Opportunity for Hearing before Levy)",
      "26:6331" : "26:6331 (26:6331 IRS: Wrongful Levy)",
      "26:6334" : "26:6334 (26:6334 IRS: Property Exempt from Levy)",
      "26:6502" : "26:6502 (26:6502 IRS:Enforcement of tax liens)",
      "26:6532" : "26:6532 (26:6532 IRS: Refund of Tax Penalty)",
      "26:6653sp" : "26:6653sp (26:6653sp IRS: Failure to Pay Stamp Tax)",
      "26:6672" : "26:6672 (26:6672 IRS: Failure to Collect and Pay Over Tax, or Attempt to Evade or Defeat Tax)",
      "26:6694" : "26:6694 (26:6694 IRS: Underestimate Of Tax Liability By Tax Preparer)",
      "26:6702" : "26:6702 (26:6702 IRS: Refund of Income Tax Penalty)",
      "26:6703" : "26:6703 (26:6703 IRS: Refund of Tax Penalty)",
      "26:7323" : "26:7323 (26:7323 IRS: Proceedings in rem enforce forfeitures property)",
      "26:7401" : "26:7401 (26:7401 IRS: Tax Liability)",
      "26:7402" : "26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)",
      "26:7403" : "26:7403 (26:7403 Suit to Enforce Federal Tax Lien)",
      "26:7404" : "26:7404 (26:7404 IRS: Action for collection of estate tax)",
      "26:7405" : "26:7405 (26:7405 IRS: Action for recovery of refunds erroneously made)",
      "26:7407" : "26:7407 (26:7407 IRS: Action to enjoin income tax preparers)",
      "26:7422rt" : "26:7422rt (26:7422 IRS: Refund Taxes)",
      "26:7422rx" : "26:7422rx (26:7422 IRS: Refund Excise Tax)",
      "26:7425(a)" : "26:7425(a) (26:7425(a) IRS: Judiciary & Judicial Procedures - Discharge of Liens)",
      "26:7426" : "26:7426 (26:7426 IRS: Wrongful Levy for Taxes)",
      "26:7428" : "26:7428 (26:7428 IRS: Declaratory Judgment)",
      "26:7429" : "26:7429 (26:7429 IRS: Tax Jeopardy Assessment)",
      "26:7430" : "26:7430 (26:7430 IRS: Awarding of Costs and Certain Fees in Tax Suit)",
      "26:7431" : "26:7431 (26:7431 IRS: Unauthorized Disclosure of Return & Return Info)",
      "26:7434" : "26:7434 (26:7434 IRS: Civil Damages for Fraudulent Filing of Information)",
      "26:7604" : "26:7604 (26:7604 IRS: Enforce summons; examination books & witnesses)",
      "26:7604(a)" : "26:7604(a) (26:7604(a) IRS: Complaint to Enforce IRS Summons)",
      "26:7609" : "26:7609 (26:7609 IRS: Petition to Quash IRS Summons)",
      "26:7609en" : "26:7609en (26:7609en IRS: Petition to serve Third-Party Summons)",
      "27:0185" : "27:0185 (27:185 Enforcement of Arbitration Award)",
      "28:0157(b)" : "28:0157(b) (28:0157(b) Bankruptcy Claim to be tried in U.S. District Court)",
      "28:0157(c )(1)" : "28:0157(c )(1) (28:0157(c )(1) Findings, Concl. & Proposed Judgment)",
      "28:0157(d)" : "28:0157(d) (28:0157(d) Motion for Withdrawal of Reference)",
      "28:0157c" : "28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)",
      "28:0157d" : "28:0157d (28:0157 Motion for Withdrawal of Reference)",
      "28:0158" : "28:0158 (28:0158 Notice of Appeal re Bankruptcy Matter (BA)",
      "28:0185" : "28:0185 (28:185 Suit to Compel Arbitration)",
      "28:0451" : "28:0451 (28:451 Employment Discrimination)",
      "28:0463" : "28:0463 (28:0463 Expenses of Judicial Litigation)",
      "28:0534" : "28:0534 (28:0534 Arrest Records)",
      "28:0591" : "28:0591 (28:0591 Independent Counsel)",
      "28:0592" : "28:0592 (28:0592 Independent Counsel - Application for Appointment)",
      "28:0593" : "28:0593 (28:0593 Independent Counsel - Court Responsibilities)",
      "28:0594" : "28:0594 (28:0594 Independent Counsel - Responsibilities)",
      "28:0595" : "28:0595 (28:0595 Independent Counsel - Congressional Oversight)",
      "28:0596" : "28:0596 (28:0596 Independent Counsel - Removal)",
      "28:0597" : "28:0597 (28:0597 Independent Counsel - Dept. of Justice Relationship)",
      "28:0598" : "28:0598 (28:0598 Independent Counsel - Chapter Termination)",
      "28:0636" : "28:0636 (28:0636 Jurisdiction and Power of Magistrate Judges)",
      "28:0754" : "28:0754 (28:0754 Receiver of Property in Different Districts )",
      "28:0794" : "28:0794 (28:794 Rehabilitation Act)",
      "28:1001" : "28:1001 (28:1001 E.R.I.S.A.)",
      "28:1132" : "28:1132 (28:1132 E.R.I.S.A.)",
      "28:1291" : "28:1291 (28:1291 Maritime)",
      "28:1330" : "28:1330 (28:1330 Breach of Contract)",
      "28:1331" : "28:1331 (28:1331 Fed. Question)",
      "28:1331(a)rp" : "28:1331(a)rp (28:1331(a)rp Fed. Question: Real Property )",
      "28:1331ag" : "28:1331ag (28:1331ag Fed. Question: Employment Discrimination (Age))",
      "28:1331al" : "28:1331al (28:1331 Fed. Question: Airline Crash)",
      "28:1331as" : "28:1331as (28:1331as Fed. Question: Assault, Libel, Slander)",
      "28:1331at" : "28:1331at (28:1331 Fed. Question: Anti-trust)",
      "28:1331au" : "28:1331au (28:1331 Fed. Question: Auto Negligence)",
      "28:1331b" : "28:1331b (28:1331 Federal Question: Bivens Act)",
      "28:1331bc" : "28:1331bc (28:1331 Fed. Question: Breach of Contract)",
      "28:1331bv" : "28:1331bv (28:1331bv Fed. Question: Bivens-Prisoner)",
      "28:1331ca" : "28:1331ca (28:1331 Fed Question: Fed Communications Act of 1)",
      "28:1331cm" : "28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)",
      "28:1331cr" : "28:1331cr (28:1331cr Fed. Question: Civil Rights (Race Discrimination))",
      "28:1331cv" : "28:1331cv (28:1331 Federal Question: Other Civil Rights)",
      "28:1331dd" : "28:1331dd (28:1331dd Fed. Question: Discovery Disputes (conversion case))",
      "28:1331dj" : "28:1331dj (28:1331dj Fed. Question: Declaratory Judgment)",
      "28:1331dp" : "28:1331dp (28:1331dp Fed. Question: Violation of Due Process)",
      "28:1331ed" : "28:1331ed (28:1331 Fed. Question: Employment Discrimination)",
      "28:1331ef" : "28:1331ef (28:1331ef Fed. Question: Civil Rights Violation (Excess Force))",
      "28:1331ej" : "28:1331ej (28:1331ej Fed. Question: Enforcement of Judgment)",
      "28:1331es" : "28:1331es (28:1331 Enforcement of Administrative Subpoena)",
      "28:1331fa" : "28:1331fa (28:1331fa Fed. Question: Civil Rights Violation-False Arrest)",
      "28:1331fl" : "28:1331fl (28:1331 Fed. Question: Fair Labor Standards)",
      "28:1331fm" : "28:1331fm (28:1331fm Fed. Question: Family and Medical Leave Act)",
      "28:1331fr" : "28:1331fr (28:1331fr Fed. Question: Fraud)",
      "28:1331in" : "28:1331in (28:1331 Fed. Question: Insurance Contract)",
      "28:1331lm" : "28:1331lm (28:1331lm Fed. Question: Labor/Mgt. Relations Act)",
      "28:1331mm" : "28:1331mm (28:1331 Fed. Question: Medical Malpractice)",
      "28:1331ng" : "28:1331ng (28:1331ng Fed. Question: Natural Gas Act)",
      "28:1331ni" : "28:1331ni (28:1331ni Fed. Question: Negotiable Instrument)",
      "28:1331pd" : "28:1331pd (28:1331pd Fed. Question: Property Damage)",
      "28:1331pi" : "28:1331pi (28:1331 Fed. Question: Personal Injury)",
      "28:1331pl" : "28:1331pl (28:1331pl Fed. Question: Product Liability)",
      "28:1331pr" : "28:1331pr (28:1331pr Fed. Question: Federal Prisoner Civil Rights)",
      "28:1331ra" : "28:1331ra (28:1331ra Fed. Question: Racketeering (RICO) Act)",
      "28:1331rc" : "28:1331rc (28:1331rc Fed. Question: Reclamation Project Auth. Act of 1972)",
      "28:1331rd" : "28:1331rd (28:1331 Fed. Question: Review Agency Decision)",
      "28:1331rp" : "28:1331rp (28:1331(a) Fed. Question: Real Property)",
      "28:1331rr" : "28:1331rr (28:1331 Fed. Question: Railway Labor Act)",
      "28:1331rs" : "28:1331rs (28:1331rs Fed. Question: Federal Rail Safety Act)",
      "28:1331sh" : "28:1331sh (28:1331sh Fed. Question: Sexual Harassment)",
      "28:1331ss" : "28:1331ss (28:1331ss Fed. Question: Constitutionality of State Statutes)",
      "28:1331sv" : "28:1331sv (28:1331 Fed. Question: Securities Violation)",
      "28:1331sx" : "28:1331sx (28:1331sx Fed. Question: Employment Discrimination (Sex))",
      "28:1331tr" : "28:1331tr (28:1331 Fed. Question: Trademark)",
      "28:1331tt" : "28:1331tt (28:1331 Fed. Question: Tort Action)",
      "28:1331v" : "28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendme)",
      "28:1331va" : "28:1331va (28:1331va Fed. Question: Violation 5th & 14th Amendment)",
      "28:1331vc" : "28:1331vc (28:1331vc Fed. Question: Violation of Constitutional Rights)",
      "28:1331w" : "28:1331w (28:1331w Fed. Question: Wrongful Termination of Employment)",
      "28:1331wd" : "28:1331wd (28:1331wd Fed. Question: Wrongful Death)",
      "28:1331wl" : "28:1331wl (28:1331 Federal Question: EPA Waste Lien)",
      "28:1331wt" : "28:1331wt (28:1331 Fed. Question: Water Rights)",
      "28:1332" : "28:1332 (28:1332 Diversity Action)",
      "28:1332ac" : "28:1332ac (28:1332 Diversity-Account Receivable)",
      "28:1332al" : "28:1332al (28:1332 Diversity-Airline Crash)",
      "28:1332ap" : "28:1332ap (28:1332ap Diversity-Airplane Product Liability)",
      "28:1332as" : "28:1332as (28:1332 Diversity-Asbestos Litigation)",
      "28:1332au" : "28:1332au (28:1332 Diversity-Auto Negligence)",
      "28:1332bc" : "28:1332bc (28:1332 Diversity-Breach of Contract)",
      "28:1332bw" : "28:1332bw (28:1332bw Diversity -Breach of Warranty)",
      "28:1332co" : "28:1332co (28:1332 Diversity-Conversion)",
      "28:1332ct" : "28:1332ct (28:1332 Diversity-(Citizenship))",
      "28:1332de" : "28:1332de (28:1332de Diversity: Forcible Detainer)",
      "28:1332det" : "28:1332det (28:1332 Diversity: Forcible Detainer)",
      "28:1332df" : "28:1332df (28:1332 Diversity-Contract Default)",
      "28:1332ds" : "28:1332ds (28:1332 Diversity-Contract Dispute)",
      "28:1332dtp" : "28:1332dtp (28:1332dtp Diversity - Deceptive Trade Practices)",
      "28:1332ed" : "28:1332ed (28:1332 Diversity-Employment Discrimination)",
      "28:1332ej" : "28:1332ej (28:1332ej Diversity-Enforcement of Judgment)",
      "28:1332fc" : "28:1332fc (28:1332fc Diversity - Foreclosure)",
      "28:1332fd" : "28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)",
      "28:1332fr" : "28:1332fr (28:1332 Diversity-Fraud)",
      "28:1332ia" : "28:1332ia (28:1332 Diversity-Interpleader Action)",
      "28:1332if" : "28:1332if (28:1332if Diversity- Insurance Fraud)",
      "28:1332ij" : "28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)",
      "28:1332in" : "28:1332in (28:1332 Diversity-Insurance Contract)",
      "28:1332jd" : "28:1332jd (28:1332 Diversity-Declaratory Judgement)",
      "28:1332lb" : "28:1332lb (28:1332 Diversity-Libel,Assault,Slander)",
      "28:1332lm" : "28:1332lm (28:1332 Diversity - Legal Malpractice)",
      "28:1332lp" : "28:1332lp (28:1332lp Diversity-Property Damage/Product Liability)",
      "28:1332lr" : "28:1332lr (28:1332lr Diversity - Labor)",
      "28:1332ma" : "28:1332ma (28:1332 Diversity-Miller Act)",
      "28:1332md" : "28:1332md (28:1332md Diversity-Motor Vehicle/Wrongful Death)",
      "28:1332mm" : "28:1332mm (28:1332 Diversity-Medical Malpractice)",
      "28:1332mv" : "28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)",
      "28:1332ni" : "28:1332ni (28:1332 Diversity-Negotiable Instrument)",
      "28:1332nm" : "28:1332nm (28:1332 Diversity-Non-Motor Vehicle)",
      "28:1332nr" : "28:1332nr (28:1332nr Diversity-Notice of Removal)",
      "28:1332oc" : "28:1332oc (28:1332 Diversity-Other Contract)",
      "28:1332op" : "28:1332op (28:1332op Diversity-Recovery of Overpayment)",
      "28:1332pa" : "28:1332pa (28:1332pa Diversity-Personal Injury/Airplane)",
      "28:1332pd" : "28:1332pd (28:1332 Diversity-Property Damage)",
      "28:1332pi" : "28:1332pi (28:1332 Diversity-Personal Injury)",
      "28:1332pl" : "28:1332pl (28:1332 Diversity-Product Liability)",
      "28:1332pr" : "28:1332pr (28:1332 Diversity-Petition for Removal)",
      "28:1332qt" : "28:1332qt (28:1332 Diversity-Petition to Quiet Title)",
      "28:1332rd" : "28:1332rd (28:1332rd Diversity-Recovery of Debt)",
      "28:1332ri" : "28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)",
      "28:1332rl" : "28:1332rl (28:1332rl Diversity-Rent Lease & Ejectment)",
      "28:1332rp" : "28:1332rp (28:1332rp Diversity-Real Property)",
      "28:1332sa" : "28:1332sa (28:1332 - Diversity: Securities & Exchange Commiss)",
      "28:1332sf" : "28:1332sf (28:1332 - Diversity: Securities Fraud)",
      "28:1332sh" : "28:1332sh (28:1332sh Diversity-Sexual Harassment)",
      "28:1332ss" : "28:1332ss (28:1332 Diversity - Stockholders Suits)",
      "28:1332t" : "28:1332t (28:1332t Diversity-Torts)",
      "28:1332tl" : "28:1332tl (28:1332 Diversity-Torts to Land)",
      "28:1332tm" : "28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))",
      "28:1332tn" : "28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)",
      "28:1332ts" : "28:1332ts (28:1332ts Diversity-Misappropriation of Trade Secrets)",
      "28:1332vt" : "28:1332vt (28:1332vt Diversity-Natl Motor Vehicle Title Information System)",
      "28:1332wc" : "28:1332wc (28:1332wc Diversity- Worker's Compensation Benefits)",
      "28:1332wd" : "28:1332wd (28:1332 Diversity-Wrongful Death)",
      "28:1333" : "28:1333 (28:1333 Admiralty)",
      "28:1333ad" : "28:1333ad (28:1333ad Admiralty)",
      "28:1333in" : "28:1333in (28:1333in Personal Injury)",
      "28:1333mc" : "28:1333mc (28:1333mc Marine Contract)",
      "28:1333pd" : "28:1333pd (28:1333pd Property Damage)",
      "28:1333pi" : "28:1333pi (28:1333pi Marine Personal Injury)",
      "28:1334" : "28:1334 (28:1334 Bankruptcy Appeal)",
      "28:1334(b)" : "28:1334(b) (28:1334(b) Proceeding arising/related to case under title 11)",
      "28:1334(c )" : "28:1334(c ) (28:1334(c ) R&R re motions for abstention)",
      "28:1334c" : "28:1334c (28:1334(c) R&R re motions for abstention (non-cor)",
      "28:1335" : "28:1335 (28:1335 Interpleader Action)",
      "28:1337" : "28:1337 (28:1337 Sherman-Clayton Act)",
      "28:1337sc" : "28:1337sc (28:1337sc Sherman-Clayton Act)",
      "28:1338cp" : "28:1338cp (28:1338 Copyright Infringement)",
      "28:1338pt" : "28:1338pt (28:1338 Patent Infringement)",
      "28:1338tr" : "28:1338tr (28:1338 Trademark Infringement)",
      "28:1339" : "28:1339 (28:1339 Postal matters)",
      "28:1340" : "28:1340 (28:1340 IRS: Custom Duties)",
      "28:1340er" : "28:1340er (28:1340 Recovery of Erroneous Refund)",
      "28:1340tp" : "28:1340tp (28:1340tp Jurisdiction of Internal Revenue Matters; Customs Duties)",
      "28:1341" : "28:1341 (28:1341 Complaint for Forfeiture)",
      "28:1343" : "28:1343 (28:1343 Violation of Civil Rights)",
      "28:1344" : "28:1344 (28:1344 Election disputes)",
      "28:1345" : "28:1345 (28:1345 U.S. Plaintiff)",
      "28:1345co" : "28:1345co (28:1345 Replevin & Conversion)",
      "28:1345db" : "28:1345db (28:1345 Debt to US - FHA/HUD Title I)",
      "28:1345df" : "28:1345df (28:1345 Default of Promissory Note)",
      "28:1345er" : "28:1345er (28:1345 Recovery of Erroneous Refund)",
      "28:1345fc" : "28:1345fc (28:1345 Foreclosure)",
      "28:1345ff" : "28:1345ff (28:1345 Complaint for Forfeiture)",
      "28:1345hl" : "28:1345hl (28:1345 VA Home Loan Guaranty Debt)",
      "28:1345lc" : "28:1345lc (28:1345lc Land Condemnation)",
      "28:1345mc" : "28:1345mc (28:1345 Medical Care Recovery)",
      "28:1345mi" : "28:1345mi (28:1345 Mining Claim Ejectment)",
      "28:1345pd" : "28:1345pd (28:1345 Property Damage)",
      "28:1345pe" : "28:1345pe (28:1345 Property Ejectment)",
      "28:1345rc" : "28:1345rc (28:1345 Recovery of Debt to US)",
      "28:1345ro" : "28:1345ro (28:1345ro Recovery of Retirement Overpayment)",
      "28:1345st" : "28:1345st (28:1345 Default of Student Loan)",
      "28:1345tp" : "28:1345tp (28:1345 Trespass on Public Land)",
      "28:1345tx" : "28:1345tx (28:1345tx Prohibit dfts assessing tx on purch/use of pers prop)",
      "28:1345va" : "28:1345va (28:1345 Recovery of VA Overpayment)",
      "28:1346" : "28:1346 (28:1346 U.S. Defendant)",
      "28:1346bc" : "28:1346bc (28:1346 Breach of Contract)",
      "28:1346pi" : "28:1346pi (28:1346pi Marine Personal Injury (or tort claim - personal injury / motor vehicle))",
      "28:1346rc" : "28:1346rc (28:1346 Recovery of IRS Tax)",
      "28:1346t" : "28:1346t (28:1346t Tort Claim)",
      "28:1346tc" : "28:1346tc (28:1346 Tort Claim)",
      "28:1346wd" : "28:1346wd (28:1346 Wrongful Death)",
      "28:1348" : "28:1348 (28:1348 Banking association as party)",
      "28:1349" : "28:1349 (28:1349 Corporation organized under Federal Law as party)",
      "28:1350" : "28:1350 (28:1350 Alien Tort Claims Act)",
      "28:1352" : "28:1352 (28:1352 Miller Act)",
      "28:1355" : "28:1355 (28:1355 Petition for Return of Property)",
      "28:1356" : "28:1356 (28:1356 Executory Process/Foreclosure)",
      "28:1358" : "28:1358 (28:1358 Land Condemnation)",
      "28:1361" : "28:1361 (28:1361 Petition for Writ of Mandamus)",
      "28:1361pr" : "28:1361pr (28:1361pr Complaint for mandamus relief (prisoner))",
      "28:1362ic" : "28:1362ic (28:1362 Indian Tribal Controversy)",
      "28:1362iw" : "28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)",
      "28:1363" : "28:1363 (28:1363 Action for protection of jurors employment rights)",
      "28:1364" : "28:1364 (28:1364 Auto Negligence)",
      "28:1367" : "28:1367 (28:1367 Other Property Damage)",
      "28:1391" : "28:1391 (28:1391 Personal Injury)",
      "28:1394" : "28:1394 (28:1394 Banking Assoc action agst Comptroller of Currency)",
      "28:1395" : "28:1395 (28:1395 Complaint for Forfeiture )",
      "28:1402" : "28:1402 (28:1402 Medical Malpractice)",
      "28:1403" : "28:1403 (28:1403 Condemnation of real estate for the use of the US)",
      "28:1407" : "28:1407 (28:1407 Airline Crash)",
      "28:1407im" : "28:1407im (28:1407im MDL: Silicone Gel Breast Implant Products Liability)",
      "28:1407md" : "28:1407md (28:1407md MDL: Multidistrict Litigation)",
      "28:1407n" : "28:1407n (28:1407n MDL: Personal Injury/Norplant Product Liability)",
      "28:1407pl" : "28:1407pl (28:1407pl MDL: Products Liability)",
      "28:1441ac" : "28:1441ac (28:1441 Petition for Removal- Account Receivable)",
      "28:1441ada" : "28:1441ada (28:1441ada Removal- Americans with Disabilities Act)",
      "28:1441ag" : "28:1441ag (28:1441ag Removal- Civil Rights (Age))",
      "28:1441al" : "28:1441al (28:1441 Petition for Removal- Airline Crash)",
      "28:1441as" : "28:1441as (28:1441 Petition for Removal- Asbestos Litigation)",
      "28:1441au" : "28:1441au (28:1441 Petition for Removal- Auto Negligence)",
      "28:1441ba" : "28:1441ba (28:1441ba Removal - National Bank Act)",
      "28:1441bc" : "28:1441bc (28:1441 Petition for Removal- Breach of Contract)",
      "28:1441bfd" : "28:1441bfd (28:1441bfd Removal- Breach of Fiduciary Duties)",
      "28:1441ca" : "28:1441ca (28:1441ca Removal - Carmack Amendment)",
      "28:1441cc" : "28:1441cc (28:1441cc Removal- Computer Crimes Act)",
      "28:1441cj" : "28:1441cj (28:1441cj Removal- Confessed Judgement)",
      "28:1441cla" : "28:1441cla (28:1441cla Removal - Consumer Leasing Act)",
      "28:1441cp" : "28:1441cp (28:1441cp Removal- Copyright)",
      "28:1441cpl" : "28:1441cpl (28:1441cpl Removal - Contract Product Liability)",
      "28:1441cra" : "28:1441cra (28:1441cra Removal - Fair Credit Reporting Act)",
      "28:1441cv" : "28:1441cv (28:1441 Petition for Removal- Civil Rights Act)",
      "28:1441dea" : "28:1441dea (28:1441dea Removal - Disabilities Education Act)",
      "28:1441df" : "28:1441df (28:1441 Petition for Removal- Contract Default)",
      "28:1441di" : "28:1441di (28:1441di Removal- Civil Rights (Disability Act))",
      "28:1441dj" : "28:1441dj (28:1441 Petition for Removal- Declaratory Judgemen)",
      "28:1441ds" : "28:1441ds (28:1441 Petition for Removal- Contract Dispute)",
      "28:1441ea" : "28:1441ea (28:1441ea Removal- Employment Discrimination (Age))",
      "28:1441eb" : "28:1441eb (28:1441eb Removal - E.R.I.S.A. Employee Benefits)",
      "28:1441ec" : "28:1441ec (28:1441ec Removal - Electronic Comm. Privacy Act)",
      "28:1441ed" : "28:1441ed (28:1441 Petition for Removal - Employment Discrim)",
      "28:1441em" : "28:1441em (28:1441em Removal - Emergency Medical Treatment & Active Labor)",
      "28:1441er" : "28:1441er (28:1441er Removal- Employment Discrimination (Race))",
      "28:1441es" : "28:1441es (28:1441es Removal- Employment Discrimination (Sex))",
      "28:1441fa" : "28:1441fa (28:1441fa Removal - Civil Rights - False Arrest)",
      "28:1441fc" : "28:1441fc (28:1441 Petition for Removal - Fair Credit Reporti)",
      "28:1441fd" : "28:1441fd (28:1441fd Removal - Fair Debt Collection Practices Act)",
      "28:1441fe" : "28:1441fe (28:1441fe Removal- Fed. Employee Garnishment Statute)",
      "28:1441fh" : "28:1441fh (28:1441fh Removal- FEHBA)",
      "28:1441fif" : "28:1441fif (28:1441fif Removal - Insecticide/Fungicide/Rodenticide Act -1942)",
      "28:1441fl" : "28:1441fl (28:1441fl Removal- Fair Labor Standards Act)",
      "28:1441fm" : "28:1441fm (28:1441fm Removal - Family and Medical Leave Act)",
      "28:1441fr" : "28:1441fr (28:1441 Petition for Removal- Fraud)",
      "28:1441fs" : "28:1441fs (28:1441fs Removal - Foreign Sovereign Immunities Act)",
      "28:1441fsa" : "28:1441fsa (28:1441fsa Removal - Federal Food Stamp Act)",
      "28:1441hb" : "28:1441hb (28:1441hb Removal - Petition of Habeas Corpus)",
      "28:1441hc" : "28:1441hc (28:1441hc Removal - Handicapped Child Protection Act)",
      "28:1441hd" : "28:1441hd (28:1441hd Removal- Housing Discrimination)",
      "28:1441ia" : "28:1441ia (28:1441ia Removal- Interstate Commerce Act)",
      "28:1441if" : "28:1441if (28:1441if Removal - Insurance Fraud)",
      "28:1441ij" : "28:1441ij (28:1441 Petition for Removal- Injunctive/Declarato)",
      "28:1441il" : "28:1441il (28:1441il Removal- Interstate Land Full Discloser Act)",
      "28:1441in" : "28:1441in (28:1441 Petition for Removal- Insurance Contract)",
      "28:1441int" : "28:1441int (28:1441 Petition for Removal- Action for Interplea)",
      "28:1441la" : "28:1441la (28:1441la Removal - Truth in Lending Act)",
      "28:1441lb" : "28:1441lb (28:1441 Petition for Removal Libel,Assault,Slander)",
      "28:1441lm" : "28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relatio)",
      "28:1441ml" : "28:1441ml (28:1441ml Removal- Motor Vehicle Prod Liability)",
      "28:1441mm" : "28:1441mm (28:1441 Petition for Removal- Medical Malpractice)",
      "28:1441mv" : "28:1441mv (28:1441mv Removal- Motor Vehicle)",
      "28:1441ni" : "28:1441ni (28:1441 Petition for Removal- Negotiable Instrumen)",
      "28:1441nm" : "28:1441nm (28:1441 Petition for Removal- Non-Motor Vehicle)",
      "28:1441nr" : "28:1441nr (28:1441nr Notice of Removal)",
      "28:1441oc" : "28:1441oc (28:1441 Petition For Removal--Other Contract)",
      "28:1441pa" : "28:1441pa (28:1441pa Removal - Patent Infringement)",
      "28:1441pd" : "28:1441pd (28:1441 Petition for Removal- Property Damage)",
      "28:1441pi" : "28:1441pi (28:1441 Petition for Removal- Personal Injury)",
      "28:1441pl" : "28:1441pl (28:1441 Petition for Removal- Product Liability)",
      "28:1441pr" : "28:1441pr (28:1441 Petition for Removal)",
      "28:1441qt" : "28:1441qt (28:1441 Petition for Removal- Petition to Quiet Ti)",
      "28:1441ra" : "28:1441ra (28:1441ra Removal- Civil Rights (Race))",
      "28:1441ri" : "28:1441ri (28:1441 Petition for Removal- Racketeering (RICO))",
      "28:1441rl" : "28:1441rl (28:1441rl Removal- Rent, Lease, & Ejectment)",
      "28:1441sa" : "28:1441sa (28:1441 - Petition for Removal: SEC Act)",
      "28:1441sf" : "28:1441sf (28:1441 - Petition for Removal: Securities Fraud)",
      "28:1441sh" : "28:1441sh (28:1441sh Removal-Sexual Harassment)",
      "28:1441st" : "28:1441st (28:1441st Removal - Stockholders Suit)",
      "28:1441sv" : "28:1441sv (28:1441sv Removal-Security Violation)",
      "28:1441sx" : "28:1441sx (28:1441sx Removal-Civil Rights (Sex))",
      "28:1441tc" : "28:1441tc (28:1441tc Removal - Tricare Program)",
      "28:1441ti" : "28:1441ti (28:1441ti Removal-Trademark Infringement)",
      "28:1441til" : "28:1441til (28:1441til Removal - Truth and Lending)",
      "28:1441tl" : "28:1441tl (28:1441 Petition for Removal- Torts to Land)",
      "28:1441tm" : "28:1441tm (28:1441 Petition for Removal- Tort/Motor Vehicle ()",
      "28:1441tn" : "28:1441tn (28:1441 Petition for Removal- Tort/Non-Motor Vehic)",
      "28:1441us" : "28:1441us (28:1441us Removal - Uniformed Svc Emp/Reemp Rights Act)",
      "28:1441wc" : "28:1441wc (28:1441wc Removal - Worker's Compensation Benefits)",
      "28:1441wd" : "28:1441wd (28:1441 Petition for Removal- Wrongful Death)",
      "28:1441wt" : "28:1441wt (28:1441wt Removal- Employment (Wrongful Termination))",
      "28:1442" : "28:1442 (28:1442 Notice of Removal - Suit against Federal Officer)",
      "28:1442aaf" : "28:1442aaf (28:1442aaf Petition for Removal - Agst members of armed forces)",
      "28:1442bc" : "28:1442bc (28:1442 Petition for Removal- Breach of Contract)",
      "28:1442pr" : "28:1442pr (28:1442 Petition for Removal)",
      "28:1443" : "28:1443 (28:1443(1) Rent, Lease & Ejectment)",
      "28:1443(1)" : "28:1443(1) (28:1443(1) Removal from State Court - Civil Rights: Rent, Lease, and Ejectment)",
      "28:1444" : "28:1444 (28:1444 Petition for Removal- Foreclosure)",
      "28:1446al" : "28:1446al (28:1446al Notice of Removal - Airline Crash)",
      "28:1446as" : "28:1446as (28:1446as Notice of Removal - Asbestos Litigation)",
      "28:1446bc" : "28:1446bc (28:1446bc Notice of Removal - Breach of Contract)",
      "28:1446cs" : "28:1446cs (28:1446cs Notice of Removal - Child Support Enforcement)",
      "28:1446dj" : "28:1446dj (28:1446dj Notice of Removal - Declaratory Judgment)",
      "28:1446er" : "28:1446er (28:1446er Notice of Removal - E.R.I.S.A)",
      "28:1446fm" : "28:1446fm (28:1446fm Notice of Removal - Family and Medical Leave Act)",
      "28:1446fr" : "28:1446fr (28:1446fr Notice of Removal - Fraud)",
      "28:1446in" : "28:1446in (28:1446 Breach of Contract- Insurance)",
      "28:1446lb" : "28:1446lb (28:1446lb Notice of Removal - Libel, Assault, Slander)",
      "28:1446ml" : "28:1446ml (28:1446ml Notice of Removal - Motor Vehicle Prod Liability)",
      "28:1446mm" : "28:1446mm (28:1446mm Notice of Removal - Medical Malpractice)",
      "28:1446mv" : "28:1446mv (28:1446mv Notice of Removal - Motor Vehicle)",
      "28:1446ni" : "28:1446ni (28:1446ni Notice of Removal - Negotiable Instrument)",
      "28:1446nr" : "28:1446nr (28:1446nr Notice of Removal)",
      "28:1446oc" : "28:1446oc (28:1446oc Notice of Removal - Other Contract)",
      "28:1446pd" : "28:1446pd (28:1446 Petition for Removal- Property Damage (P.I)",
      "28:1446pi" : "28:1446pi (28:1446 Petition for Removal- Personal Injury)",
      "28:1446pl" : "28:1446pl (28:1446pl Petition for Removal - Product Liability)",
      "28:1446pr" : "28:1446pr (28:1446 Petition for Removal)",
      "28:1446st" : "28:1446st (28:1446st Notice of Removal - Stockholders Suit)",
      "28:1446tl" : "28:1446tl (28:1446tl Notice of Removal - Torts to Land)",
      "28:1446wd" : "28:1446wd (28:1446wd Notice of Removal - Wrongful Death)",
      "28:1452" : "28:1452 (28:1452 R&R re motions to remand (non-core))",
      "28:1453" : "28:1453 (28:1453 Class Action Fairness Act)",
      "28:1491" : "28:1491 (28:1491 Tucker Act)",
      "28:1602" : "28:1602 (28:1602 Foreign Sovereign Immunities Act)",
      "28:1605" : "28:1605 (28:1605 Foreign Sovereign Immunities Act of 1976)",
      "28:1605A" : "28:1605A (28:1605A Antiterrorism & Effective Death Penalty Act 1996)",
      "28:1610" : "28:1610 (28:1610 Juridictional Immunities of Foreign States)",
      "28:1631" : "28:1631 (28:1631 Case Transferred to Cure Want of Jurisdiction)",
      "28:1651" : "28:1651 (28:1651 Petition for Writ of Coram Nobis)",
      "28:1651cn" : "28:1651cn (28:1651cn Petition for Writ of Error Coram Nobis )",
      "28:1651hc" : "28:1651hc (28:1651 Petition for Writ of Habeas Corpus)",
      "28:1651mn" : "28:1651mn (28:1651 Petition for Writ of Mandamus)",
      "28:1651ne" : "28:1651ne (28:1651ne Application for Writ Ne Exeat)",
      "28:1651w" : "28:1651w (28:1651w All Writs Act)",
      "28:1715" : "28:1715 (28:1715 Class Action Fairness Act of 2005)",
      "28:1732" : "28:1732 (28:1732 Reproduction of Records)",
      "28:1738Acs" : "28:1738Acs (28:1738Acs The Uniform Child Custody Jurisdiction Act)",
      "28:1782" : "28:1782 (28:1782 Assistance to Foreign Tribunals (incl letter rogatory))",
      "28:1783" : "28:1783 (28:1783 Petition for Subpoena of person in foreign country)",
      "28:1826" : "28:1826 (28:1826 Order of confinement of recalcitrant witness)",
      "28:1875" : "28:1875 (28:1875 Juror Protection Act / Protection of Jurors' Employment)",
      "28:1916" : "28:1916 (28:1916 Marine Personal Injury)",
      "28:1963" : "28:1963 (28:1963 Registration of judgment from another district)",
      "28:2001" : "28:2001 (28:2001 Judicial Sale of Realty)",
      "28:2071" : "28:2071 (28:2071 Rule Making Power Generally)",
      "28:2201" : "28:2201 (28:2201 Constitutionality of State Statute(s))",
      "28:2201an" : "28:2201an (28:2201an Declaratory Judgement (aliens and nationality))",
      "28:2201cp" : "28:2201cp (28:2201cp Declaratory Judgment (Copyright))",
      "28:2201dj" : "28:2201dj (28:2201 Declaratory Judgment)",
      "28:2201fa" : "28:2201fa (28:2201fa Declaratory Judgment- Firearms)",
      "28:2201fs" : "28:2201fs (28:2201fs Declaratory Judgment (Food Security Act))",
      "28:2201ij" : "28:2201ij (28:2201 Injunction)",
      "28:2201in" : "28:2201in (28:2201 Declaratory Judgement (Insurance))",
      "28:2201pi" : "28:2201pi (28:2201pi Declaratory Judgment - Personal Injury)",
      "28:2241" : "28:2241 (28:2241 Petition for Writ of Habeas Corpus (federa)",
      "28:2241fd" : "28:2241fd (28:2241fd Petition for Writ of Habeas Corpus (federal))",
      "28:2241in" : "28:2241in (28:2241in Habeas Corpus: INS)",
      "28:2241st" : "28:2241st (28:2241st Petition for Writ of Habeas Corpus (State))",
      "28:2244" : "28:2244 (28:2244 Habeas Corpus - Finality of Determination)",
      "28:2254" : "28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))",
      "28:2254dp" : "28:2254dp (28:2254dp Petition for Writ of Habeas Corpus (Death Penalty))",
      "28:2254se" : "28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)",
      "28:2255" : "28:2255 (28:2255 Motion to Vacate / Correct Illegal Sentence)",
      "28:2271" : "28:2271 (28:2271 Federal Tort Claims Act)",
      "28:2283" : "28:2283 (28:2283 Stay of State Court Proceedings (Injunctive Relief))",
      "28:2345" : "28:2345 (28:2345 Medicare Recovery)",
      "28:2347" : "28:2347 (28:2347 Petition to Review Orders in the Ct of Appeals)",
      "28:2401" : "28:2401 (28:2401 Federal Tort Claims Act (Time for commencing action against the US))",
      "28:2403" : "28:2403 (28:2403 Constitutionality of State Statute(s) )",
      "28:2405" : "28:2405 (28:2405 Garnishment of debtors of a corporation by US)",
      "28:2409" : "28:2409 (28:2409(a) Quiet Title Action)",
      "28:2409(a)" : "28:2409(a) (28:2409(a) Quiet Title Action)",
      "28:2410" : "28:2410 (28:2410 Quiet Title)",
      "28:2412" : "28:2412 (28:2412 Equal Access to Justice Act)",
      "28:2415" : "28:2415 (28:2415 Detinue and Conversion)",
      "28:2671" : "28:2671 (28:2671 Federal Tort Claims Act)",
      "28:2672mv" : "28:2672mv (28:2672mv Federal Tort Claims Act - Motor Vehicle)",
      "28:2672pi" : "28:2672pi (28:2672pi Federal Tort Claim Act - Personal Injury)",
      "28:2674" : "28:2674 (28:2674 Federal Tort Claims Act)",
      "28:2675" : "28:2675 (28:2675 Federal Tort Claims Act - Disposition by Agency Req)",
      "28:2679(d)" : "28:2679(d) (28:2679(d)(2) Federal Tort Claims Act - Employee of U.S.A.)",
      "28:2680" : "28:2680 (28:2680 Federal Tort Claims Act - Exceptions)",
      "28:3001" : "28:3001 (28:3001 Federal Debt Collection Act)",
      "28:3001(a)" : "28:3001(a) (28:3001(a) Federal Debt Collection Procedures Act of 1990)",
      "28:3203" : "28:3203 (28:3203 Postjudgment Remedies: Writ of Execution)",
      "28:3301" : "28:3301 (28:3301 Fraudulent Transfer Federal Debt Collection Procedures Act)",
      "28:7402" : "28:7402 (28:7402 Refund of Taxes)",
      "28:7422" : "28:7422 (28:7422 Appeal from Administrative Decision)",
      "29:0101" : "29:0101 (29:0101 Labor: Issuance of Restraining Orders and Injunctions )",
      "29:0151" : "29:0151 (29:151 Labor: Review of Agency Action)",
      "29:0158(b)" : "29:0158(b) (29:0158(b) Labor: NLRA - Unfair Labor Practices)",
      "29:0159" : "29:0159 (29:0159 Labor: Violation of Collective Bargaining Agreement )",
      "29:0160" : "29:0160 (29:160(1) National Labor Relations Act)",
      "29:0160j" : "29:0160j (29:0160j Labor: Petition for Inj - Relief from Unfair Labor Practice)",
      "29:0160l" : "29:0160l (29:0160l Labor: Petition for Inj re Uncertified Labor Organizations)",
      "29:0161(2)" : "29:0161(2) (29:0161(2) Labor: Enforcement of agency subpoena)",
      "29:0178" : "29:0178 (29:0178 Labor: Petition for Inj to Enjoin Strike during Natl Emergency)",
      "29:0184" : "29:0184 (29:184 Violation Collection Bargain Agreement)",
      "29:0185" : "29:0185 (29:0185 Labor: Suits by and against Labor Organizations)",
      "29:0185ep" : "29:0185ep (29:185 Employee Pension Plan)",
      "29:0185lm" : "29:0185lm (29:185 Labor/Mgt. Relations (Contracts))",
      "29:0186" : "29:0186 (29:0186 Labor: Liabilities of and Restrictions on Labor and Management)",
      "29:0187" : "29:0187 (29:0187 Labor: Recover Damages from Unfair Labor Practice)",
      "29:0201do" : "29:0201do (29:201 Denial of Overtime Compensation)",
      "29:0201fl" : "29:0201fl (29:201 Fair Labor Standards Act)",
      "29:0203" : "29:0203 (29:203 Equal Pay Act)",
      "29:0206" : "29:0206 (29:206 Collect Unpaid Wages)",
      "29:0206(d)" : "29:0206(d) (29:0206(d) FLSA: Prohibition of Sex Discrimination)",
      "29:0207(a)" : "29:0207(a) (29:0207(a) FLSA: Action for Overtime Wage Violation)",
      "29:0207fl" : "29:0207fl (29:0207fl FLSA: Maximum Hours)",
      "29:0210" : "29:0210 (29:0210 FLSA: Court Review of Wage Orders in PR and VI)",
      "29:0215fl" : "29:0215fl (29:0215fl FLSA: Prohibited Acts)",
      "29:0216(b)" : "29:0216(b) (29:0216(b) FLSA: Minimum wage or overtime compensation)",
      "29:0216(e)" : "29:0216(e) (29:0216(e) FLSA: Penalty assessed for child labor provisions)",
      "29:0217" : "29:0217 (29:0217 FLSA: Enjoin Violations of Fair Labor Standards Act)",
      "29:0260" : "29:0260 (29:0260 FLSA: Liquidated Damages)",
      "29:0401" : "29:0401 (29:0401 Labor Management Disclosure Act)",
      "29:0411" : "29:0411 (29:0411 Landrum Griffin Act)",
      "29:0412" : "29:0412 (29:0412 Infringement of rights; members of labor organization)",
      "29:0440" : "29:0440 (29:0440 violations reporting requirements; labor organization)",
      "29:0501(b)" : "29:0501(b) (29:0501(b) Violation of Fiduciary Responsibility)",
      "29:0621" : "29:0621 (29:621 Job Discrimination (Age))",
      "29:0623" : "29:0623 (29:623 Job Discrimination (Age))",
      "29:0626" : "29:0626 (29:626 Job Discrimination (Age))",
      "29:0633" : "29:0633 (29:633 Job Discrimination (Age))",
      "29:0651" : "29:0651 (29:651 Occupational Safety/Health)",
      "29:0660" : "29:0660 (29:0660 Action by Sec Labor for discrimination re rights OSHA)",
      "29:0662" : "29:0662 (29:0662 Inj proceedings re dangerous emp conditions; by Sec.)",
      "29:0666" : "29:0666 (29:0666 Collection of civil penalties under OSHA)",
      "29:0701" : "29:0701 (29:0701 Vocational Rehabilitation)",
      "29:0754" : "29:0754 (29:754 Discrimination)",
      "29:0791" : "29:0791 (29:791 Job Discrimination (Rehabilitation Act))",
      "29:0792(d)(2)" : "29:0792(d)(2) (29:0792(d)(2) Accessible facilities for phys. handicapped emp)",
      "29:0794" : "29:0794 (29:0794 Job Discrimination (Handicap))",
      "29:0794ra" : "29:0794ra (29:0794 Rehabilitation Act)",
      "29:1001" : "29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)",
      "29:1002" : "29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)",
      "29:1055" : "29:1055 (29:1055 E.R.I.S.A., Employee Retirement (Joint and Survivor Annuity))",
      "29:1101" : "29:1101 (29:1101 E.R.I.S.A.: Coverage)",
      "29:1104" : "29:1104 (29:1104 Recovery of Benefits to Employee)",
      "29:1109" : "29:1109 (29:1109 Breach of Fiduciary Duties)",
      "29:1131" : "29:1131 (29:1131 ERISA - Collection of Delinquent Trust Fun)",
      "29:1132" : "29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)",
      "29:1145" : "29:1145 (29:1145 E.R.I.S.A.)",
      "29:1149" : "29:1149 (29:1149 Recover Pension & Profit Sharing)",
      "29:1161" : "29:1161 (29:1161 COBRA - Continuation Coverage)",
      "29:1162" : "29:1162 (29:1162 COBRA - Continuation Coverage)",
      "29:1303" : "29:1303 (29:1303 PBGC: Operation of Corporation)",
      "29:1337" : "29:1337 (29:1337 E.R.I.S.A.)",
      "29:1362" : "29:1362 (29:1362 ERISA)",
      "29:1381" : "29:1381 (29:1381 E.R.I.S.A.)",
      "29:1401" : "29:1401 (29:1401(b)(2) Appeal of Arbitration Award)",
      "29:1401(b)(2)" : "29:1401(b)(2) (29:1401(b)(2) E.R.I.S.A.: Resolution of Disputes - Appeal of Arbitration Award)",
      "29:1451" : "29:1451 (29:1451 E.R.I.S.A.)",
      "29:1801" : "29:1801 (29:1801 Farmworker Rights)",
      "29:1854" : "29:1854 (29:1854 Migrant & Seasonal Agri Worker Protect Act (AWPA))",
      "29:1916" : "29:1916 (29:1916 Spec. Rule for Longshoremen & Harborworkers)",
      "29:2001" : "29:2001 (29:2001 Employee Polygraph Protection Act)",
      "29:2101" : "29:2101 (29:2101 Worker Adjustment and Retraining Notification Act)",
      "29:2104" : "29:2104 (29:2104 Worker Adjustment & Retraining Notification (WARN))",
      "29:2601" : "29:2601 (29:2601 Family and Medical Leave Act (FMLA))",
      "29:2610" : "29:2610 (29:2610 Family & Maternity Leave Act)",
      "29:2611" : "29:2611 (29:2611 FMLA: Definitions)",
      "29:2612" : "29:2612 (29:2612 FMLA: Leave Requirements)",
      "29:2617" : "29:2617 (29:2617 Family and Medical Leave Act (FMLA))",
      "29:790" : "29:790 (29:790 Rehabilitation of Labor)",
      "30:0022" : "30:0022 (30:0022 General Mining Law of 1872 (Lands Open to Purchase by Citizens))",
      "30:0181" : "30:0181 (30:181 Environment: Review of Agency Action)",
      "30:0801" : "30:0801 (30:0801 Penalities/Federal Mine Safety Health Act)",
      "30:0815" : "30:0815 (30:0815 Federal Mine Safety & Health Act (Procedure for Enforcement))",
      "30:1201" : "30:1201 (30:1201 Environment: Review of Agency Action)",
      "30:1202" : "30:1202 (30:1202 Mining Reclamation Act)",
      "30:1276" : "30:1276 (30:1276 Interior: Review of Agency Action)",
      "30:1701" : "30:1701 (30:1701 Federal Oil Gas Royalty Mgt Act 1982 (FOGRMA))",
      "31:0732" : "31:0732 (31:0732 General Acct. Office Personnel Act of 1980 (Personnel Management System))",
      "31:1341" : "31:1341 (31:1341 Government employee--limitations on expending monies)",
      "31:3545" : "31:3545 (31:3545 Action to Recovery Money)",
      "31:3702" : "31:3702 (31:3702 Procedures for Settling Claims )",
      "31:3713" : "31:3713 (31:3713 Priority of Government Claims)",
      "31:3720" : "31:3720 (31:3720 Federal Income Tax Interceptions (Collection of Payments))",
      "31:3728" : "31:3728 (31:3728 Setoff against Judgment )",
      "31:3729" : "31:3729 (31:3729 False Claims Act)",
      "31:3730" : "31:3730 (31:3730 Qui Tam False Claims Act)",
      "31:3731" : "31:3731 (31:3731 Fraud)",
      "31:3733(j)(2)" : "31:3733(j)(2) (31:3733(j)(2) Pet to Mod or Set Aside CV Investigative Demand)",
      "31:5314" : "31:5314 (31:5314 Failure to Report Interest in Foreign Accounts)",
      "31:5317" : "31:5317 (31:5317 Forfeiture of money; transportation not reported )",
      "31:5320" : "31:5320 (31:5320 Inj proceedings re Rpts of Currency & Foreign Trans. )",
      "31:5321" : "31:5321 (31:5321 Penalty; Reports of Currency and Foreign Transaction )",
      "31:5332(a)" : "31:5332(a) (31:5332(a) Evading Currency Reporting Requirement)",
      "31:5332(f)" : "31:5332(f) (31:5332(f) Transport and Transfer US currency from in to out)",
      "31:6716" : "31:6716 (31:6716 Discrimination re money and finance )",
      "31:9701" : "31:9701 (31:9701 Federal User Charge Statute)",
      "33:0408" : "33:0408 (33:0408 Injury to Harbor Improvement)",
      "33:0594" : "33:0594 (33:0594 Land Condemnation)",
      "33:0901" : "33:0901 (33:0901 Longshoremen Harbor Workers Compensation Act (Navigation and Navigable Waters))",
      "33:0905(b)" : "33:0905(b) (33:0905(b) Longshoremen Workers' Compensation Act - Recovery of Damages caused by the negligence of )",
      "33:0918" : "33:0918 (33:0918 Longshore and Harbor Workers Compensation Act - Collection of Defaulted Payments)",
      "33:0921" : "33:0921 (33:0921 Longshore & Harbor Workers Compensation Act - Review of Compensation Orders)",
      "33:0933" : "33:0933 (33:0933 Longshore and Harbor Workers' Compensation Act - Compensation for Injuries (Third-Party Clai)",
      "33:1221" : "33:1221 (33:1221 Ports and Waterways Safety Program)",
      "33:1251" : "33:1251 (33:1251 Federal Water Pollution Control Act (Clean Water Act))",
      "33:1319(a)(2)pv" : "33:1319(a)(2)pv (33:1319(a)(2)pv Clean Water Act - Pollutants & Permit Violations)",
      "33:1319cw" : "33:1319cw (33:1319 Clean Water Act)",
      "33:1319pv" : "33:1319pv (33:1319 Pollutants & Permit Violations)",
      "33:1321" : "33:1321 (33:1321 Clean Water Act - Discharge of hazardous substance or pollutants/water)",
      "33:1361" : "33:1361 (33:1361 Clean Water Act-Administrator Authority)",
      "33:1364" : "33:1364 (33:1364 Clean Water Act - EPA action to restrain pollution endangering health (emergency powers))",
      "33:1365" : "33:1365 (33:1365 Environmental Matters)",
      "33:1415" : "33:1415 (33:1415 Marine Protection, Research, and Sanctuaries Act)",
      "33:1515" : "33:1515 (33:1515 Deepwater Ports Act (citizen civil action))",
      "33:2701" : "33:2701 (33:2701 Oil Pollution Act of 1940)",
      "35:0001" : "35:0001 (35:0001 Establishment of PTO)",
      "35:0032" : "35:0032 (35:0032 Suspension from Practice before Patent & Trade. Off.)",
      "35:0145" : "35:0145 (35:145 Patent Infringement)",
      "35:0146" : "35:0146 (35:0146 Appeal from Decision of the Board of Patent Appeals)",
      "35:0183" : "35:0183 (35:183 Patent Infringement)",
      "35:0256" : "35:0256 (35:0256 Patent Non-Infringement (Correction of Named Inventor))",
      "35:0271" : "35:0271 (35:271 Patent Infringement)",
      "35:0281" : "35:0281 (35:0281 Remedy for Infringement of Patent/jurisdiction conferred 28:1338)",
      "35:0282" : "35:0282 (35:0282 Patent Infringement - Defenses)",
      "35:0283" : "35:0283 (35:0283 Action to enjoin violation of right secured by patent)",
      "35:0289" : "35:0289 (35:0289 Recover profits from unlicensed use of design patent)",
      "35:0291" : "35:0291 (35:0291 Action for relief between owners; interfering patents)",
      "35:0292" : "35:0292 (35:0292 Penalty & Forfeiture; illegal use of word patent (false marking))",
      "35:0311" : "35:0311 (35:0311 Patent - Request for Inter Partes Reexamination)",
      "38:1110" : "38:1110 (38:1110 Basic Entitlements / Wartime)",
      "38:1131" : "38:1131 (38:1131 Basic Entitlements / Peacetime)",
      "38:1681" : "38:1681 (38:1681 Recovery of VA Overpayment)",
      "38:1686" : "38:1686 (38:1686 Recovery of VA Overpayment)",
      "38:1780" : "38:1780 (38:1780 Recovery of VA Overpayment)",
      "38:1816" : "38:1816 (38:1816 Deficiency balance on VA Mortgage Foreclosure (Regulations Governing the VA Loan Guaranty Pr)",
      "38:1965" : "38:1965 (38:1965 Servicemen's Group Life Insurance (Definitions))",
      "38:1975" : "38:1975 (38:1975 Recovery of Servicemen's Group Life Insurance - Jurisdiction of District Court)",
      "38:1984" : "38:1984 (38:1984 Suit for Veterans Insurance)",
      "38:2011" : "38:2011 (38:2011 - Veteran's Readjustment Assistance Act of)",
      "38:3116" : "38:3116 (38:3116 VA Overpayment)",
      "38:3481" : "38:3481 (38:3481 Recovery of VA Overpayment)",
      "38:3680" : "38:3680 (38:3680 Recovery of Education Assist Allowance Overpayment)",
      "38:4212" : "38:4212 (38:4212 Veterans Employment Emphasis Under Federal Contracts )",
      "38:4301" : "38:4301 (38:4301 Uniformed Srvs. Employment & Reemployment Rights Act (purpose))",
      "38:4302" : "38:4302 (38:4302 Veterans Reemployment Rights Act (relation to other laws and plans or agreements.)",
      "38:4311" : "38:4311 (38:4311 Uniformed Service Employment or Reemployment Rights Act (USERRA) - Discrimination)",
      "38:4312" : "38:4312 (38:4312 Rights of inducted persons to reemployment )",
      "38:4322" : "38:4322 (38:4322 Enforcement of employment or reemployment rights)",
      "38:4323" : "38:4323 (38:4323 Enforcement of rights with respect to a State or private employer)",
      "38:4324" : "38:4324 (38:4324 Enforcement of rights with respect to Federal executive agencies)",
      "38:4325" : "38:4325 (38:4325 Enforcement of rights with respect to certain Federal agencies)",
      "38:5315" : "38:5315 (38:5315 Delinquent Payment of Amounts Due to US)",
      "38:5316" : "38:5316 (38:5316 VA Overpayment )",
      "39:0403" : "39:0403 (39:0403 Discriminatory use of the Postal Service)",
      "39:0409" : "39:0409 (39:0409 Suits by and against the Postal Service)",
      "39:1207" : "39:1207 (39:1207 Review Agency Action--Labor Disputes)",
      "39:1208(b)" : "39:1208(b) (39:1208(b) Postal Reorganization Act of 1970 - Suits)",
      "39:3005" : "39:3005 (39:3005 Detention of Mail for Temporary Periods)",
      "39:3007" : "39:3007 (39:3007 Detention of Mail for Temporary Periods - Injunction directing retention of incoming mail)",
      "39:3008(e)" : "39:3008(e) (39:3008(e) Enforce compliance with a USPS Prohibitory Order)",
      "39:409" : "39:409 (39:409 Postal Service)",
      "40:0258" : "40:0258 (40:258(a) Public Buildings & Property: Land Condem)",
      "40:0270" : "40:0270 (40:270 Miller Act)",
      "40:0581" : "40:0581 (40:0581 General Authority of Administrator of General Services)",
      "40:0875" : "40:0875 (40:875 Public Buildings & Property: Negligence)",
      "40:1101" : "40:1101 (40:1101 Brooks Architect - Engineers Act)",
      "40:3131" : "40:3131 (40:3131 Bonds of contractors of public buildings )",
      "40:3142" : "40:3142 (40:3142 Davis-Bacon Act (prevailing wages))",
      "41:0251" : "41:0251 (41:251 Public Contracts-Review of Agency Action)",
      "41:1463" : "41:1463 (41:1463 Public Contracts: Unlawful Employment Prac)",
      "41:2102-2107" : "41:2102-2107 (41:2102-2107 Procurement Integrity Act)",
      "41:3301" : "41:3301 (41:3301 Competition in Contracting Act)",
      "41:6503" : "41:6503 (41:6503 Walsh-Healy Act - Breach of Public Contract)",
      "41:6505" : "41:6505 (41:6505 Exclusions - Review of legal questions in contracts; Walsh-Healy Act)",
      "41:6702 - 6704" : "41:6702 - 6704 (41:6702 - 6704 Service Contract Labor Standards / McNamara-O'Hara Service Contract Act 1965)",
      "41:7105(f)" : "41:7105(f) (41:7105(f) Action to Judicially Enforce Administrative Subpoena)",
      "42:0205" : "42:0205 (42:205 Denial Social Security Benefits)",
      "42:0206" : "42:0206 (42:206 Social Security Benefits)",
      "42:0247" : "42:0247 (42:247 Personal Injury-Swine Flu)",
      "42:0254o" : "42:0254o (42:0254o Breach of Scholarship Contract)",
      "42:0256" : "42:0256 (42:0256 Public Health Services Act - Grants)",
      "42:0292f" : "42:0292f (42:0292f Default of borrower)",
      "42:0292k" : "42:0292k (42:0292k Student loan insurance (Public Health Occupations))",
      "42:0293" : "42:0293 (42:0293 Recovery of losses from loan guarantee; public health)",
      "42:0297" : "42:0297 (42:0297 Student loans; public or nonprofit school of nursing)",
      "42:0300aa-1" : "42:0300aa-1 (42:0300aa-1 Nat'l. Childhood Vaccine Injury Compensation Act)",
      "42:0300f" : "42:0300f (42:0300f Safe Drinking Water Act (Definitions))",
      "42:0300g" : "42:0300g (42:0300g Actions re safety of public water systems (EPA))",
      "42:0300g-3" : "42:0300g-3 (42:0300g-3 Enforcement of Drinking Water Regulations)",
      "42:0401" : "42:0401 (42:0401 Social Security Act - Trust Funds)",
      "42:0402" : "42:0402 (42:402 Social Security Benefits)",
      "42:0405id" : "42:0405id (42:405 Review of HHS Decision (SSID))",
      "42:0405rs" : "42:0405rs (42:0405rs Review of HHS Decision (RSI))",
      "42:0405wc" : "42:0405wc (42:405 Review of HHS Decision (DIWC))",
      "42:0405ww" : "42:0405ww (42:405 Review of HHS Decision (DIWW))",
      "42:0416" : "42:0416 (42:416 Denial of Social Security Benefits)",
      "42:0421(d)" : "42:0421(d) (42:0421(d) Review HHS decision re disability determinations)",
      "42:0423" : "42:0423 (42:0423 Social Security Act (Disability Insurance Benefit Payments))",
      "42:0427" : "42:0427 (42:427 Social Security Benefits)",
      "42:0601" : "42:0601 (42:0601 Title IV-A of the Social Security Act (Grants to States for Aid and Assistance to Needy Fami)",
      "42:0602" : "42:0602 (42:0602 Temp. Assistance for Needy Families (TANF) )",
      "42:0660" : "42:0660 (42:0660 Action to enforce child support obligations)",
      "42:10139" : "42:10139 (42:10139 judicial review of agency actions )",
      "42:10801" : "42:10801 (42:10801 Protection & Advocacy for Individuals with Mental Illness Act of 1986 (PAIMI))",
      "42:10805" : "42:10805 (42:10805 Protection and Advocacy Systems)",
      "42:11001" : "42:11001 (42:11001 Emergency Plan. & Comm. Right to Know Act (EPCRA))",
      "42:11046" : "42:11046 (42:11046 Fed Emer Plan Comm Right-to-know Act (EPCRA) - civil actions)",
      "42:11101" : "42:11101 (42:11101 Health Care Quality Improvement Act of 1986 )",
      "42:11112" : "42:11112 (42:11112 Health Care Quality Improvement Act (Standards for Professional Review Actions))",
      "42:11601" : "42:11601 (42:11601 International Child Abduction Remedies Act)",
      "42:11603(b)" : "42:11603(b) (42:11603(b) Int'l. Child Abduction Remedies Act (ICARA) - Judicial Remedies)",
      "42:12101" : "42:12101 (42:12101 Americans with Disabilities Act)",
      "42:12102" : "42:12102 (42:12102 Americans with Disabilities Act (ADA) Disability Definition)",
      "42:12111" : "42:12111 (42:12111 Americans with Disabilities Act - Employment )",
      "42:12112" : "42:12112 (42:12112 Americans with Disabilities Act - Employment Discrimination)",
      "42:12117" : "42:12117 (42:12117 Americans with Disabilities Act - Enforcement)",
      "42:12132" : "42:12132 (42:12132 Americans with Disabilities Act - Discrimination)",
      "42:12188" : "42:12188 (42:12188 Americans With Disabilities Act - Civil Enforcement Actions)",
      "42:1320a-7b(b)(2)(A)" : "42:1320a-7b(b)(2)(A) (42:1320a-7b(b)(2)(A) Anti-Kickback Act (for federal health care programs) )",
      "42:1320d-2" : "42:1320d-2 (42:1320d-2 Health Insurance Portability And Accountability Act (HIPAA))",
      "42:1381a" : "42:1381a (42:1381a Supplemental Security Income benefits (SSID))",
      "42:1382" : "42:1382 (42:1382 Eligibility for benefits)",
      "42:1383" : "42:1383 (42:1383 Review of HHS Decision)",
      "42:1395" : "42:1395 (42:1395 HHS: Adverse Reimbursement Review)",
      "42:1395dd" : "42:1395dd (42:1395dd Exam & Treatment Emergency Med Cond & Women in Labor)",
      "42:1395hr" : "42:1395hr (42:1395hr Hospital Reimbursement for Medicare Services)",
      "42:1395w-21" : "42:1395w-21 (42:1395w-21 Medicare Act (Eligibility, Election, and Enrollment))",
      "42:1396" : "42:1396 (42:1396 - Tort Negligence)",
      "42:1396a" : "42:1396a (42:1396a State Plans for Medical Assistance)",
      "42:1396b" : "42:1396b (42:1396b Medical Assist Prgm, Pmt to States/Medicaid Implem)",
      "42:13981" : "42:13981 (42:13981 Violence Against Women Act (Civil Rights))",
      "42:14135" : "42:14135 (42:14135 DNA Backlog Grant Program)",
      "42:1437" : "42:1437 (42:1437 U.S. Housing Act of 1937)",
      "42:1471" : "42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclo)",
      "42:1475" : "42:1475 (42:1475 Declaratory & Injunctive Relief - Foreclosure Procedures)",
      "42:1479" : "42:1479 (42:1479 Mortgage, lease, contract re farm housing)",
      "42:14901" : "42:14901 (42:14901 Intercountry Adoptions)",
      "42:15483" : "42:15483 (42:15483 Help America Vote Act)",
      "42:1651" : "42:1651 (42:1651 Defense Base Act)",
      "42:1705" : "42:1705 (42:1705 Receipt of Workmen's compensation benefits)",
      "42:1971" : "42:1971 (42:1971 Voting Rights Law)",
      "42:1973" : "42:1973 (42:1973 Voting Rights Act)",
      "42:1973(a)" : "42:1973(a) (42:1973(a) Enforcement of Voting Rights)",
      "42:1973(c )" : "42:1973(c ) (42:1973(c ) Voting Rights -Qualifications & Procedures)",
      "42:1973gg-2" : "42:1973gg-2 (42:1973gg-2 Nat'l. Voter Registration Act of 1993 (NVRA))",
      "42:1981a" : "42:1981a (42:1981a Damages in cases of intentional discrim. in employment)",
      "42:1981cv" : "42:1981cv (42:1981 Civil Rights)",
      "42:1981hs" : "42:1981hs (42:1981 Housing Discrimination)",
      "42:1981jb" : "42:1981jb (42:1981 Job Discrimination (Race))",
      "42:1981ra" : "42:1981ra (42:1981ra Race Discrimination)",
      "42:1981sx" : "42:1981sx (42:1981 Sex Discrimination)",
      "42:1982hs" : "42:1982hs (42:1982hs Discrimination re property rights (housing))",
      "42:1982ra" : "42:1982ra (42:1982ra Discrimination re property rights (race))",
      "42:1982sx" : "42:1982sx (42:1982sx Discrimination re property rights (sex))",
      "42:1983bv" : "42:1983bv (42:1983bv Bivens Non-Prisoner)",
      "42:1983cv" : "42:1983cv (42:1983 Civil Rights Act)",
      "42:1983cvp" : "42:1983cvp (42:1983cvp Civil Rights (Personal Property))",
      "42:1983d" : "42:1983d (42:1983d Civil Rights (Death))",
      "42:1983dp" : "42:1983dp (42:1983dp Civil Right Denial of Due Process)",
      "42:1983ed" : "42:1983ed (42:1983 Civil Rights (Employment Discrimination))",
      "42:1983pr" : "42:1983pr (42:1983 Prisoner Civil Rights)",
      "42:1983vp" : "42:1983vp (42:1983vp Violation of Due Process and Equal Protection)",
      "42:1985" : "42:1985 (42:1985 Consipracy to interfere with civil rights)",
      "42:1986" : "42:1986 (42:1986 Neglect of Duty)",
      "42:1987" : "42:1987 (42:1987 Prosecution of violations of certain laws (violations of sec 1990 or 5506 to 5516 or 5518 to)",
      "42:1988" : "42:1988 (42:1988 Proceedings in Vindication of Civil Rights)",
      "42:1997" : "42:1997 (42:1997 Institutionalized Persons Act of 1980 )",
      "42:2000a-3pa" : "42:2000a-3pa (42:2000a-3pa Discrimination, segregation; public accommodation - Injunctive Relief)",
      "42:2000ad" : "42:2000ad (42:2000ad Job Discrimination (Disability Act))",
      "42:2000ag" : "42:2000ag (42:2000 Job Discrimination (Age))",
      "42:2000bb" : "42:2000bb (42:2000bb Religious Freedom Restoration Act of 1993)",
      "42:2000bea" : "42:2000bea (42:2000bea Equal access to public facilities)",
      "42:2000c-6ed" : "42:2000c-6ed (42:2000c-6ed Discrimination in Education)",
      "42:2000cc" : "42:2000cc (42:2000cc Religious Land Use & Institutionalized Persons Act of 2000)",
      "42:2000d" : "42:2000d (42:2000d Federally Assisted Programs)",
      "42:2000e" : "42:2000e (42:2000e Job Discrimination (Employment))",
      "42:2000e-2ag" : "42:2000e-2ag (42:2000e-2ag Job Discrimination (Age))",
      "42:2000e-2e" : "42:2000e-2e (42:2000e-2e Job Discrimination (Unlawful Employment Practices))",
      "42:2000e-2no" : "42:2000e-2no (42:2000e-2no Job Discrimination (National Origin))",
      "42:2000e-2ot" : "42:2000e-2ot (42:2000e-2ot Job Discrimination (other))",
      "42:2000e-2pb" : "42:2000e-2pb (42:2000e-2pb Job Discrimination (Public Accomodations))",
      "42:2000e-2ra" : "42:2000e-2ra (42:2000e-2ra Job Discrimination (Race))",
      "42:2000e-2rl" : "42:2000e-2rl (42:2000e-2rl Job Discrimination (religion))",
      "42:2000e-2sh" : "42:2000e-2sh (42:2000e-2sh Job Discrimination (Sexual Harassment))",
      "42:2000e-2sx" : "42:2000e-2sx (42:2000e-2sx Job Discrimination (Sex))",
      "42:2000e-5eeo" : "42:2000e-5eeo (42:2000e-5eeo Petition to Enforce EEOC Subpoena)",
      "42:2000pb" : "42:2000pb (42:2000 Job Discrimination (Public Accomodations))",
      "42:2000ra" : "42:2000ra (42:2000 Job Discrimination (Race))",
      "42:2000sx" : "42:2000sx (42:2000 Job Discrimination (Sex))",
      "42:2003" : "42:2003 (42:2003 Job Discrimination)",
      "42:2005" : "42:2005 (42:2005 Review of Agency Action-HHS)",
      "42:2210" : "42:2210 (42:2210 Indeminification & Limitation of Liability-Financial)",
      "42:2651" : "42:2651 (42:2651 Medical Care Recovery)",
      "42:2996" : "42:2996 (42:2996 Legal Services Corporation Act)",
      "42:3058(g)" : "42:3058(g) (42:3058(g) Older American's Act of 1965, 42 U.S.C. 3058(g) (State Long-term Care Ombudsman Program))",
      "42:3121" : "42:3121 (42:3121 Public Works and Economic Development Act of 1965)",
      "42:3133" : "42:3133 (42:3133 Coordination - Grants for Public Works and Economic Development)",
      "42:3601" : "42:3601 (42:405 Fair Housing Act)",
      "42:3604(f)(3)(c )" : "42:3604(f)(3)(c ) (42:3604(f)(3)(c ) Fair Housing Amendments Act)",
      "42:3610" : "42:3610 (42:3610 Fair Housing Act-Administrative Enforcement; Preliminary Matters)",
      "42:3612" : "42:3612 (42:3612 Civil rights in housing - Enforcement by Secretary)",
      "42:3613" : "42:3613 (42:3613 Action for inj relief re deprivation of civil rights)",
      "42:4000" : "42:4000 (42:4000 National Flood Insurance Act)",
      "42:4001" : "42:4001 (42:4001 National Insurance Flood Act)",
      "42:4013" : "42:4013 (42:4013 National Flood Insurance Act - Nature and Limitation of Insurance Coverage)",
      "42:4053" : "42:4053 (42:4053 Breach of Insurance Contract)",
      "42:4072" : "42:4072 (42:4072 Payment of Flood Insurance Claim)",
      "42:4321" : "42:4321 (42:4321 Review of Agency Action-Environment)",
      "42:4332" : "42:4332 (42:4332 Environmental Policy - Coop of Agency Repo)",
      "42:4721" : "42:4721 (42:4721 Intergovernmental Personnel Act (findings and purposes))",
      "42:4821" : "42:4821 (42:4821 Lead-Based Paint Poisoning Prevention Act (findings and purposes) )",
      "42:4901" : "42:4901 (42:4901 Noise Control Act of 1972 (findings and purposes))",
      "42:4910(c )" : "42:4910(c ) (42:4910(c ) Action to restrain violation re noise control)",
      "42:5101" : "42:5101 (42:5101 Child Abuse Prevention and Treatment Act)",
      "42:5303" : "42:5303 (42:5303 Block Grant Act of 1974 (42 USC 5301-5321))",
      "42:5401" : "42:5401 (42:5401 Natl Mnfactrd Housing Cnstr Safety Standard Act 1974 (findings and purposes))",
      "42:5411" : "42:5411 (42:5411 Housing Construction and Safety Standards Act - Injunctive Relief)",
      "42:5851" : "42:5851 (42:5851 Discrimination Whistle blower Employee - ERA (employee protection))",
      "42:6101" : "42:6101 (42:6101 Age Discrimination in Federally Assisted Programs (statement of purpose))",
      "42:6201" : "42:6201 (42:6201 Energy Policy & Conservation Act (statement of purpose))",
      "42:6393" : "42:6393 (42:6393 Controversies under Energy Policy & Conservation Act (Admin Procedure and Judicial Review))",
      "42:6901en" : "42:6901en (42:6901 Environmental Cleanup Expenses)",
      "42:6901rs" : "42:6901rs (42:6901 Resource & Recovery Act)",
      "42:6928" : "42:6928 (42:6928 Violations of requirements of hazardous Waste Mgmt (federal enforcement))",
      "42:6961" : "42:6961 (42:6961 Federal Facilities Compliance Act)",
      "42:6972" : "42:6972 (42:6972 Resource & Recovery Act - Citizen Suit)",
      "42:6972(a)" : "42:6972(a) (42:6972(a) Solid Waste Disposal Act - Citizen Suit)",
      "42:7192" : "42:7192 (42:7192 Controversies under Dept of Energy Organization Act - Judicial Review)",
      "42:7384" : "42:7384 (42:7384 Energy Employees Occupational Illness Compensation Program Act (EEOICPA))",
      "42:7401" : "42:7401 (42:7401 Clean Air Act (findings & declarations))",
      "42:7412" : "42:7412 (42:7412 Air Pollution Control - emission standards )",
      "42:7413" : "42:7413 (42:7413(b) Clean Air Act)",
      "42:7413(b)" : "42:7413(b) (42:7413(b) Clean Air Act - Enforcement)",
      "42:7475" : "42:7475 (42:7475 Clean Air Act - Preconstruction Requirements)",
      "42:7545" : "42:7545 (42:7545 Air Pollution Prevention - Regulation of Fuels)",
      "42:7603" : "42:7603 (42:7603 Action for immediate restraint (Emergency Powers))",
      "42:7604" : "42:7604 (42:7604 Clean Air Act - Citizen suit to enforce Clean Air Act)",
      "42:7604(f)cl" : "42:7604(f)cl (42:7604(f)cl Clear Air Act - Emission Standards)",
      "42:7604cl" : "42:7604cl (42:7604 Clear Air Act (Emission Standards))",
      "42:7604ir" : "42:7604ir (42:7604 Petition to Quash IRS Summons)",
      "42:7671" : "42:7671 (42:7671 Clean Air Act (Stratospheric Ozone Protection) (Definitions))",
      "42:8324" : "42:8324 (42:8324 Powerplant and Industrial Fuel Use - terms and conditions)",
      "42:8351" : "42:8351 (42:8351 Powerplant and Industrial Fuel Use - Temporary Exemptions)",
      "42:9601" : "42:9601 (42:9601 Comprehensive Environmental Compen/Resp/Liab (CERCLA) (Definitions))",
      "42:9604" : "42:9604 (42:9604 Comprehensive Envir., Response, Comp. & Liab. Act (CERCLA) - Removal and Other Remedial Acti)",
      "42:9607" : "42:9607 (42:9607 Real Property Tort to Land)",
      "42:9613" : "42:9613 (42:9613 Comp Environ Recovery Comp & Liability Act (CERCLA) - Civil Proceedings)",
      "43:0421" : "43:0421 (43:0421 Complaint in Condemnation - Eminent Domain)",
      "43:0945a" : "43:0945a (43:0945a Compensation for Land Condemnation )",
      "43:0945b" : "43:0945b (43:0945b Complaint in Condemnation - Easements)",
      "43:0946" : "43:0946 (43:0946 Complaint in Condemnation - Right of Way for Irrigation and Drainage Projects)",
      "43:1331" : "43:1331 (43:1331 Outer Continental Shelf Lands Act (Definitions))",
      "43:1333" : "43:1333 (43:1333 Outer Continental Shelf Lands Act - Laws and Regulations Governing Lands)",
      "43:1349" : "43:1349 (43:1349 Outer Continental Land Shelf Act - Citizen Suits)",
      "43:1701" : "43:1701 (43:1701 Violation of Federal Land Policy and Management Act (FLPMA))",
      "43:1737" : "43:1737 (43:1737 FLPMA - Implementation Provisions)",
      "43:945" : "43:945 (43:945 Compensation for Land Condemnation)",
      "43:945a" : "43:945a (43:945a Complaint in Condemnation)",
      "43:946" : "43:946 (43:946 Complaint in Condemnation - Eminent Domain)",
      "44:2107" : "44:2107 (44:2107 Presidential Recordings and Materials Act (NARA acceptance of records for historical preserv)",
      "45:0051" : "45:0051 (45:51 Railways: Fed. Employer's Liability Act)",
      "45:0056" : "45:0056 (45:0056 Employers Liability Act - Personal Inj re Railroads (bringing an action))",
      "45:0151" : "45:0151 (45:151 Railway Labor Act)",
      "45:0152" : "45:0152 (45:0152 Railway Labor Act - General Duties)",
      "45:0153" : "45:0153 (45:0153 First Railway Labor Act - National Railroad Adjustment Board)",
      "45:0159" : "45:0159 (45:0159 Review of arbitration award (RR Carriers/Mediation Bd))",
      "45:0184" : "45:0184 (45:184 Action to Set Aside Award of a System Board)",
      "45:0231(f)" : "45:0231(f) (45:0231(f) Compel obedience to order of Railroad Retirement Bd)",
      "45:0351" : "45:0351 (45:0351 Railroad Unemployment Insurance Act)",
      "45:0719" : "45:0719 (45:0719 Regional Rail Reorganization Act of 1973 (judicial review))",
      "45:1105" : "45:1105 (45:1105 Northeast Rail Service Act - Judicial Review)",
      "45:1395" : "45:1395 (45:1395 Railroads: Adverse Reimbursement Review)",
      "45:7457" : "45:7457 (45:7457 Compel Reclamation Under Clear Air Act)",
      "46:0688" : "46:0688 (46:688 Jones Act)",
      "46:0741" : "46:0741 (46:741 Shipping)",
      "46:0761" : "46:0761 (46:761 Shipping: Damages for Death on High Seas)",
      "46:1101" : "46:1101 (46:1101 Violation of Maritime Regulations)",
      "46:1156" : "46:1156 (46:1156 Administrative Procedure Act)",
      "46:2114" : "46:2114 (46:2114 Wrongful Discharge from Employment - protection from discrimination)",
      "46:30101" : "46:30101 (46:30101 Extension of jurisdiction to cases of damage or injury on land)",
      "46:30104" : "46:30104 (46:30104 Marine Personal Injury - Jones Act)",
      "46:30302" : "46:30302 (46:30302 Shipping: Damages for Death on High Seas )",
      "46:30304" : "46:30304 (46:30304 Breach of Maritime Contract - liability of noncompliance)",
      "46:30503" : "46:30503 (46:30503 Limitation of Liability - declaration of nature and value of goods)",
      "46:30504" : "46:30504 (46:30504 Limitation of Liability - loss by fire)",
      "46:30505-30510" : "46:30505-30510 (46:30505-30510 Exoneration, Limitation of Liability)",
      "46:30511" : "46:30511 (46:30511 Action by owner for limitation)",
      "46:30701" : "46:30701 (46:30701 Marine Cargo Loss or Damage - Liability of Water Carriers)",
      "46:30704" : "46:30704 (46:30704 Liability of Water Carriers - Loading, stowage, custody, care, and delivery)",
      "46:30902 to 30911" : "46:30902 to 30911 (46:30902 to 30911 Suits in Admiralty Act )",
      "46:31102" : "46:31102 (46:31102 Public Vessels Act - Waiver of Immunity)",
      "46:31301" : "46:31301 (46:31301 Federal Maritime Lien Act)",
      "46:31301 to 31343" : "46:31301 to 31343 (46:31301 to 31343 Maritime Commercial Instruments and Liens Act)",
      "46:31321" : "46:31321 (46:31321 Foreclosure of Preferred Ship Mortgages)",
      "46:31325" : "46:31325 (46:31325 Suit to enforce lien upon mortgaged vessel-foreclosure / Foreclosure of Preferred Foreign S)",
      "46:31341" : "46:31341 (46:31341 Federal Maritime Lien Act)",
      "46:31342" : "46:31342 (46:31342 Breach of Maritime Contract (establishing maritime liens))",
      "46:31343" : "46:31343 (46:31343 Commercial Instruments & Maritime Liens)",
      "46:40101" : "46:40101 (46:40101 Shipping Act of 1998 )",
      "46:41102(a)" : "46:41102(a) (46:41102(a) Shipping Act of 1984 - General Prohibitions)",
      "46:41309" : "46:41309 (46:41309 Shipping Act of 1984 - Enforcement of Reparation Orders)",
      "46:50101" : "46:50101 (46:50101 Violation of Maritime Regulations )",
      "46:58109" : "46:58109 (46:58109 Violation of Merchant Marine Act - Penalties)",
      "47:0151" : "47:0151 (47:0151 Federal Communications Act of 1934)",
      "47:0151cs" : "47:0151cs (47:0151cs Federal Communications Act - Collection for Services)",
      "47:0201bt" : "47:0201bt (47:0201bt Breach of Tariff)",
      "47:0203" : "47:0203 (47:0203 Telecommunications Collection of Charges)",
      "47:0205" : "47:0205 (47:0205 Wire and Radio Communication Svc and Charges (Recovery of Damages) )",
      "47:0206" : "47:0206 (47:0206 Carrier's Liability for Damages)",
      "47:0227" : "47:0227 (47:0227 FCC-Unsolicited Telephone Sales)",
      "47:0227(b)(3)" : "47:0227(b)(3) (47:0227(b)(3) Telephone Consumer Protection Act of 1991)",
      "47:0251" : "47:0251 (47:0251 Telecommunications Act of 1996 - Interconnection)",
      "47:0252" : "47:0252 (47:0252 Telecommunications Act)",
      "47:0254(h)" : "47:0254(h) (47:0254(h) Children's Internet Protection Act)",
      "47:0332" : "47:0332 (47:0332 FCA-Wire or Radio Communications (Mobile Services))",
      "47:0332(c )" : "47:0332(c ) (47:0332(c ) Federal Telecommunications Act of 1996)",
      "47:0338" : "47:0338 (47:0338 Satellite Home Viewer Improvement Act)",
      "47:0401" : "47:0401 (47:0401 Application of Federal Communication Comm for Inj. (Enforcement Provisions))",
      "47:0407" : "47:0407 (47:0407 Order for payment of money; petition for enforcement;)",
      "47:0510" : "47:0510 (47:0510 Forfeiture of Communications Devices)",
      "47:0521" : "47:0521 (47:0521 Cable Televsn. Consumer Protection & Competition Act of 1992)",
      "47:0532" : "47:0532 (47:0532 Cable Communication Policy Act of 1984)",
      "47:0551" : "47:0551 (47:0551 Cable Communications Act)",
      "47:0553" : "47:0553 (47:0553 U.S.C.A. Cable Communications Policy Act)",
      "47:0605" : "47:0605 (47:0605 Unlawful Reception Broadcast Signal i.e., Satellite - Theft of Satellite Communications)",
      "47:227" : "47:227 (Restrictions on use of telephone equipment)",
      "48:0883" : "48:0883 (48:883 Violation of US Coastal Law)",
      "48:1985" : "48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)",
      "49:0081" : "49:0081 (49:81 Damaged Goods While Being Transported)",
      "49:0101" : "49:0101 (49:0101 ICC Termination Act of 1996)",
      "49:0502" : "49:0502 (49:0502 Transportation Administrative Subpoena)",
      "49:0781" : "49:0781 (49:781 Forfeiture)",
      "49:10101" : "49:10101 (49:10101 Interstate Commerce Act-Interstate Transportation Rail)",
      "49:10743" : "49:10743 (49:10743 Revised Interstate Commerce Act)",
      "49:11101" : "49:11101 (49:11101 Interstate Commerce Act)",
      "49:1113" : "49:1113 (49:1113 Petition to enforce administrative summon)",
      "49:1136" : "49:1136 (49:1136 Aviation Disaster Family Assistance Act of 1996)",
      "49:11501" : "49:11501 (49:11501 Railroad Revitalization & Regulatory Reform Act (General jurisdiction))",
      "49:11502" : "49:11502 (49:11502 Railroad Revitalization Regulatory Reform (authority to exempt rail carrier transportation))",
      "49:11503" : "49:11503 (49:11503 Railroad Revitalization Regulatory Reform)",
      "49:11701" : "49:11701 (49:11701 General authority of enforcement of regulations in rail)",
      "49:11702" : "49:11702 (49:11702(a)(4) Violations of Interstate Commerce A)",
      "49:11705" : "49:11705 (49:11705 Limitation on actions by and against rail carriers)",
      "49:11706" : "49:11706 (49:11706 Carmack Amendent (Liability of carriers under receipts and bills of lading))",
      "49:11707" : "49:11707 (49:11707 Carmack Amendment (Liability when property is delivered in violation of routing instruction)",
      "49:13101" : "49:13101 (49:13101 Transportation Policy)",
      "49:13702" : "49:13702 (49:13702 Tariff requirement for certain transportation)",
      "49:13706" : "49:13706 (49:13706 Motor Carriers, etc-Liability for Payment of Rates)",
      "49:14501" : "49:14501 (49:14501 Preemption (federal authority of intrastate transportation))",
      "49:14705" : "49:14705 (49:14705 Interstate Commerce Act/Carmack Amendment (Limitations on actions by and against carriers))",
      "49:14706" : "49:14706 (49:14706 Carmack Amendment to the Interstate Commerce Act / Liability of Carriers - Receipts & Bills)",
      "49:1471" : "49:1471 (49:1471 Federal Aviation Act)",
      "49:1903" : "49:1903 (49:1903 Petition to enforce administrative summon)",
      "49:20301-20306" : "49:20301-20306 (49:20301-20306 Federal Safety Appliance Act)",
      "49:21302" : "49:21302 (49:21302 Carriers violations of Interstate Commerce Act (Chapter 201 accident and incident violation)",
      "49:30101" : "49:30101 (49:30101 National Traffic & Motor Vehicle Safety Act )",
      "49:30112" : "49:30112 (49:30112 Motor Vehicle Safety (prohibition on non-complying motor vehicles and equipment))",
      "49:30502" : "49:30502 (49:30502 Natl Motor Vehicle Title Information Syst)",
      "49:31114" : "49:31114 (49:31114 Access to Interstate System/Commercial Motor Vehicle )",
      "49:31502" : "49:31502 (49:31502 Motor Carrier Safety: Requirements for Qualifications)",
      "49:32101" : "49:32101 (49:32101 Motor Vehicle Information and Costs Savings Act)",
      "49:32701" : "49:32701 (49:32701 Odometer Requirements Act)",
      "49:32710" : "49:32710 (Odometers Act)",
      "49:40101" : "49:40101 (49:40101 Federal Aviation Act)",
      "49:40102" : "49:40102 (49:40102 Airline Deregulation Actv(definitions of air and commerce safety) )",
      "49:40105" : "49:40105 (49:40105 Warsaw Convention )",
      "49:41705" : "49:41705 (49:41705 Air Carrier Access Act (discrimination against handicapped individuals))",
      "49:41713" : "49:41713 (49:41713 Airline Deregulation Actv (premp of authority over prices, routes, and service))",
      "49:44709" : "49:44709 (49:44709 Noise Control Act of 1972 )",
      "49:44715" : "49:44715 (49:44715 Noise Control Act of 1972 )",
      "49:46507" : "49:46507 (49:46507 False information and threats)",
      "49:47101" : "49:47101 (49:47101 Airport and Airway Improvement Act of 1982)",
      "49:47501" : "49:47501 (49:47501 Aviation Safety & Noise Abatement Act of 1979 )",
      "49:49101" : "49:49101 (49:49101 Wrongful Termination in Contravention of Published Regulations)",
      "49:49104" : "49:49104 (49:49104 Breach of Lease by Metro. Wash. Airport Auth.)",
      "49:60101" : "49:60101 (49:60101 Pipeline Safety Act of 1994)",
      "49:60102" : "49:60102 (49:60102 Hazardous Liquid Pipeline Safety Act of 1979 (HLPSA))",
      "49:80102" : "49:80102 (49:80102 Bills of Lading - Application)",
      "49:80302" : "49:80302 (49:80302 Contraband - Prohibitions)",
      "49:80303" : "49:80303 (49:80303 Seizure and forfeiture of vessel or aircraft conveying contraband )",
      "50:1701-1706" : "50:1701-1706 (50:1701-1706 International Emergency Economic Powers Act)",
      "50a:0001" : "50a:0001 (50a:0001 Trading With the Enemy Act (act located in Title 50, Appendix.))",
      "50a:0501" : "50a:0501 (50a:0501 Sailors and Soldiers Civil Relief Act (act located in Title 50, Appendix.))",
      "50a:0533" : "50a:0533 (50a:0533 Servicemembers Civil Relief Act-mortgages (act located in Title 50, Appendix.))",
      "50a:0540" : "50a:0540 (50a:0540 Sailors and Soldiers Civil Relief Act (act located in Title 50, Appendix.))",
      "50a:2412" : "50a:2412 (50a:2412 Export Administration Act--1979 (act located in Title 50, Appendix.))",
      "51:20137(a)" : "51:20137(a) (51:20137(a) Malpractice & Negligence Against U.S. Space program )",
      "8:287" : "8:287 (8:287 Petition to Enforce INS Subpoena)",
      "misc" : "misc (Civil Miscellaneous Case)"
   },
   "laedce" : {
      "00:0000" : "00:0000 (00:0000 Cause Code Unknown)",
      "02:0431" : "02:0431 (02:431 Fed. Election Commission: Failure Enforce Compliance)",
      "02:0437" : "02:0437 (02:437 Federal Election Commission)",
      "05:0075" : "05:0075 (05:75(2) Contract - Reduction in Grade)",
      "05:0551" : "05:0551 (05:551 Administrative Procedure Act)",
      "05:0552ad" : "05:0552ad (05:0552 Administrative Procedure Act)",
      "05:0552fi" : "05:0552fi (05:552 Freedom of Information Act)",
      "05:0552pa" : "05:0552pa (05:552 Right to Privacy Act)",
      "05:0554" : "05:0554 (05:0554 Constitutionality of Maritime Statutes)",
      "05:0701" : "05:0701 (05:0701 Maritime Subsidy Board)",
      "05:0702" : "05:0702 (05:702 Administrative Procedure Act)",
      "05:0704" : "05:0704 (05:704 Labor Litigation)",
      "05:0706" : "05:0706 (05:0706 Jud. Review of Food Stamp Rev. Program)",
      "05:2302" : "05:2302 (05:2302 Federal Whistleblowing Act)",
      "05:7703" : "05:7703 (05:7703 Discrimination - Review of Agency Act)",
      "07:0006" : "07:0006 (07:0006(b) Federal Commodity Exchange Regulation)",
      "07:0025" : "07:0025 (07:0025 Fraud - Commodities Leverage Contracts)",
      "07:0181" : "07:0181 (07:181 Packers & Stockyard Act)",
      "07:0499" : "07:0499 (07:499 Agricultural Commodities Act)",
      "07:0601" : "07:0601 (07:601 USDA Condemnation)",
      "07:1721" : "07:1721 (07:1721 Agricultural Trade Development Asst Act)",
      "07:1930" : "07:1930 (07:1930 Perishable Agric. Comm. Act of 1930)",
      "07:2023" : "07:2023 (07:2023 Food Stamp Act)",
      "07:2321" : "07:2321 (07:2321 Plant Variety Protection Act)",
      "08:0287" : "08:0287 (08:0287 Petition to Enforce INS Subpoena)",
      "08:1101" : "08:1101 (08:1101 Immigration & Nationality Act)",
      "08:1105" : "08:1105 (08:1105(a) Aliens: Habeas Corpus to Release INS Detainee)",
      "08:1251" : "08:1251 (08:1251 Immigration and Nationality Act)",
      "08:1252" : "08:1252 (08:1252(a)(2) Injunction for Deportation)",
      "08:1255" : "08:1255 (08:1255 - Immigration and Nationality Act)",
      "08:1260" : "08:1260 (08:1260 Aliens: Access to Records)",
      "08:1324" : "08:1324 (08:1324 Aliens: Complaint for Forfeiture)",
      "08:1329" : "08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petition)",
      "08:1446" : "08:1446 (08:1446 Petition for Naturalization Hearing)",
      "08:1447" : "08:1447 (08:1447 Review of Denial of Naturalization Application)",
      "09:0001" : "09:0001 (09:1 U.S. Arbitration Act)",
      "09:0004" : "09:0004 (09:0004 Arbitration)",
      "09:0008" : "09:0008 (09:0008 Declaratory Judgment/Admiralty)",
      "09:0009" : "09:0009 (09:0009 Motion to Confirm Arbitration Award)",
      "09:0010" : "09:0010 (09:0010 Petition to Vacate Arbitration Award)",
      "09:0201" : "09:0201 (09:0201 Recognition & Enforcement of Foreign Arbitral Awards)",
      "09:0205" : "09:0205 (09:0205 - Enforcement of Foreign Arbital Awards)",
      "10:1552" : "10:1552 (10:1552 Armed Forces: Action to Correct Records)",
      "10:1553" : "10:1553 (10:1553 Armed Forces: FOIA General)",
      "10:2305" : "10:2305 (10:2305 Review of Federal Contract)",
      "11:0101" : "11:0101 (11:101 Bankruptcy)",
      "11:1445" : "11:1445 (11:1445 Collection of a Discharged Obligation)",
      "12:0022" : "12:0022 (12:22 Securities Fraud)",
      "12:0635" : "12:0635 (12:635 Breach of Insurance Contract)",
      "12:1421" : "12:1421 (12:1421 Federal Home Loan Bank Act)",
      "12:1421fi" : "12:1421fi (12:1421fi FIRRE)",
      "12:1461" : "12:1461 (12:1461 Homeowners Loan Act)",
      "12:1703" : "12:1703 (12:1703 Default of HUD Loan)",
      "12:1725" : "12:1725 (12:1725 Collection under Contract Guaranty)",
      "12:1730" : "12:1730 (12:1730 Collection Under Contract Guaranty)",
      "12:1818" : "12:1818 (12:1818 Recovery On Notes By FDIC)",
      "12:1819" : "12:1819 (12:1819 Default of Promissory Note)",
      "12:1821" : "12:1821 (12:1821 Default of Loan by Promissary Note)",
      "12:1971" : "12:1971 (12:1971 Relief under Bank Holding Act)",
      "12:2601" : "12:2601 (12:2601 Real Estate Settlement Procedures Act)",
      "12:3410" : "12:3410 (12:3410 Right to Financial Privacy Act)",
      "12:3479" : "12:3479 (12:3479 Louisiana Watercraft Statute)",
      "12:4010" : "12:4010 (12:4010 Violation of Expedited Funds Availability Act)",
      "14:1125" : "14:1125 (14:1125 Anticybersquatting Piracy Act)",
      "15:0001" : "15:0001 (15:1 Antitrust Litigation)",
      "15:0002at" : "15:0002at (15:2 Antitrust Litigation)",
      "15:0002fi" : "15:0002fi (15:0002fi Fair Labor Standards Act)",
      "15:0002fl" : "15:0002fl (15:2(a) Fair Labor Standards Act)",
      "15:0005" : "15:0005 (15:5(a) Fair Labor Standards Act)",
      "15:0015" : "15:0015 (15:15 Antitrust Litigation)",
      "15:0025" : "15:0025 (15:25 Clayton Act)",
      "15:0044" : "15:0044 (15:44 Trademark Infringement)",
      "15:0045" : "15:0045 (15:0045 Federal Trade Commission Act)",
      "15:0052" : "15:0052 (15:0052 Federal Trade Commission Act)",
      "15:0053" : "15:0053 (15:0053 Federal Trade Commission Act)",
      "15:0053b" : "15:0053b (15:0053(b) Prelim & Perm Inj Relief & Other Equitable Relief)",
      "15:0077" : "15:0077 (15:77 Securities Fraud)",
      "15:0078" : "15:0078 (15:78m(a) Securities Exchange Act)",
      "15:0631" : "15:0631 (15:631 Small Business Act)",
      "15:0717" : "15:0717 (15:0717 Natural Gas Act)",
      "15:1051" : "15:1051 (15:1051 Trademark Infringement)",
      "15:1114" : "15:1114 (15:1114 Trademark Infringement)",
      "15:1121" : "15:1121 (15:1121 Trademark Infringement)",
      "15:1125" : "15:1125 (15:1125 Trademark Infringement (Lanham Act))",
      "15:1126" : "15:1126 (15:1126 Patent Infringement)",
      "15:1127" : "15:1127 (15:1127 Trademark Infringement)",
      "15:1221" : "15:1221 (15:1221 Auto Dealer Suits Agst Manufactures)",
      "15:1267" : "15:1267 (15:1267 Federal Hazardous Substances Act)",
      "15:1601" : "15:1601 (15:1601 Truth in Lending)",
      "15:1640" : "15:1640 (15:1640 Truth in Lending)",
      "15:1681" : "15:1681 (15:1681 Fair Credit Reporting Act)",
      "15:1691" : "15:1691 (15:1691 Equal Credit Opportunity Act)",
      "15:1692" : "15:1692 (15:1692 Fair Debt Collection Act)",
      "15:1709" : "15:1709 (15:1709 Other Fraud)",
      "15:1938" : "15:1938 (15:1938 Fair Labor Standards Act)",
      "15:1981" : "15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))",
      "15:1988" : "15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))",
      "15:1989" : "15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))",
      "15:2301" : "15:2301 (15:2301 Magnuson-Moss Warranty Act)",
      "15:2616" : "15:2616 (15:2616 Environmental Matters)",
      "15:2801" : "15:2801 (15:2801 Petroleum Marketing Practices Act)",
      "15:6801" : "15:6801 (15:6801 - Gram-Leach-Bliley Act)",
      "16:0668" : "16:0668 (16:668 Bald Eagle Protection Act)",
      "16:0703" : "16:0703 (16:703 Migratory Bird Act)",
      "16:1538" : "16:1538 (16:1538 Endangered Species Act)",
      "16:3371" : "16:3371 (16:3371 Wildlife Under the Lacey Act)",
      "16:3372" : "16:3372 (16:3372 Conservation: Complaint for Forfeiture)",
      "16:3373" : "16:3373 (16:3373 Appeal of Decision - DOI)",
      "16:3374" : "16:3374 (16:3374 Conservation: Complaint for Forfeiture)",
      "17:0101" : "17:0101 (17:101 Copyright Infringement)",
      "17:0201" : "17:0201 (17:0201 - Ownership of Copyright)",
      "17:0501" : "17:0501 (17:501 Copyright Infringement)",
      "17:0504" : "17:0504 (17:504 Copyright Infringement)",
      "18:0241" : "18:0241 (18:241 Conspiracy Against Citizen Rights)",
      "18:1030" : "18:1030 (18:1030 United States Computer Fraud Abuse Act)",
      "18:1836a" : "18:1836a (18:1836(a) Injunction against Misappropriation of Trade Secrets)",
      "18:1836b" : "18:1836b (18:1836(b) Civil Action to Protect Trade Secrets)",
      "18:1961" : "18:1961 (18:1961 Racketeering (RICO) Act)",
      "18:1962" : "18:1962 (18:1962 Racketeering (RICO) Act)",
      "18:1964" : "18:1964 (18:1964 Racketeering (RICO) Act)",
      "18:2252" : "18:2252 (18:2252 Assault, Internet Pornography)",
      "18:2510" : "18:2510 (18:2510 Electronic Communications Privacy Act)",
      "18:2707" : "18:2707 (18:2707 Electronic Communication Privacy Act)",
      "18:4208" : "18:4208 (18:4208(B) Agency Action Review)",
      "18:925c" : "18:925c (18:925(c) Petition for Relief from Disabilities under FFA)",
      "19:1305" : "19:1305 (19:1305 Custom Duties:0Forfeiture-Immoral Articles)",
      "20:1080" : "20:1080 (20:1080 Student Loan Recovery)",
      "20:1087" : "20:1087 (20:1087 Student Loan Recovery)",
      "20:1097" : "20:1097 (20:1097 Education - fraud)",
      "20:1332" : "20:1332 (20:1332 - E.R.I.S.A.)",
      "20:1400" : "20:1400 (20:1400 Civil Rights of Handicapped Child)",
      "20:1401" : "20:1401 (20:1401 Education: Handicapped Child Act)",
      "20:1412" : "20:1412 (20:1412 Disabilities Education Act)",
      "21:0301" : "21:0301 (21:0301 Food, Drug & Cosmetic Act)",
      "21:0332" : "21:0332 (21:0332 Federal Food, Drug & Cosmetic Act)",
      "21:0360" : "21:0360 (21:0360 - Federal Food, Drug & Cosmetic Act)",
      "21:0601" : "21:0601 (21:0601 Federal Meat Inspection Act(FMIA))",
      "21:0841" : "21:0841 (21:841 Forfeiture Property-Drugs)",
      "21:0881" : "21:0881 (21:881 Forfeiture Property-Drugs)",
      "21:0881a" : "21:0881a (21:881 Forfeiture Property - Aircraft)",
      "21:0881re" : "21:0881re (21:881 Forfeiture Property - Real Estate)",
      "22:3612" : "22:3612 (22:3612 Claim for Damage to Panama Canal)",
      "22:3776" : "22:3776 (22:3776 Panama Canal Commission Action)",
      "22:3777" : "22:3777 (22:3777 Allision in Panama Canal Locks)",
      "23:0134" : "23:0134 (23:134 P.I.- Auto Negligence)",
      "23:1441" : "23:1441 (23:1441 Contract Real Estate)",
      "24:1000" : "24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)",
      "25:0640" : "25:0640 (25:640 Indian Tribal Rights)",
      "25:1901" : "25:1901 (25:1901 Indian Child Welfare Act)",
      "26:6212" : "26:6212 (26:6212 Injunctive Relief from IRS Lien)",
      "26:6213" : "26:6213 (26:6213 Injunctive Relief from IRS Lien)",
      "26:6320" : "26:6320 (26:6320 - Ntc of Determ. Concerning Collection Action(s))",
      "26:6502" : "26:6502 (26:6502 IRS: Enforcement of tax liens)",
      "26:6532" : "26:6532 (26:6532 IRS: Refund of Tax Penalty)",
      "26:6702" : "26:6702 (26:6702 IRS: Refund of Income Tax Penalty)",
      "26:6703" : "26:6703 (26:6703 IRS: Refund of Tax Penalty)",
      "26:7401" : "26:7401 (26:7401 IRS: Tax Liability)",
      "26:7402" : "26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)",
      "26:7403" : "26:7403 (26:7403 Suit to Enforce Federal Tax Lien)",
      "26:7422" : "26:7422 (26:7422 IRS Tax Suit)",
      "26:7422rt" : "26:7422rt (26:7422 IRS: Refund Taxes)",
      "26:7422rx" : "26:7422rx (26:7422 IRS: Refund Excise Tax)",
      "26:7426" : "26:7426 (26:7426 IRS: Wrongful Levy for Taxes)",
      "26:7429" : "26:7429 (26:7429 IRS: Tax Jeopardy Assessment)",
      "26:7430" : "26:7430 (26:7430 IRS Tax Suit)",
      "26:7609" : "26:7609 (26:7609 IRS: Petition to Quash IRS Summons)",
      "27:0185" : "27:0185 (27:185 Enforcement of Arbitration Award)",
      "28:0051" : "28:0051 (28:0051 Personal Injury)",
      "28:0157c" : "28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)",
      "28:0157d" : "28:0157d (28:0157 Motion for Withdrawal of Reference)",
      "28:0158" : "28:0158 (28:0158 Notice of Appeal re Bankruptcy Matter (BAP))",
      "28:0185" : "28:0185 (28:185 Suit to Compel Arbitration)",
      "28:0451" : "28:0451 (28:451 Employment Discrimination)",
      "28:0794" : "28:0794 (28:794 Rehabilitation Act)",
      "28:1001" : "28:1001 (28:1001 E.R.I.S.A.)",
      "28:1132" : "28:1132 (28:1132 E.R.I.S.A.)",
      "28:1291" : "28:1291 (28:1291 Maritime)",
      "28:1300" : "28:1300 (28:1300 Cargo Damage/Loss)",
      "28:1301" : "28:1301 (28:1301 Cargo Loss or Damage)",
      "28:1330" : "28:1330 (28:1330 Breach of Contract)",
      "28:1331" : "28:1331 (28:1331 Fed. Question)",
      "28:1331al" : "28:1331al (28:1331 Fed. Question: Airline Crash)",
      "28:1331at" : "28:1331at (28:1331 Fed. Question: Anti-trust)",
      "28:1331au" : "28:1331au (28:1331 Fed. Question: Auto Negligence)",
      "28:1331b" : "28:1331b (28:1331 Federal Question: Bivens Act)",
      "28:1331bc" : "28:1331bc (28:1331 Fed. Question: Breach of Contract)",
      "28:1331ca" : "28:1331ca (28:1331 Fed Question: Fed Communications Act of 1934)",
      "28:1331cm" : "28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)",
      "28:1331cv" : "28:1331cv (28:1331 Federal Question: Other Civil Rights)",
      "28:1331ed" : "28:1331ed (28:1331 Fed. Question: Employment Discrimination)",
      "28:1331es" : "28:1331es (28:1331 Enforcement of Administrative Subpoena)",
      "28:1331fl" : "28:1331fl (28:1331 Fed. Question: Fair Labor Standards)",
      "28:1331in" : "28:1331in (28:1331 Fed. Question: Insurance Contract)",
      "28:1331mm" : "28:1331mm (28:1331 Fed. Question: Medical Malpractice)",
      "28:1331pi" : "28:1331pi (28:1331 Fed. Question: Personal Injury)",
      "28:1331rd" : "28:1331rd (28:1331 Fed. Question: Review Agency Decision)",
      "28:1331rp" : "28:1331rp (28:1331(a) Fed. Question: Real Property)",
      "28:1331rr" : "28:1331rr (28:1331 Fed. Question: Railway Labor Act)",
      "28:1331sv" : "28:1331sv (28:1331 Fed. Question: Securities Violation)",
      "28:1331tr" : "28:1331tr (28:1331 Fed. Question: Trademark)",
      "28:1331tt" : "28:1331tt (28:1331 Fed. Question: Tort Action)",
      "28:1331v" : "28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendment)",
      "28:1331wl" : "28:1331wl (28:1331 Federal Question: EPA Waste Lien)",
      "28:1331wt" : "28:1331wt (28:1331 Fed. Question: Water Rights)",
      "28:1332" : "28:1332 (28:1332 Marine Personal Injury)",
      "28:1332ac" : "28:1332ac (28:1332 Diversity-Account Receivable)",
      "28:1332al" : "28:1332al (28:1332 Diversity-Airline Crash)",
      "28:1332as" : "28:1332as (28:1332 Diversity-Asbestos Litigation)",
      "28:1332au" : "28:1332au (28:1332 Diversity-Auto Negligence)",
      "28:1332bc" : "28:1332bc (28:1332 Diversity-Breach of Contract)",
      "28:1332co" : "28:1332co (28:1332 Diversity-Conversion)",
      "28:1332ct" : "28:1332ct (28:1332 Diversity-(Citizenship))",
      "28:1332det" : "28:1332det (28:1332 Diversity: Forcible Detainer)",
      "28:1332df" : "28:1332df (28:1332 Diversity-Contract Default)",
      "28:1332ds" : "28:1332ds (28:1332 Diversity-Contract Dispute)",
      "28:1332ed" : "28:1332ed (28:1332 Diversity-Employment Discrimination)",
      "28:1332fd" : "28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)",
      "28:1332fr" : "28:1332fr (28:1332 Diversity-Fraud)",
      "28:1332ia" : "28:1332ia (28:1332 Diversity-Interpleader Action)",
      "28:1332ij" : "28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)",
      "28:1332in" : "28:1332in (28:1332 Diversity-Insurance Contract)",
      "28:1332jd" : "28:1332jd (28:1332 Diversity-Declaratory Judgment)",
      "28:1332lb" : "28:1332lb (28:1332 Diversity-Libel,Assualt,Slander)",
      "28:1332lm" : "28:1332lm (28:1332 Diversity - Legal Malpractice)",
      "28:1332ma" : "28:1332ma (28:1332 Diversity-Miller Act)",
      "28:1332mm" : "28:1332mm (28:1332 Diversity-Medical Malpractice)",
      "28:1332mv" : "28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)",
      "28:1332ni" : "28:1332ni (28:1332 Diversity-Negotiable Instrument)",
      "28:1332nm" : "28:1332nm (28:1332 Diversity-Non-Motor Vehicle)",
      "28:1332oc" : "28:1332oc (28:1332 Diversity-Other Contract)",
      "28:1332pd" : "28:1332pd (28:1332 Diversity-Property Damage)",
      "28:1332pi" : "28:1332pi (28:1332 Diversity-Personal Injury)",
      "28:1332pl" : "28:1332pl (28:1332 Diversity-Product Liability)",
      "28:1332pr" : "28:1332pr (28:1332 Diversity-Petition for Removal)",
      "28:1332qt" : "28:1332qt (28:1332 Diversity-Petition to Quiet Title)",
      "28:1332ri" : "28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)",
      "28:1332sa" : "28:1332sa (28:1332 - Diversity: Securities & Exchange Commission Act)",
      "28:1332sf" : "28:1332sf (28:1332 - Diversity: Securities Fraud)",
      "28:1332ss" : "28:1332ss (28:1332 Diversity - Stockholders Suits)",
      "28:1332tl" : "28:1332tl (28:1332 Diversity-Torts to Land)",
      "28:1332tm" : "28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))",
      "28:1332tn" : "28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)",
      "28:1332wd" : "28:1332wd (28:1332 Diversity-Wrongful Death)",
      "28:1333" : "28:1333 (28:1333 Admiralty)",
      "28:1333in" : "28:1333in (28:1333 Personal Injury)",
      "28:1333mc" : "28:1333mc (28:1333 Marine Contract)",
      "28:1333pd" : "28:1333pd (28:1333 Property Damage)",
      "28:1333pi" : "28:1333pi (28:1333 Marine Personal Injury)",
      "28:1334" : "28:1334 (28:1334 Bankruptcy Appeal)",
      "28:1334b" : "28:1334b (28:1334(b) Proceeding arising/related to case under title 11)",
      "28:1334d" : "28:1334d (28:1334(d) R&R re motions for abstention (non-core))",
      "28:1335" : "28:1335 (28:1335 Interpleader Action)",
      "28:1337" : "28:1337 (28:1337 Sherman-Clayton Act)",
      "28:1338cp" : "28:1338cp (28:1338 Copyright Infringement)",
      "28:1338pt" : "28:1338pt (28:1338 Patent Infringement)",
      "28:1338tr" : "28:1338tr (28:1338 Trademark Infringement)",
      "28:1339" : "28:1339 (28:1339 Postal Matters)",
      "28:1340" : "28:1340 (28:1340 IRS: Custom Duties)",
      "28:1340er" : "28:1340er (28:1340 Recovery of Erroneous Refund)",
      "28:1341" : "28:1341 (28:1341 Complaint for Forfeiture)",
      "28:1343" : "28:1343 (28:1343 Violation of Civil Rights)",
      "28:1345co" : "28:1345co (28:1345 Replevin & Conversion)",
      "28:1345db" : "28:1345db (28:1345 Debt to US - FHA/HUD Title I)",
      "28:1345df" : "28:1345df (28:1345 Default of Promissory Note)",
      "28:1345er" : "28:1345er (28:1345 Recovery of Erroneous Refund)",
      "28:1345fc" : "28:1345fc (28:1345 Foreclosure)",
      "28:1345ff" : "28:1345ff (28:1345 Complaint for Forfeiture)",
      "28:1345hl" : "28:1345hl (28:1345 VA Home Loan Guaranty Debt)",
      "28:1345lc" : "28:1345lc (28:1345lc Land Condemnation)",
      "28:1345mc" : "28:1345mc (28:1345 Medical Care Recovery)",
      "28:1345mi" : "28:1345mi (28:1345 Mining Claim Ejectment)",
      "28:1345pd" : "28:1345pd (28:1345 Property Damage)",
      "28:1345pe" : "28:1345pe (28:1345 Property Ejectment)",
      "28:1345rc" : "28:1345rc (28:1345 Recovery of Debt to US)",
      "28:1345st" : "28:1345st (28:1345 Default of Student Loan)",
      "28:1345tp" : "28:1345tp (28:1345 Trespass on Public Land)",
      "28:1345va" : "28:1345va (28:1345 Recovery of VA Overpayment)",
      "28:1346a1" : "28:1346a1 (28:1346a1 IRS Tax Suit)",
      "28:1346bc" : "28:1346bc (28:1346 Breach of Contract)",
      "28:1346pi" : "28:1346pi (28:1346 - Marine Personal Injury)",
      "28:1346rc" : "28:1346rc (28:1346 Recovery of IRS Tax)",
      "28:1346tc" : "28:1346tc (28:1346 Tort Claim)",
      "28:1346wd" : "28:1346wd (28:1346 Wrongful Death)",
      "28:1352" : "28:1352 (28:1352 Miller Act)",
      "28:1355" : "28:1355 (28:1355 Petition for Return of Property)",
      "28:1356" : "28:1356 (28:1356 Executory Process/Foreclosure)",
      "28:1358" : "28:1358 (28:1358 Land Condemnation)",
      "28:1361" : "28:1361 (28:1361 Petition for Writ of Mandamus)",
      "28:1362ic" : "28:1362ic (28:1362 Indian Tribal Controversy)",
      "28:1362iw" : "28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)",
      "28:1364" : "28:1364 (28:1364 Auto Negligence)",
      "28:1367" : "28:1367 (28:1367 Other Property Damage)",
      "28:1391" : "28:1391 (28:1391 Personal Injury)",
      "28:1391c" : "28:1391c (28:1391 Breach of Contract)",
      "28:1391in" : "28:1391in (28:1391 Insurance Contract)",
      "28:1402" : "28:1402 (28:1402 Medical Malpractice)",
      "28:1407" : "28:1407 (28:1407 Airline Crash)",
      "28:1407im" : "28:1407im (28:1407 Silicone Gel Breast Implant Products Liability)",
      "28:1407md" : "28:1407md (28:1407md Multidistrict Litigation)",
      "28:1407n" : "28:1407n (28:1407n - Personal Injury/Norplant Product Liability)",
      "28:1407pl" : "28:1407pl (28:1407 Products Liability)",
      "28:1441ac" : "28:1441ac (28:1441 Petition for Removal- Account Receivable)",
      "28:1441al" : "28:1441al (28:1441 Petition for Removal- Airline Crash)",
      "28:1441as" : "28:1441as (28:1441 Petition for Removal- Asbestos Litigation)",
      "28:1441au" : "28:1441au (28:1441 Petition for Removal- Auto Negligence)",
      "28:1441bc" : "28:1441bc (28:1441 Petition for Removal- Breach of Contract)",
      "28:1441cv" : "28:1441cv (28:1441 Petition for Removal- Civil Rights Act)",
      "28:1441df" : "28:1441df (28:1441 Petition for Removal- Contract Default)",
      "28:1441dj" : "28:1441dj (28:1441 Petition for Removal- Declaratory Judgment)",
      "28:1441ds" : "28:1441ds (28:1441 Petition for Removal- Contract Dispute)",
      "28:1441ed" : "28:1441ed (28:1441 Petition for Removal - Employment Discrimination)",
      "28:1441fc" : "28:1441fc (28:1441 Petition for Removal - Fair Credit Reporting Act)",
      "28:1441fr" : "28:1441fr (28:1441 Petition for Removal- Fraud)",
      "28:1441ij" : "28:1441ij (28:1441 Petition for Removal- Injunctive/Declaratory Relief)",
      "28:1441in" : "28:1441in (28:1441 Petition for Removal- Insurance Contract)",
      "28:1441int" : "28:1441int (28:1441 Petition for Removal- Action for Interpleader)",
      "28:1441lb" : "28:1441lb (28:1441 Petition for Removal - Libel, Assault, Slander)",
      "28:1441lm" : "28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relations)",
      "28:1441mm" : "28:1441mm (28:1441 Petition for Removal- Medical Malpractice)",
      "28:1441ni" : "28:1441ni (28:1441 Petition for Removal- Negotiable Instrument)",
      "28:1441nm" : "28:1441nm (28:1441 Petition for Removal- Non-Motor Vehicle)",
      "28:1441oc" : "28:1441oc (28:1441 Petition For Removal--Other Contract)",
      "28:1441pd" : "28:1441pd (28:1441 Petition for Removal- Property Damage)",
      "28:1441pe" : "28:1441pe (28:1441pe Personal Injury)",
      "28:1441pi" : "28:1441pi (28:1441 Petition for Removal- Personal Injury)",
      "28:1441pl" : "28:1441pl (28:1441 Petition for Removal- Product Liability)",
      "28:1441pr" : "28:1441pr (28:1441 Petition for Removal)",
      "28:1441qt" : "28:1441qt (28:1441 Petition for Removal- Petition to Quiet Title)",
      "28:1441ri" : "28:1441ri (28:1441 Petition for Removal- Racketeering (RICO) Act)",
      "28:1441sa" : "28:1441sa (28:1441 - Petition for Removal: SEC Act)",
      "28:1441sf" : "28:1441sf (28:1441 - Petition for Removal: Securities Fraud)",
      "28:1441tl" : "28:1441tl (28:1441 Petition for Removal- Torts to Land)",
      "28:1441tm" : "28:1441tm (28:1441 Petition for Removal- Tort/Motor Vehicle (P.I.))",
      "28:1441tn" : "28:1441tn (28:1441 Petition for Removal- Tort/Non-Motor Vehicle)",
      "28:1441wd" : "28:1441wd (28:1441 Petition for Removal- Wrongful Death)",
      "28:1442bc" : "28:1442bc (28:1442 Petition for Removal- Breach of Contract)",
      "28:1442pr" : "28:1442pr (28:1442 Petition for Removal)",
      "28:1443" : "28:1443 (28:1443(1) State Ct Crim Case Removal)",
      "28:1444" : "28:1444 (28:1444 Petition for Removal- Foreclosure)",
      "28:1446in" : "28:1446in (28:1446 Breach of Contract- Insurance)",
      "28:1446pd" : "28:1446pd (28:1446 Petition for Removal- Property Damage (P.I.))",
      "28:1446pi" : "28:1446pi (28:1446 Petition for Removal- Personal Injury)",
      "28:1446pl" : "28:1446pl (28:1446pl Petition for Removal - Product Liability)",
      "28:1446pr" : "28:1446pr (28:1446 Petition for Removal)",
      "28:1452" : "28:1452 (28:1452 R&R re motions to remand (non-core))",
      "28:1452a" : "28:1452a (28:1452a Removal of Claims Related to Bankruptcy Cases)",
      "28:1452b" : "28:1452b (28:1452 Removal of Claims in re Bankruptcy)",
      "28:1491" : "28:1491 (28:1491 Recovery of I.R.S. Taxes)",
      "28:1602" : "28:1602 (28:1602 Foreign Sovereign Immunities Act)",
      "28:1605" : "28:1605 (28:1605 Foreign Sovereign Immunities Act of 1976)",
      "28:1651" : "28:1651 (28:1651 Petition for Writ of Coram Nobis)",
      "28:1651hc" : "28:1651hc (28:1651 Petition for Writ of Habeas Corpus)",
      "28:1651mn" : "28:1651mn (28:1651 Petition for Writ of Mandamus)",
      "28:1651w" : "28:1651w (28:1651 All Writs Act)",
      "28:1732" : "28:1732 (28:1732 Collection of Indebtedness)",
      "28:1738" : "28:1738 (28:1738(a) Parental Kidnapping Prevention Act)",
      "28:1782" : "28:1782 (28:1782 Assistance to Foreign Tribunals)",
      "28:1875" : "28:1875 (28:1875 Juror Protection Act)",
      "28:1916" : "28:1916 (28:1916 Marine Personal Injury)",
      "28:1983" : "28:1983 (28:1983 Civil Rights)",
      "28:2000e" : "28:2000e (28:2000e Pregnancy Discrimination Act)",
      "28:2201" : "28:2201 (28:2201 Constitutionality of State Statute(s))",
      "28:2201dj" : "28:2201dj (28:2201 Declaratory Judgment)",
      "28:2201ij" : "28:2201ij (28:2201 Injunction)",
      "28:2201in" : "28:2201in (28:2201 Declaratory Judgment (Insurance))",
      "28:2201pi" : "28:2201pi (28:2201pi Declaratory Judgment - Personal Injury)",
      "28:2241" : "28:2241 (28:2241 Petition for Writ of Habeas Corpus)",
      "28:2254" : "28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))",
      "28:2254se" : "28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)",
      "28:2255" : "28:2255 (28:2255 Motion to Vacate)",
      "28:2255mv" : "28:2255mv (28:2255 Motion to Vacate)",
      "28:2271" : "28:2271 (28:2271 Federal Tort Claims Act)",
      "28:2283" : "28:2283 (28:2283 Injunctive Relief)",
      "28:2345" : "28:2345 (28:2345 Medicare Recovery)",
      "28:2391" : "28:2391 (28:2391 Guaranty Agreements)",
      "28:2401" : "28:2401 (28:2401 Federal Tort Claims Act)",
      "28:2409" : "28:2409 (28:2409(a) Quiet Title Action)",
      "28:2410" : "28:2410 (28:2410 Quiet Title)",
      "28:2412" : "28:2412 (28:2412 Equal Access to Justice Act)",
      "28:2671" : "28:2671 (28:2671 Federal Tort Claims Act)",
      "28:2674" : "28:2674 (28:2674 Federal Tort Claims Act)",
      "28:2675" : "28:2675 (28:2675 Federal Tort Claims Act)",
      "28:2679d2" : "28:2679d2 (28:2679d2 Employee of U.S.A.)",
      "28:2680" : "28:2680 (28:2680 Federal Tort Claims Act)",
      "28:2861" : "28:2861 (28:2861 Federal Tort Claims Act)",
      "28:3001a" : "28:3001a (28:3001(a) Federal Debt Collection Procedures Act of 1990)",
      "28:7402" : "28:7402 (28:7402 Refund of Taxes)",
      "28:7422" : "28:7422 (28:7422 Appeal from Administrative Decision)",
      "28:7425a" : "28:7425a (28:7425a Judiciary & Judicial Procedures)",
      "29:0151" : "29:0151 (29:151 Labor: Review of Agency Action)",
      "29:0160" : "29:0160 (29:160(1) National Labor Relations Act)",
      "29:0184" : "29:0184 (29:184 Violation Collection Bargain Agreement)",
      "29:0185ep" : "29:0185ep (29:185 Employee Pension Plan)",
      "29:0185lm" : "29:0185lm (29:185 Labor/Mgt. Relations (Contracts))",
      "29:0201do" : "29:0201do (29:201 Denial of Overtime Compensation)",
      "29:0201fl" : "29:0201fl (29:201 Fair Labor Standards Act)",
      "29:0203" : "29:0203 (29:203 Equal Pay Act)",
      "29:0206" : "29:0206 (29:206 Collect Unpaid Wages)",
      "29:0207" : "29:0207 (29:0207 Fair Labor Standards Act)",
      "29:0210" : "29:0210 (29:0210 Workers Adj and Restraining Notification Act (WARN))",
      "29:0216b" : "29:0216b (29:0216(b) Fair Labor Standards Act)",
      "29:0401" : "29:0401 (29:0401 Labor Management Disclosure Act)",
      "29:0411" : "29:0411 (29:0411 Land Griffin Act)",
      "29:0621" : "29:0621 (29:621 Job Discrimination (Age))",
      "29:0623" : "29:0623 (29:623 Job Discrimination (Age))",
      "29:0626" : "29:0626 (29:626 Job Discrimination (Age))",
      "29:0626s" : "29:0626s (29:0626s Job Discrimination (Sex))",
      "29:0633" : "29:0633 (29:633 Job Discrimination (Age))",
      "29:0651" : "29:0651 (29:651 Occupational Safety/Health)",
      "29:0745" : "29:0745 (29:0745 Discrimination)",
      "29:0754" : "29:0754 (29:754 Discrimination)",
      "29:0790" : "29:0790 (29:0790 Rehabilitation of Labor)",
      "29:0791" : "29:0791 (29:791 Job Discrimination (Rehabilitation Act))",
      "29:0794" : "29:0794 (29:0794 Job Discrimination (Handicap))",
      "29:1001" : "29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)",
      "29:1002" : "29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)",
      "29:1055" : "29:1055 (29:1055 - E.R.I.S.A., Employee Retirement)",
      "29:1104" : "29:1104 (29:1104 Recovery of Benefits to Employee)",
      "29:1109" : "29:1109 (29:1109 Breach of Fiduciary Duties)",
      "29:1131" : "29:1131 (29:1131 ERISA - Collection of Delinquent Trust Funds)",
      "29:1132" : "29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)",
      "29:1145" : "29:1145 (29:1145 E.R.I.S.A.)",
      "29:1149" : "29:1149 (29:1149 Recover Pension & Profit Sharing)",
      "29:1161" : "29:1161 (29:1161 Comprehensive Omnibus Budget Rec Act of 1985)",
      "29:1337" : "29:1337 (29:1337 E.R.I.S.A.)",
      "29:1343" : "29:1343 (29:1343 - Title VII Discrimination Case)",
      "29:1362" : "29:1362 (29:1362 ERISA)",
      "29:1381" : "29:1381 (29:1381 E.R.I.S.A.)",
      "29:1401" : "29:1401 (29:1401(b)(2) Appeal of Arbitration Award)",
      "29:1451" : "29:1451 (29:1451 E.R.I.S.A.)",
      "29:1801" : "29:1801 (29:1801 Farmworker Rights)",
      "29:1916" : "29:1916 (29:1916 Spec. Rule for Longshoremen & Harborworkers)",
      "29:2001" : "29:2001 (29:2001 Employee Polygraph Protection Act of 1988)",
      "29:2101" : "29:2101 (29:2101 Worker Adjustment & Restraining Notification Act)",
      "29:2601" : "29:2601 (29:2601 Family Medical Leave Act)",
      "29:2609" : "29:2609 (29:2609 Family & Medical Leave Act)",
      "29:2612" : "29:2612 (29:2612 Family Medical Leave Act)",
      "29:2617" : "29:2617 (29:2617 Employment Discrimination (Pregnancy))",
      "29:2617ml" : "29:2617ml (29:2617 Family & Medical Leave Act)",
      "29:301" : "29:301 (29:301(a) Labor Management Relations Act)",
      "30:0181" : "30:0181 (30:181 Environment: Review of Agency Action)",
      "30:0801" : "30:0801 (30:0801 Penalties/Federal Mine Safety Health Act - 1977)",
      "30:1201" : "30:1201 (30:1201 Environment: Review of Agency Action)",
      "30:1202" : "30:1202 (30:1202 Mining Reclamation Act)",
      "30:1276" : "30:1276 (30:1276 Interior: Review of Agency Action)",
      "31:1331" : "31:1331 (31:1331 False Claims Act)",
      "31:3545" : "31:3545 (31:3545 Action to Recovery Money)",
      "31:3729" : "31:3729 (31:3729 False Claims Act)",
      "31:3730" : "31:3730 (31:3730 Qui Tam False Claims Act)",
      "31:3731" : "31:3731 (31:3731 Fraud)",
      "32:0715" : "32:0715 (32:0715 Federal Tort Claims Act)",
      "33:0408" : "33:0408 (33:0408 Injury to Harbor Improvement)",
      "33:0594" : "33:0594 (33:0594 Land Condemnation)",
      "33:0901" : "33:0901 (33:0901 Longshoremen Harbor Workers Compensation Act)",
      "33:0905" : "33:0905 (33:0905 Marine Personal Injury)",
      "33:0918" : "33:0918 (33:0918 Longshore and Harbor Workers Compensation Act)",
      "33:0921" : "33:0921 (33:0921 Longshore & Harbor Workers Compensation Act)",
      "33:0933" : "33:0933 (33:0933 Longshore and Harbor Workers' Compensation Act)",
      "33:1319cw" : "33:1319cw (33:1319 Clean Water Act)",
      "33:1319pv" : "33:1319pv (33:1319 Pollutants & Permit Violations)",
      "33:1333" : "33:1333 (33:1333 Admiralty)",
      "33:1365" : "33:1365 (33:1365 Environmental Matters)",
      "33:1515" : "33:1515 (33:1515 Deepwater Ports Act)",
      "33:2001" : "33:2001 (33:2001 U.S. Inland Navigation Rules)",
      "33:2005" : "33:2005 (33:2005 Violation of the Inland Navigation Rules Act of 1980)",
      "33:2701" : "33:2701 (33:2701 - Oil Pollution Act)",
      "34:0504" : "34:0504 (34:0504 - Rehabilitation Act)",
      "35:0145" : "35:0145 (35:145 Patent Infringement)",
      "35:0172" : "35:0172 (35:172 Patent Infringement)",
      "35:0183" : "35:0183 (35:183 Patent Infringement)",
      "35:0271" : "35:0271 (35:271 Patent Infringement)",
      "38:1681" : "38:1681 (38:1681 Recovery of VA Overpayment)",
      "38:1686" : "38:1686 (38:1686 Recovery of VA Overpayment)",
      "38:1780" : "38:1780 (38:1780 Recovery of VA Overpayment)",
      "38:2011" : "38:2011 (38:2011 - Veteran's Readjustment Assistance Act of 1974)",
      "38:3116" : "38:3116 (38:3116 VA Overpayment)",
      "38:4301" : "38:4301 (38:4301 Veterans Re-Employment Act)",
      "39:0409" : "39:0409 (39:0409 Postal Service)",
      "39:3005" : "39:3005 (39:3005 Detention of Mail for Temporary Periods)",
      "40:0258" : "40:0258 (40:258(a) Public Buildings & Property: Land Condemnation)",
      "40:0270" : "40:0270 (40:270 Miller Act)",
      "40:0875" : "40:0875 (40:875 Public Buildings & Property: Negligence)",
      "40:3131" : "40:3131 (40:3131 Miller Act)",
      "41:0251" : "41:0251 (41:251 Public Contracts-Review of Agency Action)",
      "41:0351" : "41:0351 (41:0351 Service Contract Act)",
      "41:1463" : "41:1463 (41:1463 Public Contracts: Unlawful Employment Practices)",
      "42:0034" : "42:0034 (42:0034 Other Civil Rights)",
      "42:0205" : "42:0205 (42:205 Denial Social Security Benefits)",
      "42:0206" : "42:0206 (42:206 Social Security Benefits)",
      "42:0247" : "42:0247 (42:247 Personal Injury-Swine Flu)",
      "42:0300" : "42:0300 (42:0300 Pub Health & Welfare-Grants & Contracts for Family Planning)",
      "42:0401" : "42:0401 (42:0401 Social Security Act)",
      "42:0402" : "42:0402 (42:402 Social Security Benefits)",
      "42:0405id" : "42:0405id (42:405 Review of HHS Decision (SSID))",
      "42:0405wc" : "42:0405wc (42:405 Review of HHS Decision (DIWC))",
      "42:0405ww" : "42:0405ww (42:405 Review of HHS Decision (DIWW))",
      "42:0416" : "42:0416 (42:416 Denial of Social Security Benefits)",
      "42:0423" : "42:0423 (42:0423 - Social Security Act)",
      "42:0425" : "42:0425 (42:0425 Social Security Benefits)",
      "42:11601" : "42:11601 (42:11601 International Child Abduction Remedies Act)",
      "42:1210" : "42:1210 (42:1210 Age in Employment Act)",
      "42:12101" : "42:12101 (42:12101 Americans With Disabilities Act)",
      "42:12117" : "42:12117 (42:12117 Americans with Disabilities Act)",
      "42:12132" : "42:12132 (42:12132 Americans with Disabilities Act)",
      "42:12181" : "42:12181 (42:12181 Title III Americans with Disabilities Act)",
      "42:12201" : "42:12201 (42:12201 Violations of Title II Amer W/Disabilities Act)",
      "42:1383" : "42:1383 (42:1383 Review of HHS Decision)",
      "42:1395" : "42:1395 (42:1395 HHS: Adverse Reimbursement Review)",
      "42:1395dd" : "42:1395dd (42:1395dd Treatment for Emergency Med Conditions)",
      "42:1395hr" : "42:1395hr (42:1395 - Hospital Reimbursement for Medicare Services)",
      "42:1396" : "42:1396 (42:1396 - Tort Negligence)",
      "42:13981" : "42:13981 (42:13981 Violence Against Women Act)",
      "42:1471" : "42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclosure Sale)",
      "42:1981cv" : "42:1981cv (42:1981 Civil Rights)",
      "42:1981hs" : "42:1981hs (42:1981 Housing Discrimination)",
      "42:1981jb" : "42:1981jb (42:1981 Job Discrimination (Race))",
      "42:1981sx" : "42:1981sx (42:1981 Sex Discrimination)",
      "42:1983cv" : "42:1983cv (42:1983 Civil Rights Act)",
      "42:1983d" : "42:1983d (42:1983 Civil Rights (Death))",
      "42:1983ed" : "42:1983ed (42:1983 Civil Rights (Employment Discrimination))",
      "42:1983pr" : "42:1983pr (42:1983 Prisoner Civil Rights)",
      "42:1984" : "42:1984 (42:1984 Civil Rights)",
      "42:1985" : "42:1985 (42:1985 Civil Rights)",
      "42:1986" : "42:1986 (42:1986 Neglect of Duty)",
      "42:1988" : "42:1988 (42:1988 Civil Rights Employment)",
      "42:2000ag" : "42:2000ag (42:2000 Job Discrimination (Age))",
      "42:2000e" : "42:2000e (42:2000e Job Discrimination (Employment))",
      "42:2000pb" : "42:2000pb (42:2000 Job Discrimination (Public Accomodations))",
      "42:2000ra" : "42:2000ra (42:2000 Job Discrimination (Race))",
      "42:2000sx" : "42:2000sx (42:2000 Job Discrimination (Sex))",
      "42:2003" : "42:2003 (42:2003 Job Discrimination)",
      "42:2005" : "42:2005 (42:2005 Review of Agency Action-HHS)",
      "42:2651" : "42:2651 (42:2651 Medical Care Recovery)",
      "42:3133" : "42:3133 (42:3133 - Miller Act)",
      "42:3601" : "42:3601 (42:3601 Fair Housing Act)",
      "42:3612" : "42:3612 (42:3612 Fair Housing Act)",
      "42:4000" : "42:4000 (42:4000 National Flood Insurance Act)",
      "42:4001" : "42:4001 (42:4001 National Flood Insurance Act)",
      "42:4013" : "42:4013 (42:4013 National Flood Insurance Act)",
      "42:4053" : "42:4053 (42:4053 Breach of Insurance Contract)",
      "42:4072" : "42:4072 (42:4072 Payment of Flood Insurance Claim)",
      "42:4321" : "42:4321 (42:4321 Review of Agency Action-Environment)",
      "42:4332" : "42:4332 (42:4332 Environmental Policy - Coop of Agency Reports)",
      "42:6201" : "42:6201 (42:6201 Energy Policy & Conservation Act)",
      "42:6901en" : "42:6901en (42:6901 Environmental Cleanup Expenses)",
      "42:6901rs" : "42:6901rs (42:6901 Resource & Recovery Act)",
      "42:7401" : "42:7401 (42:7401 Clean Air Act)",
      "42:7413" : "42:7413 (42:7413(b) Clean Air Act)",
      "42:7604cl" : "42:7604cl (42:7604 Clear Air Act (Emission Standards))",
      "42:7604ir" : "42:7604ir (42:7604 Petition to Quash IRS Summons)",
      "42:9601" : "42:9601 (42:9601 Comp Environ, Response, Comp, & Liability Act)",
      "42:9607" : "42:9607 (42:9607 Real Property Tort to Land)",
      "43:0945" : "43:0945 (43:0945 Compensation for Land Condemnation)",
      "43:0945a" : "43:0945a (43:0945a Complaint in Condemnation)",
      "43:0946" : "43:0946 (43:0946 Complaint in Condemnation - Eminent Domain)",
      "43:1301" : "43:1301 (43:1301 Outer Continental Shelf Lands Act (Definitions))",
      "43:1331" : "43:1331 (43:1331 Outer Continental Shelf Lands Act (Definitions))",
      "43:1333" : "43:1333 (43:1333 Outer Continental Shelf Lands Act)",
      "43:1349" : "43:1349 (43:1349 Outer Continental Land Shelf Act)",
      "43:1438" : "43:1438 (43:1438 Marine Personal Injury)",
      "45:0051" : "45:0051 (45:51 Railways: Fed. Employer's Liability Act)",
      "45:0151" : "45:0151 (45:151 Railway Labor Act)",
      "45:0152" : "45:0152 (45:0152 Railway Labor Act)",
      "45:0184" : "45:0184 (45:184 Action to Set Aside Award of a System Board of Adjust)",
      "45:1395" : "45:1395 (45:1395 Railroads: Adverse Reimbursement Review)",
      "45:7457" : "45:7457 (45:7457 Compel Reclamation Under Clear Air Act)",
      "46:0181" : "46:0181 (46:0181 Limitation of Liability)",
      "46:0182" : "46:0182 (46:0182 Limitation of Liability)",
      "46:0183" : "46:0183 (46:0183 Limitation of Liability)",
      "46:0185" : "46:0185 (46:0185 Exoneration from or Limitation of Liability)",
      "46:0190" : "46:0190 (46:0190 Marine Contract)",
      "46:0688" : "46:0688 (46:0688 Marine Personal Injury)",
      "46:0740" : "46:0740 (46:0740 Marine Injury)",
      "46:0740pd" : "46:0740pd (46:0740pd Property Damage)",
      "46:0741" : "46:0741 (46:741 Shipping)",
      "46:0742" : "46:0742 (46:0742 Suits in Admiralty Act)",
      "46:0745" : "46:0745 (46:0745 Suits in Admiralty Acts)",
      "46:0761" : "46:0761 (46:761 Shipping: Damages for Death on High Seas)",
      "46:0781" : "46:0781 (46:0781 Public Vessels Act)",
      "46:0951" : "46:0951 (46:0951 Maritime Foreclosure)",
      "46:0971" : "46:0971 (46:0971 Preferred Maritime Lien)",
      "46:0971pi" : "46:0971pi (46:0971pi Maritime Personal Injury)",
      "46:1101" : "46:1101 (46:1101 Violation of Maritime Regulations)",
      "46:1156" : "46:1156 (46:1156 Administrative Procedure Act)",
      "46:1300" : "46:1300 (46:1300 Marine Cargo Loss or Damage)",
      "46:1301" : "46:1301 (46:1301 Cargo Loss & Damage)",
      "46:1331" : "46:1331 (46:1331 Outer Continental Shelf Lands Act)",
      "46:1701" : "46:1701 (46:1701 Shipping Act of 1984)",
      "46:1709" : "46:1709 (46:1709 Shipping Act of 1984 10(a))",
      "46:1713d" : "46:1713d (46:1713(d) Shipping Act of 1984 14(d))",
      "46:2114" : "46:2114 (46:2114 Wrongful Discharge from Employment)",
      "46:30104" : "46:30104 (46:30104 Marine Personal Injury)",
      "46:30504" : "46:30504 (46:30504 Exoneration from or Limitation of Liability)",
      "46:31301" : "46:31301 (46:31301 Breach of Maritime Contract)",
      "46:31321" : "46:31321 (46:31321 Foreclosure of Preferred Ship Mortgages)",
      "46:31325" : "46:31325 (46:31325 Admiralty)",
      "46:31341" : "46:31341 (46:31341 Federal Maritime Lien Act)",
      "46:31342" : "46:31342 (46:31342 Breach of Maritime Contract)",
      "46:31343" : "46:31343 (46:31343 Commercial Instruments & Maritime Liens)",
      "46:9721" : "46:9721 (46:9721 Federal Maritime Lien Act)",
      "47:0251" : "47:0251 (47:0251 Telecommunications Act of 1996)",
      "47:0605" : "47:0605 (47:0605 Theft of Satellite Communications)",
      "47:4072" : "47:4072 (47:4072 National Flood Insurance Program)",
      "48:0883" : "48:0883 (48:883 Violation of US Coastal Law)",
      "48:1985" : "48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)",
      "49:0081" : "49:0081 (49:81 Damaged Goods While Being Transported)",
      "49:0781" : "49:0781 (49:781 Forfeiture)",
      "49:10743" : "49:10743 (49:10743 Revised Interstate Commerce Act)",
      "49:11503" : "49:11503 (49:11503 Railroad Revitalization Regulatory Reform Act)",
      "49:11701" : "49:11701 (49:11701 Admiralty & Maritime)",
      "49:11702" : "49:11702 (49:11702(a)(4) Violations of Interstate Commerce Act)",
      "49:1305" : "49:1305 (49:1305 Airline Deregulation Act)",
      "49:1471" : "49:1471 (49:1471 Federal Aviation Act)",
      "49:1903" : "49:1903 (49:1903 Petition to enforce administrative summons)",
      "49:30101" : "49:30101 (49:30101 National Traffic & Motor Vehicle Safety Act)",
      "49:40101" : "49:40101 (49:40101 Federal Aviation Act)",
      "50:0540" : "50:0540 (50:0540 Sailors and Soldiers Civil Relief Act)",
      "misc" : "misc (Civil Miscellaneous Case)"
   },
   "lamdce" : {
      "0" : "0 (no cause specified)",
      "00:0000" : "00:0000 (Cause code unknown)",
      "02:0431" : "02:0431 (02:431 Fed. Election Commission: Failure Enforce Compliance)",
      "02:0437" : "02:0437 (02:437 Federal Election Commission)",
      "05:0075" : "05:0075 (05:75(2) Contract - Reduction in Grade)",
      "05:0551" : "05:0551 (05:551 Administrative Procedure Act)",
      "05:0552fi" : "05:0552fi (05:552 Freedom of Information Act)",
      "05:0552pa" : "05:0552pa (05:552 Right to Privacy Act)",
      "05:0554" : "05:0554 (05:0554 Constitutionality of Maritime Statutes)",
      "05:0701" : "05:0701 (05:0701 Maritime Subsidy Board)",
      "05:0702" : "05:0702 (05:702 Administrative Procedure Act)",
      "05:0704" : "05:0704 (05:704 Labor Litigation)",
      "05:7703" : "05:7703 (05:7703 Discrimination - Review of Agency Act)",
      "05:8470" : "05:8470 (05:8470 Enforcement of Judgment against Retirement Benefits)",
      "07:0006" : "07:0006 (7:6(b) Federal Commodity Exchange Regulation)",
      "07:0025" : "07:0025 (7:25 Fraud - Commodities Leverage Contracts)",
      "07:0181" : "07:0181 (07:181 Packers & Stockyard Act)",
      "07:0499" : "07:0499 (07:499 Agricultural Commodities Act)",
      "07:0601" : "07:0601 (07:601 USDA Condemnation)",
      "07:2321" : "07:2321 (07:2321 Plant Variety Protection Act)",
      "08:1105" : "08:1105 (8:1105(a) Aliens: Habeas Corpus to Release INS Detainee)",
      "08:1182" : "08:1182 (8:1182 Defend. Denial of Pla. Appl. for Alien Employment Cer)",
      "08:1252" : "08:1252 (08:1252(a)(2) Injunction for Deportation)",
      "08:1260" : "08:1260 (08:1260 Aliens: Access to Records)",
      "08:1324" : "08:1324 (08:1324 Aliens: Complaint for Forfeiture)",
      "08:1329" : "08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petition)",
      "08:1446" : "08:1446 (8:1446 Petition for Naturalization Hearing)",
      "08:1451(j)" : "08:1451(j) (8:1451(j) Motion to Correct Order & Judg. of Naturalization)",
      "09:0001" : "09:0001 (09:1 U.S. Arbitration Act)",
      "09:0009" : "09:0009 (9:9 Motion to Confirm Arbitration Loan)",
      "09:0010" : "09:0010 (09:0010 Petition to Vacate Arbitration Award)",
      "10:1408" : "10:1408 (10:1408 Claim for Military Retirement)",
      "10:1552" : "10:1552 (10:1552 Armed Forces: Action to Correct Records)",
      "10:1553" : "10:1553 (10:1553 Armed Forces: FOIA General)",
      "10:2305" : "10:2305 (10:2305 Review of Federal Contract)",
      "11:0101" : "11:0101 (11:101 Bankruptcy)",
      "12:0022" : "12:0022 (12:22 Securities Fraud)",
      "12:0635" : "12:0635 (12:635 Breach of Insurance Contract)",
      "12:1461" : "12:1461 (12:1461 Homeowners Loan Act)",
      "12:1464" : "12:1464 (12:1464 Federal Savings and Loan)",
      "12:1703" : "12:1703 (12:1703 Default of HUD Loan)",
      "12:1725" : "12:1725 (12:1725 Collection under Contract Guaranty)",
      "12:1730" : "12:1730 (12:1730 Collection Under Contract Guaranty)",
      "12:1819" : "12:1819 (12:1819 Default of Promissory Note)",
      "12:1821" : "12:1821 (12:1821 Default of Loan by Promissary Note)",
      "12:191" : "12:191 (12:191 Bank Foreclosure)",
      "12:192" : "12:192 (12:192 Liquidation of National Bank)",
      "12:1971" : "12:1971 (12:1971 Relief under Bank Holding Act)",
      "12:1972" : "12:1972 (12:1972 Typing Arrangement Act)",
      "12:3410" : "12:3410 (12:3410 Right to Financial Privacy Act)",
      "15:0001" : "15:0001 (15:1 Antitrust Litigation)",
      "15:0002at" : "15:0002at (15:2 Antitrust Litigation)",
      "15:0002fl" : "15:0002fl (15:2(a) Fair Labor Standards Act)",
      "15:0005" : "15:0005 (15:5(a) Fair Labor Standards Act)",
      "15:0015" : "15:0015 (15:15 Antitrust Litigation)",
      "15:0025" : "15:0025 (15:25 Clayton Act)",
      "15:0044" : "15:0044 (15:44 Trademark Infringement)",
      "15:0045" : "15:0045 (15:0045 Federal Trade Commission Act)",
      "15:0052" : "15:0052 (15:0052 Federal Trade Commission Act)",
      "15:0053" : "15:0053 (15:0053 Federal Trade Commission Act)",
      "15:0077" : "15:0077 (15:77 Securities Fraud)",
      "15:0078" : "15:0078 (15:78m(a) Securities Exchange Act)",
      "15:0631" : "15:0631 (15:631 Small Business Act)",
      "15:0717" : "15:0717 (15:717 Natural Gas Act)",
      "15:0754" : "15:0754 (15:754 Emergency Petroleum Allocation-Admin.& Enforcement)",
      "15:1051" : "15:1051 (15:1051 Trademark Infringement)",
      "15:1114" : "15:1114 (15:1114 Trademark Infringement)",
      "15:1121" : "15:1121 (15:1121 Trademark Infringement)",
      "15:1125" : "15:1125 (15:1125 Trademark Infringement (Lanham Act))",
      "15:1126" : "15:1126 (15:1126 Patent Infringement)",
      "15:1127" : "15:1127 (15:1127 Trademark Infringement)",
      "15:1601" : "15:1601 (15:1601 Truth in Lending)",
      "15:1640" : "15:1640 (15:1640 Truth in Lending)",
      "15:1681" : "15:1681 (15:1681 Fair Credit Reporting Act)",
      "15:1692" : "15:1692 (15:1692 Fair Debt Collection Act)",
      "15:1938" : "15:1938 (15:1938 Fair Labor Standards Act)",
      "15:1981" : "15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))",
      "15:1988" : "15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))",
      "15:1989" : "15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))",
      "15:2301" : "15:2301 (15:2301 Magnuson-Moss Warranty Act)",
      "15:2801" : "15:2801 (15:2801 Petroleum Marketing Practices Act)",
      "15:3901" : "15:3901 (15:3901 Liability Risk Retention Act)",
      "15:53(b)" : "15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equita)",
      "16:0668" : "16:0668 (16:668 Bald Eagle Protection Act)",
      "16:0703" : "16:0703 (16:703 Migratory Bird Act)",
      "16:1538" : "16:1538 (16:1538 Endangered Species Act)",
      "16:3371" : "16:3371 (16:3371 Wildlife Under the Lacey Act)",
      "16:3372" : "16:3372 (16:3372 Conservation: Complaint for Forfeiture)",
      "16:3373" : "16:3373 (16:3373 Appeal of Decision - DOI)",
      "16:3374" : "16:3374 (16:3374 Conservation: Complaint for Forfeiture)",
      "17:0101" : "17:0101 (17:101 Copyright Infringement)",
      "17:0501" : "17:0501 (17:501 Copyright Infringement)",
      "17:0504" : "17:0504 (17:504 Copyright Infringement)",
      "18:0241" : "18:0241 (18:241 Conspiracy Against Citizen Rights)",
      "18:1836a" : "18:1836a (18:1836(a) Injunction against Misappropriation of Trade Secrets)",
      "18:1836b" : "18:1836b (18:1836(b) Civil Action to Protect Trade Secrets)",
      "18:1961" : "18:1961 (18:1961 Racketeering (RICO) Act)",
      "18:1962" : "18:1962 (18:1962 Racketeering (RICO) Act)",
      "18:1964" : "18:1964 (18:1964 Racketeering (RICO) Act)",
      "18:2511" : "18:2511 (18:2511 Wiretapping)",
      "18:3114" : "18:3114 (18:3114 Motion for Return of Seized Property)",
      "18:4208" : "18:4208 (18:4208(B) Agency Action Review)",
      "19:1305" : "19:1305 (19:1305 Custom Duties: Forfeiture-Immoral Articles)",
      "20:1080" : "20:1080 (20:1080 Student Loan Recovery)",
      "20:1400" : "20:1400 (20:1400 Civil Rights of Handicapped Child)",
      "20:1401" : "20:1401 (20:1401 Education: Handicapped Child Act)",
      "21:0301" : "21:0301 (21:0301 FDA Drug & Cosmetic Act)",
      "21:0841" : "21:0841 (21:841 Forfeiture Property-Drugs)",
      "21:0881" : "21:0881 (21:881 Forfeiture Property-Drugs)",
      "21:0881a" : "21:0881a (21:881 Forfeiture Property - Aircraft)",
      "21:0881re" : "21:0881re (21:881 Forfeiture Property - Real Estate)",
      "23:0134" : "23:0134 (23:134 P.I.- Auto Negligence)",
      "23:1441" : "23:1441 (23:1441 Contract Real Estate)",
      "24:1000" : "24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)",
      "25:0640" : "25:0640 (25:640 Indian Tribal Rights)",
      "25:1901" : "25:1901 (25:1901 Indian Child Welfare Act)",
      "26:6212" : "26:6212 (26:6212 Injunctive Relief from IRS Lien)",
      "26:6213" : "26:6213 (26:6213 Injunctive Relief from IRS Lien)",
      "26:6502" : "26:6502 (26:6502 IRS:Enforcement of tax liens)",
      "26:6532" : "26:6532 (26:6532 IRS: Refund of Tax Penalty)",
      "26:6702" : "26:6702 (26:6702 IRS: Refund of Income Tax Penalty)",
      "26:6703" : "26:6703 (26:6703 IRS: Refund of Tax Penalty)",
      "26:7401" : "26:7401 (26:7401 IRS: Tax Liability)",
      "26:7402" : "26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)",
      "26:7403" : "26:7403 (26:7403 Suit to Enforce Federal Tax Lien)",
      "26:7422rt" : "26:7422rt (26:7422 IRS: Refund Taxes)",
      "26:7422rx" : "26:7422rx (26:7422 IRS: Refund Excise Tax)",
      "26:7426" : "26:7426 (26:7426 IRS: Wrongful Levy for Taxes)",
      "26:7429" : "26:7429 (26:7429 IRS: Tax Jeopardy Assessment)",
      "26:7609" : "26:7609 (26:7609 IRS: Petition to Quash IRS Summons)",
      "27:0185" : "27:0185 (27:185 Enforcement of Arbitration Award)",
      "28:0157c" : "28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)",
      "28:0157d" : "28:0157d (28:0157 Motion for Withdrawal of Reference)",
      "28:0158" : "28:0158 (28:0158 Bankruptcy Appeal from Judgment/Order)",
      "28:0185" : "28:0185 (28:185 Suit to Compel Arbitration)",
      "28:0451" : "28:0451 (28:451 Employment Discrimination)",
      "28:0754" : "28:0754 (28:754 Receiver of Property in Different Districts)",
      "28:0794" : "28:0794 (28:794 Rehabilitation Act)",
      "28:1001" : "28:1001 (28:1001 E.R.I.S.A.)",
      "28:1132" : "28:1132 (28:1132 E.R.I.S.A.)",
      "28:1330" : "28:1330 (28:1330 Breach of Contract)",
      "28:1331" : "28:1331 (28:1331 Fed. Question)",
      "28:1331al" : "28:1331al (28:1331 Fed. Question: Airline Crash)",
      "28:1331at" : "28:1331at (28:1331 Fed. Question: Anti-trust)",
      "28:1331au" : "28:1331au (28:1331 Fed. Question: Auto Negligence)",
      "28:1331b" : "28:1331b (28:1331 Federal Question: Bivens Act)",
      "28:1331bc" : "28:1331bc (28:1331 Fed. Question: Breach of Contract)",
      "28:1331ca" : "28:1331ca (28:1331 Fed Question: Fed Communications Act of 1)",
      "28:1331cm" : "28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)",
      "28:1331cv" : "28:1331cv (28:1331 Fed. Question: Civil Rights Violation)",
      "28:1331ed" : "28:1331ed (28:1331 Fed. Question: Employment Discrimination)",
      "28:1331ej" : "28:1331ej (28:1331 Federal Question: Enforcement of Judgment)",
      "28:1331es" : "28:1331es (28:1331 Enforcement of Administrative Subpoena)",
      "28:1331fl" : "28:1331fl (28:1331 Fed. Question: Fair Labor Standards)",
      "28:1331in" : "28:1331in (28:1331 Fed. Question: Insurance Contract)",
      "28:1331mm" : "28:1331mm (28:1331 Fed. Question: Medical Malpractice)",
      "28:1331ng" : "28:1331ng (28:1331 Fed. Question: Natural Gas Act)",
      "28:1331pi" : "28:1331pi (28:1331 Fed. Question: Personal Injury)",
      "28:1331rd" : "28:1331rd (28:1331 Fed. Question: Review Agency Decision)",
      "28:1331rp" : "28:1331rp (28:1331(a) Fed. Question: Real Property)",
      "28:1331rr" : "28:1331rr (28:1331 Fed. Question: Railway Labor Act)",
      "28:1331sv" : "28:1331sv (28:1331 Fed. Question: Securities Violation)",
      "28:1331tr" : "28:1331tr (28:1331 Fed. Question: Trademark)",
      "28:1331tt" : "28:1331tt (28:1331 Fed. Question: Tort Action)",
      "28:1331v" : "28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendment)",
      "28:1331wl" : "28:1331wl (28:1331 Federal Question: EPA Waste Lien)",
      "28:1331wt" : "28:1331wt (28:1331 Fed. Question: Water Rights)",
      "28:1332ac" : "28:1332ac (28:1332 Diversity-Account Receivable)",
      "28:1332al" : "28:1332al (28:1332 Diversity-Airline Crash)",
      "28:1332as" : "28:1332as (28:1332 Diversity-Asbestos Litigation)",
      "28:1332au" : "28:1332au (28:1332 Diversity-Auto Negligence)",
      "28:1332bc" : "28:1332bc (28:1332 Diversity-Breach of Contract)",
      "28:1332co" : "28:1332co (28:1332 Diversity-Conversion)",
      "28:1332ct" : "28:1332ct (28:1332 Diversity-(Citizenship))",
      "28:1332det" : "28:1332det (28:1332 Diversity: Forcible Detainer)",
      "28:1332df" : "28:1332df (28:1332 Diversity-Contract Default)",
      "28:1332ds" : "28:1332ds (28:1332 Diversity-Contract Dispute)",
      "28:1332ed" : "28:1332ed (28:1332 Diversity-Employment Discrimination)",
      "28:1332fd" : "28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)",
      "28:1332fr" : "28:1332fr (28:1332 Diversity-Fraud)",
      "28:1332ia" : "28:1332ia (28:1332 Diversity-Interpleader Action)",
      "28:1332ij" : "28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)",
      "28:1332in" : "28:1332in (28:1332 Diversity-Insurance Contract)",
      "28:1332jd" : "28:1332jd (28:1332 Diversity-Declaratory Judgment)",
      "28:1332lb" : "28:1332lb (28:1332 Diversity-Libel, Assault, Slander)",
      "28:1332lm" : "28:1332lm (28:1332 Diversity - Legal Malpractice)",
      "28:1332ma" : "28:1332ma (28:1332 Diversity-Miller Act)",
      "28:1332mm" : "28:1332mm (28:1332 Diversity-Medical Malpractice)",
      "28:1332mv" : "28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)",
      "28:1332ni" : "28:1332ni (28:1332 Diversity-Negotiable Instrument)",
      "28:1332nm" : "28:1332nm (28:1332 Diversity-Non-Motor Vehicle)",
      "28:1332nr" : "28:1332nr (28:1332 Diversity-Notice of Removal)",
      "28:1332oc" : "28:1332oc (28:1332 Diversity-Other Contract)",
      "28:1332pd" : "28:1332pd (28:1332 Diversity-Property Damage)",
      "28:1332pi" : "28:1332pi (28:1332 Diversity-Personal Injury)",
      "28:1332pl" : "28:1332pl (28:1332 Diversity-Product Liability)",
      "28:1332pr" : "28:1332pr (28:1332 Diversity-Petition for Removal)",
      "28:1332qt" : "28:1332qt (28:1332 Diversity-Petition to Quiet Title)",
      "28:1332ri" : "28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)",
      "28:1332sa" : "28:1332sa (28:1332 - Diversity: Securities & Exchange Commiss)",
      "28:1332sf" : "28:1332sf (28:1332 - Diversity: Securities Fraud)",
      "28:1332ss" : "28:1332ss (28:1332 Diversity - Stockholders Suits)",
      "28:1332tl" : "28:1332tl (28:1332 Diversity-Torts to Land)",
      "28:1332tm" : "28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))",
      "28:1332tn" : "28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)",
      "28:1332wd" : "28:1332wd (28:1332 Diversity-Wrongful Death)",
      "28:1333" : "28:1333 (28:1333 Admiralty)",
      "28:1334" : "28:1334 (28:1334 Bankruptcy Appeal)",
      "28:1334c" : "28:1334c (28:1334(c) R&R re motions for abstention (non-cor)",
      "28:1335" : "28:1335 (28:1335 Interpleader Action)",
      "28:1337" : "28:1337 (28:1337 Sherman-Clayton Act)",
      "28:1338cp" : "28:1338cp (28:1338 Copyright Infringement)",
      "28:1338pt" : "28:1338pt (28:1338 Patent Infringement)",
      "28:1338tr" : "28:1338tr (28:1338 Trademark Infringement)",
      "28:1340" : "28:1340 (28:1340 IRS: Custom Duties)",
      "28:1340er" : "28:1340er (28:1340 Recovery of Erroneous Refund)",
      "28:1341" : "28:1341 (28:1341 Complaint for Forfeiture)",
      "28:1343" : "28:1343 (28:1343 Violation of Civil Rights)",
      "28:1345" : "28:1345 (28:1345 USA Plaintiff)",
      "28:1345co" : "28:1345co (28:1345 Replevin & Conversion)",
      "28:1345db" : "28:1345db (28:1345 Debt to US - FHA/HUD Title I)",
      "28:1345df" : "28:1345df (28:1345 Default of Promissory Note)",
      "28:1345er" : "28:1345er (28:1345 Recovery of Erroneous Refund)",
      "28:1345fc" : "28:1345fc (28:1345 Foreclosure)",
      "28:1345ff" : "28:1345ff (28:1345 Complaint for Forfeiture)",
      "28:1345hl" : "28:1345hl (28:1345 VA Home Loan Guaranty Debt)",
      "28:1345mc" : "28:1345mc (28:1345 Medical Care Recovery)",
      "28:1345mi" : "28:1345mi (28:1345 Mining Claim Ejectment)",
      "28:1345pd" : "28:1345pd (28:1345 Property Damage)",
      "28:1345pe" : "28:1345pe (28:1345 VA Property Ejectment)",
      "28:1345rc" : "28:1345rc (28:1345 Recovery of Debt to US)",
      "28:1345st" : "28:1345st (28:1345 Default of Student Loan)",
      "28:1345tp" : "28:1345tp (28:1345 Trespass on Public Land)",
      "28:1345va" : "28:1345va (28:1345 Recovery of VA Overpayment)",
      "28:1346bc" : "28:1346bc (28:1346 Breach of Contract)",
      "28:1346rc" : "28:1346rc (28:1346 Recovery of IRS Tax)",
      "28:1346tc" : "28:1346tc (28:1346 Tort Claim)",
      "28:1346wd" : "28:1346wd (28:1346 Wrongful Death)",
      "28:1349" : "28:1349 (28:1348 Corporation organized under Federal Law as party)",
      "28:1352" : "28:1352 (28:1352 Miller Act)",
      "28:1355" : "28:1355 (28:1355 Petition for Return of Property)",
      "28:1358" : "28:1358 (28:1358 Land Condemnation)",
      "28:1361" : "28:1361 (28:1361 Petition for Writ of Mandamus)",
      "28:1362ic" : "28:1362ic (28:1362 Indian Tribal Controversy)",
      "28:1362iw" : "28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)",
      "28:1364" : "28:1364 (28:1364 Auto Negligence)",
      "28:1391" : "28:1391 (28:1391 Personal Injury)",
      "28:1402" : "28:1402 (28:1402 Medical Malpractice)",
      "28:1407" : "28:1407 (28:1407 Airline Crash)",
      "28:1441ac" : "28:1441ac (28:1441 Notice of Removal-Account Receivable)",
      "28:1441al" : "28:1441al (28:1441 Notice of Removal-Airline Crash)",
      "28:1441as" : "28:1441as (28:1441 Notice of Removal-Asbestos Litigation)",
      "28:1441au" : "28:1441au (28:1441 Notice of Removal-Auto Negligence)",
      "28:1441bc" : "28:1441bc (28:1441 Notice of Removal-Breach of Contract)",
      "28:1441cv" : "28:1441cv (28:1441 Petition for Removal- Civil Rights Act)",
      "28:1441df" : "28:1441df (28:1441 Notice of Removal-Contract Default)",
      "28:1441dj" : "28:1441dj (28:1441 Notice of Removal-Declaratory Judgment)",
      "28:1441ds" : "28:1441ds (28:1441 Notice of Removal-Contract Dispute)",
      "28:1441ed" : "28:1441ed (28:1441 Petition for Removal - Employment Discrim)",
      "28:1441fc" : "28:1441fc (28:1441 Petition for Removal - Fair Credit Reporti)",
      "28:1441fr" : "28:1441fr (28:1441 Notice of Removal-Fraud)",
      "28:1441ij" : "28:1441ij (28:1441 Notice of Removal-Injunctive/Declaratory Relief)",
      "28:1441in" : "28:1441in (28:1441 Notice of Removal-Insurance Contract)",
      "28:1441int" : "28:1441int (28:1441 Petition for Removal- Action for Interplea)",
      "28:1441lb" : "28:1441lb (28:1441 Notice of Removal-Libel, Assault, Slander)",
      "28:1441lm" : "28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relatio)",
      "28:1441mm" : "28:1441mm (28:1441 Notice of Removal-Medical Malpractice)",
      "28:1441ni" : "28:1441ni (28:1441 Notice of Removal-Negotiable Instrument)",
      "28:1441nm" : "28:1441nm (28:1441 Notice of Removal-Non-Motor Vehicle)",
      "28:1441nr" : "28:1441nr (28:1441 Notice of Removal)",
      "28:1441oc" : "28:1441oc (28:1441 Petition For Removal--Other Contract)",
      "28:1441pd" : "28:1441pd (28:1441 Notice of Removal-Property Damage)",
      "28:1441pi" : "28:1441pi (28:1441 Notice of Removal-Personal Injury)",
      "28:1441pl" : "28:1441pl (28:1441 Notice of Removal-Product Liability)",
      "28:1441pr" : "28:1441pr (28:1441 Petition for Removal)",
      "28:1441qt" : "28:1441qt (28:1441 Notice of Removal-Petition to Quiet Title)",
      "28:1441ri" : "28:1441ri (28:1441 Petition for Removal- Racketeering (RICO))",
      "28:1441sa" : "28:1441sa (28:1441 - Petition for Removal: SEC Act)",
      "28:1441sf" : "28:1441sf (28:1441 - Petition for Removal: Securities Fraud)",
      "28:1441tl" : "28:1441tl (28:1441 Notice of Removal-Torts to Land)",
      "28:1441tm" : "28:1441tm (28:1441 Notice of Removal-Tort/Motor Vehicle (P.I.))",
      "28:1441tn" : "28:1441tn (28:1441 Notice of Removal-Tort/Non-Motor Vehicle)",
      "28:1441wd" : "28:1441wd (28:1441 Notice of Removal-Wrongful Death)",
      "28:1442bc" : "28:1442bc (28:1442 Notice of Removal-Breach of Contract)",
      "28:1442nr" : "28:1442nr (28:1442 Notice of Removal)",
      "28:1442pr" : "28:1442pr (28:1442 Petition for Removal)",
      "28:1443" : "28:1443 (28:1443(1) Rent, Lease & Ejectment)",
      "28:1444" : "28:1444 (28:1441 Notice of Removal-Foreclosure)",
      "28:1446in" : "28:1446in (28:1446 Breach of Contract- Insurance)",
      "28:1446nr" : "28:1446nr (28:1446 Notice of Removal)",
      "28:1446pd" : "28:1446pd (28:1446 Notice of Removal-Property Damage (P.I.))",
      "28:1446pi" : "28:1446pi (28:1446 Notice of Removal-Personal Injury)",
      "28:1446pl" : "28:1446pl (28:1446pl Petition for Removal - Product Liability)",
      "28:1446pr" : "28:1446pr (28:1446 Petition for Removal)",
      "28:1452" : "28:1452 (28:1452 Removal of Claim in Civil Action Related to BK. Case)",
      "28:1651" : "28:1651 (28:1651 Petition for Writ of Coram Nobis)",
      "28:1651hc" : "28:1651hc (28:1651 Petition for Writ of Habeas Corpus)",
      "28:1651mn" : "28:1651mn (28:1651 Petition for Writ of Mandamus)",
      "28:1655" : "28:1655 (28:1655 Petn, Relief from Judgment)",
      "28:1782" : "28:1782 (28:1782 Letter rogatory - appointment)",
      "28:1911" : "28:1911 (Fees and Costs)",
      "28:1962" : "28:1962 (28:1962 Cmp to retrieve a federal court judgment)",
      "28:1983" : "28:1983 (28:1983 Civil Rights)",
      "28:2201" : "28:2201 (28:2201 Constitutionality of State Statute(s))",
      "28:2201dj" : "28:2201dj (28:2201 Declaratory Judgment)",
      "28:2201ij" : "28:2201ij (28:2201 Injunction)",
      "28:2201in" : "28:2201in (28:2201 Declaratory Judgment (Insurance))",
      "28:2241" : "28:2241 (28:2241 Petition for Writ of Habeas Corpus (Federal))",
      "28:2254" : "28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))",
      "28:2254se" : "28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)",
      "28:2255" : "28:2255 (28:2255 Motion to Vacate Sentence)",
      "28:2271" : "28:2271 (28:2271 Federal Tort Claims Act)",
      "28:2345" : "28:2345 (28:2345 Medicare Recovery)",
      "28:2409" : "28:2409 (28:2409(a) Quiet Title Action)",
      "28:2410" : "28:2410 (Actions affecting property on which United States had lien)",
      "28:2671" : "28:2671 (28:2671 Federal Tort Claims Act)",
      "28:2674" : "28:2674 (28:2674 Federal Tort Claims Act)",
      "28:3001" : "28:3001 (28:3001 Federal Debt Collection Act)",
      "28:7402" : "28:7402 (28:7402 Refund of Taxes)",
      "28:7422" : "28:7422 (28:7422 Appeal from Administrative Decision)",
      "29:0151" : "29:0151 (29:151 Labor: Review of Agency Action)",
      "29:0160" : "29:0160 (29:160(1) National Labor Relations Act)",
      "29:0184" : "29:0184 (29:184 Violation Collection Bargain Agreement)",
      "29:0185ep" : "29:0185ep (29:185 Employee Pension Plan)",
      "29:0185lm" : "29:0185lm (29:185 Labor/Mgt. Relations (Contracts))",
      "29:0201do" : "29:0201do (29:201 Denial of Overtime Compensation)",
      "29:0201fl" : "29:0201fl (29:201 Fair Labor Standards Act)",
      "29:0203" : "29:0203 (29:203 Equal Pay Act)",
      "29:0206" : "29:0206 (29:206 Collect Unpaid Wages)",
      "29:0401" : "29:0401 (29:0401 Labor Management Disclosure Act)",
      "29:0621" : "29:0621 (29:621 Job Discrimination (Age))",
      "29:0623" : "29:0623 (29:623 Job Discrimination (Age))",
      "29:0626" : "29:0626 (29:626 Job Discrimination (Age))",
      "29:0633" : "29:0633 (29:633 Job Discrimination (Age))",
      "29:0651" : "29:0651 (29:651 Occupational Safety/Health)",
      "29:0754" : "29:0754 (29:754 Discrimination)",
      "29:0791" : "29:0791 (29:791 Job Discrimination (Rehabilitation Act))",
      "29:0794" : "29:0794 (29:0794 Job Discrimination (Handicap))",
      "29:1001" : "29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)",
      "29:1002" : "29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)",
      "29:1104" : "29:1104 (29:1104 Recovery of Benefits to Employee)",
      "29:1109" : "29:1109 (29:1109 Breach of Fiduciary Duties)",
      "29:1131" : "29:1131 (29:1131 ERISA - Collection of Delinquent Trust Funds)",
      "29:1132" : "29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)",
      "29:1145" : "29:1145 (29:1145 E.R.I.S.A.)",
      "29:1149" : "29:1149 (29:1149 Recover Pension & Profit Sharing)",
      "29:1337" : "29:1337 (29:1337 E.R.I.S.A.)",
      "29:1362" : "29:1362 (29:1362 ERISA)",
      "29:1381" : "29:1381 (29:1381 E.R.I.S.A.)",
      "29:1401" : "29:1401 (29:1401(b)(2) Appeal of Arbitration Award)",
      "29:1451" : "29:1451 (29:1451 E.R.I.S.A.)",
      "29:1801" : "29:1801 (29:1801 Farmworker Rights)",
      "29:2617" : "29:2617 (Family and Medical Leave Act)",
      "29:790" : "29:790 (29:790 Rehabilitation of Labor)",
      "30:0181" : "30:0181 (30:181 Environment: Review of Agency Action)",
      "30:0801" : "30:0801 (30:0801 Penalities/Federal Mine Safety Health Act)",
      "30:1201" : "30:1201 (30:1201 Environment: Review of Agency Action)",
      "30:1202" : "30:1202 (30:1202 Mining Reclamation Act)",
      "30:1276" : "30:1276 (30:1276 Interior: Review of Agency Action)",
      "31:3545" : "31:3545 (31:3545 Action to Recovery Money)",
      "31:3729" : "31:3729 (31:3729 False Claims Act)",
      "31:3730" : "31:3730 (31:3730 Qui Tam False Claims Act)",
      "31:3731" : "31:3731 (31:3731 Fraud)",
      "33:1319cw" : "33:1319cw (33:1319 Clean Water Act)",
      "33:1319pv" : "33:1319pv (33:1319 Pollutants & Permit Violations)",
      "33:1365" : "33:1365 (33:1365 Environmental Matters)",
      "35:0145" : "35:0145 (35:145 Patent Infringement)",
      "35:0183" : "35:0183 (35:183 Patent Infringement)",
      "35:0271" : "35:0271 (35:271 Patent Infringement)",
      "38:1681" : "38:1681 (38:1681 Recovery of VA Overpayment)",
      "38:1686" : "38:1686 (38:1686 Recovery of VA Overpayment)",
      "38:1780" : "38:1780 (38:1780 Recovery of VA Overpayment)",
      "38:2011" : "38:2011 (38:2011 - Veteran's Readjustment Assistance Act of)",
      "38:2021" : "38:2021 (Right to re-employment of inducted persons)",
      "38:3116" : "38:3116 (38:3116 VA Overpayment)",
      "38:775" : "38:775 (Recovery of Servicemen's Group Life Insurance)",
      "39:3005" : "39:3005 (39:3005 Detention of Mail for Temporary Periods)",
      "39:409" : "39:409 (39:409 Postal Service)",
      "40:0258" : "40:0258 (40:258(a) Public Buildings & Property: Land Condemnation)",
      "40:0270" : "40:0270 (40:270 Miller Act)",
      "40:0875" : "40:0875 (40:875 Public Buildings & Property: Negligence)",
      "41:0251" : "41:0251 (41:251 Public Contracts-Review of Agency Action)",
      "41:1463" : "41:1463 (41:1463 Public Contracts: Unlawful Employment Practices)",
      "42:0205" : "42:0205 (42:205 Denial Social Security Benefits)",
      "42:0206" : "42:0206 (42:206 Social Security Benefits)",
      "42:0247" : "42:0247 (42:247 Personal Injury-Swine Flu)",
      "42:0402" : "42:0402 (42:402 Social Security Benefits)",
      "42:0405id" : "42:0405id (42:405 Review of HHS Decision (SSID))",
      "42:0405wc" : "42:0405wc (42:405 Review of HHS Decision (DIWC))",
      "42:0405ww" : "42:0405ww (42:405 Review of HHS Decision (DIWW))",
      "42:0416" : "42:0416 (42:416 Denial of Social Security Benefits)",
      "42:0427" : "42:0427 (42:427 Social Security Benefits)",
      "42:12101" : "42:12101 (Americans with Disabilities Act)",
      "42:12182" : "42:12182 (42:12182 Americans with Disabilities Act)",
      "42:1383" : "42:1383 (42:1383 Review of HHS Decision)",
      "42:1395" : "42:1395 (42:1395 HHS: Adverse Reimbursement Review)",
      "42:1396" : "42:1396 (42:1396 - Tort Negligence)",
      "42:1471" : "42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclo)",
      "42:1981cv" : "42:1981cv (42:1981 Civil Rights)",
      "42:1981hs" : "42:1981hs (42:1981 Housing Discrimination)",
      "42:1981jb" : "42:1981jb (42:1981 Job Discrimination (Race))",
      "42:1981sx" : "42:1981sx (42:1981 Sex Discrimination)",
      "42:1983cv" : "42:1983cv (42:1983 Civil Rights Act)",
      "42:1983ed" : "42:1983ed (42:1983 Civil Rights (Employment Discrimination))",
      "42:1983pr" : "42:1983pr (42:1983 Prisoner Civil Rights)",
      "42:1984" : "42:1984 (Wrongful taking of Property Rights by Municipal w/o Due Proc)",
      "42:1986" : "42:1986 (42:1986 Neglect of Duty)",
      "42:2000ag" : "42:2000ag (42:2000 Job Discrimination (Age))",
      "42:2000e" : "42:2000e (42:2000e Job Discrimination (Employment))",
      "42:2000pb" : "42:2000pb (42:2000 Job Discrimination (Public Accommodations))",
      "42:2000ra" : "42:2000ra (42:2000 Job Discrimination (Race))",
      "42:2000sx" : "42:2000sx (42:2000 Job Discrimination (Sex))",
      "42:2003" : "42:2003 (42:2003 Job Discrimination)",
      "42:2005" : "42:2005 (42:2005 Review of Agency Action-HHS)",
      "42:2615" : "42:2615 (42:2616 Medical Recovery Act)",
      "42:2651" : "42:2651 (42:2651 Medical Care Recovery)",
      "42:3601" : "42:3601 (42:405 Fair Housing Act)",
      "42:4000" : "42:4000 (42:4000 National Flood Insurance Act)",
      "42:4001" : "42:4001 (42:4001 National Insurance Flood Act)",
      "42:4053" : "42:4053 (42:4053 Breach of Insurance Contract)",
      "42:4072" : "42:4072 (42:4072 Payment of Flood Insurance Claim)",
      "42:4321" : "42:4321 (42:4321 Review of Agency Action-Environment)",
      "42:4332" : "42:4332 (42:4332)",
      "42:6901en" : "42:6901en (42:6901 Environmental Cleanup Expenses)",
      "42:6901rs" : "42:6901rs (42:6901 Resource & Recovery Act)",
      "42:7413" : "42:7413 (42:7413(b) Clean Air Act)",
      "42:7604cl" : "42:7604cl (42:7604 Clear Air Act (Emission Standards))",
      "42:7604ir" : "42:7604ir (42:7604 Petition to Quash IRS Summons)",
      "42:9607" : "42:9607 (42:9607 Real Property Tort to Land)",
      "43:945" : "43:945 (43:945 Compensation for Land Condemnation)",
      "43:945a" : "43:945a (43:945a Complaint in Condemnation)",
      "43:946" : "43:946 (43:946 Complaint in Condemnation - Eminent Domain)",
      "45:0051" : "45:0051 (45:51 Railways: Fed. Employer's Liability Act)",
      "45:0151" : "45:0151 (45:151 Railway Labor Act)",
      "45:0184" : "45:0184 (45:184 Action to Set Aside Award of a System Board of Adjust)",
      "45:1395" : "45:1395 (45:1395 Railroads: Adverse Reimbursement Review)",
      "45:7457" : "45:7457 (45:7457 Compel Reclamation Under Clear Air Act)",
      "46:0688" : "46:0688 (46:0688 Jones Act)",
      "46:0741" : "46:0741 (46:741 Shipping)",
      "46:0761" : "46:0761 (46:761 Shipping: Damages for Death on High Seas)",
      "46:1101" : "46:1101 (46:1101 Violation of Maritime Regulations)",
      "46:1156" : "46:1156 (46:1156 Administrative Procedure Act)",
      "47:0605" : "47:0605 (47:0605 Communications Act of 1934)",
      "48:0883" : "48:0883 (48:883 Violation of US Coastal Law)",
      "48:1985" : "48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)",
      "49:0081" : "49:0081 (49:81 Damaged Goods While Being Transported)",
      "49:0781" : "49:0781 (49:781 Forfeiture)",
      "49:11503" : "49:11503 (49:11503 Railroad Revitalization Regulatory Reform)",
      "49:11702" : "49:11702 (49:11702(a)(4) Violations of Interstate Commerce A)",
      "49:1471" : "49:1471 (49:1471 Federal Aviation Act)",
      "49:1903" : "49:1903 (49:1903 Petition to enforce administrative summon)",
      "8:287" : "8:287 (8:287 Petition to Enforce INS Subpoena)",
      "99:9999" : "99:9999 (99:9999 Report cause code (DO NOT DELETE!))",
      "adsup" : "adsup (Administrative Subpoena)",
      "contempt" : "contempt (Contempt Proceedings)",
      "disbar" : "disbar (Disbarment Proceedings)",
      "fordepo" : "fordepo (Foreign Deposition)",
      "misc" : "misc (Civil Miscellaneous Case)",
      "motcomp" : "motcomp (Motion to Compel)",
      "motquash" : "motquash (Motion to Quash)",
      "motret" : "motret (Motion for Return of Property)",
      "petenf" : "petenf (Petition to Enforce IRS Summons)",
      "petper" : "petper (Petition to Perpetuate Testimony)",
      "regjgm" : "regjgm (Registration of Foreign Judgment)",
      "tranbkref" : "tranbkref (Transmission of Bankruptcy Reference)",
      "tranff" : "tranff (Transmission of Proposed Findings of Fact and Concl. of Law)",
      "writgar" : "writgar (Application for a Writ of Garnishment)"
   },
   "lawdce" : {
      "0" : "0 (No cause code entered)",
      "02:0431" : "02:0431 (02:431 Fed. Election Commission: Failure Enforce C)",
      "02:0437" : "02:0437 (02:437 Federal Election Commission)",
      "05:0075" : "05:0075 (05:75(2) Contract - Reduction in Grade)",
      "05:0551" : "05:0551 (05:551 Administrative Procedure Act)",
      "05:0552fi" : "05:0552fi (05:552 Freedom of Information Act)",
      "05:0552pa" : "05:0552pa (05:552 Right to Privacy Act)",
      "05:0554" : "05:0554 (05:0554 Constitutionality of Maritime Statutes)",
      "05:0701" : "05:0701 (05:0701 Maritime Subsidy Board)",
      "05:0702" : "05:0702 (05:702 Administrative Procedure Act)",
      "05:0704" : "05:0704 (05:704 Labor Litigation)",
      "05:7703" : "05:7703 (05:7703 Discrimination - Review of Agency Act)",
      "07:0006" : "07:0006 (7:6(b) Federal Commodity Exchange Regulation)",
      "07:0025" : "07:0025 (7:25 Fraud - Commodities Leverage Contracts)",
      "07:0181" : "07:0181 (07:181 Packers & Stockyard Act)",
      "07:0499" : "07:0499 (07:499 Agricultural Commodities Act)",
      "07:0601" : "07:0601 (07:601 USDA Condemnation)",
      "07:1501" : "07:1501 (07:1501 Federal Crop Insurance Act)",
      "07:2023" : "07:2023 (07:2023 Suit for injunctive relief under Food Stamp Act)",
      "07:2321" : "07:2321 (07:2321 Plant Variety Protection Act)",
      "08:0287" : "08:0287 (08:0287 Petition to Enforce INS Subpoena)",
      "08:1105" : "08:1105 (8:1105(a) Aliens: Habeas Corpus to Release INS Det)",
      "08:1183" : "08:1183 (08:1183 Alien Admission - Sponsor Obligations)",
      "08:1252" : "08:1252 (08:1252(a)(2) Injunction for Deportation)",
      "08:1260" : "08:1260 (08:1260 Aliens: Access to Records)",
      "08:1324" : "08:1324 (08:1324 Aliens: Complaint for Forfeiture)",
      "08:1329" : "08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petiti)",
      "08:1446" : "08:1446 (8:1446 Petition for Naturalization Hearing)",
      "09:0001" : "09:0001 (09:1 U.S. Arbitration Act)",
      "09:0009" : "09:0009 (9:9 Motion to Confirm Arbitration Loan)",
      "09:0010" : "09:0010 (09:0010 Petition to Vacate Arbitration Award)",
      "09:0201" : "09:0201 (09:0201 Enforcement of foreign arbitral awards)",
      "10:1408" : "10:1408 (10:1408 Claim for Military Retirement)",
      "10:1552" : "10:1552 (10:1552 Armed Forces: Action to Correct Records)",
      "10:1553" : "10:1553 (10:1553 Armed Forces: FOIA General)",
      "10:2305" : "10:2305 (10:2305 Review of Federal Contract)",
      "11:0101" : "11:0101 (11:101 Bankruptcy)",
      "11:0362" : "11:0362 (11:0362 Alleged Violation of Automatic Stay)",
      "11:0525" : "11:0525 (11:0525 Protection Against Debtor Discrimination)",
      "12:0022" : "12:0022 (12:22 Securities Fraud)",
      "12:0191" : "12:0191 (12:0191 Bank Foreclosure)",
      "12:0192" : "12:0192 (12:0192 Liquidation of National Bank)",
      "12:0635" : "12:0635 (12:635 Breach of Insurance Contract)",
      "12:1461" : "12:1461 (12:1461 Homeowners Loan Act)",
      "12:1464" : "12:1464 (12:1464 Federal Savings and Loan)",
      "12:1703" : "12:1703 (12:1703 Default of HUD Loan)",
      "12:1725" : "12:1725 (12:1725 Collection under Contract Guaranty)",
      "12:1730" : "12:1730 (12:1730 Collection Under Contract Guaranty)",
      "12:1818i2I" : "12:1818i2I (12:1818(i)(2)(I) Federal Deposit Insurance Act)",
      "12:1819" : "12:1819 (12:1819 Default of Promissory Note)",
      "12:1821" : "12:1821 (12:1821 Default of Loan by Promissary Note)",
      "12:1971" : "12:1971 (12:1971 Relief under Bank Holding Act)",
      "12:1972" : "12:1972 (12:1972 Typing Arrangement Act)",
      "12:2011" : "12:2011 (12:2011 Farm Credit Act of 1971)",
      "12:3410" : "12:3410 (12:3410 Right to Financial Privacy Act)",
      "15:0001" : "15:0001 (15:1 Antitrust Litigation)",
      "15:0002at" : "15:0002at (15:2 Antitrust Litigation)",
      "15:0002fl" : "15:0002fl (15:2(a) Fair Labor Standards Act)",
      "15:0005" : "15:0005 (15:5(a) Fair Labor Standards Act)",
      "15:0015" : "15:0015 (15:15 Antitrust Litigation)",
      "15:0025" : "15:0025 (15:25 Clayton Act)",
      "15:0044" : "15:0044 (15:44 Trademark Infringement)",
      "15:0045" : "15:0045 (15:0045 Federal Trade Commission Act)",
      "15:0052" : "15:0052 (15:0052 Federal Trade Commission Act)",
      "15:0053" : "15:0053 (15:0053 Federal Trade Commission Act)",
      "15:0053(b)" : "15:0053(b) (15:0053(b) - Prelim & Perm Inj Relief & other Equity)",
      "15:0077" : "15:0077 (15:77 Securities Fraud)",
      "15:0078" : "15:0078 (15:78m(a) Securities Exchange Act)",
      "15:0078j" : "15:0078j (15:78j(b)ss Stockholder Suit)",
      "15:0631" : "15:0631 (15:631 Small Business Act)",
      "15:0717" : "15:0717 (15:717 Natural Gas Act)",
      "15:0754" : "15:0754 (15:754 Emergency Petroleum Allocation-Admin.& Enforcement)",
      "15:1051" : "15:1051 (15:1051 Trademark Infringement)",
      "15:1114" : "15:1114 (15:1114 Trademark Infringement)",
      "15:1121" : "15:1121 (15:1121 Trademark Infringement)",
      "15:1125" : "15:1125 (15:1125 Trademark Infringement (Lanham Act))",
      "15:1126" : "15:1126 (15:1126 Patent Infringement)",
      "15:1127" : "15:1127 (15:1127 Trademark Infringement)",
      "15:1601" : "15:1601 (15:1601 Truth in Lending)",
      "15:1640" : "15:1640 (15:1640 Truth in Lending)",
      "15:1681" : "15:1681 (15:1681 Fair Credit Reporting Act)",
      "15:1691" : "15:1691 (15:1691 Equal Credit Opportunity Act)",
      "15:1692" : "15:1692 (15:1692 Fair Debt Collection Act)",
      "15:1693" : "15:1693 (15:1693 Electronic Fund Transfer Act)",
      "15:1938" : "15:1938 (15:1938 Fair Labor Standards Act)",
      "15:1981" : "15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))",
      "15:1988" : "15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))",
      "15:1989" : "15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))",
      "15:2301" : "15:2301 (15:2301 Magnuson-Moss Warranty Act)",
      "15:2801" : "15:2801 (15:2801 Petroleum Marketing Practices Act)",
      "16:0668" : "16:0668 (16:668 Bald Eagle Protection Act)",
      "16:0703" : "16:0703 (16:703 Migratory Bird Act)",
      "16:1538" : "16:1538 (16:1538 Endangered Species Act)",
      "16:3371" : "16:3371 (16:3371 Wildlife Under the Lacey Act)",
      "16:3372" : "16:3372 (16:3372 Conservation: Complaint for Forfeiture)",
      "16:3373" : "16:3373 (16:3373 Appeal of Decision - DOI)",
      "16:3374" : "16:3374 (16:3374 Conservation: Complaint for Forfeiture)",
      "17:0101" : "17:0101 (17:101 Copyright Infringement)",
      "17:0501" : "17:0501 (17:501 Copyright Infringement)",
      "17:0504" : "17:0504 (17:504 Copyright Infringement)",
      "18:0241" : "18:0241 (18:241 Conspiracy Against Citizen Rights)",
      "18:0922" : "18:0922 (18:0922 Brady Handgun Control Act)",
      "18:1030" : "18:1030 (18:1030 Computer Fraud and Abuse Act)",
      "18:1836a" : "18:1836a (18:1836(a) - Injunction against Misappropriation of Trade Secrets)",
      "18:1836b" : "18:1836b (18:1836(b) - Civil Action to Protect Trade Secrets)",
      "18:1961" : "18:1961 (18:1961 Racketeering (RICO) Act)",
      "18:1962" : "18:1962 (18:1962 Racketeering (RICO) Act)",
      "18:1964" : "18:1964 (18:1964 Racketeering (RICO) Act)",
      "18:2511" : "18:2511 (18:2511 Wiretapping)",
      "18:2701" : "18:2701 (18:2701 Unlawful access to stored communications)",
      "18:3114" : "18:3114 (18:3114 Motion for Return of Seized Property)",
      "18:4208" : "18:4208 (18:4208(B) Agency Action Review)",
      "19:1305" : "19:1305 (19:1305 Custom Duties:0Forfeiture-Immoral Articles)",
      "20:1071" : "20:1071 (20:1071 Student Loan Recovery)",
      "20:1080" : "20:1080 (20:1080 Student Loan Recovery)",
      "20:1087" : "20:1087 (20:1087 National Direct Student Loan)",
      "20:1400" : "20:1400 (20:1400 Civil Rights of Handicapped Child)",
      "20:1401" : "20:1401 (20:1401 Education: Handicapped Child Act)",
      "21:0674" : "21:0674 (21:0674 Enforcement & Inj. relief from F.D.A.)",
      "21:0841" : "21:0841 (21:841 Forfeiture Property-Drugs)",
      "21:0842" : "21:0842 (21:0842 Civil penalties-recordkeeping violations)",
      "21:0881" : "21:0881 (21:881 Forfeiture Property-Drugs)",
      "21:0881a" : "21:0881a (21:881 Forfeiture Property - Aircraft)",
      "21:0881re" : "21:0881re (21:881 Forfeiture Property - Real Estate)",
      "22:9001" : "22:9001 (22:9001 International Child Abduction Remedies)",
      "23:0134" : "23:0134 (23:134 P.I.- Auto Negligence)",
      "23:1441" : "23:1441 (23:1441 Contract Real Estate)",
      "24:1000" : "24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)",
      "25:0640" : "25:0640 (25:640 Indian Tribal Rights)",
      "25:1901" : "25:1901 (25:1901 Indian Child Welfare Act)",
      "26:4968" : "26:4968 (26:4968 Recovery of refund of IRS taxes)",
      "26:6212" : "26:6212 (26:6212 Injunctive Relief from IRS Lien)",
      "26:6213" : "26:6213 (26:6213 Injunctive Relief from IRS Lien)",
      "26:6502" : "26:6502 (26:6502 IRS:Enforcement of tax liens)",
      "26:6532" : "26:6532 (26:6532 IRS: Refund of Tax Penalty)",
      "26:6702" : "26:6702 (26:6702 IRS: Refund of Income Tax Penalty)",
      "26:6703" : "26:6703 (26:6703 IRS: Refund of Tax Penalty)",
      "26:7401" : "26:7401 (26:7401 IRS: Tax Liability)",
      "26:7402" : "26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)",
      "26:7403" : "26:7403 (26:7403 Suit to Enforce Federal Tax Lien)",
      "26:7422rt" : "26:7422rt (26:7422 IRS: Refund Taxes)",
      "26:7422rx" : "26:7422rx (26:7422 IRS: Refund Excise Tax)",
      "26:7426" : "26:7426 (26:7426 IRS: Wrongful Levy for Taxes)",
      "26:7429" : "26:7429 (26:7429 IRS: Tax Jeopardy Assessment)",
      "26:7609" : "26:7609 (26:7609 IRS: Petition to Quash IRS Summons)",
      "27:0185" : "27:0185 (27:185 Enforcement of Arbitration Award)",
      "28:0157c" : "28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)",
      "28:0157d" : "28:0157d (28:0157 Motion for Withdrawal of Reference)",
      "28:0158" : "28:0158 (28:0158 Notice of Appeal re Bankruptcy Matter)",
      "28:0185" : "28:0185 (28:185 Suit to Compel Arbitration)",
      "28:0451" : "28:0451 (28:451 Employment Discrimination)",
      "28:0754" : "28:0754 (28:0754 Receiver of Property in Different Districts)",
      "28:0794" : "28:0794 (28:794 Rehabilitation Act)",
      "28:1001" : "28:1001 (28:1001 E.R.I.S.A.)",
      "28:1132" : "28:1132 (28:1132 E.R.I.S.A.)",
      "28:1330" : "28:1330 (28:1330 Breach of Contract)",
      "28:1331" : "28:1331 (28:1331 Fed. Question)",
      "28:1331al" : "28:1331al (28:1331 Fed. Question: Airline Crash)",
      "28:1331at" : "28:1331at (28:1331 Fed. Question: Anti-trust)",
      "28:1331au" : "28:1331au (28:1331 Fed. Question: Auto Negligence)",
      "28:1331b" : "28:1331b (28:1331 Federal Question: Bivens Act)",
      "28:1331bc" : "28:1331bc (28:1331 Fed. Question: Breach of Contract)",
      "28:1331ca" : "28:1331ca (28:1331 Fed Question: Fed Communications Act of 1)",
      "28:1331cm" : "28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)",
      "28:1331cv" : "28:1331cv (28:1331 Federal Question: Other Civil Rights)",
      "28:1331ed" : "28:1331ed (28:1331 Fed. Question: Employment Discrimination)",
      "28:1331ej" : "28:1331ej (28:1331 Federal Question: Enforcement of Judgment)",
      "28:1331es" : "28:1331es (28:1331 Enforcement of Administrative Subpoena)",
      "28:1331fl" : "28:1331fl (28:1331 Fed. Question: Fair Labor Standards)",
      "28:1331in" : "28:1331in (28:1331 Fed. Question: Insurance Contract)",
      "28:1331mm" : "28:1331mm (28:1331 Fed. Question: Medical Malpractice)",
      "28:1331ng" : "28:1331ng (28:1331 Fed. Question: Natural Gas Act)",
      "28:1331pi" : "28:1331pi (28:1331 Fed. Question: Personal Injury)",
      "28:1331rd" : "28:1331rd (28:1331 Fed. Question: Review Agency Decision)",
      "28:1331rp" : "28:1331rp (28:1331(a) Fed. Question: Real Property)",
      "28:1331rr" : "28:1331rr (28:1331 Fed. Question: Railway Labor Act)",
      "28:1331sv" : "28:1331sv (28:1331 Fed. Question: Securities Violation)",
      "28:1331tr" : "28:1331tr (28:1331 Fed. Question: Trademark)",
      "28:1331tt" : "28:1331tt (28:1331 Fed. Question: Tort Action)",
      "28:1331v" : "28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendme)",
      "28:1331wl" : "28:1331wl (28:1331 Federal Question: EPA Waste Lien)",
      "28:1331wt" : "28:1331wt (28:1331 Fed. Question: Water Rights)",
      "28:1332ac" : "28:1332ac (28:1332 Diversity-Account Receivable)",
      "28:1332al" : "28:1332al (28:1332 Diversity-Airline Crash)",
      "28:1332as" : "28:1332as (28:1332 Diversity-Asbestos Litigation)",
      "28:1332au" : "28:1332au (28:1332 Diversity-Auto Negligence)",
      "28:1332bc" : "28:1332bc (28:1332 Diversity-Breach of Contract)",
      "28:1332co" : "28:1332co (28:1332 Diversity-Conversion)",
      "28:1332ct" : "28:1332ct (28:1332 Diversity-(Citizenship))",
      "28:1332det" : "28:1332det (28:1332 Diversity: Forcible Detainer)",
      "28:1332df" : "28:1332df (28:1332 Diversity-Contract Default)",
      "28:1332ds" : "28:1332ds (28:1332 Diversity-Contract Dispute)",
      "28:1332ed" : "28:1332ed (28:1332 Diversity-Employment Discrimination)",
      "28:1332fd" : "28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)",
      "28:1332fr" : "28:1332fr (28:1332 Diversity-Fraud)",
      "28:1332ia" : "28:1332ia (28:1332 Diversity-Interpleader Action)",
      "28:1332ij" : "28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)",
      "28:1332in" : "28:1332in (28:1332 Diversity-Insurance Contract)",
      "28:1332jd" : "28:1332jd (28:1332 Diversity-Declaratory Judgement)",
      "28:1332lb" : "28:1332lb (28:1332 Diversity-Libel,Assault,Slander)",
      "28:1332lm" : "28:1332lm (28:1332 Diversity - Legal Malpractice)",
      "28:1332ma" : "28:1332ma (28:1332 Diversity-Miller Act)",
      "28:1332mm" : "28:1332mm (28:1332 Diversity-Medical Malpractice)",
      "28:1332mv" : "28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)",
      "28:1332ni" : "28:1332ni (28:1332 Diversity-Negotiable Instrument)",
      "28:1332nm" : "28:1332nm (28:1332 Diversity-Non-Motor Vehicle)",
      "28:1332nr" : "28:1332nr (28:1332 Diversity-Notice of Removal)",
      "28:1332oc" : "28:1332oc (28:1332 Diversity-Other Contract)",
      "28:1332pd" : "28:1332pd (28:1332 Diversity-Property Damage)",
      "28:1332pi" : "28:1332pi (28:1332 Diversity-Personal Injury)",
      "28:1332pl" : "28:1332pl (28:1332 Diversity-Product Liability)",
      "28:1332pr" : "28:1332pr (28:1332 Diversity-Petition for Removal)",
      "28:1332qt" : "28:1332qt (28:1332 Diversity-Petition to Quiet Title)",
      "28:1332ri" : "28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)",
      "28:1332sa" : "28:1332sa (28:1332 - Diversity: Securities & Exchange Commiss)",
      "28:1332sf" : "28:1332sf (28:1332 - Diversity: Securities Fraud)",
      "28:1332ss" : "28:1332ss (28:1332 Diversity - Stockholders Suits)",
      "28:1332tl" : "28:1332tl (28:1332 Diversity-Torts to Land)",
      "28:1332tm" : "28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))",
      "28:1332tn" : "28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)",
      "28:1332wd" : "28:1332wd (28:1332 Diversity-Wrongful Death)",
      "28:1333" : "28:1333 (28:1333 Admiralty)",
      "28:1334" : "28:1334 (28:1334 Bankruptcy Cases and Proceedings)",
      "28:1334c" : "28:1334c (28:1334(c) R&R re motions for abstention (non-core))",
      "28:1335" : "28:1335 (28:1335 Interpleader Action)",
      "28:1337" : "28:1337 (28:1337 Sherman-Clayton Act)",
      "28:1338cp" : "28:1338cp (28:1338 Copyright Infringement)",
      "28:1338pt" : "28:1338pt (28:1338 Patent Infringement)",
      "28:1338tr" : "28:1338tr (28:1338 Trademark Infringement)",
      "28:1340" : "28:1340 (28:1340 IRS: Custom Duties)",
      "28:1340er" : "28:1340er (28:1340 Recovery of Erroneous Refund)",
      "28:1341" : "28:1341 (28:1341 Complaint for Forfeiture)",
      "28:1343" : "28:1343 (28:1343 Violation of Civil Rights)",
      "28:1345" : "28:1345 (28:1345 USA Plaintiff)",
      "28:1345co" : "28:1345co (28:1345 Replevin & Conversion)",
      "28:1345db" : "28:1345db (28:1345 Debt to US - FHA/HUD Title I)",
      "28:1345df" : "28:1345df (28:1345 Default of Promissory Note)",
      "28:1345er" : "28:1345er (28:1345 Recovery of Erroneous Refund)",
      "28:1345fc" : "28:1345fc (28:1345 Foreclosure)",
      "28:1345ff" : "28:1345ff (28:1345 Complaint for Forfeiture)",
      "28:1345hl" : "28:1345hl (28:1345 VA Home Loan Guaranty Debt)",
      "28:1345mc" : "28:1345mc (28:1345 Medical Care Recovery)",
      "28:1345mi" : "28:1345mi (28:1345 Mining Claim Ejectment)",
      "28:1345pd" : "28:1345pd (28:1345 Property Damage)",
      "28:1345pe" : "28:1345pe (28:1345 Property Ejectment)",
      "28:1345rc" : "28:1345rc (28:1345 Recovery of Debt to US)",
      "28:1345st" : "28:1345st (28:1345 Default of Student Loan)",
      "28:1345tp" : "28:1345tp (28:1345 Trespass on Public Land)",
      "28:1345va" : "28:1345va (28:1345 Recovery of VA Overpayment)",
      "28:1346bc" : "28:1346bc (28:1346 Breach of Contract)",
      "28:1346rc" : "28:1346rc (28:1346 Recovery of IRS Tax)",
      "28:1346tc" : "28:1346tc (28:1346 Tort Claim)",
      "28:1346wd" : "28:1346wd (28:1346 Wrongful Death)",
      "28:1349" : "28:1349 (28:1349 Corporation organized under Federal Law as party)",
      "28:1352" : "28:1352 (28:1352 Miller Act)",
      "28:1355" : "28:1355 (28:1355 Petition for Return of Property)",
      "28:1358" : "28:1358 (28:1358 Land Condemnation)",
      "28:1361" : "28:1361 (28:1361 Petition for Writ of Mandamus)",
      "28:1362ic" : "28:1362ic (28:1362 Indian Tribal Controversy)",
      "28:1362iw" : "28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)",
      "28:1364" : "28:1364 (28:1364 Auto Negligence)",
      "28:1391" : "28:1391 (28:1391 Personal Injury)",
      "28:1395" : "28:1395 (28:1395 Fine, Penalty, Forfeiture)",
      "28:1402" : "28:1402 (28:1402 Medical Malpractice)",
      "28:1407" : "28:1407 (28:1407 Airline Crash)",
      "28:1441ac" : "28:1441ac (28:1441 Petition for Removal- Account Receivable)",
      "28:1441al" : "28:1441al (28:1441 Petition for Removal- Airline Crash)",
      "28:1441as" : "28:1441as (28:1441 Petition for Removal- Asbestos Litigation)",
      "28:1441au" : "28:1441au (28:1441 Petition for Removal- Auto Negligence)",
      "28:1441bc" : "28:1441bc (28:1441 Petition for Removal- Breach of Contract)",
      "28:1441cv" : "28:1441cv (28:1441 Petition for Removal- Civil Rights Act)",
      "28:1441df" : "28:1441df (28:1441 Petition for Removal- Contract Default)",
      "28:1441dj" : "28:1441dj (28:1441 Petition for Removal- Declaratory Judgemen)",
      "28:1441ds" : "28:1441ds (28:1441 Petition for Removal- Contract Dispute)",
      "28:1441ed" : "28:1441ed (28:1441 Petition for Removal - Employment Discrimination)",
      "28:1441fc" : "28:1441fc (28:1441 Petition for Removal - Fair Credit Reporting)",
      "28:1441fr" : "28:1441fr (28:1441 Petition for Removal- Fraud)",
      "28:1441ij" : "28:1441ij (28:1441 Petition for Removal- Injunctive/Declarato)",
      "28:1441in" : "28:1441in (28:1441 Petition for Removal- Insurance Contract)",
      "28:1441int" : "28:1441int (28:1441 Petition for Removal- Action for Interpleader)",
      "28:1441lb" : "28:1441lb (28:1441 Petition for Removal Libel,Assault,Slander)",
      "28:1441lm" : "28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relations)",
      "28:1441mm" : "28:1441mm (28:1441 Petition for Removal- Medical Malpractice)",
      "28:1441ni" : "28:1441ni (28:1441 Petition for Removal- Negotiable Instrumen)",
      "28:1441nm" : "28:1441nm (28:1441 Petition for Removal- Non-Motor Vehicle)",
      "28:1441nr" : "28:1441nr (28:1441 Notice of Removal)",
      "28:1441oc" : "28:1441oc (28:1441 Petition For Removal--Other Contract)",
      "28:1441pd" : "28:1441pd (28:1441 Petition for Removal- Property Damage)",
      "28:1441pi" : "28:1441pi (28:1441 Petition for Removal- Personal Injury)",
      "28:1441pl" : "28:1441pl (28:1441 Petition for Removal- Product Liability)",
      "28:1441pr" : "28:1441pr (28:1441 Petition for Removal)",
      "28:1441qt" : "28:1441qt (28:1441 Petition for Removal- Petition to Quiet Ti)",
      "28:1441ri" : "28:1441ri (28:1441 Petition for Removal- Racketeering (RICO))",
      "28:1441sa" : "28:1441sa (28:1441 - Petition for Removal: SEC Act)",
      "28:1441sf" : "28:1441sf (28:1441 - Petition for Removal: Securities Fraud)",
      "28:1441tl" : "28:1441tl (28:1441 Petition for Removal- Torts to Land)",
      "28:1441tm" : "28:1441tm (28:1441 Petition for Removal- Tort/Motor Vehicle ()",
      "28:1441tn" : "28:1441tn (28:1441 Petition for Removal- Tort/Non-Motor Vehic)",
      "28:1441wd" : "28:1441wd (28:1441 Petition for Removal- Wrongful Death)",
      "28:1442bc" : "28:1442bc (28:1442 Petition for Removal- Breach of Contract)",
      "28:1442nr" : "28:1442nr (28:1442 Notice of Removal)",
      "28:1442pr" : "28:1442pr (28:1442 Petition for Removal)",
      "28:1443" : "28:1443 (28:1443(1) Rent, Lease & Ejectment)",
      "28:1444" : "28:1444 (28:1444 Petition for Removal- Foreclosure)",
      "28:1446in" : "28:1446in (28:1446 Breach of Contract- Insurance)",
      "28:1446nr" : "28:1446nr (28:1446 Notice of Removal)",
      "28:1446pd" : "28:1446pd (28:1446 Petition for Removal- Property Damage (P.I)",
      "28:1446pi" : "28:1446pi (28:1446 Petition for Removal- Personal Injury)",
      "28:1446pl" : "28:1446pl (28:1446pl Petition for Removal - Product Liability)",
      "28:1446pr" : "28:1446pr (28:1446 Petition for Removal)",
      "28:1452" : "28:1452 (28:1452 Removal of claim in civil action related to BK. case)",
      "28:1651" : "28:1651 (28:1651 Petition for Writ of Coram Nobis)",
      "28:1651hc" : "28:1651hc (28:1651 Petition for Writ of Habeas Corpus)",
      "28:1651mn" : "28:1651mn (28:1651 Petition for Writ of Mandamus)",
      "28:1782" : "28:1782 (28:1782 Letter rogatory - appointment)",
      "28:1962" : "28:1962 (28:1962 Lien Against Property)",
      "28:1983" : "28:1983 (28:1983 Civil Rights)",
      "28:2201" : "28:2201 (28:2201 Constitutionality of State Statute(s))",
      "28:2201dj" : "28:2201dj (28:2201 Declaratory Judgement)",
      "28:2201ij" : "28:2201ij (28:2201 Injunction)",
      "28:2201in" : "28:2201in (28:2201 Declaratory Judgement (Insurance))",
      "28:2241" : "28:2241 (28:2241 Petition for Writ of Habeas Corpus (federa)",
      "28:2254" : "28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))",
      "28:2254se" : "28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)",
      "28:2255" : "28:2255 (28:2255 Motion to Vacate / Correct Illegal Sentenc)",
      "28:2271" : "28:2271 (28:2271 Federal Tort Claims Act)",
      "28:2345" : "28:2345 (28:2345 Medicare Recovery)",
      "28:2409" : "28:2409 (28:2409(a) Quiet Title Action)",
      "28:2410" : "28:2410 (28:2410 Quiet Title)",
      "28:2671" : "28:2671 (28:2671 Federal Tort Claims Act)",
      "28:2674" : "28:2674 (28:2674 Federal Tort Claims Act)",
      "28:3001" : "28:3001 (28:3001 Federal Debt Collection Act)",
      "28:7402" : "28:7402 (28:7402 Refund of Taxes)",
      "28:7422" : "28:7422 (28:7422 Appeal from Administrative Decision)",
      "29:0151" : "29:0151 (29:151 Labor: Review of Agency Action)",
      "29:0160" : "29:0160 (29:160(1) National Labor Relations Act)",
      "29:0184" : "29:0184 (29:184 Violation Collection Bargain Agreement)",
      "29:0185ep" : "29:0185ep (29:185 Employee Pension Plan)",
      "29:0185lm" : "29:0185lm (29:185 Labor/Mgt. Relations (Contracts))",
      "29:0201do" : "29:0201do (29:201 Denial of Overtime Compensation)",
      "29:0201fl" : "29:0201fl (29:201 Fair Labor Standards Act)",
      "29:0203" : "29:0203 (29:203 Equal Pay Act)",
      "29:0206" : "29:0206 (29:206 Collect Unpaid Wages)",
      "29:0401" : "29:0401 (29:0401 Labor Management Disclosure Act)",
      "29:0621" : "29:0621 (29:621 Job Discrimination (Age))",
      "29:0623" : "29:0623 (29:623 Job Discrimination (Age))",
      "29:0626" : "29:0626 (29:626 Job Discrimination (Age))",
      "29:0633" : "29:0633 (29:633 Job Discrimination (Age))",
      "29:0651" : "29:0651 (29:651 Occupational Safety/Health)",
      "29:0754" : "29:0754 (29:754 Discrimination)",
      "29:0790" : "29:0790 (29:0790 Rehabilitation of Labor)",
      "29:0791" : "29:0791 (29:791 Job Discrimination (Rehabilitation Act))",
      "29:0794" : "29:0794 (29:0794 Job Discrimination (Handicap))",
      "29:1001" : "29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)",
      "29:1002" : "29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)",
      "29:1104" : "29:1104 (29:1104 Recovery of Benefits to Employee)",
      "29:1109" : "29:1109 (29:1109 Breach of Fiduciary Duties)",
      "29:1131" : "29:1131 (29:1131 ERISA - Collection of Delinquent Trust Fun)",
      "29:1132" : "29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)",
      "29:1145" : "29:1145 (29:1145 E.R.I.S.A.)",
      "29:1149" : "29:1149 (29:1149 Recover Pension & Profit Sharing)",
      "29:1337" : "29:1337 (29:1337 E.R.I.S.A.)",
      "29:1362" : "29:1362 (29:1362 ERISA)",
      "29:1381" : "29:1381 (29:1381 E.R.I.S.A.)",
      "29:1401" : "29:1401 (29:1401(b)(2) Appeal of Arbitration Award)",
      "29:1451" : "29:1451 (29:1451 E.R.I.S.A.)",
      "29:1801" : "29:1801 (29:1801 Farmworker Rights)",
      "29:2001" : "29:2001 (29:2001 Violation of employer polygraph protection act)",
      "29:2101" : "29:2101 (29:2101 Worker Adjustment & Retraining Notification)",
      "29:2601" : "29:2601 (29:2601 Family and Medical Leave Act)",
      "30:0181" : "30:0181 (30:181 Environment: Review of Agency Action)",
      "30:0801" : "30:0801 (30:0801 Penalities/Federal Mine Safety Health Act)",
      "30:1201" : "30:1201 (30:1201 Environment: Review of Agency Action)",
      "30:1202" : "30:1202 (30:1202 Mining Reclamation Act)",
      "30:1276" : "30:1276 (30:1276 Interior: Review of Agency Action)",
      "31:3545" : "31:3545 (31:3545 Action to Recovery Money)",
      "31:3729" : "31:3729 (31:3729 False Claims Act)",
      "31:3730" : "31:3730 (31:3730 Qui Tam False Claims Act)",
      "31:3731" : "31:3731 (31:3731 Fraud)",
      "33:0901" : "33:0901 (33:0901 Longshoreman's & Harbor Worker's Act)",
      "33:1319cw" : "33:1319cw (33:1319 Clean Water Act)",
      "33:1319pv" : "33:1319pv (33:1319 Pollutants & Permit Violations)",
      "33:1365" : "33:1365 (33:1365 Environmental Matters)",
      "33:2001" : "33:2001 (33:2001 Inland Navigation Rules)",
      "33:905(b)" : "33:905(b) (Longshoremen Workers' Compensation Act - Recovery of Damages caused by the negligence of a Vess)",
      "35:0145" : "35:0145 (35:145 Patent Infringement)",
      "35:0183" : "35:0183 (35:183 Patent Infringement)",
      "35:0271" : "35:0271 (35:271 Patent Infringement)",
      "38:1681" : "38:1681 (38:1681 Recovery of VA Overpayment)",
      "38:1686" : "38:1686 (38:1686 Recovery of VA Overpayment)",
      "38:1780" : "38:1780 (38:1780 Recovery of VA Overpayment)",
      "38:2011" : "38:2011 (38:2011 - Veteran's Readjustment Assistance Act)",
      "38:2021" : "38:2021 (38:2021 Right to re-employment of inducted persons)",
      "38:3116" : "38:3116 (38:3116 VA Overpayment)",
      "38:4301" : "38:4301 (38:4301 Employment & Re-employment Rights of Uniformed Service Members)",
      "39:0409" : "39:0409 (39:0409 - Postal Service)",
      "39:3005" : "39:3005 (39:3005 Detention of Mail for Temporary Periods)",
      "40:0258" : "40:0258 (40:258(a) Public Buildings & Property: Land Condem)",
      "40:0270" : "40:0270 (40:270 Miller Act)",
      "40:0875" : "40:0875 (40:875 Public Buildings & Property: Negligence)",
      "40:3131" : "40:3131 (40:3131 Miller Act)",
      "41:0251" : "41:0251 (41:251 Public Contracts-Review of Agency Action)",
      "41:1463" : "41:1463 (41:1463 Public Contracts: Unlawful Employment Prac)",
      "42:0121" : "42:0121 (42:121 Judicial Proceedings to Exercise Rights of Access)",
      "42:0205" : "42:0205 (42:205 Denial Social Security Benefits)",
      "42:0206" : "42:0206 (42:206 Social Security Benefits)",
      "42:0247" : "42:0247 (42:247 Personal Injury-Swine Flu)",
      "42:0294" : "42:0294 (42:0294 Health Education Assist Loan)",
      "42:0402" : "42:0402 (42:402 Social Security Benefits)",
      "42:0405id" : "42:0405id (42:405 Review of HHS Decision (SSID))",
      "42:0405wc" : "42:0405wc (42:405 Review of HHS Decision (DIWC))",
      "42:0405ww" : "42:0405ww (42:405 Review of HHS Decision (DIWW))",
      "42:0416" : "42:0416 (42:416 Denial of Social Security Benefits)",
      "42:0427" : "42:0427 (42:427 Social Security Benefits)",
      "42:11603" : "42:11603 (42:11603 International child abduction)",
      "42:12101" : "42:12101 (42:12101 Americans with Disabilities Act)",
      "42:12132" : "42:12132 (42:12132 Americans with Disabilities Act - Discrimination)",
      "42:12181" : "42:12181 (42:12181 Americans with Disabilities Act - Public Accomodations)",
      "42:1383" : "42:1383 (42:1383 Review of HHS Decision)",
      "42:1395" : "42:1395 (42:1395 HHS: Adverse Reimbursement Review)",
      "42:1395dd" : "42:1395dd (42:1395dd Emergency Medical Treatment & Active Labor Act)",
      "42:1471" : "42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclosure)",
      "42:1981cv" : "42:1981cv (42:1981 Civil Rights)",
      "42:1981hs" : "42:1981hs (42:1981 Housing Discrimination)",
      "42:1981jb" : "42:1981jb (42:1981 Job Discrimination (Race))",
      "42:1981sx" : "42:1981sx (42:1981 Sex Discrimination)",
      "42:1983cv" : "42:1983cv (42:1983 Civil Rights Act)",
      "42:1983ed" : "42:1983ed (42:1983 Civil Rights (Employment Discrimination))",
      "42:1983pr" : "42:1983pr (42:1983 Prisoner Civil Rights)",
      "42:1986" : "42:1986 (42:1986 Neglect of Duty)",
      "42:1997" : "42:1997 (42:1997 Civil rights of institutionalized persons act)",
      "42:2000ag" : "42:2000ag (42:2000 Job Discrimination (Age))",
      "42:2000e" : "42:2000e (42:2000e Job Discrimination (Employment))",
      "42:2000pb" : "42:2000pb (42:2000 Job Discrimination (Public Accomodations))",
      "42:2000ra" : "42:2000ra (42:2000 Job Discrimination (Race))",
      "42:2000sx" : "42:2000sx (42:2000 Job Discrimination (Sex))",
      "42:2003" : "42:2003 (42:2003 Job Discrimination)",
      "42:2005" : "42:2005 (42:2005 Review of Agency Action-HHS)",
      "42:2541(q)" : "42:2541(q) (42:2541(q) Suit on Natl Health Svc Corp Sch Loan)",
      "42:2651" : "42:2651 (42:2651 Medical Care Recovery)",
      "42:3601" : "42:3601 (42:405 Fair Housing Act)",
      "42:3604" : "42:3604 (42:3604 Fair Housing Act)",
      "42:4000" : "42:4000 (42:4000 National Flood Insurance Act)",
      "42:4001" : "42:4001 (42:4001 National Insurance Flood Act)",
      "42:4053" : "42:4053 (42:4053 Breach of Insurance Contract)",
      "42:4072" : "42:4072 (42:4072 Payment of Flood Insurance Claim)",
      "42:4321" : "42:4321 (42:4321 Review of Agency Action-Environment)",
      "42:4332" : "42:4332 (42:4332 Environmental Policy - Coop of Agency Repo)",
      "42:6901en" : "42:6901en (42:6901 Environmental Cleanup Expenses)",
      "42:6901rs" : "42:6901rs (42:6901 Resource & Recovery Act)",
      "42:7413" : "42:7413 (42:7413(b) Clean Air Act)",
      "42:7604cl" : "42:7604cl (42:7604 Clear Air Act (Emission Standards))",
      "42:7604ir" : "42:7604ir (42:7604 Petition to Quash IRS Summons)",
      "42:9607" : "42:9607 (42:9607 Real Property Tort to Land)",
      "43:0945" : "43:0945 (43:0945 Compensation for Land Condemnation)",
      "43:0945a" : "43:0945a (43:0945a Complaint in Condemnation)",
      "43:0946" : "43:0946 (43:0946 Complaint in Condemnation - Eminent Domain)",
      "43:1331" : "43:1331 (43:1331 General Maritime/OCSLA)",
      "43:1333" : "43:1333 (43:1333 Outer Continental Shelf Lands Act)",
      "43:1349(h)" : "43:1349(h) (43:1349(h) Suit on open acct for enforcement of lien)",
      "45:0051" : "45:0051 (45:51 Railways: Fed. Employer's Liability Act)",
      "45:0151" : "45:0151 (45:151 Railway Labor Act)",
      "45:0184" : "45:0184 (45:184 Action to Set Aside Award of a System Board)",
      "45:1395" : "45:1395 (45:1395 Railroads: Adverse Reimbursement Review)",
      "45:7457" : "45:7457 (45:7457 Compel Reclamation Under Clear Air Act)",
      "46:0183" : "46:0183 (46:0183 Exoneration from or limitation of liability)",
      "46:0688" : "46:0688 (46:0688 Jones Act Suit)",
      "46:0740" : "46:0740 (46:0740 Admiralty & Maritime Jurisdiction)",
      "46:0741" : "46:0741 (46:741 Shipping)",
      "46:0761" : "46:0761 (46:761 Shipping: Damages for Death on High Seas)",
      "46:1101" : "46:1101 (46:1101 Violation of Maritime Regulations)",
      "46:1156" : "46:1156 (46:1156 Administrative Procedure Act)",
      "46:30104" : "46:30104 (46:30104 Personal Injury to or Death of Seamen)",
      "46:30501" : "46:30501 (46:30501 Exoneration & Limitation of Liability)",
      "46:31325" : "46:31325 (46:31325 Preferred Mortgage Liens & Enforcement)",
      "47:0227" : "47:0227 (47:0227 Telephone Consumer Protection Act)",
      "47:0503" : "47:0503 (47:0503 Violation of wire or radio comm regulations)",
      "47:0605" : "47:0605 (47:0605 Unauthorized Publication or Use of Communications)",
      "48:0883" : "48:0883 (48:883 Violation of US Coastal Law)",
      "48:1985" : "48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)",
      "49:0081" : "49:0081 (49:81 Damaged Goods While Being Transported)",
      "49:0781" : "49:0781 (49:781 Forfeiture)",
      "49:11503" : "49:11503 (49:11503 Railroad Revitalization Regulatory Reform)",
      "49:11702" : "49:11702 (49:11702(a)(4) Violations of Interstate Commerce Act)",
      "49:1471" : "49:1471 (49:1471 Federal Aviation Act)",
      "49:1903" : "49:1903 (49:1903 Petition to enforce administrative summons)"
   },
   "madce" : {
      "0" : "0 (No cause code entered)",
      "02:0431" : "02:0431 (02:431 Fed. Election Commission: Failure Enforce C)",
      "02:0437" : "02:0437 (02:437 Federal Election Commission)",
      "05:0075" : "05:0075 (05:75(2) Contract - Reduction in Grade)",
      "05:0551" : "05:0551 (05:551 Administrative Procedure Act)",
      "05:0552fi" : "05:0552fi (05:552 Freedom of Information Act)",
      "05:0552pa" : "05:0552pa (05:552 Right to Privacy Act)",
      "05:0554" : "05:0554 (05:0554 Constitutionality of Maritime Statutes)",
      "05:0701" : "05:0701 (05:0701 Maritime Subsidy Board)",
      "05:0702" : "05:0702 (05:702 Administrative Procedure Act)",
      "05:0704" : "05:0704 (05:704 Labor Litigation)",
      "05:7703" : "05:7703 (05:7703 Discrimination - Review of Agency Act)",
      "05:8470" : "05:8470 (5:8470 Enforcement of Judgment Against Retirement Benefits)",
      "07:0006" : "07:0006 (7:6(b) Federal Commodity Exchange Regulation)",
      "07:0025" : "07:0025 (7:25 Fraud - Commodities Leverage Contracts)",
      "07:0181" : "07:0181 (07:181 Packers & Stockyard Act)",
      "07:0499" : "07:0499 (07:499 Agricultural Commodities Act)",
      "07:0601" : "07:0601 (07:601 USDA Condemnation)",
      "07:2321" : "07:2321 (07:2321 Plant Variety Protection Act)",
      "08:1105" : "08:1105 (8:1105(a) Aliens: Habeas Corpus to Release INS Det)",
      "08:1182" : "08:1182 (8:1182 Defend. Denial of Pla. Appl. for Alien Employment Cer)",
      "08:1252" : "08:1252 (08:1252(a)(2) Injunction for Deportation)",
      "08:1260" : "08:1260 (08:1260 Aliens: Access to Records)",
      "08:1324" : "08:1324 (08:1324 Aliens: Complaint for Forfeiture)",
      "08:1329" : "08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petiti)",
      "08:1446" : "08:1446 (8:1446 Petition for Naturalization Hearing)",
      "08:1451(j)" : "08:1451(j) (8:1451(j) Motion to Correct Order & Judg. of Naturalization)",
      "09:0001" : "09:0001 (09:1 U.S. Arbitration Act)",
      "09:0009" : "09:0009 (9:9 Motion to Confirm Arbitration Loan)",
      "09:0010" : "09:0010 (09:0010 Petition to Vacate Arbitration Award)",
      "10:1408" : "10:1408 (10:1408 Claim for Military Retirement)",
      "10:1552" : "10:1552 (10:1552 Armed Forces: Action to Correct Records)",
      "10:1553" : "10:1553 (10:1553 Armed Forces: FOIA General)",
      "10:2305" : "10:2305 (10:2305 Review of Federal Contract)",
      "11:0101" : "11:0101 (11:101 Bankruptcy)",
      "11:0548" : "11:0548 (11:548 Unfair and Deceptive Trade Acts)",
      "12:0022" : "12:0022 (12:22 Securities Fraud)",
      "12:0635" : "12:0635 (12:635 Breach of Insurance Contract)",
      "12:1452f" : "12:1452f (12:1452(f) Action to enforce note and mortgage)",
      "12:1461" : "12:1461 (12:1461 Homeowners Loan Act)",
      "12:1464" : "12:1464 (12:1464 Federal Savings and Loan)",
      "12:1703" : "12:1703 (12:1703 Default of HUD Loan)",
      "12:1725" : "12:1725 (12:1725 Collection under Contract Guaranty)",
      "12:1730" : "12:1730 (12:1730 Collection Under Contract Guaranty)",
      "12:1819" : "12:1819 (12:1819 Default of Promissory Note)",
      "12:1821" : "12:1821 (12:1821 Default of Loan by Promissary Note)",
      "12:191" : "12:191 (12:191 Bank Foreclosure)",
      "12:192" : "12:192 (12:192 Liquidation of National Bank)",
      "12:1971" : "12:1971 (12:1971 Relief under Bank Holding Act)",
      "12:1972" : "12:1972 (12:1972 Typing Arrangement Act)",
      "12:2601" : "12:2601 (Real Estate Settlement Procedures Act)",
      "12:3410" : "12:3410 (12:3410 Right to Financial Privacy Act)",
      "15:0001" : "15:0001 (15:1 Antitrust Litigation)",
      "15:0002at" : "15:0002at (15:2 Antitrust Litigation)",
      "15:0002fl" : "15:0002fl (15:2(a) Fair Labor Standards Act)",
      "15:0005" : "15:0005 (15:5(a) Fair Labor Standards Act)",
      "15:0015" : "15:0015 (15:15 Antitrust Litigation)",
      "15:0025" : "15:0025 (15:25 Clayton Act)",
      "15:0044" : "15:0044 (15:44 Trademark Infringement)",
      "15:0045" : "15:0045 (15:0045 Federal Trade Commission Act)",
      "15:0052" : "15:0052 (15:0052 Federal Trade Commission Act)",
      "15:0053" : "15:0053 (15:0053 Federal Trade Commission Act)",
      "15:0077" : "15:0077 (15:77 Securities Fraud)",
      "15:0078" : "15:0078 (15:78m(a) Securities Exchange Act)",
      "15:0631" : "15:0631 (15:631 Small Business Act)",
      "15:0717" : "15:0717 (15:717 Natural Gas Act)",
      "15:0754" : "15:0754 (15:754 Emergency Petroleum Allocation-Admin.& Enforcement)",
      "15:1051" : "15:1051 (15:1051 Trademark Infringement)",
      "15:1114" : "15:1114 (15:1114 Trademark Infringement)",
      "15:1121" : "15:1121 (15:1121 Trademark Infringement)",
      "15:1125" : "15:1125 (15:1125 Trademark Infringement (Lanham Act))",
      "15:1126" : "15:1126 (15:1126 Patent Infringement)",
      "15:1127" : "15:1127 (15:1127 Trademark Infringement)",
      "15:1601" : "15:1601 (15:1601 Truth in Lending)",
      "15:1640" : "15:1640 (15:1640 Truth in Lending)",
      "15:1679" : "15:1679 (Credit Repair Organizations Act)",
      "15:1681" : "15:1681 (15:1681 Fair Credit Reporting Act)",
      "15:1692" : "15:1692 (15:1692 Fair Debt Collection Act)",
      "15:1938" : "15:1938 (15:1938 Fair Labor Standards Act)",
      "15:1981" : "15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))",
      "15:1988" : "15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))",
      "15:1989" : "15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))",
      "15:2301" : "15:2301 (15:2301 Magnuson-Moss Warranty Act)",
      "15:2801" : "15:2801 (15:2801 Petroleum Marketing Practices Act)",
      "15:53(b)" : "15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equita)",
      "16:0668" : "16:0668 (16:668 Bald Eagle Protection Act)",
      "16:0703" : "16:0703 (16:703 Migratory Bird Act)",
      "16:1538" : "16:1538 (16:1538 Endangered Species Act)",
      "16:3371" : "16:3371 (16:3371 Wildlife Under the Lacey Act)",
      "16:3372" : "16:3372 (16:3372 Conservation: Complaint for Forfeiture)",
      "16:3373" : "16:3373 (16:3373 Appeal of Decision - DOI)",
      "16:3374" : "16:3374 (16:3374 Conservation: Complaint for Forfeiture)",
      "17:0101" : "17:0101 (17:101 Copyright Infringement)",
      "17:0501" : "17:0501 (17:501 Copyright Infringement)",
      "17:0504" : "17:0504 (17:504 Copyright Infringement)",
      "17:0512" : "17:0512 (17:512(h) Digitial Millennium Copyright Act of 1998)",
      "17:512h" : "17:512h (17:512(h) Subpoena issued)",
      "18:0241" : "18:0241 (18:241 Conspiracy Against Citizen Rights)",
      "18:1030" : "18:1030 (18:1030 Violation of Computer Fraud and Abuse Act)",
      "18:1836a" : "18:1836a (18:1836(a) Injunction against Misappropriation of Trade Secrets)",
      "18:1836b" : "18:1836b (18:1836(b) Civil Action to Protect Trade Secrets)",
      "18:1955" : "18:1955 (Forfeiture - gambling)",
      "18:1961" : "18:1961 (18:1961 Racketeering (RICO) Act)",
      "18:1962" : "18:1962 (18:1962 Racketeering (RICO) Act)",
      "18:1964" : "18:1964 (18:1964 Racketeering (RICO) Act)",
      "18:2511" : "18:2511 (18:2511 Wiretapping)",
      "18:3114" : "18:3114 (18:3114 Motion for Return of Seized Property)",
      "18:4208" : "18:4208 (18:4208(B) Agency Action Review)",
      "18:4246" : "18:4246 (Certification of Dangerousness Due to Mental Disease or Defect)",
      "18:4248" : "18:4248 (18:4248(a) Commitment of Sexually Dangerous Person)",
      "19:1305" : "19:1305 (19:1305 Custom Duties:0Forfeiture-Immoral Articles)",
      "20:1080" : "20:1080 (20:1080 Student Loan Recovery)",
      "20:1400" : "20:1400 (20:1400 Civil Rights of Handicapped Child)",
      "20:1401" : "20:1401 (20:1401 Education: Handicapped Child Act)",
      "20:1415" : "20:1415 (20:1415 Rights to Special Educational Services)",
      "21:0841" : "21:0841 (21:841 Forfeiture Property-Drugs)",
      "21:0881" : "21:0881 (21:881 Forfeiture Property-Drugs)",
      "21:0881a" : "21:0881a (21:881 Forfeiture Property - Aircraft)",
      "21:0881re" : "21:0881re (21:881 Forfeiture Property - Real Estate)",
      "23:0134" : "23:0134 (23:134 P.I.- Auto Negligence)",
      "23:1441" : "23:1441 (23:1441 Contract Real Estate)",
      "24:1000" : "24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)",
      "25:0640" : "25:0640 (25:640 Indian Tribal Rights)",
      "25:1901" : "25:1901 (25:1901 Indian Child Welfare Act)",
      "26:6212" : "26:6212 (26:6212 Injunctive Relief from IRS Lien)",
      "26:6213" : "26:6213 (26:6213 Injunctive Relief from IRS Lien)",
      "26:6502" : "26:6502 (26:6502 IRS:Enforcement of tax liens)",
      "26:6532" : "26:6532 (26:6532 IRS: Refund of Tax Penalty)",
      "26:6702" : "26:6702 (26:6702 IRS: Refund of Income Tax Penalty)",
      "26:6703" : "26:6703 (26:6703 IRS: Refund of Tax Penalty)",
      "26:7401" : "26:7401 (26:7401 IRS: Tax Liability)",
      "26:7402" : "26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)",
      "26:7403" : "26:7403 (26:7403 Suit to Enforce Federal Tax Lien)",
      "26:7422rt" : "26:7422rt (26:7422 IRS: Refund Taxes)",
      "26:7422rx" : "26:7422rx (26:7422 IRS: Refund Excise Tax)",
      "26:7426" : "26:7426 (26:7426 IRS: Wrongful Levy for Taxes)",
      "26:7429" : "26:7429 (26:7429 IRS: Tax Jeopardy Assessment)",
      "26:7609" : "26:7609 (26:7609 IRS: Petition to Quash IRS Summons)",
      "27:0185" : "27:0185 (27:185 Enforcement of Arbitration Award)",
      "28:0157c" : "28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)",
      "28:0157d" : "28:0157d (28:0157 Motion for Withdrawal of Reference)",
      "28:0158" : "28:0158 (28:0158 Notice of Appeal re Bankruptcy Matter (BA)",
      "28:0185" : "28:0185 (28:185 Suit to Compel Arbitration)",
      "28:0451" : "28:0451 (28:451 Employment Discrimination)",
      "28:0754" : "28:0754 (28:754 Receiver of Property in Different Districts)",
      "28:0794" : "28:0794 (28:794 Rehabilitation Act)",
      "28:1001" : "28:1001 (28:1001 E.R.I.S.A.)",
      "28:1132" : "28:1132 (28:1132 E.R.I.S.A.)",
      "28:1330" : "28:1330 (28:1330 Breach of Contract)",
      "28:1331" : "28:1331 (28:1331 Fed. Question)",
      "28:1331al" : "28:1331al (28:1331 Fed. Question: Airline Crash)",
      "28:1331at" : "28:1331at (28:1331 Fed. Question: Anti-trust)",
      "28:1331au" : "28:1331au (28:1331 Fed. Question: Auto Negligence)",
      "28:1331b" : "28:1331b (28:1331 Federal Question: Bivens Act)",
      "28:1331bc" : "28:1331bc (28:1331 Fed. Question: Breach of Contract)",
      "28:1331ca" : "28:1331ca (28:1331 Fed Question: Fed Communications Act of 1)",
      "28:1331cm" : "28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)",
      "28:1331cv" : "28:1331cv (28:1331 Federal Question: Other Civil Rights)",
      "28:1331ed" : "28:1331ed (28:1331 Fed. Question: Employment Discrimination)",
      "28:1331ej" : "28:1331ej (28:1331 Federal Question: Enforcement of Judgment)",
      "28:1331es" : "28:1331es (28:1331 Enforcement of Administrative Subpoena)",
      "28:1331fl" : "28:1331fl (28:1331 Fed. Question: Fair Labor Standards)",
      "28:1331in" : "28:1331in (28:1331 Fed. Question: Insurance Contract)",
      "28:1331mm" : "28:1331mm (28:1331 Fed. Question: Medical Malpractice)",
      "28:1331ng" : "28:1331ng (28:1331 Fed. Question: Natural Gas Act)",
      "28:1331pi" : "28:1331pi (28:1331 Fed. Question: Personal Injury)",
      "28:1331rd" : "28:1331rd (28:1331 Fed. Question: Review Agency Decision)",
      "28:1331rp" : "28:1331rp (28:1331(a) Fed. Question: Real Property)",
      "28:1331rr" : "28:1331rr (28:1331 Fed. Question: Railway Labor Act)",
      "28:1331sv" : "28:1331sv (28:1331 Fed. Question: Securities Violation)",
      "28:1331tr" : "28:1331tr (28:1331 Fed. Question: Trademark)",
      "28:1331tt" : "28:1331tt (28:1331 Fed. Question: Tort Action)",
      "28:1331v" : "28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendme)",
      "28:1331wl" : "28:1331wl (28:1331 Federal Question: EPA Waste Lien)",
      "28:1331wt" : "28:1331wt (28:1331 Fed. Question: Water Rights)",
      "28:1332ac" : "28:1332ac (28:1332 Diversity-Account Receivable)",
      "28:1332al" : "28:1332al (28:1332 Diversity-Airline Crash)",
      "28:1332as" : "28:1332as (28:1332 Diversity-Asbestos Litigation)",
      "28:1332au" : "28:1332au (28:1332 Diversity-Auto Negligence)",
      "28:1332bc" : "28:1332bc (28:1332 Diversity-Breach of Contract)",
      "28:1332co" : "28:1332co (28:1332 Diversity-Conversion)",
      "28:1332ct" : "28:1332ct (28:1332 Diversity-(Citizenship))",
      "28:1332det" : "28:1332det (28:1332 Diversity: Forcible Detainer)",
      "28:1332df" : "28:1332df (28:1332 Diversity-Contract Default)",
      "28:1332ds" : "28:1332ds (28:1332 Diversity-Contract Dispute)",
      "28:1332ed" : "28:1332ed (28:1332 Diversity-Employment Discrimination)",
      "28:1332fd" : "28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)",
      "28:1332fr" : "28:1332fr (28:1332 Diversity-Fraud)",
      "28:1332ia" : "28:1332ia (28:1332 Diversity-Interpleader Action)",
      "28:1332ij" : "28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)",
      "28:1332in" : "28:1332in (28:1332 Diversity-Insurance Contract)",
      "28:1332jd" : "28:1332jd (28:1332 Diversity-Declaratory Judgment)",
      "28:1332lb" : "28:1332lb (28:1332 Diversity-Libel,Assault,Slander)",
      "28:1332lm" : "28:1332lm (28:1332 Diversity - Legal Malpractice)",
      "28:1332ma" : "28:1332ma (28:1332 Diversity-Miller Act)",
      "28:1332mm" : "28:1332mm (28:1332 Diversity-Medical Malpractice)",
      "28:1332mv" : "28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)",
      "28:1332ni" : "28:1332ni (28:1332 Diversity-Negotiable Instrument)",
      "28:1332nm" : "28:1332nm (28:1332 Diversity-Non-Motor Vehicle)",
      "28:1332nr" : "28:1332nr (28:1332 Diversity-Notice of Removal)",
      "28:1332oc" : "28:1332oc (28:1332 Diversity-Other Contract)",
      "28:1332pd" : "28:1332pd (28:1332 Diversity-Property Damage)",
      "28:1332pi" : "28:1332pi (28:1332 Diversity-Personal Injury)",
      "28:1332pl" : "28:1332pl (28:1332 Diversity-Product Liability)",
      "28:1332pr" : "28:1332pr (28:1332 Diversity-Petition for Removal)",
      "28:1332qt" : "28:1332qt (28:1332 Diversity-Petition to Quiet Title)",
      "28:1332ri" : "28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)",
      "28:1332sa" : "28:1332sa (28:1332 - Diversity: Securities & Exchange Commiss)",
      "28:1332sf" : "28:1332sf (28:1332 - Diversity: Securities Fraud)",
      "28:1332ss" : "28:1332ss (28:1332 Diversity - Stockholders Suits)",
      "28:1332tl" : "28:1332tl (28:1332 Diversity-Torts to Land)",
      "28:1332tm" : "28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))",
      "28:1332tn" : "28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)",
      "28:1332wd" : "28:1332wd (28:1332 Diversity-Wrongful Death)",
      "28:1333" : "28:1333 (28:1333 Admiralty)",
      "28:1334" : "28:1334 (28:1334 Bankruptcy Appeal)",
      "28:1334c" : "28:1334c (28:1334(c) R&R re motions for abstention (non-cor)",
      "28:1335" : "28:1335 (28:1335 Interpleader Action)",
      "28:1337" : "28:1337 (28:1337 Sherman-Clayton Act)",
      "28:1338cp" : "28:1338cp (28:1338 Copyright Infringement)",
      "28:1338pt" : "28:1338pt (28:1338 Patent Infringement)",
      "28:1338tr" : "28:1338tr (28:1338 Trademark Infringement)",
      "28:1340" : "28:1340 (28:1340 IRS: Custom Duties)",
      "28:1340er" : "28:1340er (28:1340 Recovery of Erroneous Refund)",
      "28:1341" : "28:1341 (28:1341 Complaint for Forfeiture)",
      "28:1343" : "28:1343 (28:1343 Violation of Civil Rights)",
      "28:1345" : "28:1345 (28:1345 USA Plaintiff)",
      "28:1345co" : "28:1345co (28:1345 Replevin & Conversion)",
      "28:1345db" : "28:1345db (28:1345 Debt to US - FHA/HUD Title I)",
      "28:1345df" : "28:1345df (28:1345 Default of Promissory Note)",
      "28:1345er" : "28:1345er (28:1345 Recovery of Erroneous Refund)",
      "28:1345fc" : "28:1345fc (28:1345 Foreclosure)",
      "28:1345ff" : "28:1345ff (28:1345 Complaint for Forfeiture)",
      "28:1345hl" : "28:1345hl (28:1345 VA Home Loan Guaranty Debt)",
      "28:1345mc" : "28:1345mc (28:1345 Medical Care Recovery)",
      "28:1345mi" : "28:1345mi (28:1345 Mining Claim Ejectment)",
      "28:1345pd" : "28:1345pd (28:1345 Property Damage)",
      "28:1345pe" : "28:1345pe (28:1345 Property Ejectment)",
      "28:1345rc" : "28:1345rc (28:1345 Recovery of Debt to US)",
      "28:1345st" : "28:1345st (28:1345 Default of Student Loan)",
      "28:1345tp" : "28:1345tp (28:1345 Trespass on Public Land)",
      "28:1345va" : "28:1345va (28:1345 Recovery of VA Overpayment)",
      "28:1346bc" : "28:1346bc (28:1346 Breach of Contract)",
      "28:1346rc" : "28:1346rc (28:1346 Recovery of IRS Tax)",
      "28:1346tc" : "28:1346tc (28:1346 Tort Claim)",
      "28:1346wd" : "28:1346wd (28:1346 Wrongful Death)",
      "28:1349" : "28:1349 (28:1349 Corporation organized under Federal Law as party)",
      "28:1352" : "28:1352 (28:1352 Miller Act)",
      "28:1355" : "28:1355 (28:1355 Petition for Return of Property)",
      "28:1358" : "28:1358 (28:1358 Land Condemnation)",
      "28:1361" : "28:1361 (28:1361 Petition for Writ of Mandamus)",
      "28:1362ic" : "28:1362ic (28:1362 Indian Tribal Controversy)",
      "28:1362iw" : "28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)",
      "28:1364" : "28:1364 (28:1364 Auto Negligence)",
      "28:1391" : "28:1391 (28:1391 Personal Injury)",
      "28:1402" : "28:1402 (28:1402 Medical Malpractice)",
      "28:1407" : "28:1407 (28:1407 Airline Crash)",
      "28:1441ac" : "28:1441ac (28:1441 Petition for Removal- Account Receivable)",
      "28:1441al" : "28:1441al (28:1441 Petition for Removal- Airline Crash)",
      "28:1441as" : "28:1441as (28:1441 Petition for Removal- Asbestos Litigation)",
      "28:1441au" : "28:1441au (28:1441 Petition for Removal- Auto Negligence)",
      "28:1441bc" : "28:1441bc (28:1441 Petition for Removal- Breach of Contract)",
      "28:1441cv" : "28:1441cv (28:1441 Petition for Removal- Civil Rights Act)",
      "28:1441df" : "28:1441df (28:1441 Petition for Removal- Contract Default)",
      "28:1441dj" : "28:1441dj (28:1441 Petition for Removal- Declaratory Judgemen)",
      "28:1441ds" : "28:1441ds (28:1441 Petition for Removal- Contract Dispute)",
      "28:1441ed" : "28:1441ed (28:1441 Petition for Removal - Employment Discrim)",
      "28:1441fc" : "28:1441fc (28:1441 Petition for Removal - Fair Credit Reporti)",
      "28:1441fr" : "28:1441fr (28:1441 Petition for Removal- Fraud)",
      "28:1441ij" : "28:1441ij (28:1441 Petition for Removal- Injunctive/Declarato)",
      "28:1441in" : "28:1441in (28:1441 Petition for Removal- Insurance Contract)",
      "28:1441int" : "28:1441int (28:1441 Petition for Removal- Action for Interplea)",
      "28:1441lb" : "28:1441lb (28:1441 Petition for Removal Libel,Assault,Slander)",
      "28:1441lm" : "28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relatio)",
      "28:1441mm" : "28:1441mm (28:1441 Petition for Removal- Medical Malpractice)",
      "28:1441ni" : "28:1441ni (28:1441 Petition for Removal- Negotiable Instrumen)",
      "28:1441nm" : "28:1441nm (28:1441 Petition for Removal- Non-Motor Vehicle)",
      "28:1441nr" : "28:1441nr (28:1441 Notice of Removal)",
      "28:1441oc" : "28:1441oc (28:1441 Petition For Removal--Other Contract)",
      "28:1441pd" : "28:1441pd (28:1441 Petition for Removal- Property Damage)",
      "28:1441pi" : "28:1441pi (28:1441 Petition for Removal- Personal Injury)",
      "28:1441pl" : "28:1441pl (28:1441 Petition for Removal- Product Liability)",
      "28:1441pr" : "28:1441pr (28:1441 Petition for Removal)",
      "28:1441qt" : "28:1441qt (28:1441 Petition for Removal- Petition to Quiet Ti)",
      "28:1441ri" : "28:1441ri (28:1441 Petition for Removal- Racketeering (RICO))",
      "28:1441sa" : "28:1441sa (28:1441 - Petition for Removal: SEC Act)",
      "28:1441sf" : "28:1441sf (28:1441 - Petition for Removal: Securities Fraud)",
      "28:1441tl" : "28:1441tl (28:1441 Petition for Removal- Torts to Land)",
      "28:1441tm" : "28:1441tm (28:1441 Petition for Removal- Tort/Motor Vehicle ()",
      "28:1441tn" : "28:1441tn (28:1441 Petition for Removal- Tort/Non-Motor Vehic)",
      "28:1441wd" : "28:1441wd (28:1441 Petition for Removal- Wrongful Death)",
      "28:1442bc" : "28:1442bc (28:1442 Petition for Removal- Breach of Contract)",
      "28:1442nr" : "28:1442nr (28:1442 Notice of Removal)",
      "28:1442pr" : "28:1442pr (28:1442 Petition for Removal)",
      "28:1443" : "28:1443 (28:1443(1) Rent, Lease & Ejectment)",
      "28:1444" : "28:1444 (28:1444 Petition for Removal- Foreclosure)",
      "28:1446in" : "28:1446in (28:1446 Breach of Contract- Insurance)",
      "28:1446nr" : "28:1446nr (28:1446 Notice of Removal)",
      "28:1446pd" : "28:1446pd (28:1446 Petition for Removal- Property Damage (P.I)",
      "28:1446pi" : "28:1446pi (28:1446 Petition for Removal- Personal Injury)",
      "28:1446pl" : "28:1446pl (28:1446pl Petition for Removal - Product Liability)",
      "28:1446pr" : "28:1446pr (28:1446 Petition for Removal)",
      "28:1452" : "28:1452 (28:1452 R&R re motions to remand (non-core))",
      "28:1651" : "28:1651 (28:1651 Petition for Writ of Coram Nobis)",
      "28:1651hc" : "28:1651hc (28:1651 Petition for Writ of Habeas Corpus)",
      "28:1651mn" : "28:1651mn (28:1651 Petition for Writ of Mandamus)",
      "28:1782" : "28:1782 (28:1782 Letter rogatory - appointment)",
      "28:1983" : "28:1983 (28:1983 Civil Rights)",
      "28:2201" : "28:2201 (28:2201 Constitutionality of State Statute(s))",
      "28:2201dj" : "28:2201dj (28:2201 Declaratory Judgment)",
      "28:2201ij" : "28:2201ij (28:2201 Injunction)",
      "28:2201in" : "28:2201in (28:2201 Declaratory Judgment (Insurance))",
      "28:2241" : "28:2241 (28:2241 Petition for Writ of Habeas Corpus (federa)",
      "28:2254" : "28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))",
      "28:2254se" : "28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)",
      "28:2255" : "28:2255 (28:2255 Motion to Vacate / Correct Illegal Sentenc)",
      "28:2271" : "28:2271 (28:2271 Federal Tort Claims Act)",
      "28:2345" : "28:2345 (28:2345 Medicare Recovery)",
      "28:2409" : "28:2409 (28:2409(a) Quiet Title Action)",
      "28:2410" : "28:2410 (28:2410 Quiet Title)",
      "28:2671" : "28:2671 (28:2671 Federal Tort Claims Act)",
      "28:2674" : "28:2674 (28:2674 Federal Tort Claims Act)",
      "28:3001" : "28:3001 (28:3001 Federal Debt Collection Act)",
      "28:7402" : "28:7402 (28:7402 Refund of Taxes)",
      "28:7422" : "28:7422 (28:7422 Appeal from Administrative Decision)",
      "29:0151" : "29:0151 (29:151 Labor: Review of Agency Action)",
      "29:0160" : "29:0160 (29:160(1) National Labor Relations Act)",
      "29:0184" : "29:0184 (29:184 Violation Collection Bargain Agreement)",
      "29:0185ep" : "29:0185ep (29:185 Employee Pension Plan)",
      "29:0185lm" : "29:0185lm (29:185 Labor/Mgt. Relations (Contracts))",
      "29:0201do" : "29:0201do (29:201 Denial of Overtime Compensation)",
      "29:0201fl" : "29:0201fl (29:201 Fair Labor Standards Act)",
      "29:0203" : "29:0203 (29:203 Equal Pay Act)",
      "29:0206" : "29:0206 (29:206 Collect Unpaid Wages)",
      "29:0401" : "29:0401 (29:0401 Labor Management Disclosure Act)",
      "29:0621" : "29:0621 (29:621 Job Discrimination (Age))",
      "29:0623" : "29:0623 (29:623 Job Discrimination (Age))",
      "29:0626" : "29:0626 (29:626 Job Discrimination (Age))",
      "29:0633" : "29:0633 (29:633 Job Discrimination (Age))",
      "29:0651" : "29:0651 (29:651 Occupational Safety/Health)",
      "29:0754" : "29:0754 (29:754 Discrimination)",
      "29:0791" : "29:0791 (29:791 Job Discrimination (Rehabilitation Act))",
      "29:0794" : "29:0794 (29:0794 Job Discrimination (Handicap))",
      "29:1001" : "29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)",
      "29:1002" : "29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)",
      "29:1104" : "29:1104 (29:1104 Recovery of Benefits to Employee)",
      "29:1109" : "29:1109 (29:1109 Breach of Fiduciary Duties)",
      "29:1131" : "29:1131 (29:1131 ERISA - Collection of Delinquent Trust Fun)",
      "29:1132" : "29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)",
      "29:1145" : "29:1145 (29:1145 E.R.I.S.A.)",
      "29:1149" : "29:1149 (29:1149 Recover Pension & Profit Sharing)",
      "29:1337" : "29:1337 (29:1337 E.R.I.S.A.)",
      "29:1342" : "29:1342 (ERISA - Termination Proceedings)",
      "29:1362" : "29:1362 (29:1362 ERISA)",
      "29:1381" : "29:1381 (29:1381 E.R.I.S.A.)",
      "29:1401" : "29:1401 (29:1401(b)(2) Appeal of Arbitration Award)",
      "29:1451" : "29:1451 (29:1451 E.R.I.S.A.)",
      "29:1801" : "29:1801 (29:1801 Farmworker Rights)",
      "29:2601" : "29:2601 (Family and Medical Leave Act of 1993)",
      "29:790" : "29:790 (29:790 Rehabilitation of Labor)",
      "30:0181" : "30:0181 (30:181 Environment: Review of Agency Action)",
      "30:0801" : "30:0801 (30:0801 Penalities/Federal Mine Safety Health Act)",
      "30:1201" : "30:1201 (30:1201 Environment: Review of Agency Action)",
      "30:1202" : "30:1202 (30:1202 Mining Reclamation Act)",
      "30:1276" : "30:1276 (30:1276 Interior: Review of Agency Action)",
      "31:3545" : "31:3545 (31:3545 Action to Recovery Money)",
      "31:3729" : "31:3729 (31:3729 False Claims Act)",
      "31:3730" : "31:3730 (31:3730 Qui Tam False Claims Act)",
      "31:3731" : "31:3731 (31:3731 Fraud)",
      "33:1319cw" : "33:1319cw (33:1319 Clean Water Act)",
      "33:1319pv" : "33:1319pv (33:1319 Pollutants & Permit Violations)",
      "33:1365" : "33:1365 (33:1365 Environmental Matters)",
      "35:0145" : "35:0145 (35:145 Patent Infringement)",
      "35:0183" : "35:0183 (35:183 Patent Infringement)",
      "35:0271" : "35:0271 (35:271 Patent Infringement)",
      "38:1681" : "38:1681 (38:1681 Recovery of VA Overpayment)",
      "38:1686" : "38:1686 (38:1686 Recovery of VA Overpayment)",
      "38:1780" : "38:1780 (38:1780 Recovery of VA Overpayment)",
      "38:2011" : "38:2011 (38:2011 - Veteran's Readjustment Assistance Act of)",
      "38:2021" : "38:2021 (38:2021 Right to re-employment of inducted persons)",
      "38:3116" : "38:3116 (38:3116 VA Overpayment)",
      "38:775" : "38:775 (38:775 Recovery of Servicemen's Group Life Insurance)",
      "39:3005" : "39:3005 (39:3005 Detention of Mail for Temporary Periods)",
      "39:409" : "39:409 (39:409 Postal Service)",
      "40:0258" : "40:0258 (40:258(a) Public Buildings & Property: Land Condem)",
      "40:0270" : "40:0270 (40:270 Miller Act)",
      "40:0875" : "40:0875 (40:875 Public Buildings & Property: Negligence)",
      "41:0251" : "41:0251 (41:251 Public Contracts-Review of Agency Action)",
      "41:1463" : "41:1463 (41:1463 Public Contracts: Unlawful Employment Prac)",
      "42:0205" : "42:0205 (42:205 Denial Social Security Benefits)",
      "42:0206" : "42:0206 (42:206 Social Security Benefits)",
      "42:0247" : "42:0247 (42:247 Personal Injury-Swine Flu)",
      "42:0402" : "42:0402 (42:402 Social Security Benefits)",
      "42:0405id" : "42:0405id (42:405 Review of HHS Decision (SSID))",
      "42:0405wc" : "42:0405wc (42:405 Review of HHS Decision (DIWC))",
      "42:0405ww" : "42:0405ww (42:405 Review of HHS Decision (DIWW))",
      "42:0416" : "42:0416 (42:416 Denial of Social Security Benefits)",
      "42:0427" : "42:0427 (42:427 Social Security Benefits)",
      "42:12182" : "42:12182 (42:1218(2) Americans with Disabilities Act)",
      "42:1383" : "42:1383 (42:1383 Review of HHS Decision)",
      "42:1395" : "42:1395 (42:1395 HHS: Adverse Reimbursement Review)",
      "42:1396" : "42:1396 (42:1396 - Tort Negligence)",
      "42:13981" : "42:13981 (Violence Against Women Act)",
      "42:1471" : "42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclo)",
      "42:1981cv" : "42:1981cv (42:1981 Civil Rights)",
      "42:1981hs" : "42:1981hs (42:1981 Housing Discrimination)",
      "42:1981jb" : "42:1981jb (42:1981 Job Discrimination (Race))",
      "42:1981sx" : "42:1981sx (42:1981 Sex Discrimination)",
      "42:1983cv" : "42:1983cv (42:1983 Civil Rights Act)",
      "42:1983ed" : "42:1983ed (42:1983 Civil Rights (Employment Discrimination))",
      "42:1983pr" : "42:1983pr (42:1983 Prisoner Civil Rights)",
      "42:1986" : "42:1986 (42:1986 Neglect of Duty)",
      "42:2000ag" : "42:2000ag (42:2000 Job Discrimination (Age))",
      "42:2000e" : "42:2000e (42:2000e Job Discrimination (Employment))",
      "42:2000pb" : "42:2000pb (42:2000 Job Discrimination (Public Accomodations))",
      "42:2000ra" : "42:2000ra (42:2000 Job Discrimination (Race))",
      "42:2000sx" : "42:2000sx (42:2000 Job Discrimination (Sex))",
      "42:2003" : "42:2003 (42:2003 Job Discrimination)",
      "42:2005" : "42:2005 (42:2005 Review of Agency Action-HHS)",
      "42:2615" : "42:2615 (42:2616 Medical Recovery Act)",
      "42:2651" : "42:2651 (42:2651 Medical Care Recovery)",
      "42:3601" : "42:3601 (42:405 Fair Housing Act)",
      "42:4000" : "42:4000 (42:4000 National Flood Insurance Act)",
      "42:4001" : "42:4001 (42:4001 National Insurance Flood Act)",
      "42:4053" : "42:4053 (42:4053 Breach of Insurance Contract)",
      "42:4072" : "42:4072 (42:4072 Payment of Flood Insurance Claim)",
      "42:4321" : "42:4321 (42:4321 Review of Agency Action-Environment)",
      "42:4332" : "42:4332 (42:4332 Environmental Policy - Coop of Agency Repo)",
      "42:6901en" : "42:6901en (42:6901 Environmental Cleanup Expenses)",
      "42:6901rs" : "42:6901rs (42:6901 Resource & Recovery Act)",
      "42:7413" : "42:7413 (42:7413(b) Clean Air Act)",
      "42:7604cl" : "42:7604cl (42:7604 Clear Air Act (Emission Standards))",
      "42:7604ir" : "42:7604ir (42:7604 Petition to Quash IRS Summons)",
      "42:9607" : "42:9607 (42:9607 Real Property Tort to Land)",
      "43:945" : "43:945 (43:945 Compensation for Land Condemnation)",
      "43:945a" : "43:945a (43:945a Complaint in Condemnation)",
      "43:946" : "43:946 (43:946 Complaint in Condemnation - Eminent Domain)",
      "45:0051" : "45:0051 (45:51 Railways: Fed. Employer's Liability Act)",
      "45:0151" : "45:0151 (45:151 Railway Labor Act)",
      "45:0184" : "45:0184 (45:184 Action to Set Aside Award of a System Board)",
      "45:1395" : "45:1395 (45:1395 Railroads: Adverse Reimbursement Review)",
      "45:7457" : "45:7457 (45:7457 Compel Reclamation Under Clear Air Act)",
      "46:0688" : "46:0688 (46:688 Jones Act)",
      "46:0741" : "46:0741 (46:741 Shipping)",
      "46:0761" : "46:0761 (46:761 Shipping: Damages for Death on High Seas)",
      "46:1101" : "46:1101 (46:1101 Violation of Maritime Regulations)",
      "46:1156" : "46:1156 (46:1156 Administrative Procedure Act)",
      "46:31324" : "46:31324 (46:3132(4) In Rem Action to Foreclose Ship's Mortgage)",
      "47:0151" : "47:0151 (47:151 Federal Communications Act of 1934)",
      "47:0553" : "47:0553 (47:553 Cable Communications Policy Act)",
      "47:332c" : "47:332c (47:332(c) Federal Telecommunications Act of 1996)",
      "48:0883" : "48:0883 (48:883 Violation of US Coastal Law)",
      "48:1985" : "48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)",
      "49:0081" : "49:0081 (49:81 Damaged Goods While Being Transported)",
      "49:0781" : "49:0781 (49:781 Forfeiture)",
      "49:10761" : "49:10761 (49:1076(1) Failure to pay tariff)",
      "49:11503" : "49:11503 (49:11503 Railroad Revitalization Regulatory Reform)",
      "49:11702" : "49:11702 (49:11702(a)(4) Violations of Interstate Commerce A)",
      "49:1471" : "49:1471 (49:1471 Federal Aviation Act)",
      "49:1903" : "49:1903 (49:1903 Petition to enforce administrative summon)",
      "8:287" : "8:287 (8:287 Petition to Enforce INS Subpoena)",
      "950" : "950 (Constitutionality of State Statutes)",
      "99:9999" : "99:9999 (99:9999 Report cause code (DO NOT DELETE!))",
      "MDL" : "MDL (Multi District Litigation - 28 USC 1407)",
      "adsup" : "adsup (Administrative Subpoena)",
      "appl6001" : "appl6001 (Application pursuant to 18:6001 et seq.)",
      "applIII" : "applIII (Application - Title III wiretaps)",
      "appldisclo" : "appldisclo (Application for disclosure order)",
      "asgnjgm" : "asgnjgm (Assignment of Judgment to US)",
      "attydisc" : "attydisc (Referral from BK Court - Attorney Discipline)",
      "bkadv" : "bkadv (Adversarial proceedings - Bankruptcy)",
      "bkcert" : "bkcert (Certification of issue from Bankruptcy Court)",
      "cmprcv" : "cmprcv (Complaint and Order establishing Receivership)",
      "contempt" : "contempt (Contempt Proceedings)",
      "contproc" : "contproc (Contested miscellaneous proceeding)",
      "disbar" : "disbar (Disbarment Proceedings)",
      "extindi" : "extindi (Motion to extend time to indict)",
      "fordepo" : "fordepo (Foreign Deposition)",
      "gjproc" : "gjproc (Grand Jury Proceedings)",
      "inc" : "inc (Incomplete filing by pro se litigant)",
      "lvapp" : "lvapp (For leave to appeal interlocutory order of BK Court)",
      "mdl" : "mdl (Multi District Litigation - master case)",
      "misc" : "misc (Civil Miscellaneous Case)",
      "motcnsl" : "motcnsl (Motion for appointment of counsel for grand jury)",
      "motcomp" : "motcomp (Motion to Compel)",
      "motquash" : "motquash (Motion to Quash)",
      "motret" : "motret (Motion for Return of Property)",
      "penreg" : "penreg (Application for a pen register)",
      "petenf" : "petenf (Petition to enforce IRS summons)",
      "petper" : "petper (Petition to Perpetuate Testimony)",
      "regjgm" : "regjgm (Registration of Foreign Judgment)",
      "tranbkref" : "tranbkref (Transmission of Bankruptcy Reference)",
      "tranff" : "tranff (Transmission of Proposed Findings of Fact and Concl. of Law)",
      "trap" : "trap (Trap & trace application - 18 USC 3122, 3123)",
      "writent" : "writent (Application for writ of entry)",
      "writgar" : "writgar (Application for a Writ of Garnishment)",
      "writhc" : "writhc (Petition for writ of habeas corpus)",
      "xx" : "xx (JS 44 Sec. IV - no matching citation currently in database)"
   },
   "mddce" : {
      "0" : "0 (00:0000)",
      "02:0138" : "02:0138 (02:0138 Library of Congress Access)",
      "02:0358" : "02:0358 (02:0358 President's Recommendations on Exec., Jud. & Leg. Salary)",
      "02:0431" : "02:0431 (02:0431 Federal Election Commission: Failure to Enforce Compliance)",
      "02:0437" : "02:0437 (02:0437 Federal Election Commission)",
      "02:0681" : "02:0681 (02:0681 Deferral of Budget Authority)",
      "02:1202" : "02:1202 (02:1202 Discriminatory practices affecting US Senate employees)",
      "02:1301" : "02:1301 (02:1301 Congressional Accountability Act)",
      "02:1317(a)" : "02:1317(a) (02:1317(a) Violation of Congressional Accountability Act)",
      "05:0075" : "05:0075 (DO NOT USE 05:75(2) Contract - Reduction in Grade)",
      "05:0101" : "05:0101 (05:0101 Ethics in Government Act)",
      "05:0504(c)" : "05:0504(c) (05:0504(c)(2) Equal Access to Justice (Govt Employees))",
      "05:0551" : "05:0551 (05:551 Administrative Procedures Act)",
      "05:0552b" : "05:0552b (05:0552b(g)sa Implement requirements of Govt in Sunshine Act)",
      "05:0552fi" : "05:0552fi (05:552 Freedom of Information Act)",
      "05:0552pa" : "05:0552pa (05:552 Right to Privacy Act)",
      "05:0554" : "05:0554 (05:0554 Adjudications Required by Statutes)",
      "05:0555(b)" : "05:0555(b) (05:0555(b) Agency Decision - Right to Counsel)",
      "05:0701" : "05:0701 (05:0701 Judicial Review of Agency Decision)",
      "05:0702" : "05:0702 (05:702 Administrative Procedure Act - Right of Review)",
      "05:0704" : "05:0704 (05:704 Labor Litigation)",
      "05:0706" : "05:0706 (05:706 Judicial Review of Agency Action)",
      "05:1158" : "05:1158 (5:1158 Immigration & Nationality Act, Section 208 (Asylum))",
      "05:1508" : "05:1508 (5:1508 Judicial Review of Order Issued by the Merit Systems Protection Board)",
      "05:2302" : "05:2302 (5:2302 Federal Whistleblowing Act / Civil Service Reform Act (CSRA))",
      "05:3318" : "05:3318 (5:3318 Veterans Preference Act)",
      "05:5514" : "05:5514 (5:5514 Debt Collection Act of 1982)",
      "05:5542" : "05:5542 (5:5542 Federal Employees Pay Act -- overtime rates)",
      "05:7101" : "05:7101 (5:7101 Labor-Management Relations (Findings and Purpose))",
      "05:7123" : "05:7123 (5:7123 Petition by FLRA against unfair labor practices)",
      "05:7501" : "05:7501 (5:7501 Government Employees Adverse Action--14 days or less)",
      "05:7511" : "05:7511 (5:7511 Government Employees Adverse Action--Over 14 days)",
      "05:7703" : "05:7703 (5:7703 Discrimination - Review of Agency Act)",
      "05:8101" : "05:8101 (5:8101 Workmen's Compensation Benefits)",
      "05:8110" : "05:8110 (5:8110 Augmented Compensation for dependents of Govt. Employees)",
      "05:8316" : "05:8316 (5:8316 Claims agst US re Retirement for Federal Emp.)",
      "05:8470" : "05:8470 (05:8470 Enforcement of Judgment against Retirement Benefits )",
      "05:8701" : "05:8701 (5:8701 Federal Employees Group Life Insurance Act of 1954)",
      "05:8705" : "05:8705 (5:8705 Declaratory Judgment - Insurance)",
      "05:8715" : "05:8715 (5:8715 Claims against the US - Jurisdiction of Courts)",
      "05:8901" : "05:8901 (5:8901 Federal Employees Health Benefits Act)",
      "05:8902" : "05:8902 (5:8902 Contracting Authority of OPM - Group Health Insurance)",
      "05:8903" : "05:8903 (5:8903 Federal Employees Health Benefit Act)",
      "05:8912" : "05:8912 (5:8912 Claims agst US re health benefits for Federal emp.)",
      "07:0001" : "07:0001 (7:1 Commodity Exchange Act)",
      "07:0006" : "07:0006 (DO NOT USE7:6(b) Federal Commodity Exchange Regulation)",
      "07:0006(b)" : "07:0006(b) (7:6(b) Federal Commodity Exchange Regulation)",
      "07:0009a" : "07:0009a (7:9a Recovery of penalties by Commodity Futures Trading Com)",
      "07:0013a" : "07:0013a (7:13a Contract market rules violations; recovery of penalty)",
      "07:0013a-1" : "07:0013a-1 (7:13a-1 Enjoin or restrain violations Contract Market rules)",
      "07:0025" : "07:0025 (7:25 Fraud - Commodities Leverage Contracts)",
      "07:0087" : "07:0087 (7:87 Enforcement of United States Grain Standards Act)",
      "07:0136" : "07:0136 (7:136 Violations of EPA re Environmental Pesticide Control)",
      "07:0181" : "07:0181 (07:181 Packers & Stockyard Act)",
      "07:0193(b)" : "07:0193(b) (7:193(b) Recovery of penalties re violations by packers)",
      "07:0203" : "07:0203 (7:203 Recovery of penalties for violations by stockyards)",
      "07:0209(b)" : "07:0209(b) (7:209(b) Violations re purchase, sale, handling of livestock)",
      "07:0210(f)" : "07:0210(f) (7:210(f) Suit to enforce award of damages (Packers/Stockyards))",
      "07:0213(b)" : "07:0213(b) (7:213(b) Unfair, discriminatory, deceptive practice/marketing)",
      "07:0216" : "07:0216 (7:216 Injunctions to restrain & enforce orders of Secretary)",
      "07:0222" : "07:0222 (7:222 Adoption of FTC powers for enforcement.)",
      "07:0245" : "07:0245 (7:245 Action on bond by person injured in Warehouse)",
      "07:0292" : "07:0292 (7:292 Monopolizing or restraining trade & enhancing prices)",
      "07:0499" : "07:0499 (07:499 Agricultural Commodities Act)",
      "07:0601" : "07:0601 (07:601 USDA Condemnation)",
      "07:0608" : "07:0608 (7:608 Agriculture Adjustment Act)",
      "07:0901" : "07:0901 (7:901 Rural Electrification Act)",
      "07:1291(b)" : "07:1291(b) (7:1291(b) Agricultural Adjustment Act; freight rates.)",
      "07:1376" : "07:1376 (7:1376 Adjustment of Quotas and Enforcement; penalties.)",
      "07:1501" : "07:1501 (7:1501 Federal Crop Insurance Act)",
      "07:1508" : "07:1508 (7:1508 Crop Insurance)",
      "07:1631" : "07:1631 (7:1631 Food Security Act)",
      "07:1721" : "07:1721 (7:1721 Agricultural Trade Development Asst Act)",
      "07:1922" : "07:1922 (7:1922 Persons Eligible for Loans - Forclosure)",
      "07:1926" : "07:1926 (7:1926 Water and Waste Facility Loans and Grants)",
      "07:1930" : "07:1930 (7:1930 Perishable Agric. Comm. Act of 1930)",
      "07:2011" : "07:2011 (7:2011 Supplemental Nutrition Assistance Program)",
      "07:2022" : "07:2022 (7:2022 Disposition of Claims: Denial application to participate; food stamp prog.)",
      "07:2023(a)" : "07:2023(a) (7:2023(a) Judicial Review of Food Stamp Disqualification)",
      "07:2024" : "07:2024 (7:2024 False Claims Act, Food Stamp Fraud)",
      "07:2131" : "07:2131 (7:2131 Violation of the Animal Welfare Act)",
      "07:2146" : "07:2146 (7:2146 Transportation, Sale, and Handling of Animals)",
      "07:228a" : "07:228a (7:228a Request by Secretary for TRO or Inj. re Poultry)",
      "07:2301" : "07:2301 (7:2301 Agricultural Fair Practices Act)",
      "07:2305" : "07:2305 (7:2305 Unfair trade practices affecting producers Agri prod)",
      "07:2321" : "07:2321 (07:2321 Plant Variety Protection Act)",
      "07:2563" : "07:2563 (7:2563 Plant Variety Protection and Rights - Injunction)",
      "07:6999" : "07:6999 (7:6999 Judicial Review of Adverse Farm Agency Decision)",
      "08:1101" : "08:1101 (8:1101 Immigration & Nationality Act (Definitions))",
      "08:1105" : "08:1105 (DO NOT USE 8:1105(a) Aliens: Habeas Corpus to Release INS Det)",
      "08:1105a" : "08:1105a (8:1105a Immigration: Judicial Review for Battered Spouses; Deportation (INS))",
      "08:1151" : "08:1151 (8:1151 Immigration and Nationality Act of 1952)",
      "08:1152" : "08:1152 (8:1152 Immigration: Numerical limitations on individual foreign states)",
      "08:1153" : "08:1153 (8:1153 Immigration: Allocation of Immigrant Visas)",
      "08:1154" : "08:1154 (8:1154 Immigration: Procedure for Granting Immigration Status)",
      "08:1158" : "08:1158 (8:1158 Immigration & Nationality Act, Section 208 (Asylum))",
      "08:1182" : "08:1182 (8:1182 Inadmissible Aliens: Defend. Denial of Pla. Appl. for Alien Employment Cer)",
      "08:1183" : "08:1183 (8:1183 Admission of Aliens on Giving Bond or Undertaking; Return on Departure)",
      "08:1188" : "08:1188 (8:1188 Immigration: Admission of Temporary H-2A Workers)",
      "08:1225" : "08:1225 (8:1225 Immigration: Enforcement of Administrative Subpoena)",
      "08:1252" : "08:1252 (08:1252 Judicial Review of Orders of Removal)",
      "08:1255" : "08:1255 (8:1255 Immigration: Failure USCIS To Adjudicate Permanent Residency Petition)",
      "08:1260" : "08:1260 (08:1260 Aliens: Removal of Aliens Falling into Distress)",
      "08:1324" : "08:1324 (08:1324 Immigration: Complaint for Forfeiture)",
      "08:1329" : "08:1329 (08:1329 Immigration: Writ of Mandamus to Adjudicate Visa Petition)",
      "08:1357" : "08:1357 (8:1357 Immigration and Nationality Act - Administrative Search Warrant)",
      "08:1421" : "08:1421 (8:1421 Immigration: Naturalization Authority)",
      "08:1445" : "08:1445 (8:1445 Immigration: Application for Naturalization)",
      "08:1446" : "08:1446 (8:1446 Immigration: Petition for Naturalization Hearing)",
      "08:1447" : "08:1447 (8:1447 Immigration: Review of Denial of Naturalization Application)",
      "08:1451" : "08:1451 (8:1451 Immigration: Revocation of Citizenship)",
      "08:1451(a)" : "08:1451(a) (8:1451(a) Action to revoke Citizenship)",
      "08:1451(j)" : "08:1451(j) (8:1451(j) Immigration: Motion to Correct Order & Judg. of Naturalization)",
      "09:0001" : "09:0001 (09:1 U.S. Arbitration Act)",
      "09:0003" : "09:0003 (9:3 Application to Stay Proceedings Pending Arbitration)",
      "09:0004" : "09:0004 (9:4 Petition to order arbitration; failure to arbitrate)",
      "09:0007" : "09:0007 (9:7 Petition to compel attendance before arbitrator)",
      "09:0008" : "09:0008 (9:8 Declaratory Judgment/Admiralty)",
      "09:0009" : "09:0009 (9:9 Motion to Confirm Arbitration Award)",
      "09:0010" : "09:0010 (09:0010 Petition to Vacate Arbitration Award)",
      "09:0011" : "09:0011 (9:11 Motion to modify or correct arbitration award)",
      "09:0201" : "09:0201 (9:201 Petition to Compel/Stay Arbitration under an Insurance Contract)",
      "09:0202" : "09:0202 (9:202 Award under Convention on Foreign Arbitral Awards)",
      "09:0205" : "09:0205 (9:205 Removal from State Court: Enforcement of Foreign Arbital Awards)",
      "09:0207" : "09:0207 (9:207 Application for order confirming award of arbitrators)",
      "10:0672" : "10:0672 (10:672 Armed Forces: Active Guard/Reserve (AGR) Program)",
      "10:1006" : "10:1006 (10:1006 Armed Forces: Review of Agency Decision)",
      "10:1072tc" : "10:1072tc (10:1072tc Armed Forces: TRICARE PROGRAM)",
      "10:1089(c)" : "10:1089(c) (10:1089(c) Armed Forces: Removal; dft acting in scope of duties)",
      "10:1091" : "10:1091 (10:1091 Armed Forces: Personal Service Contracts)",
      "10:1107" : "10:1107 (10:1107 Armed Forces: Use Of Investigational New Drug)",
      "10:1408" : "10:1408 (10:1408 Armed Forces: Claim for Military Retirement)",
      "10:1552" : "10:1552 (10:1552 Armed Forces: Action to Correct Records)",
      "10:1553" : "10:1553 (10:1553 Armed Forces: Review of Discharge or Dismissal)",
      "10:2005" : "10:2005 (10:2005 Armed Forces: Advanced Education Assistance)",
      "10:2121" : "10:2121 (10:2121 Armed Forces: Health Professions Scholarship Financial Asst Prog)",
      "10:2302" : "10:2302 (10:2302 Armed Forces: Arms Services Procurement Act)",
      "10:2305" : "10:2305 (10:2305 Armed Forces: Review of Federal Contract)",
      "10:2323fa" : "10:2323fa (10:2323fa Armed Forces: Fifth Amendment Equal Protection: Contract Goal for Small Disadvantaged Bus)",
      "10:2733" : "10:2733 (10:2733 Armed Forces: Military Claims Act)",
      "10:2734" : "10:2734 (10:2734 Armed Forces: Foreign Military Claims Act)",
      "10:2771" : "10:2771 (10:2771 Armed Forces: Final Settlement - Deceased Members)",
      "10:3258" : "10:3258 (10:3258 Armed Forces: Reg.Army: Re-enlistment after Service as Ofcr)",
      "11:0101" : "11:0101 (11:101 Bankruptcy (Definitions))",
      "11:0110" : "11:0110 (11:110 Bankruptcy: Penalty for Preparers of Fraudulent or Negligent Petitions)",
      "11:0362(h)" : "11:0362(h) (11:362(h) Bankruptcy: Violation of Automatic Stay)",
      "11:0523" : "11:0523 (11:523 Bankruptcy: Exceptions to Discharge)",
      "11:0524" : "11:0524 (11:524 Bankruptcy: Effect of Discharge)",
      "11:0525" : "11:0525 (11:525 Bankruptcy: Protections Against Discriminatory Treatment)",
      "11:0548" : "11:0548 (11:548 Bankruptcy: Fraudulent Transfers and Obligations)",
      "11:0704" : "11:0704 (11:704 Bankruptcy: Duties of Trustee)",
      "12:0022" : "12:0022 (DO NOT USE 12:22 Securities Fraud)",
      "12:0085" : "12:0085 (12:85 National Banks: Rate of Interest on Loans, Discounts, and Purchases)",
      "12:0093(a)" : "12:0093(a) (12:93(a) National Banks: Violation of Provisions; Forfeiture of Franchise; Personal Liability of Di)",
      "12:0191" : "12:0191 (12:191 National Banks: Appointment of Receiver)",
      "12:0192" : "12:0192 (12:192 National Banks: Liquidation of National Bank)",
      "12:0215" : "12:0215 (12:215 National Banks: Consolidation and Merger)",
      "12:0622" : "12:0622 (12:622 Foreign Banking: Forfeiture, Dissolution, and Liability of Directors and Officers for Noncom)",
      "12:0632" : "12:0632 (12:632 Foreign Banking: Voluntary Liquidation)",
      "12:0635" : "12:0635 (12:635 Breach of Insurance Contract)",
      "12:0635i-3" : "12:0635i-3 (12:635i-3 Export-Import Bank: Breach of Insurance Contract)",
      "12:1421" : "12:1421 (12:1421 Federal Home Loan Bank Act (Short Title))",
      "12:1441" : "12:1441 (12:1441 FHLB: Financial Inst Reform Receiving Enforcement Act 1989)",
      "12:1451" : "12:1451 (12:1451 Emergency Home Loan Corporation (Definitions))",
      "12:1452" : "12:1452 (12:1452 Federal Home Loan Mortgage Corporation Act)",
      "12:1452(f)" : "12:1452(f) (12:1452(f) Fed Home Loan Mortgage Corp: Actions by and against the Corporation)",
      "12:1455(b)" : "12:1455(b) (12:1455(b) Fed Home Loan Mortgage Corp: Enforcement of Regulations)",
      "12:1461" : "12:1461 (12:1461 Savings Associations: Homeowners Loan Act (Short Title))",
      "12:1464" : "12:1464 (12:1464 Savings Associations: Federal Savings and Loan)",
      "12:1703" : "12:1703 (12:1703 National Housing: Insurance of Financial Institutions)",
      "12:1715(b)" : "12:1715(b) (12:1715(b) National Housing: Rules and Regulations)",
      "12:1725" : "12:1725 (DO NOT USE 12:1725 Collection under Contract Guaranty)",
      "12:1730" : "12:1730 (DO NOT USE 12:1730 Collection Under Contract Guaranty)",
      "12:1749aaa" : "12:1749aaa (12:1749aaa National Housing: National Insurance Development Program)",
      "12:1751" : "12:1751 (12:1751 Fed Credit Unions: Short Title)",
      "12:1782" : "12:1782 (12:1782 Fed Credit Unions: Administration of Insurance Fund)",
      "12:1786" : "12:1786 (12:1786 Fed Credit Unions: Actions re Violations by Credit Unions)",
      "12:1811" : "12:1811 (12:1811 FDIC: Financial Inst. Reform Recovery Act of 1989 (FIRREA) (Organization of FDIC))",
      "12:1818" : "12:1818 (12:1818 FDIC: Violations re Federal Deposit Insurance Corporation)",
      "12:1818(e)" : "12:1818(e) (12:1818(e) FDIC: Suspension or Removal of Bank Officer)",
      "12:1819" : "12:1819 (12:1819 FDIC: Corporate Powers)",
      "12:1821" : "12:1821 (12:1821 FDIC: Insurance Funds)",
      "12:1831" : "12:1831 (12:1831 FDIC: Separability of Certain Provisions)",
      "12:1831(d)" : "12:1831(d) (12:1831(d) FDIC: Deposit. Inst. Dereg. & Monetary Ctrl. Act of 1980)",
      "12:1831r-1" : "12:1831r-1 (12:1831r-1 FDIC: Notice of Branch Closure)",
      "12:1833(a)" : "12:1833(a) (12:1833(a) FDIC: Forfieture Civil Penalties)",
      "12:1954" : "12:1954 (12:1954 Injunctions (Action by Sec of Treasury re financial recordkeeping))",
      "12:1971" : "12:1971 (12:1971 Relief under Bank Holding Company Act (Definitions))",
      "12:1972" : "12:1972 (12:1972 Typing Arrangement Act )",
      "12:2001" : "12:2001 (12:2001 Farm Credit Act of 1971)",
      "12:2601" : "12:2601 (12:2601 Real Estate Settlement Procedures Act (RESPA) (findings & purpose))",
      "12:2604(c)" : "12:2604(c) (12:2604(c) Real Estate Settlement Procedures Act (\"RESPA\"))",
      "12:2605" : "12:2605 (12:2605 RESPA: Servicing of Mortgage Loans)",
      "12:2607" : "12:2607 (12:2607 RESPA: Violation re kickbacks/unearned fees; Real Estate)",
      "12:2609" : "12:2609 (12:2609 RESPA: Escrow)",
      "12:3012" : "12:3012 (12:3012 National Consumer Cooperative Bank: Suits by or against Bank)",
      "12:3410" : "12:3410 (12:3410 Right to Financial Privacy: Customer Challenges)",
      "12:3751" : "12:3751 (12:3751 Single Family Mortgage Forclosure Act: Findings and Purpose)",
      "12:3801" : "12:3801 (12:3801 Alternative Mortgage Transaction Parity Act)",
      "12:3907" : "12:3907 (12:3907 International Lending Supervision: Capital Adequacy)",
      "12:4010" : "12:4010 (12:4010 Expedited Funds Availability: Violation of Act (Civil Liability))",
      "12:5101" : "12:5101 (12:5101 Fraudulent Transfer Act (Enforcement for Mortgage Licensing))",
      "15:0001" : "15:0001 (15:1 Antitrust Litigation (Monopolizing Trade))",
      "15:0002at" : "15:0002at (15:2 Antitrust Litigation)",
      "15:0002fl" : "15:0002fl (15:2fl Antitrust Litigation)",
      "15:0004" : "15:0004 (15:4 USDC Jurisdiction re violations of Sec. 1-7 of Title 15)",
      "15:0005" : "15:0005 (15:5 Bringing in Additional Parties)",
      "15:0009" : "15:0009 (15:9 USDC Jurisdiction re violations of Sec. 8 of Title 15)",
      "15:0013" : "15:0013 (15:13 Robinson Patman Act)",
      "15:0014" : "15:0014 (15:14 Clayton Act)",
      "15:0015" : "15:0015 (15:15 Antitrust Litigation)",
      "15:0025" : "15:0025 (15:25 Clayton Act)",
      "15:0026" : "15:0026 (15:26 Suit for injunctive relief re violation antitrust laws)",
      "15:0041" : "15:0041 (15:41 Federal Trade Commission Act)",
      "15:0044" : "15:0044 (DO NOT USE 15:44 Trademark Infringement)",
      "15:0045" : "15:0045 (15:45 Federal Trade Commission Act (unfair or deceptive acts))",
      "15:0045cp" : "15:0045cp (15:45cp Violation of Children Online Privacy Protection Act)",
      "15:0052" : "15:0052 (15:0052 Federal Trade Commission Act)",
      "15:0053" : "15:0053 (15:0053 Federal Trade Commission Act)",
      "15:0053(b)" : "15:0053(b) (15:53(b) Prelim & Perm Inj Relief & other Equitable Relief)",
      "15:0068" : "15:0068 (15:68 Proceedings re FTC violations re wool products)",
      "15:0069" : "15:0069 (15:69 Proceedings re FTC violations re fur products)",
      "15:0070" : "15:0070 (15:70 Proceedings re FTC violations re textile fiber product)",
      "15:0077" : "15:0077 (15:77 Securities Fraud)",
      "15:0078" : "15:0078 (15:78m(a) Securities Exchange Act)",
      "15:0079" : "15:0079 (15:79 Public Utility Holding Companies)",
      "15:0080a-3" : "15:0080a-3 (15:80a-3 Investment Company Act of 1940)",
      "15:0260" : "15:0260 (15:260 Proceedings re weights and measures and standard time)",
      "15:0298" : "15:0298 (15:298 Violation of Law Proceedings re gold or silver)",
      "15:0433" : "15:0433 (15:433 Discrimination against farmers)",
      "15:0631" : "15:0631 (15:631 Small Business Act)",
      "15:0636" : "15:0636 (15:636 Small Business Act - Aid to small business)",
      "15:0661" : "15:0661 (15:661 Small Business Investment Act of 1958)",
      "15:0687" : "15:0687 (15:687 Small Business Investment Program)",
      "15:0714(b)" : "15:0714(b) (15:714(b) Commodity Credit Corporation)",
      "15:0715(f)" : "15:0715(f) (15:715(f) Proceedings re petroleum and petroleum products)",
      "15:0717" : "15:0717 (15:717 Natural Gas Act)",
      "15:0754" : "15:0754 (DO NOT USE 15:754 Emergency Petroleum Allocation-Admin.& Enforcement)",
      "15:0766" : "15:0766 (15:766 Controversies arising re Federal Energy Admin. rules)",
      "15:1051" : "15:1051 (15:1051 Trademark Infringement)",
      "15:1071" : "15:1071 (15:1071 Appeal of Decision of U.S. Patent & Trademark Office (Comm / Trademark Trial Bd))",
      "15:1114" : "15:1114 (15:1114 Trademark Infringement (Lanham Act))",
      "15:1116" : "15:1116 (15:1116 Inj to prevent violation rights of trademark owner)",
      "15:1120" : "15:1120 (15:1120 Trademark - False or Fraudulent Registration)",
      "15:1121" : "15:1121 (15:1121 Trademark Infringement (jurisdiction))",
      "15:1125" : "15:1125 (15:1125 Trademark Infringement (Lanham Act))",
      "15:1125(a)" : "15:1125(a) (15:1125(a) False representation of goods sold in interstate commerce)",
      "15:1125la" : "15:1125la (15:1125la Trademark Infringement (Lanham Act))",
      "15:1126" : "15:1126 (15:1126 Trademarks - International conventions)",
      "15:1127" : "15:1127 (15:1127 Trademark Infringement)",
      "15:1191" : "15:1191 (15:1191 Flamable Fabrics Act)",
      "15:1221" : "15:1221 (15:1221 Auto Dealer Suits Agst Manufacturers)",
      "15:1261" : "15:1261 (15:1261 Hazardous Substances (definitions))",
      "15:1263" : "15:1263 (15:1263 Prohibited Hazardous Substance - Interstate Commerce)",
      "15:1267(a)" : "15:1267(a) (15:1267(a) Federal Hazardous Substances Act)",
      "15:1314" : "15:1314 (15:1314 Antitrust--Petition for enforcement)",
      "15:1501" : "15:1501 (15:1501 Estab of Dept of Commerce)",
      "15:1601" : "15:1601 (15:1601 Truth in Lending)",
      "15:1605" : "15:1605 (15:1605 Determination of Finance Charge)",
      "15:1638" : "15:1638 (15:1638 Truth in Lending)",
      "15:1640" : "15:1640 (15:1640 Truth in Lending)",
      "15:1666" : "15:1666 (15:1666 Fair Credit Billing Act Dispute)",
      "15:1667" : "15:1667 (15:1667 Consumer Leasing Act)",
      "15:1679" : "15:1679 (15:1679 Violation of Credit Repair Organizations Act)",
      "15:1681" : "15:1681 (15:1681 Fair Credit Reporting Act)",
      "15:1691" : "15:1691 (15:1691 Equal Credit Opportunity Act)",
      "15:1692" : "15:1692 (15:1692 Fair Debt Collection Act)",
      "15:1693ef" : "15:1693ef (15:1693ef Electronic Funds Transfer Act)",
      "15:1693m" : "15:1693m (15:1693m Violation of Prov. of Subchpt.VI (Electronic Fund Transfers))",
      "15:1701" : "15:1701 (15:1701 Interstate Land Sales Full Disclosure Act (ILFFDA))",
      "15:1709" : "15:1709 (15:1709 Interstate Land Sales)",
      "15:1714" : "15:1714 (15:1714 Actions to enjoin violations re interstate land sale)",
      "15:1938" : "15:1938 (DO NOT USE 15:1938 Fair Labor Standards Act)",
      "15:1981" : "15:1981 (DO NOT USE 15:1981 Fraud-Motor Vehicle (Odometer))",
      "15:1988" : "15:1988 (DO NOT USE 15:1988 Fraud-Motor Vehicle (Odometer))",
      "15:1989" : "15:1989 (DO NOT USE 15:1989 Fraud-Motor Vehicle (Odometer))",
      "15:2071" : "15:2071 (15:2071 Consumer Product Safety; Condemnation hazardous prod)",
      "15:2073" : "15:2073 (15:2073 Private action to enforce Consumer Product Safety)",
      "15:2301" : "15:2301 (15:2301 Magnuson-Moss Warranty Act)",
      "15:2310(c)" : "15:2310(c) (15:2310(c) Consumer Product Warranties)",
      "15:2601" : "15:2601 (15:2601 Toxic Substances Control Act (TCSA))",
      "15:2604" : "15:2604 (15:2604 Application for inj re distribution toxic substance)",
      "15:2616" : "15:2616 (15:2616 Toxic Substance control; seizure of chemical)",
      "15:2620" : "15:2620 (15:2620 Toxic Substances Control Act: citizen's petition)",
      "15:2651" : "15:2651 (15:2651 Asbestos Hazard Emergency Response Act)",
      "15:2801" : "15:2801 (15:2801 Petroleum Marketing Practices Act)",
      "15:2805" : "15:2805 (15:2805 Petroleum Marketing Practices-Franchise Protection)",
      "15:3414" : "15:3414 (15:3414 National Gas Policy Act)",
      "15:3710a" : "15:3710a (15:3710a Federal Technology Transfer Act of 1986)",
      "15:3901" : "15:3901 (15:3901 Federal Risk Retention Act)",
      "15:6801" : "15:6801 (15:6801 Gram-Leach-Bliley Act)",
      "15:7701" : "15:7701 (15:7701 Federal CAN-Spam Act)",
      "16:0470" : "16:0470 (16:470 Archaeological resources Protection Act)",
      "16:0668" : "16:0668 (16:668 Bald and Golden Eagle Protection Act)",
      "16:0669" : "16:0669 (16:669 Pittman-Robertson Conservation Restoration Act)",
      "16:0675" : "16:0675 (16:675 Norbeck Wildlife Preserve Organic Act)",
      "16:0703" : "16:0703 (16:703 Migratory Bird Act)",
      "16:0825" : "16:0825 (16:825 Federal Power Commission Regulation; Public Utilities)",
      "16:0831" : "16:0831 (16:831 Actions re: rights of Tennessee Valley Authority)",
      "16:1244" : "16:1244 (16:1244 National Scenic and National Historic Trails)",
      "16:1374" : "16:1374 (12:1374(d)(6) Petition for Review re Application for Import of Polar Bear Trophies)",
      "16:1531" : "16:1531 (16:1531 Endangered Species Act)",
      "16:1533" : "16:1533 (16:1533 Endangered Species Act)",
      "16:1538" : "16:1538 (16:1538 Endangered Species Act)",
      "16:1540" : "16:1540 (16:1540 Endangered Species Act - Penalties and Enforcement)",
      "16:1600" : "16:1600 (16:1600 National Forest Management Act of 1976)",
      "16:1801" : "16:1801 (16:1801 Magnuson-Stevens Fishery Conservation and Management Act)",
      "16:1858" : "16:1858 (16:1858 National Fishery Management Program - Civil Penalties and Permit Sanctions)",
      "16:19jj" : "16:19jj (16:19jj Park System Resource Protection Act)",
      "16:3371" : "16:3371 (16:3371 Wildlife Under the Lacey Act (Definitions))",
      "16:3372" : "16:3372 (16:3372 Lacey Act: Prohibited Acts)",
      "16:3373" : "16:3373 (16:3373 Lacey Act: Penalties and Sanctions - Appeal of Decision - DOI)",
      "16:3374" : "16:3374 (16:3374 Lacey Act: Complaint for Forfeiture)",
      "16:470f" : "16:470f (16:470f National Historic Preservation Act)",
      "16:823a" : "16:823a (16:823a Federal Public Utility Regulatory Policies Act)",
      "17:0101" : "17:0101 (17:101 Copyright Infringement (definitions))",
      "17:0201" : "17:0201 (17:201 Ownership of Copyright)",
      "17:0205" : "17:0205 (17:205(d) Priority Between Conflicting Transfers)",
      "17:0407" : "17:0407 (17:407 Recovery of fines & penalties by Register of Copyrights)",
      "17:0411" : "17:0411 (17:411 Action by copyright owner for infringement)",
      "17:0501" : "17:0501 (17:501 Copyright Infringement)",
      "17:0502" : "17:0502 (17:502(a) Inj to prevent or restrain infringement copyright)",
      "17:0504" : "17:0504 (17:504 Copyright Infringement)",
      "17:0512" : "17:0512 (17:512 Copyright Infringement of Digital Communications)",
      "17:1201" : "17:1201 (17:1201 Digital Millennium Copyright Act)",
      "18:0241" : "18:0241 (DO NOT USE 18:241 Conspiracy Against Citizen Rights)",
      "18:0492" : "18:0492 (18:492 Forfeiture of Counterfeit Paraphernalia)",
      "18:0603" : "18:0603 (18:603 Conflict of Interest)",
      "18:0922" : "18:0922 (18:922 Firearms - Unlawful Possession (Civil Fines))",
      "18:0923" : "18:0923 (18:923(f)(3) Review of Revocation of a License as a Dealer in Firearms)",
      "18:0925" : "18:0925 (18:925(c) Restoration of ability to possess firearms/ammo)",
      "18:0981" : "18:0981 (18:981 Civil Forfeiture)",
      "18:0981(a)" : "18:0981(a) (12:981(a)(1)(A) Civil Forfeiture: Money Laundering Control Act)",
      "18:1030" : "18:1030 (18:1030 Fraud & Related Activity in Connection with Computers)",
      "18:1345" : "18:1345 (18:1345 Injunction against Fraud)",
      "18:1514" : "18:1514 (18:1514 Civil Action to Restrain Harassment of a Victim)",
      "18:1514A" : "18:1514A (18:1514A Civil Action to Protect Against Retaliation in Fraud Cases)",
      "18:1836a" : "18:1836a (18:1836(a) - Injunction against Misappropriation of Trade Secrets)",
      "18:1836b" : "18:1836b (18:1836(b) - Civil Action to Protect Trade Secrets)",
      "18:1905" : "18:1905 (18:1905 Disclosure of Confidential Information)",
      "18:1956" : "18:1956 (18:1956(b)(3) Laundering of Monetary Instruments - Forfeit Property)",
      "18:1961" : "18:1961 (DO NOT USE 18:1961 Racketeering (RICO) Act)",
      "18:1962" : "18:1962 (DO NOT USE 18:1962 Racketeering (RICO) Act)",
      "18:1964" : "18:1964 (18:1964 Racketeering (RICO) Act)",
      "18:1968" : "18:1968 (18:1968 Action re civil investigative demand)",
      "18:2254" : "18:2254 (18:2254 Civil Forfeiture - Exploitation of Children)",
      "18:2333" : "18:2333 (18:2333 Civil Remedies: Anti-Terrorism Act of 1991)",
      "18:2511" : "18:2511 (18:2511 Wiretapping - Injunctive Relief or Civil Fine)",
      "18:2520" : "18:2520 (18:2520 Civil Damages for Interception Wire or Oral Communications)",
      "18:2707" : "18:2707 (18:2707 Civil Action: Stored Communications)",
      "18:2710" : "18:2710 (18:2710(c) Wrongful Disclosure of Video Tape Rental or Sales Records)",
      "18:2724" : "18:2724 (18:2724 Civil Action - Motor Vehicle Records)",
      "18:3114" : "18:3114 (18:3114 Motion for Return of Seized Property )",
      "18:3184" : "18:3184 (18;3184 Extradition Procedure)",
      "18:3663" : "18:3663 (18:3663 Civil Enforcement of Crim. Rest. Obligation)",
      "18:4100" : "18:4100 (18:4100 Transfer of Offenders)",
      "18:4208" : "18:4208 (DO NOT USE 18:4208(B) Agency Action Review)",
      "19:1305" : "19:1305 (19:1305 Customs Duties: Forfeiture-Immoral Articles)",
      "19:1497" : "19:1497 (19:1497 Customs Duties: Penalty for Failure to Declare)",
      "19:1595" : "19:1595 (19:1595 Customs Duties: Forfeiture and Other Penalties)",
      "19:1607" : "19:1607 (19:1607 Customs Duties: Notice of Seizure)",
      "19:1955" : "19:1955 (19:1955 Civil Forfeiture-Prohibition of Illegal Gambling)",
      "20-0107" : "20-0107 (20-107 Randolph-Sheppard Vending Stand Act)",
      "20-1087" : "20-1087 (20:1087 Student Loan Discharge)",
      "20:1070" : "20:1070 (20:1070 Student Assistance)",
      "20:1080" : "20:1080 (20:1080 Default of Student Loan: Recovery)",
      "20:1095" : "20:1095 (20:1095a Education - Wage Garnishment Requirement)",
      "20:1097" : "20:1097 (20:1097 Education - Criminal penalties for fraud)",
      "20:1098" : "20:1098 (20:1098g Higher Education Act - Exemption from state disclosure)",
      "20:1232" : "20:1232 (20:1232g Family Education Rights & Privacy Act of 1974)",
      "20:1400" : "20:1400 (20:1400 IDEA: Individuals With Disabilities Education Act (short title))",
      "20:1401" : "20:1401 (20:1401 IDEA: Education of Individuals with Disabilities (definitions))",
      "20:1415" : "20:1415 (20:1415 IDEA: Challenge decision re education for handicapped)",
      "20:1415(e)" : "20:1415(e) (20:1415(e)(2)de IDEA: Mediation)",
      "20:1681" : "20:1681 (20:1681 Title IX Educational Amendments 1992 - Sex Discrimination)",
      "20:1683" : "20:1683 (20:1683 Judicial Review: Prohibition against sex discrimination in education)",
      "20:1706" : "20:1706 (20:1706 Relief from denial of equal educational opportunity)",
      "20:1717" : "20:1717 (20:1717 Relief from denial of equal educational opportunity)",
      "21:0301" : "21:0301 (21:301 Federal Food, Drug & Cosmetic Act)",
      "21:0331" : "21:0331 (21:331 Federal Food, Drug & Cosmetic Act - Prohibited Acts)",
      "21:0332" : "21:0332 (21:332 Federal Food, Drug and Cosmetic Act, Injunctive Relief)",
      "21:0332(a)" : "21:0332(a) (21:332(a) Federal Food, Drug, and Cosmetic Act)",
      "21:0334(a)" : "21:0334(a) (21:334(a) Forfeiture or condemnation-food, drug, cosmetics)",
      "21:0348" : "21:0348 (21:348 Federal Food, Drug and Cosmetic Act - Food Additives)",
      "21:0360" : "21:0360 (21:360 Federal Food, Drug & Cosmetic Act - Drugs and Devices)",
      "21:0467" : "21:0467 (21:467 Seizure and condemnation of poultry products)",
      "21:0601" : "21:0601 (21:601 Federal Meat Inspection Act 21 USC 601-695 (Definitions))",
      "21:0673" : "21:0673 (21:673 Seizure and condemnation of meat or meat products)",
      "21:0674" : "21:0674 (21:674 Proceeding to enforce & enjoin re meat products)",
      "21:0821" : "21:0821 (21:821 Violation of Record Keeping Provision of Controlled Substance Act)",
      "21:0841" : "21:0841 (21:841 Forfeiture Property-Drugs)",
      "21:0842" : "21:0842 (21:842 Civil Penalty for violation re controlled substance)",
      "21:0881" : "21:0881 (21:881 Forfeiture Property-Drugs)",
      "21:0881a" : "21:0881a (21:881 Forfeiture Property - Aircraft)",
      "21:0881re" : "21:0881re (21:881 Forfeiture Property - Real Estate)",
      "21:0882" : "21:0882 (21:882 Inj to enjoin violations re controlled substance)",
      "21:1049" : "21:1049 (21:1049 Seizure and condemnation re eggs or egg products)",
      "22:0286" : "22:0286 (22:286 Action against World Bank or IMF)",
      "22:2702" : "22:2702 (22:2702 Medical Malpractice by Govt. Medical Personnel)",
      "22:3612" : "22:3612 (22:3612 Claim for Damage to Panama Canal)",
      "22:3776" : "22:3776 (22:3776 Panama Canal Commission Action on claims)",
      "22:3777" : "22:3777 (22:3777 Investigation of accident or injury giving rise to a claim)",
      "22:4140" : "22:4140 (22:4140 Foreign Service Grievance Act - Judicial Review)",
      "23:0112" : "23:0112 (23:112 Federal Highway Act - Letting of Contracts)",
      "23:0134" : "23:0134 (23:134 Metropolitan Transportation Planning)",
      "23:1441" : "23:1441 (DO NOT USE 23:1441 Contract Real Estate)",
      "24:1000" : "24:1000 (DO NOT USE 24:1000 Hospitals & Asylums: Withdrawal Liability)",
      "25:0640" : "25:0640 (25:640 Indian Tribal Rights)",
      "25:1901" : "25:1901 (25:1901 Indian Child Welfare Act)",
      "25:2701" : "25:2701 (25:2701 Indian Gaming Regulatory Act (IGRA))",
      "25:4101" : "25:4101 (25:4101 Native American Housing Assistance and Self-Determination Act (NAHASDA))",
      "26:0063" : "26:0063 (26:63 IRS: Taxable income (Definition))",
      "26:0982" : "26:0982 (26:982 IRS: To Quash IRS Formal Document Request)",
      "26:2032" : "26:2032 (26:2032 IRS: Alternate valuation)",
      "26:6212" : "26:6212 (26:6212 IRS: Notice of Deficiency (Injunctive Relief from IRS Lien))",
      "26:6213" : "26:6213 (26:6213 IRS: Injunctive Relief from IRS Lien in Tax Court)",
      "26:6221" : "26:6221 (26:6221 IRS: TEFRA Tax, Equity and Fiscal Responsibility Act of 1982)",
      "26:6226" : "26:6226 (26:6226 IRS: Judicial Review of Partnership Adjustment)",
      "26:6320" : "26:6320 (26:6320 IRS: Notice and Opportunity for Hearing upon Filing Notice of Lien)",
      "26:6330" : "26:6330 (26:6330 IRS: Notice and Opportunity for Hearing before Levy)",
      "26:6331" : "26:6331 (26:6331 IRS: Wrongful Levy)",
      "26:6334" : "26:6334 (26:6334 IRS: Property Exempt from Levy)",
      "26:6502" : "26:6502 (26:6502 IRS: Collection after Assessment (Enforcement of tax liens))",
      "26:6532" : "26:6532 (26:6532 IRS: Periods of Limitation on Suits)",
      "26:6653sp" : "26:6653sp (26:6653sp IRS: Failure to Pay Stamp Tax)",
      "26:6672" : "26:6672 (26:6672 IRS: Failure to Collect and Pay Over Tax, or Attempt to Evade or Defeat Tax)",
      "26:6694" : "26:6694 (26:6694 IRS: Underestimate Of Tax Liability By Tax Preparer)",
      "26:6702" : "26:6702 (26:6702 IRS: Penalty for Frivolous Tax Submission)",
      "26:6703" : "26:6703 (26:6703 IRS: Refund of Tax Penalty)",
      "26:7323" : "26:7323 (26:7323 IRS: Proceedings in rem enforce forfeitures property)",
      "26:7401" : "26:7401 (26:7401 IRS: Tax Liability - Authorization to collect via civil action)",
      "26:7402" : "26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)",
      "26:7403" : "26:7403 (26:7403 IRS: Action to Enforce Federal Tax Lien)",
      "26:7404" : "26:7404 (26:7404 IRS: Action for collection of estate tax)",
      "26:7405" : "26:7405 (26:7405 IRS: Action for recovery of refunds erroneously made)",
      "26:7407" : "26:7407 (26:7407 IRS: Action to enjoin income tax preparers)",
      "26:7422rt" : "26:7422rt (26:7422 IRS: Refund Taxes)",
      "26:7422rx" : "26:7422rx (26:7422 IRS: Refund Excise Tax)",
      "26:7425(a)" : "26:7425(a) (26:7425(a) IRS: Judiciary & Judicial Procedures - Discharge of Liens)",
      "26:7426" : "26:7426 (26:7426 IRS: Wrongful Levy for Taxes)",
      "26:7428" : "26:7428 (26:7428 IRS: Declaratory Judgment)",
      "26:7429" : "26:7429 (26:7429 IRS: Tax Jeopardy Assessment)",
      "26:7430" : "26:7430 (26:7430 IRS: Awarding of Costs and Certain Fees in Tax Suit)",
      "26:7431" : "26:7431 (26:7431 IRS: Unauthorized Disclosure of Return & Return Info)",
      "26:7434" : "26:7434 (26:7434 IRS: Civil Damages for Fraudulent Filing of Information)",
      "26:7604" : "26:7604 (26:7604 IRS: Enforce summons; examination books & witnesses)",
      "26:7604(a)" : "26:7604(a) (26:7604(a) IRS: Complaint to Enforce IRS Summons)",
      "26:7609" : "26:7609 (26:7609 IRS: Petition to Quash IRS Summons)",
      "26:7609en" : "26:7609en (26:7609en IRS: Petition to serve Third-Party Summons)",
      "27:0185" : "27:0185 (27:185 Enforcement of Arbitration Award)",
      "28-1332rl" : "28-1332rl (28:1332 Diversity-Rent Lease & Ejectment)",
      "28:0157c" : "28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)",
      "28:0157d" : "28:0157d (28:0157 Motion for Withdrawal of Reference)",
      "28:0158" : "28:0158 (28:0158 Notice of Appeal re Bankruptcy Matter (BA)",
      "28:0185" : "28:0185 (DO NOT USE 28:185 Suit to Compel Arbitration)",
      "28:0451" : "28:0451 (DO NOT USE 28:451 Employment Discrimination)",
      "28:0463" : "28:0463 (28:0463 Expenses of Judicial Litigation)",
      "28:0534" : "28:0534 (28:0534 Arrest Records)",
      "28:0591" : "28:0591 (28:0591 Independent Counsel)",
      "28:0592" : "28:0592 (28:0592 Independent Counsel - Application for Appointment)",
      "28:0593" : "28:0593 (28:0593 Independent Counsel - Court Responsibilities)",
      "28:0594" : "28:0594 (28:0594 Independent Counsel - Responsibilities)",
      "28:0595" : "28:0595 (28:0595 Independent Counsel - Congressional Oversight)",
      "28:0596" : "28:0596 (28:0596 Independent Counsel - Removal)",
      "28:0597" : "28:0597 (28:0597 Independent Counsel - Dept. of Justice Relationship)",
      "28:0598" : "28:0598 (28:0598 Independent Counsel - Chapter Termination)",
      "28:0636" : "28:0636 (28:0636 Jurisdiction and Power of Magistrate Judges)",
      "28:0754" : "28:0754 (28:0754 Receiver of Property in Different Districts)",
      "28:0794" : "28:0794 (DO NOT USE 28:794 Rehabilitation Act)",
      "28:1001" : "28:1001 (DO NOT USE 28:1001 E.R.I.S.A.)",
      "28:1132" : "28:1132 (DO NOT USE 28:1132 E.R.I.S.A.)",
      "28:1291" : "28:1291 (28:1291 Maritime)",
      "28:1330" : "28:1330 (28:1330 Breach of Contract)",
      "28:1331" : "28:1331 (28:1331 Fed. Question: Bivens-Prisoner)",
      "28:1331al" : "28:1331al (28:1331 Fed. Question: Airline Crash)",
      "28:1331at" : "28:1331at (28:1331 Fed. Question: Anti-trust)",
      "28:1331au" : "28:1331au (28:1331 Fed. Question: Auto Negligence)",
      "28:1331b" : "28:1331b (28:1331 Federal Question: Bivens Act)",
      "28:1331bc" : "28:1331bc (28:1331 Fed. Question: Breach of Contract)",
      "28:1331ca" : "28:1331ca (28:1331 Fed Question: Fed Communications Act of 1)",
      "28:1331cm" : "28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)",
      "28:1331cr" : "28:1331cr (28:1331cr Fed. Question: Civil Rights (Race Discrimination))",
      "28:1331cv" : "28:1331cv (28:1331 Federal Question: Other Civil Rights)",
      "28:1331dd" : "28:1331dd (28:1331dd Fed. Question: Discovery Disputes (conversion case))",
      "28:1331dj" : "28:1331dj (28:1331dj Fed. Question: Declaratory Judgment)",
      "28:1331dp" : "28:1331dp (28:1331dp Fed. Question: Violation of Due Process)",
      "28:1331ed" : "28:1331ed (28:1331 Fed. Question: Employment Discrimination)",
      "28:1331ef" : "28:1331ef (28:1331ef Fed. Question: Civil Rights Violation (Excess Force))",
      "28:1331ej" : "28:1331ej (28:1331 Federal Question: Enforcement of Judgment )",
      "28:1331es" : "28:1331es (28:1331 Enforcement of Administrative Subpoena)",
      "28:1331fa" : "28:1331fa (28:1331fa Fed. Question: Civil Rights Violation-False Arrest)",
      "28:1331fl" : "28:1331fl (28:1331 Fed. Question: Fair Labor Standards)",
      "28:1331fm" : "28:1331fm (28:1331fm Fed. Question: Family and Medical Leave Act)",
      "28:1331fr" : "28:1331fr (28:1331fr Fed. Question: Fraud)",
      "28:1331in" : "28:1331in (28:1331 Fed. Question: Insurance Contract)",
      "28:1331mm" : "28:1331mm (28:1331 Fed. Question: Medical Malpractice)",
      "28:1331ng" : "28:1331ng (28:1331 Fed. Question: Natural Gas Act )",
      "28:1331ni" : "28:1331ni (28:1331ni Fed. Question: Negotiable Instrument)",
      "28:1331pi" : "28:1331pi (28:1331 Fed. Question: Personal Injury)",
      "28:1331pl" : "28:1331pl (28:1331 Product Liability)",
      "28:1331pr" : "28:1331pr (28:1331 Federal Prisoner Civil Rights)",
      "28:1331ra" : "28:1331ra (28:1331 Racketeering (RICO) Act)",
      "28:1331rc" : "28:1331rc (28:1331 Reclamation Project Auth. Act of 1972)",
      "28:1331rd" : "28:1331rd (28:1331 Fed. Question: Review Agency Decision)",
      "28:1331rp" : "28:1331rp (28:1331(a) Fed. Question: Real Property)",
      "28:1331rr" : "28:1331rr (28:1331 Fed. Question: Railway Labor Act)",
      "28:1331rs" : "28:1331rs (28:1331 Federal Rail Safety Act)",
      "28:1331sh" : "28:1331sh (28:1331 Sexual Harrassment)",
      "28:1331ss" : "28:1331ss (28:1331 Constitutionality of State Statutes)",
      "28:1331sv" : "28:1331sv (28:1331 Fed. Question: Securities Violation)",
      "28:1331sx" : "28:1331sx (28:1331 Employment Discrimination (Sex))",
      "28:1331tr" : "28:1331tr (28:1331 Fed. Question: Trademark)",
      "28:1331tt" : "28:1331tt (28:1331 Fed. Question: Tort Action)",
      "28:1331v" : "28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendme)",
      "28:1331va" : "28:1331va (28:1331 Violation 5th & 8th Amendments)",
      "28:1331vc" : "28:1331vc (28:1331 Violation of Constitutional Rights)",
      "28:1331w" : "28:1331w (28:1331 Wrongful Termination of Employment)",
      "28:1331wd" : "28:1331wd (28:1331 Wrongful Death)",
      "28:1331wl" : "28:1331wl (28:1331 Federal Question: EPA Waste Lien)",
      "28:1331wt" : "28:1331wt (28:1331 Fed. Question: Water Rights)",
      "28:1332" : "28:1332 (28:1332 Diversity Action)",
      "28:1332ac" : "28:1332ac (28:1332 Diversity-Account Receivable)",
      "28:1332al" : "28:1332al (28:1332 Diversity-Airline Crash)",
      "28:1332ap" : "28:1332ap (28:1332 Diversity-Airplane Product Liability)",
      "28:1332as" : "28:1332as (28:1332 Diversity-Asbestos Litigation)",
      "28:1332au" : "28:1332au (28:1332 Diversity-Auto Negligence)",
      "28:1332bc" : "28:1332bc (28:1332 Diversity-Breach of Contract)",
      "28:1332bw" : "28:1332bw (28:1332 Diversity-Breach of Warranty)",
      "28:1332co" : "28:1332co (28:1332 Diversity-Conversion)",
      "28:1332ct" : "28:1332ct (28:1332 Diversity-(Citizenship))",
      "28:1332de" : "28:1332de (28:1332 Diversity-Forcible Detainer)",
      "28:1332det" : "28:1332det (28:1332 Diversity: Forcible Detainer)",
      "28:1332df" : "28:1332df (28:1332 Diversity-Contract Default)",
      "28:1332ds" : "28:1332ds (28:1332 Diversity-Contract Dispute)",
      "28:1332dtp" : "28:1332dtp (28:1332 Diversity-Deceptive Trade Practices)",
      "28:1332ed" : "28:1332ed (28:1332 Diversity-Employment Discrimination)",
      "28:1332ej" : "28:1332ej (28:1332 Diversity-Enforcement of Judgement)",
      "28:1332fc" : "28:1332fc (28:1332 Diversity-Foreclosure)",
      "28:1332fd" : "28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)",
      "28:1332fr" : "28:1332fr (28:1332 Diversity-Fraud)",
      "28:1332ia" : "28:1332ia (28:1332 Diversity-Interpleader Action)",
      "28:1332if" : "28:1332if (28:1332 Diversity-Insurance Fraud)",
      "28:1332ij" : "28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)",
      "28:1332in" : "28:1332in (28:1332 Diversity-Insurance Contract)",
      "28:1332jd" : "28:1332jd (28:1332 Diversity-Declaratory Judgement)",
      "28:1332lb" : "28:1332lb (28:1332 Diversity-Libel,Assault,Slander)",
      "28:1332lm" : "28:1332lm (28:1332 Diversity - Legal Malpractice)",
      "28:1332lp" : "28:1332lp (28:1332 Diversity-Property Damage/Product Liability)",
      "28:1332lr" : "28:1332lr (28:1332 Diversity-Labor)",
      "28:1332ma" : "28:1332ma (28:1332 Diversity-Miller Act)",
      "28:1332md" : "28:1332md (28:1332 Diversity-Motor Vehicle/Wrongful Death)",
      "28:1332mm" : "28:1332mm (28:1332 Diversity-Medical Malpractice)",
      "28:1332mv" : "28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)",
      "28:1332ni" : "28:1332ni (28:1332 Diversity-Negotiable Instrument)",
      "28:1332nm" : "28:1332nm (28:1332 Diversity-Non-Motor Vehicle)",
      "28:1332nr" : "28:1332nr (28:1332 Diversity-Notice of Removal )",
      "28:1332oc" : "28:1332oc (28:1332 Diversity-Other Contract)",
      "28:1332op" : "28:1332op (28:1332 Diversity-Recovery of Overpayment)",
      "28:1332pa" : "28:1332pa (28:1332 Personal Injury/Airplane)",
      "28:1332pd" : "28:1332pd (28:1332 Property Damage)",
      "28:1332pi" : "28:1332pi (28:1332 Diversity-Personal Injury)",
      "28:1332pl" : "28:1332pl (28:1332 Diversity-Product Liability)",
      "28:1332pr" : "28:1332pr (28:1332 Diversity-Petition for Removal)",
      "28:1332qt" : "28:1332qt (28:1332 Diversity-Petition to Quiet Title)",
      "28:1332rd" : "28:1332rd (28:1332 Diversity-Recovery of Debt)",
      "28:1332ri" : "28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)",
      "28:1332rp" : "28:1332rp (28:1332 Diversity-Real Property)",
      "28:1332sa" : "28:1332sa (28:1332 - Diversity: Securities & Exchange Commiss)",
      "28:1332sf" : "28:1332sf (28:1332 - Diversity: Securities Fraud)",
      "28:1332sh" : "28:1332sh (28:1332 Diversity-Sexual Harassment)",
      "28:1332ss" : "28:1332ss (28:1332 Diversity - Stockholders Suits)",
      "28:1332t" : "28:1332t (28:1332 Diversity-Torts)",
      "28:1332tl" : "28:1332tl (28:1332 Diversity-Torts to Land)",
      "28:1332tm" : "28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))",
      "28:1332tn" : "28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)",
      "28:1332ts" : "28:1332ts (28:1332 Diversity-Misappropriation of Trade Secrets)",
      "28:1332vt" : "28:1332vt (28:1332 Diversity-Natl Motor Vehicle Title Information System)",
      "28:1332wc" : "28:1332wc (28:1332 Diversity-Worker's Compensation Benefits)",
      "28:1332wd" : "28:1332wd (28:1332 Diversity-Wrongful Death)",
      "28:1333" : "28:1333 (28:1333 Admiralty)",
      "28:1333ad" : "28:1333ad (28:1333 Admiralty)",
      "28:1333in" : "28:1333in (28:1333 Personal Injury)",
      "28:1333mc" : "28:1333mc (28:1333 Marine Contract)",
      "28:1333pd" : "28:1333pd (28:1333 Property Damage)",
      "28:1333pi" : "28:1333pi (28:1333 Marine Personal Injury)",
      "28:1334" : "28:1334 (28:1334 Bankruptcy Appeal)",
      "28:1334(b)" : "28:1334(b) (28:1334 Bankruptcy Appeal)",
      "28:1334(c)" : "28:1334(c) (28:1334 R&R re motions for absention)",
      "28:1334c" : "28:1334c (28:1334(c) R&R re motions for abstention (non-cor)",
      "28:1335" : "28:1335 (28:1335 Interpleader Action)",
      "28:1337" : "28:1337 (28:1337 Sherman-Clayton Act)",
      "28:1337sc" : "28:1337sc (28:1337 Sherman-Clayton Act)",
      "28:1338cp" : "28:1338cp (28:1338 Copyright Infringement)",
      "28:1338pt" : "28:1338pt (28:1338 Patent Infringement)",
      "28:1338tr" : "28:1338tr (28:1338 Trademark Infringement)",
      "28:1339" : "28:1339 (28:1339 Postal matters)",
      "28:1340" : "28:1340 (28:1340 IRS: Custom Duties)",
      "28:1340er" : "28:1340er (28:1340 Recovery of Erroneous Refund)",
      "28:1340tp" : "28:1340tp (28:1340 Jurisdiction of Internal Revenue Matters; Customs Duties)",
      "28:1341" : "28:1341 (28:1341 Complaint for Forfeiture)",
      "28:1343" : "28:1343 (28:1343 Violation of Civil Rights)",
      "28:1344" : "28:1344 (28:1344 Elections disputes)",
      "28:1345" : "28:1345 (28:1345 USA Plaintiff )",
      "28:1345co" : "28:1345co (28:1345 Replevin & Conversion)",
      "28:1345db" : "28:1345db (28:1345 Debt to US - FHA/HUD Title I)",
      "28:1345df" : "28:1345df (28:1345 Default of Promissory Note)",
      "28:1345er" : "28:1345er (28:1345 Recovery of Erroneous Refund)",
      "28:1345fc" : "28:1345fc (28:1345 Foreclosure)",
      "28:1345ff" : "28:1345ff (28:1345 Complaint for Forfeiture)",
      "28:1345hl" : "28:1345hl (28:1345 VA Home Loan Guaranty Debt)",
      "28:1345lc" : "28:1345lc (28:1345 Land Condemnation)",
      "28:1345mc" : "28:1345mc (28:1345 Medical Care Recovery)",
      "28:1345mi" : "28:1345mi (28:1345 Mining Claim Ejectment)",
      "28:1345pd" : "28:1345pd (28:1345 Property Damage)",
      "28:1345pe" : "28:1345pe (28:1345 Property Ejectment)",
      "28:1345rc" : "28:1345rc (28:1345 Recovery of Debt to US)",
      "28:1345ro" : "28:1345ro (28:1345 Recovery of Retirement Overpayment)",
      "28:1345st" : "28:1345st (28:1345 Default of Student Loan)",
      "28:1345tp" : "28:1345tp (28:1345 Trespass on Public Land)",
      "28:1345tx" : "28:1345tx (28:1345 Prohibit dfts assessing tx on purch/use of pers prop)",
      "28:1345va" : "28:1345va (28:1345 Recovery of VA Overpayment)",
      "28:1346" : "28:1346 (28:1346 U.S. Defendant)",
      "28:1346bc" : "28:1346bc (28:1346 Breach of Contract)",
      "28:1346pi" : "28:1346pi (28:1346 Marine Personal Injury (or tort claim - personal injury / motor vehicle))",
      "28:1346rc" : "28:1346rc (28:1346 Rcovery of IRS Tax)",
      "28:1346tc" : "28:1346tc (28:1346 Tort Claim)",
      "28:1346wd" : "28:1346wd (28:1346 Wrongful Death)",
      "28:1348" : "28:1348 (28:1348 Banking association as party)",
      "28:1349" : "28:1349 (28:1348 Corporation organized under Federal Law as party )",
      "28:1350" : "28:1350 (28:1350 Alien Tort Claims Act)",
      "28:1352" : "28:1352 (28:1352 Miller Act)",
      "28:1355" : "28:1355 (28:1355 Petition for Return of Property)",
      "28:1356" : "28:1356 (28:1356 Executory Process/Foreclosure)",
      "28:1358" : "28:1358 (28:1358 Land Condemnation)",
      "28:1361" : "28:1361 (28:1361 Petition for Writ of Mandamus)",
      "28:1361pr" : "28:1361pr (28:1361 Complaint for mandamus relief (prisoner))",
      "28:1362ic" : "28:1362ic (28:1362 Indian Tribal Controversy)",
      "28:1362iw" : "28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)",
      "28:1363" : "28:1363 (28:1363 Action for protection of jurors employment rights)",
      "28:1364" : "28:1364 (28:1364 Auto Negligence)",
      "28:1367" : "28:1367 (28:1367 Other Property Damage)",
      "28:1391" : "28:1391 (DO NOT USE 28:1391 Personal Injury)",
      "28:1394" : "28:1394 (28:1394 Banking Assoc action agst Comptroller of Currency)",
      "28:1395" : "28:1395 (28:1395 Complaint of Forfeiture)",
      "28:1402" : "28:1402 (28:1402 US as Defendant)",
      "28:1403" : "28:1403 (28:1403 Condemnation of real estate for the use of the US)",
      "28:1407" : "28:1407 (28:1407 Airline Crash)",
      "28:1407im" : "28:1407im (28:1407 MDL: Silicone Gel Breast Implant Products Liability)",
      "28:1407md" : "28:1407md (28:1407 MDL: Multidistrict Litigation)",
      "28:1407n" : "28:1407n (28:1407 MDL: Perosnal/Injury/Norplant Product Liability)",
      "28:1407pl" : "28:1407pl (28:1407 MDL: Products Liability)",
      "28:1441ac" : "28:1441ac (28:1441 Petition for Removal- Account Receivable)",
      "28:1441ada" : "28:1441ada (28:1441 Removal-Americans with Disabilities Act)",
      "28:1441ag" : "28:1441ag (28:1441 Removal - Civil Rights (Age))",
      "28:1441al" : "28:1441al (28:1441 Petition for Removal- Airline Crash)",
      "28:1441as" : "28:1441as (28:1441 Petition for Removal- Asbestos Litigation)",
      "28:1441au" : "28:1441au (28:1441 Petition for Removal- Auto Negligence)",
      "28:1441ba" : "28:1441ba (28:1441 Removal - National Bank Act)",
      "28:1441bc" : "28:1441bc (28:1441 Removal - Breach of Contract)",
      "28:1441bfd" : "28:1441bfd (28:1441 Removal - Breach of Fiduciary Duties)",
      "28:1441ca" : "28:1441ca (28:1441 Removal - Carmack Amendment)",
      "28:1441cc" : "28:1441cc (28:1441 Removal - Computer Crimes Act)",
      "28:1441cj" : "28:1441cj (28:1441 Removal - Confessed Judgement)",
      "28:1441cla" : "28:1441cla (28:1441 Removal - Consumer Leasing Act)",
      "28:1441cp" : "28:1441cp (28:1441 Removal - Copyright)",
      "28:1441cpl" : "28:1441cpl (28:1441 Removal - Contract Product Liability)",
      "28:1441cra" : "28:1441cra (28:1441 Removal - Fair Credit Reporting Act)",
      "28:1441cv" : "28:1441cv (28:1441 Petition for Removal- Civil Rights Act)",
      "28:1441dea" : "28:1441dea (28:1441 Removal - Disabilities Education Act)",
      "28:1441df" : "28:1441df (28:1441 Petition for Removal- Contract Default)",
      "28:1441di" : "28:1441di (28:1441 Removal - Civil Rights (Disability Act))",
      "28:1441dj" : "28:1441dj (28:1441 Petition for Removal- Declaratory Judgemen)",
      "28:1441ds" : "28:1441ds (28:1441 Petition for Removal- Contract Dispute)",
      "28:1441ea" : "28:1441ea (28:1441 Removal - Employment Discrimination (Age))",
      "28:1441eb" : "28:1441eb (28:1441 Removal - E.R.I.S.A. Employee Benefits)",
      "28:1441ec" : "28:1441ec (28:1441 Removal - Electronic Comm. Privacy Act)",
      "28:1441ed" : "28:1441ed (28:1441 Petition for Removal - Employment Discrim)",
      "28:1441em" : "28:1441em (28:1441 Removal - Emergency Medical Treatment & Active Labor)",
      "28:1441er" : "28:1441er (28:1441 Removal - Employment Discrimination (Race))",
      "28:1441es" : "28:1441es (28:1441 Removal - Employment Discrimination (Sex))",
      "28:1441fa" : "28:1441fa (28:1441 Removal - Civil Rights (False Arrest))",
      "28:1441fc" : "28:1441fc (28:1441 Petition for Removal - Fair Credit Reporti)",
      "28:1441fd" : "28:1441fd (28:1441 Removal - Fair Debt Collection Practices Act)",
      "28:1441fe" : "28:1441fe (28:1441 Removal - Fed. Employee Garnishment Statute)",
      "28:1441fh" : "28:1441fh (28:1441 Removal - FEHBA)",
      "28:1441fif" : "28:1441fif (28:1441 Removal - Insecticide/Fungicide/Rodenticide Act -1942)",
      "28:1441fl" : "28:1441fl (28:1441 Removal - Fair Labor Standards Act)",
      "28:1441fm" : "28:1441fm (28:1441 Removal - Family and Medical Leave Act)",
      "28:1441fr" : "28:1441fr (28:1441 Petition for Removal- Fraud)",
      "28:1441fs" : "28:1441fs (28:1441 Removal - Foreigh Sovereign Immunities Act)",
      "28:1441fsa" : "28:1441fsa (28:1441 Removal - Federal Food Stamp Act)",
      "28:1441hb" : "28:1441hb (28:1441 Removal - Petition of Habeas Corpus)",
      "28:1441hc" : "28:1441hc (28:1441 Removal - Handicapped Child Protection Act)",
      "28:1441hd" : "28:1441hd (28:1441 Removal - Housing Discrimination)",
      "28:1441ia" : "28:1441ia (28:1441 Removal - Interstate Commerse Act)",
      "28:1441if" : "28:1441if (28:1441 Removal - Insurance Fraud)",
      "28:1441ij" : "28:1441ij (28:1441 Petition for Removal- Injunctive/Declarato)",
      "28:1441il" : "28:1441il (28:1441 Removal - Interstate Land Full Discloser Act)",
      "28:1441in" : "28:1441in (28:1441 Petition for Removal- Insurance Contract)",
      "28:1441int" : "28:1441int (28:1441 Petition for Removal- Action for Interplea)",
      "28:1441la" : "28:1441la (28:1441la Removal - Truth in Lending Act)",
      "28:1441lb" : "28:1441lb (28:1441 Petition for Removal Libel,Assault,Slander)",
      "28:1441lm" : "28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relatio)",
      "28:1441ml" : "28:1441ml (28:1441 Removal - Motor Vehicle Prod Liability)",
      "28:1441mm" : "28:1441mm (28:1441 Petition for Removal- Medical Malpractice)",
      "28:1441mv" : "28:1441mv (28:1441 Removal - Motor Vehicle)",
      "28:1441ni" : "28:1441ni (28:1441 Petition for Removal- Negotiable Instrumen)",
      "28:1441nm" : "28:1441nm (28:1441 Petition for Removal- Non-Motor Vehicle)",
      "28:1441nr" : "28:1441nr (28:1441 Notice of Removal)",
      "28:1441oc" : "28:1441oc (28:1441 Petition For Removal--Other Contract)",
      "28:1441pa" : "28:1441pa (28:1441 Removal - Patent Infringement)",
      "28:1441pd" : "28:1441pd (28:1441 Petition for Removal- Property Damage)",
      "28:1441pi" : "28:1441pi (28:1441 Petition for Removal- Personal Injury)",
      "28:1441pl" : "28:1441pl (28:1441 Petition for Removal- Product Liability)",
      "28:1441pr" : "28:1441pr (28:1441 Petition for Removal)",
      "28:1441qt" : "28:1441qt (28:1441 Petition for Removal- Petition to Quiet Ti)",
      "28:1441ra" : "28:1441ra (28:1441 Removal - Civil Rights (Race))",
      "28:1441ri" : "28:1441ri (28:1441 Petition for Removal- Racketeering (RICO))",
      "28:1441rl" : "28:1441rl (28:1441 Removal - Rent, Lease & Ejectment)",
      "28:1441sa" : "28:1441sa (28:1441 - Petition for Removal: SEC Act)",
      "28:1441sf" : "28:1441sf (28:1441 - Petition for Removal: Securities Fraud)",
      "28:1441sh" : "28:1441sh (28:1441 Removal - Sexual Harassment)",
      "28:1441st" : "28:1441st (28:1441 Removal - Stockholders Suit)",
      "28:1441sv" : "28:1441sv (28:1441 Removal - Security Violation)",
      "28:1441sx" : "28:1441sx (28:1441 Removal - Civil Rights (Sex))",
      "28:1441tc" : "28:1441tc (28:1441 Removal - Tricare Program)",
      "28:1441ti" : "28:1441ti (28:1441 Removal - Trademark Infridgement)",
      "28:1441til" : "28:1441til (28:1441 Removal - Truth and Lending)",
      "28:1441tl" : "28:1441tl (28:1441 Petition for Removal- Torts to Land)",
      "28:1441tm" : "28:1441tm (28:1441 Petition for Removal- Tort/Motor Vehicle ()",
      "28:1441tn" : "28:1441tn (28:1441 Petition for Removal- Tort/Non-Motor Vehic)",
      "28:1441us" : "28:1441us (28:1441 Removal - Uniformed Svc Emp/Reemp Rights Act)",
      "28:1441wc" : "28:1441wc (28:1441 Removal - Worker's Compensation Benefits)",
      "28:1441wd" : "28:1441wd (28:1441 Petition for Removal- Wrongful Death)",
      "28:1441wt" : "28:1441wt (28:1441 Removal - Employment (Wrongful Termination))",
      "28:1442" : "28:1442 (28:1442 Notice of Removal - Suit against Federal Officer)",
      "28:1442aaf" : "28:1442aaf (28:1442 Petition for Removal - Agst members of armed forces)",
      "28:1442bc" : "28:1442bc (DO NOT USE 28:1442 Petition for Removal- Breach of Contract)",
      "28:1442nr" : "28:1442nr (DO NOT USE 28:1442 Notice of Removal)",
      "28:1442pr" : "28:1442pr (DO NOT USE 28:1442 Petition for Removal)",
      "28:1443" : "28:1443 (28:1443 Removal from State Court - Civil Rights: Rent, Lease, and Ejectment)",
      "28:1444" : "28:1444 (28:1444 Notice of Removal- Foreclosure)",
      "28:1446" : "28:1446 (28:1446 Notice of Removal - Airline Crash)",
      "28:1446al" : "28:1446al (28:1446 Notice of Removal - Airline Crash)",
      "28:1446as" : "28:1446as (28:1446 Notice of Removal - Asbestos Litigation)",
      "28:1446bc" : "28:1446bc (28:1446 Notice of Removal - Breach of Contract)",
      "28:1446cs" : "28:1446cs (28:1446 Notice of Removal - Child Support Enforcement)",
      "28:1446dj" : "28:1446dj (28:1441 Notice of Removal - Declaratory Judgement)",
      "28:1446er" : "28:1446er (28:1446 Notice of Removal - E.R.I.S.A)",
      "28:1446fm" : "28:1446fm (28:1446 Notice of Removal - Family Medical Leave Act)",
      "28:1446fr" : "28:1446fr (28:1446 Notice of Removal - Fraud)",
      "28:1446in" : "28:1446in (28:1446 Breach of Contract- Insurance)",
      "28:1446lb" : "28:1446lb (28:1446 Notice of Removal - Libel, Assault, Slander)",
      "28:1446ml" : "28:1446ml (28:1446 Notice of Removal - Motor Vehicle Prod Liability)",
      "28:1446mm" : "28:1446mm (28:1446 Notice of Removal - Medical Malpractice)",
      "28:1446mv" : "28:1446mv (28:1446 Notice of Removal - Motor Vehicle)",
      "28:1446ni" : "28:1446ni (28:1446 Notice of Removal - Negotiable Instrument)",
      "28:1446nr" : "28:1446nr (28:1446 Notice of Removal )",
      "28:1446oc" : "28:1446oc (28:1446 Notice of Removal - Other Contract)",
      "28:1446pd" : "28:1446pd (28:1446 Petition for Removal- Property Damage (P.I)",
      "28:1446pi" : "28:1446pi (28:1446 Petition for Removal- Personal Injury)",
      "28:1446pl" : "28:1446pl (28:1446pl Petition for Removal - Product Liability)",
      "28:1446pr" : "28:1446pr (28:1446 Petition for Removal)",
      "28:1446st" : "28:1446st (28:1446 Notice of Removal - Stockholders Suit)",
      "28:1446tl" : "28:1446tl (28:1446 Notice of Removal - Torts to Land)",
      "28:1446wd" : "28:1446wd (28:1446 Notice of Removal - Wrongful Death)",
      "28:1452" : "28:1452 (28:1452 R&R re motions to remand (non-core))",
      "28:1453" : "28:1453 (28:1453 Class Action Fairness Act)",
      "28:1491" : "28:1491 (28:1491 Tucker Act)",
      "28:1602" : "28:1602 (28:1602 Foreign Sovereign Immunities Act)",
      "28:1605" : "28:1605 (28:1605 Foreign Socereign Immunities Act of 1976)",
      "28:1605A" : "28:1605A (28:1605 Antiterrorism & Effective Death Penalty Act of 1996)",
      "28:1610" : "28:1610 (28:1610 Juridictional Immunities of Foreign States)",
      "28:1631" : "28:1631 (28:1631 Case Transferred to Cure Want of Jurisdiction)",
      "28:1651" : "28:1651 (DO NOT USE 28:1651 Petition for Writ of Coram Nobis)",
      "28:1651cn" : "28:1651cn (28:1651 Petition for Writ of Error Coram Nobis)",
      "28:1651hc" : "28:1651hc (28:1651 Petition for Writ of Habeas Corpus)",
      "28:1651mn" : "28:1651mn (28:1651 Petition for Writ of Mandamus)",
      "28:1651ne" : "28:1651ne (28:1651 Application for Writ Ne Exeat)",
      "28:1651w" : "28:1651w (28:1651 All Writs Act)",
      "28:1715" : "28:1715 (28:1715 Class Action Fairness Act of 2005)",
      "28:1732" : "28:1732 (28:1732 Reproduction of Records)",
      "28:1738Acs" : "28:1738Acs (28:1738 The Uniform Child Custody Jurisdiction Act)",
      "28:1782" : "28:1782 (28:1782 Letter rogatory - appointment )",
      "28:1783" : "28:1783 (28:1783 Petition for Subpoena of person in foreign country)",
      "28:1826" : "28:1826 (28:1826 Order of confinement of recalcitrant witness)",
      "28:1875" : "28:1875 (28:1875 Juror Protection Act / Protection of Jurors' Employment)",
      "28:1916" : "28:1916 (28:1916 Marine Personal Injury)",
      "28:1963" : "28:1963 (28:1963 Registration of judgement from another district)",
      "28:1983" : "28:1983 (DO NOT USE 28:1983 Civil Rights)",
      "28:2001" : "28:2001 (28:2001 Judicial Sale of Realty)",
      "28:2071" : "28:2071 (28:2071 Rule Making Power Generally)",
      "28:2201" : "28:2201 (28:2201 Creation of a Remedy - Declaration of Rights)",
      "28:2201an" : "28:2201an (28:2201 Declaration Judgement (aliens and nationality))",
      "28:2201cp" : "28:2201cp (28:2201 Declaratory Judgement (Copyright))",
      "28:2201dj" : "28:2201dj (28:2201 Declaratory Judgement)",
      "28:2201fa" : "28:2201fa (28:2201 Declaratory Judgement - Firearms)",
      "28:2201fs" : "28:2201fs (28:2201 Declaratory Judgement (Food Security Act))",
      "28:2201ij" : "28:2201ij (28:2201 Injunction)",
      "28:2201in" : "28:2201in (28:2201 Declaratory Judgement (Insurance))",
      "28:2201pi" : "28:2201pi (28:2201 Declaratory Judgement - Personal Injury)",
      "28:2241" : "28:2241 (28:2241 Petition for Writ of Habeas Corpus (federa)",
      "28:2241fd" : "28:2241fd (28:2241 Petition for Writ of Habeas Corpus (federal))",
      "28:2241in" : "28:2241in (28:2241 Habeas Corpus: INS)",
      "28:2241st" : "28:2241st (28:2241 Petition for Writ of Habeas Corpus (State))",
      "28:2244" : "28:2244 (28:2244 Habeas Corpus - Finality of Determination)",
      "28:2254" : "28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))",
      "28:2254dp" : "28:2254dp (28:2254 Petition for Writ of Habeas Corpus (Death Penalty))",
      "28:2254se" : "28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)",
      "28:2255" : "28:2255 (28:2255 Motion to Vacate / Correct Illegal Sentenc)",
      "28:2271" : "28:2271 (DO NOT USE 28:2271 Federal Tort Claims Act)",
      "28:2283" : "28:2283 (28:2283 Stay of State Court Proceedings (Injunctive Relief))",
      "28:2345" : "28:2345 (DO NOT USE 28:2345 Medicare Recovery)",
      "28:2347" : "28:2347 (28:2347 Petition to Review Orders in the Ct of Appeals)",
      "28:2401" : "28:2401 (28:2401 Federal Tort Claims Act (Time for commencing action against the US))",
      "28:2403" : "28:2403 (28:2403 Constitutionality of State Statutes)",
      "28:2405" : "28:2405 (28:2405 Garnishment of debtors of a corporation by US)",
      "28:2409" : "28:2409 (28:2409(a) Quiet Title Action)",
      "28:2409(a)" : "28:2409(a) (28:2409 Quiet Title Action)",
      "28:2410" : "28:2410 (28:2410 Quiet Title)",
      "28:2412" : "28:2412 (28:2412 Equal Access to Justice Act)",
      "28:2415" : "28:2415 (28:2415 Detinue and Conversion)",
      "28:2671" : "28:2671 (28:2671 Federal Tort Claims Act)",
      "28:2672mv" : "28:2672mv (28:2672 Federal Tort Claims Act - Motor Vehicle)",
      "28:2672pi" : "28:2672pi (28:2672 Federal Tort Claims Act - Personal Injury)",
      "28:2674" : "28:2674 (28:2674 Federal Tort Claims Act)",
      "28:2675" : "28:2675 (28:2675 Federal Tort Claims Act - Disposition by Agency Req)",
      "28:2679d2" : "28:2679d2 (28:2679 Federal Tort Claims Act - Employee of the U.S.A.)",
      "28:2680" : "28:2680 (28:2680 Federal Tort Claims Act - Exceptions)",
      "28:3001" : "28:3001 (28:3001 Federal Debt Collection Act )",
      "28:3001(a)" : "28:3001(a) (28:3001 Federal Debt Collection Procedures Act of 1990)",
      "28:3203" : "28:3203 (28:3203 Post Judgement Remedies: Writ of Execution)",
      "28:3301" : "28:3301 (28:3301 Fraudulent Transfer Federal Debt Collection Procedures Act)",
      "28:592" : "28:592 (28:592 Independent Counsel - Application for Appointment)",
      "28:7402" : "28:7402 (28:7402 Refund of Taxes)",
      "28:7422" : "28:7422 (28:7422 Appeal from Administrative Decision)",
      "29:0151" : "29:0151 (29:151 Labor: Review of Agency Action)",
      "29:0160" : "29:0160 (29:160(1) National Labor Relations Act)",
      "29:0184" : "29:0184 (29:184 Violation Collection Bargain Agreement)",
      "29:0185ep" : "29:0185ep (29:185 Employee Pension Plan)",
      "29:0185lm" : "29:0185lm (29:185 Labor/Mgt. Relations (Contracts))",
      "29:0201do" : "29:0201do (29:201 Denial of Overtime Compensation)",
      "29:0201fl" : "29:0201fl (29:201 Fair Labor Standards Act)",
      "29:0203" : "29:0203 (29:203 Equal Pay Act)",
      "29:0206" : "29:0206 (29:206 Collect Unpaid Wages)",
      "29:0401" : "29:0401 (29:0401 Labor Management Disclosure Act)",
      "29:0621" : "29:0621 (29:621 Job Discrimination (Age))",
      "29:0623" : "29:0623 (29:623 Job Discrimination (Age))",
      "29:0626" : "29:0626 (29:626 Job Discrimination (Age))",
      "29:0633" : "29:0633 (29:633 Job Discrimination (Age))",
      "29:0651" : "29:0651 (29:651 Occupational Safety/Health)",
      "29:0754" : "29:0754 (DO NOT USE 29:754 Discrimination)",
      "29:0791" : "29:0791 (29:791 Job Discrimination (Rehabilitation Act))",
      "29:0794" : "29:0794 (29:0794 Job Discrimination (Handicap))",
      "29:1001" : "29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)",
      "29:1002" : "29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)",
      "29:1104" : "29:1104 (29:1104 Recovery of Benefits to Employee)",
      "29:1109" : "29:1109 (29:1109 Breach of Fiduciary Duties)",
      "29:1131" : "29:1131 (DO NOT USE 29:1131 ERISA - Collection of Delinquent Trust Fund)",
      "29:1132" : "29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)",
      "29:1145" : "29:1145 (29:1145 E.R.I.S.A.)",
      "29:1149" : "29:1149 (29:1149 Recover Pension & Profit Sharing)",
      "29:1337" : "29:1337 (DO NOT USE 29:1337 E.R.I.S.A.)",
      "29:1362" : "29:1362 (29:1362 ERISA)",
      "29:1381" : "29:1381 (29:1381 E.R.I.S.A.)",
      "29:1401" : "29:1401 (29:1401(b)(2) Appeal of Arbitration Award)",
      "29:1451" : "29:1451 (29:1451 E.R.I.S.A.)",
      "29:1801" : "29:1801 (29:1801 Farmworker Rights)",
      "29:2601" : "29:2601 (29:2601 Family and Medical Leave Act )",
      "29:790" : "29:790 (29:790 Rehabilitation of Labor)",
      "30:0181" : "30:0181 (30:181 Land subject to disposition; persons entitled to benefits; reciprocal privileges)",
      "30:0801" : "30:0801 (30:0801 Penalities/Federal Mine Safety Health Act)",
      "30:1201" : "30:1201 (30:1201 Environment: Review of Agency Action (Congressional Findings))",
      "30:1202" : "30:1202 (30:1202 Mining Reclamation Act (Statement of Purpose))",
      "30:1276" : "30:1276 (30:1276 Interior: Judicial Review of Agency Action)",
      "30:1701" : "30:1701 (30:1701 Federal Oil Gas Royalty Mgt Act 1982 (FOGRMA))",
      "30:22" : "30:22 (30:22 General Mining Law of 1872 (Lands Open to Purchase by Citizens))",
      "30:815" : "30:815 (30:815 Federal Mine Safety & Health Act (Procedure for Enforcement))",
      "31:1341" : "31:1341 (31:1341 Government employee--limitations on expending monies)",
      "31:3545" : "31:3545 (31:3545 Civil Action to Recovery Money)",
      "31:3702" : "31:3702 (31:3702 Procedures for Settling Claims)",
      "31:3713" : "31:3713 (31:3713 Priority of Government Claims)",
      "31:3720" : "31:3720 (31:3720 Federal Income Tax Interceptions (Collection of Payments))",
      "31:3728" : "31:3728 (31:3728 Setoff against Judgment)",
      "31:3729" : "31:3729 (31:3729 False Claims Act - Liability)",
      "31:3730" : "31:3730 (31:3730 Qui Tam False Claims Act)",
      "31:3731" : "31:3731 (31:3731 False Claims Act - Procedures)",
      "31:3733j2" : "31:3733j2 (31:3733j2 Pet to Mod or Set Aside CV Investigative Demand)",
      "31:5314" : "31:5314 (31:5314 Failure to Report Interest in Foreign Accounts)",
      "31:5317" : "31:5317 (31:5317 Search and Forfeiture of Monetary Instruments)",
      "31:5320" : "31:5320 (31:5320 Inj proceedings re Rpts of Currency & Foreign Trans.)",
      "31:5321" : "31:5321 (31:5321 Civil Penalties re Reports of Currency and Foreign Transaction)",
      "31:5332(a)" : "31:5332(a) (31:5332(a) Evading Currency Reporting Requirement)",
      "31:5332(f)" : "31:5332(f) (31:5332(f) Transport and Transfer US currency from in to out)",
      "31:6716" : "31:6716 (31:6716 Discrimination re money and finance)",
      "31:732" : "31:732 (31:732 General Acct. Office Personnel Act of 1980 (Personnel Management System))",
      "31:9701" : "31:9701 (31:9701 Federal User Charge Statute)",
      "33:1221" : "33:1221 (33:1221 Ports and Waterways Safety Program)",
      "33:1251" : "33:1251 (33:1251 Federal Water Pollution Control Act (Clean Water Act))",
      "33:1319cw" : "33:1319cw (33:1319cw Clean Water Act - Enforcement)",
      "33:1319pv" : "33:1319pv (33:1319(a)(2)pv Pollutants & Permit Violations)",
      "33:1321" : "33:1321 (33:1321 Clean Water Act - Discharge of hazardous substance or pollutants/water)",
      "33:1361" : "33:1361 (33:1361 Clean Water Act-Administrator Authority)",
      "33:1364" : "33:1364 (33:1364 Clean Water Act - EPA action to restrain pollution endangering health (emergency powers))",
      "33:1365" : "33:1365 (33:1365 Clean Water Act - Citizen Suits re Environmental Matters)",
      "33:1415" : "33:1415 (33:1415 Marine Protection, Research, and Sanctuaries Act)",
      "33:1515" : "33:1515 (33:1515 Deepwater Ports Act (citizen civil action))",
      "33:2701" : "33:2701 (33:2701 Oil Pollution Act of 1940)",
      "33:408" : "33:408 (33:408 Injury to Harbor Improvement)",
      "33:594" : "33:594 (33:594 Land Condemnation)",
      "33:901" : "33:901 (33:901 Longshoremen Harbor Workers Compensation Act (Navigation and Navigable Waters))",
      "33:905(b)" : "33:905(b) (33:905(b) Longshoremen Workers' Compensation Act-Recovery of Damages caused by negligence of a )",
      "33:918" : "33:918 (33:918 Longshore and Harbor Workers Compensation Act - Collection of Defaulted Payments)",
      "33:921" : "33:921 (33:921 Longshore & Harbor Workers Compensation Act - Review of Compensation Orders)",
      "33:933" : "33:933 (33:933 Longshore and Harbor Workers' Compensation Act-Compensation for Injuries (Third-Party Cl)",
      "35:0145" : "35:0145 (35:145 Civil Action to Obtain Patent)",
      "35:0183" : "35:0183 (35:183 Right to Compensation - Patent Laws)",
      "35:0271" : "35:0271 (35:271 Patent Infringement)",
      "35:1" : "35:1 (35:1 Establishment of PTO)",
      "35:146" : "35:146 (35:146 Appeal from Decision of the Board of Patent Appeals)",
      "35:256" : "35:256 (35:256 Patent Non-Infringement (Correction of Named Inventor))",
      "35:281" : "35:281 (35:281 Remedy for Infringement of Patent/jurisdiction conferred 28:1338)",
      "35:282" : "35:282 (35:282 Patent Infringement - Defenses)",
      "35:283" : "35:283 (35:283 Action to enjoin violation of right secured by patent)",
      "35:289" : "35:289 (35:289 Recover profits from unlicensed use of design patent)",
      "35:291" : "35:291 (35:291 Action for relief between owners; interfering patents)",
      "35:292" : "35:292 (35:292 Penalty & Forfeiture; illegal use of word patent (false marking))",
      "35:311" : "35:311 (35:311 Patent - Request for Inter Partes Reexamination)",
      "35:32" : "35:32 (35:32 Suspension from Practice before Patent & Trade. Off.)",
      "38:1110" : "38:1110 (38:1110 Basic Entitlements / Wartime)",
      "38:1131" : "38:1131 (38:1131 Basic Entitlements / Peacetime)",
      "38:1681" : "38:1681 (DO NOT USE 38:1681 Recovery of VA Overpayment)",
      "38:1686" : "38:1686 (DO NOT USE 38:1686 Recovery of VA Overpayment)",
      "38:1780" : "38:1780 (DO NOT USE 38:1780 Recovery of VA Overpayment)",
      "38:1816" : "38:1816 (38:1816 Deficiency balance on VA Mortgage Foreclosure (Regs Governing the VA Loan Guaranty Pgm))",
      "38:1965" : "38:1965 (38:1965 Servicemen's Group Life Insurance (Definitions))",
      "38:1975" : "38:1975 (38:1975 Recovery of Servicemen's Group Life Insurance - Jurisdiction of District Court)",
      "38:1984" : "38:1984 (38:1984 Suit for Veterans Insurance)",
      "38:2011" : "38:2011 (DO NOT USE 38:2011 - Veteran's Readjustment Assistance Act of)",
      "38:2021" : "38:2021 (DO NOT USE 38:2021 Right to re-employment of inducted persons)",
      "38:3116" : "38:3116 (DO NOT USE 38:3116 VA Overpayment)",
      "38:3481" : "38:3481 (38:3481 Recovery of VA Overpayment)",
      "38:3680" : "38:3680 (38:3680 Recovery of Education Assist Allowance Overpayment)",
      "38:4212" : "38:4212 (38:4212 Veterans Employment Emphasis Under Federal Contracts)",
      "38:4301" : "38:4301 (38:4301 Uniformed Srvs. Employment & Reemployment Rights Act (purpose))",
      "38:4302" : "38:4302 (38:4302 Veterans Reemployment Rights Act (relation to other laws and plans or agreements).)",
      "38:4311" : "38:4311 (38:4311 Uniformed Service Employment or Reemployment Rights Act (USERRA) - Discrimination)",
      "38:4312" : "38:4312 (38:4312 Rights of inducted persons to reemployment)",
      "38:4323" : "38:4323 (38:4323 USERRA - Enforcement of rights with respect to state or private employer)",
      "38:4324" : "38:4324 (38:4324 USERRA - Enforcement of rights with respect to federal executive agencies)",
      "38:5315" : "38:5315 (38:5315 Delinquent Payment of Amounts Due to US)",
      "38:5316" : "38:5316 (38:5316 VA Overpayment)",
      "38:775" : "38:775 (DO NOT USE 38:775 Recovery of Servicemen's Group Life Insurance)",
      "39:1207" : "39:1207 (39:1207 Review Agency Action--Labor Disputes)",
      "39:1208(b)" : "39:1208(b) (39:1208(b) Postal Reorganization Act of 1970 - Suits)",
      "39:3005" : "39:3005 (39:3005 False Representations and Lotteries)",
      "39:3007" : "39:3007 (39:3007 Detention of Mail for Temporary Periods - Injunction directing retention of incoming mail)",
      "39:3008(e)" : "39:3008(e) (39:3008(e) Enforce compliance with a USPS Prohibitory Order)",
      "39:403" : "39:403 (39:403 Discriminatory use of the Postal Service)",
      "39:409" : "39:409 (39:409 Suits by and against the Postal Service)",
      "40:0258" : "40:0258 (DO NOT USE 40:258(a) Public Buildings & Property: Land Condem)",
      "40:0875" : "40:0875 (DO NOT USE 40:875 Public Buildings & Property: Negligence)",
      "40:1101" : "40:1101 (40:1101 Brooks Architect - Engineers Act)",
      "40:3131" : "40:3131 (40:3131 Bonds of contractors of public buildings)",
      "40:3142" : "40:3142 (40:3142 Davis-Bacon Act (prevailing wages))",
      "40:581" : "40:581 (40:581 General Authority of Administrator of General Services)",
      "41:0251" : "41:0251 (DO NOT USE 41:251 Public Contracts-Review of Agency Action)",
      "41:1463" : "41:1463 (DO NOT USE 41:1463 Public Contracts: Unlawful Employment Prac)",
      "41:2102-07" : "41:2102-07 (41:2102-2107 Procurement Integrity Act)",
      "41:3301" : "41:3301 (41:3301 Competition in Contracting Act)",
      "41:6503" : "41:6503 (41:6503 Walsh-Healy Act - Breach of Public Contract)",
      "41:6505" : "41:6505 (41:6505 Exclusions - Review of legal questions in contracts; Walsh-Healy Act)",
      "41:6702-04" : "41:6702-04 (41:6702-6704 Service Contract Labor Standards / McNamara-O'Hara Service Contract Act 1965)",
      "41:7105(f)" : "41:7105(f) (41:7105(f) Action to Judicially Enforce Administrative Subpoena)",
      "42:0205" : "42:0205 (42:205 Appointment of Surgeon General)",
      "42:0206" : "42:0206 (42:206 Surgeon General - Assignment of Officers)",
      "42:0247" : "42:0247 (DO NOT USE 42:247 Personal Injury-Swine Flu)",
      "42:0402" : "42:0402 (42:402 Social Security Benefits)",
      "42:0405id" : "42:0405id (42:405 Review of HHS Decision (SSID))",
      "42:0405wc" : "42:0405wc (42:405 Review of HHS Decision (DIWC))",
      "42:0405ww" : "42:0405ww (42:405 Review of HHS Decision (DIWW))",
      "42:0416" : "42:0416 (42:416 Denial of Social Security Benefits)",
      "42:0427" : "42:0427 (42:427 Social Security Benefits (Transitional Insured Status))",
      "42:10139" : "42:10139 (42:10139 Judicial review of agency actions)",
      "42:10801" : "42:10801 (42:10801 Protection & Advocacy for Individuals with Mental Illness Act of 1986 (PAIMI))",
      "42:10805" : "42:10805 (42:10805 Protection and Advocacy Systems)",
      "42:11001" : "42:11001 (42:11001 Emergency Plan. & Comm. Right to Know Act (EPCRA))",
      "42:11046" : "42:11046 (42:11046 Fed Emer Plan Comm Right-to-know Act (EPCRA) - civil actions)",
      "42:11101" : "42:11101 (42:11101 Health Care Quality Improvement Act of 1986)",
      "42:11112" : "42:11112 (42:11112 Health Care Quality Improvement Act (Standards for Professional Review Actions))",
      "42:11601" : "42:11601 (42:11601 International Child Abduction Remedies Act)",
      "42:11603b" : "42:11603b (42:11603(b) Int'l. Child Abduction Remedies Act (ICARA) - Judicial Remedies)",
      "42:12101" : "42:12101 (42:12101 The Americans with Disabilities Act of 1990)",
      "42:12102" : "42:12102 (42:12102 Americans with Disabilities Act (ADA) Disability Definition)",
      "42:12111" : "42:12111 (42:12111 Americans with Disabilities Act - Employment)",
      "42:12112" : "42:12112 (42:12112 Americans with Disabilities Act - Employment Discrimination)",
      "42:12117" : "42:12117 (42:12117 Americans with Disabilities Act - Enforcement)",
      "42:12132" : "42:12132 (42:12132 Americans with Disabilities Act - Discrimination)",
      "42:12188" : "42:12188 (42:12188 Americans With Disabilities Act - Civil Enforcement Actions)",
      "42:1320a" : "42:1320a (42:1320a-7b(b)(2)(A) Anti-Kickback Act (for federal health care programs))",
      "42:1320d-2" : "42:1320d-2 (42:1320d-2 Health Insurance Portability And Accountability Act (HIPAA))",
      "42:1381a" : "42:1381a (42:1381a Supplemental Security Income benefits (SSID))",
      "42:1382" : "42:1382 (42:1382 Eligibility for benefits)",
      "42:1383" : "42:1383 (42:1383 Review of HHS Decision (regarding payment of benefits))",
      "42:1395" : "42:1395 (42:1395 Emergency Medical Treatment and Active Labor Act)",
      "42:1395dd" : "42:1395dd (42:1395dd Exam & Treatment Emergency Med Cond & Women in Labor)",
      "42:1395hr" : "42:1395hr (42:1395hr Hospital Reimbursement for Medicare Services)",
      "42:1395w" : "42:1395w (42:1395w-21 Medicare Act (Eligibility, Election, and Enrollment))",
      "42:1396" : "42:1396 (DO NOT USE 42:1396 - Tort Negligence)",
      "42:1396a" : "42:1396a (42:1396a State Plans for Medical Assistance)",
      "42:1396b" : "42:1396b (42:1396b Medical Assist Prgm, Pmt to States/Medicaid Implem)",
      "42:13981" : "42:13981 (42:13981 Violence Against Women Act (Civil Rights))",
      "42:14135" : "42:14135 (42:14135 DNA Backlog Grant Program)",
      "42:1437" : "42:1437 (42:1437 U.S. Housing Act of 1937)",
      "42:1471" : "42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclo)",
      "42:1475" : "42:1475 (42:1475 Declaratory & Injunctive Relief - Foreclosure Procedures)",
      "42:1479" : "42:1479 (42:1479 Mortgage, lease, contract re farm housing)",
      "42:14901" : "42:14901 (42:14901 Intercountry Adoptions)",
      "42:15483" : "42:15483 (42:15483 Help America Vote Act)",
      "42:1651" : "42:1651 (42:1651 Defense Base Act)",
      "42:1705" : "42:1705 (42:1705 Receipt of Workmen's compensation benefits)",
      "42:1971" : "42:1971 (42:1971 Voting Rights Law)",
      "42:1973" : "42:1973 (42:1973 Voting Rights Act)",
      "42:1973(a)" : "42:1973(a) (42:1973(a) Enforcement of Voting Rights)",
      "42:1973(c)" : "42:1973(c) (42:1973(c) Voting Rights -Qualifications & Procedures)",
      "42:1973gg" : "42:1973gg (42:1973gg-2 Nat'l. Voter Registration Act of 1993 (NVRA))",
      "42:1981a" : "42:1981a (42:1981a Damages in cases of intentional discrim. in employment)",
      "42:1981cv" : "42:1981cv (42:1981cv Civil Rights)",
      "42:1981hs" : "42:1981hs (42:1981hs Housing Discrimination)",
      "42:1981jb" : "42:1981jb (42:1981jb Job Discrimination (Race))",
      "42:1981ra" : "42:1981ra (42:1981ra Race Discrimination)",
      "42:1981sx" : "42:1981sx (42:1981sx Sex Discrimination)",
      "42:1982hs" : "42:1982hs (42:1982hs Discrimination re property rights (housing))",
      "42:1982ra" : "42:1982ra (42:1982ra Discrimination re property rights (race))",
      "42:1982sx" : "42:1982sx (42:1982sx Discrimination re property rights (sex))",
      "42:1983bv" : "42:1983bv (42:1983bv Bivens Non-Prisoner)",
      "42:1983cv" : "42:1983cv (42:1983 Civil Rights Act - Civil Action for Deprivation of Rights)",
      "42:1983cvp" : "42:1983cvp (42:1983cvp Civil Rights (Personal Property))",
      "42:1983d" : "42:1983d (42:1983d Civil Rights (Death))",
      "42:1983dp" : "42:1983dp (42:1983dp Civil Right Denial of Due Process)",
      "42:1983ed" : "42:1983ed (42:1983ed Civil Rights (Employment Discrimination))",
      "42:1983pr" : "42:1983pr (42:1983pr Prisoner Civil Rights)",
      "42:1983vp" : "42:1983vp (42:1983vp Violation of Due Process and Equal Protection)",
      "42:1985" : "42:1985 (42:1985 Conspiracy to interfere with civil rights)",
      "42:1986" : "42:1986 (42:1986 Neglect of Duty)",
      "42:1987" : "42:1987 (42:1987 Prosecution of violations of certain laws (viol of sec 1990 or 5506 to 5516 or 5518 to 5532))",
      "42:1988" : "42:1988 (42:1988 Proceedings in Vindication of Civil Rights)",
      "42:1997" : "42:1997 (42:1997 Institutionalized Persons Act of 1980)",
      "42:2000a" : "42:2000a (42:2000a-3pa Discrimination, segregation; public accommodation - Injunctive Relief)",
      "42:2000ad" : "42:2000ad (42:2000ad Job Discrimination (Disability Act))",
      "42:2000ag" : "42:2000ag (42:2000 Job Discrimination (Age))",
      "42:2000bb" : "42:2000bb (42:2000bb Religious Freedom Restoration Act of 1993)",
      "42:2000bea" : "42:2000bea (42:2000bea Equal access to public facilities)",
      "42:2000c" : "42:2000c (42:2000c-6ed Discrimination in Education)",
      "42:2000cc" : "42:2000cc (42:2000cc Religious Land Use & Institutionalized Persons Act of 2000)",
      "42:2000d" : "42:2000d (42:2000d Federally Assisted Programs)",
      "42:2000e-2" : "42:2000e-2 (42:2000e-2 Job Discrimination)",
      "42:2000e-5" : "42:2000e-5 (42:2000e-5eeo Petition to Enforce EEOC Subpoena)",
      "42:2000pb" : "42:2000pb (42:2000 Job Discrimination (Public Accomodations))",
      "42:2000ra" : "42:2000ra (42:2000 Job Discrimination (Race))",
      "42:2000sx" : "42:2000sx (42:2000 Job Discrimination (Sex))",
      "42:2003" : "42:2003 (42:2003 Regulations of Indian Hospitals)",
      "42:2005" : "42:2005 (42:2005 Financial assistance to Indian tribes)",
      "42:2210" : "42:2210 (42:2210 Indeminification & Limitation of Liability-Financial)",
      "42:254o" : "42:254o (42:254o Breach of Scholarship Contract)",
      "42:256" : "42:256 (42:256 Public Health Services Act - Grants)",
      "42:2615" : "42:2615 (DO NOT USE 42:2616 Medical Recovery Act)",
      "42:2651" : "42:2651 (42:2651 Medical Care Recovery by US)",
      "42:292f" : "42:292f (42:292f Default of borrower)",
      "42:292k" : "42:292k (42:292k Student loan insurance (Public Health Occupations))",
      "42:293" : "42:293 (42:293 Recovery of losses from loan guarantee; public health)",
      "42:297" : "42:297 (42:297 Student loans; public or nonprofit school of nursing)",
      "42:2996" : "42:2996 (42:2996 Legal Services Corporation Act)",
      "42:300aa-1" : "42:300aa-1 (42:300aa-1 Nat'l. Childhood Vaccine Injury Compensation Act)",
      "42:300f" : "42:300f (42:300f Safe Drinking Water Act (Definitions))",
      "42:300g" : "42:300g (42:300g Actions re safety of public water systems (EPA))",
      "42:300g-3" : "42:300g-3 (42:300g-3 Enforcement of Drinking Water Regulations)",
      "42:3058(g)" : "42:3058(g) (42:3058(g) Older American's Act of 1965, 42 U.S.C. 3058(g) (State Long-term Care Ombudsman Prog)",
      "42:3121" : "42:3121 (42:3121 Public Works and Economic Development Act of 1965)",
      "42:3133" : "42:3133 (42:3133 Coordination - Grants for Public Works and Economic Development)",
      "42:3601" : "42:3601 (42:405 Fair Housing Act)",
      "42:3604(f)" : "42:3604(f) (42:3604(f)(3)(c) Fair Housing Amendments Act)",
      "42:3610" : "42:3610 (42:3610 Fair Housing Act-Administrative Enforcement; Preliminary Matters)",
      "42:3612" : "42:3612 (42:3612 Civil rights in housing - Enforcement by Secretary)",
      "42:3613" : "42:3613 (42:3613 Action for inj relief re deprivation of civil rights)",
      "42:4000" : "42:4000 (DO NOT USE 42:4000 National Flood Insurance Act)",
      "42:4001" : "42:4001 (42:4001 National Insurance Flood Act)",
      "42:4013" : "42:4013 (42:4013 National Flood Insurance Act - Nature and Limitation of Insurance Coverage)",
      "42:4053" : "42:4053 (42:4053 Breach of Insurance Contract)",
      "42:405id" : "42:405id (42:405id Review of HHS Decision (SSID))",
      "42:405rs" : "42:405rs (42:405rs Review of HHS Decision (RSI))",
      "42:4072" : "42:4072 (42:4072 Payment of Flood Insurance Claim)",
      "42:421(d)" : "42:421(d) (42:421(d) Review HHS decision re disability determinations)",
      "42:423" : "42:423 (42:423 Social Security Act (Disability Insurance Benefit Payments))",
      "42:4321" : "42:4321 (42:4321 Review of Agency Action-Environment (Declaration of Purpose))",
      "42:4332" : "42:4332 (42:4332 Environmental Policy - Cooperation of Agencies; Reports)",
      "42:4721" : "42:4721 (42:4721 Intergovernmental Personnel Act (findings and purposes))",
      "42:4821" : "42:4821 (42:4821 Lead-Based Paint Poisoning Prevention Act (findings and purposes))",
      "42:4901" : "42:4901 (42:4901 Noise Control Act of 1972 (findings and purposes))",
      "42:4910(c)" : "42:4910(c) (42:4910(c) Action to restrain violation re noise control)",
      "42:5101" : "42:5101 (42:5101 Child Abuse Prevention and Treatment Act)",
      "42:5303" : "42:5303 (42:5303 Block Grant Act of 1974 (42 USC 5301-5321))",
      "42:5401" : "42:5401 (42:5401 Natl Mnfactrd Housing Cnstr Safety Standard Act 1974 (findings and purposes))",
      "42:5411" : "42:5411 (42:5411 Housing Construction and Safety Standards Act - Injunctive Relief)",
      "42:5851" : "42:5851 (42:5851 Discrimination \"Whistle blower\" Employee - ERA (employee protection))",
      "42:601" : "42:601 (42:601 Title IV-A of Social Security Act (Grants to States for Aid/Assistance to Needy Families)",
      "42:602" : "42:602 (42:602 Temp. Assistance for Needy Families (TANF))",
      "42:6101" : "42:6101 (42:6101 Age Discrimination in Federally Assisted Programs (statement of purpose))",
      "42:6201" : "42:6201 (42:6201 Energy Policy & Conservation Act (statement of purpose))",
      "42:6393" : "42:6393 (42:6393 Controversies under Energy Policy & Conservation Act (Admin Procedure and Judicial Review))",
      "42:660" : "42:660 (42:660 Action to enforce child support obligations)",
      "42:6901en" : "42:6901en (42:6901 Environmental Cleanup Expenses (congressional findings))",
      "42:6901rs" : "42:6901rs (42:6901 Resource & Recovery Act (congressional findings))",
      "42:6928" : "42:6928 (42:6928 Violations of requirements of hazardous Waste Mgmt (federal enforcement))",
      "42:6961" : "42:6961 (42:6961 Federal Facilities Compliance Act)",
      "42:6972" : "42:6972 (42:6972 Resource & Recovery Act - Citizen Suit)",
      "42:6972(a)" : "42:6972(a) (42:6972(a) Solid Waste Disposal Act - Citizen Suit)",
      "42:7192" : "42:7192 (42:7192 Controversies under Dept of Energy Organization Act - Judicial Review)",
      "42:7384" : "42:7384 (42:7384 Energy Employees Occupational Illness Compensation Program Act (EEOICPA))",
      "42:7401" : "42:7401 (42:7401 Clean Air Act (findings & declarations))",
      "42:7412" : "42:7412 (42:7412 Air Pollution Control - emission standards)",
      "42:7413" : "42:7413 (42:7413(b) Clean Air Act)",
      "42:7413(b)" : "42:7413(b) (42:7413(b) Clean Air Act - Enforcement)",
      "42:7475" : "42:7475 (42:7475 Clean Air Act - Preconstruction Requirements)",
      "42:7545" : "42:7545 (42:7545 Air Pollution Prevention - Regulation of Fuels)",
      "42:7603" : "42:7603 (42:7603 Action for immediate restraint (Emergency Powers))",
      "42:7604" : "42:7604 (42:7604 Clean Air Act - Citizen suit to enforce Clean Air Act)",
      "42:7604(f)" : "42:7604(f) (42:7604(f)cl Clear Air Act - Emission Standards)",
      "42:7604cl" : "42:7604cl (42:7604 Clear Air Act (Emission Standards))",
      "42:7604ir" : "42:7604ir (42:7604 Petition to Quash IRS Summons)",
      "42:7671" : "42:7671 (42:7671 Clean Air Act (Stratospheric Ozone Protection) (Definitions))",
      "42:8324" : "42:8324 (42:8324 Powerplant and Industrial Fuel Use - terms and conditions)",
      "42:8351" : "42:8351 (42:8351 Powerplant and Industrial Fuel Use - Temporary Exemptions)",
      "42:9601" : "42:9601 (42:9601 Comprehensive Environmental Compen/Resp/Liab (CERCLA) (Definitions))",
      "42:9604" : "42:9604 (42:9604 Comprehensive Envir., Response, Comp. & Liab. Act (CERCLA)-Removal and Other Remedial Action)",
      "42:9607" : "42:9607 (42:9607 Real Property Tort to Land - Liability)",
      "42:9613" : "42:9613 (42:9613 Comp Environ Recovery Comp & Liability Act (CERCLA) - Civil Proceedings)",
      "43:1331" : "43:1331 (43:1331 Outer Continental Shelf Lands Act (Definitions))",
      "43:1333" : "43:1333 (43:1333 Outer Continental Shelf Lands Act - Laws and Regulations Governing Lands)",
      "43:1349" : "43:1349 (43:1349 Outer Continental Land Shelf Act - Citizen Suits)",
      "43:1701" : "43:1701 (43:1701 Violation of Federal Land Policy and Management Act (FLPMA))",
      "43:1737" : "43:1737 (43:1737 FLPMA - Implementation Provisions)",
      "43:421" : "43:421 (43:421 Complaint in Condemnation - Eminent Domain)",
      "43:945" : "43:945 (DO NOT USE 43:945 Compensation for Land Condemnation)",
      "43:945a" : "43:945a (43:945a Compensation for Land Condemnation)",
      "43:945b" : "43:945b (43:945b Complaint in Condemnation - Easements)",
      "43:946" : "43:946 (43:946 Complaint in Condemnation - Right of Way for Irrigation and Drainage Projects)",
      "44:2107" : "44:2107 (44:2107 Presidential Recordings & Materials Act(NARA acceptance of recs for historical preservation))",
      "45:0051" : "45:0051 (45:51 Railways: Fed. Employer's Liability Act)",
      "45:0151" : "45:0151 (45:151 Railway Labor Act (Definitions))",
      "45:0184" : "45:0184 (45:184 Action to Set Aside Award of a System Board)",
      "45:1105" : "45:1105 (45:1105 Northeast Rail Service Act - Judicial Review)",
      "45:1395" : "45:1395 (45:1395 Railroads: Adverse Reimbursement Review)",
      "45:152" : "45:152 (45:152 Railway Labor Act - General Duties)",
      "45:153" : "45:153 (45:153 First Railway Labor Act - National Railroad Adjustment Board)",
      "45:159" : "45:159 (45:159 Review of arbitration award (RR Carriers/Mediation Bd))",
      "45:231(f)" : "45:231(f) (45:231(f) Compel obedience to order of Railroad Retirement Bd)",
      "45:351" : "45:351 (45:351 Railroad Unemployment Insurance Act)",
      "45:56" : "45:56 (45:56 Employers Liability Act - Personal Inj re Railroads (bringing an action))",
      "45:719" : "45:719 (45:719 Regional Rail Reorganization Act of 1973 (judicial review))",
      "45:7457" : "45:7457 (DO NOT USE 45:7457 Compel Reclamation Under Clear Air Act)",
      "46:0688" : "46:0688 (46:688 Jones Act)",
      "46:0741" : "46:0741 (DO NOT USE 46:741 Shipping)",
      "46:0761" : "46:0761 (DO NOT USE 46:761 Shipping: Damages for Death on High Seas)",
      "46:1101" : "46:1101 (DO NOT USE 46:1101 Violation of Maritime Regulations)",
      "46:1156" : "46:1156 (DO NOT USE 46:1156 Administrative Procedure Act)",
      "46:2114" : "46:2114 (46:2114 Wrongful Discharge from Employment - protection from discrimination)",
      "46:30101" : "46:30101 (46:30101 Extension of jurisdiction to cases of damage or injury on land)",
      "46:30104" : "46:30104 (46:30104 Marine Personal Injury - Jones Act)",
      "46:30302" : "46:30302 (46:30302 Shipping: Damages for Death on High Seas)",
      "46:30304" : "46:30304 (46:30304 Breach of Maritime Contract - liability of noncompliance)",
      "46:30503" : "46:30503 (46:30503 Limitation of Liability - declaration of nature and value of goods)",
      "46:30504" : "46:30504 (46:30504 Limitation of Liability - loss by fire)",
      "46:30505" : "46:30505 (46:30505-30510 Exoneration, Limitation of Liability)",
      "46:30511" : "46:30511 (46:30511 Action by owner for limitation)",
      "46:30701" : "46:30701 (46:30701 Marine Cargo Loss or Damage - Liability of Water Carriers)",
      "46:30704" : "46:30704 (46:30704 Liability of Water Carriers - Loading, stowage, custody, care, and delivery)",
      "46:30902" : "46:30902 (46:30902 to 30911 Suits in Admiralty Act)",
      "46:31102" : "46:31102 (46:31102 Public Vessels Act - Waiver of Immunity)",
      "46:31301" : "46:31301 (46:31301 Federal Maritime Lien Act)",
      "46:31321" : "46:31321 (46:31321 Foreclosure of Preferred Ship Mortgages)",
      "46:31325" : "46:31325 (46:31325 Suit to enforce lien upon mortgaged vessel-foreclosure/Forecls of Prefer. Foreign Ship Mort)",
      "46:31341" : "46:31341 (46:31341 Federal Maritime Lien Act)",
      "46:31342" : "46:31342 (46:31342 Breach of Maritime Contract (establishing maritime liens))",
      "46:31343" : "46:31343 (46:31343 Commercial Instruments & Maritime Liens)",
      "46:40101" : "46:40101 (46:40101 Shipping Act of 1998)",
      "46:41102" : "46:41102 (46:41102(a) Shipping Act of 1984 - General Prohibitions)",
      "46:41309" : "46:41309 (46:41309 Shipping Act of 1984 - Enforcement of Reparation Orders)",
      "46:50101" : "46:50101 (46:50101 Violation of Maritime Regulations)",
      "46:58109" : "46:58109 (46:58109 Violation of Merchant Marine Act - Penalties)",
      "47:151" : "47:151 (47:151 Federal Communications Act of 1934)",
      "47:151cs" : "47:151cs (47:151cs Federal Communications Act - Collection for Services)",
      "47:201bt" : "47:201bt (47:201bt Breach of Tariff)",
      "47:203" : "47:203 (47:203 Telecommunications Collection of Charges)",
      "47:205" : "47:205 (47:205 Wire and Radio Communication Svc and Charges (Recovery of Damages))",
      "47:206" : "47:206 (47:206 Carrier's Liability for Damages)",
      "47:227" : "47:227 (47:227 FCC-Unsolicited Telephone Sales)",
      "47:227(b)" : "47:227(b) (47:227(b)(3) Telephone Consumer Protection Act of 1991)",
      "47:251" : "47:251 (47:251 Telecommunications Act of 1996 - Interconnection)",
      "47:252" : "47:252 (47:252 Telecommunications Act)",
      "47:254(h)" : "47:254(h) (47:254(h) Children's Internet Protection Act)",
      "47:332" : "47:332 (47:332 FCA-Wire or Radio Communications (Mobile Services))",
      "47:332(c)" : "47:332(c) (47:332(c) Federal Telecommunications Act of 1996)",
      "47:338" : "47:338 (47:338 Satellite Home Viewer Improvement Act)",
      "47:401" : "47:401 (47:401 Application of Federal Communication Comm for Inj. (Enforcement Provisions))",
      "47:407" : "47:407 (47:407 Order for payment of money; petition for enforcement;)",
      "47:510" : "47:510 (47:510 Forfeiture of Communications Devices)",
      "47:521" : "47:521 (47:521 Cable Televsn. Consumer Protection & Competition Act of 1992)",
      "47:532" : "47:532 (47:532 Cable Communication Policy Act of 1984)",
      "47:551" : "47:551 (47:551 Cable Communications Act)",
      "47:553" : "47:553 (47:553 U.S.C.A. Cable Communications Policy Act)",
      "47:605" : "47:605 (47:605 Unlawful Reception Broadcast Signal i.e., Satellite - Theft of Satellite Communications)",
      "48:0883" : "48:0883 (DO NOT USE 48:883 Violation of US Coastal Law)",
      "48:1985" : "48:1985 (DO NOT USE 48:1985 Conspiracy/Deprivation Civil Rights)",
      "49:0081" : "49:0081 (DO NOT USE 49:81 Damaged Goods While Being Transported)",
      "49:0781" : "49:0781 (DO NOT USE 49:781 Forfeiture)",
      "49:101" : "49:101 (49:101 ICC Termination Act of 1996)",
      "49:10101" : "49:10101 (49:10101 Interstate Commerce Act-Interstate Transportation Rail)",
      "49:10743" : "49:10743 (49:10743 Revised Interstate Commerce Act)",
      "49:11101" : "49:11101 (49:11101 Interstate Commerce Act)",
      "49:1113" : "49:1113 (49:1113 Petition to enforce administrative summon)",
      "49:1136" : "49:1136 (49:1136 Aviation Disaster Family Assistance Act of 1996)",
      "49:11501" : "49:11501 (49:11501 Railroad Revitalization & Regulatory Reform Act (General jurisdiction))",
      "49:11502" : "49:11502 (49:11502 Railroad Revitalization Regulatory Reform (authority to exempt rail carrier transportation))",
      "49:11503" : "49:11503 (DO NOT USE 49:11503 Railroad Revitalization Regulatory Reform)",
      "49:11701" : "49:11701 (49:11701 General authority of enforcement of regulations in rail)",
      "49:11702" : "49:11702 (49:11702 Enforcement by the Board)",
      "49:11705" : "49:11705 (49:11705 Limitation on actions by and against rail carriers)",
      "49:11706" : "49:11706 (49:11706 Carmack Amendent (Liability of carriers under receipts and bills of lading))",
      "49:11707" : "49:11707 (49:11707 Carmack Amendment (Liability when property is delivered in violation of routing instruction)",
      "49:13101" : "49:13101 (49:13101 Transportation Policy)",
      "49:13702" : "49:13702 (49:13702 Tariff requirement for certain transportation)",
      "49:13706" : "49:13706 (49:13706 Motor Carriers, etc-Liability for Payment of Rates)",
      "49:14501" : "49:14501 (49:14501 Preemption (federal authority of intrastate transportation))",
      "49:14705" : "49:14705 (49:14705 Interstate Commerce Act/Carmack Amendment (Limitations on actions by and against carriers))",
      "49:14706" : "49:14706 (49:14706 Carmack Amendment to the Interstate Commerce Act / Liability of Carriers - Receipts & Bill)",
      "49:1471" : "49:1471 (DO NOT USE 49:1471 Federal Aviation Act)",
      "49:1903" : "49:1903 (DO NOT USE 49:1903 Petition to enforce administrative summon)",
      "49:20301" : "49:20301 (49:20301-20306 Federal Safety Appliance Act)",
      "49:21302" : "49:21302 (49:21302 Carriers violations of Interstate Commerce Act (Chapter 201 accident and incident violation)",
      "49:30101" : "49:30101 (49:30101 National Traffic & Motor Vehicle Safety Act)",
      "49:30112" : "49:30112 (49:30112 Motor Vehicle Safety (prohibition on non-complying motor vehicles and equipment))",
      "49:30502" : "49:30502 (49:30502 Natl Motor Vehicle Title Information Syst)",
      "49:31114" : "49:31114 (49:31114 Access to Interstate System/Commercial Motor Vehicle)",
      "49:31502" : "49:31502 (49:31502 Motor Carrier Safety: Requirements for Qualifications)",
      "49:32101" : "49:32101 (49:32101 Motor Vehicle Information and Costs Savings Act)",
      "49:32701" : "49:32701 (49:32701 Odometer Requirements Act)",
      "49:40101" : "49:40101 (49:40101 Federal Aviation Act)",
      "49:40102" : "49:40102 (49:40102 Airline Deregulation Actv (definitions of air and commerce safety))",
      "49:40105" : "49:40105 (49:40105 Warsaw Convention)",
      "49:41705" : "49:41705 (49:41705 Air Carrier Access Act (discrimination against handicapped individuals))",
      "49:41713" : "49:41713 (49:41713 Airline Deregulation Actv (premp of authority over prices, routes, and service))",
      "49:44709" : "49:44709 (49:44709 Noise Control Act of 1972)",
      "49:44715" : "49:44715 (49:44715 Noise Control Act of 1972)",
      "49:46507" : "49:46507 (49:46507 False information and threats)",
      "49:47101" : "49:47101 (49:47101 Airport and Airway Improvement Act of 1982)",
      "49:47501" : "49:47501 (49:47501 Aviation Safety & Noise Abatement Act of 1979)",
      "49:49101" : "49:49101 (49:49101 Wrongful Termination in Contravention of Published Regulations)",
      "49:49104" : "49:49104 (49:49104 Breach of Lease by Metro. Wash. Airport Auth.)",
      "49:502" : "49:502 (49:502 Transportation Administrative Subpoena)",
      "49:60101" : "49:60101 (49:60101 Pipeline Safety Act of 1994)",
      "49:60102" : "49:60102 (49:60102 Hazardous Liquid Pipeline Safety Act of 1979 (HLPSA))",
      "49:80102" : "49:80102 (49:80102 Bills of Lading - Application)",
      "49:80302" : "49:80302 (49:80302 Contraband - Prohibitions)",
      "49:80303" : "49:80303 (49:80303 Seizure and forfeiture of vessel or aircraft conveying contraband)",
      "50:1701" : "50:1701 (50:1701-1706 International Emergency Economic Powers Act)",
      "50a:1" : "50a:1 (50a:1 Trading With the Enemy Act (act located in Title 50, Appendix.))",
      "50a:2412" : "50a:2412 (50a:2412 Export Administration Act--1979 (act located in Title 50, Appendix.))",
      "50a:501" : "50a:501 (50a:501 Sailors and Soldiers Civil Relief Act (act located in Title 50, Appendix.))",
      "50a:533" : "50a:533 (50a:533 Servicemembers Civil Relief Act-mortgages (act located in Title 50, Appendix.))",
      "50a:540" : "50a:540 (50a:540 Sailors and Soldiers Civil Relief Act (act located in Title 50, Appendix.))",
      "51:20137" : "51:20137 (51:20137(a) Malpractice & Negligence Against U.S. Space program)",
      "5:8316" : "5:8316 (DO NOT USE 5:8316 Claims agst US re Retirement for Federal Emp.)",
      "5:8470" : "5:8470 (DO NOT USE 5:8470 Enforcement of Judgment against Retirement Benefits)",
      "8:287" : "8:287 (DO NOT USE 8:287 Petition to Enforce INS Subpoena)",
      "99:9999" : "99:9999 (99:9999 Report cause code (DO NOT DELETE!) )",
      "adsup" : "adsup (Administrative Subpoena )",
      "contempt" : "contempt (Contempt Proceedings )",
      "disbar" : "disbar (Disbarment Proceedings )",
      "disp" : "disp (Disciplinary Proceeding )",
      "fordepo" : "fordepo (Foreign Deposition )",
      "misc" : "misc (Civil Miscellaneous Case)",
      "motcomp" : "motcomp (Motion to Compel )",
      "motcompf" : "motcompf (Motion to Compel - Fingerprints )",
      "motquash" : "motquash (Motion to Quash )",
      "motret" : "motret (Motion for Return of Property )",
      "petenf" : "petenf (Petition to Enforce IRS Summons )",
      "petper" : "petper (Petition to Perpetuate Testimony )",
      "regjgm" : "regjgm (Registration of Foreign Judgment )",
      "tranbkref" : "tranbkref (Transmission of Bankruptcy Reference )",
      "tranff" : "tranff (Transmission of Proposed Findings of Fact and Concl. of Law )",
      "writgar" : "writgar (Application for a Writ of Garnishment )"
   },
   "medce" : {
      "0" : "0 (No cause code entered)",
      "02:0431" : "02:0431 (02:431 Fed. Election Commission: Failure Enforce C)",
      "02:0437" : "02:0437 (02:437 Federal Election Commission)",
      "05:0075" : "05:0075 (05:75(2) Contract - Reduction in Grade)",
      "05:0551" : "05:0551 (05:551 Administrative Procedure Act)",
      "05:0552fi" : "05:0552fi (05:552 Freedom of Information Act)",
      "05:0552pa" : "05:0552pa (05:552 Right to Privacy Act)",
      "05:0554" : "05:0554 (05:0554 Constitutionality of Maritime Statutes)",
      "05:0701" : "05:0701 (05:0701 Maritime Subsidy Board)",
      "05:0702" : "05:0702 (05:702 Administrative Procedure Act)",
      "05:0704" : "05:0704 (05:704 Labor Litigation)",
      "05:7703" : "05:7703 (05:7703 Discrimination - Review of Agency Act)",
      "05:8470" : "05:8470 (05:8470 Enforcement of Judgment against Retirement Benefits)",
      "07:0006" : "07:0006 (7:6(b) Federal Commodity Exchange Regulation)",
      "07:0025" : "07:0025 (7:25 Fraud - Commodities Leverage Contracts)",
      "07:0181" : "07:0181 (07:181 Packers & Stockyard Act)",
      "07:0499" : "07:0499 (07:499 Agricultural Commodities Act)",
      "07:0601" : "07:0601 (07:601 USDA Condemnation)",
      "07:2321" : "07:2321 (07:2321 Plant Variety Protection Act)",
      "08:1105" : "08:1105 (8:1105(a) Aliens: Habeas Corpus to Release INS Det)",
      "08:1182" : "08:1182 (8:1182 Defend. Denial of Pla. Appl. for Alien Employment Cer)",
      "08:1252" : "08:1252 (08:1252(a)(2) Injunction for Deportation)",
      "08:1260" : "08:1260 (08:1260 Aliens: Access to Records)",
      "08:1324" : "08:1324 (08:1324 Aliens: Complaint for Forfeiture)",
      "08:1329" : "08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petiti)",
      "08:1446" : "08:1446 (8:1446 Petition for Naturalization Hearing)",
      "08:1451(j)" : "08:1451(j) (8:1451(j) Motion to Correct Order & Judg. of Naturalization)",
      "09:0001" : "09:0001 (09:1 U.S. Arbitration Act)",
      "09:0009" : "09:0009 (9:9 Motion to Confirm Arbitration Loan)",
      "09:0010" : "09:0010 (09:0010 Petition to Vacate Arbitration Award)",
      "10:1408" : "10:1408 (10:1408 Claim for Military Retirement)",
      "10:1552" : "10:1552 (10:1552 Armed Forces: Action to Correct Records)",
      "10:1553" : "10:1553 (10:1553 Armed Forces: FOIA General)",
      "10:2305" : "10:2305 (10:2305 Review of Federal Contract)",
      "11:0101" : "11:0101 (11:101 Bankruptcy)",
      "12:0022" : "12:0022 (12:22 Securities Fraud)",
      "12:0635" : "12:0635 (12:635 Breach of Insurance Contract)",
      "12:1461" : "12:1461 (12:1461 Homeowners Loan Act)",
      "12:1464" : "12:1464 (12:1464 Federal Savings and Loan)",
      "12:1703" : "12:1703 (12:1703 Default of HUD Loan)",
      "12:1725" : "12:1725 (12:1725 Collection under Contract Guaranty)",
      "12:1730" : "12:1730 (12:1730 Collection Under Contract Guaranty)",
      "12:1819" : "12:1819 (12:1819 Default of Promissory Note)",
      "12:1821" : "12:1821 (12:1821 Default of Loan by Promissary Note)",
      "12:191" : "12:191 (12:191 Bank Foreclosure)",
      "12:192" : "12:192 (12:192 Liquidation of National Bank)",
      "12:1971" : "12:1971 (12:1971 Relief under Bank Holding Act)",
      "12:1972" : "12:1972 (12:1972 Typing Arrangement Act)",
      "12:3410" : "12:3410 (12:3410 Right to Financial Privacy Act)",
      "15:0001" : "15:0001 (15:1 Antitrust Litigation)",
      "15:0002at" : "15:0002at (15:2 Antitrust Litigation)",
      "15:0002fl" : "15:0002fl (15:2(a) Fair Labor Standards Act)",
      "15:0005" : "15:0005 (15:5(a) Fair Labor Standards Act)",
      "15:0015" : "15:0015 (15:15 Antitrust Litigation)",
      "15:0025" : "15:0025 (15:25 Clayton Act)",
      "15:0044" : "15:0044 (15:44 Trademark Infringement)",
      "15:0045" : "15:0045 (15:0045 Federal Trade Commission Act)",
      "15:0052" : "15:0052 (15:0052 Federal Trade Commission Act)",
      "15:0053" : "15:0053 (15:0053 Federal Trade Commission Act)",
      "15:0077" : "15:0077 (15:77 Securities Fraud)",
      "15:0078" : "15:0078 (15:78m(a) Securities Exchange Act)",
      "15:0631" : "15:0631 (15:631 Small Business Act)",
      "15:0717" : "15:0717 (15:717 Natural Gas Act)",
      "15:0754" : "15:0754 (15:754 Emergency Petroleum Allocation-Admin.& Enforcement)",
      "15:1051" : "15:1051 (15:1051 Trademark Infringement)",
      "15:1114" : "15:1114 (15:1114 Trademark Infringement)",
      "15:1121" : "15:1121 (15:1121 Trademark Infringement)",
      "15:1125" : "15:1125 (15:1125 Trademark Infringement (Lanham Act))",
      "15:1126" : "15:1126 (15:1126 Patent Infringement)",
      "15:1127" : "15:1127 (15:1127 Trademark Infringement)",
      "15:1601" : "15:1601 (15:1601 Truth in Lending)",
      "15:1640" : "15:1640 (15:1640 Truth in Lending)",
      "15:1681" : "15:1681 (15:1681 Fair Credit Reporting Act)",
      "15:1692" : "15:1692 (15:1692 Fair Debt Collection Act)",
      "15:1938" : "15:1938 (15:1938 Fair Labor Standards Act)",
      "15:1981" : "15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))",
      "15:1988" : "15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))",
      "15:1989" : "15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))",
      "15:2301" : "15:2301 (15:2301 Magnuson-Moss Warranty Act)",
      "15:2801" : "15:2801 (15:2801 Petroleum Marketing Practices Act)",
      "15:53(b)" : "15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equita)",
      "16:0668" : "16:0668 (16:668 Bald Eagle Protection Act)",
      "16:0703" : "16:0703 (16:703 Migratory Bird Act)",
      "16:1538" : "16:1538 (16:1538 Endangered Species Act)",
      "16:3371" : "16:3371 (16:3371 Wildlife Under the Lacey Act)",
      "16:3372" : "16:3372 (16:3372 Conservation: Complaint for Forfeiture)",
      "16:3373" : "16:3373 (16:3373 Appeal of Decision - DOI)",
      "16:3374" : "16:3374 (16:3374 Conservation: Complaint for Forfeiture)",
      "17:0101" : "17:0101 (17:101 Copyright Infringement)",
      "17:0501" : "17:0501 (17:501 Copyright Infringement)",
      "17:0504" : "17:0504 (17:504 Copyright Infringement)",
      "18:0241" : "18:0241 (18:241 Conspiracy Against Citizen Rights)",
      "18:1836a" : "18:1836a (18:1836(a) Injunction against Misappropriation of Trade Secrets)",
      "18:1836b" : "18:1836b (18:1836(b) Civil Action to Protect Trade Secrets)",
      "18:1961" : "18:1961 (18:1961 Racketeering (RICO) Act)",
      "18:1962" : "18:1962 (18:1962 Racketeering (RICO) Act)",
      "18:1964" : "18:1964 (18:1964 Racketeering (RICO) Act)",
      "18:2511" : "18:2511 (18:2511 Wiretapping)",
      "18:3114" : "18:3114 (18:3114 Motion for Return of Seized Property)",
      "18:4208" : "18:4208 (18:4208(B) Agency Action Review)",
      "18:924" : "18:924 (18:924 Seizure, Forfeiture and Disposition of Firearm)",
      "19:1305" : "19:1305 (19:1305 Custom Duties:0Forfeiture-Immoral Articles)",
      "20:1080" : "20:1080 (20:1080 Student Loan Recovery)",
      "20:1400" : "20:1400 (20:1400 Civil Rights of Handicapped Child)",
      "20:1401" : "20:1401 (20:1401 Education: Handicapped Child Act)",
      "21:0841" : "21:0841 (21:841 Forfeiture Property-Drugs)",
      "21:0881" : "21:0881 (21:881 Forfeiture Property-Drugs)",
      "21:0881a" : "21:0881a (21:881 Forfeiture Property - Aircraft)",
      "21:0881re" : "21:0881re (21:881 Forfeiture Property - Real Estate)",
      "23:0134" : "23:0134 (23:134 P.I.- Auto Negligence)",
      "23:1441" : "23:1441 (23:1441 Contract Real Estate)",
      "24:1000" : "24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)",
      "25:0640" : "25:0640 (25:640 Indian Tribal Rights)",
      "25:1901" : "25:1901 (25:1901 Indian Child Welfare Act)",
      "26:6212" : "26:6212 (26:6212 Injunctive Relief from IRS Lien)",
      "26:6213" : "26:6213 (26:6213 Injunctive Relief from IRS Lien)",
      "26:6502" : "26:6502 (26:6502 IRS:Enforcement of tax liens)",
      "26:6532" : "26:6532 (26:6532 IRS: Refund of Tax Penalty)",
      "26:6702" : "26:6702 (26:6702 IRS: Refund of Income Tax Penalty)",
      "26:6703" : "26:6703 (26:6703 IRS: Refund of Tax Penalty)",
      "26:7401" : "26:7401 (26:7401 IRS: Tax Liability)",
      "26:7402" : "26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)",
      "26:7403" : "26:7403 (26:7403 Suit to Enforce Federal Tax Lien)",
      "26:7422rt" : "26:7422rt (26:7422 IRS: Refund Taxes)",
      "26:7422rx" : "26:7422rx (26:7422 IRS: Refund Excise Tax)",
      "26:7426" : "26:7426 (26:7426 IRS: Wrongful Levy for Taxes)",
      "26:7429" : "26:7429 (26:7429 IRS: Tax Jeopardy Assessment)",
      "26:7609" : "26:7609 (26:7609 IRS: Petition to Quash IRS Summons)",
      "27:0185" : "27:0185 (27:185 Enforcement of Arbitration Award)",
      "28:0157c" : "28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)",
      "28:0157d" : "28:0157d (28:0157 Motion for Withdrawal of Reference)",
      "28:0158" : "28:0158 (28:0158 Notice of Appeal re Bankruptcy Matter (BA)",
      "28:0185" : "28:0185 (28:185 Suit to Compel Arbitration)",
      "28:0451" : "28:0451 (28:451 Employment Discrimination)",
      "28:0754" : "28:0754 (28:754 Receiver of Property in Different Districts)",
      "28:0794" : "28:0794 (28:794 Rehabilitation Act)",
      "28:1001" : "28:1001 (28:1001 E.R.I.S.A.)",
      "28:1132" : "28:1132 (28:1132 E.R.I.S.A.)",
      "28:1330" : "28:1330 (28:1330 Breach of Contract)",
      "28:1331" : "28:1331 (28:1331 Fed. Question)",
      "28:1331al" : "28:1331al (28:1331 Fed. Question: Airline Crash)",
      "28:1331at" : "28:1331at (28:1331 Fed. Question: Anti-trust)",
      "28:1331au" : "28:1331au (28:1331 Fed. Question: Auto Negligence)",
      "28:1331b" : "28:1331b (28:1331 Federal Question: Bivens Act)",
      "28:1331bc" : "28:1331bc (28:1331 Fed. Question: Breach of Contract)",
      "28:1331ca" : "28:1331ca (28:1331 Fed Question: Fed Communications Act of 1)",
      "28:1331cm" : "28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)",
      "28:1331cv" : "28:1331cv (28:1331 Federal Question: Other Civil Rights)",
      "28:1331ed" : "28:1331ed (28:1331 Fed. Question: Employment Discrimination)",
      "28:1331ej" : "28:1331ej (28:1331 Federal Question: Enforcement of Judgment)",
      "28:1331es" : "28:1331es (28:1331 Enforcement of Administrative Subpoena)",
      "28:1331fl" : "28:1331fl (28:1331 Fed. Question: Fair Labor Standards)",
      "28:1331in" : "28:1331in (28:1331 Fed. Question: Insurance Contract)",
      "28:1331mm" : "28:1331mm (28:1331 Fed. Question: Medical Malpractice)",
      "28:1331ng" : "28:1331ng (28:1331 Fed. Question: Natural Gas Act)",
      "28:1331pi" : "28:1331pi (28:1331 Fed. Question: Personal Injury)",
      "28:1331rd" : "28:1331rd (28:1331 Fed. Question: Review Agency Decision)",
      "28:1331rp" : "28:1331rp (28:1331(a) Fed. Question: Real Property)",
      "28:1331rr" : "28:1331rr (28:1331 Fed. Question: Railway Labor Act)",
      "28:1331sv" : "28:1331sv (28:1331 Fed. Question: Securities Violation)",
      "28:1331tr" : "28:1331tr (28:1331 Fed. Question: Trademark)",
      "28:1331tt" : "28:1331tt (28:1331 Fed. Question: Tort Action)",
      "28:1331v" : "28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendme)",
      "28:1331wl" : "28:1331wl (28:1331 Federal Question: EPA Waste Lien)",
      "28:1331wt" : "28:1331wt (28:1331 Fed. Question: Water Rights)",
      "28:1332ac" : "28:1332ac (28:1332 Diversity-Account Receivable)",
      "28:1332al" : "28:1332al (28:1332 Diversity-Airline Crash)",
      "28:1332as" : "28:1332as (28:1332 Diversity-Asbestos Litigation)",
      "28:1332au" : "28:1332au (28:1332 Diversity-Auto Negligence)",
      "28:1332bc" : "28:1332bc (28:1332 Diversity-Breach of Contract)",
      "28:1332co" : "28:1332co (28:1332 Diversity-Conversion)",
      "28:1332ct" : "28:1332ct (28:1332 Diversity-(Citizenship))",
      "28:1332det" : "28:1332det (28:1332 Diversity: Forcible Detainer)",
      "28:1332df" : "28:1332df (28:1332 Diversity-Contract Default)",
      "28:1332ds" : "28:1332ds (28:1332 Diversity-Contract Dispute)",
      "28:1332ed" : "28:1332ed (28:1332 Diversity-Employment Discrimination)",
      "28:1332fd" : "28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)",
      "28:1332fr" : "28:1332fr (28:1332 Diversity-Fraud)",
      "28:1332ia" : "28:1332ia (28:1332 Diversity-Interpleader Action)",
      "28:1332ij" : "28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)",
      "28:1332in" : "28:1332in (28:1332 Diversity-Insurance Contract)",
      "28:1332jd" : "28:1332jd (28:1332 Diversity-Declaratory Judgment)",
      "28:1332lb" : "28:1332lb (28:1332 Diversity-Libel,Assault,Slander)",
      "28:1332lm" : "28:1332lm (28:1332 Diversity - Legal Malpractice)",
      "28:1332ma" : "28:1332ma (28:1332 Diversity-Miller Act)",
      "28:1332mm" : "28:1332mm (28:1332 Diversity-Medical Malpractice)",
      "28:1332mv" : "28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)",
      "28:1332ni" : "28:1332ni (28:1332 Diversity-Negotiable Instrument)",
      "28:1332nm" : "28:1332nm (28:1332 Diversity-Non-Motor Vehicle)",
      "28:1332nr" : "28:1332nr (28:1332 Diversity-Notice of Removal)",
      "28:1332oc" : "28:1332oc (28:1332 Diversity-Other Contract)",
      "28:1332pd" : "28:1332pd (28:1332 Diversity-Property Damage)",
      "28:1332pi" : "28:1332pi (28:1332 Diversity-Personal Injury)",
      "28:1332pl" : "28:1332pl (28:1332 Diversity-Product Liability)",
      "28:1332pr" : "28:1332pr (28:1332 Diversity-Petition for Removal)",
      "28:1332qt" : "28:1332qt (28:1332 Diversity-Petition to Quiet Title)",
      "28:1332ri" : "28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)",
      "28:1332sa" : "28:1332sa (28:1332 - Diversity: Securities & Exchange Commiss)",
      "28:1332sf" : "28:1332sf (28:1332 - Diversity: Securities Fraud)",
      "28:1332ss" : "28:1332ss (28:1332 Diversity - Stockholders Suits)",
      "28:1332tl" : "28:1332tl (28:1332 Diversity-Torts to Land)",
      "28:1332tm" : "28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))",
      "28:1332tn" : "28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)",
      "28:1332wd" : "28:1332wd (28:1332 Diversity-Wrongful Death)",
      "28:1333" : "28:1333 (28:1333 Admiralty)",
      "28:1334" : "28:1334 (28:1334 Bankruptcy Appeal)",
      "28:1334c" : "28:1334c (28:1334(c) R&R re motions for abstention (non-cor)",
      "28:1335" : "28:1335 (28:1335 Interpleader Action)",
      "28:1337" : "28:1337 (28:1337 Sherman-Clayton Act)",
      "28:1338cp" : "28:1338cp (28:1338 Copyright Infringement)",
      "28:1338pt" : "28:1338pt (28:1338 Patent Infringement)",
      "28:1338tr" : "28:1338tr (28:1338 Trademark Infringement)",
      "28:1340" : "28:1340 (28:1340 IRS: Custom Duties)",
      "28:1340er" : "28:1340er (28:1340 Recovery of Erroneous Refund)",
      "28:1341" : "28:1341 (28:1341 Complaint for Forfeiture)",
      "28:1343" : "28:1343 (28:1343 Violation of Civil Rights)",
      "28:1345" : "28:1345 (28:1345 USA Plaintiff)",
      "28:1345co" : "28:1345co (28:1345 Replevin & Conversion)",
      "28:1345db" : "28:1345db (28:1345 Debt to US - FHA/HUD Title I)",
      "28:1345df" : "28:1345df (28:1345 Default of Promissory Note)",
      "28:1345er" : "28:1345er (28:1345 Recovery of Erroneous Refund)",
      "28:1345fc" : "28:1345fc (28:1345 Foreclosure)",
      "28:1345ff" : "28:1345ff (28:1345 Complaint for Forfeiture)",
      "28:1345hl" : "28:1345hl (28:1345 VA Home Loan Guaranty Debt)",
      "28:1345mc" : "28:1345mc (28:1345 Medical Care Recovery)",
      "28:1345mi" : "28:1345mi (28:1345 Mining Claim Ejectment)",
      "28:1345pd" : "28:1345pd (28:1345 Property Damage)",
      "28:1345pe" : "28:1345pe (28:1345 Property Ejectment)",
      "28:1345rc" : "28:1345rc (28:1345 Recovery of Debt to US)",
      "28:1345st" : "28:1345st (28:1345 Default of Student Loan)",
      "28:1345tp" : "28:1345tp (28:1345 Trespass on Public Land)",
      "28:1345va" : "28:1345va (28:1345 Recovery of VA Overpayment)",
      "28:1346bc" : "28:1346bc (28:1346 Breach of Contract)",
      "28:1346rc" : "28:1346rc (28:1346 Recovery of IRS Tax)",
      "28:1346tc" : "28:1346tc (28:1346 Tort Claim)",
      "28:1346wd" : "28:1346wd (28:1346 Wrongful Death)",
      "28:1349" : "28:1349 (28:1348 Corporation organized under Federal Law as party)",
      "28:1352" : "28:1352 (28:1352 Miller Act)",
      "28:1355" : "28:1355 (28:1355 Petition for Return of Property)",
      "28:1358" : "28:1358 (28:1358 Land Condemnation)",
      "28:1361" : "28:1361 (28:1361 Petition for Writ of Mandamus)",
      "28:1362ic" : "28:1362ic (28:1362 Indian Tribal Controversy)",
      "28:1362iw" : "28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)",
      "28:1364" : "28:1364 (28:1364 Auto Negligence)",
      "28:1391" : "28:1391 (28:1391 Personal Injury)",
      "28:1402" : "28:1402 (28:1402 Medical Malpractice)",
      "28:1407" : "28:1407 (28:1407 Airline Crash)",
      "28:1441ac" : "28:1441ac (28:1441 Petition for Removal- Account Receivable)",
      "28:1441al" : "28:1441al (28:1441 Petition for Removal- Airline Crash)",
      "28:1441as" : "28:1441as (28:1441 Petition for Removal- Asbestos Litigation)",
      "28:1441au" : "28:1441au (28:1441 Petition for Removal- Auto Negligence)",
      "28:1441bc" : "28:1441bc (28:1441 Petition for Removal- Breach of Contract)",
      "28:1441cv" : "28:1441cv (28:1441 Petition for Removal- Civil Rights Act)",
      "28:1441df" : "28:1441df (28:1441 Petition for Removal- Contract Default)",
      "28:1441dj" : "28:1441dj (28:1441 Petition for Removal- Declaratory Judgment)",
      "28:1441ds" : "28:1441ds (28:1441 Petition for Removal- Contract Dispute)",
      "28:1441ed" : "28:1441ed (28:1441 Petition for Removal - Employment Discrim)",
      "28:1441fc" : "28:1441fc (28:1441 Petition for Removal - Fair Credit Reporti)",
      "28:1441fr" : "28:1441fr (28:1441 Petition for Removal- Fraud)",
      "28:1441ij" : "28:1441ij (28:1441 Petition for Removal- Injunctive/Declarato)",
      "28:1441in" : "28:1441in (28:1441 Petition for Removal- Insurance Contract)",
      "28:1441int" : "28:1441int (28:1441 Petition for Removal- Action for Interplea)",
      "28:1441lb" : "28:1441lb (28:1441 Petition for Removal Libel,Assault,Slander)",
      "28:1441lm" : "28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relatio)",
      "28:1441mm" : "28:1441mm (28:1441 Petition for Removal- Medical Malpractice)",
      "28:1441ni" : "28:1441ni (28:1441 Petition for Removal- Negotiable Instrumen)",
      "28:1441nm" : "28:1441nm (28:1441 Petition for Removal- Non-Motor Vehicle)",
      "28:1441nr" : "28:1441nr (28:1441 Notice of Removal)",
      "28:1441oc" : "28:1441oc (28:1441 Petition For Removal--Other Contract)",
      "28:1441pd" : "28:1441pd (28:1441 Petition for Removal- Property Damage)",
      "28:1441pi" : "28:1441pi (28:1441 Petition for Removal- Personal Injury)",
      "28:1441pl" : "28:1441pl (28:1441 Petition for Removal- Product Liability)",
      "28:1441pr" : "28:1441pr (28:1441 Petition for Removal)",
      "28:1441qt" : "28:1441qt (28:1441 Petition for Removal- Petition to Quiet Ti)",
      "28:1441ri" : "28:1441ri (28:1441 Petition for Removal- Racketeering (RICO))",
      "28:1441sa" : "28:1441sa (28:1441 - Petition for Removal: SEC Act)",
      "28:1441sf" : "28:1441sf (28:1441 - Petition for Removal: Securities Fraud)",
      "28:1441tl" : "28:1441tl (28:1441 Petition for Removal- Torts to Land)",
      "28:1441tm" : "28:1441tm (28:1441 Petition for Removal- Tort/Motor Vehicle ()",
      "28:1441tn" : "28:1441tn (28:1441 Petition for Removal- Tort/Non-Motor Vehic)",
      "28:1441wd" : "28:1441wd (28:1441 Petition for Removal- Wrongful Death)",
      "28:1442bc" : "28:1442bc (28:1442 Petition for Removal- Breach of Contract)",
      "28:1442nr" : "28:1442nr (28:1442 Notice of Removal)",
      "28:1442pr" : "28:1442pr (28:1442 Petition for Removal)",
      "28:1443" : "28:1443 (28:1443(1) Rent, Lease & Ejectment)",
      "28:1444" : "28:1444 (28:1444 Petition for Removal- Foreclosure)",
      "28:1446in" : "28:1446in (28:1446 Breach of Contract- Insurance)",
      "28:1446nr" : "28:1446nr (28:1446 Notice of Removal)",
      "28:1446pd" : "28:1446pd (28:1446 Petition for Removal- Property Damage (P.I)",
      "28:1446pi" : "28:1446pi (28:1446 Petition for Removal- Personal Injury)",
      "28:1446pl" : "28:1446pl (28:1446pl Petition for Removal - Product Liability)",
      "28:1446pr" : "28:1446pr (28:1446 Petition for Removal)",
      "28:1452" : "28:1452 (28:1452 R&R re motions to remand (non-core))",
      "28:1651" : "28:1651 (28:1651 Petition for Writ of Coram Nobis)",
      "28:1651hc" : "28:1651hc (28:1651 Petition for Writ of Habeas Corpus)",
      "28:1651mn" : "28:1651mn (28:1651 Petition for Writ of Mandamus)",
      "28:1782" : "28:1782 (28:1782 Letter rogatory - appointment)",
      "28:1983" : "28:1983 (28:1983 Civil Rights)",
      "28:2201" : "28:2201 (28:2201 Constitutionality of State Statute(s))",
      "28:2201dj" : "28:2201dj (28:2201 Declaratory Judgment)",
      "28:2201ij" : "28:2201ij (28:2201 Injunction)",
      "28:2201in" : "28:2201in (28:2201 Declaratory Judgment (Insurance))",
      "28:2241" : "28:2241 (28:2241 Petition for Writ of Habeas Corpus (federa)",
      "28:2254" : "28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))",
      "28:2254se" : "28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)",
      "28:2255" : "28:2255 (28:2255 Motion to Vacate / Correct Illegal Sentenc)",
      "28:2271" : "28:2271 (28:2271 Federal Tort Claims Act)",
      "28:2345" : "28:2345 (28:2345 Medicare Recovery)",
      "28:2409" : "28:2409 (28:2409(a) Quiet Title Action)",
      "28:2410" : "28:2410 (28:2410 Quiet Title)",
      "28:2671" : "28:2671 (28:2671 Federal Tort Claims Act)",
      "28:2674" : "28:2674 (28:2674 Federal Tort Claims Act)",
      "28:3001" : "28:3001 (28:3001 Federal Debt Collection Act)",
      "28:7402" : "28:7402 (28:7402 Refund of Taxes)",
      "28:7422" : "28:7422 (28:7422 Appeal from Administrative Decision)",
      "29:0151" : "29:0151 (29:151 Labor: Review of Agency Action)",
      "29:0160" : "29:0160 (29:160(1) National Labor Relations Act)",
      "29:0184" : "29:0184 (29:184 Violation Collection Bargain Agreement)",
      "29:0185ep" : "29:0185ep (29:185 Employee Pension Plan)",
      "29:0185lm" : "29:0185lm (29:185 Labor/Mgt. Relations (Contracts))",
      "29:0201do" : "29:0201do (29:201 Denial of Overtime Compensation)",
      "29:0201fl" : "29:0201fl (29:201 Fair Labor Standards Act)",
      "29:0203" : "29:0203 (29:203 Equal Pay Act)",
      "29:0206" : "29:0206 (29:206 Collect Unpaid Wages)",
      "29:0401" : "29:0401 (29:0401 Labor Management Disclosure Act)",
      "29:0621" : "29:0621 (29:621 Job Discrimination (Age))",
      "29:0623" : "29:0623 (29:623 Job Discrimination (Age))",
      "29:0626" : "29:0626 (29:626 Job Discrimination (Age))",
      "29:0633" : "29:0633 (29:633 Job Discrimination (Age))",
      "29:0651" : "29:0651 (29:651 Occupational Safety/Health)",
      "29:0754" : "29:0754 (29:754 Discrimination)",
      "29:0791" : "29:0791 (29:791 Job Discrimination (Rehabilitation Act))",
      "29:0794" : "29:0794 (29:0794 Job Discrimination (Handicap))",
      "29:1001" : "29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)",
      "29:1002" : "29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)",
      "29:1104" : "29:1104 (29:1104 Recovery of Benefits to Employee)",
      "29:1109" : "29:1109 (29:1109 Breach of Fiduciary Duties)",
      "29:1131" : "29:1131 (29:1131 ERISA - Collection of Delinquent Trust Fun)",
      "29:1132" : "29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)",
      "29:1145" : "29:1145 (29:1145 E.R.I.S.A.)",
      "29:1149" : "29:1149 (29:1149 Recover Pension & Profit Sharing)",
      "29:1337" : "29:1337 (29:1337 E.R.I.S.A.)",
      "29:1362" : "29:1362 (29:1362 ERISA)",
      "29:1381" : "29:1381 (29:1381 E.R.I.S.A.)",
      "29:1401" : "29:1401 (29:1401(b)(2) Appeal of Arbitration Award)",
      "29:1451" : "29:1451 (29:1451 E.R.I.S.A.)",
      "29:1801" : "29:1801 (29:1801 Farmworker Rights)",
      "29:2615" : "29:2615 (29:2615 Family and Medical Leave Act)",
      "29:790" : "29:790 (29:790 Rehabilitation of Labor)",
      "30:0181" : "30:0181 (30:181 Environment: Review of Agency Action)",
      "30:0801" : "30:0801 (30:0801 Penalities/Federal Mine Safety Health Act)",
      "30:1201" : "30:1201 (30:1201 Environment: Review of Agency Action)",
      "30:1202" : "30:1202 (30:1202 Mining Reclamation Act)",
      "30:1276" : "30:1276 (30:1276 Interior: Review of Agency Action)",
      "31:3545" : "31:3545 (31:3545 Action to Recovery Money)",
      "31:3729" : "31:3729 (31:3729 False Claims Act)",
      "31:3730" : "31:3730 (31:3730 Qui Tam False Claims Act)",
      "31:3731" : "31:3731 (31:3731 Fraud)",
      "33:1319cw" : "33:1319cw (33:1319 Clean Water Act)",
      "33:1319pv" : "33:1319pv (33:1319 Pollutants & Permit Violations)",
      "33:1365" : "33:1365 (33:1365 Environmental Matters)",
      "35:0145" : "35:0145 (35:145 Patent Infringement)",
      "35:0183" : "35:0183 (35:183 Patent Infringement)",
      "35:0271" : "35:0271 (35:271 Patent Infringement)",
      "38:1681" : "38:1681 (38:1681 Recovery of VA Overpayment)",
      "38:1686" : "38:1686 (38:1686 Recovery of VA Overpayment)",
      "38:1780" : "38:1780 (38:1780 Recovery of VA Overpayment)",
      "38:2011" : "38:2011 (38:2011 - Veteran's Readjustment Assistance Act of)",
      "38:2021" : "38:2021 (Right to re-employment of inducted persons)",
      "38:3116" : "38:3116 (38:3116 VA Overpayment)",
      "38:775" : "38:775 (Recovery of Servicemen's Group Life Insurance)",
      "39:3005" : "39:3005 (39:3005 Detention of Mail for Temporary Periods)",
      "39:409" : "39:409 (39:409 Postal Service)",
      "40:0258" : "40:0258 (40:258(a) Public Buildings & Property: Land Condem)",
      "40:0875" : "40:0875 (40:875 Public Buildings & Property: Negligence)",
      "40:3131" : "40:3131 (40:3131 Miller Act)",
      "41:0251" : "41:0251 (41:251 Public Contracts-Review of Agency Action)",
      "41:1463" : "41:1463 (41:1463 Public Contracts: Unlawful Employment Prac)",
      "42:0205" : "42:0205 (42:205 Denial Social Security Benefits)",
      "42:0206" : "42:0206 (42:206 Social Security Benefits)",
      "42:0247" : "42:0247 (42:247 Personal Injury-Swine Flu)",
      "42:0402" : "42:0402 (42:402 Social Security Benefits)",
      "42:0405id" : "42:0405id (42:405 Review of HHS Decision (SSID))",
      "42:0405wc" : "42:0405wc (42:405 Review of HHS Decision (DIWC))",
      "42:0405ww" : "42:0405ww (42:405 Review of HHS Decision (DIWW))",
      "42:0416" : "42:0416 (42:416 Denial of Social Security Benefits)",
      "42:0427" : "42:0427 (42:427 Social Security Benefits)",
      "42:11601" : "42:11601 (42:11601 International Child Abduction Remedies Act (Hague))",
      "42:12101" : "42:12101 (42:12101 American Disabilities Act)",
      "42:1383" : "42:1383 (42:1383 Review of HHS Decision)",
      "42:1395" : "42:1395 (42:1395 HHS: Adverse Reimbursement Review)",
      "42:1396" : "42:1396 (42:1396 - Tort Negligence)",
      "42:1471" : "42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclo)",
      "42:1981cv" : "42:1981cv (42:1981 Civil Rights)",
      "42:1981hs" : "42:1981hs (42:1981 Housing Discrimination)",
      "42:1981jb" : "42:1981jb (42:1981 Job Discrimination (Race))",
      "42:1981sx" : "42:1981sx (42:1981 Sex Discrimination)",
      "42:1983cv" : "42:1983cv (42:1983 Civil Rights Act)",
      "42:1983ed" : "42:1983ed (42:1983 Civil Rights (Employment Discrimination))",
      "42:1983pr" : "42:1983pr (42:1983 Prisoner Civil Rights)",
      "42:1986" : "42:1986 (42:1986 Neglect of Duty)",
      "42:2000ag" : "42:2000ag (42:2000 Job Discrimination (Age))",
      "42:2000e" : "42:2000e (42:2000e Job Discrimination (Employment))",
      "42:2000pb" : "42:2000pb (42:2000 Job Discrimination (Public Accomodations))",
      "42:2000ra" : "42:2000ra (42:2000 Job Discrimination (Race))",
      "42:2000sx" : "42:2000sx (42:2000 Job Discrimination (Sex))",
      "42:2003" : "42:2003 (42:2003 Job Discrimination)",
      "42:2005" : "42:2005 (42:2005 Review of Agency Action-HHS)",
      "42:2615" : "42:2615 (42:2616 Medical Recovery Act)",
      "42:2651" : "42:2651 (42:2651 Medical Care Recovery)",
      "42:3601" : "42:3601 (42:405 Fair Housing Act)",
      "42:4000" : "42:4000 (42:4000 National Flood Insurance Act)",
      "42:4001" : "42:4001 (42:4001 National Insurance Flood Act)",
      "42:4053" : "42:4053 (42:4053 Breach of Insurance Contract)",
      "42:4072" : "42:4072 (42:4072 Payment of Flood Insurance Claim)",
      "42:4321" : "42:4321 (42:4321 Review of Agency Action-Environment)",
      "42:4332" : "42:4332 (42:4332 Environmental Policy - Coop of Agency Repo)",
      "42:6901en" : "42:6901en (42:6901 Environmental Cleanup Expenses)",
      "42:6901rs" : "42:6901rs (42:6901 Resource & Recovery Act)",
      "42:7413" : "42:7413 (42:7413(b) Clean Air Act)",
      "42:7604cl" : "42:7604cl (42:7604 Clear Air Act (Emission Standards))",
      "42:7604ir" : "42:7604ir (42:7604 Petition to Quash IRS Summons)",
      "42:9607" : "42:9607 (42:9607 Real Property Tort to Land)",
      "43:945" : "43:945 (43:945 Compensation for Land Condemnation)",
      "43:945a" : "43:945a (43:945a Complaint in Condemnation)",
      "43:946" : "43:946 (43:946 Complaint in Condemnation - Eminent Domain)",
      "45:0051" : "45:0051 (45:51 Railways: Fed. Employer's Liability Act)",
      "45:0151" : "45:0151 (45:151 Railway Labor Act)",
      "45:0184" : "45:0184 (45:184 Action to Set Aside Award of a System Board)",
      "45:1395" : "45:1395 (45:1395 Railroads: Adverse Reimbursement Review)",
      "45:7457" : "45:7457 (45:7457 Compel Reclamation Under Clear Air Act)",
      "46:0688" : "46:0688 (46:688 Jones Act)",
      "46:0741" : "46:0741 (46:741 Shipping)",
      "46:0761" : "46:0761 (46:761 Shipping: Damages for Death on High Seas)",
      "46:1101" : "46:1101 (46:1101 Violation of Maritime Regulations)",
      "46:1156" : "46:1156 (46:1156 Administrative Procedure Act)",
      "46:31325" : "46:31325 (46:31325 Preferred Mortgage Lien on Vessel)",
      "48:0883" : "48:0883 (48:883 Violation of US Coastal Law)",
      "48:1985" : "48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)",
      "49:0081" : "49:0081 (49:81 Damaged Goods While Being Transported)",
      "49:0781" : "49:0781 (49:781 Forfeiture)",
      "49:11503" : "49:11503 (49:11503 Railroad Revitalization Regulatory Reform)",
      "49:11702" : "49:11702 (49:11702(a)(4) Violations of Interstate Commerce A)",
      "49:1471" : "49:1471 (49:1471 Federal Aviation Act)",
      "49:1903" : "49:1903 (49:1903 Petition to enforce administrative summon)",
      "8:287" : "8:287 (8:287 Petition to Enforce INS Subpoena)",
      "99:9999" : "99:9999 (99:9999 Report cause code (DO NOT DELETE!))",
      "adsup" : "adsup (Administrative Subpoena)",
      "certjgmreg" : "certjgmreg (Certificate of Judgment for Registration in Other District)",
      "contempt" : "contempt (Contempt Proceedings)",
      "disbar" : "disbar (Disbarment Proceedings)",
      "expartdisc" : "expartdisc (Ex Parte order to disclose returns and return information)",
      "fordepo" : "fordepo (Foreign Deposition)",
      "mappstlmt" : "mappstlmt (Motion for Approval of Settlement)",
      "mdisclhrg" : "mdisclhrg (Motion for Disclosure Hearing)",
      "misc" : "misc (Civil Miscellaneous Case)",
      "miscgjm" : "miscgjm (Miscellaneous Grand Jury Matters)",
      "miscmtn" : "miscmtn (Miscellaneous Motions)",
      "motcomp" : "motcomp (Motion to Compel)",
      "motquash" : "motquash (Motion to Quash)",
      "motret" : "motret (Motion for Return of Property)",
      "mtnapptCJA" : "mtnapptCJA (Motion for Appointment of Counsel)",
      "penreg" : "penreg (Pen Register)",
      "petenf" : "petenf (Petition to Enforce IRS Summons)",
      "petper" : "petper (Petition to Perpetuate Testimony)",
      "petwrit" : "petwrit (Petition for Writ)",
      "petwritmnd" : "petwritmnd (Petition for Writ of Mandamus)",
      "regjgm" : "regjgm (Registration of Foreign Judgment)",
      "repdisclgj" : "repdisclgj (Report/Disclosure of Grand Jury Matters)",
      "seizwarr" : "seizwarr (Seizure Warrant)",
      "tranbkref" : "tranbkref (Transmission of Bankruptcy Reference)",
      "tranff" : "tranff (Transmission of Proposed Findings of Fact and Concl. of Law)",
      "transjuris" : "transjuris (Transfer of Jurisdiction)",
      "writgar" : "writgar (Application for a Writ of Garnishment)"
   },
   "miedce" : {
      "0" : "0 (No cause code entered)",
      "02:0431" : "02:0431 (02:431 Fed. Election Commission: Failure Enforce C)",
      "02:0437" : "02:0437 (02:437 Federal Election Commission)",
      "05:0075" : "05:0075 (05:75(2) Contract - Reduction in Grade)",
      "05:0551" : "05:0551 (05:551 Administrative Procedure Act)",
      "05:0552fi" : "05:0552fi (05:552 Freedom of Information Act)",
      "05:0552pa" : "05:0552pa (05:552 Right to Privacy Act)",
      "05:0554" : "05:0554 (05:0554 Constitutionality of Maritime Statutes)",
      "05:0701" : "05:0701 (05:0701 Maritime Subsidy Board)",
      "05:0702" : "05:0702 (05:702 Administrative Procedure Act)",
      "05:0704" : "05:0704 (05:704 Labor Litigation)",
      "05:7703" : "05:7703 (05:7703 Discrimination - Review of Agency Act)",
      "07:0006" : "07:0006 (7:6(b) Federal Commodity Exchange Regulation)",
      "07:0025" : "07:0025 (7:25 Fraud - Commodities Leverage Contracts)",
      "07:0181" : "07:0181 (07:181 Packers & Stockyard Act)",
      "07:0499" : "07:0499 (07:499 Agricultural Commodities Act)",
      "07:0601" : "07:0601 (07:601 USDA Condemnation)",
      "07:2321" : "07:2321 (07:2321 Plant Variety Protection Act)",
      "08:1105" : "08:1105 (8:1105(a) Aliens: Habeas Corpus to Release INS Det)",
      "08:1252" : "08:1252 (08:1252(a)(2) Injunction for Deportation)",
      "08:1260" : "08:1260 (08:1260 Aliens: Access to Records)",
      "08:1324" : "08:1324 (08:1324 Aliens: Complaint for Forfeiture)",
      "08:1329" : "08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petiti)",
      "08:1446" : "08:1446 (8:1446 Petition for Naturalization Hearing)",
      "09:0001" : "09:0001 (09:1 U.S. Arbitration Act)",
      "09:0009" : "09:0009 (9:9 Motion to Confirm Arbitration Loan)",
      "09:0010" : "09:0010 (09:0010 Petition to Vacate Arbitration Award)",
      "10:1552" : "10:1552 (10:1552 Armed Forces: Action to Correct Records)",
      "10:1553" : "10:1553 (10:1553 Armed Forces: FOIA General)",
      "10:2305" : "10:2305 (10:2305 Review of Federal Contract)",
      "10:2733" : "10:2733 (10:2733 Military Claims Action)",
      "11:0101" : "11:0101 (11:101 Bankruptcy)",
      "12:0022" : "12:0022 (12:22 Securities Fraud)",
      "12:0635" : "12:0635 (12:635 Breach of Insurance Contract)",
      "12:1461" : "12:1461 (12:1461 Homeowners Loan Act)",
      "12:1703" : "12:1703 (12:1703 Default of HUD Loan)",
      "12:1725" : "12:1725 (12:1725 Collection under Contract Guaranty)",
      "12:1730" : "12:1730 (12:1730 Collection Under Contract Guaranty)",
      "12:1819" : "12:1819 (12:1819 Default of Promissory Note)",
      "12:1821" : "12:1821 (12:1821 Default of Loan by Promissary Note)",
      "12:1971" : "12:1971 (12:1971 Relief under Bank Holding Act)",
      "12:3410" : "12:3410 (12:3410 Right to Financial Privacy Act)",
      "15:0001" : "15:0001 (15:1 Antitrust Litigation)",
      "15:0002at" : "15:0002at (15:2 Antitrust Litigation)",
      "15:0002fl" : "15:0002fl (15:2(a) Fair Labor Standards Act)",
      "15:0005" : "15:0005 (15:5(a) Fair Labor Standards Act)",
      "15:0015" : "15:0015 (15:15 Antitrust Litigation)",
      "15:0025" : "15:0025 (15:25 Clayton Act)",
      "15:0044" : "15:0044 (15:44 Trademark Infringement)",
      "15:0045" : "15:0045 (15:0045 Federal Trade Commission Act)",
      "15:0052" : "15:0052 (15:0052 Federal Trade Commission Act)",
      "15:0053" : "15:0053 (15:0053 Federal Trade Commission Act)",
      "15:0077" : "15:0077 (15:77 Securities Fraud)",
      "15:0078" : "15:0078 (15:78m(a) Securities Exchange Act)",
      "15:0631" : "15:0631 (15:631 Small Business Act)",
      "15:0717" : "15:0717 (15:717 Natural Gas Act)",
      "15:1051" : "15:1051 (15:1051 Trademark Infringement)",
      "15:1114" : "15:1114 (15:1114 Trademark Infringement)",
      "15:1121" : "15:1121 (15:1121 Trademark Infringement)",
      "15:1125" : "15:1125 (15:1125 Trademark Infringement (Lanham Act))",
      "15:1126" : "15:1126 (15:1126 Patent Infringement)",
      "15:1127" : "15:1127 (15:1127 Trademark Infringement)",
      "15:1601" : "15:1601 (15:1601 Truth in Lending)",
      "15:1640" : "15:1640 (15:1640 Truth in Lending)",
      "15:1681" : "15:1681 (15:1681 Fair Credit Reporting Act)",
      "15:1692" : "15:1692 (15:1692 Fair Debt Collection Act)",
      "15:1938" : "15:1938 (15:1938 Fair Labor Standards Act)",
      "15:1981" : "15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))",
      "15:1988" : "15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))",
      "15:1989" : "15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))",
      "15:2301" : "15:2301 (15:2301 Magnuson-Moss Warranty Act)",
      "15:2801" : "15:2801 (15:2801 Petroleum Marketing Practices Act)",
      "15:53(b)" : "15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equita)",
      "16:0668" : "16:0668 (16:668 Bald Eagle Protection Act)",
      "16:0703" : "16:0703 (16:703 Migratory Bird Act)",
      "16:1538" : "16:1538 (16:1538 Endangered Species Act)",
      "16:3371" : "16:3371 (16:3371 Wildlife Under the Lacey Act)",
      "16:3372" : "16:3372 (16:3372 Conservation: Complaint for Forfeiture)",
      "16:3373" : "16:3373 (16:3373 Appeal of Decision - DOI)",
      "16:3374" : "16:3374 (16:3374 Conservation: Complaint for Forfeiture)",
      "17:0101" : "17:0101 (17:101 Copyright Infringement)",
      "17:0501" : "17:0501 (17:501 Copyright Infringement)",
      "17:0504" : "17:0504 (17:504 Copyright Infringement)",
      "18:0241" : "18:0241 (18:241 Conspiracy Against Citizen Rights)",
      "18:0981" : "18:0981 (18:981 Civil Forfeiture)",
      "18:1836a" : "18:1836a (18:1836(a) Injunction against Misappropriation of Trade Secrets)",
      "18:1836b" : "18:1836b (18:1836(b) Civil Action to Protect Trade Secrets)",
      "18:1961" : "18:1961 (18:1961 Racketeering (RICO) Act)",
      "18:1962" : "18:1962 (18:1962 Racketeering (RICO) Act)",
      "18:1964" : "18:1964 (18:1964 Racketeering (RICO) Act)",
      "18:4208" : "18:4208 (18:4208(B) Agency Action Review)",
      "19:1305" : "19:1305 (19:1305 Custom Duties:0Forfeiture-Immoral Articles)",
      "20:1080" : "20:1080 (20:1080 Student Loan Recovery)",
      "20:1083" : "20:1083 (20:1083 National Direct Student Loan Recovery)",
      "20:1400" : "20:1400 (20:1400 Civil Rights of Handicapped Child)",
      "20:1401" : "20:1401 (20:1401 Education: Handicapped Child Act)",
      "21:0841" : "21:0841 (21:841 Forfeiture Property-Drugs)",
      "21:0881" : "21:0881 (21:881 Forfeiture Property-Drugs)",
      "21:0881a" : "21:0881a (21:881 Forfeiture Property - Aircraft)",
      "21:0881re" : "21:0881re (21:881 Forfeiture Property - Real Estate)",
      "23:0134" : "23:0134 (23:134 P.I.- Auto Negligence)",
      "23:1441" : "23:1441 (23:1441 Contract Real Estate)",
      "24:1000" : "24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)",
      "25:0640" : "25:0640 (25:640 Indian Tribal Rights)",
      "25:1901" : "25:1901 (25:1901 Indian Child Welfare Act)",
      "26:6212" : "26:6212 (26:6212 Injunctive Relief from IRS Lien)",
      "26:6213" : "26:6213 (26:6213 Injunctive Relief from IRS Lien)",
      "26:6502" : "26:6502 (26:6502 IRS:Enforcement of tax liens)",
      "26:6532" : "26:6532 (26:6532 IRS: Refund of Tax Penalty)",
      "26:6702" : "26:6702 (26:6702 IRS: Refund of Income Tax Penalty)",
      "26:6703" : "26:6703 (26:6703 IRS: Refund of Tax Penalty)",
      "26:7401" : "26:7401 (26:7401 IRS: Tax Liability)",
      "26:7402" : "26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)",
      "26:7403" : "26:7403 (26:7403 Suit to Enforce Federal Tax Lien)",
      "26:7422rt" : "26:7422rt (26:7422 IRS: Refund Taxes)",
      "26:7422rx" : "26:7422rx (26:7422 IRS: Refund Excise Tax)",
      "26:7426" : "26:7426 (26:7426 IRS: Wrongful Levy for Taxes)",
      "26:7429" : "26:7429 (26:7429 IRS: Tax Jeopardy Assessment)",
      "26:7609" : "26:7609 (26:7609 IRS: Petition to Quash IRS Summons)",
      "27:0185" : "27:0185 (27:185 Enforcement of Arbitration Award)",
      "28:0157c" : "28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)",
      "28:0157d" : "28:0157d (28:0157 Motion for Withdrawal of Reference)",
      "28:0158" : "28:0158 (28:0158 Notice of Appeal re Bankruptcy Matter (BA)",
      "28:0185" : "28:0185 (28:185 Suit to Compel Arbitration)",
      "28:0451" : "28:0451 (28:451 Employment Discrimination)",
      "28:0794" : "28:0794 (28:794 Rehabilitation Act)",
      "28:1001" : "28:1001 (28:1001 E.R.I.S.A.)",
      "28:1132" : "28:1132 (28:1132 E.R.I.S.A.)",
      "28:1330" : "28:1330 (28:1330 Breach of Contract)",
      "28:1331" : "28:1331 (28:1331 Fed. Question)",
      "28:1331al" : "28:1331al (28:1331 Fed. Question: Airline Crash)",
      "28:1331at" : "28:1331at (28:1331 Fed. Question: Anti-trust)",
      "28:1331au" : "28:1331au (28:1331 Fed. Question: Auto Negligence)",
      "28:1331b" : "28:1331b (28:1331 Federal Question: Bivens Act)",
      "28:1331bc" : "28:1331bc (28:1331 Fed. Question: Breach of Contract)",
      "28:1331ca" : "28:1331ca (28:1331 Fed Question: Fed Communications Act of 1)",
      "28:1331cm" : "28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)",
      "28:1331cv" : "28:1331cv (28:1331 Federal Question: Other Civil Rights)",
      "28:1331ed" : "28:1331ed (28:1331 Fed. Question: Employment Discrimination)",
      "28:1331es" : "28:1331es (28:1331 Enforcement of Administrative Subpoena)",
      "28:1331fl" : "28:1331fl (28:1331 Fed. Question: Fair Labor Standards)",
      "28:1331in" : "28:1331in (28:1331 Fed. Question: Insurance Contract)",
      "28:1331mm" : "28:1331mm (28:1331 Fed. Question: Medical Malpractice)",
      "28:1331pi" : "28:1331pi (28:1331 Fed. Question: Personal Injury)",
      "28:1331pl" : "28:1331pl (28:1331 Product Liability)",
      "28:1331rd" : "28:1331rd (28:1331 Fed. Question: Review Agency Decision)",
      "28:1331rp" : "28:1331rp (28:1331(a) Fed. Question: Real Property)",
      "28:1331rr" : "28:1331rr (28:1331 Fed. Question: Railway Labor Act)",
      "28:1331sv" : "28:1331sv (28:1331 Fed. Question: Securities Violation)",
      "28:1331tr" : "28:1331tr (28:1331 Fed. Question: Trademark)",
      "28:1331tt" : "28:1331tt (28:1331 Fed. Question: Tort Action)",
      "28:1331v" : "28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendme)",
      "28:1331wl" : "28:1331wl (28:1331 Federal Question: EPA Waste Lien)",
      "28:1331wt" : "28:1331wt (28:1331 Fed. Question: Water Rights)",
      "28:1332ac" : "28:1332ac (28:1332 Diversity-Account Receivable)",
      "28:1332al" : "28:1332al (28:1332 Diversity-Airline Crash)",
      "28:1332as" : "28:1332as (28:1332 Diversity-Asbestos Litigation)",
      "28:1332au" : "28:1332au (28:1332 Diversity-Auto Negligence)",
      "28:1332bc" : "28:1332bc (28:1332 Diversity-Breach of Contract)",
      "28:1332co" : "28:1332co (28:1332 Diversity-Conversion)",
      "28:1332ct" : "28:1332ct (28:1332 Diversity-(Citizenship))",
      "28:1332det" : "28:1332det (28:1332 Diversity: Forcible Detainer)",
      "28:1332df" : "28:1332df (28:1332 Diversity-Contract Default)",
      "28:1332ds" : "28:1332ds (28:1332 Diversity-Contract Dispute)",
      "28:1332ed" : "28:1332ed (28:1332 Diversity-Employment Discrimination)",
      "28:1332fd" : "28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)",
      "28:1332fr" : "28:1332fr (28:1332 Diversity-Fraud)",
      "28:1332ia" : "28:1332ia (28:1332 Diversity-Interpleader Action)",
      "28:1332ij" : "28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)",
      "28:1332in" : "28:1332in (28:1332 Diversity-Insurance Contract)",
      "28:1332jd" : "28:1332jd (28:1332 Diversity-Declaratory Judgement)",
      "28:1332lb" : "28:1332lb (28:1332 Diversity-Libel,Assault,Slander)",
      "28:1332lm" : "28:1332lm (28:1332 Diversity - Legal Malpractice)",
      "28:1332ma" : "28:1332ma (28:1332 Diversity-Miller Act)",
      "28:1332mm" : "28:1332mm (28:1332 Diversity-Medical Malpractice)",
      "28:1332mv" : "28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)",
      "28:1332ni" : "28:1332ni (28:1332 Diversity-Negotiable Instrument)",
      "28:1332nm" : "28:1332nm (28:1332 Diversity-Non-Motor Vehicle)",
      "28:1332oc" : "28:1332oc (28:1332 Diversity-Other Contract)",
      "28:1332pd" : "28:1332pd (28:1332 Diversity-Property Damage)",
      "28:1332pi" : "28:1332pi (28:1332 Diversity-Personal Injury)",
      "28:1332pl" : "28:1332pl (28:1332 Diversity-Product Liability)",
      "28:1332pr" : "28:1332pr (28:1332 Diversity-Petition for Removal)",
      "28:1332qt" : "28:1332qt (28:1332 Diversity-Petition to Quiet Title)",
      "28:1332ri" : "28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)",
      "28:1332sa" : "28:1332sa (28:1332 - Diversity: Securities & Exchange Commiss)",
      "28:1332sf" : "28:1332sf (28:1332 - Diversity: Securities Fraud)",
      "28:1332ss" : "28:1332ss (28:1332 Diversity - Stockholders Suits)",
      "28:1332tl" : "28:1332tl (28:1332 Diversity-Torts to Land)",
      "28:1332tm" : "28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))",
      "28:1332tn" : "28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)",
      "28:1332wd" : "28:1332wd (28:1332 Diversity-Wrongful Death)",
      "28:1333" : "28:1333 (28:1333 Admiralty)",
      "28:1334" : "28:1334 (28:1334 Bankruptcy Appeal)",
      "28:1334c" : "28:1334c (28:1334(c) R&R re motions for abstention (non-cor)",
      "28:1335" : "28:1335 (28:1335 Interpleader Action)",
      "28:1337" : "28:1337 (28:1337 Sherman-Clayton Act)",
      "28:1338cp" : "28:1338cp (28:1338 Copyright Infringement)",
      "28:1338pt" : "28:1338pt (28:1338 Patent Infringement)",
      "28:1338tr" : "28:1338tr (28:1338 Trademark Infringement)",
      "28:1340" : "28:1340 (28:1340 IRS: Custom Duties)",
      "28:1340er" : "28:1340er (28:1340 Recovery of Erroneous Refund)",
      "28:1341" : "28:1341 (28:1341 Complaint for Forfeiture)",
      "28:1343" : "28:1343 (28:1343 Violation of Civil Rights)",
      "28:1345" : "28:1345 (28:1345 U.S. Plaintiff)",
      "28:1345co" : "28:1345co (28:1345 Replevin & Conversion)",
      "28:1345db" : "28:1345db (28:1345 Debt to US - FHA/HUD Title I)",
      "28:1345df" : "28:1345df (28:1345 Default of Promissory Note)",
      "28:1345er" : "28:1345er (28:1345 Recovery of Erroneous Refund)",
      "28:1345fc" : "28:1345fc (28:1345 Foreclosure)",
      "28:1345ff" : "28:1345ff (28:1345 Complaint for Forfeiture)",
      "28:1345hl" : "28:1345hl (28:1345 VA Home Loan Guaranty Debt)",
      "28:1345mc" : "28:1345mc (28:1345 Medical Care Recovery)",
      "28:1345mi" : "28:1345mi (28:1345 Mining Claim Ejectment)",
      "28:1345pd" : "28:1345pd (28:1345 Property Damage)",
      "28:1345pe" : "28:1345pe (28:1345 Property Ejectment)",
      "28:1345rc" : "28:1345rc (28:1345 Recovery of Debt to US)",
      "28:1345st" : "28:1345st (28:1345 Default of Student Loan)",
      "28:1345tp" : "28:1345tp (28:1345 Trespass on Public Land)",
      "28:1345va" : "28:1345va (28:1345 Recovery of VA Overpayment)",
      "28:1346bc" : "28:1346bc (28:1346 Breach of Contract)",
      "28:1346rc" : "28:1346rc (28:1346 Recovery of IRS Tax)",
      "28:1346tc" : "28:1346tc (28:1346 Tort Claim)",
      "28:1346wd" : "28:1346wd (28:1346 Wrongful Death)",
      "28:1352" : "28:1352 (28:1352 Miller Act)",
      "28:1355" : "28:1355 (28:1355 Petition for Return of Property)",
      "28:1358" : "28:1358 (28:1358 Land Condemnation)",
      "28:1361" : "28:1361 (28:1361 Petition for Writ of Mandamus)",
      "28:1362ic" : "28:1362ic (28:1362 Indian Tribal Controversy)",
      "28:1362iw" : "28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)",
      "28:1364" : "28:1364 (28:1364 Auto Negligence)",
      "28:1391" : "28:1391 (28:1391 Personal Injury)",
      "28:1402" : "28:1402 (28:1402 Medical Malpractice)",
      "28:1407" : "28:1407 (28:1407 Airline Crash)",
      "28:1441ac" : "28:1441ac (28:1441 Petition for Removal- Account Receivable)",
      "28:1441al" : "28:1441al (28:1441 Petition for Removal- Airline Crash)",
      "28:1441as" : "28:1441as (28:1441 Petition for Removal- Asbestos Litigation)",
      "28:1441au" : "28:1441au (28:1441 Petition for Removal- Auto Negligence)",
      "28:1441bc" : "28:1441bc (28:1441 Petition for Removal- Breach of Contract)",
      "28:1441cv" : "28:1441cv (28:1441 Petition for Removal- Civil Rights Act)",
      "28:1441df" : "28:1441df (28:1441 Petition for Removal- Contract Default)",
      "28:1441dj" : "28:1441dj (28:1441 Petition for Removal- Declaratory Judgemen)",
      "28:1441ds" : "28:1441ds (28:1441 Petition for Removal- Contract Dispute)",
      "28:1441ed" : "28:1441ed (28:1441 Petition for Removal - Employment Discrim)",
      "28:1441er" : "28:1441er (28:1441 Petition for Removal - E.R.I.S.A.)",
      "28:1441fc" : "28:1441fc (28:1441 Petition for Removal - Fair Credit Reporti)",
      "28:1441fl" : "28:1441fl (28:1441 Petition for Removal - Fair Labor Standards)",
      "28:1441fr" : "28:1441fr (28:1441 Petition for Removal- Fraud)",
      "28:1441ij" : "28:1441ij (28:1441 Petition for Removal- Injunctive/Declarato)",
      "28:1441in" : "28:1441in (28:1441 Petition for Removal- Insurance Contract)",
      "28:1441int" : "28:1441int (28:1441 Petition for Removal- Action for Interplea)",
      "28:1441lb" : "28:1441lb (28:1441 Petition for Removal Libel,Assault,Slander)",
      "28:1441lm" : "28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relatio)",
      "28:1441mm" : "28:1441mm (28:1441 Petition for Removal- Medical Malpractice)",
      "28:1441mv" : "28:1441mv (28:1441 Petition for Removal - Motor Vehicle)",
      "28:1441ni" : "28:1441ni (28:1441 Petition for Removal- Negotiable Instrumen)",
      "28:1441nm" : "28:1441nm (28:1441 Petition for Removal- Non-Motor Vehicle)",
      "28:1441oc" : "28:1441oc (28:1441 Petition For Removal--Other Contract)",
      "28:1441pd" : "28:1441pd (28:1441 Petition for Removal- Property Damage)",
      "28:1441pi" : "28:1441pi (28:1441 Petition for Removal- Personal Injury)",
      "28:1441pl" : "28:1441pl (28:1441 Petition for Removal- Product Liability)",
      "28:1441pr" : "28:1441pr (28:1441 Petition for Removal)",
      "28:1441qt" : "28:1441qt (28:1441 Petition for Removal- Petition to Quiet Ti)",
      "28:1441ri" : "28:1441ri (28:1441 Petition for Removal- Racketeering (RICO))",
      "28:1441sa" : "28:1441sa (28:1441 - Petition for Removal: SEC Act)",
      "28:1441sf" : "28:1441sf (28:1441 - Petition for Removal: Securities Fraud)",
      "28:1441tl" : "28:1441tl (28:1441 Petition for Removal- Torts to Land)",
      "28:1441tm" : "28:1441tm (28:1441 Petition for Removal- Tort/Motor Vehicle ()",
      "28:1441tn" : "28:1441tn (28:1441 Petition for Removal- Tort/Non-Motor Vehic)",
      "28:1441wd" : "28:1441wd (28:1441 Petition for Removal- Wrongful Death)",
      "28:1442bc" : "28:1442bc (28:1442 Petition for Removal- Breach of Contract)",
      "28:1442pr" : "28:1442pr (28:1442 Petition for Removal)",
      "28:1443" : "28:1443 (28:1443(1) Rent, Lease & Ejectment)",
      "28:1444" : "28:1444 (28:1444 Petition for Removal- Foreclosure)",
      "28:1446in" : "28:1446in (28:1446 Breach of Contract- Insurance)",
      "28:1446pd" : "28:1446pd (28:1446 Petition for Removal- Property Damage (P.I)",
      "28:1446pi" : "28:1446pi (28:1446 Petition for Removal- Personal Injury)",
      "28:1446pl" : "28:1446pl (28:1446pl Petition for Removal - Product Liability)",
      "28:1446pr" : "28:1446pr (28:1446 Petition for Removal)",
      "28:1452" : "28:1452 (28:1452 R&R re motions to remand (non-core))",
      "28:1651" : "28:1651 (28:1651 Petition for Writ of Coram Nobis)",
      "28:1651hc" : "28:1651hc (28:1651 Petition for Writ of Habeas Corpus)",
      "28:1651mn" : "28:1651mn (28:1651 Petition for Writ of Mandamus)",
      "28:1983" : "28:1983 (28:1983 Civil Rights)",
      "28:2201" : "28:2201 (28:2201 Constitutionality of State Statute(s))",
      "28:2201dj" : "28:2201dj (28:2201 Declaratory Judgement)",
      "28:2201ij" : "28:2201ij (28:2201 Injunction)",
      "28:2201in" : "28:2201in (28:2201 Declaratory Judgement (Insurance))",
      "28:2241" : "28:2241 (28:2241 Petition for Writ of Habeas Corpus (federa)",
      "28:2254" : "28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))",
      "28:2254se" : "28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)",
      "28:2255" : "28:2255 (28:2255 Motion to Vacate / Correct Illegal Sentenc)",
      "28:2271" : "28:2271 (28:2271 Federal Tort Claims Act)",
      "28:2345" : "28:2345 (28:2345 Medicare Recovery)",
      "28:2409" : "28:2409 (28:2409(a) Quiet Title Action)",
      "28:2410" : "28:2410 (28:2410 Quiet Title)",
      "28:2671" : "28:2671 (28:2671 Federal Tort Claims Act)",
      "28:2674" : "28:2674 (28:2674 Federal Tort Claims Act)",
      "28:3001" : "28:3001 (28:3001 Federal Debt Collection)",
      "28:7402" : "28:7402 (28:7402 Refund of Taxes)",
      "28:7422" : "28:7422 (28:7422 Appeal from Administrative Decision)",
      "29:0151" : "29:0151 (29:151 Labor: Review of Agency Action)",
      "29:0160" : "29:0160 (29:160(1) National Labor Relations Act)",
      "29:0184" : "29:0184 (29:184 Violation Collection Bargain Agreement)",
      "29:0185ep" : "29:0185ep (29:185 Employee Pension Plan)",
      "29:0185lm" : "29:0185lm (29:185 Labor/Mgt. Relations (Contracts))",
      "29:0201do" : "29:0201do (29:201 Denial of Overtime Compensation)",
      "29:0201fl" : "29:0201fl (29:201 Fair Labor Standards Act)",
      "29:0203" : "29:0203 (29:203 Equal Pay Act)",
      "29:0206" : "29:0206 (29:206 Collect Unpaid Wages)",
      "29:0401" : "29:0401 (29:0401 Labor Management Disclosure Act)",
      "29:0621" : "29:0621 (29:621 Job Discrimination (Age))",
      "29:0623" : "29:0623 (29:623 Job Discrimination (Age))",
      "29:0626" : "29:0626 (29:626 Job Discrimination (Age))",
      "29:0633" : "29:0633 (29:633 Job Discrimination (Age))",
      "29:0651" : "29:0651 (29:651 Occupational Safety/Health)",
      "29:0754" : "29:0754 (29:754 Discrimination)",
      "29:0791" : "29:0791 (29:791 Job Discrimination (Rehabilitation Act))",
      "29:0794" : "29:0794 (29:0794 Job Discrimination (Handicap))",
      "29:1001" : "29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)",
      "29:1002" : "29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)",
      "29:1101" : "29:1101 (29:1101 E.R.I.S.A.)",
      "29:1104" : "29:1104 (29:1104 Recovery of Benefits to Employee)",
      "29:1109" : "29:1109 (29:1109 Breach of Fiduciary Duties)",
      "29:1131" : "29:1131 (29:1131 ERISA - Collection of Delinquent Trust Fun)",
      "29:1132" : "29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)",
      "29:1145" : "29:1145 (29:1145 E.R.I.S.A.)",
      "29:1149" : "29:1149 (29:1149 Recover Pension & Profit Sharing)",
      "29:1337" : "29:1337 (29:1337 E.R.I.S.A.)",
      "29:1362" : "29:1362 (29:1362 ERISA)",
      "29:1381" : "29:1381 (29:1381 E.R.I.S.A.)",
      "29:1401" : "29:1401 (29:1401(b)(2) Appeal of Arbitration Award)",
      "29:1451" : "29:1451 (29:1451 E.R.I.S.A.)",
      "29:1801" : "29:1801 (29:1801 Farmworker Rights)",
      "29:790" : "29:790 (29:790 Rehabilitation of Labor)",
      "30:0181" : "30:0181 (30:181 Environment: Review of Agency Action)",
      "30:0801" : "30:0801 (30:0801 Penalities/Federal Mine Safety Health Act)",
      "30:1201" : "30:1201 (30:1201 Environment: Review of Agency Action)",
      "30:1202" : "30:1202 (30:1202 Mining Reclamation Act)",
      "30:1276" : "30:1276 (30:1276 Interior: Review of Agency Action)",
      "31:3545" : "31:3545 (31:3545 Action to Recovery Money)",
      "31:3729" : "31:3729 (31:3729 False Claims Act)",
      "31:3730" : "31:3730 (31:3730 Qui Tam False Claims Act)",
      "31:3731" : "31:3731 (31:3731 Fraud)",
      "31:5317" : "31:5317 (31:5317 Search and Forfeiture of Monetary Instruments)",
      "33:1319cw" : "33:1319cw (33:1319 Clean Water Act)",
      "33:1319pv" : "33:1319pv (33:1319 Pollutants & Permit Violations)",
      "33:1365" : "33:1365 (33:1365 Environmental Matters)",
      "35:0145" : "35:0145 (35:145 Patent Infringement)",
      "35:0183" : "35:0183 (35:183 Patent Infringement)",
      "35:0271" : "35:0271 (35:271 Patent Infringement)",
      "37:0502" : "37:0502 (37:502(b) Recoup Overpayment of Excessive Leave)",
      "38:1681" : "38:1681 (38:1681 Recovery of VA Overpayment)",
      "38:1686" : "38:1686 (38:1686 Recovery of VA Overpayment)",
      "38:1780" : "38:1780 (38:1780 Recovery of VA Overpayment)",
      "38:1803rc" : "38:1803rc (38:1803 Recoupment of Veterans Administration Home Loan)",
      "38:2011" : "38:2011 (38:2011 - Veteran's Readjustment Assistance Act of)",
      "38:3116" : "38:3116 (38:3116 VA Overpayment)",
      "39:3005" : "39:3005 (39:3005 Detention of Mail for Temporary Periods)",
      "39:409" : "39:409 (39:409 Postal Service)",
      "40:0258" : "40:0258 (40:258(a) Public Buildings & Property: Land Condem)",
      "40:0270" : "40:0270 (40:270 Miller Act)",
      "40:0875" : "40:0875 (40:875 Public Buildings & Property: Negligence)",
      "41:0251" : "41:0251 (41:251 Public Contracts-Review of Agency Action)",
      "41:1463" : "41:1463 (41:1463 Public Contracts: Unlawful Employment Prac)",
      "42:0205" : "42:0205 (42:205 Denial Social Security Benefits)",
      "42:0206" : "42:0206 (42:206 Social Security Benefits)",
      "42:0247" : "42:0247 (42:247 Personal Injury-Swine Flu)",
      "42:0402" : "42:0402 (42:402 Social Security Benefits)",
      "42:0405id" : "42:0405id (42:405 Review of HHS Decision (SSID))",
      "42:0405wc" : "42:0405wc (42:405 Review of HHS Decision (DIWC))",
      "42:0405ww" : "42:0405ww (42:405 Review of HHS Decision (DIWW))",
      "42:0416" : "42:0416 (42:416 Denial of Social Security Benefits)",
      "42:0427" : "42:0427 (42:427 Social Security Benefits)",
      "42:1383" : "42:1383 (42:1383 Review of HHS Decision)",
      "42:1395" : "42:1395 (42:1395 HHS: Adverse Reimbursement Review)",
      "42:1396" : "42:1396 (42:1396 - Tort Negligence)",
      "42:1471" : "42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclo)",
      "42:1981cv" : "42:1981cv (42:1981 Civil Rights)",
      "42:1981hs" : "42:1981hs (42:1981 Housing Discrimination)",
      "42:1981jb" : "42:1981jb (42:1981 Job Discrimination (Race))",
      "42:1981sx" : "42:1981sx (42:1981 Sex Discrimination)",
      "42:1983cv" : "42:1983cv (42:1983 Civil Rights Act)",
      "42:1983ed" : "42:1983ed (42:1983 Civil Rights (Employment Discrimination))",
      "42:1983pr" : "42:1983pr (42:1983 Prisoner Civil Rights)",
      "42:1986" : "42:1986 (42:1986 Neglect of Duty)",
      "42:2000ag" : "42:2000ag (42:2000 Job Discrimination (Age))",
      "42:2000e" : "42:2000e (42:2000e Job Discrimination (Employment))",
      "42:2000ha" : "42:2000ha (42:2000 Job Discrimination (handicap))",
      "42:2000pb" : "42:2000pb (42:2000 Job Discrimination (Public Accomodations))",
      "42:2000ra" : "42:2000ra (42:2000 Job Discrimination (Race))",
      "42:2000sx" : "42:2000sx (42:2000 Job Discrimination (Sex))",
      "42:2003" : "42:2003 (42:2003 Job Discrimination)",
      "42:2005" : "42:2005 (42:2005 Review of Agency Action-HHS)",
      "42:2651" : "42:2651 (42:2651 Medical Care Recovery)",
      "42:3601" : "42:3601 (42:405 Fair Housing Act)",
      "42:4000" : "42:4000 (42:4000 National Flood Insurance Act)",
      "42:4001" : "42:4001 (42:4001 National Insurance Flood Act)",
      "42:4053" : "42:4053 (42:4053 Breach of Insurance Contract)",
      "42:4072" : "42:4072 (42:4072 Payment of Flood Insurance Claim)",
      "42:4321" : "42:4321 (42:4321 Review of Agency Action-Environment)",
      "42:4332" : "42:4332 (42:4332 Environmental Policy - Coop of Agency Repo)",
      "42:6901en" : "42:6901en (42:6901 Environmental Cleanup Expenses)",
      "42:6901rs" : "42:6901rs (42:6901 Resource & Recovery Act)",
      "42:7413" : "42:7413 (42:7413(b) Clean Air Act)",
      "42:7604cl" : "42:7604cl (42:7604 Clear Air Act (Emission Standards))",
      "42:7604ir" : "42:7604ir (42:7604 Petition to Quash IRS Summons)",
      "42:9607" : "42:9607 (42:9607 Real Property Tort to Land)",
      "43:945" : "43:945 (43:945 Compensation for Land Condemnation)",
      "43:945a" : "43:945a (43:945a Complaint in Condemnation)",
      "43:946" : "43:946 (43:946 Complaint in Condemnation - Eminent Domain)",
      "45:0051" : "45:0051 (45:51 Railways: Fed. Employer's Liability Act)",
      "45:0151" : "45:0151 (45:151 Railway Labor Act)",
      "45:0184" : "45:0184 (45:184 Action to Set Aside Award of a System Board)",
      "45:1395" : "45:1395 (45:1395 Railroads: Adverse Reimbursement Review)",
      "45:7457" : "45:7457 (45:7457 Compel Reclamation Under Clear Air Act)",
      "46:0688" : "46:0688 (46:688 Jones Act)",
      "46:0688ma" : "46:0688ma (46:688 Maritime Personal Injury)",
      "46:0741" : "46:0741 (46:741 Shipping)",
      "46:0761" : "46:0761 (46:761 Shipping: Damages for Death on High Seas)",
      "46:1101" : "46:1101 (46:1101 Violation of Maritime Regulations)",
      "46:1156" : "46:1156 (46:1156 Administrative Procedure Act)",
      "47:0503" : "47:0503 (47:503 Radio and Wire Communication - Forfeiture)",
      "47:0504" : "47:0504 (47:504 Radio and Wire Communication - Recovery of Forfeiture)",
      "48:0883" : "48:0883 (48:883 Violation of US Coastal Law)",
      "48:1985" : "48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)",
      "49:0081" : "49:0081 (49:81 Damaged Goods While Being Transported)",
      "49:0781" : "49:0781 (49:781 Forfeiture)",
      "49:11503" : "49:11503 (49:11503 Railroad Revitalization Regulatory Reform)",
      "49:11702" : "49:11702 (49:11702(a)(4) Violations of Interstate Commerce A)",
      "49:1471" : "49:1471 (49:1471 Federal Aviation Act)",
      "49:1903" : "49:1903 (49:1903 Petition to enforce administrative summon)",
      "8:287" : "8:287 (8:287 Petition to Enforce INS Subpoena)",
      "misc" : "misc (Civil Miscellaneous Case)"
   },
   "miwdce" : {
      "*" : "* ()",
      "0" : "0 (No cause code entered)",
      "00:0000" : "00:0000 (00:0000 Cause Code Unknown )",
      "02:0431" : "02:0431 (02:431 Fed. Election Commission: Failure Enforce C)",
      "02:0437" : "02:0437 (02:437 Federal Election Commission)",
      "05:0075" : "05:0075 (05:75(2) Contract - Reduction in Grade)",
      "05:0551" : "05:0551 (05:551 Administrative Procedure Act)",
      "05:0552fi" : "05:0552fi (05:552 Freedom of Information Act)",
      "05:0552pa" : "05:0552pa (05:552 Right to Privacy Act)",
      "05:0554" : "05:0554 (05:0554 Constitutionality of Maritime Statutes)",
      "05:0701" : "05:0701 (05:0701 Maritime Subsidy Board)",
      "05:0702" : "05:0702 (05:702 Administrative Procedure Act)",
      "05:0704" : "05:0704 (05:704 Labor Litigation)",
      "05:1508" : "05:1508 (05:1508 Petition for Judicial Review of Merit Sys Prot Board)",
      "05:7703" : "05:7703 (05:7703 Discrimination - Review of Agency Act)",
      "07:0006" : "07:0006 (7:6(b) Federal Commodity Exchange Regulation)",
      "07:0025" : "07:0025 (7:25 Fraud - Commodities Leverage Contracts)",
      "07:0181" : "07:0181 (07:181 Packers & Stockyard Act)",
      "07:0499" : "07:0499 (07:499 Agricultural Commodities Act)",
      "07:0601" : "07:0601 (07:601 USDA Condemnation)",
      "07:2011" : "07:2011 (07:2011 Food Stamp Act)",
      "07:2023" : "07:2023 (07:2023 Administrative & Judicial Review of USDA decision )",
      "07:2321" : "07:2321 (07:2321 Plant Variety Protection Act)",
      "08:0287" : "08:0287 (08:0287 Petition to Enforce INS Subpoena)",
      "08:1105" : "08:1105 (8:1105(a) Aliens: Habeas Corpus to Release INS Det)",
      "08:1252" : "08:1252 (08:1252(a)(2) Injunction for Deportation)",
      "08:1260" : "08:1260 (08:1260 Aliens: Access to Records)",
      "08:1324" : "08:1324 (08:1324 Aliens: Complaint for Forfeiture)",
      "08:1329" : "08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petiti)",
      "08:1446" : "08:1446 (8:1446 Petition for Naturalization Hearing)",
      "08:1447" : "08:1447 (08:1447 Hearings on Denials of Applications for Naturalization)",
      "09:0001" : "09:0001 (09:1 U.S. Arbitration Act)",
      "09:0004" : "09:0004 (09:4 Petition for Order Compelling Arbitration)",
      "09:0009" : "09:0009 (9:9 Motion to Confirm Arbitration Loan)",
      "09:0010" : "09:0010 (09:0010 Petition to Vacate Arbitration Award)",
      "10:1109" : "10:1109 (10:1109 Other Statutory Actions )",
      "10:1552" : "10:1552 (10:1552 Armed Forces: Action to Correct Records)",
      "10:1553" : "10:1553 (10:1553 Armed Forces: FOIA General)",
      "10:2305" : "10:2305 (10:2305 Review of Federal Contract)",
      "11:0101" : "11:0101 (11:101 Bankruptcy)",
      "12:0022" : "12:0022 (12:22 Securities Fraud)",
      "12:0635" : "12:0635 (12:635 Breach of Insurance Contract)",
      "12:1461" : "12:1461 (12:1461 Homeowners Loan Act)",
      "12:1703" : "12:1703 (12:1703 Default of HUD Loan)",
      "12:1725" : "12:1725 (12:1725 Collection under Contract Guaranty)",
      "12:1730" : "12:1730 (12:1730 Collection Under Contract Guaranty)",
      "12:1811" : "12:1811 (12:1811 Negotiable Instruments )",
      "12:1819" : "12:1819 (12:1819 Default of Promissory Note)",
      "12:1821" : "12:1821 (12:1821 Default of Loan by Promissory Note)",
      "12:1833" : "12:1833 (12:1833 Fin. Inst. Reform, Recovery, and Enforcement Act )",
      "12:1971" : "12:1971 (12:1971 Relief under Bank Holding Act)",
      "12:3410" : "12:3410 (12:3410 Right to Financial Privacy Act)",
      "15:0001" : "15:0001 (15:1 Antitrust Litigation)",
      "15:0002at" : "15:0002at (15:2 Antitrust Litigation)",
      "15:0002fl" : "15:0002fl (15:2(a) Fair Labor Standards Act)",
      "15:0005" : "15:0005 (15:5(a) Fair Labor Standards Act)",
      "15:0015" : "15:0015 (15:15 Antitrust Litigation)",
      "15:0025" : "15:0025 (15:25 Clayton Act)",
      "15:0044" : "15:0044 (15:44 Trademark Infringement)",
      "15:0045" : "15:0045 (15:0045 Federal Trade Commission Act)",
      "15:0052" : "15:0052 (15:0052 Federal Trade Commission Act)",
      "15:0053" : "15:0053 (15:0053 Federal Trade Commission Act)",
      "15:0053b" : "15:0053b (15:53(b) Prelim & Perm Inj Relief & Other Equitable Relief )",
      "15:0077" : "15:0077 (15:77 Securities Fraud)",
      "15:0078" : "15:0078 (15:78m(a) Securities Exchange Act)",
      "15:0631" : "15:0631 (15:631 Small Business Act)",
      "15:0717" : "15:0717 (15:717 Natural Gas Act)",
      "15:1051" : "15:1051 (15:1051 Trademark Infringement)",
      "15:1071" : "15:1071 (15:1071 Trademark - Appeal to Courts )",
      "15:1114" : "15:1114 (15:1114 Trademark Infringement)",
      "15:1121" : "15:1121 (15:1121 Trademark Infringement)",
      "15:1125" : "15:1125 (15:1125 Trademark Infringement (Lanham Act))",
      "15:1126" : "15:1126 (15:1126 Patent Infringement)",
      "15:1127" : "15:1127 (15:1127 Trademark Infringement)",
      "15:1601" : "15:1601 (15:1601 Truth in Lending)",
      "15:1605" : "15:1605 (15:1605 Consumer Credit Protection - Finance Charge )",
      "15:1640" : "15:1640 (15:1640 Truth in Lending)",
      "15:1681" : "15:1681 (15:1681 Fair Credit Reporting Act)",
      "15:1691" : "15:1691 (15:1691 Equal Credit Opportunity Act)",
      "15:1692" : "15:1692 (15:1692 Fair Debt Collection Act)",
      "15:1693" : "15:1693 (15:1693 Use of electronic systems to transfer funds)",
      "15:1938" : "15:1938 (15:1938 Fair Labor Standards Act)",
      "15:1981" : "15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))",
      "15:1988" : "15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))",
      "15:1989" : "15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))",
      "15:2301" : "15:2301 (15:2301 Magnuson-Moss Warranty Act)",
      "15:2801" : "15:2801 (15:2801 Petroleum Marketing Practices Act)",
      "15:53(b)" : "15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equita)",
      "16:0668" : "16:0668 (16:668 Bald Eagle Protection Act)",
      "16:0703" : "16:0703 (16:703 Migratory Bird Act)",
      "16:1247d" : "16:1247d (16:1247(d) Railroad Rights-of-Way)",
      "16:1538" : "16:1538 (16:1538 Endangered Species Act)",
      "16:3371" : "16:3371 (16:3371 Wildlife Under the Lacey Act)",
      "16:3372" : "16:3372 (16:3372 Conservation: Complaint for Forfeiture)",
      "16:3373" : "16:3373 (16:3373 Appeal of Decision - DOI)",
      "16:3374" : "16:3374 (16:3374 Conservation: Complaint for Forfeiture)",
      "17:0101" : "17:0101 (17:101 Copyright Infringement)",
      "17:0501" : "17:0501 (17:501 Copyright Infringement)",
      "17:0504" : "17:0504 (17:504 Copyright Infringement)",
      "18:0241" : "18:0241 (18:241 Conspiracy Against Citizen Rights)",
      "18:0981" : "18:0981 (18:981 Forfeiture in Rem )",
      "18:1836a" : "18:1836a (18:1836(a) Injunction against Misappropriation of Trade Secrets)",
      "18:1836b" : "18:1836b (18:1836(b) Civil Action to Protect Trade Secrets)",
      "18:1961" : "18:1961 (18:1961 Racketeering (RICO) Act)",
      "18:1962" : "18:1962 (18:1962 Racketeering (RICO) Act)",
      "18:1964" : "18:1964 (18:1964 Racketeering (RICO) Act)",
      "18:248" : "18:248 (18:248 Freedom of access to clinic entrances )",
      "18:4208" : "18:4208 (18:4208(B) Agency Action Review)",
      "19:1305" : "19:1305 (19:1305 Custom Duties:0Forfeiture-Immoral Articles)",
      "20:0107" : "20:0107 (20:107 Randolph-Sheppard Act/Vending Stand Act )",
      "20:1080" : "20:1080 (20:1080 Student Loan Recovery)",
      "20:1099b" : "20:1099b (20:1099(b) Higher Education - Recognition of accrediting agency or association)",
      "20:1400" : "20:1400 (20:1400 Civil Rights of Handicapped Child)",
      "20:1401" : "20:1401 (20:1401 Education: Handicapped Child Act)",
      "20:1415" : "20:1415 (20:1415 Education-Handicapped Child-Procedures)",
      "21:0301" : "21:0301 (21:301 Federal Food, Drug, and Cosmetic Act )",
      "21:0841" : "21:0841 (21:841 Forfeiture Property-Drugs)",
      "21:0881" : "21:0881 (21:881 Forfeiture Property-Drugs)",
      "21:0881a" : "21:0881a (21:881 Forfeiture Property - Aircraft)",
      "21:0881re" : "21:0881re (21:881 Forfeiture Property - Real Estate)",
      "23:0134" : "23:0134 (23:134 P.I.- Auto Negligence)",
      "23:1441" : "23:1441 (23:1441 Contract Real Estate)",
      "24:1000" : "24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)",
      "25:0640" : "25:0640 (25:640 Indian Tribal Rights)",
      "25:1303" : "25:1303 (25:1303 Petition for Writ of Habeas Corpus (Indian Tribal))",
      "25:1901" : "25:1901 (25:1901 Indian Child Welfare Act)",
      "25:2701" : "25:2701 (25:2701 Indian Gaming Regulatory Act )",
      "26:6212" : "26:6212 (26:6212 Injunctive Relief from IRS Lien)",
      "26:6213" : "26:6213 (26:6213 Injunctive Relief from IRS Lien)",
      "26:6330" : "26:6330 (26:6330 Review of IRS Tax Liability Determination)",
      "26:6502" : "26:6502 (26:6502 IRS:Enforcement of tax liens)",
      "26:6532" : "26:6532 (26:6532 IRS: Refund of Tax Penalty)",
      "26:6702" : "26:6702 (26:6702 IRS: Refund of Income Tax Penalty)",
      "26:6703" : "26:6703 (26:6703 IRS: Refund of Tax Penalty)",
      "26:7401" : "26:7401 (26:7401 IRS: Tax Liability)",
      "26:7402" : "26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)",
      "26:7403" : "26:7403 (26:7403 Suit to Enforce Federal Tax Lien)",
      "26:7422rt" : "26:7422rt (26:7422 IRS: Refund Taxes)",
      "26:7422rx" : "26:7422rx (26:7422 IRS: Refund Excise Tax)",
      "26:7426" : "26:7426 (26:7426 IRS: Wrongful Levy for Taxes)",
      "26:7429" : "26:7429 (26:7429 IRS: Tax Jeopardy Assessment)",
      "26:7609" : "26:7609 (26:7609 IRS: Petition to Quash IRS Summons)",
      "27:0185" : "27:0185 (27:185 Enforcement of Arbitration Award)",
      "28:0157c" : "28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)",
      "28:0157d" : "28:0157d (28:0157 Motion for Withdrawal of Reference)",
      "28:0158" : "28:0158 (28:0158 Notice of Appeal re Bankruptcy Matter (BA)",
      "28:0185" : "28:0185 (28:185 Suit to Compel Arbitration)",
      "28:0185lm" : "28:0185lm (28:185 Labor/Management Relations Act )",
      "28:0451" : "28:0451 (28:451 Employment Discrimination)",
      "28:0794" : "28:0794 (28:794 Rehabilitation Act)",
      "28:1001" : "28:1001 (28:1001 E.R.I.S.A.)",
      "28:1132" : "28:1132 (28:1132 E.R.I.S.A.)",
      "28:1330" : "28:1330 (28:1330 Breach of Contract)",
      "28:1331" : "28:1331 (28:1331 Fed. Question)",
      "28:1331al" : "28:1331al (28:1331 Fed. Question: Airline Crash)",
      "28:1331at" : "28:1331at (28:1331 Fed. Question: Anti-trust)",
      "28:1331au" : "28:1331au (28:1331 Fed. Question: Auto Negligence)",
      "28:1331b" : "28:1331b (28:1331 Federal Question: Bivens Act)",
      "28:1331bc" : "28:1331bc (28:1331 Fed. Question: Breach of Contract)",
      "28:1331ca" : "28:1331ca (28:1331 Fed Question: Fed Communications Act of 1)",
      "28:1331cm" : "28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)",
      "28:1331cv" : "28:1331cv (28:1331 Federal Question: Other Civil Rights)",
      "28:1331ed" : "28:1331ed (28:1331 Fed. Question: Employment Discrimination)",
      "28:1331es" : "28:1331es (28:1331 Enforcement of Administrative Subpoena)",
      "28:1331fl" : "28:1331fl (28:1331 Fed. Question: Fair Labor Standards)",
      "28:1331in" : "28:1331in (28:1331 Fed. Question: Insurance Contract)",
      "28:1331mm" : "28:1331mm (28:1331 Fed. Question: Medical Malpractice)",
      "28:1331mp" : "28:1331mp (28:1331 Federal Question-Marine Personal Injury )",
      "28:1331pi" : "28:1331pi (28:1331 Fed. Question: Personal Injury)",
      "28:1331rd" : "28:1331rd (28:1331 Fed. Question: Review Agency Decision)",
      "28:1331rp" : "28:1331rp (28:1331(a) Fed. Question: Real Property)",
      "28:1331rr" : "28:1331rr (28:1331 Fed. Question: Railway Labor Act)",
      "28:1331sc" : "28:1331sc (28:1331 Federal Question-Securities, Commodities, Exchange )",
      "28:1331sv" : "28:1331sv (28:1331 Fed. Question: Securities Violation)",
      "28:1331tc" : "28:1331tc (28:1331 Federal Question-Fed. Telecomm. Act of 1996 )",
      "28:1331tr" : "28:1331tr (28:1331 Fed. Question: Trademark)",
      "28:1331tt" : "28:1331tt (28:1331 Fed. Question: Tort Action)",
      "28:1331v" : "28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendme)",
      "28:1331wl" : "28:1331wl (28:1331 Federal Question: EPA Waste Lien)",
      "28:1331wt" : "28:1331wt (28:1331 Fed. Question: Water Rights)",
      "28:1332" : "28:1332 (28:1332 Diversity-Personal Injury-Product Liability )",
      "28:1332ac" : "28:1332ac (28:1332 Diversity-Account Receivable)",
      "28:1332al" : "28:1332al (28:1332 Diversity-Airline Crash)",
      "28:1332as" : "28:1332as (28:1332 Diversity-Asbestos Litigation)",
      "28:1332au" : "28:1332au (28:1332 Diversity-Auto Negligence)",
      "28:1332bc" : "28:1332bc (28:1332 Diversity-Breach of Contract)",
      "28:1332co" : "28:1332co (28:1332 Diversity-Conversion)",
      "28:1332ct" : "28:1332ct (28:1332 Diversity-(Citizenship))",
      "28:1332det" : "28:1332det (28:1332 Diversity: Forcible Detainer)",
      "28:1332df" : "28:1332df (28:1332 Diversity-Contract Default)",
      "28:1332ds" : "28:1332ds (28:1332 Diversity-Contract Dispute)",
      "28:1332ed" : "28:1332ed (28:1332 Diversity-Employment Discrimination)",
      "28:1332fd" : "28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)",
      "28:1332fr" : "28:1332fr (28:1332 Diversity-Fraud)",
      "28:1332ia" : "28:1332ia (28:1332 Diversity-Interpleader Action)",
      "28:1332ij" : "28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)",
      "28:1332in" : "28:1332in (28:1332 Diversity-Insurance Contract)",
      "28:1332jd" : "28:1332jd (28:1332 Diversity-Declaratory Judgement)",
      "28:1332lb" : "28:1332lb (28:1332 Diversity-Libel,Assault,Slander)",
      "28:1332lm" : "28:1332lm (28:1332 Diversity - Legal Malpractice)",
      "28:1332ma" : "28:1332ma (28:1332 Diversity-Miller Act)",
      "28:1332mm" : "28:1332mm (28:1332 Diversity-Medical Malpractice)",
      "28:1332mp" : "28:1332mp (28:1332 Diversity-Motor Vehicle Product Liability )",
      "28:1332mv" : "28:1332mv (28:1332 Diversity-Motor Vehicle)",
      "28:1332ni" : "28:1332ni (28:1332 Diversity-Negotiable Instrument)",
      "28:1332nm" : "28:1332nm (28:1332 Diversity-Non-Motor Vehicle)",
      "28:1332oc" : "28:1332oc (28:1332 Diversity-Other Contract)",
      "28:1332op" : "28:1332op (28:1332 Diversity- Other Personal Property)",
      "28:1332pd" : "28:1332pd (28:1332 Diversity-Property Damage)",
      "28:1332pi" : "28:1332pi (28:1332 Diversity-Personal Injury)",
      "28:1332pl" : "28:1332pl (28:1332 Diversity-Product Liability)",
      "28:1332pr" : "28:1332pr (28:1332 Diversity-Petition for Removal)",
      "28:1332qt" : "28:1332qt (28:1332 Diversity-Petition to Quiet Title)",
      "28:1332ri" : "28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)",
      "28:1332rp" : "28:1332rp (28:1332 Diversity-Real Property )",
      "28:1332sa" : "28:1332sa (28:1332 - Diversity: Securities & Exchange Commiss)",
      "28:1332sf" : "28:1332sf (28:1332 - Diversity: Securities Fraud)",
      "28:1332ss" : "28:1332ss (28:1332 Diversity - Stockholders Suits)",
      "28:1332tl" : "28:1332tl (28:1332 Diversity-Torts to Land)",
      "28:1332tm" : "28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))",
      "28:1332tn" : "28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)",
      "28:1332wd" : "28:1332wd (28:1332 Diversity-Wrongful Death)",
      "28:1333" : "28:1333 (28:1333 Admiralty)",
      "28:1334" : "28:1334 (28:1334 Bankruptcy Appeal)",
      "28:1334c" : "28:1334c (28:1334(c) R&R re motions for abstention (non-cor)",
      "28:1335" : "28:1335 (28:1335 Interpleader Action)",
      "28:1337" : "28:1337 (28:1337 Sherman-Clayton Act)",
      "28:1338cp" : "28:1338cp (28:1338 Copyright Infringement)",
      "28:1338pt" : "28:1338pt (28:1338 Patent Infringement)",
      "28:1338tr" : "28:1338tr (28:1338 Trademark Infringement)",
      "28:1340" : "28:1340 (28:1340 IRS: Custom Duties)",
      "28:1340er" : "28:1340er (28:1340 Recovery of Erroneous Refund)",
      "28:1341" : "28:1341 (28:1341 Complaint for Forfeiture)",
      "28:1343" : "28:1343 (28:1343 Violation of Civil Rights)",
      "28:1345" : "28:1345 (28:1345 Unjust Enrichment)",
      "28:1345co" : "28:1345co (28:1345 Replevin & Conversion)",
      "28:1345db" : "28:1345db (28:1345 Debt to US - FHA/HUD Title I)",
      "28:1345df" : "28:1345df (28:1345 Default of Promissory Note)",
      "28:1345em" : "28:1345em (28:1345 Environmental Matters )",
      "28:1345er" : "28:1345er (28:1345 Recovery of Erroneous Refund)",
      "28:1345fc" : "28:1345fc (28:1345 Foreclosure)",
      "28:1345ff" : "28:1345ff (28:1345 Complaint for Forfeiture)",
      "28:1345hd" : "28:1345hd (28:1345 Default of HUD Loan )",
      "28:1345hl" : "28:1345hl (28:1345 VA Home Loan Guaranty Debt)",
      "28:1345mc" : "28:1345mc (28:1345 Medical Care Recovery)",
      "28:1345mi" : "28:1345mi (28:1345 Mining Claim Ejectment)",
      "28:1345pd" : "28:1345pd (28:1345 Property Damage)",
      "28:1345pe" : "28:1345pe (28:1345 Property Ejectment)",
      "28:1345rc" : "28:1345rc (28:1345 Recovery of Debt to US)",
      "28:1345st" : "28:1345st (28:1345 Default of Student Loan)",
      "28:1345tp" : "28:1345tp (28:1345 Trespass on Public Land)",
      "28:1345us" : "28:1345us (28:1345 Debt to United States )",
      "28:1345va" : "28:1345va (28:1345 Recovery of VA Overpayment)",
      "28:1346bc" : "28:1346bc (28:1346 Breach of Contract)",
      "28:1346rc" : "28:1346rc (28:1346 Recovery of IRS Tax)",
      "28:1346tc" : "28:1346tc (28:1346 Tort Claim)",
      "28:1346wd" : "28:1346wd (28:1346 Wrongful Death)",
      "28:1352" : "28:1352 (28:1352 Miller Act)",
      "28:1355" : "28:1355 (28:1355 Petition for Return of Property)",
      "28:1358" : "28:1358 (28:1358 Land Condemnation)",
      "28:1361" : "28:1361 (28:1361 Petition for Writ of Mandamus)",
      "28:1362ic" : "28:1362ic (28:1362 Indian Tribal Controversy)",
      "28:1362iw" : "28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)",
      "28:1364" : "28:1364 (28:1364 Auto Negligence)",
      "28:1367" : "28:1367 (28:1367 Supplemental Jurisdiction)",
      "28:1391" : "28:1391 (28:1391 Venue/Diversity)",
      "28:1402" : "28:1402 (28:1402 Medical Malpractice)",
      "28:1407" : "28:1407 (28:1407 Airline Crash)",
      "28:1441" : "28:1441 (28:1441 Contract Product Liability )",
      "28:1441ac" : "28:1441ac (28:1441 Petition for Removal- Account Receivable)",
      "28:1441ad" : "28:1441ad (28:1441 Petition for Removal - Appeal from Administrative Decision)",
      "28:1441al" : "28:1441al (28:1441 Petition for Removal- Airline Crash)",
      "28:1441as" : "28:1441as (28:1441 Petition for Removal- Asbestos Litigation)",
      "28:1441au" : "28:1441au (28:1441 Petition for Removal- Auto Negligence)",
      "28:1441bc" : "28:1441bc (28:1441 Petition for Removal- Breach of Contract)",
      "28:1441cr" : "28:1441cr (28:1441 Petition for Removal - Civil Rights)",
      "28:1441cv" : "28:1441cv (28:1441 Petition for Removal- Civil Rights Act)",
      "28:1441cve" : "28:1441cve (28:1441 Petition for Removal- Civil Rights: Employment)",
      "28:1441df" : "28:1441df (28:1441 Petition for Removal- Contract Default)",
      "28:1441dj" : "28:1441dj (28:1441 Petition for Removal- Declaratory Judgemen)",
      "28:1441ds" : "28:1441ds (28:1441 Petition for Removal- Contract Dispute)",
      "28:1441ed" : "28:1441ed (28:1441 Petition for Removal - Employment Discrim)",
      "28:1441er" : "28:1441er (28:1441 Petition for Removal- ERISA)",
      "28:1441fc" : "28:1441fc (28:1441 Petition for Removal - Fair Credit Reporti)",
      "28:1441fl" : "28:1441fl (28:1441 Petition for Removal- Fair Labor Standards Act)",
      "28:1441fm" : "28:1441fm (28:1441 Petition for Removal- FMLA)",
      "28:1441fr" : "28:1441fr (28:1441 Petition for Removal- Fraud)",
      "28:1441ij" : "28:1441ij (28:1441 Petition for Removal- Injunctive/Declarato)",
      "28:1441in" : "28:1441in (28:1441 Petition for Removal- Insurance Contract)",
      "28:1441int" : "28:1441int (28:1441 Petition for Removal- Action for Interplea)",
      "28:1441lb" : "28:1441lb (28:1441 Petition for Removal Libel,Assault,Slander)",
      "28:1441lc" : "28:1441lc (28:1441 Petition for Removal - Land Condemnation)",
      "28:1441lm" : "28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relatio)",
      "28:1441mm" : "28:1441mm (28:1441 Petition for Removal- Medical Malpractice)",
      "28:1441ni" : "28:1441ni (28:1441 Petition for Removal- Negotiable Instrumen)",
      "28:1441nl" : "28:1441nl (28:1441 Petition for Removal-Notice of Levy )",
      "28:1441nm" : "28:1441nm (28:1441 Petition for Removal- Non-Motor Vehicle)",
      "28:1441oc" : "28:1441oc (28:1441 Petition For Removal--Other Contract)",
      "28:1441ocr" : "28:1441ocr (28:1441 Petition for Removal - Other Civil Rights)",
      "28:1441pc" : "28:1441pc (28:1441 Petition for Removal-Prisoner Civil Rights )",
      "28:1441pd" : "28:1441pd (28:1441 Petition for Removal- Property Damage)",
      "28:1441pi" : "28:1441pi (28:1441 Petition for Removal- Personal Injury)",
      "28:1441pl" : "28:1441pl (28:1441 Petition for Removal- Product Liability)",
      "28:1441pr" : "28:1441pr (28:1441 Petition for Removal)",
      "28:1441qt" : "28:1441qt (28:1441 Petition for Removal- Petition to Quiet Ti)",
      "28:1441ri" : "28:1441ri (28:1441 Petition for Removal- Racketeering (RICO))",
      "28:1441ro" : "28:1441ro (28:1441 Recovery of Overpayment & Enforcement of Judgment )",
      "28:1441sa" : "28:1441sa (28:1441 Petition for Removal- SEC Act)",
      "28:1441sf" : "28:1441sf (28:1441 - Petition for Removal: Securities Fraud)",
      "28:1441tl" : "28:1441tl (28:1441 Petition for Removal- Torts to Land)",
      "28:1441tm" : "28:1441tm (28:1441 Petition for Removal- Tort/Motor Vehicle ()",
      "28:1441tn" : "28:1441tn (28:1441 Petition for Removal- Tort/Non-Motor Vehic)",
      "28:1441wd" : "28:1441wd (28:1441 Petition for Removal- Wrongful Death)",
      "28:1442bc" : "28:1442bc (28:1442 Petition for Removal- Breach of Contract)",
      "28:1442pr" : "28:1442pr (28:1442 Petition for Removal)",
      "28:1443" : "28:1443 (28:1443 Petition for Removal- Rent, Lease & Ejectment)",
      "28:1443cr" : "28:1443cr (28:1443 Petition for Removal- Criminal Case Re: Civil Rights)",
      "28:1444" : "28:1444 (28:1444 Petition for Removal- Foreclosure)",
      "28:1446in" : "28:1446in (28:1446 Breach of Contract- Insurance)",
      "28:1446or" : "28:1446or (28:1446 Petition for Removal-Other Civil Rights )",
      "28:1446pd" : "28:1446pd (28:1446 Petition for Removal- Property Damage (P.I)",
      "28:1446pi" : "28:1446pi (28:1446 Petition for Removal- Personal Injury)",
      "28:1446pl" : "28:1446pl (28:1446pl Petition for Removal - Product Liability)",
      "28:1446pr" : "28:1446pr (28:1446 Petition for Removal)",
      "28:1452" : "28:1452 (28:1452 Removal of Claim Related to Bankruptcy Case)",
      "28:1651" : "28:1651 (28:1651 Petition for Writ of Coram Nobis)",
      "28:1651hc" : "28:1651hc (28:1651 Petition for Writ of Habeas Corpus)",
      "28:1651mn" : "28:1651mn (28:1651 Petition for Writ of Mandamus)",
      "28:1983" : "28:1983 (28:1983 Civil Rights)",
      "28:2201" : "28:2201 (28:2201 Constitutionality of State Statute(s))",
      "28:2201dj" : "28:2201dj (28:2201 Declaratory Judgment)",
      "28:2201ij" : "28:2201ij (28:2201 Injunction)",
      "28:2201in" : "28:2201in (28:2201 Declaratory Judgement (Insurance))",
      "28:2241" : "28:2241 (28:2241 Petition for Writ of Habeas Corpus)",
      "28:2254" : "28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))",
      "28:2254se" : "28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)",
      "28:2255" : "28:2255 (28:2255 Motion to Vacate / Correct Illegal Sentenc)",
      "28:2271" : "28:2271 (28:2271 Federal Tort Claims Act)",
      "28:2345" : "28:2345 (28:2345 Medicare Recovery)",
      "28:2409" : "28:2409 (28:2409(a) Quiet Title Action)",
      "28:2410" : "28:2410 (28:2410 Quiet Title)",
      "28:2671" : "28:2671 (28:2671 Federal Tort Claims Act)",
      "28:2674" : "28:2674 (28:2674 Federal Tort Claims Act)",
      "28:2679" : "28:2679 (28:2679 Petition for Removal - Tort Claims Procedure)",
      "28:7402" : "28:7402 (28:7402 Refund of Taxes)",
      "28:7422" : "28:7422 (28:7422 Appeal from Administrative Decision)",
      "29:0141" : "29:0141 (29:141 Labor Management Relations Act of 1947 )",
      "29:0151" : "29:0151 (29:151 Labor: Review of Agency Action)",
      "29:0160" : "29:0160 (29:160(1) National Labor Relations Act)",
      "29:0184" : "29:0184 (29:184 Violation Collection Bargain Agreement)",
      "29:0185ep" : "29:0185ep (29:185 Employee Pension Plan)",
      "29:0185lm" : "29:0185lm (29:185 Labor/Mgt. Relations (Contracts))",
      "29:0201do" : "29:0201do (29:201 Denial of Overtime Compensation)",
      "29:0201fl" : "29:0201fl (29:201 Fair Labor Standards Act)",
      "29:0203" : "29:0203 (29:203 Equal Pay Act)",
      "29:0206" : "29:0206 (29:206 Collect Unpaid Wages)",
      "29:0401" : "29:0401 (29:0401 Labor Management Disclosure Act)",
      "29:0504" : "29:0504 (29:0504 Labor - Prohibition re holding office )",
      "29:0621" : "29:0621 (29:621 Job Discrimination (Age))",
      "29:0623" : "29:0623 (29:623 Job Discrimination (Age))",
      "29:0626" : "29:0626 (29:626 Job Discrimination (Age))",
      "29:0633" : "29:0633 (29:633 Job Discrimination (Age))",
      "29:0651" : "29:0651 (29:651 Occupational Safety/Health)",
      "29:0754" : "29:0754 (29:754 Discrimination)",
      "29:0790" : "29:0790 (29:790 Rehabilitation of Labor)",
      "29:0791" : "29:0791 (29:791 Job Discrimination (Rehabilitation Act))",
      "29:0794" : "29:0794 (29:0794 Job Discrimination (Handicap))",
      "29:0825" : "29:0825 (29:825 The Family and Medical Leave Act of 1993 )",
      "29:1001" : "29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)",
      "29:1002" : "29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)",
      "29:1104" : "29:1104 (29:1104 Recovery of Benefits to Employee)",
      "29:1109" : "29:1109 (29:1109 Breach of Fiduciary Duties)",
      "29:1131" : "29:1131 (29:1131 ERISA - Collection of Delinquent Trust Fund)",
      "29:1132" : "29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)",
      "29:1144" : "29:1144 (29:1144 ERISA - other laws )",
      "29:1145" : "29:1145 (29:1145 E.R.I.S.A.)",
      "29:1149" : "29:1149 (29:1149 Recover Pension & Profit Sharing)",
      "29:1161" : "29:1161 (29:1161 Health Benefits under COBRA )",
      "29:1185" : "29:1185 (29:1185 Federal Women's Health and Cancer Rights Act of 1998)",
      "29:1337" : "29:1337 (29:1337 E.R.I.S.A.)",
      "29:1362" : "29:1362 (29:1362 ERISA)",
      "29:1381" : "29:1381 (29:1381 E.R.I.S.A.)",
      "29:1401" : "29:1401 (29:1401(b)(2) Appeal of Arbitration Award)",
      "29:1451" : "29:1451 (29:1451 E.R.I.S.A.)",
      "29:1801" : "29:1801 (29:1801 Farmworker Rights)",
      "29:2001" : "29:2001 (29:2001 Employee Polygraph Protection Act )",
      "29:2101" : "29:2101 (29:2101 Worker Adjustment and Retraining Notification Act)",
      "29:2601" : "29:2601 (29:2601 Violation of the Family and Medical Leave Act)",
      "30:0181" : "30:0181 (30:181 Environment: Review of Agency Action)",
      "30:0801" : "30:0801 (30:0801 Penalities/Federal Mine Safety Health Act)",
      "30:1201" : "30:1201 (30:1201 Environment: Review of Agency Action)",
      "30:1202" : "30:1202 (30:1202 Mining Reclamation Act)",
      "30:1276" : "30:1276 (30:1276 Interior: Review of Agency Action)",
      "31:3545" : "31:3545 (31:3545 Action to Recovery Money)",
      "31:3701" : "31:3701 (31:3701 Negotiable Instruments )",
      "31:3729" : "31:3729 (31:3729 False Claims Act)",
      "31:3729mf" : "31:3729mf (31:3729 Money and Finance False Claims)",
      "31:3730" : "31:3730 (31:3730 Qui Tam False Claims Act)",
      "31:3731" : "31:3731 (31:3731 Fraud)",
      "33:1319cw" : "33:1319cw (33:1319 Clean Water Act)",
      "33:1319pv" : "33:1319pv (33:1319 Pollutants & Permit Violations)",
      "33:1365" : "33:1365 (33:1365 Environmental Matters)",
      "35:0145" : "35:0145 (35:145 Patent Infringement)",
      "35:0183" : "35:0183 (35:183 Patent Infringement)",
      "35:0271" : "35:0271 (35:271 Patent Infringement)",
      "35:0284" : "35:0284 (35:284 Patent Infringement - Damages )",
      "35:1331" : "35:1331 (35:1331 Patent Infringement )",
      "38:1681" : "38:1681 (38:1681 Recovery of VA Overpayment)",
      "38:1686" : "38:1686 (38:1686 Recovery of VA Overpayment)",
      "38:1780" : "38:1780 (38:1780 Recovery of VA Overpayment)",
      "38:2011" : "38:2011 (38:2011 - Veteran's Readjustment Assistance Act of)",
      "38:3116" : "38:3116 (38:3116 VA Overpayment)",
      "38:4301" : "38:4301 (38:4301 Uniformed Services Employment and Reemployment Rights Act)",
      "39:0409" : "39:0409 (39:409 Postal Service )",
      "39:3005" : "39:3005 (39:3005 Detention of Mail for Temporary Periods)",
      "39:409" : "39:409 (39:409 Postal Service)",
      "40:0258" : "40:0258 (40:258(a) Public Buildings & Property: Land Condem)",
      "40:0270" : "40:0270 (40:270 Miller Act)",
      "40:0875" : "40:0875 (40:875 Public Buildings & Property: Negligence)",
      "41:0251" : "41:0251 (41:251 Public Contracts-Review of Agency Action)",
      "41:1463" : "41:1463 (41:1463 Public Contracts: Unlawful Employment Prac)",
      "42:0205" : "42:0205 (42:205 Denial Social Security Benefits)",
      "42:0206" : "42:0206 (42:206 Social Security Benefits)",
      "42:0247" : "42:0247 (42:247 Personal Injury-Swine Flu)",
      "42:0402" : "42:0402 (42:402 Social Security Benefits)",
      "42:0405id" : "42:0405id (42:405 Review of Social Security Decision (SSID))",
      "42:0405si" : "42:0405si (42:405 Review of Social Security Decision (RSI))",
      "42:0405wc" : "42:0405wc (42:405 Review of Social Security Decision (DIWC))",
      "42:0405ww" : "42:0405ww (42:405 Review of Social Security Decision (DIWW))",
      "42:0416" : "42:0416 (42:416 Denial of Social Security Benefits)",
      "42:0423" : "42:0423 (42:423 Review of HHS Decision )",
      "42:0425" : "42:0425 (42:425 Social Security Benefits )",
      "42:0427" : "42:0427 (42:427 Social Security Benefits)",
      "42:0666a13" : "42:0666a13 (42:666(a)(13)(A) Recording of Social Security Numbers )",
      "42:11601" : "42:11601 (42:11601 International Child Abduction Remedies Act)",
      "42:11603" : "42:11603 (42:11603 International Child Abduction Judicial Remedies)",
      "42:12101" : "42:12101 (42:12101 American Disability Act for Handicappers)",
      "42:12111" : "42:12111 (42:12111 American Disability Act)",
      "42:12112" : "42:12112 (42:12112 American With Disabilities Act- Discrimination)",
      "42:12117" : "42:12117 (42:12117 Americans With Disabilities Act- Enforcement)",
      "42:12133" : "42:12133 (42:12133 Americans with Disabilities Act - Enforcement )",
      "42:1383" : "42:1383 (42:1383 Review of HHS Decision)",
      "42:1395" : "42:1395 (42:1395 HHS: Adverse Reimbursement Review)",
      "42:1396" : "42:1396 (42:1396 - Tort Negligence)",
      "42:1471" : "42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclo)",
      "42:1973ff" : "42:1973ff (42:1973ff Uniformed & Overseas Citizens Absentee Voting Act )",
      "42:1981" : "42:1981 (42:1981 Civil Rights-Jobs )",
      "42:1981cv" : "42:1981cv (42:1981 Civil Rights)",
      "42:1981hs" : "42:1981hs (42:1981 Housing Discrimination)",
      "42:1981jb" : "42:1981jb (42:1981 Job Discrimination (Race))",
      "42:1981sx" : "42:1981sx (42:1981 Sex Discrimination)",
      "42:1983" : "42:1983 (42:1983 Other Civil Rights )",
      "42:1983cv" : "42:1983cv (42:1983 Civil Rights Act)",
      "42:1983ed" : "42:1983ed (42:1983 Civil Rights (Employment Discrimination))",
      "42:1983ocv" : "42:1983ocv (42:1983 Other Civil Rights)",
      "42:1983pr" : "42:1983pr (42:1983 Prisoner Civil Rights)",
      "42:1986" : "42:1986 (42:1986 Neglect of Duty)",
      "42:2000ag" : "42:2000ag (42:2000 Job Discrimination (Age))",
      "42:2000e" : "42:2000e (42:2000e Job Discrimination (Employment))",
      "42:2000pb" : "42:2000pb (42:2000 Job Discrimination (Public Accomodations))",
      "42:2000ra" : "42:2000ra (42:2000 Job Discrimination (Race))",
      "42:2000sx" : "42:2000sx (42:2000 Job Discrimination (Sex))",
      "42:2003" : "42:2003 (42:2003 Job Discrimination)",
      "42:2005" : "42:2005 (42:2005 Review of Agency Action-HHS)",
      "42:2651" : "42:2651 (42:2651 Medical Care Recovery)",
      "42:3601" : "42:3601 (42:3601 Fair Housing Act)",
      "42:4000" : "42:4000 (42:4000 National Flood Insurance Act)",
      "42:4001" : "42:4001 (42:4001 National Insurance Flood Act)",
      "42:4053" : "42:4053 (42:4053 Breach of Insurance Contract)",
      "42:4072" : "42:4072 (42:4072 Payment of Flood Insurance Claim)",
      "42:4321" : "42:4321 (42:4321 Review of Agency Action-Environment)",
      "42:4332" : "42:4332 (42:4332 Environmental Policy - Coop of Agency Repo)",
      "42:6901en" : "42:6901en (42:6901 Environmental Cleanup Expenses)",
      "42:6901rs" : "42:6901rs (42:6901 Resource & Recovery Act)",
      "42:6928" : "42:6928 (42:6928 Environmental Protection Agency Rules Violation )",
      "42:7413" : "42:7413 (42:7413(b) Clean Air Act)",
      "42:7604cl" : "42:7604cl (42:7604 Clear Air Act (Emission Standards))",
      "42:7604ir" : "42:7604ir (42:7604 Petition to Quash IRS Summons)",
      "42:9601" : "42:9601 (42:9601 Environmental Matters )",
      "42:9606" : "42:9606 (42:9606 Environmental Matters - Abatement Actions )",
      "42:9607" : "42:9607 (42:9607 Real Property Tort to Land)",
      "42:9613" : "42:9613 (42:9613 Environmental Matters)",
      "43:0945" : "43:0945 (43:945 Compensation for Land Condemnation )",
      "43:0945a" : "43:0945a (43:945(a) Complaint in Condemnation )",
      "43:0946" : "43:0946 (43:946 Complaint in Condemnation-Eminent Domain )",
      "43:945" : "43:945 (43:945 Compensation for Land Condemnation)",
      "43:945a" : "43:945a (43:945a Complaint in Condemnation)",
      "43:946" : "43:946 (43:946 Complaint in Condemnation - Eminent Domain)",
      "45:0051" : "45:0051 (45:51 Railways: Fed. Employer's Liability Act)",
      "45:0151" : "45:0151 (45:151 Railway Labor Act)",
      "45:0184" : "45:0184 (45:184 Action to Set Aside Award of a System Board)",
      "45:1395" : "45:1395 (45:1395 Railroads: Adverse Reimbursement Review)",
      "45:7457" : "45:7457 (45:7457 Compel Reclamation Under Clear Air Act)",
      "46:0063" : "46:0063 (46:63 Marine Personal Injury )",
      "46:0183" : "46:0183 (46:0183 Shipping; Amount of Liability)",
      "46:0188" : "46:0188 (46:0188 Limitation of liability of owners-vessels )",
      "46:0688" : "46:0688 (46:688 Jones Act)",
      "46:0688mp" : "46:0688mp (46:688 Maritime Personal Injury )",
      "46:0741" : "46:0741 (46:741 Shipping)",
      "46:0761" : "46:0761 (46:761 Shipping: Damages for Death on High Seas)",
      "46:1101" : "46:1101 (46:1101 Violation of Maritime Regulations)",
      "46:1156" : "46:1156 (46:1156 Administrative Procedure Act)",
      "46:3134" : "46:3134 (46:3134 Marine Contract Action)",
      "47:0151" : "47:0151 (47:151 Telecommunications Act of 1996 )",
      "47:0227" : "47:0227 (47:227 Restrictions on the use of telephone equipment)",
      "47:0251" : "47:0251 (47:0251 Telecommunications Act of 1966- Interconnection)",
      "47:0252" : "47:0252 (47:252 Telecommunications Act of 1996)",
      "47:0302" : "47:0302 (47:302 Forfeiture-FCC Violations )",
      "47:0332" : "47:0332 (47:332 Federal Telecommunications Act of 1996 )",
      "47:0504" : "47:0504 (47:504 Communications Act-Forfeiture )",
      "47:0510" : "47:0510 (47:510 Forfeiture of Communications Devices )",
      "47:0541" : "47:0541 (47:541 Cable Communications Policy Act )",
      "47:0546" : "47:0546 (47:546 Cable Communications Policy Act of 1984 )",
      "47:0553" : "47:0553 (47:553 Unauthorized reception of cable service )",
      "47:0605" : "47:0605 (47:605 Unauthorized publication or use of communications)",
      "48:0883" : "48:0883 (48:883 Violation of US Coastal Law)",
      "48:1985" : "48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)",
      "49:0081" : "49:0081 (49:81 Damaged Goods While Being Transported)",
      "49:0781" : "49:0781 (49:781 Forfeiture)",
      "49:10101" : "49:10101 (49:10101 Rail Transportation Policy )",
      "49:10743" : "49:10743 (49:10743 Revised Interstate Commerce Act )",
      "49:11503" : "49:11503 (49:11503 Railroad Revitalization Regulatory Reform)",
      "49:11702" : "49:11702 (49:11702(a)(4) Violations of Interstate Commerce A)",
      "49:1374" : "49:1374 (49:1374(c) Rates for carriage of persons and property )",
      "49:1471" : "49:1471 (49:1471 Federal Aviation Act)",
      "49:1903" : "49:1903 (49:1903 Petition to enforce administrative summon)",
      "49:32710" : "49:32710 (49:32710 Odometer Tampering )",
      "49:41705" : "49:41705 (49:41705 Air Carriers Access Act )",
      "misc" : "misc (Civil Miscellaneous Case)"
   },
   "mndce" : {
      "0" : "0 (No cause code entered)",
      "02:0431" : "02:0431 (02:431 Fed. Election Commission: Failure Enforce C)",
      "02:0437" : "02:0437 (02:437 Federal Election Commission)",
      "05:0075" : "05:0075 (05:75(2) Contract - Reduction in Grade)",
      "05:0551" : "05:0551 (05:551 Administrative Procedure Act)",
      "05:0552fi" : "05:0552fi (05:552 Freedom of Information Act)",
      "05:0552pa" : "05:0552pa (05:552 Right to Privacy Act)",
      "05:0554" : "05:0554 (05:0554 Constitutionality of Maritime Statutes)",
      "05:0701" : "05:0701 (05:0701 Maritime Subsidy Board)",
      "05:0701(a)" : "05:0701(a) (05:0701(a) Petition for judicial review - VA)",
      "05:0702" : "05:0702 (05:702 Administrative Procedure Act)",
      "05:0704" : "05:0704 (05:704 Labor Litigation)",
      "05:1508" : "05:1508 (05:1508 Petition for judicial review - Hatch Act)",
      "05:7703" : "05:7703 (05:7703 Discrimination - Review of Agency Act)",
      "07:0006" : "07:0006 (7:6(b) Federal Commodity Exchange Regulation)",
      "07:0025" : "07:0025 (7:25 Fraud - Commodities Leverage Contracts)",
      "07:0181" : "07:0181 (07:181 Packers & Stockyard Act)",
      "07:0499" : "07:0499 (07:499 Agricultural Commodities Act)",
      "07:0601" : "07:0601 (07:601 USDA Condemnation)",
      "07:1421" : "07:1421 (07:1421 Agricultural Act for 1949)",
      "07:2022" : "07:2022 (07:2022 Review of administrative decision - Food Stamp Program)",
      "07:2023" : "07:2023 (07:2023 Food Stamp Act)",
      "07:2321" : "07:2321 (07:2321 Plant Variety Protection Act)",
      "08:1101" : "08:1101 (Immigration and Nationality Act)",
      "08:1105" : "08:1105 (8:1105(a) Aliens: Habeas Corpus to Release INS Det)",
      "08:1252" : "08:1252 (08:1252(a)(2) Injunction for Deportation)",
      "08:1260" : "08:1260 (08:1260 Aliens: Access to Records)",
      "08:1324" : "08:1324 (08:1324 Aliens: Complaint for Forfeiture)",
      "08:1329" : "08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petiti)",
      "08:1446" : "08:1446 (8:1446 Petition for Naturalization Hearing)",
      "08:1451" : "08:1451 (08:1451 Immigration: Revocation of Citizenship)",
      "08:1451a" : "08:1451a (08:1451a Action to revoke Citizenship)",
      "08:1451j" : "08:1451j (08:1451(j) Immigration: Motion to Correct Order & Judg. of Naturalization)",
      "09:0001" : "09:0001 (09:1 U.S. Arbitration Act)",
      "09:0009" : "09:0009 (9:9 Motion to Confirm Arbitration Loan)",
      "09:0010" : "09:0010 (09:0010 Petition to Vacate Arbitration Award)",
      "10:1552" : "10:1552 (10:1552 Armed Forces: Action to Correct Records)",
      "10:1553" : "10:1553 (10:1553 Armed Forces: FOIA General)",
      "10:2305" : "10:2305 (10:2305 Review of Federal Contract)",
      "11:0101" : "11:0101 (11:101 Bankruptcy)",
      "12:0022" : "12:0022 (12:22 Securities Fraud)",
      "12:0635" : "12:0635 (12:635 Breach of Insurance Contract)",
      "12:1441a" : "12:1441a (12:1441a Rental Overcharges)",
      "12:1461" : "12:1461 (12:1461 Homeowners Loan Act)",
      "12:1703" : "12:1703 (12:1703 Default of HUD Loan)",
      "12:1725" : "12:1725 (12:1725 Collection under Contract Guaranty)",
      "12:1730" : "12:1730 (12:1730 Collection Under Contract Guaranty)",
      "12:1819" : "12:1819 (12:1819 Default of Promissory Note)",
      "12:1821" : "12:1821 (12:1821 Default of Loan by Promissary Note)",
      "12:1831d" : "12:1831d (12:1831d Depository Inst. Dereg. and Monetary Control Act of 1980)",
      "12:1971" : "12:1971 (12:1971 Relief under Bank Holding Act)",
      "12:2609" : "12:2609 (12:2609 Real Estate Settlement Procedures Act)",
      "12:3401" : "12:3401 (12:3401 Right to Financial Privacy Act)",
      "12:3410" : "12:3410 (12:3410 Right to Financial Privacy Act)",
      "12:4004" : "12:4004 (12:4004(a) Expedited Funds Availability Act)",
      "15:0001" : "15:0001 (15:1 Antitrust Litigation)",
      "15:0002at" : "15:0002at (15:2 Antitrust Litigation)",
      "15:0002fl" : "15:0002fl (15:2(a) Fair Labor Standards Act)",
      "15:0005" : "15:0005 (15:5(a) Fair Labor Standards Act)",
      "15:0015" : "15:0015 (15:15 Antitrust Litigation)",
      "15:0025" : "15:0025 (15:25 Clayton Act)",
      "15:0044" : "15:0044 (15:44 Trademark Infringement)",
      "15:0045" : "15:0045 (15:0045 Federal Trade Commission Act)",
      "15:0052" : "15:0052 (15:0052 Federal Trade Commission Act)",
      "15:0053" : "15:0053 (15:0053 Federal Trade Commission Act)",
      "15:0077" : "15:0077 (15:77 Securities Fraud)",
      "15:0078" : "15:0078 (15:78m(a) Securities Exchange Act)",
      "15:0631" : "15:0631 (15:631 Small Business Act)",
      "15:0717" : "15:0717 (15:717 Natural Gas Act)",
      "15:1051" : "15:1051 (15:1051 Trademark Infringement)",
      "15:1114" : "15:1114 (15:1114 Trademark Infringement)",
      "15:1121" : "15:1121 (15:1121 Trademark Infringement)",
      "15:1125" : "15:1125 (15:1125 Trademark Infringement (Lanham Act))",
      "15:1126" : "15:1126 (15:1126 Patent Infringement)",
      "15:1127" : "15:1127 (15:1127 Trademark Infringement)",
      "15:1221" : "15:1221 (15:1221 Automobile Dealer Suits Against Manufacturer)",
      "15:1601" : "15:1601 (15:1601 Truth in Lending)",
      "15:1640" : "15:1640 (15:1640 Truth in Lending)",
      "15:1681" : "15:1681 (15:1681 Fair Credit Reporting Act)",
      "15:1691" : "15:1691 (15:1691 Equal Credit Opportunity Act)",
      "15:1692" : "15:1692 (15:1692 Fair Debt Collection Act)",
      "15:1693" : "15:1693 (15:1693 Electronic Fund Transfer Act)",
      "15:1938" : "15:1938 (15:1938 Fair Labor Standards Act)",
      "15:1981" : "15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))",
      "15:1988" : "15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))",
      "15:1989" : "15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))",
      "15:2301" : "15:2301 (15:2301 Magnuson-Moss Warranty Act)",
      "15:2801" : "15:2801 (15:2801 Petroleum Marketing Practices Act)",
      "15:53(b)" : "15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equita)",
      "16:0668" : "16:0668 (16:668 Bald Eagle Protection Act)",
      "16:0703" : "16:0703 (16:703 Migratory Bird Act)",
      "16:1538" : "16:1538 (16:1538 Endangered Species Act)",
      "16:3371" : "16:3371 (16:3371 Wildlife Under the Lacey Act)",
      "16:3372" : "16:3372 (16:3372 Conservation: Complaint for Forfeiture)",
      "16:3373" : "16:3373 (16:3373 Appeal of Decision - DOI)",
      "16:3374" : "16:3374 (16:3374 Conservation: Complaint for Forfeiture)",
      "17:0101" : "17:0101 (17:101 Copyright Infringement)",
      "17:0501" : "17:0501 (17:501 Copyright Infringement)",
      "17:0504" : "17:0504 (17:504 Copyright Infringement)",
      "18:0241" : "18:0241 (18:241 Conspiracy Against Citizen Rights)",
      "18:1345" : "18:1345 (18:1345 Injunctions against fraud)",
      "18:1836a" : "18:1836a (18:1836(a) Injunction against Misappropriation of Trade Secrets)",
      "18:1836b" : "18:1836b (18:1836(b) Civil Action to Protect Trade Secrets)",
      "18:1961" : "18:1961 (18:1961 Racketeering (RICO) Act)",
      "18:1962" : "18:1962 (18:1962 Racketeering (RICO) Act)",
      "18:1964" : "18:1964 (18:1964 Racketeering (RICO) Act)",
      "18:2510" : "18:2510 (18:2510 Wire or Oral Communications)",
      "18:2520" : "18:2520 (18:2520 Interception of Wire/Oral Communication)",
      "18:2710(c)" : "18:2710(c) (18:2710(c) Wrongful disclosure of video tape data)",
      "18:2724" : "18:2724 (18:2724 Civil Action - Motor Vehicle Records)",
      "18:4208" : "18:4208 (18:4208(B) Agency Action Review)",
      "18:4245" : "18:4245 (18:4245 Petition to Determine Mental Condition of Imprisoned Person)",
      "18:4246" : "18:4246 (18:4246 Petition to Determine Present Mental Condition of Imprisoned Person)",
      "19:1305" : "19:1305 (19:1305 Custom Duties:0Forfeiture-Immoral Articles)",
      "19:1433" : "19:1433 (19:1433 Failure to notify U. S. Customs prior to U. S. Entry)",
      "20:1080" : "20:1080 (20:1080 Student Loan Recovery)",
      "20:1400" : "20:1400 (20:1400 Civil Rights of Handicapped Child)",
      "20:1401" : "20:1401 (20:1401 Education: Handicapped Child Act)",
      "20:1415" : "20:1415 (20:1415 IDEA - Individuals with Disabilities Education Act)",
      "20:1681" : "20:1681 (20:1681 Sex/Blindness Discrimination in Educational Programs)",
      "21:0332" : "21:0332 (21:0332 Injunction to Restrain Violations of Prohibitions 331)",
      "21:0334(a)" : "21:0334(a) (21:0334(a) Forfeiture - Food, Drugs, Cosmetics)",
      "21:0841" : "21:0841 (21:841 Forfeiture Property-Drugs)",
      "21:0881" : "21:0881 (21:881 Forfeiture Property-Drugs)",
      "21:0881a" : "21:0881a (21:881 Forfeiture Property - Aircraft)",
      "21:0881re" : "21:0881re (21:881 Forfeiture Property - Real Estate)",
      "23:0134" : "23:0134 (23:134 P.I.- Auto Negligence)",
      "23:1441" : "23:1441 (23:1441 Contract Real Estate)",
      "24:1000" : "24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)",
      "25:0081" : "25:0081 (25:0081 Contracts with Indian Tribes or Indians)",
      "25:0461" : "25:0461 (25:0461 Indian Reorganization Act)",
      "25:0640" : "25:0640 (25:640 Indian Tribal Rights)",
      "25:1302" : "25:1302 (25:1302 Indian Civil Rights Act)",
      "25:1901" : "25:1901 (25:1901 Indian Child Welfare Act)",
      "25:2601" : "25:2601 (25:2601 Indian Education Act)",
      "25:2701" : "25:2701 (25:2701 Indian Gaming Regulatory Act of 1988)",
      "26:6011" : "26:6011 (26:6011 - Taxes-General requirement of return, statement or list)",
      "26:6212" : "26:6212 (26:6212 Injunctive Relief from IRS Lien)",
      "26:6213" : "26:6213 (26:6213 Injunctive Relief from IRS Lien)",
      "26:6502" : "26:6502 (26:6502 IRS:Enforcement of tax liens)",
      "26:6532" : "26:6532 (26:6532 IRS: Refund of Tax Penalty)",
      "26:6702" : "26:6702 (26:6702 IRS: Refund of Income Tax Penalty)",
      "26:6703" : "26:6703 (26:6703 IRS: Refund of Tax Penalty)",
      "26:7401" : "26:7401 (26:7401 IRS: Tax Liability)",
      "26:7402" : "26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)",
      "26:7403" : "26:7403 (26:7403 Suit to Enforce Federal Tax Lien)",
      "26:7422rt" : "26:7422rt (26:7422 IRS: Refund Taxes)",
      "26:7422rx" : "26:7422rx (26:7422 IRS: Refund Excise Tax)",
      "26:7426" : "26:7426 (26:7426 IRS: Wrongful Levy for Taxes)",
      "26:7429" : "26:7429 (26:7429 IRS: Tax Jeopardy Assessment)",
      "26:7609" : "26:7609 (26:7609 IRS: Petition to Quash IRS Summons)",
      "27:0185" : "27:0185 (27:185 Enforcement of Arbitration Award)",
      "28:0157" : "28:0157 (28:0157 Transfer of Adversary Proceeding)",
      "28:0157c" : "28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)",
      "28:0157d" : "28:0157d (28:0157 Motion for Withdrawal of Reference)",
      "28:0158" : "28:0158 (28:0158 Notice of Appeal re Bankruptcy Matter (BA)",
      "28:0185" : "28:0185 (28:185 Suit to Compel Arbitration)",
      "28:0451" : "28:0451 (28:451 Employment Discrimination)",
      "28:0794" : "28:0794 (28:794 Rehabilitation Act)",
      "28:1001" : "28:1001 (28:1001 E.R.I.S.A.)",
      "28:1132" : "28:1132 (28:1132 E.R.I.S.A.)",
      "28:1330" : "28:1330 (28:1330 Breach of Contract)",
      "28:1331" : "28:1331 (28:1331 Fed. Question)",
      "28:1331al" : "28:1331al (28:1331 Fed. Question: Airline Crash)",
      "28:1331at" : "28:1331at (28:1331 Fed. Question: Anti-trust)",
      "28:1331au" : "28:1331au (28:1331 Fed. Question: Auto Negligence)",
      "28:1331b" : "28:1331b (28:1331 Federal Question: Bivens Act)",
      "28:1331bc" : "28:1331bc (28:1331 Fed. Question: Breach of Contract)",
      "28:1331ca" : "28:1331ca (28:1331 Fed Question: Fed Communications Act of 1)",
      "28:1331cm" : "28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)",
      "28:1331cv" : "28:1331cv (28:1331 Federal Question: Other Civil Rights)",
      "28:1331ed" : "28:1331ed (28:1331 Fed. Question: Employment Discrimination)",
      "28:1331es" : "28:1331es (28:1331 Enforcement of Administrative Subpoena)",
      "28:1331fl" : "28:1331fl (28:1331 Fed. Question: Fair Labor Standards)",
      "28:1331in" : "28:1331in (28:1331 Fed. Question: Insurance Contract)",
      "28:1331mm" : "28:1331mm (28:1331 Fed. Question: Medical Malpractice)",
      "28:1331pi" : "28:1331pi (28:1331 Fed. Question: Personal Injury)",
      "28:1331rd" : "28:1331rd (28:1331 Fed. Question: Review Agency Decision)",
      "28:1331rp" : "28:1331rp (28:1331(a) Fed. Question: Real Property)",
      "28:1331rr" : "28:1331rr (28:1331 Fed. Question: Railway Labor Act)",
      "28:1331sv" : "28:1331sv (28:1331 Fed. Question: Securities Violation)",
      "28:1331tr" : "28:1331tr (28:1331 Fed. Question: Trademark)",
      "28:1331tt" : "28:1331tt (28:1331 Fed. Question: Tort Action)",
      "28:1331v" : "28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendme)",
      "28:1331wl" : "28:1331wl (28:1331 Federal Question: EPA Waste Lien)",
      "28:1331wt" : "28:1331wt (28:1331 Fed. Question: Water Rights)",
      "28:1332" : "28:1332 (28:1332 Diversity)",
      "28:1332ac" : "28:1332ac (28:1332 Diversity-Account Receivable)",
      "28:1332al" : "28:1332al (28:1332 Diversity-Airline Crash)",
      "28:1332as" : "28:1332as (28:1332 Diversity-Asbestos Litigation)",
      "28:1332au" : "28:1332au (28:1332 Diversity-Auto Negligence)",
      "28:1332bc" : "28:1332bc (28:1332 Diversity-Breach of Contract)",
      "28:1332co" : "28:1332co (28:1332 Diversity-Conversion)",
      "28:1332ct" : "28:1332ct (28:1332 Diversity-(Citizenship))",
      "28:1332det" : "28:1332det (28:1332 Diversity: Forcible Detainer)",
      "28:1332df" : "28:1332df (28:1332 Diversity-Contract Default)",
      "28:1332ds" : "28:1332ds (28:1332 Diversity-Contract Dispute)",
      "28:1332ed" : "28:1332ed (28:1332 Diversity-Employment Discrimination)",
      "28:1332fd" : "28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)",
      "28:1332fr" : "28:1332fr (28:1332 Diversity-Fraud)",
      "28:1332ia" : "28:1332ia (28:1332 Diversity-Interpleader Action)",
      "28:1332ij" : "28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)",
      "28:1332in" : "28:1332in (28:1332 Diversity-Insurance Contract)",
      "28:1332jd" : "28:1332jd (28:1332 Diversity-Declaratory Judgment)",
      "28:1332lb" : "28:1332lb (28:1332 Diversity-Libel,Assault,Slander)",
      "28:1332lm" : "28:1332lm (28:1332 Diversity - Legal Malpractice)",
      "28:1332ma" : "28:1332ma (28:1332 Diversity-Miller Act)",
      "28:1332mm" : "28:1332mm (28:1332 Diversity-Medical Malpractice)",
      "28:1332mv" : "28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)",
      "28:1332ni" : "28:1332ni (28:1332 Diversity-Negotiable Instrument)",
      "28:1332nm" : "28:1332nm (28:1332 Diversity-Non-Motor Vehicle)",
      "28:1332oc" : "28:1332oc (28:1332 Diversity-Other Contract)",
      "28:1332pd" : "28:1332pd (28:1332 Diversity-Property Damage)",
      "28:1332pi" : "28:1332pi (28:1332 Diversity-Personal Injury)",
      "28:1332pip" : "28:1332pip (28:1332-pip-Diversity-Personal Injury, Product Liability)",
      "28:1332pl" : "28:1332pl (28:1332 Diversity-Product Liability)",
      "28:1332pr" : "28:1332pr (28:1332 Diversity-Petition for Removal)",
      "28:1332qt" : "28:1332qt (28:1332 Diversity-Petition to Quiet Title)",
      "28:1332ri" : "28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)",
      "28:1332sa" : "28:1332sa (28:1332 - Diversity: Securities & Exchange Commiss)",
      "28:1332sf" : "28:1332sf (28:1332 - Diversity: Securities Fraud)",
      "28:1332ss" : "28:1332ss (28:1332 Diversity - Stockholders Suits)",
      "28:1332tl" : "28:1332tl (28:1332 Diversity-Torts to Land)",
      "28:1332tm" : "28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))",
      "28:1332tn" : "28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)",
      "28:1332wd" : "28:1332wd (28:1332 Diversity-Wrongful Death)",
      "28:1333" : "28:1333 (28:1333 Admiralty)",
      "28:1334" : "28:1334 (28:1334 Bankruptcy Appeal)",
      "28:1334c" : "28:1334c (28:1334(c) R&R re motions for abstention (non-cor)",
      "28:1335" : "28:1335 (28:1335 Interpleader Action)",
      "28:1337" : "28:1337 (28:1337 Sherman-Clayton Act)",
      "28:1338cp" : "28:1338cp (28:1338 Copyright Infringement)",
      "28:1338pt" : "28:1338pt (28:1338 Patent Infringement)",
      "28:1338tr" : "28:1338tr (28:1338 Trademark Infringement)",
      "28:1340" : "28:1340 (28:1340 IRS: Custom Duties)",
      "28:1340er" : "28:1340er (28:1340 Recovery of Erroneous Refund)",
      "28:1341" : "28:1341 (28:1341 Complaint for Forfeiture)",
      "28:1343" : "28:1343 (28:1343 Violation of Civil Rights)",
      "28:1345co" : "28:1345co (28:1345 Replevin & Conversion)",
      "28:1345db" : "28:1345db (28:1345 Debt to US - FHA/HUD Title I)",
      "28:1345df" : "28:1345df (28:1345 Default of Promissory Note)",
      "28:1345er" : "28:1345er (28:1345 Recovery of Erroneous Refund)",
      "28:1345fc" : "28:1345fc (28:1345 Foreclosure)",
      "28:1345ff" : "28:1345ff (28:1345 Complaint for Forfeiture)",
      "28:1345hl" : "28:1345hl (28:1345 VA Home Loan Guaranty Debt)",
      "28:1345mc" : "28:1345mc (28:1345 Medical Care Recovery)",
      "28:1345mi" : "28:1345mi (28:1345 Mining Claim Ejectment)",
      "28:1345pd" : "28:1345pd (28:1345 Property Damage)",
      "28:1345pe" : "28:1345pe (28:1345 Property Ejectment)",
      "28:1345rc" : "28:1345rc (28:1345 Recovery of Debt to US)",
      "28:1345st" : "28:1345st (28:1345 Default of Student Loan)",
      "28:1345tp" : "28:1345tp (28:1345 Trespass on Public Land)",
      "28:1345va" : "28:1345va (28:1345 Recovery of VA Overpayment)",
      "28:1346bc" : "28:1346bc (28:1346 Breach of Contract)",
      "28:1346rc" : "28:1346rc (28:1346 Recovery of IRS Tax)",
      "28:1346tc" : "28:1346tc (28:1346 Tort Claim)",
      "28:1346wd" : "28:1346wd (28:1346 Wrongful Death)",
      "28:1352" : "28:1352 (28:1352 Miller Act)",
      "28:1355" : "28:1355 (28:1355 Petition for Return of Property)",
      "28:1358" : "28:1358 (28:1358 Land Condemnation)",
      "28:1361" : "28:1361 (28:1361 Petition for Writ of Mandamus)",
      "28:1362ic" : "28:1362ic (28:1362 Indian Tribal Controversy)",
      "28:1362iw" : "28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)",
      "28:1364" : "28:1364 (28:1364 Auto Negligence)",
      "28:1391" : "28:1391 (28:1391 Personal Injury)",
      "28:1402" : "28:1402 (28:1402 Medical Malpractice)",
      "28:1407" : "28:1407 (28:1407 Airline Crash)",
      "28:1441ac" : "28:1441ac (28:1441 Petition for Removal- Account Receivable)",
      "28:1441al" : "28:1441al (28:1441 Petition for Removal- Airline Crash)",
      "28:1441as" : "28:1441as (28:1441 Petition for Removal- Asbestos Litigation)",
      "28:1441au" : "28:1441au (28:1441 Petition for Removal- Auto Negligence)",
      "28:1441bc" : "28:1441bc (28:1441 Petition for Removal- Breach of Contract)",
      "28:1441cv" : "28:1441cv (28:1441 Petition for Removal- Civil Rights Act)",
      "28:1441df" : "28:1441df (28:1441 Petition for Removal- Contract Default)",
      "28:1441dj" : "28:1441dj (28:1441 Petition for Removal- Declaratory Judgemen)",
      "28:1441ds" : "28:1441ds (28:1441 Petition for Removal- Contract Dispute)",
      "28:1441ed" : "28:1441ed (28:1441 Petition for Removal - Employment Discrim)",
      "28:1441fc" : "28:1441fc (28:1441 Petition for Removal - Fair Credit Reporti)",
      "28:1441fr" : "28:1441fr (28:1441 Petition for Removal- Fraud)",
      "28:1441ij" : "28:1441ij (28:1441 Petition for Removal- Injunctive/Declarato)",
      "28:1441in" : "28:1441in (28:1441 Petition for Removal- Insurance Contract)",
      "28:1441int" : "28:1441int (28:1441 Petition for Removal- Action for Interplea)",
      "28:1441lb" : "28:1441lb (28:1441 Petition for Removal Libel,Assault,Slander)",
      "28:1441lm" : "28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relatio)",
      "28:1441mm" : "28:1441mm (28:1441 Petition for Removal- Medical Malpractice)",
      "28:1441ni" : "28:1441ni (28:1441 Petition for Removal- Negotiable Instrumen)",
      "28:1441nm" : "28:1441nm (28:1441 Petition for Removal- Non-Motor Vehicle)",
      "28:1441oc" : "28:1441oc (28:1441 Petition For Removal--Other Contract)",
      "28:1441pd" : "28:1441pd (28:1441 Petition for Removal- Property Damage)",
      "28:1441pi" : "28:1441pi (28:1441 Petition for Removal- Personal Injury)",
      "28:1441pip" : "28:1441pip (28:1441pip-Remove-Personal Injury, Product Liability)",
      "28:1441pl" : "28:1441pl (28:1441 Petition for Removal- Product Liability)",
      "28:1441pr" : "28:1441pr (28:1441 Petition for Removal)",
      "28:1441qt" : "28:1441qt (28:1441 Petition for Removal- Petition to Quiet Ti)",
      "28:1441ri" : "28:1441ri (28:1441 Petition for Removal- Racketeering (RICO))",
      "28:1441sa" : "28:1441sa (28:1441 - Petition for Removal: SEC Act)",
      "28:1441sf" : "28:1441sf (28:1441 - Petition for Removal: Securities Fraud)",
      "28:1441tl" : "28:1441tl (28:1441 Petition for Removal- Torts to Land)",
      "28:1441tm" : "28:1441tm (28:1441 Petition for Removal- Tort/Motor Vehicle ()",
      "28:1441tn" : "28:1441tn (28:1441 Petition for Removal- Tort/Non-Motor Vehic)",
      "28:1441wd" : "28:1441wd (28:1441 Petition for Removal- Wrongful Death)",
      "28:1442bc" : "28:1442bc (28:1442 Petition for Removal- Breach of Contract)",
      "28:1442pr" : "28:1442pr (28:1442 Petition for Removal)",
      "28:1443" : "28:1443 (28:1443(1) Rent, Lease & Ejectment)",
      "28:1444" : "28:1444 (28:1444 Petition for Removal- Foreclosure)",
      "28:1446in" : "28:1446in (28:1446 Breach of Contract- Insurance)",
      "28:1446pd" : "28:1446pd (28:1446 Petition for Removal- Property Damage (P.I)",
      "28:1446pi" : "28:1446pi (28:1446 Petition for Removal- Personal Injury)",
      "28:1446pl" : "28:1446pl (28:1446pl Petition for Removal - Product Liability)",
      "28:1446pr" : "28:1446pr (28:1446 Petition for Removal)",
      "28:1452" : "28:1452 (28:1452 R&R re motions to remand (non-core))",
      "28:157(b)" : "28:157(b) (28:157(b) Transfer of Adversary Proceeding)",
      "28:1651" : "28:1651 (28:1651 Petition for Writ of Coram Nobis)",
      "28:1651hc" : "28:1651hc (28:1651 Petition for Writ of Habeas Corpus)",
      "28:1651mn" : "28:1651mn (28:1651 Petition for Writ of Mandamus)",
      "28:1983" : "28:1983 (28:1983 Civil Rights)",
      "28:2201" : "28:2201 (28:2201 Constitutionality of State Statute(s))",
      "28:2201dj" : "28:2201dj (28:2201 Declaratory Judgment)",
      "28:2201ij" : "28:2201ij (28:2201 Injunction)",
      "28:2201in" : "28:2201in (28:2201 Declaratory Judgment (Insurance))",
      "28:2241" : "28:2241 (28:2241 Petition for Writ of Habeas Corpus (federa)",
      "28:2254" : "28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))",
      "28:2254se" : "28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)",
      "28:2255" : "28:2255 (28:2255 Motion to Vacate / Correct Illegal Sentence)",
      "28:2271" : "28:2271 (28:2271 Federal Tort Claims Act)",
      "28:2345" : "28:2345 (28:2345 Medicare Recovery)",
      "28:2409" : "28:2409 (28:2409(a) Quiet Title Action)",
      "28:2410" : "28:2410 (28:2410 Quiet Title)",
      "28:2671" : "28:2671 (28:2671 Federal Tort Claims Act)",
      "28:2674" : "28:2674 (28:2674 Federal Tort Claims Act)",
      "28:7402" : "28:7402 (28:7402 Refund of Taxes)",
      "28:7422" : "28:7422 (28:7422 Appeal from Administrative Decision)",
      "29:0151" : "29:0151 (29:151 Labor: Review of Agency Action)",
      "29:0160" : "29:0160 (29:160(1) National Labor Relations Act)",
      "29:0184" : "29:0184 (29:184 Violation Collection Bargain Agreement)",
      "29:0185ep" : "29:0185ep (29:185 Employee Pension Plan)",
      "29:0185lm" : "29:0185lm (29:185 Labor/Mgt. Relations (Contracts))",
      "29:0201do" : "29:0201do (29:201 Denial of Overtime Compensation)",
      "29:0201fl" : "29:0201fl (29:201 Fair Labor Standards Act)",
      "29:0203" : "29:0203 (29:203 Equal Pay Act)",
      "29:0206" : "29:0206 (29:206 Collect Unpaid Wages)",
      "29:0401" : "29:0401 (29:0401 Labor Management Disclosure Act)",
      "29:0621" : "29:0621 (29:621 Job Discrimination (Age))",
      "29:0623" : "29:0623 (29:623 Job Discrimination (Age))",
      "29:0626" : "29:0626 (29:626 Job Discrimination (Age))",
      "29:0633" : "29:0633 (29:633 Job Discrimination (Age))",
      "29:0651" : "29:0651 (29:651 Occupational Safety/Health)",
      "29:0701" : "29:0701 (29:0701 Vocational Rehabilitation)",
      "29:0754" : "29:0754 (29:754 Discrimination)",
      "29:0791" : "29:0791 (29:791 Job Discrimination (Rehabilitation Act))",
      "29:0794" : "29:0794 (29:0794 Job Discrimination (Handicap))",
      "29:1001" : "29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)",
      "29:1002" : "29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)",
      "29:1104" : "29:1104 (29:1104 Recovery of Benefits to Employee)",
      "29:1109" : "29:1109 (29:1109 Breach of Fiduciary Duties)",
      "29:1131" : "29:1131 (29:1131 ERISA - Collection of Delinquent Trust Fun)",
      "29:1132" : "29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)",
      "29:1145" : "29:1145 (29:1145 E.R.I.S.A.)",
      "29:1149" : "29:1149 (29:1149 Recover Pension & Profit Sharing)",
      "29:1337" : "29:1337 (29:1337 E.R.I.S.A.)",
      "29:1362" : "29:1362 (29:1362 ERISA)",
      "29:1381" : "29:1381 (29:1381 E.R.I.S.A.)",
      "29:1401" : "29:1401 (29:1401(b)(2) Appeal of Arbitration Award)",
      "29:1451" : "29:1451 (29:1451 E.R.I.S.A.)",
      "29:1801" : "29:1801 (29:1801 Farmworker Rights)",
      "29:2002" : "29:2002 (Employee Polygraph Protection Act - EPPA)",
      "29:201do" : "29:201do (29:201do Denial of Overtime Compensation)",
      "29:2101" : "29:2101 (29:2101 WARN - Worker Adjustment & Retraining Notification Act)",
      "29:2601" : "29:2601 (29:2601 Family and Medical Leave Act)",
      "29:790" : "29:790 (29:790 Rehabilitation of Labor)",
      "30:0181" : "30:0181 (30:181 Environment: Review of Agency Action)",
      "30:0801" : "30:0801 (30:0801 Penalities/Federal Mine Safety Health Act)",
      "30:1201" : "30:1201 (30:1201 Environment: Review of Agency Action)",
      "30:1202" : "30:1202 (30:1202 Mining Reclamation Act)",
      "30:1276" : "30:1276 (30:1276 Interior: Review of Agency Action)",
      "31:3545" : "31:3545 (31:3545 Action to Recovery Money)",
      "31:3729" : "31:3729 (31:3729 False Claims Act)",
      "31:3730" : "31:3730 (31:3730 Qui Tam False Claims Act)",
      "31:3731" : "31:3731 (31:3731 Fraud)",
      "33:0701" : "33:0701 (33:0701 Flood Control Act of 1944)",
      "33:1251" : "33:1251 (Federal Water Pollution Control Act)",
      "33:1319cw" : "33:1319cw (33:1319 Clean Water Act)",
      "33:1319pv" : "33:1319pv (33:1319 Pollutants & Permit Violations)",
      "33:1365" : "33:1365 (33:1365 Environmental Matters)",
      "35:0145" : "35:0145 (35:145 Patent Infringement)",
      "35:0183" : "35:0183 (35:183 Patent Infringement)",
      "35:0271" : "35:0271 (35:271 Patent Infringement)",
      "38:1681" : "38:1681 (38:1681 Recovery of VA Overpayment)",
      "38:1686" : "38:1686 (38:1686 Recovery of VA Overpayment)",
      "38:1780" : "38:1780 (38:1780 Recovery of VA Overpayment)",
      "38:2011" : "38:2011 (38:2011 - Veteran's Readjustment Assistance Act of)",
      "38:2021" : "38:2021 (38:2021 Veteran's Reemployment Act)",
      "38:3116" : "38:3116 (38:3116 VA Overpayment)",
      "38:4301" : "38:4301 (38:4301 USERRA-Uniformed Svs. Employment & Reemployment Rights Act)",
      "38:4311" : "38:4311 (38:4311 Uniformed Svs. Employment &Reemployment Rights Act)",
      "38:4323" : "38:4323 (38:4323 USERRA-Uniformed Svs. Employment & Reemployment Rights Act)",
      "38:611" : "38:611 (38:611 Overpayment of VA benefits for Medical Treatment)",
      "39:3005" : "39:3005 (39:3005 Detention of Mail for Temporary Periods)",
      "39:409" : "39:409 (39:409 Postal Service)",
      "40:0258" : "40:0258 (40:258(a) Public Buildings & Property: Land Condem)",
      "40:0270" : "40:0270 (40:270 Miller Act)",
      "40:0875" : "40:0875 (40:875 Public Buildings & Property: Negligence)",
      "41:0251" : "41:0251 (41:251 Public Contracts-Review of Agency Action)",
      "41:1463" : "41:1463 (41:1463 Public Contracts: Unlawful Employment Prac)",
      "42:0205" : "42:0205 (42:205 Denial Social Security Benefits)",
      "42:0206" : "42:0206 (42:206 Social Security Benefits)",
      "42:0247" : "42:0247 (42:247 Personal Injury-Swine Flu)",
      "42:0402" : "42:0402 (42:402 Social Security Benefits)",
      "42:0405id" : "42:0405id (42:0405 Review of HHS Decision (SSID))",
      "42:0405rs" : "42:0405rs (42:0405 Review of HHS Decision (RSI))",
      "42:0405wc" : "42:0405wc (42:0405 Review of HHS Decision (DIWC))",
      "42:0405ww" : "42:0405ww (42:0405 Review of HHS Decision (DIWW))",
      "42:0416" : "42:0416 (42:416 Denial of Social Security Benefits)",
      "42:0427" : "42:0427 (42:427 Social Security Benefits)",
      "42:11603" : "42:11603 (Return of Child/ Rights of Access to Child)",
      "42:12101" : "42:12101 (42:12101 Americans with Disabilities Act)",
      "42:1383" : "42:1383 (42:1383 Review of HHS Decision (regarding payment of benefits))",
      "42:1395" : "42:1395 (42:1395 HHS: Adverse Reimbursement Review)",
      "42:1396" : "42:1396 (42:1396 - Tort Negligence)",
      "42:1471" : "42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclo)",
      "42:1913" : "42:1913 (42:1913 Compensation and Liability Act of 1980)",
      "42:1981cv" : "42:1981cv (42:1981 Civil Rights)",
      "42:1981hs" : "42:1981hs (42:1981 Housing Discrimination)",
      "42:1981jb" : "42:1981jb (42:1981 Job Discrimination (Race))",
      "42:1981sx" : "42:1981sx (42:1981 Sex Discrimination)",
      "42:1982" : "42:1982 (42:1982 Property Rights of Citizens)",
      "42:1983cv" : "42:1983cv (42:1983 Civil Rights Act)",
      "42:1983ed" : "42:1983ed (42:1983 Civil Rights (Employment Discrimination))",
      "42:1983pr" : "42:1983pr (42:1983 Prisoner Civil Rights)",
      "42:1986" : "42:1986 (42:1986 Neglect of Duty)",
      "42:2000ag" : "42:2000ag (42:2000 Job Discrimination (Age))",
      "42:2000e" : "42:2000e (42:2000e Job Discrimination (Employment))",
      "42:2000pb" : "42:2000pb (42:2000 Job Discrimination (Public Accomodations))",
      "42:2000ra" : "42:2000ra (42:2000 Job Discrimination (Race))",
      "42:2000re" : "42:2000re (42:2000re Job Discrimination (Religion))",
      "42:2000sp" : "42:2000sp (42:2000sp Job Discrimination (Sex Preference))",
      "42:2000sx" : "42:2000sx (42:2000 Job Discrimination (Sex))",
      "42:2003" : "42:2003 (42:2003 Job Discrimination)",
      "42:2005" : "42:2005 (42:2005 Review of Agency Action-HHS)",
      "42:2021ae" : "42:2021ae (42:2021(b) Agreements wi. States re: Dev. Atomic Energy)",
      "42:2651" : "42:2651 (42:2651 Medical Care Recovery)",
      "42:3601" : "42:3601 (42:405 Fair Housing Act)",
      "42:3605" : "42:3605 (42:3605 Discrimination in Real Estate-Related Transactions)",
      "42:4000" : "42:4000 (42:4000 National Flood Insurance Act)",
      "42:4001" : "42:4001 (42:4001 National Insurance Flood Act)",
      "42:4053" : "42:4053 (42:4053 Breach of Insurance Contract)",
      "42:4072" : "42:4072 (42:4072 Payment of Flood Insurance Claim)",
      "42:425" : "42:425 (42:425 Social Security Benefits)",
      "42:4321" : "42:4321 (42:4321 Review of Agency Action-Environment)",
      "42:4332" : "42:4332 (42:4332 Environmental Policy - Coop of Agency Repo)",
      "42:4852" : "42:4852 (42:4852 Lead-Based Paint Hazard Reduction in Housing)",
      "42:6901en" : "42:6901en (42:6901 Environmental Cleanup Expenses)",
      "42:6901rs" : "42:6901rs (42:6901 Resource & Recovery Act)",
      "42:7413" : "42:7413 (42:7413(b) Clean Air Act)",
      "42:7604cl" : "42:7604cl (42:7604 Clear Air Act (Emission Standards))",
      "42:7604ir" : "42:7604ir (42:7604 Petition to Quash IRS Summons)",
      "42:9601" : "42:9601 (42:9601 CERCLA - Comprehensive Environ. Response, Comp. & Liability)",
      "42:9607" : "42:9607 (42:9607 Real Property Tort to Land)",
      "43:945" : "43:945 (43:945 Compensation for Land Condemnation)",
      "43:945a" : "43:945a (43:945a Complaint in Condemnation)",
      "43:946" : "43:946 (43:946 Complaint in Condemnation - Eminent Domain)",
      "45:0051" : "45:0051 (45:51 Railways: Fed. Employer's Liability Act)",
      "45:0151" : "45:0151 (45:151 Railway Labor Act)",
      "45:0184" : "45:0184 (45:184 Action to Set Aside Award of a System Board)",
      "45:1395" : "45:1395 (45:1395 Railroads: Adverse Reimbursement Review)",
      "45:7457" : "45:7457 (45:7457 Compel Reclamation Under Clear Air Act)",
      "46:0185" : "46:0185 (46:0185 Petition for Exoneration/Limitation for Loss by Collision)",
      "46:0688" : "46:0688 (46:688 Jones Act)",
      "46:0741" : "46:0741 (46:741 Shipping)",
      "46:0761" : "46:0761 (46:761 Shipping: Damages for Death on High Seas)",
      "46:0951" : "46:0951 (46:0951 In REM to Enforce Lien on Mortgaged Vessel)",
      "46:1101" : "46:1101 (46:1101 Violation of Maritime Regulations)",
      "46:1156" : "46:1156 (46:1156 Administrative Procedure Act)",
      "47:0153" : "47:0153 (47:153 Telecommunications Act of 1996)",
      "47:0203" : "47:0203 (47:203 Communications Act of 1934)",
      "47:0252" : "47:0252 (47:0252 Telecommunications Act of 1996)",
      "47:0605" : "47:0605 (47:0605 Unauthorized Reception of Satellite Signals)",
      "47:151" : "47:151 (47:151 Communication Act of 1934)",
      "47:227b3" : "47:227b3 (47:227(b)(3) Telephone Consumer Protection Act of 1991)",
      "48:0883" : "48:0883 (48:883 Violation of US Coastal Law)",
      "48:1985" : "48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)",
      "49:0081" : "49:0081 (49:81 Damaged Goods While Being Transported)",
      "49:0781" : "49:0781 (49:781 Forfeiture)",
      "49:10101" : "49:10101 (49:10101 ICC Termination Act of 1995)",
      "49:11503" : "49:11503 (49:11503 Railroad Revitalization Regulatory Reform)",
      "49:11702" : "49:11702 (49:11702(a)(4) Violations of Interstate Commerce A)",
      "49:14704" : "49:14704 (Rights and remedies of persons injured by carriers or brokers)",
      "49:14706" : "49:14706 (49:14706 Carmack Amendment to the Interstate Commerce Act / Liability of Carriers - Receipts & Bills)",
      "49:1471" : "49:1471 (49:1471 Federal Aviation Act)",
      "49:1552" : "49:1552 (49:1552 Airline Deregulation Act)",
      "49:1801" : "49:1801 (49:1801 Violation of Hazardous Material Act)",
      "49:1903" : "49:1903 (49:1903 Petition to enforce administrative summon)",
      "49:20101" : "49:20101 (49:20101 Federal Railroad Safety Act)",
      "49:32701" : "49:32701 (49:32701 Odometer Requirments Act)",
      "50:0501" : "50:0501 (50:0501 - S&SCRA - Soliders and Sailors Civil Relief Act)",
      "8:287" : "8:287 (8:287 Petition to Enforce INS Subpoena)",
      "misc" : "misc (Civil Miscellaneous Case)"
   },
   "moedce" : {
      "0" : "0 (No cause code entered)",
      "00:0000" : "00:0000 (00:0000 Cause Code Unknown)",
      "02:0431" : "02:0431 (02:431 Fed. Election Commission: Failure Enforce C)",
      "02:0437" : "02:0437 (02:437 Federal Election Commission)",
      "05:0075" : "05:0075 (05:75(2) Contract - Reduction in Grade)",
      "05:0551" : "05:0551 (05:551 Administrative Procedure Act)",
      "05:0552fi" : "05:0552fi (05:552 Freedom of Information Act)",
      "05:0552pa" : "05:0552pa (05:552 Right to Privacy Act)",
      "05:0554" : "05:0554 (05:0554 Constitutionality of Maritime Statutes)",
      "05:0701" : "05:0701 (05:0701 Maritime Subsidy Board)",
      "05:0702" : "05:0702 (05:702 Administrative Procedure Act)",
      "05:0704" : "05:0704 (05:704 Labor Litigation)",
      "05:7703" : "05:7703 (05:7703 Discrimination - Review of Agency Act)",
      "05:8701" : "05:8701 (05:8701 Federal Employees Group Life Insurance Act)",
      "05:8901" : "05:8901 (05:8901 Federal Employees Health Benefits Act)",
      "07:0006" : "07:0006 (7:6(b) Federal Commodity Exchange Regulation)",
      "07:0025" : "07:0025 (7:25 Fraud - Commodities Leverage Contracts)",
      "07:0181" : "07:0181 (07:181 Packers & Stockyard Act)",
      "07:0499" : "07:0499 (07:499 Agricultural Commodities Act)",
      "07:0601" : "07:0601 (07:601 USDA Condemnation)",
      "07:2321" : "07:2321 (07:2321 Plant Variety Protection Act)",
      "08:1105" : "08:1105 (8:1105(a) Aliens: Habeas Corpus to Release INS Det)",
      "08:1252" : "08:1252 (08:1252(a)(2) Injunction for Deportation)",
      "08:1260" : "08:1260 (08:1260 Aliens: Access to Records)",
      "08:1324" : "08:1324 (08:1324 Aliens: Complaint for Forfeiture)",
      "08:1329" : "08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petiti)",
      "08:1446" : "08:1446 (8:1446 Petition for Naturalization Hearing)",
      "09:0001" : "09:0001 (09:1 U.S. Arbitration Act)",
      "09:0009" : "09:0009 (9:9 Motion to Confirm Arbitration Award)",
      "09:0010" : "09:0010 (09:0010 Petition to Vacate Arbitration Award)",
      "10:1552" : "10:1552 (10:1552 Armed Forces: Action to Correct Records)",
      "10:1553" : "10:1553 (10:1553 Armed Forces: FOIA General)",
      "10:2305" : "10:2305 (10:2305 Review of Federal Contract)",
      "11:0101" : "11:0101 (11:101 Bankruptcy)",
      "12:0022" : "12:0022 (12:22 Securities Fraud)",
      "12:0635" : "12:0635 (12:635 Breach of Insurance Contract)",
      "12:1461" : "12:1461 (12:1461 Homeowners Loan Act)",
      "12:1703" : "12:1703 (12:1703 Default of HUD Loan)",
      "12:1725" : "12:1725 (12:1725 Collection under Contract Guaranty)",
      "12:1730" : "12:1730 (12:1730 Collection Under Contract Guaranty)",
      "12:1819" : "12:1819 (12:1819 Default of Promissory Note)",
      "12:1821" : "12:1821 (12:1821 Default of Loan by Promissary Note)",
      "12:1971" : "12:1971 (12:1971 Relief under Bank Holding Act)",
      "12:2601" : "12:2601 (12:2601 Real Estate Settlement Procedures Act)",
      "12:2615" : "12:2615 (12:2615 Contracts)",
      "12:3410" : "12:3410 (12:3410 Right to Financial Privacy Act)",
      "15:0001" : "15:0001 (15:1 Antitrust Litigation)",
      "15:0002at" : "15:0002at (15:2 Antitrust Litigation)",
      "15:0002fl" : "15:0002fl (15:2(a) Fair Labor Standards Act)",
      "15:0005" : "15:0005 (15:5(a) Fair Labor Standards Act)",
      "15:0015" : "15:0015 (15:15 Antitrust Litigation)",
      "15:0025" : "15:0025 (15:25 Clayton Act)",
      "15:0044" : "15:0044 (15:44 Trademark Infringement)",
      "15:0045" : "15:0045 (15:0045 Federal Trade Commission Act)",
      "15:0052" : "15:0052 (15:0052 Federal Trade Commission Act)",
      "15:0053" : "15:0053 (15:0053 Federal Trade Commission Act)",
      "15:0077" : "15:0077 (15:77 Securities Fraud)",
      "15:0078" : "15:0078 (15:78m(a) Securities Exchange Act)",
      "15:0631" : "15:0631 (15:631 Small Business Act)",
      "15:0717" : "15:0717 (15:717 Natural Gas Act)",
      "15:1051" : "15:1051 (15:1051 Trademark Infringement)",
      "15:1114" : "15:1114 (15:1114 Trademark Infringement)",
      "15:1121" : "15:1121 (15:1121 Trademark Infringement)",
      "15:1125" : "15:1125 (15:1125 Trademark Infringement (Lanham Act))",
      "15:1126" : "15:1126 (15:1126 Patent Infringement)",
      "15:1127" : "15:1127 (15:1127 Trademark Infringement)",
      "15:1129" : "15:1129 (15:1129 Cyberpiracy Protection for Individuals)",
      "15:1222" : "15:1222 (15:1222 Automobile Dealers Day in Court Act)",
      "15:1601" : "15:1601 (15:1601 Truth in Lending)",
      "15:1640" : "15:1640 (15:1640 Truth in Lending)",
      "15:1681" : "15:1681 (15:1681 Fair Credit Reporting Act)",
      "15:1692" : "15:1692 (15:1692 Fair Debt Collection Act)",
      "15:1693" : "15:1693 (15:1693 Electronic Fund Transfer Act)",
      "15:1938" : "15:1938 (15:1938 Fair Labor Standards Act)",
      "15:1981" : "15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))",
      "15:1988" : "15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))",
      "15:1989" : "15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))",
      "15:2301" : "15:2301 (15:2301 Magnuson-Moss Warranty Act)",
      "15:2801" : "15:2801 (15:2801 Petroleum Marketing Practices Act)",
      "15:53(b)" : "15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equita)",
      "16:0470" : "16:0470 (16:0470 National Historic Preservation Act)",
      "16:0668" : "16:0668 (16:668 Bald Eagle Protection Act)",
      "16:0703" : "16:0703 (16:703 Migratory Bird Act)",
      "16:1538" : "16:1538 (16:1538 Endangered Species Act)",
      "16:3371" : "16:3371 (16:3371 Wildlife Under the Lacey Act)",
      "16:3372" : "16:3372 (16:3372 Conservation: Complaint for Forfeiture)",
      "16:3373" : "16:3373 (16:3373 Appeal of Decision - DOI)",
      "16:3374" : "16:3374 (16:3374 Conservation: Complaint for Forfeiture)",
      "17:0101" : "17:0101 (17:101 Copyright Infringement)",
      "17:0501" : "17:0501 (17:501 Copyright Infringement)",
      "17:0504" : "17:0504 (17:504 Copyright Infringement)",
      "18:0241" : "18:0241 (18:241 Conspiracy Against Citizen Rights)",
      "18:1030" : "18:1030 (18:1030 Computer Fraud and Abuse Act)",
      "18:1836a" : "18:1836a (18:1836(a) Injunction against Misappropriation of Trade Secrets)",
      "18:1836b" : "18:1836b (18:1836(b) Civil Action to Protect Trade Secrets)",
      "18:1961" : "18:1961 (18:1961 Racketeering (RICO) Act)",
      "18:1962" : "18:1962 (18:1962 Racketeering (RICO) Act)",
      "18:1964" : "18:1964 (18:1964 Racketeering (RICO) Act)",
      "18:2254" : "18:2254 (18:2254 Release of Seized Property)",
      "18:4208" : "18:4208 (18:4208(B) Agency Action Review)",
      "18:981" : "18:981 (18:981 Forfeiture (Wire Fraud))",
      "19:1305" : "19:1305 (19:1305 Custom Duties:0Forfeiture-Immoral Articles)",
      "20:1080" : "20:1080 (20:1080 Student Loan Recovery)",
      "20:1082" : "20:1082 (20:1021 Federal Family Education Loan Program (FFELP))",
      "20:1400" : "20:1400 (20:1400 Civil Rights of Handicapped Child)",
      "20:1401" : "20:1401 (20:1401 Education: Handicapped Child Act)",
      "20:1681" : "20:1681 (20:1681 Title 9 of the Education Amendment Act of 1972)",
      "21:0342" : "21:0342 (21:0342 Food Drug and Cosmetic Act)",
      "21:0841" : "21:0841 (21:841 Forfeiture Property-Drugs)",
      "21:0881" : "21:0881 (21:881 Forfeiture Property-Drugs)",
      "21:0881a" : "21:0881a (21:881 Forfeiture Property - Aircraft)",
      "21:0881re" : "21:0881re (21:881 Forfeiture Property - Real Estate)",
      "23:0134" : "23:0134 (23:134 P.I.- Auto Negligence)",
      "23:1441" : "23:1441 (23:1441 Contract Real Estate)",
      "24:1000" : "24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)",
      "25:0640" : "25:0640 (25:640 Indian Tribal Rights)",
      "25:1901" : "25:1901 (25:1901 Indian Child Welfare Act)",
      "26:6212" : "26:6212 (26:6212 Injunctive Relief from IRS Lien)",
      "26:6213" : "26:6213 (26:6213 Injunctive Relief from IRS Lien)",
      "26:6404" : "26:6404 (26:6404 Erroneous Tax Abatement)",
      "26:6502" : "26:6502 (26:6502 IRS:Enforcement of tax liens)",
      "26:6532" : "26:6532 (26:6532 IRS: Refund of Tax Penalty)",
      "26:6702" : "26:6702 (26:6702 IRS: Refund of Income Tax Penalty)",
      "26:6703" : "26:6703 (26:6703 IRS: Refund of Tax Penalty)",
      "26:7401" : "26:7401 (26:7401 IRS: Tax Liability)",
      "26:7402" : "26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)",
      "26:7403" : "26:7403 (26:7403 Suit to Enforce Federal Tax Lien)",
      "26:7422rt" : "26:7422rt (26:7422 IRS: Refund Taxes)",
      "26:7422rx" : "26:7422rx (26:7422 IRS: Refund Excise Tax)",
      "26:7426" : "26:7426 (26:7426 IRS: Wrongful Levy for Taxes)",
      "26:7429" : "26:7429 (26:7429 IRS: Tax Jeopardy Assessment)",
      "26:7609" : "26:7609 (26:7609 IRS: Petition to Quash IRS Summons)",
      "27:0185" : "27:0185 (27:185 Enforcement of Arbitration Award)",
      "28:0157b" : "28:0157b (28:1057b Transfer Related Claims and Causes of Action)",
      "28:0157b5" : "28:0157b5 (28:0157(b)(5) Transfer Related Claims and Causes of Action)",
      "28:0157c" : "28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)",
      "28:0157d" : "28:0157d (28:0157 Motion for Withdrawal of Reference)",
      "28:0157e" : "28:0157e (28:0157e Non Consent to Jury Trial by the Bankruptcy Court )",
      "28:0158" : "28:0158 (28:0158 Notice of Appeal re Bankruptcy Matter (BA)",
      "28:0185" : "28:0185 (28:185 Suit to Compel Arbitration)",
      "28:0451" : "28:0451 (28:451 Employment Discrimination)",
      "28:0794" : "28:0794 (28:794 Rehabilitation Act)",
      "28:1001" : "28:1001 (28:1001 E.R.I.S.A.)",
      "28:1132" : "28:1132 (28:1132 E.R.I.S.A.)",
      "28:1132lm" : "28:1132lm (28:1132lm Diversity - Legal Malpractice)",
      "28:1330" : "28:1330 (28:1330 Breach of Contract)",
      "28:1331" : "28:1331 (28:1331 Fed. Question)",
      "28:1331al" : "28:1331al (28:1331 Fed. Question: Airline Crash)",
      "28:1331at" : "28:1331at (28:1331 Fed. Question: Anti-trust)",
      "28:1331au" : "28:1331au (28:1331 Fed. Question: Auto Negligence)",
      "28:1331b" : "28:1331b (28:1331 Federal Question: Bivens Act)",
      "28:1331bc" : "28:1331bc (28:1331bc Base Closure Action)",
      "28:1331ca" : "28:1331ca (28:1331 Fed Question: Fed Communications Act of 1)",
      "28:1331cm" : "28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)",
      "28:1331cv" : "28:1331cv (28:1331 Federal Question: Other Civil Rights)",
      "28:1331ed" : "28:1331ed (28:1331 Fed. Question: Employment Discrimination)",
      "28:1331es" : "28:1331es (28:1331 Enforcement of Administrative Subpoena)",
      "28:1331fl" : "28:1331fl (28:1331 Fed. Question: Fair Labor Standards)",
      "28:1331in" : "28:1331in (28:1331 Fed. Question: Insurance Contract)",
      "28:1331mm" : "28:1331mm (28:1331 Fed. Question: Medical Malpractice)",
      "28:1331pi" : "28:1331pi (28:1331 Fed. Question: Personal Injury)",
      "28:1331rd" : "28:1331rd (28:1331 Fed. Question: Review Agency Decision)",
      "28:1331rp" : "28:1331rp (28:1331(a) Fed. Question: Real Property)",
      "28:1331rr" : "28:1331rr (28:1331 Fed. Question: Railway Labor Act)",
      "28:1331sv" : "28:1331sv (28:1331 Fed. Question: Securities Violation)",
      "28:1331tr" : "28:1331tr (28:1331 Fed. Question: Trademark)",
      "28:1331tt" : "28:1331tt (28:1331 Fed. Question: Tort Action)",
      "28:1331v" : "28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendme)",
      "28:1331wl" : "28:1331wl (28:1331 Federal Question: EPA Waste Lien)",
      "28:1331wt" : "28:1331wt (28:1331 Fed. Question: Water Rights)",
      "28:1332ac" : "28:1332ac (28:1332 Diversity-Account Receivable)",
      "28:1332al" : "28:1332al (28:1332 Diversity-Airline Crash)",
      "28:1332as" : "28:1332as (28:1332 Diversity-Asbestos Litigation)",
      "28:1332au" : "28:1332au (28:1332 Diversity-Auto Negligence)",
      "28:1332bc" : "28:1332bc (28:1332 Diversity-Breach of Contract)",
      "28:1332co" : "28:1332co (28:1332 Diversity-Conversion)",
      "28:1332ct" : "28:1332ct (28:1332 Diversity-(Citizenship))",
      "28:1332det" : "28:1332det (28:1332 Diversity: Forcible Detainer)",
      "28:1332df" : "28:1332df (28:1332 Diversity-Contract Default)",
      "28:1332ds" : "28:1332ds (28:1332 Diversity-Contract Dispute)",
      "28:1332ed" : "28:1332ed (28:1332 Diversity-Employment Discrimination)",
      "28:1332fd" : "28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)",
      "28:1332fr" : "28:1332fr (28:1332 Diversity-Fraud)",
      "28:1332ia" : "28:1332ia (28:1332 Diversity-Interpleader Action)",
      "28:1332ij" : "28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)",
      "28:1332in" : "28:1332in (28:1332 Diversity-Insurance Contract)",
      "28:1332jd" : "28:1332jd (28:1332 Diversity-Declaratory Judgment)",
      "28:1332lb" : "28:1332lb (28:1332 Diversity-Libel,Assault,Slander)",
      "28:1332lm" : "28:1332lm (28:1332 Diversity - Legal Malpractice)",
      "28:1332ma" : "28:1332ma (28:1332 Diversity-Miller Act)",
      "28:1332mm" : "28:1332mm (28:1332 Diversity-Medical Malpractice)",
      "28:1332mv" : "28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)",
      "28:1332ni" : "28:1332ni (28:1332 Diversity-Negotiable Instrument)",
      "28:1332nm" : "28:1332nm (28:1332 Diversity-Non-Motor Vehicle)",
      "28:1332oc" : "28:1332oc (28:1332 Diversity-Other Contract)",
      "28:1332pd" : "28:1332pd (28:1332 Diversity-Property Damage)",
      "28:1332pi" : "28:1332pi (28:1332 Diversity-Personal Injury)",
      "28:1332pl" : "28:1332pl (28:1332 Diversity-Product Liability)",
      "28:1332pr" : "28:1332pr (28:1332 Diversity-Petition for Removal)",
      "28:1332qt" : "28:1332qt (28:1332 Diversity-Petition to Quiet Title)",
      "28:1332ri" : "28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)",
      "28:1332sa" : "28:1332sa (28:1332 - Diversity: Securities & Exchange Commiss)",
      "28:1332sf" : "28:1332sf (28:1332 - Diversity: Securities Fraud)",
      "28:1332ss" : "28:1332ss (28:1332 Diversity - Stockholders Suits)",
      "28:1332tl" : "28:1332tl (28:1332 Diversity-Torts to Land)",
      "28:1332tm" : "28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))",
      "28:1332tn" : "28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)",
      "28:1332wd" : "28:1332wd (28:1332 Diversity-Wrongful Death)",
      "28:1333" : "28:1333 (28:1333 Admiralty)",
      "28:1334" : "28:1334 (28:1334 Bankruptcy Appeal)",
      "28:1334c" : "28:1334c (28:1334(c) R&R re motions for abstention (non-cor)",
      "28:1335" : "28:1335 (28:1335 Interpleader Action)",
      "28:1337" : "28:1337 (28:1337 Sherman-Clayton Act)",
      "28:1338cp" : "28:1338cp (28:1338 Copyright Infringement)",
      "28:1338pt" : "28:1338pt (28:1338 Patent Infringement)",
      "28:1338tr" : "28:1338tr (28:1338 Trademark Infringement)",
      "28:1340" : "28:1340 (28:1340 IRS: Custom Duties)",
      "28:1340er" : "28:1340er (28:1340 Recovery of Erroneous Refund)",
      "28:1341" : "28:1341 (28:1341 Complaint for Forfeiture)",
      "28:1343" : "28:1343 (28:1343 Violation of Civil Rights)",
      "28:1345co" : "28:1345co (28:1345 Replevin & Conversion)",
      "28:1345db" : "28:1345db (28:1345 Debt to US - FHA/HUD Title I)",
      "28:1345df" : "28:1345df (28:1345 Default of Promissory Note)",
      "28:1345er" : "28:1345er (28:1345 Recovery of Erroneous Refund)",
      "28:1345fc" : "28:1345fc (28:1345 Foreclosure)",
      "28:1345ff" : "28:1345ff (28:1345 Complaint for Forfeiture)",
      "28:1345hl" : "28:1345hl (28:1345 VA Home Loan Guaranty Debt)",
      "28:1345mc" : "28:1345mc (28:1345 Medical Care Recovery)",
      "28:1345mi" : "28:1345mi (28:1345 Mining Claim Ejectment)",
      "28:1345pd" : "28:1345pd (28:1345 Property Damage)",
      "28:1345pe" : "28:1345pe (28:1345 Property Ejectment)",
      "28:1345rc" : "28:1345rc (28:1345 Recovery of Debt to US)",
      "28:1345st" : "28:1345st (28:1345 Default of Student Loan)",
      "28:1345tp" : "28:1345tp (28:1345 Trespass on Public Land)",
      "28:1345va" : "28:1345va (28:1345 Recovery of VA Overpayment)",
      "28:1346bc" : "28:1346bc (28:1346 Breach of Contract)",
      "28:1346rc" : "28:1346rc (28:1346 Recovery of IRS Tax)",
      "28:1346tc" : "28:1346tc (28:1346 Tort Claim)",
      "28:1346wd" : "28:1346wd (28:1346 Wrongful Death)",
      "28:1352" : "28:1352 (28:1352 Miller Act)",
      "28:1355" : "28:1355 (28:1355 Petition for Return of Property)",
      "28:1358" : "28:1358 (28:1358 Land Condemnation)",
      "28:1361" : "28:1361 (28:1361 Petition for Writ of Mandamus)",
      "28:1362ic" : "28:1362ic (28:1362 Indian Tribal Controversy)",
      "28:1362iw" : "28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)",
      "28:1364" : "28:1364 (28:1364 Auto Negligence)",
      "28:1391" : "28:1391 (28:1391 Personal Injury)",
      "28:1402" : "28:1402 (28:1402 Medical Malpractice)",
      "28:1407" : "28:1407 (28:1407 Airline Crash)",
      "28:1441ac" : "28:1441ac (28:1441 Petition for Removal- Account Receivable)",
      "28:1441al" : "28:1441al (28:1441 Petition for Removal- Airline Crash)",
      "28:1441as" : "28:1441as (28:1441 Petition for Removal- Asbestos Litigation)",
      "28:1441au" : "28:1441au (28:1441 Petition for Removal- Auto Negligence)",
      "28:1441bc" : "28:1441bc (28:1441 Petition for Removal- Breach of Contract)",
      "28:1441cv" : "28:1441cv (28:1441 Petition for Removal- Civil Rights Act)",
      "28:1441df" : "28:1441df (28:1441 Petition for Removal- Contract Default)",
      "28:1441dj" : "28:1441dj (28:1441 Petition for Removal- Declaratory Judgemen)",
      "28:1441ds" : "28:1441ds (28:1441 Petition for Removal- Contract Dispute)",
      "28:1441ed" : "28:1441ed (28:1441 Petition for Removal - Employment Discrim)",
      "28:1441fc" : "28:1441fc (28:1441 Petition for Removal - Fair Credit Reporti)",
      "28:1441fr" : "28:1441fr (28:1441 Petition for Removal- Fraud)",
      "28:1441ij" : "28:1441ij (28:1441 Petition for Removal- Injunctive/Declarato)",
      "28:1441in" : "28:1441in (28:1441 Petition for Removal- Insurance Contract)",
      "28:1441int" : "28:1441int (28:1441 Petition for Removal- Action for Interplea)",
      "28:1441lb" : "28:1441lb (28:1441 Petition for Removal Libel,Assault,Slander)",
      "28:1441lm" : "28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relatio)",
      "28:1441mm" : "28:1441mm (28:1441 Petition for Removal- Medical Malpractice)",
      "28:1441ni" : "28:1441ni (28:1441 Petition for Removal- Negotiable Instrumen)",
      "28:1441nm" : "28:1441nm (28:1441 Petition for Removal- Non-Motor Vehicle)",
      "28:1441oc" : "28:1441oc (28:1441 Petition For Removal--Other Contract)",
      "28:1441pd" : "28:1441pd (28:1441 Petition for Removal- Property Damage)",
      "28:1441pi" : "28:1441pi (28:1441 Petition for Removal- Personal Injury)",
      "28:1441pl" : "28:1441pl (28:1441 Petition for Removal- Product Liability)",
      "28:1441pr" : "28:1441pr (28:1441 Petition for Removal)",
      "28:1441qt" : "28:1441qt (28:1441 Petition for Removal- Petition to Quiet Ti)",
      "28:1441ri" : "28:1441ri (28:1441 Petition for Removal- Racketeering (RICO))",
      "28:1441sa" : "28:1441sa (28:1441 - Petition for Removal: SEC Act)",
      "28:1441sf" : "28:1441sf (28:1441 - Petition for Removal: Securities Fraud)",
      "28:1441tl" : "28:1441tl (28:1441 Petition for Removal- Torts to Land)",
      "28:1441tm" : "28:1441tm (28:1441 Petition for Removal- Tort/Motor Vehicle ()",
      "28:1441tn" : "28:1441tn (28:1441 Petition for Removal- Tort/Non-Motor Vehic)",
      "28:1441wd" : "28:1441wd (28:1441 Petition for Removal- Wrongful Death)",
      "28:1442bc" : "28:1442bc (28:1442 Petition for Removal- Breach of Contract)",
      "28:1442pr" : "28:1442pr (28:1442 Petition for Removal)",
      "28:1443" : "28:1443 (28:1443(1) Removal / Civil Rights)",
      "28:1444" : "28:1444 (28:1444 Petition for Removal- Foreclosure)",
      "28:1446in" : "28:1446in (28:1446 Breach of Contract- Insurance)",
      "28:1446pd" : "28:1446pd (28:1446 Petition for Removal- Property Damage (P.I)",
      "28:1446pi" : "28:1446pi (28:1446 Petition for Removal- Personal Injury)",
      "28:1446pl" : "28:1446pl (28:1446pl Petition for Removal - Product Liability)",
      "28:1446pr" : "28:1446pr (28:1446 Petition for Removal)",
      "28:1452" : "28:1452 (28:1452 R&R re motions to remand (non-core))",
      "28:1455" : "28:1455 (28:1455 Procedure for Removal Criminal Prosecutions)",
      "28:1651" : "28:1651 (28:1651 Petition for Writ of Coram Nobis)",
      "28:1651hc" : "28:1651hc (28:1651 Petition for Writ of Habeas Corpus)",
      "28:1651mn" : "28:1651mn (28:1651 Petition for Writ of Mandamus)",
      "28:1983" : "28:1983 (28:1983 Civil Rights)",
      "28:2201" : "28:2201 (28:2201 Constitutionality of State Statute(s))",
      "28:2201dj" : "28:2201dj (28:2201 Declaratory Judgment)",
      "28:2201ij" : "28:2201ij (28:2201 Injunction)",
      "28:2201in" : "28:2201in (28:2201 Declaratory Judgement (Insurance))",
      "28:2241" : "28:2241 (28:2241 Petition for Writ of Habeas Corpus (federa)",
      "28:2254" : "28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))",
      "28:2254se" : "28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)",
      "28:2255" : "28:2255 (28:2255 Motion to Vacate / Correct Illegal Sentenc)",
      "28:2271" : "28:2271 (28:2271 Federal Tort Claims Act)",
      "28:2345" : "28:2345 (28:2345 Medicare Recovery)",
      "28:2409" : "28:2409 (28:2409(a) Quiet Title Action)",
      "28:2410" : "28:2410 (28:2410 Quiet Title)",
      "28:2671" : "28:2671 (28:2671 Federal Tort Claims Act)",
      "28:2674" : "28:2674 (28:2674 Federal Tort Claims Act)",
      "28:7402" : "28:7402 (28:7402 Refund of Taxes)",
      "28:7422" : "28:7422 (28:7422 Appeal from Administrative Decision)",
      "29:0151" : "29:0151 (29:151 Labor: Review of Agency Action)",
      "29:0160" : "29:0160 (29:160(1) National Labor Relations Act)",
      "29:0184" : "29:0184 (29:184 Violation Collection Bargain Agreement)",
      "29:0185ep" : "29:0185ep (29:185 Employee Pension Plan)",
      "29:0185lm" : "29:0185lm (29:185 Labor/Mgt. Relations (Contracts))",
      "29:0201do" : "29:0201do (29:201 Denial of Overtime Compensation)",
      "29:0201fl" : "29:0201fl (29:201 Fair Labor Standards Act)",
      "29:0203" : "29:0203 (29:203 Equal Pay Act)",
      "29:0206" : "29:0206 (29:206 Collect Unpaid Wages)",
      "29:0401" : "29:0401 (29:0401 Labor Management Disclosure Act)",
      "29:0621" : "29:0621 (29:621 Job Discrimination (Age))",
      "29:0623" : "29:0623 (29:623 Job Discrimination (Age))",
      "29:0626" : "29:0626 (29:626 Job Discrimination (Age))",
      "29:0633" : "29:0633 (29:633 Job Discrimination (Age))",
      "29:0651" : "29:0651 (29:651 Occupational Safety/Health)",
      "29:0754" : "29:0754 (29:754 Discrimination)",
      "29:0791" : "29:0791 (29:791 Job Discrimination (Rehabilitation Act))",
      "29:0794" : "29:0794 (29:0794 Job Discrimination (Handicap))",
      "29:1001" : "29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)",
      "29:1002" : "29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)",
      "29:1104" : "29:1104 (29:1104 Recovery of Benefits to Employee)",
      "29:1109" : "29:1109 (29:1109 Breach of Fiduciary Duties)",
      "29:1131" : "29:1131 (29:1131 ERISA - Collection of Delinquent Trust Fun)",
      "29:1132" : "29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)",
      "29:1145" : "29:1145 (29:1145 E.R.I.S.A.)",
      "29:1149" : "29:1149 (29:1149 Recover Pension & Profit Sharing)",
      "29:1337" : "29:1337 (29:1337 E.R.I.S.A.)",
      "29:1362" : "29:1362 (29:1362 ERISA)",
      "29:1381" : "29:1381 (29:1381 E.R.I.S.A.)",
      "29:1401" : "29:1401 (29:1401(b)(2) Appeal of Arbitration Award)",
      "29:1451" : "29:1451 (29:1451 E.R.I.S.A.)",
      "29:1801" : "29:1801 (29:1801 Farmworker Rights)",
      "29:2617" : "29:2617 (29:2617 Family Medical Leave Act)",
      "29:790" : "29:790 (29:790 Rehabilitation of Labor)",
      "30:0181" : "30:0181 (30:181 Environment: Review of Agency Action)",
      "30:0801" : "30:0801 (30:0801 Penalities/Federal Mine Safety Health Act)",
      "30:1201" : "30:1201 (30:1201 Environment: Review of Agency Action)",
      "30:1202" : "30:1202 (30:1202 Mining Reclamation Act)",
      "30:1276" : "30:1276 (30:1276 Interior: Review of Agency Action)",
      "31:3545" : "31:3545 (31:3545 Action to Recovery Money)",
      "31:3729" : "31:3729 (31:3729 False Claims Act)",
      "31:3730" : "31:3730 (31:3730 Qui Tam False Claims Act)",
      "31:3731" : "31:3731 (31:3731 Fraud)",
      "33:1319cw" : "33:1319cw (33:1319 Clean Water Act)",
      "33:1319pv" : "33:1319pv (33:1319 Pollutants & Permit Violations)",
      "33:1365" : "33:1365 (33:1365 Environmental Matters)",
      "35:0145" : "35:0145 (35:145 Patent Infringement)",
      "35:0183" : "35:0183 (35:183 Patent Infringement)",
      "35:0271" : "35:0271 (35:271 Patent Infringement)",
      "38:1681" : "38:1681 (38:1681 Recovery of VA Overpayment)",
      "38:1686" : "38:1686 (38:1686 Recovery of VA Overpayment)",
      "38:1780" : "38:1780 (38:1780 Recovery of VA Overpayment)",
      "38:2011" : "38:2011 (38:2011 - Veteran's Readjustment Assistance Act of)",
      "38:3116" : "38:3116 (38:3116 VA Overpayment)",
      "38:4321" : "38:4321 (38:4321 Veterans Employment Benefits)",
      "38:4323" : "38:4323 (38:4323 Veterans Re-employment Rights Act (VRRA))",
      "39:3005" : "39:3005 (39:3005 Detention of Mail for Temporary Periods)",
      "39:409" : "39:409 (39:409 Postal Service)",
      "40:0258" : "40:0258 (40:258(a) Public Buildings & Property: Land Condem)",
      "40:0270" : "40:0270 (40:270 Miller Act)",
      "40:0875" : "40:0875 (40:875 Public Buildings & Property: Negligence)",
      "41:0251" : "41:0251 (41:251 Public Contracts-Review of Agency Action)",
      "41:1463" : "41:1463 (41:1463 Public Contracts: Unlawful Employment Prac)",
      "42:0205" : "42:0205 (42:205 Denial Social Security Benefits)",
      "42:0206" : "42:0206 (42:206 Social Security Benefits)",
      "42:0247" : "42:0247 (42:247 Personal Injury-Swine Flu)",
      "42:0402" : "42:0402 (42:402 Social Security Benefits)",
      "42:0405id" : "42:0405id (42:405 Review of HHS Decision (SSID))",
      "42:0405wc" : "42:0405wc (42:405 Review of HHS Decision (DIWC))",
      "42:0405ww" : "42:0405ww (42:405 Review of HHS Decision (DIWW))",
      "42:0416" : "42:0416 (42:416 Denial of Social Security Benefits)",
      "42:0427" : "42:0427 (42:427 Social Security Benefits)",
      "42:10841" : "42:10841 (42:10841 Mental Health Systems Act)",
      "42:11601" : "42:11601 (42:11601 International Child Abduction Remedies Act)",
      "42:12101" : "42:12101 (42:12101 Americans with Disabilities Act)",
      "42:1383" : "42:1383 (42:1383 Review of HHS Decision)",
      "42:1395" : "42:1395 (42:1395 HHS: Adverse Reimbursement Review)",
      "42:1396" : "42:1396 (42:1396 - Tort Negligence)",
      "42:13981" : "42:13981 (42:13981 Violence Against Women Act of 1995)",
      "42:1471" : "42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclo)",
      "42:1973av" : "42:1973av (42:1973av Requirement w/Response to Admin of Voter Registration)",
      "42:1973ce" : "42:1973ce (42:1973ce Civil Enforcement and Private Right of Action)",
      "42:1973gg6" : "42:1973gg6 (42:1973gg6 Requirement W/Resp To Admin Of Voter Registration)",
      "42:1973gg9" : "42:1973gg9 (42:1973gg9 Civil Enforcement and Private Right of Action)",
      "42:1981cv" : "42:1981cv (42:1981 Civil Rights)",
      "42:1981hs" : "42:1981hs (42:1981 Housing Discrimination)",
      "42:1981jb" : "42:1981jb (42:1981 Job Discrimination (Race))",
      "42:1981sx" : "42:1981sx (42:1981 Sex Discrimination)",
      "42:1983cv" : "42:1983cv (42:1983 Civil Rights Act)",
      "42:1983ed" : "42:1983ed (42:1983 Civil Rights (Employment Discrimination))",
      "42:1983pr" : "42:1983pr (42:1983 Prisoner Civil Rights)",
      "42:1986" : "42:1986 (42:1986 Neglect of Duty)",
      "42:2000ag" : "42:2000ag (42:2000 Job Discrimination (Age))",
      "42:2000e" : "42:2000e (42:2000e Job Discrimination (Employment))",
      "42:2000pb" : "42:2000pb (42:2000 Job Discrimination (Public Accomodations))",
      "42:2000ra" : "42:2000ra (42:2000 Job Discrimination (Race))",
      "42:2000sx" : "42:2000sx (42:2000 Job Discrimination (Sex))",
      "42:2003" : "42:2003 (42:2003 Job Discrimination)",
      "42:2005" : "42:2005 (42:2005 Review of Agency Action-HHS)",
      "42:2651" : "42:2651 (42:2651 Medical Care Recovery)",
      "42:288c" : "42:288c (42:288c National Research Service Awards Recovery)",
      "42:3601" : "42:3601 (42:405 Fair Housing Act)",
      "42:3604" : "42:3604 (42:3604 Title VIII - Housing Discrimination)",
      "42:4000" : "42:4000 (42:4000 National Flood Insurance Act)",
      "42:4001" : "42:4001 (42:4001 National Insurance Flood Act)",
      "42:4053" : "42:4053 (42:4053 Breach of Insurance Contract)",
      "42:4072" : "42:4072 (42:4072 Payment of Flood Insurance Claim)",
      "42:4321" : "42:4321 (42:4321 Review of Agency Action-Environment)",
      "42:4332" : "42:4332 (42:4332 Environmental Policy - Coop of Agency Repo)",
      "42:6901en" : "42:6901en (42:6901 Environmental Cleanup Expenses)",
      "42:6901rs" : "42:6901rs (42:6901 Resource & Recovery Act)",
      "42:7413" : "42:7413 (42:7413(b) Clean Air Act)",
      "42:7604cl" : "42:7604cl (42:7604 Clear Air Act (Emission Standards))",
      "42:7604ir" : "42:7604ir (42:7604 Petition to Quash IRS Summons)",
      "42:9607" : "42:9607 (42:9607 Real Property Tort to Land)",
      "43:945" : "43:945 (43:945 Compensation for Land Condemnation)",
      "43:945a" : "43:945a (43:945a Complaint in Condemnation)",
      "43:946" : "43:946 (43:946 Complaint in Condemnation - Eminent Domain)",
      "45:0051" : "45:0051 (45:51 Railways: Fed. Employer's Liability Act)",
      "45:0056" : "45:0056 (45:0056 Federal Employers Liability Act)",
      "45:0151" : "45:0151 (45:151 Railway Labor Act)",
      "45:0184" : "45:0184 (45:184 Action to Set Aside Award of a System Board)",
      "45:1395" : "45:1395 (45:1395 Railroads: Adverse Reimbursement Review)",
      "45:7457" : "45:7457 (45:7457 Compel Reclamation Under Clear Air Act)",
      "46:0181" : "46:0181 (46:0181 Admiralty Liability)",
      "46:0688" : "46:0688 (46:688 Jones Act)",
      "46:0741" : "46:0741 (46:741 Shipping)",
      "46:0761" : "46:0761 (46:761 Shipping: Damages for Death on High Seas)",
      "46:1101" : "46:1101 (46:1101 Violation of Maritime Regulations)",
      "46:1156" : "46:1156 (46:1156 Administrative Procedure Act)",
      "46:31325" : "46:31325 (46:31325 Preferred Mortgage Liens and Enforcement)",
      "46:761" : "46:761 (46:761 Death on the High Seas Act)",
      "47:0151" : "47:0151 (47:0151 Cable Communication Policy Act)",
      "47:0207" : "47:0207 (47:0207 Federal Communications Act - Recovery of Damages)",
      "47:0227" : "47:0227 (47:0227 Telephone Consumer Protection Act)",
      "47:0553" : "47:0553 (47:0553 Unauthorized Reception of Cable Service)",
      "47:0605" : "47:0605 (47:0605 Unauthorized Publication or Use of Communications)",
      "47:332" : "47:332 (47:332 Federal Telecommunications Act of 1996)",
      "47:553" : "47:553 (47:553 Unauthorized reception of cable service)",
      "47:605" : "47:605 (47:605 Unauthorized publication or use of communications)",
      "48:0883" : "48:0883 (48:883 Violation of US Coastal Law)",
      "48:1985" : "48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)",
      "49:0081" : "49:0081 (49:81 Damaged Goods While Being Transported)",
      "49:0781" : "49:0781 (49:781 Forfeiture)",
      "49:11503" : "49:11503 (49:11503 Railroad Revitalization Regulatory Reform)",
      "49:11702" : "49:11702 (49:11702(a)(4) Violations of Interstate Commerce A)",
      "49:14704" : "49:14704 (49:14704 ICC Termination Act of 1995)",
      "49:1471" : "49:1471 (49:1471 Federal Aviation Act)",
      "49:1903" : "49:1903 (49:1903 Petition to enforce administrative summon)",
      "8:287" : "8:287 (8:287 Petition to Enforce INS Subpoena)",
      "misc" : "misc (Civil Miscellaneous Case)"
   },
   "mowdce" : {
      "0" : "0 (No cause code entered)",
      "00:0000" : "00:0000 (00:0000 Cause Code Unknown)",
      "02:0431" : "02:0431 (02:431 Fed. Election Commission: Failure Enforce C)",
      "02:0437" : "02:0437 (02:437 Federal Election Commission)",
      "05:0075" : "05:0075 (05:75(2) Contract - Reduction in Grade)",
      "05:0551" : "05:0551 (05:551 Administrative Procedure Act)",
      "05:0552fi" : "05:0552fi (05:552 Freedom of Information Act)",
      "05:0552pa" : "05:0552pa (05:552 Right to Privacy Act)",
      "05:0554" : "05:0554 (05:0554 Constitutionality of Maritime Statutes)",
      "05:0701" : "05:0701 (05:0701 Maritime Subsidy Board)",
      "05:0702" : "05:0702 (05:702 Administrative Procedure Act)",
      "05:0704" : "05:0704 (05:704 Labor Litigation)",
      "05:0706" : "05:0706 (05:0706 Review of Judicial Administrative Decision)",
      "05:7703" : "05:7703 (05:7703 Discrimination - Review of Agency Act)",
      "05:8912" : "05:8912 (05:8912 Denial of Federal Employee Health Benefits )",
      "07:0006" : "07:0006 (7:6(b) Federal Commodity Exchange Regulation)",
      "07:0025" : "07:0025 (7:25 Fraud - Commodities Leverage Contracts)",
      "07:0181" : "07:0181 (07:181 Packers & Stockyard Act)",
      "07:0499" : "07:0499 (07:499 Agricultural Commodities Act)",
      "07:0601" : "07:0601 (07:601 USDA Condemnation)",
      "07:2023" : "07:2023 (07:2023 Review of disqualification of food stamps )",
      "07:2131" : "07:2131 (07:2131 Animal Welfare Act Penalty)",
      "07:2156" : "07:2156 (07:2156 Forfeiture of Animals Involved in Dog Fighting)",
      "07:2321" : "07:2321 (07:2321 Plant Variety Protection Act)",
      "08:1101" : "08:1101 (08:1101 Legal Immigration Family Equity Act)",
      "08:1105" : "08:1105 (8:1105(a) Aliens: Habeas Corpus to Release INS Det)",
      "08:1252" : "08:1252 (08:1252(a)(2) Injunction for Deportation)",
      "08:1260" : "08:1260 (08:1260 Aliens: Access to Records)",
      "08:1324" : "08:1324 (08:1324 Aliens: Complaint for Forfeiture)",
      "08:1324a" : "08:1324a (Unlawful employment of aliens)",
      "08:1329" : "08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petiti)",
      "08:1446" : "08:1446 (8:1446 Petition for Naturalization Hearing)",
      "08:1447" : "08:1447 (08:1447 Hearing on Failure to Make a Determination under 08:1446)",
      "08:1451a" : "08:1451a (8:1451a Revocation of Naturalization)",
      "09:0001" : "09:0001 (09:1 U.S. Arbitration Act)",
      "09:0009" : "09:0009 (9:9 Motion to Confirm Arbitration Loan)",
      "09:0010" : "09:0010 (09:0010 Petition to Vacate Arbitration Award)",
      "09:0205" : "09:0205 (09:0205 Recognition and Enforcement of Foreign Arbitral Award)",
      "10:1552" : "10:1552 (10:1552 Armed Forces: Action to Correct Records)",
      "10:1553" : "10:1553 (10:1553 Armed Forces: FOIA General)",
      "10:2305" : "10:2305 (10:2305 Review of Federal Contract)",
      "11:0101" : "11:0101 (11:101 Bankruptcy)",
      "12:0022" : "12:0022 (12:22 Securities Fraud)",
      "12:0635" : "12:0635 (12:635 Breach of Insurance Contract)",
      "12:1461" : "12:1461 (12:1461 Homeowners Loan Act)",
      "12:1703" : "12:1703 (12:1703 Default of HUD Loan)",
      "12:1715z-1" : "12:1715z-1 (12:1715z-1 National Housing Act )",
      "12:1725" : "12:1725 (12:1725 Collection under Contract Guaranty)",
      "12:1730" : "12:1730 (12:1730 Collection Under Contract Guaranty)",
      "12:1819" : "12:1819 (12:1819 Default of Promissory Note)",
      "12:1821" : "12:1821 (12:1821 Default of Loan by Promissary Note)",
      "12:1971" : "12:1971 (12:1971 Relief under Bank Holding Act)",
      "12:2601" : "12:2601 (12:2601 Real Estate Settlement Procedures Act)",
      "12:3410" : "12:3410 (12:3410 Right to Financial Privacy Act)",
      "12:5531" : "12:5531 (Prohibiting unfair, deceptive, or abusive acts or practices)",
      "12:5536" : "12:5536 (Prohibited acts)",
      "15:0001" : "15:0001 (15:1 Antitrust Litigation)",
      "15:0002at" : "15:0002at (15:2 Antitrust Litigation)",
      "15:0002fl" : "15:0002fl (15:2(a) Fair Labor Standards Act)",
      "15:0005" : "15:0005 (15:5(a) Fair Labor Standards Act)",
      "15:0015" : "15:0015 (15:15 Antitrust Litigation)",
      "15:0025" : "15:0025 (15:25 Clayton Act)",
      "15:0044" : "15:0044 (15:44 Trademark Infringement)",
      "15:0045" : "15:0045 (15:0045 Federal Trade Commission Act)",
      "15:0052" : "15:0052 (15:0052 Federal Trade Commission Act)",
      "15:0053" : "15:0053 (15:0053 Federal Trade Commission Act)",
      "15:0077" : "15:0077 (15:77 Securities Fraud)",
      "15:0078" : "15:0078 (15:78m(a) Securities Exchange Act)",
      "15:0631" : "15:0631 (15:631 Small Business Act)",
      "15:0714" : "15:0714 (15:0714b(c) Breach of Conservation Reserve Program Contracts)",
      "15:0717" : "15:0717 (15:717 Natural Gas Act)",
      "15:1051" : "15:1051 (15:1051 Trademark Infringement)",
      "15:1114" : "15:1114 (15:1114 Trademark Infringement)",
      "15:1121" : "15:1121 (15:1121 Trademark Infringement)",
      "15:1125" : "15:1125 (15:1125 Trademark Infringement (Lanham Act))",
      "15:1126" : "15:1126 (15:1126 Patent Infringement)",
      "15:1127" : "15:1127 (15:1127 Trademark Infringement)",
      "15:1501" : "15:1501 (15:1501 Unfair Competition claims for false advertising and trademark infringement)",
      "15:1601" : "15:1601 (15:1601 Truth in Lending)",
      "15:1640" : "15:1640 (15:1640 Truth in Lending)",
      "15:1681" : "15:1681 (15:1681 Fair Credit Reporting Act)",
      "15:1692" : "15:1692 (15:1692 Fair Debt Collection Act)",
      "15:1693" : "15:1693 (15:1693 Electronic Fund Transfer Act)",
      "15:1938" : "15:1938 (15:1938 Fair Labor Standards Act)",
      "15:1981" : "15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))",
      "15:1988" : "15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))",
      "15:1989" : "15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))",
      "15:2301" : "15:2301 (15:2301 Magnuson-Moss Warranty Act)",
      "15:2801" : "15:2801 (15:2801 Petroleum Marketing Practices Act)",
      "15:53(b)" : "15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equita)",
      "15:6801" : "15:6801 (15:6801 Violation of Gramm-Leach-Bliley Act)",
      "15:6809" : "15:6809 (15:6809 Commerce and Trade)",
      "16:0668" : "16:0668 (16:668 Bald Eagle Protection Act)",
      "16:0703" : "16:0703 (16:703 Migratory Bird Act)",
      "16:1538" : "16:1538 (16:1538 Endangered Species Act)",
      "16:3371" : "16:3371 (16:3371 Wildlife Under the Lacey Act)",
      "16:3372" : "16:3372 (16:3372 Conservation: Complaint for Forfeiture)",
      "16:3373" : "16:3373 (16:3373 Appeal of Decision - DOI)",
      "16:3374" : "16:3374 (16:3374 Conservation: Complaint for Forfeiture)",
      "16:6330" : "16:6330 (16:6330 Judicial Review of a Collection Due Process - IRS)",
      "16:791a" : "16:791a (Federal Power Act)",
      "17:0101" : "17:0101 (17:101 Copyright Infringement)",
      "17:0106A" : "17:0106A (17:0106A Rights of Certain Authors to Attribution and Integrity)",
      "17:0501" : "17:0501 (17:501 Copyright Infringement)",
      "17:0504" : "17:0504 (17:504 Copyright Infringement)",
      "17:0512(h)" : "17:0512(h) (17:0512(h) Subpoena to Identify Infringer)",
      "18:0241" : "18:0241 (18:241 Conspiracy Against Citizen Rights)",
      "18:0923" : "18:0923 (18:0923 Denial or revocation of firearms license)",
      "18:1030" : "18:1030 (18:1030 Computer Fraud and Abuse Act )",
      "18:1345" : "18:1345 (18:1345 Fraud Injunction Statute)",
      "18:1514A" : "18:1514A (18:1514A Sarbanes-Oxley Act of 2002)",
      "18:1836a" : "18:1836a (18:1836(a) Injunction against Misappropriation of Trade Secrets)",
      "18:1836b" : "18:1836b (18:1836(b) Civil Action to Protect Trade Secrets)",
      "18:1961" : "18:1961 (18:1961 Racketeering (RICO) Act)",
      "18:1962" : "18:1962 (18:1962 Racketeering (RICO) Act)",
      "18:1964" : "18:1964 (18:1964 Racketeering (RICO) Act)",
      "18:2254" : "18:2254 (18:2254 Civil Forfeiture)",
      "18:248" : "18:248 (18:248 Freedom of Access to Clinic Entrances Act of 1994 )",
      "18:2510" : "18:2510 (18:2510 Electronic Communications Privacy Act )",
      "18:2721" : "18:2721 (18:2721 Driver's Privacy Protection Act)",
      "18:3511" : "18:3511 (Judicial Review of Requests for Information)",
      "18:4208" : "18:4208 (18:4208(B) Agency Action Review)",
      "18:4245" : "18:4245 (18:4245 Petition to Determine Mental Status of Prisoner)",
      "18:4246" : "18:4246 (18:4246 Petition to Determine Present Mental Condition of Imprisoned Person)",
      "18:981" : "18:981 (18:981 Civil Forfeiture)",
      "19:1305" : "19:1305 (19:1305 Custom Duties:0Forfeiture-Immoral Articles)",
      "20:1080" : "20:1080 (20:1080 Student Loan Recovery)",
      "20:1095" : "20:1095 (20:1095 Failure to Comply with Order of Withholding from Earnings)",
      "20:1400" : "20:1400 (20:1400 Civil Rights of Handicapped Child)",
      "20:1401" : "20:1401 (20:1401 Education: Handicapped Child Act)",
      "20:1415" : "20:1415 (20:1415 Individuals with Disabilities)",
      "20:1681" : "20:1681 (20:1681 Title IX Educational Amendments 1992 - Sex Discrimination)",
      "21:0801" : "21:0801 (21:0801 Health Care Fraud)",
      "21:0841" : "21:0841 (21:841 Forfeiture Property-Drugs)",
      "21:0881" : "21:0881 (21:881 Forfeiture Property-Drugs)",
      "21:0881a" : "21:0881a (21:881 Forfeiture Property - Aircraft)",
      "21:0881mv" : "21:0881mv (21:0881mv Forfeiture of Motor Vehicle)",
      "21:0881re" : "21:0881re (21:881 Forfeiture Property - Real Estate)",
      "21:332A" : "21:332A (21:332A Food, Drug & Cosmetics Act)",
      "23:0134" : "23:0134 (23:134 P.I.- Auto Negligence)",
      "23:1441" : "23:1441 (23:1441 Contract Real Estate)",
      "24:1000" : "24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)",
      "25:0640" : "25:0640 (25:640 Indian Tribal Rights)",
      "25:1901" : "25:1901 (25:1901 Indian Child Welfare Act)",
      "26:6103" : "26:6103 (26:6103 Confidentiality and Disclosure of Tax Return Information)",
      "26:6111" : "26:6111 (26:6111 Tax Code - Disclosure of Reportable Transactions)",
      "26:6212" : "26:6212 (26:6212 Injunctive Relief from IRS Lien)",
      "26:6213" : "26:6213 (26:6213 Injunctive Relief from IRS Lien)",
      "26:6330" : "26:6330 (26:6330 Review of IRS Due Process Hearing)",
      "26:6502" : "26:6502 (26:6502 IRS:Enforcement of tax liens)",
      "26:6532" : "26:6532 (26:6532 IRS: Refund of Tax Penalty)",
      "26:6702" : "26:6702 (26:6702 IRS: Refund of Income Tax Penalty)",
      "26:6703" : "26:6703 (26:6703 IRS: Refund of Tax Penalty)",
      "26:7401" : "26:7401 (26:7401 IRS: Tax Liability)",
      "26:7402" : "26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)",
      "26:7403" : "26:7403 (26:7403 Suit to Enforce Federal Tax Lien)",
      "26:7407" : "26:7407 (26:7407 Action to Enjoin Income Tax Preparers)",
      "26:7422rt" : "26:7422rt (26:7422 IRS: Refund Taxes)",
      "26:7422rx" : "26:7422rx (26:7422 IRS: Refund Excise Tax)",
      "26:7426" : "26:7426 (26:7426 IRS: Wrongful Levy for Taxes)",
      "26:7429" : "26:7429 (26:7429 IRS: Tax Jeopardy Assessment)",
      "26:7434" : "26:7434 (26:7434 Civil Damages for Fraudulent Filing of Information Returns)",
      "26:7609" : "26:7609 (26:7609 IRS: Petition to Quash IRS Summons)",
      "27:0185" : "27:0185 (27:185 Enforcement of Arbitration Award)",
      "28:0157c" : "28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)",
      "28:0157d" : "28:0157d (28:0157 Motion for Withdrawal of Reference)",
      "28:0158" : "28:0158 (28:0158 Notice of Appeal re Bankruptcy Matter (BA)",
      "28:0185" : "28:0185 (28:185 Suit to Compel Arbitration)",
      "28:0451" : "28:0451 (28:451 Employment Discrimination)",
      "28:0794" : "28:0794 (28:794 Rehabilitation Act)",
      "28:1001" : "28:1001 (28:1001 E.R.I.S.A.)",
      "28:1132" : "28:1132 (28:1132 E.R.I.S.A.)",
      "28:1330" : "28:1330 (28:1330 Breach of Contract)",
      "28:1331" : "28:1331 (28:1331 Fed. Question)",
      "28:1331al" : "28:1331al (28:1331 Fed. Question: Airline Crash)",
      "28:1331at" : "28:1331at (28:1331 Fed. Question: Anti-trust)",
      "28:1331au" : "28:1331au (28:1331 Fed. Question: Auto Negligence)",
      "28:1331b" : "28:1331b (28:1331 Federal Question: Bivens Act)",
      "28:1331bc" : "28:1331bc (28:1331 Fed. Question: Breach of Contract)",
      "28:1331ca" : "28:1331ca (28:1331 Fed Question: Fed Communications Act of 1)",
      "28:1331cm" : "28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)",
      "28:1331cv" : "28:1331cv (28:1331 Federal Question: Other Civil Rights)",
      "28:1331ed" : "28:1331ed (28:1331 Fed. Question: Employment Discrimination)",
      "28:1331es" : "28:1331es (28:1331 Enforcement of Administrative Subpoena)",
      "28:1331fl" : "28:1331fl (28:1331 Fed. Question: Fair Labor Standards)",
      "28:1331in" : "28:1331in (28:1331 Fed. Question: Insurance Contract)",
      "28:1331mm" : "28:1331mm (28:1331 Fed. Question: Medical Malpractice)",
      "28:1331pi" : "28:1331pi (28:1331 Fed. Question: Personal Injury)",
      "28:1331rd" : "28:1331rd (28:1331 Fed. Question: Review Agency Decision)",
      "28:1331rp" : "28:1331rp (28:1331(a) Fed. Question: Real Property)",
      "28:1331rr" : "28:1331rr (28:1331 Fed. Question: Railway Labor Act)",
      "28:1331sv" : "28:1331sv (28:1331 Fed. Question: Securities Violation)",
      "28:1331tr" : "28:1331tr (28:1331 Fed. Question: Trademark)",
      "28:1331tt" : "28:1331tt (28:1331 Fed. Question: Tort Action)",
      "28:1331v" : "28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendme)",
      "28:1331wl" : "28:1331wl (28:1331 Federal Question: EPA Waste Lien)",
      "28:1331wt" : "28:1331wt (28:1331 Fed. Question: Water Rights)",
      "28:1332ac" : "28:1332ac (28:1332 Diversity-Account Receivable)",
      "28:1332al" : "28:1332al (28:1332 Diversity-Airline Crash)",
      "28:1332as" : "28:1332as (28:1332 Diversity-Asbestos Litigation)",
      "28:1332au" : "28:1332au (28:1332 Diversity-Auto Negligence)",
      "28:1332bc" : "28:1332bc (28:1332 Diversity-Breach of Contract)",
      "28:1332co" : "28:1332co (28:1332 Diversity-Conversion)",
      "28:1332ct" : "28:1332ct (28:1332 Diversity-(Citizenship))",
      "28:1332det" : "28:1332det (28:1332 Diversity: Forcible Detainer)",
      "28:1332df" : "28:1332df (28:1332 Diversity-Contract Default)",
      "28:1332ds" : "28:1332ds (28:1332 Diversity-Contract Dispute)",
      "28:1332ed" : "28:1332ed (28:1332 Diversity-Employment Discrimination)",
      "28:1332fd" : "28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)",
      "28:1332fr" : "28:1332fr (28:1332 Diversity-Fraud)",
      "28:1332ia" : "28:1332ia (28:1332 Diversity-Interpleader Action)",
      "28:1332ij" : "28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)",
      "28:1332in" : "28:1332in (28:1332 Diversity-Insurance Contract)",
      "28:1332jd" : "28:1332jd (28:1332 Diversity-Declaratory Judgment)",
      "28:1332lb" : "28:1332lb (28:1332 Diversity-Libel,Assault,Slander)",
      "28:1332lm" : "28:1332lm (28:1332 Diversity - Legal Malpractice)",
      "28:1332ma" : "28:1332ma (28:1332 Diversity-Miller Act)",
      "28:1332mm" : "28:1332mm (28:1332 Diversity-Medical Malpractice)",
      "28:1332mv" : "28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)",
      "28:1332ni" : "28:1332ni (28:1332 Diversity-Negotiable Instrument)",
      "28:1332nm" : "28:1332nm (28:1332 Diversity-Non-Motor Vehicle)",
      "28:1332oc" : "28:1332oc (28:1332 Diversity-Other Contract)",
      "28:1332pd" : "28:1332pd (28:1332 Diversity-Property Damage)",
      "28:1332pi" : "28:1332pi (28:1332 Diversity-Personal Injury)",
      "28:1332pl" : "28:1332pl (28:1332 Diversity-Product Liability)",
      "28:1332pr" : "28:1332pr (28:1332 Diversity-Petition for Removal)",
      "28:1332qt" : "28:1332qt (28:1332 Diversity-Petition to Quiet Title)",
      "28:1332ri" : "28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)",
      "28:1332sa" : "28:1332sa (28:1332 - Diversity: Securities & Exchange Commiss)",
      "28:1332sf" : "28:1332sf (28:1332 - Diversity: Securities Fraud)",
      "28:1332ss" : "28:1332ss (28:1332 Diversity - Stockholders Suits)",
      "28:1332tl" : "28:1332tl (28:1332 Diversity-Torts to Land)",
      "28:1332tm" : "28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))",
      "28:1332tn" : "28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)",
      "28:1332wd" : "28:1332wd (28:1332 Diversity-Wrongful Death)",
      "28:1333" : "28:1333 (28:1333 Admiralty)",
      "28:1334" : "28:1334 (28:1334 Bankruptcy Appeal)",
      "28:1334c" : "28:1334c (28:1334(c) R&R re motions for abstention (non-cor)",
      "28:1335" : "28:1335 (28:1335 Interpleader Action)",
      "28:1337" : "28:1337 (28:1337 Sherman-Clayton Act)",
      "28:1338cp" : "28:1338cp (28:1338 Copyright Infringement)",
      "28:1338pt" : "28:1338pt (28:1338 Patent Infringement)",
      "28:1338tr" : "28:1338tr (28:1338 Trademark Infringement)",
      "28:1340" : "28:1340 (28:1340 IRS: Custom Duties)",
      "28:1340er" : "28:1340er (28:1340 Recovery of Erroneous Refund)",
      "28:1341" : "28:1341 (28:1341 Complaint for Forfeiture)",
      "28:1343" : "28:1343 (28:1343 Violation of Civil Rights)",
      "28:1345" : "28:1345 (28:1345 Petition for Indemnity)",
      "28:1345co" : "28:1345co (28:1345 Replevin & Conversion)",
      "28:1345db" : "28:1345db (28:1345 Debt to US - FHA/HUD Title I)",
      "28:1345df" : "28:1345df (28:1345 Default of Promissory Note)",
      "28:1345er" : "28:1345er (28:1345 Recovery of Erroneous Refund)",
      "28:1345fc" : "28:1345fc (28:1345 Foreclosure)",
      "28:1345ff" : "28:1345ff (28:1345 Complaint for Forfeiture)",
      "28:1345hl" : "28:1345hl (28:1345 VA Home Loan Guaranty Debt)",
      "28:1345mc" : "28:1345mc (28:1345 Medical Care Recovery)",
      "28:1345mi" : "28:1345mi (28:1345 Mining Claim Ejectment)",
      "28:1345pd" : "28:1345pd (28:1345 Property Damage)",
      "28:1345pe" : "28:1345pe (28:1345 Property Ejectment)",
      "28:1345q" : "28:1345q (28:1345 Quiet Title Action)",
      "28:1345rc" : "28:1345rc (28:1345 Recovery of Debt to US)",
      "28:1345st" : "28:1345st (28:1345 Default of Student Loan)",
      "28:1345tp" : "28:1345tp (28:1345 Trespass on Public Land)",
      "28:1345va" : "28:1345va (28:1345 Recovery of VA Overpayment)",
      "28:1346bc" : "28:1346bc (28:1346 Breach of Contract)",
      "28:1346rc" : "28:1346rc (28:1346 Recovery of IRS Tax)",
      "28:1346tc" : "28:1346tc (28:1346 Tort Claim)",
      "28:1346wd" : "28:1346wd (28:1346 Wrongful Death)",
      "28:1352" : "28:1352 (28:1352 Miller Act)",
      "28:1355" : "28:1355 (28:1355 Petition for Return of Property)",
      "28:1358" : "28:1358 (28:1358 Land Condemnation)",
      "28:1361" : "28:1361 (28:1361 Petition for Writ of Mandamus)",
      "28:1362ic" : "28:1362ic (28:1362 Indian Tribal Controversy)",
      "28:1362iw" : "28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)",
      "28:1364" : "28:1364 (28:1364 Auto Negligence)",
      "28:1391" : "28:1391 (28:1391 Personal Injury)",
      "28:1402" : "28:1402 (28:1402 Medical Malpractice)",
      "28:1407" : "28:1407 (28:1407 Multidistrict Litigation)",
      "28:1441ac" : "28:1441ac (28:1441 Petition for Removal- Account Receivable)",
      "28:1441al" : "28:1441al (28:1441 Petition for Removal- Airline Crash)",
      "28:1441as" : "28:1441as (28:1441 Petition for Removal- Asbestos Litigation)",
      "28:1441au" : "28:1441au (28:1441 Petition for Removal- Auto Negligence)",
      "28:1441bc" : "28:1441bc (28:1441 Petition for Removal- Breach of Contract)",
      "28:1441cv" : "28:1441cv (28:1441 Petition for Removal- Civil Rights Act)",
      "28:1441df" : "28:1441df (28:1441 Petition for Removal- Contract Default)",
      "28:1441dj" : "28:1441dj (28:1441 Petition for Removal- Declaratory Judgemen)",
      "28:1441ds" : "28:1441ds (28:1441 Petition for Removal- Contract Dispute)",
      "28:1441ed" : "28:1441ed (28:1441 Petition for Removal - Employment Discrim)",
      "28:1441fc" : "28:1441fc (28:1441 Petition for Removal - Fair Credit Reporti)",
      "28:1441fr" : "28:1441fr (28:1441 Petition for Removal- Fraud)",
      "28:1441ij" : "28:1441ij (28:1441 Petition for Removal- Injunctive/Declarato)",
      "28:1441in" : "28:1441in (28:1441 Petition for Removal- Insurance Contract)",
      "28:1441int" : "28:1441int (28:1441 Petition for Removal- Action for Interplea)",
      "28:1441lb" : "28:1441lb (28:1441 Petition for Removal Libel,Assault,Slander)",
      "28:1441lm" : "28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relatio)",
      "28:1441mm" : "28:1441mm (28:1441 Petition for Removal- Medical Malpractice)",
      "28:1441ni" : "28:1441ni (28:1441 Petition for Removal- Negotiable Instrumen)",
      "28:1441nm" : "28:1441nm (28:1441 Petition for Removal- Non-Motor Vehicle)",
      "28:1441oc" : "28:1441oc (28:1441 Petition For Removal--Other Contract)",
      "28:1441pd" : "28:1441pd (28:1441 Petition for Removal- Property Damage)",
      "28:1441pi" : "28:1441pi (28:1441 Petition for Removal- Personal Injury)",
      "28:1441pl" : "28:1441pl (28:1441 Petition for Removal- Product Liability)",
      "28:1441pr" : "28:1441pr (28:1441 Petition for Removal)",
      "28:1441qt" : "28:1441qt (28:1441 Petition for Removal- Petition to Quiet Ti)",
      "28:1441ri" : "28:1441ri (28:1441 Petition for Removal- Racketeering (RICO))",
      "28:1441sa" : "28:1441sa (28:1441 - Petition for Removal: SEC Act)",
      "28:1441sf" : "28:1441sf (28:1441 - Petition for Removal: Securities Fraud)",
      "28:1441tl" : "28:1441tl (28:1441 Petition for Removal- Torts to Land)",
      "28:1441tm" : "28:1441tm (28:1441 Petition for Removal- Tort/Motor Vehicle ()",
      "28:1441tn" : "28:1441tn (28:1441 Petition for Removal- Tort/Non-Motor Vehic)",
      "28:1441wd" : "28:1441wd (28:1441 Petition for Removal- Wrongful Death)",
      "28:1442bc" : "28:1442bc (28:1442 Petition for Removal- Breach of Contract)",
      "28:1442pr" : "28:1442pr (28:1442 Petition for Removal)",
      "28:1443" : "28:1443 (28:1443(1) Rent, Lease & Ejectment)",
      "28:1444" : "28:1444 (28:1444 Petition for Removal- Foreclosure)",
      "28:1446in" : "28:1446in (28:1446 Breach of Contract- Insurance)",
      "28:1446pd" : "28:1446pd (28:1446 Petition for Removal- Property Damage (P.I)",
      "28:1446pi" : "28:1446pi (28:1446 Petition for Removal- Personal Injury)",
      "28:1446pl" : "28:1446pl (28:1446pl Petition for Removal - Product Liability)",
      "28:1446pr" : "28:1446pr (28:1446 Petition for Removal)",
      "28:1452" : "28:1452 (28:1452 R&R re motions to remand (non-core))",
      "28:1651" : "28:1651 (28:1651 Petition for Writ of Coram Nobis)",
      "28:1651hc" : "28:1651hc (28:1651 Petition for Writ of Habeas Corpus)",
      "28:1651mn" : "28:1651mn (28:1651 Petition for Writ of Mandamus)",
      "28:1983" : "28:1983 (28:1983 Civil Rights)",
      "28:2201" : "28:2201 (28:2201 Constitutionality of State Statute(s))",
      "28:2201dj" : "28:2201dj (28:2201 Declaratory Judgement)",
      "28:2201ij" : "28:2201ij (28:2201 Injunction)",
      "28:2201in" : "28:2201in (28:2201 Declaratory Judgement (Insurance))",
      "28:2241" : "28:2241 (28:2241 Petition for Writ of Habeas Corpus (federa)",
      "28:2254" : "28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))",
      "28:2254se" : "28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)",
      "28:2255" : "28:2255 (28:2255 Motion to Vacate / Correct Illegal Sentenc)",
      "28:2271" : "28:2271 (28:2271 Federal Tort Claims Act)",
      "28:2345" : "28:2345 (28:2345 Medicare Recovery)",
      "28:2409" : "28:2409 (28:2409(a) Quiet Title Action)",
      "28:2410" : "28:2410 (28:2410 Quiet Title)",
      "28:2671" : "28:2671 (28:2671 Federal Tort Claims Act)",
      "28:2674" : "28:2674 (28:2674 Federal Tort Claims Act)",
      "28:2679" : "28:2679 (28:2679 Removal of damages action against Federal Employee)",
      "28:3001" : "28:3001 (28:3001 Federal Debt Collections Procedure Act)",
      "28:3301" : "28:3301 (28:3301 Fraudulent Transfer)",
      "28:7402" : "28:7402 (28:7402 Refund of Taxes)",
      "28:7422" : "28:7422 (28:7422 Appeal from Administrative Decision)",
      "29:0151" : "29:0151 (29:151 Labor: Review of Agency Action)",
      "29:0160" : "29:0160 (29:160(1) National Labor Relations Act)",
      "29:0184" : "29:0184 (29:184 Violation Collection Bargain Agreement)",
      "29:0185ep" : "29:0185ep (29:185 Employee Pension Plan)",
      "29:0185lm" : "29:0185lm (29:185 Labor/Mgt. Relations (Contracts))",
      "29:0201do" : "29:0201do (29:201 Denial of Overtime Compensation)",
      "29:0201fl" : "29:0201fl (29:201 Fair Labor Standards Act)",
      "29:0203" : "29:0203 (29:203 Equal Pay Act)",
      "29:0206" : "29:0206 (29:206 Collect Unpaid Wages)",
      "29:0216" : "29:0216 (29:0216 Failure to Pay Earned Compensation)",
      "29:0217" : "29:0217 (29:0217 Action for Injunctive Relief-Minimum Wage and Overtime Comp)",
      "29:0401" : "29:0401 (29:0401 Labor Management Disclosure Act)",
      "29:0621" : "29:0621 (29:621 Job Discrimination (Age))",
      "29:0623" : "29:0623 (29:623 Job Discrimination (Age))",
      "29:0626" : "29:0626 (29:626 Job Discrimination (Age))",
      "29:0633" : "29:0633 (29:633 Job Discrimination (Age))",
      "29:0651" : "29:0651 (29:651 Occupational Safety/Health)",
      "29:0754" : "29:0754 (29:754 Discrimination)",
      "29:0791" : "29:0791 (29:791 Job Discrimination (Rehabilitation Act))",
      "29:0794" : "29:0794 (29:0794 Job Discrimination (Handicap))",
      "29:1001" : "29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)",
      "29:1002" : "29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)",
      "29:1104" : "29:1104 (29:1104 Recovery of Benefits to Employee)",
      "29:1109" : "29:1109 (29:1109 Breach of Fiduciary Duties)",
      "29:1131" : "29:1131 (29:1131 ERISA - Collection of Delinquent Trust Fun)",
      "29:1132" : "29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)",
      "29:1145" : "29:1145 (29:1145 E.R.I.S.A.)",
      "29:1149" : "29:1149 (29:1149 Recover Pension & Profit Sharing)",
      "29:1337" : "29:1337 (29:1337 E.R.I.S.A.)",
      "29:1362" : "29:1362 (29:1362 ERISA)",
      "29:1381" : "29:1381 (29:1381 E.R.I.S.A.)",
      "29:1401" : "29:1401 (29:1401(b)(2) Appeal of Arbitration Award)",
      "29:1451" : "29:1451 (29:1451 E.R.I.S.A.)",
      "29:1801" : "29:1801 (29:1801 Farmworker Rights)",
      "29:2601" : "29:2601 (29:2601 Family Medical Leave Act)",
      "29:412" : "29:412 (29:412 Infringement of Rights; jurisdiction)",
      "29:790" : "29:790 (29:790 Rehabilitation of Labor)",
      "29:791" : "29:791 (29:791 Employment Discrimination under the Rehabiliation Act)",
      "30:0181" : "30:0181 (30:181 Environment: Review of Agency Action)",
      "30:0801" : "30:0801 (30:0801 Penalities/Federal Mine Safety Health Act)",
      "30:1201" : "30:1201 (30:1201 Environment: Review of Agency Action)",
      "30:1202" : "30:1202 (30:1202 Mining Reclamation Act)",
      "30:1276" : "30:1276 (30:1276 Interior: Review of Agency Action)",
      "30:801" : "30:801 (30:801 Penalties Federal Mine Safety Health Act of 1977 )",
      "31:3545" : "31:3545 (31:3545 Action to Recovery Money)",
      "31:3729" : "31:3729 (31:3729 False Claims Act)",
      "31:3730" : "31:3730 (31:3730 Qui Tam False Claims Act)",
      "31:3731" : "31:3731 (31:3731 Fraud)",
      "33:1319cw" : "33:1319cw (33:1319 Clean Water Act)",
      "33:1319pv" : "33:1319pv (33:1319 Pollutants & Permit Violations)",
      "33:1365" : "33:1365 (33:1365 Environmental Matters)",
      "35:0101" : "35:0101 (35:0101 Patents)",
      "35:0145" : "35:0145 (35:145 Patent Infringement)",
      "35:0183" : "35:0183 (35:183 Patent Infringement)",
      "35:0271" : "35:0271 (35:271 Patent Infringement)",
      "35:0292" : "35:0292 (35:292 False Patent Marking)",
      "38:1681" : "38:1681 (38:1681 Recovery of VA Overpayment)",
      "38:1686" : "38:1686 (38:1686 Recovery of VA Overpayment)",
      "38:1780" : "38:1780 (38:1780 Recovery of VA Overpayment)",
      "38:2011" : "38:2011 (38:2011 - Veteran's Readjustment Assistance Act of)",
      "38:3116" : "38:3116 (38:3116 VA Overpayment)",
      "38:4301" : "38:4301 (38:4301 Employment/Reemployment Rights of Members of Uniformed Services)",
      "39:3005" : "39:3005 (39:3005 Detention of Mail for Temporary Periods)",
      "39:3008" : "39:3008 (39:3008 Prohibition of pandering advertisements)",
      "39:409" : "39:409 (39:409 Postal Service)",
      "40:0258" : "40:0258 (40:258(a) Public Buildings & Property: Land Condem)",
      "40:0270" : "40:0270 (40:270 Miller Act)",
      "40:0875" : "40:0875 (40:875 Public Buildings & Property: Negligence)",
      "40:3113" : "40:3113 (40:3113 Condemnation)",
      "41:0251" : "41:0251 (41:251 Public Contracts-Review of Agency Action)",
      "41:1463" : "41:1463 (41:1463 Public Contracts: Unlawful Employment Prac)",
      "42:0201" : "42:0201 (42:0201 Public Health Service)",
      "42:0205" : "42:0205 (42:205 Denial Social Security Benefits)",
      "42:0206" : "42:0206 (42:206 Social Security Benefits)",
      "42:0233" : "42:0233 (42:0233 Remand of tort action involving federally funded business)",
      "42:0247" : "42:0247 (42:247 Personal Injury-Swine Flu)",
      "42:0402" : "42:0402 (42:402 Social Security Benefits)",
      "42:0405id" : "42:0405id (42:405 Review of HHS Decision (SSID))",
      "42:0405si" : "42:0405si (42:405si Review of HHS Decision (RSI) )",
      "42:0405wc" : "42:0405wc (42:405 Review of HHS Decision (DIWC))",
      "42:0405ww" : "42:0405ww (42:405 Review of HHS Decision (DIWW))",
      "42:0408" : "42:0408 (42:0408 Social Security Fraud)",
      "42:0416" : "42:0416 (42:416 Denial of Social Security Benefits)",
      "42:0427" : "42:0427 (42:427 Social Security Benefits)",
      "42:11601" : "42:11601 (42:11601 International Child Abduction Remedies Act)",
      "42:12101" : "42:12101 (42:12101 American with Disabilities Act)",
      "42:12117" : "42:12117 (Americans with Disabilities Act )",
      "42:1320" : "42:1320 (42:1320 Disclosure of Health Information - HIPAA)",
      "42:1383" : "42:1383 (42:1383 Review of HHS Decision)",
      "42:1394" : "42:1394 (42:1394 Medicare as Secondary Payer Act)",
      "42:1395" : "42:1395 (42:1395 HHS: Adverse Reimbursement Review)",
      "42:1396" : "42:1396 (42:1396 - Tort Negligence)",
      "42:13981" : "42:13981 (42:13981 Violence Against Women Act )",
      "42:1471" : "42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclo)",
      "42:1751" : "42:1751 (National School Lunch Act and Child Nutrition Act)",
      "42:1973gg" : "42:1973gg (42:1973 Voter Registration Agency Designation)",
      "42:1981cv" : "42:1981cv (42:1981 Civil Rights)",
      "42:1981hs" : "42:1981hs (42:1981 Housing Discrimination)",
      "42:1981jb" : "42:1981jb (42:1981 Job Discrimination (Race))",
      "42:1981sx" : "42:1981sx (42:1981 Sex Discrimination)",
      "42:1983cv" : "42:1983cv (42:1983 Civil Rights Act)",
      "42:1983ed" : "42:1983ed (42:1983 Civil Rights (Employment Discrimination))",
      "42:1983pr" : "42:1983pr (42:1983 Prisoner Civil Rights)",
      "42:1986" : "42:1986 (42:1986 Neglect of Duty)",
      "42:2000ag" : "42:2000ag (42:2000 Job Discrimination (Age))",
      "42:2000e" : "42:2000e (42:2000e Job Discrimination (Employment))",
      "42:2000pb" : "42:2000pb (42:2000 Job Discrimination (Public Accomodations))",
      "42:2000ra" : "42:2000ra (42:2000 Job Discrimination (Race))",
      "42:2000sx" : "42:2000sx (42:2000 Job Discrimination (Sex))",
      "42:2003" : "42:2003 (42:2003 Job Discrimination)",
      "42:2005" : "42:2005 (42:2005 Review of Agency Action-HHS)",
      "42:2541" : "42:2541 (42:2541 Recovery of Scholarships)",
      "42:2651" : "42:2651 (42:2651 Medical Care Recovery)",
      "42:3601" : "42:3601 (42:405 Fair Housing Act)",
      "42:4000" : "42:4000 (42:4000 National Flood Insurance Act)",
      "42:4001" : "42:4001 (42:4001 National Insurance Flood Act)",
      "42:4053" : "42:4053 (42:4053 Breach of Insurance Contract)",
      "42:4072" : "42:4072 (42:4072 Payment of Flood Insurance Claim)",
      "42:425" : "42:425 (42:427 Social Security Benefits)",
      "42:4321" : "42:4321 (42:4321 Review of Agency Action-Environment)",
      "42:4332" : "42:4332 (42:4332 Environmental Policy - Coop of Agency Repo)",
      "42:4654" : "42:4654 (42:4654 Attorney's Fees/Expenses in Inverse Condemnation Case)",
      "42:4852" : "42:4852 (42:4852-Residential Lead Based Paint Act)",
      "42:5851" : "42:5851 (Energy Reorganization Act )",
      "42:6901en" : "42:6901en (42:6901 Environmental Cleanup Expenses)",
      "42:6901rs" : "42:6901rs (42:6901 Resource & Recovery Act)",
      "42:6928" : "42:6928 (42:6928 Federal Water Pollution Control Act)",
      "42:7413" : "42:7413 (42:7413(b) Clean Air Act)",
      "42:7604cl" : "42:7604cl (42:7604 Clear Air Act (Emission Standards))",
      "42:7604ir" : "42:7604ir (42:7604 Petition to Quash IRS Summons)",
      "42:9601" : "42:9601 (42:9601 Comprehensive Environm Resp, Comp & Liability Act )",
      "42:9607" : "42:9607 (42:9607 Real Property Tort to Land)",
      "43:945" : "43:945 (43:945 Compensation for Land Condemnation)",
      "43:945a" : "43:945a (43:945a Complaint in Condemnation)",
      "43:946" : "43:946 (43:946 Complaint in Condemnation - Eminent Domain)",
      "45:0051" : "45:0051 (45:51 Railways: Fed. Employer's Liability Act)",
      "45:0151" : "45:0151 (45:151 Railway Labor Act)",
      "45:0184" : "45:0184 (45:184 Action to Set Aside Award of a System Board)",
      "45:1395" : "45:1395 (45:1395 Railroads: Adverse Reimbursement Review)",
      "45:7457" : "45:7457 (45:7457 Compel Reclamation Under Clear Air Act)",
      "46:0688" : "46:0688 (46:688 Jones Act)",
      "46:0741" : "46:0741 (46:741 Shipping)",
      "46:0761" : "46:0761 (46:761 Shipping: Damages for Death on High Seas)",
      "46:1101" : "46:1101 (46:1101 Violation of Maritime Regulations)",
      "46:1156" : "46:1156 (46:1156 Administrative Procedure Act)",
      "46:1701" : "46:1701 (46:1701 Ocean Shipping Reform Act of 1998)",
      "46:31301" : "46:31301 (46:31301 Promissory Note and Enforcement of Ship Mortgage)",
      "47:227" : "47:227 (47:227 FCC-Unsolicited Telephone Sales)",
      "47:252" : "47:252 (47:252(e)(6) Interconnection Agreement)",
      "47:605" : "47:605 (47:605 Unlawful interception of signals and programming services)",
      "48:0883" : "48:0883 (48:883 Violation of US Coastal Law)",
      "48:1985" : "48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)",
      "49:0081" : "49:0081 (49:81 Damaged Goods While Being Transported)",
      "49:0507" : "49:0507 (49:0507 Motor Carrier Safety Regulations)",
      "49:0781" : "49:0781 (49:781 Forfeiture)",
      "49:10101" : "49:10101 (49:10101 Rail Transportation Policy)",
      "49:11503" : "49:11503 (49:11503 Railroad Revitalization Regulatory Reform)",
      "49:11702" : "49:11702 (49:11702(a)(4) Violations of Interstate Commerce A)",
      "49:13101" : "49:13101 (49:13101 Carrier Transportation Policy)",
      "49:13702" : "49:13702 (49:13702 Tariff Requirements)",
      "49:14501" : "49:14501 (49:14501 Federal authority over interstate transportation)",
      "49:14706" : "49:14706 (49:14706 Failure to deliver shipment of goods in good condition)",
      "49:1471" : "49:1471 (49:1471 Federal Aviation Act)",
      "49:1903" : "49:1903 (49:1903 Petition to enforce administrative summon)",
      "49:20101" : "49:20101 (49:20101 Railroad Safety)",
      "49:32701" : "49:32701 (49:32701 Federal Odometer Act )",
      "49:40101" : "49:40101 (49:40101 Airline Deregulation Act of 1978)",
      "8:287" : "8:287 (8:287 Petition to Enforce INS Subpoena)",
      "misc" : "misc (Civil Miscellaneous Case)"
   },
   "msndce" : {
      "0" : "0 (No cause code entered)",
      "02:0431" : "02:0431 (02:431 Federal Election Commission: Failure to Enforce Compliance)",
      "02:0437" : "02:0437 (02:437 Federal Election Commission)",
      "02:138" : "02:138 (02:138 Library of Congress Access)",
      "05:0075" : "05:0075 (05:75(2) Contract - Reduction in Grade (NO LONGER USED))",
      "05:0551" : "05:0551 (05:551 Administrative Procedures Act)",
      "05:0552fi" : "05:0552fi (05:552fi Freedom of Information Act)",
      "05:0552pa" : "05:0552pa (05:552pa Right to Privacy Act)",
      "05:0554" : "05:0554 (05:0554 Adjudications Required by Statutes)",
      "05:0701" : "05:0701 (05:0701 Judicial Review of Agency Decision)",
      "05:0702" : "05:0702 (05:702 Administrative Procedure Act - Right of Review)",
      "05:0704" : "05:0704 (05:704 Labor Litigation)",
      "05:7703" : "05:7703 (05:7703 Discrimination - Review of Agency Act)",
      "05:8470" : "05:8470 (05:8470 Enforcement of Judgment against Retirement Benefits)",
      "07:0006" : "07:0006 (7:6(b) Federal Commodity Exchange Regulation)",
      "07:0025" : "07:0025 (7:25 Fraud - Commodities Leverage Contracts)",
      "07:0181" : "07:0181 (07:181 Packers & Stockyards Act)",
      "07:0499" : "07:0499 (07:499 Agricultural Commodities Act)",
      "07:0499Ec4" : "07:0499Ec4 (Perishable Agricultural Commodities Act (PACA))",
      "07:0601" : "07:0601 (07:601 USDA Condemnation)",
      "07:2321" : "07:2321 (07:2321 Plant Variety Protection Act)",
      "08:1105" : "08:1105 (8:1105(a) Immigration: Judicial Review for Battered Spouses; Deportation (INS))",
      "08:1182" : "08:1182 (8:1182 Inadmissible Aliens: Defend. Denial of Pla. Appl. for Alien Employment Cer)",
      "08:1252" : "08:1252 (08:1252 Judicial Review of Orders of Removal)",
      "08:1260" : "08:1260 (08:1260 Aliens: Removal of Aliens Falling into Distress)",
      "08:1324" : "08:1324 (08:1324 Immigration: Complaint for Forfeiture)",
      "08:1329" : "08:1329 (08:1329 Immigration: Writ of Mandamus to Adjudicate Visa Petition)",
      "08:1357" : "08:1357 (Immmigration and Nationality Act- Administrative Search Warrant)",
      "08:1446" : "08:1446 (8:1446 Immigration: Petition for Naturalization Hearing)",
      "08:1451(j)" : "08:1451(j) (8:1451(j) Motion to Correct Order & Judg. of Naturalization)",
      "09:0001" : "09:0001 (09:1 U.S. Arbitration Act)",
      "09:0009" : "09:0009 (9:9 Motion to Confirm Arbitration Award)",
      "09:0010" : "09:0010 (9:10 Petition to Vacate Arbitration Award)",
      "10:1408" : "10:1408 (10:1408 Armed Forces: Claim for Military Retirement)",
      "10:1552" : "10:1552 (10:1552 Armed Forces: Action to Correct Records)",
      "10:1553" : "10:1553 (10:1553 Armed Forces: Review of Discharge or Dismissal)",
      "10:2305" : "10:2305 (10:2305 Armed Forces: Review of Federal Contract)",
      "11:0101" : "11:0101 (11:101 Bankruptcy (Definitions))",
      "12:0635" : "12:0635 (12:635i-3 Export-Import Bank: Breach of Insurance Contract)",
      "12:1441" : "12:1441 (FHLB: Financial Inst Reform Receiving Enforcement Act 1989)",
      "12:1461" : "12:1461 (12:1461 Savings Associations: Homeowners Loan Act (Short Title))",
      "12:1464" : "12:1464 (12:1464 Savings Associations: Federal Savings and Loan)",
      "12:1703" : "12:1703 (12:1703 National Housing: Insurance of Financial Institutions)",
      "12:1819" : "12:1819 (12:1819 FDIC: Corporate Powers)",
      "12:1821" : "12:1821 (12:1821 FDIC: Insurance Funds)",
      "12:191" : "12:191 (12:191 National Banks: Appointment of Receiver)",
      "12:192" : "12:192 (12:192 National Banks: Liquidation of National Bank)",
      "12:1971" : "12:1971 (12:1971 Relief under Bank Holding Company Act (Definitions))",
      "12:1972" : "12:1972 (12:1972 Typing Arrangement Act)",
      "12:3410" : "12:3410 (12:3410 Right to Financial Privacy: Customer Challenges)",
      "15:0001" : "15:0001 (15:1 Antitrust Litigation (Monopolizing Trade))",
      "15:0002at" : "15:0002at (15:2at Antitrust Litigation)",
      "15:0002fl" : "15:0002fl (15:2fl Antitrust Litigation)",
      "15:0005" : "15:0005 (15:5 Bringing in Additional Parties)",
      "15:0015" : "15:0015 (15:15 Antitrust Litigation)",
      "15:0025" : "15:0025 (15:25 Clayton Act)",
      "15:0044" : "15:0044 (15:44 Trademark Infringement (No Longer Used))",
      "15:0045" : "15:0045 (15:0045 Federal Trade Commission Act)",
      "15:0045cp" : "15:0045cp (15:45cp Violation of Children Online Privacy Protection Act)",
      "15:0052" : "15:0052 (15:0052 Federal Trade Commission Act)",
      "15:0053" : "15:0053 (15:0053 Federal Trade Commission Act)",
      "15:0053(b)" : "15:0053(b) (Prelim & Perm Inj Relief & other Equitable Relief)",
      "15:0077" : "15:0077 (15:77 Securities Fraud)",
      "15:0078" : "15:0078 (15:78m(a) Securities Exchange Act)",
      "15:0631" : "15:0631 (15:631 Small Business Act)",
      "15:0717" : "15:0717 (15:717 Natural Gas Act)",
      "15:1051" : "15:1051 (15:1051 Trademark Infringement)",
      "15:1114" : "15:1114 (15:1114 Trademark Infringement (Lanham Act))",
      "15:1121" : "15:1121 (15:1121 Trademark Infringement (jurisdiction))",
      "15:1125" : "15:1125 (15:1125la Trademark Infringement (Lanham Act))",
      "15:1125(d)" : "15:1125(d) (15:1125(d)ac)",
      "15:1126" : "15:1126 (15:1126 Trademarks - International conventions)",
      "15:1127" : "15:1127 (15:1127 Trademark Infringement)",
      "15:1601" : "15:1601 (15:1601 Truth in Lending)",
      "15:1640" : "15:1640 (15:1640 Truth in Lending)",
      "15:1681" : "15:1681 (15:1681 Fair Credit Reporting Act)",
      "15:1692" : "15:1692 (15:1692 Fair Debt Collection Act)",
      "15:1938" : "15:1938 (15:1938 Fair Labor Standards Act (No Longer Used))",
      "15:1981" : "15:1981 (15:1981 Fraud-Motor Vehicle (Odometer) (REPEALED)(No Longer Used))",
      "15:1988" : "15:1988 (15:1988 Fraud-Motor Vehicle (Odometer) (REPEALED) (NO LONGER USED))",
      "15:1989" : "15:1989 (15:1989 Fraud-Motor Vehicle (Odometer) (REPEALED) (NO LONGER USED))",
      "15:2301" : "15:2301 (15:2301 Magnuson-Moss Warranty Act)",
      "15:2801" : "15:2801 (15:2801 Petroleum Marketing Practices Act)",
      "15:53(b)" : "15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equitable Relief)",
      "15:78j(b)" : "15:78j(b) (15:78j(b)ss Stockholder Suit)",
      "16:0668" : "16:0668 (16:668 Bald and Golden Eagle Protection Act)",
      "16:0703" : "16:0703 (16:703 Migratory Bird Act)",
      "16:1538" : "16:1538 (16:1538 Endangered Species Act)",
      "16:3371" : "16:3371 (16:3371 Wildlife Under the Lacey Act (Definitions))",
      "16:3372" : "16:3372 (16:3372 Lacey Act: Prohibited Acts)",
      "16:3373" : "16:3373 (16:3373 Lacey Act: Penalties and Sanctions - Appeal of Decision - DOI)",
      "16:3374" : "16:3374 (16:3374 Lacey Act: Complaint for Forfeiture)",
      "17:0101" : "17:0101 (17:101 Copyright Infringement (definitions))",
      "17:0501" : "17:0501 (17:501 Copyright Infringement)",
      "17:0504" : "17:0504 (17:504 Remedies for Copyright Infringement)",
      "17:1201" : "17:1201 (17:1201 Digital Millennium Copyright Act)",
      "17:512" : "17:512 (17:512 Copyright Infringement of Digital Communications)",
      "18:1836a" : "18:1836a (18:1836(a) Injunction against Misappropriation of Trade Secrets)",
      "18:1836b" : "18:1836b (18:1836(b) Civil Action to Protect Trade Secrets)",
      "18:1961" : "18:1961 (18:1961 Racketeering (RICO) Act (No Longer Used))",
      "18:1962" : "18:1962 (18:1962 Racketeering (RICO) Act (No Longer Used))",
      "18:1964" : "18:1964 (18:1964 Civil Remedies: Racketeering (RICO) Act)",
      "18:2511" : "18:2511 (18:2511 Wiretapping - Injunctive Relief or Civil Fine)",
      "18:3114" : "18:3114 (18:3114 Motion for Return of Seized Property)",
      "18:4208" : "18:4208 (18:4208 Agency Action Review (REPEALED) (No Longer in Use))",
      "19:1305" : "19:1305 (19:1305 Custom Duties: Forfeiture-Immoral Articles)",
      "20:1080" : "20:1080 (20:1080 Default of Student Loan: Recovery)",
      "20:1400" : "20:1400 (20:1400 IDEA: Individuals With Disabilities Education Act (short title))",
      "20:1401" : "20:1401 (20:1401 IDEA: Education of Individuals with Disabilities (definitions))",
      "21:0841" : "21:0841 (21:841 Forfeiture Property - Drugs)",
      "21:0881" : "21:0881 (21:881 Forfeiture Property - Drugs)",
      "21:0881a" : "21:0881a (21:881 Forfeiture Property - Aircraft)",
      "21:0881re" : "21:0881re (21:881re Forfeiture Property - Real Estate)",
      "23:0134" : "23:0134 (23:134 Metropolitan Transportation Planning)",
      "25:1901" : "25:1901 (25:1901 Indian Child Welfare Act)",
      "26:6212" : "26:6212 (26:6212 IRS: Notice of Deficiency (Injunctive Relief from IRS Lien))",
      "26:6213" : "26:6213 (26:6213 IRS: Injunctive Relief from IRS Lien in Tax Court)",
      "26:6502" : "26:6502 (26:6502 IRS: Collection after Assessment (Enforcement of tax liens))",
      "26:6532" : "26:6532 (26:6532 IRS: Periods of Limitation on Suits)",
      "26:6702" : "26:6702 (26:6702 IRS: Penalty for Frivolous Tax Submission)",
      "26:6703" : "26:6703 (26:6703 IRS: Refund of Tax Penalty)",
      "26:7401" : "26:7401 (26:7401 IRS: Tax Liability - Authorization to collect via civil action)",
      "26:7402" : "26:7402 (IRS: Jurisdiction of District Courts)",
      "26:7402(b)" : "26:7402(b) (26:7402(b) IRS: Petition to Enforce IRS Summons)",
      "26:7403" : "26:7403 (26:7403 Action to Enforce Federal Tax Lien)",
      "26:7422rt" : "26:7422rt (26:7422 IRS: Refund Taxes)",
      "26:7422rx" : "26:7422rx (26:7422 IRS: Refund Excise Tax)",
      "26:7426" : "26:7426 (26:7426 IRS: Wrongful Levy for Taxes)",
      "26:7429" : "26:7429 (26:7429 IRS: Tax Jeopardy Assessment)",
      "26:7609" : "26:7609 (26:7609 IRS: Petition to Quash IRS Summons)",
      "27:0185" : "27:0185 (27:185 Enforcement of Arbitration Award)",
      "28:0157c" : "28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)",
      "28:0157d" : "28:0157d (28:0157d Motion for Withdrawal of Reference)",
      "28:0158" : "28:0158 (28:0158 Notice of Appeal re Bankruptcy Matter (District or BAP))",
      "28:0185" : "28:0185 (28:185 Suit to Compel Arbitration (REPEALED) (No Longer in Use))",
      "28:0451" : "28:0451 (28:451 Employment Discrimination (REPEALED) (No Longer in Use))",
      "28:0754" : "28:0754 (28:754 Receiver of Property in Different Districts)",
      "28:0794" : "28:0794 (28:794 Rehabilitation Act (REPEALED) (No Longer in Use))",
      "28:1001" : "28:1001 (28:1001 E.R.I.S.A. (REPEALED) (No Longer in Use))",
      "28:1132" : "28:1132 (28:1132 E.R.I.S.A. (REPEALED) (No Longer in Use))",
      "28:1330" : "28:1330 (28:1330 Breach of Contract)",
      "28:1331" : "28:1331 (28:1331 Fed. Question)",
      "28:1331al" : "28:1331al (28:1331 Fed. Question: Airline Crash)",
      "28:1331at" : "28:1331at (28:1331 Fed. Question: Anti-trust)",
      "28:1331au" : "28:1331au (28:1331 Fed. Question: Auto Negligence)",
      "28:1331b" : "28:1331b (28:1331 Federal Question: Bivens Act)",
      "28:1331bc" : "28:1331bc (28:1331bc Fed. Question: Breach of Contract)",
      "28:1331ca" : "28:1331ca (28:1331ca Fed Question: Fed Communications Act of 1934)",
      "28:1331cm" : "28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)",
      "28:1331cv" : "28:1331cv (28:1331 Fed. Question: Other Civil Rights)",
      "28:1331ed" : "28:1331ed (28:1331 Fed. Question: Employment Discrimination)",
      "28:1331ej" : "28:1331ej (28:1331 Federal Question: Enforcement of Judgment)",
      "28:1331es" : "28:1331es (28:1331 Fed. Question: Enforcement of Administrative Subpoena)",
      "28:1331fl" : "28:1331fl (28:1331 Fed. Question: Fair Labor Standards)",
      "28:1331in" : "28:1331in (28:1331 Fed. Question: Insurance Contract)",
      "28:1331mm" : "28:1331mm (28:1331 Fed. Question: Medical Malpractice)",
      "28:1331ng" : "28:1331ng (28:1331 Fed. Question: Natural Gas Act)",
      "28:1331pi" : "28:1331pi (28:1331 Fed. Question: Personal Injury)",
      "28:1331rd" : "28:1331rd (28:1331 Fed. Question: Review Agency Decision)",
      "28:1331rp" : "28:1331rp (28:1331(a) Fed. Question: Real Property)",
      "28:1331rr" : "28:1331rr (28:1331 Fed. Question: Railway Labor Act)",
      "28:1331sv" : "28:1331sv (28:1331 Fed. Question: Securities Violation)",
      "28:1331tr" : "28:1331tr (28:1331 Fed. Question: Trademark)",
      "28:1331tt" : "28:1331tt (28:1331 Fed. Question: Tort Action)",
      "28:1331v" : "28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendments)",
      "28:1331wl" : "28:1331wl (28:1331 Fed. Question: EPA Waste Lien)",
      "28:1331wt" : "28:1331wt (28:1331 Fed. Question: Water Rights)",
      "28:1332ac" : "28:1332ac (28:1332 Diversity-Account Receivable)",
      "28:1332al" : "28:1332al (28:1332 Diversity-Airline Crash)",
      "28:1332as" : "28:1332as (28:1332 Diversity-Asbestos Litigation)",
      "28:1332au" : "28:1332au (28:1332 Diversity-Auto Negligence)",
      "28:1332bc" : "28:1332bc (28:1332 Diversity-Breach of Contract)",
      "28:1332co" : "28:1332co (28:1332 Diversity-Conversion)",
      "28:1332ct" : "28:1332ct (28:1332 Diversity-(Citizenship))",
      "28:1332de" : "28:1332de (28:1332 Diversity: Forcible Detainer)",
      "28:1332df" : "28:1332df (28:1332 Diversity-Contract Default)",
      "28:1332ds" : "28:1332ds (28:1332 Diversity-Contract Dispute)",
      "28:1332ed" : "28:1332ed (28:1332 Diversity-Employment Discrimination)",
      "28:1332fd" : "28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)",
      "28:1332fr" : "28:1332fr (28:1332 Diversity-Fraud)",
      "28:1332ia" : "28:1332ia (28:1332 Diversity-Interpleader Action)",
      "28:1332ij" : "28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)",
      "28:1332in" : "28:1332in (28:1332 Diversity-Insurance Contract)",
      "28:1332jd" : "28:1332jd (28:1332 Diversity-Declaratory Judgment)",
      "28:1332lb" : "28:1332lb (28:1332 Diversity-Libel,Assault,Slander)",
      "28:1332lm" : "28:1332lm (28:1332 Diversity - Legal Malpractice)",
      "28:1332ma" : "28:1332ma (28:1332 Diversity-Miller Act)",
      "28:1332mm" : "28:1332mm (28:1332 Diversity-Medical Malpractice)",
      "28:1332mv" : "28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)",
      "28:1332ni" : "28:1332ni (28:1332 Diversity-Negotiable Instrument)",
      "28:1332nm" : "28:1332nm (28:1332 Diversity-Non-Motor Vehicle)",
      "28:1332nr" : "28:1332nr (28:1332 Diversity-Notice of Removal)",
      "28:1332oc" : "28:1332oc (28:1332 Diversity-Other Contract)",
      "28:1332pd" : "28:1332pd (28:1332 Diversity-Property Damage)",
      "28:1332pi" : "28:1332pi (28:1332 Diversity-Personal Injury)",
      "28:1332pl" : "28:1332pl (28:1332 Diversity-Product Liability)",
      "28:1332pr" : "28:1332pr (28:1332 Diversity-Petition for Removal)",
      "28:1332qt" : "28:1332qt (28:1332 Diversity-Petition to Quiet Title)",
      "28:1332ri" : "28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)",
      "28:1332sa" : "28:1332sa (28:1332 - Diversity: Securities & Exchange Commiss)",
      "28:1332sf" : "28:1332sf (28:1332 - Diversity: Securities Fraud)",
      "28:1332ss" : "28:1332ss (28:1332 Diversity - Stockholders Suits)",
      "28:1332tl" : "28:1332tl (28:1332 Diversity-Torts to Land)",
      "28:1332tm" : "28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))",
      "28:1332tn" : "28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)",
      "28:1332wd" : "28:1332wd (28:1332 Diversity-Wrongful Death)",
      "28:1333" : "28:1333 (28:1333 Admiralty)",
      "28:1334" : "28:1334 (28:1334 Bankruptcy Appeal)",
      "28:1334c" : "28:1334c (28:1334(c) R&R re motions for abstention)",
      "28:1335" : "28:1335 (28:1335 Interpleader Action)",
      "28:1337sc" : "28:1337sc (28:1337 Sherman-Clayton Act)",
      "28:1338cp" : "28:1338cp (28:1338 Copyright Infringement)",
      "28:1338pt" : "28:1338pt (28:1338 Patent Infringement)",
      "28:1338tr" : "28:1338tr (28:1338 Trademark Infringement)",
      "28:1340tp" : "28:1340tp (28:1340 Jurisdiction of Internal Revenue Matters; Customs Duties)",
      "28:1341" : "28:1341 (28:1341 Taxes by States)",
      "28:1343" : "28:1343 (28:1343 Violation of Civil Rights)",
      "28:1345" : "28:1345 (28:1345 U.S. Plaintiff)",
      "28:1345co" : "28:1345co (28:1345 Replevin & Conversion)",
      "28:1345db" : "28:1345db (28:1345 Debt to US - FHA/HUD Title I)",
      "28:1345df" : "28:1345df (28:1345 Default of Promissory Note)",
      "28:1345er" : "28:1345er (28:1345 Recovery of Erroneous Refund)",
      "28:1345fc" : "28:1345fc (28:1345 Foreclosure)",
      "28:1345ff" : "28:1345ff (28:1345 Complaint for Forfeiture)",
      "28:1345hl" : "28:1345hl (28:1345 VA Home Loan Guaranty Debt)",
      "28:1345mc" : "28:1345mc (28:1345 Medical Care Recovery)",
      "28:1345mi" : "28:1345mi (28:1345 Mining Claim Ejectment)",
      "28:1345pd" : "28:1345pd (28:1345 Property Damage)",
      "28:1345pe" : "28:1345pe (28:1345 Property Ejectment)",
      "28:1345rc" : "28:1345rc (28:1345 Recovery of Debt to US)",
      "28:1345st" : "28:1345st (28:1345 Default of Student Loan)",
      "28:1345tp" : "28:1345tp (28:1345 Trespass on Public Land)",
      "28:1345va" : "28:1345va (28:1345 Recovery of VA Overpayment)",
      "28:1346bc" : "28:1346bc (28:1346 Breach of Contract)",
      "28:1346rc" : "28:1346rc (28:1346 Recovery of IRS Tax)",
      "28:1346t" : "28:1346t (28:1346 Tort Claim)",
      "28:1346wd" : "28:1346wd (28:1346 Wrongful Death)",
      "28:1349" : "28:1349 (28:1349 Corporation organized under Federal Law as party)",
      "28:1352" : "28:1352 (28:1352 Miller Act)",
      "28:1355" : "28:1355 (28:1355 Petition for Return of Property)",
      "28:1358" : "28:1358 (28:1358 Land Condemnation)",
      "28:1361" : "28:1361 (28:1361 Petition for Writ of Mandamus)",
      "28:1362ic" : "28:1362ic (28:1362 Indian Tribal Controversy)",
      "28:1362iw" : "28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)",
      "28:1364" : "28:1364 (28:1364 Auto Negligence)",
      "28:1391" : "28:1391 (28:1391 Personal Injury Venue)",
      "28:1402" : "28:1402 (28:1402 U.S. as a Defendant (formerly Medical Malpractice))",
      "28:1407" : "28:1407 (28:1407 MDL Airline Crash)",
      "28:1441ac" : "28:1441ac (28:1441ac Removal- Account Receivable)",
      "28:1441al" : "28:1441al (28:1441 Removal- Airline Crash)",
      "28:1441as" : "28:1441as (28:1441 Removal - Asbestos Litigation)",
      "28:1441au" : "28:1441au (28:1441 Removal - Auto Negligence)",
      "28:1441bc" : "28:1441bc (28:1441 Removal - Breach of Contract)",
      "28:1441cv" : "28:1441cv (28:1441 Removal - Civil Rights Act)",
      "28:1441df" : "28:1441df (28:1441 Removal - Contract Default)",
      "28:1441dj" : "28:1441dj (28:1441dj Declaratory Judgemen)",
      "28:1441ds" : "28:1441ds (28:1441 Removal - Contract Dispute)",
      "28:1441ed" : "28:1441ed (28:1441 Removal - Employment Discrimination)",
      "28:1441fc" : "28:1441fc (28:1441 Removal - Fair Credit Reporting Act)",
      "28:1441fr" : "28:1441fr (28:1441 Removal- Fraud)",
      "28:1441ij" : "28:1441ij (28:1441 Petition for Removal- Injunctive/Declarato)",
      "28:1441in" : "28:1441in (28:1441 Petition for Removal- Insurance Contract)",
      "28:1441int" : "28:1441int (28:1441 Petition for Removal- Action for Interplea)",
      "28:1441lb" : "28:1441lb (28:1441 Petition for Removal Libel,Assault,Slander)",
      "28:1441lm" : "28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relatio)",
      "28:1441mm" : "28:1441mm (28:1441 Petition for Removal- Medical Malpractice)",
      "28:1441ni" : "28:1441ni (28:1441 Petition for Removal- Negotiable Instrumen)",
      "28:1441nm" : "28:1441nm (28:1441 Petition for Removal- Non-Motor Vehicle)",
      "28:1441nr" : "28:1441nr (28:1441 Notice of Removal)",
      "28:1441oc" : "28:1441oc (28:1441 Petition For Removal--Other Contract)",
      "28:1441pd" : "28:1441pd (28:1441 Petition for Removal- Property Damage)",
      "28:1441pi" : "28:1441pi (28:1441 Petition for Removal- Personal Injury)",
      "28:1441pl" : "28:1441pl (28:1441 Petition for Removal- Product Liability)",
      "28:1441pr" : "28:1441pr (28:1441 Petition for Removal)",
      "28:1441qt" : "28:1441qt (28:1441 Petition for Removal- Petition to Quiet Title)",
      "28:1441ri" : "28:1441ri (28:1441 Removal- Racketeering (RICO))",
      "28:1441sa" : "28:1441sa (28:1441 - Removal: SEC Act)",
      "28:1441sf" : "28:1441sf (28:1441 - Removal: Securities Fraud)",
      "28:1441tl" : "28:1441tl (28:1441 Removal- Torts to Land)",
      "28:1441tm" : "28:1441tm (28:1441 Removal- Tort/Motor Vehicle (P.I))",
      "28:1441tn" : "28:1441tn (28:1441 Removal- Tort/Non-Motor Vehicle)",
      "28:1441wd" : "28:1441wd (28:1441 Removal- Wrongful Death)",
      "28:1442aaf" : "28:1442aaf (28:1442 Petition for Removal -Against Members of Armed Forces)",
      "28:1442bc" : "28:1442bc (28:1442 Petition for Removal- Breach of Contract)",
      "28:1442nr" : "28:1442nr (28:1442 Notice of Removal -Suit Against Federal Officer)",
      "28:1443" : "28:1443 (28:1443(1) Removal from State Court - Civil Rights:Rent, Lease & Ejectment)",
      "28:1444" : "28:1444 (28:1444 Notice of Removal- Foreclosure)",
      "28:1446in" : "28:1446in (28:1446 Breach of Contract- Insurance)",
      "28:1446nr" : "28:1446nr (28:1446 Notice of Removal)",
      "28:1446pd" : "28:1446pd (28:1446 Notice of Removal- Property Damage (P.I.))",
      "28:1446pi" : "28:1446pi (28:1446 Notice of Removal- Personal Injury)",
      "28:1446pl" : "28:1446pl (28:1446pl Notice of Removal - Product Liability)",
      "28:1446pr" : "28:1446pr (28:1446 Petition for Removal)",
      "28:1452" : "28:1452 (28:1452 Removal of Claims Related to Bankruptcy Cases)",
      "28:157b" : "28:157b (28:157b Bankruptcy Claim to be tried in U.S. District Court)",
      "28:1651" : "28:1651 (28:1651 Petition for Writ of Coram Nobis (REPEALED) (No Longer in Use))",
      "28:1651cn" : "28:1651cn (28:1651 Petition for Writ of Error Coram Nobis)",
      "28:1651hc" : "28:1651hc (28:1651 Petition for Writ of Habeas Corpus)",
      "28:1651mn" : "28:1651mn (28:1651 Petition for Writ of Mandamus)",
      "28:1782" : "28:1782 (28:1782 Assistance to Foreign Tribunals (incl letter rogatory))",
      "28:2201" : "28:2201 (28:2201 Creation of a Remedy -Declaration of Rights (formerly Constitutionality of State Statute(s)))",
      "28:2201dj" : "28:2201dj (28:2201 Declaratory Judgment)",
      "28:2201ij" : "28:2201ij (28:2201 Injunction)",
      "28:2201in" : "28:2201in (28:2201 Declaratory Judgment (Insurance))",
      "28:2241" : "28:2241 (28:2241fd Petition for Writ of Habeas Corpus (federal))",
      "28:2254" : "28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))",
      "28:2254se" : "28:2254se (28:2254 Petition for Writ of Habeas Corpus - Stay of Execution)",
      "28:2255" : "28:2255 (28:2255 Motion to Vacate / Correct Illegal Sentence)",
      "28:2271" : "28:2271 (28:2271 Federal Tort Claims Act (REPEALED) (No Longer in Use))",
      "28:2345" : "28:2345 (28:2345 Medicare Recovery (REPEALED) (No Longer in Use))",
      "28:2409" : "28:2409 (28:2409(a) Quiet Title Action)",
      "28:2410" : "28:2410 (28:2410 - Actions affecting property on which United States has lien)",
      "28:2671" : "28:2671 (28:2671 Federal Tort Claims Act)",
      "28:2674" : "28:2674 (28:2674 Federal Tort Claims Act - Liability of US)",
      "28:3001" : "28:3001 (28:3001 Federal Debt Collection Act)",
      "29:0151" : "29:0151 (29:151 Labor: National Labor Relations Act (NLRA))",
      "29:0159" : "29:0159 (29:0159 Violation of Collective Bargaining Agreement)",
      "29:0160" : "29:0160 (29:160 Labor: NLRA - Prevention of Unfair Labor Practices)",
      "29:0185ep" : "29:0185ep (29:185 Suits by and Against Labor Organizations (formerly Employee Pension Plan))",
      "29:0185lm" : "29:0185lm (29:185 Suits by and Against Labor Organizations (formerly Labor/Mgt. Relations (Contracts)))",
      "29:0201do" : "29:0201do (29:201 Denial of Overtime Compensation)",
      "29:0201fl" : "29:0201fl (29:201 Fair Labor Standards Act)",
      "29:0203" : "29:0203 (29:203 Definitions (formerly Equal Pay Act))",
      "29:0206" : "29:0206 (29:206 FLSA: Minimum Wage (formerly Collect Unpaid Wages))",
      "29:0401" : "29:0401 (29:0401 Labor Management Disclosure Act)",
      "29:0621" : "29:0621 (29:621 Job Discrimination (Age))",
      "29:0623" : "29:0623 (29:623 Job Discrimination (Prohibition of Age Discrimination))",
      "29:0626" : "29:0626 (29:626 Job Discrimination (Investigation and Enforcement))",
      "29:0633" : "29:0633 (29:633 Job Discrimination (Age- Federal-State Relationship))",
      "29:0651" : "29:0651 (29:651 Occupational Safety/Health)",
      "29:0754" : "29:0754 (29:754 Discrimination (No Longer Used))",
      "29:0791" : "29:0791 (29:791 Job Discrimination (Rehabilitation Act))",
      "29:0794" : "29:0794 (29:0794 Job Discrimination (Handicap))",
      "29:1001" : "29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)",
      "29:1002" : "29:1002 (29:1002 E.R.I.S.A.: Employee Retirement (Definitions))",
      "29:1104" : "29:1104 (29:1104 Recovery of Benefits to Employee)",
      "29:1109" : "29:1109 (29:1109 Breach of Fiduciary Duties)",
      "29:1131" : "29:1131 (29:1131 ERISA - Collection of Delinquent Trust Fun (No Longer Used - refers to CR))",
      "29:1132" : "29:1132 (29:1132 E.R.I.S.A.-Civil Enforcement of Employee Benefits)",
      "29:1145" : "29:1145 (29:1145 E.R.I.S.A.)",
      "29:1149" : "29:1149 (29:1149 Recover Pension & Profit Sharing)",
      "29:1337" : "29:1337 (29:1337 E.R.I.S.A.)",
      "29:1362" : "29:1362 (29:1362 ERISA)",
      "29:1381" : "29:1381 (29:1381 E.R.I.S.A.)",
      "29:1401" : "29:1401 (29:1401(b)(2) Appeal of Arbitration Award)",
      "29:1451" : "29:1451 (29:1451 E.R.I.S.A.)",
      "29:1801" : "29:1801 (29:1801 Farmworker Rights)",
      "29:207(a)" : "29:207(a) (29:207(a) Action for Overtime Wage Violation)",
      "29:790" : "29:790 (29:790 Rehabilitation of Labor)",
      "30:0181" : "30:0181 (30:181 Environment: Review of Agency Action)",
      "30:0801" : "30:0801 (30:0801 Penalities/Federal Mine Safety Health Act)",
      "30:1201" : "30:1201 (30:1201 Environment: Review of Agency Action)",
      "30:1202" : "30:1202 (30:1202 Mining Reclamation Act)",
      "30:1276" : "30:1276 (30:1276 Interior: Review of Agency Action)",
      "31:3545" : "31:3545 (31:3545 Action to Recovery Money)",
      "31:3729" : "31:3729 (31:3729 False Claims Act)",
      "31:3730" : "31:3730 (31:3730 Qui Tam False Claims Act)",
      "31:3731" : "31:3731 (31:3731 Fraud)",
      "33:1319cw" : "33:1319cw (33:1319 Clean Water Act)",
      "33:1319pv" : "33:1319pv (33:1319 Pollutants & Permit Violations)",
      "33:1365" : "33:1365 (33:1365 Environmental Matters)",
      "35:0145" : "35:0145 (35:145 Patent Infringement)",
      "35:0183" : "35:0183 (35:183 Patent Infringement)",
      "35:0271" : "35:0271 (35:271 Patent Infringement)",
      "38:1681" : "38:1681 (38:1681 Recovery of VA Overpayment)",
      "38:1780" : "38:1780 (38:1780 Recovery of VA Overpayment)",
      "38:2011" : "38:2011 (38:2011 - Veteran's Readjustment Assistance Act of)",
      "38:2021" : "38:2021 (Right to re-employment of inducted persons)",
      "38:3116" : "38:3116 (38:3116 VA Overpayment)",
      "38:775" : "38:775 (Recovery of Servicemen's Group Life Insurance)",
      "39:3005" : "39:3005 (39:3005 Detention of Mail for Temporary Periods)",
      "39:409" : "39:409 (39:409 Postal Service)",
      "40:0258" : "40:0258 (40:258(a) Public Buildings & Property: Land Condem)",
      "40:0270" : "40:0270 (40:270 Miller Act)",
      "41:0251" : "41:0251 (41:251 Public Contracts-Review of Agency Action (REPEALED - No Longer in Use))",
      "41:1463" : "41:1463 (41:1463 Public Contracts: Unlawful Employment Prac (No Longer Used - Not Valid))",
      "42:0205" : "42:0205 (42:205 Denial Social Security Benefits)",
      "42:0206" : "42:0206 (42:206 Social Security Benefits)",
      "42:0402" : "42:0402 (42:402 Social Security Benefits)",
      "42:0405id" : "42:0405id (42:405 Review of HHS Decision (SSID))",
      "42:0405wc" : "42:0405wc (42:405 Review of HHS Decision (DIWC))",
      "42:0405ww" : "42:0405ww (42:405 Review of HHS Decision (DIWW))",
      "42:0416" : "42:0416 (42:416 Denial of Social Security Benefits)",
      "42:0427" : "42:0427 (42:427 Social Security Benefits)",
      "42:1383" : "42:1383 (42:1383 Review of HHS Decision)",
      "42:1395" : "42:1395 (42:1395 HHS: Adverse Reimbursement Review)",
      "42:1396" : "42:1396 (42:1396 - Tort Negligence (No Longer Used))",
      "42:1471" : "42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclo)",
      "42:1981cv" : "42:1981cv (42:1981 Civil Rights)",
      "42:1981hs" : "42:1981hs (42:1981 Housing Discrimination)",
      "42:1981jb" : "42:1981jb (42:1981 Job Discrimination (Race))",
      "42:1981sx" : "42:1981sx (42:1981 Sex Discrimination)",
      "42:1983cv" : "42:1983cv (42:1983 Civil Rights Act)",
      "42:1983ed" : "42:1983ed (42:1983 Civil Rights (Employment Discrimination))",
      "42:1983pr" : "42:1983pr (42:1983pr Prisoner Civil Rights)",
      "42:1986" : "42:1986 (42:1986 Neglect of Duty)",
      "42:2000ag" : "42:2000ag (42:2000 Job Discrimination (Age))",
      "42:2000e" : "42:2000e (42:2000e Job Discrimination (Employment))",
      "42:2000pb" : "42:2000pb (42:2000 Job Discrimination (Public Accomodations))",
      "42:2000ra" : "42:2000ra (42:2000 Job Discrimination (Race))",
      "42:2000sx" : "42:2000sx (42:2000 Job Discrimination (Sex))",
      "42:2003" : "42:2003 (42:2003 Job Discrimination)",
      "42:2005" : "42:2005 (42:2005 Review of Agency Action-HHS)",
      "42:2615" : "42:2615 (42:2616 Medical Recovery Act)",
      "42:2651" : "42:2651 (42:2651 Medical Care Recovery)",
      "42:3601" : "42:3601 (42:405 Fair Housing Act)",
      "42:4001" : "42:4001 (42:4001 National Insurance Flood Act)",
      "42:4053" : "42:4053 (42:4053 Breach of Insurance Contract)",
      "42:4072" : "42:4072 (42:4072 Payment of Flood Insurance Claim)",
      "42:4321" : "42:4321 (42:4321 Review of Agency Action-Environment)",
      "42:4332" : "42:4332 (42:4332 Environmental Policy - Coop of Agency Repo)",
      "42:6901en" : "42:6901en (42:6901 Environmental Cleanup Expenses)",
      "42:6901rs" : "42:6901rs (42:6901 Resource & Recovery Act)",
      "42:7413" : "42:7413 (42:7413(b) Clean Air Act)",
      "42:7604cl" : "42:7604cl (42:7604 Clear Air Act (Emission Standards))",
      "42:7604ir" : "42:7604ir (42:7604 Petition to Quash IRS Summons)",
      "42:9607" : "42:9607 (42:9607 Real Property Tort to Land)",
      "43:945" : "43:945 (43:945 Compensation for Land Condemnation)",
      "43:945a" : "43:945a (43:945a Complaint in Condemnation)",
      "43:946" : "43:946 (43:946 Complaint in Condemnation - Eminent Domain)",
      "45:0051" : "45:0051 (45:51 Railways: Fed. Employer's Liability Act)",
      "45:0151" : "45:0151 (45:151 Railway Labor Act)",
      "45:0184" : "45:0184 (45:184 Action to Set Aside Award of a System Board)",
      "46:0688" : "46:0688 (46:688 Jones Act)",
      "46:0741" : "46:0741 (46:741 Shipping (No Longer Used))",
      "46:0761" : "46:0761 (46:761 Shipping: Damages for Death on High Seas)",
      "46:1101" : "46:1101 (46:1101 Violation of Maritime Regulations)",
      "46:1156" : "46:1156 (46:1156 Administrative Procedure Act (No Longer Used))",
      "48:0883" : "48:0883 (48:883 Violation of US Coastal Law)",
      "49:0081" : "49:0081 (49:81 Damaged Goods While Being Transported (No Longer Used))",
      "49:0781" : "49:0781 (49:781 Forfeiture (No Longer Used))",
      "49:11702" : "49:11702 (49:11702(a)(4) Violations of Interstate Commerce A)",
      "99:9999" : "99:9999 (99:9999 Report cause code (DO NOT DELETE!))",
      "adsup" : "adsup (Administrative Subpoena)",
      "contempt" : "contempt (Contempt Proceedings)",
      "disbar" : "disbar (Disbarment Proceedings)",
      "fordepo" : "fordepo (Foreign Deposition)",
      "misc" : "misc (Civil Miscellaneous Case)",
      "motcomp" : "motcomp (Motion to Compel)",
      "motquash" : "motquash (Motion to Quash)",
      "motret" : "motret (Motion for Return of Property)",
      "petenf" : "petenf (Petition to Enforce IRS Summons)",
      "petper" : "petper (Petition to Perpetuate Testimony)",
      "regjgm" : "regjgm (Registration of Foreign Judgment)",
      "tranbkref" : "tranbkref (Transmission of Bankruptcy Reference)",
      "tranff" : "tranff (Transmission of Proposed Findings of Fact and Concl. of Law)",
      "writgar" : "writgar (Application for a Writ of Garnishment)"
   },
   "mssdce" : {
      "0" : "0 (no cause specified)",
      "02:0431" : "02:0431 (02:431 Fed. Election Commission: Failure Enforce Compliance)",
      "02:0437" : "02:0437 (02:437 Federal Election Commission)",
      "05:0075" : "05:0075 (05:75(2) Contract - Reduction in Grade)",
      "05:0551" : "05:0551 (05:551 Administrative Procedure Act)",
      "05:0552fi" : "05:0552fi (05:552 Freedom of Information Act)",
      "05:0552pa" : "05:0552pa (05:552 Right to Privacy Act)",
      "05:0554" : "05:0554 (05:0554 Constitutionality of Maritime Statutes)",
      "05:0701" : "05:0701 (05:0701 Maritime Subsidy Board)",
      "05:0702" : "05:0702 (05:702 Administrative Procedure Act)",
      "05:0704" : "05:0704 (05:704 Labor Litigation)",
      "05:7703" : "05:7703 (05:7703 Discrimination - Review of Agency Act)",
      "05:8470" : "05:8470 (05:8470 Enforcement of Judgment against Retirement Benefits)",
      "07:0006" : "07:0006 (7:6(b) Federal Commodity Exchange Regulation)",
      "07:0025" : "07:0025 (7:25 Fraud - Commodities Leverage Contracts)",
      "07:0181" : "07:0181 (07:181 Packers & Stockyard Act)",
      "07:0499" : "07:0499 (07:499 Agricultural Commodities Act)",
      "07:0601" : "07:0601 (07:601 USDA Condemnation)",
      "07:2321" : "07:2321 (07:2321 Plant Variety Protection Act)",
      "08:1105" : "08:1105 (8:1105(a) Aliens: Habeas Corpus to Release INS Detainee)",
      "08:1182" : "08:1182 (8:1182 Defend. Denial of Pla. Appl. for Alien Employment Cer)",
      "08:1252" : "08:1252 (08:1252(a)(2) Injunction for Deportation)",
      "08:1260" : "08:1260 (08:1260 Aliens: Access to Records)",
      "08:1324" : "08:1324 (08:1324 Aliens: Complaint for Forfeiture)",
      "08:1329" : "08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petition)",
      "08:1446" : "08:1446 (8:1446 Petition for Naturalization Hearing)",
      "08:1451(j)" : "08:1451(j) (8:1451(j) Motion to Correct Order & Judg. of Naturalization)",
      "09:0001" : "09:0001 (09:1 U.S. Arbitration Act)",
      "09:0009" : "09:0009 (9:9 Motion to Confirm Arbitration Loan)",
      "09:0010" : "09:0010 (09:0010 Petition to Vacate Arbitration Award)",
      "10:1408" : "10:1408 (10:1408 Claim for Military Retirement)",
      "10:1552" : "10:1552 (10:1552 Armed Forces: Action to Correct Records)",
      "10:1553" : "10:1553 (10:1553 Armed Forces: FOIA General)",
      "10:2305" : "10:2305 (10:2305 Review of Federal Contract)",
      "11:0101" : "11:0101 (11:101 Bankruptcy)",
      "12:0022" : "12:0022 (12:22 Securities Fraud)",
      "12:0635" : "12:0635 (12:635 Breach of Insurance Contract)",
      "12:1461" : "12:1461 (12:1461 Homeowners Loan Act)",
      "12:1464" : "12:1464 (12:1464 Federal Savings and Loan)",
      "12:1703" : "12:1703 (12:1703 Default of HUD Loan)",
      "12:1725" : "12:1725 (12:1725 Collection under Contract Guaranty)",
      "12:1730" : "12:1730 (12:1730 Collection Under Contract Guaranty)",
      "12:1819" : "12:1819 (12:1819 Default of Promissory Note)",
      "12:1821" : "12:1821 (12:1821 Default of Loan by Promissary Note)",
      "12:191" : "12:191 (12:191 Bank Foreclosure)",
      "12:192" : "12:192 (12:192 Liquidation of National Bank)",
      "12:1971" : "12:1971 (12:1971 Relief under Bank Holding Act)",
      "12:1972" : "12:1972 (12:1972 Typing Arrangement Act)",
      "12:3410" : "12:3410 (12:3410 Right to Financial Privacy Act)",
      "15:0001" : "15:0001 (15:1 Antitrust Litigation)",
      "15:0002at" : "15:0002at (15:2 Antitrust Litigation)",
      "15:0002fl" : "15:0002fl (15:2(a) Fair Labor Standards Act)",
      "15:0005" : "15:0005 (15:5(a) Fair Labor Standards Act)",
      "15:0015" : "15:0015 (15:15 Antitrust Litigation)",
      "15:0025" : "15:0025 (15:25 Clayton Act)",
      "15:0044" : "15:0044 (15:44 Trademark Infringement)",
      "15:0045" : "15:0045 (15:0045 Federal Trade Commission Act)",
      "15:0052" : "15:0052 (15:0052 Federal Trade Commission Act)",
      "15:0053" : "15:0053 (15:0053 Federal Trade Commission Act)",
      "15:0077" : "15:0077 (15:77 Securities Fraud)",
      "15:0078" : "15:0078 (15:78m(a) Securities Exchange Act)",
      "15:0631" : "15:0631 (15:631 Small Business Act)",
      "15:0717" : "15:0717 (15:717 Natural Gas Act)",
      "15:0754" : "15:0754 (15:754 Emergency Petroleum Allocation-Admin.& Enforcement)",
      "15:1051" : "15:1051 (15:1051 Trademark Infringement)",
      "15:1114" : "15:1114 (15:1114 Trademark Infringement)",
      "15:1121" : "15:1121 (15:1121 Trademark Infringement)",
      "15:1125" : "15:1125 (15:1125 Trademark Infringement (Lanham Act))",
      "15:1126" : "15:1126 (15:1126 Patent Infringement)",
      "15:1127" : "15:1127 (15:1127 Trademark Infringement)",
      "15:1601" : "15:1601 (15:1601 Truth in Lending)",
      "15:1640" : "15:1640 (15:1640 Truth in Lending)",
      "15:1681" : "15:1681 (15:1681 Fair Credit Reporting Act)",
      "15:1692" : "15:1692 (15:1692 Fair Debt Collection Act)",
      "15:1938" : "15:1938 (15:1938 Fair Labor Standards Act)",
      "15:1981" : "15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))",
      "15:1988" : "15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))",
      "15:1989" : "15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))",
      "15:2301" : "15:2301 (15:2301 Magnuson-Moss Warranty Act)",
      "15:2801" : "15:2801 (15:2801 Petroleum Marketing Practices Act)",
      "15:53(b)" : "15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equita)",
      "16:0668" : "16:0668 (16:668 Bald Eagle Protection Act)",
      "16:0703" : "16:0703 (16:703 Migratory Bird Act)",
      "16:1538" : "16:1538 (16:1538 Endangered Species Act)",
      "16:3371" : "16:3371 (16:3371 Wildlife Under the Lacey Act)",
      "16:3372" : "16:3372 (16:3372 Conservation: Complaint for Forfeiture)",
      "16:3373" : "16:3373 (16:3373 Appeal of Decision - DOI)",
      "16:3374" : "16:3374 (16:3374 Conservation: Complaint for Forfeiture)",
      "17:0101" : "17:0101 (17:101 Copyright Infringement)",
      "17:0501" : "17:0501 (17:501 Copyright Infringement)",
      "17:0504" : "17:0504 (17:504 Copyright Infringement)",
      "18:0241" : "18:0241 (18:241 Conspiracy Against Citizen Rights)",
      "18:1836a" : "18:1836a (18:1836(a) Injunction against Misappropriation of Trade Secrets)",
      "18:1836b" : "18:1836b (18:1836(b) Civil Action to Protect Trade Secrets)",
      "18:1961" : "18:1961 (18:1961 Racketeering (RICO) Act)",
      "18:1962" : "18:1962 (18:1962 Racketeering (RICO) Act)",
      "18:1964" : "18:1964 (18:1964 Racketeering (RICO) Act)",
      "18:2511" : "18:2511 (18:2511 Wiretapping)",
      "18:3114" : "18:3114 (18:3114 Motion for Return of Seized Property)",
      "18:4208" : "18:4208 (18:4208(B) Agency Action Review)",
      "19:1305" : "19:1305 (19:1305 Custom Duties: Forfeiture-Immoral Articles)",
      "20:1080" : "20:1080 (20:1080 Student Loan Recovery)",
      "20:1400" : "20:1400 (20:1400 Civil Rights of Handicapped Child)",
      "20:1401" : "20:1401 (20:1401 Education: Handicapped Child Act)",
      "21:0841" : "21:0841 (21:841 Forfeiture Property-Drugs)",
      "21:0881" : "21:0881 (21:881 Forfeiture Property-Drugs)",
      "21:0881a" : "21:0881a (21:881 Forfeiture Property - Aircraft)",
      "21:0881re" : "21:0881re (21:881 Forfeiture Property - Real Estate)",
      "23:0134" : "23:0134 (23:134 P.I.- Auto Negligence)",
      "23:1441" : "23:1441 (23:1441 Contract Real Estate)",
      "24:1000" : "24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)",
      "25:0640" : "25:0640 (25:640 Indian Tribal Rights)",
      "25:1901" : "25:1901 (25:1901 Indian Child Welfare Act)",
      "26:6212" : "26:6212 (26:6212 Injunctive Relief from IRS Lien)",
      "26:6213" : "26:6213 (26:6213 Injunctive Relief from IRS Lien)",
      "26:6502" : "26:6502 (26:6502 IRS:Enforcement of tax liens)",
      "26:6532" : "26:6532 (26:6532 IRS: Refund of Tax Penalty)",
      "26:6702" : "26:6702 (26:6702 IRS: Refund of Income Tax Penalty)",
      "26:6703" : "26:6703 (26:6703 IRS: Refund of Tax Penalty)",
      "26:7401" : "26:7401 (26:7401 IRS: Tax Liability)",
      "26:7402" : "26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)",
      "26:7403" : "26:7403 (26:7403 Suit to Enforce Federal Tax Lien)",
      "26:7422rt" : "26:7422rt (26:7422 IRS: Refund Taxes)",
      "26:7422rx" : "26:7422rx (26:7422 IRS: Refund Excise Tax)",
      "26:7426" : "26:7426 (26:7426 IRS: Wrongful Levy for Taxes)",
      "26:7429" : "26:7429 (26:7429 IRS: Tax Jeopardy Assessment)",
      "26:7609" : "26:7609 (26:7609 IRS: Petition to Quash IRS Summons)",
      "27:0185" : "27:0185 (27:185 Enforcement of Arbitration Award)",
      "28:0157c" : "28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)",
      "28:0157d" : "28:0157d (28:0157 Motion for Withdrawal of Reference)",
      "28:0158" : "28:0158 (28:0158 Bankruptcy Appeal from Judgment/Order)",
      "28:0185" : "28:0185 (28:185 Suit to Compel Arbitration)",
      "28:0451" : "28:0451 (28:451 Employment Discrimination)",
      "28:0754" : "28:0754 (28:754 Receiver of Property in Different Districts)",
      "28:0794" : "28:0794 (28:794 Rehabilitation Act)",
      "28:1001" : "28:1001 (28:1001 E.R.I.S.A.)",
      "28:1132" : "28:1132 (28:1132 E.R.I.S.A.)",
      "28:1330" : "28:1330 (28:1330 Breach of Contract)",
      "28:1331" : "28:1331 (28:1331 Fed. Question)",
      "28:1331al" : "28:1331al (28:1331 Fed. Question: Airline Crash)",
      "28:1331at" : "28:1331at (28:1331 Fed. Question: Anti-trust)",
      "28:1331au" : "28:1331au (28:1331 Fed. Question: Auto Negligence)",
      "28:1331b" : "28:1331b (28:1331 Federal Question: Bivens Act)",
      "28:1331bc" : "28:1331bc (28:1331 Fed. Question: Breach of Contract)",
      "28:1331ca" : "28:1331ca (28:1331 Fed Question: Fed Communications Act of 1)",
      "28:1331cm" : "28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)",
      "28:1331cv" : "28:1331cv (28:1331 Fed. Question: Civil Rights Violation)",
      "28:1331ed" : "28:1331ed (28:1331 Fed. Question: Employment Discrimination)",
      "28:1331ej" : "28:1331ej (28:1331 Federal Question: Enforcement of Judgment)",
      "28:1331es" : "28:1331es (28:1331 Enforcement of Administrative Subpoena)",
      "28:1331fl" : "28:1331fl (28:1331 Fed. Question: Fair Labor Standards)",
      "28:1331in" : "28:1331in (28:1331 Fed. Question: Insurance Contract)",
      "28:1331mm" : "28:1331mm (28:1331 Fed. Question: Medical Malpractice)",
      "28:1331ng" : "28:1331ng (28:1331 Fed. Question: Natural Gas Act)",
      "28:1331pi" : "28:1331pi (28:1331 Fed. Question: Personal Injury)",
      "28:1331rd" : "28:1331rd (28:1331 Fed. Question: Review Agency Decision)",
      "28:1331rp" : "28:1331rp (28:1331(a) Fed. Question: Real Property)",
      "28:1331rr" : "28:1331rr (28:1331 Fed. Question: Railway Labor Act)",
      "28:1331sv" : "28:1331sv (28:1331 Fed. Question: Securities Violation)",
      "28:1331tr" : "28:1331tr (28:1331 Fed. Question: Trademark)",
      "28:1331tt" : "28:1331tt (28:1331 Fed. Question: Tort Action)",
      "28:1331v" : "28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendment)",
      "28:1331wl" : "28:1331wl (28:1331 Federal Question: EPA Waste Lien)",
      "28:1331wt" : "28:1331wt (28:1331 Fed. Question: Water Rights)",
      "28:1332ac" : "28:1332ac (28:1332 Diversity-Account Receivable)",
      "28:1332al" : "28:1332al (28:1332 Diversity-Airline Crash)",
      "28:1332as" : "28:1332as (28:1332 Diversity-Asbestos Litigation)",
      "28:1332au" : "28:1332au (28:1332 Diversity-Auto Negligence)",
      "28:1332bc" : "28:1332bc (28:1332 Diversity-Breach of Contract)",
      "28:1332co" : "28:1332co (28:1332 Diversity-Conversion)",
      "28:1332ct" : "28:1332ct (28:1332 Diversity-(Citizenship))",
      "28:1332det" : "28:1332det (28:1332 Diversity: Forcible Detainer)",
      "28:1332df" : "28:1332df (28:1332 Diversity-Contract Default)",
      "28:1332ds" : "28:1332ds (28:1332 Diversity-Contract Dispute)",
      "28:1332ed" : "28:1332ed (28:1332 Diversity-Employment Discrimination)",
      "28:1332fd" : "28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)",
      "28:1332fr" : "28:1332fr (28:1332 Diversity-Fraud)",
      "28:1332ia" : "28:1332ia (28:1332 Diversity-Interpleader Action)",
      "28:1332ij" : "28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)",
      "28:1332in" : "28:1332in (28:1332 Diversity-Insurance Contract)",
      "28:1332jd" : "28:1332jd (28:1332 Diversity-Declaratory Judgment)",
      "28:1332lb" : "28:1332lb (28:1332 Diversity-Libel, Assault, Slander)",
      "28:1332lm" : "28:1332lm (28:1332 Diversity - Legal Malpractice)",
      "28:1332ma" : "28:1332ma (28:1332 Diversity-Miller Act)",
      "28:1332mm" : "28:1332mm (28:1332 Diversity-Medical Malpractice)",
      "28:1332mv" : "28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)",
      "28:1332ni" : "28:1332ni (28:1332 Diversity-Negotiable Instrument)",
      "28:1332nm" : "28:1332nm (28:1332 Diversity-Non-Motor Vehicle)",
      "28:1332nr" : "28:1332nr (28:1332 Diversity-Notice of Removal)",
      "28:1332oc" : "28:1332oc (28:1332 Diversity-Other Contract)",
      "28:1332pd" : "28:1332pd (28:1332 Diversity-Property Damage)",
      "28:1332pi" : "28:1332pi (28:1332 Diversity-Personal Injury)",
      "28:1332pl" : "28:1332pl (28:1332 Diversity-Product Liability)",
      "28:1332pr" : "28:1332pr (28:1332 Diversity-Petition for Removal)",
      "28:1332qt" : "28:1332qt (28:1332 Diversity-Petition to Quiet Title)",
      "28:1332ri" : "28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)",
      "28:1332sa" : "28:1332sa (28:1332 - Diversity: Securities & Exchange Commiss)",
      "28:1332sf" : "28:1332sf (28:1332 - Diversity: Securities Fraud)",
      "28:1332ss" : "28:1332ss (28:1332 Diversity - Stockholders Suits)",
      "28:1332tl" : "28:1332tl (28:1332 Diversity-Torts to Land)",
      "28:1332tm" : "28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))",
      "28:1332tn" : "28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)",
      "28:1332wd" : "28:1332wd (28:1332 Diversity-Wrongful Death)",
      "28:1333" : "28:1333 (28:1333 Admiralty)",
      "28:1334" : "28:1334 (28:1334 Bankruptcy Appeal)",
      "28:1334c" : "28:1334c (28:1334(c) R&R re motions for abstention (non-cor)",
      "28:1335" : "28:1335 (28:1335 Interpleader Action)",
      "28:1337" : "28:1337 (28:1337 Sherman-Clayton Act)",
      "28:1338cp" : "28:1338cp (28:1338 Copyright Infringement)",
      "28:1338pt" : "28:1338pt (28:1338 Patent Infringement)",
      "28:1338tr" : "28:1338tr (28:1338 Trademark Infringement)",
      "28:1340" : "28:1340 (28:1340 IRS: Custom Duties)",
      "28:1340er" : "28:1340er (28:1340 Recovery of Erroneous Refund)",
      "28:1341" : "28:1341 (28:1341 Complaint for Forfeiture)",
      "28:1343" : "28:1343 (28:1343 Violation of Civil Rights)",
      "28:1345" : "28:1345 (28:1345 USA Plaintiff)",
      "28:1345co" : "28:1345co (28:1345 Replevin & Conversion)",
      "28:1345db" : "28:1345db (28:1345 Debt to US - FHA/HUD Title I)",
      "28:1345df" : "28:1345df (28:1345 Default of Promissory Note)",
      "28:1345er" : "28:1345er (28:1345 Recovery of Erroneous Refund)",
      "28:1345fc" : "28:1345fc (28:1345 Foreclosure)",
      "28:1345ff" : "28:1345ff (28:1345 Complaint for Forfeiture)",
      "28:1345hl" : "28:1345hl (28:1345 VA Home Loan Guaranty Debt)",
      "28:1345mc" : "28:1345mc (28:1345 Medical Care Recovery)",
      "28:1345mi" : "28:1345mi (28:1345 Mining Claim Ejectment)",
      "28:1345pd" : "28:1345pd (28:1345 Property Damage)",
      "28:1345pe" : "28:1345pe (28:1345 VA Property Ejectment)",
      "28:1345rc" : "28:1345rc (28:1345 Recovery of Debt to US)",
      "28:1345st" : "28:1345st (28:1345 Default of Student Loan)",
      "28:1345tp" : "28:1345tp (28:1345 Trespass on Public Land)",
      "28:1345va" : "28:1345va (28:1345 Recovery of VA Overpayment)",
      "28:1346bc" : "28:1346bc (28:1346 Breach of Contract)",
      "28:1346rc" : "28:1346rc (28:1346 Recovery of IRS Tax)",
      "28:1346tc" : "28:1346tc (28:1346 Tort Claim)",
      "28:1346wd" : "28:1346wd (28:1346 Wrongful Death)",
      "28:1349" : "28:1349 (28:1348 Corporation organized under Federal Law as party)",
      "28:1352" : "28:1352 (28:1352 Miller Act)",
      "28:1355" : "28:1355 (28:1355 Petition for Return of Property)",
      "28:1358" : "28:1358 (28:1358 Land Condemnation)",
      "28:1361" : "28:1361 (28:1361 Petition for Writ of Mandamus)",
      "28:1362ic" : "28:1362ic (28:1362 Indian Tribal Controversy)",
      "28:1362iw" : "28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)",
      "28:1364" : "28:1364 (28:1364 Auto Negligence)",
      "28:1391" : "28:1391 (28:1391 Personal Injury)",
      "28:1402" : "28:1402 (28:1402 Medical Malpractice)",
      "28:1407" : "28:1407 (28:1407 Airline Crash)",
      "28:1441ac" : "28:1441ac (28:1441 Notice of Removal-Account Receivable)",
      "28:1441al" : "28:1441al (28:1441 Notice of Removal-Airline Crash)",
      "28:1441as" : "28:1441as (28:1441 Notice of Removal-Asbestos Litigation)",
      "28:1441au" : "28:1441au (28:1441 Notice of Removal-Auto Negligence)",
      "28:1441bc" : "28:1441bc (28:1441 Notice of Removal-Breach of Contract)",
      "28:1441cv" : "28:1441cv (28:1441 Petition for Removal- Civil Rights Act)",
      "28:1441df" : "28:1441df (28:1441 Notice of Removal-Contract Default)",
      "28:1441dj" : "28:1441dj (28:1441 Notice of Removal-Declaratory Judgment)",
      "28:1441ds" : "28:1441ds (28:1441 Notice of Removal-Contract Dispute)",
      "28:1441ed" : "28:1441ed (28:1441 Petition for Removal - Employment Discrim)",
      "28:1441fc" : "28:1441fc (28:1441 Petition for Removal - Fair Credit Reporti)",
      "28:1441fr" : "28:1441fr (28:1441 Notice of Removal-Fraud)",
      "28:1441ij" : "28:1441ij (28:1441 Notice of Removal-Injunctive/Declaratory Relief)",
      "28:1441in" : "28:1441in (28:1441 Notice of Removal-Insurance Contract)",
      "28:1441int" : "28:1441int (28:1441 Petition for Removal- Action for Interplea)",
      "28:1441lb" : "28:1441lb (28:1441 Notice of Removal-Libel, Assault, Slander)",
      "28:1441lm" : "28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relatio)",
      "28:1441mm" : "28:1441mm (28:1441 Notice of Removal-Medical Malpractice)",
      "28:1441ni" : "28:1441ni (28:1441 Notice of Removal-Negotiable Instrument)",
      "28:1441nm" : "28:1441nm (28:1441 Notice of Removal-Non-Motor Vehicle)",
      "28:1441nr" : "28:1441nr (28:1441 Notice of Removal)",
      "28:1441oc" : "28:1441oc (28:1441 Petition For Removal--Other Contract)",
      "28:1441pd" : "28:1441pd (28:1441 Notice of Removal-Property Damage)",
      "28:1441pi" : "28:1441pi (28:1441 Notice of Removal-Personal Injury)",
      "28:1441pl" : "28:1441pl (28:1441 Notice of Removal-Product Liability)",
      "28:1441pr" : "28:1441pr (28:1441 Petition for Removal)",
      "28:1441qt" : "28:1441qt (28:1441 Notice of Removal-Petition to Quiet Title)",
      "28:1441ri" : "28:1441ri (28:1441 Petition for Removal- Racketeering (RICO))",
      "28:1441sa" : "28:1441sa (28:1441 - Petition for Removal: SEC Act)",
      "28:1441sf" : "28:1441sf (28:1441 - Petition for Removal: Securities Fraud)",
      "28:1441tl" : "28:1441tl (28:1441 Notice of Removal-Torts to Land)",
      "28:1441tm" : "28:1441tm (28:1441 Notice of Removal-Tort/Motor Vehicle (P.I.))",
      "28:1441tn" : "28:1441tn (28:1441 Notice of Removal-Tort/Non-Motor Vehicle)",
      "28:1441wd" : "28:1441wd (28:1441 Notice of Removal-Wrongful Death)",
      "28:1442bc" : "28:1442bc (28:1442 Notice of Removal-Breach of Contract)",
      "28:1442nr" : "28:1442nr (28:1442 Notice of Removal)",
      "28:1442pr" : "28:1442pr (28:1442 Petition for Removal)",
      "28:1443" : "28:1443 (28:1443(1) Rent, Lease & Ejectment)",
      "28:1444" : "28:1444 (28:1441 Notice of Removal-Foreclosure)",
      "28:1446in" : "28:1446in (28:1446 Breach of Contract- Insurance)",
      "28:1446nr" : "28:1446nr (28:1446 Notice of Removal)",
      "28:1446pd" : "28:1446pd (28:1446 Notice of Removal-Property Damage (P.I.))",
      "28:1446pi" : "28:1446pi (28:1446 Notice of Removal-Personal Injury)",
      "28:1446pl" : "28:1446pl (28:1446pl Petition for Removal - Product Liability)",
      "28:1446pr" : "28:1446pr (28:1446 Petition for Removal)",
      "28:1452" : "28:1452 (28:1452 Removal of Claim in Civil Action Related to BK. Case)",
      "28:1651" : "28:1651 (28:1651 Petition for Writ of Coram Nobis)",
      "28:1651hc" : "28:1651hc (28:1651 Petition for Writ of Habeas Corpus)",
      "28:1651mn" : "28:1651mn (28:1651 Petition for Writ of Mandamus)",
      "28:1782" : "28:1782 (28:1782 Letter rogatory - appointment)",
      "28:1983" : "28:1983 (28:1983 Civil Rights)",
      "28:2201" : "28:2201 (28:2201 Constitutionality of State Statute(s))",
      "28:2201dj" : "28:2201dj (28:2201 Declaratory Judgment)",
      "28:2201ij" : "28:2201ij (28:2201 Injunction)",
      "28:2201in" : "28:2201in (28:2201 Declaratory Judgment (Insurance))",
      "28:2241" : "28:2241 (28:2241 Petition for Writ of Habeas Corpus (Federal))",
      "28:2254" : "28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))",
      "28:2254se" : "28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)",
      "28:2255" : "28:2255 (28:2255 Motion to Vacate Sentence)",
      "28:2271" : "28:2271 (28:2271 Federal Tort Claims Act)",
      "28:2345" : "28:2345 (28:2345 Medicare Recovery)",
      "28:2409" : "28:2409 (28:2409(a) Quiet Title Action)",
      "28:2410" : "28:2410 (Actions affecting property on which United States had lien)",
      "28:2671" : "28:2671 (28:2671 Federal Tort Claims Act)",
      "28:2674" : "28:2674 (28:2674 Federal Tort Claims Act)",
      "28:3001" : "28:3001 (28:3001 Federal Debt Collection Act)",
      "28:7402" : "28:7402 (28:7402 Refund of Taxes)",
      "28:7422" : "28:7422 (28:7422 Appeal from Administrative Decision)",
      "29:0151" : "29:0151 (29:151 Labor: Review of Agency Action)",
      "29:0160" : "29:0160 (29:160(1) National Labor Relations Act)",
      "29:0184" : "29:0184 (29:184 Violation Collection Bargain Agreement)",
      "29:0185ep" : "29:0185ep (29:185 Employee Pension Plan)",
      "29:0185lm" : "29:0185lm (29:185 Labor/Mgt. Relations (Contracts))",
      "29:0201do" : "29:0201do (29:201 Denial of Overtime Compensation)",
      "29:0201fl" : "29:0201fl (29:201 Fair Labor Standards Act)",
      "29:0203" : "29:0203 (29:203 Equal Pay Act)",
      "29:0206" : "29:0206 (29:206 Collect Unpaid Wages)",
      "29:0401" : "29:0401 (29:0401 Labor Management Disclosure Act)",
      "29:0621" : "29:0621 (29:621 Job Discrimination (Age))",
      "29:0623" : "29:0623 (29:623 Job Discrimination (Age))",
      "29:0626" : "29:0626 (29:626 Job Discrimination (Age))",
      "29:0633" : "29:0633 (29:633 Job Discrimination (Age))",
      "29:0651" : "29:0651 (29:651 Occupational Safety/Health)",
      "29:0754" : "29:0754 (29:754 Discrimination)",
      "29:0791" : "29:0791 (29:791 Job Discrimination (Rehabilitation Act))",
      "29:0794" : "29:0794 (29:0794 Job Discrimination (Handicap))",
      "29:1001" : "29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)",
      "29:1002" : "29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)",
      "29:1104" : "29:1104 (29:1104 Recovery of Benefits to Employee)",
      "29:1109" : "29:1109 (29:1109 Breach of Fiduciary Duties)",
      "29:1131" : "29:1131 (29:1131 ERISA - Collection of Delinquent Trust Funds)",
      "29:1132" : "29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)",
      "29:1145" : "29:1145 (29:1145 E.R.I.S.A.)",
      "29:1149" : "29:1149 (29:1149 Recover Pension & Profit Sharing)",
      "29:1337" : "29:1337 (29:1337 E.R.I.S.A.)",
      "29:1362" : "29:1362 (29:1362 ERISA)",
      "29:1381" : "29:1381 (29:1381 E.R.I.S.A.)",
      "29:1401" : "29:1401 (29:1401(b)(2) Appeal of Arbitration Award)",
      "29:1451" : "29:1451 (29:1451 E.R.I.S.A.)",
      "29:1801" : "29:1801 (29:1801 Farmworker Rights)",
      "29:790" : "29:790 (29:790 Rehabilitation of Labor)",
      "30:0181" : "30:0181 (30:181 Environment: Review of Agency Action)",
      "30:0801" : "30:0801 (30:0801 Penalities/Federal Mine Safety Health Act)",
      "30:1201" : "30:1201 (30:1201 Environment: Review of Agency Action)",
      "30:1202" : "30:1202 (30:1202 Mining Reclamation Act)",
      "30:1276" : "30:1276 (30:1276 Interior: Review of Agency Action)",
      "31:3545" : "31:3545 (31:3545 Action to Recovery Money)",
      "31:3729" : "31:3729 (31:3729 False Claims Act)",
      "31:3730" : "31:3730 (31:3730 Qui Tam False Claims Act)",
      "31:3731" : "31:3731 (31:3731 Fraud)",
      "33:1319cw" : "33:1319cw (33:1319 Clean Water Act)",
      "33:1319pv" : "33:1319pv (33:1319 Pollutants & Permit Violations)",
      "33:1365" : "33:1365 (33:1365 Environmental Matters)",
      "35:0145" : "35:0145 (35:145 Patent Infringement)",
      "35:0183" : "35:0183 (35:183 Patent Infringement)",
      "35:0271" : "35:0271 (35:271 Patent Infringement)",
      "38:1681" : "38:1681 (38:1681 Recovery of VA Overpayment)",
      "38:1686" : "38:1686 (38:1686 Recovery of VA Overpayment)",
      "38:1780" : "38:1780 (38:1780 Recovery of VA Overpayment)",
      "38:2011" : "38:2011 (38:2011 - Veteran's Readjustment Assistance Act of)",
      "38:2021" : "38:2021 (Right to re-employment of inducted persons)",
      "38:3116" : "38:3116 (38:3116 VA Overpayment)",
      "38:775" : "38:775 (Recovery of Servicemen's Group Life Insurance)",
      "39:3005" : "39:3005 (39:3005 Detention of Mail for Temporary Periods)",
      "39:409" : "39:409 (39:409 Postal Service)",
      "40:0258" : "40:0258 (40:258(a) Public Buildings & Property: Land Condemnation)",
      "40:0270" : "40:0270 (40:270 Miller Act)",
      "40:0875" : "40:0875 (40:875 Public Buildings & Property: Negligence)",
      "41:0251" : "41:0251 (41:251 Public Contracts-Review of Agency Action)",
      "41:1463" : "41:1463 (41:1463 Public Contracts: Unlawful Employment Practices)",
      "42:0205" : "42:0205 (42:205 Denial Social Security Benefits)",
      "42:0206" : "42:0206 (42:206 Social Security Benefits)",
      "42:0247" : "42:0247 (42:247 Personal Injury-Swine Flu)",
      "42:0402" : "42:0402 (42:402 Social Security Benefits)",
      "42:0405id" : "42:0405id (42:405 Review of HHS Decision (SSID))",
      "42:0405wc" : "42:0405wc (42:405 Review of HHS Decision (DIWC))",
      "42:0405ww" : "42:0405ww (42:405 Review of HHS Decision (DIWW))",
      "42:0416" : "42:0416 (42:416 Denial of Social Security Benefits)",
      "42:0427" : "42:0427 (42:427 Social Security Benefits)",
      "42:1383" : "42:1383 (42:1383 Review of HHS Decision)",
      "42:1395" : "42:1395 (42:1395 HHS: Adverse Reimbursement Review)",
      "42:1395dd" : "42:1395dd (42:1395 Emergency Medical Treatment & Active Labor Act)",
      "42:1396" : "42:1396 (42:1396 - Tort Negligence)",
      "42:1471" : "42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclo)",
      "42:1981cv" : "42:1981cv (42:1981 Civil Rights)",
      "42:1981hs" : "42:1981hs (42:1981 Housing Discrimination)",
      "42:1981jb" : "42:1981jb (42:1981 Job Discrimination (Race))",
      "42:1981sx" : "42:1981sx (42:1981 Sex Discrimination)",
      "42:1983cv" : "42:1983cv (42:1983 Civil Rights Act)",
      "42:1983ed" : "42:1983ed (42:1983 Civil Rights (Employment Discrimination))",
      "42:1983pr" : "42:1983pr (42:1983 Prisoner Civil Rights)",
      "42:1986" : "42:1986 (42:1986 Neglect of Duty)",
      "42:2000ag" : "42:2000ag (42:2000 Job Discrimination (Age))",
      "42:2000e" : "42:2000e (42:2000e Job Discrimination (Employment))",
      "42:2000pb" : "42:2000pb (42:2000 Job Discrimination (Public Accommodations))",
      "42:2000ra" : "42:2000ra (42:2000 Job Discrimination (Race))",
      "42:2000sx" : "42:2000sx (42:2000 Job Discrimination (Sex))",
      "42:2003" : "42:2003 (42:2003 Job Discrimination)",
      "42:2005" : "42:2005 (42:2005 Review of Agency Action-HHS)",
      "42:2615" : "42:2615 (42:2616 Medical Recovery Act)",
      "42:2651" : "42:2651 (42:2651 Medical Care Recovery)",
      "42:3601" : "42:3601 (42:405 Fair Housing Act)",
      "42:4000" : "42:4000 (42:4000 National Flood Insurance Act)",
      "42:4001" : "42:4001 (42:4001 National Insurance Flood Act)",
      "42:4053" : "42:4053 (42:4053 Breach of Insurance Contract)",
      "42:4072" : "42:4072 (42:4072 Payment of Flood Insurance Claim)",
      "42:4321" : "42:4321 (42:4321 Review of Agency Action-Environment)",
      "42:4332" : "42:4332 (42:4332)",
      "42:6901en" : "42:6901en (42:6901 Environmental Cleanup Expenses)",
      "42:6901rs" : "42:6901rs (42:6901 Resource & Recovery Act)",
      "42:7413" : "42:7413 (42:7413(b) Clean Air Act)",
      "42:7604cl" : "42:7604cl (42:7604 Clear Air Act (Emission Standards))",
      "42:7604ir" : "42:7604ir (42:7604 Petition to Quash IRS Summons)",
      "42:9607" : "42:9607 (42:9607 Real Property Tort to Land)",
      "43:945" : "43:945 (43:945 Compensation for Land Condemnation)",
      "43:945a" : "43:945a (43:945a Complaint in Condemnation)",
      "43:946" : "43:946 (43:946 Complaint in Condemnation - Eminent Domain)",
      "45:0051" : "45:0051 (45:51 Railways: Fed. Employer's Liability Act)",
      "45:0151" : "45:0151 (45:151 Railway Labor Act)",
      "45:0184" : "45:0184 (45:184 Action to Set Aside Award of a System Board of Adjust)",
      "45:1395" : "45:1395 (45:1395 Railroads: Adverse Reimbursement Review)",
      "45:7457" : "45:7457 (45:7457 Compel Reclamation Under Clear Air Act)",
      "46:0688" : "46:0688 (46:688 Jones Act)",
      "46:0741" : "46:0741 (46:741 Shipping)",
      "46:0761" : "46:0761 (46:761 Shipping: Damages for Death on High Seas)",
      "46:1101" : "46:1101 (46:1101 Violation of Maritime Regulations)",
      "46:1156" : "46:1156 (46:1156 Administrative Procedure Act)",
      "46:688" : "46:688 (Jones Act (Merchant Marine))",
      "47:251" : "47:251 (Duties of telecommunications carriers)",
      "47:252" : "47:252 (Procedures of negotiation, arbitration, and approval of agreements for intercnonnection services)",
      "47:261" : "47:261 (Telecommunication Carrier, Commission and State Regulations)",
      "48:0883" : "48:0883 (48:883 Violation of US Coastal Law)",
      "48:1985" : "48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)",
      "49:0081" : "49:0081 (49:81 Damaged Goods While Being Transported)",
      "49:0781" : "49:0781 (49:781 Forfeiture)",
      "49:11503" : "49:11503 (49:11503 Railroad Revitalization Regulatory Reform)",
      "49:11702" : "49:11702 (49:11702(a)(4) Violations of Interstate Commerce A)",
      "49:1471" : "49:1471 (49:1471 Federal Aviation Act)",
      "49:1903" : "49:1903 (49:1903 Petition to enforce administrative summon)",
      "8:287" : "8:287 (8:287 Petition to Enforce INS Subpoena)",
      "99:9999" : "99:9999 (99:9999 Report cause code (DO NOT DELETE!))",
      "adsup" : "adsup (Administrative Subpoena)",
      "contempt" : "contempt (Contempt Proceedings)",
      "disbar" : "disbar (Disbarment Proceedings)",
      "fordepo" : "fordepo (Foreign Deposition)",
      "misc" : "misc (Civil Miscellaneous Case)",
      "motcomp" : "motcomp (Motion to Compel)",
      "motquash" : "motquash (Motion to Quash)",
      "motret" : "motret (Motion for Return of Property)",
      "petenf" : "petenf (Petition to Enforce IRS Summons)",
      "petper" : "petper (Petition to Perpetuate Testimony)",
      "regjgm" : "regjgm (Registration of Foreign Judgment)",
      "tranbkref" : "tranbkref (Transmission of Bankruptcy Reference)",
      "tranff" : "tranff (Transmission of Proposed Findings of Fact and Concl. of Law)",
      "writgar" : "writgar (Application for a Writ of Garnishment)"
   },
   "mtdce" : {
      "0" : "0 (No cause code entered)",
      "00:0000" : "00:0000 (00:0000 Cause Code Unknown)",
      "02:0431" : "02:0431 (02:431 Fed. Election Commission: Failure Enforce Compliance)",
      "02:0437" : "02:0437 (02:437 Federal Election Commission)",
      "05:0075" : "05:0075 (05:75(2) Contract - Reduction in Grade)",
      "05:0551" : "05:0551 (05:551 Administrative Procedure Act)",
      "05:0552fi" : "05:0552fi (05:552 Freedom of Information Act)",
      "05:0552pa" : "05:0552pa (05:552 Right to Privacy Act)",
      "05:0554" : "05:0554 (05:0554 Constitutionality of Maritime Statutes)",
      "05:0701" : "05:0701 (05:0701 Maritime Subsidy Board)",
      "05:0702" : "05:0702 (05:702 Administrative Procedure Act)",
      "05:0704" : "05:0704 (05:704 Labor Litigation)",
      "05:7703" : "05:7703 (05:7703 Discrimination - Review of Agency Act)",
      "07:0006" : "07:0006 (7:6(b) Federal Commodity Exchange Regulation)",
      "07:0025" : "07:0025 (7:25 Fraud - Commodities Leverage Contracts)",
      "07:0181" : "07:0181 (07:181 Packers & Stockyard Act)",
      "07:0499" : "07:0499 (07:499 Agricultural Commodities Act)",
      "07:0601" : "07:0601 (07:601 USDA Condemnation)",
      "07:2321" : "07:2321 (07:2321 Plant Variety Protection Act)",
      "08:1105" : "08:1105 (8:1105(a) Aliens: Habeas Corpus to Release INS Detainee)",
      "08:1252" : "08:1252 (08:1252(a)(2) Injunction for Deportation)",
      "08:1260" : "08:1260 (08:1260 Aliens: Access to Records)",
      "08:1324" : "08:1324 (08:1324 Aliens: Complaint for Forfeiture)",
      "08:1329" : "08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petition)",
      "08:1446" : "08:1446 (8:1446 Petition for Naturalization Hearing)",
      "09:0001" : "09:0001 (09:1 U.S. Arbitration Act)",
      "09:0009" : "09:0009 (9:9 Motion to Confirm Arbitration Loan)",
      "09:0010" : "09:0010 (09:0010 Petition to Vacate Arbitration Award)",
      "10:1552" : "10:1552 (10:1552 Armed Forces: Action to Correct Records)",
      "10:1553" : "10:1553 (10:1553 Armed Forces: FOIA General)",
      "10:2305" : "10:2305 (10:2305 Review of Federal Contract)",
      "11:0101" : "11:0101 (11:101 Bankruptcy)",
      "12:0022" : "12:0022 (12:22 Securities Fraud)",
      "12:0635" : "12:0635 (12:635 Breach of Insurance Contract)",
      "12:1461" : "12:1461 (12:1461 Homeowners Loan Act)",
      "12:1703" : "12:1703 (12:1703 Default of HUD Loan)",
      "12:1725" : "12:1725 (12:1725 Collection under Contract Guaranty)",
      "12:1730" : "12:1730 (12:1730 Collection Under Contract Guaranty)",
      "12:1751" : "12:1751 (Federal Credit Union Act)",
      "12:1819" : "12:1819 (12:1819 Default of Promissory Note)",
      "12:1821" : "12:1821 (12:1821 Default of Loan by Promissary Note)",
      "12:1971" : "12:1971 (12:1971 Relief under Bank Holding Act)",
      "12:3410" : "12:3410 (12:3410 Right to Financial Privacy Act)",
      "15:0001" : "15:0001 (15:1 Antitrust Litigation)",
      "15:0002at" : "15:0002at (15:2 Antitrust Litigation)",
      "15:0002fl" : "15:0002fl (15:2(a) Fair Labor Standards Act)",
      "15:0005" : "15:0005 (15:5(a) Fair Labor Standards Act)",
      "15:0015" : "15:0015 (15:15 Antitrust Litigation)",
      "15:0025" : "15:0025 (15:25 Clayton Act)",
      "15:0044" : "15:0044 (15:44 Trademark Infringement)",
      "15:0045" : "15:0045 (15:0045 Federal Trade Commission Act)",
      "15:0052" : "15:0052 (15:0052 Federal Trade Commission Act)",
      "15:0053" : "15:0053 (15:0053 Federal Trade Commission Act)",
      "15:0077" : "15:0077 (15:77 Securities Fraud)",
      "15:0078" : "15:0078 (15:78m(a) Securities Exchange Act)",
      "15:0631" : "15:0631 (15:631 Small Business Act)",
      "15:0717" : "15:0717 (15:717 Natural Gas Act)",
      "15:1051" : "15:1051 (15:1051 Trademark Infringement)",
      "15:1114" : "15:1114 (15:1114 Trademark Infringement)",
      "15:1121" : "15:1121 (15:1121 Trademark Infringement)",
      "15:1125" : "15:1125 (15:1125 Trademark Infringement (Lanham Act))",
      "15:1126" : "15:1126 (15:1126 Patent Infringement)",
      "15:1127" : "15:1127 (15:1127 Trademark Infringement)",
      "15:1601" : "15:1601 (15:1601 Truth in Lending)",
      "15:1640" : "15:1640 (15:1640 Truth in Lending)",
      "15:1681" : "15:1681 (15:1681 Fair Credit Reporting Act)",
      "15:1692" : "15:1692 (15:1692 Fair Debt Collection Act)",
      "15:1938" : "15:1938 (15:1938 Fair Labor Standards Act)",
      "15:1981" : "15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))",
      "15:1988" : "15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))",
      "15:1989" : "15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))",
      "15:2301" : "15:2301 (15:2301 Magnuson-Moss Warranty Act)",
      "15:2801" : "15:2801 (15:2801 Petroleum Marketing Practices Act)",
      "15:53(b)" : "15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equitable Relief)",
      "16:0668" : "16:0668 (16:668 Bald Eagle Protection Act)",
      "16:0703" : "16:0703 (16:703 Migratory Bird Act)",
      "16:1538" : "16:1538 (16:1538 Endangered Species Act)",
      "16:3371" : "16:3371 (16:3371 Wildlife Under the Lacey Act)",
      "16:3372" : "16:3372 (16:3372 Conservation: Complaint for Forfeiture)",
      "16:3373" : "16:3373 (16:3373 Appeal of Decision - DOI)",
      "16:3374" : "16:3374 (16:3374 Conservation: Complaint for Forfeiture)",
      "17:0101" : "17:0101 (17:101 Copyright Infringement)",
      "17:0501" : "17:0501 (17:501 Copyright Infringement)",
      "17:0504" : "17:0504 (17:504 Copyright Infringement)",
      "18:0241" : "18:0241 (18:241 Conspiracy Against Citizen Rights)",
      "18:1836a" : "18:1836a (18:1836(a) Injunction against Misappropriation of Trade Secrets)",
      "18:1836b" : "18:1836b (18:1836(b) Civil Action to Protect Trade Secrets)",
      "18:1961" : "18:1961 (18:1961 Racketeering (RICO) Act)",
      "18:1962" : "18:1962 (18:1962 Racketeering (RICO) Act)",
      "18:1964" : "18:1964 (18:1964 Racketeering (RICO) Act)",
      "18:4208" : "18:4208 (18:4208(B) Agency Action Review)",
      "19:1305" : "19:1305 (19:1305 Custom Duties:0Forfeiture-Immoral Articles)",
      "20:1080" : "20:1080 (20:1080 Student Loan Recovery)",
      "20:1400" : "20:1400 (20:1400 Civil Rights of Handicapped Child)",
      "20:1401" : "20:1401 (20:1401 Education: Handicapped Child Act)",
      "21:0841" : "21:0841 (21:841 Forfeiture Property-Drugs)",
      "21:0881" : "21:0881 (21:881 Forfeiture Property-Drugs)",
      "21:0881a" : "21:0881a (21:881 Forfeiture Property - Aircraft)",
      "21:0881re" : "21:0881re (21:881 Forfeiture Property - Real Estate)",
      "23:0134" : "23:0134 (23:134 P.I.- Auto Negligence)",
      "23:1441" : "23:1441 (23:1441 Contract Real Estate)",
      "24:1000" : "24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)",
      "25:0640" : "25:0640 (25:640 Indian Tribal Rights)",
      "25:1901" : "25:1901 (25:1901 Indian Child Welfare Act)",
      "25:2701" : "25:2701 (Indian Gaming Regulatory Act)",
      "25:2710" : "25:2710 (25:2710 Indian Gaming Regulatory Act)",
      "26:6212" : "26:6212 (26:6212 Injunctive Relief from IRS Lien)",
      "26:6213" : "26:6213 (26:6213 Injunctive Relief from IRS Lien)",
      "26:6502" : "26:6502 (26:6502 IRS:Enforcement of tax liens)",
      "26:6532" : "26:6532 (26:6532 IRS: Refund of Tax Penalty)",
      "26:6702" : "26:6702 (26:6702 IRS: Refund of Income Tax Penalty)",
      "26:6703" : "26:6703 (26:6703 IRS: Refund of Tax Penalty)",
      "26:7401" : "26:7401 (26:7401 IRS: Tax Liability)",
      "26:7402" : "26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)",
      "26:7403" : "26:7403 (26:7403 Suit to Enforce Federal Tax Lien)",
      "26:7422rt" : "26:7422rt (26:7422 IRS: Refund Taxes)",
      "26:7422rx" : "26:7422rx (26:7422 IRS: Refund Excise Tax)",
      "26:7426" : "26:7426 (26:7426 IRS: Wrongful Levy for Taxes)",
      "26:7429" : "26:7429 (26:7429 IRS: Tax Jeopardy Assessment)",
      "26:7609" : "26:7609 (26:7609 IRS: Petition to Quash IRS Summons)",
      "27:0185" : "27:0185 (27:185 Enforcement of Arbitration Award)",
      "28:0157c" : "28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)",
      "28:0157d" : "28:0157d (28:0157 Motion for Withdrawal of Reference)",
      "28:0158" : "28:0158 (28:0158 Notice of Appeal re Bankruptcy Matter (BAP))",
      "28:0185" : "28:0185 (28:185 Suit to Compel Arbitration)",
      "28:0451" : "28:0451 (28:451 Employment Discrimination)",
      "28:0794" : "28:0794 (28:794 Rehabilitation Act)",
      "28:1001" : "28:1001 (28:1001 E.R.I.S.A.)",
      "28:1132" : "28:1132 (28:1132 E.R.I.S.A.)",
      "28:1330" : "28:1330 (28:1330 Breach of Contract)",
      "28:1331" : "28:1331 (28:1331 Fed. Question)",
      "28:1331al" : "28:1331al (28:1331 Fed. Question: Airline Crash)",
      "28:1331at" : "28:1331at (28:1331 Fed. Question: Anti-trust)",
      "28:1331au" : "28:1331au (28:1331 Fed. Question: Auto Negligence)",
      "28:1331b" : "28:1331b (28:1331 Federal Question: Bivens Act)",
      "28:1331bc" : "28:1331bc (28:1331 Fed. Question: Breach of Contract)",
      "28:1331ca" : "28:1331ca (28:1331 Fed Question: Fed Communications Act of 1934)",
      "28:1331cm" : "28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)",
      "28:1331cv" : "28:1331cv (28:1331 Federal Question: Other Civil Rights)",
      "28:1331ed" : "28:1331ed (28:1331 Fed. Question: Employment Discrimination)",
      "28:1331es" : "28:1331es (28:1331 Enforcement of Administrative Subpoena)",
      "28:1331fl" : "28:1331fl (28:1331 Fed. Question: Fair Labor Standards)",
      "28:1331in" : "28:1331in (28:1331 Fed. Question: Insurance Contract)",
      "28:1331mm" : "28:1331mm (28:1331 Fed. Question: Medical Malpractice)",
      "28:1331pi" : "28:1331pi (28:1331 Fed. Question: Personal Injury)",
      "28:1331rd" : "28:1331rd (28:1331 Fed. Question: Review Agency Decision)",
      "28:1331rp" : "28:1331rp (28:1331(a) Fed. Question: Real Property)",
      "28:1331rr" : "28:1331rr (28:1331 Fed. Question: Railway Labor Act)",
      "28:1331sv" : "28:1331sv (28:1331 Fed. Question: Securities Violation)",
      "28:1331tr" : "28:1331tr (28:1331 Fed. Question: Trademark)",
      "28:1331tt" : "28:1331tt (28:1331 Fed. Question: Tort Action)",
      "28:1331v" : "28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendment)",
      "28:1331wl" : "28:1331wl (28:1331 Federal Question: EPA Waste Lien)",
      "28:1331wt" : "28:1331wt (28:1331 Fed. Question: Water Rights)",
      "28:1332ac" : "28:1332ac (28:1332 Diversity-Account Receivable)",
      "28:1332al" : "28:1332al (28:1332 Diversity-Airline Crash)",
      "28:1332as" : "28:1332as (28:1332 Diversity-Asbestos Litigation)",
      "28:1332au" : "28:1332au (28:1332 Diversity-Auto Negligence)",
      "28:1332bc" : "28:1332bc (28:1332 Diversity-Breach of Contract)",
      "28:1332co" : "28:1332co (28:1332 Diversity-Conversion)",
      "28:1332ct" : "28:1332ct (28:1332 Diversity-(Citizenship))",
      "28:1332det" : "28:1332det (28:1332 Diversity: Forcible Detainer)",
      "28:1332df" : "28:1332df (28:1332 Diversity-Contract Default)",
      "28:1332ds" : "28:1332ds (28:1332 Diversity-Contract Dispute)",
      "28:1332ed" : "28:1332ed (28:1332 Diversity-Employment Discrimination)",
      "28:1332fd" : "28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)",
      "28:1332fr" : "28:1332fr (28:1332 Diversity-Fraud)",
      "28:1332ia" : "28:1332ia (28:1332 Diversity-Interpleader Action)",
      "28:1332ij" : "28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)",
      "28:1332in" : "28:1332in (28:1332 Diversity-Insurance Contract)",
      "28:1332jd" : "28:1332jd (28:1332 Diversity-Declaratory Judgement)",
      "28:1332lb" : "28:1332lb (28:1332 Diversity-Libel,Assault,Slander)",
      "28:1332lm" : "28:1332lm (28:1332 Diversity - Legal Malpractice)",
      "28:1332ma" : "28:1332ma (28:1332 Diversity-Miller Act)",
      "28:1332mm" : "28:1332mm (28:1332 Diversity-Medical Malpractice)",
      "28:1332mv" : "28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)",
      "28:1332ni" : "28:1332ni (28:1332 Diversity-Negotiable Instrument)",
      "28:1332nm" : "28:1332nm (28:1332 Diversity-Non-Motor Vehicle)",
      "28:1332oc" : "28:1332oc (28:1332 Diversity-Other Contract)",
      "28:1332pd" : "28:1332pd (28:1332 Diversity-Property Damage)",
      "28:1332pi" : "28:1332pi (28:1332 Diversity-Personal Injury)",
      "28:1332pl" : "28:1332pl (28:1332 Diversity-Product Liability)",
      "28:1332pr" : "28:1332pr (28:1332 Diversity-Petition for Removal)",
      "28:1332qt" : "28:1332qt (28:1332 Diversity-Petition to Quiet Title)",
      "28:1332ri" : "28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)",
      "28:1332sa" : "28:1332sa (28:1332 - Diversity: Securities & Exchange Commission Act)",
      "28:1332sf" : "28:1332sf (28:1332 - Diversity: Securities Fraud)",
      "28:1332ss" : "28:1332ss (28:1332 Diversity - Stockholders Suits)",
      "28:1332tl" : "28:1332tl (28:1332 Diversity-Torts to Land)",
      "28:1332tm" : "28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))",
      "28:1332tn" : "28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)",
      "28:1332wd" : "28:1332wd (28:1332 Diversity-Wrongful Death)",
      "28:1333" : "28:1333 (28:1333 Admiralty)",
      "28:1334" : "28:1334 (28:1334 Bankruptcy Appeal)",
      "28:1334c" : "28:1334c (28:1334(c) R&R re motions for abstention (non-core))",
      "28:1335" : "28:1335 (28:1335 Interpleader Action)",
      "28:1337" : "28:1337 (28:1337 Sherman-Clayton Act)",
      "28:1338cp" : "28:1338cp (28:1338 Copyright Infringement)",
      "28:1338pt" : "28:1338pt (28:1338 Patent Infringement)",
      "28:1338tr" : "28:1338tr (28:1338 Trademark Infringement)",
      "28:1340" : "28:1340 (28:1340 IRS: Custom Duties)",
      "28:1340er" : "28:1340er (28:1340 Recovery of Erroneous Refund)",
      "28:1341" : "28:1341 (28:1341 Complaint for Forfeiture)",
      "28:1343" : "28:1343 (28:1343 Violation of Civil Rights)",
      "28:1345co" : "28:1345co (28:1345 Replevin & Conversion)",
      "28:1345db" : "28:1345db (28:1345 Debt to US - FHA/HUD Title I)",
      "28:1345df" : "28:1345df (28:1345 Default of Promissory Note)",
      "28:1345er" : "28:1345er (28:1345 Recovery of Erroneous Refund)",
      "28:1345fc" : "28:1345fc (28:1345 Foreclosure)",
      "28:1345ff" : "28:1345ff (28:1345 Complaint for Forfeiture)",
      "28:1345hl" : "28:1345hl (28:1345 VA Home Loan Guaranty Debt)",
      "28:1345mc" : "28:1345mc (28:1345 Medical Care Recovery)",
      "28:1345mi" : "28:1345mi (28:1345 Mining Claim Ejectment)",
      "28:1345pd" : "28:1345pd (28:1345 Property Damage)",
      "28:1345pe" : "28:1345pe (28:1345 Property Ejectment)",
      "28:1345rc" : "28:1345rc (28:1345 Recovery of Debt to US)",
      "28:1345st" : "28:1345st (28:1345 Default of Student Loan)",
      "28:1345tp" : "28:1345tp (28:1345 Trespass on Public Land)",
      "28:1345va" : "28:1345va (28:1345 Recovery of VA Overpayment)",
      "28:1346bc" : "28:1346bc (28:1346 Breach of Contract)",
      "28:1346rc" : "28:1346rc (28:1346 Recovery of IRS Tax)",
      "28:1346tc" : "28:1346tc (28:1346 Tort Claim)",
      "28:1346wd" : "28:1346wd (28:1346 Wrongful Death)",
      "28:1352" : "28:1352 (28:1352 Miller Act)",
      "28:1355" : "28:1355 (28:1355 Petition for Return of Property)",
      "28:1358" : "28:1358 (28:1358 Land Condemnation)",
      "28:1361" : "28:1361 (28:1361 Petition for Writ of Mandamus)",
      "28:1362ic" : "28:1362ic (28:1362 Indian Tribal Controversy)",
      "28:1362iw" : "28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)",
      "28:1364" : "28:1364 (28:1364 Auto Negligence)",
      "28:1391" : "28:1391 (28:1391 Personal Injury)",
      "28:1402" : "28:1402 (28:1402 Medical Malpractice)",
      "28:1407" : "28:1407 (28:1407 Airline Crash)",
      "28:1441ac" : "28:1441ac (28:1441 Petition for Removal- Account Receivable)",
      "28:1441al" : "28:1441al (28:1441 Petition for Removal- Airline Crash)",
      "28:1441as" : "28:1441as (28:1441 Petition for Removal- Asbestos Litigation)",
      "28:1441au" : "28:1441au (28:1441 Petition for Removal- Auto Negligence)",
      "28:1441bc" : "28:1441bc (28:1441 Petition for Removal- Breach of Contract)",
      "28:1441cv" : "28:1441cv (28:1441 Petition for Removal- Civil Rights Act)",
      "28:1441df" : "28:1441df (28:1441 Petition for Removal- Contract Default)",
      "28:1441dj" : "28:1441dj (28:1441 Petition for Removal- Declaratory Judgement)",
      "28:1441ds" : "28:1441ds (28:1441 Petition for Removal- Contract Dispute)",
      "28:1441ed" : "28:1441ed (28:1441 Petition for Removal - Employment Discrimination)",
      "28:1441fc" : "28:1441fc (28:1441 Petition for Removal - Fair Credit Reporting Act)",
      "28:1441fr" : "28:1441fr (28:1441 Petition for Removal- Fraud)",
      "28:1441ij" : "28:1441ij (28:1441 Petition for Removal- Injunctive/Declaratory Relief)",
      "28:1441in" : "28:1441in (28:1441 Petition for Removal- Insurance Contract)",
      "28:1441int" : "28:1441int (28:1441 Petition for Removal- Action for Interpleader)",
      "28:1441lb" : "28:1441lb (28:1441 Petition for Removal Libel,Assault,Slander)",
      "28:1441lm" : "28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relations)",
      "28:1441mm" : "28:1441mm (28:1441 Petition for Removal- Medical Malpractice)",
      "28:1441ni" : "28:1441ni (28:1441 Petition for Removal- Negotiable Instrument)",
      "28:1441nm" : "28:1441nm (28:1441 Petition for Removal- Non-Motor Vehicle)",
      "28:1441oc" : "28:1441oc (28:1441 Petition For Removal--Other Contract)",
      "28:1441pd" : "28:1441pd (28:1441 Petition for Removal- Property Damage)",
      "28:1441pi" : "28:1441pi (28:1441 Petition for Removal- Personal Injury)",
      "28:1441pl" : "28:1441pl (28:1441 Petition for Removal- Product Liability)",
      "28:1441pr" : "28:1441pr (28:1441 Petition for Removal)",
      "28:1441qt" : "28:1441qt (28:1441 Petition for Removal- Petition to Quiet Title)",
      "28:1441ri" : "28:1441ri (28:1441 Petition for Removal- Racketeering (RICO) Act)",
      "28:1441sa" : "28:1441sa (28:1441 - Petition for Removal: SEC Act)",
      "28:1441sf" : "28:1441sf (28:1441 - Petition for Removal: Securities Fraud)",
      "28:1441tl" : "28:1441tl (28:1441 Petition for Removal- Torts to Land)",
      "28:1441tm" : "28:1441tm (28:1441 Petition for Removal- Tort/Motor Vehicle (P.I.))",
      "28:1441tn" : "28:1441tn (28:1441 Petition for Removal- Tort/Non-Motor Vehicle)",
      "28:1441wd" : "28:1441wd (28:1441 Petition for Removal- Wrongful Death)",
      "28:1442bc" : "28:1442bc (28:1442 Petition for Removal- Breach of Contract)",
      "28:1442pr" : "28:1442pr (28:1442 Petition for Removal)",
      "28:1443" : "28:1443 (28:1443(1) Rent, Lease & Ejectment)",
      "28:1444" : "28:1444 (28:1444 Petition for Removal- Foreclosure)",
      "28:1446in" : "28:1446in (28:1446 Breach of Contract- Insurance)",
      "28:1446pd" : "28:1446pd (28:1446 Petition for Removal- Property Damage (P.I.))",
      "28:1446pi" : "28:1446pi (28:1446 Petition for Removal- Personal Injury)",
      "28:1446pl" : "28:1446pl (28:1446pl Petition for Removal - Product Liability)",
      "28:1446pr" : "28:1446pr (28:1446 Petition for Removal)",
      "28:1452" : "28:1452 (28:1452 R&R re motions to remand (non-core))",
      "28:1651" : "28:1651 (28:1651 Petition for Writ of Coram Nobis)",
      "28:1651a" : "28:1651a (All Writs Act)",
      "28:1651hc" : "28:1651hc (28:1651 Petition for Writ of Habeas Corpus)",
      "28:1651mn" : "28:1651mn (28:1651 Petition for Writ of Mandamus)",
      "28:1983" : "28:1983 (28:1983 Civil Rights)",
      "28:2201" : "28:2201 (28:2201 Constitutionality of State Statute(s))",
      "28:2201dj" : "28:2201dj (28:2201 Declaratory Judgement)",
      "28:2201ij" : "28:2201ij (28:2201 Injunction)",
      "28:2201in" : "28:2201in (28:2201 Declaratory Judgement (Insurance))",
      "28:2241" : "28:2241 (28:2241 Petition for Writ of Habeas Corpus (federal))",
      "28:2254" : "28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))",
      "28:2254se" : "28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)",
      "28:2255" : "28:2255 (28:2255 Motion to Vacate / Correct Illegal Sentence)",
      "28:2271" : "28:2271 (28:2271 Federal Tort Claims Act)",
      "28:2345" : "28:2345 (28:2345 Medicare Recovery)",
      "28:2409" : "28:2409 (28:2409(a) Quiet Title Action)",
      "28:2410" : "28:2410 (28:2410 Quiet Title)",
      "28:2671" : "28:2671 (28:2671 Federal Tort Claims Act)",
      "28:2674" : "28:2674 (28:2674 Federal Tort Claims Act)",
      "28:7402" : "28:7402 (28:7402 Refund of Taxes)",
      "28:7422" : "28:7422 (28:7422 Appeal from Administrative Decision)",
      "29:0151" : "29:0151 (29:151 Labor: Review of Agency Action)",
      "29:0160" : "29:0160 (29:160(1) National Labor Relations Act)",
      "29:0184" : "29:0184 (29:184 Violation Collection Bargain Agreement)",
      "29:0185ep" : "29:0185ep (29:185 Employee Pension Plan)",
      "29:0185lm" : "29:0185lm (29:185 Labor/Mgt. Relations (Contracts))",
      "29:0201do" : "29:0201do (29:201 Denial of Overtime Compensation)",
      "29:0201fl" : "29:0201fl (29:201 Fair Labor Standards Act)",
      "29:0203" : "29:0203 (29:203 Equal Pay Act)",
      "29:0206" : "29:0206 (29:206 Collect Unpaid Wages)",
      "29:0401" : "29:0401 (29:0401 Labor Management Disclosure Act)",
      "29:0621" : "29:0621 (29:621 Job Discrimination (Age))",
      "29:0623" : "29:0623 (29:623 Job Discrimination (Age))",
      "29:0626" : "29:0626 (29:626 Job Discrimination (Age))",
      "29:0633" : "29:0633 (29:633 Job Discrimination (Age))",
      "29:0651" : "29:0651 (29:651 Occupational Safety/Health)",
      "29:0754" : "29:0754 (29:754 Discrimination)",
      "29:0791" : "29:0791 (29:791 Job Discrimination (Rehabilitation Act))",
      "29:0794" : "29:0794 (29:0794 Job Discrimination (Handicap))",
      "29:1001" : "29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)",
      "29:1002" : "29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)",
      "29:1104" : "29:1104 (29:1104 Recovery of Benefits to Employee)",
      "29:1109" : "29:1109 (29:1109 Breach of Fiduciary Duties)",
      "29:1131" : "29:1131 (29:1131 ERISA - Collection of Delinquent Trust Funds)",
      "29:1132" : "29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)",
      "29:1145" : "29:1145 (29:1145 E.R.I.S.A.)",
      "29:1149" : "29:1149 (29:1149 Recover Pension & Profit Sharing)",
      "29:1337" : "29:1337 (29:1337 E.R.I.S.A.)",
      "29:1362" : "29:1362 (29:1362 ERISA)",
      "29:1381" : "29:1381 (29:1381 E.R.I.S.A.)",
      "29:1401" : "29:1401 (29:1401(b)(2) Appeal of Arbitration Award)",
      "29:1451" : "29:1451 (29:1451 E.R.I.S.A.)",
      "29:1801" : "29:1801 (29:1801 Farmworker Rights)",
      "29:790" : "29:790 (29:790 Rehabilitation of Labor)",
      "30:0181" : "30:0181 (30:181 Environment: Review of Agency Action)",
      "30:0801" : "30:0801 (30:0801 Penalities/Federal Mine Safety Health Act - 1977)",
      "30:1201" : "30:1201 (30:1201 Environment: Review of Agency Action)",
      "30:1202" : "30:1202 (30:1202 Mining Reclamation Act)",
      "30:1276" : "30:1276 (30:1276 Interior: Review of Agency Action)",
      "31:3545" : "31:3545 (31:3545 Action to Recovery Money)",
      "31:3729" : "31:3729 (31:3729 False Claims Act)",
      "31:3730" : "31:3730 (31:3730 Qui Tam False Claims Act)",
      "31:3731" : "31:3731 (31:3731 Fraud)",
      "33:1319cw" : "33:1319cw (33:1319 Clean Water Act)",
      "33:1319pv" : "33:1319pv (33:1319 Pollutants & Permit Violations)",
      "33:1365" : "33:1365 (33:1365 Environmental Matters)",
      "35:0145" : "35:0145 (35:145 Patent Infringement)",
      "35:0183" : "35:0183 (35:183 Patent Infringement)",
      "35:0271" : "35:0271 (35:271 Patent Infringement)",
      "38:1681" : "38:1681 (38:1681 Recovery of VA Overpayment)",
      "38:1686" : "38:1686 (38:1686 Recovery of VA Overpayment)",
      "38:1780" : "38:1780 (38:1780 Recovery of VA Overpayment)",
      "38:2011" : "38:2011 (38:2011 - Veteran's Readjustment Assistance Act of 1974)",
      "38:2022" : "38:2022 (38:2022 Veterans' Re-employment Rights Act of 1988)",
      "38:3116" : "38:3116 (38:3116 VA Overpayment)",
      "39:3005" : "39:3005 (39:3005 Detention of Mail for Temporary Periods)",
      "39:409" : "39:409 (39:409 Postal Service)",
      "40:0258" : "40:0258 (40:258(a) Public Buildings & Property: Land Condemnation)",
      "40:0270" : "40:0270 (40:270 Miller Act)",
      "40:0875" : "40:0875 (40:875 Public Buildings & Property: Negligence)",
      "41:0251" : "41:0251 (41:251 Public Contracts-Review of Agency Action)",
      "41:1463" : "41:1463 (41:1463 Public Contracts: Unlawful Employment Practices)",
      "42:0205" : "42:0205 (42:205 Denial Social Security Benefits)",
      "42:0206" : "42:0206 (42:206 Social Security Benefits)",
      "42:0247" : "42:0247 (42:247 Personal Injury-Swine Flu)",
      "42:0402" : "42:0402 (42:402 Social Security Benefits)",
      "42:0405id" : "42:0405id (42:405 Review of HHS Decision (SSID))",
      "42:0405wc" : "42:0405wc (42:405 Review of HHS Decision (DIWC))",
      "42:0405ww" : "42:0405ww (42:405 Review of HHS Decision (DIWW))",
      "42:0416" : "42:0416 (42:416 Denial of Social Security Benefits)",
      "42:0427" : "42:0427 (42:427 Social Security Benefits)",
      "42:12102" : "42:12102 (42:12102 Americans With Disabilities Act)",
      "42:1383" : "42:1383 (42:1383 Review of HHS Decision)",
      "42:1395" : "42:1395 (42:1395 HHS: Adverse Reimbursement Review)",
      "42:1395dd" : "42:1395dd (42:1395dd(d)(2)(A) Emergency Medical Treatment & Labor Act)",
      "42:1396" : "42:1396 (42:1396 - Tort Negligence)",
      "42:1471" : "42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclosure Sale)",
      "42:1981cv" : "42:1981cv (42:1981 Civil Rights)",
      "42:1981hs" : "42:1981hs (42:1981 Housing Discrimination)",
      "42:1981jb" : "42:1981jb (42:1981 Job Discrimination (Race))",
      "42:1981sx" : "42:1981sx (42:1981 Sex Discrimination)",
      "42:1983cv" : "42:1983cv (42:1983 Civil Rights Act)",
      "42:1983ed" : "42:1983ed (42:1983 Civil Rights (Employment Discrimination))",
      "42:1983pr" : "42:1983pr (42:1983 Prisoner Civil Rights)",
      "42:1986" : "42:1986 (42:1986 Neglect of Duty)",
      "42:2000ag" : "42:2000ag (42:2000 Job Discrimination (Age))",
      "42:2000e" : "42:2000e (42:2000e Job Discrimination (Employment))",
      "42:2000pb" : "42:2000pb (42:2000 Job Discrimination (Public Accomodations))",
      "42:2000ra" : "42:2000ra (42:2000 Job Discrimination (Race))",
      "42:2000sx" : "42:2000sx (42:2000 Job Discrimination (Sex))",
      "42:2003" : "42:2003 (42:2003 Job Discrimination)",
      "42:2005" : "42:2005 (42:2005 Review of Agency Action-HHS)",
      "42:2651" : "42:2651 (42:2651 Medical Care Recovery)",
      "42:3601" : "42:3601 (42:405 Fair Housing Act)",
      "42:4000" : "42:4000 (42:4000 National Flood Insurance Act)",
      "42:4001" : "42:4001 (42:4001 National Insurance Flood Act)",
      "42:4053" : "42:4053 (42:4053 Breach of Insurance Contract)",
      "42:4072" : "42:4072 (42:4072 Payment of Flood Insurance Claim)",
      "42:4321" : "42:4321 (42:4321 Review of Agency Action-Environment)",
      "42:4332" : "42:4332 (42:4332 Environmental Policy - Coop of Agency Reports)",
      "42:6901en" : "42:6901en (42:6901 Environmental Cleanup Expenses)",
      "42:6901rs" : "42:6901rs (42:6901 Resource & Recovery Act)",
      "42:7413" : "42:7413 (42:7413(b) Clean Air Act)",
      "42:7604cl" : "42:7604cl (42:7604 Clean Air Act (Emission Standards))",
      "42:7604ir" : "42:7604ir (42:7604 Petition to Quash IRS Summons)",
      "42:9607" : "42:9607 (42:9607 Real Property Tort to Land)",
      "43:945" : "43:945 (43:945 Compensation for Land Condemnation)",
      "43:945a" : "43:945a (43:945a Complaint in Condemnation)",
      "43:946" : "43:946 (43:946 Complaint in Condemnation - Eminent Domain)",
      "45:0051" : "45:0051 (45:51 Railways: Fed. Employer's Liability Act)",
      "45:0151" : "45:0151 (45:151 Railway Labor Act)",
      "45:0184" : "45:0184 (45:184 Action to Set Aside Award of a System Board of Adjust)",
      "45:1395" : "45:1395 (45:1395 Railroads: Adverse Reimbursement Review)",
      "45:7457" : "45:7457 (Compel Reclamation Under Clean Air Act)",
      "46:0688" : "46:0688 (46:688 Jones Act)",
      "46:0741" : "46:0741 (46:741 Shipping)",
      "46:0761" : "46:0761 (46:761 Shipping: Damages for Death on High Seas)",
      "46:1101" : "46:1101 (46:1101 Violation of Maritime Regulations)",
      "46:1156" : "46:1156 (46:1156 Administrative Procedure Act)",
      "48:0883" : "48:0883 (48:883 Violation of US Coastal Law)",
      "48:1985" : "48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)",
      "49:0081" : "49:0081 (49:81 Damaged Goods While Being Transported)",
      "49:0781" : "49:0781 (49:781 Forfeiture)",
      "49:11503" : "49:11503 (49:11503 Railroad Revitalization Regulatory Reform Act)",
      "49:11702" : "49:11702 (49:11702(a)(4) Violations of Interstate Commerce Act)",
      "49:1471" : "49:1471 (49:1471 Federal Aviation Act)",
      "49:1903" : "49:1903 (49:1903 Petition to enforce administrative summons)",
      "8:287" : "8:287 (8:287 Petition to Enforce INS Subpoena)",
      "misc" : "misc (Civil Miscellaneous Case)"
   },
   "ncedce" : {
      "0" : "0 (no cause specified)",
      "02:0431" : "02:0431 (02:431 Fed. Election Commission: Failure Enforce Compliance)",
      "02:0437" : "02:0437 (02:437 Federal Election Commission)",
      "05:0075" : "05:0075 (05:75(2) Contract - Reduction in Grade)",
      "05:0551" : "05:0551 (05:551 Administrative Procedure Act)",
      "05:0552fi" : "05:0552fi (05:552 Freedom of Information Act)",
      "05:0552pa" : "05:0552pa (05:552 Right to Privacy Act)",
      "05:0554" : "05:0554 (05:0554 Constitutionality of Maritime Statutes)",
      "05:0701" : "05:0701 (05:0701 Maritime Subsidy Board)",
      "05:0702" : "05:0702 (05:702 Administrative Procedure Act)",
      "05:0704" : "05:0704 (05:704 Labor Litigation)",
      "05:7703" : "05:7703 (05:7703 Discrimination - Review of Agency Act)",
      "05:8470" : "05:8470 (05:8470 Enforcement of Judgment Against Retirement Benefits)",
      "07:0006" : "07:0006 (7:6(b) Federal Commodity Exchange Regulation)",
      "07:0025" : "07:0025 (7:25 Fraud - Commodities Leverage Contracts)",
      "07:0181" : "07:0181 (07:181 Packers & Stockyard Act)",
      "07:0499" : "07:0499 (07:499 Agricultural Commodities Act)",
      "07:0601" : "07:0601 (07:601 USDA Condemnation)",
      "07:2321" : "07:2321 (07:2321 Plant Variety Protection Act)",
      "08:1105" : "08:1105 (8:1105(a) Aliens: Habeas Corpus to Release INS Detainee)",
      "08:1182" : "08:1182 (08:1182 Defend. Denial of Pla. Appl. for Alien Employ. Cer)",
      "08:1252" : "08:1252 (08:1252(a)(2) Injunction for Deportation)",
      "08:1260" : "08:1260 (08:1260 Aliens: Access to Records)",
      "08:1324" : "08:1324 (08:1324 Aliens: Complaint for Forfeiture)",
      "08:1329" : "08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petition)",
      "08:1446" : "08:1446 (8:1446 Petition for Naturalization Hearing)",
      "08:1451(j)" : "08:1451(j) (08:1451(j) Motion to Correct Order & Judg. of Naturalization)",
      "09:0001" : "09:0001 (09:1 U.S. Arbitration Act)",
      "09:0009" : "09:0009 (9:9 Motion to Confirm Arbitration Loan)",
      "09:0010" : "09:0010 (09:0010 Petition to Vacate Arbitration Award)",
      "10:1408" : "10:1408 (10:1408 Claim for Military Retirement)",
      "10:1552" : "10:1552 (10:1552 Armed Forces: Action to Correct Records)",
      "10:1553" : "10:1553 (10:1553 Armed Forces: FOIA General)",
      "10:2305" : "10:2305 (10:2305 Review of Federal Contract)",
      "11:0101" : "11:0101 (11:101 Bankruptcy)",
      "12:0022" : "12:0022 (12:22 Securities Fraud)",
      "12:0635" : "12:0635 (12:635 Breach of Insurance Contract)",
      "12:1461" : "12:1461 (12:1461 Homeowners Loan Act)",
      "12:1464" : "12:1464 (12:1464 Federal Savings and Loan)",
      "12:1703" : "12:1703 (12:1703 Default of HUD Loan)",
      "12:1725" : "12:1725 (12:1725 Collection under Contract Guaranty)",
      "12:1730" : "12:1730 (12:1730 Collection Under Contract Guaranty)",
      "12:1819" : "12:1819 (12:1819 Default of Promissory Note)",
      "12:1821" : "12:1821 (12:1821 Default of Loan by Promissary Note)",
      "12:191" : "12:191 (12:191 Bank Forclosure)",
      "12:192" : "12:192 (12:192 Liquidation of National Bank)",
      "12:1971" : "12:1971 (12:1971 Relief under Bank Holding Act)",
      "12:1972" : "12:1972 (12:1972 Typing Arrangement Act)",
      "12:3410" : "12:3410 (12:3410 Right to Financial Privacy Act)",
      "15:0001" : "15:0001 (15:1 Antitrust Litigation)",
      "15:0002at" : "15:0002at (15:2 Antitrust Litigation)",
      "15:0002fl" : "15:0002fl (15:2(a) Fair Labor Standards Act)",
      "15:0005" : "15:0005 (15:5(a) Fair Labor Standards Act)",
      "15:0015" : "15:0015 (15:15 Antitrust Litigation)",
      "15:0025" : "15:0025 (15:25 Clayton Act)",
      "15:0044" : "15:0044 (15:44 Trademark Infringement)",
      "15:0045" : "15:0045 (15:0045 Federal Trade Commission Act)",
      "15:0052" : "15:0052 (15:0052 Federal Trade Commission Act)",
      "15:0053" : "15:0053 (15:0053 Federal Trade Commission Act)",
      "15:0077" : "15:0077 (15:77 Securities Fraud)",
      "15:0078" : "15:0078 (15:78m(a) Securities Exchange Act)",
      "15:0631" : "15:0631 (15:631 Small Business Act)",
      "15:0717" : "15:0717 (15:717 Natural Gas Act)",
      "15:0754" : "15:0754 (15:754 Emergency Petroleum Allocation-Admin.& Enforcement)",
      "15:1051" : "15:1051 (15:1051 Trademark Infringement)",
      "15:1114" : "15:1114 (15:1114 Trademark Infringement)",
      "15:1121" : "15:1121 (15:1121 Trademark Infringement)",
      "15:1125" : "15:1125 (15:1125 Trademark Infringement (Lanham Act))",
      "15:1126" : "15:1126 (15:1126 Patent Infringement)",
      "15:1127" : "15:1127 (15:1127 Trademark Infringement)",
      "15:1601" : "15:1601 (15:1601 Truth in Lending)",
      "15:1640" : "15:1640 (15:1640 Truth in Lending)",
      "15:1681" : "15:1681 (15:1681 Fair Credit Reporting Act)",
      "15:1691" : "15:1691 (15:1691 Equal Credit Opportunity Act)",
      "15:1692" : "15:1692 (15:1692 Fair Debt Collection Act)",
      "15:1701" : "15:1701 (15:1701 Interstate Land Sales Full Disclosure Act)",
      "15:1938" : "15:1938 (15:1938 Fair Labor Standards Act)",
      "15:1981" : "15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))",
      "15:1988" : "15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))",
      "15:1989" : "15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))",
      "15:2301" : "15:2301 (15:2301 Magnuson-Moss Warranty Act)",
      "15:2801" : "15:2801 (15:2801 Petroleum Marketing Practices Act)",
      "15:53(b)" : "15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equita)",
      "16:0668" : "16:0668 (16:668 Bald Eagle Protection Act)",
      "16:0703" : "16:0703 (16:703 Migratory Bird Act)",
      "16:1538" : "16:1538 (16:1538 Endangered Species Act)",
      "16:3371" : "16:3371 (16:3371 Wildlife Under the Lacey Act)",
      "16:3372" : "16:3372 (16:3372 Conservation: Complaint for Forfeiture)",
      "16:3373" : "16:3373 (16:3373 Appeal of Decision - DOI)",
      "16:3374" : "16:3374 (16:3374 Conservation: Complaint for Forfeiture)",
      "17:0101" : "17:0101 (17:101 Copyright Infringement)",
      "17:0501" : "17:0501 (17:501 Copyright Infringement)",
      "17:0504" : "17:0504 (17:504 Copyright Infringement)",
      "18:0241" : "18:0241 (18:241 Conspiracy Against Citizen Rights)",
      "18:0492" : "18:0492 (Counterfeit Forfeiture)",
      "18:0924" : "18:0924 (18:0924 Forfeiture Property - Firearm)",
      "18:1514" : "18:1514 (18:1514 Harassment of a Witness)",
      "18:1961" : "18:1961 (18:1961 Racketeering (RICO) Act)",
      "18:1962" : "18:1962 (18:1962 Racketeering (RICO) Act)",
      "18:1964" : "18:1964 (18:1964 Racketeering (RICO) Act)",
      "18:2511" : "18:2511 (18:2511 Wiretapping)",
      "18:3114" : "18:3114 (18:3114 Motion for Return of Seized Property)",
      "18:4208" : "18:4208 (18:4208(B) Agency Action Review)",
      "18:4241" : "18:4241 (18:4241 Motion to Determine Mental Competency/Other Dist.)",
      "18:4248" : "18:4248 (18:4248 Civil Commitment of a Sexually Dangerous Person)",
      "18:981" : "18:981 (18:981 Civil Forfeiture)",
      "19:1305" : "19:1305 (19:1305 Custom Duties: Forfeiture-Immoral Articles)",
      "20:1080" : "20:1080 (20:1080 Student Loan Recovery)",
      "20:1400" : "20:1400 (20:1400 Civil Rights of Handicapped Child)",
      "20:1401" : "20:1401 (20:1401 Education: Handicapped Child Act)",
      "20:1415" : "20:1415 (20:1415 Individuals with Disabilities Education Act)",
      "20:1415e4" : "20:1415e4 (20:1415(e)(4) Action for attorney fees and costs under IDEA)",
      "21:0841" : "21:0841 (21:841 Forfeiture Property-Drugs)",
      "21:0881" : "21:0881 (21:881 Forfeiture Property-Drugs)",
      "21:0881a" : "21:0881a (21:881 Forfeiture Property - Aircraft)",
      "21:0881re" : "21:0881re (21:881 Forfeiture Property - Real Estate)",
      "23:0134" : "23:0134 (23:134 P.I.- Auto Negligence)",
      "23:1441" : "23:1441 (23:1441 Contract Real Estate)",
      "24:1000" : "24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)",
      "25:0640" : "25:0640 (25:640 Indian Tribal Rights)",
      "25:1901" : "25:1901 (25:1901 Indian Child Welfare Act)",
      "26:6212" : "26:6212 (26:6212 Injunctive Relief from IRS Lien)",
      "26:6213" : "26:6213 (26:6213 Injunctive Relief from IRS Lien)",
      "26:6502" : "26:6502 (26:6502 IRS:Enforcement of tax liens)",
      "26:6532" : "26:6532 (26:6532 IRS: Refund of Tax Penalty)",
      "26:6702" : "26:6702 (26:6702 IRS: Refund of Income Tax Penalty)",
      "26:6703" : "26:6703 (26:6703 IRS: Refund of Tax Penalty)",
      "26:7401" : "26:7401 (26:7401 IRS: Tax Liability)",
      "26:7402" : "26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)",
      "26:7403" : "26:7403 (26:7403 Suit to Enforce Federal Tax Lien)",
      "26:7422rt" : "26:7422rt (26:7422 IRS: Refund Taxes)",
      "26:7422rx" : "26:7422rx (26:7422 IRS: Refund Excise Tax)",
      "26:7426" : "26:7426 (26:7426 IRS: Wrongful Levy for Taxes)",
      "26:7429" : "26:7429 (26:7429 IRS: Tax Jeopardy Assessment)",
      "26:7609" : "26:7609 (26:7609 IRS: Petition to Quash IRS Summons)",
      "27:0185" : "27:0185 (27:185 Enforcement of Arbitration Award)",
      "28:0157c" : "28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)",
      "28:0157d" : "28:0157d (28:0157 Motion for Withdrawal of Reference)",
      "28:0158" : "28:0158 (28:0158 Bankruptcy Appeal from Judgment/Order)",
      "28:0185" : "28:0185 (28:185 Suit to Compel Arbitration)",
      "28:0451" : "28:0451 (28:451 Employment Discrimination)",
      "28:0754" : "28:0754 (28:754 Receiver of Property in Different Districts)",
      "28:0794" : "28:0794 (28:794 Rehabilitation Act)",
      "28:1001" : "28:1001 (28:1001 E.R.I.S.A.)",
      "28:1132" : "28:1132 (28:1132 E.R.I.S.A.)",
      "28:1292" : "28:1292 (28:1292 Personal Injury on Navigable Waters)",
      "28:1330" : "28:1330 (28:1330 Breach of Contract)",
      "28:1331" : "28:1331 (28:1331 Fed. Question)",
      "28:1331al" : "28:1331al (28:1331 Fed. Question: Airline Crash)",
      "28:1331at" : "28:1331at (28:1331 Fed. Question: Anti-trust)",
      "28:1331au" : "28:1331au (28:1331 Fed. Question: Auto Negligence)",
      "28:1331b" : "28:1331b (28:1331 Federal Question: Bivens Act)",
      "28:1331bc" : "28:1331bc (28:1331 Fed. Question: Breach of Contract)",
      "28:1331ca" : "28:1331ca (28:1331 Fed Question: Fed Communications Act of 1)",
      "28:1331cm" : "28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)",
      "28:1331cv" : "28:1331cv (28:1331 Fed. Question: Civil Rights Violation)",
      "28:1331ed" : "28:1331ed (28:1331 Fed. Question: Employment Discrimination)",
      "28:1331ej" : "28:1331ej (28:1331 Federal Question: Enforcement of Judgment)",
      "28:1331es" : "28:1331es (28:1331 Enforcement of Administrative Subpoena)",
      "28:1331fl" : "28:1331fl (28:1331 Fed. Question: Fair Labor Standards)",
      "28:1331in" : "28:1331in (28:1331 Fed. Question: Insurance Contract)",
      "28:1331mm" : "28:1331mm (28:1331 Fed. Question: Medical Malpractice)",
      "28:1331ng" : "28:1331ng (28:1331 Fed. Question: Natural Gas Act)",
      "28:1331pi" : "28:1331pi (28:1331 Fed. Question: Personal Injury)",
      "28:1331rd" : "28:1331rd (28:1331 Fed. Question: Review Agency Decision)",
      "28:1331rp" : "28:1331rp (28:1331(a) Fed. Question: Real Property)",
      "28:1331rr" : "28:1331rr (28:1331 Fed. Question: Railway Labor Act)",
      "28:1331sv" : "28:1331sv (28:1331 Fed. Question: Securities Violation)",
      "28:1331tr" : "28:1331tr (28:1331 Fed. Question: Trademark)",
      "28:1331tt" : "28:1331tt (28:1331 Fed. Question: Tort Action)",
      "28:1331v" : "28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendment)",
      "28:1331wl" : "28:1331wl (28:1331 Federal Question: EPA Waste Lien)",
      "28:1331wt" : "28:1331wt (28:1331 Fed. Question: Water Rights)",
      "28:1332ac" : "28:1332ac (28:1332 Diversity-Account Receivable)",
      "28:1332al" : "28:1332al (28:1332 Diversity-Airline Crash)",
      "28:1332as" : "28:1332as (28:1332 Diversity-Asbestos Litigation)",
      "28:1332au" : "28:1332au (28:1332 Diversity-Auto Negligence)",
      "28:1332bc" : "28:1332bc (28:1332 Diversity-Breach of Contract)",
      "28:1332co" : "28:1332co (28:1332 Diversity-Conversion)",
      "28:1332ct" : "28:1332ct (28:1332 Diversity-(Citizenship))",
      "28:1332det" : "28:1332det (28:1332 Diversity: Forcible Detainer)",
      "28:1332df" : "28:1332df (28:1332 Diversity-Contract Default)",
      "28:1332ds" : "28:1332ds (28:1332 Diversity-Contract Dispute)",
      "28:1332ed" : "28:1332ed (28:1322 Diversity-Employment Discrimination)",
      "28:1332fd" : "28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)",
      "28:1332fr" : "28:1332fr (28:1332 Diversity-Fraud)",
      "28:1332ia" : "28:1332ia (28:1332 Diversity-Interpleader Action)",
      "28:1332ij" : "28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)",
      "28:1332in" : "28:1332in (28:1332 Diversity-Insurance Contract)",
      "28:1332jd" : "28:1332jd (28:1332 Declaratory Judgment)",
      "28:1332lb" : "28:1332lb (28:1332 Diversity-Libel,Assault,Slander)",
      "28:1332lm" : "28:1332lm (28:1332 Diversity - Legal Malpractice)",
      "28:1332ma" : "28:1332ma (28:1332 Diversity-Miller Act)",
      "28:1332mm" : "28:1332mm (28:1332 Diversity-Medical Malpractice)",
      "28:1332mv" : "28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)",
      "28:1332ni" : "28:1332ni (28:1332 Diversity-Negotiable Instrument)",
      "28:1332nm" : "28:1332nm (28:1332 Diversity-Non-Motor Vehicle)",
      "28:1332nr" : "28:1332nr (28:1332 Diversity-Petition for Removal)",
      "28:1332oc" : "28:1332oc (28:1332 Diversity-Other Contract)",
      "28:1332pd" : "28:1332pd (28:1332 Diversity-Property Damage)",
      "28:1332pi" : "28:1332pi (28:1332 Diversity-Personal Injury)",
      "28:1332pl" : "28:1332pl (28:1332 Diversity-Product Liability)",
      "28:1332pr" : "28:1332pr (28:1332 Diversity-Petition for Removal)",
      "28:1332qt" : "28:1332qt (28:1332 Diversity-Petition to Quiet Title)",
      "28:1332ri" : "28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)",
      "28:1332sa" : "28:1332sa (28:1332 - Diversity: Securities & Exchange Commiss)",
      "28:1332sf" : "28:1332sf (28:1332 - Diversity: Securities Fraud)",
      "28:1332ss" : "28:1332ss (28:1332 Diversity - Stockholders Suits)",
      "28:1332tl" : "28:1332tl (28:1332 Diversity-Torts to Land)",
      "28:1332tm" : "28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))",
      "28:1332tn" : "28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)",
      "28:1332wd" : "28:1332wd (28:1332 Diversity-Wrongful Death)",
      "28:1333" : "28:1333 (28:1333 Admiralty)",
      "28:1334" : "28:1334 (28:1334 Bankruptcy Appeal)",
      "28:1334c" : "28:1334c (28:1334(c) R&R re motions for abstention (non-cor)",
      "28:1335" : "28:1335 (28:1335 Interpleader Action)",
      "28:1337" : "28:1337 (28:1337 Sherman-Clayton Act)",
      "28:1338cp" : "28:1338cp (28:1338 Copyright Infringement)",
      "28:1338pt" : "28:1338pt (28:1338 Patent Infringement)",
      "28:1338tr" : "28:1338tr (28:1338 Trademark Infringement)",
      "28:1340" : "28:1340 (28:1340 IRS: Custom Duties)",
      "28:1340er" : "28:1340er (28:1340 Recovery of Erroneous Refund)",
      "28:1341" : "28:1341 (28:1341 Complaint for Forfeiture)",
      "28:1343" : "28:1343 (28:1343 Violation of Civil Rights)",
      "28:1345" : "28:1345 (28:1345 USA Plaintiff)",
      "28:1345co" : "28:1345co (28:1345 Replevin & Conversion)",
      "28:1345db" : "28:1345db (28:1345 Debt to US - FHA/HUD Title I)",
      "28:1345df" : "28:1345df (28:1345 Default of Promissory Note)",
      "28:1345er" : "28:1345er (28:1345 Recovery of Erroneous Refund)",
      "28:1345fc" : "28:1345fc (28:1345 Foreclosure)",
      "28:1345ff" : "28:1345ff (28:1345 Complaint for Forfeiture)",
      "28:1345hl" : "28:1345hl (28:1345 VA Home Loan Guaranty Debt)",
      "28:1345mc" : "28:1345mc (28:1345 Medical Care Recovery)",
      "28:1345mi" : "28:1345mi (28:1345 Mining Claim Ejectment)",
      "28:1345pd" : "28:1345pd (28:1345 Property Damage)",
      "28:1345pe" : "28:1345pe (28:1345 VA Property Ejectment)",
      "28:1345rc" : "28:1345rc (28:1345 Recovery of Debt to US)",
      "28:1345st" : "28:1345st (28:1345 Default of Student Loan)",
      "28:1345tp" : "28:1345tp (28:1345 Trespass on Public Land)",
      "28:1345va" : "28:1345va (28:1345 Recovery of VA Overpayment)",
      "28:1346" : "28:1346 (28:1346 Breach of Contract)",
      "28:1346bc" : "28:1346bc (28:1346 Breach of Contract)",
      "28:1346rc" : "28:1346rc (28:1346 Recovery of IRS Tax)",
      "28:1346tc" : "28:1346tc (28:1346 Tort Claim)",
      "28:1346wd" : "28:1346wd (28:1346 Wrongful Death)",
      "28:1349" : "28:1349 (28:1348 Corporation organized under Federal Law as party)",
      "28:1352" : "28:1352 (28:1352 Miller Act)",
      "28:1355" : "28:1355 (28:1355 Petition for Return of Property)",
      "28:1358" : "28:1358 (28:1358 Land Condemnation)",
      "28:1361" : "28:1361 (28:1361 Petition for Writ of Mandamus)",
      "28:1362ic" : "28:1362ic (28:1362 Indian Tribal Controversy)",
      "28:1362iw" : "28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)",
      "28:1364" : "28:1364 (28:1364 Auto Negligence)",
      "28:1391" : "28:1391 (28:1391 Personal Injury)",
      "28:1402" : "28:1402 (28:1402 Medical Malpractice)",
      "28:1407" : "28:1407 (28:1407 Airline Crash)",
      "28:1441ac" : "28:1441ac (28:1441 Notice of Removal- Account Receivable)",
      "28:1441al" : "28:1441al (28:1441 Notice of Removal- Airline Crash)",
      "28:1441as" : "28:1441as (28:1441 Notice of Removal- Asbestos Litigation)",
      "28:1441au" : "28:1441au (28:1441 Notice of Removal- Auto Negligence)",
      "28:1441bc" : "28:1441bc (28:1441 Notice of Removal- Breach of Contract)",
      "28:1441cv" : "28:1441cv (28:1441 Petition for Removal- Civil Rights Act)",
      "28:1441df" : "28:1441df (28:1441 Notice of Removal- Contract Default)",
      "28:1441dj" : "28:1441dj (28:1441 Notice of Removal- Declaratory Judgment)",
      "28:1441ds" : "28:1441ds (28:1441 Notice of Removal- Contract Dispute)",
      "28:1441ed" : "28:1441ed (28:1441 Petition for Removal - Employment Discrim)",
      "28:1441fc" : "28:1441fc (28:1441 Petition for Removal - Fair Credit Reporti)",
      "28:1441fr" : "28:1441fr (28:1441 Notice of Removal- Fraud)",
      "28:1441ij" : "28:1441ij (28:1441 Notice of Removal- Injunctive/Declaratory Relief)",
      "28:1441in" : "28:1441in (28:1441 Notice of Removal- Insurance Contract)",
      "28:1441int" : "28:1441int (28:1441 Petition for Removal- Action for Interplea)",
      "28:1441lb" : "28:1441lb (28:1441 Notice of Removal- Libel,Assault,Slander)",
      "28:1441lm" : "28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relatio)",
      "28:1441mm" : "28:1441mm (28:1441 Notice of Removal- Medical Malpractice)",
      "28:1441ni" : "28:1441ni (28:1441 Notice of Removal- Negotiable Instrument)",
      "28:1441nm" : "28:1441nm (28:1441 Notice of Removal- Non-Motor Vehicle)",
      "28:1441nr" : "28:1441nr (28:1441 Notice of Removal)",
      "28:1441oc" : "28:1441oc (28:1441 Petition For Removal--Other Contract)",
      "28:1441pd" : "28:1441pd (28:1441 Notice of Removal- Property Damage)",
      "28:1441pi" : "28:1441pi (28:1441 Notice of Removal- Personal Injury)",
      "28:1441pl" : "28:1441pl (28:1441 Notice of Removal- Product Liability)",
      "28:1441pr" : "28:1441pr (28:1441 Petition for Removal)",
      "28:1441qt" : "28:1441qt (28:1441 Notice of Removal- Petition to Quiet Title)",
      "28:1441ri" : "28:1441ri (28:1441 Petition for Removal- Racketeering (RICO))",
      "28:1441sa" : "28:1441sa (28:1441 - Petition for Removal: SEC Act)",
      "28:1441sf" : "28:1441sf (28:1441 - Petition for Removal: Securities Fraud)",
      "28:1441tl" : "28:1441tl (28:1441 Notice of Removal- Torts to Land)",
      "28:1441tm" : "28:1441tm (28:1441 Notice of Removal- Tort/Motor Vehicle (P.I.))",
      "28:1441tn" : "28:1441tn (28:1441 Notice of Removal- Tort/Non-Motor Vehicle)",
      "28:1441wd" : "28:1441wd (28:1441 Notice of Removal- Wrongful Death)",
      "28:1442bc" : "28:1442bc (28:1442 Notice of Removal- Breach of Contract)",
      "28:1442nr" : "28:1442nr (28:1442 Notice of Removal)",
      "28:1442pr" : "28:1442pr (28:1442 Petition for Removal)",
      "28:1443" : "28:1443 (28:1443(1) Rent, Lease & Ejectment)",
      "28:1444" : "28:1444 (28:1444 Notice of Removal- Foreclosure)",
      "28:1446in" : "28:1446in (28:1446 Breach of Contract- Insurance)",
      "28:1446nr" : "28:1446nr (28:1446 Notice of Removal)",
      "28:1446pd" : "28:1446pd (28:1446 Notice of Removal- Property Damage (P.I.))",
      "28:1446pi" : "28:1446pi (28:1446 Notice of Removal- Personal Injury)",
      "28:1446pl" : "28:1446pl (28:1446pl Petition for Removal - Product Liability)",
      "28:1446pr" : "28:1446pr (28:1446 Petition for Removal)",
      "28:1452" : "28:1452 (28:1452 Removal of Claim in Civil Action Related to BK. Case)",
      "28:1651" : "28:1651 (28:1651 Petition for Writ of Coram Nobis)",
      "28:1651hc" : "28:1651hc (28:1651 Petition for Writ of Habeas Corpus)",
      "28:1651mn" : "28:1651mn (28:1651 Petition for Writ of Mandamus)",
      "28:1782" : "28:1782 (28:1782 Letter rogatory - appointment)",
      "28:1983" : "28:1983 (28:1983 Civil Rights)",
      "28:2201" : "28:2201 (28:2201 Constitutionality of State Statute(s))",
      "28:2201dj" : "28:2201dj (28:2201 Declaratory Judgment)",
      "28:2201ij" : "28:2201ij (28:2201 Injunction)",
      "28:2201in" : "28:2201in (28:2201 Declaratory Judgment (Insurance))",
      "28:2241" : "28:2241 (28:2241 Petition for Writ of Habeas Corpus (Federal))",
      "28:2254" : "28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))",
      "28:2254se" : "28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)",
      "28:2255" : "28:2255 (28:2255 Motion to Vacate Sentence)",
      "28:2271" : "28:2271 (28:2271 Federal Tort Claims Act)",
      "28:2345" : "28:2345 (28:2345 Medicare Recovery)",
      "28:2409" : "28:2409 (28:2409(a) Quiet Title Action)",
      "28:2410" : "28:2410 (28:2410 Actions - Property on which U.S. had lien)",
      "28:2671" : "28:2671 (28:2671 Federal Tort Claims Act)",
      "28:2674" : "28:2674 (28:2674 Federal Tort Claims Act)",
      "28:3001" : "28:3001 (28:3001 Federal Debt Collection Act)",
      "28:7402" : "28:7402 (28:7402 Refund of Taxes)",
      "28:7422" : "28:7422 (28:7422 Appeal from Administrative Decision)",
      "29:0151" : "29:0151 (29:151 Labor: Review of Agency Action)",
      "29:0160" : "29:0160 (29:160(1) National Labor Relations Act)",
      "29:0184" : "29:0184 (29:184 Violation Collection Bargain Agreement)",
      "29:0185ep" : "29:0185ep (29:185 Employee Pension Plan)",
      "29:0185lm" : "29:0185lm (29:185 Labor/Mgt. Relations (Contracts))",
      "29:0201do" : "29:0201do (29:201 Denial of Overtime Compensation)",
      "29:0201fl" : "29:0201fl (29:201 Fair Labor Standards Act)",
      "29:0203" : "29:0203 (29:203 Equal Pay Act)",
      "29:0206" : "29:0206 (29:206 Collect Unpaid Wages)",
      "29:0401" : "29:0401 (29:0401 Labor Management Disclosure Act)",
      "29:0621" : "29:0621 (29:621 Job Discrimination (Age))",
      "29:0623" : "29:0623 (29:623 Job Discrimination (Age))",
      "29:0626" : "29:0626 (29:626 Job Discrimination (Age))",
      "29:0633" : "29:0633 (29:633 Job Discrimination (Age))",
      "29:0651" : "29:0651 (29:651 Occupational Safety/Health)",
      "29:0754" : "29:0754 (29:754 Discrimination)",
      "29:0791" : "29:0791 (29:791 Job Discrimination (Rehabilitation Act))",
      "29:0794" : "29:0794 (29:0794 Job Discrimination (Handicap))",
      "29:1001" : "29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)",
      "29:1002" : "29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)",
      "29:1104" : "29:1104 (29:1104 Recovery of Benefits to Employee)",
      "29:1109" : "29:1109 (29:1109 Breach of Fiduciary Duties)",
      "29:1131" : "29:1131 (29:1131 ERISA - Collection of Delinquent Trust Funds)",
      "29:1132" : "29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)",
      "29:1145" : "29:1145 (29:1145 E.R.I.S.A.)",
      "29:1149" : "29:1149 (29:1149 Recover Pension & Profit Sharing)",
      "29:1337" : "29:1337 (29:1337 E.R.I.S.A.)",
      "29:1362" : "29:1362 (29:1362 ERISA)",
      "29:1381" : "29:1381 (29:1381 E.R.I.S.A.)",
      "29:1401" : "29:1401 (29:1401(b)(2) Appeal of Arbitration Award)",
      "29:1451" : "29:1451 (29:1451 E.R.I.S.A.)",
      "29:1801" : "29:1801 (29:1801 Farmworker Rights)",
      "29:2001" : "29:2001 (29:2001 Employee Polygraph Protection)",
      "29:2601" : "29:2601 (29:2601 The Family and Medical Leave Act of 1993)",
      "29:790" : "29:790 (29:790 Rehabilitation of Labor)",
      "30:0181" : "30:0181 (30:181 Environment: Review of Agency Action)",
      "30:0801" : "30:0801 (30:0801 Penalities/Federal Mine Safety Health Act)",
      "30:1201" : "30:1201 (30:1201 Environment: Review of Agency Action)",
      "30:1202" : "30:1202 (30:1202 Mining Reclamation Act)",
      "30:1276" : "30:1276 (30:1276 Interior: Review of Agency Action)",
      "31:3545" : "31:3545 (31:3545 Action to Recovery Money)",
      "31:3729" : "31:3729 (31:3729 False Claims Act)",
      "31:3730" : "31:3730 (31:3730 Qui Tam False Claims Act)",
      "31:3731" : "31:3731 (31:3731 Fraud)",
      "33:1319cw" : "33:1319cw (33:1319 Clean Water Act)",
      "33:1319pv" : "33:1319pv (33:1319 Pollutants & Permit Violations)",
      "33:1365" : "33:1365 (33:1365 Environmental Matters)",
      "35:0145" : "35:0145 (35:145 Patent Infringement)",
      "35:0183" : "35:0183 (35:183 Patent Infringement)",
      "35:0271" : "35:0271 (35:271 Patent Infringement)",
      "38:1681" : "38:1681 (38:1681 Recovery of VA Overpayment)",
      "38:1686" : "38:1686 (38:1686 Recovery of VA Overpayment)",
      "38:1780" : "38:1780 (38:1780 Recovery of VA Overpayment)",
      "38:1801" : "38:1801 (38:1801 Recovery of VA Loan Guaranty Payment)",
      "38:2011" : "38:2011 (38:2011 - Veteran's Readjustment Assistance Act of)",
      "38:2021" : "38:2021 (38:2021 Right to Re-employment of inducted persons)",
      "38:3116" : "38:3116 (38:3116 VA Overpayment)",
      "38:4301" : "38:4301 (38:4301 Uniformed Services Employment and Reemployment Rights Act of 1994)",
      "38:775" : "38:775 (38:775 Recov. of Servicemen's Group Life Ins.)",
      "39:3005" : "39:3005 (39:3005 Detention of Mail for Temporary Periods)",
      "39:409" : "39:409 (39:409 Postal Service)",
      "40:0258" : "40:0258 (40:258(a) Public Buildings & Property: Land Condemnation)",
      "40:0270" : "40:0270 (40:270 Miller Act)",
      "40:0875" : "40:0875 (40:875 Public Buildings & Property: Negligence)",
      "41:0251" : "41:0251 (41:251 Public Contracts-Review of Agency Action)",
      "41:1463" : "41:1463 (41:1463 Public Contracts: Unlawful Employment Practices)",
      "42:0205" : "42:0205 (42:205 Denial Social Security Benefits)",
      "42:0206" : "42:0206 (42:206 Social Security Benefits)",
      "42:0247" : "42:0247 (42:247 Personal Injury-Swine Flu)",
      "42:0402" : "42:0402 (42:402 Social Security Benefits)",
      "42:0405id" : "42:0405id (42:405 Review of HHS Decision (SSID))",
      "42:0405ri" : "42:0405ri (42:405 review of HHS Decision (RI))",
      "42:0405wc" : "42:0405wc (42:405 Review of HHS Decision (DIWC))",
      "42:0405ww" : "42:0405ww (42:405 Review of HHS Decision (DIWW))",
      "42:0416" : "42:0416 (42:416 Denial of Social Security Benefits)",
      "42:0427" : "42:0427 (42:427 Social Security Benefits)",
      "42:11601" : "42:11601 (42:11601 International Child Abduction Remedies Act)",
      "42:12101" : "42:12101 (42:12101 The Americans with Disabilities Act of 1990)",
      "42:1383" : "42:1383 (42:1383 Review of HHS Decision)",
      "42:1395" : "42:1395 (42:1395 HHS: Adverse Reimbursement Review)",
      "42:1395dd" : "42:1395dd (42:1395dd Emergency Medical Treatment and Active Labor Act)",
      "42:1396" : "42:1396 (42:1396 - Tort Negligence)",
      "42:1471" : "42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclo)",
      "42:1981cv" : "42:1981cv (42:1981 Civil Rights)",
      "42:1981hs" : "42:1981hs (42:1981 Housing Discrimination)",
      "42:1981jb" : "42:1981jb (42:1981 Job Discrimination (Race))",
      "42:1981sx" : "42:1981sx (42:1981 Sex Discrimination)",
      "42:1983cv" : "42:1983cv (42:1983 Civil Rights Act)",
      "42:1983ed" : "42:1983ed (42:1983 Civil Rights (Employment Discrimination))",
      "42:1983pr" : "42:1983pr (42:1983 Prisoner Civil Rights)",
      "42:1985" : "42:1985 (42:1985 Conspiracy to interfere with Civil Rights)",
      "42:1986" : "42:1986 (42:1986 Neglect of Duty)",
      "42:2000ag" : "42:2000ag (42:2000 Job Discrimination (Age))",
      "42:2000e" : "42:2000e (42:2000e Job Discrimination (Employment))",
      "42:2000pb" : "42:2000pb (42:2000 Job Discrimination (Public Accommodations))",
      "42:2000ra" : "42:2000ra (42:2000 Job Discrimination (Race))",
      "42:2000sx" : "42:2000sx (42:2000 Job Discrimination (Sex))",
      "42:2003" : "42:2003 (42:2003 Job Discrimination)",
      "42:2005" : "42:2005 (42:2005 Review of Agency Action-HHS)",
      "42:2651" : "42:2651 (42:2651 Medical Recovery Act)",
      "42:3601" : "42:3601 (42:405 Fair Housing Act)",
      "42:4000" : "42:4000 (42:4000 National Flood Insurance Act)",
      "42:4001" : "42:4001 (42:4001 National Flood Insurance Act)",
      "42:4053" : "42:4053 (42:4053 Breach of Insurance Contract)",
      "42:4072" : "42:4072 (42:4072 Payment of Flood Insurance Claim)",
      "42:4321" : "42:4321 (42:4321 Review of Agency Action-Environment)",
      "42:4332" : "42:4332 (42:4332)",
      "42:6901en" : "42:6901en (42:6901 Environmental Cleanup Expenses)",
      "42:6901rs" : "42:6901rs (42:6901 Resource & Recovery Act)",
      "42:7413" : "42:7413 (42:7413(b) Clean Air Act)",
      "42:7604cl" : "42:7604cl (42:7604 Clear Air Act (Emission Standards))",
      "42:7604ir" : "42:7604ir (42:7604 Petition to Quash IRS Summons)",
      "42:9607" : "42:9607 (42:9607 Real Property Tort to Land)",
      "43:945" : "43:945 (43:945 Compensation for Land Condemnation)",
      "43:945a" : "43:945a (43:945a Complaint in Condemnation)",
      "43:946" : "43:946 (43:946 Complaint in Condemnation - Eminent Domain)",
      "45:0051" : "45:0051 (45:51 Railways: Fed. Employer's Liability Act)",
      "45:0151" : "45:0151 (45:151 Railway Labor Act)",
      "45:0184" : "45:0184 (45:184 Action to Set Aside Award of a System Board of Adjust)",
      "45:1395" : "45:1395 (45:1395 Railroads: Adverse Reimbursement Review)",
      "45:7457" : "45:7457 (45:7457 Compel Reclamation Under Clear Air Act)",
      "46:0688" : "46:0688 (46:688 Jones Act)",
      "46:0741" : "46:0741 (46:741 Shipping)",
      "46:0761" : "46:0761 (46:761 Shipping: Damages for Death on High Seas)",
      "46:1101" : "46:1101 (46:1101 Violation of Maritime Regulations)",
      "46:1156" : "46:1156 (46:1156 Administrative Procedure Act)",
      "46:183" : "46:183 (46:183 Limitation of Liability)",
      "46:688" : "46:688 (46:688 Jones Act)",
      "46:951" : "46:951 (46:951 Foreclosure of Preferred Mortgage)",
      "47*" : "47* ()",
      "47:222" : "47:222 (47:222 Telecommunications Act of 1996)",
      "47:521" : "47:521 (47:521 Cable Communications Policy Act of 1984)",
      "47:605" : "47:605 (47:605 Unauthorized publication or use of communications)",
      "48:0883" : "48:0883 (48:883 Violation of US Coastal Law)",
      "48:1985" : "48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)",
      "49:0081" : "49:0081 (49:81 Damaged Goods While Being Transported)",
      "49:0781" : "49:0781 (49:781 Forfeiture)",
      "49:11503" : "49:11503 (49:11503 Railroad Revitalization Regulatory Reform)",
      "49:11702" : "49:11702 (49:11702(a)(4) Violations of Interstate Commerce A)",
      "49:1471" : "49:1471 (49:1471 Federal Aviation Act)",
      "49:1903" : "49:1903 (49:1903 Petition to enforce administrative summon)",
      "8:287" : "8:287 (8:287 Petition to Enforce INS Subpoena)",
      "99:9999" : "99:9999 (99:9999 Report cause code (DO NOT DELETE!))",
      "adsup" : "adsup (Administrative Subpoena)",
      "contempt" : "contempt (Contempt Proceedings)",
      "disbar" : "disbar (Disbarment Proceedings)",
      "fordepo" : "fordepo (Foreign Deposition)",
      "misc" : "misc (Civil Miscellaneous Case)",
      "miscadmir" : "miscadmir (Misc. Admiralty)",
      "motcomp" : "motcomp (Motion to Compel)",
      "motquash" : "motquash (Motion to Quash)",
      "motret" : "motret (Motion for Return of Property)",
      "petenf" : "petenf (Petition to Enforce IRS Summons)",
      "petper" : "petper (Petition to Perpetuate Testimony)",
      "regjgm" : "regjgm (Registration of Foreign Judgment)",
      "tranbkref" : "tranbkref (Transmission of Bankruptcy Reference)",
      "tranff" : "tranff (Transmission of Proposed Findings of Fact and Concl. of Law)",
      "writgar" : "writgar (Application for a Writ of Garnishment)"
   },
   "ncmdce" : {
      "0" : "0 (no cause specified)",
      "02:0138" : "02:0138 (Library of Congress Access)",
      "02:0358" : "02:0358 (President's Recommendations on Exec., Jud. & Leg. Salary)",
      "02:0431" : "02:0431 (02:431 Fed. Election Commission: Failure Enforce Compliance)",
      "02:0437" : "02:0437 (02:437 Federal Election Commission)",
      "02:0681" : "02:0681 (Deferral of Budget Authority)",
      "02:1202" : "02:1202 (Discriminatory practices affecting US Senate employees)",
      "02:1301" : "02:1301 (Congressional Accountability Act)",
      "02:1317(a)" : "02:1317(a) (Violation of Congressional Accountability Act)",
      "05:0075" : "05:0075 (05:75(2) Contract - Reduction in Grade)",
      "05:0551" : "05:0551 (05:551 Administrative Procedure Act)",
      "05:0552fi" : "05:0552fi (05:552 Freedom of Information Act)",
      "05:0552pa" : "05:0552pa (05:552 Right to Privacy Act)",
      "05:0554" : "05:0554 (05:0554 Constitutionality of Maritime Statutes)",
      "05:0701" : "05:0701 (05:0701 Maritime Subsidy Board)",
      "05:0702" : "05:0702 (05:702 Administrative Procedure Act)",
      "05:0704" : "05:0704 (05:704 Labor Litigation)",
      "05:7101" : "05:7101 (05:7101 Management & Employee Relations)",
      "05:7703" : "05:7703 (05:7703 Discrimination - Review of Agency Act)",
      "05:8470" : "05:8470 (05:8470 Enforcement of Judgment against Retirement Benefits)",
      "07:0006" : "07:0006 (7:6(b) Federal Commodity Exchange Regulation)",
      "07:0025" : "07:0025 (7:25 Fraud - Commodities Leverage Contracts)",
      "07:0181" : "07:0181 (07:181 Packers & Stockyard Act)",
      "07:0499" : "07:0499 (07:499 Agricultural Commodities Act)",
      "07:0601" : "07:0601 (07:601 USDA Condemnation)",
      "07:2023" : "07:2023 (07:2023 Review of USDA Decision - Food Stamps)",
      "07:2321" : "07:2321 (07:2321 Plant Variety Protection Act)",
      "08:1105" : "08:1105 (8:1105(a) Aliens: Habeas Corpus to Release INS Detainee)",
      "08:1182" : "08:1182 (8:1182 Defend. Denial of Pla. Appl. for Alien Employment Cer)",
      "08:1252" : "08:1252 (08:1252(a)(2) Injunction for Deportation)",
      "08:1260" : "08:1260 (08:1260 Aliens: Access to Records)",
      "08:1324" : "08:1324 (08:1324 Aliens: Complaint for Forfeiture)",
      "08:1329" : "08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petition)",
      "08:1446" : "08:1446 (8:1446 Petition for Naturalization Hearing)",
      "08:1451(j)" : "08:1451(j) (8:1451(j) Motion to Correct Order & Judg. of Naturalization)",
      "09:0001" : "09:0001 (09:1 U.S. Arbitration Act)",
      "09:0009" : "09:0009 (09:0009 Motion to Confirm Arbitration)",
      "09:0010" : "09:0010 (09:0010 Petition to Vacate Arbitration Award)",
      "10:1408" : "10:1408 (10:1408 Claim for Military Retirement)",
      "10:1552" : "10:1552 (10:1552 Armed Forces: Action to Correct Records)",
      "10:1553" : "10:1553 (10:1553 Armed Forces: FOIA General)",
      "10:2005" : "10:2005 (10:2005 Reimbursement of Scholarship Funds)",
      "10:2305" : "10:2305 (10:2305 Review of Federal Contract)",
      "10:2733" : "10:2733 (10:2733 Armed Forces: Noncombat Activities-Personal Injury)",
      "11:0101" : "11:0101 (11:101 Bankruptcy)",
      "12:0022" : "12:0022 (12:22 Securities Fraud)",
      "12:0635" : "12:0635 (12:635 Breach of Insurance Contract)",
      "12:1461" : "12:1461 (12:1461 Homeowners Loan Act)",
      "12:1464" : "12:1464 (12:1464 Federal Savings and Loan)",
      "12:1703" : "12:1703 (12:1703 Default of HUD Loan)",
      "12:1715z-4" : "12:1715z-4 (12:1715z-4a Unauthorized use of multifam.hous.project assets)",
      "12:1725" : "12:1725 (12:1725 Collection under Contract Guaranty)",
      "12:1730" : "12:1730 (12:1730 Collection Under Contract Guaranty)",
      "12:1819" : "12:1819 (12:1819 Default of Promissory Note)",
      "12:1821" : "12:1821 (12:1821 Default of Loan by Promissory Note)",
      "12:191" : "12:191 (12:191 Bank Foreclosure)",
      "12:192" : "12:192 (12:192 Liquidation of National Bank)",
      "12:1971" : "12:1971 (12:1971 Relief under Bank Holding Act)",
      "12:1972" : "12:1972 (12:1972 Typing Arrangement Act)",
      "12:2601" : "12:2601 (12:2601 Real Estate Settlement Procedures Act)",
      "12:3410" : "12:3410 (12:3410 Right to Financial Privacy Act)",
      "15:0001" : "15:0001 (15:1 Antitrust Litigation)",
      "15:0002at" : "15:0002at (15:2 Antitrust Litigation)",
      "15:0002fl" : "15:0002fl (15:2(a) Fair Labor Standards Act)",
      "15:0005" : "15:0005 (15:5(a) Fair Labor Standards Act)",
      "15:0015" : "15:0015 (15:15 Antitrust Litigation)",
      "15:0025" : "15:0025 (15:25 Clayton Act)",
      "15:0044" : "15:0044 (15:44 Trademark Infringement)",
      "15:0045" : "15:0045 (15:0045 Federal Trade Commission Act)",
      "15:0052" : "15:0052 (15:0052 Federal Trade Commission Act)",
      "15:0053" : "15:0053 (15:0053 Federal Trade Commission Act)",
      "15:0077" : "15:0077 (15:77 Securities Fraud)",
      "15:0078" : "15:0078 (15:78m(a) Securities Exchange Act)",
      "15:0631" : "15:0631 (15:631 Small Business Act)",
      "15:0717" : "15:0717 (15:717 Natural Gas Act)",
      "15:0754" : "15:0754 (15:754 Emergency Petroleum Allocation-Admin.& Enforcement)",
      "15:1051" : "15:1051 (15:1051 Trademark Infringement)",
      "15:1114" : "15:1114 (15:1114 Trademark Infringement)",
      "15:1121" : "15:1121 (15:1121 Trademark Infringement)",
      "15:1125" : "15:1125 (15:1125 Trademark Infringement (Lanham Act))",
      "15:1126" : "15:1126 (15:1126 Patent Infringement)",
      "15:1127" : "15:1127 (15:1127 Trademark Infringement)",
      "15:1601" : "15:1601 (15:1601 Truth in Lending)",
      "15:1640" : "15:1640 (15:1640 Truth in Lending)",
      "15:1681" : "15:1681 (15:1681 Fair Credit Reporting Act)",
      "15:1692" : "15:1692 (15:1692 Fair Debt Collection Act)",
      "15:1693" : "15:1693 (15:1693 Electronic Fund Transfers Act)",
      "15:1938" : "15:1938 (15:1938 Fair Labor Standards Act)",
      "15:1981" : "15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))",
      "15:1988" : "15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))",
      "15:1989" : "15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))",
      "15:2301" : "15:2301 (15:2301 Magnuson-Moss Warranty Act)",
      "15:2801" : "15:2801 (15:2801 Petroleum Marketing Practices Act)",
      "15:53(b)" : "15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equita)",
      "16:0668" : "16:0668 (16:668 Bald Eagle Protection Act)",
      "16:0703" : "16:0703 (16:703 Migratory Bird Act)",
      "16:1538" : "16:1538 (16:1538 Endangered Species Act)",
      "16:3371" : "16:3371 (16:3371 Wildlife Under the Lacey Act)",
      "16:3372" : "16:3372 (16:3372 Conservation: Complaint for Forfeiture)",
      "16:3373" : "16:3373 (16:3373 Appeal of Decision - DOI)",
      "16:3374" : "16:3374 (16:3374 Conservation: Complaint for Forfeiture)",
      "17:0101" : "17:0101 (17:101 Copyright Infringement)",
      "17:0501" : "17:0501 (17:501 Copyright Infringement)",
      "17:0504" : "17:0504 (17:504 Copyright Infringement)",
      "18:0241" : "18:0241 (18:241 Conspiracy Against Citizen Rights)",
      "18:0981" : "18:0981 (18:0981 Civil Forfeiture - Gambling, etc.)",
      "18:1030" : "18:1030 (18:1030 Computer Fraud and Abuse Act)",
      "18:1514A" : "18:1514A (18:1514A Sarbanes-Oxley Act of 2002)",
      "18:1836a" : "18:1836a (18:1836(a) Injunction against Misappropriation of Trade Secrets)",
      "18:1836b" : "18:1836b (18:1836(b) Civil Action to Protect Trade Secrets)",
      "18:1955" : "18:1955 (18:1955 Forfeiture, Gambling)",
      "18:1957" : "18:1957 (18:1957 Monetary Transaction in Prop.Derive.from Unlaw.Activ)",
      "18:1961" : "18:1961 (18:1961 Racketeering (RICO) Act)",
      "18:1962" : "18:1962 (18:1962 Racketeering (RICO) Act)",
      "18:1964" : "18:1964 (18:1964 Racketeering (RICO) Act)",
      "18:2254" : "18:2254 (18:2254 Forfeiture-Materials Involv.Sexual Exploit.of Minors)",
      "18:2510" : "18:2510 (18:2510 Wire and Electronics Communications Act)",
      "18:2511" : "18:2511 (18:2511 Wiretapping)",
      "18:2701" : "18:2701 (18:2701 Electronics Communication Privacy Act)",
      "18:2707" : "18:2707 (18:2707 Illegal Disclosure of Electronic Comm. Svc. Records)",
      "18:3114" : "18:3114 (18:3114 Motion for Return of Seized Property)",
      "18:4208" : "18:4208 (18:4208(B) Agency Action Review)",
      "19:1305" : "19:1305 (19:1305 Custom Duties: Forfeiture-Immoral Articles)",
      "19:1603" : "19:1603 (19:1603 Seizure Without Prosecution [Rule 41(e)])",
      "19:1604" : "19:1604 (19:1604 Seizure With Prosecution [Rule 41(e)])",
      "20:1080" : "20:1080 (20:1080 Student Loan Recovery)",
      "20:1400" : "20:1400 (20:1400 Civil Rights of Handicapped Child)",
      "20:1401" : "20:1401 (20:1401 Education: Handicapped Child Act)",
      "21:0301" : "21:0301 (21:0301 Federal Food, Drug & Cosmetic Act)",
      "21:0342" : "21:0342 (21:0342 Forfeiture Property - Food)",
      "21:0841" : "21:0841 (21:841 Forfeiture Property-Drugs)",
      "21:0881" : "21:0881 (21:881 Forfeiture Property-Drugs)",
      "21:0881a" : "21:0881a (21:881 Forfeiture Property - Aircraft)",
      "21:0881re" : "21:0881re (21:881 Forfeiture Property - Real Estate)",
      "23:0134" : "23:0134 (23:134 P.I.- Auto Negligence)",
      "23:1441" : "23:1441 (23:1441 Contract Real Estate)",
      "24:1000" : "24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)",
      "25:0640" : "25:0640 (25:640 Indian Tribal Rights)",
      "25:1901" : "25:1901 (25:1901 Indian Child Welfare Act)",
      "26:6212" : "26:6212 (26:6212 Injunctive Relief from IRS Lien)",
      "26:6213" : "26:6213 (26:6213 Injunctive Relief from IRS Lien)",
      "26:6502" : "26:6502 (26:6502 IRS:Enforcement of tax liens)",
      "26:6532" : "26:6532 (26:6532 IRS: Refund of Tax Penalty)",
      "26:6702" : "26:6702 (26:6702 IRS: Refund of Income Tax Penalty)",
      "26:6703" : "26:6703 (26:6703 IRS: Refund of Tax Penalty)",
      "26:7401" : "26:7401 (26:7401 IRS: Tax Liability)",
      "26:7402" : "26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)",
      "26:7403" : "26:7403 (26:7403 Suit to Enforce Federal Tax Lien)",
      "26:7407" : "26:7407 (26:7407 IRS Civil Injunction)",
      "26:7422rt" : "26:7422rt (26:7422 IRS: Refund Taxes)",
      "26:7422rx" : "26:7422rx (26:7422 IRS: Refund Excise Tax)",
      "26:7426" : "26:7426 (26:7426 IRS: Wrongful Levy for Taxes)",
      "26:7429" : "26:7429 (26:7429 IRS: Tax Jeopardy Assessment)",
      "26:7431" : "26:7431 (26:7431 IRS: Civil Damages for Unauthorized Disclosure)",
      "26:7609" : "26:7609 (26:7609 IRS: Petition to Quash IRS Summons)",
      "27:0185" : "27:0185 (27:185 Enforcement of Arbitration Award)",
      "28:0157c" : "28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)",
      "28:0157d" : "28:0157d (28:0157 Motion for Withdrawal of Reference)",
      "28:0158" : "28:0158 (28:0158 Bankruptcy Appeal from Judgment/Order)",
      "28:0185" : "28:0185 (28:185 Suit to Compel Arbitration)",
      "28:0451" : "28:0451 (28:451 Employment Discrimination)",
      "28:0754" : "28:0754 (28:754 Receiver of Property in Different Districts)",
      "28:0794" : "28:0794 (28:794 Rehabilitation Act)",
      "28:1001" : "28:1001 (28:1001 E.R.I.S.A.)",
      "28:1132" : "28:1132 (28:1132 E.R.I.S.A.)",
      "28:1330" : "28:1330 (28:1330 Breach of Contract)",
      "28:1331" : "28:1331 (28:1331 Fed. Question)",
      "28:1331al" : "28:1331al (28:1331 Fed. Question: Airline Crash)",
      "28:1331at" : "28:1331at (28:1331 Fed. Question: Anti-trust)",
      "28:1331au" : "28:1331au (28:1331 Fed. Question: Auto Negligence)",
      "28:1331b" : "28:1331b (28:1331 Federal Question: Bivens Act)",
      "28:1331bc" : "28:1331bc (28:1331 Fed. Question: Breach of Contract)",
      "28:1331bv" : "28:1331bv (28:1331 Prisoner Bivens Action)",
      "28:1331ca" : "28:1331ca (28:1331 Fed Question: Fed Communications Act of 1)",
      "28:1331cm" : "28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)",
      "28:1331cv" : "28:1331cv (28:1331 Fed. Question: Civil Rights Violation)",
      "28:1331ed" : "28:1331ed (28:1331 Fed. Question: Employment Discrimination)",
      "28:1331ej" : "28:1331ej (28:1331 Federal Question: Enforcement of Judgment)",
      "28:1331es" : "28:1331es (28:1331 Enforcement of Administrative Subpoena)",
      "28:1331fl" : "28:1331fl (28:1331 Fed. Question: Fair Labor Standards)",
      "28:1331in" : "28:1331in (28:1331 Fed. Question: Insurance Contract)",
      "28:1331mm" : "28:1331mm (28:1331 Fed. Question: Medical Malpractice)",
      "28:1331ng" : "28:1331ng (28:1331 Fed. Question: Natural Gas Act)",
      "28:1331pd" : "28:1331pd (28:1331 Federal Question: Property Damage)",
      "28:1331pi" : "28:1331pi (28:1331 Fed. Question: Personal Injury)",
      "28:1331rd" : "28:1331rd (28:1331 Fed. Question: Review Agency Decision)",
      "28:1331rp" : "28:1331rp (28:1331(a) Fed. Question: Real Property)",
      "28:1331rr" : "28:1331rr (28:1331 Fed. Question: Railway Labor Act)",
      "28:1331sv" : "28:1331sv (28:1331 Fed. Question: Securities Violation)",
      "28:1331tr" : "28:1331tr (28:1331 Fed. Question: Trademark)",
      "28:1331tt" : "28:1331tt (28:1331 Fed. Question: Tort Action)",
      "28:1331v" : "28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendment)",
      "28:1331wl" : "28:1331wl (28:1331 Federal Question: EPA Waste Lien)",
      "28:1331wt" : "28:1331wt (28:1331 Fed. Question: Water Rights)",
      "28:1332" : "28:1332 (28:1332 Diversity)",
      "28:1332ac" : "28:1332ac (28:1332 Diversity-Account Receivable)",
      "28:1332al" : "28:1332al (28:1332 Diversity-Airline Crash)",
      "28:1332as" : "28:1332as (28:1332 Diversity-Asbestos Litigation)",
      "28:1332au" : "28:1332au (28:1332 Diversity-Auto Negligence)",
      "28:1332bc" : "28:1332bc (28:1332 Diversity-Breach of Contract)",
      "28:1332co" : "28:1332co (28:1332 Diversity-Conversion)",
      "28:1332ct" : "28:1332ct (28:1332 Diversity-(Citizenship))",
      "28:1332det" : "28:1332det (28:1332 Diversity: Forcible Detainer)",
      "28:1332df" : "28:1332df (28:1332 Diversity-Contract Default)",
      "28:1332ds" : "28:1332ds (28:1332 Diversity-Contract Dispute)",
      "28:1332ed" : "28:1332ed (28:1332 Diversity-Employment Discrimination)",
      "28:1332fd" : "28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)",
      "28:1332fr" : "28:1332fr (28:1332 Diversity-Fraud)",
      "28:1332ia" : "28:1332ia (28:1332 Diversity-Interpleader Action)",
      "28:1332ij" : "28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)",
      "28:1332in" : "28:1332in (28:1332 Diversity-Insurance Contract)",
      "28:1332jd" : "28:1332jd (28:1332 Diversity-Declaratory Judgment)",
      "28:1332lb" : "28:1332lb (28:1332 Diversity-Libel, Assault, Slander)",
      "28:1332lm" : "28:1332lm (28:1332 Diversity - Legal Malpractice)",
      "28:1332ma" : "28:1332ma (28:1332 Diversity-Miller Act)",
      "28:1332mm" : "28:1332mm (28:1332 Diversity-Medical Malpractice)",
      "28:1332mv" : "28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)",
      "28:1332ni" : "28:1332ni (28:1332 Diversity-Negotiable Instrument)",
      "28:1332nm" : "28:1332nm (28:1332 Diversity-Non-Motor Vehicle)",
      "28:1332nr" : "28:1332nr (28:1332 Diversity-Notice of Removal)",
      "28:1332oc" : "28:1332oc (28:1332 Diversity-Other Contract)",
      "28:1332pd" : "28:1332pd (28:1332 Diversity-Property Damage)",
      "28:1332pi" : "28:1332pi (28:1332 Diversity-Personal Injury)",
      "28:1332pl" : "28:1332pl (28:1332 Diversity-Product Liability)",
      "28:1332pr" : "28:1332pr (28:1332 Diversity-Petition for Removal)",
      "28:1332qt" : "28:1332qt (28:1332 Diversity-Petition to Quiet Title)",
      "28:1332ri" : "28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)",
      "28:1332sa" : "28:1332sa (28:1332 - Diversity: Securities & Exchange Commiss)",
      "28:1332sf" : "28:1332sf (28:1332 - Diversity: Securities Fraud)",
      "28:1332ss" : "28:1332ss (28:1332 Diversity - Stockholders Suits)",
      "28:1332tl" : "28:1332tl (28:1332 Diversity-Torts to Land)",
      "28:1332tm" : "28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))",
      "28:1332tn" : "28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)",
      "28:1332wd" : "28:1332wd (28:1332 Diversity-Wrongful Death)",
      "28:1333" : "28:1333 (28:1333 Admiralty)",
      "28:1334" : "28:1334 (28:1334 Bankruptcy Appeal)",
      "28:1334c" : "28:1334c (28:1334(c) R&R re motions for abstention (non-cor)",
      "28:1334jt" : "28:1334jt (28:1334 Bankruptcy Adversary Jury Trial)",
      "28:1335" : "28:1335 (28:1335 Interpleader Action)",
      "28:1337" : "28:1337 (28:1337 Sherman-Clayton Act)",
      "28:1338cp" : "28:1338cp (28:1338 Copyright Infringement)",
      "28:1338pt" : "28:1338pt (28:1338 Patent Infringement)",
      "28:1338tr" : "28:1338tr (28:1338 Trademark Infringement)",
      "28:1340" : "28:1340 (28:1340 IRS: Custom Duties)",
      "28:1340er" : "28:1340er (28:1340 Recovery of Erroneous Refund)",
      "28:1341" : "28:1341 (28:1341 Complaint for Forfeiture)",
      "28:1343" : "28:1343 (28:1343 Violation of Civil Rights)",
      "28:1345" : "28:1345 (28:1345 USA Plaintiff)",
      "28:1345co" : "28:1345co (28:1345 Replevin & Conversion)",
      "28:1345db" : "28:1345db (28:1345 Debt to US - FHA/HUD Title I)",
      "28:1345df" : "28:1345df (28:1345 Default of Promissory Note)",
      "28:1345er" : "28:1345er (28:1345 Recovery of Erroneous Refund)",
      "28:1345fc" : "28:1345fc (28:1345 Foreclosure)",
      "28:1345ff" : "28:1345ff (28:1345 Complaint for Forfeiture)",
      "28:1345hl" : "28:1345hl (28:1345 VA Home Loan Guaranty Debt)",
      "28:1345mc" : "28:1345mc (28:1345 Medical Care Recovery)",
      "28:1345mi" : "28:1345mi (28:1345 Mining Claim Ejectment)",
      "28:1345pd" : "28:1345pd (28:1345 Property Damage)",
      "28:1345pe" : "28:1345pe (28:1345 VA Property Ejectment)",
      "28:1345rc" : "28:1345rc (28:1345 Recovery of Debt to US)",
      "28:1345st" : "28:1345st (28:1345 Default of Student Loan)",
      "28:1345tp" : "28:1345tp (28:1345 Trespass on Public Land)",
      "28:1345va" : "28:1345va (28:1345 Recovery of VA Overpayment)",
      "28:1346bc" : "28:1346bc (28:1346 Breach of Contract)",
      "28:1346cc" : "28:1346cc (28:1346cc Contract Claims)",
      "28:1346rc" : "28:1346rc (28:1346 Recovery of IRS Tax)",
      "28:1346tc" : "28:1346tc (28:1346 Tort Claim)",
      "28:1346wd" : "28:1346wd (28:1346 Wrongful Death)",
      "28:1349" : "28:1349 (28:1348 Corporation organized under Federal Law as party)",
      "28:1352" : "28:1352 (28:1352 Miller Act)",
      "28:1355" : "28:1355 (28:1355 Petition for Return of Property)",
      "28:1358" : "28:1358 (28:1358 Land Condemnation)",
      "28:1361" : "28:1361 (28:1361 Petition for Writ of Mandamus)",
      "28:1362ic" : "28:1362ic (28:1362 Indian Tribal Controversy)",
      "28:1362iw" : "28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)",
      "28:1364" : "28:1364 (28:1364 Auto Negligence)",
      "28:1391" : "28:1391 (28:1391 Personal Injury)",
      "28:1402" : "28:1402 (28:1402 Medical Malpractice)",
      "28:1407" : "28:1407 (28:1407 Airline Crash)",
      "28:1441ac" : "28:1441ac (28:1441 Notice of Removal-Account Receivable)",
      "28:1441al" : "28:1441al (28:1441 Notice of Removal-Airline Crash)",
      "28:1441as" : "28:1441as (28:1441 Notice of Removal-Asbestos Litigation)",
      "28:1441au" : "28:1441au (28:1441 Notice of Removal-Auto Negligence)",
      "28:1441bc" : "28:1441bc (28:1441 Notice of Removal-Breach of Contract)",
      "28:1441cv" : "28:1441cv (28:1441 Petition for Removal- Civil Rights Act)",
      "28:1441df" : "28:1441df (28:1441 Notice of Removal-Contract Default)",
      "28:1441dj" : "28:1441dj (28:1441 Notice of Removal-Declaratory Judgment)",
      "28:1441ds" : "28:1441ds (28:1441 Notice of Removal-Contract Dispute)",
      "28:1441ed" : "28:1441ed (28:1441 Petition for Removal - Employment Discrim)",
      "28:1441er" : "28:1441er (28:1441 Notice of Removal-ERISA)",
      "28:1441fc" : "28:1441fc (28:1441 Petition for Removal - Fair Credit Reporti)",
      "28:1441fr" : "28:1441fr (28:1441 Notice of Removal-Fraud)",
      "28:1441ij" : "28:1441ij (28:1441 Notice of Removal-Injunctive/Declaratory Relief)",
      "28:1441in" : "28:1441in (28:1441 Notice of Removal-Insurance Contract)",
      "28:1441int" : "28:1441int (28:1441 Petition for Removal- Action for Interplea)",
      "28:1441lb" : "28:1441lb (28:1441 Notice of Removal-Libel, Assault, Slander)",
      "28:1441lm" : "28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relatio)",
      "28:1441mm" : "28:1441mm (28:1441 Notice of Removal-Medical Malpractice)",
      "28:1441ni" : "28:1441ni (28:1441 Notice of Removal-Negotiable Instrument)",
      "28:1441nm" : "28:1441nm (28:1441 Notice of Removal-Non-Motor Vehicle)",
      "28:1441nr" : "28:1441nr (28:1441 Notice of Removal)",
      "28:1441oc" : "28:1441oc (28:1441 Petition For Removal--Other Contract)",
      "28:1441pd" : "28:1441pd (28:1441 Notice of Removal-Property Damage)",
      "28:1441pi" : "28:1441pi (28:1441 Notice of Removal-Personal Injury)",
      "28:1441pl" : "28:1441pl (28:1441 Notice of Removal-Product Liability)",
      "28:1441pr" : "28:1441pr (28:1441 Petition for Removal)",
      "28:1441qt" : "28:1441qt (28:1441 Notice of Removal-Petition to Quiet Title)",
      "28:1441ri" : "28:1441ri (28:1441 Petition for Removal- Racketeering (RICO))",
      "28:1441sa" : "28:1441sa (28:1441 - Petition for Removal: SEC Act)",
      "28:1441sf" : "28:1441sf (28:1441 - Petition for Removal: Securities Fraud)",
      "28:1441tl" : "28:1441tl (28:1441 Notice of Removal-Torts to Land)",
      "28:1441tm" : "28:1441tm (28:1441 Notice of Removal-Tort/Motor Vehicle (P.I.))",
      "28:1441tn" : "28:1441tn (28:1441 Notice of Removal-Tort/Non-Motor Vehicle)",
      "28:1441wd" : "28:1441wd (28:1441 Notice of Removal-Wrongful Death)",
      "28:1442bc" : "28:1442bc (28:1442 Notice of Removal-Breach of Contract)",
      "28:1442nr" : "28:1442nr (28:1442 Notice of Removal)",
      "28:1442pr" : "28:1442pr (28:1442 Petition for Removal)",
      "28:1443" : "28:1443 (28:1443(1) Rent, Lease & Ejectment)",
      "28:1444" : "28:1444 (28:1441 Notice of Removal-Foreclosure)",
      "28:1446in" : "28:1446in (28:1446 Breach of Contract- Insurance)",
      "28:1446nr" : "28:1446nr (28:1446 Notice of Removal)",
      "28:1446pd" : "28:1446pd (28:1446 Notice of Removal-Property Damage (P.I.))",
      "28:1446pi" : "28:1446pi (28:1446 Notice of Removal-Personal Injury)",
      "28:1446pl" : "28:1446pl (28:1446pl Petition for Removal - Product Liability)",
      "28:1446pr" : "28:1446pr (28:1446 Petition for Removal)",
      "28:1452" : "28:1452 (28:1452 Removal of Claim in Civil Action Related to BK. Case)",
      "28:1651" : "28:1651 (28:1651 Petition for Writ of Coram Nobis)",
      "28:1651hc" : "28:1651hc (28:1651 Petition for Writ of Habeas Corpus)",
      "28:1651mn" : "28:1651mn (28:1651 Petition for Writ of Mandamus)",
      "28:1738A" : "28:1738A (Full Face and Credit Given to Child Custody Determinations)",
      "28:1782" : "28:1782 (28:1782 Letter rogatory - appointment)",
      "28:1875" : "28:1875 (28:1875 Protection of Juror Employment)",
      "28:1983" : "28:1983 (28:1983 Civil Rights)",
      "28:2201" : "28:2201 (28:2201 Constitutionality of State Statute(s))",
      "28:2201dj" : "28:2201dj (28:2201 Declaratory Judgment)",
      "28:2201ij" : "28:2201ij (28:2201 Injunction)",
      "28:2201in" : "28:2201in (28:2201 Declaratory Judgment (Insurance))",
      "28:2241" : "28:2241 (28:2241 Petition for Writ of Habeas Corpus (Federal))",
      "28:2254" : "28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))",
      "28:2254se" : "28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)",
      "28:2255" : "28:2255 (28:2255 Motion to Vacate Sentence)",
      "28:2271" : "28:2271 (28:2271 Federal Tort Claims Act)",
      "28:2345" : "28:2345 (28:2345 Medicare Recovery)",
      "28:2409" : "28:2409 (28:2409(a) Quiet Title Action)",
      "28:2410" : "28:2410 (Actions affecting property on which United States had lien)",
      "28:2671" : "28:2671 (28:2671 Federal Tort Claims Act)",
      "28:2674" : "28:2674 (28:2674 Federal Tort Claims Act)",
      "28:3001" : "28:3001 (28:3001 Federal Debt Collection Act)",
      "28:3301" : "28:3301 (28:3301 Fraudulent Transfer Involving Debt)",
      "28:7402" : "28:7402 (28:7402 Refund of Taxes)",
      "28:7422" : "28:7422 (28:7422 Appeal from Administrative Decision)",
      "29:0151" : "29:0151 (29:151 Labor: Review of Agency Action)",
      "29:0160" : "29:0160 (29:160(1) National Labor Relations Act)",
      "29:0184" : "29:0184 (29:184 Violation Collection Bargain Agreement)",
      "29:0185ep" : "29:0185ep (29:185 Employee Pension Plan)",
      "29:0185lm" : "29:0185lm (29:185 Labor/Mgt. Relations (Contracts))",
      "29:0201do" : "29:0201do (29:201 Denial of Overtime Compensation)",
      "29:0201fl" : "29:0201fl (29:201 Fair Labor Standards Act)",
      "29:0203" : "29:0203 (29:203 Equal Pay Act)",
      "29:0206" : "29:0206 (29:206 Collect Unpaid Wages)",
      "29:0401" : "29:0401 (29:0401 Labor Management Disclosure Act)",
      "29:0621" : "29:0621 (29:621 Job Discrimination (Age))",
      "29:0623" : "29:0623 (29:623 Job Discrimination (Age))",
      "29:0626" : "29:0626 (29:626 Job Discrimination (Age))",
      "29:0633" : "29:0633 (29:633 Job Discrimination (Age))",
      "29:0651" : "29:0651 (29:651 Occupational Safety/Health)",
      "29:0754" : "29:0754 (29:754 Discrimination)",
      "29:0791" : "29:0791 (29:791 Job Discrimination (Rehabilitation Act))",
      "29:0794" : "29:0794 (29:0794 Job Discrimination (Handicap))",
      "29:1001" : "29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)",
      "29:1002" : "29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)",
      "29:1104" : "29:1104 (29:1104 Recovery of Benefits to Employee)",
      "29:1109" : "29:1109 (29:1109 Breach of Fiduciary Duties)",
      "29:1131" : "29:1131 (29:1131 ERISA - Collection of Delinquent Trust Funds)",
      "29:1132" : "29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)",
      "29:1145" : "29:1145 (29:1145 E.R.I.S.A.)",
      "29:1149" : "29:1149 (29:1149 Recover Pension & Profit Sharing)",
      "29:1307" : "29:1307 (29:1307 E.R.I.S.A - Recovery of Penalty & Interest)",
      "29:1337" : "29:1337 (29:1337 E.R.I.S.A.)",
      "29:1362" : "29:1362 (29:1362 ERISA)",
      "29:1381" : "29:1381 (29:1381 E.R.I.S.A.)",
      "29:1401" : "29:1401 (29:1401(b)(2) Appeal of Arbitration Award)",
      "29:1451" : "29:1451 (29:1451 E.R.I.S.A.)",
      "29:1801" : "29:1801 (29:1801 Farmworker Rights)",
      "29:2001" : "29:2001 (29:USC2001 Employee Polygraph Protection Act)",
      "29:2101" : "29:2101 (29:2101 Worker Adj. & Retraining Notification Act)",
      "29:2601" : "29:2601 (29:2601 Family & Medical Leave Act)",
      "29:790" : "29:790 (29:790 Rehabilitation of Labor)",
      "30:0181" : "30:0181 (30:181 Environment: Review of Agency Action)",
      "30:0801" : "30:0801 (30:0801 Penalities/Federal Mine Safety Health Act)",
      "30:1201" : "30:1201 (30:1201 Environment: Review of Agency Action)",
      "30:1202" : "30:1202 (30:1202 Mining Reclamation Act)",
      "30:1276" : "30:1276 (30:1276 Interior: Review of Agency Action)",
      "31:3545" : "31:3545 (31:3545 Action to Recovery Money)",
      "31:3729" : "31:3729 (31:3729 False Claims Act)",
      "31:3730" : "31:3730 (31:3730 Qui Tam False Claims Act)",
      "31:3731" : "31:3731 (31:3731 Fraud)",
      "33:1319cw" : "33:1319cw (33:1319 Clean Water Act)",
      "33:1319pv" : "33:1319pv (33:1319 Pollutants & Permit Violations)",
      "33:1365" : "33:1365 (33:1365 Environmental Matters)",
      "35:0145" : "35:0145 (35:145 Patent Infringement)",
      "35:0183" : "35:0183 (35:183 Patent Infringement)",
      "35:0271" : "35:0271 (35:271 Patent Infringement)",
      "38:1681" : "38:1681 (38:1681 Recovery of VA Overpayment)",
      "38:1686" : "38:1686 (38:1686 Recovery of VA Overpayment)",
      "38:1780" : "38:1780 (38:1780 Recovery of VA Overpayment)",
      "38:1984" : "38:1984 (38:1984 Veteran's Benefits - Insurance Suits)",
      "38:2011" : "38:2011 (38:2011 - Veteran's Readjustment Assistance Act of)",
      "38:2021" : "38:2021 (Right to re-employment of inducted persons)",
      "38:3116" : "38:3116 (38:3116 VA Overpayment)",
      "38:775" : "38:775 (Recovery of Servicemen's Group Life Insurance)",
      "39:3005" : "39:3005 (39:3005 Detention of Mail for Temporary Periods)",
      "39:409" : "39:409 (39:409 Postal Service)",
      "40:0258" : "40:0258 (40:258(a) Public Buildings & Property: Land Condemnation)",
      "40:0875" : "40:0875 (40:875 Public Buildings & Property: Negligence)",
      "40:3131" : "40:3131 (40:3131 Miller Act)",
      "41:0251" : "41:0251 (41:251 Public Contracts-Review of Agency Action)",
      "41:1463" : "41:1463 (41:1463 Public Contracts: Unlawful Employment Practices)",
      "42:0205" : "42:0205 (42:205 Denial Social Security Benefits)",
      "42:0206" : "42:0206 (42:206 Social Security Benefits)",
      "42:0247" : "42:0247 (42:247 Personal Injury-Swine Flu)",
      "42:0402" : "42:0402 (42:402 Social Security Benefits)",
      "42:0405id" : "42:0405id (42:405 Review of HHS Decision (SSID))",
      "42:0405rsi" : "42:0405rsi (42:0405 Review of HHS Decision (RSI))",
      "42:0405wc" : "42:0405wc (42:405 Review of HHS Decision (DIWC))",
      "42:0405ww" : "42:0405ww (42:405 Review of HHS Decision (DIWW))",
      "42:0416" : "42:0416 (42:416 Denial of Social Security Benefits)",
      "42:0427" : "42:0427 (42:427 Social Security Benefits)",
      "42:11603b" : "42:11603b (42:11603(b) Int'l Child Abduction Remedies Act)",
      "42:12112" : "42:12112 (42:12112 Americans with Disabilities Act)",
      "42:1383" : "42:1383 (42:1383 Review of HHS Decision)",
      "42:1395" : "42:1395 (42:1395 HHS: Adverse Reimbursement Review)",
      "42:1395dd" : "42:1395dd (42:1395 Emergency Medical Treat. & Active Labor Act (EMTALA))",
      "42:1396" : "42:1396 (42:1396 - Tort Negligence)",
      "42:13981" : "42:13981 (42:13981 Violation of Civil Rights for Women)",
      "42:1471" : "42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclo)",
      "42:1971" : "42:1971 (42:1971 Voting Rights Act)",
      "42:1981cv" : "42:1981cv (42:1981 Civil Rights)",
      "42:1981hs" : "42:1981hs (42:1981 Housing Discrimination)",
      "42:1981jb" : "42:1981jb (42:1981 Job Discrimination (Race))",
      "42:1981sx" : "42:1981sx (42:1981 Sex Discrimination)",
      "42:1983cv" : "42:1983cv (42:1983 Civil Rights Act)",
      "42:1983ed" : "42:1983ed (42:1983 Civil Rights (Employment Discrimination))",
      "42:1983pr" : "42:1983pr (42:1983 Prisoner Civil Rights)",
      "42:1985" : "42:1985 (42:1985 Conspiracy to Interfere with Civil Rights)",
      "42:1986" : "42:1986 (42:1986 Neglect of Duty)",
      "42:2000ag" : "42:2000ag (42:2000 Job Discrimination (Age))",
      "42:2000e" : "42:2000e (42:2000e Job Discrimination (Employment))",
      "42:2000e3" : "42:2000e3 (42:2000 Unlawful Employment Practices)",
      "42:2000no" : "42:2000no (42:2000 Job Discrimination (National Origin))",
      "42:2000pb" : "42:2000pb (42:2000 Job Discrimination (Public Accommodations))",
      "42:2000ra" : "42:2000ra (42:2000 Job Discrimination (Race))",
      "42:2000rl" : "42:2000rl (42:2000 Job Discrimination (Religion))",
      "42:2000sx" : "42:2000sx (42:2000 Job Discrimination (Sex))",
      "42:2003" : "42:2003 (42:2003 Job Discrimination)",
      "42:2005" : "42:2005 (42:2005 Review of Agency Action-HHS)",
      "42:2651" : "42:2651 (42:2651 Medical Recovery Act)",
      "42:3601" : "42:3601 (42:3601 Fair Housing Act)",
      "42:4000" : "42:4000 (42:4000 National Flood Insurance Act)",
      "42:4001" : "42:4001 (42:4001 National Insurance Flood Act)",
      "42:4053" : "42:4053 (42:4053 Breach of Insurance Contract)",
      "42:4072" : "42:4072 (42:4072 Payment of Flood Insurance Claim)",
      "42:4321" : "42:4321 (42:4321 Review of Agency Action-Environment)",
      "42:4332" : "42:4332 (42:4332)",
      "42:6901en" : "42:6901en (42:6901 Environmental Cleanup Expenses)",
      "42:6901rs" : "42:6901rs (42:6901 Resource & Recovery Act)",
      "42:6972" : "42:6972 (42:6972 Environmental Matters)",
      "42:7413" : "42:7413 (42:7413 Air Quality Standards)",
      "42:7523" : "42:7523 (42:7523 Clean Air Act (Emission Standards))",
      "42:7604cl" : "42:7604cl (42:7604 Clear Air Act (Emission Standards))",
      "42:7604ir" : "42:7604ir (42:7604 Petition to Quash IRS Summons)",
      "42:9607" : "42:9607 (42:9607 Real Property Tort to Land (Environmental))",
      "43:945" : "43:945 (43:945 Compensation for Land Condemnation)",
      "43:945a" : "43:945a (43:945a Complaint in Condemnation)",
      "43:946" : "43:946 (43:946 Complaint in Condemnation - Eminent Domain)",
      "45:0051" : "45:0051 (45:51 Railways: Fed. Employer's Liability Act)",
      "45:0151" : "45:0151 (45:151 Railway Labor Act)",
      "45:0184" : "45:0184 (45:184 Action to Set Aside Award of a System Board of Adjust)",
      "45:0231" : "45:0231 (45:231 Railroad Retirement Act)",
      "45:1395" : "45:1395 (45:1395 Railroads: Adverse Reimbursement Review)",
      "45:7457" : "45:7457 (45:7457 Compel Reclamation Under Clear Air Act)",
      "46:0688" : "46:0688 (46:688 Jones Act)",
      "46:0741" : "46:0741 (46:741 Shipping)",
      "46:0761" : "46:0761 (46:761 Shipping: Damages for Death on High Seas)",
      "46:1101" : "46:1101 (46:1101 Violation of Maritime Regulations)",
      "46:1156" : "46:1156 (46:1156 Administrative Procedure Act)",
      "46:1701" : "46:1701 (46:1701 Ocean Commerce Actions)",
      "47:0101" : "47:0101 (47:0101 Federal Communications Act of 1934)",
      "47:0227" : "47:0227 (47:0227 Telephone Consumer Protection Act)",
      "47:0230" : "47:0230 (47:0230 Blocking/Screening Offensive Material on Internet)",
      "47:0332" : "47:0332 (47:0332 Violation of Telecommunications Act of 1996)",
      "47:0553" : "47:0553 (Cable Communications Policy Act of 1984)",
      "47:0605" : "47:0605 (47:0605 Unauthorized Publication/Use of Communications)",
      "48:0883" : "48:0883 (48:883 Violation of US Coastal Law)",
      "48:1985" : "48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)",
      "49:0081" : "49:0081 (49:81 Damaged Goods While Being Transported)",
      "49:0781" : "49:0781 (49:781 Forfeiture)",
      "49:1076" : "49:1076 (49:1076 ICC Rates)",
      "49:11503" : "49:11503 (49:11503 Railroad Revitalization Regulatory Reform)",
      "49:11702" : "49:11702 (49:11702(a)(4) Violations of Interstate Commerce A)",
      "49:11707" : "49:11707 (49:11707 ICC: Liability of Common Carriers)",
      "49:14706" : "49:14706 (49:14706 Interstate Freight Claim (Carmack Amendment))",
      "49:1471" : "49:1471 (49:1471 Federal Aviation Act)",
      "49:1903" : "49:1903 (49:1903 Petition to enforce administrative summon)",
      "49:521" : "49:521 (49:521 Federal Motor Carrier Safety Regulations)",
      "8:287" : "8:287 (8:287 Petition to Enforce INS Subpoena)",
      "99:9999" : "99:9999 (99:9999 Report cause code (DO NOT DELETE!))",
      "adsup" : "adsup (Administrative Subpoena)",
      "contempt" : "contempt (Contempt Proceedings)",
      "denifp" : "denifp (Order Denying In Forma Pauperis)",
      "disbar" : "disbar (Disbarment Proceedings)",
      "entprem" : "entprem (Application to Enter Premises to Seize Property)",
      "fordepo" : "fordepo (Foreign Deposition)",
      "misc" : "misc (Civil Miscellaneous Case)",
      "motcomp" : "motcomp (Motion to Compel)",
      "motquash" : "motquash (Motion to Quash)",
      "motret" : "motret (Motion for Return of Property)",
      "petenf" : "petenf (Petition to Enforce IRS Summons)",
      "petenfeeoc" : "petenfeeoc (Petition to Enforce EEOC Summons)",
      "petper" : "petper (Petition to Perpetuate Testimony)",
      "regjgm" : "regjgm (Registration of Foreign Judgment)",
      "suspen" : "suspen (Suspension Proceedings)",
      "tranbkref" : "tranbkref (Transmission of Bankruptcy Reference)",
      "tranff" : "tranff (Transmission of Proposed Findings of Fact and Concl. of Law)",
      "writgar" : "writgar (Application for a Writ of Garnishment)"
   },
   "ncwdce" : {
      "0" : "0 (no cause specified)",
      "02:0431" : "02:0431 (02:431 Fed. Election Commission: Failure Enforce Compliance)",
      "02:0437" : "02:0437 (02:437 Federal Election Commission)",
      "05:0075" : "05:0075 (05:75(2) Contract - Reduction in Grade)",
      "05:0551" : "05:0551 (05:551 Administrative Procedure Act)",
      "05:0552fi" : "05:0552fi (05:552 Freedom of Information Act)",
      "05:0552pa" : "05:0552pa (05:552 Right to Privacy Act)",
      "05:0554" : "05:0554 (05:0554 Constitutionality of Maritime Statutes)",
      "05:0701" : "05:0701 (05:0701 Maritime Subsidy Board)",
      "05:0702" : "05:0702 (05:702 Administrative Procedure Act)",
      "05:0704" : "05:0704 (05:704 Labor Litigation)",
      "05:7703" : "05:7703 (05:7703 Discrimination - Review of Agency Act)",
      "05:8470" : "05:8470 (05:8470 Enforcement of Judgment against Retirement Benefits)",
      "07:0006" : "07:0006 (7:6(b) Federal Commodity Exchange Regulation)",
      "07:0025" : "07:0025 (7:25 Fraud - Commodities Leverage Contracts)",
      "07:0181" : "07:0181 (07:181 Packers & Stockyard Act)",
      "07:0499" : "07:0499 (07:499 Agricultural Commodities Act)",
      "07:0601" : "07:0601 (07:601 USDA Condemnation)",
      "07:2321" : "07:2321 (07:2321 Plant Variety Protection Act)",
      "08:1105" : "08:1105 (8:1105(a) Aliens: Habeas Corpus to Release INS Detainee)",
      "08:1182" : "08:1182 (8:1182 Defend. Denial of Pla. Appl. for Alien Employment Cer)",
      "08:1252" : "08:1252 (08:1252(a)(2) Injunction for Deportation)",
      "08:1260" : "08:1260 (08:1260 Aliens: Access to Records)",
      "08:1324" : "08:1324 (08:1324 Aliens: Complaint for Forfeiture)",
      "08:1329" : "08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petition)",
      "08:1446" : "08:1446 (8:1446 Petition for Naturalization Hearing)",
      "08:1451(j)" : "08:1451(j) (8:1451(j) Motion to Correct Order & Judg. of Naturalization)",
      "09:0001" : "09:0001 (09:1 U.S. Arbitration Act)",
      "09:0009" : "09:0009 (9:9 Motion to Confirm Arbitration Loan)",
      "09:0010" : "09:0010 (09:0010 Petition to Vacate Arbitration Award)",
      "10:1408" : "10:1408 (10:1408 Claim for Military Retirement)",
      "10:1552" : "10:1552 (10:1552 Armed Forces: Action to Correct Records)",
      "10:1553" : "10:1553 (10:1553 Armed Forces: FOIA General)",
      "10:2305" : "10:2305 (10:2305 Review of Federal Contract)",
      "11:0101" : "11:0101 (11:101 Bankruptcy)",
      "12:0022" : "12:0022 (12:22 Securities Fraud)",
      "12:0635" : "12:0635 (12:635 Breach of Insurance Contract)",
      "12:1461" : "12:1461 (12:1461 Homeowners Loan Act)",
      "12:1464" : "12:1464 (12:1464 Federal Savings and Loan)",
      "12:1703" : "12:1703 (12:1703 Default of HUD Loan)",
      "12:1725" : "12:1725 (12:1725 Collection under Contract Guaranty)",
      "12:1730" : "12:1730 (12:1730 Collection Under Contract Guaranty)",
      "12:1819" : "12:1819 (12:1819 Default of Promissory Note)",
      "12:1821" : "12:1821 (12:1821 Default of Loan by Promissary Note)",
      "12:1833" : "12:1833 (12:1833 Civil Penalties)",
      "12:191" : "12:191 (12:191 Bank Foreclosure)",
      "12:192" : "12:192 (12:192 Liquidation of National Bank)",
      "12:1971" : "12:1971 (12:1971 Relief under Bank Holding Act)",
      "12:1972" : "12:1972 (12:1972 Typing Arrangement Act)",
      "12:3410" : "12:3410 (12:3410 Right to Financial Privacy Act)",
      "15:0001" : "15:0001 (15:1 Antitrust Litigation)",
      "15:0002at" : "15:0002at (15:2 Antitrust Litigation)",
      "15:0002fl" : "15:0002fl (15:2(a) Fair Labor Standards Act)",
      "15:0005" : "15:0005 (15:5(a) Fair Labor Standards Act)",
      "15:0015" : "15:0015 (15:15 Antitrust Litigation)",
      "15:0025" : "15:0025 (15:25 Clayton Act)",
      "15:0044" : "15:0044 (15:44 Trademark Infringement)",
      "15:0045" : "15:0045 (15:0045 Federal Trade Commission Act)",
      "15:0052" : "15:0052 (15:0052 Federal Trade Commission Act)",
      "15:0053" : "15:0053 (15:0053 Federal Trade Commission Act)",
      "15:0077" : "15:0077 (15:77 Securities Fraud)",
      "15:0078" : "15:0078 (15:78m(a) Securities Exchange Act)",
      "15:0631" : "15:0631 (15:631 Small Business Act)",
      "15:0717" : "15:0717 (15:717 Natural Gas Act)",
      "15:0754" : "15:0754 (15:754 Emergency Petroleum Allocation-Admin.& Enforcement)",
      "15:1051" : "15:1051 (15:1051 Trademark Infringement)",
      "15:1071" : "15:1071 (15:1071 Trademark Infringement (Lanham Act))",
      "15:1114" : "15:1114 (15:1114 Trademark Infringement)",
      "15:1121" : "15:1121 (15:1121 Trademark Infringement)",
      "15:1125" : "15:1125 (15:1125 Trademark Infringement (Lanham Act))",
      "15:1126" : "15:1126 (15:1126 Patent Infringement)",
      "15:1127" : "15:1127 (15:1127 Trademark Infringement)",
      "15:1601" : "15:1601 (15:1601 Truth in Lending)",
      "15:1640" : "15:1640 (15:1640 Truth in Lending)",
      "15:1681" : "15:1681 (15:1681 Fair Credit Reporting Act)",
      "15:1691" : "15:1691 (15:1691 Equal Credit Opportunity Act)",
      "15:1692" : "15:1692 (15:1692 Fair Debt Collection Act)",
      "15:1709" : "15:1709 (15:1709 Violations re Sale or Lease of Lots)",
      "15:1938" : "15:1938 (15:1938 Fair Labor Standards Act)",
      "15:1981" : "15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))",
      "15:1988" : "15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))",
      "15:1989" : "15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))",
      "15:2301" : "15:2301 (15:2301 Magnuson-Moss Warranty Act)",
      "15:2801" : "15:2801 (15:2801 Petroleum Marketing Practices Act)",
      "15:53(b)" : "15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equita)",
      "15:6101" : "15:6101 (Telemarketing & Consumer Fraud)",
      "15:6102" : "15:6102 (Telemarketing & Consumer Fraud & Abuse Prevention Act)",
      "15:687(c)" : "15:687(c) (15:687(c) SBA Receivership)",
      "16:0668" : "16:0668 (16:668 Bald Eagle Protection Act)",
      "16:0703" : "16:0703 (16:703 Migratory Bird Act)",
      "16:1246(g)" : "16:1246(g) (16:1246(g) National Trails System Act - Land Condemnation)",
      "16:1538" : "16:1538 (16:1538 Endangered Species Act)",
      "16:3371" : "16:3371 (16:3371 Wildlife Under the Lacey Act)",
      "16:3372" : "16:3372 (16:3372 Conservation: Complaint for Forfeiture)",
      "16:3373" : "16:3373 (16:3373 Appeal of Decision - DOI)",
      "16:3374" : "16:3374 (16:3374 Conservation: Complaint for Forfeiture)",
      "17:0101" : "17:0101 (17:101 Copyright Infringement)",
      "17:0501" : "17:0501 (17:501 Copyright Infringement)",
      "17:0504" : "17:0504 (17:504 Copyright Infringement)",
      "18:0241" : "18:0241 (18:241 Conspiracy Against Citizen Rights)",
      "18:1836a" : "18:1836a (18:1836(a) Injunction against Misappropriation of Trade Secrets)",
      "18:1836b" : "18:1836b (18:1836(b) Civil Action to Protect Trade Secrets)",
      "18:1961" : "18:1961 (18:1961 Racketeering (RICO) Act)",
      "18:1962" : "18:1962 (18:1962 Racketeering (RICO) Act)",
      "18:1964" : "18:1964 (18:1964 Racketeering (RICO) Act)",
      "18:2511" : "18:2511 (18:2511 Wiretapping)",
      "18:3114" : "18:3114 (18:3114 Motion for Return of Seized Property)",
      "18:3664" : "18:3664 (18:3664 Procedure for issuance and enforcement of order of restitution)",
      "18:4208" : "18:4208 (18:4208(B) Agency Action Review)",
      "19:1305" : "19:1305 (19:1305 Custom Duties: Forfeiture-Immoral Articles)",
      "20:1080" : "20:1080 (20:1080 Student Loan Recovery)",
      "20:1400" : "20:1400 (20:1400 Civil Rights of Handicapped Child)",
      "20:1401" : "20:1401 (20:1401 Education: Handicapped Child Act)",
      "20:1415" : "20:1415 (20:1415 Attorney Fees/Costs re: ADA)",
      "21:0841" : "21:0841 (21:841 Forfeiture Property-Drugs)",
      "21:0881" : "21:0881 (21:0881 Property Forfeiture)",
      "21:0881a" : "21:0881a (21:881 Forfeiture Property - Aircraft)",
      "21:0881re" : "21:0881re (21:881 Forfeiture Property - Real Estate)",
      "23:0134" : "23:0134 (23:134 P.I.- Auto Negligence)",
      "23:1441" : "23:1441 (23:1441 Contract Real Estate)",
      "24:1000" : "24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)",
      "25:0640" : "25:0640 (25:640 Indian Tribal Rights)",
      "25:1901" : "25:1901 (25:1901 Indian Child Welfare Act)",
      "26:6212" : "26:6212 (26:6212 Injunctive Relief from IRS Lien)",
      "26:6213" : "26:6213 (26:6213 Injunctive Relief from IRS Lien)",
      "26:6502" : "26:6502 (26:6502 IRS:Enforcement of tax liens)",
      "26:6532" : "26:6532 (26:6532 IRS: Refund of Tax Penalty)",
      "26:6702" : "26:6702 (26:6702 IRS: Refund of Income Tax Penalty)",
      "26:6703" : "26:6703 (26:6703 IRS: Refund of Tax Penalty)",
      "26:7401" : "26:7401 (26:7401 IRS: Tax Liability)",
      "26:7402" : "26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)",
      "26:7403" : "26:7403 (26:7403 Suit to Enforce Federal Tax Lien)",
      "26:7422rt" : "26:7422rt (26:7422 IRS: Refund Taxes)",
      "26:7422rx" : "26:7422rx (26:7422 IRS: Refund Excise Tax)",
      "26:7426" : "26:7426 (26:7426 IRS: Wrongful Levy for Taxes)",
      "26:7429" : "26:7429 (26:7429 IRS: Tax Jeopardy Assessment)",
      "26:7609" : "26:7609 (26:7609 IRS: Petition to Quash IRS Summons)",
      "27:0185" : "27:0185 (27:185 Enforcement of Arbitration Award)",
      "28:0157c" : "28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)",
      "28:0157d" : "28:0157d (28:0157 Motion for Withdrawal of Reference)",
      "28:0158" : "28:0158 (28:0158 Bankruptcy Appeal from Judgment/Order)",
      "28:0185" : "28:0185 (28:185 Suit to Compel Arbitration)",
      "28:0451" : "28:0451 (28:451 Employment Discrimination)",
      "28:0754" : "28:0754 (28:754 Receiver of Property in Different Districts)",
      "28:0794" : "28:0794 (28:794 Rehabilitation Act)",
      "28:1001" : "28:1001 (28:1001 E.R.I.S.A.)",
      "28:1132" : "28:1132 (28:1132 E.R.I.S.A.)",
      "28:1330" : "28:1330 (28:1330 Breach of Contract)",
      "28:1331" : "28:1331 (28:1331 Fed. Question)",
      "28:1331al" : "28:1331al (28:1331 Fed. Question: Airline Crash)",
      "28:1331at" : "28:1331at (28:1331 Fed. Question: Anti-trust)",
      "28:1331au" : "28:1331au (28:1331 Fed. Question: Auto Negligence)",
      "28:1331b" : "28:1331b (28:1331 Federal Question: Bivens Act)",
      "28:1331bc" : "28:1331bc (28:1331 Fed. Question: Breach of Contract)",
      "28:1331ca" : "28:1331ca (28:1331 Fed Question: Fed Communications Act of 1)",
      "28:1331cm" : "28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)",
      "28:1331cv" : "28:1331cv (28:1331 Fed. Question: Civil Rights Violation)",
      "28:1331ed" : "28:1331ed (28:1331 Fed. Question: Employment Discrimination)",
      "28:1331ej" : "28:1331ej (28:1331 Federal Question: Enforcement of Judgment)",
      "28:1331es" : "28:1331es (28:1331 Enforcement of Administrative Subpoena)",
      "28:1331fl" : "28:1331fl (28:1331 Fed. Question: Fair Labor Standards)",
      "28:1331in" : "28:1331in (28:1331 Fed. Question: Insurance Contract)",
      "28:1331mm" : "28:1331mm (28:1331 Fed. Question: Medical Malpractice)",
      "28:1331ng" : "28:1331ng (28:1331 Fed. Question: Natural Gas Act)",
      "28:1331pi" : "28:1331pi (28:1331 Fed. Question: Personal Injury)",
      "28:1331rd" : "28:1331rd (28:1331 Fed. Question: Review Agency Decision)",
      "28:1331rp" : "28:1331rp (28:1331(a) Fed. Question: Real Property)",
      "28:1331rr" : "28:1331rr (28:1331 Fed. Question: Railway Labor Act)",
      "28:1331sv" : "28:1331sv (28:1331 Fed. Question: Securities Violation)",
      "28:1331tr" : "28:1331tr (28:1331 Fed. Question: Trademark)",
      "28:1331tt" : "28:1331tt (28:1331 Fed. Question: Tort Action)",
      "28:1331v" : "28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendment)",
      "28:1331wl" : "28:1331wl (28:1331 Federal Question: EPA Waste Lien)",
      "28:1331wt" : "28:1331wt (28:1331 Fed. Question: Water Rights)",
      "28:1332ac" : "28:1332ac (28:1332 Diversity-Account Receivable)",
      "28:1332al" : "28:1332al (28:1332 Diversity-Airline Crash)",
      "28:1332as" : "28:1332as (28:1332 Diversity-Asbestos Litigation)",
      "28:1332au" : "28:1332au (28:1332 Diversity-Auto Negligence)",
      "28:1332bc" : "28:1332bc (Diversity-Breach of Contract)",
      "28:1332co" : "28:1332co (28:1332 Diversity-Conversion)",
      "28:1332ct" : "28:1332ct (28:1332 Diversity-(Citizenship))",
      "28:1332det" : "28:1332det (28:1332 Diversity: Forcible Detainer)",
      "28:1332df" : "28:1332df (28:1332 Diversity-Contract Default)",
      "28:1332ds" : "28:1332ds (28:1332 Diversity-Contract Dispute)",
      "28:1332ed" : "28:1332ed (28:1332 Diversity-Employment Discrimination)",
      "28:1332fd" : "28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)",
      "28:1332fr" : "28:1332fr (28:1332 Diversity-Fraud)",
      "28:1332ia" : "28:1332ia (28:1332 Diversity-Interpleader Action)",
      "28:1332ij" : "28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)",
      "28:1332in" : "28:1332in (28:1332 Diversity-Insurance Contract)",
      "28:1332jd" : "28:1332jd (28:1332 Diversity-Declaratory Judgment)",
      "28:1332lb" : "28:1332lb (28:1332 Diversity-Libel, Assault, Slander)",
      "28:1332lm" : "28:1332lm (28:1332 Diversity - Legal Malpractice)",
      "28:1332ma" : "28:1332ma (28:1332 Diversity-Miller Act)",
      "28:1332mm" : "28:1332mm (28:1332 Diversity-Medical Malpractice)",
      "28:1332mv" : "28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)",
      "28:1332ni" : "28:1332ni (28:1332 Diversity-Negotiable Instrument)",
      "28:1332nm" : "28:1332nm (28:1332 Diversity-Non-Motor Vehicle)",
      "28:1332nr" : "28:1332nr (Diversity - Notice of Removal)",
      "28:1332oc" : "28:1332oc (28:1332 Diversity-Other Contract)",
      "28:1332pd" : "28:1332pd (28:1332 Diversity-Property Damage)",
      "28:1332pi" : "28:1332pi (28:1332 Diversity-Personal Injury)",
      "28:1332pl" : "28:1332pl (28:1332 Diversity-Product Liability)",
      "28:1332pr" : "28:1332pr (28:1332 Diversity-Petition for Removal)",
      "28:1332qt" : "28:1332qt (28:1332 Diversity-Petition to Quiet Title)",
      "28:1332ri" : "28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)",
      "28:1332sa" : "28:1332sa (28:1332 - Diversity: Securities & Exchange Commiss)",
      "28:1332sf" : "28:1332sf (28:1332 - Diversity: Securities Fraud)",
      "28:1332ss" : "28:1332ss (28:1332 Diversity - Stockholders Suits)",
      "28:1332tl" : "28:1332tl (28:1332 Diversity-Torts to Land)",
      "28:1332tm" : "28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))",
      "28:1332tn" : "28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)",
      "28:1332wd" : "28:1332wd (28:1332 Diversity-Wrongful Death)",
      "28:1333" : "28:1333 (28:1333 Admiralty)",
      "28:1334" : "28:1334 (28:1334 Bankruptcy Appeal)",
      "28:1334c" : "28:1334c (28:1334(c) R&R re motions for abstention (non-cor)",
      "28:1335" : "28:1335 (28:1335 Interpleader Action)",
      "28:1337" : "28:1337 (28:1337 Sherman-Clayton Act)",
      "28:1338cp" : "28:1338cp (28:1338 Copyright Infringement)",
      "28:1338pt" : "28:1338pt (28:1338 Patent Infringement)",
      "28:1338tr" : "28:1338tr (28:1338 Trademark Infringement)",
      "28:1340" : "28:1340 (28:1340 IRS: Custom Duties)",
      "28:1340er" : "28:1340er (28:1340 Recovery of Erroneous Refund)",
      "28:1341" : "28:1341 (28:1341 Complaint for Forfeiture)",
      "28:1343" : "28:1343 (28:1343 Violation of Civil Rights)",
      "28:1345" : "28:1345 (28:1345 USA Plaintiff)",
      "28:1345co" : "28:1345co (28:1345 Replevin & Conversion)",
      "28:1345db" : "28:1345db (28:1345 Debt to US - FHA/HUD Title I)",
      "28:1345df" : "28:1345df (28:1345 Default of Promissory Note)",
      "28:1345er" : "28:1345er (28:1345 Recovery of Erroneous Refund)",
      "28:1345fc" : "28:1345fc (28:1345 Foreclosure)",
      "28:1345ff" : "28:1345ff (28:1345 Complaint for Forfeiture)",
      "28:1345hl" : "28:1345hl (28:1345 VA Home Loan Guaranty Debt)",
      "28:1345mc" : "28:1345mc (28:1345 Medical Care Recovery)",
      "28:1345mi" : "28:1345mi (28:1345 Mining Claim Ejectment)",
      "28:1345pd" : "28:1345pd (28:1345 Property Damage)",
      "28:1345pe" : "28:1345pe (28:1345 VA Property Ejectment)",
      "28:1345rc" : "28:1345rc (28:1345 Recovery of Debt to US)",
      "28:1345st" : "28:1345st (28:1345 Default of Student Loan)",
      "28:1345tp" : "28:1345tp (28:1345 Trespass on Public Land)",
      "28:1345va" : "28:1345va (28:1345 Recovery of VA Overpayment)",
      "28:1346bc" : "28:1346bc (28:1346 Breach of Contract)",
      "28:1346rc" : "28:1346rc (28:1346 Recovery of IRS Tax)",
      "28:1346tc" : "28:1346tc (28:1346 Tort Claim)",
      "28:1346wd" : "28:1346wd (28:1346 Wrongful Death)",
      "28:1349" : "28:1349 (28:1348 Corporation organized under Federal Law as party)",
      "28:1352" : "28:1352 (28:1352 Miller Act)",
      "28:1355" : "28:1355 (28:1355 Petition for Return of Property)",
      "28:1358" : "28:1358 (28:1358 Land Condemnation)",
      "28:1361" : "28:1361 (28:1361 Petition for Writ of Mandamus)",
      "28:1362ic" : "28:1362ic (28:1362 Indian Tribal Controversy)",
      "28:1362iw" : "28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)",
      "28:1364" : "28:1364 (28:1364 Auto Negligence)",
      "28:1391" : "28:1391 (28:1391 Personal Injury)",
      "28:1402" : "28:1402 (28:1402 Medical Malpractice)",
      "28:1407" : "28:1407 (28:1407 Multidistrict Litigation)",
      "28:1441ac" : "28:1441ac (28:1441 Notice of Removal-Account Receivable)",
      "28:1441al" : "28:1441al (28:1441 Notice of Removal-Airline Crash)",
      "28:1441as" : "28:1441as (28:1441 Notice of Removal-Asbestos Litigation)",
      "28:1441au" : "28:1441au (28:1441 Notice of Removal-Auto Negligence)",
      "28:1441bc" : "28:1441bc (28:1441 Notice of Removal-Breach of Contract)",
      "28:1441cv" : "28:1441cv (28:1441cv Notice of Removal - Civil Rights)",
      "28:1441df" : "28:1441df (28:1441 Notice of Removal-Contract Default)",
      "28:1441dj" : "28:1441dj (28:1441 Notice of Removal-Declaratory Judgment)",
      "28:1441ds" : "28:1441ds (28:1441 Notice of Removal-Contract Dispute)",
      "28:1441ed" : "28:1441ed (28:1441 Notice of Removal - Employment Discrimination)",
      "28:1441fc" : "28:1441fc (28:1441 Petition for Removal - Fair Credit Reporti)",
      "28:1441fr" : "28:1441fr (28:1441 Notice of Removal-Fraud)",
      "28:1441ij" : "28:1441ij (28:1441 Notice of Removal-Injunctive/Declaratory Relief)",
      "28:1441in" : "28:1441in (28:1441 Notice of Removal-Insurance Contract)",
      "28:1441int" : "28:1441int (28:1441 Petition for Removal- Action for Interplea)",
      "28:1441lb" : "28:1441lb (28:1441 Notice of Removal-Libel, Assault, Slander)",
      "28:1441lm" : "28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relatio)",
      "28:1441mm" : "28:1441mm (28:1441 Notice of Removal-Medical Malpractice)",
      "28:1441ni" : "28:1441ni (28:1441 Notice of Removal-Negotiable Instrument)",
      "28:1441nm" : "28:1441nm (28:1441 Notice of Removal-Non-Motor Vehicle)",
      "28:1441nr" : "28:1441nr (28:1441 Notice of Removal)",
      "28:1441oc" : "28:1441oc (28:1441 Petition For Removal--Other Contract)",
      "28:1441pd" : "28:1441pd (28:1441 Notice of Removal-Property Damage)",
      "28:1441pi" : "28:1441pi (28:1441 Notice of Removal-Personal Injury)",
      "28:1441pl" : "28:1441pl (28:1441 Notice of Removal-Product Liability)",
      "28:1441pr" : "28:1441pr (28:1441 Petition for Removal)",
      "28:1441qt" : "28:1441qt (28:1441 Notice of Removal-Petition to Quiet Title)",
      "28:1441ri" : "28:1441ri (28:1441 Petition for Removal- Racketeering (RICO))",
      "28:1441sa" : "28:1441sa (28:1441 - Petition for Removal: SEC Act)",
      "28:1441sf" : "28:1441sf (28:1441 - Petition for Removal: Securities Fraud)",
      "28:1441tl" : "28:1441tl (28:1441 Notice of Removal-Torts to Land)",
      "28:1441tm" : "28:1441tm (28:1441 Notice of Removal-Tort/Motor Vehicle (P.I.))",
      "28:1441tn" : "28:1441tn (28:1441 Notice of Removal-Tort/Non-Motor Vehicle)",
      "28:1441wd" : "28:1441wd (28:1441 Notice of Removal-Wrongful Death)",
      "28:1442bc" : "28:1442bc (28:1442 Notice of Removal-Breach of Contract)",
      "28:1442nr" : "28:1442nr (28:1442 Notice of Removal)",
      "28:1442pr" : "28:1442pr (28:1442 Petition for Removal)",
      "28:1443" : "28:1443 (28:1443(1) Rent, Lease & Ejectment)",
      "28:1444" : "28:1444 (28:1441 Notice of Removal-Foreclosure)",
      "28:1446in" : "28:1446in (28:1446 Breach of Contract- Insurance)",
      "28:1446nr" : "28:1446nr (28:1446 Notice of Removal)",
      "28:1446pd" : "28:1446pd (28:1446 Notice of Removal-Property Damage (P.I.))",
      "28:1446pi" : "28:1446pi (28:1446 Notice of Removal-Personal Injury)",
      "28:1446pl" : "28:1446pl (28:1446pl Petition for Removal - Product Liability)",
      "28:1446pr" : "28:1446pr (28:1446 Petition for Removal)",
      "28:1452" : "28:1452 (28:1452 Removal of Claim in Civil Action Related to BK. Case)",
      "28:1651" : "28:1651 (28:1651 Petition for Writ of Coram Nobis)",
      "28:1651hc" : "28:1651hc (28:1651 Petition for Writ of Habeas Corpus)",
      "28:1651mn" : "28:1651mn (28:1651 Petition for Writ of Mandamus)",
      "28:1782" : "28:1782 (28:1782 Letter rogatory - appointment)",
      "28:1983" : "28:1983 (28:1983 Civil Rights)",
      "28:2201" : "28:2201 (28:2201 Constitutionality of State Statute(s))",
      "28:2201dj" : "28:2201dj (Declaratory Judgment)",
      "28:2201ij" : "28:2201ij (28:2201 Injunction)",
      "28:2201in" : "28:2201in (28:2201 Declaratory Judgment (Insurance))",
      "28:2241" : "28:2241 (28:2241 Petition for Writ of Habeas Corpus (Federal))",
      "28:2254" : "28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))",
      "28:2254se" : "28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)",
      "28:2255" : "28:2255 (28:2255 Motion to Vacate Sentence)",
      "28:2271" : "28:2271 (28:2271 Federal Tort Claims Act)",
      "28:2345" : "28:2345 (28:2345 Medicare Recovery)",
      "28:2409" : "28:2409 (28:2409(a) Quiet Title Action)",
      "28:2410" : "28:2410 (Actions affecting property on which United States had lien)",
      "28:2671" : "28:2671 (28:2671 Federal Tort Claims Act)",
      "28:2674" : "28:2674 (28:2674 Federal Tort Claims Act)",
      "28:3001" : "28:3001 (28:3001 Federal Debt Collection Act)",
      "28:7402" : "28:7402 (28:7402 Refund of Taxes)",
      "28:7422" : "28:7422 (28:7422 Appeal from Administrative Decision)",
      "29:0151" : "29:0151 (29:151 Labor: Review of Agency Action)",
      "29:0160" : "29:0160 (29:160(1) National Labor Relations Act)",
      "29:0184" : "29:0184 (29:184 Violation Collection Bargain Agreement)",
      "29:0185ep" : "29:0185ep (29:185 Employee Pension Plan)",
      "29:0185lm" : "29:0185lm (29:185 Labor/Mgt. Relations (Contracts))",
      "29:0201do" : "29:0201do (29:201 Denial of Overtime Compensation)",
      "29:0201fl" : "29:0201fl (29:201 Fair Labor Standards Act)",
      "29:0203" : "29:0203 (29:203 Equal Pay Act)",
      "29:0206" : "29:0206 (29:206 Collect Unpaid Wages)",
      "29:0401" : "29:0401 (29:0401 Labor Management Disclosure Act)",
      "29:0621" : "29:0621 (29:621 Job Discrimination (Age))",
      "29:0623" : "29:0623 (29:623 Job Discrimination (Age))",
      "29:0626" : "29:0626 (29:626 Job Discrimination (Age))",
      "29:0633" : "29:0633 (29:633 Job Discrimination (Age))",
      "29:0651" : "29:0651 (29:651 Occupational Safety/Health)",
      "29:0754" : "29:0754 (29:754 Discrimination)",
      "29:0791" : "29:0791 (29:791 Job Discrimination (Rehabilitation Act))",
      "29:0794" : "29:0794 (29:0794 Job Discrimination (Handicap))",
      "29:1001" : "29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)",
      "29:1002" : "29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)",
      "29:1104" : "29:1104 (29:1104 Recovery of Benefits to Employee)",
      "29:1109" : "29:1109 (29:1109 Breach of Fiduciary Duties)",
      "29:1131" : "29:1131 (29:1131 ERISA - Collection of Delinquent Trust Funds)",
      "29:1132" : "29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)",
      "29:1145" : "29:1145 (29:1145 E.R.I.S.A.)",
      "29:1149" : "29:1149 (29:1149 Recover Pension & Profit Sharing)",
      "29:1337" : "29:1337 (29:1337 E.R.I.S.A.)",
      "29:1362" : "29:1362 (29:1362 ERISA)",
      "29:1381" : "29:1381 (29:1381 E.R.I.S.A.)",
      "29:1401" : "29:1401 (29:1401(b)(2) Appeal of Arbitration Award)",
      "29:1451" : "29:1451 (29:1451 E.R.I.S.A.)",
      "29:1801" : "29:1801 (29:1801 Farmworker Rights)",
      "29:2601" : "29:2601 (29:2601 Family & Medical Leave Act)",
      "29:790" : "29:790 (29:790 Rehabilitation of Labor)",
      "30:0181" : "30:0181 (30:181 Environment: Review of Agency Action)",
      "30:0801" : "30:0801 (30:0801 Penalities/Federal Mine Safety Health Act)",
      "30:1201" : "30:1201 (30:1201 Environment: Review of Agency Action)",
      "30:1202" : "30:1202 (30:1202 Mining Reclamation Act)",
      "30:1276" : "30:1276 (30:1276 Interior: Review of Agency Action)",
      "31:3545" : "31:3545 (31:3545 Action to Recovery Money)",
      "31:3729" : "31:3729 (31:3729 False Claims Act)",
      "31:3730" : "31:3730 (31:3730 Qui Tam False Claims Act)",
      "31:3731" : "31:3731 (31:3731 Fraud)",
      "33:1319cw" : "33:1319cw (33:1319 Clean Water Act)",
      "33:1319pv" : "33:1319pv (33:1319 Pollutants & Permit Violations)",
      "33:1365" : "33:1365 (33:1365 Environmental Matters)",
      "35:0145" : "35:0145 (35:145 Patent Infringement)",
      "35:0183" : "35:0183 (35:183 Patent Infringement)",
      "35:0271" : "35:0271 (35:271 Patent Infringement)",
      "35:256" : "35:256 (35:256 Patent Correction of Named Inventor)",
      "38:1681" : "38:1681 (38:1681 Recovery of VA Overpayment)",
      "38:1686" : "38:1686 (38:1686 Recovery of VA Overpayment)",
      "38:1780" : "38:1780 (38:1780 Recovery of VA Overpayment)",
      "38:2011" : "38:2011 (38:2011 - Veteran's Readjustment Assistance Act of)",
      "38:2021" : "38:2021 (Right to re-employment of inducted persons)",
      "38:3116" : "38:3116 (38:3116 VA Overpayment)",
      "38:775" : "38:775 (Recovery of Servicemen's Group Life Insurance)",
      "39:3005" : "39:3005 (39:3005 Detention of Mail for Temporary Periods)",
      "39:409" : "39:409 (39:409 Postal Service)",
      "40:0258" : "40:0258 (40:258(a) Public Buildings & Property: Land Condemnation)",
      "40:0270" : "40:0270 (40:270 Miller Act)",
      "40:0875" : "40:0875 (40:875 Public Buildings & Property: Negligence)",
      "41:0251" : "41:0251 (41:251 Public Contracts-Review of Agency Action)",
      "41:1463" : "41:1463 (41:1463 Public Contracts: Unlawful Employment Practices)",
      "42:0205" : "42:0205 (42:0205 Denial Social Security Benefits)",
      "42:0206" : "42:0206 (42:206 Social Security Benefits)",
      "42:0247" : "42:0247 (42:247 Personal Injury-Swine Flu)",
      "42:0402" : "42:0402 (42:402 Social Security Benefits)",
      "42:0405id" : "42:0405id (42:405 Review of HHS Decision (SSID))",
      "42:0405wc" : "42:0405wc (42:405 Review of HHS Decision (DIWC))",
      "42:0405ww" : "42:0405ww (42:405 Review of HHS Decision (DIWW))",
      "42:0416" : "42:0416 (42:416 Denial of Social Security Benefits)",
      "42:0427" : "42:0427 (42:427 Social Security Benefits)",
      "42:11601" : "42:11601 (42:11601 Intl Child Abduction Remedies Act)",
      "42:12101" : "42:12101 (42:12101 Americans With Disability Act)",
      "42:1383" : "42:1383 (42:1383 Review of HHS Decision)",
      "42:1395" : "42:1395 (42:1395 HHS: Adverse Reimbursement Review)",
      "42:1396" : "42:1396 (42:1396 - Tort Negligence)",
      "42:1471" : "42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclo)",
      "42:1981cv" : "42:1981cv (42:1981 Civil Rights)",
      "42:1981hs" : "42:1981hs (42:1981 Housing Discrimination)",
      "42:1981jb" : "42:1981jb (42:1981 Job Discrimination (Race))",
      "42:1981sx" : "42:1981sx (42:1981 Sex Discrimination)",
      "42:1983cv" : "42:1983cv (42:1983 Civil Rights Act)",
      "42:1983ed" : "42:1983ed (42:1983 Civil Rights (Employment Discrimination))",
      "42:1983pr" : "42:1983pr (Prisoner Civil Rights)",
      "42:1985" : "42:1985 (Conspiracy to Interfere with Civil Rights)",
      "42:1986" : "42:1986 (42:1986 Neglect of Duty)",
      "42:2000ag" : "42:2000ag (42:2000 Job Discrimination (Age))",
      "42:2000cc" : "42:2000cc (42:2000 Religious Land Use and Institutionalized Person Act (RLUIPA))",
      "42:2000e" : "42:2000e (42:2000e Job Discrimination (Employment))",
      "42:2000pb" : "42:2000pb (42:2000 Job Discrimination (Public Accommodations))",
      "42:2000ra" : "42:2000ra (42:2000ra Job Discrimination (Race))",
      "42:2000sx" : "42:2000sx (42:2000 Job Discrimination (Sex))",
      "42:2003" : "42:2003 (42:2003 Job Discrimination)",
      "42:2005" : "42:2005 (42:2005 Review of Agency Action-HHS)",
      "42:2615" : "42:2615 (42:2616 Medical Recovery Act)",
      "42:2651" : "42:2651 (42:2651 Medical Care Recovery)",
      "42:3601" : "42:3601 (42:405 Fair Housing Act)",
      "42:4000" : "42:4000 (42:4000 National Flood Insurance Act)",
      "42:4001" : "42:4001 (42:4001 National Insurance Flood Act)",
      "42:4053" : "42:4053 (42:4053 Breach of Insurance Contract)",
      "42:4072" : "42:4072 (42:4072 Payment of Flood Insurance Claim)",
      "42:4321" : "42:4321 (42:4321 Review of Agency Action-Environment)",
      "42:4332" : "42:4332 (42:4332)",
      "42:6901en" : "42:6901en (42:6901 Environmental Cleanup Expenses)",
      "42:6901rs" : "42:6901rs (42:6901 Resource & Recovery Act)",
      "42:7413" : "42:7413 (42:7413(b) Clean Air Act)",
      "42:7604cl" : "42:7604cl (42:7604 Clear Air Act (Emission Standards))",
      "42:7604ir" : "42:7604ir (42:7604 Petition to Quash IRS Summons)",
      "42:9607" : "42:9607 (42:9607 Real Property Tort to Land)",
      "43:945" : "43:945 (43:945 Compensation for Land Condemnation)",
      "43:945a" : "43:945a (43:945a Complaint in Condemnation)",
      "43:946" : "43:946 (43:946 Complaint in Condemnation - Eminent Domain)",
      "45:0051" : "45:0051 (45:51 Railways: Fed. Employer's Liability Act)",
      "45:0151" : "45:0151 (45:151 Railway Labor Act)",
      "45:0184" : "45:0184 (45:184 Action to Set Aside Award of a System Board of Adjust)",
      "45:1395" : "45:1395 (45:1395 Railroads: Adverse Reimbursement Review)",
      "45:7457" : "45:7457 (45:7457 Compel Reclamation Under Clear Air Act)",
      "46:0688" : "46:0688 (46:688 Jones Act)",
      "46:0741" : "46:0741 (46:741 Shipping)",
      "46:0761" : "46:0761 (46:761 Shipping: Damages for Death on High Seas)",
      "46:1101" : "46:1101 (46:1101 Violation of Maritime Regulations)",
      "46:1156" : "46:1156 (46:1156 Administrative Procedure Act)",
      "46:31325" : "46:31325 (46:31325 Preferred Mortgage Liens & Enforcement)",
      "47:0521" : "47:0521 (47:0521 Cable Communications Policy Act)",
      "47:0605" : "47:0605 (47:0605 Unauthorized publication or use of communications)",
      "47:227" : "47:227 (47:227 Telephone Consumer Protection Act)",
      "48:0883" : "48:0883 (48:883 Violation of US Coastal Law)",
      "48:1985" : "48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)",
      "49:0081" : "49:0081 (49:81 Damaged Goods While Being Transported)",
      "49:0781" : "49:0781 (49:781 Forfeiture)",
      "49:11503" : "49:11503 (49:11503 Railroad Revitalization Regulatory Reform)",
      "49:11702" : "49:11702 (49:11702(a)(4) Violations of Interstate Commerce A)",
      "49:14706" : "49:14706 (49:14706 Cargo Damage Claim - Interstate Commerce Act)",
      "49:1471" : "49:1471 (49:1471 Federal Aviation Act)",
      "49:1903" : "49:1903 (49:1903 Petition to enforce administrative summon)",
      "8:287" : "8:287 (8:287 Petition to Enforce INS Subpoena)",
      "99999" : "99999 (Complaint for Forfeiture)",
      "99:9999" : "99:9999 (99:9999 Report cause code (DO NOT DELETE!))",
      "adsup" : "adsup (Administrative Subpoena)",
      "apptcnsl" : "apptcnsl (Motion for appointment of counsel)",
      "contempt" : "contempt (Contempt Proceedings)",
      "disbar" : "disbar (Disbarment Proceedings)",
      "fordepo" : "fordepo (Foreign Deposition)",
      "gjproc" : "gjproc (Grand Jury Proceeding)",
      "misc" : "misc (Civil Miscellaneous Case)",
      "motcomp" : "motcomp (Motion to Compel)",
      "motquash" : "motquash (Motion to Quash)",
      "motret" : "motret (Motion for Return of Property)",
      "petenf" : "petenf (Petition to Enforce IRS Summons)",
      "petper" : "petper (Petition to Perpetuate Testimony)",
      "regjgm" : "regjgm (Registration of Foreign Judgment)",
      "tranbkref" : "tranbkref (Transmission of Bankruptcy Reference)",
      "tranff" : "tranff (Transmission of Proposed Findings of Fact and Concl. of Law)",
      "writgar" : "writgar (Application for a Writ of Garnishment)"
   },
   "nddce" : {
      "02:0431" : "02:0431 (02:431 Fed. Election Commission: Failure Enforce Compliance)",
      "02:0437" : "02:0437 (02:437 Federal Election Commission)",
      "05:0075" : "05:0075 (05:75(2) Contract - Reduction in Grade)",
      "05:0551" : "05:0551 (05:551 Administrative Procedure Act)",
      "05:0552fi" : "05:0552fi (05:552 Freedom of Information Act)",
      "05:0552pa" : "05:0552pa (05:552 Right to Privacy Act)",
      "05:0554" : "05:0554 (05:0554 Constitutionality of Maritime Statutes)",
      "05:0701" : "05:0701 (05:0701 Maritime Subsidy Board)",
      "05:0702" : "05:0702 (05:702 Administrative Procedure Act)",
      "05:0704" : "05:0704 (05:704 Labor Litigation)",
      "05:7703" : "05:7703 (05:7703 Discrimination - Review of Agency Act)",
      "07:0006" : "07:0006 (07:6(b) Federal Commodity Exchange Regulation)",
      "07:0025" : "07:0025 (07:25 Fraud - Commodities Leverage Contracts)",
      "07:0181" : "07:0181 (07:181 Packers & Stockyard Act)",
      "07:0499" : "07:0499 (07:499 Agricultural Commodities Act)",
      "07:0601" : "07:0601 (07:601 USDA Condemnation)",
      "07:2321" : "07:2321 (07:2321 Plant Variety Protection Act)",
      "08:0287" : "08:0287 (08:287 Petition to Enforce INS Subpoena)",
      "08:1105" : "08:1105 (08:1105(a) Aliens: Habeas Corpus to Release INS Detainee)",
      "08:1252" : "08:1252 (08:1252(a)(2) Injunction for Deportation)",
      "08:1260" : "08:1260 (08:1260 Aliens: Access to Records)",
      "08:1324" : "08:1324 (08:1324 Aliens: Complaint for Forfeiture)",
      "08:1329" : "08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petition)",
      "08:1446" : "08:1446 (08:1446 Petition for Naturalization Hearing)",
      "09:0001" : "09:0001 (09:1 U.S. Arbitration Act)",
      "09:0009" : "09:0009 (09:9 Motion to Confirm Arbitration Loan)",
      "09:0010" : "09:0010 (09:10 Petition to Vacate Arbitration Award)",
      "10:1552" : "10:1552 (10:1552 Armed Forces: Action to Correct Records)",
      "10:1553" : "10:1553 (10:1553 Armed Forces: FOIA General)",
      "10:2305" : "10:2305 (10:2305 Review of Federal Contract)",
      "11:0101" : "11:0101 (11:101 Bankruptcy)",
      "12:0022" : "12:0022 (12:22 Securities Fraud)",
      "12:0635" : "12:0635 (12:635 Breach of Insurance Contract)",
      "12:1461" : "12:1461 (12:1461 Homeowners Loan Act)",
      "12:1703" : "12:1703 (12:1703 Default of HUD Loan)",
      "12:1725" : "12:1725 (12:1725 Collection under Contract Guaranty)",
      "12:1730" : "12:1730 (12:1730 Collection under Contract Guaranty)",
      "12:1751" : "12:1751 (12:1751 Federal Credit Union Act)",
      "12:1819" : "12:1819 (12:1819 Default of Promissory Note)",
      "12:1821" : "12:1821 (12:1821 Default of Loan by Promissary Note)",
      "12:1971" : "12:1971 (12:1971 Relief under Bank Holding Act)",
      "12:3410" : "12:3410 (12:3410 Right to Financial Privacy Act)",
      "15:0001" : "15:0001 (15:1 Antitrust Litigation)",
      "15:0002at" : "15:0002at (15:2 Antitrust Litigation)",
      "15:0002fl" : "15:0002fl (15:2(a) Fair Labor Standards Act)",
      "15:0005" : "15:0005 (15:5(a) Fair Labor Standards Act)",
      "15:0015" : "15:0015 (15:15 Antitrust Litigation)",
      "15:0025" : "15:0025 (15:25 Clayton Act)",
      "15:0044" : "15:0044 (15:44 Trademark Infringement)",
      "15:0045" : "15:0045 (15:45 Federal Trade Commission Act)",
      "15:0052" : "15:0052 (15:52 Federal Trade Commission Act)",
      "15:0053" : "15:0053 (15:53 Federal Trade Commission Act)",
      "15:0053b" : "15:0053b (15:53(b) Prelim & Perm Inj Relief & Other Equitable Relief)",
      "15:0077" : "15:0077 (15:77 Securities Fraud)",
      "15:0078" : "15:0078 (15:78m(a) Securities Exchange Act)",
      "15:0631" : "15:0631 (15:631 Small Business Act)",
      "15:0717" : "15:0717 (15:717 Natural Gas Act)",
      "15:1051" : "15:1051 (15:1051 Trademark Infringement)",
      "15:1114" : "15:1114 (15:1114 Trademark Infringement)",
      "15:1121" : "15:1121 (15:1121 Trademark Infringement)",
      "15:1125" : "15:1125 (15:1125 Trademark Infringement (Lanham Act))",
      "15:1126" : "15:1126 (15:1126 Patent Infringement)",
      "15:1127" : "15:1127 (15:1127 Trademark Infringement)",
      "15:1601" : "15:1601 (15:1601 Truth in Lending)",
      "15:1640" : "15:1640 (15:1640 Truth in Lending)",
      "15:1681" : "15:1681 (15:1681 Fair Credit Reporting Act)",
      "15:1692" : "15:1692 (15:1692 Fair Debt Collection Act)",
      "15:1938" : "15:1938 (15:1938 Fair Labor Standards Act)",
      "15:1981" : "15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))",
      "15:1988" : "15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))",
      "15:1989" : "15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))",
      "15:2301" : "15:2301 (15:2301 Magnuson-Moss Warranty Act)",
      "15:2801" : "15:2801 (15:2801 Petroleum Marketing Practices Act)",
      "15:53(b)" : "15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equita)",
      "16:0668" : "16:0668 (16:668 Bald Eagle Protection Act)",
      "16:0703" : "16:0703 (16:703 Migratory Bird Act)",
      "16:1538" : "16:1538 (16:1538 Endangered Species Act)",
      "16:3371" : "16:3371 (16:3371 Wildlife under the Lacey Act)",
      "16:3372" : "16:3372 (16:3372 Conservation: Complaint for Forfeiture)",
      "16:3373" : "16:3373 (16:3373 Appeal of Decision-DOI)",
      "16:3374" : "16:3374 (16:3374 Conservation: Complaint for Forfeiture)",
      "17:0101" : "17:0101 (17:101 Copyright Infringement)",
      "17:0501" : "17:0501 (17:501 Copyright Infringement)",
      "17:0504" : "17:0504 (17:504 Copyright Infringement)",
      "18:0241" : "18:0241 (18:241 Conspiracy Against Citizen Rights)",
      "18:1514" : "18:1514 (Restrain Harassment of a Victim/Witness)",
      "18:1836a" : "18:1836a (18:1836(a) Injunction against Misappropriation of Trade Secrets)",
      "18:1836b" : "18:1836b (18:1836(b) Civil Action to Protect Trade Secrets)",
      "18:1961" : "18:1961 (18:1961 Racketeering (RICO) Act)",
      "18:1962" : "18:1962 (18:1962 Racketeering (RICO) Act)",
      "18:1964" : "18:1964 (18:1964 Racketeering (RICO) Act)",
      "18:4208" : "18:4208 (18:4208(B) Agency Action Review)",
      "19:1305" : "19:1305 (19:1305 Custom Duties:0Forfeiture-Immoral Articles)",
      "20:1080" : "20:1080 (20:1080 Student Loan Recovery)",
      "20:1400" : "20:1400 (20:1400 Civil Rights of Handicapped Child)",
      "20:1401" : "20:1401 (20:1401 Education: Handicapped Child Act)",
      "21:0841" : "21:0841 (21:841 Forfeiture Property-Drugs)",
      "21:0881" : "21:0881 (21:881 Forfeiture Property-Drugs)",
      "21:0881a" : "21:0881a (21:881 Forfeiture Property - Aircraft)",
      "21:0881re" : "21:0881re (21:881 Forfeiture Property - Real Estate)",
      "23:0134" : "23:0134 (23:134 P.I.- Auto Negligence)",
      "23:1441" : "23:1441 (23:1441 Contract Real Estate)",
      "24:1000" : "24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)",
      "25:0640" : "25:0640 (25:640 Indian Tribal Rights)",
      "25:1302" : "25:1302 (25:1302 Tribal Constitutional Rights)",
      "25:1303" : "25:1303 (25:1303 Tribal Habeas Corpus)",
      "25:1901" : "25:1901 (25:1901 Indian Child Welfare Act)",
      "26:6212" : "26:6212 (26:6212 Injunctive Relief from IRS Lien)",
      "26:6213" : "26:6213 (26:6213 Injunctive Relief from IRS Lien)",
      "26:6502" : "26:6502 (26:6502 IRS:Enforcement of tax liens)",
      "26:6532" : "26:6532 (26:6532 IRS: Refund of Tax Penalty)",
      "26:6702" : "26:6702 (26:6702 IRS: Refund of Income Tax Penalty)",
      "26:6703" : "26:6703 (26:6703 IRS: Refund of Tax Penalty)",
      "26:7401" : "26:7401 (26:7401 IRS: Tax Liability)",
      "26:7402" : "26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)",
      "26:7403" : "26:7403 (26:7403 Suit to Enforce Federal Tax Lien)",
      "26:7422rt" : "26:7422rt (26:7422 IRS: Refund Taxes)",
      "26:7422rx" : "26:7422rx (26:7422 IRS: Refund Excise Tax)",
      "26:7426" : "26:7426 (26:7426 IRS: Wrongful Levy for Taxes)",
      "26:7429" : "26:7429 (26:7429 IRS: Tax Jeopardy Assessment)",
      "26:7609" : "26:7609 (26:7609 IRS: Petition to Quash IRS Summons)",
      "27:0185" : "27:0185 (27:185 Enforcement of Arbitration Award)",
      "28:0157c" : "28:0157c (28:157(c)(1) Findings, Conclusion & Proposed Judgment)",
      "28:0157d" : "28:0157d (28:157 Motion for Withdrawal of Reference)",
      "28:0158" : "28:0158 (28:158 Notice of Appeal re Bankruptcy Matter (BAP))",
      "28:0185" : "28:0185 (28:185 Suit to Compel Arbitration)",
      "28:0451" : "28:0451 (28:451 Employment Discrimination)",
      "28:0794" : "28:0794 (28:794 Rehabilitation Act)",
      "28:1001" : "28:1001 (28:1001 ERISA)",
      "28:1132" : "28:1132 (28:1132 ERISA)",
      "28:1330" : "28:1330 (28:1330 Breach of Contract)",
      "28:1331" : "28:1331 (28:1331 Fed. Question)",
      "28:1331al" : "28:1331al (28:1331 Fed. Question: Airline Crash)",
      "28:1331at" : "28:1331at (28:1331 Fed. Question: Anti-trust)",
      "28:1331au" : "28:1331au (28:1331 Fed. Question: Auto Negligence)",
      "28:1331b" : "28:1331b (28:1331 Fed. Question: Bivens Act)",
      "28:1331bc" : "28:1331bc (28:1331 Fed. Question: Breach of Contract)",
      "28:1331ca" : "28:1331ca (28:1331 Fed. Question: Fed. Communications Act - 1934)",
      "28:1331cm" : "28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)",
      "28:1331cv" : "28:1331cv (28:1331 Fed. Question: Other Civil Rights)",
      "28:1331ed" : "28:1331ed (28:1331 Fed. Question: Employment Discrimination)",
      "28:1331es" : "28:1331es (28:1331 Enforcement of Administrative Subpoena)",
      "28:1331fl" : "28:1331fl (28:1331 Fed. Question: Fair Labor Standards)",
      "28:1331in" : "28:1331in (28:1331 Fed. Question: Insurance Contract)",
      "28:1331mm" : "28:1331mm (28:1331 Fed. Question: Medical Malpractice)",
      "28:1331pi" : "28:1331pi (28:1331 Fed. Question: Personal Injury)",
      "28:1331rd" : "28:1331rd (28:1331 Fed. Question: Review Agency Decision)",
      "28:1331rp" : "28:1331rp (28:1331(a) Fed. Question: Real Property)",
      "28:1331rr" : "28:1331rr (28:1331 Fed. Question: Railway Labor Act)",
      "28:1331sv" : "28:1331sv (28:1331 Fed. Question: Securities Violation)",
      "28:1331tr" : "28:1331tr (28:1331 Fed. Question: Trademark)",
      "28:1331tt" : "28:1331tt (28:1331 Fed. Question: Tort Action)",
      "28:1331v" : "28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendment)",
      "28:1331wl" : "28:1331wl (28:1331 Fed. Question: EPA Waste Lien)",
      "28:1331wt" : "28:1331wt (28:1331 Fed. Question: Water Rights)",
      "28:1332ac" : "28:1332ac (28:1332 Diversity-Account Receivable)",
      "28:1332al" : "28:1332al (28:1332 Diversity-Airline Crash)",
      "28:1332as" : "28:1332as (28:1332 Diversity-Asbestos Litigation)",
      "28:1332au" : "28:1332au (28:1332 Diversity-Auto Negligence)",
      "28:1332bc" : "28:1332bc (28:1332 Diversity-Breach of Contract)",
      "28:1332co" : "28:1332co (28:1332 Diversity-Conversion)",
      "28:1332ct" : "28:1332ct (28:1332 Diversity-Citizenship)",
      "28:1332det" : "28:1332det (28:1332 Diversity-Forcible Detainer)",
      "28:1332df" : "28:1332df (28:1332 Diversity-Contract Default)",
      "28:1332ds" : "28:1332ds (28:1332 Diversity-Contract Dispute)",
      "28:1332ed" : "28:1332ed (28:1332 Diversity-Employment Discrimination)",
      "28:1332fd" : "28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)",
      "28:1332fr" : "28:1332fr (28:1332 Diversity-Fraud)",
      "28:1332ia" : "28:1332ia (28:1332 Diversity-Interpleader Action)",
      "28:1332ij" : "28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)",
      "28:1332in" : "28:1332in (28:1332 Diversity-Insurance Contract)",
      "28:1332jd" : "28:1332jd (28:1332 Diversity-Declaratory Judgment)",
      "28:1332lb" : "28:1332lb (28:1332 Diversity-Libel,Assault,Slander)",
      "28:1332lm" : "28:1332lm (28:1332 Diversity-Legal Malpractice)",
      "28:1332ma" : "28:1332ma (28:1332 Diversity-Miller Act)",
      "28:1332mm" : "28:1332mm (28:1332 Diversity-Medical Malpractice)",
      "28:1332mv" : "28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)",
      "28:1332ni" : "28:1332ni (28:1332 Diversity-Negotiable Instrument)",
      "28:1332nm" : "28:1332nm (28:1332 Diversity-Non-Motor Vehicle)",
      "28:1332oc" : "28:1332oc (28:1332 Diversity-Other Contract)",
      "28:1332pd" : "28:1332pd (28:1332 Diversity-Property Damage)",
      "28:1332pi" : "28:1332pi (28:1332 Diversity-Personal Injury)",
      "28:1332pl" : "28:1332pl (28:1332 Diversity-Product Liability)",
      "28:1332pr" : "28:1332pr (28:1332 Diversity-Petition for Removal)",
      "28:1332qt" : "28:1332qt (28:1332 Diversity-Petition to Quiet Title)",
      "28:1332ri" : "28:1332ri (28:1332 Diversity-Racketeering Act (RICO))",
      "28:1332sa" : "28:1332sa (28:1332 Diversity-Securities & Exchange Commission Act)",
      "28:1332sf" : "28:1332sf (28:1332 Diversity-Securities Fraud)",
      "28:1332ss" : "28:1332ss (28:1332 Diversity - Stockholders Suits)",
      "28:1332tl" : "28:1332tl (28:1332 Diversity-Torts to Land)",
      "28:1332tm" : "28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))",
      "28:1332tn" : "28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)",
      "28:1332wd" : "28:1332wd (28:1332 Diversity-Wrongful Death)",
      "28:1333" : "28:1333 (28:1333 Admiralty)",
      "28:1334" : "28:1334 (28:1334 Bankruptcy Appeal)",
      "28:1334c" : "28:1334c (28:1334(c) R&R re motions for abstention (non-core))",
      "28:1335" : "28:1335 (28:1335 Interpleader Action)",
      "28:1337" : "28:1337 (28:1337 Sherman-Clayton Act)",
      "28:1338cp" : "28:1338cp (28:1338 Copyright Infringement)",
      "28:1338pt" : "28:1338pt (28:1338 Patent Infringement)",
      "28:1338tr" : "28:1338tr (28:1338 Trademark Infringement)",
      "28:1340" : "28:1340 (28:1340 IRS: Custom Duties)",
      "28:1340er" : "28:1340er (28:1340 Recovery of Erroneous Refund)",
      "28:1341" : "28:1341 (28:1341 Complaint for Forfeiture)",
      "28:1343" : "28:1343 (28:1343 Violation of Civil Rights)",
      "28:1345co" : "28:1345co (28:1345 Replevin & Conversion)",
      "28:1345db" : "28:1345db (28:1345 Debt to US - FHA/HUD Title I)",
      "28:1345df" : "28:1345df (28:1345 Default of Promissory Note)",
      "28:1345er" : "28:1345er (28:1345 Recovery of Erroneous Refund)",
      "28:1345fc" : "28:1345fc (28:1345 Foreclosure)",
      "28:1345ff" : "28:1345ff (28:1345 Complaint for Forfeiture)",
      "28:1345hl" : "28:1345hl (28:1345 VA Home Loan Guaranty Debt)",
      "28:1345mc" : "28:1345mc (28:1345 Medical Care Recovery)",
      "28:1345mi" : "28:1345mi (28:1345 Mining Claim Ejectment)",
      "28:1345pd" : "28:1345pd (28:1345 Property Damage)",
      "28:1345pe" : "28:1345pe (28:1345 Property Ejectment)",
      "28:1345rc" : "28:1345rc (28:1345 Recovery of Debt to US)",
      "28:1345st" : "28:1345st (28:1345 Default of Student Loan)",
      "28:1345tp" : "28:1345tp (28:1345 Trespass on Public Land)",
      "28:1345va" : "28:1345va (28:1345 Recovery of VA Overpayment)",
      "28:1346bc" : "28:1346bc (28:1346 Breach of Contract)",
      "28:1346rc" : "28:1346rc (28:1346 Recovery of IRS Tax)",
      "28:1346tc" : "28:1346tc (28:1346 Tort Claim)",
      "28:1346wd" : "28:1346wd (28:1346 Wrongful Death)",
      "28:1352" : "28:1352 (28:1352 Miller Act)",
      "28:1355" : "28:1355 (28:1355 Petition for Return of Property)",
      "28:1358" : "28:1358 (28:1358 Land Condemnation)",
      "28:1361" : "28:1361 (28:1361 Petition for Writ of Mandamus)",
      "28:1362ic" : "28:1362ic (28:1362 Indian Tribal Controversy)",
      "28:1362iw" : "28:1362iw (28:1362 Declaration re Indian Tribal Water Rights)",
      "28:1364" : "28:1364 (28:1364 Auto Negligence)",
      "28:1391" : "28:1391 (28:1391 Personal Injury)",
      "28:1402" : "28:1402 (28:1402 Medical Malpractice)",
      "28:1407" : "28:1407 (28:1407 Airline Crash)",
      "28:1441ac" : "28:1441ac (28:1441 Petition for Removal- Account Receivable)",
      "28:1441al" : "28:1441al (28:1441 Petition for Removal- Airline Crash)",
      "28:1441as" : "28:1441as (28:1441 Petition for Removal- Asbestos Litigation)",
      "28:1441au" : "28:1441au (28:1441 Petition for Removal- Auto Negligence)",
      "28:1441bc" : "28:1441bc (28:1441 Petition for Removal- Breach of Contract)",
      "28:1441cv" : "28:1441cv (28:1441 Petition for Removal- Civil Rights Act)",
      "28:1441df" : "28:1441df (28:1441 Petition for Removal- Contract Default)",
      "28:1441dj" : "28:1441dj (28:1441 Petition for Removal- Declaratory Judgment)",
      "28:1441ds" : "28:1441ds (28:1441 Petition for Removal- Contract Dispute)",
      "28:1441ed" : "28:1441ed (28:1441 Petition for Removal- Employment Discrimination)",
      "28:1441fc" : "28:1441fc (28:1441 Petition for Removal- Fair Credit Reporting Act)",
      "28:1441fr" : "28:1441fr (28:1441 Petition for Removal- Fraud)",
      "28:1441ij" : "28:1441ij (28:1441 Petition for Removal- Injunctive/Declaratory Relief)",
      "28:1441in" : "28:1441in (28:1441 Petition for Removal- Insurance Contract)",
      "28:1441int" : "28:1441int (28:1441 Petition for Removal- Action for Interpleader)",
      "28:1441lb" : "28:1441lb (28:1441 Petition for Removal- Libel, Assault, Slander)",
      "28:1441lm" : "28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relations)",
      "28:1441mm" : "28:1441mm (28:1441 Petition for Removal- Medical Malpractice)",
      "28:1441ni" : "28:1441ni (28:1441 Petition for Removal- Negotiable Instrument)",
      "28:1441nm" : "28:1441nm (28:1441 Petition for Removal- Non-Motor Vehicle)",
      "28:1441oc" : "28:1441oc (28:1441 Petition for Removal- Other Contract)",
      "28:1441pd" : "28:1441pd (28:1441 Petition for Removal- Property Damage)",
      "28:1441pi" : "28:1441pi (28:1441 Petition for Removal- Personal Injury)",
      "28:1441pl" : "28:1441pl (28:1441 Petition for Removal- Product Liability)",
      "28:1441pr" : "28:1441pr (28:1441 Petition for Removal)",
      "28:1441qt" : "28:1441qt (28:1441 Petition for Removal- Petition to Quiet Title)",
      "28:1441ri" : "28:1441ri (28:1441 Petition for Removal- Racketeering (RICO) Act)",
      "28:1441sa" : "28:1441sa (28:1441 Petition for Removal- SEC Act)",
      "28:1441sf" : "28:1441sf (28:1441 Petition for Removal- Securities Fraud)",
      "28:1441tl" : "28:1441tl (28:1441 Petition for Removal- Torts to Land)",
      "28:1441tm" : "28:1441tm (28:1441 Petition for Removal- Tort/Motor Vehicle (P.I.))",
      "28:1441tn" : "28:1441tn (28:1441 Petition for Removal- Tort/Non-Motor Vehicle)",
      "28:1441wd" : "28:1441wd (28:1441 Petition for Removal- Wrongful Death)",
      "28:1442bc" : "28:1442bc (28:1442 Petition for Removal- Breach of Contract)",
      "28:1442pr" : "28:1442pr (28:1442 Petition for Removal)",
      "28:1443" : "28:1443 (28:1443(1) Rent, Lease & Ejectment)",
      "28:1444" : "28:1444 (28:1444 Petition for Removal- Foreclosure)",
      "28:1446in" : "28:1446in (28:1446 Breach of Contract- Insurance)",
      "28:1446pd" : "28:1446pd (28:1446 Petition for Removal- Property Damage (P.I.))",
      "28:1446pi" : "28:1446pi (28:1446 Petition for Removal- Personal Injury)",
      "28:1446pl" : "28:1446pl (28:1446 Petition for Removal- Product Liability)",
      "28:1446pr" : "28:1446pr (28:1446 Petition for Removal)",
      "28:1452" : "28:1452 (28:1452 R&R re motions to remand (non-core))",
      "28:1651" : "28:1651 (28:1651 Petition for Writ of Coram Nobis)",
      "28:1651hc" : "28:1651hc (28:1651 Petition for Writ of Habeas Corpus)",
      "28:1651mn" : "28:1651mn (28:1651 Petition for Writ of Mandamus)",
      "28:1983" : "28:1983 (28:1983 Civil Rights)",
      "28:2201" : "28:2201 (28:2201 Constitutionality of State Statute(s))",
      "28:2201dj" : "28:2201dj (28:2201 Declaratory Judgment)",
      "28:2201ij" : "28:2201ij (28:2201 Injunction)",
      "28:2201in" : "28:2201in (28:2201 Declaratory Judgment (Insurance))",
      "28:2241" : "28:2241 (28:2241 Petition for Writ of Habeas Corpus (Federal))",
      "28:2254" : "28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))",
      "28:2254se" : "28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)",
      "28:2255" : "28:2255 (28:2255 Motion to Vacate / Correct Illegal Sentence)",
      "28:2271" : "28:2271 (28:2271 Federal Tort Claims Act)",
      "28:2345" : "28:2345 (28:2345 Medicare Recovery)",
      "28:2409" : "28:2409 (28:2409(a) Quiet Title Action)",
      "28:2410" : "28:2410 (28:2410 Quiet Title)",
      "28:2671" : "28:2671 (28:2671 Federal Tort Claims Act)",
      "28:2674" : "28:2674 (28:2674 Federal Tort Claims Act)",
      "28:7402" : "28:7402 (28:7402 Refund of Taxes)",
      "28:7422" : "28:7422 (28:7422 Appeal from Administrative Decision)",
      "29:0151" : "29:0151 (29:151 Labor: Review of Agency Action)",
      "29:0160" : "29:0160 (29:160(1) National Labor Relations Act)",
      "29:0184" : "29:0184 (29:184 Violation Collection Bargain Agreement)",
      "29:0185ep" : "29:0185ep (29:185 Employee Pension Plan)",
      "29:0185lm" : "29:0185lm (29:185 Labor/Mgt. Relations (Contracts))",
      "29:0201do" : "29:0201do (29:201 Denial of Overtime Compensation)",
      "29:0201fl" : "29:0201fl (29:201 Fair Labor Standards Act)",
      "29:0203" : "29:0203 (29:203 Equal Pay Act)",
      "29:0206" : "29:0206 (29:206 Collect Unpaid Wages)",
      "29:0401" : "29:0401 (29:401 Labor Management Disclosure Act)",
      "29:0621" : "29:0621 (29:621 Job Discrimination (Age))",
      "29:0623" : "29:0623 (29:623 Job Discrimination (Age))",
      "29:0626" : "29:0626 (29:626 Job Discrimination (Age))",
      "29:0633" : "29:0633 (29:633 Job Discrimination (Age))",
      "29:0651" : "29:0651 (29:651 Occupational Safety/Health)",
      "29:0754" : "29:0754 (29:754 Discrimination)",
      "29:0790" : "29:0790 (29:790 Rehabilitation of Labor)",
      "29:0791" : "29:0791 (29:791 Job Discrimination (Rehabilitation Act))",
      "29:0794" : "29:0794 (29:794 Job Discrimination (Handicap))",
      "29:1001" : "29:1001 (29:1001 ERISA - Employee Retirement)",
      "29:1002" : "29:1002 (29:1002 ERISA - Employee Retirement)",
      "29:1104" : "29:1104 (29:1104 Recovery of Benefits to Employee)",
      "29:1109" : "29:1109 (29:1109 Breach of Fiduciary Duties)",
      "29:1131" : "29:1131 (29:1131 ERISA - Collection of Delinquent Trust Funds)",
      "29:1132" : "29:1132 (29:1132 ERISA - Employee Benefits)",
      "29:1145" : "29:1145 (29:1145 ERISA)",
      "29:1149" : "29:1149 (29:1149 Recover Pension & Profit Sharing)",
      "29:1337" : "29:1337 (29:1337 ERISA)",
      "29:1362" : "29:1362 (29:1362 ERISA)",
      "29:1381" : "29:1381 (29:1381 ERISA)",
      "29:1401" : "29:1401 (29:1401(b)(2) Appeal of Arbitration Award)",
      "29:1451" : "29:1451 (29:1451 ERISA)",
      "29:1801" : "29:1801 (29:1801 Farmworker Rights)",
      "29:2601" : "29:2601 (Family and Medical Leave Act of 1993)",
      "29:790" : "29:790 (29:790 Rehabilitation of Labor)",
      "30:0181" : "30:0181 (30:181 Environment: Review of Agency Action)",
      "30:0801" : "30:0801 (30:801 Penalties/Federal Mine Safety Health Act)",
      "30:1201" : "30:1201 (30:1201 Environment: Review of Agency Action)",
      "30:1202" : "30:1202 (30:1202 Mining Reclamation Act)",
      "30:1276" : "30:1276 (30:1276 Interior: Review of Agency Action)",
      "31:3545" : "31:3545 (31:3545 Action to Recovery Money)",
      "31:3729" : "31:3729 (31:3729 False Claims Act)",
      "31:3730" : "31:3730 (31:3730 Qui Tam False Claims Act)",
      "31:3731" : "31:3731 (31:3731 Fraud)",
      "33:1319cw" : "33:1319cw (33:1319 Clean Water Act)",
      "33:1319pv" : "33:1319pv (33:1319 Pollutants & Permit Violations)",
      "33:1365" : "33:1365 (33:1365 Environmental Matters)",
      "35:0145" : "35:0145 (35:145 Patent Infringement)",
      "35:0183" : "35:0183 (35:183 Patent Infringement)",
      "35:0271" : "35:0271 (35:271 Patent Infringement)",
      "38:1681" : "38:1681 (38:1681 Recovery of VA Overpayment)",
      "38:1686" : "38:1686 (38:1686 Recovery of VA Overpayment)",
      "38:1780" : "38:1780 (38:1780 Recovery of VA Overpayment)",
      "38:2011" : "38:2011 (38:2011 Veteran's Readjustment Assistance Act - 1974)",
      "38:3116" : "38:3116 (38:3116 VA Overpayment)",
      "39:3005" : "39:3005 (39:3005 Detention of Mail for Temporary Periods)",
      "39:409" : "39:409 (39:409 Postal Service)",
      "40:0258" : "40:0258 (40:258(a) Public Buildings & Property: Land Condemnation)",
      "40:0270" : "40:0270 (40:270 Miller Act)",
      "40:0875" : "40:0875 (40:875 Public Buildings & Property: Negligence)",
      "41:0251" : "41:0251 (41:251 Public Contracts-Review of Agency Action)",
      "41:1463" : "41:1463 (41:1463 Public Contracts: Unlawful Employment Practices)",
      "42:0205" : "42:0205 (42:205 Denial Social Security Benefits)",
      "42:0206" : "42:0206 (42:206 Social Security Benefits)",
      "42:0247" : "42:0247 (42:247 Personal Injury-Swine Flu)",
      "42:0402" : "42:0402 (42:402 Social Security Benefits)",
      "42:0405id" : "42:0405id (42:405 Review of HHS Decision (SSID))",
      "42:0405wc" : "42:0405wc (42:405 Review of HHS Decision (DIWC))",
      "42:0405ww" : "42:0405ww (42:405 Review of HHS Decision (DIWW))",
      "42:0416" : "42:0416 (42:416 Denial of Social Security Benefits)",
      "42:0427" : "42:0427 (42:427 Social Security Benefits)",
      "42:12101" : "42:12101 (42:12101 Disabilities Act of 1990)",
      "42:1383" : "42:1383 (42:1383 Review of HHS Decision)",
      "42:1395" : "42:1395 (42:1395 HHS Adverse Reimbursement Review)",
      "42:1396" : "42:1396 (42:1396 Tort Negligence)",
      "42:1471" : "42:1471 (42:1471 Declaratory & Injunctive Relief-Foreclosure Sale)",
      "42:1981cv" : "42:1981cv (42:1981 Civil Rights)",
      "42:1981hs" : "42:1981hs (42:1981 Housing Discrimination)",
      "42:1981jb" : "42:1981jb (42:1981 Job Discrimination (Race))",
      "42:1981sx" : "42:1981sx (42:1981 Sex Discrimination)",
      "42:1983cv" : "42:1983cv (42:1983 Civil Rights Act)",
      "42:1983ed" : "42:1983ed (42:1983 Civil Rights (Employment Discrimination))",
      "42:1983pr" : "42:1983pr (42:1983 Prisoner Civil Rights)",
      "42:1986" : "42:1986 (42:1986 Neglect of Duty)",
      "42:2000ag" : "42:2000ag (42:2000 Job Discrimination (Age))",
      "42:2000e" : "42:2000e (42:2000 Job Discrimination (Employment))",
      "42:2000pb" : "42:2000pb (42:2000 Job Discrimination (Public Accomodations))",
      "42:2000ra" : "42:2000ra (42:2000 Job Discrimination (Race))",
      "42:2000sx" : "42:2000sx (42:2000 Job Discrimination (Sex))",
      "42:2003" : "42:2003 (42:2003 Job Discrimination)",
      "42:2005" : "42:2005 (42:2005 Review of Agency Action-HHS)",
      "42:2651" : "42:2651 (42:2651 Medical Care Recovery)",
      "42:3601" : "42:3601 (42:3601 Fair Housing Act)",
      "42:4000" : "42:4000 (42:4000 National Flood Insurance Act)",
      "42:4001" : "42:4001 (42:4001 National Insurance Flood Act)",
      "42:4053" : "42:4053 (42:4053 Breach of Insurance Contract)",
      "42:4072" : "42:4072 (42:4072 Payment of Flood Insurance Claim)",
      "42:4321" : "42:4321 (42:4321 Review of Agency Action-Environment)",
      "42:4332" : "42:4332 (42:4332 Environmental Policy - Coop of Agency Reports)",
      "42:6901en" : "42:6901en (42:6901 Environmental Cleanup Expenses)",
      "42:6901rs" : "42:6901rs (42:6901 Resource & Recovery Act)",
      "42:7413" : "42:7413 (42:7413(b) Clean Air Act)",
      "42:7604cl" : "42:7604cl (42:7604 Clear Air Act (Emission Standards))",
      "42:7604ir" : "42:7604ir (42:7604 Petition to Quash IRS Summons)",
      "42:9607" : "42:9607 (42:9607 Real Property Tort to Land)",
      "43:0945" : "43:0945 (43:945 Compensation for Land Condemnation)",
      "43:0945a" : "43:0945a (43:945 Complaint in Condemnation)",
      "43:0946" : "43:0946 (43:946 Complaint in Condemnation - Eminent Domain)",
      "43:945" : "43:945 (43:945 Compensation for Land Condemnation)",
      "43:945a" : "43:945a (43:945a Complaint in Condemnation)",
      "43:946" : "43:946 (43:946 Complaint in Condemnation - Eminent Domain)",
      "45:0051" : "45:0051 (45:51 Railways: Fed. Employer's Liability Act)",
      "45:0151" : "45:0151 (45:151 Railway Labor Act)",
      "45:0184" : "45:0184 (45:184 Action to Set Aside Award of a System Board of Adjust)",
      "45:1395" : "45:1395 (45:1395 Railroads: Adverse Reimbursement Review)",
      "45:7457" : "45:7457 (45:7457 Compel Reclamation Under Clear Air Act)",
      "46:0688" : "46:0688 (46:688 Jones Act)",
      "46:0741" : "46:0741 (46:741 Shipping)",
      "46:0761" : "46:0761 (46:761 Shipping: Damages for Death on High Seas)",
      "46:1101" : "46:1101 (46:1101 Violation of Maritime Regulations)",
      "46:1156" : "46:1156 (46:1156 Administrative Procedure Act)",
      "47:252" : "47:252 (47:252 Telecommunications Act of 1996)",
      "48:0883" : "48:0883 (48:883 Violation of US Coastal Law)",
      "48:1985" : "48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)",
      "49:0081" : "49:0081 (49:81 Damaged Goods While Being Transported)",
      "49:0781" : "49:0781 (49:781 Forfeiture)",
      "49:11503" : "49:11503 (49:11503 Railroad Revitalization Regulatory Reform Act)",
      "49:11702" : "49:11702 (49:11702(a)(4) Violations of Interstate Commerce Act)",
      "49:1471" : "49:1471 (49:1471 Federal Aviation Act)",
      "49:1903" : "49:1903 (49:1903 Petition to Enforce Administrative Summons)",
      "8:287" : "8:287 (8:287 Petition to Enforce INS Subpoena)",
      "misc" : "misc (Civil Miscellaneous Case)"
   },
   "nedce" : {
      "0" : "0 (No cause code entered)",
      "00:0000" : "00:0000 (00:0000 Cause Code Unknown )",
      "02:0431" : "02:0431 (02:431 Fed. Election Commission: Failure Enforce C)",
      "02:0437" : "02:0437 (02:437 Federal Election Commission)",
      "05:0075" : "05:0075 (05:75(2) Contract - Reduction in Grade)",
      "05:0551" : "05:0551 (05:551 Administrative Procedure Act)",
      "05:0552fi" : "05:0552fi (05:552 Freedom of Information Act)",
      "05:0552pa" : "05:0552pa (05:552 Right to Privacy Act)",
      "05:0554" : "05:0554 (05:0554 Constitutionality of Maritime Statutes)",
      "05:0701" : "05:0701 (05:0701 Maritime Subsidy Board)",
      "05:0702" : "05:0702 (05:702 Administrative Procedure Act)",
      "05:0704" : "05:0704 (05:704 Labor Litigation)",
      "05:7703" : "05:7703 (05:7703 Discrimination - Review of Agency Act)",
      "05:8902" : "05:8902 (05:8902 Health Insurance - Govt Organizations and Employees)",
      "07:0006" : "07:0006 (7:6(b) Federal Commodity Exchange Regulation)",
      "07:0025" : "07:0025 (7:25 Fraud - Commodities Leverage Contracts)",
      "07:0181" : "07:0181 (07:181 Packers & Stockyard Act)",
      "07:0499" : "07:0499 (07:499 Agricultural Commodities Act)",
      "07:0601" : "07:0601 (07:601 USDA Condemnation)",
      "07:1508" : "07:1508 ( 07:1508 Crop Insurance)",
      "07:1631" : "07:1631 (07:1631 Food Security Act of 1985)",
      "07:2023" : "07:2023 (07:2023 Food Stamp Program)",
      "07:2131" : "07:2131 (07:2131 Animal Welfare Act)",
      "07:2321" : "07:2321 (07:2321 Plant Variety Protection Act)",
      "08:1105" : "08:1105 (8:1105(a) Aliens: Habeas Corpus to Release INS Det)",
      "08:1154" : "08:1154 (08:1154 Immigration and Nationality Act)",
      "08:1252" : "08:1252 (08:1252(a)(2) Injunction for Deportation)",
      "08:1260" : "08:1260 (08:1260 Aliens: Access to Records)",
      "08:1324" : "08:1324 (08:1324 Aliens: Complaint for Forfeiture)",
      "08:1329" : "08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petiti)",
      "08:1446" : "08:1446 (8:1446 Petition for Naturalization Hearing)",
      "08:1451" : "08:1451 (8:1451 Revocation of Naturalization Proceedings)",
      "09:0001" : "09:0001 (09:1 U.S. Arbitration Act)",
      "09:0009" : "09:0009 (9:9 Motion to Confirm Arbitration Loan)",
      "09:0010" : "09:0010 (09:0010 Petition to Vacate Arbitration Award)",
      "10:1552" : "10:1552 (10:1552 Armed Forces: Action to Correct Records)",
      "10:1553" : "10:1553 (10:1553 Armed Forces: FOIA General)",
      "10:2005" : "10:2005 (10:2005 Advanced Education Assistance)",
      "10:2305" : "10:2305 (10:2305 Review of Federal Contract)",
      "11:0101" : "11:0101 (11:101 Bankruptcy)",
      "12:0022" : "12:0022 (12:22 Securities Fraud)",
      "12:0635" : "12:0635 (12:635 Breach of Insurance Contract)",
      "12:1461" : "12:1461 (12:1461 Homeowners Loan Act)",
      "12:1703" : "12:1703 (12:1703 Default of HUD Loan)",
      "12:1725" : "12:1725 (12:1725 Collection under Contract Guaranty)",
      "12:1730" : "12:1730 (12:1730 Collection Under Contract Guaranty)",
      "12:1751" : "12:1751 (12:1751 Federal Credit Union Act)",
      "12:1819" : "12:1819 (12:1819 Default of Promissory Note)",
      "12:1821" : "12:1821 (12:1821 Default of Loan by Promissary Note)",
      "12:1971" : "12:1971 (12:1971 Relief under Bank Holding Act)",
      "12:3410" : "12:3410 (12:3410 Right to Financial Privacy Act)",
      "15:0001" : "15:0001 (15:1 Antitrust Litigation)",
      "15:0002at" : "15:0002at (15:2 Antitrust Litigation)",
      "15:0002fl" : "15:0002fl (15:2(a) Fair Labor Standards Act)",
      "15:0005" : "15:0005 (15:5(a) Fair Labor Standards Act)",
      "15:0015" : "15:0015 (15:15 Antitrust Litigation)",
      "15:0025" : "15:0025 (15:25 Clayton Act)",
      "15:0044" : "15:0044 (15:44 Trademark Infringement)",
      "15:0045" : "15:0045 (15:0045 Federal Trade Commission Act)",
      "15:0052" : "15:0052 (15:0052 Federal Trade Commission Act)",
      "15:0053" : "15:0053 (15:0053 Federal Trade Commission Act)",
      "15:0077" : "15:0077 (15:77 Securities Fraud)",
      "15:0078" : "15:0078 (15:78m(a) Securities Exchange Act)",
      "15:0631" : "15:0631 (15:631 Small Business Act)",
      "15:0717" : "15:0717 (15:717 Natural Gas Act)",
      "15:1051" : "15:1051 (15:1051 Trademark Infringement)",
      "15:1114" : "15:1114 (15:1114 Trademark Infringement)",
      "15:1121" : "15:1121 (15:1121 Trademark Infringement)",
      "15:1125" : "15:1125 (15:1125 Trademark Infringement (Lanham Act))",
      "15:1126" : "15:1126 (15:1126 Patent Infringement)",
      "15:1127" : "15:1127 (15:1127 Trademark Infringement)",
      "15:1601" : "15:1601 (15:1601 Truth in Lending)",
      "15:1640" : "15:1640 (15:1640 Truth in Lending)",
      "15:1681" : "15:1681 (15:1681 Fair Credit Reporting Act)",
      "15:1691" : "15:1691 (15:1691 Equal Credit Opportunity Act)",
      "15:1692" : "15:1692 (15:1692 Fair Debt Collection Act)",
      "15:1938" : "15:1938 (15:1938 Fair Labor Standards Act)",
      "15:1981" : "15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))",
      "15:1988" : "15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))",
      "15:1989" : "15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))",
      "15:2301" : "15:2301 (15:2301 Magnuson-Moss Warranty Act)",
      "15:2801" : "15:2801 (15:2801 Petroleum Marketing Practices Act)",
      "15:53(b)" : "15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equita)",
      "16:0668" : "16:0668 (16:668 Bald Eagle Protection Act)",
      "16:0703" : "16:0703 (16:703 Migratory Bird Act)",
      "16:1241" : "16:1241 (16:1241 National Trails System Act)",
      "16:1538" : "16:1538 (16:1538 Endangered Species Act)",
      "16:3371" : "16:3371 (16:3371 Wildlife Under the Lacey Act)",
      "16:3372" : "16:3372 (16:3372 Conservation: Complaint for Forfeiture)",
      "16:3373" : "16:3373 (16:3373 Appeal of Decision - DOI)",
      "16:3374" : "16:3374 (16:3374 Conservation: Complaint for Forfeiture)",
      "17:0101" : "17:0101 (17:101 Copyright Infringement)",
      "17:0501" : "17:0501 (17:501 Copyright Infringement)",
      "17:0504" : "17:0504 (17:504 Copyright Infringement)",
      "17:0512" : "17:0512 (17:512 Digital Millennium Copyright Act)",
      "18:0241" : "18:0241 (18:241 Conspiracy Against Citizen Rights)",
      "18:0925" : "18:0925 (18:925 Firearm)",
      "18:1345" : "18:1345 (18:1345 Injunctions against fraud)",
      "18:1836a" : "18:1836a (18:1836(a) Injunction against Misappropriation of Trade Secrets)",
      "18:1836b" : "18:1836b (18:1836(b) Civil Action to Protect Trade Secrets)",
      "18:1961" : "18:1961 (18:1961 Racketeering (RICO) Act)",
      "18:1962" : "18:1962 (18:1962 Racketeering (RICO) Act)",
      "18:1964" : "18:1964 (18:1964 Racketeering (RICO) Act)",
      "18:2520" : "18:2520 (18:2520 Interception of Electronic Communication)",
      "18:4208" : "18:4208 (18:4208(B) Agency Action Review)",
      "19:1305" : "19:1305 (19:1305 Custom Duties:0Forfeiture-Immoral Articles)",
      "19:1584" : "19:1584 (19:1584 Tariff Act of 1930)",
      "20:1080" : "20:1080 (20:1080 Student Loan Recovery)",
      "20:1400" : "20:1400 (20:1400 Civil Rights of Handicapped Child)",
      "20:1401" : "20:1401 (20:1401 Education: Handicapped Child Act)",
      "21:0601" : "21:0601 (21:601 Federal Meat Inspection Act)",
      "21:0841" : "21:0841 (21:841 Forfeiture Property-Drugs)",
      "21:0881" : "21:0881 (21:881 Forfeiture Property-Drugs)",
      "21:0881a" : "21:0881a (21:881 Forfeiture Property - Aircraft)",
      "21:0881j" : "21:0881j (21:0881j Forfeiture Property - Gambling)",
      "21:0881re" : "21:0881re (21:881 Forfeiture Property - Real Estate)",
      "23:0134" : "23:0134 (23:134 P.I.- Auto Negligence)",
      "23:1441" : "23:1441 (23:1441 Contract Real Estate)",
      "24:1000" : "24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)",
      "24:4072" : "24:4072 (24:4072 Federal Flood Insurance Claim)",
      "25:0640" : "25:0640 (25:640 Indian Tribal Rights)",
      "25:1901" : "25:1901 (25:1901 Indian Child Welfare Act)",
      "25:2701" : "25:2701 (25:2701 Indian Gaming Regulatory Act (IGRA))",
      "26:6212" : "26:6212 (26:6212 Injunctive Relief from IRS Lien)",
      "26:6213" : "26:6213 (26:6213 Injunctive Relief from IRS Lien)",
      "26:6502" : "26:6502 (26:6502 IRS:Enforcement of tax liens)",
      "26:6532" : "26:6532 (26:6532 IRS: Refund of Tax Penalty)",
      "26:6702" : "26:6702 (26:6702 IRS: Refund of Income Tax Penalty)",
      "26:6703" : "26:6703 (26:6703 IRS: Refund of Tax Penalty)",
      "26:7401" : "26:7401 (26:7401 IRS: Tax Liability)",
      "26:7402" : "26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)",
      "26:7403" : "26:7403 (26:7403 Suit to Enforce Federal Tax Lien)",
      "26:7422rt" : "26:7422rt (26:7422 IRS: Refund Taxes)",
      "26:7422rx" : "26:7422rx (26:7422 IRS: Refund Excise Tax)",
      "26:7426" : "26:7426 (26:7426 IRS: Wrongful Levy for Taxes)",
      "26:7429" : "26:7429 (26:7429 IRS: Tax Jeopardy Assessment)",
      "26:7609" : "26:7609 (26:7609 IRS: Petition to Quash IRS Summons)",
      "27:0185" : "27:0185 (27:185 Enforcement of Arbitration Award)",
      "28:0157c" : "28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)",
      "28:0157d" : "28:0157d (28:0157 Motion for Withdrawal of Reference)",
      "28:0158" : "28:0158 (28:0158 Notice of Appeal re Bankruptcy Matter (BA)",
      "28:0185" : "28:0185 (28:185 Suit to Compel Arbitration)",
      "28:0451" : "28:0451 (28:451 Employment Discrimination)",
      "28:0794" : "28:0794 (28:794 Rehabilitation Act)",
      "28:1001" : "28:1001 (28:1001 E.R.I.S.A.)",
      "28:1132" : "28:1132 (28:1132 E.R.I.S.A.)",
      "28:1330" : "28:1330 (28:1330 Breach of Contract)",
      "28:1331" : "28:1331 (28:1331 Fed. Question)",
      "28:1331al" : "28:1331al (28:1331 Fed. Question: Airline Crash)",
      "28:1331at" : "28:1331at (28:1331 Fed. Question: Anti-trust)",
      "28:1331au" : "28:1331au (28:1331 Fed. Question: Auto Negligence)",
      "28:1331b" : "28:1331b (28:1331 Federal Question: Bivens Act)",
      "28:1331bc" : "28:1331bc (28:1331 Fed. Question: Breach of Contract)",
      "28:1331ca" : "28:1331ca (28:1331 Fed Question: Fed Communications Act of 1)",
      "28:1331cm" : "28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)",
      "28:1331cv" : "28:1331cv (28:1331 Federal Question: Other Civil Rights)",
      "28:1331ed" : "28:1331ed (28:1331 Fed. Question: Employment Discrimination)",
      "28:1331es" : "28:1331es (28:1331 Enforcement of Administrative Subpoena)",
      "28:1331fl" : "28:1331fl (28:1331 Fed. Question: Fair Labor Standards)",
      "28:1331in" : "28:1331in (28:1331 Fed. Question: Insurance Contract)",
      "28:1331mm" : "28:1331mm (28:1331 Fed. Question: Medical Malpractice)",
      "28:1331pi" : "28:1331pi (28:1331 Fed. Question: Personal Injury)",
      "28:1331rd" : "28:1331rd (28:1331 Fed. Question: Review Agency Decision)",
      "28:1331rp" : "28:1331rp (28:1331(a) Fed. Question: Real Property)",
      "28:1331rr" : "28:1331rr (28:1331 Fed. Question: Railway Labor Act)",
      "28:1331sv" : "28:1331sv (28:1331 Fed. Question: Securities Violation)",
      "28:1331tr" : "28:1331tr (28:1331 Fed. Question: Trademark)",
      "28:1331tt" : "28:1331tt (28:1331 Fed. Question: Tort Action)",
      "28:1331v" : "28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendme)",
      "28:1331wl" : "28:1331wl (28:1331 Federal Question: EPA Waste Lien)",
      "28:1331wt" : "28:1331wt (28:1331 Fed. Question: Water Rights)",
      "28:1332ac" : "28:1332ac (28:1332 Diversity-Account Receivable)",
      "28:1332al" : "28:1332al (28:1332 Diversity-Airline Crash)",
      "28:1332as" : "28:1332as (28:1332 Diversity-Asbestos Litigation)",
      "28:1332au" : "28:1332au (28:1332 Diversity-Auto Negligence)",
      "28:1332bc" : "28:1332bc (28:1332 Diversity-Breach of Contract)",
      "28:1332co" : "28:1332co (28:1332 Diversity-Conversion)",
      "28:1332ct" : "28:1332ct (28:1332 Diversity-(Citizenship))",
      "28:1332det" : "28:1332det (28:1332 Diversity: Forcible Detainer)",
      "28:1332df" : "28:1332df (28:1332 Diversity-Contract Default)",
      "28:1332ds" : "28:1332ds (28:1332 Diversity-Contract Dispute)",
      "28:1332ed" : "28:1332ed (28:1332 Diversity-Employment Discrimination)",
      "28:1332fd" : "28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)",
      "28:1332fr" : "28:1332fr (28:1332 Diversity-Fraud)",
      "28:1332ia" : "28:1332ia (28:1332 Diversity-Interpleader Action)",
      "28:1332ij" : "28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)",
      "28:1332in" : "28:1332in (28:1332 Diversity-Insurance Contract)",
      "28:1332jd" : "28:1332jd (28:1332 Diversity-Declaratory Judgement)",
      "28:1332lb" : "28:1332lb (28:1332 Diversity-Libel,Assault,Slander)",
      "28:1332lm" : "28:1332lm (28:1332 Diversity - Legal Malpractice)",
      "28:1332ma" : "28:1332ma (28:1332 Diversity-Miller Act)",
      "28:1332mm" : "28:1332mm (28:1332 Diversity-Medical Malpractice)",
      "28:1332mv" : "28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)",
      "28:1332ni" : "28:1332ni (28:1332 Diversity-Negotiable Instrument)",
      "28:1332nm" : "28:1332nm (28:1332 Diversity-Non-Motor Vehicle)",
      "28:1332oc" : "28:1332oc (28:1332 Diversity-Other Contract)",
      "28:1332pd" : "28:1332pd (28:1332 Diversity-Property Damage)",
      "28:1332pi" : "28:1332pi (28:1332 Diversity-Personal Injury)",
      "28:1332pl" : "28:1332pl (28:1332 Diversity-Product Liability)",
      "28:1332pr" : "28:1332pr (28:1332 Diversity-Petition for Removal)",
      "28:1332qt" : "28:1332qt (28:1332 Diversity-Petition to Quiet Title)",
      "28:1332ri" : "28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)",
      "28:1332sa" : "28:1332sa (28:1332 - Diversity: Securities & Exchange Commiss)",
      "28:1332sf" : "28:1332sf (28:1332 - Diversity: Securities Fraud)",
      "28:1332ss" : "28:1332ss (28:1332 Diversity - Stockholders Suits)",
      "28:1332tl" : "28:1332tl (28:1332 Diversity-Torts to Land)",
      "28:1332tm" : "28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))",
      "28:1332tn" : "28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)",
      "28:1332wd" : "28:1332wd (28:1332 Diversity-Wrongful Death)",
      "28:1333" : "28:1333 (28:1333 Admiralty)",
      "28:1334" : "28:1334 (28:1334 Bankruptcy Appeal)",
      "28:13345fa" : "28:13345fa (28:1345 Recover of FAA - fine or penalty)",
      "28:1334ab" : "28:1334ab (28:1334ab Civil Proceeding (BK))",
      "28:1334c" : "28:1334c (28:1334(c) R&R re motions for abstention (non-cor)",
      "28:1335" : "28:1335 (28:1335 Interpleader Action)",
      "28:1337" : "28:1337 (28:1337 Sherman-Clayton Act)",
      "28:1338cp" : "28:1338cp (28:1338 Copyright Infringement)",
      "28:1338pt" : "28:1338pt (28:1338 Patent Infringement)",
      "28:1338tr" : "28:1338tr (28:1338 Trademark Infringement)",
      "28:1340" : "28:1340 (28:1340 IRS: Custom Duties)",
      "28:1340er" : "28:1340er (28:1340 Recovery of Erroneous Refund)",
      "28:1341" : "28:1341 (28:1341 Complaint for Forfeiture)",
      "28:1343" : "28:1343 (28:1343 Violation of Civil Rights)",
      "28:1345co" : "28:1345co (28:1345 Replevin & Conversion)",
      "28:1345db" : "28:1345db (28:1345 Debt to US - FHA/HUD Title I)",
      "28:1345df" : "28:1345df (28:1345 Default of Promissory Note)",
      "28:1345er" : "28:1345er (28:1345 Recovery of Erroneous Refund)",
      "28:1345fa" : "28:1345fa (28:1345 Recover of FAA - fine or penalty )",
      "28:1345fc" : "28:1345fc (28:1345 Foreclosure)",
      "28:1345ff" : "28:1345ff (28:1345 Complaint for Forfeiture)",
      "28:1345hl" : "28:1345hl (28:1345 VA Home Loan Guaranty Debt)",
      "28:1345mc" : "28:1345mc (28:1345 Medical Care Recovery)",
      "28:1345mi" : "28:1345mi (28:1345 Mining Claim Ejectment)",
      "28:1345pd" : "28:1345pd (28:1345 Property Damage)",
      "28:1345pe" : "28:1345pe (28:1345 Property Ejectment)",
      "28:1345rc" : "28:1345rc (28:1345 Recovery of Debt to US)",
      "28:1345st" : "28:1345st (28:1345 Default of Student Loan)",
      "28:1345tp" : "28:1345tp (28:1345 Trespass on Public Land)",
      "28:1345va" : "28:1345va (28:1345 Recovery of VA Overpayment)",
      "28:1346bc" : "28:1346bc (28:1346 Breach of Contract)",
      "28:1346rc" : "28:1346rc (28:1346 Recovery of IRS Tax)",
      "28:1346tc" : "28:1346tc (28:1346 Tort Claim)",
      "28:1346wd" : "28:1346wd (28:1346 Wrongful Death)",
      "28:1352" : "28:1352 (28:1352 Miller Act)",
      "28:1355" : "28:1355 (28:1355 Petition for Return of Property)",
      "28:1358" : "28:1358 (28:1358 Land Condemnation)",
      "28:1361" : "28:1361 (28:1361 Petition for Writ of Mandamus)",
      "28:1362ic" : "28:1362ic (28:1362 Indian Tribal Controversy)",
      "28:1362iw" : "28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)",
      "28:1364" : "28:1364 (28:1364 Auto Negligence)",
      "28:1391" : "28:1391 (28:1391 Personal Injury)",
      "28:1402" : "28:1402 (28:1402 Medical Malpractice)",
      "28:1404" : "28:1404 (28:1404 Registration of Judgment)",
      "28:1407" : "28:1407 (28:1407 Airline Crash)",
      "28:1441ac" : "28:1441ac (28:1441 Petition for Removal- Account Receivable)",
      "28:1441al" : "28:1441al (28:1441 Petition for Removal- Airline Crash)",
      "28:1441as" : "28:1441as (28:1441 Petition for Removal- Asbestos Litigation)",
      "28:1441au" : "28:1441au (28:1441 Petition for Removal- Auto Negligence)",
      "28:1441bc" : "28:1441bc (28:1441 Petition for Removal- Breach of Contract)",
      "28:1441cv" : "28:1441cv (28:1441 Petition for Removal- Civil Rights Act)",
      "28:1441df" : "28:1441df (28:1441 Petition for Removal- Contract Default)",
      "28:1441dj" : "28:1441dj (28:1441 Petition for Removal- Declaratory Judgemen)",
      "28:1441ds" : "28:1441ds (28:1441 Petition for Removal- Contract Dispute)",
      "28:1441ed" : "28:1441ed (28:1441 Petition for Removal - Employment Discrim)",
      "28:1441fc" : "28:1441fc (28:1441 Petition for Removal - Fair Credit Reporti)",
      "28:1441fr" : "28:1441fr (28:1441 Petition for Removal- Fraud)",
      "28:1441ij" : "28:1441ij (28:1441 Petition for Removal- Injunctive/Declarato)",
      "28:1441in" : "28:1441in (28:1441 Petition for Removal- Insurance Contract)",
      "28:1441int" : "28:1441int (28:1441 Petition for Removal- Action for Interplea)",
      "28:1441lb" : "28:1441lb (28:1441 Petition for Removal Libel,Assault,Slander)",
      "28:1441lm" : "28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relatio)",
      "28:1441mm" : "28:1441mm (28:1441 Petition for Removal- Medical Malpractice)",
      "28:1441ni" : "28:1441ni (28:1441 Petition for Removal- Negotiable Instrumen)",
      "28:1441nm" : "28:1441nm (28:1441 Petition for Removal- Non-Motor Vehicle)",
      "28:1441oc" : "28:1441oc (28:1441 Petition For Removal--Other Contract)",
      "28:1441pd" : "28:1441pd (28:1441 Petition for Removal- Property Damage)",
      "28:1441pi" : "28:1441pi (28:1441 Petition for Removal- Personal Injury)",
      "28:1441pl" : "28:1441pl (28:1441 Petition for Removal- Product Liability)",
      "28:1441pr" : "28:1441pr (28:1441 Petition for Removal)",
      "28:1441qt" : "28:1441qt (28:1441 Petition for Removal- Petition to Quiet Ti)",
      "28:1441ri" : "28:1441ri (28:1441 Petition for Removal- Racketeering (RICO))",
      "28:1441sa" : "28:1441sa (28:1441 - Petition for Removal: SEC Act)",
      "28:1441sf" : "28:1441sf (28:1441 - Petition for Removal: Securities Fraud)",
      "28:1441tl" : "28:1441tl (28:1441 Petition for Removal- Torts to Land)",
      "28:1441tm" : "28:1441tm (28:1441 Petition for Removal- Tort/Motor Vehicle ()",
      "28:1441tn" : "28:1441tn (28:1441 Petition for Removal- Tort/Non-Motor Vehic)",
      "28:1441wd" : "28:1441wd (28:1441 Petition for Removal- Wrongful Death)",
      "28:1442bc" : "28:1442bc (28:1442 Petition for Removal- Breach of Contract)",
      "28:1442pr" : "28:1442pr (28:1442 Petition for Removal)",
      "28:1443" : "28:1443 (28:1443(1) Rent, Lease & Ejectment)",
      "28:1444" : "28:1444 (28:1444 Petition for Removal- Foreclosure)",
      "28:1446in" : "28:1446in (28:1446 Breach of Contract- Insurance)",
      "28:1446pd" : "28:1446pd (28:1446 Petition for Removal- Property Damage (P.I)",
      "28:1446pi" : "28:1446pi (28:1446 Petition for Removal- Personal Injury)",
      "28:1446pl" : "28:1446pl (28:1446pl Petition for Removal - Product Liability)",
      "28:1446pr" : "28:1446pr (28:1446 Petition for Removal)",
      "28:1452" : "28:1452 (28:1452 R&R re motions to remand (non-core))",
      "28:1491" : "28:1491 (28:1491 Tucker Act)",
      "28:1651" : "28:1651 (28:1651 Petition for Writ of Coram Nobis)",
      "28:1651hc" : "28:1651hc (28:1651 Petition for Writ of Habeas Corpus)",
      "28:1651mn" : "28:1651mn (28:1651 Petition for Writ of Mandamus)",
      "28:1782" : "28:1782 (28:1782 Assistance to Foreign Tribunals)",
      "28:1983" : "28:1983 (28:1983 Civil Rights)",
      "28:2201" : "28:2201 (28:2201 Constitutionality of State Statute(s))",
      "28:2201dj" : "28:2201dj (28:2201 Declaratory Judgement)",
      "28:2201ij" : "28:2201ij (28:2201 Injunction)",
      "28:2201in" : "28:2201in (28:2201 Declaratory Judgement (Insurance))",
      "28:2241" : "28:2241 (28:2241 Petition for Writ of Habeas Corpus (federa)",
      "28:2242" : "28:2242 (28:2242 Petition for Writ of Habeas Corpus)",
      "28:2244" : "28:2244 (28:2244 Finality of Determination)",
      "28:2254" : "28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))",
      "28:2254se" : "28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)",
      "28:2255" : "28:2255 (28:2255 Motion to Vacate / Correct Illegal Sentenc)",
      "28:2271" : "28:2271 (28:2271 Federal Tort Claims Act)",
      "28:2345" : "28:2345 (28:2345 Medicare Recovery)",
      "28:2409" : "28:2409 (28:2409(a) Quiet Title Action)",
      "28:2410" : "28:2410 (28:2410 Quiet Title)",
      "28:2671" : "28:2671 (28:2671 Federal Tort Claims Act)",
      "28:2674" : "28:2674 (28:2674 Federal Tort Claims Act)",
      "28:3203" : "28:3203 (28:3203 Postjudgment Remedies: Writ of Execution)",
      "28:3301" : "28:3301 (28:3301 Fraudulent Transfer Federal Debt Collection Procedures Act)",
      "28:7402" : "28:7402 (28:7402 Refund of Taxes)",
      "28:7422" : "28:7422 (28:7422 Appeal from Administrative Decision)",
      "29:0151" : "29:0151 (29:151 Labor: Review of Agency Action)",
      "29:0160" : "29:0160 (29:160(1) National Labor Relations Act)",
      "29:0184" : "29:0184 (29:184 Violation Collection Bargain Agreement)",
      "29:0185ep" : "29:0185ep (29:185 Employee Pension Plan)",
      "29:0185lm" : "29:0185lm (29:185 Labor/Mgt. Relations (Contracts))",
      "29:0201do" : "29:0201do (29:201 Denial of Overtime Compensation)",
      "29:0201fl" : "29:0201fl (29:201 Fair Labor Standards Act)",
      "29:0203" : "29:0203 (29:203 Equal Pay Act)",
      "29:0206" : "29:0206 (29:206 Collect Unpaid Wages)",
      "29:0401" : "29:0401 (29:0401 Labor Management Disclosure Act)",
      "29:0621" : "29:0621 (29:621 Job Discrimination (Age))",
      "29:0623" : "29:0623 (29:623 Job Discrimination (Age))",
      "29:0626" : "29:0626 (29:626 Job Discrimination (Age))",
      "29:0633" : "29:0633 (29:633 Job Discrimination (Age))",
      "29:0651" : "29:0651 (29:651 Occupational Safety/Health)",
      "29:0754" : "29:0754 (29:754 Discrimination)",
      "29:0791" : "29:0791 (29:791 Job Discrimination (Rehabilitation Act))",
      "29:0794" : "29:0794 (29:0794 Job Discrimination (Handicap))",
      "29:1001" : "29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)",
      "29:1002" : "29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)",
      "29:1104" : "29:1104 (29:1104 Recovery of Benefits to Employee)",
      "29:1109" : "29:1109 (29:1109 Breach of Fiduciary Duties)",
      "29:1131" : "29:1131 (29:1131 ERISA - Collection of Delinquent Trust Fun)",
      "29:1132" : "29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)",
      "29:1145" : "29:1145 (29:1145 E.R.I.S.A.)",
      "29:1149" : "29:1149 (29:1149 Recover Pension & Profit Sharing)",
      "29:1337" : "29:1337 (29:1337 E.R.I.S.A.)",
      "29:1362" : "29:1362 (29:1362 ERISA)",
      "29:1381" : "29:1381 (29:1381 E.R.I.S.A.)",
      "29:1401" : "29:1401 (29:1401(b)(2) Appeal of Arbitration Award)",
      "29:1451" : "29:1451 (29:1451 E.R.I.S.A.)",
      "29:1801" : "29:1801 (29:1801 Farmworker Rights)",
      "29:2601" : "29:2601 (29:2601 Family Medical Leave Act)",
      "29:790" : "29:790 (29:790 Rehabilitation of Labor)",
      "30:0181" : "30:0181 (30:181 Environment: Review of Agency Action)",
      "30:0801" : "30:0801 (30:0801 Penalities/Federal Mine Safety Health Act)",
      "30:1201" : "30:1201 (30:1201 Environment: Review of Agency Action)",
      "30:1202" : "30:1202 (30:1202 Mining Reclamation Act)",
      "30:1276" : "30:1276 (30:1276 Interior: Review of Agency Action)",
      "31:3545" : "31:3545 (31:3545 Action to Recovery Money)",
      "31:3729" : "31:3729 (31:3729 False Claims Act)",
      "31:3730" : "31:3730 (31:3730 Qui Tam False Claims Act)",
      "31:3731" : "31:3731 (31:3731 Fraud)",
      "33:1319cw" : "33:1319cw (33:1319 Clean Water Act)",
      "33:1319pv" : "33:1319pv (33:1319 Pollutants & Permit Violations)",
      "33:1365" : "33:1365 (33:1365 Environmental Matters)",
      "35:0145" : "35:0145 (35:145 Patent Infringement)",
      "35:0183" : "35:0183 (35:183 Patent Infringement)",
      "35:0271" : "35:0271 (35:271 Patent Infringement)",
      "38:1681" : "38:1681 (38:1681 Recovery of VA Overpayment)",
      "38:1686" : "38:1686 (38:1686 Recovery of VA Overpayment)",
      "38:1780" : "38:1780 (38:1780 Recovery of VA Overpayment)",
      "38:2011" : "38:2011 (38:2011 - Veteran's Readjustment Assistance Act of)",
      "38:3116" : "38:3116 (38:3116 VA Overpayment)",
      "38:4301" : "38:4301 (38:4301 Veterans' Reemployment Rights Act)",
      "39:3005" : "39:3005 (39:3005 Detention of Mail for Temporary Periods)",
      "39:409" : "39:409 (39:409 Postal Service)",
      "40:0258" : "40:0258 (40:258(a) Public Buildings & Property: Land Condem)",
      "40:03131" : "40:03131 (40:3131 Miller Act)",
      "40:0875" : "40:0875 (40:875 Public Buildings & Property: Negligence)",
      "41:0251" : "41:0251 (41:251 Public Contracts-Review of Agency Action)",
      "41:1463" : "41:1463 (41:1463 Public Contracts: Unlawful Employment Prac)",
      "42:0205" : "42:0205 (42:205 Denial Social Security Benefits)",
      "42:0206" : "42:0206 (42:206 Social Security Benefits)",
      "42:0247" : "42:0247 (42:247 Personal Injury-Swine Flu)",
      "42:0402" : "42:0402 (42:402 Social Security Benefits)",
      "42:0405" : "42:0405 (42:0405 Review of HHS Decision)",
      "42:0405id" : "42:0405id (42:405 Review of HHS Decision (SSID))",
      "42:0405wc" : "42:0405wc (42:405 Review of HHS Decision (DIWC))",
      "42:0405ww" : "42:0405ww (42:405 Review of HHS Decision (DIWW))",
      "42:0416" : "42:0416 (42:416 Denial of Social Security Benefits)",
      "42:0427" : "42:0427 (42:427 Social Security Benefits)",
      "42:12101" : "42:12101 (42:12101 Americans with Disabilities Act)",
      "42:12131" : "42:12131 (42:12131 Americans with Disabilities Act)",
      "42:1383" : "42:1383 (42:1383 Review of HHS Decision)",
      "42:1395" : "42:1395 (42:1395 HHS: Adverse Reimbursement Review)",
      "42:1396" : "42:1396 (42:1396 - Tort Negligence)",
      "42:13981" : "42:13981 (42:13981 Violence Against Women Act)",
      "42:1471" : "42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclo)",
      "42:1981cv" : "42:1981cv (42:1981 Civil Rights)",
      "42:1981hs" : "42:1981hs (42:1981 Housing Discrimination)",
      "42:1981jb" : "42:1981jb (42:1981 Job Discrimination (Race))",
      "42:1981sx" : "42:1981sx (42:1981 Sex Discrimination)",
      "42:1982" : "42:1982 (42:1982 Property Rights of Citizens)",
      "42:1983cv" : "42:1983cv (42:1983 Civil Rights Act)",
      "42:1983ed" : "42:1983ed (42:1983 Civil Rights (Employment Discrimination))",
      "42:1983pr" : "42:1983pr (42:1983 Prisoner Civil Rights)",
      "42:1985" : "42:1985 (42:1985 Conspiracy to interfere with civil rights)",
      "42:1986" : "42:1986 (42:1986 Neglect of Duty)",
      "42:2000ag" : "42:2000ag (42:2000 Job Discrimination (Age))",
      "42:2000e" : "42:2000e (42:2000e Job Discrimination (Employment))",
      "42:2000pb" : "42:2000pb (42:2000 Job Discrimination (Public Accomodations))",
      "42:2000ra" : "42:2000ra (42:2000 Job Discrimination (Race))",
      "42:2000sx" : "42:2000sx (42:2000 Job Discrimination (Sex))",
      "42:2003" : "42:2003 (42:2003 Job Discrimination)",
      "42:2005" : "42:2005 (42:2005 Review of Agency Action-HHS)",
      "42:2651" : "42:2651 (42:2651 Medical Care Recovery)",
      "42:3601" : "42:3601 (42:3601 Fair Housing Act)",
      "42:4000" : "42:4000 (42:4000 National Flood Insurance Act)",
      "42:4001" : "42:4001 (42:4001 National Insurance Flood Act)",
      "42:4053" : "42:4053 (42:4053 Breach of Insurance Contract)",
      "42:4072" : "42:4072 (42:4072 Payment of Flood Insurance Claim)",
      "42:4321" : "42:4321 (42:4321 Review of Agency Action-Environment)",
      "42:4332" : "42:4332 (42:4332 Environmental Policy - Coop of Agency Repo)",
      "42:6901en" : "42:6901en (42:6901 Environmental Cleanup Expenses)",
      "42:6901rs" : "42:6901rs (42:6901 Resource & Recovery Act)",
      "42:7413" : "42:7413 (42:7413(b) Clean Air Act)",
      "42:7604cl" : "42:7604cl (42:7604 Clear Air Act (Emission Standards))",
      "42:7604ir" : "42:7604ir (42:7604 Petition to Quash IRS Summons)",
      "42:9607" : "42:9607 (42:9607 Real Property Tort to Land)",
      "42:9613" : "42:9613 (42:9613(b) CERCLA)",
      "43:945" : "43:945 (43:945 Compensation for Land Condemnation)",
      "43:945a" : "43:945a (43:945a Complaint in Condemnation)",
      "43:946" : "43:946 (43:946 Complaint in Condemnation - Eminent Domain)",
      "45:0051" : "45:0051 (45:51 Railways: Fed. Employer's Liability Act)",
      "45:0151" : "45:0151 (45:151 Railway Labor Act)",
      "45:0153" : "45:0153 (45:153 National Railroad Adjustment Board)",
      "45:0184" : "45:0184 (45:184 Action to Set Aside Award of a System Board)",
      "45:1395" : "45:1395 (45:1395 Railroads: Adverse Reimbursement Review)",
      "45:7457" : "45:7457 (45:7457 Compel Reclamation Under Clear Air Act)",
      "46:0688" : "46:0688 (46:688 Jones Act)",
      "46:0741" : "46:0741 (46:741 Shipping)",
      "46:0761" : "46:0761 (46:761 Shipping: Damages for Death on High Seas)",
      "46:1101" : "46:1101 (46:1101 Violation of Maritime Regulations)",
      "46:1156" : "46:1156 (46:1156 Administrative Procedure Act)",
      "47:0201" : "47:0201 (47:0201 Telecommunications - Service and charges)",
      "47:0251" : "47:0251 (47:0251 Telecommunications Act of 1996)",
      "47:0607" : "47:0607 (47:0607 Communications Act of 1934)",
      "47:553" : "47:553 (47:553 Unauthorized reception of cable service)",
      "48:0883" : "48:0883 (48:883 Violation of US Coastal Law)",
      "48:1985" : "48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)",
      "49:0081" : "49:0081 (49:81 Damaged Goods While Being Transported)",
      "49:0781" : "49:0781 (49:781 Forfeiture)",
      "49:11503" : "49:11503 (49:11503 Railroad Revitalization Regulatory Reform)",
      "49:11702" : "49:11702 (49:11702(a)(4) Violations of Interstate Commerce A)",
      "49:1471" : "49:1471 (49:1471 Federal Aviation Act)",
      "49:1903" : "49:1903 (49:1903 Petition to enforce administrative summon)",
      "49:32701" : "49:32701 (49:32701 Federal Odometer Act)",
      "8:287" : "8:287 (8:287 Petition to Enforce INS Subpoena)",
      "misc" : "misc (Civil Miscellaneous Case)"
   },
   "nhdce" : {
      "0" : "0 (No cause code entered)",
      "02:0431" : "02:0431 (02:431 Fed. Election Commission: Failure Enforce C)",
      "02:0437" : "02:0437 (02:437 Federal Election Commission)",
      "05:0075" : "05:0075 (05:75(2) Contract - Reduction in Grade)",
      "05:0551" : "05:0551 (05:551 Administrative Procedure Act)",
      "05:0552fi" : "05:0552fi (05:552 Freedom of Information Act)",
      "05:0552pa" : "05:0552pa (05:552 Right to Privacy Act)",
      "05:0554" : "05:0554 (05:0554 Constitutionality of Maritime Statutes)",
      "05:0701" : "05:0701 (05:0701 Maritime Subsidy Board)",
      "05:0702" : "05:0702 (05:702 Administrative Procedure Act)",
      "05:0704" : "05:0704 (05:704 Labor Litigation)",
      "05:7703" : "05:7703 (05:7703 Discrimination - Review of Agency Act)",
      "05:8470" : "05:8470 (05:8470 Enforcement of Judgment against Retirement Benefits )",
      "07:0006" : "07:0006 (7:6(b) Federal Commodity Exchange Regulation)",
      "07:0025" : "07:0025 (7:25 Fraud - Commodities Leverage Contracts)",
      "07:0181" : "07:0181 (07:181 Packers & Stockyard Act)",
      "07:0499" : "07:0499 (07:499 Agricultural Commodities Act)",
      "07:0601" : "07:0601 (07:601 USDA Condemnation)",
      "07:0608" : "07:0608 (07:608(a) Agriculture Marketing Agreement Act)",
      "07:2023" : "07:2023 (07:2023 Supplemental Nutrition - Restoration of Rights)",
      "07:2321" : "07:2321 (07:2321 Plant Variety Protection Act)",
      "08:1105" : "08:1105 (8:1105(a) Aliens: Habeas Corpus to Release INS Det)",
      "08:1182" : "08:1182 (8:1182 Defend. Denial of Pla. Appl. for Alien Employment Cer)",
      "08:1252" : "08:1252 (08:1252(a)(2) Injunction for Deportation)",
      "08:1260" : "08:1260 (08:1260 Aliens: Access to Records)",
      "08:1324" : "08:1324 (08:1324 Aliens: Complaint for Forfeiture)",
      "08:1329" : "08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petiti)",
      "08:1421" : "08:1421 (8:1421 Review of Naturalization Decision)",
      "08:1446" : "08:1446 (8:1446 Petition for Naturalization Hearing)",
      "08:1447" : "08:1447 (8:1447 Hearings on Denials of Applications for Naturalization)",
      "08:1451(a)" : "08:1451(a) (08:1451(a) Complaint for Revocation of Naturalization )",
      "09:0001" : "09:0001 (09:1 U.S. Arbitration Act)",
      "09:0009" : "09:0009 (9:9 Motion to Confirm Arbitration Loan)",
      "09:0010" : "09:0010 (09:0010 Petition to Vacate Arbitration Award)",
      "10:1408" : "10:1408 (10:1408 Claim for Military Retirement )",
      "10:1552" : "10:1552 (10:1552 Armed Forces: Action to Correct Records)",
      "10:1553" : "10:1553 (10:1553 Armed Forces: FOIA General)",
      "10:2005" : "10:2005 (Advanced Education Assistance Active Duty Agreement)",
      "10:2305" : "10:2305 (10:2305 Review of Federal Contract)",
      "11:0101" : "11:0101 (11:101 Bankruptcy)",
      "12:0022" : "12:0022 (12:22 Securities Fraud)",
      "12:0635" : "12:0635 (12:635 Breach of Insurance Contract)",
      "12:1461" : "12:1461 (12:1461 Homeowners Loan Act)",
      "12:1464" : "12:1464 (12:1464 Federal Savings and Loan )",
      "12:1703" : "12:1703 (12:1703 Default of HUD Loan)",
      "12:1725" : "12:1725 (12:1725 Collection under Contract Guaranty)",
      "12:1730" : "12:1730 (12:1730 Collection Under Contract Guaranty)",
      "12:1819" : "12:1819 (12:1819 Default of Promissory Note)",
      "12:1821" : "12:1821 (12:1821 Default of Loan by Promissary Note)",
      "12:191" : "12:191 (12:191 Bank Foreclosure )",
      "12:192" : "12:192 (12:192 Liquidation of National Bank )",
      "12:1971" : "12:1971 (12:1971 Relief under Bank Holding Act)",
      "12:1972" : "12:1972 (12:1972 Typing Arrangement Act )",
      "12:3410" : "12:3410 (12:3410 Right to Financial Privacy Act)",
      "15:0001" : "15:0001 (15:1 Antitrust Litigation)",
      "15:0002at" : "15:0002at (15:2 Antitrust Litigation)",
      "15:0002fl" : "15:0002fl (15:2(a) Fair Labor Standards Act)",
      "15:0005" : "15:0005 (15:5(a) Fair Labor Standards Act)",
      "15:0015" : "15:0015 (15:15 Antitrust Litigation)",
      "15:0025" : "15:0025 (15:25 Clayton Act)",
      "15:0044" : "15:0044 (15:44 Trademark Infringement)",
      "15:0045" : "15:0045 (15:0045 Federal Trade Commission Act)",
      "15:0052" : "15:0052 (15:0052 Federal Trade Commission Act)",
      "15:0053" : "15:0053 (15:0053 Federal Trade Commission Act)",
      "15:0077" : "15:0077 (15:77 Securities Fraud)",
      "15:0078" : "15:0078 (15:78m(a) Securities Exchange Act)",
      "15:0631" : "15:0631 (15:631 Small Business Act)",
      "15:0717" : "15:0717 (15:717 Natural Gas Act)",
      "15:0754" : "15:0754 (15:754 Emergency Petroleum Allocation-Admin.& Enforcement )",
      "15:1051" : "15:1051 (15:1051 Trademark Infringement)",
      "15:1114" : "15:1114 (15:1114 Trademark Infringement)",
      "15:1121" : "15:1121 (15:1121 Trademark Infringement)",
      "15:1125" : "15:1125 (15:1125 Trademark Infringement (Lanham Act))",
      "15:1126" : "15:1126 (15:1126 Patent Infringement)",
      "15:1127" : "15:1127 (15:1127 Trademark Infringement)",
      "15:1601" : "15:1601 (15:1601 Truth in Lending)",
      "15:1640" : "15:1640 (15:1640 Truth in Lending)",
      "15:1681" : "15:1681 (15:1681 Fair Credit Reporting Act)",
      "15:1691" : "15:1691 (Equal Credit Opportunity Act )",
      "15:1692" : "15:1692 (15:1692 Fair Debt Collection Act)",
      "15:1693" : "15:1693 (15:1693 Electronic Funds Transfer Act)",
      "15:1938" : "15:1938 (15:1938 Fair Labor Standards Act)",
      "15:1981" : "15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))",
      "15:1988" : "15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))",
      "15:1989" : "15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))",
      "15:2301" : "15:2301 (15:2301 Magnuson-Moss Warranty Act)",
      "15:2601" : "15:2601 (15:2601 Control of Toxic Substances)",
      "15:2801" : "15:2801 (15:2801 Petroleum Marketing Practices Act)",
      "15:53(b)" : "15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equita)",
      "16:0668" : "16:0668 (16:668 Bald Eagle Protection Act)",
      "16:0703" : "16:0703 (16:703 Migratory Bird Act)",
      "16:0823" : "16:0823 (16:0823 Federal Power Act )",
      "16:1538" : "16:1538 (16:1538 Endangered Species Act)",
      "16:3371" : "16:3371 (16:3371 Wildlife Under the Lacey Act)",
      "16:3372" : "16:3372 (16:3372 Conservation: Complaint for Forfeiture)",
      "16:3373" : "16:3373 (16:3373 Appeal of Decision - DOI)",
      "16:3374" : "16:3374 (16:3374 Conservation: Complaint for Forfeiture)",
      "16:791a" : "16:791a (16:791a Federal Power Act)",
      "17:0101" : "17:0101 (17:101 Copyright Infringement)",
      "17:0501" : "17:0501 (17:501 Copyright Infringement)",
      "17:0504" : "17:0504 (17:504 Copyright Infringement)",
      "18:0241" : "18:0241 (18:241 Conspiracy Against Citizen Rights)",
      "18:0924" : "18:0924 (18:0924 Firearms Penalties)",
      "18:0981" : "18:0981 (18:0981 Forfeiture Property )",
      "18:1030" : "18:1030 (18:1030 Computer Fraud and Abuse Act)",
      "18:1836a" : "18:1836a (18:1836(a) Injunction against Misappropriation of Trade Secrets)",
      "18:1836b" : "18:1836b (18:1836(b) Civil Action to Protect Trade Secrets)",
      "18:1961" : "18:1961 (18:1961 Racketeering (RICO) Act)",
      "18:1962" : "18:1962 (18:1962 Racketeering (RICO) Act)",
      "18:1964" : "18:1964 (18:1964 Racketeering (RICO) Act)",
      "18:2511" : "18:2511 (18:2511 Wiretapping )",
      "18:3114" : "18:3114 (18:3114 Motion for Return of Seized Property )",
      "18:4208" : "18:4208 (18:4208(B) Agency Action Review)",
      "19:1305" : "19:1305 (19:1305 Custom Duties:0Forfeiture-Immoral Articles)",
      "20:1071" : "20:1071 (20:1071 Higher Education Act 1965)",
      "20:1080" : "20:1080 (20:1080 Student Loan Recovery)",
      "20:1400" : "20:1400 (20:1400 Civil Rights of Handicapped Child)",
      "20:1401" : "20:1401 (20:1401 Education: Handicapped Child Act)",
      "20:1415" : "20:1415 (20:1415 Education: Handicapped Child Act )",
      "21:0841" : "21:0841 (21:841 Forfeiture Property-Drugs)",
      "21:0842" : "21:0842 (21:U.S.C. 842 - Drug Diversion - Controlled Substance )",
      "21:0881" : "21:0881 (21:881 Forfeiture Property-Drugs)",
      "21:0881a" : "21:0881a (21:881 Forfeiture Property - Aircraft)",
      "21:0881oth" : "21:0881oth (21:881 Forfeiture Property - Other)",
      "21:0881re" : "21:0881re (21:881 Forfeiture Property - Real Estate)",
      "23:0134" : "23:0134 (23:134 P.I.- Auto Negligence)",
      "23:1441" : "23:1441 (23:1441 Contract Real Estate)",
      "24:1000" : "24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)",
      "25:0640" : "25:0640 (25:640 Indian Tribal Rights)",
      "25:1901" : "25:1901 (25:1901 Indian Child Welfare Act)",
      "26:0036" : "26:0036 (26:36 IRS - First-Time Homebuyer Credit)",
      "26:2207" : "26:2207 (26:2207 Liability of Recipient of Property)",
      "26:6212" : "26:6212 (26:6212 Injunctive Relief from IRS Lien)",
      "26:6213" : "26:6213 (26:6213 Injunctive Relief from IRS Lien)",
      "26:6502" : "26:6502 (26:6502 IRS:Enforcement of tax liens)",
      "26:6532" : "26:6532 (26:6532 IRS: Refund of Tax Penalty)",
      "26:6702" : "26:6702 (26:6702 IRS: Refund of Income Tax Penalty)",
      "26:6703" : "26:6703 (26:6703 IRS: Refund of Tax Penalty)",
      "26:7401" : "26:7401 (26:7401 IRS: Tax Liability)",
      "26:7402" : "26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)",
      "26:7403" : "26:7403 (26:7403 Suit to Enforce Federal Tax Lien)",
      "26:7422rt" : "26:7422rt (26:7422 IRS: Refund Taxes)",
      "26:7422rx" : "26:7422rx (26:7422 IRS: Refund Excise Tax)",
      "26:7426" : "26:7426 (26:7426 IRS: Wrongful Levy for Taxes)",
      "26:7429" : "26:7429 (26:7429 IRS: Tax Jeopardy Assessment)",
      "26:7609" : "26:7609 (26:7609 IRS: Petition to Quash IRS Summons)",
      "27:0185" : "27:0185 (27:185 Enforcement of Arbitration Award)",
      "28:0157c" : "28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)",
      "28:0157d" : "28:0157d (28:0157 Motion for Withdrawal of Reference)",
      "28:0158" : "28:0158 (28:0158 Notice of Appeal re Bankruptcy Matter (BA)",
      "28:0185" : "28:0185 (28:185 Suit to Compel Arbitration)",
      "28:0451" : "28:0451 (28:451 Employment Discrimination)",
      "28:0754" : "28:0754 (28:754 Receiver of Property in Different Districts )",
      "28:0794" : "28:0794 (28:794 Rehabilitation Act)",
      "28:1001" : "28:1001 (28:1001 E.R.I.S.A.)",
      "28:1132" : "28:1132 (28:1132 E.R.I.S.A.)",
      "28:1330" : "28:1330 (28:1330 Breach of Contract)",
      "28:1331" : "28:1331 (28:1331 Fed. Question)",
      "28:1331al" : "28:1331al (28:1331 Fed. Question: Airline Crash)",
      "28:1331at" : "28:1331at (28:1331 Fed. Question: Anti-trust)",
      "28:1331au" : "28:1331au (28:1331 Fed. Question: Auto Negligence)",
      "28:1331b" : "28:1331b (28:1331 Federal Question: Bivens Act)",
      "28:1331bc" : "28:1331bc (28:1331 Fed. Question: Breach of Contract)",
      "28:1331ca" : "28:1331ca (28:1331 Fed Question: Fed Communications Act of 1)",
      "28:1331cm" : "28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)",
      "28:1331cv" : "28:1331cv (28:1331 Federal Question: Other Civil Rights)",
      "28:1331ed" : "28:1331ed (28:1331 Fed. Question: Employment Discrimination)",
      "28:1331ej" : "28:1331ej (28:1331 Federal Question: Enforcement of Judgment )",
      "28:1331es" : "28:1331es (28:1331 Enforcement of Administrative Subpoena)",
      "28:1331fl" : "28:1331fl (28:1331 Fed. Question: Fair Labor Standards)",
      "28:1331in" : "28:1331in (28:1331 Fed. Question: Insurance Contract)",
      "28:1331mm" : "28:1331mm (28:1331 Fed. Question: Medical Malpractice)",
      "28:1331ng" : "28:1331ng (28:1331 Fed. Question: Natural Gas Act )",
      "28:1331pi" : "28:1331pi (28:1331 Fed. Question: Personal Injury)",
      "28:1331rd" : "28:1331rd (28:1331 Fed. Question: Review Agency Decision)",
      "28:1331rp" : "28:1331rp (28:1331(a) Fed. Question: Real Property)",
      "28:1331rr" : "28:1331rr (28:1331 Fed. Question: Railway Labor Act)",
      "28:1331sv" : "28:1331sv (28:1331 Fed. Question: Securities Violation)",
      "28:1331tr" : "28:1331tr (28:1331 Fed. Question: Trademark)",
      "28:1331tt" : "28:1331tt (28:1331 Fed. Question: Tort Action)",
      "28:1331v" : "28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendme)",
      "28:1331wl" : "28:1331wl (28:1331 Federal Question: EPA Waste Lien)",
      "28:1331wt" : "28:1331wt (28:1331 Fed. Question: Water Rights)",
      "28:1332ac" : "28:1332ac (28:1332 Diversity-Account Receivable)",
      "28:1332al" : "28:1332al (28:1332 Diversity-Airline Crash)",
      "28:1332as" : "28:1332as (28:1332 Diversity-Asbestos Litigation)",
      "28:1332au" : "28:1332au (28:1332 Diversity-Auto Negligence)",
      "28:1332bc" : "28:1332bc (28:1332 Diversity-Breach of Contract)",
      "28:1332co" : "28:1332co (28:1332 Diversity-Conversion)",
      "28:1332ct" : "28:1332ct (28:1332 Diversity-(Citizenship))",
      "28:1332det" : "28:1332det (28:1332 Diversity: Forcible Detainer)",
      "28:1332df" : "28:1332df (28:1332 Diversity-Contract Default)",
      "28:1332ds" : "28:1332ds (28:1332 Diversity-Contract Dispute)",
      "28:1332ed" : "28:1332ed (28:1332 Diversity-Employment Discrimination)",
      "28:1332fd" : "28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)",
      "28:1332fr" : "28:1332fr (28:1332 Diversity-Fraud)",
      "28:1332ia" : "28:1332ia (28:1332 Diversity-Interpleader Action)",
      "28:1332ij" : "28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)",
      "28:1332in" : "28:1332in (28:1332 Diversity-Insurance Contract)",
      "28:1332jd" : "28:1332jd (28:1332 Diversity-Declaratory Judgment)",
      "28:1332lb" : "28:1332lb (28:1332 Diversity-Libel,Assault,Slander)",
      "28:1332lm" : "28:1332lm (28:1332 Diversity - Legal Malpractice)",
      "28:1332ma" : "28:1332ma (28:1332 Diversity-Miller Act)",
      "28:1332mm" : "28:1332mm (28:1332 Diversity-Medical Malpractice)",
      "28:1332mv" : "28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)",
      "28:1332ni" : "28:1332ni (28:1332 Diversity-Negotiable Instrument)",
      "28:1332nm" : "28:1332nm (28:1332 Diversity-Non-Motor Vehicle)",
      "28:1332nr" : "28:1332nr (28:1332 Diversity-Notice of Removal )",
      "28:1332oc" : "28:1332oc (28:1332 Diversity-Other Contract)",
      "28:1332pd" : "28:1332pd (28:1332 Diversity-Property Damage)",
      "28:1332pi" : "28:1332pi (28:1332 Diversity-Personal Injury)",
      "28:1332pl" : "28:1332pl (28:1332 Diversity-Product Liability)",
      "28:1332pr" : "28:1332pr (28:1332 Diversity-Petition for Removal)",
      "28:1332qt" : "28:1332qt (28:1332 Diversity-Petition to Quiet Title)",
      "28:1332ri" : "28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)",
      "28:1332sa" : "28:1332sa (28:1332 - Diversity: Securities & Exchange Commiss)",
      "28:1332sf" : "28:1332sf (28:1332 - Diversity: Securities Fraud)",
      "28:1332ss" : "28:1332ss (28:1332 Diversity - Stockholders Suits)",
      "28:1332tl" : "28:1332tl (28:1332 Diversity-Torts to Land)",
      "28:1332tm" : "28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))",
      "28:1332tn" : "28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)",
      "28:1332wd" : "28:1332wd (28:1332 Diversity-Wrongful Death)",
      "28:1333" : "28:1333 (28:1333 Admiralty)",
      "28:1334" : "28:1334 (28:1334 Bankruptcy Appeal)",
      "28:1334c" : "28:1334c (28:1334(c) R&R re motions for abstention (non-cor)",
      "28:1335" : "28:1335 (28:1335 Interpleader Action)",
      "28:1337" : "28:1337 (28:1337 Sherman-Clayton Act)",
      "28:1338cp" : "28:1338cp (28:1338 Copyright Infringement)",
      "28:1338pt" : "28:1338pt (28:1338 Patent Infringement)",
      "28:1338tr" : "28:1338tr (28:1338 Trademark Infringement)",
      "28:1340" : "28:1340 (28:1340 IRS: Custom Duties)",
      "28:1340er" : "28:1340er (28:1340 Recovery of Erroneous Refund)",
      "28:1341" : "28:1341 (28:1341 Complaint for Forfeiture)",
      "28:1343" : "28:1343 (28:1343 Violation of Civil Rights)",
      "28:1345" : "28:1345 (28:1345 USA Plaintiff )",
      "28:1345co" : "28:1345co (28:1345 Replevin & Conversion)",
      "28:1345db" : "28:1345db (28:1345 Debt to US - FHA/HUD Title I)",
      "28:1345df" : "28:1345df (28:1345 Default of Promissory Note)",
      "28:1345er" : "28:1345er (28:1345 Recovery of Erroneous Refund)",
      "28:1345fc" : "28:1345fc (28:1345 Foreclosure)",
      "28:1345ff" : "28:1345ff (28:1345 Complaint for Forfeiture)",
      "28:1345hl" : "28:1345hl (28:1345 VA Home Loan Guaranty Debt)",
      "28:1345mc" : "28:1345mc (28:1345 Medical Care Recovery)",
      "28:1345mi" : "28:1345mi (28:1345 Mining Claim Ejectment)",
      "28:1345pd" : "28:1345pd (28:1345 Property Damage)",
      "28:1345pe" : "28:1345pe (28:1345 Property Ejectment)",
      "28:1345rc" : "28:1345rc (28:1345 Recovery of Debt to US)",
      "28:1345st" : "28:1345st (28:1345 Default of Student Loan)",
      "28:1345tp" : "28:1345tp (28:1345 Trespass on Public Land)",
      "28:1345va" : "28:1345va (28:1345 Recovery of VA Overpayment)",
      "28:1346bc" : "28:1346bc (28:1346 Breach of Contract)",
      "28:1346rc" : "28:1346rc (28:1346 Recovery of IRS Tax)",
      "28:1346tc" : "28:1346tc (28:1346 Tort Claim)",
      "28:1346wd" : "28:1346wd (28:1346 Wrongful Death)",
      "28:1349" : "28:1349 (28:1348 Corporation organized under Federal Law as party )",
      "28:1352" : "28:1352 (28:1352 Miller Act)",
      "28:1355" : "28:1355 (28:1355 Petition for Return of Property)",
      "28:1358" : "28:1358 (28:1358 Land Condemnation)",
      "28:1361" : "28:1361 (28:1361 Petition for Writ of Mandamus)",
      "28:1362ic" : "28:1362ic (28:1362 Indian Tribal Controversy)",
      "28:1362iw" : "28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)",
      "28:1364" : "28:1364 (28:1364 Auto Negligence)",
      "28:1391" : "28:1391 (28:1391 Personal Injury)",
      "28:1402" : "28:1402 (28:1402 Medical Malpractice)",
      "28:1407" : "28:1407 (28:1407 Airline Crash)",
      "28:1441ac" : "28:1441ac (28:1441 Petition for Removal- Account Receivable)",
      "28:1441al" : "28:1441al (28:1441 Petition for Removal- Airline Crash)",
      "28:1441as" : "28:1441as (28:1441 Petition for Removal- Asbestos Litigation)",
      "28:1441au" : "28:1441au (28:1441 Petition for Removal- Auto Negligence)",
      "28:1441bc" : "28:1441bc (28:1441 Petition for Removal- Breach of Contract)",
      "28:1441cv" : "28:1441cv (28:1441 Petition for Removal- Civil Rights Act)",
      "28:1441df" : "28:1441df (28:1441 Petition for Removal- Contract Default)",
      "28:1441dj" : "28:1441dj (28:1441 Petition for Removal- Declaratory Judgment)",
      "28:1441ds" : "28:1441ds (28:1441 Petition for Removal- Contract Dispute)",
      "28:1441ed" : "28:1441ed (28:1441 Petition for Removal - Employment Discrim)",
      "28:1441fc" : "28:1441fc (28:1441 Petition for Removal - Fair Credit Reporti)",
      "28:1441fr" : "28:1441fr (28:1441 Petition for Removal- Fraud)",
      "28:1441ij" : "28:1441ij (28:1441 Petition for Removal- Injunctive/Declarato)",
      "28:1441in" : "28:1441in (28:1441 Petition for Removal- Insurance Contract)",
      "28:1441int" : "28:1441int (28:1441 Petition for Removal- Action for Interplea)",
      "28:1441lb" : "28:1441lb (28:1441 Petition for Removal Libel,Assault,Slander)",
      "28:1441lm" : "28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relatio)",
      "28:1441mm" : "28:1441mm (28:1441 Petition for Removal- Medical Malpractice)",
      "28:1441ni" : "28:1441ni (28:1441 Petition for Removal- Negotiable Instrumen)",
      "28:1441nm" : "28:1441nm (28:1441 Petition for Removal- Non-Motor Vehicle)",
      "28:1441nr" : "28:1441nr (28:1441 Notice of Removal )",
      "28:1441oc" : "28:1441oc (28:1441 Petition For Removal--Other Contract)",
      "28:1441pd" : "28:1441pd (28:1441 Petition for Removal- Property Damage)",
      "28:1441pi" : "28:1441pi (28:1441 Petition for Removal- Personal Injury)",
      "28:1441pl" : "28:1441pl (28:1441 Petition for Removal- Product Liability)",
      "28:1441pr" : "28:1441pr (28:1441 Petition for Removal)",
      "28:1441qt" : "28:1441qt (28:1441 Petition for Removal- Petition to Quiet Title)",
      "28:1441ri" : "28:1441ri (28:1441 Petition for Removal- Racketeering (RICO))",
      "28:1441sa" : "28:1441sa (28:1441 - Petition for Removal: SEC Act)",
      "28:1441sf" : "28:1441sf (28:1441 - Petition for Removal: Securities Fraud)",
      "28:1441tl" : "28:1441tl (28:1441 Petition for Removal- Torts to Land)",
      "28:1441tm" : "28:1441tm (28:1441 Petition for Removal- Tort/Motor Vehicle)",
      "28:1441tn" : "28:1441tn (28:1441 Petition for Removal- Tort/Non-Motor Vehic)",
      "28:1441wd" : "28:1441wd (28:1441 Petition for Removal- Wrongful Death)",
      "28:1442bc" : "28:1442bc (28:1442 Petition for Removal- Breach of Contract)",
      "28:1442nr" : "28:1442nr (28:1442 Notice of Removal )",
      "28:1442pr" : "28:1442pr (28:1442 Petition for Removal)",
      "28:1443" : "28:1443 (28:1443(1) Rent, Lease & Ejectment)",
      "28:1444" : "28:1444 (28:1444 Petition for Removal- Foreclosure)",
      "28:1446in" : "28:1446in (28:1446 Breach of Contract- Insurance)",
      "28:1446nr" : "28:1446nr (28:1446 Notice of Removal )",
      "28:1446pd" : "28:1446pd (28:1446 Petition for Removal- Property Damage (P.I)",
      "28:1446pi" : "28:1446pi (28:1446 Petition for Removal- Personal Injury)",
      "28:1446pl" : "28:1446pl (28:1446pl Petition for Removal - Product Liability)",
      "28:1446pr" : "28:1446pr (28:1446 Petition for Removal)",
      "28:1452" : "28:1452 (28:1452 R&R re motions to remand (non-core))",
      "28:157b" : "28:157b (Tort-Personal Injury/Wrongful Death Claims )",
      "28:1651" : "28:1651 (28:1651 Petition for Writ of Coram Nobis)",
      "28:1651hc" : "28:1651hc (28:1651 Petition for Writ of Habeas Corpus)",
      "28:1651mn" : "28:1651mn (28:1651 Petition for Writ of Mandamus)",
      "28:1782" : "28:1782 (28:1782 Letter rogatory - appointment )",
      "28:1983" : "28:1983 (28:1983 Civil Rights)",
      "28:2201" : "28:2201 (28:2201 Constitutionality of State Statute(s))",
      "28:2201dj" : "28:2201dj (28:2201 Declaratory Judgment)",
      "28:2201ij" : "28:2201ij (28:2201 Injunction)",
      "28:2201in" : "28:2201in (28:2201 Declaratory Judgment (Insurance))",
      "28:2241" : "28:2241 (28:2241 Petition for Writ of Habeas Corpus (federal))",
      "28:2254" : "28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))",
      "28:2254se" : "28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)",
      "28:2255" : "28:2255 (28:2255 Motion to Vacate / Correct Illegal Sentence)",
      "28:2271" : "28:2271 (28:2271 Federal Tort Claims Act)",
      "28:2345" : "28:2345 (28:2345 Medicare Recovery)",
      "28:2409" : "28:2409 (28:2409(a) Quiet Title Action)",
      "28:2410" : "28:2410 (28:2410 Quiet Title)",
      "28:2671" : "28:2671 (28:2671 Federal Tort Claims Act)",
      "28:2674" : "28:2674 (28:2674 Federal Tort Claims Act)",
      "28:2675" : "28:2675 (28:2675 Federal Tort Claims Act )",
      "28:3001" : "28:3001 (28:3001 Federal Debt Collection Act )",
      "28:7402" : "28:7402 (28:7402 Refund of Taxes)",
      "28:7422" : "28:7422 (28:7422 Appeal from Administrative Decision)",
      "29:0151" : "29:0151 (29:151 Labor: Review of Agency Action)",
      "29:0160" : "29:0160 (29:160(1) National Labor Relations Act)",
      "29:0184" : "29:0184 (29:184 Violation Collection Bargain Agreement)",
      "29:0185ep" : "29:0185ep (29:185 Employee Pension Plan)",
      "29:0185lm" : "29:0185lm (29:185 Labor/Mgt. Relations (Contracts))",
      "29:0201do" : "29:0201do (29:201 Denial of Overtime Compensation)",
      "29:0201fl" : "29:0201fl (29:201 Fair Labor Standards Act)",
      "29:0203" : "29:0203 (29:203 Equal Pay Act)",
      "29:0206" : "29:0206 (29:206 Collect Unpaid Wages)",
      "29:0401" : "29:0401 (29:0401 Labor Management Disclosure Act)",
      "29:0621" : "29:0621 (29:621 Job Discrimination (Age))",
      "29:0623" : "29:0623 (29:623 Job Discrimination (Age))",
      "29:0626" : "29:0626 (29:626 Job Discrimination (Age))",
      "29:0633" : "29:0633 (29:633 Job Discrimination (Age))",
      "29:0651" : "29:0651 (29:651 Occupational Safety/Health)",
      "29:0754" : "29:0754 (29:754 Discrimination)",
      "29:0791" : "29:0791 (29:791 Job Discrimination (Rehabilitation Act))",
      "29:0794" : "29:0794 (29:0794 Job Discrimination (Handicap))",
      "29:1001" : "29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)",
      "29:1002" : "29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)",
      "29:1104" : "29:1104 (29:1104 Recovery of Benefits to Employee)",
      "29:1109" : "29:1109 (29:1109 Breach of Fiduciary Duties)",
      "29:1131" : "29:1131 (29:1131 ERISA - Collection of Delinquent Trust Fun)",
      "29:1132" : "29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)",
      "29:1145" : "29:1145 (29:1145 E.R.I.S.A.)",
      "29:1149" : "29:1149 (29:1149 Recover Pension & Profit Sharing)",
      "29:1337" : "29:1337 (29:1337 E.R.I.S.A.)",
      "29:1362" : "29:1362 (29:1362 ERISA)",
      "29:1381" : "29:1381 (29:1381 E.R.I.S.A.)",
      "29:1401" : "29:1401 (29:1401(b)(2) Appeal of Arbitration Award)",
      "29:1451" : "29:1451 (29:1451 E.R.I.S.A.)",
      "29:1801" : "29:1801 (29:1801 Farmworker Rights)",
      "29:2601" : "29:2601 (29:2601Family and Medical Leave)",
      "29:790" : "29:790 (29:790 Rehabilitation of Labor)",
      "30:0181" : "30:0181 (30:181 Environment: Review of Agency Action)",
      "30:0801" : "30:0801 (30:0801 Penalities/Federal Mine Safety Health Act)",
      "30:1201" : "30:1201 (30:1201 Environment: Review of Agency Action)",
      "30:1202" : "30:1202 (30:1202 Mining Reclamation Act)",
      "30:1276" : "30:1276 (30:1276 Interior: Review of Agency Action)",
      "31:3545" : "31:3545 (31:3545 Action to Recovery Money)",
      "31:3729" : "31:3729 (31:3729 False Claims Act)",
      "31:3730" : "31:3730 (31:3730 Qui Tam False Claims Act)",
      "31:3731" : "31:3731 (31:3731 Fraud)",
      "33:1319cw" : "33:1319cw (33:1319 Clean Water Act)",
      "33:1319pv" : "33:1319pv (33:1319 Pollutants & Permit Violations)",
      "33:1365" : "33:1365 (33:1365 Environmental Matters)",
      "35:0145" : "35:0145 (35:145 Patent Infringement)",
      "35:0183" : "35:0183 (35:183 Patent Infringement)",
      "35:0271" : "35:0271 (35:271 Patent Infringement)",
      "38:1681" : "38:1681 (38:1681 Recovery of VA Overpayment)",
      "38:1686" : "38:1686 (38:1686 Recovery of VA Overpayment)",
      "38:1780" : "38:1780 (38:1780 Recovery of VA Overpayment)",
      "38:2011" : "38:2011 (38:2011 - Veteran's Readjustment Assistance Act of)",
      "38:2021" : "38:2021 (Right to re-employment of inducted persons )",
      "38:3116" : "38:3116 (38:3116 VA Overpayment)",
      "38:4301" : "38:4301 (Uniformed Services Employment and Reemployment Rights Act)",
      "38:775" : "38:775 (Recovery of Servicemen's Group Life Insurance )",
      "39:3005" : "39:3005 (39:3005 Detention of Mail for Temporary Periods)",
      "39:409" : "39:409 (39:409 Postal Service)",
      "40:0258" : "40:0258 (40:258(a) Public Buildings & Property: Land Condem)",
      "40:0270" : "40:0270 (40:270 Miller Act)",
      "40:0875" : "40:0875 (40:875 Public Buildings & Property: Negligence)",
      "41:0251" : "41:0251 (41:251 Public Contracts-Review of Agency Action)",
      "41:1463" : "41:1463 (41:1463 Public Contracts: Unlawful Employment Prac)",
      "42:0205" : "42:0205 (42:205 Denial Social Security Benefits)",
      "42:0206" : "42:0206 (42:206 Social Security Benefits)",
      "42:0247" : "42:0247 (42:247 Personal Injury-Swine Flu)",
      "42:0297n" : "42:0297n (42:297n Public Health Loan Repayment Scholarship)",
      "42:0402" : "42:0402 (42:402 Social Security Benefits)",
      "42:0405id" : "42:0405id (42:405 Review of HHS Decision (SSID))",
      "42:0405wc" : "42:0405wc (42:405 Review of HHS Decision (DIWC))",
      "42:0405ww" : "42:0405ww (42:405 Review of HHS Decision (DIWW))",
      "42:0416" : "42:0416 (42:416 Denial of Social Security Benefits)",
      "42:0427" : "42:0427 (42:427 Social Security Benefits)",
      "42:11601" : "42:11601 (42:11601 International Child Abduction)",
      "42:12101" : "42:12101 (42:12101 Americans With Disabilities Act )",
      "42:1383" : "42:1383 (42:1383 Review of HHS Decision)",
      "42:1395" : "42:1395 (42:1395 HHS: Adverse Reimbursement Review)",
      "42:1396" : "42:1396 (42:1396 - Tort Negligence)",
      "42:1471" : "42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclo)",
      "42:1981cv" : "42:1981cv (42:1981 Civil Rights)",
      "42:1981hs" : "42:1981hs (42:1981 Housing Discrimination)",
      "42:1981jb" : "42:1981jb (42:1981 Job Discrimination (Race))",
      "42:1981sx" : "42:1981sx (42:1981 Sex Discrimination)",
      "42:1983cv" : "42:1983cv (42:1983 Civil Rights Act)",
      "42:1983ed" : "42:1983ed (42:1983 Civil Rights (Employment Discrimination))",
      "42:1983pr" : "42:1983pr (42:1983 Prisoner Civil Rights)",
      "42:1986" : "42:1986 (42:1986 Neglect of Duty)",
      "42:2000ag" : "42:2000ag (42:2000 Job Discrimination (Age))",
      "42:2000da" : "42:2000da (42:2000 Job Discrimination (ADA 1990) )",
      "42:2000e" : "42:2000e (42:2000e Job Discrimination (Employment))",
      "42:2000pb" : "42:2000pb (42:2000 Job Discrimination (Public Accomodations))",
      "42:2000ra" : "42:2000ra (42:2000 Job Discrimination (Race))",
      "42:2000sx" : "42:2000sx (42:2000 Job Discrimination (Sex))",
      "42:2003" : "42:2003 (42:2003 Job Discrimination)",
      "42:2005" : "42:2005 (42:2005 Review of Agency Action-HHS)",
      "42:2601" : "42:2601 (42:2601 Family and Medical Leave Act of 1993)",
      "42:2615" : "42:2615 (42:2616 Medical Recovery Act )",
      "42:2651" : "42:2651 (42:2651 Medical Care Recovery)",
      "42:3601" : "42:3601 (42:405 Fair Housing Act)",
      "42:4000" : "42:4000 (42:4000 National Flood Insurance Act)",
      "42:4001" : "42:4001 (42:4001 National Insurance Flood Act)",
      "42:4053" : "42:4053 (42:4053 Breach of Insurance Contract)",
      "42:4072" : "42:4072 (42:4072 Payment of Flood Insurance Claim)",
      "42:4321" : "42:4321 (42:4321 Review of Agency Action-Environment)",
      "42:4332" : "42:4332 (42:4332 Environmental Policy - Coop of Agency Repo)",
      "42:4852d" : "42:4852d (42:4852d Disclosure of Information Concerning Lead Upon Transfer of Residential Property)",
      "42:6901" : "42:6901 (Environmental Cleanup Expenses )",
      "42:6901en" : "42:6901en (42:6901 Environmental Cleanup Expenses)",
      "42:6901rs" : "42:6901rs (42:6901 Resource & Recovery Act)",
      "42:7413" : "42:7413 (42:7413(b) Clean Air Act)",
      "42:7604cl" : "42:7604cl (42:7604 Clear Air Act (Emission Standards))",
      "42:7604ir" : "42:7604ir (42:7604 Petition to Quash IRS Summons)",
      "42:9604" : "42:9604 (42:9604 Response Authorities (CERCLA))",
      "42:9607" : "42:9607 (42:9607 Real Property Tort to Land (CERCLA))",
      "43:945" : "43:945 (43:945 Compensation for Land Condemnation)",
      "43:945a" : "43:945a (43:945a Complaint in Condemnation)",
      "43:946" : "43:946 (43:946 Complaint in Condemnation - Eminent Domain)",
      "45:0051" : "45:0051 (45:51 Railways: Fed. Employer's Liability Act)",
      "45:0151" : "45:0151 (45:151 Railway Labor Act)",
      "45:0184" : "45:0184 (45:184 Action to Set Aside Award of a System Board)",
      "45:1395" : "45:1395 (45:1395 Railroads: Adverse Reimbursement Review)",
      "45:7457" : "45:7457 (45:7457 Compel Reclamation Under Clear Air Act)",
      "46:0688" : "46:0688 (46:688 Jones Act)",
      "46:0741" : "46:0741 (46:741 Shipping)",
      "46:0761" : "46:0761 (46:761 Shipping: Damages for Death on High Seas)",
      "46:1101" : "46:1101 (46:1101 Violation of Maritime Regulations)",
      "46:1156" : "46:1156 (46:1156 Administrative Procedure Act)",
      "47:0332" : "47:0332 (47:332 Federal Telecommunications Act of 1996 )",
      "47:227" : "47:227 (47:227 Telephone Consumer Protection Act)",
      "47:553" : "47:553 (47:553 Unauthorized Reception of Cable Service)",
      "48:0883" : "48:0883 (48:883 Violation of US Coastal Law)",
      "48:1985" : "48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)",
      "49:0081" : "49:0081 (49:81 Damaged Goods While Being Transported)",
      "49:0781" : "49:0781 (49:781 Forfeiture)",
      "49:11503" : "49:11503 (49:11503 Railroad Revitalization Regulatory Reform)",
      "49:11702" : "49:11702 (49:11702(a)(4) Violations of Interstate Commerce A)",
      "49:1471" : "49:1471 (49:1471 Federal Aviation Act)",
      "49:1903" : "49:1903 (49:1903 Petition to enforce administrative summon)",
      "8:1105(a)" : "8:1105(a) (Aliens: Habeas Corpus to Release INS Detainee )",
      "8:1183(a)" : "8:1183(a) (8:1183(a) Aliens: Requirements for Sponsor's Affidavit of Support)",
      "8:287" : "8:287 (8:287 Petition to Enforce INS Subpoena)",
      "99:9999" : "99:9999 (99:9999 Report cause code (DO NOT DELETE!) )",
      "adsup" : "adsup (Administrative Subpoena )",
      "contempt" : "contempt (Contempt Proceedings )",
      "disbar" : "disbar (Disbarment Proceedings )",
      "fordepo" : "fordepo (Foreign Deposition )",
      "mifp" : "mifp (Motion to proceed IFP )",
      "misc" : "misc (Civil Miscellaneous Case)",
      "motcomp" : "motcomp (Motion to Compel )",
      "motquash" : "motquash (Motion to Quash )",
      "motret" : "motret (Motion for Return of Property )",
      "petenf" : "petenf (Petition to Enforce IRS Summons )",
      "petper" : "petper (Petition to Perpetuate Testimony )",
      "regjgm" : "regjgm (Registration of Foreign Judgment )",
      "tranbkref" : "tranbkref (Transmission of Bankruptcy Reference )",
      "tranff" : "tranff (Transmission of Proposed Findings of Fact and Concl. of Law )",
      "writgar" : "writgar (Application for a Writ of Garnishment )"
   },
   "njdce" : {
      "0" : "0 (No cause code entered)",
      "02:0431" : "02:0431 (02:431 Fed. Election Commission: Failure Enforce C)",
      "02:0437" : "02:0437 (02:437 Federal Election Commission)",
      "05:0075" : "05:0075 (05:75(2) Contract - Reduction in Grade)",
      "05:0551" : "05:0551 (05:551 Administrative Procedure Act)",
      "05:0552fi" : "05:0552fi (05:552 Freedom of Information Act)",
      "05:0552pa" : "05:0552pa (05:552 Right to Privacy Act)",
      "05:0554" : "05:0554 (05:0554 Constitutionality of Maritime Statutes)",
      "05:0701" : "05:0701 (05:0701 Maritime Subsidy Board)",
      "05:0702" : "05:0702 (05:702 Administrative Procedure Act)",
      "05:0704" : "05:0704 (05:704 Labor Litigation)",
      "05:7703" : "05:7703 (05:7703 Discrimination - Review of Agency Act)",
      "05:8470" : "05:8470 (05:8470 Enforcement of Judgment against Retirement Benefits)",
      "07:0006" : "07:0006 (7:6(b) Federal Commodity Exchange Regulation)",
      "07:0025" : "07:0025 (7:25 Fraud - Commodities Leverage Contracts)",
      "07:0181" : "07:0181 (07:181 Packers & Stockyard Act)",
      "07:0499" : "07:0499 (07:499 Agricultural Commodities Act)",
      "07:0601" : "07:0601 (07:601 USDA Condemnation)",
      "07:2321" : "07:2321 (07:2321 Plant Variety Protection Act)",
      "08:1105" : "08:1105 (8:1105(a) Aliens: Habeas Corpus to Release INS Det)",
      "08:1182" : "08:1182 (8:1182 Defend. Denial of Pla. Appl. for Alien Employment Cer)",
      "08:1252" : "08:1252 (08:1252(a)(2) Injunction for Deportation)",
      "08:1260" : "08:1260 (08:1260 Aliens: Access to Records)",
      "08:1324" : "08:1324 (08:1324 Aliens: Complaint for Forfeiture)",
      "08:1329" : "08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petiti)",
      "08:1446" : "08:1446 (8:1446 Petition for Naturalization Hearing)",
      "08:1451(j)" : "08:1451(j) (8:1451(j) Motion to Correct Order & Judg. of Naturalization)",
      "09:0001" : "09:0001 (09:1 U.S. Arbitration Act)",
      "09:0009" : "09:0009 (9:9 Motion to Confirm Arbitration Loan)",
      "09:0010" : "09:0010 (09:0010 Petition to Vacate Arbitration Award)",
      "10:1408" : "10:1408 (10:1408 Claim for Military Retirement)",
      "10:1552" : "10:1552 (10:1552 Armed Forces: Action to Correct Records)",
      "10:1553" : "10:1553 (10:1553 Armed Forces: FOIA General)",
      "10:2305" : "10:2305 (10:2305 Review of Federal Contract)",
      "11:0101" : "11:0101 (11:101 Bankruptcy)",
      "12:0022" : "12:0022 (12:22 Securities Fraud)",
      "12:0635" : "12:0635 (12:635 Breach of Insurance Contract)",
      "12:1461" : "12:1461 (12:1461 Homeowners Loan Act)",
      "12:1464" : "12:1464 (12:1464 Federal Savings and Loan)",
      "12:1703" : "12:1703 (12:1703 Default of HUD Loan)",
      "12:1725" : "12:1725 (12:1725 Collection under Contract Guaranty)",
      "12:1730" : "12:1730 (12:1730 Collection Under Contract Guaranty)",
      "12:1819" : "12:1819 (12:1819 Default of Promissory Note)",
      "12:1821" : "12:1821 (12:1821 Default of Loan by Promissary Note)",
      "12:191" : "12:191 (12:191 Bank Foreclosure)",
      "12:192" : "12:192 (12:192 Liquidation of National Bank)",
      "12:1971" : "12:1971 (12:1971 Relief under Bank Holding Act)",
      "12:1972" : "12:1972 (12:1972 Tying Arrangement Act)",
      "12:3410" : "12:3410 (12:3410 Right to Financial Privacy Act)",
      "15:0001" : "15:0001 (15:1 Antitrust Litigation)",
      "15:0002at" : "15:0002at (15:2 Antitrust Litigation)",
      "15:0002fl" : "15:0002fl (15:2(a) Fair Labor Standards Act)",
      "15:0005" : "15:0005 (15:5(a) Fair Labor Standards Act)",
      "15:0015" : "15:0015 (15:15 Antitrust Litigation)",
      "15:0025" : "15:0025 (15:25 Clayton Act)",
      "15:0044" : "15:0044 (15:44 Trademark Infringement)",
      "15:0045" : "15:0045 (15:0045 Federal Trade Commission Act)",
      "15:0052" : "15:0052 (15:0052 Federal Trade Commission Act)",
      "15:0053" : "15:0053 (15:0053 Federal Trade Commission Act)",
      "15:0077" : "15:0077 (15:77 Securities Fraud)",
      "15:0078" : "15:0078 (15:78m(a) Securities Exchange Act)",
      "15:0631" : "15:0631 (15:631 Small Business Act)",
      "15:0717" : "15:0717 (15:717 Natural Gas Act)",
      "15:0754" : "15:0754 (15:754 Emergency Petroleum Allocation-Admin.& Enforcement)",
      "15:1051" : "15:1051 (15:1051 Trademark Infringement)",
      "15:1114" : "15:1114 (15:1114 Trademark Infringement)",
      "15:1121" : "15:1121 (15:1121 Trademark Infringement)",
      "15:1125" : "15:1125 (15:1125 Trademark Infringement (Lanham Act))",
      "15:1126" : "15:1126 (15:1126 Patent Infringement)",
      "15:1127" : "15:1127 (15:1127 Trademark Infringement)",
      "15:1601" : "15:1601 (15:1601 Truth in Lending)",
      "15:1640" : "15:1640 (15:1640 Truth in Lending)",
      "15:1681" : "15:1681 (15:1681 Fair Credit Reporting Act)",
      "15:1692" : "15:1692 (15:1692 Fair Debt Collection Act)",
      "15:1938" : "15:1938 (15:1938 Fair Labor Standards Act)",
      "15:1981" : "15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))",
      "15:1988" : "15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))",
      "15:1989" : "15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))",
      "15:2301" : "15:2301 (15:2301 Magnuson-Moss Warranty Act)",
      "15:2801" : "15:2801 (15:2801 Petroleum Marketing Practices Act)",
      "15:53(b)" : "15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equita)",
      "16:0668" : "16:0668 (16:668 Bald Eagle Protection Act)",
      "16:0703" : "16:0703 (16:703 Migratory Bird Act)",
      "16:1538" : "16:1538 (16:1538 Endangered Species Act)",
      "16:3371" : "16:3371 (16:3371 Wildlife Under the Lacey Act)",
      "16:3372" : "16:3372 (16:3372 Conservation: Complaint for Forfeiture)",
      "16:3373" : "16:3373 (16:3373 Appeal of Decision - DOI)",
      "16:3374" : "16:3374 (16:3374 Conservation: Complaint for Forfeiture)",
      "17:0101" : "17:0101 (17:101 Copyright Infringement)",
      "17:0501" : "17:0501 (17:501 Copyright Infringement)",
      "17:0504" : "17:0504 (17:504 Copyright Infringement)",
      "18:0241" : "18:0241 (18:241 Conspiracy Against Citizen Rights)",
      "18:157(3)" : "18:157(3) (18:157(3) Bankruptcy Fraud)",
      "18:1836a" : "18:1836a (18:1836(a) Injunction against Misappropriation of Trade Secrets)",
      "18:1836b" : "18:1836b (18:1836(b) Civil Action to Protect Trade Secrets)",
      "18:1961" : "18:1961 (18:1961 Racketeering (RICO) Act)",
      "18:1962" : "18:1962 (18:1962 Racketeering (RICO) Act)",
      "18:1964" : "18:1964 (18:1964 Racketeering (RICO) Act)",
      "18:2511" : "18:2511 (18:2511 Wiretapping)",
      "18:3114" : "18:3114 (18:3114 Motion for Return of Seized Property)",
      "18:4208" : "18:4208 (18:4208(B) Agency Action Review)",
      "19:1305" : "19:1305 (19:1305 Custom Duties:0Forfeiture-Immoral Articles)",
      "20:1080" : "20:1080 (20:1080 Student Loan Recovery)",
      "20:1400" : "20:1400 (20:1400 Civil Rights of Handicapped Child)",
      "20:1401" : "20:1401 (20:1401 Education: Handicapped Child Act)",
      "21:0841" : "21:0841 (21:841 Forfeiture Property-Drugs)",
      "21:0881" : "21:0881 (21:881 Forfeiture Property-Drugs)",
      "21:0881a" : "21:0881a (21:881 Forfeiture Property - Aircraft)",
      "21:0881re" : "21:0881re (21:881 Forfeiture Property - Real Estate)",
      "23:0134" : "23:0134 (23:134 P.I.- Auto Negligence)",
      "23:1441" : "23:1441 (23:1441 Contract Real Estate)",
      "24:1000" : "24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)",
      "25:0640" : "25:0640 (25:640 Indian Tribal Rights)",
      "25:1901" : "25:1901 (25:1901 Indian Child Welfare Act)",
      "26:6212" : "26:6212 (26:6212 Injunctive Relief from IRS Lien)",
      "26:6213" : "26:6213 (26:6213 Injunctive Relief from IRS Lien)",
      "26:6502" : "26:6502 (26:6502 IRS:Enforcement of tax liens)",
      "26:6532" : "26:6532 (26:6532 IRS: Refund of Tax Penalty)",
      "26:6702" : "26:6702 (26:6702 IRS: Refund of Income Tax Penalty)",
      "26:6703" : "26:6703 (26:6703 IRS: Refund of Tax Penalty)",
      "26:7401" : "26:7401 (26:7401 IRS: Tax Liability)",
      "26:7402" : "26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)",
      "26:7402a" : "26:7402a (26:7402(a) Injunctive Relief - Internal Revenue Code)",
      "26:7403" : "26:7403 (26:7403 Suit to Enforce Federal Tax Lien)",
      "26:7422rt" : "26:7422rt (26:7422 IRS: Refund Taxes)",
      "26:7422rx" : "26:7422rx (26:7422 IRS: Refund Excise Tax)",
      "26:7426" : "26:7426 (26:7426 IRS: Wrongful Levy for Taxes)",
      "26:7429" : "26:7429 (26:7429 IRS: Tax Jeopardy Assessment)",
      "26:7609" : "26:7609 (26:7609 IRS: Petition to Quash IRS Summons)",
      "27:0185" : "27:0185 (27:185 Enforcement of Arbitration Award)",
      "28:0157c" : "28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)",
      "28:0157d" : "28:0157d (28:0157 Motion for Withdrawal of Reference)",
      "28:0158" : "28:0158 (28:0158 Notice of Appeal re Bankruptcy Matter (BA)",
      "28:0185" : "28:0185 (28:185 Suit to Compel Arbitration)",
      "28:0451" : "28:0451 (28:451 Employment Discrimination)",
      "28:0754" : "28:0754 (28:754 Receiver of Property in Different Districts)",
      "28:0794" : "28:0794 (28:794 Rehabilitation Act)",
      "28:1001" : "28:1001 (28:1001 E.R.I.S.A.)",
      "28:1132" : "28:1132 (28:1132 E.R.I.S.A.)",
      "28:1330" : "28:1330 (28:1330 Breach of Contract)",
      "28:1331" : "28:1331 (28:1331 Fed. Question)",
      "28:1331al" : "28:1331al (28:1331 Fed. Question: Airline Crash)",
      "28:1331at" : "28:1331at (28:1331 Fed. Question: Anti-trust)",
      "28:1331au" : "28:1331au (28:1331 Fed. Question: Auto Negligence)",
      "28:1331b" : "28:1331b (28:1331 Federal Question: Bivens Act)",
      "28:1331bc" : "28:1331bc (28:1331 Fed. Question: Breach of Contract)",
      "28:1331ca" : "28:1331ca (28:1331 Fed Question: Fed Communications Act of 1)",
      "28:1331cm" : "28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)",
      "28:1331cv" : "28:1331cv (28:1331 Federal Question: Other Civil Rights)",
      "28:1331ed" : "28:1331ed (28:1331 Fed. Question: Employment Discrimination)",
      "28:1331ej" : "28:1331ej (28:1331 Federal Question: Enforcement of Judgment)",
      "28:1331es" : "28:1331es (28:1331 Enforcement of Administrative Subpoena)",
      "28:1331fl" : "28:1331fl (28:1331 Fed. Question: Fair Labor Standards)",
      "28:1331ij" : "28:1331ij (28:1331 Federal Question-Injunctive & Declaratory Relief)",
      "28:1331in" : "28:1331in (28:1331 Fed. Question: Insurance Contract)",
      "28:1331mm" : "28:1331mm (28:1331 Fed. Question: Medical Malpractice)",
      "28:1331ng" : "28:1331ng (28:1331 Fed. Question: Natural Gas Act)",
      "28:1331pi" : "28:1331pi (28:1331 Fed. Question: Personal Injury)",
      "28:1331rd" : "28:1331rd (28:1331 Fed. Question: Review Agency Decision)",
      "28:1331rp" : "28:1331rp (28:1331(a) Fed. Question: Real Property)",
      "28:1331rr" : "28:1331rr (28:1331 Fed. Question: Railway Labor Act)",
      "28:1331sv" : "28:1331sv (28:1331 Fed. Question: Securities Violation)",
      "28:1331tr" : "28:1331tr (28:1331 Fed. Question: Trademark)",
      "28:1331tt" : "28:1331tt (28:1331 Fed. Question: Tort Action)",
      "28:1331v" : "28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendme)",
      "28:1331wl" : "28:1331wl (28:1331 Federal Question: EPA Waste Lien)",
      "28:1331wt" : "28:1331wt (28:1331 Fed. Question: Water Rights)",
      "28:1332ac" : "28:1332ac (28:1332 Diversity-Account Receivable)",
      "28:1332al" : "28:1332al (28:1332 Diversity-Airline Crash)",
      "28:1332as" : "28:1332as (28:1332 Diversity-Asbestos Litigation)",
      "28:1332au" : "28:1332au (28:1332 Diversity-Auto Negligence)",
      "28:1332bc" : "28:1332bc (28:1332 Diversity-Breach of Contract)",
      "28:1332co" : "28:1332co (28:1332 Diversity-Conversion)",
      "28:1332ct" : "28:1332ct (28:1332 Diversity-(Citizenship))",
      "28:1332det" : "28:1332det (28:1332 Diversity: Forcible Detainer)",
      "28:1332df" : "28:1332df (28:1332 Diversity-Contract Default)",
      "28:1332ds" : "28:1332ds (28:1332 Diversity-Contract Dispute)",
      "28:1332ed" : "28:1332ed (28:1332 Diversity-Employment Discrimination)",
      "28:1332fd" : "28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)",
      "28:1332fr" : "28:1332fr (28:1332 Diversity-Fraud)",
      "28:1332ia" : "28:1332ia (28:1332 Diversity-Interpleader Action)",
      "28:1332ij" : "28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)",
      "28:1332in" : "28:1332in (28:1332 Diversity-Insurance Contract)",
      "28:1332jd" : "28:1332jd (28:1332 Diversity-Declaratory Judgment)",
      "28:1332lb" : "28:1332lb (28:1332 Diversity-Libel,Assault,Slander)",
      "28:1332lm" : "28:1332lm (28:1332 Diversity - Legal Malpractice)",
      "28:1332ma" : "28:1332ma (28:1332 Diversity-Miller Act)",
      "28:1332mm" : "28:1332mm (28:1332 Diversity-Medical Malpractice)",
      "28:1332mv" : "28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)",
      "28:1332ni" : "28:1332ni (28:1332 Diversity-Negotiable Instrument)",
      "28:1332nm" : "28:1332nm (28:1332 Diversity-Non-Motor Vehicle)",
      "28:1332nr" : "28:1332nr (28:1332 Diversity-Notice of Removal)",
      "28:1332oc" : "28:1332oc (28:1332 Diversity-Other Contract)",
      "28:1332pd" : "28:1332pd (28:1332 Diversity-Property Damage)",
      "28:1332pi" : "28:1332pi (28:1332 Diversity-Personal Injury)",
      "28:1332pl" : "28:1332pl (28:1332 Diversity-Product Liability)",
      "28:1332pr" : "28:1332pr (28:1332 Diversity-Petition for Removal)",
      "28:1332qt" : "28:1332qt (28:1332 Diversity-Petition to Quiet Title)",
      "28:1332ri" : "28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)",
      "28:1332sa" : "28:1332sa (28:1332 - Diversity: Securities & Exchange Commiss)",
      "28:1332sf" : "28:1332sf (28:1332 - Diversity: Securities Fraud)",
      "28:1332ss" : "28:1332ss (28:1332 Diversity - Stockholders Suits)",
      "28:1332tl" : "28:1332tl (28:1332 Diversity-Torts to Land)",
      "28:1332tm" : "28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))",
      "28:1332tn" : "28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)",
      "28:1332wd" : "28:1332wd (28:1332 Diversity-Wrongful Death)",
      "28:1333" : "28:1333 (28:1333 Admiralty)",
      "28:1334" : "28:1334 (28:1334 Bankruptcy Appeal)",
      "28:1334c" : "28:1334c (28:1334(c) R&R re motions for abstention (non-cor)",
      "28:1335" : "28:1335 (28:1335 Interpleader Action)",
      "28:1337" : "28:1337 (28:1337 Sherman-Clayton Act)",
      "28:1338cp" : "28:1338cp (28:1338 Copyright Infringement)",
      "28:1338pt" : "28:1338pt (28:1338 Patent Infringement)",
      "28:1338tr" : "28:1338tr (28:1338 Trademark Infringement)",
      "28:1340" : "28:1340 (28:1340 IRS: Custom Duties)",
      "28:1340er" : "28:1340er (28:1340 Recovery of Erroneous Refund)",
      "28:1341" : "28:1341 (28:1341 Complaint for Forfeiture)",
      "28:1343" : "28:1343 (28:1343 Violation of Civil Rights)",
      "28:1345" : "28:1345 (28:1345 USA Plaintiff)",
      "28:1345co" : "28:1345co (28:1345 Replevin & Conversion)",
      "28:1345db" : "28:1345db (28:1345 Debt to US - FHA/HUD Title I)",
      "28:1345df" : "28:1345df (28:1345 Default of Promissory Note)",
      "28:1345er" : "28:1345er (28:1345 Recovery of Erroneous Refund)",
      "28:1345fc" : "28:1345fc (28:1345 Foreclosure)",
      "28:1345ff" : "28:1345ff (28:1345 Complaint for Forfeiture)",
      "28:1345hl" : "28:1345hl (28:1345 VA Home Loan Guaranty Debt)",
      "28:1345ij" : "28:1345ij (28:1345ij Injunction Relief)",
      "28:1345mc" : "28:1345mc (28:1345 Medical Care Recovery)",
      "28:1345mi" : "28:1345mi (28:1345 Mining Claim Ejectment)",
      "28:1345pd" : "28:1345pd (28:1345 Property Damage)",
      "28:1345pe" : "28:1345pe (28:1345 Property Ejectment)",
      "28:1345rc" : "28:1345rc (28:1345 Recovery of Debt to US)",
      "28:1345st" : "28:1345st (28:1345 Default of Student Loan)",
      "28:1345tp" : "28:1345tp (28:1345 Trespass on Public Land)",
      "28:1345va" : "28:1345va (28:1345 Recovery of VA Overpayment)",
      "28:1346bc" : "28:1346bc (28:1346 Breach of Contract)",
      "28:1346rc" : "28:1346rc (28:1346 Recovery of IRS Tax)",
      "28:1346tc" : "28:1346tc (28:1346 Tort Claim)",
      "28:1346wd" : "28:1346wd (28:1346 Wrongful Death)",
      "28:1349" : "28:1349 (28:1348 Corporation organized under Federal Law as party)",
      "28:1352" : "28:1352 (28:1352 Miller Act)",
      "28:1355" : "28:1355 (28:1355 Petition for Return of Property)",
      "28:1358" : "28:1358 (28:1358 Land Condemnation)",
      "28:1361" : "28:1361 (28:1361 Petition for Writ of Mandamus)",
      "28:1362ic" : "28:1362ic (28:1362 Indian Tribal Controversy)",
      "28:1362iw" : "28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)",
      "28:1364" : "28:1364 (28:1364 Auto Negligence)",
      "28:1391" : "28:1391 (28:1391 Personal Injury)",
      "28:1402" : "28:1402 (28:1402 Medical Malpractice)",
      "28:1407" : "28:1407 (28:1407 Airline Crash)",
      "28:1441ac" : "28:1441ac (28:1441 Notice of Removal- Account Receivable)",
      "28:1441al" : "28:1441al (28:1441 Notice of Removal- Airline Crash)",
      "28:1441as" : "28:1441as (28:1441 Notice of Removal- Asbestos Litigation)",
      "28:1441au" : "28:1441au (28:1441 Notice of Removal- Auto Negligence)",
      "28:1441bc" : "28:1441bc (28:1441 Notice of Removal- Breach of Contract)",
      "28:1441cv" : "28:1441cv (28:1441 Notice of Removal- Civil Rights Act)",
      "28:1441df" : "28:1441df (28:1441 Notice of Removal- Contract Default)",
      "28:1441dj" : "28:1441dj (28:1441 Notice of Removal- Declaratory Judgment)",
      "28:1441ds" : "28:1441ds (28:1441 Notice of Removal- Contract Dispute)",
      "28:1441ed" : "28:1441ed (28:1441 Notice of Removal - Employment Discrim)",
      "28:1441fc" : "28:1441fc (28:1441 Notice of Removal - Fair Credit Reporti)",
      "28:1441fr" : "28:1441fr (28:1441 Notice of Removal- Fraud)",
      "28:1441ij" : "28:1441ij (28:1441 Notice of Removal- Injunctive/Declarato)",
      "28:1441in" : "28:1441in (28:1441 Notice of Removal- Insurance Contract)",
      "28:1441int" : "28:1441int (28:1441 Notice of Removal- Action for Interplea)",
      "28:1441lb" : "28:1441lb (28:1441 Notice of Removal Libel,Assault,Slander)",
      "28:1441lm" : "28:1441lm (28:1441 Notice of Removal- Labor/Mgmnt. Relatio)",
      "28:1441mm" : "28:1441mm (28:1441 Notice of Removal- Medical Malpractice)",
      "28:1441ni" : "28:1441ni (28:1441 Notice of Removal- Negotiable Instrumen)",
      "28:1441nm" : "28:1441nm (28:1441 Notice of Removal- Non-Motor Vehicle)",
      "28:1441nr" : "28:1441nr (28:1441 Notice of Removal)",
      "28:1441oc" : "28:1441oc (28:1441 Notice of Removal--Other Contract)",
      "28:1441pd" : "28:1441pd (28:1441 Notice of Removal- Property Damage)",
      "28:1441pi" : "28:1441pi (28:1441 Notice of Removal- Personal Injury)",
      "28:1441pl" : "28:1441pl (28:1441 Notice of Removal- Product Liability)",
      "28:1441pr" : "28:1441pr (28:1441 Notice of Removal)",
      "28:1441qt" : "28:1441qt (28:1441 Notice of Removal- Petition to Quiet Ti)",
      "28:1441ri" : "28:1441ri (28:1441 Notice of Removal- Racketeering (RICO))",
      "28:1441sa" : "28:1441sa (28:1441 - Notice of Removal: SEC Act)",
      "28:1441sf" : "28:1441sf (28:1441 - Notice of Removal: Securities Fraud)",
      "28:1441tl" : "28:1441tl (28:1441 Notice of Removal- Torts to Land)",
      "28:1441tm" : "28:1441tm (28:1441 Notice of Removal- Tort/Motor Vehicle ()",
      "28:1441tn" : "28:1441tn (28:1441 Notice of Removal- Tort/Non-Motor Vehic)",
      "28:1441wd" : "28:1441wd (28:1441 Notice of Removal- Wrongful Death)",
      "28:1442bc" : "28:1442bc (28:1442 Notice of Removal- Breach of Contract)",
      "28:1442nr" : "28:1442nr (28:1442 Notice of Removal)",
      "28:1442pr" : "28:1442pr (28:1442 Notice of Removal)",
      "28:1443" : "28:1443 (28:1443(1) Rent, Lease & Ejectment)",
      "28:1444" : "28:1444 (28:1444 Notice of Removal- Foreclosure)",
      "28:1446in" : "28:1446in (28:1446 Breach of Contract- Insurance)",
      "28:1446nr" : "28:1446nr (28:1446 Notice of Removal)",
      "28:1446pd" : "28:1446pd (28:1446 Notice for Removal- Property Damage (P.I)",
      "28:1446pi" : "28:1446pi (28:1446 Notice for Removal- Personal Injury)",
      "28:1446pl" : "28:1446pl (28:1446pl Notice for Removal - Product Liability)",
      "28:1446pr" : "28:1446pr (28:1446 Notice for Removal)",
      "28:1452" : "28:1452 (28:1452 R&R re motions to remand (non-core))",
      "28:1651" : "28:1651 (28:1651 Petition for Writ of Coram Nobis)",
      "28:1651hc" : "28:1651hc (28:1651 Petition for Writ of Habeas Corpus)",
      "28:1651mn" : "28:1651mn (28:1651 Petition for Writ of Mandamus)",
      "28:1782" : "28:1782 (28:1782 Letter rogatory - appointment)",
      "28:1983" : "28:1983 (28:1983 Civil Rights)",
      "28:2201" : "28:2201 (28:2201 Constitutionality of State Statute(s))",
      "28:2201dj" : "28:2201dj (28:2201 Declaratory Judgment)",
      "28:2201ij" : "28:2201ij (28:2201 Injunction)",
      "28:2201in" : "28:2201in (28:2201 Declaratory Judgment (Insurance))",
      "28:2241" : "28:2241 (28:2241 Petition for Writ of Habeas Corpus (federa)",
      "28:2254" : "28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))",
      "28:2254se" : "28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)",
      "28:2255" : "28:2255 (28:2255 Motion to Vacate / Correct Illegal Sentenc)",
      "28:2271" : "28:2271 (28:2271 Federal Tort Claims Act)",
      "28:2345" : "28:2345 (28:2345 Medicare Recovery)",
      "28:2409" : "28:2409 (28:2409(a) Quiet Title Action)",
      "28:2410" : "28:2410 (28:2410 Quiet Title)",
      "28:2671" : "28:2671 (28:2671 Federal Tort Claims Act)",
      "28:2674" : "28:2674 (28:2674 Federal Tort Claims Act)",
      "28:7402" : "28:7402 (28:7402 Refund of Taxes)",
      "28:7422" : "28:7422 (28:7422 Appeal from Administrative Decision)",
      "29:0151" : "29:0151 (29:151 Labor: Review of Agency Action)",
      "29:0160" : "29:0160 (29:160(1) National Labor Relations Act)",
      "29:0184" : "29:0184 (29:184 Violation Collection Bargain Agreement)",
      "29:0185ep" : "29:0185ep (29:185 Employee Pension Plan)",
      "29:0185lm" : "29:0185lm (29:185 Labor/Mgt. Relations (Contracts))",
      "29:0201do" : "29:0201do (29:201 Denial of Overtime Compensation)",
      "29:0201fl" : "29:0201fl (29:201 Fair Labor Standards Act)",
      "29:0203" : "29:0203 (29:203 Equal Pay Act)",
      "29:0206" : "29:0206 (29:206 Collect Unpaid Wages)",
      "29:0401" : "29:0401 (29:0401 Labor Management Disclosure Act)",
      "29:0621" : "29:0621 (29:621 Job Discrimination (Age))",
      "29:0623" : "29:0623 (29:623 Job Discrimination (Age))",
      "29:0626" : "29:0626 (29:626 Job Discrimination (Age))",
      "29:0633" : "29:0633 (29:633 Job Discrimination (Age))",
      "29:0651" : "29:0651 (29:651 Occupational Safety/Health)",
      "29:0754" : "29:0754 (29:754 Discrimination)",
      "29:0791" : "29:0791 (29:791 Job Discrimination (Rehabilitation Act))",
      "29:0794" : "29:0794 (29:0794 Job Discrimination (Handicap))",
      "29:1001" : "29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)",
      "29:1002" : "29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)",
      "29:1104" : "29:1104 (29:1104 Recovery of Benefits to Employee)",
      "29:1109" : "29:1109 (29:1109 Breach of Fiduciary Duties)",
      "29:1131" : "29:1131 (29:1131 ERISA - Collection of Delinquent Trust Fun)",
      "29:1132" : "29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)",
      "29:1145" : "29:1145 (29:1145 E.R.I.S.A.)",
      "29:1149" : "29:1149 (29:1149 Recover Pension & Profit Sharing)",
      "29:1337" : "29:1337 (29:1337 E.R.I.S.A.)",
      "29:1362" : "29:1362 (29:1362 ERISA)",
      "29:1381" : "29:1381 (29:1381 E.R.I.S.A.)",
      "29:1401" : "29:1401 (29:1401(b)(2) Appeal of Arbitration Award)",
      "29:1451" : "29:1451 (29:1451 E.R.I.S.A.)",
      "29:1801" : "29:1801 (29:1801 Farmworker Rights)",
      "29:2601" : "29:2601 (29:2601 Family Medical Leave Act)",
      "29:790" : "29:790 (29:790 Rehabilitation of Labor)",
      "30:0181" : "30:0181 (30:181 Environment: Review of Agency Action)",
      "30:0801" : "30:0801 (30:0801 Penalities/Federal Mine Safety Health Act)",
      "30:1201" : "30:1201 (30:1201 Environment: Review of Agency Action)",
      "30:1202" : "30:1202 (30:1202 Mining Reclamation Act)",
      "30:1276" : "30:1276 (30:1276 Interior: Review of Agency Action)",
      "31:3545" : "31:3545 (31:3545 Action to Recovery Money)",
      "31:3729" : "31:3729 (31:3729 False Claims Act)",
      "31:3730" : "31:3730 (31:3730 Qui Tam False Claims Act)",
      "31:3731" : "31:3731 (31:3731 Fraud)",
      "33:1319cw" : "33:1319cw (33:1319 Clean Water Act)",
      "33:1319pv" : "33:1319pv (33:1319 Pollutants & Permit Violations)",
      "33:1365" : "33:1365 (33:1365 Environmental Matters)",
      "35:0145" : "35:0145 (35:145 Patent Infringement)",
      "35:0183" : "35:0183 (35:183 Patent Infringement)",
      "35:0271" : "35:0271 (35:271 Patent Infringement)",
      "375/1" : "375/1 (375/1 (False Claims Act - U.S. Plaintiff))",
      "38:1681" : "38:1681 (38:1681 Recovery of VA Overpayment)",
      "38:1686" : "38:1686 (38:1686 Recovery of VA Overpayment)",
      "38:1780" : "38:1780 (38:1780 Recovery of VA Overpayment)",
      "38:2011" : "38:2011 (38:2011 - Veteran's Readjustment Assistance Act of)",
      "38:2021" : "38:2021 (Right to re-employment of inducted persons)",
      "38:3116" : "38:3116 (38:3116 VA Overpayment)",
      "38:775" : "38:775 (Recovery of Servicemen's Group Life Insurance)",
      "39:3005" : "39:3005 (39:3005 Detention of Mail for Temporary Periods)",
      "39:409" : "39:409 (39:409 Postal Service)",
      "40:0258" : "40:0258 (40:258(a) Public Buildings & Property: Land Condem)",
      "40:0270" : "40:0270 (40:270 Miller Act)",
      "40:0875" : "40:0875 (40:875 Public Buildings & Property: Negligence)",
      "40:3131" : "40:3131 (40:3131 Miller Act)",
      "41:0251" : "41:0251 (41:251 Public Contracts-Review of Agency Action)",
      "41:1463" : "41:1463 (41:1463 Public Contracts: Unlawful Employment Prac)",
      "42:0205" : "42:0205 (42:205 Denial Social Security Benefits)",
      "42:0206" : "42:0206 (42:206 Social Security Benefits)",
      "42:0247" : "42:0247 (42:247 Personal Injury-Swine Flu)",
      "42:0402" : "42:0402 (42:402 Social Security Benefits)",
      "42:0405id" : "42:0405id (42:405 Review of HHS Decision (SSID))",
      "42:0405wc" : "42:0405wc (42:405 Review of HHS Decision (DIWC))",
      "42:0405ww" : "42:0405ww (42:405 Review of HHS Decision (DIWW))",
      "42:0416" : "42:0416 (42:416 Denial of Social Security Benefits)",
      "42:0427" : "42:0427 (42:427 Social Security Benefits)",
      "42:12101" : "42:12101 (42:12101 Americans with Disabilities Act)",
      "42:1383" : "42:1383 (42:1383 Review of HHS Decision)",
      "42:1395" : "42:1395 (42:1395 HHS: Adverse Reimbursement Review)",
      "42:1396" : "42:1396 (42:1396 - Tort Negligence)",
      "42:1471" : "42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclo)",
      "42:1981cv" : "42:1981cv (42:1981 Civil Rights)",
      "42:1981hs" : "42:1981hs (42:1981 Housing Discrimination)",
      "42:1981jb" : "42:1981jb (42:1981 Job Discrimination (Race))",
      "42:1981sx" : "42:1981sx (42:1981 Sex Discrimination)",
      "42:1983cv" : "42:1983cv (42:1983 Civil Rights Act)",
      "42:1983ed" : "42:1983ed (42:1983 Civil Rights (Employment Discrimination))",
      "42:1983pr" : "42:1983pr (42:1983 Prisoner Civil Rights)",
      "42:1986" : "42:1986 (42:1986 Neglect of Duty)",
      "42:2000ag" : "42:2000ag (42:2000 Job Discrimination (Age))",
      "42:2000e" : "42:2000e (42:2000e Job Discrimination (Employment))",
      "42:2000pb" : "42:2000pb (42:2000 Job Discrimination (Public Accomodations))",
      "42:2000ra" : "42:2000ra (42:2000 Job Discrimination (Race))",
      "42:2000sx" : "42:2000sx (42:2000 Job Discrimination (Sex))",
      "42:2003" : "42:2003 (42:2003 Job Discrimination)",
      "42:2005" : "42:2005 (42:2005 Review of Agency Action-HHS)",
      "42:2615" : "42:2615 (42:2616 Medical Recovery Act)",
      "42:2651" : "42:2651 (42:2651 Medical Care Recovery)",
      "42:3601" : "42:3601 (42:405 Fair Housing Act)",
      "42:4000" : "42:4000 (42:4000 National Flood Insurance Act)",
      "42:4001" : "42:4001 (42:4001 National Insurance Flood Act)",
      "42:4053" : "42:4053 (42:4053 Breach of Insurance Contract)",
      "42:4072" : "42:4072 (42:4072 Payment of Flood Insurance Claim)",
      "42:4321" : "42:4321 (42:4321 Review of Agency Action-Environment)",
      "42:4332" : "42:4332 (42:4332 Environmental Policy - Coop of Agency Repo)",
      "42:6901en" : "42:6901en (42:6901 Environmental Cleanup Expenses)",
      "42:6901rs" : "42:6901rs (42:6901 Resource & Recovery Act)",
      "42:7413" : "42:7413 (42:7413(b) Clean Air Act)",
      "42:7604cl" : "42:7604cl (42:7604 Clear Air Act (Emission Standards))",
      "42:7604ir" : "42:7604ir (42:7604 Petition to Quash IRS Summons)",
      "42:9607" : "42:9607 (42:9607 Real Property Tort to Land)",
      "42:9613" : "42:9613 (42:9613 CERCLA)",
      "43:945" : "43:945 (43:945 Compensation for Land Condemnation)",
      "43:945a" : "43:945a (43:945a Complaint in Condemnation)",
      "43:946" : "43:946 (43:946 Complaint in Condemnation - Eminent Domain)",
      "45:0051" : "45:0051 (45:51 Railways: Fed. Employer's Liability Act)",
      "45:0151" : "45:0151 (45:151 Railway Labor Act)",
      "45:0184" : "45:0184 (45:184 Action to Set Aside Award of a System Board)",
      "45:1395" : "45:1395 (45:1395 Railroads: Adverse Reimbursement Review)",
      "45:7457" : "45:7457 (45:7457 Compel Reclamation Under Clear Air Act)",
      "46:0185" : "46:0185 (46:0185 PETITION FOR LIMITATION LIABILITY)",
      "46:0688" : "46:0688 (46:688 Jones Act)",
      "46:0740" : "46:0740 (46:0740 DAMAGE OR INJURY CAUSED BY VESSEL)",
      "46:0741" : "46:0741 (46:741 Shipping)",
      "46:0761" : "46:0761 (46:761 Shipping: Damages for Death on High Seas)",
      "46:1101" : "46:1101 (46:1101 Violation of Maritime Regulations)",
      "46:1156" : "46:1156 (46:1156 Administrative Procedure Act)",
      "47:227" : "47:227 (47:227 FCC-Unsolicited Telephone Sales)",
      "47:227(b)" : "47:227(b) (47:227(b)(3) Telephone Consumer Protection Act of 1991)",
      "47:251" : "47:251 (47:251 Telecommunications Act of 1996 - Interconnection)",
      "48:0883" : "48:0883 (48:883 Violation of US Coastal Law)",
      "48:1985" : "48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)",
      "49:0081" : "49:0081 (49:81 Damaged Goods While Being Transported)",
      "49:0781" : "49:0781 (49:781 Forfeiture)",
      "49:11503" : "49:11503 (49:11503 Railroad Revitalization Regulatory Reform)",
      "49:11702" : "49:11702 (49:11702(a)(4) Violations of Interstate Commerce A)",
      "49:1471" : "49:1471 (49:1471 Federal Aviation Act)",
      "49:1903" : "49:1903 (49:1903 Petition to enforce administrative summon)",
      "8:287" : "8:287 (8:287 Petition to Enforce INS Subpoena)",
      "99:9999" : "99:9999 (99:9999 Report cause code (DO NOT DELETE!))",
      "adsup" : "adsup (Administrative Subpoena)",
      "attydisc" : "attydisc (Attorney Discipline)",
      "contempt" : "contempt (Contempt Proceedings)",
      "disbar" : "disbar (Disbarment Proceedings)",
      "fordepo" : "fordepo (Foreign Deposition)",
      "misc" : "misc (Civil Miscellaneous Case)",
      "motcomp" : "motcomp (Motion to Compel)",
      "motquash" : "motquash (Motion to Quash)",
      "motret" : "motret (Motion for Return of Property)",
      "petenf" : "petenf (Petition to Enforce IRS Summons)",
      "petper" : "petper (Petition to Perpetuate Testimony)",
      "regjgm" : "regjgm (Registration of Foreign Judgment)",
      "tranbkref" : "tranbkref (Transmission of Bankruptcy Reference)",
      "tranff" : "tranff (Transmission of Proposed Findings of Fact and Concl. of Law)",
      "writgar" : "writgar (Application for a Writ of Garnishment)"
   },
   "nmdce" : {
      "0" : "0 (No cause code entered)",
      "00:0000" : "00:0000 (00:0000 Cause Code Unknown)",
      "02:0431" : "02:0431 (02:431 Fed. Election Commission: Failure Enforce Compliance)",
      "02:0437" : "02:0437 (02:437 Federal Election Commission)",
      "05:0075" : "05:0075 (05:75(2) Contract - Reduction in Grade)",
      "05:0551" : "05:0551 (05:551 Administrative Procedure Act)",
      "05:0552fi" : "05:0552fi (05:552 Freedom of Information Act)",
      "05:0552pa" : "05:0552pa (05:552 Right to Privacy Act)",
      "05:0554" : "05:0554 (05:0554 Constitutionality of Maritime Statutes)",
      "05:0701" : "05:0701 (05:0701 Maritime Subsidy Board)",
      "05:0702" : "05:0702 (05:702 Administrative Procedure Act)",
      "05:0704" : "05:0704 (05:704 Labor Litigation)",
      "05:7703" : "05:7703 (05:7703 Discrimination - Review of Agency Act)",
      "07:0006" : "07:0006 (7:6(b) Federal Commodity Exchange Regulation)",
      "07:0025" : "07:0025 (7:25 Fraud - Commodities Leverage Contracts)",
      "07:0181" : "07:0181 (07:181 Packers & Stockyard Act)",
      "07:0499" : "07:0499 (07:499 Agricultural Commodities Act)",
      "07:0601" : "07:0601 (07:601 USDA Condemnation)",
      "07:2321" : "07:2321 (07:2321 Plant Variety Protection Act)",
      "08:1105" : "08:1105 (8:1105(a) Aliens: Habeas Corpus to Release INS Detainee)",
      "08:1252" : "08:1252 (08:1252(a)(2) Injunction for Deportation)",
      "08:1260" : "08:1260 (08:1260 Aliens: Access to Records)",
      "08:1324" : "08:1324 (08:1324 Aliens: Complaint for Forfeiture)",
      "08:1329" : "08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petition)",
      "08:1446" : "08:1446 (8:1446 Petition for Naturalization Hearing)",
      "09:0001" : "09:0001 (09:1 U.S. Arbitration Act)",
      "09:0009" : "09:0009 (9:9 Motion to Confirm Arbitration Loan)",
      "09:0010" : "09:0010 (09:0010 Petition to Vacate Arbitration Award)",
      "10:1552" : "10:1552 (10:1552 Armed Forces: Action to Correct Records)",
      "10:1553" : "10:1553 (10:1553 Armed Forces: FOIA General)",
      "10:2305" : "10:2305 (10:2305 Review of Federal Contract)",
      "11:0101" : "11:0101 (11:101 Bankruptcy)",
      "12:0022" : "12:0022 (12:22 Securities Fraud)",
      "12:0635" : "12:0635 (12:635 Breach of Insurance Contract)",
      "12:1461" : "12:1461 (12:1461 Homeowners Loan Act)",
      "12:1703" : "12:1703 (12:1703 Default of HUD Loan)",
      "12:1725" : "12:1725 (12:1725 Collection under Contract Guaranty)",
      "12:1730" : "12:1730 (12:1730 Collection Under Contract Guaranty)",
      "12:1819" : "12:1819 (12:1819 Default of Promissory Note)",
      "12:1821" : "12:1821 (12:1821 Default of Loan by Promissary Note)",
      "12:1971" : "12:1971 (12:1971 Relief under Bank Holding Act)",
      "12:3410" : "12:3410 (12:3410 Right to Financial Privacy Act)",
      "15:0001" : "15:0001 (15:1 Antitrust Litigation)",
      "15:0002at" : "15:0002at (15:2 Antitrust Litigation)",
      "15:0002fl" : "15:0002fl (15:2(a) Fair Labor Standards Act)",
      "15:0005" : "15:0005 (15:5(a) Fair Labor Standards Act)",
      "15:0015" : "15:0015 (15:15 Antitrust Litigation)",
      "15:0025" : "15:0025 (15:25 Clayton Act)",
      "15:0044" : "15:0044 (15:44 Trademark Infringement)",
      "15:0045" : "15:0045 (15:0045 Federal Trade Commission Act)",
      "15:0052" : "15:0052 (15:0052 Federal Trade Commission Act)",
      "15:0053" : "15:0053 (15:0053 Federal Trade Commission Act)",
      "15:0077" : "15:0077 (15:77 Securities Fraud)",
      "15:0078" : "15:0078 (15:78m(a) Securities Exchange Act)",
      "15:0631" : "15:0631 (15:631 Small Business Act)",
      "15:0717" : "15:0717 (15:717 Natural Gas Act)",
      "15:1051" : "15:1051 (15:1051 Trademark Infringement)",
      "15:1114" : "15:1114 (15:1114 Trademark Infringement)",
      "15:1121" : "15:1121 (15:1121 Trademark Infringement)",
      "15:1125" : "15:1125 (15:1125 Trademark Infringement (Lanham Act))",
      "15:1126" : "15:1126 (15:1126 Patent Infringement)",
      "15:1127" : "15:1127 (15:1127 Trademark Infringement)",
      "15:1601" : "15:1601 (15:1601 Truth in Lending)",
      "15:1640" : "15:1640 (15:1640 Truth in Lending)",
      "15:1681" : "15:1681 (15:1681 Fair Credit Reporting Act)",
      "15:1692" : "15:1692 (15:1692 Fair Debt Collection Act)",
      "15:1938" : "15:1938 (15:1938 Fair Labor Standards Act)",
      "15:1981" : "15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))",
      "15:1988" : "15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))",
      "15:1989" : "15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))",
      "15:2301" : "15:2301 (15:2301 Magnuson-Moss Warranty Act)",
      "15:2801" : "15:2801 (15:2801 Petroleum Marketing Practices Act)",
      "15:53(b)" : "15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equitable Relief)",
      "16:0668" : "16:0668 (16:668 Bald Eagle Protection Act)",
      "16:0703" : "16:0703 (16:703 Migratory Bird Act)",
      "16:1538" : "16:1538 (16:1538 Endangered Species Act)",
      "16:3371" : "16:3371 (16:3371 Wildlife Under the Lacey Act)",
      "16:3372" : "16:3372 (16:3372 Conservation: Complaint for Forfeiture)",
      "16:3373" : "16:3373 (16:3373 Appeal of Decision - DOI)",
      "16:3374" : "16:3374 (16:3374 Conservation: Complaint for Forfeiture)",
      "17:0101" : "17:0101 (17:101 Copyright Infringement)",
      "17:0501" : "17:0501 (17:501 Copyright Infringement)",
      "17:0504" : "17:0504 (17:504 Copyright Infringement)",
      "18:0241" : "18:0241 (18:241 Conspiracy Against Citizen Rights)",
      "18:1836a" : "18:1836a (18:1836(a) Injunction against Misappropriation of Trade Secrets)",
      "18:1836b" : "18:1836b (18:1836(b) Civil Action to Protect Trade Secrets)",
      "18:1961" : "18:1961 (18:1961 Racketeering (RICO) Act)",
      "18:1962" : "18:1962 (18:1962 Racketeering (RICO) Act)",
      "18:1964" : "18:1964 (18:1964 Racketeering (RICO) Act)",
      "18:4208" : "18:4208 (18:4208(B) Agency Action Review)",
      "19:1305" : "19:1305 (19:1305 Custom Duties:0Forfeiture-Immoral Articles)",
      "20:1080" : "20:1080 (20:1080 Student Loan Recovery)",
      "20:1400" : "20:1400 (20:1400 Civil Rights of Handicapped Child)",
      "20:1401" : "20:1401 (20:1401 Education: Handicapped Child Act)",
      "21:0841" : "21:0841 (21:841 Forfeiture Property-Drugs)",
      "21:0881" : "21:0881 (21:881 Forfeiture Property-Drugs)",
      "21:0881a" : "21:0881a (21:881 Forfeiture Property - Aircraft)",
      "21:0881re" : "21:0881re (21:881 Forfeiture Property - Real Estate)",
      "23:0134" : "23:0134 (23:134 P.I.- Auto Negligence)",
      "23:1441" : "23:1441 (23:1441 Contract Real Estate)",
      "24:1000" : "24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)",
      "25:0640" : "25:0640 (25:640 Indian Tribal Rights)",
      "25:1901" : "25:1901 (25:1901 Indian Child Welfare Act)",
      "26:6212" : "26:6212 (26:6212 Injunctive Relief from IRS Lien)",
      "26:6213" : "26:6213 (26:6213 Injunctive Relief from IRS Lien)",
      "26:6502" : "26:6502 (26:6502 IRS:Enforcement of tax liens)",
      "26:6532" : "26:6532 (26:6532 IRS: Refund of Tax Penalty)",
      "26:6702" : "26:6702 (26:6702 IRS: Refund of Income Tax Penalty)",
      "26:6703" : "26:6703 (26:6703 IRS: Refund of Tax Penalty)",
      "26:7401" : "26:7401 (26:7401 IRS: Tax Liability)",
      "26:7402" : "26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)",
      "26:7403" : "26:7403 (26:7403 Suit to Enforce Federal Tax Lien)",
      "26:7422rt" : "26:7422rt (26:7422 IRS: Refund Taxes)",
      "26:7422rx" : "26:7422rx (26:7422 IRS: Refund Excise Tax)",
      "26:7426" : "26:7426 (26:7426 IRS: Wrongful Levy for Taxes)",
      "26:7429" : "26:7429 (26:7429 IRS: Tax Jeopardy Assessment)",
      "26:7609" : "26:7609 (26:7609 IRS: Petition to Quash IRS Summons)",
      "27:0185" : "27:0185 (27:185 Enforcement of Arbitration Award)",
      "28:0157c" : "28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)",
      "28:0157d" : "28:0157d (28:0157 Motion for Withdrawal of Reference)",
      "28:0158" : "28:0158 (28:0158 Notice of Appeal re Bankruptcy Matter (BAP))",
      "28:0185" : "28:0185 (28:185 Suit to Compel Arbitration)",
      "28:0451" : "28:0451 (28:451 Employment Discrimination)",
      "28:0794" : "28:0794 (28:794 Rehabilitation Act)",
      "28:1001" : "28:1001 (28:1001 E.R.I.S.A.)",
      "28:1132" : "28:1132 (28:1132 E.R.I.S.A.)",
      "28:1330" : "28:1330 (28:1330 Breach of Contract)",
      "28:1331" : "28:1331 (28:1331 Fed. Question)",
      "28:1331al" : "28:1331al (28:1331 Fed. Question: Airline Crash)",
      "28:1331at" : "28:1331at (28:1331 Fed. Question: Anti-trust)",
      "28:1331au" : "28:1331au (28:1331 Fed. Question: Auto Negligence)",
      "28:1331b" : "28:1331b (28:1331 Federal Question: Bivens Act)",
      "28:1331bc" : "28:1331bc (28:1331 Fed. Question: Breach of Contract)",
      "28:1331ca" : "28:1331ca (28:1331 Fed Question: Fed Communications Act of 1934)",
      "28:1331cm" : "28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)",
      "28:1331cv" : "28:1331cv (28:1331 Federal Question: Other Civil Rights)",
      "28:1331ed" : "28:1331ed (28:1331 Fed. Question: Employment Discrimination)",
      "28:1331es" : "28:1331es (28:1331 Enforcement of Administrative Subpoena)",
      "28:1331fl" : "28:1331fl (28:1331 Fed. Question: Fair Labor Standards)",
      "28:1331in" : "28:1331in (28:1331 Fed. Question: Insurance Contract)",
      "28:1331mm" : "28:1331mm (28:1331 Fed. Question: Medical Malpractice)",
      "28:1331pi" : "28:1331pi (28:1331 Fed. Question: Personal Injury)",
      "28:1331rd" : "28:1331rd (28:1331 Fed. Question: Review Agency Decision)",
      "28:1331rp" : "28:1331rp (28:1331(a) Fed. Question: Real Property)",
      "28:1331rr" : "28:1331rr (28:1331 Fed. Question: Railway Labor Act)",
      "28:1331sv" : "28:1331sv (28:1331 Fed. Question: Securities Violation)",
      "28:1331tr" : "28:1331tr (28:1331 Fed. Question: Trademark)",
      "28:1331tt" : "28:1331tt (28:1331 Fed. Question: Tort Action)",
      "28:1331v" : "28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendment)",
      "28:1331wl" : "28:1331wl (28:1331 Federal Question: EPA Waste Lien)",
      "28:1331wt" : "28:1331wt (28:1331 Fed. Question: Water Rights)",
      "28:1332ac" : "28:1332ac (28:1332 Diversity-Account Receivable)",
      "28:1332al" : "28:1332al (28:1332 Diversity-Airline Crash)",
      "28:1332as" : "28:1332as (28:1332 Diversity-Asbestos Litigation)",
      "28:1332au" : "28:1332au (28:1332 Diversity-Auto Negligence)",
      "28:1332bc" : "28:1332bc (28:1332 Diversity-Breach of Contract)",
      "28:1332co" : "28:1332co (28:1332 Diversity-Conversion)",
      "28:1332ct" : "28:1332ct (28:1332 Diversity-(Citizenship))",
      "28:1332det" : "28:1332det (28:1332 Diversity: Forcible Detainer)",
      "28:1332df" : "28:1332df (28:1332 Diversity-Contract Default)",
      "28:1332ds" : "28:1332ds (28:1332 Diversity-Contract Dispute)",
      "28:1332ed" : "28:1332ed (28:1332 Diversity-Employment Discrimination)",
      "28:1332fd" : "28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)",
      "28:1332fr" : "28:1332fr (28:1332 Diversity-Fraud)",
      "28:1332ia" : "28:1332ia (28:1332 Diversity-Interpleader Action)",
      "28:1332ij" : "28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)",
      "28:1332in" : "28:1332in (28:1332 Diversity-Insurance Contract)",
      "28:1332jd" : "28:1332jd (28:1332 Diversity-Declaratory Judgement)",
      "28:1332lb" : "28:1332lb (28:1332 Diversity-Libel,Assault,Slander)",
      "28:1332lm" : "28:1332lm (28:1332 Diversity - Legal Malpractice)",
      "28:1332ma" : "28:1332ma (28:1332 Diversity-Miller Act)",
      "28:1332mm" : "28:1332mm (28:1332 Diversity-Medical Malpractice)",
      "28:1332mv" : "28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)",
      "28:1332ni" : "28:1332ni (28:1332 Diversity-Negotiable Instrument)",
      "28:1332nm" : "28:1332nm (28:1332 Diversity-Non-Motor Vehicle)",
      "28:1332oc" : "28:1332oc (28:1332 Diversity-Other Contract)",
      "28:1332pd" : "28:1332pd (28:1332 Diversity-Property Damage)",
      "28:1332pi" : "28:1332pi (28:1332 Diversity-Personal Injury)",
      "28:1332pl" : "28:1332pl (28:1332 Diversity-Product Liability)",
      "28:1332pr" : "28:1332pr (28:1332 Diversity-Petition for Removal)",
      "28:1332qt" : "28:1332qt (28:1332 Diversity-Petition to Quiet Title)",
      "28:1332ri" : "28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)",
      "28:1332sa" : "28:1332sa (28:1332 - Diversity: Securities & Exchange Commission Act)",
      "28:1332sf" : "28:1332sf (28:1332 - Diversity: Securities Fraud)",
      "28:1332ss" : "28:1332ss (28:1332 Diversity - Stockholders Suits)",
      "28:1332tl" : "28:1332tl (28:1332 Diversity-Torts to Land)",
      "28:1332tm" : "28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))",
      "28:1332tn" : "28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)",
      "28:1332wd" : "28:1332wd (28:1332 Diversity-Wrongful Death)",
      "28:1333" : "28:1333 (28:1333 Admiralty)",
      "28:1334" : "28:1334 (28:1334 Bankruptcy Appeal)",
      "28:1334c" : "28:1334c (28:1334(c) R&R re motions for abstention (non-core))",
      "28:1335" : "28:1335 (28:1335 Interpleader Action)",
      "28:1337" : "28:1337 (28:1337 Sherman-Clayton Act)",
      "28:1338cp" : "28:1338cp (28:1338 Copyright Infringement)",
      "28:1338pt" : "28:1338pt (28:1338 Patent Infringement)",
      "28:1338tr" : "28:1338tr (28:1338 Trademark Infringement)",
      "28:1340" : "28:1340 (28:1340 IRS: Custom Duties)",
      "28:1340er" : "28:1340er (28:1340 Recovery of Erroneous Refund)",
      "28:1341" : "28:1341 (28:1341 Complaint for Forfeiture)",
      "28:1343" : "28:1343 (28:1343 Violation of Civil Rights)",
      "28:1345co" : "28:1345co (28:1345 Replevin & Conversion)",
      "28:1345db" : "28:1345db (28:1345 Debt to US - FHA/HUD Title I)",
      "28:1345df" : "28:1345df (28:1345 Default of Promissory Note)",
      "28:1345er" : "28:1345er (28:1345 Recovery of Erroneous Refund)",
      "28:1345fc" : "28:1345fc (28:1345 Foreclosure)",
      "28:1345ff" : "28:1345ff (28:1345 Complaint for Forfeiture)",
      "28:1345hl" : "28:1345hl (28:1345 VA Home Loan Guaranty Debt)",
      "28:1345mc" : "28:1345mc (28:1345 Medical Care Recovery)",
      "28:1345mi" : "28:1345mi (28:1345 Mining Claim Ejectment)",
      "28:1345pd" : "28:1345pd (28:1345 Property Damage)",
      "28:1345pe" : "28:1345pe (28:1345 Property Ejectment)",
      "28:1345rc" : "28:1345rc (28:1345 Recovery of Debt to US)",
      "28:1345st" : "28:1345st (28:1345 Default of Student Loan)",
      "28:1345tp" : "28:1345tp (28:1345 Trespass on Public Land)",
      "28:1345va" : "28:1345va (28:1345 Recovery of VA Overpayment)",
      "28:1346bc" : "28:1346bc (28:1346 Breach of Contract)",
      "28:1346rc" : "28:1346rc (28:1346 Recovery of IRS Tax)",
      "28:1346tc" : "28:1346tc (28:1346 Tort Claim)",
      "28:1346wd" : "28:1346wd (28:1346 Wrongful Death)",
      "28:1350" : "28:1350 (28:1350 Alien's Action for Tort)",
      "28:1352" : "28:1352 (28:1352 Miller Act)",
      "28:1355" : "28:1355 (28:1355 Petition for Return of Property)",
      "28:1358" : "28:1358 (28:1358 Land Condemnation)",
      "28:1361" : "28:1361 (28:1361 Petition for Writ of Mandamus)",
      "28:1362ic" : "28:1362ic (28:1362 Indian Tribal Controversy)",
      "28:1362iw" : "28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)",
      "28:1364" : "28:1364 (28:1364 Auto Negligence)",
      "28:1391" : "28:1391 (28:1391 Personal Injury)",
      "28:1402" : "28:1402 (28:1402 Medical Malpractice)",
      "28:1407" : "28:1407 (28:1407 Airline Crash)",
      "28:1441ac" : "28:1441ac (28:1441 Petition for Removal- Account Receivable)",
      "28:1441al" : "28:1441al (28:1441 Petition for Removal- Airline Crash)",
      "28:1441as" : "28:1441as (28:1441 Petition for Removal- Asbestos Litigation)",
      "28:1441au" : "28:1441au (28:1441 Petition for Removal- Auto Negligence)",
      "28:1441bc" : "28:1441bc (28:1441 Petition for Removal- Breach of Contract)",
      "28:1441cv" : "28:1441cv (28:1441 Petition for Removal- Civil Rights Act)",
      "28:1441df" : "28:1441df (28:1441 Petition for Removal- Contract Default)",
      "28:1441dj" : "28:1441dj (28:1441 Petition for Removal- Declaratory Judgment)",
      "28:1441ds" : "28:1441ds (28:1441 Petition for Removal- Contract Dispute)",
      "28:1441ed" : "28:1441ed (28:1441 Petition for Removal - Employment Discrimination)",
      "28:1441fc" : "28:1441fc (28:1441 Petition for Removal - Fair Credit Reporting Act)",
      "28:1441fr" : "28:1441fr (28:1441 Petition for Removal- Fraud)",
      "28:1441ij" : "28:1441ij (28:1441 Petition for Removal- Injunctive/Declaratory Relief)",
      "28:1441in" : "28:1441in (28:1441 Petition for Removal- Insurance Contract)",
      "28:1441int" : "28:1441int (28:1441 Petition for Removal- Action for Interpleader)",
      "28:1441lb" : "28:1441lb (28:1441 Petition for Removal Libel,Assault,Slander)",
      "28:1441lm" : "28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relations)",
      "28:1441mm" : "28:1441mm (28:1441 Petition for Removal- Medical Malpractice)",
      "28:1441ni" : "28:1441ni (28:1441 Petition for Removal- Negotiable Instrument)",
      "28:1441nm" : "28:1441nm (28:1441 Petition for Removal- Non-Motor Vehicle)",
      "28:1441oc" : "28:1441oc (28:1441 Petition For Removal--Other Contract)",
      "28:1441pd" : "28:1441pd (28:1441 Petition for Removal- Property Damage)",
      "28:1441pi" : "28:1441pi (28:1441 Petition for Removal- Personal Injury)",
      "28:1441pl" : "28:1441pl (28:1441 Petition for Removal- Product Liability)",
      "28:1441pr" : "28:1441pr (28:1441 Petition for Removal)",
      "28:1441qt" : "28:1441qt (28:1441 Petition for Removal- Petition to Quiet Title)",
      "28:1441ri" : "28:1441ri (28:1441 Petition for Removal- Racketeering (RICO) Act)",
      "28:1441sa" : "28:1441sa (28:1441 - Petition for Removal: SEC Act)",
      "28:1441sf" : "28:1441sf (28:1441 - Petition for Removal: Securities Fraud)",
      "28:1441tl" : "28:1441tl (28:1441 Petition for Removal- Torts to Land)",
      "28:1441tm" : "28:1441tm (28:1441 Petition for Removal- Tort/Motor Vehicle (P.I.))",
      "28:1441tn" : "28:1441tn (28:1441 Petition for Removal- Tort/Non-Motor Vehicle)",
      "28:1441wd" : "28:1441wd (28:1441 Petition for Removal- Wrongful Death)",
      "28:1442bc" : "28:1442bc (28:1442 Petition for Removal- Breach of Contract)",
      "28:1442pr" : "28:1442pr (28:1442 Petition for Removal)",
      "28:1443" : "28:1443 (28:1443(1) Rent, Lease & Ejectment)",
      "28:1444" : "28:1444 (28:1444 Petition for Removal- Foreclosure)",
      "28:1446in" : "28:1446in (28:1446 Breach of Contract- Insurance)",
      "28:1446pd" : "28:1446pd (28:1446 Petition for Removal- Property Damage (P.I.))",
      "28:1446pi" : "28:1446pi (28:1446 Petition for Removal- Personal Injury)",
      "28:1446pl" : "28:1446pl (28:1446pl Petition for Removal - Product Liability)",
      "28:1446pr" : "28:1446pr (28:1446 Petition for Removal)",
      "28:1452" : "28:1452 (28:1452 R&R re motions to remand (non-core))",
      "28:1651" : "28:1651 (28:1651 Petition for Writ of Coram Nobis)",
      "28:1651hc" : "28:1651hc (28:1651 Petition for Writ of Habeas Corpus)",
      "28:1651mn" : "28:1651mn (28:1651 Petition for Writ of Mandamus)",
      "28:1983" : "28:1983 (28:1983 Civil Rights)",
      "28:2201" : "28:2201 (28:2201 Constitutionality of State Statute(s))",
      "28:2201dj" : "28:2201dj (28:2201 Declaratory Judgment)",
      "28:2201ij" : "28:2201ij (28:2201 Injunction)",
      "28:2201in" : "28:2201in (28:2201 Declaratory Judgment (Insurance))",
      "28:2241" : "28:2241 (28:2241 Petition for Writ of Habeas Corpus (federal))",
      "28:2254" : "28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))",
      "28:2254se" : "28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)",
      "28:2255" : "28:2255 (28:2255 Motion to Vacate / Correct Illegal Sentence)",
      "28:2271" : "28:2271 (28:2271 Federal Tort Claims Act)",
      "28:2345" : "28:2345 (28:2345 Medicare Recovery)",
      "28:2409" : "28:2409 (28:2409(a) Quiet Title Action)",
      "28:2410" : "28:2410 (28:2410 Quiet Title)",
      "28:2671" : "28:2671 (28:2671 Federal Tort Claims Act)",
      "28:2674" : "28:2674 (28:2674 Federal Tort Claims Act)",
      "28:7402" : "28:7402 (28:7402 Refund of Taxes)",
      "28:7422" : "28:7422 (28:7422 Appeal from Administrative Decision)",
      "29:0151" : "29:0151 (29:151 Labor: Review of Agency Action)",
      "29:0160" : "29:0160 (29:160(1) National Labor Relations Act)",
      "29:0184" : "29:0184 (29:184 Violation Collection Bargain Agreement)",
      "29:0185ep" : "29:0185ep (29:185 Employee Pension Plan)",
      "29:0185lm" : "29:0185lm (29:185 Labor/Mgt. Relations (Contracts))",
      "29:0201do" : "29:0201do (29:201 Denial of Overtime Compensation)",
      "29:0201fl" : "29:0201fl (29:201 Fair Labor Standards Act)",
      "29:0203" : "29:0203 (29:203 Equal Pay Act)",
      "29:0206" : "29:0206 (29:206 Collect Unpaid Wages)",
      "29:0401" : "29:0401 (29:0401 Labor Management Disclosure Act)",
      "29:0621" : "29:0621 (29:621 Job Discrimination (Age))",
      "29:0623" : "29:0623 (29:623 Job Discrimination (Age))",
      "29:0626" : "29:0626 (29:626 Job Discrimination (Age))",
      "29:0633" : "29:0633 (29:633 Job Discrimination (Age))",
      "29:0651" : "29:0651 (29:651 Occupational Safety/Health)",
      "29:0754" : "29:0754 (29:754 Discrimination)",
      "29:0791" : "29:0791 (29:791 Job Discrimination (Rehabilitation Act))",
      "29:0794" : "29:0794 (29:0794 Job Discrimination (Handicap))",
      "29:1001" : "29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)",
      "29:1002" : "29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)",
      "29:1104" : "29:1104 (29:1104 Recovery of Benefits to Employee)",
      "29:1109" : "29:1109 (29:1109 Breach of Fiduciary Duties)",
      "29:1131" : "29:1131 (29:1131 ERISA - Collection of Delinquent Trust Funds)",
      "29:1132" : "29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)",
      "29:1145" : "29:1145 (29:1145 E.R.I.S.A.)",
      "29:1149" : "29:1149 (29:1149 Recover Pension & Profit Sharing)",
      "29:1337" : "29:1337 (29:1337 E.R.I.S.A.)",
      "29:1362" : "29:1362 (29:1362 ERISA)",
      "29:1381" : "29:1381 (29:1381 E.R.I.S.A.)",
      "29:1401" : "29:1401 (29:1401(b)(2) Appeal of Arbitration Award)",
      "29:1451" : "29:1451 (29:1451 E.R.I.S.A.)",
      "29:1801" : "29:1801 (29:1801 Farmworker Rights)",
      "29:790" : "29:790 (29:790 Rehabilitation of Labor)",
      "30:0181" : "30:0181 (30:181 Environment: Review of Agency Action)",
      "30:0801" : "30:0801 (30:0801 Penalities/Federal Mine Safety Health Act - 1977)",
      "30:1201" : "30:1201 (30:1201 Environment: Review of Agency Action)",
      "30:1202" : "30:1202 (30:1202 Mining Reclamation Act)",
      "30:1276" : "30:1276 (30:1276 Interior: Review of Agency Action)",
      "31:3545" : "31:3545 (31:3545 Action to Recovery Money)",
      "31:3729" : "31:3729 (31:3729 False Claims Act)",
      "31:3730" : "31:3730 (31:3730 Qui Tam False Claims Act)",
      "31:3731" : "31:3731 (31:3731 Fraud)",
      "33:1319cw" : "33:1319cw (33:1319 Clean Water Act)",
      "33:1319pv" : "33:1319pv (33:1319 Pollutants & Permit Violations)",
      "33:1365" : "33:1365 (33:1365 Environmental Matters)",
      "35:0145" : "35:0145 (35:145 Patent Infringement)",
      "35:0183" : "35:0183 (35:183 Patent Infringement)",
      "35:0271" : "35:0271 (35:271 Patent Infringement)",
      "38:1681" : "38:1681 (38:1681 Recovery of VA Overpayment)",
      "38:1686" : "38:1686 (38:1686 Recovery of VA Overpayment)",
      "38:1780" : "38:1780 (38:1780 Recovery of VA Overpayment)",
      "38:2011" : "38:2011 (38:2011 - Veteran's Readjustment Assistance Act of 1974)",
      "38:3116" : "38:3116 (38:3116 VA Overpayment)",
      "39:3005" : "39:3005 (39:3005 Detention of Mail for Temporary Periods)",
      "39:409" : "39:409 (39:409 Postal Service)",
      "40:0258" : "40:0258 (40:258(a) Public Buildings & Property: Land Condemnation)",
      "40:0270" : "40:0270 (40:270 Miller Act)",
      "40:0875" : "40:0875 (40:875 Public Buildings & Property: Negligence)",
      "41:0251" : "41:0251 (41:251 Public Contracts-Review of Agency Action)",
      "41:1463" : "41:1463 (41:1463 Public Contracts: Unlawful Employment Practices)",
      "42:0205" : "42:0205 (42:205 Denial Social Security Benefits)",
      "42:0206" : "42:0206 (42:206 Social Security Benefits)",
      "42:0247" : "42:0247 (42:247 Personal Injury-Swine Flu)",
      "42:0402" : "42:0402 (42:402 Social Security Benefits)",
      "42:0405id" : "42:0405id (42:405 Review of HHS Decision (SSID))",
      "42:0405wc" : "42:0405wc (42:405 Review of HHS Decision (DIWC))",
      "42:0405ww" : "42:0405ww (42:405 Review of HHS Decision (DIWW))",
      "42:0416" : "42:0416 (42:416 Denial of Social Security Benefits)",
      "42:0427" : "42:0427 (42:427 Social Security Benefits)",
      "42:1383" : "42:1383 (42:1383 Review of HHS Decision)",
      "42:1395" : "42:1395 (42:1395 HHS: Adverse Reimbursement Review)",
      "42:1396" : "42:1396 (42:1396 - Tort Negligence)",
      "42:1471" : "42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclosure Sale)",
      "42:1981cv" : "42:1981cv (42:1981 Civil Rights)",
      "42:1981hs" : "42:1981hs (42:1981 Housing Discrimination)",
      "42:1981jb" : "42:1981jb (42:1981 Job Discrimination (Race))",
      "42:1981sx" : "42:1981sx (42:1981 Sex Discrimination)",
      "42:1983cv" : "42:1983cv (42:1983 Civil Rights Act)",
      "42:1983ed" : "42:1983ed (42:1983 Civil Rights (Employment Discrimination))",
      "42:1983pr" : "42:1983pr (42:1983 Prisoner Civil Rights)",
      "42:1986" : "42:1986 (42:1986 Neglect of Duty)",
      "42:2000ag" : "42:2000ag (42:2000 Job Discrimination (Age))",
      "42:2000e" : "42:2000e (42:2000e Job Discrimination (Employment))",
      "42:2000pb" : "42:2000pb (42:2000 Job Discrimination (Public Accomodations))",
      "42:2000ra" : "42:2000ra (42:2000 Job Discrimination (Race))",
      "42:2000sx" : "42:2000sx (42:2000 Job Discrimination (Sex))",
      "42:2003" : "42:2003 (42:2003 Job Discrimination)",
      "42:2005" : "42:2005 (42:2005 Review of Agency Action-HHS)",
      "42:2651" : "42:2651 (42:2651 Medical Care Recovery)",
      "42:3601" : "42:3601 (42:405 Fair Housing Act)",
      "42:4000" : "42:4000 (42:4000 National Flood Insurance Act)",
      "42:4001" : "42:4001 (42:4001 National Insurance Flood Act)",
      "42:4053" : "42:4053 (42:4053 Breach of Insurance Contract)",
      "42:4072" : "42:4072 (42:4072 Payment of Flood Insurance Claim)",
      "42:425" : "42:425 (42:427 Social Security Benenfits)",
      "42:4321" : "42:4321 (42:4321 Review of Agency Action-Environment)",
      "42:4332" : "42:4332 (42:4332 Environmental Policy - Coop of Agency Reports)",
      "42:6901en" : "42:6901en (42:6901 Environmental Cleanup Expenses)",
      "42:6901rs" : "42:6901rs (42:6901 Resource & Recovery Act)",
      "42:7413" : "42:7413 (42:7413(b) Clean Air Act)",
      "42:7604cl" : "42:7604cl (42:7604 Clear Air Act (Emission Standards))",
      "42:7604ir" : "42:7604ir (42:7604 Petition to Quash IRS Summons)",
      "42:9607" : "42:9607 (42:9607 Real Property Tort to Land)",
      "43:945" : "43:945 (43:945 Compensation for Land Condemnation)",
      "43:945a" : "43:945a (43:945a Complaint in Condemnation)",
      "43:946" : "43:946 (43:946 Complaint in Condemnation - Eminent Domain)",
      "45:0051" : "45:0051 (45:51 Railways: Fed. Employer's Liability Act)",
      "45:0151" : "45:0151 (45:151 Railway Labor Act)",
      "45:0184" : "45:0184 (45:184 Action to Set Aside Award of a System Board of Adjust)",
      "45:1395" : "45:1395 (45:1395 Railroads: Adverse Reimbursement Review)",
      "45:7457" : "45:7457 (45:7457 Compel Reclamation Under Clear Air Act)",
      "46:0688" : "46:0688 (46:688 Jones Act)",
      "46:0741" : "46:0741 (46:741 Shipping)",
      "46:0761" : "46:0761 (46:761 Shipping: Damages for Death on High Seas)",
      "46:1101" : "46:1101 (46:1101 Violation of Maritime Regulations)",
      "46:1156" : "46:1156 (46:1156 Administrative Procedure Act)",
      "48:0883" : "48:0883 (48:883 Violation of US Coastal Law)",
      "48:1985" : "48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)",
      "49:0081" : "49:0081 (49:81 Damaged Goods While Being Transported)",
      "49:0781" : "49:0781 (49:781 Forfeiture)",
      "49:11503" : "49:11503 (49:11503 Railroad Revitalization Regulatory Reform Act)",
      "49:11702" : "49:11702 (49:11702(a)(4) Violations of Interstate Commerce Act)",
      "49:1471" : "49:1471 (49:1471 Federal Aviation Act)",
      "49:1903" : "49:1903 (49:1903 Petition to enforce administrative summons)",
      "8:287" : "8:287 (8:287 Petition to Enforce INS Subpoena)",
      "misc" : "misc (Civil Miscellaneous Case)"
   },
   "nmidce" : {
      "0" : "0 (No cause code entered)",
      "00:0000" : "00:0000 (00:0000 Cause Code Unknown)",
      "02:0431" : "02:0431 (02:431 Fed. Election Commission: Failure Enforce Compliance)",
      "02:0437" : "02:0437 (02:437 Federal Election Commission)",
      "05:0075" : "05:0075 (05:75(2) Contract - Reduction in Grade)",
      "05:0551" : "05:0551 (05:551 Administrative Procedure Act)",
      "05:0552fi" : "05:0552fi (05:552 Freedom of Information Act)",
      "05:0552pa" : "05:0552pa (05:552 Right to Privacy Act)",
      "05:0554" : "05:0554 (05:0554 Constitutionality of Maritime Statutes)",
      "05:0701" : "05:0701 (05:0701 Maritime Subsidy Board)",
      "05:0702" : "05:0702 (05:702 Administrative Procedure Act)",
      "05:0704" : "05:0704 (05:704 Labor Litigation)",
      "05:7703" : "05:7703 (05:7703 Discrimination - Review of Agency Act)",
      "07:0006" : "07:0006 (7:6(b) Federal Commodity Exchange Regulation)",
      "07:0025" : "07:0025 (7:25 Fraud - Commodities Leverage Contracts)",
      "07:0181" : "07:0181 (07:181 Packers & Stockyard Act)",
      "07:0499" : "07:0499 (07:499 Agricultural Commodities Act)",
      "07:0601" : "07:0601 (07:601 USDA Condemnation)",
      "07:2321" : "07:2321 (07:2321 Plant Variety Protection Act)",
      "08:1105" : "08:1105 (8:1105(a) Aliens: Habeas Corpus to Release INS Detainee)",
      "08:1252" : "08:1252 (08:1252(a)(2) Injunction for Deportation)",
      "08:1260" : "08:1260 (08:1260 Aliens: Access to Records)",
      "08:1324" : "08:1324 (08:1324 Aliens: Complaint for Forfeiture)",
      "08:1329" : "08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petition)",
      "08:1446" : "08:1446 (8:1446 Petition for Naturalization Hearing)",
      "08:1451a" : "08:1451a (Revocation of Naturalization - Title 8 USC 1451(a))",
      "09:0001" : "09:0001 (09:1 U.S. Arbitration Act)",
      "09:0009" : "09:0009 (9:9 Motion to Confirm Arbitration Loan)",
      "09:0010" : "09:0010 (09:0010 Petition to Vacate Arbitration Award)",
      "10:1552" : "10:1552 (10:1552 Armed Forces: Action to Correct Records)",
      "10:1553" : "10:1553 (10:1553 Armed Forces: FOIA General)",
      "10:2305" : "10:2305 (10:2305 Review of Federal Contract)",
      "11:0101" : "11:0101 (11:101 Bankruptcy)",
      "12:0022" : "12:0022 (12:22 Securities Fraud)",
      "12:0635" : "12:0635 (12:635 Breach of Insurance Contract)",
      "12:1461" : "12:1461 (12:1461 Homeowners Loan Act)",
      "12:1703" : "12:1703 (12:1703 Default of HUD Loan)",
      "12:1725" : "12:1725 (12:1725 Collection under Contract Guaranty)",
      "12:1730" : "12:1730 (12:1730 Collection Under Contract Guaranty)",
      "12:1819" : "12:1819 (12:1819 Default of Promissory Note)",
      "12:1821" : "12:1821 (12:1821 Default of Loan by Promissary Note)",
      "12:1971" : "12:1971 (12:1971 Relief under Bank Holding Act)",
      "12:3410" : "12:3410 (12:3410 Right to Financial Privacy Act)",
      "15:0001" : "15:0001 (15:1 Antitrust Litigation)",
      "15:0002at" : "15:0002at (15:2 Antitrust Litigation)",
      "15:0002fl" : "15:0002fl (15:2(a) Fair Labor Standards Act)",
      "15:0005" : "15:0005 (15:5(a) Fair Labor Standards Act)",
      "15:0015" : "15:0015 (15:15 Antitrust Litigation)",
      "15:0025" : "15:0025 (15:25 Clayton Act)",
      "15:0044" : "15:0044 (15:44 Trademark Infringement)",
      "15:0045" : "15:0045 (15:0045 Federal Trade Commission Act)",
      "15:0052" : "15:0052 (15:0052 Federal Trade Commission Act)",
      "15:0053" : "15:0053 (15:0053 Federal Trade Commission Act)",
      "15:0077" : "15:0077 (15:77 Securities Fraud)",
      "15:0078" : "15:0078 (15:78m(a) Securities Exchange Act)",
      "15:0631" : "15:0631 (15:631 Small Business Act)",
      "15:0717" : "15:0717 (15:717 Natural Gas Act)",
      "15:1051" : "15:1051 (15:1051 Trademark Infringement)",
      "15:1114" : "15:1114 (15:1114 Trademark Infringement)",
      "15:1121" : "15:1121 (15:1121 Trademark Infringement)",
      "15:1125" : "15:1125 (15:1125 Trademark Infringement (Lanham Act))",
      "15:1126" : "15:1126 (15:1126 Patent Infringement)",
      "15:1127" : "15:1127 (15:1127 Trademark Infringement)",
      "15:1601" : "15:1601 (15:1601 Truth in Lending)",
      "15:1640" : "15:1640 (15:1640 Truth in Lending)",
      "15:1681" : "15:1681 (15:1681 Fair Credit Reporting Act)",
      "15:1692" : "15:1692 (15:1692 Fair Debt Collection Act)",
      "15:1938" : "15:1938 (15:1938 Fair Labor Standards Act)",
      "15:1981" : "15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))",
      "15:1988" : "15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))",
      "15:1989" : "15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))",
      "15:2301" : "15:2301 (15:2301 Magnuson-Moss Warranty Act)",
      "15:2801" : "15:2801 (15:2801 Petroleum Marketing Practices Act)",
      "15:53(b)" : "15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equitable Relief)",
      "16:0668" : "16:0668 (16:668 Bald Eagle Protection Act)",
      "16:0703" : "16:0703 (16:703 Migratory Bird Act)",
      "16:1538" : "16:1538 (16:1538 Endangered Species Act)",
      "16:3371" : "16:3371 (16:3371 Wildlife Under the Lacey Act)",
      "16:3372" : "16:3372 (16:3372 Conservation: Complaint for Forfeiture)",
      "16:3373" : "16:3373 (16:3373 Appeal of Decision - DOI)",
      "16:3374" : "16:3374 (16:3374 Conservation: Complaint for Forfeiture)",
      "17:0101" : "17:0101 (17:101 Copyright Infringement)",
      "17:0501" : "17:0501 (17:501 Copyright Infringement)",
      "17:0504" : "17:0504 (17:504 Copyright Infringement)",
      "18:0241" : "18:0241 (18:241 Conspiracy Against Citizen Rights)",
      "18:1836a" : "18:1836a (18:1836(a) Injunction against Misappropriation of Trade Secrets)",
      "18:1836b" : "18:1836b (18:1836(b) Civil Action to Protect Trade Secrets)",
      "18:1961" : "18:1961 (18:1961 Racketeering (RICO) Act)",
      "18:1962" : "18:1962 (18:1962 Racketeering (RICO) Act)",
      "18:1964" : "18:1964 (18:1964 Racketeering (RICO) Act)",
      "18:4208" : "18:4208 (18:4208(B) Agency Action Review)",
      "19:1305" : "19:1305 (19:1305 Custom Duties:0Forfeiture-Immoral Articles)",
      "20:1080" : "20:1080 (20:1080 Student Loan Recovery)",
      "20:1400" : "20:1400 (20:1400 Civil Rights of Handicapped Child)",
      "20:1401" : "20:1401 (20:1401 Education: Handicapped Child Act)",
      "21:0841" : "21:0841 (21:841 Forfeiture Property-Drugs)",
      "21:0881" : "21:0881 (21:881 Forfeiture Property-Drugs)",
      "21:0881a" : "21:0881a (21:881 Forfeiture Property - Aircraft)",
      "21:0881re" : "21:0881re (21:881 Forfeiture Property - Real Estate)",
      "23:0134" : "23:0134 (23:134 P.I.- Auto Negligence)",
      "23:1441" : "23:1441 (23:1441 Contract Real Estate)",
      "24:1000" : "24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)",
      "25:0640" : "25:0640 (25:640 Indian Tribal Rights)",
      "25:1901" : "25:1901 (25:1901 Indian Child Welfare Act)",
      "26:6212" : "26:6212 (26:6212 Injunctive Relief from IRS Lien)",
      "26:6213" : "26:6213 (26:6213 Injunctive Relief from IRS Lien)",
      "26:6502" : "26:6502 (26:6502 IRS:Enforcement of tax liens)",
      "26:6532" : "26:6532 (26:6532 IRS: Refund of Tax Penalty)",
      "26:6702" : "26:6702 (26:6702 IRS: Refund of Income Tax Penalty)",
      "26:6703" : "26:6703 (26:6703 IRS: Refund of Tax Penalty)",
      "26:7401" : "26:7401 (26:7401 IRS: Tax Liability)",
      "26:7402" : "26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)",
      "26:7403" : "26:7403 (26:7403 Suit to Enforce Federal Tax Lien)",
      "26:7422rt" : "26:7422rt (26:7422 IRS: Refund Taxes)",
      "26:7422rx" : "26:7422rx (26:7422 IRS: Refund Excise Tax)",
      "26:7426" : "26:7426 (26:7426 IRS: Wrongful Levy for Taxes)",
      "26:7429" : "26:7429 (26:7429 IRS: Tax Jeopardy Assessment)",
      "26:7609" : "26:7609 (26:7609 IRS: Petition to Quash IRS Summons)",
      "27:0185" : "27:0185 (27:185 Enforcement of Arbitration Award)",
      "28:0157c" : "28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)",
      "28:0157d" : "28:0157d (28:0157 Motion for Withdrawal of Reference)",
      "28:0158" : "28:0158 (28:0158 Notice of Appeal re Bankruptcy Matter (BAP))",
      "28:0185" : "28:0185 (28:185 Suit to Compel Arbitration)",
      "28:0451" : "28:0451 (28:451 Employment Discrimination)",
      "28:0794" : "28:0794 (28:794 Rehabilitation Act)",
      "28:1001" : "28:1001 (28:1001 E.R.I.S.A.)",
      "28:1132" : "28:1132 (28:1132 E.R.I.S.A.)",
      "28:1330" : "28:1330 (28:1330 Breach of Contract)",
      "28:1331" : "28:1331 (28:1331 Fed. Question)",
      "28:1331al" : "28:1331al (28:1331 Fed. Question: Airline Crash)",
      "28:1331at" : "28:1331at (28:1331 Fed. Question: Anti-trust)",
      "28:1331au" : "28:1331au (28:1331 Fed. Question: Auto Negligence)",
      "28:1331b" : "28:1331b (28:1331 Federal Question: Bivens Act)",
      "28:1331bc" : "28:1331bc (28:1331 Fed. Question: Breach of Contract)",
      "28:1331ca" : "28:1331ca (28:1331 Fed Question: Fed Communications Act of 1934)",
      "28:1331cm" : "28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)",
      "28:1331cv" : "28:1331cv (28:1331 Federal Question: Other Civil Rights)",
      "28:1331ed" : "28:1331ed (28:1331 Fed. Question: Employment Discrimination)",
      "28:1331es" : "28:1331es (28:1331 Enforcement of Administrative Subpoena)",
      "28:1331fl" : "28:1331fl (28:1331 Fed. Question: Fair Labor Standards)",
      "28:1331in" : "28:1331in (28:1331 Fed. Question: Insurance Contract)",
      "28:1331mm" : "28:1331mm (28:1331 Fed. Question: Medical Malpractice)",
      "28:1331pi" : "28:1331pi (28:1331 Fed. Question: Personal Injury)",
      "28:1331rd" : "28:1331rd (28:1331 Fed. Question: Review Agency Decision)",
      "28:1331rp" : "28:1331rp (28:1331(a) Fed. Question: Real Property)",
      "28:1331rr" : "28:1331rr (28:1331 Fed. Question: Railway Labor Act)",
      "28:1331sv" : "28:1331sv (28:1331 Fed. Question: Securities Violation)",
      "28:1331tr" : "28:1331tr (28:1331 Fed. Question: Trademark)",
      "28:1331tt" : "28:1331tt (28:1331 Fed. Question: Tort Action)",
      "28:1331v" : "28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendment)",
      "28:1331wl" : "28:1331wl (28:1331 Federal Question: EPA Waste Lien)",
      "28:1331wt" : "28:1331wt (28:1331 Fed. Question: Water Rights)",
      "28:1332ac" : "28:1332ac (28:1332 Diversity-Account Receivable)",
      "28:1332al" : "28:1332al (28:1332 Diversity-Airline Crash)",
      "28:1332as" : "28:1332as (28:1332 Diversity-Asbestos Litigation)",
      "28:1332au" : "28:1332au (28:1332 Diversity-Auto Negligence)",
      "28:1332bc" : "28:1332bc (28:1332 Diversity-Breach of Contract)",
      "28:1332co" : "28:1332co (28:1332 Diversity-Conversion)",
      "28:1332ct" : "28:1332ct (28:1332 Diversity-(Citizenship))",
      "28:1332det" : "28:1332det (28:1332 Diversity: Forcible Detainer)",
      "28:1332df" : "28:1332df (28:1332 Diversity-Contract Default)",
      "28:1332ds" : "28:1332ds (28:1332 Diversity-Contract Dispute)",
      "28:1332ed" : "28:1332ed (28:1332 Diversity-Employment Discrimination)",
      "28:1332fd" : "28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)",
      "28:1332fr" : "28:1332fr (28:1332 Diversity-Fraud)",
      "28:1332ia" : "28:1332ia (28:1332 Diversity-Interpleader Action)",
      "28:1332ij" : "28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)",
      "28:1332in" : "28:1332in (28:1332 Diversity-Insurance Contract)",
      "28:1332jd" : "28:1332jd (28:1332 Diversity-Declaratory Judgement)",
      "28:1332lb" : "28:1332lb (28:1332 Diversity-Libel,Assault,Slander)",
      "28:1332lm" : "28:1332lm (28:1332 Diversity - Legal Malpractice)",
      "28:1332ma" : "28:1332ma (28:1332 Diversity-Miller Act)",
      "28:1332mm" : "28:1332mm (28:1332 Diversity-Medical Malpractice)",
      "28:1332mv" : "28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)",
      "28:1332ni" : "28:1332ni (28:1332 Diversity-Negotiable Instrument)",
      "28:1332nm" : "28:1332nm (28:1332 Diversity-Non-Motor Vehicle)",
      "28:1332oc" : "28:1332oc (28:1332 Diversity-Other Contract)",
      "28:1332pd" : "28:1332pd (28:1332 Diversity-Property Damage)",
      "28:1332pi" : "28:1332pi (28:1332 Diversity-Personal Injury)",
      "28:1332pl" : "28:1332pl (28:1332 Diversity-Product Liability)",
      "28:1332pr" : "28:1332pr (28:1332 Diversity-Petition for Removal)",
      "28:1332qt" : "28:1332qt (28:1332 Diversity-Petition to Quiet Title)",
      "28:1332ri" : "28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)",
      "28:1332sa" : "28:1332sa (28:1332 - Diversity: Securities & Exchange Commission Act)",
      "28:1332sf" : "28:1332sf (28:1332 - Diversity: Securities Fraud)",
      "28:1332ss" : "28:1332ss (28:1332 Diversity - Stockholders Suits)",
      "28:1332tl" : "28:1332tl (28:1332 Diversity-Torts to Land)",
      "28:1332tm" : "28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))",
      "28:1332tn" : "28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)",
      "28:1332wd" : "28:1332wd (28:1332 Diversity-Wrongful Death)",
      "28:1333" : "28:1333 (28:1333 Admiralty)",
      "28:1334" : "28:1334 (28:1334 Bankruptcy Appeal)",
      "28:1334c" : "28:1334c (28:1334(c) R&R re motions for abstention (non-core))",
      "28:1335" : "28:1335 (28:1335 Interpleader Action)",
      "28:1337" : "28:1337 (28:1337 Sherman-Clayton Act)",
      "28:1338cp" : "28:1338cp (28:1338 Copyright Infringement)",
      "28:1338pt" : "28:1338pt (28:1338 Patent Infringement)",
      "28:1338tr" : "28:1338tr (28:1338 Trademark Infringement)",
      "28:1340" : "28:1340 (28:1340 IRS: Custom Duties)",
      "28:1340er" : "28:1340er (28:1340 Recovery of Erroneous Refund)",
      "28:1341" : "28:1341 (28:1341 Complaint for Forfeiture)",
      "28:1343" : "28:1343 (28:1343 Violation of Civil Rights)",
      "28:1345co" : "28:1345co (28:1345 Replevin & Conversion)",
      "28:1345db" : "28:1345db (28:1345 Debt to US - FHA/HUD Title I)",
      "28:1345df" : "28:1345df (28:1345 Default of Promissory Note)",
      "28:1345er" : "28:1345er (28:1345 Recovery of Erroneous Refund)",
      "28:1345fc" : "28:1345fc (28:1345 Foreclosure)",
      "28:1345ff" : "28:1345ff (28:1345 Complaint for Forfeiture)",
      "28:1345hl" : "28:1345hl (28:1345 VA Home Loan Guaranty Debt)",
      "28:1345mc" : "28:1345mc (28:1345 Medical Care Recovery)",
      "28:1345mi" : "28:1345mi (28:1345 Mining Claim Ejectment)",
      "28:1345pd" : "28:1345pd (28:1345 Property Damage)",
      "28:1345pe" : "28:1345pe (28:1345 Property Ejectment)",
      "28:1345rc" : "28:1345rc (28:1345 Recovery of Debt to US)",
      "28:1345st" : "28:1345st (28:1345 Default of Student Loan)",
      "28:1345tp" : "28:1345tp (28:1345 Trespass on Public Land)",
      "28:1345va" : "28:1345va (28:1345 Recovery of VA Overpayment)",
      "28:1346bc" : "28:1346bc (28:1346 Breach of Contract)",
      "28:1346rc" : "28:1346rc (28:1346 Recovery of IRS Tax)",
      "28:1346tc" : "28:1346tc (28:1346 Tort Claim)",
      "28:1346wd" : "28:1346wd (28:1346 Wrongful Death)",
      "28:1352" : "28:1352 (28:1352 Miller Act)",
      "28:1355" : "28:1355 (28:1355 Petition for Return of Property)",
      "28:1358" : "28:1358 (28:1358 Land Condemnation)",
      "28:1361" : "28:1361 (28:1361 Petition for Writ of Mandamus)",
      "28:1362ic" : "28:1362ic (28:1362 Indian Tribal Controversy)",
      "28:1362iw" : "28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)",
      "28:1364" : "28:1364 (28:1364 Auto Negligence)",
      "28:1391" : "28:1391 (28:1391 Personal Injury)",
      "28:1402" : "28:1402 (28:1402 Medical Malpractice)",
      "28:1407" : "28:1407 (28:1407 Airline Crash)",
      "28:1441ac" : "28:1441ac (28:1441 Petition for Removal- Account Receivable)",
      "28:1441al" : "28:1441al (28:1441 Petition for Removal- Airline Crash)",
      "28:1441as" : "28:1441as (28:1441 Petition for Removal- Asbestos Litigation)",
      "28:1441au" : "28:1441au (28:1441 Petition for Removal- Auto Negligence)",
      "28:1441bc" : "28:1441bc (28:1441 Petition for Removal- Breach of Contract)",
      "28:1441cv" : "28:1441cv (28:1441 Petition for Removal- Civil Rights Act)",
      "28:1441df" : "28:1441df (28:1441 Petition for Removal- Contract Default)",
      "28:1441dj" : "28:1441dj (28:1441 Petition for Removal- Declaratory Judgement)",
      "28:1441ds" : "28:1441ds (28:1441 Petition for Removal- Contract Dispute)",
      "28:1441ed" : "28:1441ed (28:1441 Petition for Removal - Employment Discrimination)",
      "28:1441fc" : "28:1441fc (28:1441 Petition for Removal - Fair Credit Reporting Act)",
      "28:1441fr" : "28:1441fr (28:1441 Petition for Removal- Fraud)",
      "28:1441ij" : "28:1441ij (28:1441 Petition for Removal- Injunctive/Declaratory Relief)",
      "28:1441in" : "28:1441in (28:1441 Petition for Removal- Insurance Contract)",
      "28:1441int" : "28:1441int (28:1441 Petition for Removal- Action for Interpleader)",
      "28:1441lb" : "28:1441lb (28:1441 Petition for Removal Libel,Assault,Slander)",
      "28:1441lm" : "28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relations)",
      "28:1441mm" : "28:1441mm (28:1441 Petition for Removal- Medical Malpractice)",
      "28:1441ni" : "28:1441ni (28:1441 Petition for Removal- Negotiable Instrument)",
      "28:1441nm" : "28:1441nm (28:1441 Petition for Removal- Non-Motor Vehicle)",
      "28:1441oc" : "28:1441oc (28:1441 Petition For Removal--Other Contract)",
      "28:1441pd" : "28:1441pd (28:1441 Petition for Removal- Property Damage)",
      "28:1441pi" : "28:1441pi (28:1441 Petition for Removal- Personal Injury)",
      "28:1441pl" : "28:1441pl (28:1441 Petition for Removal- Product Liability)",
      "28:1441pr" : "28:1441pr (28:1441 Petition for Removal)",
      "28:1441qt" : "28:1441qt (28:1441 Petition for Removal- Petition to Quiet Title)",
      "28:1441ri" : "28:1441ri (28:1441 Petition for Removal- Racketeering (RICO) Act)",
      "28:1441sa" : "28:1441sa (28:1441 - Petition for Removal: SEC Act)",
      "28:1441sf" : "28:1441sf (28:1441 - Petition for Removal: Securities Fraud)",
      "28:1441tl" : "28:1441tl (28:1441 Petition for Removal- Torts to Land)",
      "28:1441tm" : "28:1441tm (28:1441 Petition for Removal- Tort/Motor Vehicle (P.I.))",
      "28:1441tn" : "28:1441tn (28:1441 Petition for Removal- Tort/Non-Motor Vehicle)",
      "28:1441wd" : "28:1441wd (28:1441 Petition for Removal- Wrongful Death)",
      "28:1442bc" : "28:1442bc (28:1442 Petition for Removal- Breach of Contract)",
      "28:1442pr" : "28:1442pr (28:1442 Petition for Removal)",
      "28:1443" : "28:1443 (28:1443(1) Rent, Lease & Ejectment)",
      "28:1444" : "28:1444 (28:1444 Petition for Removal- Foreclosure)",
      "28:1446in" : "28:1446in (28:1446 Breach of Contract- Insurance)",
      "28:1446pd" : "28:1446pd (28:1446 Petition for Removal- Property Damage (P.I.))",
      "28:1446pi" : "28:1446pi (28:1446 Petition for Removal- Personal Injury)",
      "28:1446pl" : "28:1446pl (28:1446pl Petition for Removal - Product Liability)",
      "28:1446pr" : "28:1446pr (28:1446 Petition for Removal)",
      "28:1452" : "28:1452 (28:1452 R&R re motions to remand (non-core))",
      "28:1651" : "28:1651 (28:1651 Petition for Writ of Coram Nobis)",
      "28:1651hc" : "28:1651hc (28:1651 Petition for Writ of Habeas Corpus)",
      "28:1651mn" : "28:1651mn (28:1651 Petition for Writ of Mandamus)",
      "28:1983" : "28:1983 (28:1983 Civil Rights)",
      "28:2201" : "28:2201 (28:2201 Constitutionality of State Statute(s))",
      "28:2201dj" : "28:2201dj (28:2201 Declaratory Judgement)",
      "28:2201ij" : "28:2201ij (28:2201 Injunction)",
      "28:2201in" : "28:2201in (28:2201 Declaratory Judgement (Insurance))",
      "28:2241" : "28:2241 (28:2241 Petition for Writ of Habeas Corpus (federal))",
      "28:2254" : "28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))",
      "28:2254se" : "28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)",
      "28:2255" : "28:2255 (28:2255 Motion to Vacate / Correct Illegal Sentence)",
      "28:2271" : "28:2271 (28:2271 Federal Tort Claims Act)",
      "28:2345" : "28:2345 (28:2345 Medicare Recovery)",
      "28:2409" : "28:2409 (28:2409(a) Quiet Title Action)",
      "28:2410" : "28:2410 (28:2410 Quiet Title)",
      "28:2671" : "28:2671 (28:2671 Federal Tort Claims Act)",
      "28:2674" : "28:2674 (28:2674 Federal Tort Claims Act)",
      "28:7402" : "28:7402 (28:7402 Refund of Taxes)",
      "28:7422" : "28:7422 (28:7422 Appeal from Administrative Decision)",
      "29:0151" : "29:0151 (29:151 Labor: Review of Agency Action)",
      "29:0160" : "29:0160 (29:160(1) National Labor Relations Act)",
      "29:0184" : "29:0184 (29:184 Violation Collection Bargain Agreement)",
      "29:0185ep" : "29:0185ep (29:185 Employee Pension Plan)",
      "29:0185lm" : "29:0185lm (29:185 Labor/Mgt. Relations (Contracts))",
      "29:0201do" : "29:0201do (29:201 Denial of Overtime Compensation)",
      "29:0201fl" : "29:0201fl (29:201 Fair Labor Standards Act)",
      "29:0203" : "29:0203 (29:203 Equal Pay Act)",
      "29:0206" : "29:0206 (29:206 Collect Unpaid Wages)",
      "29:0401" : "29:0401 (29:0401 Labor Management Disclosure Act)",
      "29:0621" : "29:0621 (29:621 Job Discrimination (Age))",
      "29:0623" : "29:0623 (29:623 Job Discrimination (Age))",
      "29:0626" : "29:0626 (29:626 Job Discrimination (Age))",
      "29:0633" : "29:0633 (29:633 Job Discrimination (Age))",
      "29:0651" : "29:0651 (29:651 Occupational Safety/Health)",
      "29:0754" : "29:0754 (29:754 Discrimination)",
      "29:0791" : "29:0791 (29:791 Job Discrimination (Rehabilitation Act))",
      "29:0794" : "29:0794 (29:0794 Job Discrimination (Handicap))",
      "29:1001" : "29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)",
      "29:1002" : "29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)",
      "29:1104" : "29:1104 (29:1104 Recovery of Benefits to Employee)",
      "29:1109" : "29:1109 (29:1109 Breach of Fiduciary Duties)",
      "29:1131" : "29:1131 (29:1131 ERISA - Collection of Delinquent Trust Funds)",
      "29:1132" : "29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)",
      "29:1145" : "29:1145 (29:1145 E.R.I.S.A.)",
      "29:1149" : "29:1149 (29:1149 Recover Pension & Profit Sharing)",
      "29:1337" : "29:1337 (29:1337 E.R.I.S.A.)",
      "29:1362" : "29:1362 (29:1362 ERISA)",
      "29:1381" : "29:1381 (29:1381 E.R.I.S.A.)",
      "29:1401" : "29:1401 (29:1401(b)(2) Appeal of Arbitration Award)",
      "29:1451" : "29:1451 (29:1451 E.R.I.S.A.)",
      "29:1801" : "29:1801 (29:1801 Farmworker Rights)",
      "29:790" : "29:790 (29:790 Rehabilitation of Labor)",
      "30:0181" : "30:0181 (30:181 Environment: Review of Agency Action)",
      "30:0801" : "30:0801 (30:0801 Penalities/Federal Mine Safety Health Act - 1977)",
      "30:1201" : "30:1201 (30:1201 Environment: Review of Agency Action)",
      "30:1202" : "30:1202 (30:1202 Mining Reclamation Act)",
      "30:1276" : "30:1276 (30:1276 Interior: Review of Agency Action)",
      "31:3545" : "31:3545 (31:3545 Action to Recovery Money)",
      "31:3729" : "31:3729 (31:3729 False Claims Act)",
      "31:3730" : "31:3730 (31:3730 Qui Tam False Claims Act)",
      "31:3731" : "31:3731 (31:3731 Fraud)",
      "33:1319cw" : "33:1319cw (33:1319 Clean Water Act)",
      "33:1319pv" : "33:1319pv (33:1319 Pollutants & Permit Violations)",
      "33:1365" : "33:1365 (33:1365 Environmental Matters)",
      "33:901" : "33:901 (33:901 Longshoremen & Harbor Worker's Comp Act)",
      "35:0145" : "35:0145 (35:145 Patent Infringement)",
      "35:0183" : "35:0183 (35:183 Patent Infringement)",
      "35:0271" : "35:0271 (35:271 Patent Infringement)",
      "38:1681" : "38:1681 (38:1681 Recovery of VA Overpayment)",
      "38:1686" : "38:1686 (38:1686 Recovery of VA Overpayment)",
      "38:1780" : "38:1780 (38:1780 Recovery of VA Overpayment)",
      "38:2011" : "38:2011 (38:2011 - Veteran's Readjustment Assistance Act of 1974)",
      "38:3116" : "38:3116 (38:3116 VA Overpayment)",
      "39:3005" : "39:3005 (39:3005 Detention of Mail for Temporary Periods)",
      "39:409" : "39:409 (39:409 Postal Service)",
      "40:0258" : "40:0258 (40:258(a) Public Buildings & Property: Land Condemnation)",
      "40:0270" : "40:0270 (40:270 Miller Act)",
      "40:0875" : "40:0875 (40:875 Public Buildings & Property: Negligence)",
      "41:0251" : "41:0251 (41:251 Public Contracts-Review of Agency Action)",
      "41:1463" : "41:1463 (41:1463 Public Contracts: Unlawful Employment Practices)",
      "42:0205" : "42:0205 (42:205 Denial Social Security Benefits)",
      "42:0206" : "42:0206 (42:206 Social Security Benefits)",
      "42:0247" : "42:0247 (42:247 Personal Injury-Swine Flu)",
      "42:0402" : "42:0402 (42:402 Social Security Benefits)",
      "42:0405id" : "42:0405id (42:405 Review of HHS Decision (SSID))",
      "42:0405wc" : "42:0405wc (42:405 Review of HHS Decision (DIWC))",
      "42:0405ww" : "42:0405ww (42:405 Review of HHS Decision (DIWW))",
      "42:0416" : "42:0416 (42:416 Denial of Social Security Benefits)",
      "42:0427" : "42:0427 (42:427 Social Security Benefits)",
      "42:12101" : "42:12101 (42:12101 Violation of Americans with Disabilities Act)",
      "42:1383" : "42:1383 (42:1383 Review of HHS Decision)",
      "42:1395" : "42:1395 (42:1395 HHS: Adverse Reimbursement Review)",
      "42:1396" : "42:1396 (42:1396 - Tort Negligence)",
      "42:1471" : "42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclosure Sale)",
      "42:1981cv" : "42:1981cv (42:1981 Civil Rights)",
      "42:1981hs" : "42:1981hs (42:1981 Housing Discrimination)",
      "42:1981jb" : "42:1981jb (42:1981 Job Discrimination (Race))",
      "42:1981sx" : "42:1981sx (42:1981 Sex Discrimination)",
      "42:1983cv" : "42:1983cv (42:1983 Civil Rights Act)",
      "42:1983ed" : "42:1983ed (42:1983 Civil Rights (Employment Discrimination))",
      "42:1983pr" : "42:1983pr (42:1983 Prisoner Civil Rights)",
      "42:1985" : "42:1985 (42:1985 Civil Rights Act)",
      "42:1986" : "42:1986 (42:1986 Neglect of Duty)",
      "42:2000ag" : "42:2000ag (42:2000 Job Discrimination (Age))",
      "42:2000e" : "42:2000e (42:2000e Job Discrimination (Employment))",
      "42:2000pb" : "42:2000pb (42:2000 Job Discrimination (Public Accomodations))",
      "42:2000ra" : "42:2000ra (42:2000 Job Discrimination (Race))",
      "42:2000sx" : "42:2000sx (42:2000 Job Discrimination (Sex))",
      "42:2003" : "42:2003 (42:2003 Job Discrimination)",
      "42:2005" : "42:2005 (42:2005 Review of Agency Action-HHS)",
      "42:2651" : "42:2651 (42:2651 Medical Care Recovery)",
      "42:3601" : "42:3601 (42:405 Fair Housing Act)",
      "42:4000" : "42:4000 (42:4000 National Flood Insurance Act)",
      "42:4001" : "42:4001 (42:4001 National Insurance Flood Act)",
      "42:4053" : "42:4053 (42:4053 Breach of Insurance Contract)",
      "42:4072" : "42:4072 (42:4072 Payment of Flood Insurance Claim)",
      "42:4321" : "42:4321 (42:4321 Review of Agency Action-Environment)",
      "42:4332" : "42:4332 (42:4332 Environmental Policy - Coop of Agency Reports)",
      "42:6901en" : "42:6901en (42:6901 Environmental Cleanup Expenses)",
      "42:6901rs" : "42:6901rs (42:6901 Resource & Recovery Act)",
      "42:7413" : "42:7413 (42:7413(b) Clean Air Act)",
      "42:7604cl" : "42:7604cl (42:7604 Clear Air Act (Emission Standards))",
      "42:7604ir" : "42:7604ir (42:7604 Petition to Quash IRS Summons)",
      "42:9607" : "42:9607 (42:9607 Real Property Tort to Land)",
      "43:945" : "43:945 (43:945 Compensation for Land Condemnation)",
      "43:945a" : "43:945a (43:945a Complaint in Condemnation)",
      "43:946" : "43:946 (43:946 Complaint in Condemnation - Eminent Domain)",
      "45:0051" : "45:0051 (45:51 Railways: Fed. Employer's Liability Act)",
      "45:0151" : "45:0151 (45:151 Railway Labor Act)",
      "45:0184" : "45:0184 (45:184 Action to Set Aside Award of a System Board of Adjust)",
      "45:1395" : "45:1395 (45:1395 Railroads: Adverse Reimbursement Review)",
      "45:7457" : "45:7457 (45:7457 Compel Reclamation Under Clear Air Act)",
      "46:0688" : "46:0688 (46:688 Jones Act)",
      "46:0741" : "46:0741 (46:741 Shipping)",
      "46:0761" : "46:0761 (46:761 Shipping: Damages for Death on High Seas)",
      "46:1101" : "46:1101 (46:1101 Violation of Maritime Regulations)",
      "46:1156" : "46:1156 (46:1156 Administrative Procedure Act)",
      "46:190" : "46:190 (46:190 INDEMNITY UNDER THE GENERAL MARITIME LAW)",
      "48:0883" : "48:0883 (48:883 Violation of US Coastal Law)",
      "48:1424" : "48:1424 (48:1424 The Organic Act of Guam)",
      "48:1983" : "48:1983 (48:1983 Civil Rights)",
      "48:1985" : "48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)",
      "49:0081" : "49:0081 (49:81 Damaged Goods While Being Transported)",
      "49:0781" : "49:0781 (49:781 Forfeiture)",
      "49:11503" : "49:11503 (49:11503 Railroad Revitalization Regulatory Reform Act)",
      "49:11702" : "49:11702 (49:11702(a)(4) Violations of Interstate Commerce Act)",
      "49:1471" : "49:1471 (49:1471 Federal Aviation Act)",
      "49:1903" : "49:1903 (49:1903 Petition to enforce administrative summons)",
      "8:287" : "8:287 (8:287 Petition to Enforce INS Subpoena)",
      "MiscCause" : "MiscCause (Civil Miscellaneous Case)",
      "Rule9H" : "Rule9H (Breach of Contract - Maritime Rule 9(h))",
      "misc" : "misc (Civil Miscellaneous Case)"
   },
   "nvdce" : {
      "0" : "0 (No cause code entered)",
      "02:0431" : "02:0431 (02:431 Fed. Election Commission: Failure Enforce C)",
      "02:0437" : "02:0437 (02:437 Federal Election Commission)",
      "05:0075" : "05:0075 (05:75(2) Contract - Reduction in Grade)",
      "05:0551" : "05:0551 (05:551 Administrative Procedure Act)",
      "05:0552fi" : "05:0552fi (05:552 Freedom of Information Act)",
      "05:0552pa" : "05:0552pa (05:552 Right to Privacy Act)",
      "05:0554" : "05:0554 (05:0554 Constitutionality of Maritime Statutes)",
      "05:0701" : "05:0701 (05:0701 Maritime Subsidy Board)",
      "05:0702" : "05:0702 (05:702 Administrative Procedure Act)",
      "05:0704" : "05:0704 (05:704 Labor Litigation)",
      "05:7703" : "05:7703 (05:7703 Discrimination - Review of Agency Act)",
      "07:0006" : "07:0006 (7:6(b) Federal Commodity Exchange Regulation)",
      "07:0025" : "07:0025 (7:25 Fraud - Commodities Leverage Contracts)",
      "07:0181" : "07:0181 (07:181 Packers & Stockyard Act)",
      "07:0499" : "07:0499 (07:499 Agricultural Commodities Act)",
      "07:0601" : "07:0601 (07:601 USDA Condemnation)",
      "07:2321" : "07:2321 (07:2321 Plant Variety Protection Act)",
      "08:1105" : "08:1105 (8:1105(a) Aliens: Habeas Corpus to Release INS Det)",
      "08:1252" : "08:1252 (08:1252(a)(2) Injunction for Deportation)",
      "08:1260" : "08:1260 (08:1260 Aliens: Access to Records)",
      "08:1324" : "08:1324 (08:1324 Aliens: Complaint for Forfeiture)",
      "08:1329" : "08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petiti)",
      "08:1446" : "08:1446 (8:1446 Petition for Naturalization Hearing)",
      "09:0001" : "09:0001 (09:1 U.S. Arbitration Act)",
      "09:0009" : "09:0009 (9:9 Motion to Confirm Arbitration Loan)",
      "09:0010" : "09:0010 (09:0010 Petition to Vacate Arbitration Award)",
      "10:1552" : "10:1552 (10:1552 Armed Forces: Action to Correct Records)",
      "10:1553" : "10:1553 (10:1553 Armed Forces: FOIA General)",
      "10:2305" : "10:2305 (10:2305 Review of Federal Contract)",
      "11:0101" : "11:0101 (11:101 Bankruptcy)",
      "12:0022" : "12:0022 (12:22 Securities Fraud)",
      "12:0635" : "12:0635 (12:635 Breach of Insurance Contract)",
      "12:1461" : "12:1461 (12:1461 Homeowners Loan Act)",
      "12:1703" : "12:1703 (12:1703 Default of HUD Loan)",
      "12:1725" : "12:1725 (12:1725 Collection under Contract Guaranty)",
      "12:1730" : "12:1730 (12:1730 Collection Under Contract Guaranty)",
      "12:1819" : "12:1819 (12:1819 Default of Promissory Note)",
      "12:1821" : "12:1821 (12:1821 Default of Loan by Promissary Note)",
      "12:1971" : "12:1971 (12:1971 Relief under Bank Holding Act)",
      "12:3410" : "12:3410 (12:3410 Right to Financial Privacy Act)",
      "15:0001" : "15:0001 (15:1 Antitrust Litigation)",
      "15:0002at" : "15:0002at (15:2 Antitrust Litigation)",
      "15:0002fl" : "15:0002fl (15:2(a) Fair Labor Standards Act)",
      "15:0005" : "15:0005 (15:5(a) Fair Labor Standards Act)",
      "15:0015" : "15:0015 (15:15 Antitrust Litigation)",
      "15:0025" : "15:0025 (15:25 Clayton Act)",
      "15:0044" : "15:0044 (15:44 Trademark Infringement)",
      "15:0045" : "15:0045 (15:0045 Federal Trade Commission Act)",
      "15:0052" : "15:0052 (15:0052 Federal Trade Commission Act)",
      "15:0053" : "15:0053 (15:0053 Federal Trade Commission Act)",
      "15:0077" : "15:0077 (15:77 Securities Fraud)",
      "15:0078" : "15:0078 (15:78m(a) Securities Exchange Act)",
      "15:0631" : "15:0631 (15:631 Small Business Act)",
      "15:0717" : "15:0717 (15:717 Natural Gas Act)",
      "15:1051" : "15:1051 (15:1051 Trademark Infringement)",
      "15:1114" : "15:1114 (15:1114 Trademark Infringement)",
      "15:1121" : "15:1121 (15:1121 Trademark Infringement)",
      "15:1125" : "15:1125 (15:1125 Trademark Infringement (Lanham Act))",
      "15:1126" : "15:1126 (15:1126 Patent Infringement)",
      "15:1127" : "15:1127 (15:1127 Trademark Infringement)",
      "15:1601" : "15:1601 (15:1601 Truth in Lending)",
      "15:1640" : "15:1640 (15:1640 Truth in Lending)",
      "15:1681" : "15:1681 (15:1681 Fair Credit Reporting Act)",
      "15:1692" : "15:1692 (15:1692 Fair Debt Collection Act)",
      "15:1938" : "15:1938 (15:1938 Fair Labor Standards Act)",
      "15:1981" : "15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))",
      "15:1988" : "15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))",
      "15:1989" : "15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))",
      "15:2301" : "15:2301 (15:2301 Magnuson-Moss Warranty Act)",
      "15:2801" : "15:2801 (15:2801 Petroleum Marketing Practices Act)",
      "15:53(b)" : "15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equita)",
      "16:0668" : "16:0668 (16:668 Bald Eagle Protection Act)",
      "16:0703" : "16:0703 (16:703 Migratory Bird Act)",
      "16:1538" : "16:1538 (16:1538 Endangered Species Act)",
      "16:3371" : "16:3371 (16:3371 Wildlife Under the Lacey Act)",
      "16:3372" : "16:3372 (16:3372 Conservation: Complaint for Forfeiture)",
      "16:3373" : "16:3373 (16:3373 Appeal of Decision - DOI)",
      "16:3374" : "16:3374 (16:3374 Conservation: Complaint for Forfeiture)",
      "17:0101" : "17:0101 (17:101 Copyright Infringement)",
      "17:0501" : "17:0501 (17:501 Copyright Infringement)",
      "17:0504" : "17:0504 (17:504 Copyright Infringement)",
      "18:0241" : "18:0241 (18:241 Conspiracy Against Citizen Rights)",
      "18:1836a" : "18:1836a (18:1836(a) Injunction against Misappropriation of Trade Secrets)",
      "18:1836b" : "18:1836b (18:1836(b) Civil Action to Protect Trade Secrets)",
      "18:1961" : "18:1961 (18:1961 Racketeering (RICO) Act)",
      "18:1962" : "18:1962 (18:1962 Racketeering (RICO) Act)",
      "18:1964" : "18:1964 (18:1964 Racketeering (RICO) Act)",
      "18:4208" : "18:4208 (18:4208(B) Agency Action Review)",
      "19:1305" : "19:1305 (19:1305 Custom Duties:0Forfeiture-Immoral Articles)",
      "20:1080" : "20:1080 (20:1080 Student Loan Recovery)",
      "20:1400" : "20:1400 (20:1400 Civil Rights of Handicapped Child)",
      "20:1401" : "20:1401 (20:1401 Education: Handicapped Child Act)",
      "21:0841" : "21:0841 (21:841 Forfeiture Property-Drugs)",
      "21:0881" : "21:0881 (21:881 Forfeiture Property-Drugs)",
      "21:0881a" : "21:0881a (21:881 Forfeiture Property - Aircraft)",
      "21:0881re" : "21:0881re (21:881 Forfeiture Property - Real Estate)",
      "23:0134" : "23:0134 (23:134 P.I.- Auto Negligence)",
      "23:1441" : "23:1441 (23:1441 Contract Real Estate)",
      "24:1000" : "24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)",
      "25:0640" : "25:0640 (25:640 Indian Tribal Rights)",
      "25:1901" : "25:1901 (25:1901 Indian Child Welfare Act)",
      "26:6212" : "26:6212 (26:6212 Injunctive Relief from IRS Lien)",
      "26:6213" : "26:6213 (26:6213 Injunctive Relief from IRS Lien)",
      "26:6502" : "26:6502 (26:6502 IRS:Enforcement of tax liens)",
      "26:6532" : "26:6532 (26:6532 IRS: Refund of Tax Penalty)",
      "26:6702" : "26:6702 (26:6702 IRS: Refund of Income Tax Penalty)",
      "26:6703" : "26:6703 (26:6703 IRS: Refund of Tax Penalty)",
      "26:7401" : "26:7401 (26:7401 IRS: Tax Liability)",
      "26:7402" : "26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)",
      "26:7403" : "26:7403 (26:7403 Suit to Enforce Federal Tax Lien)",
      "26:7422rt" : "26:7422rt (26:7422 IRS: Refund Taxes)",
      "26:7422rx" : "26:7422rx (26:7422 IRS: Refund Excise Tax)",
      "26:7426" : "26:7426 (26:7426 IRS: Wrongful Levy for Taxes)",
      "26:7429" : "26:7429 (26:7429 IRS: Tax Jeopardy Assessment)",
      "26:7609" : "26:7609 (26:7609 IRS: Petition to Quash IRS Summons)",
      "27:0185" : "27:0185 (27:185 Enforcement of Arbitration Award)",
      "28:0157c" : "28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)",
      "28:0157d" : "28:0157d (28:0157 Motion for Withdrawal of Reference)",
      "28:0158" : "28:0158 (28:0158 Notice of Appeal re Bankruptcy Matter (BA)",
      "28:0185" : "28:0185 (28:185 Suit to Compel Arbitration)",
      "28:0451" : "28:0451 (28:451 Employment Discrimination)",
      "28:0794" : "28:0794 (28:794 Rehabilitation Act)",
      "28:1001" : "28:1001 (28:1001 E.R.I.S.A.)",
      "28:1132" : "28:1132 (28:1132 E.R.I.S.A.)",
      "28:1330" : "28:1330 (28:1330 Breach of Contract)",
      "28:1331" : "28:1331 (28:1331 Fed. Question)",
      "28:1331al" : "28:1331al (28:1331 Fed. Question: Airline Crash)",
      "28:1331at" : "28:1331at (28:1331 Fed. Question: Anti-trust)",
      "28:1331au" : "28:1331au (28:1331 Fed. Question: Auto Negligence)",
      "28:1331b" : "28:1331b (28:1331 Federal Question: Bivens Act)",
      "28:1331bc" : "28:1331bc (28:1331 Fed. Question: Breach of Contract)",
      "28:1331ca" : "28:1331ca (28:1331 Fed Question: Fed Communications Act of 1)",
      "28:1331cm" : "28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)",
      "28:1331cv" : "28:1331cv (28:1331 Federal Question: Other Civil Rights)",
      "28:1331ed" : "28:1331ed (28:1331 Fed. Question: Employment Discrimination)",
      "28:1331es" : "28:1331es (28:1331 Enforcement of Administrative Subpoena)",
      "28:1331fl" : "28:1331fl (28:1331 Fed. Question: Fair Labor Standards)",
      "28:1331in" : "28:1331in (28:1331 Fed. Question: Insurance Contract)",
      "28:1331mm" : "28:1331mm (28:1331 Fed. Question: Medical Malpractice)",
      "28:1331pi" : "28:1331pi (28:1331 Fed. Question: Personal Injury)",
      "28:1331rd" : "28:1331rd (28:1331 Fed. Question: Review Agency Decision)",
      "28:1331rp" : "28:1331rp (28:1331(a) Fed. Question: Real Property)",
      "28:1331rr" : "28:1331rr (28:1331 Fed. Question: Railway Labor Act)",
      "28:1331sv" : "28:1331sv (28:1331 Fed. Question: Securities Violation)",
      "28:1331tr" : "28:1331tr (28:1331 Fed. Question: Trademark)",
      "28:1331tt" : "28:1331tt (28:1331 Fed. Question: Tort Action)",
      "28:1331v" : "28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendme)",
      "28:1331wl" : "28:1331wl (28:1331 Federal Question: EPA Waste Lien)",
      "28:1331wt" : "28:1331wt (28:1331 Fed. Question: Water Rights)",
      "28:1332ac" : "28:1332ac (28:1332 Diversity-Account Receivable)",
      "28:1332al" : "28:1332al (28:1332 Diversity-Airline Crash)",
      "28:1332as" : "28:1332as (28:1332 Diversity-Asbestos Litigation)",
      "28:1332au" : "28:1332au (28:1332 Diversity-Auto Negligence)",
      "28:1332bc" : "28:1332bc (28:1332 Diversity-Breach of Contract)",
      "28:1332co" : "28:1332co (28:1332 Diversity-Conversion)",
      "28:1332ct" : "28:1332ct (28:1332 Diversity-(Citizenship))",
      "28:1332det" : "28:1332det (28:1332 Diversity: Forcible Detainer)",
      "28:1332df" : "28:1332df (28:1332 Diversity-Contract Default)",
      "28:1332ds" : "28:1332ds (28:1332 Diversity-Contract Dispute)",
      "28:1332ed" : "28:1332ed (28:1332 Diversity-Employment Discrimination)",
      "28:1332fd" : "28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)",
      "28:1332fr" : "28:1332fr (28:1332 Diversity-Fraud)",
      "28:1332ia" : "28:1332ia (28:1332 Diversity-Interpleader Action)",
      "28:1332ij" : "28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)",
      "28:1332in" : "28:1332in (28:1332 Diversity-Insurance Contract)",
      "28:1332jd" : "28:1332jd (28:1332 Diversity-Declaratory Judgement)",
      "28:1332lb" : "28:1332lb (28:1332 Diversity-Libel,Assault,Slander)",
      "28:1332lm" : "28:1332lm (28:1332 Diversity - Legal Malpractice)",
      "28:1332ma" : "28:1332ma (28:1332 Diversity-Miller Act)",
      "28:1332mm" : "28:1332mm (28:1332 Diversity-Medical Malpractice)",
      "28:1332mv" : "28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)",
      "28:1332ni" : "28:1332ni (28:1332 Diversity-Negotiable Instrument)",
      "28:1332nm" : "28:1332nm (28:1332 Diversity-Non-Motor Vehicle)",
      "28:1332oc" : "28:1332oc (28:1332 Diversity-Other Contract)",
      "28:1332pd" : "28:1332pd (28:1332 Diversity-Property Damage)",
      "28:1332pi" : "28:1332pi (28:1332 Diversity-Personal Injury)",
      "28:1332pl" : "28:1332pl (28:1332 Diversity-Product Liability)",
      "28:1332pr" : "28:1332pr (28:1332 Diversity-Petition for Removal)",
      "28:1332qt" : "28:1332qt (28:1332 Diversity-Petition to Quiet Title)",
      "28:1332ri" : "28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)",
      "28:1332sa" : "28:1332sa (28:1332 - Diversity: Securities & Exchange Commiss)",
      "28:1332sf" : "28:1332sf (28:1332 - Diversity: Securities Fraud)",
      "28:1332ss" : "28:1332ss (28:1332 Diversity - Stockholders Suits)",
      "28:1332tl" : "28:1332tl (28:1332 Diversity-Torts to Land)",
      "28:1332tm" : "28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))",
      "28:1332tn" : "28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)",
      "28:1332wd" : "28:1332wd (28:1332 Diversity-Wrongful Death)",
      "28:1333" : "28:1333 (28:1333 Admiralty)",
      "28:1334" : "28:1334 (28:1334 Bankruptcy Appeal)",
      "28:1334c" : "28:1334c (28:1334(c) R&R re motions for abstention (non-cor)",
      "28:1335" : "28:1335 (28:1335 Interpleader Action)",
      "28:1337" : "28:1337 (28:1337 Sherman-Clayton Act)",
      "28:1338cp" : "28:1338cp (28:1338 Copyright Infringement)",
      "28:1338pt" : "28:1338pt (28:1338 Patent Infringement)",
      "28:1338tr" : "28:1338tr (28:1338 Trademark Infringement)",
      "28:1340" : "28:1340 (28:1340 IRS: Custom Duties)",
      "28:1340er" : "28:1340er (28:1340 Recovery of Erroneous Refund)",
      "28:1341" : "28:1341 (28:1341 Complaint for Forfeiture)",
      "28:1343" : "28:1343 (28:1343 Violation of Civil Rights)",
      "28:1345co" : "28:1345co (28:1345 Replevin & Conversion)",
      "28:1345db" : "28:1345db (28:1345 Debt to US - FHA/HUD Title I)",
      "28:1345df" : "28:1345df (28:1345 Default of Promissory Note)",
      "28:1345er" : "28:1345er (28:1345 Recovery of Erroneous Refund)",
      "28:1345fc" : "28:1345fc (28:1345 Foreclosure)",
      "28:1345ff" : "28:1345ff (28:1345 Complaint for Forfeiture)",
      "28:1345hl" : "28:1345hl (28:1345 VA Home Loan Guaranty Debt)",
      "28:1345mc" : "28:1345mc (28:1345 Medical Care Recovery)",
      "28:1345mi" : "28:1345mi (28:1345 Mining Claim Ejectment)",
      "28:1345pd" : "28:1345pd (28:1345 Property Damage)",
      "28:1345pe" : "28:1345pe (28:1345 Property Ejectment)",
      "28:1345rc" : "28:1345rc (28:1345 Recovery of Debt to US)",
      "28:1345st" : "28:1345st (28:1345 Default of Student Loan)",
      "28:1345tp" : "28:1345tp (28:1345 Trespass on Public Land)",
      "28:1345va" : "28:1345va (28:1345 Recovery of VA Overpayment)",
      "28:1346bc" : "28:1346bc (28:1346 Breach of Contract)",
      "28:1346rc" : "28:1346rc (28:1346 Recovery of IRS Tax)",
      "28:1346tc" : "28:1346tc (28:1346 Tort Claim)",
      "28:1346wd" : "28:1346wd (28:1346 Wrongful Death)",
      "28:1352" : "28:1352 (28:1352 Miller Act)",
      "28:1355" : "28:1355 (28:1355 Petition for Return of Property)",
      "28:1358" : "28:1358 (28:1358 Land Condemnation)",
      "28:1361" : "28:1361 (28:1361 Petition for Writ of Mandamus)",
      "28:1362ic" : "28:1362ic (28:1362 Indian Tribal Controversy)",
      "28:1362iw" : "28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)",
      "28:1364" : "28:1364 (28:1364 Auto Negligence)",
      "28:1391" : "28:1391 (28:1391 Personal Injury)",
      "28:1402" : "28:1402 (28:1402 Medical Malpractice)",
      "28:1407" : "28:1407 (28:1407 Airline Crash)",
      "28:1441ac" : "28:1441ac (28:1441 Petition for Removal- Account Receivable)",
      "28:1441al" : "28:1441al (28:1441 Petition for Removal- Airline Crash)",
      "28:1441as" : "28:1441as (28:1441 Petition for Removal- Asbestos Litigation)",
      "28:1441au" : "28:1441au (28:1441 Petition for Removal- Auto Negligence)",
      "28:1441bc" : "28:1441bc (28:1441 Petition for Removal- Breach of Contract)",
      "28:1441cv" : "28:1441cv (28:1441 Petition for Removal- Civil Rights Act)",
      "28:1441df" : "28:1441df (28:1441 Petition for Removal- Contract Default)",
      "28:1441dj" : "28:1441dj (28:1441 Petition for Removal- Declaratory Judgemen)",
      "28:1441ds" : "28:1441ds (28:1441 Petition for Removal- Contract Dispute)",
      "28:1441ed" : "28:1441ed (28:1441 Petition for Removal - Employment Discrim)",
      "28:1441fc" : "28:1441fc (28:1441 Petition for Removal - Fair Credit Reporti)",
      "28:1441fr" : "28:1441fr (28:1441 Petition for Removal- Fraud)",
      "28:1441ij" : "28:1441ij (28:1441 Petition for Removal- Injunctive/Declarato)",
      "28:1441in" : "28:1441in (28:1441 Petition for Removal- Insurance Contract)",
      "28:1441int" : "28:1441int (28:1441 Petition for Removal- Action for Interplea)",
      "28:1441lb" : "28:1441lb (28:1441 Petition for Removal Libel,Assault,Slander)",
      "28:1441lm" : "28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relatio)",
      "28:1441mm" : "28:1441mm (28:1441 Petition for Removal- Medical Malpractice)",
      "28:1441ni" : "28:1441ni (28:1441 Petition for Removal- Negotiable Instrumen)",
      "28:1441nm" : "28:1441nm (28:1441 Petition for Removal- Non-Motor Vehicle)",
      "28:1441oc" : "28:1441oc (28:1441 Petition For Removal--Other Contract)",
      "28:1441pd" : "28:1441pd (28:1441 Petition for Removal- Property Damage)",
      "28:1441pi" : "28:1441pi (28:1441 Petition for Removal- Personal Injury)",
      "28:1441pl" : "28:1441pl (28:1441 Petition for Removal- Product Liability)",
      "28:1441pr" : "28:1441pr (28:1441 Petition for Removal)",
      "28:1441qt" : "28:1441qt (28:1441 Petition for Removal- Petition to Quiet Ti)",
      "28:1441ri" : "28:1441ri (28:1441 Petition for Removal- Racketeering (RICO))",
      "28:1441sa" : "28:1441sa (28:1441 - Petition for Removal: SEC Act)",
      "28:1441sf" : "28:1441sf (28:1441 - Petition for Removal: Securities Fraud)",
      "28:1441tl" : "28:1441tl (28:1441 Petition for Removal- Torts to Land)",
      "28:1441tm" : "28:1441tm (28:1441 Petition for Removal- Tort/Motor Vehicle ()",
      "28:1441tn" : "28:1441tn (28:1441 Petition for Removal- Tort/Non-Motor Vehic)",
      "28:1441wd" : "28:1441wd (28:1441 Petition for Removal- Wrongful Death)",
      "28:1442bc" : "28:1442bc (28:1442 Petition for Removal- Breach of Contract)",
      "28:1442pr" : "28:1442pr (28:1442 Petition for Removal)",
      "28:1443" : "28:1443 (28:1443(1) Rent, Lease & Ejectment)",
      "28:1444" : "28:1444 (28:1444 Petition for Removal- Foreclosure)",
      "28:1446in" : "28:1446in (28:1446 Breach of Contract- Insurance)",
      "28:1446pd" : "28:1446pd (28:1446 Petition for Removal- Property Damage (P.I)",
      "28:1446pi" : "28:1446pi (28:1446 Petition for Removal- Personal Injury)",
      "28:1446pl" : "28:1446pl (28:1446pl Petition for Removal - Product Liability)",
      "28:1446pr" : "28:1446pr (28:1446 Petition for Removal)",
      "28:1452" : "28:1452 (28:1452 R&R re motions to remand (non-core))",
      "28:1651" : "28:1651 (28:1651 Petition for Writ of Coram Nobis)",
      "28:1651hc" : "28:1651hc (28:1651 Petition for Writ of Habeas Corpus)",
      "28:1651mn" : "28:1651mn (28:1651 Petition for Writ of Mandamus)",
      "28:1983" : "28:1983 (28:1983 Civil Rights)",
      "28:2201" : "28:2201 (28:2201 Constitutionality of State Statute(s))",
      "28:2201dj" : "28:2201dj (28:2201 Declaratory Judgment)",
      "28:2201ij" : "28:2201ij (28:2201 Injunction)",
      "28:2201in" : "28:2201in (28:2201 Declaratory Judgment (Insurance))",
      "28:2241" : "28:2241 (28:2241 Petition for Writ of Habeas Corpus (federa)",
      "28:2254" : "28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))",
      "28:2254se" : "28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)",
      "28:2255" : "28:2255 (28:2255 Motion to Vacate / Correct Illegal Sentenc)",
      "28:2271" : "28:2271 (28:2271 Federal Tort Claims Act)",
      "28:2345" : "28:2345 (28:2345 Medicare Recovery)",
      "28:2409" : "28:2409 (28:2409(a) Quiet Title Action)",
      "28:2410" : "28:2410 (28:2410 Quiet Title)",
      "28:2671" : "28:2671 (28:2671 Federal Tort Claims Act)",
      "28:2674" : "28:2674 (28:2674 Federal Tort Claims Act)",
      "28:7402" : "28:7402 (28:7402 Refund of Taxes)",
      "28:7422" : "28:7422 (28:7422 Appeal from Administrative Decision)",
      "29:0151" : "29:0151 (29:151 Labor: Review of Agency Action)",
      "29:0160" : "29:0160 (29:160(1) National Labor Relations Act)",
      "29:0184" : "29:0184 (29:184 Violation Collection Bargain Agreement)",
      "29:0185ep" : "29:0185ep (29:185 Employee Pension Plan)",
      "29:0185lm" : "29:0185lm (29:185 Labor/Mgt. Relations (Contracts))",
      "29:0201do" : "29:0201do (29:201 Denial of Overtime Compensation)",
      "29:0201fl" : "29:0201fl (29:201 Fair Labor Standards Act)",
      "29:0203" : "29:0203 (29:203 Equal Pay Act)",
      "29:0206" : "29:0206 (29:206 Collect Unpaid Wages)",
      "29:0401" : "29:0401 (29:0401 Labor Management Disclosure Act)",
      "29:0411" : "29:0411 (29:0411 Labor Organizations)",
      "29:0621" : "29:0621 (29:621 Job Discrimination (Age))",
      "29:0623" : "29:0623 (29:623 Job Discrimination (Age))",
      "29:0626" : "29:0626 (29:626 Job Discrimination (Age))",
      "29:0633" : "29:0633 (29:633 Job Discrimination (Age))",
      "29:0651" : "29:0651 (29:651 Occupational Safety/Health)",
      "29:0754" : "29:0754 (29:754 Discrimination)",
      "29:0791" : "29:0791 (29:791 Job Discrimination (Rehabilitation Act))",
      "29:0794" : "29:0794 (29:0794 Job Discrimination (Handicap))",
      "29:1001" : "29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)",
      "29:1002" : "29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)",
      "29:1104" : "29:1104 (29:1104 Recovery of Benefits to Employee)",
      "29:1109" : "29:1109 (29:1109 Breach of Fiduciary Duties)",
      "29:1131" : "29:1131 (29:1131 ERISA - Collection of Delinquent Trust Fun)",
      "29:1132" : "29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)",
      "29:1145" : "29:1145 (29:1145 E.R.I.S.A.)",
      "29:1149" : "29:1149 (29:1149 Recover Pension & Profit Sharing)",
      "29:1337" : "29:1337 (29:1337 E.R.I.S.A.)",
      "29:1362" : "29:1362 (29:1362 ERISA)",
      "29:1381" : "29:1381 (29:1381 E.R.I.S.A.)",
      "29:1401" : "29:1401 (29:1401(b)(2) Appeal of Arbitration Award)",
      "29:1451" : "29:1451 (29:1451 E.R.I.S.A.)",
      "29:1801" : "29:1801 (29:1801 Farmworker Rights)",
      "29:790" : "29:790 (29:790 Rehabilitation of Labor)",
      "30:0181" : "30:0181 (30:181 Environment: Review of Agency Action)",
      "30:0801" : "30:0801 (30:0801 Penalities/Federal Mine Safety Health Act)",
      "30:1201" : "30:1201 (30:1201 Environment: Review of Agency Action)",
      "30:1202" : "30:1202 (30:1202 Mining Reclamation Act)",
      "30:1276" : "30:1276 (30:1276 Interior: Review of Agency Action)",
      "31:3545" : "31:3545 (31:3545 Action to Recovery Money)",
      "31:3729" : "31:3729 (31:3729 False Claims Act)",
      "31:3730" : "31:3730 (31:3730 Qui Tam False Claims Act)",
      "31:3731" : "31:3731 (31:3731 Fraud)",
      "33:1319cw" : "33:1319cw (33:1319 Clean Water Act)",
      "33:1319pv" : "33:1319pv (33:1319 Pollutants & Permit Violations)",
      "33:1365" : "33:1365 (33:1365 Environmental Matters)",
      "35:0145" : "35:0145 (35:145 Patent Infringement)",
      "35:0183" : "35:0183 (35:183 Patent Infringement)",
      "35:0271" : "35:0271 (35:271 Patent Infringement)",
      "38:1681" : "38:1681 (38:1681 Recovery of VA Overpayment)",
      "38:1686" : "38:1686 (38:1686 Recovery of VA Overpayment)",
      "38:1780" : "38:1780 (38:1780 Recovery of VA Overpayment)",
      "38:2011" : "38:2011 (38:2011 - Veteran's Readjustment Assistance Act of)",
      "38:3116" : "38:3116 (38:3116 VA Overpayment)",
      "39:3005" : "39:3005 (39:3005 Detention of Mail for Temporary Periods)",
      "39:409" : "39:409 (39:409 Postal Service)",
      "40:0258" : "40:0258 (40:258(a) Public Buildings & Property: Land Condem)",
      "40:0270" : "40:0270 (40:270 Miller Act)",
      "40:0875" : "40:0875 (40:875 Public Buildings & Property: Negligence)",
      "41:0251" : "41:0251 (41:251 Public Contracts-Review of Agency Action)",
      "41:1463" : "41:1463 (41:1463 Public Contracts: Unlawful Employment Prac)",
      "42:0205" : "42:0205 (42:205 Denial Social Security Benefits)",
      "42:0206" : "42:0206 (42:206 Social Security Benefits)",
      "42:0247" : "42:0247 (42:247 Personal Injury-Swine Flu)",
      "42:0402" : "42:0402 (42:402 Social Security Benefits)",
      "42:0405id" : "42:0405id (42:405 Review of HHS Decision (SSID))",
      "42:0405wc" : "42:0405wc (42:405 Review of HHS Decision (DIWC))",
      "42:0405ww" : "42:0405ww (42:405 Review of HHS Decision (DIWW))",
      "42:0416" : "42:0416 (42:416 Denial of Social Security Benefits)",
      "42:0427" : "42:0427 (42:427 Social Security Benefits)",
      "42:11601" : "42:11601 (42:11601 International Child Abduction Remedies Act)",
      "42:1383" : "42:1383 (42:1383 Review of HHS Decision)",
      "42:1395" : "42:1395 (42:1395 HHS: Adverse Reimbursement Review)",
      "42:1396" : "42:1396 (42:1396 - Tort Negligence)",
      "42:1471" : "42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclo)",
      "42:1981cv" : "42:1981cv (42:1981 Civil Rights)",
      "42:1981hs" : "42:1981hs (42:1981 Housing Discrimination)",
      "42:1981jb" : "42:1981jb (42:1981 Job Discrimination (Race))",
      "42:1981sx" : "42:1981sx (42:1981 Sex Discrimination)",
      "42:1983cv" : "42:1983cv (42:1983 Civil Rights Act)",
      "42:1983ed" : "42:1983ed (42:1983 Civil Rights (Employment Discrimination))",
      "42:1983pr" : "42:1983pr (42:1983 Prisoner Civil Rights)",
      "42:1986" : "42:1986 (42:1986 Neglect of Duty)",
      "42:2000ag" : "42:2000ag (42:2000 Job Discrimination (Age))",
      "42:2000e" : "42:2000e (42:2000e Job Discrimination (Employment))",
      "42:2000pb" : "42:2000pb (42:2000 Job Discrimination (Public Accomodations))",
      "42:2000ra" : "42:2000ra (42:2000 Job Discrimination (Race))",
      "42:2000sx" : "42:2000sx (42:2000 Job Discrimination (Sex))",
      "42:2003" : "42:2003 (42:2003 Job Discrimination)",
      "42:2005" : "42:2005 (42:2005 Review of Agency Action-HHS)",
      "42:2651" : "42:2651 (42:2651 Medical Care Recovery)",
      "42:3601" : "42:3601 (42:405 Fair Housing Act)",
      "42:4000" : "42:4000 (42:4000 National Flood Insurance Act)",
      "42:4001" : "42:4001 (42:4001 National Insurance Flood Act)",
      "42:4053" : "42:4053 (42:4053 Breach of Insurance Contract)",
      "42:4072" : "42:4072 (42:4072 Payment of Flood Insurance Claim)",
      "42:4321" : "42:4321 (42:4321 Review of Agency Action-Environment)",
      "42:4332" : "42:4332 (42:4332 Environmental Policy - Coop of Agency Repo)",
      "42:6901en" : "42:6901en (42:6901 Environmental Cleanup Expenses)",
      "42:6901rs" : "42:6901rs (42:6901 Resource & Recovery Act)",
      "42:7413" : "42:7413 (42:7413(b) Clean Air Act)",
      "42:7604cl" : "42:7604cl (42:7604 Clear Air Act (Emission Standards))",
      "42:7604ir" : "42:7604ir (42:7604 Petition to Quash IRS Summons)",
      "42:9607" : "42:9607 (42:9607 Real Property Tort to Land)",
      "43:945" : "43:945 (43:945 Compensation for Land Condemnation)",
      "43:945a" : "43:945a (43:945a Complaint in Condemnation)",
      "43:946" : "43:946 (43:946 Complaint in Condemnation - Eminent Domain)",
      "45:0051" : "45:0051 (45:51 Railways: Fed. Employer's Liability Act)",
      "45:0151" : "45:0151 (45:151 Railway Labor Act)",
      "45:0184" : "45:0184 (45:184 Action to Set Aside Award of a System Board)",
      "45:1395" : "45:1395 (45:1395 Railroads: Adverse Reimbursement Review)",
      "45:7457" : "45:7457 (45:7457 Compel Reclamation Under Clear Air Act)",
      "46:0688" : "46:0688 (46:688 Jones Act)",
      "46:0741" : "46:0741 (46:741 Shipping)",
      "46:0761" : "46:0761 (46:761 Shipping: Damages for Death on High Seas)",
      "46:1101" : "46:1101 (46:1101 Violation of Maritime Regulations)",
      "46:1156" : "46:1156 (46:1156 Administrative Procedure Act)",
      "47:227" : "47:227 (47:227 Telephone Consumer Protection Act)",
      "48:0883" : "48:0883 (48:883 Violation of US Coastal Law)",
      "48:1985" : "48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)",
      "49:0081" : "49:0081 (49:81 Damaged Goods While Being Transported)",
      "49:0781" : "49:0781 (49:781 Forfeiture)",
      "49:11503" : "49:11503 (49:11503 Railroad Revitalization Regulatory Reform)",
      "49:11702" : "49:11702 (49:11702(a)(4) Violations of Interstate Commerce A)",
      "49:1471" : "49:1471 (49:1471 Federal Aviation Act)",
      "49:1903" : "49:1903 (49:1903 Petition to enforce administrative summon)",
      "8:287" : "8:287 (8:287 Petition to Enforce INS Subpoena)",
      "misc" : "misc (Civil Miscellaneous Case)"
   },
   "nyedce" : {
      "0" : "0 (00:0000)",
      "02:0431" : "02:0431 (02:431 Fed. Election Commission: Failure Enforce Compliance)",
      "02:0437" : "02:0437 (02:437 Federal Election Commission)",
      "02:1202" : "02:1202 (Discriminatory practices affecting US Senate employees)",
      "02:1301" : "02:1301 (Congressional Accountability Act)",
      "02:1317(a)" : "02:1317(a) (Violation of Congressional Account Ability Act)",
      "02:138" : "02:138 (Library of Congress Access)",
      "02:358" : "02:358 (President's Recommendations on Exec., Jud. & Leg. Salary)",
      "02:431" : "02:431 (Federal Election Commision: Failure to Enforce Compliance)",
      "02:437" : "02:437 (Federal Election Commision)",
      "02:681" : "02:681 (Deferral of Budget Authority)",
      "05:0075" : "05:0075 (05:75(2) Contract - Reduction in Grade)",
      "05:0551" : "05:0551 (05:551 Administrative Procedure Act)",
      "05:0552fi" : "05:0552fi (05:552 Freedom of Information Act)",
      "05:0552pa" : "05:0552pa (05:552 Right to Privacy Act)",
      "05:0554" : "05:0554 (05:0554 Constitutionality of Maritime Statutes)",
      "05:0554a" : "05:0554a (05:0554 Adjudications)",
      "05:0701" : "05:0701 (05:0701 Maritime Subsidy Board)",
      "05:0701jr" : "05:0701jr (05:0701jr Judicial Review)",
      "05:0702" : "05:0702 (05:702 Administrative Procedure Act)",
      "05:0704" : "05:0704 (05:704 Labor Litigation)",
      "05:7703" : "05:7703 (05:7703 Discrimination - Review of Agency Act)",
      "05:8470" : "05:8470 (05:8470 Enforcement of Judgment against Retirement Benefits )",
      "07:0006" : "07:0006 (7:6(b) Federal Commodity Exchange Regulation)",
      "07:0025" : "07:0025 (7:25 Fraud - Commodities Leverage Contracts)",
      "07:0181" : "07:0181 (07:181 Packers & Stockyard Act)",
      "07:0499" : "07:0499 (07:499 Agricultural Commodities Act)",
      "07:0601" : "07:0601 (07:601 USDA Condemnation)",
      "07:2321" : "07:2321 (07:2321 Plant Variety Protection Act)",
      "08:1105" : "08:1105 (8:1105(a) Aliens: Habeas Corpus to Release INS Det)",
      "08:1182" : "08:1182 (8:1182 Defend. Denial of Pla. Appl. for Alien Employment Cer)",
      "08:1252" : "08:1252 (08:1252(a)(2) Injunction for Deportation)",
      "08:1260" : "08:1260 (08:1260 Aliens: Access to Records)",
      "08:1324" : "08:1324 (08:1324 Aliens: Complaint for Forfeiture)",
      "08:1329" : "08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petiti)",
      "08:1446" : "08:1446 (8:1446 Petition for Naturalization Hearing)",
      "08:1451(j)" : "08:1451(j) (8:1451(j) Motion to Correct Order & Judg. of Naturalization )",
      "09:0001" : "09:0001 (09:1 U.S. Arbitration Act)",
      "09:0009" : "09:0009 (9:9 Motion to Confirm Arbitration Loan)",
      "09:0010" : "09:0010 (09:0010 Petition to Vacate Arbitration Award)",
      "10:1408" : "10:1408 (10:1408 Claim for Military Retirement )",
      "10:1552" : "10:1552 (10:1552 Armed Forces: Action to Correct Records)",
      "10:1553" : "10:1553 (10:1553 Armed Forces: FOIA General)",
      "10:2305" : "10:2305 (10:2305 Review of Federal Contract)",
      "11:0101" : "11:0101 (11:101 Bankruptcy)",
      "12:0022" : "12:0022 (12:22 Securities Fraud)",
      "12:0635" : "12:0635 (12:635 Breach of Insurance Contract)",
      "12:1461" : "12:1461 (12:1461 Homeowners Loan Act)",
      "12:1464" : "12:1464 (12:1464 Federal Savings and Loan )",
      "12:1703" : "12:1703 (12:1703 Default of HUD Loan)",
      "12:1725" : "12:1725 (12:1725 Collection under Contract Guaranty)",
      "12:1730" : "12:1730 (12:1730 Collection Under Contract Guaranty)",
      "12:1819" : "12:1819 (12:1819 Default of Promissory Note)",
      "12:1821" : "12:1821 (12:1821 Default of Loan by Promissary Note)",
      "12:191" : "12:191 (12:191 Bank Foreclosure )",
      "12:192" : "12:192 (12:192 Liquidation of National Bank )",
      "12:1971" : "12:1971 (12:1971 Relief under Bank Holding Act)",
      "12:1972" : "12:1972 (12:1972 Typing Arrangement Act )",
      "12:3410" : "12:3410 (12:3410 Right to Financial Privacy Act)",
      "15:0001" : "15:0001 (15:1 Antitrust Litigation)",
      "15:0002at" : "15:0002at (15:2 Antitrust Litigation)",
      "15:0002fl" : "15:0002fl (15:2(a) Fair Labor Standards Act)",
      "15:0005" : "15:0005 (15:5(a) Fair Labor Standards Act)",
      "15:0015" : "15:0015 (15:15 Antitrust Litigation)",
      "15:0025" : "15:0025 (15:25 Clayton Act)",
      "15:0044" : "15:0044 (15:44 Trademark Infringement)",
      "15:0045" : "15:0045 (15:0045 Federal Trade Commission Act)",
      "15:0052" : "15:0052 (15:0052 Federal Trade Commission Act)",
      "15:0053" : "15:0053 (15:0053 Federal Trade Commission Act)",
      "15:0077" : "15:0077 (15:77 Securities Fraud)",
      "15:0078" : "15:0078 (15:78m(a) Securities Exchange Act)",
      "15:0631" : "15:0631 (15:631 Small Business Act)",
      "15:0717" : "15:0717 (15:717 Natural Gas Act)",
      "15:0754" : "15:0754 (15:754 Emergency Petroleum Allocation-Admin.& Enforcement )",
      "15:1051" : "15:1051 (15:1051 Trademark Infringement)",
      "15:1114" : "15:1114 (15:1114 Trademark Infringement)",
      "15:1121" : "15:1121 (15:1121 Trademark Infringement)",
      "15:1125" : "15:1125 (15:1125 Trademark Infringement (Lanham Act))",
      "15:1126" : "15:1126 (15:1126 Patent Infringement)",
      "15:1127" : "15:1127 (15:1127 Trademark Infringement)",
      "15:1601" : "15:1601 (15:1601 Truth in Lending)",
      "15:1640" : "15:1640 (15:1640 Truth in Lending)",
      "15:1681" : "15:1681 (15:1681 Fair Credit Reporting Act)",
      "15:1692" : "15:1692 (15:1692 Fair Debt Collection Act)",
      "15:1938" : "15:1938 (15:1938 Fair Labor Standards Act)",
      "15:1981" : "15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))",
      "15:1988" : "15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))",
      "15:1989" : "15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))",
      "15:2301" : "15:2301 (15:2301 Magnuson-Moss Warranty Act)",
      "15:2801" : "15:2801 (15:2801 Petroleum Marketing Practices Act)",
      "15:45" : "15:45 (15:45 Federal Trade Commission Act)",
      "15:53(b)" : "15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equita)",
      "16:0668" : "16:0668 (16:668 Bald Eagle Protection Act)",
      "16:0703" : "16:0703 (16:703 Migratory Bird Act)",
      "16:1538" : "16:1538 (16:1538 Endangered Species Act)",
      "16:3371" : "16:3371 (16:3371 Wildlife Under the Lacey Act)",
      "16:3372" : "16:3372 (16:3372 Conservation: Complaint for Forfeiture)",
      "16:3373" : "16:3373 (16:3373 Appeal of Decision - DOI)",
      "16:3374" : "16:3374 (16:3374 Conservation: Complaint for Forfeiture)",
      "17:0101" : "17:0101 (17:101 Copyright Infringement)",
      "17:0501" : "17:0501 (17:501 Copyright Infringement)",
      "17:0504" : "17:0504 (17:504 Copyright Infringement)",
      "18:0241" : "18:0241 (18:241 Conspiracy Against Citizen Rights)",
      "18:1836a" : "18:1836a (18:1836(a) - Injunction against Misappropriation of Trade Secrets)",
      "18:1836b" : "18:1836b (18:1836(b) - Civil Action to Protect Trade Secrets)",
      "18:1961" : "18:1961 (18:1961 Racketeering (RICO) Act)",
      "18:1962" : "18:1962 (18:1962 Racketeering (RICO) Act)",
      "18:1964" : "18:1964 (18:1964 Racketeering (RICO) Act)",
      "18:2510" : "18:2510 (APPLICATION FOR INTERCEPTION OF WIRE OR ORAL COMMUNICATIONS )",
      "18:2511" : "18:2511 (18:2511 Wiretapping )",
      "18:2701" : "18:2701 (STORED WIRE AND ELECTRONIC COMMUNICATIONS )",
      "18:3114" : "18:3114 (18:3114 Motion for Return of Seized Property)",
      "18:4208" : "18:4208 (18:4208(B) Agency Action Review)",
      "19:1305" : "19:1305 (19:1305 Custom Duties:0Forfeiture-Immoral Articles)",
      "20:1080" : "20:1080 (20:1080 Student Loan Recovery)",
      "20:1400" : "20:1400 (20:1400 Civil Rights of Handicapped Child)",
      "20:1401" : "20:1401 (20:1401 Education: Handicapped Child Act)",
      "21:0841" : "21:0841 (21:841 Forfeiture Property-Drugs)",
      "21:0881" : "21:0881 (21:881 Forfeiture Property-Drugs)",
      "21:0881a" : "21:0881a (21:881 Forfeiture Property - Aircraft)",
      "21:0881re" : "21:0881re (21:881 Forfeiture Property - Real Estate)",
      "23:0134" : "23:0134 (23:134 P.I.- Auto Negligence)",
      "23:1441" : "23:1441 (23:1441 Contract Real Estate)",
      "24:1000" : "24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)",
      "25:0640" : "25:0640 (25:640 Indian Tribal Rights)",
      "25:1901" : "25:1901 (25:1901 Indian Child Welfare Act)",
      "26:6212" : "26:6212 (26:6212 Injunctive Relief from IRS Lien)",
      "26:6213" : "26:6213 (26:6213 Injunctive Relief from IRS Lien)",
      "26:6502" : "26:6502 (26:6502 IRS:Enforcement of tax liens)",
      "26:6532" : "26:6532 (26:6532 IRS: Refund of Tax Penalty)",
      "26:6702" : "26:6702 (26:6702 IRS: Refund of Income Tax Penalty)",
      "26:6703" : "26:6703 (26:6703 IRS: Refund of Tax Penalty)",
      "26:7401" : "26:7401 (26:7401 IRS: Tax Liability)",
      "26:7402" : "26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)",
      "26:7403" : "26:7403 (26:7403 Suit to Enforce Federal Tax Lien)",
      "26:7422rt" : "26:7422rt (26:7422 IRS: Refund Taxes)",
      "26:7422rx" : "26:7422rx (26:7422 IRS: Refund Excise Tax)",
      "26:7426" : "26:7426 (26:7426 IRS: Wrongful Levy for Taxes)",
      "26:7429" : "26:7429 (26:7429 IRS: Tax Jeopardy Assessment)",
      "26:7609" : "26:7609 (26:7609 IRS: Petition to Quash IRS Summons)",
      "27:0185" : "27:0185 (27:185 Enforcement of Arbitration Award)",
      "28:0157c" : "28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)",
      "28:0157d" : "28:0157d (28:0157 Motion for Withdrawal of Reference)",
      "28:0158" : "28:0158 (28:0158 Notice of Appeal re Bankruptcy Matter (BA)",
      "28:0185" : "28:0185 (28:185 Suit to Compel Arbitration)",
      "28:0451" : "28:0451 (28:451 Employment Discrimination)",
      "28:0754" : "28:0754 (28:754 Receiver of Property in Different Districts )",
      "28:0794" : "28:0794 (28:794 Rehabilitation Act)",
      "28:1001" : "28:1001 (28:1001 E.R.I.S.A.)",
      "28:1132" : "28:1132 (28:1132 E.R.I.S.A.)",
      "28:1330" : "28:1330 (28:1330 Breach of Contract)",
      "28:1331" : "28:1331 (28:1331 Fed. Question)",
      "28:1331al" : "28:1331al (28:1331 Fed. Question: Airline Crash)",
      "28:1331at" : "28:1331at (28:1331 Fed. Question: Anti-trust)",
      "28:1331au" : "28:1331au (28:1331 Fed. Question: Auto Negligence)",
      "28:1331b" : "28:1331b (28:1331 Federal Question: Bivens Act)",
      "28:1331bc" : "28:1331bc (28:1331 Fed. Question: Breach of Contract)",
      "28:1331ca" : "28:1331ca (28:1331 Fed Question: Fed Communications Act of 1)",
      "28:1331cm" : "28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)",
      "28:1331cv" : "28:1331cv (28:1331 Federal Question: Other Civil Rights)",
      "28:1331ed" : "28:1331ed (28:1331 Fed. Question: Employment Discrimination)",
      "28:1331ej" : "28:1331ej (28:1331 Federal Question: Enforcement of Judgment )",
      "28:1331es" : "28:1331es (28:1331 Enforcement of Administrative Subpoena)",
      "28:1331fl" : "28:1331fl (28:1331 Fed. Question: Fair Labor Standards)",
      "28:1331in" : "28:1331in (28:1331 Fed. Question: Insurance Contract)",
      "28:1331mm" : "28:1331mm (28:1331 Fed. Question: Medical Malpractice)",
      "28:1331ng" : "28:1331ng (28:1331 Fed. Question: Natural Gas Act )",
      "28:1331pi" : "28:1331pi (28:1331 Fed. Question: Personal Injury)",
      "28:1331rd" : "28:1331rd (28:1331 Fed. Question: Review Agency Decision)",
      "28:1331rp" : "28:1331rp (28:1331(a) Fed. Question: Real Property)",
      "28:1331rr" : "28:1331rr (28:1331 Fed. Question: Railway Labor Act)",
      "28:1331sv" : "28:1331sv (28:1331 Fed. Question: Securities Violation)",
      "28:1331tr" : "28:1331tr (28:1331 Fed. Question: Trademark)",
      "28:1331tt" : "28:1331tt (28:1331 Fed. Question: Tort Action)",
      "28:1331v" : "28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendme)",
      "28:1331wl" : "28:1331wl (28:1331 Federal Question: EPA Waste Lien)",
      "28:1331wt" : "28:1331wt (28:1331 Fed. Question: Water Rights)",
      "28:1332ac" : "28:1332ac (28:1332 Diversity-Account Receivable)",
      "28:1332al" : "28:1332al (28:1332 Diversity-Airline Crash)",
      "28:1332as" : "28:1332as (28:1332 Diversity-Asbestos Litigation)",
      "28:1332au" : "28:1332au (28:1332 Diversity-Auto Negligence)",
      "28:1332bc" : "28:1332bc (28:1332 Diversity-Breach of Contract)",
      "28:1332co" : "28:1332co (28:1332 Diversity-Conversion)",
      "28:1332ct" : "28:1332ct (28:1332 Diversity-(Citizenship))",
      "28:1332det" : "28:1332det (28:1332 Diversity: Forcible Detainer)",
      "28:1332df" : "28:1332df (28:1332 Diversity-Contract Default)",
      "28:1332ds" : "28:1332ds (28:1332 Diversity-Contract Dispute)",
      "28:1332ed" : "28:1332ed (28:1332 Diversity-Employment Discrimination)",
      "28:1332fd" : "28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)",
      "28:1332fr" : "28:1332fr (28:1332 Diversity-Fraud)",
      "28:1332ia" : "28:1332ia (28:1332 Diversity-Interpleader Action)",
      "28:1332ij" : "28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)",
      "28:1332in" : "28:1332in (28:1332 Diversity-Insurance Contract)",
      "28:1332jd" : "28:1332jd (28:1332 Diversity-Declaratory Judgement)",
      "28:1332lb" : "28:1332lb (28:1332 Diversity-Libel,Assault,Slander)",
      "28:1332lm" : "28:1332lm (28:1332 Diversity - Legal Malpractice)",
      "28:1332ma" : "28:1332ma (28:1332 Diversity-Miller Act)",
      "28:1332mm" : "28:1332mm (28:1332 Diversity-Medical Malpractice)",
      "28:1332mv" : "28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)",
      "28:1332ni" : "28:1332ni (28:1332 Diversity-Negotiable Instrument)",
      "28:1332nm" : "28:1332nm (28:1332 Diversity-Non-Motor Vehicle)",
      "28:1332nr" : "28:1332nr (28:1332 Diversity-Notice of Removal )",
      "28:1332oc" : "28:1332oc (28:1332 Diversity-Other Contract)",
      "28:1332pd" : "28:1332pd (28:1332 Diversity-Property Damage)",
      "28:1332pi" : "28:1332pi (28:1332 Diversity-Personal Injury)",
      "28:1332pl" : "28:1332pl (28:1332 Diversity-Product Liability)",
      "28:1332pr" : "28:1332pr (28:1332 Diversity-Petition for Removal)",
      "28:1332qt" : "28:1332qt (28:1332 Diversity-Petition to Quiet Title)",
      "28:1332ri" : "28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)",
      "28:1332sa" : "28:1332sa (28:1332 - Diversity: Securities & Exchange Commiss)",
      "28:1332sf" : "28:1332sf (28:1332 - Diversity: Securities Fraud)",
      "28:1332ss" : "28:1332ss (28:1332 Diversity - Stockholders Suits)",
      "28:1332tl" : "28:1332tl (28:1332 Diversity-Torts to Land)",
      "28:1332tm" : "28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))",
      "28:1332tn" : "28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)",
      "28:1332wd" : "28:1332wd (28:1332 Diversity-Wrongful Death)",
      "28:1333" : "28:1333 (28:1333 Admiralty)",
      "28:1334" : "28:1334 (28:1334 Bankruptcy Appeal)",
      "28:1334c" : "28:1334c (28:1334(c) R&R re motions for abstention (non-cor)",
      "28:1335" : "28:1335 (28:1335 Interpleader Action)",
      "28:1337" : "28:1337 (28:1337 Sherman-Clayton Act)",
      "28:1338cp" : "28:1338cp (28:1338 Copyright Infringement)",
      "28:1338pt" : "28:1338pt (28:1338 Patent Infringement)",
      "28:1338tr" : "28:1338tr (28:1338 Trademark Infringement)",
      "28:1340" : "28:1340 (28:1340 IRS: Custom Duties)",
      "28:1340er" : "28:1340er (28:1340 Recovery of Erroneous Refund)",
      "28:1341" : "28:1341 (28:1341 Complaint for Forfeiture)",
      "28:1343" : "28:1343 (28:1343 Violation of Civil Rights)",
      "28:1345" : "28:1345 (28:1345 USA Plaintiff )",
      "28:1345co" : "28:1345co (28:1345 Replevin & Conversion)",
      "28:1345db" : "28:1345db (28:1345 Debt to US - FHA/HUD Title I)",
      "28:1345df" : "28:1345df (28:1345 Default of Promissory Note)",
      "28:1345er" : "28:1345er (28:1345 Recovery of Erroneous Refund)",
      "28:1345fc" : "28:1345fc (28:1345 Foreclosure)",
      "28:1345ff" : "28:1345ff (28:1345 Complaint for Forfeiture)",
      "28:1345hl" : "28:1345hl (28:1345 VA Home Loan Guaranty Debt)",
      "28:1345mc" : "28:1345mc (28:1345 Medical Care Recovery)",
      "28:1345mi" : "28:1345mi (28:1345 Mining Claim Ejectment)",
      "28:1345pd" : "28:1345pd (28:1345 Property Damage)",
      "28:1345pe" : "28:1345pe (28:1345 Property Ejectment)",
      "28:1345rc" : "28:1345rc (28:1345 Recovery of Debt to US)",
      "28:1345st" : "28:1345st (28:1345 Default of Student Loan)",
      "28:1345tp" : "28:1345tp (28:1345 Trespass on Public Land)",
      "28:1345va" : "28:1345va (28:1345 Recovery of VA Overpayment)",
      "28:1346bc" : "28:1346bc (28:1346 Breach of Contract)",
      "28:1346rc" : "28:1346rc (28:1346 Recovery of IRS Tax)",
      "28:1346tc" : "28:1346tc (28:1346 Tort Claim)",
      "28:1346wd" : "28:1346wd (28:1346 Wrongful Death)",
      "28:1349" : "28:1349 (28:1348 Corporation organized under Federal Law as party )",
      "28:1352" : "28:1352 (28:1352 Miller Act)",
      "28:1355" : "28:1355 (28:1355 Petition for Return of Property)",
      "28:1358" : "28:1358 (28:1358 Land Condemnation)",
      "28:1361" : "28:1361 (28:1361 Petition for Writ of Mandamus)",
      "28:1362ic" : "28:1362ic (28:1362 Indian Tribal Controversy)",
      "28:1362iw" : "28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)",
      "28:1364" : "28:1364 (28:1364 Auto Negligence)",
      "28:1391" : "28:1391 (28:1391 Personal Injury)",
      "28:1402" : "28:1402 (28:1402 Medical Malpractice)",
      "28:1407" : "28:1407 (28:1407 Airline Crash)",
      "28:1441ac" : "28:1441ac (28:1441 Petition for Removal- Account Receivable)",
      "28:1441al" : "28:1441al (28:1441 Petition for Removal- Airline Crash)",
      "28:1441as" : "28:1441as (28:1441 Petition for Removal- Asbestos Litigation)",
      "28:1441au" : "28:1441au (28:1441 Petition for Removal- Auto Negligence)",
      "28:1441bc" : "28:1441bc (28:1441 Petition for Removal- Breach of Contract)",
      "28:1441cv" : "28:1441cv (28:1441 Petition for Removal- Civil Rights Act)",
      "28:1441df" : "28:1441df (28:1441 Petition for Removal- Contract Default)",
      "28:1441dj" : "28:1441dj (28:1441 Petition for Removal- Declaratory Judgemen)",
      "28:1441ds" : "28:1441ds (28:1441 Petition for Removal- Contract Dispute)",
      "28:1441ed" : "28:1441ed (28:1441 Petition for Removal - Employment Discrim)",
      "28:1441fc" : "28:1441fc (28:1441 Petition for Removal - Fair Credit Reporti)",
      "28:1441fr" : "28:1441fr (28:1441 Petition for Removal- Fraud)",
      "28:1441ij" : "28:1441ij (28:1441 Petition for Removal- Injunctive/Declarato)",
      "28:1441in" : "28:1441in (28:1441 Petition for Removal- Insurance Contract)",
      "28:1441int" : "28:1441int (28:1441 Petition for Removal- Action for Interplea)",
      "28:1441lb" : "28:1441lb (28:1441 Petition for Removal Libel,Assault,Slander)",
      "28:1441lm" : "28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relatio)",
      "28:1441mm" : "28:1441mm (28:1441 Petition for Removal- Medical Malpractice)",
      "28:1441ni" : "28:1441ni (28:1441 Petition for Removal- Negotiable Instrumen)",
      "28:1441nm" : "28:1441nm (28:1441 Petition for Removal- Non-Motor Vehicle)",
      "28:1441nr" : "28:1441nr (28:1441 Notice of Removal )",
      "28:1441oc" : "28:1441oc (28:1441 Petition For Removal--Other Contract)",
      "28:1441pd" : "28:1441pd (28:1441 Petition for Removal- Property Damage)",
      "28:1441pi" : "28:1441pi (28:1441 Petition for Removal- Personal Injury)",
      "28:1441pl" : "28:1441pl (28:1441 Petition for Removal- Product Liability)",
      "28:1441pr" : "28:1441pr (28:1441 Petition for Removal)",
      "28:1441qt" : "28:1441qt (28:1441 Petition for Removal- Petition to Quiet Ti)",
      "28:1441ri" : "28:1441ri (28:1441 Petition for Removal- Racketeering (RICO))",
      "28:1441sa" : "28:1441sa (28:1441 - Petition for Removal: SEC Act)",
      "28:1441sf" : "28:1441sf (28:1441 - Petition for Removal: Securities Fraud)",
      "28:1441tl" : "28:1441tl (28:1441 Petition for Removal- Torts to Land)",
      "28:1441tm" : "28:1441tm (28:1441 Petition for Removal- Tort/Motor Vehicle ()",
      "28:1441tn" : "28:1441tn (28:1441 Petition for Removal- Tort/Non-Motor Vehic)",
      "28:1441wd" : "28:1441wd (28:1441 Petition for Removal- Wrongful Death)",
      "28:1442bc" : "28:1442bc (28:1442 Petition for Removal- Breach of Contract)",
      "28:1442nr" : "28:1442nr (28:1442 Notice of Removal )",
      "28:1442pr" : "28:1442pr (28:1442 Petition for Removal)",
      "28:1443" : "28:1443 (28:1443(1) Rent, Lease & Ejectment)",
      "28:1444" : "28:1444 (28:1444 Petition for Removal- Foreclosure)",
      "28:1446in" : "28:1446in (28:1446 Breach of Contract- Insurance)",
      "28:1446nr" : "28:1446nr (28:1446 Notice of Removal )",
      "28:1446pd" : "28:1446pd (28:1446 Petition for Removal- Property Damage (P.I)",
      "28:1446pi" : "28:1446pi (28:1446 Petition for Removal- Personal Injury)",
      "28:1446pl" : "28:1446pl (28:1446pl Petition for Removal - Product Liability)",
      "28:1446pr" : "28:1446pr (28:1446 Petition for Removal)",
      "28:1452" : "28:1452 (28:1452 R&R re motions to remand (non-core))",
      "28:1651" : "28:1651 (28:1651 Petition for Writ of Coram Nobis)",
      "28:1651hc" : "28:1651hc (28:1651 Petition for Writ of Habeas Corpus)",
      "28:1651mn" : "28:1651mn (28:1651 Petition for Writ of Mandamus)",
      "28:1782" : "28:1782 (28:1782 Letter rogatory - appointment )",
      "28:1983" : "28:1983 (28:1983 Civil Rights)",
      "28:2201" : "28:2201 (28:2201 Constitutionality of State Statute(s))",
      "28:2201dj" : "28:2201dj (28:2201 Declaratory Judgement)",
      "28:2201ij" : "28:2201ij (28:2201 Injunction)",
      "28:2201in" : "28:2201in (28:2201 Declaratory Judgement (Insurance))",
      "28:2241" : "28:2241 (28:2241 Petition for Writ of Habeas Corpus (federa)",
      "28:2254" : "28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))",
      "28:2254se" : "28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)",
      "28:2255" : "28:2255 (28:2255 Motion to Vacate / Correct Illegal Sentenc)",
      "28:2271" : "28:2271 (28:2271 Federal Tort Claims Act)",
      "28:2345" : "28:2345 (28:2345 Medicare Recovery)",
      "28:2409" : "28:2409 (28:2409(a) Quiet Title Action)",
      "28:2410" : "28:2410 (28:2410 Quiet Title)",
      "28:2671" : "28:2671 (28:2671 Federal Tort Claims Act)",
      "28:2674" : "28:2674 (28:2674 Federal Tort Claims Act)",
      "28:3001" : "28:3001 (28:3001 Federal Debt Collection Act )",
      "28:7402" : "28:7402 (28:7402 Refund of Taxes)",
      "28:7422" : "28:7422 (28:7422 Appeal from Administrative Decision)",
      "29:0151" : "29:0151 (29:151 Labor: Review of Agency Action)",
      "29:0160" : "29:0160 (29:160(1) National Labor Relations Act)",
      "29:0184" : "29:0184 (29:184 Violation Collection Bargain Agreement)",
      "29:0185ep" : "29:0185ep (29:185 Employee Pension Plan)",
      "29:0185lm" : "29:0185lm (29:185 Labor/Mgt. Relations (Contracts))",
      "29:0201do" : "29:0201do (29:201 Denial of Overtime Compensation)",
      "29:0201fl" : "29:0201fl (29:201 Fair Labor Standards Act)",
      "29:0203" : "29:0203 (29:203 Equal Pay Act)",
      "29:0206" : "29:0206 (29:206 Collect Unpaid Wages)",
      "29:0401" : "29:0401 (29:0401 Labor Management Disclosure Act)",
      "29:0621" : "29:0621 (29:621 Job Discrimination (Age))",
      "29:0623" : "29:0623 (29:623 Job Discrimination (Age))",
      "29:0626" : "29:0626 (29:626 Job Discrimination (Age))",
      "29:0633" : "29:0633 (29:633 Job Discrimination (Age))",
      "29:0651" : "29:0651 (29:651 Occupational Safety/Health)",
      "29:0754" : "29:0754 (29:754 Discrimination)",
      "29:0791" : "29:0791 (29:791 Job Discrimination (Rehabilitation Act))",
      "29:0794" : "29:0794 (29:0794 Job Discrimination (Handicap))",
      "29:1001" : "29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)",
      "29:1002" : "29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)",
      "29:1104" : "29:1104 (29:1104 Recovery of Benefits to Employee)",
      "29:1109" : "29:1109 (29:1109 Breach of Fiduciary Duties)",
      "29:1131" : "29:1131 (29:1131 ERISA - Collection of Delinquent Trust Fun)",
      "29:1132" : "29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)",
      "29:1145" : "29:1145 (29:1145 E.R.I.S.A.)",
      "29:1149" : "29:1149 (29:1149 Recover Pension & Profit Sharing)",
      "29:1337" : "29:1337 (29:1337 E.R.I.S.A.)",
      "29:1362" : "29:1362 (29:1362 ERISA)",
      "29:1381" : "29:1381 (29:1381 E.R.I.S.A.)",
      "29:1401" : "29:1401 (29:1401(b)(2) Appeal of Arbitration Award)",
      "29:1451" : "29:1451 (29:1451 E.R.I.S.A.)",
      "29:1801" : "29:1801 (29:1801 Farmworker Rights)",
      "29:790" : "29:790 (29:790 Rehabilitation of Labor)",
      "30:0181" : "30:0181 (30:181 Environment: Review of Agency Action)",
      "30:0801" : "30:0801 (30:0801 Penalities/Federal Mine Safety Health Act)",
      "30:1201" : "30:1201 (30:1201 Environment: Review of Agency Action)",
      "30:1202" : "30:1202 (30:1202 Mining Reclamation Act)",
      "30:1276" : "30:1276 (30:1276 Interior: Review of Agency Action)",
      "31:3545" : "31:3545 (31:3545 Action to Recovery Money)",
      "31:3729" : "31:3729 (31:3729 False Claims Act)",
      "31:3730" : "31:3730 (31:3730 Qui Tam False Claims Act)",
      "31:3731" : "31:3731 (31:3731 Fraud)",
      "31:5221" : "31:5221 (31:5221 Foreign Bank Account Penalties)",
      "33:1319cw" : "33:1319cw (33:1319 Clean Water Act)",
      "33:1319pv" : "33:1319pv (33:1319 Pollutants & Permit Violations)",
      "33:1365" : "33:1365 (33:1365 Environmental Matters)",
      "35:0145" : "35:0145 (35:145 Patent Infringement)",
      "35:0183" : "35:0183 (35:183 Patent Infringement)",
      "35:0271" : "35:0271 (35:271 Patent Infringement)",
      "38:1681" : "38:1681 (38:1681 Recovery of VA Overpayment)",
      "38:1686" : "38:1686 (38:1686 Recovery of VA Overpayment)",
      "38:1780" : "38:1780 (38:1780 Recovery of VA Overpayment)",
      "38:2011" : "38:2011 (38:2011 - Veteran's Readjustment Assistance Act of)",
      "38:2021" : "38:2021 (Right to re-employment of inducted persons )",
      "38:3116" : "38:3116 (38:3116 VA Overpayment)",
      "38:775" : "38:775 (Recovery of Servicemen's Group Life Insurance )",
      "39:3005" : "39:3005 (39:3005 Detention of Mail for Temporary Periods)",
      "39:409" : "39:409 (39:409 Postal Service)",
      "40:0258" : "40:0258 (40:258(a) Public Buildings & Property: Land Condem)",
      "40:0270" : "40:0270 (40:270 Miller Act)",
      "40:0875" : "40:0875 (40:875 Public Buildings & Property: Negligence)",
      "41:0251" : "41:0251 (41:251 Public Contracts-Review of Agency Action)",
      "41:1463" : "41:1463 (41:1463 Public Contracts: Unlawful Employment Prac)",
      "42:0205" : "42:0205 (42:205 Denial Social Security Benefits)",
      "42:0206" : "42:0206 (42:206 Social Security Benefits)",
      "42:0247" : "42:0247 (42:247 Personal Injury-Swine Flu)",
      "42:0402" : "42:0402 (42:402 Social Security Benefits)",
      "42:0405id" : "42:0405id (42:405 Review of HHS Decision (SSID))",
      "42:0405wc" : "42:0405wc (42:405 Review of HHS Decision (DIWC))",
      "42:0405ww" : "42:0405ww (42:405 Review of HHS Decision (DIWW))",
      "42:0416" : "42:0416 (42:416 Denial of Social Security Benefits)",
      "42:0427" : "42:0427 (42:427 Social Security Benefits)",
      "42:11601" : "42:11601 (42:11601 - INTERNATIONAL CHILD ABDUCTION REMEDIES)",
      "42:1201" : "42:1201 (42:1201 Civil Rights (Disability) )",
      "42:1383" : "42:1383 (42:1383 Review of HHS Decision)",
      "42:1395" : "42:1395 (42:1395 HHS: Adverse Reimbursement Review)",
      "42:1396" : "42:1396 (42:1396 - Tort Negligence)",
      "42:1471" : "42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclo)",
      "42:1981cv" : "42:1981cv (42:1981 Civil Rights)",
      "42:1981hs" : "42:1981hs (42:1981 Housing Discrimination)",
      "42:1981jb" : "42:1981jb (42:1981 Job Discrimination (Race))",
      "42:1981sx" : "42:1981sx (42:1981 Sex Discrimination)",
      "42:1983cv" : "42:1983cv (42:1983 Civil Rights Act)",
      "42:1983ed" : "42:1983ed (42:1983 Civil Rights (Employment Discrimination))",
      "42:1983pr" : "42:1983pr (42:1983 Prisoner Civil Rights)",
      "42:1986" : "42:1986 (42:1986 Neglect of Duty)",
      "42:2000ag" : "42:2000ag (42:2000 Job Discrimination (Age))",
      "42:2000e" : "42:2000e (42:2000e Job Discrimination (Employment))",
      "42:2000pb" : "42:2000pb (42:2000 Job Discrimination (Public Accomodations))",
      "42:2000ra" : "42:2000ra (42:2000 Job Discrimination (Race))",
      "42:2000sx" : "42:2000sx (42:2000 Job Discrimination (Sex))",
      "42:2003" : "42:2003 (42:2003 Job Discrimination)",
      "42:2005" : "42:2005 (42:2005 Review of Agency Action-HHS)",
      "42:2615" : "42:2615 (42:2615 Medical Recovery Act )",
      "42:2651" : "42:2651 (42:2651 Medical Care Recovery)",
      "42:3601" : "42:3601 (42:405 Fair Housing Act)",
      "42:4000" : "42:4000 (42:4000 National Flood Insurance Act)",
      "42:4001" : "42:4001 (42:4001 National Insurance Flood Act)",
      "42:4053" : "42:4053 (42:4053 Breach of Insurance Contract)",
      "42:4072" : "42:4072 (42:4072 Payment of Flood Insurance Claim)",
      "42:4321" : "42:4321 (42:4321 Review of Agency Action-Environment)",
      "42:4332" : "42:4332 (42:4332 Environmental Policy - Coop of Agency Repo)",
      "42:6901en" : "42:6901en (42:6901 Environmental Cleanup Expenses)",
      "42:6901rs" : "42:6901rs (42:6901 Resource & Recovery Act)",
      "42:7413" : "42:7413 (42:7413(b) Clean Air Act)",
      "42:7604cl" : "42:7604cl (42:7604 Clear Air Act (Emission Standards))",
      "42:7604ir" : "42:7604ir (42:7604 Petition to Quash IRS Summons)",
      "42:9607" : "42:9607 (42:9607 Real Property Tort to Land)",
      "43:945" : "43:945 (43:945 Compensation for Land Condemnation)",
      "43:945a" : "43:945a (43:945a Complaint in Condemnation)",
      "43:946" : "43:946 (43:946 Complaint in Condemnation - Eminent Domain)",
      "45:0051" : "45:0051 (45:51 Railways: Fed. Employer's Liability Act)",
      "45:0151" : "45:0151 (45:151 Railway Labor Act)",
      "45:0184" : "45:0184 (45:184 Action to Set Aside Award of a System Board)",
      "45:1395" : "45:1395 (45:1395 Railroads: Adverse Reimbursement Review)",
      "45:7457" : "45:7457 (45:7457 Compel Reclamation Under Clear Air Act)",
      "46:0688" : "46:0688 (46:688 Jones Act)",
      "46:0741" : "46:0741 (46:741 Shipping)",
      "46:0761" : "46:0761 (46:761 Shipping: Damages for Death on High Seas)",
      "46:1101" : "46:1101 (46:1101 Violation of Maritime Regulations)",
      "46:1156" : "46:1156 (46:1156 Administrative Procedure Act)",
      "47:227b3" : "47:227b3 (47:227(b)(3) Telephone Consumer Protection Act of 1991)",
      "47:605" : "47:605 (47:605 Unauthorized publication or use of communications)",
      "48:0883" : "48:0883 (48:883 Violation of US Coastal Law)",
      "48:1985" : "48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)",
      "49:0081" : "49:0081 (49:81 Damaged Goods While Being Transported)",
      "49:0781" : "49:0781 (49:781 Forfeiture)",
      "49:11503" : "49:11503 (49:11503 Railroad Revitalization Regulatory Reform)",
      "49:11702" : "49:11702 (49:11702(a)(4) Violations of Interstate Commerce A)",
      "49:1471" : "49:1471 (49:1471 Federal Aviation Act)",
      "49:1903" : "49:1903 (49:1903 Petition to enforce administrative summon)",
      "8:287" : "8:287 (08:287 Petition to Enforce INS Subpoena)",
      "99:9999" : "99:9999 (99:9999 Report cause code (DO NOT DELETE) )",
      "adsup" : "adsup (Administrative Subpoena )",
      "contempt" : "contempt (Contempt Proceedings )",
      "disbar" : "disbar (Disbarment Proceedings )",
      "discpro" : "discpro (Disciplinary Proceedings )",
      "fordepo" : "fordepo (Foreign Deposition )",
      "motcomp" : "motcomp (Motion to Compel)",
      "motquash" : "motquash (Motion to Quash)",
      "motret" : "motret (Motion for Return of Property)",
      "petenf" : "petenf (Petition to Enforce IRS Summons )",
      "petper" : "petper (Petition to Perpetuate Testimony )",
      "regjgm" : "regjgm (Registration of Foreign Judgment )",
      "tranbkref" : "tranbkref (Transmission of Bankruptcy Reference )",
      "tranff" : "tranff (Transmission of Proposed Findings of Fact and Concl. of Law )",
      "writgar" : "writgar (Application for a Writ of Garnishment )"
   },
   "nyndce" : {
      "0" : "0 (No cause code entered)",
      "02:0138" : "02:0138 (02:0138 Library of Congress Access)",
      "02:0358" : "02:0358 (02:0358 President's Recommendations on Exec., Jud. & Leg. Salary)",
      "02:0431" : "02:0431 (02:431 Federal Election Commission: Failure Enforce Compliance)",
      "02:0437" : "02:0437 (02:437 Federal Election Commission)",
      "02:0681" : "02:0681 (02:0681 Deferral of Budget Authority)",
      "02:1202" : "02:1202 (02:1202 Discriminatory practices affecting US Senate employees)",
      "02:1301" : "02:1301 (02:1301 Congressional Accountability Act)",
      "02:1317a" : "02:1317a (02:1317(a) Violation of Congressional Accountability Act)",
      "05:0075" : "05:0075 (05:75(2) Contract - Reduction in Grade)",
      "05:0101" : "05:0101 (05:0101 Ethics in Government Act)",
      "05:0504c2" : "05:0504c2 (05:0504(c)(2) Equal Access to Justice (Govt Employees))",
      "05:0551" : "05:0551 (05:551 Administrative Procedures Act)",
      "05:0552bsa" : "05:0552bsa (05:0552b(g) Implement requirements of Govt in Sunshine Act)",
      "05:0552fi" : "05:0552fi (05:552 Freedom of Information Act)",
      "05:0552pa" : "05:0552pa (05:552 Right to Privacy Act)",
      "05:0554" : "05:0554 (05:0554 Adjudications Required by Statutes)",
      "05:0555b" : "05:0555b (05:0555(b) Agency Decision - Right to Counsel)",
      "05:0701" : "05:0701 (05:0701 Judicial Review of Agency Decision)",
      "05:0702" : "05:0702 (05:702 Administrative Procedure Act - Right of Review)",
      "05:0704" : "05:0704 (05:704 Labor Litigation)",
      "05:0706" : "05:0706 (05:0706 Judicial Review of Agency Action)",
      "05:1508" : "05:1508 (05:1508 Judicial Review of Order Issued by the Merit Systems Protection Board)",
      "05:2302" : "05:2302 (05:2302 Federal Whistleblowing Act / Civil Service Reform Act (CSRA))",
      "05:3318" : "05:3318 (05:3318 Veterans Preference Act)",
      "05:5514" : "05:5514 (05:5514 Debt Collection Act of 1982)",
      "05:5542" : "05:5542 (05:5542 Federal Employees Pay Act -- overtime rates)",
      "05:7101" : "05:7101 (05:7101 Labor-Management Relations (Findings and Purpose))",
      "05:7123" : "05:7123 (05:7123 Petition by FLRA against unfair labor practices)",
      "05:7501" : "05:7501 (05:7501 Government Employees Adverse Action--14 days or less)",
      "05:7511" : "05:7511 (05:7511 Government Employees Adverse Action--Over 14 days)",
      "05:7703" : "05:7703 (05:7703 Discrimination - Review of Agency Act)",
      "05:8101" : "05:8101 (05:8101 Workmen's Compensation Benefits)",
      "05:8110" : "05:8110 (05:8110 Augmented Compensation for dependents of Govt. Employees)",
      "05:8316" : "05:8316 (05:8316 Claims against US regarding Retirement for Federal Employees)",
      "05:8470" : "05:8470 (05:8470 Enforcement of Judgment against Retirement Benefits)",
      "05:8701" : "05:8701 (05:8701 Federal Employees Group Life Insurance Act of 1954)",
      "05:8705" : "05:8705 (05:8705 Declaratory Judgment - Insurance)",
      "05:8715" : "05:8715 (05:8715 Claims against the US - Jurisdiction of Courts)",
      "05:8901" : "05:8901 (05:8901 Federal Employees Health Benefits Act)",
      "05:8902" : "05:8902 (05:8902 Contracting Authority of OPM - Group Health Insurance)",
      "05:8903" : "05:8903 (05:8903 Federal Employees Health Benefit Act)",
      "05:8912" : "05:8912 (05:8912 Claims against US regarding health benefits for Federal employees)",
      "07:0001" : "07:0001 (07:0001 Commodity Exchange Act)",
      "07:0006" : "07:0006 (7:6(b) Federal Commodity Exchange Regulation)",
      "07:0009a" : "07:0009a (07:0009a Recovery of penalties by Commodity Futures Trading Comm)",
      "07:0013a" : "07:0013a (07:0013a Contract market rules violations; recovery of penalty)",
      "07:0013a-1" : "07:0013a-1 (07:0013a-1 Enjoin or restrain violations Contract Market rules)",
      "07:0025" : "07:0025 (7:25 Fraud - Commodities Leverage Contracts)",
      "07:0087" : "07:0087 (07:0087 Enforcement of United States Grain Standards Act)",
      "07:0136" : "07:0136 (07:0136 Violations of EPA re Environmental Pesticide Control)",
      "07:0181" : "07:0181 (07:181 Packers & Stockyards Act)",
      "07:0193b" : "07:0193b (07:0193(b) Recovery of penalties re violations by packers)",
      "07:0203" : "07:0203 (07:0203 Recovery of penalties for violations by stockyards)",
      "07:0209(b)" : "07:0209(b) (07:0209(b) Violations re purchase, sale, handling of livestock)",
      "07:0210(f)" : "07:0210(f) (07:0210(f) Suit to enforce award of damages (Packers/Stockyards))",
      "07:0213(b)" : "07:0213(b) (07:0213(b) Unfair, discriminatory, deceptive practice/marketing)",
      "07:0216" : "07:0216 (07:0216 Injunctions to restrain & enforce orders of Secretary)",
      "07:0222" : "07:0222 (07:0222 Adoption of FTC powers for enforcement)",
      "07:0228a" : "07:0228a (07:0228a Request by Secretary for TRO or Inj. re Poultry)",
      "07:0245" : "07:0245 (07:0245 Action on bond by person injured in Warehouse)",
      "07:0292" : "07:0292 (07:0292 Monopolizing or restraining trade & enhancing prices)",
      "07:0499" : "07:0499 (07:499 Agricultural Commodities Act)",
      "07:0499Ec4" : "07:0499Ec4 (07:0499E(c)(4) Perishable Agricultural Commodities Act (PACA))",
      "07:0601" : "07:0601 (07:601 USDA Condemnation)",
      "07:0608" : "07:0608 (07:0608 Agriculture Adjustment Act)",
      "07:0901" : "07:0901 (07:0901 Rural Electrification Act)",
      "07:1291(b)" : "07:1291(b) (07:1291(b) Agricultural Adjustment Act; freight rates)",
      "07:1376" : "07:1376 (07:1376 Adjustment of Quotas and Enforcement; penalties)",
      "07:1501" : "07:1501 (07:1501 Federal Crop Insurance Act)",
      "07:1508" : "07:1508 (07:1508 Crop Insurance)",
      "07:1631" : "07:1631 (07:1631 Food Security Act)",
      "07:1721" : "07:1721 (07:1721 Agricultural Trade Development Asst Act)",
      "07:1922" : "07:1922 (07:1922 Persons Eligible for Loans - Foreclosure)",
      "07:1926" : "07:1926 (07:1926 Water and Waste Facility Loans and Grants)",
      "07:1930" : "07:1930 (07:1930 Perishable Agric. Comm. Act of 1930)",
      "07:2011" : "07:2011 (07:2011 Supplemental Nutrition Assistance Program)",
      "07:2022" : "07:2022 (07:2022 Disposition of Claims: Denial application to participate; food stamp prog.)",
      "07:2023" : "07:2023 (07:2023 Supplemental Nutrition Assistance Program)",
      "07:2023(a)" : "07:2023(a) (07:2023(a) Judicial Review of Food Stamp Disqualification)",
      "07:2024" : "07:2024 (07:2024 False Claims Act, Food Stamp Fraud)",
      "07:2131" : "07:2131 (07:2131 Violation of the Animal Welfare Act)",
      "07:2146" : "07:2146 (07:2146 Transportation, Sale, and Handling of Animals)",
      "07:2301" : "07:2301 (07:2301 Agricultural Fair Practices Act)",
      "07:2305" : "07:2305 (07:2305 Unfair trade practices affecting producers Agri prod)",
      "07:2321" : "07:2321 (07:2321 Plant Variety Protection Act)",
      "07:2563" : "07:2563 (07:2563 Plant Variety Protection and Rights - Injunction)",
      "07:6999" : "07:6999 (07:6999 Judicial Review of Adverse Farm Agency Decision)",
      "08:1101" : "08:1101 (08:1101 Immigration & Nationality Act (Definitions))",
      "08:1105" : "08:1105 (08:1105a Immigration: Judicial Review for Battered Spouses; Deportation (INS))",
      "08:1152" : "08:1152 (08:1152 Immigration: Numerical limitations on individual foreign states)",
      "08:1153" : "08:1153 (08:1153 Immigration: Allocation of Immigrant Visas)",
      "08:1154" : "08:1154 (08:1154 Immigration: Procedure for Granting Immigration Status)",
      "08:1158" : "08:1158 (08:1158 Immigration & Nationality Act, Section 208 (Asylum))",
      "08:1182" : "08:1182 (8:1182 Defend. Denial of Pla. Appl. for Alien Employment Cer)",
      "08:1183" : "08:1183 (08:1183 Admission of Aliens on Giving Bond or Undertaking; Return on Departure)",
      "08:1183a" : "08:1183a (08:1183a Requirements for sponsor's affidavit of support)",
      "08:1188" : "08:1188 (08:1188 Immigration: Admission of Temporary H-2A Workers)",
      "08:1225" : "08:1225 (08:1225 Immigration: Enforcement of Administrative Subpoena)",
      "08:1231a6" : "08:1231a6 (08:1231(a)(6) Immigration: Due Process Clause)",
      "08:1251a4" : "08:1251a4 (08:1251(A)(4) Immigration: Application for a Stay of Deportation)",
      "08:1252" : "08:1252 (08:1252 Judicial Review of Orders of Removal)",
      "08:1255" : "08:1255 (08:1255 Immigration: Failure USCIS to Adjudicate Permanent Residency Petition)",
      "08:1260" : "08:1260 (08:1260 Aliens: Removal of Aliens Falling into Distress)",
      "08:1324" : "08:1324 (08:1324 Immigration: Complaint for Forfeiture)",
      "08:1329" : "08:1329 (08:1329 Immigration: Writ of Mandamus to Adjudicate Visa Petition)",
      "08:1357" : "08:1357 (08:1357 Immigration and Nationality Act - Administrative Search Warrant)",
      "08:1421" : "08:1421 (08:1421 Immigration: Naturalization Authority)",
      "08:1445" : "08:1445 (08:1445 Immigration: Application for Naturalization)",
      "08:1446" : "08:1446 (08:1446 Immigration: Petition for Naturalization Hearing)",
      "08:1447" : "08:1447 (08:1447 Immigration: Review of Denial of Naturalization Application)",
      "08:1451" : "08:1451 (08:1451 Immigration: Revocation of Citizenship)",
      "08:1451(a)" : "08:1451(a) (08:1451(a) Action to revoke Citizenship)",
      "08:1451(j)" : "08:1451(j) (8:1451(j) Immigration: Motion to Correct Order & Judg. of Naturalization)",
      "09:0001" : "09:0001 (09:1 U.S. Arbitration Act)",
      "09:0003" : "09:0003 (09:0003 Application to Stay Proceedings Pending Arbitration)",
      "09:0004" : "09:0004 (09:0004 Petition to order arbitration; failure to arbitrate)",
      "09:0007" : "09:0007 (09:0007 Petition to compel attendance before arbitrator)",
      "09:0008" : "09:0008 (09:0008 Declaratory Judgment/Admiralty)",
      "09:0009" : "09:0009 (9:9 Motion to Confirm Arbitration Loan)",
      "09:0010" : "09:0010 (09:0010 Petition to Vacate Arbitration Award)",
      "09:0011" : "09:0011 (09:0011 Motion to modify or correct arbitration award)",
      "09:0201" : "09:0201 (09:0201 Petition to Compel/Stay Arbitration under an Insurance Contract)",
      "09:0202" : "09:0202 (09:0202 Award under Convention on Foreign Arbitral Awards)",
      "09:0205" : "09:0205 (09:0205 Removal from State Court: Enforcement of Foreign Arbitral Awards)",
      "09:0207" : "09:0207 (09:0207 Application for order confirming award of arbitrators)",
      "10:0672" : "10:0672 (10:0672 Armed Forces: Active Guard/Reserve (AGR) Program)",
      "10:1006" : "10:1006 (10:1006 Armed Forces: Review of Agency Decision)",
      "10:1072tc" : "10:1072tc (10:1072tc Armed Forces: TRICARE PROGRAM)",
      "10:1089(c)" : "10:1089(c) (10:1089(c) Armed Forces: Removal; dft acting in scope of duties)",
      "10:1091" : "10:1091 (10:1091 Armed Forces: Personal Service Contracts)",
      "10:1107" : "10:1107 (10:1107 Armed Forces: Use Of Investigational New Drug)",
      "10:1408" : "10:1408 (10:1408 Armed Forces: Claim for Military Retirement)",
      "10:1552" : "10:1552 (10:1552 Armed Forces: Action to Correct Records)",
      "10:1553" : "10:1553 (10:1553 Armed Forces: Review of Discharge or Dismissal)",
      "10:2005" : "10:2005 (10:2005 Armed Forces: Advanced Education Assistance)",
      "10:2121" : "10:2121 (10:2121 Armed Forces: Health Professions Scholarship Financial Asst Prog)",
      "10:2302" : "10:2302 (10:2302 Armed Forces: Arms Services Procurement Act)",
      "10:2305" : "10:2305 (10:2305 Armed Forces: Review of Federal Contract)",
      "10:2323fa" : "10:2323fa (10:2323fa Armed Forces: Fifth Amdmt Equal Protection: Contract Goal for Small Disadvantaged Business)",
      "10:2733" : "10:2733 (10:2733 Armed Forces: Military Claims Act)",
      "10:2734" : "10:2734 (10:2734 Armed Forces: Foreign Military Claims Act)",
      "10:2771" : "10:2771 (10:2771 Armed Forces: Final Settlement - Deceased Members)",
      "10:3258" : "10:3258 (10:3258 Armed Forces: Reg. Army: Re-enlistment after Service as Ofcr)",
      "11:0101" : "11:0101 (11:101 Bankruptcy)",
      "11:0110" : "11:0110 (11:110 Bankruptcy: Penalty for Preparers of Fraudulent or Negligent Petitions)",
      "11:0362" : "11:0362 (11:362(h) Bankruptcy: Violation of Automatic Stay)",
      "11:0523" : "11:0523 (11:523 Bankruptcy: Exceptions to Discharge)",
      "11:0524" : "11:0524 (11:524 Bankruptcy: Effect of Discharge)",
      "11:0525" : "11:0525 (11:525 Bankruptcy: Protections Against Discriminatory Treatment)",
      "11:0548" : "11:0548 (11:548 Bankruptcy: Fraudulent Transfers and Obligations)",
      "11:0704" : "11:0704 (11:704 Bankruptcy: Duties of Trustee)",
      "12:0022" : "12:0022 (12:22 Securities Fraud)",
      "12:0085" : "12:0085 (12:85 National Banks: Rate of Interest on Loans, Discounts, and Purchases)",
      "12:0093" : "12:0093 (Banks: Violation of Provisions; Forfeiture of Franchise; Personal Liability of Dir)",
      "12:0191" : "12:0191 (12:191 National Banks: Appointment of Receiver)",
      "12:0192" : "12:0192 (12:192 National Banks: Liquidation of National Bank)",
      "12:0215" : "12:0215 (12:215 National Banks: Consolidation and Merger)",
      "12:0622" : "12:0622 (12:622 Foreign Banking: Forfeiture, Dissolution, and Liability of Directors and Officers for Noncomp)",
      "12:0632" : "12:0632 (12:632 Foreign Banking: Voluntary Liquidation)",
      "12:0635" : "12:0635 (12:635i-3 Export-Import Bank: Breach of Insurance Contract)",
      "12:1421" : "12:1421 (12:1421 Federal Home Loan Bank Act (Short Title))",
      "12:1441" : "12:1441 (12:1441 FHLB: Financial Inst Reform Receiving Enforcement Act 1989)",
      "12:1451" : "12:1451 (12:1451 Emergency Home Loan Corporation)",
      "12:1452" : "12:1452 (12:1452 Federal Home Loan Mortgage Corporation Act)",
      "12:1452f" : "12:1452f (12:1452(f) Fed Home Loan Mortgage Corp: Actions by and against the Corporation)",
      "12:1455b" : "12:1455b (12:1455(b) Fed Home Loan Mortgage Corp: Enforcement of Regulations)",
      "12:1461" : "12:1461 (12:1461 Savings Associations: Homeowners Loan Act (Short Title))",
      "12:1464" : "12:1464 (12:1464 Savings Associations: Federal Savings and Loan)",
      "12:1703" : "12:1703 (12:1703 National Housing: Insurance of Financial Institutions)",
      "12:1715b" : "12:1715b (12:1715(b) National Housing: Rules and Regulations)",
      "12:1725" : "12:1725 (12:1725 Collection under Contract Guaranty)",
      "12:1730" : "12:1730 (12:1730 Collection Under Contract Guaranty)",
      "12:1749aaa" : "12:1749aaa (12:1749aaa National Housing: National Insurance Development Program)",
      "12:1751" : "12:1751 (12:1751 Fed Credit Unions: Short Title)",
      "12:1782" : "12:1782 (12:1782 Fed Credit Unions: Administration of Insurance Fund)",
      "12:1786" : "12:1786 (12:1786 Fed Credit Unions: Actions re Violations by Credit Unions)",
      "12:1787aB" : "12:1787aB (12:1787(a)(B) Fed Credit Unions: Liquidation of Insured Credit Union by Board)",
      "12:1789a2" : "12:1789a2 (12:1789(a)(2) Fed Credit Unions: Admin Provision to Sue and be Sued)",
      "12:1811" : "12:1811 (12:1811 FDIC: Financial Inst. Reform Recovery Act of 1989 (FIRREA)(Organization of FDIC))",
      "12:1818" : "12:1818 (12:1818 FDIC: Violations re Federal Deposit Insurance Corporation)",
      "12:1818e" : "12:1818e ()",
      "12:1819" : "12:1819 (12:1819 FDIC: Corporate Powers)",
      "12:1821" : "12:1821 (12:1821 FDIC: Insurance Funds)",
      "12:1831" : "12:1831 (12:1831 FDIC: Separability of Certain Provisions)",
      "12:1831d" : "12:1831d (12:1831(d) FDIC: Deposit. Inst. Dereg. & Monetary Ctrl. Act of 1980)",
      "12:1831r-1" : "12:1831r-1 (12:1831r-1 FDIC: Notice of Branch Closure)",
      "12:1833a" : "12:1833a (12:1833(a) FDIC: Forfeiture Civil Penalties)",
      "12:1954" : "12:1954 (12:1954 Injunctions (Action by Sec of Treasury re financial recordkeeping))",
      "12:1971" : "12:1971 (12:1971 Relief under Bank Holding Act)",
      "12:1972" : "12:1972 (12:1972 Tying Arrangement Act)",
      "12:2001" : "12:2001 (12:2001 Farm Credit Act of 1971)",
      "12:2601" : "12:2601 (12:2601 Real Estate Settlement Procedures Act (RESPA))",
      "12:2604c" : "12:2604c (12:2604(c) Real Estate Settlement Procedures Act (RESPA))",
      "12:2605" : "12:2605 (12:2605 RESPA: Servicing of Mortgage Loans)",
      "12:2607" : "12:2607 (12:2607 RESPA: Violation re kickbacks/unearned fees; Real Estate)",
      "12:2609" : "12:2609 (12:2609 RESPA: Escrow)",
      "12:3012" : "12:3012 (12:3012 National Consumer Cooperative Bank: Suits by or against Bank)",
      "12:3410" : "12:3410 (12:3410 Right to Financial Privacy: Customer Challenges)",
      "12:3751" : "12:3751 (12:3751 Single Family Mortgage Foreclosure Act: Findings and Purpose)",
      "12:3801" : "12:3801 (12:3801 Alternative Mortgage Transaction Parity Act)",
      "12:3907" : "12:3907 (12:3907 International Lending Supervision: Capital Adequacy)",
      "12:4010" : "12:4010 (12:4010 Expedited Funds Availability: Violation of Act (Civil Liability))",
      "12:5101" : "12:5101 (12:5101 Fraudulent Transfer Act (Enforcement for Mortgage Licensing))",
      "15:0001" : "15:0001 (15:1 Antitrust Litigation)",
      "15:0002at" : "15:0002at (15:2 Antitrust Litigation)",
      "15:0002fl" : "15:0002fl (15:2fl Antitrust Litigation)",
      "15:0004" : "15:0004 (15:4 USDC Jurisdiction re violations of Sec. 1-7 of Title 15)",
      "15:0005" : "15:0005 (15:5 Bringing in Additional Parties)",
      "15:0009" : "15:0009 (15:9 USDC Jurisdiction re violations of Sec. 8 of Title 15)",
      "15:0013" : "15:0013 (15:13 Robinson Patman Act)",
      "15:0014" : "15:0014 (15:14 Clayton Act)",
      "15:0015" : "15:0015 (15:15 Antitrust Litigation)",
      "15:0025" : "15:0025 (15:25 Clayton Act)",
      "15:0026" : "15:0026 (15:26 Suit for injunctive relief re violation antitrust laws)",
      "15:0034-35" : "15:0034-35 (15:34-35 Investment Company Act of 1940)",
      "15:0041" : "15:0041 (15:41 Federal Trade Commission Act)",
      "15:0044" : "15:0044 (15:44 Trademark Infringement)",
      "15:0045" : "15:0045 (15:45 Federal Trade Commission Act)",
      "15:0045cp" : "15:0045cp (15:45cp Violation of Children Online Privacy Protection Act)",
      "15:0052" : "15:0052 (15:0052 Federal Trade Commission Act)",
      "15:0053" : "15:0053 (15:53 Federal Trade Commission Act)",
      "15:0053(b)" : "15:0053(b) (15:53(b) Prelim & Perm Inj Relief & other Equitable Relief)",
      "15:0068" : "15:0068 (15:68 Proceedings re FTC violations re wool products)",
      "15:0069" : "15:0069 (15:69 Proceedings re FTC violations re fur products)",
      "15:0070" : "15:0070 (15:70 Proceedings re FTC violations re textile fiber product)",
      "15:0077" : "15:0077 (15:77 Securities Fraud)",
      "15:0078" : "15:0078 (15:78m(a) Securities Exchange Act)",
      "15:0078jbs" : "15:0078jbs (15:78j(b)ss Stockholder Suit)",
      "15:0078ma" : "15:0078ma (15:78m(a) Securities Exchange Act)",
      "15:0079" : "15:0079 (15:79 Public Utility Holding Companies)",
      "15:0080a3" : "15:0080a3 (15:80a-3 Investment Company Act of 1940)",
      "15:0260" : "15:0260 (15:260 Proceedings re weights and measures and standard time)",
      "15:0298" : "15:0298 (15:298 Violation of Law Proceedings re gold or silver)",
      "15:0433" : "15:0433 (15:433 Discrimination against farmers)",
      "15:0631" : "15:0631 (15:631 Small Business Act)",
      "15:0636" : "15:0636 (15:636 Small Business Act - Aid to small business)",
      "15:0661" : "15:0661 (15:661 Small Business Investment Act of 1958)",
      "15:0687" : "15:0687 (15:687 Small Business Investment Program)",
      "15:0714(b)" : "15:0714(b) (15:714(b) Commodity Credit Corporation)",
      "15:0715(f)" : "15:0715(f) (15:715(f) Proceedings re petroleum and petroleum products)",
      "15:0717" : "15:0717 (15:717 Natural Gas Act)",
      "15:0719ic" : "15:0719ic (15:719i(c) Civil actions re violations or inj involving Gas)",
      "15:0754" : "15:0754 (15:754 Emergency Petroleum Allocation-Admin.& Enforcement)",
      "15:0766" : "15:0766 (15:766 Controversies arising re Federal Energy Admin rules)",
      "15:1051" : "15:1051 (15:1051 Trademark Infringement)",
      "15:1071" : "15:1071 (15:1071 Appeal of Decision of U.S. Patent & Trademark Office (Comm / Trademark Trial))",
      "15:1114" : "15:1114 (15:1114 Trademark Infringement (Lanham Act))",
      "15:1116" : "15:1116 (15:1116 Inj to prevent violation rights of trademark owner)",
      "15:1120" : "15:1120 (15:1120 Trademark - False or Fraudulent Registration)",
      "15:1121" : "15:1121 (15:1121 Trademark Infringement)",
      "15:1125" : "15:1125 (15:1125 Trademark Infringement (Lanham Act))",
      "15:1125(a)" : "15:1125(a) (15:1125(a) False representation of goods sold in interstate commerce)",
      "15:1125dac" : "15:1125dac (15:1125(d)ac Trademark (anticybersquatting consumer protection))",
      "15:1125la" : "15:1125la (15:1125la Trademark Infringement (Lanham Act))",
      "15:1126" : "15:1126 (15:1126 Trademarks - International conventions)",
      "15:1127" : "15:1127 (15:1127 Trademark Infringement)",
      "15:1191" : "15:1191 (15:1191 Flammable Fabrics Act)",
      "15:1221" : "15:1221 (15:1221 Auto Dealer Suits Against Manufacturers)",
      "15:1261" : "15:1261 (15:1261 Hazardous Substances)",
      "15:1263" : "15:1263 (15:1263 Prohibited Hazardous Substance - Interstate Commerce)",
      "15:1267(a)" : "15:1267(a) (15:1267(a) Federal Hazardous Substances Act)",
      "15:1314" : "15:1314 (15:1314 Antitrust - Petition for enforcement)",
      "15:1501" : "15:1501 (15:1501 Establishment of Department of Commerce)",
      "15:1601" : "15:1601 (15:1601 Truth in Lending)",
      "15:1605" : "15:1605 (15:1605 Determination of Finance Charge)",
      "15:1638" : "15:1638 (15:1638 Truth in Lending)",
      "15:1640" : "15:1640 (15:1640 Truth in Lending)",
      "15:1666" : "15:1666 (15:1666 Fair Credit Billing Act Dispute)",
      "15:1667" : "15:1667 (15:1667 Consumer Leasing Act)",
      "15:1679" : "15:1679 (15:1679 Violation of Credit Repair Organizations Act)",
      "15:1681" : "15:1681 (15:1681 Fair Credit Reporting Act)",
      "15:1691" : "15:1691 (15:1691 Equal Credit Opportunity Act)",
      "15:1692" : "15:1692 (15:1692 Fair Debt Collection Act)",
      "15:1693" : "15:1693 (15:1693 Electronic Fund Transfer Act)",
      "15:1693ef" : "15:1693ef (15:1693ef Electronic Funds Transfer Act)",
      "15:1693m" : "15:1693m (15:1693m Violation of Prov. of Subchpt. VI (Electronic Fund Transfers))",
      "15:1701" : "15:1701 (15:1701 Interstate Land Sales Full Disclosure Act (ILFFDA))",
      "15:1709" : "15:1709 (15:1709 Interstate Land Sales)",
      "15:1714" : "15:1714 (15:1714 Actions to enjoin violations re interstate land sale)",
      "15:1938" : "15:1938 (15:1938 Fair Labor Standards Act)",
      "15:1981" : "15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))",
      "15:1988" : "15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))",
      "15:1989" : "15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))",
      "15:2071" : "15:2071 (15:2071 Consumer Product Safety; Condemnation hazardous prod)",
      "15:2073" : "15:2073 (15:2073 Private action to enforce Consumer Product Safety)",
      "15:2301" : "15:2301 (15:2301 Magnuson-Moss Warranty Act)",
      "15:2310(c)" : "15:2310(c) (15:2310(c) Consumer Product Warranties)",
      "15:2601" : "15:2601 (15:2601 Toxic Substances Control Act (TCSA))",
      "15:2604" : "15:2604 (15:2604 Application for inj re distribution toxic substance)",
      "15:2616" : "15:2616 (15:2616 Toxic Substance control; seizure of chemical)",
      "15:2620" : "15:2620 (15:2620 Toxic Substances Control Act: citizen's petition)",
      "15:2651" : "15:2651 (15:2651 Asbestos Hazard Emergency Response Act)",
      "15:2801" : "15:2801 (15:2801 Petroleum Marketing Practices Act)",
      "15:2805" : "15:2805 (15:2805 Petroleum Marketing Practices-Franchise Protection)",
      "15:3414" : "15:3414 (15:3414 National Gas Policy Act)",
      "15:3710a" : "15:3710a (15:3710a Federal Technology Transfer Act of 1986)",
      "15:3901" : "15:3901 (15:3901 Federal Risk Retention Act)",
      "15:6801" : "15:6801 (15:6801 Gram-Leach-Bliley Act)",
      "15:7701" : "15:7701 (15:7701 Federal CAN-Spam Act)",
      "16:0019jj" : "16:0019jj (16:19jj Park System Resource Protection Act)",
      "16:0470" : "16:0470 (16:470 Archaeological Resources Protection Act)",
      "16:0470f" : "16:0470f (16:470f National Historic Preservation Act)",
      "16:0668" : "16:0668 (16:668 Bald and Golden Eagle Protection Act)",
      "16:0669" : "16:0669 (16:669 Pittman-Robertson Conservation Restoration Act)",
      "16:0675" : "16:0675 (16:675 Norbeck Wildlife Preserve Organic Act)",
      "16:0703" : "16:0703 (16:703 Migratory Bird Act)",
      "16:0823a" : "16:0823a (16:823a Federal Public Utility Regulatory Policies Act)",
      "16:0825" : "16:0825 (16:825 Federal Power Commission Regulation; Public Utilities)",
      "16:0831" : "16:0831 (16:831 Actions re: rights of Tennessee Valley Authority)",
      "16:1244" : "16:1244 (16:1244 National Scenic and National Historic Trails)",
      "16:1374d6" : "16:1374d6 (16:1374(d)(6) Petition for Review re Application for Import of Polar Bear Trophies)",
      "16:1531" : "16:1531 (16:1531 Endangered Species Act)",
      "16:1533" : "16:1533 (16:1533 Endangered Species Act)",
      "16:1538" : "16:1538 (16:1538 Endangered Species Act)",
      "16:1540" : "16:1540 (16:1540 Endangered Species Act - Penalties and Enforcement)",
      "16:1600" : "16:1600 (16:1600 National Forest Management Act of 1976)",
      "16:1801" : "16:1801 (16:1801 Magnuson-Stevens Fishery Conservation and Management Act)",
      "16:1858" : "16:1858 (16:1858 National Fishery Management Program - Civil Penalties and Permit Sanctions)",
      "16:3371" : "16:3371 (16:3371 Wildlife Under the Lacey Act)",
      "16:3372" : "16:3372 (16:3372 Lacey Act: Prohibited Acts)",
      "16:3373" : "16:3373 (16:3373 Lacey Act: Penalties and Sanctions - Appeal of Decision - DOI)",
      "16:3374" : "16:3374 (16:3374 Conservation: Complaint for Forfeiture)",
      "17:0101" : "17:0101 (17:101 Copyright Infringement)",
      "17:0201" : "17:0201 (17:201 Ownership of Copyright)",
      "17:0205d" : "17:0205d (17:205(d) Priority Between Conflicting Transfers)",
      "17:0407" : "17:0407 (17:407 Recovery of fines & penalties by Register of Copyrights)",
      "17:0411b" : "17:0411b (17:411(b) Action by copyright owner for infringement)",
      "17:0501" : "17:0501 (17:501 Copyright Infringement)",
      "17:0502a" : "17:0502a (17:502(a) Inj to prevent or restrain infringement copyright)",
      "17:0504" : "17:0504 (17:504 Remedies for Copyright Infringement)",
      "17:0512" : "17:0512 (17:512 Copyright Infringement of Digital Communications)",
      "17:1201" : "17:1201 (17:1201 Digital Millennium Copyright Act)",
      "18:0241" : "18:0241 (18:241 Conspiracy Against Citizen Rights)",
      "18:0492" : "18:0492 (18:492 Forfeiture of Counterfeit Paraphernalia)",
      "18:0603" : "18:0603 (18:603 Conflict of Interest)",
      "18:0922" : "18:0922 (18:922 Firearms - Unlawful Possession (Civil Fines))",
      "18:0923f3" : "18:0923f3 (18:923(f)(3) Review of Revocation of a License as a Dealer in Firearms)",
      "18:0925(c)" : "18:0925(c) (18:925(c) Restoration of ability to possess firearms/ammo)",
      "18:0981" : "18:0981 (18:981 Civil Forfeiture)",
      "18:0981a1A" : "18:0981a1A (18:981(a)(1)(A) Civil Forfeiture: Money Laundering Control Act)",
      "18:0983" : "18:0983 (18:983 Civil Forfeiture - General Rules)",
      "18:1028" : "18:1028 (18:1028 Currency Used to Commit a Violation)",
      "18:1030" : "18:1030 (18:1030 Fraud and related activity in connection with computers)",
      "18:1345" : "18:1345 (18:1345 Injunction against Fraud)",
      "18:1514" : "18:1514 (18:1514 Civil Action to Restrain Harassment of a Victim)",
      "18:1514A" : "18:1514A (18:1514A Civil Action to Protect Against Retaliation in Fraud Cases)",
      "18:1836a" : "18:1836a (18:1836(a) Injunction against Misappropriation of Trade Secrets)",
      "18:1836b" : "18:1836b (18:1836(b) Civil Action to Protect Trade Secrets)",
      "18:1905" : "18:1905 (18:1905 Disclosure of Confidential Information)",
      "18:1955" : "18:1955 (18:1955 Civil Forfeiture - Prohibition of Illegal Gambling)",
      "18:1956b3" : "18:1956b3 (18:1956(b)(3) Laundering of Monetary Instruments - Forfeit Property)",
      "18:1961" : "18:1961 (18:1961 Racketeering (RICO) Act)",
      "18:1962" : "18:1962 (18:1962 Racketeering (RICO) Act)",
      "18:1964" : "18:1964 (18:1964 Civil Remedies: Racketeering (RICO) Act)",
      "18:1968" : "18:1968 (18:1968 Action re civil investigative demand)",
      "18:2254" : "18:2254 (18:2254 Civil Forfeiture - Exploitation of Children)",
      "18:2333" : "18:2333 (18:2333 Civil Remedies: Anti-Terrorism Act of 1991)",
      "18:2511" : "18:2511 (18:2511 Wiretapping - Injunctive Relief or Civil Fine)",
      "18:2520" : "18:2520 (18:2520 Civil Damages for Interception Wire or Oral Communications)",
      "18:2707" : "18:2707 (18:2707 Civil Action: Stored Communications)",
      "18:2710(c)" : "18:2710(c) (18:2710(c) Wrongful Disclosure of Video Tape Rental or Sales Records)",
      "18:2724" : "18:2724 (18:2724 Civil Action - Motor Vehicle Records)",
      "18:3114" : "18:3114 (18:3114 Motion for Return of Seized Property)",
      "18:3184" : "18:3184 (18:3184 Extradition Procedure)",
      "18:3663" : "18:3663 (18:3663 Civil Enforcement of Criminal Restitution Obligation)",
      "18:3664e" : "18:3664e (18:3664e Civil Enforcement of Crim. Restitution Obligation)",
      "18:4100" : "18:4100 (18:4100 Transfer of Offenders)",
      "18:4208" : "18:4208 (18:4208(B) Agency Action Review)",
      "19:1305" : "19:1305 (19:1305 Custom Duties: Forfeiture-Immoral Articles)",
      "19:1497" : "19:1497 (19:1497 Customs Duties: Penalty for Failure to Declare)",
      "19:1595a" : "19:1595a (19:1595a Customs Duties: Forfeiture and Other Penalties)",
      "19:1607" : "19:1607 (19:1607 Customs Duties: Notice of Seizure)",
      "20:0107" : "20:0107 (20:107 Randolph-Sheppard Vending Stand Act)",
      "20:1070" : "20:1070 (20:1070 Student Assistance)",
      "20:1080" : "20:1080 (20:1080 Default of Student Loan: Recovery)",
      "20:1087" : "20:1087 (20:1087 Student Loan Discharge)",
      "20:1095a" : "20:1095a (20:1095a Education - Wage Garnishment Requirement)",
      "20:1097" : "20:1097 (20:1097 Education - Criminal penalties for fraud)",
      "20:1098g" : "20:1098g (20:1098g Higher Education Act - Exemption from state disclosure)",
      "20:1232g" : "20:1232g (20:1232(g) Family Education Rights & Privacy Act of 1974)",
      "20:1400" : "20:1400 (20:1400 IDEA: Individuals with Disabilities Education Act)",
      "20:1401" : "20:1401 (20:1401 IDEA: Education of Individuals with Disabilities)",
      "20:1412" : "20:1412 (20:1412 IDEA: State Eligibility)",
      "20:1415" : "20:1415 (20:1415 IDEA: Challenge decision re education for handicapped)",
      "20:1415e2" : "20:1415e2 (20:1415(e)(2)de IDEA: Mediation)",
      "20:1681" : "20:1681 (20:1681 Title IX Educational Amendments 1992 - Sex Discrimination)",
      "20:1683" : "20:1683 (20:1683 Judicial Review: Prohibition against sex discrimination in education)",
      "20:1706" : "20:1706 (20:1706 Relief from denial of equal educational opportunity)",
      "20:1717" : "20:1717 (20:1717 Reopening proceedings w/ order to end segregation)",
      "21:0301" : "21:0301 (21:301 Federal Food, Drug & Cosmetic Act)",
      "21:0331" : "21:0331 (21:331 Federal Food, Drug & Cosmetic Act - Prohibited Acts)",
      "21:0332" : "21:0332 (21:332 Federal Food, Drug & Cosmetic Act, Injunctive Relief)",
      "21:0332a" : "21:0332a (21:332(a) Federal Food, Drug & Cosmetic Act)",
      "21:0334a" : "21:0334a (21:334(a) Forfeiture or condemnation-food, drug, cosmetics)",
      "21:0348" : "21:0348 (21:348 Federal Food, Drug & Cosmetic Act - Food Additives)",
      "21:0360" : "21:0360 (21:360 Federal Food, Drug & Cosmetic Act - Drugs and Devices)",
      "21:0467" : "21:0467 (21:467 Seizure and condemnation of poultry products)",
      "21:0601" : "21:0601 (21:601 Federal Meat Inspection Act 21 USC 601-695)",
      "21:0673" : "21:0673 (21:673 Seizure and condemnation of meat or meat products)",
      "21:0674" : "21:0674 (21:674 Proceeding to enforce & enjoin re meat products)",
      "21:0821" : "21:0821 (21:821 Violation of Record Keeping Provision of Controlled Substance Act)",
      "21:0841" : "21:0841 (21:841 Forfeiture Property-Drugs)",
      "21:0842" : "21:0842 (21:842 Civil Penalty for violation re controlled substance)",
      "21:0881" : "21:0881 (21:881 Forfeiture Property-Drugs)",
      "21:0881a" : "21:0881a (21:881a Forfeiture Property - Aircraft)",
      "21:0881re" : "21:0881re (21:881re Forfeiture Property - Real Estate)",
      "21:0882" : "21:0882 (21:882 Inj to enjoin violations re controlled substance)",
      "21:1049" : "21:1049 (21:1049 Seizure and condemnation re eggs or egg products)",
      "22:0286" : "22:0286 (22:286 Action against World Bank or IMF)",
      "22:2702" : "22:2702 (22:2702 Medical Malpractice by Govt Medical Personnel)",
      "22:3612" : "22:3612 (22:3612 Claim for Damage to Panama Canal)",
      "22:3776" : "22:3776 (22:3776 Panama Canal Commission Action on claims)",
      "22:3777" : "22:3777 (22:3777 Investigation of accident or injury giving rise to a claim)",
      "22:4140" : "22:4140 (22:4140 Foreign Service Grievance Act - Judicial Review)",
      "23:0112" : "23:0112 (23:112 Federal Highway Act - Letting of Contracts)",
      "23:0134" : "23:0134 (23:134 Metropolitan Transportation Planning)",
      "23:1441" : "23:1441 (23:1441 Contract Real Estate)",
      "24:1000" : "24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)",
      "25:0177" : "25:0177 (Nonintercourse Act)",
      "25:0640" : "25:0640 (25:640 Indian Tribal Rights)",
      "25:1901" : "25:1901 (25:1901 Indian Child Welfare Act)",
      "25:2701" : "25:2701 (25:2701 Indian Gaming Regulatory Act (IGRA))",
      "25:4101" : "25:4101 (25:4101 Native American Housing Assistance and Self-Determination Act (NAHASDA))",
      "26:0063" : "26:0063 (26:63 IRS: Taxable income)",
      "26:0982" : "26:0982 (26:982 IRS: To Quash IRS Formal Document Request)",
      "26:2032" : "26:2032 (26:2032 IRS: Alternate valuation)",
      "26:6212" : "26:6212 (26:6212 IRS: Notice of Deficienty (Injunctive Relief from IRS Lien))",
      "26:6213" : "26:6213 (26:6213 IRS: Injunctive Relief from IRS Lien in Tax Court)",
      "26:6221" : "26:6221 (26:6221 IRS: TEFRA Tax, Equity and Fiscal Responsibility Act of 1982)",
      "26:6226" : "26:6226 (26:6226 IRS: Judicial Review of Partnership Adjustment)",
      "26:6320" : "26:6320 (26:6320 IRS: Notice and Opportunity for Hearing upon Filing Notice of Lien)",
      "26:6330" : "26:6330 (26:6330 IRS: Notice and Opportunity for Hearing before Levy)",
      "26:6331" : "26:6331 (26:6331 IRS: Wrongful Levy)",
      "26:6334" : "26:6334 (26:6334 IRS: Property Exempt from Levy)",
      "26:6502" : "26:6502 (26:6502 IRS: Collection after Assessment (Enforcement of tax liens))",
      "26:6532" : "26:6532 (26:6532 IRS: Periods of Limitation on Suits)",
      "26:6653sp" : "26:6653sp (26:6653sp IRS: Failure to Pay Stamp Tax)",
      "26:6672" : "26:6672 (26:6672 IRS: Failure to Collect and Pay Over Tax, or Attempt to Evade or Defeat Tax)",
      "26:6694" : "26:6694 (26:6694 IRS: Underestimate of Tax Liability By Tax Preparer)",
      "26:6702" : "26:6702 (26:6702 IRS: Penalty for Frivolous Tax Submission)",
      "26:6703" : "26:6703 (26:6703 IRS: Refund of Tax Penalty)",
      "26:7323" : "26:7323 (26:7323 IRS: Proceedings in rem enforce forfeitures property)",
      "26:7401" : "26:7401 (26:7401 IRS: Tax Liability - Authorization to collect via civil action)",
      "26:7402" : "26:7402 (26:7402 IRS: Jurisdiction of District Courts)",
      "26:7402(b)" : "26:7402(b) (26:7402(b) IRS: Petition to Enforce IRS Summons)",
      "26:7403" : "26:7403 (26:7403 IRS: Action to Enforce Federal Tax Lien)",
      "26:7404" : "26:7404 (26:7404 IRS: Action for collection of estate tax)",
      "26:7405" : "26:7405 (26:7405 IRS: Action for recovery of refunds erroneously made)",
      "26:7407" : "26:7407 (26:7407 IRS: Action to enjoin income tax preparers)",
      "26:7422rt" : "26:7422rt (26:7422rt IRS: Refund Taxes)",
      "26:7422rx" : "26:7422rx (26:7422rx IRS: Refund Excise Tax)",
      "26:7425(a)" : "26:7425(a) (26:7425(a) IRS: Judiciary & Judicial Procedures - Discharge of Liens)",
      "26:7426" : "26:7426 (26:7426 IRS: Wrongful Levy for Taxes)",
      "26:7428" : "26:7428 (26:7428 IRS: Declaratory Judgment)",
      "26:7429" : "26:7429 (26:7429 IRS: Tax Jeopardy Assessment)",
      "26:7430" : "26:7430 (26:7430 IRS: Awarding of Costs and Certain Fees in Tax Suit)",
      "26:7431" : "26:7431 (26:7431 IRS: Unauthorized Disclosure of Return & Return Info)",
      "26:7434" : "26:7434 (26:7434 IRS: Civil Damages for Fraudulent Filing of Information)",
      "26:7604" : "26:7604 (26:7604 IRS: Enforce summons; examination books & witnesses)",
      "26:7604(a)" : "26:7604(a) (26:7604(a) IRS: Complaint to Enforce IRS Summons)",
      "26:7609" : "26:7609 (26:7609 IRS: Petition to Quash IRS Summons)",
      "26:7609en" : "26:7609en (26:7609en IRS: Petition to serve Third-Party Summons)",
      "27:0185" : "27:0185 (27:185 Enforcement of Arbitration Award)",
      "28:0157c" : "28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)",
      "28:0157d" : "28:0157d (28:0157 Motion for Withdrawal of Reference)",
      "28:0158" : "28:0158 (28:0158 Notice of Appeal re Bankruptcy Matter (BA)",
      "28:0185" : "28:0185 (28:185 Suit to Compel Arbitration)",
      "28:0451" : "28:0451 (28:451 Employment Discrimination)",
      "28:0754" : "28:0754 (28:754 Receiver of Property in Different Districts)",
      "28:0794" : "28:0794 (28:794 Rehabilitation Act)",
      "28:1001" : "28:1001 (28:1001 E.R.I.S.A.)",
      "28:1132" : "28:1132 (28:1132 E.R.I.S.A.)",
      "28:1330" : "28:1330 (28:1330 Breach of Contract)",
      "28:1331" : "28:1331 (28:1331 Fed. Question)",
      "28:1331al" : "28:1331al (28:1331 Fed. Question: Airline Crash)",
      "28:1331at" : "28:1331at (28:1331 Fed. Question: Anti-trust)",
      "28:1331au" : "28:1331au (28:1331 Fed. Question: Auto Negligence)",
      "28:1331b" : "28:1331b (28:1331 Federal Question: Bivens Act)",
      "28:1331bc" : "28:1331bc (28:1331 Fed. Question: Breach of Contract)",
      "28:1331ca" : "28:1331ca (28:1331 Fed Question: Fed Communications Act of 1)",
      "28:1331cm" : "28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)",
      "28:1331cv" : "28:1331cv (28:1331 Federal Question: Other Civil Rights)",
      "28:1331ed" : "28:1331ed (28:1331 Fed. Question: Employment Discrimination)",
      "28:1331ej" : "28:1331ej (28:1331 Federal Question: Enforcement of Judgment)",
      "28:1331es" : "28:1331es (28:1331 Enforcement of Administrative Subpoena)",
      "28:1331fl" : "28:1331fl (28:1331 Fed. Question: Fair Labor Standards)",
      "28:1331in" : "28:1331in (28:1331 Fed. Question: Insurance Contract)",
      "28:1331mm" : "28:1331mm (28:1331 Fed. Question: Medical Malpractice)",
      "28:1331ng" : "28:1331ng (28:1331 Fed. Question: Natural Gas Act)",
      "28:1331pi" : "28:1331pi (28:1331 Fed. Question: Personal Injury)",
      "28:1331rd" : "28:1331rd (28:1331 Fed. Question: Review Agency Decision)",
      "28:1331rp" : "28:1331rp (28:1331(a) Fed. Question: Real Property)",
      "28:1331rr" : "28:1331rr (28:1331 Fed. Question: Railway Labor Act)",
      "28:1331sv" : "28:1331sv (28:1331 Fed. Question: Securities Violation)",
      "28:1331tr" : "28:1331tr (28:1331 Fed. Question: Trademark)",
      "28:1331tt" : "28:1331tt (28:1331 Fed. Question: Tort Action)",
      "28:1331v" : "28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendme)",
      "28:1331wl" : "28:1331wl (28:1331 Federal Question: EPA Waste Lien)",
      "28:1331wt" : "28:1331wt (28:1331 Fed. Question: Water Rights)",
      "28:1332ac" : "28:1332ac (28:1332 Diversity-Account Receivable)",
      "28:1332al" : "28:1332al (28:1332 Diversity-Airline Crash)",
      "28:1332as" : "28:1332as (28:1332 Diversity-Asbestos Litigation)",
      "28:1332au" : "28:1332au (28:1332 Diversity-Auto Negligence)",
      "28:1332bc" : "28:1332bc (28:1332 Diversity-Breach of Contract)",
      "28:1332co" : "28:1332co (28:1332 Diversity-Conversion)",
      "28:1332ct" : "28:1332ct (28:1332 Diversity-(Citizenship))",
      "28:1332det" : "28:1332det (28:1332 Diversity: Forcible Detainer)",
      "28:1332df" : "28:1332df (28:1332 Diversity-Contract Default)",
      "28:1332ds" : "28:1332ds (28:1332 Diversity-Contract Dispute)",
      "28:1332ed" : "28:1332ed (28:1332 Diversity-Employment Discrimination)",
      "28:1332fd" : "28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)",
      "28:1332fr" : "28:1332fr (28:1332 Diversity-Fraud)",
      "28:1332ia" : "28:1332ia (28:1332 Diversity-Interpleader Action)",
      "28:1332ij" : "28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)",
      "28:1332in" : "28:1332in (28:1332 Diversity-Insurance Contract)",
      "28:1332jd" : "28:1332jd (28:1332 Diversity-Declaratory Judgement)",
      "28:1332lb" : "28:1332lb (28:1332 Diversity-Libel,Assault,Slander)",
      "28:1332lm" : "28:1332lm (28:1332 Diversity - Legal Malpractice)",
      "28:1332ma" : "28:1332ma (28:1332 Diversity-Miller Act)",
      "28:1332mm" : "28:1332mm (28:1332 Diversity-Medical Malpractice)",
      "28:1332mv" : "28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)",
      "28:1332ni" : "28:1332ni (28:1332 Diversity-Negotiable Instrument)",
      "28:1332nm" : "28:1332nm (28:1332 Diversity-Non-Motor Vehicle)",
      "28:1332nr" : "28:1332nr (28:1332 Diversity-Notice of Removal)",
      "28:1332oc" : "28:1332oc (28:1332 Diversity-Other Contract)",
      "28:1332pd" : "28:1332pd (28:1332 Diversity-Property Damage)",
      "28:1332pi" : "28:1332pi (28:1332 Diversity-Personal Injury)",
      "28:1332pl" : "28:1332pl (28:1332 Diversity-Product Liability)",
      "28:1332pr" : "28:1332pr (28:1332 Diversity-Petition for Removal)",
      "28:1332qt" : "28:1332qt (28:1332 Diversity-Petition to Quiet Title)",
      "28:1332ri" : "28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)",
      "28:1332sa" : "28:1332sa (28:1332 - Diversity: Securities & Exchange Commiss)",
      "28:1332sf" : "28:1332sf (28:1332 - Diversity: Securities Fraud)",
      "28:1332ss" : "28:1332ss (28:1332 Diversity - Stockholders Suits)",
      "28:1332tl" : "28:1332tl (28:1332 Diversity-Torts to Land)",
      "28:1332tm" : "28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))",
      "28:1332tn" : "28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)",
      "28:1332wd" : "28:1332wd (28:1332 Diversity-Wrongful Death)",
      "28:1333" : "28:1333 (28:1333 Admiralty)",
      "28:1334" : "28:1334 (28:1334 Bankruptcy Appeal)",
      "28:1334c" : "28:1334c (28:1334(c) R&R re motions for abstention (non-cor)",
      "28:1335" : "28:1335 (28:1335 Interpleader Action)",
      "28:1337" : "28:1337 (28:1337 Sherman-Clayton Act)",
      "28:1338cp" : "28:1338cp (28:1338 Copyright Infringement)",
      "28:1338pt" : "28:1338pt (28:1338 Patent Infringement)",
      "28:1338tr" : "28:1338tr (28:1338 Trademark Infringement)",
      "28:1340" : "28:1340 (28:1340 IRS: Custom Duties)",
      "28:1340er" : "28:1340er (28:1340 Recovery of Erroneous Refund)",
      "28:1341" : "28:1341 (28:1341 Complaint for Forfeiture)",
      "28:1343" : "28:1343 (28:1343 Violation of Civil Rights)",
      "28:1345" : "28:1345 (28:1345 USA Plaintiff)",
      "28:1345co" : "28:1345co (28:1345 Replevin & Conversion)",
      "28:1345db" : "28:1345db (28:1345 Debt to US - FHA/HUD Title I)",
      "28:1345df" : "28:1345df (28:1345 Default of Promissory Note)",
      "28:1345er" : "28:1345er (28:1345 Recovery of Erroneous Refund)",
      "28:1345fc" : "28:1345fc (28:1345 Foreclosure)",
      "28:1345ff" : "28:1345ff (28:1345 Complaint for Forfeiture)",
      "28:1345hl" : "28:1345hl (28:1345 VA Home Loan Guaranty Debt)",
      "28:1345mc" : "28:1345mc (28:1345 Medical Care Recovery)",
      "28:1345mi" : "28:1345mi (28:1345 Mining Claim Ejectment)",
      "28:1345pd" : "28:1345pd (28:1345 Property Damage)",
      "28:1345pe" : "28:1345pe (28:1345 Property Ejectment)",
      "28:1345rc" : "28:1345rc (28:1345 Recovery of Debt to US)",
      "28:1345st" : "28:1345st (28:1345 Default of Student Loan)",
      "28:1345tp" : "28:1345tp (28:1345 Trespass on Public Land)",
      "28:1345va" : "28:1345va (28:1345 Recovery of VA Overpayment)",
      "28:1346bc" : "28:1346bc (28:1346 Breach of Contract)",
      "28:1346rc" : "28:1346rc (28:1346 Recovery of IRS Tax)",
      "28:1346tc" : "28:1346tc (28:1346 Tort Claim)",
      "28:1346wd" : "28:1346wd (28:1346 Wrongful Death)",
      "28:1349" : "28:1349 (28:1348 Corporation organized under Federal Law as party)",
      "28:1352" : "28:1352 (28:1352 Miller Act)",
      "28:1355" : "28:1355 (28:1355 Petition for Return of Property)",
      "28:1358" : "28:1358 (28:1358 Land Condemnation)",
      "28:1361" : "28:1361 (28:1361 Petition for Writ of Mandamus)",
      "28:1362ic" : "28:1362ic (28:1362 Indian Tribal Controversy)",
      "28:1362iw" : "28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)",
      "28:1364" : "28:1364 (28:1364 Auto Negligence)",
      "28:1391" : "28:1391 (28:1391 Personal Injury)",
      "28:1402" : "28:1402 (28:1402 Medical Malpractice)",
      "28:1407" : "28:1407 (28:1407 Airline Crash)",
      "28:1441ac" : "28:1441ac (28:1441 Petition for Removal- Account Receivable)",
      "28:1441al" : "28:1441al (28:1441 Petition for Removal- Airline Crash)",
      "28:1441as" : "28:1441as (28:1441 Petition for Removal- Asbestos Litigation)",
      "28:1441au" : "28:1441au (28:1441 Petition for Removal- Auto Negligence)",
      "28:1441bc" : "28:1441bc (28:1441 Petition for Removal- Breach of Contract)",
      "28:1441cv" : "28:1441cv (28:1441 Petition for Removal- Civil Rights Act)",
      "28:1441df" : "28:1441df (28:1441 Petition for Removal- Contract Default)",
      "28:1441dj" : "28:1441dj (28:1441 Petition for Removal- Declaratory Judgemen)",
      "28:1441ds" : "28:1441ds (28:1441 Petition for Removal- Contract Dispute)",
      "28:1441ed" : "28:1441ed (28:1441 Petition for Removal - Employment Discrim)",
      "28:1441fc" : "28:1441fc (28:1441 Petition for Removal - Fair Credit Reporti)",
      "28:1441fr" : "28:1441fr (28:1441 Petition for Removal- Fraud)",
      "28:1441ij" : "28:1441ij (28:1441 Petition for Removal- Injunctive/Declarato)",
      "28:1441in" : "28:1441in (28:1441 Petition for Removal- Insurance Contract)",
      "28:1441int" : "28:1441int (28:1441 Petition for Removal- Action for Interplea)",
      "28:1441lb" : "28:1441lb (28:1441 Petition for Removal Libel,Assault,Slander)",
      "28:1441lm" : "28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relatio)",
      "28:1441mm" : "28:1441mm (28:1441 Petition for Removal- Medical Malpractice)",
      "28:1441ni" : "28:1441ni (28:1441 Petition for Removal- Negotiable Instrumen)",
      "28:1441nm" : "28:1441nm (28:1441 Petition for Removal- Non-Motor Vehicle)",
      "28:1441nr" : "28:1441nr (28:1441 Notice of Removal)",
      "28:1441oc" : "28:1441oc (28:1441 Petition For Removal--Other Contract)",
      "28:1441pd" : "28:1441pd (28:1441 Petition for Removal- Property Damage)",
      "28:1441pi" : "28:1441pi (28:1441 Petition for Removal- Personal Injury)",
      "28:1441pl" : "28:1441pl (28:1441 Petition for Removal- Product Liability)",
      "28:1441pr" : "28:1441pr (28:1441 Petition for Removal)",
      "28:1441qt" : "28:1441qt (28:1441 Petition for Removal- Petition to Quiet Ti)",
      "28:1441ri" : "28:1441ri (28:1441 Petition for Removal- Racketeering (RICO))",
      "28:1441sa" : "28:1441sa (28:1441 - Petition for Removal: SEC Act)",
      "28:1441sf" : "28:1441sf (28:1441 - Petition for Removal: Securities Fraud)",
      "28:1441tl" : "28:1441tl (28:1441 Petition for Removal- Torts to Land)",
      "28:1441tm" : "28:1441tm (28:1441 Petition for Removal- Tort/Motor Vehicle ()",
      "28:1441tn" : "28:1441tn (28:1441 Petition for Removal- Tort/Non-Motor Vehic)",
      "28:1441wd" : "28:1441wd (28:1441 Petition for Removal- Wrongful Death)",
      "28:1442bc" : "28:1442bc (28:1442 Petition for Removal- Breach of Contract)",
      "28:1442nr" : "28:1442nr (28:1442 Notice of Removal)",
      "28:1442pr" : "28:1442pr (28:1442 Petition for Removal)",
      "28:1443" : "28:1443 (28:1443(1) Rent, Lease & Ejectment)",
      "28:1444" : "28:1444 (28:1444 Petition for Removal- Foreclosure)",
      "28:1446in" : "28:1446in (28:1446 Breach of Contract- Insurance)",
      "28:1446nr" : "28:1446nr (28:1446 Notice of Removal)",
      "28:1446pd" : "28:1446pd (28:1446 Petition for Removal- Property Damage (P.I)",
      "28:1446pi" : "28:1446pi (28:1446 Petition for Removal- Personal Injury)",
      "28:1446pl" : "28:1446pl (28:1446pl Petition for Removal - Product Liability)",
      "28:1446pr" : "28:1446pr (28:1446 Petition for Removal)",
      "28:1452" : "28:1452 (28:1452 R&R re motions to remand (non-core))",
      "28:1651" : "28:1651 (28:1651 Petition for Writ of Coram Nobis)",
      "28:1651hc" : "28:1651hc (28:1651 Petition for Writ of Habeas Corpus)",
      "28:1651mn" : "28:1651mn (28:1651 Petition for Writ of Mandamus)",
      "28:1782" : "28:1782 (28:1782 Letter rogatory - appointment)",
      "28:1983" : "28:1983 (28:1983 Civil Rights)",
      "28:2201" : "28:2201 (28:2201 Constitutionality of State Statute(s))",
      "28:2201dj" : "28:2201dj (28:2201 Declaratory Judgement)",
      "28:2201ij" : "28:2201ij (28:2201 Injunction)",
      "28:2201in" : "28:2201in (28:2201 Declaratory Judgement (Insurance))",
      "28:2241" : "28:2241 (28:2241 Petition for Writ of Habeas Corpus (federa)",
      "28:2254" : "28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))",
      "28:2254se" : "28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)",
      "28:2255" : "28:2255 (28:2255 Motion to Vacate / Correct Illegal Sentenc)",
      "28:2271" : "28:2271 (28:2271 Federal Tort Claims Act)",
      "28:2345" : "28:2345 (28:2345 Medicare Recovery)",
      "28:2409" : "28:2409 (28:2409(a) Quiet Title Action)",
      "28:2410" : "28:2410 (28:2410 Quiet Title)",
      "28:2671" : "28:2671 (28:2671 Federal Tort Claims Act)",
      "28:2674" : "28:2674 (28:2674 Federal Tort Claims Act)",
      "28:2675" : "28:2675 (28:2675 Federal Tort Claims Act - Disposition by Agency Req)",
      "28:3001" : "28:3001 (28:3001 Federal Debt Collection Act)",
      "28:3205" : "28:3205 (28:3205 Garnishment)",
      "28:7402" : "28:7402 (28:7402 Refund of Taxes)",
      "28:7422" : "28:7422 (28:7422 Appeal from Administrative Decision)",
      "29:0151" : "29:0151 (29:151 Labor: Review of Agency Action)",
      "29:0160" : "29:0160 (29:160(1) National Labor Relations Act)",
      "29:0184" : "29:0184 (29:184 Violation Collection Bargain Agreement)",
      "29:0185ep" : "29:0185ep (29:185 Employee Pension Plan)",
      "29:0185lm" : "29:0185lm (29:185 Labor/Mgt. Relations (Contracts))",
      "29:0201do" : "29:0201do (29:201 Denial of Overtime Compensation)",
      "29:0201fl" : "29:0201fl (29:201 Fair Labor Standards Act)",
      "29:0203" : "29:0203 (29:203 Equal Pay Act)",
      "29:0206" : "29:0206 (29:206 Collect Unpaid Wages)",
      "29:0401" : "29:0401 (29:0401 Labor Management Disclosure Act)",
      "29:0621" : "29:0621 (29:621 Job Discrimination (Age))",
      "29:0623" : "29:0623 (29:623 Job Discrimination (Age))",
      "29:0626" : "29:0626 (29:626 Job Discrimination (Age))",
      "29:0633" : "29:0633 (29:633 Job Discrimination (Age))",
      "29:0651" : "29:0651 (29:651 Occupational Safety/Health)",
      "29:0754" : "29:0754 (29:754 Discrimination)",
      "29:0791" : "29:0791 (29:791 Job Discrimination (Rehabilitation Act))",
      "29:0794" : "29:0794 (29:0794 Job Discrimination (Handicap))",
      "29:1001" : "29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)",
      "29:1002" : "29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)",
      "29:1104" : "29:1104 (29:1104 Recovery of Benefits to Employee)",
      "29:1109" : "29:1109 (29:1109 Breach of Fiduciary Duties)",
      "29:1131" : "29:1131 (29:1131 ERISA - Collection of Delinquent Trust Fun)",
      "29:1132" : "29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)",
      "29:1145" : "29:1145 (29:1145 E.R.I.S.A.)",
      "29:1149" : "29:1149 (29:1149 Recover Pension & Profit Sharing)",
      "29:1337" : "29:1337 (29:1337 E.R.I.S.A.)",
      "29:1362" : "29:1362 (29:1362 ERISA)",
      "29:1381" : "29:1381 (29:1381 E.R.I.S.A.)",
      "29:1401" : "29:1401 (29:1401(b)(2) Appeal of Arbitration Award)",
      "29:1451" : "29:1451 (29:1451 E.R.I.S.A.)",
      "29:1801" : "29:1801 (29:1801 Farmworker Rights)",
      "29:2601" : "29:2601 (29:2601 Family and Medical Leave Act of 1993)",
      "29:2615" : "29:2615 (29:2615 Family Medical Leave Act)",
      "29:2617" : "29:2617 (29:2617 Family Medical Leave Act)",
      "29:790" : "29:790 (29:790 Rehabilitation of Labor)",
      "30:0022" : "30:0022 (30:22 General Mining Law of 1872 (Lands Open to Purchase by Citizens))",
      "30:0181" : "30:0181 (30:181 Land subject to disposition; persons entitled to benefits; reciprocal privileges)",
      "30:0801" : "30:0801 (30:801 Penalities/Federal Mine Safety Health Act)",
      "30:0815" : "30:0815 (30:815 Federal Mine Safety & Health Act (Procedure for Enforcement))",
      "30:1201" : "30:1201 (30:1201 Environment: Review of Agency Action)",
      "30:1202" : "30:1202 (30:1202 Mining Reclamation Act)",
      "30:1276" : "30:1276 (30:1276 Interior: Judicial Review of Agency Action)",
      "30:1701" : "30:1701 (30:1701 Federal Oil Gas Royalty Mgt Act 1982 (FOGRMA))",
      "31:0732" : "31:0732 (31:0732 General Acct. Office Personnel Act of 1980 (Personnel Management System))",
      "31:1341" : "31:1341 (31:1341 Government employee - limitations on expending monies)",
      "31:3545" : "31:3545 (31:3545 Civil Action to Recover Money)",
      "31:3702" : "31:3702 (31:3702 Procedures for Settling Claims)",
      "31:3713" : "31:3713 (31:3713 Priority of Government Claims)",
      "31:3720" : "31:3720 (31:3720 Federal Income Tax Interceptions (Collection of Payments))",
      "31:3728" : "31:3728 (31:3728 Setoff against Judgment)",
      "31:3729" : "31:3729 (31:3729 False Claims Act - Liability)",
      "31:3730" : "31:3730 (31:3730 Qui Tam False Claims Act)",
      "31:3731" : "31:3731 (31:3731 False Claims Act - Procedures)",
      "31:3733j2" : "31:3733j2 (31:3733(j)(2) Pet to Mod or Set Aside CV Investigative Demand)",
      "31:5314" : "31:5314 (31:5314 Failure to Report Interest in Foreign Accounts)",
      "31:5317" : "31:5317 (31:5317 Search and Forfeiture of Monetary Instruments)",
      "31:5320" : "31:5320 (31:5320 Inj proceedings re Rpts of Currency & Foreign Trans.)",
      "31:5321" : "31:5321 (31:5321 Penalty for failure to report transportation money)",
      "31:5332(a)" : "31:5332(a) (31:5332(a) Evading Currency Reporting Requirement)",
      "31:5332(f)" : "31:5332(f) (31:5332(f) Transport and Transfer US currency from in to out)",
      "31:6716" : "31:6716 (31:6716 Discrimination re money and finance)",
      "31:9701" : "31:9701 (31:9701 Federal User Charge Statute)",
      "33:0408" : "33:0408 (33:408 Injury to Harbor Improvement)",
      "33:0594" : "33:0594 (33:594 Land Condemnation)",
      "33:0901" : "33:0901 (33:901 Longshoremen Harbor Workers Compensation Act (Navigation and Navigable Waters))",
      "33:0905(b)" : "33:0905(b) (33:905(b) Longshoremen Workers' Compensation Act - Recovery of Damages caused by vessel neglige)",
      "33:0918" : "33:0918 (33:918 Longshore and Harbor Workers Compensation Act - Collection of Defaulted Payments)",
      "33:0921" : "33:0921 (33:921 Longshore & Harbor Workers Compensation Act - Review of Compensation Orders)",
      "33:0933" : "33:0933 (33:933 Longshore and Harbor Workers' Compensation Act-Compensation for Injuries (Third-Party Cl)",
      "33:1221" : "33:1221 (33:1221 Ports and Waterways Safety Program)",
      "33:1251" : "33:1251 (33:1251 Federal Water Pollution Control Act (Clean Water Act))",
      "33:1319cw" : "33:1319cw (33:1319cw Clean Water Act - Enforcement)",
      "33:1319pv" : "33:1319pv (33:1319(a)(2)pv Clean Water Act - Pollutants & Permit Violations)",
      "33:1321" : "33:1321 (33:1321 Clean Water Act - Discharge of hazardous substance or pollutants/water)",
      "33:1361" : "33:1361 (33:1361 Clean Water Act - Administrator Authority)",
      "33:1364" : "33:1364 (33:1364 Clean Water Act - EPA action to restrain pollution endangering health (emergency powers))",
      "33:1365" : "33:1365 (33:1365 Clean Water Act - Citizen Suits re Environmental Matters)",
      "33:1415" : "33:1415 (33:1415 Marine Protection, Research, and Sanctuaries Act)",
      "33:1515" : "33:1515 (33:1515 Deepwater Ports Act (citizen civil action))",
      "33:2701" : "33:2701 (33:2701 Oil Pollution Act of 1940)",
      "35:0001" : "35:0001 (35:1 Establishment of PTO)",
      "35:0032" : "35:0032 (35:32 Suspension from Practice before Patent & Trade Office)",
      "35:0145" : "35:0145 (35:145 Civil Action to Obtain Patent)",
      "35:0146" : "35:0146 (35:146 Appeal from Decision of the Board of Patent Appeals)",
      "35:0183" : "35:0183 (35:183 Right to Compensation - Patent Laws)",
      "35:0256" : "35:0256 (35:256 Patent Non-Infringement (Correction of Named Inventor))",
      "35:0271" : "35:0271 (35:271 Patent Infringement)",
      "35:0281" : "35:0281 (35:281 Remedy for Infringement of Patent/Jurisdiction conferred 28:1338)",
      "35:0282" : "35:0282 (35:282 Patent Infringement - Defenses)",
      "35:0283" : "35:0283 (35:283 Action to enjoin violation of right secured by patent)",
      "35:0289" : "35:0289 (35:289 Recover profits from unlicensed use of design patent)",
      "35:0291" : "35:0291 (35:291 Action for relief between owners; interfering patents)",
      "35:0292" : "35:0292 (35:292 Penalty & Forfeiture; illegal use of word patent (false marking))",
      "35:0311" : "35:0311 (35:311 Patent - Request for Inter Partes Reexamination)",
      "38:1110" : "38:1110 (38:1110 Basic Entitlements / Wartime)",
      "38:1131" : "38:1131 (38:1131 Basic Entitlements / Peacetime)",
      "38:1681" : "38:1681 (38:1681 Recovery of VA Overpayment)",
      "38:1686" : "38:1686 (38:1686 Recovery of VA Overpayment)",
      "38:1780" : "38:1780 (38:1780 Recovery of VA Overpayment)",
      "38:1816" : "38:1816 (38:1816 Deficiency balance VA Mortgage Foreclosure-Regulations governing VA Loan Guaranty Program)",
      "38:1965" : "38:1965 (38:1965 Servicemen's Group Life Insurance)",
      "38:1975" : "38:1975 (38:1975 Recovery of Servicemen's Group Life Insurance - Jurisdiction of District Court)",
      "38:1984" : "38:1984 (38:1984 Suit for Veterans Insurance)",
      "38:2011" : "38:2011 (38:2011 - Veteran's Readjustment Assistance Act of)",
      "38:2021" : "38:2021 (38:2021 Right to re-employment of inducted persons)",
      "38:3116" : "38:3116 (38:3116 VA Overpayment)",
      "38:3481" : "38:3481 (38:3481 Recovery of VA Overpayment)",
      "38:3680" : "38:3680 (38:3680 Recovery of Education Assist Allowance Overpayment)",
      "38:4212" : "38:4212 (38:4212 Veterans Employment Emphasis Under Federal Contracts)",
      "38:4301" : "38:4301 (38:4301 - Uniformed Services Employment and Reemployment Rights Act (USERRA))",
      "38:4302" : "38:4302 (38:4302 Veterans Reemployment Rights Act (relation to other laws and plans or agreements))",
      "38:4311" : "38:4311 (38:4311 Uniformed Service Employment or Reemployment Rights Act (USERRA) - Discrimination)",
      "38:4312" : "38:4312 (38:4312 Rights of inducted persons to reemployment)",
      "38:4323" : "38:4323 (38:4323 USERRA - Enforcement of rights with respect to state or private employer)",
      "38:4324" : "38:4324 (38:4324 USERRA - Enforcement of rights with respect to federal executive agencies)",
      "38:5315" : "38:5315 (38:5315 Delinquent Payment of Amounts Due to US)",
      "38:5316" : "38:5316 (38:5316 VA Overpayment)",
      "38:775" : "38:775 (Recovery of Servicemen's Group Life Insurance)",
      "39:0403" : "39:0403 (39:403 Discriminatory use of the Postal Service)",
      "39:0409" : "39:0409 (39:409 Suits by and against the Postal Service)",
      "39:1207" : "39:1207 (39:1207 Review Agency Action - Labor Disputes)",
      "39:1208b" : "39:1208b (39:1208(b) Postal Reorganization Act of 1970 - Suits)",
      "39:3005" : "39:3005 (39:3005 False Representations and Lotteries)",
      "39:3007" : "39:3007 (39:3007 Detention of Mail for Temporary Periods - Injunction directing retention of incoming mail)",
      "39:3008e" : "39:3008e (39:3008(e) Enforce compliance with a USPS Prohibitory Order)",
      "40:0258" : "40:0258 (40:258(a) Public Buildings & Property: Land Condem)",
      "40:0270" : "40:0270 (40:270 Miller Act)",
      "40:0581" : "40:0581 (40:581 General Authority of Administrator of General Services)",
      "40:0875" : "40:0875 (40:875 Public Buildings & Property: Negligence)",
      "40:1101" : "40:1101 (40:1101 Brooks Architect - Engineers Act)",
      "40:3131" : "40:3131 (40:3131 Bonds of contractors of Public buildings)",
      "40:3142" : "40:3142 (40:3142 Davis-Bacon Act (prevailing wages))",
      "41:0251" : "41:0251 (41:251 Public Contracts-Review of Agency Action)",
      "41:1463" : "41:1463 (41:1463 Public Contracts: Unlawful Employment Prac)",
      "41:2102" : "41:2102 (41:2102-2107 Procurement Integrity Act)",
      "41:3301" : "41:3301 (41:3301 Competition in Contracting Act)",
      "41:6503" : "41:6503 (41:6503 Walsh-Healy Act - Breach of Public Contract)",
      "41:6505" : "41:6505 (41:6505 Exclusions - Review of legal questions in contracts; Walsh-Healy Act)",
      "41:6702" : "41:6702 (41:6702-6704 Service Contract Labor Standards / McNamara-O'Hara Service Contract Act 1965)",
      "41:7105f" : "41:7105f (41:7105(f) Action to Judicially Enforce Administrative Subpoena)",
      "42:0205" : "42:0205 (42:205 Denial Social Security Benefits)",
      "42:0206" : "42:0206 (42:206 Social Security Benefits)",
      "42:0247" : "42:0247 (42:247 Personal Injury-Swine Flu)",
      "42:0294" : "42:0294 (42:294 Public Health and Welfare, Health Professions Education)",
      "42:0402" : "42:0402 (42:402 Social Security Benefits)",
      "42:0405id" : "42:0405id (42:405 Review of HHS Decision (SSID))",
      "42:0405wc" : "42:0405wc (42:405 Review of HHS Decision (DIWC))",
      "42:0405ww" : "42:0405ww (42:405 Review of HHS Decision (DIWW))",
      "42:0416" : "42:0416 (42:416 Denial of Social Security Benefits)",
      "42:0427" : "42:0427 (42:427 Social Security Benefits)",
      "42:11603" : "42:11603 (42:11603(b) Internat. Child Abduction Remedies Act (ICARA))",
      "42:12101" : "42:12101 (42:12101 American Disabilities Act)",
      "42:1383" : "42:1383 (42:1383 Review of HHS Decision)",
      "42:1395" : "42:1395 (42:1395 HHS: Adverse Reimbursement Review)",
      "42:1396" : "42:1396 (42:1396 - Tort Negligence)",
      "42:14141" : "42:14141 (42:14141 Violent Crime Control and Law Enforcement Act of 1994)",
      "42:1471" : "42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclo)",
      "42:1981cv" : "42:1981cv (42:1981 Civil Rights)",
      "42:1981hs" : "42:1981hs (42:1981 Housing Discrimination)",
      "42:1981jb" : "42:1981jb (42:1981 Job Discrimination (Race))",
      "42:1981sx" : "42:1981sx (42:1981 Sex Discrimination)",
      "42:1983cv" : "42:1983cv (42:1983 Civil Rights Act)",
      "42:1983ed" : "42:1983ed (42:1983 Civil Rights (Employment Discrimination))",
      "42:1983pr" : "42:1983pr (42:1983 Prisoner Civil Rights)",
      "42:1986" : "42:1986 (42:1986 Neglect of Duty)",
      "42:2000ag" : "42:2000ag (42:2000 Job Discrimination (Age))",
      "42:2000e" : "42:2000e (42:2000e Job Discrimination (Employment))",
      "42:2000pb" : "42:2000pb (42:2000 Job Discrimination (Public Accommodations))",
      "42:2000ra" : "42:2000ra (42:2000 Job Discrimination (Race))",
      "42:2000sx" : "42:2000sx (42:2000 Job Discrimination (Sex))",
      "42:2003" : "42:2003 (42:2003 Job Discrimination)",
      "42:2005" : "42:2005 (42:2005 Review of Agency Action-HHS)",
      "42:2615" : "42:2615 (42:2616 Medical Recovery Act)",
      "42:2651" : "42:2651 (42:2651 Medical Care Recovery)",
      "42:3601" : "42:3601 (42:405 Fair Housing Act)",
      "42:4000" : "42:4000 (42:4000 National Flood Insurance Act)",
      "42:4001" : "42:4001 (42:4001 National Insurance Flood Act)",
      "42:4053" : "42:4053 (42:4053 Breach of Insurance Contract)",
      "42:4072" : "42:4072 (42:4072 Payment of Flood Insurance Claim)",
      "42:4321" : "42:4321 (42:4321 Review of Agency Action-Environment)",
      "42:4332" : "42:4332 (42:4332 Environmental Policy - Coop of Agency Repo)",
      "42:6901en" : "42:6901en (42:6901 Environmental Cleanup Expenses)",
      "42:6901rs" : "42:6901rs (42:6901 Resource & Recovery Act)",
      "42:7413" : "42:7413 (42:7413(b) Clean Air Act)",
      "42:7604cl" : "42:7604cl (42:7604 Clear Air Act (Emission Standards))",
      "42:7604ir" : "42:7604ir (42:7604 Petition to Quash IRS Summons)",
      "42:9601" : "42:9601 (42:9601 - Cause of Action Arising under CERCLA)",
      "42:9607" : "42:9607 (42:9607 Real Property Tort to Land)",
      "43:0421" : "43:0421 (43:421 Complaint in Condemnation - Eminent Domain)",
      "43:0945a" : "43:0945a (43:945a Compensation for Land Condemnation)",
      "43:0945b" : "43:0945b (43:945b Complaint in Condemnation - Easements)",
      "43:0946" : "43:0946 (43:946 Complaint in Condemnation - Right of Way for Irrigation and Drainage Projects)",
      "43:1331" : "43:1331 (43:1331 Outer Continental Shelf Lands Act)",
      "43:1333" : "43:1333 (43:1333 Outer Continental Shelf Lands Act - Laws and Regulations Governing Lands)",
      "43:1349" : "43:1349 (43:1349 Outer Continental Land Shelf Act - Citizen Suits)",
      "43:1701" : "43:1701 (43:1701 Violation of Federal Land Policy and Management Act (FLPMA))",
      "43:1737" : "43:1737 (43:1737 FLPMA - Implementation Provisions)",
      "44:2107" : "44:2107 (44:2107 Presidential Recordings & Materials Act (NARA acceptance of records historical preservation))",
      "45:0051" : "45:0051 (45:51 Railways: Fed. Employer's Liability Act)",
      "45:0056" : "45:0056 (45:56 Employers Liability Act - Personal Inj re Railroads)",
      "45:0151" : "45:0151 (45:151 Railway Labor Act)",
      "45:0152" : "45:0152 (45:152 Railway Labor Act - General Duties)",
      "45:0153" : "45:0153 (45:153 First Railway Labor Act - National Railroad Adjustment Board)",
      "45:0159" : "45:0159 (45:159 Review of arbitration award (RR Carriers/Mediation Bd))",
      "45:0184" : "45:0184 (45:184 Action to Set Aside Award of a System Board)",
      "45:0231f" : "45:0231f (45:231(f) Compel obedience to order of Railroad Retirement Bd)",
      "45:0351" : "45:0351 (45:351 Railroad Unemployment Insurance Act)",
      "45:0719" : "45:0719 (45:719 Regional Rail Reorganization Act of 1973)",
      "45:1105" : "45:1105 (45:1105 Northeast Rail Service Act)",
      "45:1395" : "45:1395 (45:1395 Railroads: Adverse Reimbursement Review)",
      "45:7457" : "45:7457 (45:7457 Compel Reclamation Under Clear Air Act)",
      "46:0183" : "46:0183 (46:0183 Admiralty/Limitation of Liability)",
      "46:0688" : "46:0688 (46:688 Jones Act)",
      "46:0740" : "46:0740 (46:0740 Admiralty Extension Act)",
      "46:0741" : "46:0741 (46:741 Shipping)",
      "46:0761" : "46:0761 (46:761 Shipping: Damages for Death on High Seas)",
      "46:1101" : "46:1101 (46:1101 Violation of Maritime Regulations)",
      "46:1156" : "46:1156 (46:1156 Administrative Procedure Act)",
      "46:31325" : "46:31325 (46:31325 Shipping-Preferred Mortgage Liens and Enforcement)",
      "46:31342" : "46:31342 (46:31342 Establishing Maritime Liens)",
      "47:227" : "47:227 (47:227 Telephone Consumer Protection Act)",
      "47:332" : "47:332 (47:332 Telecommunications Act of 1996.)",
      "47:553" : "47:553 (47:553 Theft of Cable Services)",
      "47:605" : "47:605 (47:605 Unauthorized Publ./Use of Telecast for Comm Advantage)",
      "48:0883" : "48:0883 (48:883 Violation of US Coastal Law)",
      "48:1985" : "48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)",
      "49:0081" : "49:0081 (49:81 Damaged Goods While Being Transported)",
      "49:0781" : "49:0781 (49:781 Forfeiture)",
      "49:11503" : "49:11503 (49:11503 Railroad Revitalization Regulatory Reform)",
      "49:11702" : "49:11702 (49:11702(a)(4) Violations of Interstate Commerce A)",
      "49:1471" : "49:1471 (49:1471 Federal Aviation Act)",
      "49:1903" : "49:1903 (49:1903 Petition to enforce administrative summon)",
      "49:20109" : "49:20109 (49:20109 Employee Protections, Federal Railroad Safety Act)",
      "50:1701" : "50:1701 (50:1701-1706 International Emergency Economic Powers Act)",
      "50a:0001" : "50a:0001 (50a:1 Trading With the Enemy Act)",
      "50a:0501" : "50a:0501 (50a:501 Sailors and Soldiers Civil Relief Act)",
      "50a:0533" : "50a:0533 (50a:533 Servicemembers Civil Relief Act - Mortgages)",
      "50a:0540" : "50a:0540 (50a:540 Sailors and Soldiers Civil Relief Act)",
      "50a:2412" : "50a:2412 (50a:2412 Export Administration Act - 1979)",
      "51:20137a" : "51:20137a (51:20137a Malpractice & Negligence Against U.S. Space program)",
      "8:287" : "8:287 (8:287 Petition to Enforce INS Subpoena)",
      "99:9999" : "99:9999 (99:9999 Report cause code (DO NOT DELETE!))",
      "adsup" : "adsup (Administrative Subpoena)",
      "contempt" : "contempt (Contempt Proceedings)",
      "disbar" : "disbar (Disbarment Proceedings)",
      "fordepo" : "fordepo (Foreign Deposition)",
      "misc" : "misc (Civil Miscellaneous Case)",
      "motcomp" : "motcomp (Motion to Compel)",
      "motquash" : "motquash (Motion to Quash)",
      "motret" : "motret (Motion for Return of Property)",
      "petenf" : "petenf (Petition to Enforce IRS Summons)",
      "petper" : "petper (Petition to Perpetuate Testimony)",
      "regjgm" : "regjgm (Registration of Foreign Judgment)",
      "tranbkref" : "tranbkref (Transmission of Bankruptcy Reference)",
      "tranff" : "tranff (Transmission of Proposed Findings of Fact and Concl. of Law)",
      "writgar" : "writgar (Application for a Writ of Garnishment)"
   },
   "nysdce" : {
      "0" : "0 (No cause code entered)",
      "02:0138" : "02:0138 (02:138 Library of Congress Access)",
      "02:0358" : "02:0358 (02:358 President's Recommendations on Exec., Jud. & Leg. Salary)",
      "02:0431" : "02:0431 (02:431 Fed. Election Commission: Failure Enforce C)",
      "02:0437" : "02:0437 (02:437 Federal Election Commission)",
      "02:0681" : "02:0681 (02:681 Deferral of Budget Authority)",
      "02:1202" : "02:1202 (02:1202 Discriminatory practices affecting US Senate employees)",
      "02:1301" : "02:1301 (02:1301 Congressional Accountability Act)",
      "02:1317a" : "02:1317a (02:1317(a) Violation of Congressional Accountability Act)",
      "05:0075" : "05:0075 (05:75(2) Contract - Reduction in Grade)",
      "05:0101" : "05:0101 (05:101 Ethics in Government Act)",
      "05:0504" : "05:0504 (05:504(c)(2) Equal Access to Justice)",
      "05:0551" : "05:0551 (05:551 Administrative Procedure Act)",
      "05:0552b" : "05:0552b (05:552b(g)sa Implement requirements of Govt in Sunshine Act)",
      "05:0552fi" : "05:0552fi (05:552 Freedom of Information Act)",
      "05:0552nm" : "05:0552nm (05:552(a) Complaint in the Nature of Mandamus)",
      "05:0552pa" : "05:0552pa (05:552 Right to Privacy Act)",
      "05:0554" : "05:0554 (05:0554 Adjudications Required by Statutes)",
      "05:0555(b)" : "05:0555(b) (05:0555(b) Agency Decision - Right to Counsel)",
      "05:0701" : "05:0701 (05:0701 Maritime Subsidy Board)",
      "05:0702" : "05:0702 (05:702 Administrative Procedure Act)",
      "05:0704" : "05:0704 (05:704 Labor Litigation)",
      "05:0706" : "05:0706 (05:706(a) Writ of Mandamus)",
      "05:1508" : "05:1508 (05:1508 Judicial Review of Order Issued by the Merit Systems Protection Board)",
      "05:2302" : "05:2302 (05:2302 Federal Whistleblowing Act / Civil Service Reform Act (CSRA))",
      "05:3318" : "05:3318 (05:3318 Veterans Preference Act)",
      "05:5514" : "05:5514 (05:5514 Debt Collection Act of 1982)",
      "05:5542" : "05:5542 (05:5542 Federal Employees Pay Act -- overtime rates)",
      "05:7101" : "05:7101 (05:7101 Labor-Management Relations (Findings and Purpose))",
      "05:7123" : "05:7123 (05:7123 Petition by FLRA against unfair labor practices)",
      "05:7501" : "05:7501 (05:7501 Government Employees Adverse Action--14 days or less)",
      "05:7511" : "05:7511 (05:7511 Government Employees Adverse Action--Over 14 days)",
      "05:7703" : "05:7703 (05:7703 Discrimination - Review of Agency Act)",
      "05:8101" : "05:8101 (05:8101 Workmen's Compensation Benefits)",
      "05:8110" : "05:8110 (05:8110 Augmented Compensation for dependents of Govt. Employees)",
      "05:8316" : "05:8316 (05:8316 Claims agst US re Retirement for Federal Emp.)",
      "05:8470" : "05:8470 (05:8470 Enforcement of Judgment against Retirement Benefits)",
      "05:8701" : "05:8701 (05:8701 Federal Employees Group Life Insurance Act of 1954)",
      "05:8705" : "05:8705 (05:8705 Declaratory Judgment - Insurance)",
      "05:8715" : "05:8715 (05:8715 Claims against the US - Jurisdiction of Courts)",
      "05:8901" : "05:8901 (05:8901 Federal Employees Health Benefits Act)",
      "05:8902" : "05:8902 (05:8902 Contracting Authority of OPM - Group Health Insurance)",
      "05:8903" : "05:8903 (05:8903 Federal Employees Health Benefit Act)",
      "05:8912" : "05:8912 (05:8912 Claims agst US re health benefits for Federal emp.)",
      "07:0001" : "07:0001 (07:1 Personal Property)",
      "07:0004b" : "07:0004b (07:4(b) Agriculture, Commodity Exchanges)",
      "07:0006" : "07:0006 (7:6(b) Federal Commodity Exchange Regulation)",
      "07:0009a" : "07:0009a (07:0009a Recovery of penalties by Commodity Futures Trading Com)",
      "07:0013a" : "07:0013a (07:0013a Contract market rules violations; recovery of penalty)",
      "07:0013a-1" : "07:0013a-1 (07:0013a-1 Enjoin or restrain violations Contract Market rules)",
      "07:0025" : "07:0025 (7:25 Fraud - Commodities Leverage Contracts)",
      "07:0087" : "07:0087 (07:0087 Enforcement of United States Grain Standards Act)",
      "07:0136" : "07:0136 (07:0136 Violations of EPA re Environmental Pesticide Control)",
      "07:0181" : "07:0181 (07:181 Packers & Stockyard Act)",
      "07:0193(b)" : "07:0193(b) (07:0193(b) Recovery of penalties re violations by packers)",
      "07:0203" : "07:0203 (07:0203 Recovery of penalties for violations by stockyards)",
      "07:0209(b)" : "07:0209(b) (07:0209(b) Violations re purchase, sale, handling of livestock)",
      "07:0210(f)" : "07:0210(f) (07:0210(f) Suit to enforce award of damages (Packers/Stockyards))",
      "07:0213(b)" : "07:0213(b) (07:0213(b) Unfair, discriminatory, deceptive practice/marketing)",
      "07:0216" : "07:0216 (07:0216 Injunctions to restrain & enforce orders of Secretary)",
      "07:0222" : "07:0222 (07:0222 Adoption of FTC powers for enforcement)",
      "07:0228a" : "07:0228a (07:0228a Request by Secretary for TRO or Inj. re Poultry)",
      "07:0245" : "07:0245 (07:0245 Action on bond by person injured in Warehouse)",
      "07:0292" : "07:0292 (07:0292 Monopolizing or restraining trade & enhancing prices)",
      "07:0499" : "07:0499 (07:499 Agricultural Commodities Act)",
      "07:0601" : "07:0601 (07:601 USDA Condemnation)",
      "07:0608" : "07:0608 (07:0608 Agriculture Adjustment Act)",
      "07:0901" : "07:0901 (07:0901 Rural Electrification Act)",
      "07:1291(b)" : "07:1291(b) (07:1291(b) Agricultural Adjustment Act; freight rates)",
      "07:1376" : "07:1376 (07:1376 Adjustment of Quotas and Enforcement; penalties)",
      "07:1501" : "07:1501 (07:1501 Federal Crop Insurance Act)",
      "07:1508" : "07:1508 (07:1508 Crop Insurance)",
      "07:1631" : "07:1631 (07:1631 Food Security Act)",
      "07:1721" : "07:1721 (07:1721 Agricultural Trade Development Asst Act)",
      "07:1922" : "07:1922 (07:1922 Persons Eligible for Loans - Forclosure)",
      "07:1926" : "07:1926 (07:1926 Water and Waste Facility Loans and Grants)",
      "07:1930" : "07:1930 (07:1930 Perishable Agric. Comm. Act of 1930)",
      "07:2011" : "07:2011 (07:2011 Supplemental Nutrition Assistance Program)",
      "07:2022" : "07:2022 (07:2022 Disposition of Claims: Denial application to participate; food stamp prog)",
      "07:2023(a)" : "07:2023(a) (07:2023(a) Judicial Review of Food Stamp Disqualification)",
      "07:2024" : "07:2024 (07:2024 False Claims Act, Food Stamp Fraud)",
      "07:2131" : "07:2131 (07:2131 Violation of the Animal Welfare Act)",
      "07:2146" : "07:2146 (07:2146 Transportation, Sale, and Handling of Animals)",
      "07:2301" : "07:2301 (07:2301 Agricultural Fair Practices Act)",
      "07:2305" : "07:2305 (07:2305 Unfair trade practices affecting producers Agri prod)",
      "07:2321" : "07:2321 (07:2321 Plant Variety Protection Act)",
      "07:2563" : "07:2563 (07:2563 Plant Variety Protection and Rights - Injunction)",
      "07:6999" : "07:6999 (07:6999 Judicial Review of Adverse Farm Agency Decision)",
      "08:0274" : "08:0274 (08:274 Action for violation thereof illegal seizure in rem)",
      "08:0287" : "08:0287 (08:287 Petition to enforce INS Subpoena)",
      "08:0334" : "08:0334 (8 CFR 334.16(b) I.N.S.)",
      "08:1101" : "08:1101 (08:1101 Immigration & Nationality Act (Definitions))",
      "08:1105" : "08:1105 (08:1105(a) Immigration: Judicial Review for Battered Spouses; Deportation (INS))",
      "08:1151" : "08:1151 (08:1151 Immigration and Nationality Act of 1952)",
      "08:1152" : "08:1152 (08:1152 Immigration: Numerical limitations on individual foreign states)",
      "08:1153" : "08:1153 (08:1153 Immigration: Allocation of Immigrant Visas)",
      "08:1154" : "08:1154 (08:1154 Immigration: Procedure for Granting Immigration Status)",
      "08:1158" : "08:1158 (08:1158 Immigration & Nationality Act, Section 208 (Asylum))",
      "08:1182" : "08:1182 (08:1182 Inadmissible Aliens: Defend. Denial of Pla. Appl. for Alien Employment Cer)",
      "08:1183" : "08:1183 (08:1183 Admission of Aliens on Giving Bond or Undertaking; Return on Departure)",
      "08:1188" : "08:1188 (08:1188 Immigration: Admission of Temporary H-2A Workers)",
      "08:1225" : "08:1225 (08:1225 Immigration: Enforcement of Administrative Subpoena)",
      "08:1231(a)" : "08:1231(a) (08:1231(a)(6) Immigration: Due Process Clause)",
      "08:1251(A)" : "08:1251(A) (08:1251(A)(4) Immigration: Application for a Stay of Deportation)",
      "08:1252" : "08:1252 (08:1252 Judicial Review of Orders of Removal)",
      "08:1255" : "08:1255 (08:1255 Immigration: Failure USCIS To Adjudicate Permanent Residency Petition)",
      "08:1260" : "08:1260 (08:1260 Aliens: Removal of Aliens Falling into Distress)",
      "08:1324" : "08:1324 (08:1324 Aliens: Complaint for Forfeiture)",
      "08:1329" : "08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petiti)",
      "08:1357" : "08:1357 (08:1357 Immigration and Nationality Act - Administrative Search Warrant)",
      "08:1421" : "08:1421 (08:1421 Immigration: Naturalization Authority)",
      "08:1445" : "08:1445 (08:1445 Immigration: Application for Naturalization)",
      "08:1446" : "08:1446 (8:1446 Petition for Naturalization Hearing)",
      "08:1447" : "08:1447 (08:1447 Immigration: Review of Denial of Naturalization Application)",
      "08:1451" : "08:1451 (08:1451 Immigration: Revocation of Citizenship)",
      "08:1451(a)" : "08:1451(a) (08:1451(a)Action to revoke Citizenship)",
      "08:1451j" : "08:1451j (08:1451(j) Motion to Correct Order & Judg. of Naturalization)",
      "08:1503a" : "08:1503a (08:1503(a) Proceedings for Declaration of U.S. Nationality)",
      "09:0001" : "09:0001 (09:1 U.S. Arbitration Act)",
      "09:0003" : "09:0003 (09:0003 Application to Stay Proceedings Pending Arbitration)",
      "09:0004" : "09:0004 (09:4 Petition to order arbitration; failure to arbitrate)",
      "09:0005" : "09:0005 (09:5 Petition to Appoint Arbitrator)",
      "09:0007" : "09:0007 (09:7 Petition to compel attendance before arbitrator)",
      "09:0008" : "09:0008 (09:0008 Declaratory Judgment/Admiralty)",
      "09:0009" : "09:0009 (9:9 Motion to Confirm Arbitration Award)",
      "09:0010" : "09:0010 (09:0010 Petition to Vacate Arbitration Award)",
      "09:0011" : "09:0011 (09:0011 Motion to modify or correct arbitration award)",
      "09:0012" : "09:0012 (09:12 Petition to Vacate Arbitration Award)",
      "09:0201" : "09:0201 (09:201 Enforcement of Convention)",
      "09:0202" : "09:0202 (09:202 Award under Convention on Foreign Arbitral Awards)",
      "09:0203" : "09:0203 (09:203 Jurisdiction; amount in controversy)",
      "09:0204" : "09:0204 (09:204 Venue)",
      "09:0205" : "09:0205 (09:205 Removal from State Court: Enforcement of Foreign Arbital Awards)",
      "09:0206" : "09:0206 (09:206 Order to compel arbitration; appointment of arbitrators)",
      "09:0207" : "09:0207 (09:207 Application for order confirming award of arbitrators)",
      "09:0208" : "09:0208 (09:208 Chapter 1; residual application)",
      "09:0301" : "09:0301 (09:301 Enforcement of Convention)",
      "09:0302" : "09:0302 (09:302 Incorporation by reference)",
      "09:0303" : "09:0303 (09:303 Order to compel arbitration; appointment of arbitrators; locale)",
      "09:0304" : "09:0304 (09:304 Recognition and enforcement of foreign arbitral decisions and awards; reciprocity)",
      "09:0305" : "09:0305 (09:305 Relationship between the Inter-American Convention and the Convention on the Recognition)",
      "09:0306" : "09:0306 (09:306 Applicable rules of Inter-American Commercial Arbitration Commission)",
      "09:0307" : "09:0307 (09:307 Chapter 1; residual application)",
      "10:0672" : "10:0672 (10:672 Armed Forces: Active Guard/Reserve (AGR) Program)",
      "10:1006" : "10:1006 (10:1006 Armed Forces: Review of Agency Decision)",
      "10:1072tc" : "10:1072tc (10:1072tc Armed Forces: TRICARE PROGRAM)",
      "10:1089c" : "10:1089c (10:1089c Armed Forces: Removal; dft acting in scope of duties)",
      "10:1091" : "10:1091 (10:1091 Armed Forces: Personal Service Contracts)",
      "10:1107" : "10:1107 (10:1107 Armed Forces: Use Of Investigational New Drug)",
      "10:1408" : "10:1408 (10:1408 Armed Forces: Claim for Military Retirement)",
      "10:1552" : "10:1552 (10:1552 Armed Forces: Action to Correct Records)",
      "10:1553" : "10:1553 (10:1553 Armed Forces: Review of Discharge or Dismissal)",
      "10:2301" : "10:2301 (10:2301 Violation of Procurement Laws (REPEALED 10-13-1994))",
      "10:2305" : "10:2305 (10:2305 Armed Forces: Review of Federal Contract)",
      "10:2323fa" : "10:2323fa (10:2323fa Armed Forces: Fifth Amendment Equal Protection: Contract Goal for Small Disadvantaged Bus)",
      "10:2733" : "10:2733 (10:2733 Armed Forces: Military Claims Act)",
      "10:2734" : "10:2734 (10:2734 Armed Forces: Foreign Military Claims Act)",
      "10:2771" : "10:2771 (10:2771 Armed Forces: Final Settlement - Deceased Members)",
      "10:3258" : "10:3258 (10:3258 Armed Forces: Reg.Army: Re-enlistment after Service as Ofcr)",
      "11:0101" : "11:0101 (11:101 Bankruptcy)",
      "11:0110" : "11:0110 (11:110 Bankruptcy: Penalty for Preparers of Fraudulent or Negligent Petitions)",
      "11:0362(h)" : "11:0362(h) (11:362(h) Bankruptcy: Violation of Automatic Stay)",
      "11:0523" : "11:0523 (11:523 Bankruptcy: Exceptions to Discharge)",
      "11:0524" : "11:0524 (11:524 Bankruptcy: Effect of Discharge)",
      "11:0525" : "11:0525 (11:525 Bankruptcy: Protections Against Discriminatory Treatment)",
      "11:0541" : "11:0541 (11:541 Property of the Estate)",
      "11:0548" : "11:0548 (11:548 Bankruptcy: Fraudulent Transfers and Obligations)",
      "11:0704" : "11:0704 (11:704 Bankruptcy: Duties of Trustee)",
      "11:1110" : "11:1110 (11:1110 Appeal of Bankruptcy Court Order)",
      "12:0022" : "12:0022 (12:22 Securities Fraud)",
      "12:0085" : "12:0085 (12:85 National Banks: Rate of Interest on Loans, Discounts, and Purchases)",
      "12:0096(a)" : "12:0096(a) (12:93(a) National Banks: Violation of Provisions; Forfeiture of Franchise; Personal Liability of Di)",
      "12:0191" : "12:0191 (12:191 National Banks: Appointment of Receiver)",
      "12:0192" : "12:0192 (12:192 National Banks: Liquidation of National Bank)",
      "12:0632" : "12:0632 (12:632 Foreign Banking: Voluntary Liquidation)",
      "12:0635" : "12:0635 (12:635 Breach of Insurance Contract)",
      "12:0635i-3" : "12:0635i-3 (12:635i-3 Export-Import Bank: Breach of Insurance Contract)",
      "12:0725" : "12:0725 (12:725 Collection Under Contract Guaranty)",
      "12:1421" : "12:1421 (12:1421 Federal Home Loan Bank Act (Short Title))",
      "12:1441" : "12:1441 (12:1441FHLB: Financial Inst Reform Receiving Enforcement Act 1989)",
      "12:1451" : "12:1451 (12:1451 Emergency Home Loan Corporation (Definitions))",
      "12:1452" : "12:1452 (12:1452 Federal Home Loan Mortgage Corporation Act)",
      "12:1461" : "12:1461 (12:1461 Savings Associations: Homeowners Loan Act (Short Title))",
      "12:1464" : "12:1464 (12:1464 Savings Associations: Federal Savings and Loan)",
      "12:1703" : "12:1703 (12:1703 National Housing: Insurance of Financial Institutions)",
      "12:1715(b)" : "12:1715(b) (12:1715(b) National Housing: Rules and Regulations)",
      "12:1725" : "12:1725 (12:1725 Collection under Contract Guaranty)",
      "12:1730" : "12:1730 (12:1730 Collection Under Contract Guaranty)",
      "12:1749" : "12:1749 (12:1749 Federal Crime Insurance Program)",
      "12:1749aaa" : "12:1749aaa (12:1749aaa National Housing: National Insurance Development Program)",
      "12:1751" : "12:1751 (12:1751 Fed Credit Unions: Short Title)",
      "12:1782" : "12:1782 (12:1782 Fed Credit Unions: Administration of Insurance Fund)",
      "12:1786" : "12:1786 (12:1786 Fed Credit Unions: Actions re Violations by Credit Unions)",
      "12:1787(a)" : "12:1787(a) (12:1787(a)(B) Fed Credit Unions: Liquidation of Insured Credit Union by Board)",
      "12:1789(a)" : "12:1789(a) (12:1789(a)(2) Fed Credit Unions: Admin Provision to Sue and be Sued)",
      "12:1811" : "12:1811 (12:1811 FDIC: Financial Inst. Reform Recovery Act of 1989 (FIRREA) (Organization of FDIC))",
      "12:1818" : "12:1818 (12:1818 FDIC: Violations re Federal Deposit Insurance Corporation)",
      "12:1818(e)" : "12:1818(e) (12:1818(e)FDIC: Suspension or Removal of Bank Officer)",
      "12:1818f" : "12:1818f (12:1818(f) Stay of Suspension\\Prohibition in Credit Union)",
      "12:1819" : "12:1819 (12:1819 FDIC: Corporate Powers)",
      "12:1821" : "12:1821 (12:1821 FDIC: Insurance Funds)",
      "12:1831" : "12:1831 (12:1831 FDIC: Separability of Certain Provisions)",
      "12:1831(d)" : "12:1831(d) (12:1831(d) FDIC: Deposit. Inst. Dereg. & Monetary Ctrl. Act of 1980)",
      "12:1831j" : "12:1831j (12:1831j Depository Institution Employee Protection Remedy)",
      "12:1831r-1" : "12:1831r-1 (12:1831r-1 FDIC: Notice of Branch Closure)",
      "12:1833(a)" : "12:1833(a) (12:1833(a) FDIC: Forfieture Civil Penalties)",
      "12:1954" : "12:1954 (12:1954 Injunctions (Action by Sec of Treasury re financial recordkeeping))",
      "12:1971" : "12:1971 (12:1971 Relief under Bank Holding Company Act (Definitions))",
      "12:1972" : "12:1972 (12:1972 Tying Arrangement Act)",
      "12:2001" : "12:2001 (12:2001 Farm Credit Act of 1971)",
      "12:2601" : "12:2601 (12:2601 Real Estate Settlement Procedures Act (RESPA) (findings & purpose))",
      "12:2604(c)" : "12:2604(c) (12:2604(c) Real Estate Settlement Procedures Act (\"RESPA\"))",
      "12:2605" : "12:2605 (12:2605 RESPA: Servicing of Mortgage Loans)",
      "12:2607" : "12:2607 (12:2607 RESPA: Violation re kickbacks/unearned fees; Real Estate)",
      "12:2609" : "12:2609 (12:2609 RESPA: Escrow)",
      "12:3012" : "12:3012 (12:3012 National Consumer Cooperative Bank: Suits by or against Bank)",
      "12:3410" : "12:3410 (12:3410 Right to Financial Privacy: Customer Challenges)",
      "12:3751" : "12:3751 (12:3751 Single Family Mortgage Forclosure Act: Findings and Purpose)",
      "12:3801" : "12:3801 (12:3801 Alternative Mortgage Transaction Parity Act)",
      "12:3907" : "12:3907 (12:3907 International Lending Supervision: Capital Adequacy)",
      "12:4010" : "12:4010 (12:4010 Expedited Funds Availability: Violation of Act (Civil Liability))",
      "12:5101" : "12:5101 (12:5101 Fraudulent Transfer Act (Enforcement for Mortgage Licensing))",
      "15:0001" : "15:0001 (15:1 Antitrust Litigation (Monopolizing Trade))",
      "15:0002at" : "15:0002at (15:2 Antitrust Litigation)",
      "15:0002fl" : "15:0002fl (15:2(a) Fair Labor Standards Act)",
      "15:0004" : "15:0004 (15:4 USDC Jurisdiction re violations of Sec. 1-7 of Title 15)",
      "15:0005" : "15:0005 (15:5(a) Fair Labor Standards Act)",
      "15:0009" : "15:0009 (15:9 USDC Jurisdiction re violations of Sec. 8 of Title 15)",
      "15:0013" : "15:0013 (15:13 Robinson Patman Act)",
      "15:0014" : "15:0014 (15:14 Clayton Act)",
      "15:0015" : "15:0015 (15:15 Antitrust Litigation)",
      "15:0025" : "15:0025 (15:25 Clayton Act)",
      "15:0026" : "15:0026 (15:26 Suit for injunctive relief re violation antitrust laws)",
      "15:0041" : "15:0041 (15:41 Federal Trade Commission Act)",
      "15:0044" : "15:0044 (15:44 Trademark Infringement)",
      "15:0045" : "15:0045 (15:45 Federal Trade Commission Act (unfair or deceptive acts))",
      "15:0045cp" : "15:0045cp (15:45cp Violation of Children Online Privacy Protection Act)",
      "15:0052" : "15:0052 (15:0052 Federal Trade Commission Act)",
      "15:0053" : "15:0053 (15:0053 Federal Trade Commission Act)",
      "15:0053b" : "15:0053b (15:53b Prelim & Perm Inj Relief & other Equitable Relief)",
      "15:0068" : "15:0068 (15:68 Proceedings re FTC violations re wool products)",
      "15:0069" : "15:0069 (15:69 Proceedings re FTC violations re fur products)",
      "15:0070" : "15:0070 (15:70 Proceedings re FTC violations re textile fiber product)",
      "15:0077" : "15:0077 (15:77 Securities Fraud)",
      "15:0078" : "15:0078 (15:78m(a) Securities Exchange Act)",
      "15:0078j" : "15:0078j (15:78j(b)ss Stockholder Suit)",
      "15:0079" : "15:0079 (15:79 Public Utility Holding Companies)",
      "15:0080a-3" : "15:0080a-3 (15:80a-3 Investment Company Act of 1940)",
      "15:0260" : "15:0260 (15:260 Proceedings re weights and measures and standard time)",
      "15:0294" : "15:0294 (15:294 Breach of Contract)",
      "15:0298" : "15:0298 (15:298 Violation of Law Proceedings re gold or silver)",
      "15:0433" : "15:0433 (15:433 Discrimination against farmers)",
      "15:0631" : "15:0631 (15:631 Small Business Act)",
      "15:0636" : "15:0636 (15:636 Small Business Act - Aid to small business)",
      "15:0661" : "15:0661 (15:661 Small Business Investment Act of 1958)",
      "15:0687" : "15:0687 (15:687 Small Business Investment Program)",
      "15:0714(b)" : "15:0714(b) (15:714(b) Commodity Credit Corporation)",
      "15:0715(f)" : "15:0715(f) (15:715(f) Proceedings re petroleum and petroleum products)",
      "15:0717" : "15:0717 (15:717 Natural Gas Act)",
      "15:0719i" : "15:0719i (15:179i(c) Civil actions re violations or inj involving Gas)",
      "15:0754" : "15:0754 (15:754 Emergency Petroleum Allocation-Admin.& Enforcement)",
      "15:0766" : "15:0766 (15:766 Controversies arising re Federal Energy Admin. rules)",
      "15:1051" : "15:1051 (15:1051 Trademark Infringement)",
      "15:1071" : "15:1071 (15:1071 Appeal of Decision of U.S. Patent & Trademark Office (Comm / Trademark Trial Bd))",
      "15:1114" : "15:1114 (15:1114 Trademark Infringement (Lanham Act))",
      "15:1116" : "15:1116 (15:1116 Inj to prevent violation rights of trademark owner)",
      "15:1120" : "15:1120 (15:1120 Trademark - False or Fraudulent Registration)",
      "15:1121" : "15:1121 (15:1121 Trademark Infringement)",
      "15:1125" : "15:1125 (15:1125la Trademark Infringement (Lanham Act))",
      "15:1125(a)" : "15:1125(a) (15:1125 (a) False representation of goods sold in interstate commerce)",
      "15:1125(d)" : "15:1125(d) (15:1125(d)ac Trademark (Anticybersquatting consumer protection))",
      "15:1126" : "15:1126 (15:1126 Trademark - International Conventions)",
      "15:1127" : "15:1127 (15:1127 Trademark Infringement)",
      "15:1191" : "15:1191 (15:1191 Flamable Fabrics Act)",
      "15:1221" : "15:1221 (15:1221 Auto Dealer Suits Agst Manufacturers)",
      "15:1261" : "15:1261 (15:1261 Hazardous Substances (definitions))",
      "15:1263" : "15:1263 (15:1263 Prohibited Hazardous Substance - Interstate Commerce)",
      "15:1267(a)" : "15:1267(a) (15:1267(a) Federal Hazardous Substances Act)",
      "15:1314" : "15:1314 (15:1314 Antitrust--Petition for enforcement)",
      "15:1331" : "15:1331 (15:1331 Federal Cigarette Labeling & Advertising Act)",
      "15:1501" : "15:1501 (15:1501 Estab of Dept of Commerce)",
      "15:1601" : "15:1601 (15:1601 Truth in Lending)",
      "15:1605" : "15:1605 (15:1605 Determination of Finance Charge)",
      "15:1638" : "15:1638 (15:1638 Truth in Lending)",
      "15:1640" : "15:1640 (15:1640 Truth in Lending)",
      "15:1666" : "15:1666 (15:1666 Fair Credit Billing Act Dispute)",
      "15:1667" : "15:1667 (15:1667 Consumer Leasing Act)",
      "15:1679" : "15:1679 (15:1679 Violation of Credit Repair Organizations Act)",
      "15:1681" : "15:1681 (15:1681 Fair Credit Reporting Act)",
      "15:1691" : "15:1691 (15:1691 Equal Credit Opportunity Act)",
      "15:1692" : "15:1692 (15:1692 Fair Debt Collection Act)",
      "15:1693" : "15:1693 (15:1693ef Electronic Fund Transfer Act)",
      "15:1693m" : "15:1693m (15:1693m Violation of Prov. of Subchpt.VI (Electronic Fund Transfers))",
      "15:1701" : "15:1701 (15:1701 Interstate Land Sales Full Disclosure Act (ILFFDA))",
      "15:1709" : "15:1709 (15:1709 Interstate Land Sales)",
      "15:1714" : "15:1714 (15:1714 Actions to enjoin violations re interstate land sale)",
      "15:1938" : "15:1938 (15:1938 Fair Labor Standards Act)",
      "15:1981" : "15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))",
      "15:1988" : "15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))",
      "15:1989" : "15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))",
      "15:2071" : "15:2071 (15:2071 Consumer Product Safety; Condemnation hazardous prod)",
      "15:2073" : "15:2073 (15:2073 Private action to enforce Consumer Product Safety)",
      "15:2301" : "15:2301 (15:2301 Magnuson-Moss Warranty Act)",
      "15:2310(c)" : "15:2310(c) (15:2310(c) Consumer Product Warranties)",
      "15:2601" : "15:2601 (15:2601 Toxic Substances Control Act (TCSA))",
      "15:2604" : "15:2604 (15:2604 Application for inj re distribution toxic substance)",
      "15:2616" : "15:2616 (15:2616 Toxic Substance control; seizure of chemical)",
      "15:2620" : "15:2620 (15:2620 Toxic Substances Control Act: citizen's petition)",
      "15:2651" : "15:2651 (15:2651 Asbestos Hazard Emergency Response Act)",
      "15:2801" : "15:2801 (15:2801 Petroleum Marketing Practices Act)",
      "15:2805" : "15:2805 (15:2805 Petroleum Marketing Practices-Franchise Protection)",
      "15:34-35" : "15:34-35 (15:34-35 Investment Company Act of 1940)",
      "15:3414" : "15:3414 (15:3414 National Gas Policy Act)",
      "15:3607" : "15:3607 (15:3607 Condominium & Cooperative Abuse Act of 1980)",
      "16:0019jj" : "16:0019jj (16:19jj Park System Resource Protection Act)",
      "16:0470" : "16:0470 (16:470 Archaeological resources Protection Act)",
      "16:0470f" : "16:0470f (16:0470f National Historic Preservation Act)",
      "16:0668" : "16:0668 (16:668 Bald and Golden Eagle Protection Act)",
      "16:0669" : "16:0669 (16:669 Pittman-Robertson Conservation Restoration Act)",
      "16:0675" : "16:0675 (16:675 Norbeck Wildlife Preserve Organic Act)",
      "16:0703" : "16:0703 (16:703 Migratory Bird Act)",
      "16:0823a" : "16:0823a (16:823a Federal Public Utility Regulatory Policies Act)",
      "16:0825" : "16:0825 (16:0825 Federal Power Commission Regulation; Public Utilities)",
      "16:0831" : "16:0831 (16:0831 Actions re: rights of Tennessee Valley Authority)",
      "16:1244" : "16:1244 (16:1244 National Scenic and National Historic Trails)",
      "16:1374(d)" : "16:1374(d) (16:1374(d)(6) Petition for Review re Application for Import of Polar Bear Trophies)",
      "16:1531" : "16:1531 (16:1531 Endangered Species Act)",
      "16:1533" : "16:1533 (16:1533 Endangered Species Act)",
      "16:1538" : "16:1538 (16:1538 Endangered Species Act)",
      "16:1540" : "16:1540 (16:1540 Endangered Species Act - Penalties and Enforcement)",
      "16:1600" : "16:1600 (16:1600 National Forest Management Act of 1976)",
      "16:1801" : "16:1801 (16:1801 Magnuson-Stevens Fishery Conservation and Management Act)",
      "16:1858" : "16:1858 (16:1858 National Fishery Management Program - Civil Penalties and Permit Sanctions)",
      "16:3371" : "16:3371 (16:3371 Wildlife Under the Lacey Act)",
      "16:3372" : "16:3372 (16:3372 Lacey Act: Prohibited Acts)",
      "16:3373" : "16:3373 (16:3373 Lacey Act: Penalties and Sanctions - Appeal of Decision - DOI)",
      "16:3374" : "16:3374 (16:3374 Lacey Act: Complaint for Forfeiture)",
      "17:0043" : "17:0043 (17:43(a) Lanham Act)",
      "17:0101" : "17:0101 (17:101 Copyright Infringement)",
      "17:0201" : "17:0201 (17:201 Ownership of Copyright)",
      "17:0205(d)" : "17:0205(d) (17:205(d) Priority Between Conflicting Transfers)",
      "17:0407" : "17:0407 (17:407 Recovery of fines & penalties by Register of Copyrights)",
      "17:0411(b)" : "17:0411(b) (17:411(b) Action by copyright owner for infringement)",
      "17:0501" : "17:0501 (17:501 Copyright Infringement)",
      "17:0502(a)" : "17:0502(a) (17:502(a) Inj to prevent or restrain infringement copyright)",
      "17:0504" : "17:0504 (17:504 Remedies for Copyright Infringement)",
      "17:0512" : "17:0512 (17:512 Copyright Infringement of Digital Communications)",
      "17:1201" : "17:1201 (17:1201 Digital Millennium Copyright Act)",
      "18:0241" : "18:0241 (18:241 Conspiracy Against Citizen Rights)",
      "18:0492" : "18:0492 (18:492 Forfeiture of Counterfeit Paraphernalia)",
      "18:0603" : "18:0603 (18:603 Conflict of Interest)",
      "18:0922" : "18:0922 (18:922 Firearms - Unlawful Possession (Civil Fines))",
      "18:0923(f)" : "18:0923(f) (18:923(f)(3) Review of Revocation of a License as a Dealer in Firearms)",
      "18:0925(c)" : "18:0925(c) (18:925(c) Restoration of ability to possess firearms/ammo)",
      "18:0981" : "18:0981 (18:981 Civil Forfeiture)",
      "18:0981(a)" : "18:0981(a) (18:0981(a)(1)(A) Civil Forfeiture: Money Laundering Control Act)",
      "18:0983" : "18:0983 (18:983 Civil Forfeiture - General Rules)",
      "18:0984" : "18:0984 (18:984 Civil Forfeiture of Fungible Property)",
      "18:1030" : "18:1030 (18:1030 Fraud & Related Activity in Connection with Computers)",
      "18:1341" : "18:1341 (18:1341 Patent Infringement)",
      "18:1345" : "18:1345 (18:1345 Injunction against Fraud)",
      "18:1514" : "18:1514 (18:1514 Civil Action to Restrain Harassment of a Victim)",
      "18:1514A" : "18:1514A (18:1514A Civil Action to Protect Against Retaliation in Fraud Cases)",
      "18:1836a" : "18:1836a (18:1836(a) Injunction against Misappropriation of Trade Secrets)",
      "18:1836b" : "18:1836b (18:1836(b) Civil Action to Protect Trade Secrets)",
      "18:1905" : "18:1905 (18:1905 Disclosure of Confidential Information)",
      "18:1955" : "18:1955 (18:1955 Civil Forfeiture-Prohibition of Illegal Gambling)",
      "18:1956(b)" : "18:1956(b) (18:1956(b)(3) Laundering of Monetary Instruments - Forfeit Property)",
      "18:1961" : "18:1961 (18:1961 Racketeering (RICO) Act)",
      "18:1962" : "18:1962 (18:1962 Racketeering (RICO) Act)",
      "18:1964" : "18:1964 (18:1964 Civil Remedies: Racketeering (RICO) Act)",
      "18:1968" : "18:1968 (18:1968 Action re civil investigative demand)",
      "18:2254" : "18:2254 (18:2254 Civil Forfeiture - Exploitation of Children)",
      "18:2333" : "18:2333 (18:2333 Civil Remedies: Anti-Terrorism Act of 1991)",
      "18:2511" : "18:2511 (18:2511 Wiretapping - Injunctive Relief or Civil Fine)",
      "18:2707" : "18:2707 (18:2707 Civil Action: Stored Communications)",
      "18:2709" : "18:2709 (18:2709 Counterintelligence access to telephone toll and transactional records)",
      "18:2710(c)" : "18:2710(c) (18:2710(c) Wrongful Disclosure of Video Tape Rental or Sales Records)",
      "18:2724" : "18:2724 (18:2724 Civil Action - Motor Vehicle Records)",
      "18:3114" : "18:3114 (18:3114 Motion for Return of Seized Property)",
      "18:3184" : "18:3184 (18:3184 Extradition Procedure)",
      "18:3663" : "18:3663 (18:3663 Civil Enforcement of Crim. Rest. Obligation)",
      "18:3771" : "18:3771 (18:3771 Crime Victim's Rights)",
      "18:4100" : "18:4100 (18:4100 Transfer of Offenders)",
      "18:4208" : "18:4208 (18:4208(B) Agency Action Review)",
      "19:1305" : "19:1305 (19:1305 Customs Duties: Forfeiture-Immoral Articles)",
      "19:1497" : "19:1497 (19:1497 Customs Duties: Penalty for Failure to Declare)",
      "19:1595a" : "19:1595a (19:1595a Customs Duties: Forfeiture and Other Penalties)",
      "19:1607" : "19:1607 (19:1607 Customs Duties: Notice of Seizure)",
      "20:0107" : "20:0107 (20:107 Randolph-Sheppard Vending Stand Act)",
      "20:1070" : "20:1070 (20:1070 Student Assistance)",
      "20:1080" : "20:1080 (20:1080 Student Loan Recovery)",
      "20:1087" : "20:1087 (20:1087 Student Loan Discharge)",
      "20:1095a" : "20:1095a (20:1095a Education - Wage Garnishment Requirement)",
      "20:1097" : "20:1097 (20:1097 Education - Criminal penalties for fraud)",
      "20:1098g" : "20:1098g (20:1098g Higher Education Act - Exemption from state disclosure)",
      "20:1232(g)" : "20:1232(g) (20:1232(g) Family Education Rights & Privacy Act of 1974)",
      "20:1400" : "20:1400 (20:1400 IDEA: Individuals With Disabilities Education Act (short title))",
      "20:1401" : "20:1401 (20:1401 IDEA: Education of Individuals with Disabilities (definitions))",
      "20:1412" : "20:1412 (20:1412 IDEA: State Eligibility)",
      "20:1415" : "20:1415 (20:1415 IDEA: Challenge decision re education for handicapped)",
      "20:1415(e)" : "20:1415(e) (20:1415(e)(2)de IDEA: Mediation)",
      "20:1681" : "20:1681 (20:1681 Title IX Educational Amendments 1992 - Sex Discrimination)",
      "20:1683" : "20:1683 (20:1683 Judicial Review: Prohibition against sex discrimination in education)",
      "20:1706" : "20:1706 (20:1706 Relief from denial of equal educational opportunity)",
      "20:1717" : "20:1717 (20:1717 Reopening proceedings w/order to end segregation)",
      "21:0301" : "21:0301 (21:301 Federal Food, Drug & Cosmetic Act)",
      "21:0331" : "21:0331 (21:331 Federal Food, Drug & Cosmetic Act - Prohibited Acts)",
      "21:0332" : "21:0332 (21:332 Federal Food, Drug and Cosmetic Act, Injunctive Relief)",
      "21:0332(a)" : "21:0332(a) (21:332(a) Federal Food, Drug, and Cosmetic Act)",
      "21:0334(a)" : "21:0334(a) (21:334(a) Forfeiture or condemnation-food, drug, cosmetics)",
      "21:0348" : "21:0348 (21:348 Federal Food, Drug and Cosmetic Act - Food Additives)",
      "21:0360" : "21:0360 (21:360 Federal Food, Drug & Cosmetic Act - Drugs and Devices)",
      "21:0467" : "21:0467 (21:467 Seizure and condemnation of poultry products)",
      "21:0601" : "21:0601 (21:601 Federal Meat Inspection Act 21 USC 601-695 (Definitions))",
      "21:0673" : "21:0673 (21:673 Seizure and condemnation of meat or meat products)",
      "21:0674" : "21:0674 (21:674 Proceeding to enforce & enjoin re meat products)",
      "21:0821" : "21:0821 (21:821 Violation of Record Keeping Provision of Controlled Substance Act)",
      "21:0841" : "21:0841 (21:841 Forfeiture Property-Drugs)",
      "21:0842" : "21:0842 (21:842 Civil Penalty for violation re controlled substance)",
      "21:0881" : "21:0881 (21:881 Forfeiture Property-Drugs)",
      "21:0881a" : "21:0881a (21:881 Forfeiture Property - Aircraft)",
      "21:0881re" : "21:0881re (21:881 Forfeiture Property - Real Estate)",
      "21:0882" : "21:0882 (21:882 Inj to enjoin violations re controlled substance)",
      "21:1049" : "21:1049 (21:1049 Seizure and condemnation re eggs or egg products)",
      "22:0286" : "22:0286 (22:286 Action against World Bank or IMF)",
      "22:2702" : "22:2702 (22:2702 Medical Malpractice by Govt. Medical Personnel)",
      "22:3612" : "22:3612 (22:3612 Claim for Damage to Panama Canal)",
      "22:3776" : "22:3776 (22:3776 Panama Canal Commission Action on claims)",
      "22:3777" : "22:3777 (22:3777 Investigation of accident or injury giving rise to a claim)",
      "22:4140" : "22:4140 (22:4140 Foreign Service Grievance Act - Judicial Review)",
      "23:0112" : "23:0112 (23:112 Federal Highway Act - Letting of Contracts)",
      "23:0134" : "23:0134 (23:134 Metropolitan Transportation Planning)",
      "23:1441" : "23:1441 (23:1441 Contract Real Estate)",
      "24:1000" : "24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)",
      "25:0640" : "25:0640 (25:640 Indian Tribal Rights)",
      "25:1901" : "25:1901 (25:1901 Indian Child Welfare Act)",
      "26:0063" : "26:0063 (26:63 IRS: Taxable income (Definition))",
      "26:0401" : "26:0401 (26:401 Pension Plan Distribution)",
      "26:0982" : "26:0982 (26:982 IRS: To Quash IRS Formal Document Request)",
      "26:2032" : "26:2032 (26:2032 IRS: Alternate valuation)",
      "26:6212" : "26:6212 (26:6212 IRS: Notice of Deficiency (Injunctive Relief from IRS Lien))",
      "26:6213" : "26:6213 (26:6213 IRS: Injunctive Relief from IRS Lien in Tax Court)",
      "26:6221" : "26:6221 (26:6221 IRS: TEFRA Tax, Equity and Fiscal Responsibility Act of 1982)",
      "26:6226" : "26:6226 (26:6226 IRS: Judicial Review of Partnership Adjustment)",
      "26:6320" : "26:6320 (26:6320 IRS: Notice and Opportunity for Hearing upon Filing Notice of Lien)",
      "26:6330" : "26:6330 (26:6330 IRS: Notice and Opportunity for Hearing before Levy)",
      "26:6331" : "26:6331 (26:6331 IRS: Wrongful Levy)",
      "26:6334" : "26:6334 (26:6334 IRS: Property Exempt from Levy)",
      "26:6502" : "26:6502 (26:6502 IRS: Collection after Assessment (Enforcement of tax liens))",
      "26:6532" : "26:6532 (26:6532 IRS: Periods of Limitation on Suits)",
      "26:6653sp" : "26:6653sp (26:6653sp IRS: Failure to Pay Stamp Tax)",
      "26:6672" : "26:6672 (26:6672 IRS: Failure to Collect and Pay Over Tax, or Attempt to Evade or Defeat Tax)",
      "26:6694" : "26:6694 (26:6694 IRS: Underestimate Of Tax Liability By Tax Preparer)",
      "26:6702" : "26:6702 (26:6702 IRS: Penalty for Frivolous Tax Submission)",
      "26:6703" : "26:6703 (26:6703 IRS: Refund of Tax Penalty)",
      "26:7401" : "26:7401 (26:7401 IRS: Tax Liability - Authorization to collect via civil action)",
      "26:7402" : "26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)",
      "26:7403" : "26:7403 (26:7403 Suit to Enforce Federal Tax Lien)",
      "26:7404" : "26:7404 (26:7404 IRS: Action for collection of estate tax)",
      "26:7405" : "26:7405 (26:7405 IRS: Action for recovery of refunds erroneously made)",
      "26:7407" : "26:7407 (26:7407 IRS: Action to enjoin income tax preparers)",
      "26:7422" : "26:7422 (26:7422 Refund of Income Tax)",
      "26:7422rt" : "26:7422rt (26:7422 IRS: Refund Taxes)",
      "26:7422rx" : "26:7422rx (26:7422 IRS: Refund Excise Tax)",
      "26:7426" : "26:7426 (26:7426 IRS: Wrongful Levy for Taxes)",
      "26:7428" : "26:7428 (26:7428 IRS: Declaratory Judgment)",
      "26:7429" : "26:7429 (26:7429 IRS: Tax Jeopardy Assessment)",
      "26:7430" : "26:7430 (26:7430 IRS: Awarding of Costs and Certain Fees in Tax Suit)",
      "26:7431" : "26:7431 (26:7431 IRS: Unauthorized Disclosure of Return & Return Info)",
      "26:7434" : "26:7434 (26:7434 IRS: Civil Damages for Fraudulent Filing of Information)",
      "26:7604" : "26:7604 (26:7604 IRS: Enforce summons; examination books & witnesses)",
      "26:7604(a)" : "26:7604(a) (26:7604(a) IRS: Complaint to Enforce IRS Summons)",
      "26:7609" : "26:7609 (26:7609 IRS: Petition to Quash IRS Summons)",
      "26:7609en" : "26:7609en (26:7609en IRS: Petition to serve Third-Party Summons)",
      "27:0185" : "27:0185 (27:185 Enforcement of Arbitration Award)",
      "28:0157" : "28:0157 (28:157 Motion to Withdraw Reference)",
      "28:0157(b)" : "28:0157(b) (28:157(b) Bankruptcy Claim to be tried in U.S. District Court)",
      "28:0157c" : "28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)",
      "28:0157d" : "28:0157d (28:0157 Motion for Withdrawal of Reference)",
      "28:0158" : "28:0158 (28:0158 Notice of Appeal re Bankruptcy Matter (BA)",
      "28:0185" : "28:0185 (28:185 Suit to Compel Arbitration)",
      "28:0451" : "28:0451 (28:451 Employment Discrimination)",
      "28:0463" : "28:0463 (28:463 Expenses of Judicial Litigation)",
      "28:0534" : "28:0534 (28:534 Arrest Records)",
      "28:0591" : "28:0591 (28:591 Independent Counsel)",
      "28:0592" : "28:0592 (28:592 Independent Counsel - Application for Appointment)",
      "28:0593" : "28:0593 (28:593 Independent Counsel - Court Responsibilities)",
      "28:0594" : "28:0594 (28:594 Independent Counsel - Responsibilities)",
      "28:0595" : "28:0595 (28:595 Independent Counsel - Congressional Oversight)",
      "28:0596" : "28:0596 (28:596 Independent Counsel - Removal)",
      "28:0597" : "28:0597 (28:597 Independent Counsel - Dept. of Justice Relationship)",
      "28:0598" : "28:0598 (28:598 Independent Counsel - Chapter Termination)",
      "28:0636" : "28:0636 (28:636 Jurisdiction and Power of Magistrate Judges)",
      "28:0754" : "28:0754 (28:754 Receiver of Property in Different Districts)",
      "28:0794" : "28:0794 (28:794 Rehabilitation Act)",
      "28:1001" : "28:1001 (28:1001 E.R.I.S.A.)",
      "28:1132" : "28:1132 (28:1132 E.R.I.S.A.)",
      "28:1291" : "28:1291 (28:1291 Maritime)",
      "28:1330" : "28:1330 (28:1330 Breach of Contract)",
      "28:1331" : "28:1331 (28:1331 Fed. Question)",
      "28:1331ag" : "28:1331ag (28:1331ag Fed. Question: Employment Discrimination (Age))",
      "28:1331al" : "28:1331al (28:1331al Fed. Question: Airline Crash)",
      "28:1331as" : "28:1331as (28:1331as Fed. Question: Assault, Libel, Slander)",
      "28:1331at" : "28:1331at (28:1331at Fed. Question: Anti-trust)",
      "28:1331au" : "28:1331au (28:1331au Fed. Question: Auto Negligence)",
      "28:1331b" : "28:1331b (28:1331b Fed. Question: Bivens Act)",
      "28:1331bc" : "28:1331bc (28:1331bc Fed. Question: Breach of Contract)",
      "28:1331bv" : "28:1331bv (28:1331bv Fed. Question: Bivens-Prisoner)",
      "28:1331ca" : "28:1331ca (28:1331ca Fed Question: Fed Communications Act)",
      "28:1331cm" : "28:1331cm (28:1331cm Fed. Question: Interstate Commerce Act)",
      "28:1331cr" : "28:1331cr (28:1331cr Fed. Question: Civil Rights (Race Discrimination))",
      "28:1331cv" : "28:1331cv (28:1331cv Fed. Question: Other Civil Rights)",
      "28:1331dd" : "28:1331dd (28:1331dd Fed. Question: Discovery Disputes (conversion case))",
      "28:1331dj" : "28:1331dj (28:1331dj Fed. Question: Declaratory Judgment)",
      "28:1331dp" : "28:1331dp (28:1331dp Fed. Question: Violation of Due Process)",
      "28:1331ed" : "28:1331ed (28:1331ed Fed. Question: Employment Discrimination)",
      "28:1331ef" : "28:1331ef (28:1331ef Fed. Question: Civil Rights Violation (Excess Force))",
      "28:1331ej" : "28:1331ej (28:1331ej Fed. Question: Enforcement of Judgment)",
      "28:1331es" : "28:1331es (28:1331es Fed. Question: Enforcement of Administrative Subpoena)",
      "28:1331fa" : "28:1331fa (28:1331fa Fed. Question: Civil Rights Violation-False Arrest)",
      "28:1331fl" : "28:1331fl (28:1331fl Fed. Question: Fair Labor Standards)",
      "28:1331fm" : "28:1331fm (28:1331fm Fed. Question: Family and Medical Leave Act)",
      "28:1331fr" : "28:1331fr (28:1331fr Fed. Question: Fraud)",
      "28:1331in" : "28:1331in (28:1331in Fed. Question: Insurance Contract)",
      "28:1331mm" : "28:1331mm (28:1331mm Fed. Question: Medical Malpractice)",
      "28:1331ng" : "28:1331ng (28:1331ng Fed. Question: Natural Gas Act)",
      "28:1331ni" : "28:1331ni (28:1331ni Fed. Question: Negotiable Instrument)",
      "28:1331ot" : "28:1331ot (28:1331 Fed. Question: Other)",
      "28:1331pd" : "28:1331pd (28:1331pd Fed. Question: Property Damage)",
      "28:1331pi" : "28:1331pi (28:1331pi Fed. Question: Personal Injury)",
      "28:1331pl" : "28:1331pl (28:1331pl Fed. Question: Product Liability)",
      "28:1331pr" : "28:1331pr (28:1331pr Fed. Question: Federal Prisoner Civil Rights)",
      "28:1331ra" : "28:1331ra (28:1331ra Fed. Question: Racketeering (RICO) Act)",
      "28:1331rc" : "28:1331rc (28:1331rc Fed. Question: Reclamation Project Auth. Act of 1972)",
      "28:1331rd" : "28:1331rd (28:1331rd Fed. Question: Review Agency Decision)",
      "28:1331rp" : "28:1331rp (28:1331(a)rp Fed. Question: Real Property)",
      "28:1331rr" : "28:1331rr (28:1331rr Fed. Question: Real Property)",
      "28:1331rs" : "28:1331rs (28:1331rs Fed. Question: Federal Rail Safety Act)",
      "28:1331sh" : "28:1331sh (28:1331sh Fed. Question: Sexual Harassment)",
      "28:1331ss" : "28:1331ss (28:1331ss Fed. Question: Constitutionality of State Statutes)",
      "28:1331sv" : "28:1331sv (28:1331sv Fed. Question: Securities Violation)",
      "28:1331sx" : "28:1331sx (28:1331sx Fed. Question: Employment Discrimination (Sex))",
      "28:1331tr" : "28:1331tr (28:1331tr Fed. Question: Trademark)",
      "28:1331tra" : "28:1331tra (28:1331(a)tra Fed. Question: Air Transportation)",
      "28:1331tt" : "28:1331tt (28:1331tt Fed. Question: Tort Action)",
      "28:1331v" : "28:1331v (28:1331v Fed. Question: Violation 5th & 8th Amendments)",
      "28:1331va" : "28:1331va (28:1331va Fed. Question: Violation 5th & 14th Amendment)",
      "28:1331vc" : "28:1331vc (28:1331vc Fed. Question: Violation of Constitutional Rights)",
      "28:1331w" : "28:1331w (28:1331w Fed. Question: Wrongful Termination of Employment)",
      "28:1331wd" : "28:1331wd (28:1331wd Fed. Question: Wrongful Death)",
      "28:1331wl" : "28:1331wl (28:1331wl Fed. Question: EPA Waste Lien)",
      "28:1331wt" : "28:1331wt (28:1331wt Fed. Question: Water Rights)",
      "28:1332" : "28:1332 (28:1332 Diversity Action)",
      "28:1332ac" : "28:1332ac (28:1332ac Diversity-Account Receivable)",
      "28:1332al" : "28:1332al (28:1332al Diversity-Airline Crash)",
      "28:1332ap" : "28:1332ap (28:1332ap Diversity-Airplane Product Liability)",
      "28:1332as" : "28:1332as (28:1332as Diversity-Asbestos Litigation)",
      "28:1332au" : "28:1332au (28:1332au Diversity-Auto Negligence)",
      "28:1332bc" : "28:1332bc (28:1332bc Diversity-Breach of Contract)",
      "28:1332bw" : "28:1332bw (28:1332bw Diversity -Breach of Warranty)",
      "28:1332co" : "28:1332co (28:1332co Diversity-Conversion)",
      "28:1332ct" : "28:1332ct (28:1332ct Diversity-(Citizenship))",
      "28:1332det" : "28:1332det (28:1332de Diversity: Forcible Detainer)",
      "28:1332df" : "28:1332df (28:1332df Diversity-Contract Default)",
      "28:1332ds" : "28:1332ds (28:1332ds Diversity-Contract Dispute)",
      "28:1332dtp" : "28:1332dtp (28:1332dtp Diversity - Deceptive Trade Practices)",
      "28:1332ed" : "28:1332ed (28:1332ed Diversity-Employment Discrimination)",
      "28:1332ej" : "28:1332ej (28:1332ej Diversity-Enforcement of Judgment)",
      "28:1332fc" : "28:1332fc (28:1332fc Diversity - Foreclosure)",
      "28:1332fd" : "28:1332fd (28:1332fd Diversity-Breach of Fiduciary Duty)",
      "28:1332fr" : "28:1332fr (28:1332fr Diversity-Fraud)",
      "28:1332ia" : "28:1332ia (28:1332ia Diversity-Interpleader Action)",
      "28:1332if" : "28:1332if (28:1332if Diversity- Insurance Fraud)",
      "28:1332ij" : "28:1332ij (28:1332ij Diversity-Injunctive & Declaratory Relief)",
      "28:1332in" : "28:1332in (28:1332in Diversity-Insurance Contract)",
      "28:1332jd" : "28:1332jd (28:1332jd Diversity-Declaratory Judgement)",
      "28:1332lb" : "28:1332lb (28:1332lb Diversity-Libel, Assault, Slander)",
      "28:1332lm" : "28:1332lm (28:1332lm Diversity - Legal Malpractice)",
      "28:1332lp" : "28:1332lp (28:1332lp Diversity-Property Damage/Product Liability)",
      "28:1332lr" : "28:1332lr (28:1332lr Diversity - Labor)",
      "28:1332m" : "28:1332m (28:1332m Diversity: Legal Malpractice)",
      "28:1332ma" : "28:1332ma (28:1332ma Diversity-Miller Act)",
      "28:1332md" : "28:1332md (28:1332md Diversity-Motor Vehicle/Wrongful Death)",
      "28:1332mm" : "28:1332mm (28:1332mm Diversity-Medical Malpractice)",
      "28:1332mv" : "28:1332mv (28:1332mv Diversity-Motor Vehicle Product Liability)",
      "28:1332ni" : "28:1332ni (28:1332ni Diversity-Negotiable Instrument)",
      "28:1332nm" : "28:1332nm (28:1332nm Diversity-Non-Motor Vehicle)",
      "28:1332nr" : "28:1332nr (28:1332nr Diversity: Notice of Removal)",
      "28:1332oc" : "28:1332oc (28:1332oc Diversity-Other Contract)",
      "28:1332op" : "28:1332op (28:1332op Diversity-Recovery of Overpayment)",
      "28:1332pd" : "28:1332pd (28:1332pd Diversity-Property Damage)",
      "28:1332pi" : "28:1332pi (28:1332pi Diversity-Personal Injury)",
      "28:1332pl" : "28:1332pl (28:1332pl Diversity-Product Liability)",
      "28:1332pm" : "28:1332pm (28:1332pm Diversity: Promissory Note)",
      "28:1332pr" : "28:1332pr (28:1332pr Diversity-Petition for Removal)",
      "28:1332qt" : "28:1332qt (28:1332qt Diversity-Petition to Quiet Title)",
      "28:1332rd" : "28:1332rd (28:1332rd Diversity-Recovery of Debt)",
      "28:1332ri" : "28:1332ri (28:1332ri Diversity-Racketeering (RICO) Act)",
      "28:1332rl" : "28:1332rl (28:1332rl Diversity-Rent Lease & Ejectment)",
      "28:1332rp" : "28:1332rp (28:1332rp Diversity-Real Property)",
      "28:1332sa" : "28:1332sa (28:1332sa Diversity: Securities & Exchange Commiss)",
      "28:1332sf" : "28:1332sf (28:1332sf Diversity: Securities Fraud)",
      "28:1332sh" : "28:1332sh ( 28:1332sh Diversity-Sexual Harassment)",
      "28:1332ss" : "28:1332ss (28:1332ss Diversity - Stockholders Suits)",
      "28:1332t" : "28:1332t (28:1332t Diversity-Torts)",
      "28:1332tl" : "28:1332tl (28:1332tl Diversity-Torts to Land)",
      "28:1332tm" : "28:1332tm (28:1332tm Diversity-Tort/Motor Vehicle (P.I.))",
      "28:1332tn" : "28:1332tn (28:1332tn Diversity-Tort/Non-Motor Vehicle)",
      "28:1332wd" : "28:1332wd (28:1332wd Diversity-Wrongful Death)",
      "28:1333" : "28:1333 (28:1333ad Admiralty)",
      "28:1333in" : "28:1333in (28:1333in Personal Injury)",
      "28:1333mc" : "28:1333mc (28:1333mc Marine Contract)",
      "28:1333pd" : "28:1333pd (28:1333pd Property Damage)",
      "28:1333pi" : "28:1333pi (28:1333pi Marine Personal Injury)",
      "28:1334" : "28:1334 (28:1334 Bankruptcy Appeal)",
      "28:1334(b)" : "28:1334(b) (28:1334(b) Proceeding arising/related to case under title 11)",
      "28:1334c" : "28:1334c (28:1334(c) R&R re motions for abstention)",
      "28:1335" : "28:1335 (28:1335 Interpleader Action)",
      "28:1337" : "28:1337 (28:1337sc Sherman-Clayton Act)",
      "28:1338cp" : "28:1338cp (28:1338cp Copyright Infringement)",
      "28:1338pt" : "28:1338pt (28:1338pt Patent Infringement)",
      "28:1338tr" : "28:1338tr (28:1338tr Trademark Infringement)",
      "28:1339" : "28:1339 (28:1339 Postal matters)",
      "28:1340" : "28:1340 (28:1340 IRS: Custom Duties)",
      "28:1340er" : "28:1340er (28:1340 Recovery of Erroneous Refund)",
      "28:1340tp" : "28:1340tp (28:1340tp Jurisdiction of Internal Revenue Matters; Customs Duties)",
      "28:1341" : "28:1341 (28:1341 Complaint for Forfeiture)",
      "28:1343" : "28:1343 (28:1343 Violation of Civil Rights)",
      "28:1344" : "28:1344 (28:1344 Election disputes)",
      "28:1345" : "28:1345 (28:1345 USA Plaintiff)",
      "28:1345co" : "28:1345co (28:1345co Replevin & Conversion)",
      "28:1345db" : "28:1345db (28:1345db Debt to US - FHA/HUD Title I)",
      "28:1345df" : "28:1345df (28:1345df Default of Promissory Note)",
      "28:1345er" : "28:1345er (28:1345er Recovery of Erroneous Refund)",
      "28:1345fc" : "28:1345fc (28:1345fc Foreclosure)",
      "28:1345ff" : "28:1345ff (28:1345ff Complaint for Forfeiture)",
      "28:1345hl" : "28:1345hl (28:1345hl VA Home Loan Guaranty Debt)",
      "28:1345lc" : "28:1345lc (28:1345lc Land Condemnation)",
      "28:1345mc" : "28:1345mc (28:1345mc Medical Care Recovery)",
      "28:1345mi" : "28:1345mi (28:1345mi Mining Claim Ejectment)",
      "28:1345pd" : "28:1345pd (28:1345pd Property Damage)",
      "28:1345pe" : "28:1345pe (28:1345pe Property Ejectment)",
      "28:1345rc" : "28:1345rc (28:1345rc Recovery of Debt to US)",
      "28:1345ro" : "28:1345ro (28:1345ro Recovery of Retirement Overpayment)",
      "28:1345st" : "28:1345st (28:1345st Default of Student Loan)",
      "28:1345tp" : "28:1345tp (28:1345tp Trespass on Public Land)",
      "28:1345va" : "28:1345va (28:1345va Recovery of VA Overpayment)",
      "28:1346" : "28:1346 (28:1346 U.S. Defendant)",
      "28:1346bc" : "28:1346bc (28:1346bc Breach of Contract)",
      "28:1346pi" : "28:1346pi (28:1346pi Marine Personal Injury (or tort claim - personal injury / motor vehicle))",
      "28:1346rc" : "28:1346rc (28:1346rc Recovery of IRS Tax)",
      "28:1346tc" : "28:1346tc (28:1346t Tort Claim)",
      "28:1346wd" : "28:1346wd (28:1346wd Wrongful Death)",
      "28:1348" : "28:1348 (28:1348 Banking association as party)",
      "28:1349" : "28:1349 (28:1349 Corporation organized under Federal Law as party)",
      "28:1350" : "28:1350 (28:1350 Alien Tort Claims Act)",
      "28:1352" : "28:1352 (28:1352 Miller Act)",
      "28:1355" : "28:1355 (28:1355 Petition for Return of Property)",
      "28:1356" : "28:1356 (28:1356 Executory Process/Foreclosure)",
      "28:1358" : "28:1358 (28:1358 Land Condemnation)",
      "28:1361" : "28:1361 (28:1361 Petition for Writ of Mandamus)",
      "28:1361pr" : "28:1361pr (28:1361pr Complaint for mandamus relief (prisoner))",
      "28:1362ic" : "28:1362ic (28:1362 Indian Tribal Controversy)",
      "28:1362iw" : "28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)",
      "28:1363" : "28:1363 (28:1363 Action for protection of jurors employment rights)",
      "28:1364" : "28:1364 (28:1364 Auto Negligence)",
      "28:1367" : "28:1367 (28:1367 Other Property Damage)",
      "28:1391" : "28:1391 (28:1391 Personal Injury)",
      "28:1394" : "28:1394 (28:1394 Banking Association against Comptroller of Currency)",
      "28:1395" : "28:1395 (28:1395 Complaint for Forfeiture)",
      "28:1400" : "28:1400 (28:1440(a) Copyright Infringement)",
      "28:1402" : "28:1402 (28:1402 Medical Malpractice)",
      "28:1403" : "28:1403 (28:1403 Condemnation of real estate for the use of the US)",
      "28:1407" : "28:1407 (28:1407 Airline Crash)",
      "28:1407im" : "28:1407im (28:1407im MDL: Silicone Gel Breast Implant Products Liability)",
      "28:1407md" : "28:1407md (28:1407md MDL: Multidistrict Litigation)",
      "28:1407n" : "28:1407n (28:1407n MDL: Personal Injury/Norplant Product Liability)",
      "28:1407pl" : "28:1407pl (28:1407pl MDL: Products Liability)",
      "28:1441ac" : "28:1441ac (28:1441ac Petition for Removal- Account Receivable)",
      "28:1441ada" : "28:1441ada (28:1441ada Removal- Americans with Disabilities Act)",
      "28:1441ag" : "28:1441ag (28:1441ag Removal- Civil Rights (Age))",
      "28:1441al" : "28:1441al (28:1441al Petition for Removal- Airline Crash)",
      "28:1441as" : "28:1441as (28:1441as Petition for Removal- Asbestos Litigation)",
      "28:1441au" : "28:1441au (28:1441au Petition for Removal- Auto Negligence)",
      "28:1441ba" : "28:1441ba (28:1441ba Removal - National Bank Act)",
      "28:1441bc" : "28:1441bc (28:1441 Petition for Removal- Breach of Contract)",
      "28:1441bfd" : "28:1441bfd (28:1441bfd Removal- Breach of Fiduciary Duties)",
      "28:1441ca" : "28:1441ca (28:1441ca Removal - Carmack Amendment)",
      "28:1441cc" : "28:1441cc (28:1441cc Removal- Computer Crimes Act)",
      "28:1441cj" : "28:1441cj (28:1441cj Removal- Confessed Judgment)",
      "28:1441cl" : "28:1441cl (28:1441cla Removal - Consumer Leasing Act)",
      "28:1441cp" : "28:1441cp (28:1441cp Removal- Copyright)",
      "28:1441cpl" : "28:1441cpl (28:1441cpl Removal - Contract Product Liability)",
      "28:1441cra" : "28:1441cra (28:1441cra Removal - Fair Credit Reporting Act)",
      "28:1441cv" : "28:1441cv (28:1441cv Petition for Removal- Civil Rights Act)",
      "28:1441dea" : "28:1441dea (28:1441dea Removal - Disabilities Education Act)",
      "28:1441df" : "28:1441df (28:1441df Petition for Removal- Contract Default)",
      "28:1441di" : "28:1441di (28:1441di Removal- Civil Rights (Disability Act))",
      "28:1441dj" : "28:1441dj (28:1441dj Petition for Removal- Declaratory Judgment)",
      "28:1441ds" : "28:1441ds (28:1441ds Petition for Removal- Contract Dispute)",
      "28:1441ea" : "28:1441ea (28:1441ea Removal - Employment Discrimination)",
      "28:1441eb" : "28:1441eb (28:1441eb Removal- Employment Discrimination (Sex))",
      "28:1441ec" : "28:1441ec (28:1441ec Removal- Employment Discrimination (Age))",
      "28:1441ed" : "28:1441ed (28:1441ed Petition for Removal - Employment Discrim)",
      "28:1441em" : "28:1441em (28:1441em Removal - Electronic Comm. Privacy Act)",
      "28:1441er" : "28:1441er (28:1441er Removal - Emergency Medical Treatment & Active Labor)",
      "28:1441es" : "28:1441es (28:1441es Removal- Employment Discrimination (Race))",
      "28:1441fa" : "28:1441fa (28:1441fa Removal - E.R.I.S.A. Employee Benefits)",
      "28:1441fc" : "28:1441fc (28:1441fc Petition for Removal - Fair Credit Report)",
      "28:1441fd" : "28:1441fd (28:1441fd Removal - Fair Debt Collection Practices Act)",
      "28:1441fe" : "28:1441fe (28:1441fe Removal- Fed. Employee Garnishment Statute)",
      "28:1441fh" : "28:1441fh (28:1441fh Removal- FEHBA)",
      "28:1441fif" : "28:1441fif (28:1441fif Removal - Insecticide/Fungicide/Rodenticide Act -1942)",
      "28:1441fl" : "28:1441fl (28:1441fl Removal- Fair Labor Standards Act)",
      "28:1441fm" : "28:1441fm (28:1441fm Removal - Family and Medical Leave Act)",
      "28:1441fr" : "28:1441fr (28:1441fr Petition for Removal- Fraud)",
      "28:1441fs" : "28:1441fs (28:1441fs Removal - Foreign Sovereign Immunities Act)",
      "28:1441fsa" : "28:1441fsa (28:1441fsa Removal - Federal Food Stamp Act)",
      "28:1441hb" : "28:1441hb (28:1441hb Removal - Petition of Habeas Corpus)",
      "28:1441hc" : "28:1441hc (28:1441hc Removal - Handicapped Child Protection Act)",
      "28:1441hd" : "28:1441hd (28:1441hd Removal- Housing Discrimination)",
      "28:1441ia" : "28:1441ia (28:1441ia Removal- Interstate Commerce Act)",
      "28:1441if" : "28:1441if (28:1441if Removal - Insurance Fraud)",
      "28:1441ij" : "28:1441ij (28:1441ij Petition for Removal- Injunctive/Declarato)",
      "28:1441il" : "28:1441il (28:1441il Removal- Interstate Land Full Discloser Act)",
      "28:1441in" : "28:1441in (28:1441in Petition for Removal- Insurance Contract)",
      "28:1441int" : "28:1441int (28:1441int Petition for Removal- Action for Interplea)",
      "28:1441la" : "28:1441la (28:1441la Removal - Truth in Lending Act)",
      "28:1441lb" : "28:1441lb (28:1441lb Petition for Removal Libel,Assault,Slander)",
      "28:1441lm" : "28:1441lm (28:1441lm Petition for Removal- Labor/Mgmnt. Relatio)",
      "28:1441mm" : "28:1441mm (28:1441mm Petition for Removal- Medical Malpractice)",
      "28:1441mv" : "28:1441mv (28:1441mv Removal- Motor Vehicle)",
      "28:1441ni" : "28:1441ni (28:1441ni Petition for Removal- Negotiable Instrumen)",
      "28:1441nm" : "28:1441nm (28:1441nm Petition for Removal- Non-Motor Vehicle)",
      "28:1441nr" : "28:1441nr (28:1441nr Notice of Removal)",
      "28:1441oc" : "28:1441oc (28:1441oc Petition For Removal--Other Contract)",
      "28:1441pa" : "28:1441pa (28:1441pa Removal - Patent Infringement)",
      "28:1441pd" : "28:1441pd (28:1441pd Petition for Removal- Property Damage)",
      "28:1441pi" : "28:1441pi (28:1441pi Petition for Removal- Personal Injury)",
      "28:1441pl" : "28:1441pl (28:1441pl Petition for Removal- Product Liability)",
      "28:1441pr" : "28:1441pr (28:1441pr Petition for Removal)",
      "28:1441qt" : "28:1441qt (28:1441qt Petition for Removal- Petition to Quiet Ti)",
      "28:1441ra" : "28:1441ra (28:1441ra Removal- Civil Rights (Race))",
      "28:1441ri" : "28:1441ri (28:1441ri Petition for Removal- Racketeering (RICO))",
      "28:1441sa" : "28:1441sa (28:1441sa Petition for Removal: SEC Act)",
      "28:1441sf" : "28:1441sf (28:1441sf Petition for Removal: Securities Fraud)",
      "28:1441sh" : "28:1441sh (28:1441sh Removal-Sexual Harassment)",
      "28:1441st" : "28:1441st (28:1441st Removal - Stockholders Suit)",
      "28:1441sv" : "28:1441sv (28:1441sv Removal-Security Violation)",
      "28:1441sx" : "28:1441sx (28:1441sx Removal-Civil Rights (Sex))",
      "28:1441tc" : "28:1441tc (28:1441tc Removal - Tricare Program)",
      "28:1441ti" : "28:1441ti (28:1441ti Removal-Trademark Infringement)",
      "28:1441til" : "28:1441til (28:1441til Removal - Truth and Lending)",
      "28:1441tl" : "28:1441tl (28:1441tl Petition for Removal- Torts to Land)",
      "28:1441tm" : "28:1441tm (28:1441tm Petition for Removal- Tort/Motor Vehicle ()",
      "28:1441tn" : "28:1441tn (28:1441tn Petition for Removal- Tort/Non-Motor Vehic)",
      "28:1441us" : "28:1441us (28:1441us Removal - Uniformed Svc Emp/Reemp Rights Act)",
      "28:1441wc" : "28:1441wc (28:1441wc Removal - Worker's Compensation Benefits)",
      "28:1441wd" : "28:1441wd (28:1441wd Petition for Removal- Wrongful Death)",
      "28:1441wt" : "28:1441wt (28:1441wt Removal- Employment (Wrongful Termination))",
      "28:1442" : "28:1442 (28:1442 Notice of Removal - Suit against Federal Officer)",
      "28:1442aaf" : "28:1442aaf (28:1442aaf Petition for Removal - Agst members of armed forces)",
      "28:1442bc" : "28:1442bc (28:1442bc Petition for Removal- Breach of Contract)",
      "28:1442nr" : "28:1442nr (28:1442nr Notice of Removal)",
      "28:1442pr" : "28:1442pr (28:1442pr Petition for Removal)",
      "28:1443" : "28:1443 (28:1443(1) Removal from State Court - Civil Rights: Rent, Lease, and Ejectment)",
      "28:1444" : "28:1444 (28:1444 Petition for Removal- Foreclosure)",
      "28:1446al" : "28:1446al (28:1446al Notice of Removal - Airline Crash)",
      "28:1446as" : "28:1446as (28:1446as Notice of Removal - Asbestos Litigation)",
      "28:1446bc" : "28:1446bc (28:1446bc Notice of Removal - Breach of Contract)",
      "28:1446cs" : "28:1446cs (28:1446cs Notice of Removal - Child Support Enforcement)",
      "28:1446dj" : "28:1446dj (28:1446dj Notice of Removal - Declaratory Judgment)",
      "28:1446er" : "28:1446er (28:1446er Notice of Removal - E.R.I.S.A)",
      "28:1446fm" : "28:1446fm (28:1446fm Notice of Removal - Family and Medical Leave Act)",
      "28:1446fr" : "28:1446fr (28:1446fr Notice of Removal - Fraud)",
      "28:1446in" : "28:1446in (28:1446in Breach of Contract- Insurance)",
      "28:1446lb" : "28:1446lb (28:1446lb Notice of Removal - Libel, Assault, Slander)",
      "28:1446ml" : "28:1446ml (28:1446ml Notice of Removal - Motor Vehicle Prod Liability)",
      "28:1446mm" : "28:1446mm (28:1446mm Notice of Removal - Medical Malpractice)",
      "28:1446mv" : "28:1446mv (28:1446mv Notice of Removal - Motor Vehicle)",
      "28:1446ni" : "28:1446ni (28:1446ni Notice of Removal - Negotiable Instrument)",
      "28:1446nr" : "28:1446nr (28:1446nr Notice of Removal)",
      "28:1446pd" : "28:1446pd (28:1446pd Petition for Removal- Property Damage (P.I)",
      "28:1446pi" : "28:1446pi (28:1446pi Petition for Removal- Personal Injury)",
      "28:1446pl" : "28:1446pl (28:1446pl Petition for Removal - Product Liability)",
      "28:1446pr" : "28:1446pr (28:1446pr Petition for Removal)",
      "28:1446st" : "28:1446st (28:1446st Notice of Removal - Stockholders Suit)",
      "28:1446tl" : "28:1446tl (28:1446tl Notice of Removal - Torts to Land)",
      "28:1446wd" : "28:1446wd (28:1446wd Notice of Removal - Wrongful Death)",
      "28:1452" : "28:1452 (28:1452 R&R re motions to remand (non-core))",
      "28:1453" : "28:1453 (28:1453 Class Action Fairness Act)",
      "28:1491" : "28:1491 (28:1491 Tucker Act)",
      "28:1602" : "28:1602 (28:1602 Foreign Sovereign Immunities Act)",
      "28:1603" : "28:1603 (28:1603 Suit on Loan Agreements)",
      "28:1605" : "28:1605 (28:1605 Foreign Sovereign Immunities Act of 1976)",
      "28:1605A" : "28:1605A (28:1605A Antiterrorism & Effective Death Penalty Act 1996)",
      "28:1610" : "28:1610 (28:1610 Juridictional Immunities of Foreign States)",
      "28:1631" : "28:1631 (28:1631 Case Transferred to Cure Want of Jurisdiction)",
      "28:1651" : "28:1651 (28:1651cn Petition for Writ of Coram Nobis)",
      "28:1651hc" : "28:1651hc (28:1651hc Petition for Writ of Habeas Corpus)",
      "28:1651mn" : "28:1651mn (28:1651mn Petition for Writ of Mandamus)",
      "28:1651ne" : "28:1651ne (28:1651ne Application for Writ Ne Exeat)",
      "28:1651w" : "28:1651w (28:1651w All Writs Act)",
      "28:1701" : "28:1701 (28:1701 Violation of Shipping Act of 1984)",
      "28:1715" : "28:1715 (28:1715 Class Action Fairness Act of 2005)",
      "28:1732" : "28:1732 (28:1732 Reproduction of Records)",
      "28:1738" : "28:1738 (28:1783 Petition for Subpoena of person in foreign country)",
      "28:1738Acs" : "28:1738Acs (28:1738Acs The Uniform Child Custody Jurisdiction Act)",
      "28:1782" : "28:1782 (28:1782 Assistance to Foreign Tribunals (incl letter rogatory))",
      "28:1826" : "28:1826 (28:1826 Order of confinement of recalcitrant witness)",
      "28:1875" : "28:1875 (28:1875 Juror Protection Act / Protection of Jurors' Employment)",
      "28:1916" : "28:1916 (28:1916 Marine Personal Injury)",
      "28:1963" : "28:1963 (28:1963 Registration of judgment from another district)",
      "28:2001" : "28:2001 (28:2001 Judicial Sale of Realty)",
      "28:2071" : "28:2071 (28:2071 Rule Making Power Generally)",
      "28:2201" : "28:2201 (28:2201 Constitutionality of State Statute(s))",
      "28:2201an" : "28:2201an (28:2201an Declaratory Judgment (aliens and nationality))",
      "28:2201cp" : "28:2201cp (28:2201cp Declaratory Judgment (Copyright))",
      "28:2201dj" : "28:2201dj (28:2201dj Declaratory Judgment)",
      "28:2201fa" : "28:2201fa (28:2201fa Declaratory Judgment- Firearms)",
      "28:2201fs" : "28:2201fs (28:2201fs Declaratory Judgment (Food Security Act))",
      "28:2201ij" : "28:2201ij (28:2201 Injunction)",
      "28:2201in" : "28:2201in (28:2201ij Injunction)",
      "28:2201pi" : "28:2201pi (28:2201pi Declaratory Judgment - Personal Injury)",
      "28:2241" : "28:2241 (28:2241fd Petition for Writ of Habeas Corpus (Federal))",
      "28:2241in" : "28:2241in (28:2241in Habeas Corpus: INS)",
      "28:2241st" : "28:2241st (28:2241st Petition for Writ of Habeas Corpus (State))",
      "28:2244" : "28:2244 (28:2244 Habeas Corpus - Finality of Determination)",
      "28:2254" : "28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))",
      "28:2254dp" : "28:2254dp (28:2254dp Petition for Writ of Habeas Corpus (Death Penalty))",
      "28:2254se" : "28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)",
      "28:2255" : "28:2255 (28:2255 Motion to Vacate / Correct Illegal Sentenc)",
      "28:2271" : "28:2271 (28:2271 Federal Tort Claims Act)",
      "28:2283" : "28:2283 (28:2283 Stay of State Court Proceedings (Injunctive Relief))",
      "28:2284" : "28:2284 (28:2284 Three-Judge Court)",
      "28:2345" : "28:2345 (28:2345 Medicare Recovery)",
      "28:2347" : "28:2347 (28:2347 Petition to Review Orders in the Ct of Appeals)",
      "28:2401" : "28:2401 (28:2401 Federal Tort Claims Act (Time for commencing action against the US))",
      "28:2403" : "28:2403 (28:2403 Constitutionality of State Statute(s))",
      "28:2405" : "28:2405 (28:2405 Garnishment of debtors of a corporation by US)",
      "28:2409" : "28:2409 (28:2409(a) Quiet Title Action)",
      "28:2410" : "28:2410 (28:2410 Quiet Title - Actions affecting property on which United States has lien)",
      "28:2412" : "28:2412 (28:2412 Equal Access to Justice Act)",
      "28:2415" : "28:2415 (28:2415 Detinue and Conversion)",
      "28:2671" : "28:2671 (28:2671 Federal Tort Claims Act)",
      "28:2672mv" : "28:2672mv (28:2672mv Federal Tort Claims Act - Motor Vehicle)",
      "28:2672pi" : "28:2672pi (28:2672pi Federal Tort Claim Act - Personal Injury)",
      "28:2674" : "28:2674 (28:2674 Federal Tort Claims Act)",
      "28:2675" : "28:2675 (28:2675 Federal Tort Claims Act - Disposition by Agency Req)",
      "28:2679(d)" : "28:2679(d) (28:2679(d)(2) Federal Tort Claims Act - Employee of U.S.A.)",
      "28:2680" : "28:2680 (28:2680 Federal Tort Claims Act - Exceptions)",
      "28:3001" : "28:3001 (28:3001 Federal Debt Collection Act)",
      "28:3001(a)" : "28:3001(a) (28:3001(a) Federal Debt Collection Procedures Act of 1990)",
      "28:3203" : "28:3203 (28:3203 Postjudgment Remedies: Writ of Execution)",
      "28:3301" : "28:3301 (28:3301 Fraudulent Transfer Federal Debt Collection Procedures Act)",
      "28:7402" : "28:7402 (28:7402 Refund of Taxes)",
      "28:7422" : "28:7422 (28:7422 Appeal from Administrative Decision)",
      "29:0101" : "29:0101 (29:101 Labor: Issuance of Restraining Orders and Injunctions)",
      "29:0151" : "29:0151 (29:151 Labor: National Labor Relations Act (NLRA))",
      "29:0158(b)" : "29:0158(b) (29:0158(b) Labor: NLRA - Unfair Labor Practices)",
      "29:0159" : "29:0159 (29:0159 Labor: Violation of Collective Bargaining Agreement)",
      "29:0160" : "29:0160 (29:160 Labor: NLRA - Prevention of Unfair Labor Practices)",
      "29:0160j" : "29:0160j (29:160j Labor: Petition for Inj - Relief from Unfair Labor Practice)",
      "29:0160l" : "29:0160l (29:160l Labor: Petition for Inj re Uncertified Labor Organizations)",
      "29:0161(2)" : "29:0161(2) (29:161(2) Labor: Enforcement of agency subpoena)",
      "29:0178" : "29:0178 (29:178 Labor: Petition for Inj to Enjoin Strike during Natl Emergency)",
      "29:0184" : "29:0184 (29:184 Violation Collection Bargain Agreement)",
      "29:0185" : "29:0185 (29:185 Labor: Suits by and against Labor Organizations)",
      "29:0185ep" : "29:0185ep (29:185 Employee Pension Plan)",
      "29:0185lm" : "29:0185lm (29:185 Labor/Mgt. Relations (Contracts))",
      "29:0186" : "29:0186 (29:186 Labor: Liabilities of and Restrictions on Labor and Management)",
      "29:0187" : "29:0187 (29:187 Labor: Recover Damages from Unfair Labor Practice)",
      "29:0201do" : "29:0201do (29:201 Denial of Overtime Compensation)",
      "29:0201fl" : "29:0201fl (29:201 Fair Labor Standards Act)",
      "29:0203" : "29:0203 (29:203 FLSA: Definitions)",
      "29:0206" : "29:0206 (29:206 FLSA: Minimum Wage)",
      "29:0206(d)" : "29:0206(d) (29:206(d) FLSA: Prohibition of Sex Discrimination)",
      "29:0207(a)" : "29:0207(a) (29:207(a) FLSA: Action for Overtime Wage Violation)",
      "29:0207fl" : "29:0207fl (29:207fl FLSA: Maximum Hours)",
      "29:0210" : "29:0210 (29:210 FLSA: Court Review of Wage Orders in PR and VI)",
      "29:0215fl" : "29:0215fl (29:215fl FLSA: Prohibited Acts)",
      "29:0216(b)" : "29:0216(b) (29:216(b) FLSA: Minimum wage or overtime compensation)",
      "29:0216(e)" : "29:0216(e) (29:216(e)FLSA: Penalty assessed for child labor provisions)",
      "29:0217" : "29:0217 (29:217 FLSA: Enjoin Violations of Fair Labor Standards Act)",
      "29:0260" : "29:0260 (29:260 FLSA: Liquidated Damages)",
      "29:0401" : "29:0401 (29:0401 Labor Management Disclosure Act)",
      "29:0411" : "29:0411 (29:411 Landrum Griffin Act)",
      "29:0412" : "29:0412 (29:412 Infringement of rights; members of labor organization)",
      "29:0440" : "29:0440 (29:440 violations reporting requirements; labor organization)",
      "29:0501(b)" : "29:0501(b) (29:501(b) Violation of Fiduciary Responsibility)",
      "29:0620" : "29:0620 (29:620 Age Discrimination)",
      "29:0621" : "29:0621 (29:621 Job Discrimination (Age))",
      "29:0623" : "29:0623 (29:623 Job Discrimination (Age))",
      "29:0626" : "29:0626 (29:626 Job Discrimination (Age))",
      "29:0633" : "29:0633 (29:633 Job Discrimination (Age))",
      "29:0651" : "29:0651 (29:651 Occupational Safety/Health)",
      "29:0660" : "29:0660 (29:660 Action by Sec Labor for discrimination re rights OSHA)",
      "29:0662" : "29:0662 (29:662 Inj proceedings re dangerous emp conditions; by Sec.)",
      "29:0666" : "29:0666 (29:666 Collection of civil penalties under OSHA)",
      "29:0701" : "29:0701 (29:701 Vocational Rehabilitation)",
      "29:0754" : "29:0754 (29:754 Discrimination)",
      "29:0790" : "29:0790 (29:0790 Rehabilitation of Labor)",
      "29:0791" : "29:0791 (29:791 Job Discrimination (Rehabilitation Act))",
      "29:0792(d)" : "29:0792(d) (29:792(d)(2) Accessible facilities for phys. handicapped emp)",
      "29:0794" : "29:0794 (29:0794 Job Discrimination (Handicap))",
      "29:0794ra" : "29:0794ra (29:794 Rehabilitation Act of 1973)",
      "29:0829" : "29:0829 (29:0829 (Repealed) Family and Medical Leave Act of 1993)",
      "29:1001" : "29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)",
      "29:1002" : "29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)",
      "29:1055" : "29:1055 (29:1055 E.R.I.S.A., Employee Retirement (Joint and Survivor Annuity))",
      "29:1101" : "29:1101 (29:1101 E.R.I.S.A.: Coverage)",
      "29:1104" : "29:1104 (29:1104 Recovery of Benefits to Employee)",
      "29:1109" : "29:1109 (29:1109 Breach of Fiduciary Duties)",
      "29:1131" : "29:1131 (29:1131 ERISA - Collection of Delinquent Trust Fun)",
      "29:1132" : "29:1132 (29:1132 E.R.I.S.A.: Civil Enforcement of Employee Benefits)",
      "29:1145" : "29:1145 (29:1145 E.R.I.S.A.: Delinquent Contributions)",
      "29:1149" : "29:1149 (29:1149 E.R.I.S.A.: Prohibition on False Statements and Representations)",
      "29:1161" : "29:1161 (29:1161 COBRA - Continuation Coverage)",
      "29:1162" : "29:1162 (29:1162 COBRA - Continuation Coverage)",
      "29:1303" : "29:1303 (29:1303 PBGC: Operation of Corporation)",
      "29:1337" : "29:1337 (29:1337 E.R.I.S.A.)",
      "29:1362" : "29:1362 (29:1362 E.R.I.S.A.: Liability for Termination of Single Employer Plans)",
      "29:1381" : "29:1381 (29:1381 E.R.I.S.A.: Withdrawal Liability)",
      "29:1401" : "29:1401 (29:1401(b)(2) E.R.I.S.A.: Resolution of Disputes - Appeal of Arbitration Award)",
      "29:1451" : "29:1451 (29:1451 E.R.I.S.A.: Enforcement - Civil Actions)",
      "29:1801" : "29:1801 (29:1801 Farmworker Rights)",
      "29:1854" : "29:1854 (29:1854 Migrant & Seasonal Agri Worker Protect Act (AWPA))",
      "29:1916" : "29:1916 (29:1916 Spec. Rule for Longshoremen & Harborworkers)",
      "29:2001" : "29:2001 (29:2001 Employee Polygraph Protection Act)",
      "29:2100" : "29:2100 (29:2100 WARN ACT)",
      "29:2101" : "29:2101 (29:2101 Worker Adjustment and Retraining Notification Act)",
      "29:2104" : "29:2104 (29:2104 Worker Adjustment & Retraining Notification (WARN))",
      "29:2601" : "29:2601 (29:2601 FMLA: Family and Medical Leave Act (Findings and Purposes))",
      "29:2611" : "29:2611 (29:2611 FMLA: Definitions)",
      "29:2612" : "29:2612 (29:2612 FMLA: Leave Requirements)",
      "29:2617" : "29:2617 (29:2617 Family and Medical Leave Act of 1993)",
      "30:0022" : "30:0022 (30:22 General Mining Law of 1872 (Lands Open to Purchase by Citizens))",
      "30:0181" : "30:0181 (30:0181 Land subject to disposition; persons entitled to benefits; reciprocal privileges)",
      "30:0801" : "30:0801 (30:0801 Penalties/Federal Mine Safety Health Act)",
      "30:0815" : "30:0815 (30:815 Federal Mine Safety & Health Act (Procedure for Enforcement))",
      "30:1201" : "30:1201 (30:1201 Environment: Review of Agency Action (Congressional Findings))",
      "30:1202" : "30:1202 (30:1202 Mining Reclamation Act (Statement of Purpose))",
      "30:1276" : "30:1276 (30:1276 Interior: Judicial Review of Agency Action)",
      "30:1701" : "30:1701 (30:1701 Federal Oil Gas Royalty Mgt Act 1982 (FOGRMA))",
      "31:0732" : "31:0732 (31:732 General Acct. Office Personnel Act of 1980 (Personnel Management System))",
      "31:1341" : "31:1341 (31:1341 Government employee--limitations on expending monies)",
      "31:3545" : "31:3545 (31:3545 Action to Recovery Money)",
      "31:3702" : "31:3702 (31:3702 Procedures for Settling Claims)",
      "31:3713" : "31:3713 (31:3713 Priority of Government Claims)",
      "31:3720" : "31:3720 (31:3720 Federal Income Tax Interceptions (Collection of Payments))",
      "31:3728" : "31:3728 (31:3728 Setoff against Judgment)",
      "31:3729" : "31:3729 (31:3729 False Claims Act)",
      "31:3730" : "31:3730 (31:3730 Qui Tam False Claims Act)",
      "31:3731" : "31:3731 (31:3731 False Claims Act - Procedures)",
      "31:3733(j)" : "31:3733(j) (31:3733(j)(2) Pet to Mod or Set Aside CV Investigative Demand)",
      "31:5314" : "31:5314 (31:5314 Failure to Report Interest in Foreign Accounts)",
      "31:5317" : "31:5317 (31:5317 Search and Forfeiture of Monetary Instruments)",
      "31:5320" : "31:5320 (31:5320 Inj or penalty; failure to file foreign currency rpt)",
      "31:5321" : "31:5321 (31:5321 Penalty; Reports of Currency and Foreign Transaction)",
      "31:5332(a)" : "31:5332(a) (31:5332(a) Evading Currency Reporting Requirement)",
      "31:5332(f)" : "31:5332(f) (31:5332(f) Transport and Transfer US currency from in to out)",
      "31:6716" : "31:6716 (31:6716 Discrimination re money and finance)",
      "31:9701" : "31:9701 (31:9701 Federal User Charge Statute)",
      "33:0408" : "33:0408 (33:408 Injury to Harbor Improvement)",
      "33:0594" : "33:0594 (33:594 Land Condemnation)",
      "33:0901" : "33:0901 (33:901 Longshoremen Harbor Workers Compensation Act (Navigation and Navigable Waters))",
      "33:0905(b)" : "33:0905(b) (33:905(b) Longshoremen Workers' Compensation Act - Recovery of Damages caused by the negligence)",
      "33:0918" : "33:0918 (33:918 Longshore and Harbor Workers Compensation Act - Collection of Defaulted Payments)",
      "33:0921" : "33:0921 (33:921 Longshore & Harbor Workers Compensation Act - Review of Compensation Orders)",
      "33:0933" : "33:0933 (33:933 Longshore and Harbor Workers' Compensation Act - Compensation for Injuries (Third-Party )",
      "33:1221" : "33:1221 (33:1221 Ports and Waterways Safety Program)",
      "33:1251" : "33:1251 (33:1251 Federal Water Pollution Control Act (Clean Water Act))",
      "33:1319cw" : "33:1319cw (33:1319cw Clean Water Act - Enforcement)",
      "33:1319pv" : "33:1319pv (33:1319pv Clean Water Act - Pollutants & Permit Violations)",
      "33:1321" : "33:1321 (33:1321 Clean Water Act - Discharge of hazardous substance or pollutants/water)",
      "33:1361" : "33:1361 (33:1361 Clean Water Act-Administrator Authority)",
      "33:1365" : "33:1365 (33:1365 Clean Water Act - Citizen Suits re Environmental Matters)",
      "33:1415" : "33:1415 (33:1415 Marine Protection, Research, and Sanctuaries Act)",
      "33:1515" : "33:1515 (33:1515 Deepwater Ports Act (citizen civil action))",
      "33:2701" : "33:2701 (33:2701 Oil Pollution Act of 1940)",
      "35:0001" : "35:0001 (35:0001 Establishment of PTO)",
      "35:0032" : "35:0032 (35:0032 Suspension from Practice before Patent & Trade. Off.)",
      "35:0145" : "35:0145 (35:145 Civil Action to Obtain Patent)",
      "35:0146" : "35:0146 (35:146 Appeal from Decision of the Board of Patent Appeals)",
      "35:0183" : "35:0183 (35:183 Right to Compensation - Patent Laws)",
      "35:0256" : "35:0256 (35:256 Patent Non-Infringement (Correction of Named Inventor))",
      "35:0271" : "35:0271 (35:271 Patent Infringement)",
      "35:0281" : "35:0281 (35:281 Remedy for Infringement of Patent/jurisdiction conferred 28:1338)",
      "35:0282" : "35:0282 (35:282 Patent Infringement - Defenses)",
      "35:0283" : "35:0283 (35:283 Action to enjoin violation of right secured by patent)",
      "35:0289" : "35:0289 (35:289 Recover profits from unlicensed use of design patent)",
      "35:0291" : "35:0291 (35:291 Action for relief between owners; interfering patents)",
      "35:0292" : "35:0292 (35:292 Penalty & Forfeiture; illegal use of word patent (false marking))",
      "35:0311" : "35:0311 (35:311 Patent - Request for Inter Partes Reexamination)",
      "38:0775" : "38:0775 (38:775 Recovery of Servicemen's Group Life Insurance)",
      "38:1110" : "38:1110 (38:1110 Basic Entitlements / Wartime)",
      "38:1131" : "38:1131 (38:1131 Basic Entitlements / Peacetime)",
      "38:1681" : "38:1681 (38:1681 Recovery of VA Overpayment (DISCONTINUED AFTER 1/27/2014))",
      "38:1686" : "38:1686 (38:1686 Recovery of VA Overpayment)",
      "38:1780" : "38:1780 (38:1780 Recovery of VA Overpayment (DISCONTINUED AFTER 1/27/2014))",
      "38:1816" : "38:1816 (38:1816 Deficiency balance on VA Mortgage Foreclosure (Regulations Governing the VA Loan Guaranty Pr)",
      "38:1965" : "38:1965 (38:1965 Servicemen's Group Life Insurance (Definitions))",
      "38:1975" : "38:1975 (38:1975 Recovery of Servicemen's Group Life Insurance - Jurisdiction of District Court)",
      "38:1984" : "38:1984 (38:1984 Suit for Veterans Insurance)",
      "38:2011" : "38:2011 (38:2011 - Veteran's Readjustment Assistance Act of (DISCONTINUED AFTER 1/27/2014))",
      "38:2021" : "38:2021 (38:2021 Right to Re-Employment of Inducted Persons (DISCONTINUED AFTER 1/27/2014))",
      "38:3116" : "38:3116 (38:3116 VA Overpayment (DISCONTINUED AFTER 1/27/2014))",
      "38:3481" : "38:3481 (38:3481 Recovery of VA Overpayment)",
      "38:3680" : "38:3680 (38:3680 Recovery of Education Assist Allowance Overpayment)",
      "38:4212" : "38:4212 (38:4212 Veterans Employment Emphasis Under Federal Contracts)",
      "38:4301" : "38:4301 (38:4301 Uniformed Srvs. Employment & Reemployment Rights Act (purpose))",
      "38:4302" : "38:4302 (38:4302 Veterans Reemployment Rights Act (relation to other laws and plans or agreements.)",
      "38:4311" : "38:4311 (38:4311 Uniformed Service Employment or Reemployment Rights Act (USERRA) - Discrimination)",
      "38:4312" : "38:4312 (38:4312 Rights of inducted persons to reemployment)",
      "38:4323" : "38:4323 (38:4323 USERRA - Enforcement of rights with respect to state or private employer)",
      "38:4324" : "38:4324 (38:4324 USERRA - Enforcement of rights with respect to federal executive agencies)",
      "38:5315" : "38:5315 (38:5315 Delinquent Payment of Amounts Due to US)",
      "38:5316" : "38:5316 (38:5316 VA Overpayment)",
      "39:0101" : "39:0101 (39:101 Postal Reorganization Act)",
      "39:0403" : "39:0403 (39:403 Discriminatory use of the Postal Service)",
      "39:0409" : "39:0409 (39:0409 Postal Service)",
      "39:1207" : "39:1207 (39:1207 Review Agency Action--Labor Disputes)",
      "39:1208(b)" : "39:1208(b) (39:1208(b) Postal Reorganization Act of 1970 - Suits)",
      "39:3005" : "39:3005 (39:3005 False Representations and Lotteries)",
      "39:3007" : "39:3007 (39:3007 Detention of Mail for Temporary Periods - Injunction directing retention of incoming mail)",
      "39:3008(e)" : "39:3008(e) (39:3008(e) Enforce compliance with a USPS Prohibitory Order)",
      "40:0258" : "40:0258 (40:258(a) Public Buildings & Property: Land Condemnation)",
      "40:0270" : "40:0270 (40:270 Miller Act (DISCONTINUED AFTER 1/27/2014))",
      "40:0581" : "40:0581 (40:581 General Authority of Administrator of General Services)",
      "40:0875" : "40:0875 (40:875 Public Buildings & Property: Negligence)",
      "40:1101" : "40:1101 (40:1101 Brooks Architect - Engineers Act)",
      "40:3131" : "40:3131 (40:3131 Bonds of contractors of public buildings)",
      "40:3133" : "40:3133 (Rights of Persons Furnishing Labor or Material)",
      "40:3142" : "40:3142 (40:3142 Davis-Bacon Act (prevailing wages))",
      "41:0251" : "41:0251 (41:251 Public Contracts-Review of Agency Action)",
      "41:1463" : "41:1463 (41:1463 Public Contracts: Unlawful Employment Prac)",
      "41:2102" : "41:2102 (41:2102 Procurement Integrity Act)",
      "41:2103" : "41:2103 (41:2103 Procurement Integrity Act)",
      "41:2104" : "41:2104 (41:2104 Procurement Integrity Act)",
      "41:2105" : "41:2105 (41:2105 Procurement Integrity Act)",
      "41:2106" : "41:2106 (41:2106 Procurement Integrity Act)",
      "41:2107" : "41:2107 (41:2107 Procurement Integrity Act)",
      "41:3301" : "41:3301 (41:3301 Competition in Contracting Act)",
      "41:6503" : "41:6503 (41:6503 Walsh-Healy Act - Breach of Public Contract)",
      "41:6505" : "41:6505 (41:6505 Exclusions - Review of legal questions in contracts; Walsh-Healy Act)",
      "41:6702" : "41:6702 (41:6702 Service Contract Labor Standards / McNamara-O'Hara Service Contract Act 1965)",
      "41:6703" : "41:6703 (41:6703 Service Contract Labor Standards / McNamara-O'Hara Service Contract Act 1965)",
      "41:6704" : "41:6704 (41:6704 Service Contract Labor Standards / McNamara-O'Hara Service Contract Act 1965)",
      "41:7105(f)" : "41:7105(f) (41:7105(f) Action to Judicially Enforce Administrative Subpoena)",
      "42:0205" : "42:0205 (42:205 Appointment of Surgeon General)",
      "42:0206" : "42:0206 (42:206 Surgeon General - Assignment of Officers)",
      "42:0234" : "42:0234 (42:234 Suit to recover on NHSC Scholarship training program)",
      "42:0247" : "42:0247 (42:247 Personal Injury-Swine Flu)",
      "42:0254o" : "42:0254o (42:0254o Breach of Scholarship Contract)",
      "42:0256" : "42:0256 (42:256 Public Health Services Act - Grants)",
      "42:0292f" : "42:0292f (42:292f Default of borrower)",
      "42:0292k" : "42:0292k (42:292k Student loan insurance (Public Health Occupations))",
      "42:0293" : "42:0293 (42:293 Recovery of losses from loan guarantee; public health)",
      "42:0294" : "42:0294 (42:294 To Recover on Health Education Assistance Loan)",
      "42:0297" : "42:0297 (42:297 Student loans; public or nonprofit school of nursing)",
      "42:0300aa1" : "42:0300aa1 (42:300aa-1 Nat'l. Childhood Vaccine Injury Compensation Act)",
      "42:0300f" : "42:0300f (42:300f Safe Drinking Water Act (Definitions))",
      "42:0300g" : "42:0300g (42:300g Actions re safety of public water systems (EPA))",
      "42:0300g-3" : "42:0300g-3 (42:3003g-3 Enforcement of Drinking Water Regulations)",
      "42:0401" : "42:0401 (42:401 Social Security Act - Trust Funds)",
      "42:0402" : "42:0402 (42:402 Social Security Benefits)",
      "42:0405" : "42:0405 (42:405 Rev. of Final Dec. of Sec. of HEW re: S.S. Benefits)",
      "42:0405id" : "42:0405id (42:405 Review of HHS Decision (SSID))",
      "42:0405rs" : "42:0405rs (42:405rsReview of HHS Decision (RSI))",
      "42:0405wc" : "42:0405wc (42:405 Review of HHS Decision (DIWC))",
      "42:0405ww" : "42:0405ww (42:405 Review of HHS Decision (DIWW))",
      "42:0416" : "42:0416 (42:416 Denial of Social Security Benefits)",
      "42:0421(d)" : "42:0421(d) (42:421(d) Review HHS decision re disability determinations)",
      "42:0423" : "42:0423 (42:423 Social Security Act (Disability Insurance Benefit Payments))",
      "42:0425" : "42:0425 (42:425 Social Security Benefits)",
      "42:0427" : "42:0427 (42:427 Social Security Benefits (Transitional Insured Status))",
      "42:0601" : "42:0601 (42:601 Title IV-A of the Social Security Act (Grants to States for Aid and Assistance to Needy Famil)",
      "42:0602" : "42:0602 (42:602 Temp. Assistance for Needy Families (TANF))",
      "42:0660" : "42:0660 (42:660 Action to enforce child support obligations)",
      "42:10139" : "42:10139 (42:10139 judicial review of agency actions)",
      "42:10801" : "42:10801 (42:10801 Protection & Advocacy for Individuals with Mental Illness Act of 1986 (PAIMI))",
      "42:10805" : "42:10805 (42:10805 Protection and Advocacy Systems)",
      "42:11001" : "42:11001 (42:11001 Emergency Plan. & Comm. Right to Know Act (EPCRA))",
      "42:11046" : "42:11046 (42:11046 Fed Emer Plan Comm Right-to-know Act (EPCRA) - civil actions)",
      "42:11101" : "42:11101 (42:11101 Health Care Quality Improvement Act of 1986)",
      "42:11112" : "42:11112 (42:11112 Health Care Quality Improvement Act (Standards for Professional Review Actions))",
      "42:11601" : "42:11601 (42:11601 International Child Abduction Remedies Act)",
      "42:11603b" : "42:11603b (42:11603(b) Int'l. Child Abduction Remedies Act (ICARA) - Judicial Remedies)",
      "42:12101" : "42:12101 (42:12101 The Americans with Disabilities Act of 1990)",
      "42:12102" : "42:12102 (42:12102 Americans with Disabilities Act (ADA) Disability Definition)",
      "42:12111" : "42:12111 (42:12111 Americans with Disabilities Act - Employment)",
      "42:12112" : "42:12112 (42:12112 Americans with Disabilities Act - Employment Discrimination)",
      "42:12117" : "42:12117 (42:12117 Americans with Disabilities Act - Enforcement)",
      "42:12131" : "42:12131 (42:12131 Americans with Disabilities Act of 1990)",
      "42:12132" : "42:12132 (42:12132 Americans with Disabilities Act - Discrimination)",
      "42:12188" : "42:12188 (42:12188 Americans With Disabilities Act - Civil Enforcement Actions)",
      "42:1320a-7" : "42:1320a-7 (42:1320a-7b(b)(2)(A) Anti-Kickback Act (for federal health care programs))",
      "42:1320d-2" : "42:1320d-2 (42:1320d-2 Health Insurance Portability And Accountability Act (HIPAA))",
      "42:1345" : "42:1345 (42:1345 Enforcement of State Court Judgment)",
      "42:1381a" : "42:1381a (42:1381a Supplemental Security Income benefits (SSID))",
      "42:1382" : "42:1382 (42:1382 Eligibility for benefits)",
      "42:1383" : "42:1383 (42:1383 Review of HHS Decision (regarding payment of benefits))",
      "42:1395" : "42:1395 (42:1395 Emergency Medical Treatment and Active Labor Act)",
      "42:1395dd" : "42:1395dd (42:1395dd Exam & Treatment Emergency Med Cond & Women in Labor)",
      "42:1395hr" : "42:1395hr (42:1395hr Hospital Reimbursement for Medicare Services)",
      "42:1395w21" : "42:1395w21 (42:1395w-21 Medicare Act (Eligibility, Election, and Enrollment))",
      "42:1396" : "42:1396 (42:1396 - Tort Negligence)",
      "42:1396a" : "42:1396a (42:1396a State Plans for Medical Assistance)",
      "42:1396b" : "42:1396b (42:1396b Medical Assist Prgm, Pmt to States/Medicaid Implem)",
      "42:13981" : "42:13981 (42:13981 Violence Against Women Act (Civil Rights))",
      "42:14135" : "42:14135 (42:14135 DNA Backlog Grant Program)",
      "42:1437" : "42:1437 (42:1437 U.S. Housing Act of 1937)",
      "42:1471" : "42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclosure)",
      "42:1475" : "42:1475 (42:1475 Declaratory & Injunctive Relief - Foreclosure Procedures)",
      "42:1479" : "42:1479 (42:1479 Mortgage, lease, contract re farm housing)",
      "42:14901" : "42:14901 (42:14901 Intercountry Adoptions)",
      "42:15483" : "42:15483 (42:15483 Help America Vote Act)",
      "42:1651" : "42:1651 (42:1651 Defense Base Act)",
      "42:1705" : "42:1705 (42:1705 Receipt of Workmen's compensation benefits)",
      "42:1971" : "42:1971 (42:1971 Voting Rights Law)",
      "42:1973" : "42:1973 (42:1973 Voting Rights Act)",
      "42:1973(a)" : "42:1973(a) (42:1973(a) Enforcement of Voting Rights)",
      "42:1973(c)" : "42:1973(c) (42:1973(c) Voting Rights -Qualifications & Procedures)",
      "42:1973agg" : "42:1973agg (42:1973gg-2 Nat'l. Voter Registration Act of 1993 (NVRA))",
      "42:1981" : "42:1981 (42:1981 Equal Rights Under the Law)",
      "42:1981a" : "42:1981a (42:1981a Damages in cases of intentional discrim. in employment)",
      "42:1981cv" : "42:1981cv (42:1981 Civil Rights)",
      "42:1981hs" : "42:1981hs (42:1981 Housing Discrimination)",
      "42:1981jb" : "42:1981jb (42:1981 Job Discrimination (Race))",
      "42:1981ra" : "42:1981ra (42:1981ra Race Discrimination)",
      "42:1981sx" : "42:1981sx (42:1981 Sex Discrimination)",
      "42:1982hs" : "42:1982hs (42:1982hs Discrimination re property rights (housing))",
      "42:1982ra" : "42:1982ra (42:1982ra Discrimination re property rights (race))",
      "42:1982sx" : "42:1982sx (42:1982sx Discrimination re property rights (sex))",
      "42:1983" : "42:1983 (42:1983 Prisoner Civil Rights)",
      "42:1983bv" : "42:1983bv (42:1932bv Bivens Non-Prisoner)",
      "42:1983cv" : "42:1983cv (42:1983 Civil Rights Act)",
      "42:1983cvp" : "42:1983cvp (42:1983cvp Civil Rights (Personal Property))",
      "42:1983d" : "42:1983d (42:1983d Civil Rights (Death))",
      "42:1983dp" : "42:1983dp (42:1983dp Civil Right Denial of Due Process)",
      "42:1983ed" : "42:1983ed (42:1983 Civil Rights (Employment Discrimination))",
      "42:1983pr" : "42:1983pr (42:1983 Prisoner Civil Rights)",
      "42:1983vp" : "42:1983vp (42:1983vp Violation of Due Process and Equal Protection)",
      "42:1985" : "42:1985 (42:1985 Consipracy to interfere with civil rights)",
      "42:1986" : "42:1986 (42:1986 Neglect of Duty)",
      "42:1987" : "42:1987 (42:1987 Prosecution of violations of certain laws (violations of sec 1990 or 5506 to 5516 or 5518 to)",
      "42:1988" : "42:1988 (42:1988 Proceedings in Vindication of Civil Rights)",
      "42:1997" : "42:1997 (42:1997 Institutionalized Persons Act of 1980)",
      "42:2000a-3" : "42:2000a-3 (42:2000a-3pa Discrimination, segregation; public accommodation - Injunctive Relief)",
      "42:2000ad" : "42:2000ad (42:2000ad Job Discrimination (Disability Act))",
      "42:2000ag" : "42:2000ag (42:2000e-2ag Job Discrimination (Age))",
      "42:2000bb" : "42:2000bb (42:2000bb Religious Freedom Restoration Act of 1993)",
      "42:2000bea" : "42:2000bea (42:2000bea Equal access to public facilities)",
      "42:2000c6" : "42:2000c6 (42:2000c-6ed Discrimination in Education)",
      "42:2000cc" : "42:2000cc (42:2000cc Religious Land Use & Institutionalized Persons Act of 2000)",
      "42:2000d" : "42:2000d (42:2000d Federally Assisted Programs)",
      "42:2000e" : "42:2000e (42:2000e-2e Job Discrimination (Unlawful Employment Practices))",
      "42:2000e-5" : "42:2000e-5 (42:2000e-5eeo Petition to Enforce EEOC Subpoena)",
      "42:2000e2o" : "42:2000e2o (42:2000e-2ot Job Discrimination (other))",
      "42:2000e2r" : "42:2000e2r (42:2000e-2rl Job Discrimination (religion))",
      "42:2000e2s" : "42:2000e2s (42:2000e-2sh Job Discrimination (Sexual Harassment))",
      "42:2000pb" : "42:2000pb (42:2000e-2pb Job Discrimination (Public Accommodations))",
      "42:2000ra" : "42:2000ra (42:2000e-2ra Job Discrimination (Race))",
      "42:2000sx" : "42:2000sx (42:2000e-2sx Job Discrimination (Sex))",
      "42:2003" : "42:2003 (42:2003 Job Discrimination)",
      "42:2005" : "42:2005 (42:2005 Review of Agency Action-HHS)",
      "42:2210" : "42:2210 (42:2210 Indeminification & Limitation of Liability-Financial)",
      "42:2615" : "42:2615 (42:2615 Medical Recovery Act)",
      "42:2651" : "42:2651 (42:2651 Medical Care Recovery by US)",
      "42:2996" : "42:2996 (42:2296 Legal Services Corporation Act)",
      "42:3058(g)" : "42:3058(g) (42:3058(g) Older American's Act of 1965, 42 U.S.C. 3058(g) (State Long-term Care Ombudsman Prog)",
      "42:3121" : "42:3121 (42:3121 Public Works and Economic Development Act of 1965)",
      "42:3133" : "42:3133 (42:3133 Coordination - Grants for Public Works and Economic Development)",
      "42:3601" : "42:3601 (42:3601 Fair Housing Act)",
      "42:3604f3c" : "42:3604f3c (42:3604(f)(3)(c) Fair Housing Amendments Act)",
      "42:3610" : "42:3610 (42:3610 Fair Housing Act-Administrative Enforcement; Preliminary Matters)",
      "42:3612" : "42:3612 (42:3612 Civil rights in housing - Enforcement by Secretary)",
      "42:3613" : "42:3613 (42:3613 Action for inj relief re deprivation of civil rights)",
      "42:4000" : "42:4000 (42:4000 National Flood Insurance Act)",
      "42:4001" : "42:4001 (42:4001 National Insurance Flood Act)",
      "42:4013" : "42:4013 (42:4013 National Flood Insurance Act - Nature and Limitation of Insurance Coverage)",
      "42:4053" : "42:4053 (42:4053 Breach of Insurance Contract)",
      "42:4072" : "42:4072 (42:4072 Payment of Flood Insurance Claim)",
      "42:4321" : "42:4321 (42:4321 Review of Agency Action-Environment)",
      "42:4332" : "42:4332 (42:4332 Environmental Policy - Cooperation of Agencies; Reports)",
      "42:4712" : "42:4712 (42:4721 Intergovernmental Personnel Act (findings and purposes))",
      "42:4821" : "42:4821 (42:4821 Lead-Based Paint Poisoning Prevention Act (findings and purposes))",
      "42:4901" : "42:4901 (42:4901 Noise Control Act of 1972 (findings and purposes))",
      "42:4910(c)" : "42:4910(c) (42:4901(c) Action to restrain violation re noise control)",
      "42:5101" : "42:5101 (42:5101 Child Abuse Prevention and Treatment Act)",
      "42:5303" : "42:5303 (42:5303 Block Grant Act of 1974 (42 USC 5301-5321))",
      "42:5401" : "42:5401 (42:5401 Natl Mnfactrd Housing Cnstr Safety Standard Act 1974 (findings and purposes))",
      "42:5411" : "42:5411 (42:5411 Housing Construction and Safety Standards Act - Injunctive Relief)",
      "42:5851" : "42:5851 (42:5851 Discrimination -Whistle blower Employee - ERA (employee protection))",
      "42:6101" : "42:6101 (42:6101 Age Discrimination in Federally Assisted Programs (statement of purpose))",
      "42:6201" : "42:6201 (42:6201 Energy Policy & Conservation Act (statement of purpose))",
      "42:6393" : "42:6393 (42:6393 Controversies under Energy Policy & Conservation Act (Admin Procedure and Judicial Review))",
      "42:6901en" : "42:6901en (42:6901en Environmental Cleanup Expenses (congressional findings))",
      "42:6901rs" : "42:6901rs (42:6901rs Resource & Recovery Act (congressional findings))",
      "42:6928" : "42:6928 (42:6928 Violations of requirements of hazardous Waste Mgmt (federal enforcement))",
      "42:6961" : "42:6961 (42:6961 Federal Facilities Compliance Act)",
      "42:6972" : "42:6972 (42:6972 Resource & Recovery Act - Citizen Suit)",
      "42:6972(a)" : "42:6972(a) (42:6972(a) Solid Waste Disposal Act - Citizen Suit)",
      "42:7192" : "42:7192 (42:7192 Controversies under Dept of Energy Organization Act - Judicial Review)",
      "42:7384" : "42:7384 (42:7384 Energy Employees Occupational Illness Compensation Program Act (EEOICPA))",
      "42:7401" : "42:7401 (42:7401 Clean Air Act (findings & declarations))",
      "42:7412" : "42:7412 (42:7412 Air Pollution Control - emission standards)",
      "42:7413" : "42:7413 (42:7413(b) Clean Air Act - Enforcement)",
      "42:7475" : "42:7475 (42:7475 Clean Air Act - Preconstruction Requirements)",
      "42:7545" : "42:7545 (42:7545 Air Pollution Prevention - Regulation of Fuels)",
      "42:7603" : "42:7603 (42:7603 Action for immediate restraint (Emergency Powers))",
      "42:7604" : "42:7604 (42:7604 Clean Air Act - Citizen suit to enforce Clean Air Act)",
      "42:7604cl" : "42:7604cl (42:7604cl Clear Air Act - Emission Standards)",
      "42:7604ir" : "42:7604ir (42:7604 Petition to Quash IRS Summons)",
      "42:7671" : "42:7671 (42:7671 Clean Air Act (Stratospheric Ozone Protection) (Definitions))",
      "42:8324" : "42:8324 (42:8324 Powerplant and Industrial Fuel Use - terms and conditions)",
      "42:8351" : "42:8351 (42:8351 Powerplant and Industrial Fuel Use - Temporary Exemptions)",
      "42:9601" : "42:9601 (42:9601 Comprehensive Environmental Compen/Resp/Liab (CERCLA) (Definitions))",
      "42:9604" : "42:9604 (42:9604 Comprehensive Envir., Response, Comp. & Liab. Act (CERCLA) - Removal and Other Remedial Acti)",
      "42:9607" : "42:9607 (42:9607 Real Property Tort to Land - Liability)",
      "42:9613" : "42:9613 (42:9613 Comp Environ Recovery Comp & Liability Act (CERCLA) - Civil Proceedings)",
      "42:9831" : "42:9831 (42:9831-9852 Head Start Act)",
      "43:0421" : "43:0421 (43:0421 Complaint in Condemnation - Eminent Domain)",
      "43:0945" : "43:0945 (43:945 Compensation for Land Condemnation)",
      "43:0945a" : "43:0945a (43:945a Compensation for Land Condemnation)",
      "43:0945b" : "43:0945b (43:945b Complaint in Condemnation - Easements)",
      "43:0946" : "43:0946 (43:946 Complaint in Condemnation - Right of Way for Irrigation and Drainage Projects)",
      "43:1331" : "43:1331 (43:1331 Outer Continental Shelf Lands Act (Definitions))",
      "43:1333" : "43:1333 (43:1333 Outer Continental Shelf Lands Act - Laws and Regulations Governing Lands)",
      "43:1349" : "43:1349 (43:1349 Outer Continental Land Shelf Act - Citizen Suits)",
      "43:1701" : "43:1701 (43:1701 Violation of Federal Land Policy and Management Act (FLPMA))",
      "43:1737" : "43:1737 (43:1737 FLPMA - Implementation Provisions)",
      "44:2107" : "44:2107 (44:2107 Presidential Recordings and Materials Act (NARA acceptance of records for historical preserv)",
      "45:0051" : "45:0051 (45:51 Railways: Fed. Employer's Liability Act)",
      "45:0056" : "45:0056 (45:56 Employers Liability Act - Personal Inj re Railroads (bringing an action))",
      "45:0151" : "45:0151 (45:151 Railway Labor Act)",
      "45:0152" : "45:0152 (45:152 Railway Labor Act - General Duties)",
      "45:0153" : "45:0153 (45:153 First Railway Labor Act - National Railroad Adjustment Board)",
      "45:0159" : "45:0159 (45:159 Review of arbitration award (RR Carriers/Mediation Bd))",
      "45:0184" : "45:0184 (45:184 Action to Set Aside Award of a System Board)",
      "45:0351" : "45:0351 (45:351 Railroad Unemployment Insurance Act)",
      "45:0719" : "45:0719 (45:719 Regional Rail Reorganization Act of 1973 (judicial review))",
      "45:1105" : "45:1105 (45:1105 Northeast Rail Service Act - Judicial Review)",
      "45:1395" : "45:1395 (45:1395 Railroads: Adverse Reimbursement Review)",
      "45:7457" : "45:7457 (45:7457 Compel Reclamation Under Clear Air Act)",
      "46:0183" : "46:0183 (46:183 Limitation of Liability (DISCONTINUED AFTER 1/27/2014))",
      "46:0688" : "46:0688 (46:688 Jones Act)",
      "46:0741" : "46:0741 (46:741 Shipping (DISCONTINUED AFTER 1/27/2014))",
      "46:0761" : "46:0761 (46:761 Shipping: Damages for Death on High Seas (DISCONTINUED AFTER 1/27/2014))",
      "46:1101" : "46:1101 (46:1101 Violation of Maritime Regulations (DISCONTINUED AFTER 1/27/2014))",
      "46:1156" : "46:1156 (46:1156 Administrative Procedure Act)",
      "46:1300" : "46:1300 (46:1300 F.E.L.A. (DISCONTINUED AFTER 1/27/2014))",
      "46:1701" : "46:1701 (46:1701 Violation of Shipping Act of 1984 (DISCONTINUED AFTER 1/27/2014))",
      "46:2114" : "46:2114 (46:2114 Wrongful Discharge from Employment - protection from discrimination)",
      "46:30101" : "46:30101 (46:30101 Extension of jurisdiction to cases of damage or injury on land)",
      "46:30104" : "46:30104 (46:30104 Marine Personal Injury - Jones Act)",
      "46:30302" : "46:30302 (46:30302 Shipping: Damages for Death on High Seas)",
      "46:30304" : "46:30304 (46:30304 Breach of Maritime Contract - liability of noncompliance)",
      "46:30503" : "46:30503 (46:30503 Limitation of Liability - declaration of nature and value of goods)",
      "46:30504" : "46:30504 (46:30504 Limitation of Liability - loss by fire)",
      "46:30505" : "46:30505 (46:30505 General Limit of Liability)",
      "46:30506" : "46:30506 (46:30506 Limit of Liability for Personal Injury or Death)",
      "46:30507" : "46:30507 (46:30507 Apportionment of Losses)",
      "46:30508" : "46:30508 (46:30508 Provisions Requiring Notice of Claim or Limiting Time for Bringing Action)",
      "46:30509" : "46:30509 (46:30509 Provisions Limiting Liability for Personal Injury or Death)",
      "46:30510" : "46:30510 (46:30510 Vicarious Liability for Medical Malpractice With Regard to Crew)",
      "46:30511" : "46:30511 (46:30511 Action by Owner for Limitation)",
      "46:30701" : "46:30701 (46:30701 Marine Cargo Loss or Damage - Liability of Water Carriers)",
      "46:30704" : "46:30704 (46:30704 Liability of Water Carriers - Loading, stowage, custody, care, and delivery)",
      "46:30902" : "46:30902 (46:30902 Definition)",
      "46:30903" : "46:30903 (46:30903 Waiver of Immunity)",
      "46:30904" : "46:30904 (46:30904 Exclusive Remedy)",
      "46:30905" : "46:30905 (46:30905 Period for Bringing Action)",
      "46:30906" : "46:30906 (46:30906 Venue)",
      "46:30907" : "46:30907 (46:30907 Procedure for Hearing and Determination)",
      "46:30908" : "46:30908 (46:30908 Exemption from Arrest or Seizure)",
      "46:30909" : "46:30909 (46:30909 Security)",
      "46:30910" : "46:30910 (46:30910 Exoneration and Limitation)",
      "46:30911" : "46:30911 (46:30911 Costs and Interest)",
      "46:31102" : "46:31102 (46:31102 Public Vessels Act - Waiver of Immunity)",
      "46:31301" : "46:31301 (46:31301 Maritime Commercial Instruments and Liens Act)",
      "46:31302" : "46:31302 (46:31302 Maritime Commercial Instruments and Liens Act)",
      "46:31303" : "46:31303 (46:31303 Maritime Commercial Instruments and Liens Act)",
      "46:31304" : "46:31304 (46:31304 Maritime Commercial Instruments and Liens Act)",
      "46:31305" : "46:31305 (46:31305 Maritime Commercial Instruments and Liens Act)",
      "46:31306" : "46:31306 (46:31306 Maritime Commercial Instruments and Liens Act)",
      "46:31307" : "46:31307 (46:31307 Maritime Commercial Instruments and Liens Act)",
      "46:31308" : "46:31308 (46:31308 Maritime Commercial Instruments and Liens Act)",
      "46:31309" : "46:31309 (46:31309 Maritime Commercial Instruments and Liens Act)",
      "46:31310" : "46:31310 (46:31310 Maritime Commercial Instruments and Liens Act)",
      "46:31311" : "46:31311 (46:31311 Maritime Commercial Instruments and Liens Act)",
      "46:31312" : "46:31312 (46:31312 Maritime Commercial Instruments and Liens Act)",
      "46:31313" : "46:31313 (46:31313 Maritime Commercial Instruments and Liens Act)",
      "46:31314" : "46:31314 (46:31314 Maritime Commercial Instruments and Liens Act)",
      "46:31315" : "46:31315 (46:31315 Maritime Commercial Instruments and Liens Act)",
      "46:31316" : "46:31316 (46:31316 Maritime Commercial Instruments and Liens Act)",
      "46:31317" : "46:31317 (46:31317 Maritime Commercial Instruments and Liens Act)",
      "46:31318" : "46:31318 (46:31318 Maritime Commercial Instruments and Liens Act)",
      "46:31319" : "46:31319 (46:31319 Maritime Commercial Instruments and Liens Act)",
      "46:31320" : "46:31320 (46:31320 Maritime Commercial Instruments and Liens Act)",
      "46:31321" : "46:31321 (46:31321 Maritime Commercial Instruments and Liens Act)",
      "46:31322" : "46:31322 (46:31322 Maritime Commercial Instruments and Liens Act)",
      "46:31323" : "46:31323 (46:31323 Maritime Commercial Instruments and Liens Act)",
      "46:31324" : "46:31324 (46:31324 Maritime Commercial Instruments and Liens Act)",
      "46:31325" : "46:31325 (46:31325 Maritime Commercial Instruments and Liens Act)",
      "46:31326" : "46:31326 (46:31326 Maritime Commercial Instruments and Liens Act)",
      "46:31327" : "46:31327 (46:31327 Maritime Commercial Instruments and Liens Act)",
      "46:31328" : "46:31328 (46:31328 Maritime Commercial Instruments and Liens Act)",
      "46:31329" : "46:31329 (46:31329 Maritime Commercial Instruments and Liens Act)",
      "46:31330" : "46:31330 (46:31330 Maritime Commercial Instruments and Liens Act)",
      "46:31331" : "46:31331 (46:31331 Maritime Commercial Instruments and Liens Act)",
      "46:31332" : "46:31332 (46:31332 Maritime Commercial Instruments and Liens Act)",
      "46:31333" : "46:31333 (46:31333 Maritime Commercial Instruments and Liens Act)",
      "46:31334" : "46:31334 (46:31334 Maritime Commercial Instruments and Liens Act)",
      "46:31335" : "46:31335 (46:31335 Maritime Commercial Instruments and Liens Act)",
      "46:31336" : "46:31336 (46:31336 Maritime Commercial Instruments and Liens Act)",
      "46:31337" : "46:31337 (46:31337 Maritime Commercial Instruments and Liens Act)",
      "46:31338" : "46:31338 (46:31338 Maritime Commercial Instruments and Liens Act)",
      "46:31339" : "46:31339 (46:31339 Maritime Commercial Instruments and Liens Act)",
      "46:31340" : "46:31340 (46:31340 Maritime Commercial Instruments and Liens Act)",
      "46:31341" : "46:31341 (46:31341 Maritime Commercial Instruments and Liens Act)",
      "46:31342" : "46:31342 (46:31342 Maritime Commercial Instruments and Liens Act)",
      "46:31343" : "46:31343 (46:31343 Maritime Commercial Instruments and Liens Act)",
      "46:40101" : "46:40101 (46:40101 Shipping Act of 1998)",
      "46:41102a" : "46:41102a (46:41102(a) Shipping Act of 1984 - General Prohibitions)",
      "46:41309" : "46:41309 (46:41309 Shipping Act of 1984 - Enforcement of Reparation Orders)",
      "46:50101" : "46:50101 (46:50101 Violation of Maritime Regulations)",
      "46:58109" : "46:58109 (46:58109 Violation of Merchant Marine Act - Penalties)",
      "47:0151" : "47:0151 (47:151 Communications Act of 1934)",
      "47:0151cs" : "47:0151cs (47:151cs Federal Communications Act - Collection for Services)",
      "47:0201bt" : "47:0201bt (47:201bt Breach of Tariff)",
      "47:0203" : "47:0203 (47:203 Telecommunications Collection of Charges)",
      "47:0205" : "47:0205 (47:205 Wire and Radio Communication Svc and Charges (Recovery of Damages))",
      "47:0206" : "47:0206 (47:206 Carrier's Liability for Damages)",
      "47:0227" : "47:0227 (47:227 FCC-Unsolicited Telephone Sales)",
      "47:0227b3" : "47:0227b3 (47:227(b)(3) Telephone Consumer Protection Act of 1991)",
      "47:0251" : "47:0251 (47:251 Telecommunications Act of 1996 - Interconnection)",
      "47:0252" : "47:0252 (47:252 Telecommunications Act)",
      "47:0254(h)" : "47:0254(h) (47:254(h) Children's Internet Protection Act)",
      "47:0332" : "47:0332 (47:332 FCA-Wire or Radio Communications (Mobile Services))",
      "47:0332(c)" : "47:0332(c) (47:332 (c) Federal Telecommunications Act of 1996)",
      "47:0338" : "47:0338 (47:338 Satellite Home Viewer Improvement Act)",
      "47:0401" : "47:0401 (47:401 Application of Federal Communication Comm for Inj. (Enforcement Provisions))",
      "47:0407" : "47:0407 (47:407 Order for payment of money; petition for enforcement;)",
      "47:0510" : "47:0510 (47:510 Forfeiture of Communications Devices)",
      "47:0521" : "47:0521 (47:521 Cable Televsn. Consumer Protection & Competition Act of 1992)",
      "47:0522" : "47:0522 (47:522 Cable Communications Act)",
      "47:0532" : "47:0532 (47:532 Cable Communication Policy Act of 1984)",
      "47:0551" : "47:0551 (47:551 Cable Communications Act)",
      "47:0553" : "47:0553 (47:553 U.S.C.A. Cable Communications Policy Act)",
      "47:0605" : "47:0605 (47:605 Unlawful Reception Broadcast Signal i.e., Satellite - Theft of Satellite Communications)",
      "48:0734" : "48:0734 (48:734 Federal Employees Group Life Insurance)",
      "48:0883" : "48:0883 (48:883 Violation of US Coastal Law)",
      "48:1985" : "48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)",
      "49:0081" : "49:0081 (49:81 Damaged Goods While Being Transported (DISCONTINUED AFTER 1/27/2014))",
      "49:0101" : "49:0101 (49:101 ICC Termination Act of 1996)",
      "49:0502" : "49:0502 (49:502 Transportation Administrative Subpoena)",
      "49:0781" : "49:0781 (49:781 Forfeiture (DISCONTINUED AFTER 1/27/2014))",
      "49:10101" : "49:10101 (49:10101 Interstate Commerce Act-Interstate Transportation Rail)",
      "49:10743" : "49:10743 (49:10743 Revised Interstate Commerce Act)",
      "49:11101" : "49:11101 (49:11101 Interstate Commerce Act)",
      "49:1113" : "49:1113 (49:1113 Petition to enforce administrative summon)",
      "49:1136" : "49:1136 (49:1136 Aviation Disaster Family Assistance Act of 1996)",
      "49:11501" : "49:11501 (49:11501 Railroad Revitalization & Regulatory Reform Act (General jurisdiction))",
      "49:11502" : "49:11502 (49:11502 Railroad Revitalization Regulatory Reform (authority to exempt rail carrier transportation))",
      "49:11503" : "49:11503 (49:11503 Railroad Revitalization Regulatory Reform)",
      "49:11701" : "49:11701 (49:11701 General authority of enforcement of regulations in rail)",
      "49:11702" : "49:11702 (49:11702 Enforcement by the Board)",
      "49:11707" : "49:11707 (49:11707 Carmack Amendment (Liability when property is delivered in violation of routing instruct))",
      "49:13101" : "49:13101 (49:13101 Transportation Policy)",
      "49:13702" : "49:13702 (49:13702 Tariff requirement for certain transportation)",
      "49:13706" : "49:13706 ( 49:13706 Motor Carriers, etc-Liability for Payment of Rates)",
      "49:1374" : "49:1374 (49:1374(b) Federal Aviation Act)",
      "49:14501" : "49:14501 (49:14501 Preemption (federal authority of intrastate transportation))",
      "49:14705" : "49:14705 (49:14705 Interstate Commerce Act/Carmack Amendment (Limitations on actions by and against carriers))",
      "49:14706" : "49:14706 (49:14706 Carmack Amendment to the Interstate Commerce Act / Liability of Carriers - Receipts & Bills)",
      "49:1471" : "49:1471 (49:1471 Federal Aviation Act (DISCONTINUED AFTER 1/27/2014))",
      "49:1502" : "49:1502 (49:1502 Warsaw Convention (DISCONTINUED AFTER 1/27/2014))",
      "49:1903" : "49:1903 (49:1903 Petition to enforce administrative summon (DISCONTINUED AFTER 1/27/2014))",
      "49:20109" : "49:20109 (49:20109 Federal Rail Safety Act (FRSA))",
      "49:20301" : "49:20301 (49:20301 Federal Safety Appliance Act)",
      "49:20302" : "49:20302 (49:20302 Federal Safety Appliance Act)",
      "49:20303" : "49:20303 (49:20303 Federal Safety Appliance Act)",
      "49:20304" : "49:20304 (49:20304 Federal Safety Appliance Act)",
      "49:20305" : "49:20305 (49:20305 Federal Safety Appliance Act)",
      "49:20306" : "49:20306 (49:20306 Federal Safety Appliance Act)",
      "49:21302" : "49:21302 (49:21302 Carriers violations of Interstate Commerce Act (Chapter 201 accident and incident violation)",
      "49:30101" : "49:30101 (49:30101 National Traffic & Motor Vehicle Safety Act)",
      "49:30112" : "49:30112 (49:30112 Motor Vehicle Safety (prohibition on non-complying motor vehicles and equipment))",
      "49:30502" : "49:30502 (49:30502 Natl Motor Vehicle Title Information Syst)",
      "49:31114" : "49:31114 (49:31114 Access to Interstate System/Commercial Motor Vehicle)",
      "49:31502" : "49:31502 (49:31502 Motor Carrier Safety: Requirements for Qualifications)",
      "49:32101" : "49:32101 (49:32101 Motor Vehicle Information and Costs Savings Act)",
      "49:32701" : "49:32701 (49:32701 Odometer Requirements Act)",
      "49:40101" : "49:40101 (49:40101 Air Trans. Safety and Sys. Stabilization Act)",
      "49:40102" : "49:40102 (49:40102 Airline Deregulation Actv(definitions of air and commerce safety))",
      "49:40105" : "49:40105 (49:40105 Warsaw Convention)",
      "49:408B3" : "49:408B3 (49:408B3 Air Transportation Safety Act)",
      "49:41705" : "49:41705 (49:41705 Air Carrier Access Act (discrimination against handicapped individuals))",
      "49:41713" : "49:41713 (49:41713 Airline Deregulation Actv (premp of authority over prices, routes, and service))",
      "49:44709" : "49:44709 (49:44709 Noise Control Act of 1972)",
      "49:44715" : "49:44715 (49:44715 Noise Control Act of 1972)",
      "49:46507" : "49:46507 (49:46507 False information and threats)",
      "49:47101" : "49:47101 (49:47101 Airport and Airway Improvement Act of 1982)",
      "49:47501" : "49:47501 (49:47501 Aviation Safety & Noise Abatement Act of 1979)",
      "49:49101" : "49:49101 (49:49101 Wrongful Termination in Contravention of Published Regulations)",
      "49:49104" : "49:49104 (49:49104 Breach of Lease by Metro. Wash. Airport Auth.)",
      "49:60101" : "49:60101 (49:60101 Pipeline Safety Act of 1994)",
      "49:60102" : "49:60102 (49:60102 Hazardous Liquid Pipeline Safety Act of 1979 (HLPSA))",
      "49:80102" : "49:80102 (49:80102 Bills of Lading - Application)",
      "49:80302" : "49:80302 (49:80302 Contraband - Prohibitions)",
      "49:80303" : "49:80303 (49:80303 Seizure and forfeiture of vessel or aircraft conveying contraband)",
      "50:1701" : "50:1701 (50:1701 International Emergency Economic Powers Act)",
      "50:1702" : "50:1702 (50:1702 International Emergency Economic Powers Act)",
      "50:1703" : "50:1703 (50:1703 International Emergency Economic Powers Act)",
      "50:1704" : "50:1704 (50:1704 International Emergency Economic Powers Act)",
      "50:1705" : "50:1705 (50:1705 International Emergency Economic Powers Act)",
      "50:1706" : "50:1706 (50:1706 International Emergency Economic Powers Act)",
      "50a:0001" : "50a:0001 (50a:1 Trading With the Enemy Act (act located in Title 50, Appendix.))",
      "50a:0501" : "50a:0501 (50a:501 Sailors and Soldiers Civil Relief Act (act located in Title 50, Appendix.))",
      "50a:0533" : "50a:0533 (50a:533 Servicemembers Civil Relief Act-mortgages (act located in Title 50, Appendix.))",
      "50a:0540" : "50a:0540 (50a:540 Sailors and Soldiers Civil Relief Act (act located in Title 50, Appendix.))",
      "50a:2412" : "50a:2412 (50a:2412 Export Administration Act--1979 (act located in Title 50, Appendix.))",
      "51:20137a" : "51:20137a (51:20137(a) Malpractice & Negligence Against U.S. Space program)",
      "99:9999" : "99:9999 (99:9999 Report cause code (DO NOT DELETE!))",
      "M:08-425" : "M:08-425 (M 08-425 Sureties Proceedings)",
      "M:08-65" : "M:08-65 (M 08-65 Letters Rogatory - Cuba)",
      "M:08-85c" : "M:08-85c (M 08-85 Motion to Compel)",
      "M:08-85q" : "M:08-85q (M 08-85 Motion to Quash)",
      "M:08-86" : "M:08-86 (M 08-86 Internet Infringement)",
      "M:08-88" : "M:08-88 (M 08-88 Surety Companies)",
      "M:09-282" : "M:09-282 (M 09-282 Attorney Change of Name)",
      "M:09-342" : "M:09-342 (M 09-342 Letters Rogatory - Costa Rica)",
      "M:09-372" : "M:09-372 (M 09-372 Letters Rogatory - Spain)",
      "M:10-468" : "M:10-468 (M 10-468 Standing Order)",
      "M:10-63" : "M:10-63 (M 10-63 Letters Rogatory - Sweden)",
      "M:10-7" : "M:10-7 (M 10-7 Letters Rogatory - Argentina)",
      "M:11-03" : "M:11-03 (M 11-03 SEC Litigation to Freeze Account)",
      "M:11-120" : "M:11-120 (M 11-120 Letters Rogatory - Mexico)",
      "M:11-188" : "M:11-188 (M 11-188 Subpoenas - Habeas Corpus)",
      "M:11-189" : "M:11-189 (M 11-189 Subpoenas - Habeas Corpus)",
      "M:12-160" : "M:12-160 (M 12-160 Letters Rogatory - Canada)",
      "M:12-329" : "M:12-329 (M 12-329 Letters Rogatory - Italy)",
      "M:13-72" : "M:13-72 (M 13-72 Letters Rogatory - Brazil)",
      "M:15-306" : "M:15-306 (M 15-306 Letters Rogatory - Puerto Rico)",
      "M:15-377" : "M:15-377 (M 15-377 Letters Rogatory - Venezuela)",
      "M:16-286" : "M:16-286 (M 16-286 Letters Rogatory - Guatemala)",
      "M:16-347" : "M:16-347 (M 16-347 Letters Rogatory - Columbia)",
      "M:16-59" : "M:16-59 (M 16-59 Letters Rogatory - Czech Republic)",
      "M:16-88" : "M:16-88 (M 16-88 Sale of Unclaimed Seamens' Effects)",
      "M:18-113" : "M:18-113 (M 18-113 Letters Rogatory - Tanzania)",
      "M:18-117" : "M:18-117 (M 18-117 Letters Rogatory - Poland)",
      "M:18-302" : "M:18-302 (M 18-302 Registration of Foreign Judgment)",
      "M:18-304" : "M:18-304 (M 18-304 Administrative Subpoena Proceedings)",
      "M:18-305" : "M:18-305 (M 18-305 Registration of Student Loan Judgment)",
      "M:18-66" : "M:18-66 (M 18-66 Forfeiture Proceedings - Funds Held in Trust 28 USC 1746)",
      "M:18-981" : "M:18-981 (M 18-981 Nonjudicial Civil Forfeiture Proceeding)",
      "M:19-101" : "M:19-101 (M 19-101 Letters Rogatory - Aruba)",
      "M:19-102" : "M:19-102 (M 19-102 Letters Rogatory - Peru)",
      "M:19-103" : "M:19-103 (M 19-103 Letters Rogatory - Andorra)",
      "M:19-104" : "M:19-104 (M 19-104 Letters Rogatory - Brussels)",
      "M:19-106" : "M:19-106 (M 19-106 Letters Rogatory - Mauritania)",
      "M:19-107" : "M:19-107 (M 19-107 Letters Rogatory - Luxembourg)",
      "M:19-109" : "M:19-109 (M 19-109 Letters Rogatory - Portugal)",
      "M:19-110" : "M:19-110 (M 19-110 Letters Rogatory - Israel)",
      "M:19-111" : "M:19-111 (M 19-111 Letters Rogatory - Ecuador)",
      "M:19-112" : "M:19-112 (M 19-112 Letters Rogatory - Ireland)",
      "M:19-113" : "M:19-113 (M 19-113 Letters Rogatory - Haiti)",
      "M:19-114" : "M:19-114 (M 19-114 Letters Rogatory - Greece)",
      "M:19-115" : "M:19-115 (M 19-115 Letters Rogatory - Belgium)",
      "M:19-116" : "M:19-116 (M 19-116 Letters Rogatory - Russia)",
      "M:19-117" : "M:19-117 (M 19-117 Letters Rogatory - Hong Kong)",
      "M:19-118" : "M:19-118 (M 19-118 Letters Rogatory - Bermuda)",
      "M:19-119" : "M:19-119 (M 19-119 Letters Rogatory - Monaco)",
      "M:19-120" : "M:19-120 (M 19-120 Letters Rogatory - Hungary)",
      "M:19-121" : "M:19-121 (M 19-121 Letters Rogatory - Lithuania)",
      "M:19-122" : "M:19-122 (M 19-122 Letters Rogatory - Latvia)",
      "M:19-123" : "M:19-123 (M 19-123 Letters Rogatory - Finland)",
      "M:19-130" : "M:19-130 (M 19-130 Letters Rogatory - Kazakhstan)",
      "M:19-131" : "M:19-131 (M 19-131 Letters Rogatory - Dabal)",
      "M:19-132" : "M:19-132 (M 19-132 Letters Rogatory - New Zealand)",
      "M:19-133" : "M:19-133 (M 19-133 Letters Rogatory - Belarus)",
      "M:19-134" : "M:19-134 (M 19-134 Letters Rogatory - Cyprus)",
      "M:19-135" : "M:19-135 (M 19-135 Letters Rogatory - South Africa)",
      "M:19-136" : "M:19-136 (M 19-136 Letters Rogatory - Jersey)",
      "M:19-137" : "M:19-137 (M 19-137 Letters Rogatory - Antigua)",
      "M:19-138" : "M:19-138 (M 19-138 Letters Rogatory - Saint Vincent Grenadines)",
      "M:19-139" : "M:19-139 (M 19-139 Letters Rogatory - British Virgin Islands)",
      "M:19-141" : "M:19-141 (M 19-141 Letters Rogatory - Korea)",
      "M:19-143" : "M:19-143 (M 19-143 Letters Rogatory - Liechtenstein)",
      "M:19-145" : "M:19-145 (M 19-145 Letters Rogatory - Slovak Republic)",
      "M:19-146" : "M:19-146 (M 19-146 Letters Rogatory - China)",
      "M:19-148" : "M:19-148 (M 19-148 Letters Rogatory - Anguilla)",
      "M:19-151" : "M:19-151 (M 19-151 Letters Rogatory - Ukraine)",
      "M:19-152" : "M:19-152 (M 19-152 Letters Rogatory - Croatia)",
      "M:19-155" : "M:19-155 (M 19-155 Letters Rogatory - Special Court for Sierra Leone)",
      "M:19-156" : "M:19-156 (M 19-156 Letters Rogatory - Moldova)",
      "M:19-193" : "M:19-193 (M 19-193 Letters Rogatory - Yugoslavia)",
      "M:19-194" : "M:19-194 (M 19-194 Letters Rogatory - Philippines)",
      "M:19-195" : "M:19-195 (M 19-195 Letters Rogatory - Pakistan)",
      "M:19-196" : "M:19-196 (M 19-196 Letters Rogatory - Zimbabwe)",
      "M:19-197" : "M:19-197 (M 19-197 Letters Rogatory - Nigeria)",
      "M:19-198" : "M:19-198 (M 19-198 Letters Rogatory - Namibia)",
      "M:19-199" : "M:19-199 (M 19-199 Letters Rogatory - Indonesia)",
      "M:19-200" : "M:19-200 (M 19-200 Letters Rogatory - Zambia)",
      "M:19-201" : "M:19-201 (M 19-201 Letters Rogatory - Romania)",
      "M:19-25" : "M:19-25 (M 19-25 Order Authorizing IRS Officer to Enter Premises for Levy)",
      "M:19-300" : "M:19-300 (M 19-300 Letters Rogatory - Uruguay)",
      "M:19-301" : "M:19-301 (M 19-301 Letters Rogatory - Uganda)",
      "M:19-302" : "M:19-302 (M 19-302 Letters Rogatory - Singapore)",
      "M:19-303" : "M:19-303 (M 19-303 Letters Rogatory - Mauritius)",
      "M:19-305" : "M:19-305 (M 19-305 Letters Rogatory - Panama)",
      "M:19-373" : "M:19-373 (M 19-373 Letters Rogatory - Vietnam)",
      "M:19-374" : "M:19-374 (M 19-374 Letters Rogatory - Cayman Islands)",
      "M:19-376" : "M:19-376 (M 19-376 Letters Rogatory - Kenya)",
      "M:19-378" : "M:19-378 (M 19-378 Letters Rogatory - Azerbaijan)",
      "M:19-379" : "M:19-379 (M 19-379 Letters Rogatory - Guam)",
      "M:19-380" : "M:19-380 (M 19-380 Letters Rogatory - Paraguay)",
      "M:19-382" : "M:19-382 (M 19-382 Letters Rogatory - Bangladesh)",
      "M:19-383" : "M:19-383 (M 19-383 Letters Rogatory - Albania)",
      "M:19-384" : "M:19-384 (M 19-384 Letters Rogatory - Malawi)",
      "M:19-385" : "M:19-385 (M 19-385 Letters Rogatory - Montenegro)",
      "M:19-386" : "M:19-386 (M 19-386 Letters Rogatory - Seychelles)",
      "M:19-4" : "M:19-4 (M 19-4 Letters Rogatory - Jamaica)",
      "M:19-42" : "M:19-42 (M 19-42 Letters Rogatory - Egypt)",
      "M:19-43" : "M:19-43 (M 19-43 Letters Rogatory - Estonia)",
      "M:19-5" : "M:19-5 (M 19-5 Letters Rogatory - Trinidad & Tobago)",
      "M:19-51" : "M:19-51 (M 19-51 Letters Rogatory - Algeria)",
      "M:19-58" : "M:19-58 (M 19-58 General Bonds in Admirality Purs. to Local Admirality Rule 8)",
      "M:19-60" : "M:19-60 (M 19-60 Letters Rogatory - Bulgaria)",
      "M:19-63" : "M:19-63 (M 19-63 Receivers - Property in Other Districts)",
      "M:19-67" : "M:19-67 (M 19-67 Letters Rogatory - Chile)",
      "M:19-70" : "M:19-70 (M 19-70 Letters Rogatory - France)",
      "M:19-71" : "M:19-71 (M 19-71 Letters Rogatory - Thailand)",
      "M:19-73" : "M:19-73 (M 19-73 Letters Rogatory - Austria)",
      "M:19-76" : "M:19-76 (M 19-76 Letters Rogatory - Turkey)",
      "M:19-77" : "M:19-77 (M 19-77 Letters Rogatory - Arabia)",
      "M:19-78" : "M:19-78 (M 19-78 Denial to Sue In Forma Pauperis)",
      "M:19-80" : "M:19-80 (M 19-80 Letters Rogatory - Morocco)",
      "M:19-82" : "M:19-82 (M 19-82 Letters Rogatory - Japan)",
      "M:19-83" : "M:19-83 (M 19-83 Letters Rogatory - Australia)",
      "M:19-84" : "M:19-84 (M 19-84 Letters Rogatory - Switzerland)",
      "M:19-85" : "M:19-85 (M 19-85 Letters Rogatory - Denmark)",
      "M:19-86" : "M:19-86 (M 19-86 Letters Rogatory - India)",
      "M:19-88" : "M:19-88 (M 19-88 Letters Rogatory - Germany)",
      "M:19-89" : "M:19-89 (M 19-89 Letters Rogatory - Guinea)",
      "M:19-90" : "M:19-90 (M 19-90 Letters Rogatory - Norway)",
      "M:19-91" : "M:19-91 (M 19-91 Letters Rogatory - West Pakistan)",
      "M:19-92" : "M:19-92 (M 19-92 Letters Rogatory - Bahamas)",
      "M:19-96" : "M:19-96 (M 19-96 Letters Rogatory - Great Britain)",
      "M:19-98" : "M:19-98 (M 19-98 Letters Rogatory - Somalia)",
      "M:19-99" : "M:19-99 (M 19-99 Letters Rogatory - Netherlands)",
      "M:22-1" : "M:22-1 (M 22-1 Designation by U.S. Attorney of individual to accept service of summons and complaint)",
      "M:22-2" : "M:22-2 (M 22-2 Designation of individual to issue certified copies in bankruptcy part)",
      "M:23" : "M:23 (M 23 Petition to Perpetuate Testimony)",
      "M:25-1" : "M:25-1 (M 25-1 Order for Entry to Effect Levy - IRS Matter)",
      "M:25-2" : "M:25-2 (M 25-2 Permission to have access to safe deposit boxes)",
      "M:26-1" : "M:26-1 (M 26-1 Proceeding to Enforce Order of Administrator - National Credit Union)",
      "M:26-2" : "M:26-2 (M 26-2 Application to Enforce Admin. Order Rule 5A Rule of Division of Business among District Judge)",
      "M:28" : "M:28 (M 28 Warrant for Entry & Inspection of Premises)",
      "M:29" : "M:29 (M 29 Privacy Act Application)",
      "M:30" : "M:30 (M 30 Privacy Act Application)",
      "M:31" : "M:31 (M 31 Order of Commodity Exchange Commission Directing Person to Pay Money)",
      "M:32" : "M:32 (M 32 Petition for Writ to Produce Federal Prisoner in State Court)",
      "M:33" : "M:33 (M 33 Inspection Warrant - Department of Energy)",
      "M:34" : "M:34 (M 34 Order of Another District Court that the State Court Produce)",
      "M:35" : "M:35 (M 35 Order to Stay Transfer of Federal Prisoner)",
      "M:36" : "M:36 (M 36 National Labor Relations Board)",
      "M:37" : "M:37 (M 37 Application to Re-Open Civil Case(s) that are more than 25 years old)",
      "M:38" : "M:38 (M 38 Application for Reassignment of Bankruptcy Proceeding)",
      "M:39" : "M:39 (M 39 Application for Discovery and Inspection of Defendant Detained in Federal Prison)",
      "M:41" : "M:41 (M 41 Order of Return of 28:2254/2255 Petition)",
      "M:42" : "M:42 (M 42 Order Denying Stay of Deportation)",
      "M:43" : "M:43 (M 43 Contempt of Court in Bankruptcy)",
      "M:44" : "M:44 (M 44 Claim Compensation under Longshoremens & Harbor Workers Compensation Act)",
      "M:46" : "M:46 (M 46 Order From Another District for Public Viewing)",
      "M:47" : "M:47 (M 47 Bankruptcy Cases - Before Appeal Filed)",
      "M:47b" : "M:47b (M 47B Transmission of Proposed Findings of Fact and Conclusions of Law)",
      "M:48" : "M:48 (M 48 Application for Appointment of Counsel - No Case In This Court)",
      "M:49" : "M:49 (M 49 Order Denying Commencement of Civil Action)",
      "M:51" : "M:51 (M 51 Order to Show Cause - Case Being Transferred from Northern District of New York)",
      "M:52" : "M:52 (M 52 Application for Leave to File a Complaint)",
      "M:53" : "M:53 (M 53 Order Barring Individual from Entering Courthouse Building)",
      "M:54" : "M:54 (M 54 Immigration Naturalization - Order Delaying Deportation)",
      "M:55" : "M:55 (M 55 Petition for Appointment of Impartial Umpire - Labor Management Relations Act and Others)",
      "M:58" : "M:58 (M 58 Application for Extension of Time to File Petition for Removal)",
      "M:59" : "M:59 (M 59 Application to Produce Federal Prisoner in State Court)",
      "M:67" : "M:67 (M 67 Notice of Eviction to Squatters (USA Cases))",
      "M:70" : "M:70 (M 70 Asbestos Litigation - SDNY)",
      "M:71" : "M:71 (M 71 Application re: Federal Rules Cr. 11(e)(2))",
      "M:72" : "M:72 (M 72 Order of Attachment of Another District - EDNY)",
      "M:73" : "M:73 (M 73 Subpoena to Government Agency)",
      "M:75" : "M:75 (M 75 Application for Writ of Garnishment)",
      "M:76" : "M:76 (M 76 Central Violations Bureau)",
      "M:77" : "M:77 (M 77 Application to have subpoena issued to person living in this district re: action in foreign cou)",
      "M:87" : "M:87 (M 87 Order Returning Fees in Miscellaneous Matters)",
      "M:88" : "M:88 (M 88 Order Denying Leave to File Civil Case(s) Under Seal)",
      "M:90" : "M:90 (M 90 Order of Attachment)",
      "M:91" : "M:91 (M 91 Disbursement to Juror from Petty Cash Fund)",
      "M:92" : "M:92 (M 92 Notice Concerning Election for Judicial Disqualification)",
      "M:93" : "M:93 (M 93 Letters Rogatory)",
      "M:94" : "M:94 (M 94 Other)",
      "M:96" : "M:96 (M 96 Attorney Admissions)",
      "M:other" : "M:other (Civil Miscellaneous Case - Other)",
      "adsup" : "adsup (Administrative Subpoena)",
      "contempt" : "contempt (Contempt Proceedings)",
      "disbar" : "disbar (Disbarment Proceedings)",
      "fordepo" : "fordepo (Foreign Deposition)",
      "misc" : "misc (Civil Miscellaneous Case)",
      "motcomp" : "motcomp (Motion to Compel)",
      "motquash" : "motquash (Motion to Quash)",
      "motret" : "motret (Motion for Return of Property)",
      "petenf" : "petenf (Petition to Enforce IRS Summons)",
      "petper" : "petper (Petition to Perpetuate Testimony)",
      "regjgm" : "regjgm (Registration of Foreign Judgment)",
      "tranbkref" : "tranbkref (Transmission of Bankruptcy Reference)",
      "tranff" : "tranff (Transmission of Proposed Findings of Fact and Concl. of Law)",
      "writgar" : "writgar (Application for a Writ of Garnishment)"
   },
   "nywdce" : {
      "0" : "0 (No cause code entered)",
      "02:0431" : "02:0431 (02:431 Fed. Election Commission: Failure Enforce C)",
      "02:0437" : "02:0437 (02:437 Federal Election Commission)",
      "05:0075" : "05:0075 (05:75(2) Contract - Reduction in Grade)",
      "05:0551" : "05:0551 (05:551 Administrative Procedure Act)",
      "05:0552fi" : "05:0552fi (05:552 Freedom of Information Act)",
      "05:0552pa" : "05:0552pa (05:552 Right to Privacy Act)",
      "05:0554" : "05:0554 (05:0554 Constitutionality of Maritime Statutes)",
      "05:0701" : "05:0701 (05:0701 Maritime Subsidy Board)",
      "05:0702" : "05:0702 (05:702 Administrative Procedure Act)",
      "05:0704" : "05:0704 (05:704 Labor Litigation)",
      "05:7703" : "05:7703 (05:7703 Discrimination - Review of Agency Act)",
      "05:8470" : "05:8470 (05:8470 Enforcement of Judgment against Retirement Benefits)",
      "07:0006" : "07:0006 (7:6(b) Federal Commodity Exchange Regulation)",
      "07:0025" : "07:0025 (7:25 Fraud - Commodities Leverage Contracts)",
      "07:0181" : "07:0181 (07:181 Packers & Stockyard Act)",
      "07:0499" : "07:0499 (07:499 Agricultural Commodities Act)",
      "07:0601" : "07:0601 (07:601 USDA Condemnation)",
      "07:2023" : "07:2023 (07:2023 Violation of Food Stamp Program Regulations)",
      "07:2321" : "07:2321 (07:2321 Plant Variety Protection Act)",
      "08:1105" : "08:1105 (8:1105(a) Aliens: Habeas Corpus to Release INS Det)",
      "08:1182" : "08:1182 (8:1182 Defend. Denial of Pla. Appl. for Alien Employment Cer)",
      "08:1252" : "08:1252 (08:1252(a)(2) Injunction for Deportation)",
      "08:1260" : "08:1260 (08:1260 Aliens: Access to Records)",
      "08:1324" : "08:1324 (08:1324 Aliens: Complaint for Forfeiture)",
      "08:1329" : "08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petiti)",
      "08:1446" : "08:1446 (8:1446 Petition for Naturalization Hearing)",
      "08:1451(j)" : "08:1451(j) (8:1451(j) Motion to Correct Order & Judg. of Naturalization)",
      "09:0001" : "09:0001 (09:1 U.S. Arbitration Act)",
      "09:0009" : "09:0009 (9:9 Motion to Confirm Arbitration Loan)",
      "09:0010" : "09:0010 (09:0010 Petition to Vacate Arbitration Award)",
      "10:1408" : "10:1408 (10:1408 Claim for Military Retirement)",
      "10:1552" : "10:1552 (10:1552 Armed Forces: Action to Correct Records)",
      "10:1553" : "10:1553 (10:1553 Armed Forces: FOIA General)",
      "10:2305" : "10:2305 (10:2305 Review of Federal Contract)",
      "11:0101" : "11:0101 (11:101 Bankruptcy)",
      "12:0022" : "12:0022 (12:22 Securities Fraud)",
      "12:0635" : "12:0635 (12:635 Breach of Insurance Contract)",
      "12:1461" : "12:1461 (12:1461 Homeowners Loan Act)",
      "12:1464" : "12:1464 (12:1464 Federal Savings and Loan)",
      "12:1703" : "12:1703 (12:1703 Default of HUD Loan)",
      "12:1725" : "12:1725 (12:1725 Collection under Contract Guaranty)",
      "12:1730" : "12:1730 (12:1730 Collection Under Contract Guaranty)",
      "12:1819" : "12:1819 (12:1819 Default of Promissory Note)",
      "12:1821" : "12:1821 (12:1821 Default of Loan by Promissary Note)",
      "12:191" : "12:191 (12:191 Bank Foreclosure)",
      "12:192" : "12:192 (12:192 Liquidation of National Bank)",
      "12:1971" : "12:1971 (12:1971 Relief under Bank Holding Act)",
      "12:1972" : "12:1972 (12:1972 Typing Arrangement Act)",
      "12:2601" : "12:2601 (Real Estate Settlement Procedures Act)",
      "12:3410" : "12:3410 (12:3410 Right to Financial Privacy Act)",
      "15:0001" : "15:0001 (15:1 Antitrust Litigation)",
      "15:0002at" : "15:0002at (15:2 Antitrust Litigation)",
      "15:0002fl" : "15:0002fl (15:2(a) Fair Labor Standards Act)",
      "15:0005" : "15:0005 (15:5(a) Fair Labor Standards Act)",
      "15:0015" : "15:0015 (15:15 Antitrust Litigation)",
      "15:0025" : "15:0025 (15:25 Clayton Act)",
      "15:0044" : "15:0044 (15:44 Trademark Infringement)",
      "15:0045" : "15:0045 (15:0045 Federal Trade Commission Act)",
      "15:0052" : "15:0052 (15:0052 Federal Trade Commission Act)",
      "15:0053" : "15:0053 (15:0053 Federal Trade Commission Act)",
      "15:0077" : "15:0077 (15:77 Securities Fraud)",
      "15:0078" : "15:0078 (15:78m(a) Securities Exchange Act)",
      "15:0631" : "15:0631 (15:631 Small Business Act)",
      "15:0717" : "15:0717 (15:717 Natural Gas Act)",
      "15:0754" : "15:0754 (15:754 Emergency Petroleum Allocation-Admin.& Enforcement)",
      "15:1051" : "15:1051 (15:1051 Trademark Infringement)",
      "15:1114" : "15:1114 (15:1114 Trademark Infringement)",
      "15:1121" : "15:1121 (15:1121 Trademark Infringement)",
      "15:1125" : "15:1125 (15:1125 Trademark Infringement (Lanham Act))",
      "15:1126" : "15:1126 (15:1126 Patent Infringement)",
      "15:1127" : "15:1127 (15:1127 Trademark Infringement)",
      "15:1601" : "15:1601 (15:1601 Truth in Lending)",
      "15:1640" : "15:1640 (15:1640 Truth in Lending)",
      "15:1681" : "15:1681 (15:1681 Fair Credit Reporting Act)",
      "15:1692" : "15:1692 (15:1692 Fair Debt Collection Act)",
      "15:1938" : "15:1938 (15:1938 Fair Labor Standards Act)",
      "15:1981" : "15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))",
      "15:1988" : "15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))",
      "15:1989" : "15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))",
      "15:2301" : "15:2301 (15:2301 Magnuson-Moss Warranty Act)",
      "15:2801" : "15:2801 (15:2801 Petroleum Marketing Practices Act)",
      "15:53(b)" : "15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equita)",
      "16:0668" : "16:0668 (16:668 Bald Eagle Protection Act)",
      "16:0703" : "16:0703 (16:703 Migratory Bird Act)",
      "16:1538" : "16:1538 (16:1538 Endangered Species Act)",
      "16:3371" : "16:3371 (16:3371 Wildlife Under the Lacey Act)",
      "16:3372" : "16:3372 (16:3372 Conservation: Complaint for Forfeiture)",
      "16:3373" : "16:3373 (16:3373 Appeal of Decision - DOI)",
      "16:3374" : "16:3374 (16:3374 Conservation: Complaint for Forfeiture)",
      "17:0101" : "17:0101 (17:101 Copyright Infringement)",
      "17:0501" : "17:0501 (17:501 Copyright Infringement)",
      "17:0504" : "17:0504 (17:504 Copyright Infringement)",
      "17:1203" : "17:1203 (17:1203 Digital Millenniun Copyright Act)",
      "18:0241" : "18:0241 (18:241 Conspiracy Against Citizen Rights)",
      "18:1836a" : "18:1836a (18:1836(a) Injunction against Misappropriation of Trade Secrets)",
      "18:1836b" : "18:1836b (18:1836(b) Civil Action to Protect Trade Secrets)",
      "18:1961" : "18:1961 (18:1961 Racketeering (RICO) Act)",
      "18:1962" : "18:1962 (18:1962 Racketeering (RICO) Act)",
      "18:1964" : "18:1964 (18:1964 Racketeering (RICO) Act)",
      "18:2511" : "18:2511 (18:2511 Wiretapping)",
      "18:3114" : "18:3114 (18:3114 Motion for Return of Seized Property)",
      "18:4208" : "18:4208 (18:4208(B) Agency Action Review)",
      "19:1305" : "19:1305 (19:1305 Custom Duties:0Forfeiture-Immoral Articles)",
      "20:1080" : "20:1080 (20:1080 Student Loan Recovery)",
      "20:1400" : "20:1400 (20:1400 Civil Rights of Handicapped Child)",
      "20:1401" : "20:1401 (20:1401 Education: Handicapped Child Act)",
      "21:0841" : "21:0841 (21:841 Forfeiture Property-Drugs)",
      "21:0881" : "21:0881 (21:881 Forfeiture Property-Drugs)",
      "21:0881a" : "21:0881a (21:881 Forfeiture Property - Aircraft)",
      "21:0881re" : "21:0881re (21:881 Forfeiture Property - Real Estate)",
      "23:0134" : "23:0134 (23:134 P.I.- Auto Negligence)",
      "23:1441" : "23:1441 (23:1441 Contract Real Estate)",
      "24:1000" : "24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)",
      "25:0640" : "25:0640 (25:640 Indian Tribal Rights)",
      "25:1901" : "25:1901 (25:1901 Indian Child Welfare Act)",
      "26:6212" : "26:6212 (26:6212 Injunctive Relief from IRS Lien)",
      "26:6213" : "26:6213 (26:6213 Injunctive Relief from IRS Lien)",
      "26:6502" : "26:6502 (26:6502 IRS:Enforcement of tax liens)",
      "26:6532" : "26:6532 (26:6532 IRS: Refund of Tax Penalty)",
      "26:6702" : "26:6702 (26:6702 IRS: Refund of Income Tax Penalty)",
      "26:6703" : "26:6703 (26:6703 IRS: Refund of Tax Penalty)",
      "26:7401" : "26:7401 (26:7401 IRS: Tax Liability)",
      "26:7402" : "26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)",
      "26:7403" : "26:7403 (26:7403 Suit to Enforce Federal Tax Lien)",
      "26:7422rt" : "26:7422rt (26:7422 IRS: Refund Taxes)",
      "26:7422rx" : "26:7422rx (26:7422 IRS: Refund Excise Tax)",
      "26:7426" : "26:7426 (26:7426 IRS: Wrongful Levy for Taxes)",
      "26:7429" : "26:7429 (26:7429 IRS: Tax Jeopardy Assessment)",
      "26:7609" : "26:7609 (26:7609 IRS: Petition to Quash IRS Summons)",
      "27:0185" : "27:0185 (27:185 Enforcement of Arbitration Award)",
      "28:0157c" : "28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)",
      "28:0157d" : "28:0157d (28:0157 Motion for Withdrawal of Reference)",
      "28:0158" : "28:0158 (28:0158 Notice of Appeal re Bankruptcy Matter (BA)",
      "28:0185" : "28:0185 (28:185 Suit to Compel Arbitration)",
      "28:0451" : "28:0451 (28:451 Employment Discrimination)",
      "28:0754" : "28:0754 (28:754 Receiver of Property in Different Districts)",
      "28:0794" : "28:0794 (28:794 Rehabilitation Act)",
      "28:1001" : "28:1001 (28:1001 E.R.I.S.A.)",
      "28:1132" : "28:1132 (28:1132 E.R.I.S.A.)",
      "28:1330" : "28:1330 (28:1330 Breach of Contract)",
      "28:1331" : "28:1331 (28:1331 Fed. Question)",
      "28:1331al" : "28:1331al (28:1331 Fed. Question: Airline Crash)",
      "28:1331at" : "28:1331at (28:1331 Fed. Question: Anti-trust)",
      "28:1331au" : "28:1331au (28:1331 Fed. Question: Auto Negligence)",
      "28:1331b" : "28:1331b (28:1331 Federal Question: Bivens Act)",
      "28:1331bc" : "28:1331bc (28:1331 Fed. Question: Breach of Contract)",
      "28:1331ca" : "28:1331ca (28:1331 Fed Question: Fed Communications Act of 1)",
      "28:1331cm" : "28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)",
      "28:1331cv" : "28:1331cv (28:1331 Federal Question: Other Civil Rights)",
      "28:1331ed" : "28:1331ed (28:1331 Fed. Question: Employment Discrimination)",
      "28:1331ej" : "28:1331ej (28:1331 Federal Question: Enforcement of Judgment)",
      "28:1331es" : "28:1331es (28:1331 Enforcement of Administrative Subpoena)",
      "28:1331fl" : "28:1331fl (28:1331 Fed. Question: Fair Labor Standards)",
      "28:1331in" : "28:1331in (28:1331 Fed. Question: Insurance Contract)",
      "28:1331mm" : "28:1331mm (28:1331 Fed. Question: Medical Malpractice)",
      "28:1331ng" : "28:1331ng (28:1331 Fed. Question: Natural Gas Act)",
      "28:1331pi" : "28:1331pi (28:1331 Fed. Question: Personal Injury)",
      "28:1331rd" : "28:1331rd (28:1331 Fed. Question: Review Agency Decision)",
      "28:1331rp" : "28:1331rp (28:1331(a) Fed. Question: Real Property)",
      "28:1331rr" : "28:1331rr (28:1331 Fed. Question: Railway Labor Act)",
      "28:1331sv" : "28:1331sv (28:1331 Fed. Question: Securities Violation)",
      "28:1331tr" : "28:1331tr (28:1331 Fed. Question: Trademark)",
      "28:1331tt" : "28:1331tt (28:1331 Fed. Question: Tort Action)",
      "28:1331v" : "28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendme)",
      "28:1331wl" : "28:1331wl (28:1331 Federal Question: EPA Waste Lien)",
      "28:1331wt" : "28:1331wt (28:1331 Fed. Question: Water Rights)",
      "28:1332ac" : "28:1332ac (28:1332 Diversity-Account Receivable)",
      "28:1332al" : "28:1332al (28:1332 Diversity-Airline Crash)",
      "28:1332as" : "28:1332as (28:1332 Diversity-Asbestos Litigation)",
      "28:1332au" : "28:1332au (28:1332 Diversity-Auto Negligence)",
      "28:1332bc" : "28:1332bc (28:1332 Diversity-Breach of Contract)",
      "28:1332co" : "28:1332co (28:1332 Diversity-Conversion)",
      "28:1332ct" : "28:1332ct (28:1332 Diversity-(Citizenship))",
      "28:1332det" : "28:1332det (28:1332 Diversity: Forcible Detainer)",
      "28:1332df" : "28:1332df (28:1332 Diversity-Contract Default)",
      "28:1332ds" : "28:1332ds (28:1332 Diversity-Contract Dispute)",
      "28:1332ed" : "28:1332ed (28:1332 Diversity-Employment Discrimination)",
      "28:1332fd" : "28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)",
      "28:1332fr" : "28:1332fr (28:1332 Diversity-Fraud)",
      "28:1332ia" : "28:1332ia (28:1332 Diversity-Interpleader Action)",
      "28:1332ij" : "28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)",
      "28:1332in" : "28:1332in (28:1332 Diversity-Insurance Contract)",
      "28:1332jd" : "28:1332jd (28:1332 Diversity-Declaratory Judgement)",
      "28:1332lb" : "28:1332lb (28:1332 Diversity-Libel,Assault,Slander)",
      "28:1332lm" : "28:1332lm (28:1332 Diversity - Legal Malpractice)",
      "28:1332ma" : "28:1332ma (28:1332 Diversity-Miller Act)",
      "28:1332mm" : "28:1332mm (28:1332 Diversity-Medical Malpractice)",
      "28:1332mv" : "28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)",
      "28:1332ni" : "28:1332ni (28:1332 Diversity-Negotiable Instrument)",
      "28:1332nm" : "28:1332nm (28:1332 Diversity-Non-Motor Vehicle)",
      "28:1332nr" : "28:1332nr (28:1332 Diversity-Notice of Removal)",
      "28:1332oc" : "28:1332oc (28:1332 Diversity-Other Contract)",
      "28:1332pd" : "28:1332pd (28:1332 Diversity-Property Damage)",
      "28:1332pi" : "28:1332pi (28:1332 Diversity-Personal Injury)",
      "28:1332pl" : "28:1332pl (28:1332 Diversity-Product Liability)",
      "28:1332pr" : "28:1332pr (28:1332 Diversity-Petition for Removal)",
      "28:1332qt" : "28:1332qt (28:1332 Diversity-Petition to Quiet Title)",
      "28:1332ri" : "28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)",
      "28:1332sa" : "28:1332sa (28:1332 - Diversity: Securities & Exchange Commiss)",
      "28:1332sf" : "28:1332sf (28:1332 - Diversity: Securities Fraud)",
      "28:1332ss" : "28:1332ss (28:1332 Diversity - Stockholders Suits)",
      "28:1332tl" : "28:1332tl (28:1332 Diversity-Torts to Land)",
      "28:1332tm" : "28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))",
      "28:1332tn" : "28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)",
      "28:1332wd" : "28:1332wd (28:1332 Diversity-Wrongful Death)",
      "28:1333" : "28:1333 (28:1333 Admiralty)",
      "28:1334" : "28:1334 (28:1334 Bankruptcy Appeal)",
      "28:1334c" : "28:1334c (28:1334(c) R&R re motions for abstention (non-cor)",
      "28:1335" : "28:1335 (28:1335 Interpleader Action)",
      "28:1337" : "28:1337 (28:1337 Sherman-Clayton Act)",
      "28:1338cp" : "28:1338cp (28:1338 Copyright Infringement)",
      "28:1338pt" : "28:1338pt (28:1338 Patent Infringement)",
      "28:1338tr" : "28:1338tr (28:1338 Trademark Infringement)",
      "28:1340" : "28:1340 (28:1340 IRS: Custom Duties)",
      "28:1340er" : "28:1340er (28:1340 Recovery of Erroneous Refund)",
      "28:1341" : "28:1341 (28:1341 Complaint for Forfeiture)",
      "28:1343" : "28:1343 (28:1343 Violation of Civil Rights)",
      "28:1345" : "28:1345 (28:1345 USA Plaintiff)",
      "28:1345co" : "28:1345co (28:1345 Replevin & Conversion)",
      "28:1345db" : "28:1345db (28:1345 Debt to US - FHA/HUD Title I)",
      "28:1345df" : "28:1345df (28:1345 Default of Promissory Note)",
      "28:1345er" : "28:1345er (28:1345 Recovery of Erroneous Refund)",
      "28:1345fc" : "28:1345fc (28:1345 Foreclosure)",
      "28:1345ff" : "28:1345ff (28:1345 Complaint for Forfeiture)",
      "28:1345hl" : "28:1345hl (28:1345 VA Home Loan Guaranty Debt)",
      "28:1345mc" : "28:1345mc (28:1345 Medical Care Recovery)",
      "28:1345mi" : "28:1345mi (28:1345 Mining Claim Ejectment)",
      "28:1345pd" : "28:1345pd (28:1345 Property Damage)",
      "28:1345pe" : "28:1345pe (28:1345 Property Ejectment)",
      "28:1345rc" : "28:1345rc (28:1345 Recovery of Debt to US)",
      "28:1345st" : "28:1345st (28:1345 Default of Student Loan)",
      "28:1345tp" : "28:1345tp (28:1345 Trespass on Public Land)",
      "28:1345va" : "28:1345va (28:1345 Recovery of VA Overpayment)",
      "28:1346bc" : "28:1346bc (28:1346 Breach of Contract)",
      "28:1346rc" : "28:1346rc (28:1346 Recovery of IRS Tax)",
      "28:1346tc" : "28:1346tc (28:1346 Tort Claim)",
      "28:1346wd" : "28:1346wd (28:1346 Wrongful Death)",
      "28:1349" : "28:1349 (28:1348 Corporation organized under Federal Law as party)",
      "28:1352" : "28:1352 (28:1352 Miller Act)",
      "28:1355" : "28:1355 (28:1355 Petition for Return of Property)",
      "28:1358" : "28:1358 (28:1358 Land Condemnation)",
      "28:1361" : "28:1361 (28:1361 Petition for Writ of Mandamus)",
      "28:1362ic" : "28:1362ic (28:1362 Indian Tribal Controversy)",
      "28:1362iw" : "28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)",
      "28:1364" : "28:1364 (28:1364 Auto Negligence)",
      "28:1391" : "28:1391 (28:1391 Personal Injury)",
      "28:1402" : "28:1402 (28:1402 Medical Malpractice)",
      "28:1407" : "28:1407 (28:1407 Airline Crash)",
      "28:1441ac" : "28:1441ac (28:1441 Petition for Removal- Account Receivable)",
      "28:1441al" : "28:1441al (28:1441 Petition for Removal- Airline Crash)",
      "28:1441as" : "28:1441as (28:1441 Petition for Removal- Asbestos Litigation)",
      "28:1441au" : "28:1441au (28:1441 Petition for Removal- Auto Negligence)",
      "28:1441bc" : "28:1441bc (28:1441 Petition for Removal- Breach of Contract)",
      "28:1441cv" : "28:1441cv (28:1441 Petition for Removal- Civil Rights Act)",
      "28:1441df" : "28:1441df (28:1441 Petition for Removal- Contract Default)",
      "28:1441dj" : "28:1441dj (28:1441 Petition for Removal- Declaratory Judgemen)",
      "28:1441ds" : "28:1441ds (28:1441 Petition for Removal- Contract Dispute)",
      "28:1441ed" : "28:1441ed (28:1441 Petition for Removal - Employment Discrim)",
      "28:1441fc" : "28:1441fc (28:1441 Petition for Removal - Fair Credit Reporti)",
      "28:1441fr" : "28:1441fr (28:1441 Petition for Removal- Fraud)",
      "28:1441ij" : "28:1441ij (28:1441 Petition for Removal- Injunctive/Declarato)",
      "28:1441in" : "28:1441in (28:1441 Petition for Removal- Insurance Contract)",
      "28:1441int" : "28:1441int (28:1441 Petition for Removal- Action for Interplea)",
      "28:1441lb" : "28:1441lb (28:1441 Petition for Removal Libel,Assault,Slander)",
      "28:1441lm" : "28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relatio)",
      "28:1441mm" : "28:1441mm (28:1441 Petition for Removal- Medical Malpractice)",
      "28:1441ni" : "28:1441ni (28:1441 Petition for Removal- Negotiable Instrumen)",
      "28:1441nm" : "28:1441nm (28:1441 Petition for Removal- Non-Motor Vehicle)",
      "28:1441nr" : "28:1441nr (28:1441 Notice of Removal)",
      "28:1441oc" : "28:1441oc (28:1441 Petition For Removal--Other Contract)",
      "28:1441pd" : "28:1441pd (28:1441 Petition for Removal- Property Damage)",
      "28:1441pi" : "28:1441pi (28:1441 Petition for Removal- Personal Injury)",
      "28:1441pl" : "28:1441pl (28:1441 Petition for Removal- Product Liability)",
      "28:1441pr" : "28:1441pr (28:1441 Petition for Removal)",
      "28:1441qt" : "28:1441qt (28:1441 Petition for Removal- Petition to Quiet Ti)",
      "28:1441ri" : "28:1441ri (28:1441 Petition for Removal- Racketeering (RICO))",
      "28:1441sa" : "28:1441sa (28:1441 - Petition for Removal: SEC Act)",
      "28:1441sf" : "28:1441sf (28:1441 - Petition for Removal: Securities Fraud)",
      "28:1441tl" : "28:1441tl (28:1441 Petition for Removal- Torts to Land)",
      "28:1441tm" : "28:1441tm (28:1441 Petition for Removal- Tort/Motor Vehicle ()",
      "28:1441tn" : "28:1441tn (28:1441 Petition for Removal- Tort/Non-Motor Vehic)",
      "28:1441wd" : "28:1441wd (28:1441 Petition for Removal- Wrongful Death)",
      "28:1442bc" : "28:1442bc (28:1442 Petition for Removal- Breach of Contract)",
      "28:1442nr" : "28:1442nr (28:1442 Notice of Removal)",
      "28:1442pr" : "28:1442pr (28:1442 Petition for Removal)",
      "28:1443" : "28:1443 (28:1443(1) Rent, Lease & Ejectment)",
      "28:1444" : "28:1444 (28:1444 Petition for Removal- Foreclosure)",
      "28:1446in" : "28:1446in (28:1446 Breach of Contract- Insurance)",
      "28:1446nr" : "28:1446nr (28:1446 Notice of Removal)",
      "28:1446pd" : "28:1446pd (28:1446 Petition for Removal- Property Damage (P.I)",
      "28:1446pi" : "28:1446pi (28:1446 Petition for Removal- Personal Injury)",
      "28:1446pl" : "28:1446pl (28:1446pl Petition for Removal - Product Liability)",
      "28:1446pr" : "28:1446pr (28:1446 Petition for Removal)",
      "28:1452" : "28:1452 (28:1452 R&R re motions to remand (non-core))",
      "28:1651" : "28:1651 (28:1651 Petition for Writ of Coram Nobis)",
      "28:1651hc" : "28:1651hc (28:1651 Petition for Writ of Habeas Corpus)",
      "28:1651mn" : "28:1651mn (28:1651 Petition for Writ of Mandamus)",
      "28:1782" : "28:1782 (28:1782 Letter rogatory - appointment)",
      "28:1821" : "28:1821 (28:1821 Witness Fees, Per Diem, Mileage)",
      "28:1983" : "28:1983 (28:1983 Civil Rights)",
      "28:2201" : "28:2201 (28:2201 Constitutionality of State Statute(s))",
      "28:2201dj" : "28:2201dj (28:2201 Declaratory Judgement)",
      "28:2201ij" : "28:2201ij (28:2201 Injunction)",
      "28:2201in" : "28:2201in (28:2201 Declaratory Judgement (Insurance))",
      "28:2241" : "28:2241 (28:2241 Petition for Writ of Habeas Corpus (federa)",
      "28:2254" : "28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))",
      "28:2254se" : "28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)",
      "28:2255" : "28:2255 (28:2255 Motion to Vacate / Correct Illegal Sentenc)",
      "28:2271" : "28:2271 (28:2271 Federal Tort Claims Act)",
      "28:2345" : "28:2345 (28:2345 Medicare Recovery)",
      "28:2409" : "28:2409 (28:2409(a) Quiet Title Action)",
      "28:2410" : "28:2410 (28:2410 Quiet Title)",
      "28:2671" : "28:2671 (28:2671 Federal Tort Claims Act)",
      "28:2674" : "28:2674 (28:2674 Federal Tort Claims Act)",
      "28:3001" : "28:3001 (28:3001 Federal Debt Collection Act)",
      "28:7402" : "28:7402 (28:7402 Refund of Taxes)",
      "28:7422" : "28:7422 (28:7422 Appeal from Administrative Decision)",
      "29:0151" : "29:0151 (29:151 Labor: Review of Agency Action)",
      "29:0160" : "29:0160 (29:160(1) National Labor Relations Act)",
      "29:0184" : "29:0184 (29:184 Violation Collection Bargain Agreement)",
      "29:0185ep" : "29:0185ep (29:185 Employee Pension Plan)",
      "29:0185lm" : "29:0185lm (29:185 Labor/Mgt. Relations (Contracts))",
      "29:0201do" : "29:0201do (29:201 Denial of Overtime Compensation)",
      "29:0201fl" : "29:0201fl (29:201 Fair Labor Standards Act)",
      "29:0203" : "29:0203 (29:203 Equal Pay Act)",
      "29:0206" : "29:0206 (29:206 Collect Unpaid Wages)",
      "29:0401" : "29:0401 (29:0401 Labor Management Disclosure Act)",
      "29:0621" : "29:0621 (29:621 Job Discrimination (Age))",
      "29:0623" : "29:0623 (29:623 Job Discrimination (Age))",
      "29:0626" : "29:0626 (29:626 Job Discrimination (Age))",
      "29:0633" : "29:0633 (29:633 Job Discrimination (Age))",
      "29:0651" : "29:0651 (29:651 Occupational Safety/Health)",
      "29:0754" : "29:0754 (29:754 Discrimination)",
      "29:0791" : "29:0791 (29:791 Job Discrimination (Rehabilitation Act))",
      "29:0794" : "29:0794 (29:0794 Job Discrimination (Handicap))",
      "29:1001" : "29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)",
      "29:1002" : "29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)",
      "29:1104" : "29:1104 (29:1104 Recovery of Benefits to Employee)",
      "29:1109" : "29:1109 (29:1109 Breach of Fiduciary Duties)",
      "29:1131" : "29:1131 (29:1131 ERISA - Collection of Delinquent Trust Fun)",
      "29:1132" : "29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)",
      "29:1145" : "29:1145 (29:1145 E.R.I.S.A.)",
      "29:1149" : "29:1149 (29:1149 Recover Pension & Profit Sharing)",
      "29:1337" : "29:1337 (29:1337 E.R.I.S.A.)",
      "29:1362" : "29:1362 (29:1362 ERISA)",
      "29:1381" : "29:1381 (29:1381 E.R.I.S.A.)",
      "29:1401" : "29:1401 (29:1401(b)(2) Appeal of Arbitration Award)",
      "29:1451" : "29:1451 (29:1451 E.R.I.S.A.)",
      "29:1801" : "29:1801 (29:1801 Farmworker Rights)",
      "29:790" : "29:790 (29:790 Rehabilitation of Labor)",
      "30:0181" : "30:0181 (30:181 Environment: Review of Agency Action)",
      "30:0801" : "30:0801 (30:0801 Penalities/Federal Mine Safety Health Act)",
      "30:1201" : "30:1201 (30:1201 Environment: Review of Agency Action)",
      "30:1202" : "30:1202 (30:1202 Mining Reclamation Act)",
      "30:1276" : "30:1276 (30:1276 Interior: Review of Agency Action)",
      "31:3545" : "31:3545 (31:3545 Action to Recovery Money)",
      "31:3729" : "31:3729 (31:3729 False Claims Act)",
      "31:3730" : "31:3730 (31:3730 Qui Tam False Claims Act)",
      "31:3731" : "31:3731 (31:3731 Fraud)",
      "33:1319cw" : "33:1319cw (33:1319 Clean Water Act)",
      "33:1319pv" : "33:1319pv (33:1319 Pollutants & Permit Violations)",
      "33:1365" : "33:1365 (33:1365 Environmental Matters)",
      "35:0145" : "35:0145 (35:145 Patent Infringement)",
      "35:0183" : "35:0183 (35:183 Patent Infringement)",
      "35:0271" : "35:0271 (35:271 Patent Infringement)",
      "38:1681" : "38:1681 (38:1681 Recovery of VA Overpayment)",
      "38:1686" : "38:1686 (38:1686 Recovery of VA Overpayment)",
      "38:1780" : "38:1780 (38:1780 Recovery of VA Overpayment)",
      "38:2011" : "38:2011 (38:2011 - Veteran's Readjustment Assistance Act of)",
      "38:2021" : "38:2021 (Right to re-employment of inducted persons)",
      "38:3116" : "38:3116 (38:3116 VA Overpayment)",
      "38:775" : "38:775 (Recovery of Servicemen's Group Life Insurance)",
      "39:3005" : "39:3005 (39:3005 Detention of Mail for Temporary Periods)",
      "39:409" : "39:409 (39:409 Postal Service)",
      "40:0258" : "40:0258 (40:258(a) Public Buildings & Property: Land Condem)",
      "40:0270" : "40:0270 (40:270 Miller Act)",
      "40:0875" : "40:0875 (40:875 Public Buildings & Property: Negligence)",
      "41:0251" : "41:0251 (41:251 Public Contracts-Review of Agency Action)",
      "41:1463" : "41:1463 (41:1463 Public Contracts: Unlawful Employment Prac)",
      "42:0205" : "42:0205 (42:205 Denial Social Security Benefits)",
      "42:0206" : "42:0206 (42:206 Social Security Benefits)",
      "42:0247" : "42:0247 (42:247 Personal Injury-Swine Flu)",
      "42:0402" : "42:0402 (42:402 Social Security Benefits)",
      "42:0405id" : "42:0405id (42:405 Review of HHS Decision (SSID))",
      "42:0405wc" : "42:0405wc (42:405 Review of HHS Decision (DIWC))",
      "42:0405ww" : "42:0405ww (42:405 Review of HHS Decision (DIWW))",
      "42:0416" : "42:0416 (42:416 Denial of Social Security Benefits)",
      "42:0427" : "42:0427 (42:427 Social Security Benefits)",
      "42:11603" : "42:11603 (International Child Abduction Remedies Act)",
      "42:12101" : "42:12101 (42:12101 Americans With Disabilities Act)",
      "42:1383" : "42:1383 (42:1383 Review of HHS Decision)",
      "42:1395" : "42:1395 (42:1395 HHS: Adverse Reimbursement Review)",
      "42:1396" : "42:1396 (42:1396 - Tort Negligence)",
      "42:1471" : "42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclo)",
      "42:1981cv" : "42:1981cv (42:1981 Civil Rights)",
      "42:1981hs" : "42:1981hs (42:1981 Housing Discrimination)",
      "42:1981jb" : "42:1981jb (42:1981 Job Discrimination (Race))",
      "42:1981sx" : "42:1981sx (42:1981 Sex Discrimination)",
      "42:1983cv" : "42:1983cv (42:1983 Civil Rights Act)",
      "42:1983ed" : "42:1983ed (42:1983 Civil Rights (Employment Discrimination))",
      "42:1983pr" : "42:1983pr (42:1983 Prisoner Civil Rights)",
      "42:1986" : "42:1986 (42:1986 Neglect of Duty)",
      "42:2000ag" : "42:2000ag (42:2000 Job Discrimination (Age))",
      "42:2000e" : "42:2000e (42:2000e Job Discrimination (Employment))",
      "42:2000pb" : "42:2000pb (42:2000 Job Discrimination (Public Accommodations))",
      "42:2000ra" : "42:2000ra (42:2000 Job Discrimination (Race))",
      "42:2000sx" : "42:2000sx (42:2000 Job Discrimination (Sex))",
      "42:2003" : "42:2003 (42:2003 Job Discrimination)",
      "42:2005" : "42:2005 (42:2005 Review of Agency Action-HHS)",
      "42:2615" : "42:2615 (42:2616 Medical Recovery Act)",
      "42:2651" : "42:2651 (42:2651 Medical Care Recovery)",
      "42:3601" : "42:3601 (42:405 Fair Housing Act)",
      "42:4000" : "42:4000 (42:4000 National Flood Insurance Act)",
      "42:4001" : "42:4001 (42:4001 National Insurance Flood Act)",
      "42:4053" : "42:4053 (42:4053 Breach of Insurance Contract)",
      "42:4072" : "42:4072 (42:4072 Payment of Flood Insurance Claim)",
      "42:4321" : "42:4321 (42:4321 Review of Agency Action-Environment)",
      "42:4332" : "42:4332 (42:4332 Environmental Policy - Coop of Agency Repo)",
      "42:6901en" : "42:6901en (42:6901 Environmental Cleanup Expenses)",
      "42:6901rs" : "42:6901rs (42:6901 Resource & Recovery Act)",
      "42:7413" : "42:7413 (42:7413(b) Clean Air Act)",
      "42:7604cl" : "42:7604cl (42:7604 Clear Air Act (Emission Standards))",
      "42:7604ir" : "42:7604ir (42:7604 Petition to Quash IRS Summons)",
      "42:9607" : "42:9607 (42:9607 Real Property Tort to Land)",
      "43:945" : "43:945 (43:945 Compensation for Land Condemnation)",
      "43:945a" : "43:945a (43:945a Complaint in Condemnation)",
      "43:946" : "43:946 (43:946 Complaint in Condemnation - Eminent Domain)",
      "45:0051" : "45:0051 (45:51 Railways: Fed. Employer's Liability Act)",
      "45:0151" : "45:0151 (45:151 Railway Labor Act)",
      "45:0184" : "45:0184 (45:184 Action to Set Aside Award of a System Board)",
      "45:1395" : "45:1395 (45:1395 Railroads: Adverse Reimbursement Review)",
      "45:7457" : "45:7457 (45:7457 Compel Reclamation Under Clear Air Act)",
      "46:0688" : "46:0688 (46:688 Jones Act)",
      "46:0741" : "46:0741 (46:741 Shipping)",
      "46:0761" : "46:0761 (46:761 Shipping: Damages for Death on High Seas)",
      "46:1101" : "46:1101 (46:1101 Violation of Maritime Regulations)",
      "46:1156" : "46:1156 (46:1156 Administrative Procedure Act)",
      "48:0883" : "48:0883 (48:883 Violation of US Coastal Law)",
      "48:1985" : "48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)",
      "49:0081" : "49:0081 (49:81 Damaged Goods While Being Transported)",
      "49:0502" : "49:0502 (49:502 Motor Carrier Safety Act of 1984)",
      "49:0781" : "49:0781 (49:781 Forfeiture)",
      "49:11503" : "49:11503 (49:11503 Railroad Revitalization Regulatory Reform)",
      "49:11702" : "49:11702 (49:11702(a)(4) Violations of Interstate Commerce A)",
      "49:1471" : "49:1471 (49:1471 Federal Aviation Act)",
      "49:1903" : "49:1903 (49:1903 Petition to enforce administrative summon)",
      "8:287" : "8:287 (8:287 Petition to Enforce INS Subpoena)",
      "99:9999" : "99:9999 (99:9999 Report cause code (DO NOT DELETE!))",
      "adsup" : "adsup (Administrative Subpoena)",
      "contempt" : "contempt (Contempt Proceedings)",
      "disbar" : "disbar (Disbarment Proceedings)",
      "fordepo" : "fordepo (Foreign Deposition)",
      "misc" : "misc (Civil Miscellaneous Case)",
      "motcomp" : "motcomp (Motion to Compel)",
      "motquash" : "motquash (Motion to Quash)",
      "motret" : "motret (Motion for Return of Property)",
      "petenf" : "petenf (Petition to Enforce IRS Summons)",
      "petper" : "petper (Petition to Perpetuate Testimony)",
      "regjgm" : "regjgm (Registration of Foreign Judgment)",
      "tranbkref" : "tranbkref (Transmission of Bankruptcy Reference)",
      "tranff" : "tranff (Transmission of Proposed Findings of Fact and Concl. of Law)",
      "writgar" : "writgar (Application for a Writ of Garnishment)"
   },
   "ohndce" : {
      "0" : "0 (No cause code entered)",
      "00:0000" : "00:0000 (00:0000 Cause Code Unknown)",
      "02:0431" : "02:0431 (02:431 Fed. Election Commission: Failure Enforce C)",
      "02:0437" : "02:0437 (02:437 Federal Election Commission)",
      "05:0075" : "05:0075 (05:75(2) Contract - Reduction in Grade)",
      "05:0551" : "05:0551 (05:551 Administrative Procedure Act)",
      "05:0552fi" : "05:0552fi (05:552 Freedom of Information Act)",
      "05:0552pa" : "05:0552pa (05:552 Right to Privacy Act)",
      "05:0554" : "05:0554 (05:0554 Constitutionality of Maritime Statutes)",
      "05:0701" : "05:0701 (05:0701 Maritime Subsidy Board)",
      "05:0702" : "05:0702 (05:702 Administrative Procedure Act)",
      "05:0704" : "05:0704 (05:704 Labor Litigation)",
      "05:7703" : "05:7703 (05:7703 Discrimination - Review of Agency Act)",
      "05:8101" : "05:8101 (05:8101 Federal Employees Compensation Act )",
      "07:0006" : "07:0006 (7:6(b) Federal Commodity Exchange Regulation)",
      "07:0025" : "07:0025 (7:25 Fraud - Commodities Leverage Contracts)",
      "07:0181" : "07:0181 (07:181 Packers & Stockyard Act)",
      "07:0499" : "07:0499 (07:499 Agricultural Commodities Act)",
      "07:0601" : "07:0601 (07:601 USDA Condemnation)",
      "07:2023" : "07:2023 (07:2023 Food Stamp Act)",
      "07:2321" : "07:2321 (07:2321 Plant Variety Protection Act)",
      "08:1105" : "08:1105 (8:1105(a) Aliens: Habeas Corpus to Release INS Det)",
      "08:1252" : "08:1252 (08:1252(a)(2) Injunction for Deportation)",
      "08:1260" : "08:1260 (08:1260 Aliens: Access to Records)",
      "08:1324" : "08:1324 (08:1324 Aliens: Complaint for Forfeiture)",
      "08:1329" : "08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petiti)",
      "08:1446" : "08:1446 (8:1446 Petition for Naturalization Hearing)",
      "08:1451" : "08:1451 (08:1451(a) Revocation of Naturalization )",
      "09:0001" : "09:0001 (09:1 U.S. Arbitration Act)",
      "09:0009" : "09:0009 (9:9 Motion to Confirm Arbitration Loan)",
      "09:0010" : "09:0010 (09:0010 Petition to Vacate Arbitration Award)",
      "10:1552" : "10:1552 (10:1552 Armed Forces: Action to Correct Records)",
      "10:1553" : "10:1553 (10:1553 Armed Forces: FOIA General)",
      "10:2305" : "10:2305 (10:2305 Review of Federal Contract)",
      "11:0101" : "11:0101 (11:101 Bankruptcy)",
      "12:0022" : "12:0022 (12:22 Securities Fraud)",
      "12:0635" : "12:0635 (12:635 Breach of Insurance Contract)",
      "12:1441" : "12:1441 (12:1441 Replevin; Action to recover property )",
      "12:1461" : "12:1461 (12:1461 Homeowners Loan Act)",
      "12:1703" : "12:1703 (12:1703 Default of HUD Loan)",
      "12:1725" : "12:1725 (12:1725 Collection under Contract Guaranty)",
      "12:1730" : "12:1730 (12:1730 Collection Under Contract Guaranty)",
      "12:1819" : "12:1819 (12:1819 Default of Promissory Note)",
      "12:1821" : "12:1821 (12:1821 Default of Loan by Promissary Note)",
      "12:1971" : "12:1971 (12:1971 Relief under Bank Holding Act)",
      "12:3410" : "12:3410 (12:3410 Right to Financial Privacy Act)",
      "15:0001" : "15:0001 (15:1 Antitrust Litigation)",
      "15:0002at" : "15:0002at (15:2 Antitrust Litigation)",
      "15:0002fl" : "15:0002fl (15:2(a) Fair Labor Standards Act)",
      "15:0005" : "15:0005 (15:5(a) Fair Labor Standards Act)",
      "15:0015" : "15:0015 (15:15 Antitrust Litigation)",
      "15:0025" : "15:0025 (15:25 Clayton Act)",
      "15:0044" : "15:0044 (15:44 Trademark Infringement)",
      "15:0045" : "15:0045 (15:0045 Federal Trade Commission Act)",
      "15:0052" : "15:0052 (15:0052 Federal Trade Commission Act)",
      "15:0053" : "15:0053 (15:0053 Federal Trade Commission Act)",
      "15:0077" : "15:0077 (15:77 Securities Fraud)",
      "15:0078" : "15:0078 (15:78m(a) Securities Exchange Act)",
      "15:0631" : "15:0631 (15:631 Small Business Act)",
      "15:0717" : "15:0717 (15:717 Natural Gas Act)",
      "15:1051" : "15:1051 (15:1051 Trademark Infringement)",
      "15:1114" : "15:1114 (15:1114 Trademark Infringement)",
      "15:1121" : "15:1121 (15:1121 Trademark Infringement)",
      "15:1125" : "15:1125 (15:1125 Trademark Infringement (Lanham Act))",
      "15:1126" : "15:1126 (15:1126 Patent Infringement)",
      "15:1127" : "15:1127 (15:1127 Trademark Infringement)",
      "15:1221" : "15:1221 (15:1221 Auto Dealers Suits Against Manufacturers )",
      "15:1261" : "15:1261 (15:1261 Federal Hazardous Substances Act )",
      "15:1601" : "15:1601 (15:1601 Truth in Lending)",
      "15:1640" : "15:1640 (15:1640 Truth in Lending)",
      "15:1681" : "15:1681 (15:1681 Fair Credit Reporting Act)",
      "15:1692" : "15:1692 (15:1692 Fair Debt Collection Act)",
      "15:1693" : "15:1693 (15:1693 Electronic Fund Transfer Act)",
      "15:1938" : "15:1938 (15:1938 Fair Labor Standards Act)",
      "15:1981" : "15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))",
      "15:1988" : "15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))",
      "15:1989" : "15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))",
      "15:2301" : "15:2301 (15:2301 Magnuson-Moss Warranty Act)",
      "15:2801" : "15:2801 (15:2801 Petroleum Marketing Practices Act)",
      "15:53(b)" : "15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equita)",
      "16:0668" : "16:0668 (16:668 Bald Eagle Protection Act)",
      "16:0703" : "16:0703 (16:703 Migratory Bird Act)",
      "16:1538" : "16:1538 (16:1538 Endangered Species Act)",
      "16:3371" : "16:3371 (16:3371 Wildlife Under the Lacey Act)",
      "16:3372" : "16:3372 (16:3372 Conservation: Complaint for Forfeiture)",
      "16:3373" : "16:3373 (16:3373 Appeal of Decision - DOI)",
      "16:3374" : "16:3374 (16:3374 Conservation: Complaint for Forfeiture)",
      "17:0101" : "17:0101 (17:101 Copyright Infringement)",
      "17:0501" : "17:0501 (17:501 Copyright Infringement)",
      "17:0504" : "17:0504 (17:504 Copyright Infringement)",
      "18:0241" : "18:0241 (18:241 Conspiracy Against Citizen Rights)",
      "18:0923" : "18:0923 (18:0923 Application for Firearm license )",
      "18:1030" : "18:1030 (18:1030 Computer Fraud and Abuse Act)",
      "18:1345" : "18:1345 (Injunction Against Fraud )",
      "18:1519" : "18:1519 (18:1519 Destruction of Records)",
      "18:1836a" : "18:1836a (18:1836(a) Injunction against Misappropriation of Trade Secrets)",
      "18:1836b" : "18:1836b (18:1836(b) Civil Action to Protect Trade Secrets)",
      "18:1961" : "18:1961 (18:1961 Racketeering (RICO) Act)",
      "18:1962" : "18:1962 (18:1962 Racketeering (RICO) Act)",
      "18:1964" : "18:1964 (18:1964 Racketeering (RICO) Act)",
      "18:2510" : "18:2510 (18:2510 Omnibus Crime Control & Safe Streets Act (1968) )",
      "18:4208" : "18:4208 (18:4208(B) Agency Action Review)",
      "19:1305" : "19:1305 (19:1305 Custom Duties:0Forfeiture-Immoral Articles)",
      "20:1080" : "20:1080 (20:1080 Student Loan Recovery)",
      "20:1400" : "20:1400 (20:1400 Civil Rights of Handicapped Child)",
      "20:1401" : "20:1401 (20:1401 Education: Handicapped Child Act)",
      "20:1415" : "20:1415 (20:1415 Public Education for Handicapped )",
      "21:0841" : "21:0841 (21:841 Forfeiture Property-Drugs)",
      "21:0881" : "21:0881 (21:881 Forfeiture Property-Drugs)",
      "21:0881a" : "21:0881a (21:881 Forfeiture Property - Aircraft)",
      "21:0881re" : "21:0881re (21:881 Forfeiture Property - Real Estate)",
      "21:301" : "21:301 (21:301 Food and Drug Act )",
      "23:0134" : "23:0134 (23:134 P.I.- Auto Negligence)",
      "23:1441" : "23:1441 (23:1441 Contract Real Estate)",
      "24:1000" : "24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)",
      "25:0640" : "25:0640 (25:640 Indian Tribal Rights)",
      "25:1901" : "25:1901 (25:1901 Indian Child Welfare Act)",
      "26:6212" : "26:6212 (26:6212 Injunctive Relief from IRS Lien)",
      "26:6213" : "26:6213 (26:6213 Injunctive Relief from IRS Lien)",
      "26:6226" : "26:6226 (26:6226 Judicial Review of Partnership Adjustments )",
      "26:6502" : "26:6502 (26:6502 IRS:Enforcement of tax liens)",
      "26:6532" : "26:6532 (26:6532 IRS: Refund of Tax Penalty)",
      "26:6702" : "26:6702 (26:6702 IRS: Refund of Income Tax Penalty)",
      "26:6703" : "26:6703 (26:6703 IRS: Refund of Tax Penalty)",
      "26:7401" : "26:7401 (26:7401 IRS: Tax Liability)",
      "26:7402" : "26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)",
      "26:7403" : "26:7403 (26:7403 Suit to Enforce Federal Tax Lien)",
      "26:7422rt" : "26:7422rt (26:7422 IRS: Refund Taxes)",
      "26:7422rx" : "26:7422rx (26:7422 IRS: Refund Excise Tax)",
      "26:7426" : "26:7426 (26:7426 IRS: Wrongful Levy for Taxes)",
      "26:7429" : "26:7429 (26:7429 IRS: Tax Jeopardy Assessment)",
      "26:7609" : "26:7609 (26:7609 IRS: Petition to Quash IRS Summons)",
      "27:0185" : "27:0185 (27:185 Enforcement of Arbitration Award)",
      "28:0157c" : "28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)",
      "28:0157d" : "28:0157d (28:0157 Motion for Withdrawal of Reference)",
      "28:0158" : "28:0158 (28:0158 Notice of Appeal re Bankruptcy Matter (BA)",
      "28:0185" : "28:0185 (28:185 Suit to Compel Arbitration)",
      "28:0451" : "28:0451 (28:451 Employment Discrimination)",
      "28:0794" : "28:0794 (28:794 Rehabilitation Act)",
      "28:1001" : "28:1001 (28:1001 E.R.I.S.A.)",
      "28:1132" : "28:1132 (28:1132 E.R.I.S.A.)",
      "28:1330" : "28:1330 (28:1330 Breach of Contract)",
      "28:1331" : "28:1331 (28:1331 Fed. Question)",
      "28:1331al" : "28:1331al (28:1331 Fed. Question: Airline Crash)",
      "28:1331at" : "28:1331at (28:1331 Fed. Question: Anti-trust)",
      "28:1331au" : "28:1331au (28:1331 Fed. Question: Auto Negligence)",
      "28:1331b" : "28:1331b (28:1331 Federal Question: Bivens Act)",
      "28:1331bc" : "28:1331bc (28:1331 Fed. Question: Breach of Contract)",
      "28:1331ca" : "28:1331ca (28:1331 Fed Question: Fed Communications Act of 1)",
      "28:1331cm" : "28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)",
      "28:1331cv" : "28:1331cv (28:1331 Federal Question: Other Civil Rights)",
      "28:1331ed" : "28:1331ed (28:1331 Fed. Question: Employment Discrimination)",
      "28:1331es" : "28:1331es (28:1331 Enforcement of Administrative Subpoena)",
      "28:1331fl" : "28:1331fl (28:1331 Fed. Question: Fair Labor Standards)",
      "28:1331in" : "28:1331in (28:1331 Fed. Question: Insurance Contract)",
      "28:1331mm" : "28:1331mm (28:1331 Fed. Question: Medical Malpractice)",
      "28:1331pi" : "28:1331pi (28:1331 Fed. Question: Personal Injury)",
      "28:1331rd" : "28:1331rd (28:1331 Fed. Question: Review Agency Decision)",
      "28:1331rp" : "28:1331rp (28:1331(a) Fed. Question: Real Property)",
      "28:1331rr" : "28:1331rr (28:1331 Fed. Question: Railway Labor Act)",
      "28:1331sv" : "28:1331sv (28:1331 Fed. Question: Securities Violation)",
      "28:1331tr" : "28:1331tr (28:1331 Fed. Question: Trademark)",
      "28:1331tt" : "28:1331tt (28:1331 Fed. Question: Tort Action)",
      "28:1331v" : "28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendme)",
      "28:1331wl" : "28:1331wl (28:1331 Federal Question: EPA Waste Lien)",
      "28:1331wt" : "28:1331wt (28:1331 Fed. Question: Water Rights)",
      "28:1332ac" : "28:1332ac (28:1332 Diversity-Account Receivable)",
      "28:1332al" : "28:1332al (28:1332 Diversity-Airline Crash)",
      "28:1332as" : "28:1332as (28:1332 Diversity-Asbestos Litigation)",
      "28:1332au" : "28:1332au (28:1332 Diversity-Auto Negligence)",
      "28:1332bc" : "28:1332bc (28:1332 Diversity-Breach of Contract)",
      "28:1332co" : "28:1332co (28:1332 Diversity-Conversion)",
      "28:1332ct" : "28:1332ct (28:1332 Diversity-(Citizenship))",
      "28:1332det" : "28:1332det (28:1332 Diversity: Forcible Detainer)",
      "28:1332df" : "28:1332df (28:1332 Diversity-Contract Default)",
      "28:1332ds" : "28:1332ds (28:1332 Diversity-Contract Dispute)",
      "28:1332ed" : "28:1332ed (28:1332 Diversity-Employment Discrimination)",
      "28:1332fd" : "28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)",
      "28:1332fr" : "28:1332fr (28:1332 Diversity-Fraud)",
      "28:1332ia" : "28:1332ia (28:1332 Diversity-Interpleader Action)",
      "28:1332ij" : "28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)",
      "28:1332in" : "28:1332in (28:1332 Diversity-Insurance Contract)",
      "28:1332jd" : "28:1332jd (28:1332 Diversity-Declaratory Judgment)",
      "28:1332lb" : "28:1332lb (28:1332 Diversity-Libel,Assault,Slander)",
      "28:1332lm" : "28:1332lm (28:1332 Diversity - Legal Malpractice)",
      "28:1332ma" : "28:1332ma (28:1332 Diversity-Miller Act)",
      "28:1332mm" : "28:1332mm (28:1332 Diversity-Medical Malpractice)",
      "28:1332mv" : "28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)",
      "28:1332ni" : "28:1332ni (28:1332 Diversity-Negotiable Instrument)",
      "28:1332nm" : "28:1332nm (28:1332 Diversity-Non-Motor Vehicle)",
      "28:1332oc" : "28:1332oc (28:1332 Diversity-Other Contract)",
      "28:1332pd" : "28:1332pd (28:1332 Diversity-Property Damage)",
      "28:1332pi" : "28:1332pi (28:1332 Diversity-Personal Injury)",
      "28:1332pl" : "28:1332pl (28:1332 Diversity-Product Liability)",
      "28:1332pr" : "28:1332pr (28:1332 Diversity-Petition for Removal)",
      "28:1332qt" : "28:1332qt (28:1332 Diversity-Petition to Quiet Title)",
      "28:1332ri" : "28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)",
      "28:1332sa" : "28:1332sa (28:1332 - Diversity: Securities & Exchange Commiss)",
      "28:1332sf" : "28:1332sf (28:1332 - Diversity: Securities Fraud)",
      "28:1332ss" : "28:1332ss (28:1332 Diversity - Stockholders Suits)",
      "28:1332tl" : "28:1332tl (28:1332 Diversity-Torts to Land)",
      "28:1332tm" : "28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))",
      "28:1332tn" : "28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)",
      "28:1332wd" : "28:1332wd (28:1332 Diversity-Wrongful Death)",
      "28:1333" : "28:1333 (28:1333 Admiralty)",
      "28:1334" : "28:1334 (28:1334 Bankruptcy Appeal)",
      "28:1334c" : "28:1334c (28:1334(c) R&R re motions for abstention (non-cor)",
      "28:1335" : "28:1335 (28:1335 Interpleader Action)",
      "28:1337" : "28:1337 (28:1337 Sherman-Clayton Act)",
      "28:1338cp" : "28:1338cp (28:1338 Copyright Infringement)",
      "28:1338pt" : "28:1338pt (28:1338 Patent Infringement)",
      "28:1338tr" : "28:1338tr (28:1338 Trademark Infringement)",
      "28:1340" : "28:1340 (28:1340 IRS: Custom Duties)",
      "28:1340er" : "28:1340er (28:1340 Recovery of Erroneous Refund)",
      "28:1341" : "28:1341 (28:1341 Complaint for Forfeiture)",
      "28:1343" : "28:1343 (28:1343 Violation of Civil Rights)",
      "28:1345co" : "28:1345co (28:1345 Replevin & Conversion)",
      "28:1345db" : "28:1345db (28:1345 Debt to US - FHA/HUD Title I)",
      "28:1345df" : "28:1345df (28:1345 Default of Promissory Note)",
      "28:1345er" : "28:1345er (28:1345 Recovery of Erroneous Refund)",
      "28:1345fc" : "28:1345fc (28:1345 Foreclosure)",
      "28:1345ff" : "28:1345ff (28:1345 Complaint for Forfeiture)",
      "28:1345hl" : "28:1345hl (28:1345 VA Home Loan Guaranty Debt)",
      "28:1345mc" : "28:1345mc (28:1345 Medical Care Recovery)",
      "28:1345mi" : "28:1345mi (28:1345 Mining Claim Ejectment)",
      "28:1345pd" : "28:1345pd (28:1345 Property Damage)",
      "28:1345pe" : "28:1345pe (28:1345 Property Ejectment)",
      "28:1345rc" : "28:1345rc (28:1345 Recovery of Debt to US)",
      "28:1345st" : "28:1345st (28:1345 Default of Student Loan)",
      "28:1345tp" : "28:1345tp (28:1345 Trespass on Public Land)",
      "28:1345va" : "28:1345va (28:1345 Recovery of VA Overpayment)",
      "28:1346bc" : "28:1346bc (28:1346 Breach of Contract)",
      "28:1346rc" : "28:1346rc (28:1346 Recovery of IRS Tax)",
      "28:1346tc" : "28:1346tc (28:1346 Tort Claim)",
      "28:1346wd" : "28:1346wd (28:1346 Wrongful Death)",
      "28:1352" : "28:1352 (28:1352 Miller Act)",
      "28:1355" : "28:1355 (28:1355 Petition for Return of Property)",
      "28:1358" : "28:1358 (28:1358 Land Condemnation)",
      "28:1361" : "28:1361 (28:1361 Petition for Writ of Mandamus)",
      "28:1362ic" : "28:1362ic (28:1362 Indian Tribal Controversy)",
      "28:1362iw" : "28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)",
      "28:1364" : "28:1364 (28:1364 Auto Negligence)",
      "28:1391" : "28:1391 (28:1391 Personal Injury)",
      "28:1402" : "28:1402 (28:1402 Medical Malpractice)",
      "28:1407" : "28:1407 (28:1407 Airline Crash)",
      "28:1441ac" : "28:1441ac (28:1441 Petition for Removal- Account Receivable)",
      "28:1441al" : "28:1441al (28:1441 Petition for Removal- Airline Crash)",
      "28:1441as" : "28:1441as (28:1441 Petition for Removal- Asbestos Litigation)",
      "28:1441au" : "28:1441au (28:1441 Petition for Removal- Auto Negligence)",
      "28:1441bc" : "28:1441bc (28:1441 Petition for Removal- Breach of Contract)",
      "28:1441cv" : "28:1441cv (28:1441 Petition for Removal- Civil Rights Act)",
      "28:1441df" : "28:1441df (28:1441 Petition for Removal- Contract Default)",
      "28:1441dj" : "28:1441dj (28:1441 Petition for Removal- Declaratory Judgemen)",
      "28:1441ds" : "28:1441ds (28:1441 Petition for Removal- Contract Dispute)",
      "28:1441ed" : "28:1441ed (28:1441 Petition for Removal - Employment Discrim)",
      "28:1441fc" : "28:1441fc (28:1441 Petition for Removal - Fair Credit Reporti)",
      "28:1441fr" : "28:1441fr (28:1441 Petition for Removal- Fraud)",
      "28:1441ij" : "28:1441ij (28:1441 Petition for Removal- Injunctive/Declarato)",
      "28:1441in" : "28:1441in (28:1441 Petition for Removal- Insurance Contract)",
      "28:1441int" : "28:1441int (28:1441 Petition for Removal- Action for Interplea)",
      "28:1441lb" : "28:1441lb (28:1441 Petition for Removal Libel,Assault,Slander)",
      "28:1441lm" : "28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relatio)",
      "28:1441mm" : "28:1441mm (28:1441 Petition for Removal- Medical Malpractice)",
      "28:1441ni" : "28:1441ni (28:1441 Petition for Removal- Negotiable Instrumen)",
      "28:1441nm" : "28:1441nm (28:1441 Petition for Removal- Non-Motor Vehicle)",
      "28:1441oc" : "28:1441oc (28:1441 Petition For Removal--Other Contract)",
      "28:1441pd" : "28:1441pd (28:1441 Petition for Removal- Property Damage)",
      "28:1441pi" : "28:1441pi (28:1441 Petition for Removal- Personal Injury)",
      "28:1441pl" : "28:1441pl (28:1441 Petition for Removal- Product Liability)",
      "28:1441pr" : "28:1441pr (28:1441 Petition for Removal)",
      "28:1441qt" : "28:1441qt (28:1441 Petition for Removal- Petition to Quiet Ti)",
      "28:1441ri" : "28:1441ri (28:1441 Petition for Removal- Racketeering (RICO))",
      "28:1441sa" : "28:1441sa (28:1441 - Petition for Removal: SEC Act)",
      "28:1441sf" : "28:1441sf (28:1441 - Petition for Removal: Securities Fraud)",
      "28:1441tl" : "28:1441tl (28:1441 Petition for Removal- Torts to Land)",
      "28:1441tm" : "28:1441tm (28:1441 Petition for Removal- Tort/Motor Vehicle ()",
      "28:1441tn" : "28:1441tn (28:1441 Petition for Removal- Tort/Non-Motor Vehic)",
      "28:1441wd" : "28:1441wd (28:1441 Petition for Removal- Wrongful Death)",
      "28:1442bc" : "28:1442bc (28:1442 Petition for Removal- Breach of Contract)",
      "28:1442pr" : "28:1442pr (28:1442 Petition for Removal)",
      "28:1443" : "28:1443 (28:1443(1) Rent, Lease & Ejectment)",
      "28:1444" : "28:1444 (28:1444 Petition for Removal- Foreclosure)",
      "28:1446in" : "28:1446in (28:1446 Breach of Contract- Insurance)",
      "28:1446pd" : "28:1446pd (28:1446 Petition for Removal- Property Damage (P.I)",
      "28:1446pi" : "28:1446pi (28:1446 Petition for Removal- Personal Injury)",
      "28:1446pl" : "28:1446pl (28:1446pl Petition for Removal - Product Liability)",
      "28:1446pr" : "28:1446pr (28:1446 Petition for Removal)",
      "28:1452" : "28:1452 (28:1452 R&R re motions to remand (non-core))",
      "28:157e" : "28:157e (28:157 Recovery of Property of the Estate )",
      "28:1651" : "28:1651 (28:1651 Petition for Writ of Coram Nobis)",
      "28:1651hc" : "28:1651hc (28:1651 Petition for Writ of Habeas Corpus)",
      "28:1651mn" : "28:1651mn (28:1651 Petition for Writ of Mandamus)",
      "28:1782" : "28:1782 (Assistance to Foriegn and International Tribunals )",
      "28:1983" : "28:1983 (28:1983 Civil Rights)",
      "28:2201" : "28:2201 (28:2201 Constitutionality of State Statute(s))",
      "28:2201dj" : "28:2201dj (28:2201 Declaratory Judgment)",
      "28:2201ij" : "28:2201ij (28:2201 Injunction)",
      "28:2201in" : "28:2201in (28:2201 Declaratory Judgment (Insurance))",
      "28:2241" : "28:2241 (28:2241 Petition for Writ of Habeas Corpus (federa)",
      "28:2254" : "28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))",
      "28:2254se" : "28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)",
      "28:2255" : "28:2255 (28:2255 Motion to Vacate / Correct Illegal Sentence)",
      "28:2271" : "28:2271 (28:2271 Federal Tort Claims Act)",
      "28:2345" : "28:2345 (28:2345 Medicare Recovery)",
      "28:2409" : "28:2409 (28:2409(a) Quiet Title Action)",
      "28:2410" : "28:2410 (28:2410 Quiet Title)",
      "28:2671" : "28:2671 (28:2671 Federal Tort Claims Act)",
      "28:2674" : "28:2674 (28:2674 Federal Tort Claims Act)",
      "28:7402" : "28:7402 (28:7402 Refund of Taxes)",
      "28:7422" : "28:7422 (28:7422 Appeal from Administrative Decision)",
      "29:0151" : "29:0151 (29:151 Labor: Review of Agency Action)",
      "29:0160" : "29:0160 (29:160(1) National Labor Relations Act)",
      "29:0184" : "29:0184 (29:184 Violation Collection Bargain Agreement)",
      "29:0185ep" : "29:0185ep (29:185 Employee Pension Plan)",
      "29:0185lm" : "29:0185lm (29:185 Labor/Mgt. Relations (Contracts))",
      "29:0201do" : "29:0201do (29:201 Denial of Overtime Compensation)",
      "29:0201fl" : "29:0201fl (29:201 Fair Labor Standards Act)",
      "29:0203" : "29:0203 (29:203 Equal Pay Act)",
      "29:0206" : "29:0206 (29:206 Collect Unpaid Wages)",
      "29:0401" : "29:0401 (29:0401 Labor Management Disclosure Act)",
      "29:0504" : "29:0504 (29:504 Request for Administrative Hearing )",
      "29:0621" : "29:0621 (29:621 Job Discrimination (Age))",
      "29:0623" : "29:0623 (29:623 Job Discrimination (Age))",
      "29:0626" : "29:0626 (29:626 Job Discrimination (Age))",
      "29:0633" : "29:0633 (29:633 Job Discrimination (Age))",
      "29:0651" : "29:0651 (29:651 Occupational Safety/Health)",
      "29:0754" : "29:0754 (29:754 Discrimination)",
      "29:0791" : "29:0791 (29:791 Job Discrimination (Rehabilitation Act))",
      "29:0794" : "29:0794 (29:0794 Job Discrimination (Handicap))",
      "29:1001" : "29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)",
      "29:1002" : "29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)",
      "29:1104" : "29:1104 (29:1104 Recovery of Benefits to Employee)",
      "29:1109" : "29:1109 (29:1109 Breach of Fiduciary Duties)",
      "29:1131" : "29:1131 (29:1131 ERISA - Collection of Delinquent Trust Fun)",
      "29:1132" : "29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)",
      "29:1145" : "29:1145 (29:1145 E.R.I.S.A.)",
      "29:1149" : "29:1149 (29:1149 Recover Pension & Profit Sharing)",
      "29:1337" : "29:1337 (29:1337 E.R.I.S.A.)",
      "29:1362" : "29:1362 (29:1362 ERISA)",
      "29:1381" : "29:1381 (29:1381 E.R.I.S.A.)",
      "29:1401" : "29:1401 (29:1401(b)(2) Appeal of Arbitration Award)",
      "29:1451" : "29:1451 (29:1451 E.R.I.S.A.)",
      "29:1801" : "29:1801 (29:1801 Farmworker Rights)",
      "29:2101" : "29:2101 (29:2101 Worker Adjustment & Retraining Notification Act )",
      "29:2661" : "29:2661 (29:2661 Family Medical Leave Act)",
      "29:790" : "29:790 (29:790 Rehabilitation of Labor)",
      "30:0181" : "30:0181 (30:181 Environment: Review of Agency Action)",
      "30:0801" : "30:0801 (30:0801 Penalities/Federal Mine Safety Health Act)",
      "30:1201" : "30:1201 (30:1201 Environment: Review of Agency Action)",
      "30:1202" : "30:1202 (30:1202 Mining Reclamation Act)",
      "30:1276" : "30:1276 (30:1276 Interior: Review of Agency Action)",
      "31:3545" : "31:3545 (31:3545 Action to Recovery Money)",
      "31:3729" : "31:3729 (31:3729 False Claims Act)",
      "31:3730" : "31:3730 (31:3730 Qui Tam False Claims Act)",
      "31:3731" : "31:3731 (31:3731 Fraud)",
      "33:1319cw" : "33:1319cw (33:1319 Clean Water Act)",
      "33:1319pv" : "33:1319pv (33:1319 Pollutants & Permit Violations)",
      "33:1365" : "33:1365 (33:1365 Environmental Matters)",
      "35:0145" : "35:0145 (35:145 Patent Infringement)",
      "35:0183" : "35:0183 (35:183 Patent Infringement)",
      "35:0271" : "35:0271 (35:271 Patent Infringement)",
      "35:252" : "35:252 (Patent Non-Infringement )",
      "37:1006" : "37:1006 (37:1006 Overpayment of Advance Pay )",
      "38:1681" : "38:1681 (38:1681 Recovery of VA Overpayment)",
      "38:1686" : "38:1686 (38:1686 Recovery of VA Overpayment)",
      "38:1780" : "38:1780 (38:1780 Recovery of VA Overpayment)",
      "38:2011" : "38:2011 (38:2011 - Veteran's Readjustment Assistance Act of)",
      "38:3116" : "38:3116 (38:3116 VA Overpayment)",
      "38:5301" : "38:5301 (38:5301 Nonassignability and Exempt Status of VA Benefits)",
      "39:3005" : "39:3005 (39:3005 Detention of Mail for Temporary Periods)",
      "39:409" : "39:409 (39:409 Postal Service)",
      "40:0258" : "40:0258 (40:258(a) Public Buildings & Property: Land Condem)",
      "40:0270" : "40:0270 (40:270 Miller Act)",
      "40:0875" : "40:0875 (40:875 Public Buildings & Property: Negligence)",
      "41:0251" : "41:0251 (41:251 Public Contracts-Review of Agency Action)",
      "41:1463" : "41:1463 (41:1463 Public Contracts: Unlawful Employment Prac)",
      "42:0205" : "42:0205 (42:205 Denial Social Security Benefits)",
      "42:0206" : "42:0206 (42:206 Social Security Benefits)",
      "42:0247" : "42:0247 (42:247 Personal Injury-Swine Flu)",
      "42:0402" : "42:0402 (42:402 Social Security Benefits)",
      "42:0405" : "42:0405 (42:405 Review of HHS Decision)",
      "42:0405id" : "42:0405id (42:405 Review of HHS Decision (SSID))",
      "42:0405wc" : "42:0405wc (42:405 Review of HHS Decision (DIWC))",
      "42:0405ww" : "42:0405ww (42:405 Review of HHS Decision (DIWW))",
      "42:0416" : "42:0416 (42:416 Denial of Social Security Benefits)",
      "42:0427" : "42:0427 (42:427 Social Security Benefits)",
      "42:11101" : "42:11101 (42:11101 Health Care Quality Improvement Act )",
      "42:12131" : "42:12131 (42:12131 Americans with Disabilities )",
      "42:1383" : "42:1383 (42:1383 Review of HHS Decision)",
      "42:1395" : "42:1395 (42:1395 HHS: Adverse Reimbursement Review)",
      "42:1396" : "42:1396 (42:1396 - Tort Negligence)",
      "42:1471" : "42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclo)",
      "42:1981cv" : "42:1981cv (42:1981 Civil Rights)",
      "42:1981hs" : "42:1981hs (42:1981 Housing Discrimination)",
      "42:1981jb" : "42:1981jb (42:1981 Job Discrimination (Race))",
      "42:1981sx" : "42:1981sx (42:1981 Sex Discrimination)",
      "42:1983cv" : "42:1983cv (42:1983 Civil Rights Act)",
      "42:1983ed" : "42:1983ed (42:1983 Civil Rights (Employment Discrimination))",
      "42:1983pr" : "42:1983pr (42:1983 Prisoner Civil Rights)",
      "42:1985" : "42:1985 (42:1985 Conspiracy to Interfere with Civil Rights)",
      "42:1986" : "42:1986 (42:1986 Neglect of Duty)",
      "42:2000ag" : "42:2000ag (42:2000 Job Discrimination (Age))",
      "42:2000e" : "42:2000e (42:2000e Job Discrimination (Employment))",
      "42:2000pb" : "42:2000pb (42:2000 Job Discrimination (Public Accomodations))",
      "42:2000ra" : "42:2000ra (42:2000 Job Discrimination (Race))",
      "42:2000sx" : "42:2000sx (42:2000 Job Discrimination (Sex))",
      "42:2003" : "42:2003 (42:2003 Job Discrimination)",
      "42:2005" : "42:2005 (42:2005 Review of Agency Action-HHS)",
      "42:2651" : "42:2651 (42:2651 Medical Care Recovery)",
      "42:3601" : "42:3601 (42:405 Fair Housing Act)",
      "42:4000" : "42:4000 (42:4000 National Flood Insurance Act)",
      "42:4001" : "42:4001 (42:4001 National Insurance Flood Act)",
      "42:4053" : "42:4053 (42:4053 Breach of Insurance Contract)",
      "42:4072" : "42:4072 (42:4072 Payment of Flood Insurance Claim)",
      "42:425" : "42:425 (42:425 Social Security Benefits )",
      "42:4321" : "42:4321 (42:4321 Review of Agency Action-Environment)",
      "42:4332" : "42:4332 (42:4332 Environmental Policy - Coop of Agency Repo)",
      "42:6901en" : "42:6901en (42:6901 Environmental Cleanup Expenses)",
      "42:6901rs" : "42:6901rs (42:6901 Resource & Recovery Act)",
      "42:7413" : "42:7413 (42:7413(b) Clean Air Act)",
      "42:7604cl" : "42:7604cl (42:7604 Clear Air Act (Emission Standards))",
      "42:7604ir" : "42:7604ir (42:7604 Petition to Quash IRS Summons)",
      "42:9607" : "42:9607 (42:9607 Real Property Tort to Land)",
      "43:945" : "43:945 (43:945 Compensation for Land Condemnation)",
      "43:945a" : "43:945a (43:945a Complaint in Condemnation)",
      "43:946" : "43:946 (43:946 Complaint in Condemnation - Eminent Domain)",
      "45:0051" : "45:0051 (45:51 Railways: Fed. Employer's Liability Act)",
      "45:0151" : "45:0151 (45:151 Railway Labor Act)",
      "45:0184" : "45:0184 (45:184 Action to Set Aside Award of a System Board)",
      "45:1395" : "45:1395 (45:1395 Railroads: Adverse Reimbursement Review)",
      "45:7457" : "45:7457 (45:7457 Compel Reclamation Under Clear Air Act)",
      "46:0688" : "46:0688 (46:688 Jones Act)",
      "46:0741" : "46:0741 (46:741 Shipping)",
      "46:0761" : "46:0761 (46:761 Shipping: Damages for Death on High Seas)",
      "46:0781" : "46:0781 (46:0781 Public Vessels Act )",
      "46:0971" : "46:0971 (46:971 Federal Maritime Lien )",
      "46:1101" : "46:1101 (46:1101 Violation of Maritime Regulations)",
      "46:1156" : "46:1156 (46:1156 Administrative Procedure Act)",
      "47:0227" : "47:0227 (47:227 Violation of the Telephone Consumer Protection Act/Junk Fax Prevention Act)",
      "47:0553" : "47:0553 (47:553 Violation of Illegal Interception of Cable System)",
      "48:0883" : "48:0883 (48:883 Violation of US Coastal Law)",
      "48:1985" : "48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)",
      "49:0081" : "49:0081 (49:81 Damaged Goods While Being Transported)",
      "49:0781" : "49:0781 (49:781 Forfeiture)",
      "49:10761" : "49:10761 (49:10761 Collection of Unpaid Freight Bills )",
      "49:11503" : "49:11503 (49:11503 Railroad Revitalization Regulatory Reform)",
      "49:11702" : "49:11702 (49:11702(a)(4) Violations of Interstate Commerce A)",
      "49:1471" : "49:1471 (49:1471 Federal Aviation Act)",
      "49:1903" : "49:1903 (49:1903 Petition to enforce administrative summon)",
      "5:0557" : "5:0557 (5:0557 Administrative Procedure Act )",
      "8:287" : "8:287 (8:287 Petition to Enforce INS Subpoena)"
   },
   "ohndea" : {
      "0" : "0 (No cause code entered)",
      "00:0000" : "00:0000 (00:0000 Cause Code Unknown)",
      "02:0431" : "02:0431 (02:431 Fed. Election Commission: Failure Enforce Compliance)",
      "02:0437" : "02:0437 (02:437 Federal Election Commission)",
      "05:0075" : "05:0075 (05:75(2) Contract - Reduction in Grade)",
      "05:0551" : "05:0551 (05:551 Administrative Procedure Act)",
      "05:0552fi" : "05:0552fi (05:552 Freedom of Information Act)",
      "05:0552pa" : "05:0552pa (05:552 Right to Privacy Act)",
      "05:0554" : "05:0554 (05:0554 Constitutionality of Maritime Statutes)",
      "05:0701" : "05:0701 (05:0701 Maritime Subsidy Board)",
      "05:0702" : "05:0702 (05:702 Administrative Procedure Act)",
      "05:0704" : "05:0704 (05:704 Labor Litigation)",
      "05:7703" : "05:7703 (05:7703 Discrimination - Review of Agency Act)",
      "05:8101" : "05:8101 (05:8101 Federal Employees Compensation Act)",
      "07:0006" : "07:0006 (7:6(b) Federal Commodity Exchange Regulation)",
      "07:0025" : "07:0025 (7:25 Fraud - Commodities Leverage Contracts)",
      "07:0181" : "07:0181 (07:181 Packers & Stockyard Act)",
      "07:0499" : "07:0499 (07:499 Agricultural Commodities Act)",
      "07:0601" : "07:0601 (07:601 USDA Condemnation)",
      "07:2023" : "07:2023 (07:2023 Food Stamp Act)",
      "07:2321" : "07:2321 (07:2321 Plant Variety Protection Act)",
      "08:1105" : "08:1105 (8:1105(a) Aliens: Habeas Corpus to Release INS Detainee)",
      "08:1252" : "08:1252 (08:1252(a)(2) Injunction for Deportation)",
      "08:1260" : "08:1260 (08:1260 Aliens: Access to Records)",
      "08:1324" : "08:1324 (08:1324 Aliens: Complaint for Forfeiture)",
      "08:1329" : "08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petition)",
      "08:1446" : "08:1446 (8:1446 Petition for Naturalization Hearing)",
      "08:1451" : "08:1451 (08:1451(a) Revocation of Naturalization)",
      "09:0001" : "09:0001 (09:1 U.S. Arbitration Act)",
      "09:0009" : "09:0009 (9:9 Motion to Confirm Arbitration Award)",
      "09:0010" : "09:0010 (09:0010 Petition to Vacate Arbitration Award)",
      "10:1552" : "10:1552 (10:1552 Armed Forces: Action to Correct Records)",
      "10:1553" : "10:1553 (10:1553 Armed Forces: FOIA General)",
      "10:2305" : "10:2305 (10:2305 Review of Federal Contract)",
      "11:0101" : "11:0101 (11:101 Bankruptcy)",
      "12:0022" : "12:0022 (12:22 Securities Fraud)",
      "12:0635" : "12:0635 (12:635 Breach of Insurance Contract)",
      "12:1441" : "12:1441 (12:1441 Replevin; Action to recover property)",
      "12:1461" : "12:1461 (12:1461 Homeowners Loan Act)",
      "12:1703" : "12:1703 (12:1703 Default of HUD Loan)",
      "12:1725" : "12:1725 (12:1725 Collection under Contract Guaranty)",
      "12:1730" : "12:1730 (12:1730 Collection Under Contract Guaranty)",
      "12:1819" : "12:1819 (12:1819 Default of Promissory Note)",
      "12:1821" : "12:1821 (12:1821 Default of Loan by Promissary Note)",
      "12:1971" : "12:1971 (12:1971 Relief under Bank Holding Act)",
      "12:3410" : "12:3410 (12:3410 Right to Financial Privacy Act)",
      "15:0001" : "15:0001 (15:1 Antitrust Litigation)",
      "15:0002at" : "15:0002at (15:2 Antitrust Litigation)",
      "15:0002fl" : "15:0002fl (15:2(a) Fair Labor Standards Act)",
      "15:0005" : "15:0005 (15:5(a) Fair Labor Standards Act)",
      "15:0015" : "15:0015 (15:15 Antitrust Litigation)",
      "15:0025" : "15:0025 (15:25 Clayton Act)",
      "15:0044" : "15:0044 (15:44 Trademark Infringement)",
      "15:0045" : "15:0045 (15:0045 Federal Trade Commission Act)",
      "15:0052" : "15:0052 (15:0052 Federal Trade Commission Act)",
      "15:0053" : "15:0053 (15:0053 Federal Trade Commission Act)",
      "15:0077" : "15:0077 (15:77 Securities Fraud)",
      "15:0078" : "15:0078 (15:78m(a) Securities Exchange Act)",
      "15:0631" : "15:0631 (15:631 Small Business Act)",
      "15:0717" : "15:0717 (15:0717 Natural Gas Act)",
      "15:1051" : "15:1051 (15:1051 Trademark Infringement)",
      "15:1114" : "15:1114 (15:1114 Trademark Infringement)",
      "15:1121" : "15:1121 (15:1121 Trademark Infringement)",
      "15:1125" : "15:1125 (15:1125 Trademark Infringement (Lanham Act))",
      "15:1126" : "15:1126 (15:1126 Patent Infringement)",
      "15:1127" : "15:1127 (15:1127 Trademark Infringement)",
      "15:1221" : "15:1221 (15:1221 Auto Dealers Suits Against Manufacturers)",
      "15:1261" : "15:1261 (15:1261 Federal Hazardous Substances Act)",
      "15:1601" : "15:1601 (15:1601 Truth in Lending)",
      "15:1640" : "15:1640 (15:1640 Truth in Lending)",
      "15:1681" : "15:1681 (15:1681 Fair Credit Reporting Act)",
      "15:1692" : "15:1692 (15:1692 Fair Debt Collection Act)",
      "15:1938" : "15:1938 (15:1938 Fair Labor Standards Act)",
      "15:1981" : "15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))",
      "15:1988" : "15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))",
      "15:1989" : "15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))",
      "15:2301" : "15:2301 (15:2301 Magnuson-Moss Warranty Act)",
      "15:2801" : "15:2801 (15:2801 Petroleum Marketing Practices Act)",
      "15:53(b)" : "15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equitable Relief)",
      "16:0668" : "16:0668 (16:668 Bald Eagle Protection Act)",
      "16:0703" : "16:0703 (16:703 Migratory Bird Act)",
      "16:1538" : "16:1538 (16:1538 Endangered Species Act)",
      "16:3371" : "16:3371 (16:3371 Wildlife Under the Lacey Act)",
      "16:3372" : "16:3372 (16:3372 Conservation: Complaint for Forfeiture)",
      "16:3373" : "16:3373 (16:3373 Appeal of Decision - DOI)",
      "16:3374" : "16:3374 (16:3374 Conservation: Complaint for Forfeiture)",
      "17:0101" : "17:0101 (17:101 Copyright Infringement)",
      "17:0501" : "17:0501 (17:501 Copyright Infringement)",
      "17:0504" : "17:0504 (17:504 Copyright Infringement)",
      "18:0241" : "18:0241 (18:241 Conspiracy Against Citizen Rights)",
      "18:0923" : "18:0923 (18:0923 Application for Firearm license)",
      "18:1030" : "18:1030 (18:1030 Computer Fraud and Abuse Act)",
      "18:1345" : "18:1345 (Injunction Against Fraud)",
      "18:1519" : "18:1519 (18:1519 Destruction of Records)",
      "18:1961" : "18:1961 (18:1961 Racketeering (RICO) Act)",
      "18:1962" : "18:1962 (18:1962 Racketeering (RICO) Act)",
      "18:1964" : "18:1964 (18:1964 Racketeering (RICO) Act)",
      "18:2510" : "18:2510 (18:2510 Omnibus Crime Control & Safe Streets Act (1968))",
      "18:4208" : "18:4208 (18:4208(B) Agency Action Review)",
      "19:1305" : "19:1305 (19:1305 Custom Duties:0Forfeiture-Immoral Articles)",
      "20:1080" : "20:1080 (20:1080 Student Loan Recovery)",
      "20:1400" : "20:1400 (20:1400 Civil Rights of Handicapped Child)",
      "20:1401" : "20:1401 (20:1401 Education: Handicapped Child Act)",
      "20:1415" : "20:1415 (20:1415 Public Education for Handicapped)",
      "21:0841" : "21:0841 (21:841 Forfeiture Property-Drugs)",
      "21:0881" : "21:0881 (21:881 Forfeiture Property-Drugs)",
      "21:0881a" : "21:0881a (21:881 Forfeiture Property - Aircraft)",
      "21:0881re" : "21:0881re (21:881 Forfeiture Property - Real Estate)",
      "21:301" : "21:301 (21:301 Food and Drug Act)",
      "23:0134" : "23:0134 (23:134 P.I.- Auto Negligence)",
      "23:1441" : "23:1441 (23:1441 Contract Real Estate)",
      "24:1000" : "24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)",
      "25:0640" : "25:0640 (25:640 Indian Tribal Rights)",
      "25:1901" : "25:1901 (25:1901 Indian Child Welfare Act)",
      "26:6212" : "26:6212 (26:6212 Injunctive Relief from IRS Lien)",
      "26:6213" : "26:6213 (26:6213 Injunctive Relief from IRS Lien)",
      "26:6226" : "26:6226 (26:6226 Judicial Review of Partnership Adjustments)",
      "26:6502" : "26:6502 (26:6502 IRS: Enforcement of Tax Liens)",
      "26:6532" : "26:6532 (26:6532 IRS: Refund of Tax Penalty)",
      "26:6702" : "26:6702 (26:6702 IRS: Refund of Income Tax Penalty)",
      "26:6703" : "26:6703 (26:6703 IRS: Refund of Tax Penalty)",
      "26:7401" : "26:7401 (26:7401 IRS: Tax Liability)",
      "26:7402" : "26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)",
      "26:7403" : "26:7403 (26:7403 Suit to Enforce Federal Tax Lien)",
      "26:7422rt" : "26:7422rt (26:7422 IRS: Refund Taxes)",
      "26:7422rx" : "26:7422rx (26:7422 IRS: Refund Excise Tax)",
      "26:7426" : "26:7426 (26:7426 IRS: Wrongful Levy for Taxes)",
      "26:7429" : "26:7429 (26:7429 IRS: Tax Jeopardy Assessment)",
      "26:7609" : "26:7609 (26:7609 IRS: Petition to Quash IRS Summons)",
      "27:0185" : "27:0185 (27:185 Enforcement of Arbitration Award)",
      "28:0157c" : "28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)",
      "28:0157d" : "28:0157d (28:0157 Motion for Withdrawal of Reference)",
      "28:0158" : "28:0158 (28:0158 Notice of Appeal re Bankruptcy Matter (BAP))",
      "28:0185" : "28:0185 (28:185 Suit to Compel Arbitration)",
      "28:0451" : "28:0451 (28:451 Employment Discrimination)",
      "28:0794" : "28:0794 (28:794 Rehabilitation Act)",
      "28:1001" : "28:1001 (28:1001 E.R.I.S.A.)",
      "28:1132" : "28:1132 (28:1132 E.R.I.S.A.)",
      "28:1330" : "28:1330 (28:1330 Breach of Contract)",
      "28:1331" : "28:1331 (28:1331 Fed. Question)",
      "28:1331al" : "28:1331al (28:1331 Fed. Question: Airline Crash)",
      "28:1331at" : "28:1331at (28:1331 Fed. Question: Anti-trust)",
      "28:1331au" : "28:1331au (28:1331 Fed. Question: Auto Negligence)",
      "28:1331b" : "28:1331b (28:1331 Federal Question: Bivens Act)",
      "28:1331bc" : "28:1331bc (28:1331 Fed. Question: Breach of Contract)",
      "28:1331ca" : "28:1331ca (28:1331 Fed Question: Fed Communications Act of 1934)",
      "28:1331cm" : "28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)",
      "28:1331cv" : "28:1331cv (28:1331 Federal Question: Other Civil Rights)",
      "28:1331ed" : "28:1331ed (28:1331 Fed. Question: Employment Discrimination)",
      "28:1331es" : "28:1331es (28:1331 Enforcement of Administrative Subpoena)",
      "28:1331fl" : "28:1331fl (28:1331 Fed. Question: Fair Labor Standards)",
      "28:1331in" : "28:1331in (28:1331 Fed. Question: Insurance Contract)",
      "28:1331mm" : "28:1331mm (28:1331 Fed. Question: Medical Malpractice)",
      "28:1331pi" : "28:1331pi (28:1331 Fed. Question: Personal Injury)",
      "28:1331rd" : "28:1331rd (28:1331 Fed. Question: Review Agency Decision)",
      "28:1331rp" : "28:1331rp (28:1331(a) Fed. Question: Real Property)",
      "28:1331rr" : "28:1331rr (28:1331 Fed. Question: Railway Labor Act)",
      "28:1331sv" : "28:1331sv (28:1331 Fed. Question: Securities Violation)",
      "28:1331tr" : "28:1331tr (28:1331 Fed. Question: Trademark)",
      "28:1331tt" : "28:1331tt (28:1331 Fed. Question: Tort Action)",
      "28:1331v" : "28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendment)",
      "28:1331wl" : "28:1331wl (28:1331 Federal Question: EPA Waste Lien)",
      "28:1331wt" : "28:1331wt (28:1331 Fed. Question: Water Rights)",
      "28:1332ac" : "28:1332ac (28:1332 Diversity-Account Receivable)",
      "28:1332al" : "28:1332al (28:1332 Diversity-Airline Crash)",
      "28:1332as" : "28:1332as (28:1332 Diversity-Asbestos Litigation)",
      "28:1332au" : "28:1332au (28:1332 Diversity-Auto Negligence)",
      "28:1332bc" : "28:1332bc (28:1332 Diversity-Breach of Contract)",
      "28:1332co" : "28:1332co (28:1332 Diversity-Conversion)",
      "28:1332ct" : "28:1332ct (28:1332 Diversity-(Citizenship))",
      "28:1332det" : "28:1332det (28:1332 Diversity: Forcible Detainer)",
      "28:1332df" : "28:1332df (28:1332 Diversity-Contract Default)",
      "28:1332ds" : "28:1332ds (28:1332 Diversity-Contract Dispute)",
      "28:1332ed" : "28:1332ed (28:1332 Diversity-Employment Discrimination)",
      "28:1332fd" : "28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)",
      "28:1332fr" : "28:1332fr (28:1332 Diversity-Fraud)",
      "28:1332ia" : "28:1332ia (28:1332 Diversity-Interpleader Action)",
      "28:1332ij" : "28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)",
      "28:1332in" : "28:1332in (28:1332 Diversity-Insurance Contract)",
      "28:1332jd" : "28:1332jd (28:1332 Diversity-Declaratory Judgement)",
      "28:1332lb" : "28:1332lb (28:1332 Diversity-Libel,Assualt,Slander)",
      "28:1332lm" : "28:1332lm (28:1332 Diversity - Legal Malpractice)",
      "28:1332ma" : "28:1332ma (28:1332 Diversity-Miller Act)",
      "28:1332mm" : "28:1332mm (28:1332 Diversity-Medical Malpractice)",
      "28:1332mv" : "28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)",
      "28:1332ni" : "28:1332ni (28:1332 Diversity-Negotiable Instrument)",
      "28:1332nm" : "28:1332nm (28:1332 Diversity-Non-Motor Vehicle)",
      "28:1332oc" : "28:1332oc (28:1332 Diversity-Other Contract)",
      "28:1332pd" : "28:1332pd (28:1332 Diversity-Property Damage)",
      "28:1332pi" : "28:1332pi (28:1332 Diversity-Personal Injury)",
      "28:1332pl" : "28:1332pl (28:1332 Diversity-Product Liability)",
      "28:1332pr" : "28:1332pr (28:1332 Diversity-Petition for Removal)",
      "28:1332qt" : "28:1332qt (28:1332 Diversity-Petition to Quiet Title)",
      "28:1332ri" : "28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)",
      "28:1332sa" : "28:1332sa (28:1332 - Diversity: Securities & Exchange Commission Act)",
      "28:1332sf" : "28:1332sf (28:1332 - Diversity: Securities Fraud)",
      "28:1332ss" : "28:1332ss (28:1332 Diversity - Stockholders Suits)",
      "28:1332tl" : "28:1332tl (28:1332 Diversity-Torts to Land)",
      "28:1332tm" : "28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))",
      "28:1332tn" : "28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)",
      "28:1332wd" : "28:1332wd (28:1332 Diversity-Wrongful Death)",
      "28:1333" : "28:1333 (28:1333 Admiralty)",
      "28:1334" : "28:1334 (28:1334 Bankruptcy Appeal)",
      "28:1334c" : "28:1334c (28:1334(c) R&R re motions for abstention (non-core))",
      "28:1335" : "28:1335 (28:1335 Interpleader Action)",
      "28:1337" : "28:1337 (28:1337 Sherman-Clayton Act)",
      "28:1338cp" : "28:1338cp (28:1338 Copyright Infringement)",
      "28:1338pt" : "28:1338pt (28:1338 Patent Infringement)",
      "28:1338tr" : "28:1338tr (28:1338 Trademark Infringement)",
      "28:1340" : "28:1340 (28:1340 IRS: Custom Duties)",
      "28:1340er" : "28:1340er (28:1340 Recovery of Erroneous Refund)",
      "28:1341" : "28:1341 (28:1341 Complaint for Forfeiture)",
      "28:1343" : "28:1343 (28:1343 Violation of Civil Rights)",
      "28:1345co" : "28:1345co (28:1345 Replevin & Conversion)",
      "28:1345db" : "28:1345db (28:1345 Debt to US - FHA/HUD Title I)",
      "28:1345df" : "28:1345df (28:1345 Default of Promissory Note)",
      "28:1345er" : "28:1345er (28:1345 Recovery of Erroneous Refund)",
      "28:1345fc" : "28:1345fc (28:1345 Foreclosure)",
      "28:1345ff" : "28:1345ff (28:1345 Complaint for Forfeiture)",
      "28:1345hl" : "28:1345hl (28:1345 VA Home Loan Guaranty Debt)",
      "28:1345mc" : "28:1345mc (28:1345 Medical Care Recovery)",
      "28:1345mi" : "28:1345mi (28:1345 Mining Claim Ejectment)",
      "28:1345pd" : "28:1345pd (28:1345 Property Damage)",
      "28:1345pe" : "28:1345pe (28:1345 Property Ejectment)",
      "28:1345rc" : "28:1345rc (28:1345 Recovery of Debt to US)",
      "28:1345st" : "28:1345st (28:1345 Default of Student Loan)",
      "28:1345tp" : "28:1345tp (28:1345 Trespass on Public Land)",
      "28:1345va" : "28:1345va (28:1345 Recovery of VA Overpayment)",
      "28:1346bc" : "28:1346bc (28:1346 Breach of Contract)",
      "28:1346rc" : "28:1346rc (28:1346 Recovery of IRS Tax)",
      "28:1346tc" : "28:1346tc (28:1346 Tort Claim)",
      "28:1346wd" : "28:1346wd (28:1346 Wrongful Death)",
      "28:1352" : "28:1352 (28:1352 Miller Act)",
      "28:1355" : "28:1355 (28:1355 Petition for Return of Property)",
      "28:1358" : "28:1358 (28:1358 Land Condemnation)",
      "28:1361" : "28:1361 (28:1361 Petition for Writ of Mandamus)",
      "28:1362ic" : "28:1362ic (28:1362 Indian Tribal Controversy)",
      "28:1362iw" : "28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)",
      "28:1364" : "28:1364 (28:1364 Auto Negligence)",
      "28:1391" : "28:1391 (28:1391 Personal Injury)",
      "28:1402" : "28:1402 (28:1402 Medical Malpractice)",
      "28:1407" : "28:1407 (28:1407 Airline Crash)",
      "28:1441ac" : "28:1441ac (28:1441 Notice of Removal - Account Receivable)",
      "28:1441al" : "28:1441al (28:1441 Notice of Removal - Airline Crash)",
      "28:1441as" : "28:1441as (28:1441 Notice of Removal - Asbestos Litigation)",
      "28:1441au" : "28:1441au (28:1441 Notice of Removal - Auto Negligence)",
      "28:1441bc" : "28:1441bc (28:1441 Notice of Removal - Breach of Contract)",
      "28:1441cv" : "28:1441cv (28:1441 Notice of Removal - Civil Rights Act)",
      "28:1441df" : "28:1441df (28:1441 Notice of Removal - Contract Default)",
      "28:1441dj" : "28:1441dj (28:1441 Notice of Removal - Declaratory Judgement)",
      "28:1441ds" : "28:1441ds (28:1441 Notice of Removal - Contract Dispute)",
      "28:1441ed" : "28:1441ed (28:1441 Notice of Removal - Employment Discrimination)",
      "28:1441fc" : "28:1441fc (28:1441 Notice of Removal - Fair Credit Reporting Act)",
      "28:1441fr" : "28:1441fr (28:1441 Notice of Removal - Fraud)",
      "28:1441ij" : "28:1441ij (28:1441 Notice of Removal - Injunctuve/Declaratory Relief)",
      "28:1441in" : "28:1441in (28:1441 Notice of Removal - Insurance Contract)",
      "28:1441int" : "28:1441int (28:1441 Notice of Removal - Action for Interpleader)",
      "28:1441lb" : "28:1441lb (28:1441 Notice of Removal - Libel,Assault,Slander)",
      "28:1441lm" : "28:1441lm (28:1441 Notice of Removal - Labor/Mgmnt. Relations)",
      "28:1441mm" : "28:1441mm (28:1441 Notice of Removal - Medical Malpractice)",
      "28:1441ni" : "28:1441ni (28:1441 Notice of Removal - Negotiable Instrument)",
      "28:1441nm" : "28:1441nm (28:1441 Notice of Removal - Non-Motor Vehicle)",
      "28:1441oc" : "28:1441oc (28:1441 Notice of Removal - Other Contract)",
      "28:1441pd" : "28:1441pd (28:1441 Notice of Removal - Property Damage)",
      "28:1441pi" : "28:1441pi (28:1441 Notice of Removal - Personal Injury)",
      "28:1441pl" : "28:1441pl (28:1441 Notice of Removal - Product Liability)",
      "28:1441pr" : "28:1441pr (28:1441 Notice of Removal)",
      "28:1441qt" : "28:1441qt (28:1441 Notice of Removal - Petition to Quiet Title)",
      "28:1441ri" : "28:1441ri (28:1441 Notice of Removal - Racketeering (RICO) Act)",
      "28:1441sa" : "28:1441sa (28:1441 Notice of Removal - SEC Act)",
      "28:1441sf" : "28:1441sf (28:1441 Notice of Removal - Securities Fraud)",
      "28:1441tl" : "28:1441tl (28:1441 Notice of Removal - Torts to Land)",
      "28:1441tm" : "28:1441tm (28:1441 Notice of Removal - Tort/Motor Vehicle (P.I.))",
      "28:1441tn" : "28:1441tn (28:1441 Notice of Removal - Tort/Non-Motor Vehicle)",
      "28:1441wd" : "28:1441wd (28:1441 Notice of Removal - Wrongful Death)",
      "28:1442bc" : "28:1442bc (28:1442 Notice of Removal - Breach of Contract)",
      "28:1442pr" : "28:1442pr (28:1442 Notice of Removal)",
      "28:1443" : "28:1443 (28:1443(1) Rent, Lease & Ejectment)",
      "28:1444" : "28:1444 (28:1444 Petition for Removal - Foreclosure)",
      "28:1446in" : "28:1446in (28:1446 Breach of Contract- Insurance)",
      "28:1446pd" : "28:1446pd (28:1446 Notice of Removal - Property Damage (P.I.))",
      "28:1446pi" : "28:1446pi (28:1446 Notice of Removal - Personal Injury)",
      "28:1446pl" : "28:1446pl (28:1446 Notice of Removal - Product Liability)",
      "28:1446pr" : "28:1446pr (28:1446 Notice of Removal)",
      "28:1452" : "28:1452 (28:1452 R&R re motions to remand (non-core))",
      "28:157e" : "28:157e (28:157 Recovery of Property of the Estate)",
      "28:1651" : "28:1651 (28:1651 Petition for Writ of Coram Nobis)",
      "28:1651hc" : "28:1651hc (28:1651 Petition for Writ of Habeas Corpus)",
      "28:1651mn" : "28:1651mn (28:1651 Petition for Writ of Mandamus)",
      "28:1782" : "28:1782 (Assistance to Foriegn and International Tribunals)",
      "28:1983" : "28:1983 (28:1983 Civil Rights)",
      "28:2201" : "28:2201 (28:2201 Constitutionality of State Statute(s))",
      "28:2201dj" : "28:2201dj (28:2201 Declaratory Judgment)",
      "28:2201ij" : "28:2201ij (28:2201 Injunction)",
      "28:2201in" : "28:2201in (28:2201 Declaratory Judgment (Insurance))",
      "28:2241" : "28:2241 (28:2241 Petition for Writ of Habeas Corpus)",
      "28:2254" : "28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))",
      "28:2254se" : "28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)",
      "28:2255" : "28:2255 (28:2255 Motion to Vacate Sentence (Federal))",
      "28:2271" : "28:2271 (28:2271 Federal Tort Claims Act)",
      "28:2345" : "28:2345 (28:2345 Medicare Recovery)",
      "28:2409" : "28:2409 (28:2409(a) Quiet Title Action)",
      "28:2410" : "28:2410 (28:2410 Quiet Title)",
      "28:2671" : "28:2671 (28:2671 Federal Tort Claims Act)",
      "28:2674" : "28:2674 (28:2674 Federal Tort Claims Act)",
      "28:7402" : "28:7402 (28:7402 Refund of Taxes)",
      "28:7422" : "28:7422 (28:7422 Appeal from Administrative Decision)",
      "29:0151" : "29:0151 (29:151 Labor: Review of Agency Action)",
      "29:0160" : "29:0160 (29:160(1) National Labor Relations Act)",
      "29:0184" : "29:0184 (29:184 Violation collective bargaining agreement)",
      "29:0185ep" : "29:0185ep (29:185 Employee Pension Plan)",
      "29:0185lm" : "29:0185lm (29:185 Labor/Mgt. Relations (Contracts))",
      "29:0201do" : "29:0201do (29:201 Denial of Overtime Compensation)",
      "29:0201fl" : "29:0201fl (29:201 Fair Labor Standards Act)",
      "29:0203" : "29:0203 (29:203 Equal Pay Act)",
      "29:0206" : "29:0206 (29:206 Collect Unpaid Wages)",
      "29:0401" : "29:0401 (29:0401 Labor Management Disclosure Act)",
      "29:0504" : "29:0504 (29:504 Request for Administrative Hearing)",
      "29:0621" : "29:0621 (29:621 Job Discrimination (Age))",
      "29:0623" : "29:0623 (29:623 Job Discrimination (Age))",
      "29:0626" : "29:0626 (29:626 Job Discrimination (Age))",
      "29:0633" : "29:0633 (29:633 Job Discrimination (Age))",
      "29:0651" : "29:0651 (29:651 Occupational Safety/Health)",
      "29:0754" : "29:0754 (29:754 Discrimination)",
      "29:0791" : "29:0791 (29:791 Job Discrimination (Rehabilitation Act))",
      "29:0794" : "29:0794 (29:0794 Job Discrimination (Handicap))",
      "29:1001" : "29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)",
      "29:1002" : "29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)",
      "29:1104" : "29:1104 (29:1104 Recovery of Benefits to Employee)",
      "29:1109" : "29:1109 (29:1109 Breach of Fiduciary Duties)",
      "29:1131" : "29:1131 (29:1131 ERISA - Collection of Delinquent Trust Funds)",
      "29:1132" : "29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)",
      "29:1145" : "29:1145 (29:1145 E.R.I.S.A.)",
      "29:1149" : "29:1149 (29:1149 Recover Pension & Profit Sharing)",
      "29:1337" : "29:1337 (29:1337 E.R.I.S.A.)",
      "29:1362" : "29:1362 (29:1362 ERISA)",
      "29:1381" : "29:1381 (29:1381 E.R.I.S.A.)",
      "29:1401" : "29:1401 (29:1401(b)(2) Appeal of Arbitration Award)",
      "29:1451" : "29:1451 (29:1451 E.R.I.S.A.)",
      "29:1801" : "29:1801 (29:1801 Farmworker Rights)",
      "29:2101" : "29:2101 (29:2101 Worker Adjustment & Retraining Notification Act)",
      "29:2661" : "29:2661 (29:2661 Family Medical Leave Act)",
      "29:790" : "29:790 (29:790 Rehabilitation of Labor)",
      "30:0181" : "30:0181 (30:181 Environment: Review of Agency Action)",
      "30:0801" : "30:0801 (30:0801 Penalities/Federal Mine Safety Health Act - 1977)",
      "30:1201" : "30:1201 (30:1201 Environment: Review of Agency Action)",
      "30:1202" : "30:1202 (30:1202 Mining Reclamation Act)",
      "30:1276" : "30:1276 (30:1276 Interior: Review of Agency Action)",
      "31:3545" : "31:3545 (31:3545 Action to Recovery Money)",
      "31:3729" : "31:3729 (31:3729 False Claims Act)",
      "31:3730" : "31:3730 (31:3730 Qui Tam False Claims Act)",
      "31:3731" : "31:3731 (31:3731 Fraud)",
      "33:1319cw" : "33:1319cw (33:1319 Clean Water Act)",
      "33:1319pv" : "33:1319pv (33:1319 Pollutants & Permit Violations)",
      "33:1365" : "33:1365 (33:1365 Environmental Matters)",
      "35:0145" : "35:0145 (35:145 Patent Infringement)",
      "35:0183" : "35:0183 (35:183 Patent Infringement)",
      "35:0271" : "35:0271 (35:271 Patent Infringement)",
      "35:252" : "35:252 (Patent Non-Infringement)",
      "37:1006" : "37:1006 (37:1006 Overpayment of Advance Pay)",
      "38:1681" : "38:1681 (38:1681 Recovery of VA Overpayment)",
      "38:1686" : "38:1686 (38:1686 Recovery of VA Overpayment)",
      "38:1780" : "38:1780 (38:1780 Recovery of VA Overpayment)",
      "38:2011" : "38:2011 (38:2011 - Veteran's Readjustment Assistance Act of 1974)",
      "38:3116" : "38:3116 (38:3116 VA Overpayment)",
      "38:5301" : "38:5301 (38:5301 Nonassignability and Exempt Status of VA Benefits)",
      "39:3005" : "39:3005 (39:3005 Detention of Mail for Temporary Periods)",
      "39:409" : "39:409 (39:409 Postal Service)",
      "40:0258" : "40:0258 (40:258(a) Public Buildings & Property: Land Condemnation)",
      "40:0270" : "40:0270 (40:270 Miller Act)",
      "40:0875" : "40:0875 (40:875 Public Buildings & Property: Negligence)",
      "41:0251" : "41:0251 (41:251 Public Contracts-Review of Agency Action)",
      "41:1463" : "41:1463 (41:1463 Public Contracts: Unlawful Employment Practices)",
      "42:0205" : "42:0205 (42:205 Denial Social Security Benefits)",
      "42:0206" : "42:0206 (42:206 Social Security Benefits)",
      "42:0247" : "42:0247 (42:247 Personal Injury-Swine Flu)",
      "42:0402" : "42:0402 (42:402 Social Security Benefits)",
      "42:0405" : "42:0405 (42:405 Review of HHS Decision - (DIWC,DIWW))",
      "42:0405id" : "42:0405id (42:405 Review of HHS Decision (SSID))",
      "42:0405wc" : "42:0405wc (42:405 Review of HHS Decision (DIWC))",
      "42:0405ww" : "42:0405ww (42:405 Review of HHS Decision (DIWW))",
      "42:0416" : "42:0416 (42:416 Denial of Social Security Benefits)",
      "42:0427" : "42:0427 (42:427 Social Security Benefits)",
      "42:11101" : "42:11101 (42:11101 Health Care Quality Improvement Act)",
      "42:12131" : "42:12131 (42:12131 Americans with Disabilities)",
      "42:1383" : "42:1383 (42:1383 Review of HHS Decision)",
      "42:1395" : "42:1395 (42:1395 HHS: Adverse Reimbursement Review)",
      "42:1396" : "42:1396 (42:1396 - Tort Negligence)",
      "42:1471" : "42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclosure Sale)",
      "42:1981cv" : "42:1981cv (42:1981 Civil Rights)",
      "42:1981hs" : "42:1981hs (42:1981 Housing Discrimination)",
      "42:1981jb" : "42:1981jb (42:1981 Job Discrimination (Race))",
      "42:1981sx" : "42:1981sx (42:1981 Sex Discrimination)",
      "42:1983cv" : "42:1983cv (42:1983 Civil Rights Act)",
      "42:1983ed" : "42:1983ed (42:1983 Civil Rights (Employment Discrimination))",
      "42:1983pr" : "42:1983pr (42:1983 Prisoner Civil Rights)",
      "42:1986" : "42:1986 (42:1986 Neglect of Duty)",
      "42:2000ag" : "42:2000ag (42:2000 Job Discrimination (Age))",
      "42:2000e" : "42:2000e (42:2000e Job Discrimination (Employment))",
      "42:2000pb" : "42:2000pb (42:2000 Job Discrimination (Public Accomodations))",
      "42:2000ra" : "42:2000ra (42:2000 Job Discrimination (Race))",
      "42:2000sx" : "42:2000sx (42:2000 Job Discrimination (Sex))",
      "42:2003" : "42:2003 (42:2003 Job Discrimination)",
      "42:2005" : "42:2005 (42:2005 Review of Agency Action-HHS)",
      "42:2651" : "42:2651 (42:2651 Medical Care Recovery)",
      "42:3601" : "42:3601 (42:405 Fair Housing Act)",
      "42:4000" : "42:4000 (42:4000 National Flood Insurance Act)",
      "42:4001" : "42:4001 (42:4001 National Insurance Flood Act)",
      "42:4053" : "42:4053 (42:4053 Breach of Insurance Contract)",
      "42:4072" : "42:4072 (42:4072 Payment of Flood Insurance Claim)",
      "42:425" : "42:425 (42:425 Social Security Benefits)",
      "42:4321" : "42:4321 (42:4321 Review of Agency Action-Environment)",
      "42:4332" : "42:4332 (42:4332 Environmental Policy - Coop of Agency Reports)",
      "42:6901en" : "42:6901en (42:6901 Environmental Cleanup Expenses)",
      "42:6901rs" : "42:6901rs (42:6901 Resource & Recovery Act)",
      "42:7413" : "42:7413 (42:7413(b) Clean Air Act)",
      "42:7604cl" : "42:7604cl (42:7604 Clear Air Act (Emission Standards))",
      "42:7604ir" : "42:7604ir (42:7604 Petition to Quash IRS Summons)",
      "42:9607" : "42:9607 (42:9607 Real Property Tort to Land)",
      "43:945" : "43:945 (43:945 Compensation for Land Condemnation)",
      "43:945a" : "43:945a (43:945a Complaint in Condemnation)",
      "43:946" : "43:946 (43:946 Complaint in Condemnation - Eminent Domain)",
      "45:0051" : "45:0051 (45:51 Railways: Fed. Employer's Liability Act)",
      "45:0151" : "45:0151 (45:151 Railway Labor Act)",
      "45:0184" : "45:0184 (45:184 Action to Set Aside Award of a System Board of Adjust)",
      "45:1395" : "45:1395 (45:1395 Railroads: Adverse Reimbursement Review)",
      "45:7457" : "45:7457 (45:7457 Compel Reclamation Under Clear Air Act)",
      "46:0688" : "46:0688 (46:688 Jones Act)",
      "46:0741" : "46:0741 (46:741 Shipping)",
      "46:0761" : "46:0761 (46:761 Shipping: Damages for Death on High Seas)",
      "46:0781" : "46:0781 (46:0781 Public Vessels Act)",
      "46:0971" : "46:0971 (46:971 Federal Maritime Lien)",
      "46:1101" : "46:1101 (46:1101 Violation of Maritime Regulations)",
      "46:1156" : "46:1156 (46:1156 Administrative Procedure Act)",
      "47:0553" : "47:0553 (47:553 Violation of Illegal Interception of Cable System)",
      "48:0883" : "48:0883 (48:883 Violation of US Coastal Law)",
      "48:1985" : "48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)",
      "49:0081" : "49:0081 (49:81 Damaged Goods While Being Transported)",
      "49:0781" : "49:0781 (49:781 Forfeiture)",
      "49:10761" : "49:10761 (49:10761 Collection of Unpaid Freight Bills)",
      "49:11503" : "49:11503 (49:11503 Railroad Revitalization Regulatory Reform Act)",
      "49:11702" : "49:11702 (49:11702(a)(4) Violations of Interstate Commerce Act)",
      "49:1471" : "49:1471 (49:1471 Federal Aviation Act)",
      "49:1903" : "49:1903 (49:1903 Petition to enforce administrative summons)",
      "5:0557" : "5:0557 (5:0557 Administrative Procedure Act)",
      "8:287" : "8:287 (8:287 Petition to Enforce INS Subpoena)",
      "misc" : "misc (Civil Miscellaneous Case)"
   },
   "ohsdce" : {
      "0" : "0 (No cause code entered)",
      "00:0000" : "00:0000 (00:0000 Cause Code Unknown)",
      "02:0431" : "02:0431 (02:431 Fed. Election Commission: Failure Enforce C)",
      "02:0437" : "02:0437 (02:437 Federal Election Commission)",
      "05:0075" : "05:0075 (05:75(2) Contract - Reduction in Grade)",
      "05:0551" : "05:0551 (05:551 Administrative Procedure Act)",
      "05:0552fi" : "05:0552fi (05:552 Freedom of Information Act)",
      "05:0552pa" : "05:0552pa (05:552 Right to Privacy Act)",
      "05:0554" : "05:0554 (05:0554 Constitutionality of Maritime Statutes)",
      "05:0701" : "05:0701 (05:0701 Maritime Subsidy Board)",
      "05:0702" : "05:0702 (05:702 Administrative Procedure Act)",
      "05:0704" : "05:0704 (05:704 Labor Litigation)",
      "05:7703" : "05:7703 (05:7703 Discrimination - Review of Agency Act)",
      "07:0006" : "07:0006 (7:6(b) Federal Commodity Exchange Regulation)",
      "07:0025" : "07:0025 (7:25 Fraud - Commodities Leverage Contracts)",
      "07:0181" : "07:0181 (07:181 Packers & Stockyard Act)",
      "07:0499" : "07:0499 (07:499 Agricultural Commodities Act)",
      "07:0601" : "07:0601 (07:601 USDA Condemnation)",
      "07:2321" : "07:2321 (07:2321 Plant Variety Protection Act)",
      "08:1105" : "08:1105 (8:1105(a) Aliens: Habeas Corpus to Release INS Det)",
      "08:1252" : "08:1252 (08:1252(a)(2) Injunction for Deportation)",
      "08:1260" : "08:1260 (08:1260 Aliens: Access to Records)",
      "08:1324" : "08:1324 (08:1324 Aliens: Complaint for Forfeiture)",
      "08:1329" : "08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petiti)",
      "08:1446" : "08:1446 (8:1446 Petition for Naturalization Hearing)",
      "09:0001" : "09:0001 (09:1 U.S. Arbitration Act)",
      "09:0009" : "09:0009 (9:9 Motion to Confirm Arbitration Loan)",
      "09:0010" : "09:0010 (09:0010 Petition to Vacate Arbitration Award)",
      "10:1552" : "10:1552 (10:1552 Armed Forces: Action to Correct Records)",
      "10:1553" : "10:1553 (10:1553 Armed Forces: FOIA General)",
      "10:2305" : "10:2305 (10:2305 Review of Federal Contract)",
      "11:0101" : "11:0101 (11:101 Bankruptcy)",
      "12:0022" : "12:0022 (12:22 Securities Fraud)",
      "12:0635" : "12:0635 (12:635 Breach of Insurance Contract)",
      "12:1461" : "12:1461 (12:1461 Homeowners Loan Act)",
      "12:1703" : "12:1703 (12:1703 Default of HUD Loan)",
      "12:1725" : "12:1725 (12:1725 Collection under Contract Guaranty)",
      "12:1730" : "12:1730 (12:1730 Collection Under Contract Guaranty)",
      "12:1819" : "12:1819 (12:1819 Default of Promissory Note)",
      "12:1821" : "12:1821 (12:1821 Default of Loan by Promissary Note)",
      "12:1971" : "12:1971 (12:1971 Relief under Bank Holding Act)",
      "12:3410" : "12:3410 (12:3410 Right to Financial Privacy Act)",
      "15:0001" : "15:0001 (15:1 Antitrust Litigation)",
      "15:0002at" : "15:0002at (15:2 Antitrust Litigation)",
      "15:0002fl" : "15:0002fl (15:2(a) Fair Labor Standards Act)",
      "15:0005" : "15:0005 (15:5(a) Fair Labor Standards Act)",
      "15:0015" : "15:0015 (15:15 Antitrust Litigation)",
      "15:0025" : "15:0025 (15:25 Clayton Act)",
      "15:0044" : "15:0044 (15:44 Trademark Infringement)",
      "15:0045" : "15:0045 (15:0045 Federal Trade Commission Act)",
      "15:0052" : "15:0052 (15:0052 Federal Trade Commission Act)",
      "15:0053" : "15:0053 (15:0053 Federal Trade Commission Act)",
      "15:0077" : "15:0077 (15:77 Securities Fraud)",
      "15:0078" : "15:0078 (15:78m(a) Securities Exchange Act)",
      "15:0631" : "15:0631 (15:631 Small Business Act)",
      "15:0717" : "15:0717 (15:717 Natural Gas Act)",
      "15:1051" : "15:1051 (15:1051 Trademark Infringement)",
      "15:1114" : "15:1114 (15:1114 Trademark Infringement)",
      "15:1121" : "15:1121 (15:1121 Trademark Infringement)",
      "15:1125" : "15:1125 (15:1125 Trademark Infringement (Lanham Act))",
      "15:1126" : "15:1126 (15:1126 Patent Infringement)",
      "15:1127" : "15:1127 (15:1127 Trademark Infringement)",
      "15:1601" : "15:1601 (15:1601 Truth in Lending)",
      "15:1640" : "15:1640 (15:1640 Truth in Lending)",
      "15:1681" : "15:1681 (15:1681 Fair Credit Reporting Act)",
      "15:1692" : "15:1692 (15:1692 Fair Debt Collection Act)",
      "15:1938" : "15:1938 (15:1938 Fair Labor Standards Act)",
      "15:1981" : "15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))",
      "15:1988" : "15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))",
      "15:1989" : "15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))",
      "15:2301" : "15:2301 (15:2301 Magnuson-Moss Warranty Act)",
      "15:2801" : "15:2801 (15:2801 Petroleum Marketing Practices Act)",
      "15:53(b)" : "15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equita)",
      "16:0668" : "16:0668 (16:668 Bald Eagle Protection Act)",
      "16:0703" : "16:0703 (16:703 Migratory Bird Act)",
      "16:1538" : "16:1538 (16:1538 Endangered Species Act)",
      "16:3371" : "16:3371 (16:3371 Wildlife Under the Lacey Act)",
      "16:3372" : "16:3372 (16:3372 Conservation: Complaint for Forfeiture)",
      "16:3373" : "16:3373 (16:3373 Appeal of Decision - DOI)",
      "16:3374" : "16:3374 (16:3374 Conservation: Complaint for Forfeiture)",
      "17:0101" : "17:0101 (17:101 Copyright Infringement)",
      "17:0501" : "17:0501 (17:501 Copyright Infringement)",
      "17:0504" : "17:0504 (17:504 Copyright Infringement)",
      "18:0241" : "18:0241 (18:241 Conspiracy Against Citizen Rights)",
      "18:1836a" : "18:1836a (18:1836(a) Injunction against Misappropriation of Trade Secrets)",
      "18:1836b" : "18:1836b (18:1836(b) Civil Action to Protect Trade Secrets)",
      "18:1961" : "18:1961 (18:1961 Racketeering (RICO) Act)",
      "18:1962" : "18:1962 (18:1962 Racketeering (RICO) Act)",
      "18:1964" : "18:1964 (18:1964 Racketeering (RICO) Act)",
      "18:4208" : "18:4208 (18:4208(B) Agency Action Review)",
      "19:1305" : "19:1305 (19:1305 Custom Duties:0Forfeiture-Immoral Articles)",
      "20:1080" : "20:1080 (20:1080 Student Loan Recovery)",
      "20:1400" : "20:1400 (20:1400 Civil Rights of Handicapped Child)",
      "20:1401" : "20:1401 (20:1401 Education: Handicapped Child Act)",
      "21:0841" : "21:0841 (21:841 Forfeiture Property-Drugs)",
      "21:0881" : "21:0881 (21:881 Forfeiture Property-Drugs)",
      "21:0881a" : "21:0881a (21:881 Forfeiture Property - Aircraft)",
      "21:0881re" : "21:0881re (21:881 Forfeiture Property - Real Estate)",
      "23:0134" : "23:0134 (23:134 P.I.- Auto Negligence)",
      "23:1441" : "23:1441 (23:1441 Contract Real Estate)",
      "24:1000" : "24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)",
      "25:0640" : "25:0640 (25:640 Indian Tribal Rights)",
      "25:1901" : "25:1901 (25:1901 Indian Child Welfare Act)",
      "26:6212" : "26:6212 (26:6212 Injunctive Relief from IRS Lien)",
      "26:6213" : "26:6213 (26:6213 Injunctive Relief from IRS Lien)",
      "26:6502" : "26:6502 (26:6502 IRS:Enforcement of tax liens)",
      "26:6532" : "26:6532 (26:6532 IRS: Refund of Tax Penalty)",
      "26:6702" : "26:6702 (26:6702 IRS: Refund of Income Tax Penalty)",
      "26:6703" : "26:6703 (26:6703 IRS: Refund of Tax Penalty)",
      "26:7401" : "26:7401 (26:7401 IRS: Tax Liability)",
      "26:7402" : "26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)",
      "26:7403" : "26:7403 (26:7403 Suit to Enforce Federal Tax Lien)",
      "26:7422rt" : "26:7422rt (26:7422 IRS: Refund Taxes)",
      "26:7422rx" : "26:7422rx (26:7422 IRS: Refund Excise Tax)",
      "26:7426" : "26:7426 (26:7426 IRS: Wrongful Levy for Taxes)",
      "26:7429" : "26:7429 (26:7429 IRS: Tax Jeopardy Assessment)",
      "26:7609" : "26:7609 (26:7609 IRS: Petition to Quash IRS Summons)",
      "27:0185" : "27:0185 (27:185 Enforcement of Arbitration Award)",
      "28:0157c" : "28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)",
      "28:0157d" : "28:0157d (28:0157 Motion for Withdrawal of Reference)",
      "28:0158" : "28:0158 (28:0158 Notice of Appeal re Bankruptcy Matter (BA)",
      "28:0185" : "28:0185 (28:185 Suit to Compel Arbitration)",
      "28:0451" : "28:0451 (28:451 Employment Discrimination)",
      "28:0794" : "28:0794 (28:794 Rehabilitation Act)",
      "28:1001" : "28:1001 (28:1001 E.R.I.S.A.)",
      "28:1132" : "28:1132 (28:1132 E.R.I.S.A.)",
      "28:1330" : "28:1330 (28:1330 Breach of Contract)",
      "28:1331" : "28:1331 (28:1331 Fed. Question)",
      "28:1331al" : "28:1331al (28:1331 Fed. Question: Airline Crash)",
      "28:1331at" : "28:1331at (28:1331 Fed. Question: Anti-trust)",
      "28:1331au" : "28:1331au (28:1331 Fed. Question: Auto Negligence)",
      "28:1331b" : "28:1331b (28:1331 Federal Question: Bivens Act)",
      "28:1331bc" : "28:1331bc (28:1331 Fed. Question: Breach of Contract)",
      "28:1331ca" : "28:1331ca (28:1331 Fed Question: Fed Communications Act of 1)",
      "28:1331cm" : "28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)",
      "28:1331cv" : "28:1331cv (28:1331 Federal Question: Other Civil Rights)",
      "28:1331ed" : "28:1331ed (28:1331 Fed. Question: Employment Discrimination)",
      "28:1331es" : "28:1331es (28:1331 Enforcement of Administrative Subpoena)",
      "28:1331fl" : "28:1331fl (28:1331 Fed. Question: Fair Labor Standards)",
      "28:1331in" : "28:1331in (28:1331 Fed. Question: Insurance Contract)",
      "28:1331mm" : "28:1331mm (28:1331 Fed. Question: Medical Malpractice)",
      "28:1331pi" : "28:1331pi (28:1331 Fed. Question: Personal Injury)",
      "28:1331rd" : "28:1331rd (28:1331 Fed. Question: Review Agency Decision)",
      "28:1331rp" : "28:1331rp (28:1331(a) Fed. Question: Real Property)",
      "28:1331rr" : "28:1331rr (28:1331 Fed. Question: Railway Labor Act)",
      "28:1331sv" : "28:1331sv (28:1331 Fed. Question: Securities Violation)",
      "28:1331tr" : "28:1331tr (28:1331 Fed. Question: Trademark)",
      "28:1331tt" : "28:1331tt (28:1331 Fed. Question: Tort Action)",
      "28:1331v" : "28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendme)",
      "28:1331wl" : "28:1331wl (28:1331 Federal Question: EPA Waste Lien)",
      "28:1331wt" : "28:1331wt (28:1331 Fed. Question: Water Rights)",
      "28:1332ac" : "28:1332ac (28:1332 Diversity-Account Receivable)",
      "28:1332al" : "28:1332al (28:1332 Diversity-Airline Crash)",
      "28:1332as" : "28:1332as (28:1332 Diversity-Asbestos Litigation)",
      "28:1332au" : "28:1332au (28:1332 Diversity-Auto Negligence)",
      "28:1332bc" : "28:1332bc (28:1332 Diversity-Breach of Contract)",
      "28:1332co" : "28:1332co (28:1332 Diversity-Conversion)",
      "28:1332ct" : "28:1332ct (28:1332 Diversity-(Citizenship))",
      "28:1332det" : "28:1332det (28:1332 Diversity: Forcible Detainer)",
      "28:1332df" : "28:1332df (28:1332 Diversity-Contract Default)",
      "28:1332ds" : "28:1332ds (28:1332 Diversity-Contract Dispute)",
      "28:1332ed" : "28:1332ed (28:1332 Diversity-Employment Discrimination)",
      "28:1332fd" : "28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)",
      "28:1332fr" : "28:1332fr (28:1332 Diversity-Fraud)",
      "28:1332ia" : "28:1332ia (28:1332 Diversity-Interpleader Action)",
      "28:1332ij" : "28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)",
      "28:1332in" : "28:1332in (28:1332 Diversity-Insurance Contract)",
      "28:1332jd" : "28:1332jd (28:1332 Diversity-Declaratory Judgment)",
      "28:1332lb" : "28:1332lb (28:1332 Diversity-Libel,Assault,Slander)",
      "28:1332lm" : "28:1332lm (28:1332 Diversity - Legal Malpractice)",
      "28:1332ma" : "28:1332ma (28:1332 Diversity-Miller Act)",
      "28:1332mm" : "28:1332mm (28:1332 Diversity-Medical Malpractice)",
      "28:1332mv" : "28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)",
      "28:1332ni" : "28:1332ni (28:1332 Diversity-Negotiable Instrument)",
      "28:1332nm" : "28:1332nm (28:1332 Diversity-Non-Motor Vehicle)",
      "28:1332oc" : "28:1332oc (28:1332 Diversity-Other Contract)",
      "28:1332pd" : "28:1332pd (28:1332 Diversity-Property Damage)",
      "28:1332pi" : "28:1332pi (28:1332 Diversity-Personal Injury)",
      "28:1332pl" : "28:1332pl (28:1332 Diversity-Product Liability)",
      "28:1332pr" : "28:1332pr (28:1332 Diversity-Petition for Removal)",
      "28:1332qt" : "28:1332qt (28:1332 Diversity-Petition to Quiet Title)",
      "28:1332ri" : "28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)",
      "28:1332sa" : "28:1332sa (28:1332 - Diversity: Securities & Exchange Commiss)",
      "28:1332sf" : "28:1332sf (28:1332 - Diversity: Securities Fraud)",
      "28:1332ss" : "28:1332ss (28:1332 Diversity - Stockholders Suits)",
      "28:1332tl" : "28:1332tl (28:1332 Diversity-Torts to Land)",
      "28:1332tm" : "28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))",
      "28:1332tn" : "28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)",
      "28:1332wd" : "28:1332wd (28:1332 Diversity-Wrongful Death)",
      "28:1333" : "28:1333 (28:1333 Admiralty)",
      "28:1334" : "28:1334 (28:1334 Bankruptcy Appeal)",
      "28:1334c" : "28:1334c (28:1334(c) R&R re motions for abstention (non-cor)",
      "28:1335" : "28:1335 (28:1335 Interpleader Action)",
      "28:1337" : "28:1337 (28:1337 Sherman-Clayton Act)",
      "28:1338cp" : "28:1338cp (28:1338 Copyright Infringement)",
      "28:1338pt" : "28:1338pt (28:1338 Patent Infringement)",
      "28:1338tr" : "28:1338tr (28:1338 Trademark Infringement)",
      "28:1340" : "28:1340 (28:1340 IRS: Custom Duties)",
      "28:1340er" : "28:1340er (28:1340 Recovery of Erroneous Refund)",
      "28:1341" : "28:1341 (28:1341 Complaint for Forfeiture)",
      "28:1343" : "28:1343 (28:1343 Violation of Civil Rights)",
      "28:1345co" : "28:1345co (28:1345 Replevin & Conversion)",
      "28:1345db" : "28:1345db (28:1345 Debt to US - FHA/HUD Title I)",
      "28:1345df" : "28:1345df (28:1345 Default of Promissory Note)",
      "28:1345er" : "28:1345er (28:1345 Recovery of Erroneous Refund)",
      "28:1345fc" : "28:1345fc (28:1345 Foreclosure)",
      "28:1345ff" : "28:1345ff (28:1345 Complaint for Forfeiture)",
      "28:1345hl" : "28:1345hl (28:1345 VA Home Loan Guaranty Debt)",
      "28:1345mc" : "28:1345mc (28:1345 Medical Care Recovery)",
      "28:1345mi" : "28:1345mi (28:1345 Mining Claim Ejectment)",
      "28:1345pd" : "28:1345pd (28:1345 Property Damage)",
      "28:1345pe" : "28:1345pe (28:1345 Property Ejectment)",
      "28:1345rc" : "28:1345rc (28:1345 Recovery of Debt to US)",
      "28:1345st" : "28:1345st (28:1345 Default of Student Loan)",
      "28:1345tp" : "28:1345tp (28:1345 Trespass on Public Land)",
      "28:1345va" : "28:1345va (28:1345 Recovery of VA Overpayment)",
      "28:1346bc" : "28:1346bc (28:1346 Breach of Contract)",
      "28:1346rc" : "28:1346rc (28:1346 Recovery of IRS Tax)",
      "28:1346tc" : "28:1346tc (28:1346 Tort Claim)",
      "28:1346wd" : "28:1346wd (28:1346 Wrongful Death)",
      "28:1352" : "28:1352 (28:1352 Miller Act)",
      "28:1355" : "28:1355 (28:1355 Petition for Return of Property)",
      "28:1358" : "28:1358 (28:1358 Land Condemnation)",
      "28:1361" : "28:1361 (28:1361 Petition for Writ of Mandamus)",
      "28:1362ic" : "28:1362ic (28:1362 Indian Tribal Controversy)",
      "28:1362iw" : "28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)",
      "28:1364" : "28:1364 (28:1364 Auto Negligence)",
      "28:1391" : "28:1391 (28:1391 Personal Injury)",
      "28:1402" : "28:1402 (28:1402 Medical Malpractice)",
      "28:1407" : "28:1407 (28:1407 Airline Crash)",
      "28:1441ac" : "28:1441ac (28:1441 Petition for Removal- Account Receivable)",
      "28:1441al" : "28:1441al (28:1441 Petition for Removal- Airline Crash)",
      "28:1441as" : "28:1441as (28:1441 Petition for Removal- Asbestos Litigation)",
      "28:1441au" : "28:1441au (28:1441 Petition for Removal- Auto Negligence)",
      "28:1441bc" : "28:1441bc (28:1441 Petition for Removal- Breach of Contract)",
      "28:1441cv" : "28:1441cv (28:1441 Petition for Removal- Civil Rights Act)",
      "28:1441df" : "28:1441df (28:1441 Petition for Removal- Contract Default)",
      "28:1441dj" : "28:1441dj (28:1441 Petition for Removal- Declaratory Judgment)",
      "28:1441ds" : "28:1441ds (28:1441 Petition for Removal- Contract Dispute)",
      "28:1441ed" : "28:1441ed (28:1441 Petition for Removal - Employment Discrim)",
      "28:1441fc" : "28:1441fc (28:1441 Petition for Removal - Fair Credit Reporti)",
      "28:1441fr" : "28:1441fr (28:1441 Petition for Removal- Fraud)",
      "28:1441ij" : "28:1441ij (28:1441 Petition for Removal- Injunctive/Declarato)",
      "28:1441in" : "28:1441in (28:1441 Petition for Removal- Insurance Contract)",
      "28:1441int" : "28:1441int (28:1441 Petition for Removal- Action for Interplea)",
      "28:1441lb" : "28:1441lb (28:1441 Petition for Removal Libel,Assault,Slander)",
      "28:1441lm" : "28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relatio)",
      "28:1441mm" : "28:1441mm (28:1441 Petition for Removal- Medical Malpractice)",
      "28:1441ni" : "28:1441ni (28:1441 Petition for Removal- Negotiable Instrumen)",
      "28:1441nm" : "28:1441nm (28:1441 Petition for Removal- Non-Motor Vehicle)",
      "28:1441oc" : "28:1441oc (28:1441 Petition For Removal--Other Contract)",
      "28:1441pd" : "28:1441pd (28:1441 Petition for Removal- Property Damage)",
      "28:1441pi" : "28:1441pi (28:1441 Petition for Removal- Personal Injury)",
      "28:1441pl" : "28:1441pl (28:1441 Petition for Removal- Product Liability)",
      "28:1441pr" : "28:1441pr (28:1441 Petition for Removal)",
      "28:1441qt" : "28:1441qt (28:1441 Petition for Removal- Petition to Quiet Ti)",
      "28:1441ri" : "28:1441ri (28:1441 Petition for Removal- Racketeering (RICO))",
      "28:1441sa" : "28:1441sa (28:1441 - Petition for Removal: SEC Act)",
      "28:1441sf" : "28:1441sf (28:1441 - Petition for Removal: Securities Fraud)",
      "28:1441tl" : "28:1441tl (28:1441 Petition for Removal- Torts to Land)",
      "28:1441tm" : "28:1441tm (28:1441 Petition for Removal- Tort/Motor Vehicle ()",
      "28:1441tn" : "28:1441tn (28:1441 Petition for Removal- Tort/Non-Motor Vehic)",
      "28:1441wd" : "28:1441wd (28:1441 Petition for Removal- Wrongful Death)",
      "28:1442bc" : "28:1442bc (28:1442 Petition for Removal- Breach of Contract)",
      "28:1442pr" : "28:1442pr (28:1442 Petition for Removal)",
      "28:1443" : "28:1443 (28:1443(1) Rent, Lease & Ejectment)",
      "28:1444" : "28:1444 (28:1444 Petition for Removal- Foreclosure)",
      "28:1446in" : "28:1446in (28:1446 Breach of Contract- Insurance)",
      "28:1446pd" : "28:1446pd (28:1446 Petition for Removal- Property Damage (P.I)",
      "28:1446pi" : "28:1446pi (28:1446 Petition for Removal- Personal Injury)",
      "28:1446pl" : "28:1446pl (28:1446pl Petition for Removal - Product Liability)",
      "28:1446pr" : "28:1446pr (28:1446 Petition for Removal)",
      "28:1452" : "28:1452 (28:1452 R&R re motions to remand (non-core))",
      "28:1651" : "28:1651 (28:1651 Petition for Writ of Coram Nobis)",
      "28:1651hc" : "28:1651hc (28:1651 Petition for Writ of Habeas Corpus)",
      "28:1651mn" : "28:1651mn (28:1651 Petition for Writ of Mandamus)",
      "28:1983" : "28:1983 (28:1983 Civil Rights)",
      "28:2201" : "28:2201 (28:2201 Constitutionality of State Statute(s))",
      "28:2201dj" : "28:2201dj (28:2201 Declaratory Judgment)",
      "28:2201ij" : "28:2201ij (28:2201 Injunction)",
      "28:2201in" : "28:2201in (28:2201 Declaratory Judgment (Insurance))",
      "28:2241" : "28:2241 (28:2241 Petition for Writ of Habeas Corpus (federa)",
      "28:2254" : "28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))",
      "28:2254se" : "28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)",
      "28:2255" : "28:2255 (28:2255 Motion to Vacate / Correct Illegal Sentenc)",
      "28:2271" : "28:2271 (28:2271 Federal Tort Claims Act)",
      "28:2345" : "28:2345 (28:2345 Medicare Recovery)",
      "28:2409" : "28:2409 (28:2409(a) Quiet Title Action)",
      "28:2410" : "28:2410 (28:2410 Quiet Title)",
      "28:2671" : "28:2671 (28:2671 Federal Tort Claims Act)",
      "28:2674" : "28:2674 (28:2674 Federal Tort Claims Act)",
      "28:7402" : "28:7402 (28:7402 Refund of Taxes)",
      "28:7422" : "28:7422 (28:7422 Appeal from Administrative Decision)",
      "29:0151" : "29:0151 (29:151 Labor: Review of Agency Action)",
      "29:0160" : "29:0160 (29:160(1) National Labor Relations Act)",
      "29:0184" : "29:0184 (29:184 Violation Collection Bargain Agreement)",
      "29:0185ep" : "29:0185ep (29:185 Employee Pension Plan)",
      "29:0185lm" : "29:0185lm (29:185 Labor/Mgt. Relations (Contracts))",
      "29:0201do" : "29:0201do (29:201 Denial of Overtime Compensation)",
      "29:0201fl" : "29:0201fl (29:201 Fair Labor Standards Act)",
      "29:0203" : "29:0203 (29:203 Equal Pay Act)",
      "29:0206" : "29:0206 (29:206 Collect Unpaid Wages)",
      "29:0401" : "29:0401 (29:0401 Labor Management Disclosure Act)",
      "29:0621" : "29:0621 (29:621 Job Discrimination (Age))",
      "29:0623" : "29:0623 (29:623 Job Discrimination (Age))",
      "29:0626" : "29:0626 (29:626 Job Discrimination (Age))",
      "29:0633" : "29:0633 (29:633 Job Discrimination (Age))",
      "29:0651" : "29:0651 (29:651 Occupational Safety/Health)",
      "29:0754" : "29:0754 (29:754 Discrimination)",
      "29:0791" : "29:0791 (29:791 Job Discrimination (Rehabilitation Act))",
      "29:0794" : "29:0794 (29:0794 Job Discrimination (Handicap))",
      "29:1001" : "29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)",
      "29:1002" : "29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)",
      "29:1104" : "29:1104 (29:1104 Recovery of Benefits to Employee)",
      "29:1109" : "29:1109 (29:1109 Breach of Fiduciary Duties)",
      "29:1131" : "29:1131 (29:1131 ERISA - Collection of Delinquent Trust Fun)",
      "29:1132" : "29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)",
      "29:1145" : "29:1145 (29:1145 E.R.I.S.A.)",
      "29:1149" : "29:1149 (29:1149 Recover Pension & Profit Sharing)",
      "29:1337" : "29:1337 (29:1337 E.R.I.S.A.)",
      "29:1362" : "29:1362 (29:1362 ERISA)",
      "29:1381" : "29:1381 (29:1381 E.R.I.S.A.)",
      "29:1401" : "29:1401 (29:1401(b)(2) Appeal of Arbitration Award)",
      "29:1451" : "29:1451 (29:1451 E.R.I.S.A.)",
      "29:1801" : "29:1801 (29:1801 Farmworker Rights)",
      "29:2617" : "29:2617 (29:2617 Family and Medical Leave Act)",
      "29:790" : "29:790 (29:790 Rehabilitation of Labor)",
      "30:0181" : "30:0181 (30:181 Environment: Review of Agency Action)",
      "30:0801" : "30:0801 (30:0801 Penalities/Federal Mine Safety Health Act)",
      "30:1201" : "30:1201 (30:1201 Environment: Review of Agency Action)",
      "30:1202" : "30:1202 (30:1202 Mining Reclamation Act)",
      "30:1276" : "30:1276 (30:1276 Interior: Review of Agency Action)",
      "31:3545" : "31:3545 (31:3545 Action to Recovery Money)",
      "31:3729" : "31:3729 (31:3729 False Claims Act)",
      "31:3730" : "31:3730 (31:3730 Qui Tam False Claims Act)",
      "31:3731" : "31:3731 (31:3731 Fraud)",
      "33:1319cw" : "33:1319cw (33:1319 Clean Water Act)",
      "33:1319pv" : "33:1319pv (33:1319 Pollutants & Permit Violations)",
      "33:1365" : "33:1365 (33:1365 Environmental Matters)",
      "35:0145" : "35:0145 (35:145 Patent Infringement)",
      "35:0183" : "35:0183 (35:183 Patent Infringement)",
      "35:0271" : "35:0271 (35:271 Patent Infringement)",
      "38:1681" : "38:1681 (38:1681 Recovery of VA Overpayment)",
      "38:1686" : "38:1686 (38:1686 Recovery of VA Overpayment)",
      "38:1780" : "38:1780 (38:1780 Recovery of VA Overpayment)",
      "38:2011" : "38:2011 (38:2011 - Veteran's Readjustment Assistance Act of)",
      "38:3116" : "38:3116 (38:3116 VA Overpayment)",
      "39:3005" : "39:3005 (39:3005 Detention of Mail for Temporary Periods)",
      "39:409" : "39:409 (39:409 Postal Service)",
      "40:0258" : "40:0258 (40:258(a) Public Buildings & Property: Land Condem)",
      "40:0270" : "40:0270 (40:270 Miller Act)",
      "40:0875" : "40:0875 (40:875 Public Buildings & Property: Negligence)",
      "41:0251" : "41:0251 (41:251 Public Contracts-Review of Agency Action)",
      "41:1463" : "41:1463 (41:1463 Public Contracts: Unlawful Employment Prac)",
      "42:0205" : "42:0205 (42:205 Denial Social Security Benefits)",
      "42:0206" : "42:0206 (42:206 Social Security Benefits)",
      "42:0247" : "42:0247 (42:247 Personal Injury-Swine Flu)",
      "42:0402" : "42:0402 (42:402 Social Security Benefits)",
      "42:0405id" : "42:0405id (42:405 Review of HHS Decision (SSID))",
      "42:0405wc" : "42:0405wc (42:405 Review of HHS Decision (DIWC))",
      "42:0405ww" : "42:0405ww (42:405 Review of HHS Decision (DIWW))",
      "42:0416" : "42:0416 (42:416 Denial of Social Security Benefits)",
      "42:0427" : "42:0427 (42:427 Social Security Benefits)",
      "42:12101" : "42:12101 (42:12101 Americans with Disabilities Act)",
      "42:1383" : "42:1383 (42:1383 Review of HHS Decision)",
      "42:1395" : "42:1395 (42:1395 HHS: Adverse Reimbursement Review)",
      "42:1396" : "42:1396 (42:1396 - Tort Negligence)",
      "42:1471" : "42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclo)",
      "42:1981cv" : "42:1981cv (42:1981 Civil Rights)",
      "42:1981hs" : "42:1981hs (42:1981 Housing Discrimination)",
      "42:1981jb" : "42:1981jb (42:1981 Job Discrimination (Race))",
      "42:1981sx" : "42:1981sx (42:1981 Sex Discrimination)",
      "42:1983cv" : "42:1983cv (42:1983 Civil Rights Act)",
      "42:1983ed" : "42:1983ed (42:1983 Civil Rights (Employment Discrimination))",
      "42:1983pr" : "42:1983pr (42:1983 Prisoner Civil Rights)",
      "42:1985" : "42:1985 (42:1985 Conspiracy to Interfere with Civil Rights)",
      "42:1986" : "42:1986 (42:1986 Neglect of Duty)",
      "42:2000ag" : "42:2000ag (42:2000 Job Discrimination (Age))",
      "42:2000e" : "42:2000e (42:2000e Job Discrimination (Employment))",
      "42:2000pb" : "42:2000pb (42:2000 Job Discrimination (Public Accomodations))",
      "42:2000ra" : "42:2000ra (42:2000 Job Discrimination (Race))",
      "42:2000sx" : "42:2000sx (42:2000 Job Discrimination (Sex))",
      "42:2003" : "42:2003 (42:2003 Job Discrimination)",
      "42:2005" : "42:2005 (42:2005 Review of Agency Action-HHS)",
      "42:2651" : "42:2651 (42:2651 Medical Care Recovery)",
      "42:3601" : "42:3601 (42:405 Fair Housing Act)",
      "42:4000" : "42:4000 (42:4000 National Flood Insurance Act)",
      "42:4001" : "42:4001 (42:4001 National Insurance Flood Act)",
      "42:4053" : "42:4053 (42:4053 Breach of Insurance Contract)",
      "42:4072" : "42:4072 (42:4072 Payment of Flood Insurance Claim)",
      "42:425" : "42:425 (42:425 Social Security Benefits)",
      "42:4321" : "42:4321 (42:4321 Review of Agency Action-Environment)",
      "42:4332" : "42:4332 (42:4332 Environmental Policy - Coop of Agency Repo)",
      "42:6901en" : "42:6901en (42:6901 Environmental Cleanup Expenses)",
      "42:6901rs" : "42:6901rs (42:6901 Resource & Recovery Act)",
      "42:7413" : "42:7413 (42:7413(b) Clean Air Act)",
      "42:7604cl" : "42:7604cl (42:7604 Clear Air Act (Emission Standards))",
      "42:7604ir" : "42:7604ir (42:7604 Petition to Quash IRS Summons)",
      "42:9607" : "42:9607 (42:9607 Real Property Tort to Land)",
      "43:945" : "43:945 (43:945 Compensation for Land Condemnation)",
      "43:945a" : "43:945a (43:945a Complaint in Condemnation)",
      "43:946" : "43:946 (43:946 Complaint in Condemnation - Eminent Domain)",
      "45:0051" : "45:0051 (45:51 Railways: Fed. Employer's Liability Act)",
      "45:0151" : "45:0151 (45:151 Railway Labor Act)",
      "45:0184" : "45:0184 (45:184 Action to Set Aside Award of a System Board)",
      "45:1395" : "45:1395 (45:1395 Railroads: Adverse Reimbursement Review)",
      "45:7457" : "45:7457 (45:7457 Compel Reclamation Under Clear Air Act)",
      "46:0688" : "46:0688 (46:688 Jones Act)",
      "46:0741" : "46:0741 (46:741 Shipping)",
      "46:0761" : "46:0761 (46:761 Shipping: Damages for Death on High Seas)",
      "46:1101" : "46:1101 (46:1101 Violation of Maritime Regulations)",
      "46:1156" : "46:1156 (46:1156 Administrative Procedure Act)",
      "47:0553" : "47:0553 (47:553 Unauthorized Reception of Cable Service)",
      "48:0883" : "48:0883 (48:883 Violation of US Coastal Law)",
      "48:1985" : "48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)",
      "49:0081" : "49:0081 (49:81 Damaged Goods While Being Transported)",
      "49:0781" : "49:0781 (49:781 Forfeiture)",
      "49:11503" : "49:11503 (49:11503 Railroad Revitalization Regulatory Reform)",
      "49:11702" : "49:11702 (49:11702(a)(4) Violations of Interstate Commerce A)",
      "49:1471" : "49:1471 (49:1471 Federal Aviation Act)",
      "49:1903" : "49:1903 (49:1903 Petition to enforce administrative summon)",
      "8:287" : "8:287 (8:287 Petition to Enforce INS Subpoena)",
      "misc" : "misc (Civil Miscellaneous Case)"
   },
   "okedce" : {
      "0" : "0 (No cause code entered)",
      "02:0138" : "02:0138 (02:0138 Library of Congress Access)",
      "02:0358" : "02:0358 (02:0358 President's Recommendations on Exec., Jud. & Leg. Salary)",
      "02:0431" : "02:0431 (02:431 Fed. Election Commission: Failure Enforce Compliance)",
      "02:0437" : "02:0437 (02:437 Federal Election Commission)",
      "02:0681" : "02:0681 (02:0681 Deferral of Budget Authority)",
      "02:1202" : "02:1202 (02:1202 Discriminatory practices affecting US Senate employees)",
      "02:1301" : "02:1301 (02:1301 Congressional Accountability Act)",
      "02:1317a" : "02:1317a (02:1317(a) Violation of Congressional Accountability Act)",
      "05:0075" : "05:0075 (05:75(2) Contract - Reduction in Grade)",
      "05:0551" : "05:0551 (05:551 Administrative Procedure Act)",
      "05:0552fi" : "05:0552fi (05:552 Freedom of Information Act)",
      "05:0552pa" : "05:0552pa (05:552 Right to Privacy Act)",
      "05:0554" : "05:0554 (05:0554 Constitutionality of Maritime Statutes)",
      "05:0701" : "05:0701 (05:0701 Maritime Subsidy Board)",
      "05:0702" : "05:0702 (05:702 Administrative Procedure Act)",
      "05:0704" : "05:0704 (05:704 Labor Litigation)",
      "05:7703" : "05:7703 (05:7703 Discrimination - Review of Agency Act)",
      "07:0006" : "07:0006 (7:6(b) Federal Commodity Exchange Regulation)",
      "07:0025" : "07:0025 (7:25 Fraud - Commodities Leverage Contracts)",
      "07:0181" : "07:0181 (07:181 Packers & Stockyard Act)",
      "07:0499" : "07:0499 (07:499 Agricultural Commodities Act)",
      "07:0601" : "07:0601 (07:601 USDA Condemnation)",
      "07:1926" : "07:1926 (07:1926 Water and Waste Facility Loans and Grants)",
      "07:2023" : "07:2023 (07:2023 Administrative and Judicial Review; Restoration of Rights)",
      "07:2321" : "07:2321 (07:2321 Plant Variety Protection Act)",
      "08:0287" : "08:0287 (08:0287 Petition to Enforce INS Subpoena)",
      "08:1105" : "08:1105 (8:1105(a) Aliens: Habeas Corpus to Release INS Detainee)",
      "08:1252" : "08:1252 (08:1252(a)(2) Injunction for Deportation)",
      "08:1260" : "08:1260 (08:1260 Aliens: Access to Records)",
      "08:1324" : "08:1324 (08:1324 Aliens: Complaint for Forfeiture)",
      "08:1329" : "08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petition)",
      "08:1446" : "08:1446 (8:1446 Petition for Naturalization Hearing)",
      "09:0001" : "09:0001 (09:1 U.S. Arbitration Act)",
      "09:0009" : "09:0009 (9:9 Motion to Confirm Arbitration Loan)",
      "09:0010" : "09:0010 (09:0010 Petition to Vacate Arbitration Award)",
      "10:1552" : "10:1552 (10:1552 Armed Forces: Action to Correct Records)",
      "10:1553" : "10:1553 (10:1553 Armed Forces: FOIA General)",
      "10:2305" : "10:2305 (10:2305 Review of Federal Contract)",
      "11:0101" : "11:0101 (11:101 Bankruptcy)",
      "12:0022" : "12:0022 (12:22 Securities Fraud)",
      "12:0635" : "12:0635 (12:635 Breach of Insurance Contract)",
      "12:1461" : "12:1461 (12:1461 Homeowners Loan Act)",
      "12:1703" : "12:1703 (12:1703 Default of HUD Loan)",
      "12:1725" : "12:1725 (12:1725 Collection under Contract Guaranty)",
      "12:1730" : "12:1730 (12:1730 Collection Under Contract Guaranty)",
      "12:1819" : "12:1819 (12:1819 Default of Promissory Note)",
      "12:1821" : "12:1821 (12:1821 Default of Loan by Promissary Note)",
      "12:1971" : "12:1971 (12:1971 Relief under Bank Holding Act)",
      "12:3410" : "12:3410 (12:3410 Right to Financial Privacy Act)",
      "15:0001" : "15:0001 (15:1 Antitrust Litigation)",
      "15:0002at" : "15:0002at (15:2 Antitrust Litigation)",
      "15:0002fl" : "15:0002fl (15:2(a) Fair Labor Standards Act)",
      "15:0005" : "15:0005 (15:5(a) Fair Labor Standards Act)",
      "15:0015" : "15:0015 (15:15 Antitrust Litigation)",
      "15:0025" : "15:0025 (15:25 Clayton Act)",
      "15:0044" : "15:0044 (15:44 Trademark Infringement)",
      "15:0045" : "15:0045 (15:0045 Federal Trade Commission Act)",
      "15:0049" : "15:0049 (15:0049 Documentary Evidence; Depositions; Witnesses)",
      "15:0052" : "15:0052 (15:0052 Federal Trade Commission Act)",
      "15:0053" : "15:0053 (15:0053 Federal Trade Commission Act)",
      "15:0077" : "15:0077 (15:77 Securities Fraud)",
      "15:0078" : "15:0078 (15:78m(a) Securities Exchange Act)",
      "15:0631" : "15:0631 (15:631 Small Business Act)",
      "15:0717" : "15:0717 (15:717 Natural Gas Act)",
      "15:1051" : "15:1051 (15:1051 Trademark Infringement)",
      "15:1114" : "15:1114 (15:1114 Trademark Infringement)",
      "15:1121" : "15:1121 (15:1121 Trademark Infringement)",
      "15:1125" : "15:1125 (15:1125 Trademark Infringement (Lanham Act))",
      "15:1126" : "15:1126 (15:1126 Patent Infringement)",
      "15:1127" : "15:1127 (15:1127 Trademark Infringement)",
      "15:1601" : "15:1601 (15:1601 Truth in Lending)",
      "15:1640" : "15:1640 (15:1640 Truth in Lending)",
      "15:1681" : "15:1681 (15:1681 Fair Credit Reporting Act)",
      "15:1692" : "15:1692 (15:1692 Fair Debt Collection Act)",
      "15:1938" : "15:1938 (15:1938 Fair Labor Standards Act)",
      "15:1981" : "15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))",
      "15:1988" : "15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))",
      "15:1989" : "15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))",
      "15:2301" : "15:2301 (15:2301 Magnuson-Moss Warranty Act)",
      "15:2801" : "15:2801 (15:2801 Petroleum Marketing Practices Act)",
      "15:53(b)" : "15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equitable Relief)",
      "16:0019jj" : "16:0019jj (16:0019jj Park System Resources Protection Act)",
      "16:0668" : "16:0668 (16:668 Bald Eagle Protection Act)",
      "16:0703" : "16:0703 (16:703 Migratory Bird Act)",
      "16:1538" : "16:1538 (16:1538 Endangered Species Act)",
      "16:3371" : "16:3371 (16:3371 Wildlife Under the Lacey Act)",
      "16:3372" : "16:3372 (16:3372 Conservation: Complaint for Forfeiture)",
      "16:3373" : "16:3373 (16:3373 Appeal of Decision - DOI)",
      "16:3374" : "16:3374 (16:3374 Conservation: Complaint for Forfeiture)",
      "17:0101" : "17:0101 (17:101 Copyright Infringement)",
      "17:0501" : "17:0501 (17:501 Copyright Infringement)",
      "17:0504" : "17:0504 (17:504 Copyright Infringement)",
      "18:0241" : "18:0241 (18:241 Conspiracy Against Citizen Rights)",
      "18:0981" : "18:0981 (18:0981 Civil Forfeiture)",
      "18:1034" : "18:1034 (18:1034 Civil penalties and injunctions for violations of section 1033)",
      "18:1595" : "18:1595 (18:1595 Civil remedy)",
      "18:1836a" : "18:1836a (18:1836(a) Injunction against Misappropriation of Trade Secrets)",
      "18:1836b" : "18:1836b (18:1836(b) Civil Action to Protect Trade Secrets)",
      "18:1961" : "18:1961 (18:1961 Racketeering (RICO) Act)",
      "18:1962" : "18:1962 (18:1962 Racketeering (RICO) Act)",
      "18:1964" : "18:1964 (18:1964 Racketeering (RICO) Act)",
      "18:4208" : "18:4208 (18:4208(B) Agency Action Review)",
      "18:923f" : "18:923f (18:923 (f)(3) - judicial review of denial or revocation of firearms license)",
      "19:1305" : "19:1305 (19:1305 Custom Duties:0Forfeiture-Immoral Articles)",
      "20:1080" : "20:1080 (20:1080 Student Loan Recovery)",
      "20:1400" : "20:1400 (20:1400 Civil Rights of Handicapped Child)",
      "20:1401" : "20:1401 (20:1401 Education: Handicapped Child Act)",
      "21:0352" : "21:0352 (21:352 Misbranded Drugs and Devices)",
      "21:0801" : "21:0801 (21:801 Comprehensive Drug Abuse Prevention Control Act of 1970)",
      "21:0841" : "21:0841 (21:841 Forfeiture Property-Drugs)",
      "21:0881" : "21:0881 (21:881 Forfeiture Property-Drugs)",
      "21:0881a" : "21:0881a (21:881 Forfeiture Property - Aircraft)",
      "21:0881re" : "21:0881re (21:881 Forfeiture Property - Real Estate)",
      "22:9000" : "22:9000 (22:9000 International Child Abduction Remedies)",
      "23:0134" : "23:0134 (23:134 P.I.- Auto Negligence)",
      "23:1441" : "23:1441 (23:1441 Contract Real Estate)",
      "24:1000" : "24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)",
      "25:0002" : "25:0002 (25:2 Duties of Commissioner)",
      "25:0357" : "25:0357 (25:0357 Condemnation of lands under laws of States)",
      "25:0450f" : "25:0450f (25:0450 Self-Determination Contracts)",
      "25:0640" : "25:0640 (25:640 Indian Tribal Rights)",
      "25:1303" : "25:1303 (25:1303 Habeas Corpus - Indian Civil Rights Act (detention))",
      "25:1901" : "25:1901 (25:1901 Indian Child Welfare Act)",
      "25:4044" : "25:4044 (25:4044 Reconciliation Report)",
      "25:4101" : "25:4101 (25:4101 Native American Housing)",
      "26:6212" : "26:6212 (26:6212 Injunctive Relief from IRS Lien)",
      "26:6213" : "26:6213 (26:6213 Injunctive Relief from IRS Lien)",
      "26:6502" : "26:6502 (26:6502 IRS:Enforcement of tax liens)",
      "26:6532" : "26:6532 (26:6532 IRS: Refund of Tax Penalty)",
      "26:6702" : "26:6702 (26:6702 IRS: Refund of Income Tax Penalty)",
      "26:6703" : "26:6703 (26:6703 IRS: Refund of Tax Penalty)",
      "26:7401" : "26:7401 (26:7401 IRS: Tax Liability)",
      "26:7402" : "26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)",
      "26:7403" : "26:7403 (26:7403 Suit to Enforce Federal Tax Lien)",
      "26:7422rt" : "26:7422rt (26:7422 IRS: Refund Taxes)",
      "26:7422rx" : "26:7422rx (26:7422 IRS: Refund Excise Tax)",
      "26:7426" : "26:7426 (26:7426 IRS: Wrongful Levy for Taxes)",
      "26:7429" : "26:7429 (26:7429 IRS: Tax Jeopardy Assessment)",
      "26:7609" : "26:7609 (26:7609 IRS: Petition to Quash IRS Summons)",
      "27:0185" : "27:0185 (27:185 Enforcement of Arbitration Award)",
      "28:0157c" : "28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)",
      "28:0157d" : "28:0157d (28:0157 Motion for Withdrawal of Reference)",
      "28:0158" : "28:0158 (28:0158 Notice of Appeal re Bankruptcy Matter (BAP))",
      "28:0185" : "28:0185 (28:185 Suit to Compel Arbitration)",
      "28:0451" : "28:0451 (28:451 Employment Discrimination)",
      "28:0794" : "28:0794 (28:794 Rehabilitation Act)",
      "28:1001" : "28:1001 (28:1001 E.R.I.S.A.)",
      "28:1132" : "28:1132 (28:1132 E.R.I.S.A.)",
      "28:1330" : "28:1330 (28:1330 Breach of Contract)",
      "28:1331" : "28:1331 (28:1331 Fed. Question)",
      "28:1331al" : "28:1331al (28:1331 Fed. Question: Airline Crash)",
      "28:1331at" : "28:1331at (28:1331 Fed. Question: Anti-trust)",
      "28:1331au" : "28:1331au (28:1331 Fed. Question: Auto Negligence)",
      "28:1331b" : "28:1331b (28:1331 Federal Question: Bivens Act)",
      "28:1331bc" : "28:1331bc (28:1331 Fed. Question: Breach of Contract)",
      "28:1331ca" : "28:1331ca (28:1331 Fed Question: Fed Communications Act of 1934)",
      "28:1331cm" : "28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)",
      "28:1331cv" : "28:1331cv (28:1331 Federal Question: Other Civil Rights)",
      "28:1331ed" : "28:1331ed (28:1331 Fed. Question: Employment Discrimination)",
      "28:1331es" : "28:1331es (28:1331 Enforcement of Administrative Subpoena)",
      "28:1331fl" : "28:1331fl (28:1331 Fed. Question: Fair Labor Standards)",
      "28:1331in" : "28:1331in (28:1331 Fed. Question: Insurance Contract)",
      "28:1331mm" : "28:1331mm (28:1331 Fed. Question: Medical Malpractice)",
      "28:1331pi" : "28:1331pi (28:1331 Fed. Question: Personal Injury)",
      "28:1331rd" : "28:1331rd (28:1331 Fed. Question: Review Agency Decision)",
      "28:1331rp" : "28:1331rp (28:1331(a) Fed. Question: Real Property)",
      "28:1331rr" : "28:1331rr (28:1331 Fed. Question: Railway Labor Act)",
      "28:1331sv" : "28:1331sv (28:1331 Fed. Question: Securities Violation)",
      "28:1331tr" : "28:1331tr (28:1331 Fed. Question: Trademark)",
      "28:1331tt" : "28:1331tt (28:1331 Fed. Question: Tort Action)",
      "28:1331v" : "28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendment)",
      "28:1331wl" : "28:1331wl (28:1331 Federal Question: EPA Waste Lien)",
      "28:1331wt" : "28:1331wt (28:1331 Fed. Question: Water Rights)",
      "28:1332ac" : "28:1332ac (28:1332 Diversity-Account Receivable)",
      "28:1332al" : "28:1332al (28:1332 Diversity-Airline Crash)",
      "28:1332as" : "28:1332as (28:1332 Diversity-Asbestos Litigation)",
      "28:1332au" : "28:1332au (28:1332 Diversity-Auto Negligence)",
      "28:1332bc" : "28:1332bc (28:1332 Diversity-Breach of Contract)",
      "28:1332co" : "28:1332co (28:1332 Diversity-Conversion)",
      "28:1332ct" : "28:1332ct (28:1332 Diversity-(Citizenship))",
      "28:1332det" : "28:1332det (28:1332 Diversity: Forcible Detainer)",
      "28:1332df" : "28:1332df (28:1332 Diversity-Contract Default)",
      "28:1332ds" : "28:1332ds (28:1332 Diversity-Contract Dispute)",
      "28:1332ed" : "28:1332ed (28:1332 Diversity-Employment Discrimination)",
      "28:1332fd" : "28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)",
      "28:1332fr" : "28:1332fr (28:1332 Diversity-Fraud)",
      "28:1332ia" : "28:1332ia (28:1332 Diversity-Interpleader Action)",
      "28:1332ij" : "28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)",
      "28:1332in" : "28:1332in (28:1332 Diversity-Insurance Contract)",
      "28:1332jd" : "28:1332jd (28:1332 Diversity-Declaratory Judgment)",
      "28:1332lb" : "28:1332lb (28:1332 Diversity-Libel,Assault,Slander)",
      "28:1332lm" : "28:1332lm (28:1332 Diversity - Legal Malpractice)",
      "28:1332ma" : "28:1332ma (28:1332 Diversity-Miller Act)",
      "28:1332mm" : "28:1332mm (28:1332 Diversity-Medical Malpractice)",
      "28:1332mv" : "28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)",
      "28:1332ni" : "28:1332ni (28:1332 Diversity-Negotiable Instrument)",
      "28:1332nm" : "28:1332nm (28:1332 Diversity-Non-Motor Vehicle)",
      "28:1332oc" : "28:1332oc (28:1332 Diversity-Other Contract)",
      "28:1332pd" : "28:1332pd (28:1332 Diversity-Property Damage)",
      "28:1332pi" : "28:1332pi (28:1332 Diversity-Personal Injury)",
      "28:1332pl" : "28:1332pl (28:1332 Diversity-Product Liability)",
      "28:1332pr" : "28:1332pr (28:1332 Diversity-Petition for Removal)",
      "28:1332qt" : "28:1332qt (28:1332 Diversity-Petition to Quiet Title)",
      "28:1332ri" : "28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)",
      "28:1332sa" : "28:1332sa (28:1332 - Diversity: Securities & Exchange Commission Act)",
      "28:1332sf" : "28:1332sf (28:1332 - Diversity: Securities Fraud)",
      "28:1332ss" : "28:1332ss (28:1332 Diversity - Stockholders Suits)",
      "28:1332tl" : "28:1332tl (28:1332 Diversity-Torts to Land)",
      "28:1332tm" : "28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))",
      "28:1332tn" : "28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)",
      "28:1332wd" : "28:1332wd (28:1332 Diversity-Wrongful Death)",
      "28:1333" : "28:1333 (28:1333 Admiralty)",
      "28:1334" : "28:1334 (28:1334 Bankruptcy Appeal)",
      "28:1334c" : "28:1334c (28:1334(c) R&R re motions for abstention (non-core))",
      "28:1335" : "28:1335 (28:1335 Interpleader Action)",
      "28:1337" : "28:1337 (28:1337 Sherman-Clayton Act)",
      "28:1338cp" : "28:1338cp (28:1338 Copyright Infringement)",
      "28:1338pt" : "28:1338pt (28:1338 Patent Infringement)",
      "28:1338tr" : "28:1338tr (28:1338 Trademark Infringement)",
      "28:1340" : "28:1340 (28:1340 IRS: Custom Duties)",
      "28:1340er" : "28:1340er (28:1340 Recovery of Erroneous Refund)",
      "28:1341" : "28:1341 (28:1341 Complaint for Forfeiture)",
      "28:1343" : "28:1343 (28:1343 Violation of Civil Rights)",
      "28:1345co" : "28:1345co (28:1345 Replevin & Conversion)",
      "28:1345db" : "28:1345db (28:1345 Debt to US - FHA/HUD Title I)",
      "28:1345df" : "28:1345df (28:1345 Default of Promissory Note)",
      "28:1345er" : "28:1345er (28:1345 Recovery of Erroneous Refund)",
      "28:1345fc" : "28:1345fc (28:1345 Foreclosure)",
      "28:1345ff" : "28:1345ff (28:1345 Complaint for Forfeiture)",
      "28:1345hl" : "28:1345hl (28:1345 VA Home Loan Guaranty Debt)",
      "28:1345mc" : "28:1345mc (28:1345 Medical Care Recovery)",
      "28:1345mi" : "28:1345mi (28:1345 Mining Claim Ejectment)",
      "28:1345pd" : "28:1345pd (28:1345 Property Damage)",
      "28:1345pe" : "28:1345pe (28:1345 Property Ejectment)",
      "28:1345rc" : "28:1345rc (28:1345 Recovery of Debt to US)",
      "28:1345st" : "28:1345st (28:1345 Default of Student Loan)",
      "28:1345tp" : "28:1345tp (28:1345 Trespass on Public Land)",
      "28:1345va" : "28:1345va (28:1345 Recovery of VA Overpayment)",
      "28:1346(b)" : "28:1346(b) ()",
      "28:1346bc" : "28:1346bc (28:1346 Breach of Contract)",
      "28:1346rc" : "28:1346rc (28:1346 Recovery of IRS Tax)",
      "28:1346tc" : "28:1346tc (28:1346 Tort Claim)",
      "28:1346wd" : "28:1346wd (28:1346 Wrongful Death)",
      "28:1352" : "28:1352 (28:1352 Miller Act)",
      "28:1355" : "28:1355 (28:1355 Petition for Return of Property)",
      "28:1358" : "28:1358 (28:1358 Land Condemnation)",
      "28:1361" : "28:1361 (28:1361 Petition for Writ of Mandamus)",
      "28:1362" : "28:1362 (28:1362 Indian Tribes)",
      "28:1362ic" : "28:1362ic (28:1362 Indian Tribal Controversy)",
      "28:1362iw" : "28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)",
      "28:1364" : "28:1364 (28:1364 Auto Negligence)",
      "28:1391" : "28:1391 (28:1391 Personal Injury)",
      "28:1402" : "28:1402 (28:1402 Medical Malpractice)",
      "28:1407" : "28:1407 (28:1407 Airline Crash)",
      "28:1441ac" : "28:1441ac (28:1441 Petition for Removal- Account Receivable)",
      "28:1441al" : "28:1441al (28:1441 Petition for Removal- Airline Crash)",
      "28:1441as" : "28:1441as (28:1441 Petition for Removal- Asbestos Litigation)",
      "28:1441au" : "28:1441au (28:1441 Petition for Removal- Auto Negligence)",
      "28:1441bc" : "28:1441bc (28:1441 Petition for Removal- Breach of Contract)",
      "28:1441cv" : "28:1441cv (28:1441 Petition for Removal- Civil Rights Act)",
      "28:1441df" : "28:1441df (28:1441 Petition for Removal- Contract Default)",
      "28:1441dj" : "28:1441dj (28:1441 Petition for Removal- Declaratory Judgement)",
      "28:1441ds" : "28:1441ds (28:1441 Petition for Removal- Contract Dispute)",
      "28:1441ed" : "28:1441ed (28:1441 Petition for Removal - Employment Discrimination)",
      "28:1441fc" : "28:1441fc (28:1441 Petition for Removal - Fair Credit Reporting Act)",
      "28:1441fr" : "28:1441fr (28:1441 Petition for Removal- Fraud)",
      "28:1441ij" : "28:1441ij (28:1441 Petition for Removal- Injunctive/Declaratory Relief)",
      "28:1441in" : "28:1441in (28:1441 Petition for Removal- Insurance Contract)",
      "28:1441int" : "28:1441int (28:1441 Petition for Removal- Action for Interpleader)",
      "28:1441lb" : "28:1441lb (28:1441 Petition for Removal Libel,Assault,Slander)",
      "28:1441lm" : "28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relations)",
      "28:1441mm" : "28:1441mm (28:1441 Petition for Removal- Medical Malpractice)",
      "28:1441ni" : "28:1441ni (28:1441 Petition for Removal- Negotiable Instrument)",
      "28:1441nm" : "28:1441nm (28:1441 Petition for Removal- Non-Motor Vehicle)",
      "28:1441oc" : "28:1441oc (28:1441 Petition For Removal--Other Contract)",
      "28:1441pd" : "28:1441pd (28:1441 Petition for Removal- Property Damage)",
      "28:1441pi" : "28:1441pi (28:1441 Petition for Removal- Personal Injury)",
      "28:1441pl" : "28:1441pl (28:1441 Petition for Removal- Product Liability)",
      "28:1441pr" : "28:1441pr (28:1441 Petition for Removal)",
      "28:1441qt" : "28:1441qt (28:1441 Petition for Removal- Petition to Quiet Title)",
      "28:1441ri" : "28:1441ri (28:1441 Petition for Removal- Racketeering (RICO) Act)",
      "28:1441sa" : "28:1441sa (28:1441 - Petition for Removal: SEC Act)",
      "28:1441sf" : "28:1441sf (28:1441 - Petition for Removal: Securities Fraud)",
      "28:1441tl" : "28:1441tl (28:1441 Petition for Removal- Torts to Land)",
      "28:1441tm" : "28:1441tm (28:1441 Petition for Removal- Tort/Motor Vehicle (P.I.))",
      "28:1441tn" : "28:1441tn (28:1441 Petition for Removal- Tort/Non-Motor Vehicle)",
      "28:1441wd" : "28:1441wd (28:1441 Petition for Removal- Wrongful Death)",
      "28:1442bc" : "28:1442bc (28:1442 Petition for Removal- Breach of Contract)",
      "28:1442pr" : "28:1442pr (28:1442 Petition for Removal)",
      "28:1443" : "28:1443 (28:1443(1) Rent, Lease & Ejectment)",
      "28:1444" : "28:1444 (28:1444 Petition for Removal- Foreclosure)",
      "28:1446in" : "28:1446in (28:1446 Breach of Contract- Insurance)",
      "28:1446pd" : "28:1446pd (28:1446 Petition for Removal- Property Damage (P.I.))",
      "28:1446pi" : "28:1446pi (28:1446 Petition for Removal- Personal Injury)",
      "28:1446pl" : "28:1446pl (28:1446pl Petition for Removal - Product Liability)",
      "28:1446pr" : "28:1446pr (28:1446 Petition for Removal)",
      "28:1452" : "28:1452 (28:1452 R&R re motions to remand (non-core))",
      "28:1651" : "28:1651 (28:1651 Petition for Writ of Coram Nobis)",
      "28:1651hc" : "28:1651hc (28:1651 Petition for Writ of Habeas Corpus)",
      "28:1651mn" : "28:1651mn (28:1651 Petition for Writ of Mandamus)",
      "28:1983" : "28:1983 (28:1983 Civil Rights)",
      "28:2201" : "28:2201 (28:2201 Constitutionality of State Statute(s))",
      "28:2201dj" : "28:2201dj (28:2201 Declaratory Judgment)",
      "28:2201ij" : "28:2201ij (28:2201 Injunction)",
      "28:2201in" : "28:2201in (28:2201 Declaratory Judgment (Insurance))",
      "28:2241" : "28:2241 (28:2241 Petition for Writ of Habeas Corpus (federal))",
      "28:2254" : "28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))",
      "28:2254se" : "28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)",
      "28:2255" : "28:2255 (28:2255 Motion to Vacate / Correct Illegal Sentence)",
      "28:2271" : "28:2271 (28:2271 Federal Tort Claims Act)",
      "28:2345" : "28:2345 (28:2345 Medicare Recovery)",
      "28:2409" : "28:2409 (28:2409(a) Quiet Title Action)",
      "28:2410" : "28:2410 (28:2410 Quiet Title)",
      "28:2671" : "28:2671 (28:2671 Federal Tort Claims Act)",
      "28:2674" : "28:2674 (28:2674 Federal Tort Claims Act)",
      "28:2675" : "28:2675 (28:2675 Disposition by Federal Agency as Prerequisite; Evidence)",
      "28:3301" : "28:3301 (28:3301 et seq. Fraudulent Transfer)",
      "28:7402" : "28:7402 (28:7402 Refund of Taxes)",
      "28:7422" : "28:7422 (28:7422 Appeal from Administrative Decision)",
      "29:0151" : "29:0151 (29:151 Labor: Review of Agency Action)",
      "29:0160" : "29:0160 (29:160(1) National Labor Relations Act)",
      "29:0184" : "29:0184 (29:184 Violation Collection Bargain Agreement)",
      "29:0185ep" : "29:0185ep (29:185 Employee Pension Plan)",
      "29:0185lm" : "29:0185lm (29:185 Labor/Mgt. Relations (Contracts))",
      "29:0201do" : "29:0201do (29:201 Denial of Overtime Compensation)",
      "29:0201fl" : "29:0201fl (29:201 Fair Labor Standards Act)",
      "29:0203" : "29:0203 (29:203 Equal Pay Act)",
      "29:0206" : "29:0206 (29:206 Collect Unpaid Wages)",
      "29:0215" : "29:0215 (29:215 Fair Labor Standards Act - Prohibited Acts; Prima Facie Evidence)",
      "29:0401" : "29:0401 (29:0401 Labor Management Disclosure Act)",
      "29:0411" : "29:0411 (29:0411 Bill of Rights; Constitution and Bylaws of Labor Organizations)",
      "29:0621" : "29:0621 (29:621 Job Discrimination (Age))",
      "29:0623" : "29:0623 (29:623 Job Discrimination (Age))",
      "29:0626" : "29:0626 (29:626 Job Discrimination (Age))",
      "29:0633" : "29:0633 (29:633 Job Discrimination (Age))",
      "29:0651" : "29:0651 (29:651 Occupational Safety/Health)",
      "29:0701" : "29:0701 (29:0701 Rehabilitation Act - Findings/Purpose/Policy)",
      "29:0754" : "29:0754 (29:754 Discrimination)",
      "29:0790" : "29:0790 (29:0790 Rehabilitation of Labor)",
      "29:0791" : "29:0791 (29:791 Job Discrimination (Rehabilitation Act))",
      "29:0794" : "29:0794 (29:0794 Nondiscrimination under Federal grants and programs)",
      "29:1001" : "29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)",
      "29:1002" : "29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)",
      "29:1104" : "29:1104 (29:1104 Recovery of Benefits to Employee)",
      "29:1109" : "29:1109 (29:1109 Breach of Fiduciary Duties)",
      "29:1131" : "29:1131 (29:1131 ERISA - Collection of Delinquent Trust Funds)",
      "29:1132" : "29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)",
      "29:1145" : "29:1145 (29:1145 E.R.I.S.A.)",
      "29:1149" : "29:1149 (29:1149 Recover Pension & Profit Sharing)",
      "29:1337" : "29:1337 (29:1337 E.R.I.S.A.)",
      "29:1362" : "29:1362 (29:1362 ERISA)",
      "29:1381" : "29:1381 (29:1381 E.R.I.S.A.)",
      "29:1401" : "29:1401 (29:1401(b)(2) Appeal of Arbitration Award)",
      "29:1451" : "29:1451 (29:1451 E.R.I.S.A.)",
      "29:1801" : "29:1801 (29:1801 Farmworker Rights)",
      "29:2101wa" : "29:2101wa (29:2101 Workers Adjustment & Retraining Act)",
      "29:2601" : "29:2601 (29:2601 Family & Medical Leave Act)",
      "29:2612" : "29:2612 (Leave Requirement)",
      "30:0181" : "30:0181 (30:181 Environment: Review of Agency Action)",
      "30:0801" : "30:0801 (30:0801 Penalities/Federal Mine Safety Health Act - 1977)",
      "30:1201" : "30:1201 (30:1201 Environment: Review of Agency Action)",
      "30:1202" : "30:1202 (30:1202 Mining Reclamation Act)",
      "30:1276" : "30:1276 (30:1276 Interior: Review of Agency Action)",
      "31:3545" : "31:3545 (31:3545 Action to Recover Money)",
      "31:3729" : "31:3729 (31:3729 False Claims Act)",
      "31:3730" : "31:3730 (31:3730 Qui Tam False Claims Act)",
      "31:3731" : "31:3731 (31:3731 Fraud)",
      "31:5321" : "31:5321 (31:5321 Civil penalties)",
      "33:1319cw" : "33:1319cw (33:1319 Clean Water Act)",
      "33:1319pv" : "33:1319pv (33:1319 Pollutants & Permit Violations)",
      "33:1365" : "33:1365 (33:1365 Environmental Matters)",
      "35:0145" : "35:0145 (35:145 Patent Infringement)",
      "35:0183" : "35:0183 (35:183 Patent Infringement)",
      "35:0271" : "35:0271 (35:271 Patent Infringement)",
      "36:0327" : "36:0327 (36:0327 Water development projects administered by US Army Corp of Engineers)",
      "38:1681" : "38:1681 (38:1681 Recovery of VA Overpayment)",
      "38:1686" : "38:1686 (38:1686 Recovery of VA Overpayment)",
      "38:1780" : "38:1780 (38:1780 Recovery of VA Overpayment)",
      "38:2011" : "38:2011 (38:2011 - Veteran's Readjustment Assistance Act of 1974)",
      "38:3116" : "38:3116 (38:3116 VA Overpayment)",
      "38:4301" : "38:4301 (38:4301)",
      "38:4323" : "38:4323 (38:4323 Veteran's Reemployment Rights Act)",
      "39:0409" : "39:0409 (39:0409 Postal Service)",
      "39:3005" : "39:3005 (39:3005 Detention of Mail for Temporary Periods)",
      "40:0258" : "40:0258 (40:258(a) Public Buildings & Property: Land Condemnation)",
      "40:0270" : "40:0270 (40:270 Miller Act)",
      "40:0875" : "40:0875 (40:875 Public Buildings & Property: Negligence)",
      "41:0251" : "41:0251 (41:251 Public Contracts-Review of Agency Action)",
      "41:1463" : "41:1463 (41:1463 Public Contracts: Unlawful Employment Practices)",
      "42:0205" : "42:0205 (42:205 Denial Social Security Benefits)",
      "42:0206" : "42:0206 (42:206 Social Security Benefits)",
      "42:0233" : "42:0233 (42:0233 Civil actions or proceedings against commissioned officers or employees)",
      "42:0247" : "42:0247 (42:247 Personal Injury-Swine Flu)",
      "42:0292" : "42:0292 (42:0292 Health Professions Education - Student Loans)",
      "42:0402" : "42:0402 (42:402 Social Security Benefits)",
      "42:0405id" : "42:0405id (42:405 Review of HHS Decision (SSID))",
      "42:0405wc" : "42:0405wc (42:405 Review of HHS Decision (DIWC))",
      "42:0405ww" : "42:0405ww (42:405 Review of HHS Decision (DIWW))",
      "42:0416" : "42:0416 (42:416 Denial of Social Security Benefits)",
      "42:0427" : "42:0427 (42:427 Social Security Benefits)",
      "42:11601" : "42:11601 (42:11601 International Child Abduction Remedies Act)",
      "42:12101" : "42:12101 (42:12101 Employment Discrimination Rehabilitation Act)",
      "42:12112" : "42:12112 (42:12112 Discrimination)",
      "42:12181" : "42:12181 (42:12181 Americans with Disabilities)",
      "42:12201" : "42:12201 (42:12201 Construction)",
      "42:1332" : "42:1332 (42:1332 Diversity Jurisdiction)",
      "42:1383" : "42:1383 (42:1383 Review of HHS Decision)",
      "42:1395" : "42:1395 (42:1395 HHS: Adverse Reimbursement Review)",
      "42:1395dd" : "42:1395dd (42:1395dd Examination & treatment for emergency med. cond.)",
      "42:1396" : "42:1396 (42:1396 - Tort Negligence)",
      "42:14501" : "42:14501 (42:14501 Volunteer Protection Act of 1997)",
      "42:1471" : "42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclosure Sale)",
      "42:1981cv" : "42:1981cv (42:1981 Civil Rights)",
      "42:1981hs" : "42:1981hs (42:1981 Housing Discrimination)",
      "42:1981jb" : "42:1981jb (42:1981 Job Discrimination (Race))",
      "42:1981sx" : "42:1981sx (42:1981 Sex Discrimination)",
      "42:1983cv" : "42:1983cv (42:1983 Civil Rights Act)",
      "42:1983ed" : "42:1983ed (42:1983 Civil Rights (Employment Discrimination))",
      "42:1983pr" : "42:1983pr (42:1983 Prisoner Civil Rights)",
      "42:1986" : "42:1986 (42:1986 Neglect of Duty)",
      "42:2000ag" : "42:2000ag (42:2000 Job Discrimination (Age))",
      "42:2000e" : "42:2000e (42:2000e Job Discrimination (Employment))",
      "42:2000pb" : "42:2000pb (42:2000 Job Discrimination (Public Accomodations))",
      "42:2000ra" : "42:2000ra (42:2000 Job Discrimination (Race))",
      "42:2000sx" : "42:2000sx (42:2000 Job Discrimination (Sex))",
      "42:2003" : "42:2003 (42:2003 Job Discrimination)",
      "42:2005" : "42:2005 (42:2005 Review of Agency Action-HHS)",
      "42:2651" : "42:2651 (42:2651 Medical Care Recovery)",
      "42:3601" : "42:3601 (42:3601 Fair Housing Act)",
      "42:4000" : "42:4000 (42:4000 National Flood Insurance Act)",
      "42:4001" : "42:4001 (42:4001 National Insurance Flood Act)",
      "42:4053" : "42:4053 (42:4053 Breach of Insurance Contract)",
      "42:4072" : "42:4072 (42:4072 Payment of Flood Insurance Claim)",
      "42:4321" : "42:4321 (42:4321 Review of Agency Action-Environment)",
      "42:4332" : "42:4332 (42:4332 Environmental Policy - Coop of Agency Reports)",
      "42:6901en" : "42:6901en (42:6901 Environmental Cleanup Expenses)",
      "42:6901rs" : "42:6901rs (42:6901 Resource & Recovery Act)",
      "42:7413" : "42:7413 (42:7413(b) Clean Air Act)",
      "42:7604cl" : "42:7604cl (42:7604 Clear Air Act (Emission Standards))",
      "42:7604ir" : "42:7604ir (42:7604 Petition to Quash IRS Summons)",
      "42:9607" : "42:9607 (42:9607 Real Property Tort to Land)",
      "43:0945" : "43:0945 (43:0945 Compensation for Land Condemnation)",
      "43:0945a" : "43:0945a (43:0945a Complaint in Condemnation)",
      "43:0946" : "43:0946 (43:0946 Complaint in Condemnation - Eminent Domain)",
      "45:0051" : "45:0051 (45:51 Railways: Fed. Employer's Liability Act)",
      "45:0151" : "45:0151 (45:151 Railway Labor Act)",
      "45:0184" : "45:0184 (45:184 Action to Set Aside Award of a System Board of Adjust)",
      "45:1395" : "45:1395 (45:1395 Railroads: Adverse Reimbursement Review)",
      "45:7457" : "45:7457 (45:7457 Compel Reclamation Under Clear Air Act)",
      "46:0183" : "46:0183 (46:183 Limitation of Vessel Owners Liability)",
      "46:0688" : "46:0688 (46:688 Jones Act)",
      "46:0741" : "46:0741 (46:741 Shipping)",
      "46:0761" : "46:0761 (46:761 Shipping: Damages for Death on High Seas)",
      "46:1101" : "46:1101 (46:1101 Violation of Maritime Regulations)",
      "46:1156" : "46:1156 (46:1156 Administrative Procedure Act)",
      "46:30505" : "46:30505 (46:30505 General Limit of Liability)",
      "47:0201" : "47:0201 (47:0201 Service and charges)",
      "47:0227" : "47:0227 (47:0227 Restrictions on use of telephone equipment)",
      "47:0605" : "47:0605 (47:0605 Unauthorized Publication or Use of Communications)",
      "47:8553" : "47:8553 (47:8553)",
      "48:0883" : "48:0883 (48:883 Violation of US Coastal Law)",
      "48:1985" : "48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)",
      "49:0081" : "49:0081 (49:81 Damaged Goods While Being Transported)",
      "49:0781" : "49:0781 (49:781 Forfeiture)",
      "49:11503" : "49:11503 (49:11503 Railroad Revitalization Regulatory Reform Act)",
      "49:11702" : "49:11702 (49:11702(a)(4) Violations of Interstate Commerce Act)",
      "49:1471" : "49:1471 (49:1471 Federal Aviation Act)",
      "49:1903" : "49:1903 (49:1903 Petition to enforce administrative summons)",
      "49:20109" : "49:20109 (49:20109 Employee Protections)",
      "misc" : "misc (civil miscellaneous case)"
   },
   "okndce" : {
      "0" : "0 (No cause code entered)",
      "00:0000" : "00:0000 (00:0000 Cause Code Unknown)",
      "02:0431" : "02:0431 (02:431 Fed. Election Commission: Failure Enforce Compliance)",
      "02:0437" : "02:0437 (02:437 Federal Election Commission)",
      "05:0075" : "05:0075 (05:75(2) Contract - Reduction in Grade)",
      "05:0551" : "05:0551 (05:551 Administrative Procedure Act)",
      "05:0552fi" : "05:0552fi (05:552 Freedom of Information Act)",
      "05:0552pa" : "05:0552pa (05:552 Right to Privacy Act)",
      "05:0554" : "05:0554 (05:0554 Constitutionality of Maritime Statutes)",
      "05:0701" : "05:0701 (05:0701 Maritime Subsidy Board)",
      "05:0702" : "05:0702 (05:702 Administrative Procedure Act)",
      "05:0704" : "05:0704 (05:704 Labor Litigation)",
      "05:7703" : "05:7703 (05:7703 Discrimination - Review of Agency Act)",
      "07:0006" : "07:0006 (7:6(b) Federal Commodity Exchange Regulation)",
      "07:0025" : "07:0025 (7:25 Fraud - Commodities Leverage Contracts)",
      "07:0181" : "07:0181 (07:181 Packers & Stockyard Act)",
      "07:0499" : "07:0499 (07:499 Agricultural Commodities Act)",
      "07:0601" : "07:0601 (07:601 USDA Condemnation)",
      "07:2321" : "07:2321 (07:2321 Plant Variety Protection Act)",
      "08:1105" : "08:1105 (8:1105(a) Aliens: Habeas Corpus to Release INS Detainee)",
      "08:1252" : "08:1252 (08:1252(a)(2) Injunction for Deportation)",
      "08:1260" : "08:1260 (08:1260 Aliens: Access to Records)",
      "08:1324" : "08:1324 (08:1324 Aliens: Complaint for Forfeiture)",
      "08:1329" : "08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petition)",
      "08:1446" : "08:1446 (8:1446 Petition for Naturalization Hearing)",
      "09:0001" : "09:0001 (09:1 U.S. Arbitration Act)",
      "09:0009" : "09:0009 (9:9 Motion to Confirm Arbitration Loan)",
      "09:0010" : "09:0010 (09:0010 Petition to Vacate Arbitration Award)",
      "10:1552" : "10:1552 (10:1552 Armed Forces: Action to Correct Records)",
      "10:1553" : "10:1553 (10:1553 Armed Forces: FOIA General)",
      "10:2305" : "10:2305 (10:2305 Review of Federal Contract)",
      "11:0101" : "11:0101 (11:101 Bankruptcy)",
      "12:0022" : "12:0022 (12:22 Securities Fraud)",
      "12:0635" : "12:0635 (12:635 Breach of Insurance Contract)",
      "12:1461" : "12:1461 (12:1461 Homeowners Loan Act)",
      "12:1703" : "12:1703 (12:1703 Default of HUD Loan)",
      "12:1725" : "12:1725 (12:1725 Collection under Contract Guaranty)",
      "12:1730" : "12:1730 (12:1730 Collection Under Contract Guaranty)",
      "12:1819" : "12:1819 (12:1819 Default of Promissory Note)",
      "12:1821" : "12:1821 (12:1821 Default of Loan by Promissary Note)",
      "12:1971" : "12:1971 (12:1971 Relief under Bank Holding Act)",
      "12:3410" : "12:3410 (12:3410 Right to Financial Privacy Act)",
      "15:0001" : "15:0001 (15:1 Antitrust Litigation)",
      "15:0002at" : "15:0002at (15:2 Antitrust Litigation)",
      "15:0002fl" : "15:0002fl (15:2(a) Fair Labor Standards Act)",
      "15:0005" : "15:0005 (15:5(a) Fair Labor Standards Act)",
      "15:0015" : "15:0015 (15:15 Antitrust Litigation)",
      "15:0025" : "15:0025 (15:25 Clayton Act)",
      "15:0044" : "15:0044 (15:44 Trademark Infringement)",
      "15:0045" : "15:0045 (15:0045 Federal Trade Commission Act)",
      "15:0052" : "15:0052 (15:0052 Federal Trade Commission Act)",
      "15:0053" : "15:0053 (15:0053 Federal Trade Commission Act)",
      "15:0077" : "15:0077 (15:77 Securities Fraud)",
      "15:0078" : "15:0078 (15:78m(a) Securities Exchange Act)",
      "15:0631" : "15:0631 (15:631 Small Business Act)",
      "15:0717" : "15:0717 (15:717 Natural Gas Act)",
      "15:1051" : "15:1051 (15:1051 Trademark Infringement)",
      "15:1114" : "15:1114 (15:1114 Trademark Infringement)",
      "15:1121" : "15:1121 (15:1121 Trademark Infringement)",
      "15:1125" : "15:1125 (15:1125 Trademark Infringement (Lanham Act))",
      "15:1126" : "15:1126 (15:1126 Patent Infringement)",
      "15:1127" : "15:1127 (15:1127 Trademark Infringement)",
      "15:1601" : "15:1601 (15:1601 Truth in Lending)",
      "15:1640" : "15:1640 (15:1640 Truth in Lending)",
      "15:1681" : "15:1681 (15:1681 Fair Credit Reporting Act)",
      "15:1692" : "15:1692 (15:1692 Fair Debt Collection Act)",
      "15:1938" : "15:1938 (15:1938 Fair Labor Standards Act)",
      "15:1981" : "15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))",
      "15:1988" : "15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))",
      "15:1989" : "15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))",
      "15:2301" : "15:2301 (15:2301 Magnuson-Moss Warranty Act)",
      "15:2801" : "15:2801 (15:2801 Petroleum Marketing Practices Act)",
      "15:53(b)" : "15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equitable Relief)",
      "16:0668" : "16:0668 (16:668 Bald Eagle Protection Act)",
      "16:0703" : "16:0703 (16:703 Migratory Bird Act)",
      "16:1538" : "16:1538 (16:1538 Endangered Species Act)",
      "16:3371" : "16:3371 (16:3371 Wildlife Under the Lacey Act)",
      "16:3372" : "16:3372 (16:3372 Conservation: Complaint for Forfeiture)",
      "16:3373" : "16:3373 (16:3373 Appeal of Decision - DOI)",
      "16:3374" : "16:3374 (16:3374 Conservation: Complaint for Forfeiture)",
      "17:0101" : "17:0101 (17:101 Copyright Infringement)",
      "17:0501" : "17:0501 (17:501 Copyright Infringement)",
      "17:0504" : "17:0504 (17:504 Copyright Infringement)",
      "18:0241" : "18:0241 (18:241 Conspiracy Against Citizen Rights)",
      "18:1836a" : "18:1836a (18:1836(a) Injunction against Misappropriation of Trade Secrets)",
      "18:1836b" : "18:1836b (18:1836(b) Civil Action to Protect Trade Secrets)",
      "18:1961" : "18:1961 (18:1961 Racketeering (RICO) Act)",
      "18:1962" : "18:1962 (18:1962 Racketeering (RICO) Act)",
      "18:1964" : "18:1964 (18:1964 Racketeering (RICO) Act)",
      "18:4208" : "18:4208 (18:4208(B) Agency Action Review)",
      "19:1305" : "19:1305 (19:1305 Custom Duties:0Forfeiture-Immoral Articles)",
      "20:1080" : "20:1080 (20:1080 Student Loan Recovery)",
      "20:1400" : "20:1400 (20:1400 Civil Rights of Handicapped Child)",
      "20:1401" : "20:1401 (20:1401 Education: Handicapped Child Act)",
      "21:0841" : "21:0841 (21:841 Forfeiture Property-Drugs)",
      "21:0881" : "21:0881 (21:881 Forfeiture Property-Drugs)",
      "21:0881a" : "21:0881a (21:881 Forfeiture Property - Aircraft)",
      "21:0881re" : "21:0881re (21:881 Forfeiture Property - Real Estate)",
      "23:0134" : "23:0134 (23:134 P.I.- Auto Negligence)",
      "23:1441" : "23:1441 (23:1441 Contract Real Estate)",
      "24:1000" : "24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)",
      "25:0640" : "25:0640 (25:640 Indian Tribal Rights)",
      "25:1901" : "25:1901 (25:1901 Indian Child Welfare Act)",
      "26:6212" : "26:6212 (26:6212 Injunctive Relief from IRS Lien)",
      "26:6213" : "26:6213 (26:6213 Injunctive Relief from IRS Lien)",
      "26:6502" : "26:6502 (26:6502 IRS:Enforcement of tax liens)",
      "26:6532" : "26:6532 (26:6532 IRS: Refund of Tax Penalty)",
      "26:6702" : "26:6702 (26:6702 IRS: Refund of Income Tax Penalty)",
      "26:6703" : "26:6703 (26:6703 IRS: Refund of Tax Penalty)",
      "26:7401" : "26:7401 (26:7401 IRS: Tax Liability)",
      "26:7402" : "26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)",
      "26:7403" : "26:7403 (26:7403 Suit to Enforce Federal Tax Lien)",
      "26:7422rt" : "26:7422rt (26:7422 IRS: Refund Taxes)",
      "26:7422rx" : "26:7422rx (26:7422 IRS: Refund Excise Tax)",
      "26:7426" : "26:7426 (26:7426 IRS: Wrongful Levy for Taxes)",
      "26:7429" : "26:7429 (26:7429 IRS: Tax Jeopardy Assessment)",
      "26:7609" : "26:7609 (26:7609 IRS: Petition to Quash IRS Summons)",
      "27:0185" : "27:0185 (27:185 Enforcement of Arbitration Award)",
      "28:0157c" : "28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)",
      "28:0157d" : "28:0157d (28:0157 Motion for Withdrawal of Reference)",
      "28:0158" : "28:0158 (28:0158 Notice of Appeal re Bankruptcy Matter (BAP))",
      "28:0185" : "28:0185 (28:185 Suit to Compel Arbitration)",
      "28:0451" : "28:0451 (28:451 Employment Discrimination)",
      "28:0794" : "28:0794 (28:794 Rehabilitation Act)",
      "28:1001" : "28:1001 (28:1001 E.R.I.S.A.)",
      "28:1132" : "28:1132 (28:1132 E.R.I.S.A.)",
      "28:1330" : "28:1330 (28:1330 Breach of Contract)",
      "28:1331" : "28:1331 (28:1331 Fed. Question)",
      "28:1331al" : "28:1331al (28:1331 Fed. Question: Airline Crash)",
      "28:1331at" : "28:1331at (28:1331 Fed. Question: Anti-trust)",
      "28:1331au" : "28:1331au (28:1331 Fed. Question: Auto Negligence)",
      "28:1331b" : "28:1331b (28:1331 Federal Question: Bivens Act)",
      "28:1331bc" : "28:1331bc (28:1331 Fed. Question: Breach of Contract)",
      "28:1331ca" : "28:1331ca (28:1331 Fed Question: Fed Communications Act of 1934)",
      "28:1331cm" : "28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)",
      "28:1331cv" : "28:1331cv (28:1331 Federal Question: Other Civil Rights)",
      "28:1331ed" : "28:1331ed (28:1331 Fed. Question: Employment Discrimination)",
      "28:1331es" : "28:1331es (28:1331 Enforcement of Administrative Subpoena)",
      "28:1331fl" : "28:1331fl (28:1331 Fed. Question: Fair Labor Standards)",
      "28:1331in" : "28:1331in (28:1331 Fed. Question: Insurance Contract)",
      "28:1331mm" : "28:1331mm (28:1331 Fed. Question: Medical Malpractice)",
      "28:1331pi" : "28:1331pi (28:1331 Fed. Question: Personal Injury)",
      "28:1331rd" : "28:1331rd (28:1331 Fed. Question: Review Agency Decision)",
      "28:1331rp" : "28:1331rp (28:1331(a) Fed. Question: Real Property)",
      "28:1331rr" : "28:1331rr (28:1331 Fed. Question: Railway Labor Act)",
      "28:1331sv" : "28:1331sv (28:1331 Fed. Question: Securities Violation)",
      "28:1331tr" : "28:1331tr (28:1331 Fed. Question: Trademark)",
      "28:1331tt" : "28:1331tt (28:1331 Fed. Question: Tort Action)",
      "28:1331v" : "28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendment)",
      "28:1331wl" : "28:1331wl (28:1331 Federal Question: EPA Waste Lien)",
      "28:1331wt" : "28:1331wt (28:1331 Fed. Question: Water Rights)",
      "28:1332ac" : "28:1332ac (28:1332 Diversity-Account Receivable)",
      "28:1332al" : "28:1332al (28:1332 Diversity-Airline Crash)",
      "28:1332as" : "28:1332as (28:1332 Diversity-Asbestos Litigation)",
      "28:1332au" : "28:1332au (28:1332 Diversity-Auto Negligence)",
      "28:1332bc" : "28:1332bc (28:1332 Diversity-Breach of Contract)",
      "28:1332co" : "28:1332co (28:1332 Diversity-Conversion)",
      "28:1332ct" : "28:1332ct (28:1332 Diversity-(Citizenship))",
      "28:1332det" : "28:1332det (28:1332 Diversity: Forcible Detainer)",
      "28:1332df" : "28:1332df (28:1332 Diversity-Contract Default)",
      "28:1332ds" : "28:1332ds (28:1332 Diversity-Contract Dispute)",
      "28:1332ed" : "28:1332ed (28:1332 Diversity-Employment Discrimination)",
      "28:1332fd" : "28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)",
      "28:1332fr" : "28:1332fr (28:1332 Diversity-Fraud)",
      "28:1332ia" : "28:1332ia (28:1332 Diversity-Interpleader Action)",
      "28:1332ij" : "28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)",
      "28:1332in" : "28:1332in (28:1332 Diversity-Insurance Contract)",
      "28:1332jd" : "28:1332jd (28:1332 Diversity-Declaratory Judgement)",
      "28:1332lb" : "28:1332lb (28:1332 Diversity-Libel,Assault,Slander)",
      "28:1332lm" : "28:1332lm (28:1332 Diversity - Legal Malpractice)",
      "28:1332ma" : "28:1332ma (28:1332 Diversity-Miller Act)",
      "28:1332mm" : "28:1332mm (28:1332 Diversity-Medical Malpractice)",
      "28:1332mv" : "28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)",
      "28:1332n" : "28:1332n (28:1332 Diversity-Norplant Product Liability)",
      "28:1332ni" : "28:1332ni (28:1332 Diversity-Negotiable Instrument)",
      "28:1332nm" : "28:1332nm (28:1332 Diversity-Non-Motor Vehicle)",
      "28:1332oc" : "28:1332oc (28:1332 Diversity-Other Contract)",
      "28:1332pd" : "28:1332pd (28:1332 Diversity-Property Damage)",
      "28:1332pi" : "28:1332pi (28:1332 Diversity-Personal Injury)",
      "28:1332pl" : "28:1332pl (28:1332 Diversity-Product Liability)",
      "28:1332pr" : "28:1332pr (28:1332 Diversity-Petition for Removal)",
      "28:1332qt" : "28:1332qt (28:1332 Diversity-Petition to Quiet Title)",
      "28:1332ri" : "28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)",
      "28:1332sa" : "28:1332sa (28:1332 - Diversity: Securities & Exchange Commission Act)",
      "28:1332sf" : "28:1332sf (28:1332 - Diversity: Securities Fraud)",
      "28:1332ss" : "28:1332ss (28:1332 Diversity - Stockholders Suits)",
      "28:1332tl" : "28:1332tl (28:1332 Diversity-Torts to Land)",
      "28:1332tm" : "28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))",
      "28:1332tn" : "28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)",
      "28:1332wd" : "28:1332wd (28:1332 Diversity-Wrongful Death)",
      "28:1333" : "28:1333 (28:1333 Admiralty)",
      "28:1334" : "28:1334 (28:1334 Bankruptcy Appeal)",
      "28:1334c" : "28:1334c (28:1334(c) R&R re motions for abstention (non-core))",
      "28:1335" : "28:1335 (28:1335 Interpleader Action)",
      "28:1337" : "28:1337 (28:1337 Sherman-Clayton Act)",
      "28:1338cp" : "28:1338cp (28:1338 Copyright Infringement)",
      "28:1338pt" : "28:1338pt (28:1338 Patent Infringement)",
      "28:1338tr" : "28:1338tr (28:1338 Trademark Infringement)",
      "28:1340" : "28:1340 (28:1340 IRS: Custom Duties)",
      "28:1340er" : "28:1340er (28:1340 Recovery of Erroneous Refund)",
      "28:1341" : "28:1341 (28:1341 Complaint for Forfeiture)",
      "28:1343" : "28:1343 (28:1343 Violation of Civil Rights)",
      "28:1345co" : "28:1345co (28:1345 Replevin & Conversion)",
      "28:1345db" : "28:1345db (28:1345 Debt to US - FHA/HUD Title I)",
      "28:1345df" : "28:1345df (28:1345 Default of Promissory Note)",
      "28:1345er" : "28:1345er (28:1345 Recovery of Erroneous Refund)",
      "28:1345fc" : "28:1345fc (28:1345 Foreclosure)",
      "28:1345ff" : "28:1345ff (28:1345 Complaint for Forfeiture)",
      "28:1345hl" : "28:1345hl (28:1345 VA Home Loan Guaranty Debt)",
      "28:1345mc" : "28:1345mc (28:1345 Medical Care Recovery)",
      "28:1345mi" : "28:1345mi (28:1345 Mining Claim Ejectment)",
      "28:1345pd" : "28:1345pd (28:1345 Property Damage)",
      "28:1345pe" : "28:1345pe (28:1345 Property Ejectment)",
      "28:1345rc" : "28:1345rc (28:1345 Recovery of Debt to US)",
      "28:1345st" : "28:1345st (28:1345 Default of Student Loan)",
      "28:1345tp" : "28:1345tp (28:1345 Trespass on Public Land)",
      "28:1345va" : "28:1345va (28:1345 Recovery of VA Overpayment)",
      "28:1346bc" : "28:1346bc (28:1346 Breach of Contract)",
      "28:1346rc" : "28:1346rc (28:1346 Recovery of IRS Tax)",
      "28:1346tc" : "28:1346tc (28:1346 Tort Claim)",
      "28:1346wd" : "28:1346wd (28:1346 Wrongful Death)",
      "28:1352" : "28:1352 (28:1352 Miller Act)",
      "28:1355" : "28:1355 (28:1355 Petition for Return of Property)",
      "28:1358" : "28:1358 (28:1358 Land Condemnation)",
      "28:1361" : "28:1361 (28:1361 Petition for Writ of Mandamus)",
      "28:1362ic" : "28:1362ic (28:1362 Indian Tribal Controversy)",
      "28:1362iw" : "28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)",
      "28:1364" : "28:1364 (28:1364 Auto Negligence)",
      "28:1391" : "28:1391 (28:1391 Personal Injury)",
      "28:1402" : "28:1402 (28:1402 Medical Malpractice)",
      "28:1407" : "28:1407 (28:1407 Airline Crash)",
      "28:1441ac" : "28:1441ac (28:1441 Petition for Removal- Account Receivable)",
      "28:1441al" : "28:1441al (28:1441 Petition for Removal- Airline Crash)",
      "28:1441as" : "28:1441as (28:1441 Petition for Removal- Asbestos Litigation)",
      "28:1441au" : "28:1441au (28:1441 Petition for Removal- Auto Negligence)",
      "28:1441bc" : "28:1441bc (28:1441 Petition for Removal- Breach of Contract)",
      "28:1441cv" : "28:1441cv (28:1441 Petition for Removal- Civil Rights Act)",
      "28:1441df" : "28:1441df (28:1441 Petition for Removal- Contract Default)",
      "28:1441dj" : "28:1441dj (28:1441 Petition for Removal- Declaratory Judgement)",
      "28:1441ds" : "28:1441ds (28:1441 Petition for Removal- Contract Dispute)",
      "28:1441ed" : "28:1441ed (28:1441 Petition for Removal - Employment Discrimination)",
      "28:1441fc" : "28:1441fc (28:1441 Petition for Removal - Fair Credit Reporting Act)",
      "28:1441fr" : "28:1441fr (28:1441 Petition for Removal- Fraud)",
      "28:1441ij" : "28:1441ij (28:1441 Petition for Removal- Injunctive/Declaratory Relief)",
      "28:1441in" : "28:1441in (28:1441 Petition for Removal- Insurance Contract)",
      "28:1441int" : "28:1441int (28:1441 Petition for Removal- Action for Interpleader)",
      "28:1441lb" : "28:1441lb (28:1441 Petition for Removal Libel,Assault,Slander)",
      "28:1441lm" : "28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relations)",
      "28:1441mm" : "28:1441mm (28:1441 Petition for Removal- Medical Malpractice)",
      "28:1441ni" : "28:1441ni (28:1441 Petition for Removal- Negotiable Instrument)",
      "28:1441nm" : "28:1441nm (28:1441 Petition for Removal- Non-Motor Vehicle)",
      "28:1441oc" : "28:1441oc (28:1441 Petition For Removal--Other Contract)",
      "28:1441pd" : "28:1441pd (28:1441 Petition for Removal- Property Damage)",
      "28:1441pi" : "28:1441pi (28:1441 Petition for Removal- Personal Injury)",
      "28:1441pl" : "28:1441pl (28:1441 Petition for Removal- Product Liability)",
      "28:1441pr" : "28:1441pr (28:1441 Petition for Removal)",
      "28:1441qt" : "28:1441qt (28:1441 Petition for Removal- Petition to Quiet Title)",
      "28:1441ri" : "28:1441ri (28:1441 Petition for Removal- Racketeering (RICO) Act)",
      "28:1441sa" : "28:1441sa (28:1441 - Petition for Removal: SEC Act)",
      "28:1441sf" : "28:1441sf (28:1441 - Petition for Removal: Securities Fraud)",
      "28:1441tl" : "28:1441tl (28:1441 Petition for Removal- Torts to Land)",
      "28:1441tm" : "28:1441tm (28:1441 Petition for Removal- Tort/Motor Vehicle (P.I.))",
      "28:1441tn" : "28:1441tn (28:1441 Petition for Removal- Tort/Non-Motor Vehicle)",
      "28:1441wd" : "28:1441wd (28:1441 Petition for Removal- Wrongful Death)",
      "28:1442bc" : "28:1442bc (28:1442 Petition for Removal- Breach of Contract)",
      "28:1442pr" : "28:1442pr (28:1442 Petition for Removal)",
      "28:1443" : "28:1443 (28:1443(1) Rent, Lease & Ejectment)",
      "28:1444" : "28:1444 (28:1444 Petition for Removal- Foreclosure)",
      "28:1446in" : "28:1446in (28:1446 Breach of Contract- Insurance)",
      "28:1446pd" : "28:1446pd (28:1446 Petition for Removal- Property Damage (P.I.))",
      "28:1446pi" : "28:1446pi (28:1446 Petition for Removal- Personal Injury)",
      "28:1446pl" : "28:1446pl (28:1446pl Petition for Removal - Product Liability)",
      "28:1446pr" : "28:1446pr (28:1446 Petition for Removal)",
      "28:1452" : "28:1452 (28:1452 R&R re motions to remand (non-core))",
      "28:1651" : "28:1651 (28:1651 Petition for Writ of Coram Nobis)",
      "28:1651hc" : "28:1651hc (28:1651 Petition for Writ of Habeas Corpus)",
      "28:1651mn" : "28:1651mn (28:1651 Petition for Writ of Mandamus)",
      "28:1983" : "28:1983 (28:1983 Civil Rights)",
      "28:2201" : "28:2201 (28:2201 Constitutionality of State Statute(s))",
      "28:2201dj" : "28:2201dj (28:2201 Declaratory Judgement)",
      "28:2201ij" : "28:2201ij (28:2201 Injunction)",
      "28:2201in" : "28:2201in (28:2201 Declaratory Judgement (Insurance))",
      "28:2241" : "28:2241 (28:2241 Petition for Writ of Habeas Corpus)",
      "28:2254" : "28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))",
      "28:2254se" : "28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)",
      "28:2255" : "28:2255 (28:2255 Motion to Vacate / Correct Illegal Sentence)",
      "28:2271" : "28:2271 (28:2271 Federal Tort Claims Act)",
      "28:2345" : "28:2345 (28:2345 Medicare Recovery)",
      "28:2409" : "28:2409 (28:2409(a) Quiet Title Action)",
      "28:2410" : "28:2410 (28:2410 Quiet Title)",
      "28:2671" : "28:2671 (28:2671 Federal Tort Claims Act)",
      "28:2674" : "28:2674 (28:2674 Federal Tort Claims Act)",
      "28:7402" : "28:7402 (28:7402 Refund of Taxes)",
      "28:7422" : "28:7422 (28:7422 Appeal from Administrative Decision)",
      "29:0151" : "29:0151 (29:151 Labor: Review of Agency Action)",
      "29:0160" : "29:0160 (29:160(1) National Labor Relations Act)",
      "29:0184" : "29:0184 (29:184 Violation Collection Bargain Agreement)",
      "29:0185ep" : "29:0185ep (29:185 Employee Pension Plan)",
      "29:0185lm" : "29:0185lm (29:185 Labor/Mgt. Relations (Contracts))",
      "29:0201do" : "29:0201do (29:201 Denial of Overtime Compensation)",
      "29:0201fl" : "29:0201fl (29:201 Fair Labor Standards Act)",
      "29:0203" : "29:0203 (29:203 Equal Pay Act)",
      "29:0206" : "29:0206 (29:206 Collect Unpaid Wages)",
      "29:0401" : "29:0401 (29:0401 Labor Management Disclosure Act)",
      "29:0621" : "29:0621 (29:621 Job Discrimination (Age))",
      "29:0623" : "29:0623 (29:623 Job Discrimination (Age))",
      "29:0626" : "29:0626 (29:626 Job Discrimination (Age))",
      "29:0633" : "29:0633 (29:633 Job Discrimination (Age))",
      "29:0651" : "29:0651 (29:651 Occupational Safety/Health)",
      "29:0754" : "29:0754 (29:754 Discrimination)",
      "29:0791" : "29:0791 (29:791 Job Discrimination (Rehabilitation Act))",
      "29:0794" : "29:0794 (29:0794 Job Discrimination (Handicap))",
      "29:1001" : "29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)",
      "29:1002" : "29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)",
      "29:1104" : "29:1104 (29:1104 Recovery of Benefits to Employee)",
      "29:1109" : "29:1109 (29:1109 Breach of Fiduciary Duties)",
      "29:1131" : "29:1131 (29:1131 ERISA - Collection of Delinquent Trust Funds)",
      "29:1132" : "29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)",
      "29:1145" : "29:1145 (29:1145 E.R.I.S.A.)",
      "29:1149" : "29:1149 (29:1149 Recover Pension & Profit Sharing)",
      "29:1337" : "29:1337 (29:1337 E.R.I.S.A.)",
      "29:1362" : "29:1362 (29:1362 ERISA)",
      "29:1381" : "29:1381 (29:1381 E.R.I.S.A.)",
      "29:1401" : "29:1401 (29:1401(b)(2) Appeal of Arbitration Award)",
      "29:1451" : "29:1451 (29:1451 E.R.I.S.A.)",
      "29:1801" : "29:1801 (29:1801 Farmworker Rights)",
      "29:2617" : "29:2617 (29:2617 Family & Medical Leave Act of 1993)",
      "29:790" : "29:790 (29:790 Rehabilitation of Labor)",
      "30:0181" : "30:0181 (30:181 Environment: Review of Agency Action)",
      "30:0801" : "30:0801 (30:0801 Penalities/Federal Mine Safety Health Act - 1977)",
      "30:1201" : "30:1201 (30:1201 Environment: Review of Agency Action)",
      "30:1202" : "30:1202 (30:1202 Mining Reclamation Act)",
      "30:1276" : "30:1276 (30:1276 Interior: Review of Agency Action)",
      "31:3545" : "31:3545 (31:3545 Action to Recover Money)",
      "31:3729" : "31:3729 (31:3729 False Claims Act)",
      "31:3730" : "31:3730 (31:3730 Qui Tam False Claims Act)",
      "31:3731" : "31:3731 (31:3731 Fraud)",
      "33:1319cw" : "33:1319cw (33:1319 Clean Water Act)",
      "33:1319pv" : "33:1319pv (33:1319 Pollutants & Permit Violations)",
      "33:1365" : "33:1365 (33:1365 Environmental Matters)",
      "35:0145" : "35:0145 (35:145 Patent Infringement)",
      "35:0183" : "35:0183 (35:183 Patent Infringement)",
      "35:0271" : "35:0271 (35:271 Patent Infringement)",
      "38:1681" : "38:1681 (38:1681 Recovery of VA Overpayment)",
      "38:1686" : "38:1686 (38:1686 Recovery of VA Overpayment)",
      "38:1780" : "38:1780 (38:1780 Recovery of VA Overpayment)",
      "38:2011" : "38:2011 (38:2011 - Veteran's Readjustment Assistance Act of 1974)",
      "38:3116" : "38:3116 (38:3116 VA Overpayment)",
      "39:3005" : "39:3005 (39:3005 Detention of Mail for Temporary Periods)",
      "39:409" : "39:409 (39:409 Postal Service)",
      "40:0258" : "40:0258 (40:258(a) Public Buildings & Property: Land Condemnation)",
      "40:0270" : "40:0270 (40:270 Miller Act)",
      "40:0875" : "40:0875 (40:875 Public Buildings & Property: Negligence)",
      "41:0251" : "41:0251 (41:251 Public Contracts-Review of Agency Action)",
      "41:1463" : "41:1463 (41:1463 Public Contracts: Unlawful Employment Practices)",
      "42:0205" : "42:0205 (42:205 Denial Social Security Benefits)",
      "42:0206" : "42:0206 (42:206 Social Security Benefits)",
      "42:0247" : "42:0247 (42:247 Personal Injury-Swine Flu)",
      "42:0402" : "42:0402 (42:402 Social Security Benefits)",
      "42:0405id" : "42:0405id (42:405 Review of HHS Decision (SSID))",
      "42:0405rs" : "42:0405rs (42:405 Review of HHS Decision (RSI))",
      "42:0405wc" : "42:0405wc (42:405 Review of HHS Decision (DIWC))",
      "42:0405ww" : "42:0405ww (42:405 Review of HHS Decision (DIWW))",
      "42:0416" : "42:0416 (42:416 Denial of Social Security Benefits)",
      "42:0427" : "42:0427 (42:427 Social Security Benefits)",
      "42:11603b" : "42:11603b (42:11603 International Child Abduction Remedies Act)",
      "42:12101" : "42:12101 (42:12101 Americans with Disabilities Act (ADA))",
      "42:1383" : "42:1383 (42:1383 Review of HHS Decision)",
      "42:1395" : "42:1395 (42:1395 HHS: Adverse Reimbursement Review)",
      "42:1396" : "42:1396 (42:1396 - Tort Negligence)",
      "42:1471" : "42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclosure Sale)",
      "42:1981cv" : "42:1981cv (42:1981 Civil Rights)",
      "42:1981hs" : "42:1981hs (42:1981 Housing Discrimination)",
      "42:1981jb" : "42:1981jb (42:1981 Job Discrimination (Race))",
      "42:1981sx" : "42:1981sx (42:1981 Sex Discrimination)",
      "42:1983cv" : "42:1983cv (42:1983 Civil Rights Act)",
      "42:1983ed" : "42:1983ed (42:1983 Civil Rights (Employment Discrimination))",
      "42:1983pr" : "42:1983pr (42:1983 Prisoner Civil Rights)",
      "42:1986" : "42:1986 (42:1986 Neglect of Duty)",
      "42:2000ag" : "42:2000ag (42:2000 Job Discrimination (Age))",
      "42:2000e" : "42:2000e (42:2000e Job Discrimination (Employment))",
      "42:2000pb" : "42:2000pb (42:2000 Job Discrimination (Public Accomodations))",
      "42:2000ra" : "42:2000ra (42:2000 Job Discrimination (Race))",
      "42:2000sh" : "42:2000sh (42:2000 Job Discrimination (Sexual Harassment))",
      "42:2000sx" : "42:2000sx (42:2000 Job Discrimination (Sex))",
      "42:2003" : "42:2003 (42:2003 Job Discrimination)",
      "42:2005" : "42:2005 (42:2005 Review of Agency Action-HHS)",
      "42:2651" : "42:2651 (42:2651 Medical Care Recovery)",
      "42:3601" : "42:3601 (42:405 Fair Housing Act)",
      "42:4000" : "42:4000 (42:4000 National Flood Insurance Act)",
      "42:4001" : "42:4001 (42:4001 National Insurance Flood Act)",
      "42:4053" : "42:4053 (42:4053 Breach of Insurance Contract)",
      "42:4072" : "42:4072 (42:4072 Payment of Flood Insurance Claim)",
      "42:4321" : "42:4321 (42:4321 Review of Agency Action-Environment)",
      "42:4332" : "42:4332 (42:4332 Environmental Policy - Coop of Agency Reports)",
      "42:6901en" : "42:6901en (42:6901 Environmental Cleanup Expenses)",
      "42:6901rs" : "42:6901rs (42:6901 Resource & Recovery Act)",
      "42:7413" : "42:7413 (42:7413(b) Clean Air Act)",
      "42:7604cl" : "42:7604cl (42:7604 Clear Air Act (Emission Standards))",
      "42:7604ir" : "42:7604ir (42:7604 Petition to Quash IRS Summons)",
      "42:9607" : "42:9607 (42:9607 Real Property Tort to Land)",
      "43:945" : "43:945 (43:945 Compensation for Land Condemnation)",
      "43:945a" : "43:945a (43:945a Complaint in Condemnation)",
      "43:946" : "43:946 (43:946 Complaint in Condemnation - Eminent Domain)",
      "45:0051" : "45:0051 (45:51 Railways: Fed. Employer's Liability Act)",
      "45:0151" : "45:0151 (45:151 Railway Labor Act)",
      "45:0184" : "45:0184 (45:184 Action to Set Aside Award of a System Board of Adjust)",
      "45:1395" : "45:1395 (45:1395 Railroads: Adverse Reimbursement Review)",
      "45:7457" : "45:7457 (45:7457 Compel Reclamation Under Clear Air Act)",
      "46:0688" : "46:0688 (46:688 Jones Act)",
      "46:0741" : "46:0741 (46:741 Shipping)",
      "46:0761" : "46:0761 (46:761 Shipping: Damages for Death on High Seas)",
      "46:1101" : "46:1101 (46:1101 Violation of Maritime Regulations)",
      "46:1156" : "46:1156 (46:1156 Administrative Procedure Act)",
      "48:0883" : "48:0883 (48:883 Violation of US Coastal Law)",
      "48:1985" : "48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)",
      "49:0081" : "49:0081 (49:81 Damaged Goods While Being Transported)",
      "49:0781" : "49:0781 (49:781 Forfeiture)",
      "49:11503" : "49:11503 (49:11503 Railroad Revitalization Regulatory Reform Act)",
      "49:11702" : "49:11702 (49:11702(a)(4) Violations of Interstate Commerce Act)",
      "49:1471" : "49:1471 (49:1471 Federal Aviation Act)",
      "49:1903" : "49:1903 (49:1903 Petition to enforce administrative summons)",
      "8:287" : "8:287 (8:287 Petition to Enforce INS Subpoena)",
      "MDL 1132" : "MDL 1132 (MDL 1132 Exterior Insulation Finish System (EIFS) Products Liability Litigation)",
      "MDL1014" : "MDL1014 (MDL 1014 Orthopedic Bone Screw Products Liability Litigation)",
      "MDL1038" : "MDL1038 (MDL 1038 Norplant Contraceptive Prod. Liability Litigation)",
      "MDL1048" : "MDL1048 (MDL 1048 Felbatol Products Liability Litigation)",
      "MDL1057" : "MDL1057 (MDL 1057 Telectronics Pacing Sys., Accufix Atrial J Leads)",
      "MDL1060" : "MDL1060 (MDL 1060 Baxter Healthcare Corp. Gammagard Prod. Liab. Lit.)",
      "MDL1061" : "MDL1061 (MDL 1061 Prudential Ins. Co. of America Sales Practices Lit.)",
      "MDL1203" : "MDL1203 (MDL 1203 Diet Drugs Products Liability Litigation)",
      "MDL1214" : "MDL1214 (MDL 1214 Great Southern Life Insurance Company Sales Practices Litigation)",
      "MDL1231" : "MDL1231 (MDL 1231 Tobacco Litigation)",
      "MDL1252" : "MDL1252 (MDL 1252 Multimedia Games, Inc., Securities Litigation)",
      "MDL1296" : "MDL1296 (MDL 1296 Alliance Equipment Lease Program Securities Litigation)",
      "MDL1348" : "MDL1348 (MDL 1348 Rezulin Products Liability Litigation)",
      "MDL1357" : "MDL1357 (MDL 1357 NOS Communications, Inc., Billing Practices Litigation)",
      "MDL1373" : "MDL1373 (MDL 1373 Bridgestone/Firestone, Inc., Tires Products Liability Litigation)",
      "MDL1382" : "MDL1382 (MDL 1382 Unitrin, Inc., Industrial Life Insurance Litigation)",
      "MDL1387" : "MDL1387 (MDL 1387 Protegen Sling and Vesica System Prod. Liab. Lit.)",
      "MDL1393" : "MDL1393 (MDL 1393 Cooper Tire & Rubber Co. Tires Products Liability Litigation)",
      "MDL1401" : "MDL1401 (MDL 1401 Sulzer Orthopedics Inc. Hip Prosthesis and Knee Prosthesis Products Liability Litigation)",
      "MDL1407" : "MDL1407 (MDL 1407 Phenylpropanolamine (PPA) Products Liability Litigation)",
      "MDL1431" : "MDL1431 (MDL 1431 Baycol Products Liability Litigation)",
      "MDL1446" : "MDL1446 (MDL 1446 Enron Corp. Securities, Derivative & \"ERISA\" Litigation)",
      "MDL1477" : "MDL1477 (MDL 1477 Serzone Products Liability Litigation)",
      "MDL1484" : "MDL1484 (MDL 1484 Merrill Lynch & Co., Inc., Research Reports Securities Litigation)",
      "MDL1487" : "MDL1487 (MDL 1487 Worldcom, Inc., Securities & \"ERISA\" Litigation)",
      "MDL1507" : "MDL1507 (MDL 1507 Prempro Products Liability Litigation)",
      "MDL1535" : "MDL1535 (MDL 1535 Welding Fume Products Liability Litigation)",
      "MDL1566" : "MDL1566 (MDL 1566 Western States Wholesale Natural Gas Antitrust Litigation)",
      "MDL1596" : "MDL1596 (MDL 1596 Zyprexa Products Liability Litigation)",
      "MDL1598" : "MDL1598 (MDL 1598 Ephedra Products Liability Litigation)",
      "MDL1626" : "MDL1626 (MDL 1626 Accutane (Isotretinoin) Products Liability Litigation)",
      "MDL1657" : "MDL1657 (MDL 1657 Vioxx Products Liability Litigation)",
      "MDL1699" : "MDL1699 (MDL 1699 Bextra and Celebrex Marketing, Sales Practices and Products Liability Litigation)",
      "MDL1708" : "MDL1708 (MDL 1708 Guidant Corp. Implantable Defibrillators Products Liability Litigation)",
      "MDL1726" : "MDL1726 (MDL 1726 Medtronic, Inc., Implantable Defibrillators Products Liability Litigation)",
      "MDL1742" : "MDL1742 (MDL 1742 Ortho Evra Products Liability Litigation)",
      "MDL1763" : "MDL1763 (MDL 1763 Human Tissue Products Liability Litigation)",
      "MDL1781" : "MDL1781 (MDL 1781 Cintas Corp. Overtime Pay Arbitration Litigation)",
      "MDL1789" : "MDL1789 (MDL 1789 Fosamax Products Liability Litigation)",
      "MDL1810" : "MDL1810 (MDL 1810 Merscorp Inc., Et Al., Real Estate Settlement Procedures Act (RESPA) Litigation)",
      "MDL1842" : "MDL1842 (MDL 1842 Kugel Mesh Hernia Patch Products Liability Litigation)",
      "MDL1845" : "MDL1845 (MDL 1845 Conagra Peanut Butter Products Liability Litigation)",
      "MDL1905" : "MDL1905 (MDL 1905 Medtronic, Inc., Sprint Fidelis Leads Products Liability Litigation)",
      "MDL1909" : "MDL1909 (MDL 1909 Gadolinium Contrast Dyes Products Liability Litigation)",
      "MDL1928" : "MDL1928 (MDL 1928 Trasylol Products Liability Litigation)",
      "MDL1957" : "MDL1957 (MDL 1957 Aftermarket Automotive Filters Antitrust Litigation)",
      "MDL1989" : "MDL1989 (MDL 1989 Semgroup Energy Partners, L.P., Securities Litigation)",
      "MDL1999" : "MDL1999 (MDL 1999 Lawnmower Engine Horsepower Marketing and Sales Practices Litigation (No.II))",
      "MDL2004" : "MDL2004 (MDL 2004 Mentor Corp. Obtape Transobturator Sling Products Liability Litigation)",
      "MDL2016" : "MDL2016 (MDL 2016 Yamaha Motor Corp. Rhino ATV Products Liability Litigation)",
      "MDL2048" : "MDL2048 (MDL 2048 Cox Enterprises, Inc., Set-Top Cable Television Box Antitrust Litigation)",
      "MDL2051" : "MDL2051 (MDL 2051 Denture Cream Products Liability Litigation)",
      "MDL2083" : "MDL2083 (MDL 2083 KBR, Inc., Burn Pit Litigation)",
      "MDL2100" : "MDL2100 (MDL 2100 Yasmin and Yaz (Drospirenone) Marketing, Sales Practices and Products Liability Litigation)",
      "MDL2165" : "MDL2165 (MDL 2165 Endangered Species Act Section 4 Deadline Litigation)",
      "MDL2197" : "MDL2197 (MDL 2197 Depuy Orthopaedics, Inc., ASR Hip Implant Products Liability Litigation)",
      "MDL2244" : "MDL2244 (MDL 2244 Depuy Orthopaedics, Inc., Pinnacle Hip Implant Products Liability Litigation)",
      "MDL2272" : "MDL2272 (MDL 2272 Zimmer Nexgen Knee Implant Products Liability Litigation)",
      "MDL2299" : "MDL2299 (MDL 2299 Actos Products Liability Litigation)",
      "MDL2325" : "MDL2325 (MDL 2325 American Medical Systems, Inc., Pelvic Repair System Products Liability Litigation)",
      "MDL2342" : "MDL2342 (MDL 2342 Zoloft (Sertraline Hydrochloride) Products Liability Litigation)",
      "MDL2391" : "MDL2391 (MDL 2391 Biomet M2A Magnum Hip Implant Products Liability Litigation)",
      "MDL2428" : "MDL2428 (MDL 2428 Fresenius Granuflo/Naturalyte Dialysate Products Liability Litigation)",
      "MDL2434" : "MDL2434 (MDL 2434 Mirena IUD Products Liability Litigation)",
      "MDL2441" : "MDL2441 (MDL 2441 Stryker Rejuvenate and ABG II Hip Implant Products Liability Litigation)",
      "MDL2522" : "MDL2522 (MDL 2522 Target Corporation Customer Data Security Breach Litigation)",
      "MDL2543" : "MDL2543 (MDL 2543 General Motors LLC Ignition Switch Litigation)",
      "MDL2570" : "MDL2570 (MDL 2570 Cook Medical, Inc., IVC Filters Marketing, Sales Practices and Products Liability Lit)",
      "MDL2592" : "MDL2592 (MDL 2592 Xarelto (Rivaroxaban) Products Liability Litigation)",
      "MDL2599" : "MDL2599 (MDL 2599 Takata Airbag Products Liability Litigation)",
      "MDL2600" : "MDL2600 (MDL 2600 Protegrity Corporation and Protegrity USA, Inc., Patent Litigation)",
      "MDL2605" : "MDL2605 (MDL 2605 Nutek Baby Wipes Products Liability Litigation)",
      "MDL2619" : "MDL2619 (MDL 2619 Herbal Supplements Marketing and Sales Practices Litigation)",
      "MDL2641" : "MDL2641 (MDL 2641 Bard IVC Filters Products Liability Litigation)",
      "MDL2656" : "MDL2656 (MDL 2656 Domestic Airline Travel Antitrust Litigation)",
      "MDL2672" : "MDL2672 (MDL 2672 Volkswagen \"Clean Diesel\" Marketing, Sales Practices and Products Liability Litig)",
      "MDL2677" : "MDL2677 (MDL 2677 Daily Fantasy Sports Litigation)",
      "MDL2700" : "MDL2700 (MDL 2700 Genentech Herceptin (Trastuzumab) Marketing and Sales Practices Litigation)",
      "MDL2709" : "MDL2709 (MDL 2709 Dollar General Corp. Motor Oil Marketing and Sales Practices Litigation)",
      "MDL2741" : "MDL2741 (Roundup Products Liability Litigation)",
      "MDL2782" : "MDL2782 (MDL 2782 Ethicon Physiomesh Flexible Composite Hernia Mesh Products Liability Litigation)",
      "MDL2789" : "MDL2789 (MDL 2789 Proton-Pump Inhibitor Products Liability Litigation (No. II))",
      "MDL2800" : "MDL2800 (MDL 2800 Equifax, Inc., Customer Data Security Breach Litigation)",
      "MDL2804" : "MDL2804 (MDL 2804 National Prescription Opiate Litigation)",
      "MDL2809" : "MDL2809 (MDL 2809 Onglyza (Saxagliptin) & Kimbiglyze XR (Saxagliptin & Metformin) Products Liability Lit.)",
      "MDL865" : "MDL865 (MDL 865 Showa Denko K.K. L-Tryptophan Prod. Liability Lit.)",
      "MDL875" : "MDL875 (MDL 875 Asbestos Products Liability Litigation)",
      "MDL899" : "MDL899 (MDL 899 Mortgage Escrow Deposit Litigation)",
      "MDL907" : "MDL907 (MDL 907 Eli Lilly & Co. Prozac Products Liability Litigation)",
      "MDL926" : "MDL926 (MDL 926 Silicone Gel Breast Implants Prod. Liability Lit.)",
      "admin" : "admin (Administrative)",
      "misc" : "misc (Civil Miscellaneous Case)"
   },
   "okwdce" : {
      "*41*" : "*41* ( )",
      "0" : "0 (No cause code entered)",
      "00:0000" : "00:0000 (00:0000 Cause Code Unknown)",
      "02:0431" : "02:0431 (02:431 Fed. Election Commission: Failure Enforce C)",
      "02:0437" : "02:0437 (02:437 Federal Election Commission)",
      "05:0075" : "05:0075 (05:75(2) Contract - Reduction in Grade)",
      "05:0551" : "05:0551 (05:551 Administrative Procedure Act)",
      "05:0552fi" : "05:0552fi (05:552 Freedom of Information Act)",
      "05:0552pa" : "05:0552pa (05:552 Right to Privacy Act)",
      "05:0554" : "05:0554 (05:0554 Constitutionality of Maritime Statutes)",
      "05:0701" : "05:0701 (05:0701 Maritime Subsidy Board)",
      "05:0702" : "05:0702 (05:702 Administrative Procedure Act)",
      "05:0704" : "05:0704 (05:704 Labor Litigation)",
      "05:7703" : "05:7703 (05:7703 Discrimination - Review of Agency Act)",
      "07:0006" : "07:0006 (7:6(b) Federal Commodity Exchange Regulation)",
      "07:0025" : "07:0025 (7:25 Fraud - Commodities Leverage Contracts)",
      "07:0181" : "07:0181 (07:181 Packers & Stockyard Act)",
      "07:0499" : "07:0499 (07:499 Agricultural Commodities Act)",
      "07:0601" : "07:0601 (07:601 USDA Condemnation)",
      "07:2321" : "07:2321 (07:2321 Plant Variety Protection Act)",
      "08:1105" : "08:1105 (8:1105(a) Aliens: Habeas Corpus to Release INS Det)",
      "08:1252" : "08:1252 (08:1252(a)(2) Injunction for Deportation)",
      "08:1260" : "08:1260 (08:1260 Aliens: Access to Records)",
      "08:1324" : "08:1324 (08:1324 Aliens: Complaint for Forfeiture)",
      "08:1329" : "08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petition)",
      "08:1446" : "08:1446 (8:1446 Petition for Naturalization Hearing)",
      "08:287" : "08:287 (08:287 Petition To Enforce INS Subpoena)",
      "09:0001" : "09:0001 (09:1 U.S. Arbitration Act)",
      "09:0009" : "09:0009 (9:9 Motion to Confirm Arbitration Loan)",
      "09:0010" : "09:0010 (09:0010 Petition to Vacate Arbitration Award)",
      "10:1552" : "10:1552 (10:1552 Armed Forces: Action to Correct Records)",
      "10:1553" : "10:1553 (10:1553 Armed Forces: FOIA General)",
      "10:2305" : "10:2305 (10:2305 Review of Federal Contract)",
      "11:0101" : "11:0101 (11:101 Bankruptcy)",
      "12:0022" : "12:0022 (12:22 Securities Fraud)",
      "12:0635" : "12:0635 (12:635 Breach of Insurance Contract)",
      "12:1461" : "12:1461 (12:1461 Homeowners Loan Act)",
      "12:1703" : "12:1703 (12:1703 Default of HUD Loan)",
      "12:1725" : "12:1725 (12:1725 Collection under Contract Guaranty)",
      "12:1730" : "12:1730 (12:1730 Collection Under Contract Guaranty)",
      "12:1819" : "12:1819 (12:1819 Default of Promissory Note)",
      "12:1821" : "12:1821 (12:1821 Default of Loan by Promissary Note)",
      "12:1971" : "12:1971 (12:1971 Relief under Bank Holding Act)",
      "12:3410" : "12:3410 (12:3410 Right to Financial Privacy Act)",
      "15:0001" : "15:0001 (15:1 Antitrust Litigation)",
      "15:0002at" : "15:0002at (15:2 Antitrust Litigation)",
      "15:0002fl" : "15:0002fl (15:2(a) Fair Labor Standards Act)",
      "15:0005" : "15:0005 (15:5(a) Fair Labor Standards Act)",
      "15:0015" : "15:0015 (15:15 Antitrust Litigation)",
      "15:0025" : "15:0025 (15:25 Clayton Act)",
      "15:0044" : "15:0044 (15:44 Trademark Infringement)",
      "15:0045" : "15:0045 (15:0045 Federal Trade Commission Act)",
      "15:0052" : "15:0052 (15:0052 Federal Trade Commission Act)",
      "15:0053" : "15:0053 (15:0053 Federal Trade Commission Act)",
      "15:0077" : "15:0077 (15:77 Securities Fraud)",
      "15:0078" : "15:0078 (15:78m(a) Securities Exchange Act)",
      "15:0631" : "15:0631 (15:631 Small Business Act)",
      "15:0717" : "15:0717 (15:717 Natural Gas Act)",
      "15:1051" : "15:1051 (15:1051 Trademark Infringement)",
      "15:1114" : "15:1114 (15:1114 Trademark Infringement)",
      "15:1121" : "15:1121 (15:1121 Trademark Infringement)",
      "15:1125" : "15:1125 (15:1125 Trademark Infringement (Lanham Act))",
      "15:1126" : "15:1126 (15:1126 Patent Infringement)",
      "15:1127" : "15:1127 (15:1127 Trademark Infringement)",
      "15:1601" : "15:1601 (15:1601 Truth in Lending)",
      "15:1640" : "15:1640 (15:1640 Truth in Lending)",
      "15:1681" : "15:1681 (15:1681 Fair Credit Reporting Act)",
      "15:1692" : "15:1692 (15:1692 Fair Debt Collection Act)",
      "15:1938" : "15:1938 (15:1938 Fair Labor Standards Act)",
      "15:1981" : "15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))",
      "15:1988" : "15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))",
      "15:1989" : "15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))",
      "15:2301" : "15:2301 (15:2301 Magnuson-Moss Warranty Act)",
      "15:2801" : "15:2801 (15:2801 Petroleum Marketing Practices Act)",
      "15:53(b)" : "15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equita)",
      "16:0668" : "16:0668 (16:668 Bald Eagle Protection Act)",
      "16:0703" : "16:0703 (16:703 Migratory Bird Act)",
      "16:1538" : "16:1538 (16:1538 Endangered Species Act)",
      "16:3371" : "16:3371 (16:3371 Wildlife Under the Lacey Act)",
      "16:3372" : "16:3372 (16:3372 Conservation: Complaint for Forfeiture)",
      "16:3373" : "16:3373 (16:3373 Appeal of Decision - DOI)",
      "16:3374" : "16:3374 (16:3374 Conservation: Complaint for Forfeiture)",
      "17:0101" : "17:0101 (17:101 Copyright Infringement)",
      "17:0501" : "17:0501 (17:501 Copyright Infringement)",
      "17:0504" : "17:0504 (17:504 Copyright Infringement)",
      "18:0241" : "18:0241 (18:241 Conspiracy Against Citizen Rights)",
      "18:1836a" : "18:1836a (18:1836(a) Injunction against Misappropriation of Trade Secrets)",
      "18:1836b" : "18:1836b (18:1836(b) Civil Action to Protect Trade Secrets)",
      "18:1961" : "18:1961 (18:1961 Racketeering (RICO) Act)",
      "18:1962" : "18:1962 (18:1962 Racketeering (RICO) Act)",
      "18:1964" : "18:1964 (18:1964 Racketeering (RICO) Act)",
      "18:4208" : "18:4208 (18:4208(B) Agency Action Review)",
      "19:1305" : "19:1305 (19:1305 Custom Duties:0Forfeiture-Immoral Articles)",
      "20:107" : "20:107 (20:107 OPERATION OF VENDING FACILITIES)",
      "20:1080" : "20:1080 (20:1080 Student Loan Recovery)",
      "20:1400" : "20:1400 (20:1400 Civil Rights of Handicapped Child)",
      "20:1401" : "20:1401 (20:1401 Education: Handicapped Child Act)",
      "21:0841" : "21:0841 (21:841 Forfeiture Property-Drugs)",
      "21:0881" : "21:0881 (21:881 Forfeiture Property-Drugs)",
      "21:0881a" : "21:0881a (21:881 Forfeiture Property - Aircraft)",
      "21:0881re" : "21:0881re (21:881 Forfeiture Property - Real Estate)",
      "23:0134" : "23:0134 (23:134 P.I.- Auto Negligence)",
      "23:1441" : "23:1441 (23:1441 Contract Real Estate)",
      "24:1000" : "24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)",
      "25:0640" : "25:0640 (25:640 Indian Tribal Rights)",
      "25:1901" : "25:1901 (25:1901 Indian Child Welfare Act)",
      "26:6212" : "26:6212 (26:6212 Injunctive Relief from IRS Lien)",
      "26:6213" : "26:6213 (26:6213 Injunctive Relief from IRS Lien)",
      "26:6502" : "26:6502 (26:6502 IRS:Enforcement of tax liens)",
      "26:6532" : "26:6532 (26:6532 IRS: Refund of Tax Penalty)",
      "26:6702" : "26:6702 (26:6702 IRS: Refund of Income Tax Penalty)",
      "26:6703" : "26:6703 (26:6703 IRS: Refund of Tax Penalty)",
      "26:7401" : "26:7401 (26:7401 IRS: Tax Liability)",
      "26:7402" : "26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)",
      "26:7403" : "26:7403 (26:7403 Suit to Enforce Federal Tax Lien)",
      "26:7422rt" : "26:7422rt (26:7422 IRS: Refund Taxes)",
      "26:7422rx" : "26:7422rx (26:7422 IRS: Refund Excise Tax)",
      "26:7426" : "26:7426 (26:7426 IRS: Wrongful Levy for Taxes)",
      "26:7429" : "26:7429 (26:7429 IRS: Tax Jeopardy Assessment)",
      "26:7609" : "26:7609 (26:7609 IRS: Petition to Quash IRS Summons)",
      "27:0185" : "27:0185 (27:185 Enforcement of Arbitration Award)",
      "28:0157c" : "28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)",
      "28:0157d" : "28:0157d (28:0157 Motion for Withdrawal of Reference)",
      "28:0158" : "28:0158 (28:0158 Notice of Appeal re Bankruptcy Matter (BA))",
      "28:0185" : "28:0185 (28:185 Suit to Compel Arbitration)",
      "28:0451" : "28:0451 (28:451 Employment Discrimination)",
      "28:0636" : "28:0636 (28:0636 Appeal from Magistrate's Order)",
      "28:0794" : "28:0794 (28:794 Rehabilitation Act)",
      "28:1001" : "28:1001 (28:1001 E.R.I.S.A.)",
      "28:1132" : "28:1132 (28:1132 E.R.I.S.A.)",
      "28:1330" : "28:1330 (28:1330 Breach of Contract)",
      "28:1331" : "28:1331 (28:1331 Fed. Question)",
      "28:1331al" : "28:1331al (28:1331 Fed. Question: Airline Crash)",
      "28:1331at" : "28:1331at (28:1331 Fed. Question: Anti-trust)",
      "28:1331au" : "28:1331au (28:1331 Fed. Question: Auto Negligence)",
      "28:1331b" : "28:1331b (28:1331 Federal Question: Bivens Act)",
      "28:1331bc" : "28:1331bc (28:1331 Fed. Question: Breach of Contract)",
      "28:1331ca" : "28:1331ca (28:1331 Fed Question: Fed Communications Act of 1)",
      "28:1331cm" : "28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)",
      "28:1331cv" : "28:1331cv (28:1331 Federal Question: Other Civil Rights)",
      "28:1331ed" : "28:1331ed (28:1331 Fed. Question: Employment Discrimination)",
      "28:1331es" : "28:1331es (28:1331 Enforcement of Administrative Subpoena)",
      "28:1331fl" : "28:1331fl (28:1331 Fed. Question: Fair Labor Standards)",
      "28:1331in" : "28:1331in (28:1331 Fed. Question: Insurance Contract)",
      "28:1331mm" : "28:1331mm (28:1331 Fed. Question: Medical Malpractice)",
      "28:1331pi" : "28:1331pi (28:1331 Fed. Question: Personal Injury)",
      "28:1331rd" : "28:1331rd (28:1331 Fed. Question: Review Agency Decision)",
      "28:1331rp" : "28:1331rp (28:1331(a) Fed. Question: Real Property)",
      "28:1331rr" : "28:1331rr (28:1331 Fed. Question: Railway Labor Act)",
      "28:1331sv" : "28:1331sv (28:1331 Fed. Question: Securities Violation)",
      "28:1331tr" : "28:1331tr (28:1331 Fed. Question: Trademark)",
      "28:1331tt" : "28:1331tt (28:1331 Fed. Question: Tort Action)",
      "28:1331v" : "28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendme)",
      "28:1331wl" : "28:1331wl (28:1331 Federal Question: EPA Waste Lien)",
      "28:1331wt" : "28:1331wt (28:1331 Fed. Question: Water Rights)",
      "28:1332ac" : "28:1332ac (28:1332 Diversity-Account Receivable)",
      "28:1332al" : "28:1332al (28:1332 Diversity-Airline Crash)",
      "28:1332as" : "28:1332as (28:1332 Diversity-Asbestos Litigation)",
      "28:1332au" : "28:1332au (28:1332 Diversity-Auto Negligence)",
      "28:1332bc" : "28:1332bc (28:1332 Diversity-Breach of Contract)",
      "28:1332co" : "28:1332co (28:1332 Diversity-Conversion)",
      "28:1332ct" : "28:1332ct (28:1332 Diversity-(Citizenship))",
      "28:1332det" : "28:1332det (28:1332 Diversity: Forcible Detainer)",
      "28:1332df" : "28:1332df (28:1332 Diversity-Contract Default)",
      "28:1332ds" : "28:1332ds (28:1332 Diversity-Contract Dispute)",
      "28:1332ed" : "28:1332ed (28:1332 Diversity-Employment Discrimination)",
      "28:1332fd" : "28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)",
      "28:1332fr" : "28:1332fr (28:1332 Diversity-Fraud)",
      "28:1332ia" : "28:1332ia (28:1332 Diversity-Interpleader Action)",
      "28:1332ij" : "28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)",
      "28:1332in" : "28:1332in (28:1332 Diversity-Insurance Contract)",
      "28:1332jd" : "28:1332jd (28:1332 Diversity-Declaratory Judgement)",
      "28:1332lb" : "28:1332lb (28:1332 Diversity-Libel,Assault,Slander)",
      "28:1332lm" : "28:1332lm (28:1332 Diversity - Legal Malpractice)",
      "28:1332ma" : "28:1332ma (28:1332 Diversity-Miller Act)",
      "28:1332mm" : "28:1332mm (28:1332 Diversity-Medical Malpractice)",
      "28:1332mv" : "28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)",
      "28:1332ni" : "28:1332ni (28:1332 Diversity-Negotiable Instrument)",
      "28:1332nm" : "28:1332nm (28:1332 Diversity-Non-Motor Vehicle)",
      "28:1332oc" : "28:1332oc (28:1332 Diversity-Other Contract)",
      "28:1332pd" : "28:1332pd (28:1332 Diversity-Property Damage)",
      "28:1332pi" : "28:1332pi (28:1332 Diversity-Personal Injury)",
      "28:1332pl" : "28:1332pl (28:1332 Diversity-Product Liability)",
      "28:1332pr" : "28:1332pr (28:1332 Diversity-Petition for Removal)",
      "28:1332qt" : "28:1332qt (28:1332 Diversity-Petition to Quiet Title)",
      "28:1332ri" : "28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)",
      "28:1332sa" : "28:1332sa (28:1332 - Diversity: Securities & Exchange Commiss)",
      "28:1332sf" : "28:1332sf (28:1332 - Diversity: Securities Fraud)",
      "28:1332ss" : "28:1332ss (28:1332 Diversity - Stockholders Suits)",
      "28:1332tl" : "28:1332tl (28:1332 Diversity-Torts to Land)",
      "28:1332tm" : "28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))",
      "28:1332tn" : "28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)",
      "28:1332wd" : "28:1332wd (28:1332 Diversity-Wrongful Death)",
      "28:1333" : "28:1333 (28:1333 Admiralty)",
      "28:1334" : "28:1334 (28:1334 Bankruptcy Appeal)",
      "28:1334c" : "28:1334c (28:1334(c) R&R re motions for abstention (non-cor)",
      "28:1335" : "28:1335 (28:1335 Interpleader Action)",
      "28:1337" : "28:1337 (28:1337 Sherman-Clayton Act)",
      "28:1338cp" : "28:1338cp (28:1338 Copyright Infringement)",
      "28:1338pt" : "28:1338pt (28:1338 Patent Infringement)",
      "28:1338tr" : "28:1338tr (28:1338 Trademark Infringement)",
      "28:1340" : "28:1340 (28:1340 IRS: Custom Duties)",
      "28:1340er" : "28:1340er (28:1340 Recovery of Erroneous Refund)",
      "28:1341" : "28:1341 (28:1341 Complaint for Forfeiture)",
      "28:1343" : "28:1343 (28:1343 Violation of Civil Rights)",
      "28:1345co" : "28:1345co (28:1345 Replevin & Conversion)",
      "28:1345db" : "28:1345db (28:1345 Debt to US - FHA/HUD Title I)",
      "28:1345df" : "28:1345df (28:1345 Default of Promissory Note)",
      "28:1345er" : "28:1345er (28:1345 Recovery of Erroneous Refund)",
      "28:1345fc" : "28:1345fc (28:1345 Foreclosure)",
      "28:1345ff" : "28:1345ff (28:1345 Complaint for Forfeiture)",
      "28:1345hl" : "28:1345hl (28:1345 VA Home Loan Guaranty Debt)",
      "28:1345mc" : "28:1345mc (28:1345 Medical Care Recovery)",
      "28:1345mi" : "28:1345mi (28:1345 Mining Claim Ejectment)",
      "28:1345pd" : "28:1345pd (28:1345 Property Damage)",
      "28:1345pe" : "28:1345pe (28:1345 Property Ejectment)",
      "28:1345rc" : "28:1345rc (28:1345 Recovery of Debt to US)",
      "28:1345st" : "28:1345st (28:1345 Default of Student Loan)",
      "28:1345tp" : "28:1345tp (28:1345 Trespass on Public Land)",
      "28:1345va" : "28:1345va (28:1345 Recovery of VA Overpayment)",
      "28:1346bc" : "28:1346bc (28:1346 Breach of Contract)",
      "28:1346rc" : "28:1346rc (28:1346 Recovery of IRS Tax)",
      "28:1346tc" : "28:1346tc (28:1346 Tort Claim)",
      "28:1346wd" : "28:1346wd (28:1346 Wrongful Death)",
      "28:1352" : "28:1352 (28:1352 Miller Act)",
      "28:1355" : "28:1355 (28:1355 Petition for Return of Property)",
      "28:1358" : "28:1358 (28:1358 Land Condemnation)",
      "28:1361" : "28:1361 (28:1361 Petition for Writ of Mandamus)",
      "28:1362ic" : "28:1362ic (28:1362 Indian Tribal Controversy)",
      "28:1362iw" : "28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)",
      "28:1364" : "28:1364 (28:1364 Auto Negligence)",
      "28:1391" : "28:1391 (28:1391 Personal Injury)",
      "28:1402" : "28:1402 (28:1402 Medical Malpractice)",
      "28:1407" : "28:1407 (28:1407 Airline Crash)",
      "28:1441ac" : "28:1441ac (28:1441 Petition for Removal- Account Receivable)",
      "28:1441al" : "28:1441al (28:1441 Petition for Removal- Airline Crash)",
      "28:1441as" : "28:1441as (28:1441 Petition for Removal- Asbestos Litigation)",
      "28:1441au" : "28:1441au (28:1441 Petition for Removal- Auto Negligence)",
      "28:1441bc" : "28:1441bc (28:1441 Petition for Removal- Breach of Contract)",
      "28:1441cv" : "28:1441cv (28:1441 Petition for Removal- Civil Rights Act)",
      "28:1441df" : "28:1441df (28:1441 Petition for Removal- Contract Default)",
      "28:1441dj" : "28:1441dj (28:1441 Petition for Removal- Declaratory Judgement)",
      "28:1441ds" : "28:1441ds (28:1441 Petition for Removal- Contract Dispute)",
      "28:1441ed" : "28:1441ed (28:1441 Petition for Removal - Employment Discrim)",
      "28:1441fc" : "28:1441fc (28:1441 Petition for Removal - Fair Credit Reporting)",
      "28:1441fr" : "28:1441fr (28:1441 Petition for Removal- Fraud)",
      "28:1441ij" : "28:1441ij (28:1441 Petition for Removal- Injunctive/Declarato)",
      "28:1441in" : "28:1441in (28:1441 Petition for Removal- Insurance Contract)",
      "28:1441int" : "28:1441int (28:1441 Petition for Removal- Action for Interplea)",
      "28:1441lb" : "28:1441lb (28:1441 Petition for Removal Libel,Assault,Slander)",
      "28:1441lm" : "28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relations)",
      "28:1441mm" : "28:1441mm (28:1441 Petition for Removal- Medical Malpractice)",
      "28:1441ni" : "28:1441ni (28:1441 Petition for Removal- Negotiable Instrumen)",
      "28:1441nm" : "28:1441nm (28:1441 Petition for Removal- Non-Motor Vehicle)",
      "28:1441oc" : "28:1441oc (28:1441 Petition For Removal--Other Contract)",
      "28:1441pd" : "28:1441pd (28:1441 Petition for Removal- Property Damage)",
      "28:1441pi" : "28:1441pi (28:1441 Petition for Removal- Personal Injury)",
      "28:1441pl" : "28:1441pl (28:1441 Petition for Removal- Product Liability)",
      "28:1441pr" : "28:1441pr (28:1441 Petition for Removal)",
      "28:1441qt" : "28:1441qt (28:1441 Petition for Removal- Petition to Quiet Title)",
      "28:1441ri" : "28:1441ri (28:1441 Petition for Removal- Racketeering (RICO))",
      "28:1441sa" : "28:1441sa (28:1441 - Petition for Removal: SEC Act)",
      "28:1441sf" : "28:1441sf (28:1441 - Petition for Removal: Securities Fraud)",
      "28:1441tl" : "28:1441tl (28:1441 Petition for Removal- Torts to Land)",
      "28:1441tm" : "28:1441tm (28:1441 Petition for Removal- Tort/Motor Vehicle)",
      "28:1441tn" : "28:1441tn (28:1441 Petition for Removal- Tort/Non-Motor Vehic)",
      "28:1441wd" : "28:1441wd (28:1441 Petition for Removal- Wrongful Death)",
      "28:1442bc" : "28:1442bc (28:1442 Petition for Removal- Breach of Contract)",
      "28:1442pr" : "28:1442pr (28:1442 Petition for Removal)",
      "28:1443" : "28:1443 (28:1443(1) Rent, Lease & Ejectment)",
      "28:1444" : "28:1444 (28:1444 Petition for Removal- Foreclosure)",
      "28:1446in" : "28:1446in (28:1446 Breach of Contract- Insurance)",
      "28:1446pd" : "28:1446pd (28:1446 Petition for Removal- Property Damage (P.I)",
      "28:1446pi" : "28:1446pi (28:1446 Petition for Removal- Personal Injury)",
      "28:1446pl" : "28:1446pl (28:1446pl Petition for Removal - Product Liability)",
      "28:1446pr" : "28:1446pr (28:1446 Petition for Removal)",
      "28:1452" : "28:1452 (28:1452 R&R re motions to remand (non-core))",
      "28:1651" : "28:1651 (28:1651 Petition for Writ of Coram Nobis)",
      "28:1651hc" : "28:1651hc (28:1651 Petition for Writ of Habeas Corpus)",
      "28:1651mn" : "28:1651mn (28:1651 Petition for Writ of Mandamus)",
      "28:1983" : "28:1983 (28:1983 Civil Rights)",
      "28:2201" : "28:2201 (28:2201 Constitutionality of State Statute(s))",
      "28:2201dj" : "28:2201dj (28:2201 Declaratory Judgement)",
      "28:2201ij" : "28:2201ij (28:2201 Injunction)",
      "28:2201in" : "28:2201in (28:2201 Declaratory Judgement (Insurance))",
      "28:2241" : "28:2241 (28:2241 Petition for Writ of Habeas Corpus (federal))",
      "28:2241s" : "28:2241s (28:2241 Petition for Writ of Habeas Corpus (state))",
      "28:2254" : "28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))",
      "28:2254se" : "28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)",
      "28:2255" : "28:2255 (28:2255 Motion to Vacate / Correct Illegal Sentence)",
      "28:2271" : "28:2271 (28:2271 Federal Tort Claims Act)",
      "28:2345" : "28:2345 (28:2345 Medicare Recovery)",
      "28:2409" : "28:2409 (28:2409(a) Quiet Title Action)",
      "28:2410" : "28:2410 (28:2410 Quiet Title)",
      "28:2671" : "28:2671 (28:2671 Federal Tort Claims Act)",
      "28:2674" : "28:2674 (28:2674 Federal Tort Claims Act)",
      "28:7402" : "28:7402 (28:7402 Refund of Taxes)",
      "28:7422" : "28:7422 (28:7422 Appeal from Administrative Decision)",
      "29:0151" : "29:0151 (29:151 Labor: Review of Agency Action)",
      "29:0160" : "29:0160 (29:160(1) National Labor Relations Act)",
      "29:0184" : "29:0184 (29:184 Violation Collection Bargain Agreement)",
      "29:0185ep" : "29:0185ep (29:185 Employee Pension Plan)",
      "29:0185lm" : "29:0185lm (29:185 Labor/Mgt. Relations (Contracts))",
      "29:0201do" : "29:0201do (29:201 Denial of Overtime Compensation)",
      "29:0201fl" : "29:0201fl (29:201 Fair Labor Standards Act)",
      "29:0203" : "29:0203 (29:203 Equal Pay Act)",
      "29:0206" : "29:0206 (29:206 Collect Unpaid Wages)",
      "29:0401" : "29:0401 (29:0401 Labor Management Disclosure Act)",
      "29:0621" : "29:0621 (29:621 Job Discrimination (Age))",
      "29:0623" : "29:0623 (29:623 Job Discrimination (Age))",
      "29:0626" : "29:0626 (29:626 Job Discrimination (Age))",
      "29:0633" : "29:0633 (29:633 Job Discrimination (Age))",
      "29:0651" : "29:0651 (29:651 Occupational Safety/Health)",
      "29:0754" : "29:0754 (29:754 Discrimination)",
      "29:0791" : "29:0791 (29:791 Job Discrimination (Rehabilitation Act))",
      "29:0794" : "29:0794 (29:0794 Job Discrimination (Handicap))",
      "29:1001" : "29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)",
      "29:1002" : "29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)",
      "29:1104" : "29:1104 (29:1104 Recovery of Benefits to Employee)",
      "29:1109" : "29:1109 (29:1109 Breach of Fiduciary Duties)",
      "29:1131" : "29:1131 (29:1131 ERISA - Collection of Delinquent Trust Fun)",
      "29:1132" : "29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)",
      "29:1145" : "29:1145 (29:1145 E.R.I.S.A.)",
      "29:1149" : "29:1149 (29:1149 Recover Pension & Profit Sharing)",
      "29:1337" : "29:1337 (29:1337 E.R.I.S.A.)",
      "29:1362" : "29:1362 (29:1362 ERISA)",
      "29:1381" : "29:1381 (29:1381 E.R.I.S.A.)",
      "29:1401" : "29:1401 (29:1401(b)(2) Appeal of Arbitration Award)",
      "29:1451" : "29:1451 (29:1451 E.R.I.S.A.)",
      "29:1801" : "29:1801 (29:1801 Farmworker Rights)",
      "29:2601" : "29:2601 (29:2601 Pursuant to the Family Leave Act)",
      "29:790" : "29:790 (29:790 Rehabilitation of Labor)",
      "30:0181" : "30:0181 (30:181 Environment: Review of Agency Action)",
      "30:0801" : "30:0801 (30:0801 Penalities/Federal Mine Safety Health Act)",
      "30:1201" : "30:1201 (30:1201 Environment: Review of Agency Action)",
      "30:1202" : "30:1202 (30:1202 Mining Reclamation Act)",
      "30:1276" : "30:1276 (30:1276 Interior: Review of Agency Action)",
      "31:3545" : "31:3545 (31:3545 Action to Recovery Money)",
      "31:3729" : "31:3729 (31:3729 False Claims Act)",
      "31:3730" : "31:3730 (31:3730 Qui Tam False Claim Act)",
      "31:3731" : "31:3731 (31:3731 Fraud)",
      "33:1319cw" : "33:1319cw (33:1319 Clean Water Act)",
      "33:1319pv" : "33:1319pv (33:1319 Pollutants & Permit Violations)",
      "33:1365" : "33:1365 (33:1365 Environmental Matters)",
      "35:0145" : "35:0145 (35:145 Patent Infringement)",
      "35:0183" : "35:0183 (35:183 Patent Infringement)",
      "35:0271" : "35:0271 (35:271 Patent Infringement)",
      "38:1681" : "38:1681 (38:1681 Recovery of VA Overpayment)",
      "38:1686" : "38:1686 (38:1686 Recovery of VA Overpayment)",
      "38:1780" : "38:1780 (38:1780 Recovery of VA Overpayment)",
      "38:2011" : "38:2011 (38:2011 - Veteran's Readjustment Assistance Act of)",
      "38:3116" : "38:3116 (38:3116 VA Overpayment)",
      "39:3005" : "39:3005 (39:3005 Detention of Mail for Temporary Periods)",
      "39:409" : "39:409 (39:409 Postal Service)",
      "40:0258" : "40:0258 (40:258(a) Public Buildings & Property: Land Condem)",
      "40:0875" : "40:0875 (40:875 Public Buildings & Property: Negligence)",
      "40:3131" : "40:3131 (40:3131 Miller Act)",
      "41:0251" : "41:0251 (41:251 Public Contracts-Review of Agency Action)",
      "41:1463" : "41:1463 (41:1463 Public Contracts: Unlawful Employment Prac)",
      "42:0205" : "42:0205 (42:205 Denial Social Security Benefits)",
      "42:0206" : "42:0206 (42:206 Social Security Benefits)",
      "42:0247" : "42:0247 (42:247 Personal Injury-Swine Flu)",
      "42:0402" : "42:0402 (42:402 Social Security Benefits)",
      "42:0405id" : "42:0405id (42:405 Review of HHS Decision (SSID))",
      "42:0405wc" : "42:0405wc (42:405 Review of HHS Decision (DIWC))",
      "42:0405ww" : "42:0405ww (42:405 Review of HHS Decision (DIWW))",
      "42:0416" : "42:0416 (42:416 Denial of Social Security Benefits)",
      "42:0427" : "42:0427 (42:427 Social Security Benefits)",
      "42:1383" : "42:1383 (42:1383 Review of HHS Decision)",
      "42:1395" : "42:1395 (42:1395 HHS: Adverse Reimbursement Review)",
      "42:1396" : "42:1396 (42:1396 - Tort Negligence)",
      "42:1471" : "42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclo)",
      "42:1981cv" : "42:1981cv (42:1981 Civil Rights)",
      "42:1981hs" : "42:1981hs (42:1981 Housing Discrimination)",
      "42:1981jb" : "42:1981jb (42:1981 Job Discrimination (Race))",
      "42:1981sx" : "42:1981sx (42:1981 Sex Discrimination)",
      "42:1983cv" : "42:1983cv (42:1983 Civil Rights Act)",
      "42:1983ed" : "42:1983ed (42:1983 Civil Rights (Employment Discrimination))",
      "42:1983pr" : "42:1983pr (42:1983 Prisoner Civil Rights)",
      "42:1986" : "42:1986 (42:1986 Neglect of Duty)",
      "42:2000ag" : "42:2000ag (42:2000 Job Discrimination (Age))",
      "42:2000e" : "42:2000e (42:2000e Job Discrimination (Employment))",
      "42:2000pb" : "42:2000pb (42:2000 Job Discrimination (Public Accomodations))",
      "42:2000ra" : "42:2000ra (42:2000 Job Discrimination (Race))",
      "42:2000sx" : "42:2000sx (42:2000 Job Discrimination (Sex))",
      "42:2003" : "42:2003 (42:2003 Job Discrimination)",
      "42:2005" : "42:2005 (42:2005 Review of Agency Action-HHS)",
      "42:2651" : "42:2651 (42:2651 Medical Care Recovery)",
      "42:294" : "42:294 (Default In A Health Education Assistance Loan (HEAL))",
      "42:3601" : "42:3601 (42:405 Fair Housing Act)",
      "42:4000" : "42:4000 (42:4000 National Flood Insurance Act)",
      "42:4001" : "42:4001 (42:4001 National Insurance Flood Act)",
      "42:4053" : "42:4053 (42:4053 Breach of Insurance Contract)",
      "42:4072" : "42:4072 (42:4072 Payment of Flood Insurance Claim)",
      "42:4321" : "42:4321 (42:4321 Review of Agency Action-Environment)",
      "42:4332" : "42:4332 (42:4332 Environmental Policy - Coop of Agency Repo)",
      "42:6901en" : "42:6901en (42:6901 Environmental Cleanup Expenses)",
      "42:6901rs" : "42:6901rs (42:6901 Resource & Recovery Act)",
      "42:7413" : "42:7413 (42:7413(b) Clean Air Act)",
      "42:7604cl" : "42:7604cl (42:7604 Clean Air Act (Emission Standards))",
      "42:7604ir" : "42:7604ir (42:7604 Petition to Quash IRS Summons)",
      "42:9607" : "42:9607 (42:9607 Real Property Tort to Land)",
      "43:945" : "43:945 (43:945 Compensation for Land Condemnation)",
      "43:945a" : "43:945a (43:945a Complaint in Condemnation)",
      "43:946" : "43:946 (43:946 Complaint in Condemnation - Eminent Domain)",
      "45:0051" : "45:0051 (45:51 Railways: Fed. Employer's Liability Act)",
      "45:0151" : "45:0151 (45:151 Railway Labor Act)",
      "45:0184" : "45:0184 (45:184 Action to Set Aside Award of a System Board)",
      "45:1395" : "45:1395 (45:1395 Railroads: Adverse Reimbursement Review)",
      "45:7457" : "45:7457 (45:7457 Compel Reclamation Under Clear Air Act)",
      "46:0688" : "46:0688 (46:688 Jones Act)",
      "46:0741" : "46:0741 (46:741 Shipping)",
      "46:0761" : "46:0761 (46:761 Shipping: Damages for Death on High Seas)",
      "46:1101" : "46:1101 (46:1101 Violation of Maritime Regulations)",
      "46:1156" : "46:1156 (46:1156 Administrative Procedure Act)",
      "48:0883" : "48:0883 (48:883 Violation of US Coastal Law)",
      "48:1985" : "48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)",
      "49:0081" : "49:0081 (49:81 Damaged Goods While Being Transported)",
      "49:0781" : "49:0781 (49:781 Forfeiture)",
      "49:11503" : "49:11503 (49:11503 Railroad Revitalization Regulatory Reform)",
      "49:11702" : "49:11702 (49:11702(a)(4) Violations of Interstate Commerce A)",
      "49:1471" : "49:1471 (49:1471 Federal Aviation Act)",
      "49:1903" : "49:1903 (49:1903 Petition to enforce administrative summon)",
      "8:287" : "8:287 (8:287 Petition to Enforce INS Subpoena)",
      "md" : "md (Probation Transfer Case)",
      "misc" : "misc (Civil Miscellaneous Case)"
   },
   "ordce" : {
      "00:0000" : "00:0000 (00:0000 Cause Code Unknown)",
      "02:0431" : "02:0431 (02:431 Fed. Election Commission: Failure Enforce C)",
      "02:0437" : "02:0437 (02:437 Federal Election Commission)",
      "05:0075" : "05:0075 (05:75(2) Contract - Reduction in Grade)",
      "05:0551" : "05:0551 (05:551 Administrative Procedure Act)",
      "05:0552(b)" : "05:0552(b) (05:0552(b) Sunshine Act )",
      "05:0552fi" : "05:0552fi (05:552 Freedom of Information Act)",
      "05:0552pa" : "05:0552pa (05:552 Right to Privacy Act)",
      "05:0554" : "05:0554 (05:0554 Constitutionality of Maritime Statutes)",
      "05:0701" : "05:0701 (05:0701 Maritime Subsidy Board)",
      "05:0702" : "05:0702 (05:702 Administrative Procedure Act)",
      "05:0704" : "05:0704 (05:704 Labor Litigation)",
      "05:0706" : "05:0706 (5:706 Administrative Procedures Act(Judicial Review))",
      "05:7703" : "05:7703 (05:7703 Discrimination - Review of Agency Act)",
      "07:0006" : "07:0006 (7:6(b) Federal Commodity Exchange Regulation)",
      "07:0025" : "07:0025 (7:25 Fraud - Commodities Leverage Contracts)",
      "07:0181" : "07:0181 (07:181 Packers & Stockyard Act)",
      "07:0499" : "07:0499 (07:499 Agricultural Commodities Act)",
      "07:0601" : "07:0601 (07:601 USDA Condemnation)",
      "07:0608" : "07:0608 (Agricultural Adjustment Act )",
      "07:0610" : "07:0610 (7:610(h) Agricultural Marketing Service Subpoena )",
      "07:1501" : "07:1501 (7:1501 Federal Crop Insurance Act )",
      "07:2011" : "07:2011 (7:2011 Food Stamp Act )",
      "07:2321" : "07:2321 (07:2321 Plant Variety Protection Act)",
      "08:0287" : "08:0287 (Petition to Enforce INS Subpoena)",
      "08:1105" : "08:1105 (8:1105(a) Aliens: Habeas Corpus to Release INS Det)",
      "08:1182" : "08:1182 (08:1182 Immigration & Nationality Act of 1990)",
      "08:1183" : "08:1183 (08:1182a Enforcement of an Affidavit of Support)",
      "08:1252" : "08:1252 (08:1252(a)(2) Injunction for Deportation)",
      "08:1260" : "08:1260 (08:1260 Aliens: Access to Records)",
      "08:1324" : "08:1324 (08:1324 Aliens: Complaint for Forfeiture)",
      "08:1329" : "08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petiti)",
      "08:1373" : "08:1373 (8 U.S. Code Â§ 1373 - Communication between Gov't. agencies and the INS)",
      "08:1421" : "08:1421 (08:1421 Immigration & Nationality Act - Review of Denial of Application)",
      "08:1446" : "08:1446 (8:1446 Petition for Naturalization Hearing)",
      "08:1447" : "08:1447 (8:1447 Hearings on Denials of Applications for Naturalization)",
      "08:1451" : "08:1451 (08:1451 Revocation of Naturalization)",
      "08:1503" : "08:1503 (08:1503 Denial of Rights and Privileges as National)",
      "08:1644" : "08:1644 (8 U.S. Code Â§ 1644 - Communication between State and local gov't agencies and INS)",
      "09:0001" : "09:0001 (09:1 U.S. Arbitration Act)",
      "09:0009" : "09:0009 (9:9 Motion to Confirm Arbitration Award)",
      "09:0010" : "09:0010 (09:0010 Petition to Vacate Arbitration Award)",
      "10:1552" : "10:1552 (10:1552 Armed Forces: Action to Correct Records)",
      "10:1553" : "10:1553 (10:1553 Armed Forces: FOIA General)",
      "10:2305" : "10:2305 (10:2305 Review of Federal Contract)",
      "11:0101" : "11:0101 (11:101 Bankruptcy)",
      "11:0110" : "11:0110 (11:0110 Bankruptcy Petition Preparer Section )",
      "11:0542" : "11:0542 (11:0542 Turnover of Property to the Estate)",
      "12:0022" : "12:0022 (12:22 Securities Fraud)",
      "12:0635" : "12:0635 (12:635 Breach of Insurance Contract)",
      "12:1441" : "12:1441 (12:1441 Home Owners' Loan Act of 1933 )",
      "12:1461" : "12:1461 (12:1461 Homeowners Loan Act)",
      "12:1701" : "12:1701 (12:1701 National Housing Act of 1934 )",
      "12:1703" : "12:1703 (12:1703 Default of HUD Loan)",
      "12:1725" : "12:1725 (12:1725 Collection under Contract Guaranty)",
      "12:1730" : "12:1730 (12:1730 Collection Under Contract Guaranty)",
      "12:1819" : "12:1819 (12:1819 Default of Promissory Note)",
      "12:1821" : "12:1821 (12:1821 Default of Loan by Promissary Note)",
      "12:1971" : "12:1971 (12:1971 Relief under Bank Holding Act)",
      "12:2001" : "12:2001 (12:2001 Farm Credit Act of 1971 )",
      "12:2201" : "12:2201 (Agricultural Credit Act of 1987 )",
      "12:2605" : "12:2605 (12:2605 Real Estate Settlement Procedures Act )",
      "12:3410" : "12:3410 (12:3410 Right to Financial Privacy Act)",
      "15:0001" : "15:0001 (15:1 Antitrust Litigation)",
      "15:0002at" : "15:0002at (15:2 Antitrust Litigation)",
      "15:0002fl" : "15:0002fl (15:2(a) Fair Labor Standards Act)",
      "15:0005" : "15:0005 (15:5(a) Fair Labor Standards Act)",
      "15:0015" : "15:0015 (15:15 Antitrust Litigation)",
      "15:0025" : "15:0025 (15:25 Clayton Act)",
      "15:0044" : "15:0044 (15:44 Trademark Infringement)",
      "15:0045" : "15:0045 (15:0045 Federal Trade Commission Act)",
      "15:0052" : "15:0052 (15:0052 Federal Trade Commission Act)",
      "15:0053" : "15:0053 (15:0053 Federal Trade Commission Act)",
      "15:0077" : "15:0077 (15:77 Securities Fraud)",
      "15:0078" : "15:0078 (15:78m(a) Securities Exchange Act)",
      "15:0631" : "15:0631 (15:631 Small Business Act)",
      "15:0717" : "15:0717 (15:717 Natural Gas Act)",
      "15:1051" : "15:1051 (15:1051 Trademark Infringement)",
      "15:1114" : "15:1114 (15:1114 Trademark Infringement)",
      "15:1121" : "15:1121 (15:1121 Trademark Infringement)",
      "15:1125" : "15:1125 (15:1125 Trademark Infringement (Lanham Act))",
      "15:1126" : "15:1126 (15:1126 Patent Infringement)",
      "15:1127" : "15:1127 (15:1127 Trademark Infringement)",
      "15:1221" : "15:1221 (15:1221 Automobile Dealers Day-in-Court Act )",
      "15:1261" : "15:1261 (15:1261 Federal Hazardous Substance Act)",
      "15:1601" : "15:1601 (15:1601 Truth in Lending)",
      "15:1640" : "15:1640 (15:1640 Truth in Lending)",
      "15:1681" : "15:1681 (15:1681 Fair Credit Reporting Act)",
      "15:1692" : "15:1692 (15:1692 Fair Debt Collection Act)",
      "15:1693e" : "15:1693e (15:1693e Preauthorized transfers)",
      "15:1938" : "15:1938 (15:1938 Fair Labor Standards Act)",
      "15:1981" : "15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))",
      "15:1988" : "15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))",
      "15:1989" : "15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))",
      "15:2301" : "15:2301 (15:2301 Magnuson-Moss Warranty Act)",
      "15:2801" : "15:2801 (15:2801 Petroleum Marketing Practices Act)",
      "15:53(b)" : "15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equitable Relief)",
      "16:0460" : "16:0460 (Hells Canyon National Recreation Area Act)",
      "16:0470" : "16:0470 (National Historic Preservation Act )",
      "16:0544" : "16:0544 (16:0544 Columbia River Gorge National Scenic Area Act )",
      "16:0618" : "16:0618 (16:0618 Federal Timber Contract Payment Modification Act )",
      "16:0668" : "16:0668 (16:668 Bald Eagle Protection Act)",
      "16:0703" : "16:0703 (16:703 Migratory Bird Act)",
      "16:1531" : "16:1531 (16:1531 Endangered Species Act )",
      "16:1538" : "16:1538 (16:1538 Endangered Species Act)",
      "16:1600" : "16:1600 (National Forest Management Act)",
      "16:3371" : "16:3371 (16:3371 Wildlife Under the Lacey Act)",
      "16:3372" : "16:3372 (16:3372 Conservation: Complaint for Forfeiture)",
      "16:3373" : "16:3373 (16:3373 Appeal of Decision - DOI)",
      "16:3374" : "16:3374 (16:3374 Conservation: Complaint for Forfeiture)",
      "17:0101" : "17:0101 (17:101 Copyright Infringement)",
      "17:0501" : "17:0501 (17:501 Copyright Infringement)",
      "17:0504" : "17:0504 (17:504 Copyright Infringement)",
      "18:0241" : "18:0241 (18:241 Conspiracy Against Citizen Rights)",
      "18:0709" : "18:0709 (18:709 False Advertising or Misuse of Names)",
      "18:0923" : "18:0923 (18:923 Petition Judicial Review, Firearm Licensing Violation)",
      "18:0981" : "18:0981 (18:981 Civil Forfeiture)",
      "18:1030" : "18:1030 (18:1030(g) Fraud and Related Activity in Connection with Computers)",
      "18:1595" : "18:1595 (18:1595 Civil Remedy Victims of Trafficking and Violence Protection Act of 2000)",
      "18:1836a" : "18:1836a (18:1836(a) Injunction against Misappropriation of Trade Secrets)",
      "18:1836b" : "18:1836b (18:1836(b) Civil Action to Protect Trade Secrets)",
      "18:1961" : "18:1961 (18:1961 Racketeering (RICO) Act)",
      "18:1962" : "18:1962 (18:1962 Racketeering (RICO) Act)",
      "18:1964" : "18:1964 (18:1964 Racketeering (RICO) Act)",
      "18:1965" : "18:1965 (18:1965 (RICO))",
      "18:3663" : "18:3663 (18:3663(h) Enforce Order of Restitution )",
      "18:4208" : "18:4208 (18:4208(B) Agency Action Review)",
      "19:1305" : "19:1305 (19:1305 Custom Duties: Forfeiture-Immoral Articles)",
      "20:1080" : "20:1080 (20:1080 Student Loan Recovery)",
      "20:1400" : "20:1400 (20:1400 Civil Rights of Handicapped Child)",
      "20:1401" : "20:1401 (20:1401 Education: Handicapped Child Act)",
      "21:0331" : "21:0331 (Food, Drug, & Cosmetics Act )",
      "21:0332" : "21:0332 (Federal Food Drug & Cosmetic Act)",
      "21:0334" : "21:0334 (Food Drug and Cosmetics Act)",
      "21:0801" : "21:0801 (21:801 Drug Abuse Prevention & Control )",
      "21:0841" : "21:0841 (21:841 Forfeiture Property-Drugs)",
      "21:0881" : "21:0881 (21:881 Forfeiture Property-Drugs)",
      "21:0881a" : "21:0881a (21:881 Forfeiture Property - Aircraft)",
      "21:0881re" : "21:0881re (21:881 Forfeiture Property - Real Estate)",
      "22:6021cu" : "22:6021cu (Cuban Liberty & Democratic Solidarity Act of 1996 )",
      "23:0134" : "23:0134 (23:134 P.I.- Auto Negligence)",
      "23:1441" : "23:1441 (23:1441 Contract Real Estate)",
      "24:1000" : "24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)",
      "25:0640" : "25:0640 (25:640 Indian Tribal Rights)",
      "25:1303" : "25:1303 (Indian Habeas Corpus )",
      "25:1901" : "25:1901 (25:1901 Indian Child Welfare Act)",
      "25:7601" : "25:7601 (Indian Gaming Regulatory Act )",
      "26:3101" : "26:3101 (26:3101 Federal Insurance Contributions Act)",
      "26:5041" : "26:5041 (26:5041 Imposition of Tax - Credit for Small Domestic Producers)",
      "26:6212" : "26:6212 (26:6212 Injunctive Relief from IRS Lien)",
      "26:6213" : "26:6213 (26:6213 Injunctive Relief from IRS Lien)",
      "26:6330" : "26:6330 (26:6330 Seizure of Property for Collection of Taxes - Due Process)",
      "26:6331" : "26:6331 (26:6331 Seizure of Property for Collection of Taxes- Levy)",
      "26:6502" : "26:6502 (26:6502 IRS:Enforcement of tax liens)",
      "26:6532" : "26:6532 (26:6532 IRS: Refund of Tax Penalty)",
      "26:6702" : "26:6702 (26:6702 IRS: Refund of Income Tax Penalty)",
      "26:6703" : "26:6703 (26:6703 IRS: Refund of Tax Penalty)",
      "26:7401" : "26:7401 (26:7401 IRS: Tax Liability)",
      "26:7402" : "26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)",
      "26:7403" : "26:7403 (26:7403 Suit to Enforce Federal Tax Lien)",
      "26:7422rt" : "26:7422rt (26:7422 IRS: Refund Taxes)",
      "26:7422rx" : "26:7422rx (26:7422 IRS: Refund Excise Tax)",
      "26:7426" : "26:7426 (26:7426 IRS: Wrongful Levy for Taxes)",
      "26:7429" : "26:7429 (26:7429 IRS: Tax Jeopardy Assessment)",
      "26:7609" : "26:7609 (26:7609 IRS: Petition to Quash IRS Summons)",
      "27:0185" : "27:0185 (27:185 Enforcement of Arbitration Award)",
      "28:0157c" : "28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)",
      "28:0157d" : "28:0157d (28:0157 Motion for Withdrawal of Reference)",
      "28:0158" : "28:0158 (28:0158 Notice of Appeal re Bankruptcy Matter (BA)",
      "28:0185" : "28:0185 (28:185 Suit to Compel Arbitration)",
      "28:0451" : "28:0451 (28:451 Employment Discrimination)",
      "28:0754" : "28:0754 (28:754 Receiver of Property in Different District )",
      "28:0794" : "28:0794 (28:794 Rehabilitation Act)",
      "28:1001" : "28:1001 (28:1001 E.R.I.S.A.)",
      "28:1132" : "28:1132 (28:1132 E.R.I.S.A.)",
      "28:1330" : "28:1330 (28:1330 Breach of Contract)",
      "28:1331" : "28:1331 (28:1331 Fed. Question)",
      "28:1331al" : "28:1331al (28:1331 Fed. Question: Airline Crash)",
      "28:1331at" : "28:1331at (28:1331 Fed. Question: Anti-trust)",
      "28:1331au" : "28:1331au (28:1331 Fed. Question: Auto Negligence)",
      "28:1331b" : "28:1331b (28:1331 Federal Question: Bivens Act)",
      "28:1331bc" : "28:1331bc (28:1331 Fed. Question: Breach of Contract)",
      "28:1331ca" : "28:1331ca (28:1331 Fed Question: Fed Communications Act of 1)",
      "28:1331cm" : "28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)",
      "28:1331cv" : "28:1331cv (28:1331 Federal Question: Other Civil Rights)",
      "28:1331ed" : "28:1331ed (28:1331 Fed. Question: Employment Discrimination)",
      "28:1331epa" : "28:1331epa (28:1331 Federal Question - Environmental Action Under CERCLA)",
      "28:1331es" : "28:1331es (28:1331 Enforcement of Administrative Subpoena)",
      "28:1331fl" : "28:1331fl (28:1331 Fed. Question: Fair Labor Standards)",
      "28:1331in" : "28:1331in (28:1331 Fed. Question: Insurance Contract)",
      "28:1331mm" : "28:1331mm (28:1331 Fed. Question: Medical Malpractice)",
      "28:1331pi" : "28:1331pi (28:1331 Fed. Question: Personal Injury)",
      "28:1331rd" : "28:1331rd (28:1331 Fed. Question: Review Agency Decision)",
      "28:1331rp" : "28:1331rp (28:1331(a) Fed. Question: Real Property)",
      "28:1331rr" : "28:1331rr (28:1331 Fed. Question: Railway Labor Act)",
      "28:1331sv" : "28:1331sv (28:1331 Fed. Question: Securities Violation)",
      "28:1331tr" : "28:1331tr (28:1331 Fed. Question: Trademark)",
      "28:1331tt" : "28:1331tt (28:1331 Fed. Question: Tort Action)",
      "28:1331v" : "28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendme)",
      "28:1331wl" : "28:1331wl (28:1331 Federal Question: EPA Waste Lien)",
      "28:1331wt" : "28:1331wt (28:1331 Fed. Question: Water Rights)",
      "28:1332ac" : "28:1332ac (28:1332 Diversity-Account Receivable)",
      "28:1332al" : "28:1332al (28:1332 Diversity-Airline Crash)",
      "28:1332as" : "28:1332as (28:1332 Diversity-Asbestos Litigation)",
      "28:1332au" : "28:1332au (28:1332 Diversity-Auto Negligence)",
      "28:1332bc" : "28:1332bc (28:1332 Diversity-Breach of Contract)",
      "28:1332cl" : "28:1332cl (28:1332cl Class Action Fairness Action - 2005)",
      "28:1332co" : "28:1332co (28:1332 Diversity-Conversion)",
      "28:1332ct" : "28:1332ct (28:1332 Diversity-(Citizenship))",
      "28:1332det" : "28:1332det (28:1332 Diversity: Forcible Detainer)",
      "28:1332df" : "28:1332df (28:1332 Diversity-Contract Default)",
      "28:1332ds" : "28:1332ds (28:1332 Diversity-Contract Dispute)",
      "28:1332ed" : "28:1332ed (28:1332 Diversity-Employment Discrimination)",
      "28:1332fd" : "28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)",
      "28:1332fr" : "28:1332fr (28:1332 Diversity-Fraud)",
      "28:1332ia" : "28:1332ia (28:1332 Diversity-Interpleader Action)",
      "28:1332ij" : "28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)",
      "28:1332in" : "28:1332in (28:1332 Diversity-Insurance Contract)",
      "28:1332jd" : "28:1332jd (28:1332 Diversity-Declaratory Judgment)",
      "28:1332lb" : "28:1332lb (28:1332 Diversity-Libel,Assault,Slander)",
      "28:1332lm" : "28:1332lm (28:1332 Diversity - Legal Malpractice)",
      "28:1332ma" : "28:1332ma (28:1332 Diversity-Miller Act)",
      "28:1332mm" : "28:1332mm (28:1332 Diversity-Medical Malpractice)",
      "28:1332mv" : "28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)",
      "28:1332ni" : "28:1332ni (28:1332 Diversity-Negotiable Instrument)",
      "28:1332nm" : "28:1332nm (28:1332 Diversity-Non-Motor Vehicle)",
      "28:1332oc" : "28:1332oc (28:1332 Diversity-Other Contract)",
      "28:1332pd" : "28:1332pd (28:1332 Diversity-Property Damage)",
      "28:1332pi" : "28:1332pi (28:1332 Diversity-Personal Injury)",
      "28:1332pl" : "28:1332pl (28:1332 Diversity-Product Liability)",
      "28:1332pr" : "28:1332pr (28:1332 Diversity-Petition for Removal)",
      "28:1332qt" : "28:1332qt (28:1332 Diversity-Petition to Quiet Title)",
      "28:1332ri" : "28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)",
      "28:1332sa" : "28:1332sa (28:1332 - Diversity: Securities & Exchange Commiss)",
      "28:1332sf" : "28:1332sf (28:1332 - Diversity: Securities Fraud)",
      "28:1332ss" : "28:1332ss (28:1332 Diversity - Stockholders Suits)",
      "28:1332tl" : "28:1332tl (28:1332 Diversity-Torts to Land)",
      "28:1332tm" : "28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))",
      "28:1332tn" : "28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)",
      "28:1332wd" : "28:1332wd (28:1332 Diversity-Wrongful Death)",
      "28:1333" : "28:1333 (28:1333 Admiralty)",
      "28:1334" : "28:1334 (28:1334 Bankruptcy Appeal)",
      "28:1334c" : "28:1334c (28:1334(c) R&R re motions for abstention (non-cor)",
      "28:1335" : "28:1335 (28:1335 Interpleader Action)",
      "28:1337" : "28:1337 (28:1337 Sherman-Clayton Act)",
      "28:1338cp" : "28:1338cp (28:1338 Copyright Infringement)",
      "28:1338pt" : "28:1338pt (28:1338 Patent Infringement)",
      "28:1338tr" : "28:1338tr (28:1338 Trademark Infringement)",
      "28:1340" : "28:1340 (28:1340 IRS: Custom Duties)",
      "28:1340er" : "28:1340er (28:1340 Recovery of Erroneous Refund)",
      "28:1341" : "28:1341 (28:1341 Complaint for Forfeiture)",
      "28:1343" : "28:1343 (28:1343 Violation of Civil Rights)",
      "28:1345co" : "28:1345co (28:1345 Replevin & Conversion)",
      "28:1345db" : "28:1345db (28:1345 Debt to US - FHA/HUD Title I)",
      "28:1345df" : "28:1345df (28:1345 Default of Promissory Note)",
      "28:1345er" : "28:1345er (28:1345 Recovery of Erroneous Refund)",
      "28:1345fc" : "28:1345fc (28:1345 Foreclosure)",
      "28:1345ff" : "28:1345ff (28:1345 Complaint for Forfeiture)",
      "28:1345hl" : "28:1345hl (28:1345 VA Home Loan Guaranty Debt)",
      "28:1345mc" : "28:1345mc (28:1345 Medical Care Recovery)",
      "28:1345mi" : "28:1345mi (28:1345 Mining Claim Ejectment)",
      "28:1345o" : "28:1345o (28:1345 Other )",
      "28:1345pd" : "28:1345pd (28:1345 Property Damage)",
      "28:1345pe" : "28:1345pe (28:1345 Property Ejectment)",
      "28:1345rc" : "28:1345rc (28:1345 Recovery of Debt to US)",
      "28:1345st" : "28:1345st (28:1345 Default of Student Loan)",
      "28:1345tp" : "28:1345tp (28:1345 Trespass on Public Land)",
      "28:1345va" : "28:1345va (28:1345 Recovery of VA Overpayment)",
      "28:1346bc" : "28:1346bc (28:1346 Breach of Contract)",
      "28:1346o" : "28:1346o (28:1346 Other )",
      "28:1346pi" : "28:1346pi (28:1346 Personal Injury )",
      "28:1346rc" : "28:1346rc (28:1346 Recovery of IRS Tax)",
      "28:1346tc" : "28:1346tc (28:1346 Tort Claim)",
      "28:1346wd" : "28:1346wd (28:1346 Wrongful Death)",
      "28:1350" : "28:1350 (28:1350 Alien Action for Tort)",
      "28:1352" : "28:1352 (28:1352 Miller Act)",
      "28:1355" : "28:1355 (28:1355 Petition for Return of Property)",
      "28:1358" : "28:1358 (28:1358 Land Condemnation)",
      "28:1361" : "28:1361 (28:1361 Petition for Writ of Mandamus)",
      "28:1362ic" : "28:1362ic (28:1362 Indian Tribal Controversy)",
      "28:1362iw" : "28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)",
      "28:1363" : "28:1363 (Violation of Juror Employment Protection )",
      "28:1364" : "28:1364 (28:1364 Auto Negligence)",
      "28:1391" : "28:1391 (28:1391 Personal Injury)",
      "28:1402" : "28:1402 (28:1402 Medical Malpractice)",
      "28:1407" : "28:1407 (28:1407 Multidistrict Litigation)",
      "28:1412" : "28:1412 (28:1412 Change of Venue)",
      "28:1441ac" : "28:1441ac (28:1441 Petition for Removal- Account Receivable)",
      "28:1441al" : "28:1441al (28:1441 Petition for Removal- Airline Crash)",
      "28:1441as" : "28:1441as (28:1441 Petition for Removal- Asbestos Litigation)",
      "28:1441au" : "28:1441au (28:1441 Petition for Removal- Auto Negligence)",
      "28:1441bc" : "28:1441bc (28:1441 Petition for Removal- Breach of Contract)",
      "28:1441cv" : "28:1441cv (28:1441 Petition for Removal- Civil Rights Act)",
      "28:1441df" : "28:1441df (28:1441 Petition for Removal- Contract Default)",
      "28:1441dj" : "28:1441dj (28:1441 Petition for Removal- Declaratory Judgment)",
      "28:1441ds" : "28:1441ds (28:1441 Petition for Removal- Contract Dispute)",
      "28:1441ed" : "28:1441ed (28:1441 Petition for Removal - Employment Discrim)",
      "28:1441fc" : "28:1441fc (28:1441 Petition for Removal - Fair Credit Reporti)",
      "28:1441fr" : "28:1441fr (28:1441 Petition for Removal- Fraud)",
      "28:1441ij" : "28:1441ij (28:1441 Petition for Removal- Injunctive/Declarato)",
      "28:1441in" : "28:1441in (28:1441 Petition for Removal- Insurance Contract)",
      "28:1441int" : "28:1441int (28:1441 Petition for Removal- Action for Interplea)",
      "28:1441lb" : "28:1441lb (28:1441 Petition for Removal Libel,Assault,Slander)",
      "28:1441lm" : "28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relatio)",
      "28:1441mm" : "28:1441mm (28:1441 Petition for Removal- Medical Malpractice)",
      "28:1441ni" : "28:1441ni (28:1441 Petition for Removal- Negotiable Instrumen)",
      "28:1441nm" : "28:1441nm (28:1441 Petition for Removal- Non-Motor Vehicle)",
      "28:1441oc" : "28:1441oc (28:1441 Petition For Removal--Other Contract)",
      "28:1441pd" : "28:1441pd (28:1441 Petition for Removal- Property Damage)",
      "28:1441pi" : "28:1441pi (28:1441 Petition for Removal- Personal Injury)",
      "28:1441pl" : "28:1441pl (28:1441 Petition for Removal- Product Liability)",
      "28:1441pr" : "28:1441pr (28:1441 Petition for Removal)",
      "28:1441qt" : "28:1441qt (28:1441 Petition for Removal- Petition to Quiet Ti)",
      "28:1441ri" : "28:1441ri (28:1441 Petition for Removal- Racketeering (RICO))",
      "28:1441sa" : "28:1441sa (28:1441 - Petition for Removal: SEC Act)",
      "28:1441sf" : "28:1441sf (28:1441 - Petition for Removal: Securities Fraud)",
      "28:1441tl" : "28:1441tl (28:1441 Petition for Removal- Torts to Land)",
      "28:1441tm" : "28:1441tm (28:1441 Petition for Removal- Tort/Motor Vehicle ()",
      "28:1441tn" : "28:1441tn (28:1441 Petition for Removal- Tort/Non-Motor Vehic)",
      "28:1441wd" : "28:1441wd (28:1441 Petition for Removal- Wrongful Death)",
      "28:1442bc" : "28:1442bc (28:1442 Petition for Removal- Breach of Contract)",
      "28:1442pr" : "28:1442pr (28:1442 Petition for Removal)",
      "28:1443" : "28:1443 (28:1443(1) Rent, Lease & Ejectment)",
      "28:1444" : "28:1444 (28:1444 Petition for Removal- Foreclosure)",
      "28:1446in" : "28:1446in (28:1446 Breach of Contract- Insurance)",
      "28:1446pd" : "28:1446pd (28:1446 Petition for Removal- Property Damage (P.I)",
      "28:1446pi" : "28:1446pi (28:1446 Petition for Removal- Personal Injury)",
      "28:1446pl" : "28:1446pl (28:1446pl Petition for Removal - Product Liability)",
      "28:1446pr" : "28:1446pr (28:1446 Petition for Removal)",
      "28:1452" : "28:1452 (28:1452 R&R re motions to remand (non-core))",
      "28:1602" : "28:1602 (28:1602 Foreign Sovereign Immunities Act )",
      "28:1651" : "28:1651 (28:1651 Petition for Writ of Coram Nobis)",
      "28:1651hc" : "28:1651hc (28:1651 Petition for Writ of Habeas Corpus)",
      "28:1651mn" : "28:1651mn (28:1651 Petition for Writ of Mandamus)",
      "28:1983" : "28:1983 (28:1983 Civil Rights)",
      "28:2201" : "28:2201 (28:2201 Constitutionality of State Statute(s))",
      "28:2201dj" : "28:2201dj (28:2201 Declaratory Judgment)",
      "28:2201ij" : "28:2201ij (28:2201 Injunction)",
      "28:2201in" : "28:2201in (28:2201 Declaratory Judgement (Insurance))",
      "28:2241" : "28:2241 (28:2241 Petition Writ of Habeas Corpus (Federal))",
      "28:2254" : "28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))",
      "28:2254se" : "28:2254se (28:2254 Petition for Writ of Habeas Corpus - Stay of Execution)",
      "28:2255" : "28:2255 (28:2255 Motion to Vacate / Correct Illegal Sentence)",
      "28:2271" : "28:2271 (28:2271 Federal Tort Claims Act)",
      "28:2345" : "28:2345 (28:2345 Medicare Recovery)",
      "28:2409" : "28:2409 (28:2409(a) Quiet Title Action)",
      "28:2410" : "28:2410 (28:2410 Quiet Title)",
      "28:2601" : "28:2601 (28:2601 Family Medical Leave Act )",
      "28:2671" : "28:2671 (28:2671 Federal Tort Claims Act)",
      "28:2674" : "28:2674 (28:2674 Federal Tort Claims Act)",
      "28:2675" : "28:2675 (28:2675 Motor Vehicle Damages involving USPS employee )",
      "28:3000" : "28:3000 (28:3000 Federal Debt Collection Procedures Act )",
      "28:7402" : "28:7402 (28:7402 Refund of Taxes)",
      "28:7422" : "28:7422 (28:7422 Appeal from Administrative Decision)",
      "29:0151" : "29:0151 (29:151 Labor: Review of Agency Action)",
      "29:0160" : "29:0160 (29:160(1) National Labor Relations Act)",
      "29:0184" : "29:0184 (29:184 Violation Collection Bargain Agreement)",
      "29:0185ep" : "29:0185ep (29:185 Employee Pension Plan)",
      "29:0185lm" : "29:0185lm (29:185 Labor/Mgt. Relations (Contracts))",
      "29:0201do" : "29:0201do (29:201 Fair Labor Standards Act - Denial of Overtime Compensation)",
      "29:0201fl" : "29:0201fl (29:201 Fair Labor Standards Act of 1938)",
      "29:0203" : "29:0203 (29:203 Equal Pay Act)",
      "29:0206" : "29:0206 (29:206 Collect Unpaid Wages)",
      "29:0207" : "29:0207 (29:207 Fair Labor Standards Act - Maximum Hours)",
      "29:0216" : "29:0216 (29:0216 Fair Labor Standards Act)",
      "29:0401" : "29:0401 (29:0401 Labor Management Disclosure Act)",
      "29:0411" : "29:0411 (29:0411 Union Workers Freedom of Speech)",
      "29:0464" : "29:0464 (29:464 Labor Managment Reporting-Disclosure; Civ Enforcement)",
      "29:0621" : "29:0621 (29:621 Job Discrimination (Age))",
      "29:0623" : "29:0623 (29:623 Job Discrimination (Age))",
      "29:0626" : "29:0626 (29:626 Job Discrimination (Age))",
      "29:0633" : "29:0633 (29:633 Job Discrimination (Age))",
      "29:0651" : "29:0651 (29:651 Occupational Safety/Health)",
      "29:0754" : "29:0754 (29:754 Discrimination)",
      "29:0790" : "29:0790 (29:790 Rehabilitation of Labor )",
      "29:0791" : "29:0791 (29:791 Job Discrimination (Rehabilitation Act))",
      "29:0794" : "29:0794 (29:0794 Job Discrimination (Handicap))",
      "29:1001" : "29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)",
      "29:1002" : "29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)",
      "29:1104" : "29:1104 (29:1104 Recovery of Benefits to Employee)",
      "29:1109" : "29:1109 (29:1109 Breach of Fiduciary Duties)",
      "29:1131" : "29:1131 (29:1131 ERISA - Collection of Delinquent Trust Fund)",
      "29:1132" : "29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)",
      "29:1140" : "29:1140 (29:1140 ERISA-Interference with Protected Rights )",
      "29:1145" : "29:1145 (29:1145 Employee Retirement Income Security Act)",
      "29:1149" : "29:1149 (29:1149 Recover Pension & Profit Sharing)",
      "29:1166" : "29:1166 (29:1166 Consolidated Omnibus Reconciliation Act of 1985 )",
      "29:1337" : "29:1337 (29:1337 E.R.I.S.A.)",
      "29:1362" : "29:1362 (29:1362 ERISA)",
      "29:1381" : "29:1381 (29:1381 E.R.I.S.A.)",
      "29:1401" : "29:1401 (29:1401(b)(2) Appeal of Arbitration Award)",
      "29:1451" : "29:1451 (29:1451 E.R.I.S.A.)",
      "29:1801" : "29:1801 (29:1801 Farmworker Rights)",
      "29:2101" : "29:2101 (29:2101-2104 (WARN) Worker Adjustment and Retraining Notification)",
      "29:2601" : "29:2601 (29:2601 Family & Medical Leave Act)",
      "29:2617" : "29:2617 (29:2617 Family and Medical Leave Act Discrimination)",
      "30:0181" : "30:0181 (30:181 Environment: Review of Agency Action)",
      "30:0801" : "30:0801 (30:0801 Penalities/Federal Mine Safety Health Act)",
      "30:1201" : "30:1201 (30:1201 Environment: Review of Agency Action)",
      "30:1202" : "30:1202 (30:1202 Mining Reclamation Act)",
      "30:1276" : "30:1276 (30:1276 Interior: Review of Agency Action)",
      "31:3545" : "31:3545 (31:3545 Action to Recovery Money)",
      "31:3729" : "31:3729 (31:3729 False Claims Act)",
      "31:3730" : "31:3730 (31:3730 Qui Tam False Claims Act)",
      "31:3731" : "31:3731 (31:3731 Fraud)",
      "31:5324" : "31:5324 (31:5324 Structuring Transactions to Evade Reporting Requirement)",
      "32:4300" : "32:4300 (32:4300 Uniformed Services Employment & Reemployment Rights Act)",
      "33:0901" : "33:0901 (33:0901 Longshore & Harbor Worker's Compensation Act )",
      "33:0905" : "33:0905 (33:0905 Longshore & Harbor Workers - Employer Liability)",
      "33:0921" : "33:0921 (33:921(d) Longshore & Harbor Workers Compensation Act )",
      "33:1319cw" : "33:1319cw (33:1319 Clean Water Act)",
      "33:1319pv" : "33:1319pv (33:1319 Pollutants & Permit Violations)",
      "33:1321" : "33:1321 (Clean Water Act - Oil & Hazardous Substance Liability)",
      "33:1365" : "33:1365 (33:1365 Environmental Matters)",
      "33:2701" : "33:2701 (33:2701 Oil Pollution Act of 1990 )",
      "35:0102" : "35:0102 (35:102 Invalidity and Nonenforceability of U.S. Patent)",
      "35:0145" : "35:0145 (35:145 Civil Action to Obtain Patent)",
      "35:0183" : "35:0183 (35:183 Patent - Right to Compensation)",
      "35:0271" : "35:0271 (35:271 Patent Infringement)",
      "38:0301" : "38:0301 (38:301 et seq Veterans Affairs, General Benefits )",
      "38:1681" : "38:1681 (38:1681 Recovery of VA Overpayment)",
      "38:1686" : "38:1686 (38:1686 Recovery of VA Overpayment)",
      "38:1780" : "38:1780 (38:1780 Recovery of VA Overpayment)",
      "38:2011" : "38:2011 (38:2011 - Veteran's Readjustment Assistance Act of)",
      "38:3116" : "38:3116 (38:3116 VA Overpayment)",
      "38:4301" : "38:4301 (38:4301 Uniformed Services Employment & Re-Employment Rights Act)",
      "39:0409" : "39:0409 (Suits by and against U.S. Postal Service)",
      "39:3005" : "39:3005 (39:3005 Detention of Mail for Temporary Periods)",
      "40:0258" : "40:0258 (40:258(a) Public Buildings & Property: Land Condem)",
      "40:0270" : "40:0270 (40:270 Miller Act)",
      "40:0875" : "40:0875 (40:875 Public Buildings & Property: Negligence)",
      "40:3133" : "40:3133 (40:3133 Miller Act)",
      "41:0251" : "41:0251 (41:251 Public Contracts-Review of Agency Action)",
      "41:0601" : "41:0601 (Contract Disputes Act of 1978 )",
      "41:1463" : "41:1463 (41:1463 Public Contracts: Unlawful Employment Prac)",
      "42:0205" : "42:0205 (42:205 Denial Social Security Benefits)",
      "42:0206" : "42:0206 (42:206 Social Security Benefits)",
      "42:0233" : "42:0233 (42:0233(c) Removal of tort action against United States)",
      "42:0247" : "42:0247 (42:247 Personal Injury-Swine Flu)",
      "42:0300" : "42:0300 (42:0300(aa) National Vaccine Injury Compensation Act (NVIC))",
      "42:0300(j)" : "42:0300(j) (Safe Drinking Water)",
      "42:0402" : "42:0402 (42:402 Social Security Benefits)",
      "42:0405g" : "42:0405g (42:0405g Review of Commissioner's Final Decision)",
      "42:0405id" : "42:0405id (42:405 Review of HHS Decision (SSID))",
      "42:0405wc" : "42:0405wc (42:405 Review of HHS Decision (DIWC))",
      "42:0405ww" : "42:0405ww (42:405 Review of HHS Decision (DIWW))",
      "42:0416" : "42:0416 (42:416 Denial of Social Security Benefits)",
      "42:0425" : "42:0425 (42:425 Social Security Benefits)",
      "42:0427" : "42:0427 (42:427 Social Security Benefits)",
      "42:10804" : "42:10804 (42:10804 Protection/Advocacy for the Mentally Ill )",
      "42:11101" : "42:11101 (Federal Health Care Quality Improvement Act)",
      "42:11601" : "42:11601 (International Child Abduction Remedies Act)",
      "42:12101" : "42:12101 (42:12101 Americans with Disabilities Act)",
      "42:12102" : "42:12102 (42:12102 Americans With Disabilities Act )",
      "42:12111" : "42:12111 (42:12111 Americans With Disabilities Act )",
      "42:12201" : "42:12201 (42:12201 Americans With Disabilities Act-Injured Worker Discrimination)",
      "42:1383" : "42:1383 (42:1383 Review of HHS Decision)",
      "42:1395" : "42:1395 (42:1395 HHS: Adverse Reimbursement Review)",
      "42:1396" : "42:1396 (42:1396 - Tort Negligence)",
      "42:14141" : "42:14141 (42:14141 Violent Crime Control and Law Enforcement Act of 1994)",
      "42:1471" : "42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclo)",
      "42:1981cv" : "42:1981cv (42:1981 Civil Rights)",
      "42:1981hs" : "42:1981hs (42:1981 Housing Discrimination)",
      "42:1981jb" : "42:1981jb (42:1981 Job Discrimination (Race))",
      "42:1981sx" : "42:1981sx (42:1981 Sex Discrimination)",
      "42:1983cv" : "42:1983cv (42:1983 Civil Rights Act)",
      "42:1983ed" : "42:1983ed (42:1983 Civil Rights (Employment Discrimination))",
      "42:1983pr" : "42:1983pr (42:1983 Prisoner Civil Rights)",
      "42:1986" : "42:1986 (42:1986 Neglect of Duty)",
      "42:2000ag" : "42:2000ag (42:2000 Job Discrimination (Age))",
      "42:2000bb" : "42:2000bb (42:2000bb Religious Freedom Restoration Act )",
      "42:2000e" : "42:2000e (42:2000e Job Discrimination (Employment))",
      "42:2000pb" : "42:2000pb (42:2000 Job Discrimination (Public Accomodations))",
      "42:2000ra" : "42:2000ra (42:2000 Job Discrimination (Race))",
      "42:2000sx" : "42:2000sx (42:2000 Job Discrimination (Sex))",
      "42:2003" : "42:2003 (42:2003 Job Discrimination)",
      "42:2005" : "42:2005 (42:2005 Review of Agency Action-HHS)",
      "42:2651" : "42:2651 (42:2651 Medical Care Recovery)",
      "42:3601" : "42:3601 (42:405 Fair Housing Act)",
      "42:4000" : "42:4000 (42:4000 National Flood Insurance Act)",
      "42:4001" : "42:4001 (42:4001 National Insurance Flood Act)",
      "42:4053" : "42:4053 (42:4053 Breach of Insurance Contract)",
      "42:4072" : "42:4072 (42:4072 Payment of Flood Insurance Claim)",
      "42:4321" : "42:4321 (42:4321 Review of Agency Action-Environment)",
      "42:4332" : "42:4332 (42:4332 Environmental Policy - Coop of Agency Repo)",
      "42:4601" : "42:4601 (42:4601 Uniform Relocation Act )",
      "42:6901en" : "42:6901en (42:6901 Environmental Cleanup Expenses)",
      "42:6901rs" : "42:6901rs (42:6901 Resource & Recovery Act)",
      "42:6972" : "42:6972 (42:6972 Resource Conservation & Recovery Act )",
      "42:7413" : "42:7413 (42:7413(b) Clean Air Act)",
      "42:7604cl" : "42:7604cl (42:7604 Clear Air Act (Emission Standards))",
      "42:7604ir" : "42:7604ir (42:7604 Petition to Quash IRS Summons)",
      "42:9601" : "42:9601 (42:9601 CERCLA Hazardous Waste Cleanup Costs )",
      "42:9607" : "42:9607 (42:9607 Real Property Tort to Land)",
      "42:9659" : "42:9659 (42 USC 9659 Comprehensive Environmental Response, Compensation & Liability Act (CERCLA))",
      "43:0666" : "43:0666 (43:666 McCarran Amendment )",
      "43:0945" : "43:0945 (Compensatin for Land Condemnation)",
      "43:0945a" : "43:0945a (Complaint in Condemnation)",
      "43:0946" : "43:0946 (Complaint in Condemnation - Eminent Domain)",
      "45:0051" : "45:0051 (45:51 Railways: Fed. Employer's Liability Act)",
      "45:0151" : "45:0151 (45:151 Railway Labor Act)",
      "45:0184" : "45:0184 (45:184 Action to Set Aside Award of a System Board)",
      "45:1395" : "45:1395 (45:1395 Railroads: Adverse Reimbursement Review)",
      "45:7457" : "45:7457 (45:7457 Compel Reclamation Under Clear Air Act)",
      "46:0181" : "46:0181 (46:0181 Exoneration/Limitation of Liability - Bodily Injury )",
      "46:0183" : "46:0183 (46:0183 Exoneration/Limitation of Liability )",
      "46:0688" : "46:0688 (46:688 Jones Act)",
      "46:0740" : "46:0740 (Collision of Vessels in Navigable Waters)",
      "46:0741" : "46:0741 (46:741 Shipping)",
      "46:0761" : "46:0761 (46:761 Shipping: Damages for Death on High Seas)",
      "46:0911" : "46:0911 (46:0911 Ship Mortgage Act )",
      "46:0971" : "46:0971 (46:0971 Maritime Liens )",
      "46:10601" : "46:10601 (46:10601 Fishing Agreements)",
      "46:1101" : "46:1101 (46:1101 Violation of Maritime Regulations)",
      "46:1156" : "46:1156 (46:1156 Administrative Procedure Act)",
      "46:1300" : "46:1300 (46:1300 Carriage of Goods by Sea Act )",
      "46:31322" : "46:31322 (46:31322 Mortgage Act of 1920 )",
      "47:0151" : "47:0151 (47:151 Complaint for pmt of Telecommunication Services )",
      "47:0252" : "47:0252 (Telecommunications Act of 1996)",
      "47:0553" : "47:0553 (47:0553 Cable Communications Policy Act of 1984)",
      "47:0605" : "47:0605 (Unauthorized Publication or use of Communications)",
      "47:227" : "47:227 (47:227 Restrictions on Use of Telephone Equipment)",
      "48:0883" : "48:0883 (48:883 Violation of US Coastal Law)",
      "48:1985" : "48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)",
      "49:0081" : "49:0081 (49:81 Damaged Goods While Being Transported)",
      "49:0781" : "49:0781 (49:781 Forfeiture)",
      "49:10101" : "49:10101 (49:10101 Interstate Commerce Act )",
      "49:10761" : "49:10761 (49:10761 Interstate Commerce Act Rate Requirements)",
      "49:11503" : "49:11503 (49:11503 Railroad Revitalization Regulatory Reform)",
      "49:11702" : "49:11702 (49:11702(a)(4) Violations of Interstate Commerce Act)",
      "49:11707" : "49:11707 (49:11707 Carmack Amendment )",
      "49:13501" : "49:13501 (49:13501 Violation of Fed Leasing Statutes and Regulations)",
      "49:13906" : "49:13906 (49:13906 Security of Motor Carriers, Brokers, and Freight Forwarders)",
      "49:14102" : "49:14102 (49:14102 Violation of Fed Leasing Statutes and Regulations)",
      "49:14501" : "49:14501 (49:14501 Fed Preemption of Local Solid Waste Ordinances )",
      "49:14704" : "49:14704 (49:14704 Violation of Fed Leasing Statutes and Regulations)",
      "49:14706" : "49:14706 (49:14706 Interstate Transportation - Carmack Amendment)",
      "49:1471" : "49:1471 (49:1471 Federal Aviation Act)",
      "49:1903" : "49:1903 (49:1903 Petition to enforce administrative summon)",
      "49:20101" : "49:20101 (49:20101 Federal Railroad Authorization Act of 1994 )",
      "49:31105" : "49:31105 (Surface Transportation Assistance Act of 1982)",
      "49:32703" : "49:32703 (49 USC 32703 Odometer Tampering )",
      "49:60101" : "49:60101 (49:60101 Natural Gas Pipeline Safety Act )",
      "misc" : "misc (Civil Miscellaneous Case)"
   },
   "paedce" : {
      "0" : "0 (00:0000)",
      "02:0138" : "02:0138 (02:138 Library of Congress Access)",
      "02:0358" : "02:0358 (02:358 President's Recommendations on Exec., Jud. & Leg. Salary)",
      "02:0431" : "02:0431 (02:431 Federal Election Commission: Failure to Enforce Compliance)",
      "02:0437" : "02:0437 (02:437 Federal Election Commission)",
      "02:0681" : "02:0681 (02:681 Deferral of Budget Authority)",
      "02:1202" : "02:1202 (02:1202 Discriminatory practices affecting US Senate employees)",
      "02:1301" : "02:1301 (02:1301 Congressional Accountability Act)",
      "02:1317(a)" : "02:1317(a) (02:1317(a) Violation of Congressional Accountability Act)",
      "05:0075" : "05:0075 (05:75(2) Contract - Reduction in Grade)",
      "05:0551" : "05:0551 (05:551 Administrative Procedure Act)",
      "05:0552fi" : "05:0552fi (05:552 Freedom of Information Act)",
      "05:0552pa" : "05:0552pa (05:552 Right to Privacy Act)",
      "05:0554" : "05:0554 (05:0554 Constitutionality of Maritime Statutes)",
      "05:0701" : "05:0701 (05:0701 Maritime Subsidy Board)",
      "05:0702" : "05:0702 (05:702 Administrative Procedure Act)",
      "05:0704" : "05:0704 (05:704 Labor Litigation)",
      "05:0706(2)" : "05:0706(2) (05:0706(2) Defense Base Closure & Realignment Act of 1990)",
      "05:7703" : "05:7703 (05:7703 Discrimination - Review of Agency Act)",
      "05:8131" : "05:8131 (05:8131 Federal Employee's Compensation Act (FECA))",
      "05:8470" : "05:8470 (05:8470 Enforcement of Judgment against Retirement Benefits)",
      "05:8701" : "05:8701 (05:8701 Federal Employees Group Life Insurance Act of 1954)",
      "05:8901" : "05:8901 (05:8901 Federal Employees Health Benefits Act)",
      "06:(a)(4)" : "06:(a)(4) (06:(a)(4) Inspector General Act of 1978)",
      "07:0006" : "07:0006 (7:6(b) Federal Commodity Exchange Regulation)",
      "07:0025" : "07:0025 (7:25 Fraud - Commodities Leverage Contracts)",
      "07:0181" : "07:0181 (07:181 Packers & Stockyard Act)",
      "07:0499" : "07:0499 (07:499 Agricultural Commodities Act)",
      "07:0601" : "07:0601 (07:601 USDA Condemnation)",
      "07:2023(a)" : "07:2023(a) (7:2023(a) Judicial Review of Food Stamp Disqualification)",
      "07:2024" : "07:2024 (07:2024 False Claims Act, Food Stamp Fraud)",
      "07:2131" : "07:2131 (07:U.S.C. 2131 Violation of the Animal Welfare Act)",
      "07:2321" : "07:2321 (07:2321 Plant Variety Protection Act)",
      "08:1105" : "08:1105 (8:1105(a) Aliens: Habeas Corpus to Release INS Det)",
      "08:1158" : "08:1158 (08:1158 Immigration & Nationality Act, Section 208)",
      "08:1182" : "08:1182 (8:1182 Defend. Denial of Pla. Appl. for Alien Employment Cer)",
      "08:1251(A)" : "08:1251(A) (08:1251(A)(4) Application for a Stay of Deportation)",
      "08:1252" : "08:1252 (08:1252(a)(2) Injunction for Deportation)",
      "08:1255" : "08:1255 (08:1255 Failure USCIS To Adjudicate Permanent Residency Petition)",
      "08:1260" : "08:1260 (08:1260 Aliens: Access to Records)",
      "08:1324" : "08:1324 (08:1324 Aliens: Complaint for Forfeiture)",
      "08:1329" : "08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petiti)",
      "08:1421(c)" : "08:1421(c) (08:1421(c) Petition for Review of Naturalization)",
      "08:1446" : "08:1446 (8:1446 Petition for Naturalization Hearing)",
      "08:1451(j)" : "08:1451(j) (8:1451(j) Motion to Correct Order & Judg. of Naturalization)",
      "09:0001" : "09:0001 (09:1 U.S. Arbitration Act)",
      "09:0007" : "09:0007 (09:0007 Petition to Enforce Arbitration Subpoena)",
      "09:0009" : "09:0009 (9:9 Motion to Confirm Arbitration Loan)",
      "09:0010" : "09:0010 (09:0010 Petition to Vacate Arbitration Award)",
      "09:201" : "09:201 (Petition to Compel/Stay Arbitration under an Insurance Contract)",
      "10:1408" : "10:1408 (10:1408 Claim for Military Retirement)",
      "10:1552" : "10:1552 (10:1552 Armed Forces: Action to Correct Records)",
      "10:1553" : "10:1553 (10:1553 Armed Forces: FOIA General)",
      "10:2305" : "10:2305 (10:2305 Review of Federal Contract)",
      "11:0101" : "11:0101 (11:101 Bankruptcy)",
      "12:0022" : "12:0022 (12:22 Securities Fraud)",
      "12:0635" : "12:0635 (12:635 Breach of Insurance Contract)",
      "12:1" : "12:1 (12:USCS Sec. 1 Wrongful wire transaction)",
      "12:1345" : "12:1345 (12:1345 Financial Inst. Reform Recov. & Enforc. Act of 1989)",
      "12:1421" : "12:1421 (12:1421 Federal Home Loan Bank Act)",
      "12:1451" : "12:1451 (12:1451 Emergency Home Finance Act of 1970)",
      "12:1461" : "12:1461 (12:1461 Homeowners Loan Act)",
      "12:1464" : "12:1464 (12:1464 Federal Savings and Loan)",
      "12:1701x" : "12:1701x (12:1701x(a)(5) National Affordable Housing Act)",
      "12:1703" : "12:1703 (12:1703 Default of HUD Loan)",
      "12:1715(b)" : "12:1715(b) (12:1715(b) HUD Mortgage Assignment Program)",
      "12:1725" : "12:1725 (12:1725 Collection under Contract Guaranty)",
      "12:1730" : "12:1730 (12:1730 Collection Under Contract Guaranty)",
      "12:1786" : "12:1786 (12:1786 Termination of insured Credit Union Status)",
      "12:1811" : "12:1811 (12:1811 Financial Inst. Reform Recov. & Enforc. Act of 1989)",
      "12:1819" : "12:1819 (12:1819 Default of Promissory Note)",
      "12:1821" : "12:1821 (12:1821 Default of Loan by Promissary Note)",
      "12:1831d" : "12:1831d (12:1831d Deposit. Inst. Dereg. & Monetary Ctrl. Act of 1980)",
      "12:191" : "12:191 (12:191 Bank Foreclosure)",
      "12:192" : "12:192 (12:192 Liquidation of National Bank)",
      "12:1971" : "12:1971 (12:1971 Relief under Bank Holding Act)",
      "12:1972" : "12:1972 (12:1972 Typing Arrangement Act)",
      "12:2604(c)" : "12:2604(c) (12:2604(c) Real Estate Settlement Procedures Act (RESPA))",
      "12:2609" : "12:2609 (12:2609 Real Estate Settlement Procedures Act)",
      "12:3410" : "12:3410 (12:3410 Right to Financial Privacy Act)",
      "12:3751" : "12:3751 (12:3751 Single Family Mortgage Forclosure Act)",
      "12:4901" : "12:4901 (12:4901 Dodd-Frank Act)",
      "12:5101" : "12:5101 (12:5101 Fraudulent Transfer Act)",
      "12:5211" : "12:5211 (12:5211 Troubled Asset Relief Program (\"TARP\"))",
      "12:8632" : "12:8632 (12:8632 Federal Reserve Act)",
      "12:93(a)" : "12:93(a) (12:93(a) National Bank Act)",
      "15:0001" : "15:0001 (15:1 Antitrust Litigation)",
      "15:0002at" : "15:0002at (15:2 Antitrust Litigation)",
      "15:0002fl" : "15:0002fl (15:2(a) Fair Labor Standards Act)",
      "15:0005" : "15:0005 (15:5(a) Fair Labor Standards Act)",
      "15:0015" : "15:0015 (15:15 Antitrust Litigation)",
      "15:0025" : "15:0025 (15:25 Clayton Act)",
      "15:0044" : "15:0044 (15:44 Trademark Infringement)",
      "15:0045" : "15:0045 (15:0045 Federal Trade Commission Act)",
      "15:0052" : "15:0052 (15:0052 Federal Trade Commission Act)",
      "15:0053" : "15:0053 (15:0053 Federal Trade Commission Act)",
      "15:0077" : "15:0077 (15:77 Securities Fraud)",
      "15:0078" : "15:0078 (15:78m(a) Securities Exchange Act)",
      "15:0631" : "15:0631 (15:631 Small Business Act)",
      "15:0717" : "15:0717 (15:717 Natural Gas Act)",
      "15:0754" : "15:0754 (15:754 Emergency Petroleum Allocation-Admin.& Enforcement)",
      "15:1051" : "15:1051 (15:1051 Trademark Infringement)",
      "15:1114" : "15:1114 (15:1114 Trademark Infringement)",
      "15:1121" : "15:1121 (15:1121 Trademark Infringement)",
      "15:1125" : "15:1125 (15:1125 Trademark Infringement (Lanham Act))",
      "15:1126" : "15:1126 (15:1126 Patent Infringement)",
      "15:1127" : "15:1127 (15:1127 Trademark Infringement)",
      "15:1267(a)" : "15:1267(a) (15:1267(a) Federal Hazardous Substances Act)",
      "15:1601" : "15:1601 (15:1601 Truth in Lending)",
      "15:1640" : "15:1640 (15:1640 Truth in Lending)",
      "15:1667" : "15:1667 (15:1667 Consumer Leasing Act)",
      "15:1679" : "15:1679 (15:1679 Credit Repair Organizations Act)",
      "15:1681" : "15:1681 (15:1681 Fair Credit Reporting Act)",
      "15:1691" : "15:1691 (15:1691 Equal Credit Opportunity Act)",
      "15:1692" : "15:1692 (15:1692 Fair Debt Collection Act)",
      "15:1693ef" : "15:1693ef (15:1693 Electronic Funds Transfer Act)",
      "15:1693m" : "15:1693m (Violation of Prov. of Subchpt.VI (Electronic Fund Transfers))",
      "15:1701" : "15:1701 (15:1701 Interstate Land Sales Full Disclosure Act)",
      "15:1938" : "15:1938 (15:1938 Fair Labor Standards Act)",
      "15:1981" : "15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))",
      "15:1988" : "15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))",
      "15:1989" : "15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))",
      "15:2301" : "15:2301 (15:2301 Magnuson-Moss Warranty Act)",
      "15:2801" : "15:2801 (15:2801 Petroleum Marketing Practices Act)",
      "15:30-35" : "15:30-35 (15:30-35 Investment Company Act of 1940)",
      "15:3710a" : "15:3710a (15:3710a Federal Technology Transfer Act of 1986)",
      "15:53(b)" : "15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equita)",
      "15:80" : "15:80 (15:80 Investment Company Act)",
      "16:0668" : "16:0668 (16:668 Bald Eagle Protection Act)",
      "16:0703" : "16:0703 (16:703 Migratory Bird Act)",
      "16:0823" : "16:0823 (Federal Public Utility Regulatory Policies Act, 16 U.S.C.)",
      "16:1374(d)(6)" : "16:1374(d)(6) (16:1374(d)(6) Petition for Review re Application for Import of Polar Bear Trophies)",
      "16:1538" : "16:1538 (16:1538 Endangered Species Act)",
      "16:3371" : "16:3371 (16:3371 Wildlife Under the Lacey Act)",
      "16:3372" : "16:3372 (16:3372 Conservation: Complaint for Forfeiture)",
      "16:3373" : "16:3373 (16:3373 Appeal of Decision - DOI)",
      "16:3374" : "16:3374 (16:3374 Conservation: Complaint for Forfeiture)",
      "16:470(f)" : "16:470(f) (16:470(f) National Historic Preservation Act)",
      "17:0101" : "17:0101 (17:101 Copyright Infringement)",
      "17:0501" : "17:0501 (17:501 Copyright Infringement)",
      "17:0504" : "17:0504 (17:504 Copyright Infringement)",
      "18:0241" : "18:0241 (18:241 Conspiracy Against Citizen Rights)",
      "18:0981a" : "18:0981a (18:0981(a)(1)(A) Money Laundering Control Act)",
      "18:1030" : "18:1030 (18:1030 Federal Computer Fraud & Abuse Act)",
      "18:1332(d)" : "18:1332(d) (18:1332(d) Class Action Fairness Act (CAFA))",
      "18:1345" : "18:1345 (18:1345 Mail Fraud Injunction)",
      "18:1514A" : "18:1514A (18:1514A Sarbanes-Oxley Act)",
      "18:1836a" : "18:1836a (18:1836(a) Injunction Against Misappropriation of Trade Secrets)",
      "18:1836b" : "18:1836b (18:1836(b) Civil Action to Protect Trade Secrets)",
      "18:1961" : "18:1961 (18:1961 Racketeering (RICO) Act)",
      "18:1962" : "18:1962 (18:1962 Racketeering (RICO) Act)",
      "18:1964" : "18:1964 (18:1964 Racketeering (RICO) Act)",
      "18:2333" : "18:2333 (18:2333 Anti-Terrorism Act of 1991-Civil Remedies)",
      "18:2382" : "18:2382 (18:2382 Misprision of treason)",
      "18:248" : "18:248 (18:248 Freedom of Access to Clinic Entrances Act)",
      "18:248(1994)" : "18:248(1994) (18:248(1994) Freedom of Access to Clinic Entrances Act (FACE))",
      "18:2511" : "18:2511 (18:2511 Wiretapping)",
      "18:2710" : "18:2710 (18:2710 Electronic Communication Protection Act (ECPA))",
      "18:2721" : "18:2721 (18:2721 Federal Drivers Privacy Protection Act)",
      "18:3114" : "18:3114 (18:3114 Motion for Return of Seized Property)",
      "18:4208" : "18:4208 (18:4208(B) Agency Action Review)",
      "18:923f3" : "18:923f3 (18:923(f)(3) Review of Revocation of a License as a Dealer in Firearms)",
      "18:925(c)" : "18:925(c) (18:925(c) Restoration of ability to possess firearms/ammo)",
      "19:1305" : "19:1305 (19:1305 Custom Duties:0Forfeiture-Immoral Articles)",
      "20:1080" : "20:1080 (20:1080 Student Loan Recovery)",
      "20:1095(a)(6)" : "20:1095(a)(6) (20:1095(a)(6) Higher Education Act of 1965)",
      "20:1232(g)" : "20:1232(g) (20:1232(g) Family Education Rights & Privacy Act of 1974)",
      "20:1400" : "20:1400 (20:1400 Civil Rights of Handicapped Child)",
      "20:1401" : "20:1401 (20:1401 Appeal From The Decision Of The Special Education Appeals Panel (IDEIA))",
      "20:1415" : "20:1415 (20:1415(e)(2) Individuals with Disabilities Education Act)",
      "21:0332(a)" : "21:0332(a) (21:0332(a) Federal Food, Drug, and Cosmetic Act)",
      "21:0601" : "21:0601 (21:0601-0695 Federal Meat Inspection Act (the Act))",
      "21:0841" : "21:0841 (21:841 Forfeiture Property-Drugs)",
      "21:0881" : "21:0881 (21:881 Forfeiture Property-Drugs)",
      "21:0881a" : "21:0881a (21:881 Forfeiture Property - Aircraft)",
      "21:0881re" : "21:0881re (21:881 Forfeiture Property - Real Estate)",
      "23:0134" : "23:0134 (23:134 P.I.- Auto Negligence)",
      "23:1441" : "23:1441 (23:1441 Contract Real Estate)",
      "24:1000" : "24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)",
      "25:0640" : "25:0640 (25:640 Indian Tribal Rights)",
      "25:1901" : "25:1901 (25:1901 Indian Child Welfare Act)",
      "26:6212" : "26:6212 (26:6212 Injunctive Relief from IRS Lien)",
      "26:6213" : "26:6213 (26:6213 Injunctive Relief from IRS Lien)",
      "26:6502" : "26:6502 (26:6502 IRS:Enforcement of tax liens)",
      "26:6532" : "26:6532 (26:6532 IRS: Refund of Tax Penalty)",
      "26:6672" : "26:6672 (26:6672 Trust Fund Recovery Penalty)",
      "26:6702" : "26:6702 (26:6702 IRS: Refund of Income Tax Penalty)",
      "26:6703" : "26:6703 (26:6703 IRS: Refund of Tax Penalty)",
      "26:7401" : "26:7401 (26:7401 IRS: Tax Liability)",
      "26:7402" : "26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)",
      "26:7403" : "26:7403 (26:7403 Suit to Enforce Federal Tax Lien)",
      "26:7422rt" : "26:7422rt (26:7422 IRS: Refund Taxes)",
      "26:7422rx" : "26:7422rx (26:7422 IRS: Refund Excise Tax)",
      "26:7426" : "26:7426 (26:7426 IRS: Wrongful Levy for Taxes)",
      "26:7429" : "26:7429 (26:7429 IRS: Tax Jeopardy Assessment)",
      "26:7434" : "26:7434 (26:7434 Civil Damages for Fraudulent Filing of Information Returns)",
      "26:7604a" : "26:7604a (26:7604a IRS: Complaint to Enforce IRS Summons)",
      "26:7609" : "26:7609 (26:7609 IRS: Petition to Quash IRS Summons)",
      "27:0185" : "27:0185 (27:185 Enforcement of Arbitration Award)",
      "28:0157" : "28:0157 (28:0157 Withdrawal of Reference)",
      "28:0157c" : "28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)",
      "28:0157d" : "28:0157d (28:0157 Motion for Withdrawal of Reference)",
      "28:0158" : "28:0158 (28:0158 Notice of Appeal re Bankruptcy Matter (BA)",
      "28:0185" : "28:0185 (28:185 Suit to Compel Arbitration)",
      "28:0451" : "28:0451 (28:451 Employment Discrimination)",
      "28:0754" : "28:0754 (28:754 Receiver of Property in Different Districts)",
      "28:0794" : "28:0794 (28:794 Rehabilitation Act)",
      "28:1001" : "28:1001 (28:1001 E.R.I.S.A.)",
      "28:1131" : "28:1131 (28:1131 Violation of Lanham Act and Unfair Competition)",
      "28:1132" : "28:1132 (28:1132 E.R.I.S.A.)",
      "28:1330" : "28:1330 (28:1330 Breach of Contract)",
      "28:1331" : "28:1331 (28:1331 Fed. Question)",
      "28:1331al" : "28:1331al (28:1331 Fed. Question: Airline Crash)",
      "28:1331at" : "28:1331at (28:1331 Fed. Question: Anti-trust)",
      "28:1331au" : "28:1331au (28:1331 Fed. Question: Auto Negligence)",
      "28:1331b" : "28:1331b (28:1331 Federal Question: Bivens Act)",
      "28:1331bc" : "28:1331bc (28:1331 Fed. Question: Breach of Contract)",
      "28:1331ca" : "28:1331ca (28:1331 Fed Question: Fed Communications Act of 1)",
      "28:1331cm" : "28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)",
      "28:1331cv" : "28:1331cv (28:1331 Federal Question: Other Civil Rights)",
      "28:1331ed" : "28:1331ed (28:1331 Fed. Question: Employment Discrimination)",
      "28:1331ej" : "28:1331ej (28:1331 Federal Question: Enforcement of Judgment)",
      "28:1331es" : "28:1331es (28:1331 Enforcement of Administrative Subpoena)",
      "28:1331fl" : "28:1331fl (28:1331 Fed. Question: Fair Labor Standards)",
      "28:1331in" : "28:1331in (28:1331 Fed. Question: Insurance Contract)",
      "28:1331mm" : "28:1331mm (28:1331 Fed. Question: Medical Malpractice)",
      "28:1331ng" : "28:1331ng (28:1331 Fed. Question: Natural Gas Act)",
      "28:1331pi" : "28:1331pi (28:1331 Fed. Question: Personal Injury)",
      "28:1331rd" : "28:1331rd (28:1331 Fed. Question: Review Agency Decision)",
      "28:1331rp" : "28:1331rp (28:1331(a) Fed. Question: Real Property)",
      "28:1331rr" : "28:1331rr (28:1331 Fed. Question: Railway Labor Act)",
      "28:1331sv" : "28:1331sv (28:1331 Fed. Question: Securities Violation)",
      "28:1331tr" : "28:1331tr (28:1331 Fed. Question: Trademark)",
      "28:1331tt" : "28:1331tt (28:1331 Fed. Question: Tort Action)",
      "28:1331v" : "28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendme)",
      "28:1331va" : "28:1331va (28:1331 Fed. Question: Violation 5th & 14th Amendment)",
      "28:1331wl" : "28:1331wl (28:1331 Federal Question: EPA Waste Lien)",
      "28:1331wt" : "28:1331wt (28:1331 Fed. Question: Water Rights)",
      "28:1332" : "28:1332 (28:1332 Diversity - Misappropriation of Trade Secrets)",
      "28:1332ac" : "28:1332ac (28:1332 Diversity-Account Receivable)",
      "28:1332al" : "28:1332al (28:1332 Diversity-Airline Crash)",
      "28:1332as" : "28:1332as (28:1332 Diversity-Asbestos Litigation)",
      "28:1332au" : "28:1332au (28:1332 Diversity-Auto Negligence)",
      "28:1332bc" : "28:1332bc (28:1332 Diversity-Breach of Contract)",
      "28:1332co" : "28:1332co (28:1332 Diversity-Conversion)",
      "28:1332ct" : "28:1332ct (28:1332 Diversity-(Citizenship))",
      "28:1332d5B" : "28:1332d5B (28:1332(d)(5)(B) Diversity of Citizenship under CAFA)",
      "28:1332det" : "28:1332det (28:1332 Diversity: Forcible Detainer)",
      "28:1332df" : "28:1332df (28:1332 Diversity-Contract Default)",
      "28:1332ds" : "28:1332ds (28:1332 Diversity-Contract Dispute)",
      "28:1332ed" : "28:1332ed (28:1332 Diversity-Employment Discrimination)",
      "28:1332fd" : "28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)",
      "28:1332fr" : "28:1332fr (28:1332 Diversity-Fraud)",
      "28:1332ia" : "28:1332ia (28:1332 Diversity-Interpleader Action)",
      "28:1332ij" : "28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)",
      "28:1332in" : "28:1332in (28:1332 Diversity-Insurance Contract)",
      "28:1332jd" : "28:1332jd (28:1332 Diversity-Declaratory Judgement)",
      "28:1332lb" : "28:1332lb (28:1332 Diversity-Libel,Assault,Slander)",
      "28:1332lm" : "28:1332lm (28:1332 Diversity - Legal Malpractice)",
      "28:1332ma" : "28:1332ma (28:1332 Diversity-Miller Act)",
      "28:1332mm" : "28:1332mm (28:1332 Diversity-Medical Malpractice)",
      "28:1332mv" : "28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)",
      "28:1332ni" : "28:1332ni (28:1332 Diversity-Negotiable Instrument)",
      "28:1332nm" : "28:1332nm (28:1332 Diversity-Non-Motor Vehicle)",
      "28:1332nr" : "28:1332nr (28:1332 Diversity-Notice of Removal)",
      "28:1332oc" : "28:1332oc (28:1332 Diversity-Other Contract)",
      "28:1332pd" : "28:1332pd (28:1332 Diversity-Property Damage)",
      "28:1332pi" : "28:1332pi (28:1332 Diversity-Personal Injury)",
      "28:1332pl" : "28:1332pl (28:1332 Diversity-Product Liability)",
      "28:1332qt" : "28:1332qt (28:1332 Diversity-Petition to Quiet Title)",
      "28:1332ri" : "28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)",
      "28:1332sa" : "28:1332sa (28:1332 - Diversity: Securities & Exchange Commiss)",
      "28:1332sf" : "28:1332sf (28:1332 - Diversity: Securities Fraud)",
      "28:1332ss" : "28:1332ss (28:1332 Diversity - Stockholders Suits)",
      "28:1332tl" : "28:1332tl (28:1332 Diversity-Torts to Land)",
      "28:1332tm" : "28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))",
      "28:1332tn" : "28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)",
      "28:1332wd" : "28:1332wd (28:1332 Diversity-Wrongful Death)",
      "28:1333" : "28:1333 (28:1333 Admiralty)",
      "28:1334" : "28:1334 (28:1334 Bankruptcy Appeal)",
      "28:1334c" : "28:1334c (28:1334(c) R&R re motions for abstention (non-cor)",
      "28:1335" : "28:1335 (28:1335 Interpleader Action)",
      "28:1337" : "28:1337 (28:1337 Carriage of Goods by Sea Act)",
      "28:1338cp" : "28:1338cp (28:1338 Copyright Infringement)",
      "28:1338pt" : "28:1338pt (28:1338 Patent Infringement)",
      "28:1338tr" : "28:1338tr (28:1338 Trademark Infringement)",
      "28:1340" : "28:1340 (28:1340 IRS: Custom Duties)",
      "28:1340er" : "28:1340er (28:1340 Recovery of Erroneous Refund)",
      "28:1341" : "28:1341 (28:1341 Complaint for Forfeiture)",
      "28:1343" : "28:1343 (28:1343 Violation of Civil Rights)",
      "28:1345" : "28:1345 (28:1345 USA Plaintiff)",
      "28:1345co" : "28:1345co (28:1345 Replevin & Conversion)",
      "28:1345db" : "28:1345db (28:1345 Debt to US - FHA/HUD Title I)",
      "28:1345df" : "28:1345df (28:1345 Default of Promissory Note)",
      "28:1345er" : "28:1345er (28:1345 Recovery of Erroneous Refund)",
      "28:1345fc" : "28:1345fc (28:1345 Foreclosure)",
      "28:1345ff" : "28:1345ff (28:1345 Complaint for Forfeiture)",
      "28:1345hl" : "28:1345hl (28:1345 VA Home Loan Guaranty Debt)",
      "28:1345mc" : "28:1345mc (28:1345 Medical Care Recovery)",
      "28:1345mi" : "28:1345mi (28:1345 Mining Claim Ejectment)",
      "28:1345pd" : "28:1345pd (28:1345 Property Damage)",
      "28:1345pe" : "28:1345pe (28:1345 Property Ejectment)",
      "28:1345rc" : "28:1345rc (28:1345 Recovery of Debt to US)",
      "28:1345st" : "28:1345st (28:1345 Default of Student Loan)",
      "28:1345tp" : "28:1345tp (28:1345 Trespass on Public Land)",
      "28:1345va" : "28:1345va (28:1345 Recovery of VA Overpayment)",
      "28:1346bc" : "28:1346bc (28:1346 Breach of Contract)",
      "28:1346rc" : "28:1346rc (28:1346 Recovery of IRS Tax)",
      "28:1346tc" : "28:1346tc (28:1346 Tort Claim)",
      "28:1346wd" : "28:1346wd (28:1346 Wrongful Death)",
      "28:1349" : "28:1349 (28:1348 Corporation organized under Federal Law as party)",
      "28:1350" : "28:1350 (28:1350 Alien Tort Claims Act)",
      "28:1352" : "28:1352 (28:1352 Miller Act)",
      "28:1355" : "28:1355 (28:1355 Petition for Return of Property)",
      "28:1358" : "28:1358 (28:1358 Land Condemnation)",
      "28:1361" : "28:1361 (28:1361 Petition for Writ of Mandamus)",
      "28:1362ic" : "28:1362ic (28:1362 Indian Tribal Controversy)",
      "28:1362iw" : "28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)",
      "28:1364" : "28:1364 (28:1364 Auto Negligence)",
      "28:1391" : "28:1391 (28:1391 Personal Injury)",
      "28:1402" : "28:1402 (28:1402 Medical Malpractice)",
      "28:1407" : "28:1407 (28:1407 Airline Crash)",
      "28:1441ac" : "28:1441ac (28:1441 Notice of Removal- Account Receivable)",
      "28:1441al" : "28:1441al (28:1441 Notice of Removal- Airline Crash)",
      "28:1441as" : "28:1441as (28:1441 Notice of Removal- Asbestos Litigation)",
      "28:1441au" : "28:1441au (28:1441 Notice of Removal- Auto Negligence)",
      "28:1441bc" : "28:1441bc (28:1441 Notice of Removal- Breach of Contract)",
      "28:1441cv" : "28:1441cv (28:1441 Notice of Removal- Civil Rights Act)",
      "28:1441df" : "28:1441df (28:1441 Notice of Removal- Contract Default)",
      "28:1441dj" : "28:1441dj (28:1441 Notice of Removal- Declaratory Judgemen)",
      "28:1441ds" : "28:1441ds (28:1441 Notice of Removal- Contract Dispute)",
      "28:1441ed" : "28:1441ed (28:1441 Notice of Removal - Employment Discrimination)",
      "28:1441fc" : "28:1441fc (28:1441 Notice of Removal - Fair Credit Reporting)",
      "28:1441fr" : "28:1441fr (28:1441 Notice of Removal- Fraud)",
      "28:1441ij" : "28:1441ij (28:1441 Notice of Removal- Injunctive/Declaratory)",
      "28:1441in" : "28:1441in (28:1441 Notice of Removal- Insurance Contract)",
      "28:1441int" : "28:1441int (28:1441 Notice of Removal- Action for Interplea)",
      "28:1441lb" : "28:1441lb (28:1441 Notice of Removal Libel,Assault,Slander)",
      "28:1441lm" : "28:1441lm (28:1441 Notice of Removal- Labor/Mgmnt. Relation)",
      "28:1441mm" : "28:1441mm (28:1441 Notice of Removal- Medical Malpractice)",
      "28:1441ni" : "28:1441ni (28:1441 Notice of Removal- Negotiable Instrument)",
      "28:1441nm" : "28:1441nm (28:1441 Notice of Removal- Non-Motor Vehicle)",
      "28:1441nr" : "28:1441nr (28:1441 Notice of Removal)",
      "28:1441oc" : "28:1441oc (28:1441 Notice of Removal--Other Contract)",
      "28:1441pd" : "28:1441pd (28:1441 Notice of Removal- Property Damage)",
      "28:1441pi" : "28:1441pi (28:1441 Notice of Removal- Personal Injury)",
      "28:1441pl" : "28:1441pl (28:1441 Notice of Removal- Product Liability)",
      "28:1441qt" : "28:1441qt (28:1441 Notice of Removal- Petition to Quiet Ti)",
      "28:1441ri" : "28:1441ri (28:1441 Notice of Removal- Racketeering (RICO))",
      "28:1441sa" : "28:1441sa (28:1441 - Notice of Removal: SEC Act)",
      "28:1441sf" : "28:1441sf (28:1441 - Notice of Removal: Securities Fraud)",
      "28:1441tl" : "28:1441tl (28:1441 Notice of Removal- Torts to Land)",
      "28:1441tm" : "28:1441tm (28:1441 Notice of Removal- Tort/Motor Vehicle)",
      "28:1441tn" : "28:1441tn (28:1441 Notice of Removal- Tort/Non-Motor Vehicle)",
      "28:1441wd" : "28:1441wd (28:1441 Notice of Removal- Wrongful Death)",
      "28:1442bc" : "28:1442bc (28:1442 Notice of Removal- Breach of Contract)",
      "28:1442nr" : "28:1442nr (28:1442 Notice of Removal)",
      "28:1443" : "28:1443 (28:1443(1) Rent, Lease & Ejectment)",
      "28:1444" : "28:1444 (28:1444 Notice of Removal- Foreclosure)",
      "28:1446in" : "28:1446in (28:1446 Breach of Contract- Insurance)",
      "28:1446nr" : "28:1446nr (28:1446 Notice of Removal)",
      "28:1446pd" : "28:1446pd (28:1446 Notice of Removal- Property Damage)",
      "28:1446pi" : "28:1446pi (28:1446 Notice of Removal- Personal Injury)",
      "28:1446pl" : "28:1446pl (28:1446pl Notice of Removal - Product Liability)",
      "28:1452" : "28:1452 (28:1452 R&R re motions to remand (non-core))",
      "28:1491" : "28:1491 (28:1491 Tucker Act)",
      "28:1602" : "28:1602 (28:1602 Foreign Sovereign Immunities Act)",
      "28:1651" : "28:1651 (28:1651 Petition for Writ of Coram Nobis)",
      "28:1651hc" : "28:1651hc (28:1651 Petition for Writ of Habeas Corpus)",
      "28:1651mn" : "28:1651mn (28:1651 Petition for Writ of Mandamus)",
      "28:1715" : "28:1715 (28:1715 Class Action Fairness Act of 2005)",
      "28:1738A" : "28:1738A (28:1738A The Uniform Child Custody Jurisdiction Act)",
      "28:1782" : "28:1782 (28:1782 Letter rogatory - appointment)",
      "28:1875" : "28:1875 (28 U.S.C. 1875 Jury Systems Improvement Act)",
      "28:1983" : "28:1983 (28:1983 Civil Rights)",
      "28:2201" : "28:2201 (28:2201 Constitutionality of State Statute(s))",
      "28:2201dj" : "28:2201dj (28:2201 Declaratory Judgement)",
      "28:2201ij" : "28:2201ij (28:2201 Injunction)",
      "28:2201in" : "28:2201in (28:2201 Declaratory Judgement (Insurance))",
      "28:2241" : "28:2241 (28:2241 Petition for Writ of Habeas Corpus (federal))",
      "28:2254" : "28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))",
      "28:2254dp" : "28:2254dp (28:2254dp Petition for Writ of Habeas Corpus (DEATH PENALTY))",
      "28:2254se" : "28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)",
      "28:2255" : "28:2255 (28:2255 Motion to Vacate / Correct Illegal Sentenc)",
      "28:2271" : "28:2271 (28:2271 Federal Tort Claims Act)",
      "28:2345" : "28:2345 (28:2345 Medicare Recovery)",
      "28:2409" : "28:2409 (28:2409(a) Quiet Title Action)",
      "28:2410" : "28:2410 (28:2410 Quiet Title)",
      "28:2671" : "28:2671 (28:2671 Federal Tort Claims Act)",
      "28:2674" : "28:2674 (28:2674 Federal Tort Claims Act)",
      "28:2679" : "28:2679 (28:2679 Federal Driver's Act)",
      "28:3001" : "28:3001 (28:3001 Federal Debt Collection Act)",
      "28:7402" : "28:7402 (28:7402 Refund of Taxes)",
      "28:7422" : "28:7422 (28:7422 Appeal from Administrative Decision)",
      "29:0151" : "29:0151 (29:151 Labor: Review of Agency Action)",
      "29:0158(b)" : "29:0158(b) (29:0158(b) National Labor Relations Act)",
      "29:0160" : "29:0160 (29:160(1) National Labor Relations Act)",
      "29:0184" : "29:0184 (29:184 Violation Collection Bargain Agreement)",
      "29:0185ep" : "29:0185ep (29:185 Employee Pension Plan)",
      "29:0185lm" : "29:0185lm (29:185 Labor/Mgt. Relations (Contracts))",
      "29:0201do" : "29:0201do (29:201 Denial of Overtime Compensation)",
      "29:0201fl" : "29:0201fl (29:201 Fair Labor Standards Act)",
      "29:0203" : "29:0203 (29:203 Equal Pay Act)",
      "29:0206" : "29:0206 (29:206 Collect Unpaid Wages)",
      "29:0401" : "29:0401 (29:0401 Labor Management Disclosure Act)",
      "29:0621" : "29:0621 (29:621 Job Discrimination (Age))",
      "29:0623" : "29:0623 (29:623 Job Discrimination (Age))",
      "29:0626" : "29:0626 (29:626 Job Discrimination (Age))",
      "29:0633" : "29:0633 (29:633 Job Discrimination (Age))",
      "29:0651" : "29:0651 (29:651 Occupational Safety/Health)",
      "29:0754" : "29:0754 (29:754 Discrimination)",
      "29:0791" : "29:0791 (29:791 Job Discrimination (Rehabilitation Act))",
      "29:0794" : "29:0794 (29:0794 Job Discrimination (Handicap))",
      "29:0794ra" : "29:0794ra (29:0794ra Rehabilitation Act of 1973)",
      "29:1001" : "29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)",
      "29:1002" : "29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)",
      "29:1104" : "29:1104 (29:1104 Recovery of Benefits to Employee)",
      "29:1109" : "29:1109 (29:1109 Breach of Fiduciary Duties)",
      "29:1131" : "29:1131 (29:1131 ERISA - Collection of Delinquent Trust Fun)",
      "29:1132" : "29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)",
      "29:1145" : "29:1145 (29:1145 E.R.I.S.A.)",
      "29:1149" : "29:1149 (29:1149 Recover Pension & Profit Sharing)",
      "29:1161" : "29:1161 (29:1161 COBRA)",
      "29:1337" : "29:1337 (29:1337 E.R.I.S.A.)",
      "29:1362" : "29:1362 (29:1362 ERISA)",
      "29:1381" : "29:1381 (29:1381 E.R.I.S.A.)",
      "29:1401" : "29:1401 (29:1401(b)(2) Appeal of Arbitration Award)",
      "29:1451" : "29:1451 (29:1451 E.R.I.S.A.)",
      "29:1801" : "29:1801 (29:1801 Farmworker Rights)",
      "29:2000(e)" : "29:2000(e) (29:2000(e)(k) Pregnancy Discrimination Act)",
      "29:207(a)" : "29:207(a) (29:207(a) Action for Overtime Wage Violation)",
      "29:2104" : "29:2104 (29:2104 Worker Adjustment & Retraining Notification (WARN))",
      "29:2601" : "29:2601 (29:2601 Family Medical Act of 1993)",
      "29:790" : "29:790 (29:790 Rehabilitation of Labor)",
      "30:0181" : "30:0181 (30:181 Environment: Review of Agency Action)",
      "30:0801" : "30:0801 (30:0801 Penalities/Federal Mine Safety Health Act)",
      "30:1201" : "30:1201 (30:1201 Environment: Review of Agency Action)",
      "30:1202" : "30:1202 (30:1202 Mining Reclamation Act)",
      "30:1276" : "30:1276 (30:1276 Interior: Review of Agency Action)",
      "31:3129(h)" : "31:3129(h) (31:3129(h) False Claims Act Whistle Blower Protection)",
      "31:3545" : "31:3545 (31:3545 Action to Recovery Money)",
      "31:3729" : "31:3729 (31:3729 False Claims Act)",
      "31:3730" : "31:3730 (31:3730 Qui Tam False Claims Act)",
      "31:3731" : "31:3731 (31:3731 Fraud)",
      "31:5332(a)" : "31:5332(a) (31:5332(a) Evading Currency Reporting Requirement)",
      "31:9701" : "31:9701 (31:9701 Federal User Charge Statute)",
      "33:0905(b)" : "33:0905(b) (33:0905(b) Longshoremen Workers' Compensation Act)",
      "33:1221" : "33:1221 (Ports and Waterways Safety Act)",
      "33:1251" : "33:1251 (33:1251 Federal Water Pollution Control Act)",
      "33:1319cw" : "33:1319cw (33:1319 Clean Water Act)",
      "33:1319pv" : "33:1319pv (33:1319 Pollutants & Permit Violations)",
      "33:1365" : "33:1365 (33:1365 Environmental Matters)",
      "33:2701" : "33:2701 (33:2701 Oil Pollution Act of 1940)",
      "35:0145" : "35:0145 (35:145 Patent Infringement)",
      "35:0146" : "35:0146 (35:0146 Appeal from Decision of the Board of Patent Appeals)",
      "35:0183" : "35:0183 (35:183 Patent Infringement)",
      "35:0271" : "35:0271 (35:271 Patent Infringement)",
      "35:0297" : "35:0297 (35:0297 American Inventors Protection Act)",
      "36:0371" : "36:0371 (36:0371 Amateur Sports Act of 1978)",
      "38:0775" : "38:0775 (38:0775 Recovery of Servicemen's Group Life Insurance)",
      "38:0784" : "38:0784 (38:0784 Suit for Veterans Insurance)",
      "38:1681" : "38:1681 (38:1681 Recovery of VA Overpayment)",
      "38:1686" : "38:1686 (38:1686 Recovery of VA Overpayment)",
      "38:1780" : "38:1780 (38:1780 Recovery of VA Overpayment)",
      "38:2001" : "38:2001 (38:2001 Vietnam Veteran Readjustment Act)",
      "38:2011" : "38:2011 (38:2011 - Veteran's Readjustment Assistance Act of)",
      "38:2021" : "38:2021 (38:2021 Right to Re-employment of inducted persons)",
      "38:3116" : "38:3116 (38:3116 VA Overpayment)",
      "38:4301" : "38:4301 (38:4301 Uniformed Srvs. Employment & Reemployment Rights Act)",
      "39:3005" : "39:3005 (39:3005 Detention of Mail for Temporary Periods)",
      "39:3008(e)" : "39:3008(e) (39:3008(e) Enforce compliance with a USPS Prohibitory Order)",
      "39:409" : "39:409 (39:409 Postal Service)",
      "40:0258" : "40:0258 (40:258(a) Public Buildings & Property: Land Condem)",
      "40:0270" : "40:0270 (40:270 Miller Act)",
      "40:0275" : "40:0275 (40:0275 Condemnation (Eminent Domain))",
      "40:0276" : "40:0276 (40:0276 Davis-Bacon Act)",
      "40:0875" : "40:0875 (40:875 Public Buildings & Property: Negligence)",
      "41:0251" : "41:0251 (41:251 Public Contracts-Review of Agency Action)",
      "41:0423" : "41:0423 (41:0423 Procurement Integrity Act)",
      "41:0502" : "41:0502 (41:0502 Pennsylvania Usury Act)",
      "41:1463" : "41:1463 (41:1463 Public Contracts: Unlawful Employment Prac)",
      "42.29" : "42.29 (Bill of Lading Act 42.29 U.S.C. APP (1988 ED.) 122)",
      "42:0151" : "42:0151 (42:0151 Federal Communications Act)",
      "42:0205" : "42:0205 (42:205 Denial Social Security Benefits)",
      "42:0206" : "42:0206 (42:206 Social Security Benefits)",
      "42:0247" : "42:0247 (42:247 Personal Injury-Swine Flu)",
      "42:0402" : "42:0402 (42:402 Social Security Benefits)",
      "42:0405id" : "42:0405id (42:405 Review of HHS Decision (SSID))",
      "42:0405wc" : "42:0405wc (42:405 Review of HHS Decision (DIWC))",
      "42:0405ww" : "42:0405ww (42:405 Review of HHS Decision (DIWW))",
      "42:0416" : "42:0416 (42:416 Denial of Social Security Benefits)",
      "42:0427" : "42:0427 (42:427 Social Security Benefits)",
      "42:0601" : "42:0601 (42:0601 Title IV-A of the Social Security Act)",
      "42:11001" : "42:11001 (42:11001 Emergency Plan. & Comm. Right to Know Act (EPCRA))",
      "42:1101" : "42:1101 (42:1101 Health Care Quality Improvement Act of 1986)",
      "42:11603" : "42:11603 (42:11603(b) Int'l. Child Abduction in Remedies Act (ICARA))",
      "42:12101" : "42:12101 (42:12101 The Americans with Disabilities Act of 1990)",
      "42:1320" : "42:1320 (42:1320 01-1 Health Insurance Portability And Accountability Act (HIPAA))",
      "42:1320(a)-7b(b)(2)(A)" : "42:1320(a)-7b(b)(2)(A) (42:1320(a)-7b(b)(2)(A) Anti-Kickback Act)",
      "42:1383" : "42:1383 (42:1383 Review of HHS Decision)",
      "42:1385" : "42:1385 (42:1385 Medicare Health Act)",
      "42:1395" : "42:1395 (42:1395 HHS: Adverse Reimbursement Review)",
      "42:1396" : "42:1396 (42:1396 - Tort Negligence)",
      "42:1396sa" : "42:1396sa (42:1396 Title XIX of the Social Security Act)",
      "42:1399(dd)" : "42:1399(dd) (42:1399(dd) Emergency Medical Treatment and Active Labor Act)",
      "42:1437" : "42:1437 (42:1437 U.S. Housing Act of 1937)",
      "42:1471" : "42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclo)",
      "42:1971" : "42:1971 (42:1971 Voting Rights Law)",
      "42:1973gg" : "42:1973gg (42:1973gg-2 Nat'l. Voter Registration Act of 1993 (NVRA))",
      "42:1981cv" : "42:1981cv (42:1981 Civil Rights)",
      "42:1981hs" : "42:1981hs (42:1981 Housing Discrimination)",
      "42:1981jb" : "42:1981jb (42:1981 Job Discrimination (Race))",
      "42:1981sx" : "42:1981sx (42:1981 Sex Discrimination)",
      "42:1983cv" : "42:1983cv (42:1983 Civil Rights Act)",
      "42:1983ed" : "42:1983ed (42:1983 Civil Rights (Employment Discrimination))",
      "42:1983pr" : "42:1983pr (42:1983 Prisoner Civil Rights)",
      "42:1986" : "42:1986 (42:1986 Neglect of Duty)",
      "42:1997" : "42:1997 (42:1997 Institutionalized Persons Act of 1980)",
      "42:2000" : "42:2000 (42:2000(e)2(a) Family and Medical Leave Act)",
      "42:2000ag" : "42:2000ag (42:2000 Job Discrimination (Age))",
      "42:2000bb" : "42:2000bb (42:2000bb Religious Freedom Restoration Act of 1993)",
      "42:2000e" : "42:2000e (42:2000e Job Discrimination (Employment))",
      "42:2000pb" : "42:2000pb (42:2000 Job Discrimination (Public Accomodations))",
      "42:2000ra" : "42:2000ra (42:2000 Job Discrimination (Race))",
      "42:2000sh" : "42:2000sh (42:2000 Job Discrimination (Sexual Harassment))",
      "42:2000sx" : "42:2000sx (42:2000 Job Discrimination (Sex))",
      "42:2003" : "42:2003 (42:2003 Job Discrimination)",
      "42:2005" : "42:2005 (42:2005 Review of Agency Action-HHS)",
      "42:234" : "42:234 (42:234 Defaulted Public Health Service Corps loan)",
      "42:2615" : "42:2615 (42:2616 Medical Recovery Act)",
      "42:2651" : "42:2651 (42:2651 Medical Care Recovery)",
      "42:300" : "42:300 (42:300 Safe Drinking Water Act)",
      "42:300aa-1" : "42:300aa-1 (42:300aa-1 Nat'l. Childhood Vaccine Injury Compensation Act)",
      "42:3058" : "42:3058 (Older American's Act of 1965, 42 U.S.C. 3058(g))",
      "42:3601" : "42:3601 (42:405 Fair Housing Act)",
      "42:3604(f)" : "42:3604(f) (42:3604(f)(3)(C) Fair Housing Amendments Act)",
      "42:4000" : "42:4000 (42:4000 National Flood Insurance Act)",
      "42:4001" : "42:4001 (42:4001 National Insurance Flood Act)",
      "42:4053" : "42:4053 (42:4053 Breach of Insurance Contract)",
      "42:4072" : "42:4072 (42:4072 Payment of Flood Insurance Claim)",
      "42:4321" : "42:4321 (42:4321 Review of Agency Action-Environment)",
      "42:4332" : "42:4332 (42:4332 Environmental Policy - Coop of Agency Repo)",
      "42:5300" : "42:5300 (42:5300 Block Grant Act of 1974)",
      "42:6901en" : "42:6901en (42:6901 Environmental Cleanup Expenses)",
      "42:6901rs" : "42:6901rs (42:6901 Resource & Recovery Act)",
      "42:6972" : "42:6972 (42:6972(a) Solid Waste Disposal Act)",
      "42:7401" : "42:7401 (42:7401 Clean Air Act)",
      "42:7413" : "42:7413 (42:7413(b) Clean Air Act)",
      "42:7604cl" : "42:7604cl (42:7604 Clear Air Act (Emission Standards))",
      "42:7604ir" : "42:7604ir (42:7604 Petition to Quash IRS Summons)",
      "42:8324" : "42:8324 (42:8324 PA Storage Tank and Spill Prevention Act)",
      "42:8351" : "42:8351 (42:8351 Pennsylvania Dragonetti Act)",
      "42:9604" : "42:9604 (42:9604 Comprehensive Envir. Comp. & Liab. Act (CERCLA))",
      "42:9607" : "42:9607 (42:9607 Real Property Tort to Land)",
      "43:1421" : "43:1421 (Whistle Blower Law)",
      "43:260" : "43:260 (43:260 Wage Payment and Collection Law (WPCL))",
      "43:945" : "43:945 (43:945 Compensation for Land Condemnation)",
      "43:945a" : "43:945a (43:945a Complaint in Condemnation)",
      "43:946" : "43:946 (43:946 Complaint in Condemnation - Eminent Domain)",
      "45:0051" : "45:0051 (45:51 Railways: Fed. Employer's Liability Act)",
      "45:0151" : "45:0151 (45:151 Railway Labor Act)",
      "45:0153" : "45:0153 (45:0153, First (p) Railway Labor Act)",
      "45:0184" : "45:0184 (45:184 Action to Set Aside Award of a System Board)",
      "45:0351" : "45:0351 (45:351 Railroad Unemployment Insurance Act)",
      "45:0581(c)" : "45:0581(c) (45:0581(c) Rail Passenger Service Act)",
      "45:1395" : "45:1395 (45:1395 Railroads: Adverse Reimbursement Review)",
      "45:7457" : "45:7457 (45:7457 Compel Reclamation Under Clear Air Act)",
      "46:0183" : "46:0183 (46:0183 Exoneration, Limitation of Liability)",
      "46:0688" : "46:0688 (46:0688 Jones Act)",
      "46:0741" : "46:0741 (46:741 Shipping)",
      "46:0761" : "46:0761 (46:761 Shipping: Damages for Death on High Seas)",
      "46:1101" : "46:1101 (46:1101 Violation of Maritime Regulations)",
      "46:1156" : "46:1156 (46:1156 Administrative Procedure Act)",
      "46:1300" : "46:1300 (46:1300 Carriage of Goods by Sea Act (COGSA))",
      "46:1701" : "46:1701 (46:1701 Shipping Act of 1984)",
      "46:31301" : "46:31301 (46:31301-31343 Maritime Commercial Instruments and Liens Act)",
      "46:741" : "46:741 (46:741 Suits In Admiralty Act)",
      "46:7701" : "46:7701 (46:7701 Enforcement of a United States Coast Guard)",
      "46:781" : "46:781 (46:781 Public Vessels Act)",
      "47:0151" : "47:0151 (47:0151 Communications Act of 1934)",
      "47:0553" : "47:0553 (47:553 U.S.C.A. Cable Communications Policy Act)",
      "47:0605" : "47:0605 (47:0605 Unlawful Reception Broadcast Signal i.e., Satellite)",
      "47:227" : "47:227 (47:227(b)(3) Telephone Consumer Protection Act of 1991)",
      "47:254(h)" : "47:254(h) (47:254(h) Children's Internet Protection Act)",
      "47:332(c)" : "47:332(c) (47:332(c) Federal Telecommunications Act of 1996)",
      "47:521" : "47:521 (Cable Televsn. Consumer Protection & Competition Act of 1992)",
      "48:0883" : "48:0883 (48:883 Violation of US Coastal Law)",
      "48:1985" : "48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)",
      "49:0081" : "49:0081 (49:81 Damaged Goods While Being Transported)",
      "49:0781" : "49:0781 (49:781 Forfeiture)",
      "49:101" : "49:101 (49:101 ICC Termination Act of 1996)",
      "49:11503" : "49:11503 (49:11503 Railroad Revitalization Regulatory Reform)",
      "49:11702" : "49:11702 (49:11702(a)(4) Violations of Interstate Commerce A)",
      "49:11707" : "49:11707 (49:11707 Carmack Amendment)",
      "49:1431" : "49:1431 (49:1431 Noise Control Act of 1972)",
      "49:14501" : "49:14501 (49:14501 Preemption)",
      "49:1471" : "49:1471 (49:1471 Federal Aviation Act)",
      "49:1502" : "49:1502 (49:1502 Warsaw Convention)",
      "49:1903" : "49:1903 (49:1903 Petition to enforce administrative summon)",
      "49:20109" : "49:20109 (49:20109 Federal Railroad Safety Act of 1970)",
      "49:20301-20306" : "49:20301-20306 (49:20301-20306 Federal Safety Appliance Act)",
      "49:2101" : "49:2101 (49:2101 Aviation Safety & Noise Abatement Act of 1979)",
      "49:3102" : "49:3102 (49:3102 Federal Motor Carrier Safety Regulations Act)",
      "49:31105" : "49:31105 (49:31105 Surface Transportation Assistance Act (STAA))",
      "49:32101" : "49:32101 (49:32101 Motor Vehicle Information and Costs Savings Act)",
      "49:32701" : "49:32701 (49:32701 Odometer Requirements Act)",
      "49:41705" : "49:41705 (49:41705 Air Carrier Access Act)",
      "49:80101" : "49:80101 (49:80101 Bills of Lading Act)",
      "50:1701-06" : "50:1701-06 (50:1701-06 International Emergency Economic Powers Act)",
      "72:1301.1" : "72:1301.1 (72:1301.1 (DAUPA) Dispositon of Abandoned and Unclaimed Property Act)",
      "73:2001" : "73:2001 (73:2001 Unsolicited Merchandise Act)",
      "73:201" : "73:201 (73:201 Violation of the Pennsylvania Consumer Fraud Act, and all other Acts in the United States)",
      "73:2270" : "73:2270 (73:2270 Violation of Real Estate Settlement Procedures Act)",
      "77:0671" : "77:0671 (77:671 Pennsylvania Workers' Compensation Act)",
      "8:287" : "8:287 (8:287 Petition to Enforce INS Subpoena)",
      "99:9999" : "99:9999 (99:9999 Report cause code (DO NOT DELETE!))",
      "PA:221" : "PA:221 (PA:221 Article 5(b) of the Landlord & Tenant Act)",
      "adsup" : "adsup (Administrative Subpoena)",
      "affseizwar" : "affseizwar (Application and Affidavit for Seizure Warrant)",
      "appadm" : "appadm (Application for Admission)",
      "appcounsel" : "appcounsel (Appointment of Court Appointed Counsel)",
      "appentprem" : "appentprem (Application of the U.S. to enter premises to Effect Levy)",
      "appltrrog" : "appltrrog (Application for Letters Rogatory)",
      "appointrec" : "appointrec (Appointment of Receiver)",
      "appt" : "appt (Appointment)",
      "apptsm" : "apptsm (Appointment of Special Master)",
      "appttrust" : "appttrust (Appointment of Trustee)",
      "certL.R.12" : "certL.R.12 (Certifying Students to Practice Under L.R. 12)",
      "certLR83.5" : "certLR83.5 (Certifying Students to Practice Under L.R. 83.5)",
      "certobk" : "certobk (Certified Copy of Order from Bankruptcy Court)",
      "certousca" : "certousca (Certified Copy of Order from U.S.C.A)",
      "cmpextr" : "cmpextr (Complaint for Extadition)",
      "confarbawd" : "confarbawd (Motion for Confirmation of Arbitration Award)",
      "contempt" : "contempt (Contempt Proceedings)",
      "cpodd" : "cpodd (copy of Order from Another District Court)",
      "disbar" : "disbar (Disbarment Proceedings)",
      "eeocom" : "eeocom (Equal Employment Opportunity Commission Complaint)",
      "enfadsup" : "enfadsup (Enforcement of Administrative Subpoena)",
      "fordepo" : "fordepo (Foreign Deposition)",
      "minspwarr" : "minspwarr (Motion for Inspection Warrant Under the OSHA of 1970)",
      "misc" : "misc (Civil Miscellaneous Case)",
      "motamd" : "motamd (Motion to Amend)",
      "motappt" : "motappt (Motion to Appoint)",
      "motcomp" : "motcomp (Motion to Compel)",
      "motcompset" : "motcompset (Motion to Compel Settlement)",
      "motdisp" : "motdisp (Motion for Order to Dispose)",
      "motenf" : "motenf (Motion for Enforcement)",
      "motexpapp" : "motexpapp (Motion for Expedited Appeal)",
      "motext" : "motext (Motion to Extend Time)",
      "mothrg" : "mothrg (Motion for Hearing)",
      "motlvapp" : "motlvapp (Motion for Leave to Appeal)",
      "motorder" : "motorder (Motion for Order)",
      "motquash" : "motquash (Motion to Quash)",
      "motrel" : "motrel (Motion to Release)",
      "motret" : "motret (Motion for Return of Property)",
      "motseize" : "motseize (Motion to Seize Property)",
      "motst" : "motst (Motion to Stay)",
      "motstapp" : "motstapp (Motion for Stay Pending Appeal)",
      "motstr" : "motstr (Motion to Strike)",
      "mottn" : "mottn (Motion for Transcripts)",
      "ntcfedlien" : "ntcfedlien (Notice of Federal Lien)",
      "object" : "object (Objection)",
      "petenf" : "petenf (Petition to Enforce IRS Summons)",
      "petnat" : "petnat (Petition for Naturalization)",
      "petper" : "petper (Petition to Perpetuate Testimony)",
      "petpresevi" : "petpresevi (Petition for the Preservation of Evidence)",
      "petrev" : "petrev (Petition for Review)",
      "petserv" : "petserv (Petition for Leave to Serve John Doe Summons)",
      "petvacawd" : "petvacawd (Petition to Vacate/Modify The Award of Arbitration)",
      "regjgm" : "regjgm (Registration of Foreign Judgment)",
      "retcashbl" : "retcashbl (Return of Cash Bail)",
      "rshowcaus" : "rshowcaus (Rule to Show Cause)",
      "tranff" : "tranff (Transmission of Proposed Findings of Fact and Concl. of Law)",
      "tranrr" : "tranrr (Transmission of Report & Recommendation)",
      "writgar" : "writgar (Application for a Writ of Garnishment)"
   },
   "pamdce" : {
      "0" : "0 (No cause code entered)",
      "00:0000" : "00:0000 (00:0000 Cause Code Unknown)",
      "02:0431" : "02:0431 (02:431 Fed. Election Commission: Failure Enforce C)",
      "02:0437" : "02:0437 (02:437 Federal Election Commission)",
      "05:0075" : "05:0075 (05:75(2) Contract - Reduction in Grade)",
      "05:0551" : "05:0551 (05:551 Administrative Procedure Act)",
      "05:0552fi" : "05:0552fi (05:552 Freedom of Information Act)",
      "05:0552pa" : "05:0552pa (05:552 Right to Privacy Act)",
      "05:0554" : "05:0554 (05:0554 Constitutionality of Maritime Statutes)",
      "05:0701" : "05:0701 (05:0701 Maritime Subsidy Board)",
      "05:0702" : "05:0702 (05:702 Administrative Procedure Act)",
      "05:0704" : "05:0704 (05:704 Labor Litigation)",
      "05:7703" : "05:7703 (05:7703 Discrimination - Review of Agency Act)",
      "07:0006" : "07:0006 (7:6(b) Federal Commodity Exchange Regulation)",
      "07:0025" : "07:0025 (7:25 Fraud - Commodities Leverage Contracts)",
      "07:0181" : "07:0181 (07:181 Packers & Stockyard Act)",
      "07:0499" : "07:0499 (07:499 Agricultural Commodities Act)",
      "07:0601" : "07:0601 (07:601 USDA Condemnation)",
      "07:2023" : "07:2023 (Food Stamp Program)",
      "07:2321" : "07:2321 (07:2321 Plant Variety Protection Act)",
      "08:1105" : "08:1105 (8:1105(a) Aliens: Habeas Corpus to Release INS Det)",
      "08:1252" : "08:1252 (08:1252(a)(2) Injunction for Deportation)",
      "08:1260" : "08:1260 (08:1260 Aliens: Access to Records)",
      "08:1324" : "08:1324 (08:1324 Aliens: Complaint for Forfeiture)",
      "08:1329" : "08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petiti)",
      "08:1446" : "08:1446 (8:1446 Petition for Naturalization Hearing)",
      "09:0001" : "09:0001 (09:1 U.S. Arbitration Act)",
      "09:0009" : "09:0009 (9:9 Motion to Confirm Arbitration Loan)",
      "09:0010" : "09:0010 (09:0010 Petition to Vacate Arbitration Award)",
      "10:1552" : "10:1552 (10:1552 Armed Forces: Action to Correct Records)",
      "10:1553" : "10:1553 (10:1553 Armed Forces: FOIA General)",
      "10:2305" : "10:2305 (10:2305 Review of Federal Contract)",
      "11:0101" : "11:0101 (11:101 Bankruptcy)",
      "12:0022" : "12:0022 (12:22 Securities Fraud)",
      "12:0635" : "12:0635 (12:635 Breach of Insurance Contract)",
      "12:1421" : "12:1421 (12:1421 FIRREA-Confession of Judgment)",
      "12:1441" : "12:1441 (12:1441 Resolution Trust Corporation)",
      "12:1461" : "12:1461 (12:1461 Homeowners Loan Act)",
      "12:1703" : "12:1703 (12:1703 Default of HUD Loan)",
      "12:1725" : "12:1725 (12:1725 Collection under Contract Guaranty)",
      "12:1730" : "12:1730 (12:1730 Collection Under Contract Guaranty)",
      "12:1819" : "12:1819 (12:1819 Default of Promissory Note)",
      "12:1821" : "12:1821 (12:1821 Default of Loan by Promissary Note)",
      "12:1971" : "12:1971 (12:1971 Relief under Bank Holding Act)",
      "12:2607" : "12:2607 (12:2607 Real Estate Settlement Procedures Act)",
      "12:3410" : "12:3410 (12:3410 Right to Financial Privacy Act)",
      "15:0001" : "15:0001 (15:1 Antitrust Litigation)",
      "15:0002at" : "15:0002at (15:2 Antitrust Litigation)",
      "15:0002fl" : "15:0002fl (15:2(a) Fair Labor Standards Act)",
      "15:0005" : "15:0005 (15:5(a) Fair Labor Standards Act)",
      "15:0015" : "15:0015 (15:15 Antitrust Litigation)",
      "15:0025" : "15:0025 (15:25 Clayton Act)",
      "15:0044" : "15:0044 (15:44 Trademark Infringement)",
      "15:0045" : "15:0045 (15:0045 Federal Trade Commission Act)",
      "15:0052" : "15:0052 (15:0052 Federal Trade Commission Act)",
      "15:0053" : "15:0053 (15:0053 Federal Trade Commission Act)",
      "15:0077" : "15:0077 (15:77 Securities Fraud)",
      "15:0078" : "15:0078 (15:78m(a) Securities Exchange Act)",
      "15:0631" : "15:0631 (15:631 Small Business Act)",
      "15:0717" : "15:0717 (15:717 Natural Gas Act)",
      "15:1051" : "15:1051 (15:1051 Trademark Infringement)",
      "15:1114" : "15:1114 (15:1114 Trademark Infringement)",
      "15:1121" : "15:1121 (15:1121 Trademark Infringement)",
      "15:1125" : "15:1125 (15:1125 Trademark Infringement (Lanham Act))",
      "15:1126" : "15:1126 (15:1126 Patent Infringement)",
      "15:1127" : "15:1127 (15:1127 Trademark Infringement)",
      "15:1601" : "15:1601 (15:1601 Truth in Lending)",
      "15:1640" : "15:1640 (15:1640 Truth in Lending)",
      "15:1681" : "15:1681 (15:1681 Fair Credit Reporting Act)",
      "15:1692" : "15:1692 (15:1692 Fair Debt Collection Act)",
      "15:1693" : "15:1693 (15:1693 Credit Card Accountability, Responsibility & Disclosure Act)",
      "15:1938" : "15:1938 (15:1938 Fair Labor Standards Act)",
      "15:1981" : "15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))",
      "15:1988" : "15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))",
      "15:1989" : "15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))",
      "15:2301" : "15:2301 (15:2301 Magnuson-Moss Warranty Act)",
      "15:2801" : "15:2801 (15:2801 Petroleum Marketing Practices Act)",
      "15:53(b)" : "15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equita)",
      "15:6501" : "15:6501 (15:6501 Children's Online Privacy Protection Act of 1998)",
      "16:0668" : "16:0668 (16:668 Bald Eagle Protection Act)",
      "16:0703" : "16:0703 (16:703 Migratory Bird Act)",
      "16:1538" : "16:1538 (16:1538 Endangered Species Act)",
      "16:3371" : "16:3371 (16:3371 Wildlife Under the Lacey Act)",
      "16:3372" : "16:3372 (16:3372 Conservation: Complaint for Forfeiture)",
      "16:3373" : "16:3373 (16:3373 Appeal of Decision - DOI)",
      "16:3374" : "16:3374 (16:3374 Conservation: Complaint for Forfeiture)",
      "16:817" : "16:817 (Federal Energy Regulatory Commission (FERC))",
      "17:0101" : "17:0101 (17:101 Copyright Infringement)",
      "17:0501" : "17:0501 (17:501 Copyright Infringement)",
      "17:0504" : "17:0504 (17:504 Copyright Infringement)",
      "18:0241" : "18:0241 (18:241 Conspiracy Against Citizen Rights)",
      "18:1345" : "18:1345 (18:1345 Injunction against Fraud)",
      "18:1836a" : "18:1836a (18:1836(a) Injunction against Misappropriation of Trade Secrets)",
      "18:1836b" : "18:1836b (18:1836(b) Civil Action to Protect Trade Secrets)",
      "18:1955" : "18:1955 (18:1955 Compl for forfeiture in Rem)",
      "18:1961" : "18:1961 (18:1961 Racketeering (RICO) Act)",
      "18:1962" : "18:1962 (18:1962 Racketeering (RICO) Act)",
      "18:1964" : "18:1964 (18:1964 Racketeering (RICO) Act)",
      "18:4208" : "18:4208 (18:4208(B) Agency Action Review)",
      "19:1305" : "19:1305 (19:1305 Custom Duties:0Forfeiture-Immoral Articles)",
      "20:1070" : "20:1070 (20:1070 To assist in making available the benefits of postsecondary education to eligible students)",
      "20:1080" : "20:1080 (20:1080 Student Loan Recovery)",
      "20:1400" : "20:1400 (20:1400 Civil Rights of Handicapped Child)",
      "20:1401" : "20:1401 (20:1401 Education: Handicapped Child Act)",
      "21:0332" : "21:0332 (21:0332 Food, Drug, Cosmetic Misbranding or Adulterating)",
      "21:0841" : "21:0841 (21:841 Forfeiture Property-Drugs)",
      "21:0881" : "21:0881 (21:881 Forfeiture Property-Drugs)",
      "21:0881a" : "21:0881a (21:881 Forfeiture Property - Aircraft)",
      "21:0881re" : "21:0881re (21:881 Forfeiture Property - Real Estate)",
      "23:0134" : "23:0134 (23:134 P.I.- Auto Negligence)",
      "23:1441" : "23:1441 (23:1441 Contract Real Estate)",
      "24:1000" : "24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)",
      "25:0640" : "25:0640 (25:640 Indian Tribal Rights)",
      "25:1901" : "25:1901 (25:1901 Indian Child Welfare Act)",
      "26:6212" : "26:6212 (26:6212 Injunctive Relief from IRS Lien)",
      "26:6213" : "26:6213 (26:6213 Injunctive Relief from IRS Lien)",
      "26:6502" : "26:6502 (26:6502 IRS:Enforcement of tax liens)",
      "26:6532" : "26:6532 (26:6532 IRS: Refund of Tax Penalty)",
      "26:6702" : "26:6702 (26:6702 IRS: Refund of Income Tax Penalty)",
      "26:6703" : "26:6703 (26:6703 IRS: Refund of Tax Penalty)",
      "26:7401" : "26:7401 (26:7401 IRS: Tax Liability)",
      "26:7402" : "26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)",
      "26:7403" : "26:7403 (26:7403 Suit to Enforce Federal Tax Lien)",
      "26:7422rt" : "26:7422rt (26:7422 IRS: Refund Taxes)",
      "26:7422rx" : "26:7422rx (26:7422 IRS: Refund Excise Tax)",
      "26:7426" : "26:7426 (26:7426 IRS: Wrongful Levy for Taxes)",
      "26:7429" : "26:7429 (26:7429 IRS: Tax Jeopardy Assessment)",
      "26:7609" : "26:7609 (26:7609 IRS: Petition to Quash IRS Summons)",
      "27:0185" : "27:0185 (27:185 Enforcement of Arbitration Award)",
      "28:0157c" : "28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)",
      "28:0157d" : "28:0157d (28:0157 Motion for Withdrawal of Reference)",
      "28:0158" : "28:0158 (28:0158 Notice of Appeal re Bankruptcy Matter (BA)",
      "28:0185" : "28:0185 (28:185 Suit to Compel Arbitration)",
      "28:0451" : "28:0451 (28:451 Employment Discrimination)",
      "28:0794" : "28:0794 (28:794 Rehabilitation Act)",
      "28:1001" : "28:1001 (28:1001 E.R.I.S.A.)",
      "28:1132" : "28:1132 (28:1132 E.R.I.S.A.)",
      "28:1330" : "28:1330 (28:1330 Breach of Contract)",
      "28:1331" : "28:1331 (28:1331 Fed. Question)",
      "28:1331al" : "28:1331al (28:1331 Fed. Question: Airline Crash)",
      "28:1331ap" : "28:1331ap (28:1331 Fed. Question: Civil Rights (FILE DATE: 3/25/98))",
      "28:1331at" : "28:1331at (28:1331 Fed. Question: Anti-trust)",
      "28:1331au" : "28:1331au (28:1331 Fed. Question: Auto Negligence)",
      "28:1331b" : "28:1331b (28:1331 Federal Question: Bivens Act)",
      "28:1331bc" : "28:1331bc (28:1331 Fed. Question: Breach of Contract)",
      "28:1331ca" : "28:1331ca (28:1331 Fed Question: Fed Communications Act of 1)",
      "28:1331cm" : "28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)",
      "28:1331cv" : "28:1331cv (28:1331 Federal Question: Other Civil Rights)",
      "28:1331ed" : "28:1331ed (28:1331 Fed. Question: Employment Discrimination)",
      "28:1331es" : "28:1331es (28:1331 Enforcement of Administrative Subpoena)",
      "28:1331fl" : "28:1331fl (28:1331 Fed. Question: Fair Labor Standards)",
      "28:1331in" : "28:1331in (28:1331 Fed. Question: Insurance Contract)",
      "28:1331mm" : "28:1331mm (28:1331 Fed. Question: Medical Malpractice)",
      "28:1331pi" : "28:1331pi (28:1331 Fed. Question: Personal Injury)",
      "28:1331rd" : "28:1331rd (28:1331 Fed. Question: Review Agency Decision)",
      "28:1331rp" : "28:1331rp (28:1331(a) Fed. Question: Real Property)",
      "28:1331rr" : "28:1331rr (28:1331 Fed. Question: Railway Labor Act)",
      "28:1331sv" : "28:1331sv (28:1331 Fed. Question: Securities Violation)",
      "28:1331tr" : "28:1331tr (28:1331 Fed. Question: Trademark)",
      "28:1331tt" : "28:1331tt (28:1331 Fed. Question: Tort Action)",
      "28:1331v" : "28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendme)",
      "28:1331wl" : "28:1331wl (28:1331 Federal Question: EPA Waste Lien)",
      "28:1331wt" : "28:1331wt (28:1331 Fed. Question: Water Rights)",
      "28:1332ac" : "28:1332ac (28:1332 Diversity-Account Receivable)",
      "28:1332al" : "28:1332al (28:1332 Diversity-Airline Crash)",
      "28:1332as" : "28:1332as (28:1332 Diversity-Asbestos Litigation)",
      "28:1332au" : "28:1332au (28:1332 Diversity-Auto Negligence)",
      "28:1332bc" : "28:1332bc (28:1332 Diversity-Breach of Contract)",
      "28:1332co" : "28:1332co (28:1332 Diversity-Conversion)",
      "28:1332ct" : "28:1332ct (28:1332 Diversity-(Citizenship))",
      "28:1332det" : "28:1332det (28:1332 Diversity: Forcible Detainer)",
      "28:1332df" : "28:1332df (28:1332 Diversity-Contract Default)",
      "28:1332ds" : "28:1332ds (28:1332 Diversity-Contract Dispute)",
      "28:1332ed" : "28:1332ed (28:1332 Diversity-Employment Discrimination)",
      "28:1332fd" : "28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)",
      "28:1332fr" : "28:1332fr (28:1332 Diversity-Fraud)",
      "28:1332ia" : "28:1332ia (28:1332 Diversity-Interpleader Action)",
      "28:1332ij" : "28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)",
      "28:1332in" : "28:1332in (28:1332 Diversity-Insurance Contract)",
      "28:1332jd" : "28:1332jd (28:1332 Diversity-Declaratory Judgement)",
      "28:1332lb" : "28:1332lb (28:1332 Diversity-Libel,Assault,Slander)",
      "28:1332lm" : "28:1332lm (28:1332 Diversity - Legal Malpractice)",
      "28:1332ma" : "28:1332ma (28:1332 Diversity-Miller Act)",
      "28:1332mm" : "28:1332mm (28:1332 Diversity-Medical Malpractice)",
      "28:1332mv" : "28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)",
      "28:1332ni" : "28:1332ni (28:1332 Diversity-Negotiable Instrument)",
      "28:1332nm" : "28:1332nm (28:1332 Diversity-Non-Motor Vehicle)",
      "28:1332oc" : "28:1332oc (28:1332 Diversity-Other Contract)",
      "28:1332pd" : "28:1332pd (28:1332 Diversity-Property Damage)",
      "28:1332pi" : "28:1332pi (28:1332 Diversity-Personal Injury)",
      "28:1332pl" : "28:1332pl (28:1332 Diversity-Product Liability)",
      "28:1332pr" : "28:1332pr (28:1332 Diversity-Petition for Removal)",
      "28:1332qt" : "28:1332qt (28:1332 Diversity-Petition to Quiet Title)",
      "28:1332ri" : "28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)",
      "28:1332sa" : "28:1332sa (28:1332 - Diversity: Securities & Exchange Commiss)",
      "28:1332sf" : "28:1332sf (28:1332 - Diversity: Securities Fraud)",
      "28:1332ss" : "28:1332ss (28:1332 Diversity - Stockholders Suits)",
      "28:1332tl" : "28:1332tl (28:1332 Diversity-Torts to Land)",
      "28:1332tm" : "28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))",
      "28:1332tn" : "28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)",
      "28:1332wd" : "28:1332wd (28:1332 Diversity-Wrongful Death)",
      "28:1333" : "28:1333 (28:1333 Admiralty)",
      "28:1334" : "28:1334 (28:1334 Bankruptcy Appeal)",
      "28:1334c" : "28:1334c (28:1334(c) R&R re motions for abstention (non-cor)",
      "28:1335" : "28:1335 (28:1335 Interpleader Action)",
      "28:1337" : "28:1337 (28:1337 Sherman-Clayton Act)",
      "28:1338cp" : "28:1338cp (28:1338 Copyright Infringement)",
      "28:1338pt" : "28:1338pt (28:1338 Patent Infringement)",
      "28:1338tr" : "28:1338tr (28:1338 Trademark Infringement)",
      "28:1340" : "28:1340 (28:1340 IRS: Custom Duties)",
      "28:1340er" : "28:1340er (28:1340 Recovery of Erroneous Refund)",
      "28:1341" : "28:1341 (28:1341 Complaint for Forfeiture)",
      "28:1343" : "28:1343 (28:1343 Violation of Civil Rights)",
      "28:1345" : "28:1345 (28:1345 Default on Loan)",
      "28:1345co" : "28:1345co (28:1345 Replevin & Conversion)",
      "28:1345db" : "28:1345db (28:1345 Debt to US - FHA/HUD Title I)",
      "28:1345df" : "28:1345df (28:1345 Default of Promissory Note)",
      "28:1345er" : "28:1345er (28:1345 Recovery of Erroneous Refund)",
      "28:1345fc" : "28:1345fc (28:1345 Foreclosure)",
      "28:1345ff" : "28:1345ff (28:1345 Complaint for Forfeiture)",
      "28:1345hl" : "28:1345hl (28:1345 VA Home Loan Guaranty Debt)",
      "28:1345mc" : "28:1345mc (28:1345 Medical Care Recovery)",
      "28:1345mi" : "28:1345mi (28:1345 Mining Claim Ejectment)",
      "28:1345pd" : "28:1345pd (28:1345 Property Damage)",
      "28:1345pe" : "28:1345pe (28:1345 Property Ejectment)",
      "28:1345rc" : "28:1345rc (28:1345 Recovery of Debt to US)",
      "28:1345st" : "28:1345st (28:1345 Default of Student Loan)",
      "28:1345tp" : "28:1345tp (28:1345 Trespass on Public Land)",
      "28:1345va" : "28:1345va (28:1345 Recovery of VA Overpayment)",
      "28:1346bc" : "28:1346bc (28:1346 Breach of Contract)",
      "28:1346rc" : "28:1346rc (28:1346 Recovery of IRS Tax)",
      "28:1346tc" : "28:1346tc (28:1346 Tort Claim)",
      "28:1346wd" : "28:1346wd (28:1346 Wrongful Death)",
      "28:1352" : "28:1352 (28:1352 Miller Act)",
      "28:1355" : "28:1355 (28:1355 Petition for Return of Property)",
      "28:1358" : "28:1358 (28:1358 Land Condemnation)",
      "28:1361" : "28:1361 (28:1361 Petition for Writ of Mandamus)",
      "28:1362ic" : "28:1362ic (28:1362 Indian Tribal Controversy)",
      "28:1362iw" : "28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)",
      "28:1364" : "28:1364 (28:1364 Auto Negligence)",
      "28:1391" : "28:1391 (28:1391 Personal Injury)",
      "28:1402" : "28:1402 (28:1402 Medical Malpractice)",
      "28:1407" : "28:1407 (28:1407 Airline Crash)",
      "28:1441ac" : "28:1441ac (28:1441 Petition for Removal- Account Receivable)",
      "28:1441al" : "28:1441al (28:1441 Petition for Removal- Airline Crash)",
      "28:1441as" : "28:1441as (28:1441 Petition for Removal- Asbestos Litigation)",
      "28:1441au" : "28:1441au (28:1441 Petition for Removal- Auto Negligence)",
      "28:1441bc" : "28:1441bc (28:1441 Petition for Removal- Breach of Contract)",
      "28:1441cv" : "28:1441cv (28:1441 Petition for Removal- Civil Rights Act)",
      "28:1441df" : "28:1441df (28:1441 Petition for Removal- Contract Default)",
      "28:1441dj" : "28:1441dj (28:1441 Petition for Removal- Declaratory Judgemen)",
      "28:1441ds" : "28:1441ds (28:1441 Petition for Removal- Contract Dispute)",
      "28:1441ed" : "28:1441ed (28:1441 Petition for Removal - Employment Discrim)",
      "28:1441fc" : "28:1441fc (28:1441 Petition for Removal - Fair Credit Reporti)",
      "28:1441fr" : "28:1441fr (28:1441 Petition for Removal- Fraud)",
      "28:1441ij" : "28:1441ij (28:1441 Petition for Removal- Injunctive/Declarato)",
      "28:1441in" : "28:1441in (28:1441 Petition for Removal- Insurance Contract)",
      "28:1441int" : "28:1441int (28:1441 Petition for Removal- Action for Interplea)",
      "28:1441lb" : "28:1441lb (28:1441 Petition for Removal Libel,Assault,Slander)",
      "28:1441lm" : "28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relatio)",
      "28:1441mm" : "28:1441mm (28:1441 Petition for Removal- Medical Malpractice)",
      "28:1441ni" : "28:1441ni (28:1441 Petition for Removal- Negotiable Instrumen)",
      "28:1441nm" : "28:1441nm (28:1441 Petition for Removal- Non-Motor Vehicle)",
      "28:1441oc" : "28:1441oc (28:1441 Petition For Removal--Other Contract)",
      "28:1441pd" : "28:1441pd (28:1441 Petition for Removal- Property Damage)",
      "28:1441pi" : "28:1441pi (28:1441 Petition for Removal- Personal Injury)",
      "28:1441pl" : "28:1441pl (28:1441 Petition for Removal- Product Liability)",
      "28:1441pr" : "28:1441pr (28:1441 Petition for Removal)",
      "28:1441qt" : "28:1441qt (28:1441 Petition for Removal- Petition to Quiet Ti)",
      "28:1441ri" : "28:1441ri (28:1441 Petition for Removal- Racketeering (RICO))",
      "28:1441sa" : "28:1441sa (28:1441 - Petition for Removal: SEC Act)",
      "28:1441sf" : "28:1441sf (28:1441 - Petition for Removal: Securities Fraud)",
      "28:1441tl" : "28:1441tl (28:1441 Petition for Removal- Torts to Land)",
      "28:1441tm" : "28:1441tm (28:1441 Petition for Removal- Tort/Motor Vehicle ()",
      "28:1441tn" : "28:1441tn (28:1441 Petition for Removal- Tort/Non-Motor Vehic)",
      "28:1441wd" : "28:1441wd (28:1441 Petition for Removal- Wrongful Death)",
      "28:1442a" : "28:1442a (28:1442a-Removal:Members of armed forces sued or prosecuted)",
      "28:1442bc" : "28:1442bc (28:1442 Petition for Removal- Breach of Contract)",
      "28:1442pr" : "28:1442pr (28:1442 Petition for Removal)",
      "28:1443" : "28:1443 (28:1443(1) Rent, Lease & Ejectment)",
      "28:1444" : "28:1444 (28:1444 Petition for Removal- Foreclosure)",
      "28:1446in" : "28:1446in (28:1446 Breach of Contract- Insurance)",
      "28:1446pd" : "28:1446pd (28:1446 Petition for Removal- Property Damage (P.I)",
      "28:1446pi" : "28:1446pi (28:1446 Petition for Removal- Personal Injury)",
      "28:1446pl" : "28:1446pl (28:1446pl Petition for Removal - Product Liability)",
      "28:1446pr" : "28:1446pr (28:1446 Petition for Removal)",
      "28:1452" : "28:1452 (28:1452 R&R re motions to remand (non-core))",
      "28:1651" : "28:1651 (28:1651 Petition for Writ of Coram Nobis)",
      "28:1651hc" : "28:1651hc (28:1651 Petition for Writ of Habeas Corpus)",
      "28:1651mn" : "28:1651mn (28:1651 Petition for Writ of Mandamus)",
      "28:1983" : "28:1983 (28:1983 Civil Rights)",
      "28:2201" : "28:2201 (28:2201 Constitutionality of State Statute(s))",
      "28:2201dj" : "28:2201dj (28:2201 Declaratory Judgement)",
      "28:2201ij" : "28:2201ij (28:2201 Injunction)",
      "28:2201in" : "28:2201in (28:2201 Declaratory Judgement (Insurance))",
      "28:2241" : "28:2241 (28:2241 Petition for Writ of Habeas Corpus (federa)",
      "28:2241in" : "28:2241in (28:2241 Petition for Writ of Habeas Corpus (IMMIGRATION))",
      "28:2254" : "28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))",
      "28:2254in" : "28:2254in (28:2254 State Petn for Writ of Habeas Corpus (IMMIGRATION))",
      "28:2254se" : "28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)",
      "28:2255" : "28:2255 (28:2255 Motion to Vacate / Correct Illegal Sentenc)",
      "28:2271" : "28:2271 (28:2271 Federal Tort Claims Act)",
      "28:2345" : "28:2345 (28:2345 Medicare Recovery)",
      "28:2409" : "28:2409 (28:2409(a) Quiet Title Action)",
      "28:2410" : "28:2410 (28:2410 Quiet Title)",
      "28:2671" : "28:2671 (28:2671 Federal Tort Claims Act)",
      "28:2674" : "28:2674 (28:2674 Federal Tort Claims Act)",
      "28:7402" : "28:7402 (28:7402 Refund of Taxes)",
      "28:7422" : "28:7422 (28:7422 Appeal from Administrative Decision)",
      "29:0151" : "29:0151 (29:151 Labor: Review of Agency Action)",
      "29:0160" : "29:0160 (29:160(1) National Labor Relations Act)",
      "29:0184" : "29:0184 (29:184 Violation Collection Bargain Agreement)",
      "29:0185ep" : "29:0185ep (29:185 Employee Pension Plan)",
      "29:0185lm" : "29:0185lm (29:185 Labor/Mgt. Relations (Contracts))",
      "29:0201" : "29:0201 (29:0201 Violation of Fair Labor Act of 1938)",
      "29:0201do" : "29:0201do (29:201 Denial of Overtime Compensation)",
      "29:0201fl" : "29:0201fl (29:201 Fair Labor Standards Act)",
      "29:0203" : "29:0203 (29:203 Equal Pay Act)",
      "29:0206" : "29:0206 (29:206 Collect Unpaid Wages)",
      "29:0401" : "29:0401 (29:0401 Labor Management Disclosure Act)",
      "29:0621" : "29:0621 (29:621 Job Discrimination (Age))",
      "29:0623" : "29:0623 (29:623 Job Discrimination (Age))",
      "29:0626" : "29:0626 (29:626 Job Discrimination (Age))",
      "29:0633" : "29:0633 (29:633 Job Discrimination (Age))",
      "29:0651" : "29:0651 (29:651 Occupational Safety/Health)",
      "29:0754" : "29:0754 (29:754 Discrimination)",
      "29:0791" : "29:0791 (29:791 Job Discrimination (Rehabilitation Act))",
      "29:0794" : "29:0794 (29:0794 Job Discrimination (Handicap))",
      "29:1001" : "29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)",
      "29:1002" : "29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)",
      "29:1104" : "29:1104 (29:1104 Recovery of Benefits to Employee)",
      "29:1109" : "29:1109 (29:1109 Breach of Fiduciary Duties)",
      "29:1131" : "29:1131 (29:1131 ERISA - Collection of Delinquent Trust Fun)",
      "29:1132" : "29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)",
      "29:1145" : "29:1145 (29:1145 E.R.I.S.A.)",
      "29:1149" : "29:1149 (29:1149 Recover Pension & Profit Sharing)",
      "29:1332" : "29:1332 (29:1332 Age Discrimination)",
      "29:1337" : "29:1337 (29:1337 E.R.I.S.A.)",
      "29:1362" : "29:1362 (29:1362 ERISA)",
      "29:1381" : "29:1381 (29:1381 E.R.I.S.A.)",
      "29:1401" : "29:1401 (29:1401(b)(2) Appeal of Arbitration Award)",
      "29:1451" : "29:1451 (29:1451 E.R.I.S.A.)",
      "29:1801" : "29:1801 (29:1801 Farmworker Rights)",
      "29:2101" : "29:2101 (29:2101 Worker Adjustment & Retraining Notification Act)",
      "29:2611" : "29:2611 (29:2611 Family and Medical Leave Act of 1993)",
      "29:790" : "29:790 (29:790 Rehabilitation of Labor)",
      "30:0181" : "30:0181 (30:181 Environment: Review of Agency Action)",
      "30:0801" : "30:0801 (30:0801 Penalities/Federal Mine Safety Health Act)",
      "30:1201" : "30:1201 (30:1201 Environment: Review of Agency Action)",
      "30:1202" : "30:1202 (30:1202 Mining Reclamation Act)",
      "30:1276" : "30:1276 (30:1276 Interior: Review of Agency Action)",
      "30:801" : "30:801 (Fed. Mine Safety & Health)",
      "31:3545" : "31:3545 (31:3545 Action to Recovery Money)",
      "31:3729" : "31:3729 (31:3729 False Claims Act)",
      "31:3730" : "31:3730 (31:3730 Qui Tam False Claims Act)",
      "31:3731" : "31:3731 (31:3731 Fraud)",
      "33:1319cw" : "33:1319cw (33:1319 Clean Water Act)",
      "33:1319pv" : "33:1319pv (33:1319 Pollutants & Permit Violations)",
      "33:1365" : "33:1365 (33:1365 Environmental Matters)",
      "35:0145" : "35:0145 (35:145 Patent Infringement)",
      "35:0183" : "35:0183 (35:183 Patent Infringement)",
      "35:0271" : "35:0271 (35:271 Patent Infringement)",
      "38:1681" : "38:1681 (38:1681 Recovery of VA Overpayment)",
      "38:1686" : "38:1686 (38:1686 Recovery of VA Overpayment)",
      "38:1780" : "38:1780 (38:1780 Recovery of VA Overpayment)",
      "38:2011" : "38:2011 (38:2011 - Veteran's Readjustment Assistance Act of)",
      "38:3116" : "38:3116 (38:3116 VA Overpayment)",
      "38:4301" : "38:4301 (38:4301 Employment and Re-Employment Rights of Members of Uniformed Services)",
      "39:3005" : "39:3005 (39:3005 Detention of Mail for Temporary Periods)",
      "39:409" : "39:409 (39:409 Postal Service)",
      "40:0257" : "40:0257 (40:0257 Land Condemnation)",
      "40:0258" : "40:0258 (40:258(a) Public Buildings & Property: Land Condem)",
      "40:0270" : "40:0270 (40:270 Miller Act)",
      "40:0875" : "40:0875 (40:875 Public Buildings & Property: Negligence)",
      "41:0251" : "41:0251 (41:251 Public Contracts-Review of Agency Action)",
      "41:1463" : "41:1463 (41:1463 Public Contracts: Unlawful Employment Prac)",
      "42:0205" : "42:0205 (42:205 Denial Social Security Benefits)",
      "42:0206" : "42:0206 (42:206 Social Security Benefits)",
      "42:0247" : "42:0247 (42:247 Personal Injury-Swine Flu)",
      "42:0402" : "42:0402 (42:402 Social Security Benefits)",
      "42:0405id" : "42:0405id (42:405 Review of HHS Decision (SSID))",
      "42:0405wc" : "42:0405wc (42:405 Review of HHS Decision (DIWC))",
      "42:0405ww" : "42:0405ww (42:405 Review of HHS Decision (DIWW))",
      "42:0416" : "42:0416 (42:416 Denial of Social Security Benefits)",
      "42:0427" : "42:0427 (42:427 Social Security Benefits)",
      "42:12101" : "42:12101 (42:12101 Americans With Disabilities Act of 1990)",
      "42:12189" : "42:12189 (Accessibility to the Handicapped)",
      "42:1383" : "42:1383 (42:1383 Review of HHS Decision)",
      "42:1395" : "42:1395 (42:1395 HHS: Adverse Reimbursement Review)",
      "42:1396" : "42:1396 (42:1396 - Tort Negligence)",
      "42:1471" : "42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclo)",
      "42:1981cv" : "42:1981cv (42:1981 Civil Rights)",
      "42:1981hs" : "42:1981hs (42:1981 Housing Discrimination)",
      "42:1981jb" : "42:1981jb (42:1981 Job Discrimination (Race))",
      "42:1981sx" : "42:1981sx (42:1981 Sex Discrimination)",
      "42:1983cv" : "42:1983cv (42:1983 Civil Rights Act)",
      "42:1983ed" : "42:1983ed (42:1983 Civil Rights (Employment Discrimination))",
      "42:1983pr" : "42:1983pr (42:1983 Prisoner Civil Rights)",
      "42:1986" : "42:1986 (42:1986 Neglect of Duty)",
      "42:2000ag" : "42:2000ag (42:2000 Job Discrimination (Age))",
      "42:2000e" : "42:2000e (42:2000e Job Discrimination (Employment))",
      "42:2000pb" : "42:2000pb (42:2000 Job Discrimination (Public Accomodations))",
      "42:2000ra" : "42:2000ra (42:2000 Job Discrimination (Race))",
      "42:2000sx" : "42:2000sx (42:2000 Job Discrimination (Sex))",
      "42:2003" : "42:2003 (42:2003 Job Discrimination)",
      "42:2005" : "42:2005 (42:2005 Review of Agency Action-HHS)",
      "42:2651" : "42:2651 (42:2651 Medical Care Recovery)",
      "42:3601" : "42:3601 (42:405 Fair Housing Act)",
      "42:4000" : "42:4000 (42:4000 National Flood Insurance Act)",
      "42:4001" : "42:4001 (42:4001 National Insurance Flood Act)",
      "42:4053" : "42:4053 (42:4053 Breach of Insurance Contract)",
      "42:4072" : "42:4072 (42:4072 Payment of Flood Insurance Claim)",
      "42:425" : "42:425 (42:427 Social Security Benenfits)",
      "42:4321" : "42:4321 (42:4321 Review of Agency Action-Environment)",
      "42:4332" : "42:4332 (42:4332 Environmental Policy - Coop of Agency Repo)",
      "42:6901en" : "42:6901en (42:6901 Environmental Cleanup Expenses)",
      "42:6901rs" : "42:6901rs (42:6901 Resource & Recovery Act)",
      "42:7413" : "42:7413 (42:7413(b) Clean Air Act)",
      "42:7604cl" : "42:7604cl (42:7604 Clear Air Act (Emission Standards))",
      "42:7604ir" : "42:7604ir (42:7604 Petition to Quash IRS Summons)",
      "42:9607" : "42:9607 (42:9607 Real Property Tort to Land)",
      "43:945" : "43:945 (43:945 Compensation for Land Condemnation)",
      "43:945a" : "43:945a (43:945a Complaint in Condemnation)",
      "43:946" : "43:946 (43:946 Complaint in Condemnation - Eminent Domain)",
      "45:0051" : "45:0051 (45:51 Railways: Fed. Employer's Liability Act)",
      "45:0151" : "45:0151 (45:151 Railway Labor Act)",
      "45:0184" : "45:0184 (45:184 Action to Set Aside Award of a System Board)",
      "45:1395" : "45:1395 (45:1395 Railroads: Adverse Reimbursement Review)",
      "45:7457" : "45:7457 (45:7457 Compel Reclamation Under Clear Air Act)",
      "46:0688" : "46:0688 (46:688 Jones Act)",
      "46:0741" : "46:0741 (46:741 Shipping)",
      "46:0761" : "46:0761 (46:761 Shipping: Damages for Death on High Seas)",
      "46:1101" : "46:1101 (46:1101 Violation of Maritime Regulations)",
      "46:1156" : "46:1156 (46:1156 Administrative Procedure Act)",
      "47:0151" : "47:0151 (47:0151 Telecommunications Act of 1996)",
      "47:0605" : "47:0605 (47:0605 Unlawful Reception Broadcast Signal)",
      "47:332" : "47:332 (47:332 Telecommunications Act)",
      "48:0883" : "48:0883 (48:883 Violation of US Coastal Law)",
      "48:1985" : "48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)",
      "49:0081" : "49:0081 (49:81 Damaged Goods While Being Transported)",
      "49:0781" : "49:0781 (49:781 Forfeiture)",
      "49:11503" : "49:11503 (49:11503 Railroad Revitalization Regulatory Reform)",
      "49:11702" : "49:11702 (49:11702(a)(4) Violations of Interstate Commerce A)",
      "49:1471" : "49:1471 (49:1471 Federal Aviation Act)",
      "49:1903" : "49:1903 (49:1903 Petition to enforce administrative summon)",
      "8:1154" : "8:1154 (8:1154 Immigration and Nationality Act)",
      "8:287" : "8:287 (8:287 Petition to Enforce INS Subpoena)",
      "misc" : "misc (Civil Miscellaneous Case)"
   },
   "pawdce" : {
      "0" : "0 (no cause specified)",
      "02:0431" : "02:0431 (02:431 Fed. Election Commission: Failure Enforce C)",
      "02:0437" : "02:0437 (02:437 Federal Election Commission)",
      "05:0075" : "05:0075 (05:75(2) Contract - Reduction in Grade)",
      "05:0551" : "05:0551 (05:551 Administrative Procedure Act)",
      "05:0552fi" : "05:0552fi (05:552 Freedom of Information Act)",
      "05:0552pa" : "05:0552pa (05:552 Right to Privacy Act)",
      "05:0554" : "05:0554 (05:0554 Constitutionality of Maritime Statutes)",
      "05:0701" : "05:0701 (05:0701 Maritime Subsidy Board)",
      "05:0702" : "05:0702 (05:702 Administrative Procedure Act)",
      "05:0704" : "05:0704 (05:704 Labor Litigation)",
      "05:7703" : "05:7703 (05:7703 Discrimination - Review of Agency Act)",
      "07:0006" : "07:0006 (7:6(b) Federal Commodity Exchange Regulation)",
      "07:0025" : "07:0025 (7:25 Fraud - Commodities Leverage Contracts)",
      "07:0181" : "07:0181 (07:181 Packers & Stockyard Act)",
      "07:0499" : "07:0499 (07:499 Agricultural Commodities Act)",
      "07:0601" : "07:0601 (07:601 USDA Condemnation)",
      "07:2321" : "07:2321 (07:2321 Plant Variety Protection Act)",
      "08:1105" : "08:1105 (8:1105(a) Aliens: Habeas Corpus to Release INS Det)",
      "08:1252" : "08:1252 (08:1252(a)(2) Injunction for Deportation)",
      "08:1260" : "08:1260 (08:1260 Aliens: Access to Records)",
      "08:1324" : "08:1324 (08:1324 Aliens: Complaint for Forfeiture)",
      "08:1329" : "08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petiti)",
      "08:1446" : "08:1446 (8:1446 Petition for Naturalization Hearing)",
      "09:0001" : "09:0001 (09:1 U.S. Arbitration Act)",
      "09:0009" : "09:0009 (9:9 Motion to Confirm Arbitration Loan)",
      "09:0010" : "09:0010 (09:0010 Petition to Vacate Arbitration Award)",
      "10:1408" : "10:1408 (10:1408 Claim for Military Retirement)",
      "10:1552" : "10:1552 (10:1552 Armed Forces: Action to Correct Records)",
      "10:1553" : "10:1553 (10:1553 Armed Forces: FOIA General)",
      "10:2305" : "10:2305 (10:2305 Review of Federal Contract)",
      "11:0101" : "11:0101 (11:101 Bankruptcy)",
      "11:101" : "11:101 (11:101 Bankruptcy)",
      "12:0022" : "12:0022 (12:22 Securities Fraud)",
      "12:0635" : "12:0635 (12:635 Breach of Insurance Contract)",
      "12:1345" : "12:1345 (12:1345 Financial Inst. Reform Recov. & Enforc. Act of 1989)",
      "12:1421" : "12:1421 (12:1421 Federal Home Loan Bank Act)",
      "12:1451" : "12:1451 (12:1451 Emergency Home Finance Act of 1970)",
      "12:1461" : "12:1461 (12:1461 Homeowners Loan Act)",
      "12:1464" : "12:1464 (12:1464 Federal Savings and Loan)",
      "12:1701x" : "12:1701x (12:1701x(a)(5) National Affordable Housing Act)",
      "12:1703" : "12:1703 (12:1703 Default of HUD Loan)",
      "12:1715(b)" : "12:1715(b) (12:1715(b) HUD Mortgage Assignment Program)",
      "12:1725" : "12:1725 (12:1725 Collection under Contract Guaranty)",
      "12:1730" : "12:1730 (12:1730 Collection Under Contract Guaranty)",
      "12:1786" : "12:1786 (12:1786 Termination of insured Credit Union Status)",
      "12:1811" : "12:1811 (12:1811 Financial Inst. Reform Recov. & Enforc. Act of 1989)",
      "12:1819" : "12:1819 (12:1819 Default of Promissory Note)",
      "12:1821" : "12:1821 (12:1821 Default of Loan by Promissary Note)",
      "12:1831d" : "12:1831d (12:1831d Deposit. Inst. Dereg. & Monetary Ctrl. Act of 1980)",
      "12:191" : "12:191 (12:191 Bank Foreclosure)",
      "12:192" : "12:192 (12:192 Liquidation of National Bank)",
      "12:1971" : "12:1971 (12:1971 Relief under Bank Holding Act)",
      "12:1972" : "12:1972 (12:1972 Typing Arrangement Act)",
      "12:22" : "12:22 (12:22 Securities Fraud)",
      "12:3410" : "12:3410 (12:3410 Right to Financial Privacy Act)",
      "12:635" : "12:635 (12:635 Breach of Insurance Contract)",
      "12:93(a)" : "12:93(a) (12:93(a) National Bank Act)",
      "15:0001" : "15:0001 (15:1 Antitrust Litigation)",
      "15:0002at" : "15:0002at (15:2 Antitrust Litigation)",
      "15:0002fl" : "15:0002fl (15:2(a) Fair Labor Standards Act)",
      "15:0005" : "15:0005 (15:5(a) Fair Labor Standards Act)",
      "15:0015" : "15:0015 (15:15 Antitrust Litigation)",
      "15:0025" : "15:0025 (15:25 Clayton Act)",
      "15:0044" : "15:0044 (15:44 Trademark Infringement)",
      "15:0045" : "15:0045 (15:0045 Federal Trade Commission Act)",
      "15:0052" : "15:0052 (15:0052 Federal Trade Commission Act)",
      "15:0053" : "15:0053 (15:0053 Federal Trade Commission Act)",
      "15:0077" : "15:0077 (15:77 Securities Fraud)",
      "15:0078" : "15:0078 (15:78m(a) Securities Exchange Act)",
      "15:0631" : "15:0631 (15:631 Small Business Act)",
      "15:0717" : "15:0717 (15:717 Natural Gas Act)",
      "15:1" : "15:1 (15:1 Antitrust Litigation)",
      "15:1051" : "15:1051 (15:1051 Trademark Infringement)",
      "15:1114" : "15:1114 (15:1114 Trademark Infringement)",
      "15:1121" : "15:1121 (15:1121 Trademark Infringement)",
      "15:1125" : "15:1125 (15:1125 Trademark Infringement (Lanham Act))",
      "15:1126" : "15:1126 (15:1126 Patent Infringement)",
      "15:1127" : "15:1127 (15:1127 Trademark Infringement)",
      "15:1267(a)" : "15:1267(a) (15:1267(a) Federal Hazardous Substances Act)",
      "15:15" : "15:15 (15:15 Antitrust Litigation)",
      "15:1601" : "15:1601 (15:1601 Truth in Lending)",
      "15:1640" : "15:1640 (15:1640 Truth in Lending)",
      "15:1681" : "15:1681 (15:1681 Fair Credit Reporting Act)",
      "15:1692" : "15:1692 (15:1692 Fair Debt Collection Act)",
      "15:1701" : "15:1701 (15:1701 Interstate Land Sales Full Disclosure Act)",
      "15:1934" : "15:1934 ()",
      "15:1938" : "15:1938 (15:1938 Fair Labor Standards Act)",
      "15:1981" : "15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))",
      "15:1988" : "15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))",
      "15:1989" : "15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))",
      "15:2301" : "15:2301 (15:2301 Magnuson-Moss Warranty Act)",
      "15:25" : "15:25 (15:25 Clayton Act)",
      "15:2801" : "15:2801 (15:2801 Petroleum Marketing Practices Act)",
      "15:2at" : "15:2at (15:2 Antitrust Litigation)",
      "15:2fl" : "15:2fl (15:2(a) Fair Labor Standards Act)",
      "15:3710a" : "15:3710a (15:3710a Federal Technology Transfer Act of 1986)",
      "15:44" : "15:44 (15:44 Trademark Infringement)",
      "15:45" : "15:45 (15:45 Federal Trade Commission Act)",
      "15:5" : "15:5 (15:5(a) Fair Labor Standards Act)",
      "15:53(b)" : "15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equita)",
      "15:631" : "15:631 (15:631 Small Business Act)",
      "15:754" : "15:754 (15:754 Emergency Petroleum Allocation-Admin.& Enforcement)",
      "15:77" : "15:77 (15:77 Securities Fraud)",
      "15:78" : "15:78 (15:78m(a) Securities Exchange Act)",
      "16:0668" : "16:0668 (16:668 Bald Eagle Protection Act)",
      "16:0703" : "16:0703 (16:703 Migratory Bird Act)",
      "16:1538" : "16:1538 (16:1538 Endangered Species Act)",
      "16:3371" : "16:3371 (16:3371 Wildlife Under the Lacey Act)",
      "16:3372" : "16:3372 (16:3372 Conservation: Complaint for Forfeiture)",
      "16:3373" : "16:3373 (16:3373 Appeal of Decision - DOI)",
      "16:3374" : "16:3374 (16:3374 Conservation: Complaint for Forfeiture)",
      "16:668" : "16:668 (16:668 Bald Eagle Protection Act)",
      "16:703" : "16:703 (16:703 Migratory Bird Act)",
      "17:0101" : "17:0101 (17:101 Copyright Infringement)",
      "17:0501" : "17:0501 (17:501 Copyright Infringement)",
      "17:0504" : "17:0504 (17:504 Copyright Infringement)",
      "17:101" : "17:101 (17:101 Copyright Infringement)",
      "17:501" : "17:501 (17:501 Copyright Infringement)",
      "17:504" : "17:504 (17:504 Copyright Infringement)",
      "18:0241" : "18:0241 (18:241 Conspiracy Against Citizen Rights)",
      "18:1001" : "18:1001 (18:1001 Personal Property: Fraud)",
      "18:1836a" : "18:1836a (18:1836(a) Injunction against Misappropriation of Trade Secrets)",
      "18:1836b" : "18:1836b (18:1836(b) Civil Action to Protect Trade Secrets)",
      "18:1955D" : "18:1955D ()",
      "18:1961" : "18:1961 (18:1961 Racketeering (RICO) Act)",
      "18:1962" : "18:1962 (18:1962 Racketeering (RICO) Act)",
      "18:1964" : "18:1964 (18:1964 Racketeering (RICO) Act)",
      "18:2382" : "18:2382 (18:2382 Misprision of treason)",
      "18:241" : "18:241 (18:241 Conspiracy Against Citizen Rights)",
      "18:2511" : "18:2511 (18:2511 Wiretapping)",
      "18:3114" : "18:3114 (18:3114 Motion for Return of Seized Property)",
      "18:4208" : "18:4208 (18:4208(B) Agency Action Review)",
      "18:981a" : "18:981a (18:981(a)(1)(A) Money Laundering Control Act)",
      "19:1305" : "19:1305 (19:1305 Custom Duties: Forfeiture-Immoral Articles)",
      "20:1080" : "20:1080 (20:1080 Student Loan Recovery)",
      "20:1400" : "20:1400 (20:1400 Civil Rights of Handicapped Child)",
      "20:1401" : "20:1401 (20:1401 Education: Handicapped Child Act)",
      "21:0841" : "21:0841 (21:841 Forfeiture Property-Drugs)",
      "21:0881" : "21:0881 (21:881 Forfeiture Property-Drugs)",
      "21:0881a" : "21:0881a (21:881 Forfeiture Property - Aircraft)",
      "21:0881re" : "21:0881re (21:881 Forfeiture Property - Real Estate)",
      "21:332(a)" : "21:332(a) (21:332(a) Federal Food, Drug, and Cosmetic Act)",
      "21:601" : "21:601 (21:601 Federal Meat Inspection Act (FMIA))",
      "21:841" : "21:841 (21:841 Forfeiture Property-Drugs)",
      "21:881" : "21:881 (21:881 Forfeiture Property-Drugs)",
      "23:0134" : "23:0134 (23:134 P.I.- Auto Negligence)",
      "23:134" : "23:134 (23:134 P.I.- Auto Negligence)",
      "23:1441" : "23:1441 (23:1441 Contract Real Estate)",
      "24:1000" : "24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)",
      "25:0640" : "25:0640 (25:640 Indian Tribal Rights)",
      "25:1901" : "25:1901 (25:1901 Indian Child Welfare Act)",
      "25:640" : "25:640 (25:640 Indian Tribal Rights)",
      "26:4121" : "26:4121 ()",
      "26:6212" : "26:6212 (26:6212 Injunctive Relief from IRS Lien)",
      "26:6213" : "26:6213 (26:6213 Injunctive Relief from IRS Lien)",
      "26:6502" : "26:6502 (26:6502 IRS:Enforcement of tax liens)",
      "26:6532" : "26:6532 (26:6532 IRS: Refund of Tax Penalty)",
      "26:6702" : "26:6702 (26:6702 IRS: Refund of Income Tax Penalty)",
      "26:6703" : "26:6703 (26:6703 IRS: Refund of Tax Penalty)",
      "26:7401" : "26:7401 (26:7401 IRS: Tax Liability)",
      "26:7402" : "26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)",
      "26:7403" : "26:7403 (26:7403 Suit to Enforce Federal Tax Lien)",
      "26:7422rt" : "26:7422rt (26:7422 IRS: Refund Taxes)",
      "26:7422rx" : "26:7422rx (26:7422 IRS: Refund Excise Tax)",
      "26:7426" : "26:7426 (26:7426 IRS: Wrongful Levy for Taxes)",
      "26:7429" : "26:7429 (26:7429 IRS: Tax Jeopardy Assessment)",
      "26:7604a" : "26:7604a (26:7604a IRS: Complaint to Enforce IRS Summons)",
      "26:7609" : "26:7609 (26:7609 IRS: Petition to Quash IRS Summons)",
      "27:0185" : "27:0185 (27:185 Enforcement of Arbitration Award)",
      "27:185" : "27:185 (27:185 Enforcement of Arbitration Award)",
      "28:0157c" : "28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)",
      "28:0157d" : "28:0157d (28:0157 Motion for Withdrawal of Reference)",
      "28:0158" : "28:0158 (28:0158 Notice of Appeal re Bankruptcy Matter (BA)",
      "28:0185" : "28:0185 (28:185 Suit to Compel Arbitration)",
      "28:0451" : "28:0451 (28:451 Employment Discrimination)",
      "28:0794" : "28:0794 (28:794 Rehabilitation Act)",
      "28:1001" : "28:1001 (28:1001 E.R.I.S.A.)",
      "28:1132" : "28:1132 (28:1132 E.R.I.S.A.)",
      "28:1324" : "28:1324 ()",
      "28:1330" : "28:1330 (28:1330 Breach of Contract)",
      "28:1331" : "28:1331 (28:1331 Fed. Question)",
      "28:1331al" : "28:1331al (28:1331 Fed. Question: Airline Crash)",
      "28:1331at" : "28:1331at (28:1331 Fed. Question: Anti-trust)",
      "28:1331au" : "28:1331au (28:1331 Fed. Question: Auto Negligence)",
      "28:1331b" : "28:1331b (28:1331 Federal Question: Bivens Act)",
      "28:1331bc" : "28:1331bc (28:1331 Fed. Question: Breach of Contract)",
      "28:1331ca" : "28:1331ca (28:1331 Fed Question: Fed Communications Act of 1)",
      "28:1331cm" : "28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)",
      "28:1331cv" : "28:1331cv (28:1331 Fed. Question: Civil Rights Violation)",
      "28:1331ed" : "28:1331ed (28:1331 Fed. Question: Employment Discrimination)",
      "28:1331ej" : "28:1331ej (28:1331 Federal Question: Enforcement of Judgment)",
      "28:1331es" : "28:1331es (28:1331 Enforcement of Administrative Subpoena)",
      "28:1331fl" : "28:1331fl (28:1331 Fed. Question: Fair Labor Standards)",
      "28:1331in" : "28:1331in (28:1331 Fed. Question: Insurance Contract)",
      "28:1331mm" : "28:1331mm (28:1331 Fed. Question: Medical Malpractice)",
      "28:1331ng" : "28:1331ng (28:1331 Fed. Question: Natural Gas Act)",
      "28:1331pi" : "28:1331pi (28:1331 Fed. Question: Personal Injury)",
      "28:1331rd" : "28:1331rd (28:1331 Fed. Question: Review Agency Decision)",
      "28:1331rp" : "28:1331rp (28:1331(a) Fed. Question: Real Property)",
      "28:1331rr" : "28:1331rr (28:1331 Fed. Question: Railway Labor Act)",
      "28:1331sv" : "28:1331sv (28:1331 Fed. Question: Securities Violation)",
      "28:1331tr" : "28:1331tr (28:1331 Fed. Question: Trademark)",
      "28:1331tt" : "28:1331tt (28:1331 Fed. Question: Tort Action)",
      "28:1331v" : "28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendment)",
      "28:1331wl" : "28:1331wl (28:1331 Federal Question: EPA Waste Lien)",
      "28:1331wt" : "28:1331wt (28:1331 Fed. Question: Water Rights)",
      "28:1332" : "28:1332 (28:1332 Diversity-Other)",
      "28:1332ac" : "28:1332ac (28:1332 Diversity-Account Receivable)",
      "28:1332al" : "28:1332al (28:1332 Diversity-Airline Crash)",
      "28:1332as" : "28:1332as (28:1332 Diversity-Asbestos Litigation)",
      "28:1332au" : "28:1332au (28:1332 Diversity-Auto Negligence)",
      "28:1332bc" : "28:1332bc (28:1332 Diversity-Breach of Contract)",
      "28:1332co" : "28:1332co (28:1332 Diversity-Conversion)",
      "28:1332ct" : "28:1332ct (28:1332 Diversity-(Citizenship))",
      "28:1332det" : "28:1332det (28:1332 Diversity: Forcible Detainer)",
      "28:1332df" : "28:1332df (28:1332 Diversity-Contract Default)",
      "28:1332ds" : "28:1332ds (28:1332 Diversity-Contract Dispute)",
      "28:1332ed" : "28:1332ed (28:1332 Diversity-Employment Discrimination)",
      "28:1332fd" : "28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)",
      "28:1332fr" : "28:1332fr (28:1332 Diversity-Fraud)",
      "28:1332ia" : "28:1332ia (28:1332 Diversity-Interpleader Action)",
      "28:1332ij" : "28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)",
      "28:1332in" : "28:1332in (28:1332 Diversity-Insurance Contract)",
      "28:1332jd" : "28:1332jd (28:1332 Diversity-Declaratory Judgment)",
      "28:1332lb" : "28:1332lb (28:1332 Diversity-Libel, Assault, Slander)",
      "28:1332lm" : "28:1332lm (28:1332 Diversity - Legal Malpractice)",
      "28:1332ma" : "28:1332ma (28:1332 Diversity-Miller Act)",
      "28:1332mm" : "28:1332mm (28:1332 Diversity-Medical Malpractice)",
      "28:1332mv" : "28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)",
      "28:1332ni" : "28:1332ni (28:1332 Diversity-Negotiable Instrument)",
      "28:1332nm" : "28:1332nm (28:1332 Diversity-Non-Motor Vehicle)",
      "28:1332nr" : "28:1332nr (28:1332 Diversity-Notice of Removal)",
      "28:1332oc" : "28:1332oc (28:1332 Diversity-Other Contract)",
      "28:1332pd" : "28:1332pd (28:1332 Diversity-Property Damage)",
      "28:1332pi" : "28:1332pi (28:1332 Diversity-Personal Injury)",
      "28:1332pl" : "28:1332pl (28:1332 Diversity-Product Liability)",
      "28:1332pr" : "28:1332pr (28:1332 Diversity-Petition for Removal)",
      "28:1332qt" : "28:1332qt (28:1332 Diversity-Petition to Quiet Title)",
      "28:1332ri" : "28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)",
      "28:1332sa" : "28:1332sa (28:1332 - Diversity: Securities & Exchange Commiss)",
      "28:1332sf" : "28:1332sf (28:1332 - Diversity: Securities Fraud)",
      "28:1332ss" : "28:1332ss (28:1332 Diversity - Stockholders Suits)",
      "28:1332tl" : "28:1332tl (28:1332 Diversity-Torts to Land)",
      "28:1332tm" : "28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))",
      "28:1332tn" : "28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)",
      "28:1332wd" : "28:1332wd (28:1332 Diversity-Wrongful Death)",
      "28:1333" : "28:1333 (28:1333 Admiralty)",
      "28:1334" : "28:1334 ()",
      "28:1334c" : "28:1334c (28:1334(c) R&R re motions for abstention (non-cor)",
      "28:1335" : "28:1335 (28:1335 Interpleader Action)",
      "28:1337" : "28:1337 (28:1337 Sherman-Clayton Act)",
      "28:1338cp" : "28:1338cp (28:1338 Copyright Infringement)",
      "28:1338pt" : "28:1338pt (28:1338 Patent Infringement)",
      "28:1338tr" : "28:1338tr (28:1338 Trademark Infringement)",
      "28:1340" : "28:1340 (28:1340 IRS: Custom Duties)",
      "28:1340er" : "28:1340er (28:1340 Recovery of Erroneous Refund)",
      "28:1341" : "28:1341 (28:1341 Complaint for Forfeiture)",
      "28:1343" : "28:1343 (28:1343 Violation of Civil Rights)",
      "28:1344" : "28:1344 (28:1344 Election Dispute)",
      "28:1345" : "28:1345 (28:1345 USA Plaintiff)",
      "28:1345co" : "28:1345co (28:1345 Replevin & Conversion)",
      "28:1345db" : "28:1345db (28:1345 Debt to US - FHA/HUD Title I)",
      "28:1345df" : "28:1345df (28:1345 Default of Promissory Note)",
      "28:1345er" : "28:1345er (28:1345 Recovery of Erroneous Refund)",
      "28:1345fc" : "28:1345fc (28:1345 Foreclosure)",
      "28:1345ff" : "28:1345ff (28:1345 Complaint for Forfeiture)",
      "28:1345hl" : "28:1345hl (28:1345 VA Home Loan Guaranty Debt)",
      "28:1345mc" : "28:1345mc (28:1345 Medical Care Recovery)",
      "28:1345mi" : "28:1345mi (28:1345 Mining Claim Ejectment)",
      "28:1345pd" : "28:1345pd (28:1345 Property Damage)",
      "28:1345pe" : "28:1345pe (28:1345 VA Property Ejectment)",
      "28:1345rc" : "28:1345rc (28:1345 Recovery of Debt to US)",
      "28:1345st" : "28:1345st (28:1345 Default of Student Loan)",
      "28:1345tp" : "28:1345tp (28:1345 Trespass on Public Land)",
      "28:1345va" : "28:1345va (28:1345 Recovery of VA Overpayment)",
      "28:1346bc" : "28:1346bc (28:1346 Breach of Contract)",
      "28:1346rc" : "28:1346rc (28:1346 Recovery of IRS Tax)",
      "28:1346tc" : "28:1346tc (28:1346 Tort Claim)",
      "28:1346wd" : "28:1346wd (28:1346 Wrongful Death)",
      "28:1349" : "28:1349 (28:1348 Corporation organized under Federal Law as party)",
      "28:1352" : "28:1352 (28:1352 Miller Act)",
      "28:1355" : "28:1355 (28:1355 Petition for Return of Property)",
      "28:1358" : "28:1358 (28:1358 Land Condemnation)",
      "28:1361" : "28:1361 (28:1361 Petition for Writ of Mandamus)",
      "28:1362ic" : "28:1362ic (28:1362 Indian Tribal Controversy)",
      "28:1362iw" : "28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)",
      "28:1364" : "28:1364 (28:1364 Auto Negligence)",
      "28:1391" : "28:1391 (28:1391 Personal Injury)",
      "28:1400" : "28:1400 ()",
      "28:1402" : "28:1402 (28:1402 Medical Malpractice)",
      "28:1407" : "28:1407 (28:1407 Airline Crash)",
      "28:1441ac" : "28:1441ac (28:1441 Notice of Removal-Account Receivable)",
      "28:1441al" : "28:1441al (28:1441 Notice of Removal-Airline Crash)",
      "28:1441as" : "28:1441as (28:1441 Notice of Removal-Asbestos Litigation)",
      "28:1441au" : "28:1441au (28:1441 Notice of Removal-Auto Negligence)",
      "28:1441bc" : "28:1441bc (28:1441 Notice of Removal - Breach of Contract)",
      "28:1441cr" : "28:1441cr (28:1441cr Notice of Removal - Civil Rights)",
      "28:1441cv" : "28:1441cv (28:1441 Petition for Removal- Civil Rights Act)",
      "28:1441df" : "28:1441df (28:1441 Notice of Removal-Contract Default)",
      "28:1441dj" : "28:1441dj (28:1441 Notice of Removal-Declaratory Judgment)",
      "28:1441ds" : "28:1441ds (28:1441 Notice of Removal-Contract Dispute)",
      "28:1441ed" : "28:1441ed (28:1441 Petition for Removal - Employment Discrim)",
      "28:1441er" : "28:1441er (Notice of Removal - ERISA)",
      "28:1441fc" : "28:1441fc (28:1441 Petition for Removal - Fair Credit Reporti)",
      "28:1441fr" : "28:1441fr (28:1441 Notice of Removal-Fraud)",
      "28:1441ij" : "28:1441ij (28:1441 Notice of Removal-Injunctive/Declaratory Relief)",
      "28:1441in" : "28:1441in (28:1441 Notice of Removal-Insurance Contract)",
      "28:1441int" : "28:1441int (28:1441 Petition for Removal- Action for Interplea)",
      "28:1441lb" : "28:1441lb (28:1441 Notice of Removal-Libel, Assault, Slander)",
      "28:1441lm" : "28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relatio)",
      "28:1441mm" : "28:1441mm (28:1441 Notice of Removal-Medical Malpractice)",
      "28:1441ni" : "28:1441ni (28:1441 Notice of Removal-Negotiable Instrument)",
      "28:1441nm" : "28:1441nm (28:1441 Notice of Removal-Non-Motor Vehicle)",
      "28:1441nr" : "28:1441nr (28:1441 Notice of Removal)",
      "28:1441oc" : "28:1441oc (28:1441 Petition For Removal--Other Contract)",
      "28:1441pd" : "28:1441pd (28:1441 Notice of Removal-Property Damage)",
      "28:1441pi" : "28:1441pi (28:1441 Notice of Removal-Personal Injury)",
      "28:1441pl" : "28:1441pl (28:1441 Notice of Removal-Product Liability)",
      "28:1441pr" : "28:1441pr (28:1441 Petition for Removal)",
      "28:1441qt" : "28:1441qt (28:1441 Notice of Removal-Petition to Quiet Title)",
      "28:1441ri" : "28:1441ri (28:1441 Petition for Removal- Racketeering (RICO))",
      "28:1441sa" : "28:1441sa (28:1441 - Petition for Removal: SEC Act)",
      "28:1441sf" : "28:1441sf (28:1441 - Petition for Removal: Securities Fraud)",
      "28:1441tl" : "28:1441tl (28:1441 Notice of Removal-Torts to Land)",
      "28:1441tm" : "28:1441tm (28:1441 Notice of Removal-Tort/Motor Vehicle (P.I.))",
      "28:1441tn" : "28:1441tn (28:1441 Notice of Removal-Tort/Non-Motor Vehicle)",
      "28:1441wd" : "28:1441wd (28:1441 Notice of Removal-Wrongful Death)",
      "28:1442bc" : "28:1442bc (28:1442 Notice of Removal-Breach of Contract)",
      "28:1442nr" : "28:1442nr (28:1442 Notice of Removal)",
      "28:1442pr" : "28:1442pr (28:1442 Petition for Removal)",
      "28:1443" : "28:1443 (28:1443(1) Rent, Lease & Ejectment)",
      "28:1444" : "28:1444 (28:1441 Notice of Removal-Foreclosure)",
      "28:1446er" : "28:1446er (Notice of Removal - ERISA)",
      "28:1446in" : "28:1446in (28:1446 Breach of Contract- Insurance)",
      "28:1446nr" : "28:1446nr (28:1446 Notice of Removal)",
      "28:1446pd" : "28:1446pd (28:1446 Notice of Removal-Property Damage (P.I.))",
      "28:1446pi" : "28:1446pi (28:1446 Notice of Removal-Personal Injury)",
      "28:1446pl" : "28:1446pl (28:1446pl Petition for Removal - Product Liability)",
      "28:1446pr" : "28:1446pr (28:1446 Petition for Removal)",
      "28:1452" : "28:1452 (28:1452 Removal of Claim in Civil Action Related to BK. Case)",
      "28:153" : "28:153 ()",
      "28:157A" : "28:157A ()",
      "28:157c" : "28:157c (28:157(c)(1) Findings, Concl. & Proposed Judgment)",
      "28:157d" : "28:157d (Motion for Withdrawal of Reference)",
      "28:158" : "28:158 (28:158 Bankruptcy Appeal from Judgment/Order)",
      "28:1602" : "28:1602 (28:1602 Foreign Sovereign Immunities Act)",
      "28:1651" : "28:1651 (28:1651 Petition for Writ of Coram Nobis)",
      "28:1651hc" : "28:1651hc (28:1651 Petition for Writ of Habeas Corpus)",
      "28:1651mn" : "28:1651mn (28:1651 Petition for Writ of Mandamus)",
      "28:1782" : "28:1782 (28:1782 Letter rogatory - appointment)",
      "28:185" : "28:185 (28:185 Suit to Compel Arbitration)",
      "28:1983" : "28:1983 (28:1983 Civil Rights)",
      "28:2201" : "28:2201 (28:2201 Constitutionality of State Statute(s))",
      "28:2201dj" : "28:2201dj (28:2201 Declaratory Judgment)",
      "28:2201ij" : "28:2201ij (28:2201 Injunction)",
      "28:2201in" : "28:2201in (28:2201 Declaratory Judgment (Insurance))",
      "28:2241" : "28:2241 (28:2241 Petition for Writ of Habeas Corpus (Federal))",
      "28:2254" : "28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))",
      "28:2254dp" : "28:2254dp (28:2254dp Petition for Writ of Habeas Corpus (DEATH PENALTY))",
      "28:2254se" : "28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)",
      "28:2255" : "28:2255 (28:2255 Motion to Vacate Sentence)",
      "28:2271" : "28:2271 (28:2271 Federal Tort Claims Act)",
      "28:2345" : "28:2345 (28:2345 Medicare Recovery)",
      "28:2409" : "28:2409 (28:2409(a) Quiet Title Action)",
      "28:2410" : "28:2410 (Actions affecting property on which United States had lien)",
      "28:2600" : "28:2600 ()",
      "28:2671" : "28:2671 (28:2671 Federal Tort Claims Act)",
      "28:2674" : "28:2674 (28:2674 Federal Tort Claims Act)",
      "28:2679" : "28:2679 (28:2679 Federal Driver's Act)",
      "28:3001" : "28:3001 (28:3001 Federal Debt Collection Act)",
      "28:451" : "28:451 (28:451 Employment Discrimination)",
      "28:7402" : "28:7402 (28:7402 Refund of Taxes)",
      "28:7422" : "28:7422 (28:7422 Appeal from Administrative Decision)",
      "28:754" : "28:754 (28:754 Receiver of Property in Different Districts)",
      "28:794" : "28:794 (28:794 Rehabilitation Act)",
      "29:0151" : "29:0151 (29:151 Labor: Review of Agency Action)",
      "29:0160" : "29:0160 (29:160(1) National Labor Relations Act)",
      "29:0184" : "29:0184 (29:184 Violation Collection Bargain Agreement)",
      "29:0185ep" : "29:0185ep (29:185 Employee Pension Plan)",
      "29:0185lm" : "29:0185lm (29:185 Labor/Mgt. Relations (Contracts))",
      "29:0201do" : "29:0201do (29:201 Denial of Overtime Compensation)",
      "29:0201fl" : "29:0201fl (29:201 Fair Labor Standards Act)",
      "29:0203" : "29:0203 (29:203 Equal Pay Act)",
      "29:0206" : "29:0206 (29:206 Collect Unpaid Wages)",
      "29:0401" : "29:0401 (29:0401 Labor Management Disclosure Act)",
      "29:0621" : "29:0621 (29:621 Job Discrimination (Age))",
      "29:0623" : "29:0623 (29:623 Job Discrimination (Age))",
      "29:0626" : "29:0626 (29:626 Job Discrimination (Age))",
      "29:0633" : "29:0633 (29:633 Job Discrimination (Age))",
      "29:0651" : "29:0651 (29:651 Occupational Safety/Health)",
      "29:0754" : "29:0754 (29:754 Discrimination)",
      "29:0791" : "29:0791 (29:791 Job Discrimination (Rehabilitation Act))",
      "29:0794" : "29:0794 (29:0794 Job Discrimination (Handicap))",
      "29:1001" : "29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)",
      "29:1002" : "29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)",
      "29:1104" : "29:1104 (29:1104 Recovery of Benefits to Employee)",
      "29:1109" : "29:1109 (29:1109 Breach of Fiduciary Duties)",
      "29:1129A" : "29:1129A ()",
      "29:1131" : "29:1131 (29:1131 ERISA - Collection of Delinquent Trust Funds)",
      "29:1132" : "29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)",
      "29:1140" : "29:1140 ()",
      "29:1145" : "29:1145 (29:1145 E.R.I.S.A.)",
      "29:1149" : "29:1149 (29:1149 Recover Pension & Profit Sharing)",
      "29:1161" : "29:1161 (29:1161 COBRA)",
      "29:1332" : "29:1332 ()",
      "29:1337" : "29:1337 (29:1337 E.R.I.S.A.)",
      "29:1362" : "29:1362 (29:1362 ERISA)",
      "29:1381" : "29:1381 (29:1381 E.R.I.S.A.)",
      "29:1401" : "29:1401 (29:1401(b)(2) Appeal of Arbitration Award)",
      "29:1451" : "29:1451 (29:1451 E.R.I.S.A.)",
      "29:151" : "29:151 (29:151 Labor: Review of Agency Action)",
      "29:158(b)" : "29:158(b) (29:158(b) National Labor Relations Act)",
      "29:160" : "29:160 (29:160(1) National Labor Relations Act)",
      "29:1801" : "29:1801 (29:1801 Farmworker Rights)",
      "29:184" : "29:184 (29:184 Violation Collection Bargain Agreement)",
      "29:185ep" : "29:185ep (29:185 Employee Pension Plan)",
      "29:185lm" : "29:185lm (29:185 Labor/Mgt. Relations (Contracts))",
      "29:201" : "29:201 ()",
      "29:201do" : "29:201do (29:201 Denial of Overtime Compensation)",
      "29:201fl" : "29:201fl (29:201 Fair Labor Standards Act)",
      "29:206" : "29:206 (29:206 Collect Unpaid Wages)",
      "29:2104" : "29:2104 (29:2104 Worker Adjustment & Retraining Notification (WARN))",
      "29:216" : "29:216 (29:216 Selective Service)",
      "29:2601" : "29:2601 (29:2601 Family Medical Leave Act 1993 (FMLA))",
      "29:401" : "29:401 (29:401 Labor Management Disclosure Act)",
      "29:621" : "29:621 (29:621 Job Discrimination (Age))",
      "29:623" : "29:623 (29:623 Job Discrimination (Age))",
      "29:626" : "29:626 (29:626 Job Discrimination (Age))",
      "29:633" : "29:633 (29:633 Job Discrimination (Age))",
      "29:651" : "29:651 (29:651 Occupational Safety/Health)",
      "29:754" : "29:754 (29:754 Discrimination)",
      "29:790" : "29:790 (29:790 Rehabilitation of Labor)",
      "29:791" : "29:791 (29:791 Job Discrimination (Rehabilitation Act))",
      "29:794" : "29:794 (29:794 Job Discrimination (Handicap))",
      "2:431" : "2:431 (2:431 Fed. Election Commission: Failure Enforce Compliance)",
      "2:437" : "2:437 (2:437 Federal Election Commission)",
      "30:0181" : "30:0181 (30:181 Environment: Review of Agency Action)",
      "30:0801" : "30:0801 (30:0801 Penalities/Federal Mine Safety Health Act)",
      "30:1201" : "30:1201 (30:1201 Environment: Review of Agency Action)",
      "30:1202" : "30:1202 (30:1202 Mining Reclamation Act)",
      "30:1276" : "30:1276 (30:1276 Interior: Review of Agency Action)",
      "30:181" : "30:181 (30:181 Environment: Review of Agency Action)",
      "30:801" : "30:801 (30:801 Federal Mine Safety and Health Act of 1977)",
      "31:3545" : "31:3545 (31:3545 Action to Recovery Money)",
      "31:3729" : "31:3729 (31:3729 False Claims Act)",
      "31:3730" : "31:3730 (31:3730 Qui Tam False Claims Act)",
      "31:3731" : "31:3731 (31:3731 Fraud)",
      "33:1319cw" : "33:1319cw (33:1319 Clean Water Act)",
      "33:1319pv" : "33:1319pv (33:1319 Pollutants & Permit Violations)",
      "33:1365" : "33:1365 (33:1365 Environmental Matters)",
      "33:905(b)" : "33:905(b) (33:905(b) Longshoremen Workers' Compensation Act)",
      "35:0145" : "35:0145 (35:145 Patent Infringement)",
      "35:0183" : "35:0183 (35:183 Patent Infringement)",
      "35:0271" : "35:0271 (35:271 Patent Infringement)",
      "35:145" : "35:145 (35:145 Patent Infringement)",
      "35:146" : "35:146 (35:146 Appeal from Decision of the Board of Patent Appeals)",
      "35:183" : "35:183 (35:183 Patent Infringement)",
      "35:271" : "35:271 (35:271 Patent Infringement)",
      "38:1681" : "38:1681 (38:1681 Recovery of VA Overpayment)",
      "38:1686" : "38:1686 (38:1686 Recovery of VA Overpayment)",
      "38:1780" : "38:1780 (38:1780 Recovery of VA Overpayment)",
      "38:2001" : "38:2001 (Vietnam Veteran Readjustment Act)",
      "38:2011" : "38:2011 (38:2011 - Veteran's Readjustment Assistance Act of)",
      "38:2021" : "38:2021 (38:2021 Right to re-employment of inducted persons)",
      "38:3116" : "38:3116 (38:3116 VA Overpayment)",
      "38:775" : "38:775 (Recovery of Servicemen's Group Life Insurance)",
      "38:784" : "38:784 (38:784 Suit for Veterans Insurance)",
      "39:3005" : "39:3005 (39:3005 Detention of Mail for Temporary Periods)",
      "39:409" : "39:409 (39:409 Postal Service)",
      "40:0258" : "40:0258 (40:258(a) Public Buildings & Property: Land Condem)",
      "40:0270" : "40:0270 (40:270 Miller Act)",
      "40:0875" : "40:0875 (40:875 Public Buildings & Property: Negligence)",
      "40:258" : "40:258 (40:258(a) Public Buildings & Property: Land Condemnation)",
      "40:270" : "40:270 (40:270 Miller Act)",
      "40:275" : "40:275 (40:275 Condemnation (Eminent Domain))",
      "40:875" : "40:875 (40:875 Public Buildings & Property: Negligence)",
      "41:0251" : "41:0251 (41:251 Public Contracts-Review of Agency Action)",
      "41:1463" : "41:1463 (41:1463 Public Contracts: Unlawful Employment Practices)",
      "41:251" : "41:251 (41:251 Public Contracts-Review of Agency Action)",
      "42:0205" : "42:0205 (42:205 Denial Social Security Benefits)",
      "42:0206" : "42:0206 (42:206 Social Security Benefits)",
      "42:0247" : "42:0247 (42:247 Personal Injury-Swine Flu)",
      "42:0402" : "42:0402 (42:402 Social Security Benefits)",
      "42:0405G" : "42:0405G (42:0405(g) Social Security (RSI))",
      "42:0405id" : "42:0405id (42:405(g) Review of HHS Decision (SSID))",
      "42:0405wc" : "42:0405wc (42:405(g) Review of HHS Decision (DIWC))",
      "42:0405ww" : "42:0405ww (42:405(g) Review of HHS Decision (DIWW))",
      "42:0416" : "42:0416 (42:416 Denial of Social Security Benefits)",
      "42:0427" : "42:0427 (42:427 Social Security Benefits)",
      "42:1101" : "42:1101 (Health Care Qualty Improvement Act of 1986)",
      "42:12101" : "42:12101 (42:12101 The Americans with Disabilities Act of 1990)",
      "42:1332" : "42:1332 ()",
      "42:1381A" : "42:1381A ()",
      "42:1383" : "42:1383 (42:1383 Review of HHS Decision)",
      "42:1395" : "42:1395 (42:1395 HHS: Adverse Reimbursement Review)",
      "42:1396" : "42:1396 (42:1396 Nursing Home Reform Act)",
      "42:1471" : "42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclo)",
      "42:1981cv" : "42:1981cv (42:1981 Civil Rights)",
      "42:1981hs" : "42:1981hs (42:1981 Housing Discrimination)",
      "42:1981jb" : "42:1981jb (42:1981 Job Discrimination (Race))",
      "42:1981sx" : "42:1981sx (42:1981 Sex Discrimination)",
      "42:1983cv" : "42:1983cv (42:1983 Civil Rights Act)",
      "42:1983ed" : "42:1983ed (42:1983 Civil Rights (Employment Discrimination))",
      "42:1983pr" : "42:1983pr (42:1983pr Prisoner Civil Rights)",
      "42:1986" : "42:1986 (42:1986 Neglect of Duty)",
      "42:2000" : "42:2000 (42:2000 Civil Rights: Other)",
      "42:2000ag" : "42:2000ag (42:2000 Job Discrimination (Age))",
      "42:2000e" : "42:2000e (42:2000e Job Discrimination (Employment))",
      "42:2000pb" : "42:2000pb (42:2000 Job Discrimination (Public Accommodations))",
      "42:2000ra" : "42:2000ra (42:2000 Job Discrimination (Race))",
      "42:2000rl" : "42:2000rl (42:2000 Job Discrimination (Religion))",
      "42:2000sx" : "42:2000sx (42:2000 Job Discrimination (Sex))",
      "42:2003" : "42:2003 (42:2003 Job Discrimination)",
      "42:2005" : "42:2005 (42:2005 Review of Agency Action-HHS)",
      "42:205" : "42:205 (42:205 Denial Social Security Benefits)",
      "42:206" : "42:206 (42:206 Social Security Benefits)",
      "42:234" : "42:234 (42:234 Defaulted Public Health Service Corps loan)",
      "42:247" : "42:247 (42:247 Personal Injury-Swine Flu)",
      "42:2615" : "42:2615 (42:2616 Medical Recovery Act)",
      "42:2651" : "42:2651 (42:2651 Medical Care Recovery)",
      "42:300aa-1" : "42:300aa-1 (42:300aa-1 Nat'l. Childhood Vaccine Injury Compensation Act)",
      "42:3601" : "42:3601 (42:405 Fair Housing Act)",
      "42:4000" : "42:4000 (42:4000 National Flood Insurance Act)",
      "42:4001" : "42:4001 (42:4001 National Insurance Flood Act)",
      "42:402" : "42:402 (42:402 Social Security Benefits)",
      "42:405*" : "42:405* ()",
      "42:4053" : "42:4053 (42:4053 Breach of Insurance Contract)",
      "42:405G" : "42:405G (42:405(g) Social Security (RSI))",
      "42:405id" : "42:405id (42:405(g) Review of HHS Decision (SSID))",
      "42:405wc" : "42:405wc (42:405(g) Review of HHS Decision (DIWC))",
      "42:405ww" : "42:405ww (42:405(g) Review of HHS Decision (DIWW))",
      "42:4072" : "42:4072 (42:4072 Payment of Flood Insurance Claim)",
      "42:416" : "42:416 (42:416 Denial of Social Security Benefits)",
      "42:4321" : "42:4321 (42:4321 Review of Agency Action-Environment)",
      "42:4332" : "42:4332 (42:4332 Environmental Policy - Coop of Agency Repo)",
      "42:6901en" : "42:6901en (42:6901 Environmental Cleanup Expenses)",
      "42:6901rs" : "42:6901rs (42:6901 Resource & Recovery Act)",
      "42:7401" : "42:7401 (42:7401 Clean Air Act)",
      "42:7413" : "42:7413 (42:7413(b) Clean Air Act)",
      "42:7604cl" : "42:7604cl (42:7604 Clear Air Act (Emission Standards))",
      "42:7604ir" : "42:7604ir (42:7604 Petition to Quash IRS Summons)",
      "42:9604" : "42:9604 (42:9604 Comprehensive Envir. Comp. & Liab. Act (CERCLA))",
      "42:9607" : "42:9607 (42:9607 Real Property Tort to Land)",
      "43:945" : "43:945 (43:945 Compensation for Land Condemnation)",
      "43:945a" : "43:945a (43:945a Complaint in Condemnation)",
      "43:946" : "43:946 (43:946 Complaint in Condemnation - Eminent Domain)",
      "45:0051" : "45:0051 (45:51 Railways: Fed. Employer's Liability Act)",
      "45:0151" : "45:0151 (45:151 Railway Labor Act)",
      "45:0184" : "45:0184 (45:184 Action to Set Aside Award of a System Board)",
      "45:1395" : "45:1395 (45:1395 Railroads: Adverse Reimbursement Review)",
      "45:151" : "45:151 (45:151 Railway Labor Act)",
      "45:153" : "45:153 (45:153, First (p) Railway Labor Act)",
      "45:184" : "45:184 (45:184 Action to Set Aside Award of a System Board of Adjust)",
      "45:51" : "45:51 (45:51 Railways: Fed. Employer's Liability Act)",
      "45:581(c)" : "45:581(c) (45:581(c) Rail Passenger Service Act)",
      "45:7457" : "45:7457 (45:7457 Compel Reclamation Under Clear Air Act)",
      "46:0688" : "46:0688 (46:688 Jones Act)",
      "46:0741" : "46:0741 (46:741 Shipping)",
      "46:0761" : "46:0761 (46:761 Shipping: Damages for Death on High Seas)",
      "46:1101" : "46:1101 (46:1101 Violation of Maritime Regulations)",
      "46:1156" : "46:1156 (46:1156 Administrative Procedure Act)",
      "46:1300" : "46:1300 (46:1300 Carriage of Goods by Sea Act (COGSA))",
      "46:1701" : "46:1701 (46:1701 Shipping Act of 1984)",
      "46:183" : "46:183 (46:183 Exoneration, Limitation of Liability)",
      "46:688" : "46:688 (46:688 General Admiralty and Maritime Law)",
      "46:741" : "46:741 (46:741 Shipping)",
      "46:761" : "46:761 (46:761 Shipping: Damages for Death on High Seas)",
      "46:7701" : "46:7701 (46:7701 Enforcement of a United States Coast Guard)",
      "47:553" : "47:553 (47:553 U.S.C.A. Cable Communications Policy Act)",
      "47:605" : "47:605 (47:605 Unlawful Reception Broadcast Signal i.e., Satellite)",
      "48:0883" : "48:0883 (48:883 Violation of US Coastal Law)",
      "48:1985" : "48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)",
      "48:883" : "48:883 (48:883 Violation of US Coastal Law)",
      "49:0081" : "49:0081 (49:81 Damaged Goods While Being Transported)",
      "49:0781" : "49:0781 (49:781 Forfeiture)",
      "49:10101" : "49:10101 ()",
      "49:10741" : "49:10741 ()",
      "49:11503" : "49:11503 (49:11503 Railroad Revitalization Regulatory Reform)",
      "49:11702" : "49:11702 (49:11702(a)(4) Violations of Interstate Commerce A)",
      "49:11707" : "49:11707 (49:11707 Carmack Amendment)",
      "49:1431" : "49:1431 (49:1431 Noise Control Act of 1972)",
      "49:1471" : "49:1471 (49:1471 Federal Aviation Act)",
      "49:1903" : "49:1903 (49:1903 Petition to enforce administrative summon)",
      "49:2101" : "49:2101 (49:2101 Aviation Safety & Noise Abatement Act of 1979)",
      "49:3102" : "49:3102 (49:3102 Federal Motor Carrier Safety Regulations Act)",
      "49:781" : "49:781 (49:781 Forfeiture)",
      "49:81" : "49:81 (49:81 Damaged Goods While Being Transported)",
      "50:1701-06" : "50:1701-06 (50:1701-06 International Emergency Economic Powers Act)",
      "5:551" : "5:551 (5:551 Administrative Procedure Act)",
      "5:552fi" : "5:552fi (5:552 Freedom of Information Act)",
      "5:552pa" : "5:552pa (5:552 Right to Privacy Act)",
      "5:554" : "5:554 (5:554 Constitutionality of Maritime Statutes)",
      "5:701" : "5:701 (5:701 Maritime Subsidy Board)",
      "5:702" : "5:702 (5:702 Administrative Procedure Act)",
      "5:704" : "5:704 (5:704 Labor Litigation)",
      "5:75" : "5:75 (5:75(2) Contract - Reduction in Grade)",
      "5:7511" : "5:7511 ()",
      "5:7703" : "5:7703 (5:7703 Discrimination - Review of Agency Act)",
      "5:8131" : "5:8131 (5:8131 Federal Employee's Compensation Act (FECA))",
      "5:8470" : "5:8470 (5:8470 Enforcement of Judgment against Retirement Benefits)",
      "5:8901" : "5:8901 (5:8901 Federal Employees Health Benefits Act)",
      "7:181" : "7:181 (7:181 Packers & Stockyard Act)",
      "7:2023(a)" : "7:2023(a) (7:2023(a) Judicial Review of Food Stamp Disqualification)",
      "7:2024" : "7:2024 (7:2024 False Claims Act, Food Stamp Fraud)",
      "7:2321" : "7:2321 (7:2321 Plant Variety Protection Act)",
      "7:25" : "7:25 (7:25 Fraud - Commodities Leverage Contracts)",
      "7:499" : "7:499 (7:499 Agricultural Commodities Act)",
      "7:6" : "7:6 (7:6(b) Federal Commodity Exchange Regulation)",
      "7:601" : "7:601 (7:601 USDA Condemnation)",
      "8:1105" : "8:1105 (8:1105(a) Aliens: Habeas Corpus to Release INS Detainee)",
      "8:1182" : "8:1182 (8:1182 Defend. Denial of Pla. Appl. for Alien Employment Cer)",
      "8:1251(A)" : "8:1251(A) (8:1251(A)(4) Application for a Stay of Deportation)",
      "8:1260" : "8:1260 (8:1260 Aliens: Access to Records)",
      "8:1324" : "8:1324 (8:1324 Aliens: Complaint for Forfeiture)",
      "8:1329" : "8:1329 (8:1329 Writ of Mandamus to Adjudicate Visa Petition)",
      "8:1446" : "8:1446 (8:1446 Petition for Naturalization Hearing)",
      "8:1451(j)" : "8:1451(j) (8:1451(j) Motion to Correct Order & Judg. of Naturalization)",
      "8:287" : "8:287 (8:287 Petition to Enforce INS Subpoena)",
      "99:9999" : "99:9999 (99:9999 Report cause code (DO NOT DELETE!))",
      "9:1" : "9:1 (9:1 U.S. Arbitration Act)",
      "9:9" : "9:9 (9:9 Arbitration Award)",
      "PA:221" : "PA:221 (PA:221 Article 5(b) of the Landlord & Tenant Act)",
      "adsup" : "adsup (Administrative Subpoena)",
      "appcounsel" : "appcounsel (Appointment of Court Appointed Counsel)",
      "appentprem" : "appentprem (Application of the U.S. to enter premises to Effect Levy)",
      "appltrrog" : "appltrrog (Application for Letters Rogatory)",
      "appointrec" : "appointrec (Appointment of Receiver)",
      "certL.R.12" : "certL.R.12 (Certifying Students to Practice Under L.R. 12)",
      "certobk" : "certobk (Certified Copy of Order from Bankruptcy Court)",
      "confarbawd" : "confarbawd (Motion for Confirmation of Arbitration Award)",
      "contempt" : "contempt (Contempt Proceedings)",
      "disbar" : "disbar (Disbarment Proceedings)",
      "fordepo" : "fordepo (Foreign Deposition)",
      "minspwarr" : "minspwarr (Motion for Inspection Warrant Under the OSHA of 1970)",
      "misc" : "misc (Civil Miscellaneous Case)",
      "motcomp" : "motcomp (Motion to Compel)",
      "motcompset" : "motcompset (Motion to Compel Settlement)",
      "motdisp" : "motdisp (Motion for Order to Dispose)",
      "motenf" : "motenf (Motion for Enforcement)",
      "motexpapp" : "motexpapp (Motion for Expedited Appeal)",
      "motext" : "motext (Motion to Extend Time)",
      "motlvapp" : "motlvapp (Motion for Leave to Appeal)",
      "motquash" : "motquash (Motion to Quash)",
      "motret" : "motret (Motion for Return of Property)",
      "motseize" : "motseize (Motion to Seize Property)",
      "motstapp" : "motstapp (Motion for Stay Pending Appeal)",
      "ntcfedlien" : "ntcfedlien (Notice of Federal Lien)",
      "petenf" : "petenf (Petition to Enforce IRS Summons)",
      "petnat" : "petnat (Petition for Naturalization)",
      "petper" : "petper (Petition to Perpetuate Testimony)",
      "petserv" : "petserv (Petition for Leave to Serve John Doe Summons)",
      "petvacawd" : "petvacawd (Petition To Vacate/Modify The Award of Arbitrators)",
      "regjgm" : "regjgm (Registration of Foreign Judgment)",
      "retcashbl" : "retcashbl (Return of Cash Bail)",
      "rshowcaus" : "rshowcaus (Rule to Show Cause)",
      "tranbkref" : "tranbkref (Transmission of Bankruptcy Reference)",
      "tranff" : "tranff (Transmission of Proposed Findings of Fact and Concl. of Law)",
      "tranrr" : "tranrr (Transmission of Report & Recommendation)",
      "writgar" : "writgar (Application for a Writ of Garnishment)"
   },
   "prdce" : {
      "0" : "0 (No cause code entered)",
      "02:0431" : "02:0431 (02:431 Fed. Election Commission: Failure Enforce C)",
      "02:0437" : "02:0437 (02:437 Federal Election Commission)",
      "05:0075" : "05:0075 (05:75(2) Contract - Reduction in Grade)",
      "05:0551" : "05:0551 (05:551 Administrative Procedure Act)",
      "05:0552fi" : "05:0552fi (05:552 Freedom of Information Act)",
      "05:0552pa" : "05:0552pa (05:552 Right to Privacy Act)",
      "05:0554" : "05:0554 (05:0554 Constitutionality of Maritime Statutes)",
      "05:0701" : "05:0701 (05:0701 Maritime Subsidy Board)",
      "05:0702" : "05:0702 (05:702 Administrative Procedure Act)",
      "05:0704" : "05:0704 (05:704 Labor Litigation)",
      "05:7703" : "05:7703 (05:7703 Discrimination - Review of Agency Act)",
      "05:8470" : "05:8470 (05:8470 Enforcement of Judgment against Retirement Benefits)",
      "07:0006" : "07:0006 (7:6(b) Federal Commodity Exchange Regulation)",
      "07:0025" : "07:0025 (7:25 Fraud - Commodities Leverage Contracts)",
      "07:0181" : "07:0181 (07:181 Packers & Stockyard Act)",
      "07:0499" : "07:0499 (07:499 Agricultural Commodities Act)",
      "07:0601" : "07:0601 (07:601 USDA Condemnation)",
      "07:2321" : "07:2321 (07:2321 Plant Variety Protection Act)",
      "08:1105" : "08:1105 (8:1105(a) Aliens: Habeas Corpus to Release INS Det)",
      "08:1182" : "08:1182 (8:1182 Defend. Denial of Pla. Appl. for Alien Employment Cer)",
      "08:1252" : "08:1252 (08:1252(a)(2) Injunction for Deportation)",
      "08:1260" : "08:1260 (08:1260 Aliens: Access to Records)",
      "08:1324" : "08:1324 (08:1324 Aliens: Complaint for Forfeiture)",
      "08:1329" : "08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petiti)",
      "08:1446" : "08:1446 (8:1446 Petition for Naturalization Hearing)",
      "08:1451(j)" : "08:1451(j) (8:1451(j) Motion to Correct Order & Judg. of Naturalization)",
      "09:0001" : "09:0001 (09:1 U.S. Arbitration Act)",
      "09:0009" : "09:0009 (9:9 Motion to Confirm Arbitration Loan)",
      "09:0010" : "09:0010 (09:0010 Petition to Vacate Arbitration Award)",
      "10:1408" : "10:1408 (10:1408 Claim for Military Retirement)",
      "10:1552" : "10:1552 (10:1552 Armed Forces: Action to Correct Records)",
      "10:1553" : "10:1553 (10:1553 Armed Forces: FOIA General)",
      "10:2305" : "10:2305 (10:2305 Review of Federal Contract)",
      "11:0101" : "11:0101 (11:101 Bankruptcy)",
      "12:0022" : "12:0022 (12:22 Securities Fraud)",
      "12:0635" : "12:0635 (12:635 Breach of Insurance Contract)",
      "12:1461" : "12:1461 (12:1461 Homeowners Loan Act)",
      "12:1464" : "12:1464 (12:1464 Federal Savings and Loan)",
      "12:1703" : "12:1703 (12:1703 Default of HUD Loan)",
      "12:1725" : "12:1725 (12:1725 Collection under Contract Guaranty)",
      "12:1730" : "12:1730 (12:1730 Collection Under Contract Guaranty)",
      "12:1819" : "12:1819 (12:1819 Default of Promissory Note)",
      "12:1821" : "12:1821 (12:1821 Default of Loan by Promissary Note)",
      "12:191" : "12:191 (12:191 Bank Foreclosure)",
      "12:192" : "12:192 (12:192 Liquidation of National Bank)",
      "12:1971" : "12:1971 (12:1971 Relief under Bank Holding Act)",
      "12:1972" : "12:1972 (12:1972 Typing Arrangement Act)",
      "12:3410" : "12:3410 (12:3410 Right to Financial Privacy Act)",
      "15:0001" : "15:0001 (15:1 Antitrust Litigation)",
      "15:0002at" : "15:0002at (15:2 Antitrust Litigation)",
      "15:0002fl" : "15:0002fl (15:2(a) Fair Labor Standards Act)",
      "15:0005" : "15:0005 (15:5(a) Fair Labor Standards Act)",
      "15:0015" : "15:0015 (15:15 Antitrust Litigation)",
      "15:0025" : "15:0025 (15:25 Clayton Act)",
      "15:0044" : "15:0044 (15:44 Trademark Infringement)",
      "15:0045" : "15:0045 (15:0045 Federal Trade Commission Act)",
      "15:0052" : "15:0052 (15:0052 Federal Trade Commission Act)",
      "15:0053" : "15:0053 (15:0053 Federal Trade Commission Act)",
      "15:0077" : "15:0077 (15:77 Securities Fraud)",
      "15:0078" : "15:0078 (15:78m(a) Securities Exchange Act)",
      "15:0631" : "15:0631 (15:631 Small Business Act)",
      "15:0717" : "15:0717 (15:717 Natural Gas Act)",
      "15:0754" : "15:0754 (15:754 Emergency Petroleum Allocation-Admin.& Enforcement)",
      "15:1051" : "15:1051 (15:1051 Trademark Infringement)",
      "15:1114" : "15:1114 (15:1114 Trademark Infringement)",
      "15:1121" : "15:1121 (15:1121 Trademark Infringement)",
      "15:1125" : "15:1125 (15:1125 Trademark Infringement (Lanham Act))",
      "15:1126" : "15:1126 (15:1126 Patent Infringement)",
      "15:1127" : "15:1127 (15:1127 Trademark Infringement)",
      "15:1601" : "15:1601 (15:1601 Truth in Lending)",
      "15:1640" : "15:1640 (15:1640 Truth in Lending)",
      "15:1681" : "15:1681 (15:1681 Fair Credit Reporting Act)",
      "15:1692" : "15:1692 (15:1692 Fair Debt Collection Act)",
      "15:1938" : "15:1938 (15:1938 Fair Labor Standards Act)",
      "15:1981" : "15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))",
      "15:1988" : "15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))",
      "15:1989" : "15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))",
      "15:2301" : "15:2301 (15:2301 Magnuson-Moss Warranty Act)",
      "15:2801" : "15:2801 (15:2801 Petroleum Marketing Practices Act)",
      "15:53(b)" : "15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equita)",
      "16:0668" : "16:0668 (16:668 Bald Eagle Protection Act)",
      "16:0703" : "16:0703 (16:703 Migratory Bird Act)",
      "16:1538" : "16:1538 (16:1538 Endangered Species Act)",
      "16:3371" : "16:3371 (16:3371 Wildlife Under the Lacey Act)",
      "16:3372" : "16:3372 (16:3372 Conservation: Complaint for Forfeiture)",
      "16:3373" : "16:3373 (16:3373 Appeal of Decision - DOI)",
      "16:3374" : "16:3374 (16:3374 Conservation: Complaint for Forfeiture)",
      "17:0101" : "17:0101 (17:101 Copyright Infringement)",
      "17:0501" : "17:0501 (17:501 Copyright Infringement)",
      "17:0504" : "17:0504 (17:504 Copyright Infringement)",
      "18:0241" : "18:0241 (18:241 Conspiracy Against Citizen Rights)",
      "18:1836a" : "18:1836a (18:18:1836(a) Injunction against Misappropiation of Trade Secrets)",
      "18:1836b" : "18:1836b (18:1836(b) Civil Action to Protect Trade Secrets)",
      "18:1961" : "18:1961 (18:1961 Racketeering (RICO) Act)",
      "18:1962" : "18:1962 (18:1962 Racketeering (RICO) Act)",
      "18:1964" : "18:1964 (18:1964 Racketeering (RICO) Act)",
      "18:2511" : "18:2511 (18:2511 Wiretapping)",
      "18:3114" : "18:3114 (18:3114 Motion for Return of Seized Property)",
      "18:4208" : "18:4208 (18:4208(B) Agency Action Review)",
      "19:1305" : "19:1305 (19:1305 Custom Duties:0Forfeiture-Immoral Articles)",
      "20:1080" : "20:1080 (20:1080 Student Loan Recovery)",
      "20:1400" : "20:1400 (20:1400 Civil Rights of Handicapped Child)",
      "20:1401" : "20:1401 (20:1401 Education: Handicapped Child Act)",
      "21:0841" : "21:0841 (21:841 Forfeiture Property-Drugs)",
      "21:0881" : "21:0881 (21:881 Forfeiture Property-Drugs)",
      "21:0881a" : "21:0881a (21:881 Forfeiture Property - Aircraft)",
      "21:0881re" : "21:0881re (21:881 Forfeiture Property - Real Estate)",
      "23:0134" : "23:0134 (23:134 P.I.- Auto Negligence)",
      "23:1441" : "23:1441 (23:1441 Contract Real Estate)",
      "24:1000" : "24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)",
      "25:0640" : "25:0640 (25:640 Indian Tribal Rights)",
      "25:1901" : "25:1901 (25:1901 Indian Child Welfare Act)",
      "26:6212" : "26:6212 (26:6212 Injunctive Relief from IRS Lien)",
      "26:6213" : "26:6213 (26:6213 Injunctive Relief from IRS Lien)",
      "26:6502" : "26:6502 (26:6502 IRS:Enforcement of tax liens)",
      "26:6532" : "26:6532 (26:6532 IRS: Refund of Tax Penalty)",
      "26:6702" : "26:6702 (26:6702 IRS: Refund of Income Tax Penalty)",
      "26:6703" : "26:6703 (26:6703 IRS: Refund of Tax Penalty)",
      "26:7401" : "26:7401 (26:7401 IRS: Tax Liability)",
      "26:7402" : "26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)",
      "26:7403" : "26:7403 (26:7403 Suit to Enforce Federal Tax Lien)",
      "26:7422rt" : "26:7422rt (26:7422 IRS: Refund Taxes)",
      "26:7422rx" : "26:7422rx (26:7422 IRS: Refund Excise Tax)",
      "26:7426" : "26:7426 (26:7426 IRS: Wrongful Levy for Taxes)",
      "26:7429" : "26:7429 (26:7429 IRS: Tax Jeopardy Assessment)",
      "26:7609" : "26:7609 (26:7609 IRS: Petition to Quash IRS Summons)",
      "27:0185" : "27:0185 (27:185 Enforcement of Arbitration Award)",
      "28:0157c" : "28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)",
      "28:0157d" : "28:0157d (28:0157 Motion for Withdrawal of Reference)",
      "28:0158" : "28:0158 (28:0158 Notice of Appeal re Bankruptcy Matter (BA)",
      "28:0185" : "28:0185 (28:185 Suit to Compel Arbitration)",
      "28:0451" : "28:0451 (28:451 Employment Discrimination)",
      "28:0754" : "28:0754 (28:754 Receiver of Property in Different Districts)",
      "28:0794" : "28:0794 (28:794 Rehabilitation Act)",
      "28:1001" : "28:1001 (28:1001 E.R.I.S.A.)",
      "28:1132" : "28:1132 (28:1132 E.R.I.S.A.)",
      "28:1330" : "28:1330 (28:1330 Breach of Contract)",
      "28:1331" : "28:1331 (28:1331 Fed. Question)",
      "28:1331al" : "28:1331al (28:1331 Fed. Question: Airline Crash)",
      "28:1331at" : "28:1331at (28:1331 Fed. Question: Anti-trust)",
      "28:1331au" : "28:1331au (28:1331 Fed. Question: Auto Negligence)",
      "28:1331b" : "28:1331b (28:1331 Federal Question: Bivens Act)",
      "28:1331bc" : "28:1331bc (28:1331 Fed. Question: Breach of Contract)",
      "28:1331ca" : "28:1331ca (28:1331 Fed Question: Fed Communications Act of 1)",
      "28:1331cm" : "28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)",
      "28:1331cv" : "28:1331cv (28:1331 Federal Question: Other Civil Rights)",
      "28:1331ed" : "28:1331ed (28:1331 Fed. Question: Employment Discrimination)",
      "28:1331ej" : "28:1331ej (28:1331 Federal Question: Enforcement of Judgment)",
      "28:1331es" : "28:1331es (28:1331 Enforcement of Administrative Subpoena)",
      "28:1331fl" : "28:1331fl (28:1331 Fed. Question: Fair Labor Standards)",
      "28:1331in" : "28:1331in (28:1331 Fed. Question: Insurance Contract)",
      "28:1331mm" : "28:1331mm (28:1331 Fed. Question: Medical Malpractice)",
      "28:1331ng" : "28:1331ng (28:1331 Fed. Question: Natural Gas Act)",
      "28:1331pi" : "28:1331pi (28:1331 Fed. Question: Personal Injury)",
      "28:1331rd" : "28:1331rd (28:1331 Fed. Question: Review Agency Decision)",
      "28:1331rp" : "28:1331rp (28:1331(a) Fed. Question: Real Property)",
      "28:1331rr" : "28:1331rr (28:1331 Fed. Question: Railway Labor Act)",
      "28:1331sv" : "28:1331sv (28:1331 Fed. Question: Securities Violation)",
      "28:1331tr" : "28:1331tr (28:1331 Fed. Question: Trademark)",
      "28:1331tt" : "28:1331tt (28:1331 Fed. Question: Tort Action)",
      "28:1331v" : "28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendme)",
      "28:1331wl" : "28:1331wl (28:1331 Federal Question: EPA Waste Lien)",
      "28:1331wt" : "28:1331wt (28:1331 Fed. Question: Water Rights)",
      "28:1332ac" : "28:1332ac (28:1332 Diversity-Account Receivable)",
      "28:1332al" : "28:1332al (28:1332 Diversity-Airline Crash)",
      "28:1332as" : "28:1332as (28:1332 Diversity-Asbestos Litigation)",
      "28:1332au" : "28:1332au (28:1332 Diversity-Auto Negligence)",
      "28:1332bc" : "28:1332bc (28:1332 Diversity-Breach of Contract)",
      "28:1332co" : "28:1332co (28:1332 Diversity-Conversion)",
      "28:1332ct" : "28:1332ct (28:1332 Diversity-(Citizenship))",
      "28:1332det" : "28:1332det (28:1332 Diversity: Forcible Detainer)",
      "28:1332df" : "28:1332df (28:1332 Diversity-Contract Default)",
      "28:1332ds" : "28:1332ds (28:1332 Diversity-Contract Dispute)",
      "28:1332ed" : "28:1332ed (28:1332 Diversity-Employment Discrimination)",
      "28:1332fd" : "28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)",
      "28:1332fr" : "28:1332fr (28:1332 Diversity-Fraud)",
      "28:1332ia" : "28:1332ia (28:1332 Diversity-Interpleader Action)",
      "28:1332ij" : "28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)",
      "28:1332in" : "28:1332in (28:1332 Diversity-Insurance Contract)",
      "28:1332jd" : "28:1332jd (28:1332 Diversity-Declaratory Judgement)",
      "28:1332lb" : "28:1332lb (28:1332 Diversity-Libel,Assault,Slander)",
      "28:1332lm" : "28:1332lm (28:1332 Diversity - Legal Malpractice)",
      "28:1332ma" : "28:1332ma (28:1332 Diversity-Miller Act)",
      "28:1332mm" : "28:1332mm (28:1332 Diversity-Medical Malpractice)",
      "28:1332mv" : "28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)",
      "28:1332ni" : "28:1332ni (28:1332 Diversity-Negotiable Instrument)",
      "28:1332nm" : "28:1332nm (28:1332 Diversity-Non-Motor Vehicle)",
      "28:1332nr" : "28:1332nr (28:1332 Diversity-Notice of Removal)",
      "28:1332oc" : "28:1332oc (28:1332 Diversity-Other Contract)",
      "28:1332pd" : "28:1332pd (28:1332 Diversity-Property Damage)",
      "28:1332pi" : "28:1332pi (28:1332 Diversity-Personal Injury)",
      "28:1332pl" : "28:1332pl (28:1332 Diversity-Product Liability)",
      "28:1332pr" : "28:1332pr (28:1332 Diversity-Petition for Removal)",
      "28:1332qt" : "28:1332qt (28:1332 Diversity-Petition to Quiet Title)",
      "28:1332ri" : "28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)",
      "28:1332sa" : "28:1332sa (28:1332 - Diversity: Securities & Exchange Commiss)",
      "28:1332sf" : "28:1332sf (28:1332 - Diversity: Securities Fraud)",
      "28:1332ss" : "28:1332ss (28:1332 Diversity - Stockholders Suits)",
      "28:1332tl" : "28:1332tl (28:1332 Diversity-Torts to Land)",
      "28:1332tm" : "28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))",
      "28:1332tn" : "28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)",
      "28:1332wd" : "28:1332wd (28:1332 Diversity-Wrongful Death)",
      "28:1333" : "28:1333 (28:1333 Admiralty)",
      "28:1334" : "28:1334 (28:1334 Bankruptcy Appeal)",
      "28:1334c" : "28:1334c (28:1334(c) R&R re motions for abstention (non-cor)",
      "28:1335" : "28:1335 (28:1335 Interpleader Action)",
      "28:1337" : "28:1337 (28:1337 Sherman-Clayton Act)",
      "28:1338cp" : "28:1338cp (28:1338 Copyright Infringement)",
      "28:1338pt" : "28:1338pt (28:1338 Patent Infringement)",
      "28:1338tr" : "28:1338tr (28:1338 Trademark Infringement)",
      "28:1340" : "28:1340 (28:1340 IRS: Custom Duties)",
      "28:1340er" : "28:1340er (28:1340 Recovery of Erroneous Refund)",
      "28:1341" : "28:1341 (28:1341 Complaint for Forfeiture)",
      "28:1343" : "28:1343 (28:1343 Violation of Civil Rights)",
      "28:1345" : "28:1345 (28:1345 USA Plaintiff)",
      "28:1345co" : "28:1345co (28:1345 Replevin & Conversion)",
      "28:1345db" : "28:1345db (28:1345 Debt to US - FHA/HUD Title I)",
      "28:1345df" : "28:1345df (28:1345 Default of Promissory Note)",
      "28:1345er" : "28:1345er (28:1345 Recovery of Erroneous Refund)",
      "28:1345fc" : "28:1345fc (28:1345 Foreclosure)",
      "28:1345ff" : "28:1345ff (28:1345 Complaint for Forfeiture)",
      "28:1345hl" : "28:1345hl (28:1345 VA Home Loan Guaranty Debt)",
      "28:1345mc" : "28:1345mc (28:1345 Medical Care Recovery)",
      "28:1345mi" : "28:1345mi (28:1345 Mining Claim Ejectment)",
      "28:1345pd" : "28:1345pd (28:1345 Property Damage)",
      "28:1345pe" : "28:1345pe (28:1345 Property Ejectment)",
      "28:1345rc" : "28:1345rc (28:1345 Recovery of Debt to US)",
      "28:1345st" : "28:1345st (28:1345 Default of Student Loan)",
      "28:1345tp" : "28:1345tp (28:1345 Trespass on Public Land)",
      "28:1345va" : "28:1345va (28:1345 Recovery of VA Overpayment)",
      "28:1346bc" : "28:1346bc (28:1346 Breach of Contract)",
      "28:1346rc" : "28:1346rc (28:1346 Recovery of IRS Tax)",
      "28:1346tc" : "28:1346tc (28:1346 Tort Claim)",
      "28:1346wd" : "28:1346wd (28:1346 Wrongful Death)",
      "28:1349" : "28:1349 (28:1348 Corporation organized under Federal Law as party)",
      "28:1352" : "28:1352 (28:1352 Miller Act)",
      "28:1355" : "28:1355 (28:1355 Petition for Return of Property)",
      "28:1358" : "28:1358 (28:1358 Land Condemnation)",
      "28:1361" : "28:1361 (28:1361 Petition for Writ of Mandamus)",
      "28:1362ic" : "28:1362ic (28:1362 Indian Tribal Controversy)",
      "28:1362iw" : "28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)",
      "28:1364" : "28:1364 (28:1364 Auto Negligence)",
      "28:1391" : "28:1391 (28:1391 Personal Injury)",
      "28:1402" : "28:1402 (28:1402 Medical Malpractice)",
      "28:1407" : "28:1407 (28:1407 Airline Crash)",
      "28:1441ac" : "28:1441ac (28:1441 Petition for Removal- Account Receivable)",
      "28:1441al" : "28:1441al (28:1441 Petition for Removal- Airline Crash)",
      "28:1441as" : "28:1441as (28:1441 Petition for Removal- Asbestos Litigation)",
      "28:1441au" : "28:1441au (28:1441 Petition for Removal- Auto Negligence)",
      "28:1441bc" : "28:1441bc (28:1441 Petition for Removal- Breach of Contract)",
      "28:1441cv" : "28:1441cv (28:1441 Petition for Removal- Civil Rights Act)",
      "28:1441df" : "28:1441df (28:1441 Petition for Removal- Contract Default)",
      "28:1441dj" : "28:1441dj (28:1441 Petition for Removal- Declaratory Judgemen)",
      "28:1441ds" : "28:1441ds (28:1441 Petition for Removal- Contract Dispute)",
      "28:1441ed" : "28:1441ed (28:1441 Petition for Removal - Employment Discrim)",
      "28:1441fc" : "28:1441fc (28:1441 Petition for Removal - Fair Credit Reporti)",
      "28:1441fr" : "28:1441fr (28:1441 Petition for Removal- Fraud)",
      "28:1441ij" : "28:1441ij (28:1441 Petition for Removal- Injunctive/Declarato)",
      "28:1441in" : "28:1441in (28:1441 Petition for Removal- Insurance Contract)",
      "28:1441int" : "28:1441int (28:1441 Petition for Removal- Action for Interplea)",
      "28:1441lb" : "28:1441lb (28:1441 Petition for Removal Libel,Assault,Slander)",
      "28:1441lm" : "28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relatio)",
      "28:1441mm" : "28:1441mm (28:1441 Petition for Removal- Medical Malpractice)",
      "28:1441ni" : "28:1441ni (28:1441 Petition for Removal- Negotiable Instrumen)",
      "28:1441nm" : "28:1441nm (28:1441 Petition for Removal- Non-Motor Vehicle)",
      "28:1441nr" : "28:1441nr (28:1441 Notice of Removal)",
      "28:1441oc" : "28:1441oc (28:1441 Petition For Removal--Other Contract)",
      "28:1441pd" : "28:1441pd (28:1441 Petition for Removal- Property Damage)",
      "28:1441pi" : "28:1441pi (28:1441 Petition for Removal- Personal Injury)",
      "28:1441pl" : "28:1441pl (28:1441 Petition for Removal- Product Liability)",
      "28:1441pr" : "28:1441pr (28:1441 Petition for Removal)",
      "28:1441qt" : "28:1441qt (28:1441 Petition for Removal- Petition to Quiet Ti)",
      "28:1441ri" : "28:1441ri (28:1441 Petition for Removal- Racketeering (RICO))",
      "28:1441sa" : "28:1441sa (28:1441 - Petition for Removal: SEC Act)",
      "28:1441sf" : "28:1441sf (28:1441 - Petition for Removal: Securities Fraud)",
      "28:1441tl" : "28:1441tl (28:1441 Petition for Removal- Torts to Land)",
      "28:1441tm" : "28:1441tm (28:1441 Petition for Removal- Tort/Motor Vehicle ()",
      "28:1441tn" : "28:1441tn (28:1441 Petition for Removal- Tort/Non-Motor Vehic)",
      "28:1441wd" : "28:1441wd (28:1441 Petition for Removal- Wrongful Death)",
      "28:1442bc" : "28:1442bc (28:1442 Petition for Removal- Breach of Contract)",
      "28:1442nr" : "28:1442nr (28:1442 Notice of Removal)",
      "28:1442pr" : "28:1442pr (28:1442 Petition for Removal)",
      "28:1443" : "28:1443 (28:1443(1) Rent, Lease & Ejectment)",
      "28:1444" : "28:1444 (28:1444 Petition for Removal- Foreclosure)",
      "28:1446in" : "28:1446in (28:1446 Breach of Contract- Insurance)",
      "28:1446nr" : "28:1446nr (28:1446 Notice of Removal)",
      "28:1446pd" : "28:1446pd (28:1446 Petition for Removal- Property Damage (P.I)",
      "28:1446pi" : "28:1446pi (28:1446 Petition for Removal- Personal Injury)",
      "28:1446pl" : "28:1446pl (28:1446pl Petition for Removal - Product Liability)",
      "28:1446pr" : "28:1446pr (28:1446 Petition for Removal)",
      "28:1452" : "28:1452 (28:1452 R&R re motions to remand (non-core))",
      "28:1651" : "28:1651 (28:1651 Petition for Writ of Coram Nobis)",
      "28:1651hc" : "28:1651hc (28:1651 Petition for Writ of Habeas Corpus)",
      "28:1651mn" : "28:1651mn (28:1651 Petition for Writ of Mandamus)",
      "28:1782" : "28:1782 (28:1782 Letter rogatory - appointment)",
      "28:1875" : "28:1875 (28:1875 (d)(1) Protection of Juror's Employment)",
      "28:1983" : "28:1983 (28:1983 Civil Rights)",
      "28:2201" : "28:2201 (28:2201 Constitutionality of State Statute(s))",
      "28:2201dj" : "28:2201dj (28:2201 Declaratory Judgement)",
      "28:2201ij" : "28:2201ij (28:2201 Injunction)",
      "28:2201in" : "28:2201in (28:2201 Declaratory Judgement (Insurance))",
      "28:2241" : "28:2241 (28:2241 Petition for Writ of Habeas Corpus (federa)",
      "28:2254" : "28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))",
      "28:2254se" : "28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)",
      "28:2255" : "28:2255 (28:2255 Motion to Vacate / Correct Illegal Sentenc)",
      "28:2271" : "28:2271 (28:2271 Federal Tort Claims Act)",
      "28:2345" : "28:2345 (28:2345 Medicare Recovery)",
      "28:2409" : "28:2409 (28:2409(a) Quiet Title Action)",
      "28:2410" : "28:2410 (28:2410 Quiet Title)",
      "28:2671" : "28:2671 (28:2671 Federal Tort Claims Act)",
      "28:2674" : "28:2674 (28:2674 Federal Tort Claims Act)",
      "28:3001" : "28:3001 (28:3001 Federal Debt Collection Act)",
      "28:7402" : "28:7402 (28:7402 Refund of Taxes)",
      "28:7422" : "28:7422 (28:7422 Appeal from Administrative Decision)",
      "29:0151" : "29:0151 (29:151 Labor: Review of Agency Action)",
      "29:0160" : "29:0160 (29:160(1) National Labor Relations Act)",
      "29:0184" : "29:0184 (29:184 Violation Collection Bargain Agreement)",
      "29:0185ep" : "29:0185ep (29:185 Employee Pension Plan)",
      "29:0185lm" : "29:0185lm (29:185 Labor/Mgt. Relations (Contracts))",
      "29:0201do" : "29:0201do (29:201 Denial of Overtime Compensation)",
      "29:0201fl" : "29:0201fl (29:201 Fair Labor Standards Act)",
      "29:0203" : "29:0203 (29:203 Equal Pay Act)",
      "29:0206" : "29:0206 (29:206 Collect Unpaid Wages)",
      "29:0401" : "29:0401 (29:0401 Labor Management Disclosure Act)",
      "29:0621" : "29:0621 (29:621 Job Discrimination (Age))",
      "29:0623" : "29:0623 (29:623 Job Discrimination (Age))",
      "29:0626" : "29:0626 (29:626 Job Discrimination (Age))",
      "29:0633" : "29:0633 (29:633 Job Discrimination (Age))",
      "29:0651" : "29:0651 (29:651 Occupational Safety/Health)",
      "29:0754" : "29:0754 (29:754 Discrimination)",
      "29:0791" : "29:0791 (29:791 Job Discrimination (Rehabilitation Act))",
      "29:0794" : "29:0794 (29:0794 Job Discrimination (Handicap))",
      "29:1001" : "29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)",
      "29:1002" : "29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)",
      "29:1104" : "29:1104 (29:1104 Recovery of Benefits to Employee)",
      "29:1109" : "29:1109 (29:1109 Breach of Fiduciary Duties)",
      "29:1131" : "29:1131 (29:1131 ERISA - Collection of Delinquent Trust Fun)",
      "29:1132" : "29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)",
      "29:1145" : "29:1145 (29:1145 E.R.I.S.A.)",
      "29:1149" : "29:1149 (29:1149 Recover Pension & Profit Sharing)",
      "29:1337" : "29:1337 (29:1337 E.R.I.S.A.)",
      "29:1362" : "29:1362 (29:1362 ERISA)",
      "29:1381" : "29:1381 (29:1381 E.R.I.S.A.)",
      "29:1401" : "29:1401 (29:1401(b)(2) Appeal of Arbitration Award)",
      "29:1451" : "29:1451 (29:1451 E.R.I.S.A.)",
      "29:1801" : "29:1801 (29:1801 Farmworker Rights)",
      "29:790" : "29:790 (29:790 Rehabilitation of Labor)",
      "30:0181" : "30:0181 (30:181 Environment: Review of Agency Action)",
      "30:0801" : "30:0801 (30:0801 Penalities/Federal Mine Safety Health Act)",
      "30:1201" : "30:1201 (30:1201 Environment: Review of Agency Action)",
      "30:1202" : "30:1202 (30:1202 Mining Reclamation Act)",
      "30:1276" : "30:1276 (30:1276 Interior: Review of Agency Action)",
      "31:3545" : "31:3545 (31:3545 Action to Recovery Money)",
      "31:3729" : "31:3729 (31:3729 False Claims Act)",
      "31:3730" : "31:3730 (31:3730 Qui Tam False Claims Act)",
      "31:3731" : "31:3731 (31:3731 Fraud)",
      "33:1319cw" : "33:1319cw (33:1319 Clean Water Act)",
      "33:1319pv" : "33:1319pv (33:1319 Pollutants & Permit Violations)",
      "33:1365" : "33:1365 (33:1365 Environmental Matters)",
      "35:0145" : "35:0145 (35:145 Patent Infringement)",
      "35:0183" : "35:0183 (35:183 Patent Infringement)",
      "35:0271" : "35:0271 (35:271 Patent Infringement)",
      "38:1681" : "38:1681 (38:1681 Recovery of VA Overpayment)",
      "38:1686" : "38:1686 (38:1686 Recovery of VA Overpayment)",
      "38:1780" : "38:1780 (38:1780 Recovery of VA Overpayment)",
      "38:2011" : "38:2011 (38:2011 - Veteran's Readjustment Assistance Act of)",
      "38:2021" : "38:2021 (Right to re-employment of inducted persons)",
      "38:3116" : "38:3116 (38:3116 VA Overpayment)",
      "38:775" : "38:775 (Recovery of Servicemen's Group Life Insurance)",
      "39:3005" : "39:3005 (39:3005 Detention of Mail for Temporary Periods)",
      "39:409" : "39:409 (39:409 Postal Service)",
      "40:0258" : "40:0258 (40:258(a) Public Buildings & Property: Land Condem)",
      "40:0270" : "40:0270 (40:270 Miller Act)",
      "40:0875" : "40:0875 (40:875 Public Buildings & Property: Negligence)",
      "41:0251" : "41:0251 (41:251 Public Contracts-Review of Agency Action)",
      "41:1463" : "41:1463 (41:1463 Public Contracts: Unlawful Employment Prac)",
      "42:0205" : "42:0205 (42:205 Denial Social Security Benefits)",
      "42:0206" : "42:0206 (42:206 Social Security Benefits)",
      "42:0247" : "42:0247 (42:247 Personal Injury-Swine Flu)",
      "42:0402" : "42:0402 (42:402 Social Security Benefits)",
      "42:0405id" : "42:0405id (42:405 Review of HHS Decision (SSID))",
      "42:0405wc" : "42:0405wc (42:405 Review of HHS Decision (DIWC))",
      "42:0405ww" : "42:0405ww (42:405 Review of HHS Decision (DIWW))",
      "42:0416" : "42:0416 (42:416 Denial of Social Security Benefits)",
      "42:0427" : "42:0427 (42:427 Social Security Benefits)",
      "42:12101" : "42:12101 (42:12101 Americans with Disabilities Act (ADA))",
      "42:1383" : "42:1383 (42:1383 Review of HHS Decision)",
      "42:1395" : "42:1395 (42:1395 HHS: Adverse Reimbursement Review)",
      "42:1396" : "42:1396 (42:1396 - Tort Negligence)",
      "42:1471" : "42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclo)",
      "42:1981cv" : "42:1981cv (42:1981 Civil Rights)",
      "42:1981hs" : "42:1981hs (42:1981 Housing Discrimination)",
      "42:1981jb" : "42:1981jb (42:1981 Job Discrimination (Race))",
      "42:1981sx" : "42:1981sx (42:1981 Sex Discrimination)",
      "42:1983cv" : "42:1983cv (42:1983 Civil Rights Act)",
      "42:1983ed" : "42:1983ed (42:1983 Civil Rights (Employment Discrimination))",
      "42:1983pr" : "42:1983pr (42:1983 Prisoner Civil Rights)",
      "42:1986" : "42:1986 (42:1986 Neglect of Duty)",
      "42:2000ag" : "42:2000ag (42:2000 Job Discrimination (Age))",
      "42:2000e" : "42:2000e (42:2000e Job Discrimination (Employment))",
      "42:2000pb" : "42:2000pb (42:2000 Job Discrimination (Public Accomodations))",
      "42:2000ra" : "42:2000ra (42:2000 Job Discrimination (Race))",
      "42:2000sx" : "42:2000sx (42:2000 Job Discrimination (Sex))",
      "42:2003" : "42:2003 (42:2003 Job Discrimination)",
      "42:2005" : "42:2005 (42:2005 Review of Agency Action-HHS)",
      "42:2615" : "42:2615 (42:2616 Medical Recovery Act)",
      "42:2651" : "42:2651 (42:2651 Medical Care Recovery)",
      "42:3601" : "42:3601 (42:405 Fair Housing Act)",
      "42:4000" : "42:4000 (42:4000 National Flood Insurance Act)",
      "42:4001" : "42:4001 (42:4001 National Insurance Flood Act)",
      "42:4053" : "42:4053 (42:4053 Breach of Insurance Contract)",
      "42:4072" : "42:4072 (42:4072 Payment of Flood Insurance Claim)",
      "42:4321" : "42:4321 (42:4321 Review of Agency Action-Environment)",
      "42:4332" : "42:4332 (42:4332 Environmental Policy - Coop of Agency Repo)",
      "42:6901en" : "42:6901en (42:6901 Environmental Cleanup Expenses)",
      "42:6901rs" : "42:6901rs (42:6901 Resource & Recovery Act)",
      "42:7413" : "42:7413 (42:7413(b) Clean Air Act)",
      "42:7604cl" : "42:7604cl (42:7604 Clear Air Act (Emission Standards))",
      "42:7604ir" : "42:7604ir (42:7604 Petition to Quash IRS Summons)",
      "42:9607" : "42:9607 (42:9607 Real Property Tort to Land)",
      "43:945" : "43:945 (43:945 Compensation for Land Condemnation)",
      "43:945a" : "43:945a (43:945a Complaint in Condemnation)",
      "43:946" : "43:946 (43:946 Complaint in Condemnation - Eminent Domain)",
      "45:0051" : "45:0051 (45:51 Railways: Fed. Employer's Liability Act)",
      "45:0151" : "45:0151 (45:151 Railway Labor Act)",
      "45:0184" : "45:0184 (45:184 Action to Set Aside Award of a System Board)",
      "45:1395" : "45:1395 (45:1395 Railroads: Adverse Reimbursement Review)",
      "45:7457" : "45:7457 (45:7457 Compel Reclamation Under Clear Air Act)",
      "46:0688" : "46:0688 (46:688 Jones Act)",
      "46:0741" : "46:0741 (46:741 Shipping)",
      "46:0761" : "46:0761 (46:761 Shipping: Damages for Death on High Seas)",
      "46:1101" : "46:1101 (46:1101 Violation of Maritime Regulations)",
      "46:1156" : "46:1156 (46:1156 Administrative Procedure Act)",
      "48:0883" : "48:0883 (48:883 Violation of US Coastal Law)",
      "48:1985" : "48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)",
      "49:0081" : "49:0081 (49:81 Damaged Goods While Being Transported)",
      "49:0781" : "49:0781 (49:781 Forfeiture)",
      "49:11503" : "49:11503 (49:11503 Railroad Revitalization Regulatory Reform)",
      "49:11702" : "49:11702 (49:11702(a)(4) Violations of Interstate Commerce A)",
      "49:1471" : "49:1471 (49:1471 Federal Aviation Act)",
      "49:1903" : "49:1903 (49:1903 Petition to enforce administrative summon)",
      "8:287" : "8:287 (8:287 Petition to Enforce INS Subpoena)",
      "99:9999" : "99:9999 (99:9999 Report cause code (DO NOT DELETE!))",
      "adsup" : "adsup (Administrative Subpoena)",
      "contempt" : "contempt (Contempt Proceedings)",
      "disbar" : "disbar (Disbarment Proceedings)",
      "fordepo" : "fordepo (Foreign Deposition)",
      "misc" : "misc (Civil Miscellaneous Case)",
      "motcomp" : "motcomp (Motion to Compel)",
      "motquash" : "motquash (Motion to Quash)",
      "motret" : "motret (Motion for Return of Property)",
      "petenf" : "petenf (Petition to Enforce IRS Summons)",
      "petper" : "petper (Petition to Perpetuate Testimony)",
      "regjgm" : "regjgm (Registration of Foreign Judgment)",
      "tranbkref" : "tranbkref (Transmission of Bankruptcy Reference)",
      "tranff" : "tranff (Transmission of Proposed Findings of Fact and Concl. of Law)",
      "writgar" : "writgar (Application for a Writ of Garnishment)"
   },
   "ridce" : {
      "0" : "0 (no cause specified)",
      "02:0431" : "02:0431 (02:431 Fed. Election Commission: Failure Enforce Compliance)",
      "02:0437" : "02:0437 (02:437 Federal Election Commission)",
      "05:0075" : "05:0075 (05:75(2) Contract - Reduction in Grade)",
      "05:0551" : "05:0551 (05:551 Administrative Procedure Act)",
      "05:0552fi" : "05:0552fi (05:552 Freedom of Information Act)",
      "05:0552pa" : "05:0552pa (05:552 Right to Privacy Act)",
      "05:0554" : "05:0554 (05:0554 Constitutionality of Maritime Statutes)",
      "05:0701" : "05:0701 (05:0701 Maritime Subsidy Board)",
      "05:0702" : "05:0702 (05:702 Administrative Procedure Act)",
      "05:0704" : "05:0704 (05:704 Labor Litigation)",
      "05:7703" : "05:7703 (05:7703 Discrimination - Review of Agency Act)",
      "05:8470" : "05:8470 (05:8470 Enforcement of Judgment against Retirement Benefits)",
      "07:0006" : "07:0006 (7:6(b) Federal Commodity Exchange Regulation)",
      "07:0025" : "07:0025 (7:25 Fraud - Commodities Leverage Contracts)",
      "07:0181" : "07:0181 (07:181 Packers & Stockyard Act)",
      "07:0499" : "07:0499 (07:499 Agricultural Commodities Act)",
      "07:0601" : "07:0601 (07:601 USDA Condemnation)",
      "07:2321" : "07:2321 (07:2321 Plant Variety Protection Act)",
      "08:1105" : "08:1105 (8:1105(a) Aliens: Habeas Corpus to Release INS Detainee)",
      "08:1182" : "08:1182 (8:1182 Defend. Denial of Pla. Appl. for Alien Employment Cer)",
      "08:1252" : "08:1252 (08:1252(a)(2) Injunction for Deportation)",
      "08:1260" : "08:1260 (08:1260 Aliens: Access to Records)",
      "08:1324" : "08:1324 (08:1324 Aliens: Complaint for Forfeiture)",
      "08:1329" : "08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petition)",
      "08:1421" : "08:1421 (8:1421(c) Review of Denial of Naturalization Application)",
      "08:1446" : "08:1446 (8:1446 Petition for Naturalization Hearing)",
      "08:1451(j)" : "08:1451(j) (8:1451(j) Motion to Correct Order & Judg. of Naturalization)",
      "09:0001" : "09:0001 (09:1 U.S. Arbitration Act)",
      "09:0009" : "09:0009 (9:9 Motion to Confirm Arbitration Loan)",
      "09:0010" : "09:0010 (09:0010 Petition to Vacate Arbitration Award)",
      "10:1408" : "10:1408 (10:1408 Claim for Military Retirement)",
      "10:1552" : "10:1552 (10:1552 Armed Forces: Action to Correct Records)",
      "10:1553" : "10:1553 (10:1553 Armed Forces: FOIA General)",
      "10:2305" : "10:2305 (10:2305 Review of Federal Contract)",
      "11:0101" : "11:0101 (11:101 Bankruptcy)",
      "12:0022" : "12:0022 (12:22 Securities Fraud)",
      "12:0635" : "12:0635 (12:635 Breach of Insurance Contract)",
      "12:1461" : "12:1461 (12:1461 Homeowners Loan Act)",
      "12:1464" : "12:1464 (12:1464 Federal Savings and Loan)",
      "12:1703" : "12:1703 (12:1703 Default of HUD Loan)",
      "12:1725" : "12:1725 (12:1725 Collection under Contract Guaranty)",
      "12:1730" : "12:1730 (12:1730 Collection Under Contract Guaranty)",
      "12:1789" : "12:1789 (12:1789 Negligent title examination)",
      "12:1819" : "12:1819 (12:1819 Default of Promissory Note)",
      "12:1821" : "12:1821 (12:1821 Default of Loan by Promissary Note)",
      "12:191" : "12:191 (12:191 Bank Foreclosure)",
      "12:192" : "12:192 (12:192 Liquidation of National Bank)",
      "12:1971" : "12:1971 (12:1971 Relief under Bank Holding Act)",
      "12:1972" : "12:1972 (12:1972 Typing Arrangement Act)",
      "12:3410" : "12:3410 (12:3410 Right to Financial Privacy Act)",
      "15:0001" : "15:0001 (15:1 Antitrust Litigation)",
      "15:0002at" : "15:0002at (15:2 Antitrust Litigation)",
      "15:0002fl" : "15:0002fl (15:2(a) Fair Labor Standards Act)",
      "15:0005" : "15:0005 (15:5(a) Fair Labor Standards Act)",
      "15:0015" : "15:0015 (15:15 Antitrust Litigation)",
      "15:0025" : "15:0025 (15:25 Clayton Act)",
      "15:0044" : "15:0044 (15:44 Trademark Infringement)",
      "15:0045" : "15:0045 (15:45 Federal Trade Commission Act)",
      "15:0052" : "15:0052 (15:0052 Federal Trade Commission Act)",
      "15:0053" : "15:0053 (15:0053 Federal Trade Commission Act)",
      "15:0077" : "15:0077 (15:77 Securities Fraud)",
      "15:0078" : "15:0078 (15:78m(a) Securities Exchange Act)",
      "15:0631" : "15:0631 (15:631 Small Business Act)",
      "15:0717" : "15:0717 (15:717 Natural Gas Act)",
      "15:0754" : "15:0754 (15:754 Emergency Petroleum Allocation-Admin.& Enforcement)",
      "15:1051" : "15:1051 (15:1051 Trademark Infringement)",
      "15:1114" : "15:1114 (15:1114 Trademark Infringement)",
      "15:1121" : "15:1121 (15:1121 Trademark Infringement)",
      "15:1125" : "15:1125 (15:1125 Trademark Infringement (Lanham Act))",
      "15:1126" : "15:1126 (15:1126 Patent Infringement)",
      "15:1127" : "15:1127 (15:1127 Trademark Infringement)",
      "15:1601" : "15:1601 (15:1601 Truth in Lending)",
      "15:1640" : "15:1640 (15:1640 Truth in Lending)",
      "15:1681" : "15:1681 (15:1681 Fair Credit Reporting Act)",
      "15:1692" : "15:1692 (15:1692 Fair Debt Collection Act)",
      "15:1938" : "15:1938 (15:1938 Fair Labor Standards Act)",
      "15:1981" : "15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))",
      "15:1988" : "15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))",
      "15:1989" : "15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))",
      "15:2301" : "15:2301 (15:2301 Magnuson-Moss Warranty Act)",
      "15:2310" : "15:2310 (15:2310 Breach of Warrenty)",
      "15:2801" : "15:2801 (15:2801 Petroleum Marketing Practices Act)",
      "15:53(b)" : "15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equita)",
      "16:0668" : "16:0668 (16:668 Bald Eagle Protection Act)",
      "16:0703" : "16:0703 (16:703 Migratory Bird Act)",
      "16:0823" : "16:0823 (16:0823 Federal Power Act)",
      "16:1538" : "16:1538 (16:1538 Endangered Species Act)",
      "16:1847" : "16:1847 (16:1847 Magnuson Fishery Conservation & Management Act)",
      "16:3371" : "16:3371 (16:3371 Wildlife Under the Lacey Act)",
      "16:3372" : "16:3372 (16:3372 Conservation: Complaint for Forfeiture)",
      "16:3373" : "16:3373 (16:3373 Appeal of Decision - DOI)",
      "16:3374" : "16:3374 (16:3374 Conservation: Complaint for Forfeiture)",
      "17:0101" : "17:0101 (17:101 Copyright Infringement)",
      "17:0501" : "17:0501 (17:501 Copyright Infringement)",
      "17:0504" : "17:0504 (17:504 Copyright Infringement)",
      "18:0241" : "18:0241 (18:241 Conspiracy Against Citizen Rights)",
      "18:0925" : "18:0925 (18:925A - Wrongful denial of the purchase of a firearm)",
      "18:0981" : "18:0981 (18:0981 Civil forfeiture-violation-financial institution)",
      "18:1030" : "18:1030 (18:1030 Computer Fraud and Abuse Act)",
      "18:1345" : "18:1345 (18:1345 Injunctive Relief to Restrain Commision of Fraud)",
      "18:1836a" : "18:1836a (18:1836(a) Injunction against Misappropriation of Trade Secrets)",
      "18:1836b" : "18:1836b (18:1836(b) Civil Action to Protect Trade Secrets)",
      "18:1961" : "18:1961 (18:1961 Racketeering (RICO) Act)",
      "18:1962" : "18:1962 (18:1962 Racketeering (RICO) Act)",
      "18:1964" : "18:1964 (18:1964 Racketeering (RICO) Act)",
      "18:2251" : "18:2251 (18:2251 Protection of Children Agnst Sexual Exploitation Act)",
      "18:2333" : "18:2333 (Civil remedy - Acts of Terrorism)",
      "18:2511" : "18:2511 (18:2511 Wiretapping)",
      "18:2701" : "18:2701 (18:2701 Stored Communications Act)",
      "18:3006A" : "18:3006A (18:3006 Adequate representation of criminal defendants)",
      "18:3114" : "18:3114 (18:3114 Motion for Return of Seized Property)",
      "18:3402" : "18:3402 (18:3402 Right to appeal judgment of magistrate judge)",
      "18:3582(c)" : "18:3582(c) (18:3582(c)(2) Motion for reduction of sentence)",
      "18:4208" : "18:4208 (18:4208(B) Agency Action Review)",
      "18:78" : "18:78 (18:78 Securities and Exchange Act)",
      "19:1305" : "19:1305 (19:1305 Custom Duties: Forfeiture-Immoral Articles)",
      "19:1627" : "19:1627 (Forfeiture regarding seizure by Customs)",
      "20:107" : "20:107 (20:107 Randolph-Sheppard Act)",
      "20:1080" : "20:1080 (20:1080 Student Loan Recovery)",
      "20:1400" : "20:1400 (20:1400 Civil Rights of Handicapped Child)",
      "20:1401" : "20:1401 (20:1401 Education: Handicapped Child Act)",
      "20:1415" : "20:1415 (20:1415 Handicapped Child Act - attorneys fees)",
      "20:1681" : "20:1681 (20:1681 Educational Amendments)",
      "21:0841" : "21:0841 (21:841 Forfeiture Property-Drugs)",
      "21:0881" : "21:0881 (21:881 Forfeiture Property-Drugs)",
      "21:0881a" : "21:0881a (21:881 Forfeiture Property - Aircraft)",
      "21:0881re" : "21:0881re (21:881 Forfeiture Property - Real Estate)",
      "21:343" : "21:343 (21:343 Food, Drug & Cosmetic Act)",
      "23:0134" : "23:0134 (23:134 P.I.- Auto Negligence)",
      "23:1441" : "23:1441 (23:1441 Contract Real Estate)",
      "24:1000" : "24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)",
      "25:0640" : "25:0640 (25:640 Indian Tribal Rights)",
      "25:1901" : "25:1901 (25:1901 Indian Child Welfare Act)",
      "26:6212" : "26:6212 (26:6212 Injunctive Relief from IRS Lien)",
      "26:6213" : "26:6213 (26:6213 Injunctive Relief from IRS Lien)",
      "26:6502" : "26:6502 (26:6502 IRS:Enforcement of tax liens)",
      "26:6532" : "26:6532 (26:6532 IRS: Refund of Tax Penalty)",
      "26:6702" : "26:6702 (26:6702 IRS: Refund of Income Tax Penalty)",
      "26:6703" : "26:6703 (26:6703 IRS: Refund of Tax Penalty)",
      "26:7401" : "26:7401 (26:7401 IRS: Tax Liability)",
      "26:7402" : "26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)",
      "26:7403" : "26:7403 (26:7403 Suit to Enforce Federal Tax Lien)",
      "26:7422rt" : "26:7422rt (26:7422 IRS: Refund Taxes)",
      "26:7422rx" : "26:7422rx (26:7422 IRS: Refund Excise Tax)",
      "26:7426" : "26:7426 (26:7426 IRS: Wrongful Levy for Taxes)",
      "26:7429" : "26:7429 (26:7429 IRS: Tax Jeopardy Assessment)",
      "26:7609" : "26:7609 (26:7609 IRS: Petition to Quash IRS Summons)",
      "27:0185" : "27:0185 (27:185 Enforcement of Arbitration Award)",
      "28:0157c" : "28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)",
      "28:0157d" : "28:0157d (28:0157 Motion for Withdrawal of Reference)",
      "28:0158" : "28:0158 (28:0158 Bankruptcy Appeal from Judgment/Order)",
      "28:0185" : "28:0185 (28:185 Suit to Compel Arbitration)",
      "28:0451" : "28:0451 (28:451 Employment Discrimination)",
      "28:0754" : "28:0754 (28:754 Receiver of Property in Different Districts)",
      "28:0794" : "28:0794 (28:794 Rehabilitation Act)",
      "28:1001" : "28:1001 (28:1001 E.R.I.S.A.)",
      "28:1132" : "28:1132 (28:1132 E.R.I.S.A.)",
      "28:1330" : "28:1330 (28:1330 Breach of Contract)",
      "28:1331" : "28:1331 (28:1331 Fed. Question)",
      "28:1331al" : "28:1331al (28:1331 Fed. Question: Airline Crash)",
      "28:1331at" : "28:1331at (28:1331 Fed. Question: Anti-trust)",
      "28:1331au" : "28:1331au (28:1331 Fed. Question: Auto Negligence)",
      "28:1331b" : "28:1331b (28:1331 Federal Question: Bivens Act)",
      "28:1331bc" : "28:1331bc (28:1331 Fed. Question: Breach of Contract)",
      "28:1331ca" : "28:1331ca (28:1331 Fed Question: Fed Communications Act of 1)",
      "28:1331cm" : "28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)",
      "28:1331cv" : "28:1331cv (28:1331 Fed. Question: Civil Rights Violation)",
      "28:1331ed" : "28:1331ed (28:1331 Fed. Question: Employment Discrimination)",
      "28:1331ej" : "28:1331ej (28:1331 Federal Question: Enforcement of Judgment)",
      "28:1331es" : "28:1331es (28:1331 Enforcement of Administrative Subpoena)",
      "28:1331fl" : "28:1331fl (28:1331 Fed. Question: Fair Labor Standards)",
      "28:1331in" : "28:1331in (28:1331 Fed. Question: Insurance Contract)",
      "28:1331mm" : "28:1331mm (28:1331 Fed. Question: Medical Malpractice)",
      "28:1331ng" : "28:1331ng (28:1331 Fed. Question: Natural Gas Act)",
      "28:1331pi" : "28:1331pi (28:1331 Fed. Question: Personal Injury)",
      "28:1331rd" : "28:1331rd (28:1331 Fed. Question: Review Agency Decision)",
      "28:1331rp" : "28:1331rp (28:1331(a) Fed. Question: Real Property)",
      "28:1331rr" : "28:1331rr (28:1331 Fed. Question: Railway Labor Act)",
      "28:1331sv" : "28:1331sv (28:1331 Fed. Question: Securities Violation)",
      "28:1331tr" : "28:1331tr (28:1331 Fed. Question: Trademark)",
      "28:1331tt" : "28:1331tt (28:1331 Fed. Question: Tort Action)",
      "28:1331v" : "28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendment)",
      "28:1331wl" : "28:1331wl (28:1331 Federal Question: EPA Waste Lien)",
      "28:1331wt" : "28:1331wt (28:1331 Fed. Question: Water Rights)",
      "28:1332ac" : "28:1332ac (28:1332 Diversity-Account Receivable)",
      "28:1332al" : "28:1332al (28:1332 Diversity-Airline Crash)",
      "28:1332as" : "28:1332as (28:1332 Diversity-Asbestos Litigation)",
      "28:1332au" : "28:1332au (28:1332 Diversity-Auto Negligence)",
      "28:1332bc" : "28:1332bc (28:1332 Diversity-Breach of Contract)",
      "28:1332co" : "28:1332co (28:1332 Diversity-Conversion)",
      "28:1332ct" : "28:1332ct (28:1332 Diversity-(Citizenship))",
      "28:1332det" : "28:1332det (28:1332 Diversity: Forcible Detainer)",
      "28:1332df" : "28:1332df (28:1332 Diversity-Contract Default)",
      "28:1332ds" : "28:1332ds (28:1332 Diversity-Contract Dispute)",
      "28:1332ed" : "28:1332ed (28:1332 Diversity-Employment Discrimination)",
      "28:1332fd" : "28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)",
      "28:1332fr" : "28:1332fr (28:1332 Diversity-Fraud)",
      "28:1332ia" : "28:1332ia (28:1332 Diversity-Interpleader Action)",
      "28:1332ij" : "28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)",
      "28:1332in" : "28:1332in (28:1332 Diversity-Insurance Contract)",
      "28:1332jd" : "28:1332jd (28:1332 Diversity-Declaratory Judgment)",
      "28:1332lb" : "28:1332lb (28:1332 Diversity-Libel, Assault, Slander)",
      "28:1332lm" : "28:1332lm (28:1332 Diversity - Legal Malpractice)",
      "28:1332ma" : "28:1332ma (28:1332 Diversity-Miller Act)",
      "28:1332mm" : "28:1332mm (28:1332 Diversity-Medical Malpractice)",
      "28:1332mv" : "28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)",
      "28:1332ni" : "28:1332ni (28:1332 Diversity-Negotiable Instrument)",
      "28:1332nm" : "28:1332nm (28:1332 Diversity-Non-Motor Vehicle)",
      "28:1332nr" : "28:1332nr (28:1332 Diversity-Notice of Removal)",
      "28:1332oc" : "28:1332oc (28:1332 Diversity-Other Contract)",
      "28:1332pd" : "28:1332pd (28:1332 Diversity-Property Damage)",
      "28:1332pi" : "28:1332pi (28:1332 Diversity-Personal Injury)",
      "28:1332pl" : "28:1332pl (28:1332 Diversity-Product Liability)",
      "28:1332pr" : "28:1332pr (28:1332 Diversity-Petition for Removal)",
      "28:1332qt" : "28:1332qt (28:1332 Diversity-Petition to Quiet Title)",
      "28:1332ri" : "28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)",
      "28:1332sa" : "28:1332sa (28:1332 - Diversity: Securities & Exchange Commiss)",
      "28:1332sf" : "28:1332sf (28:1332 - Diversity: Securities Fraud)",
      "28:1332ss" : "28:1332ss (28:1332 Diversity - Stockholders Suits)",
      "28:1332tl" : "28:1332tl (28:1332 Diversity-Torts to Land)",
      "28:1332tm" : "28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))",
      "28:1332tn" : "28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)",
      "28:1332wd" : "28:1332wd (28:1332 Diversity-Wrongful Death)",
      "28:1333" : "28:1333 (28:1333 Admiralty)",
      "28:1334" : "28:1334 (28:1334 Bankruptcy Appeal)",
      "28:1334c" : "28:1334c (28:1334(c) R&R re motions for abstention (non-cor)",
      "28:1335" : "28:1335 (28:1335 Interpleader Action)",
      "28:1337" : "28:1337 (28:1337 Sherman-Clayton Act)",
      "28:1338cp" : "28:1338cp (28:1338 Copyright Infringement)",
      "28:1338pt" : "28:1338pt (28:1338 Patent Infringement)",
      "28:1338tr" : "28:1338tr (28:1338 Trademark Infringement)",
      "28:1340" : "28:1340 (28:1340 IRS: Custom Duties)",
      "28:1340er" : "28:1340er (28:1340 Recovery of Erroneous Refund)",
      "28:1341" : "28:1341 (28:1341 Complaint for Forfeiture)",
      "28:1343" : "28:1343 (28:1343 Violation of Civil Rights)",
      "28:1345" : "28:1345 (28:1345 USA Plaintiff)",
      "28:1345co" : "28:1345co (28:1345 Replevin & Conversion)",
      "28:1345db" : "28:1345db (28:1345 Debt to US - FHA/HUD Title I)",
      "28:1345df" : "28:1345df (28:1345 Default of Promissory Note)",
      "28:1345er" : "28:1345er (28:1345 Recovery of Erroneous Refund)",
      "28:1345fc" : "28:1345fc (28:1345 Foreclosure)",
      "28:1345ff" : "28:1345ff (28:1345 Complaint for Forfeiture)",
      "28:1345hl" : "28:1345hl (28:1345 VA Home Loan Guaranty Debt)",
      "28:1345mc" : "28:1345mc (28:1345 Medical Care Recovery)",
      "28:1345mi" : "28:1345mi (28:1345 Mining Claim Ejectment)",
      "28:1345pd" : "28:1345pd (28:1345 Property Damage)",
      "28:1345pe" : "28:1345pe (28:1345 VA Property Ejectment)",
      "28:1345rc" : "28:1345rc (28:1345 Recovery of Debt to US)",
      "28:1345st" : "28:1345st (28:1345 Default of Student Loan)",
      "28:1345tp" : "28:1345tp (28:1345 Trespass on Public Land)",
      "28:1345va" : "28:1345va (28:1345 Recovery of VA Overpayment)",
      "28:1346bc" : "28:1346bc (28:1346 Breach of Contract)",
      "28:1346rc" : "28:1346rc (28:1346 Recovery of IRS Tax)",
      "28:1346tc" : "28:1346tc (28:1346 Tort Claim)",
      "28:1346wd" : "28:1346wd (28:1346 Wrongful Death)",
      "28:1349" : "28:1349 (28:1348 Corporation organized under Federal Law as party)",
      "28:1352" : "28:1352 (28:1352 Miller Act)",
      "28:1355" : "28:1355 (28:1355 Petition for Return of Property)",
      "28:1358" : "28:1358 (28:1358 Land Condemnation)",
      "28:1361" : "28:1361 (28:1361 Petition for Writ of Mandamus)",
      "28:1362ic" : "28:1362ic (28:1362 Indian Tribal Controversy)",
      "28:1362iw" : "28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)",
      "28:1364" : "28:1364 (28:1364 Auto Negligence)",
      "28:1391" : "28:1391 (28:1391 Personal Injury)",
      "28:1402" : "28:1402 (28:1402 Medical Malpractice)",
      "28:1407" : "28:1407 (28:1407 Airline Crash)",
      "28:1441ac" : "28:1441ac (28:1441 Notice of Removal-Account Receivable)",
      "28:1441al" : "28:1441al (28:1441 Notice of Removal-Airline Crash)",
      "28:1441as" : "28:1441as (28:1441 Notice of Removal-Asbestos Litigation)",
      "28:1441au" : "28:1441au (28:1441 Notice of Removal-Auto Negligence)",
      "28:1441bc" : "28:1441bc (28:1441 Notice of Removal-Breach of Contract)",
      "28:1441cv" : "28:1441cv (28:1441 Notice of Removal - Civil Rights)",
      "28:1441df" : "28:1441df (28:1441 Notice of Removal-Contract Default)",
      "28:1441dj" : "28:1441dj (28:1441 Notice of Removal-Declaratory Judgment)",
      "28:1441ds" : "28:1441ds (28:1441 Notice of Removal-Contract Dispute)",
      "28:1441ed" : "28:1441ed (28:1441 Notice of Removal - Employment Discrim)",
      "28:1441fc" : "28:1441fc (28:1441 Petition for Removal - Fair Credit Reporti)",
      "28:1441fr" : "28:1441fr (28:1441 Notice of Removal-Fraud)",
      "28:1441ij" : "28:1441ij (28:1441 Notice of Removal-Injunctive/Declaratory Relief)",
      "28:1441in" : "28:1441in (28:1441 Notice of Removal-Insurance Contract)",
      "28:1441int" : "28:1441int (28:1441 Petition for Removal- Action for Interplea)",
      "28:1441lb" : "28:1441lb (28:1441 Notice of Removal-Libel, Assault, Slander)",
      "28:1441ld" : "28:1441ld (28:1441 Notice of removal - Labor Dispute)",
      "28:1441lm" : "28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relatio)",
      "28:1441mm" : "28:1441mm (28:1441 Notice of Removal-Medical Malpractice)",
      "28:1441ni" : "28:1441ni (28:1441 Notice of Removal-Negotiable Instrument)",
      "28:1441nm" : "28:1441nm (28:1441 Notice of Removal-Non-Motor Vehicle)",
      "28:1441nr" : "28:1441nr (28:1441 Notice of Removal)",
      "28:1441oc" : "28:1441oc (28:1441 Notice of Removal--Other Contract)",
      "28:1441pd" : "28:1441pd (28:1441 Notice of Removal-Property Damage)",
      "28:1441pi" : "28:1441pi (28:1441 Notice of Removal-Personal Injury)",
      "28:1441pl" : "28:1441pl (28:1441 Notice of Removal-Product Liability)",
      "28:1441pr" : "28:1441pr (28:1441 Petition for Removal)",
      "28:1441qt" : "28:1441qt (28:1441 Notice of Removal-Petition to Quiet Title)",
      "28:1441ri" : "28:1441ri (28:1441 Petition for Removal- Racketeering (RICO))",
      "28:1441sa" : "28:1441sa (28:1441 - Petition for Removal: SEC Act)",
      "28:1441sf" : "28:1441sf (28:1441 - Petition for Removal: Securities Fraud)",
      "28:1441tl" : "28:1441tl (28:1441 Notice of Removal-Torts to Land)",
      "28:1441tm" : "28:1441tm (28:1441 Notice of Removal-Tort/Motor Vehicle (P.I.))",
      "28:1441tn" : "28:1441tn (28:1441 Notice of Removal-Tort/Non-Motor Vehicle)",
      "28:1441wd" : "28:1441wd (28:1441 Notice of Removal-Wrongful Death)",
      "28:1442bc" : "28:1442bc (28:1442 Notice of Removal-Breach of Contract)",
      "28:1442nr" : "28:1442nr (28:1442 Notice of Removal)",
      "28:1442pr" : "28:1442pr (28:1442 Petition for Removal)",
      "28:1443" : "28:1443 (28:1443(1) Rent, Lease & Ejectment)",
      "28:1444" : "28:1444 (28:1441 Notice of Removal-Foreclosure)",
      "28:1446in" : "28:1446in (28:1446 Breach of Contract- Insurance)",
      "28:1446nr" : "28:1446nr (28:1446 Notice of Removal)",
      "28:1446pd" : "28:1446pd (28:1446 Notice of Removal-Property Damage (P.I.))",
      "28:1446pi" : "28:1446pi (28:1446 Notice of Removal-Personal Injury)",
      "28:1446pl" : "28:1446pl (28:1446pl Petition for Removal - Product Liability)",
      "28:1446pr" : "28:1446pr (28:1446 Petition for Removal)",
      "28:1452" : "28:1452 (28:1452 Removal of Claim in Civil Action Related to BK. Case)",
      "28:1651" : "28:1651 (28:1651 Petition for Writ of Coram Nobis)",
      "28:1651hc" : "28:1651hc (28:1651 Petition for Writ of Habeas Corpus)",
      "28:1651mn" : "28:1651mn (28:1651 Petition for Writ of Mandamus)",
      "28:1655" : "28:1655 (28:1655 Lien Enforcement; absent defendant)",
      "28:1782" : "28:1782 (28:1782 Letter rogatory - appointment)",
      "28:1983" : "28:1983 (28:1983 Civil Rights)",
      "28:2201" : "28:2201 (28:2201 Constitutionality of State Statute(s))",
      "28:2201dj" : "28:2201dj (28:2201 Declaratory Judgment)",
      "28:2201ij" : "28:2201ij (28:2201 Injunction)",
      "28:2201in" : "28:2201in (28:2201 Declaratory Judgment (Insurance))",
      "28:2241" : "28:2241 (28:2241 Petition for Writ of Habeas Corpus (Federal))",
      "28:2254" : "28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))",
      "28:2254se" : "28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)",
      "28:2255" : "28:2255 (28:2255 Motion to Vacate Sentence)",
      "28:2271" : "28:2271 (28:2271 Federal Tort Claims Act)",
      "28:2345" : "28:2345 (28:2345 Medicare Recovery)",
      "28:2409" : "28:2409 (28:2409(a) Quiet Title Action)",
      "28:2410" : "28:2410 (Actions Affecting Property on Which United States Had a Lien)",
      "28:2671" : "28:2671 (28:2671 Federal Tort Claims Act)",
      "28:2674" : "28:2674 (28:2674 Federal Tort Claims Act)",
      "28:3001" : "28:3001 (28:3001 Federal Debt Collection Act)",
      "28:7402" : "28:7402 (28:7402 Refund of Taxes)",
      "28:7422" : "28:7422 (28:7422 Appeal from Administrative Decision)",
      "29:0151" : "29:0151 (29:151 Labor: Review of Agency Action)",
      "29:0160" : "29:0160 (29:160(1) National Labor Relations Act)",
      "29:0184" : "29:0184 (29:184 Violation Collection Bargain Agreement)",
      "29:0185ep" : "29:0185ep (29:185 Employee Pension Plan)",
      "29:0185lm" : "29:0185lm (29:185 Labor/Mgt. Relations (Contracts))",
      "29:0201do" : "29:0201do (29:201 Denial of Overtime Compensation)",
      "29:0201fl" : "29:0201fl (29:201 Fair Labor Standards Act)",
      "29:0203" : "29:0203 (29:203 Equal Pay Act)",
      "29:0206" : "29:0206 (29:206 Collect Unpaid Wages)",
      "29:0401" : "29:0401 (29:0401 Labor Management Disclosure Act)",
      "29:0621" : "29:0621 (29:621 Job Discrimination (Age))",
      "29:0623" : "29:0623 (29:623 Job Discrimination (Age))",
      "29:0626" : "29:0626 (29:626 Job Discrimination (Age))",
      "29:0633" : "29:0633 (29:633 Job Discrimination (Age))",
      "29:0651" : "29:0651 (29:651 Occupational Safety/Health)",
      "29:0754" : "29:0754 (29:754 Discrimination)",
      "29:0791" : "29:0791 (29:791 Job Discrimination (Rehabilitation Act))",
      "29:0794" : "29:0794 (29:0794 Job Discrimination (Handicap))",
      "29:1001" : "29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)",
      "29:1002" : "29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)",
      "29:1104" : "29:1104 (29:1104 Recovery of Benefits to Employee)",
      "29:1109" : "29:1109 (29:1109 Breach of Fiduciary Duties)",
      "29:1131" : "29:1131 (29:1131 ERISA - Collection of Delinquent Trust Funds)",
      "29:1132" : "29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)",
      "29:1145" : "29:1145 (29:1145 E.R.I.S.A.)",
      "29:1149" : "29:1149 (29:1149 Recover Pension & Profit Sharing)",
      "29:1337" : "29:1337 (29:1337 E.R.I.S.A.)",
      "29:1362" : "29:1362 (29:1362 ERISA)",
      "29:1381" : "29:1381 (29:1381 E.R.I.S.A.)",
      "29:1401" : "29:1401 (29:1401(b)(2) Appeal of Arbitration Award)",
      "29:1451" : "29:1451 (29:1451 E.R.I.S.A.)",
      "29:1801" : "29:1801 (29:1801 Farmworker Rights)",
      "29:2101" : "29:2101 (29:2101 Worker Adjustment and Retraining Notification Act)",
      "29:2601" : "29:2601 (29:2601 Family and Medical Leave Act of 1993)",
      "29:481(g)" : "29:481(g) (29:481(g) Violation of Union Campaigning)",
      "29:790" : "29:790 (29:790 Rehabilitation of Labor)",
      "30:0181" : "30:0181 (30:181 Environment: Review of Agency Action)",
      "30:0801" : "30:0801 (30:0801 Penalities/Federal Mine Safety Health Act)",
      "30:1201" : "30:1201 (30:1201 Environment: Review of Agency Action)",
      "30:1202" : "30:1202 (30:1202 Mining Reclamation Act)",
      "30:1276" : "30:1276 (30:1276 Interior: Review of Agency Action)",
      "31:3545" : "31:3545 (31:3545 Action to Recovery Money)",
      "31:3729" : "31:3729 (31:3729 False Claims Act)",
      "31:3730" : "31:3730 (31:3730 Qui Tam False Claims Act)",
      "31:3731" : "31:3731 (31:3731 Fraud)",
      "33:1319cw" : "33:1319cw (33:1319 Clean Water Act)",
      "33:1319pv" : "33:1319pv (33:1319 Pollutants & Permit Violations)",
      "33:1365" : "33:1365 (33:1365 Environmental Matters)",
      "33:2701" : "33:2701 (33:2701 Oil Pollution Liability & Compensation Act)",
      "35:0145" : "35:0145 (35:145 Patent Infringement)",
      "35:0183" : "35:0183 (35:183 Patent Infringement)",
      "35:0271" : "35:0271 (35:271 Patent Infringement)",
      "38:1681" : "38:1681 (38:1681 Recovery of VA Overpayment)",
      "38:1686" : "38:1686 (38:1686 Recovery of VA Overpayment)",
      "38:1780" : "38:1780 (38:1780 Recovery of VA Overpayment)",
      "38:2011" : "38:2011 (38:2011 - Veteran's Readjustment Assistance Act of)",
      "38:2021" : "38:2021 (Right to re-employment of inducted persons)",
      "38:3116" : "38:3116 (38:3116 VA Overpayment)",
      "38:521" : "38:521 (38:521 Recovery of VA Overpayment)",
      "38:775" : "38:775 (Recovery of Servicemen's Group Life Insurance)",
      "39:3005" : "39:3005 (39:3005 Detention of Mail for Temporary Periods)",
      "39:409" : "39:409 (39:409 Postal Service)",
      "40:0258" : "40:0258 (40:258(a) Public Buildings & Property: Land Condemnation)",
      "40:0270" : "40:0270 (40:270 Miller Act)",
      "40:0875" : "40:0875 (40:875 Public Buildings & Property: Negligence)",
      "41:0251" : "41:0251 (41:251 Public Contracts-Review of Agency Action)",
      "41:1463" : "41:1463 (41:1463 Public Contracts: Unlawful Employment Practices)",
      "42:0205" : "42:0205 (42:205 Denial Social Security Benefits)",
      "42:0206" : "42:0206 (42:206 Social Security Benefits)",
      "42:0247" : "42:0247 (42:247 Personal Injury-Swine Flu)",
      "42:0402" : "42:0402 (42:402 Social Security Benefits)",
      "42:0405id" : "42:0405id (42:405 Review of HHS Decision (SSID))",
      "42:0405wc" : "42:0405wc (42:405 Review of HHS Decision (DIWC))",
      "42:0405ww" : "42:0405ww (42:405 Review of HHS Decision (DIWW))",
      "42:0416" : "42:0416 (42:416 Denial of Social Security Benefits)",
      "42:0427" : "42:0427 (42:427 Social Security Benefits)",
      "42:12101" : "42:12101 (42:12101 Americans With Disabilities Act)",
      "42:1383" : "42:1383 (42:1383 Review of HHS Decision)",
      "42:1395" : "42:1395 (42:1395 HHS: Adverse Reimbursement Review)",
      "42:1396" : "42:1396 (42:1396 - Tort Negligence)",
      "42:1471" : "42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclo)",
      "42:1973" : "42:1973 (42:1973 National Voter Registration Act of 1993)",
      "42:1981cv" : "42:1981cv (42:1981 Civil Rights)",
      "42:1981hs" : "42:1981hs (42:1981 Housing Discrimination)",
      "42:1981jb" : "42:1981jb (42:1981 Job Discrimination (Race))",
      "42:1981sx" : "42:1981sx (42:1981 Sex Discrimination)",
      "42:1983cv" : "42:1983cv (42:1983 Civil Rights Act)",
      "42:1983ed" : "42:1983ed (42:1983 Civil Rights (Employment Discrimination))",
      "42:1983pr" : "42:1983pr (42:1983 Prisoner Civil Rights)",
      "42:1986" : "42:1986 (42:1986 Neglect of Duty)",
      "42:2000ag" : "42:2000ag (42:2000 Job Discrimination (Age))",
      "42:2000e" : "42:2000e (42:2000e Job Discrimination (Employment))",
      "42:2000pb" : "42:2000pb (42:2000 Job Discrimination (Public Accommodations))",
      "42:2000ra" : "42:2000ra (42:2000 Job Discrimination (Race))",
      "42:2000sx" : "42:2000sx (42:2000 Job Discrimination (Sex))",
      "42:2003" : "42:2003 (42:2003 Job Discrimination)",
      "42:2005" : "42:2005 (42:2005 Review of Agency Action-HHS)",
      "42:2615" : "42:2615 (42:2616 Medical Recovery Act)",
      "42:2651" : "42:2651 (42:2651 Medical Care Recovery)",
      "42:3601" : "42:3601 (42:405 Fair Housing Act)",
      "42:4000" : "42:4000 (42:4000 National Flood Insurance Act)",
      "42:4001" : "42:4001 (42:4001 National Insurance Flood Act)",
      "42:4053" : "42:4053 (42:4053 Breach of Insurance Contract)",
      "42:4072" : "42:4072 (42:4072 Flood Insurance Policy)",
      "42:4321" : "42:4321 (42:4321 Review of Agency Action-Environment)",
      "42:4332" : "42:4332 (42:4332)",
      "42:6901en" : "42:6901en (42:6901 Environmental Cleanup Expenses)",
      "42:6901rs" : "42:6901rs (42:6901 Resource & Recovery Act)",
      "42:7413" : "42:7413 (42:7413(b) Clean Air Act)",
      "42:7604cl" : "42:7604cl (42:7604 Clear Air Act (Emission Standards))",
      "42:7604ir" : "42:7604ir (42:7604 Petition to Quash IRS Summons)",
      "42:9607" : "42:9607 (42:9607 Real Property Tort to Land)",
      "42:9904" : "42:9904 (42:9904 Misallocation of Federal Block Grant Funds)",
      "43:945" : "43:945 (43:945 Compensation for Land Condemnation)",
      "43:945a" : "43:945a (43:945a Complaint in Condemnation)",
      "43:946" : "43:946 (43:946 Complaint in Condemnation - Eminent Domain)",
      "45:0051" : "45:0051 (45:51 Railways: Fed. Employer's Liability Act)",
      "45:0151" : "45:0151 (45:151 Railway Labor Act)",
      "45:0184" : "45:0184 (45:184 Action to Set Aside Award of a System Board of Adjust)",
      "45:1395" : "45:1395 (45:1395 Railroads: Adverse Reimbursement Review)",
      "45:7457" : "45:7457 (45:7457 Compel Reclamation Under Clear Air Act)",
      "46:0688" : "46:0688 (46:688 Jones Act)",
      "46:0741" : "46:0741 (46:741 Shipping)",
      "46:0761" : "46:0761 (46:761 Shipping: Damages for Death on High Seas)",
      "46:1101" : "46:1101 (46:1101 Violation of Maritime Regulations)",
      "46:1156" : "46:1156 (46:1156 Administrative Procedure Act)",
      "46:31301" : "46:31301 (46:31301 Foreclosure on 1st preferred ship's mortgage)",
      "46:688" : "46:688 (46:688 Jones Act)",
      "47:0553" : "47:0553 (47:0553 Cable Communications)",
      "47:151" : "47:151 (47:151 Communications Act of 1934)",
      "47:332" : "47:332 (47:332 Telecommunications Act of 1996)",
      "47:553" : "47:553 (47:553 Theft of cable services)",
      "47:605" : "47:605 (47:605 Unauthorized Use of Commumnications)",
      "48:0883" : "48:0883 (48:883 Violation of US Coastal Law)",
      "48:1985" : "48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)",
      "49:0081" : "49:0081 (49:81 Damaged Goods While Being Transported)",
      "49:0781" : "49:0781 (49:781 Forfeiture)",
      "49:10741" : "49:10741 (49:10741 Interstate Commerce Act)",
      "49:10927" : "49:10927 (49:10927 Uninsured interstate trans. of autos)",
      "49:11503" : "49:11503 (49:11503 Railroad Revitalization Regulatory Reform)",
      "49:11702" : "49:11702 (49:11702(a)(4) Violations of Interstate Commerce A)",
      "49:13706" : "49:13706 (49:13706 Non-payment of freight charges)",
      "49:1471" : "49:1471 (49:1471 Federal Aviation Act)",
      "49:1903" : "49:1903 (49:1903 Petition to enforce administrative summon)",
      "49:24311" : "49:24311 (49:24311(b) Rail Passenger Service Act)",
      "8:287" : "8:287 (8:287 Petition to Enforce INS Subpoena)",
      "99:9999" : "99:9999 (99:9999 Report cause code (DO NOT DELETE!))",
      "adsup" : "adsup (Administrative Subpoena)",
      "contempt" : "contempt (Contempt Proceedings)",
      "disbar" : "disbar (Disbarment Proceedings)",
      "fordepo" : "fordepo (Foreign Deposition)",
      "fsa" : "fsa (food stamp act)",
      "i" : "i ()",
      "misc" : "misc (Civil Miscellaneous Case)",
      "motcomp" : "motcomp (Motion to Compel)",
      "motquash" : "motquash (Motion to Quash)",
      "motret" : "motret (Motion for Return of Property)",
      "petenf" : "petenf (Petition to Enforce IRS Summons)",
      "petper" : "petper (Petition to Perpetuate Testimony)",
      "regjgm" : "regjgm (Registration of Foreign Judgment)",
      "tranbkref" : "tranbkref (Transmission of Bankruptcy Reference)",
      "tranff" : "tranff (Transmission of Proposed Findings of Fact and Concl. of Law)",
      "writgar" : "writgar (Application for a Writ of Garnishment)"
   },
   "scdce" : {
      "0" : "0 (no cause specified)",
      "02:0431" : "02:0431 (02:431 Fed. Election Commission: Failure Enforce Compliance)",
      "02:0437" : "02:0437 (02:437 Federal Election Commission)",
      "05:0075" : "05:0075 (05:75(2) Contract - Reduction in Grade)",
      "05:0551" : "05:0551 (05:551 Administrative Procedure Act)",
      "05:0552fi" : "05:0552fi (05:552 Freedom of Information Act)",
      "05:0552pa" : "05:0552pa (05:552 Right to Privacy Act)",
      "05:0554" : "05:0554 (05:0554 Constitutionality of Maritime Statutes)",
      "05:0701" : "05:0701 (05:0701 Maritime Subsidy Board)",
      "05:0702" : "05:0702 (05:702 Administrative Procedure Act)",
      "05:0704" : "05:0704 (05:704 Labor Litigation)",
      "05:7703" : "05:7703 (05:7703 Discrimination - Review of Agency Act)",
      "05:8470" : "05:8470 (05:8470 Enforcement of Judgment against Retirement Benefits)",
      "05:8477" : "05:8477 (05:8477 Fiduciary Responsibilities, Liability and Penalties)",
      "07:0006" : "07:0006 (7:6(b) Federal Commodity Exchange Regulation)",
      "07:0025" : "07:0025 (7:25 Fraud - Commodities Leverage Contracts)",
      "07:0181" : "07:0181 (07:181 Packers & Stockyard Act)",
      "07:0499" : "07:0499 (07:499 Agricultural Commodities Act)",
      "07:0601" : "07:0601 (07:601 USDA Condemnation)",
      "07:1926" : "07:1926 (07:1926 Waste and Water Facility Loans and Grants)",
      "07:2321" : "07:2321 (07:2321 Plant Variety Protection Act)",
      "08:1105" : "08:1105 (8:1105(a) Aliens: Habeas Corpus to Release INS Detainee)",
      "08:1182" : "08:1182 (8:1182 Defend. Denial of Pla. Appl. for Alien Employment Cer)",
      "08:1252" : "08:1252 (08:1252(a)(2) Injunction for Deportation)",
      "08:1260" : "08:1260 (08:1260 Aliens: Access to Records)",
      "08:1324" : "08:1324 (08:1324 Aliens: Complaint for Forfeiture)",
      "08:1329" : "08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petition)",
      "08:1421c" : "08:1421c (08:1421 Review of Naturalization Application)",
      "08:1446" : "08:1446 (8:1446 Petition for Naturalization Hearing)",
      "08:1451(j)" : "08:1451(j) (8:1451(j) Motion to Correct Order & Judg. of Naturalization)",
      "09:0001" : "09:0001 (09:1 U.S. Arbitration Act)",
      "09:0009" : "09:0009 (9:9 Motion to Confirm Arbitration Loan)",
      "09:0010" : "09:0010 (09:0010 Petition to Vacate Arbitration Award)",
      "10:1408" : "10:1408 (10:1408 Claim for Military Retirement)",
      "10:1552" : "10:1552 (10:1552 Armed Forces: Action to Correct Records)",
      "10:1553" : "10:1553 (10:1553 Armed Forces: FOIA General)",
      "10:2305" : "10:2305 (10:2305 Review of Federal Contract)",
      "11:0101" : "11:0101 (11:101 Bankruptcy)",
      "11:524" : "11:524 (11:524 Effect of Discharge)",
      "12:0022" : "12:0022 (12:22 Securities Fraud)",
      "12:0632" : "12:0632 (Federal Reserve Act)",
      "12:0635" : "12:0635 (12:635 Breach of Insurance Contract)",
      "12:1461" : "12:1461 (12:1461 Homeowners Loan Act)",
      "12:1464" : "12:1464 (12:1464 Federal Savings and Loan)",
      "12:1703" : "12:1703 (12:1703 Default of HUD Loan)",
      "12:1725" : "12:1725 (12:1725 Collection under Contract Guaranty)",
      "12:1730" : "12:1730 (12:1730 Collection Under Contract Guaranty)",
      "12:1819" : "12:1819 (12:1819 Default of Promissory Note)",
      "12:1821" : "12:1821 (12:1821 Default of Loan by Promissary Note)",
      "12:191" : "12:191 (12:191 Bank Foreclosure)",
      "12:192" : "12:192 (12:192 Liquidation of National Bank)",
      "12:1971" : "12:1971 (12:1971 Relief under Bank Holding Act)",
      "12:1972" : "12:1972 (12:1972 Typing Arrangement Act)",
      "12:3410" : "12:3410 (12:3410 Right to Financial Privacy Act)",
      "15:0001" : "15:0001 (15:1 Antitrust Litigation)",
      "15:0002at" : "15:0002at (15:2 Antitrust Litigation)",
      "15:0002fl" : "15:0002fl (15:2(a) Fair Labor Standards Act)",
      "15:0005" : "15:0005 (15:5(a) Fair Labor Standards Act)",
      "15:0015" : "15:0015 (15:15 Antitrust Litigation)",
      "15:0025" : "15:0025 (15:25 Clayton Act)",
      "15:0044" : "15:0044 (15:44 Trademark Infringement)",
      "15:0045" : "15:0045 (15:0045 Federal Trade Commission Act)",
      "15:0052" : "15:0052 (15:0052 Federal Trade Commission Act)",
      "15:0053" : "15:0053 (15:0053 Federal Trade Commission Act)",
      "15:0077" : "15:0077 (15:77 Securities Fraud)",
      "15:0078" : "15:0078 (15:78m(a) Securities Exchange Act)",
      "15:0631" : "15:0631 (15:631 Small Business Act)",
      "15:0717" : "15:0717 (15:717 Natural Gas Act)",
      "15:0754" : "15:0754 (15:754 Emergency Petroleum Allocation-Admin.& Enforcement)",
      "15:1051" : "15:1051 (15:1051 Trademark Infringement)",
      "15:1114" : "15:1114 (15:1114 Trademark Infringement)",
      "15:1121" : "15:1121 (15:1121 Trademark Infringement)",
      "15:1125" : "15:1125 (15:1125 Trademark Infringement (Lanham Act))",
      "15:1126" : "15:1126 (15:1126 Patent Infringement)",
      "15:1127" : "15:1127 (15:1127 Trademark Infringement)",
      "15:1601" : "15:1601 (15:1601 Truth in Lending)",
      "15:1640" : "15:1640 (15:1640 Truth in Lending)",
      "15:1681" : "15:1681 (15:1681 Fair Credit Reporting Act)",
      "15:1691" : "15:1691 (15:1691 Equal Credit Opportunity Act)",
      "15:1692" : "15:1692 (15:1692 Fair Debt Collection Act)",
      "15:1938" : "15:1938 (15:1938 Fair Labor Standards Act)",
      "15:1981" : "15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))",
      "15:1988" : "15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))",
      "15:1989" : "15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))",
      "15:2301" : "15:2301 (15:2301 Magnuson-Moss Warranty Act)",
      "15:2801" : "15:2801 (15:2801 Petroleum Marketing Practices Act)",
      "15:53(b)" : "15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equita)",
      "16:0668" : "16:0668 (16:668 Bald Eagle Protection Act)",
      "16:0703" : "16:0703 (16:703 Migratory Bird Act)",
      "16:1538" : "16:1538 (16:1538 Endangered Species Act)",
      "16:3371" : "16:3371 (16:3371 Wildlife Under the Lacey Act)",
      "16:3372" : "16:3372 (16:3372 Conservation: Complaint for Forfeiture)",
      "16:3373" : "16:3373 (16:3373 Appeal of Decision - DOI)",
      "16:3374" : "16:3374 (16:3374 Conservation: Complaint for Forfeiture)",
      "17:0101" : "17:0101 (17:101 Copyright Infringement)",
      "17:0501" : "17:0501 (17:501 Copyright Infringement)",
      "17:0504" : "17:0504 (17:504 Copyright Infringement)",
      "18:0241" : "18:0241 (18:241 Conspiracy Against Citizen Rights)",
      "18:1514" : "18:1514 (18:1514 To restrain harassment of victim/witness)",
      "18:1831" : "18:1831 (18:1831 Defend Trade Secrets Act)",
      "18:1836a" : "18:1836a (18:1836(a) Injunction against Misappropriation of Trade Secrets)",
      "18:1836b" : "18:1836b (18:1836(b) Civil Action to Protect Trade Secrets)",
      "18:1961" : "18:1961 (18:1961 Racketeering (RICO) Act)",
      "18:1962" : "18:1962 (18:1962 Racketeering (RICO) Act)",
      "18:1964" : "18:1964 (18:1964 Racketeering (RICO) Act)",
      "18:2511" : "18:2511 (18:2511 Wiretapping)",
      "18:2701" : "18:2701 (18:2701 Stored Communications Act)",
      "18:3114" : "18:3114 (18:3114 Motion for Return of Seized Property)",
      "18:4208" : "18:4208 (18:4208(B) Agency Action Review)",
      "18:983f3A" : "18:983f3A (18:983f3A Release of Government Seized Property)",
      "19:1305" : "19:1305 (19:1305 Custom Duties: Forfeiture-Immoral Articles)",
      "20:1080" : "20:1080 (20:1080 Student Loan Recovery)",
      "20:1400" : "20:1400 (20:1400 Civil Rights of Handicapped Child)",
      "20:1401" : "20:1401 (20:1401 Education: Handicapped Child Act)",
      "20:1415" : "20:1415 (Individuals with Disabilities Education Act (IDEA))",
      "21:0841" : "21:0841 (21:841 Forfeiture Property-Drugs)",
      "21:0881" : "21:0881 (21:881 Forfeiture Property-Drugs)",
      "21:0881a" : "21:0881a (21:881 Forfeiture Property - Aircraft)",
      "21:0881re" : "21:0881re (21:881 Forfeiture Property - Real Estate)",
      "21:399d" : "21:399d (21:399 Food Safety Modernization Act (FSMA))",
      "21:801" : "21:801 (21:801 Violations of the Controlled Substance Act)",
      "23:0134" : "23:0134 (23:134 P.I.- Auto Negligence)",
      "23:1441" : "23:1441 (23:1441 Contract Real Estate)",
      "24:1000" : "24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)",
      "25:0640" : "25:0640 (25:640 Indian Tribal Rights)",
      "25:1901" : "25:1901 (25:1901 Indian Child Welfare Act)",
      "26:6212" : "26:6212 (26:6212 Injunctive Relief from IRS Lien)",
      "26:6213" : "26:6213 (26:6213 Injunctive Relief from IRS Lien)",
      "26:6502" : "26:6502 (26:6502 IRS:Enforcement of tax liens)",
      "26:6532" : "26:6532 (26:6532 IRS: Refund of Tax Penalty)",
      "26:6702" : "26:6702 (26:6702 IRS: Refund of Income Tax Penalty)",
      "26:6703" : "26:6703 (26:6703 IRS: Refund of Tax Penalty)",
      "26:7401" : "26:7401 (26:7401 IRS: Tax Liability)",
      "26:7402" : "26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)",
      "26:7402a" : "26:7402a (26:7402 Injunction to Enforce Internal Revenue Code)",
      "26:7403" : "26:7403 (26:7403 Suit to Enforce Federal Tax Lien)",
      "26:7405" : "26:7405 (26:7405 Suit by US for Recovery of Erroneous Refund)",
      "26:7422rt" : "26:7422rt (26:7422 IRS: Refund Taxes)",
      "26:7422rx" : "26:7422rx (26:7422 IRS: Refund Excise Tax)",
      "26:7426" : "26:7426 (26:7426 IRS: Wrongful Levy for Taxes)",
      "26:7429" : "26:7429 (26:7429 IRS: Tax Jeopardy Assessment)",
      "26:7609" : "26:7609 (26:7609 IRS: Petition to Quash IRS Summons)",
      "27:0185" : "27:0185 (27:185 Enforcement of Arbitration Award)",
      "28:0157c" : "28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)",
      "28:0157d" : "28:0157d (28:0157 Motion for Withdrawal of Reference)",
      "28:0158" : "28:0158 (28:0158 Bankruptcy Appeal from Judgment/Order)",
      "28:0185" : "28:0185 (28:185 Suit to Compel Arbitration)",
      "28:0451" : "28:0451 (28:451 Employment Discrimination)",
      "28:0754" : "28:0754 (28:754 Receiver of Property in Different Districts)",
      "28:0794" : "28:0794 (28:794 Rehabilitation Act)",
      "28:1001" : "28:1001 (28:1001 E.R.I.S.A.)",
      "28:1132" : "28:1132 (28:1132 E.R.I.S.A.)",
      "28:1330" : "28:1330 (28:1330 Breach of Contract)",
      "28:1331" : "28:1331 (28:1331 Fed. Question)",
      "28:1331al" : "28:1331al (28:1331 Fed. Question: Airline Crash)",
      "28:1331at" : "28:1331at (28:1331 Fed. Question: Anti-trust)",
      "28:1331au" : "28:1331au (28:1331 Fed. Question: Auto Negligence)",
      "28:1331b" : "28:1331b (28:1331 Federal Question: Bivens Act)",
      "28:1331bc" : "28:1331bc (28:1331 Fed. Question: Breach of Contract)",
      "28:1331ca" : "28:1331ca (28:1331 Fed Question: Fed Communications Act of 1)",
      "28:1331cm" : "28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)",
      "28:1331cv" : "28:1331cv (28:1331 Fed. Question: Civil Rights Violation)",
      "28:1331ed" : "28:1331ed (28:1331 Fed. Question: Employment Discrimination)",
      "28:1331ej" : "28:1331ej (28:1331 Federal Question: Enforcement of Judgment)",
      "28:1331es" : "28:1331es (28:1331 Enforcement of Administrative Subpoena)",
      "28:1331fl" : "28:1331fl (28:1331 Fed. Question: Fair Labor Standards)",
      "28:1331in" : "28:1331in (28:1331 Fed. Question: Insurance Contract)",
      "28:1331mm" : "28:1331mm (28:1331 Fed. Question: Medical Malpractice)",
      "28:1331ng" : "28:1331ng (28:1331 Fed. Question: Natural Gas Act)",
      "28:1331pi" : "28:1331pi (28:1331 Fed. Question: Personal Injury)",
      "28:1331rd" : "28:1331rd (28:1331 Fed. Question: Review Agency Decision)",
      "28:1331rp" : "28:1331rp (28:1331(a) Fed. Question: Real Property)",
      "28:1331rr" : "28:1331rr (28:1331 Fed. Question: Railway Labor Act)",
      "28:1331sv" : "28:1331sv (28:1331 Fed. Question: Securities Violation)",
      "28:1331tr" : "28:1331tr (28:1331 Fed. Question: Trademark)",
      "28:1331tt" : "28:1331tt (28:1331 Fed. Question: Tort Action)",
      "28:1331v" : "28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendment)",
      "28:1331wl" : "28:1331wl (28:1331 Federal Question: EPA Waste Lien)",
      "28:1331wt" : "28:1331wt (28:1331 Fed. Question: Water Rights)",
      "28:1332ac" : "28:1332ac (28:1332 Diversity-Account Receivable)",
      "28:1332al" : "28:1332al (28:1332 Diversity-Airline Crash)",
      "28:1332as" : "28:1332as (28:1332 Diversity-Asbestos Litigation)",
      "28:1332au" : "28:1332au (28:1332 Diversity-Auto Negligence)",
      "28:1332bc" : "28:1332bc (28:1332 Diversity-Breach of Contract)",
      "28:1332co" : "28:1332co (28:1332 Diversity-Conversion)",
      "28:1332ct" : "28:1332ct (28:1332 Diversity-(Citizenship))",
      "28:1332det" : "28:1332det (28:1332 Diversity: Forcible Detainer)",
      "28:1332df" : "28:1332df (28:1332 Diversity-Contract Default)",
      "28:1332ds" : "28:1332ds (28:1332 Diversity-Contract Dispute)",
      "28:1332ed" : "28:1332ed (28:1332 Diversity-Employment Discrimination)",
      "28:1332fd" : "28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)",
      "28:1332fr" : "28:1332fr (28:1332 Diversity-Fraud)",
      "28:1332ia" : "28:1332ia (28:1332 Diversity-Interpleader Action)",
      "28:1332ij" : "28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)",
      "28:1332in" : "28:1332in (28:1332 Diversity-Insurance Contract)",
      "28:1332jd" : "28:1332jd (28:1332 Diversity-Declaratory Judgment)",
      "28:1332lb" : "28:1332lb (28:1332 Diversity-Libel, Assault, Slander)",
      "28:1332lm" : "28:1332lm (28:1332 Diversity - Legal Malpractice)",
      "28:1332ma" : "28:1332ma (28:1332 Diversity-Miller Act)",
      "28:1332mm" : "28:1332mm (28:1332 Diversity-Medical Malpractice)",
      "28:1332mv" : "28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)",
      "28:1332ni" : "28:1332ni (28:1332 Diversity-Negotiable Instrument)",
      "28:1332nm" : "28:1332nm (28:1332 Diversity-Non-Motor Vehicle)",
      "28:1332nr" : "28:1332nr (28:1332 Diversity-Notice of Removal)",
      "28:1332oc" : "28:1332oc (28:1332 Diversity-Other Contract)",
      "28:1332pd" : "28:1332pd (28:1332 Diversity-Property Damage)",
      "28:1332pi" : "28:1332pi (28:1332 Diversity-Personal Injury)",
      "28:1332pl" : "28:1332pl (28:1332 Diversity-Product Liability)",
      "28:1332pr" : "28:1332pr (28:1332 Diversity-Petition for Removal)",
      "28:1332qt" : "28:1332qt (28:1332 Diversity-Petition to Quiet Title)",
      "28:1332ri" : "28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)",
      "28:1332sa" : "28:1332sa (28:1332 - Diversity: Securities & Exchange Commiss)",
      "28:1332sf" : "28:1332sf (28:1332 - Diversity: Securities Fraud)",
      "28:1332ss" : "28:1332ss (28:1332 Diversity - Stockholders Suits)",
      "28:1332tl" : "28:1332tl (28:1332 Diversity-Torts to Land)",
      "28:1332tm" : "28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))",
      "28:1332tn" : "28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)",
      "28:1332wd" : "28:1332wd (28:1332 Diversity-Wrongful Death)",
      "28:1333" : "28:1333 (28:1333 Admiralty)",
      "28:1334" : "28:1334 (28:1334 Bankruptcy Appeal)",
      "28:1334c" : "28:1334c (28:1334(c) R&R re motions for abstention (non-cor)",
      "28:1335" : "28:1335 (28:1335 Interpleader Action)",
      "28:1337" : "28:1337 (28:1337 Sherman-Clayton Act)",
      "28:1338cp" : "28:1338cp (28:1338 Copyright Infringement)",
      "28:1338pt" : "28:1338pt (28:1338 Patent Infringement)",
      "28:1338tr" : "28:1338tr (28:1338 Trademark Infringement)",
      "28:1340" : "28:1340 (28:1340 IRS: Custom Duties)",
      "28:1340er" : "28:1340er (28:1340 Recovery of Erroneous Refund)",
      "28:1341" : "28:1341 (28:1341 Complaint for Forfeiture)",
      "28:1343" : "28:1343 (28:1343 Violation of Civil Rights)",
      "28:1345" : "28:1345 (28:1345 USA Plaintiff)",
      "28:1345co" : "28:1345co (28:1345 Replevin & Conversion)",
      "28:1345db" : "28:1345db (28:1345 Debt to US - FHA/HUD Title I)",
      "28:1345df" : "28:1345df (28:1345 Default of Promissory Note)",
      "28:1345er" : "28:1345er (28:1345 Recovery of Erroneous Refund)",
      "28:1345fc" : "28:1345fc (28:1345 Foreclosure)",
      "28:1345ff" : "28:1345ff (28:1345 Complaint for Forfeiture)",
      "28:1345hl" : "28:1345hl (28:1345 VA Home Loan Guaranty Debt)",
      "28:1345mc" : "28:1345mc (28:1345 Medical Care Recovery)",
      "28:1345mi" : "28:1345mi (28:1345 Mining Claim Ejectment)",
      "28:1345pd" : "28:1345pd (28:1345 Property Damage)",
      "28:1345pe" : "28:1345pe (28:1345 VA Property Ejectment)",
      "28:1345rc" : "28:1345rc (28:1345 Recovery of Debt to US)",
      "28:1345st" : "28:1345st (28:1345 Default of Student Loan)",
      "28:1345tp" : "28:1345tp (28:1345 Trespass on Public Land)",
      "28:1345va" : "28:1345va (28:1345 Recovery of VA Overpayment)",
      "28:1346bc" : "28:1346bc (28:1346 Breach of Contract)",
      "28:1346rc" : "28:1346rc (28:1346 Recovery of IRS Tax)",
      "28:1346tc" : "28:1346tc (28:1346 Tort Claim)",
      "28:1346wd" : "28:1346wd (28:1346 Wrongful Death)",
      "28:1349" : "28:1349 (28:1348 Corporation organized under Federal Law as party)",
      "28:1352" : "28:1352 (28:1352 Miller Act)",
      "28:1355" : "28:1355 (28:1355 Petition for Return of Property)",
      "28:1358" : "28:1358 (28:1358 Land Condemnation)",
      "28:1361" : "28:1361 (28:1361 Petition for Writ of Mandamus)",
      "28:1362ic" : "28:1362ic (28:1362 Indian Tribal Controversy)",
      "28:1362iw" : "28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)",
      "28:1364" : "28:1364 (28:1364 Auto Negligence)",
      "28:1367" : "28:1367 (28:1367 Federal Receiver Case to Disgorge Profits)",
      "28:1391" : "28:1391 (28:1391 Personal Injury)",
      "28:1402" : "28:1402 (28:1402 Medical Malpractice)",
      "28:1407" : "28:1407 (28:1407 Airline Crash)",
      "28:1441ac" : "28:1441ac (28:1441 Notice of Removal-Account Receivable)",
      "28:1441al" : "28:1441al (28:1441 Notice of Removal-Airline Crash)",
      "28:1441as" : "28:1441as (28:1441 Notice of Removal-Asbestos Litigation)",
      "28:1441au" : "28:1441au (28:1441 Notice of Removal-Auto Negligence)",
      "28:1441bc" : "28:1441bc (28:1441 Notice of Removal-Breach of Contract)",
      "28:1441cv" : "28:1441cv (28:1441 Petition for Removal- Civil Rights Act)",
      "28:1441df" : "28:1441df (28:1441 Notice of Removal-Contract Default)",
      "28:1441dj" : "28:1441dj (28:1441 Notice of Removal-Declaratory Judgment)",
      "28:1441ds" : "28:1441ds (28:1441 Notice of Removal-Contract Dispute)",
      "28:1441ed" : "28:1441ed (28:1441 Petition for Removal - Employment Discrim)",
      "28:1441fc" : "28:1441fc (28:1441 Petition for Removal - Fair Credit Reporti)",
      "28:1441fr" : "28:1441fr (28:1441 Notice of Removal-Fraud)",
      "28:1441ij" : "28:1441ij (28:1441 Notice of Removal-Injunctive/Declaratory Relief)",
      "28:1441in" : "28:1441in (28:1441 Notice of Removal-Insurance Contract)",
      "28:1441int" : "28:1441int (28:1441 Petition for Removal- Action for Interplea)",
      "28:1441lb" : "28:1441lb (28:1441 Notice of Removal-Libel, Assault, Slander)",
      "28:1441lm" : "28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relatio)",
      "28:1441mm" : "28:1441mm (28:1441 Notice of Removal-Medical Malpractice)",
      "28:1441ni" : "28:1441ni (28:1441 Notice of Removal-Negotiable Instrument)",
      "28:1441nm" : "28:1441nm (28:1441 Notice of Removal-Non-Motor Vehicle)",
      "28:1441nr" : "28:1441nr (28:1441 Notice of Removal)",
      "28:1441oc" : "28:1441oc (28:1441 Petition For Removal--Other Contract)",
      "28:1441pd" : "28:1441pd (28:1441 Notice of Removal-Property Damage)",
      "28:1441pi" : "28:1441pi (28:1441 Notice of Removal-Personal Injury)",
      "28:1441pl" : "28:1441pl (28:1441 Notice of Removal-Product Liability)",
      "28:1441pr" : "28:1441pr (28:1441 Petition for Removal)",
      "28:1441qt" : "28:1441qt (28:1441 Notice of Removal-Petition to Quiet Title)",
      "28:1441ri" : "28:1441ri (28:1441 Petition for Removal- Racketeering (RICO))",
      "28:1441sa" : "28:1441sa (28:1441 - Petition for Removal: SEC Act)",
      "28:1441sf" : "28:1441sf (28:1441 - Petition for Removal: Securities Fraud)",
      "28:1441tl" : "28:1441tl (28:1441 Notice of Removal-Torts to Land)",
      "28:1441tm" : "28:1441tm (28:1441 Notice of Removal-Tort/Motor Vehicle (P.I.))",
      "28:1441tn" : "28:1441tn (28:1441 Notice of Removal-Tort/Non-Motor Vehicle)",
      "28:1441wd" : "28:1441wd (28:1441 Notice of Removal-Wrongful Death)",
      "28:1442bc" : "28:1442bc (28:1442 Notice of Removal-Breach of Contract)",
      "28:1442nr" : "28:1442nr (28:1442 Notice of Removal)",
      "28:1442pr" : "28:1442pr (28:1442 Petition for Removal)",
      "28:1443" : "28:1443 (28:1443(1) Rent, Lease & Ejectment)",
      "28:1444" : "28:1444 (28:1441 Notice of Removal-Foreclosure)",
      "28:1446in" : "28:1446in (28:1446 Breach of Contract- Insurance)",
      "28:1446nr" : "28:1446nr (28:1446 Notice of Removal)",
      "28:1446pd" : "28:1446pd (28:1446 Notice of Removal-Property Damage (P.I.))",
      "28:1446pi" : "28:1446pi (28:1446 Notice of Removal-Personal Injury)",
      "28:1446pl" : "28:1446pl (28:1446pl Petition for Removal - Product Liability)",
      "28:1446pr" : "28:1446pr (28:1446 Petition for Removal)",
      "28:1452" : "28:1452 (28:1452 Removal of Claim in Civil Action Related to BK. Case)",
      "28:1491" : "28:1491 (28:1491 Review of Federal Agency Bids for Contract)",
      "28:1651" : "28:1651 (28:1651 Petition for Writ of Coram Nobis)",
      "28:1782" : "28:1782 (28:1782 Letter rogatory - appointment)",
      "28:1983" : "28:1983 (28:1983 Civil Rights (DO NOT USE))",
      "28:2201" : "28:2201 (28:2201 Constitutionality of State Statute(s))",
      "28:2201dj" : "28:2201dj (28:2201 Declaratory Judgment)",
      "28:2201ij" : "28:2201ij (28:2201 Injunction)",
      "28:2201in" : "28:2201in (28:2201 Declaratory Judgment (Insurance))",
      "28:2241c" : "28:2241c (28:2241 Petition for Writ of Habeas Corpus (County))",
      "28:2241f" : "28:2241f (28:2241 Petition for Writ of Habeas Corpus (Federal))",
      "28:2241s" : "28:2241s (28:2241 Petition for Writ of Habeas Corpus (State))",
      "28:2254" : "28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))",
      "28:2254se" : "28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)",
      "28:2255" : "28:2255 (28:2255 Motion to Vacate Sentence)",
      "28:2271" : "28:2271 (28:2271 Federal Tort Claims Act)",
      "28:2345" : "28:2345 (28:2345 Medicare Recovery)",
      "28:2409" : "28:2409 (28:2409(a) Quiet Title Action)",
      "28:2410" : "28:2410 (Actions affecting property on which United States had lien)",
      "28:2671" : "28:2671 (28:2671 Federal Tort Claims Act)",
      "28:2674" : "28:2674 (28:2674 Federal Tort Claims Act)",
      "28:3001" : "28:3001 (28:3001 Federal Debt Collection Act)",
      "28:7402" : "28:7402 (28:7402 Refund of Taxes)",
      "28:7422" : "28:7422 (28:7422 Appeal from Administrative Decision)",
      "29:0151" : "29:0151 (29:151 Labor: Review of Agency Action)",
      "29:0160" : "29:0160 (29:160(1) National Labor Relations Act)",
      "29:0184" : "29:0184 (29:184 Violation Collection Bargain Agreement)",
      "29:0185ep" : "29:0185ep (29:185 Employee Pension Plan)",
      "29:0185lm" : "29:0185lm (29:185 Labor/Mgt. Relations (Contracts))",
      "29:0201do" : "29:0201do (29:201 Denial of Overtime Compensation)",
      "29:0201fl" : "29:0201fl (29:201 Fair Labor Standards Act)",
      "29:0203" : "29:0203 (29:203 Equal Pay Act)",
      "29:0206" : "29:0206 (29:206 Collect Unpaid Wages)",
      "29:0401" : "29:0401 (29:0401 Labor Management Disclosure Act)",
      "29:0621" : "29:0621 (29:621 Job Discrimination (Age))",
      "29:0623" : "29:0623 (29:623 Job Discrimination (Age))",
      "29:0626" : "29:0626 (29:626 Job Discrimination (Age))",
      "29:0633" : "29:0633 (29:633 Job Discrimination (Age))",
      "29:0651" : "29:0651 (29:651 Occupational Safety/Health)",
      "29:0754" : "29:0754 (29:754 Discrimination)",
      "29:0791" : "29:0791 (29:791 Job Discrimination (Rehabilitation Act))",
      "29:0794" : "29:0794 (29:0794 Job Discrimination (Handicap))",
      "29:1001" : "29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)",
      "29:1002" : "29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)",
      "29:1104" : "29:1104 (29:1104 Recovery of Benefits to Employee)",
      "29:1109" : "29:1109 (29:1109 Breach of Fiduciary Duties)",
      "29:1131" : "29:1131 (29:1131 ERISA - Collection of Delinquent Trust Funds)",
      "29:1132" : "29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)",
      "29:1145" : "29:1145 (29:1145 E.R.I.S.A.)",
      "29:1149" : "29:1149 (29:1149 Recover Pension & Profit Sharing)",
      "29:1337" : "29:1337 (29:1337 E.R.I.S.A.)",
      "29:1362" : "29:1362 (29:1362 ERISA)",
      "29:1381" : "29:1381 (29:1381 E.R.I.S.A.)",
      "29:1401" : "29:1401 (29:1401(b)(2) Appeal of Arbitration Award)",
      "29:1451" : "29:1451 (29:1451 E.R.I.S.A.)",
      "29:1801" : "29:1801 (29:1801 Farmworker Rights)",
      "29:2001" : "29:2001 (29:2001 Employee Polygraph Protection Act)",
      "29:2101" : "29:2101 (29:2101 WARN Act)",
      "29:2601" : "29:2601 (29:2601 Family Medical Leave Act)",
      "29:790" : "29:790 (29:790 Rehabilitation of Labor)",
      "30:0181" : "30:0181 (30:181 Environment: Review of Agency Action)",
      "30:0801" : "30:0801 (30:0801 Penalities/Federal Mine Safety Health Act)",
      "30:1201" : "30:1201 (30:1201 Environment: Review of Agency Action)",
      "30:1202" : "30:1202 (30:1202 Mining Reclamation Act)",
      "30:1276" : "30:1276 (30:1276 Interior: Review of Agency Action)",
      "31:3545" : "31:3545 (31:3545 Action to Recovery Money)",
      "31:3729" : "31:3729 (31:3729 False Claims Act)",
      "31:3730" : "31:3730 (31:3730 Qui Tam False Claims Act)",
      "31:3731" : "31:3731 (31:3731 Fraud)",
      "33:1319cw" : "33:1319cw (33:1319 Clean Water Act)",
      "33:1319pv" : "33:1319pv (33:1319 Pollutants & Permit Violations)",
      "33:1365" : "33:1365 (33:1365 Environmental Matters)",
      "35:0145" : "35:0145 (35:145 Patent Infringement)",
      "35:0183" : "35:0183 (35:183 Patent Infringement)",
      "35:0271" : "35:0271 (35:271 Patent Infringement)",
      "38:1681" : "38:1681 (38:1681 Recovery of VA Overpayment)",
      "38:1686" : "38:1686 (38:1686 Recovery of VA Overpayment)",
      "38:1780" : "38:1780 (38:1780 Recovery of VA Overpayment)",
      "38:2011" : "38:2011 (38:2011 - Veteran's Readjustment Assistance Act of)",
      "38:2021" : "38:2021 (Right to re-employment of inducted persons)",
      "38:3116" : "38:3116 (38:3116 VA Overpayment)",
      "38:4301" : "38:4301 (38:4301 Violation of Uniform Services Employment Rights Act)",
      "38:775" : "38:775 (Recovery of Servicemen's Group Life Insurance)",
      "39:3005" : "39:3005 (39:3005 Detention of Mail for Temporary Periods)",
      "39:409" : "39:409 (39:409 Postal Service)",
      "40:0258" : "40:0258 (40:258(a) Public Buildings & Property: Land Condemnation)",
      "40:0875" : "40:0875 (40:875 Public Buildings & Property: Negligence)",
      "40:3131" : "40:3131 (40:3131 Miller Act)",
      "41:0251" : "41:0251 (41:251 Public Contracts-Review of Agency Action)",
      "41:1463" : "41:1463 (41:1463 Public Contracts: Unlawful Employment Practices)",
      "42:0205" : "42:0205 (42:205 Denial Social Security Benefits)",
      "42:0206" : "42:0206 (42:206 Social Security Benefits)",
      "42:0247" : "42:0247 (42:247 Personal Injury-Swine Flu)",
      "42:0402" : "42:0402 (42:402 Social Security Benefits)",
      "42:0405id" : "42:0405id (42:405 Review of HHS Decision (SSID))",
      "42:0405wc" : "42:0405wc (42:405 Review of HHS Decision (DIWC))",
      "42:0405ww" : "42:0405ww (42:405 Review of HHS Decision (DIWW))",
      "42:0416" : "42:0416 (42:416 Denial of Social Security Benefits)",
      "42:0427" : "42:0427 (42:427 Social Security Benefits)",
      "42:11601" : "42:11601 (42:11601 International Child Abduction Remedies Act / Hague)",
      "42:12117" : "42:12117 (42:12117 Americans with Disabilities Act)",
      "42:1383" : "42:1383 (42:1383 Review of HHS Decision)",
      "42:1395" : "42:1395 (42:1395 HHS: Adverse Reimbursement Review)",
      "42:1395dd" : "42:1395dd (42:1395dd EMTALA Claims and Gross Negligence/Negligence)",
      "42:1396" : "42:1396 (42:1396 - Tort Negligence)",
      "42:1471" : "42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclo)",
      "42:1973" : "42:1973 (42:1973 - Voting Rights Act of 1965)",
      "42:1981cv" : "42:1981cv (42:1981 Civil Rights)",
      "42:1981hs" : "42:1981hs (42:1981 Housing Discrimination)",
      "42:1981jb" : "42:1981jb (42:1981 Job Discrimination (Race))",
      "42:1981sx" : "42:1981sx (42:1981 Sex Discrimination)",
      "42:1982cv" : "42:1982cv (42:1982 Civil Rights Racial Discrimination)",
      "42:1983cv" : "42:1983cv (42:1983 Civil Rights Act)",
      "42:1983ed" : "42:1983ed (42:1983 Civil Rights (Employment Discrimination))",
      "42:1983pr" : "42:1983pr (42:1983pr (Other))",
      "42:1983prb" : "42:1983prb (42:1983 Prisoner Civil Rights, Federal Filers (Bivens))",
      "42:1983prs" : "42:1983prs (42:1983 Prisoner Civil Rights, State Filers)",
      "42:1986" : "42:1986 (42:1986 Neglect of Duty)",
      "42:2000ag" : "42:2000ag (42:2000 Job Discrimination (Age))",
      "42:2000e" : "42:2000e (42:2000e Job Discrimination (Employment))",
      "42:2000pb" : "42:2000pb (42:2000 Job Discrimination (Public Accommodations))",
      "42:2000ra" : "42:2000ra (42:2000 Job Discrimination (Race))",
      "42:2000sx" : "42:2000sx (42:2000 Job Discrimination (Sex))",
      "42:2003" : "42:2003 (42:2003 Job Discrimination)",
      "42:2005" : "42:2005 (42:2005 Review of Agency Action-HHS)",
      "42:2615" : "42:2615 (42:2616 Medical Recovery Act)",
      "42:2651" : "42:2651 (42:2651 Medical Care Recovery)",
      "42:3601" : "42:3601 (42:405 Fair Housing Act)",
      "42:4000" : "42:4000 (42:4000 National Flood Insurance Act)",
      "42:4001" : "42:4001 (42:4001 National Insurance Flood Act)",
      "42:4053" : "42:4053 (42:4053 Breach of Insurance Contract)",
      "42:4072" : "42:4072 (42:4072 Payment of Flood Insurance Claim)",
      "42:4321" : "42:4321 (42:4321 Review of Agency Action-Environment)",
      "42:4332" : "42:4332 (42:4332)",
      "42:6901en" : "42:6901en (42:6901 Environmental Cleanup Expenses)",
      "42:6901rs" : "42:6901rs (42:6901 Resource & Recovery Act)",
      "42:7413" : "42:7413 (42:7413(b) Clean Air Act)",
      "42:7604cl" : "42:7604cl (42:7604 Clear Air Act (Emission Standards))",
      "42:7604ir" : "42:7604ir (42:7604 Petition to Quash IRS Summons)",
      "42:9601" : "42:9601 (42:9601 Hazardous Substances Releases, Liability - Definition)",
      "42:9607" : "42:9607 (42:9607 Real Property Tort to Land)",
      "43:945" : "43:945 (43:945 Compensation for Land Condemnation)",
      "43:945a" : "43:945a (43:945a Complaint in Condemnation)",
      "43:946" : "43:946 (43:946 Complaint in Condemnation - Eminent Domain)",
      "45:0051" : "45:0051 (45:51 Railways: Fed. Employer's Liability Act)",
      "45:0151" : "45:0151 (45:151 Railway Labor Act)",
      "45:0184" : "45:0184 (45:184 Action to Set Aside Award of a System Board of Adjust)",
      "45:1395" : "45:1395 (45:1395 Railroads: Adverse Reimbursement Review)",
      "45:7457" : "45:7457 (45:7457 Compel Reclamation Under Clear Air Act)",
      "46:0688" : "46:0688 (46:688 Jones Act)",
      "46:0741" : "46:0741 (46:741 Shipping)",
      "46:0761" : "46:0761 (46:761 Shipping: Damages for Death on High Seas)",
      "46:1101" : "46:1101 (46:1101 Violation of Maritime Regulations)",
      "46:1156" : "46:1156 (46:1156 Administrative Procedure Act)",
      "46:30511" : "46:30511 (46:30511 Action by Owner for Limitation)",
      "47:0151" : "47:0151 (47:0151 Communications Act)",
      "47:0553" : "47:0553 (47:0553 Unauthorized Reception of Cable Service)",
      "47:227" : "47:227 (47:227 Violation of the Telephone Consumer Protection Act)",
      "48:0883" : "48:0883 (48:883 Violation of US Coastal Law)",
      "48:1985" : "48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)",
      "49:0081" : "49:0081 (49:81 Damaged Goods While Being Transported)",
      "49:0781" : "49:0781 (49:781 Forfeiture)",
      "49:11503" : "49:11503 (49:11503 Railroad Revitalization Regulatory Reform)",
      "49:11702" : "49:11702 (49:11702(a)(4) Violations of Interstate Commerce A)",
      "49:1471" : "49:1471 (49:1471 Federal Aviation Act)",
      "49:1903" : "49:1903 (49:1903 Petition to enforce administrative summon)",
      "49:3011" : "49:3011 (49:3011 National Traffic and Motor Vehicle Safety Act)",
      "49:32710b" : "49:32710b (49:32710(b) Federal Odometer Act - Odometer Tampering and Fraud)",
      "50:3901" : "50:3901 (50:3901 Federal Question: Servicemembers Civil Relief Act)",
      "7:2023" : "7:2023 (Food Stamp Act)",
      "8:287" : "8:287 (8:287 Petition to Enforce INS Subpoena)",
      "99:9999" : "99:9999 (99:9999 Report cause code (DO NOT DELETE!))",
      "adsup" : "adsup (Administrative Subpoena)",
      "contempt" : "contempt (Contempt Proceedings)",
      "disbar" : "disbar (Disbarment Proceedings)",
      "fordepo" : "fordepo (Foreign Deposition)",
      "misc" : "misc (Civil Miscellaneous Case)",
      "motcomp" : "motcomp (Motion to Compel)",
      "motquash" : "motquash (Motion to Quash)",
      "motret" : "motret (Motion for Return of Property)",
      "petenf" : "petenf (Petition to Enforce IRS Summons)",
      "petper" : "petper (Petition to Perpetuate Testimony)",
      "regjgm" : "regjgm (Registration of Foreign Judgment)",
      "tranbkref" : "tranbkref (Transmission of Bankruptcy Reference)",
      "tranff" : "tranff (Transmission of Proposed Findings of Fact and Concl. of Law)",
      "writgar" : "writgar (Application for a Writ of Garnishment)"
   },
   "sddce" : {
      "02:0431" : "02:0431 (02:431 Fed. Election Commission: Failure Enforce C)",
      "02:0437" : "02:0437 (02:437 Federal Election Commission)",
      "05:0075" : "05:0075 (05:75(2) Contract - Reduction in Grade)",
      "05:0551" : "05:0551 (05:551 Administrative Procedure Act)",
      "05:0552fi" : "05:0552fi (05:552 Freedom of Information Act)",
      "05:0552pa" : "05:0552pa (05:552 Right to Privacy Act)",
      "05:0554" : "05:0554 (05:0554 Constitutionality of Maritime Statutes)",
      "05:0701" : "05:0701 (05:0701 Maritime Subsidy Board)",
      "05:0702" : "05:0702 (05:702 Administrative Procedure Act)",
      "05:0704" : "05:0704 (05:704 Labor Litigation)",
      "05:7703" : "05:7703 (05:7703 Discrimination - Review of Agency Act)",
      "07:0006" : "07:0006 (7:6(b) Federal Commodity Exchange Regulation)",
      "07:0025" : "07:0025 (7:25 Fraud - Commodities Leverage Contracts)",
      "07:0181" : "07:0181 (07:181 Packers & Stockyard Act)",
      "07:0247" : "07:0247 (07:0247 Recovery on Surety Bond (Warehouse Act))",
      "07:0499" : "07:0499 (07:499 Agricultural Commodities Act)",
      "07:0601" : "07:0601 (07:601 USDA Condemnation)",
      "07:1401" : "07:1401 (Agriculture Adjustment Act)",
      "07:2321" : "07:2321 (07:2321 Plant Variety Protection Act)",
      "08:1105" : "08:1105 (8:1105(a) Aliens: Habeas Corpus to Release INS Det)",
      "08:1252" : "08:1252 (08:1252(a)(2) Injunction for Deportation)",
      "08:1260" : "08:1260 (08:1260 Aliens: Access to Records)",
      "08:1324" : "08:1324 (08:1324 Aliens: Complaint for Forfeiture)",
      "08:1329" : "08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petiti)",
      "08:1446" : "08:1446 (8:1446 Petition for Naturalization Hearing)",
      "08:1447" : "08:1447 (Review of Denial of Naturalization Application)",
      "09:0001" : "09:0001 (09:1 U.S. Arbitration Act)",
      "09:0009" : "09:0009 (9:9 Motion to Confirm Arbitration Loan)",
      "09:0010" : "09:0010 (09:0010 Petition to Vacate Arbitration Award)",
      "10:1552" : "10:1552 (10:1552 Armed Forces: Action to Correct Records)",
      "10:1553" : "10:1553 (10:1553 Armed Forces: FOIA General)",
      "10:2305" : "10:2305 (10:2305 Review of Federal Contract)",
      "11:0101" : "11:0101 (11:101 Bankruptcy)",
      "12:0022" : "12:0022 (12:22 Securities Fraud)",
      "12:0635" : "12:0635 (12:635 Breach of Insurance Contract)",
      "12:1461" : "12:1461 (12:1461 Homeowners Loan Act)",
      "12:1703" : "12:1703 (12:1703 Default of HUD Loan)",
      "12:1725" : "12:1725 (12:1725 Collection under Contract Guaranty)",
      "12:1730" : "12:1730 (12:1730 Collection Under Contract Guaranty)",
      "12:1787" : "12:1787 (12:1787 Federal Credit Union - Payment of Insurance)",
      "12:1819" : "12:1819 (12:1819 Default of Promissory Note)",
      "12:1821" : "12:1821 (12:1821 Default of Loan by Promissary Note)",
      "12:1971" : "12:1971 (12:1971 Relief under Bank Holding Act)",
      "12:3410" : "12:3410 (12:3410 Right to Financial Privacy Act)",
      "15:0001" : "15:0001 (15:1 Antitrust Litigation)",
      "15:0002at" : "15:0002at (15:2 Antitrust Litigation)",
      "15:0002fl" : "15:0002fl (15:2(a) Fair Labor Standards Act)",
      "15:0005" : "15:0005 (15:5(a) Fair Labor Standards Act)",
      "15:0015" : "15:0015 (15:15 Antitrust Litigation)",
      "15:0025" : "15:0025 (15:25 Clayton Act)",
      "15:0044" : "15:0044 (15:44 Trademark Infringement)",
      "15:0045" : "15:0045 (15:0045 Federal Trade Commission Act)",
      "15:0052" : "15:0052 (15:0052 Federal Trade Commission Act)",
      "15:0053" : "15:0053 (15:0053 Federal Trade Commission Act)",
      "15:0077" : "15:0077 (15:77 Securities Fraud)",
      "15:0078" : "15:0078 (15:78m(a) Securities Exchange Act)",
      "15:0631" : "15:0631 (15:631 Small Business Act)",
      "15:0717" : "15:0717 (15:717 Natural Gas Act)",
      "15:1051" : "15:1051 (15:1051 Trademark Infringement)",
      "15:1114" : "15:1114 (15:1114 Trademark Infringement)",
      "15:1121" : "15:1121 (15:1121 Trademark Infringement)",
      "15:1125" : "15:1125 (15:1125 Trademark Infringement (Lanham Act))",
      "15:1126" : "15:1126 (15:1126 Patent Infringement)",
      "15:1127" : "15:1127 (15:1127 Trademark Infringement)",
      "15:1601" : "15:1601 (15:1601 Truth in Lending)",
      "15:1640" : "15:1640 (15:1640 Truth in Lending)",
      "15:1681" : "15:1681 (15:1681 Fair Credit Reporting Act)",
      "15:1692" : "15:1692 (15:1692 Fair Debt Collection Act)",
      "15:1938" : "15:1938 (15:1938 Fair Labor Standards Act)",
      "15:1981" : "15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))",
      "15:1988" : "15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))",
      "15:1989" : "15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))",
      "15:2301" : "15:2301 (15:2301 Magnuson-Moss Warranty Act)",
      "15:2801" : "15:2801 (15:2801 Petroleum Marketing Practices Act)",
      "15:53(b)" : "15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equita)",
      "16:0668" : "16:0668 (16:668 Bald Eagle Protection Act)",
      "16:0703" : "16:0703 (16:703 Migratory Bird Act)",
      "16:0715" : "16:0715 (16:0715 Migratory Bird Conservation Act)",
      "16:0718" : "16:0718 (16:0718 Hunting and Conservation Stamp Tax)",
      "16:1538" : "16:1538 (16:1538 Endangered Species Act)",
      "16:3371" : "16:3371 (16:3371 Wildlife Under the Lacey Act)",
      "16:3372" : "16:3372 (16:3372 Conservation: Complaint for Forfeiture)",
      "16:3373" : "16:3373 (16:3373 Appeal of Decision - DOI)",
      "16:3374" : "16:3374 (16:3374 Conservation: Complaint for Forfeiture)",
      "17:0101" : "17:0101 (17:101 Copyright Infringement)",
      "17:0501" : "17:0501 (17:501 Copyright Infringement)",
      "17:0504" : "17:0504 (17:504 Copyright Infringement)",
      "18:0241" : "18:0241 (18:241 Conspiracy Against Citizen Rights)",
      "18:0981" : "18:0981 (Civil Forfeiture of Real Property)",
      "18:1035" : "18:1035 (18:1035 False Statements Relating to Health Care)",
      "18:1836a" : "18:1836a (18:1836(a) - Injunction against Misappropriation of Trade Secrets)",
      "18:1836b" : "18:1836b (18:1836(b) - Civil Action to Protect Trade Secrets)",
      "18:1961" : "18:1961 (18:1961 Racketeering (RICO) Act)",
      "18:1962" : "18:1962 (18:1962 Racketeering (RICO) Act)",
      "18:1964" : "18:1964 (18:1964 Racketeering (RICO) Act)",
      "18:4208" : "18:4208 (18:4208(B) Agency Action Review)",
      "19:1305" : "19:1305 (19:1305 Custom Duties:0Forfeiture-Immoral Articles)",
      "20:1080" : "20:1080 (20:1080 Student Loan Recovery)",
      "20:1400" : "20:1400 (20:1400 Civil Rights of Handicapped Child)",
      "20:1401" : "20:1401 (20:1401 Education: Handicapped Child Act)",
      "21:0841" : "21:0841 (21:841 Forfeiture Property-Drugs)",
      "21:0842" : "21:0842 (21:842 Food & Drugs - Prohibited Acts)",
      "21:0881" : "21:0881 (21:881 Forfeiture Property-Drugs)",
      "21:0881a" : "21:0881a (21:881 Forfeiture Property - Aircraft)",
      "21:0881re" : "21:0881re (21:881 Forfeiture Property - Real Estate)",
      "23:0134" : "23:0134 (23:134 P.I.- Auto Negligence)",
      "23:1441" : "23:1441 (23:1441 Contract Real Estate)",
      "24:1000" : "24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)",
      "25:0081" : "25:0081 (Contracts with Indian Tribes/Indians)",
      "25:0640" : "25:0640 (25:640 Indian Tribal Rights)",
      "25:1901" : "25:1901 (25:1901 Indian Child Welfare Act)",
      "25:2701" : "25:2701 (25:2701 Indian Gaming Regulatory Act)",
      "26:6103" : "26:6103 (26:6103(i)(1) IRS: Disclosure of Tax Returns and Return Information)",
      "26:6212" : "26:6212 (26:6212 Injunctive Relief from IRS Lien)",
      "26:6213" : "26:6213 (26:6213 Injunctive Relief from IRS Lien)",
      "26:6502" : "26:6502 (26:6502 IRS:Enforcement of tax liens)",
      "26:6532" : "26:6532 (26:6532 IRS: Refund of Tax Penalty)",
      "26:6702" : "26:6702 (26:6702 IRS: Refund of Income Tax Penalty)",
      "26:6703" : "26:6703 (26:6703 IRS: Refund of Tax Penalty)",
      "26:7401" : "26:7401 (26:7401 IRS: Tax Liability)",
      "26:7402" : "26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)",
      "26:7403" : "26:7403 (26:7403 Suit to Enforce Federal Tax Lien)",
      "26:7405" : "26:7405 (IRS: Action for Recovery of Erroneous Refunds)",
      "26:7422rt" : "26:7422rt (26:7422 IRS: Refund Taxes)",
      "26:7422rx" : "26:7422rx (26:7422 IRS: Refund Excise Tax)",
      "26:7426" : "26:7426 (26:7426 IRS: Wrongful Levy for Taxes)",
      "26:7429" : "26:7429 (26:7429 IRS: Tax Jeopardy Assessment)",
      "26:7602" : "26:7602 (IRS: Disclosure of Tax Returns and Return Information)",
      "26:7609" : "26:7609 (26:7609 IRS: Petition to Quash IRS Summons)",
      "27:0185" : "27:0185 (27:185 Enforcement of Arbitration Award)",
      "28:0157c" : "28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)",
      "28:0157d" : "28:0157d (28:0157 Motion for Withdrawal of Reference)",
      "28:0158" : "28:0158 (28:0158 Notice of Appeal re Bankruptcy Matter (BA)",
      "28:0185" : "28:0185 (28:185 Suit to Compel Arbitration)",
      "28:0451" : "28:0451 (28:451 Employment Discrimination)",
      "28:0794" : "28:0794 (28:794 Rehabilitation Act)",
      "28:1001" : "28:1001 (28:1001 E.R.I.S.A.)",
      "28:1132" : "28:1132 (28:1132 E.R.I.S.A.)",
      "28:1330" : "28:1330 (28:1330 Breach of Contract)",
      "28:1331" : "28:1331 (28:1331 Fed. Question)",
      "28:1331al" : "28:1331al (28:1331 Fed. Question: Airline Crash)",
      "28:1331at" : "28:1331at (28:1331 Fed. Question: Anti-trust)",
      "28:1331au" : "28:1331au (28:1331 Fed. Question: Auto Negligence)",
      "28:1331b" : "28:1331b (28:1331 Federal Question: Bivens Act)",
      "28:1331bc" : "28:1331bc (28:1331 Fed. Question: Breach of Contract)",
      "28:1331ca" : "28:1331ca (28:1331 Fed Question: Fed Communications Act of 1)",
      "28:1331cm" : "28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)",
      "28:1331cv" : "28:1331cv (28:1331 Federal Question: Other Civil Rights)",
      "28:1331ed" : "28:1331ed (28:1331 Fed. Question: Employment Discrimination)",
      "28:1331es" : "28:1331es (28:1331 Enforcement of Administrative Subpoena)",
      "28:1331fl" : "28:1331fl (28:1331 Fed. Question: Fair Labor Standards)",
      "28:1331in" : "28:1331in (28:1331 Fed. Question: Insurance Contract)",
      "28:1331mm" : "28:1331mm (28:1331 Fed. Question: Medical Malpractice)",
      "28:1331pi" : "28:1331pi (28:1331 Fed. Question: Personal Injury)",
      "28:1331rd" : "28:1331rd (28:1331 Fed. Question: Review Agency Decision)",
      "28:1331rp" : "28:1331rp (28:1331(a) Fed. Question: Real Property)",
      "28:1331rr" : "28:1331rr (28:1331 Fed. Question: Railway Labor Act)",
      "28:1331sv" : "28:1331sv (28:1331 Fed. Question: Securities Violation)",
      "28:1331tr" : "28:1331tr (28:1331 Fed. Question: Trademark)",
      "28:1331tt" : "28:1331tt (28:1331 Fed. Question: Tort Action)",
      "28:1331v" : "28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendme)",
      "28:1331wl" : "28:1331wl (28:1331 Federal Question: EPA Waste Lien)",
      "28:1331wt" : "28:1331wt (28:1331 Fed. Question: Water Rights)",
      "28:1332ac" : "28:1332ac (28:1332 Diversity-Account Receivable)",
      "28:1332al" : "28:1332al (28:1332 Diversity-Airline Crash)",
      "28:1332as" : "28:1332as (28:1332 Diversity-Asbestos Litigation)",
      "28:1332au" : "28:1332au (28:1332 Diversity-Auto Negligence)",
      "28:1332bc" : "28:1332bc (28:1332 Diversity-Breach of Contract)",
      "28:1332co" : "28:1332co (28:1332 Diversity-Conversion)",
      "28:1332ct" : "28:1332ct (28:1332 Diversity-(Citizenship))",
      "28:1332det" : "28:1332det (28:1332 Diversity: Forcible Detainer)",
      "28:1332df" : "28:1332df (28:1332 Diversity-Contract Default)",
      "28:1332ds" : "28:1332ds (28:1332 Diversity-Contract Dispute)",
      "28:1332ed" : "28:1332ed (28:1332 Diversity-Employment Discrimination)",
      "28:1332fd" : "28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)",
      "28:1332fr" : "28:1332fr (28:1332 Diversity-Fraud)",
      "28:1332ia" : "28:1332ia (28:1332 Diversity-Interpleader Action)",
      "28:1332ij" : "28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)",
      "28:1332in" : "28:1332in (28:1332 Diversity-Insurance Contract)",
      "28:1332jd" : "28:1332jd (28:1332 Diversity-Declaratory Judgement)",
      "28:1332lb" : "28:1332lb (28:1332 Diversity-Libel,Assault,Slander)",
      "28:1332lm" : "28:1332lm (28:1332 Diversity - Legal Malpractice)",
      "28:1332ma" : "28:1332ma (28:1332 Diversity-Miller Act)",
      "28:1332mm" : "28:1332mm (28:1332 Diversity-Medical Malpractice)",
      "28:1332mv" : "28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)",
      "28:1332ni" : "28:1332ni (28:1332 Diversity-Negotiable Instrument)",
      "28:1332nm" : "28:1332nm (28:1332 Diversity-Non-Motor Vehicle)",
      "28:1332oc" : "28:1332oc (28:1332 Diversity-Other Contract)",
      "28:1332pd" : "28:1332pd (28:1332 Diversity-Property Damage)",
      "28:1332pi" : "28:1332pi (28:1332 Diversity-Personal Injury)",
      "28:1332pl" : "28:1332pl (28:1332 Diversity-Product Liability)",
      "28:1332pr" : "28:1332pr (28:1332 Diversity-Petition for Removal)",
      "28:1332qt" : "28:1332qt (28:1332 Diversity-Petition to Quiet Title)",
      "28:1332ri" : "28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)",
      "28:1332sa" : "28:1332sa (28:1332 - Diversity: Securities & Exchange Commiss)",
      "28:1332sf" : "28:1332sf (28:1332 - Diversity: Securities Fraud)",
      "28:1332ss" : "28:1332ss (28:1332 Diversity - Stockholders Suits)",
      "28:1332tl" : "28:1332tl (28:1332 Diversity-Torts to Land)",
      "28:1332tm" : "28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))",
      "28:1332tn" : "28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)",
      "28:1332wd" : "28:1332wd (28:1332 Diversity-Wrongful Death)",
      "28:1333" : "28:1333 (28:1333 Admiralty)",
      "28:1334" : "28:1334 (28:1334 Bankruptcy Appeal)",
      "28:1334c" : "28:1334c (28:1334(c) R&R re motions for abstention (non-cor)",
      "28:1335" : "28:1335 (28:1335 Interpleader Action)",
      "28:1337" : "28:1337 (28:1337 Sherman-Clayton Act)",
      "28:1338cp" : "28:1338cp (28:1338 Copyright Infringement)",
      "28:1338pt" : "28:1338pt (28:1338 Patent Infringement)",
      "28:1338tr" : "28:1338tr (28:1338 Trademark Infringement)",
      "28:1339" : "28:1339 (28:1339 Postal Matters)",
      "28:1340" : "28:1340 (28:1340 IRS: Custom Duties)",
      "28:1340er" : "28:1340er (28:1340 Recovery of Erroneous Refund)",
      "28:1341" : "28:1341 (28:1341 Complaint for Forfeiture)",
      "28:1343" : "28:1343 (28:1343 Violation of Civil Rights)",
      "28:1345co" : "28:1345co (28:1345 Replevin & Conversion)",
      "28:1345db" : "28:1345db (28:1345 Debt to US - FHA/HUD Title I)",
      "28:1345df" : "28:1345df (28:1345 Default of Promissory Note)",
      "28:1345er" : "28:1345er (28:1345 Recovery of Erroneous Refund)",
      "28:1345fc" : "28:1345fc (28:1345 Foreclosure)",
      "28:1345ff" : "28:1345ff (28:1345 Complaint for Forfeiture)",
      "28:1345hl" : "28:1345hl (28:1345 VA Home Loan Guaranty Debt)",
      "28:1345mc" : "28:1345mc (28:1345 Medical Care Recovery)",
      "28:1345mi" : "28:1345mi (28:1345 Mining Claim Ejectment)",
      "28:1345pd" : "28:1345pd (28:1345 Property Damage)",
      "28:1345pe" : "28:1345pe (28:1345 Property Ejectment)",
      "28:1345rc" : "28:1345rc (28:1345 Recovery of Debt to US)",
      "28:1345st" : "28:1345st (28:1345 Default of Student Loan)",
      "28:1345tp" : "28:1345tp (28:1345 Trespass on Public Land)",
      "28:1345va" : "28:1345va (28:1345 Recovery of VA Overpayment)",
      "28:1346bc" : "28:1346bc (28:1346 Breach of Contract)",
      "28:1346rc" : "28:1346rc (28:1346 Recovery of IRS Tax)",
      "28:1346tc" : "28:1346tc (28:1346 Tort Claim)",
      "28:1346wd" : "28:1346wd (28:1346 Wrongful Death)",
      "28:1352" : "28:1352 (28:1352 Miller Act)",
      "28:1355" : "28:1355 (28:1355 Petition for Return of Property)",
      "28:1358" : "28:1358 (28:1358 Land Condemnation)",
      "28:1361" : "28:1361 (28:1361 Petition for Writ of Mandamus)",
      "28:1362ic" : "28:1362ic (28:1362 Indian Tribal Controversy)",
      "28:1362iw" : "28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)",
      "28:1364" : "28:1364 (28:1364 Auto Negligence)",
      "28:1391" : "28:1391 (28:1391 Personal Injury)",
      "28:1395" : "28:1395 (28:1395 Fine, Penalty or Forfeiture)",
      "28:1402" : "28:1402 (28:1402 Medical Malpractice)",
      "28:1407" : "28:1407 (28:1407 Airline Crash)",
      "28:1441ac" : "28:1441ac (28:1441 Petition for Removal- Account Receivable)",
      "28:1441al" : "28:1441al (28:1441 Petition for Removal- Airline Crash)",
      "28:1441as" : "28:1441as (28:1441 Petition for Removal- Asbestos Litigation)",
      "28:1441au" : "28:1441au (28:1441 Petition for Removal- Auto Negligence)",
      "28:1441bc" : "28:1441bc (28:1441 Petition for Removal- Breach of Contract)",
      "28:1441cv" : "28:1441cv (28:1441 Petition for Removal- Civil Rights Act)",
      "28:1441df" : "28:1441df (28:1441 Petition for Removal- Contract Default)",
      "28:1441dj" : "28:1441dj (28:1441 Petition for Removal- Declaratory Judgemen)",
      "28:1441ds" : "28:1441ds (28:1441 Petition for Removal- Contract Dispute)",
      "28:1441ed" : "28:1441ed (28:1441 Petition for Removal - Employment Discrim)",
      "28:1441fc" : "28:1441fc (28:1441 Petition for Removal - Fair Credit Reporti)",
      "28:1441fr" : "28:1441fr (28:1441 Petition for Removal- Fraud)",
      "28:1441ij" : "28:1441ij (28:1441 Petition for Removal- Injunctive/Declarato)",
      "28:1441in" : "28:1441in (28:1441 Petition for Removal- Insurance Contract)",
      "28:1441int" : "28:1441int (28:1441 Petition for Removal- Action for Interplea)",
      "28:1441lb" : "28:1441lb (28:1441 Petition for Removal Libel,Assault,Slander)",
      "28:1441lm" : "28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relatio)",
      "28:1441mm" : "28:1441mm (28:1441 Petition for Removal- Medical Malpractice)",
      "28:1441ni" : "28:1441ni (28:1441 Petition for Removal- Negotiable Instrumen)",
      "28:1441nm" : "28:1441nm (28:1441 Petition for Removal- Non-Motor Vehicle)",
      "28:1441oc" : "28:1441oc (28:1441 Petition For Removal--Other Contract)",
      "28:1441pd" : "28:1441pd (28:1441 Petition for Removal- Property Damage)",
      "28:1441pi" : "28:1441pi (28:1441 Petition for Removal- Personal Injury)",
      "28:1441pl" : "28:1441pl (28:1441 Petition for Removal- Product Liability)",
      "28:1441pr" : "28:1441pr (28:1441 Petition for Removal)",
      "28:1441qt" : "28:1441qt (28:1441 Petition for Removal- Petition to Quiet Ti)",
      "28:1441ri" : "28:1441ri (28:1441 Petition for Removal- Racketeering (RICO))",
      "28:1441sa" : "28:1441sa (28:1441 - Petition for Removal: SEC Act)",
      "28:1441sf" : "28:1441sf (28:1441 - Petition for Removal: Securities Fraud)",
      "28:1441tl" : "28:1441tl (28:1441 Petition for Removal- Torts to Land)",
      "28:1441tm" : "28:1441tm (28:1441 Petition for Removal- Tort/Motor Vehicle ()",
      "28:1441tn" : "28:1441tn (28:1441 Petition for Removal- Tort/Non-Motor Vehic)",
      "28:1441wd" : "28:1441wd (28:1441 Petition for Removal- Wrongful Death)",
      "28:1442bc" : "28:1442bc (28:1442 Petition for Removal- Breach of Contract)",
      "28:1442pr" : "28:1442pr (28:1442 Petition for Removal)",
      "28:1443" : "28:1443 (28:1443(1) Rent, Lease & Ejectment)",
      "28:1444" : "28:1444 (28:1444 Petition for Removal- Foreclosure)",
      "28:1446in" : "28:1446in (28:1446 Breach of Contract- Insurance)",
      "28:1446pd" : "28:1446pd (28:1446 Petition for Removal- Property Damage (P.I)",
      "28:1446pi" : "28:1446pi (28:1446 Petition for Removal- Personal Injury)",
      "28:1446pl" : "28:1446pl (28:1446pl Petition for Removal - Product Liability)",
      "28:1446pr" : "28:1446pr (28:1446 Petition for Removal)",
      "28:1452" : "28:1452 (28:1452 R&R re motions to remand (non-core))",
      "28:1651" : "28:1651 (28:1651 Petition for Writ of Coram Nobis)",
      "28:1651a" : "28:1651a (28:1651a All Writs)",
      "28:1651hc" : "28:1651hc (28:1651 Petition for Writ of Habeas Corpus)",
      "28:1651mn" : "28:1651mn (28:1651 Petition for Writ of Mandamus)",
      "28:2201" : "28:2201 (28:2201 Constitutionality of State Statute(s))",
      "28:2201dj" : "28:2201dj (28:2201 Declaratory Judgment)",
      "28:2201ij" : "28:2201ij (28:2201 Injunction)",
      "28:2201in" : "28:2201in (28:2201 Declaratory Judgment (Insurance))",
      "28:2241" : "28:2241 (28:2241 Petition for Writ of Habeas Corpus (federa)",
      "28:2254" : "28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))",
      "28:2254se" : "28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)",
      "28:2255" : "28:2255 (28:2255 Motion to Vacate / Correct Illegal Sentence)",
      "28:2271" : "28:2271 (28:2271 Federal Tort Claims Act)",
      "28:2345" : "28:2345 (28:2345 Medicare Recovery)",
      "28:2409" : "28:2409 (28:2409(a) Quiet Title Action)",
      "28:2410" : "28:2410 (28:2410 Quiet Title)",
      "28:2671" : "28:2671 (28:2671 Federal Tort Claims Act)",
      "28:2674" : "28:2674 (28:2674 Federal Tort Claims Act)",
      "28:7402" : "28:7402 (28:7402 Refund of Taxes)",
      "28:7422" : "28:7422 (28:7422 Appeal from Administrative Decision)",
      "29:0151" : "29:0151 (29:151 Labor: Review of Agency Action)",
      "29:0160" : "29:0160 (29:160(1) National Labor Relations Act)",
      "29:0184" : "29:0184 (29:184 Violation Collection Bargain Agreement)",
      "29:0185(a)" : "29:0185(a) (29:0185(a) Suit By and Against Labor Organizations)",
      "29:0185ep" : "29:0185ep (29:185 Employee Pension Plan)",
      "29:0185lm" : "29:0185lm (29:185 Labor/Mgt. Relations (Contracts))",
      "29:0201do" : "29:0201do (29:201 Denial of Overtime Compensation)",
      "29:0201fl" : "29:0201fl (29:201 Fair Labor Standards Act)",
      "29:0203" : "29:0203 (29:203 Equal Pay Act)",
      "29:0206" : "29:0206 (29:206 Collect Unpaid Wages)",
      "29:0401" : "29:0401 (29:0401 Labor Management Disclosure Act)",
      "29:0621" : "29:0621 (29:621 Job Discrimination (Age))",
      "29:0623" : "29:0623 (29:623 Job Discrimination (Age))",
      "29:0626" : "29:0626 (29:626 Job Discrimination (Age))",
      "29:0633" : "29:0633 (29:633 Job Discrimination (Age))",
      "29:0651" : "29:0651 (29:651 Occupational Safety/Health)",
      "29:0754" : "29:0754 (29:754 Discrimination)",
      "29:0791" : "29:0791 (29:791 Job Discrimination (Rehabilitation Act))",
      "29:0794" : "29:0794 (29:0794 Job Discrimination (Handicap))",
      "29:1001" : "29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)",
      "29:1002" : "29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)",
      "29:1104" : "29:1104 (29:1104 Recovery of Benefits to Employee)",
      "29:1109" : "29:1109 (29:1109 Breach of Fiduciary Duties)",
      "29:1131" : "29:1131 (29:1131 ERISA - Collection of Delinquent Trust Fun)",
      "29:1132" : "29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)",
      "29:1145" : "29:1145 (29:1145 E.R.I.S.A.)",
      "29:1149" : "29:1149 (29:1149 Recover Pension & Profit Sharing)",
      "29:1337" : "29:1337 (29:1337 E.R.I.S.A.)",
      "29:1362" : "29:1362 (29:1362 ERISA)",
      "29:1381" : "29:1381 (29:1381 E.R.I.S.A.)",
      "29:1401" : "29:1401 (29:1401(b)(2) Appeal of Arbitration Award)",
      "29:1451" : "29:1451 (29:1451 E.R.I.S.A.)",
      "29:1801" : "29:1801 (29:1801 Farmworker Rights)",
      "29:2101" : "29:2101 (29:2101 Worker Adjustment/Retraining Notification)",
      "29:2601" : "29:2601 (29:2601 Family and Medical Leave Act)",
      "29:790" : "29:790 (29:790 Rehabilitation of Labor)",
      "30:0181" : "30:0181 (30:181 Environment: Review of Agency Action)",
      "30:0801" : "30:0801 (30:0801 Penalities/Federal Mine Safety Health Act)",
      "30:1201" : "30:1201 (30:1201 Environment: Review of Agency Action)",
      "30:1202" : "30:1202 (30:1202 Mining Reclamation Act)",
      "30:1276" : "30:1276 (30:1276 Interior: Review of Agency Action)",
      "31:3545" : "31:3545 (31:3545 Action to Recovery Money)",
      "31:3729" : "31:3729 (31:3729 False Claims Act (use sc subtype))",
      "31:3730" : "31:3730 (31:3730 Qui Tam False Claims Act)",
      "31:3731" : "31:3731 (31:3731 Fraud)",
      "33:1319cw" : "33:1319cw (33:1319 Clean Water Act)",
      "33:1319pv" : "33:1319pv (33:1319 Pollutants & Permit Violations)",
      "33:1365" : "33:1365 (33:1365 Environmental Matters)",
      "35:0145" : "35:0145 (35:145 Patent Infringement)",
      "35:0183" : "35:0183 (35:183 Patent Infringement)",
      "35:0271" : "35:0271 (35:271 Patent Infringement)",
      "375/1" : "375/1 (False Claims Act - U.S. Plaintiff)",
      "38:1681" : "38:1681 (38:1681 Recovery of VA Overpayment)",
      "38:1686" : "38:1686 (38:1686 Recovery of VA Overpayment)",
      "38:1729" : "38:1729 (38:1729 Recovery of Cost of Certain Care & Services)",
      "38:1780" : "38:1780 (38:1780 Recovery of VA Overpayment)",
      "38:2011" : "38:2011 (38:2011 - Veteran's Readjustment Assistance Act of)",
      "38:2021" : "38:2021 (38:2021 Recovery of Unpaid Back Wages and Benefits)",
      "38:3116" : "38:3116 (38:3116 VA Overpayment)",
      "38:4303" : "38:4303 (38:4303 Uniformed Services Employment & Re-employ Rights Act)",
      "39:3005" : "39:3005 (39:3005 Detention of Mail for Temporary Periods)",
      "39:3005fr" : "39:3005fr (False Representation through Postal Service)",
      "39:409" : "39:409 (39:409 Postal Service)",
      "40:0258" : "40:0258 (40:258(a) Public Buildings & Property: Land Condem)",
      "40:0270" : "40:0270 (40:270 Miller Act)",
      "40:0875" : "40:0875 (40:875 Public Buildings & Property: Negligence)",
      "41:0251" : "41:0251 (41:251 Public Contracts-Review of Agency Action)",
      "41:1463" : "41:1463 (41:1463 Public Contracts: Unlawful Employment Prac)",
      "42:0205" : "42:0205 (42:205 Denial Social Security Benefits)",
      "42:0206" : "42:0206 (42:206 Social Security Benefits)",
      "42:0247" : "42:0247 (42:247 Personal Injury-Swine Flu)",
      "42:0402" : "42:0402 (42:402 Social Security Benefits)",
      "42:0405id" : "42:0405id (42:405 Review of HHS Decision (SSID))",
      "42:0405wc" : "42:0405wc (42:405 Review of HHS Decision (DIWC))",
      "42:0405ww" : "42:0405ww (42:405 Review of HHS Decision (DIWW))",
      "42:0416" : "42:0416 (42:416 Denial of Social Security Benefits)",
      "42:0427" : "42:0427 (42:427 Social Security Benefits)",
      "42:0651" : "42:0651 (Child Support Obligations)",
      "42:12101" : "42:12101 (42:12101 Discrimination Against the Disabled)",
      "42:12117" : "42:12117 (42:12117 Americans with Disabilities Act (Enforcement))",
      "42:12177" : "42:12177 (Americans with Disabilities Act (Enforcement))",
      "42:12201" : "42:12201 (42:12201 Americans with Disabilities Act of 1990)",
      "42:1383" : "42:1383 (42:1383 Review of HHS Decision)",
      "42:1395" : "42:1395 (42:1395 HHS: Adverse Reimbursement Review)",
      "42:1396" : "42:1396 (42:1396 - Tort Negligence)",
      "42:1415" : "42:1415 (42:1415(e) Individuals with Disabilities Ed. Act - Appeal)",
      "42:1471" : "42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclo)",
      "42:1981cv" : "42:1981cv (42:1981 Civil Rights)",
      "42:1981hs" : "42:1981hs (42:1981 Housing Discrimination)",
      "42:1981jb" : "42:1981jb (42:1981 Job Discrimination (Race))",
      "42:1981sx" : "42:1981sx (42:1981 Sex Discrimination)",
      "42:1983cv" : "42:1983cv (42:1983 Civil Rights Act - Civil Action for Deprivation of Rights)",
      "42:1983d" : "42:1983d (42:1983 Civil Rights (Death))",
      "42:1983ed" : "42:1983ed (42:1983 Civil Rights (Employment Discrimination))",
      "42:1983pr" : "42:1983pr (42:1983 Prisoner Civil Rights)",
      "42:1986" : "42:1986 (42:1986 Neglect of Duty)",
      "42:2000ag" : "42:2000ag (42:2000 Job Discrimination (Age))",
      "42:2000cc" : "42:2000cc (42:2000 Religious Land Use & Institutionalized Persons Act of 2000)",
      "42:2000e" : "42:2000e (42:2000e Job Discrimination (Employment))",
      "42:2000pb" : "42:2000pb (42:2000 Job Discrimination (Public Accomodations))",
      "42:2000ra" : "42:2000ra (42:2000 Job Discrimination (Race))",
      "42:2000sx" : "42:2000sx (42:2000 Job Discrimination (Sex))",
      "42:2003" : "42:2003 (42:2003 Job Discrimination)",
      "42:2005" : "42:2005 (42:2005 Review of Agency Action-HHS)",
      "42:2651" : "42:2651 (42:2651 Medical Care Recovery)",
      "42:3601" : "42:3601 (42:405 Fair Housing Act)",
      "42:4000" : "42:4000 (42:4000 National Flood Insurance Act)",
      "42:4001" : "42:4001 (42:4001 National Insurance Flood Act)",
      "42:4053" : "42:4053 (42:4053 Breach of Insurance Contract)",
      "42:4072" : "42:4072 (42:4072 Payment of Flood Insurance Claim)",
      "42:4321" : "42:4321 (42:4321 Review of Agency Action-Environment)",
      "42:4332" : "42:4332 (42:4332 Environmental Policy - Coop of Agency Repo)",
      "42:6901en" : "42:6901en (42:6901 Environmental Cleanup Expenses)",
      "42:6901rs" : "42:6901rs (42:6901 Resource & Recovery Act)",
      "42:7413" : "42:7413 (42:7413(b) Clean Air Act)",
      "42:7604cl" : "42:7604cl (42:7604 Clear Air Act (Emission Standards))",
      "42:7604ir" : "42:7604ir (42:7604 Petition to Quash IRS Summons)",
      "42:9607" : "42:9607 (42:9607 Real Property Tort to Land)",
      "43:945" : "43:945 (43:945 Compensation for Land Condemnation)",
      "43:945a" : "43:945a (43:945a Complaint in Condemnation)",
      "43:946" : "43:946 (43:946 Complaint in Condemnation - Eminent Domain)",
      "45:0051" : "45:0051 (45:51 Railways: Fed. Employer's Liability Act)",
      "45:0151" : "45:0151 (45:151 Railway Labor Act)",
      "45:0184" : "45:0184 (45:184 Action to Set Aside Award of a System Board)",
      "45:1395" : "45:1395 (45:1395 Railroads: Adverse Reimbursement Review)",
      "45:7457" : "45:7457 (45:7457 Compel Reclamation Under Clear Air Act)",
      "46:0688" : "46:0688 (46:688 Jones Act)",
      "46:0741" : "46:0741 (46:741 Shipping)",
      "46:0761" : "46:0761 (46:761 Shipping: Damages for Death on High Seas)",
      "46:1101" : "46:1101 (46:1101 Violation of Maritime Regulations)",
      "46:1156" : "46:1156 (46:1156 Administrative Procedure Act)",
      "48:0883" : "48:0883 (48:883 Violation of US Coastal Law)",
      "48:1985" : "48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)",
      "49:0081" : "49:0081 (49:81 Damaged Goods While Being Transported)",
      "49:0781" : "49:0781 (49:781 Forfeiture)",
      "49:11503" : "49:11503 (49:11503 Railroad Revitalization Regulatory Reform)",
      "49:11702" : "49:11702 (49:11702(a)(4) Violations of Interstate Commerce A)",
      "49:11706" : "49:11706 (Interstate Commerce Enforcement - Common Carriers)",
      "49:1471" : "49:1471 (49:1471 Federal Aviation Act)",
      "49:1903" : "49:1903 (49:1903 Petition to enforce administrative summon)",
      "8:287" : "8:287 (8:287 Petition to Enforce INS Subpoena)",
      "misc" : "misc (Civil Miscellaneous Case)"
   },
   "tnedce" : {
      "0" : "0 (00:0000)",
      "00:0000" : "00:0000 (00:0000 Cause Code Unknown )",
      "02:0431" : "02:0431 (02:431 Fed. Election Commission: Failure Enforce C)",
      "02:0437" : "02:0437 (02:437 Federal Election Commission)",
      "05:0075" : "05:0075 (05:75(2) Contract - Reduction in Grade)",
      "05:0551" : "05:0551 (05:551 Administrative Procedure Act)",
      "05:0552fi" : "05:0552fi (05:552 Freedom of Information Act)",
      "05:0552pa" : "05:0552pa (05:552 Right to Privacy Act)",
      "05:0554" : "05:0554 (05:0554 Constitutionality of Maritime Statutes)",
      "05:0701" : "05:0701 (05:0701 Maritime Subsidy Board)",
      "05:0702" : "05:0702 (05:702 Administrative Procedure Act)",
      "05:0704" : "05:0704 (05:704 Labor Litigation)",
      "05:7703" : "05:7703 (05:7703 Discrimination - Review of Agency Act)",
      "07:0006" : "07:0006 (7:6(b) Federal Commodity Exchange Regulation)",
      "07:0025" : "07:0025 (7:25 Fraud - Commodities Leverage Contracts)",
      "07:0181" : "07:0181 (07:181 Packers & Stockyard Act)",
      "07:0499" : "07:0499 (07:499 Agricultural Commodities Act)",
      "07:0601" : "07:0601 (07:601 USDA Condemnation)",
      "07:2321" : "07:2321 (07:2321 Plant Variety Protection Act)",
      "08:1105" : "08:1105 (8:1105(a) Aliens: Habeas Corpus to Release INS Det)",
      "08:1252" : "08:1252 (08:1252(a)(2) Injunction for Deportation)",
      "08:1260" : "08:1260 (08:1260 Aliens: Access to Records)",
      "08:1324" : "08:1324 (08:1324 Aliens: Complaint for Forfeiture)",
      "08:1329" : "08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petiti)",
      "08:1446" : "08:1446 (8:1446 Petition for Naturalization Hearing)",
      "09:0001" : "09:0001 (09:1 U.S. Arbitration Act)",
      "09:0009" : "09:0009 (9:9 Motion to Confirm Arbitration Loan)",
      "09:0010" : "09:0010 (09:0010 Petition to Vacate Arbitration Award)",
      "10:1552" : "10:1552 (10:1552 Armed Forces: Action to Correct Records)",
      "10:1553" : "10:1553 (10:1553 Armed Forces: FOIA General)",
      "10:2305" : "10:2305 (10:2305 Review of Federal Contract)",
      "11:0101" : "11:0101 (11:101 Bankruptcy)",
      "12:0022" : "12:0022 (12:22 Securities Fraud)",
      "12:0635" : "12:0635 (12:635 Breach of Insurance Contract)",
      "12:1461" : "12:1461 (12:1461 Homeowners Loan Act)",
      "12:1703" : "12:1703 (12:1703 Default of HUD Loan)",
      "12:1725" : "12:1725 (12:1725 Collection under Contract Guaranty)",
      "12:1730" : "12:1730 (12:1730 Collection Under Contract Guaranty)",
      "12:1819" : "12:1819 (12:1819 Default of Promissory Note)",
      "12:1821" : "12:1821 (12:1821 Default of Loan by Promissary Note)",
      "12:1971" : "12:1971 (12:1971 Relief under Bank Holding Act)",
      "12:3410" : "12:3410 (12:3410 Right to Financial Privacy Act)",
      "15:0001" : "15:0001 (15:1 Antitrust Litigation)",
      "15:0002at" : "15:0002at (15:2 Antitrust Litigation)",
      "15:0002fl" : "15:0002fl (15:2(a) Fair Labor Standards Act)",
      "15:0005" : "15:0005 (15:5(a) Fair Labor Standards Act)",
      "15:0015" : "15:0015 (15:15 Antitrust Litigation)",
      "15:0025" : "15:0025 (15:25 Clayton Act)",
      "15:0044" : "15:0044 (15:44 Trademark Infringement)",
      "15:0045" : "15:0045 (15:0045 Federal Trade Commission Act)",
      "15:0052" : "15:0052 (15:0052 Federal Trade Commission Act)",
      "15:0053" : "15:0053 (15:0053 Federal Trade Commission Act)",
      "15:0077" : "15:0077 (15:77 Securities Fraud)",
      "15:0078" : "15:0078 (15:78m(a) Securities Exchange Act)",
      "15:0631" : "15:0631 (15:631 Small Business Act)",
      "15:0717" : "15:0717 (15:717 Natural Gas Act)",
      "15:1051" : "15:1051 (15:1051 Trademark Infringement)",
      "15:1114" : "15:1114 (15:1114 Trademark Infringement)",
      "15:1121" : "15:1121 (15:1121 Trademark Infringement)",
      "15:1125" : "15:1125 (15:1125 Trademark Infringement (Lanham Act))",
      "15:1126" : "15:1126 (15:1126 Patent Infringement)",
      "15:1127" : "15:1127 (15:1127 Trademark Infringement)",
      "15:1601" : "15:1601 (15:1601 Truth in Lending)",
      "15:1640" : "15:1640 (15:1640 Truth in Lending)",
      "15:1681" : "15:1681 (15:1681 Fair Credit Reporting Act)",
      "15:1692" : "15:1692 (15:1692 Fair Debt Collection Act)",
      "15:1938" : "15:1938 (15:1938 Fair Labor Standards Act)",
      "15:1981" : "15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))",
      "15:1988" : "15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))",
      "15:1989" : "15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))",
      "15:2301" : "15:2301 (15:2301 Magnuson-Moss Warranty Act)",
      "15:2801" : "15:2801 (15:2801 Petroleum Marketing Practices Act)",
      "15:53(b)" : "15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equita)",
      "16:0668" : "16:0668 (16:668 Bald Eagle Protection Act)",
      "16:0703" : "16:0703 (16:703 Migratory Bird Act)",
      "16:1538" : "16:1538 (16:1538 Endangered Species Act)",
      "16:3371" : "16:3371 (16:3371 Wildlife Under the Lacey Act)",
      "16:3372" : "16:3372 (16:3372 Conservation: Complaint for Forfeiture)",
      "16:3373" : "16:3373 (16:3373 Appeal of Decision - DOI)",
      "16:3374" : "16:3374 (16:3374 Conservation: Complaint for Forfeiture)",
      "17:0101" : "17:0101 (17:101 Copyright Infringement)",
      "17:0501" : "17:0501 (17:501 Copyright Infringement)",
      "17:0504" : "17:0504 (17:504 Copyright Infringement)",
      "18:0241" : "18:0241 (18:241 Conspiracy Against Rights)",
      "18:1836" : "18:1836 (18:1836 Civil Seizure of Misappropriated Trade Secrets)",
      "18:1836a" : "18:1836a (18:1836(a) Injunction against Misappropriation of Trade Secrets)",
      "18:1836b" : "18:1836b (18:1836(b) Civil Action to Protect Trade Secrets)",
      "18:1961" : "18:1961 (18:1961 Racketeering (RICO) Act)",
      "18:1962" : "18:1962 (18:1962 Racketeering (RICO) Act)",
      "18:1964" : "18:1964 (18:1964 Racketeering (RICO) Act)",
      "18:4208" : "18:4208 (18:4208(B) Agency Action Review)",
      "19:1305" : "19:1305 (19:1305 Custom Duties:0Forfeiture-Immoral Articles)",
      "20:1080" : "20:1080 (20:1080 Student Loan Recovery)",
      "20:1400" : "20:1400 (20:1400 Civil Rights of Handicapped Child)",
      "20:1401" : "20:1401 (20:1401 Education: Handicapped Child Act)",
      "21:0601" : "21:0601 (21:601 Federal Meat Inspection Act )",
      "21:0841" : "21:0841 (21:841 Forfeiture Property-Drugs)",
      "21:0881" : "21:0881 (21:881 Forfeiture Property-Drugs)",
      "21:0881a" : "21:0881a (21:881 Forfeiture Property - Aircraft)",
      "21:0881re" : "21:0881re (21:881 Forfeiture Property - Real Estate)",
      "23:0134" : "23:0134 (23:134 P.I.- Auto Negligence)",
      "23:1441" : "23:1441 (23:1441 Contract Real Estate)",
      "24:1000" : "24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)",
      "25:0640" : "25:0640 (25:640 Indian Tribal Rights)",
      "25:1901" : "25:1901 (25:1901 Indian Child Welfare Act)",
      "26:6212" : "26:6212 (26:6212 Injunctive Relief from IRS Lien)",
      "26:6213" : "26:6213 (26:6213 Injunctive Relief from IRS Lien)",
      "26:6502" : "26:6502 (26:6502 IRS:Enforcement of tax liens)",
      "26:6532" : "26:6532 (26:6532 IRS: Refund of Tax Penalty)",
      "26:6702" : "26:6702 (26:6702 IRS: Refund of Income Tax Penalty)",
      "26:6703" : "26:6703 (26:6703 IRS: Refund of Tax Penalty)",
      "26:7401" : "26:7401 (26:7401 IRS: Tax Liability)",
      "26:7402" : "26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)",
      "26:7403" : "26:7403 (26:7403 Suit to Enforce Federal Tax Lien)",
      "26:7422rt" : "26:7422rt (26:7422 IRS: Refund Taxes)",
      "26:7422rx" : "26:7422rx (26:7422 IRS: Refund Excise Tax)",
      "26:7426" : "26:7426 (26:7426 IRS: Wrongful Levy for Taxes)",
      "26:7429" : "26:7429 (26:7429 IRS: Tax Jeopardy Assessment)",
      "26:7609" : "26:7609 (26:7609 IRS: Petition to Quash IRS Summons)",
      "27:0185" : "27:0185 (27:185 Enforcement of Arbitration Award)",
      "28:0157c" : "28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)",
      "28:0157d" : "28:0157d (28:0157 Motion for Withdrawal of Reference)",
      "28:0158" : "28:0158 (28:0158 Notice of Appeal re Bankruptcy Matter (BA)",
      "28:0185" : "28:0185 (28:185 Suit to Compel Arbitration)",
      "28:0451" : "28:0451 (28:451 Employment Discrimination)",
      "28:0794" : "28:0794 (28:794 Rehabilitation Act)",
      "28:1001" : "28:1001 (28:1001 E.R.I.S.A.)",
      "28:1132" : "28:1132 (28:1132 E.R.I.S.A.)",
      "28:1330" : "28:1330 (28:1330 Breach of Contract)",
      "28:1331" : "28:1331 (28:1331 Fed. Question)",
      "28:1331al" : "28:1331al (28:1331 Fed. Question: Airline Crash)",
      "28:1331at" : "28:1331at (28:1331 Fed. Question: Anti-trust)",
      "28:1331au" : "28:1331au (28:1331 Fed. Question: Auto Negligence)",
      "28:1331b" : "28:1331b (28:1331 Federal Question: Bivens Act)",
      "28:1331bc" : "28:1331bc (28:1331 Fed. Question: Breach of Contract)",
      "28:1331ca" : "28:1331ca (28:1331 Fed Question: Fed Communications Act of 1)",
      "28:1331cm" : "28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)",
      "28:1331cv" : "28:1331cv (28:1331 Federal Question: Other Civil Rights)",
      "28:1331ed" : "28:1331ed (28:1331 Fed. Question: Employment Discrimination)",
      "28:1331es" : "28:1331es (28:1331 Enforcement of Administrative Subpoena)",
      "28:1331fl" : "28:1331fl (28:1331 Fed. Question: Fair Labor Standards)",
      "28:1331in" : "28:1331in (28:1331 Fed. Question: Insurance Contract)",
      "28:1331mm" : "28:1331mm (28:1331 Fed. Question: Medical Malpractice)",
      "28:1331pi" : "28:1331pi (28:1331 Fed. Question: Personal Injury)",
      "28:1331rd" : "28:1331rd (28:1331 Fed. Question: Review Agency Decision)",
      "28:1331rp" : "28:1331rp (28:1331(a) Fed. Question: Real Property)",
      "28:1331rr" : "28:1331rr (28:1331 Fed. Question: Railway Labor Act)",
      "28:1331sv" : "28:1331sv (28:1331 Fed. Question: Securities Violation)",
      "28:1331tr" : "28:1331tr (28:1331 Fed. Question: Trademark)",
      "28:1331tt" : "28:1331tt (28:1331 Fed. Question: Tort Action)",
      "28:1331v" : "28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendme)",
      "28:1331wl" : "28:1331wl (28:1331 Federal Question: EPA Waste Lien)",
      "28:1331wt" : "28:1331wt (28:1331 Fed. Question: Water Rights)",
      "28:1332ac" : "28:1332ac (28:1332 Diversity-Account Receivable)",
      "28:1332al" : "28:1332al (28:1332 Diversity-Airline Crash)",
      "28:1332as" : "28:1332as (28:1332 Diversity-Asbestos Litigation)",
      "28:1332au" : "28:1332au (28:1332 Diversity-Auto Negligence)",
      "28:1332bc" : "28:1332bc (28:1332 Diversity-Breach of Contract)",
      "28:1332co" : "28:1332co (28:1332 Diversity-Conversion)",
      "28:1332ct" : "28:1332ct (28:1332 Diversity-(Citizenship))",
      "28:1332det" : "28:1332det (28:1332 Diversity: Forcible Detainer)",
      "28:1332df" : "28:1332df (28:1332 Diversity-Contract Default)",
      "28:1332ds" : "28:1332ds (28:1332 Diversity-Contract Dispute)",
      "28:1332ed" : "28:1332ed (28:1332 Diversity-Employment Discrimination)",
      "28:1332fd" : "28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)",
      "28:1332fr" : "28:1332fr (28:1332 Diversity-Fraud)",
      "28:1332ia" : "28:1332ia (28:1332 Diversity-Interpleader Action)",
      "28:1332ij" : "28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)",
      "28:1332in" : "28:1332in (28:1332 Diversity-Insurance Contract)",
      "28:1332jd" : "28:1332jd (28:1332 Diversity-Declaratory Judgment)",
      "28:1332lb" : "28:1332lb (28:1332 Diversity-Libel,Assault,Slander)",
      "28:1332lm" : "28:1332lm (28:1332 Diversity - Legal Malpractice)",
      "28:1332ma" : "28:1332ma (28:1332 Diversity-Miller Act)",
      "28:1332mm" : "28:1332mm (28:1332 Diversity-Medical Malpractice)",
      "28:1332mv" : "28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)",
      "28:1332ni" : "28:1332ni (28:1332 Diversity-Negotiable Instrument)",
      "28:1332nm" : "28:1332nm (28:1332 Diversity-Non-Motor Vehicle)",
      "28:1332oc" : "28:1332oc (28:1332 Diversity-Other Contract)",
      "28:1332pd" : "28:1332pd (28:1332 Diversity-Property Damage)",
      "28:1332pi" : "28:1332pi (28:1332 Diversity-Personal Injury)",
      "28:1332pl" : "28:1332pl (28:1332 Diversity-Product Liability)",
      "28:1332pr" : "28:1332pr (28:1332 Diversity-Petition for Removal)",
      "28:1332qt" : "28:1332qt (28:1332 Diversity-Petition to Quiet Title)",
      "28:1332ri" : "28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)",
      "28:1332sa" : "28:1332sa (28:1332 - Diversity: Securities & Exchange Commiss)",
      "28:1332sf" : "28:1332sf (28:1332 - Diversity: Securities Fraud)",
      "28:1332ss" : "28:1332ss (28:1332 Diversity - Stockholders Suits)",
      "28:1332tl" : "28:1332tl (28:1332 Diversity-Torts to Land)",
      "28:1332tm" : "28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))",
      "28:1332tn" : "28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)",
      "28:1332wd" : "28:1332wd (28:1332 Diversity-Wrongful Death)",
      "28:1333" : "28:1333 (28:1333 Admiralty)",
      "28:1334" : "28:1334 (28:1334 Bankruptcy Appeal)",
      "28:1334c" : "28:1334c (28:1334(c) R&R re motions for abstention (non-cor)",
      "28:1335" : "28:1335 (28:1335 Interpleader Action)",
      "28:1337" : "28:1337 (28:1337 Sherman-Clayton Act)",
      "28:1338cp" : "28:1338cp (28:1338 Copyright Infringement)",
      "28:1338pt" : "28:1338pt (28:1338 Patent Infringement)",
      "28:1338tr" : "28:1338tr (28:1338 Trademark Infringement)",
      "28:1340" : "28:1340 (28:1340 IRS: Custom Duties)",
      "28:1340er" : "28:1340er (28:1340 Recovery of Erroneous Refund)",
      "28:1341" : "28:1341 (28:1341 Complaint for Forfeiture)",
      "28:1343" : "28:1343 (28:1343 Violation of Civil Rights)",
      "28:1345co" : "28:1345co (28:1345 Replevin & Conversion)",
      "28:1345db" : "28:1345db (28:1345 Debt to US - FHA/HUD Title I)",
      "28:1345df" : "28:1345df (28:1345 Default of Promissory Note)",
      "28:1345er" : "28:1345er (28:1345 Recovery of Erroneous Refund)",
      "28:1345fc" : "28:1345fc (28:1345 Foreclosure)",
      "28:1345ff" : "28:1345ff (28:1345 Complaint for Forfeiture)",
      "28:1345hl" : "28:1345hl (28:1345 VA Home Loan Guaranty Debt)",
      "28:1345mc" : "28:1345mc (28:1345 Medical Care Recovery)",
      "28:1345mi" : "28:1345mi (28:1345 Mining Claim Ejectment)",
      "28:1345pd" : "28:1345pd (28:1345 Property Damage)",
      "28:1345pe" : "28:1345pe (28:1345 Property Ejectment)",
      "28:1345rc" : "28:1345rc (28:1345 Recovery of Debt to US)",
      "28:1345st" : "28:1345st (28:1345 Default of Student Loan)",
      "28:1345tp" : "28:1345tp (28:1345 Trespass on Public Land)",
      "28:1345va" : "28:1345va (28:1345 Recovery of VA Overpayment)",
      "28:1346bc" : "28:1346bc (28:1346 Breach of Contract)",
      "28:1346rc" : "28:1346rc (28:1346 Recovery of IRS Tax)",
      "28:1346tc" : "28:1346tc (28:1346 Tort Claim)",
      "28:1346wd" : "28:1346wd (28:1346 Wrongful Death)",
      "28:1352" : "28:1352 (28:1352 Miller Act)",
      "28:1355" : "28:1355 (28:1355 Petition for Return of Property)",
      "28:1358" : "28:1358 (28:1358 Land Condemnation)",
      "28:1361" : "28:1361 (28:1361 Petition for Writ of Mandamus)",
      "28:1362ic" : "28:1362ic (28:1362 Indian Tribal Controversy)",
      "28:1362iw" : "28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)",
      "28:1364" : "28:1364 (28:1364 Auto Negligence)",
      "28:1391" : "28:1391 (28:1391 Personal Injury)",
      "28:1402" : "28:1402 (28:1402 Medical Malpractice)",
      "28:1407" : "28:1407 (28:1407 Airline Crash)",
      "28:1441ac" : "28:1441ac (28:1441 Petition for Removal- Account Receivable)",
      "28:1441al" : "28:1441al (28:1441 Petition for Removal- Airline Crash)",
      "28:1441as" : "28:1441as (28:1441 Petition for Removal- Asbestos Litigation)",
      "28:1441au" : "28:1441au (28:1441 Petition for Removal- Auto Negligence)",
      "28:1441bc" : "28:1441bc (28:1441 Petition for Removal- Breach of Contract)",
      "28:1441cv" : "28:1441cv (28:1441 Petition for Removal- Civil Rights Act)",
      "28:1441df" : "28:1441df (28:1441 Petition for Removal- Contract Default)",
      "28:1441dj" : "28:1441dj (28:1441 Petition for Removal- Declaratory Judgemen)",
      "28:1441ds" : "28:1441ds (28:1441 Petition for Removal- Contract Dispute)",
      "28:1441ed" : "28:1441ed (28:1441 Petition for Removal - Employment Discrim)",
      "28:1441fc" : "28:1441fc (28:1441 Petition for Removal - Fair Credit Reporti)",
      "28:1441fr" : "28:1441fr (28:1441 Petition for Removal- Fraud)",
      "28:1441ij" : "28:1441ij (28:1441 Petition for Removal- Injunctive/Declarato)",
      "28:1441in" : "28:1441in (28:1441 Petition for Removal- Insurance Contract)",
      "28:1441int" : "28:1441int (28:1441 Petition for Removal- Action for Interplea)",
      "28:1441lb" : "28:1441lb (28:1441 Petition for Removal Libel,Assault,Slander)",
      "28:1441lm" : "28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relatio)",
      "28:1441mm" : "28:1441mm (28:1441 Petition for Removal- Medical Malpractice)",
      "28:1441ni" : "28:1441ni (28:1441 Petition for Removal- Negotiable Instrumen)",
      "28:1441nm" : "28:1441nm (28:1441 Petition for Removal- Non-Motor Vehicle)",
      "28:1441oc" : "28:1441oc (28:1441 Petition For Removal--Other Contract)",
      "28:1441pd" : "28:1441pd (28:1441 Petition for Removal- Property Damage)",
      "28:1441pi" : "28:1441pi (28:1441 Petition for Removal- Personal Injury)",
      "28:1441pl" : "28:1441pl (28:1441 Petition for Removal- Product Liability)",
      "28:1441pr" : "28:1441pr (28:1441 Petition for Removal)",
      "28:1441qt" : "28:1441qt (28:1441 Petition for Removal- Petition to Quiet Ti)",
      "28:1441ri" : "28:1441ri (28:1441 Petition for Removal- Racketeering (RICO))",
      "28:1441sa" : "28:1441sa (28:1441 - Petition for Removal: SEC Act)",
      "28:1441sf" : "28:1441sf (28:1441 - Petition for Removal: Securities Fraud)",
      "28:1441tl" : "28:1441tl (28:1441 Petition for Removal- Torts to Land)",
      "28:1441tm" : "28:1441tm (28:1441 Petition for Removal- Tort/Motor Vehicle)",
      "28:1441tn" : "28:1441tn (28:1441 Petition for Removal- Tort/Non-Motor Vehic)",
      "28:1441wd" : "28:1441wd (28:1441 Petition for Removal- Wrongful Death)",
      "28:1442bc" : "28:1442bc (28:1442 Petition for Removal- Breach of Contract)",
      "28:1442pr" : "28:1442pr (28:1442 Petition for Removal)",
      "28:1443" : "28:1443 (28:1443(1) Rent, Lease & Ejectment)",
      "28:1444" : "28:1444 (28:1444 Petition for Removal- Foreclosure)",
      "28:1446in" : "28:1446in (28:1446 Breach of Contract- Insurance)",
      "28:1446pd" : "28:1446pd (28:1446 Petition for Removal- Property Damage (P.I)",
      "28:1446pi" : "28:1446pi (28:1446 Petition for Removal- Personal Injury)",
      "28:1446pl" : "28:1446pl (28:1446pl Petition for Removal - Product Liability)",
      "28:1446pr" : "28:1446pr (28:1446 Petition for Removal)",
      "28:1452" : "28:1452 (28:1452 R&R re motions to remand (non-core))",
      "28:1651" : "28:1651 (28:1651 Petition for Writ of Coram Nobis)",
      "28:1651hc" : "28:1651hc (28:1651 Petition for Writ of Habeas Corpus)",
      "28:1651mn" : "28:1651mn (28:1651 Petition for Writ of Mandamus)",
      "28:1983" : "28:1983 (28:1983 Civil Rights)",
      "28:2201" : "28:2201 (28:2201 Constitutionality of State Statute(s))",
      "28:2201dj" : "28:2201dj (28:2201 Declaratory Judgment)",
      "28:2201ij" : "28:2201ij (28:2201 Injunction)",
      "28:2201in" : "28:2201in (28:2201 Declaratory Judgment (Insurance))",
      "28:2241" : "28:2241 (28:2241 Petition for Writ of Habeas Corpus (federa)",
      "28:2254" : "28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))",
      "28:2254se" : "28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)",
      "28:2255" : "28:2255 (28:2255 Motion to Vacate / Correct Illegal Sentenc)",
      "28:2271" : "28:2271 (28:2271 Federal Tort Claims Act)",
      "28:2345" : "28:2345 (28:2345 Medicare Recovery)",
      "28:2409" : "28:2409 (28:2409(a) Quiet Title Action)",
      "28:2410" : "28:2410 (28:2410 Quiet Title)",
      "28:2671" : "28:2671 (28:2671 Federal Tort Claims Act)",
      "28:2674" : "28:2674 (28:2674 Federal Tort Claims Act)",
      "28:3001" : "28:3001 (28:3001 Federal Debt Collection Procedures Act )",
      "28:7402" : "28:7402 (28:7402 Refund of Taxes)",
      "28:7422" : "28:7422 (28:7422 Appeal from Administrative Decision)",
      "29:0151" : "29:0151 (29:151 Labor: Review of Agency Action)",
      "29:0160" : "29:0160 (29:160(1) National Labor Relations Act)",
      "29:0184" : "29:0184 (29:184 Violation Collection Bargain Agreement)",
      "29:0185ep" : "29:0185ep (29:185 Employee Pension Plan)",
      "29:0185lm" : "29:0185lm (29:185 Labor/Mgt. Relations (Contracts))",
      "29:0201do" : "29:0201do (29:201 Denial of Overtime Compensation)",
      "29:0201fl" : "29:0201fl (29:201 Fair Labor Standards Act)",
      "29:0203" : "29:0203 (29:203 Equal Pay Act)",
      "29:0206" : "29:0206 (29:206 Collect Unpaid Wages)",
      "29:0401" : "29:0401 (29:0401 Labor Management Disclosure Act)",
      "29:0621" : "29:0621 (29:621 Job Discrimination (Age))",
      "29:0623" : "29:0623 (29:623 Job Discrimination (Age))",
      "29:0626" : "29:0626 (29:626 Job Discrimination (Age))",
      "29:0633" : "29:0633 (29:633 Job Discrimination (Age))",
      "29:0651" : "29:0651 (29:651 Occupational Safety/Health)",
      "29:0754" : "29:0754 (29:754 Discrimination)",
      "29:0791" : "29:0791 (29:791 Job Discrimination (Rehabilitation Act))",
      "29:0794" : "29:0794 (29:0794 Job Discrimination (Handicap))",
      "29:1001" : "29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)",
      "29:1002" : "29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)",
      "29:1104" : "29:1104 (29:1104 Recovery of Benefits to Employee)",
      "29:1109" : "29:1109 (29:1109 Breach of Fiduciary Duties)",
      "29:1131" : "29:1131 (29:1131 ERISA - Collection of Delinquent Trust Fun)",
      "29:1132" : "29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)",
      "29:1145" : "29:1145 (29:1145 E.R.I.S.A.)",
      "29:1149" : "29:1149 (29:1149 Recover Pension & Profit Sharing)",
      "29:1337" : "29:1337 (29:1337 E.R.I.S.A.)",
      "29:1362" : "29:1362 (29:1362 ERISA)",
      "29:1381" : "29:1381 (29:1381 E.R.I.S.A.)",
      "29:1401" : "29:1401 (29:1401(b)(2) Appeal of Arbitration Award)",
      "29:1451" : "29:1451 (29:1451 E.R.I.S.A.)",
      "29:1801" : "29:1801 (29:1801 Farmworker Rights)",
      "29:2601" : "29:2601 (29:2601 Family and Medical Leave Act of 1993 )",
      "29:790" : "29:790 (29:790 Rehabilitation of Labor)",
      "30:0181" : "30:0181 (30:181 Environment: Review of Agency Action)",
      "30:0801" : "30:0801 (30:0801 Penalities/Federal Mine Safety Health Act)",
      "30:1201" : "30:1201 (30:1201 Environment: Review of Agency Action)",
      "30:1202" : "30:1202 (30:1202 Mining Reclamation Act)",
      "30:1276" : "30:1276 (30:1276 Interior: Review of Agency Action)",
      "31:3545" : "31:3545 (31:3545 Action to Recovery Money)",
      "31:3729" : "31:3729 (31:3729 False Claims Act)",
      "31:3730" : "31:3730 (31:3730 Qui Tam False Claims Act)",
      "31:3731" : "31:3731 (31:3731 Fraud)",
      "33:1319cw" : "33:1319cw (33:1319 Clean Water Act)",
      "33:1319pv" : "33:1319pv (33:1319 Pollutants & Permit Violations)",
      "33:1365" : "33:1365 (33:1365 Environmental Matters)",
      "35:0145" : "35:0145 (35:145 Patent Infringement)",
      "35:0183" : "35:0183 (35:183 Patent Infringement)",
      "35:0271" : "35:0271 (35:271 Patent Infringement)",
      "38:1681" : "38:1681 (38:1681 Recovery of VA Overpayment)",
      "38:1686" : "38:1686 (38:1686 Recovery of VA Overpayment)",
      "38:1780" : "38:1780 (38:1780 Recovery of VA Overpayment)",
      "38:2011" : "38:2011 (38:2011 - Veteran's Readjustment Assistance Act of)",
      "38:3116" : "38:3116 (38:3116 VA Overpayment)",
      "38:4301" : "38:4301 (38:4301 Uniformed Services Employ./Re-employ. Rights Act )",
      "39:1208" : "39:1208 (39:1208 Breach of Collective Bargaining Agreement)",
      "39:3005" : "39:3005 (39:3005 Detention of Mail for Temporary Periods)",
      "39:409" : "39:409 (39:409 Postal Service)",
      "40:0258" : "40:0258 (40:258(a) Public Buildings & Property: Land Condem)",
      "40:0875" : "40:0875 (40:875 Public Buildings & Property: Negligence)",
      "40:3131" : "40:3131 (40:3131 Miller Act)",
      "41:0251" : "41:0251 (41:251 Public Contracts-Review of Agency Action)",
      "41:1463" : "41:1463 (41:1463 Public Contracts: Unlawful Employment Prac)",
      "42:0205" : "42:0205 (42:205 Denial Social Security Benefits)",
      "42:0206" : "42:0206 (42:206 Social Security Benefits)",
      "42:0247" : "42:0247 (42:247 Personal Injury-Swine Flu)",
      "42:0402" : "42:0402 (42:402 Social Security Benefits)",
      "42:0405id" : "42:0405id (42:405 Review of HHS Decision (SSID))",
      "42:0405wc" : "42:0405wc (42:405 Review of HHS Decision (DIWC))",
      "42:0405ww" : "42:0405ww (42:405 Review of HHS Decision (DIWW))",
      "42:0416" : "42:0416 (42:416 Denial of Social Security Benefits)",
      "42:0427" : "42:0427 (42:427 Social Security Benefits)",
      "42:11601" : "42:11601 (International Child Abduction Remedies Act )",
      "42:12117" : "42:12117 (42:12117 Americans with Disabilities Act )",
      "42:1383" : "42:1383 (42:1383 Review of HHS Decision)",
      "42:1395" : "42:1395 (42:1395 HHS: Adverse Reimbursement Review)",
      "42:1396" : "42:1396 (42:1396 - Tort Negligence)",
      "42:1471" : "42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclo)",
      "42:1981cv" : "42:1981cv (42:1981 Civil Rights)",
      "42:1981hs" : "42:1981hs (42:1981 Housing Discrimination)",
      "42:1981jb" : "42:1981jb (42:1981 Job Discrimination (Race))",
      "42:1981sx" : "42:1981sx (42:1981 Sex Discrimination)",
      "42:1983cv" : "42:1983cv (42:1983 Civil Rights Act)",
      "42:1983ed" : "42:1983ed (42:1983 Civil Rights (Employment Discrimination))",
      "42:1983pr" : "42:1983pr (42:1983 Prisoner Civil Rights)",
      "42:1986" : "42:1986 (42:1986 Neglect of Duty)",
      "42:2000ag" : "42:2000ag (42:2000 Job Discrimination (Age))",
      "42:2000e" : "42:2000e (42:2000e Job Discrimination (Employment))",
      "42:2000pb" : "42:2000pb (42:2000 Job Discrimination (Public Accomodations))",
      "42:2000ra" : "42:2000ra (42:2000 Job Discrimination (Race))",
      "42:2000sx" : "42:2000sx (42:2000 Job Discrimination (Sex))",
      "42:2003" : "42:2003 (42:2003 Job Discrimination)",
      "42:2005" : "42:2005 (42:2005 Review of Agency Action-HHS)",
      "42:2651" : "42:2651 (42:2651 Medical Care Recovery)",
      "42:3601" : "42:3601 (42:405 Fair Housing Act)",
      "42:4000" : "42:4000 (42:4000 National Flood Insurance Act)",
      "42:4001" : "42:4001 (42:4001 National Insurance Flood Act)",
      "42:4053" : "42:4053 (42:4053 Breach of Insurance Contract)",
      "42:4072" : "42:4072 (42:4072 Payment of Flood Insurance Claim)",
      "42:4321" : "42:4321 (42:4321 Review of Agency Action-Environment)",
      "42:4332" : "42:4332 (42:4332 Environmental Policy - Coop of Agency Repo)",
      "42:6901en" : "42:6901en (42:6901 Environmental Cleanup Expenses)",
      "42:6901rs" : "42:6901rs (42:6901 Resource & Recovery Act)",
      "42:7413" : "42:7413 (42:7413(b) Clean Air Act)",
      "42:7604cl" : "42:7604cl (42:7604 Clear Air Act (Emission Standards))",
      "42:7604ir" : "42:7604ir (42:7604 Petition to Quash IRS Summons)",
      "42:9607" : "42:9607 (42:9607 Real Property Tort to Land)",
      "43:945" : "43:945 (43:945 Compensation for Land Condemnation)",
      "43:945a" : "43:945a (43:945a Complaint in Condemnation)",
      "43:946" : "43:946 (43:946 Complaint in Condemnation - Eminent Domain)",
      "45:0051" : "45:0051 (45:51 Railways: Fed. Employer's Liability Act)",
      "45:0151" : "45:0151 (45:151 Railway Labor Act)",
      "45:0184" : "45:0184 (45:184 Action to Set Aside Award of a System Board)",
      "45:1395" : "45:1395 (45:1395 Railroads: Adverse Reimbursement Review)",
      "45:7457" : "45:7457 (45:7457 Compel Reclamation Under Clear Air Act)",
      "46:0688" : "46:0688 (46:688 Jones Act)",
      "46:0741" : "46:0741 (46:741 Shipping)",
      "46:0761" : "46:0761 (46:761 Shipping: Damages for Death on High Seas)",
      "46:1101" : "46:1101 (46:1101 Violation of Maritime Regulations)",
      "46:1156" : "46:1156 (46:1156 Administrative Procedure Act)",
      "47:0605" : "47:0605 (47:605 Electronic Communications Privacy Act )",
      "48:0883" : "48:0883 (48:883 Violation of US Coastal Law)",
      "48:1985" : "48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)",
      "49:0081" : "49:0081 (49:81 Damaged Goods While Being Transported)",
      "49:0781" : "49:0781 (49:781 Forfeiture)",
      "49:11503" : "49:11503 (49:11503 Railroad Revitalization Regulatory Reform)",
      "49:11702" : "49:11702 (49:11702(a)(4) Violations of Interstate Commerce A)",
      "49:1471" : "49:1471 (49:1471 Federal Aviation Act)",
      "49:1903" : "49:1903 (49:1903 Petition to enforce administrative summon)",
      "8:287" : "8:287 (8:287 Petition to Enforce INS Subpoena)",
      "misc" : "misc (Civil Miscellaneous Case)"
   },
   "tnmdce" : {
      "0" : "0 (No cause code entered)",
      "00:0000" : "00:0000 (00:0000 Cause Code Unknown)",
      "02:0431" : "02:0431 (02:431 Fed. Election Commission: Failure Enforce Compliance)",
      "02:0437" : "02:0437 (02:437 Federal Election Commission)",
      "04:0051" : "04:0051 (04:0051 Federal Employers' Liability Act)",
      "05:0075" : "05:0075 (05:75(2) Contract - Reduction in Grade)",
      "05:0504" : "05:0504 (Equal Access to Justice Act)",
      "05:0551" : "05:0551 (05:551 Administrative Procedure Act)",
      "05:0552fi" : "05:0552fi (05:552 Freedom of Information Act)",
      "05:0552pa" : "05:0552pa (05:552 Right to Privacy Act)",
      "05:0554" : "05:0554 (05:0554 Constitutionality of Maritime Statutes)",
      "05:0701" : "05:0701 (05:0701 Maritime Subsidy Board)",
      "05:0702" : "05:0702 (05:702 Administrative Procedure Act)",
      "05:0704" : "05:0704 (05:704 Labor Litigation)",
      "05:7703" : "05:7703 (05:7703 Discrimination - Review of Agency Act)",
      "07:0006" : "07:0006 (7:6(b) Federal Commodity Exchange Regulation)",
      "07:0025" : "07:0025 (7:25 Fraud - Commodities Leverage Contracts)",
      "07:0181" : "07:0181 (07:181 Packers & Stockyard Act)",
      "07:0499" : "07:0499 (07:499 Agricultural Commodities Act)",
      "07:0601" : "07:0601 (07:601 USDA Condemnation)",
      "07:1365" : "07:1365 (07:1365 Agricultural Adjustment Act)",
      "07:2023" : "07:2023 (07:2023 Administration Appeal - Dept. of Agriculture)",
      "07:2321" : "07:2321 (07:2321 Plant Variety Protection Act)",
      "08:0287" : "08:0287 (8:287 Petition to Enforce INS Subpoena)",
      "08:1103" : "08:1103 (08:1103 Immigration & Nationality Act of 1952)",
      "08:1105" : "08:1105 (8:1105(a) Aliens: Habeas Corpus to Release INS Detainee)",
      "08:1252" : "08:1252 (08:1252 Judicial Review of Orders of Removal)",
      "08:1260" : "08:1260 (08:1260 Aliens: Access to Records)",
      "08:1324" : "08:1324 (08:1324 Aliens: Complaint for Forfeiture)",
      "08:1329" : "08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petition)",
      "08:1421" : "08:1421 (08:1421 Judicial Review of Denial of Naturalization Petition)",
      "08:1446" : "08:1446 (8:1446 Petition for Naturalization Hearing)",
      "08:1447" : "08:1447 (08:1447 Failure to make decision on naturalization petition)",
      "08:1451" : "08:1451 (08:1451(a) Revocation of Citizenship)",
      "09:0001" : "09:0001 (09:1 U.S. Arbitration Act)",
      "09:0009" : "09:0009 (09:0009 Motion to Confirm Arbitration Award)",
      "09:0010" : "09:0010 (09:0010 Petition to Vacate Arbitration Award)",
      "10:1552" : "10:1552 (10:1552 Armed Forces: Action to Correct Records)",
      "10:1553" : "10:1553 (10:1553 Armed Forces: FOIA General)",
      "10:2005" : "10:2005 (10:2005 Advanced Education Assistance)",
      "10:2305" : "10:2305 (10:2305 Review of Federal Contract)",
      "10:2687" : "10:2687 (BRAC Act (Defense Base Closure and Realignment Act of 1990))",
      "11:0101" : "11:0101 (11:101 Bankruptcy)",
      "11:0110" : "11:0110 (11:0110 Bankruptcy Petition Preparer-Penalty)",
      "11:525" : "11:525 (11:525 Bankruptcy-Protection from Discrimination & Retaliation)",
      "12:0021" : "12:0021 (12:0021 National Bank Act)",
      "12:0022" : "12:0022 (12:22 Securities Fraud)",
      "12:0221" : "12:0221 (12:0221 Federal Reserve Act)",
      "12:0635" : "12:0635 (12:635 Breach of Insurance Contract)",
      "12:1201" : "12:1201 (12:1201 Real Estate Settlement Procedures Act)",
      "12:1461" : "12:1461 (12:1461 Homeowners Loan Act)",
      "12:1703" : "12:1703 (12:1703 Default of HUD Loan)",
      "12:1725" : "12:1725 (12:1725 Collection under Contract Guaranty)",
      "12:1730" : "12:1730 (12:1730 Collection Under Contract Guaranty)",
      "12:1759" : "12:1759 (12:1759 Banks & Banking membership)",
      "12:1819" : "12:1819 (12:1819 Default of Promissory Note)",
      "12:1821" : "12:1821 (12:1821 Default of Loan by Promissary Note)",
      "12:1971" : "12:1971 (12:1971 Relief under Bank Holding Act)",
      "12:1972" : "12:1972 (12:1972 Bank Holding Company Act)",
      "12:2601" : "12:2601 (12:2601 Real Estate Settlement Procedures Act)",
      "12:3410" : "12:3410 (12:3410 Right to Financial Privacy Act)",
      "15:0001" : "15:0001 (15:1 Antitrust Litigation)",
      "15:0002at" : "15:0002at (15:2 Antitrust Litigation)",
      "15:0002fl" : "15:0002fl (15:2(a) Fair Labor Standards Act)",
      "15:0005" : "15:0005 (15:5(a) Fair Labor Standards Act)",
      "15:0015" : "15:0015 (15:15 Antitrust Litigation)",
      "15:0025" : "15:0025 (15:25 Clayton Act)",
      "15:0044" : "15:0044 (15:44 Trademark Infringement)",
      "15:0045" : "15:0045 (15:0045 Federal Trade Commission Act)",
      "15:0052" : "15:0052 (15:0052 Federal Trade Commission Act)",
      "15:0053" : "15:0053 (15:0053 Federal Trade Commission Act)",
      "15:0077" : "15:0077 (15:77 Securities Fraud)",
      "15:0078" : "15:0078 (15:78m(a) Securities Exchange Act)",
      "15:0080" : "15:0080 (15:80 Investment Company Act)",
      "15:0631" : "15:0631 (15:631 Small Business Act)",
      "15:0717" : "15:0717 (15:717 Natural Gas Act)",
      "15:1051" : "15:1051 (15:1051 Trademark Infringement)",
      "15:1114" : "15:1114 (15:1114 Trademark Infringement)",
      "15:1121" : "15:1121 (15:1121 Trademark Infringement)",
      "15:1125" : "15:1125 (15:1125 Trademark Infringement (Lanham Act))",
      "15:1126" : "15:1126 (15:1126 Patent Infringement)",
      "15:1127" : "15:1127 (15:1127 Trademark Infringement)",
      "15:1222" : "15:1222 (15:1222 Auto dealers suits against Manufacturers)",
      "15:1501" : "15:1501 (15:1501 Trademark/Anti-Cybersquatting Consumer Protect Act)",
      "15:1601" : "15:1601 (15:1601 Truth in Lending)",
      "15:1640" : "15:1640 (15:1640 Truth in Lending)",
      "15:1667" : "15:1667 (15:1667 Truth in Lending)",
      "15:1679" : "15:1679 (15:1679 Commerce and Trade)",
      "15:1681" : "15:1681 (15:1681 Fair Credit Reporting Act)",
      "15:1691" : "15:1691 (15:1691 Equal Credit Opportunity Act)",
      "15:1692" : "15:1692 (15:1692 Fair Debt Collection Act)",
      "15:1693" : "15:1693 (15:1693 Electronic Fund Transfers Act)",
      "15:1701la" : "15:1701la (15:1701-1720 Interstate Land Sales Full Disclosure Act)",
      "15:1821" : "15:1821 (15:1821 Horse Protection Act)",
      "15:1938" : "15:1938 (15:1938 Fair Labor Standards Act)",
      "15:1981" : "15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))",
      "15:1988" : "15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))",
      "15:1989" : "15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))",
      "15:2301" : "15:2301 (15:2301 Magnuson-Moss Warranty Act)",
      "15:2801" : "15:2801 (15:2801 Petroleum Marketing Practices Act)",
      "15:53(b)" : "15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equitable Relief)",
      "15:6101" : "15:6101 (15:6101 Federal Trade Commission's Telemarketing Sales Rule)",
      "16:0470" : "16:0470 (16:0470 Archaeological Resource Act)",
      "16:0668" : "16:0668 (16:668 Bald Eagle Protection Act)",
      "16:0703" : "16:0703 (16:703 Migratory Bird Act)",
      "16:0742" : "16:0742 (16:0742 Airborne Hunting Act)",
      "16:0831" : "16:0831 (16:0831 Tennessee Valley Authority Act)",
      "16:1538" : "16:1538 (16:1538 Endangered Species Act)",
      "16:3371" : "16:3371 (16:3371 Wildlife Under the Lacey Act)",
      "16:3372" : "16:3372 (16:3372 Conservation: Complaint for Forfeiture)",
      "16:3373" : "16:3373 (16:3373 Appeal of Decision - DOI)",
      "16:3374" : "16:3374 (16:3374 Conservation: Complaint for Forfeiture)",
      "17:0101" : "17:0101 (17:0101 Copyright Infringement)",
      "17:0102" : "17:0102 (17:0102 Copyright Infringement)",
      "17:0106" : "17:0106 (17:0106 Copyright Infringement)",
      "17:0501" : "17:0501 (17:501 Copyright Infringement)",
      "17:0504" : "17:0504 (17:504 Copyright Infringement)",
      "18:0241" : "18:0241 (18:241 Conspiracy Against Citizen Rights)",
      "18:0492" : "18:0492 (18:0492 Forfeiture of Property)",
      "18:0921" : "18:0921 (18:0921 Firearms)",
      "18:0922" : "18:0922 (18:0922 Firearms)",
      "18:0925" : "18:0925 (18:0925 Petition for Relief/Prohibition of Firearms Poss.)",
      "18:0981" : "18:0981 (18:0981 Civil Forfeiture)",
      "18:1030" : "18:1030 (18:1030 Computer Fraud)",
      "18:1033" : "18:1033 (18:1033 Insurance-Fraud & False Statements)",
      "18:1344" : "18:1344 (18:1344 Bank Fraud)",
      "18:1345" : "18:1345 (18:1345 Health Care Fraud)",
      "18:1589" : "18:1589 (18:1589 Forced Labor)",
      "18:1836a" : "18:1836a (18:1836(a) Injunction against Misappropriation of Trade Secrets)",
      "18:1836b" : "18:1836b (18:1836(b) Civil Action to Protect Trade Secrets)",
      "18:1951" : "18:1951 (18:1951 Racketeering (RICO) Act)",
      "18:1955" : "18:1955 (18:1955 Forfeiture of Property or Currency)",
      "18:1961" : "18:1961 (18:1961 Racketeering (RICO) Act)",
      "18:1962" : "18:1962 (18:1962 Racketeering (RICO) Act)",
      "18:1964" : "18:1964 (18:1964 Racketeering (RICO) Act)",
      "18:2254" : "18:2254 (18:2254 Forfeiture of Property or Currency)",
      "18:2510" : "18:2510 (18:2510 Wiretapping Act)",
      "18:2701" : "18:2701 (18:2701-2711 Stored Communications Act)",
      "18:4208" : "18:4208 (18:4208(B) Agency Action Review)",
      "19:1305" : "19:1305 (19:1305 Custom Duties:0Forfeiture-Immoral Articles)",
      "19:1602" : "19:1602 (19:1602 Property Confiscation)",
      "20:1078" : "20:1078 (Federal Family Education Loan Program (FFELP))",
      "20:1080" : "20:1080 (20:1080 Student Loan Recovery)",
      "20:1400" : "20:1400 (20:1400 Civil Rights of Handicapped Child)",
      "20:1401" : "20:1401 (20:1401 Education: Handicapped Child Act)",
      "20:1681" : "20:1681 (20:1681 Title IX of Education Amendment of 1972)",
      "21:0301" : "21:0301 (21:0301 Federal Food, Drug & Cosmetic Act)",
      "21:0801" : "21:0801 (21:801 Compreh. Drug Abuse Prev. and Control Act of 1970)",
      "21:0841" : "21:0841 (21:841 Forfeiture Property-Drugs)",
      "21:0876" : "21:0876 (21:0876 DEA Subpoena Enforcement)",
      "21:0881" : "21:0881 (21:881 Forfeiture Property-Drugs)",
      "21:0881a" : "21:0881a (21:881 Forfeiture Property - Aircraft)",
      "21:0881re" : "21:0881re (21:881 Forfeiture Property - Real Estate)",
      "22:9001" : "22:9001 (22 USC 9001 International Child Abduction Remedies Act)",
      "23:0134" : "23:0134 (23:134 P.I.- Auto Negligence)",
      "23:1441" : "23:1441 (23:1441 Contract Real Estate)",
      "24:1000" : "24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)",
      "25:0640" : "25:0640 (25:640 Indian Tribal Rights)",
      "25:1901" : "25:1901 (25:1901 Indian Child Welfare Act)",
      "26:0042" : "26:0042 (26:0042 Low Income Housing Tax Credit Program)",
      "26:5861" : "26:5861 (26:5861 National Firearm Act)",
      "26:6212" : "26:6212 (26:6212 Injunctive Relief from IRS Lien)",
      "26:6213" : "26:6213 (26:6213 Injunctive Relief from IRS Lien)",
      "26:6330" : "26:6330 (26:6330 Tax Collection Appeal)",
      "26:6334" : "26:6334 (26:6334 IRS-Administrative Levy)",
      "26:6502" : "26:6502 (26:6502 IRS:Enforcement of tax liens)",
      "26:6532" : "26:6532 (26:6532 IRS: Refund of Tax Penalty)",
      "26:6672" : "26:6672 (26:6672 Trust Fund Recovery Penalty)",
      "26:6702" : "26:6702 (26:6702 IRS: Refund of Income Tax Penalty)",
      "26:6703" : "26:6703 (26:6703 IRS: Refund of Tax Penalty)",
      "26:7401" : "26:7401 (26:7401 IRS: Tax Liability)",
      "26:7402" : "26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)",
      "26:7403" : "26:7403 (26:7403 Suit to Enforce Federal Tax Lien)",
      "26:7408" : "26:7408 (26:7408 Penalty for Promoting Abusive Tax Shelters)",
      "26:7422rt" : "26:7422rt (26:7422 IRS: Refund Taxes)",
      "26:7422rx" : "26:7422rx (26:7422 IRS: Refund Excise Tax)",
      "26:7426" : "26:7426 (26:7426 IRS: Wrongful Levy for Taxes)",
      "26:7429" : "26:7429 (26:7429 IRS: Tax Jeopardy Assessment)",
      "26:7609" : "26:7609 (26:7609 IRS: Petition to Quash IRS Summons)",
      "27:0185" : "27:0185 (27:185 Enforcement of Arbitration Award)",
      "28:0157b" : "28:0157b (28:0157(b)(5) Personal Injury Tort/Wrongful Death Claims)",
      "28:0157c" : "28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)",
      "28:0157d" : "28:0157d (28:0157 Motion for Withdrawal of Reference)",
      "28:0158" : "28:0158 (28:0158 Notice of Appeal re Bankruptcy Matter)",
      "28:0185" : "28:0185 (28:185 Suit to Compel Arbitration)",
      "28:0451" : "28:0451 (28:451 Employment Discrimination)",
      "28:0794" : "28:0794 (28:794 Rehabilitation Act)",
      "28:1001" : "28:1001 (28:1001 E.R.I.S.A.)",
      "28:1132" : "28:1132 (28:1132 E.R.I.S.A.)",
      "28:1330" : "28:1330 (28:1330 Breach of Contract)",
      "28:1331" : "28:1331 (28:1331 Fed. Question)",
      "28:1331al" : "28:1331al (28:1331 Fed. Question: Airline Crash)",
      "28:1331at" : "28:1331at (28:1331 Fed. Question: Anti-trust)",
      "28:1331au" : "28:1331au (28:1331 Fed. Question: Auto Negligence)",
      "28:1331b" : "28:1331b (28:1331 Federal Question: Bivens Act)",
      "28:1331bc" : "28:1331bc (28:1331 Fed. Question: Breach of Contract)",
      "28:1331ca" : "28:1331ca (28:1331 Fed Question: Fed Communications Act of 1934)",
      "28:1331cm" : "28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)",
      "28:1331cv" : "28:1331cv (28:1331 Federal Question: Other Civil Rights)",
      "28:1331ed" : "28:1331ed (28:1331 Fed. Question: Employment Discrimination)",
      "28:1331es" : "28:1331es (28:1331 Enforcement of Administrative Subpoena)",
      "28:1331fc" : "28:1331fc (28:1331 Federal Question: Foreclosure)",
      "28:1331fl" : "28:1331fl (28:1331 Fed. Question: Fair Labor Standards)",
      "28:1331in" : "28:1331in (28:1331 Fed. Question: Insurance Contract)",
      "28:1331lb" : "28:1331lb (28:1331 Assault, Libel & Slander)",
      "28:1331ll" : "28:1331ll (28:1331 Other Labor Litigation)",
      "28:1331ma" : "28:1331ma (28:1331 Federal Question: Medicare Act)",
      "28:1331mm" : "28:1331mm (28:1331 Fed. Question: Medical Malpractice)",
      "28:1331mv" : "28:1331mv (28:1331 Motor Vehicle)",
      "28:1331of" : "28:1331of (28:1331 Other Fraud)",
      "28:1331pi" : "28:1331pi (28:1331 Fed. Question: Personal Injury)",
      "28:1331rd" : "28:1331rd (28:1331 Fed. Question: Review Agency Decision)",
      "28:1331rp" : "28:1331rp (28:1331(a) Fed. Question: Real Property)",
      "28:1331rr" : "28:1331rr (28:1331 Fed. Question: Railway Labor Act)",
      "28:1331sv" : "28:1331sv (28:1331 Fed. Question: Securities Violation)",
      "28:1331tr" : "28:1331tr (28:1331 Fed. Question: Trademark)",
      "28:1331tt" : "28:1331tt (28:1331 Fed. Question: Tort Action)",
      "28:1331v" : "28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendment)",
      "28:1331wl" : "28:1331wl (28:1331 Federal Question: EPA Waste Lien)",
      "28:1331wt" : "28:1331wt (28:1331 Fed. Question: Water Rights)",
      "28:1332ac" : "28:1332ac (28:1332 Diversity-Account Receivable)",
      "28:1332al" : "28:1332al (28:1332 Diversity-Airline Crash)",
      "28:1332as" : "28:1332as (28:1332 Diversity-Asbestos Litigation)",
      "28:1332au" : "28:1332au (28:1332 Diversity-Auto Negligence)",
      "28:1332bb" : "28:1332bb (28:1332 Diversity-Banks and Banking)",
      "28:1332bc" : "28:1332bc (28:1332 Diversity-Breach of Contract)",
      "28:1332bl" : "28:1332bl (28:1332 Diversity-Breach of Lease Agreement)",
      "28:1332co" : "28:1332co (28:1332 Diversity-Conversion)",
      "28:1332cpl" : "28:1332cpl (28:1332 Diversity-Contract Product Liability)",
      "28:1332ct" : "28:1332ct (28:1332 Diversity-(Citizenship))",
      "28:1332det" : "28:1332det (28:1332 Diversity: Forcible Detainer)",
      "28:1332df" : "28:1332df (28:1332 Diversity-Contract Default)",
      "28:1332ds" : "28:1332ds (28:1332 Diversity-Contract Dispute)",
      "28:1332ed" : "28:1332ed (28:1332 Diversity-Employment Discrimination)",
      "28:1332ej" : "28:1332ej (28:1332 Diversity-Overpayment & Enforcement of Judgment)",
      "28:1332em" : "28:1332em (28:1332 Diversity-Employment)",
      "28:1332fd" : "28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)",
      "28:1332fr" : "28:1332fr (28:1332 Diversity-Fraud)",
      "28:1332ia" : "28:1332ia (28:1332 Diversity-Interpleader Action)",
      "28:1332ij" : "28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)",
      "28:1332in" : "28:1332in (28:1332 Diversity-Insurance Contract)",
      "28:1332jd" : "28:1332jd (28:1332 Diversity-Declaratory Judgment)",
      "28:1332lb" : "28:1332lb (28:1332 Diversity-Libel,Assault,Slander)",
      "28:1332ll" : "28:1332ll (28:1332 Diversity-Labor Litigation)",
      "28:1332lm" : "28:1332lm (28:1332 Diversity - Legal Malpractice)",
      "28:1332m" : "28:1332m (28:1332 Marine Contract)",
      "28:1332ma" : "28:1332ma (28:1332 Diversity-Miller Act)",
      "28:1332med" : "28:1332med (28:1332 Diversity-Medicare Act)",
      "28:1332mm" : "28:1332mm (28:1332 Diversity-Medical Malpractice)",
      "28:1332mpl" : "28:1332mpl (28:1332 Diversity-Marine Product Liability)",
      "28:1332mv" : "28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)",
      "28:1332ni" : "28:1332ni (28:1332 Diversity-Negotiable Instrument)",
      "28:1332nm" : "28:1332nm (28:1332 Diversity-Non-Motor Vehicle)",
      "28:1332oc" : "28:1332oc (28:1332 Diversity-Other Contract)",
      "28:1332of" : "28:1332of (28:1332 Other Fraud)",
      "28:1332op" : "28:1332op (28:1332 Diversity-All Other Real Property)",
      "28:1332pd" : "28:1332pd (28:1332 Diversity-Property Damage)",
      "28:1332pi" : "28:1332pi (28:1332 Diversity-Personal Injury)",
      "28:1332pl" : "28:1332pl (28:1332 Diversity-Product Liability)",
      "28:1332pr" : "28:1332pr (28:1332 Diversity-Notice of Removal)",
      "28:1332qt" : "28:1332qt (28:1332 Diversity-Petition to Quiet Title)",
      "28:1332ri" : "28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)",
      "28:1332sa" : "28:1332sa (28:1332 - Diversity: Securities & Exchange Commission Act)",
      "28:1332sf" : "28:1332sf (28:1332 - Diversity: Securities Fraud)",
      "28:1332ss" : "28:1332ss (28:1332 Diversity - Stockholders Suits)",
      "28:1332tl" : "28:1332tl (28:1332 Diversity-Torts to Land)",
      "28:1332tm" : "28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))",
      "28:1332tn" : "28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)",
      "28:1332wd" : "28:1332wd (28:1332 Diversity-Wrongful Death)",
      "28:1333" : "28:1333 (28:1333 Admiralty)",
      "28:1334" : "28:1334 (28:1334 Bankruptcy Appeal)",
      "28:1334c" : "28:1334c (28:1334(c) R&R re motions for abstention (non-core))",
      "28:1335" : "28:1335 (28:1335 Interpleader Action)",
      "28:1337" : "28:1337 (28:1337 Sherman-Clayton Act)",
      "28:1338cp" : "28:1338cp (28:1338 Copyright Infringement)",
      "28:1338pt" : "28:1338pt (28:1338 Patent Infringement)",
      "28:1338tr" : "28:1338tr (28:1338 Trademark Infringement)",
      "28:1340" : "28:1340 (28:1340 IRS: Custom Duties)",
      "28:1340er" : "28:1340er (28:1340 Recovery of Erroneous Refund)",
      "28:1341" : "28:1341 (28:1341 Complaint for Forfeiture)",
      "28:1343" : "28:1343 (28:1343 Violation of Civil Rights)",
      "28:1345co" : "28:1345co (28:1345 Replevin & Conversion)",
      "28:1345db" : "28:1345db (28:1345 Debt to US - FHA/HUD Title I)",
      "28:1345df" : "28:1345df (28:1345 Default of Promissory Note)",
      "28:1345er" : "28:1345er (28:1345 Recovery of Erroneous Refund)",
      "28:1345fc" : "28:1345fc (28:1345 Foreclosure)",
      "28:1345ff" : "28:1345ff (28:1345 Complaint for Forfeiture)",
      "28:1345hl" : "28:1345hl (28:1345 VA Home Loan Guaranty Debt)",
      "28:1345mc" : "28:1345mc (28:1345 Medical Care Recovery)",
      "28:1345mi" : "28:1345mi (28:1345 Mining Claim Ejectment)",
      "28:1345pd" : "28:1345pd (28:1345 Property Damage)",
      "28:1345pe" : "28:1345pe (28:1345 Property Ejectment)",
      "28:1345rc" : "28:1345rc (28:1345 Recovery of Debt to US)",
      "28:1345st" : "28:1345st (28:1345 Default of Student Loan)",
      "28:1345tp" : "28:1345tp (28:1345 Trespass on Public Land)",
      "28:1345va" : "28:1345va (28:1345 Recovery of VA Overpayment)",
      "28:1346bc" : "28:1346bc (28:1346 Breach of Contract)",
      "28:1346rc" : "28:1346rc (28:1346 Recovery of IRS Tax)",
      "28:1346tc" : "28:1346tc (28:1346 Tort Claim)",
      "28:1346wd" : "28:1346wd (28:1346 Wrongful Death)",
      "28:1352" : "28:1352 (28:1352 Miller Act)",
      "28:1355" : "28:1355 (28:1355 Petition for Return of Property)",
      "28:1358" : "28:1358 (28:1358 Land Condemnation)",
      "28:1361" : "28:1361 (28:1361 Petition for Writ of Mandamus)",
      "28:1362ic" : "28:1362ic (28:1362 Indian Tribal Controversy)",
      "28:1362iw" : "28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)",
      "28:1364" : "28:1364 (28:1364 Auto Negligence)",
      "28:1391" : "28:1391 (28:1391 Personal Injury)",
      "28:1402" : "28:1402 (28:1402 Medical Malpractice)",
      "28:1407" : "28:1407 (28:1407 Airline Crash)",
      "28:1441ac" : "28:1441ac (28:1441 Notice of Removal- Account Receivable)",
      "28:1441al" : "28:1441al (28:1441 Notice of Removal- Airline Crash)",
      "28:1441as" : "28:1441as (28:1441 Notice of Removal- Asbestos Litigation)",
      "28:1441at" : "28:1441at (28:1441 Notice of Removal- Antitrust)",
      "28:1441au" : "28:1441au (28:1441 Notice of Removal- Auto Negligence)",
      "28:1441bb" : "28:1441bb (28:1441 Notice of Removal-Banks and Banking)",
      "28:1441bc" : "28:1441bc (28:1441 Notice of Removal- Breach of Contract)",
      "28:1441ca" : "28:1441ca (28:1441 Notice of Removal - Copyrights Act)",
      "28:1441co" : "28:1441co (28:1441 Notice of Removal - Commerce/ICC Rates)",
      "28:1441cv" : "28:1441cv (28:1441 Notice of Removal- Civil Rights Act)",
      "28:1441df" : "28:1441df (28:1441 Notice of Removal- Contract Default)",
      "28:1441dj" : "28:1441dj (28:1441 Notice of Removal- Declaratory Judgment)",
      "28:1441ds" : "28:1441ds (28:1441 Notice of Removal- Contract Dispute)",
      "28:1441ed" : "28:1441ed (28:1441 Notice of Removal- Employment Discrimination)",
      "28:1441en" : "28:1441en (28:1441 Notice of Removal-Environmental Matters)",
      "28:1441er" : "28:1441er (28:1441 Notice of Removal - ERISA)",
      "28:1441fa" : "28:1441fa (28:1441 Notice of Removal - Family Medical Leave Act)",
      "28:1441fc" : "28:1441fc (28:1441 Notice of Removal - Fair Credit Reporting Act)",
      "28:1441fd" : "28:1441fd (28:1441 Notice of Removal-Fair Debt Collection Act)",
      "28:1441fl" : "28:1441fl (28:1441 Notice of Removal - Fair Labor Standards Act)",
      "28:1441fo" : "28:1441fo (28:1441 Notice of Removal-Foreclosure)",
      "28:1441fr" : "28:1441fr (28:1441 Notice of Removal- Fraud)",
      "28:1441fra" : "28:1441fra (28:1441 Notice of Removal-Franchise)",
      "28:1441hb" : "28:1441hb (28:1441 Health Benefits)",
      "28:1441ho" : "28:1441ho (28:1441 Notice of Removal- Civil Rights/Housing)",
      "28:1441ic" : "28:1441ic (28:1441 Interstate Commerce Act)",
      "28:1441ij" : "28:1441ij (28:1441 Notice of Removal- Injunctive/Declaratory Relief)",
      "28:1441in" : "28:1441in (28:1441 Notice of Removal- Insurance Contract)",
      "28:1441int" : "28:1441int (28:1441 Notice of Removal- Action for Interpleader)",
      "28:1441lb" : "28:1441lb (28:1441 Notice of Removal- Libel,Assault,Slander)",
      "28:1441lm" : "28:1441lm (28:1441 Notice of Removal- Labor/Mgmnt. Relations)",
      "28:1441ma" : "28:1441ma (28:1441 Notice of Removal-Marine)",
      "28:1441me" : "28:1441me (28:1441 Notice of Removal - Medicare)",
      "28:1441ml" : "28:1441ml (28:1441 Notice of Removal- Motor Vehicle Product Liability)",
      "28:1441mm" : "28:1441mm (28:1441 Notice of Removal- Medical Malpractice)",
      "28:1441ni" : "28:1441ni (28:1441 Notice of Removal- Negotiable Instrument)",
      "28:1441nm" : "28:1441nm (28:1441 Notice of Removal- Non-Motor Vehicle)",
      "28:1441oc" : "28:1441oc (28:1441 Notice of Removal--Other Contract)",
      "28:1441ol" : "28:1441ol (28:1441 Notice of Removal-Other Labor Litigation)",
      "28:1441op" : "28:1441op (28:1441 Notice of Removal-All Other Real Property)",
      "28:1441os" : "28:1441os (28:1441 Notice of Removal-Other Statutory Actions)",
      "28:1441pa" : "28:1441pa (28:1441 Notice of Removal-Patent)",
      "28:1441pd" : "28:1441pd (28:1441 Notice of Removal- Property Damage)",
      "28:1441pi" : "28:1441pi (28:1441 Notice of Removal- Personal Injury)",
      "28:1441pl" : "28:1441pl (28:1441 Notice of Removal- Product Liability)",
      "28:1441pr" : "28:1441pr (28:1441 Notice of Removal)",
      "28:1441qt" : "28:1441qt (28:1441 Notice of Removal- Petition to Quiet Title)",
      "28:1441ri" : "28:1441ri (28:1441 Notice of Removal- Racketeering (RICO) Act)",
      "28:1441rp" : "28:1441rp (28:1441 Notice of Removal-Real Property)",
      "28:1441sa" : "28:1441sa (28:1441 - Notice of Removal: SEC Act)",
      "28:1441sf" : "28:1441sf (28:1441 - Notice of Removal: Securities Fraud)",
      "28:1441ta" : "28:1441ta (28:1441 - Notice of Removal-Taxes)",
      "28:1441ti" : "28:1441ti (28:1441 Trademark Infringement)",
      "28:1441tl" : "28:1441tl (28:1441 Notice of Removal- Torts to Land)",
      "28:1441tm" : "28:1441tm (28:1441 Notice of Removal- Tort/Motor Vehicle (P.I.))",
      "28:1441tn" : "28:1441tn (28:1441 Notice of Removal- Tort/Non-Motor Vehicle)",
      "28:1441tr" : "28:1441tr (28:1441 Notice of Removal-Truth in Lending)",
      "28:1441vr" : "28:1441vr (28:1441vr Notice of Removal-Denial of Voting Rights)",
      "28:1441wd" : "28:1441wd (28:1441 Notice of Removal- Wrongful Death)",
      "28:1442bc" : "28:1442bc (28:1442 Notice of Removal- Breach of Contract)",
      "28:1442pr" : "28:1442pr (28:1442 Notice of Removal)",
      "28:1443" : "28:1443 (28:1443(1) Rent, Lease & Ejectment)",
      "28:1444" : "28:1444 (28:1444 Notice of Removal- Foreclosure)",
      "28:1446in" : "28:1446in (28:1446 Breach of Contract- Insurance)",
      "28:1446oc" : "28:1446oc (28:1446 Notice of Removal - Other Contract)",
      "28:1446pd" : "28:1446pd (28:1446 Notice of Removal- Property Damage (P.I.))",
      "28:1446pi" : "28:1446pi (28:1446 Notice of Removal- Personal Injury)",
      "28:1446pl" : "28:1446pl (28:1446 Notice of Removal- Product Liability)",
      "28:1446pr" : "28:1446pr (28:1446 Notice of Removal)",
      "28:1446tr" : "28:1446tr (28:1446 Trademark Infringement)",
      "28:1452" : "28:1452 (28:1452 Removal of claims related to bankruptcy cases)",
      "28:1605" : "28:1605 (28:1605 Jurisdictional Immunity of a Foreign State)",
      "28:1651" : "28:1651 (28:1651 Petition for Writ of Coram Nobis)",
      "28:1651hc" : "28:1651hc (28:1651 Petition for Writ of Habeas Corpus)",
      "28:1651mn" : "28:1651mn (28:1651 Petition for Writ of Mandamus)",
      "28:1711" : "28:1711 (28:1711 Class Action Fairness Act of 2005)",
      "28:1738" : "28:1738 (28:1738(A) Parental Kidnapping Prevention Act)",
      "28:1782" : "28:1782 (28:1782 Letter of Request for Judicial Assistance)",
      "28:1875" : "28:1875 (28:1875 Protection of Jurors' Employment)",
      "28:1983" : "28:1983 (28:1983 Civil Rights)",
      "28:2201" : "28:2201 (28:2201 Constitutionality of State Statute(s))",
      "28:2201dj" : "28:2201dj (28:2201 Declaratory Judgment)",
      "28:2201ij" : "28:2201ij (28:2201 Injunction)",
      "28:2201in" : "28:2201in (28:2201 Declaratory Judgment (Insurance))",
      "28:2241" : "28:2241 (28:2241 Petition for Writ of Habeas Corpus)",
      "28:2254" : "28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))",
      "28:2254dp" : "28:2254dp (28:2254 Petition for Writ of H/C-Death Penalty)",
      "28:2254se" : "28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)",
      "28:2255" : "28:2255 (28:2255 Motion to Vacate / Correct Illegal Sentence)",
      "28:2271" : "28:2271 (28:2271 Federal Tort Claims Act)",
      "28:2345" : "28:2345 (28:2345 Medicare Recovery)",
      "28:2401" : "28:2401 (28:2401 Federal Tort Claims Act)",
      "28:2409" : "28:2409 (28:2409(a) Quiet Title Action)",
      "28:2410" : "28:2410 (28:2410 Quiet Title)",
      "28:2671" : "28:2671 (28:2671 Federal Tort Claims Act)",
      "28:2674" : "28:2674 (28:2674 Federal Tort Claims Act)",
      "28:7402" : "28:7402 (28:7402 Refund of Taxes)",
      "28:7422" : "28:7422 (28:7422 Appeal from Administrative Decision)",
      "29:0151" : "29:0151 (29:151 Labor: Review of Agency Action)",
      "29:0160" : "29:0160 (29:160(1) National Labor Relations Act)",
      "29:0184" : "29:0184 (29:184 Violation Collection Bargain Agreement)",
      "29:0185ep" : "29:0185ep (29:185 Employee Pension Plan)",
      "29:0185lm" : "29:0185lm (29:185 Labor/Mgt. Relations (Contracts))",
      "29:0185ol" : "29:0185ol (29:185 Other Labor Litigation)",
      "29:0201do" : "29:0201do (29:201 Denial of Overtime Compensation)",
      "29:0201fl" : "29:0201fl (29:201 Fair Labor Standards Act)",
      "29:0203" : "29:0203 (29:203 Equal Pay Act)",
      "29:0206" : "29:0206 (29:206 Collect Unpaid Wages)",
      "29:0401" : "29:0401 (29:0401 Labor Management Disclosure Act)",
      "29:0621" : "29:0621 (29:621 Job Discrimination (Age))",
      "29:0623" : "29:0623 (29:623 Job Discrimination (Age))",
      "29:0626" : "29:0626 (29:626 Job Discrimination (Age))",
      "29:0629" : "29:0629 (29:0629 Job Discrimination (Age))",
      "29:0633" : "29:0633 (29:633 Job Discrimination (Age))",
      "29:0651" : "29:0651 (29:651 Occupational Safety/Health)",
      "29:0701" : "29:0701 (29:0701 Americans With Disabilities Act of 1990)",
      "29:0754" : "29:0754 (29:754 Discrimination)",
      "29:0791" : "29:0791 (29:791 Job Discrimination (Rehabilitation Act))",
      "29:0794" : "29:0794 (29:0794 Job Discrimination (Handicap))",
      "29:1001" : "29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)",
      "29:1002" : "29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)",
      "29:1104" : "29:1104 (29:1104 Recovery of Benefits to Employee)",
      "29:1109" : "29:1109 (29:1109 Breach of Fiduciary Duties)",
      "29:1131" : "29:1131 (29:1131 ERISA - Collection of Delinquent Trust Funds)",
      "29:1132" : "29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)",
      "29:1133" : "29:1133 (29:1133 E.R.I.S.A.-Short Term Disability Benefits)",
      "29:1145" : "29:1145 (29:1145 E.R.I.S.A.)",
      "29:1149" : "29:1149 (29:1149 Recover Pension & Profit Sharing)",
      "29:1161" : "29:1161 (29:1161 Comprehensive Omnibus Budget Reconciliation Act)",
      "29:1337" : "29:1337 (29:1337 E.R.I.S.A.)",
      "29:1362" : "29:1362 (29:1362 ERISA)",
      "29:1381" : "29:1381 (29:1381 E.R.I.S.A.)",
      "29:1401" : "29:1401 (29:1401(b)(2) Appeal of Arbitration Award)",
      "29:1451" : "29:1451 (29:1451 E.R.I.S.A.)",
      "29:1801" : "29:1801 (29:1801 Farmworker Rights)",
      "29:2000" : "29:2000 (29:2000 Employee Polygraph Protection)",
      "29:2101" : "29:2101 (29:2101 Worker Adjustment/Retraining Notification Act)",
      "29:2601" : "29:2601 (29:2601 Family Medical Leave Act)",
      "29:2611" : "29:2611 (29:2611 Family Medical Leave Act)",
      "29:790" : "29:790 (29:790 Rehabilitation of Labor)",
      "30:0181" : "30:0181 (30:181 Environment: Review of Agency Action)",
      "30:0801" : "30:0801 (30:0801 Penalities/Federal Mine Safety Health Act - 1977)",
      "30:1201" : "30:1201 (30:1201 Environment: Review of Agency Action)",
      "30:1202" : "30:1202 (30:1202 Mining Reclamation Act)",
      "30:1276" : "30:1276 (30:1276 Interior: Review of Agency Action)",
      "31:3545" : "31:3545 (31:3545 Action to Recovery Money)",
      "31:3729" : "31:3729 (31:3729 False Claims Act)",
      "31:3730" : "31:3730 (31:3730 Qui Tam False Claims Act)",
      "31:3731" : "31:3731 (31:3731 Fraud)",
      "33:0415" : "33:0415 (33:0415 Barge Removal/Costs)",
      "33:1251" : "33:1251 (33:1251 Clean Water Act)",
      "33:1319cw" : "33:1319cw (33:1319 Clean Water Act)",
      "33:1319pv" : "33:1319pv (33:1319 Pollutants & Permit Violations)",
      "33:1365" : "33:1365 (33:1365 Environmental Matters)",
      "35:0101" : "35:0101 (35:0101 Patent Infringement)",
      "35:0145" : "35:0145 (35:145 Patent Infringement)",
      "35:0183" : "35:0183 (35:183 Patent Infringement)",
      "35:0271" : "35:0271 (35:271 Patent Infringement)",
      "35:0511" : "35:0511 (35:0511 Veteran's Benefits)",
      "38:1681" : "38:1681 (38:1681 Recovery of VA Overpayment)",
      "38:1686" : "38:1686 (38:1686 Recovery of VA Overpayment)",
      "38:1780" : "38:1780 (38:1780 Recovery of VA Overpayment)",
      "38:2011" : "38:2011 (38:2011 - Veteran's Readjustment Assistance Act of 1974)",
      "38:3116" : "38:3116 (38:3116 VA Overpayment)",
      "38:4301" : "38:4301 (38:4301 Uniform Services Employment and Reemployment Rights)",
      "39:3005" : "39:3005 (39:3005 Detention of Mail for Temporary Periods)",
      "39:409" : "39:409 (39:409 Postal Service)",
      "40:0258" : "40:0258 (40:258(a) Public Buildings & Property: Land Condemnation)",
      "40:0270" : "40:0270 (40:270 Miller Act)",
      "40:0875" : "40:0875 (40:875 Public Buildings & Property: Negligence)",
      "41:0251" : "41:0251 (41:251 Public Contracts-Review of Agency Action)",
      "41:1463" : "41:1463 (41:1463 Public Contracts: Unlawful Employment Practices)",
      "42:0205" : "42:0205 (42:205 Denial Social Security Benefits)",
      "42:0206" : "42:0206 (42:206 Social Security Benefits)",
      "42:0233" : "42:0233 (42:0233 Public Health & Welfare-Proceedings against Commissioned Officers or Employees)",
      "42:0247" : "42:0247 (42:247 Personal Injury-Swine Flu)",
      "42:0292" : "42:0292 (42:0292 Medical School Loans)",
      "42:0402" : "42:0402 (42:402 Social Security Benefits)",
      "42:0405id" : "42:0405id (42:405 Review of HHS Decision (SSID))",
      "42:0405si" : "42:0405si (42:0405 Review of HHS Decision (RSI))",
      "42:0405wc" : "42:0405wc (42:405 Review of HHS Decision (DIWC))",
      "42:0405ww" : "42:0405ww (42:405 Review of HHS Decision (DIWW))",
      "42:0416" : "42:0416 (42:416 Denial of Social Security Benefits)",
      "42:0427" : "42:0427 (42:427 Social Security Benefits)",
      "42:11112" : "42:11112 (42:11112 Standards for professional review actions)",
      "42:11601" : "42:11601 (42:11601 International Child Abduction Remedies Act)",
      "42:12101" : "42:12101 (42:12101 Americans with Disabilities Act)",
      "42:12117" : "42:12117 (42:12117 Americans with Disabilities Act)",
      "42:12131" : "42:12131 (42:12131 Americans with Disabilities Act)",
      "42:1320" : "42:1320 (42:1320 Health Insurance Portability & Accountability Act)",
      "42:1383" : "42:1383 (42:1383 Review of HHS Decision)",
      "42:1395" : "42:1395 (42:1395 HHS: Adverse Reimbursement Review)",
      "42:1395dd" : "42:1395dd (42:1395dd Examination and treatment for emergency medical conditions and women in labor)",
      "42:1396" : "42:1396 (42:1396 Medicaid)",
      "42:1396r-5" : "42:1396r-5 (42:1396r-5 - Treatment of income and resources for certain institutionalized spouses)",
      "42:13981" : "42:13981 (42:13981 Violence Against Women Act)",
      "42:1471" : "42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclosure Sale)",
      "42:15041" : "42:15041 (42:15041 Developmental Disabilities & Assistance Act)",
      "42:1973" : "42:1973 (42:1973 Denial of Voting Rights)",
      "42:1981cv" : "42:1981cv (42:1981 Civil Rights)",
      "42:1981hs" : "42:1981hs (42:1981 Housing Discrimination)",
      "42:1981jb" : "42:1981jb (42:1981 Job Discrimination (Race))",
      "42:1981sx" : "42:1981sx (42:1981 Sex Discrimination)",
      "42:1983cv" : "42:1983cv (42:1983 Civil Rights Act)",
      "42:1983ed" : "42:1983ed (42:1983 Civil Rights (Employment Discrimination))",
      "42:1983pr" : "42:1983pr (42:1983 Prisoner Civil Rights)",
      "42:1985" : "42:1985 (42:1985 Conspiracy to Interfere with Civil Rights)",
      "42:1986" : "42:1986 (42:1986 Neglect of Duty)",
      "42:1997" : "42:1997 (42:1997 Civil Rights of Institutionalized Persons Act)",
      "42:2000ag" : "42:2000ag (42:2000 Job Discrimination (Age))",
      "42:2000e" : "42:2000e (42:2000e Job Discrimination (Employment))",
      "42:2000pb" : "42:2000pb (42:2000 Job Discrimination (Public Accomodations))",
      "42:2000ra" : "42:2000ra (42:2000 Job Discrimination (Race))",
      "42:2000sx" : "42:2000sx (42:2000 Job Discrimination (Sex))",
      "42:2003" : "42:2003 (42:2003 Job Discrimination)",
      "42:2005" : "42:2005 (42:2005 Review of Agency Action-HHS)",
      "42:2651" : "42:2651 (42:2651 Medical Care Recovery)",
      "42:3601" : "42:3601 (42:3601 Fair Housing Act)",
      "42:3796" : "42:3796 (42:3796 Payment of death benefits-Public Health & Welfare)",
      "42:4000" : "42:4000 (42:4000 National Flood Insurance Act)",
      "42:4001" : "42:4001 (42:4001 National Insurance Flood Act)",
      "42:4053" : "42:4053 (42:4053 Breach of Insurance Contract)",
      "42:4072" : "42:4072 (42:4072 Payment of Flood Insurance Claim)",
      "42:4321" : "42:4321 (42:4321 Review of Agency Action-Environment)",
      "42:4332" : "42:4332 (42:4332 Environmental Policy - Coop of Agency Reports)",
      "42:6101" : "42:6101 (42:6101 Federal Age Discrimination Act)",
      "42:6901en" : "42:6901en (42:6901 Environmental Cleanup Expenses)",
      "42:6901rs" : "42:6901rs (42:6901 Resource & Recovery Act)",
      "42:6972" : "42:6972 (42:6972 Resource Conservation and Recovery Act)",
      "42:6991" : "42:6991 (42:6991 Resource Conservation and Recovery Act)",
      "42:7413" : "42:7413 (42:7413(b) Clean Air Act)",
      "42:7604cl" : "42:7604cl (42:7604 Clear Air Act (Emission Standards))",
      "42:7604ir" : "42:7604ir (42:7604 Petition to Quash IRS Summons)",
      "42:9607" : "42:9607 (42:9607 Real Property Tort to Land)",
      "42:9613" : "42:9613 (42:9613 Comprehensive Environmental/Liability Act)",
      "43:945" : "43:945 (43:945 Compensation for Land Condemnation)",
      "43:945a" : "43:945a (43:945a Complaint in Condemnation)",
      "43:946" : "43:946 (43:946 Complaint in Condemnation - Eminent Domain)",
      "45:0051" : "45:0051 (45:51 Railways: Fed. Employer's Liability Act)",
      "45:0151" : "45:0151 (45:151 Railway Labor Act)",
      "45:0184" : "45:0184 (45:184 Action to Set Aside Award of a System Board of Adjust)",
      "45:1395" : "45:1395 (45:1395 Railroads: Adverse Reimbursement Review)",
      "45:152" : "45:152 (45:152 Railway Labor Act)",
      "45:7457" : "45:7457 (45:7457 Compel Reclamation Under Clear Air Act)",
      "46:0181" : "46:0181 (Limitation of Vessel Owner's Liability Act)",
      "46:0688" : "46:0688 (46:688 Jones Act)",
      "46:0741" : "46:0741 (46:741 Shipping)",
      "46:0761" : "46:0761 (46:761 Shipping: Damages for Death on High Seas)",
      "46:1101" : "46:1101 (46:1101 Violation of Maritime Regulations)",
      "46:1156" : "46:1156 (46:1156 Administrative Procedure Act)",
      "46:30501" : "46:30501 (46:30501 Exoneration and Limitation of Liability (Maritime))",
      "46:31301" : "46:31301 (46:31301 Commercial Instruments & Maritime Liens Act)",
      "47:0151" : "47:0151 (47:0151 Federal Communications Act)",
      "47:0230" : "47:0230 (47:0230 Communications Decency Act)",
      "47:0252" : "47:0252 (47:0252 Federal Telecommunications Act of 1996)",
      "47:0332" : "47:0332 (47:0332 Federal Telecommunications Act of 1996)",
      "47:0553" : "47:0553 (47:0553 Communications Act of 1934)",
      "47:0605" : "47:0605 (47:0605 Electronic Communications Privacy Act)",
      "47:227" : "47:227 (47:227 Restrictions on use of telephone equipment)",
      "47:504" : "47:504 (47:504 Telegraphs, Telephones, and Radiotelegraphs-Forfeitures)",
      "48:0883" : "48:0883 (48:883 Violation of US Coastal Law)",
      "48:1985" : "48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)",
      "49:0081" : "49:0081 (49:81 Damaged Goods While Being Transported)",
      "49:043" : "49:043 (49:043 Federal Railroad Safety Act)",
      "49:0781" : "49:0781 (49:781 Forfeiture)",
      "49:10101" : "49:10101 (49:10101 Interstate Commerce Act)",
      "49:11503" : "49:11503 (49:11503 Railroad Revitalization Regulatory Reform Act)",
      "49:11702" : "49:11702 (49:11702(a)(4) Violations of Interstate Commerce Act)",
      "49:13702" : "49:13702 (49:13702 Interstate Commerce Act)",
      "49:14501" : "49:14501 (49:14501 Motor Carriers)",
      "49:14704" : "49:14704 (49:14704 Interstate Transportation/Motor Carriers)",
      "49:14706" : "49:14706 (49:14706 The Carmack Amendment)",
      "49:1471" : "49:1471 (49:1471 Federal Aviation Act)",
      "49:1903" : "49:1903 (49:1903 Petition to enforce administrative summons)",
      "49:32701" : "49:32701 (49:32701 Odometer Act)",
      "49:40105" : "49:40105 (49:40105 Unification of Certain Rules Relating to Intl Transp by Air)",
      "49:46301" : "49:46301 (49:46301 F.A.A. Civil Penalty)",
      "49:47107" : "49:47107 (Project Grant Application Approval Conditioned on Assurances About Airport Operations)",
      "8:287" : "8:287 (8:287 Petition to Enforce INS Subpoena)",
      "misc" : "misc (Civil Miscellaneous Case)"
   },
   "tnwdce" : {
      "*41*" : "*41* ( )",
      "0" : "0 (No cause code entered)",
      "00:0000" : "00:0000 (00:0000 Cause Code Unknown)",
      "02:0431" : "02:0431 (02:431 Fed. Election Commission: Failure Enforce C)",
      "02:0437" : "02:0437 (02:437 Federal Election Commission)",
      "05:0075" : "05:0075 (05:75(2) Contract - Reduction in Grade)",
      "05:0551" : "05:0551 (05:551 Administrative Procedure Act)",
      "05:0552fi" : "05:0552fi (05:552 Freedom of Information Act)",
      "05:0552pa" : "05:0552pa (05:552 Right to Privacy Act)",
      "05:0554" : "05:0554 (05:0554 Constitutionality of Maritime Statutes)",
      "05:0701" : "05:0701 (05:0701 Maritime Subsidy Board)",
      "05:0702" : "05:0702 (05:702 Administrative Procedure Act)",
      "05:0704" : "05:0704 (05:704 Labor Litigation)",
      "05:7703" : "05:7703 (05:7703 Discrimination - Review of Agency Act)",
      "07:0006" : "07:0006 (7:6(b) Federal Commodity Exchange Regulation)",
      "07:0025" : "07:0025 (7:25 Fraud - Commodities Leverage Contracts)",
      "07:0181" : "07:0181 (07:181 Packers & Stockyard Act)",
      "07:0499" : "07:0499 (07:499 Agricultural Commodities Act)",
      "07:0601" : "07:0601 (07:601 USDA Condemnation)",
      "07:2321" : "07:2321 (07:2321 Plant Variety Protection Act)",
      "08:1105" : "08:1105 (8:1105(a) Aliens: Habeas Corpus to Release INS Det)",
      "08:1252" : "08:1252 (08:1252(a)(2) Injunction for Deportation)",
      "08:1260" : "08:1260 (08:1260 Aliens: Access to Records)",
      "08:1324" : "08:1324 (08:1324 Aliens: Complaint for Forfeiture)",
      "08:1329" : "08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petiti)",
      "08:1446" : "08:1446 (8:1446 Petition for Naturalization Hearing)",
      "09:0001" : "09:0001 (09:1 U.S. Arbitration Act)",
      "09:0009" : "09:0009 (9:9 Motion to Confirm Arbitration Loan)",
      "09:0010" : "09:0010 (09:0010 Petition to Vacate Arbitration Award)",
      "10:1552" : "10:1552 (10:1552 Armed Forces: Action to Correct Records)",
      "10:1553" : "10:1553 (10:1553 Armed Forces: FOIA General)",
      "10:2305" : "10:2305 (10:2305 Review of Federal Contract)",
      "11:0101" : "11:0101 (11:101 Bankruptcy)",
      "12:0022" : "12:0022 (12:22 Securities Fraud)",
      "12:0635" : "12:0635 (12:635 Breach of Insurance Contract)",
      "12:1461" : "12:1461 (12:1461 Homeowners Loan Act)",
      "12:1703" : "12:1703 (12:1703 Default of HUD Loan)",
      "12:1725" : "12:1725 (12:1725 Collection under Contract Guaranty)",
      "12:1730" : "12:1730 (12:1730 Collection Under Contract Guaranty)",
      "12:1819" : "12:1819 (12:1819 Default of Promissory Note)",
      "12:1821" : "12:1821 (12:1821 Default of Loan by Promissary Note)",
      "12:1971" : "12:1971 (12:1971 Relief under Bank Holding Act)",
      "12:3410" : "12:3410 (12:3410 Right to Financial Privacy Act)",
      "15:0001" : "15:0001 (15:1 Antitrust Litigation)",
      "15:0002at" : "15:0002at (15:2 Antitrust Litigation)",
      "15:0002fl" : "15:0002fl (15:2(a) Fair Labor Standards Act)",
      "15:0005" : "15:0005 (15:5(a) Fair Labor Standards Act)",
      "15:0015" : "15:0015 (15:15 Antitrust Litigation)",
      "15:0025" : "15:0025 (15:25 Clayton Act)",
      "15:0044" : "15:0044 (15:44 Trademark Infringement)",
      "15:0045" : "15:0045 (15:0045 Federal Trade Commission Act)",
      "15:0052" : "15:0052 (15:0052 Federal Trade Commission Act)",
      "15:0053" : "15:0053 (15:0053 Federal Trade Commission Act)",
      "15:0077" : "15:0077 (15:77 Securities Fraud)",
      "15:0078" : "15:0078 (15:78m(a) Securities Exchange Act)",
      "15:0631" : "15:0631 (15:631 Small Business Act)",
      "15:0717" : "15:0717 (15:717 Natural Gas Act)",
      "15:1051" : "15:1051 (15:1051 Trademark Infringement)",
      "15:1114" : "15:1114 (15:1114 Trademark Infringement)",
      "15:1121" : "15:1121 (15:1121 Trademark Infringement)",
      "15:1125" : "15:1125 (15:1125 Trademark Infringement (Lanham Act))",
      "15:1126" : "15:1126 (15:1126 Patent Infringement)",
      "15:1127" : "15:1127 (15:1127 Trademark Infringement)",
      "15:1601" : "15:1601 (15:1601 Truth in Lending)",
      "15:1640" : "15:1640 (15:1640 Truth in Lending)",
      "15:1681" : "15:1681 (15:1681 Fair Credit Reporting Act)",
      "15:1692" : "15:1692 (15:1692 Fair Debt Collection Act)",
      "15:1938" : "15:1938 (15:1938 Fair Labor Standards Act)",
      "15:1981" : "15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))",
      "15:1988" : "15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))",
      "15:1989" : "15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))",
      "15:2301" : "15:2301 (15:2301 Magnuson-Moss Warranty Act)",
      "15:2801" : "15:2801 (15:2801 Petroleum Marketing Practices Act)",
      "15:53(b)" : "15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equita)",
      "16:0668" : "16:0668 (16:668 Bald Eagle Protection Act)",
      "16:0703" : "16:0703 (16:703 Migratory Bird Act)",
      "16:1538" : "16:1538 (16:1538 Endangered Species Act)",
      "16:3371" : "16:3371 (16:3371 Wildlife Under the Lacey Act)",
      "16:3372" : "16:3372 (16:3372 Conservation: Complaint for Forfeiture)",
      "16:3373" : "16:3373 (16:3373 Appeal of Decision - DOI)",
      "16:3374" : "16:3374 (16:3374 Conservation: Complaint for Forfeiture)",
      "17:0101" : "17:0101 (17:101 Copyright Infringement)",
      "17:0501" : "17:0501 (17:501 Copyright Infringement)",
      "17:0504" : "17:0504 (17:504 Copyright Infringement)",
      "18:0241" : "18:0241 (18:241 Conspiracy Against Citizen Rights)",
      "18:1836a" : "18:1836a (18:1836(a) Injunction against Misappropriation of Trade Secrets)",
      "18:1836b" : "18:1836b (18:1836(b) Civil Action to Protect Trade Secrets)",
      "18:1961" : "18:1961 (18:1961 Racketeering (RICO) Act)",
      "18:1962" : "18:1962 (18:1962 Racketeering (RICO) Act)",
      "18:1964" : "18:1964 (18:1964 Racketeering (RICO) Act)",
      "18:4208" : "18:4208 (18:4208(B) Agency Action Review)",
      "19:1305" : "19:1305 (19:1305 Custom Duties:0Forfeiture-Immoral Articles)",
      "20:1080" : "20:1080 (20:1080 Student Loan Recovery)",
      "20:1400" : "20:1400 (20:1400 Civil Rights of Handicapped Child)",
      "20:1401" : "20:1401 (20:1401 Education: Handicapped Child Act)",
      "21:0841" : "21:0841 (21:841 Forfeiture Property-Drugs)",
      "21:0881" : "21:0881 (21:881 Forfeiture Property-Drugs)",
      "21:0881a" : "21:0881a (21:881 Forfeiture Property - Aircraft)",
      "21:0881re" : "21:0881re (21:881 Forfeiture Property - Real Estate)",
      "23:0134" : "23:0134 (23:134 P.I.- Auto Negligence)",
      "23:1441" : "23:1441 (23:1441 Contract Real Estate)",
      "24:1000" : "24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)",
      "25:0640" : "25:0640 (25:640 Indian Tribal Rights)",
      "25:1901" : "25:1901 (25:1901 Indian Child Welfare Act)",
      "26:6212" : "26:6212 (26:6212 Injunctive Relief from IRS Lien)",
      "26:6213" : "26:6213 (26:6213 Injunctive Relief from IRS Lien)",
      "26:6502" : "26:6502 (26:6502 IRS:Enforcement of tax liens)",
      "26:6532" : "26:6532 (26:6532 IRS: Refund of Tax Penalty)",
      "26:6702" : "26:6702 (26:6702 IRS: Refund of Income Tax Penalty)",
      "26:6703" : "26:6703 (26:6703 IRS: Refund of Tax Penalty)",
      "26:7401" : "26:7401 (26:7401 IRS: Tax Liability)",
      "26:7402" : "26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)",
      "26:7403" : "26:7403 (26:7403 Suit to Enforce Federal Tax Lien)",
      "26:7422rt" : "26:7422rt (26:7422 IRS: Refund Taxes)",
      "26:7422rx" : "26:7422rx (26:7422 IRS: Refund Excise Tax)",
      "26:7426" : "26:7426 (26:7426 IRS: Wrongful Levy for Taxes)",
      "26:7429" : "26:7429 (26:7429 IRS: Tax Jeopardy Assessment)",
      "26:7609" : "26:7609 (26:7609 IRS: Petition to Quash IRS Summons)",
      "27:0185" : "27:0185 (27:185 Enforcement of Arbitration Award)",
      "28:0157c" : "28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)",
      "28:0157d" : "28:0157d (28:0157 Motion for Withdrawal of Reference)",
      "28:0158" : "28:0158 (28:0158 Notice of Appeal re Bankruptcy Matter (BA)",
      "28:0185" : "28:0185 (28:185 Suit to Compel Arbitration)",
      "28:0451" : "28:0451 (28:451 Employment Discrimination)",
      "28:0794" : "28:0794 (28:794 Rehabilitation Act)",
      "28:1001" : "28:1001 (28:1001 E.R.I.S.A.)",
      "28:1132" : "28:1132 (28:1132 E.R.I.S.A.)",
      "28:1330" : "28:1330 (28:1330 Breach of Contract)",
      "28:1331" : "28:1331 (28:1331 Fed. Question)",
      "28:1331al" : "28:1331al (28:1331 Fed. Question: Airline Crash)",
      "28:1331at" : "28:1331at (28:1331 Fed. Question: Anti-trust)",
      "28:1331au" : "28:1331au (28:1331 Fed. Question: Auto Negligence)",
      "28:1331b" : "28:1331b (28:1331 Federal Question: Bivens Act)",
      "28:1331bc" : "28:1331bc (28:1331 Fed. Question: Breach of Contract)",
      "28:1331ca" : "28:1331ca (28:1331 Fed Question: Fed Communications Act of 1)",
      "28:1331cm" : "28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)",
      "28:1331cv" : "28:1331cv (28:1331 Federal Question: Other Civil Rights)",
      "28:1331ed" : "28:1331ed (28:1331 Fed. Question: Employment Discrimination)",
      "28:1331es" : "28:1331es (28:1331 Enforcement of Administrative Subpoena)",
      "28:1331fl" : "28:1331fl (28:1331 Fed. Question: Fair Labor Standards)",
      "28:1331in" : "28:1331in (28:1331 Fed. Question: Insurance Contract)",
      "28:1331mm" : "28:1331mm (28:1331 Fed. Question: Medical Malpractice)",
      "28:1331pi" : "28:1331pi (28:1331 Fed. Question: Personal Injury)",
      "28:1331rd" : "28:1331rd (28:1331 Fed. Question: Review Agency Decision)",
      "28:1331rp" : "28:1331rp (28:1331(a) Fed. Question: Real Property)",
      "28:1331rr" : "28:1331rr (28:1331 Fed. Question: Railway Labor Act)",
      "28:1331sv" : "28:1331sv (28:1331 Fed. Question: Securities Violation)",
      "28:1331tr" : "28:1331tr (28:1331 Fed. Question: Trademark)",
      "28:1331tt" : "28:1331tt (28:1331 Fed. Question: Tort Action)",
      "28:1331v" : "28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendme)",
      "28:1331wl" : "28:1331wl (28:1331 Federal Question: EPA Waste Lien)",
      "28:1331wt" : "28:1331wt (28:1331 Fed. Question: Water Rights)",
      "28:1332ac" : "28:1332ac (28:1332 Diversity-Account Receivable)",
      "28:1332al" : "28:1332al (28:1332 Diversity-Airline Crash)",
      "28:1332as" : "28:1332as (28:1332 Diversity-Asbestos Litigation)",
      "28:1332au" : "28:1332au (28:1332 Diversity-Auto Negligence)",
      "28:1332bc" : "28:1332bc (28:1332 Diversity-Breach of Contract)",
      "28:1332co" : "28:1332co (28:1332 Diversity-Conversion)",
      "28:1332ct" : "28:1332ct (28:1332 Diversity-(Citizenship))",
      "28:1332det" : "28:1332det (28:1332 Diversity: Forcible Detainer)",
      "28:1332df" : "28:1332df (28:1332 Diversity-Contract Default)",
      "28:1332ds" : "28:1332ds (28:1332 Diversity-Contract Dispute)",
      "28:1332ed" : "28:1332ed (28:1332 Diversity-Employment Discrimination)",
      "28:1332fd" : "28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)",
      "28:1332fr" : "28:1332fr (28:1332 Diversity-Fraud)",
      "28:1332ia" : "28:1332ia (28:1332 Diversity-Interpleader Action)",
      "28:1332ij" : "28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)",
      "28:1332in" : "28:1332in (28:1332 Diversity-Insurance Contract)",
      "28:1332jd" : "28:1332jd (28:1332 Diversity-Declaratory Judgement)",
      "28:1332lb" : "28:1332lb (28:1332 Diversity-Libel,Assault,Slander)",
      "28:1332lm" : "28:1332lm (28:1332 Diversity - Legal Malpractice)",
      "28:1332ma" : "28:1332ma (28:1332 Diversity-Miller Act)",
      "28:1332mm" : "28:1332mm (28:1332 Diversity-Medical Malpractice)",
      "28:1332mv" : "28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)",
      "28:1332ni" : "28:1332ni (28:1332 Diversity-Negotiable Instrument)",
      "28:1332nm" : "28:1332nm (28:1332 Diversity-Non-Motor Vehicle)",
      "28:1332oc" : "28:1332oc (28:1332 Diversity-Other Contract)",
      "28:1332pd" : "28:1332pd (28:1332 Diversity-Property Damage)",
      "28:1332pi" : "28:1332pi (28:1332 Diversity-Personal Injury)",
      "28:1332pl" : "28:1332pl (28:1332 Diversity-Product Liability)",
      "28:1332pr" : "28:1332pr (28:1332 Diversity-Petition for Removal)",
      "28:1332qt" : "28:1332qt (28:1332 Diversity-Petition to Quiet Title)",
      "28:1332ri" : "28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)",
      "28:1332sa" : "28:1332sa (28:1332 - Diversity: Securities & Exchange Commiss)",
      "28:1332sf" : "28:1332sf (28:1332 - Diversity: Securities Fraud)",
      "28:1332ss" : "28:1332ss (28:1332 Diversity - Stockholders Suits)",
      "28:1332tl" : "28:1332tl (28:1332 Diversity-Torts to Land)",
      "28:1332tm" : "28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))",
      "28:1332tn" : "28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)",
      "28:1332wd" : "28:1332wd (28:1332 Diversity-Wrongful Death)",
      "28:1333" : "28:1333 (28:1333 Admiralty)",
      "28:1334" : "28:1334 (28:1334 Bankruptcy Appeal)",
      "28:1334c" : "28:1334c (28:1334(c) R&R re motions for abstention (non-cor)",
      "28:1335" : "28:1335 (28:1335 Interpleader Action)",
      "28:1337" : "28:1337 (28:1337 Sherman-Clayton Act)",
      "28:1338cp" : "28:1338cp (28:1338 Copyright Infringement)",
      "28:1338pt" : "28:1338pt (28:1338 Patent Infringement)",
      "28:1338tr" : "28:1338tr (28:1338 Trademark Infringement)",
      "28:1340" : "28:1340 (28:1340 IRS: Custom Duties)",
      "28:1340er" : "28:1340er (28:1340 Recovery of Erroneous Refund)",
      "28:1341" : "28:1341 (28:1341 Complaint for Forfeiture)",
      "28:1343" : "28:1343 (28:1343 Violation of Civil Rights)",
      "28:1345co" : "28:1345co (28:1345 Replevin & Conversion)",
      "28:1345db" : "28:1345db (28:1345 Debt to US - FHA/HUD Title I)",
      "28:1345df" : "28:1345df (28:1345 Default of Promissory Note)",
      "28:1345er" : "28:1345er (28:1345 Recovery of Erroneous Refund)",
      "28:1345fc" : "28:1345fc (28:1345 Foreclosure)",
      "28:1345ff" : "28:1345ff (28:1345 Complaint for Forfeiture)",
      "28:1345hl" : "28:1345hl (28:1345 VA Home Loan Guaranty Debt)",
      "28:1345mc" : "28:1345mc (28:1345 Medical Care Recovery)",
      "28:1345mi" : "28:1345mi (28:1345 Mining Claim Ejectment)",
      "28:1345pd" : "28:1345pd (28:1345 Property Damage)",
      "28:1345pe" : "28:1345pe (28:1345 Property Ejectment)",
      "28:1345rc" : "28:1345rc (28:1345 Recovery of Debt to US)",
      "28:1345st" : "28:1345st (28:1345 Default of Student Loan)",
      "28:1345tp" : "28:1345tp (28:1345 Trespass on Public Land)",
      "28:1345va" : "28:1345va (28:1345 Recovery of VA Overpayment)",
      "28:1346bc" : "28:1346bc (28:1346 Breach of Contract)",
      "28:1346rc" : "28:1346rc (28:1346 Recovery of IRS Tax)",
      "28:1346tc" : "28:1346tc (28:1346 Tort Claim)",
      "28:1346wd" : "28:1346wd (28:1346 Wrongful Death)",
      "28:1352" : "28:1352 (28:1352 Miller Act)",
      "28:1355" : "28:1355 (28:1355 Petition for Return of Property)",
      "28:1358" : "28:1358 (28:1358 Land Condemnation)",
      "28:1361" : "28:1361 (28:1361 Petition for Writ of Mandamus)",
      "28:1362ic" : "28:1362ic (28:1362 Indian Tribal Controversy)",
      "28:1362iw" : "28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)",
      "28:1364" : "28:1364 (28:1364 Auto Negligence)",
      "28:1391" : "28:1391 (28:1391 Personal Injury)",
      "28:1402" : "28:1402 (28:1402 Medical Malpractice)",
      "28:1407" : "28:1407 (28:1407 Airline Crash)",
      "28:1441ac" : "28:1441ac (28:1441 Petition for Removal- Account Receivable)",
      "28:1441al" : "28:1441al (28:1441 Petition for Removal- Airline Crash)",
      "28:1441as" : "28:1441as (28:1441 Petition for Removal- Asbestos Litigation)",
      "28:1441au" : "28:1441au (28:1441 Petition for Removal- Auto Negligence)",
      "28:1441bc" : "28:1441bc (28:1441 Petition for Removal- Breach of Contract)",
      "28:1441cv" : "28:1441cv (28:1441 Petition for Removal- Civil Rights Act)",
      "28:1441df" : "28:1441df (28:1441 Petition for Removal- Contract Default)",
      "28:1441dj" : "28:1441dj (28:1441 Petition for Removal- Declaratory Judgemen)",
      "28:1441ds" : "28:1441ds (28:1441 Petition for Removal- Contract Dispute)",
      "28:1441ed" : "28:1441ed (28:1441 Petition for Removal - Employment Discrim)",
      "28:1441fc" : "28:1441fc (28:1441 Petition for Removal - Fair Credit Reporti)",
      "28:1441fr" : "28:1441fr (28:1441 Petition for Removal- Fraud)",
      "28:1441ij" : "28:1441ij (28:1441 Petition for Removal- Injunctive/Declarato)",
      "28:1441in" : "28:1441in (28:1441 Petition for Removal- Insurance Contract)",
      "28:1441int" : "28:1441int (28:1441 Petition for Removal- Action for Interplea)",
      "28:1441lb" : "28:1441lb (28:1441 Petition for Removal Libel,Assault,Slander)",
      "28:1441lm" : "28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relatio)",
      "28:1441mm" : "28:1441mm (28:1441 Petition for Removal- Medical Malpractice)",
      "28:1441ni" : "28:1441ni (28:1441 Petition for Removal- Negotiable Instrumen)",
      "28:1441nm" : "28:1441nm (28:1441 Petition for Removal- Non-Motor Vehicle)",
      "28:1441oc" : "28:1441oc (28:1441 Petition For Removal--Other Contract)",
      "28:1441pd" : "28:1441pd (28:1441 Petition for Removal- Property Damage)",
      "28:1441pi" : "28:1441pi (28:1441 Petition for Removal- Personal Injury)",
      "28:1441pl" : "28:1441pl (28:1441 Petition for Removal- Product Liability)",
      "28:1441pr" : "28:1441pr (28:1441 Petition for Removal)",
      "28:1441qt" : "28:1441qt (28:1441 Petition for Removal- Petition to Quiet Ti)",
      "28:1441ri" : "28:1441ri (28:1441 Petition for Removal- Racketeering (RICO))",
      "28:1441sa" : "28:1441sa (28:1441 - Petition for Removal: SEC Act)",
      "28:1441sf" : "28:1441sf (28:1441 - Petition for Removal: Securities Fraud)",
      "28:1441tl" : "28:1441tl (28:1441 Petition for Removal- Torts to Land)",
      "28:1441tm" : "28:1441tm (28:1441 Petition for Removal- Tort/Motor Vehicle ()",
      "28:1441tn" : "28:1441tn (28:1441 Petition for Removal- Tort/Non-Motor Vehic)",
      "28:1441wd" : "28:1441wd (28:1441 Petition for Removal- Wrongful Death)",
      "28:1442bc" : "28:1442bc (28:1442 Petition for Removal- Breach of Contract)",
      "28:1442pr" : "28:1442pr (28:1442 Petition for Removal)",
      "28:1443" : "28:1443 (28:1443(1) Rent, Lease & Ejectment)",
      "28:1444" : "28:1444 (28:1444 Petition for Removal- Foreclosure)",
      "28:1446in" : "28:1446in (28:1446 Breach of Contract- Insurance)",
      "28:1446pd" : "28:1446pd (28:1446 Petition for Removal- Property Damage (P.I)",
      "28:1446pi" : "28:1446pi (28:1446 Petition for Removal- Personal Injury)",
      "28:1446pl" : "28:1446pl (28:1446pl Petition for Removal - Product Liability)",
      "28:1446pr" : "28:1446pr (28:1446 Petition for Removal)",
      "28:1452" : "28:1452 (28:1452 R&R re motions to remand (non-core))",
      "28:1651" : "28:1651 (28:1651 Petition for Writ of Coram Nobis)",
      "28:1651hc" : "28:1651hc (28:1651 Petition for Writ of Habeas Corpus)",
      "28:1651mn" : "28:1651mn (28:1651 Petition for Writ of Mandamus)",
      "28:1983" : "28:1983 (28:1983 Civil Rights)",
      "28:2201" : "28:2201 (28:2201 Constitutionality of State Statute(s))",
      "28:2201dj" : "28:2201dj (28:2201 Declaratory Judgement)",
      "28:2201ij" : "28:2201ij (28:2201 Injunction)",
      "28:2201in" : "28:2201in (28:2201 Declaratory Judgement (Insurance))",
      "28:2241" : "28:2241 (28:2241 Petition for Writ of Habeas Corpus (federa)",
      "28:2254" : "28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))",
      "28:2254se" : "28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)",
      "28:2255" : "28:2255 (28:2255 Motion to Vacate / Correct Illegal Sentenc)",
      "28:2271" : "28:2271 (28:2271 Federal Tort Claims Act)",
      "28:2345" : "28:2345 (28:2345 Medicare Recovery)",
      "28:2409" : "28:2409 (28:2409(a) Quiet Title Action)",
      "28:2410" : "28:2410 (28:2410 Quiet Title)",
      "28:2671" : "28:2671 (28:2671 Federal Tort Claims Act)",
      "28:2674" : "28:2674 (28:2674 Federal Tort Claims Act)",
      "28:7402" : "28:7402 (28:7402 Refund of Taxes)",
      "28:7422" : "28:7422 (28:7422 Appeal from Administrative Decision)",
      "29:0151" : "29:0151 (29:151 Labor: Review of Agency Action)",
      "29:0160" : "29:0160 (29:160(1) National Labor Relations Act)",
      "29:0184" : "29:0184 (29:184 Violation Collection Bargain Agreement)",
      "29:0185ep" : "29:0185ep (29:185 Employee Pension Plan)",
      "29:0185lm" : "29:0185lm (29:185 Labor/Mgt. Relations (Contracts))",
      "29:0201do" : "29:0201do (29:201 Denial of Overtime Compensation)",
      "29:0201fl" : "29:0201fl (29:201 Fair Labor Standards Act)",
      "29:0203" : "29:0203 (29:203 Equal Pay Act)",
      "29:0206" : "29:0206 (29:206 Collect Unpaid Wages)",
      "29:0401" : "29:0401 (29:0401 Labor Management Disclosure Act)",
      "29:0621" : "29:0621 (29:621 Job Discrimination (Age))",
      "29:0623" : "29:0623 (29:623 Job Discrimination (Age))",
      "29:0626" : "29:0626 (29:626 Job Discrimination (Age))",
      "29:0633" : "29:0633 (29:633 Job Discrimination (Age))",
      "29:0651" : "29:0651 (29:651 Occupational Safety/Health)",
      "29:0754" : "29:0754 (29:754 Discrimination)",
      "29:0791" : "29:0791 (29:791 Job Discrimination (Rehabilitation Act))",
      "29:0794" : "29:0794 (29:0794 Job Discrimination (Handicap))",
      "29:1001" : "29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)",
      "29:1002" : "29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)",
      "29:1104" : "29:1104 (29:1104 Recovery of Benefits to Employee)",
      "29:1109" : "29:1109 (29:1109 Breach of Fiduciary Duties)",
      "29:1131" : "29:1131 (29:1131 ERISA - Collection of Delinquent Trust Fun)",
      "29:1132" : "29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)",
      "29:1145" : "29:1145 (29:1145 E.R.I.S.A.)",
      "29:1149" : "29:1149 (29:1149 Recover Pension & Profit Sharing)",
      "29:1337" : "29:1337 (29:1337 E.R.I.S.A.)",
      "29:1362" : "29:1362 (29:1362 ERISA)",
      "29:1381" : "29:1381 (29:1381 E.R.I.S.A.)",
      "29:1401" : "29:1401 (29:1401(b)(2) Appeal of Arbitration Award)",
      "29:1451" : "29:1451 (29:1451 E.R.I.S.A.)",
      "29:1801" : "29:1801 (29:1801 Farmworker Rights)",
      "29:2615a" : "29:2615a (29:2615a Family Medical Leave Act)",
      "29:790" : "29:790 (29:790 Rehabilitation of Labor)",
      "30:0181" : "30:0181 (30:181 Environment: Review of Agency Action)",
      "30:0801" : "30:0801 (30:0801 Penalities/Federal Mine Safety Health Act)",
      "30:1201" : "30:1201 (30:1201 Environment: Review of Agency Action)",
      "30:1202" : "30:1202 (30:1202 Mining Reclamation Act)",
      "30:1276" : "30:1276 (30:1276 Interior: Review of Agency Action)",
      "31:3545" : "31:3545 (31:3545 Action to Recovery Money)",
      "31:3729" : "31:3729 (31:3729 False Claims Act)",
      "31:3730" : "31:3730 (31:3730 Qui Tam False Claims Act)",
      "31:3731" : "31:3731 (31:3731 Fraud)",
      "33:1319cw" : "33:1319cw (33:1319 Clean Water Act)",
      "33:1319pv" : "33:1319pv (33:1319 Pollutants & Permit Violations)",
      "33:1365" : "33:1365 (33:1365 Environmental Matters)",
      "35:0145" : "35:0145 (35:145 Patent Infringement)",
      "35:0183" : "35:0183 (35:183 Patent Infringement)",
      "35:0271" : "35:0271 (35:271 Patent Infringement)",
      "38:1681" : "38:1681 (38:1681 Recovery of VA Overpayment)",
      "38:1686" : "38:1686 (38:1686 Recovery of VA Overpayment)",
      "38:1780" : "38:1780 (38:1780 Recovery of VA Overpayment)",
      "38:2011" : "38:2011 (38:2011 - Veteran's Readjustment Assistance Act of)",
      "38:3116" : "38:3116 (38:3116 VA Overpayment)",
      "38:775" : "38:775 (Recovery of Servicemen's Group Life Insurance)",
      "39:3005" : "39:3005 (39:3005 Detention of Mail for Temporary Periods)",
      "39:409" : "39:409 (39:409 Postal Service)",
      "40:0258" : "40:0258 (40:258(a) Public Buildings & Property: Land Condem)",
      "40:0270" : "40:0270 (40:270 Miller Act)",
      "40:0875" : "40:0875 (40:875 Public Buildings & Property: Negligence)",
      "41:0251" : "41:0251 (41:251 Public Contracts-Review of Agency Action)",
      "41:1463" : "41:1463 (41:1463 Public Contracts: Unlawful Employment Prac)",
      "42:0205" : "42:0205 (42:205 Denial Social Security Benefits)",
      "42:0206" : "42:0206 (42:206 Social Security Benefits)",
      "42:0247" : "42:0247 (42:247 Personal Injury-Swine Flu)",
      "42:0402" : "42:0402 (42:402 Social Security Benefits)",
      "42:0405id" : "42:0405id (42:405 Review of HHS Decision (SSID))",
      "42:0405wc" : "42:0405wc (42:405 Review of HHS Decision (DIWC))",
      "42:0405ww" : "42:0405ww (42:405 Review of HHS Decision (DIWW))",
      "42:0416" : "42:0416 (42:416 Denial of Social Security Benefits)",
      "42:0427" : "42:0427 (42:427 Social Security Benefits)",
      "42:1383" : "42:1383 (42:1383 Review of HHS Decision)",
      "42:1395" : "42:1395 (42:1395 HHS: Adverse Reimbursement Review)",
      "42:1396" : "42:1396 (42:1396 - Tort Negligence)",
      "42:1471" : "42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclo)",
      "42:1981cv" : "42:1981cv (42:1981 Civil Rights)",
      "42:1981hs" : "42:1981hs (42:1981 Housing Discrimination)",
      "42:1981jb" : "42:1981jb (42:1981 Job Discrimination (Race))",
      "42:1981sx" : "42:1981sx (42:1981 Sex Discrimination)",
      "42:1983cv" : "42:1983cv (42:1983 Civil Rights Act)",
      "42:1983ed" : "42:1983ed (42:1983 Civil Rights (Employment Discrimination))",
      "42:1983pr" : "42:1983pr (42:1983 Prisoner Civil Rights)",
      "42:1986" : "42:1986 (42:1986 Neglect of Duty)",
      "42:2000ag" : "42:2000ag (42:2000 Job Discrimination (Age))",
      "42:2000e" : "42:2000e (42:2000e Job Discrimination (Employment))",
      "42:2000pb" : "42:2000pb (42:2000 Job Discrimination (Public Accomodations))",
      "42:2000ra" : "42:2000ra (42:2000 Job Discrimination (Race))",
      "42:2000sx" : "42:2000sx (42:2000 Job Discrimination (Sex))",
      "42:2003" : "42:2003 (42:2003 Job Discrimination)",
      "42:2005" : "42:2005 (42:2005 Review of Agency Action-HHS)",
      "42:2651" : "42:2651 (42:2651 Medical Care Recovery)",
      "42:3601" : "42:3601 (42:405 Fair Housing Act)",
      "42:4000" : "42:4000 (42:4000 National Flood Insurance Act)",
      "42:4001" : "42:4001 (42:4001 National Insurance Flood Act)",
      "42:4053" : "42:4053 (42:4053 Breach of Insurance Contract)",
      "42:4072" : "42:4072 (42:4072 Payment of Flood Insurance Claim)",
      "42:4321" : "42:4321 (42:4321 Review of Agency Action-Environment)",
      "42:4332" : "42:4332 (42:4332 Environmental Policy - Coop of Agency Repo)",
      "42:6901en" : "42:6901en (42:6901 Environmental Cleanup Expenses)",
      "42:6901rs" : "42:6901rs (42:6901 Resource & Recovery Act)",
      "42:7413" : "42:7413 (42:7413(b) Clean Air Act)",
      "42:7604cl" : "42:7604cl (42:7604 Clear Air Act (Emission Standards))",
      "42:7604ir" : "42:7604ir (42:7604 Petition to Quash IRS Summons)",
      "42:9607" : "42:9607 (42:9607 Real Property Tort to Land)",
      "43:945" : "43:945 (43:945 Compensation for Land Condemnation)",
      "43:945a" : "43:945a (43:945a Complaint in Condemnation)",
      "43:946" : "43:946 (43:946 Complaint in Condemnation - Eminent Domain)",
      "45:0051" : "45:0051 (45:51 Railways: Fed. Employer's Liability Act)",
      "45:0151" : "45:0151 (45:151 Railway Labor Act)",
      "45:0184" : "45:0184 (45:184 Action to Set Aside Award of a System Board)",
      "45:1395" : "45:1395 (45:1395 Railroads: Adverse Reimbursement Review)",
      "45:7457" : "45:7457 (45:7457 Compel Reclamation Under Clear Air Act)",
      "46:0688" : "46:0688 (46:688 Jones Act)",
      "46:0741" : "46:0741 (46:741 Shipping)",
      "46:0761" : "46:0761 (46:761 Shipping: Damages for Death on High Seas)",
      "46:1101" : "46:1101 (46:1101 Violation of Maritime Regulations)",
      "46:1156" : "46:1156 (46:1156 Administrative Procedure Act)",
      "48:0883" : "48:0883 (48:883 Violation of US Coastal Law)",
      "48:1985" : "48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)",
      "49:0081" : "49:0081 (49:81 Damaged Goods While Being Transported)",
      "49:0781" : "49:0781 (49:781 Forfeiture)",
      "49:11503" : "49:11503 (49:11503 Railroad Revitalization Regulatory Reform)",
      "49:11702" : "49:11702 (49:11702(a)(4) Violations of Interstate Commerce A)",
      "49:1471" : "49:1471 (49:1471 Federal Aviation Act)",
      "49:1903" : "49:1903 (49:1903 Petition to enforce administrative summon)",
      "8:287" : "8:287 (8:287 Petition to Enforce INS Subpoena)",
      "misc" : "misc (Civil Miscellaneous Case)"
   },
   "txedce" : {
      "0" : "0 (No cause code entered)",
      "02:0431" : "02:0431 (02:431 Fed. Election Commission: Failure Enforce C)",
      "02:0437" : "02:0437 (02:437 Federal Election Commission)",
      "05:0075" : "05:0075 (05:75(2) Contract - Reduction in Grade)",
      "05:0551" : "05:0551 (05:551 Administrative Procedure Act)",
      "05:0552fi" : "05:0552fi (05:552 Freedom of Information Act)",
      "05:0552pa" : "05:0552pa (05:552 Right to Privacy Act)",
      "05:0554" : "05:0554 (05:0554 Constitutionality of Maritime Statutes)",
      "05:0701" : "05:0701 (05:0701 Maritime Subsidy Board)",
      "05:0702" : "05:0702 (05:702 Administrative Procedure Act)",
      "05:0704" : "05:0704 (05:704 Labor Litigation)",
      "05:7703" : "05:7703 (05:7703 Discrimination - Review of Agency Act)",
      "05:8470" : "05:8470 (05:8470 Enforcement of Judgment against Retirement Benefits)",
      "07:0006" : "07:0006 (7:6(b) Federal Commodity Exchange Regulation)",
      "07:0025" : "07:0025 (7:25 Fraud - Commodities Leverage Contracts)",
      "07:0181" : "07:0181 (07:181 Packers & Stockyard Act)",
      "07:0499" : "07:0499 (07:499 Agricultural Commodities Act)",
      "07:0601" : "07:0601 (07:601 USDA Condemnation)",
      "07:2023" : "07:2023 (07:2023 Petition for Judicial Review & Request for Stay)",
      "07:2321" : "07:2321 (07:2321 Plant Variety Protection Act)",
      "08:1105" : "08:1105 (8:1105(a) Aliens: Habeas Corpus to Release INS Det)",
      "08:1182" : "08:1182 (8:1182 Defend. Denial of Pla. Appl. for Alien Employment Cer)",
      "08:1252" : "08:1252 (08:1252(a)(2) Injunction for Deportation)",
      "08:1260" : "08:1260 (08:1260 Aliens: Access to Records)",
      "08:1324" : "08:1324 (08:1324 Aliens: Complaint for Forfeiture)",
      "08:1329" : "08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petiti)",
      "08:1446" : "08:1446 (8:1446 Petition for Naturalization Hearing)",
      "08:1451" : "08:1451 (08:1451 Revocation of Naturalization Proceedings)",
      "08:1451(a)" : "08:1451(a) (08:1451(a) Action to revoke Citizenship)",
      "08:1451(j)" : "08:1451(j) (8:1451(j) Motion to Correct Order & Judg. of Naturalization)",
      "09:0001" : "09:0001 (09:1 U.S. Arbitration Act)",
      "09:0009" : "09:0009 (9:9 Motion to Confirm Arbitration Loan)",
      "09:0010" : "09:0010 (09:0010 Petition to Vacate Arbitration Award)",
      "10:1408" : "10:1408 (10:1408 Claim for Military Retirement)",
      "10:1552" : "10:1552 (10:1552 Armed Forces: Action to Correct Records)",
      "10:1553" : "10:1553 (10:1553 Armed Forces: FOIA General)",
      "10:2305" : "10:2305 (10:2305 Review of Federal Contract)",
      "11:0101" : "11:0101 (11:101 Bankruptcy)",
      "12:0022" : "12:0022 (12:22 Securities Fraud)",
      "12:0635" : "12:0635 (12:635 Breach of Insurance Contract)",
      "12:1441a" : "12:1441a (12:1441a Federal Home Loan Banks)",
      "12:1461" : "12:1461 (12:1461 Homeowners Loan Act)",
      "12:1464" : "12:1464 (12:1464 Federal Savings and Loan)",
      "12:1703" : "12:1703 (12:1703 Default of HUD Loan)",
      "12:1725" : "12:1725 (12:1725 Collection under Contract Guaranty)",
      "12:1730" : "12:1730 (12:1730 Collection Under Contract Guaranty)",
      "12:1819" : "12:1819 (12:1819 Default of Promissory Note)",
      "12:1821" : "12:1821 (12:1821 Default of Loan by Promissary Note)",
      "12:191" : "12:191 (12:191 Bank Foreclosure)",
      "12:192" : "12:192 (12:192 Liquidation of National Bank)",
      "12:1971" : "12:1971 (12:1971 Relief under Bank Holding Act)",
      "12:1972" : "12:1972 (12:1972 Typing Arrangement Act)",
      "12:2601" : "12:2601 (12:2601 Real Estate Settlement Procedures Act)",
      "12:3410" : "12:3410 (12:3410 Right to Financial Privacy Act)",
      "15:0001" : "15:0001 (15:1 Antitrust Litigation)",
      "15:0002at" : "15:0002at (15:2 Antitrust Litigation)",
      "15:0002fl" : "15:0002fl (15:2(a) Fair Labor Standards Act)",
      "15:0005" : "15:0005 (15:5(a) Fair Labor Standards Act)",
      "15:0015" : "15:0015 (15:15 Antitrust Litigation)",
      "15:0025" : "15:0025 (15:25 Clayton Act)",
      "15:0044" : "15:0044 (15:44 Trademark Infringement)",
      "15:0045" : "15:0045 (15:0045 Federal Trade Commission Act)",
      "15:0052" : "15:0052 (15:0052 Federal Trade Commission Act)",
      "15:0053" : "15:0053 (15:0053 Federal Trade Commission Act)",
      "15:0077" : "15:0077 (15:77 Securities Fraud)",
      "15:0077alc" : "15:0077alc (15:0077alc Securities Fraud - Alcatel MDL)",
      "15:0078" : "15:0078 (15:78m(a) Securities Exchange Act)",
      "15:0631" : "15:0631 (15:631 Small Business Act)",
      "15:0717" : "15:0717 (15:717 Natural Gas Act)",
      "15:0754" : "15:0754 (15:754 Emergency Petroleum Allocation-Admin.& Enforcement)",
      "15:1051" : "15:1051 (15:1051 Trademark Infringement)",
      "15:1114" : "15:1114 (15:1114 Trademark Infringement)",
      "15:1121" : "15:1121 (15:1121 Trademark Infringement)",
      "15:1125" : "15:1125 (15:1125 Trademark Infringement (Lanham Act))",
      "15:1126" : "15:1126 (15:1126 Patent Infringement)",
      "15:1127" : "15:1127 (15:1127 Trademark Infringement)",
      "15:1601" : "15:1601 (15:1601 Truth in Lending)",
      "15:1640" : "15:1640 (15:1640 Truth in Lending)",
      "15:1681" : "15:1681 (15:1681 Fair Credit Reporting Act)",
      "15:1692" : "15:1692 (15:1692 Fair Debt Collection Act)",
      "15:1938" : "15:1938 (15:1938 Fair Labor Standards Act)",
      "15:1981" : "15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))",
      "15:1988" : "15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))",
      "15:1989" : "15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))",
      "15:2301" : "15:2301 (15:2301 Magnuson-Moss Warranty Act)",
      "15:2801" : "15:2801 (15:2801 Petroleum Marketing Practices Act)",
      "15:53(b)" : "15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equita)",
      "16:0668" : "16:0668 (16:668 Bald Eagle Protection Act)",
      "16:0703" : "16:0703 (16:703 Migratory Bird Act)",
      "16:1538" : "16:1538 (16:1538 Endangered Species Act)",
      "16:3371" : "16:3371 (16:3371 Wildlife Under the Lacey Act)",
      "16:3372" : "16:3372 (16:3372 Conservation: Complaint for Forfeiture)",
      "16:3373" : "16:3373 (16:3373 Appeal of Decision - DOI)",
      "16:3374" : "16:3374 (16:3374 Conservation: Complaint for Forfeiture)",
      "17:0101" : "17:0101 (17:101 Copyright Infringement)",
      "17:0501" : "17:0501 (17:501 Copyright Infringement)",
      "17:0504" : "17:0504 (17:504 Copyright Infringement)",
      "18:0241" : "18:0241 (18:241 Conspiracy Against Citizen Rights)",
      "18:0925" : "18:0925 (18:0925 Petition for Relief from Disability Firearms Act)",
      "18:1030" : "18:1030 (18:1030 On-going Damage to Computer Data)",
      "18:1345" : "18:1345 (18:1345 Default of Government Direct Farm Ownership Loan)",
      "18:1836a" : "18:1836a (18:1836(a) Injunction against Misappropriation of Trade Secrets)",
      "18:1836b" : "18:1836b (18:1836(b) Civil Action to Protect Trade Secrets)",
      "18:1961" : "18:1961 (18:1961 Racketeering (RICO) Act)",
      "18:1962" : "18:1962 (18:1962 Racketeering (RICO) Act)",
      "18:1964" : "18:1964 (18:1964 Racketeering (RICO) Act)",
      "18:2511" : "18:2511 (18:2511 Wiretapping)",
      "18:3114" : "18:3114 (18:3114 Motion for Return of Seized Property)",
      "18:4208" : "18:4208 (18:4208(B) Agency Action Review)",
      "19:1305" : "19:1305 (19:1305 Custom Duties:0Forfeiture-Immoral Articles)",
      "20:1080" : "20:1080 (20:1080 Student Loan Recovery)",
      "20:1400" : "20:1400 (20:1400 Civil Rights of Handicapped Child)",
      "20:1401" : "20:1401 (20:1401 Education: Handicapped Child Act)",
      "21:0331a" : "21:0331a (21:0331a Fed Food Drug Cosmetic Act)",
      "21:0841" : "21:0841 (21:841 Forfeiture Property-Drugs)",
      "21:0853" : "21:0853 (21:0853 Foreiture Money)",
      "21:0881" : "21:0881 (21:881 Forfeiture Property-Drugs)",
      "21:0881a" : "21:0881a (21:881 Forfeiture Property - Aircraft)",
      "21:0881re" : "21:0881re (21:881 Forfeiture Property - Real Estate)",
      "21:355" : "21:355 (21:355 New Drugs)",
      "23:0134" : "23:0134 (23:134 P.I.- Auto Negligence)",
      "23:1441" : "23:1441 (23:1441 Contract Real Estate)",
      "24:1000" : "24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)",
      "25:0640" : "25:0640 (25:640 Indian Tribal Rights)",
      "25:1901" : "25:1901 (25:1901 Indian Child Welfare Act)",
      "26:6103" : "26:6103 (26:6103 Application to Disclose Tax Returns)",
      "26:6212" : "26:6212 (26:6212 Injunctive Relief from IRS Lien)",
      "26:6213" : "26:6213 (26:6213 Injunctive Relief from IRS Lien)",
      "26:6331" : "26:6331 (26:6331 IRS: Appl. to Enter Premises to Effect Levy)",
      "26:6502" : "26:6502 (26:6502 IRS:Enforcement of tax liens)",
      "26:6532" : "26:6532 (26:6532 IRS: Refund of Tax Penalty)",
      "26:6702" : "26:6702 (26:6702 IRS: Refund of Income Tax Penalty)",
      "26:6703" : "26:6703 (26:6703 IRS: Refund of Tax Penalty)",
      "26:7401" : "26:7401 (26:7401 IRS: Tax Liability)",
      "26:7402" : "26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)",
      "26:7403" : "26:7403 (26:7403 Suit to Enforce Federal Tax Lien)",
      "26:7422rt" : "26:7422rt (26:7422 IRS: Refund Taxes)",
      "26:7422rx" : "26:7422rx (26:7422 IRS: Refund Excise Tax)",
      "26:7426" : "26:7426 (26:7426 IRS: Wrongful Levy for Taxes)",
      "26:7429" : "26:7429 (26:7429 IRS: Tax Jeopardy Assessment)",
      "26:7609" : "26:7609 (26:7609 IRS: Petition to Quash IRS Summons)",
      "27:0185" : "27:0185 (27:185 Enforcement of Arbitration Award)",
      "28:0157c" : "28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)",
      "28:0157d" : "28:0157d (28:0157 Motion for Withdrawal of Reference)",
      "28:0158" : "28:0158 (28:0158 Notice of Appeal re Bankruptcy Matter (BA)",
      "28:0185" : "28:0185 (28:185 Suit to Compel Arbitration)",
      "28:0451" : "28:0451 (28:451 Employment Discrimination)",
      "28:0754" : "28:0754 (28:754 Receiver of Property in Different Districts)",
      "28:0794" : "28:0794 (28:794 Rehabilitation Act)",
      "28:1001" : "28:1001 (28:1001 E.R.I.S.A.)",
      "28:1132" : "28:1132 (28:1132 E.R.I.S.A.)",
      "28:1330" : "28:1330 (28:1330 Breach of Contract)",
      "28:1331" : "28:1331 (28:1331 Fed. Question)",
      "28:1331al" : "28:1331al (28:1331 Fed. Question: Airline Crash)",
      "28:1331at" : "28:1331at (28:1331 Fed. Question: Anti-trust)",
      "28:1331au" : "28:1331au (28:1331 Fed. Question: Auto Negligence)",
      "28:1331b" : "28:1331b (28:1331 Federal Question: Bivens Act)",
      "28:1331bc" : "28:1331bc (28:1331 Fed. Question: Breach of Contract)",
      "28:1331ca" : "28:1331ca (28:1331 Fed Question: Fed Communications Act of 1)",
      "28:1331cm" : "28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)",
      "28:1331cv" : "28:1331cv (28:1331 Federal Question: Other Civil Rights)",
      "28:1331ed" : "28:1331ed (28:1331 Fed. Question: Employment Discrimination)",
      "28:1331ej" : "28:1331ej (28:1331 Federal Question: Enforcement of Judgment)",
      "28:1331es" : "28:1331es (28:1331 Enforcement of Administrative Subpoena)",
      "28:1331fl" : "28:1331fl (28:1331 Fed. Question: Fair Labor Standards)",
      "28:1331in" : "28:1331in (28:1331 Fed. Question: Insurance Contract)",
      "28:1331mm" : "28:1331mm (28:1331 Fed. Question: Medical Malpractice)",
      "28:1331ng" : "28:1331ng (28:1331 Fed. Question: Natural Gas Act)",
      "28:1331pi" : "28:1331pi (28:1331 Fed. Question: Personal Injury)",
      "28:1331rd" : "28:1331rd (28:1331 Fed. Question: Review Agency Decision)",
      "28:1331rp" : "28:1331rp (28:1331(a) Fed. Question: Real Property)",
      "28:1331rr" : "28:1331rr (28:1331 Fed. Question: Railway Labor Act)",
      "28:1331sv" : "28:1331sv (28:1331 Fed. Question: Securities Violation)",
      "28:1331tr" : "28:1331tr (28:1331 Fed. Question: Trademark)",
      "28:1331tt" : "28:1331tt (28:1331 Fed. Question: Tort Action)",
      "28:1331v" : "28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendme)",
      "28:1331wl" : "28:1331wl (28:1331 Federal Question: EPA Waste Lien)",
      "28:1331wt" : "28:1331wt (28:1331 Fed. Question: Water Rights)",
      "28:1332" : "28:1332 (28:1332 Diversity Retaliation Wrongful Termination)",
      "28:1332ac" : "28:1332ac (28:1332 Diversity-Account Receivable)",
      "28:1332al" : "28:1332al (28:1332 Diversity-Airline Crash)",
      "28:1332as" : "28:1332as (28:1332 Diversity-Asbestos Litigation)",
      "28:1332au" : "28:1332au (28:1332 Diversity-Auto Negligence)",
      "28:1332bc" : "28:1332bc (28:1332 Diversity-Breach of Contract)",
      "28:1332co" : "28:1332co (28:1332 Diversity-Conversion)",
      "28:1332ct" : "28:1332ct (28:1332 Diversity-(Citizenship))",
      "28:1332det" : "28:1332det (28:1332 Diversity: Forcible Detainer)",
      "28:1332df" : "28:1332df (28:1332 Diversity-Contract Default)",
      "28:1332ds" : "28:1332ds (28:1332 Diversity-Contract Dispute)",
      "28:1332ed" : "28:1332ed (28:1332 Diversity-Employment Discrimination)",
      "28:1332fd" : "28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)",
      "28:1332fr" : "28:1332fr (28:1332 Diversity-Fraud)",
      "28:1332ia" : "28:1332ia (28:1332 Diversity-Interpleader Action)",
      "28:1332ij" : "28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)",
      "28:1332in" : "28:1332in (28:1332 Diversity-Insurance Contract)",
      "28:1332jd" : "28:1332jd (28:1332 Diversity-Declaratory Judgement)",
      "28:1332lb" : "28:1332lb (28:1332 Diversity-Libel,Assault,Slander)",
      "28:1332lm" : "28:1332lm (28:1332 Diversity - Legal Malpractice)",
      "28:1332ma" : "28:1332ma (28:1332 Diversity-Miller Act)",
      "28:1332mm" : "28:1332mm (28:1332 Diversity-Medical Malpractice)",
      "28:1332mv" : "28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)",
      "28:1332n" : "28:1332n (28:1332n Diversity-Norplant Product Liability)",
      "28:1332ni" : "28:1332ni (28:1332 Diversity-Negotiable Instrument)",
      "28:1332nm" : "28:1332nm (28:1332 Diversity-Non-Motor Vehicle)",
      "28:1332nr" : "28:1332nr (28:1332 Diversity-Notice of Removal)",
      "28:1332oc" : "28:1332oc (28:1332 Diversity-Other Contract)",
      "28:1332pd" : "28:1332pd (28:1332 Diversity-Property Damage)",
      "28:1332pi" : "28:1332pi (28:1332 Diversity-Personal Injury)",
      "28:1332pl" : "28:1332pl (28:1332 Diversity-Product Liability)",
      "28:1332pr" : "28:1332pr (28:1332 Diversity-Petition for Removal)",
      "28:1332qt" : "28:1332qt (28:1332 Diversity-Petition to Quiet Title)",
      "28:1332ri" : "28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)",
      "28:1332sa" : "28:1332sa (28:1332 - Diversity: Securities & Exchange Commiss)",
      "28:1332sf" : "28:1332sf (28:1332 - Diversity: Securities Fraud)",
      "28:1332ss" : "28:1332ss (28:1332 Diversity - Stockholders Suits)",
      "28:1332tl" : "28:1332tl (28:1332 Diversity-Torts to Land)",
      "28:1332tm" : "28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))",
      "28:1332tn" : "28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)",
      "28:1332wd" : "28:1332wd (28:1332 Diversity-Wrongful Death)",
      "28:1333" : "28:1333 (28:1333 Admiralty)",
      "28:1334" : "28:1334 (28:1334 Bankruptcy Appeal)",
      "28:1334c" : "28:1334c (28:1334(c) R&R re motions for abstention (non-cor)",
      "28:1335" : "28:1335 (28:1335 Interpleader Action)",
      "28:1337" : "28:1337 (28:1337 Sherman-Clayton Act)",
      "28:1338cp" : "28:1338cp (28:1338 Copyright Infringement)",
      "28:1338pt" : "28:1338pt (28:1338 Patent Infringement)",
      "28:1338tr" : "28:1338tr (28:1338 Trademark Infringement)",
      "28:1340" : "28:1340 (28:1340 IRS: Custom Duties)",
      "28:1340er" : "28:1340er (28:1340 Recovery of Erroneous Refund)",
      "28:1341" : "28:1341 (28:1341 Complaint for Forfeiture)",
      "28:1343" : "28:1343 (28:1343 Violation of Civil Rights)",
      "28:1345" : "28:1345 (28:1345 USA Plaintiff)",
      "28:1345co" : "28:1345co (28:1345 Replevin & Conversion)",
      "28:1345db" : "28:1345db (28:1345 Debt to US - FHA/HUD Title I)",
      "28:1345df" : "28:1345df (28:1345 Default of Promissory Note)",
      "28:1345er" : "28:1345er (28:1345 Recovery of Erroneous Refund)",
      "28:1345fc" : "28:1345fc (28:1345 Foreclosure)",
      "28:1345ff" : "28:1345ff (28:1345 Complaint for Forfeiture)",
      "28:1345hl" : "28:1345hl (28:1345 VA Home Loan Guaranty Debt)",
      "28:1345mc" : "28:1345mc (28:1345 Medical Care Recovery)",
      "28:1345mi" : "28:1345mi (28:1345 Mining Claim Ejectment)",
      "28:1345pd" : "28:1345pd (28:1345 Property Damage)",
      "28:1345pe" : "28:1345pe (28:1345 Property Ejectment)",
      "28:1345rc" : "28:1345rc (28:1345 Recovery of Debt to US)",
      "28:1345st" : "28:1345st (28:1345 Default of Student Loan)",
      "28:1345tp" : "28:1345tp (28:1345 Trespass on Public Land)",
      "28:1345va" : "28:1345va (28:1345 Recovery of VA Overpayment)",
      "28:1346bc" : "28:1346bc (28:1346 Breach of Contract)",
      "28:1346rc" : "28:1346rc (28:1346 Recovery of IRS Tax)",
      "28:1346tc" : "28:1346tc (28:1346 Tort Claim)",
      "28:1346wd" : "28:1346wd (28:1346 Wrongful Death)",
      "28:1349" : "28:1349 (28:1348 Corporation organized under Federal Law as party)",
      "28:1352" : "28:1352 (28:1352 Miller Act)",
      "28:1355" : "28:1355 (28:1355 Petition for Return of Property)",
      "28:1358" : "28:1358 (28:1358 Land Condemnation)",
      "28:1361" : "28:1361 (28:1361 Petition for Writ of Mandamus)",
      "28:1362ic" : "28:1362ic (28:1362 Indian Tribal Controversy)",
      "28:1362iw" : "28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)",
      "28:1364" : "28:1364 (28:1364 Auto Negligence)",
      "28:1391" : "28:1391 (28:1391 Personal Injury)",
      "28:1402" : "28:1402 (28:1402 Medical Malpractice)",
      "28:1407" : "28:1407 (28:1407 Airline Crash)",
      "28:1441ac" : "28:1441ac (28:1441 Petition for Removal- Account Receivable)",
      "28:1441al" : "28:1441al (28:1441 Petition for Removal- Airline Crash)",
      "28:1441as" : "28:1441as (28:1441 Petition for Removal- Asbestos Litigation)",
      "28:1441au" : "28:1441au (28:1441 Petition for Removal- Auto Negligence)",
      "28:1441bc" : "28:1441bc (28:1441 Petition for Removal- Breach of Contract)",
      "28:1441cv" : "28:1441cv (28:1441 Petition for Removal- Civil Rights Act)",
      "28:1441df" : "28:1441df (28:1441 Petition for Removal- Contract Default)",
      "28:1441dj" : "28:1441dj (28:1441 Petition for Removal- Declaratory Judgemen)",
      "28:1441ds" : "28:1441ds (28:1441 Petition for Removal- Contract Dispute)",
      "28:1441ed" : "28:1441ed (28:1441 Petition for Removal - Employment Discrim)",
      "28:1441fc" : "28:1441fc (28:1441 Petition for Removal - Fair Credit Reporti)",
      "28:1441fr" : "28:1441fr (28:1441 Petition for Removal- Fraud)",
      "28:1441ij" : "28:1441ij (28:1441 Petition for Removal- Injunctive/Declarato)",
      "28:1441in" : "28:1441in (28:1441 Petition for Removal- Insurance Contract)",
      "28:1441int" : "28:1441int (28:1441 Petition for Removal- Action for Interplea)",
      "28:1441lb" : "28:1441lb (28:1441 Petition for Removal Libel,Assault,Slander)",
      "28:1441lm" : "28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relatio)",
      "28:1441mm" : "28:1441mm (28:1441 Petition for Removal- Medical Malpractice)",
      "28:1441ni" : "28:1441ni (28:1441 Petition for Removal- Negotiable Instrumen)",
      "28:1441nm" : "28:1441nm (28:1441 Petition for Removal- Non-Motor Vehicle)",
      "28:1441nr" : "28:1441nr (28:1441 Notice of Removal)",
      "28:1441oc" : "28:1441oc (28:1441 Petition For Removal--Other Contract)",
      "28:1441pd" : "28:1441pd (28:1441 Petition for Removal- Property Damage)",
      "28:1441pi" : "28:1441pi (28:1441 Petition for Removal- Personal Injury)",
      "28:1441pl" : "28:1441pl (28:1441 Petition for Removal- Product Liability)",
      "28:1441pr" : "28:1441pr (28:1441 Petition for Removal)",
      "28:1441qt" : "28:1441qt (28:1441 Petition for Removal- Petition to Quiet Ti)",
      "28:1441ri" : "28:1441ri (28:1441 Petition for Removal- Racketeering (RICO))",
      "28:1441sa" : "28:1441sa (28:1441 - Petition for Removal: SEC Act)",
      "28:1441sf" : "28:1441sf (28:1441 - Petition for Removal: Securities Fraud)",
      "28:1441tl" : "28:1441tl (28:1441 Petition for Removal- Torts to Land)",
      "28:1441tm" : "28:1441tm (28:1441 Petition for Removal- Tort/Motor Vehicle ()",
      "28:1441tn" : "28:1441tn (28:1441 Petition for Removal- Tort/Non-Motor Vehic)",
      "28:1441wd" : "28:1441wd (28:1441 Petition for Removal- Wrongful Death)",
      "28:1442bc" : "28:1442bc (28:1442 Petition for Removal- Breach of Contract)",
      "28:1442nr" : "28:1442nr (28:1442 Notice of Removal)",
      "28:1442pr" : "28:1442pr (28:1442 Petition for Removal)",
      "28:1443" : "28:1443 (28:1443(1) Rent, Lease & Ejectment)",
      "28:1444" : "28:1444 (28:1444 Petition for Removal- Foreclosure)",
      "28:1446in" : "28:1446in (28:1446 Breach of Contract- Insurance)",
      "28:1446nr" : "28:1446nr (28:1446 Notice of Removal)",
      "28:1446pd" : "28:1446pd (28:1446 Petition for Removal- Property Damage (P.I)",
      "28:1446pi" : "28:1446pi (28:1446 Petition for Removal- Personal Injury)",
      "28:1446pl" : "28:1446pl (28:1446pl Petition for Removal - Product Liability)",
      "28:1446pr" : "28:1446pr (28:1446 Petition for Removal)",
      "28:1452" : "28:1452 (28:1452 Removal of Claims Related to Bankruptcy Cases)",
      "28:1651" : "28:1651 (28:1651 Petition for Writ of Coram Nobis)",
      "28:1651hc" : "28:1651hc (28:1651 Petition for Writ of Habeas Corpus)",
      "28:1651mn" : "28:1651mn (28:1651 Petition for Writ of Mandamus)",
      "28:1782" : "28:1782 (28:1782 Letter rogatory - appointment)",
      "28:1916" : "28:1916 (Jones Act)",
      "28:1983" : "28:1983 (28:1983 Civil Rights)",
      "28:2201" : "28:2201 (28:2201 Constitutionality of State Statute(s))",
      "28:2201dj" : "28:2201dj (28:2201 Declaratory Judgement)",
      "28:2201ij" : "28:2201ij (28:2201 Injunction)",
      "28:2201in" : "28:2201in (28:2201 Declaratory Judgement (Insurance))",
      "28:2241" : "28:2241 (28:2241 Petition for Writ of Habeas Corpus (federal))",
      "28:2241s" : "28:2241s (28:2241s Petition for Writ of Habeas Corpus (State))",
      "28:2254" : "28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))",
      "28:2254ex" : "28:2254ex (28:2254ex Petition for Writ of Habeas Corpus (Capital))",
      "28:2254se" : "28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)",
      "28:2255" : "28:2255 (28:2255 Motion to Vacate/Correct Illegal Sentence)",
      "28:2271" : "28:2271 (28:2271 Federal Tort Claims Act)",
      "28:2345" : "28:2345 (28:2345 Medicare Recovery)",
      "28:2409" : "28:2409 (28:2409(a) Quiet Title Action)",
      "28:2410" : "28:2410 (28:2410 Quiet Title)",
      "28:2671" : "28:2671 (28:2671 Federal Tort Claims Act)",
      "28:2674" : "28:2674 (28:2674 Federal Tort Claims Act)",
      "28:3001" : "28:3001 (28:3001 Federal Debt Collection Act)",
      "28:7402" : "28:7402 (28:7402 Refund of Taxes)",
      "28:7422" : "28:7422 (28:7422 Appeal from Administrative Decision)",
      "29:0151" : "29:0151 (29:151 Labor: Review of Agency Action)",
      "29:0160" : "29:0160 (29:160(1) National Labor Relations Act)",
      "29:0184" : "29:0184 (29:184 Violation Collection Bargain Agreement)",
      "29:0185ep" : "29:0185ep (29:185 Employee Pension Plan)",
      "29:0185lm" : "29:0185lm (29:185 Labor/Mgt. Relations (Contracts))",
      "29:0201do" : "29:0201do (29:201 Denial of Overtime Compensation)",
      "29:0201fl" : "29:0201fl (29:201 Fair Labor Standards Act)",
      "29:0203" : "29:0203 (29:203 Equal Pay Act)",
      "29:0206" : "29:0206 (29:206 Collect Unpaid Wages)",
      "29:0401" : "29:0401 (29:0401 Labor Management Disclosure Act)",
      "29:0601" : "29:0601 (29:601 Age Discrimination in Employment Act)",
      "29:0621" : "29:0621 (29:621 Job Discrimination (Age))",
      "29:0623" : "29:0623 (29:623 Job Discrimination (Age))",
      "29:0626" : "29:0626 (29:626 Job Discrimination (Age))",
      "29:0633" : "29:0633 (29:633 Job Discrimination (Age))",
      "29:0651" : "29:0651 (29:651 Occupational Safety/Health)",
      "29:0754" : "29:0754 (29:754 Discrimination)",
      "29:0791" : "29:0791 (29:791 Job Discrimination (Rehabilitation Act))",
      "29:0794" : "29:0794 (29:0794 Job Discrimination (Handicap))",
      "29:1001" : "29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)",
      "29:1002" : "29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)",
      "29:1104" : "29:1104 (29:1104 Recovery of Benefits to Employee)",
      "29:1109" : "29:1109 (29:1109 Breach of Fiduciary Duties)",
      "29:1131" : "29:1131 (29:1131 ERISA - Collection of Delinquent Trust Fun)",
      "29:1132" : "29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)",
      "29:1145" : "29:1145 (29:1145 E.R.I.S.A.)",
      "29:1149" : "29:1149 (29:1149 Recover Pension & Profit Sharing)",
      "29:1337" : "29:1337 (29:1337 E.R.I.S.A.)",
      "29:1362" : "29:1362 (29:1362 ERISA)",
      "29:1381" : "29:1381 (29:1381 E.R.I.S.A.)",
      "29:1401" : "29:1401 (29:1401(b)(2) Appeal of Arbitration Award)",
      "29:1451" : "29:1451 (29:1451 E.R.I.S.A.)",
      "29:1554" : "29:1554 (29:1554 Federal Fair Labor Standards Act)",
      "29:1801" : "29:1801 (29:1801 Farmworker Rights)",
      "29:2601" : "29:2601 (29:2601 Family and Medical Leave Act)",
      "29:2617" : "29:2617 (29:2617 Family Leave Act)",
      "29:790" : "29:790 (29:790 Rehabilitation of Labor)",
      "30:0181" : "30:0181 (30:181 Environment: Review of Agency Action)",
      "30:0801" : "30:0801 (30:0801 Penalities/Federal Mine Safety Health Act)",
      "30:1201" : "30:1201 (30:1201 Environment: Review of Agency Action)",
      "30:1202" : "30:1202 (30:1202 Mining Reclamation Act)",
      "30:1276" : "30:1276 (30:1276 Interior: Review of Agency Action)",
      "31:3545" : "31:3545 (31:3545 Action to Recovery Money)",
      "31:3729" : "31:3729 (31:3729 False Claims Act)",
      "31:3730" : "31:3730 (31:3730 Qui Tam False Claims Act)",
      "31:3731" : "31:3731 (31:3731 Fraud)",
      "33:1319cw" : "33:1319cw (33:1319 Clean Water Act)",
      "33:1319pv" : "33:1319pv (33:1319 Pollutants & Permit Violations)",
      "33:1365" : "33:1365 (33:1365 Environmental Matters)",
      "33:403" : "33:403 (33:403 Rivers & Harbors Act of 1899)",
      "35:0145" : "35:0145 (35:145 Patent Infringement)",
      "35:0183" : "35:0183 (35:183 Patent Infringement)",
      "35:0271" : "35:0271 (35:271 Patent Infringement)",
      "38:1506" : "38:1506 (38:1506 Recovery of VA Overpayment)",
      "38:1681" : "38:1681 (38:1681 Recovery of VA Overpayment)",
      "38:1686" : "38:1686 (38:1686 Recovery of VA Overpayment)",
      "38:1780" : "38:1780 (38:1780 Recovery of VA Overpayment)",
      "38:2011" : "38:2011 (38:2011 - Veteran's Readjustment Assistance Act of)",
      "38:2021" : "38:2021 (Right to re-employment of inducted persons)",
      "38:3116" : "38:3116 (38:3116 VA Overpayment)",
      "38:775" : "38:775 (Recovery of Servicemen's Group Life Insurance)",
      "39:3005" : "39:3005 (39:3005 Detention of Mail for Temporary Periods)",
      "39:409" : "39:409 (39:409 Postal Service)",
      "40:0258" : "40:0258 (40:258(a) Public Buildings & Property: Land Condem)",
      "40:0270" : "40:0270 (40:270 Miller Act)",
      "40:0875" : "40:0875 (40:875 Public Buildings & Property: Negligence)",
      "41:0251" : "41:0251 (41:251 Public Contracts-Review of Agency Action)",
      "41:1463" : "41:1463 (41:1463 Public Contracts: Unlawful Employment Prac)",
      "42:0205" : "42:0205 (42:205 Denial Social Security Benefits)",
      "42:0206" : "42:0206 (42:206 Social Security Benefits)",
      "42:0247" : "42:0247 (42:247 Personal Injury-Swine Flu)",
      "42:0402" : "42:0402 (42:402 Social Security Benefits)",
      "42:0405id" : "42:0405id (42:405 Review of HHS Decision (SSID))",
      "42:0405wc" : "42:0405wc (42:405 Review of HHS Decision (DIWC))",
      "42:0405ww" : "42:0405ww (42:405 Review of HHS Decision (DIWW))",
      "42:0416" : "42:0416 (42:416 Denial of Social Security Benefits)",
      "42:0427" : "42:0427 (42:427 Social Security Benefits)",
      "42:11603" : "42:11603 (42:11603 International Child Abduction Remedies)",
      "42:12101" : "42:12101 (42:12101 Americans with Disabilities Act)",
      "42:12117" : "42:12117 (42:12117 Employment Discrimination under A.D.A.)",
      "42:12181" : "42:12181 (42:12181 Americans with Disabilities Act of 1990)",
      "42:1320a" : "42:1320a (42:1320a Recovery of civil monetary penalty & assessment)",
      "42:1383" : "42:1383 (42:1383 Review of HHS Decision)",
      "42:1395" : "42:1395 (42:1395 HHS: Adverse Reimbursement Review)",
      "42:1396" : "42:1396 (42:1396 - Tort Negligence)",
      "42:1471" : "42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclo)",
      "42:1971" : "42:1971 (42:1971 Voting Right's Act)",
      "42:1981cv" : "42:1981cv (42:1981 Civil Rights)",
      "42:1981hs" : "42:1981hs (42:1981 Housing Discrimination)",
      "42:1981jb" : "42:1981jb (42:1981 Job Discrimination (Race))",
      "42:1981sx" : "42:1981sx (42:1981 Sex Discrimination)",
      "42:1983cv" : "42:1983cv (42:1983 Civil Rights Act)",
      "42:1983ed" : "42:1983ed (42:1983 Civil Rights (Employment Discrimination))",
      "42:1983pr" : "42:1983pr (42:1983 Prisoner Civil Rights)",
      "42:1986" : "42:1986 (42:1986 Neglect of Duty)",
      "42:2000ag" : "42:2000ag (42:2000 Job Discrimination (Age))",
      "42:2000bb" : "42:2000bb (42:2000bb Religious Freedom Restoration Act)",
      "42:2000e" : "42:2000e (42:2000e Job Discrimination (Employment))",
      "42:2000pb" : "42:2000pb (42:2000 Job Discrimination (Public Accomodations))",
      "42:2000ra" : "42:2000ra (42:2000 Job Discrimination (Race))",
      "42:2000sx" : "42:2000sx (42:2000 Job Discrimination (Sex))",
      "42:2003" : "42:2003 (42:2003 Job Discrimination)",
      "42:2005" : "42:2005 (42:2005 Review of Agency Action-HHS)",
      "42:2615" : "42:2615 (42:2616 Medical Recovery Act)",
      "42:2651" : "42:2651 (42:2651 Medical Care Recovery)",
      "42:3601" : "42:3601 (42:405 Fair Housing Act)",
      "42:4000" : "42:4000 (42:4000 National Flood Insurance Act)",
      "42:4001" : "42:4001 (42:4001 National Insurance Flood Act)",
      "42:4053" : "42:4053 (42:4053 Breach of Insurance Contract)",
      "42:4072" : "42:4072 (42:4072 Payment of Flood Insurance Claim)",
      "42:4321" : "42:4321 (42:4321 Review of Agency Action-Environment)",
      "42:4332" : "42:4332 (42:4332 Environmental Policy - Coop of Agency Repo)",
      "42:6901en" : "42:6901en (42:6901 Environmental Cleanup Expenses)",
      "42:6901rs" : "42:6901rs (42:6901 Resource & Recovery Act)",
      "42:7413" : "42:7413 (42:7413(b) Clean Air Act)",
      "42:7604cl" : "42:7604cl (42:7604 Clear Air Act (Emission Standards))",
      "42:7604ir" : "42:7604ir (42:7604 Petition to Quash IRS Summons)",
      "42:9607" : "42:9607 (42:9607 Real Property Tort to Land)",
      "43:945" : "43:945 (43:945 Compensation for Land Condemnation)",
      "43:945a" : "43:945a (43:945a Complaint in Condemnation)",
      "43:946" : "43:946 (43:946 Complaint in Condemnation - Eminent Domain)",
      "45:0051" : "45:0051 (45:51 Railways: Fed. Employer's Liability Act)",
      "45:0151" : "45:0151 (45:151 Railway Labor Act)",
      "45:0184" : "45:0184 (45:184 Action to Set Aside Award of a System Board)",
      "45:1395" : "45:1395 (45:1395 Railroads: Adverse Reimbursement Review)",
      "45:7457" : "45:7457 (45:7457 Compel Reclamation Under Clear Air Act)",
      "46:0688" : "46:0688 (46:688 Jones Act)",
      "46:0741" : "46:0741 (46:741 Shipping)",
      "46:0761" : "46:0761 (46:761 Shipping: Damages for Death on High Seas)",
      "46:1101" : "46:1101 (46:1101 Violation of Maritime Regulations)",
      "46:1156" : "46:1156 (46:1156 Administrative Procedure Act)",
      "47:0227" : "47:0227 (Federal Telephone Consumer Protection Act)",
      "47:0553" : "47:0553 (47:0553 Unauthorized Reception of Cable Service)",
      "48:0883" : "48:0883 (48:883 Violation of US Coastal Law)",
      "48:1985" : "48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)",
      "49:0081" : "49:0081 (49:81 Damaged Goods While Being Transported)",
      "49:0781" : "49:0781 (49:781 Forfeiture)",
      "49:11503" : "49:11503 (49:11503 Railroad Revitalization Regulatory Reform)",
      "49:11702" : "49:11702 (49:11702(a)(4) Violations of Interstate Commerce A)",
      "49:1471" : "49:1471 (49:1471 Federal Aviation Act)",
      "49:1903" : "49:1903 (49:1903 Petition to enforce administrative summon)",
      "49:32703" : "49:32703 (49:32703 Odometer Tampering)",
      "49:60101" : "49:60101 (49:60101 Hazardous Liquid Pipeline Act)",
      "49:6121a" : "49:6121a (49:6121a Pipeline Safety Act)",
      "8:287" : "8:287 (8:287 Petition to Enforce INS Subpoena)",
      "99:9999" : "99:9999 (99:9999 Report cause code (DO NOT DELETE!))",
      "adsup" : "adsup (Administrative Subpoena)",
      "contempt" : "contempt (Contempt Proceedings)",
      "disbar" : "disbar (Disbarment Proceedings)",
      "fordepo" : "fordepo (Foreign Deposition)",
      "misc" : "misc (Civil Miscellaneous Case)",
      "motcomp" : "motcomp (Motion to Compel)",
      "motquash" : "motquash (Motion to Quash)",
      "motret" : "motret (Motion for Return of Property)",
      "petenf" : "petenf (Petition to Enforce IRS Summons)",
      "petper" : "petper (Petition to Perpetuate Testimony)",
      "regjgm" : "regjgm (Registration of Foreign Judgment)",
      "tranbkref" : "tranbkref (Transmission of Bankruptcy Reference)",
      "tranff" : "tranff (Transmission of Proposed Findings of Fact and Concl. of Law)",
      "writgar" : "writgar (Application for a Writ of Garnishment)"
   },
   "txndce" : {
      "0" : "0 (No cause code entered)",
      "02:0431" : "02:0431 (02:431 Fed. Election Commission: Failure Enforce C)",
      "02:0437" : "02:0437 (02:437 Federal Election Commission)",
      "05:0075" : "05:0075 (05:75(2) Contract - Reduction in Grade)",
      "05:0551" : "05:0551 (05:551 Administrative Procedure Act)",
      "05:0552fi" : "05:0552fi (05:552 Freedom of Information Act)",
      "05:0552pa" : "05:0552pa (05:552 Right to Privacy Act)",
      "05:0554" : "05:0554 (05:0554 Constitutionality of Maritime Statutes)",
      "05:0701" : "05:0701 (05:0701 Maritime Subsidy Board)",
      "05:0702" : "05:0702 (05:702 Administrative Procedure Act)",
      "05:0704" : "05:0704 (05:704 Labor Litigation)",
      "05:7703" : "05:7703 (05:7703 Discrimination - Review of Agency Act)",
      "05:8470" : "05:8470 (05:8470 Enforcement of Judgment against Retirement Benefits)",
      "07:0006" : "07:0006 (7:6(b) Federal Commodity Exchange Regulation)",
      "07:0025" : "07:0025 (7:25 Fraud - Commodities Leverage Contracts)",
      "07:0181" : "07:0181 (07:181 Packers & Stockyard Act)",
      "07:0499" : "07:0499 (07:499 Agricultural Commodities Act)",
      "07:0601" : "07:0601 (07:601 USDA Condemnation)",
      "07:2321" : "07:2321 (07:2321 Plant Variety Protection Act)",
      "08:0287" : "08:0287 (08:0287 Petition to Enforce INS Subpoena)",
      "08:1105" : "08:1105 (8:1105(a) Aliens: Habeas Corpus to Release INS Det)",
      "08:1182" : "08:1182 (8:1182 Defend. Denial of Pla. Appl. for Alien Employment Cer)",
      "08:1252" : "08:1252 (08:1252(a)(2) Injunction for Deportation)",
      "08:1260" : "08:1260 (08:1260 Aliens: Access to Records)",
      "08:1324" : "08:1324 (08:1324 Aliens: Complaint for Forfeiture)",
      "08:1329" : "08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petiti)",
      "08:1446" : "08:1446 (8:1446 Petition for Naturalization Hearing)",
      "08:1447" : "08:1447 (8:1447 Petition for Naturalization Hearing)",
      "08:1451(j)" : "08:1451(j) (8:1451(j) Motion to Correct Order & Judg. of Naturalization)",
      "09:0001" : "09:0001 (09:1 U.S. Arbitration Act)",
      "09:0009" : "09:0009 (9:9 Motion to Confirm Arbitration Award)",
      "09:0010" : "09:0010 (09:0010 Petition to Vacate Arbitration Award)",
      "10:1408" : "10:1408 (10:1408 Claim for Military Retirement)",
      "10:1552" : "10:1552 (10:1552 Armed Forces: Action to Correct Records)",
      "10:1553" : "10:1553 (10:1553 Armed Forces: FOIA General)",
      "10:2305" : "10:2305 (10:2305 Review of Federal Contract)",
      "11:0101" : "11:0101 (11:101 Bankruptcy)",
      "12:0022" : "12:0022 (12:22 Securities Fraud)",
      "12:0635" : "12:0635 (12:635 Breach of Insurance Contract)",
      "12:1461" : "12:1461 (12:1461 Homeowners Loan Act)",
      "12:1464" : "12:1464 (12:1464 Federal Savings and Loan)",
      "12:1703" : "12:1703 (12:1703 Default of HUD Loan)",
      "12:1725" : "12:1725 (12:1725 Collection under Contract Guaranty)",
      "12:1730" : "12:1730 (12:1730 Collection Under Contract Guaranty)",
      "12:1819" : "12:1819 (12:1819 Default of Promissory Note)",
      "12:1821" : "12:1821 (12:1821 Default of Loan by Promissary Note)",
      "12:191" : "12:191 (12:191 Bank Foreclosure)",
      "12:192" : "12:192 (12:192 Liquidation of National Bank)",
      "12:1971" : "12:1971 (12:1971 Relief under Bank Holding Act)",
      "12:1972" : "12:1972 (12:1972 Tying Arrangement Act)",
      "12:3410" : "12:3410 (12:3410 Right to Financial Privacy Act)",
      "15:0001" : "15:0001 (15:1 Antitrust Litigation)",
      "15:0002at" : "15:0002at (15:2 Antitrust Litigation)",
      "15:0002fl" : "15:0002fl (15:2(a) Fair Labor Standards Act)",
      "15:0005" : "15:0005 (15:5(a) Fair Labor Standards Act)",
      "15:0015" : "15:0015 (15:15 Antitrust Litigation)",
      "15:0025" : "15:0025 (15:25 Clayton Act)",
      "15:0044" : "15:0044 (15:44 Trademark Infringement)",
      "15:0045" : "15:0045 (15:0045 Federal Trade Commission Act)",
      "15:0052" : "15:0052 (15:0052 Federal Trade Commission Act)",
      "15:0053" : "15:0053 (15:0053 Federal Trade Commission Act)",
      "15:0077" : "15:0077 (15:77 Securities)",
      "15:0078" : "15:0078 (15:78m(a) Securities Exchange Act)",
      "15:0078n" : "15:0078n (15:78n(a) Securities Exchange Act)",
      "15:0631" : "15:0631 (15:631 Small Business Act)",
      "15:0717" : "15:0717 (15:717 Natural Gas Act)",
      "15:0754" : "15:0754 (15:754 Emergency Petroleum Allocation-Admin.& Enforcement)",
      "15:1051" : "15:1051 (15:1051 Trademark Infringement)",
      "15:1114" : "15:1114 (15:1114 Trademark Infringement)",
      "15:1121" : "15:1121 (15:1121 Trademark Infringement)",
      "15:1125" : "15:1125 (15:1125 Trademark Infringement (Lanham Act))",
      "15:1126" : "15:1126 (15:1126 Patent Infringement)",
      "15:1127" : "15:1127 (15:1127 Trademark Infringement)",
      "15:1601" : "15:1601 (15:1601 Truth in Lending)",
      "15:1640" : "15:1640 (15:1640 Truth in Lending)",
      "15:1681" : "15:1681 (15:1681 Fair Credit Reporting Act)",
      "15:1692" : "15:1692 (15:1692 Fair Debt Collection Act)",
      "15:1938" : "15:1938 (15:1938 Fair Labor Standards Act)",
      "15:1981" : "15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))",
      "15:1988" : "15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))",
      "15:1989" : "15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))",
      "15:2301" : "15:2301 (15:2301 Magnuson-Moss Warranty Act)",
      "15:2801" : "15:2801 (15:2801 Petroleum Marketing Practices Act)",
      "15:53(b)" : "15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equita)",
      "16:0668" : "16:0668 (16:668 Bald Eagle Protection Act)",
      "16:0703" : "16:0703 (16:703 Migratory Bird Act)",
      "16:1538" : "16:1538 (16:1538 Endangered Species Act)",
      "16:3371" : "16:3371 (16:3371 Wildlife Under the Lacey Act)",
      "16:3372" : "16:3372 (16:3372 Conservation: Complaint for Forfeiture)",
      "16:3373" : "16:3373 (16:3373 Appeal of Decision - DOI)",
      "16:3374" : "16:3374 (16:3374 Conservation: Complaint for Forfeiture)",
      "17:0101" : "17:0101 (17:101 Copyright Infringement)",
      "17:0501" : "17:0501 (17:501 Copyright Infringement)",
      "17:0504" : "17:0504 (17:504 Copyright Infringement)",
      "18:0241" : "18:0241 (18:241 Conspiracy Against Citizen Rights)",
      "18:1030" : "18:1030 (18:1030 Computer Fraud & Abuse Act)",
      "18:1836a" : "18:1836a (18:1836(a) Injunction against Misappropriation of Trade Secrets)",
      "18:1836b" : "18:1836b (18:1836(b) Civil Action to Protect Trade Secrets)",
      "18:1961" : "18:1961 (18:1961 Racketeering (RICO) Act)",
      "18:1962" : "18:1962 (18:1962 Racketeering (RICO) Act)",
      "18:1964" : "18:1964 (18:1964 Racketeering (RICO) Act)",
      "18:2511" : "18:2511 (18:2511 Wiretapping)",
      "18:3114" : "18:3114 (18:3114 Motion for Return of Seized Property)",
      "18:3599" : "18:3599 (18:3599 Appointment of Clemency Counsel)",
      "18:4208" : "18:4208 (18:4208(B) Agency Action Review)",
      "19:1305" : "19:1305 (19:1305 Custom Duties:0Forfeiture-Immoral Articles)",
      "20:1080" : "20:1080 (20:1080 Student Loan Recovery)",
      "20:1400" : "20:1400 (20:1400 Civil Rights of Handicapped Child)",
      "20:1401" : "20:1401 (20:1401 Education: Handicapped Child Act)",
      "21:0841" : "21:0841 (21:841 Forfeiture Property-Drugs)",
      "21:0881" : "21:0881 (21:881 Forfeiture Property-Drugs)",
      "21:0881a" : "21:0881a (21:881 Forfeiture Property - Aircraft)",
      "21:0881re" : "21:0881re (21:881 Forfeiture Property - Real Estate)",
      "22:9001" : "22:9001 (22:9001 International Child Abduction Remedies)",
      "23:0134" : "23:0134 (23:134 P.I.- Auto Negligence)",
      "23:1441" : "23:1441 (23:1441 Contract Real Estate)",
      "24:1000" : "24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)",
      "25:0640" : "25:0640 (25:640 Indian Tribal Rights)",
      "25:1901" : "25:1901 (25:1901 Indian Child Welfare Act)",
      "26:6212" : "26:6212 (26:6212 Injunctive Relief from IRS Lien)",
      "26:6213" : "26:6213 (26:6213 Injunctive Relief from IRS Lien)",
      "26:6502" : "26:6502 (26:6502 IRS:Enforcement of tax liens)",
      "26:6532" : "26:6532 (26:6532 IRS: Refund of Tax Penalty)",
      "26:6702" : "26:6702 (26:6702 IRS: Refund of Income Tax Penalty)",
      "26:6703" : "26:6703 (26:6703 IRS: Refund of Tax Penalty)",
      "26:7401" : "26:7401 (26:7401 IRS: Tax Liability)",
      "26:7402" : "26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)",
      "26:7403" : "26:7403 (26:7403 Suit to Enforce Federal Tax Lien)",
      "26:7422rt" : "26:7422rt (26:7422 IRS: Refund Taxes)",
      "26:7422rx" : "26:7422rx (26:7422 IRS: Refund Excise Tax)",
      "26:7426" : "26:7426 (26:7426 IRS: Wrongful Levy for Taxes)",
      "26:7429" : "26:7429 (26:7429 IRS: Tax Jeopardy Assessment)",
      "26:7609" : "26:7609 (26:7609 IRS: Petition to Quash IRS Summons)",
      "27:0185" : "27:0185 (27:185 Enforcement of Arbitration Award)",
      "28:0157c" : "28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)",
      "28:0157d" : "28:0157d (28:0157 Motion for Withdrawal of Reference)",
      "28:0158" : "28:0158 (28:0158 Notice of Appeal re Bankruptcy Matter (BA)",
      "28:0185" : "28:0185 (28:185 Suit to Compel Arbitration)",
      "28:0451" : "28:0451 (28:451 Employment Discrimination)",
      "28:0754" : "28:0754 (28:754 Receiver of Property in Different Districts)",
      "28:0794" : "28:0794 (28:794 Rehabilitation Act)",
      "28:1001" : "28:1001 (28:1001 E.R.I.S.A.)",
      "28:1132" : "28:1132 (28:1132 E.R.I.S.A.)",
      "28:1330" : "28:1330 (28:1330 Breach of Contract)",
      "28:1331" : "28:1331 (28:1331 Fed. Question)",
      "28:1331al" : "28:1331al (28:1331 Fed. Question: Airline Crash)",
      "28:1331at" : "28:1331at (28:1331 Fed. Question: Anti-trust)",
      "28:1331au" : "28:1331au (28:1331 Fed. Question: Auto Negligence)",
      "28:1331b" : "28:1331b (28:1331 Federal Question: Bivens Act)",
      "28:1331bc" : "28:1331bc (28:1331 Fed. Question: Breach of Contract)",
      "28:1331ca" : "28:1331ca (28:1131ca Federal Question: Federal Communications Act)",
      "28:1331cm" : "28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)",
      "28:1331cv" : "28:1331cv (28:1331 Federal Question: Other Civil Rights)",
      "28:1331ed" : "28:1331ed (28:1331 Fed. Question: Employment Discrimination)",
      "28:1331ej" : "28:1331ej (28:1331 Federal Question: Enforcement of Judgment)",
      "28:1331es" : "28:1331es (28:1331 Enforcement of Administrative Subpoena)",
      "28:1331fl" : "28:1331fl (28:1331 Fed. Question: Fair Labor Standards)",
      "28:1331in" : "28:1331in (28:1331 Fed. Question: Insurance Contract)",
      "28:1331mm" : "28:1331mm (28:1331 Fed. Question: Medical Malpractice)",
      "28:1331ng" : "28:1331ng (28:1331 Fed. Question: Natural Gas Act)",
      "28:1331pi" : "28:1331pi (28:1331 Fed. Question: Personal Injury)",
      "28:1331rd" : "28:1331rd (28:1331 Fed. Question: Review Agency Decision)",
      "28:1331rp" : "28:1331rp (28:1331(a) Fed. Question: Real Property)",
      "28:1331rr" : "28:1331rr (28:1331 Fed. Question: Railway Labor Act)",
      "28:1331sv" : "28:1331sv (28:1331 Fed. Question: Securities Violation)",
      "28:1331tr" : "28:1331tr (28:1331 Fed. Question: Trademark)",
      "28:1331tt" : "28:1331tt (28:1331 Fed. Question: Tort Action)",
      "28:1331v" : "28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendme)",
      "28:1331wl" : "28:1331wl (28:1331 Federal Question: EPA Waste Lien)",
      "28:1331wt" : "28:1331wt (28:1331 Fed. Question: Water Rights)",
      "28:1332ac" : "28:1332ac (28:1332 Diversity-Account Receivable)",
      "28:1332al" : "28:1332al (28:1332 Diversity-Airline Crash)",
      "28:1332as" : "28:1332as (28:1332 Diversity-Asbestos Litigation)",
      "28:1332au" : "28:1332au (28:1332 Diversity-Auto Negligence)",
      "28:1332bc" : "28:1332bc (28:1332 Diversity-Breach of Contract)",
      "28:1332co" : "28:1332co (28:1332 Diversity-Conversion)",
      "28:1332ct" : "28:1332ct (28:1332 Diversity-(Citizenship))",
      "28:1332det" : "28:1332det (28:1332 Diversity: Forcible Detainer)",
      "28:1332df" : "28:1332df (28:1332 Diversity-Contract Default)",
      "28:1332ds" : "28:1332ds (28:1332 Diversity-Contract Dispute)",
      "28:1332ed" : "28:1332ed (28:1332 Diversity-Employment Discrimination)",
      "28:1332fd" : "28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)",
      "28:1332fr" : "28:1332fr (28:1332 Diversity-Fraud)",
      "28:1332ia" : "28:1332ia (28:1332 Diversity-Interpleader Action)",
      "28:1332ij" : "28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)",
      "28:1332in" : "28:1332in (28:1332 Diversity-Insurance Contract)",
      "28:1332jd" : "28:1332jd (28:1332 Diversity-Declaratory Judgment)",
      "28:1332lb" : "28:1332lb (28:1332 Diversity-Libel,Assault,Slander)",
      "28:1332lm" : "28:1332lm (28:1332 Diversity - Legal Malpractice)",
      "28:1332ma" : "28:1332ma (28:1332 Diversity-Miller Act)",
      "28:1332mm" : "28:1332mm (28:1332 Diversity-Medical Malpractice)",
      "28:1332mv" : "28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)",
      "28:1332ni" : "28:1332ni (28:1332 Diversity-Negotiable Instrument)",
      "28:1332nm" : "28:1332nm (28:1332 Diversity-Non-Motor Vehicle)",
      "28:1332nr" : "28:1332nr (28:1332 Diversity-Notice of Removal)",
      "28:1332oc" : "28:1332oc (28:1332 Diversity-Other Contract)",
      "28:1332pd" : "28:1332pd (28:1332 Diversity-Property Damage)",
      "28:1332pi" : "28:1332pi (28:1332 Diversity-Personal Injury)",
      "28:1332pl" : "28:1332pl (28:1332 Diversity-Product Liability)",
      "28:1332pr" : "28:1332pr (28:1332 Diversity-Petition for Removal)",
      "28:1332qt" : "28:1332qt (28:1332 Diversity-Petition to Quiet Title)",
      "28:1332ri" : "28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)",
      "28:1332sa" : "28:1332sa (28:1332 - Diversity: Securities & Exchange Commiss)",
      "28:1332sf" : "28:1332sf (28:1332 - Diversity: Securities Fraud)",
      "28:1332ss" : "28:1332ss (28:1332 Diversity - Stockholders Suits)",
      "28:1332tl" : "28:1332tl (28:1332 Diversity-Torts to Land)",
      "28:1332tm" : "28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))",
      "28:1332tn" : "28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)",
      "28:1332wd" : "28:1332wd (28:1332 Diversity-Wrongful Death)",
      "28:1333" : "28:1333 (28:1333 Admiralty)",
      "28:1334" : "28:1334 (28:1334 Bankruptcy Appeal)",
      "28:1334c" : "28:1334c (28:1334(c) R&R re motions for abstention (non-cor)",
      "28:1335" : "28:1335 (28:1335 Interpleader Action)",
      "28:1337" : "28:1337 (28:1337 Sherman-Clayton Act)",
      "28:1338cp" : "28:1338cp (28:1338 Copyright Infringement)",
      "28:1338pt" : "28:1338pt (28:1338 Patent Infringement)",
      "28:1338tr" : "28:1338tr (28:1338 Trademark Infringement)",
      "28:1340" : "28:1340 (28:1340 IRS: Custom Duties)",
      "28:1340er" : "28:1340er (28:1340 Recovery of Erroneous Refund)",
      "28:1341" : "28:1341 (28:1341 Complaint for Forfeiture)",
      "28:1343" : "28:1343 (28:1343 Violation of Civil Rights)",
      "28:1345" : "28:1345 (28:1345 USA Plaintiff)",
      "28:1345co" : "28:1345co (28:1345 Replevin & Conversion)",
      "28:1345db" : "28:1345db (28:1345 Debt to US - FHA/HUD Title I)",
      "28:1345df" : "28:1345df (28:1345 Default of Promissory Note)",
      "28:1345er" : "28:1345er (28:1345 Recovery of Erroneous Refund)",
      "28:1345fc" : "28:1345fc (28:1345 Foreclosure)",
      "28:1345ff" : "28:1345ff (28:1345 Complaint for Forfeiture)",
      "28:1345hl" : "28:1345hl (28:1345 VA Home Loan Guaranty Debt)",
      "28:1345mc" : "28:1345mc (28:1345 Medical Care Recovery)",
      "28:1345mi" : "28:1345mi (28:1345 Mining Claim Ejectment)",
      "28:1345pd" : "28:1345pd (28:1345 Property Damage)",
      "28:1345pe" : "28:1345pe (28:1345 Property Ejectment)",
      "28:1345rc" : "28:1345rc (28:1345 Recovery of Debt to US)",
      "28:1345st" : "28:1345st (28:1345 Default of Student Loan)",
      "28:1345tp" : "28:1345tp (28:1345 Trespass on Public Land)",
      "28:1345va" : "28:1345va (28:1345 Recovery of VA Overpayment)",
      "28:1346bc" : "28:1346bc (28:1346 Breach of Contract)",
      "28:1346rc" : "28:1346rc (28:1346 Recovery of IRS Tax)",
      "28:1346tc" : "28:1346tc (28:1346 Tort Claim)",
      "28:1346wd" : "28:1346wd (28:1346 Wrongful Death)",
      "28:1349" : "28:1349 (28:1348 Corporation organized under Federal Law as party)",
      "28:1352" : "28:1352 (28:1352 Miller Act)",
      "28:1355" : "28:1355 (28:1355 Petition for Return of Property)",
      "28:1358" : "28:1358 (28:1358 Land Condemnation)",
      "28:1361" : "28:1361 (28:1361 Petition for Writ of Mandamus)",
      "28:1362ic" : "28:1362ic (28:1362 Indian Tribal Controversy)",
      "28:1362iw" : "28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)",
      "28:1364" : "28:1364 (28:1364 Auto Negligence)",
      "28:1391" : "28:1391 (28:1391 Personal Injury)",
      "28:1402" : "28:1402 (28:1402 Medical Malpractice)",
      "28:1407" : "28:1407 (28:1407 Airline Crash)",
      "28:1441ac" : "28:1441ac (28:1441 Petition for Removal- Account Receivable)",
      "28:1441al" : "28:1441al (28:1441 Petition for Removal- Airline Crash)",
      "28:1441as" : "28:1441as (28:1441 Petition for Removal- Asbestos Litigation)",
      "28:1441au" : "28:1441au (28:1441 Petition for Removal- Auto Negligence)",
      "28:1441bc" : "28:1441bc (28:1441 Petition for Removal- Breach of Contract)",
      "28:1441cv" : "28:1441cv (28:1441 Petition for Removal- Civil Rights Act)",
      "28:1441df" : "28:1441df (28:1441 Petition for Removal- Contract Default)",
      "28:1441dj" : "28:1441dj (28:1441 Petition for Removal- Declaratory Judgemen)",
      "28:1441ds" : "28:1441ds (28:1441 Petition for Removal- Contract Dispute)",
      "28:1441ed" : "28:1441ed (28:1441 Petition for Removal - Employment Discrim)",
      "28:1441fc" : "28:1441fc (28:1441 Petition for Removal - Fair Credit Reporti)",
      "28:1441fr" : "28:1441fr (28:1441 Petition for Removal- Fraud)",
      "28:1441ij" : "28:1441ij (28:1441 Petition for Removal- Injunctive/Declarato)",
      "28:1441in" : "28:1441in (28:1441 Petition for Removal- Insurance Contract)",
      "28:1441int" : "28:1441int (28:1441 Petition for Removal- Action for Interplea)",
      "28:1441lb" : "28:1441lb (28:1441 Petition for Removal Libel,Assault,Slander)",
      "28:1441lm" : "28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relatio)",
      "28:1441mm" : "28:1441mm (28:1441 Petition for Removal- Medical Malpractice)",
      "28:1441ni" : "28:1441ni (28:1441 Petition for Removal- Negotiable Instrumen)",
      "28:1441nm" : "28:1441nm (28:1441 Petition for Removal- Non-Motor Vehicle)",
      "28:1441nr" : "28:1441nr (28:1441 Notice of Removal)",
      "28:1441oc" : "28:1441oc (28:1441 Petition For Removal--Other Contract)",
      "28:1441pd" : "28:1441pd (28:1441 Petition for Removal- Property Damage)",
      "28:1441pi" : "28:1441pi (28:1441 Petition for Removal- Personal Injury)",
      "28:1441pl" : "28:1441pl (28:1441 Petition for Removal- Product Liability)",
      "28:1441pr" : "28:1441pr (28:1441 Petition for Removal)",
      "28:1441qt" : "28:1441qt (28:1441 Petition for Removal- Petition to Quiet Ti)",
      "28:1441ri" : "28:1441ri (28:1441 Petition for Removal- Racketeering (RICO))",
      "28:1441sa" : "28:1441sa (28:1441 - Petition for Removal: SEC Act)",
      "28:1441sf" : "28:1441sf (28:1441 - Petition for Removal: Securities Fraud)",
      "28:1441tl" : "28:1441tl (28:1441 Petition for Removal- Torts to Land)",
      "28:1441tm" : "28:1441tm (28:1441 Petition for Removal- Tort/Motor Vehicle ()",
      "28:1441tn" : "28:1441tn (28:1441 Petition for Removal- Tort/Non-Motor Vehic)",
      "28:1441wd" : "28:1441wd (28:1441 Petition for Removal- Wrongful Death)",
      "28:1442bc" : "28:1442bc (28:1442 Petition for Removal- Breach of Contract)",
      "28:1442nr" : "28:1442nr (28:1442 Notice of Removal)",
      "28:1442pr" : "28:1442pr (28:1442 Petition for Removal)",
      "28:1443" : "28:1443 (28:1443(1) Rent, Lease & Ejectment)",
      "28:1444" : "28:1444 (28:1444 Petition for Removal- Foreclosure)",
      "28:1446in" : "28:1446in (28:1446 Breach of Contract- Insurance)",
      "28:1446nr" : "28:1446nr (28:1446 Notice of Removal)",
      "28:1446pd" : "28:1446pd (28:1446 Petition for Removal- Property Damage (P.I)",
      "28:1446pi" : "28:1446pi (28:1446 Petition for Removal- Personal Injury)",
      "28:1446pl" : "28:1446pl (28:1446pl Petition for Removal - Product Liability)",
      "28:1446pr" : "28:1446pr (28:1446 Petition for Removal)",
      "28:1452" : "28:1452 (28:1452 Removal of Claim in Civil Action Related to BK Case)",
      "28:1455" : "28:1455 (28:1455 Notice of Removal of Criminal Prosecution)",
      "28:1651" : "28:1651 (28:1651 Petition for Writ of Coram Nobis)",
      "28:1651hc" : "28:1651hc (28:1651 Petition for Writ of Habeas Corpus)",
      "28:1651mn" : "28:1651mn (28:1651 Petition for Writ of Mandamus)",
      "28:1782" : "28:1782 (28:1782 Letter rogatory - appointment)",
      "28:2201" : "28:2201 (28:2201 Constitutionality of State Statute(s))",
      "28:2201dj" : "28:2201dj (28:2201 Declaratory Judgment)",
      "28:2201ij" : "28:2201ij (28:2201 Injunction)",
      "28:2201in" : "28:2201in (28:2201 Declaratory Judgment (Insurance))",
      "28:2241" : "28:2241 (28:2241 Petition for Writ of Habeas Corpus)",
      "28:2254" : "28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))",
      "28:2254se" : "28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)",
      "28:2255" : "28:2255 (28:2255 Motion to Vacate / Correct Illegal Sentence)",
      "28:2271" : "28:2271 (28:2271 Federal Tort Claims Act)",
      "28:2345" : "28:2345 (28:2345 Medicare Recovery)",
      "28:2409" : "28:2409 (28:2409(a) Quiet Title Action)",
      "28:2410" : "28:2410 (28:2410 Quiet Title)",
      "28:2671" : "28:2671 (28:2671 Federal Tort Claims Act)",
      "28:2674" : "28:2674 (28:2674 Federal Tort Claims Act)",
      "28:3001" : "28:3001 (Federal Debt Collection Act)",
      "28:3203" : "28:3203 (28:3203 Execution)",
      "28:3205" : "28:3205 (Garnishment)",
      "28:7402" : "28:7402 (28:7402 Refund of Taxes)",
      "28:7422" : "28:7422 (28:7422 Appeal from Administrative Decision)",
      "29:0151" : "29:0151 (29:151 Labor: Review of Agency Action)",
      "29:0160" : "29:0160 (29:160(1) National Labor Relations Act)",
      "29:0184" : "29:0184 (29:184 Violation Collection Bargain Agreement)",
      "29:0185ep" : "29:0185ep (29:185 Employee Pension Plan)",
      "29:0185lm" : "29:0185lm (29:185 Labor/Mgt. Relations (Contracts))",
      "29:0201do" : "29:0201do (29:201 Denial of Overtime Compensation)",
      "29:0201fl" : "29:0201fl (29:201 Fair Labor Standards Act)",
      "29:0203" : "29:0203 (29:203 Equal Pay Act)",
      "29:0206" : "29:0206 (29:206 Collect Unpaid Wages)",
      "29:0401" : "29:0401 (29:0401 Labor Management Disclosure Act)",
      "29:0621" : "29:0621 (29:621 Job Discrimination (Age))",
      "29:0623" : "29:0623 (29:623 Job Discrimination (Age))",
      "29:0626" : "29:0626 (29:626 Job Discrimination (Age))",
      "29:0633" : "29:0633 (29:633 Job Discrimination (Age))",
      "29:0651" : "29:0651 (29:651 Occupational Safety/Health)",
      "29:0754" : "29:0754 (29:754 Discrimination)",
      "29:0791" : "29:0791 (29:791 Job Discrimination (Rehabilitation Act))",
      "29:0794" : "29:0794 (29:0794 Job Discrimination (Handicap))",
      "29:1001" : "29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)",
      "29:1002" : "29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)",
      "29:1104" : "29:1104 (29:1104 Recovery of Benefits to Employee)",
      "29:1109" : "29:1109 (29:1109 Breach of Fiduciary Duties)",
      "29:1131" : "29:1131 (29:1131 ERISA - Collection of Delinquent Trust Fun)",
      "29:1132" : "29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)",
      "29:1145" : "29:1145 (29:1145 E.R.I.S.A.)",
      "29:1149" : "29:1149 (29:1149 Recover Pension & Profit Sharing)",
      "29:1337" : "29:1337 (29:1337 E.R.I.S.A.)",
      "29:1362" : "29:1362 (29:1362 ERISA)",
      "29:1381" : "29:1381 (29:1381 E.R.I.S.A.)",
      "29:1401" : "29:1401 (29:1401(b)(2) Appeal of Arbitration Award)",
      "29:1451" : "29:1451 (29:1451 E.R.I.S.A.)",
      "29:1801" : "29:1801 (29:1801 Farmworker Rights)",
      "29:2101" : "29:2101 (29:2101 Exclusions from Definition of Loss of Employment)",
      "29:2601" : "29:2601 (29:2615 Family and Medical Leave)",
      "29:790" : "29:790 (29:790 Rehabilitation of Labor)",
      "30:0181" : "30:0181 (30:181 Environment: Review of Agency Action)",
      "30:0801" : "30:0801 (30:0801 Penalities/Federal Mine Safety Health Act)",
      "30:1201" : "30:1201 (30:1201 Environment: Review of Agency Action)",
      "30:1202" : "30:1202 (30:1202 Mining Reclamation Act)",
      "30:1276" : "30:1276 (30:1276 Interior: Review of Agency Action)",
      "31:3545" : "31:3545 (31:3545 Action to Recovery Money)",
      "31:3729" : "31:3729 (31:3729 False Claims Act)",
      "31:3730" : "31:3730 (31:3730 Qui Tam False Claims Act)",
      "31:3731" : "31:3731 (31:3731 Fraud)",
      "33:1319cw" : "33:1319cw (33:1319 Clean Water Act)",
      "33:1319pv" : "33:1319pv (33:1319 Pollutants & Permit Violations)",
      "33:1365" : "33:1365 (33:1365 Environmental Matters)",
      "35:0145" : "35:0145 (35:145 Patent Infringement)",
      "35:0183" : "35:0183 (35:183 Patent Infringement)",
      "35:0271" : "35:0271 (35:271 Patent Infringement)",
      "38:1681" : "38:1681 (38:1681 Recovery of VA Overpayment)",
      "38:1686" : "38:1686 (38:1686 Recovery of VA Overpayment)",
      "38:1780" : "38:1780 (38:1780 Recovery of VA Overpayment)",
      "38:1891" : "38:1891 (38:1891 VA Home Loan Default)",
      "38:2011" : "38:2011 (38:2011 - Veteran's Readjustment Assistance Act of)",
      "38:2021" : "38:2021 (Right to re-employment of inducted persons)",
      "38:3116" : "38:3116 (38:3116 VA Overpayment)",
      "38:4311" : "38:4311 (38:4311 Discrimination Against Persons Who Serve in the Uniformed Services)",
      "38:775" : "38:775 (Recovery of Servicemen's Group Life Insurance)",
      "39:3005" : "39:3005 (39:3005 Detention of Mail for Temporary Periods)",
      "39:409" : "39:409 (39:409 Postal Service)",
      "40:0258" : "40:0258 (40:258(a) Public Buildings & Property: Land Condem)",
      "40:0270" : "40:0270 (40:270 Miller Act)",
      "40:0875" : "40:0875 (40:875 Public Buildings & Property: Negligence)",
      "40:3131" : "40:3131 (40:3131 Miller Act)",
      "41:0251" : "41:0251 (41:251 Public Contracts-Review of Agency Action)",
      "41:1463" : "41:1463 (41:1463 Public Contracts: Unlawful Employment Prac)",
      "42:0205" : "42:0205 (42:205 Denial Social Security Benefits)",
      "42:0206" : "42:0206 (42:206 Social Security Benefits)",
      "42:0247" : "42:0247 (42:247 Personal Injury-Swine Flu)",
      "42:0402" : "42:0402 (42:402 Social Security Benefits)",
      "42:0405id" : "42:0405id (42:405 Review of HHS Decision (SSID))",
      "42:0405wc" : "42:0405wc (42:405 Review of HHS Decision (DIWC))",
      "42:0405ww" : "42:0405ww (42:405 Review of HHS Decision (DIWW))",
      "42:0416" : "42:0416 (42:416 Denial of Social Security Benefits)",
      "42:0427" : "42:0427 (42:427 Social Security Benefits)",
      "42:0659" : "42:0659 (42:659 Enforcement of Child Support Obligations)",
      "42:1383" : "42:1383 (42:1383 Review of HHS Decision)",
      "42:1395" : "42:1395 (42:1395 HHS: Adverse Reimbursement Review)",
      "42:1396" : "42:1396 (42:1396 - Tort Negligence)",
      "42:1471" : "42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclo)",
      "42:1981cv" : "42:1981cv (42:1981 Civil Rights)",
      "42:1981hs" : "42:1981hs (42:1981 Housing Discrimination)",
      "42:1981jb" : "42:1981jb (42:1981 Job Discrimination (Race))",
      "42:1981sx" : "42:1981sx (42:1981 Sex Discrimination)",
      "42:1983cv" : "42:1983cv (42:1983 Civil Rights Act)",
      "42:1983ed" : "42:1983ed (42:1983 Civil Rights (Employment Discrimination))",
      "42:1983pr" : "42:1983pr (42:1983 Prisoner Civil Rights)",
      "42:1986" : "42:1986 (42:1986 Neglect of Duty)",
      "42:2000ag" : "42:2000ag (42:2000 Job Discrimination (Age))",
      "42:2000e" : "42:2000e (42:2000e Job Discrimination (Employment))",
      "42:2000pb" : "42:2000pb (42:2000 Job Discrimination (Public Accomodations))",
      "42:2000ra" : "42:2000ra (42:2000 Job Discrimination (Race))",
      "42:2000sx" : "42:2000sx (42:2000 Job Discrimination (Sex))",
      "42:2003" : "42:2003 (42:2003 Job Discrimination)",
      "42:2005" : "42:2005 (42:2005 Review of Agency Action-HHS)",
      "42:2615" : "42:2615 (42:2616 Medical Recovery Act)",
      "42:2651" : "42:2651 (42:2651 Medical Care Recovery)",
      "42:3601" : "42:3601 (42:405 Fair Housing Act)",
      "42:4000" : "42:4000 (42:4000 National Flood Insurance Act)",
      "42:4001" : "42:4001 (42:4001 National Insurance Flood Act)",
      "42:4053" : "42:4053 (42:4053 Breach of Insurance Contract)",
      "42:4072" : "42:4072 (42:4072 Payment of Flood Insurance Claim)",
      "42:4321" : "42:4321 (42:4321 Review of Agency Action-Environment)",
      "42:4332" : "42:4332 (42:4332 Environmental Policy - Coop of Agency Repo)",
      "42:6901en" : "42:6901en (42:6901 Environmental Cleanup Expenses)",
      "42:6901rs" : "42:6901rs (42:6901 Resource & Recovery Act)",
      "42:7413" : "42:7413 (42:7413(b) Clean Air Act)",
      "42:7547" : "42:7547 (Nonroad Engines and Vehicles)",
      "42:7604cl" : "42:7604cl (42:7604 Clear Air Act (Emission Standards))",
      "42:7604ir" : "42:7604ir (42:7604 Petition to Quash IRS Summons)",
      "42:9607" : "42:9607 (42:9607 Real Property Tort to Land)",
      "43:945" : "43:945 (43:945 Compensation for Land Condemnation)",
      "43:945a" : "43:945a (43:945a Complaint in Condemnation)",
      "43:946" : "43:946 (43:946 Complaint in Condemnation - Eminent Domain)",
      "45:0051" : "45:0051 (45:51 Railways: Fed. Employer's Liability Act)",
      "45:0151" : "45:0151 (45:151 Railway Labor Act)",
      "45:0184" : "45:0184 (45:184 Action to Set Aside Award of a System Board)",
      "45:1395" : "45:1395 (45:1395 Railroads: Adverse Reimbursement Review)",
      "45:7457" : "45:7457 (45:7457 Compel Reclamation Under Clear Air Act)",
      "46:0688" : "46:0688 (46:688 Jones Act)",
      "46:0741" : "46:0741 (46:741 Shipping)",
      "46:0761" : "46:0761 (46:761 Shipping: Damages for Death on High Seas)",
      "46:1101" : "46:1101 (46:1101 Violation of Maritime Regulations)",
      "46:1156" : "46:1156 (46:1156 Administrative Procedure Act)",
      "47:151" : "47:151 (47:151 FCC)",
      "47:206" : "47:206 (47:206 Carriers' Liability for Damages)",
      "47:222" : "47:222 (47:222 Telecommunications Act of 1996)",
      "47:227" : "47:227 (47:227 Restrictions on Use of Telephone Equipment)",
      "47:332" : "47:332 (47:332 Mobile Services)",
      "48:0883" : "48:0883 (48:883 Violation of US Coastal Law)",
      "48:1985" : "48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)",
      "49:0081" : "49:0081 (49:81 Damaged Goods While Being Transported)",
      "49:0781" : "49:0781 (49:781 Forfeiture)",
      "49:11503" : "49:11503 (49:11503 Railroad Revitalization Regulatory Reform)",
      "49:11702" : "49:11702 (49:11702(a)(4) Violations of Interstate Commerce A)",
      "49:1471" : "49:1471 (49:1471 Federal Aviation Act)",
      "49:1903" : "49:1903 (49:1903 Petition to enforce administrative summon)",
      "99:9999" : "99:9999 (99:9999 Report cause code (DO NOT DELETE!))",
      "adsup" : "adsup (Administrative Subpoena)",
      "contempt" : "contempt (Contempt Proceedings)",
      "disbar" : "disbar (Disbarment Proceedings)",
      "fordepo" : "fordepo (Foreign Deposition)",
      "misc" : "misc (Civil Miscellaneous Case)",
      "motcomp" : "motcomp (Motion to Compel)",
      "motquash" : "motquash (Motion to Quash)",
      "motret" : "motret (Motion for Return of Property)",
      "petenf" : "petenf (Petition to Enforce IRS Summons)",
      "petper" : "petper (Petition to Perpetuate Testimony)",
      "regjgm" : "regjgm (Registration of Foreign Judgment)",
      "tranbkref" : "tranbkref (Transmission of Bankruptcy Reference)",
      "tranff" : "tranff (Transmission of Proposed Findings of Fact and Concl. of Law)",
      "writgar" : "writgar (Application for a Writ of Garnishment)"
   },
   "txsdce" : {
      "0" : "0 (No cause code entered)",
      "02:0431" : "02:0431 (02:431 Fed. Election Commission: Failure Enforce C)",
      "02:0437" : "02:0437 (02:437 Federal Election Commission)",
      "05:0075" : "05:0075 (05:75(2) Contract - Reduction in Grade)",
      "05:0551" : "05:0551 (05:551 Administrative Procedure Act)",
      "05:0552fi" : "05:0552fi (05:552 Freedom of Information Act)",
      "05:0552pa" : "05:0552pa (05:552 Right to Privacy Act)",
      "05:0554" : "05:0554 (05:0554 Constitutionality of Maritime Statutes)",
      "05:0701" : "05:0701 (05:0701 Maritime Subsidy Board)",
      "05:0702" : "05:0702 (05:702 Administrative Procedure Act)",
      "05:0704" : "05:0704 (05:704 Labor Litigation)",
      "05:7703" : "05:7703 (05:7703 Discrimination - Review of Agency Act)",
      "05:8470" : "05:8470 (05:8470 Enforcement of Judgment against Retirement Benefits)",
      "05:8701" : "05:8701 (05:8701 FEGLA)",
      "05:8901" : "05:8901 (05:8901 FEHBA)",
      "07:0006" : "07:0006 (7:6(b) Federal Commodity Exchange Regulation)",
      "07:0025" : "07:0025 (7:25 Fraud - Commodities Leverage Contracts)",
      "07:0181" : "07:0181 (07:181 Packers & Stockyard Act)",
      "07:0499" : "07:0499 (07:499 Agricultural Commodities Act)",
      "07:0601" : "07:0601 (07:601 USDA Condemnation)",
      "07:2023" : "07:2023 (07:2023 Food Stamp Act)",
      "07:2321" : "07:2321 (07:2321 Plant Variety Protection Act)",
      "08:1105" : "08:1105 (8:1105(a) Aliens: Habeas Corpus to Release INS Det)",
      "08:1182" : "08:1182 (8:1182 Defend. Denial of Pla. Appl. for Alien Employment Cer)",
      "08:1252" : "08:1252 (08:1252(a)(2) Injunction for Deportation)",
      "08:1260" : "08:1260 (08:1260 Aliens: Access to Records)",
      "08:1324" : "08:1324 (08:1324 Aliens: Complaint for Forfeiture)",
      "08:1329" : "08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petiti)",
      "08:1446" : "08:1446 (8:1446 Petition for Naturalization Hearing)",
      "08:1451(j)" : "08:1451(j) (8:1451(j) Motion to Correct Order & Judg. of Naturalization)",
      "09:0001" : "09:0001 (09:1 U.S. Arbitration Act)",
      "09:0009" : "09:0009 (9:9 Motion to Confirm Arbitration Award)",
      "09:0010" : "09:0010 (09:0010 Petition to Vacate Arbitration Award)",
      "10:1408" : "10:1408 (10:1408 Claim for Military Retirement)",
      "10:1552" : "10:1552 (10:1552 Armed Forces: Action to Correct Records)",
      "10:1553" : "10:1553 (10:1553 Armed Forces: FOIA General)",
      "10:2305" : "10:2305 (10:2305 Review of Federal Contract)",
      "11:0101" : "11:0101 (11:101 Bankruptcy)",
      "12:0022" : "12:0022 (12:22 Securities Fraud)",
      "12:0632" : "12:0632 (12:0632 International Banking)",
      "12:0635" : "12:0635 (12:635 Breach of Insurance Contract)",
      "12:1461" : "12:1461 (12:1461 Homeowners Loan Act)",
      "12:1464" : "12:1464 (12:1464 Federal Savings and Loan)",
      "12:1703" : "12:1703 (12:1703 Default of HUD Loan)",
      "12:1725" : "12:1725 (12:1725 Collection under Contract Guaranty)",
      "12:1730" : "12:1730 (12:1730 Collection Under Contract Guaranty)",
      "12:1818" : "12:1818 (12:1818 Federal Reserve Act)",
      "12:1819" : "12:1819 (12:1819 Default of Promissory Note)",
      "12:1821" : "12:1821 (12:1821 Default of Loan by Promissary Note)",
      "12:191" : "12:191 (12:191 Bank Foreclosure)",
      "12:192" : "12:192 (12:192 Liquidation of National Bank)",
      "12:1971" : "12:1971 (12:1971 Relief under Bank Holding Act)",
      "12:1972" : "12:1972 (12:1972 Typing Arrangement Act)",
      "12:3410" : "12:3410 (12:3410 Right to Financial Privacy Act)",
      "15:0001" : "15:0001 (15:1 Antitrust Litigation)",
      "15:0002at" : "15:0002at (15:2 Antitrust Litigation)",
      "15:0002fl" : "15:0002fl (15:2(a) Fair Labor Standards Act)",
      "15:0005" : "15:0005 (15:5(a) Fair Labor Standards Act)",
      "15:0015" : "15:0015 (15:15 Antitrust Litigation)",
      "15:0025" : "15:0025 (15:25 Clayton Act)",
      "15:0044" : "15:0044 (15:44 Trademark Infringement)",
      "15:0045" : "15:0045 (15:0045 Federal Trade Commission Act)",
      "15:0052" : "15:0052 (15:0052 Federal Trade Commission Act)",
      "15:0053" : "15:0053 (15:0053 Federal Trade Commission Act)",
      "15:0077" : "15:0077 (15:77 Securities Fraud)",
      "15:0078" : "15:0078 (15:78m(a) Securities Exchange Act)",
      "15:0080" : "15:0080 (15:0080 Companies and Advisors)",
      "15:0631" : "15:0631 (15:631 Small Business Act)",
      "15:0717" : "15:0717 (15:717 Natural Gas Act)",
      "15:0754" : "15:0754 (15:754 Emergency Petroleum Allocation-Admin.& Enforcement)",
      "15:1051" : "15:1051 (15:1051 Trademark Infringement)",
      "15:1114" : "15:1114 (15:1114 Trademark Infringement)",
      "15:1121" : "15:1121 (15:1121 Trademark Infringement)",
      "15:1125" : "15:1125 (15:1125 Trademark Infringement (Lanham Act))",
      "15:1126" : "15:1126 (15:1126 Patent Infringement)",
      "15:1127" : "15:1127 (15:1127 Trademark Infringement)",
      "15:1314" : "15:1314 (15:1314 Antitrust Civil Process Act)",
      "15:1601" : "15:1601 (15:1601 Truth in Lending)",
      "15:1640" : "15:1640 (15:1640 Truth in Lending)",
      "15:1681" : "15:1681 (15:1681 Fair Credit Reporting Act)",
      "15:1692" : "15:1692 (15:1692 Fair Debt Collection Act)",
      "15:1938" : "15:1938 (15:1938 Fair Labor Standards Act)",
      "15:1981" : "15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))",
      "15:1988" : "15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))",
      "15:1989" : "15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))",
      "15:2051" : "15:2051 (15:2051 Consumer Products Safety Act)",
      "15:2301" : "15:2301 (15:2301 Magnuson-Moss Warranty Act)",
      "15:2801" : "15:2801 (15:2801 Petroleum Marketing Practices Act)",
      "15:53(b)" : "15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equita)",
      "16:0668" : "16:0668 (16:668 Bald Eagle Protection Act)",
      "16:0703" : "16:0703 (16:703 Migratory Bird Act)",
      "16:1531" : "16:1531 (16:1531 Endangered Species Act)",
      "16:1538" : "16:1538 (16:1538 Endangered Species Act)",
      "16:3371" : "16:3371 (16:3371 Wildlife Under the Lacey Act)",
      "16:3372" : "16:3372 (16:3372 Conservation: Complaint for Forfeiture)",
      "16:3373" : "16:3373 (16:3373 Appeal of Decision - DOI)",
      "16:3374" : "16:3374 (16:3374 Conservation: Complaint for Forfeiture)",
      "17:0101" : "17:0101 (17:101 Copyright Infringement)",
      "17:0501" : "17:0501 (17:501 Copyright Infringement)",
      "17:0504" : "17:0504 (17:504 Copyright Infringement)",
      "18:0241" : "18:0241 (18:241 Conspiracy Against Citizen Rights)",
      "18:0511" : "18:0511 (18:0511 Motor Vehicle Theft Prevention Act)",
      "18:0981" : "18:0981 (18:0981 Forfeiture in Rem)",
      "18:1702" : "18:1702 (18:1702 Postal Service (Obstruction))",
      "18:1836a" : "18:1836a (18:1836(a) Injunction against Misappropriation of Trade Secrets)",
      "18:1836b" : "18:1836b (18:1836(b) Civil Action to Protect Trade Secrets)",
      "18:1961" : "18:1961 (18:1961 Racketeering (RICO) Act)",
      "18:1962" : "18:1962 (18:1962 Racketeering (RICO) Act)",
      "18:1964" : "18:1964 (18:1964 Racketeering (RICO) Act)",
      "18:2511" : "18:2511 (18:2511 Wiretapping)",
      "18:3114" : "18:3114 (18:3114 Motion for Return of Seized Property)",
      "18:4208" : "18:4208 (18:4208(B) Agency Action Review)",
      "19:1305" : "19:1305 (19:1305 Custom Duties:0Forfeiture-Immoral Articles)",
      "20:1080" : "20:1080 (20:1080 Student Loan Recovery)",
      "20:1091" : "20:1091 (20:1091 Recovery of IRS Offset)",
      "20:1400" : "20:1400 (20:1400 Civil Rights of Handicapped Child)",
      "20:1401" : "20:1401 (20:1401 Education: Handicapped Child Act)",
      "21:0301" : "21:0301 (21:0301 Fed Food Drug Cosmetic Act)",
      "21:0841" : "21:0841 (21:841 Forfeiture Property-Drugs)",
      "21:0881" : "21:0881 (21:881 Forfeiture Property-Drugs)",
      "21:0881a" : "21:0881a (21:881 Forfeiture Property - Aircraft)",
      "21:0881re" : "21:0881re (21:881 Forfeiture Property - Real Estate)",
      "21:2101" : "21:2101 (21:2101 Warn Act)",
      "23:0134" : "23:0134 (23:134 P.I.- Auto Negligence)",
      "23:1441" : "23:1441 (23:1441 Contract Real Estate)",
      "24:1000" : "24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)",
      "25:0640" : "25:0640 (25:640 Indian Tribal Rights)",
      "25:1901" : "25:1901 (25:1901 Indian Child Welfare Act)",
      "26:5872" : "26:5872 (26:5872 Forfeitures)",
      "26:6212" : "26:6212 (26:6212 Injunctive Relief from IRS Lien)",
      "26:6213" : "26:6213 (26:6213 Injunctive Relief from IRS Lien)",
      "26:6321" : "26:6321 (26:6321 Lein for Taxes)",
      "26:6502" : "26:6502 (26:6502 IRS:Enforcement of tax liens)",
      "26:6532" : "26:6532 (26:6532 IRS: Refund of Tax Penalty)",
      "26:6702" : "26:6702 (26:6702 IRS: Refund of Income Tax Penalty)",
      "26:6703" : "26:6703 (26:6703 IRS: Refund of Tax Penalty)",
      "26:7401" : "26:7401 (26:7401 IRS: Tax Liability)",
      "26:7402" : "26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)",
      "26:7403" : "26:7403 (26:7403 Suit to Enforce Federal Tax Lien)",
      "26:7405" : "26:7405 (26:7405 Recovery of Overpayment of Taxes)",
      "26:7422rt" : "26:7422rt (26:7422 IRS: Refund Taxes)",
      "26:7422rx" : "26:7422rx (26:7422 IRS: Refund Excise Tax)",
      "26:7426" : "26:7426 (26:7426 IRS: Wrongful Levy for Taxes)",
      "26:7429" : "26:7429 (26:7429 IRS: Tax Jeopardy Assessment)",
      "26:7609" : "26:7609 (26:7609 IRS: Petition to Quash IRS Summons)",
      "27:0185" : "27:0185 (27:185 Enforcement of Arbitration Award)",
      "28:0157c" : "28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)",
      "28:0157d" : "28:0157d (28:0157 Motion for Withdrawal of Reference)",
      "28:0157s" : "28:0157s (28:0157s Motion for Stay Pending Ruling)",
      "28:0158" : "28:0158 (28:0158 Notice of Appeal re Bankruptcy Matter (BA))",
      "28:0185" : "28:0185 (28:185 Suit to Compel Arbitration)",
      "28:0451" : "28:0451 (28:451 Employment Discrimination)",
      "28:0754" : "28:0754 (28:754 Receiver of Property in Different Districts)",
      "28:0794" : "28:0794 (28:794 Rehabilitation Act)",
      "28:1001" : "28:1001 (28:1001 E.R.I.S.A.)",
      "28:1132" : "28:1132 (28:1132 E.R.I.S.A.)",
      "28:1330" : "28:1330 (28:1330 Breach of Contract)",
      "28:1331" : "28:1331 (28:1331 Fed. Question)",
      "28:1331al" : "28:1331al (28:1331 Fed. Question: Airline Crash)",
      "28:1331at" : "28:1331at (28:1331 Fed. Question: Anti-trust)",
      "28:1331au" : "28:1331au (28:1331 Fed. Question: Auto Negligence)",
      "28:1331b" : "28:1331b (28:1331 Federal Question: Bivens Act)",
      "28:1331bc" : "28:1331bc (28:1331 Fed. Question: Breach of Contract)",
      "28:1331ca" : "28:1331ca (28:1331 Fed Question: Fed Communications Act of 1)",
      "28:1331cm" : "28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)",
      "28:1331cv" : "28:1331cv (28:1331 Federal Question: Other Civil Rights)",
      "28:1331ed" : "28:1331ed (28:1331 Fed. Question: Employment Discrimination)",
      "28:1331ej" : "28:1331ej (28:1331 Federal Question: Enforcement of Judgment)",
      "28:1331es" : "28:1331es (28:1331 Enforcement of Administrative Subpoena)",
      "28:1331fl" : "28:1331fl (28:1331 Fed. Question: Fair Labor Standards)",
      "28:1331in" : "28:1331in (28:1331 Fed. Question: Insurance Contract)",
      "28:1331mm" : "28:1331mm (28:1331 Fed. Question: Medical Malpractice)",
      "28:1331ng" : "28:1331ng (28:1331 Fed. Question: Natural Gas Act)",
      "28:1331pi" : "28:1331pi (28:1331 Fed. Question: Personal Injury)",
      "28:1331rd" : "28:1331rd (28:1331 Fed. Question: Review Agency Decision)",
      "28:1331rp" : "28:1331rp (28:1331(a) Fed. Question: Real Property)",
      "28:1331rr" : "28:1331rr (28:1331 Fed. Question: Railway Labor Act)",
      "28:1331sv" : "28:1331sv (28:1331 Fed. Question: Securities Violation)",
      "28:1331tr" : "28:1331tr (28:1331 Fed. Question: Trademark)",
      "28:1331tt" : "28:1331tt (28:1331 Fed. Question: Tort Action)",
      "28:1331v" : "28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendme)",
      "28:1331wl" : "28:1331wl (28:1331 Federal Question: EPA Waste Lien)",
      "28:1331wt" : "28:1331wt (28:1331 Fed. Question: Water Rights)",
      "28:1332ac" : "28:1332ac (28:1332 Diversity-Account Receivable)",
      "28:1332ai" : "28:1332ai (28:1332ai Diversity-Asbestos-Personal Injury)",
      "28:1332al" : "28:1332al (28:1332 Diversity-Airline Crash)",
      "28:1332as" : "28:1332as (28:1332 Diversity-Asbestos Litigation)",
      "28:1332au" : "28:1332au (28:1332 Diversity-Auto Negligence)",
      "28:1332aw" : "28:1332aw (28:1332aw Diversity-Asbestos-Wrongful Death)",
      "28:1332bc" : "28:1332bc (28:1332 Diversity-Breach of Contract)",
      "28:1332co" : "28:1332co (28:1332 Diversity-Conversion)",
      "28:1332ct" : "28:1332ct (28:1332 Diversity-(Citizenship))",
      "28:1332det" : "28:1332det (28:1332 Diversity: Forcible Detainer)",
      "28:1332df" : "28:1332df (28:1332 Diversity-Contract Default)",
      "28:1332ds" : "28:1332ds (28:1332 Diversity-Contract Dispute)",
      "28:1332ed" : "28:1332ed (28:1332 Diversity-Employment Discrimination)",
      "28:1332fd" : "28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)",
      "28:1332fr" : "28:1332fr (28:1332 Diversity-Fraud)",
      "28:1332ia" : "28:1332ia (28:1332 Diversity-Interpleader Action)",
      "28:1332ij" : "28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)",
      "28:1332in" : "28:1332in (28:1332 Diversity-Insurance Contract)",
      "28:1332jd" : "28:1332jd (28:1332 Diversity-Declaratory Judgment)",
      "28:1332lb" : "28:1332lb (28:1332 Diversity-Libel,Assault,Slander)",
      "28:1332lm" : "28:1332lm (28:1332 Diversity - Legal Malpractice)",
      "28:1332ma" : "28:1332ma (28:1332 Diversity-Miller Act)",
      "28:1332mm" : "28:1332mm (28:1332 Diversity-Medical Malpractice)",
      "28:1332mv" : "28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)",
      "28:1332ni" : "28:1332ni (28:1332 Diversity-Negotiable Instrument)",
      "28:1332nm" : "28:1332nm (28:1332 Diversity-Non-Motor Vehicle)",
      "28:1332nr" : "28:1332nr (28:1332 Diversity-Notice of Removal)",
      "28:1332oc" : "28:1332oc (28:1332 Diversity-Other Contract)",
      "28:1332pd" : "28:1332pd (28:1332 Diversity-Property Damage)",
      "28:1332pi" : "28:1332pi (28:1332 Diversity-Personal Injury)",
      "28:1332pl" : "28:1332pl (28:1332 Diversity-Product Liability)",
      "28:1332pr" : "28:1332pr (28:1332 Diversity-Petition for Removal)",
      "28:1332qt" : "28:1332qt (28:1332 Diversity-Petition to Quiet Title)",
      "28:1332ri" : "28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)",
      "28:1332sa" : "28:1332sa (28:1332 - Diversity: Securities & Exchange Commiss)",
      "28:1332sf" : "28:1332sf (28:1332 - Diversity: Securities Fraud)",
      "28:1332ss" : "28:1332ss (28:1332 Diversity - Stockholders Suits)",
      "28:1332tl" : "28:1332tl (28:1332 Diversity-Torts to Land)",
      "28:1332tm" : "28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))",
      "28:1332tn" : "28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)",
      "28:1332wd" : "28:1332wd (28:1332 Diversity-Wrongful Death)",
      "28:1333" : "28:1333 (28:1333 Admiralty)",
      "28:1334" : "28:1334 (28:1334 Bankruptcy Appeal)",
      "28:1334c" : "28:1334c (28:1334(c) R&R re motions for abstention (non-cor)",
      "28:1335" : "28:1335 (28:1335 Interpleader Action)",
      "28:1337" : "28:1337 (28:1337 Sherman-Clayton Act)",
      "28:1338cp" : "28:1338cp (28:1338 Copyright Infringement)",
      "28:1338pt" : "28:1338pt (28:1338 Patent Infringement)",
      "28:1338tr" : "28:1338tr (28:1338 Trademark Infringement)",
      "28:1340" : "28:1340 (28:1340 IRS: Custom Duties)",
      "28:1340er" : "28:1340er (28:1340 Recovery of Erroneous Refund)",
      "28:1341" : "28:1341 (28:1341 Complaint for Forfeiture)",
      "28:1343" : "28:1343 (28:1343 Violation of Civil Rights)",
      "28:1345" : "28:1345 (28:1345 USA Plaintiff)",
      "28:1345co" : "28:1345co (28:1345 Replevin & Conversion)",
      "28:1345db" : "28:1345db (28:1345 Debt to US - FHA/HUD Title I)",
      "28:1345df" : "28:1345df (28:1345 Default of Promissory Note)",
      "28:1345er" : "28:1345er (28:1345 Recovery of Erroneous Refund)",
      "28:1345fc" : "28:1345fc (28:1345 Foreclosure)",
      "28:1345ff" : "28:1345ff (28:1345 Complaint for Forfeiture)",
      "28:1345hl" : "28:1345hl (28:1345 VA Home Loan Guaranty Debt)",
      "28:1345mc" : "28:1345mc (28:1345 Medical Care Recovery)",
      "28:1345mi" : "28:1345mi (28:1345 Mining Claim Ejectment)",
      "28:1345pd" : "28:1345pd (28:1345 Property Damage)",
      "28:1345pe" : "28:1345pe (28:1345 Property Ejectment)",
      "28:1345rc" : "28:1345rc (28:1345 Recovery of Debt to US)",
      "28:1345st" : "28:1345st (28:1345 Default of Student Loan)",
      "28:1345tp" : "28:1345tp (28:1345 Trespass on Public Land)",
      "28:1345va" : "28:1345va (28:1345 Recovery of VA Overpayment)",
      "28:1346bc" : "28:1346bc (28:1346 Breach of Contract)",
      "28:1346rc" : "28:1346rc (28:1346 Recovery of IRS Tax)",
      "28:1346tc" : "28:1346tc (28:1346 Tort Claim)",
      "28:1346wd" : "28:1346wd (28:1346 Wrongful Death)",
      "28:1349" : "28:1349 (28:1348 Corporation organized under Federal Law as party)",
      "28:1352" : "28:1352 (28:1352 Miller Act)",
      "28:1355" : "28:1355 (28:1355 Petition for Return of Property)",
      "28:1358" : "28:1358 (28:1358 Land Condemnation)",
      "28:1361" : "28:1361 (28:1361 Petition for Writ of Mandamus)",
      "28:1362ic" : "28:1362ic (28:1362 Indian Tribal Controversy)",
      "28:1362iw" : "28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)",
      "28:1364" : "28:1364 (28:1364 Auto Negligence)",
      "28:1391" : "28:1391 (28:1391 Personal Injury)",
      "28:1402" : "28:1402 (28:1402 Medical Malpractice)",
      "28:1407" : "28:1407 (28:1407 Airline Crash)",
      "28:1441ac" : "28:1441ac (28:1441 Petition for Removal- Account Receivable)",
      "28:1441ai" : "28:1441ai (28:1441ai Notice of Removal-Asbestos-Personal Injury)",
      "28:1441al" : "28:1441al (28:1441 Petition for Removal- Airline Crash)",
      "28:1441as" : "28:1441as (28:1441 Petition for Removal- Asbestos Litigation)",
      "28:1441au" : "28:1441au (28:1441 Petition for Removal- Auto Negligence)",
      "28:1441aw" : "28:1441aw (28:1441aw Notice of Removal-Asbestos-Wrongful Death)",
      "28:1441bc" : "28:1441bc (28:1441 Petition for Removal- Breach of Contract)",
      "28:1441cv" : "28:1441cv (28:1441 Petition for Removal- Civil Rights Act)",
      "28:1441df" : "28:1441df (28:1441 Petition for Removal- Contract Default)",
      "28:1441dj" : "28:1441dj (28:1441 Petition for Removal- Declaratory Judgemen)",
      "28:1441ds" : "28:1441ds (28:1441 Petition for Removal- Contract Dispute)",
      "28:1441ed" : "28:1441ed (28:1441 Petition for Removal - Employment Discrim)",
      "28:1441fc" : "28:1441fc (28:1441 Petition for Removal - Fair Credit Reporti)",
      "28:1441fr" : "28:1441fr (28:1441 Petition for Removal- Fraud)",
      "28:1441ij" : "28:1441ij (28:1441 Petition for Removal- Injunctive/Declarato)",
      "28:1441in" : "28:1441in (28:1441 Petition for Removal- Insurance Contract)",
      "28:1441int" : "28:1441int (28:1441 Petition for Removal- Action for Interplea)",
      "28:1441lb" : "28:1441lb (28:1441 Petition for Removal Libel,Assault,Slander)",
      "28:1441lm" : "28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relatio)",
      "28:1441mm" : "28:1441mm (28:1441 Petition for Removal- Medical Malpractice)",
      "28:1441ni" : "28:1441ni (28:1441 Petition for Removal- Negotiable Instrumen)",
      "28:1441nm" : "28:1441nm (28:1441 Petition for Removal- Non-Motor Vehicle)",
      "28:1441nr" : "28:1441nr (28:1441 Notice of Removal)",
      "28:1441oc" : "28:1441oc (28:1441 Petition For Removal--Other Contract)",
      "28:1441pd" : "28:1441pd (28:1441 Petition for Removal- Property Damage)",
      "28:1441pi" : "28:1441pi (28:1441 Petition for Removal- Personal Injury)",
      "28:1441pl" : "28:1441pl (28:1441 Petition for Removal- Product Liability)",
      "28:1441pr" : "28:1441pr (28:1441 Petition for Removal)",
      "28:1441qt" : "28:1441qt (28:1441 Petition for Removal- Petition to Quiet Ti)",
      "28:1441ri" : "28:1441ri (28:1441 Petition for Removal- Racketeering (RICO))",
      "28:1441sa" : "28:1441sa (28:1441 - Petition for Removal: SEC Act)",
      "28:1441sf" : "28:1441sf (28:1441 - Petition for Removal: Securities Fraud)",
      "28:1441tl" : "28:1441tl (28:1441 Petition for Removal- Torts to Land)",
      "28:1441tm" : "28:1441tm (28:1441 Petition for Removal- Tort/Motor Vehicle ()",
      "28:1441tn" : "28:1441tn (28:1441 Petition for Removal- Tort/Non-Motor Vehic)",
      "28:1441wd" : "28:1441wd (28:1441 Petition for Removal- Wrongful Death)",
      "28:1442bc" : "28:1442bc (28:1442 Petition for Removal- Breach of Contract)",
      "28:1442nr" : "28:1442nr (28:1442 Notice of Removal)",
      "28:1442pr" : "28:1442pr (28:1442 Petition for Removal)",
      "28:1443" : "28:1443 (28:1443(1) Rent, Lease & Ejectment)",
      "28:1444" : "28:1444 (28:1444 Petition for Removal- Foreclosure)",
      "28:1446in" : "28:1446in (28:1446 Breach of Contract- Insurance)",
      "28:1446nr" : "28:1446nr (28:1446 Notice of Removal)",
      "28:1446pd" : "28:1446pd (28:1446 Petition for Removal- Property Damage (P.I)",
      "28:1446pi" : "28:1446pi (28:1446 Petition for Removal- Personal Injury)",
      "28:1446pl" : "28:1446pl (28:1446pl Petition for Removal - Product Liability)",
      "28:1446pr" : "28:1446pr (28:1446 Petition for Removal)",
      "28:1452" : "28:1452 (28:1452 R&R re motions to remand (non-core))",
      "28:1651" : "28:1651 (28:1651 Petition for Writ of Coram Nobis)",
      "28:1651hc" : "28:1651hc (28:1651 Petition for Writ of Habeas Corpus)",
      "28:1651mn" : "28:1651mn (28:1651 Petition for Writ of Mandamus)",
      "28:1782" : "28:1782 (28:1782 Letter rogatory - appointment)",
      "28:1875" : "28:1875 (28:1875 Protection of Juror Employment)",
      "28:1916" : "28:1916 (28:1916 Seaman's Act Case)",
      "28:1983" : "28:1983 (28:1983 Civil Rights)",
      "28:2201" : "28:2201 (28:2201 Constitutionality of State Statute(s))",
      "28:2201dj" : "28:2201dj (28:2201 Declaratory Judgment)",
      "28:2201ij" : "28:2201ij (28:2201 Injunction)",
      "28:2201in" : "28:2201in (28:2201 Declaratory Judgment (Insurance))",
      "28:2241" : "28:2241 (28:2241 Petition for Writ of Habeas Corpus (federa)",
      "28:2254" : "28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))",
      "28:2254dp" : "28:2254dp (28:2254 Petition for Writ of Habeas Corpus(Death Penalty))",
      "28:2254se" : "28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)",
      "28:2255" : "28:2255 (28:2255 Motion to Vacate / Correct Illegal Sentenc)",
      "28:2271" : "28:2271 (28:2271 Federal Tort Claims Act)",
      "28:2345" : "28:2345 (28:2345 Medicare Recovery)",
      "28:2409" : "28:2409 (28:2409(a) Quiet Title Action)",
      "28:2410" : "28:2410 (28:2410 Quiet Title)",
      "28:2671" : "28:2671 (28:2671 Federal Tort Claims Act)",
      "28:2674" : "28:2674 (28:2674 Federal Tort Claims Act)",
      "28:3001" : "28:3001 (28:3001 Federal Debt Collection Act)",
      "28:7402" : "28:7402 (28:7402 Refund of Taxes)",
      "28:7422" : "28:7422 (28:7422 Appeal from Administrative Decision)",
      "29:0151" : "29:0151 (29:151 Labor: Review of Agency Action)",
      "29:0160" : "29:0160 (29:160(1) National Labor Relations Act)",
      "29:0184" : "29:0184 (29:184 Violation Collection Bargain Agreement)",
      "29:0185ep" : "29:0185ep (29:185 Employee Pension Plan)",
      "29:0185lm" : "29:0185lm (29:185 Labor/Mgt. Relations (Contracts))",
      "29:0201do" : "29:0201do (29:201 Denial of Overtime Compensation)",
      "29:0201fl" : "29:0201fl (29:201 Fair Labor Standards Act)",
      "29:0203" : "29:0203 (29:203 Equal Pay Act)",
      "29:0206" : "29:0206 (29:206 Collect Unpaid Wages)",
      "29:0401" : "29:0401 (29:0401 Labor Management Disclosure Act)",
      "29:0621" : "29:0621 (29:621 Job Discrimination (Age))",
      "29:0623" : "29:0623 (29:623 Job Discrimination (Age))",
      "29:0626" : "29:0626 (29:626 Job Discrimination (Age))",
      "29:0633" : "29:0633 (29:633 Job Discrimination (Age))",
      "29:0651" : "29:0651 (29:651 Occupational Safety/Health)",
      "29:0754" : "29:0754 (29:754 Discrimination)",
      "29:0791" : "29:0791 (29:791 Job Discrimination (Rehabilitation Act))",
      "29:0794" : "29:0794 (29:0794 Job Discrimination (Handicap))",
      "29:1001" : "29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)",
      "29:1002" : "29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)",
      "29:1104" : "29:1104 (29:1104 Recovery of Benefits to Employee)",
      "29:1109" : "29:1109 (29:1109 Breach of Fiduciary Duties)",
      "29:1131" : "29:1131 (29:1131 ERISA - Collection of Delinquent Trust Fun)",
      "29:1132" : "29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)",
      "29:1145" : "29:1145 (29:1145 E.R.I.S.A.)",
      "29:1149" : "29:1149 (29:1149 Recover Pension & Profit Sharing)",
      "29:1337" : "29:1337 (29:1337 E.R.I.S.A.)",
      "29:1362" : "29:1362 (29:1362 ERISA)",
      "29:1381" : "29:1381 (29:1381 E.R.I.S.A.)",
      "29:1401" : "29:1401 (29:1401(b)(2) Appeal of Arbitration Award)",
      "29:1451" : "29:1451 (29:1451 E.R.I.S.A.)",
      "29:1801" : "29:1801 (29:1801 Farmworker Rights)",
      "29:2001" : "29:2001 (29:2001 Employee Polygraph Protection Act)",
      "29:2104" : "29:2104 (29:2104 WARN ACT)",
      "29:2601" : "29:2601 (29:2601 Family Medical Leave Act (FMLA))",
      "29:790" : "29:790 (29:790 Rehabilitation of Labor)",
      "30:0181" : "30:0181 (30:181 Environment: Review of Agency Action)",
      "30:0801" : "30:0801 (30:0801 Penalities/Federal Mine Safety Health Act)",
      "30:1201" : "30:1201 (30:1201 Environment: Review of Agency Action)",
      "30:1202" : "30:1202 (30:1202 Mining Reclamation Act)",
      "30:1276" : "30:1276 (30:1276 Interior: Review of Agency Action)",
      "31:3545" : "31:3545 (31:3545 Action to Recovery Money)",
      "31:3729" : "31:3729 (31:3729 False Claims Act)",
      "31:3730" : "31:3730 (31:3730 Qui Tam False Claims Act)",
      "31:3731" : "31:3731 (31:3731 Fraud)",
      "31:5316" : "31:5316 (31:5316 Report on Monetary Instruments)",
      "33:1319cw" : "33:1319cw (33:1319 Clean Water Act)",
      "33:1319pv" : "33:1319pv (33:1319 Pollutants & Permit Violations)",
      "33:1365" : "33:1365 (33:1365 Environmental Matters)",
      "35:0145" : "35:0145 (35:145 Patent Infringement)",
      "35:0183" : "35:0183 (35:183 Patent Infringement)",
      "35:0271" : "35:0271 (35:271 Patent Infringement)",
      "38:1681" : "38:1681 (38:1681 Recovery of VA Overpayment)",
      "38:1686" : "38:1686 (38:1686 Recovery of VA Overpayment)",
      "38:1780" : "38:1780 (38:1780 Recovery of VA Overpayment)",
      "38:2011" : "38:2011 (38:2011 - Veteran's Readjustment Assistance Act of)",
      "38:2021" : "38:2021 (38:2021 Right to re-employment of inducted persons)",
      "38:3116" : "38:3116 (38:3116 VA Overpayment)",
      "38:4212" : "38:4212 (38:4212 Vietnam Era Veterans Readjustment Act)",
      "38:775" : "38:775 (38:775 Recovery of Serviceman's Group Life Insurance)",
      "39:3005" : "39:3005 (39:3005 Detention of Mail for Temporary Periods)",
      "39:409" : "39:409 (39:409 Postal Service)",
      "40:0258" : "40:0258 (40:258(a) Public Buildings & Property: Land Condem)",
      "40:0270" : "40:0270 (40:270 Miller Act)",
      "40:0875" : "40:0875 (40:875 Public Buildings & Property: Negligence)",
      "41:0251" : "41:0251 (41:251 Public Contracts-Review of Agency Action)",
      "41:1463" : "41:1463 (41:1463 Public Contracts: Unlawful Employment Prac)",
      "42:0205" : "42:0205 (42:205 Denial Social Security Benefits)",
      "42:0206" : "42:0206 (42:206 Social Security Benefits)",
      "42:0247" : "42:0247 (42:247 Personal Injury-Swine Flu)",
      "42:0402" : "42:0402 (42:402 Social Security Benefits)",
      "42:0405id" : "42:0405id (42:405 Review of HHS Decision (SSID))",
      "42:0405wc" : "42:0405wc (42:405 Review of HHS Decision (DIWC))",
      "42:0405ww" : "42:0405ww (42:405 Review of HHS Decision (DIWW))",
      "42:0416" : "42:0416 (42:416 Denial of Social Security Benefits)",
      "42:0427" : "42:0427 (42:427 Social Security Benefits)",
      "42:11603" : "42:11603 (42:11603 ICARA)",
      "42:11607" : "42:11607 (42:11607 Int'l Child Abduction Act)",
      "42:12101" : "42:12101 (42:12101 American Disabilities Act)",
      "42:12188" : "42:12188 (42:12188 American Disabilities Act of 1990)",
      "42:1383" : "42:1383 (42:1383 Review of HHS Decision)",
      "42:1395" : "42:1395 (42:1395 HHS: Adverse Reimbursement Review)",
      "42:1396" : "42:1396 (42:1396 - Tort Negligence)",
      "42:1471" : "42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclo)",
      "42:1973" : "42:1973 (42:1973 Voting Rights Act)",
      "42:1981cv" : "42:1981cv (42:1981 Civil Rights)",
      "42:1981hs" : "42:1981hs (42:1981 Housing Discrimination)",
      "42:1981jb" : "42:1981jb (42:1981 Job Discrimination (Race))",
      "42:1981sx" : "42:1981sx (42:1981 Sex Discrimination)",
      "42:1983cv" : "42:1983cv (42:1983 Civil Rights Act)",
      "42:1983ed" : "42:1983ed (42:1983 Civil Rights (Employment Discrimination))",
      "42:1983pr" : "42:1983pr (42:1983 Prisoner Civil Rights)",
      "42:1986" : "42:1986 (42:1986 Neglect of Duty)",
      "42:2000" : "42:2000 (42:2000 Job Discrimination)",
      "42:2000ag" : "42:2000ag (42:2000 Job Discrimination (Age))",
      "42:2000e" : "42:2000e (42:2000e Job Discrimination (Employment))",
      "42:2000pb" : "42:2000pb (42:2000 Job Discrimination (Public Accomodations))",
      "42:2000ra" : "42:2000ra (42:2000 Job Discrimination (Race))",
      "42:2000sx" : "42:2000sx (42:2000 Job Discrimination (Sex))",
      "42:2003" : "42:2003 (42:2003 Job Discrimination)",
      "42:2005" : "42:2005 (42:2005 Review of Agency Action-HHS)",
      "42:2615" : "42:2615 (42:2616 Medical Recovery Act)",
      "42:2651" : "42:2651 (42:2651 Medical Care Recovery)",
      "42:3601" : "42:3601 (42:405 Fair Housing Act)",
      "42:4000" : "42:4000 (42:4000 National Flood Insurance Act)",
      "42:4001" : "42:4001 (42:4001 National Insurance Flood Act)",
      "42:4053" : "42:4053 (42:4053 Breach of Insurance Contract)",
      "42:4072" : "42:4072 (42:4072 Payment of Flood Insurance Claim)",
      "42:4321" : "42:4321 (42:4321 Review of Agency Action-Environment)",
      "42:4332" : "42:4332 (42:4332 Environmental Policy - Coop of Agency Repo)",
      "42:688" : "42:688 (42:688 Jones Act Case)",
      "42:6901en" : "42:6901en (42:6901 Environmental Cleanup Expenses)",
      "42:6901rs" : "42:6901rs (42:6901 Resource & Recovery Act)",
      "42:7413" : "42:7413 (42:7413(b) Clean Air Act)",
      "42:7604cl" : "42:7604cl (42:7604 Clear Air Act (Emission Standards))",
      "42:7604ir" : "42:7604ir (42:7604 Petition to Quash IRS Summons)",
      "42:9607" : "42:9607 (42:9607 Real Property Tort to Land)",
      "42:9613" : "42:9613 (42:9613 CERCLA)",
      "43:1333" : "43:1333 (43:1333 Outer Continental Shelf Lands Act)",
      "43:945" : "43:945 (43:945 Compensation for Land Condemnation)",
      "43:945a" : "43:945a (43:945a Complaint in Condemnation)",
      "43:946" : "43:946 (43:946 Complaint in Condemnation - Eminent Domain)",
      "45:0051" : "45:0051 (45:51 Railways: Fed. Employer's Liability Act)",
      "45:0151" : "45:0151 (45:151 Railway Labor Act)",
      "45:0184" : "45:0184 (45:184 Action to Set Aside Award of a System Board)",
      "45:1395" : "45:1395 (45:1395 Railroads: Adverse Reimbursement Review)",
      "45:7457" : "45:7457 (45:7457 Compel Reclamation Under Clear Air Act)",
      "46:0688" : "46:0688 (46:688 Jones Act)",
      "46:0741" : "46:0741 (46:741 Shipping)",
      "46:0761" : "46:0761 (46:761 Shipping: Damages for Death on High Seas)",
      "46:1101" : "46:1101 (46:1101 Violation of Maritime Regulations)",
      "46:1156" : "46:1156 (46:1156 Administrative Procedure Act)",
      "46:1300" : "46:1300 (46:1300 Carriage of Goods by Sea Act)",
      "47:0227" : "47:0227 (47:0227 Telephone Consumer Protection Act)",
      "47:0521" : "47:0521 (47:0521 Cable Communications Policy Act)",
      "47:11707" : "47:11707 (47:11707 Carmack Amendment)",
      "48:0883" : "48:0883 (48:883 Violation of US Coastal Law)",
      "48:1985" : "48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)",
      "49:0081" : "49:0081 (49:81 Damaged Goods While Being Transported)",
      "49:0781" : "49:0781 (49:781 Forfeiture)",
      "49:11503" : "49:11503 (49:11503 Railroad Revitalization Regulatory Reform)",
      "49:11702" : "49:11702 (49:11702(a)(4) Violations of Interstate Commerce A)",
      "49:1374" : "49:1374 (49:1374 Air Carrier Access Act)",
      "49:1471" : "49:1471 (49:1471 Federal Aviation Act)",
      "49:1903" : "49:1903 (49:1903 Petition to enforce administrative summon)",
      "88:8888" : "88:8888 (88:8888 Other Statutory Actions)",
      "8:287" : "8:287 (8:287 Petition to Enforce INS Subpoena)",
      "99:9999" : "99:9999 (99:9999 Report cause code (DO NOT DELETE!))",
      "adsup" : "adsup (Administrative Subpoena)",
      "appifp" : "appifp (Application for IFP)",
      "contempt" : "contempt (Contempt Proceedings)",
      "disbar" : "disbar (Disbarment Proceedings)",
      "efflevy" : "efflevy (Application of US to enter premises to effect levy)",
      "fordepo" : "fordepo (Foreign Deposition)",
      "misc" : "misc (Civil Miscellaneous Case)",
      "motcomp" : "motcomp (Motion to Compel)",
      "motquash" : "motquash (Motion to Quash)",
      "motret" : "motret (Motion for Return of Property)",
      "petenf" : "petenf (Petition to Enforce IRS Summons)",
      "petper" : "petper (Petition to Perpetuate Testimony)",
      "regjgm" : "regjgm (Registration of Foreign Judgment)",
      "sanctions" : "sanctions (Sanctions Imposed)",
      "tranbkref" : "tranbkref (Transmission of Bankruptcy Reference)",
      "tranff" : "tranff (Transmission of Proposed Findings of Fact and Concl. of Law)",
      "writgar" : "writgar (Application for a Writ of Garnishment)"
   },
   "txwdce" : {
      "0" : "0 (No cause code entered)",
      "02:0431" : "02:0431 (02:431 Fed. Election Commission: Failure Enforce C)",
      "02:0437" : "02:0437 (02:437 Federal Election Commission)",
      "05:0075" : "05:0075 (05:75(2) Contract - Reduction in Grade)",
      "05:0551" : "05:0551 (05:551 Administrative Procedure Act)",
      "05:0552fi" : "05:0552fi (05:552 Freedom of Information Act)",
      "05:0552pa" : "05:0552pa (05:552 Right to Privacy Act)",
      "05:0554" : "05:0554 (05:0554 Constitutionality of Maritime Statutes)",
      "05:0701" : "05:0701 (05:0701 Maritime Subsidy Board)",
      "05:0702" : "05:0702 (05:702 Administrative Procedure Act)",
      "05:0704" : "05:0704 (05:704 Labor Litigation)",
      "05:7703" : "05:7703 (05:7703 Discrimination - Review of Agency Act)",
      "05:8151" : "05:8151 (05:8151 - Civil Service Retention Rights)",
      "05:8701" : "05:8701 (05:8701 - Federal Employees' Group Life Insurance Act)",
      "07:0006" : "07:0006 (07:6(b) Federal Commodity Exchange Regulation)",
      "07:0025" : "07:0025 (07:25 Fraud - Commodities Leverage Contracts)",
      "07:0181" : "07:0181 (07:181 Packers & Stockyard Act)",
      "07:0499" : "07:0499 (07:499 Agricultural Commodities Act)",
      "07:0601" : "07:0601 (07:601 USDA Condemnation)",
      "07:2020" : "07:2020 (07:2020 Food Stamp Program Administration)",
      "07:2023" : "07:2023 (07:2023 Reinstatement of Food Stamp Privileges)",
      "07:2321" : "07:2321 (07:2321 Plant Variety Protection Act)",
      "08:1101" : "08:1101 (08:1101 - Immigration and Nationality)",
      "08:1105" : "08:1105 (8:1105(a) Aliens: Habeas Corpus to Release INS Det)",
      "08:1182" : "08:1182 (08:1182 Defend. Denial of Pla. Appl. for Alien Employment Ce)",
      "08:1252" : "08:1252 (08:1252(a)(2) Injunction for Deportation)",
      "08:1260" : "08:1260 (08:1260 Aliens: Access to Records)",
      "08:1324" : "08:1324 (08:1324 Aliens: Complaint for Forfeiture)",
      "08:1324(a)" : "08:1324(a) (08:1324(a) Complaint for penalties)",
      "08:1324(b)" : "08:1324(b) (08:1324(b) Complaint for forfeitures)",
      "08:1329" : "08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petiti)",
      "08:1446" : "08:1446 (8:1446 Petition for Naturalization Hearing)",
      "08:1447" : "08:1447 (08:1447 - Hearing on Denial of Application for Naturalizatio)",
      "08:1451(j)" : "08:1451(j) (08:1451(j) Motion to Correct Order & Judg. of Naturalization)",
      "08:287" : "08:287 (08:287 Petition to Enforce INS Subpoena)",
      "09:0001" : "09:0001 (09:1 U.S. Arbitration Act)",
      "09:0009" : "09:0009 (09:9 Motion to Confirm Arbitration Loan)",
      "09:0010" : "09:0010 (09:0010 Petition to Vacate Arbitration Award)",
      "09:0207" : "09:0207 (09:0207 - Foreign Arbitration Awards)",
      "10:1408" : "10:1408 (10:1408 Claim for Military Retirement)",
      "10:1552" : "10:1552 (10:1552 Armed Forces: Action to Correct Records)",
      "10:1553" : "10:1553 (10:1553 Armed Forces: FOIA General)",
      "10:2305" : "10:2305 (10:2305 Review of Federal Contract)",
      "11:0101" : "11:0101 (11:101 Bankruptcy)",
      "12:0022" : "12:0022 (12:22 Securities Fraud)",
      "12:0635" : "12:0635 (12:635 Breach of Insurance Contract)",
      "12:1441" : "12:1441 (12:1441(a) Breach of Contract)",
      "12:1461" : "12:1461 (12:1461 Homeowners Loan Act)",
      "12:1464" : "12:1464 (12:1464 Federal Savings and Loan)",
      "12:1703" : "12:1703 (12:1703 Default of HUD Loan)",
      "12:1725" : "12:1725 (12:1725 Collection under Contract Guaranty)",
      "12:1730" : "12:1730 (12:1730 Collection Under Contract Guaranty)",
      "12:1790b" : "12:1790b (12:1790(b) Credit Union Employee Protection Remedy)",
      "12:1819" : "12:1819 (12:1819 Default of Promissory Note)",
      "12:1821" : "12:1821 (12:1821 Default of Loan by Promissary Note)",
      "12:1825" : "12:1825 (12:1825 Exemption from Taxation)",
      "12:191" : "12:191 (12:191 Bank Foreclosure)",
      "12:1971" : "12:1971 (12:1971 Relief under Bank Holding Act)",
      "12:1972" : "12:1972 (12:1972 Typing Arrangement Act)",
      "12:2605" : "12:2605 (12:2605 Real Estate Settlement Procedures Act (RESPA))",
      "12:3409" : "12:3409 (12:3409 Application for Delayed Customer Notice)",
      "12:3410" : "12:3410 (12:3410 Right to Financial Privacy Act)",
      "12:5101" : "12:5101 (12:5101 Secure and Fair Enforcement for Mortgage Licensing)",
      "15:0001" : "15:0001 (15:1 Antitrust Litigation)",
      "15:0002at" : "15:0002at (15:2 Antitrust Litigation)",
      "15:0002fl" : "15:0002fl (15:2(a) Fair Labor Standards Act)",
      "15:0005" : "15:0005 (15:5(a) Fair Labor Standards Act)",
      "15:0015" : "15:0015 (15:15 Antitrust Litigation)",
      "15:0025" : "15:0025 (15:25 Clayton Act)",
      "15:0044" : "15:0044 (15:44 Trademark Infringement)",
      "15:0045" : "15:0045 (15:0045 Federal Trade Commission Act)",
      "15:0052" : "15:0052 (15:0052 Federal Trade Commission Act)",
      "15:0053" : "15:0053 (15:0053 Federal Trade Commission Act)",
      "15:0077" : "15:0077 (15:77 Securities Fraud)",
      "15:0078" : "15:0078 (15:78m(a) Securities Exchange Act)",
      "15:0631" : "15:0631 (15:631 Small Business Act)",
      "15:0717" : "15:0717 (15:717 Natural Gas Act)",
      "15:0754" : "15:0754 (15:754 Emergency Petroleum Allocation-Admin.& Enforcement)",
      "15:1051" : "15:1051 (15:1051 Trademark Infringement)",
      "15:1114" : "15:1114 (15:1114 Trademark Infringement)",
      "15:1121" : "15:1121 (15:1121 Trademark Infringement)",
      "15:1125" : "15:1125 (15:1125 Trademark Infringement (Lanham Act))",
      "15:1126" : "15:1126 (15:1126 Patent Infringement)",
      "15:1127" : "15:1127 (15:1127 Trademark Infringement)",
      "15:1601" : "15:1601 (15:1601 Truth in Lending)",
      "15:1640" : "15:1640 (15:1640 Truth in Lending)",
      "15:1679" : "15:1679 (15:1679 Credit Repair Organization Act)",
      "15:1681" : "15:1681 (15:1681 Fair Credit Reporting Act)",
      "15:1691" : "15:1691 (15:1691 Equal Credit Opportunity Act)",
      "15:1692" : "15:1692 (15:1692 Fair Debt Collection Act)",
      "15:1693" : "15:1693 (15:1693 Electronic Fund Transfers)",
      "15:1981" : "15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))",
      "15:1988" : "15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))",
      "15:1989" : "15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))",
      "15:2301" : "15:2301 (15:2301 Magnuson-Moss Warranty Act)",
      "15:2801" : "15:2801 (15:2801 Petroleum Marketing Practices Act)",
      "15:53(b)" : "15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equita)",
      "15:6103" : "15:6103 (15:6103 - Telemarketing Consumer Fraud and Abuse Prevention)",
      "15:6501" : "15:6501 (15:6501 - Children's Online Privacy Protection Act of 1998)",
      "15:7701" : "15:7701 (15:7701 CAN-SPAM Act of 2003)",
      "15:78dd" : "15:78dd (15:78 Foreign Corrupt Practices Act)",
      "16:0668" : "16:0668 (16:668 Bald Eagle Protection Act)",
      "16:0703" : "16:0703 (16:703 Migratory Bird Act)",
      "16:1538" : "16:1538 (16:1538 Endangered Species Act)",
      "16:3371" : "16:3371 (16:3371 Wildlife Under the Lacey Act)",
      "16:3372" : "16:3372 (16:3372 Conservation: Complaint for Forfeiture)",
      "16:3373" : "16:3373 (16:3373 Appeal of Decision - DOI)",
      "16:3374" : "16:3374 (16:3374 Conservation: Complaint for Forfeiture)",
      "16:824a(3)" : "16:824a(3) (16:824 a(3) Cogeneration and Small Power Production Rules)",
      "17:0101" : "17:0101 (17:101 Copyright Infringement)",
      "17:0501" : "17:0501 (17:501 Copyright Infringement)",
      "17:0504" : "17:0504 (17:504 Copyright Infringement)",
      "17:512" : "17:512 (17:512 Digital Millennium Copyright Act)",
      "18:0241" : "18:0241 (18:241 Conspiracy Against Citizen Rights)",
      "18:0923" : "18:0923 (18:923 - Review of Firearms Licensing)",
      "18:0981" : "18:0981 (18:981 Civil Forfeiture)",
      "18:0982" : "18:0982 (18:982 Criminal Forfeiture)",
      "18:0985" : "18:0985 (18:985 Civil Forfeiture of real property)",
      "18:1030" : "18:1030 (18:1030 Computer Fraud and Abuse Act)",
      "18:1514A" : "18:1514A (18:1514A - Civil Action to Protect Against Retaliation in Fraud Cases)",
      "18:1836a" : "18:1836a (18:1836(a) Injunction against Misappropriation of Trade Secrets)",
      "18:1836b" : "18:1836b (18:1836(b) Civil Action to Protect Trade Secrets)",
      "18:1961" : "18:1961 (18:1961 Racketeering (RICO) Act)",
      "18:1962" : "18:1962 (18:1962 Racketeering (RICO) Act)",
      "18:1964" : "18:1964 (18:1964 Racketeering (RICO) Act)",
      "18:2510" : "18:2510 (18:2510 Wire and Electronic Communications Interception)",
      "18:2511" : "18:2511 (18:2511 Wiretapping)",
      "18:3114" : "18:3114 (18:3114 Motion for Return of Seized Property)",
      "18:3182" : "18:3182 (18:3182 FUG FROM ST OR TERRITORY TO ST, DIST, OR TERRITORY)",
      "18:3511" : "18:3511 (18:3511 Judicial Review of Request for Information)",
      "18:3626" : "18:3626 (18:3626 - Prison Condition Remedies)",
      "18:4208" : "18:4208 (18:4208(B) Agency Action Review)",
      "19:1305" : "19:1305 (19:1305 Custom Duties:0Forfeiture-Immoral Articles)",
      "20:0107" : "20:0107 (20:0107 Vending Facilities for Blind in Federal Buildings)",
      "20:1080" : "20:1080 (20:1080 Student Loan Recovery)",
      "20:1095" : "20:1095 (20:1095 Student Loans-Transfer of Allotments)",
      "20:1400" : "20:1400 (20:1400 Civil Rights of Handicapped Child)",
      "20:1401" : "20:1401 (20:1401 Education: Handicapped Child Act)",
      "20:1681" : "20:1681 (20:1681 Title IX of the Education Amendment of 1972)",
      "20:1987" : "20:1987 (20:1987 Amendment of Higher Education Act of 1987)",
      "21:0331" : "21:0331 (21:0331 - Adulteration or misbranding of any food, drug, device, or cosmetic)",
      "21:0841" : "21:0841 (21:841 Forfeiture Property-Drugs)",
      "21:0881" : "21:0881 (21:881 Forfeiture Property-Drugs)",
      "21:0881a" : "21:0881a (21:881 Forfeiture Property - Aircraft)",
      "21:0881re" : "21:0881re (21:881 Forfeiture Property - Real Estate)",
      "23:0134" : "23:0134 (23:134 P.I.- Auto Negligence)",
      "23:1441" : "23:1441 (23:1441 Contract Real Estate)",
      "24:1000" : "24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)",
      "25:0640" : "25:0640 (25:640 Indian Tribal Rights)",
      "25:1300g-6" : "25:1300g-6 (25:1300 Texas Restoration Act-Gaming Activities)",
      "25:1901" : "25:1901 (25:1901 Indian Child Welfare Act)",
      "26:6212" : "26:6212 (26:6212 Injunctive Relief from IRS Lien)",
      "26:6213" : "26:6213 (26:6213 Injunctive Relief from IRS Lien)",
      "26:6226" : "26:6226 (26:6226 Judicial Review - Tax Partnerships)",
      "26:6334" : "26:6334 (26:6334 - Application to Enforce Levy)",
      "26:6502" : "26:6502 (26:6502 IRS:Enforcement of tax liens)",
      "26:6532" : "26:6532 (26:6532 IRS: Refund of Tax Penalty)",
      "26:6702" : "26:6702 (26:6702 IRS: Refund of Income Tax Penalty)",
      "26:6703" : "26:6703 (26:6703 IRS: Refund of Tax Penalty)",
      "26:7401" : "26:7401 (26:7401 IRS: Tax Liability)",
      "26:7402" : "26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)",
      "26:7403" : "26:7403 (26:7403 Suit to Enforce Federal Tax Lien)",
      "26:7422rt" : "26:7422rt (26:7422 IRS: Refund Taxes)",
      "26:7422rx" : "26:7422rx (26:7422 IRS: Refund Excise Tax)",
      "26:7426" : "26:7426 (26:7426 IRS: Wrongful Levy for Taxes)",
      "26:7429" : "26:7429 (26:7429 IRS: Tax Jeopardy Assessment)",
      "26:7431" : "26:7431 (26:7431 - Civil Damages for Unauthorized Disclosure of Return Information)",
      "26:7433" : "26:7433 (26:7433 Civil Damages for Unauthorized Collection Actions)",
      "26:7609" : "26:7609 (26:7609 IRS: Petition to Quash IRS Summons)",
      "27:0185" : "27:0185 (27:185 Enforcement of Arbitration Award)",
      "28:0157" : "28:0157 (28:0157 Bankruptcy Non-Core Proceedings)",
      "28:0157c" : "28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)",
      "28:0157d" : "28:0157d (28:0157 Withdrawal of Reference)",
      "28:0158" : "28:0158 (28:0158 Notice of Appeal re Bankruptcy Matter (BA)",
      "28:0185" : "28:0185 (28:185 Suit to Compel Arbitration)",
      "28:0451" : "28:0451 (28:451 Employment Discrimination)",
      "28:0754" : "28:0754 (28:754 Receiver of Property in Different Districts)",
      "28:0794" : "28:0794 (28:794 Rehabilitation Act)",
      "28:1001" : "28:1001 (28:1001 E.R.I.S.A.)",
      "28:1132" : "28:1132 (28:1132 E.R.I.S.A.)",
      "28:1330" : "28:1330 (28:1330 Breach of Contract)",
      "28:1331" : "28:1331 (28:1331 Fed. Question)",
      "28:1331al" : "28:1331al (28:1331 Fed. Question: Airline Crash)",
      "28:1331at" : "28:1331at (28:1331 Fed. Question: Anti-trust)",
      "28:1331au" : "28:1331au (28:1331 Fed. Question: Auto Negligence)",
      "28:1331b" : "28:1331b (28:1331 Federal Question: Bivens Act)",
      "28:1331bc" : "28:1331bc (28:1331 Fed. Question: Breach of Contract)",
      "28:1331ca" : "28:1331ca (28:1331 Fed Question: Fed Communications Act of 1)",
      "28:1331cm" : "28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)",
      "28:1331cv" : "28:1331cv (28:1331 Federal Question: Other Civil Rights)",
      "28:1331ed" : "28:1331ed (28:1331 Fed. Question: Employment Discrimination)",
      "28:1331ej" : "28:1331ej (28:1331 Federal Question: Enforcement of Judgment)",
      "28:1331es" : "28:1331es (28:1331 Enforcement of Administrative Subpoena)",
      "28:1331fl" : "28:1331fl (28:1331 Fed. Question: Fair Labor Standards)",
      "28:1331in" : "28:1331in (28:1331 Fed. Question: Insurance Contract)",
      "28:1331mm" : "28:1331mm (28:1331 Fed. Question: Medical Malpractice)",
      "28:1331pi" : "28:1331pi (28:1331 Fed. Question: Personal Injury)",
      "28:1331rd" : "28:1331rd (28:1331 Fed. Question: Review Agency Decision)",
      "28:1331rp" : "28:1331rp (28:1331(a) Fed. Question: Real Property)",
      "28:1331rr" : "28:1331rr (28:1331 Fed. Question: Railway Labor Act)",
      "28:1331sv" : "28:1331sv (28:1331 Fed. Question: Securities Violation)",
      "28:1331tr" : "28:1331tr (28:1331 Fed. Question: Trademark)",
      "28:1331tt" : "28:1331tt (28:1331 Fed. Question: Tort Action)",
      "28:1331v" : "28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendme)",
      "28:1331wl" : "28:1331wl (28:1331 Federal Question: EPA Waste Lien)",
      "28:1331wt" : "28:1331wt (28:1331 Fed. Question: Water Rights)",
      "28:1332ac" : "28:1332ac (28:1332 Diversity-Account Receivable)",
      "28:1332al" : "28:1332al (28:1332 Diversity-Airline Crash)",
      "28:1332as" : "28:1332as (28:1332 Diversity-Asbestos Litigation)",
      "28:1332au" : "28:1332au (28:1332 Diversity-Auto Negligence)",
      "28:1332bc" : "28:1332bc (28:1332 Diversity-Breach of Contract)",
      "28:1332co" : "28:1332co (28:1332 Diversity-Conversion)",
      "28:1332ct" : "28:1332ct (28:1332 Diversity-(Citizenship))",
      "28:1332det" : "28:1332det (28:1332 Diversity: Forcible Detainer)",
      "28:1332df" : "28:1332df (28:1332 Diversity-Contract Default)",
      "28:1332ds" : "28:1332ds (28:1332 Diversity-Contract Dispute)",
      "28:1332ed" : "28:1332ed (28:1332 Diversity-Employment Discrimination)",
      "28:1332fd" : "28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)",
      "28:1332fr" : "28:1332fr (28:1332 Diversity-Fraud)",
      "28:1332ia" : "28:1332ia (28:1332 Diversity-Interpleader Action)",
      "28:1332ij" : "28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)",
      "28:1332in" : "28:1332in (28:1332 Diversity-Insurance Contract)",
      "28:1332jd" : "28:1332jd (28:1332 Diversity-Declaratory Judgement)",
      "28:1332lb" : "28:1332lb (28:1332 Diversity-Libel,Assault,Slander)",
      "28:1332lm" : "28:1332lm (28:1332 Diversity - Legal Malpractice)",
      "28:1332ma" : "28:1332ma (28:1332 Diversity-Miller Act)",
      "28:1332mm" : "28:1332mm (28:1332 Diversity-Medical Malpractice)",
      "28:1332mv" : "28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)",
      "28:1332ni" : "28:1332ni (28:1332 Diversity-Negotiable Instrument)",
      "28:1332nm" : "28:1332nm (28:1332 Diversity-Non-Motor Vehicle)",
      "28:1332oc" : "28:1332oc (28:1332 Diversity-Other Contract)",
      "28:1332pd" : "28:1332pd (28:1332 Diversity-Property Damage)",
      "28:1332pi" : "28:1332pi (28:1332 Diversity-Personal Injury)",
      "28:1332pl" : "28:1332pl (28:1332 Diversity-Product Liability)",
      "28:1332pr" : "28:1332pr (28:1332 Diversity-Petition for Removal)",
      "28:1332qt" : "28:1332qt (28:1332 Diversity-Petition to Quiet Title)",
      "28:1332ri" : "28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)",
      "28:1332sa" : "28:1332sa (28:1332 - Diversity: Securities & Exchange Commiss)",
      "28:1332sf" : "28:1332sf (28:1332 - Diversity: Securities Fraud)",
      "28:1332ss" : "28:1332ss (28:1332 Diversity - Stockholders Suits)",
      "28:1332tl" : "28:1332tl (28:1332 Diversity-Torts to Land)",
      "28:1332tm" : "28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))",
      "28:1332tn" : "28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)",
      "28:1332wc" : "28:1332wc (28:1332 Diversity-Wrongful Conversion)",
      "28:1332wd" : "28:1332wd (28:1332 Diversity-Wrongful Death)",
      "28:1333" : "28:1333 (28:1333 Admiralty)",
      "28:1334" : "28:1334 (28:1334 Bankruptcy Appeal)",
      "28:1334c" : "28:1334c (28:1334(c) R&R re motions for abstention (non-cor)",
      "28:1335" : "28:1335 (28:1335 Interpleader Action)",
      "28:1337" : "28:1337 (28:1337 Sherman-Clayton Act)",
      "28:1338cp" : "28:1338cp (28:1338 Copyright Infringement)",
      "28:1338pt" : "28:1338pt (28:1338 Patent Infringement)",
      "28:1338tr" : "28:1338tr (28:1338 Trademark Infringement)",
      "28:1340" : "28:1340 (28:1340 IRS: Custom Duties)",
      "28:1340er" : "28:1340er (28:1340 Recovery of Erroneous Refund)",
      "28:1341" : "28:1341 (28:1341 Complaint for Forfeiture)",
      "28:1343" : "28:1343 (28:1343 Violation of Civil Rights)",
      "28:1345" : "28:1345 (28:1345 USA Plaintiff)",
      "28:1345co" : "28:1345co (28:1345 Replevin & Conversion)",
      "28:1345db" : "28:1345db (28:1345 Debt to US - FHA/HUD Title I)",
      "28:1345df" : "28:1345df (28:1345 Default of Promissory Note)",
      "28:1345er" : "28:1345er (28:1345 Recovery of Erroneous Refund)",
      "28:1345fc" : "28:1345fc (28:1345 Foreclosure)",
      "28:1345ff" : "28:1345ff (28:1345 Complaint for Forfeiture)",
      "28:1345hl" : "28:1345hl (28:1345 VA Home Loan Guaranty Debt)",
      "28:1345mc" : "28:1345mc (28:1345 Medical Care Recovery)",
      "28:1345mi" : "28:1345mi (28:1345 Mining Claim Ejectment)",
      "28:1345pd" : "28:1345pd (28:1345 Property Damage)",
      "28:1345pe" : "28:1345pe (28:1345 Property Ejectment)",
      "28:1345rc" : "28:1345rc (28:1345 Recovery of Debt to US)",
      "28:1345st" : "28:1345st (28:1345 Default of Student Loan)",
      "28:1345tp" : "28:1345tp (28:1345 Trespass on Public Land)",
      "28:1345va" : "28:1345va (28:1345 Recovery of VA Overpayment)",
      "28:1346a" : "28:1346a (28:1346 Wrongful Tax Levy)",
      "28:1346bc" : "28:1346bc (28:1346 Breach of Contract)",
      "28:1346rc" : "28:1346rc (28:1346 Recovery of IRS Tax)",
      "28:1346ta" : "28:1346ta (28:1346 Tucker Act)",
      "28:1346tc" : "28:1346tc (28:1346 Tort Claim)",
      "28:1346wd" : "28:1346wd (28:1346 Wrongful Death)",
      "28:1349" : "28:1349 (28:1348 Corporation organized under Federal Law as party)",
      "28:1352" : "28:1352 (28:1352 Miller Act)",
      "28:1355" : "28:1355 (28:1355 Petition for Return of Property)",
      "28:1358" : "28:1358 (28:1358 Land Condemnation)",
      "28:1361" : "28:1361 (28:1361 Petition for Writ of Mandamus)",
      "28:1362ic" : "28:1362ic (28:1362 Indian Tribal Controversy)",
      "28:1362iw" : "28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)",
      "28:1364" : "28:1364 (28:1364 Auto Negligence)",
      "28:1367" : "28:1367 (28:1367 - Deceptive Trade Practices Act)",
      "28:1391" : "28:1391 (28:1391 Personal Injury)",
      "28:1402" : "28:1402 (28:1402 Medical Malpractice)",
      "28:1407" : "28:1407 (28:1407 Airline Crash)",
      "28:1441ac" : "28:1441ac (28:1441 Petition for Removal- Account Receivable)",
      "28:1441ag" : "28:1441ag (28:1441ag Petition for Removal - Age Discrimination)",
      "28:1441al" : "28:1441al (28:1441 Petition for Removal- Airline Crash)",
      "28:1441as" : "28:1441as (28:1441 Petition for Removal- Asbestos Litigation)",
      "28:1441au" : "28:1441au (28:1441 Petition for Removal- Auto Negligence)",
      "28:1441bc" : "28:1441bc (28:1441 Petition for Removal- Breach of Contract)",
      "28:1441cr" : "28:1441cr (28:1441 Petition for Removal - Constitutional Rights)",
      "28:1441cr1" : "28:1441cr1 (28:1441 Petition for Removal - 42:1983 Civil Rights)",
      "28:1441cv" : "28:1441cv (28:1441 Petition for Removal- Civil Rights Act)",
      "28:1441df" : "28:1441df (28:1441 Petition for Removal- Contract Default)",
      "28:1441di" : "28:1441di (28:1441 Petition for Removal - Discrimination)",
      "28:1441dj" : "28:1441dj (28:1441 Petition for Removal- Declaratory Judgemen)",
      "28:1441ds" : "28:1441ds (28:1441 Petition for Removal- Contract Dispute)",
      "28:1441ed" : "28:1441ed (28:1441 Petition for Removal - Employment Discrim)",
      "28:1441em" : "28:1441em (28:1441 Petition for Removal- Employment Discrimination)",
      "28:1441f" : "28:1441f (28:1441 Petition for Removal - Foreclosure)",
      "28:1441fc" : "28:1441fc (28:1441 Petition for Removal - Fair Credit Reporti)",
      "28:1441fl" : "28:1441fl (28:1441 Petition for Removal - Family & Medical Leave Act)",
      "28:1441fr" : "28:1441fr (28:1441 Petition for Removal- Fraud)",
      "28:1441ij" : "28:1441ij (28:1441 Petition for Removal- Injunctive/Declarato)",
      "28:1441in" : "28:1441in (28:1441 Petition for Removal- Insurance Contract)",
      "28:1441int" : "28:1441int (28:1441 Petition for Removal- Action for Interplea)",
      "28:1441lb" : "28:1441lb (28:1441 Petition for Removal Libel,Assault,Slander)",
      "28:1441lm" : "28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relatio)",
      "28:1441lmr" : "28:1441lmr (28:1441 Labor Management Relations Code)",
      "28:1441mm" : "28:1441mm (28:1441 Petition for Removal- Medical Malpractice)",
      "28:1441ni" : "28:1441ni (28:1441 Petition for Removal- Negotiable Instrumen)",
      "28:1441nm" : "28:1441nm (28:1441 Petition for Removal- Non-Motor Vehicle)",
      "28:1441oc" : "28:1441oc (28:1441 Petition For Removal--Other Contract)",
      "28:1441pd" : "28:1441pd (28:1441 Petition for Removal- Property Damage)",
      "28:1441pi" : "28:1441pi (28:1441 Petition for Removal- Personal Injury)",
      "28:1441pl" : "28:1441pl (28:1441 Petition for Removal- Product Liability)",
      "28:1441pr" : "28:1441pr (28:1441 Petition for Removal)",
      "28:1441qt" : "28:1441qt (28:1441 Petition for Removal- Petition to Quiet Ti)",
      "28:1441rc" : "28:1441rc (28:1441 Petition for Removal - Race Discrimination)",
      "28:1441ri" : "28:1441ri (28:1441 Petition for Removal- Racketeering (RICO))",
      "28:1441sa" : "28:1441sa (28:1441 - Petition for Removal: SEC Act)",
      "28:1441sf" : "28:1441sf (28:1441 - Petition for Removal: Securities Fraud)",
      "28:1441tl" : "28:1441tl (28:1441 Petition for Removal- Torts to Land)",
      "28:1441tm" : "28:1441tm (28:1441 Petition for Removal- Tort/Motor Vehicle ()",
      "28:1441tn" : "28:1441tn (28:1441 Petition for Removal- Tort/Non-Motor Vehic)",
      "28:1441ts" : "28:1441ts (28:1441 Petition for Removal - Title VII)",
      "28:1441wd" : "28:1441wd (28:1441 Petition for Removal- Wrongful Death)",
      "28:1442bc" : "28:1442bc (28:1442 Petition for Removal- Breach of Contract)",
      "28:1442fe" : "28:1442fe (28:1442 Petition for Removal-Fed Employee/Scope of Employmt)",
      "28:1442pr" : "28:1442pr (28:1442 Petition for Removal)",
      "28:1443" : "28:1443 (28:1443(1) Rent, Lease & Ejectment)",
      "28:1444" : "28:1444 (28:1444 Petition for Removal- Foreclosure)",
      "28:1446at" : "28:1446at (28:1446 Petition for Removal - Antitrust)",
      "28:1446bc" : "28:1446bc (28:1446 Petition for Removal-Breach of Contract)",
      "28:1446er" : "28:1446er (28:1446 Petition for Removal - ERISA)",
      "28:1446fl" : "28:1446fl (28:1446 Petition for Removal - Fair Labor Standards)",
      "28:1446in" : "28:1446in (28:1446 Breach of Contract- Insurance)",
      "28:1446pd" : "28:1446pd (28:1446 Petition for Removal- Property Damage (P.I)",
      "28:1446pi" : "28:1446pi (28:1446 Petition for Removal- Personal Injury)",
      "28:1446pl" : "28:1446pl (28:1446pl Petition for Removal - Product Liability)",
      "28:1446pr" : "28:1446pr (28:1446 Petition for Removal)",
      "28:1446sd" : "28:1446sd (28:1446 Petition For Removal - Sex Discrimination/Harass)",
      "28:1452" : "28:1452 (28:1452 R&R re motions to remand (non-core))",
      "28:1491" : "28:1491 (28:1491 Claim Against the United States)",
      "28:1651" : "28:1651 (28:1651 Petition for Writ of Coram Nobis)",
      "28:1651hc" : "28:1651hc (28:1651 Petition for Writ of Habeas Corpus)",
      "28:1651mn" : "28:1651mn (28:1651 Petition for Writ of Mandamus)",
      "28:1655" : "28:1655 (28:1655 Adverse Possession of Personal Property & Injuries)",
      "28:1696" : "28:1696 (28:1696 Service In Foreign and International Litigation)",
      "28:1738a" : "28:1738a (28:1738A Parental Kidnapping Prevention Act)",
      "28:1782" : "28:1782 (28:1782 Letter rogatory - appointment)",
      "28:1983" : "28:1983 (28:1983 Civil Rights)",
      "28:2201" : "28:2201 (28:2201 Constitutionality of State Statute(s))",
      "28:2201dj" : "28:2201dj (28:2201 Declaratory Judgment)",
      "28:2201ij" : "28:2201ij (28:2201 Injunction)",
      "28:2201in" : "28:2201in (28:2201 Declaratory Judgement (Insurance))",
      "28:2241" : "28:2241 (28:2241 Petition for Writ of Habeas Corpus (federa)",
      "28:2254" : "28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))",
      "28:2254se" : "28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)",
      "28:2255" : "28:2255 (28:2255 Motion to Vacate / Correct Illegal Sentenc)",
      "28:2271" : "28:2271 (28:2271 Federal Tort Claims Act)",
      "28:2345" : "28:2345 (28:2345 Medicare Recovery)",
      "28:2409" : "28:2409 (28:2409(a) Quiet Title Action)",
      "28:2410" : "28:2410 (28:2410 Quiet Title)",
      "28:2671" : "28:2671 (28:2671 Federal Tort Claims Act)",
      "28:2674" : "28:2674 (28:2674 Federal Tort Claims Act)",
      "28:3001" : "28:3001 (28:3001 Federal Debt Collection Procedures Act)",
      "28:7402" : "28:7402 (28:7402 Refund of Taxes)",
      "28:7422" : "28:7422 (28:7422 Appeal from Administrative Decision)",
      "28:754" : "28:754 (28:754 Receiver of Property in Different District)",
      "29:0141" : "29:0141 (29:0141 Labor Management Relations Act of 1947)",
      "29:0151" : "29:0151 (29:151 Labor: Review of Agency Action)",
      "29:0160" : "29:0160 (29:160(1) National Labor Relations Act)",
      "29:0184" : "29:0184 (29:184 Violation Collection Bargain Agreement)",
      "29:0185ep" : "29:0185ep (29:185 Employee Pension Plan)",
      "29:0185lm" : "29:0185lm (29:185 Labor/Mgt. Relations (Contracts))",
      "29:0201do" : "29:0201do (29:201 Denial of Overtime Compensation)",
      "29:0201fl" : "29:0201fl (29:201 Fair Labor Standards Act)",
      "29:0203" : "29:0203 (29:203 Equal Pay Act)",
      "29:0206" : "29:0206 (29:206 Collect Unpaid Wages)",
      "29:0207" : "29:0207 (29:207 Maximum Hours)",
      "29:0401" : "29:0401 (29:0401 Labor Management Disclosure Act)",
      "29:0621" : "29:0621 (29:621 Job Discrimination (Age))",
      "29:0623" : "29:0623 (29:623 Job Discrimination (Age))",
      "29:0626" : "29:0626 (29:626 Job Discrimination (Age))",
      "29:0633" : "29:0633 (29:633 Job Discrimination (Age))",
      "29:0651" : "29:0651 (29:651 Occupational Safety/Health)",
      "29:0701" : "29:0701 (29:701 Rehabilitation Act of 1973)",
      "29:0754" : "29:0754 (29:754 Discrimination)",
      "29:0791" : "29:0791 (29:791 Job Discrimination (Rehabilitation Act))",
      "29:0794" : "29:0794 (29:0794 Job Discrimination (Handicap))",
      "29:1001" : "29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)",
      "29:1002" : "29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)",
      "29:1104" : "29:1104 (29:1104 Recovery of Benefits to Employee)",
      "29:1109" : "29:1109 (29:1109 Breach of Fiduciary Duties)",
      "29:1131" : "29:1131 (29:1131 ERISA - Collection of Delinquent Trust Fun)",
      "29:1132" : "29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)",
      "29:1140" : "29:1140 (29:1140 Interference with Protected Rights)",
      "29:1145" : "29:1145 (29:1145 E.R.I.S.A.)",
      "29:1149" : "29:1149 (29:1149 Recover Pension & Profit Sharing)",
      "29:1337" : "29:1337 (29:1337 E.R.I.S.A.)",
      "29:1362" : "29:1362 (29:1362 ERISA)",
      "29:1381" : "29:1381 (29:1381 E.R.I.S.A.)",
      "29:1401" : "29:1401 (29:1401(b)(2) Appeal of Arbitration Award)",
      "29:1451" : "29:1451 (29:1451 E.R.I.S.A.)",
      "29:1801" : "29:1801 (29:1801 Farmworker Rights)",
      "29:2001" : "29:2001 (29:2001 Federal Employee Polygraph Protection Act)",
      "29:2102" : "29:2102 (29:2102 WARN Act (Worker Adjustment and Retraining Notification))",
      "29:2601" : "29:2601 (29:2601 Family and Medical Leave Act of 1993)",
      "29:790" : "29:790 (29:790 Rehabilitation of Labor)",
      "30:0181" : "30:0181 (30:181 Environment: Review of Agency Action)",
      "30:0801" : "30:0801 (30:0801 Penalities/Federal Mine Safety Health Act)",
      "30:1201" : "30:1201 (30:1201 Environment: Review of Agency Action)",
      "30:1202" : "30:1202 (30:1202 Mining Reclamation Act)",
      "30:1276" : "30:1276 (30:1276 Interior: Review of Agency Action)",
      "31:3545" : "31:3545 (31:3545 Action to Recover Money)",
      "31:3729" : "31:3729 (31:3729 False Claims Act)",
      "31:3730" : "31:3730 (31:3730 Qui Tam False Claims Act)",
      "31:3731" : "31:3731 (31:3731 Fraud)",
      "31:5316" : "31:5316 (31:5316 Reports on Exporting/Importing monetary instruments)",
      "31:5317" : "31:5317 (31:5317 Search and forfeiture of monetary instruments)",
      "31:5324" : "31:5324 (31:5324 Structuring of Financial Transactions)",
      "31:5332" : "31:5332 (31:5332 Forfeiture - Cash Smuggling)",
      "33:1319cw" : "33:1319cw (33:1319 Clean Water Act)",
      "33:1319pv" : "33:1319pv (33:1319 Pollutants & Permit Violations)",
      "33:1365" : "33:1365 (33:1365 Environmental Matters)",
      "33:2702" : "33:2702 (33:2702 Oil Pollution Liability and Compensation)",
      "33:907" : "33:907 (33:907 Longshore & Harbor Workers' Compensation Act)",
      "35:0100" : "35:0100 (35:100 Patent Infringement)",
      "35:0145" : "35:0145 (35:145 Patent Infringement)",
      "35:0183" : "35:0183 (35:183 Patent Infringement)",
      "35:0271" : "35:0271 (35:271 Patent Infringement)",
      "35:0292" : "35:0292 (35:292 Patent Infringement)",
      "38:1681" : "38:1681 (38:1681 Recovery of VA Overpayment)",
      "38:1686" : "38:1686 (38:1686 Recovery of VA Overpayment)",
      "38:1780" : "38:1780 (38:1780 Recovery of VA Overpayment)",
      "38:1975" : "38:1975 (38:1975 Recovery of Servicemen's Group Life Insurance - Jurisdiction of District Court)",
      "38:2011" : "38:2011 (38:2011 - Veteran's Readjustment Assistance Act of)",
      "38:3116" : "38:3116 (38:3116 VA Overpayment)",
      "38:3720" : "38:3720 (38:3720 Power of Secretary of Veterans Affairs)",
      "38:4301" : "38:4301 (38:4301 Right to Reemployment of Inducted Persons)",
      "39:3005" : "39:3005 (39:3005 Detention of Mail for Temporary Periods)",
      "39:3007" : "39:3007 (39:3007 Detention of Mail)",
      "39:409" : "39:409 (39:409 Postal Service)",
      "40:0258" : "40:0258 (40:258(a) Public Buildings & Property: Land Condem)",
      "40:0875" : "40:0875 (40:875 Public Buildings & Property: Negligence)",
      "40:3114" : "40:3114 (40:3114 Land Condemnation Action)",
      "40:3131" : "40:3131 (40:3131 Miller Act)",
      "41:0251" : "41:0251 (41:251 Public Contracts-Review of Agency Action)",
      "41:1463" : "41:1463 (41:1463 Public Contracts: Unlawful Employment Prac)",
      "42:0205" : "42:0205 (42:205 Denial Social Security Benefits)",
      "42:0206" : "42:0206 (42:206 Social Security Benefits)",
      "42:0247" : "42:0247 (42:247 Personal Injury-Swine Flu)",
      "42:0292" : "42:0292 (42:0292 - Health Professions Education - Student Loans)",
      "42:0294" : "42:0294 (42:0294 - Health Professions Education)",
      "42:0402" : "42:0402 (42:402 Social Security Benefits)",
      "42:0405id" : "42:0405id (42:405 Review of HHS Decision (SSID))",
      "42:0405wc" : "42:0405wc (42:405 Review of HHS Decision (DIWC))",
      "42:0405ww" : "42:0405ww (42:405 Review of HHS Decision (DIWW))",
      "42:0407" : "42:0407 (42:407 Federal Old-Age, Survivors and Disability Insurance)",
      "42:0416" : "42:0416 (42:416 Denial of Social Security Benefits)",
      "42:0427" : "42:0427 (42:427 Social Security Benefits)",
      "42:11603b" : "42:11603b (42:11603(b) Appl. for Return of Child Pursuant to Hague Convention)",
      "42:12101" : "42:12101 (42:12101 Americans with Disabilities Act of 1990)",
      "42:12117" : "42:12117 (42:12117 Employment Discrimination on Basis of Disability)",
      "42:12188" : "42:12188 (42:12188 Americans with Disabilities Act)",
      "42:1383" : "42:1383 (42:1383 Review of HHS Decision)",
      "42:1395" : "42:1395 (42:1395 HHS: Adverse Reimbursement Review)",
      "42:1395dd" : "42:1395dd (42:1395dd Emergency Medical Treatment Act)",
      "42:1396" : "42:1396 (42:1396 - Tort Negligence)",
      "42:1437" : "42:1437 (42:1437 Housing Act)",
      "42:1471" : "42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclo)",
      "42:1973" : "42:1973 (42:1973 Voting Rights Act)",
      "42:1981cv" : "42:1981cv (42:1981 Civil Rights)",
      "42:1981hs" : "42:1981hs (42:1981 Housing Discrimination)",
      "42:1981jb" : "42:1981jb (42:1981 Job Discrimination (Race))",
      "42:1981sx" : "42:1981sx (42:1981 Sex Discrimination)",
      "42:1983cv" : "42:1983cv (42:1983 Civil Rights Act)",
      "42:1983ed" : "42:1983ed (42:1983 Civil Rights (Employment Discrimination))",
      "42:1983pr" : "42:1983pr (42:1983 Prisoner Civil Rights)",
      "42:1986" : "42:1986 (42:1986 Neglect of Duty)",
      "42:2000ag" : "42:2000ag (42:2000 Job Discrimination (Age))",
      "42:2000d" : "42:2000d (42:2000d Federally Assisted Programs)",
      "42:2000e" : "42:2000e (42:2000e Job Discrimination (Employment))",
      "42:2000pb" : "42:2000pb (42:2000 Job Discrimination (Public Accomodations))",
      "42:2000ra" : "42:2000ra (42:2000 Job Discrimination (Race))",
      "42:2000re" : "42:2000re (42:2000 Job Discrimination (Religion))",
      "42:2000sx" : "42:2000sx (42:2000 Job Discrimination (Sex))",
      "42:2003" : "42:2003 (42:2003 Job Discrimination)",
      "42:2005" : "42:2005 (42:2005 Review of Agency Action-HHS)",
      "42:2615" : "42:2615 (42:2616 Medical Recovery Act)",
      "42:2651" : "42:2651 (42:2651 Medical Care Recovery)",
      "42:292(f)" : "42:292(f) (42:292(f) Registration of State Court Judgment)",
      "42:3601" : "42:3601 (42:405 Fair Housing Act)",
      "42:4000" : "42:4000 (42:4000 National Flood Insurance Act)",
      "42:4001" : "42:4001 (42:4001 National Insurance Flood Act)",
      "42:4053" : "42:4053 (42:4053 Breach of Insurance Contract)",
      "42:4072" : "42:4072 (42:4072 Payment of Flood Insurance Claim)",
      "42:4321" : "42:4321 (42:4321 Review of Agency Action-Environment)",
      "42:4332" : "42:4332 (42:4332 Environmental Policy - Coop of Agency Repo)",
      "42:6901en" : "42:6901en (42:6901 Environmental Cleanup Expenses)",
      "42:6901rs" : "42:6901rs (42:6901 Resource & Recovery Act)",
      "42:7413" : "42:7413 (42:7413(b) Clean Air Act)",
      "42:7604cl" : "42:7604cl (42:7604 Clear Air Act (Emission Standards))",
      "42:7604ir" : "42:7604ir (42:7604 Petition to Quash IRS Summons)",
      "42:9604" : "42:9604 (42:9604 Hazardous Substances Releases, Liability, Comp)",
      "42:9607" : "42:9607 (42:9607 Real Property Tort to Land)",
      "43:945" : "43:945 (43:945 Compensation for Land Condemnation)",
      "43:945a" : "43:945a (43:945a Complaint in Condemnation)",
      "43:946" : "43:946 (43:946 Complaint in Condemnation - Eminent Domain)",
      "45:0051" : "45:0051 (45:51 Railways: Fed. Employer's Liability Act)",
      "45:0151" : "45:0151 (45:151 Railway Labor Act)",
      "45:0184" : "45:0184 (45:184 Action to Set Aside Award of a System Board)",
      "45:1395" : "45:1395 (45:1395 Railroads: Adverse Reimbursement Review)",
      "45:7457" : "45:7457 (45:7457 Compel Reclamation Under Clear Air Act)",
      "46:0688" : "46:0688 (46:688 Jones Act)",
      "46:0741" : "46:0741 (46:741 Shipping)",
      "46:0761" : "46:0761 (46:761 Shipping: Damages for Death on High Seas)",
      "46:1101" : "46:1101 (46:1101 Violation of Maritime Regulations)",
      "46:1156" : "46:1156 (46:1156 Administrative Procedure Act)",
      "47:0151" : "47:0151 (47:0151 Federal Communications Commission)",
      "47:0223" : "47:0223 (47:223 Communications Decency Act)",
      "47:0252" : "47:0252 (47:252 Review of State Utilities Commission Determinations)",
      "47:0521" : "47:0521 (47:0521 Cable Communications)",
      "47:0605" : "47:0605 (47:0605 Unauthorized Publication and Use of Communication)",
      "47:227" : "47:227 (47:227 - Telephone Consumer Protection Act)",
      "47:503" : "47:503 (47:503 FCC Non-Compliance Forfeiture)",
      "48:0883" : "48:0883 (48:883 Violation of US Coastal Law)",
      "48:1985" : "48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)",
      "49:0081" : "49:0081 (49:81 Damaged Goods While Being Transported)",
      "49:0781" : "49:0781 (49:781 Forfeiture)",
      "49:10743" : "49:10743 (49:10743 Liability for Payment of Rates)",
      "49:10761" : "49:10761 (49:10761 Transportation Prohibited w/o Tariff)",
      "49:10762" : "49:10762 (49:10762(a)(1) Recovery of charges - Interstate Commerce)",
      "49:10921" : "49:10921 (49:10921 Requirement for Permit Subject to ICC Jurisdiction)",
      "49:11503" : "49:11503 (49:11503 Railroad Revitalization Regulatory Reform)",
      "49:11702" : "49:11702 (49:11702(a)(4) Violations of Interstate Commerce A)",
      "49:11707" : "49:11707 (49:11707 Liability of Common Carriers under bills of lading)",
      "49:14102" : "49:14102 (49:14102 - Interstate Commerce - Leased Motor Vehicles)",
      "49:14705" : "49:14705 (49:14705 Recovery of Transportation Charge (ICC))",
      "49:14706" : "49:14706 (49:14706 Carmack Amendment)",
      "49:1471" : "49:1471 (49:1471 Federal Aviation Act)",
      "49:1903" : "49:1903 (49:1903 Petition to enforce administrative summon)",
      "49:32705" : "49:32705 (49:32705 Disclosure Requirements on Transfer of Motor Vehicles)",
      "50:3937" : "50:3937 (50:3937 Servicemembers Civil Relief Act (SCRA) - Interest Rate)",
      "51:20137" : "51:20137 (51:20137(1) Malpractice & Negligence Against U.S. Space Program)",
      "adsup" : "adsup (Administrative Subpoena)",
      "bivens" : "bivens (Bivens)",
      "bivens-1" : "bivens-1 (Bivens - Retaliation by Prison Offical)",
      "contempt" : "contempt (Contempt Proceedings)",
      "fordepo" : "fordepo (Foreign Deposition)",
      "misc" : "misc (Civil Miscellaneous Case)",
      "motbank" : "motbank (Motion to Stay Pending Bankruptcy Appeal)",
      "motcomp" : "motcomp (Motion to Compel)",
      "motexam" : "motexam (Motion to Examine)",
      "motquash" : "motquash (Motion to Quash)",
      "motret" : "motret (Motion for Return of Property)",
      "petenf" : "petenf (Petition to Enforce IRS Summons)",
      "petper" : "petper (Petition to Perpetuate Testimony)",
      "regjgm" : "regjgm (Registration of Foreign Judgment)",
      "tranbkref" : "tranbkref (Transmission of Bankruptcy Reference)",
      "writecn" : "writecn (Writ of Error Coram Nobis)",
      "writgar" : "writgar (Application for a Writ of Garnishment)"
   },
   "utdce" : {
      "0" : "0 (00:0000)",
      "02:0431" : "02:0431 (02:0431 Fed. Election Commission: Failure Enforce Compliance)",
      "02:0437" : "02:0437 (02:0437 Federal Election Commission)",
      "05:0075" : "05:0075 (05:0075(2) Contract - Reduction in Grade)",
      "05:0551" : "05:0551 (05:0551 Administrative Procedure Act)",
      "05:0552fi" : "05:0552fi (05:0552 Freedom of Information Act)",
      "05:0552pa" : "05:0552pa (05:552 Right to Privacy Act)",
      "05:0554" : "05:0554 (05:0554 Constitutionality of Maritime Statutes)",
      "05:0701" : "05:0701 (05:0701 Maritime Subsidy Board)",
      "05:0702" : "05:0702 (05:0702 Administrative Procedure Act)",
      "05:0704" : "05:0704 (05:0704 Labor Litigation)",
      "05:7703" : "05:7703 (05:7703 Discrimination - Review of Agency Act)",
      "05:8101" : "05:8101 (05:8101 Government Employees Compensation for Work Injuries)",
      "05:8470" : "05:8470 (05:8470 Enforcement of Judgment against Retirement Benefits)",
      "05:8701" : "05:8701 (05:8701 Federal Employees Group Life Insurance Act (FEGLI))",
      "05:8912" : "05:8912 (05:8912 Federal Employee Health Benefit Act of 1959)",
      "07:0006" : "07:0006 (07:0006(b) Federal Commodity Exchange Regulation)",
      "07:0025" : "07:0025 (07:0025 Fraud - Commodities Leverage Contracts)",
      "07:0181" : "07:0181 (07:0181 Packers & Stockyard Act)",
      "07:0499" : "07:0499 (07:0499 Agricultural Commodities Act)",
      "07:0601" : "07:0601 (07:0601 USDA Condemnation)",
      "07:2023" : "07:2023 (07:2023 Food Stamp Act)",
      "07:2321" : "07:2321 (07:2321 Plant Variety Protection Act)",
      "08:0287" : "08:0287 (08:0287 Petition to Enforce INS Subpoena)",
      "08:1105" : "08:1105 (08:1105(a) Aliens: Habeas Corpus to Release INS Detainee)",
      "08:1182" : "08:1182 (08:1182 Defend. Denial of Pla. Appl. for Alien Employment Ce)",
      "08:1225" : "08:1225 (08:1225 Immigration: Enforcement of Administrative Subpoena)",
      "08:1252" : "08:1252 (08:1252(a)(2) Injunction for Deportation)",
      "08:1260" : "08:1260 (08:1260 Aliens: Access to Records)",
      "08:1324" : "08:1324 (08:1324 Aliens: Complaint for Forfeiture)",
      "08:1329" : "08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petition)",
      "08:1421" : "08:1421 (08:1421 Application for Judicial Review)",
      "08:1446" : "08:1446 (08:1446 Petition for Naturalization Hearing)",
      "08:1447" : "08:1447 (08:1447 Request for Naturalilzation Hearing)",
      "08:1451(j)" : "08:1451(j) (08:1451(j) Motion to Correct Order & Judg. of Naturalization)",
      "09:0001" : "09:0001 (09:0001 U.S. Arbitration Act)",
      "09:0009" : "09:0009 (09:0009 Motion to Confirm Arbitration Award)",
      "09:0010" : "09:0010 (09:0010 Petition to Vacate Arbitration Award)",
      "09:0207" : "09:0207 (09:0207 Application for Order Confirming Award of Arbitrators)",
      "10:1408" : "10:1408 (10:1408 Claim for Military Retirement)",
      "10:1552" : "10:1552 (10:1552 Armed Forces: Action to Correct Records)",
      "10:1553" : "10:1553 (10:1553 Armed Forces: FOIA General)",
      "10:2305" : "10:2305 (10:2305 Review of Federal Contract)",
      "11:0101" : "11:0101 (11:0101 Bankruptcy)",
      "11:0110" : "11:0110 (11:0110(i) Bankruptcy - Assessment of Damage)",
      "12:0022" : "12:0022 (12:0022 Securities Fraud)",
      "12:0191" : "12:0191 (12:0191 Bank Foreclosure)",
      "12:0192" : "12:0192 (12:0192 Liquidation of National Bank)",
      "12:0503" : "12:0503 (12:0503 Civil Liability - Officers and Directors)",
      "12:0635" : "12:0635 (12:0635 Breach of Insurance Contract)",
      "12:1461" : "12:1461 (12:1461 Homeowners Loan Act)",
      "12:1464" : "12:1464 (12:1464 Federal Savings and Loan)",
      "12:1703" : "12:1703 (12:1703 Default of HUD Loan)",
      "12:1725" : "12:1725 (12:1725 Collection under Contract Guaranty)",
      "12:1730" : "12:1730 (12:1730 Collection Under Contract Guaranty)",
      "12:1818" : "12:1818 (12:1818 Collection of Civil Assessment)",
      "12:1819" : "12:1819 (12:1819 Default of Promissory Note)",
      "12:1821" : "12:1821 (12:1821 Default of Loan by Promissary Note)",
      "12:1971" : "12:1971 (12:1971 Relief under Bank Holding Act)",
      "12:1972" : "12:1972 (12:1972 Typing Arrangement Act)",
      "12:2605" : "12:2605 (12:2605 Servicing of Mortgage Loans)",
      "12:2607" : "12:2607 (12:2607 Prohibition Against Kickbacks & Fees)",
      "12:3410" : "12:3410 (12:3410 Right to Financial Privacy Act)",
      "15:0001" : "15:0001 (15:0001 Antitrust Litigation)",
      "15:0002at" : "15:0002at (15:0002 Antitrust Litigation)",
      "15:0002fl" : "15:0002fl (15:0002(a) Fair Labor Standards Act)",
      "15:0005" : "15:0005 (15:0005(a) Fair Labor Standards Act)",
      "15:0015" : "15:0015 (15:0015 Antitrust Litigation)",
      "15:0025" : "15:0025 (15:0025 Clayton Act)",
      "15:0044" : "15:0044 (15:0044 Trademark Infringement)",
      "15:0045" : "15:0045 (15:0045 FTC Franchise Rule)",
      "15:0052" : "15:0052 (15:0052 Federal Trade Commission Act)",
      "15:0053" : "15:0053 (15:0053 Federal Trade Commission Act)",
      "15:0053(b)" : "15:0053(b) (15:0053(b) - Prelim & Perm Inj Relief & other Equita)",
      "15:0077" : "15:0077 (15:0077 Securities Fraud)",
      "15:0077vb" : "15:0077vb (15:0077 Enforce a SEC Summons)",
      "15:0078" : "15:0078 (15:0078m(a) Securities Exchange Act)",
      "15:0631" : "15:0631 (15:0631 Small Business Act)",
      "15:0717" : "15:0717 (15:0717 Natural Gas Act)",
      "15:0754" : "15:0754 (15:0754 Emergency Petroleum Allocation-Admin.& Enforcement)",
      "15:1051" : "15:1051 (15:1051 Trademark Infringement)",
      "15:1114" : "15:1114 (15:1114 Trademark Infringement)",
      "15:1119" : "15:1119 (15:1119 Cancellation of Trademark Proceedings)",
      "15:1121" : "15:1121 (15:1121 Trademark Infringement)",
      "15:1125" : "15:1125 (15:1125 Trademark Infringement (Lanham Act))",
      "15:1125(a)" : "15:1125(a) (15:1125(a) False representation of goods sold in interstate commerce)",
      "15:1126" : "15:1126 (15:1126 Patent Infringement)",
      "15:1127" : "15:1127 (15:1127 Trademark Infringement)",
      "15:1221" : "15:1221 (15:1221 Federal Automobile Dealers' Day In Court Act)",
      "15:1601" : "15:1601 (15:1601 Truth in Lending)",
      "15:1640" : "15:1640 (15:1640 Truth in Lending)",
      "15:1667" : "15:1667 (15:1667 Consumer Lease Act)",
      "15:1681" : "15:1681 (15:1681 Fair Credit Reporting Act)",
      "15:1691" : "15:1691 (15:1691 Equal Credit Opportunity Act)",
      "15:1692" : "15:1692 (15:1692 Fair Debt Collection Act)",
      "15:1693ef" : "15:1693ef (15:1693 Electronic Funds Transfer Act)",
      "15:1938" : "15:1938 (15:1938 Fair Labor Standards Act)",
      "15:1981" : "15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))",
      "15:1988" : "15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))",
      "15:1989" : "15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))",
      "15:2301" : "15:2301 (15:2301 Magnuson-Moss Warranty Act)",
      "15:2601" : "15:2601 (15:2601 Toxic Substances Control Act)",
      "15:2801" : "15:2801 (15:2801 Petroleum Marketing Practices Act)",
      "15:7701" : "15:7701 (15:7701 Federal CAN-Spam Act)",
      "15:78j(b)" : "15:78j(b) (15:78j(b)ss Stockholder Suit)",
      "15:80a-3" : "15:80a-3 (15:80a-3 Investment Company Act of 1940)",
      "16:0431" : "16:0431 (16:0431 Antiquities Act)",
      "16:0668" : "16:0668 (16:0668 Bald Eagle Protection Act)",
      "16:0703" : "16:0703 (16:0703 Migratory Bird Act)",
      "16:1531" : "16:1531 (16:1531 Endangered Species Act)",
      "16:1538" : "16:1538 (16:1538 Endangered Species Act)",
      "16:3371" : "16:3371 (16:3371 Wildlife Under the Lacey Act)",
      "16:3372" : "16:3372 (16:3372 Conservation: Complaint for Forfeiture)",
      "16:3373" : "16:3373 (16:3373 Appeal of Decision - DOI)",
      "16:3374" : "16:3374 (16:3374 Conservation: Complaint for Forfeiture)",
      "17:0101" : "17:0101 (17:0101 Copyright Infringement)",
      "17:0501" : "17:0501 (17:0501 Copyright Infringement)",
      "17:0504" : "17:0504 (17:0504 Copyright Infringement)",
      "17:0512" : "17:0512 (17:0512(h) Subpoena to Identify Copyright Infringer)",
      "18:0241" : "18:0241 (18:0241 Conspiracy Against Citizen Rights)",
      "18:0925" : "18:0925 (18:0925 Relief from Disabilities)",
      "18:1030" : "18:1030 (18:1030(g) Civil Action - Computer Fraud)",
      "18:1836a" : "18:1836a (18:1836(a) - Injunction against Misappropriation of Trade Secrets)",
      "18:1836b" : "18:1836b (18:1836(b) - Civil Action to Protect Trade Secrets)",
      "18:1961" : "18:1961 (18:1961 Racketeering (RICO) Act)",
      "18:1962" : "18:1962 (18:1962 Racketeering (RICO) Act)",
      "18:1964" : "18:1964 (18:1964 Racketeering (RICO) Act)",
      "18:2254" : "18:2254 (18:2254 Civil Forfeiture)",
      "18:2333" : "18:2333 (18:2333 Personal Injury - International Terrorism)",
      "18:2511" : "18:2511 (18:2511 Wiretapping)",
      "18:2701" : "18:2701 (18:2701 Unlawful Access to Stored Communications)",
      "18:3114" : "18:3114 (18:3114 Motion for Return of Seized Property)",
      "18:3512" : "18:3512 (Foreign Requests for Assistance in Criminal Investigations and Prosecutions)",
      "18:3582" : "18:3582 (18:3582(c)(2) Motion to Modify Imposed Term of Imprisonment)",
      "18:4208" : "18:4208 (18:4208(B) Agency Action Review)",
      "19:1305" : "19:1305 (19:1305 Custom Duties: Forfeiture-Immoral Articles)",
      "20:1080" : "20:1080 (20:1080 Student Loan Recovery)",
      "20:1400" : "20:1400 (20:1400 Civil Rights of Handicapped Child)",
      "20:1401" : "20:1401 (20:1401 Education: Handicapped Child Act)",
      "20:1681" : "20:1681 (20:1681 Title IX Educational Amendments 1992 - Sex Discrimination)",
      "21:0301" : "21:0301 (21:0301 Seizure & Condemnation of Articles of Drug)",
      "21:0841" : "21:0841 (21:0841 Forfeiture Property-Drugs)",
      "21:0881" : "21:0881 (21:0881 Forfeiture Property-Drugs)",
      "21:0881a" : "21:0881a (21:0881 Forfeiture Property - Aircraft)",
      "21:0881o" : "21:0881o (21:0881 Forfeiture Property - Other)",
      "21:0881re" : "21:0881re (21:0881 Forfeiture Property - Real Estate)",
      "21:331" : "21:331 (21:331 Federal Food, Drug & Cosmetic Act - Prohibited Acts)",
      "21:360" : "21:360 (21:360 Federal Food, Drug & Cosmetic Act - Drugs and Devices)",
      "22:9003" : "22:9003 (22:9003 Hague Convention - Petition for Return of Children)",
      "23:0134" : "23:0134 (23:0134 P.I.- Auto Negligence)",
      "23:1441" : "23:1441 (23:1441 Contract Real Estate)",
      "24:1000" : "24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)",
      "25:0640" : "25:0640 (25:0640 Indian Tribal Rights)",
      "25:1901" : "25:1901 (25:1901 Indian Child Welfare Act)",
      "26:6212" : "26:6212 (26:6212 Injunctive Relief from IRS Lien)",
      "26:6213" : "26:6213 (26:6213 Injunctive Relief from IRS Lien)",
      "26:6330" : "26:6330 (26:6330 IRS: Notice & Opportunity for Hearing Before Levy)",
      "26:6334" : "26:6334 (26:6334(e)(1) Levy Allowed on Principal Residences)",
      "26:6502" : "26:6502 (26:6502 IRS:Enforcement of tax liens)",
      "26:6532" : "26:6532 (26:6532 IRS: Refund of Tax Penalty)",
      "26:6672" : "26:6672 (26:6672 IRS: Failure to Collect and Pay Over Tax, or Attempt to Evade or Defeat Tax)",
      "26:6702" : "26:6702 (26:6702 IRS: Refund of Income Tax Penalty)",
      "26:6703" : "26:6703 (26:6703 IRS: Refund of Tax Penalty)",
      "26:7401" : "26:7401 (26:7401 IRS: Tax Liability)",
      "26:7402" : "26:7402 (26:7402(b) IRS: Petition to Enforce IRS Summons)",
      "26:7402a" : "26:7402a (26:7402(a) IRS: Jurisdiction of District Courts)",
      "26:7403" : "26:7403 (26:7403 Suit to Enforce Federal Tax Lien)",
      "26:7407" : "26:7407 (Action to Enjoin Income Tax Preparers)",
      "26:7422rt" : "26:7422rt (26:7422 IRS: Refund Taxes)",
      "26:7422rx" : "26:7422rx (26:7422 IRS: Refund Excise Tax)",
      "26:7426" : "26:7426 (26:7426 IRS: Wrongful Levy for Taxes)",
      "26:7429" : "26:7429 (26:7429 IRS: Tax Jeopardy Assessment)",
      "26:7434" : "26:7434 (26:7434 IRS: Civil Damages for Fraudulent Filing of Information)",
      "26:7609" : "26:7609 (26:7609 IRS: Petition to Quash IRS Summons)",
      "27:0185" : "27:0185 (27:0185 Enforcement of Arbitration Award)",
      "28:0157c" : "28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)",
      "28:0157d" : "28:0157d (28:0157 Motion for Withdrawal of Reference)",
      "28:0158" : "28:0158 (28:0158 Bankruptcy Appeal from Judgment/Order)",
      "28:0185" : "28:0185 (28:0185 Suit to Compel Arbitration)",
      "28:0451" : "28:0451 (28:0451 Employment Discrimination)",
      "28:0794" : "28:0794 (28:0794 Rehabilitation Act)",
      "28:1001" : "28:1001 (28:1001 E.R.I.S.A.)",
      "28:1132" : "28:1132 (28:1132 E.R.I.S.A.)",
      "28:1330" : "28:1330 (28:1330 Breach of Contract)",
      "28:1331" : "28:1331 (28:1331 Fed. Question)",
      "28:1331al" : "28:1331al (28:1331 Fed. Question: Airline Crash)",
      "28:1331at" : "28:1331at (28:1331 Fed. Question: Anti-trust)",
      "28:1331au" : "28:1331au (28:1331 Fed. Question: Auto Negligence)",
      "28:1331b" : "28:1331b (28:1331 Fed. Question: Bivens Act)",
      "28:1331bc" : "28:1331bc (28:1331 Fed. Question: Breach of Contract)",
      "28:1331ca" : "28:1331ca (28:1331 Fed Question: Fed Communications Act of 1)",
      "28:1331cm" : "28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)",
      "28:1331cv" : "28:1331cv (28:1331 Fed. Question: Civil Rights Violation)",
      "28:1331ed" : "28:1331ed (28:1331 Fed. Question: Employment Discrimination)",
      "28:1331ej" : "28:1331ej (28:1331 Fed. Question: Enforcement of Judgment)",
      "28:1331es" : "28:1331es (28:1331 Fed. Question: Enforcement of Administrative Subpoena)",
      "28:1331fl" : "28:1331fl (28:1331 Fed. Question: Fair Labor Standards)",
      "28:1331in" : "28:1331in (28:1331 Fed. Question: Insurance Contract)",
      "28:1331mm" : "28:1331mm (28:1331 Fed. Question: Medical Malpractice)",
      "28:1331ng" : "28:1331ng (28:1331 Fed. Question: Natural Gas Act)",
      "28:1331pi" : "28:1331pi (28:1331 Fed. Question: Personal Injury)",
      "28:1331rd" : "28:1331rd (28:1331 Fed. Question: Review Agency Decision)",
      "28:1331rp" : "28:1331rp (28:1331(a) Fed. Question: Real Property)",
      "28:1331rr" : "28:1331rr (28:1331 Fed. Question: Railway Labor Act)",
      "28:1331sv" : "28:1331sv (28:1331 Fed. Question: Securities Violation)",
      "28:1331tr" : "28:1331tr (28:1331 Fed. Question: Trademark)",
      "28:1331tt" : "28:1331tt (28:1331 Fed. Question: Tort Action)",
      "28:1331v" : "28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendment)",
      "28:1331wl" : "28:1331wl (28:1331 Fed. Question: EPA Waste Lien)",
      "28:1331wt" : "28:1331wt (28:1331 Fed. Question: Water Rights)",
      "28:1332" : "28:1332 (28:1332 Diversity)",
      "28:1332ac" : "28:1332ac (28:1332 Diversity-Account Receivable)",
      "28:1332al" : "28:1332al (28:1332 Diversity-Airline Crash)",
      "28:1332as" : "28:1332as (28:1332 Diversity-Asbestos Litigation)",
      "28:1332au" : "28:1332au (28:1332 Diversity-Auto Negligence)",
      "28:1332bc" : "28:1332bc (28:1332 Diversity-Breach of Contract)",
      "28:1332co" : "28:1332co (28:1332 Diversity-Conversion)",
      "28:1332ct" : "28:1332ct (28:1332 Diversity-(Citizenship))",
      "28:1332det" : "28:1332det (28:1332 Diversity-Forcible Detainer)",
      "28:1332df" : "28:1332df (28:1332 Diversity-Contract Default)",
      "28:1332ds" : "28:1332ds (28:1332 Diversity-Contract Dispute)",
      "28:1332ed" : "28:1332ed (28:1332 Diversity-Employment Discrimination)",
      "28:1332fd" : "28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)",
      "28:1332fr" : "28:1332fr (28:1332 Diversity-Fraud)",
      "28:1332ia" : "28:1332ia (28:1332 Diversity-Interpleader Action)",
      "28:1332ij" : "28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)",
      "28:1332in" : "28:1332in (28:1332 Diversity-Insurance Contract)",
      "28:1332jd" : "28:1332jd (28:1332 Diversity-Declaratory Judgment)",
      "28:1332lb" : "28:1332lb (28:1332 Diversity-Libel,Assault,Slander)",
      "28:1332lm" : "28:1332lm (28:1332 Diversity-Legal Malpractice)",
      "28:1332ma" : "28:1332ma (28:1332 Diversity-Miller Act)",
      "28:1332mm" : "28:1332mm (28:1332 Diversity-Medical Malpractice)",
      "28:1332mv" : "28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)",
      "28:1332ni" : "28:1332ni (28:1332 Diversity-Negotiable Instrument)",
      "28:1332nm" : "28:1332nm (28:1332 Diversity-Non-Motor Vehicle)",
      "28:1332nr" : "28:1332nr (28:1332 Diversity-Notice of Removal)",
      "28:1332oc" : "28:1332oc (28:1332 Diversity-Other Contract)",
      "28:1332pd" : "28:1332pd (28:1332 Diversity-Property Damage)",
      "28:1332pi" : "28:1332pi (28:1332 Diversity-Personal Injury)",
      "28:1332pl" : "28:1332pl (28:1332 Diversity-Product Liability)",
      "28:1332pr" : "28:1332pr (28:1332 Diversity-Petition for Removal)",
      "28:1332qt" : "28:1332qt (28:1332 Diversity-Petition to Quiet Title)",
      "28:1332ri" : "28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)",
      "28:1332sa" : "28:1332sa (28:1332 Diversity-Securities & Exchange Commiss)",
      "28:1332sf" : "28:1332sf (28:1332 Diversity-Securities Fraud)",
      "28:1332ss" : "28:1332ss (28:1332 Diversity-Stockholders Suits)",
      "28:1332tl" : "28:1332tl (28:1332 Diversity-Torts to Land)",
      "28:1332tm" : "28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))",
      "28:1332tn" : "28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)",
      "28:1332wd" : "28:1332wd (28:1332 Diversity-Wrongful Death)",
      "28:1333" : "28:1333 (28:1333 Admiralty)",
      "28:1334" : "28:1334 (28:1334 Bankruptcy Appeal)",
      "28:1334b" : "28:1334b (28:1334(b) Proceeding arising/related to case under title 11)",
      "28:1334c" : "28:1334c (28:1334(c) R&R re motions for abstention (non-cor)",
      "28:1335" : "28:1335 (28:1335 Interpleader Action)",
      "28:1336" : "28:1336 (28:1336 Surface Transportation Board Appeal)",
      "28:1337" : "28:1337 (28:1337 Sherman-Clayton Act)",
      "28:1338cp" : "28:1338cp (28:1338 Copyright Infringement)",
      "28:1338pt" : "28:1338pt (28:1338 Patent Infringement)",
      "28:1338tr" : "28:1338tr (28:1338 Trademark Infringement)",
      "28:1340" : "28:1340 (28:1340 IRS: Custom Duties)",
      "28:1340er" : "28:1340er (28:1340 Recovery of Erroneous Refund)",
      "28:1341" : "28:1341 (28:1341 Complaint for Forfeiture)",
      "28:1343" : "28:1343 (28:1343 Violation of Civil Rights)",
      "28:1345" : "28:1345 (28:1345 USA Plaintiff)",
      "28:1345co" : "28:1345co (28:1345 USA Plaintiff-Replevin & Conversion)",
      "28:1345db" : "28:1345db (28:1345 USA Plaintiff-Debt to US - FHA/HUD Title I)",
      "28:1345df" : "28:1345df (28:1345 Default of Promissory Note)",
      "28:1345er" : "28:1345er (28:1345 Recovery of Erroneous Refund)",
      "28:1345fc" : "28:1345fc (28:1345 USA Plaintiff-Foreclosure)",
      "28:1345ff" : "28:1345ff (28:1345ff Complaint for Forfeiture)",
      "28:1345hl" : "28:1345hl (28:1345 VA Home Loan Guaranty Debt)",
      "28:1345mc" : "28:1345mc (28:1345 Medical Care Recovery)",
      "28:1345mi" : "28:1345mi (28:1345 USA Plaintiff-Mining Claim Ejectment)",
      "28:1345pd" : "28:1345pd (28:1345 USA Plaintiff-Property Damage)",
      "28:1345pe" : "28:1345pe (28:1345 USA Plaintiff-VA Property Ejectment)",
      "28:1345rc" : "28:1345rc (28:1345 USA Plaintiff-Recovery of Debt to US)",
      "28:1345st" : "28:1345st (28:1345 USA Plaintiff-Default of Student Loan)",
      "28:1345tp" : "28:1345tp (28:1345 Trespass on Public Land)",
      "28:1345va" : "28:1345va (28:1345 USA Plaintiff-Recovery of VA Overpayment)",
      "28:1346bc" : "28:1346bc (28:1346 Breach of Contract)",
      "28:1346rc" : "28:1346rc (28:1346 Recovery of IRS Tax)",
      "28:1346tc" : "28:1346tc (28:1346 Tort Claim)",
      "28:1346wd" : "28:1346wd (28:1346 Wrongful Death)",
      "28:1349" : "28:1349 (28:1348 Corporation organized under Federal Law as party)",
      "28:1350" : "28:1350 (28:1350 Aliens Tort Claims Act)",
      "28:1352" : "28:1352 (28:1352 Miller Act)",
      "28:1355" : "28:1355 (28:1355 Petition for Return of Property)",
      "28:1358" : "28:1358 (28:1358 Land Condemnation)",
      "28:1361" : "28:1361 (28:1361 Petition for Writ of Mandamus)",
      "28:1362ic" : "28:1362ic (28:1362 Indian Tribal Controversy)",
      "28:1362iw" : "28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)",
      "28:1364" : "28:1364 (28:1364 Auto Negligence)",
      "28:1367" : "28:1367 (28:1367 Other Property Damage)",
      "28:1391" : "28:1391 (28:1391 Personal Injury)",
      "28:1402" : "28:1402 (28:1402 Medical Malpractice)",
      "28:1407" : "28:1407 (28:1407 Airline Crash)",
      "28:1441ac" : "28:1441ac (28:1441 Notice of Removal- Account Receivable)",
      "28:1441al" : "28:1441al (28:1441 Notice of Removal- Airline Crash)",
      "28:1441as" : "28:1441as (28:1441 Notice of Removal- Asbestos Litigation)",
      "28:1441au" : "28:1441au (28:1441 Notice of Removal- Auto Negligence)",
      "28:1441bc" : "28:1441bc (28:1441 Notice of Removal- Breach of Contract)",
      "28:1441cv" : "28:1441cv (28:1441 Notice of Removal- Civil Rights Act)",
      "28:1441df" : "28:1441df (28:1441 Notice of Removal- Contract Default)",
      "28:1441dj" : "28:1441dj (28:1441 Notice of Removal- Declaratory Judgment)",
      "28:1441ds" : "28:1441ds (28:1441 Notice of Removal- Contract Dispute)",
      "28:1441ed" : "28:1441ed (28:1441 Notice of Removal- Employment Discrim)",
      "28:1441fc" : "28:1441fc (28:1441 Notice of Removal - Fair Credit Reporting)",
      "28:1441fr" : "28:1441fr (28:1441 Notice of Removal- Fraud)",
      "28:1441ij" : "28:1441ij (28:1441 Notice of Removal- Injunctive/Declaratory Relief)",
      "28:1441in" : "28:1441in (28:1441 Notice of Removal- Insurance Contract)",
      "28:1441int" : "28:1441int (28:1441 Notice of Removal- Action for Interplea)",
      "28:1441lb" : "28:1441lb (28:1441 Notice of Removal- Libel,Assault,Slander)",
      "28:1441lm" : "28:1441lm (28:1441 Notice of Removal- Labor/Mgmnt. Relatio)",
      "28:1441mm" : "28:1441mm (28:1441 Notice of Removal- Medical Malpractice)",
      "28:1441ni" : "28:1441ni (28:1441 Notice of Removal- Negotiable Instrument)",
      "28:1441nm" : "28:1441nm (28:1441 Notice of Removal- Non-Motor Vehicle)",
      "28:1441nr" : "28:1441nr (28:1441 Notice of Removal)",
      "28:1441oc" : "28:1441oc (28:1441 Notice of Removal- Other Contract)",
      "28:1441pd" : "28:1441pd (28:1441 Notice of Removal- Property Damage)",
      "28:1441pi" : "28:1441pi (28:1441 Notice of Removal- Personal Injury)",
      "28:1441pl" : "28:1441pl (28:1441 Notice of Removal- Product Liability)",
      "28:1441pr" : "28:1441pr (28:1441 Notice of Removal)",
      "28:1441qt" : "28:1441qt (28:1441 Notice of Removal- Petition to Quiet Title)",
      "28:1441ri" : "28:1441ri (28:1441 Notice of Removal- Racketeering (RICO))",
      "28:1441sa" : "28:1441sa (28:1441 Notice of Removal- SEC Act)",
      "28:1441sf" : "28:1441sf (28:1441 Notice of Removal- Securities Fraud)",
      "28:1441tl" : "28:1441tl (28:1441 Notice of Removal- Torts to Land)",
      "28:1441tm" : "28:1441tm (28:1441 Notice of Removal- Tort/Motor Vehicle (P.I.))",
      "28:1441tn" : "28:1441tn (28:1441 Notice of Removal- Tort/Non-Motor Vehicle)",
      "28:1441wd" : "28:1441wd (28:1441 Notice of Removal- Wrongful Death)",
      "28:1442bc" : "28:1442bc (28:1442 Notice of Removal- Breach of Contract)",
      "28:1442nr" : "28:1442nr (28:1442 Notice of Removal)",
      "28:1442pr" : "28:1442pr (28:1442 Notice of Removal)",
      "28:1443" : "28:1443 (28:1443(1) Rent, Lease & Ejectment)",
      "28:1444" : "28:1444 (28:1444 Notice of Removal- Foreclosure)",
      "28:1446in" : "28:1446in (28:1446 Notice of Removal-Breach of Contract- Insurance)",
      "28:1446nr" : "28:1446nr (28:1446 Notice of Removal)",
      "28:1446pd" : "28:1446pd (28:1446 Notice of Removal- Property Damage (P.I.))",
      "28:1446pi" : "28:1446pi (28:1446 Notice of Removal- Personal Injury)",
      "28:1446pl" : "28:1446pl (28:1446pl Notice of Removal- Product Liability)",
      "28:1446pr" : "28:1446pr (28:1446 Notice of Removal)",
      "28:1452" : "28:1452 (28:1452 Removal of Claim in Civil Action Related to BK. Case)",
      "28:1491" : "28:1491 (28:1491 Tucker Act)",
      "28:157b" : "28:157b (28:157(b)(5) Personal Injury Tort/Wrongful Death Proceedings)",
      "28:1651" : "28:1651 (28:1651 Petition for Writ of Coram Nobis)",
      "28:1651hc" : "28:1651hc (28:1651 Petition for Writ of Habeas Corpus)",
      "28:1651mn" : "28:1651mn (28:1651 Petition for Writ of Mandamus)",
      "28:1782" : "28:1782 (28:1782 Letter rogatory - appointment)",
      "28:1983" : "28:1983 (28:1983 Civil Rights)",
      "28:2201" : "28:2201 (28:2201 Constitutionality of State Statute(s))",
      "28:2201dj" : "28:2201dj (28:2201 Declaratory Judgment)",
      "28:2201ij" : "28:2201ij (28:2201 Injunction)",
      "28:2201in" : "28:2201in (28:2201 Declaratory Judgment (Insurance))",
      "28:2241" : "28:2241 (28:2241 Petition for Writ of Habeas Corpus (Federal))",
      "28:2241st" : "28:2241st (28:2241 Petition for Writ of Habeas Corpus (State))",
      "28:2254" : "28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))",
      "28:2254se" : "28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)",
      "28:2255" : "28:2255 (28:2255 Motion to Vacate Sentence)",
      "28:2271" : "28:2271 (28:2271 Federal Tort Claims Act)",
      "28:2345" : "28:2345 (28:2345 Medicare Recovery)",
      "28:2409" : "28:2409 (28:2409(a) Quiet Title Action)",
      "28:2410" : "28:2410 (28:2410 Actions Affecting Property on which United States had Lien)",
      "28:2671" : "28:2671 (28:2671 Federal Tort Claims Act)",
      "28:2674" : "28:2674 (28:2674 Federal Tort Claims Act)",
      "28:3001" : "28:3001 (28:3001 Federal Debt Collection)",
      "28:7402" : "28:7402 (28:7402 Refund of Taxes)",
      "28:7422" : "28:7422 (28:7422 Appeal from Administrative Decision)",
      "28:754" : "28:754 (28:754 Receiver of Property in Different Districts)",
      "29:0151" : "29:0151 (29:0151 Labor: Review of Agency Action)",
      "29:0160" : "29:0160 (29:0160(1) National Labor Relations Act)",
      "29:0184" : "29:0184 (29:0184 Violation Collection Bargain Agreement)",
      "29:0185ep" : "29:0185ep (29:0185 Employee Pension Plan)",
      "29:0185lm" : "29:0185lm (29:0185 Labor/Mgt. Relations (Contracts))",
      "29:0201do" : "29:0201do (29:0201 Denial of Overtime Compensation)",
      "29:0201fl" : "29:0201fl (29:0201 Fair Labor Standards Act)",
      "29:0203" : "29:0203 (29:0203 Equal Pay Act)",
      "29:0206" : "29:0206 (29:0206 Collect Unpaid Wages)",
      "29:0401" : "29:0401 (29:0401 Labor Management Disclosure Act)",
      "29:0621" : "29:0621 (29:0621 Job Discrimination (Age))",
      "29:0623" : "29:0623 (29:0623 Job Discrimination (Age))",
      "29:0626" : "29:0626 (29:0626 Job Discrimination (Age))",
      "29:0633" : "29:0633 (29:0633 Job Discrimination (Age))",
      "29:0651" : "29:0651 (29:0651 Occupational Safety/Health)",
      "29:0754" : "29:0754 (29:0754 Discrimination)",
      "29:0790" : "29:0790 (29:0790 Rehabilitation of Labor)",
      "29:0791" : "29:0791 (29:0791 Job Discrimination (Rehabilitation Act))",
      "29:0794" : "29:0794 (29:0794 Job Discrimination (Handicap))",
      "29:1001" : "29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)",
      "29:1002" : "29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)",
      "29:1104" : "29:1104 (29:1104 Recovery of Benefits to Employee)",
      "29:1109" : "29:1109 (29:1109 Breach of Fiduciary Duties)",
      "29:1131" : "29:1131 (29:1131 ERISA - Collection of Delinquent Trust Funds)",
      "29:1132" : "29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)",
      "29:1145" : "29:1145 (29:1145 E.R.I.S.A.)",
      "29:1149" : "29:1149 (29:1149 Recover Pension & Profit Sharing)",
      "29:1337" : "29:1337 (29:1337 E.R.I.S.A.)",
      "29:1362" : "29:1362 (29:1362 ERISA)",
      "29:1381" : "29:1381 (29:1381 E.R.I.S.A.)",
      "29:1401" : "29:1401 (29:1401(b)(2) Appeal of Arbitration Award)",
      "29:1451" : "29:1451 (29:1451 E.R.I.S.A.)",
      "29:1501" : "29:1501 (29:1501 Job Training Partnership Act (JTPA))",
      "29:1801" : "29:1801 (29:1801 Farmworker Rights)",
      "29:216(b)" : "29:216(b) (29:216(b) FLSA: Minimum wage or overtime compensation)",
      "29:2601" : "29:2601 (29:2601 Family and Medical Leave)",
      "30:0181" : "30:0181 (30:0181 Environment: Review of Agency Action)",
      "30:0801" : "30:0801 (30:0801 Penalities/Federal Mine Safety Health Act)",
      "30:1201" : "30:1201 (30:1201 Environment: Review of Agency Action)",
      "30:1202" : "30:1202 (30:1202 Mining Reclamation Act)",
      "30:1276" : "30:1276 (30:1276 Interior: Review of Agency Action)",
      "31:3545" : "31:3545 (31:3545 Action to Recovery Money)",
      "31:3729" : "31:3729 (31:3729 False Claims Act)",
      "31:3730" : "31:3730 (31:3730 Qui Tam False Claims Act)",
      "31:3731" : "31:3731 (31:3731 Fraud)",
      "31:5317" : "31:5317 (31:5317 Search and Forfeiture of Monetary Instruments)",
      "33:1319cw" : "33:1319cw (33:1319 Clean Water Act)",
      "33:1319pv" : "33:1319pv (33:1319 Pollutants & Permit Violations)",
      "33:1365" : "33:1365 (33:1365 Environmental Matters)",
      "35:0145" : "35:0145 (35:0145 Patent Infringement)",
      "35:0183" : "35:0183 (35:0183 Patent Infringement)",
      "35:0271" : "35:0271 (35:0271 Patent Infringement)",
      "35:1" : "35:1 (35:1 Establishment of PTO)",
      "375/1" : "375/1 (375/1 False Claims Act - U.S. Plaintiff)",
      "38:0775" : "38:0775 (38:0775 Recovery of Servicemen's Group Life Insurance)",
      "38:1681" : "38:1681 (38:1681 Recovery of VA Overpayment)",
      "38:1686" : "38:1686 (38:1686 Recovery of VA Overpayment)",
      "38:1780" : "38:1780 (38:1780 Recovery of VA Overpayment)",
      "38:2011" : "38:2011 (38:2011 Veteran's Readjustment Assistance Act of)",
      "38:2021" : "38:2021 (38:2021 Right to re-employment of inducted persons)",
      "38:3116" : "38:3116 (38:3116 VA Overpayment)",
      "38:4323" : "38:4323 (38:4323 Uniformed Service Employment/Reemployment Rights Act)",
      "38:6106" : "38:6106 (38:6106 Misue of Benefits by Fiduciaries)",
      "39:0409" : "39:0409 (39:0409 Postal Service)",
      "39:3005" : "39:3005 (39:3005 Detention of Mail for Temporary Periods)",
      "40:0258" : "40:0258 (40:0258(a) Public Buildings & Property: Land Condemnation)",
      "40:0270" : "40:0270 (40:0270 Miller Act)",
      "40:0875" : "40:0875 (40:0875 Public Buildings & Property: Negligence)",
      "40:1101" : "40:1101 (40:1101 Brooks Architect - Engineers Act)",
      "40:3131" : "40:3131 (40:3131 Bonds of Contractors of Public Buildings)",
      "40:3142" : "40:3142 (40:3142 Davis-Bacon Act (prevailing wages))",
      "40:581" : "40:581 (40:581 General Authority of Administrator of General Services)",
      "41:0251" : "41:0251 (41:0251 Public Contracts-Review of Agency Action)",
      "41:1463" : "41:1463 (41:1463 Public Contracts: Unlawful Employment Practices)",
      "41:7105(f)" : "41:7105(f) (41:7105(f) Action to Judicially Enforce Administrative Subpoena)",
      "42:0205" : "42:0205 (42:0205 Denial Social Security Benefits)",
      "42:0206" : "42:0206 (42:0206 Social Security Benefits)",
      "42:0247" : "42:0247 (42:0247 Personal Injury-Swine Flu)",
      "42:0402" : "42:0402 (42:0402 Social Security Benefits)",
      "42:0405id" : "42:0405id (42:0405 Review of HHS Decision (SSID))",
      "42:0405rs" : "42:0405rs (42:0405 Review of HHS Decision (RSI))",
      "42:0405wc" : "42:0405wc (42:0405 Review of HHS Decision (DIWC))",
      "42:0405ww" : "42:0405ww (42:0405 Review of HHS Decision (DIWW))",
      "42:0416" : "42:0416 (42:0416 Denial of Social Security Benefits)",
      "42:0427" : "42:0427 (42:0427 Social Security Benefits)",
      "42:11601" : "42:11601 (42:11601 International Child Abduction Remedies Act)",
      "42:12101" : "42:12101 (42:12101 Americans with Disabilities Act of 1990)",
      "42:12112" : "42:12112 (42:12112 Americans with Disabilities Act - Employment Discrimination)",
      "42:12117" : "42:12117 (42:12117 Americans with Disabilities Act - Enforcement)",
      "42:12132" : "42:12132 (42:12132 Americans with Disabilities Act - Discrimination)",
      "42:12188" : "42:12188 (42:12188 Americans With Disabilities Act - Civil Enforcement Actions)",
      "42:1383" : "42:1383 (42:1383 Review of HHS Decision)",
      "42:1395" : "42:1395 (42:1395 HHS: Adverse Reimbursement Review)",
      "42:1395dd" : "42:1395dd (Examination and treatment for emergency medical conditions and women in labor)",
      "42:1396" : "42:1396 (42:1396 Grants to States for Medical Assistance Programs)",
      "42:13981" : "42:13981 (42:13981 Violence Against Women Act 1994)",
      "42:1471" : "42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclosure)",
      "42:1981cv" : "42:1981cv (42:1981 Civil Rights)",
      "42:1981hs" : "42:1981hs (42:1981 Housing Discrimination)",
      "42:1981jb" : "42:1981jb (42:1981 Job Discrimination (Race))",
      "42:1981sx" : "42:1981sx (42:1981 Sex Discrimination)",
      "42:1983cv" : "42:1983cv (42:1983 Civil Rights Act)",
      "42:1983ed" : "42:1983ed (42:1983 Civil Rights (Employment Discrimination))",
      "42:1983pr" : "42:1983pr (42:1983 Prisoner Civil Rights)",
      "42:1986" : "42:1986 (42:1986 Neglect of Duty)",
      "42:2000ag" : "42:2000ag (42:2000 Job Discrimination (Age))",
      "42:2000e" : "42:2000e (42:2000 Job Discrimination (Employment))",
      "42:2000pb" : "42:2000pb (42:2000 Job Discrimination (Public Accommodations))",
      "42:2000ra" : "42:2000ra (42:2000 Job Discrimination (Race))",
      "42:2000rl" : "42:2000rl (42:2000 Job Discrimination (religion))",
      "42:2000sx" : "42:2000sx (42:2000 Job Discrimination (Sex))",
      "42:2003" : "42:2003 (42:2003 Job Discrimination)",
      "42:2005" : "42:2005 (42:2005 Review of Agency Action-HHS)",
      "42:2210" : "42:2210 (42:2210 Radiation Exposure Compensation Act)",
      "42:2615" : "42:2615 (42:2616 Medical Recovery Act)",
      "42:2651" : "42:2651 (42:2651 Medical Care Recovery)",
      "42:3601" : "42:3601 (42:3601 Fair Housing Act)",
      "42:3604" : "42:3604 (42:3604 (f)(3)(c) Fair Housing Amendments Act)",
      "42:3613" : "42:3613 (42:3613 Action for Inj Relief re Deprivation of Civil Rights)",
      "42:4000" : "42:4000 (42:4000 National Flood Insurance Act)",
      "42:4001" : "42:4001 (42:4001 National Insurance Flood Act)",
      "42:4053" : "42:4053 (42:4053 Breach of Insurance Contract)",
      "42:4072" : "42:4072 (42:4072 Payment of Flood Insurance Claim)",
      "42:4321" : "42:4321 (42:4321 Review of Agency Action-Environment)",
      "42:4332" : "42:4332 (42:4332 Environmental Policy - Coop of Agency Repo)",
      "42:6901en" : "42:6901en (42:6901 Environmental Cleanup Expenses)",
      "42:6901rs" : "42:6901rs (42:6901 Resource & Recovery Act)",
      "42:7413" : "42:7413 (42:7413(b) Clean Air Act)",
      "42:7604cl" : "42:7604cl (42:7604 Clear Air Act (Emission Standards))",
      "42:7604ir" : "42:7604ir (42:7604 Petition to Quash IRS Summons)",
      "42:9601" : "42:9601 (42:9601 Comprehensive Environmental Compen/Resp/Liab (CERCLA)(Definitions))",
      "42:9604" : "42:9604 (42:9604 Comoprehensive Envir.,Response,Comp. & Liab.Act (CERCLA) - Removal and Other Remedies)",
      "42:9607" : "42:9607 (42:9607 Real Property Tort to Land)",
      "42:9613" : "42:9613 (42:9613 Comp Environ Recovery Comp & Liability Act (CERCLA) - Civil Proceedings)",
      "43:945" : "43:945 (43:0945 Compensation for Land Condemnation)",
      "43:945a" : "43:945a (43:0945a Complaint in Condemnation)",
      "43:946" : "43:946 (43:0946 Complaint in Condemnation - Eminent Domain)",
      "45:0051" : "45:0051 (45:0051 Railways: Fed. Employer's Liability Act)",
      "45:0151" : "45:0151 (45:0151 Railway Labor Act)",
      "45:0184" : "45:0184 (45:0184 Action to Set Aside Award of a System Board of Adjus)",
      "45:1395" : "45:1395 (45:1395 Railroads: Adverse Reimbursement Review)",
      "45:7457" : "45:7457 (45:7457 Compel Reclamation Under Clear Air Act)",
      "46:0688" : "46:0688 (46:0688 Jones Act)",
      "46:0741" : "46:0741 (46:0741 Shipping)",
      "46:0761" : "46:0761 (46:0761 Shipping: Damages for Death on High Seas)",
      "46:1101" : "46:1101 (46:1101 Violation of Maritime Regulations)",
      "46:1156" : "46:1156 (46:1156 Administrative Procedure Act)",
      "47:0252" : "47:0252 (47:0252 Telecomm-Procedures for negotion,arbitration,approva)",
      "47:0605" : "47:0605 (47:0605 Unauthorized Publication or Use of Communications)",
      "47:227" : "47:227 (47:227 FCC-Unsolicited Telephone Sales)",
      "47:332(c)" : "47:332(c) (47:332(c) Federal Telecommunications Act of 1996)",
      "48:0883" : "48:0883 (48:0883 Violation of US Coastal Law)",
      "48:1985" : "48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)",
      "49:0081" : "49:0081 (49:0081 Damaged Goods While Being Transported)",
      "49:0781" : "49:0781 (49:0781 Forfeiture)",
      "49:11501" : "49:11501 (49:11501 Railroad Revitalization & Regulatory Reform Act (General jurisdiction))",
      "49:11503" : "49:11503 (49:11503 Railroad Revitalization Regulatory Reform)",
      "49:11702" : "49:11702 (49:11702(a)(4) Violations of Interstate Commerce A)",
      "49:14706" : "49:14706 (49:14706 Carmack Amendment to the Interstate Commerce Act / Liability of Carriers - Receipts & Bills)",
      "49:1471" : "49:1471 (49:1471 Federal Aviation Act)",
      "49:1903" : "49:1903 (49:1903 Petition to enforce administrative summon)",
      "52:30116" : "52:30116 (52:30116 Limitations on Contributions and Expenditures)",
      "7:1" : "7:1 (7:1 Commodity Exchange Act)",
      "99:9999" : "99:9999 (99:9999 Report cause code (DO NOT DELETE!))",
      "adsup" : "adsup (Administrative Subpoena)",
      "atydisc" : "atydisc (Attorney Discipline)",
      "atyreg" : "atyreg (Attorney Registration)",
      "contempt" : "contempt (Contempt Proceedings)",
      "disbar" : "disbar (Disbarment Proceedings)",
      "fordepo" : "fordepo (Foreign Deposition)",
      "misc" : "misc (Civil Miscellaneous Case)",
      "motcomp" : "motcomp (Motion to Compel)",
      "motquash" : "motquash (Motion to Quash)",
      "motret" : "motret (Motion for Return of Property)",
      "petenf" : "petenf (Petition to Enforce IRS Summons)",
      "petper" : "petper (Petition to Perpetuate Testimony)",
      "regjgm" : "regjgm (Registration of Foreign Judgment)",
      "tranbkref" : "tranbkref (Transmission of Bankruptcy Reference)",
      "tranff" : "tranff (Transmission of Proposed Findings of Fact and Concl. of Law)",
      "writentry" : "writentry (Application and order for entry to effect IRS Levy)",
      "writgar" : "writgar (Application for a Writ of Garnishment)"
   },
   "vaedce" : {
      "0" : "0 (no cause specified)",
      "02:0431" : "02:0431 (02:431 Fed. Election Commission: Failure Enforce Compliance)",
      "02:0437" : "02:0437 (02:437 Federal Election Commission)",
      "02:1202" : "02:1202 (02:1202 Discriminatory practices affecting US Senate employees)",
      "02:1301" : "02:1301 (02;1301 Congressional Accountability Act)",
      "02:1317(a)" : "02:1317(a) (02:1317(a) Violation of Congressional Accountability Act)",
      "02:138" : "02:138 (Library of Congress)",
      "02:358" : "02:358 (02:358 President's Recommendations of Exec.,Jud.& Leg. Salary)",
      "02:681" : "02:681 (02:681 Deferral of Budget Authority)",
      "05:0075" : "05:0075 (05:75(2) Contract - Reduction in Grade)",
      "05:0551" : "05:0551 (05:551 Administrative Procedure Act)",
      "05:0552fi" : "05:0552fi (05:552 Freedom of Information Act)",
      "05:0552pa" : "05:0552pa (05:552 Right to Privacy Act)",
      "05:0554" : "05:0554 (05:0554 Constitutionality of Maritime Statutes)",
      "05:0554sc" : "05:0554sc (05:0554 Constitutionality of State Statutes)",
      "05:0701" : "05:0701 (05:0701 Maritime Subsidy Board)",
      "05:0702" : "05:0702 (05:702 Administrative Procedure Act)",
      "05:0704" : "05:0704 (05:704 Labor Litigation)",
      "05:0706" : "05:0706 (05:0706 Judicial Review of Agency Action)",
      "05:101" : "05:101 (05:101 Ethics in Government Act)",
      "05:7703" : "05:7703 (05:7703 Discrimination - Review of Agency Act)",
      "05:8470" : "05:8470 (05:8470 Enforcement of Judgment against Retirement Benefits)",
      "05:8701" : "05:8701 (05:8701 Federal Employee's Group Life Insurance Act)",
      "05:8903" : "05:8903 (05:8903 Federal Employees Health Benefit Act)",
      "07:0006" : "07:0006 (7:6(b) Federal Commodity Exchange Regulation)",
      "07:0025" : "07:0025 (7:25 Fraud - Commodities Leverage Contracts)",
      "07:0181" : "07:0181 (07:181 Packers & Stockyard Act)",
      "07:0499" : "07:0499 (07:499 Agricultural Commodities Act)",
      "07:0601" : "07:0601 (07:601 USDA Condemnation)",
      "07:2321" : "07:2321 (07:2321 Plant Variety Protection Act)",
      "07:6999" : "07:6999 (Judicial Review of Adverse Farm Agency Decision)",
      "08:1101" : "08:1101 (08:1101 Immigration and Nationality Act)",
      "08:1105" : "08:1105 (8:1105(a) Aliens: Habeas Corpus to Release INS Detainee)",
      "08:1182" : "08:1182 (8:1182 Defend. Denial of Pla. Appl. for Alien Employment Cer)",
      "08:1231" : "08:1231 (08:1231(a)(6) Due Process Clause)",
      "08:1252" : "08:1252 (08:1252(a)(2) Injunction for Deportation)",
      "08:1255" : "08:1255 (08:1255 Immigration)",
      "08:1260" : "08:1260 (08:1260 Aliens: Access to Records)",
      "08:1324" : "08:1324 (08:1324 Aliens: Complaint for Forfeiture)",
      "08:1329" : "08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petition)",
      "08:1421" : "08:1421 (08:1421-Review of Denial of Application for Naturalization)",
      "08:1446" : "08:1446 (8:1446 Petition for Naturalization Hearing)",
      "08:1447" : "08:1447 (08:1447 Aliens: Refusal of Citizenship)",
      "08:1447in" : "08:1447in (08:1447 Immigration and Naturalization Act)",
      "08:1451(j)" : "08:1451(j) (8:1451(j) Motion to Correct Order & Judg. of Naturalization)",
      "09:0001" : "09:0001 (09:1 U.S. Arbitration Act)",
      "09:0009" : "09:0009 (9:9 Motion to Confirm Arbitration Award)",
      "09:0010" : "09:0010 (09:0010 Petition to Vacate Arbitration Award)",
      "10:1408" : "10:1408 (10:1408 Claim for Military Retirement)",
      "10:1552" : "10:1552 (10:1552 Armed Forces: Action to Correct Records)",
      "10:1553" : "10:1553 (10:1553 Armed Forces: FOIA General)",
      "10:2121" : "10:2121 (10:2121 Health Professions Scholarship Financial Asst Prog)",
      "10:2302" : "10:2302 (10:2302 Arms Services Procurement Act)",
      "10:2305" : "10:2305 (10:2305 Review of Federal Contract)",
      "10:2323fa" : "10:2323fa (10:2323 Fifth Amendment Equal Protection)",
      "11:0101" : "11:0101 (11:101 Bankruptcy)",
      "12:0022" : "12:0022 (12:22 Securities Fraud)",
      "12:0635" : "12:0635 (12:635 Breach of Insurance Contract)",
      "12:1452" : "12:1452 (12:1452 Federal Home Loan Mortgage Corporation Act)",
      "12:1461" : "12:1461 (12:1461 Homeowners Loan Act)",
      "12:1464" : "12:1464 (12:1464 Federal Savings and Loan)",
      "12:1703" : "12:1703 (12:1703 Default of HUD Loan)",
      "12:1725" : "12:1725 (12:1725 Collection under Contract Guaranty)",
      "12:1730" : "12:1730 (12:1730 Collection Under Contract Guaranty)",
      "12:1787" : "12:1787 (12:1787-Federal Credit Union Act)",
      "12:1819" : "12:1819 (12:1819 Default of Promissory Note)",
      "12:1821" : "12:1821 (12:1821 Default of Loan by Promissary Note)",
      "12:1833" : "12:1833 (12:1833 Forfieture Civil Penalties)",
      "12:191" : "12:191 (12:191 Bank Foreclosure)",
      "12:192" : "12:192 (12:192 Liquidation of National Bank)",
      "12:1971" : "12:1971 (12:1971 Relief under Bank Holding Act)",
      "12:1972" : "12:1972 (12:1972 Tying Arrangement Act)",
      "12:2601" : "12:2601 (12:2601 Violation of Real Estate Settlement Procedure Act)",
      "12:3410" : "12:3410 (12:3410 Right to Financial Privacy Act)",
      "13:0021" : "13:0021 (13:0021 Census Act of 1976)",
      "15:0001" : "15:0001 (15:1 Antitrust Litigation)",
      "15:0002at" : "15:0002at (15:2 Antitrust Litigation)",
      "15:0002fl" : "15:0002fl (15:2(a) Fair Labor Standards Act)",
      "15:0005" : "15:0005 (15:5(a) Fair Labor Standards Act)",
      "15:0015" : "15:0015 (15:15 Antitrust Litigation)",
      "15:0025" : "15:0025 (15:25 Clayton Act)",
      "15:0041" : "15:0041 (15:0041 Federal Trade Commission Act)",
      "15:0044" : "15:0044 (15:44 Trademark Infringement)",
      "15:0045" : "15:0045 (15:0045 Credit Repair Organization Act)",
      "15:0045cp" : "15:0045cp (15:0045 Violation of Children Online Privacy Protection Act)",
      "15:0052" : "15:0052 (15:0052 Federal Trade Commission Act)",
      "15:0053" : "15:0053 (15:0053 Federal Trade Commission Act)",
      "15:0077" : "15:0077 (15:77 Securities Fraud)",
      "15:0078" : "15:0078 (15:78m(a) Securities Exchange Act)",
      "15:0631" : "15:0631 (15:631 Small Business Act)",
      "15:0717" : "15:0717 (15:0717 Natural Gas Act - Land Condemnation)",
      "15:0754" : "15:0754 (15:754 Emergency Petroleum Allocation-Admin.& Enforcement)",
      "15:1051" : "15:1051 (15:1051 Trademark Infringement)",
      "15:1071" : "15:1071 (15:1071 Appeal of Decision of U.S. Patent & Trademark Office)",
      "15:1114" : "15:1114 (15:1114 Trademark Infringement)",
      "15:1121" : "15:1121 (15:1121 Trademark Infringement)",
      "15:1125" : "15:1125 (15:1125 Trademark Infringement (Lanham Act))",
      "15:1125ac" : "15:1125ac (15:1125 Trademark (Anticybersquatting consumer protection))",
      "15:1125la" : "15:1125la (15:1125 Lanham Act)",
      "15:1126" : "15:1126 (15:1126 Patent Infringement)",
      "15:1127" : "15:1127 (15:1127 Trademark Infringement)",
      "15:1601" : "15:1601 (15:1601 Truth in Lending)",
      "15:1640" : "15:1640 (15:1640 Truth in Lending)",
      "15:1679" : "15:1679 (15:1679 Violation of Credit Repair Organizations Act)",
      "15:1681" : "15:1681 (15:1681 Fair Credit Reporting Act)",
      "15:1691" : "15:1691 (15:1691 Equal Credit Opportunity Act)",
      "15:1692" : "15:1692 (15:1692 Fair Debt Collection Act)",
      "15:1693" : "15:1693 (15:1693 Electronic Fees Transfer Act)",
      "15:1701" : "15:1701 (15:1701 Interstate Land Sales Full Disclosure Act (ILFFDA))",
      "15:1938" : "15:1938 (15:1938 Fair Labor Standards Act)",
      "15:1938fm" : "15:1938fm (15:1938 Family Medical Leave Act)",
      "15:1981" : "15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))",
      "15:1988" : "15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))",
      "15:1989" : "15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))",
      "15:2051" : "15:2051 (15:2051 Consumer Products Safety Act)",
      "15:2301" : "15:2301 (15:2301 Magnuson-Moss Warranty Act)",
      "15:2801" : "15:2801 (15:2801 Petroleum Marketing Practices Act)",
      "15:53(b)" : "15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equita)",
      "15:7701" : "15:7701 (15:7701 Federal CAN-Spam Act)",
      "15:80" : "15:80 (15:80 Violation of the Investment Advisors Act of 1940)",
      "16:0668" : "16:0668 (16:668 Bald Eagle Protection Act)",
      "16:0703" : "16:0703 (16:703 Migratory Bird Act)",
      "16:1538" : "16:1538 (16:1538 Endangered Species Act)",
      "16:3371" : "16:3371 (16:3371 Wildlife Under the Lacey Act)",
      "16:3372" : "16:3372 (16:3372 Conservation: Complaint for Forfeiture)",
      "16:3373" : "16:3373 (16:3373 Appeal of Decision - DOI)",
      "16:3374" : "16:3374 (16:3374 Conservation: Complaint for Forfeiture)",
      "16:470" : "16:470 (16:470 National Historic Preservation Act)",
      "16:470f" : "16:470f (16:470 National Historic Preservation Act)",
      "17:0101" : "17:0101 (17:101 Copyright Infringement)",
      "17:0501" : "17:0501 (17:501 Copyright Infringement)",
      "17:0504" : "17:0504 (17:504 Copyright Infringement)",
      "17:1201" : "17:1201 (17:1201 Digital Millennium Copyright Act)",
      "18:0209" : "18:0209 (18:0209 Conflict of Interest)",
      "18:0241" : "18:0241 (18:241 Conspiracy Against Citizen Rights)",
      "18:0981" : "18:0981 (18:0981 Forfeiture)",
      "18:1030" : "18:1030 (18:1030 Computer Fraud and Abuse Act)",
      "18:1345" : "18:1345 (18:1345 Injunctive and Declaratory Relief)",
      "18:1595" : "18:1595 (18 USC 1595 Human Trafficking Litigation)",
      "18:1831" : "18:1831 (18:1831 Defense of Trade Secrets Act (DTSA))",
      "18:1836a" : "18:1836a (18:1836(a) - Injunction against Misappropriation of Trade Secrets)",
      "18:1836b" : "18:1836b (18:1836(b) - Civil Action to Protect Trade Secrets)",
      "18:1961" : "18:1961 (18:1961 Racketeering (RICO) Act)",
      "18:1962" : "18:1962 (18:1962 Racketeering (RICO) Act)",
      "18:1964" : "18:1964 (18:1964 Racketeering (RICO) Act)",
      "18:2331" : "18:2331 (18:2331 Antiterrorism Act of 1990)",
      "18:2511" : "18:2511 (18:2511 Wiretapping)",
      "18:2701" : "18:2701 (18:2701 Federal Communications Privacy Act)",
      "18:3006" : "18:3006 (18:3006 Hyde Amendment, Statutory Note)",
      "18:3114" : "18:3114 (18:3114 Motion for Return of Seized Property)",
      "18:3663" : "18:3663 (18 U.S.C. 3663 - Civil Enforcement of Crim. Rest. Obligation)",
      "18:4208" : "18:4208 (18:4208(B) Agency Action Review)",
      "19:1305" : "19:1305 (19:1305 Custom Duties: Forfeiture-Immoral Articles)",
      "20:1080" : "20:1080 (20:1080 Student Loan Recovery)",
      "20:1099" : "20:1099 (20:1099 Higher Education Act)",
      "20:1400" : "20:1400 (20:1400 Civil Rights of Handicapped Child)",
      "20:1401" : "20:1401 (20:1401 Education: Handicapped Child Act)",
      "20:1415" : "20:1415 (20:1415 Handicapped Children's Protection Act)",
      "20:1415de" : "20:1415de (20:1415 Individuals with Disabilities Education Act)",
      "20:1681" : "20:1681 (20:1681 Civil Rights Education Amendments Act 1972)",
      "21:0821" : "21:0821 (21:0821 Violation of Record Keeping Provision of Controlled Substance Act)",
      "21:0841" : "21:0841 (21:841 Forfeiture Property-Drugs)",
      "21:0881" : "21:0881 (21:881 Forfeiture Property-Drugs)",
      "21:0881a" : "21:0881a (21:881 Forfeiture Property - Aircraft)",
      "21:0881re" : "21:0881re (21:881 Forfeiture Property - Real Estate)",
      "23:0134" : "23:0134 (23:134 P.I.- Auto Negligence)",
      "23:1441" : "23:1441 (23:1441 Contract Real Estate)",
      "24:1000" : "24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)",
      "25:0640" : "25:0640 (25:640 Indian Tribal Rights)",
      "25:1901" : "25:1901 (25:1901 Indian Child Welfare Act)",
      "26:5872" : "26:5872 (26:5872 Forfeiture - Firearms)",
      "26:6212" : "26:6212 (26:6212 Injunctive Relief from IRS Lien)",
      "26:6213" : "26:6213 (26:6213 Injunctive Relief from IRS Lien)",
      "26:6330" : "26:6330 (26:6330 Redetermination of IRS Collection Action)",
      "26:6502" : "26:6502 (26:6502 IRS:Enforcement of tax liens)",
      "26:6532" : "26:6532 (26:6532 IRS: Refund of Tax Penalty)",
      "26:6702" : "26:6702 (26:6702 IRS: Refund of Income Tax Penalty)",
      "26:6703" : "26:6703 (26:6703 IRS: Refund of Tax Penalty)",
      "26:7401" : "26:7401 (26:7401 IRS: Tax Liability)",
      "26:7402" : "26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)",
      "26:7403" : "26:7403 (26:7403 Suit to Enforce Federal Tax Lien)",
      "26:7422rt" : "26:7422rt (26:7422 IRS: Refund Taxes)",
      "26:7422rx" : "26:7422rx (26:7422 IRS: Refund Excise Tax)",
      "26:7426" : "26:7426 (26:7426 IRS: Wrongful Levy for Taxes)",
      "26:7429" : "26:7429 (26:7429 IRS: Tax Jeopardy Assessment)",
      "26:7431" : "26:7431 (26:7431 Unlawful Inspection and Disclosure of Confidential Tax Information by Agents of the IRS)",
      "26:7434" : "26:7434 (26:7434 IRS Fraudulent Loans)",
      "26:7609" : "26:7609 (26:7609 IRS: Petition to Quash IRS Summons)",
      "26:7609en" : "26:7609en (26:7609 IRS: Petition to serve IRS Summons)",
      "27:0185" : "27:0185 (27:185 Enforcement of Arbitration Award)",
      "28:0157c" : "28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)",
      "28:0157d" : "28:0157d (28:0157 Motion for Withdrawal of Reference)",
      "28:0158" : "28:0158 (28:0158 Bankruptcy Appeal from Judgment/Order)",
      "28:0185" : "28:0185 (28:185 Suit to Compel Arbitration)",
      "28:0451" : "28:0451 (28:451 Employment Discrimination)",
      "28:0754" : "28:0754 (28:754 Receiver of Property in Different Districts)",
      "28:0794" : "28:0794 (28:794 Rehabilitation Act)",
      "28:1001" : "28:1001 (28:1001 E.R.I.S.A.)",
      "28:1132" : "28:1132 (28:1132 E.R.I.S.A.)",
      "28:1161" : "28:1161 (28:1161 Denial of Healthcare Coverage)",
      "28:1330" : "28:1330 (28:1330 Breach of Contract)",
      "28:1331" : "28:1331 (28:1331 Federal Question)",
      "28:1331ag" : "28:1331ag (28:1331 Fed. Question: Employment Discrimination (Age))",
      "28:1331al" : "28:1331al (28:1331 Fed. Question: Airline Crash)",
      "28:1331as" : "28:1331as (28:1331 Fed. Question: Assault, Libel, Slander)",
      "28:1331at" : "28:1331at (28:1331 Fed. Question: Anti-trust)",
      "28:1331au" : "28:1331au (28:1331 Fed. Question: Auto Negligence)",
      "28:1331b" : "28:1331b (28:1331 Federal Question: Bivens Act)",
      "28:1331bc" : "28:1331bc (28:1331 Fed. Question: Breach of Contract)",
      "28:1331bv" : "28:1331bv (28:1331 Federal Question Bivens-Prisoner)",
      "28:1331ca" : "28:1331ca (28:1331 Fed Question: Fed Communications Act of 1)",
      "28:1331cm" : "28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)",
      "28:1331cr" : "28:1331cr (28:1331 Civil Rights (Race Discrimination))",
      "28:1331cv" : "28:1331cv (28:1331 Fed. Question: Civil Rights Violation)",
      "28:1331dj" : "28:1331dj (28:1331 Fed. Question: Declaratory Judgment)",
      "28:1331dp" : "28:1331dp (28:1331 Fed. Question-Violation of Due Process)",
      "28:1331ed" : "28:1331ed (28:1331 Fed. Question: Employment Discrimination)",
      "28:1331ef" : "28:1331ef (28:1331 Fed. Question: Civil Rights Violation (Excess Force))",
      "28:1331ej" : "28:1331ej (28:1331 Fed. Question: Enforcement of Judgment)",
      "28:1331es" : "28:1331es (28:1331 Enforcement of Administrative Subpoena)",
      "28:1331fa" : "28:1331fa (28:1331 Fed. Question: Civil Rights Violation-False Arrest)",
      "28:1331fl" : "28:1331fl (28:1331 Fed. Question: Fair Labor Standards)",
      "28:1331fm" : "28:1331fm (28:1331 Fed. Question - Family and Medical Leave Act)",
      "28:1331fr" : "28:1331fr (28:1331 Fed. Question: Fraud)",
      "28:1331in" : "28:1331in (28:1331 Fed. Question: Insurance Contract)",
      "28:1331lm" : "28:1331lm (28:1331 Fed. Question: Labor/Mgt. Relations Act)",
      "28:1331mm" : "28:1331mm (28:1331 Fed. Question: Medical Malpractice)",
      "28:1331ng" : "28:1331ng (28:1331 Fed. Question: Natural Gas Act)",
      "28:1331ni" : "28:1331ni (28:1331 Fed. Question: Negotiable Instrument)",
      "28:1331pd" : "28:1331pd (28:1331 Fed. Question: Property Damage)",
      "28:1331pi" : "28:1331pi (28:1331 Fed. Question: Personal Injury)",
      "28:1331pl" : "28:1331pl (28:1331 Fed. Question: Product Liability)",
      "28:1331ra" : "28:1331ra (28:1331 Fed. Question: Racketeering (RICO) Act)",
      "28:1331rd" : "28:1331rd (28:1331 Fed. Question: Review Agency Decision)",
      "28:1331rp" : "28:1331rp (28:1331 Fed. Question: Real Property)",
      "28:1331rr" : "28:1331rr (28:1331 Fed. Question: Railway Labor Act)",
      "28:1331sh" : "28:1331sh (28:1331 Fed. Question: Sexual Harassment)",
      "28:1331ss" : "28:1331ss (28:1331 Fed. Question: Constitutionality of State Statutes)",
      "28:1331sv" : "28:1331sv (28:1331 Fed. Question: Securities Violation)",
      "28:1331sx" : "28:1331sx (28:1331 Fed. Question: Employment Discrimination (Sex))",
      "28:1331tr" : "28:1331tr (28:1331 Fed. Question: Trademark)",
      "28:1331tt" : "28:1331tt (28:1331 Fed. Question: Tort Action)",
      "28:1331v" : "28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendment)",
      "28:1331vc" : "28:1331vc (28:1331 Fed Question-Violation of Constitutional Rights)",
      "28:1331w" : "28:1331w (28:1331 Fed. Question: Wrongful Termination of Employment)",
      "28:1331wd" : "28:1331wd (28:1331 Fed. Question: Wrongful Death)",
      "28:1331wl" : "28:1331wl (28:1331 Federal Question: EPA Waste Lien)",
      "28:1331wt" : "28:1331wt (28:1331 Fed. Question: Water Rights)",
      "28:1332ac" : "28:1332ac (28:1332 Diversity-Account Receivable)",
      "28:1332al" : "28:1332al (28:1332 Diversity-Airline Crash)",
      "28:1332ar" : "28:1332ar (28:1332 Diversity-Appointment of Receiver)",
      "28:1332as" : "28:1332as (28:1332 Diversity-Asbestos Litigation)",
      "28:1332au" : "28:1332au (28:1332 Diversity-Auto Negligence)",
      "28:1332bc" : "28:1332bc (28:1332 Diversity-Breach of Contract)",
      "28:1332bf" : "28:1332bf (28:1332 Diversity-Breach of Fiduciary Duty)",
      "28:1332co" : "28:1332co (28:1332 Diversity-Conversion)",
      "28:1332ct" : "28:1332ct (28:1332 Diversity-(Citizenship))",
      "28:1332det" : "28:1332det (28:1332 Diversity: Forcible Detainer)",
      "28:1332df" : "28:1332df (28:1332 Diversity-Contract Default)",
      "28:1332ds" : "28:1332ds (28:1332 Diversity-Contract Dispute)",
      "28:1332ed" : "28:1332ed (28:1332 Diversity-Employment Discrimination)",
      "28:1332fd" : "28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)",
      "28:1332fr" : "28:1332fr (28:1332 Diversity-Fraud)",
      "28:1332ia" : "28:1332ia (28:1332 Diversity-Interpleader Action)",
      "28:1332ij" : "28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)",
      "28:1332in" : "28:1332in (28:1332 Diversity-Insurance Contract)",
      "28:1332jd" : "28:1332jd (28:1332 Diversity-Declaratory Judgment)",
      "28:1332lb" : "28:1332lb (28:1332 Diversity-Libel, Assault, Slander)",
      "28:1332lm" : "28:1332lm (28:1332 Diversity-Legal Malpractice)",
      "28:1332ma" : "28:1332ma (28:1332 Diversity-Miller Act)",
      "28:1332md" : "28:1332md (28:1332 Diversity-Motor Vehicle/Wrongful Death)",
      "28:1332mm" : "28:1332mm (28:1332 Diversity-Medical Malpractice)",
      "28:1332mv" : "28:1332mv (28:1332 Diversity-Personal Injury/ Motor Vehicle)",
      "28:1332ni" : "28:1332ni (28:1332 Diversity-Negotiable Instrument)",
      "28:1332nm" : "28:1332nm (28:1332 Diversity-Non-Motor Vehicle)",
      "28:1332nr" : "28:1332nr (28:1332 Diversity-Notice of Removal)",
      "28:1332oc" : "28:1332oc (28:1332 Diversity-Other Contract)",
      "28:1332op" : "28:1332op (28:1332 Diversity-Recovery of Overpayment)",
      "28:1332pa" : "28:1332pa (28:1332 Diversity-Personal Injury/Airplane)",
      "28:1332pd" : "28:1332pd (28:1332 Diversity-Property Damage)",
      "28:1332pi" : "28:1332pi (28:1332 Diversity-Personal Injury)",
      "28:1332pl" : "28:1332pl (28:1332 Diversity-Product Liability)",
      "28:1332pr" : "28:1332pr (28:1332 Diversity-Petition for Removal)",
      "28:1332qt" : "28:1332qt (28:1332 Diversity-Petition to Quiet Title)",
      "28:1332rd" : "28:1332rd (28:1332 Diversity-Recovery of Debt)",
      "28:1332ri" : "28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)",
      "28:1332rl" : "28:1332rl (28:1332 Diversity-Rent Lease & Ejectment)",
      "28:1332sa" : "28:1332sa (28:1332 - Diversity: Securities & Exchange Commiss)",
      "28:1332sf" : "28:1332sf (28:1332 - Diversity: Securities Fraud)",
      "28:1332sh" : "28:1332sh (28:1332 Diversity-Sexual Harassment)",
      "28:1332ss" : "28:1332ss (28:1332 Diversity - Stockholders Suits)",
      "28:1332tl" : "28:1332tl (28:1332 Diversity-Torts to Land)",
      "28:1332tm" : "28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))",
      "28:1332tn" : "28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)",
      "28:1332ts" : "28:1332ts (28:1332 Diversity-Misappropriation of Trade Secrets)",
      "28:1332vt" : "28:1332vt (28:1332 DIVERSITY-Natl Motor Vehicle Title Information Syst)",
      "28:1332wd" : "28:1332wd (28:1332 Diversity-Wrongful Death)",
      "28:1333" : "28:1333 (28:1333 Admiralty)",
      "28:1334" : "28:1334 (28:1334 Bankruptcy Appeal)",
      "28:1334bjd" : "28:1334bjd (28:1334 Bankruptcy-Jury Demand)",
      "28:1334c" : "28:1334c (28:1334(c) R&R re motions for abstention (non-cor)",
      "28:1335" : "28:1335 (28:1335 Interpleader Action)",
      "28:1337" : "28:1337 (28:1337 Sherman-Clayton Act)",
      "28:1338cp" : "28:1338cp (28:1338 Copyright Infringement)",
      "28:1338pt" : "28:1338pt (28:1338 Patent Infringement)",
      "28:1338tr" : "28:1338tr (28:1338 Trademark Infringement)",
      "28:1340" : "28:1340 (28:1340 IRS: Custom Duties)",
      "28:1340er" : "28:1340er (28:1340 Recovery of Erroneous Refund)",
      "28:1340irs" : "28:1340irs (28:1340 IRS:Taxes)",
      "28:1341" : "28:1341 (28:1341 Complaint for Forfeiture)",
      "28:1343" : "28:1343 (28:1343 Violation of Civil Rights)",
      "28:1345" : "28:1345 (28:1345 USA Plaintiff)",
      "28:1345co" : "28:1345co (28:1345 Replevin & Conversion)",
      "28:1345db" : "28:1345db (28:1345 Debt to US - FHA/HUD Title I)",
      "28:1345df" : "28:1345df (28:1345 Default of Promissory Note)",
      "28:1345er" : "28:1345er (28:1345 Recovery of Erroneous Refund)",
      "28:1345fc" : "28:1345fc (28:1345 Foreclosure)",
      "28:1345ff" : "28:1345ff (28:1345 Complaint for Forfeiture)",
      "28:1345hl" : "28:1345hl (28:1345 VA Home Loan Guaranty Debt)",
      "28:1345mc" : "28:1345mc (28:1345 Medical Care Recovery)",
      "28:1345mi" : "28:1345mi (28:1345 Mining Claim Ejectment)",
      "28:1345pd" : "28:1345pd (28:1345 Property Damage)",
      "28:1345pe" : "28:1345pe (28:1345 VA Property Ejectment)",
      "28:1345rc" : "28:1345rc (28:1345 Recovery of Debt to US)",
      "28:1345st" : "28:1345st (28:1345 Default of Student Loan)",
      "28:1345tp" : "28:1345tp (28:1345 Trespass on Public Land)",
      "28:1345va" : "28:1345va (28:1345 Recovery of VA Overpayment)",
      "28:1346bc" : "28:1346bc (28:1346 Breach of Contract)",
      "28:1346pi" : "28:1346pi (28:1346 Tort Claim - Personal Injury/Motor Vehicle)",
      "28:1346rc" : "28:1346rc (28:1346 Recovery of IRS Tax)",
      "28:1346tc" : "28:1346tc (28:1346 Tort Claim)",
      "28:1346wd" : "28:1346wd (28:1346 Wrongful Death)",
      "28:1349" : "28:1349 (28:1348 Corporation organized under Federal Law as party)",
      "28:1350" : "28:1350 (28:1350 Alien Tort Claims Act)",
      "28:1352" : "28:1352 (28:1352 Miller Act)",
      "28:1355" : "28:1355 (28:1355 Petition for Return of Property)",
      "28:1358" : "28:1358 (28:1358 Land Condemnation)",
      "28:1361" : "28:1361 (28:1361 Petition for Writ of Mandamus)",
      "28:1362ic" : "28:1362ic (28:1362 Indian Tribal Controversy)",
      "28:1362iw" : "28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)",
      "28:1364" : "28:1364 (28:1364 Auto Negligence)",
      "28:1391" : "28:1391 (28:1391 Personal Injury)",
      "28:1391cj" : "28:1391cj (28:1391 Confessed Judgment)",
      "28:1402" : "28:1402 (28:1402 Medical Malpractice)",
      "28:1407" : "28:1407 (28:1407 Airline Crash)",
      "28:1415de" : "28:1415de (28:1415 Individuals with Disabilities Education Act)",
      "28:1441" : "28:1441 (28:1441 Notice of Removal-Violation Virginia Consumer Protection Act)",
      "28:1441ac" : "28:1441ac (28:1441 Notice of Removal-Account Receivable)",
      "28:1441ag" : "28:1441ag (28:1441 Notice of Removal-Civil Rights (Age))",
      "28:1441al" : "28:1441al (28:1441 Notice of Removal-Airline Crash)",
      "28:1441as" : "28:1441as (28:1441 Notice of Removal-Asbestos Litigation)",
      "28:1441au" : "28:1441au (28:1441 Notice of Removal-Auto Negligence)",
      "28:1441b" : "28:1441b (28:1441 Notice of Removal-Employee Benefits)",
      "28:1441bc" : "28:1441bc (28:1441 Notice of Removal-Breach of Contract)",
      "28:1441ca" : "28:1441ca (28:1441 Notice of Removal-Clean Air Act)",
      "28:1441cc" : "28:1441cc (28:1441 Notice of Removal-Computer Crimes Act)",
      "28:1441cf" : "28:1441cf (28:1441 Notice of Removal - Consumer Financial Protection Act)",
      "28:1441cj" : "28:1441cj (28:1441 Notice of Removal-Confessed Judgement)",
      "28:1441cp" : "28:1441cp (28:1441 Notice of Removal-Copyright)",
      "28:1441cr" : "28:1441cr (28:1441 Notice of Removal-Civil Rights)",
      "28:1441cv" : "28:1441cv (28:1441 Petition for Removal- Civil Rights Act)",
      "28:1441d" : "28:1441d (28:1441 Notice of Removal - Foreign State Garnishment)",
      "28:1441df" : "28:1441df (28:1441 Notice of Removal-Contract Default)",
      "28:1441di" : "28:1441di (28:1441 Notice of Removal-Civil Rights (Disability Act))",
      "28:1441dj" : "28:1441dj (28:1441 Notice of Removal-Declaratory Judgment)",
      "28:1441ds" : "28:1441ds (28:1441 Notice of Removal-Contract Dispute)",
      "28:1441ea" : "28:1441ea (28:1441 Notice of Removal-Employment Discrimination (Age))",
      "28:1441eb" : "28:1441eb (28:1441 Notice of Removal E.R.I.S.A. Employee Benefits)",
      "28:1441ed" : "28:1441ed (28:1441 Notice of Removal-Employment Discrimination)",
      "28:1441ep" : "28:1441ep (28:1441 Notice of Removal - Equal Pay Act)",
      "28:1441er" : "28:1441er (28:1441 Notice of Removal-Employment Discrimination (Race))",
      "28:1441es" : "28:1441es (28:1441 Notice of Removal-Employment Discrimination (Sex))",
      "28:1441fa" : "28:1441fa (28:1441 Notice of Removal - (Civil Rights - False Arrest))",
      "28:1441fc" : "28:1441fc (28:1441 Notice Of Removal - Fair Credit Reporting Act)",
      "28:1441fca" : "28:1441fca (28:1441 Notice of Removal - False Claims Act-Retaliation)",
      "28:1441fcl" : "28:1441fcl (28:1441 Notice of Removal-Foreclosure)",
      "28:1441fd" : "28:1441fd (28:1441 Notice of Removal - Fair Debt Collection Act)",
      "28:1441fe" : "28:1441fe (28:1441 Notice of Removal-Fed. Employee Garnishment Statute)",
      "28:1441fl" : "28:1441fl (28:1441 Notice of Removal-Fair Labor Standards Act)",
      "28:1441fm" : "28:1441fm (28:1441 Notice of Removal - Family and Medical Leave Act)",
      "28:1441fr" : "28:1441fr (28:1441 Notice of Removal-Fraud)",
      "28:1441fs" : "28:1441fs (28:1441 Notice of Removal - Foreign Sovereign Immunities Act)",
      "28:1441hb" : "28:1441hb (28:1441 Notice of Removal - Petition of Habeas Corpus)",
      "28:1441hc" : "28:1441hc (28:1441 Notice of Removal - Handicapped Child Protection Act)",
      "28:1441hd" : "28:1441hd (28:1441 Notice of Removal-Housing Discrimination)",
      "28:1441ia" : "28:1441ia (28:1441 Notice of Removal-Interstate Commerce Act)",
      "28:1441ij" : "28:1441ij (28:1441 Notice of Removal-Injunctive/Declaratory Relief)",
      "28:1441il" : "28:1441il (28:1441 Notice of Removal-Interstate Land Full Discloser Act)",
      "28:1441in" : "28:1441in (28:1441 Notice of Removal-Insurance Contract)",
      "28:1441int" : "28:1441int (28:1441 Petition for Removal- Action for Interplea)",
      "28:1441lb" : "28:1441lb (28:1441 Notice of Removal-Libel, Assault, Slander)",
      "28:1441lm" : "28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relatio)",
      "28:1441mm" : "28:1441mm (28:1441 Notice of Removal-Medical Malpractice)",
      "28:1441ni" : "28:1441ni (28:1441 Notice of Removal-Negotiable Instrument)",
      "28:1441nm" : "28:1441nm (28:1441 Notice of Removal-Non-Motor Vehicle)",
      "28:1441nr" : "28:1441nr (28:1441 Notice of Removal)",
      "28:1441oc" : "28:1441oc (28:1441 Petition For Removal--Other Contract)",
      "28:1441op" : "28:1441op (28:1441 Notice of Removal - Oil Pollution Act of 1990)",
      "28:1441pa" : "28:1441pa (Notice of Removal - Patent Infringement)",
      "28:1441pd" : "28:1441pd (28:1441 Notice of Removal-Property Damage)",
      "28:1441pi" : "28:1441pi (28:1441 Notice of Removal-Personal Injury)",
      "28:1441pl" : "28:1441pl (28:1441 Notice of Removal-Product Liability)",
      "28:1441pr" : "28:1441pr (28:1441 Petition for Removal)",
      "28:1441ps" : "28:1441ps (28:1441 Notice of Removal-Claim against US Postal Service)",
      "28:1441qt" : "28:1441qt (28:1441 Notice of Removal-Petition to Quiet Title)",
      "28:1441ra" : "28:1441ra (28:1441 Notice of Removal-Civil Rights (Race))",
      "28:1441ri" : "28:1441ri (28:1441 Notice of Removal-RICO)",
      "28:1441rl" : "28:1441rl (28:1441 Notice of Removal-Rent Lease & Ejectment)",
      "28:1441s" : "28:1441s (28:1441 Notice of Removal - Economic Stabilization Act)",
      "28:1441sa" : "28:1441sa (28:1441 - Petition for Removal: SEC Act)",
      "28:1441sf" : "28:1441sf (28:1441 Notice of Removal-Securities Fraud)",
      "28:1441sh" : "28:1441sh (28:1441 Notice of Removal-Sexual Harassment)",
      "28:1441ss" : "28:1441ss (28:1441 Notice of Removal - Stockholders Suits)",
      "28:1441sv" : "28:1441sv (28:1441 Notice of Removal-Security Violation)",
      "28:1441sx" : "28:1441sx (28:1441 Notice of Removal-Civil Rights (Sex))",
      "28:1441ti" : "28:1441ti (28:1441 Notice of Removal-Trademark Infringement)",
      "28:1441tl" : "28:1441tl (28:1441 Notice of Removal - Truth and Lending)",
      "28:1441tm" : "28:1441tm (28:1441 Notice of Removal-Tort/Motor Vehicle (P.I.))",
      "28:1441tn" : "28:1441tn (28:1441 Notice of Removal-Tort/Non-Motor Vehicle)",
      "28:1441va" : "28:1441va (28:1441 Notice of Removal-Little Miller Act)",
      "28:1441vr" : "28:1441vr (28:1441 Notice of Removal -Violation of Real Estate Settlement Procedure Act)",
      "28:1441wd" : "28:1441wd (28:1441 Notice of Removal-Wrongful Death)",
      "28:1441wt" : "28:1441wt (28:1441 Notice of Removal-Employment (Wrongful Termination))",
      "28:1442bc" : "28:1442bc (28:1442 Notice of Removal-Breach of Contract)",
      "28:1442g" : "28:1442g (28:1442 Notice of Removal-Garnishment)",
      "28:1442nr" : "28:1442nr (28:1442 Notice of Removal)",
      "28:1442pr" : "28:1442pr (28:1442 Petition for Removal)",
      "28:1442ss" : "28:1442ss (28:1442 Notice of Removal-Denial of Social Security Benefits)",
      "28:1443" : "28:1443 (28:1443(1) Rent, Lease & Ejectment)",
      "28:1444tax" : "28:1444tax (28:1441 Notice of Removal-Recovery of IRS Tax)",
      "28:1446" : "28:1446 ()",
      "28:1446cs" : "28:1446cs (28:1446 Notice of Removal-Child Support Enforcement)",
      "28:1446fm" : "28:1446fm (28:1446 Notice of Removal-Family and Medical Leave Act)",
      "28:1446in" : "28:1446in (28:1446 Breach of Contract- Insurance)",
      "28:1446la" : "28:1446la (28:1446 Notice of Removal - Lanham Act)",
      "28:1446nr" : "28:1446nr (28:1446 Notice of Removal)",
      "28:1446pd" : "28:1446pd (28:1446 Notice of Removal-Property Damage (P.I.))",
      "28:1446pi" : "28:1446pi (28:1446 Notice of Removal-Personal Injury)",
      "28:1446pl" : "28:1446pl (28:1446pl Petition for Removal - Product Liability)",
      "28:1446pr" : "28:1446pr (28:1446 Petition for Removal)",
      "28:1452" : "28:1452 (28:1452 Removal of Claim in Civil Action Related to BK. Case)",
      "28:1602" : "28:1602 (28:1602 Foreign Sovereign Ammunities Act)",
      "28:1605" : "28:1605 (28:1605 Antiterrorism & Effective Death Penalty Act 1996)",
      "28:1651" : "28:1651 (28:1651 Petition for Writ of Coram Nobis)",
      "28:1651hc" : "28:1651hc (28:1651 Petition for Writ of Habeas Corpus)",
      "28:1651mn" : "28:1651mn (28:1651 Petition for Writ of Mandamus)",
      "28:1738cs" : "28:1738cs (28:1738 Child Custody Determination)",
      "28:1782" : "28:1782 (28:1782 Letter Rogatory)",
      "28:2201" : "28:2201 (28:2201 Constitutionality of State Statute(s))",
      "28:2201cp" : "28:2201cp (28:2201 Declaratory Judgment (Copyright))",
      "28:2201dj" : "28:2201dj (28:2201 Declaratory Judgment)",
      "28:2201ij" : "28:2201ij (28:2201 Injunction)",
      "28:2201in" : "28:2201in (28:2201 Declaratory Judgment (Insurance))",
      "28:2241" : "28:2241 (28:2241 Petition for Writ of Habeas Corpus (Federal))",
      "28:2254" : "28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))",
      "28:2254se" : "28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)",
      "28:2255" : "28:2255 (28:2255 Motion to Vacate Sentence)",
      "28:2271" : "28:2271 (28:2271 Federal Tort Claims Act)",
      "28:2345" : "28:2345 (28:2345 Medicare Recovery)",
      "28:2401" : "28:2401 (28:2401 Time for commencing action against United States)",
      "28:2409" : "28:2409 (28:2409(a) Quiet Title Action)",
      "28:2410" : "28:2410 (Actions affecting property on which United States had lien)",
      "28:2415" : "28:2415 (28:2415 Detinue and Conversion)",
      "28:2671" : "28:2671 (28:2671 Federal Tort Claims Act)",
      "28:2671mv" : "28:2671mv (28:2671mv Federal Tort Claims Act:Motor Vehicle)",
      "28:2671pi" : "28:2671pi (28:2671 Federal Tort Claim Act - Personal Injury)",
      "28:2674" : "28:2674 (28:2674 Federal Tort Claims Act)",
      "28:2679" : "28:2679 (28:2679-Westfall Act)",
      "28:2680" : "28:2680 (28:2680 Federal Tort Claim Act Medical Malpractice)",
      "28:2680mm" : "28:2680mm (28:2680 Federal Tort Claims Act Med Malpractice)",
      "28:534" : "28:534 (28:534 Expungement of Arrest Record)",
      "28:636" : "28:636 (28:636 Request Release of Transcript)",
      "28:7402" : "28:7402 (28:7402 Refund of Taxes)",
      "28:7422" : "28:7422 (28:7422 Appeal from Administrative Decision)",
      "29:0151" : "29:0151 (29:151 Labor: Review of Agency Action)",
      "29:0160" : "29:0160 (29:160(1) National Labor Relations Act)",
      "29:0184" : "29:0184 (29:184 Violation Collection Bargain Agreement)",
      "29:0185ep" : "29:0185ep (29:185 Employee Pension Plan)",
      "29:0185lm" : "29:0185lm (29:185 Labor/Mgt. Relations (Contracts))",
      "29:0201do" : "29:0201do (29:201 Denial of Overtime Compensation)",
      "29:0201fl" : "29:0201fl (29:201 Fair Labor Standards Act)",
      "29:0203" : "29:0203 (29:203 Equal Pay Act)",
      "29:0206" : "29:0206 (29:206 Collect Unpaid Wages)",
      "29:0206epa" : "29:0206epa (29:0206 Equal Pay Act)",
      "29:0401" : "29:0401 (29:0401 Labor Management Disclosure Act)",
      "29:0621" : "29:0621 (29:621 Job Discrimination (Age))",
      "29:0623" : "29:0623 (29:623 Job Discrimination (Age))",
      "29:0626" : "29:0626 (29:626 Job Discrimination (Age))",
      "29:0633" : "29:0633 (29:633 Job Discrimination (Age))",
      "29:0651" : "29:0651 (29:651 Occupational Safety/Health)",
      "29:0754" : "29:0754 (29:754 Discrimination)",
      "29:0791" : "29:0791 (29:791 Job Discrimination (Rehabilitation Act))",
      "29:0794" : "29:0794 (29:0794 Job Discrimination (Handicap))",
      "29:1001" : "29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)",
      "29:1002" : "29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)",
      "29:1104" : "29:1104 (29:1104 Recovery of Benefits to Employee)",
      "29:1109" : "29:1109 (29:1109 Breach of Fiduciary Duties)",
      "29:1131" : "29:1131 (29:1131 ERISA - Collection of Delinquent Trust Funds)",
      "29:1132" : "29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)",
      "29:1145" : "29:1145 (29:1145 E.R.I.S.A.)",
      "29:1149" : "29:1149 (29:1149 Recover Pension & Profit Sharing)",
      "29:1337" : "29:1337 (29:1337 E.R.I.S.A.)",
      "29:1362" : "29:1362 (29:1362 ERISA)",
      "29:1381" : "29:1381 (29:1381 E.R.I.S.A.)",
      "29:1401" : "29:1401 (29:1401(b)(2) Appeal of Arbitration Award)",
      "29:1451" : "29:1451 (29:1451 E.R.I.S.A.)",
      "29:1801" : "29:1801 (29:1801 Farmworker Rights)",
      "29:2001" : "29:2001 (29:2001 Employee Polygraph Protection Act)",
      "29:2101" : "29:2101 (29:2101 Workers Adjustment and Retraining Notification Act)",
      "29:2601" : "29:2601 (29:2601 Family and Medical Leave Act)",
      "29:790" : "29:790 (29:790 Rehabilitation of Labor)",
      "30:0181" : "30:0181 (30:0181 Environment: Review of Agency Action)",
      "30:0801" : "30:0801 (30:0801 Penalities/Federal Mine Safety Health Act)",
      "30:1201" : "30:1201 (30:1201 Environment: Review of Agency Action)",
      "30:1202" : "30:1202 (30:1202 Mining Reclamation Act)",
      "30:1276" : "30:1276 (30:1276 Interior: Review of Agency Action)",
      "31:3545" : "31:3545 (31:3545 Action to Recovery Money)",
      "31:3729" : "31:3729 (31:3729 False Claims Act)",
      "31:3730" : "31:3730 (31:3730 False Claims Act)",
      "31:3731" : "31:3731 (31:3731 Fraud)",
      "31:5314" : "31:5314 (31:5314 Failure to Report Interest in Foreign Accounts)",
      "31:5317" : "31:5317 (31:5317 Forfeiture-Funds involved in Structured Transactions)",
      "33:0901" : "33:0901 (33:0901 Longshoreman Habor Workers Compensation Act)",
      "33:1319cw" : "33:1319cw (33:1319 Clean Water Act)",
      "33:1319pv" : "33:1319pv (33:1319 Pollutants & Permit Violations)",
      "33:1365" : "33:1365 (33:1365 Environmental Matters)",
      "35:0145" : "35:0145 (35:145 Patent Non-Infringement- Patent Applicant is Dissatisfied with PTO Decision)",
      "35:0183" : "35:0183 (35:183 Patent Non-Infringement- Right to Compensation)",
      "35:0271" : "35:0271 (35:271 Patent Infringement)",
      "35:0292" : "35:0292 (35:292 False Marking)",
      "35:1" : "35:1 (35:1 Patent Non-Infringement - Declaratory Judgment)",
      "35:146" : "35:146 (35:146 Appeal of Decision of the Board of Patent Appeals and Interferences)",
      "35:154" : "35:154 (35:154 AIA Appeal of Patent Term Adjustment Determination)",
      "35:256" : "35:256 (35:256 Patent Non-Infringement)",
      "35:281" : "35:281 (35:281 Patent Infringement)",
      "35:311" : "35:311 (35:311 Patent - Request for Inter Partes Reexamination)",
      "38:1681" : "38:1681 (38:1681 Recovery of VA Overpayment)",
      "38:1686" : "38:1686 (38:1686 Recovery of VA Overpayment)",
      "38:1780" : "38:1780 (38:1780 Recovery of VA Overpayment)",
      "38:2011" : "38:2011 (38:2011 - Veteran's Readjustment Assistance Act of)",
      "38:2021" : "38:2021 (38:2021 Homeless Veterans Reintegration Programs)",
      "38:3116" : "38:3116 (38:3116 VA Overpayment)",
      "38:4301" : "38:4301 (38:4301Right to Re-employment of Inducted Persons)",
      "38:775" : "38:775 (Recovery of Servicemen's Group Life Insurance)",
      "39:3005" : "39:3005 (39:3005 Detention of Mail for Temporary Periods)",
      "39:409" : "39:409 (39:409 Postal Service)",
      "40:0258" : "40:0258 (40:258(a) Public Buildings & Property: Land Condemnation)",
      "40:0270" : "40:0270 (40:0270 Miller Act)",
      "40:0875" : "40:0875 (40:875 Public Buildings & Property: Negligence)",
      "40:1101" : "40:1101 (40:1101 Brooks Architect - Engineers Act)",
      "40:3131" : "40:3131 (40:3131 Miller Act)",
      "40:3132" : "40:3132 (40:3132 Miller Act)",
      "40:3133" : "40:3133 (40:3133 Miller Act)",
      "40:3134" : "40:3134 (40:3134 Miller Act)",
      "41:0251" : "41:0251 (41:251 Public Contracts-Review of Agency Action)",
      "41:1463" : "41:1463 (41:1463 Public Contracts: Unlawful Employment Practices)",
      "41:253" : "41:253 (41:253 Competition in Contracting Act)",
      "42:0205" : "42:0205 (42:205 Denial Social Security Benefits)",
      "42:0206" : "42:0206 (42:206 Social Security Benefits)",
      "42:0247" : "42:0247 (42:247 Personal Injury-Swine Flu)",
      "42:0402" : "42:0402 (42:402 Social Security Benefits)",
      "42:0405id" : "42:0405id (42:405 Review of HHS Decision (SSID))",
      "42:0405rsi" : "42:0405rsi (42:405 Review of HHS Decision (RSI))",
      "42:0405wc" : "42:0405wc (42:405 Review of HHS Decision (DIWC))",
      "42:0405ww" : "42:0405ww (42:405 Review of HHS Decision (DIWW))",
      "42:0416" : "42:0416 (42:416 Denial of Social Security Benefits)",
      "42:0427" : "42:0427 (42:427 Social Security Benefits)",
      "42:11601" : "42:11601 (42:11601 International Child Abduction Remedies Act)",
      "42:12101ad" : "42:12101ad (42:12101 Americans with Disability (Public Accommodations))",
      "42:12101d" : "42:12101d (42:12101 Americans with Disabilities Act)",
      "42:1320d" : "42:1320d (42:1320(d) Federal Health Insurance Portability and Accountability Act)",
      "42:1383" : "42:1383 (42:1383 Review of HHS Decision)",
      "42:1395" : "42:1395 (42:1395 HHS: Adverse Reimbursement Review)",
      "42:1395em" : "42:1395em (42:1395 Fed. Quest: (Emergency Medical Treatment/Labor Act))",
      "42:1396" : "42:1396 (42:1396 Denial Medicaid Insurance)",
      "42:1471" : "42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclo)",
      "42:1973" : "42:1973 (42:1973 National Voter Registration Act)",
      "42:1973gg" : "42:1973gg (42:1973gg National Voter Rights Act)",
      "42:1981cv" : "42:1981cv (42:1981 Civil Rights)",
      "42:1981hs" : "42:1981hs (42:1981 Housing Discrimination)",
      "42:1981jb" : "42:1981jb (42:1981 Job Discrimination (Race))",
      "42:1981sx" : "42:1981sx (42:1981 Sex Discrimination)",
      "42:1983bv" : "42:1983bv (42:1983 Bivens Non-Prisoner)",
      "42:1983cv" : "42:1983cv (42:1983 Civil Rights Act)",
      "42:1983cvp" : "42:1983cvp (42:1983 Civil Rights (Personal Property))",
      "42:1983dp" : "42:1983dp (42:1983 Civil Right Denial of Due Process)",
      "42:1983ed" : "42:1983ed (42:1983 Civil Rights (Employment Discrimination))",
      "42:1983pr" : "42:1983pr (42:1983 Prisoner Civil Rights)",
      "42:1983vp" : "42:1983vp (42:1983 Violation of Due Process and Equal Protection)",
      "42:1985" : "42:1985 (42:1985 Conspiracy to Interfere with Civil Rights)",
      "42:1986" : "42:1986 (42:1986 Neglect of Duty)",
      "42:1997" : "42:1997 (42 USC 1997 CRIPA)",
      "42:2000ad" : "42:2000ad (42:2000 Job Discrimination (Disability Act))",
      "42:2000ag" : "42:2000ag (42:2000 Job Discrimination (Age))",
      "42:2000cc" : "42:2000cc (42:2000 Religious Land Use and Institutional Persons Act of 2000 (RLUIPA))",
      "42:2000e" : "42:2000e (42:2000e Job Discrimination (Employment))",
      "42:2000no" : "42:2000no (42:2000 Job Discrimination (National Origin))",
      "42:2000pb" : "42:2000pb (42:2000 Job Discrimination (Public Accommodations))",
      "42:2000ra" : "42:2000ra (42:2000 Job Discrimination (Race))",
      "42:2000re" : "42:2000re (42:2000 Job Discrimination (Religion))",
      "42:2000sh" : "42:2000sh (42:2000 Job Discrimination (Sexual Harassment))",
      "42:2000sx" : "42:2000sx (42:2000 Job Discrimination (Sex))",
      "42:2003" : "42:2003 (42:2003 Job Discrimination)",
      "42:2005" : "42:2005 (42:2005 Review of Agency Action-HHS)",
      "42:2615" : "42:2615 (42:2616 Medical Recovery Act)",
      "42:2651" : "42:2651 (42:2651 Medical Care Recovery)",
      "42:292" : "42:292 (42:292(f) Health Education & Assistance Loan Program)",
      "42:293f" : "42:293f (42:293f Defaulted Heal Loan)",
      "42:3601" : "42:3601 (42:3601 Fair Housing Act)",
      "42:4000" : "42:4000 (42:4000 National Flood Insurance Act)",
      "42:4001" : "42:4001 (42:4001 National Insurance Flood Act)",
      "42:4053" : "42:4053 (42:4053 Breach of Insurance Contract)",
      "42:4072" : "42:4072 (42:4072 Payment of Flood Insurance Claim)",
      "42:4321" : "42:4321 (42:4321 Review of Agency Action-Environment)",
      "42:4332" : "42:4332 (42:4332 National Environmental Policy Act)",
      "42:4332pr" : "42:4332pr (42:4332 Prisoner)",
      "42:6901en" : "42:6901en (42:6901 Environmental Cleanup Expenses)",
      "42:6901rs" : "42:6901rs (42:6901 Resource & Recovery Act)",
      "42:7413" : "42:7413 (42:7413 Clean Air Act)",
      "42:7604cl" : "42:7604cl (42:7604 Clear Air Act (Emission Standards))",
      "42:7604ir" : "42:7604ir (42:7604 Petition to Quash IRS Summons)",
      "42:9601ce" : "42:9601ce (42:9601 Notice of Removal - CERCLA)",
      "42:9601cr" : "42:9601cr (42:9601 CERCLA)",
      "42:9607" : "42:9607 (42:9607 Real Property Tort to Land)",
      "43:945" : "43:945 (43:945 Compensation for Land Condemnation)",
      "43:945a" : "43:945a (43:945a Complaint in Condemnation)",
      "43:946" : "43:946 (43:946 Complaint in Condemnation - Eminent Domain)",
      "45:0051" : "45:0051 (45:51 Railways: Fed. Employer's Liability Act)",
      "45:0151" : "45:0151 (45:151 Railway Labor Act)",
      "45:0184" : "45:0184 (45:184 Action to Set Aside Award of a System Board of Adjust)",
      "45:1395" : "45:1395 (45:1395 Railroads: Adverse Reimbursement Review)",
      "45:7457" : "45:7457 (45:7457 Compel Reclamation Under Clear Air Act)",
      "46:0688" : "46:0688 (46:0688 Jones Act)",
      "46:0741" : "46:0741 (46:741 Shipping)",
      "46:0761" : "46:0761 (46:761 Shipping: Damages for Death on High Seas)",
      "46:1101" : "46:1101 (46:1101 Violation of Maritime Regulations)",
      "46:1156" : "46:1156 (46:1156 Administrative Procedure Act)",
      "46:1701" : "46:1701 (46:1701 The Ocean Shipping Act of 1999)",
      "46:31301" : "46:31301 (46:31301 Ship Mortgage Act)",
      "47:0203" : "47:0203 (47:0203 Telecommunications Collection of Charges)",
      "47:0227" : "47:0227 (47:0227 FCC-Unsolicited Telephone Sales)",
      "47:0332" : "47:0332 (47:0332 Telecommuncations Act of 1996)",
      "47:0605" : "47:0605 (47:605 Violation of Federal Communications Act)",
      "47:201" : "47:201 (47:201 Enforcement of Communications Act of 1934)",
      "47:201bt" : "47:201bt (47:201 Breach of Tariff)",
      "47:227" : "47:227 (Telephone Consumer Protection Act)",
      "47:338" : "47:338 (47:338 Satellite Home Viewer Improvement Act)",
      "47:553" : "47:553 (47:553 Violation of the Communications Act of 1934)",
      "48:0883" : "48:0883 (48:883 Violation of US Coastal Law)",
      "48:1985" : "48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)",
      "49:0081" : "49:0081 (49:81 Damaged Goods While Being Transported)",
      "49:0327" : "49:0327 (49:0327 Federal Odometer Statute)",
      "49:0781" : "49:0781 (49:781 Forfeiture)",
      "49:11503" : "49:11503 (49:11503 Railroad Revitalization Regulatory Reform)",
      "49:11702" : "49:11702 (49:11702(a)(4) Violations of Interstate Commerce A)",
      "49:11706" : "49:11706 (49:11706 Carmack Amendent)",
      "49:13101" : "49:13101 (49:13101 Transportation Policy)",
      "49:1471" : "49:1471 (49:1471 Federal Aviation Act)",
      "49:1903" : "49:1903 (49:1903 Petition to enforce administrative summon)",
      "49:30502" : "49:30502 (49:30502 Natl Motor Vehicle Title Information Syst)",
      "49:49101" : "49:49101 (49:49101 Wrongful Termination in Contravention of Published Regulations)",
      "49:49104" : "49:49104 (49:49104 Breach of Lease by Metro. Wash. Airport Auth.)",
      "50:0501" : "50:0501 (50:0501 Soldiers and Sailors Civil Relief Act)",
      "8:1252" : "8:1252 (8:1252 Review of INS Decision)",
      "8:287" : "8:287 (8:287 Petition to Enforce INS Subpoena)",
      "99:9999" : "99:9999 (99:9999 Report cause code (DO NOT DELETE!))",
      "adsup" : "adsup (Administrative Subpoena)",
      "appiss" : "appiss (Application to issue subpoenas)",
      "apptro" : "apptro (Application for a TRO)",
      "contempt" : "contempt (Contempt Proceedings)",
      "disbar" : "disbar (Disbarment Proceedings)",
      "fcact" : "fcact (False Claims Act)",
      "fordepo" : "fordepo (Foreign Deposition)",
      "memsubp" : "memsubp (Motion to Enforce Subpoena)",
      "mensubp" : "mensubp (Motion to enforce Subpoena)",
      "misc" : "misc (Civil Miscellaneous Case)",
      "miscdm" : "miscdm (Misc for dm cases)",
      "moisletrog" : "moisletrog (Motion for Issuance of Letter Rogatory)",
      "motcomp" : "motcomp (Motion to Compel)",
      "motext" : "motext (Motion to extend time)",
      "motinj" : "motinj (Motion for Injunction)",
      "motinspect" : "motinspect (Motion to Inspect)",
      "motlv" : "motlv (Petition/Motion for Leave to File)",
      "motprod" : "motprod (Motion for production of documents)",
      "motproto" : "motproto (Motion for Protective Order)",
      "motquash" : "motquash (Motion to Quash)",
      "motrem" : "motrem (Motion to Remand)",
      "motret" : "motret (Motion for Return of Property)",
      "motseal" : "motseal (Motion to Seal)",
      "motstay" : "motstay (Motion to Stay)",
      "mottran" : "mottran (Motion to transfer)",
      "motvacarb" : "motvacarb (Motion to vacate an arbitration award)",
      "mrem" : "mrem (Motion to Remand)",
      "no" : "no (No caused code entered)",
      "objsub" : "objsub (Objections to Subpoena Issued)",
      "petenf" : "petenf (Petition to Enforce IRS Summons)",
      "petper" : "petper (Petition to Perpetuate Testimony)",
      "regjgm" : "regjgm (Registration of Foreign Judgment)",
      "tranbkref" : "tranbkref (Transmission of Bankruptcy Reference)",
      "tranff" : "tranff (Transmission of Proposed Findings of Fact and Concl. of Law)",
      "writgar" : "writgar (Application for a Writ of Garnishment)"
   },
   "vawdce" : {
      "0" : "0 (No cause code entered)",
      "02:0431" : "02:0431 (02:431 Fed. Election Commission: Failure Enforce Compliance)",
      "02:0437" : "02:0437 (02:437 Federal Election Commission)",
      "05:0075" : "05:0075 (05:75(2) Contract - Reduction in Grade)",
      "05:0551" : "05:0551 (05:551 Administrative Procedure Act)",
      "05:0552fi" : "05:0552fi (05:552 Freedom of Information Act)",
      "05:0552pa" : "05:0552pa (05:552 Right to Privacy Act)",
      "05:0554" : "05:0554 (05:0554 Constitutionality of Maritime Statutes)",
      "05:0701" : "05:0701 (05:0701 Maritime Subsidy Board)",
      "05:0702" : "05:0702 (05:702 Administrative Procedure Act)",
      "05:0704" : "05:0704 (05:704 Labor Litigation)",
      "05:7703" : "05:7703 (05:7703 Discrimination - Review of Agency Act)",
      "05:8470" : "05:8470 (05:8470 Enforcement of Judgment against Retirement Benefits)",
      "07:0006" : "07:0006 (7:6(b) Federal Commodity Exchange Regulation)",
      "07:0025" : "07:0025 (7:25 Fraud - Commodities Leverage Contracts)",
      "07:0181" : "07:0181 (07:181 Packers & Stockyard Act)",
      "07:0499" : "07:0499 (07:499 Agricultural Commodities Act)",
      "07:0601" : "07:0601 (07:601 USDA Condemnation)",
      "07:2023" : "07:2023 (07:2023 SNAP Administrative and Judicial Review)",
      "07:2321" : "07:2321 (07:2321 Plant Variety Protection Act)",
      "08:1105" : "08:1105 (8:1105(a) Aliens: Habeas Corpus to Release INS Det)",
      "08:1182" : "08:1182 (8:1182 Defend. Denial of Pla. Appl. for Alien Employment Cer)",
      "08:1252" : "08:1252 (08:1252(a)(2) Injunction for Deportation)",
      "08:1260" : "08:1260 (08:1260 Aliens: Access to Records)",
      "08:1324" : "08:1324 (08:1324 Aliens: Complaint for Forfeiture)",
      "08:1329" : "08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petiti)",
      "08:1421(c)" : "08:1421(c) (08:1421(c) Petition for Review of Denial of Naturalization Application)",
      "08:1446" : "08:1446 (8:1446 Petition for Naturalization Hearing)",
      "08:1451(j)" : "08:1451(j) (8:1451(j) Motion to Correct Order & Judg. of Naturalization)",
      "09:0001" : "09:0001 (09:1 U.S. Arbitration Act)",
      "09:0009" : "09:0009 (9:9 Motion to Confirm Arbitration Loan)",
      "09:0010" : "09:0010 (09:0010 Petition to Vacate Arbitration Award)",
      "10:1408" : "10:1408 (10:1408 Claim for Military Retirement)",
      "10:1552" : "10:1552 (10:1552 Armed Forces: Action to Correct Records)",
      "10:1553" : "10:1553 (10:1553 Armed Forces: FOIA General)",
      "10:2305" : "10:2305 (10:2305 Review of Federal Contract)",
      "11:0101" : "11:0101 (11:101 Bankruptcy)",
      "12:0022" : "12:0022 (12:22 Securities Fraud)",
      "12:0635" : "12:0635 (12:635 Breach of Insurance Contract)",
      "12:1461" : "12:1461 (12:1461 Homeowners Loan Act)",
      "12:1464" : "12:1464 (12:1464 Federal Savings and Loan)",
      "12:1703" : "12:1703 (12:1703 Default of HUD Loan)",
      "12:1725" : "12:1725 (12:1725 Collection under Contract Guaranty)",
      "12:1730" : "12:1730 (12:1730 Collection Under Contract Guaranty)",
      "12:1819" : "12:1819 (12:1819 Default of Promissory Note)",
      "12:1821" : "12:1821 (12:1821 Default of Loan by Promissary Note)",
      "12:191" : "12:191 (12:191 Bank Foreclosure)",
      "12:192" : "12:192 (12:192 Liquidation of National Bank)",
      "12:1971" : "12:1971 (12:1971 Relief under Bank Holding Act)",
      "12:1972" : "12:1972 (12:1972 Typing Arrangement Act)",
      "12:3410" : "12:3410 (12:3410 Right to Financial Privacy Act)",
      "15:0001" : "15:0001 (15:1 Antitrust Litigation)",
      "15:0002at" : "15:0002at (15:2 Antitrust Litigation)",
      "15:0002fl" : "15:0002fl (15:2(a) Fair Labor Standards Act)",
      "15:0005" : "15:0005 (15:5(a) Fair Labor Standards Act)",
      "15:0015" : "15:0015 (15:15 Antitrust Litigation)",
      "15:0025" : "15:0025 (15:25 Clayton Act)",
      "15:0044" : "15:0044 (15:44 Trademark Infringement)",
      "15:0045" : "15:0045 (15:0045 Federal Trade Commission Act)",
      "15:0052" : "15:0052 (15:0052 Federal Trade Commission Act)",
      "15:0053" : "15:0053 (15:0053 Federal Trade Commission Act)",
      "15:0077" : "15:0077 (15:77 Securities Fraud)",
      "15:0078" : "15:0078 (15:78m(a) Securities Exchange Act)",
      "15:0631" : "15:0631 (15:631 Small Business Act)",
      "15:0717" : "15:0717 (15:717 Natural Gas Act)",
      "15:0754" : "15:0754 (15:754 Emergency Petroleum Allocation-Admin.& Enforcement)",
      "15:1051" : "15:1051 (15:1051 Trademark Infringement)",
      "15:1114" : "15:1114 (15:1114 Trademark Infringement)",
      "15:1121" : "15:1121 (15:1121 Trademark Infringement)",
      "15:1125" : "15:1125 (15:1125 Trademark Infringement (Lanham Act))",
      "15:1125(d)" : "15:1125(d) (15:1125(d) Anticybersquatting Consumer Protection Act)",
      "15:1126" : "15:1126 (15:1126 Patent Infringement)",
      "15:1127" : "15:1127 (15:1127 Trademark Infringement)",
      "15:1601" : "15:1601 (15:1601 Truth in Lending)",
      "15:1640" : "15:1640 (15:1640 Truth in Lending)",
      "15:1681" : "15:1681 (15:1681 Fair Credit Reporting Act)",
      "15:1692" : "15:1692 (15:1692 Fair Debt Collection Act)",
      "15:1693" : "15:1693 (15:1693 Electronic Fund Transfers)",
      "15:1938" : "15:1938 (15:1938 Fair Labor Standards Act)",
      "15:1981" : "15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))",
      "15:1988" : "15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))",
      "15:1989" : "15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))",
      "15:2301" : "15:2301 (15:2301 Magnuson-Moss Warranty Act)",
      "15:2801" : "15:2801 (15:2801 Petroleum Marketing Practices Act)",
      "15:53(b)" : "15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equita)",
      "16:0668" : "16:0668 (16:668 Bald Eagle Protection Act)",
      "16:0703" : "16:0703 (16:703 Migratory Bird Act)",
      "16:1538" : "16:1538 (16:1538 Endangered Species Act)",
      "16:19jj" : "16:19jj (16:19jj Park System Resource Protection Act)",
      "16:3371" : "16:3371 (16:3371 Wildlife Under the Lacey Act)",
      "16:3372" : "16:3372 (16:3372 Conservation: Complaint for Forfeiture)",
      "16:3373" : "16:3373 (16:3373 Appeal of Decision - DOI)",
      "16:3374" : "16:3374 (16:3374 Conservation: Complaint for Forfeiture)",
      "17:0101" : "17:0101 (17:101 Copyright Infringement)",
      "17:0501" : "17:0501 (17:501 Copyright Infringement)",
      "17:0504" : "17:0504 (17:504 Copyright Infringement)",
      "18:0241" : "18:0241 (18:241 Conspiracy Against Citizen Rights)",
      "18:0981" : "18:0981 (18:981 - Civil Forfeiture)",
      "18:1345" : "18:1345 (18:1345 Injunctions Against Fraud)",
      "18:1836a" : "18:1836a (18:1836(a) - Injunction against Misappropriation of Trade Secrets)",
      "18:1836b" : "18:1836b (18:1836(b) - Civil Action to Protect Trade Secrets)",
      "18:1961" : "18:1961 (18:1961 Racketeering (RICO) Act)",
      "18:1962" : "18:1962 (18:1962 Racketeering (RICO) Act)",
      "18:1964" : "18:1964 (18:1964 Racketeering (RICO) Act)",
      "18:2511" : "18:2511 (18:2511 Wiretapping)",
      "18:3114" : "18:3114 (18:3114 Motion for Return of Seized Property)",
      "18:4208" : "18:4208 (18:4208(B) Agency Action Review)",
      "19:1305" : "19:1305 (19:1305 Custom Duties:0Forfeiture-Immoral Articles)",
      "20:1080" : "20:1080 (20:1080 Student Loan Recovery)",
      "20:1400" : "20:1400 (20:1400 Civil Rights of Handicapped Child)",
      "20:1401" : "20:1401 (20:1401 Education: Handicapped Child Act)",
      "20:1681" : "20:1681 (20:1681 - Title IX of the Education Amendment of 1972)",
      "21:0841" : "21:0841 (21:841 Forfeiture Property-Drugs)",
      "21:0881" : "21:0881 (21:881 Forfeiture Property-Drugs)",
      "21:0881a" : "21:0881a (21:881 Forfeiture Property - Aircraft)",
      "21:0881re" : "21:0881re (21:881 Forfeiture Property - Real Estate)",
      "21:301" : "21:301 (21:301 FOOD & DRUG ACT - FORFEITURE)",
      "22:9001" : "22:9001 (22:9001 et seq. (ICARA) International Child Abduction Remedies Act)",
      "23:0134" : "23:0134 (23:134 P.I.- Auto Negligence)",
      "23:1441" : "23:1441 (23:1441 Contract Real Estate)",
      "24:1000" : "24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)",
      "25:0640" : "25:0640 (25:640 Indian Tribal Rights)",
      "25:1901" : "25:1901 (25:1901 Indian Child Welfare Act)",
      "26:5891" : "26:5891 (26:5891 Structured Settlement)",
      "26:6212" : "26:6212 (26:6212 Injunctive Relief from IRS Lien)",
      "26:6213" : "26:6213 (26:6213 Injunctive Relief from IRS Lien)",
      "26:6502" : "26:6502 (26:6502 IRS:Enforcement of tax liens)",
      "26:6532" : "26:6532 (26:6532 IRS: Refund of Tax Penalty)",
      "26:6702" : "26:6702 (26:6702 IRS: Refund of Income Tax Penalty)",
      "26:6703" : "26:6703 (26:6703 IRS: Refund of Tax Penalty)",
      "26:7401" : "26:7401 (26:7401 IRS: Tax Liability)",
      "26:7402" : "26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)",
      "26:7403" : "26:7403 (26:7403 Suit to Enforce Federal Tax Lien)",
      "26:7408" : "26:7408 (26:7408 Actions to Enjoin Specified Conduct Related to Tax Shelters and Reportable Transactions)",
      "26:7422rt" : "26:7422rt (26:7422 IRS: Refund Taxes)",
      "26:7422rx" : "26:7422rx (26:7422 IRS: Refund Excise Tax)",
      "26:7426" : "26:7426 (26:7426 IRS: Wrongful Levy for Taxes)",
      "26:7429" : "26:7429 (26:7429 IRS: Tax Jeopardy Assessment)",
      "26:7609" : "26:7609 (26:7609 IRS: Petition to Quash IRS Summons)",
      "27:0185" : "27:0185 (27:185 Enforcement of Arbitration Award)",
      "28:0157c" : "28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)",
      "28:0157d" : "28:0157d (28:0157 Motion for Withdrawal of Reference)",
      "28:0158" : "28:0158 (28:0158 Notice of Appeal re Bankruptcy Matter (BA)",
      "28:0185" : "28:0185 (28:185 Suit to Compel Arbitration)",
      "28:0451" : "28:0451 (28:451 Employment Discrimination)",
      "28:0754" : "28:0754 (28:754 Receiver of Property in Different Districts)",
      "28:0794" : "28:0794 (28:794 Rehabilitation Act)",
      "28:1001" : "28:1001 (28:1001 E.R.I.S.A.)",
      "28:1132" : "28:1132 (28:1132 E.R.I.S.A.)",
      "28:1330" : "28:1330 (28:1330 Breach of Contract)",
      "28:1331" : "28:1331 (28:1331 Fed. Question)",
      "28:1331al" : "28:1331al (28:1331 Fed. Question: Airline Crash)",
      "28:1331at" : "28:1331at (28:1331 Fed. Question: Anti-trust)",
      "28:1331au" : "28:1331au (28:1331 Fed. Question: Auto Negligence)",
      "28:1331b" : "28:1331b (28:1331 Federal Question: Bivens Act)",
      "28:1331bc" : "28:1331bc (28:1331 Fed. Question: Breach of Contract)",
      "28:1331ca" : "28:1331ca (28:1331 Fed Question: Fed Communications Act of 1)",
      "28:1331cm" : "28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)",
      "28:1331cv" : "28:1331cv (28:1331 Federal Question: Other Civil Rights)",
      "28:1331ed" : "28:1331ed (28:1331 Fed. Question: Employment Discrimination)",
      "28:1331ej" : "28:1331ej (28:1331 Federal Question: Enforcement of Judgment)",
      "28:1331es" : "28:1331es (28:1331 Enforcement of Administrative Subpoena)",
      "28:1331fl" : "28:1331fl (28:1331 Fed. Question: Fair Labor Standards)",
      "28:1331in" : "28:1331in (28:1331 Fed. Question: Insurance Contract)",
      "28:1331mm" : "28:1331mm (28:1331 Fed. Question: Medical Malpractice)",
      "28:1331ng" : "28:1331ng (28:1331 Fed. Question: Natural Gas Act)",
      "28:1331pi" : "28:1331pi (28:1331 Fed. Question: Personal Injury)",
      "28:1331rd" : "28:1331rd (28:1331 Fed. Question: Review Agency Decision)",
      "28:1331rp" : "28:1331rp (28:1331(a) Fed. Question: Real Property)",
      "28:1331rr" : "28:1331rr (28:1331 Fed. Question: Railway Labor Act)",
      "28:1331sv" : "28:1331sv (28:1331 Fed. Question: Securities Violation)",
      "28:1331tr" : "28:1331tr (28:1331 Fed. Question: Trademark)",
      "28:1331tt" : "28:1331tt (28:1331 Fed. Question: Tort Action)",
      "28:1331v" : "28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendme)",
      "28:1331wl" : "28:1331wl (28:1331 Federal Question: EPA Waste Lien)",
      "28:1331wt" : "28:1331wt (28:1331 Fed. Question: Water Rights)",
      "28:1332ac" : "28:1332ac (28:1332 Diversity-Account Receivable)",
      "28:1332al" : "28:1332al (28:1332 Diversity-Airline Crash)",
      "28:1332as" : "28:1332as (28:1332 Diversity-Asbestos Litigation)",
      "28:1332au" : "28:1332au (28:1332 Diversity-Auto Negligence)",
      "28:1332bc" : "28:1332bc (28:1332 Diversity-Breach of Contract)",
      "28:1332co" : "28:1332co (28:1332 Diversity-Conversion)",
      "28:1332ct" : "28:1332ct (28:1332 Diversity-(Citizenship))",
      "28:1332det" : "28:1332det (28:1332 Diversity: Forcible Detainer)",
      "28:1332df" : "28:1332df (28:1332 Diversity-Contract Default)",
      "28:1332ds" : "28:1332ds (28:1332 Diversity-Contract Dispute)",
      "28:1332ed" : "28:1332ed (28:1332 Diversity-Employment Discrimination)",
      "28:1332fd" : "28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)",
      "28:1332fr" : "28:1332fr (28:1332 Diversity-Fraud)",
      "28:1332ia" : "28:1332ia (28:1332 Diversity-Interpleader Action)",
      "28:1332ij" : "28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)",
      "28:1332in" : "28:1332in (28:1332 Diversity-Insurance Contract)",
      "28:1332jd" : "28:1332jd (28:1332 Diversity-Declaratory Judgement)",
      "28:1332lb" : "28:1332lb (28:1332 Diversity-Libel,Assault,Slander)",
      "28:1332lm" : "28:1332lm (28:1332 Diversity - Legal Malpractice)",
      "28:1332ma" : "28:1332ma (28:1332 Diversity-Miller Act)",
      "28:1332mm" : "28:1332mm (28:1332 Diversity-Medical Malpractice)",
      "28:1332mv" : "28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)",
      "28:1332ni" : "28:1332ni (28:1332 Diversity-Negotiable Instrument)",
      "28:1332nm" : "28:1332nm (28:1332 Diversity-Non-Motor Vehicle)",
      "28:1332nr" : "28:1332nr (28:1332 Diversity-Notice of Removal)",
      "28:1332oc" : "28:1332oc (28:1332 Diversity-Other Contract)",
      "28:1332pd" : "28:1332pd (28:1332 Diversity-Property Damage)",
      "28:1332pi" : "28:1332pi (28:1332 Diversity-Personal Injury)",
      "28:1332pl" : "28:1332pl (28:1332 Diversity-Product Liability)",
      "28:1332pr" : "28:1332pr (28:1332 Diversity-Petition for Removal)",
      "28:1332qt" : "28:1332qt (28:1332 Diversity-Petition to Quiet Title)",
      "28:1332ri" : "28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)",
      "28:1332sa" : "28:1332sa (28:1332 - Diversity: Securities & Exchange Commiss)",
      "28:1332sf" : "28:1332sf (28:1332 - Diversity: Securities Fraud)",
      "28:1332ss" : "28:1332ss (28:1332 Diversity - Stockholders Suits)",
      "28:1332tl" : "28:1332tl (28:1332 Diversity-Torts to Land)",
      "28:1332tm" : "28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))",
      "28:1332tn" : "28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)",
      "28:1332wd" : "28:1332wd (28:1332 Diversity-Wrongful Death)",
      "28:1333" : "28:1333 (28:1333 Admiralty)",
      "28:1334" : "28:1334 (28:1334 Bankruptcy Appeal)",
      "28:1334c" : "28:1334c (28:1334(c) R&R re motions for abstention (non-cor)",
      "28:1335" : "28:1335 (28:1335 Interpleader Action)",
      "28:1337" : "28:1337 (28:1337 Sherman-Clayton Act)",
      "28:1338cp" : "28:1338cp (28:1338 Copyright Infringement)",
      "28:1338pt" : "28:1338pt (28:1338 Patent Infringement)",
      "28:1338tr" : "28:1338tr (28:1338 Trademark Infringement)",
      "28:1340" : "28:1340 (28:1340 IRS: Custom Duties)",
      "28:1340er" : "28:1340er (28:1340 Recovery of Erroneous Refund)",
      "28:1341" : "28:1341 (28:1341 Complaint for Forfeiture)",
      "28:1343" : "28:1343 (28:1343 Violation of Civil Rights)",
      "28:1345" : "28:1345 (28:1345 USA Plaintiff)",
      "28:1345co" : "28:1345co (28:1345 Replevin & Conversion)",
      "28:1345db" : "28:1345db (28:1345 Debt to US - FHA/HUD Title I)",
      "28:1345df" : "28:1345df (28:1345 Default of Promissory Note)",
      "28:1345er" : "28:1345er (28:1345 Recovery of Erroneous Refund)",
      "28:1345fc" : "28:1345fc (28:1345 Foreclosure)",
      "28:1345ff" : "28:1345ff (28:1345 Complaint for Forfeiture)",
      "28:1345hl" : "28:1345hl (28:1345 VA Home Loan Guaranty Debt)",
      "28:1345mc" : "28:1345mc (28:1345 Medical Care Recovery)",
      "28:1345mi" : "28:1345mi (28:1345 Mining Claim Ejectment)",
      "28:1345pd" : "28:1345pd (28:1345 Property Damage)",
      "28:1345pe" : "28:1345pe (28:1345 Property Ejectment)",
      "28:1345rc" : "28:1345rc (28:1345 Recovery of Debt to US)",
      "28:1345st" : "28:1345st (28:1345 Default of Student Loan)",
      "28:1345tp" : "28:1345tp (28:1345 Trespass on Public Land)",
      "28:1345va" : "28:1345va (28:1345 Recovery of VA Overpayment)",
      "28:1346bc" : "28:1346bc (28:1346 Breach of Contract)",
      "28:1346rc" : "28:1346rc (28:1346 Recovery of IRS Tax)",
      "28:1346tc" : "28:1346tc (28:1346 Tort Claim)",
      "28:1346wd" : "28:1346wd (28:1346 Wrongful Death)",
      "28:1349" : "28:1349 (28:1348 Corporation organized under Federal Law as party)",
      "28:1352" : "28:1352 (28:1352 Miller Act)",
      "28:1355" : "28:1355 (28:1355 Petition for Return of Property)",
      "28:1358" : "28:1358 (28:1358 Land Condemnation)",
      "28:1361" : "28:1361 (28:1361 Petition for Writ of Mandamus)",
      "28:1362ic" : "28:1362ic (28:1362 Indian Tribal Controversy)",
      "28:1362iw" : "28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)",
      "28:1364" : "28:1364 (28:1364 Auto Negligence)",
      "28:1391" : "28:1391 (28:1391 Personal Injury)",
      "28:1402" : "28:1402 (28:1402 Medical Malpractice)",
      "28:1407" : "28:1407 (28:1407 Airline Crash)",
      "28:1441ac" : "28:1441ac (28:1441 Petition for Removal- Account Receivable)",
      "28:1441al" : "28:1441al (28:1441 Petition for Removal- Airline Crash)",
      "28:1441as" : "28:1441as (28:1441 Petition for Removal- Asbestos Litigation)",
      "28:1441au" : "28:1441au (28:1441 Petition for Removal- Auto Negligence)",
      "28:1441bc" : "28:1441bc (28:1441 Petition for Removal- Breach of Contract)",
      "28:1441cv" : "28:1441cv (28:1441 Petition for Removal- Civil Rights Act)",
      "28:1441df" : "28:1441df (28:1441 Petition for Removal- Contract Default)",
      "28:1441dj" : "28:1441dj (28:1441 Petition for Removal- Declaratory Judgemen)",
      "28:1441ds" : "28:1441ds (28:1441 Petition for Removal- Contract Dispute)",
      "28:1441ed" : "28:1441ed (28:1441 Petition for Removal - Employment Discrim)",
      "28:1441fc" : "28:1441fc (28:1441 Petition for Removal - Fair Credit Reporti)",
      "28:1441fr" : "28:1441fr (28:1441 Petition for Removal- Fraud)",
      "28:1441ij" : "28:1441ij (28:1441 Petition for Removal- Injunctive/Declarato)",
      "28:1441in" : "28:1441in (28:1441 Petition for Removal- Insurance Contract)",
      "28:1441int" : "28:1441int (28:1441 Petition for Removal- Action for Interplea)",
      "28:1441lb" : "28:1441lb (28:1441 Petition for Removal Libel,Assault,Slander)",
      "28:1441lm" : "28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relatio)",
      "28:1441mm" : "28:1441mm (28:1441 Petition for Removal- Medical Malpractice)",
      "28:1441ni" : "28:1441ni (28:1441 Petition for Removal- Negotiable Instrumen)",
      "28:1441nm" : "28:1441nm (28:1441 Petition for Removal- Non-Motor Vehicle)",
      "28:1441nr" : "28:1441nr (28:1441 Notice of Removal)",
      "28:1441oc" : "28:1441oc (28:1441 Petition For Removal--Other Contract)",
      "28:1441pd" : "28:1441pd (28:1441 Petition for Removal- Property Damage)",
      "28:1441pi" : "28:1441pi (28:1441 Petition for Removal- Personal Injury)",
      "28:1441pl" : "28:1441pl (28:1441 Petition for Removal- Product Liability)",
      "28:1441pr" : "28:1441pr (28:1441 Petition for Removal)",
      "28:1441qt" : "28:1441qt (28:1441 Petition for Removal- Petition to Quiet Ti)",
      "28:1441ri" : "28:1441ri (28:1441 Petition for Removal- Racketeering (RICO))",
      "28:1441sa" : "28:1441sa (28:1441 - Petition for Removal: SEC Act)",
      "28:1441sf" : "28:1441sf (28:1441 - Petition for Removal: Securities Fraud)",
      "28:1441tl" : "28:1441tl (28:1441 Petition for Removal- Torts to Land)",
      "28:1441tm" : "28:1441tm (28:1441 Petition for Removal- Tort/Motor Vehicle ()",
      "28:1441tn" : "28:1441tn (28:1441 Petition for Removal- Tort/Non-Motor Vehic)",
      "28:1441wd" : "28:1441wd (28:1441 Petition for Removal- Wrongful Death)",
      "28:1442bc" : "28:1442bc (28:1442 Petition for Removal- Breach of Contract)",
      "28:1442nr" : "28:1442nr (28:1442 Notice of Removal)",
      "28:1442pr" : "28:1442pr (28:1442 Petition for Removal)",
      "28:1443" : "28:1443 (28:1443(1) Rent, Lease & Ejectment)",
      "28:1444" : "28:1444 (28:1444 Petition for Removal- Foreclosure)",
      "28:1446in" : "28:1446in (28:1446 Breach of Contract- Insurance)",
      "28:1446nr" : "28:1446nr (28:1446 Notice of Removal)",
      "28:1446pd" : "28:1446pd (28:1446 Petition for Removal- Property Damage (P.I)",
      "28:1446pi" : "28:1446pi (28:1446 Petition for Removal- Personal Injury)",
      "28:1446pl" : "28:1446pl (28:1446pl Petition for Removal - Product Liability)",
      "28:1446pr" : "28:1446pr (28:1446 Petition for Removal)",
      "28:1452" : "28:1452 (28:1452 R&R re motions to remand (non-core))",
      "28:1651" : "28:1651 (28:1651 Petition for Writ of Coram Nobis)",
      "28:1651hc" : "28:1651hc (28:1651 Petition for Writ of Habeas Corpus)",
      "28:1651mn" : "28:1651mn (28:1651 Petition for Writ of Mandamus)",
      "28:1782" : "28:1782 (28:1782 Letter rogatory - appointment)",
      "28:1983" : "28:1983 (28:1983 Civil Rights)",
      "28:2201" : "28:2201 (28:2201 Constitutionality of State Statute(s))",
      "28:2201dj" : "28:2201dj (28:2201 Declaratory Judgement)",
      "28:2201ij" : "28:2201ij (28:2201 Injunction)",
      "28:2201in" : "28:2201in (28:2201 Declaratory Judgement (Insurance))",
      "28:2241" : "28:2241 (28:2241 Petition for Writ of Habeas Corpus (federa)",
      "28:2254" : "28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))",
      "28:2254se" : "28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)",
      "28:2255" : "28:2255 (28:2255 Motion to Vacate / Correct Illegal Sentenc)",
      "28:2271" : "28:2271 (28:2271 Federal Tort Claims Act)",
      "28:2345" : "28:2345 (28:2345 Medicare Recovery)",
      "28:2409" : "28:2409 (28:2409(a) Quiet Title Action)",
      "28:2410" : "28:2410 (28:2410 Quiet Title)",
      "28:2671" : "28:2671 (28:2671 Federal Tort Claims Act)",
      "28:2674" : "28:2674 (28:2674 Federal Tort Claims Act)",
      "28:3001" : "28:3001 (28:3001 Federal Debt Collection Act)",
      "28:7402" : "28:7402 (28:7402 Refund of Taxes)",
      "28:7422" : "28:7422 (28:7422 Appeal from Administrative Decision)",
      "29:0151" : "29:0151 (29:151 Labor: Review of Agency Action)",
      "29:0160" : "29:0160 (29:160(1) National Labor Relations Act)",
      "29:0184" : "29:0184 (29:184 Violation Collection Bargain Agreement)",
      "29:0185ep" : "29:0185ep (29:185 Employee Pension Plan)",
      "29:0185lm" : "29:0185lm (29:185 Labor/Mgt. Relations (Contracts))",
      "29:0201do" : "29:0201do (29:201 Denial of Overtime Compensation)",
      "29:0201fl" : "29:0201fl (29:201 Fair Labor Standards Act)",
      "29:0203" : "29:0203 (29:203 Equal Pay Act)",
      "29:0206" : "29:0206 (29:206 Collect Unpaid Wages)",
      "29:0401" : "29:0401 (29:0401 Labor Management Disclosure Act)",
      "29:0621" : "29:0621 (29:621 Job Discrimination (Age))",
      "29:0623" : "29:0623 (29:623 Job Discrimination (Age))",
      "29:0626" : "29:0626 (29:626 Job Discrimination (Age))",
      "29:0633" : "29:0633 (29:633 Job Discrimination (Age))",
      "29:0651" : "29:0651 (29:651 Occupational Safety/Health)",
      "29:0754" : "29:0754 (29:754 Discrimination)",
      "29:0791" : "29:0791 (29:791 Job Discrimination (Rehabilitation Act))",
      "29:0794" : "29:0794 (29:0794 Job Discrimination (Handicap))",
      "29:1001" : "29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)",
      "29:1002" : "29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)",
      "29:1104" : "29:1104 (29:1104 Recovery of Benefits to Employee)",
      "29:1109" : "29:1109 (29:1109 Breach of Fiduciary Duties)",
      "29:1131" : "29:1131 (29:1131 ERISA - Collection of Delinquent Trust Fun)",
      "29:1132" : "29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)",
      "29:1145" : "29:1145 (29:1145 E.R.I.S.A.)",
      "29:1149" : "29:1149 (29:1149 Recover Pension & Profit Sharing)",
      "29:1337" : "29:1337 (29:1337 E.R.I.S.A.)",
      "29:1362" : "29:1362 (29:1362 ERISA)",
      "29:1381" : "29:1381 (29:1381 E.R.I.S.A.)",
      "29:1401" : "29:1401 (29:1401(b)(2) Appeal of Arbitration Award)",
      "29:1451" : "29:1451 (29:1451 E.R.I.S.A.)",
      "29:1801" : "29:1801 (29:1801 Farmworker Rights)",
      "29:2104" : "29:2104 (29:2104 Warn Act)",
      "29:2601" : "29:2601 (29:2601 Family and Medical Leave Act (FMLA))",
      "29:2615" : "29:2615 (29:2615 Family and Medical Leave Act of 1993 (FMLA))",
      "29:790" : "29:790 (29:790 Rehabilitation of Labor)",
      "30:0181" : "30:0181 (30:181 Environment: Review of Agency Action)",
      "30:0801" : "30:0801 (30:0801 Penalities/Federal Mine Safety Health Act)",
      "30:1201" : "30:1201 (30:1201 Environment: Review of Agency Action)",
      "30:1202" : "30:1202 (30:1202 Mining Reclamation Act)",
      "30:1276" : "30:1276 (30:1276 Interior: Review of Agency Action)",
      "31:3545" : "31:3545 (31:3545 Action to Recovery Money)",
      "31:3729" : "31:3729 (31:3729 False Claims Act)",
      "31:3730" : "31:3730 (31:3730 Qui Tam False Claims Act)",
      "31:3731" : "31:3731 (31:3731 Fraud)",
      "31:5314" : "31:5314 (31:5314 Records and Reports on Foreign Financial Agency Transactions)",
      "33:1319cw" : "33:1319cw (33:1319 Clean Water Act)",
      "33:1319pv" : "33:1319pv (33:1319 Pollutants & Permit Violations)",
      "33:1365" : "33:1365 (33:1365 Environmental Matters)",
      "35:0145" : "35:0145 (35:145 Patent Infringement)",
      "35:0183" : "35:0183 (35:183 Patent Infringement)",
      "35:0271" : "35:0271 (35:271 Patent Infringement)",
      "38:1681" : "38:1681 (38:1681 Recovery of VA Overpayment)",
      "38:1686" : "38:1686 (38:1686 Recovery of VA Overpayment)",
      "38:1780" : "38:1780 (38:1780 Recovery of VA Overpayment)",
      "38:2011" : "38:2011 (38:2011 - Veteran's Readjustment Assistance Act of)",
      "38:2021" : "38:2021 (Right to re-employment of inducted persons)",
      "38:3116" : "38:3116 (38:3116 VA Overpayment)",
      "38:4301" : "38:4301 (38:4301 Uniformed Services Employment & Re-employment Rights Act - USERRA)",
      "38:775" : "38:775 (Recovery of Servicemen's Group Life Insurance)",
      "39:3005" : "39:3005 (39:3005 Detention of Mail for Temporary Periods)",
      "39:409" : "39:409 (39:409 Postal Service)",
      "40:0258" : "40:0258 (40:258(a) Public Buildings & Property: Land Condem)",
      "40:0270" : "40:0270 (40:270 Miller Act)",
      "40:0875" : "40:0875 (40:875 Public Buildings & Property: Negligence)",
      "40:3133" : "40:3133 (40:3133 Miller Act)",
      "41:0251" : "41:0251 (41:251 Public Contracts-Review of Agency Action)",
      "41:1463" : "41:1463 (41:1463 Public Contracts: Unlawful Employment Prac)",
      "42:0205" : "42:0205 (42:205 Denial Social Security Benefits)",
      "42:0206" : "42:0206 (42:206 Social Security Benefits)",
      "42:0247" : "42:0247 (42:247 Personal Injury-Swine Flu)",
      "42:0402" : "42:0402 (42:402 Social Security Benefits)",
      "42:0405id" : "42:0405id (42:405 Review of HHS Decision (SSID))",
      "42:0405wc" : "42:0405wc (42:405 Review of HHS Decision (DIWC))",
      "42:0405ww" : "42:0405ww (42:405 Review of HHS Decision (DIWW))",
      "42:0416" : "42:0416 (42:416 Denial of Social Security Benefits)",
      "42:0427" : "42:0427 (42:427 Social Security Benefits)",
      "42:12101" : "42:12101 (42:12101 Americans With Disabilities Act of 1990 (ADA))",
      "42:1383" : "42:1383 (42:1383 Review of HHS Decision)",
      "42:1395" : "42:1395 (42:1395 HHS: Adverse Reimbursement Review)",
      "42:1396" : "42:1396 (42:1396 - Tort Negligence)",
      "42:1471" : "42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclo)",
      "42:1485" : "42:1485 (42:1485 Loan Default (Title V of Housing Act of 1949))",
      "42:1935dd" : "42:1935dd (42:1395dd Examination & Treatment for Emer Med Conds & Women in Labor)",
      "42:1981cv" : "42:1981cv (42:1981 Civil Rights)",
      "42:1981hs" : "42:1981hs (42:1981 Housing Discrimination)",
      "42:1981jb" : "42:1981jb (42:1981 Job Discrimination (Race))",
      "42:1981sx" : "42:1981sx (42:1981 Sex Discrimination)",
      "42:1983cv" : "42:1983cv (42:1983 Civil Rights Act)",
      "42:1983ed" : "42:1983ed (42:1983 Civil Rights (Employment Discrimination))",
      "42:1983pr" : "42:1983pr (42:1983 Prisoner Civil Rights)",
      "42:1986" : "42:1986 (42:1986 Neglect of Duty)",
      "42:2000ag" : "42:2000ag (42:2000 Job Discrimination (Age))",
      "42:2000bb" : "42:2000bb (42:2000bb-1 Free exercise of religion protected)",
      "42:2000e" : "42:2000e (42:2000e Job Discrimination (Employment))",
      "42:2000pb" : "42:2000pb (42:2000 Job Discrimination (Public Accomodations))",
      "42:2000ra" : "42:2000ra (42:2000 Job Discrimination (Race))",
      "42:2000sx" : "42:2000sx (42:2000 Job Discrimination (Sex))",
      "42:2003" : "42:2003 (42:2003 Job Discrimination)",
      "42:2005" : "42:2005 (42:2005 Review of Agency Action-HHS)",
      "42:2615" : "42:2615 (42:2616 Medical Recovery Act)",
      "42:2651" : "42:2651 (42:2651 Medical Care Recovery)",
      "42:3601" : "42:3601 (42:405 Fair Housing Act)",
      "42:4000" : "42:4000 (42:4000 National Flood Insurance Act)",
      "42:4001" : "42:4001 (42:4001 National Insurance Flood Act)",
      "42:4053" : "42:4053 (42:4053 Breach of Insurance Contract)",
      "42:4072" : "42:4072 (42:4072 Payment of Flood Insurance Claim)",
      "42:4321" : "42:4321 (42:4321 Review of Agency Action-Environment)",
      "42:4332" : "42:4332 (42:4332 Environmental Policy - Coop of Agency Repo)",
      "42:6901en" : "42:6901en (42:6901 Environmental Cleanup Expenses)",
      "42:6901rs" : "42:6901rs (42:6901 Resource & Recovery Act)",
      "42:7413" : "42:7413 (42:7413(b) Clean Air Act)",
      "42:7604cl" : "42:7604cl (42:7604 Clear Air Act (Emission Standards))",
      "42:7604ir" : "42:7604ir (42:7604 Petition to Quash IRS Summons)",
      "42:9607" : "42:9607 (42:9607 Real Property Tort to Land)",
      "43:945" : "43:945 (43:945 Compensation for Land Condemnation)",
      "43:945a" : "43:945a (43:945a Complaint in Condemnation)",
      "43:946" : "43:946 (43:946 Complaint in Condemnation - Eminent Domain)",
      "45:0051" : "45:0051 (45:51 Railways: Fed. Employer's Liability Act)",
      "45:0151" : "45:0151 (45:151 Railway Labor Act)",
      "45:0184" : "45:0184 (45:184 Action to Set Aside Award of a System Board)",
      "45:1395" : "45:1395 (45:1395 Railroads: Adverse Reimbursement Review)",
      "45:7457" : "45:7457 (45:7457 Compel Reclamation Under Clear Air Act)",
      "46:0688" : "46:0688 (46:688 Jones Act)",
      "46:0741" : "46:0741 (46:741 Shipping)",
      "46:0761" : "46:0761 (46:761 Shipping: Damages for Death on High Seas)",
      "46:1101" : "46:1101 (46:1101 Violation of Maritime Regulations)",
      "46:1156" : "46:1156 (46:1156 Administrative Procedure Act)",
      "47:227" : "47:227 (47:227 Telephone Consumer Protection Act of 1991)",
      "47:332" : "47:332 (47:332 Telecommunications Act of 1996)",
      "47:553" : "47:553 (47:553 Unauthorized Reception of Cable Service)",
      "48:0883" : "48:0883 (48:883 Violation of US Coastal Law)",
      "48:1985" : "48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)",
      "49:0081" : "49:0081 (49:81 Damaged Goods While Being Transported)",
      "49:0781" : "49:0781 (49:781 Forfeiture)",
      "49:11503" : "49:11503 (49:11503 Railroad Revitalization Regulatory Reform)",
      "49:11702" : "49:11702 (49:11702(a)(4) Violations of Interstate Commerce A)",
      "49:1471" : "49:1471 (49:1471 Federal Aviation Act)",
      "49:1903" : "49:1903 (49:1903 Petition to enforce administrative summon)",
      "49:20109" : "49:20109 (49:20109 Federal Railroad Safety Act)",
      "49:327" : "49:327 (49:327 Federal Odometer Act)",
      "8:287" : "8:287 (8:287 Petition to Enforce INS Subpoena)",
      "99:9999" : "99:9999 (99:9999 Report cause code (DO NOT DELETE!))",
      "adsup" : "adsup (Administrative Subpoena)",
      "contempt" : "contempt (Contempt Proceedings)",
      "disbar" : "disbar (Disbarment Proceedings)",
      "fordepo" : "fordepo (Foreign Deposition)",
      "misc" : "misc (Civil Miscellaneous Case)",
      "motcomp" : "motcomp (Motion to Compel)",
      "motquash" : "motquash (Motion to Quash)",
      "motret" : "motret (Motion for Return of Property)",
      "petenf" : "petenf (Petition to Enforce IRS Summons)",
      "petper" : "petper (Petition to Perpetuate Testimony)",
      "regjgm" : "regjgm (Registration of Foreign Judgment)",
      "tranbkref" : "tranbkref (Transmission of Bankruptcy Reference)",
      "tranff" : "tranff (Transmission of Proposed Findings of Fact and Concl. of Law)",
      "tro" : "tro (Temporary Restraining Order)",
      "writgar" : "writgar (Application for a Writ of Garnishment)"
   },
   "vidce" : {
      "0" : "0 (No cause code entered)",
      "02:0431" : "02:0431 (02:431 Fed. Election Commission: Failure Enforce C)",
      "02:0437" : "02:0437 (02:437 Federal Election Commission)",
      "05:0075" : "05:0075 (05:75(2) Contract - Reduction in Grade)",
      "05:0551" : "05:0551 (05:551 Administrative Procedure Act)",
      "05:0552fi" : "05:0552fi (05:552 Freedom of Information Act)",
      "05:0552pa" : "05:0552pa (05:552 Right to Privacy Act)",
      "05:0554" : "05:0554 (05:0554 Constitutionality of Maritime Statutes)",
      "05:0701" : "05:0701 (05:0701 Maritime Subsidy Board)",
      "05:0702" : "05:0702 (05:702 Administrative Procedure Act)",
      "05:0704" : "05:0704 (05:704 Labor Litigation)",
      "05:7703" : "05:7703 (05:7703 Discrimination - Review of Agency Act)",
      "07:0006" : "07:0006 (7:6(b) Federal Commodity Exchange Regulation)",
      "07:0025" : "07:0025 (7:25 Fraud - Commodities Leverage Contracts)",
      "07:0181" : "07:0181 (07:181 Packers & Stockyard Act)",
      "07:0499" : "07:0499 (07:499 Agricultural Commodities Act)",
      "07:0601" : "07:0601 (07:601 USDA Condemnation)",
      "07:2321" : "07:2321 (07:2321 Plant Variety Protection Act)",
      "08:1105" : "08:1105 (8:1105(a) Aliens: Habeas Corpus to Release INS Det)",
      "08:1252" : "08:1252 (08:1252(a)(2) Injunction for Deportation)",
      "08:1260" : "08:1260 (08:1260 Aliens: Access to Records)",
      "08:1324" : "08:1324 (08:1324 Aliens: Complaint for Forfeiture)",
      "08:1329" : "08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petiti)",
      "08:1446" : "08:1446 (8:1446 Petition for Naturalization Hearing)",
      "09:0001" : "09:0001 (09:1 U.S. Arbitration Act)",
      "09:0009" : "09:0009 (9:9 Motion to Confirm Arbitration Loan)",
      "09:0010" : "09:0010 (09:0010 Petition to Vacate Arbitration Award)",
      "10:1552" : "10:1552 (10:1552 Armed Forces: Action to Correct Records)",
      "10:1553" : "10:1553 (10:1553 Armed Forces: FOIA General)",
      "10:2305" : "10:2305 (10:2305 Review of Federal Contract)",
      "11:0101" : "11:0101 (11:101 Bankruptcy)",
      "12:0022" : "12:0022 (12:22 Securities Fraud)",
      "12:0635" : "12:0635 (12:635 Breach of Insurance Contract)",
      "12:1461" : "12:1461 (12:1461 Homeowners Loan Act)",
      "12:1703" : "12:1703 (12:1703 Default of HUD Loan)",
      "12:1725" : "12:1725 (12:1725 Collection under Contract Guaranty)",
      "12:1730" : "12:1730 (12:1730 Collection Under Contract Guaranty)",
      "12:1819" : "12:1819 (12:1819 Default of Promissory Note)",
      "12:1821" : "12:1821 (12:1821 Default of Loan by Promissary Note)",
      "12:1971" : "12:1971 (12:1971 Relief under Bank Holding Act)",
      "12:3410" : "12:3410 (12:3410 Right to Financial Privacy Act)",
      "15:0001" : "15:0001 (15:1 Antitrust Litigation)",
      "15:0002at" : "15:0002at (15:2 Antitrust Litigation)",
      "15:0002fl" : "15:0002fl (15:2(a) Fair Labor Standards Act)",
      "15:0005" : "15:0005 (15:5(a) Fair Labor Standards Act)",
      "15:0015" : "15:0015 (15:15 Antitrust Litigation)",
      "15:0025" : "15:0025 (15:25 Clayton Act)",
      "15:0044" : "15:0044 (15:44 Trademark Infringement)",
      "15:0045" : "15:0045 (15:0045 Federal Trade Commission Act)",
      "15:0052" : "15:0052 (15:0052 Federal Trade Commission Act)",
      "15:0053" : "15:0053 (15:0053 Federal Trade Commission Act)",
      "15:0077" : "15:0077 (15:77 Securities Fraud)",
      "15:0078" : "15:0078 (15:78m(a) Securities Exchange Act)",
      "15:0631" : "15:0631 (15:631 Small Business Act)",
      "15:0717" : "15:0717 (15:717 Natural Gas Act)",
      "15:1051" : "15:1051 (15:1051 Trademark Infringement)",
      "15:1114" : "15:1114 (15:1114 Trademark Infringement)",
      "15:1121" : "15:1121 (15:1121 Trademark Infringement)",
      "15:1125" : "15:1125 (15:1125 Trademark Infringement (Lanham Act))",
      "15:1126" : "15:1126 (15:1126 Patent Infringement)",
      "15:1127" : "15:1127 (15:1127 Trademark Infringement)",
      "15:1601" : "15:1601 (15:1601 Truth in Lending)",
      "15:1640" : "15:1640 (15:1640 Truth in Lending)",
      "15:1681" : "15:1681 (15:1681 Fair Credit Reporting Act)",
      "15:1692" : "15:1692 (15:1692 Fair Debt Collection Act)",
      "15:1938" : "15:1938 (15:1938 Fair Labor Standards Act)",
      "15:1981" : "15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))",
      "15:1988" : "15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))",
      "15:1989" : "15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))",
      "15:2301" : "15:2301 (15:2301 Magnuson-Moss Warranty Act)",
      "15:2801" : "15:2801 (15:2801 Petroleum Marketing Practices Act)",
      "15:53(b)" : "15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equita)",
      "16:0668" : "16:0668 (16:668 Bald Eagle Protection Act)",
      "16:0703" : "16:0703 (16:703 Migratory Bird Act)",
      "16:1538" : "16:1538 (16:1538 Endangered Species Act)",
      "16:3371" : "16:3371 (16:3371 Wildlife Under the Lacey Act)",
      "16:3372" : "16:3372 (16:3372 Conservation: Complaint for Forfeiture)",
      "16:3373" : "16:3373 (16:3373 Appeal of Decision - DOI)",
      "16:3374" : "16:3374 (16:3374 Conservation: Complaint for Forfeiture)",
      "17:0101" : "17:0101 (17:101 Copyright Infringement)",
      "17:0501" : "17:0501 (17:501 Copyright Infringement)",
      "17:0504" : "17:0504 (17:504 Copyright Infringement)",
      "18:0241" : "18:0241 (18:241 Conspiracy Against Citizen Rights)",
      "18:1836a" : "18:1836a (18:1836(a) Injunction against Misappropriation of Trade Secrets)",
      "18:1836b" : "18:1836b (18:1836(b) Civil Action to Protect Trade Secrets)",
      "18:1961" : "18:1961 (18:1961 Racketeering (RICO) Act)",
      "18:1962" : "18:1962 (18:1962 Racketeering (RICO) Act)",
      "18:1964" : "18:1964 (18:1964 Racketeering (RICO) Act)",
      "18:4208" : "18:4208 (18:4208(B) Agency Action Review)",
      "19:1305" : "19:1305 (19:1305 Custom Duties:0Forfeiture-Immoral Articles)",
      "20:1080" : "20:1080 (20:1080 Student Loan Recovery)",
      "20:1400" : "20:1400 (20:1400 Civil Rights of Handicapped Child)",
      "20:1401" : "20:1401 (20:1401 Education: Handicapped Child Act)",
      "21:0841" : "21:0841 (21:841 Forfeiture Property-Drugs)",
      "21:0881" : "21:0881 (21:881 Forfeiture Property-Drugs)",
      "21:0881a" : "21:0881a (21:881 Forfeiture Property - Aircraft)",
      "21:0881re" : "21:0881re (21:881 Forfeiture Property - Real Estate)",
      "23:0134" : "23:0134 (23:134 P.I.- Auto Negligence)",
      "23:1441" : "23:1441 (23:1441 Contract Real Estate)",
      "24:1000" : "24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)",
      "25:0640" : "25:0640 (25:640 Indian Tribal Rights)",
      "25:1901" : "25:1901 (25:1901 Indian Child Welfare Act)",
      "26:6212" : "26:6212 (26:6212 Injunctive Relief from IRS Lien)",
      "26:6213" : "26:6213 (26:6213 Injunctive Relief from IRS Lien)",
      "26:6502" : "26:6502 (26:6502 IRS:Enforcement of tax liens)",
      "26:6532" : "26:6532 (26:6532 IRS: Refund of Tax Penalty)",
      "26:6702" : "26:6702 (26:6702 IRS: Refund of Income Tax Penalty)",
      "26:6703" : "26:6703 (26:6703 IRS: Refund of Tax Penalty)",
      "26:7401" : "26:7401 (26:7401 IRS: Tax Liability)",
      "26:7402" : "26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)",
      "26:7403" : "26:7403 (26:7403 Suit to Enforce Federal Tax Lien)",
      "26:7422rt" : "26:7422rt (26:7422 IRS: Refund Taxes)",
      "26:7422rx" : "26:7422rx (26:7422 IRS: Refund Excise Tax)",
      "26:7426" : "26:7426 (26:7426 IRS: Wrongful Levy for Taxes)",
      "26:7429" : "26:7429 (26:7429 IRS: Tax Jeopardy Assessment)",
      "26:7609" : "26:7609 (26:7609 IRS: Petition to Quash IRS Summons)",
      "27:0185" : "27:0185 (27:185 Enforcement of Arbitration Award)",
      "28:0157c" : "28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)",
      "28:0157d" : "28:0157d (28:0157 Motion for Withdrawal of Reference)",
      "28:0158" : "28:0158 (28:0158 Notice of Appeal re Bankruptcy Matter (BA)",
      "28:0185" : "28:0185 (28:185 Suit to Compel Arbitration)",
      "28:0451" : "28:0451 (28:451 Employment Discrimination)",
      "28:0794" : "28:0794 (28:794 Rehabilitation Act)",
      "28:1001" : "28:1001 (28:1001 E.R.I.S.A.)",
      "28:1132" : "28:1132 (28:1132 E.R.I.S.A.)",
      "28:1330" : "28:1330 (28:1330 Breach of Contract)",
      "28:1331" : "28:1331 (28:1331 Fed. Question)",
      "28:1331al" : "28:1331al (28:1331 Fed. Question: Airline Crash)",
      "28:1331at" : "28:1331at (28:1331 Fed. Question: Anti-trust)",
      "28:1331au" : "28:1331au (28:1331 Fed. Question: Auto Negligence)",
      "28:1331b" : "28:1331b (28:1331 Federal Question: Bivens Act)",
      "28:1331bc" : "28:1331bc (28:1331 Fed. Question: Breach of Contract)",
      "28:1331ca" : "28:1331ca (28:1331 Fed Question: Fed Communications Act of 1)",
      "28:1331cm" : "28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)",
      "28:1331cv" : "28:1331cv (28:1331 Federal Question: Other Civil Rights)",
      "28:1331ed" : "28:1331ed (28:1331 Fed. Question: Employment Discrimination)",
      "28:1331es" : "28:1331es (28:1331 Enforcement of Administrative Subpoena)",
      "28:1331fl" : "28:1331fl (28:1331 Fed. Question: Fair Labor Standards)",
      "28:1331in" : "28:1331in (28:1331 Fed. Question: Insurance Contract)",
      "28:1331mm" : "28:1331mm (28:1331 Fed. Question: Medical Malpractice)",
      "28:1331pi" : "28:1331pi (28:1331 Fed. Question: Personal Injury)",
      "28:1331rd" : "28:1331rd (28:1331 Fed. Question: Review Agency Decision)",
      "28:1331rp" : "28:1331rp (28:1331(a) Fed. Question: Real Property)",
      "28:1331rr" : "28:1331rr (28:1331 Fed. Question: Railway Labor Act)",
      "28:1331sv" : "28:1331sv (28:1331 Fed. Question: Securities Violation)",
      "28:1331tr" : "28:1331tr (28:1331 Fed. Question: Trademark)",
      "28:1331tt" : "28:1331tt (28:1331 Fed. Question: Tort Action)",
      "28:1331v" : "28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendme)",
      "28:1331wl" : "28:1331wl (28:1331 Federal Question: EPA Waste Lien)",
      "28:1331wt" : "28:1331wt (28:1331 Fed. Question: Water Rights)",
      "28:1332ac" : "28:1332ac (28:1332 Diversity-Account Receivable)",
      "28:1332al" : "28:1332al (28:1332 Diversity-Airline Crash)",
      "28:1332as" : "28:1332as (28:1332 Diversity-Asbestos Litigation)",
      "28:1332au" : "28:1332au (28:1332 Diversity-Auto Negligence)",
      "28:1332bc" : "28:1332bc (28:1332 Diversity-Breach of Contract)",
      "28:1332co" : "28:1332co (28:1332 Diversity-Conversion)",
      "28:1332ct" : "28:1332ct (28:1332 Diversity-(Citizenship))",
      "28:1332det" : "28:1332det (28:1332 Diversity: Forcible Detainer)",
      "28:1332df" : "28:1332df (28:1332 Diversity-Contract Default)",
      "28:1332ds" : "28:1332ds (28:1332 Diversity-Contract Dispute)",
      "28:1332ed" : "28:1332ed (28:1332 Diversity-Employment Discrimination)",
      "28:1332fd" : "28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)",
      "28:1332fr" : "28:1332fr (28:1332 Diversity-Fraud)",
      "28:1332ia" : "28:1332ia (28:1332 Diversity-Interpleader Action)",
      "28:1332ij" : "28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)",
      "28:1332in" : "28:1332in (28:1332 Diversity-Insurance Contract)",
      "28:1332jd" : "28:1332jd (28:1332 Diversity-Declaratory Judgement)",
      "28:1332lb" : "28:1332lb (28:1332 Diversity-Libel,Assault,Slander)",
      "28:1332lm" : "28:1332lm (28:1332 Diversity - Legal Malpractice)",
      "28:1332ma" : "28:1332ma (28:1332 Diversity-Miller Act)",
      "28:1332mm" : "28:1332mm (28:1332 Diversity-Medical Malpractice)",
      "28:1332mv" : "28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)",
      "28:1332ni" : "28:1332ni (28:1332 Diversity-Negotiable Instrument)",
      "28:1332nm" : "28:1332nm (28:1332 Diversity-Non-Motor Vehicle)",
      "28:1332oc" : "28:1332oc (28:1332 Diversity-Other Contract)",
      "28:1332pd" : "28:1332pd (28:1332 Diversity-Property Damage)",
      "28:1332pi" : "28:1332pi (28:1332 Diversity-Personal Injury)",
      "28:1332pl" : "28:1332pl (28:1332 Diversity-Product Liability)",
      "28:1332pr" : "28:1332pr (28:1332 Diversity-Petition for Removal)",
      "28:1332qt" : "28:1332qt (28:1332 Diversity-Petition to Quiet Title)",
      "28:1332ri" : "28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)",
      "28:1332sa" : "28:1332sa (28:1332 - Diversity: Securities & Exchange Commiss)",
      "28:1332sf" : "28:1332sf (28:1332 - Diversity: Securities Fraud)",
      "28:1332ss" : "28:1332ss (28:1332 Diversity - Stockholders Suits)",
      "28:1332tl" : "28:1332tl (28:1332 Diversity-Torts to Land)",
      "28:1332tm" : "28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))",
      "28:1332tn" : "28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)",
      "28:1332wd" : "28:1332wd (28:1332 Diversity-Wrongful Death)",
      "28:1333" : "28:1333 (28:1333 Admiralty)",
      "28:1334" : "28:1334 (28:1334 Bankruptcy Appeal)",
      "28:1334c" : "28:1334c (28:1334(c) R&R re motions for abstention (non-cor)",
      "28:1335" : "28:1335 (28:1335 Interpleader Action)",
      "28:1337" : "28:1337 (28:1337 Sherman-Clayton Act)",
      "28:1338cp" : "28:1338cp (28:1338 Copyright Infringement)",
      "28:1338pt" : "28:1338pt (28:1338 Patent Infringement)",
      "28:1338tr" : "28:1338tr (28:1338 Trademark Infringement)",
      "28:1340" : "28:1340 (28:1340 IRS: Custom Duties)",
      "28:1340er" : "28:1340er (28:1340 Recovery of Erroneous Refund)",
      "28:1341" : "28:1341 (28:1341 Complaint for Forfeiture)",
      "28:1343" : "28:1343 (28:1343 Violation of Civil Rights)",
      "28:1345co" : "28:1345co (28:1345 Replevin & Conversion)",
      "28:1345db" : "28:1345db (28:1345 Debt to US - FHA/HUD Title I)",
      "28:1345df" : "28:1345df (28:1345 Default of Promissory Note)",
      "28:1345er" : "28:1345er (28:1345 Recovery of Erroneous Refund)",
      "28:1345fc" : "28:1345fc (28:1345 Foreclosure)",
      "28:1345ff" : "28:1345ff (28:1345 Complaint for Forfeiture)",
      "28:1345hl" : "28:1345hl (28:1345 VA Home Loan Guaranty Debt)",
      "28:1345mc" : "28:1345mc (28:1345 Medical Care Recovery)",
      "28:1345mi" : "28:1345mi (28:1345 Mining Claim Ejectment)",
      "28:1345pd" : "28:1345pd (28:1345 Property Damage)",
      "28:1345pe" : "28:1345pe (28:1345 Property Ejectment)",
      "28:1345rc" : "28:1345rc (28:1345 Recovery of Debt to US)",
      "28:1345st" : "28:1345st (28:1345 Default of Student Loan)",
      "28:1345tp" : "28:1345tp (28:1345 Trespass on Public Land)",
      "28:1345va" : "28:1345va (28:1345 Recovery of VA Overpayment)",
      "28:1346bc" : "28:1346bc (28:1346 Breach of Contract)",
      "28:1346rc" : "28:1346rc (28:1346 Recovery of IRS Tax)",
      "28:1346tc" : "28:1346tc (28:1346 Tort Claim)",
      "28:1346wd" : "28:1346wd (28:1346 Wrongful Death)",
      "28:1352" : "28:1352 (28:1352 Miller Act)",
      "28:1355" : "28:1355 (28:1355 Petition for Return of Property)",
      "28:1358" : "28:1358 (28:1358 Land Condemnation)",
      "28:1361" : "28:1361 (28:1361 Petition for Writ of Mandamus)",
      "28:1362ic" : "28:1362ic (28:1362 Indian Tribal Controversy)",
      "28:1362iw" : "28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)",
      "28:1364" : "28:1364 (28:1364 Auto Negligence)",
      "28:1391" : "28:1391 (28:1391 Personal Injury)",
      "28:1402" : "28:1402 (28:1402 Medical Malpractice)",
      "28:1407" : "28:1407 (28:1407 Airline Crash)",
      "28:1441ac" : "28:1441ac (28:1441 Petition for Removal- Account Receivable)",
      "28:1441al" : "28:1441al (28:1441 Petition for Removal- Airline Crash)",
      "28:1441as" : "28:1441as (28:1441 Petition for Removal- Asbestos Litigation)",
      "28:1441au" : "28:1441au (28:1441 Petition for Removal- Auto Negligence)",
      "28:1441bc" : "28:1441bc (28:1441 Petition for Removal- Breach of Contract)",
      "28:1441cv" : "28:1441cv (28:1441 Petition for Removal- Civil Rights Act)",
      "28:1441df" : "28:1441df (28:1441 Petition for Removal- Contract Default)",
      "28:1441dj" : "28:1441dj (28:1441 Petition for Removal- Declaratory Judgemen)",
      "28:1441ds" : "28:1441ds (28:1441 Petition for Removal- Contract Dispute)",
      "28:1441ed" : "28:1441ed (28:1441 Petition for Removal - Employment Discrim)",
      "28:1441fc" : "28:1441fc (28:1441 Petition for Removal - Fair Credit Reporti)",
      "28:1441fr" : "28:1441fr (28:1441 Petition for Removal- Fraud)",
      "28:1441ij" : "28:1441ij (28:1441 Petition for Removal- Injunctive/Declarato)",
      "28:1441in" : "28:1441in (28:1441 Petition for Removal- Insurance Contract)",
      "28:1441int" : "28:1441int (28:1441 Petition for Removal- Action for Interplea)",
      "28:1441lb" : "28:1441lb (28:1441 Petition for Removal Libel,Assault,Slander)",
      "28:1441lm" : "28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relatio)",
      "28:1441mm" : "28:1441mm (28:1441 Petition for Removal- Medical Malpractice)",
      "28:1441ni" : "28:1441ni (28:1441 Petition for Removal- Negotiable Instrumen)",
      "28:1441nm" : "28:1441nm (28:1441 Petition for Removal- Non-Motor Vehicle)",
      "28:1441oc" : "28:1441oc (28:1441 Petition For Removal--Other Contract)",
      "28:1441pd" : "28:1441pd (28:1441 Petition for Removal- Property Damage)",
      "28:1441pi" : "28:1441pi (28:1441 Petition for Removal- Personal Injury)",
      "28:1441pl" : "28:1441pl (28:1441 Petition for Removal- Product Liability)",
      "28:1441pr" : "28:1441pr (28:1441 Petition for Removal)",
      "28:1441qt" : "28:1441qt (28:1441 Petition for Removal- Petition to Quiet Ti)",
      "28:1441ri" : "28:1441ri (28:1441 Petition for Removal- Racketeering (RICO))",
      "28:1441sa" : "28:1441sa (28:1441 - Petition for Removal: SEC Act)",
      "28:1441sf" : "28:1441sf (28:1441 - Petition for Removal: Securities Fraud)",
      "28:1441tl" : "28:1441tl (28:1441 Petition for Removal- Torts to Land)",
      "28:1441tm" : "28:1441tm (28:1441 Petition for Removal- Tort/Motor Vehicle ()",
      "28:1441tn" : "28:1441tn (28:1441 Petition for Removal- Tort/Non-Motor Vehic)",
      "28:1441wd" : "28:1441wd (28:1441 Petition for Removal- Wrongful Death)",
      "28:1442bc" : "28:1442bc (28:1442 Petition for Removal- Breach of Contract)",
      "28:1442pr" : "28:1442pr (28:1442 Petition for Removal)",
      "28:1443" : "28:1443 (28:1443(1) Rent, Lease & Ejectment)",
      "28:1444" : "28:1444 (28:1444 Petition for Removal- Foreclosure)",
      "28:1446in" : "28:1446in (28:1446 Breach of Contract- Insurance)",
      "28:1446pd" : "28:1446pd (28:1446 Petition for Removal- Property Damage (P.I)",
      "28:1446pi" : "28:1446pi (28:1446 Petition for Removal- Personal Injury)",
      "28:1446pl" : "28:1446pl (28:1446pl Petition for Removal - Product Liability)",
      "28:1446pr" : "28:1446pr (28:1446 Petition for Removal)",
      "28:1452" : "28:1452 (28:1452 R&R re motions to remand (non-core))",
      "28:1651" : "28:1651 (28:1651 Petition for Writ of Coram Nobis)",
      "28:1651hc" : "28:1651hc (28:1651 Petition for Writ of Habeas Corpus)",
      "28:1651mn" : "28:1651mn (28:1651 Petition for Writ of Mandamus)",
      "28:1983" : "28:1983 (28:1983 Civil Rights)",
      "28:2201" : "28:2201 (28:2201 Constitutionality of State Statute(s))",
      "28:2201dj" : "28:2201dj (28:2201 Declaratory Judgement)",
      "28:2201ij" : "28:2201ij (28:2201 Injunction)",
      "28:2201in" : "28:2201in (28:2201 Declaratory Judgement (Insurance))",
      "28:2241" : "28:2241 (28:2241 Petition for Writ of Habeas Corpus (federa)",
      "28:2254" : "28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))",
      "28:2254se" : "28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)",
      "28:2255" : "28:2255 (28:2255 Motion to Vacate / Correct Illegal Sentenc)",
      "28:2271" : "28:2271 (28:2271 Federal Tort Claims Act)",
      "28:2345" : "28:2345 (28:2345 Medicare Recovery)",
      "28:2409" : "28:2409 (28:2409(a) Quiet Title Action)",
      "28:2410" : "28:2410 (28:2410 Quiet Title)",
      "28:2671" : "28:2671 (28:2671 Federal Tort Claims Act)",
      "28:2674" : "28:2674 (28:2674 Federal Tort Claims Act)",
      "28:7402" : "28:7402 (28:7402 Refund of Taxes)",
      "28:7422" : "28:7422 (28:7422 Appeal from Administrative Decision)",
      "29:0151" : "29:0151 (29:151 Labor: Review of Agency Action)",
      "29:0160" : "29:0160 (29:160(1) National Labor Relations Act)",
      "29:0184" : "29:0184 (29:184 Violation Collection Bargain Agreement)",
      "29:0185ep" : "29:0185ep (29:185 Employee Pension Plan)",
      "29:0185lm" : "29:0185lm (29:185 Labor/Mgt. Relations (Contracts))",
      "29:0201do" : "29:0201do (29:201 Denial of Overtime Compensation)",
      "29:0201fl" : "29:0201fl (29:201 Fair Labor Standards Act)",
      "29:0203" : "29:0203 (29:203 Equal Pay Act)",
      "29:0206" : "29:0206 (29:206 Collect Unpaid Wages)",
      "29:0401" : "29:0401 (29:0401 Labor Management Disclosure Act)",
      "29:0621" : "29:0621 (29:621 Job Discrimination (Age))",
      "29:0623" : "29:0623 (29:623 Job Discrimination (Age))",
      "29:0626" : "29:0626 (29:626 Job Discrimination (Age))",
      "29:0633" : "29:0633 (29:633 Job Discrimination (Age))",
      "29:0651" : "29:0651 (29:651 Occupational Safety/Health)",
      "29:0754" : "29:0754 (29:754 Discrimination)",
      "29:0791" : "29:0791 (29:791 Job Discrimination (Rehabilitation Act))",
      "29:0794" : "29:0794 (29:0794 Job Discrimination (Handicap))",
      "29:1001" : "29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)",
      "29:1002" : "29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)",
      "29:1104" : "29:1104 (29:1104 Recovery of Benefits to Employee)",
      "29:1109" : "29:1109 (29:1109 Breach of Fiduciary Duties)",
      "29:1131" : "29:1131 (29:1131 ERISA - Collection of Delinquent Trust Fun)",
      "29:1132" : "29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)",
      "29:1145" : "29:1145 (29:1145 E.R.I.S.A.)",
      "29:1149" : "29:1149 (29:1149 Recover Pension & Profit Sharing)",
      "29:1337" : "29:1337 (29:1337 E.R.I.S.A.)",
      "29:1362" : "29:1362 (29:1362 ERISA)",
      "29:1381" : "29:1381 (29:1381 E.R.I.S.A.)",
      "29:1401" : "29:1401 (29:1401(b)(2) Appeal of Arbitration Award)",
      "29:1451" : "29:1451 (29:1451 E.R.I.S.A.)",
      "29:1801" : "29:1801 (29:1801 Farmworker Rights)",
      "29:790" : "29:790 (29:790 Rehabilitation of Labor)",
      "30:0181" : "30:0181 (30:181 Environment: Review of Agency Action)",
      "30:0801" : "30:0801 (30:0801 Penalities/Federal Mine Safety Health Act)",
      "30:1201" : "30:1201 (30:1201 Environment: Review of Agency Action)",
      "30:1202" : "30:1202 (30:1202 Mining Reclamation Act)",
      "30:1276" : "30:1276 (30:1276 Interior: Review of Agency Action)",
      "31:3545" : "31:3545 (31:3545 Action to Recovery Money)",
      "31:3729" : "31:3729 (31:3729 False Claims Act)",
      "31:3730" : "31:3730 (31:3730 Qui Tam False Claims Act)",
      "31:3731" : "31:3731 (31:3731 Fraud)",
      "33:1319cw" : "33:1319cw (33:1319 Clean Water Act)",
      "33:1319pv" : "33:1319pv (33:1319 Pollutants & Permit Violations)",
      "33:1365" : "33:1365 (33:1365 Environmental Matters)",
      "35:0145" : "35:0145 (35:145 Patent Infringement)",
      "35:0183" : "35:0183 (35:183 Patent Infringement)",
      "35:0271" : "35:0271 (35:271 Patent Infringement)",
      "38:1681" : "38:1681 (38:1681 Recovery of VA Overpayment)",
      "38:1686" : "38:1686 (38:1686 Recovery of VA Overpayment)",
      "38:1780" : "38:1780 (38:1780 Recovery of VA Overpayment)",
      "38:2011" : "38:2011 (38:2011 - Veteran's Readjustment Assistance Act of)",
      "38:3116" : "38:3116 (38:3116 VA Overpayment)",
      "39:3005" : "39:3005 (39:3005 Detention of Mail for Temporary Periods)",
      "39:409" : "39:409 (39:409 Postal Service)",
      "40:0258" : "40:0258 (40:258(a) Public Buildings & Property: Land Condem)",
      "40:0270" : "40:0270 (40:270 Miller Act)",
      "40:0875" : "40:0875 (40:875 Public Buildings & Property: Negligence)",
      "41:0251" : "41:0251 (41:251 Public Contracts-Review of Agency Action)",
      "41:1463" : "41:1463 (41:1463 Public Contracts: Unlawful Employment Prac)",
      "42:0205" : "42:0205 (42:205 Denial Social Security Benefits)",
      "42:0206" : "42:0206 (42:206 Social Security Benefits)",
      "42:0247" : "42:0247 (42:247 Personal Injury-Swine Flu)",
      "42:0402" : "42:0402 (42:402 Social Security Benefits)",
      "42:0405id" : "42:0405id (42:405 Review of HHS Decision (SSID))",
      "42:0405wc" : "42:0405wc (42:405 Review of HHS Decision (DIWC))",
      "42:0405ww" : "42:0405ww (42:405 Review of HHS Decision (DIWW))",
      "42:0416" : "42:0416 (42:416 Denial of Social Security Benefits)",
      "42:0427" : "42:0427 (42:427 Social Security Benefits)",
      "42:1383" : "42:1383 (42:1383 Review of HHS Decision)",
      "42:1395" : "42:1395 (42:1395 HHS: Adverse Reimbursement Review)",
      "42:1396" : "42:1396 (42:1396 - Tort Negligence)",
      "42:1471" : "42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclo)",
      "42:1981cv" : "42:1981cv (42:1981 Civil Rights)",
      "42:1981hs" : "42:1981hs (42:1981 Housing Discrimination)",
      "42:1981jb" : "42:1981jb (42:1981 Job Discrimination (Race))",
      "42:1981sx" : "42:1981sx (42:1981 Sex Discrimination)",
      "42:1983cv" : "42:1983cv (42:1983 Civil Rights Act)",
      "42:1983ed" : "42:1983ed (42:1983 Civil Rights (Employment Discrimination))",
      "42:1983pr" : "42:1983pr (42:1983 Prisoner Civil Rights)",
      "42:1986" : "42:1986 (42:1986 Neglect of Duty)",
      "42:2000ag" : "42:2000ag (42:2000 Job Discrimination (Age))",
      "42:2000e" : "42:2000e (42:2000e Job Discrimination (Employment))",
      "42:2000pb" : "42:2000pb (42:2000 Job Discrimination (Public Accomodations))",
      "42:2000ra" : "42:2000ra (42:2000 Job Discrimination (Race))",
      "42:2000sx" : "42:2000sx (42:2000 Job Discrimination (Sex))",
      "42:2003" : "42:2003 (42:2003 Job Discrimination)",
      "42:2005" : "42:2005 (42:2005 Review of Agency Action-HHS)",
      "42:2651" : "42:2651 (42:2651 Medical Care Recovery)",
      "42:3601" : "42:3601 (42:405 Fair Housing Act)",
      "42:4000" : "42:4000 (42:4000 National Flood Insurance Act)",
      "42:4001" : "42:4001 (42:4001 National Insurance Flood Act)",
      "42:4053" : "42:4053 (42:4053 Breach of Insurance Contract)",
      "42:4072" : "42:4072 (42:4072 Payment of Flood Insurance Claim)",
      "42:4321" : "42:4321 (42:4321 Review of Agency Action-Environment)",
      "42:4332" : "42:4332 (42:4332 Environmental Policy - Coop of Agency Repo)",
      "42:6901en" : "42:6901en (42:6901 Environmental Cleanup Expenses)",
      "42:6901rs" : "42:6901rs (42:6901 Resource & Recovery Act)",
      "42:7413" : "42:7413 (42:7413(b) Clean Air Act)",
      "42:7604cl" : "42:7604cl (42:7604 Clear Air Act (Emission Standards))",
      "42:7604ir" : "42:7604ir (42:7604 Petition to Quash IRS Summons)",
      "42:9607" : "42:9607 (42:9607 Real Property Tort to Land)",
      "43:945" : "43:945 (43:945 Compensation for Land Condemnation)",
      "43:945a" : "43:945a (43:945a Complaint in Condemnation)",
      "43:946" : "43:946 (43:946 Complaint in Condemnation - Eminent Domain)",
      "45:0051" : "45:0051 (45:51 Railways: Fed. Employer's Liability Act)",
      "45:0151" : "45:0151 (45:151 Railway Labor Act)",
      "45:0184" : "45:0184 (45:184 Action to Set Aside Award of a System Board)",
      "45:1395" : "45:1395 (45:1395 Railroads: Adverse Reimbursement Review)",
      "45:7457" : "45:7457 (45:7457 Compel Reclamation Under Clear Air Act)",
      "46:0688" : "46:0688 (46:688 Jones Act)",
      "46:0741" : "46:0741 (46:741 Shipping)",
      "46:0761" : "46:0761 (46:761 Shipping: Damages for Death on High Seas)",
      "46:1101" : "46:1101 (46:1101 Violation of Maritime Regulations)",
      "46:1156" : "46:1156 (46:1156 Administrative Procedure Act)",
      "48:0883" : "48:0883 (48:883 Violation of US Coastal Law)",
      "48:1985" : "48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)",
      "49:0081" : "49:0081 (49:81 Damaged Goods While Being Transported)",
      "49:0781" : "49:0781 (49:781 Forfeiture)",
      "49:11503" : "49:11503 (49:11503 Railroad Revitalization Regulatory Reform)",
      "49:11702" : "49:11702 (49:11702(a)(4) Violations of Interstate Commerce A)",
      "49:1471" : "49:1471 (49:1471 Federal Aviation Act)",
      "49:1903" : "49:1903 (49:1903 Petition to enforce administrative summon)",
      "8:287" : "8:287 (8:287 Petition to Enforce INS Subpoena)",
      "misc" : "misc (Civil Miscellaneous Case)"
   },
   "vtdce" : {
      "0" : "0 (no cause specified)",
      "02:0431" : "02:0431 (02:431 Fed. Election Commission: Failure Enforce Compliance)",
      "02:0437" : "02:0437 (02:437 Federal Election Commission)",
      "05:0075" : "05:0075 (05:75(2) Contract - Reduction in Grade)",
      "05:0551" : "05:0551 (05:551 Administrative Procedure Act)",
      "05:0552fi" : "05:0552fi (05:552 Freedom of Information Act)",
      "05:0552pa" : "05:0552pa (05:552 Right to Privacy Act)",
      "05:0554" : "05:0554 (05:0554 Constitutionality of Maritime Statutes)",
      "05:0701" : "05:0701 (05:0701 Maritime Subsidy Board)",
      "05:0702" : "05:0702 (05:702 Administrative Procedure Act)",
      "05:0704" : "05:0704 (05:704 Labor Litigation)",
      "05:7703" : "05:7703 (05:7703 Discrimination - Review of Agency Act)",
      "05:8470" : "05:8470 (05:8470 Enforcement of Judgment against Retirement Benefits)",
      "07:0006" : "07:0006 (7:6(b) Federal Commodity Exchange Regulation)",
      "07:0025" : "07:0025 (7:25 Fraud - Commodities Leverage Contracts)",
      "07:0181" : "07:0181 (07:181 Packers & Stockyard Act)",
      "07:0499" : "07:0499 (07:499 Agricultural Commodities Act)",
      "07:0601" : "07:0601 (07:601 USDA Condemnation)",
      "07:2321" : "07:2321 (07:2321 Plant Variety Protection Act)",
      "08:1105" : "08:1105 (8:1105(a) Aliens: Habeas Corpus to Release INS Detainee)",
      "08:1182" : "08:1182 (8:1182 Defend. Denial of Pla. Appl. for Alien Employment Cer)",
      "08:1252" : "08:1252 (08:1252(a)(2) Injunction for Deportation)",
      "08:1260" : "08:1260 (08:1260 Aliens: Access to Records)",
      "08:1324" : "08:1324 (08:1324 Aliens: Complaint for Forfeiture)",
      "08:1329" : "08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petition)",
      "08:1446" : "08:1446 (8:1446 Petition for Naturalization Hearing)",
      "08:1451(a)" : "08:1451(a) (8:1451(a) Revocation of Naturalization)",
      "08:1451(j)" : "08:1451(j) (8:1451(j) Motion to Correct Order & Judg. of Naturalization)",
      "09:0001" : "09:0001 (09:1 U.S. Arbitration Act)",
      "09:0009" : "09:0009 (9:9 Motion to Confirm Arbitration Loan)",
      "09:0010" : "09:0010 (09:0010 Petition to Vacate Arbitration Award)",
      "10:1408" : "10:1408 (10:1408 Claim for Military Retirement)",
      "10:1552" : "10:1552 (10:1552 Armed Forces: Action to Correct Records)",
      "10:1553" : "10:1553 (10:1553 Armed Forces: FOIA General)",
      "10:2305" : "10:2305 (10:2305 Review of Federal Contract)",
      "11:0101" : "11:0101 (11:101 Bankruptcy)",
      "12:0022" : "12:0022 (12:22 Securities Fraud)",
      "12:0635" : "12:0635 (12:635 Breach of Insurance Contract)",
      "12:1461" : "12:1461 (12:1461 Homeowners Loan Act)",
      "12:1464" : "12:1464 (12:1464 Federal Savings and Loan)",
      "12:1703" : "12:1703 (12:1703 Default of HUD Loan)",
      "12:1725" : "12:1725 (12:1725 Collection under Contract Guaranty)",
      "12:1730" : "12:1730 (12:1730 Collection Under Contract Guaranty)",
      "12:1819" : "12:1819 (12:1819 Default of Promissory Note)",
      "12:1821" : "12:1821 (12:1821 Default of Loan by Promissary Note)",
      "12:1833a" : "12:1833a (12:1833a Financial Institutions Reform, Recovery and Enforcement Act)",
      "12:191" : "12:191 (12:191 Bank Foreclosure)",
      "12:192" : "12:192 (12:192 Liquidation of National Bank)",
      "12:1971" : "12:1971 (12:1971 Relief under Bank Holding Act)",
      "12:1972" : "12:1972 (12:1972 Typing Arrangement Act)",
      "12:3410" : "12:3410 (12:3410 Right to Financial Privacy Act)",
      "15:0001" : "15:0001 (15:1 Antitrust Litigation)",
      "15:0002at" : "15:0002at (15:2 Antitrust Litigation)",
      "15:0002fl" : "15:0002fl (15:2(a) Fair Labor Standards Act)",
      "15:0005" : "15:0005 (15:5(a) Fair Labor Standards Act)",
      "15:0013" : "15:0013 (15:13 Robinson - Patman Act)",
      "15:0015" : "15:0015 (15:15 Antitrust Litigation)",
      "15:0025" : "15:0025 (15:25 Clayton Act)",
      "15:0044" : "15:0044 (15:44 Trademark Infringement)",
      "15:0045" : "15:0045 (15:0045 Federal Trade Commission Act)",
      "15:0052" : "15:0052 (15:0052 Federal Trade Commission Act)",
      "15:0053" : "15:0053 (15:0053 Federal Trade Commission Act)",
      "15:0077" : "15:0077 (15:77 Securities Fraud)",
      "15:0078" : "15:0078 (15:78m(a) Securities Exchange Act)",
      "15:0631" : "15:0631 (15:631 Small Business Act)",
      "15:0717" : "15:0717 (15:717 Natural Gas Act)",
      "15:0754" : "15:0754 (15:754 Emergency Petroleum Allocation-Admin.& Enforcement)",
      "15:1051" : "15:1051 (15:1051 Trademark Infringement)",
      "15:1114" : "15:1114 (15:1114 Trademark Infringement)",
      "15:1121" : "15:1121 (15:1121 Trademark Infringement)",
      "15:1125" : "15:1125 (15:1125 Trademark Infringement (Lanham Act))",
      "15:1126" : "15:1126 (15:1126 Patent Infringement)",
      "15:1127" : "15:1127 (15:1127 Trademark Infringement)",
      "15:1601" : "15:1601 (15:1601 Truth in Lending)",
      "15:1640" : "15:1640 (15:1640 Truth in Lending)",
      "15:1681" : "15:1681 (15:1681 Fair Credit Reporting Act)",
      "15:1692" : "15:1692 (15:1692 Fair Debt Collection Act)",
      "15:1938" : "15:1938 (15:1938 Fair Labor Standards Act)",
      "15:1981" : "15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))",
      "15:1988" : "15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))",
      "15:1989" : "15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))",
      "15:2301" : "15:2301 (15:2301 Magnuson-Moss Warranty Act)",
      "15:2801" : "15:2801 (15:2801 Petroleum Marketing Practices Act)",
      "15:53(b)" : "15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equita)",
      "16:0012" : "16:0012 (Federal Regulation and Development of Power)",
      "16:0515" : "16:0515 (16:515 Weeks Act)",
      "16:0668" : "16:0668 (16:668 Bald Eagle Protection Act)",
      "16:0703" : "16:0703 (16:703 Migratory Bird Act)",
      "16:1538" : "16:1538 (16:1538 Endangered Species Act)",
      "16:3371" : "16:3371 (16:3371 Wildlife Under the Lacey Act)",
      "16:3372" : "16:3372 (16:3372 Conservation: Complaint for Forfeiture)",
      "16:3373" : "16:3373 (16:3373 Appeal of Decision - DOI)",
      "16:3374" : "16:3374 (16:3374 Conservation: Complaint for Forfeiture)",
      "17:0101" : "17:0101 (17:101 Copyright Infringement)",
      "17:0501" : "17:0501 (17:501 Copyright Infringement)",
      "17:0504" : "17:0504 (17:504 Copyright Infringement)",
      "18:0241" : "18:0241 (18:241 Conspiracy Against Citizen Rights)",
      "18:1836a" : "18:1836a (18:1836(a) Injunction against Misappropriation of Trade Secrets)",
      "18:1836b" : "18:1836b (18:1836(b) Civil Action to Protect Trade Secrets)",
      "18:1961" : "18:1961 (18:1961 Racketeering (RICO) Act)",
      "18:1962" : "18:1962 (18:1962 Racketeering (RICO) Act)",
      "18:1964" : "18:1964 (18:1964 Racketeering (RICO) Act)",
      "18:2511" : "18:2511 (18:2511 Wiretapping)",
      "18:3114" : "18:3114 (18:3114 Motion for Return of Seized Property)",
      "18:4208" : "18:4208 (18:4208(B) Agency Action Review)",
      "19:1305" : "19:1305 (19:1305 Custom Duties: Forfeiture-Immoral Articles)",
      "20:1080" : "20:1080 (20:1080 Student Loan Recovery)",
      "20:1400" : "20:1400 (20:1400 Civil Rights of Handicapped Child)",
      "20:1401" : "20:1401 (20:1401 Education: Handicapped Child Act)",
      "21:0841" : "21:0841 (21:841 Forfeiture Property-Drugs)",
      "21:0881" : "21:0881 (21:881 Forfeiture Property-Drugs)",
      "21:0881a" : "21:0881a (21:881 Forfeiture Property - Aircraft)",
      "21:0881re" : "21:0881re (21:881 Forfeiture Property - Real Estate)",
      "23:0134" : "23:0134 (23:134 P.I.- Auto Negligence)",
      "23:1441" : "23:1441 (23:1441 Contract Real Estate)",
      "24:1000" : "24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)",
      "25:0640" : "25:0640 (25:640 Indian Tribal Rights)",
      "25:1901" : "25:1901 (25:1901 Indian Child Welfare Act)",
      "26:6212" : "26:6212 (26:6212 Injunctive Relief from IRS Lien)",
      "26:6213" : "26:6213 (26:6213 Injunctive Relief from IRS Lien)",
      "26:6502" : "26:6502 (26:6502 IRS:Enforcement of tax liens)",
      "26:6532" : "26:6532 (26:6532 IRS: Refund of Tax Penalty)",
      "26:6702" : "26:6702 (26:6702 IRS: Refund of Income Tax Penalty)",
      "26:6703" : "26:6703 (26:6703 IRS: Refund of Tax Penalty)",
      "26:7401" : "26:7401 (26:7401 IRS: Tax Liability)",
      "26:7402" : "26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)",
      "26:7403" : "26:7403 (26:7403 Suit to Enforce Federal Tax Lien)",
      "26:7422rt" : "26:7422rt (26:7422 IRS: Refund Taxes)",
      "26:7422rx" : "26:7422rx (26:7422 IRS: Refund Excise Tax)",
      "26:7426" : "26:7426 (26:7426 IRS: Wrongful Levy for Taxes)",
      "26:7429" : "26:7429 (26:7429 IRS: Tax Jeopardy Assessment)",
      "26:7609" : "26:7609 (26:7609 IRS: Petition to Quash IRS Summons)",
      "27:0185" : "27:0185 (27:185 Enforcement of Arbitration Award)",
      "28:0157c" : "28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)",
      "28:0157d" : "28:0157d (28:0157 Motion for Withdrawal of Reference)",
      "28:0158" : "28:0158 (28:0158 Bankruptcy Appeal from Judgment/Order)",
      "28:0185" : "28:0185 (28:185 Suit to Compel Arbitration)",
      "28:0451" : "28:0451 (28:451 Employment Discrimination)",
      "28:0754" : "28:0754 (28:754 Receiver of Property in Different Districts)",
      "28:0794" : "28:0794 (28:794 Rehabilitation Act)",
      "28:1001" : "28:1001 (28:1001 E.R.I.S.A.)",
      "28:1132" : "28:1132 (28:1132 E.R.I.S.A.)",
      "28:1330" : "28:1330 (28:1330 Breach of Contract)",
      "28:1331" : "28:1331 (28:1331 Fed. Question)",
      "28:1331al" : "28:1331al (28:1331 Fed. Question: Airline Crash)",
      "28:1331at" : "28:1331at (28:1331 Fed. Question: Anti-trust)",
      "28:1331au" : "28:1331au (28:1331 Fed. Question: Auto Negligence)",
      "28:1331b" : "28:1331b (28:1331 Federal Question: Bivens Act)",
      "28:1331bc" : "28:1331bc (28:1331 Fed. Question: Breach of Contract)",
      "28:1331ca" : "28:1331ca (28:1331 Fed Question: Fed Communications Act of 1)",
      "28:1331cm" : "28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)",
      "28:1331cv" : "28:1331cv (28:1331 Fed. Question: Civil Rights Violation)",
      "28:1331ed" : "28:1331ed (28:1331 Fed. Question: Employment Discrimination)",
      "28:1331ej" : "28:1331ej (28:1331 Federal Question: Enforcement of Judgment)",
      "28:1331es" : "28:1331es (28:1331 Enforcement of Administrative Subpoena)",
      "28:1331fl" : "28:1331fl (28:1331 Fed. Question: Fair Labor Standards)",
      "28:1331in" : "28:1331in (28:1331 Fed. Question: Insurance Contract)",
      "28:1331mm" : "28:1331mm (28:1331 Fed. Question: Medical Malpractice)",
      "28:1331ng" : "28:1331ng (28:1331 Fed. Question: Natural Gas Act)",
      "28:1331pi" : "28:1331pi (28:1331 Fed. Question: Personal Injury)",
      "28:1331rd" : "28:1331rd (28:1331 Fed. Question: Review Agency Decision)",
      "28:1331rp" : "28:1331rp (28:1331(a) Fed. Question: Real Property)",
      "28:1331rr" : "28:1331rr (28:1331 Fed. Question: Railway Labor Act)",
      "28:1331sv" : "28:1331sv (28:1331 Fed. Question: Securities Violation)",
      "28:1331tr" : "28:1331tr (28:1331 Fed. Question: Trademark)",
      "28:1331tt" : "28:1331tt (28:1331 Fed. Question: Tort Action)",
      "28:1331v" : "28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendment)",
      "28:1331wl" : "28:1331wl (28:1331 Federal Question: EPA Waste Lien)",
      "28:1331wt" : "28:1331wt (28:1331 Fed. Question: Water Rights)",
      "28:1332ac" : "28:1332ac (28:1332 Diversity-Account Receivable)",
      "28:1332al" : "28:1332al (28:1332 Diversity-Airline Crash)",
      "28:1332as" : "28:1332as (28:1332 Diversity-Asbestos Litigation)",
      "28:1332au" : "28:1332au (28:1332 Diversity-Auto Negligence)",
      "28:1332bc" : "28:1332bc (28:1332 Diversity-Breach of Contract)",
      "28:1332co" : "28:1332co (28:1332 Diversity-Conversion)",
      "28:1332ct" : "28:1332ct (28:1332 Diversity-(Citizenship))",
      "28:1332det" : "28:1332det (28:1332 Diversity: Forcible Detainer)",
      "28:1332df" : "28:1332df (28:1332 Diversity-Contract Default)",
      "28:1332ds" : "28:1332ds (28:1332 Diversity-Contract Dispute)",
      "28:1332ed" : "28:1332ed (28:1332 Diversity-Employment Discrimination)",
      "28:1332fd" : "28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)",
      "28:1332fr" : "28:1332fr (28:1332 Diversity-Fraud)",
      "28:1332ia" : "28:1332ia (28:1332 Diversity-Interpleader Action)",
      "28:1332ij" : "28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)",
      "28:1332in" : "28:1332in (28:1332 Diversity-Insurance Contract)",
      "28:1332jd" : "28:1332jd (28:1332 Diversity-Declaratory Judgment)",
      "28:1332lb" : "28:1332lb (28:1332 Diversity-Libel, Assault, Slander)",
      "28:1332lm" : "28:1332lm (28:1332 Diversity - Legal Malpractice)",
      "28:1332ma" : "28:1332ma (28:1332 Diversity-Miller Act)",
      "28:1332mm" : "28:1332mm (28:1332 Diversity-Medical Malpractice)",
      "28:1332mv" : "28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)",
      "28:1332ni" : "28:1332ni (28:1332 Diversity-Negotiable Instrument)",
      "28:1332nm" : "28:1332nm (28:1332 Diversity-Non-Motor Vehicle)",
      "28:1332nr" : "28:1332nr (28:1332 Diversity-Notice of Removal)",
      "28:1332oc" : "28:1332oc (28:1332 Diversity-Other Contract)",
      "28:1332pd" : "28:1332pd (28:1332 Diversity-Property Damage)",
      "28:1332pi" : "28:1332pi (28:1332 Diversity-Personal Injury)",
      "28:1332pl" : "28:1332pl (28:1332 Diversity-Product Liability)",
      "28:1332pr" : "28:1332pr (28:1332 Diversity-Petition for Removal)",
      "28:1332qt" : "28:1332qt (28:1332 Diversity-Petition to Quiet Title)",
      "28:1332ri" : "28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)",
      "28:1332sa" : "28:1332sa (28:1332 - Diversity: Securities & Exchange Commiss)",
      "28:1332sf" : "28:1332sf (28:1332 - Diversity: Securities Fraud)",
      "28:1332ss" : "28:1332ss (28:1332 Diversity - Stockholders Suits)",
      "28:1332tl" : "28:1332tl (28:1332 Diversity-Torts to Land)",
      "28:1332tm" : "28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))",
      "28:1332tn" : "28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)",
      "28:1332wd" : "28:1332wd (28:1332 Diversity-Wrongful Death)",
      "28:1333" : "28:1333 (28:1333 Admiralty)",
      "28:1334" : "28:1334 (28:1334 Bankruptcy Appeal)",
      "28:1334c" : "28:1334c (28:1334(c) R&R re motions for abstention (non-cor)",
      "28:1335" : "28:1335 (28:1335 Interpleader Action)",
      "28:1337" : "28:1337 (28:1337 Sherman-Clayton Act)",
      "28:1338cp" : "28:1338cp (28:1338 Copyright Infringement)",
      "28:1338pt" : "28:1338pt (28:1338 Patent Infringement)",
      "28:1338tr" : "28:1338tr (28:1338 Trademark Infringement)",
      "28:1340" : "28:1340 (28:1340 IRS: Custom Duties)",
      "28:1340er" : "28:1340er (28:1340 Recovery of Erroneous Refund)",
      "28:1341" : "28:1341 (28:1341 Complaint for Forfeiture)",
      "28:1343" : "28:1343 (28:1343 Violation of Civil Rights)",
      "28:1345" : "28:1345 (28:1345 USA Plaintiff)",
      "28:1345co" : "28:1345co (28:1345 Replevin & Conversion)",
      "28:1345db" : "28:1345db (28:1345 Debt to US - FHA/HUD Title I)",
      "28:1345df" : "28:1345df (28:1345 Default of Promissory Note)",
      "28:1345er" : "28:1345er (28:1345 Recovery of Erroneous Refund)",
      "28:1345fc" : "28:1345fc (28:1345 Foreclosure)",
      "28:1345ff" : "28:1345ff (28:1345 Complaint for Forfeiture)",
      "28:1345hl" : "28:1345hl (28:1345 VA Home Loan Guaranty Debt)",
      "28:1345mc" : "28:1345mc (28:1345 Medical Care Recovery)",
      "28:1345mi" : "28:1345mi (28:1345 Mining Claim Ejectment)",
      "28:1345pd" : "28:1345pd (28:1345 Property Damage)",
      "28:1345pe" : "28:1345pe (28:1345 VA Property Ejectment)",
      "28:1345rc" : "28:1345rc (28:1345 Recovery of Debt to US)",
      "28:1345ss" : "28:1345ss (28:1345 Recovery of SS Overpayment)",
      "28:1345st" : "28:1345st (28:1345 Default of Student Loan)",
      "28:1345tp" : "28:1345tp (28:1345 Trespass on Public Land)",
      "28:1345va" : "28:1345va (28:1345 Recovery of VA Overpayment)",
      "28:1346bc" : "28:1346bc (28:1346 Breach of Contract)",
      "28:1346rc" : "28:1346rc (28:1346 Recovery of IRS Tax)",
      "28:1346tc" : "28:1346tc (28:1346 Tort Claim)",
      "28:1346wd" : "28:1346wd (28:1346 Wrongful Death)",
      "28:1349" : "28:1349 (28:1348 Corporation organized under Federal Law as party)",
      "28:1352" : "28:1352 (28:1352 Miller Act)",
      "28:1355" : "28:1355 (28:1355 Petition for Return of Property)",
      "28:1358" : "28:1358 (28:1358 Land Condemnation)",
      "28:1361" : "28:1361 (28:1361 Petition for Writ of Mandamus)",
      "28:1362ic" : "28:1362ic (28:1362 Indian Tribal Controversy)",
      "28:1362iw" : "28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)",
      "28:1364" : "28:1364 (28:1364 Auto Negligence)",
      "28:1391" : "28:1391 (28:1391 Personal Injury)",
      "28:1402" : "28:1402 (28:1402 Medical Malpractice)",
      "28:1407" : "28:1407 (28:1407 Airline Crash)",
      "28:1441ac" : "28:1441ac (28:1441 Notice of Removal-Account Receivable)",
      "28:1441al" : "28:1441al (28:1441 Notice of Removal-Airline Crash)",
      "28:1441as" : "28:1441as (28:1441 Notice of Removal-Asbestos Litigation)",
      "28:1441au" : "28:1441au (28:1441 Notice of Removal-Auto Negligence)",
      "28:1441bc" : "28:1441bc (28:1441 Notice of Removal-Breach of Contract)",
      "28:1441cv" : "28:1441cv (28:1441 Petition for Removal- Civil Rights Act)",
      "28:1441df" : "28:1441df (28:1441 Notice of Removal-Contract Default)",
      "28:1441dj" : "28:1441dj (28:1441 Notice of Removal-Declaratory Judgment)",
      "28:1441ds" : "28:1441ds (28:1441 Notice of Removal-Contract Dispute)",
      "28:1441ed" : "28:1441ed (28:1441 Petition for Removal - Employment Discrim)",
      "28:1441fc" : "28:1441fc (28:1441 Petition for Removal - Fair Credit Reporti)",
      "28:1441fr" : "28:1441fr (28:1441 Notice of Removal-Fraud)",
      "28:1441ij" : "28:1441ij (28:1441 Notice of Removal-Injunctive/Declaratory Relief)",
      "28:1441in" : "28:1441in (28:1441 Notice of Removal-Insurance Contract)",
      "28:1441int" : "28:1441int (28:1441 Petition for Removal- Action for Interplea)",
      "28:1441lb" : "28:1441lb (28:1441 Notice of Removal-Libel, Assault, Slander)",
      "28:1441lm" : "28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relatio)",
      "28:1441mm" : "28:1441mm (28:1441 Notice of Removal-Medical Malpractice)",
      "28:1441ni" : "28:1441ni (28:1441 Notice of Removal-Negotiable Instrument)",
      "28:1441nm" : "28:1441nm (28:1441 Notice of Removal-Non-Motor Vehicle)",
      "28:1441nr" : "28:1441nr (28:1441 Diversity-Notice of Removal)",
      "28:1441oc" : "28:1441oc (28:1441 Petition For Removal--Other Contract)",
      "28:1441pd" : "28:1441pd (28:1441 Notice of Removal-Property Damage)",
      "28:1441pi" : "28:1441pi (28:1441 Notice of Removal-Personal Injury)",
      "28:1441pl" : "28:1441pl (28:1441 Notice of Removal-Product Liability)",
      "28:1441pr" : "28:1441pr (28:1441 Petition for Removal)",
      "28:1441qt" : "28:1441qt (28:1441 Notice of Removal-Petition to Quiet Title)",
      "28:1441ri" : "28:1441ri (28:1441 Petition for Removal- Racketeering (RICO))",
      "28:1441sa" : "28:1441sa (28:1441 - Petition for Removal: SEC Act)",
      "28:1441sf" : "28:1441sf (28:1441 - Petition for Removal: Securities Fraud)",
      "28:1441tl" : "28:1441tl (28:1441 Notice of Removal-Torts to Land)",
      "28:1441tm" : "28:1441tm (28:1441 Notice of Removal-Tort/Motor Vehicle (P.I.))",
      "28:1441tn" : "28:1441tn (28:1441 Notice of Removal-Tort/Non-Motor Vehicle)",
      "28:1441wd" : "28:1441wd (28:1441 Notice of Removal-Wrongful Death)",
      "28:1442bc" : "28:1442bc (28:1442 Notice of Removal-Breach of Contract)",
      "28:1442nr" : "28:1442nr (28:1442 Notice of Removal)",
      "28:1442pr" : "28:1442pr (28:1442 Petition for Removal)",
      "28:1443" : "28:1443 (28:1443(1) Rent, Lease & Ejectment)",
      "28:1444" : "28:1444 (28:1441 Notice of Removal-Foreclosure)",
      "28:1446in" : "28:1446in (28:1446 Breach of Contract- Insurance)",
      "28:1446nr" : "28:1446nr (28:1446 Notice of Removal)",
      "28:1446pd" : "28:1446pd (28:1446 Notice of Removal-Property Damage (P.I.))",
      "28:1446pi" : "28:1446pi (28:1446 Notice of Removal-Personal Injury)",
      "28:1446pl" : "28:1446pl (28:1446pl Petition for Removal - Product Liability)",
      "28:1446pr" : "28:1446pr (28:1446 Petition for Removal)",
      "28:1452" : "28:1452 (28:1452 Removal of Claim in Civil Action Related to BK. Case)",
      "28:1651" : "28:1651 (28:1651 Petition for Writ of Coram Nobis)",
      "28:1651hc" : "28:1651hc (28:1651 Petition for Writ of Habeas Corpus)",
      "28:1651mn" : "28:1651mn (28:1651 Petition for Writ of Mandamus)",
      "28:1782" : "28:1782 (28:1782 Letter rogatory - appointment)",
      "28:1963" : "28:1963 (28:1963 Registration of Judgments for Enforcement in Other Districts)",
      "28:1983" : "28:1983 (28:1983 Civil Rights)",
      "28:2201" : "28:2201 (28:2201 Constitutionality of State Statute(s))",
      "28:2201dj" : "28:2201dj (28:2201 Declaratory Judgment)",
      "28:2201ij" : "28:2201ij (28:2201 Injunction)",
      "28:2201in" : "28:2201in (28:2201 Declaratory Judgment (Insurance))",
      "28:2241" : "28:2241 (28:2241 Petition for Writ of Habeas Corpus (Federal))",
      "28:2243" : "28:2243 (28:2243 Petition for Writ of Habeas Corpus (Issuance of Writ))",
      "28:2254" : "28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))",
      "28:2254se" : "28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)",
      "28:2255" : "28:2255 (28:2255 Motion to Vacate Sentence)",
      "28:2271" : "28:2271 (28:2271 Federal Tort Claims Act)",
      "28:2345" : "28:2345 (28:2345 Medicare Recovery)",
      "28:2409" : "28:2409 (28:2409(a) Quiet Title Action)",
      "28:2410" : "28:2410 (Actions affecting property on which United States had lien)",
      "28:2671" : "28:2671 (28:2671 Federal Tort Claims Act)",
      "28:2674" : "28:2674 (28:2674 Federal Tort Claims Act)",
      "28:3001" : "28:3001 (28:3001 Federal Debt Collection Act)",
      "28:7402" : "28:7402 (28:7402 Refund of Taxes)",
      "28:7422" : "28:7422 (28:7422 Appeal from Administrative Decision)",
      "29:0151" : "29:0151 (29:151 Labor: Review of Agency Action)",
      "29:0160" : "29:0160 (29:160(1) National Labor Relations Act)",
      "29:0184" : "29:0184 (29:184 Violation Collection Bargain Agreement)",
      "29:0185ep" : "29:0185ep (29:185 Employee Pension Plan)",
      "29:0185lm" : "29:0185lm (29:185 Labor/Mgt. Relations (Contracts))",
      "29:0201do" : "29:0201do (29:0201 Denial of Overtime Compensation)",
      "29:0201fl" : "29:0201fl (29:201 Fair Labor Standards Act)",
      "29:0203" : "29:0203 (29:203 Equal Pay Act)",
      "29:0206" : "29:0206 (29:206 Collect Unpaid Wages)",
      "29:0401" : "29:0401 (29:0401 Labor Management Disclosure Act)",
      "29:0621" : "29:0621 (29:621 Job Discrimination (Age))",
      "29:0623" : "29:0623 (29:623 Job Discrimination (Age))",
      "29:0626" : "29:0626 (29:626 Job Discrimination (Age))",
      "29:0633" : "29:0633 (29:633 Job Discrimination (Age))",
      "29:0651" : "29:0651 (29:651 Occupational Safety/Health)",
      "29:0754" : "29:0754 (29:754 Discrimination)",
      "29:0791" : "29:0791 (29:791 Job Discrimination (Rehabilitation Act))",
      "29:0794" : "29:0794 (29:0794 Job Discrimination (Handicap))",
      "29:1001" : "29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)",
      "29:1002" : "29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)",
      "29:1104" : "29:1104 (29:1104 Recovery of Benefits to Employee)",
      "29:1109" : "29:1109 (29:1109 Breach of Fiduciary Duties)",
      "29:1131" : "29:1131 (29:1131 ERISA - Collection of Delinquent Trust Funds)",
      "29:1132" : "29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)",
      "29:1145" : "29:1145 (29:1145 E.R.I.S.A.)",
      "29:1149" : "29:1149 (29:1149 Recover Pension & Profit Sharing)",
      "29:1337" : "29:1337 (29:1337 E.R.I.S.A.)",
      "29:1362" : "29:1362 (29:1362 ERISA)",
      "29:1381" : "29:1381 (29:1381 E.R.I.S.A.)",
      "29:1401" : "29:1401 (29:1401(b)(2) Appeal of Arbitration Award)",
      "29:1451" : "29:1451 (29:1451 E.R.I.S.A.)",
      "29:1801" : "29:1801 (29:1801 Farmworker Rights)",
      "29:2615" : "29:2615 (29:2615 Family and Medical Leave Act of 1993)",
      "29:790" : "29:790 (29:790 Rehabilitation of Labor)",
      "30:0181" : "30:0181 (30:181 Environment: Review of Agency Action)",
      "30:0801" : "30:0801 (30:0801 Penalities/Federal Mine Safety Health Act)",
      "30:1201" : "30:1201 (30:1201 Environment: Review of Agency Action)",
      "30:1202" : "30:1202 (30:1202 Mining Reclamation Act)",
      "30:1276" : "30:1276 (30:1276 Interior: Review of Agency Action)",
      "31:3545" : "31:3545 (31:3545 Action to Recovery Money)",
      "31:3729" : "31:3729 (31:3729 False Claims Act)",
      "31:3730" : "31:3730 (31:3730 Qui Tam False Claims Act)",
      "31:3731" : "31:3731 (31:3731 Fraud)",
      "33:1319cw" : "33:1319cw (33:1319 Clean Water Act)",
      "33:1319pv" : "33:1319pv (33:1319 Pollutants & Permit Violations)",
      "33:1365" : "33:1365 (33:1365 Environmental Matters)",
      "35:0145" : "35:0145 (35:145 Patent Infringement)",
      "35:0183" : "35:0183 (35:183 Patent Infringement)",
      "35:0271" : "35:0271 (35:271 Patent Infringement)",
      "38:1681" : "38:1681 (38:1681 Recovery of VA Overpayment)",
      "38:1686" : "38:1686 (38:1686 Recovery of VA Overpayment)",
      "38:1780" : "38:1780 (38:1780 Recovery of VA Overpayment)",
      "38:2011" : "38:2011 (38:2011 - Veteran's Readjustment Assistance Act of)",
      "38:2021" : "38:2021 (Right to re-employment of inducted persons)",
      "38:3116" : "38:3116 (38:3116 VA Overpayment)",
      "38:4323" : "38:4323 (USERRA Enforcement of Rights with Respect to a State or Private Employer)",
      "38:775" : "38:775 (Recovery of Servicemen's Group Life Insurance)",
      "39:3005" : "39:3005 (39:3005 Detention of Mail for Temporary Periods)",
      "39:409" : "39:409 (39:409 Postal Service)",
      "40:0258" : "40:0258 (40:258(a) Public Buildings & Property: Land Condemnation)",
      "40:0270" : "40:0270 (40:270 Miller Act)",
      "40:0875" : "40:0875 (40:875 Public Buildings & Property: Negligence)",
      "41:0251" : "41:0251 (41:251 Public Contracts-Review of Agency Action)",
      "41:1463" : "41:1463 (41:1463 Public Contracts: Unlawful Employment Practices)",
      "42:0205" : "42:0205 (42:205 Denial Social Security Benefits)",
      "42:0206" : "42:0206 (42:206 Social Security Benefits)",
      "42:0247" : "42:0247 (42:247 Personal Injury-Swine Flu)",
      "42:0402" : "42:0402 (42:402 Social Security Benefits)",
      "42:0405id" : "42:0405id (42:0405 Review of HHS Decision (SSID))",
      "42:0405wc" : "42:0405wc (42:405 Review of HHS Decision (DIWC))",
      "42:0405ww" : "42:0405ww (42:405 Review of HHS Decision (DIWW))",
      "42:0416" : "42:0416 (42:416 Denial of Social Security Benefits)",
      "42:0427" : "42:0427 (42:427 Social Security Benefits)",
      "42:11603" : "42:11603 (42:11603 International Child Abduction Remedies Act)",
      "42:1383" : "42:1383 (42:1383 Review of SSA Decision)",
      "42:1395" : "42:1395 (42:1395 HHS: Adverse Reimbursement Review)",
      "42:1396" : "42:1396 (42:1396 - Tort Negligence)",
      "42:1471" : "42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclo)",
      "42:1973" : "42:1973 (42:1973 Denial or abridgement of right to vote re: race/color voting qualifications)",
      "42:1981cv" : "42:1981cv (42:1981 Civil Rights)",
      "42:1981hs" : "42:1981hs (42:1981 Housing Discrimination)",
      "42:1981jb" : "42:1981jb (42:1981 Job Discrimination (Race))",
      "42:1981sx" : "42:1981sx (42:1981 Sex Discrimination)",
      "42:1983cv" : "42:1983cv (42:1983 Civil Rights Act)",
      "42:1983ed" : "42:1983ed (42:1983 Civil Rights (Employment Discrimination))",
      "42:1983pr" : "42:1983pr (42:1983 Prisoner Civil Rights)",
      "42:1986" : "42:1986 (42:1986 Neglect of Duty)",
      "42:2000ag" : "42:2000ag (42:2000 Job Discrimination (Age))",
      "42:2000e" : "42:2000e (42:2000e Job Discrimination (Employment))",
      "42:2000pb" : "42:2000pb (42:2000 Job Discrimination (Public Accommodations))",
      "42:2000ra" : "42:2000ra (42:2000 Job Discrimination (Race))",
      "42:2000sx" : "42:2000sx (42:2000 Job Discrimination (Sex))",
      "42:2003" : "42:2003 (42:2003 Job Discrimination)",
      "42:2005" : "42:2005 (42:2005 Review of Agency Action-HHS)",
      "42:2011" : "42:2011 (42:2011 Development and Control of Atomic Energy)",
      "42:2615" : "42:2615 (42:2616 Medical Recovery Act)",
      "42:2651" : "42:2651 (42:2651 Medical Care Recovery)",
      "42:3601" : "42:3601 (42:3601 Fair Housing Act)",
      "42:4000" : "42:4000 (42:4000 National Flood Insurance Act)",
      "42:4001" : "42:4001 (42:4001 National Insurance Flood Act)",
      "42:404" : "42:404 (42:404 Overpayments and Underpayments)",
      "42:4053" : "42:4053 (42:4053 Breach of Insurance Contract)",
      "42:4072" : "42:4072 (42:4072 Payment of Flood Insurance Claim)",
      "42:4321" : "42:4321 (42:4321 Review of Agency Action-Environment)",
      "42:4332" : "42:4332 (42:4332)",
      "42:6901en" : "42:6901en (42:6901 Environmental Cleanup Expenses)",
      "42:6901rs" : "42:6901rs (42:6901 Resource & Recovery Act)",
      "42:7413" : "42:7413 (42:7413(b) Clean Air Act)",
      "42:7604cl" : "42:7604cl (42:7604 Clear Air Act (Emission Standards))",
      "42:7604ir" : "42:7604ir (42:7604 Petition to Quash IRS Summons)",
      "42:9607" : "42:9607 (42:9607 Real Property Tort to Land)",
      "43:945" : "43:945 (43:945 Compensation for Land Condemnation)",
      "43:945a" : "43:945a (43:945a Complaint in Condemnation)",
      "43:946" : "43:946 (43:946 Complaint in Condemnation - Eminent Domain)",
      "45:0051" : "45:0051 (45:51 Railways: Fed. Employer's Liability Act)",
      "45:0151" : "45:0151 (45:151 Railway Labor Act)",
      "45:0184" : "45:0184 (45:184 Action to Set Aside Award of a System Board of Adjust)",
      "45:1395" : "45:1395 (45:1395 Railroads: Adverse Reimbursement Review)",
      "45:7457" : "45:7457 (45:7457 Compel Reclamation Under Clear Air Act)",
      "46:0305" : "46:0305 (46:305 Exoneration and Limitation of Liability)",
      "46:0688" : "46:0688 (46:688 Jones Act)",
      "46:0741" : "46:0741 (46:741 Shipping)",
      "46:0761" : "46:0761 (46:761 Shipping: Damages for Death on High Seas)",
      "46:1101" : "46:1101 (46:1101 Violation of Maritime Regulations)",
      "46:1156" : "46:1156 (46:1156 Administrative Procedure Act)",
      "47:0151" : "47:0151 (47:151 Federal Communications Commission Act)",
      "48:0883" : "48:0883 (48:883 Violation of US Coastal Law)",
      "48:1985" : "48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)",
      "49:0081" : "49:0081 (49:81 Damaged Goods While Being Transported)",
      "49:0781" : "49:0781 (49:781 Forfeiture)",
      "49:11503" : "49:11503 (49:11503 Railroad Revitalization Regulatory Reform)",
      "49:11702" : "49:11702 (49:11702(a)(4) Violations of Interstate Commerce A)",
      "49:1471" : "49:1471 (49:1471 Federal Aviation Act)",
      "49:1903" : "49:1903 (49:1903 Petition to enforce administrative summon)",
      "8:287" : "8:287 (8:287 Petition to Enforce INS Subpoena)",
      "99:9999" : "99:9999 (99:9999 Report cause code (DO NOT DELETE!))",
      "adsup" : "adsup (Administrative Subpoena)",
      "contempt" : "contempt (Contempt Proceedings)",
      "disbar" : "disbar (Disbarment Proceedings)",
      "fordepo" : "fordepo (Foreign Deposition)",
      "misc" : "misc (Civil Miscellaneous Case)",
      "motcomp" : "motcomp (Motion to Compel)",
      "motquash" : "motquash (Motion to Quash)",
      "motret" : "motret (Motion for Return of Property)",
      "petenf" : "petenf (Petition to Enforce IRS Summons)",
      "petper" : "petper (Petition to Perpetuate Testimony)",
      "regjgm" : "regjgm (Registration of Foreign Judgment)",
      "tranbkref" : "tranbkref (Transmission of Bankruptcy Reference)",
      "tranff" : "tranff (Transmission of Proposed Findings of Fact and Concl. of Law)",
      "writgar" : "writgar (Application for a Writ of Garnishment)"
   },
   "waedce" : {
      "0" : "0 (No cause code entered)",
      "00:0000" : "00:0000 (00:0000 Cause Code Unknown)",
      "02:0431" : "02:0431 (02:431 Fed. Election Commission: Failure Enforce C)",
      "02:0437" : "02:0437 (02:437 Federal Election Commission)",
      "05:0075" : "05:0075 (05:75(2) Contract - Reduction in Grade)",
      "05:0551" : "05:0551 (05:551 Administrative Procedure Act)",
      "05:0552fi" : "05:0552fi (05:552 Freedom of Information Act)",
      "05:0552pa" : "05:0552pa (05:552 Right to Privacy Act)",
      "05:0554" : "05:0554 (05:0554 Adjudications Required by Statutes)",
      "05:0701" : "05:0701 (05:0701 Judicial Review of Agency Decision)",
      "05:0702" : "05:0702 (05:702 Administrative Procedure Act - Right of Review)",
      "05:0704" : "05:0704 (05:704 Labor Litigation)",
      "05:7703" : "05:7703 (05:7703 Discrimination - Review of Agency Act)",
      "07:0006" : "07:0006 (7:6(b) Federal Commodity Exchange Regulation)",
      "07:0025" : "07:0025 (7:25 Fraud - Commodities Leverage Contracts)",
      "07:0181" : "07:0181 (07:181 Packers & Stockyard Act)",
      "07:0215" : "07:0215 (07:0215 Packers and Stockyards Act)",
      "07:0499" : "07:0499 (07:499 Agricultural Commodities Act)",
      "07:0601" : "07:0601 (07:601 USDA Condemnation)",
      "07:1508" : "07:1508 (7:1508 Crop Insurance)",
      "07:2321" : "07:2321 (07:2321 Plant Variety Protection Act)",
      "08:1105" : "08:1105 (8:1105(a) Aliens: Habeas Corpus to Release INS Det)",
      "08:1252" : "08:1252 (08:1252(a)(2) Injunction for Deportation)",
      "08:1260" : "08:1260 (08:1260 Aliens: Access to Records)",
      "08:1304" : "08:1304 (08:1304 U.S. Immigration Act)",
      "08:1324" : "08:1324 (08:1324 Aliens: Complaint for Forfeiture)",
      "08:1329" : "08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petiti)",
      "08:1446" : "08:1446 (8:1446 Petition for Naturalization Hearing)",
      "08:1447" : "08:1447 (8:1447 - Request for Hearing on Denial of Application for Naturalization)",
      "09:0001" : "09:0001 (09:1 U.S. Arbitration Act)",
      "09:0009" : "09:0009 (9:9 Motion to Confirm Arbitration Loan)",
      "09:0010" : "09:0010 (09:0010 Petition to Vacate Arbitration Award)",
      "10:1552" : "10:1552 (10:1552 Armed Forces: Action to Correct Records)",
      "10:1553" : "10:1553 (10:1553 Armed Forces: FOIA General)",
      "10:2305" : "10:2305 (10:2305 Review of Federal Contract)",
      "11:0101" : "11:0101 (11:101 Bankruptcy)",
      "12:0022" : "12:0022 (12:22 Securities Fraud)",
      "12:0635" : "12:0635 (12:635 Breach of Insurance Contract)",
      "12:1461" : "12:1461 (12:1461 Homeowners Loan Act)",
      "12:1703" : "12:1703 (12:1703 Default of HUD Loan)",
      "12:1725" : "12:1725 (12:1725 Collection under Contract Guaranty)",
      "12:1730" : "12:1730 (12:1730 Collection Under Contract Guaranty)",
      "12:1801fd" : "12:1801fd (Breach of fiduciary duty)",
      "12:1819" : "12:1819 (12:1819 Default of Promissory Note)",
      "12:1821" : "12:1821 (12:1821 Default of Loan by Promissary Note)",
      "12:1971" : "12:1971 (12:1971 Relief under Bank Holding Act)",
      "12:3410" : "12:3410 (12:3410 Right to Financial Privacy Act)",
      "12:5201" : "12:5201 (12:5201 Emergency Economic Stabilization Act)",
      "12:5220" : "12:5220 (12:5220 Assistance to homeowners)",
      "15:0001" : "15:0001 (15:1 Antitrust Litigation)",
      "15:0002at" : "15:0002at (15:2 Antitrust Litigation)",
      "15:0002fl" : "15:0002fl (15:2(a) Fair Labor Standards Act)",
      "15:0005" : "15:0005 (15:5(a) Fair Labor Standards Act)",
      "15:0015" : "15:0015 (15:15 Antitrust Litigation)",
      "15:0025" : "15:0025 (15:25 Clayton Act)",
      "15:0044" : "15:0044 (15:44 Trademark Infringement)",
      "15:0045" : "15:0045 (15:0045 Federal Trade Commission Act)",
      "15:0052" : "15:0052 (15:0052 Federal Trade Commission Act)",
      "15:0053" : "15:0053 (15:0053 Federal Trade Commission Act)",
      "15:0077" : "15:0077 (15:77 Securities Fraud)",
      "15:0078" : "15:0078 (15:78m(a) Securities Exchange Act)",
      "15:0631" : "15:0631 (15:631 Small Business Act)",
      "15:0717" : "15:0717 (15:717 Natural Gas Act)",
      "15:1051" : "15:1051 (15:1051 Trademark Infringement)",
      "15:1114" : "15:1114 (15:1114 Trademark Infringement)",
      "15:1121" : "15:1121 (15:1121 Trademark Infringement)",
      "15:1125" : "15:1125 (15:1125 Trademark Infringement (Lanham Act))",
      "15:1126" : "15:1126 (15:1126 Patent Infringement)",
      "15:1127" : "15:1127 (15:1127 Trademark Infringement)",
      "15:1222" : "15:1222 (15:1222 Auto Dealer Franchise Protection Act)",
      "15:1601" : "15:1601 (15:1601 Truth in Lending)",
      "15:1640" : "15:1640 (15:1640 Truth in Lending)",
      "15:1681" : "15:1681 (15:1681 Fair Credit Reporting Act)",
      "15:1692" : "15:1692 (15:1692 Fair Debt Collection Act)",
      "15:1938" : "15:1938 (15:1938 Fair Labor Standards Act)",
      "15:1981" : "15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))",
      "15:1988" : "15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))",
      "15:1989" : "15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))",
      "15:2301" : "15:2301 (15:2301 Magnuson-Moss Warranty Act)",
      "15:2801" : "15:2801 (15:2801 Petroleum Marketing Practices Act)",
      "15:53(b)" : "15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equita)",
      "15:7701" : "15:7701 (15:7701 CAN-SPAM Act)",
      "16:0544" : "16:0544 (15:0544 Conservation Columbia River Gorge)",
      "16:0668" : "16:0668 (16:668 Bald Eagle Protection Act)",
      "16:0703" : "16:0703 (16:703 Migratory Bird Act)",
      "16:0814" : "16:0814 (16:0814 Exercise by Licensee of Power of Eminent Domain)",
      "16:1538" : "16:1538 (16:1538 Endangered Species Act)",
      "16:3371" : "16:3371 (16:3371 Wildlife Under the Lacey Act)",
      "16:3372" : "16:3372 (16:3372 Conservation: Complaint for Forfeiture)",
      "16:3373" : "16:3373 (16:3373 Appeal of Decision - DOI)",
      "16:3374" : "16:3374 (16:3374 Conservation: Complaint for Forfeiture)",
      "17:0101" : "17:0101 (17:101 Copyright Infringement)",
      "17:0501" : "17:0501 (17:501 Copyright Infringement)",
      "17:0504" : "17:0504 (17:504 Copyright Infringement)",
      "18:0241" : "18:0241 (18:241 Conspiracy Against Citizen Rights)",
      "18:1514" : "18:1514 (18:1514 Temporary Restraining Order)",
      "18:1836a" : "18:1836a (18:1836(a) Injunction against Misappropriation of Trade Secrets)",
      "18:1836b" : "18:1836b (18:1836(b) Civil Action to Protect Trade Secrets)",
      "18:1961" : "18:1961 (18:1961 Racketeering (RICO) Act)",
      "18:1962" : "18:1962 (18:1962 Racketeering (RICO) Act)",
      "18:1964" : "18:1964 (18:1964 Racketeering (RICO) Act)",
      "18:2344" : "18:2344 (18:2344 Forfeiture of Contraband Cigarettes)",
      "18:2701" : "18:2701 (18:2701 Violation of Stored Electronic Communications Act)",
      "18:2724" : "18:2724 (18:2724 Civil Action - Motor Vehicle Records)",
      "18:4208" : "18:4208 (18:4208(B) Agency Action Review)",
      "18:924" : "18:924 (18:924 Forfeiture)",
      "18:925A" : "18:925A (18:925A Erroneous Denial of a Firearm)",
      "18:981" : "18:981 (18:981 Civil Forfeiture)",
      "19:1305" : "19:1305 (19:1305 Custom Duties:0Forfeiture-Immoral Articles)",
      "20:1080" : "20:1080 (20:1080 Student Loan Recovery)",
      "20:1400" : "20:1400 (20:1400 Civil Rights of Handicapped Child)",
      "20:1401" : "20:1401 (20:1401 Education: Handicapped Child Act)",
      "20:1415" : "20:1415 (20:1415 INDIVIDUALS WITH DISABILITIES EDUCATION ACT (IDEA))",
      "21:0801" : "21:0801 (21:801 Comprehensive Drug Abuse Prevention/Control Act 1970)",
      "21:0841" : "21:0841 (21:841 Forfeiture Property-Drugs)",
      "21:0881" : "21:0881 (21:881 Forfeiture Property-Drugs)",
      "21:0881a" : "21:0881a (21:881 Forfeiture Property - Aircraft)",
      "21:0881re" : "21:0881re (21:881 Forfeiture Property - Real Estate)",
      "23:0134" : "23:0134 (23:134 P.I.- Auto Negligence)",
      "23:1441" : "23:1441 (23:1441 Contract Real Estate)",
      "24:1000" : "24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)",
      "25:0640" : "25:0640 (25:640 Indian Tribal Rights)",
      "25:1302" : "25:1302 (25:1302 Indian Civil Rights)",
      "25:1901" : "25:1901 (25:1901 Indian Child Welfare Act)",
      "25:2701" : "25:2701 (25:2701 Indian Gaming Regulatory Act (IGRA))",
      "26:6212" : "26:6212 (26:6212 Injunctive Relief from IRS Lien)",
      "26:6213" : "26:6213 (26:6213 Injunctive Relief from IRS Lien)",
      "26:6334" : "26:6334 (26:6334 IRS: Property Exempt from Levy)",
      "26:6502" : "26:6502 (26:6502 IRS:Enforcement of tax liens)",
      "26:6532" : "26:6532 (26:6532 IRS: Refund of Tax Penalty)",
      "26:6702" : "26:6702 (26:6702 IRS: Refund of Income Tax Penalty)",
      "26:6703" : "26:6703 (26:6703 IRS: Refund of Tax Penalty)",
      "26:7401" : "26:7401 (26:7401 IRS: Tax Liability)",
      "26:7402" : "26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)",
      "26:7403" : "26:7403 (26:7403 Suit to Enforce Federal Tax Lien)",
      "26:7421a" : "26:7421a (IRS - Action by taxpayer)",
      "26:7422rt" : "26:7422rt (26:7422 IRS: Refund Taxes)",
      "26:7422rx" : "26:7422rx (26:7422 IRS: Refund Excise Tax)",
      "26:7426" : "26:7426 (26:7426 IRS: Wrongful Levy for Taxes)",
      "26:7429" : "26:7429 (26:7429 IRS: Tax Jeopardy Assessment)",
      "26:7604" : "26:7604 (26:7604 Petition to Enforce an IRS Summons)",
      "26:7609" : "26:7609 (26:7609 IRS: Petition to Quash IRS Summons)",
      "27:0185" : "27:0185 (27:185 Enforcement of Arbitration Award)",
      "28:0157c" : "28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)",
      "28:0157d" : "28:0157d (28:0157 Motion for Withdrawal of Reference)",
      "28:0158" : "28:0158 (28:0158 Notice of Appeal re Bankruptcy Matter (BA)",
      "28:0185" : "28:0185 (28:185 Suit to Compel Arbitration)",
      "28:0451" : "28:0451 (28:451 Employment Discrimination)",
      "28:0794" : "28:0794 (28:794 Rehabilitation Act)",
      "28:1001" : "28:1001 (28:1001 E.R.I.S.A.)",
      "28:1132" : "28:1132 (28:1132 E.R.I.S.A.)",
      "28:1330" : "28:1330 (28:1330 Breach of Contract)",
      "28:1331" : "28:1331 (28:1331 Fed. Question)",
      "28:1331al" : "28:1331al (28:1331 Fed. Question: Airline Crash)",
      "28:1331at" : "28:1331at (28:1331 Fed. Question: Anti-trust)",
      "28:1331au" : "28:1331au (28:1331 Fed. Question: Auto Negligence)",
      "28:1331b" : "28:1331b (28:1331 Federal Question: Bivens Act)",
      "28:1331bc" : "28:1331bc (28:1331 Fed. Question: Breach of Contract)",
      "28:1331ca" : "28:1331ca (28:1331 Fed Question: Fed Communications Act of 1)",
      "28:1331cm" : "28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)",
      "28:1331cv" : "28:1331cv (28:1331 Federal Question: Other Civil Rights)",
      "28:1331ed" : "28:1331ed (28:1331 Fed. Question: Employment Discrimination)",
      "28:1331es" : "28:1331es (28:1331 Enforcement of Administrative Subpoena)",
      "28:1331ev" : "28:1331ev (28:1331ev Fed. Question: Environment)",
      "28:1331fl" : "28:1331fl (28:1331 Fed. Question: Fair Labor Standards)",
      "28:1331in" : "28:1331in (28:1331 Fed. Question: Insurance Contract)",
      "28:1331mm" : "28:1331mm (28:1331 Fed. Question: Medical Malpractice)",
      "28:1331pi" : "28:1331pi (28:1331 Fed. Question: Personal Injury)",
      "28:1331rd" : "28:1331rd (28:1331 Fed. Question: Review Agency Decision)",
      "28:1331rp" : "28:1331rp (28:1331(a) Fed. Question: Real Property)",
      "28:1331rr" : "28:1331rr (28:1331 Fed. Question: Railway Labor Act)",
      "28:1331sv" : "28:1331sv (28:1331 Fed. Question: Securities Violation)",
      "28:1331tr" : "28:1331tr (28:1331 Fed. Question: Trademark)",
      "28:1331tt" : "28:1331tt (28:1331 Fed. Question: Tort Action)",
      "28:1331v" : "28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendme)",
      "28:1331wl" : "28:1331wl (28:1331 Federal Question: EPA Waste Lien)",
      "28:1331wt" : "28:1331wt (28:1331 Fed. Question: Water Rights)",
      "28:1332" : "28:1332 (28:1332 Diversity)",
      "28:1332ac" : "28:1332ac (28:1332 Diversity-Account Receivable)",
      "28:1332al" : "28:1332al (28:1332 Diversity-Airline Crash)",
      "28:1332as" : "28:1332as (28:1332 Diversity-Asbestos Litigation)",
      "28:1332au" : "28:1332au (28:1332 Diversity-Auto Negligence)",
      "28:1332bc" : "28:1332bc (28:1332 Diversity-Breach of Contract)",
      "28:1332co" : "28:1332co (28:1332 Diversity-Conversion)",
      "28:1332ct" : "28:1332ct (28:1332 Diversity-(Citizenship))",
      "28:1332det" : "28:1332det (28:1332 Diversity: Forcible Detainer)",
      "28:1332df" : "28:1332df (28:1332 Diversity-Contract Default)",
      "28:1332ds" : "28:1332ds (28:1332 Diversity-Contract Dispute)",
      "28:1332ed" : "28:1332ed (28:1332 Diversity-Employment Discrimination)",
      "28:1332fd" : "28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)",
      "28:1332fr" : "28:1332fr (28:1332 Diversity-Fraud)",
      "28:1332ia" : "28:1332ia (28:1332 Diversity-Interpleader Action)",
      "28:1332ij" : "28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)",
      "28:1332in" : "28:1332in (28:1332 Diversity-Insurance Contract)",
      "28:1332jd" : "28:1332jd (28:1332 Diversity-Declaratory Judgement)",
      "28:1332lb" : "28:1332lb (28:1332 Diversity-Libel,Assault,Slander)",
      "28:1332lm" : "28:1332lm (28:1332 Diversity - Legal Malpractice)",
      "28:1332ma" : "28:1332ma (28:1332 Diversity-Miller Act)",
      "28:1332mm" : "28:1332mm (28:1332 Diversity-Medical Malpractice)",
      "28:1332mv" : "28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)",
      "28:1332ni" : "28:1332ni (28:1332 Diversity-Negotiable Instrument)",
      "28:1332nm" : "28:1332nm (28:1332 Diversity-Non-Motor Vehicle)",
      "28:1332oc" : "28:1332oc (28:1332 Diversity-Other Contract)",
      "28:1332pd" : "28:1332pd (28:1332 Diversity-Property Damage)",
      "28:1332pi" : "28:1332pi (28:1332 Diversity-Personal Injury)",
      "28:1332pl" : "28:1332pl (28:1332 Diversity-Product Liability)",
      "28:1332pr" : "28:1332pr (28:1332 Diversity-Petition for Removal)",
      "28:1332qt" : "28:1332qt (28:1332 Diversity-Petition to Quiet Title)",
      "28:1332ri" : "28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)",
      "28:1332rp" : "28:1332rp (Diversity - real property)",
      "28:1332sa" : "28:1332sa (28:1332 - Diversity: Securities & Exchange Commiss)",
      "28:1332sf" : "28:1332sf (28:1332 - Diversity: Securities Fraud)",
      "28:1332ss" : "28:1332ss (28:1332 Diversity - Stockholders Suits)",
      "28:1332tl" : "28:1332tl (28:1332 Diversity-Torts to Land)",
      "28:1332tm" : "28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))",
      "28:1332tn" : "28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)",
      "28:1332wd" : "28:1332wd (28:1332 Diversity-Wrongful Death)",
      "28:1332wf" : "28:1332wf (28:1332wf Diversity: Windflower Patent Litigation)",
      "28:1333" : "28:1333 (28:1333 Admiralty)",
      "28:1334" : "28:1334 (28:1334 Bankruptcy Appeal)",
      "28:1334c" : "28:1334c (28:1334(c) R&R re motions for abstention (non-cor)",
      "28:1335" : "28:1335 (28:1335 Interpleader Action)",
      "28:1337" : "28:1337 (28:1337 Sherman-Clayton Act)",
      "28:1338cp" : "28:1338cp (28:1338 Copyright Infringement)",
      "28:1338pt" : "28:1338pt (28:1338 Patent Infringement)",
      "28:1338tr" : "28:1338tr (28:1338 Trademark Infringement)",
      "28:1340" : "28:1340 (28:1340 IRS: Custom Duties)",
      "28:1340er" : "28:1340er (28:1340 Recovery of Erroneous Refund)",
      "28:1341" : "28:1341 (28:1341 Complaint for Forfeiture)",
      "28:1343" : "28:1343 (28:1343 Violation of Civil Rights)",
      "28:1345co" : "28:1345co (28:1345 Replevin & Conversion)",
      "28:1345db" : "28:1345db (28:1345 Debt to US - FHA/HUD Title I)",
      "28:1345df" : "28:1345df (28:1345 Default of Promissory Note)",
      "28:1345er" : "28:1345er (28:1345 Recovery of Erroneous Refund)",
      "28:1345fc" : "28:1345fc (28:1345 Foreclosure)",
      "28:1345ff" : "28:1345ff (28:1345 Complaint for Forfeiture)",
      "28:1345hl" : "28:1345hl (28:1345 VA Home Loan Guaranty Debt)",
      "28:1345mc" : "28:1345mc (28:1345 Medical Care Recovery)",
      "28:1345mi" : "28:1345mi (28:1345 Mining Claim Ejectment)",
      "28:1345pd" : "28:1345pd (28:1345 Property Damage)",
      "28:1345pe" : "28:1345pe (28:1345 Property Ejectment)",
      "28:1345rc" : "28:1345rc (28:1345 Recovery of Debt to US)",
      "28:1345st" : "28:1345st (28:1345 Default of Student Loan)",
      "28:1345tp" : "28:1345tp (28:1345 Trespass on Public Land)",
      "28:1345ud" : "28:1345ud (28:1345ud Unlawful Detainer)",
      "28:1345va" : "28:1345va (28:1345 Recovery of VA Overpayment)",
      "28:1346bc" : "28:1346bc (28:1346 Breach of Contract)",
      "28:1346rc" : "28:1346rc (28:1346 Recovery of IRS Tax)",
      "28:1346tc" : "28:1346tc (28:1346 Tort Claim)",
      "28:1346wd" : "28:1346wd (28:1346 Wrongful Death)",
      "28:1350" : "28:1350 (28:1350 Alien Tort Statute)",
      "28:1352" : "28:1352 (28:1352 Miller Act)",
      "28:1355" : "28:1355 (28:1355 Petition for Return of Property)",
      "28:1358" : "28:1358 (28:1358 Land Condemnation)",
      "28:1361" : "28:1361 (28:1361 Petition for Writ of Mandamus)",
      "28:1362ic" : "28:1362ic (28:1362 Indian Tribal Controversy)",
      "28:1362iw" : "28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)",
      "28:1364" : "28:1364 (28:1364 Auto Negligence)",
      "28:1391" : "28:1391 (28:1391 Personal Injury)",
      "28:1402" : "28:1402 (28:1402 Medical Malpractice)",
      "28:1407" : "28:1407 (28:1407 Airline Crash)",
      "28:1441ac" : "28:1441ac (28:1441 Petition for Removal- Account Receivable)",
      "28:1441al" : "28:1441al (28:1441 Petition for Removal- Airline Crash)",
      "28:1441as" : "28:1441as (28:1441 Petition for Removal- Asbestos Litigation)",
      "28:1441au" : "28:1441au (28:1441 Petition for Removal- Auto Negligence)",
      "28:1441bc" : "28:1441bc (28:1441 Petition for Removal- Breach of Contract)",
      "28:1441cv" : "28:1441cv (28:1441 Petition for Removal- Civil Rights Act)",
      "28:1441df" : "28:1441df (28:1441 Petition for Removal- Contract Default)",
      "28:1441dj" : "28:1441dj (28:1441 Petition for Removal- Declaratory Judgemen)",
      "28:1441ds" : "28:1441ds (28:1441 Petition for Removal- Contract Dispute)",
      "28:1441ed" : "28:1441ed (28:1441 Petition for Removal - Employment Discrim)",
      "28:1441fc" : "28:1441fc (28:1441 Petition for Removal - Fair Credit Reporti)",
      "28:1441fr" : "28:1441fr (28:1441 Petition for Removal- Fraud)",
      "28:1441ij" : "28:1441ij (28:1441 Petition for Removal- Injunctive/Declarato)",
      "28:1441in" : "28:1441in (28:1441 Petition for Removal- Insurance Contract)",
      "28:1441int" : "28:1441int (28:1441 Petition for Removal- Action for Interplea)",
      "28:1441lb" : "28:1441lb (28:1441 Petition for Removal Libel,Assault,Slander)",
      "28:1441lm" : "28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relatio)",
      "28:1441mm" : "28:1441mm (28:1441 Petition for Removal- Medical Malpractice)",
      "28:1441ni" : "28:1441ni (28:1441 Petition for Removal- Negotiable Instrumen)",
      "28:1441nm" : "28:1441nm (28:1441 Petition for Removal- Non-Motor Vehicle)",
      "28:1441oc" : "28:1441oc (28:1441 Petition For Removal--Other Contract)",
      "28:1441pd" : "28:1441pd (28:1441 Petition for Removal- Property Damage)",
      "28:1441pi" : "28:1441pi (28:1441 Petition for Removal- Personal Injury)",
      "28:1441pl" : "28:1441pl (28:1441 Petition for Removal- Product Liability)",
      "28:1441pr" : "28:1441pr (28:1441 Petition for Removal)",
      "28:1441qt" : "28:1441qt (28:1441 Petition for Removal- Petition to Quiet Ti)",
      "28:1441ri" : "28:1441ri (28:1441 Petition for Removal- Racketeering (RICO))",
      "28:1441sa" : "28:1441sa (28:1441 - Petition for Removal: SEC Act)",
      "28:1441sf" : "28:1441sf (28:1441 - Petition for Removal: Securities Fraud)",
      "28:1441tl" : "28:1441tl (28:1441 Petition for Removal- Torts to Land)",
      "28:1441tm" : "28:1441tm (28:1441 Petition for Removal- Tort/Motor Vehicle ()",
      "28:1441tn" : "28:1441tn (28:1441 Petition for Removal- Tort/Non-Motor Vehic)",
      "28:1441wd" : "28:1441wd (28:1441 Petition for Removal- Wrongful Death)",
      "28:1442bc" : "28:1442bc (28:1442 Petition for Removal- Breach of Contract)",
      "28:1442pr" : "28:1442pr (28:1442 Petition for Removal)",
      "28:1443" : "28:1443 (28:1443(1) Rent, Lease & Ejectment)",
      "28:1444" : "28:1444 (28:1444 Petition for Removal- Foreclosure)",
      "28:1446in" : "28:1446in (28:1446 Breach of Contract- Insurance)",
      "28:1446pd" : "28:1446pd (28:1446 Petition for Removal- Property Damage (P.I)",
      "28:1446pi" : "28:1446pi (28:1446 Petition for Removal- Personal Injury)",
      "28:1446pl" : "28:1446pl (28:1446pl Petition for Removal - Product Liability)",
      "28:1446pr" : "28:1446pr (28:1446 Petition for Removal)",
      "28:1452" : "28:1452 (28:1452 R&R re motions to remand (non-core))",
      "28:1491" : "28:1491 (28:1491 Tucker Act)",
      "28:1651" : "28:1651 (28:1651 Petition for Writ of Coram Nobis)",
      "28:1651hc" : "28:1651hc (28:1651 Petition for Writ of Habeas Corpus)",
      "28:1651mn" : "28:1651mn (28:1651 Petition for Writ of Mandamus)",
      "28:1782" : "28:1782 (28:1782 Assistance to Foreign and International Tribunals and to Litigants Before Such Tribunals)",
      "28:1983" : "28:1983 (28:1983 Civil Rights)",
      "28:2201" : "28:2201 (28:2201 Constitutionality of State Statute(s))",
      "28:2201dj" : "28:2201dj (28:2201 Declaratory Judgement)",
      "28:2201ij" : "28:2201ij (28:2201 Injunction)",
      "28:2201in" : "28:2201in (28:2201 Declaratory Judgement (Insurance))",
      "28:2241" : "28:2241 (28:2241 Petition for Writ of Habeas Corpus (federa)",
      "28:2254" : "28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))",
      "28:2254se" : "28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)",
      "28:2255" : "28:2255 (28:2255 Motion to Vacate / Correct Illegal Sentenc)",
      "28:2271" : "28:2271 (28:2271 Federal Tort Claims Act)",
      "28:2345" : "28:2345 (28:2345 Medicare Recovery)",
      "28:2409" : "28:2409 (28:2409(a) Quiet Title Action)",
      "28:2410" : "28:2410 (28:2410 Quiet Title)",
      "28:2671" : "28:2671 (28:2671 Federal Tort Claims Act)",
      "28:2674" : "28:2674 (28:2674 Federal Tort Claims Act)",
      "28:7402" : "28:7402 (28:7402 Refund of Taxes)",
      "28:7422" : "28:7422 (28:7422 Appeal from Administrative Decision)",
      "29:0151" : "29:0151 (29:151 Labor: Review of Agency Action)",
      "29:0160" : "29:0160 (29:160(1) National Labor Relations Act)",
      "29:0184" : "29:0184 (29:184 Violation Collection Bargain Agreement)",
      "29:0185ep" : "29:0185ep (29:185 Employee Pension Plan)",
      "29:0185lm" : "29:0185lm (29:185 Labor/Mgt. Relations (Contracts))",
      "29:0201do" : "29:0201do (29:201 Denial of Overtime Compensation)",
      "29:0201fl" : "29:0201fl (29:201 Fair Labor Standards Act)",
      "29:0203" : "29:0203 (29:203 Equal Pay Act)",
      "29:0206" : "29:0206 (29:206 Collect Unpaid Wages)",
      "29:0401" : "29:0401 (29:0401 Labor Management Disclosure Act)",
      "29:0621" : "29:0621 (29:621 Job Discrimination (Age))",
      "29:0623" : "29:0623 (29:623 Job Discrimination (Age))",
      "29:0626" : "29:0626 (29:626 Job Discrimination (Age))",
      "29:0633" : "29:0633 (29:633 Job Discrimination (Age))",
      "29:0651" : "29:0651 (29:651 Occupational Safety/Health)",
      "29:0754" : "29:0754 (29:754 Discrimination)",
      "29:0791" : "29:0791 (29:791 Job Discrimination (Rehabilitation Act))",
      "29:0794" : "29:0794 (29:0794 Job Discrimination (Handicap))",
      "29:1001" : "29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)",
      "29:1002" : "29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)",
      "29:1104" : "29:1104 (29:1104 Recovery of Benefits to Employee)",
      "29:1109" : "29:1109 (29:1109 Breach of Fiduciary Duties)",
      "29:1131" : "29:1131 (29:1131 ERISA - Collection of Delinquent Trust Fun)",
      "29:1132" : "29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)",
      "29:1145" : "29:1145 (29:1145 E.R.I.S.A.)",
      "29:1149" : "29:1149 (29:1149 Recover Pension & Profit Sharing)",
      "29:1337" : "29:1337 (29:1337 E.R.I.S.A.)",
      "29:1362" : "29:1362 (29:1362 ERISA)",
      "29:1381" : "29:1381 (29:1381 E.R.I.S.A.)",
      "29:1401" : "29:1401 (29:1401(b)(2) Appeal of Arbitration Award)",
      "29:1451" : "29:1451 (29:1451 E.R.I.S.A.)",
      "29:1801" : "29:1801 (29:1801 Farmworker Rights)",
      "29:2101" : "29:2101 (29:2101 Worker Adjustment & Retraining Notification Act)",
      "29:2560" : "29:2560 (29:2560 ERISA)",
      "29:2617" : "29:2617 (29:2617 Family Medical Leave Act)",
      "29:790" : "29:790 (29:790 Rehabilitation of Labor)",
      "30:0181" : "30:0181 (30:181 Environment: Review of Agency Action)",
      "30:0801" : "30:0801 (30:0801 Penalities/Federal Mine Safety Health Act)",
      "30:1201" : "30:1201 (30:1201 Environment: Review of Agency Action)",
      "30:1202" : "30:1202 (30:1202 Mining Reclamation Act)",
      "30:1276" : "30:1276 (30:1276 Interior: Review of Agency Action)",
      "31:3545" : "31:3545 (31:3545 Action to Recovery Money)",
      "31:3729" : "31:3729 (31:3729 False Claims Act)",
      "31:3730" : "31:3730 (31:3730 Qui Tam False Claims Act)",
      "31:3731" : "31:3731 (31:3731 Fraud)",
      "31:3733" : "31:3733 (31:3733(j)(2) Pet to Mod or Set Aside CV Investigative Demand)",
      "31:5314" : "31:5314 (31:5314 Failure to Report Interest in Foreign Accounts)",
      "31:5321" : "31:5321 (31:5321 Penalty; Reports of Currency and Foreign Transaction)",
      "33:1319cw" : "33:1319cw (33:1319 Clean Water Act)",
      "33:1319pv" : "33:1319pv (33:1319 Pollutants & Permit Violations)",
      "33:1365" : "33:1365 (33:1365 Environmental Matters)",
      "35:0145" : "35:0145 (35:145 Patent Infringement)",
      "35:0183" : "35:0183 (35:183 Patent Infringement)",
      "35:0271" : "35:0271 (35:271 Patent Infringement)",
      "38:1681" : "38:1681 (38:1681 Recovery of VA Overpayment)",
      "38:1686" : "38:1686 (38:1686 Recovery of VA Overpayment)",
      "38:1780" : "38:1780 (38:1780 Recovery of VA Overpayment)",
      "38:2011" : "38:2011 (38:2011 - Veteran's Readjustment Assistance Act of)",
      "38:3116" : "38:3116 (38:3116 VA Overpayment)",
      "39:3005" : "39:3005 (39:3005 Detention of Mail for Temporary Periods)",
      "39:409" : "39:409 (39:409 Postal Service)",
      "40:0258" : "40:0258 (40:258(a) Public Buildings & Property: Land Condem)",
      "40:0875" : "40:0875 (40:875 Public Buildings & Property: Negligence)",
      "40:3131" : "40:3131 (40:3131 Public Buildings, Property, and Works (Miller Act))",
      "41:0251" : "41:0251 (41:251 Public Contracts-Review of Agency Action)",
      "41:1463" : "41:1463 (41:1463 Public Contracts: Unlawful Employment Prac)",
      "41:4712" : "41:4712 (41:4712 Enhancement of contractor protection from reprisal for disclosure of certain information)",
      "42:0205" : "42:0205 (42:205 Denial Social Security Benefits)",
      "42:0206" : "42:0206 (42:206 Social Security Benefits)",
      "42:0247" : "42:0247 (42:247 Personal Injury-Swine Flu)",
      "42:0402" : "42:0402 (42:402 Social Security Benefits)",
      "42:0405id" : "42:0405id (42:405 Review of HHS Decision (SSID))",
      "42:0405wc" : "42:0405wc (42:405 Review of HHS Decision (DIWC))",
      "42:0405ww" : "42:0405ww (42:405 Review of HHS Decision (DIWW))",
      "42:0416" : "42:0416 (42:416 Denial of Social Security Benefits)",
      "42:0427" : "42:0427 (42:0427 Social Security Benefits)",
      "42:11045" : "42:11045 (42:11045 Emergency Planning and Community Right to Know Act)",
      "42:11601" : "42:11601 (42:11601 International Child Abduction Remedies Act (ICARA))",
      "42:12101" : "42:12101 (42:12101 Americans With Disabilities Act)",
      "42:1383" : "42:1383 (42:1383 Review of HHS Decision)",
      "42:1395" : "42:1395 (42:1395 HHS: Adverse Reimbursement Review)",
      "42:1396" : "42:1396 (42:1396 - Tort Negligence)",
      "42:13981" : "42:13981 (42:13981 VIOLENCE AGAINST WOMEN ACT)",
      "42:1471" : "42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclo)",
      "42:1981cv" : "42:1981cv (42:1981 Civil Rights)",
      "42:1981hs" : "42:1981hs (42:1981 Housing Discrimination)",
      "42:1981jb" : "42:1981jb (42:1981 Job Discrimination (Race))",
      "42:1981sx" : "42:1981sx (42:1981 Sex Discrimination)",
      "42:1983cv" : "42:1983cv (42:1983 Civil Rights Act)",
      "42:1983cvp" : "42:1983cvp (42:1983 Civil Rights (Personal Property))",
      "42:1983ed" : "42:1983ed (42:1983 Civil Rights (Employment Discrimination))",
      "42:1983pr" : "42:1983pr (42:1983 Prisoner Civil Rights)",
      "42:1986" : "42:1986 (42:1986 Neglect of Duty)",
      "42:1988" : "42:1988 (42:1988 Proceedings in Vindication of Civil Rights)",
      "42:2000ag" : "42:2000ag (42:2000 Job Discrimination (Age))",
      "42:2000cc" : "42:2000cc (42:2000cc (Religious Land Use and Institutionalized Persons Act))",
      "42:2000e" : "42:2000e (42:2000e Job Discrimination (Employment))",
      "42:2000pb" : "42:2000pb (42:2000 Job Discrimination (Public Accomodations))",
      "42:2000ra" : "42:2000ra (42:2000 Job Discrimination (Race))",
      "42:2000sx" : "42:2000sx (42:2000 Job Discrimination (Sex))",
      "42:2003" : "42:2003 (42:2003 Job Discrimination)",
      "42:2005" : "42:2005 (42:2005 Review of Agency Action-HHS)",
      "42:2210" : "42:2210 (42:2210-Price-Anderson Act)",
      "42:2651" : "42:2651 (42:2651 Medical Care Recovery)",
      "42:3601" : "42:3601 (42:405 Fair Housing Act)",
      "42:4000" : "42:4000 (42:4000 National Flood Insurance Act)",
      "42:4001" : "42:4001 (42:4001 National Insurance Flood Act)",
      "42:4053" : "42:4053 (42:4053 Breach of Insurance Contract)",
      "42:4072" : "42:4072 (42:4072 Payment of Flood Insurance Claim)",
      "42:4321" : "42:4321 (42:4321 Review of Agency Action-Environment)",
      "42:4332" : "42:4332 (42:4332 Environmental Policy - Coop of Agency Repo)",
      "42:5851" : "42:5851 (42:5851 Nuclear Whistleblower Protection)",
      "42:6901en" : "42:6901en (42:6901 Environmental Cleanup Expenses)",
      "42:6901rs" : "42:6901rs (42:6901 Resource & Recovery Act)",
      "42:7413" : "42:7413 (42:7413(b) Clean Air Act)",
      "42:7604cl" : "42:7604cl (42:7604 Clear Air Act (Emission Standards))",
      "42:7604ir" : "42:7604ir (42:7604 Petition to Quash IRS Summons)",
      "42:9604" : "42:9604 (CERCLA Comprehensive Environmental Response & Comp Act)",
      "42:9606" : "42:9606 (42:9606 Comp Environmental Response, Compensation (CERCLA))",
      "42:9607" : "42:9607 (42:9607 Real Property Tort to Land)",
      "43:945" : "43:945 (43:945 Compensation for Land Condemnation)",
      "43:945a" : "43:945a (43:945a Complaint in Condemnation)",
      "43:946" : "43:946 (43:946 Complaint in Condemnation - Eminent Domain)",
      "45:0051" : "45:0051 (45:51 Railways: Fed. Employer's Liability Act)",
      "45:0151" : "45:0151 (45:151 Railway Labor Act)",
      "45:0184" : "45:0184 (45:184 Action to Set Aside Award of a System Board)",
      "45:1395" : "45:1395 (45:1395 Railroads: Adverse Reimbursement Review)",
      "45:7457" : "45:7457 (45:7457 Compel Reclamation Under Clear Air Act)",
      "46:0322" : "46:0322 (Injury at Sea)",
      "46:0688" : "46:0688 (46:688 Jones Act)",
      "46:0741" : "46:0741 (46:741 Shipping)",
      "46:0761" : "46:0761 (46:761 Shipping: Damages for Death on High Seas)",
      "46:1101" : "46:1101 (46:1101 Violation of Maritime Regulations)",
      "46:1156" : "46:1156 (46:1156 Administrative Procedure Act)",
      "47:0605" : "47:0605 (47:0605 UNAUTHORIZED PUBLICATION OR USE OF COMMUNICATION)",
      "47:332" : "47:332 (47:332 TELECOMMUNICATIONS ACT)",
      "48:0883" : "48:0883 (48:883 Violation of US Coastal Law)",
      "48:1985" : "48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)",
      "49:0081" : "49:0081 (49:81 Damaged Goods While Being Transported)",
      "49:0781" : "49:0781 (49:781 Forfeiture)",
      "49:11503" : "49:11503 (49:11503 Railroad Revitalization Regulatory Reform)",
      "49:11702" : "49:11702 (49:11702(a)(4) Violations of Interstate Commerce A)",
      "49:1471" : "49:1471 (49:1471 Federal Aviation Act)",
      "49:1903" : "49:1903 (49:1903 Petition to enforce administrative summon)",
      "7:499E(c4)" : "7:499E(c4) (7:49E(c4) Perishable Agricultural Commodities Act (PACA))",
      "8:1225" : "8:1225 (8:1225 Enforcement of Administrative Subpoena)",
      "8:1451" : "8:1451 (8:1451 Immigration and Nationality Act)",
      "8:287" : "8:287 (8:287 Petition to Enforce INS Subpoena)",
      "misc" : "misc (Civil Miscellaneous Case)"
   },
   "wawdce" : {
      "0" : "0 (No cause code entered)",
      "00:0000" : "00:0000 (00:0000 Cause Code Unknown)",
      "02:0431" : "02:0431 (02:431 Fed. Election Commission: Failure Enforce Compliance)",
      "02:0437" : "02:0437 (02:437 Federal Election Commission)",
      "05:0075" : "05:0075 (05:75(2) Contract - Reduction in Grade)",
      "05:0551" : "05:0551 (05:551 Administrative Procedure Act)",
      "05:0552fi" : "05:0552fi (05:552 Freedom of Information Act)",
      "05:0552pa" : "05:0552pa (05:552 Right to Privacy Act)",
      "05:0554" : "05:0554 (05:0554 Constitutionality of Maritime Statutes)",
      "05:0701" : "05:0701 (05:0701 Maritime Subsidy Board)",
      "05:0702" : "05:0702 (05:702 Administrative Procedure Act)",
      "05:0704" : "05:0704 (05:704 Labor Litigation)",
      "05:7703" : "05:7703 (05:7703 Discrimination - Review of Agency Act)",
      "07:0006" : "07:0006 (07:0006(b) Federal Commodity Exchange Regulation)",
      "07:0025" : "07:0025 (07:0025 Fraud - Commodities Leverage Contracts)",
      "07:0181" : "07:0181 (07:181 Packers & Stockyard Act)",
      "07:0499" : "07:0499 (07:499 Agricultural Commodities Act)",
      "07:0601" : "07:0601 (07:601 USDA Condemnation)",
      "07:2321" : "07:2321 (07:2321 Plant Variety Protection Act)",
      "08:0287" : "08:0287 (08:0287 Petition to Enforce INS Subpoena)",
      "08:1105" : "08:1105 (8:1105(a) Aliens: Habeas Corpus to Release INS Det)",
      "08:1183a" : "08:1183a (08:1183a Immigration: Action for Enforcement of a Sponsor's Affidavit of Support)",
      "08:1252" : "08:1252 (08:1252(a)(2) Injunction for Deportation)",
      "08:1255" : "08:1255 (08:1255 Adjustment of Status of Nonimmigrant to Permanent Resident)",
      "08:1260" : "08:1260 (08:1260 Aliens: Access to Records)",
      "08:1324" : "08:1324 (08:1324 Aliens: Complaint for Forfeiture)",
      "08:1326" : "08:1326 (08:1326 Aliens)",
      "08:1329" : "08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petiti)",
      "08:1446" : "08:1446 (8:1446 Petition for Naturalization Hearing)",
      "08:1447" : "08:1447 (08:1447 Petition for Hearing on Naturalization Application)",
      "08:1451j" : "08:1451j (08:1451 Motion to Correct Order & Judg. of Naturalization)",
      "08:287" : "08:287 (08:287 Petition to Enforce INS Subpoena)",
      "09:0001" : "09:0001 (09:1 U.S. Arbitration Act)",
      "09:0009" : "09:0009 (09:0009 Motion to Confirm Arbitration)",
      "09:0010" : "09:0010 (09:0010 Petition to Vacate Arbitration Award)",
      "10:1552" : "10:1552 (10:1552 Armed Forces: Action to Correct Records)",
      "10:1553" : "10:1553 (10:1553 Armed Forces: FOIA General)",
      "10:2305" : "10:2305 (10:2305 Review of Federal Contract)",
      "10:2733" : "10:2733 (10:2733 Armed Forces: Noncombat Activities-Personal Injury)",
      "11:0101" : "11:0101 (11:101 Bankruptcy)",
      "12:0022" : "12:0022 (12:22 Securities Fraud)",
      "12:0635" : "12:0635 (12:635 Breach of Insurance Contract)",
      "12:1461" : "12:1461 (12:1461 Homeowners Loan Act)",
      "12:1464" : "12:1464 (Federal Savings and Loan)",
      "12:1703" : "12:1703 (12:1703 Default of HUD Loan)",
      "12:1725" : "12:1725 (12:1725 Collection under Contract Guaranty)",
      "12:1730" : "12:1730 (12:1730 Collection Under Contract Guaranty)",
      "12:1819" : "12:1819 (12:1819 Default of Promissory Note)",
      "12:1821" : "12:1821 (12:1821 Default of Loan by Promissory Note)",
      "12:1971" : "12:1971 (12:1971 Relief under Bank Holding Act)",
      "12:3410" : "12:3410 (12:3410 Right to Financial Privacy Act)",
      "15:0001" : "15:0001 (15:1 Antitrust Litigation)",
      "15:0002at" : "15:0002at (15:2 Antitrust Litigation)",
      "15:0002fl" : "15:0002fl (15:2(a) Fair Labor Standards Act)",
      "15:0005" : "15:0005 (15:5(a) Fair Labor Standards Act)",
      "15:0015" : "15:0015 (15:15 Antitrust Litigation)",
      "15:0025" : "15:0025 (15:25 Clayton Act)",
      "15:0044" : "15:0044 (15:44 Trademark Infringement)",
      "15:0045" : "15:0045 (15:0045 Federal Trade Commission Act)",
      "15:0052" : "15:0052 (15:0052 Federal Trade Commission Act)",
      "15:0053" : "15:0053 (15:0053 Federal Trade Commission Act)",
      "15:0077" : "15:0077 (15:77 Securities Fraud)",
      "15:0078" : "15:0078 (15:78m(a) Securities Exchange Act)",
      "15:0631" : "15:0631 (15:631 Small Business Act)",
      "15:0717" : "15:0717 (15:0717 Natural Gas Act)",
      "15:1051" : "15:1051 (15:1051 Trademark Infringement)",
      "15:1114" : "15:1114 (15:1114 Trademark Infringement)",
      "15:1121" : "15:1121 (15:1121 Trademark Infringement)",
      "15:1125" : "15:1125 (15:1125 Trademark Infringement (Lanham Act))",
      "15:1126" : "15:1126 (15:1126 Patent Infringement)",
      "15:1127" : "15:1127 (15:1127 Trademark Infringement)",
      "15:1601" : "15:1601 (15:1601 Truth in Lending)",
      "15:1640" : "15:1640 (15:1640 Truth in Lending)",
      "15:1681" : "15:1681 (15:1681 Fair Credit Reporting Act)",
      "15:1692" : "15:1692 (15:1692 Fair Debt Collection Act)",
      "15:1693" : "15:1693 (15:1693 Electronic Fund Transfers Act)",
      "15:1938" : "15:1938 (15:1938 Fair Labor Standards Act)",
      "15:1981" : "15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))",
      "15:1988" : "15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))",
      "15:1989" : "15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))",
      "15:2301" : "15:2301 (15:2301 Magnuson-Moss Warranty Act)",
      "15:2801" : "15:2801 (15:2801 Petroleum Marketing Practices Act)",
      "15:53(b)" : "15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equita)",
      "16:0668" : "16:0668 (16:668 Bald Eagle Protection Act)",
      "16:0703" : "16:0703 (16:703 Migratory Bird Act)",
      "16:1538" : "16:1538 (16:1538 Endangered Species Act)",
      "16:3371" : "16:3371 (16:3371 Wildlife Under the Lacey Act)",
      "16:3372" : "16:3372 (16:3372 Conservation: Complaint for Forfeiture)",
      "16:3373" : "16:3373 (16:3373 Appeal of Decision - DOI)",
      "16:3374" : "16:3374 (16:3374 Conservation: Complaint for Forfeiture)",
      "17:0101" : "17:0101 (17:101 Copyright Infringement)",
      "17:0501" : "17:0501 (17:501 Copyright Infringement)",
      "17:0504" : "17:0504 (17:504 Copyright Infringement)",
      "18:0241" : "18:0241 (18:241 Conspiracy Against Citizen Rights)",
      "18:0981" : "18:0981 (18:0981 Civil Forfeiture - Gambling, etc.)",
      "18:1030" : "18:1030 (18:1030 Computer Fraud and Abuse Act)",
      "18:1345" : "18:1345 (18:1345 Injunctions Against Fraud)",
      "18:1514a" : "18:1514a (18:1514a Civil Action to Protect Against Retaliation in Fraud Cases)",
      "18:1836a" : "18:1836a (18:1836(a) - Injunction against Misappropriation of Trade Secrets)",
      "18:1836b" : "18:1836b (18:1836(b) - Civil Action to Protect Trade Secrets)",
      "18:1955" : "18:1955 (18:1955 Forfeiture, Gambling)",
      "18:1961" : "18:1961 (18:1961 Racketeering (RICO) Act)",
      "18:1962" : "18:1962 (18:1962 Racketeering (RICO) Act)",
      "18:1964" : "18:1964 (18:1964 Racketeering (RICO) Act)",
      "18:2254" : "18:2254 (18:2254 Forfeiture-Materials Involv.Sexual Exploit.of Minors)",
      "18:2510" : "18:2510 (18:2510 Wire and Electronics Communications Act)",
      "18:2511" : "18:2511 (18:2511 Wiretapping)",
      "18:2701" : "18:2701 (18:2701 Electronics Communication Privacy Act)",
      "18:3114" : "18:3114 (18:3114 Motion for Return of Seized Property)",
      "18:4208" : "18:4208 (18:4208(B) Agency Action Review)",
      "18:925A" : "18:925A (18:925A Firearms: Remedy for Erroneous Denial of Firearm)",
      "18:925c" : "18:925c (18:925(c) Restoration of Ability to Possess Firearms/Ammo)",
      "19:1305" : "19:1305 (19:1305 Custom Duties:0Forfeiture-Immoral Articles)",
      "20:1080" : "20:1080 (20:1080 Student Loan Recovery)",
      "20:1400" : "20:1400 (20:1400 Civil Rights of Handicapped Child)",
      "20:1401" : "20:1401 (20:1401 Education: Handicapped Child Act)",
      "21:0301" : "21:0301 (21:0301 Federal Food, Drug & Cosmetic Act)",
      "21:0841" : "21:0841 (21:841 Forfeiture Property-Drugs)",
      "21:0881" : "21:0881 (21:881 Forfeiture Property-Drugs)",
      "21:0881a" : "21:0881a (21:881 Forfeiture Property - Aircraft)",
      "21:0881pa" : "21:0881pa (21:0881 Forfeiture Property - Automobile)",
      "21:0881pc" : "21:0881pc (21:0881 Forfeiture Property - Currency)",
      "21:0881re" : "21:0881re (21:881 Forfeiture Property - Real Estate)",
      "23:0134" : "23:0134 (23:134 P.I.- Auto Negligence)",
      "23:1441" : "23:1441 (23:1441 Contract Real Estate)",
      "24:1000" : "24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)",
      "25:0640" : "25:0640 (25:640 Indian Tribal Rights)",
      "25:1901" : "25:1901 (25:1901 Indian Child Welfare Act)",
      "26:6212" : "26:6212 (26:6212 Injunctive Relief from IRS Lien)",
      "26:6213" : "26:6213 (26:6213 Injunctive Relief from IRS Lien)",
      "26:6502" : "26:6502 (26:6502 IRS:Enforcement of tax liens)",
      "26:6532" : "26:6532 (26:6532 IRS: Refund of Tax Penalty)",
      "26:6702" : "26:6702 (26:6702 IRS: Refund of Income Tax Penalty)",
      "26:6703" : "26:6703 (26:6703 IRS: Refund of Tax Penalty)",
      "26:7401" : "26:7401 (26:7401 IRS: Tax Liability)",
      "26:7402" : "26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)",
      "26:7403" : "26:7403 (26:7403 Suit to Enforce Federal Tax Lien)",
      "26:7422rt" : "26:7422rt (26:7422 IRS: Refund Taxes)",
      "26:7422rx" : "26:7422rx (26:7422 IRS: Refund Excise Tax)",
      "26:7426" : "26:7426 (26:7426 IRS: Wrongful Levy for Taxes)",
      "26:7429" : "26:7429 (26:7429 IRS: Tax Jeopardy Assessment)",
      "26:7609" : "26:7609 (26:7609 IRS: Petition to Quash IRS Summons)",
      "26:982" : "26:982 (26:982 Petition to Quash a Formal Document Request)",
      "27:0185" : "27:0185 (27:185 Enforcement of Arbitration Award)",
      "28:0157c" : "28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)",
      "28:0157d" : "28:0157d (28:0157 Motion for Withdrawal of Reference)",
      "28:0158" : "28:0158 (28:0158 Notice of Appeal re Bankruptcy Matter (BA)",
      "28:0185" : "28:0185 (28:185 Suit to Compel Arbitration)",
      "28:0451" : "28:0451 (28:451 Employment Discrimination)",
      "28:0794" : "28:0794 (28:794 Rehabilitation Act)",
      "28:1001" : "28:1001 (28:1001 E.R.I.S.A.)",
      "28:1132" : "28:1132 (28:1132 E.R.I.S.A.)",
      "28:1330" : "28:1330 (28:1330 Breach of Contract)",
      "28:1331" : "28:1331 (28:1331 Fed. Question)",
      "28:1331al" : "28:1331al (28:1331 Fed. Question: Airline Crash)",
      "28:1331at" : "28:1331at (28:1331 Fed. Question: Anti-trust)",
      "28:1331au" : "28:1331au (28:1331 Fed. Question: Auto Negligence)",
      "28:1331b" : "28:1331b (28:1331 Federal Question: Bivens Act)",
      "28:1331bc" : "28:1331bc (28:1331 Fed. Question: Breach of Contract)",
      "28:1331ca" : "28:1331ca (28:1331 Fed Question: Fed Communications Act of 1)",
      "28:1331cm" : "28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)",
      "28:1331cv" : "28:1331cv (28:1331 Federal Question: Other Civil Rights)",
      "28:1331ed" : "28:1331ed (28:1331 Fed. Question: Employment Discrimination)",
      "28:1331ef" : "28:1331ef (28:1331 Federal Question: Civil Rights Violation (Excess Force))",
      "28:1331ej" : "28:1331ej (28:1331 Federal Question: Enforcement of Judgment)",
      "28:1331es" : "28:1331es (28:1331 Enforcement of Administrative Subpoena)",
      "28:1331fl" : "28:1331fl (28:1331 Fed. Question: Fair Labor Standards)",
      "28:1331in" : "28:1331in (28:1331 Fed. Question: Insurance Contract)",
      "28:1331mm" : "28:1331mm (28:1331 Fed. Question: Medical Malpractice)",
      "28:1331ng" : "28:1331ng (28:1331 Fed. Question: Natural Gas Act)",
      "28:1331oc" : "28:1331oc (28:1331 Fed. Question: Other Contract)",
      "28:1331pd" : "28:1331pd (28:1331 Federal Question: Property Damage)",
      "28:1331pi" : "28:1331pi (28:1331 Fed. Question: Personal Injury)",
      "28:1331rd" : "28:1331rd (28:1331 Fed. Question: Review Agency Decision)",
      "28:1331rp" : "28:1331rp (28:1331(a) Fed. Question: Real Property)",
      "28:1331rr" : "28:1331rr (28:1331 Fed. Question: Railway Labor Act)",
      "28:1331ss" : "28:1331ss (28:1331 Fed. Question: Constitutionality of State Statutes)",
      "28:1331sv" : "28:1331sv (28:1331 Fed. Question: Securities Violation)",
      "28:1331tr" : "28:1331tr (28:1331 Fed. Question: Trademark)",
      "28:1331tt" : "28:1331tt (28:1331 Fed. Question: Tort Action)",
      "28:1331v" : "28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendme)",
      "28:1331vc" : "28:1331vc (28:1331 Fed. Question: Violation of Constitutional Rights)",
      "28:1331wl" : "28:1331wl (28:1331 Federal Question: EPA Waste Lien)",
      "28:1331wt" : "28:1331wt (28:1331 Fed. Question: Water Rights)",
      "28:1332" : "28:1332 (28:1332 Diversity)",
      "28:1332ac" : "28:1332ac (28:1332 Diversity-Account Receivable)",
      "28:1332al" : "28:1332al (28:1332 Diversity-Airline Crash)",
      "28:1332as" : "28:1332as (28:1332 Diversity-Asbestos Litigation)",
      "28:1332au" : "28:1332au (28:1332 Diversity-Auto Negligence)",
      "28:1332bc" : "28:1332bc (28:1332 Diversity-Breach of Contract)",
      "28:1332co" : "28:1332co (28:1332 Diversity-Conversion)",
      "28:1332ct" : "28:1332ct (28:1332 Diversity-(Citizenship))",
      "28:1332det" : "28:1332det (28:1332 Diversity: Forcible Detainer)",
      "28:1332df" : "28:1332df (28:1332 Diversity-Contract Default)",
      "28:1332ds" : "28:1332ds (28:1332 Diversity-Contract Dispute)",
      "28:1332ed" : "28:1332ed (28:1332 Diversity-Employment Discrimination)",
      "28:1332fd" : "28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)",
      "28:1332fr" : "28:1332fr (28:1332 Diversity-Fraud)",
      "28:1332ia" : "28:1332ia (28:1332 Diversity-Interpleader Action)",
      "28:1332ij" : "28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)",
      "28:1332in" : "28:1332in (28:1332 Diversity-Insurance Contract)",
      "28:1332jd" : "28:1332jd (28:1332 Diversity-Declaratory Judgment)",
      "28:1332lb" : "28:1332lb (28:1332 Diversity-Libel,Assault,Slander)",
      "28:1332lm" : "28:1332lm (28:1332 Diversity - Legal Malpractice)",
      "28:1332ma" : "28:1332ma (28:1332 Diversity-Miller Act)",
      "28:1332mc" : "28:1332mc (28:1332 Marine Contract Actions)",
      "28:1332mm" : "28:1332mm (28:1332 Diversity-Medical Malpractice)",
      "28:1332mv" : "28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)",
      "28:1332ni" : "28:1332ni (28:1332 Diversity-Negotiable Instrument)",
      "28:1332nm" : "28:1332nm (28:1332 Diversity-Non-Motor Vehicle)",
      "28:1332nr" : "28:1332nr (28:1332 Diversity-Notice of Removal)",
      "28:1332oc" : "28:1332oc (28:1332 Diversity-Other Contract)",
      "28:1332pd" : "28:1332pd (28:1332 Diversity-Property Damage)",
      "28:1332pi" : "28:1332pi (28:1332 Diversity-Personal Injury)",
      "28:1332pl" : "28:1332pl (28:1332 Diversity-Product Liability)",
      "28:1332pr" : "28:1332pr (28:1332 Diversity-Petition for Removal)",
      "28:1332qt" : "28:1332qt (28:1332 Diversity-Petition to Quiet Title)",
      "28:1332ri" : "28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)",
      "28:1332sa" : "28:1332sa (28:1332 - Diversity: Securities & Exchange Commiss)",
      "28:1332sf" : "28:1332sf (28:1332 - Diversity: Securities Fraud)",
      "28:1332ss" : "28:1332ss (28:1332 Diversity - Stockholders Suits)",
      "28:1332tl" : "28:1332tl (28:1332 Diversity-Torts to Land)",
      "28:1332tm" : "28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))",
      "28:1332tn" : "28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)",
      "28:1332wd" : "28:1332wd (28:1332 Diversity-Wrongful Death)",
      "28:1333" : "28:1333 (28:1333 Admiralty)",
      "28:1334" : "28:1334 (28:1334 Bankruptcy Appeal)",
      "28:1334c" : "28:1334c (28:1334(c) R&R re motions for abstention (non-cor)",
      "28:1335" : "28:1335 (28:1335 Interpleader Action)",
      "28:1337" : "28:1337 (28:1337 Sherman-Clayton Act)",
      "28:1338cp" : "28:1338cp (28:1338 Copyright Infringement)",
      "28:1338pt" : "28:1338pt (28:1338 Patent Infringement)",
      "28:1338tr" : "28:1338tr (28:1338 Trademark Infringement)",
      "28:1340" : "28:1340 (28:1340 IRS: Custom Duties)",
      "28:1340er" : "28:1340er (28:1340 Recovery of Erroneous Refund)",
      "28:1341" : "28:1341 (28:1341 Complaint for Forfeiture)",
      "28:1343" : "28:1343 (28:1343 Violation of Civil Rights)",
      "28:1345co" : "28:1345co (28:1345 Replevin & Conversion)",
      "28:1345db" : "28:1345db (28:1345 Debt to US - FHA/HUD Title I)",
      "28:1345df" : "28:1345df (28:1345 Default of Promissory Note)",
      "28:1345er" : "28:1345er (28:1345 Recovery of Erroneous Refund)",
      "28:1345fc" : "28:1345fc (28:1345 Foreclosure)",
      "28:1345ff" : "28:1345ff (28:1345 Complaint for Forfeiture)",
      "28:1345hl" : "28:1345hl (28:1345 VA Home Loan Guaranty Debt)",
      "28:1345mc" : "28:1345mc (28:1345 Medical Care Recovery)",
      "28:1345mi" : "28:1345mi (28:1345 Mining Claim Ejectment)",
      "28:1345pd" : "28:1345pd (28:1345 Property Damage)",
      "28:1345pe" : "28:1345pe (28:1345 Property Ejectment)",
      "28:1345rc" : "28:1345rc (28:1345 Recovery of Debt to US)",
      "28:1345st" : "28:1345st (28:1345 Default of Student Loan)",
      "28:1345tp" : "28:1345tp (28:1345 Trespass on Public Land)",
      "28:1345va" : "28:1345va (28:1345 Recovery of VA Overpayment)",
      "28:1346bc" : "28:1346bc (28:1346 Breach of Contract)",
      "28:1346rc" : "28:1346rc (28:1346 Recovery of IRS Tax)",
      "28:1346tc" : "28:1346tc (28:1346 Tort Claim)",
      "28:1346wd" : "28:1346wd (28:1346 Wrongful Death)",
      "28:1352" : "28:1352 (28:1352 Miller Act)",
      "28:1355" : "28:1355 (28:1355 Petition for Return of Property)",
      "28:1358" : "28:1358 (28:1358 Land Condemnation)",
      "28:1361" : "28:1361 (28:1361 Petition for Writ of Mandamus)",
      "28:1362ic" : "28:1362ic (28:1362 Indian Tribal Controversy)",
      "28:1362iw" : "28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)",
      "28:1364" : "28:1364 (28:1364 Auto Negligence)",
      "28:1391" : "28:1391 (28:1391 Personal Injury)",
      "28:1402" : "28:1402 (28:1402 Medical Malpractice)",
      "28:1407" : "28:1407 (28:1407 Airline Crash)",
      "28:1407b" : "28:1407b (28:1407 Breach of Contract)",
      "28:1441ac" : "28:1441ac (28:1441 Petition for Removal- Account Receivable)",
      "28:1441ada" : "28:1441ada (28:1441 Petition for Removal - Americans with Disabilities Act)",
      "28:1441al" : "28:1441al (28:1441 Petition for Removal- Airline Crash)",
      "28:1441as" : "28:1441as (28:1441 Petition for Removal- Asbestos Litigation)",
      "28:1441au" : "28:1441au (28:1441 Petition for Removal- Auto Negligence)",
      "28:1441bc" : "28:1441bc (28:1441 Petition for Removal- Breach of Contract)",
      "28:1441cpl" : "28:1441cpl (28:1441 Petition for Removal - Contract Product Liability)",
      "28:1441cv" : "28:1441cv (28:1441 Petition for Removal- Civil Rights Act)",
      "28:1441df" : "28:1441df (28:1441 Petition for Removal- Contract Default)",
      "28:1441dj" : "28:1441dj (28:1441 Petition for Removal- Declaratory Judgemen)",
      "28:1441ds" : "28:1441ds (28:1441 Petition for Removal- Contract Dispute)",
      "28:1441ed" : "28:1441ed (28:1441 Petition for Removal - Employment Discrim)",
      "28:1441er" : "28:1441er (28:1441 Notice of Removal-ERISA)",
      "28:1441fc" : "28:1441fc (28:1441 Petition for Removal - Fair Credit Reporting)",
      "28:1441fr" : "28:1441fr (28:1441 Petition for Removal- Fraud)",
      "28:1441ij" : "28:1441ij (28:1441 Petition for Removal- Injunctive/Declarato)",
      "28:1441in" : "28:1441in (28:1441 Petition for Removal- Insurance Contract)",
      "28:1441int" : "28:1441int (28:1441 Petition for Removal- Action for Interplea)",
      "28:1441lb" : "28:1441lb (28:1441 Petition for Removal Libel,Assault,Slander)",
      "28:1441lm" : "28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relatio)",
      "28:1441mm" : "28:1441mm (28:1441 Petition for Removal- Medical Malpractice)",
      "28:1441ni" : "28:1441ni (28:1441 Petition for Removal- Negotiable Instrumen)",
      "28:1441nm" : "28:1441nm (28:1441 Petition for Removal- Non-Motor Vehicle)",
      "28:1441nr" : "28:1441nr (28:1441 Notice of Removal)",
      "28:1441oc" : "28:1441oc (28:1441 Petition For Removal--Other Contract)",
      "28:1441pd" : "28:1441pd (28:1441 Petition for Removal- Property Damage)",
      "28:1441pi" : "28:1441pi (28:1441 Petition for Removal- Personal Injury)",
      "28:1441pl" : "28:1441pl (28:1441 Petition for Removal- Product Liability)",
      "28:1441pr" : "28:1441pr (28:1441 Petition for Removal)",
      "28:1441qt" : "28:1441qt (28:1441 Petition for Removal- Petition to Quiet Ti)",
      "28:1441ri" : "28:1441ri (28:1441 Petition for Removal- Racketeering (RICO))",
      "28:1441sa" : "28:1441sa (28:1441 - Petition for Removal: SEC Act)",
      "28:1441sf" : "28:1441sf (28:1441 - Petition for Removal: Securities Fraud)",
      "28:1441tl" : "28:1441tl (28:1441 Petition for Removal- Torts to Land)",
      "28:1441tm" : "28:1441tm (28:1441 Petition for Removal- Tort/Motor Vehicle ()",
      "28:1441tn" : "28:1441tn (28:1441 Petition for Removal- Tort/Non-Motor Vehic)",
      "28:1441wd" : "28:1441wd (28:1441 Petition for Removal- Wrongful Death)",
      "28:1442bc" : "28:1442bc (28:1442 Petition for Removal- Breach of Contract)",
      "28:1442nr" : "28:1442nr (28:1442 Notice of Removal)",
      "28:1442pr" : "28:1442pr (28:1442 Petition for Removal)",
      "28:1443" : "28:1443 (28:1443(1) Rent, Lease & Ejectment)",
      "28:1444" : "28:1444 (28:1444 Petition for Removal- Foreclosure)",
      "28:1446in" : "28:1446in (28:1446 Breach of Contract- Insurance)",
      "28:1446nr" : "28:1446nr (28:1446 Notice of Removal)",
      "28:1446pd" : "28:1446pd (28:1446 Petition for Removal- Property Damage (P.I)",
      "28:1446pi" : "28:1446pi (28:1446 Petition for Removal- Personal Injury)",
      "28:1446pl" : "28:1446pl (28:1446pl Petition for Removal - Product Liability)",
      "28:1446pr" : "28:1446pr (28:1446 Petition for Removal)",
      "28:1452" : "28:1452 (28:1452 R&R re motions to remand (non-core))",
      "28:1651" : "28:1651 (28:1651 Petition for Writ of Coram Nobis)",
      "28:1651hc" : "28:1651hc (28:1651 Petition for Writ of Habeas Corpus)",
      "28:1651mn" : "28:1651mn (28:1651 Petition for Writ of Mandamus)",
      "28:1782" : "28:1782 (28:1782 Letter rogatory - appointment)",
      "28:1875" : "28:1875 (28:1875 Protection of Juror Employment)",
      "28:1916" : "28:1916 (28:1916 Marine Contract Actions)",
      "28:2201" : "28:2201 (28:2201 Constitutionality of State Statute(s))",
      "28:2201dj" : "28:2201dj (28:2201 Declaratory Judgment)",
      "28:2201ij" : "28:2201ij (28:2201 Injunction)",
      "28:2201in" : "28:2201in (28:2201 Declaratory Judgment (Insurance))",
      "28:2241" : "28:2241 (28:2241 Petition for Writ of Habeas Corpus (federa)",
      "28:2254" : "28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))",
      "28:2254se" : "28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)",
      "28:2255" : "28:2255 (28:2255 Motion to Vacate / Correct Illegal Sentenc)",
      "28:2271" : "28:2271 (28:2271 Federal Tort Claims Act)",
      "28:2345" : "28:2345 (28:2345 Medicare Recovery)",
      "28:2409" : "28:2409 (28:2409(a) Quiet Title Action)",
      "28:2410" : "28:2410 (28:2410 Quiet Title)",
      "28:2671" : "28:2671 (28:2671 Federal Tort Claims Act)",
      "28:2674" : "28:2674 (28:2674 Federal Tort Claims Act)",
      "28:7402" : "28:7402 (28:7402 Refund of Taxes)",
      "28:7422" : "28:7422 (28:7422 Appeal from Administrative Decision)",
      "29:0151" : "29:0151 (29:151 Labor: Review of Agency Action)",
      "29:0160" : "29:0160 (29:160(1) National Labor Relations Act)",
      "29:0184" : "29:0184 (29:184 Violation Collection Bargain Agreement)",
      "29:01851m" : "29:01851m (29:01851m Labor/Mgt. Relations)",
      "29:0185ep" : "29:0185ep (29:185 Employee Pension Plan)",
      "29:0185lm" : "29:0185lm (29:185 Labor/Mgt. Relations (Contracts))",
      "29:0201do" : "29:0201do (29:201 Denial of Overtime Compensation)",
      "29:0201fl" : "29:0201fl (29:201 Fair Labor Standards Act)",
      "29:0203" : "29:0203 (29:203 Equal Pay Act)",
      "29:0206" : "29:0206 (29:206 Collect Unpaid Wages)",
      "29:0216b" : "29:0216b (29:216(b) - FLSA: Minimum Wage or Overtime Compensation)",
      "29:0401" : "29:0401 (29:0401 Labor Management Disclosure Act)",
      "29:0621" : "29:0621 (29:621 Job Discrimination (Age))",
      "29:0623" : "29:0623 (29:623 Job Discrimination (Age))",
      "29:0626" : "29:0626 (29:626 Job Discrimination (Age))",
      "29:0633" : "29:0633 (29:633 Job Discrimination (Age))",
      "29:0651" : "29:0651 (29:651 Occupational Safety/Health)",
      "29:0754" : "29:0754 (29:754 Discrimination)",
      "29:0791" : "29:0791 (29:791 Job Discrimination (Rehabilitation Act))",
      "29:0794" : "29:0794 (29:0794 Job Discrimination (Handicap))",
      "29:1001" : "29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)",
      "29:1002" : "29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)",
      "29:1104" : "29:1104 (29:1104 Recovery of Benefits to Employee)",
      "29:1109" : "29:1109 (29:1109 Breach of Fiduciary Duties)",
      "29:1131" : "29:1131 (29:1131 ERISA - Collection of Delinquent Trust Fun)",
      "29:1132" : "29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)",
      "29:1145" : "29:1145 (29:1145 E.R.I.S.A.)",
      "29:1149" : "29:1149 (29:1149 Recover Pension & Profit Sharing)",
      "29:1337" : "29:1337 (29:1337 E.R.I.S.A.)",
      "29:1362" : "29:1362 (29:1362 ERISA)",
      "29:1381" : "29:1381 (29:1381 E.R.I.S.A.)",
      "29:1401" : "29:1401 (29:1401(b)(2) Appeal of Arbitration Award)",
      "29:1451" : "29:1451 (29:1451 E.R.I.S.A.)",
      "29:1801" : "29:1801 (29:1801 Farmworker Rights)",
      "29:2601" : "29:2601 (29:2601 Family & Medical Leave Act)",
      "29:790" : "29:790 (29:790 Rehabilitation of Labor)",
      "30:0181" : "30:0181 (30:181 Environment: Review of Agency Action)",
      "30:0801" : "30:0801 (30:0801 Penalities/Federal Mine Safety Health Act)",
      "30:1201" : "30:1201 (30:1201 Environment: Review of Agency Action)",
      "30:1202" : "30:1202 (30:1202 Mining Reclamation Act)",
      "30:1276" : "30:1276 (30:1276 Interior: Review of Agency Action)",
      "31:3545" : "31:3545 (31:3545 Action to Recovery Money)",
      "31:3729" : "31:3729 (31:3729 False Claims Act)",
      "31:3730" : "31:3730 (31:3730 Qui Tam False Claims Act)",
      "31:3731" : "31:3731 (31:3731 Fraud)",
      "31:3733j2" : "31:3733j2 (31:3733(j)(2) Pet to Mod or Set Aside CV Investigative Demand)",
      "33:1319cw" : "33:1319cw (33:1319 Clean Water Act)",
      "33:1319pv" : "33:1319pv (33:1319 Pollutants & Permit Violations)",
      "33:1365" : "33:1365 (33:1365 Environmental Matters)",
      "33:2701" : "33:2701 (33:2701 Oil Pollution Act of 1990)",
      "35:0145" : "35:0145 (35:145 Patent Infringement)",
      "35:0183" : "35:0183 (35:183 Patent Infringement)",
      "35:0271" : "35:0271 (35:271 Patent Infringement)",
      "38:1681" : "38:1681 (38:1681 Recovery of VA Overpayment)",
      "38:1686" : "38:1686 (38:1686 Recovery of VA Overpayment)",
      "38:1780" : "38:1780 (38:1780 Recovery of VA Overpayment)",
      "38:2011" : "38:2011 (38:2011 - Veteran's Readjustment Assistance Act of)",
      "38:3116" : "38:3116 (38:3116 VA Overpayment)",
      "38:4323" : "38:4323 (38:4323 USERRA - Enforcement of rights with respect to state or private employer)",
      "39:3005" : "39:3005 (39:3005 Detention of Mail for Temporary Periods)",
      "39:409" : "39:409 (39:409 Postal Service)",
      "40:0258" : "40:0258 (40:258(a) Public Buildings & Property: Land Condem)",
      "40:0270" : "40:0270 (40:270 Miller Act)",
      "40:0875" : "40:0875 (40:875 Public Buildings & Property: Negligence)",
      "41:0251" : "41:0251 (41:251 Public Contracts-Review of Agency Action)",
      "41:1463" : "41:1463 (41:1463 Public Contracts: Unlawful Employment Prac)",
      "42:0205" : "42:0205 (42:205 Denial Social Security Benefits)",
      "42:0206" : "42:0206 (42:206 Social Security Benefits)",
      "42:0247" : "42:0247 (42:247 Personal Injury-Swine Flu)",
      "42:0402" : "42:0402 (42:402 Social Security Benefits)",
      "42:0405id" : "42:0405id (42:405 Review of HHS Decision (SSID))",
      "42:0405rsi" : "42:0405rsi (42:0405 Review of HHS Decision (RSI))",
      "42:0405wc" : "42:0405wc (42:405 Review of HHS Decision (DIWC))",
      "42:0405ww" : "42:0405ww (42:405 Review of HHS Decision (DIWW))",
      "42:0416" : "42:0416 (42:416 Denial of Social Security Benefits)",
      "42:0427" : "42:0427 (42:427 Social Security Benefits)",
      "42:11601" : "42:11601 (International Child Abduction Remedies Act)",
      "42:11603B" : "42:11603B (Int'l Child Abduction Remedies Act (ICARA) - Judicial Remedies)",
      "42:12112" : "42:12112 (42:12112 Americans with Disabilities Act)",
      "42:1383" : "42:1383 (42:1383 Review of HHS Decision)",
      "42:1395" : "42:1395 (42:1395 HHS: Adverse Reimbursement Review)",
      "42:1396" : "42:1396 (42:1396 - Tort Negligence)",
      "42:1471" : "42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclo)",
      "42:1971" : "42:1971 (42:1971 Voting Rights Act)",
      "42:1981cv" : "42:1981cv (42:1981 Civil Rights)",
      "42:1981hs" : "42:1981hs (42:1981 Housing Discrimination)",
      "42:1981jb" : "42:1981jb (42:1981 Job Discrimination (Race))",
      "42:1981sx" : "42:1981sx (42:1981 Sex Discrimination)",
      "42:1983cv" : "42:1983cv (42:1983 Civil Rights Act)",
      "42:1983ed" : "42:1983ed (42:1983 Civil Rights (Employment Discrimination))",
      "42:1983pr" : "42:1983pr (42:1983 Prisoner Civil Rights)",
      "42:1986" : "42:1986 (42:1986 Neglect of Duty)",
      "42:2000ag" : "42:2000ag (42:2000 Job Discrimination (Age))",
      "42:2000e" : "42:2000e (42:2000e Job Discrimination (Employment))",
      "42:2000e2" : "42:2000e2 (42:2000e2ot Job Discrimination (other))",
      "42:2000e3" : "42:2000e3 (42:2000 Unlawful Employment Practices)",
      "42:2000no" : "42:2000no (42:2000 Job Discrimination (National Origin))",
      "42:2000pb" : "42:2000pb (42:2000 Job Discrimination (Public Accomodations))",
      "42:2000ra" : "42:2000ra (42:2000 Job Discrimination (Race))",
      "42:2000rl" : "42:2000rl (42:2000 Job Discrimination (Religion))",
      "42:2000sx" : "42:2000sx (42:2000 Job Discrimination (Sex))",
      "42:2003" : "42:2003 (42:2003 Job Discrimination)",
      "42:2005" : "42:2005 (42:2005 Review of Agency Action-HHS)",
      "42:2651" : "42:2651 (42:2651 Medical Care Recovery)",
      "42:3601" : "42:3601 (42:405 Fair Housing Act)",
      "42:4000" : "42:4000 (42:4000 National Flood Insurance Act)",
      "42:4001" : "42:4001 (42:4001 National Insurance Flood Act)",
      "42:4053" : "42:4053 (42:4053 Breach of Insurance Contract)",
      "42:4072" : "42:4072 (42:4072 Payment of Flood Insurance Claim)",
      "42:423" : "42:423 (42:423 Social Security Act (Disability Insurance Benefit Payments))",
      "42:425" : "42:425 (42:427 Social Security Benefits)",
      "42:4321" : "42:4321 (42:4321 Review of Agency Action-Environment)",
      "42:4332" : "42:4332 (42:4332 Environmental Policy - Coop of Agency Repo)",
      "42:6901en" : "42:6901en (42:6901 Environmental Cleanup Expenses)",
      "42:6901rs" : "42:6901rs (42:6901 Resource & Recovery Act)",
      "42:6972" : "42:6972 (42:6972 Environmental Matters)",
      "42:7413" : "42:7413 (42:7413(b) Clean Air Act)",
      "42:7604cl" : "42:7604cl (42:7604 Clear Air Act (Emission Standards))",
      "42:7604ir" : "42:7604ir (42:7604 Petition to Quash IRS Summons)",
      "42:9607" : "42:9607 (42:9607 Real Property Tort to Land)",
      "42:9613" : "42:9613 (42:9613 Environmental Response, Compensation & Liability)",
      "43:945" : "43:945 (43:945 Compensation for Land Condemnation)",
      "43:945a" : "43:945a (43:945a Complaint in Condemnation)",
      "43:946" : "43:946 (43:946 Complaint in Condemnation - Eminent Domain)",
      "45:0051" : "45:0051 (45:51 Railways: Fed. Employer's Liability Act)",
      "45:0151" : "45:0151 (45:151 Railway Labor Act)",
      "45:0184" : "45:0184 (45:184 Action to Set Aside Award of a System Board)",
      "45:0231" : "45:0231 (45:0231 Railroad Retirement Act)",
      "45:1395" : "45:1395 (45:1395 Railroads: Adverse Reimbursement Review)",
      "45:7457" : "45:7457 (45:7457 Compel Reclamation Under Clear Air Act)",
      "46:0688" : "46:0688 (46:688 Jones Act)",
      "46:0741" : "46:0741 (46:741 Shipping)",
      "46:0761" : "46:0761 (46:761 Shipping: Damages for Death on High Seas)",
      "46:0762" : "46:0762 (46:762 Admiralty-Amount and apportionment of recovery)",
      "46:0961" : "46:0961 (46:0961 Foreclosure Preferred Ship Mortgage)",
      "46:1101" : "46:1101 (46:1101 Violation of Maritime Regulations)",
      "46:1156" : "46:1156 (46:1156 Administrative Procedure Act)",
      "46:1300" : "46:1300 (46:1300 Marine - Bills of Lading)",
      "46:183" : "46:183 (46:183 Limitation of Liability)",
      "46:688" : "46:688 (46:688 Jones Act)",
      "46:817" : "46:817 (46:817 Recover Freight Charges)",
      "46:951" : "46:951 (46:951 Marine Contract Actions)",
      "46:954" : "46:954 (46:954 Marine Foreclosure)",
      "47:0101" : "47:0101 (47:0101 Federal Communications Act of 1934)",
      "47:0227" : "47:0227 (47:0227 Telephone Consumer Protection Act)",
      "47:0230" : "47:0230 (47:0230 Blocking/Screening Offensive Material on Internet)",
      "47:0332" : "47:0332 (47:0332 Violation of Telecommunications Act of 1996)",
      "47:0553" : "47:0553 (47:0553 Cable Communications Policy Act of 1984)",
      "47:0605" : "47:0605 (47:0605 Unauthorized Publication/Use of Communications)",
      "48:0883" : "48:0883 (48:883 Violation of US Coastal Law)",
      "48:1985" : "48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)",
      "49:0081" : "49:0081 (49:81 Damaged Goods While Being Transported)",
      "49:0781" : "49:0781 (49:781 Forfeiture)",
      "49:1076" : "49:1076 (49:1076 ICC Rates)",
      "49:11503" : "49:11503 (49:11503 Railroad Revitalization Regulatory Reform)",
      "49:11702" : "49:11702 (49:11702(a)(4) Violations of Interstate Commerce A)",
      "49:1471" : "49:1471 (49:1471 Federal Aviation Act)",
      "49:1903" : "49:1903 (49:1903 Petition to enforce administrative summon)",
      "50a:533" : "50a:533 (50a:533 Servicemembers Civil Relief Act - mortgages)",
      "misc" : "misc (Civil Miscellaneous Case)"
   },
   "wiedce" : {
      "0" : "0 (No cause code entered)",
      "00:0000" : "00:0000 (00:0000 Cause Code Unknown)",
      "02:0431" : "02:0431 (02:431 Fed. Election Commission: Failure Enforce C)",
      "02:0437" : "02:0437 (02:437 Federal Election Commission)",
      "05:0075" : "05:0075 (05:75(2) Contract - Reduction in Grade)",
      "05:0551" : "05:0551 (05:551 Administrative Procedure Act)",
      "05:0552fi" : "05:0552fi (05:552 Freedom of Information Act)",
      "05:0552pa" : "05:0552pa (05:552 Right to Privacy Act)",
      "05:0554" : "05:0554 (05:0554 Constitutionality of Maritime Statutes)",
      "05:0701" : "05:0701 (05:0701 Maritime Subsidy Board)",
      "05:0702" : "05:0702 (05:702 Administrative Procedure Act)",
      "05:0704" : "05:0704 (05:704 Labor Litigation)",
      "05:7703" : "05:7703 (05:7703 Discrimination - Review of Agency Act)",
      "07:0006" : "07:0006 (7:6(b) Federal Commodity Exchange Regulation)",
      "07:0025" : "07:0025 (7:25 Fraud - Commodities Leverage Contracts)",
      "07:0181" : "07:0181 (07:181 Packers & Stockyard Act)",
      "07:0499" : "07:0499 (07:499 Agricultural Commodities Act)",
      "07:0601" : "07:0601 (07:601 USDA Condemnation)",
      "07:2321" : "07:2321 (07:2321 Plant Variety Protection Act)",
      "08:0287" : "08:0287 (08:0287 Petition to Vacate Arbitration Award)",
      "08:1105" : "08:1105 (8:1105(a) Aliens: Habeas Corpus to Release INS Det)",
      "08:1154" : "08:1154 (Immigration Status)",
      "08:1252" : "08:1252 (08:1252(a)(2) Injunction for Deportation)",
      "08:1260" : "08:1260 (08:1260 Aliens: Access to Records)",
      "08:1324" : "08:1324 (08:1324 Aliens: Complaint for Forfeiture)",
      "08:1329" : "08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petiti)",
      "08:1446" : "08:1446 (8:1446 Petition for Naturalization Hearing)",
      "08:1447" : "08:1447 (08:1447 Petition for Hearing Before a District Court)",
      "08:1451" : "08:1451 (08:1451 To Revoke Citizenship)",
      "08:287" : "08:287 (08:0287 Petition to Enforce INS Subpoena)",
      "09:0001" : "09:0001 (09:1 U.S. Arbitration Act)",
      "09:0009" : "09:0009 (9:9 Motion to Confirm Arbitration Award)",
      "09:0010" : "09:0010 (09:0010 Petition to Vacate Arbitration Award)",
      "10:1552" : "10:1552 (10:1552 Armed Forces: Action to Correct Records)",
      "10:1553" : "10:1553 (10:1553 Armed Forces: FOIA General)",
      "10:2305" : "10:2305 (10:2305 Review of Federal Contract)",
      "11:0101" : "11:0101 (11:101 Bankruptcy)",
      "12:0022" : "12:0022 (12:22 Securities Fraud)",
      "12:0635" : "12:0635 (12:635 Breach of Insurance Contract)",
      "12:1461" : "12:1461 (12:1461 Homeowners Loan Act)",
      "12:1703" : "12:1703 (12:1703 Default of HUD Loan)",
      "12:1725" : "12:1725 (12:1725 Collection under Contract Guaranty)",
      "12:1730" : "12:1730 (12:1730 Collection Under Contract Guaranty)",
      "12:1819" : "12:1819 (12:1819 Default of Promissory Note)",
      "12:1821" : "12:1821 (12:1821 Default of Loan by Promissary Note)",
      "12:1971" : "12:1971 (12:1971 Relief under Bank Holding Act)",
      "12:2601" : "12:2601 (12:2601 RESPA Real Estate Settlement Procedures Act)",
      "12:3410" : "12:3410 (12:3410 Right to Financial Privacy Act)",
      "15:0001" : "15:0001 (15:1 Antitrust Litigation)",
      "15:0002at" : "15:0002at (15:2 Antitrust Litigation)",
      "15:0002fl" : "15:0002fl (15:2(a) Fair Labor Standards Act)",
      "15:0005" : "15:0005 (15:5(a) Fair Labor Standards Act)",
      "15:0015" : "15:0015 (15:15 Antitrust Litigation)",
      "15:0025" : "15:0025 (15:25 Clayton Act)",
      "15:0044" : "15:0044 (15:44 Trademark Infringement)",
      "15:0045" : "15:0045 (15:0045 Federal Trade Commission Act)",
      "15:0052" : "15:0052 (15:0052 Federal Trade Commission Act)",
      "15:0053" : "15:0053 (15:0053 Federal Trade Commission Act)",
      "15:0077" : "15:0077 (15:77 Securities Fraud)",
      "15:0078" : "15:0078 (15:78m(a) Securities Exchange Act)",
      "15:0631" : "15:0631 (15:631 Small Business Act)",
      "15:0717" : "15:0717 (15:717 Natural Gas Act)",
      "15:1051" : "15:1051 (15:1051 Trademark Infringement)",
      "15:1114" : "15:1114 (15:1114 Trademark Infringement)",
      "15:1121" : "15:1121 (15:1121 Trademark Infringement)",
      "15:1125" : "15:1125 (15:1125 Trademark Infringement (Lanham Act))",
      "15:1126" : "15:1126 (15:1126 Patent Infringement)",
      "15:1127" : "15:1127 (15:1127 Trademark Infringement)",
      "15:1601" : "15:1601 (15:1601 Truth in Lending)",
      "15:1640" : "15:1640 (15:1640 Truth in Lending)",
      "15:1681" : "15:1681 (15:1681 Fair Credit Reporting Act)",
      "15:1692" : "15:1692 (15:1692 Fair Debt Collection Act)",
      "15:1693" : "15:1693 (15:1693 Electronic Funds Transfer Act)",
      "15:1938" : "15:1938 (15:1938 Fair Labor Standards Act)",
      "15:1981" : "15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))",
      "15:1988" : "15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))",
      "15:1989" : "15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))",
      "15:2301" : "15:2301 (15:2301 Magnuson-Moss Warranty Act)",
      "15:2801" : "15:2801 (15:2801 Petroleum Marketing Practices Act)",
      "15:53(b)" : "15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equita)",
      "16:0668" : "16:0668 (16:668 Bald Eagle Protection Act)",
      "16:0703" : "16:0703 (16:703 Migratory Bird Act)",
      "16:1538" : "16:1538 (16:1538 Endangered Species Act)",
      "16:3371" : "16:3371 (16:3371 Wildlife Under the Lacey Act)",
      "16:3372" : "16:3372 (16:3372 Conservation: Complaint for Forfeiture)",
      "16:3373" : "16:3373 (16:3373 Appeal of Decision - DOI)",
      "16:3374" : "16:3374 (16:3374 Conservation: Complaint for Forfeiture)",
      "17:0101" : "17:0101 (17:101 Copyright Infringement)",
      "17:0501" : "17:0501 (17:501 Copyright Infringement)",
      "17:0504" : "17:0504 (17:504 Copyright Infringement)",
      "18:0241" : "18:0241 (18:241 Conspiracy Against Citizen Rights)",
      "18:0924" : "18:0924 (18:0924 Civil Forfeiture of Firearms)",
      "18:0981" : "18:0981 (18:0981 Civil Forfeiture)",
      "18:0984" : "18:0984 (18:0984 Civil Forfeiture of Fungible Property)",
      "18:1030" : "18:1030 (18:1030 Computer Fraud & Abuse Act)",
      "18:1595" : "18:1595 (18:1585 (human trafficking, peonage, slavery))",
      "18:1836a" : "18:1836a (18:1836(a) Injunction against Misappropriation of Trade Secrets)",
      "18:1836b" : "18:1836b (18:1836(b) Civil Action to Protect Trade Secrets)",
      "18:1961" : "18:1961 (18:1961 Racketeering (RICO) Act)",
      "18:1962" : "18:1962 (18:1962 Racketeering (RICO) Act)",
      "18:1964" : "18:1964 (18:1964 Racketeering (RICO) Act)",
      "18:2255" : "18:2255 (18:2255 Civil Remedy for Personal Injuries)",
      "18:2510-2521" : "18:2510-2521 (18:2510 Electronic Communications Privacy Act)",
      "18:3114" : "18:3114 (18:3114 Motion for Return of Seized Property)",
      "18:4208" : "18:4208 (18:4208(B) Agency Action Review)",
      "19:1305" : "19:1305 (19:1305 Custom Duties:0Forfeiture-Immoral Articles)",
      "20:1080" : "20:1080 (20:1080 Student Loan Recovery)",
      "20:1095" : "20:1095 (Wage Garnishment)",
      "20:1400" : "20:1400 (20:1400 Civil Rights of Handicapped Child)",
      "20:1401" : "20:1401 (20:1401 Education: Handicapped Child Act)",
      "21:0841" : "21:0841 (21:841 Forfeiture Property-Drugs)",
      "21:0881" : "21:0881 (21:881 Forfeiture Property-Drugs)",
      "21:0881a" : "21:0881a (21:881 Forfeiture Property - Aircraft)",
      "21:0881re" : "21:0881re (21:881 Forfeiture Property - Real Estate)",
      "23:0134" : "23:0134 (23:134 P.I.- Auto Negligence)",
      "23:1441" : "23:1441 (23:1441 Contract Real Estate)",
      "24:1000" : "24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)",
      "25:0640" : "25:0640 (25:640 Indian Tribal Rights)",
      "25:1901" : "25:1901 (25:1901 Indian Child Welfare Act)",
      "26:6212" : "26:6212 (26:6212 Injunctive Relief from IRS Lien)",
      "26:6213" : "26:6213 (26:6213 Injunctive Relief from IRS Lien)",
      "26:6502" : "26:6502 (26:6502 IRS:Enforcement of tax liens)",
      "26:6532" : "26:6532 (26:6532 IRS: Refund of Tax Penalty)",
      "26:6702" : "26:6702 (26:6702 IRS: Refund of Income Tax Penalty)",
      "26:6703" : "26:6703 (26:6703 IRS: Refund of Tax Penalty)",
      "26:7401" : "26:7401 (26:7401 IRS: Tax Liability)",
      "26:7402" : "26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)",
      "26:7403" : "26:7403 (26:7403 Suit to Enforce Federal Tax Lien)",
      "26:7422rt" : "26:7422rt (26:7422 IRS: Refund Taxes)",
      "26:7422rx" : "26:7422rx (26:7422 IRS: Refund Excise Tax)",
      "26:7426" : "26:7426 (26:7426 IRS: Wrongful Levy for Taxes)",
      "26:7429" : "26:7429 (26:7429 IRS: Tax Jeopardy Assessment)",
      "26:7609" : "26:7609 (26:7609 IRS: Petition to Quash IRS Summons)",
      "27:0185" : "27:0185 (27:185 Enforcement of Arbitration Award)",
      "28:0157c" : "28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)",
      "28:0157d" : "28:0157d (28:0157 Motion for Withdrawal of Reference)",
      "28:0158" : "28:0158 (28:0158 Notice of Appeal re Bankruptcy Matter (BA)",
      "28:0185" : "28:0185 (28:185 Suit to Compel Arbitration)",
      "28:0451" : "28:0451 (28:451 Employment Discrimination)",
      "28:0794" : "28:0794 (28:794 Rehabilitation Act)",
      "28:1001" : "28:1001 (28:1001 E.R.I.S.A.)",
      "28:1132" : "28:1132 (28:1132 E.R.I.S.A.)",
      "28:1330" : "28:1330 (28:1330 Breach of Contract)",
      "28:1331" : "28:1331 (28:1331 Fed. Question)",
      "28:1331al" : "28:1331al (28:1331 Fed. Question: Airline Crash)",
      "28:1331at" : "28:1331at (28:1331 Fed. Question: Anti-trust)",
      "28:1331au" : "28:1331au (28:1331 Fed. Question: Auto Negligence)",
      "28:1331b" : "28:1331b (28:1331 Federal Question: Bivens Act)",
      "28:1331bc" : "28:1331bc (28:1331 Fed. Question: Breach of Contract)",
      "28:1331ca" : "28:1331ca (28:1331 Fed Question: Fed Communications Act of 1)",
      "28:1331cm" : "28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)",
      "28:1331cv" : "28:1331cv (28:1331 Federal Question: Other Civil Rights)",
      "28:1331ed" : "28:1331ed (28:1331 Fed. Question: Employment Discrimination)",
      "28:1331es" : "28:1331es (28:1331 Enforcement of Administrative Subpoena)",
      "28:1331fl" : "28:1331fl (28:1331 Fed. Question: Fair Labor Standards)",
      "28:1331in" : "28:1331in (28:1331 Fed. Question: Insurance Contract)",
      "28:1331mm" : "28:1331mm (28:1331 Fed. Question: Medical Malpractice)",
      "28:1331pi" : "28:1331pi (28:1331 Fed. Question: Personal Injury)",
      "28:1331rd" : "28:1331rd (28:1331 Fed. Question: Review Agency Decision)",
      "28:1331rp" : "28:1331rp (28:1331(a) Fed. Question: Real Property)",
      "28:1331rr" : "28:1331rr (28:1331 Fed. Question: Railway Labor Act)",
      "28:1331sv" : "28:1331sv (28:1331 Fed. Question: Securities Violation)",
      "28:1331tr" : "28:1331tr (28:1331 Fed. Question: Trademark)",
      "28:1331tt" : "28:1331tt (28:1331 Fed. Question: Tort Action)",
      "28:1331v" : "28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendme)",
      "28:1331wl" : "28:1331wl (28:1331 Federal Question: EPA Waste Lien)",
      "28:1331wt" : "28:1331wt (28:1331 Fed. Question: Water Rights)",
      "28:1332ac" : "28:1332ac (28:1332 Diversity-Account Receivable)",
      "28:1332al" : "28:1332al (28:1332 Diversity-Airline Crash)",
      "28:1332as" : "28:1332as (28:1332 Diversity-Asbestos Litigation)",
      "28:1332au" : "28:1332au (28:1332 Diversity-Auto Negligence)",
      "28:1332bc" : "28:1332bc (28:1332 Diversity-Breach of Contract)",
      "28:1332co" : "28:1332co (28:1332 Diversity-Conversion)",
      "28:1332ct" : "28:1332ct (28:1332 Diversity-(Citizenship))",
      "28:1332det" : "28:1332det (28:1332 Diversity: Forcible Detainer)",
      "28:1332df" : "28:1332df (28:1332 Diversity-Contract Default)",
      "28:1332ds" : "28:1332ds (28:1332 Diversity-Contract Dispute)",
      "28:1332ed" : "28:1332ed (28:1332 Diversity-Employment Discrimination)",
      "28:1332fd" : "28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)",
      "28:1332fr" : "28:1332fr (28:1332 Diversity-Fraud)",
      "28:1332ia" : "28:1332ia (28:1332 Diversity-Interpleader Action)",
      "28:1332ij" : "28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)",
      "28:1332in" : "28:1332in (28:1332 Diversity-Insurance Contract)",
      "28:1332jd" : "28:1332jd (28:1332 Diversity-Declaratory Judgement)",
      "28:1332lb" : "28:1332lb (28:1332 Diversity-Libel,Assault,Slander)",
      "28:1332lm" : "28:1332lm (28:1332 Diversity - Legal Malpractice)",
      "28:1332ma" : "28:1332ma (28:1332 Diversity-Miller Act)",
      "28:1332mm" : "28:1332mm (28:1332 Diversity-Medical Malpractice)",
      "28:1332mv" : "28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)",
      "28:1332ni" : "28:1332ni (28:1332 Diversity-Negotiable Instrument)",
      "28:1332nm" : "28:1332nm (28:1332 Diversity-Non-Motor Vehicle)",
      "28:1332oc" : "28:1332oc (28:1332 Diversity-Other Contract)",
      "28:1332pd" : "28:1332pd (28:1332 Diversity-Property Damage)",
      "28:1332pi" : "28:1332pi (28:1332 Diversity-Personal Injury)",
      "28:1332pl" : "28:1332pl (28:1332 Diversity-Product Liability)",
      "28:1332pr" : "28:1332pr (28:1332 Diversity-Petition for Removal)",
      "28:1332qt" : "28:1332qt (28:1332 Diversity-Petition to Quiet Title)",
      "28:1332ri" : "28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)",
      "28:1332sa" : "28:1332sa (28:1332 - Diversity: Securities & Exchange Commiss)",
      "28:1332sf" : "28:1332sf (28:1332 - Diversity: Securities Fraud)",
      "28:1332ss" : "28:1332ss (28:1332 Diversity - Stockholders Suits)",
      "28:1332tl" : "28:1332tl (28:1332 Diversity-Torts to Land)",
      "28:1332tm" : "28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))",
      "28:1332tn" : "28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)",
      "28:1332wd" : "28:1332wd (28:1332 Diversity-Wrongful Death)",
      "28:1333" : "28:1333 (28:1333 Admiralty)",
      "28:1334" : "28:1334 (28:1334 Bankruptcy Appeal)",
      "28:1334c" : "28:1334c (28:1334(c) R&R re motions for abstention (non-cor)",
      "28:1335" : "28:1335 (28:1335 Interpleader Action)",
      "28:1337" : "28:1337 (28:1337 Sherman-Clayton Act)",
      "28:1338cp" : "28:1338cp (28:1338 Copyright Infringement)",
      "28:1338pt" : "28:1338pt (28:1338 Patent Infringement)",
      "28:1338tr" : "28:1338tr (28:1338 Trademark Infringement)",
      "28:1340" : "28:1340 (28:1340 IRS: Custom Duties)",
      "28:1340er" : "28:1340er (28:1340 Recovery of Erroneous Refund)",
      "28:1341" : "28:1341 (28:1341 Complaint for Forfeiture)",
      "28:1343" : "28:1343 (28:1343 Violation of Civil Rights)",
      "28:1345co" : "28:1345co (28:1345 Replevin & Conversion)",
      "28:1345db" : "28:1345db (28:1345 Debt to US - FHA/HUD Title I)",
      "28:1345df" : "28:1345df (28:1345 Default of Promissory Note)",
      "28:1345er" : "28:1345er (28:1345 Recovery of Erroneous Refund)",
      "28:1345fc" : "28:1345fc (28:1345 Foreclosure)",
      "28:1345ff" : "28:1345ff (28:1345 Complaint for Forfeiture)",
      "28:1345hl" : "28:1345hl (28:1345 VA Home Loan Guaranty Debt)",
      "28:1345mc" : "28:1345mc (28:1345 Medical Care Recovery)",
      "28:1345mi" : "28:1345mi (28:1345 Mining Claim Ejectment)",
      "28:1345pd" : "28:1345pd (28:1345 Property Damage)",
      "28:1345pe" : "28:1345pe (28:1345 Property Ejectment)",
      "28:1345rc" : "28:1345rc (28:1345 Recovery of Debt to US)",
      "28:1345st" : "28:1345st (28:1345 Default of Student Loan)",
      "28:1345tp" : "28:1345tp (28:1345 Trespass on Public Land)",
      "28:1345va" : "28:1345va (28:1345 Recovery of VA Overpayment)",
      "28:1346bc" : "28:1346bc (28:1346 Breach of Contract)",
      "28:1346rc" : "28:1346rc (28:1346 Recovery of IRS Tax)",
      "28:1346tc" : "28:1346tc (28:1346 Tort Claim)",
      "28:1346wd" : "28:1346wd (28:1346 Wrongful Death)",
      "28:1352" : "28:1352 (28:1352 Miller Act)",
      "28:1355" : "28:1355 (28:1355 Petition for Return of Property)",
      "28:1358" : "28:1358 (28:1358 Land Condemnation)",
      "28:1361" : "28:1361 (28:1361 Petition for Writ of Mandamus)",
      "28:1362ic" : "28:1362ic (28:1362 Indian Tribal Controversy)",
      "28:1362iw" : "28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)",
      "28:1364" : "28:1364 (28:1364 Auto Negligence)",
      "28:1402" : "28:1402 (28:1402 Medical Malpractice)",
      "28:1407" : "28:1407 (28:1407 Multi-district Litigation)",
      "28:1441ac" : "28:1441ac (28:1441 Petition for Removal- Account Receivable)",
      "28:1441al" : "28:1441al (28:1441 Petition for Removal- Airline Crash)",
      "28:1441as" : "28:1441as (28:1441 Petition for Removal- Asbestos Litigation)",
      "28:1441au" : "28:1441au (28:1441 Petition for Removal- Auto Negligence)",
      "28:1441bc" : "28:1441bc (28:1441 Petition for Removal- Breach of Contract)",
      "28:1441cv" : "28:1441cv (28:1441 Petition for Removal- Civil Rights Act)",
      "28:1441df" : "28:1441df (28:1441 Petition for Removal- Contract Default)",
      "28:1441dj" : "28:1441dj (28:1441 Petition for Removal- Declaratory Judgment)",
      "28:1441ds" : "28:1441ds (28:1441 Petition for Removal- Contract Dispute)",
      "28:1441ed" : "28:1441ed (28:1441 Petition for Removal - Employment Discrim)",
      "28:1441fc" : "28:1441fc (28:1441 Petition for Removal - Fair Credit Reporti)",
      "28:1441fl" : "28:1441fl (28:1441 Petition for Removal - Fair Labor Standards Act)",
      "28:1441fr" : "28:1441fr (28:1441 Petition for Removal- Fraud)",
      "28:1441ij" : "28:1441ij (28:1441 Petition for Removal- Injunctive/Declarato)",
      "28:1441in" : "28:1441in (28:1441 Petition for Removal- Insurance Contract)",
      "28:1441int" : "28:1441int (28:1441 Petition for Removal- Action for Interplea)",
      "28:1441lb" : "28:1441lb (28:1441 Petition for Removal Libel,Assault,Slander)",
      "28:1441lm" : "28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relatio)",
      "28:1441mm" : "28:1441mm (28:1441 Petition for Removal- Medical Malpractice)",
      "28:1441ni" : "28:1441ni (28:1441 Petition for Removal- Negotiable Instrumen)",
      "28:1441nm" : "28:1441nm (28:1441 Petition for Removal- Non-Motor Vehicle)",
      "28:1441oc" : "28:1441oc (28:1441 Petition For Removal--Other Contract)",
      "28:1441pd" : "28:1441pd (28:1441 Petition for Removal- Property Damage)",
      "28:1441pi" : "28:1441pi (28:1441 Petition for Removal- Personal Injury)",
      "28:1441pl" : "28:1441pl (28:1441 Petition for Removal- Product Liability)",
      "28:1441pr" : "28:1441pr (28:1441 Petition for Removal)",
      "28:1441qt" : "28:1441qt (28:1441 Petition for Removal- Petition to Quiet Ti)",
      "28:1441ri" : "28:1441ri (28:1441 Petition for Removal- Racketeering (RICO))",
      "28:1441sa" : "28:1441sa (28:1441 - Petition for Removal: SEC Act)",
      "28:1441sf" : "28:1441sf (28:1441 - Petition for Removal: Securities Fraud)",
      "28:1441tl" : "28:1441tl (28:1441 Petition for Removal- Torts to Land)",
      "28:1441tm" : "28:1441tm (28:1441 Petition for Removal- Tort/Motor Vehicle ()",
      "28:1441tn" : "28:1441tn (28:1441 Petition for Removal- Tort/Non-Motor Vehic)",
      "28:1441wd" : "28:1441wd (28:1441 Petition for Removal- Wrongful Death)",
      "28:1442bc" : "28:1442bc (28:1442 Petition for Removal- Breach of Contract)",
      "28:1442pr" : "28:1442pr (28:1442 Petition for Removal)",
      "28:1443" : "28:1443 (28:1443(1) Rent, Lease & Ejectment)",
      "28:1444" : "28:1444 (28:1444 Petition for Removal- Foreclosure)",
      "28:1446in" : "28:1446in (28:1446 Breach of Contract- Insurance)",
      "28:1446pd" : "28:1446pd (28:1446 Petition for Removal- Property Damage (P.I)",
      "28:1446pi" : "28:1446pi (28:1446 Petition for Removal- Personal Injury)",
      "28:1446pl" : "28:1446pl (28:1446pl Petition for Removal - Product Liability)",
      "28:1446pr" : "28:1446pr (28:1446 Petition for Removal)",
      "28:1452" : "28:1452 (28:1452 R&R re motions to remand (non-core))",
      "28:1651" : "28:1651 (28:1651 Petition for Writ of Coram Nobis)",
      "28:1651hc" : "28:1651hc (28:1651 Petition for Writ of Habeas Corpus)",
      "28:1651mn" : "28:1651mn (28:1651 Petition for Writ of Mandamus)",
      "28:2201" : "28:2201 (28:2201 Constitutionality of State Statute(s))",
      "28:2201dj" : "28:2201dj (28:2201 Declaratory Judgment)",
      "28:2201ij" : "28:2201ij (28:2201 Injunction)",
      "28:2201in" : "28:2201in (28:2201 Declaratory Judgment (Insurance))",
      "28:2241" : "28:2241 (28:2241 Petition for Writ of Habeas Corpus (federal))",
      "28:2254" : "28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))",
      "28:2254se" : "28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)",
      "28:2255" : "28:2255 (28:2255 Motion to Vacate / Correct Illegal Sentence)",
      "28:2271" : "28:2271 (28:2271 Federal Tort Claims Act)",
      "28:2345" : "28:2345 (28:2345 Medicare Recovery)",
      "28:2409" : "28:2409 (28:2409(a) Quiet Title Action)",
      "28:2410" : "28:2410 (28:2410 Quiet Title)",
      "28:2671" : "28:2671 (28:2671 Federal Tort Claims Act)",
      "28:2674" : "28:2674 (28:2674 Federal Tort Claims Act)",
      "28:7402" : "28:7402 (28:7402 Refund of Taxes)",
      "28:7422" : "28:7422 (28:7422 Appeal from Administrative Decision)",
      "29:0151" : "29:0151 (29:151 Labor: Review of Agency Action)",
      "29:0160" : "29:0160 (29:160(1) National Labor Relations Act)",
      "29:0184" : "29:0184 (29:184 Violation Collection Bargain Agreement)",
      "29:0185ep" : "29:0185ep (29:185 Employee Pension Plan)",
      "29:0185lm" : "29:0185lm (29:185 Labor/Mgt. Relations (Contracts))",
      "29:0201do" : "29:0201do (29:201 Denial of Overtime Compensation)",
      "29:0201fl" : "29:0201fl (29:201 Fair Labor Standards Act)",
      "29:0203" : "29:0203 (29:203 Equal Pay Act)",
      "29:0206" : "29:0206 (29:206 Collect Unpaid Wages)",
      "29:0401" : "29:0401 (29:0401 Labor Management Disclosure Act)",
      "29:0621" : "29:0621 (29:621 Job Discrimination (Age))",
      "29:0623" : "29:0623 (29:623 Job Discrimination (Age))",
      "29:0626" : "29:0626 (29:626 Job Discrimination (Age))",
      "29:0633" : "29:0633 (29:633 Job Discrimination (Age))",
      "29:0651" : "29:0651 (29:651 Occupational Safety/Health)",
      "29:0754" : "29:0754 (29:754 Discrimination)",
      "29:0791" : "29:0791 (29:791 Job Discrimination (Rehabilitation Act))",
      "29:0794" : "29:0794 (29:0794 Job Discrimination (Handicap))",
      "29:1001" : "29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)",
      "29:1002" : "29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)",
      "29:1104" : "29:1104 (29:1104 Recovery of Benefits to Employee)",
      "29:1109" : "29:1109 (29:1109 Breach of Fiduciary Duties)",
      "29:1131" : "29:1131 (29:1131 ERISA - Collection of Delinquent Trust Fun)",
      "29:1132" : "29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)",
      "29:1145" : "29:1145 (29:1145 E.R.I.S.A.)",
      "29:1149" : "29:1149 (29:1149 Recover Pension & Profit Sharing)",
      "29:1337" : "29:1337 (29:1337 E.R.I.S.A.)",
      "29:1362" : "29:1362 (29:1362 ERISA)",
      "29:1381" : "29:1381 (29:1381 E.R.I.S.A.)",
      "29:1401" : "29:1401 (29:1401(b)(2) Appeal of Arbitration Award)",
      "29:1451" : "29:1451 (29:1451 E.R.I.S.A.)",
      "29:1801" : "29:1801 (29:1801 Farmworker Rights)",
      "29:2104" : "29:2104 (29:2104 Warn Act)",
      "29:2601" : "29:2601 (29:2601 Family & Medical Leave Act 1993)",
      "29:790" : "29:790 (29:790 Rehabilitation of Labor)",
      "30:0181" : "30:0181 (30:181 Environment: Review of Agency Action)",
      "30:0801" : "30:0801 (30:0801 Penalities/Federal Mine Safety Health Act)",
      "30:1201" : "30:1201 (30:1201 Environment: Review of Agency Action)",
      "30:1202" : "30:1202 (30:1202 Mining Reclamation Act)",
      "30:1276" : "30:1276 (30:1276 Interior: Review of Agency Action)",
      "31:3545" : "31:3545 (31:3545 Action to Recovery Money)",
      "31:3729" : "31:3729 (31:3729 False Claims Act)",
      "31:3730" : "31:3730 (31:3730 Qui Tam False Claims Act)",
      "31:3731" : "31:3731 (31:3731 Fraud)",
      "31:5317fm" : "31:5317fm (31:5317(c)(2) Forfeiture of Monetary Instruments)",
      "33:1319cw" : "33:1319cw (33:1319 Clean Water Act)",
      "33:1319pv" : "33:1319pv (33:1319 Pollutants & Permit Violations)",
      "33:1365" : "33:1365 (33:1365 Environmental Matters)",
      "35:0145" : "35:0145 (35:145 Patent Infringement)",
      "35:0183" : "35:0183 (35:183 Patent Infringement)",
      "35:0271" : "35:0271 (35:271 Patent Infringement)",
      "38:1681" : "38:1681 (38:1681 Recovery of VA Overpayment)",
      "38:1686" : "38:1686 (38:1686 Recovery of VA Overpayment)",
      "38:1729" : "38:1729 (38:1729 Recovery by the United States of the Cost of Certain Care and Services)",
      "38:1780" : "38:1780 (38:1780 Recovery of VA Overpayment)",
      "38:2011" : "38:2011 (38:2011 - Veteran's Readjustment Assistance Act of)",
      "38:3116" : "38:3116 (38:3116 VA Overpayment)",
      "38:4301" : "38:4301 (38:4301 Uniformed Services Employment & Reemployment Rights Act)",
      "39:3005" : "39:3005 (39:3005 Detention of Mail for Temporary Periods)",
      "39:409" : "39:409 (39:409 Postal Service)",
      "40:0258" : "40:0258 (40:258(a) Public Buildings & Property: Land Condem)",
      "40:0270" : "40:0270 (40:270 Miller Act)",
      "40:0875" : "40:0875 (40:875 Public Buildings & Property: Negligence)",
      "41:0251" : "41:0251 (41:251 Public Contracts-Review of Agency Action)",
      "41:1463" : "41:1463 (41:1463 Public Contracts: Unlawful Employment Prac)",
      "42:0205" : "42:0205 (42:205 Denial Social Security Benefits)",
      "42:0206" : "42:0206 (42:206 Social Security Benefits)",
      "42:0247" : "42:0247 (42:247 Personal Injury-Swine Flu)",
      "42:0402" : "42:0402 (42:402 Social Security Benefits)",
      "42:0405id" : "42:0405id (42:405 Review of HHS Decision (SSID))",
      "42:0405wc" : "42:0405wc (42:405 Review of HHS Decision (DIWC))",
      "42:0405ww" : "42:0405ww (42:405 Review of HHS Decision (DIWW))",
      "42:0416" : "42:0416 (42:416 Denial of Social Security Benefits)",
      "42:0427" : "42:0427 (42:427 Social Security Benefits)",
      "42:1383" : "42:1383 (42:1383 Review of HHS Decision)",
      "42:1395" : "42:1395 (42:1395 HHS: Adverse Reimbursement Review)",
      "42:1396" : "42:1396 (42:1396 - Tort Negligence)",
      "42:1471" : "42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclo)",
      "42:1981cv" : "42:1981cv (42:1981 Civil Rights)",
      "42:1981hs" : "42:1981hs (42:1981 Housing Discrimination)",
      "42:1981jb" : "42:1981jb (42:1981 Job Discrimination (Race))",
      "42:1981sx" : "42:1981sx (42:1981 Sex Discrimination)",
      "42:1983cv" : "42:1983cv (42:1983 Civil Rights Act)",
      "42:1983ed" : "42:1983ed (42:1983 Civil Rights (Employment Discrimination))",
      "42:1983pr" : "42:1983pr (42:1983 Prisoner Civil Rights)",
      "42:1985" : "42:1985 (42:1985 Conspiracy Civil Rights)",
      "42:1986" : "42:1986 (42:1986 Neglect of Duty)",
      "42:2000ada" : "42:2000ada (42:2000 American Disabilities Act)",
      "42:2000ag" : "42:2000ag (42:2000 Job Discrimination (Age))",
      "42:2000e" : "42:2000e (42:2000e Job Discrimination (Employment))",
      "42:2000pb" : "42:2000pb (42:2000 Job Discrimination (Public Accomodations))",
      "42:2000ra" : "42:2000ra (42:2000 Job Discrimination (Race))",
      "42:2000sx" : "42:2000sx (42:2000 Job Discrimination (Sex))",
      "42:2003" : "42:2003 (42:2003 Job Discrimination)",
      "42:2005" : "42:2005 (42:2005 Review of Agency Action-HHS)",
      "42:2651" : "42:2651 (42:2651 Medical Care Recovery)",
      "42:3601" : "42:3601 (42:405 Fair Housing Act)",
      "42:4000" : "42:4000 (42:4000 National Flood Insurance Act)",
      "42:4001" : "42:4001 (42:4001 National Insurance Flood Act)",
      "42:4053" : "42:4053 (42:4053 Breach of Insurance Contract)",
      "42:4072" : "42:4072 (42:4072 Payment of Flood Insurance Claim)",
      "42:4321" : "42:4321 (42:4321 Review of Agency Action-Environment)",
      "42:4332" : "42:4332 (42:4332 Environmental Policy - Coop of Agency Repo)",
      "42:6901en" : "42:6901en (42:6901 Environmental Cleanup Expenses)",
      "42:6901rs" : "42:6901rs (42:6901 Resource & Recovery Act)",
      "42:7413" : "42:7413 (42:7413(b) Clean Air Act)",
      "42:7604cl" : "42:7604cl (42:7604 Clear Air Act (Emission Standards))",
      "42:7604ir" : "42:7604ir (42:7604 Petition to Quash IRS Summons)",
      "42:9607" : "42:9607 (42:9607 Real Property Tort to Land)",
      "43:945" : "43:945 (43:945 Compensation for Land Condemnation)",
      "43:945a" : "43:945a (43:945a Complaint in Condemnation)",
      "43:946" : "43:946 (43:946 Complaint in Condemnation - Eminent Domain)",
      "45:0051" : "45:0051 (45:51 Railways: Fed. Employer's Liability Act)",
      "45:0151" : "45:0151 (45:151 Railway Labor Act)",
      "45:0184" : "45:0184 (45:184 Action to Set Aside Award of a System Board)",
      "45:1395" : "45:1395 (45:1395 Railroads: Adverse Reimbursement Review)",
      "45:7457" : "45:7457 (45:7457 Compel Reclamation Under Clear Air Act)",
      "46:0688" : "46:0688 (46:688 Jones Act)",
      "46:0741" : "46:0741 (46:741 Shipping)",
      "46:0761" : "46:0761 (46:761 Shipping: Damages for Death on High Seas)",
      "46:1101" : "46:1101 (46:1101 Violation of Maritime Regulations)",
      "46:1156" : "46:1156 (46:1156 Administrative Procedure Act)",
      "46:31301" : "46:31301 (46:31301 Preferred Maritime Lien)",
      "47:227" : "47:227 (47:227 Telephone Consumer Protection Act)",
      "47:605" : "47:605 (47:605 Federal Communications Act of 1983)",
      "48:0883" : "48:0883 (48:883 Violation of US Coastal Law)",
      "48:1985" : "48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)",
      "49:0081" : "49:0081 (49:81 Damaged Goods While Being Transported)",
      "49:0781" : "49:0781 (49:781 Forfeiture)",
      "49:11503" : "49:11503 (49:11503 Railroad Revitalization Regulatory Reform)",
      "49:11702" : "49:11702 (49:11702(a)(4) Violations of Interstate Commerce A)",
      "49:1471" : "49:1471 (49:1471 Federal Aviation Act)",
      "49:1903" : "49:1903 (49:1903 Petition to enforce administrative summon)",
      "49:31105" : "49:31105 (49:31105 Surface Transportation Assistance Act)",
      "50:591" : "50:591 (50:591 Servicemembers Civil Relief Act)",
      "8:287" : "8:287 (8:287 Petition to Enforce INS Subpoena)",
      "adsup" : "adsup (Administrative Subpoena)",
      "contempt" : "contempt (Contempt Proceedings)",
      "disbar" : "disbar (Disbarment Proceedings)",
      "fordepo" : "fordepo (Foreign Deposition)",
      "misc" : "misc (Civil Miscellaneous Case)",
      "motcomp" : "motcomp (Motion to Compel)",
      "motquash" : "motquash (Motion to Quash)",
      "motret" : "motret (Motion of Return of Property)",
      "petenf" : "petenf (Petition to Enforce IRS Summons)",
      "petper" : "petper (Petition to Perpetuate Testimony)",
      "regjgm" : "regjgm (Registration of Foreign Judgment)",
      "tranbkref" : "tranbkref (Transmission of Bankruptcy Reference)",
      "tranff" : "tranff (Transmission of Proposed Findings of Fact and Concl. of Law)",
      "writgar" : "writgar (Application for a Writ of Garnishment)"
   },
   "wiwdce" : {
      "0" : "0 (No cause code entered)",
      "02:0431" : "02:0431 (02:431 Fed. Election Commission: Failure Enforce C)",
      "02:0437" : "02:0437 (02:437 Federal Election Commission)",
      "05:0075" : "05:0075 (05:75(2) Contract - Reduction in Grade)",
      "05:0551" : "05:0551 (05:551 Administrative Procedure Act)",
      "05:0552fi" : "05:0552fi (05:552 Freedom of Information Act)",
      "05:0552pa" : "05:0552pa (05:552 Right to Privacy Act)",
      "05:0554" : "05:0554 (05:0554 Constitutionality of Maritime Statutes)",
      "05:0701" : "05:0701 (05:0701 Maritime Subsidy Board)",
      "05:0702" : "05:0702 (05:702 Administrative Procedure Act)",
      "05:0704" : "05:0704 (05:704 Labor Litigation)",
      "05:7703" : "05:7703 (05:7703 Discrimination - Review of Agency Act)",
      "07:0006" : "07:0006 (7:6(b) Federal Commodity Exchange Regulation)",
      "07:0025" : "07:0025 (7:25 Fraud - Commodities Leverage Contracts)",
      "07:0181" : "07:0181 (07:181 Packers & Stockyard Act)",
      "07:0499" : "07:0499 (07:499 Agricultural Commodities Act)",
      "07:0601" : "07:0601 (07:601 USDA Condemnation)",
      "07:2321" : "07:2321 (07:2321 Plant Variety Protection Act)",
      "08:1105" : "08:1105 (8:1105(a) Aliens: Habeas Corpus to Release INS Det)",
      "08:1252" : "08:1252 (08:1252(a)(2) Injunction for Deportation)",
      "08:1260" : "08:1260 (08:1260 Aliens: Access to Records)",
      "08:1324" : "08:1324 (08:1324 Aliens: Complaint for Forfeiture)",
      "08:1329" : "08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petiti)",
      "08:1446" : "08:1446 (8:1446 Petition for Naturalization Hearing)",
      "08:1447" : "08:1447 (8:1447 Petition for Naturalization Hearing)",
      "08:287" : "08:287 (8:287 Petition to Enforce INS Subpoena)",
      "09:0001" : "09:0001 (09:1 U.S. Arbitration Act)",
      "09:0009" : "09:0009 (9:9 Motion to Confirm Arbitration Loan)",
      "09:0010" : "09:0010 (09:0010 Petition to Vacate Arbitration Award)",
      "10:1552" : "10:1552 (10:1552 Armed Forces: Action to Correct Records)",
      "10:1553" : "10:1553 (10:1553 Armed Forces: FOIA General)",
      "10:2305" : "10:2305 (10:2305 Review of Federal Contract)",
      "11:0101" : "11:0101 (11:101 Bankruptcy)",
      "12:0022" : "12:0022 (12:22 Securities Fraud)",
      "12:0635" : "12:0635 (12:635 Breach of Insurance Contract)",
      "12:1461" : "12:1461 (12:1461 Homeowners Loan Act)",
      "12:1703" : "12:1703 (12:1703 Default of HUD Loan)",
      "12:1725" : "12:1725 (12:1725 Collection under Contract Guaranty)",
      "12:1730" : "12:1730 (12:1730 Collection Under Contract Guaranty)",
      "12:1819" : "12:1819 (12:1819 Default of Promissory Note)",
      "12:1821" : "12:1821 (12:1821 Default of Loan by Promissary Note)",
      "12:1971" : "12:1971 (12:1971 Relief under Bank Holding Act)",
      "12:2605" : "12:2605 (12:2605 Violation of RESPA & WCA)",
      "12:3410" : "12:3410 (12:3410 Right to Financial Privacy Act)",
      "15:0001" : "15:0001 (15:1 Antitrust Litigation)",
      "15:0002at" : "15:0002at (15:2 Antitrust Litigation)",
      "15:0002fl" : "15:0002fl (15:2(a) Fair Labor Standards Act)",
      "15:0005" : "15:0005 (15:5(a) Fair Labor Standards Act)",
      "15:0013" : "15:0013 (15:13 Antitrust Litigation - Price)",
      "15:0015" : "15:0015 (15:15 Antitrust Litigation)",
      "15:0025" : "15:0025 (15:25 Clayton Act)",
      "15:0044" : "15:0044 (15:44 Trademark Infringement)",
      "15:0045" : "15:0045 (15:0045 Federal Trade Commission Act)",
      "15:0052" : "15:0052 (15:0052 Federal Trade Commission Act)",
      "15:0053" : "15:0053 (15:0053 Federal Trade Commission Act)",
      "15:0077" : "15:0077 (15:77 Securities Fraud)",
      "15:0078" : "15:0078 (15:78m(a) Securities Exchange Act)",
      "15:0631" : "15:0631 (15:631 Small Business Act)",
      "15:0717" : "15:0717 (15:717 Natural Gas Act)",
      "15:1051" : "15:1051 (15:1051 Trademark Infringement)",
      "15:1114" : "15:1114 (15:1114 Trademark Infringement)",
      "15:1121" : "15:1121 (15:1121 Trademark Infringement)",
      "15:1125" : "15:1125 (15:1125 Trademark Infringement (Lanham Act))",
      "15:1126" : "15:1126 (15:1126 Patent Infringement)",
      "15:1127" : "15:1127 (15:1127 Trademark Infringement)",
      "15:1601" : "15:1601 (15:1601 Truth in Lending)",
      "15:1640" : "15:1640 (15:1640 Truth in Lending)",
      "15:1681" : "15:1681 (15:1681 Fair Credit Reporting Act)",
      "15:1692" : "15:1692 (15:1692 Fair Debt Collection Act)",
      "15:1693" : "15:1693 (15:1693 Electronic Funds Transfer Act)",
      "15:1938" : "15:1938 (15:1938 Fair Labor Standards Act)",
      "15:1981" : "15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))",
      "15:1988" : "15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))",
      "15:1989" : "15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))",
      "15:2087" : "15:2087 (15:2087 Consumer Product Safety Improvement Act)",
      "15:2301" : "15:2301 (15:2301 Magnuson-Moss Warranty Act)",
      "15:2801" : "15:2801 (15:2801 Petroleum Marketing Practices Act)",
      "15:53(b)" : "15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equita)",
      "16:0668" : "16:0668 (16:668 Bald Eagle Protection Act)",
      "16:0703" : "16:0703 (16:703 Migratory Bird Act)",
      "16:1538" : "16:1538 (16:1538 Endangered Species Act)",
      "16:3371" : "16:3371 (16:3371 Wildlife Under the Lacey Act)",
      "16:3372" : "16:3372 (16:3372 Conservation: Complaint for Forfeiture)",
      "16:3373" : "16:3373 (16:3373 Appeal of Decision - DOI)",
      "16:3374" : "16:3374 (16:3374 Conservation: Complaint for Forfeiture)",
      "17:0101" : "17:0101 (17:101 Copyright Infringement)",
      "17:0501" : "17:0501 (17:501 Copyright Infringement)",
      "17:0504" : "17:0504 (17:504 Copyright Infringement)",
      "18:0241" : "18:0241 (18:241 Conspiracy Against Citizen Rights)",
      "18:1030" : "18:1030 (18:1030 Computer Fraud and Abuse Act)",
      "18:1836" : "18:1836 (18:1836 Violation of Defend Trade Secrets Act)",
      "18:1836a" : "18:1836a (18:1836(a) Injunction against Misappropriation of Trade Secrets)",
      "18:1836b" : "18:1836b (18:1836(b) Civil Action to Protect Trade Secrets)",
      "18:1961" : "18:1961 (18:1961 Racketeering (RICO) Act)",
      "18:1962" : "18:1962 (18:1962 Racketeering (RICO) Act)",
      "18:1964" : "18:1964 (18:1964 Racketeering (RICO) Act)",
      "18:2254" : "18:2254 (18:2254 Forfeiture Property-Sexual Exploitation of Minors)",
      "18:2724" : "18:2724 (18:2724 Prohibition on Release of State Motor Vehicle Information)",
      "18:4208" : "18:4208 (18:4208(B) Agency Action Review)",
      "19:1305" : "19:1305 (19:1305 Custom Duties:0Forfeiture-Immoral Articles)",
      "20:1080" : "20:1080 (20:1080 Student Loan Recovery)",
      "20:1400" : "20:1400 (20:1400 Civil Rights of Handicapped Child)",
      "20:1401" : "20:1401 (20:1401 Education: Handicapped Child Act)",
      "20:1415" : "20:1415 (20:1415 Student Eligibility for Special Education and Services)",
      "20:1681" : "20:1681 (20:1681 Title IX)",
      "21:0301" : "21:0301 (21:0301 Seizure and Condemnation of Certain Articles of Drugs)",
      "21:0841" : "21:0841 (21:0841 Forfeiture Property - Drugs)",
      "21:0880" : "21:0880 (21:0880 Controlled Substances Act)",
      "21:0881" : "21:0881 (21:0881 Forfeiture Property - Currency)",
      "21:0881a" : "21:0881a (21:0881 Forfeiture Property - Aircraft)",
      "21:0881au" : "21:0881au (21:0881 Forfeiture Property - Automobile)",
      "21:0881re" : "21:0881re (21:0881 Forfeiture Property - Real Estate)",
      "23:0134" : "23:0134 (23:134 P.I.- Auto Negligence)",
      "23:1441" : "23:1441 (23:1441 Contract Real Estate)",
      "24:1000" : "24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)",
      "25:0640" : "25:0640 (25:640 Indian Tribal Rights)",
      "25:1901" : "25:1901 (25:1901 Indian Child Welfare Act)",
      "25:2701" : "25:2701 (25:2701 Tribal Gaming Compacts)",
      "26:6212" : "26:6212 (26:6212 Injunctive Relief from IRS Lien)",
      "26:6213" : "26:6213 (26:6213 Injunctive Relief from IRS Lien)",
      "26:6331" : "26:6331 (26:6331 IRS Writ of Entry to Enforce Levy)",
      "26:6502" : "26:6502 (26:6502 IRS:Enforcement of tax liens)",
      "26:6532" : "26:6532 (26:6532 IRS: Refund of Tax Penalty)",
      "26:6672" : "26:6672 (26:6672 Refund of Penalty Assessed by IRS)",
      "26:6702" : "26:6702 (26:6702 IRS: Refund of Income Tax Penalty)",
      "26:6703" : "26:6703 (26:6703 IRS: Refund of Tax Penalty)",
      "26:7401" : "26:7401 (26:7401 IRS: Tax Liability)",
      "26:7402" : "26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)",
      "26:7403" : "26:7403 (26:7403 Suit to Enforce Federal Tax Lien)",
      "26:7422rt" : "26:7422rt (26:7422 IRS: Refund Taxes)",
      "26:7422rx" : "26:7422rx (26:7422 IRS: Refund Excise Tax)",
      "26:7426" : "26:7426 (26:7426 IRS: Wrongful Levy for Taxes)",
      "26:7429" : "26:7429 (26:7429 IRS: Tax Jeopardy Assessment)",
      "26:7609" : "26:7609 (26:7609 IRS: Petition to Quash IRS Summons)",
      "27:0185" : "27:0185 (27:185 Enforcement of Arbitration Award)",
      "28:0157c" : "28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)",
      "28:0157d" : "28:0157d (28:0157 Motion for Withdrawal of Reference)",
      "28:0158" : "28:0158 (28:0158 Notice of Appeal re Bankruptcy Matter (BA)",
      "28:0185" : "28:0185 (28:185 Suit to Compel Arbitration)",
      "28:0451" : "28:0451 (28:451 Employment Discrimination)",
      "28:0794" : "28:0794 (28:794 Rehabilitation Act)",
      "28:1001" : "28:1001 (28:1001 E.R.I.S.A.)",
      "28:1071" : "28:1071 (28:1071 Defaulted Student Loan)",
      "28:1132" : "28:1132 (28:1132 E.R.I.S.A.)",
      "28:1330" : "28:1330 (28:1330 Breach of Contract)",
      "28:1331" : "28:1331 (28:1331 Fed. Question)",
      "28:1331al" : "28:1331al (28:1331 Fed. Question: Airline Crash)",
      "28:1331at" : "28:1331at (28:1331 Fed. Question: Anti-trust)",
      "28:1331au" : "28:1331au (28:1331 Fed. Question: Auto Negligence)",
      "28:1331b" : "28:1331b (28:1331 Federal Question: Bivens Act)",
      "28:1331bc" : "28:1331bc (28:1331 Fed. Question: Breach of Contract)",
      "28:1331ca" : "28:1331ca (28:1331 Fed Question: Fed Communications Act of 1)",
      "28:1331cm" : "28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)",
      "28:1331cv" : "28:1331cv (28:1331 Federal Question: Other Civil Rights)",
      "28:1331ed" : "28:1331ed (28:1331 Fed. Question: Employment Discrimination)",
      "28:1331es" : "28:1331es (28:1331 Enforcement of Administrative Subpoena)",
      "28:1331fl" : "28:1331fl (28:1331 Fed. Question: Fair Labor Standards)",
      "28:1331in" : "28:1331in (28:1331 Fed. Question: Insurance Contract)",
      "28:1331mm" : "28:1331mm (28:1331 Fed. Question: Medical Malpractice)",
      "28:1331pi" : "28:1331pi (28:1331 Fed. Question: Personal Injury)",
      "28:1331rd" : "28:1331rd (28:1331 Fed. Question: Review Agency Decision)",
      "28:1331rp" : "28:1331rp (28:1331(a) Fed. Question: Real Property)",
      "28:1331rr" : "28:1331rr (28:1331 Fed. Question: Railway Labor Act)",
      "28:1331sv" : "28:1331sv (28:1331 Fed. Question: Securities Violation)",
      "28:1331tr" : "28:1331tr (28:1331 Fed. Question: Trademark)",
      "28:1331tt" : "28:1331tt (28:1331 Fed. Question: Tort Action)",
      "28:1331v" : "28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendme)",
      "28:1331wl" : "28:1331wl (28:1331 Federal Question: EPA Waste Lien)",
      "28:1331wt" : "28:1331wt (28:1331 Fed. Question: Water Rights)",
      "28:1332ac" : "28:1332ac (28:1332 Diversity-Account Receivable)",
      "28:1332al" : "28:1332al (28:1332 Diversity-Airline Crash)",
      "28:1332as" : "28:1332as (28:1332 Diversity-Asbestos Litigation)",
      "28:1332au" : "28:1332au (28:1332 Diversity-Auto Negligence)",
      "28:1332bc" : "28:1332bc (28:1332 Diversity-Breach of Contract)",
      "28:1332co" : "28:1332co (28:1332 Diversity-Conversion)",
      "28:1332ct" : "28:1332ct (28:1332 Diversity-(Citizenship))",
      "28:1332det" : "28:1332det (28:1332 Diversity: Forcible Detainer)",
      "28:1332df" : "28:1332df (28:1332 Diversity-Contract Default)",
      "28:1332ds" : "28:1332ds (28:1332 Diversity-Contract Dispute)",
      "28:1332ed" : "28:1332ed (28:1332 Diversity-Employment Discrimination)",
      "28:1332fd" : "28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)",
      "28:1332fr" : "28:1332fr (28:1332 Diversity-Fraud)",
      "28:1332ia" : "28:1332ia (28:1332 Diversity-Interpleader Action)",
      "28:1332ij" : "28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)",
      "28:1332in" : "28:1332in (28:1332 Diversity-Insurance Contract)",
      "28:1332jd" : "28:1332jd (28:1332 Diversity-Declaratory Judgment)",
      "28:1332lb" : "28:1332lb (28:1332 Diversity-Libel,Assault,Slander)",
      "28:1332lm" : "28:1332lm (28:1332 Diversity - Legal Malpractice)",
      "28:1332ma" : "28:1332ma (28:1332 Diversity-Miller Act)",
      "28:1332mm" : "28:1332mm (28:1332 Diversity-Medical Malpractice)",
      "28:1332mv" : "28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)",
      "28:1332ni" : "28:1332ni (28:1332 Diversity-Negotiable Instrument)",
      "28:1332nm" : "28:1332nm (28:1332 Diversity-Non-Motor Vehicle)",
      "28:1332oc" : "28:1332oc (28:1332 Diversity-Other Contract)",
      "28:1332pd" : "28:1332pd (28:1332 Diversity-Property Damage)",
      "28:1332pi" : "28:1332pi (28:1332 Diversity-Personal Injury)",
      "28:1332pl" : "28:1332pl (28:1332 Diversity-Product Liability)",
      "28:1332pr" : "28:1332pr (28:1332 Diversity-Petition for Removal)",
      "28:1332qt" : "28:1332qt (28:1332 Diversity-Petition to Quiet Title)",
      "28:1332ri" : "28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)",
      "28:1332sa" : "28:1332sa (28:1332 - Diversity: Securities & Exchange Commiss)",
      "28:1332sf" : "28:1332sf (28:1332 - Diversity: Securities Fraud)",
      "28:1332ss" : "28:1332ss (28:1332 Diversity - Stockholders Suits)",
      "28:1332tl" : "28:1332tl (28:1332 Diversity-Torts to Land)",
      "28:1332tm" : "28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))",
      "28:1332tn" : "28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)",
      "28:1332wd" : "28:1332wd (28:1332 Diversity-Wrongful Death)",
      "28:1333" : "28:1333 (28:1333 Admiralty)",
      "28:1334" : "28:1334 (28:1334 Bankruptcy Appeal)",
      "28:1334c" : "28:1334c (28:1334(c) R&R re motions for abstention (non-cor)",
      "28:1335" : "28:1335 (28:1335 Interpleader Action)",
      "28:1337" : "28:1337 (28:1337 Sherman-Clayton Act)",
      "28:1338cp" : "28:1338cp (28:1338 Copyright Infringement)",
      "28:1338pt" : "28:1338pt (28:1338 Patent Infringement)",
      "28:1338tr" : "28:1338tr (28:1338 Trademark Infringement)",
      "28:1340" : "28:1340 (28:1340 IRS: Custom Duties)",
      "28:1340er" : "28:1340er (28:1340 Recovery of Erroneous Refund)",
      "28:1341" : "28:1341 (28:1341 Complaint for Forfeiture)",
      "28:1343" : "28:1343 (28:1343 Violation of Civil Rights)",
      "28:1345co" : "28:1345co (28:1345 Replevin & Conversion)",
      "28:1345db" : "28:1345db (28:1345 Debt to US - FHA/HUD Title I)",
      "28:1345df" : "28:1345df (28:1345 Default of Promissory Note)",
      "28:1345er" : "28:1345er (28:1345 Recovery of Erroneous Refund)",
      "28:1345fc" : "28:1345fc (28:1345 Foreclosure)",
      "28:1345ff" : "28:1345ff (28:1345 Complaint for Forfeiture)",
      "28:1345hl" : "28:1345hl (28:1345 VA Home Loan Guaranty Debt)",
      "28:1345mc" : "28:1345mc (28:1345 Medical Care Recovery)",
      "28:1345mi" : "28:1345mi (28:1345 Mining Claim Ejectment)",
      "28:1345pd" : "28:1345pd (28:1345 Property Damage)",
      "28:1345pe" : "28:1345pe (28:1345 Property Ejectment)",
      "28:1345rc" : "28:1345rc (28:1345 Recovery of Debt to US)",
      "28:1345st" : "28:1345st (28:1345 Default of Student Loan)",
      "28:1345tp" : "28:1345tp (28:1345 Trespass on Public Land)",
      "28:1345va" : "28:1345va (28:1345 Recovery of VA Overpayment)",
      "28:1346bc" : "28:1346bc (28:1346 Breach of Contract)",
      "28:1346rc" : "28:1346rc (28:1346 Recovery of IRS Tax)",
      "28:1346tc" : "28:1346tc (28:1346 Tort Claim)",
      "28:1346wd" : "28:1346wd (28:1346 Wrongful Death)",
      "28:1352" : "28:1352 (28:1352 Miller Act)",
      "28:1355" : "28:1355 (28:1355 Petition for Return of Property)",
      "28:1358" : "28:1358 (28:1358 Land Condemnation)",
      "28:1361" : "28:1361 (28:1361 Petition for Writ of Mandamus)",
      "28:1362ic" : "28:1362ic (28:1362 Indian Tribal Controversy)",
      "28:1362iw" : "28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)",
      "28:1364" : "28:1364 (28:1364 Auto Negligence)",
      "28:1391" : "28:1391 (28:1391 Personal Injury)",
      "28:1402" : "28:1402 (28:1402 Medical Malpractice)",
      "28:1407" : "28:1407 (28:1407 Airline Crash)",
      "28:1441ac" : "28:1441ac (28:1441 Petition for Removal- Account Receivable)",
      "28:1441al" : "28:1441al (28:1441 Petition for Removal- Airline Crash)",
      "28:1441as" : "28:1441as (28:1441 Petition for Removal- Asbestos Litigation)",
      "28:1441au" : "28:1441au (28:1441 Petition for Removal- Auto Negligence)",
      "28:1441bc" : "28:1441bc (28:1441 Petition for Removal- Breach of Contract)",
      "28:1441cv" : "28:1441cv (28:1441 Petition for Removal- Civil Rights Act)",
      "28:1441df" : "28:1441df (28:1441 Petition for Removal- Contract Default)",
      "28:1441dj" : "28:1441dj (28:1441 Petition for Removal- Declaratory Judgemen)",
      "28:1441ds" : "28:1441ds (28:1441 Petition for Removal- Contract Dispute)",
      "28:1441ed" : "28:1441ed (28:1441 Petition for Removal - Employment Discrim)",
      "28:1441fc" : "28:1441fc (28:1441 Petition for Removal - Fair Credit Reporti)",
      "28:1441fr" : "28:1441fr (28:1441 Petition for Removal- Fraud)",
      "28:1441ij" : "28:1441ij (28:1441 Petition for Removal- Injunctive/Declarato)",
      "28:1441in" : "28:1441in (28:1441 Petition for Removal- Insurance Contract)",
      "28:1441int" : "28:1441int (28:1441 Petition for Removal- Action for Interplea)",
      "28:1441lb" : "28:1441lb (28:1441 Petition for Removal Libel,Assault,Slander)",
      "28:1441lm" : "28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relatio)",
      "28:1441mm" : "28:1441mm (28:1441 Petition for Removal- Medical Malpractice)",
      "28:1441ni" : "28:1441ni (28:1441 Petition for Removal- Negotiable Instrumen)",
      "28:1441nm" : "28:1441nm (28:1441 Petition for Removal- Non-Motor Vehicle)",
      "28:1441oc" : "28:1441oc (28:1441 Petition For Removal--Other Contract)",
      "28:1441pd" : "28:1441pd (28:1441 Petition for Removal- Property Damage)",
      "28:1441pi" : "28:1441pi (28:1441 Petition for Removal- Personal Injury)",
      "28:1441pl" : "28:1441pl (28:1441 Petition for Removal- Product Liability)",
      "28:1441pr" : "28:1441pr (28:1441 Petition for Removal)",
      "28:1441qt" : "28:1441qt (28:1441 Petition for Removal- Petition to Quiet Ti)",
      "28:1441ri" : "28:1441ri (28:1441 Petition for Removal- Racketeering (RICO))",
      "28:1441sa" : "28:1441sa (28:1441 - Petition for Removal: SEC Act)",
      "28:1441sf" : "28:1441sf (28:1441 - Petition for Removal: Securities Fraud)",
      "28:1441tl" : "28:1441tl (28:1441 Petition for Removal- Torts to Land)",
      "28:1441tm" : "28:1441tm (28:1441 Petition for Removal- Tort/Motor Vehicle ()",
      "28:1441tn" : "28:1441tn (28:1441 Petition for Removal- Tort/Non-Motor Vehic)",
      "28:1441wd" : "28:1441wd (28:1441 Petition for Removal- Wrongful Death)",
      "28:1442bc" : "28:1442bc (28:1442 Petition for Removal- Breach of Contract)",
      "28:1442pr" : "28:1442pr (28:1442 Petition for Removal)",
      "28:1443" : "28:1443 (28:1443(1) Rent, Lease & Ejectment)",
      "28:1444" : "28:1444 (28:1444 Petition for Removal- Foreclosure)",
      "28:1446in" : "28:1446in (28:1446 Breach of Contract- Insurance)",
      "28:1446pd" : "28:1446pd (28:1446 Petition for Removal- Property Damage (P.I)",
      "28:1446pi" : "28:1446pi (28:1446 Petition for Removal- Personal Injury)",
      "28:1446pl" : "28:1446pl (28:1446pl Petition for Removal - Product Liability)",
      "28:1446pr" : "28:1446pr (28:1446 Petition for Removal)",
      "28:1452" : "28:1452 (28:1452 R&R re motions to remand (non-core))",
      "28:1651" : "28:1651 (28:1651 Petition for Writ of Coram Nobis)",
      "28:1651hc" : "28:1651hc (28:1651 Petition for Writ of Habeas Corpus)",
      "28:1651mn" : "28:1651mn (28:1651 Petition for Writ of Mandamus)",
      "28:1983" : "28:1983 (28:1983 Civil Rights)",
      "28:2201" : "28:2201 (28:2201 Constitutionality of State Statute(s))",
      "28:2201dj" : "28:2201dj (28:2201 Declaratory Judgement)",
      "28:2201ij" : "28:2201ij (28:2201 Injunction)",
      "28:2201in" : "28:2201in (28:2201 Declaratory Judgement (Insurance))",
      "28:2241" : "28:2241 (28:2241 Petition for Writ of Habeas Corpus (federa)",
      "28:2254" : "28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))",
      "28:2254se" : "28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)",
      "28:2255" : "28:2255 (28:2255 Motion to Vacate / Correct Illegal Sentenc)",
      "28:2271" : "28:2271 (28:2271 Federal Tort Claims Act)",
      "28:2345" : "28:2345 (28:2345 Medicare Recovery)",
      "28:2409" : "28:2409 (28:2409(a) Quiet Title Action)",
      "28:2410" : "28:2410 (28:2410 Quiet Title)",
      "28:2671" : "28:2671 (28:2671 Federal Tort Claims Act)",
      "28:2674" : "28:2674 (28:2674 Federal Tort Claims Act)",
      "28:7402" : "28:7402 (28:7402 Refund of Taxes)",
      "28:7422" : "28:7422 (28:7422 Appeal from Administrative Decision)",
      "29:0151" : "29:0151 (29:151 Labor: Review of Agency Action)",
      "29:0160" : "29:0160 (29:160(1) National Labor Relations Act)",
      "29:0184" : "29:0184 (29:184 Violation Collection Bargain Agreement)",
      "29:0185" : "29:0185 (29:0185 Labor Management Relations Act)",
      "29:0185ep" : "29:0185ep (29:185 Employee Pension Plan)",
      "29:0185lm" : "29:0185lm (29:185 Labor/Mgt. Relations (Contracts))",
      "29:0201do" : "29:0201do (29:201 Denial of Overtime Compensation)",
      "29:0201fl" : "29:0201fl (29:201 Fair Labor Standards Act)",
      "29:0203" : "29:0203 (29:203 Equal Pay Act)",
      "29:0206" : "29:0206 (29:206 Collect Unpaid Wages)",
      "29:0401" : "29:0401 (29:0401 Labor Management Disclosure Act)",
      "29:0621" : "29:0621 (29:621 Job Discrimination (Age))",
      "29:0623" : "29:0623 (29:623 Job Discrimination (Age))",
      "29:0626" : "29:0626 (29:626 Job Discrimination (Age))",
      "29:0633" : "29:0633 (29:633 Job Discrimination (Age))",
      "29:0651" : "29:0651 (29:651 Occupational Safety/Health)",
      "29:0754" : "29:0754 (29:754 Discrimination)",
      "29:0791" : "29:0791 (29:791 Job Discrimination (Rehabilitation Act))",
      "29:0794" : "29:0794 (29:0794 Job Discrimination (Disability))",
      "29:1001" : "29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)",
      "29:1002" : "29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)",
      "29:1104" : "29:1104 (29:1104 Recovery of Benefits to Employee)",
      "29:1109" : "29:1109 (29:1109 Breach of Fiduciary Duties)",
      "29:1131" : "29:1131 (29:1131 ERISA - Collection of Delinquent Trust Fun)",
      "29:1132" : "29:1132 (29:1132 E.R.I.S.A. - Employee Benefits)",
      "29:1145" : "29:1145 (29:1145 E.R.I.S.A.)",
      "29:1149" : "29:1149 (29:1149 Recover Pension & Profit Sharing)",
      "29:1337" : "29:1337 (29:1337 E.R.I.S.A.)",
      "29:1362" : "29:1362 (29:1362 ERISA)",
      "29:1381" : "29:1381 (29:1381 E.R.I.S.A.)",
      "29:1401" : "29:1401 (29:1401(b)(2) Appeal of Arbitration Award)",
      "29:1451" : "29:1451 (29:1451 E.R.I.S.A.)",
      "29:1801" : "29:1801 (29:1801 Farmworker Rights)",
      "29:2601" : "29:2601 (29:2601 Family and Medical Leave Act)",
      "29:790" : "29:790 (29:790 Rehabilitation of Labor)",
      "30:0181" : "30:0181 (30:181 Environment: Review of Agency Action)",
      "30:0801" : "30:0801 (30:0801 Penalities/Federal Mine Safety Health Act)",
      "30:1201" : "30:1201 (30:1201 Environment: Review of Agency Action)",
      "30:1202" : "30:1202 (30:1202 Mining Reclamation Act)",
      "30:1276" : "30:1276 (30:1276 Interior: Review of Agency Action)",
      "31:3545" : "31:3545 (31:3545 Action to Recovery Money)",
      "31:3729" : "31:3729 (31:3729 False Claims Act)",
      "31:3730" : "31:3730 (31:3730 Qui Tam False Claims Act)",
      "31:3731" : "31:3731 (31:3731 Fraud)",
      "31:5317" : "31:5317 (31:5317 Forfeiture of monies in structured transactions)",
      "33:1319cw" : "33:1319cw (33:1319 Clean Water Act)",
      "33:1319pv" : "33:1319pv (33:1319 Pollutants & Permit Violations)",
      "33:1365" : "33:1365 (33:1365 Environmental Matters)",
      "35:0102" : "35:0102 (35:0102 Patent - Declaration of Invalidity or Noninfringement)",
      "35:0145" : "35:0145 (35:145 Patent Infringement)",
      "35:0183" : "35:0183 (35:183 Patent Infringement)",
      "35:0271" : "35:0271 (35:271 Patent Infringement)",
      "38:1681" : "38:1681 (38:1681 Recovery of VA Overpayment)",
      "38:1686" : "38:1686 (38:1686 Recovery of VA Overpayment)",
      "38:1780" : "38:1780 (38:1780 Recovery of VA Overpayment)",
      "38:2011" : "38:2011 (38:2011 - Veteran's Readjustment Assistance Act of)",
      "38:3116" : "38:3116 (38:3116 VA Overpayment)",
      "38:4311-13" : "38:4311-13 (38:4311-4313 Uniformed Service Employment/Reemployment Rights Act (USERRA))",
      "39:3005" : "39:3005 (39:3005 Detention of Mail for Temporary Periods)",
      "39:409" : "39:409 (39:409 Postal Service)",
      "40:0258" : "40:0258 (40:258(a) Public Buildings & Property: Land Condem)",
      "40:0270" : "40:0270 (40:270 Miller Act)",
      "40:0875" : "40:0875 (40:875 Public Buildings & Property: Negligence)",
      "41:0251" : "41:0251 (41:251 Public Contracts-Review of Agency Action)",
      "41:1463" : "41:1463 (41:1463 Public Contracts: Unlawful Employment Prac)",
      "42:0205" : "42:0205 (42:205 Denial Social Security Benefits)",
      "42:0206" : "42:0206 (42:206 Social Security Benefits)",
      "42:0247" : "42:0247 (42:247 Personal Injury-Swine Flu)",
      "42:0292" : "42:0292 (42:0292 Default on Repayment of Student Loans)",
      "42:0402" : "42:0402 (42:402 Social Security Benefits)",
      "42:0405id" : "42:0405id (42:405 Review of HHS Decision (SSID))",
      "42:0405wc" : "42:0405wc (42:405 Review of HHS Decision (DIWC))",
      "42:0405ww" : "42:0405ww (42:405 Review of HHS Decision (DIWW))",
      "42:0416" : "42:0416 (42:416 Denial of Social Security Benefits)",
      "42:0427" : "42:0427 (42:427 Social Security Benefits)",
      "42:12101" : "42:12101 (42:12101 Americans with Disabilities Act)",
      "42:1383" : "42:1383 (42:1383 Review of HHS Decision)",
      "42:1395" : "42:1395 (42:1395 HHS: Adverse Reimbursement Review)",
      "42:1396" : "42:1396 (42:1396 Medicaid and CHIP Payment and Access Commission)",
      "42:1471" : "42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclo)",
      "42:18002" : "42:18002 (42:18002 Early Retiree Reinsurance Program)",
      "42:1973" : "42:1973 (Uniformed and Overseas Citizens Absentee Voting Act)",
      "42:1981cv" : "42:1981cv (42:1981 Civil Rights)",
      "42:1981hs" : "42:1981hs (42:1981 Housing Discrimination)",
      "42:1981jb" : "42:1981jb (42:1981 Job Discrimination (Race))",
      "42:1981sx" : "42:1981sx (42:1981 Sex Discrimination)",
      "42:1983cv" : "42:1983cv (42:1983 Civil Rights Act)",
      "42:1983ed" : "42:1983ed (42:1983 Civil Rights (Employment Discrimination))",
      "42:1983pr" : "42:1983pr (42:1983 Prisoner Civil Rights)",
      "42:1986" : "42:1986 (42:1986 Neglect of Duty)",
      "42:2000ag" : "42:2000ag (42:2000 Job Discrimination (Age))",
      "42:2000cc" : "42:2000cc (42:2000cc RLUIPA (Religious Land Use and Institutionalized Persons Act))",
      "42:2000e" : "42:2000e (42:2000e Job Discrimination (Employment))",
      "42:2000pb" : "42:2000pb (42:2000 Job Discrimination (Public Accomodations))",
      "42:2000ra" : "42:2000ra (42:2000 Job Discrimination (Race))",
      "42:2000sx" : "42:2000sx (42:2000 Job Discrimination (Sex))",
      "42:2003" : "42:2003 (42:2003 Job Discrimination)",
      "42:2005" : "42:2005 (42:2005 Review of Agency Action-HHS)",
      "42:2651" : "42:2651 (42:2651 Medical Care Recovery)",
      "42:3601" : "42:3601 (42:405 Fair Housing Act)",
      "42:4000" : "42:4000 (42:4000 National Flood Insurance Act)",
      "42:4001" : "42:4001 (42:4001 National Insurance Flood Act)",
      "42:4053" : "42:4053 (42:4053 Breach of Insurance Contract)",
      "42:4072" : "42:4072 (42:4072 Payment of Flood Insurance Claim)",
      "42:4321" : "42:4321 (42:4321 Review of Agency Action-Environment)",
      "42:4332" : "42:4332 (42:4332 Environmental Policy - Coop of Agency Repo)",
      "42:6901en" : "42:6901en (42:6901 Environmental Cleanup Expenses)",
      "42:6901rs" : "42:6901rs (42:6901 Resource & Recovery Act)",
      "42:7413" : "42:7413 (42:7413(b) Clean Air Act)",
      "42:7604cl" : "42:7604cl (42:7604 Clear Air Act (Emission Standards))",
      "42:7604ir" : "42:7604ir (42:7604 Petition to Quash IRS Summons)",
      "42:9607" : "42:9607 (42:9607 Real Property Tort to Land)",
      "43:945" : "43:945 (43:945 Compensation for Land Condemnation)",
      "43:945a" : "43:945a (43:945a Complaint in Condemnation)",
      "43:946" : "43:946 (43:946 Complaint in Condemnation - Eminent Domain)",
      "45:0051" : "45:0051 (45:51 Railways: Fed. Employer's Liability Act)",
      "45:0151" : "45:0151 (45:151 Railway Labor Act)",
      "45:0153" : "45:0153 (45:0153 National Railroad Adjustment Board)",
      "45:0184" : "45:0184 (45:184 Action to Set Aside Award of a System Board)",
      "45:1395" : "45:1395 (45:1395 Railroads: Adverse Reimbursement Review)",
      "45:7457" : "45:7457 (45:7457 Compel Reclamation Under Clear Air Act)",
      "46:0688" : "46:0688 (46:688 Jones Act)",
      "46:0741" : "46:0741 (46:741 Shipping)",
      "46:0761" : "46:0761 (46:761 Shipping: Damages for Death on High Seas)",
      "46:1101" : "46:1101 (46:1101 Violation of Maritime Regulations)",
      "46:1156" : "46:1156 (46:1156 Administrative Procedure Act)",
      "46:31325" : "46:31325 (46:31325 Foreclosure of Preferred Ship Mortgage)",
      "47:0227" : "47:0227 (47:0227 Restrictions on Use of Telephone Equipment)",
      "47:605" : "47:605 (Unauthorized Publication or Use of Communications)",
      "48:0883" : "48:0883 (48:883 Violation of US Coastal Law)",
      "48:1985" : "48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)",
      "49:0081" : "49:0081 (49:81 Damaged Goods While Being Transported)",
      "49:0781" : "49:0781 (49:781 Forfeiture)",
      "49:11503" : "49:11503 (49:11503 Railroad Revitalization Regulatory Reform)",
      "49:11702" : "49:11702 (49:11702(a)(4) Violations of Interstate Commerce A)",
      "49:14706" : "49:14706 (49:14706 Liability of Carriers Under Bills of Lading)",
      "49:1471" : "49:1471 (49:1471 Federal Aviation Act)",
      "49:1903" : "49:1903 (49:1903 Petition to enforce administrative summon)",
      "49:31105" : "49:31105 (49:31105 Surface Transportation Assistance Act)",
      "50:535" : "50:535 (50:535 (app) Servicemembers Civil Relief Act)",
      "misc" : "misc (Civil Miscellaneous Case)"
   },
   "wvndce" : {
      "0" : "0 (no cause specified)",
      "02:0431" : "02:0431 (02:431 Fed. Election Commission: Failure Enforce Compliance)",
      "02:0437" : "02:0437 (02:437 Federal Election Commission)",
      "05:0075" : "05:0075 (05:75(2) Contract - Reduction in Grade)",
      "05:0551" : "05:0551 (05:551 Administrative Procedure Act)",
      "05:0552fi" : "05:0552fi (05:552 Freedom of Information Act)",
      "05:0552pa" : "05:0552pa (05:552 Right to Privacy Act)",
      "05:0554" : "05:0554 (05:0554 Constitutionality of Maritime Statutes)",
      "05:0701" : "05:0701 (05:0701 Maritime Subsidy Board)",
      "05:0702" : "05:0702 (05:702 Administrative Procedure Act)",
      "05:0704" : "05:0704 (05:704 Labor Litigation)",
      "05:7703" : "05:7703 (05:7703 Discrimination - Review of Agency Act)",
      "05:8470" : "05:8470 (05:8470 Enforcement of Judgment against Retirement Benefits)",
      "07:0006" : "07:0006 (7:6(b) Federal Commodity Exchange Regulation)",
      "07:0025" : "07:0025 (7:25 Fraud - Commodities Leverage Contracts)",
      "07:0181" : "07:0181 (07:181 Packers & Stockyard Act)",
      "07:0499" : "07:0499 (07:499 Agricultural Commodities Act)",
      "07:0601" : "07:0601 (07:601 USDA Condemnation)",
      "07:2321" : "07:2321 (07:2321 Plant Variety Protection Act)",
      "08:1105" : "08:1105 (8:1105(a) Aliens: Habeas Corpus to Release INS Detainee)",
      "08:1182" : "08:1182 (8:1182 Defend. Denial of Pla. Appl. for Alien Employment Cer)",
      "08:1252" : "08:1252 (08:1252(a)(2) Injunction for Deportation)",
      "08:1260" : "08:1260 (08:1260 Aliens: Access to Records)",
      "08:1324" : "08:1324 (08:1324 Aliens: Complaint for Forfeiture)",
      "08:1329" : "08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petition)",
      "08:1446" : "08:1446 (8:1446 Petition for Naturalization Hearing)",
      "08:1451(j)" : "08:1451(j) (8:1451(j) Motion to Correct Order & Judg. of Naturalization)",
      "09:0001" : "09:0001 (09:1 U.S. Arbitration Act)",
      "09:0009" : "09:0009 (9:9 Motion to Confirm Arbitration Loan)",
      "09:0010" : "09:0010 (09:0010 Petition to Vacate Arbitration Award)",
      "10:1408" : "10:1408 (10:1408 Claim for Military Retirement)",
      "10:1552" : "10:1552 (10:1552 Armed Forces: Action to Correct Records)",
      "10:1553" : "10:1553 (10:1553 Armed Forces: FOIA General)",
      "10:2305" : "10:2305 (10:2305 Review of Federal Contract)",
      "11:0101" : "11:0101 (11:101 Bankruptcy)",
      "12:0022" : "12:0022 (12:22 Securities Fraud)",
      "12:0635" : "12:0635 (12:635 Breach of Insurance Contract)",
      "12:1461" : "12:1461 (12:1461 Homeowners Loan Act)",
      "12:1464" : "12:1464 (12:1464 Federal Savings and Loan)",
      "12:1703" : "12:1703 (12:1703 Default of HUD Loan)",
      "12:1725" : "12:1725 (12:1725 Collection under Contract Guaranty)",
      "12:1730" : "12:1730 (12:1730 Collection Under Contract Guaranty)",
      "12:1819" : "12:1819 (12:1819 Default of Promissory Note)",
      "12:1821" : "12:1821 (12:1821 Default of Loan by Promissary Note)",
      "12:191" : "12:191 (12:191 Bank Foreclosure)",
      "12:192" : "12:192 (12:192 Liquidation of National Bank)",
      "12:1971" : "12:1971 (12:1971 Relief under Bank Holding Act)",
      "12:1972" : "12:1972 (12:1972 Typing Arrangement Act)",
      "12:3410" : "12:3410 (12:3410 Right to Financial Privacy Act)",
      "15:0001" : "15:0001 (15:1 Antitrust Litigation)",
      "15:0002at" : "15:0002at (15:2 Antitrust Litigation)",
      "15:0002fl" : "15:0002fl (15:2(a) Fair Labor Standards Act)",
      "15:0005" : "15:0005 (15:5(a) Fair Labor Standards Act)",
      "15:0015" : "15:0015 (15:15 Antitrust Litigation)",
      "15:0025" : "15:0025 (15:25 Clayton Act)",
      "15:0044" : "15:0044 (15:44 Trademark Infringement)",
      "15:0045" : "15:0045 (15:0045 Federal Trade Commission Act)",
      "15:0052" : "15:0052 (15:0052 Federal Trade Commission Act)",
      "15:0053" : "15:0053 (15:0053 Federal Trade Commission Act)",
      "15:0077" : "15:0077 (15:77 Securities Fraud)",
      "15:0078" : "15:0078 (15:78m(a) Securities Exchange Act)",
      "15:0631" : "15:0631 (15:631 Small Business Act)",
      "15:0717" : "15:0717 (15:717 Natural Gas Act)",
      "15:0754" : "15:0754 (15:754 Emergency Petroleum Allocation-Admin.& Enforcement)",
      "15:1051" : "15:1051 (15:1051 Trademark Infringement)",
      "15:1114" : "15:1114 (15:1114 Trademark Infringement)",
      "15:1121" : "15:1121 (15:1121 Trademark Infringement)",
      "15:1125" : "15:1125 (15:1125 Trademark Infringement (Lanham Act))",
      "15:1126" : "15:1126 (15:1126 Patent Infringement)",
      "15:1127" : "15:1127 (15:1127 Trademark Infringement)",
      "15:1601" : "15:1601 (15:1601 Truth in Lending)",
      "15:1640" : "15:1640 (15:1640 Truth in Lending)",
      "15:1681" : "15:1681 (15:1681 Fair Credit Reporting Act)",
      "15:1692" : "15:1692 (15:1692 Fair Debt Collection Act)",
      "15:1938" : "15:1938 (15:1938 Fair Labor Standards Act)",
      "15:1981" : "15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))",
      "15:1988" : "15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))",
      "15:1989" : "15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))",
      "15:2301" : "15:2301 (15:2301 Magnuson-Moss Warranty Act)",
      "15:2801" : "15:2801 (15:2801 Petroleum Marketing Practices Act)",
      "15:3001" : "15:3001 (15:3001 Violation of Interstate Horse Racing Act)",
      "15:53(b)" : "15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equita)",
      "16:0668" : "16:0668 (16:668 Bald Eagle Protection Act)",
      "16:0703" : "16:0703 (16:703 Migratory Bird Act)",
      "16:1538" : "16:1538 (16:1538 Endangered Species Act)",
      "16:3371" : "16:3371 (16:3371 Wildlife Under the Lacey Act)",
      "16:3372" : "16:3372 (16:3372 Conservation: Complaint for Forfeiture)",
      "16:3373" : "16:3373 (16:3373 Appeal of Decision - DOI)",
      "16:3374" : "16:3374 (16:3374 Conservation: Complaint for Forfeiture)",
      "17:0101" : "17:0101 (17:101 Copyright Infringement)",
      "17:0501" : "17:0501 (17:501 Copyright Infringement)",
      "17:0504" : "17:0504 (17:504 Copyright Infringement)",
      "18:0241" : "18:0241 (18:241 Conspiracy Against Citizen Rights)",
      "18:1836a" : "18:1836a (18:1836(a) - Injunction against Misappropriation of Trade Secrets)",
      "18:1836b" : "18:1836b (18:1836(b) - Civil Action to Protect Trade Secrets)",
      "18:1961" : "18:1961 (18:1961 Racketeering (RICO) Act)",
      "18:1962" : "18:1962 (18:1962 Racketeering (RICO) Act)",
      "18:1964" : "18:1964 (18:1964 Racketeering (RICO) Act)",
      "18:2511" : "18:2511 (18:2511 Wiretapping)",
      "18:3114" : "18:3114 (18:3114 Motion for Return of Seized Property)",
      "18:4208" : "18:4208 (18:4208(B) Agency Action Review)",
      "19:1305" : "19:1305 (19:1305 Custom Duties: Forfeiture-Immoral Articles)",
      "20:1080" : "20:1080 (20:1080 Student Loan Recovery)",
      "20:1400" : "20:1400 (20:1400 Civil Rights of Handicapped Child)",
      "20:1401" : "20:1401 (20:1401 Education: Handicapped Child Act)",
      "21:0841" : "21:0841 (21:841 Forfeiture Property-Drugs)",
      "21:0881" : "21:0881 (21:881 Forfeiture Property-Drugs)",
      "21:0881a" : "21:0881a (21:881 Forfeiture Property - Aircraft)",
      "21:0881re" : "21:0881re (21:881 Forfeiture Property - Real Estate)",
      "23:0134" : "23:0134 (23:134 P.I.- Auto Negligence)",
      "23:1441" : "23:1441 (23:1441 Contract Real Estate)",
      "24:1000" : "24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)",
      "25:0640" : "25:0640 (25:640 Indian Tribal Rights)",
      "25:1901" : "25:1901 (25:1901 Indian Child Welfare Act)",
      "26:6212" : "26:6212 (26:6212 Injunctive Relief from IRS Lien)",
      "26:6213" : "26:6213 (26:6213 Injunctive Relief from IRS Lien)",
      "26:6502" : "26:6502 (26:6502 IRS:Enforcement of tax liens)",
      "26:6532" : "26:6532 (26:6532 IRS: Refund of Tax Penalty)",
      "26:6702" : "26:6702 (26:6702 IRS: Refund of Income Tax Penalty)",
      "26:6703" : "26:6703 (26:6703 IRS: Refund of Tax Penalty)",
      "26:7401" : "26:7401 (26:7401 IRS: Tax Liability)",
      "26:7402" : "26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)",
      "26:7403" : "26:7403 (26:7403 Suit to Enforce Federal Tax Lien)",
      "26:7422rt" : "26:7422rt (26:7422 IRS: Refund Taxes)",
      "26:7422rx" : "26:7422rx (26:7422 IRS: Refund Excise Tax)",
      "26:7426" : "26:7426 (26:7426 IRS: Wrongful Levy for Taxes)",
      "26:7429" : "26:7429 (26:7429 IRS: Tax Jeopardy Assessment)",
      "26:7431" : "26:7431 (26:7431 Wrongful Disclosure of Tax Return Information)",
      "26:7609" : "26:7609 (26:7609 IRS: Petition to Quash IRS Summons)",
      "27:0185" : "27:0185 (27:185 Enforcement of Arbitration Award)",
      "28:0157c" : "28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)",
      "28:0157d" : "28:0157d (28:0157 Motion for Withdrawal of Reference)",
      "28:0158" : "28:0158 (28:0158 Bankruptcy Appeal from Judgment/Order)",
      "28:0185" : "28:0185 (28:185 Suit to Compel Arbitration)",
      "28:0451" : "28:0451 (28:451 Employment Discrimination)",
      "28:0754" : "28:0754 (28:754 Receiver of Property in Different Districts)",
      "28:0794" : "28:0794 (28:794 Rehabilitation Act)",
      "28:1001" : "28:1001 (28:1001 E.R.I.S.A.)",
      "28:1132" : "28:1132 (28:1132 E.R.I.S.A.)",
      "28:1330" : "28:1330 (28:1330 Breach of Contract)",
      "28:1331" : "28:1331 (28:1331 Fed. Question)",
      "28:1331al" : "28:1331al (28:1331 Fed. Question: Airline Crash)",
      "28:1331at" : "28:1331at (28:1331 Fed. Question: Anti-trust)",
      "28:1331au" : "28:1331au (28:1331 Fed. Question: Auto Negligence)",
      "28:1331b" : "28:1331b (28:1331 Federal Question: Bivens Act)",
      "28:1331bc" : "28:1331bc (28:1331 Fed. Question: Breach of Contract)",
      "28:1331ca" : "28:1331ca (28:1331 Fed Question: Fed Communications Act of 1)",
      "28:1331cm" : "28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)",
      "28:1331cv" : "28:1331cv (28:1331 Fed. Question: Civil Rights Violation)",
      "28:1331ed" : "28:1331ed (28:1331 Fed. Question: Employment Discrimination)",
      "28:1331ej" : "28:1331ej (28:1331 Federal Question: Enforcement of Judgment)",
      "28:1331es" : "28:1331es (28:1331 Enforcement of Administrative Subpoena)",
      "28:1331fl" : "28:1331fl (28:1331 Fed. Question: Fair Labor Standards)",
      "28:1331in" : "28:1331in (28:1331 Fed. Question: Insurance Contract)",
      "28:1331mm" : "28:1331mm (28:1331 Fed. Question: Medical Malpractice)",
      "28:1331ng" : "28:1331ng (28:1331 Fed. Question: Natural Gas Act)",
      "28:1331pi" : "28:1331pi (28:1331 Fed. Question: Personal Injury)",
      "28:1331rd" : "28:1331rd (28:1331 Fed. Question: Review Agency Decision)",
      "28:1331rp" : "28:1331rp (28:1331(a) Fed. Question: Real Property)",
      "28:1331rr" : "28:1331rr (28:1331 Fed. Question: Railway Labor Act)",
      "28:1331sv" : "28:1331sv (28:1331 Fed. Question: Securities Violation)",
      "28:1331tr" : "28:1331tr (28:1331 Fed. Question: Trademark)",
      "28:1331tt" : "28:1331tt (28:1331 Fed. Question: Tort Action)",
      "28:1331v" : "28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendment)",
      "28:1331wl" : "28:1331wl (28:1331 Federal Question: EPA Waste Lien)",
      "28:1331wt" : "28:1331wt (28:1331 Fed. Question: Water Rights)",
      "28:1332ac" : "28:1332ac (28:1332 Diversity-Account Receivable)",
      "28:1332al" : "28:1332al (28:1332 Diversity-Airline Crash)",
      "28:1332as" : "28:1332as (28:1332 Diversity-Asbestos Litigation)",
      "28:1332au" : "28:1332au (28:1332 Diversity-Auto Negligence)",
      "28:1332bc" : "28:1332bc (28:1332 Diversity-Breach of Contract)",
      "28:1332co" : "28:1332co (28:1332 Diversity-Conversion)",
      "28:1332ct" : "28:1332ct (28:1332 Diversity-(Citizenship))",
      "28:1332det" : "28:1332det (28:1332 Diversity: Forcible Detainer)",
      "28:1332df" : "28:1332df (28:1332 Diversity-Contract Default)",
      "28:1332ds" : "28:1332ds (28:1332 Diversity-Contract Dispute)",
      "28:1332ed" : "28:1332ed (28:1332 Diversity-Employment Discrimination)",
      "28:1332fd" : "28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)",
      "28:1332fr" : "28:1332fr (28:1332 Diversity-Fraud)",
      "28:1332ia" : "28:1332ia (28:1332 Diversity-Interpleader Action)",
      "28:1332ij" : "28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)",
      "28:1332in" : "28:1332in (28:1332 Diversity-Insurance Contract)",
      "28:1332jd" : "28:1332jd (28:1332 Diversity-Declaratory Judgment)",
      "28:1332lb" : "28:1332lb (28:1332 Diversity-Libel, Assault, Slander)",
      "28:1332lm" : "28:1332lm (28:1332 Diversity - Legal Malpractice)",
      "28:1332ma" : "28:1332ma (28:1332 Diversity-Miller Act)",
      "28:1332mm" : "28:1332mm (28:1332 Diversity-Medical Malpractice)",
      "28:1332mv" : "28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)",
      "28:1332ni" : "28:1332ni (28:1332 Diversity-Negotiable Instrument)",
      "28:1332nm" : "28:1332nm (28:1332 Diversity-Non-Motor Vehicle)",
      "28:1332nr" : "28:1332nr (28:1332 Diversity-Notice of Removal)",
      "28:1332oc" : "28:1332oc (28:1332 Diversity-Other Contract)",
      "28:1332pd" : "28:1332pd (28:1332 Diversity-Property Damage)",
      "28:1332pi" : "28:1332pi (28:1332 Diversity-Personal Injury)",
      "28:1332pl" : "28:1332pl (28:1332 Diversity-Product Liability)",
      "28:1332pr" : "28:1332pr (28:1332 Diversity-Petition for Removal)",
      "28:1332qt" : "28:1332qt (28:1332 Diversity-Petition to Quiet Title)",
      "28:1332ri" : "28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)",
      "28:1332sa" : "28:1332sa (28:1332 - Diversity: Securities & Exchange Commiss)",
      "28:1332sf" : "28:1332sf (28:1332 - Diversity: Securities Fraud)",
      "28:1332ss" : "28:1332ss (28:1332 Diversity - Stockholders Suits)",
      "28:1332tl" : "28:1332tl (28:1332 Diversity-Torts to Land)",
      "28:1332tm" : "28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))",
      "28:1332tn" : "28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)",
      "28:1332wd" : "28:1332wd (28:1332 Diversity-Wrongful Death)",
      "28:1333" : "28:1333 (28:1333 Admiralty)",
      "28:1334" : "28:1334 (28:1334 Bankruptcy Appeal)",
      "28:1334c" : "28:1334c (28:1334(c) R&R re motions for abstention (non-cor)",
      "28:1335" : "28:1335 (28:1335 Interpleader Action)",
      "28:1337" : "28:1337 (28:1337 Sherman-Clayton Act)",
      "28:1338cp" : "28:1338cp (28:1338 Copyright Infringement)",
      "28:1338pt" : "28:1338pt (28:1338 Patent Infringement)",
      "28:1338tr" : "28:1338tr (28:1338 Trademark Infringement)",
      "28:1340" : "28:1340 (28:1340 IRS: Custom Duties)",
      "28:1340er" : "28:1340er (28:1340 Recovery of Erroneous Refund)",
      "28:1341" : "28:1341 (28:1341 Complaint for Forfeiture)",
      "28:1343" : "28:1343 (28:1343 Violation of Civil Rights)",
      "28:1345" : "28:1345 (28:1345 USA Plaintiff)",
      "28:1345co" : "28:1345co (28:1345 Replevin & Conversion)",
      "28:1345db" : "28:1345db (28:1345 Debt to US - FHA/HUD Title I)",
      "28:1345df" : "28:1345df (28:1345 Default of Promissory Note)",
      "28:1345er" : "28:1345er (28:1345 Recovery of Erroneous Refund)",
      "28:1345fc" : "28:1345fc (28:1345 Foreclosure)",
      "28:1345ff" : "28:1345ff (28:1345 Complaint for Forfeiture)",
      "28:1345hl" : "28:1345hl (28:1345 VA Home Loan Guaranty Debt)",
      "28:1345mc" : "28:1345mc (28:1345 Medical Care Recovery)",
      "28:1345mi" : "28:1345mi (28:1345 Mining Claim Ejectment)",
      "28:1345pd" : "28:1345pd (28:1345 Property Damage)",
      "28:1345pe" : "28:1345pe (28:1345 VA Property Ejectment)",
      "28:1345rc" : "28:1345rc (28:1345 Recovery of Debt to US)",
      "28:1345st" : "28:1345st (28:1345 Default of Student Loan)",
      "28:1345tp" : "28:1345tp (28:1345 Trespass on Public Land)",
      "28:1345va" : "28:1345va (28:1345 Recovery of VA Overpayment)",
      "28:1346bc" : "28:1346bc (28:1346 Breach of Contract)",
      "28:1346rc" : "28:1346rc (28:1346 Recovery of IRS Tax)",
      "28:1346tc" : "28:1346tc (28:1346 Tort Claim)",
      "28:1346wd" : "28:1346wd (28:1346 Wrongful Death)",
      "28:1349" : "28:1349 (28:1348 Corporation organized under Federal Law as party)",
      "28:1352" : "28:1352 (28:1352 Miller Act)",
      "28:1355" : "28:1355 (28:1355 Petition for Return of Property)",
      "28:1358" : "28:1358 (28:1358 Land Condemnation)",
      "28:1361" : "28:1361 (28:1361 Petition for Writ of Mandamus)",
      "28:1362ic" : "28:1362ic (28:1362 Indian Tribal Controversy)",
      "28:1362iw" : "28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)",
      "28:1364" : "28:1364 (28:1364 Auto Negligence)",
      "28:1391" : "28:1391 (28:1391 Personal Injury)",
      "28:1402" : "28:1402 (28:1402 Medical Malpractice)",
      "28:1407" : "28:1407 (28:1407 Airline Crash)",
      "28:1441ac" : "28:1441ac (28:1441 Notice of Removal-Account Receivable)",
      "28:1441al" : "28:1441al (28:1441 Notice of Removal-Airline Crash)",
      "28:1441as" : "28:1441as (28:1441 Notice of Removal-Asbestos Litigation)",
      "28:1441au" : "28:1441au (28:1441 Notice of Removal-Auto Negligence)",
      "28:1441bc" : "28:1441bc (28:1441 Notice of Removal-Breach of Contract)",
      "28:1441cv" : "28:1441cv (28:1441 Petition for Removal- Civil Rights Act)",
      "28:1441df" : "28:1441df (28:1441 Notice of Removal-Contract Default)",
      "28:1441dj" : "28:1441dj (28:1441 Notice of Removal-Declaratory Judgment)",
      "28:1441ds" : "28:1441ds (28:1441 Notice of Removal-Contract Dispute)",
      "28:1441ed" : "28:1441ed (28:1441 Petition for Removal - Employment Discrim)",
      "28:1441fc" : "28:1441fc (28:1441 Petition for Removal - Fair Credit Reporti)",
      "28:1441fr" : "28:1441fr (28:1441 Notice of Removal-Fraud)",
      "28:1441ij" : "28:1441ij (28:1441 Notice of Removal-Injunctive/Declaratory Relief)",
      "28:1441in" : "28:1441in (28:1441 Notice of Removal-Insurance Contract)",
      "28:1441int" : "28:1441int (28:1441 Petition for Removal- Action for Interplea)",
      "28:1441lb" : "28:1441lb (28:1441 Notice of Removal-Libel, Assault, Slander)",
      "28:1441lm" : "28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relatio)",
      "28:1441mm" : "28:1441mm (28:1441 Notice of Removal-Medical Malpractice)",
      "28:1441ni" : "28:1441ni (28:1441 Notice of Removal-Negotiable Instrument)",
      "28:1441nm" : "28:1441nm (28:1441 Notice of Removal-Non-Motor Vehicle)",
      "28:1441nr" : "28:1441nr (28:1441 Notice of Removal)",
      "28:1441oc" : "28:1441oc (28:1441 Petition For Removal--Other Contract)",
      "28:1441pd" : "28:1441pd (28:1441 Notice of Removal-Property Damage)",
      "28:1441pi" : "28:1441pi (28:1441 Notice of Removal-Personal Injury)",
      "28:1441pl" : "28:1441pl (28:1441 Notice of Removal-Product Liability)",
      "28:1441pr" : "28:1441pr (28:1441 Petition for Removal)",
      "28:1441qt" : "28:1441qt (28:1441 Notice of Removal-Petition to Quiet Title)",
      "28:1441ri" : "28:1441ri (28:1441 Petition for Removal- Racketeering (RICO))",
      "28:1441sa" : "28:1441sa (28:1441 - Petition for Removal: SEC Act)",
      "28:1441sf" : "28:1441sf (28:1441 - Petition for Removal: Securities Fraud)",
      "28:1441tl" : "28:1441tl (28:1441 Notice of Removal-Torts to Land)",
      "28:1441tm" : "28:1441tm (28:1441 Notice of Removal-Tort/Motor Vehicle (P.I.))",
      "28:1441tn" : "28:1441tn (28:1441 Notice of Removal-Tort/Non-Motor Vehicle)",
      "28:1441wd" : "28:1441wd (28:1441 Notice of Removal-Wrongful Death)",
      "28:1442bc" : "28:1442bc (28:1442 Notice of Removal-Breach of Contract)",
      "28:1442nr" : "28:1442nr (28:1442 Notice of Removal)",
      "28:1442pr" : "28:1442pr (28:1442 Petition for Removal)",
      "28:1443" : "28:1443 (28:1443(1) Rent, Lease & Ejectment)",
      "28:1444" : "28:1444 (28:1441 Notice of Removal-Foreclosure)",
      "28:1446in" : "28:1446in (28:1446 Breach of Contract- Insurance)",
      "28:1446nr" : "28:1446nr (28:1446 Notice of Removal)",
      "28:1446pd" : "28:1446pd (28:1446 Notice of Removal-Property Damage (P.I.))",
      "28:1446pi" : "28:1446pi (28:1446 Notice of Removal-Personal Injury)",
      "28:1446pl" : "28:1446pl (28:1446pl Petition for Removal - Product Liability)",
      "28:1446pr" : "28:1446pr (28:1446 Petition for Removal)",
      "28:1452" : "28:1452 (28:1452 Removal of Claim in Civil Action Related to BK. Case)",
      "28:1651" : "28:1651 (28:1651 Petition for Writ of Coram Nobis)",
      "28:1651hc" : "28:1651hc (28:1651 Petition for Writ of Habeas Corpus)",
      "28:1651mn" : "28:1651mn (28:1651 Petition for Writ of Mandamus)",
      "28:1782" : "28:1782 (28:1782 Letter rogatory - appointment)",
      "28:1983" : "28:1983 (28:1983 Civil Rights)",
      "28:2201" : "28:2201 (28:2201 Constitutionality of State Statute(s))",
      "28:2201dj" : "28:2201dj (28:2201 Declaratory Judgment)",
      "28:2201ij" : "28:2201ij (28:2201 Injunction)",
      "28:2201in" : "28:2201in (28:2201 Declaratory Judgment (Insurance))",
      "28:2241" : "28:2241 (28:2241 Petition for Writ of Habeas Corpus (Federal))",
      "28:2254" : "28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))",
      "28:2254se" : "28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)",
      "28:2255" : "28:2255 (28:2255 Motion to Vacate Sentence)",
      "28:2271" : "28:2271 (28:2271 Federal Tort Claims Act)",
      "28:2345" : "28:2345 (28:2345 Medicare Recovery)",
      "28:2409" : "28:2409 (28:2409(a) Quiet Title Action)",
      "28:2410" : "28:2410 (Actions affecting property on which United States had lien)",
      "28:2671" : "28:2671 (28:2671 Federal Tort Claims Act)",
      "28:2674" : "28:2674 (28:2674 Federal Tort Claims Act)",
      "28:7402" : "28:7402 (28:7402 Refund of Taxes)",
      "28:7422" : "28:7422 (28:7422 Appeal from Administrative Decision)",
      "29:0151" : "29:0151 (29:151 Labor: Review of Agency Action)",
      "29:0160" : "29:0160 (29:160(1) National Labor Relations Act)",
      "29:0184" : "29:0184 (29:184 Violation Collection Bargain Agreement)",
      "29:0185ep" : "29:0185ep (29:185 Employee Pension Plan)",
      "29:0185lm" : "29:0185lm (29:185 Labor/Mgt. Relations (Contracts))",
      "29:0201do" : "29:0201do (29:201 Denial of Overtime Compensation)",
      "29:0201fl" : "29:0201fl (29:201 Fair Labor Standards Act)",
      "29:0203" : "29:0203 (29:203 Equal Pay Act)",
      "29:0206" : "29:0206 (29:206 Collect Unpaid Wages)",
      "29:0401" : "29:0401 (29:0401 Labor Management Disclosure Act)",
      "29:0621" : "29:0621 (29:621 Job Discrimination (Age))",
      "29:0623" : "29:0623 (29:623 Job Discrimination (Age))",
      "29:0626" : "29:0626 (29:626 Job Discrimination (Age))",
      "29:0633" : "29:0633 (29:633 Job Discrimination (Age))",
      "29:0651" : "29:0651 (29:651 Occupational Safety/Health)",
      "29:0754" : "29:0754 (29:754 Discrimination)",
      "29:0791" : "29:0791 (29:791 Job Discrimination (Rehabilitation Act))",
      "29:0794" : "29:0794 (29:0794 Job Discrimination (Handicap))",
      "29:1001" : "29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)",
      "29:1002" : "29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)",
      "29:1104" : "29:1104 (29:1104 Recovery of Benefits to Employee)",
      "29:1109" : "29:1109 (29:1109 Breach of Fiduciary Duties)",
      "29:1131" : "29:1131 (29:1131 ERISA - Collection of Delinquent Trust Funds)",
      "29:1132" : "29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)",
      "29:1145" : "29:1145 (29:1145 E.R.I.S.A.)",
      "29:1149" : "29:1149 (29:1149 Recover Pension & Profit Sharing)",
      "29:1337" : "29:1337 (29:1337 E.R.I.S.A.)",
      "29:1342" : "29:1342 (29:1342 Terminating Pension Plan)",
      "29:1348" : "29:1348 (29:1348(a)(4) Terming Pension Plan (Effective Date))",
      "29:1362" : "29:1362 (29:1362 ERISA)",
      "29:1381" : "29:1381 (29:1381 E.R.I.S.A.)",
      "29:1401" : "29:1401 (29:1401(b)(2) Appeal of Arbitration Award)",
      "29:1451" : "29:1451 (29:1451 E.R.I.S.A.)",
      "29:1801" : "29:1801 (29:1801 Farmworker Rights)",
      "29:790" : "29:790 (29:790 Rehabilitation of Labor)",
      "30:0181" : "30:0181 (30:181 Environment: Review of Agency Action)",
      "30:0801" : "30:0801 (30:0801 Penalities/Federal Mine Safety Health Act)",
      "30:1201" : "30:1201 (30:1201 Environment: Review of Agency Action)",
      "30:1202" : "30:1202 (30:1202 Mining Reclamation Act)",
      "30:1276" : "30:1276 (30:1276 Interior: Review of Agency Action)",
      "31:3545" : "31:3545 (31:3545 Action to Recovery Money)",
      "31:3729" : "31:3729 (31:3729 False Claims Act)",
      "31:3730" : "31:3730 (31:3730 Qui Tam False Claims Act)",
      "31:3731" : "31:3731 (31:3731 Fraud)",
      "33:1319cw" : "33:1319cw (33:1319 Clean Water Act)",
      "33:1319pv" : "33:1319pv (33:1319 Pollutants & Permit Violations)",
      "33:1365" : "33:1365 (33:1365 Environmental Matters)",
      "35:0145" : "35:0145 (35:145 Patent Infringement)",
      "35:0183" : "35:0183 (35:183 Patent Infringement)",
      "35:0271" : "35:0271 (35:271 Patent Infringement)",
      "38:1681" : "38:1681 (38:1681 Recovery of VA Overpayment)",
      "38:1686" : "38:1686 (38:1686 Recovery of VA Overpayment)",
      "38:1780" : "38:1780 (38:1780 Recovery of VA Overpayment)",
      "38:2011" : "38:2011 (38:2011 - Veteran's Readjustment Assistance Act of)",
      "38:2021" : "38:2021 (Right to re-employment of inducted persons)",
      "38:3116" : "38:3116 (38:3116 VA Overpayment)",
      "38:4301" : "38:4301 (38:4301 USERRA)",
      "38:775" : "38:775 (Recovery of Servicemen's Group Life Insurance)",
      "39:3005" : "39:3005 (39:3005 Detention of Mail for Temporary Periods)",
      "39:409" : "39:409 (39:409 Postal Service)",
      "40:0258" : "40:0258 (40:258(a) Public Buildings & Property: Land Condemnation)",
      "40:0875" : "40:0875 (40:875 Public Buildings & Property: Negligence)",
      "40:3131" : "40:3131 (40:3131 Miller Act)",
      "41:0251" : "41:0251 (41:251 Public Contracts-Review of Agency Action)",
      "41:1463" : "41:1463 (41:1463 Public Contracts: Unlawful Employment Practices)",
      "42:0205" : "42:0205 (42:205 Denial Social Security Benefits)",
      "42:0206" : "42:0206 (42:206 Social Security Benefits)",
      "42:0247" : "42:0247 (42:247 Personal Injury-Swine Flu)",
      "42:0402" : "42:0402 (42:402 Social Security Benefits)",
      "42:0405id" : "42:0405id (42:405 Review of HHS Decision (SSID))",
      "42:0405rsi" : "42:0405rsi (42:0405 Review of HHS Decision (RSI))",
      "42:0405wc" : "42:0405wc (42:405 Review of HHS Decision (DIWC))",
      "42:0405ww" : "42:0405ww (42:405 Review of HHS Decision (DIWW))",
      "42:0416" : "42:0416 (42:416 Denial of Social Security Benefits)",
      "42:0427" : "42:0427 (42:427 Social Security Benefits)",
      "42:12101" : "42:12101 (42:12101 Americans with Disablities Act)",
      "42:1383" : "42:1383 (42:1383 Review of HHS Decision)",
      "42:1395" : "42:1395 (42:1395 HHS: Adverse Reimbursement Review)",
      "42:1396" : "42:1396 (42:1396 - Tort Negligence)",
      "42:1471" : "42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclo)",
      "42:1981cv" : "42:1981cv (42:1981 Civil Rights)",
      "42:1981hs" : "42:1981hs (42:1981 Housing Discrimination)",
      "42:1981jb" : "42:1981jb (42:1981 Job Discrimination (Race))",
      "42:1981sx" : "42:1981sx (42:1981 Sex Discrimination)",
      "42:1983cv" : "42:1983cv (42:1983 Civil Rights Act)",
      "42:1983ed" : "42:1983ed (42:1983 Civil Rights (Employment Discrimination))",
      "42:1983pr" : "42:1983pr (42:1983 Prisoner Civil Rights)",
      "42:1986" : "42:1986 (42:1986 Neglect of Duty)",
      "42:2000ag" : "42:2000ag (42:2000 Job Discrimination (Age))",
      "42:2000e" : "42:2000e (42:2000e Job Discrimination (Employment))",
      "42:2000pb" : "42:2000pb (42:2000 Job Discrimination (Public Accommodations))",
      "42:2000ra" : "42:2000ra (42:2000 Job Discrimination (Race))",
      "42:2000sx" : "42:2000sx (42:2000 Job Discrimination (Sex))",
      "42:2003" : "42:2003 (42:2003 Job Discrimination)",
      "42:2005" : "42:2005 (42:2005 Review of Agency Action-HHS)",
      "42:2615" : "42:2615 (42:2616 Medical Recovery Act)",
      "42:2651" : "42:2651 (42:2651 Medical Care Recovery)",
      "42:3601" : "42:3601 (42:405 Fair Housing Act)",
      "42:4000" : "42:4000 (42:4000 National Flood Insurance Act)",
      "42:4001" : "42:4001 (42:4001 National Insurance Flood Act)",
      "42:4053" : "42:4053 (42:4053 Breach of Insurance Contract)",
      "42:4072" : "42:4072 (42:4072 Payment of Flood Insurance Claim)",
      "42:4321" : "42:4321 (42:4321 Review of Agency Action-Environment)",
      "42:4332" : "42:4332 (42:4332)",
      "42:6901en" : "42:6901en (42:6901 Environmental Cleanup Expenses)",
      "42:6901rs" : "42:6901rs (42:6901 Resource & Recovery Act)",
      "42:7413" : "42:7413 (42:7413(b) Clean Air Act)",
      "42:7604cl" : "42:7604cl (42:7604 Clear Air Act (Emission Standards))",
      "42:7604ir" : "42:7604ir (42:7604 Petition to Quash IRS Summons)",
      "42:9607" : "42:9607 (42:9607 Real Property Tort to Land)",
      "43:945" : "43:945 (43:945 Compensation for Land Condemnation)",
      "43:945a" : "43:945a (43:945a Complaint in Condemnation)",
      "43:946" : "43:946 (43:946 Complaint in Condemnation - Eminent Domain)",
      "45:0051" : "45:0051 (45:51 Railways: Fed. Employer's Liability Act)",
      "45:0151" : "45:0151 (45:151 Railway Labor Act)",
      "45:0184" : "45:0184 (45:184 Action to Set Aside Award of a System Board of Adjust)",
      "45:1395" : "45:1395 (45:1395 Railroads: Adverse Reimbursement Review)",
      "45:7457" : "45:7457 (45:7457 Compel Reclamation Under Clear Air Act)",
      "46:0688" : "46:0688 (46:688 Jones Act)",
      "46:0741" : "46:0741 (46:741 Shipping)",
      "46:0761" : "46:0761 (46:761 Shipping: Damages for Death on High Seas)",
      "46:1101" : "46:1101 (46:1101 Violation of Maritime Regulations)",
      "46:1156" : "46:1156 (46:1156 Administrative Procedure Act)",
      "47:0332" : "47:0332 (47:332(c) Communications Act of 1996)",
      "47:0605" : "47:0605 (47:605 Communications Act of 1934)",
      "47:227" : "47:227 (47:227 FCC-Unsolicited Telephone Sales)",
      "48:0883" : "48:0883 (48:883 Violation of US Coastal Law)",
      "48:1985" : "48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)",
      "49:0081" : "49:0081 (49:81 Damaged Goods While Being Transported)",
      "49:0781" : "49:0781 (49:781 Forfeiture)",
      "49:11503" : "49:11503 (49:11503 Railroad Revitalization Regulatory Reform)",
      "49:11702" : "49:11702 (49:11702(a)(4) Violations of Interstate Commerce A)",
      "49:1471" : "49:1471 (49:1471 Federal Aviation Act)",
      "49:1903" : "49:1903 (49:1903 Petition to enforce administrative summon)",
      "8:287" : "8:287 (8:287 Petition to Enforce INS Subpoena)",
      "99:9999" : "99:9999 (99:9999 Report cause code (DO NOT DELETE!))",
      "ShellCase" : "ShellCase (Electronic Intake)",
      "adsup" : "adsup (Administrative Subpoena)",
      "contempt" : "contempt (Contempt Proceedings)",
      "disbar" : "disbar (Disbarment Proceedings)",
      "fordepo" : "fordepo (Foreign Deposition)",
      "misc" : "misc (Civil Miscellaneous Case)",
      "motcomp" : "motcomp (Motion to Compel)",
      "motquash" : "motquash (Motion to Quash)",
      "motret" : "motret (Motion for Return of Property)",
      "petenf" : "petenf (Petition to Enforce IRS Summons)",
      "petper" : "petper (Petition to Perpetuate Testimony)",
      "regjgm" : "regjgm (Registration of Foreign Judgment)",
      "tranbkref" : "tranbkref (Transmission of Bankruptcy Reference)",
      "tranff" : "tranff (Transmission of Proposed Findings of Fact and Concl. of Law)",
      "writgar" : "writgar (Application for a Writ of Garnishment)"
   },
   "wvsdce" : {
      "0" : "0 (Civil Shell Case)",
      "02:0431" : "02:0431 (02:431 Fed. Election Commission: Failure Enforce C)",
      "02:0437" : "02:0437 (02:437 Federal Election Commission)",
      "05:0075" : "05:0075 (05:75(2) Contract - Reduction in Grade)",
      "05:0551" : "05:0551 (05:551 Administrative Procedure Act)",
      "05:0552fi" : "05:0552fi (05:552 Freedom of Information Act)",
      "05:0552pa" : "05:0552pa (05:552 Right to Privacy Act)",
      "05:0554" : "05:0554 (05:0554 Constitutionality of Maritime Statutes)",
      "05:0701" : "05:0701 (05:0701 Maritime Subsidy Board)",
      "05:0702" : "05:0702 (05:702 Administrative Procedure Act)",
      "05:0704" : "05:0704 (05:704 Labor Litigation)",
      "05:7703" : "05:7703 (05:7703 Discrimination - Review of Agency Act)",
      "05:8470" : "05:8470 (05:8470 Enforcement of Judgment against Retirement Benefits)",
      "07:0006" : "07:0006 (7:6(b) Federal Commodity Exchange Regulation)",
      "07:0025" : "07:0025 (7:25 Fraud - Commodities Leverage Contracts)",
      "07:0181" : "07:0181 (07:181 Packers & Stockyard Act)",
      "07:0499" : "07:0499 (07:499 Agricultural Commodities Act)",
      "07:0601" : "07:0601 (07:601 USDA Condemnation)",
      "07:2023" : "07:2023 (07:2023 - Food Stamp Act)",
      "07:2321" : "07:2321 (07:2321 Plant Variety Protection Act)",
      "08:1105" : "08:1105 (8:1105(a) Aliens: Habeas Corpus to Release INS Det)",
      "08:1182" : "08:1182 (8:1182 Defend. Denial of Pla. Appl. for Alien Employment Cer)",
      "08:1183a" : "08:1183a (08:1183a - Requirements for sponsor's affidavit of support)",
      "08:1252" : "08:1252 (08:1252(a)(2) Injunction for Deportation)",
      "08:1260" : "08:1260 (08:1260 Aliens: Access to Records)",
      "08:1324" : "08:1324 (08:1324 Aliens: Complaint for Forfeiture)",
      "08:1329" : "08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petiti)",
      "08:1446" : "08:1446 (8:1446 Petition for Naturalization Hearing)",
      "08:1451(j)" : "08:1451(j) (8:1451(j) Motion to Correct Order & Judg. of Naturalization)",
      "09:0001" : "09:0001 (09:1 U.S. Arbitration Act)",
      "09:0009" : "09:0009 (9:9 Motion to Confirm Arbitration Loan)",
      "09:0010" : "09:0010 (09:0010 Petition to Vacate Arbitration Award)",
      "10:1408" : "10:1408 (10:1408 Claim for Military Retirement)",
      "10:1552" : "10:1552 (10:1552 Armed Forces: Action to Correct Records)",
      "10:1553" : "10:1553 (10:1553 Armed Forces: FOIA General)",
      "10:2005" : "10:2005 (10:2005 Recovery of Army Reserve Officers Training Benefits)",
      "10:2305" : "10:2305 (10:2305 Review of Federal Contract)",
      "111111" : "111111 (Registration of Foreign Judgment)",
      "11:0101" : "11:0101 (11:101 Bankruptcy)",
      "11:0362" : "11:0362 (11:0362 Enforcement of Bankruptcy Stay)",
      "12:0022" : "12:0022 (12:22 Securities Fraud)",
      "12:0635" : "12:0635 (12:635 Breach of Insurance Contract)",
      "12:1441a" : "12:1441a (12:1441(a) Fed Question: Collection of Note & Security Agrmt)",
      "12:1461" : "12:1461 (12:1461 Homeowners Loan Act)",
      "12:1463" : "12:1463 (12:1463 Home Owner's Loan Act)",
      "12:1464" : "12:1464 (12:1464 Federal Savings and Loan)",
      "12:1703" : "12:1703 (12:1703 Default of HUD Loan)",
      "12:1716" : "12:1716 (12:1716 Fannie Mae Charter Act)",
      "12:1725" : "12:1725 (12:1725 Collection under Contract Guaranty)",
      "12:1730" : "12:1730 (12:1730 Collection Under Contract Guaranty)",
      "12:1819" : "12:1819 (12:1819 Default of Promissory Note)",
      "12:1821" : "12:1821 (12:1821 Default of Loan by Promissary Note)",
      "12:1831" : "12:1831 (12:1831 Depository Institution Employee Protection Remedy)",
      "12:191" : "12:191 (12:191 Bank Foreclosure)",
      "12:192" : "12:192 (12:192 Liquidation of National Bank)",
      "12:1971" : "12:1971 (12:1971 Relief under Bank Holding Act)",
      "12:1972" : "12:1972 (12:1972 Typing Arrangement Act)",
      "12:2605" : "12:2605 (12:2605 Real Estate Settlement Procedures Act)",
      "12:3410" : "12:3410 (12:3410 Right to Financial Privacy Act)",
      "12:5567" : "12:5567 (12:5567 Employee protection)",
      "12:632" : "12:632 (12:632 Jurisdiction of US Courts over suits where Federal Reserve Bank is a party)",
      "12:85,86" : "12:85,86 (12:85, 86 National Bank Act)",
      "15:0001" : "15:0001 (15:1 Antitrust Litigation)",
      "15:0002at" : "15:0002at (15:2 Antitrust Litigation)",
      "15:0002fl" : "15:0002fl (15:2(a) Fair Labor Standards Act)",
      "15:0005" : "15:0005 (15:5(a) Fair Labor Standards Act)",
      "15:0015" : "15:0015 (15:15 Antitrust Litigation)",
      "15:0025" : "15:0025 (15:25 Clayton Act)",
      "15:0044" : "15:0044 (15:44 Trademark Infringement)",
      "15:0045" : "15:0045 (15:0045 Federal Trade Commission Act)",
      "15:0052" : "15:0052 (15:0052 Federal Trade Commission Act)",
      "15:0053" : "15:0053 (15:0053 Federal Trade Commission Act)",
      "15:0077" : "15:0077 (15:77 Securities Fraud)",
      "15:0078" : "15:0078 (15:78m(a) Securities Exchange Act)",
      "15:0631" : "15:0631 (15:631 Small Business Act)",
      "15:0717" : "15:0717 (15:717 Natural Gas Act)",
      "15:0754" : "15:0754 (15:754 Emergency Petroleum Allocation-Admin.& Enforcement)",
      "15:1051" : "15:1051 (15:1051 Trademark Infringement)",
      "15:1114" : "15:1114 (15:1114 Trademark Infringement)",
      "15:1121" : "15:1121 (15:1121 Trademark Infringement)",
      "15:1125" : "15:1125 (15:1125 Trademark Infringement (Lanham Act))",
      "15:1126" : "15:1126 (15:1126 Patent Infringement)",
      "15:1127" : "15:1127 (15:1127 Trademark Infringement)",
      "15:1601" : "15:1601 (15:1601 Truth in Lending)",
      "15:1635" : "15:1635 (15:1635 Right of Rescission as to Certain Transactions)",
      "15:1640" : "15:1640 (15:1640 Truth in Lending)",
      "15:1681" : "15:1681 (15:1681 Fair Credit Reporting Act)",
      "15:1692" : "15:1692 (15:1692 Fair Debt Collection Act)",
      "15:1693" : "15:1693 (15:1693 Credit Card Accountability, Responsibility & Disclosure Act)",
      "15:1938" : "15:1938 (15:1938 Fair Labor Standards Act)",
      "15:1981" : "15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))",
      "15:1988" : "15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))",
      "15:1989" : "15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))",
      "15:2301" : "15:2301 (15:2301 Magnuson-Moss Warranty Act)",
      "15:2801" : "15:2801 (15:2801 Petroleum Marketing Practices Act)",
      "15:53(b)" : "15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equita)",
      "16:0668" : "16:0668 (16:668 Bald Eagle Protection Act)",
      "16:0703" : "16:0703 (16:703 Migratory Bird Act)",
      "16:1538" : "16:1538 (16:1538 Endangered Species Act)",
      "16:3371" : "16:3371 (16:3371 Wildlife Under the Lacey Act)",
      "16:3372" : "16:3372 (16:3372 Conservation: Complaint for Forfeiture)",
      "16:3373" : "16:3373 (16:3373 Appeal of Decision - DOI)",
      "16:3374" : "16:3374 (16:3374 Conservation: Complaint for Forfeiture)",
      "16:814" : "16:814 (Excercise by Licensee of Power of Eminent Domain)",
      "17:0101" : "17:0101 (17:101 Copyright Infringement)",
      "17:0501" : "17:0501 (17:501 Copyright Infringement)",
      "17:0504" : "17:0504 (17:504 Copyright Infringement)",
      "18:0241" : "18:0241 (18:241 Conspiracy Against Citizen Rights)",
      "18:1836a" : "18:1836a (18:1836(a) Injunction against Misappropriation of Trade Secrets)",
      "18:1836b" : "18:1836b (18:1836(b) Civil Action to Protect Trade Secrets)",
      "18:1961" : "18:1961 (18:1961 Racketeering (RICO) Act)",
      "18:1962" : "18:1962 (18:1962 Racketeering (RICO) Act)",
      "18:1964" : "18:1964 (18:1964 Racketeering (RICO) Act)",
      "18:2254a2" : "18:2254a2 (18:2254(a)(2) - Forfeiture of property used to commit child pornography offenses)",
      "18:2428b1" : "18:2428b1 (18:2428(b)(1) Forfeiture of Property - Transportation for illegal sexual activity and related crimes)",
      "18:2511" : "18:2511 (18:2511 Wiretapping)",
      "18:2701" : "18:2701 (18:2701 Stored Communications Act)",
      "18:3114" : "18:3114 (18:3114 Motion for Return of Seized Property)",
      "18:3582" : "18:3582 (18:3582(c)(2) Motion for Modification of Sentence)",
      "18:3663" : "18:3663 (Conversion of Restitution Order to Civil Judgment)",
      "18:4208" : "18:4208 (18:4208(B) Agency Action Review)",
      "18:923f3" : "18:923f3 (18:923(f)(3) Review of a Revocation of Firearms License)",
      "18:924(d)" : "18:924(d) (18:924(d) - Forfeiture of Property-Firearms)",
      "18:981" : "18:981 (18:981(a)(1)(C) Forfeiture of Proceeds of Mail Fraud Scheme)",
      "18:981a1c" : "18:981a1c (18:981(a)(1)(C) - Forfeiture of proceeds of contraband cigarette trafficking)",
      "19:1305" : "19:1305 (19:1305 Custom Duties:0Forfeiture-Immoral Articles)",
      "20:1080" : "20:1080 (20:1080 Student Loan Recovery)",
      "20:1400" : "20:1400 (20:1400 Civil Rights of Handicapped Child)",
      "20:1401" : "20:1401 (20:1401 Individuals with Disabilities Education Act (IDEA))",
      "20:6301" : "20:6301 (20:6301 Elem & Secondary Education Act of 1965, as amended)",
      "21:0301" : "21:0301 (21:0301 Federal Food, Drug and Cosmetic Act)",
      "21:0801" : "21:0801 (21:801 Controlled Substances Act)",
      "21:0841" : "21:0841 (21:841 Forfeiture Property-Drugs)",
      "21:0881" : "21:0881 (21:881 Forfeiture Property-Drugs)",
      "21:0881a" : "21:0881a (21:881 Forfeiture Property - Aircraft)",
      "21:0881re" : "21:0881re (21:881 Forfeiture Property - Real Estate)",
      "22:9001" : "22:9001 (22:9001 et seq. International Child Abduction Remedies Act)",
      "23:0134" : "23:0134 (23:134 P.I.- Auto Negligence)",
      "23:1441" : "23:1441 (23:1441 Contract Real Estate)",
      "24:1000" : "24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)",
      "25:0640" : "25:0640 (25:640 Indian Tribal Rights)",
      "25:1901" : "25:1901 (25:1901 Indian Child Welfare Act)",
      "26:6212" : "26:6212 (26:6212 Injunctive Relief from IRS Lien)",
      "26:6213" : "26:6213 (26:6213 Injunctive Relief from IRS Lien)",
      "26:6502" : "26:6502 (26:6502 IRS:Enforcement of tax liens)",
      "26:6532" : "26:6532 (26:6532 IRS: Refund of Tax Penalty)",
      "26:6702" : "26:6702 (26:6702 IRS: Refund of Income Tax Penalty)",
      "26:6703" : "26:6703 (26:6703 IRS: Refund of Tax Penalty)",
      "26:7401" : "26:7401 (26:7401 IRS: Tax Liability)",
      "26:7402" : "26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)",
      "26:7403" : "26:7403 (26:7403 Suit to Enforce Federal Tax Lien)",
      "26:7422rt" : "26:7422rt (26:7422 IRS: Refund Taxes)",
      "26:7422rx" : "26:7422rx (26:7422 IRS: Refund Excise Tax)",
      "26:7426" : "26:7426 (26:7426 IRS: Wrongful Levy for Taxes)",
      "26:7429" : "26:7429 (26:7429 IRS: Tax Jeopardy Assessment)",
      "26:7434" : "26:7434 (26:7434 Civil Damages for Fraudulent Filing of Information Returns)",
      "26:7609" : "26:7609 (26:7609 IRS: Petition to Quash IRS Summons)",
      "27:0185" : "27:0185 (27:185 Enforcement of Arbitration Award)",
      "28:0157c" : "28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)",
      "28:0157d" : "28:0157d (28:0157 Motion for Withdrawal of Reference)",
      "28:0158" : "28:0158 (28:0158 Notice of Appeal re Bankruptcy Matter (BA)",
      "28:0185" : "28:0185 (28:185 Suit to Compel Arbitration)",
      "28:0451" : "28:0451 (28:451 Employment Discrimination)",
      "28:0754" : "28:0754 (28:754 Receiver of Property in Different Districts)",
      "28:0794" : "28:0794 (28:794 Rehabilitation Act)",
      "28:1001" : "28:1001 (28:1001 E.R.I.S.A.)",
      "28:1132" : "28:1132 (28:1132 E.R.I.S.A.)",
      "28:1330" : "28:1330 (28:1330 Breach of Contract)",
      "28:1331" : "28:1331 (28:1331 Fed. Question)",
      "28:1331al" : "28:1331al (28:1331 Fed. Question: Airline Crash)",
      "28:1331at" : "28:1331at (28:1331 Fed. Question: Anti-trust)",
      "28:1331au" : "28:1331au (28:1331 Fed. Question: Auto Negligence)",
      "28:1331b" : "28:1331b (28:1331 Federal Question: Bivens Act)",
      "28:1331bc" : "28:1331bc (28:1331 Fed. Question: Breach of Contract)",
      "28:1331ca" : "28:1331ca (28:1331 Fed Question: Fed Communications Act of 1)",
      "28:1331cm" : "28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)",
      "28:1331cv" : "28:1331cv (28:1331 Federal Question: Other Civil Rights)",
      "28:1331ed" : "28:1331ed (28:1331 Fed. Question: Employment Discrimination)",
      "28:1331ej" : "28:1331ej (28:1331 Federal Question: Enforcement of Judgment)",
      "28:1331es" : "28:1331es (28:1331 Enforcement of Administrative Subpoena)",
      "28:1331fl" : "28:1331fl (28:1331 Fed. Question: Fair Labor Standards)",
      "28:1331ij" : "28:1331ij (28:1331ij Federal Question Injunction and Declaratory Relief)",
      "28:1331in" : "28:1331in (28:1331 Fed. Question: Insurance Contract)",
      "28:1331mm" : "28:1331mm (28:1331 Fed. Question: Medical Malpractice)",
      "28:1331ng" : "28:1331ng (28:1331 Fed. Question: Natural Gas Act)",
      "28:1331pi" : "28:1331pi (28:1331 Fed. Question: Personal Injury)",
      "28:1331rd" : "28:1331rd (28:1331 Fed. Question: Review Agency Decision)",
      "28:1331rp" : "28:1331rp (28:1331(a) Fed. Question: Real Property)",
      "28:1331rr" : "28:1331rr (28:1331 Fed. Question: Railway Labor Act)",
      "28:1331sv" : "28:1331sv (28:1331 Fed. Question: Securities Violation)",
      "28:1331tr" : "28:1331tr (28:1331 Fed. Question: Trademark)",
      "28:1331tt" : "28:1331tt (28:1331 Fed. Question: Tort Action)",
      "28:1331v" : "28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendme)",
      "28:1331vi" : "28:1331vi (28:1331 Violation of First Amendment)",
      "28:1331wl" : "28:1331wl (28:1331 Federal Question: EPA Waste Lien)",
      "28:1331wt" : "28:1331wt (28:1331 Fed. Question: Water Rights)",
      "28:1332" : "28:1332 (28:1332 Diversity - Class Action Fairness Act of 2005)",
      "28:1332ac" : "28:1332ac (28:1332 Diversity-Account Receivable)",
      "28:1332al" : "28:1332al (28:1332 Diversity-Airline Crash)",
      "28:1332as" : "28:1332as (28:1332 Diversity-Asbestos Litigation)",
      "28:1332au" : "28:1332au (28:1332 Diversity-Auto Negligence)",
      "28:1332bc" : "28:1332bc (28:1332 Diversity-Breach of Contract)",
      "28:1332co" : "28:1332co (28:1332 Diversity-Conversion)",
      "28:1332ct" : "28:1332ct (28:1332 Diversity-(Citizenship))",
      "28:1332det" : "28:1332det (28:1332 Diversity: Forcible Detainer)",
      "28:1332df" : "28:1332df (28:1332 Diversity-Contract Default)",
      "28:1332ds" : "28:1332ds (28:1332 Diversity-Contract Dispute)",
      "28:1332ed" : "28:1332ed (28:1332 Diversity-Employment Discrimination)",
      "28:1332fd" : "28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)",
      "28:1332fr" : "28:1332fr (28:1332 Diversity-Fraud)",
      "28:1332ia" : "28:1332ia (28:1332 Diversity-Interpleader Action)",
      "28:1332ij" : "28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)",
      "28:1332in" : "28:1332in (28:1332 Diversity-Insurance Contract)",
      "28:1332jd" : "28:1332jd (28:1332 Diversity-Declaratory Judgment)",
      "28:1332lb" : "28:1332lb (28:1332 Diversity-Libel,Assault,Slander)",
      "28:1332lm" : "28:1332lm (28:1332 Diversity - Legal Malpractice)",
      "28:1332ma" : "28:1332ma (28:1332 Diversity-Miller Act)",
      "28:1332mm" : "28:1332mm (28:1332 Diversity-Medical Malpractice)",
      "28:1332mv" : "28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)",
      "28:1332ni" : "28:1332ni (28:1332 Diversity-Negotiable Instrument)",
      "28:1332nm" : "28:1332nm (28:1332 Diversity-Non-Motor Vehicle)",
      "28:1332nr" : "28:1332nr (28:1332 Diversity-Notice of Removal)",
      "28:1332oc" : "28:1332oc (28:1332 Diversity-Other Contract)",
      "28:1332pd" : "28:1332pd (28:1332 Diversity-Property Damage)",
      "28:1332pi" : "28:1332pi (28:1332 Diversity-Personal Injury)",
      "28:1332pl" : "28:1332pl (28:1332 Diversity-Product Liability)",
      "28:1332pr" : "28:1332pr (28:1332 Diversity-Petition for Removal)",
      "28:1332qt" : "28:1332qt (28:1332 Diversity-Petition to Quiet Title)",
      "28:1332ri" : "28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)",
      "28:1332sa" : "28:1332sa (28:1332 - Diversity: Securities & Exchange Commiss)",
      "28:1332sf" : "28:1332sf (28:1332 - Diversity: Securities Fraud)",
      "28:1332ss" : "28:1332ss (28:1332 Diversity - Stockholders Suits)",
      "28:1332tl" : "28:1332tl (28:1332 Diversity-Torts to Land)",
      "28:1332tm" : "28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))",
      "28:1332tn" : "28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)",
      "28:1332wd" : "28:1332wd (28:1332 Diversity-Wrongful Death)",
      "28:1333" : "28:1333 (28:1333 Admiralty)",
      "28:1334" : "28:1334 (28:1334 Bankruptcy Appeal)",
      "28:1334c" : "28:1334c (28:1334(c) R&R re motions for abstention (non-cor)",
      "28:1335" : "28:1335 (28:1335 Interpleader Action)",
      "28:1337" : "28:1337 (28:1337 Sherman-Clayton Act)",
      "28:1338cp" : "28:1338cp (28:1338 Copyright Infringement)",
      "28:1338pt" : "28:1338pt (28:1338 Patent Infringement)",
      "28:1338tr" : "28:1338tr (28:1338 Trademark Infringement)",
      "28:1340" : "28:1340 (28:1340 IRS: Custom Duties)",
      "28:1340er" : "28:1340er (28:1340 Recovery of Erroneous Refund)",
      "28:1341" : "28:1341 (28:1341 Complaint for Forfeiture)",
      "28:1343" : "28:1343 (28:1343 Violation of Civil Rights)",
      "28:1345" : "28:1345 (28:1345 USA Plaintiff)",
      "28:1345co" : "28:1345co (28:1345 Replevin & Conversion)",
      "28:1345db" : "28:1345db (28:1345 Debt to US - FHA/HUD Title I)",
      "28:1345df" : "28:1345df (28:1345 Default of Promissory Note)",
      "28:1345er" : "28:1345er (28:1345 Recovery of Erroneous Refund)",
      "28:1345fc" : "28:1345fc (28:1345 Foreclosure)",
      "28:1345ff" : "28:1345ff (28:1345 Complaint for Forfeiture)",
      "28:1345hl" : "28:1345hl (28:1345 VA Home Loan Guaranty Debt)",
      "28:1345mc" : "28:1345mc (28:1345 Medical Care Recovery)",
      "28:1345mi" : "28:1345mi (28:1345 Mining Claim Ejectment)",
      "28:1345pd" : "28:1345pd (28:1345 Property Damage)",
      "28:1345pe" : "28:1345pe (28:1345 Property Ejectment)",
      "28:1345rc" : "28:1345rc (28:1345 Recovery of Debt to US)",
      "28:1345st" : "28:1345st (28:1345 Default of Student Loan)",
      "28:1345tp" : "28:1345tp (28:1345 Trespass on Public Land)",
      "28:1345va" : "28:1345va (28:1345 Recovery of VA Overpayment)",
      "28:1346bc" : "28:1346bc (28:1346 Breach of Contract)",
      "28:1346rc" : "28:1346rc (28:1346 Recovery of IRS Tax)",
      "28:1346tc" : "28:1346tc (28:1346 Tort Claim)",
      "28:1346wd" : "28:1346wd (28:1346 Wrongful Death)",
      "28:1349" : "28:1349 (28:1348 Corporation organized under Federal Law as party)",
      "28:1352" : "28:1352 (28:1352 Miller Act)",
      "28:1355" : "28:1355 (28:1355 Petition for Return of Property)",
      "28:1358" : "28:1358 (28:1358 Land Condemnation)",
      "28:1361" : "28:1361 (28:1361 Petition for Writ of Mandamus)",
      "28:1362ic" : "28:1362ic (28:1362 Indian Tribal Controversy)",
      "28:1362iw" : "28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)",
      "28:1364" : "28:1364 (28:1364 Auto Negligence)",
      "28:1391" : "28:1391 (28:1391 Personal Injury)",
      "28:1402" : "28:1402 (28:1402 Medical Malpractice)",
      "28:1407" : "28:1407 (28:1407 Airline Crash)",
      "28:1441ac" : "28:1441ac (28:1441 Petition for Removal- Account Receivable)",
      "28:1441al" : "28:1441al (28:1441 Petition for Removal- Airline Crash)",
      "28:1441as" : "28:1441as (28:1441 Petition for Removal- Asbestos Litigation)",
      "28:1441au" : "28:1441au (28:1441 Petition for Removal- Auto Negligence)",
      "28:1441bc" : "28:1441bc (28:1441 Petition for Removal- Breach of Contract)",
      "28:1441cv" : "28:1441cv (28:1441 Petition for Removal- Civil Rights Act)",
      "28:1441df" : "28:1441df (28:1441 Petition for Removal- Contract Default)",
      "28:1441dj" : "28:1441dj (28:1441 Petition for Removal- Declaratory Judgemen)",
      "28:1441ds" : "28:1441ds (28:1441 Petition for Removal- Contract Dispute)",
      "28:1441ed" : "28:1441ed (28:1441 Petition for Removal - Employment Discrim)",
      "28:1441fc" : "28:1441fc (28:1441 Petition for Removal - Fair Credit Reporti)",
      "28:1441fr" : "28:1441fr (28:1441 Petition for Removal- Fraud)",
      "28:1441ij" : "28:1441ij (28:1441 Petition for Removal- Injunctive/Declarato)",
      "28:1441in" : "28:1441in (28:1441 Petition for Removal- Insurance Contract)",
      "28:1441int" : "28:1441int (28:1441 Petition for Removal- Action for Interplea)",
      "28:1441lb" : "28:1441lb (28:1441 Petition for Removal Libel,Assault,Slander)",
      "28:1441lm" : "28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relatio)",
      "28:1441mm" : "28:1441mm (28:1441 Petition for Removal- Medical Malpractice)",
      "28:1441ni" : "28:1441ni (28:1441 Petition for Removal- Negotiable Instrumen)",
      "28:1441nm" : "28:1441nm (28:1441 Petition for Removal- Non-Motor Vehicle)",
      "28:1441nr" : "28:1441nr (28:1441 Notice of Removal)",
      "28:1441oc" : "28:1441oc (28:1441 Petition For Removal--Other Contract)",
      "28:1441pd" : "28:1441pd (28:1441 Petition for Removal- Property Damage)",
      "28:1441pi" : "28:1441pi (28:1441 Petition for Removal- Personal Injury)",
      "28:1441pl" : "28:1441pl (28:1441 Petition for Removal- Product Liability)",
      "28:1441pr" : "28:1441pr (28:1441 Petition for Removal)",
      "28:1441qt" : "28:1441qt (28:1441 Petition for Removal- Petition to Quiet Ti)",
      "28:1441ri" : "28:1441ri (28:1441 Petition for Removal- Racketeering (RICO))",
      "28:1441sa" : "28:1441sa (28:1441 - Petition for Removal: SEC Act)",
      "28:1441sf" : "28:1441sf (28:1441 - Petition for Removal: Securities Fraud)",
      "28:1441tl" : "28:1441tl (28:1441 Petition for Removal- Torts to Land)",
      "28:1441tm" : "28:1441tm (28:1441 Petition for Removal- Tort/Motor Vehicle ()",
      "28:1441tn" : "28:1441tn (28:1441 Petition for Removal- Tort/Non-Motor Vehic)",
      "28:1441wd" : "28:1441wd (28:1441 Petition for Removal- Wrongful Death)",
      "28:1442a" : "28:1442a (28:1442a - Notice of Removal - Law Enforcement Officer Safety Act)",
      "28:1442bc" : "28:1442bc (28:1442 Petition for Removal- Breach of Contract)",
      "28:1442nr" : "28:1442nr (28:1442 Notice of Removal)",
      "28:1442pr" : "28:1442pr (28:1442 Petition for Removal)",
      "28:1443" : "28:1443 (28:1443(1) Rent, Lease & Ejectment)",
      "28:1444" : "28:1444 (28:1444 Petition for Removal- Foreclosure)",
      "28:1446in" : "28:1446in (28:1446 Breach of Contract- Insurance)",
      "28:1446nr" : "28:1446nr (28:1446 Notice of Removal)",
      "28:1446pd" : "28:1446pd (28:1446 Petition for Removal- Property Damage (P.I)",
      "28:1446pi" : "28:1446pi (28:1446 Petition for Removal- Personal Injury)",
      "28:1446pl" : "28:1446pl (28:1446pl Petition for Removal - Product Liability)",
      "28:1446pr" : "28:1446pr (28:1446 Petition for Removal)",
      "28:1452" : "28:1452 (28:1452 Removal of Claim in Civil Action Related to Bankruptcy Case)",
      "28:1453b" : "28:1453b (28:1453(b) - Class Action Fairness Act)",
      "28:1651" : "28:1651 (28:1651 Petition for Writ of Coram Nobis)",
      "28:1651a" : "28:1651a (28 USC 1651a - All Writs Act)",
      "28:1651hc" : "28:1651hc (28:1651 Petition for Writ of Habeas Corpus)",
      "28:1651mn" : "28:1651mn (28:1651 Petition for Writ of Mandamus)",
      "28:1738" : "28:1738 (28:1738 Enforce a Judgment for Monetary Damages)",
      "28:1782" : "28:1782 (28:1782 Letter rogatory - appointment)",
      "28:1916" : "28:1916 (28:1916 - Jones Act Seaman)",
      "28:1983" : "28:1983 (28:1983 Civil Rights)",
      "28:2201" : "28:2201 (28:2201 Constitutionality of State Statute(s))",
      "28:2201dj" : "28:2201dj (28:2201 Declaratory Judgment)",
      "28:2201ij" : "28:2201ij (28:2201 Injunction)",
      "28:2201in" : "28:2201in (28:2201 Declaratory Judgment (Insurance))",
      "28:2241" : "28:2241 (28:2241 Petition for Writ of Habeas Corpus (federal))",
      "28:2254" : "28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))",
      "28:2254se" : "28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)",
      "28:2255" : "28:2255 (28:2255 Motion to Vacate / Correct Illegal Sentence)",
      "28:2271" : "28:2271 (28:2271 Federal Tort Claims Act)",
      "28:2345" : "28:2345 (28:2345 Medicare Recovery)",
      "28:2409" : "28:2409 (28:2409(a) Quiet Title Action)",
      "28:2410" : "28:2410 (28:2410 Quiet Title)",
      "28:2671" : "28:2671 (28:2671 Federal Tort Claims Act)",
      "28:2674" : "28:2674 (28:2674 Federal Tort Claims Act)",
      "28:3001" : "28:3001 (28:3001 Federal Debt Collection Procedure)",
      "28:7402" : "28:7402 (28:7402 Refund of Taxes)",
      "28:7422" : "28:7422 (28:7422 Appeal from Administrative Decision)",
      "28:901-944" : "28:901-944 (28:901-944 - Black Lung Benefits Act)",
      "29:0151" : "29:0151 (29:151 Labor: Review of Agency Action)",
      "29:0160" : "29:0160 (29:160(1) National Labor Relations Act)",
      "29:0184" : "29:0184 (29:184 Violation Collection Bargain Agreement)",
      "29:0185ep" : "29:0185ep (29:185 Employee Pension Plan)",
      "29:0185lm" : "29:0185lm (29:185 Labor/Mgt. Relations (Contracts))",
      "29:0201do" : "29:0201do (29:201 Denial of Overtime Compensation)",
      "29:0201fl" : "29:0201fl (29:201 Fair Labor Standards Act)",
      "29:0203" : "29:0203 (29:203 Equal Pay Act)",
      "29:0206" : "29:0206 (29:206 Collect Unpaid Wages)",
      "29:0401" : "29:0401 (29:0401 Labor Management Disclosure Act)",
      "29:0621" : "29:0621 (29:621 Job Discrimination (Age))",
      "29:0623" : "29:0623 (29:623 Job Discrimination (Age))",
      "29:0626" : "29:0626 (29:626 Job Discrimination (Age))",
      "29:0630" : "29:0630 (29:630 Age Discrimination in Employment Act)",
      "29:0633" : "29:0633 (29:633 Job Discrimination (Age))",
      "29:0651" : "29:0651 (29:651 Occupational Safety/Health)",
      "29:0754" : "29:0754 (29:754 Discrimination)",
      "29:0791" : "29:0791 (29:791 Job Discrimination (Rehabilitation Act))",
      "29:0794" : "29:0794 (29:0794 Job Discrimination (Handicap))",
      "29:1001" : "29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)",
      "29:1002" : "29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)",
      "29:1104" : "29:1104 (29:1104 Recovery of Benefits to Employee)",
      "29:1109" : "29:1109 (29:1109 Breach of Fiduciary Duties)",
      "29:1131" : "29:1131 (29:1131 ERISA - Collection of Delinquent Trust Fun)",
      "29:1132" : "29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)",
      "29:1145" : "29:1145 (29:1145 E.R.I.S.A.)",
      "29:1149" : "29:1149 (29:1149 Recover Pension & Profit Sharing)",
      "29:1166" : "29:1166 (29:1166 Comprehensive Omnibus Budget Reconciliation Act of 1985 (COBRA))",
      "29:1337" : "29:1337 (29:1337 E.R.I.S.A.)",
      "29:1362" : "29:1362 (29:1362 ERISA)",
      "29:1381" : "29:1381 (29:1381 E.R.I.S.A.)",
      "29:1401" : "29:1401 (29:1401(b)(2) Appeal of Arbitration Award)",
      "29:1451" : "29:1451 (29:1451 E.R.I.S.A.)",
      "29:1801" : "29:1801 (29:1801 Farmworker Rights)",
      "29:2101" : "29:2101 (29:2101 - Worker Adjustment and Retraining Notification Act, \"WARN Act\")",
      "29:2601" : "29:2601 (29 USC 2601: Family & Medical Leave Act of 1993)",
      "29:790" : "29:790 (29:790 Rehabilitation of Labor)",
      "30:0181" : "30:0181 (30:181 Environment: Review of Agency Action)",
      "30:0801" : "30:0801 (30:0801 Penalities/Federal Mine Safety Health Act)",
      "30:0818" : "30:0818 (30:0818 Injunctions/Federal Mine Safety Health Act)",
      "30:0819" : "30:0819 (30:0819 - Civil Penalty Assessment Petition)",
      "30:0820j" : "30:0820j (30:0820 - Complaint for Collection of Civil Penalties)",
      "30:1201" : "30:1201 (30:1201 Environment: Review of Agency Action)",
      "30:1202" : "30:1202 (30:1202 Mining Reclamation Act)",
      "30:1270" : "30:1270 (30:1270 Surface Mining Control & Reclamation Act)",
      "30:1276" : "30:1276 (30:1276 Interior: Review of Agency Action)",
      "31:3545" : "31:3545 (31:3545 Action to Recovery Money)",
      "31:3729" : "31:3729 (31:3729 False Claims Act)",
      "31:3730" : "31:3730 (31:3730 Qui Tam False Claims Act)",
      "31:3731" : "31:3731 (31:3731 Fraud)",
      "31:5317" : "31:5317 (31:5317 Search and Forfeiture of Monetary Instruments)",
      "31:5324" : "31:5324 (31:5324 Structuring Transaction to Evade Reporting Requirement Prohibited)",
      "33:0914f" : "33:0914f (33:0914(f) Longshore and Harbor Workers' Compensation Act)",
      "33:1319cw" : "33:1319cw (33:1319 Clean Water Act)",
      "33:1319pv" : "33:1319pv (33:1319 Pollutants & Permit Violations)",
      "33:1365" : "33:1365 (33:1365 Environmental Matters)",
      "33:2701" : "33:2701 (33:2701 Oil Pollution Act of 1990)",
      "35:0145" : "35:0145 (35:145 Patent Infringement)",
      "35:0183" : "35:0183 (35:183 Patent Infringement)",
      "35:0271" : "35:0271 (35:271 Patent Infringement)",
      "38:1681" : "38:1681 (38:1681 Recovery of VA Overpayment)",
      "38:1686" : "38:1686 (38:1686 Recovery of VA Overpayment)",
      "38:1780" : "38:1780 (38:1780 Recovery of VA Overpayment)",
      "38:2011" : "38:2011 (38:2011 - Veteran's Readjustment Assistance Act of)",
      "38:2021" : "38:2021 (38:2021 Right to re-employment of inducted persons)",
      "38:3116" : "38:3116 (38:3116 VA Overpayment)",
      "38:4301" : "38:4301 (38:4301 Uniform Services Employment and Re-employment Rights Act of 1994 (USERRA))",
      "38:775" : "38:775 (Recovery of Servicemen's Group Life Insurance)",
      "39:3005" : "39:3005 (39:3005 Detention of Mail for Temporary Periods)",
      "39:409" : "39:409 (39:409 Postal Service)",
      "40:0258" : "40:0258 (40:258(a) Public Buildings & Property: Land Condem)",
      "40:0270" : "40:0270 (40:270 Miller Act)",
      "40:0875" : "40:0875 (40:875 Public Buildings & Property: Negligence)",
      "41:0251" : "41:0251 (41:251 Public Contracts-Review of Agency Action)",
      "41:1463" : "41:1463 (41:1463 Public Contracts: Unlawful Employment Prac)",
      "42:0205" : "42:0205 (42:205 Denial Social Security Benefits)",
      "42:0206" : "42:0206 (42:206 Social Security Benefits)",
      "42:0247" : "42:0247 (42:247 Personal Injury-Swine Flu)",
      "42:0292" : "42:0292 (42:292 - U. S. Health Education Assistance Loan (HEAL) Program)",
      "42:0294" : "42:0294 (42:294 - U. S. Health Education Assistance Loan (HEAL) Program)",
      "42:0402" : "42:0402 (42:402 Social Security Benefits)",
      "42:0405 g" : "42:0405 g (42:405(g) - Reversal of Medicare Reimbursement Decision)",
      "42:0405g" : "42:0405g (42:0405g RSI Tax Suits)",
      "42:0405id" : "42:0405id (42:405 Review of HHS Decision (SSID))",
      "42:0405wc" : "42:0405wc (42:405 Review of HHS Decision (DIWC))",
      "42:0405ww" : "42:0405ww (42:405 Review of HHS Decision (DIWW))",
      "42:0416" : "42:0416 (42:416 Denial of Social Security Benefits)",
      "42:0427" : "42:0427 (42:427 Social Security Benefits)",
      "42:11601" : "42:11601 (42:11601 International Child Abduction Remedies Act)",
      "42:12101" : "42:12101 (42:12101 Americans With Disabilities Act of 1991)",
      "42:1211" : "42:1211 (42:1211 - Americans with Disabilities Act)",
      "42:1320d" : "42:1320d (42:1320(d) Health Insurance Portability and Accountability Act of 1997 (HIPPA))",
      "42:1383" : "42:1383 (42:1383 Review of HHS Decision)",
      "42:1395" : "42:1395 (42:1395 HHS: Adverse Reimbursement Review)",
      "42:1395dd" : "42:1395dd (42:1395dd Emergency Medical Treatment and Active Labor Act (EMTALA))",
      "42:1396" : "42:1396 (42:1396 - Tort Negligence)",
      "42:1471" : "42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclo)",
      "42:15043" : "42:15043 (42:15043 Developmental Disabilities & Bill of Rights Act)",
      "42:1981cv" : "42:1981cv (42:1981 Civil Rights)",
      "42:1981hs" : "42:1981hs (42:1981 Housing Discrimination)",
      "42:1981jb" : "42:1981jb (42:1981 Job Discrimination (Race))",
      "42:1981sx" : "42:1981sx (42:1981 Sex Discrimination)",
      "42:1983cv" : "42:1983cv (42:1983 Civil Rights Act)",
      "42:1983ed" : "42:1983ed (42:1983 Civil Rights (Employment Discrimination))",
      "42:1983pr" : "42:1983pr (42:1983 Prisoner Civil Rights)",
      "42:1986" : "42:1986 (42:1986 Neglect of Duty)",
      "42:2000ag" : "42:2000ag (42:2000 Job Discrimination (Age))",
      "42:2000e" : "42:2000e (42:2000e Job Discrimination (Employment))",
      "42:2000pb" : "42:2000pb (42:2000 Job Discrimination (Public Accomodations))",
      "42:2000ra" : "42:2000ra (42:2000 Job Discrimination (Race))",
      "42:2000sx" : "42:2000sx (42:2000 Job Discrimination (Sex))",
      "42:2003" : "42:2003 (42:2003 Job Discrimination)",
      "42:2005" : "42:2005 (42:2005 Review of Agency Action-HHS)",
      "42:2615" : "42:2615 (42:2616 Medical Recovery Act)",
      "42:2651" : "42:2651 (42:2651 Medical Care Recovery)",
      "42:3601" : "42:3601 (42:405 Fair Housing Act)",
      "42:3604" : "42:3604 (42:3604 Violation of Fair Housing Act)",
      "42:4000" : "42:4000 (42:4000 National Flood Insurance Act)",
      "42:4001" : "42:4001 (42:4001 National Insurance Flood Act)",
      "42:405" : "42:405 (42:405 Black Lung)",
      "42:4053" : "42:4053 (42:4053 Breach of Insurance Contract)",
      "42:4072" : "42:4072 (42:4072 Payment of Flood Insurance Claim)",
      "42:4321" : "42:4321 (42:4321 Review of Agency Action-Environment)",
      "42:4332" : "42:4332 (42:4332 Environmental Policy - Coop of Agency Repo)",
      "42:6901en" : "42:6901en (42:6901 Environmental Cleanup Expenses)",
      "42:6901rs" : "42:6901rs (42:6901 Resource & Recovery Act)",
      "42:7413" : "42:7413 (42:7413(b) Clean Air Act)",
      "42:7604cl" : "42:7604cl (42:7604 Clear Air Act (Emission Standards))",
      "42:7604ir" : "42:7604ir (42:7604 Petition to Quash IRS Summons)",
      "42:9601" : "42:9601 (42:9601- CERCLA)",
      "42:9607" : "42:9607 (42:9607 Real Property Tort to Land)",
      "42:9831" : "42:9831 (42:9831 Federal Violations of the Head Start Act)",
      "43:945" : "43:945 (43:945 Compensation for Land Condemnation)",
      "43:945a" : "43:945a (43:945a Complaint in Condemnation)",
      "43:946" : "43:946 (43:946 Complaint in Condemnation - Eminent Domain)",
      "45:0051" : "45:0051 (45:51 Railways: Fed. Employer's Liability Act)",
      "45:0151" : "45:0151 (45:151 Railway Labor Act)",
      "45:0184" : "45:0184 (45:184 Action to Set Aside Award of a System Board)",
      "45:1395" : "45:1395 (45:1395 Railroads: Adverse Reimbursement Review)",
      "45:7457" : "45:7457 (45:7457 Compel Reclamation Under Clear Air Act)",
      "46:0688" : "46:0688 (46:688 Jones Act)",
      "46:0741" : "46:0741 (46:741 Shipping)",
      "46:0761" : "46:0761 (46:761 Shipping: Damages for Death on High Seas)",
      "46:1101" : "46:1101 (46:1101 Violation of Maritime Regulations)",
      "46:1156" : "46:1156 (46:1156 Administrative Procedure Act)",
      "46:688" : "46:688 (46:688 Jones Act)",
      "47:0227" : "47:0227 (47:0227 Telephone Consumer Protection Act)",
      "47:0605" : "47:0605 (47:0605 Communication Act of 1934)",
      "47:151" : "47:151 (47:151 Telecommunications Act of 1996)",
      "47:401(b)" : "47:401(b) (Intrastate rates and tariff)",
      "47:605" : "47:605 (47:605 Communications Act of 1934)",
      "48:0883" : "48:0883 (48:883 Violation of US Coastal Law)",
      "48:1985" : "48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)",
      "49:0081" : "49:0081 (49:81 Damaged Goods While Being Transported)",
      "49:0781" : "49:0781 (49:781 Forfeiture)",
      "49:11503" : "49:11503 (49:11503 Railroad Revitalization Regulatory Reform)",
      "49:11702" : "49:11702 (49:11702(a)(4) Violations of Interstate Commerce A)",
      "49:1471" : "49:1471 (49:1471 Federal Aviation Act)",
      "49:1903" : "49:1903 (49:1903 Petition to enforce administrative summon)",
      "49:20101" : "49:20101 (49:20101 Federal Railroad Safety Act)",
      "49:31100" : "49:31100 (49:31100 Fed. Motor Carrier Safety Act of 1990)",
      "52:20301" : "52:20301 (52:20301 - Uniformed and Overseas Citizens Absentee Voting Act (UOCAVA))",
      "77:7777" : "77:7777 (77:7777 Civil Shell Case Opening)",
      "8:287" : "8:287 (8:287 Petition to Enforce INS Subpoena)",
      "99:9999" : "99:9999 (99:9999 Report cause code (DO NOT DELETE!))",
      "adsup" : "adsup (Administrative Subpoena)",
      "apost" : "apost (Issuance of Apostille)",
      "contempt" : "contempt (Contempt Proceedings)",
      "disbar" : "disbar (Disbarment Proceedings)",
      "fordepo" : "fordepo (Foreign Deposition)",
      "misc" : "misc (Civil Miscellaneous Case)",
      "motcomp" : "motcomp (Motion to Compel)",
      "motquash" : "motquash (Motion to Quash)",
      "motret" : "motret (Motion for Return of Property)",
      "mottrans" : "mottrans (Motion for Transcript)",
      "petenf" : "petenf (Petition to Enforce IRS Summons)",
      "petper" : "petper (Petition to Perpetuate Testimony)",
      "regjgm" : "regjgm (Registration of Foreign Judgment)",
      "tranbkref" : "tranbkref (Transmission of Bankruptcy Reference)",
      "tranff" : "tranff (Transmission of Proposed Findings of Fact and Concl. of Law)",
      "writgar" : "writgar (Application for a Writ of Garnishment)"
   },
   "wydce" : {
      "0" : "0 (No cause code entered)",
      "02:0431" : "02:0431 (02:431 Fed. Election Commission: Failure Enforce C)",
      "02:0437" : "02:0437 (02:437 Federal Election Commission)",
      "05:0075" : "05:0075 (05:75(2) Contract - Reduction in Grade)",
      "05:0551" : "05:0551 (05:551 Administrative Procedure Act)",
      "05:0552fi" : "05:0552fi (05:552 Freedom of Information Act)",
      "05:0552pa" : "05:0552pa (05:552 Right to Privacy Act)",
      "05:0554" : "05:0554 (05:0554 Constitutionality of Maritime Statutes)",
      "05:0701" : "05:0701 (05:0701 Maritime Subsidy Board)",
      "05:0702" : "05:0702 (05:702 Administrative Procedure Act)",
      "05:0704" : "05:0704 (05:704 Labor Litigation)",
      "05:0706" : "05:0706 (05:706(2) Administrative Procedures Act)",
      "05:7703" : "05:7703 (05:7703 Discrimination - Review of Agency Act)",
      "07:0006" : "07:0006 (7:6(b) Federal Commodity Exchange Regulation)",
      "07:0025" : "07:0025 (7:25 Fraud - Commodities Leverage Contracts)",
      "07:0181" : "07:0181 (07:181 Packers & Stockyard Act)",
      "07:0499" : "07:0499 (07:499 Agricultural Commodities Act)",
      "07:0601" : "07:0601 (07:601 USDA Condemnation)",
      "07:2321" : "07:2321 (07:2321 Plant Variety Protection Act)",
      "08:1105" : "08:1105 (8:1105(a) Aliens: Habeas Corpus to Release INS Det)",
      "08:1252" : "08:1252 (08:1252(a)(2) Injunction for Deportation)",
      "08:1260" : "08:1260 (08:1260 Aliens: Access to Records)",
      "08:1324" : "08:1324 (08:1324 Aliens: Complaint for Forfeiture)",
      "08:1329" : "08:1329 (08:1329 Writ of Mandamus to Adjudicate Visa Petiti)",
      "08:1446" : "08:1446 (8:1446 Petition for Naturalization Hearing)",
      "09:0001" : "09:0001 (09:1 U.S. Arbitration Act)",
      "09:0009" : "09:0009 (9:9 Motion to Confirm Arbitration Loan)",
      "09:0010" : "09:0010 (09:0010 Petition to Vacate Arbitration Award)",
      "10:1552" : "10:1552 (10:1552 Armed Forces: Action to Correct Records)",
      "10:1553" : "10:1553 (10:1553 Armed Forces: FOIA General)",
      "10:2305" : "10:2305 (10:2305 Review of Federal Contract)",
      "11:0101" : "11:0101 (11:101 Bankruptcy)",
      "12:0022" : "12:0022 (12:22 Securities Fraud)",
      "12:0635" : "12:0635 (12:635 Breach of Insurance Contract)",
      "12:1461" : "12:1461 (12:1461 Homeowners Loan Act)",
      "12:1703" : "12:1703 (12:1703 Default of HUD Loan)",
      "12:1725" : "12:1725 (12:1725 Collection under Contract Guaranty)",
      "12:1730" : "12:1730 (12:1730 Collection Under Contract Guaranty)",
      "12:1819" : "12:1819 (12:1819 Default of Promissory Note)",
      "12:1821" : "12:1821 (12:1821 Default of Loan by Promissary Note)",
      "12:1971" : "12:1971 (12:1971 Relief under Bank Holding Act)",
      "12:2601" : "12:2601 (12:2601 RESPA-Real Estate Procedures Settlement Act)",
      "12:3410" : "12:3410 (12:3410 Right to Financial Privacy Act)",
      "15:0001" : "15:0001 (15:1 Antitrust Litigation)",
      "15:0002at" : "15:0002at (15:2 Antitrust Litigation)",
      "15:0002fl" : "15:0002fl (15:2(a) Fair Labor Standards Act)",
      "15:0005" : "15:0005 (15:5(a) Fair Labor Standards Act)",
      "15:0015" : "15:0015 (15:15 Antitrust Litigation)",
      "15:0025" : "15:0025 (15:25 Clayton Act)",
      "15:0044" : "15:0044 (15:44 Trademark Infringement)",
      "15:0045" : "15:0045 (15:0045 Federal Trade Commission Act)",
      "15:0052" : "15:0052 (15:0052 Federal Trade Commission Act)",
      "15:0053" : "15:0053 (15:0053 Federal Trade Commission Act)",
      "15:0077" : "15:0077 (15:77 Securities Fraud)",
      "15:0078" : "15:0078 (15:78m(a) Securities Exchange Act)",
      "15:0631" : "15:0631 (15:631 Small Business Act)",
      "15:0717" : "15:0717 (15:717 Natural Gas Act)",
      "15:1051" : "15:1051 (15:1051 Trademark Infringement)",
      "15:1114" : "15:1114 (15:1114 Trademark Infringement)",
      "15:1121" : "15:1121 (15:1121 Trademark Infringement)",
      "15:1125" : "15:1125 (15:1125 Trademark Infringement (Lanham Act))",
      "15:1126" : "15:1126 (15:1126 Patent Infringement)",
      "15:1127" : "15:1127 (15:1127 Trademark Infringement)",
      "15:1601" : "15:1601 (15:1601 Truth in Lending)",
      "15:1640" : "15:1640 (15:1640 Truth in Lending)",
      "15:1681" : "15:1681 (15:1681 Fair Credit Reporting Act)",
      "15:1692" : "15:1692 (15:1692 Fair Debt Collection Act)",
      "15:1938" : "15:1938 (15:1938 Fair Labor Standards Act)",
      "15:1981" : "15:1981 (15:1981 Fraud-Motor Vehicle (Odometer))",
      "15:1988" : "15:1988 (15:1988 Fraud-Motor Vehicle (Odometer))",
      "15:1989" : "15:1989 (15:1989 Fraud-Motor Vehicle (Odometer))",
      "15:2301" : "15:2301 (15:2301 Magnuson-Moss Warranty Act)",
      "15:2801" : "15:2801 (15:2801 Petroleum Marketing Practices Act)",
      "15:53(b)" : "15:53(b) (15:53(b) - Prelim & Perm Inj Relief & other Equita)",
      "16:0668" : "16:0668 (16:668 Bald Eagle Protection Act)",
      "16:0703" : "16:0703 (16:703 Migratory Bird Act)",
      "16:1538" : "16:1538 (16:1538 Endangered Species Act)",
      "16:1600" : "16:1600 (16:1600 National Forest Management Act of 1976)",
      "16:3371" : "16:3371 (16:3371 Wildlife Under the Lacey Act)",
      "16:3372" : "16:3372 (16:3372 Conservation: Complaint for Forfeiture)",
      "16:3373" : "16:3373 (16:3373 Appeal of Decision - DOI)",
      "16:3374" : "16:3374 (16:3374 Conservation: Complaint for Forfeiture)",
      "17:0101" : "17:0101 (17:101 Copyright Infringement)",
      "17:0501" : "17:0501 (17:501 Copyright Infringement)",
      "17:0504" : "17:0504 (17:504 Copyright Infringement)",
      "18:0241" : "18:0241 (18:241 Conspiracy Against Citizen Rights)",
      "18:1836a" : "18:1836a (18:1836(a) Injunction against Misappropriation of Trade Secrets)",
      "18:1836b" : "18:1836b (18:1836(b) Civil Action to Protect Trade Secrets)",
      "18:1961" : "18:1961 (18:1961 Racketeering (RICO) Act)",
      "18:1962" : "18:1962 (18:1962 Racketeering (RICO) Act)",
      "18:1964" : "18:1964 (18:1964 Racketeering (RICO) Act)",
      "18:4208" : "18:4208 (18:4208(B) Agency Action Review)",
      "18:983" : "18:983 (18:983 Civil Forfeiture Proceedings)",
      "19:1305" : "19:1305 (19:1305 Custom Duties:0Forfeiture-Immoral Articles)",
      "20:1080" : "20:1080 (20:1080 Student Loan Recovery)",
      "20:1400" : "20:1400 (20:1400 Civil Rights of Handicapped Child)",
      "20:1401" : "20:1401 (20:1401 Education: Handicapped Child Act)",
      "21:0841" : "21:0841 (21:841 Forfeiture Property-Drugs)",
      "21:0842" : "21:0842 (21:842 Food & Drug Act - Civil Penalties)",
      "21:0881" : "21:0881 (21:881 Forfeiture Property-Drugs)",
      "21:0881a" : "21:0881a (21:881 Forfeiture Property - Aircraft)",
      "21:0881re" : "21:0881re (21:881 Forfeiture Property - Real Estate)",
      "21:876" : "21:876 (Petition to Enforce DEA Subpoena)",
      "23:0134" : "23:0134 (23:134 P.I.- Auto Negligence)",
      "23:1441" : "23:1441 (23:1441 Contract Real Estate)",
      "24:1000" : "24:1000 (24:1000 Hospitals & Asylums: Withdrawal Liability)",
      "25:0640" : "25:0640 (25:640 Indian Tribal Rights)",
      "25:1901" : "25:1901 (25:1901 Indian Child Welfare Act)",
      "26:6212" : "26:6212 (26:6212 Injunctive Relief from IRS Lien)",
      "26:6213" : "26:6213 (26:6213 Injunctive Relief from IRS Lien)",
      "26:6502" : "26:6502 (26:6502 IRS:Enforcement of tax liens)",
      "26:6532" : "26:6532 (26:6532 IRS: Refund of Tax Penalty)",
      "26:6702" : "26:6702 (26:6702 IRS: Refund of Income Tax Penalty)",
      "26:6703" : "26:6703 (26:6703 IRS: Refund of Tax Penalty)",
      "26:7401" : "26:7401 (26:7401 IRS: Tax Liability)",
      "26:7402" : "26:7402 (26:7402 IRS: Petition to Enforce IRS Summons)",
      "26:7403" : "26:7403 (26:7403 Suit to Enforce Federal Tax Lien)",
      "26:7422rt" : "26:7422rt (26:7422 IRS: Refund Taxes)",
      "26:7422rx" : "26:7422rx (26:7422 IRS: Refund Excise Tax)",
      "26:7425" : "26:7425 (26:7425 Right of Redemption)",
      "26:7426" : "26:7426 (26:7426 IRS: Wrongful Levy for Taxes)",
      "26:7429" : "26:7429 (26:7429 IRS: Tax Jeopardy Assessment)",
      "26:7609" : "26:7609 (26:7609 IRS: Petition to Quash IRS Summons)",
      "27:0185" : "27:0185 (27:185 Enforcement of Arbitration Award)",
      "28:0157c" : "28:0157c (28:0157(c)(1) Findings, Concl. & Proposed Judgment)",
      "28:0157d" : "28:0157d (28:0157 Motion for Withdrawal of Reference)",
      "28:0158" : "28:0158 (28:0158 Notice of Appeal re Bankruptcy Matter (BA)",
      "28:0185" : "28:0185 (28:185 Suit to Compel Arbitration)",
      "28:0451" : "28:0451 (28:451 Employment Discrimination)",
      "28:0794" : "28:0794 (28:794 Rehabilitation Act)",
      "28:1001" : "28:1001 (28:1001 E.R.I.S.A.)",
      "28:1132" : "28:1132 (28:1132 E.R.I.S.A.)",
      "28:1330" : "28:1330 (28:1330 Breach of Contract)",
      "28:1331" : "28:1331 (28:1331 Fed. Question)",
      "28:1331al" : "28:1331al (28:1331 Fed. Question: Airline Crash)",
      "28:1331at" : "28:1331at (28:1331 Fed. Question: Anti-trust)",
      "28:1331au" : "28:1331au (28:1331 Fed. Question: Auto Negligence)",
      "28:1331b" : "28:1331b (28:1331 Federal Question: Bivens Act)",
      "28:1331bc" : "28:1331bc (28:1331 Fed. Question: Breach of Contract)",
      "28:1331ca" : "28:1331ca (28:1331 Fed Question: Fed Communications Act of 1)",
      "28:1331cm" : "28:1331cm (28:1331 Fed. Question: Interstate Commerce Act)",
      "28:1331cv" : "28:1331cv (28:1331 Federal Question: Other Civil Rights)",
      "28:1331ed" : "28:1331ed (28:1331 Fed. Question: Employment Discrimination)",
      "28:1331es" : "28:1331es (28:1331 Enforcement of Administrative Subpoena)",
      "28:1331fl" : "28:1331fl (28:1331 Fed. Question: Fair Labor Standards)",
      "28:1331in" : "28:1331in (28:1331 Fed. Question: Insurance Contract)",
      "28:1331mm" : "28:1331mm (28:1331 Fed. Question: Medical Malpractice)",
      "28:1331pi" : "28:1331pi (28:1331 Fed. Question: Personal Injury)",
      "28:1331rd" : "28:1331rd (28:1331 Fed. Question: Review Agency Decision)",
      "28:1331rp" : "28:1331rp (28:1331(a) Fed. Question: Real Property)",
      "28:1331rr" : "28:1331rr (28:1331 Fed. Question: Railway Labor Act)",
      "28:1331sv" : "28:1331sv (28:1331 Fed. Question: Securities Violation)",
      "28:1331tr" : "28:1331tr (28:1331 Fed. Question: Trademark)",
      "28:1331tt" : "28:1331tt (28:1331 Fed. Question: Tort Action)",
      "28:1331v" : "28:1331v (28:1331 Fed. Question: Violation 5th & 8th Amendme)",
      "28:1331wl" : "28:1331wl (28:1331 Federal Question: EPA Waste Lien)",
      "28:1331wt" : "28:1331wt (28:1331 Fed. Question: Water Rights)",
      "28:1332ac" : "28:1332ac (28:1332 Diversity-Account Receivable)",
      "28:1332al" : "28:1332al (28:1332 Diversity-Airline Crash)",
      "28:1332as" : "28:1332as (28:1332 Diversity-Asbestos Litigation)",
      "28:1332au" : "28:1332au (28:1332 Diversity-Auto Negligence)",
      "28:1332bc" : "28:1332bc (28:1332 Diversity-Breach of Contract)",
      "28:1332co" : "28:1332co (28:1332 Diversity-Conversion)",
      "28:1332ct" : "28:1332ct (28:1332 Diversity-(Citizenship))",
      "28:1332det" : "28:1332det (28:1332 Diversity: Forcible Detainer)",
      "28:1332df" : "28:1332df (28:1332 Diversity-Contract Default)",
      "28:1332ds" : "28:1332ds (28:1332 Diversity-Contract Dispute)",
      "28:1332ed" : "28:1332ed (28:1332 Diversity-Employment Discrimination)",
      "28:1332fd" : "28:1332fd (28:1332 Diversity-Breach of Fiduciary Duty)",
      "28:1332fr" : "28:1332fr (28:1332 Diversity-Fraud)",
      "28:1332ia" : "28:1332ia (28:1332 Diversity-Interpleader Action)",
      "28:1332ij" : "28:1332ij (28:1332 Diversity-Injunctive & Declaratory Relief)",
      "28:1332in" : "28:1332in (28:1332 Diversity-Insurance Contract)",
      "28:1332jd" : "28:1332jd (28:1332 Diversity-Declaratory Judgment)",
      "28:1332lb" : "28:1332lb (28:1332 Diversity-Libel,Assault,Slander)",
      "28:1332lm" : "28:1332lm (28:1332 Diversity - Legal Malpractice)",
      "28:1332ma" : "28:1332ma (28:1332 Diversity-Miller Act)",
      "28:1332mm" : "28:1332mm (28:1332 Diversity-Medical Malpractice)",
      "28:1332mv" : "28:1332mv (28:1332 Diversity-Motor Vehicle Product Liability)",
      "28:1332ni" : "28:1332ni (28:1332 Diversity-Negotiable Instrument)",
      "28:1332nm" : "28:1332nm (28:1332 Diversity-Non-Motor Vehicle)",
      "28:1332oc" : "28:1332oc (28:1332 Diversity-Other Contract)",
      "28:1332pd" : "28:1332pd (28:1332 Diversity-Property Damage)",
      "28:1332pi" : "28:1332pi (28:1332 Diversity-Personal Injury)",
      "28:1332pl" : "28:1332pl (28:1332 Diversity-Product Liability)",
      "28:1332pr" : "28:1332pr (28:1332 Diversity-Petition for Removal)",
      "28:1332qt" : "28:1332qt (28:1332 Diversity-Petition to Quiet Title)",
      "28:1332ri" : "28:1332ri (28:1332 Diversity-Racketeering (RICO) Act)",
      "28:1332sa" : "28:1332sa (28:1332 - Diversity: Securities & Exchange Commiss)",
      "28:1332sf" : "28:1332sf (28:1332 - Diversity: Securities Fraud)",
      "28:1332ss" : "28:1332ss (28:1332 Diversity - Stockholders Suits)",
      "28:1332tl" : "28:1332tl (28:1332 Diversity-Torts to Land)",
      "28:1332tm" : "28:1332tm (28:1332 Diversity-Tort/Motor Vehicle (P.I.))",
      "28:1332tn" : "28:1332tn (28:1332 Diversity-Tort/Non-Motor Vehicle)",
      "28:1332wd" : "28:1332wd (28:1332 Diversity-Wrongful Death)",
      "28:1333" : "28:1333 (28:1333 Admiralty)",
      "28:1334" : "28:1334 (28:1334 Bankruptcy Appeal)",
      "28:1334c" : "28:1334c (28:1334(c) R&R re motions for abstention (non-cor)",
      "28:1335" : "28:1335 (28:1335 Interpleader Action)",
      "28:1337" : "28:1337 (28:1337 Sherman-Clayton Act)",
      "28:1338cp" : "28:1338cp (28:1338 Copyright Infringement)",
      "28:1338pt" : "28:1338pt (28:1338 Patent Infringement)",
      "28:1338tr" : "28:1338tr (28:1338 Trademark Infringement)",
      "28:1340" : "28:1340 (28:1340 IRS: Custom Duties)",
      "28:1340er" : "28:1340er (28:1340 Recovery of Erroneous Refund)",
      "28:1341" : "28:1341 (28:1341 Complaint for Forfeiture)",
      "28:1343" : "28:1343 (28:1343 Violation of Civil Rights)",
      "28:1345co" : "28:1345co (28:1345 Replevin & Conversion)",
      "28:1345db" : "28:1345db (28:1345 Debt to US - FHA/HUD Title I)",
      "28:1345df" : "28:1345df (28:1345 Default of Promissory Note)",
      "28:1345er" : "28:1345er (28:1345 Recovery of Erroneous Refund)",
      "28:1345fc" : "28:1345fc (28:1345 Foreclosure)",
      "28:1345ff" : "28:1345ff (28:1345 Complaint for Forfeiture)",
      "28:1345hl" : "28:1345hl (28:1345 VA Home Loan Guaranty Debt)",
      "28:1345mc" : "28:1345mc (28:1345 Medical Care Recovery)",
      "28:1345mi" : "28:1345mi (28:1345 Mining Claim Ejectment)",
      "28:1345pd" : "28:1345pd (28:1345 Property Damage)",
      "28:1345pe" : "28:1345pe (28:1345 Property Ejectment)",
      "28:1345rc" : "28:1345rc (28:1345 Recovery of Debt to US)",
      "28:1345st" : "28:1345st (28:1345 Default of Student Loan)",
      "28:1345tp" : "28:1345tp (28:1345 Trespass on Public Land)",
      "28:1345va" : "28:1345va (28:1345 Recovery of VA Overpayment)",
      "28:1346bc" : "28:1346bc (28:1346 Breach of Contract)",
      "28:1346rc" : "28:1346rc (28:1346 Recovery of IRS Tax)",
      "28:1346tc" : "28:1346tc (28:1346 Tort Claim)",
      "28:1346wd" : "28:1346wd (28:1346 Wrongful Death)",
      "28:1352" : "28:1352 (28:1352 Miller Act)",
      "28:1355" : "28:1355 (28:1355 Petition for Return of Property)",
      "28:1358" : "28:1358 (28:1358 Land Condemnation)",
      "28:1361" : "28:1361 (28:1361 Petition for Writ of Mandamus)",
      "28:1362ic" : "28:1362ic (28:1362 Indian Tribal Controversy)",
      "28:1362iw" : "28:1362iw (28:1362 Declaration re: Indian Tribal Water Rights)",
      "28:1364" : "28:1364 (28:1364 Auto Negligence)",
      "28:1391" : "28:1391 (28:1391 Personal Injury)",
      "28:1402" : "28:1402 (28:1402 Medical Malpractice)",
      "28:1407" : "28:1407 (28:1407 Airline Crash)",
      "28:1441ac" : "28:1441ac (28:1441 Petition for Removal- Account Receivable)",
      "28:1441al" : "28:1441al (28:1441 Petition for Removal- Airline Crash)",
      "28:1441as" : "28:1441as (28:1441 Petition for Removal- Asbestos Litigation)",
      "28:1441au" : "28:1441au (28:1441 Petition for Removal- Auto Negligence)",
      "28:1441bc" : "28:1441bc (28:1441 Petition for Removal- Breach of Contract)",
      "28:1441cv" : "28:1441cv (28:1441 Petition for Removal- Civil Rights Act)",
      "28:1441df" : "28:1441df (28:1441 Petition for Removal- Contract Default)",
      "28:1441dj" : "28:1441dj (28:1441 Petition for Removal- Declaratory Judgemen)",
      "28:1441ds" : "28:1441ds (28:1441 Petition for Removal- Contract Dispute)",
      "28:1441ed" : "28:1441ed (28:1441 Petition for Removal - Employment Discrim)",
      "28:1441fc" : "28:1441fc (28:1441 Petition for Removal - Fair Credit Reporti)",
      "28:1441fr" : "28:1441fr (28:1441 Petition for Removal- Fraud)",
      "28:1441ij" : "28:1441ij (28:1441 Petition for Removal- Injunctive/Declarato)",
      "28:1441in" : "28:1441in (28:1441 Petition for Removal- Insurance Contract)",
      "28:1441int" : "28:1441int (28:1441 Petition for Removal- Action for Interplea)",
      "28:1441lb" : "28:1441lb (28:1441 Petition for Removal Libel,Assault,Slander)",
      "28:1441lm" : "28:1441lm (28:1441 Petition for Removal- Labor/Mgmnt. Relatio)",
      "28:1441mm" : "28:1441mm (28:1441 Petition for Removal- Medical Malpractice)",
      "28:1441ni" : "28:1441ni (28:1441 Petition for Removal- Negotiable Instrumen)",
      "28:1441nm" : "28:1441nm (28:1441 Petition for Removal- Non-Motor Vehicle)",
      "28:1441oc" : "28:1441oc (28:1441 Petition For Removal--Other Contract)",
      "28:1441pd" : "28:1441pd (28:1441 Petition for Removal- Property Damage)",
      "28:1441pi" : "28:1441pi (28:1441 Petition for Removal- Personal Injury)",
      "28:1441pl" : "28:1441pl (28:1441 Petition for Removal- Product Liability)",
      "28:1441pr" : "28:1441pr (28:1441 Petition for Removal)",
      "28:1441qt" : "28:1441qt (28:1441 Petition for Removal- Petition to Quiet Ti)",
      "28:1441ri" : "28:1441ri (28:1441 Petition for Removal- Racketeering (RICO))",
      "28:1441sa" : "28:1441sa (28:1441 - Petition for Removal: SEC Act)",
      "28:1441sf" : "28:1441sf (28:1441 - Petition for Removal: Securities Fraud)",
      "28:1441tl" : "28:1441tl (28:1441 Petition for Removal- Torts to Land)",
      "28:1441tm" : "28:1441tm (28:1441 Petition for Removal- Tort/Motor Vehicle ()",
      "28:1441tn" : "28:1441tn (28:1441 Petition for Removal- Tort/Non-Motor Vehic)",
      "28:1441wd" : "28:1441wd (28:1441 Petition for Removal- Wrongful Death)",
      "28:1442bc" : "28:1442bc (28:1442 Petition for Removal- Breach of Contract)",
      "28:1442pr" : "28:1442pr (28:1442 Petition for Removal)",
      "28:1443" : "28:1443 (28:1443(1) Rent, Lease & Ejectment)",
      "28:1444" : "28:1444 (28:1444 Petition for Removal- Foreclosure)",
      "28:1446in" : "28:1446in (28:1446 Breach of Contract- Insurance)",
      "28:1446pd" : "28:1446pd (28:1446 Petition for Removal- Property Damage (P.I)",
      "28:1446pi" : "28:1446pi (28:1446 Petition for Removal- Personal Injury)",
      "28:1446pl" : "28:1446pl (28:1446pl Petition for Removal - Product Liability)",
      "28:1446pr" : "28:1446pr (28:1446 Petition for Removal)",
      "28:1452" : "28:1452 (28:1452 Bankruptcy Removal)",
      "28:1651" : "28:1651 (28:1651 Petition for Writ of Coram Nobis)",
      "28:1651hc" : "28:1651hc (28:1651 Petition for Writ of Habeas Corpus)",
      "28:1651mn" : "28:1651mn (28:1651 Petition for Writ of Mandamus)",
      "28:1652" : "28:1652 (28:1652 Quiet Title to Real Property)",
      "28:1983" : "28:1983 (28:1983 Civil Rights)",
      "28:2201" : "28:2201 (28:2201 Constitutionality of State Statute(s))",
      "28:2201dj" : "28:2201dj (28:2201 Declaratory Judgement)",
      "28:2201ij" : "28:2201ij (28:2201 Injunction)",
      "28:2201in" : "28:2201in (28:2201 Declaratory Judgement (Insurance))",
      "28:2241" : "28:2241 (28:2241 Petition for Writ of Habeas Corpus (federa)",
      "28:2241st" : "28:2241st (28:2241 Petition for Writ of Habeas Corpus (state detainer))",
      "28:2254" : "28:2254 (28:2254 Petition for Writ of Habeas Corpus (State))",
      "28:2254se" : "28:2254se (28:2254 Ptn for Writ of H/C - Stay of Execution)",
      "28:2255" : "28:2255 (28:2255 Motion to Vacate / Correct Illegal Sentenc)",
      "28:2271" : "28:2271 (28:2271 Federal Tort Claims Act)",
      "28:2345" : "28:2345 (28:2345 Medicare Recovery)",
      "28:2409" : "28:2409 (28:2409(a) Quiet Title Action)",
      "28:2410" : "28:2410 (28:2410 Quiet Title)",
      "28:2671" : "28:2671 (28:2671 Federal Tort Claims Act)",
      "28:2674" : "28:2674 (28:2674 Federal Tort Claims Act)",
      "28:2675" : "28:2675 (28:2675 Federal Tort Claims Act)",
      "28:7402" : "28:7402 (28:7402 Refund of Taxes)",
      "28:7422" : "28:7422 (28:7422 Appeal from Administrative Decision)",
      "28:7425" : "28:7425 (28:7425 Quiet Title or Rescission of Foreclosure)",
      "29:0151" : "29:0151 (29:151 Labor: Review of Agency Action)",
      "29:0160" : "29:0160 (29:160(1) National Labor Relations Act)",
      "29:0184" : "29:0184 (29:184 Violation Collection Bargain Agreement)",
      "29:0185ep" : "29:0185ep (29:185 Employee Pension Plan)",
      "29:0185lm" : "29:0185lm (29:185 Labor/Mgt. Relations (Contracts))",
      "29:0201do" : "29:0201do (29:201 Denial of Overtime Compensation)",
      "29:0201fl" : "29:0201fl (29:201 Fair Labor Standards Act)",
      "29:0203" : "29:0203 (29:203 Equal Pay Act)",
      "29:0206" : "29:0206 (29:206 Collect Unpaid Wages)",
      "29:0401" : "29:0401 (29:0401 Labor Management Disclosure Act)",
      "29:0621" : "29:0621 (29:621 Job Discrimination (Age))",
      "29:0623" : "29:0623 (29:623 Job Discrimination (Age))",
      "29:0626" : "29:0626 (29:626 Job Discrimination (Age))",
      "29:0633" : "29:0633 (29:633 Job Discrimination (Age))",
      "29:0651" : "29:0651 (29:651 Occupational Safety/Health)",
      "29:0754" : "29:0754 (29:754 Discrimination)",
      "29:0791" : "29:0791 (29:791 Job Discrimination (Rehabilitation Act))",
      "29:0794" : "29:0794 (29:0794 Job Discrimination (Handicap))",
      "29:1001" : "29:1001 (29:1001 E.R.I.S.A.: Employee Retirement)",
      "29:1002" : "29:1002 (29:1002 E.R.I.S.A.: Employee Retirement)",
      "29:1104" : "29:1104 (29:1104 Recovery of Benefits to Employee)",
      "29:1109" : "29:1109 (29:1109 Breach of Fiduciary Duties)",
      "29:1131" : "29:1131 (29:1131 ERISA - Collection of Delinquent Trust Fun)",
      "29:1132" : "29:1132 (29:1132 E.R.I.S.A.-Employee Benefits)",
      "29:1145" : "29:1145 (29:1145 E.R.I.S.A.)",
      "29:1149" : "29:1149 (29:1149 Recover Pension & Profit Sharing)",
      "29:1337" : "29:1337 (29:1337 E.R.I.S.A.)",
      "29:1362" : "29:1362 (29:1362 ERISA)",
      "29:1381" : "29:1381 (29:1381 E.R.I.S.A.)",
      "29:1401" : "29:1401 (29:1401(b)(2) Appeal of Arbitration Award)",
      "29:1451" : "29:1451 (29:1451 E.R.I.S.A.)",
      "29:1801" : "29:1801 (29:1801 Farmworker Rights)",
      "29:2601" : "29:2601 (29:2601 Family and Medical Leave Act)",
      "29:790" : "29:790 (29:790 Rehabilitation of Labor)",
      "30:0181" : "30:0181 (30:181 Environment: Review of Agency Action)",
      "30:0801" : "30:0801 (30:0801 Penalities/Federal Mine Safety Health Act)",
      "30:1201" : "30:1201 (30:1201 Environment: Review of Agency Action)",
      "30:1202" : "30:1202 (30:1202 Mining Reclamation Act)",
      "30:1276" : "30:1276 (30:1276 Interior: Review of Agency Action)",
      "31:3545" : "31:3545 (31:3545 Action to Recovery Money)",
      "31:3729" : "31:3729 (31:3729 False Claims Act)",
      "31:3730" : "31:3730 (31:3730 Qui Tam False Claims Act)",
      "31:3731" : "31:3731 (31:3731 Fraud)",
      "33:1319cw" : "33:1319cw (33:1319 Clean Water Act)",
      "33:1319pv" : "33:1319pv (33:1319 Pollutants & Permit Violations)",
      "33:1365" : "33:1365 (33:1365 Environmental Matters)",
      "35:0145" : "35:0145 (35:145 Patent Infringement)",
      "35:0183" : "35:0183 (35:183 Patent Infringement)",
      "35:0271" : "35:0271 (35:271 Patent Infringement)",
      "38:1151" : "38:1151 (38:1151 VA Medical compensation claims)",
      "38:1681" : "38:1681 (38:1681 Recovery of VA Overpayment)",
      "38:1686" : "38:1686 (38:1686 Recovery of VA Overpayment)",
      "38:1780" : "38:1780 (38:1780 Recovery of VA Overpayment)",
      "38:2011" : "38:2011 (38:2011 - Veteran's Readjustment Assistance Act of)",
      "38:3116" : "38:3116 (38:3116 VA Overpayment)",
      "38:4301" : "38:4301 (38:4301 Uniformed Services Employment and Reemployment Act)",
      "39:3005" : "39:3005 (39:3005 Detention of Mail for Temporary Periods)",
      "39:409" : "39:409 (39:409 Postal Service)",
      "40:0258" : "40:0258 (40:258(a) Public Buildings & Property: Land Condem)",
      "40:0270" : "40:0270 (40:270 Miller Act)",
      "40:0875" : "40:0875 (40:875 Public Buildings & Property: Negligence)",
      "41:0251" : "41:0251 (41:251 Public Contracts-Review of Agency Action)",
      "41:1463" : "41:1463 (41:1463 Public Contracts: Unlawful Employment Prac)",
      "42:0205" : "42:0205 (42:205 Denial Social Security Benefits)",
      "42:0206" : "42:0206 (42:206 Social Security Benefits)",
      "42:0247" : "42:0247 (42:247 Personal Injury-Swine Flu)",
      "42:0402" : "42:0402 (42:402 Social Security Benefits)",
      "42:0405id" : "42:0405id (42:405 Review of HHS Decision (SSID))",
      "42:0405wc" : "42:0405wc (42:405 Review of HHS Decision (DIWC))",
      "42:0405ww" : "42:0405ww (42:405 Review of HHS Decision (DIWW))",
      "42:0416" : "42:0416 (42:416 Denial of Social Security Benefits)",
      "42:0427" : "42:0427 (42:427 Social Security Benefits)",
      "42:11601" : "42:11601 (42:11601 - Hague Convention - Child Custody)",
      "42:12101" : "42:12101 (42:12101 - Americans with Disabilities Act)",
      "42:1383" : "42:1383 (42:1383 Review of HHS Decision)",
      "42:1395" : "42:1395 (42:1395 HHS: Adverse Reimbursement Review)",
      "42:1395em" : "42:1395em (42:1395 Emergency Medical Treatment and Active Labor Act)",
      "42:1396" : "42:1396 (42:1396 - Tort Negligence)",
      "42:1471" : "42:1471 (42:1471 Declaratory & Injunctive Relief - Foreclo)",
      "42:1981cv" : "42:1981cv (42:1981 Civil Rights)",
      "42:1981hs" : "42:1981hs (42:1981 Housing Discrimination)",
      "42:1981jb" : "42:1981jb (42:1981 Job Discrimination (Race))",
      "42:1981sx" : "42:1981sx (42:1981 Sex Discrimination)",
      "42:1983cv" : "42:1983cv (42:1983 Civil Rights Act)",
      "42:1983ed" : "42:1983ed (42:1983 Civil Rights (Employment Discrimination))",
      "42:1983pr" : "42:1983pr (42:1983 Prisoner Civil Rights)",
      "42:1986" : "42:1986 (42:1986 Neglect of Duty)",
      "42:1997" : "42:1997 (42:1997 Civil Rights of Institutionalized Persons Act 1980)",
      "42:2000ag" : "42:2000ag (42:2000 Job Discrimination (Age))",
      "42:2000e" : "42:2000e (42:2000e Job Discrimination (Employment))",
      "42:2000pb" : "42:2000pb (42:2000 Job Discrimination (Public Accomodations))",
      "42:2000ra" : "42:2000ra (42:2000 Job Discrimination (Race))",
      "42:2000sx" : "42:2000sx (42:2000 Job Discrimination (Sex))",
      "42:2003" : "42:2003 (42:2003 Job Discrimination)",
      "42:2005" : "42:2005 (42:2005 Review of Agency Action-HHS)",
      "42:2651" : "42:2651 (42:2651 Medical Care Recovery)",
      "42:300" : "42:300 (42:300 Safe Drinking Water Act)",
      "42:3601" : "42:3601 (42:405 Fair Housing Act)",
      "42:4000" : "42:4000 (42:4000 National Flood Insurance Act)",
      "42:4001" : "42:4001 (42:4001 National Insurance Flood Act)",
      "42:4053" : "42:4053 (42:4053 Breach of Insurance Contract)",
      "42:4072" : "42:4072 (42:4072 Payment of Flood Insurance Claim)",
      "42:4321" : "42:4321 (42:4321 Review of Agency Action-Environment)",
      "42:4332" : "42:4332 (42:4332 Environmental Policy - Coop of Agency Repo)",
      "42:6901en" : "42:6901en (42:6901 Environmental Cleanup Expenses)",
      "42:6901rs" : "42:6901rs (42:6901 Resource Conservation & Recovery Act)",
      "42:6973" : "42:6973 (42:6973 Resource Conservation and Recovery Act)",
      "42:7413" : "42:7413 (42:7413(b) Clean Air Act)",
      "42:7604cl" : "42:7604cl (42:7604 Clear Air Act (Emission Standards))",
      "42:7604ir" : "42:7604ir (42:7604 Petition to Quash IRS Summons)",
      "42:9604" : "42:9604 (42:9604 CERCLA Section 104)",
      "42:9607" : "42:9607 (42:9607 Real Property Tort to Land)",
      "42:9613" : "42:9613 (42:9613 CERCLA Section 113)",
      "43:299" : "43:299 (43:299 Reservation of Coal & Mineral Rights)",
      "43:945" : "43:945 (43:945 Compensation for Land Condemnation)",
      "43:945a" : "43:945a (43:945a Complaint in Condemnation)",
      "43:946" : "43:946 (43:946 Complaint in Condemnation - Eminent Domain)",
      "45:0051" : "45:0051 (45:51 Railways: Fed. Employer's Liability Act)",
      "45:0151" : "45:0151 (45:151 Railway Labor Act)",
      "45:0184" : "45:0184 (45:184 Action to Set Aside Award of a System Board)",
      "45:1395" : "45:1395 (45:1395 Railroads: Adverse Reimbursement Review)",
      "45:7457" : "45:7457 (45:7457 Compel Reclamation Under Clear Air Act)",
      "46:0688" : "46:0688 (46:688 Jones Act)",
      "46:0741" : "46:0741 (46:741 Shipping)",
      "46:0761" : "46:0761 (46:761 Shipping: Damages for Death on High Seas)",
      "46:1101" : "46:1101 (46:1101 Violation of Maritime Regulations)",
      "46:1156" : "46:1156 (46:1156 Administrative Procedure Act)",
      "47:0605" : "47:0605 (47:0605 Piracy of Satellite Transmission)",
      "48:0883" : "48:0883 (48:883 Violation of US Coastal Law)",
      "48:1985" : "48:1985 (48:1985 Conspiracy/Deprivation Civil Rights)",
      "49:0081" : "49:0081 (49:81 Damaged Goods While Being Transported)",
      "49:0781" : "49:0781 (49:781 Forfeiture)",
      "49:10101" : "49:10101 (49:10101 Revised Interstate Commerce Act)",
      "49:11503" : "49:11503 (49:11503 Railroad Revitalization Regulatory Reform)",
      "49:11702" : "49:11702 (49:11702(a)(4) Violations of Interstate Commerce A)",
      "49:1471" : "49:1471 (49:1471 Federal Aviation Act)",
      "49:1903" : "49:1903 (49:1903 Petition to enforce administrative summon)",
      "8:287" : "8:287 (8:287 Petition to Enforce INS Subpoena)",
      "misc" : "misc (Civil Miscellaneous Case)"
   }
}

const getCauses = (court) => {
  if (!court || !causes[court]) {
    return null;
  }

  return Object.keys(causes[court]).map(key => {
    return {
      value: key,
      label: causes[court][key],
    }
  });
};

export default getCauses;



// WEBPACK FOOTER //
// ./src/data/causes.js